// ─────────────────────────────────────────────────────────────────────────────
// bannersData.js
// ARCHIVO GENERADO AUTOMÁTICAMENTE — NO EDITAR MANUALMENTE
// Generado: 2026-09-30T00:19:24Z
// Periodo:  202607
// Entidades banner1: 51 | Entidades banner2: 61 | Entidades banner3: 61
// Pipeline: generate_banners_data.py
// ─────────────────────────────────────────────────────────────────────────────

export const BANNERS_PERIODO = 202607;

export const BANNERS_DATA = {
  periodo: 202607,

  // Banner 1: Calificación de Cartera y Reservas (A-0417)
  banner1: [
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 29500146456.97,
    "valor_anterior": 29436406712.130005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11700653745.95,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11813664256.23,
        "delta": 113010510.28
      },
      {
        "periodo": 202509,
        "valor": 12034476527.03,
        "delta": 220812270.8
      },
      {
        "periodo": 202510,
        "valor": 12226833420.18,
        "delta": 192356893.15
      },
      {
        "periodo": 202511,
        "valor": 12256295464.7,
        "delta": 29462044.52
      },
      {
        "periodo": 202512,
        "valor": 12494487423.16,
        "delta": 238191958.46
      },
      {
        "periodo": 202601,
        "valor": 12515627569.5,
        "delta": 21140146.34
      },
      {
        "periodo": 202602,
        "valor": 28272410160.37,
        "delta": 15756782590.87
      },
      {
        "periodo": 202603,
        "valor": 28485132896.27,
        "delta": 212722735.9
      },
      {
        "periodo": 202604,
        "valor": 28736296511.99,
        "delta": 251163615.72
      },
      {
        "periodo": 202605,
        "valor": 29198861896.4,
        "delta": 462565384.41
      },
      {
        "periodo": 202606,
        "valor": 29436406712.13,
        "delta": 237544815.73
      },
      {
        "periodo": 202607,
        "valor": 29500146456.97,
        "delta": 63739744.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 71437982598.15001,
    "valor_anterior": 71065705449.01,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 62019893350.16,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 62796002053.94,
        "delta": 776108703.78
      },
      {
        "periodo": 202509,
        "valor": 63178180221.64,
        "delta": 382178167.7
      },
      {
        "periodo": 202510,
        "valor": 64206436419.51,
        "delta": 1028256197.87
      },
      {
        "periodo": 202511,
        "valor": 64064395775.9,
        "delta": -142040643.61
      },
      {
        "periodo": 202512,
        "valor": 63457648396.03,
        "delta": -606747379.87
      },
      {
        "periodo": 202601,
        "valor": 63536244704.55,
        "delta": 78596308.52
      },
      {
        "periodo": 202602,
        "valor": 66951381469.91,
        "delta": 3415136765.36
      },
      {
        "periodo": 202603,
        "valor": 68407593748.77,
        "delta": 1456212278.86
      },
      {
        "periodo": 202604,
        "valor": 68491972769.86,
        "delta": 84379021.09
      },
      {
        "periodo": 202605,
        "valor": 69860390626.64,
        "delta": 1368417856.78
      },
      {
        "periodo": 202606,
        "valor": 71065705449.01,
        "delta": 1205314822.37
      },
      {
        "periodo": 202607,
        "valor": 71437982598.15,
        "delta": 372277149.14
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 32567381777.999996,
    "valor_anterior": 32347799716.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 29112015036.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28902630641.0,
        "delta": -209384395.0
      },
      {
        "periodo": 202509,
        "valor": 29467296102.0,
        "delta": 564665461.0
      },
      {
        "periodo": 202510,
        "valor": 29785509015.0,
        "delta": 318212913.0
      },
      {
        "periodo": 202511,
        "valor": 29860975596.0,
        "delta": 75466581.0
      },
      {
        "periodo": 202512,
        "valor": 29674461796.0,
        "delta": -186513800.0
      },
      {
        "periodo": 202601,
        "valor": 29594051164.0,
        "delta": -80410632.0
      },
      {
        "periodo": 202602,
        "valor": 30327704184.0,
        "delta": 733653020.0
      },
      {
        "periodo": 202603,
        "valor": 30646624239.0,
        "delta": 318920055.0
      },
      {
        "periodo": 202604,
        "valor": 30569174001.0,
        "delta": -77450238.0
      },
      {
        "periodo": 202605,
        "valor": 33149093075.0,
        "delta": 2579919074.0
      },
      {
        "periodo": 202606,
        "valor": 32347799716.0,
        "delta": -801293359.0
      },
      {
        "periodo": 202607,
        "valor": 32567381778.0,
        "delta": 219582062.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 16708977252.999998,
    "valor_anterior": 16533168280.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18924897535.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18846895170.0,
        "delta": -78002365.0
      },
      {
        "periodo": 202509,
        "valor": 18692196091.0,
        "delta": -154699079.0
      },
      {
        "periodo": 202510,
        "valor": 18944777025.0,
        "delta": 252580934.0
      },
      {
        "periodo": 202511,
        "valor": 18260683443.0,
        "delta": -684093582.0
      },
      {
        "periodo": 202512,
        "valor": 18130978959.0,
        "delta": -129704484.0
      },
      {
        "periodo": 202601,
        "valor": 17786099122.0,
        "delta": -344879837.0
      },
      {
        "periodo": 202602,
        "valor": 17513348297.0,
        "delta": -272750825.0
      },
      {
        "periodo": 202603,
        "valor": 16967935863.0,
        "delta": -545412434.0
      },
      {
        "periodo": 202604,
        "valor": 16650270800.0,
        "delta": -317665063.0
      },
      {
        "periodo": 202605,
        "valor": 16613311300.0,
        "delta": -36959500.0
      },
      {
        "periodo": 202606,
        "valor": 16533168280.0,
        "delta": -80143020.0
      },
      {
        "periodo": 202607,
        "valor": 16708977253.0,
        "delta": 175808973.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 5245362845.45,
    "valor_anterior": 5071385485.27,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5699046250.91,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5607985249.99,
        "delta": -91061000.92
      },
      {
        "periodo": 202509,
        "valor": 5819546878.86,
        "delta": 211561628.87
      },
      {
        "periodo": 202510,
        "valor": 5726342524.54,
        "delta": -93204354.32
      },
      {
        "periodo": 202511,
        "valor": 5518509657.33,
        "delta": -207832867.21
      },
      {
        "periodo": 202512,
        "valor": 5027446480.53,
        "delta": -491063176.8
      },
      {
        "periodo": 202601,
        "valor": 5036707270.17,
        "delta": 9260789.64
      },
      {
        "periodo": 202602,
        "valor": 5165661828.72,
        "delta": 128954558.55
      },
      {
        "periodo": 202603,
        "valor": 5124471195.37,
        "delta": -41190633.35
      },
      {
        "periodo": 202604,
        "valor": 5061574316.8,
        "delta": -62896878.57
      },
      {
        "periodo": 202605,
        "valor": 5078391585.86,
        "delta": 16817269.06
      },
      {
        "periodo": 202606,
        "valor": 5071385485.27,
        "delta": -7006100.59
      },
      {
        "periodo": 202607,
        "valor": 5245362845.45,
        "delta": 173977360.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 7909636498.999999,
    "valor_anterior": 7629680689.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5838884997.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5973581574.0,
        "delta": 134696577.0
      },
      {
        "periodo": 202509,
        "valor": 5979561723.0,
        "delta": 5980149.0
      },
      {
        "periodo": 202510,
        "valor": 6121365838.0,
        "delta": 141804115.0
      },
      {
        "periodo": 202511,
        "valor": 6087620005.0,
        "delta": -33745833.0
      },
      {
        "periodo": 202512,
        "valor": 6132461790.0,
        "delta": 44841785.0
      },
      {
        "periodo": 202601,
        "valor": 6190992408.0,
        "delta": 58530618.0
      },
      {
        "periodo": 202602,
        "valor": 6419441001.0,
        "delta": 228448593.0
      },
      {
        "periodo": 202603,
        "valor": 6855136638.0,
        "delta": 435695637.0
      },
      {
        "periodo": 202604,
        "valor": 7490250852.0,
        "delta": 635114214.0
      },
      {
        "periodo": 202605,
        "valor": 7453774159.0,
        "delta": -36476693.0
      },
      {
        "periodo": 202606,
        "valor": 7629680690.0,
        "delta": 175906531.0
      },
      {
        "periodo": 202607,
        "valor": 7909636499.0,
        "delta": 279955809.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 2107736116.0,
    "valor_anterior": 2111462321.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1913238385.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1914974249.0,
        "delta": 1735864.0
      },
      {
        "periodo": 202509,
        "valor": 1910314522.0,
        "delta": -4659727.0
      },
      {
        "periodo": 202510,
        "valor": 1917149351.0,
        "delta": 6834829.0
      },
      {
        "periodo": 202511,
        "valor": 1975962699.0,
        "delta": 58813348.0
      },
      {
        "periodo": 202512,
        "valor": 1826115804.0,
        "delta": -149846895.0
      },
      {
        "periodo": 202601,
        "valor": 1858665540.0,
        "delta": 32549736.0
      },
      {
        "periodo": 202602,
        "valor": 1897579399.0,
        "delta": 38913859.0
      },
      {
        "periodo": 202603,
        "valor": 1943178256.0,
        "delta": 45598857.0
      },
      {
        "periodo": 202604,
        "valor": 2003235598.0,
        "delta": 60057342.0
      },
      {
        "periodo": 202605,
        "valor": 2074963327.0,
        "delta": 71727729.0
      },
      {
        "periodo": 202606,
        "valor": 2111462321.0,
        "delta": 36498994.0
      },
      {
        "periodo": 202607,
        "valor": 2107736116.0,
        "delta": -3726205.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 15589442257.0,
    "valor_anterior": 15839227292.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14686606733.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14849049382.0,
        "delta": 162442649.0
      },
      {
        "periodo": 202509,
        "valor": 15133307616.0,
        "delta": 284258234.0
      },
      {
        "periodo": 202510,
        "valor": 15348828080.0,
        "delta": 215520464.0
      },
      {
        "periodo": 202511,
        "valor": 15714238485.0,
        "delta": 365410405.0
      },
      {
        "periodo": 202512,
        "valor": 15450546054.0,
        "delta": -263692431.0
      },
      {
        "periodo": 202601,
        "valor": 15325851037.0,
        "delta": -124695017.0
      },
      {
        "periodo": 202602,
        "valor": 15497180353.0,
        "delta": 171329316.0
      },
      {
        "periodo": 202603,
        "valor": 15430635047.0,
        "delta": -66545306.0
      },
      {
        "periodo": 202604,
        "valor": 15805109933.0,
        "delta": 374474886.0
      },
      {
        "periodo": 202605,
        "valor": 16093957469.0,
        "delta": 288847536.0
      },
      {
        "periodo": 202606,
        "valor": 15839227292.0,
        "delta": -254730177.0
      },
      {
        "periodo": 202607,
        "valor": 15589442257.0,
        "delta": -249785035.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 3125538003.0,
    "valor_anterior": 3090066751.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3569768605.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3572405754.0,
        "delta": 2637149.0
      },
      {
        "periodo": 202509,
        "valor": 3593277576.0,
        "delta": 20871822.0
      },
      {
        "periodo": 202510,
        "valor": 3695990695.0,
        "delta": 102713119.0
      },
      {
        "periodo": 202511,
        "valor": 3734131136.0,
        "delta": 38140441.0
      },
      {
        "periodo": 202512,
        "valor": 3361830767.0,
        "delta": -372300369.0
      },
      {
        "periodo": 202601,
        "valor": 3314066948.0,
        "delta": -47763819.0
      },
      {
        "periodo": 202602,
        "valor": 2889500217.06,
        "delta": -424566730.94
      },
      {
        "periodo": 202603,
        "valor": 2902402373.14,
        "delta": 12902156.08
      },
      {
        "periodo": 202604,
        "valor": 2946188613.0,
        "delta": 43786239.86
      },
      {
        "periodo": 202605,
        "valor": 3004726917.0,
        "delta": 58538304.0
      },
      {
        "periodo": 202606,
        "valor": 3090066751.0,
        "delta": 85339834.0
      },
      {
        "periodo": 202607,
        "valor": 3125538003.0,
        "delta": 35471252.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 3828507326.0,
    "valor_anterior": 3751374381.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2844036708.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2892220390.0,
        "delta": 48183682.0
      },
      {
        "periodo": 202509,
        "valor": 2944050063.0,
        "delta": 51829673.0
      },
      {
        "periodo": 202510,
        "valor": 3023603014.0,
        "delta": 79552951.0
      },
      {
        "periodo": 202511,
        "valor": 3236290565.0,
        "delta": 212687551.0
      },
      {
        "periodo": 202512,
        "valor": 3334270982.0,
        "delta": 97980417.0
      },
      {
        "periodo": 202601,
        "valor": 3605030584.0,
        "delta": 270759602.0
      },
      {
        "periodo": 202602,
        "valor": 3670338610.0,
        "delta": 65308026.0
      },
      {
        "periodo": 202603,
        "valor": 3567451876.0,
        "delta": -102886734.0
      },
      {
        "periodo": 202604,
        "valor": 3649041890.0,
        "delta": 81590014.0
      },
      {
        "periodo": 202605,
        "valor": 3712772466.0,
        "delta": 63730576.0
      },
      {
        "periodo": 202606,
        "valor": 3751374381.0,
        "delta": 38601915.0
      },
      {
        "periodo": 202607,
        "valor": 3828507326.0,
        "delta": 77132945.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 2041245552.0,
    "valor_anterior": 2023798553.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1832385781.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1849888780.0,
        "delta": 17502999.0
      },
      {
        "periodo": 202509,
        "valor": 1867339853.0,
        "delta": 17451073.0
      },
      {
        "periodo": 202510,
        "valor": 1884844246.0,
        "delta": 17504393.0
      },
      {
        "periodo": 202511,
        "valor": 1902532243.0,
        "delta": 17687997.0
      },
      {
        "periodo": 202512,
        "valor": 1920269193.0,
        "delta": 17736950.0
      },
      {
        "periodo": 202601,
        "valor": 1936519191.0,
        "delta": 16249998.0
      },
      {
        "periodo": 202602,
        "valor": 1953910195.0,
        "delta": 17391004.0
      },
      {
        "periodo": 202603,
        "valor": 1971862157.0,
        "delta": 17951962.0
      },
      {
        "periodo": 202604,
        "valor": 1989327158.0,
        "delta": 17465001.0
      },
      {
        "periodo": 202605,
        "valor": 2006752160.0,
        "delta": 17425002.0
      },
      {
        "periodo": 202606,
        "valor": 2023798553.0,
        "delta": 17046393.0
      },
      {
        "periodo": 202607,
        "valor": 2041245552.0,
        "delta": 17446999.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 2384703422.0,
    "valor_anterior": 2268786735.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2285989600.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2263996344.0,
        "delta": -21993256.0
      },
      {
        "periodo": 202509,
        "valor": 2311872880.0,
        "delta": 47876536.0
      },
      {
        "periodo": 202510,
        "valor": 2286481253.0,
        "delta": -25391627.0
      },
      {
        "periodo": 202511,
        "valor": 2304147389.0,
        "delta": 17666136.0
      },
      {
        "periodo": 202512,
        "valor": 2159648003.0,
        "delta": -144499386.0
      },
      {
        "periodo": 202601,
        "valor": 2151299086.0,
        "delta": -8348917.0
      },
      {
        "periodo": 202602,
        "valor": 2165525214.0,
        "delta": 14226128.0
      },
      {
        "periodo": 202603,
        "valor": 2178343795.0,
        "delta": 12818581.0
      },
      {
        "periodo": 202604,
        "valor": 2137671269.0,
        "delta": -40672526.0
      },
      {
        "periodo": 202605,
        "valor": 2248795879.0,
        "delta": 111124610.0
      },
      {
        "periodo": 202606,
        "valor": 2268786735.0,
        "delta": 19990856.0
      },
      {
        "periodo": 202607,
        "valor": 2384703422.0,
        "delta": 115916687.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 25650966167.86,
    "valor_anterior": 25172157845.13,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19310491420.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19604621480.08,
        "delta": 294130059.18
      },
      {
        "periodo": 202509,
        "valor": 21543128268.97,
        "delta": 1938506788.89
      },
      {
        "periodo": 202510,
        "valor": 21860878095.62,
        "delta": 317749826.65
      },
      {
        "periodo": 202511,
        "valor": 22484755642.85,
        "delta": 623877547.23
      },
      {
        "periodo": 202512,
        "valor": 23218475743.09,
        "delta": 733720100.24
      },
      {
        "periodo": 202601,
        "valor": 23953783661.41,
        "delta": 735307918.32
      },
      {
        "periodo": 202602,
        "valor": 23940183158.67,
        "delta": -13600502.74
      },
      {
        "periodo": 202603,
        "valor": 24433933858.19,
        "delta": 493750699.52
      },
      {
        "periodo": 202604,
        "valor": 24632633832.91,
        "delta": 198699974.72
      },
      {
        "periodo": 202605,
        "valor": 25130784771.1,
        "delta": 498150938.19
      },
      {
        "periodo": 202606,
        "valor": 25172157845.13,
        "delta": 41373074.03
      },
      {
        "periodo": 202607,
        "valor": 25650966167.86,
        "delta": 478808322.73
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 356087818.0,
    "valor_anterior": 366262896.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 436463927.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 434189588.0,
        "delta": -2274339.0
      },
      {
        "periodo": 202509,
        "valor": 532592779.0,
        "delta": 98403191.0
      },
      {
        "periodo": 202510,
        "valor": 461209077.0,
        "delta": -71383702.0
      },
      {
        "periodo": 202511,
        "valor": 438479571.0,
        "delta": -22729506.0
      },
      {
        "periodo": 202512,
        "valor": 439311554.0,
        "delta": 831983.0
      },
      {
        "periodo": 202601,
        "valor": 408816717.0,
        "delta": -30494837.0
      },
      {
        "periodo": 202602,
        "valor": 423214637.0,
        "delta": 14397920.0
      },
      {
        "periodo": 202603,
        "valor": 412850149.0,
        "delta": -10364488.0
      },
      {
        "periodo": 202604,
        "valor": 380229599.0,
        "delta": -32620550.0
      },
      {
        "periodo": 202605,
        "valor": 344487255.0,
        "delta": -35742344.0
      },
      {
        "periodo": 202606,
        "valor": 366262896.0,
        "delta": 21775641.0
      },
      {
        "periodo": 202607,
        "valor": 356087818.0,
        "delta": -10175078.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 56701410.0,
    "valor_anterior": 61524047.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 53737633.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 57881133.0,
        "delta": 4143500.0
      },
      {
        "periodo": 202509,
        "valor": 49944843.0,
        "delta": -7936290.0
      },
      {
        "periodo": 202510,
        "valor": 69239498.0,
        "delta": 19294655.0
      },
      {
        "periodo": 202511,
        "valor": 61429489.0,
        "delta": -7810009.0
      },
      {
        "periodo": 202512,
        "valor": 53843955.0,
        "delta": -7585534.0
      },
      {
        "periodo": 202601,
        "valor": 44233332.0,
        "delta": -9610623.0
      },
      {
        "periodo": 202602,
        "valor": 65188851.0,
        "delta": 20955519.0
      },
      {
        "periodo": 202603,
        "valor": 78441637.0,
        "delta": 13252786.0
      },
      {
        "periodo": 202604,
        "valor": 69053920.0,
        "delta": -9387717.0
      },
      {
        "periodo": 202605,
        "valor": 46553392.0,
        "delta": -22500528.0
      },
      {
        "periodo": 202606,
        "valor": 61524047.0,
        "delta": 14970655.0
      },
      {
        "periodo": 202607,
        "valor": 56701410.0,
        "delta": -4822637.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 179773531.0,
    "valor_anterior": 179696978.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 158366582.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 159501945.0,
        "delta": 1135363.0
      },
      {
        "periodo": 202509,
        "valor": 146027158.0,
        "delta": -13474787.0
      },
      {
        "periodo": 202510,
        "valor": 141799876.0,
        "delta": -4227282.0
      },
      {
        "periodo": 202511,
        "valor": 142662278.0,
        "delta": 862402.0
      },
      {
        "periodo": 202512,
        "valor": 173524812.0,
        "delta": 30862534.0
      },
      {
        "periodo": 202601,
        "valor": 181616152.0,
        "delta": 8091340.0
      },
      {
        "periodo": 202602,
        "valor": 190478610.0,
        "delta": 8862458.0
      },
      {
        "periodo": 202603,
        "valor": 175779700.0,
        "delta": -14698910.0
      },
      {
        "periodo": 202604,
        "valor": 174131922.0,
        "delta": -1647778.0
      },
      {
        "periodo": 202605,
        "valor": 175737275.0,
        "delta": 1605353.0
      },
      {
        "periodo": 202606,
        "valor": 179696978.0,
        "delta": 3959703.0
      },
      {
        "periodo": 202607,
        "valor": 179773531.0,
        "delta": 76553.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 816696066.7900001,
    "valor_anterior": 799808343.79,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1060921097.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1047319361.46,
        "delta": -13601735.81
      },
      {
        "periodo": 202509,
        "valor": 1042842028.6,
        "delta": -4477332.86
      },
      {
        "periodo": 202510,
        "valor": 1006587675.56,
        "delta": -36254353.04
      },
      {
        "periodo": 202511,
        "valor": 969428444.48,
        "delta": -37159231.08
      },
      {
        "periodo": 202512,
        "valor": 749718208.75,
        "delta": -219710235.73
      },
      {
        "periodo": 202601,
        "valor": 739968143.64,
        "delta": -9750065.11
      },
      {
        "periodo": 202602,
        "valor": 760428064.25,
        "delta": 20459920.61
      },
      {
        "periodo": 202603,
        "valor": 779298641.87,
        "delta": 18870577.62
      },
      {
        "periodo": 202604,
        "valor": 793442218.66,
        "delta": 14143576.79
      },
      {
        "periodo": 202605,
        "valor": 809622299.91,
        "delta": 16180081.25
      },
      {
        "periodo": 202606,
        "valor": 799808343.79,
        "delta": -9813956.12
      },
      {
        "periodo": 202607,
        "valor": 816696066.79,
        "delta": 16887723.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 1787476320.0,
    "valor_anterior": 1832045147.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1747679285.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1808477123.0,
        "delta": 60797838.0
      },
      {
        "periodo": 202509,
        "valor": 1845014264.0,
        "delta": 36537141.0
      },
      {
        "periodo": 202510,
        "valor": 1818126303.0,
        "delta": -26887961.0
      },
      {
        "periodo": 202511,
        "valor": 1818007176.0,
        "delta": -119127.0
      },
      {
        "periodo": 202512,
        "valor": 1870867880.0,
        "delta": 52860704.0
      },
      {
        "periodo": 202601,
        "valor": 1902518509.0,
        "delta": 31650629.0
      },
      {
        "periodo": 202602,
        "valor": 2044337112.0,
        "delta": 141818603.0
      },
      {
        "periodo": 202603,
        "valor": 2010067611.0,
        "delta": -34269501.0
      },
      {
        "periodo": 202604,
        "valor": 1886689854.0,
        "delta": -123377757.0
      },
      {
        "periodo": 202605,
        "valor": 1894141737.0,
        "delta": 7451883.0
      },
      {
        "periodo": 202606,
        "valor": 1832045147.0,
        "delta": -62096590.0
      },
      {
        "periodo": 202607,
        "valor": 1787476320.0,
        "delta": -44568827.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 3703886611.7200003,
    "valor_anterior": 3656904392.46,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4295836700.13,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4271181418.76,
        "delta": -24655281.37
      },
      {
        "periodo": 202509,
        "valor": 4175322132.05,
        "delta": -95859286.71
      },
      {
        "periodo": 202510,
        "valor": 4356401951.08,
        "delta": 181079819.03
      },
      {
        "periodo": 202511,
        "valor": 4306095553.75,
        "delta": -50306397.33
      },
      {
        "periodo": 202512,
        "valor": 4174819675.17,
        "delta": -131275878.58
      },
      {
        "periodo": 202601,
        "valor": 3928057013.35,
        "delta": -246762661.82
      },
      {
        "periodo": 202602,
        "valor": 3950576944.46,
        "delta": 22519931.11
      },
      {
        "periodo": 202603,
        "valor": 3757801736.92,
        "delta": -192775207.54
      },
      {
        "periodo": 202604,
        "valor": 3702660443.05,
        "delta": -55141293.87
      },
      {
        "periodo": 202605,
        "valor": 3651426622.83,
        "delta": -51233820.22
      },
      {
        "periodo": 202606,
        "valor": 3656904392.46,
        "delta": 5477769.63
      },
      {
        "periodo": 202607,
        "valor": 3703886611.72,
        "delta": 46982219.26
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 24868906899.329998,
    "valor_anterior": 24621166001.48,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 23306373685.97,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24341951058.44,
        "delta": 1035577372.47
      },
      {
        "periodo": 202509,
        "valor": 25259435881.21,
        "delta": 917484822.77
      },
      {
        "periodo": 202510,
        "valor": 25915503133.86,
        "delta": 656067252.65
      },
      {
        "periodo": 202511,
        "valor": 25787231039.84,
        "delta": -128272094.02
      },
      {
        "periodo": 202512,
        "valor": 25848323567.82,
        "delta": 61092527.98
      },
      {
        "periodo": 202601,
        "valor": 26374652410.38,
        "delta": 526328842.56
      },
      {
        "periodo": 202602,
        "valor": 26221604068.19,
        "delta": -153048342.19
      },
      {
        "periodo": 202603,
        "valor": 24992078271.32,
        "delta": -1229525796.87
      },
      {
        "periodo": 202604,
        "valor": 24253607584.17,
        "delta": -738470687.15
      },
      {
        "periodo": 202605,
        "valor": 24788226879.45,
        "delta": 534619295.28
      },
      {
        "periodo": 202606,
        "valor": 24621166001.48,
        "delta": -167060877.97
      },
      {
        "periodo": 202607,
        "valor": 24868906899.33,
        "delta": 247740897.85
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 1001378720.02,
    "valor_anterior": 943547168.89,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 403525740.17,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 421697276.37,
        "delta": 18171536.2
      },
      {
        "periodo": 202509,
        "valor": 575112135.28,
        "delta": 153414858.91
      },
      {
        "periodo": 202510,
        "valor": 496962988.64,
        "delta": -78149146.64
      },
      {
        "periodo": 202511,
        "valor": 640654508.45,
        "delta": 143691519.81
      },
      {
        "periodo": 202512,
        "valor": 667765890.38,
        "delta": 27111381.93
      },
      {
        "periodo": 202601,
        "valor": 700540935.65,
        "delta": 32775045.27
      },
      {
        "periodo": 202602,
        "valor": 469803714.82,
        "delta": -230737220.83
      },
      {
        "periodo": 202603,
        "valor": 685471676.26,
        "delta": 215667961.44
      },
      {
        "periodo": 202604,
        "valor": 887794439.45,
        "delta": 202322763.19
      },
      {
        "periodo": 202605,
        "valor": 992729335.65,
        "delta": 104934896.2
      },
      {
        "periodo": 202606,
        "valor": 943547168.89,
        "delta": -49182166.76
      },
      {
        "periodo": 202607,
        "valor": 1001378720.02,
        "delta": 57831551.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 5945483359.000001,
    "valor_anterior": 5840823396.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4397351417.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4568402399.0,
        "delta": 171050982.0
      },
      {
        "periodo": 202509,
        "valor": 4821251913.0,
        "delta": 252849514.0
      },
      {
        "periodo": 202510,
        "valor": 5042454984.0,
        "delta": 221203071.0
      },
      {
        "periodo": 202511,
        "valor": 5183264830.0,
        "delta": 140809846.0
      },
      {
        "periodo": 202512,
        "valor": 5491517014.0,
        "delta": 308252184.0
      },
      {
        "periodo": 202601,
        "valor": 5479058983.0,
        "delta": -12458031.0
      },
      {
        "periodo": 202602,
        "valor": 5630485549.0,
        "delta": 151426566.0
      },
      {
        "periodo": 202603,
        "valor": 5779959184.0,
        "delta": 149473635.0
      },
      {
        "periodo": 202604,
        "valor": 5741252889.0,
        "delta": -38706295.0
      },
      {
        "periodo": 202605,
        "valor": 5744326904.0,
        "delta": 3074015.0
      },
      {
        "periodo": 202606,
        "valor": 5840823396.0,
        "delta": 96496492.0
      },
      {
        "periodo": 202607,
        "valor": 5945483359.0,
        "delta": 104659963.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 2891999641.0,
    "valor_anterior": 2857116876.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2363549033.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2391365360.0,
        "delta": 27816327.0
      },
      {
        "periodo": 202509,
        "valor": 2569306952.0,
        "delta": 177941592.0
      },
      {
        "periodo": 202510,
        "valor": 2551907859.0,
        "delta": -17399093.0
      },
      {
        "periodo": 202511,
        "valor": 2540733063.0,
        "delta": -11174796.0
      },
      {
        "periodo": 202512,
        "valor": 2635532611.0,
        "delta": 94799548.0
      },
      {
        "periodo": 202601,
        "valor": 2621078614.0,
        "delta": -14453997.0
      },
      {
        "periodo": 202602,
        "valor": 2635422801.0,
        "delta": 14344187.0
      },
      {
        "periodo": 202603,
        "valor": 2616655341.0,
        "delta": -18767460.0
      },
      {
        "periodo": 202604,
        "valor": 2841651405.0,
        "delta": 224996064.0
      },
      {
        "periodo": 202605,
        "valor": 2833658097.0,
        "delta": -7993308.0
      },
      {
        "periodo": 202606,
        "valor": 2857116876.0,
        "delta": 23458779.0
      },
      {
        "periodo": 202607,
        "valor": 2891999641.0,
        "delta": 34882765.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 771813407.0,
    "valor_anterior": 769044087.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1016889366.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1036810823.0,
        "delta": 19921457.0
      },
      {
        "periodo": 202509,
        "valor": 995576173.0,
        "delta": -41234650.0
      },
      {
        "periodo": 202510,
        "valor": 985928429.0,
        "delta": -9647744.0
      },
      {
        "periodo": 202511,
        "valor": 890646438.0,
        "delta": -95281991.0
      },
      {
        "periodo": 202512,
        "valor": 940173912.0,
        "delta": 49527474.0
      },
      {
        "periodo": 202601,
        "valor": 964694362.0,
        "delta": 24520450.0
      },
      {
        "periodo": 202602,
        "valor": 926645370.0,
        "delta": -38048992.0
      },
      {
        "periodo": 202603,
        "valor": 938744326.0,
        "delta": 12098956.0
      },
      {
        "periodo": 202604,
        "valor": 909636099.0,
        "delta": -29108227.0
      },
      {
        "periodo": 202605,
        "valor": 719609518.0,
        "delta": -190026581.0
      },
      {
        "periodo": 202606,
        "valor": 769044087.0,
        "delta": 49434569.0
      },
      {
        "periodo": 202607,
        "valor": 771813407.0,
        "delta": 2769320.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 66725854.0,
    "valor_anterior": 74414244.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1338174983.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1388776940.0,
        "delta": 50601957.0
      },
      {
        "periodo": 202509,
        "valor": 516274826.0,
        "delta": -872502114.0
      },
      {
        "periodo": 202510,
        "valor": 519497259.0,
        "delta": 3222433.0
      },
      {
        "periodo": 202511,
        "valor": 513798369.0,
        "delta": -5698890.0
      },
      {
        "periodo": 202512,
        "valor": 359308373.0,
        "delta": -154489996.0
      },
      {
        "periodo": 202601,
        "valor": 331488926.0,
        "delta": -27819447.0
      },
      {
        "periodo": 202602,
        "valor": 339296769.0,
        "delta": 7807843.0
      },
      {
        "periodo": 202603,
        "valor": 164845820.0,
        "delta": -174450949.0
      },
      {
        "periodo": 202604,
        "valor": 162403272.0,
        "delta": -2442548.0
      },
      {
        "periodo": 202605,
        "valor": 159831131.0,
        "delta": -2572141.0
      },
      {
        "periodo": 202606,
        "valor": 74414244.0,
        "delta": -85416887.0
      },
      {
        "periodo": 202607,
        "valor": 66725854.0,
        "delta": -7688390.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 7311758801.02,
    "valor_anterior": 7251618500.62,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6143547979.52,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6427030748.0,
        "delta": 283482768.48
      },
      {
        "periodo": 202509,
        "valor": 6470790062.27,
        "delta": 43759314.27
      },
      {
        "periodo": 202510,
        "valor": 5944059989.56,
        "delta": -526730072.71
      },
      {
        "periodo": 202511,
        "valor": 6298985086.24,
        "delta": 354925096.68
      },
      {
        "periodo": 202512,
        "valor": 6222175105.49,
        "delta": -76809980.75
      },
      {
        "periodo": 202601,
        "valor": 6950751693.67,
        "delta": 728576588.18
      },
      {
        "periodo": 202602,
        "valor": 7110995479.15,
        "delta": 160243785.48
      },
      {
        "periodo": 202603,
        "valor": 7263526791.82,
        "delta": 152531312.67
      },
      {
        "periodo": 202604,
        "valor": 7511289475.71,
        "delta": 247762683.89
      },
      {
        "periodo": 202605,
        "valor": 7498491536.27,
        "delta": -12797939.44
      },
      {
        "periodo": 202606,
        "valor": 7251618500.62,
        "delta": -246873035.65
      },
      {
        "periodo": 202607,
        "valor": 7311758801.02,
        "delta": 60140300.4
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 301099768.0,
    "valor_anterior": 286003623.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 150024523.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 162881563.0,
        "delta": 12857040.0
      },
      {
        "periodo": 202509,
        "valor": 179319874.0,
        "delta": 16438311.0
      },
      {
        "periodo": 202510,
        "valor": 193194308.0,
        "delta": 13874434.0
      },
      {
        "periodo": 202511,
        "valor": 206871013.0,
        "delta": 13676705.0
      },
      {
        "periodo": 202512,
        "valor": 216801242.0,
        "delta": 9930229.0
      },
      {
        "periodo": 202601,
        "valor": 217614519.0,
        "delta": 813277.0
      },
      {
        "periodo": 202602,
        "valor": 235123169.0,
        "delta": 17508650.0
      },
      {
        "periodo": 202603,
        "valor": 247626155.0,
        "delta": 12502986.0
      },
      {
        "periodo": 202604,
        "valor": 257684531.0,
        "delta": 10058376.0
      },
      {
        "periodo": 202605,
        "valor": 269492133.0,
        "delta": 11807602.0
      },
      {
        "periodo": 202606,
        "valor": 286003623.0,
        "delta": 16511490.0
      },
      {
        "periodo": 202607,
        "valor": 301099768.0,
        "delta": 15096145.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 1511714.0,
    "valor_anterior": 1472185.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1078552.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1381933.0,
        "delta": 303381.0
      },
      {
        "periodo": 202509,
        "valor": 1410555.0,
        "delta": 28622.0
      },
      {
        "periodo": 202510,
        "valor": 1383301.0,
        "delta": -27254.0
      },
      {
        "periodo": 202511,
        "valor": 1243696.0,
        "delta": -139605.0
      },
      {
        "periodo": 202512,
        "valor": 1258209.0,
        "delta": 14513.0
      },
      {
        "periodo": 202601,
        "valor": 1258209.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 1258209.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1243527.0,
        "delta": -14682.0
      },
      {
        "periodo": 202604,
        "valor": 1243527.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1436036.0,
        "delta": 192509.0
      },
      {
        "periodo": 202606,
        "valor": 1472185.0,
        "delta": 36149.0
      },
      {
        "periodo": 202607,
        "valor": 1511714.0,
        "delta": 39529.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 1278593181.0,
    "valor_anterior": 1201412878.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1114665733.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1107031300.0,
        "delta": -7634433.0
      },
      {
        "periodo": 202509,
        "valor": 1107792749.0,
        "delta": 761449.0
      },
      {
        "periodo": 202510,
        "valor": 1131992908.0,
        "delta": 24200159.0
      },
      {
        "periodo": 202511,
        "valor": 1131922843.0,
        "delta": -70065.0
      },
      {
        "periodo": 202512,
        "valor": 1140550550.0,
        "delta": 8627707.0
      },
      {
        "periodo": 202601,
        "valor": 1154797583.0,
        "delta": 14247033.0
      },
      {
        "periodo": 202602,
        "valor": 1165673303.0,
        "delta": 10875720.0
      },
      {
        "periodo": 202603,
        "valor": 1140914291.0,
        "delta": -24759012.0
      },
      {
        "periodo": 202604,
        "valor": 1199599588.0,
        "delta": 58685297.0
      },
      {
        "periodo": 202605,
        "valor": 1165630020.0,
        "delta": -33969568.0
      },
      {
        "periodo": 202606,
        "valor": 1201412878.0,
        "delta": 35782858.0
      },
      {
        "periodo": 202607,
        "valor": 1278593181.0,
        "delta": 77180303.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 253745237.0,
    "valor_anterior": 238676757.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 164392758.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 206714095.0,
        "delta": 42321337.0
      },
      {
        "periodo": 202509,
        "valor": 172574114.0,
        "delta": -34139981.0
      },
      {
        "periodo": 202510,
        "valor": 186613404.0,
        "delta": 14039290.0
      },
      {
        "periodo": 202511,
        "valor": 227464567.0,
        "delta": 40851163.0
      },
      {
        "periodo": 202512,
        "valor": 207217147.0,
        "delta": -20247420.0
      },
      {
        "periodo": 202601,
        "valor": 245201328.0,
        "delta": 37984181.0
      },
      {
        "periodo": 202602,
        "valor": 240888349.0,
        "delta": -4312979.0
      },
      {
        "periodo": 202603,
        "valor": 239453236.0,
        "delta": -1435113.0
      },
      {
        "periodo": 202604,
        "valor": 249612470.0,
        "delta": 10159234.0
      },
      {
        "periodo": 202605,
        "valor": 294340385.0,
        "delta": 44727915.0
      },
      {
        "periodo": 202606,
        "valor": 238676757.0,
        "delta": -55663628.0
      },
      {
        "periodo": 202607,
        "valor": 253745237.0,
        "delta": 15068480.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 539173215.17,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 363795824.36,
        "delta": -175377390.81
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 350004589.0,
    "valor_anterior": 351455132.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 344430582.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 353500541.0,
        "delta": 9069959.0
      },
      {
        "periodo": 202509,
        "valor": 348487981.0,
        "delta": -5012560.0
      },
      {
        "periodo": 202510,
        "valor": 349367929.0,
        "delta": 879948.0
      },
      {
        "periodo": 202511,
        "valor": 349014013.0,
        "delta": -353916.0
      },
      {
        "periodo": 202512,
        "valor": 350722936.0,
        "delta": 1708923.0
      },
      {
        "periodo": 202601,
        "valor": 345643034.0,
        "delta": -5079902.0
      },
      {
        "periodo": 202602,
        "valor": 352023689.0,
        "delta": 6380655.0
      },
      {
        "periodo": 202603,
        "valor": 370204274.0,
        "delta": 18180585.0
      },
      {
        "periodo": 202604,
        "valor": 315154555.0,
        "delta": -55049719.0
      },
      {
        "periodo": 202605,
        "valor": 344797739.0,
        "delta": 29643184.0
      },
      {
        "periodo": 202606,
        "valor": 351455132.0,
        "delta": 6657393.0
      },
      {
        "periodo": 202607,
        "valor": 350004589.0,
        "delta": -1450543.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 304296008.52,
    "valor_anterior": 295267430.97,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 231835060.59,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 237975422.46,
        "delta": 6140361.87
      },
      {
        "periodo": 202509,
        "valor": 219305738.8,
        "delta": -18669683.66
      },
      {
        "periodo": 202510,
        "valor": 225328361.7,
        "delta": 6022622.9
      },
      {
        "periodo": 202511,
        "valor": 239552159.62,
        "delta": 14223797.92
      },
      {
        "periodo": 202512,
        "valor": 253293227.64,
        "delta": 13741068.02
      },
      {
        "periodo": 202601,
        "valor": 252016000.0,
        "delta": -1277227.64
      },
      {
        "periodo": 202602,
        "valor": 268105034.83,
        "delta": 16089034.83
      },
      {
        "periodo": 202603,
        "valor": 281184630.19,
        "delta": 13079595.36
      },
      {
        "periodo": 202604,
        "valor": 287691895.95,
        "delta": 6507265.76
      },
      {
        "periodo": 202605,
        "valor": 292839194.46,
        "delta": 5147298.51
      },
      {
        "periodo": 202606,
        "valor": 295267430.97,
        "delta": 2428236.51
      },
      {
        "periodo": 202607,
        "valor": 304296008.52,
        "delta": 9028577.55
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 84545673.0,
    "valor_anterior": 83167474.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 46525190.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 46028343.0,
        "delta": -496847.0
      },
      {
        "periodo": 202509,
        "valor": 49755149.0,
        "delta": 3726806.0
      },
      {
        "periodo": 202510,
        "valor": 55726915.0,
        "delta": 5971766.0
      },
      {
        "periodo": 202511,
        "valor": 61061027.0,
        "delta": 5334112.0
      },
      {
        "periodo": 202512,
        "valor": 60602053.0,
        "delta": -458974.0
      },
      {
        "periodo": 202601,
        "valor": 63260876.0,
        "delta": 2658823.0
      },
      {
        "periodo": 202602,
        "valor": 66901241.0,
        "delta": 3640365.0
      },
      {
        "periodo": 202603,
        "valor": 68642470.0,
        "delta": 1741229.0
      },
      {
        "periodo": 202604,
        "valor": 74890568.0,
        "delta": 6248098.0
      },
      {
        "periodo": 202605,
        "valor": 79416894.0,
        "delta": 4526326.0
      },
      {
        "periodo": 202606,
        "valor": 83167474.0,
        "delta": 3750580.0
      },
      {
        "periodo": 202607,
        "valor": 84545673.0,
        "delta": 1378199.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 230047473.75,
    "valor_anterior": 239749675.24,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 235989881.03,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 229134864.22,
        "delta": -6855016.81
      },
      {
        "periodo": 202509,
        "valor": 223545674.54,
        "delta": -5589189.68
      },
      {
        "periodo": 202510,
        "valor": 229761364.53,
        "delta": 6215689.99
      },
      {
        "periodo": 202511,
        "valor": 227005627.86,
        "delta": -2755736.67
      },
      {
        "periodo": 202512,
        "valor": 211668834.57,
        "delta": -15336793.29
      },
      {
        "periodo": 202601,
        "valor": 210932334.07,
        "delta": -736500.5
      },
      {
        "periodo": 202602,
        "valor": 218858756.36,
        "delta": 7926422.29
      },
      {
        "periodo": 202603,
        "valor": 219291218.53,
        "delta": 432462.17
      },
      {
        "periodo": 202604,
        "valor": 224798811.1,
        "delta": 5507592.57
      },
      {
        "periodo": 202605,
        "valor": 228474879.59,
        "delta": 3676068.49
      },
      {
        "periodo": 202606,
        "valor": 239749675.24,
        "delta": 11274795.65
      },
      {
        "periodo": 202607,
        "valor": 230047473.75,
        "delta": -9702201.49
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 8991692.0,
    "valor_anterior": 8636882.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12600917.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11982159.0,
        "delta": -618758.0
      },
      {
        "periodo": 202509,
        "valor": 11439356.0,
        "delta": -542803.0
      },
      {
        "periodo": 202510,
        "valor": 9201847.0,
        "delta": -2237509.0
      },
      {
        "periodo": 202511,
        "valor": 9138222.0,
        "delta": -63625.0
      },
      {
        "periodo": 202512,
        "valor": 9159874.0,
        "delta": 21652.0
      },
      {
        "periodo": 202601,
        "valor": 8846170.0,
        "delta": -313704.0
      },
      {
        "periodo": 202602,
        "valor": 8922844.0,
        "delta": 76674.0
      },
      {
        "periodo": 202603,
        "valor": 8947214.0,
        "delta": 24370.0
      },
      {
        "periodo": 202604,
        "valor": 8989674.0,
        "delta": 42460.0
      },
      {
        "periodo": 202605,
        "valor": 8710761.0,
        "delta": -278913.0
      },
      {
        "periodo": 202606,
        "valor": 8636882.0,
        "delta": -73879.0
      },
      {
        "periodo": 202607,
        "valor": 8991692.0,
        "delta": 354810.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 1002194915.95,
    "valor_anterior": 993316876.3,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 631240265.84,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 639435789.66,
        "delta": 8195523.82
      },
      {
        "periodo": 202509,
        "valor": 782156815.12,
        "delta": 142721025.46
      },
      {
        "periodo": 202510,
        "valor": 753298150.27,
        "delta": -28858664.85
      },
      {
        "periodo": 202511,
        "valor": 756982779.82,
        "delta": 3684629.55
      },
      {
        "periodo": 202512,
        "valor": 751895778.86,
        "delta": -5087000.96
      },
      {
        "periodo": 202601,
        "valor": 762106901.83,
        "delta": 10211122.97
      },
      {
        "periodo": 202602,
        "valor": 773353754.21,
        "delta": 11246852.38
      },
      {
        "periodo": 202603,
        "valor": 892427138.54,
        "delta": 119073384.33
      },
      {
        "periodo": 202604,
        "valor": 904607076.74,
        "delta": 12179938.2
      },
      {
        "periodo": 202605,
        "valor": 911021582.09,
        "delta": 6414505.35
      },
      {
        "periodo": 202606,
        "valor": 993316876.3,
        "delta": 82295294.21
      },
      {
        "periodo": 202607,
        "valor": 1002194915.95,
        "delta": 8878039.65
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 332129766.51,
    "valor_anterior": 334254277.44,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 248280372.7,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 258378827.88,
        "delta": 10098455.18
      },
      {
        "periodo": 202509,
        "valor": 275452682.34,
        "delta": 17073854.46
      },
      {
        "periodo": 202510,
        "valor": 289085273.78,
        "delta": 13632591.44
      },
      {
        "periodo": 202511,
        "valor": 301419748.47,
        "delta": 12334474.69
      },
      {
        "periodo": 202512,
        "valor": 318607518.48,
        "delta": 17187770.01
      },
      {
        "periodo": 202601,
        "valor": 326774174.98,
        "delta": 8166656.5
      },
      {
        "periodo": 202602,
        "valor": 329426614.69,
        "delta": 2652439.71
      },
      {
        "periodo": 202603,
        "valor": 336493635.42,
        "delta": 7067020.73
      },
      {
        "periodo": 202604,
        "valor": 341353905.62,
        "delta": 4860270.2
      },
      {
        "periodo": 202605,
        "valor": 359174514.51,
        "delta": 17820608.89
      },
      {
        "periodo": 202606,
        "valor": 334254277.44,
        "delta": -24920237.07
      },
      {
        "periodo": 202607,
        "valor": 332129766.51,
        "delta": -2124510.93
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 202222293.0,
    "valor_anterior": 159761840.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 95122452.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 96731127.0,
        "delta": 1608675.0
      },
      {
        "periodo": 202509,
        "valor": 89193841.0,
        "delta": -7537286.0
      },
      {
        "periodo": 202510,
        "valor": 91539837.0,
        "delta": 2345996.0
      },
      {
        "periodo": 202511,
        "valor": 100868062.0,
        "delta": 9328225.0
      },
      {
        "periodo": 202512,
        "valor": 107294302.0,
        "delta": 6426240.0
      },
      {
        "periodo": 202601,
        "valor": 104611661.0,
        "delta": -2682641.0
      },
      {
        "periodo": 202602,
        "valor": 42202717.0,
        "delta": -62408944.0
      },
      {
        "periodo": 202603,
        "valor": 90874729.0,
        "delta": 48672012.0
      },
      {
        "periodo": 202604,
        "valor": 150128926.0,
        "delta": 59254197.0
      },
      {
        "periodo": 202605,
        "valor": 151760238.0,
        "delta": 1631312.0
      },
      {
        "periodo": 202606,
        "valor": 159761840.0,
        "delta": 8001602.0
      },
      {
        "periodo": 202607,
        "valor": 202222293.0,
        "delta": 42460453.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 1547825326.0,
    "valor_anterior": 1542974937.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1488439980.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1409503223.0,
        "delta": -78936757.0
      },
      {
        "periodo": 202509,
        "valor": 1327787830.0,
        "delta": -81715393.0
      },
      {
        "periodo": 202510,
        "valor": 1329286455.0,
        "delta": 1498625.0
      },
      {
        "periodo": 202511,
        "valor": 1318716374.0,
        "delta": -10570081.0
      },
      {
        "periodo": 202512,
        "valor": 1504289272.0,
        "delta": 185572898.0
      },
      {
        "periodo": 202601,
        "valor": 1477956455.0,
        "delta": -26332817.0
      },
      {
        "periodo": 202602,
        "valor": 1506165528.0,
        "delta": 28209073.0
      },
      {
        "periodo": 202603,
        "valor": 1556684908.0,
        "delta": 50519380.0
      },
      {
        "periodo": 202604,
        "valor": 1577211677.0,
        "delta": 20526769.0
      },
      {
        "periodo": 202605,
        "valor": 1570515269.0,
        "delta": -6696408.0
      },
      {
        "periodo": 202606,
        "valor": 1542974937.0,
        "delta": -27540332.0
      },
      {
        "periodo": 202607,
        "valor": 1547825326.0,
        "delta": 4850389.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 24282701.0,
    "valor_anterior": 37903324.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 46005055.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 41397119.0,
        "delta": -4607936.0
      },
      {
        "periodo": 202509,
        "valor": 40497151.0,
        "delta": -899968.0
      },
      {
        "periodo": 202510,
        "valor": 40171532.0,
        "delta": -325619.0
      },
      {
        "periodo": 202511,
        "valor": 40213825.0,
        "delta": 42293.0
      },
      {
        "periodo": 202512,
        "valor": 39945683.0,
        "delta": -268142.0
      },
      {
        "periodo": 202601,
        "valor": 38547103.0,
        "delta": -1398580.0
      },
      {
        "periodo": 202602,
        "valor": 38154404.0,
        "delta": -392699.0
      },
      {
        "periodo": 202603,
        "valor": 38958013.0,
        "delta": 803609.0
      },
      {
        "periodo": 202604,
        "valor": 35830161.0,
        "delta": -3127852.0
      },
      {
        "periodo": 202605,
        "valor": 34958433.0,
        "delta": -871728.0
      },
      {
        "periodo": 202606,
        "valor": 37903324.0,
        "delta": 2944891.0
      },
      {
        "periodo": 202607,
        "valor": 24282701.0,
        "delta": -13620623.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 32116358.25,
    "valor_anterior": 32058894.240000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28253173.35,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28112973.18,
        "delta": -140200.17
      },
      {
        "periodo": 202509,
        "valor": 28318030.37,
        "delta": 205057.19
      },
      {
        "periodo": 202510,
        "valor": 27725590.54,
        "delta": -592439.83
      },
      {
        "periodo": 202511,
        "valor": 11149997.6,
        "delta": -16575592.94
      },
      {
        "periodo": 202512,
        "valor": 11603831.79,
        "delta": 453834.19
      },
      {
        "periodo": 202601,
        "valor": 12053541.31,
        "delta": 449709.52
      },
      {
        "periodo": 202602,
        "valor": 13671554.57,
        "delta": 1618013.26
      },
      {
        "periodo": 202603,
        "valor": 13129475.87,
        "delta": -542078.7
      },
      {
        "periodo": 202604,
        "valor": 31543881.07,
        "delta": 18414405.2
      },
      {
        "periodo": 202605,
        "valor": 32444651.0,
        "delta": 900769.93
      },
      {
        "periodo": 202606,
        "valor": 32058894.24,
        "delta": -385756.76
      },
      {
        "periodo": 202607,
        "valor": 32116358.25,
        "delta": 57464.01
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 78763312.91,
    "valor_anterior": 77936549.28,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 132637458.51,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 123692225.13,
        "delta": -8945233.38
      },
      {
        "periodo": 202509,
        "valor": 119149560.69,
        "delta": -4542664.44
      },
      {
        "periodo": 202510,
        "valor": 72965526.46,
        "delta": -46184034.23
      },
      {
        "periodo": 202511,
        "valor": 75167761.54,
        "delta": 2202235.08
      },
      {
        "periodo": 202512,
        "valor": 74012068.17,
        "delta": -1155693.37
      },
      {
        "periodo": 202601,
        "valor": 74601052.83,
        "delta": 588984.66
      },
      {
        "periodo": 202602,
        "valor": 75690551.08,
        "delta": 1089498.25
      },
      {
        "periodo": 202603,
        "valor": 72223524.84,
        "delta": -3467026.24
      },
      {
        "periodo": 202604,
        "valor": 73099870.92,
        "delta": 876346.08
      },
      {
        "periodo": 202605,
        "valor": 73079032.12,
        "delta": -20838.8
      },
      {
        "periodo": 202606,
        "valor": 77936549.28,
        "delta": 4857517.16
      },
      {
        "periodo": 202607,
        "valor": 78763312.91,
        "delta": 826763.63
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 235.77,
    "valor_anterior": 119672.85,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1688531.86,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1276701.56,
        "delta": -411830.3
      },
      {
        "periodo": 202509,
        "valor": 223107.92,
        "delta": -1053593.64
      },
      {
        "periodo": 202510,
        "valor": 253066.57,
        "delta": 29958.65
      },
      {
        "periodo": 202511,
        "valor": 1229514.27,
        "delta": 976447.7
      },
      {
        "periodo": 202512,
        "valor": 85571.09,
        "delta": -1143943.18
      },
      {
        "periodo": 202601,
        "valor": 129073.64,
        "delta": 43502.55
      },
      {
        "periodo": 202602,
        "valor": 70076.61,
        "delta": -58997.03
      },
      {
        "periodo": 202603,
        "valor": 825540.72,
        "delta": 755464.11
      },
      {
        "periodo": 202604,
        "valor": 1106937.61,
        "delta": 281396.89
      },
      {
        "periodo": 202605,
        "valor": 271718.84,
        "delta": -835218.77
      },
      {
        "periodo": 202606,
        "valor": 119672.85,
        "delta": -152045.99
      },
      {
        "periodo": 202607,
        "valor": 235.77,
        "delta": -119437.08
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 74481397.0,
    "valor_anterior": 74660149.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 74139374.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 73692878.0,
        "delta": -446496.0
      },
      {
        "periodo": 202509,
        "valor": 73596804.0,
        "delta": -96074.0
      },
      {
        "periodo": 202510,
        "valor": 73472046.0,
        "delta": -124758.0
      },
      {
        "periodo": 202511,
        "valor": 76433177.0,
        "delta": 2961131.0
      },
      {
        "periodo": 202512,
        "valor": 76435008.0,
        "delta": 1831.0
      },
      {
        "periodo": 202601,
        "valor": 76217308.0,
        "delta": -217700.0
      },
      {
        "periodo": 202602,
        "valor": 76182744.0,
        "delta": -34564.0
      },
      {
        "periodo": 202603,
        "valor": 77390505.0,
        "delta": 1207761.0
      },
      {
        "periodo": 202604,
        "valor": 77948905.0,
        "delta": 558400.0
      },
      {
        "periodo": 202605,
        "valor": 76004592.0,
        "delta": -1944313.0
      },
      {
        "periodo": 202606,
        "valor": 74660149.0,
        "delta": -1344443.0
      },
      {
        "periodo": 202607,
        "valor": 74481397.0,
        "delta": -178752.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 37464.2,
    "valor_anterior": 102780.26,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5543221.76,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3949615.38,
        "delta": -1593606.38
      },
      {
        "periodo": 202509,
        "valor": 2365594.97,
        "delta": -1584020.41
      },
      {
        "periodo": 202510,
        "valor": 1559090.11,
        "delta": -806504.86
      },
      {
        "periodo": 202511,
        "valor": 1013699.5,
        "delta": -545390.61
      },
      {
        "periodo": 202512,
        "valor": 580631.68,
        "delta": -433067.82
      },
      {
        "periodo": 202601,
        "valor": 372245.19,
        "delta": -208386.49
      },
      {
        "periodo": 202602,
        "valor": 331404.74,
        "delta": -40840.45
      },
      {
        "periodo": 202603,
        "valor": 269184.27,
        "delta": -62220.47
      },
      {
        "periodo": 202604,
        "valor": 135180.59,
        "delta": -134003.68
      },
      {
        "periodo": 202605,
        "valor": 118545.3,
        "delta": -16635.29
      },
      {
        "periodo": 202606,
        "valor": 102780.26,
        "delta": -15765.04
      },
      {
        "periodo": 202607,
        "valor": 37464.2,
        "delta": -65316.06
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 479976502.08,
    "valor_anterior": 469719859.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 444286050.0,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 444571794.0,
        "delta": 285744.0
      },
      {
        "periodo": 202604,
        "valor": 471474970.62,
        "delta": 26903176.62
      },
      {
        "periodo": 202605,
        "valor": 470023044.0,
        "delta": -1451926.62
      },
      {
        "periodo": 202606,
        "valor": 469719859.0,
        "delta": -303185.0
      },
      {
        "periodo": 202607,
        "valor": 479976502.08,
        "delta": 10256643.08
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 110832462.0,
    "valor_anterior": 107234624.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27243160.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 43813655.0,
        "delta": 16570495.0
      },
      {
        "periodo": 202509,
        "valor": 60464751.0,
        "delta": 16651096.0
      },
      {
        "periodo": 202510,
        "valor": 78137614.0,
        "delta": 17672863.0
      },
      {
        "periodo": 202511,
        "valor": 95031856.0,
        "delta": 16894242.0
      },
      {
        "periodo": 202512,
        "valor": 97002617.0,
        "delta": 1970761.0
      },
      {
        "periodo": 202601,
        "valor": 97207151.0,
        "delta": 204534.0
      },
      {
        "periodo": 202602,
        "valor": 96194206.0,
        "delta": -1012945.0
      },
      {
        "periodo": 202603,
        "valor": 91211258.0,
        "delta": -4982948.0
      },
      {
        "periodo": 202604,
        "valor": 99105554.0,
        "delta": 7894296.0
      },
      {
        "periodo": 202605,
        "valor": 107115241.0,
        "delta": 8009687.0
      },
      {
        "periodo": 202606,
        "valor": 107234624.0,
        "delta": 119383.0
      },
      {
        "periodo": 202607,
        "valor": 110832462.0,
        "delta": 3597838.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 39560999.0,
    "valor_anterior": 28907579.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 499740.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 1345171.0,
        "delta": 845431.0
      },
      {
        "periodo": 202601,
        "valor": 4486903.0,
        "delta": 3141732.0
      },
      {
        "periodo": 202602,
        "valor": 8975276.0,
        "delta": 4488373.0
      },
      {
        "periodo": 202603,
        "valor": 11904045.0,
        "delta": 2928769.0
      },
      {
        "periodo": 202604,
        "valor": 17102112.0,
        "delta": 5198067.0
      },
      {
        "periodo": 202605,
        "valor": 21955333.0,
        "delta": 4853221.0
      },
      {
        "periodo": 202606,
        "valor": 28907579.0,
        "delta": 6952246.0
      },
      {
        "periodo": 202607,
        "valor": 39560999.0,
        "delta": 10653420.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 2907107201.0,
    "valor_anterior": 2529641403.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 2103840406.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 2405346103.0,
        "delta": 301505697.0
      },
      {
        "periodo": 202605,
        "valor": 2733362507.0,
        "delta": 328016404.0
      },
      {
        "periodo": 202606,
        "valor": 2529641403.0,
        "delta": -203721104.0
      },
      {
        "periodo": 202607,
        "valor": 2907107201.0,
        "delta": 377465798.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 101800103003,
    "label": "EPRC Total A-0417 — Estimaciones I+II+III+IV",
    "valor_actual": 277500680984.25,
    "valor_anterior": 274689427091.36002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 232079635033.79,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 234682910678.1,
        "delta": 2603275644.31
      },
      {
        "periodo": 202509,
        "valor": 238586876829.66,
        "delta": 3903966151.56
      },
      {
        "periodo": 202510,
        "valor": 241478782520.51,
        "delta": 2891905690.85
      },
      {
        "periodo": 202511,
        "valor": 242223953652.22,
        "delta": 745171131.71
      },
      {
        "periodo": 202512,
        "valor": 241249895475.7,
        "delta": -974058176.52
      },
      {
        "periodo": 202601,
        "valor": 242907047701.17,
        "delta": 1657152225.47
      },
      {
        "periodo": 202602,
        "valor": 263395101533.69,
        "delta": 20488053832.52
      },
      {
        "periodo": 202603,
        "valor": 266878534002.31,
        "delta": 3483432468.62
      },
      {
        "periodo": 202604,
        "valor": 268282251547.82,
        "delta": 1403717545.51
      },
      {
        "periodo": 202605,
        "valor": 274512360358.02,
        "delta": 6230108810.2
      },
      {
        "periodo": 202606,
        "valor": 274689427091.36,
        "delta": 177066733.34
      },
      {
        "periodo": 202607,
        "valor": 277500680984.25,
        "delta": 2811253892.89
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 1181643543.42,
    "valor_anterior": 1169456826.1,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 258536418.64,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 267294810.63,
        "delta": 8758391.99
      },
      {
        "periodo": 202509,
        "valor": 274036202.18,
        "delta": 6741391.55
      },
      {
        "periodo": 202510,
        "valor": 280303192.12,
        "delta": 6266989.94
      },
      {
        "periodo": 202511,
        "valor": 284859350.52,
        "delta": 4556158.4
      },
      {
        "periodo": 202512,
        "valor": 283705610.41,
        "delta": -1153740.11
      },
      {
        "periodo": 202601,
        "valor": 299954158.29,
        "delta": 16248547.88
      },
      {
        "periodo": 202602,
        "valor": 1133558592.57,
        "delta": 833604434.28
      },
      {
        "periodo": 202603,
        "valor": 1084323765.06,
        "delta": -49234827.51
      },
      {
        "periodo": 202604,
        "valor": 1070933307.43,
        "delta": -13390457.63
      },
      {
        "periodo": 202605,
        "valor": 1122837466.19,
        "delta": 51904158.76
      },
      {
        "periodo": 202606,
        "valor": 1169456826.1,
        "delta": 46619359.91
      },
      {
        "periodo": 202607,
        "valor": 1181643543.42,
        "delta": 12186717.32
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1921797011.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1537463678.25,
        "delta": -384333333.0
      },
      {
        "periodo": 202509,
        "valor": 1153130345.25,
        "delta": -384333333.0
      },
      {
        "periodo": 202510,
        "valor": 768797012.25,
        "delta": -384333333.0
      },
      {
        "periodo": 202511,
        "valor": 384463679.25,
        "delta": -384333333.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 380674731.0,
    "valor_anterior": 388291383.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 74288766.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 72618603.0,
        "delta": -1670163.0
      },
      {
        "periodo": 202509,
        "valor": 123987927.0,
        "delta": 51369324.0
      },
      {
        "periodo": 202510,
        "valor": 138791152.0,
        "delta": 14803225.0
      },
      {
        "periodo": 202511,
        "valor": 149073648.0,
        "delta": 10282496.0
      },
      {
        "periodo": 202512,
        "valor": 551662726.0,
        "delta": 402589078.0
      },
      {
        "periodo": 202601,
        "valor": 499863058.0,
        "delta": -51799668.0
      },
      {
        "periodo": 202602,
        "valor": 464219258.0,
        "delta": -35643800.0
      },
      {
        "periodo": 202603,
        "valor": 441377964.0,
        "delta": -22841294.0
      },
      {
        "periodo": 202604,
        "valor": 429160063.0,
        "delta": -12217901.0
      },
      {
        "periodo": 202605,
        "valor": 412069030.0,
        "delta": -17091033.0
      },
      {
        "periodo": 202606,
        "valor": 388291383.0,
        "delta": -23777647.0
      },
      {
        "periodo": 202607,
        "valor": 380674731.0,
        "delta": -7616652.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 105965830.0,
    "valor_anterior": 123954676.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25296387.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25521314.0,
        "delta": 224927.0
      },
      {
        "periodo": 202509,
        "valor": 19104360.0,
        "delta": -6416954.0
      },
      {
        "periodo": 202510,
        "valor": 27603748.0,
        "delta": 8499388.0
      },
      {
        "periodo": 202511,
        "valor": 86284614.0,
        "delta": 58680866.0
      },
      {
        "periodo": 202512,
        "valor": 104685299.0,
        "delta": 18400685.0
      },
      {
        "periodo": 202601,
        "valor": 99030652.0,
        "delta": -5654647.0
      },
      {
        "periodo": 202602,
        "valor": 90043925.0,
        "delta": -8986727.0
      },
      {
        "periodo": 202603,
        "valor": 132184489.0,
        "delta": 42140564.0
      },
      {
        "periodo": 202604,
        "valor": 123059014.0,
        "delta": -9125475.0
      },
      {
        "periodo": 202605,
        "valor": 118868254.0,
        "delta": -4190760.0
      },
      {
        "periodo": 202606,
        "valor": 123954676.0,
        "delta": 5086422.0
      },
      {
        "periodo": 202607,
        "valor": 105965830.0,
        "delta": -17988846.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 3090592.97,
    "valor_anterior": 3007618.16,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 676299595.35,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 637753512.03,
        "delta": -38546083.32
      },
      {
        "periodo": 202509,
        "valor": 685416665.24,
        "delta": 47663153.21
      },
      {
        "periodo": 202510,
        "valor": 663971362.28,
        "delta": -21445302.96
      },
      {
        "periodo": 202511,
        "valor": 515052936.33,
        "delta": -148918425.95
      },
      {
        "periodo": 202512,
        "valor": 336862627.77,
        "delta": -178190308.56
      },
      {
        "periodo": 202601,
        "valor": 326735527.97,
        "delta": -10127099.8
      },
      {
        "periodo": 202602,
        "valor": 318889823.73,
        "delta": -7845704.24
      },
      {
        "periodo": 202603,
        "valor": 303163891.19,
        "delta": -15725932.54
      },
      {
        "periodo": 202604,
        "valor": 105834437.24,
        "delta": -197329453.95
      },
      {
        "periodo": 202605,
        "valor": 102672220.0,
        "delta": -3162217.24
      },
      {
        "periodo": 202606,
        "valor": 3007618.16,
        "delta": -99664601.84
      },
      {
        "periodo": 202607,
        "valor": 3090592.97,
        "delta": 82974.81
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 67492003.0,
    "valor_anterior": 57692003.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 132578958.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 108591461.0,
        "delta": -23987497.0
      },
      {
        "periodo": 202509,
        "valor": 74690159.0,
        "delta": -33901302.0
      },
      {
        "periodo": 202510,
        "valor": 78461417.0,
        "delta": 3771258.0
      },
      {
        "periodo": 202511,
        "valor": 86515772.0,
        "delta": 8054355.0
      },
      {
        "periodo": 202512,
        "valor": 64342921.0,
        "delta": -22172851.0
      },
      {
        "periodo": 202601,
        "valor": 67537113.0,
        "delta": 3194192.0
      },
      {
        "periodo": 202602,
        "valor": 61785113.0,
        "delta": -5752000.0
      },
      {
        "periodo": 202603,
        "valor": 116845476.0,
        "delta": 55060363.0
      },
      {
        "periodo": 202604,
        "valor": 20492003.0,
        "delta": -96353473.0
      },
      {
        "periodo": 202605,
        "valor": 40492003.0,
        "delta": 20000000.0
      },
      {
        "periodo": 202606,
        "valor": 57692003.0,
        "delta": 17200000.0
      },
      {
        "periodo": 202607,
        "valor": 67492003.0,
        "delta": 9800000.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 54807125.0,
    "valor_anterior": 125646112.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 136427903.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 146242251.0,
        "delta": 9814348.0
      },
      {
        "periodo": 202509,
        "valor": 131805709.0,
        "delta": -14436542.0
      },
      {
        "periodo": 202510,
        "valor": 242638658.0,
        "delta": 110832949.0
      },
      {
        "periodo": 202511,
        "valor": 335081962.0,
        "delta": 92443304.0
      },
      {
        "periodo": 202512,
        "valor": 200452132.0,
        "delta": -134629830.0
      },
      {
        "periodo": 202601,
        "valor": 121250202.0,
        "delta": -79201930.0
      },
      {
        "periodo": 202602,
        "valor": 137566336.0,
        "delta": 16316134.0
      },
      {
        "periodo": 202603,
        "valor": 153090684.0,
        "delta": 15524348.0
      },
      {
        "periodo": 202604,
        "valor": 134864388.0,
        "delta": -18226296.0
      },
      {
        "periodo": 202605,
        "valor": 143733142.0,
        "delta": 8868754.0
      },
      {
        "periodo": 202606,
        "valor": 125646112.0,
        "delta": -18087030.0
      },
      {
        "periodo": 202607,
        "valor": 54807125.0,
        "delta": -70838987.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 2696702.41,
    "valor_anterior": 2773922.5700000003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4980438.58,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4890371.34,
        "delta": -90067.24
      },
      {
        "periodo": 202509,
        "valor": 4993217.94,
        "delta": 102846.6
      },
      {
        "periodo": 202510,
        "valor": 5175176.61,
        "delta": 181958.67
      },
      {
        "periodo": 202511,
        "valor": 2575739.63,
        "delta": -2599436.98
      },
      {
        "periodo": 202512,
        "valor": 2676887.51,
        "delta": 101147.88
      },
      {
        "periodo": 202601,
        "valor": 2851041.71,
        "delta": 174154.2
      },
      {
        "periodo": 202602,
        "valor": 2463359.87,
        "delta": -387681.84
      },
      {
        "periodo": 202603,
        "valor": 1659193.49,
        "delta": -804166.38
      },
      {
        "periodo": 202604,
        "valor": 2609910.55,
        "delta": 950717.06
      },
      {
        "periodo": 202605,
        "valor": 2792106.39,
        "delta": 182195.84
      },
      {
        "periodo": 202606,
        "valor": 2773922.57,
        "delta": -18183.82
      },
      {
        "periodo": 202607,
        "valor": 2696702.41,
        "delta": -77220.16
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 929019.0,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24025801.0,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": 124596749.0,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 115806253.0,
        "delta": -8790496.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 8279367.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 23016021.0,
        "delta": 14736654.0
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 697040.0,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": 723123.0,
        "delta": 26083.0
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": 929019.0,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 165582363.0,
    "valor_anterior": 63019509.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 60006222.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 61301376.0,
        "delta": 1295154.0
      },
      {
        "periodo": 202509,
        "valor": 61708019.0,
        "delta": 406643.0
      },
      {
        "periodo": 202510,
        "valor": 61437909.0,
        "delta": -270110.0
      },
      {
        "periodo": 202511,
        "valor": 61884276.0,
        "delta": 446367.0
      },
      {
        "periodo": 202512,
        "valor": 58391262.0,
        "delta": -3493014.0
      },
      {
        "periodo": 202601,
        "valor": 59991670.0,
        "delta": 1600408.0
      },
      {
        "periodo": 202602,
        "valor": 59981022.0,
        "delta": -10648.0
      },
      {
        "periodo": 202603,
        "valor": 60934413.0,
        "delta": 953391.0
      },
      {
        "periodo": 202604,
        "valor": 60658238.0,
        "delta": -276175.0
      },
      {
        "periodo": 202605,
        "valor": 62692183.0,
        "delta": 2033945.0
      },
      {
        "periodo": 202606,
        "valor": 63019509.0,
        "delta": 327326.0
      },
      {
        "periodo": 202607,
        "valor": 165582363.0,
        "delta": 102562854.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 540784.05,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 451613.4,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 451033.16,
        "delta": -580.24
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": 16572.84,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 12542291.4,
        "delta": 12525718.56
      },
      {
        "periodo": 202512,
        "valor": 16047199.13,
        "delta": 3504907.73
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": 540784.05,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 100000000.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 80400000.0,
        "delta": -19600000.0
      },
      {
        "periodo": 202509,
        "valor": 58800000.0,
        "delta": -21600000.0
      },
      {
        "periodo": 202510,
        "valor": 16300000.0,
        "delta": -42500000.0
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 104136812.0,
    "valor_anterior": 147269504.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 66918739.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 75463534.0,
        "delta": 8544795.0
      },
      {
        "periodo": 202509,
        "valor": 75047814.0,
        "delta": -415720.0
      },
      {
        "periodo": 202510,
        "valor": 83837217.0,
        "delta": 8789403.0
      },
      {
        "periodo": 202511,
        "valor": 87142176.0,
        "delta": 3304959.0
      },
      {
        "periodo": 202512,
        "valor": 87133846.0,
        "delta": -8330.0
      },
      {
        "periodo": 202601,
        "valor": 87965635.0,
        "delta": 831789.0
      },
      {
        "periodo": 202602,
        "valor": 84128082.0,
        "delta": -3837553.0
      },
      {
        "periodo": 202603,
        "valor": 83049182.0,
        "delta": -1078900.0
      },
      {
        "periodo": 202604,
        "valor": 82999256.0,
        "delta": -49926.0
      },
      {
        "periodo": 202605,
        "valor": 82047826.0,
        "delta": -951430.0
      },
      {
        "periodo": 202606,
        "valor": 147269504.0,
        "delta": 65221678.0
      },
      {
        "periodo": 202607,
        "valor": 104136812.0,
        "delta": -43132692.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 57364778.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 83290928.02,
        "delta": 25926149.2
      },
      {
        "periodo": 202509,
        "valor": 97925022.01,
        "delta": 14634093.99
      },
      {
        "periodo": 202510,
        "valor": 120285039.12,
        "delta": 22360017.11
      },
      {
        "periodo": 202511,
        "valor": 139595527.88,
        "delta": 19310488.76
      },
      {
        "periodo": 202512,
        "valor": 146900496.76,
        "delta": 7304968.88
      },
      {
        "periodo": 202601,
        "valor": 6694348.82,
        "delta": -140206147.94
      },
      {
        "periodo": 202602,
        "valor": 22559978.94,
        "delta": 15865630.12
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 7542876736.08,
    "valor_anterior": 7645586738.75,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7621428523.23,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7309273470.68,
        "delta": -312155052.55
      },
      {
        "periodo": 202509,
        "valor": 7968683303.56,
        "delta": 659409832.88
      },
      {
        "periodo": 202510,
        "valor": 7990537304.27,
        "delta": 21854000.71
      },
      {
        "periodo": 202511,
        "valor": 7802438250.11,
        "delta": -188099054.16
      },
      {
        "periodo": 202512,
        "valor": 7878698877.4,
        "delta": 76260627.29
      },
      {
        "periodo": 202601,
        "valor": 8868301715.81,
        "delta": 989602838.41
      },
      {
        "periodo": 202602,
        "valor": 8746219566.23,
        "delta": -122082149.58
      },
      {
        "periodo": 202603,
        "valor": 7789917886.38,
        "delta": -956301679.85
      },
      {
        "periodo": 202604,
        "valor": 7719721519.87,
        "delta": -70196366.51
      },
      {
        "periodo": 202605,
        "valor": 7670346198.3,
        "delta": -49375321.57
      },
      {
        "periodo": 202606,
        "valor": 7645586738.75,
        "delta": -24759459.55
      },
      {
        "periodo": 202607,
        "valor": 7542876736.08,
        "delta": -102710002.67
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 13840624.74,
    "valor_anterior": 11909298.52,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 7799130.61,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": 10834821.06,
        "delta": 3035690.45
      },
      {
        "periodo": 202606,
        "valor": 11909298.52,
        "delta": 1074477.46
      },
      {
        "periodo": 202607,
        "valor": 13840624.74,
        "delta": 1931326.22
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 1512307.0,
    "valor_anterior": 1512307.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1512307.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1512307.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1512307.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1512307.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1512307.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 1512307.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 1512307.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 1512307.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1512307.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1512307.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1512307.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1512307.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 1512307.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 22765836.0,
    "valor_anterior": 22788045.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7850746.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9398939.0,
        "delta": 1548193.0
      },
      {
        "periodo": 202509,
        "valor": 10683762.0,
        "delta": 1284823.0
      },
      {
        "periodo": 202510,
        "valor": 16736069.0,
        "delta": 6052307.0
      },
      {
        "periodo": 202511,
        "valor": 16619913.0,
        "delta": -116156.0
      },
      {
        "periodo": 202512,
        "valor": 15913665.0,
        "delta": -706248.0
      },
      {
        "periodo": 202601,
        "valor": 16810472.0,
        "delta": 896807.0
      },
      {
        "periodo": 202602,
        "valor": 10733054.0,
        "delta": -6077418.0
      },
      {
        "periodo": 202603,
        "valor": 7814387.0,
        "delta": -2918667.0
      },
      {
        "periodo": 202604,
        "valor": 11499042.0,
        "delta": 3684655.0
      },
      {
        "periodo": 202605,
        "valor": 22426352.0,
        "delta": 10927310.0
      },
      {
        "periodo": 202606,
        "valor": 22788045.0,
        "delta": 361693.0
      },
      {
        "periodo": 202607,
        "valor": 22765836.0,
        "delta": -22209.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 245198.0,
    "valor_anterior": 264660.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9211149.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9166582.0,
        "delta": -44567.0
      },
      {
        "periodo": 202509,
        "valor": 8567040.0,
        "delta": -599542.0
      },
      {
        "periodo": 202510,
        "valor": 8559918.0,
        "delta": -7122.0
      },
      {
        "periodo": 202511,
        "valor": 8487971.0,
        "delta": -71947.0
      },
      {
        "periodo": 202512,
        "valor": 5888477.0,
        "delta": -2599494.0
      },
      {
        "periodo": 202601,
        "valor": 4871194.0,
        "delta": -1017283.0
      },
      {
        "periodo": 202602,
        "valor": 4851466.0,
        "delta": -19728.0
      },
      {
        "periodo": 202603,
        "valor": 3958365.0,
        "delta": -893101.0
      },
      {
        "periodo": 202604,
        "valor": 3928840.0,
        "delta": -29525.0
      },
      {
        "periodo": 202605,
        "valor": 3402652.0,
        "delta": -526188.0
      },
      {
        "periodo": 202606,
        "valor": 264660.0,
        "delta": -3137992.0
      },
      {
        "periodo": 202607,
        "valor": 245198.0,
        "delta": -19462.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 66725854.0,
    "valor_anterior": 74414244.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 485771045.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 516274826.0,
        "delta": 30503781.0
      },
      {
        "periodo": 202509,
        "valor": 516274826.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 519497259.0,
        "delta": 3222433.0
      },
      {
        "periodo": 202511,
        "valor": 513798369.0,
        "delta": -5698890.0
      },
      {
        "periodo": 202512,
        "valor": 359308373.0,
        "delta": -154489996.0
      },
      {
        "periodo": 202601,
        "valor": 331488926.0,
        "delta": -27819447.0
      },
      {
        "periodo": 202602,
        "valor": 339296769.0,
        "delta": 7807843.0
      },
      {
        "periodo": 202603,
        "valor": 164845820.0,
        "delta": -174450949.0
      },
      {
        "periodo": 202604,
        "valor": 162403272.0,
        "delta": -2442548.0
      },
      {
        "periodo": 202605,
        "valor": 159831131.0,
        "delta": -2572141.0
      },
      {
        "periodo": 202606,
        "valor": 74414244.0,
        "delta": -85416887.0
      },
      {
        "periodo": 202607,
        "valor": 66725854.0,
        "delta": -7688390.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 53577907.86,
    "valor_anterior": 53196414.09,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 67934141.89,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 66009549.57,
        "delta": -1924592.32
      },
      {
        "periodo": 202509,
        "valor": 64548136.47,
        "delta": -1461413.1
      },
      {
        "periodo": 202510,
        "valor": 36258838.81,
        "delta": -28289297.66
      },
      {
        "periodo": 202511,
        "valor": 37696063.89,
        "delta": 1437225.08
      },
      {
        "periodo": 202512,
        "valor": 36080857.26,
        "delta": -1615206.63
      },
      {
        "periodo": 202601,
        "valor": 39380063.75,
        "delta": 3299206.49
      },
      {
        "periodo": 202602,
        "valor": 49080673.37,
        "delta": 9700609.62
      },
      {
        "periodo": 202603,
        "valor": 50772524.74,
        "delta": 1691851.37
      },
      {
        "periodo": 202604,
        "valor": 52221121.32,
        "delta": 1448596.58
      },
      {
        "periodo": 202605,
        "valor": 53859561.98,
        "delta": 1638440.66
      },
      {
        "periodo": 202606,
        "valor": 53196414.09,
        "delta": -663147.89
      },
      {
        "periodo": 202607,
        "valor": 53577907.86,
        "delta": 381493.77
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1481873.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1490289.0,
        "delta": 8416.0
      },
      {
        "periodo": 202509,
        "valor": 1511267.0,
        "delta": 20978.0
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 471625.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 453550.23,
        "delta": -18075.16
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 33040948.0,
    "valor_anterior": 35601580.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 59639355.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 64642460.0,
        "delta": 5003105.0
      },
      {
        "periodo": 202509,
        "valor": 54764099.0,
        "delta": -9878361.0
      },
      {
        "periodo": 202510,
        "valor": 53792146.0,
        "delta": -971953.0
      },
      {
        "periodo": 202511,
        "valor": 57542038.0,
        "delta": 3749892.0
      },
      {
        "periodo": 202512,
        "valor": 48741443.0,
        "delta": -8800595.0
      },
      {
        "periodo": 202601,
        "valor": 50777949.0,
        "delta": 2036506.0
      },
      {
        "periodo": 202602,
        "valor": 48090788.0,
        "delta": -2687161.0
      },
      {
        "periodo": 202603,
        "valor": 40434303.0,
        "delta": -7656485.0
      },
      {
        "periodo": 202604,
        "valor": 39878809.0,
        "delta": -555494.0
      },
      {
        "periodo": 202605,
        "valor": 39864635.0,
        "delta": -14174.0
      },
      {
        "periodo": 202606,
        "valor": 35601580.0,
        "delta": -4263055.0
      },
      {
        "periodo": 202607,
        "valor": 33040948.0,
        "delta": -2560632.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 6644924.53,
    "valor_anterior": 6645804.46,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4007641.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4009313.97,
        "delta": 1672.23
      },
      {
        "periodo": 202509,
        "valor": 3905670.45,
        "delta": -103643.52
      },
      {
        "periodo": 202510,
        "valor": 5516458.55,
        "delta": 1610788.1
      },
      {
        "periodo": 202511,
        "valor": 5515033.32,
        "delta": -1425.23
      },
      {
        "periodo": 202512,
        "valor": 5512616.01,
        "delta": -2417.31
      },
      {
        "periodo": 202601,
        "valor": 5547517.09,
        "delta": 34901.08
      },
      {
        "periodo": 202602,
        "valor": 5522423.07,
        "delta": -25094.02
      },
      {
        "periodo": 202603,
        "valor": 5520837.41,
        "delta": -1585.66
      },
      {
        "periodo": 202604,
        "valor": 5643056.29,
        "delta": 122218.88
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": 6645804.46,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": 6644924.53,
        "delta": -879.93
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 13511743.0,
    "valor_anterior": 12277540.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3151674.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3045124.0,
        "delta": -106550.0
      },
      {
        "periodo": 202509,
        "valor": 2835400.0,
        "delta": -209724.0
      },
      {
        "periodo": 202510,
        "valor": 3092377.0,
        "delta": 256977.0
      },
      {
        "periodo": 202511,
        "valor": 3836757.0,
        "delta": 744380.0
      },
      {
        "periodo": 202512,
        "valor": 5435943.0,
        "delta": 1599186.0
      },
      {
        "periodo": 202601,
        "valor": 6401006.0,
        "delta": 965063.0
      },
      {
        "periodo": 202602,
        "valor": 7118675.0,
        "delta": 717669.0
      },
      {
        "periodo": 202603,
        "valor": 8030936.0,
        "delta": 912261.0
      },
      {
        "periodo": 202604,
        "valor": 9020605.0,
        "delta": 989669.0
      },
      {
        "periodo": 202605,
        "valor": 10988179.0,
        "delta": 1967574.0
      },
      {
        "periodo": 202606,
        "valor": 12277540.0,
        "delta": 1289361.0
      },
      {
        "periodo": 202607,
        "valor": 13511743.0,
        "delta": 1234203.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 10931.0,
    "valor_anterior": 16396.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40079.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 40079.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 40079.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 34613.0,
        "delta": -5466.0
      },
      {
        "periodo": 202511,
        "valor": 34613.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 34613.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 21861.0,
        "delta": -12752.0
      },
      {
        "periodo": 202602,
        "valor": 21861.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 21861.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 16396.0,
        "delta": -5465.0
      },
      {
        "periodo": 202605,
        "valor": 16396.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 16396.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 10931.0,
        "delta": -5465.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24081791.84,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27743709.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 27743709.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 27743709.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 27743709.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 36869147.0,
        "delta": 9125438.0
      },
      {
        "periodo": 202512,
        "valor": 36587208.0,
        "delta": -281939.0
      },
      {
        "periodo": 202601,
        "valor": 35712497.0,
        "delta": -874711.0
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 133932576.0,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2149414.4,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 105194.37,
    "valor_anterior": 107932.02,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 84329.25,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 100359.99,
        "delta": 16030.74
      },
      {
        "periodo": 202604,
        "valor": 94336.55,
        "delta": -6023.44
      },
      {
        "periodo": 202605,
        "valor": 106451.83,
        "delta": 12115.28
      },
      {
        "periodo": 202606,
        "valor": 107932.02,
        "delta": 1480.19
      },
      {
        "periodo": 202607,
        "valor": 105194.37,
        "delta": -2737.65
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 15844786.0,
    "valor_anterior": 14379068.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 13855830.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 13471547.0,
        "delta": -384283.0
      },
      {
        "periodo": 202605,
        "valor": 14367461.0,
        "delta": 895914.0
      },
      {
        "periodo": 202606,
        "valor": 14379068.0,
        "delta": 11607.0
      },
      {
        "periodo": 202607,
        "valor": 15844786.0,
        "delta": 1465718.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 101800304006,
    "label": "EPRC Adicional",
    "valor_actual": 9838262496.43,
    "valor_anterior": 9959811581.67,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11807340114.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11162450664.72,
        "delta": -644889449.97
      },
      {
        "periodo": 202509,
        "valor": 11421715040.1,
        "delta": 259264375.38
      },
      {
        "periodo": 202510,
        "valor": 11275496204.85,
        "delta": -146218835.25
      },
      {
        "periodo": 202511,
        "valor": 10745228688.33,
        "delta": -530267516.52
      },
      {
        "periodo": 202512,
        "valor": 10380507963.25,
        "delta": -364720725.08
      },
      {
        "periodo": 202601,
        "valor": 10940978282.44,
        "delta": 560470319.19
      },
      {
        "periodo": 202602,
        "valor": 11610743424.03,
        "delta": 669765141.59
      },
      {
        "periodo": 202603,
        "valor": 10463414475.26,
        "delta": -1147328948.77
      },
      {
        "periodo": 202604,
        "valor": 10058517639.86,
        "delta": -404896835.4
      },
      {
        "periodo": 202605,
        "valor": 10076483499.75,
        "delta": 17965859.89
      },
      {
        "periodo": 202606,
        "valor": 9959811581.67,
        "delta": -116671918.08
      },
      {
        "periodo": 202607,
        "valor": 9838262496.43,
        "delta": -121549085.24
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 2971991989.73,
    "valor_anterior": 2926429152.2599998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2716456395.67,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2564196421.97,
        "delta": -152259973.7
      },
      {
        "periodo": 202509,
        "valor": 2623216837.86,
        "delta": 59020415.89
      },
      {
        "periodo": 202510,
        "valor": 2718411671.28,
        "delta": 95194833.42
      },
      {
        "periodo": 202511,
        "valor": 2816904305.18,
        "delta": 98492633.9
      },
      {
        "periodo": 202512,
        "valor": 2879347077.0,
        "delta": 62442771.82
      },
      {
        "periodo": 202601,
        "valor": 3010859480.63,
        "delta": 131512403.63
      },
      {
        "periodo": 202602,
        "valor": 2658704618.83,
        "delta": -352154861.8
      },
      {
        "periodo": 202603,
        "valor": 2760245827.16,
        "delta": 101541208.33
      },
      {
        "periodo": 202604,
        "valor": 2837448400.18,
        "delta": 77202573.02
      },
      {
        "periodo": 202605,
        "valor": 2866075885.62,
        "delta": 28627485.44
      },
      {
        "periodo": 202606,
        "valor": 2926429152.26,
        "delta": 60353266.64
      },
      {
        "periodo": 202607,
        "valor": 2971991989.73,
        "delta": 45562837.47
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 5365956168.870001,
    "valor_anterior": 5145729708.490001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5313551327.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5204001995.17,
        "delta": -109549332.22
      },
      {
        "periodo": 202509,
        "valor": 5397459244.92,
        "delta": 193457249.75
      },
      {
        "periodo": 202510,
        "valor": 5714827495.95,
        "delta": 317368251.03
      },
      {
        "periodo": 202511,
        "valor": 5833774219.78,
        "delta": 118946723.83
      },
      {
        "periodo": 202512,
        "valor": 4798707080.05,
        "delta": -1035067139.73
      },
      {
        "periodo": 202601,
        "valor": 4924377089.02,
        "delta": 125670008.97
      },
      {
        "periodo": 202602,
        "valor": 4516168537.03,
        "delta": -408208551.99
      },
      {
        "periodo": 202603,
        "valor": 4376022255.83,
        "delta": -140146281.2
      },
      {
        "periodo": 202604,
        "valor": 4851045724.95,
        "delta": 475023469.12
      },
      {
        "periodo": 202605,
        "valor": 5042876348.75,
        "delta": 191830623.8
      },
      {
        "periodo": 202606,
        "valor": 5145729708.49,
        "delta": 102853359.74
      },
      {
        "periodo": 202607,
        "valor": 5365956168.87,
        "delta": 220226460.38
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 3460091673.0,
    "valor_anterior": 3434814652.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3094233160.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3214952639.0,
        "delta": 120719479.0
      },
      {
        "periodo": 202509,
        "valor": 3456987381.0,
        "delta": 242034742.0
      },
      {
        "periodo": 202510,
        "valor": 3484102740.0,
        "delta": 27115359.0
      },
      {
        "periodo": 202511,
        "valor": 3479806624.0,
        "delta": -4296116.0
      },
      {
        "periodo": 202512,
        "valor": 2907084343.0,
        "delta": -572722281.0
      },
      {
        "periodo": 202601,
        "valor": 2876674359.0,
        "delta": -30409984.0
      },
      {
        "periodo": 202602,
        "valor": 3498881011.0,
        "delta": 622206652.0
      },
      {
        "periodo": 202603,
        "valor": 3674652279.0,
        "delta": 175771268.0
      },
      {
        "periodo": 202604,
        "valor": 3495969204.0,
        "delta": -178683075.0
      },
      {
        "periodo": 202605,
        "valor": 3648890453.0,
        "delta": 152921249.0
      },
      {
        "periodo": 202606,
        "valor": 3434814652.0,
        "delta": -214075801.0
      },
      {
        "periodo": 202607,
        "valor": 3460091673.0,
        "delta": 25277021.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 3895175932.0,
    "valor_anterior": 3667578048.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3676454415.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4085289322.0,
        "delta": 408834907.0
      },
      {
        "periodo": 202509,
        "valor": 4026600734.0,
        "delta": -58688588.0
      },
      {
        "periodo": 202510,
        "valor": 4037025690.0,
        "delta": 10424956.0
      },
      {
        "periodo": 202511,
        "valor": 3612248132.0,
        "delta": -424777558.0
      },
      {
        "periodo": 202512,
        "valor": 3984741136.0,
        "delta": 372493004.0
      },
      {
        "periodo": 202601,
        "valor": 3758141890.0,
        "delta": -226599246.0
      },
      {
        "periodo": 202602,
        "valor": 3734211346.0,
        "delta": -23930544.0
      },
      {
        "periodo": 202603,
        "valor": 3731433915.0,
        "delta": -2777431.0
      },
      {
        "periodo": 202604,
        "valor": 3556448000.0,
        "delta": -174985915.0
      },
      {
        "periodo": 202605,
        "valor": 3597911119.0,
        "delta": 41463119.0
      },
      {
        "periodo": 202606,
        "valor": 3667578048.0,
        "delta": 69666929.0
      },
      {
        "periodo": 202607,
        "valor": 3895175932.0,
        "delta": 227597884.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 2322960435.69,
    "valor_anterior": 2150954391.33,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1924341842.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2025397904.75,
        "delta": 101056062.5
      },
      {
        "periodo": 202509,
        "valor": 2141471459.93,
        "delta": 116073555.18
      },
      {
        "periodo": 202510,
        "valor": 2005542064.98,
        "delta": -135929394.95
      },
      {
        "periodo": 202511,
        "valor": 2067525711.05,
        "delta": 61983646.07
      },
      {
        "periodo": 202512,
        "valor": 1651140185.88,
        "delta": -416385525.17
      },
      {
        "periodo": 202601,
        "valor": 1699158805.19,
        "delta": 48018619.31
      },
      {
        "periodo": 202602,
        "valor": 1750134943.56,
        "delta": 50976138.37
      },
      {
        "periodo": 202603,
        "valor": 1763737815.51,
        "delta": 13602871.95
      },
      {
        "periodo": 202604,
        "valor": 1998707592.49,
        "delta": 234969776.98
      },
      {
        "periodo": 202605,
        "valor": 2090156684.63,
        "delta": 91449092.14
      },
      {
        "periodo": 202606,
        "valor": 2150954391.33,
        "delta": 60797706.7
      },
      {
        "periodo": 202607,
        "valor": 2322960435.69,
        "delta": 172006044.36
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 4118912389.0,
    "valor_anterior": 3798852823.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2455955534.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2563590598.0,
        "delta": 107635064.0
      },
      {
        "periodo": 202509,
        "valor": 2395221173.0,
        "delta": -168369425.0
      },
      {
        "periodo": 202510,
        "valor": 2468131753.0,
        "delta": 72910580.0
      },
      {
        "periodo": 202511,
        "valor": 2452853679.0,
        "delta": -15278074.0
      },
      {
        "periodo": 202512,
        "valor": 2387747558.0,
        "delta": -65106121.0
      },
      {
        "periodo": 202601,
        "valor": 2384217830.0,
        "delta": -3529728.0
      },
      {
        "periodo": 202602,
        "valor": 2407686247.0,
        "delta": 23468417.0
      },
      {
        "periodo": 202603,
        "valor": 2515124106.0,
        "delta": 107437859.0
      },
      {
        "periodo": 202604,
        "valor": 3521501091.0,
        "delta": 1006376985.0
      },
      {
        "periodo": 202605,
        "valor": 3610531836.0,
        "delta": 89030745.0
      },
      {
        "periodo": 202606,
        "valor": 3798852823.0,
        "delta": 188320987.0
      },
      {
        "periodo": 202607,
        "valor": 4118912389.0,
        "delta": 320059566.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 382911741.0,
    "valor_anterior": 370815639.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 336581601.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 389981821.0,
        "delta": 53400220.0
      },
      {
        "periodo": 202509,
        "valor": 472755748.0,
        "delta": 82773927.0
      },
      {
        "periodo": 202510,
        "valor": 436772936.0,
        "delta": -35982812.0
      },
      {
        "periodo": 202511,
        "valor": 418648200.0,
        "delta": -18124736.0
      },
      {
        "periodo": 202512,
        "valor": 189227071.0,
        "delta": -229421129.0
      },
      {
        "periodo": 202601,
        "valor": 222547029.0,
        "delta": 33319958.0
      },
      {
        "periodo": 202602,
        "valor": 259407120.0,
        "delta": 36860091.0
      },
      {
        "periodo": 202603,
        "valor": 213387104.0,
        "delta": -46020016.0
      },
      {
        "periodo": 202604,
        "valor": 268570831.0,
        "delta": 55183727.0
      },
      {
        "periodo": 202605,
        "valor": 390996603.0,
        "delta": 122425772.0
      },
      {
        "periodo": 202606,
        "valor": 370815639.0,
        "delta": -20180964.0
      },
      {
        "periodo": 202607,
        "valor": 382911741.0,
        "delta": 12096102.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 3213937459.0,
    "valor_anterior": 3228799580.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3207723996.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3164196243.0,
        "delta": -43527753.0
      },
      {
        "periodo": 202509,
        "valor": 3306917273.0,
        "delta": 142721030.0
      },
      {
        "periodo": 202510,
        "valor": 3286725263.0,
        "delta": -20192010.0
      },
      {
        "periodo": 202511,
        "valor": 3166283741.0,
        "delta": -120441522.0
      },
      {
        "periodo": 202512,
        "valor": 3171639656.0,
        "delta": 5355915.0
      },
      {
        "periodo": 202601,
        "valor": 3160873427.0,
        "delta": -10766229.0
      },
      {
        "periodo": 202602,
        "valor": 3202665186.0,
        "delta": 41791759.0
      },
      {
        "periodo": 202603,
        "valor": 3246848801.0,
        "delta": 44183615.0
      },
      {
        "periodo": 202604,
        "valor": 3250103330.0,
        "delta": 3254529.0
      },
      {
        "periodo": 202605,
        "valor": 3371501144.0,
        "delta": 121397814.0
      },
      {
        "periodo": 202606,
        "valor": 3228799580.0,
        "delta": -142701564.0
      },
      {
        "periodo": 202607,
        "valor": 3213937459.0,
        "delta": -14862121.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 714393836.8100001,
    "valor_anterior": 703125998.5200001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 868279306.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 905052924.71,
        "delta": 36773618.29
      },
      {
        "periodo": 202509,
        "valor": 923007183.13,
        "delta": 17954258.42
      },
      {
        "periodo": 202510,
        "valor": 1018532269.68,
        "delta": 95525086.55
      },
      {
        "periodo": 202511,
        "valor": 1009473050.75,
        "delta": -9059218.93
      },
      {
        "periodo": 202512,
        "valor": 617444487.51,
        "delta": -392028563.24
      },
      {
        "periodo": 202601,
        "valor": 583591419.2,
        "delta": -33853068.31
      },
      {
        "periodo": 202602,
        "valor": 604190272.02,
        "delta": 20598852.82
      },
      {
        "periodo": 202603,
        "valor": 632981847.66,
        "delta": 28791575.64
      },
      {
        "periodo": 202604,
        "valor": 660783288.38,
        "delta": 27801440.72
      },
      {
        "periodo": 202605,
        "valor": 663517634.16,
        "delta": 2734345.78
      },
      {
        "periodo": 202606,
        "valor": 703125998.52,
        "delta": 39608364.36
      },
      {
        "periodo": 202607,
        "valor": 714393836.81,
        "delta": 11267838.29
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 508167108.0,
    "valor_anterior": 493869597.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 258604924.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 259025739.0,
        "delta": 420815.0
      },
      {
        "periodo": 202509,
        "valor": 255210694.0,
        "delta": -3815045.0
      },
      {
        "periodo": 202510,
        "valor": 304165683.0,
        "delta": 48954989.0
      },
      {
        "periodo": 202511,
        "valor": 304597354.0,
        "delta": 431671.0
      },
      {
        "periodo": 202512,
        "valor": 300599333.0,
        "delta": -3998021.0
      },
      {
        "periodo": 202601,
        "valor": 540296021.0,
        "delta": 239696688.0
      },
      {
        "periodo": 202602,
        "valor": 603360333.0,
        "delta": 63064312.0
      },
      {
        "periodo": 202603,
        "valor": 503192415.0,
        "delta": -100167918.0
      },
      {
        "periodo": 202604,
        "valor": 508240480.0,
        "delta": 5048065.0
      },
      {
        "periodo": 202605,
        "valor": 499645219.0,
        "delta": -8595261.0
      },
      {
        "periodo": 202606,
        "valor": 493869597.0,
        "delta": -5775622.0
      },
      {
        "periodo": 202607,
        "valor": 508167108.0,
        "delta": 14297511.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 1196747989.0,
    "valor_anterior": 1176280975.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 844504811.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 833756609.0,
        "delta": -10748202.0
      },
      {
        "periodo": 202509,
        "valor": 865668080.0,
        "delta": 31911471.0
      },
      {
        "periodo": 202510,
        "valor": 845173592.0,
        "delta": -20494488.0
      },
      {
        "periodo": 202511,
        "valor": 856252472.0,
        "delta": 11078880.0
      },
      {
        "periodo": 202512,
        "valor": 921704570.0,
        "delta": 65452098.0
      },
      {
        "periodo": 202601,
        "valor": 955319494.0,
        "delta": 33614924.0
      },
      {
        "periodo": 202602,
        "valor": 924977802.0,
        "delta": -30341692.0
      },
      {
        "periodo": 202603,
        "valor": 1060898334.0,
        "delta": 135920532.0
      },
      {
        "periodo": 202604,
        "valor": 1066269191.0,
        "delta": 5370857.0
      },
      {
        "periodo": 202605,
        "valor": 1095362115.0,
        "delta": 29092924.0
      },
      {
        "periodo": 202606,
        "valor": 1176280975.0,
        "delta": 80918860.0
      },
      {
        "periodo": 202607,
        "valor": 1196747989.0,
        "delta": 20467014.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 545843603.0,
    "valor_anterior": 527538939.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 601916206.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 571514359.0,
        "delta": -30401847.0
      },
      {
        "periodo": 202509,
        "valor": 577248406.0,
        "delta": 5734047.0
      },
      {
        "periodo": 202510,
        "valor": 576035978.0,
        "delta": -1212428.0
      },
      {
        "periodo": 202511,
        "valor": 550182376.0,
        "delta": -25853602.0
      },
      {
        "periodo": 202512,
        "valor": 481571851.0,
        "delta": -68610525.0
      },
      {
        "periodo": 202601,
        "valor": 463317320.0,
        "delta": -18254531.0
      },
      {
        "periodo": 202602,
        "valor": 457595180.0,
        "delta": -5722140.0
      },
      {
        "periodo": 202603,
        "valor": 496166053.0,
        "delta": 38570873.0
      },
      {
        "periodo": 202604,
        "valor": 474400226.0,
        "delta": -21765827.0
      },
      {
        "periodo": 202605,
        "valor": 520777252.0,
        "delta": 46377026.0
      },
      {
        "periodo": 202606,
        "valor": 527538939.0,
        "delta": 6761687.0
      },
      {
        "periodo": 202607,
        "valor": 545843603.0,
        "delta": 18304664.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 4720604649.09,
    "valor_anterior": 4648793337.3,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2013974580.28,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1910158131.05,
        "delta": -103816449.23
      },
      {
        "periodo": 202509,
        "valor": 3617070230.9,
        "delta": 1706912099.85
      },
      {
        "periodo": 202510,
        "valor": 3700382501.39,
        "delta": 83312270.49
      },
      {
        "periodo": 202511,
        "valor": 3630076557.35,
        "delta": -70305944.04
      },
      {
        "periodo": 202512,
        "valor": 3857071820.12,
        "delta": 226995262.77
      },
      {
        "periodo": 202601,
        "valor": 3907121285.32,
        "delta": 50049465.2
      },
      {
        "periodo": 202602,
        "valor": 3970484418.56,
        "delta": 63363133.24
      },
      {
        "periodo": 202603,
        "valor": 4350969141.01,
        "delta": 380484722.45
      },
      {
        "periodo": 202604,
        "valor": 4402484009.47,
        "delta": 51514868.46
      },
      {
        "periodo": 202605,
        "valor": 4526670598.77,
        "delta": 124186589.3
      },
      {
        "periodo": 202606,
        "valor": 4648793337.3,
        "delta": 122122738.53
      },
      {
        "periodo": 202607,
        "valor": 4720604649.09,
        "delta": 71811311.79
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 453333729.35,
    "valor_anterior": 436691010.02,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 586898049.18,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 603433407.96,
        "delta": 16535358.78
      },
      {
        "periodo": 202509,
        "valor": 607389039.98,
        "delta": 3955632.02
      },
      {
        "periodo": 202510,
        "valor": 617830760.75,
        "delta": 10441720.77
      },
      {
        "periodo": 202511,
        "valor": 590827009.53,
        "delta": -27003751.22
      },
      {
        "periodo": 202512,
        "valor": 352566643.18,
        "delta": -238260366.35
      },
      {
        "periodo": 202601,
        "valor": 338797870.71,
        "delta": -13768772.47
      },
      {
        "periodo": 202602,
        "valor": 356786058.95,
        "delta": 17988188.24
      },
      {
        "periodo": 202603,
        "valor": 369325397.53,
        "delta": 12539338.58
      },
      {
        "periodo": 202604,
        "valor": 399467163.43,
        "delta": 30141765.9
      },
      {
        "periodo": 202605,
        "valor": 437770928.18,
        "delta": 38303764.75
      },
      {
        "periodo": 202606,
        "valor": 436691010.02,
        "delta": -1079918.16
      },
      {
        "periodo": 202607,
        "valor": 453333729.35,
        "delta": 16642719.33
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 832813350.0,
    "valor_anterior": 840213002.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 895883524.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 907737518.0,
        "delta": 11853994.0
      },
      {
        "periodo": 202509,
        "valor": 896717522.0,
        "delta": -11019996.0
      },
      {
        "periodo": 202510,
        "valor": 867643894.0,
        "delta": -29073628.0
      },
      {
        "periodo": 202511,
        "valor": 938189848.0,
        "delta": 70545954.0
      },
      {
        "periodo": 202512,
        "valor": 948614078.0,
        "delta": 10424230.0
      },
      {
        "periodo": 202601,
        "valor": 968302274.0,
        "delta": 19688196.0
      },
      {
        "periodo": 202602,
        "valor": 960118524.0,
        "delta": -8183750.0
      },
      {
        "periodo": 202603,
        "valor": 1076226627.0,
        "delta": 116108103.0
      },
      {
        "periodo": 202604,
        "valor": 993682552.0,
        "delta": -82544075.0
      },
      {
        "periodo": 202605,
        "valor": 1005174982.0,
        "delta": 11492430.0
      },
      {
        "periodo": 202606,
        "valor": 840213002.0,
        "delta": -164961980.0
      },
      {
        "periodo": 202607,
        "valor": 832813350.0,
        "delta": -7399652.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 2257644030.15,
    "valor_anterior": 2257704228.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2260085029.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2260257740.19,
        "delta": 172711.04
      },
      {
        "periodo": 202509,
        "valor": 2260644580.12,
        "delta": 386839.93
      },
      {
        "periodo": 202510,
        "valor": 2259436169.47,
        "delta": -1208410.65
      },
      {
        "periodo": 202511,
        "valor": 2258974581.66,
        "delta": -461587.81
      },
      {
        "periodo": 202512,
        "valor": 2258152122.14,
        "delta": -822459.52
      },
      {
        "periodo": 202601,
        "valor": 2257572752.02,
        "delta": -579370.12
      },
      {
        "periodo": 202602,
        "valor": 2256838732.2,
        "delta": -734019.82
      },
      {
        "periodo": 202603,
        "valor": 2256655030.63,
        "delta": -183701.57
      },
      {
        "periodo": 202604,
        "valor": 2256884424.95,
        "delta": 229394.32
      },
      {
        "periodo": 202605,
        "valor": 2257157808.42,
        "delta": 273383.47
      },
      {
        "periodo": 202606,
        "valor": 2257704228.0,
        "delta": 546419.58
      },
      {
        "periodo": 202607,
        "valor": 2257644030.15,
        "delta": -60197.85
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 1259792349.46,
    "valor_anterior": 574770724.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 437667921.88,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 742770480.69,
        "delta": 305102558.81
      },
      {
        "periodo": 202509,
        "valor": 585176488.62,
        "delta": -157593992.07
      },
      {
        "periodo": 202510,
        "valor": 583729466.39,
        "delta": -1447022.23
      },
      {
        "periodo": 202511,
        "valor": 583568163.94,
        "delta": -161302.45
      },
      {
        "periodo": 202512,
        "valor": 583572620.82,
        "delta": 4456.88
      },
      {
        "periodo": 202601,
        "valor": 583471594.57,
        "delta": -101026.25
      },
      {
        "periodo": 202602,
        "valor": 583452493.87,
        "delta": -19100.7
      },
      {
        "periodo": 202603,
        "valor": 583421572.75,
        "delta": -30921.12
      },
      {
        "periodo": 202604,
        "valor": 574873523.99,
        "delta": -8548048.76
      },
      {
        "periodo": 202605,
        "valor": 574873523.99,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 574770724.0,
        "delta": -102799.99
      },
      {
        "periodo": 202607,
        "valor": 1259792349.46,
        "delta": 685021625.46
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 509713807.04,
    "valor_anterior": 477493869.57000005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 162820362.91,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 147823284.84,
        "delta": -14997078.07
      },
      {
        "periodo": 202509,
        "valor": 169567295.51,
        "delta": 21744010.67
      },
      {
        "periodo": 202510,
        "valor": 213849232.31,
        "delta": 44281936.8
      },
      {
        "periodo": 202511,
        "valor": 246250008.43,
        "delta": 32400776.12
      },
      {
        "periodo": 202512,
        "valor": 318645041.31,
        "delta": 72395032.88
      },
      {
        "periodo": 202601,
        "valor": 357127472.04,
        "delta": 38482430.73
      },
      {
        "periodo": 202602,
        "valor": 169423608.01,
        "delta": -187703864.03
      },
      {
        "periodo": 202603,
        "valor": 423770237.68,
        "delta": 254346629.67
      },
      {
        "periodo": 202604,
        "valor": 464903852.71,
        "delta": 41133615.03
      },
      {
        "periodo": 202605,
        "valor": 90206207.82,
        "delta": -374697644.89
      },
      {
        "periodo": 202606,
        "valor": 477493869.57,
        "delta": 387287661.75
      },
      {
        "periodo": 202607,
        "valor": 509713807.04,
        "delta": 32219937.47
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 1423396511.0,
    "valor_anterior": 1378068526.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1254966160.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1260638179.0,
        "delta": 5672019.0
      },
      {
        "periodo": 202509,
        "valor": 1303035633.0,
        "delta": 42397454.0
      },
      {
        "periodo": 202510,
        "valor": 1261979893.0,
        "delta": -41055740.0
      },
      {
        "periodo": 202511,
        "valor": 1242235161.0,
        "delta": -19744732.0
      },
      {
        "periodo": 202512,
        "valor": 1249583569.0,
        "delta": 7348408.0
      },
      {
        "periodo": 202601,
        "valor": 1268123224.0,
        "delta": 18539655.0
      },
      {
        "periodo": 202602,
        "valor": 1254167580.0,
        "delta": -13955644.0
      },
      {
        "periodo": 202603,
        "valor": 1225722807.0,
        "delta": -28444773.0
      },
      {
        "periodo": 202604,
        "valor": 1394874424.0,
        "delta": 169151617.0
      },
      {
        "periodo": 202605,
        "valor": 1399628973.0,
        "delta": 4754549.0
      },
      {
        "periodo": 202606,
        "valor": 1378068526.0,
        "delta": -21560447.0
      },
      {
        "periodo": 202607,
        "valor": 1423396511.0,
        "delta": 45327985.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 245286420.0,
    "valor_anterior": 244459411.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 459516710.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 458350117.0,
        "delta": -1166593.0
      },
      {
        "periodo": 202509,
        "valor": 453736846.0,
        "delta": -4613271.0
      },
      {
        "periodo": 202510,
        "valor": 456140213.0,
        "delta": 2403367.0
      },
      {
        "periodo": 202511,
        "valor": 380506484.0,
        "delta": -75633729.0
      },
      {
        "periodo": 202512,
        "valor": 371229788.0,
        "delta": -9276696.0
      },
      {
        "periodo": 202601,
        "valor": 373505765.0,
        "delta": 2275977.0
      },
      {
        "periodo": 202602,
        "valor": 373902582.0,
        "delta": 396817.0
      },
      {
        "periodo": 202603,
        "valor": 385124702.0,
        "delta": 11222120.0
      },
      {
        "periodo": 202604,
        "valor": 385975775.0,
        "delta": 851073.0
      },
      {
        "periodo": 202605,
        "valor": 213842730.0,
        "delta": -172133045.0
      },
      {
        "periodo": 202606,
        "valor": 244459411.0,
        "delta": 30616681.0
      },
      {
        "periodo": 202607,
        "valor": 245286420.0,
        "delta": 827009.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 634559192.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 671693418.0,
        "delta": 37134226.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 882548197.35,
    "valor_anterior": 843903131.76,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1111534966.7,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1150225406.91,
        "delta": 38690440.21
      },
      {
        "periodo": 202509,
        "valor": 1135148228.34,
        "delta": -15077178.57
      },
      {
        "periodo": 202510,
        "valor": 539215804.52,
        "delta": -595932423.82
      },
      {
        "periodo": 202511,
        "valor": 669289678.43,
        "delta": 130073873.91
      },
      {
        "periodo": 202512,
        "valor": 400147261.92,
        "delta": -269142416.51
      },
      {
        "periodo": 202601,
        "valor": 909717178.8,
        "delta": 509569916.88
      },
      {
        "periodo": 202602,
        "valor": 913812731.83,
        "delta": 4095553.03
      },
      {
        "periodo": 202603,
        "valor": 1049219754.41,
        "delta": 135407022.58
      },
      {
        "periodo": 202604,
        "valor": 1157695990.67,
        "delta": 108476236.26
      },
      {
        "periodo": 202605,
        "valor": 1246184858.44,
        "delta": 88488867.77
      },
      {
        "periodo": 202606,
        "valor": 843903131.76,
        "delta": -402281726.68
      },
      {
        "periodo": 202607,
        "valor": 882548197.35,
        "delta": 38645065.59
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 21206647.0,
    "valor_anterior": 21206836.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22260850.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23201097.0,
        "delta": 940247.0
      },
      {
        "periodo": 202509,
        "valor": 22933245.0,
        "delta": -267852.0
      },
      {
        "periodo": 202510,
        "valor": 22348995.0,
        "delta": -584250.0
      },
      {
        "periodo": 202511,
        "valor": 21644320.0,
        "delta": -704675.0
      },
      {
        "periodo": 202512,
        "valor": 20662941.0,
        "delta": -981379.0
      },
      {
        "periodo": 202601,
        "valor": 20384876.0,
        "delta": -278065.0
      },
      {
        "periodo": 202602,
        "valor": 21495546.0,
        "delta": 1110670.0
      },
      {
        "periodo": 202603,
        "valor": 21627615.0,
        "delta": 132069.0
      },
      {
        "periodo": 202604,
        "valor": 21627615.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 21627615.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 21206836.0,
        "delta": -420779.0
      },
      {
        "periodo": 202607,
        "valor": 21206647.0,
        "delta": -189.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 175201926.6,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 190841904.5,
        "delta": 15639977.9
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 243195846.0,
    "valor_anterior": 243592799.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 191211184.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 206264066.0,
        "delta": 15052882.0
      },
      {
        "periodo": 202509,
        "valor": 205726554.0,
        "delta": -537512.0
      },
      {
        "periodo": 202510,
        "valor": 210086015.0,
        "delta": 4359461.0
      },
      {
        "periodo": 202511,
        "valor": 214684605.0,
        "delta": 4598590.0
      },
      {
        "periodo": 202512,
        "valor": 221892459.0,
        "delta": 7207854.0
      },
      {
        "periodo": 202601,
        "valor": 224744300.0,
        "delta": 2851841.0
      },
      {
        "periodo": 202602,
        "valor": 231410740.0,
        "delta": 6666440.0
      },
      {
        "periodo": 202603,
        "valor": 247365284.0,
        "delta": 15954544.0
      },
      {
        "periodo": 202604,
        "valor": 200076518.0,
        "delta": -47288766.0
      },
      {
        "periodo": 202605,
        "valor": 236816033.0,
        "delta": 36739515.0
      },
      {
        "periodo": 202606,
        "valor": 243592799.0,
        "delta": 6776766.0
      },
      {
        "periodo": 202607,
        "valor": 243195846.0,
        "delta": -396953.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 48760014.15,
    "valor_anterior": 48647920.34,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40243324.07,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 39465651.91,
        "delta": -777672.16
      },
      {
        "periodo": 202509,
        "valor": 39109634.71,
        "delta": -356017.2
      },
      {
        "periodo": 202510,
        "valor": 44575698.25,
        "delta": 5466063.54
      },
      {
        "periodo": 202511,
        "valor": 44575698.25,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 44613008.24,
        "delta": 37309.99
      },
      {
        "periodo": 202601,
        "valor": 44910245.94,
        "delta": 297237.7
      },
      {
        "periodo": 202602,
        "valor": 44729628.98,
        "delta": -180616.96
      },
      {
        "periodo": 202603,
        "valor": 44694082.36,
        "delta": -35546.62
      },
      {
        "periodo": 202604,
        "valor": 45551115.54,
        "delta": 857033.18
      },
      {
        "periodo": 202605,
        "valor": 45071748.54,
        "delta": -479367.0
      },
      {
        "periodo": 202606,
        "valor": 48647920.34,
        "delta": 3576171.8
      },
      {
        "periodo": 202607,
        "valor": 48760014.15,
        "delta": 112093.81
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 128851266.15,
    "valor_anterior": 128074240.45,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 135893185.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 136794053.9,
        "delta": 900868.48
      },
      {
        "periodo": 202509,
        "valor": 134448670.92,
        "delta": -2345382.98
      },
      {
        "periodo": 202510,
        "valor": 134712214.37,
        "delta": 263543.45
      },
      {
        "periodo": 202511,
        "valor": 135110704.51,
        "delta": 398490.14
      },
      {
        "periodo": 202512,
        "valor": 118062450.93,
        "delta": -17048253.58
      },
      {
        "periodo": 202601,
        "valor": 116659692.51,
        "delta": -1402758.42
      },
      {
        "periodo": 202602,
        "valor": 116993688.31,
        "delta": 333995.8
      },
      {
        "periodo": 202603,
        "valor": 117179623.13,
        "delta": 185934.82
      },
      {
        "periodo": 202604,
        "valor": 124620654.38,
        "delta": 7441031.25
      },
      {
        "periodo": 202605,
        "valor": 124634757.5,
        "delta": 14103.12
      },
      {
        "periodo": 202606,
        "valor": 128074240.45,
        "delta": 3439482.95
      },
      {
        "periodo": 202607,
        "valor": 128851266.15,
        "delta": 777025.7
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 3049995.0,
    "valor_anterior": 2952654.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2530847.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2530847.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 2530847.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 2628187.0,
        "delta": 97340.0
      },
      {
        "periodo": 202511,
        "valor": 2628187.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 2628187.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 2855314.0,
        "delta": 227127.0
      },
      {
        "periodo": 202602,
        "valor": 2855314.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 2855314.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 2952654.0,
        "delta": 97340.0
      },
      {
        "periodo": 202605,
        "valor": 2952654.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 2952654.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 3049995.0,
        "delta": 97341.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 536171272.93,
    "valor_anterior": 526827218.15,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 153058772.8,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 178961623.49,
        "delta": 25902850.69
      },
      {
        "periodo": 202509,
        "valor": 349902172.86,
        "delta": 170940549.37
      },
      {
        "periodo": 202510,
        "valor": 345689711.53,
        "delta": -4212461.33
      },
      {
        "periodo": 202511,
        "valor": 342648012.67,
        "delta": -3041698.86
      },
      {
        "periodo": 202512,
        "valor": 328445165.92,
        "delta": -14202846.75
      },
      {
        "periodo": 202601,
        "valor": 344596389.96,
        "delta": 16151224.04
      },
      {
        "periodo": 202602,
        "valor": 343779314.61,
        "delta": -817075.35
      },
      {
        "periodo": 202603,
        "valor": 467660148.71,
        "delta": 123880834.1
      },
      {
        "periodo": 202604,
        "valor": 475814258.0,
        "delta": 8154109.29
      },
      {
        "periodo": 202605,
        "valor": 477326877.56,
        "delta": 1512619.56
      },
      {
        "periodo": 202606,
        "valor": 526827218.15,
        "delta": 49500340.59
      },
      {
        "periodo": 202607,
        "valor": 536171272.93,
        "delta": 9344054.78
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 223423904.13,
    "valor_anterior": 231481450.07,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 184848386.33,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 191637152.9,
        "delta": 6788766.57
      },
      {
        "periodo": 202509,
        "valor": 200236677.1,
        "delta": 8599524.2
      },
      {
        "periodo": 202510,
        "valor": 211358613.41,
        "delta": 11121936.31
      },
      {
        "periodo": 202511,
        "valor": 218011600.0,
        "delta": 6652986.59
      },
      {
        "periodo": 202512,
        "valor": 232301055.51,
        "delta": 14289455.51
      },
      {
        "periodo": 202601,
        "valor": 247197205.34,
        "delta": 14896149.83
      },
      {
        "periodo": 202602,
        "valor": 253629223.2,
        "delta": 6432017.86
      },
      {
        "periodo": 202603,
        "valor": 263261712.74,
        "delta": 9632489.54
      },
      {
        "periodo": 202604,
        "valor": 261038430.98,
        "delta": -2223281.76
      },
      {
        "periodo": 202605,
        "valor": 266568932.38,
        "delta": 5530501.4
      },
      {
        "periodo": 202606,
        "valor": 231481450.07,
        "delta": -35087482.31
      },
      {
        "periodo": 202607,
        "valor": 223423904.13,
        "delta": -8057545.94
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 162012567.0,
    "valor_anterior": 118797524.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 29219316.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 118595213.0,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": 117721472.0,
        "delta": -873741.0
      },
      {
        "periodo": 202606,
        "valor": 118797524.0,
        "delta": 1076052.0
      },
      {
        "periodo": 202607,
        "valor": 162012567.0,
        "delta": 43215043.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 978418583.0,
    "valor_anterior": 986930606.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 910768756.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 839994605.0,
        "delta": -70774151.0
      },
      {
        "periodo": 202509,
        "valor": 754280692.0,
        "delta": -85713913.0
      },
      {
        "periodo": 202510,
        "valor": 750088360.0,
        "delta": -4192332.0
      },
      {
        "periodo": 202511,
        "valor": 748815096.0,
        "delta": -1273264.0
      },
      {
        "periodo": 202512,
        "valor": 762190214.0,
        "delta": 13375118.0
      },
      {
        "periodo": 202601,
        "valor": 889459859.0,
        "delta": 127269645.0
      },
      {
        "periodo": 202602,
        "valor": 890022276.0,
        "delta": 562417.0
      },
      {
        "periodo": 202603,
        "valor": 943370661.0,
        "delta": 53348385.0
      },
      {
        "periodo": 202604,
        "valor": 957096342.0,
        "delta": 13725681.0
      },
      {
        "periodo": 202605,
        "valor": 958607301.0,
        "delta": 1510959.0
      },
      {
        "periodo": 202606,
        "valor": 986930606.0,
        "delta": 28323305.0
      },
      {
        "periodo": 202607,
        "valor": 978418583.0,
        "delta": -8512023.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 8035837.0,
    "valor_anterior": 17170428.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19820509.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19820509.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 19820509.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 19820509.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 19820509.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 19820509.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 19820509.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 19820509.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 19820509.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 17170428.0,
        "delta": -2650081.0
      },
      {
        "periodo": 202605,
        "valor": 17170428.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 17170428.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 8035837.0,
        "delta": -9134591.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 54325907.29,
    "valor_anterior": 54325907.29,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 113082702.37,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 110252850.46,
        "delta": -2829851.91
      },
      {
        "periodo": 202509,
        "valor": 105879273.8,
        "delta": -4373576.66
      },
      {
        "periodo": 202510,
        "valor": 57864060.63,
        "delta": -48015213.17
      },
      {
        "periodo": 202511,
        "valor": 60275063.16,
        "delta": 2411002.53
      },
      {
        "periodo": 202512,
        "valor": 60275063.16,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 60275063.16,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 60275063.16,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 54325907.29,
        "delta": -5949155.87
      },
      {
        "periodo": 202604,
        "valor": 54325907.29,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 54325907.29,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 54325907.29,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 54325907.29,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 59534578.0,
    "valor_anterior": 59679362.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 54253776.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55496404.0,
        "delta": 1242628.0
      },
      {
        "periodo": 202509,
        "valor": 55572770.0,
        "delta": 76366.0
      },
      {
        "periodo": 202510,
        "valor": 55708370.0,
        "delta": 135600.0
      },
      {
        "periodo": 202511,
        "valor": 58267884.0,
        "delta": 2559514.0
      },
      {
        "periodo": 202512,
        "valor": 58664953.0,
        "delta": 397069.0
      },
      {
        "periodo": 202601,
        "valor": 58769977.0,
        "delta": 105024.0
      },
      {
        "periodo": 202602,
        "valor": 59016778.0,
        "delta": 246801.0
      },
      {
        "periodo": 202603,
        "valor": 59476843.0,
        "delta": 460065.0
      },
      {
        "periodo": 202604,
        "valor": 59809766.0,
        "delta": 332923.0
      },
      {
        "periodo": 202605,
        "valor": 59851320.0,
        "delta": 41554.0
      },
      {
        "periodo": 202606,
        "valor": 59679362.0,
        "delta": -171958.0
      },
      {
        "periodo": 202607,
        "valor": 59534578.0,
        "delta": -144784.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 39173801.78,
    "valor_anterior": 28106430.36,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 17567009.81,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 17832882.64,
        "delta": 265872.83
      },
      {
        "periodo": 202604,
        "valor": 22897749.65,
        "delta": 5064867.01
      },
      {
        "periodo": 202605,
        "valor": 31204218.56,
        "delta": 8306468.91
      },
      {
        "periodo": 202606,
        "valor": 28106430.36,
        "delta": -3097788.2
      },
      {
        "periodo": 202607,
        "valor": 39173801.78,
        "delta": 11067371.42
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 101801606062,
    "label": "EPRC Comercial E3",
    "valor_actual": 43788383587.97,
    "valor_anterior": 41794680118.909996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 37119684234.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 37889305025.4,
        "delta": 769620790.98
      },
      {
        "periodo": 202509,
        "valor": 39360691125.7,
        "delta": 1471386100.3
      },
      {
        "periodo": 202510,
        "valor": 39250535805.91,
        "delta": -110155319.79
      },
      {
        "periodo": 202511,
        "valor": 38974949036.69,
        "delta": -275586769.22
      },
      {
        "periodo": 202512,
        "valor": 36500093299.69,
        "delta": -2474855737.0
      },
      {
        "periodo": 202601,
        "valor": 37602006328.41,
        "delta": 1101913028.72
      },
      {
        "periodo": 202602,
        "valor": 37518564416.93,
        "delta": -83441911.48
      },
      {
        "periodo": 202603,
        "valor": 38954596606.04,
        "delta": 1436032189.11
      },
      {
        "periodo": 202604,
        "valor": 40881905727.06,
        "delta": 1927309121.02
      },
      {
        "periodo": 202605,
        "valor": 41563632169.61,
        "delta": 681726442.55
      },
      {
        "periodo": 202606,
        "valor": 41794680118.91,
        "delta": 231047949.3
      },
      {
        "periodo": 202607,
        "valor": 43788383587.97,
        "delta": 1993703469.06
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 6857375338.95,
    "valor_anterior": 6853428138.65,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2189517528.4,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2276881006.33,
        "delta": 87363477.93
      },
      {
        "periodo": 202509,
        "valor": 2334657530.68,
        "delta": 57776524.35
      },
      {
        "periodo": 202510,
        "valor": 2399506722.59,
        "delta": 64849191.91
      },
      {
        "periodo": 202511,
        "valor": 2441904416.73,
        "delta": 42397694.14
      },
      {
        "periodo": 202512,
        "valor": 2433412057.59,
        "delta": -8492359.14
      },
      {
        "periodo": 202601,
        "valor": 2526736284.73,
        "delta": 93324227.14
      },
      {
        "periodo": 202602,
        "valor": 6486043513.55,
        "delta": 3959307228.82
      },
      {
        "periodo": 202603,
        "valor": 6247144577.72,
        "delta": -238898935.83
      },
      {
        "periodo": 202604,
        "valor": 6299832995.98,
        "delta": 52688418.26
      },
      {
        "periodo": 202605,
        "valor": 6666381393.14,
        "delta": 366548397.16
      },
      {
        "periodo": 202606,
        "valor": 6853428138.65,
        "delta": 187046745.51
      },
      {
        "periodo": 202607,
        "valor": 6857375338.95,
        "delta": 3947200.3
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 14243327240.92,
    "valor_anterior": 13770525910.69,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11643185186.88,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11778826138.21,
        "delta": 135640951.33
      },
      {
        "periodo": 202509,
        "valor": 12197801112.73,
        "delta": 418974974.52
      },
      {
        "periodo": 202510,
        "valor": 12660098690.55,
        "delta": 462297577.82
      },
      {
        "periodo": 202511,
        "valor": 12907264022.71,
        "delta": 247165332.16
      },
      {
        "periodo": 202512,
        "valor": 13620073704.11,
        "delta": 712809681.4
      },
      {
        "periodo": 202601,
        "valor": 13548707450.82,
        "delta": -71366253.29
      },
      {
        "periodo": 202602,
        "valor": 13234340734.41,
        "delta": -314366716.41
      },
      {
        "periodo": 202603,
        "valor": 13134835400.98,
        "delta": -99505333.43
      },
      {
        "periodo": 202604,
        "valor": 13240226960.88,
        "delta": 105391559.9
      },
      {
        "periodo": 202605,
        "valor": 13645430316.19,
        "delta": 405203355.31
      },
      {
        "periodo": 202606,
        "valor": 13770525910.69,
        "delta": 125095594.5
      },
      {
        "periodo": 202607,
        "valor": 14243327240.92,
        "delta": 472801330.23
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 5302436592.0,
    "valor_anterior": 5360200099.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5110901855.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4577018025.0,
        "delta": -533883830.0
      },
      {
        "periodo": 202509,
        "valor": 4524751840.0,
        "delta": -52266185.0
      },
      {
        "periodo": 202510,
        "valor": 4577519044.0,
        "delta": 52767204.0
      },
      {
        "periodo": 202511,
        "valor": 4555427357.0,
        "delta": -22091687.0
      },
      {
        "periodo": 202512,
        "valor": 4794703086.0,
        "delta": 239275729.0
      },
      {
        "periodo": 202601,
        "valor": 4784242267.0,
        "delta": -10460819.0
      },
      {
        "periodo": 202602,
        "valor": 4691657373.0,
        "delta": -92584894.0
      },
      {
        "periodo": 202603,
        "valor": 4448756068.0,
        "delta": -242901305.0
      },
      {
        "periodo": 202604,
        "valor": 4486104060.0,
        "delta": 37347992.0
      },
      {
        "periodo": 202605,
        "valor": 5267868160.0,
        "delta": 781764100.0
      },
      {
        "periodo": 202606,
        "valor": 5360200099.0,
        "delta": 92331939.0
      },
      {
        "periodo": 202607,
        "valor": 5302436592.0,
        "delta": -57763507.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 2317725075.0,
    "valor_anterior": 2407076582.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2520108858.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2599320957.0,
        "delta": 79212099.0
      },
      {
        "periodo": 202509,
        "valor": 2649332133.0,
        "delta": 50011176.0
      },
      {
        "periodo": 202510,
        "valor": 2715834098.0,
        "delta": 66501965.0
      },
      {
        "periodo": 202511,
        "valor": 2550553921.0,
        "delta": -165280177.0
      },
      {
        "periodo": 202512,
        "valor": 2629794483.0,
        "delta": 79240562.0
      },
      {
        "periodo": 202601,
        "valor": 2526288345.0,
        "delta": -103506138.0
      },
      {
        "periodo": 202602,
        "valor": 2475397434.0,
        "delta": -50890911.0
      },
      {
        "periodo": 202603,
        "valor": 2447814938.0,
        "delta": -27582496.0
      },
      {
        "periodo": 202604,
        "valor": 2359492962.0,
        "delta": -88321976.0
      },
      {
        "periodo": 202605,
        "valor": 2361490173.0,
        "delta": 1997211.0
      },
      {
        "periodo": 202606,
        "valor": 2407076582.0,
        "delta": 45586409.0
      },
      {
        "periodo": 202607,
        "valor": 2317725075.0,
        "delta": -89351507.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 153587584.46,
    "valor_anterior": 155767954.04,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 142901278.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 134437945.13,
        "delta": -8463333.69
      },
      {
        "periodo": 202509,
        "valor": 144206533.35,
        "delta": 9768588.22
      },
      {
        "periodo": 202510,
        "valor": 143499619.95,
        "delta": -706913.4
      },
      {
        "periodo": 202511,
        "valor": 132430197.22,
        "delta": -11069422.73
      },
      {
        "periodo": 202512,
        "valor": 137738100.75,
        "delta": 5307903.53
      },
      {
        "periodo": 202601,
        "valor": 128640566.23,
        "delta": -9097534.52
      },
      {
        "periodo": 202602,
        "valor": 128900720.87,
        "delta": 260154.64
      },
      {
        "periodo": 202603,
        "valor": 135842217.17,
        "delta": 6941496.3
      },
      {
        "periodo": 202604,
        "valor": 134768267.59,
        "delta": -1073949.58
      },
      {
        "periodo": 202605,
        "valor": 146253729.69,
        "delta": 11485462.1
      },
      {
        "periodo": 202606,
        "valor": 155767954.04,
        "delta": 9514224.35
      },
      {
        "periodo": 202607,
        "valor": 153587584.46,
        "delta": -2180369.58
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 114168077.0,
    "valor_anterior": 111626202.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 91759091.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 93831093.0,
        "delta": 2072002.0
      },
      {
        "periodo": 202509,
        "valor": 107054614.0,
        "delta": 13223521.0
      },
      {
        "periodo": 202510,
        "valor": 117644955.0,
        "delta": 10590341.0
      },
      {
        "periodo": 202511,
        "valor": 111957873.0,
        "delta": -5687082.0
      },
      {
        "periodo": 202512,
        "valor": 119410968.0,
        "delta": 7453095.0
      },
      {
        "periodo": 202601,
        "valor": 115920083.0,
        "delta": -3490885.0
      },
      {
        "periodo": 202602,
        "valor": 109120765.0,
        "delta": -6799318.0
      },
      {
        "periodo": 202603,
        "valor": 116964035.0,
        "delta": 7843270.0
      },
      {
        "periodo": 202604,
        "valor": 117888659.0,
        "delta": 924624.0
      },
      {
        "periodo": 202605,
        "valor": 105982649.0,
        "delta": -11906010.0
      },
      {
        "periodo": 202606,
        "valor": 111626202.0,
        "delta": 5643553.0
      },
      {
        "periodo": 202607,
        "valor": 114168077.0,
        "delta": 2541875.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 24419707.0,
    "valor_anterior": 27447835.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18916945.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21053454.0,
        "delta": 2136509.0
      },
      {
        "periodo": 202509,
        "valor": 22043174.0,
        "delta": 989720.0
      },
      {
        "periodo": 202510,
        "valor": 20233805.0,
        "delta": -1809369.0
      },
      {
        "periodo": 202511,
        "valor": 21869295.0,
        "delta": 1635490.0
      },
      {
        "periodo": 202512,
        "valor": 23076073.0,
        "delta": 1206778.0
      },
      {
        "periodo": 202601,
        "valor": 24684062.0,
        "delta": 1607989.0
      },
      {
        "periodo": 202602,
        "valor": 26360041.0,
        "delta": 1675979.0
      },
      {
        "periodo": 202603,
        "valor": 30817057.0,
        "delta": 4457016.0
      },
      {
        "periodo": 202604,
        "valor": 35740850.0,
        "delta": 4923793.0
      },
      {
        "periodo": 202605,
        "valor": 38948224.0,
        "delta": 3207374.0
      },
      {
        "periodo": 202606,
        "valor": 27447835.0,
        "delta": -11500389.0
      },
      {
        "periodo": 202607,
        "valor": 24419707.0,
        "delta": -3028128.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 1250170461.0,
    "valor_anterior": 1235450833.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1112390976.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1138294418.0,
        "delta": 25903442.0
      },
      {
        "periodo": 202509,
        "valor": 1127352697.0,
        "delta": -10941721.0
      },
      {
        "periodo": 202510,
        "valor": 1205493563.0,
        "delta": 78140866.0
      },
      {
        "periodo": 202511,
        "valor": 1320339324.0,
        "delta": 114845761.0
      },
      {
        "periodo": 202512,
        "valor": 1292683722.0,
        "delta": -27655602.0
      },
      {
        "periodo": 202601,
        "valor": 1313585213.0,
        "delta": 20901491.0
      },
      {
        "periodo": 202602,
        "valor": 1367220619.0,
        "delta": 53635406.0
      },
      {
        "periodo": 202603,
        "valor": 1302338115.0,
        "delta": -64882504.0
      },
      {
        "periodo": 202604,
        "valor": 1240120801.0,
        "delta": -62217314.0
      },
      {
        "periodo": 202605,
        "valor": 1235469756.0,
        "delta": -4651045.0
      },
      {
        "periodo": 202606,
        "valor": 1235450833.0,
        "delta": -18923.0
      },
      {
        "periodo": 202607,
        "valor": 1250170461.0,
        "delta": 14719628.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 156659433.95,
    "valor_anterior": 159477045.71,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 238345079.56,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 239718097.57,
        "delta": 1373018.01
      },
      {
        "periodo": 202509,
        "valor": 239358112.06,
        "delta": -359985.51
      },
      {
        "periodo": 202510,
        "valor": 236851177.75,
        "delta": -2506934.31
      },
      {
        "periodo": 202511,
        "valor": 248414488.66,
        "delta": 11563310.91
      },
      {
        "periodo": 202512,
        "valor": 262623961.9,
        "delta": 14209473.24
      },
      {
        "periodo": 202601,
        "valor": 254089745.21,
        "delta": -8534216.69
      },
      {
        "periodo": 202602,
        "valor": 138727116.29,
        "delta": -115362628.92
      },
      {
        "periodo": 202603,
        "valor": 144910340.03,
        "delta": 6183223.74
      },
      {
        "periodo": 202604,
        "valor": 147635316.24,
        "delta": 2724976.21
      },
      {
        "periodo": 202605,
        "valor": 153710192.76,
        "delta": 6074876.52
      },
      {
        "periodo": 202606,
        "valor": 159477045.71,
        "delta": 5766852.95
      },
      {
        "periodo": 202607,
        "valor": 156659433.95,
        "delta": -2817611.76
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 934297995.0,
    "valor_anterior": 930674526.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 626316612.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 694269891.0,
        "delta": 67953279.0
      },
      {
        "periodo": 202509,
        "valor": 666406241.0,
        "delta": -27863650.0
      },
      {
        "periodo": 202510,
        "valor": 653993934.0,
        "delta": -12412307.0
      },
      {
        "periodo": 202511,
        "valor": 739240770.0,
        "delta": 85246836.0
      },
      {
        "periodo": 202512,
        "valor": 785953819.0,
        "delta": 46713049.0
      },
      {
        "periodo": 202601,
        "valor": 799386156.0,
        "delta": 13432337.0
      },
      {
        "periodo": 202602,
        "valor": 814231658.0,
        "delta": 14845502.0
      },
      {
        "periodo": 202603,
        "valor": 813232307.0,
        "delta": -999351.0
      },
      {
        "periodo": 202604,
        "valor": 833608442.0,
        "delta": 20376135.0
      },
      {
        "periodo": 202605,
        "valor": 875556520.0,
        "delta": 41948078.0
      },
      {
        "periodo": 202606,
        "valor": 930674526.0,
        "delta": 55118006.0
      },
      {
        "periodo": 202607,
        "valor": 934297995.0,
        "delta": 3623469.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 34821118.0,
    "valor_anterior": 34821118.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 33738638.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 34826401.0,
        "delta": 1087763.0
      },
      {
        "periodo": 202509,
        "valor": 35451733.0,
        "delta": 625332.0
      },
      {
        "periodo": 202510,
        "valor": 32283003.0,
        "delta": -3168730.0
      },
      {
        "periodo": 202511,
        "valor": 32645591.0,
        "delta": 362588.0
      },
      {
        "periodo": 202512,
        "valor": 33371278.0,
        "delta": 725687.0
      },
      {
        "periodo": 202601,
        "valor": 33733354.0,
        "delta": 362076.0
      },
      {
        "periodo": 202602,
        "valor": 33733354.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 34095942.0,
        "delta": 362588.0
      },
      {
        "periodo": 202604,
        "valor": 34458530.0,
        "delta": 362588.0
      },
      {
        "periodo": 202605,
        "valor": 34458530.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 34821118.0,
        "delta": 362588.0
      },
      {
        "periodo": 202607,
        "valor": 34821118.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 255968454.0,
    "valor_anterior": 266698662.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 232272103.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 264109191.0,
        "delta": 31837088.0
      },
      {
        "periodo": 202509,
        "valor": 272659931.0,
        "delta": 8550740.0
      },
      {
        "periodo": 202510,
        "valor": 248587307.0,
        "delta": -24072624.0
      },
      {
        "periodo": 202511,
        "valor": 277229916.0,
        "delta": 28642609.0
      },
      {
        "periodo": 202512,
        "valor": 283383035.0,
        "delta": 6153119.0
      },
      {
        "periodo": 202601,
        "valor": 288042341.0,
        "delta": 4659306.0
      },
      {
        "periodo": 202602,
        "valor": 289373786.0,
        "delta": 1331445.0
      },
      {
        "periodo": 202603,
        "valor": 272496076.0,
        "delta": -16877710.0
      },
      {
        "periodo": 202604,
        "valor": 262897630.0,
        "delta": -9598446.0
      },
      {
        "periodo": 202605,
        "valor": 260955595.0,
        "delta": -1942035.0
      },
      {
        "periodo": 202606,
        "valor": 266698662.0,
        "delta": 5743067.0
      },
      {
        "periodo": 202607,
        "valor": 255968454.0,
        "delta": -10730208.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 4652809345.86,
    "valor_anterior": 4526105588.36,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3733585258.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3552824087.51,
        "delta": -180761171.39
      },
      {
        "periodo": 202509,
        "valor": 3638003967.36,
        "delta": 85179879.85
      },
      {
        "periodo": 202510,
        "valor": 3783787547.04,
        "delta": 145783579.68
      },
      {
        "periodo": 202511,
        "valor": 4117949850.91,
        "delta": 334162303.87
      },
      {
        "periodo": 202512,
        "valor": 4560815048.76,
        "delta": 442865197.85
      },
      {
        "periodo": 202601,
        "valor": 4511430006.22,
        "delta": -49385042.54
      },
      {
        "periodo": 202602,
        "valor": 4217049298.7,
        "delta": -294380707.52
      },
      {
        "periodo": 202603,
        "valor": 4023563870.38,
        "delta": -193485428.32
      },
      {
        "periodo": 202604,
        "valor": 4126844676.98,
        "delta": 103280806.6
      },
      {
        "periodo": 202605,
        "valor": 4334523532.71,
        "delta": 207678855.73
      },
      {
        "periodo": 202606,
        "valor": 4526105588.36,
        "delta": 191582055.65
      },
      {
        "periodo": 202607,
        "valor": 4652809345.86,
        "delta": 126703757.5
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 1517914.0,
    "valor_anterior": 1721521.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1239610.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1526591.0,
        "delta": 286981.0
      },
      {
        "periodo": 202509,
        "valor": 1532782.0,
        "delta": 6191.0
      },
      {
        "periodo": 202510,
        "valor": 1551651.0,
        "delta": 18869.0
      },
      {
        "periodo": 202511,
        "valor": 1482278.0,
        "delta": -69373.0
      },
      {
        "periodo": 202512,
        "valor": 1512716.0,
        "delta": 30438.0
      },
      {
        "periodo": 202601,
        "valor": 1517697.0,
        "delta": 4981.0
      },
      {
        "periodo": 202602,
        "valor": 1637217.0,
        "delta": 119520.0
      },
      {
        "periodo": 202603,
        "valor": 1702436.0,
        "delta": 65219.0
      },
      {
        "periodo": 202604,
        "valor": 1648857.0,
        "delta": -53579.0
      },
      {
        "periodo": 202605,
        "valor": 1661232.0,
        "delta": 12375.0
      },
      {
        "periodo": 202606,
        "valor": 1721521.0,
        "delta": 60289.0
      },
      {
        "periodo": 202607,
        "valor": 1517914.0,
        "delta": -203607.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 5856323280.29,
    "valor_anterior": 6578042402.35,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4746369690.91,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5009215196.71,
        "delta": 262845505.8
      },
      {
        "periodo": 202509,
        "valor": 5398928482.62,
        "delta": 389713285.91
      },
      {
        "periodo": 202510,
        "valor": 6453610884.19,
        "delta": 1054682401.57
      },
      {
        "periodo": 202511,
        "valor": 7185317089.11,
        "delta": 731706204.92
      },
      {
        "periodo": 202512,
        "valor": 7554865103.01,
        "delta": 369548013.9
      },
      {
        "periodo": 202601,
        "valor": 7391452951.74,
        "delta": -163412151.27
      },
      {
        "periodo": 202602,
        "valor": 7364669539.77,
        "delta": -26783411.97
      },
      {
        "periodo": 202603,
        "valor": 7234233890.09,
        "delta": -130435649.68
      },
      {
        "periodo": 202604,
        "valor": 6957890342.34,
        "delta": -276343547.75
      },
      {
        "periodo": 202605,
        "valor": 6833189469.66,
        "delta": -124700872.68
      },
      {
        "periodo": 202606,
        "valor": 6578042402.35,
        "delta": -255147067.31
      },
      {
        "periodo": 202607,
        "valor": 5856323280.29,
        "delta": -721719122.06
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 13002377.24,
    "valor_anterior": 12962845.46,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9726132.35,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11609491.39,
        "delta": 1883359.04
      },
      {
        "periodo": 202509,
        "valor": 18311374.33,
        "delta": 6701882.94
      },
      {
        "periodo": 202510,
        "valor": 12403499.88,
        "delta": -5907874.45
      },
      {
        "periodo": 202511,
        "valor": 17489609.79,
        "delta": 5086109.91
      },
      {
        "periodo": 202512,
        "valor": 14356183.73,
        "delta": -3133426.06
      },
      {
        "periodo": 202601,
        "valor": 16683704.25,
        "delta": 2327520.52
      },
      {
        "periodo": 202602,
        "valor": 11367449.56,
        "delta": -5316254.69
      },
      {
        "periodo": 202603,
        "valor": 13235259.86,
        "delta": 1867810.3
      },
      {
        "periodo": 202604,
        "valor": 15141647.85,
        "delta": 1906387.99
      },
      {
        "periodo": 202605,
        "valor": 18811203.7,
        "delta": 3669555.85
      },
      {
        "periodo": 202606,
        "valor": 12962845.46,
        "delta": -5848358.24
      },
      {
        "periodo": 202607,
        "valor": 13002377.24,
        "delta": 39531.78
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 2254773107.0,
    "valor_anterior": 2235965112.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1430853683.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1470932153.0,
        "delta": 40078470.0
      },
      {
        "periodo": 202509,
        "valor": 1555141210.0,
        "delta": 84209057.0
      },
      {
        "periodo": 202510,
        "valor": 1634863034.0,
        "delta": 79721824.0
      },
      {
        "periodo": 202511,
        "valor": 1748721831.0,
        "delta": 113858797.0
      },
      {
        "periodo": 202512,
        "valor": 2006523752.0,
        "delta": 257801921.0
      },
      {
        "periodo": 202601,
        "valor": 2046277554.0,
        "delta": 39753802.0
      },
      {
        "periodo": 202602,
        "valor": 2250371704.0,
        "delta": 204094150.0
      },
      {
        "periodo": 202603,
        "valor": 2360576439.0,
        "delta": 110204735.0
      },
      {
        "periodo": 202604,
        "valor": 2214528795.0,
        "delta": -146047644.0
      },
      {
        "periodo": 202605,
        "valor": 2238658924.0,
        "delta": 24130129.0
      },
      {
        "periodo": 202606,
        "valor": 2235965112.0,
        "delta": -2693812.0
      },
      {
        "periodo": 202607,
        "valor": 2254773107.0,
        "delta": 18807995.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 66793389.0,
    "valor_anterior": 75869787.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 64897276.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 68941163.0,
        "delta": 4043887.0
      },
      {
        "periodo": 202509,
        "valor": 68616949.0,
        "delta": -324214.0
      },
      {
        "periodo": 202510,
        "valor": 71970070.0,
        "delta": 3353121.0
      },
      {
        "periodo": 202511,
        "valor": 71634819.0,
        "delta": -335251.0
      },
      {
        "periodo": 202512,
        "valor": 78051203.0,
        "delta": 6416384.0
      },
      {
        "periodo": 202601,
        "valor": 86116990.0,
        "delta": 8065787.0
      },
      {
        "periodo": 202602,
        "valor": 51053430.0,
        "delta": -35063560.0
      },
      {
        "periodo": 202603,
        "valor": 53957811.0,
        "delta": 2904381.0
      },
      {
        "periodo": 202604,
        "valor": 57455170.0,
        "delta": 3497359.0
      },
      {
        "periodo": 202605,
        "valor": 75462537.0,
        "delta": 18007367.0
      },
      {
        "periodo": 202606,
        "valor": 75869787.0,
        "delta": 407250.0
      },
      {
        "periodo": 202607,
        "valor": 66793389.0,
        "delta": -9076398.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 186109069.0,
    "valor_anterior": 188397531.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 216064645.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 213100443.0,
        "delta": -2964202.0
      },
      {
        "periodo": 202509,
        "valor": 206978938.0,
        "delta": -6121505.0
      },
      {
        "periodo": 202510,
        "valor": 212797302.0,
        "delta": 5818364.0
      },
      {
        "periodo": 202511,
        "valor": 193120198.0,
        "delta": -19677104.0
      },
      {
        "periodo": 202512,
        "valor": 190765698.0,
        "delta": -2354500.0
      },
      {
        "periodo": 202601,
        "valor": 184779362.0,
        "delta": -5986336.0
      },
      {
        "periodo": 202602,
        "valor": 182863292.0,
        "delta": -1916070.0
      },
      {
        "periodo": 202603,
        "valor": 188577352.0,
        "delta": 5714060.0
      },
      {
        "periodo": 202604,
        "valor": 186212403.0,
        "delta": -2364949.0
      },
      {
        "periodo": 202605,
        "valor": 184631708.0,
        "delta": -1580695.0
      },
      {
        "periodo": 202606,
        "valor": 188397531.0,
        "delta": 3765823.0
      },
      {
        "periodo": 202607,
        "valor": 186109069.0,
        "delta": -2288462.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2162340.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4922166.0,
        "delta": 2759826.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 2799778672.22,
    "valor_anterior": 2754541958.84,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1893194032.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1957341844.72,
        "delta": 64147812.43
      },
      {
        "periodo": 202509,
        "valor": 1942826358.0,
        "delta": -14515486.72
      },
      {
        "periodo": 202510,
        "valor": 1949255923.5,
        "delta": 6429565.5
      },
      {
        "periodo": 202511,
        "valor": 2146576941.24,
        "delta": 197321017.74
      },
      {
        "periodo": 202512,
        "valor": 2216161099.47,
        "delta": 69584158.23
      },
      {
        "periodo": 202601,
        "valor": 2488820680.23,
        "delta": 272659580.76
      },
      {
        "periodo": 202602,
        "valor": 2619746352.75,
        "delta": 130925672.52
      },
      {
        "periodo": 202603,
        "valor": 2533231884.63,
        "delta": -86514468.12
      },
      {
        "periodo": 202604,
        "valor": 2600458412.24,
        "delta": 67226527.61
      },
      {
        "periodo": 202605,
        "valor": 2632339027.14,
        "delta": 31880614.9
      },
      {
        "periodo": 202606,
        "valor": 2754541958.84,
        "delta": 122202931.7
      },
      {
        "periodo": 202607,
        "valor": 2799778672.22,
        "delta": 45236713.38
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 108051121.0,
    "valor_anterior": 100618248.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 42799219.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 47317013.0,
        "delta": 4517794.0
      },
      {
        "periodo": 202509,
        "valor": 51192871.0,
        "delta": 3875858.0
      },
      {
        "periodo": 202510,
        "valor": 59066588.0,
        "delta": 7873717.0
      },
      {
        "periodo": 202511,
        "valor": 62806536.0,
        "delta": 3739948.0
      },
      {
        "periodo": 202512,
        "valor": 72393106.0,
        "delta": 9586570.0
      },
      {
        "periodo": 202601,
        "valor": 74817394.0,
        "delta": 2424288.0
      },
      {
        "periodo": 202602,
        "valor": 83033003.0,
        "delta": 8215609.0
      },
      {
        "periodo": 202603,
        "valor": 83433386.0,
        "delta": 400383.0
      },
      {
        "periodo": 202604,
        "valor": 84588568.0,
        "delta": 1155182.0
      },
      {
        "periodo": 202605,
        "valor": 90846103.01,
        "delta": 6257535.01
      },
      {
        "periodo": 202606,
        "valor": 100618248.0,
        "delta": 9772144.99
      },
      {
        "periodo": 202607,
        "valor": 108051121.0,
        "delta": 7432873.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 443068103.0,
    "valor_anterior": 399761052.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 390856066.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 374629914.0,
        "delta": -16226152.0
      },
      {
        "periodo": 202509,
        "valor": 368144051.0,
        "delta": -6485863.0
      },
      {
        "periodo": 202510,
        "valor": 382466820.0,
        "delta": 14322769.0
      },
      {
        "periodo": 202511,
        "valor": 389366449.0,
        "delta": 6899629.0
      },
      {
        "periodo": 202512,
        "valor": 396902461.0,
        "delta": 7536012.0
      },
      {
        "periodo": 202601,
        "valor": 386313487.0,
        "delta": -10588974.0
      },
      {
        "periodo": 202602,
        "valor": 394955096.0,
        "delta": 8641609.0
      },
      {
        "periodo": 202603,
        "valor": 369470790.0,
        "delta": -25484306.0
      },
      {
        "periodo": 202604,
        "valor": 394984814.0,
        "delta": 25514024.0
      },
      {
        "periodo": 202605,
        "valor": 370691958.0,
        "delta": -24292856.0
      },
      {
        "periodo": 202606,
        "valor": 399761052.0,
        "delta": 29069094.0
      },
      {
        "periodo": 202607,
        "valor": 443068103.0,
        "delta": 43307051.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 125738594.0,
    "valor_anterior": 112679703.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 60618105.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 65102484.0,
        "delta": 4484379.0
      },
      {
        "periodo": 202509,
        "valor": 69801526.0,
        "delta": 4699042.0
      },
      {
        "periodo": 202510,
        "valor": 74419692.0,
        "delta": 4618166.0
      },
      {
        "periodo": 202511,
        "valor": 80889370.0,
        "delta": 6469678.0
      },
      {
        "periodo": 202512,
        "valor": 85379688.0,
        "delta": 4490318.0
      },
      {
        "periodo": 202601,
        "valor": 88892170.0,
        "delta": 3512482.0
      },
      {
        "periodo": 202602,
        "valor": 90959623.0,
        "delta": 2067453.0
      },
      {
        "periodo": 202603,
        "valor": 113262579.0,
        "delta": 22302956.0
      },
      {
        "periodo": 202604,
        "valor": 121868952.0,
        "delta": 8606373.0
      },
      {
        "periodo": 202605,
        "valor": 135013229.0,
        "delta": 13144277.0
      },
      {
        "periodo": 202606,
        "valor": 112679703.0,
        "delta": -22333526.0
      },
      {
        "periodo": 202607,
        "valor": 125738594.0,
        "delta": 13058891.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 156161711.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 40368220.64,
        "delta": -115793491.26
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 469565.17,
    "valor_anterior": 428275.86,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 752001.2,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 849836.34,
        "delta": 97835.14
      },
      {
        "periodo": 202509,
        "valor": 859451.43,
        "delta": 9615.09
      },
      {
        "periodo": 202510,
        "valor": 880646.36,
        "delta": 21194.93
      },
      {
        "periodo": 202511,
        "valor": 937045.3,
        "delta": 56398.94
      },
      {
        "periodo": 202512,
        "valor": 964855.01,
        "delta": 27809.71
      },
      {
        "periodo": 202601,
        "valor": 1167606.09,
        "delta": 202751.08
      },
      {
        "periodo": 202602,
        "valor": 1316586.28,
        "delta": 148980.19
      },
      {
        "periodo": 202603,
        "valor": 1382530.34,
        "delta": 65944.06
      },
      {
        "periodo": 202604,
        "valor": 1412358.54,
        "delta": 29828.2
      },
      {
        "periodo": 202605,
        "valor": 288771.7,
        "delta": -1123586.84
      },
      {
        "periodo": 202606,
        "valor": 428275.86,
        "delta": 139504.16
      },
      {
        "periodo": 202607,
        "valor": 469565.17,
        "delta": 41289.31
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 45613288.0,
    "valor_anterior": 43472235.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26293677.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24036389.0,
        "delta": -2257288.0
      },
      {
        "periodo": 202509,
        "valor": 22541546.0,
        "delta": -1494843.0
      },
      {
        "periodo": 202510,
        "valor": 22244909.0,
        "delta": -296637.0
      },
      {
        "periodo": 202511,
        "valor": 23501463.0,
        "delta": 1256554.0
      },
      {
        "periodo": 202512,
        "valor": 26112603.0,
        "delta": 2611140.0
      },
      {
        "periodo": 202601,
        "valor": 27032030.0,
        "delta": 919427.0
      },
      {
        "periodo": 202602,
        "valor": 29050065.0,
        "delta": 2018035.0
      },
      {
        "periodo": 202603,
        "valor": 31198599.0,
        "delta": 2148534.0
      },
      {
        "periodo": 202604,
        "valor": 34705540.0,
        "delta": 3506941.0
      },
      {
        "periodo": 202605,
        "valor": 39396513.0,
        "delta": 4690973.0
      },
      {
        "periodo": 202606,
        "valor": 43472235.0,
        "delta": 4075722.0
      },
      {
        "periodo": 202607,
        "valor": 45613288.0,
        "delta": 2141053.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 33379419.52,
    "valor_anterior": 34357470.27,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28878225.4,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29038008.0,
        "delta": 159782.6
      },
      {
        "periodo": 202509,
        "valor": 28800936.02,
        "delta": -237071.98
      },
      {
        "periodo": 202510,
        "valor": 32501284.25,
        "delta": 3700348.23
      },
      {
        "periodo": 202511,
        "valor": 28462731.28,
        "delta": -4038552.97
      },
      {
        "periodo": 202512,
        "valor": 28298087.36,
        "delta": -164643.92
      },
      {
        "periodo": 202601,
        "valor": 27430784.2,
        "delta": -867303.16
      },
      {
        "periodo": 202602,
        "valor": 28094442.88,
        "delta": 663658.68
      },
      {
        "periodo": 202603,
        "valor": 29581378.08,
        "delta": 1486935.2
      },
      {
        "periodo": 202604,
        "valor": 31807771.14,
        "delta": 2226393.06
      },
      {
        "periodo": 202605,
        "valor": 33155975.6,
        "delta": 1348204.46
      },
      {
        "periodo": 202606,
        "valor": 34357470.27,
        "delta": 1201494.67
      },
      {
        "periodo": 202607,
        "valor": 33379419.52,
        "delta": -978050.75
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 106942.0,
    "valor_anterior": 126165.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 114834.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 117942.0,
        "delta": 3108.0
      },
      {
        "periodo": 202509,
        "valor": 124756.0,
        "delta": 6814.0
      },
      {
        "periodo": 202510,
        "valor": 130016.0,
        "delta": 5260.0
      },
      {
        "periodo": 202511,
        "valor": 321503.0,
        "delta": 191487.0
      },
      {
        "periodo": 202512,
        "valor": 300447.0,
        "delta": -21056.0
      },
      {
        "periodo": 202601,
        "valor": 139619.0,
        "delta": -160828.0
      },
      {
        "periodo": 202602,
        "valor": 304471.0,
        "delta": 164852.0
      },
      {
        "periodo": 202603,
        "valor": 283583.0,
        "delta": -20888.0
      },
      {
        "periodo": 202604,
        "valor": 277179.0,
        "delta": -6404.0
      },
      {
        "periodo": 202605,
        "valor": 125139.0,
        "delta": -152040.0
      },
      {
        "periodo": 202606,
        "valor": 126165.0,
        "delta": 1026.0
      },
      {
        "periodo": 202607,
        "valor": 106942.0,
        "delta": -19223.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 22936.79,
    "valor_anterior": 64735.33,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4208538.16,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3128262.3,
        "delta": -1080275.86
      },
      {
        "periodo": 202509,
        "valor": 1836693.6,
        "delta": -1291568.7
      },
      {
        "periodo": 202510,
        "valor": 1210167.31,
        "delta": -626526.29
      },
      {
        "periodo": 202511,
        "valor": 697442.29,
        "delta": -512725.02
      },
      {
        "periodo": 202512,
        "valor": 424709.04,
        "delta": -272733.25
      },
      {
        "periodo": 202601,
        "valor": 250446.27,
        "delta": -174262.77
      },
      {
        "periodo": 202602,
        "valor": 228461.05,
        "delta": -21985.22
      },
      {
        "periodo": 202603,
        "valor": 171634.3,
        "delta": -56826.75
      },
      {
        "periodo": 202604,
        "valor": 89970.02,
        "delta": -81664.28
      },
      {
        "periodo": 202605,
        "valor": 77312.27,
        "delta": -12657.75
      },
      {
        "periodo": 202606,
        "valor": 64735.33,
        "delta": -12576.94
      },
      {
        "periodo": 202607,
        "valor": 22936.79,
        "delta": -41798.54
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 101677454.46,
    "valor_anterior": 102509243.35,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 104856911.67,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 100257380.25,
        "delta": -4599531.42
      },
      {
        "periodo": 202604,
        "valor": 99383066.56,
        "delta": -874313.69
      },
      {
        "periodo": 202605,
        "valor": 101300349.25,
        "delta": 1917282.69
      },
      {
        "periodo": 202606,
        "valor": 102509243.35,
        "delta": 1208894.1
      },
      {
        "periodo": 202607,
        "valor": 101677454.46,
        "delta": -831788.89
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 40384369.0,
    "valor_anterior": 39069971.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 941224.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3263119.0,
        "delta": 2321895.0
      },
      {
        "periodo": 202509,
        "valor": 7726800.0,
        "delta": 4463681.0
      },
      {
        "periodo": 202510,
        "valor": 19255409.0,
        "delta": 11528609.0
      },
      {
        "periodo": 202511,
        "valor": 34460561.0,
        "delta": 15205152.0
      },
      {
        "periodo": 202512,
        "valor": 38123413.0,
        "delta": 3662852.0
      },
      {
        "periodo": 202601,
        "valor": 36819725.0,
        "delta": -1303688.0
      },
      {
        "periodo": 202602,
        "valor": 28971160.0,
        "delta": -7848565.0
      },
      {
        "periodo": 202603,
        "valor": 27079779.0,
        "delta": -1891381.0
      },
      {
        "periodo": 202604,
        "valor": 29951815.0,
        "delta": 2872036.0
      },
      {
        "periodo": 202605,
        "valor": 34859694.0,
        "delta": 4907879.0
      },
      {
        "periodo": 202606,
        "valor": 39069971.0,
        "delta": 4210277.0
      },
      {
        "periodo": 202607,
        "valor": 40384369.0,
        "delta": 1314398.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 418924.0,
    "valor_anterior": 250010.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 5678.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 6699.0,
        "delta": 1021.0
      },
      {
        "periodo": 202605,
        "valor": 184567.0,
        "delta": 177868.0
      },
      {
        "periodo": 202606,
        "valor": 250010.0,
        "delta": 65443.0
      },
      {
        "periodo": 202607,
        "valor": 418924.0,
        "delta": 168914.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 843171617.0,
    "valor_anterior": 617314434.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 490058703.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 678499173.0,
        "delta": 188440470.0
      },
      {
        "periodo": 202605,
        "valor": 909568864.0,
        "delta": 231069691.0
      },
      {
        "periodo": 202606,
        "valor": 617314434.0,
        "delta": -292254430.0
      },
      {
        "periodo": 202607,
        "valor": 843171617.0,
        "delta": 225857183.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 101801606063,
    "label": "EPRC Consumo E3",
    "valor_actual": 49218166565.83,
    "valor_anterior": 49137453194.91,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 36770070421.77,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 36730850941.85,
        "delta": -39219479.92
      },
      {
        "periodo": 202509,
        "valor": 37702444344.18,
        "delta": 971593402.33
      },
      {
        "periodo": 202510,
        "valor": 39723961363.37,
        "delta": 2021517019.19
      },
      {
        "periodo": 202511,
        "valor": 41443012890.24,
        "delta": 1719051526.87
      },
      {
        "periodo": 202512,
        "valor": 43688174461.73,
        "delta": 2245161571.49
      },
      {
        "periodo": 202601,
        "valor": 43713998074.99,
        "delta": 25823613.26
      },
      {
        "periodo": 202602,
        "valor": 47255635218.78,
        "delta": 3541637143.79
      },
      {
        "periodo": 202603,
        "valor": 46784512036.83,
        "delta": -471123181.95
      },
      {
        "periodo": 202604,
        "valor": 46830531685.36,
        "delta": 46019648.53
      },
      {
        "periodo": 202605,
        "valor": 48827291348.82,
        "delta": 1996759663.46
      },
      {
        "periodo": 202606,
        "valor": 49137453194.91,
        "delta": 310161846.09
      },
      {
        "periodo": 202607,
        "valor": 49218166565.83,
        "delta": 80713370.92
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 389234502.83,
    "valor_anterior": 403102472.56,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 373917731.56,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 385324091.06,
        "delta": 11406359.5
      },
      {
        "periodo": 202509,
        "valor": 404239025.48,
        "delta": 18914934.42
      },
      {
        "periodo": 202510,
        "valor": 419132551.69,
        "delta": 14893526.21
      },
      {
        "periodo": 202511,
        "valor": 451709026.02,
        "delta": 32576474.33
      },
      {
        "periodo": 202512,
        "valor": 454666825.44,
        "delta": 2957799.42
      },
      {
        "periodo": 202601,
        "valor": 429189019.74,
        "delta": -25477805.7
      },
      {
        "periodo": 202602,
        "valor": 425380359.79,
        "delta": -3808659.95
      },
      {
        "periodo": 202603,
        "valor": 422319637.49,
        "delta": -3060722.3
      },
      {
        "periodo": 202604,
        "valor": 394420572.92,
        "delta": -27899064.57
      },
      {
        "periodo": 202605,
        "valor": 404135307.6,
        "delta": 9714734.68
      },
      {
        "periodo": 202606,
        "valor": 403102472.56,
        "delta": -1032835.04
      },
      {
        "periodo": 202607,
        "valor": 389234502.83,
        "delta": -13867969.73
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 4607368831.48,
    "valor_anterior": 4567631556.68,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5167873842.32,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5356852179.28,
        "delta": 188978336.96
      },
      {
        "periodo": 202509,
        "valor": 5131957451.2,
        "delta": -224894728.08
      },
      {
        "periodo": 202510,
        "valor": 5117595312.26,
        "delta": -14362138.94
      },
      {
        "periodo": 202511,
        "valor": 4857855550.87,
        "delta": -259739761.39
      },
      {
        "periodo": 202512,
        "valor": 4984222439.04,
        "delta": 126366888.17
      },
      {
        "periodo": 202601,
        "valor": 5251546669.27,
        "delta": 267324230.23
      },
      {
        "periodo": 202602,
        "valor": 4159473646.34,
        "delta": -1092073022.93
      },
      {
        "periodo": 202603,
        "valor": 4355568867.35,
        "delta": 196095221.01
      },
      {
        "periodo": 202604,
        "valor": 4375472904.15,
        "delta": 19904036.8
      },
      {
        "periodo": 202605,
        "valor": 4640994265.53,
        "delta": 265521361.38
      },
      {
        "periodo": 202606,
        "valor": 4567631556.68,
        "delta": -73362708.85
      },
      {
        "periodo": 202607,
        "valor": 4607368831.48,
        "delta": 39737274.8
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 3535477934.0,
    "valor_anterior": 3488019891.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3762009476.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3815679780.0,
        "delta": 53670304.0
      },
      {
        "periodo": 202509,
        "valor": 4035661076.0,
        "delta": 219981296.0
      },
      {
        "periodo": 202510,
        "valor": 4018842694.0,
        "delta": -16818382.0
      },
      {
        "periodo": 202511,
        "valor": 3414183968.0,
        "delta": -604658726.0
      },
      {
        "periodo": 202512,
        "valor": 3306786181.0,
        "delta": -107397787.0
      },
      {
        "periodo": 202601,
        "valor": 3410610198.0,
        "delta": 103824017.0
      },
      {
        "periodo": 202602,
        "valor": 3472155710.0,
        "delta": 61545512.0
      },
      {
        "periodo": 202603,
        "valor": 3525042503.0,
        "delta": 52886793.0
      },
      {
        "periodo": 202604,
        "valor": 3681051975.0,
        "delta": 156009472.0
      },
      {
        "periodo": 202605,
        "valor": 3512797759.0,
        "delta": -168254216.0
      },
      {
        "periodo": 202606,
        "valor": 3488019891.0,
        "delta": -24777868.0
      },
      {
        "periodo": 202607,
        "valor": 3535477934.0,
        "delta": 47458043.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 1431403185.0,
    "valor_anterior": 1411885434.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1274978623.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1280177500.0,
        "delta": 5198877.0
      },
      {
        "periodo": 202509,
        "valor": 1308279215.0,
        "delta": 28101715.0
      },
      {
        "periodo": 202510,
        "valor": 1305563615.0,
        "delta": -2715600.0
      },
      {
        "periodo": 202511,
        "valor": 1325241950.0,
        "delta": 19678335.0
      },
      {
        "periodo": 202512,
        "valor": 1349979271.0,
        "delta": 24737321.0
      },
      {
        "periodo": 202601,
        "valor": 1398242788.0,
        "delta": 48263517.0
      },
      {
        "periodo": 202602,
        "valor": 1357181326.0,
        "delta": -41061462.0
      },
      {
        "periodo": 202603,
        "valor": 1355201820.0,
        "delta": -1979506.0
      },
      {
        "periodo": 202604,
        "valor": 1363507158.0,
        "delta": 8305338.0
      },
      {
        "periodo": 202605,
        "valor": 1379156781.0,
        "delta": 15649623.0
      },
      {
        "periodo": 202606,
        "valor": 1411885434.0,
        "delta": 32728653.0
      },
      {
        "periodo": 202607,
        "valor": 1431403185.0,
        "delta": 19517751.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 26567677.15,
    "valor_anterior": 26597505.68,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26213798.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23210078.09,
        "delta": -3003720.65
      },
      {
        "periodo": 202509,
        "valor": 32086793.98,
        "delta": 8876715.89
      },
      {
        "periodo": 202510,
        "valor": 35149983.96,
        "delta": 3063189.98
      },
      {
        "periodo": 202511,
        "valor": 32806920.61,
        "delta": -2343063.35
      },
      {
        "periodo": 202512,
        "valor": 34767224.87,
        "delta": 1960304.26
      },
      {
        "periodo": 202601,
        "valor": 28169685.02,
        "delta": -6597539.85
      },
      {
        "periodo": 202602,
        "valor": 27432436.14,
        "delta": -737248.88
      },
      {
        "periodo": 202603,
        "valor": 29756442.74,
        "delta": 2324006.6
      },
      {
        "periodo": 202604,
        "valor": 28249602.21,
        "delta": -1506840.53
      },
      {
        "periodo": 202605,
        "valor": 25128865.28,
        "delta": -3120736.93
      },
      {
        "periodo": 202606,
        "valor": 26597505.68,
        "delta": 1468640.4
      },
      {
        "periodo": 202607,
        "valor": 26567677.15,
        "delta": -29828.53
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 125234297.0,
    "valor_anterior": 124961440.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 120849490.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 124758468.0,
        "delta": 3908978.0
      },
      {
        "periodo": 202509,
        "valor": 129168226.0,
        "delta": 4409758.0
      },
      {
        "periodo": 202510,
        "valor": 136038872.0,
        "delta": 6870646.0
      },
      {
        "periodo": 202511,
        "valor": 138191393.0,
        "delta": 2152521.0
      },
      {
        "periodo": 202512,
        "valor": 137774363.0,
        "delta": -417030.0
      },
      {
        "periodo": 202601,
        "valor": 122789070.0,
        "delta": -14985293.0
      },
      {
        "periodo": 202602,
        "valor": 118994226.0,
        "delta": -3794844.0
      },
      {
        "periodo": 202603,
        "valor": 121771317.0,
        "delta": 2777091.0
      },
      {
        "periodo": 202604,
        "valor": 128009817.0,
        "delta": 6238500.0
      },
      {
        "periodo": 202605,
        "valor": 120250178.0,
        "delta": -7759639.0
      },
      {
        "periodo": 202606,
        "valor": 124961440.0,
        "delta": 4711262.0
      },
      {
        "periodo": 202607,
        "valor": 125234297.0,
        "delta": 272857.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 485180892.0,
    "valor_anterior": 472225731.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 423188716.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 428536212.0,
        "delta": 5347496.0
      },
      {
        "periodo": 202509,
        "valor": 440922655.0,
        "delta": 12386443.0
      },
      {
        "periodo": 202510,
        "valor": 445200498.0,
        "delta": 4277843.0
      },
      {
        "periodo": 202511,
        "valor": 446569136.0,
        "delta": 1368638.0
      },
      {
        "periodo": 202512,
        "valor": 413460180.0,
        "delta": -33108956.0
      },
      {
        "periodo": 202601,
        "valor": 424432364.0,
        "delta": 10972184.0
      },
      {
        "periodo": 202602,
        "valor": 435227254.0,
        "delta": 10794890.0
      },
      {
        "periodo": 202603,
        "valor": 442239065.0,
        "delta": 7011811.0
      },
      {
        "periodo": 202604,
        "valor": 474338228.0,
        "delta": 32099163.0
      },
      {
        "periodo": 202605,
        "valor": 478290043.0,
        "delta": 3951815.0
      },
      {
        "periodo": 202606,
        "valor": 472225731.0,
        "delta": -6064312.0
      },
      {
        "periodo": 202607,
        "valor": 485180892.0,
        "delta": 12955161.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 5534185297.0,
    "valor_anterior": 5451194587.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5021874781.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5058413188.0,
        "delta": 36538407.0
      },
      {
        "periodo": 202509,
        "valor": 5130559792.0,
        "delta": 72146604.0
      },
      {
        "periodo": 202510,
        "valor": 5199931763.0,
        "delta": 69371971.0
      },
      {
        "periodo": 202511,
        "valor": 5259746977.0,
        "delta": 59815214.0
      },
      {
        "periodo": 202512,
        "valor": 5319299810.0,
        "delta": 59552833.0
      },
      {
        "periodo": 202601,
        "valor": 5423378065.0,
        "delta": 104078255.0
      },
      {
        "periodo": 202602,
        "valor": 5416379420.0,
        "delta": -6998645.0
      },
      {
        "periodo": 202603,
        "valor": 5418211280.0,
        "delta": 1831860.0
      },
      {
        "periodo": 202604,
        "valor": 5395317016.0,
        "delta": -22894264.0
      },
      {
        "periodo": 202605,
        "valor": 5457769737.0,
        "delta": 62452721.0
      },
      {
        "periodo": 202606,
        "valor": 5451194588.0,
        "delta": -6575149.0
      },
      {
        "periodo": 202607,
        "valor": 5534185297.0,
        "delta": 82990709.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 65115112.28,
    "valor_anterior": 63059233.92,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 66681684.95,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 67809384.17,
        "delta": 1127699.22
      },
      {
        "periodo": 202509,
        "valor": 69547987.82,
        "delta": 1738603.65
      },
      {
        "periodo": 202510,
        "valor": 70071625.87,
        "delta": 523638.05
      },
      {
        "periodo": 202511,
        "valor": 72180131.96,
        "delta": 2108506.09
      },
      {
        "periodo": 202512,
        "valor": 67443905.13,
        "delta": -4736226.83
      },
      {
        "periodo": 202601,
        "valor": 52046822.44,
        "delta": -15397082.69
      },
      {
        "periodo": 202602,
        "valor": 52820677.07,
        "delta": 773854.63
      },
      {
        "periodo": 202603,
        "valor": 57353186.37,
        "delta": 4532509.3
      },
      {
        "periodo": 202604,
        "valor": 59361114.24,
        "delta": 2007927.87
      },
      {
        "periodo": 202605,
        "valor": 60018723.86,
        "delta": 657609.62
      },
      {
        "periodo": 202606,
        "valor": 63059233.92,
        "delta": 3040510.06
      },
      {
        "periodo": 202607,
        "valor": 65115112.28,
        "delta": 2055878.36
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 1071482.0,
    "valor_anterior": 1066540.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 817586.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 983981.0,
        "delta": 166395.0
      },
      {
        "periodo": 202509,
        "valor": 982808.0,
        "delta": -1173.0
      },
      {
        "periodo": 202510,
        "valor": 978357.0,
        "delta": -4451.0
      },
      {
        "periodo": 202511,
        "valor": 971466.0,
        "delta": -6891.0
      },
      {
        "periodo": 202512,
        "valor": 958829.0,
        "delta": -12637.0
      },
      {
        "periodo": 202601,
        "valor": 953475.0,
        "delta": -5354.0
      },
      {
        "periodo": 202602,
        "valor": 1090737.0,
        "delta": 137262.0
      },
      {
        "periodo": 202603,
        "valor": 1081764.0,
        "delta": -8973.0
      },
      {
        "periodo": 202604,
        "valor": 1066328.0,
        "delta": -15436.0
      },
      {
        "periodo": 202605,
        "valor": 1062747.0,
        "delta": -3581.0
      },
      {
        "periodo": 202606,
        "valor": 1066540.0,
        "delta": 3793.0
      },
      {
        "periodo": 202607,
        "valor": 1071482.0,
        "delta": 4942.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 229542351.0,
    "valor_anterior": 222537396.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 184841822.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 191030520.0,
        "delta": 6188698.0
      },
      {
        "periodo": 202509,
        "valor": 199566294.0,
        "delta": 8535774.0
      },
      {
        "periodo": 202510,
        "valor": 206565291.0,
        "delta": 6998997.0
      },
      {
        "periodo": 202511,
        "valor": 212454541.0,
        "delta": 5889250.0
      },
      {
        "periodo": 202512,
        "valor": 177546348.0,
        "delta": -34908193.0
      },
      {
        "periodo": 202601,
        "valor": 182816739.0,
        "delta": 5270391.0
      },
      {
        "periodo": 202602,
        "valor": 187368797.0,
        "delta": 4552058.0
      },
      {
        "periodo": 202603,
        "valor": 191280759.0,
        "delta": 3911962.0
      },
      {
        "periodo": 202604,
        "valor": 201606995.0,
        "delta": 10326236.0
      },
      {
        "periodo": 202605,
        "valor": 206037832.0,
        "delta": 4430837.0
      },
      {
        "periodo": 202606,
        "valor": 222537396.0,
        "delta": 16499564.0
      },
      {
        "periodo": 202607,
        "valor": 229542351.0,
        "delta": 7004955.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 921347934.45,
    "valor_anterior": 957738275.67,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 656929455.12,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 661697246.92,
        "delta": 4767791.8
      },
      {
        "periodo": 202509,
        "valor": 693455843.56,
        "delta": 31758596.64
      },
      {
        "periodo": 202510,
        "valor": 710617919.96,
        "delta": 17162076.4
      },
      {
        "periodo": 202511,
        "valor": 757560864.86,
        "delta": 46942944.9
      },
      {
        "periodo": 202512,
        "valor": 726332152.62,
        "delta": -31228712.24
      },
      {
        "periodo": 202601,
        "valor": 784334323.27,
        "delta": 58002170.65
      },
      {
        "periodo": 202602,
        "valor": 847505838.42,
        "delta": 63171515.15
      },
      {
        "periodo": 202603,
        "valor": 890619227.19,
        "delta": 43113388.77
      },
      {
        "periodo": 202604,
        "valor": 905335647.73,
        "delta": 14716420.54
      },
      {
        "periodo": 202605,
        "valor": 922812844.16,
        "delta": 17477196.43
      },
      {
        "periodo": 202606,
        "valor": 957738275.67,
        "delta": 34925431.51
      },
      {
        "periodo": 202607,
        "valor": 921347934.45,
        "delta": -36390341.22
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 34119357.0,
    "valor_anterior": 34492620.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27904243.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 30101371.0,
        "delta": 2197128.0
      },
      {
        "periodo": 202509,
        "valor": 30659743.0,
        "delta": 558372.0
      },
      {
        "periodo": 202510,
        "valor": 31580579.0,
        "delta": 920836.0
      },
      {
        "periodo": 202511,
        "valor": 28179469.0,
        "delta": -3401110.0
      },
      {
        "periodo": 202512,
        "valor": 90308514.0,
        "delta": 62129045.0
      },
      {
        "periodo": 202601,
        "valor": 91867575.0,
        "delta": 1559061.0
      },
      {
        "periodo": 202602,
        "valor": 94715712.0,
        "delta": 2848137.0
      },
      {
        "periodo": 202603,
        "valor": 34113720.0,
        "delta": -60601992.0
      },
      {
        "periodo": 202604,
        "valor": 36764537.0,
        "delta": 2650817.0
      },
      {
        "periodo": 202605,
        "valor": 34242818.0,
        "delta": -2521719.0
      },
      {
        "periodo": 202606,
        "valor": 34492620.0,
        "delta": 249802.0
      },
      {
        "periodo": 202607,
        "valor": 34119357.0,
        "delta": -373263.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 7154365.12,
    "valor_anterior": 8618844.26,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5171125.92,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5498451.14,
        "delta": 327325.22
      },
      {
        "periodo": 202509,
        "valor": 5172306.89,
        "delta": -326144.25
      },
      {
        "periodo": 202510,
        "valor": 5433180.4,
        "delta": 260873.51
      },
      {
        "periodo": 202511,
        "valor": 5421070.57,
        "delta": -12109.83
      },
      {
        "periodo": 202512,
        "valor": 8801097.5,
        "delta": 3380026.93
      },
      {
        "periodo": 202601,
        "valor": 8306241.26,
        "delta": -494856.24
      },
      {
        "periodo": 202602,
        "valor": 8274193.97,
        "delta": -32047.29
      },
      {
        "periodo": 202603,
        "valor": 10646184.78,
        "delta": 2371990.81
      },
      {
        "periodo": 202604,
        "valor": 8336026.88,
        "delta": -2310157.9
      },
      {
        "periodo": 202605,
        "valor": 8767266.88,
        "delta": 431240.0
      },
      {
        "periodo": 202606,
        "valor": 8618844.26,
        "delta": -148422.62
      },
      {
        "periodo": 202607,
        "valor": 7154365.12,
        "delta": -1464479.14
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 13909549.94,
    "valor_anterior": 9572913.51,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14943112.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13451686.0,
        "delta": -1491426.25
      },
      {
        "periodo": 202509,
        "valor": 14278567.61,
        "delta": 826881.61
      },
      {
        "periodo": 202510,
        "valor": 14806054.28,
        "delta": 527486.67
      },
      {
        "periodo": 202511,
        "valor": 11308859.94,
        "delta": -3497194.34
      },
      {
        "periodo": 202512,
        "valor": 11644531.14,
        "delta": 335671.2
      },
      {
        "periodo": 202601,
        "valor": 11579806.19,
        "delta": -64724.95
      },
      {
        "periodo": 202602,
        "valor": 14278567.61,
        "delta": 2698761.42
      },
      {
        "periodo": 202603,
        "valor": 11423245.77,
        "delta": -2855321.84
      },
      {
        "periodo": 202604,
        "valor": 12156088.81,
        "delta": 732843.04
      },
      {
        "periodo": 202605,
        "valor": 13305540.77,
        "delta": 1149451.96
      },
      {
        "periodo": 202606,
        "valor": 9572913.51,
        "delta": -3732627.26
      },
      {
        "periodo": 202607,
        "valor": 13909549.94,
        "delta": 4336636.43
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 273079129.0,
    "valor_anterior": 273673988.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 284107721.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 282652899.0,
        "delta": -1454822.0
      },
      {
        "periodo": 202509,
        "valor": 282413104.0,
        "delta": -239795.0
      },
      {
        "periodo": 202510,
        "valor": 280917149.0,
        "delta": -1495955.0
      },
      {
        "periodo": 202511,
        "valor": 280565724.0,
        "delta": -351425.0
      },
      {
        "periodo": 202512,
        "valor": 279282479.0,
        "delta": -1283245.0
      },
      {
        "periodo": 202601,
        "valor": 278918730.0,
        "delta": -363749.0
      },
      {
        "periodo": 202602,
        "valor": 277464014.0,
        "delta": -1454716.0
      },
      {
        "periodo": 202603,
        "valor": 277009193.0,
        "delta": -454821.0
      },
      {
        "periodo": 202604,
        "valor": 275777125.0,
        "delta": -1232068.0
      },
      {
        "periodo": 202605,
        "valor": 275582517.0,
        "delta": -194608.0
      },
      {
        "periodo": 202606,
        "valor": 273673988.0,
        "delta": -1908529.0
      },
      {
        "periodo": 202607,
        "valor": 273079129.0,
        "delta": -594859.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 154054991.91,
    "valor_anterior": 145657710.62,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 65395695.41,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 75519175.1,
        "delta": 10123479.69
      },
      {
        "periodo": 202509,
        "valor": 106010378.0,
        "delta": 30491202.9
      },
      {
        "periodo": 202510,
        "valor": 112097750.67,
        "delta": 6087372.67
      },
      {
        "periodo": 202511,
        "valor": 115291485.73,
        "delta": 3193735.06
      },
      {
        "periodo": 202512,
        "valor": 120721502.74,
        "delta": 5430017.01
      },
      {
        "periodo": 202601,
        "valor": 122446209.41,
        "delta": 1724706.67
      },
      {
        "periodo": 202602,
        "valor": 124530852.87,
        "delta": 2084643.46
      },
      {
        "periodo": 202603,
        "valor": 138645793.0,
        "delta": 14114940.13
      },
      {
        "periodo": 202604,
        "valor": 138351011.36,
        "delta": -294781.64
      },
      {
        "periodo": 202605,
        "valor": 143575741.78,
        "delta": 5224730.42
      },
      {
        "periodo": 202606,
        "valor": 145657710.62,
        "delta": 2081968.84
      },
      {
        "periodo": 202607,
        "valor": 154054991.91,
        "delta": 8397281.29
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 136923.0,
    "valor_anterior": 136923.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 134852.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 134852.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 136923.0,
        "delta": 2071.0
      },
      {
        "periodo": 202510,
        "valor": 136923.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 136923.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 136923.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 136923.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 136923.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 136923.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 136923.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 136923.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 136923.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 136923.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2030717.99,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 32169829.74,
        "delta": 30139111.75
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 132082.29,
    "valor_anterior": 193180.48,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1854796.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 781487.55,
        "delta": -1073308.64
      },
      {
        "periodo": 202509,
        "valor": 870527.51,
        "delta": 89039.96
      },
      {
        "periodo": 202510,
        "valor": 930896.25,
        "delta": 60368.74
      },
      {
        "periodo": 202511,
        "valor": 293866.71,
        "delta": -637029.54
      },
      {
        "periodo": 202512,
        "valor": 22654.18,
        "delta": -271212.53
      },
      {
        "periodo": 202601,
        "valor": 37895.74,
        "delta": 15241.56
      },
      {
        "periodo": 202602,
        "valor": 101067.93,
        "delta": 63172.19
      },
      {
        "periodo": 202603,
        "valor": 154679.86,
        "delta": 53611.93
      },
      {
        "periodo": 202604,
        "valor": 131873.01,
        "delta": -22806.85
      },
      {
        "periodo": 202605,
        "valor": 151664.92,
        "delta": 19791.91
      },
      {
        "periodo": 202606,
        "valor": 193180.48,
        "delta": 41515.56
      },
      {
        "periodo": 202607,
        "valor": 132082.29,
        "delta": -61098.19
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 183945.0,
    "valor_anterior": 209172.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 257798.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": 209172.0,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": 183945.0,
        "delta": -25227.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 101801606064,
    "label": "EPRC Vivienda E3",
    "valor_actual": 17834499839.449997,
    "valor_anterior": 17662575416.379997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17481977068.45,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17834782380.05,
        "delta": 352805311.6
      },
      {
        "periodo": 202509,
        "valor": 18015968718.05,
        "delta": 181186338.0
      },
      {
        "periodo": 202510,
        "valor": 18111591016.34,
        "delta": 95622298.29
      },
      {
        "periodo": 202511,
        "valor": 17410669324.27,
        "delta": -700921692.07
      },
      {
        "periodo": 202512,
        "valor": 17484155230.66,
        "delta": 73485906.39
      },
      {
        "periodo": 202601,
        "valor": 18021802599.34,
        "delta": 537647368.68
      },
      {
        "periodo": 202602,
        "valor": 17020511759.14,
        "delta": -1001290840.2
      },
      {
        "periodo": 202603,
        "valor": 17282575608.55,
        "delta": 262063849.41
      },
      {
        "periodo": 202604,
        "valor": 17479390943.31,
        "delta": 196815334.76
      },
      {
        "periodo": 202605,
        "valor": 17684217555.78,
        "delta": 204826612.47
      },
      {
        "periodo": 202606,
        "valor": 17662575416.38,
        "delta": -21642139.4
      },
      {
        "periodo": 202607,
        "valor": 17834499839.45,
        "delta": 171924423.07
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 3101520500.28,
    "valor_anterior": 3141707423.93,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 737458419.22,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 795053832.61,
        "delta": 57595413.39
      },
      {
        "periodo": 202509,
        "valor": 778325413.27,
        "delta": -16728419.34
      },
      {
        "periodo": 202510,
        "valor": 756267262.16,
        "delta": -22058151.11
      },
      {
        "periodo": 202511,
        "valor": 776779235.56,
        "delta": 20511973.4
      },
      {
        "periodo": 202512,
        "valor": 816612728.02,
        "delta": 39833492.46
      },
      {
        "periodo": 202601,
        "valor": 723653113.61,
        "delta": -92959614.41
      },
      {
        "periodo": 202602,
        "valor": 2873464169.0,
        "delta": 2149811055.39
      },
      {
        "periodo": 202603,
        "valor": 3211715138.66,
        "delta": 338250969.66
      },
      {
        "periodo": 202604,
        "valor": 3438344685.73,
        "delta": 226629547.07
      },
      {
        "periodo": 202605,
        "valor": 3309217446.96,
        "delta": -129127238.77
      },
      {
        "periodo": 202606,
        "valor": 3141707423.93,
        "delta": -167510023.03
      },
      {
        "periodo": 202607,
        "valor": 3101520500.28,
        "delta": -40186923.65
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 10216817837.23,
    "valor_anterior": 10117116494.460001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7787608022.05,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8108116513.13,
        "delta": 320508491.08
      },
      {
        "periodo": 202509,
        "valor": 8346154090.89,
        "delta": 238037577.76
      },
      {
        "periodo": 202510,
        "valor": 8705440505.7,
        "delta": 359286414.81
      },
      {
        "periodo": 202511,
        "valor": 8934303785.78,
        "delta": 228863280.08
      },
      {
        "periodo": 202512,
        "valor": 8113887678.07,
        "delta": -820416107.71
      },
      {
        "periodo": 202601,
        "valor": 8144735045.5,
        "delta": 30847367.43
      },
      {
        "periodo": 202602,
        "valor": 9932905472.86,
        "delta": 1788170427.36
      },
      {
        "periodo": 202603,
        "valor": 10505683021.7,
        "delta": 572777548.84
      },
      {
        "periodo": 202604,
        "valor": 10306314867.37,
        "delta": -199368154.33
      },
      {
        "periodo": 202605,
        "valor": 10252758210.02,
        "delta": -53556657.35
      },
      {
        "periodo": 202606,
        "valor": 10117116494.46,
        "delta": -135641715.56
      },
      {
        "periodo": 202607,
        "valor": 10216817837.23,
        "delta": 99701342.77
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 7049800943.0,
    "valor_anterior": 7099336963.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4844080315.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5091697892.0,
        "delta": 247617577.0
      },
      {
        "periodo": 202509,
        "valor": 5233584055.0,
        "delta": 141886163.0
      },
      {
        "periodo": 202510,
        "valor": 5435479211.0,
        "delta": 201895156.0
      },
      {
        "periodo": 202511,
        "valor": 6267401361.0,
        "delta": 831922150.0
      },
      {
        "periodo": 202512,
        "valor": 5886897099.0,
        "delta": -380504262.0
      },
      {
        "periodo": 202601,
        "valor": 5793895674.0,
        "delta": -93001425.0
      },
      {
        "periodo": 202602,
        "valor": 5839902300.0,
        "delta": 46006626.0
      },
      {
        "periodo": 202603,
        "valor": 6056696888.0,
        "delta": 216794588.0
      },
      {
        "periodo": 202604,
        "valor": 6233988333.0,
        "delta": 177291445.0
      },
      {
        "periodo": 202605,
        "valor": 7523569108.0,
        "delta": 1289580775.0
      },
      {
        "periodo": 202606,
        "valor": 7099336964.0,
        "delta": -424232144.0
      },
      {
        "periodo": 202607,
        "valor": 7049800943.0,
        "delta": -49536021.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 1567649235.0,
    "valor_anterior": 1583806809.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2328627738.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1857323197.0,
        "delta": -471304541.0
      },
      {
        "periodo": 202509,
        "valor": 1909901470.0,
        "delta": 52578273.0
      },
      {
        "periodo": 202510,
        "valor": 1983958437.0,
        "delta": 74056967.0
      },
      {
        "periodo": 202511,
        "valor": 1873624670.0,
        "delta": -110333767.0
      },
      {
        "periodo": 202512,
        "valor": 1684841638.0,
        "delta": -188783032.0
      },
      {
        "periodo": 202601,
        "valor": 1676102057.0,
        "delta": -8739581.0
      },
      {
        "periodo": 202602,
        "valor": 1637469272.0,
        "delta": -38632785.0
      },
      {
        "periodo": 202603,
        "valor": 1702768785.0,
        "delta": 65299513.0
      },
      {
        "periodo": 202604,
        "valor": 1773511977.0,
        "delta": 70743192.0
      },
      {
        "periodo": 202605,
        "valor": 1642453064.0,
        "delta": -131058913.0
      },
      {
        "periodo": 202606,
        "valor": 1583806809.0,
        "delta": -58646255.0
      },
      {
        "periodo": 202607,
        "valor": 1567649235.0,
        "delta": -16157574.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 593797540.48,
    "valor_anterior": 565468006.46,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 323415311.13,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 560153896.97,
        "delta": 236738585.84
      },
      {
        "periodo": 202509,
        "valor": 587348815.99,
        "delta": 27194919.02
      },
      {
        "periodo": 202510,
        "valor": 648837650.41,
        "delta": 61488834.42
      },
      {
        "periodo": 202511,
        "valor": 530310401.67,
        "delta": -118527248.74
      },
      {
        "periodo": 202512,
        "valor": 586472351.77,
        "delta": 56161950.1
      },
      {
        "periodo": 202601,
        "valor": 600435385.45,
        "delta": 13963033.68
      },
      {
        "periodo": 202602,
        "valor": 713450204.66,
        "delta": 113014819.21
      },
      {
        "periodo": 202603,
        "valor": 612851216.54,
        "delta": -100598988.12
      },
      {
        "periodo": 202604,
        "valor": 651553711.27,
        "delta": 38702494.73
      },
      {
        "periodo": 202605,
        "valor": 592957006.27,
        "delta": -58596705.0
      },
      {
        "periodo": 202606,
        "valor": 565468006.46,
        "delta": -27488999.81
      },
      {
        "periodo": 202607,
        "valor": 593797540.48,
        "delta": 28329534.02
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 180485335.0,
    "valor_anterior": 240983245.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 176189341.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 143455135.0,
        "delta": -32734206.0
      },
      {
        "periodo": 202509,
        "valor": 92482944.0,
        "delta": -50972191.0
      },
      {
        "periodo": 202510,
        "valor": 116367714.0,
        "delta": 23884770.0
      },
      {
        "periodo": 202511,
        "valor": 62363351.0,
        "delta": -54004363.0
      },
      {
        "periodo": 202512,
        "valor": 198594357.0,
        "delta": 136231006.0
      },
      {
        "periodo": 202601,
        "valor": 231259771.0,
        "delta": 32665414.0
      },
      {
        "periodo": 202602,
        "valor": 326349969.0,
        "delta": 95090198.0
      },
      {
        "periodo": 202603,
        "valor": 769245388.0,
        "delta": 442895419.0
      },
      {
        "periodo": 202604,
        "valor": 338886622.0,
        "delta": -430358766.0
      },
      {
        "periodo": 202605,
        "valor": 223345742.0,
        "delta": -115540880.0
      },
      {
        "periodo": 202606,
        "valor": 240983245.0,
        "delta": 17637503.0
      },
      {
        "periodo": 202607,
        "valor": 180485335.0,
        "delta": -60497910.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 221833151.0,
    "valor_anterior": 219627664.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 238450528.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 236478878.0,
        "delta": -1971650.0
      },
      {
        "periodo": 202509,
        "valor": 95340940.0,
        "delta": -141137938.0
      },
      {
        "periodo": 202510,
        "valor": 103749752.0,
        "delta": 8408812.0
      },
      {
        "periodo": 202511,
        "valor": 132097580.0,
        "delta": 28347828.0
      },
      {
        "periodo": 202512,
        "valor": 195081555.0,
        "delta": 62983975.0
      },
      {
        "periodo": 202601,
        "valor": 199234097.0,
        "delta": 4152542.0
      },
      {
        "periodo": 202602,
        "valor": 89243809.0,
        "delta": -109990288.0
      },
      {
        "periodo": 202603,
        "valor": 220274692.0,
        "delta": 131030883.0
      },
      {
        "periodo": 202604,
        "valor": 348994121.0,
        "delta": 128719429.0
      },
      {
        "periodo": 202605,
        "valor": 289750378.0,
        "delta": -59243743.0
      },
      {
        "periodo": 202606,
        "valor": 219627664.0,
        "delta": -70122714.0
      },
      {
        "periodo": 202607,
        "valor": 221833151.0,
        "delta": 2205487.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 1394063826.0,
    "valor_anterior": 1875774321.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1212784083.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1271610560.0,
        "delta": 58826477.0
      },
      {
        "periodo": 202509,
        "valor": 1298116443.0,
        "delta": 26505883.0
      },
      {
        "periodo": 202510,
        "valor": 1343054261.0,
        "delta": 44937818.0
      },
      {
        "periodo": 202511,
        "valor": 1469712758.0,
        "delta": 126658497.0
      },
      {
        "periodo": 202512,
        "valor": 1287789931.0,
        "delta": -181922827.0
      },
      {
        "periodo": 202601,
        "valor": 1227294595.0,
        "delta": -60495336.0
      },
      {
        "periodo": 202602,
        "valor": 1219684221.0,
        "delta": -7610374.0
      },
      {
        "periodo": 202603,
        "valor": 1172452882.0,
        "delta": -47231339.0
      },
      {
        "periodo": 202604,
        "valor": 1874188699.0,
        "delta": 701735817.0
      },
      {
        "periodo": 202605,
        "valor": 1864385054.0,
        "delta": -9803645.0
      },
      {
        "periodo": 202606,
        "valor": 1875774321.0,
        "delta": 11389267.0
      },
      {
        "periodo": 202607,
        "valor": 1394063826.0,
        "delta": -481710495.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 579708017.8,
    "valor_anterior": 541378201.1,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 540318317.61,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 534184018.81,
        "delta": -6134298.8
      },
      {
        "periodo": 202509,
        "valor": 508767047.78,
        "delta": -25416971.03
      },
      {
        "periodo": 202510,
        "valor": 551237655.11,
        "delta": 42470607.33
      },
      {
        "periodo": 202511,
        "valor": 575975301.88,
        "delta": 24737646.77
      },
      {
        "periodo": 202512,
        "valor": 569367072.51,
        "delta": -6608229.37
      },
      {
        "periodo": 202601,
        "valor": 584571390.19,
        "delta": 15204317.68
      },
      {
        "periodo": 202602,
        "valor": 522262696.73,
        "delta": -62308693.46
      },
      {
        "periodo": 202603,
        "valor": 474867354.42,
        "delta": -47395342.31
      },
      {
        "periodo": 202604,
        "valor": 491523213.79,
        "delta": 16655859.37
      },
      {
        "periodo": 202605,
        "valor": 529509808.81,
        "delta": 37986595.02
      },
      {
        "periodo": 202606,
        "valor": 541378201.1,
        "delta": 11868392.29
      },
      {
        "periodo": 202607,
        "valor": 579708017.8,
        "delta": 38329816.7
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 683729334.0,
    "valor_anterior": 632885088.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 541292248.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 484633115.0,
        "delta": -56659133.0
      },
      {
        "periodo": 202509,
        "valor": 570108132.0,
        "delta": 85475017.0
      },
      {
        "periodo": 202510,
        "valor": 568133246.0,
        "delta": -1974886.0
      },
      {
        "periodo": 202511,
        "valor": 624256916.0,
        "delta": 56123670.0
      },
      {
        "periodo": 202512,
        "valor": 683592612.0,
        "delta": 59335696.0
      },
      {
        "periodo": 202601,
        "valor": 641649332.0,
        "delta": -41943280.0
      },
      {
        "periodo": 202602,
        "valor": 646212630.0,
        "delta": 4563298.0
      },
      {
        "periodo": 202603,
        "valor": 586641166.0,
        "delta": -59571464.0
      },
      {
        "periodo": 202604,
        "valor": 663180636.0,
        "delta": 76539470.0
      },
      {
        "periodo": 202605,
        "valor": 616218977.0,
        "delta": -46961659.0
      },
      {
        "periodo": 202606,
        "valor": 632885088.0,
        "delta": 16666111.0
      },
      {
        "periodo": 202607,
        "valor": 683729334.0,
        "delta": 50844246.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 208256075.0,
    "valor_anterior": 212096153.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 503417942.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 484642126.0,
        "delta": -18775816.0
      },
      {
        "periodo": 202509,
        "valor": 485122109.0,
        "delta": 479983.0
      },
      {
        "periodo": 202510,
        "valor": 417157373.0,
        "delta": -67964736.0
      },
      {
        "periodo": 202511,
        "valor": 409011030.0,
        "delta": -8146343.0
      },
      {
        "periodo": 202512,
        "valor": 409195783.0,
        "delta": 184753.0
      },
      {
        "periodo": 202601,
        "valor": 467321944.0,
        "delta": 58126161.0
      },
      {
        "periodo": 202602,
        "valor": 290976356.0,
        "delta": -176345588.0
      },
      {
        "periodo": 202603,
        "valor": 118758263.0,
        "delta": -172218093.0
      },
      {
        "periodo": 202604,
        "valor": 327898594.0,
        "delta": 209140331.0
      },
      {
        "periodo": 202605,
        "valor": 191496498.0,
        "delta": -136402096.0
      },
      {
        "periodo": 202606,
        "valor": 212096153.0,
        "delta": 20599655.0
      },
      {
        "periodo": 202607,
        "valor": 208256075.0,
        "delta": -3840078.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 431949264.0,
    "valor_anterior": 393700625.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 382037706.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 357701257.0,
        "delta": -24336449.0
      },
      {
        "periodo": 202509,
        "valor": 366321395.0,
        "delta": 8620138.0
      },
      {
        "periodo": 202510,
        "valor": 371081502.0,
        "delta": 4760107.0
      },
      {
        "periodo": 202511,
        "valor": 373845184.0,
        "delta": 2763682.0
      },
      {
        "periodo": 202512,
        "valor": 363648321.0,
        "delta": -10196863.0
      },
      {
        "periodo": 202601,
        "valor": 347853826.0,
        "delta": -15794495.0
      },
      {
        "periodo": 202602,
        "valor": 358386915.0,
        "delta": 10533089.0
      },
      {
        "periodo": 202603,
        "valor": 372075995.0,
        "delta": 13689080.0
      },
      {
        "periodo": 202604,
        "valor": 348310494.0,
        "delta": -23765501.0
      },
      {
        "periodo": 202605,
        "valor": 399799295.0,
        "delta": 51488801.0
      },
      {
        "periodo": 202606,
        "valor": 393700625.0,
        "delta": -6098670.0
      },
      {
        "periodo": 202607,
        "valor": 431949264.0,
        "delta": 38248639.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 1984674338.94,
    "valor_anterior": 2002512934.93,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1593170952.55,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1656231521.76,
        "delta": 63060569.21
      },
      {
        "periodo": 202509,
        "valor": 1790605951.2,
        "delta": 134374429.44
      },
      {
        "periodo": 202510,
        "valor": 1901217202.67,
        "delta": 110611251.47
      },
      {
        "periodo": 202511,
        "valor": 1798883219.08,
        "delta": -102333983.59
      },
      {
        "periodo": 202512,
        "valor": 1822798177.65,
        "delta": 23914958.57
      },
      {
        "periodo": 202601,
        "valor": 1764103018.45,
        "delta": -58695159.2
      },
      {
        "periodo": 202602,
        "valor": 1767999330.78,
        "delta": 3896312.33
      },
      {
        "periodo": 202603,
        "valor": 1939560653.4,
        "delta": 171561322.62
      },
      {
        "periodo": 202604,
        "valor": 2020465124.73,
        "delta": 80904471.33
      },
      {
        "periodo": 202605,
        "valor": 1965958770.21,
        "delta": -54506354.52
      },
      {
        "periodo": 202606,
        "valor": 2002512934.93,
        "delta": 36554164.72
      },
      {
        "periodo": 202607,
        "valor": 1984674338.94,
        "delta": -17838595.99
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 1475545.0,
    "valor_anterior": 1507174.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": 64217.0,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 25724.0,
        "delta": -38493.0
      },
      {
        "periodo": 202512,
        "valor": 14693.0,
        "delta": -11031.0
      },
      {
        "periodo": 202601,
        "valor": 22973.0,
        "delta": 8280.0
      },
      {
        "periodo": 202602,
        "valor": 1695.0,
        "delta": -21278.0
      },
      {
        "periodo": 202603,
        "valor": 492035.0,
        "delta": 490340.0
      },
      {
        "periodo": 202604,
        "valor": 1352211.0,
        "delta": 860176.0
      },
      {
        "periodo": 202605,
        "valor": 1472801.0,
        "delta": 120590.0
      },
      {
        "periodo": 202606,
        "valor": 1507174.0,
        "delta": 34373.0
      },
      {
        "periodo": 202607,
        "valor": 1475545.0,
        "delta": -31629.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 22981201.27,
    "valor_anterior": 11480525.77,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9575384.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9168220.12,
        "delta": -407164.41
      },
      {
        "periodo": 202509,
        "valor": 12200314.98,
        "delta": 3032094.86
      },
      {
        "periodo": 202510,
        "valor": 20060039.76,
        "delta": 7859724.78
      },
      {
        "periodo": 202511,
        "valor": 15054945.64,
        "delta": -5005094.12
      },
      {
        "periodo": 202512,
        "valor": 21116003.42,
        "delta": 6061057.78
      },
      {
        "periodo": 202601,
        "valor": 27732171.56,
        "delta": 6616168.14
      },
      {
        "periodo": 202602,
        "valor": 30440078.61,
        "delta": 2707907.05
      },
      {
        "periodo": 202603,
        "valor": 25929840.14,
        "delta": -4510238.47
      },
      {
        "periodo": 202604,
        "valor": 27571423.48,
        "delta": 1641583.34
      },
      {
        "periodo": 202605,
        "valor": 10120097.04,
        "delta": -17451326.44
      },
      {
        "periodo": 202606,
        "valor": 11480525.77,
        "delta": 1360428.73
      },
      {
        "periodo": 202607,
        "valor": 22981201.27,
        "delta": 11500675.5
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 373279684.0,
    "valor_anterior": 335378087.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 359356871.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 424823392.0,
        "delta": 65466521.0
      },
      {
        "periodo": 202509,
        "valor": 441940882.0,
        "delta": 17117490.0
      },
      {
        "periodo": 202510,
        "valor": 445678889.0,
        "delta": 3738007.0
      },
      {
        "periodo": 202511,
        "valor": 366126705.0,
        "delta": -79552184.0
      },
      {
        "periodo": 202512,
        "valor": 332407079.0,
        "delta": -33719626.0
      },
      {
        "periodo": 202601,
        "valor": 356183675.0,
        "delta": 23776596.0
      },
      {
        "periodo": 202602,
        "valor": 442769980.0,
        "delta": 86586305.0
      },
      {
        "periodo": 202603,
        "valor": 350285725.0,
        "delta": -92484255.0
      },
      {
        "periodo": 202604,
        "valor": 338764094.0,
        "delta": -11521631.0
      },
      {
        "periodo": 202605,
        "valor": 347231250.0,
        "delta": 8467156.0
      },
      {
        "periodo": 202606,
        "valor": 335378087.0,
        "delta": -11853163.0
      },
      {
        "periodo": 202607,
        "valor": 373279684.0,
        "delta": 37901597.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 8020273.59,
    "valor_anterior": 7770122.26,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8184201.02,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7286780.2,
        "delta": -897420.82
      },
      {
        "periodo": 202509,
        "valor": 9247765.7,
        "delta": 1960985.5
      },
      {
        "periodo": 202510,
        "valor": 7316201.25,
        "delta": -1931564.45
      },
      {
        "periodo": 202511,
        "valor": 13612087.33,
        "delta": 6295886.08
      },
      {
        "periodo": 202512,
        "valor": 25319394.39,
        "delta": 11707307.06
      },
      {
        "periodo": 202601,
        "valor": 6976530.06,
        "delta": -18342864.33
      },
      {
        "periodo": 202602,
        "valor": 6364085.33,
        "delta": -612444.73
      },
      {
        "periodo": 202603,
        "valor": 5641757.05,
        "delta": -722328.28
      },
      {
        "periodo": 202604,
        "valor": 4991236.53,
        "delta": -650520.52
      },
      {
        "periodo": 202605,
        "valor": 4433392.74,
        "delta": -557843.79
      },
      {
        "periodo": 202606,
        "valor": 7770122.26,
        "delta": 3336729.52
      },
      {
        "periodo": 202607,
        "valor": 8020273.59,
        "delta": 250151.33
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 3184538347.23,
    "valor_anterior": 3133311937.6800003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3058225342.59,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3812915187.14,
        "delta": 754689844.55
      },
      {
        "periodo": 202509,
        "valor": 4377510392.45,
        "delta": 564595205.31
      },
      {
        "periodo": 202510,
        "valor": 3908600609.54,
        "delta": -468909782.91
      },
      {
        "periodo": 202511,
        "valor": 3298114721.14,
        "delta": -610485888.4
      },
      {
        "periodo": 202512,
        "valor": 2962933390.86,
        "delta": -335181330.28
      },
      {
        "periodo": 202601,
        "valor": 2895677352.48,
        "delta": -67256038.38
      },
      {
        "periodo": 202602,
        "valor": 3044325107.03,
        "delta": 148647754.55
      },
      {
        "periodo": 202603,
        "valor": 3105299529.51,
        "delta": 60974422.48
      },
      {
        "periodo": 202604,
        "valor": 3024942486.99,
        "delta": -80357042.52
      },
      {
        "periodo": 202605,
        "valor": 3073956449.61,
        "delta": 49013962.62
      },
      {
        "periodo": 202606,
        "valor": 3133311937.68,
        "delta": 59355488.07
      },
      {
        "periodo": 202607,
        "valor": 3184538347.23,
        "delta": 51226409.55
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 128395924.35,
    "valor_anterior": 101333481.32,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 32913043.05,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 68045141.87,
        "delta": 35132098.82
      },
      {
        "periodo": 202509,
        "valor": 63906814.86,
        "delta": -4138327.01
      },
      {
        "periodo": 202510,
        "valor": 49361984.79,
        "delta": -14544830.07
      },
      {
        "periodo": 202511,
        "valor": 95629889.52,
        "delta": 46267904.73
      },
      {
        "periodo": 202512,
        "valor": 63516436.54,
        "delta": -32113452.98
      },
      {
        "periodo": 202601,
        "valor": 71976186.93,
        "delta": 8459750.39
      },
      {
        "periodo": 202602,
        "valor": 59742250.8,
        "delta": -12233936.13
      },
      {
        "periodo": 202603,
        "valor": 52678751.43,
        "delta": -7063499.37
      },
      {
        "periodo": 202604,
        "valor": 52197631.72,
        "delta": -481119.71
      },
      {
        "periodo": 202605,
        "valor": 27898991.15,
        "delta": -24298640.57
      },
      {
        "periodo": 202606,
        "valor": 101333481.32,
        "delta": 73434490.17
      },
      {
        "periodo": 202607,
        "valor": 128395924.35,
        "delta": 27062443.03
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 1270988236.0,
    "valor_anterior": 1267152413.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 724761165.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 830550490.0,
        "delta": 105789325.0
      },
      {
        "periodo": 202509,
        "valor": 918820192.0,
        "delta": 88269702.0
      },
      {
        "periodo": 202510,
        "valor": 1039006046.0,
        "delta": 120185854.0
      },
      {
        "periodo": 202511,
        "valor": 1165099637.0,
        "delta": 126093591.0
      },
      {
        "periodo": 202512,
        "valor": 1171969337.0,
        "delta": 6869700.0
      },
      {
        "periodo": 202601,
        "valor": 1227537295.0,
        "delta": 55567958.0
      },
      {
        "periodo": 202602,
        "valor": 1125644070.0,
        "delta": -101893225.0
      },
      {
        "periodo": 202603,
        "valor": 1127376134.0,
        "delta": 1732064.0
      },
      {
        "periodo": 202604,
        "valor": 1172220149.0,
        "delta": 44844015.0
      },
      {
        "periodo": 202605,
        "valor": 1191719013.0,
        "delta": 19498864.0
      },
      {
        "periodo": 202606,
        "valor": 1267152413.0,
        "delta": 75433400.0
      },
      {
        "periodo": 202607,
        "valor": 1270988236.0,
        "delta": 3835823.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 117123500.0,
    "valor_anterior": 107014935.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 32133892.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 60627633.0,
        "delta": 28493741.0
      },
      {
        "periodo": 202509,
        "valor": 36923479.0,
        "delta": -23704154.0
      },
      {
        "periodo": 202510,
        "valor": 61028560.0,
        "delta": 24105081.0
      },
      {
        "periodo": 202511,
        "valor": 64022749.0,
        "delta": 2994189.0
      },
      {
        "periodo": 202512,
        "valor": 88120510.0,
        "delta": 24097761.0
      },
      {
        "periodo": 202601,
        "valor": 77136992.0,
        "delta": -10983518.0
      },
      {
        "periodo": 202602,
        "valor": 122253356.0,
        "delta": 45116364.0
      },
      {
        "periodo": 202603,
        "valor": 160572357.0,
        "delta": 38319001.0
      },
      {
        "periodo": 202604,
        "valor": 191927820.0,
        "delta": 31355463.0
      },
      {
        "periodo": 202605,
        "valor": 134162223.0,
        "delta": -57765597.0
      },
      {
        "periodo": 202606,
        "valor": 107014935.0,
        "delta": -27147288.0
      },
      {
        "periodo": 202607,
        "valor": 117123500.0,
        "delta": 10108565.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 17341842.0,
    "valor_anterior": 7036009.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 29955519.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 42848120.0,
        "delta": 12892601.0
      },
      {
        "periodo": 202509,
        "valor": 7665549.0,
        "delta": -35182571.0
      },
      {
        "periodo": 202510,
        "valor": 4682781.0,
        "delta": -2982768.0
      },
      {
        "periodo": 202511,
        "valor": 3660167.0,
        "delta": -1022614.0
      },
      {
        "periodo": 202512,
        "valor": 42720404.0,
        "delta": 39060237.0
      },
      {
        "periodo": 202601,
        "valor": 58892243.0,
        "delta": 16171839.0
      },
      {
        "periodo": 202602,
        "valor": 8953806.0,
        "delta": -49938437.0
      },
      {
        "periodo": 202603,
        "valor": 14325898.0,
        "delta": 5372092.0
      },
      {
        "periodo": 202604,
        "valor": 14791819.0,
        "delta": 465921.0
      },
      {
        "periodo": 202605,
        "valor": 6493048.0,
        "delta": -8298771.0
      },
      {
        "periodo": 202606,
        "valor": 7036009.0,
        "delta": 542961.0
      },
      {
        "periodo": 202607,
        "valor": 17341842.0,
        "delta": 10305833.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 60707915.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 66297349.0,
        "delta": 5589434.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 920544113.04,
    "valor_anterior": 855899904.09,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 692709274.47,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 738890141.91,
        "delta": 46180867.44
      },
      {
        "periodo": 202509,
        "valor": 771991612.91,
        "delta": 33101471.0
      },
      {
        "periodo": 202510,
        "valor": 850239246.89,
        "delta": 78247633.98
      },
      {
        "periodo": 202511,
        "valor": 850338594.56,
        "delta": 99347.67
      },
      {
        "periodo": 202512,
        "valor": 880162651.94,
        "delta": 29824057.38
      },
      {
        "periodo": 202601,
        "valor": 798857657.37,
        "delta": -81304994.57
      },
      {
        "periodo": 202602,
        "valor": 828214264.46,
        "delta": 29356607.09
      },
      {
        "periodo": 202603,
        "valor": 970187378.61,
        "delta": 141973114.15
      },
      {
        "periodo": 202604,
        "valor": 1064011930.69,
        "delta": 93824552.08
      },
      {
        "periodo": 202605,
        "valor": 905795437.29,
        "delta": -158216493.4
      },
      {
        "periodo": 202606,
        "valor": 855899904.09,
        "delta": -49895533.2
      },
      {
        "periodo": 202607,
        "valor": 920544113.04,
        "delta": 64644208.95
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 64990186.0,
    "valor_anterior": 56981013.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 31149662.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 36973385.0,
        "delta": 5823723.0
      },
      {
        "periodo": 202509,
        "valor": 36600445.0,
        "delta": -372940.0
      },
      {
        "periodo": 202510,
        "valor": 40962475.0,
        "delta": 4362030.0
      },
      {
        "periodo": 202511,
        "valor": 46764683.0,
        "delta": 5802208.0
      },
      {
        "periodo": 202512,
        "valor": 46804079.0,
        "delta": 39396.0
      },
      {
        "periodo": 202601,
        "valor": 44136568.0,
        "delta": -2667511.0
      },
      {
        "periodo": 202602,
        "valor": 45042467.0,
        "delta": 905899.0
      },
      {
        "periodo": 202603,
        "valor": 49552797.0,
        "delta": 4510330.0
      },
      {
        "periodo": 202604,
        "valor": 52658246.0,
        "delta": 3105449.0
      },
      {
        "periodo": 202605,
        "valor": 53051484.0,
        "delta": 393238.0
      },
      {
        "periodo": 202606,
        "valor": 56981013.0,
        "delta": 3929529.0
      },
      {
        "periodo": 202607,
        "valor": 64990186.0,
        "delta": 8009173.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 182942657.0,
    "valor_anterior": 189082040.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 147760176.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 155137435.0,
        "delta": 7377259.0
      },
      {
        "periodo": 202509,
        "valor": 152294715.0,
        "delta": -2842720.0
      },
      {
        "periodo": 202510,
        "valor": 151079641.0,
        "delta": -1215074.0
      },
      {
        "periodo": 202511,
        "valor": 151334088.0,
        "delta": 254447.0
      },
      {
        "periodo": 202512,
        "valor": 149830573.0,
        "delta": -1503515.0
      },
      {
        "periodo": 202601,
        "valor": 160059188.0,
        "delta": 10228615.0
      },
      {
        "periodo": 202602,
        "valor": 153915702.0,
        "delta": -6143486.0
      },
      {
        "periodo": 202603,
        "valor": 148230563.0,
        "delta": -5685139.0
      },
      {
        "periodo": 202604,
        "valor": 164639186.0,
        "delta": 16408623.0
      },
      {
        "periodo": 202605,
        "valor": 167266528.0,
        "delta": 2627342.0
      },
      {
        "periodo": 202606,
        "valor": 189082040.0,
        "delta": 21815512.0
      },
      {
        "periodo": 202607,
        "valor": 182942657.0,
        "delta": -6139383.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 29992699.0,
    "valor_anterior": 33573883.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20090947.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19663795.0,
        "delta": -427152.0
      },
      {
        "periodo": 202509,
        "valor": 22428558.0,
        "delta": 2764763.0
      },
      {
        "periodo": 202510,
        "valor": 24554053.0,
        "delta": 2125495.0
      },
      {
        "periodo": 202511,
        "valor": 27081597.0,
        "delta": 2527544.0
      },
      {
        "periodo": 202512,
        "valor": 13785558.0,
        "delta": -13296039.0
      },
      {
        "periodo": 202601,
        "valor": 30211527.0,
        "delta": 16425969.0
      },
      {
        "periodo": 202602,
        "valor": 37690128.0,
        "delta": 7478601.0
      },
      {
        "periodo": 202603,
        "valor": 36135634.0,
        "delta": -1554494.0
      },
      {
        "periodo": 202604,
        "valor": 35372950.0,
        "delta": -762684.0
      },
      {
        "periodo": 202605,
        "valor": 35674517.0,
        "delta": 301567.0
      },
      {
        "periodo": 202606,
        "valor": 33573883.0,
        "delta": -2100634.0
      },
      {
        "periodo": 202607,
        "valor": 29992699.0,
        "delta": -3581184.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40109000.49,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25185460.98,
        "delta": -14923539.51
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 7709354.0,
    "valor_anterior": 2282313.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15077054.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14439859.0,
        "delta": -637195.0
      },
      {
        "periodo": 202509,
        "valor": 13774378.0,
        "delta": -665481.0
      },
      {
        "periodo": 202510,
        "valor": 10704232.0,
        "delta": -3070146.0
      },
      {
        "periodo": 202511,
        "valor": 12980637.0,
        "delta": 2276405.0
      },
      {
        "periodo": 202512,
        "valor": 11766807.0,
        "delta": -1213830.0
      },
      {
        "periodo": 202601,
        "valor": 7478082.0,
        "delta": -4288725.0
      },
      {
        "periodo": 202602,
        "valor": 2581150.0,
        "delta": -4896932.0
      },
      {
        "periodo": 202603,
        "valor": 9981054.0,
        "delta": 7399904.0
      },
      {
        "periodo": 202604,
        "valor": 9741932.0,
        "delta": -239122.0
      },
      {
        "periodo": 202605,
        "valor": 2900567.0,
        "delta": -6841365.0
      },
      {
        "periodo": 202606,
        "valor": 2282313.0,
        "delta": -618254.0
      },
      {
        "periodo": 202607,
        "valor": 7709354.0,
        "delta": 5427041.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 17852501.79,
    "valor_anterior": 10857320.16,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1590817.7,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5517932.32,
        "delta": 3927114.62
      },
      {
        "periodo": 202509,
        "valor": 6104478.22,
        "delta": 586545.9
      },
      {
        "periodo": 202510,
        "valor": 55979.68,
        "delta": -6048498.54
      },
      {
        "periodo": 202511,
        "valor": 2767961.88,
        "delta": 2711982.2
      },
      {
        "periodo": 202512,
        "valor": 16856251.49,
        "delta": 14088289.61
      },
      {
        "periodo": 202601,
        "valor": 1633096.58,
        "delta": -15223154.91
      },
      {
        "periodo": 202602,
        "valor": 54807.24,
        "delta": -1578289.34
      },
      {
        "periodo": 202603,
        "valor": 12142316.47,
        "delta": 12087509.23
      },
      {
        "periodo": 202604,
        "valor": 13432090.09,
        "delta": 1289773.62
      },
      {
        "periodo": 202605,
        "valor": 16560138.48,
        "delta": 3128048.39
      },
      {
        "periodo": 202606,
        "valor": 10857320.16,
        "delta": -5702818.32
      },
      {
        "periodo": 202607,
        "valor": 17852501.79,
        "delta": 6995181.63
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 11345369.0,
    "valor_anterior": 11951737.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6302811.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5781485.0,
        "delta": -521326.0
      },
      {
        "periodo": 202509,
        "valor": 6218169.0,
        "delta": 436684.0
      },
      {
        "periodo": 202510,
        "valor": 11496954.0,
        "delta": 5278785.0
      },
      {
        "periodo": 202511,
        "valor": 11986125.0,
        "delta": 489171.0
      },
      {
        "periodo": 202512,
        "valor": 11388241.0,
        "delta": -597884.0
      },
      {
        "periodo": 202601,
        "valor": 11681624.0,
        "delta": 293383.0
      },
      {
        "periodo": 202602,
        "valor": 13044429.0,
        "delta": 1362805.0
      },
      {
        "periodo": 202603,
        "valor": 10697921.0,
        "delta": -2346508.0
      },
      {
        "periodo": 202604,
        "valor": 13613149.0,
        "delta": 2915228.0
      },
      {
        "periodo": 202605,
        "valor": 12888296.0,
        "delta": -724853.0
      },
      {
        "periodo": 202606,
        "valor": 11951737.0,
        "delta": -936559.0
      },
      {
        "periodo": 202607,
        "valor": 11345369.0,
        "delta": -606368.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 16545771.34,
    "valor_anterior": 22872533.88,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14789945.73,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14359665.46,
        "delta": -430280.27
      },
      {
        "periodo": 202509,
        "valor": 10055721.54,
        "delta": -4303943.92
      },
      {
        "periodo": 202510,
        "valor": 10120371.72,
        "delta": 64650.18
      },
      {
        "periodo": 202511,
        "valor": 7546618.75,
        "delta": -2573752.97
      },
      {
        "periodo": 202512,
        "valor": 2334946.07,
        "delta": -5211672.68
      },
      {
        "periodo": 202601,
        "valor": 8233650.02,
        "delta": 5898703.95
      },
      {
        "periodo": 202602,
        "valor": 8597855.43,
        "delta": 364205.41
      },
      {
        "periodo": 202603,
        "valor": 9821238.46,
        "delta": 1223383.03
      },
      {
        "periodo": 202604,
        "valor": 10378148.01,
        "delta": 556909.55
      },
      {
        "periodo": 202605,
        "valor": 23540531.97,
        "delta": 13162383.96
      },
      {
        "periodo": 202606,
        "valor": 22872533.88,
        "delta": -667998.09
      },
      {
        "periodo": 202607,
        "valor": 16545771.34,
        "delta": -6326762.54
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 102785.0,
    "valor_anterior": 116266.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2691707.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2479125.0,
        "delta": -212582.0
      },
      {
        "periodo": 202509,
        "valor": 2263796.0,
        "delta": -215329.0
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 139741.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 128564.0,
        "delta": -11177.0
      },
      {
        "periodo": 202605,
        "valor": 129566.0,
        "delta": 1002.0
      },
      {
        "periodo": 202606,
        "valor": 116266.0,
        "delta": -13300.0
      },
      {
        "periodo": 202607,
        "valor": 102785.0,
        "delta": -13481.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 103312629.39,
    "valor_anterior": 80657148.85,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 153748833.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 104471652.84,
        "delta": -49277180.81
      },
      {
        "periodo": 202509,
        "valor": 107646850.64,
        "delta": 3175197.8
      },
      {
        "periodo": 202510,
        "valor": 66210717.39,
        "delta": -41436133.25
      },
      {
        "periodo": 202511,
        "valor": 67408140.28,
        "delta": 1197422.89
      },
      {
        "periodo": 202512,
        "valor": 81290469.78,
        "delta": 13882329.5
      },
      {
        "periodo": 202601,
        "valor": 68940906.41,
        "delta": -12349563.37
      },
      {
        "periodo": 202602,
        "valor": 102057639.72,
        "delta": 33116733.31
      },
      {
        "periodo": 202603,
        "valor": 72975247.04,
        "delta": -29082392.68
      },
      {
        "periodo": 202604,
        "valor": 67454729.91,
        "delta": -5520517.13
      },
      {
        "periodo": 202605,
        "valor": 72505356.09,
        "delta": 5050626.18
      },
      {
        "periodo": 202606,
        "valor": 80657148.85,
        "delta": 8151792.76
      },
      {
        "periodo": 202607,
        "valor": 103312629.39,
        "delta": 22655480.54
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 32789082.23,
    "valor_anterior": 29755218.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15038303.4,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17630652.88,
        "delta": 2592349.48
      },
      {
        "periodo": 202509,
        "valor": 17708720.44,
        "delta": 78067.56
      },
      {
        "periodo": 202510,
        "valor": 21567027.97,
        "delta": 3858307.53
      },
      {
        "periodo": 202511,
        "valor": 24741570.35,
        "delta": 3174542.38
      },
      {
        "periodo": 202512,
        "valor": 24270162.91,
        "delta": -471407.44
      },
      {
        "periodo": 202601,
        "valor": 16501560.93,
        "delta": -7768601.98
      },
      {
        "periodo": 202602,
        "valor": 13542868.52,
        "delta": -2958692.41
      },
      {
        "periodo": 202603,
        "valor": 11362307.33,
        "delta": -2180561.19
      },
      {
        "periodo": 202604,
        "valor": 21403307.9,
        "delta": 10041000.57
      },
      {
        "periodo": 202605,
        "valor": 17247156.1,
        "delta": -4156151.8
      },
      {
        "periodo": 202606,
        "valor": 29755218.2,
        "delta": 12508062.1
      },
      {
        "periodo": 202607,
        "valor": 32789082.23,
        "delta": 3033864.03
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 32147864.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 31732612.0,
        "delta": -415252.0
      },
      {
        "periodo": 202509,
        "valor": 30001226.0,
        "delta": -1731386.0
      },
      {
        "periodo": 202510,
        "valor": 30399879.0,
        "delta": 398653.0
      },
      {
        "periodo": 202511,
        "valor": 30165665.0,
        "delta": -234214.0
      },
      {
        "periodo": 202512,
        "valor": 29934989.0,
        "delta": -230676.0
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 58651208.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 24472177.0,
    "valor_anterior": 20540771.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 34456791.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28920176.0,
        "delta": -5536615.0
      },
      {
        "periodo": 202509,
        "valor": 42508402.0,
        "delta": 13588226.0
      },
      {
        "periodo": 202510,
        "valor": 42353328.0,
        "delta": -155074.0
      },
      {
        "periodo": 202511,
        "valor": 40592663.0,
        "delta": -1760665.0
      },
      {
        "periodo": 202512,
        "valor": 49936611.0,
        "delta": 9343948.0
      },
      {
        "periodo": 202601,
        "valor": 36515850.0,
        "delta": -13420761.0
      },
      {
        "periodo": 202602,
        "valor": 43758990.0,
        "delta": 7243140.0
      },
      {
        "periodo": 202603,
        "valor": 41311232.0,
        "delta": -2447758.0
      },
      {
        "periodo": 202604,
        "valor": 44497054.0,
        "delta": 3185822.0
      },
      {
        "periodo": 202605,
        "valor": 46430863.0,
        "delta": 1933809.0
      },
      {
        "periodo": 202606,
        "valor": 20540771.0,
        "delta": -25890092.0
      },
      {
        "periodo": 202607,
        "valor": 24472177.0,
        "delta": 3931406.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 2118.36,
    "valor_anterior": 15782.55,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 795170.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 478484.08,
        "delta": -316686.07
      },
      {
        "periodo": 202509,
        "valor": 253314.87,
        "delta": -225169.21
      },
      {
        "periodo": 202510,
        "valor": 144396.08,
        "delta": -108918.79
      },
      {
        "periodo": 202511,
        "valor": 172914.18,
        "delta": 28518.1
      },
      {
        "periodo": 202512,
        "valor": 41739.88,
        "delta": -131174.3
      },
      {
        "periodo": 202601,
        "valor": 42080.87,
        "delta": 340.99
      },
      {
        "periodo": 202602,
        "valor": 45068.46,
        "delta": 2987.59
      },
      {
        "periodo": 202603,
        "valor": 50505.78,
        "delta": 5437.32
      },
      {
        "periodo": 202604,
        "valor": 5608.31,
        "delta": -44897.47
      },
      {
        "periodo": 202605,
        "valor": 13587.01,
        "delta": 7978.7
      },
      {
        "periodo": 202606,
        "valor": 15782.55,
        "delta": 2195.54
      },
      {
        "periodo": 202607,
        "valor": 2118.36,
        "delta": -13664.19
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 111422379.9,
    "valor_anterior": 109863416.43,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 88233268.52,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 94991303.06,
        "delta": 6758034.54
      },
      {
        "periodo": 202604,
        "valor": 108815993.54,
        "delta": 13824690.48
      },
      {
        "periodo": 202605,
        "valor": 111876461.15,
        "delta": 3060467.61
      },
      {
        "periodo": 202606,
        "valor": 109863416.43,
        "delta": -2013044.72
      },
      {
        "periodo": 202607,
        "valor": 111422379.9,
        "delta": 1558963.47
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 26838800.0,
    "valor_anterior": 26709328.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6145608.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14404020.0,
        "delta": 8258412.0
      },
      {
        "periodo": 202509,
        "valor": 24288910.0,
        "delta": 9884890.0
      },
      {
        "periodo": 202510,
        "valor": 27862321.0,
        "delta": 3573411.0
      },
      {
        "periodo": 202511,
        "valor": 26055558.0,
        "delta": -1806763.0
      },
      {
        "periodo": 202512,
        "valor": 21409622.0,
        "delta": -4645936.0
      },
      {
        "periodo": 202601,
        "valor": 18618720.0,
        "delta": -2790902.0
      },
      {
        "periodo": 202602,
        "valor": 22345315.0,
        "delta": 3726595.0
      },
      {
        "periodo": 202603,
        "valor": 23573103.0,
        "delta": 1227788.0
      },
      {
        "periodo": 202604,
        "valor": 26833992.0,
        "delta": 3260889.0
      },
      {
        "periodo": 202605,
        "valor": 27577955.0,
        "delta": 743963.0
      },
      {
        "periodo": 202606,
        "valor": 26709328.0,
        "delta": -868627.0
      },
      {
        "periodo": 202607,
        "valor": 26838800.0,
        "delta": 129472.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 1613736.0,
    "valor_anterior": 545884.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 3772.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 4518.0,
        "delta": 746.0
      },
      {
        "periodo": 202603,
        "valor": 57058.0,
        "delta": 52540.0
      },
      {
        "periodo": 202604,
        "valor": 156381.0,
        "delta": 99323.0
      },
      {
        "periodo": 202605,
        "valor": 118635.0,
        "delta": -37746.0
      },
      {
        "periodo": 202606,
        "valor": 545884.0,
        "delta": 427249.0
      },
      {
        "periodo": 202607,
        "valor": 1613736.0,
        "delta": 1067852.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 394939891.0,
    "valor_anterior": 356600482.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 302083628.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 348161692.0,
        "delta": 46078064.0
      },
      {
        "periodo": 202605,
        "valor": 351420381.0,
        "delta": 3258689.0
      },
      {
        "periodo": 202606,
        "valor": 356600482.0,
        "delta": 5180101.0
      },
      {
        "periodo": 202607,
        "valor": 394939891.0,
        "delta": 38339409.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 111800304002,
    "label": "EPRC Etapa 2",
    "valor_actual": 35285846201.22,
    "valor_anterior": 35406683656.07,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26739268222.34,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28119910139.08,
        "delta": 1380641916.74
      },
      {
        "periodo": 202509,
        "valor": 29174533494.74,
        "delta": 1054623355.66
      },
      {
        "periodo": 202510,
        "valor": 29725531723.12,
        "delta": 550998228.38
      },
      {
        "periodo": 202511,
        "valor": 30149848235.6,
        "delta": 424316512.48
      },
      {
        "periodo": 202512,
        "valor": 28666709254.3,
        "delta": -1483138981.3
      },
      {
        "periodo": 202601,
        "valor": 28327158951.41,
        "delta": -339550302.89
      },
      {
        "periodo": 202602,
        "valor": 32417930246.15,
        "delta": 4090771294.74
      },
      {
        "periodo": 202603,
        "valor": 34438137706.6,
        "delta": 2020207460.45
      },
      {
        "periodo": 202604,
        "valor": 35627224905.06,
        "delta": 1189087198.46
      },
      {
        "periodo": 202605,
        "valor": 36043904083.9,
        "delta": 416679178.84
      },
      {
        "periodo": 202606,
        "valor": 35406683656.07,
        "delta": -637220427.83
      },
      {
        "periodo": 202607,
        "valor": 35285846201.22,
        "delta": -120837454.85
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 10218601831.51,
    "valor_anterior": 10182959763.470001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5279891655.63,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5226401519.36,
        "delta": -53490136.27
      },
      {
        "periodo": 202509,
        "valor": 5362113394.02,
        "delta": 135711874.66
      },
      {
        "periodo": 202510,
        "valor": 5537050945.56,
        "delta": 174937551.54
      },
      {
        "periodo": 202511,
        "valor": 5710517747.93,
        "delta": 173466802.37
      },
      {
        "periodo": 202512,
        "valor": 5767425960.03,
        "delta": 56908212.1
      },
      {
        "periodo": 202601,
        "valor": 5966784785.1,
        "delta": 199358825.07
      },
      {
        "periodo": 202602,
        "valor": 9570128492.17,
        "delta": 3603343707.07
      },
      {
        "periodo": 202603,
        "valor": 9429710042.37,
        "delta": -140418449.8
      },
      {
        "periodo": 202604,
        "valor": 9531701969.08,
        "delta": 101991926.71
      },
      {
        "periodo": 202605,
        "valor": 9936592586.36,
        "delta": 404890617.28
      },
      {
        "periodo": 202606,
        "valor": 10182959763.47,
        "delta": 246367177.11
      },
      {
        "periodo": 202607,
        "valor": 10218601831.51,
        "delta": 35642068.04
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 24216652241.27,
    "valor_anterior": 23483887175.859997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22124610356.59,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 22339680312.66,
        "delta": 215069956.07
      },
      {
        "periodo": 202509,
        "valor": 22727217808.85,
        "delta": 387537496.19
      },
      {
        "periodo": 202510,
        "valor": 23492521498.76,
        "delta": 765303689.91
      },
      {
        "periodo": 202511,
        "valor": 23598893793.36,
        "delta": 106372294.6
      },
      {
        "periodo": 202512,
        "valor": 23403003223.2,
        "delta": -195890570.16
      },
      {
        "periodo": 202601,
        "valor": 23724631209.11,
        "delta": 321627985.91
      },
      {
        "periodo": 202602,
        "valor": 21909982917.78,
        "delta": -1814648291.33
      },
      {
        "periodo": 202603,
        "valor": 21866426524.16,
        "delta": -43556393.62
      },
      {
        "periodo": 202604,
        "valor": 22466745589.98,
        "delta": 600319065.82
      },
      {
        "periodo": 202605,
        "valor": 23329300930.47,
        "delta": 862555340.49
      },
      {
        "periodo": 202606,
        "valor": 23483887175.86,
        "delta": 154586245.39
      },
      {
        "periodo": 202607,
        "valor": 24216652241.27,
        "delta": 732765065.41
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 12322642401.0,
    "valor_anterior": 12307765703.000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11981158962.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11621972922.0,
        "delta": -359186040.0
      },
      {
        "periodo": 202509,
        "valor": 12031722781.0,
        "delta": 409749859.0
      },
      {
        "periodo": 202510,
        "valor": 12095094964.0,
        "delta": 63372183.0
      },
      {
        "periodo": 202511,
        "valor": 11464048467.0,
        "delta": -631046497.0
      },
      {
        "periodo": 202512,
        "valor": 11023204083.0,
        "delta": -440844384.0
      },
      {
        "periodo": 202601,
        "valor": 11086465323.0,
        "delta": 63261240.0
      },
      {
        "periodo": 202602,
        "valor": 11677632594.0,
        "delta": 591167271.0
      },
      {
        "periodo": 202603,
        "valor": 11663389343.0,
        "delta": -14243251.0
      },
      {
        "periodo": 202604,
        "valor": 11678525756.0,
        "delta": 15136413.0
      },
      {
        "periodo": 202605,
        "valor": 12454883005.0,
        "delta": 776357249.0
      },
      {
        "periodo": 202606,
        "valor": 12307765703.0,
        "delta": -147117302.0
      },
      {
        "periodo": 202607,
        "valor": 12322642401.0,
        "delta": 14876698.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 7644304191.999999,
    "valor_anterior": 7486540064.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7471541896.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7964787779.0,
        "delta": 493245883.0
      },
      {
        "periodo": 202509,
        "valor": 7984212082.0,
        "delta": 19424303.0
      },
      {
        "periodo": 202510,
        "valor": 8058423403.0,
        "delta": 74211321.0
      },
      {
        "periodo": 202511,
        "valor": 7488044003.0,
        "delta": -570379400.0
      },
      {
        "periodo": 202512,
        "valor": 7964514890.0,
        "delta": 476470887.0
      },
      {
        "periodo": 202601,
        "valor": 7682673023.0,
        "delta": -281841867.0
      },
      {
        "periodo": 202602,
        "valor": 7566790106.0,
        "delta": -115882917.0
      },
      {
        "periodo": 202603,
        "valor": 7534450673.0,
        "delta": -32339433.0
      },
      {
        "periodo": 202604,
        "valor": 7279448120.0,
        "delta": -255002553.0
      },
      {
        "periodo": 202605,
        "valor": 7338558073.0,
        "delta": 59109953.0
      },
      {
        "periodo": 202606,
        "valor": 7486540064.0,
        "delta": 147981991.0
      },
      {
        "periodo": 202607,
        "valor": 7644304192.0,
        "delta": 157764128.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 2503115697.3,
    "valor_anterior": 2333319851.05,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2093456919.81,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2183045927.97,
        "delta": 89589008.16
      },
      {
        "periodo": 202509,
        "valor": 2317764787.26,
        "delta": 134718859.29
      },
      {
        "periodo": 202510,
        "valor": 2184191668.89,
        "delta": -133573118.37
      },
      {
        "periodo": 202511,
        "valor": 2232762828.88,
        "delta": 48571159.99
      },
      {
        "periodo": 202512,
        "valor": 1823645511.5,
        "delta": -409117317.38
      },
      {
        "periodo": 202601,
        "valor": 1855969056.44,
        "delta": 32323544.94
      },
      {
        "periodo": 202602,
        "valor": 1906468100.57,
        "delta": 50499044.13
      },
      {
        "periodo": 202603,
        "valor": 1929336475.42,
        "delta": 22868374.85
      },
      {
        "periodo": 202604,
        "valor": 2161725462.29,
        "delta": 232388986.87
      },
      {
        "periodo": 202605,
        "valor": 2261539279.6,
        "delta": 99813817.31
      },
      {
        "periodo": 202606,
        "valor": 2333319851.05,
        "delta": 71780571.45
      },
      {
        "periodo": 202607,
        "valor": 2503115697.3,
        "delta": 169795846.25
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 4358314763.0,
    "valor_anterior": 4035440465.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2668564115.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2782180159.0,
        "delta": 113616044.0
      },
      {
        "periodo": 202509,
        "valor": 2631444013.0,
        "delta": -150736146.0
      },
      {
        "periodo": 202510,
        "valor": 2721815580.0,
        "delta": 90371567.0
      },
      {
        "periodo": 202511,
        "valor": 2703002945.0,
        "delta": -18812635.0
      },
      {
        "periodo": 202512,
        "valor": 2644932889.0,
        "delta": -58070056.0
      },
      {
        "periodo": 202601,
        "valor": 2622926983.0,
        "delta": -22005906.0
      },
      {
        "periodo": 202602,
        "valor": 2635801238.0,
        "delta": 12874255.0
      },
      {
        "periodo": 202603,
        "valor": 2753859458.0,
        "delta": 118058220.0
      },
      {
        "periodo": 202604,
        "valor": 3767399567.0,
        "delta": 1013540109.0
      },
      {
        "periodo": 202605,
        "valor": 3836764663.0,
        "delta": 69365096.0
      },
      {
        "periodo": 202606,
        "valor": 4035440465.0,
        "delta": 198675802.0
      },
      {
        "periodo": 202607,
        "valor": 4358314763.0,
        "delta": 322874298.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 892512340.0,
    "valor_anterior": 870489205.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 778687262.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 839571487.0,
        "delta": 60884225.0
      },
      {
        "periodo": 202509,
        "valor": 935721577.0,
        "delta": 96150090.0
      },
      {
        "periodo": 202510,
        "valor": 902207239.0,
        "delta": -33514338.0
      },
      {
        "periodo": 202511,
        "valor": 887086631.0,
        "delta": -15120608.0
      },
      {
        "periodo": 202512,
        "valor": 625763324.0,
        "delta": -261323307.0
      },
      {
        "periodo": 202601,
        "valor": 671663455.0,
        "delta": 45900131.0
      },
      {
        "periodo": 202602,
        "valor": 720994415.0,
        "delta": 49330960.0
      },
      {
        "periodo": 202603,
        "valor": 686443226.0,
        "delta": -34551189.0
      },
      {
        "periodo": 202604,
        "valor": 778649909.0,
        "delta": 92206683.0
      },
      {
        "periodo": 202605,
        "valor": 908234870.0,
        "delta": 129584961.0
      },
      {
        "periodo": 202606,
        "valor": 870489205.0,
        "delta": -37745665.0
      },
      {
        "periodo": 202607,
        "valor": 892512340.0,
        "delta": 22023135.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 9998293217.0,
    "valor_anterior": 9915445001.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9341989753.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9360903849.0,
        "delta": 18914096.0
      },
      {
        "periodo": 202509,
        "valor": 9564829762.0,
        "delta": 203925913.0
      },
      {
        "periodo": 202510,
        "valor": 9692150589.0,
        "delta": 127320827.0
      },
      {
        "periodo": 202511,
        "valor": 9746370042.0,
        "delta": 54219453.0
      },
      {
        "periodo": 202512,
        "valor": 9783623188.0,
        "delta": 37253146.0
      },
      {
        "periodo": 202601,
        "valor": 9897836705.0,
        "delta": 114213517.0
      },
      {
        "periodo": 202602,
        "valor": 9986265225.0,
        "delta": 88428520.0
      },
      {
        "periodo": 202603,
        "valor": 9967398196.0,
        "delta": -18867029.0
      },
      {
        "periodo": 202604,
        "valor": 9885541147.0,
        "delta": -81857049.0
      },
      {
        "periodo": 202605,
        "valor": 10064740637.0,
        "delta": 179199490.0
      },
      {
        "periodo": 202606,
        "valor": 9915445001.0,
        "delta": -149295636.0
      },
      {
        "periodo": 202607,
        "valor": 9998293217.0,
        "delta": 82848216.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 936168383.04,
    "valor_anterior": 925662278.1500001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1173306070.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1212580406.45,
        "delta": 39274335.52
      },
      {
        "periodo": 202509,
        "valor": 1231913283.01,
        "delta": 19332876.56
      },
      {
        "periodo": 202510,
        "valor": 1325455073.3,
        "delta": 93541790.29
      },
      {
        "periodo": 202511,
        "valor": 1330067671.37,
        "delta": 4612598.07
      },
      {
        "periodo": 202512,
        "valor": 947512354.54,
        "delta": -382555316.83
      },
      {
        "periodo": 202601,
        "valor": 889727986.85,
        "delta": -57784367.69
      },
      {
        "periodo": 202602,
        "valor": 795738065.38,
        "delta": -93989921.47
      },
      {
        "periodo": 202603,
        "valor": 835245374.06,
        "delta": 39507308.68
      },
      {
        "periodo": 202604,
        "valor": 867779718.86,
        "delta": 32534344.8
      },
      {
        "periodo": 202605,
        "valor": 877246550.78,
        "delta": 9466831.92
      },
      {
        "periodo": 202606,
        "valor": 925662278.15,
        "delta": 48415727.37
      },
      {
        "periodo": 202607,
        "valor": 936168383.04,
        "delta": 10506104.89
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 1442465103.0,
    "valor_anterior": 1424544123.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 884921536.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 953295630.0,
        "delta": 68374094.0
      },
      {
        "periodo": 202509,
        "valor": 921616935.0,
        "delta": -31678695.0
      },
      {
        "periodo": 202510,
        "valor": 958159617.0,
        "delta": 36542682.0
      },
      {
        "periodo": 202511,
        "valor": 1043838124.0,
        "delta": 85678507.0
      },
      {
        "periodo": 202512,
        "valor": 1086553152.0,
        "delta": 42715028.0
      },
      {
        "periodo": 202601,
        "valor": 1339682177.0,
        "delta": 253129025.0
      },
      {
        "periodo": 202602,
        "valor": 1417591991.0,
        "delta": 77909814.0
      },
      {
        "periodo": 202603,
        "valor": 1316424722.0,
        "delta": -101167269.0
      },
      {
        "periodo": 202604,
        "valor": 1341848922.0,
        "delta": 25424200.0
      },
      {
        "periodo": 202605,
        "valor": 1375201739.0,
        "delta": 33352817.0
      },
      {
        "periodo": 202606,
        "valor": 1424544123.0,
        "delta": 49342384.0
      },
      {
        "periodo": 202607,
        "valor": 1442465103.0,
        "delta": 17920980.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 1232640589.0,
    "valor_anterior": 1212168633.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 879061035.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 869566991.0,
        "delta": -9494044.0
      },
      {
        "periodo": 202509,
        "valor": 902102621.0,
        "delta": 32535630.0
      },
      {
        "periodo": 202510,
        "valor": 878434952.0,
        "delta": -23667669.0
      },
      {
        "periodo": 202511,
        "valor": 889869529.0,
        "delta": 11434577.0
      },
      {
        "periodo": 202512,
        "valor": 956034677.0,
        "delta": 66165148.0
      },
      {
        "periodo": 202601,
        "valor": 990006323.0,
        "delta": 33971646.0
      },
      {
        "periodo": 202602,
        "valor": 959801893.0,
        "delta": -30204430.0
      },
      {
        "periodo": 202603,
        "valor": 1096076040.0,
        "delta": 136274147.0
      },
      {
        "periodo": 202604,
        "valor": 1101794049.0,
        "delta": 5718009.0
      },
      {
        "periodo": 202605,
        "valor": 1130883392.0,
        "delta": 29089343.0
      },
      {
        "periodo": 202606,
        "valor": 1212168633.0,
        "delta": 81285241.0
      },
      {
        "periodo": 202607,
        "valor": 1232640589.0,
        "delta": 20471956.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 1031354408.0,
    "valor_anterior": 1016774997.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1019030131.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1026654070.0,
        "delta": 7623939.0
      },
      {
        "periodo": 202509,
        "valor": 1049474631.0,
        "delta": 22820561.0
      },
      {
        "periodo": 202510,
        "valor": 1031188576.0,
        "delta": -18286055.0
      },
      {
        "periodo": 202511,
        "valor": 1039866833.0,
        "delta": 8678257.0
      },
      {
        "periodo": 202512,
        "valor": 942501234.0,
        "delta": -97365599.0
      },
      {
        "periodo": 202601,
        "valor": 934176400.0,
        "delta": -8324834.0
      },
      {
        "periodo": 202602,
        "valor": 934337763.0,
        "delta": 161363.0
      },
      {
        "periodo": 202603,
        "valor": 959942888.0,
        "delta": 25605125.0
      },
      {
        "periodo": 202604,
        "valor": 938904851.0,
        "delta": -21038037.0
      },
      {
        "periodo": 202605,
        "valor": 987770679.0,
        "delta": 48865828.0
      },
      {
        "periodo": 202606,
        "valor": 1016774997.0,
        "delta": 29004318.0
      },
      {
        "periodo": 202607,
        "valor": 1031354408.0,
        "delta": 14579411.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 10294761929.4,
    "valor_anterior": 10132637201.33,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6404489294.3,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6124679465.48,
        "delta": -279809828.82
      },
      {
        "periodo": 202509,
        "valor": 7948530041.82,
        "delta": 1823850576.34
      },
      {
        "periodo": 202510,
        "valor": 8194787968.39,
        "delta": 246257926.57
      },
      {
        "periodo": 202511,
        "valor": 8505587273.12,
        "delta": 310799304.73
      },
      {
        "periodo": 202512,
        "valor": 9144219021.5,
        "delta": 638631748.38
      },
      {
        "periodo": 202601,
        "valor": 9202885614.81,
        "delta": 58666593.31
      },
      {
        "periodo": 202602,
        "valor": 9035039555.68,
        "delta": -167846059.13
      },
      {
        "periodo": 202603,
        "valor": 9265152238.58,
        "delta": 230112682.9
      },
      {
        "periodo": 202604,
        "valor": 9434664334.18,
        "delta": 169512095.6
      },
      {
        "periodo": 202605,
        "valor": 9784006975.64,
        "delta": 349342641.46
      },
      {
        "periodo": 202606,
        "valor": 10132637201.33,
        "delta": 348630225.69
      },
      {
        "periodo": 202607,
        "valor": 10294761929.4,
        "delta": 162124728.07
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 453333729.35,
    "valor_anterior": 436691010.02,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 586898049.18,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 603433407.96,
        "delta": 16535358.78
      },
      {
        "periodo": 202509,
        "valor": 607389039.98,
        "delta": 3955632.02
      },
      {
        "periodo": 202510,
        "valor": 617830760.75,
        "delta": 10441720.77
      },
      {
        "periodo": 202511,
        "valor": 590827009.53,
        "delta": -27003751.22
      },
      {
        "periodo": 202512,
        "valor": 352566643.18,
        "delta": -238260366.35
      },
      {
        "periodo": 202601,
        "valor": 338797870.71,
        "delta": -13768772.47
      },
      {
        "periodo": 202602,
        "valor": 356786058.95,
        "delta": 17988188.24
      },
      {
        "periodo": 202603,
        "valor": 369325397.53,
        "delta": 12539338.58
      },
      {
        "periodo": 202604,
        "valor": 399467163.43,
        "delta": 30141765.9
      },
      {
        "periodo": 202605,
        "valor": 437770928.18,
        "delta": 38303764.75
      },
      {
        "periodo": 202606,
        "valor": 436691010.02,
        "delta": -1079918.16
      },
      {
        "periodo": 202607,
        "valor": 453333729.35,
        "delta": 16642719.33
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 868450621.0,
    "valor_anterior": 876427143.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 925027377.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 939365480.0,
        "delta": 14338103.0
      },
      {
        "periodo": 202509,
        "valor": 928910047.0,
        "delta": -10455433.0
      },
      {
        "periodo": 202510,
        "valor": 900776124.0,
        "delta": -28133923.0
      },
      {
        "periodo": 202511,
        "valor": 967851595.0,
        "delta": 67075471.0
      },
      {
        "periodo": 202512,
        "valor": 1040435308.0,
        "delta": 72583713.0
      },
      {
        "periodo": 202601,
        "valor": 1061687546.0,
        "delta": 21252238.0
      },
      {
        "periodo": 202602,
        "valor": 1056471453.0,
        "delta": -5216093.0
      },
      {
        "periodo": 202603,
        "valor": 1112042783.0,
        "delta": 55571330.0
      },
      {
        "periodo": 202604,
        "valor": 1032095946.0,
        "delta": -79946837.0
      },
      {
        "periodo": 202605,
        "valor": 1041079032.0,
        "delta": 8983086.0
      },
      {
        "periodo": 202606,
        "valor": 876427143.0,
        "delta": -164651889.0
      },
      {
        "periodo": 202607,
        "valor": 868450621.0,
        "delta": -7976522.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 2257644030.7000003,
    "valor_anterior": 2257704228.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2260085029.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2260257740.78,
        "delta": 172711.04
      },
      {
        "periodo": 202509,
        "valor": 2260644580.7,
        "delta": 386839.92
      },
      {
        "periodo": 202510,
        "valor": 2259436170.06,
        "delta": -1208410.64
      },
      {
        "periodo": 202511,
        "valor": 2258974582.24,
        "delta": -461587.82
      },
      {
        "periodo": 202512,
        "valor": 2258152122.71,
        "delta": -822459.53
      },
      {
        "periodo": 202601,
        "valor": 2257572752.57,
        "delta": -579370.14
      },
      {
        "periodo": 202602,
        "valor": 2256838732.74,
        "delta": -734019.83
      },
      {
        "periodo": 202603,
        "valor": 2256655031.19,
        "delta": -183701.55
      },
      {
        "periodo": 202604,
        "valor": 2256884424.95,
        "delta": 229393.76
      },
      {
        "periodo": 202605,
        "valor": 2257157808.42,
        "delta": 273383.47
      },
      {
        "periodo": 202606,
        "valor": 2257704228.0,
        "delta": 546419.58
      },
      {
        "periodo": 202607,
        "valor": 2257644030.7,
        "delta": -60197.3
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 7123269994.870001,
    "valor_anterior": 7161431970.61,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5189208738.71,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5757484128.54,
        "delta": 568275389.83
      },
      {
        "periodo": 202509,
        "valor": 5989277278.13,
        "delta": 231793149.59
      },
      {
        "periodo": 202510,
        "valor": 7042773530.98,
        "delta": 1053496252.85
      },
      {
        "periodo": 202511,
        "valor": 7774306323.62,
        "delta": 731532792.64
      },
      {
        "periodo": 202512,
        "valor": 8147238821.33,
        "delta": 372932497.71
      },
      {
        "periodo": 202601,
        "valor": 7983230787.57,
        "delta": -164008033.76
      },
      {
        "periodo": 202602,
        "valor": 7956396227.61,
        "delta": -26834559.96
      },
      {
        "periodo": 202603,
        "valor": 7828301647.62,
        "delta": -128094579.99
      },
      {
        "periodo": 202604,
        "valor": 7541099893.21,
        "delta": -287201754.41
      },
      {
        "periodo": 202605,
        "valor": 7416830260.53,
        "delta": -124269632.68
      },
      {
        "periodo": 202606,
        "valor": 7161431970.61,
        "delta": -255398289.92
      },
      {
        "periodo": 202607,
        "valor": 7123269994.87,
        "delta": -38161975.74
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 536625734.22,
    "valor_anterior": 500029628.54,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 187489607.51,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 172884462.23,
        "delta": -14605145.28
      },
      {
        "periodo": 202509,
        "valor": 202157237.45,
        "delta": 29272775.22
      },
      {
        "periodo": 202510,
        "valor": 241058786.47,
        "delta": 38901549.02
      },
      {
        "periodo": 202511,
        "valor": 275048478.16,
        "delta": 33989691.69
      },
      {
        "periodo": 202512,
        "valor": 344645756.18,
        "delta": 69597278.02
      },
      {
        "periodo": 202601,
        "valor": 385390982.48,
        "delta": 40745226.3
      },
      {
        "periodo": 202602,
        "valor": 195069625.18,
        "delta": -190321357.3
      },
      {
        "periodo": 202603,
        "valor": 448428743.31,
        "delta": 253359118.13
      },
      {
        "periodo": 202604,
        "valor": 492201589.37,
        "delta": 43772846.06
      },
      {
        "periodo": 202605,
        "valor": 122322952.29,
        "delta": -369878637.08
      },
      {
        "periodo": 202606,
        "valor": 500029628.54,
        "delta": 377706676.25
      },
      {
        "periodo": 202607,
        "valor": 536625734.22,
        "delta": 36596105.68
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 2254773107.0,
    "valor_anterior": 2235965112.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1430853683.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1470932153.0,
        "delta": 40078470.0
      },
      {
        "periodo": 202509,
        "valor": 1555141210.0,
        "delta": 84209057.0
      },
      {
        "periodo": 202510,
        "valor": 1634863034.0,
        "delta": 79721824.0
      },
      {
        "periodo": 202511,
        "valor": 1748721831.0,
        "delta": 113858797.0
      },
      {
        "periodo": 202512,
        "valor": 2006523752.0,
        "delta": 257801921.0
      },
      {
        "periodo": 202601,
        "valor": 2046277554.0,
        "delta": 39753802.0
      },
      {
        "periodo": 202602,
        "valor": 2250371704.0,
        "delta": 204094150.0
      },
      {
        "periodo": 202603,
        "valor": 2360576439.0,
        "delta": 110204735.0
      },
      {
        "periodo": 202604,
        "valor": 2214528795.0,
        "delta": -146047644.0
      },
      {
        "periodo": 202605,
        "valor": 2238658924.0,
        "delta": 24130129.0
      },
      {
        "periodo": 202606,
        "valor": 2235965112.0,
        "delta": -2693812.0
      },
      {
        "periodo": 202607,
        "valor": 2254773107.0,
        "delta": 18807995.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 1763269029.0,
    "valor_anterior": 1727612301.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1603971157.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1612232241.0,
        "delta": 8261084.0
      },
      {
        "periodo": 202509,
        "valor": 1654065686.0,
        "delta": 41833445.0
      },
      {
        "periodo": 202510,
        "valor": 1614867112.0,
        "delta": -39198574.0
      },
      {
        "periodo": 202511,
        "valor": 1594435704.0,
        "delta": -20431408.0
      },
      {
        "periodo": 202512,
        "valor": 1606917251.0,
        "delta": 12481547.0
      },
      {
        "periodo": 202601,
        "valor": 1633158944.0,
        "delta": 26241693.0
      },
      {
        "periodo": 202602,
        "valor": 1582685024.0,
        "delta": -50473920.0
      },
      {
        "periodo": 202603,
        "valor": 1556689811.0,
        "delta": -25995213.0
      },
      {
        "periodo": 202604,
        "valor": 1728106719.0,
        "delta": 171416908.0
      },
      {
        "periodo": 202605,
        "valor": 1750674027.0,
        "delta": 22567308.0
      },
      {
        "periodo": 202606,
        "valor": 1727612301.0,
        "delta": -23061726.0
      },
      {
        "periodo": 202607,
        "valor": 1763269029.0,
        "delta": 35656728.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 431395489.0,
    "valor_anterior": 432856942.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 675581355.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 671450560.0,
        "delta": -4130795.0
      },
      {
        "periodo": 202509,
        "valor": 660715784.0,
        "delta": -10734776.0
      },
      {
        "periodo": 202510,
        "valor": 668937515.0,
        "delta": 8221731.0
      },
      {
        "periodo": 202511,
        "valor": 573626682.0,
        "delta": -95310833.0
      },
      {
        "periodo": 202512,
        "valor": 561995486.0,
        "delta": -11631196.0
      },
      {
        "periodo": 202601,
        "valor": 558285127.0,
        "delta": -3710359.0
      },
      {
        "periodo": 202602,
        "valor": 556765874.0,
        "delta": -1519253.0
      },
      {
        "periodo": 202603,
        "valor": 573702054.0,
        "delta": 16936180.0
      },
      {
        "periodo": 202604,
        "valor": 572188178.0,
        "delta": -1513876.0
      },
      {
        "periodo": 202605,
        "valor": 398474438.0,
        "delta": -173713740.0
      },
      {
        "periodo": 202606,
        "valor": 432856942.0,
        "delta": 34382504.0
      },
      {
        "periodo": 202607,
        "valor": 431395489.0,
        "delta": -1461453.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 636721532.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 676615584.0,
        "delta": 39894052.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 3836381861.48,
    "valor_anterior": 3744102801.22,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3070124694.4,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3183086426.73,
        "delta": 112961732.33
      },
      {
        "periodo": 202509,
        "valor": 3183984964.34,
        "delta": 898537.61
      },
      {
        "periodo": 202510,
        "valor": 2600569478.69,
        "delta": -583415485.65
      },
      {
        "periodo": 202511,
        "valor": 2931158105.4,
        "delta": 330588626.71
      },
      {
        "periodo": 202512,
        "valor": 2737029864.13,
        "delta": -194128241.27
      },
      {
        "periodo": 202601,
        "valor": 3520984068.44,
        "delta": 783954204.31
      },
      {
        "periodo": 202602,
        "valor": 3658089937.45,
        "delta": 137105869.01
      },
      {
        "periodo": 202603,
        "valor": 3721097432.04,
        "delta": 63007494.59
      },
      {
        "periodo": 202604,
        "valor": 3896505414.27,
        "delta": 175407982.23
      },
      {
        "periodo": 202605,
        "valor": 4022099627.36,
        "delta": 125594213.09
      },
      {
        "periodo": 202606,
        "valor": 3744102801.22,
        "delta": -277996826.14
      },
      {
        "periodo": 202607,
        "valor": 3836381861.48,
        "delta": 92279060.26
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 129394691.0,
    "valor_anterior": 121962007.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 65194921.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 70652962.0,
        "delta": 5458041.0
      },
      {
        "periodo": 202509,
        "valor": 74263039.0,
        "delta": 3610077.0
      },
      {
        "periodo": 202510,
        "valor": 81552506.0,
        "delta": 7289467.0
      },
      {
        "periodo": 202511,
        "valor": 84587779.0,
        "delta": 3035273.0
      },
      {
        "periodo": 202512,
        "valor": 93192970.0,
        "delta": 8605191.0
      },
      {
        "periodo": 202601,
        "valor": 95339193.0,
        "delta": 2146223.0
      },
      {
        "periodo": 202602,
        "valor": 104665472.0,
        "delta": 9326279.0
      },
      {
        "periodo": 202603,
        "valor": 105197924.0,
        "delta": 532452.0
      },
      {
        "periodo": 202604,
        "valor": 106353106.0,
        "delta": 1155182.0
      },
      {
        "periodo": 202605,
        "valor": 112610641.01,
        "delta": 6257535.01
      },
      {
        "periodo": 202606,
        "valor": 121962007.0,
        "delta": 9351365.99
      },
      {
        "periodo": 202607,
        "valor": 129394691.0,
        "delta": 7432684.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 443068103.0,
    "valor_anterior": 399761052.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 390856066.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 374629914.0,
        "delta": -16226152.0
      },
      {
        "periodo": 202509,
        "valor": 368144051.0,
        "delta": -6485863.0
      },
      {
        "periodo": 202510,
        "valor": 382466820.0,
        "delta": 14322769.0
      },
      {
        "periodo": 202511,
        "valor": 389366449.0,
        "delta": 6899629.0
      },
      {
        "periodo": 202512,
        "valor": 396902461.0,
        "delta": 7536012.0
      },
      {
        "periodo": 202601,
        "valor": 386313487.0,
        "delta": -10588974.0
      },
      {
        "periodo": 202602,
        "valor": 394955096.0,
        "delta": 8641609.0
      },
      {
        "periodo": 202603,
        "valor": 369470790.0,
        "delta": -25484306.0
      },
      {
        "periodo": 202604,
        "valor": 394984814.0,
        "delta": 25514024.0
      },
      {
        "periodo": 202605,
        "valor": 370691958.0,
        "delta": -24292856.0
      },
      {
        "periodo": 202606,
        "valor": 399761052.0,
        "delta": 29069094.0
      },
      {
        "periodo": 202607,
        "valor": 443068103.0,
        "delta": 43307051.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 125738594.0,
    "valor_anterior": 112679703.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 60618105.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 65102484.0,
        "delta": 4484379.0
      },
      {
        "periodo": 202509,
        "valor": 69801526.0,
        "delta": 4699042.0
      },
      {
        "periodo": 202510,
        "valor": 74419692.0,
        "delta": 4618166.0
      },
      {
        "periodo": 202511,
        "valor": 80889370.0,
        "delta": 6469678.0
      },
      {
        "periodo": 202512,
        "valor": 85379688.0,
        "delta": 4490318.0
      },
      {
        "periodo": 202601,
        "valor": 88892170.0,
        "delta": 3512482.0
      },
      {
        "periodo": 202602,
        "valor": 90959623.0,
        "delta": 2067453.0
      },
      {
        "periodo": 202603,
        "valor": 113262579.0,
        "delta": 22302956.0
      },
      {
        "periodo": 202604,
        "valor": 121868952.0,
        "delta": 8606373.0
      },
      {
        "periodo": 202605,
        "valor": 135013229.0,
        "delta": 13144277.0
      },
      {
        "periodo": 202606,
        "valor": 112679703.0,
        "delta": -22333526.0
      },
      {
        "periodo": 202607,
        "valor": 125738594.0,
        "delta": 13058891.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 333394356.49,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 263379954.88,
        "delta": -70014401.61
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 243195846.0,
    "valor_anterior": 243592799.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 191211184.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 206264066.0,
        "delta": 15052882.0
      },
      {
        "periodo": 202509,
        "valor": 205726554.0,
        "delta": -537512.0
      },
      {
        "periodo": 202510,
        "valor": 210086015.0,
        "delta": 4359461.0
      },
      {
        "periodo": 202511,
        "valor": 214684605.0,
        "delta": 4598590.0
      },
      {
        "periodo": 202512,
        "valor": 221892459.0,
        "delta": 7207854.0
      },
      {
        "periodo": 202601,
        "valor": 224744300.0,
        "delta": 2851841.0
      },
      {
        "periodo": 202602,
        "valor": 231410740.0,
        "delta": 6666440.0
      },
      {
        "periodo": 202603,
        "valor": 247365284.0,
        "delta": 15954544.0
      },
      {
        "periodo": 202604,
        "valor": 200076518.0,
        "delta": -47288766.0
      },
      {
        "periodo": 202605,
        "valor": 236816033.0,
        "delta": 36739515.0
      },
      {
        "periodo": 202606,
        "valor": 243592799.0,
        "delta": 6776766.0
      },
      {
        "periodo": 202607,
        "valor": 243195846.0,
        "delta": -396953.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 49229579.32,
    "valor_anterior": 49076196.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40995325.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 40315488.25,
        "delta": -679837.02
      },
      {
        "periodo": 202509,
        "valor": 39969086.14,
        "delta": -346402.11
      },
      {
        "periodo": 202510,
        "valor": 45456344.61,
        "delta": 5487258.47
      },
      {
        "periodo": 202511,
        "valor": 45512743.55,
        "delta": 56398.94
      },
      {
        "periodo": 202512,
        "valor": 45577863.25,
        "delta": 65119.7
      },
      {
        "periodo": 202601,
        "valor": 46077852.03,
        "delta": 499988.78
      },
      {
        "periodo": 202602,
        "valor": 46046215.26,
        "delta": -31636.77
      },
      {
        "periodo": 202603,
        "valor": 46076612.7,
        "delta": 30397.44
      },
      {
        "periodo": 202604,
        "valor": 46963474.08,
        "delta": 886861.38
      },
      {
        "periodo": 202605,
        "valor": 45360520.24,
        "delta": -1602953.84
      },
      {
        "periodo": 202606,
        "valor": 49076196.2,
        "delta": 3715675.96
      },
      {
        "periodo": 202607,
        "valor": 49229579.32,
        "delta": 153383.12
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 45613288.0,
    "valor_anterior": 43472235.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26293677.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24036389.0,
        "delta": -2257288.0
      },
      {
        "periodo": 202509,
        "valor": 22541546.0,
        "delta": -1494843.0
      },
      {
        "periodo": 202510,
        "valor": 22244909.0,
        "delta": -296637.0
      },
      {
        "periodo": 202511,
        "valor": 23501463.0,
        "delta": 1256554.0
      },
      {
        "periodo": 202512,
        "valor": 26112603.0,
        "delta": 2611140.0
      },
      {
        "periodo": 202601,
        "valor": 27032030.0,
        "delta": 919427.0
      },
      {
        "periodo": 202602,
        "valor": 29050065.0,
        "delta": 2018035.0
      },
      {
        "periodo": 202603,
        "valor": 31198599.0,
        "delta": 2148534.0
      },
      {
        "periodo": 202604,
        "valor": 34705540.0,
        "delta": 3506941.0
      },
      {
        "periodo": 202605,
        "valor": 39396513.0,
        "delta": 4690973.0
      },
      {
        "periodo": 202606,
        "valor": 43472235.0,
        "delta": 4075722.0
      },
      {
        "periodo": 202607,
        "valor": 45613288.0,
        "delta": 2141053.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 128983348.44,
    "valor_anterior": 128267420.93,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 137747981.61,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 137575541.45,
        "delta": -172440.16
      },
      {
        "periodo": 202509,
        "valor": 135319198.43,
        "delta": -2256343.02
      },
      {
        "periodo": 202510,
        "valor": 135643110.62,
        "delta": 323912.19
      },
      {
        "periodo": 202511,
        "valor": 135404571.22,
        "delta": -238539.4
      },
      {
        "periodo": 202512,
        "valor": 118085105.11,
        "delta": -17319466.11
      },
      {
        "periodo": 202601,
        "valor": 116697588.25,
        "delta": -1387516.86
      },
      {
        "periodo": 202602,
        "valor": 117094756.24,
        "delta": 397167.99
      },
      {
        "periodo": 202603,
        "valor": 117334302.99,
        "delta": 239546.75
      },
      {
        "periodo": 202604,
        "valor": 124752527.39,
        "delta": 7418224.4
      },
      {
        "periodo": 202605,
        "valor": 124786422.42,
        "delta": 33895.03
      },
      {
        "periodo": 202606,
        "valor": 128267420.93,
        "delta": 3480998.51
      },
      {
        "periodo": 202607,
        "valor": 128983348.44,
        "delta": 715927.51
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 3049995.0,
    "valor_anterior": 2952654.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2530847.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2530847.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 2530847.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 2628187.0,
        "delta": 97340.0
      },
      {
        "periodo": 202511,
        "valor": 2628187.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 2628187.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 2855314.0,
        "delta": 227127.0
      },
      {
        "periodo": 202602,
        "valor": 2855314.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 2855314.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 2952654.0,
        "delta": 97340.0
      },
      {
        "periodo": 202605,
        "valor": 2952654.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 2952654.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 3049995.0,
        "delta": 97341.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 569550692.45,
    "valor_anterior": 561184688.42,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 181936998.2,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 207999631.49,
        "delta": 26062633.29
      },
      {
        "periodo": 202509,
        "valor": 378703108.88,
        "delta": 170703477.39
      },
      {
        "periodo": 202510,
        "valor": 378190995.78,
        "delta": -512113.1
      },
      {
        "periodo": 202511,
        "valor": 371110743.95,
        "delta": -7080251.83
      },
      {
        "periodo": 202512,
        "valor": 356743253.28,
        "delta": -14367490.67
      },
      {
        "periodo": 202601,
        "valor": 372027174.16,
        "delta": 15283920.88
      },
      {
        "periodo": 202602,
        "valor": 371873757.49,
        "delta": -153416.67
      },
      {
        "periodo": 202603,
        "valor": 497241526.79,
        "delta": 125367769.3
      },
      {
        "periodo": 202604,
        "valor": 507622029.14,
        "delta": 10380502.35
      },
      {
        "periodo": 202605,
        "valor": 510482853.16,
        "delta": 2860824.02
      },
      {
        "periodo": 202606,
        "valor": 561184688.42,
        "delta": 50701835.26
      },
      {
        "periodo": 202607,
        "valor": 569550692.45,
        "delta": 8366004.03
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 223423904.13,
    "valor_anterior": 231481450.07,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 184848386.33,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 191637152.9,
        "delta": 6788766.57
      },
      {
        "periodo": 202509,
        "valor": 200236677.1,
        "delta": 8599524.2
      },
      {
        "periodo": 202510,
        "valor": 211358613.41,
        "delta": 11121936.31
      },
      {
        "periodo": 202511,
        "valor": 218011600.0,
        "delta": 6652986.59
      },
      {
        "periodo": 202512,
        "valor": 232301055.51,
        "delta": 14289455.51
      },
      {
        "periodo": 202601,
        "valor": 247197205.34,
        "delta": 14896149.83
      },
      {
        "periodo": 202602,
        "valor": 253629223.2,
        "delta": 6432017.86
      },
      {
        "periodo": 202603,
        "valor": 263261712.74,
        "delta": 9632489.54
      },
      {
        "periodo": 202604,
        "valor": 261038430.98,
        "delta": -2223281.76
      },
      {
        "periodo": 202605,
        "valor": 266568932.38,
        "delta": 5530501.4
      },
      {
        "periodo": 202606,
        "valor": 231481450.07,
        "delta": -35087482.31
      },
      {
        "periodo": 202607,
        "valor": 223423904.13,
        "delta": -8057545.94
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 162012567.0,
    "valor_anterior": 118797524.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 29219316.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 118595213.0,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": 117721472.0,
        "delta": -873741.0
      },
      {
        "periodo": 202606,
        "valor": 118797524.0,
        "delta": 1076052.0
      },
      {
        "periodo": 202607,
        "valor": 162012567.0,
        "delta": 43215043.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 978709470.0,
    "valor_anterior": 987265943.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 911141388.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 840112547.0,
        "delta": -71028841.0
      },
      {
        "periodo": 202509,
        "valor": 754405448.0,
        "delta": -85707099.0
      },
      {
        "periodo": 202510,
        "valor": 750218376.0,
        "delta": -4187072.0
      },
      {
        "periodo": 202511,
        "valor": 749136599.0,
        "delta": -1081777.0
      },
      {
        "periodo": 202512,
        "valor": 762490661.0,
        "delta": 13354062.0
      },
      {
        "periodo": 202601,
        "valor": 889599478.0,
        "delta": 127108817.0
      },
      {
        "periodo": 202602,
        "valor": 890326747.0,
        "delta": 727269.0
      },
      {
        "periodo": 202603,
        "valor": 943654244.0,
        "delta": 53327497.0
      },
      {
        "periodo": 202604,
        "valor": 957373521.0,
        "delta": 13719277.0
      },
      {
        "periodo": 202605,
        "valor": 958732440.0,
        "delta": 1358919.0
      },
      {
        "periodo": 202606,
        "valor": 987265943.0,
        "delta": 28533503.0
      },
      {
        "periodo": 202607,
        "valor": 978709470.0,
        "delta": -8556473.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 8035837.0,
    "valor_anterior": 17170428.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19820509.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19820509.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 19820509.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 19820509.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 19820509.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 19820509.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 19820509.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 19820509.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 19820509.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 17170428.0,
        "delta": -2650081.0
      },
      {
        "periodo": 202605,
        "valor": 17170428.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 17170428.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 8035837.0,
        "delta": -9134591.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 54325907.29,
    "valor_anterior": 54325907.29,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 113082702.37,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 110252850.46,
        "delta": -2829851.91
      },
      {
        "periodo": 202509,
        "valor": 105879273.8,
        "delta": -4373576.66
      },
      {
        "periodo": 202510,
        "valor": 57864060.63,
        "delta": -48015213.17
      },
      {
        "periodo": 202511,
        "valor": 60275063.16,
        "delta": 2411002.53
      },
      {
        "periodo": 202512,
        "valor": 60275063.16,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 60275063.16,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 60275063.16,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 54325907.29,
        "delta": -5949155.87
      },
      {
        "periodo": 202604,
        "valor": 54325907.29,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 54325907.29,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 54325907.29,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 54325907.29,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 59534578.0,
    "valor_anterior": 59679362.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 54253776.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55496404.0,
        "delta": 1242628.0
      },
      {
        "periodo": 202509,
        "valor": 55572770.0,
        "delta": 76366.0
      },
      {
        "periodo": 202510,
        "valor": 55708370.0,
        "delta": 135600.0
      },
      {
        "periodo": 202511,
        "valor": 58267884.0,
        "delta": 2559514.0
      },
      {
        "periodo": 202512,
        "valor": 58664953.0,
        "delta": 397069.0
      },
      {
        "periodo": 202601,
        "valor": 58769977.0,
        "delta": 105024.0
      },
      {
        "periodo": 202602,
        "valor": 59016778.0,
        "delta": 246801.0
      },
      {
        "periodo": 202603,
        "valor": 59476843.0,
        "delta": 460065.0
      },
      {
        "periodo": 202604,
        "valor": 59809766.0,
        "delta": 332923.0
      },
      {
        "periodo": 202605,
        "valor": 59851320.0,
        "delta": 41554.0
      },
      {
        "periodo": 202606,
        "valor": 59679362.0,
        "delta": -171958.0
      },
      {
        "periodo": 202607,
        "valor": 59534578.0,
        "delta": -144784.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 22936.79,
    "valor_anterior": 64735.33,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4208538.16,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3128262.3,
        "delta": -1080275.86
      },
      {
        "periodo": 202509,
        "valor": 1836693.6,
        "delta": -1291568.7
      },
      {
        "periodo": 202510,
        "valor": 1210167.31,
        "delta": -626526.29
      },
      {
        "periodo": 202511,
        "valor": 697442.29,
        "delta": -512725.02
      },
      {
        "periodo": 202512,
        "valor": 424709.04,
        "delta": -272733.25
      },
      {
        "periodo": 202601,
        "valor": 250446.27,
        "delta": -174262.77
      },
      {
        "periodo": 202602,
        "valor": 228461.05,
        "delta": -21985.22
      },
      {
        "periodo": 202603,
        "valor": 171634.3,
        "delta": -56826.75
      },
      {
        "periodo": 202604,
        "valor": 89970.02,
        "delta": -81664.28
      },
      {
        "periodo": 202605,
        "valor": 77312.27,
        "delta": -12657.75
      },
      {
        "periodo": 202606,
        "valor": 64735.33,
        "delta": -12576.94
      },
      {
        "periodo": 202607,
        "valor": 22936.79,
        "delta": -41798.54
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 140851256.24,
    "valor_anterior": 130615673.71,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 122423921.48,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 118090262.89,
        "delta": -4333658.59
      },
      {
        "periodo": 202604,
        "valor": 122280816.21,
        "delta": 4190553.32
      },
      {
        "periodo": 202605,
        "valor": 132504567.81,
        "delta": 10223751.6
      },
      {
        "periodo": 202606,
        "valor": 130615673.71,
        "delta": -1888894.1
      },
      {
        "periodo": 202607,
        "valor": 140851256.24,
        "delta": 10235582.53
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 40384369.0,
    "valor_anterior": 39069971.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1002534.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3426413.0,
        "delta": 2423879.0
      },
      {
        "periodo": 202509,
        "valor": 8136188.0,
        "delta": 4709775.0
      },
      {
        "periodo": 202510,
        "valor": 19815445.0,
        "delta": 11679257.0
      },
      {
        "periodo": 202511,
        "valor": 35062593.0,
        "delta": 15247148.0
      },
      {
        "periodo": 202512,
        "valor": 38764055.0,
        "delta": 3701462.0
      },
      {
        "periodo": 202601,
        "valor": 37548458.0,
        "delta": -1215597.0
      },
      {
        "periodo": 202602,
        "valor": 29534158.0,
        "delta": -8014300.0
      },
      {
        "periodo": 202603,
        "valor": 27605004.0,
        "delta": -1929154.0
      },
      {
        "periodo": 202604,
        "valor": 30748614.0,
        "delta": 3143610.0
      },
      {
        "periodo": 202605,
        "valor": 35799253.0,
        "delta": 5050639.0
      },
      {
        "periodo": 202606,
        "valor": 39069971.0,
        "delta": 3270718.0
      },
      {
        "periodo": 202607,
        "valor": 40384369.0,
        "delta": 1314398.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 418924.0,
    "valor_anterior": 250010.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 5678.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 6699.0,
        "delta": 1021.0
      },
      {
        "periodo": 202605,
        "valor": 184567.0,
        "delta": 177868.0
      },
      {
        "periodo": 202606,
        "valor": 250010.0,
        "delta": 65443.0
      },
      {
        "periodo": 202607,
        "valor": 418924.0,
        "delta": 168914.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 843171617.0,
    "valor_anterior": 617314434.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 490058703.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 678499173.0,
        "delta": 188440470.0
      },
      {
        "periodo": 202605,
        "valor": 909568864.0,
        "delta": 231069691.0
      },
      {
        "periodo": 202606,
        "valor": 617314434.0,
        "delta": -292254430.0
      },
      {
        "periodo": 202607,
        "valor": 843171617.0,
        "delta": 225857183.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 111800304003,
    "label": "EPRC Etapa 3",
    "valor_actual": 110865686195.8,
    "valor_anterior": 108619439791.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 91385807506.23,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 92469424119.89,
        "delta": 1083616613.66
      },
      {
        "periodo": 202509,
        "valor": 95093836060.51,
        "delta": 2624411940.62
      },
      {
        "periodo": 202510,
        "valor": 97101278708.21,
        "delta": 2007442647.7
      },
      {
        "periodo": 202511,
        "valor": 97843863801.78,
        "delta": 742585093.57
      },
      {
        "periodo": 202512,
        "valor": 97687694107.65,
        "delta": -156169694.13
      },
      {
        "periodo": 202601,
        "valor": 99353474235.29,
        "delta": 1665780127.64
      },
      {
        "periodo": 202602,
        "valor": 101810212893.39,
        "delta": 2456738658.1
      },
      {
        "periodo": 202603,
        "valor": 103037147969.98,
        "delta": 1226935076.59
      },
      {
        "periodo": 202604,
        "valor": 105208025671.73,
        "delta": 2170877701.75
      },
      {
        "periodo": 202605,
        "valor": 108101407266.21,
        "delta": 2893381594.48
      },
      {
        "periodo": 202606,
        "valor": 108619439791.2,
        "delta": 518032524.99
      },
      {
        "periodo": 202607,
        "valor": 110865686195.8,
        "delta": 2246246404.6
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 14998380581.76,
    "valor_anterior": 14942282698.63,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5424767252.46,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5524914093.63,
        "delta": 100146841.17
      },
      {
        "periodo": 202509,
        "valor": 5620001517.56,
        "delta": 95087423.93
      },
      {
        "periodo": 202510,
        "valor": 5653212020.34,
        "delta": 33210502.78
      },
      {
        "periodo": 202511,
        "valor": 5484139130.69,
        "delta": -169072889.65
      },
      {
        "periodo": 202512,
        "valor": 5626743124.7,
        "delta": 142603994.01
      },
      {
        "periodo": 202601,
        "valor": 5525235512.5,
        "delta": -101507612.2
      },
      {
        "periodo": 202602,
        "valor": 14695258906.63,
        "delta": 9170023394.13
      },
      {
        "periodo": 202603,
        "valor": 14759383950.18,
        "delta": 64125043.55
      },
      {
        "periodo": 202604,
        "valor": 14695316549.75,
        "delta": -64067400.43
      },
      {
        "periodo": 202605,
        "valor": 14830214396.89,
        "delta": 134897847.14
      },
      {
        "periodo": 202606,
        "valor": 14942282698.63,
        "delta": 112068301.74
      },
      {
        "periodo": 202607,
        "valor": 14998380581.76,
        "delta": 56097883.13
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 37004512519.65,
    "valor_anterior": 37464701778.69,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30185877960.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 30810741549.9,
        "delta": 624863589.63
      },
      {
        "periodo": 202509,
        "valor": 30951677976.65,
        "delta": 140936426.75
      },
      {
        "periodo": 202510,
        "valor": 31239677402.8,
        "delta": 287999426.15
      },
      {
        "periodo": 202511,
        "valor": 31146734517.51,
        "delta": -92942885.29
      },
      {
        "periodo": 202512,
        "valor": 31940757494.76,
        "delta": 794022977.25
      },
      {
        "periodo": 202601,
        "valor": 31666878449.94,
        "delta": -273879044.82
      },
      {
        "periodo": 202602,
        "valor": 35108493079.27,
        "delta": 3441614629.33
      },
      {
        "periodo": 202603,
        "valor": 36035484202.91,
        "delta": 926991123.64
      },
      {
        "periodo": 202604,
        "valor": 35718912312.51,
        "delta": -316571890.4
      },
      {
        "periodo": 202605,
        "valor": 36278331486.15,
        "delta": 559419173.64
      },
      {
        "periodo": 202606,
        "valor": 37464701778.69,
        "delta": 1186370292.54
      },
      {
        "periodo": 202607,
        "valor": 37004512519.65,
        "delta": -460189259.04
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 12814263703.0,
    "valor_anterior": 12552405666.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12212486993.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12116341224.0,
        "delta": -96145769.0
      },
      {
        "periodo": 202509,
        "valor": 12078001339.0,
        "delta": -38339885.0
      },
      {
        "periodo": 202510,
        "valor": 12116143688.0,
        "delta": 38142349.0
      },
      {
        "periodo": 202511,
        "valor": 11980452120.0,
        "delta": -135691568.0
      },
      {
        "periodo": 202512,
        "valor": 12212697888.0,
        "delta": 232245768.0
      },
      {
        "periodo": 202601,
        "valor": 12213827109.0,
        "delta": 1129221.0
      },
      {
        "periodo": 202602,
        "valor": 12345950032.0,
        "delta": 132122923.0
      },
      {
        "periodo": 202603,
        "valor": 12485160044.0,
        "delta": 139210012.0
      },
      {
        "periodo": 202604,
        "valor": 12227499849.0,
        "delta": -257660195.0
      },
      {
        "periodo": 202605,
        "valor": 12758571932.0,
        "delta": 531072083.0
      },
      {
        "periodo": 202606,
        "valor": 12552405666.0,
        "delta": -206166266.0
      },
      {
        "periodo": 202607,
        "valor": 12814263703.0,
        "delta": 261858037.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 7391057996.000001,
    "valor_anterior": 7338866730.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9099431514.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8999262880.0,
        "delta": -100168634.0
      },
      {
        "periodo": 202509,
        "valor": 8778978179.0,
        "delta": -220284701.0
      },
      {
        "periodo": 202510,
        "valor": 8874791437.0,
        "delta": 95813258.0
      },
      {
        "periodo": 202511,
        "valor": 8812730156.0,
        "delta": -62061281.0
      },
      {
        "periodo": 202512,
        "valor": 8376937132.0,
        "delta": -435793024.0
      },
      {
        "periodo": 202601,
        "valor": 8328293390.0,
        "delta": -48643742.0
      },
      {
        "periodo": 202602,
        "valor": 8219044994.0,
        "delta": -109248396.0
      },
      {
        "periodo": 202603,
        "valor": 7598531916.0,
        "delta": -620513078.0
      },
      {
        "periodo": 202604,
        "valor": 7474251689.0,
        "delta": -124280227.0
      },
      {
        "periodo": 202605,
        "valor": 7513431909.0,
        "delta": 39180220.0
      },
      {
        "periodo": 202606,
        "valor": 7338866731.0,
        "delta": -174565178.0
      },
      {
        "periodo": 202607,
        "valor": 7391057996.0,
        "delta": 52191265.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 2145359014.7,
    "valor_anterior": 2169590009.6,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2605874424.62,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2227031913.02,
        "delta": -378842511.6
      },
      {
        "periodo": 202509,
        "valor": 2229016610.37,
        "delta": 1984697.35
      },
      {
        "periodo": 202510,
        "valor": 2229341842.96,
        "delta": 325232.59
      },
      {
        "periodo": 202511,
        "valor": 2240383490.45,
        "delta": 11041647.49
      },
      {
        "periodo": 202512,
        "valor": 2280465989.49,
        "delta": 40082499.04
      },
      {
        "periodo": 202601,
        "valor": 2253567300.31,
        "delta": -26898689.18
      },
      {
        "periodo": 202602,
        "valor": 2226853699.76,
        "delta": -26713600.55
      },
      {
        "periodo": 202603,
        "valor": 2279119612.22,
        "delta": 52265912.46
      },
      {
        "periodo": 202604,
        "valor": 2142460706.0,
        "delta": -136658906.22
      },
      {
        "periodo": 202605,
        "valor": 2121223079.99,
        "delta": -21237626.01
      },
      {
        "periodo": 202606,
        "valor": 2169590009.6,
        "delta": 48366929.61
      },
      {
        "periodo": 202607,
        "valor": 2145359014.7,
        "delta": -24230994.9
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 3370836401.0,
    "valor_anterior": 3353256980.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2994131541.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3047946280.0,
        "delta": 53814739.0
      },
      {
        "periodo": 202509,
        "valor": 3255634766.0,
        "delta": 207688486.0
      },
      {
        "periodo": 202510,
        "valor": 3283182544.0,
        "delta": 27547778.0
      },
      {
        "periodo": 202511,
        "valor": 3322253709.0,
        "delta": 39071165.0
      },
      {
        "periodo": 202512,
        "valor": 3288934544.0,
        "delta": -33319165.0
      },
      {
        "periodo": 202601,
        "valor": 3336805654.0,
        "delta": 47871110.0
      },
      {
        "periodo": 202602,
        "valor": 3457289794.0,
        "delta": 120484140.0
      },
      {
        "periodo": 202603,
        "valor": 3332031792.0,
        "delta": -125258002.0
      },
      {
        "periodo": 202604,
        "valor": 3383964663.0,
        "delta": 51932871.0
      },
      {
        "periodo": 202605,
        "valor": 3393663754.0,
        "delta": 9699091.0
      },
      {
        "periodo": 202606,
        "valor": 3353256980.0,
        "delta": -40406774.0
      },
      {
        "periodo": 202607,
        "valor": 3370836401.0,
        "delta": 17579421.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 925898622.0,
    "valor_anterior": 963653449.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 763521637.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 730332423.0,
        "delta": -33189214.0
      },
      {
        "periodo": 202509,
        "valor": 804561846.0,
        "delta": 74229423.0
      },
      {
        "periodo": 202510,
        "valor": 832730943.0,
        "delta": 28169097.0
      },
      {
        "periodo": 202511,
        "valor": 870262716.0,
        "delta": 37531773.0
      },
      {
        "periodo": 202512,
        "valor": 940928004.0,
        "delta": 70665288.0
      },
      {
        "periodo": 202601,
        "valor": 920230875.0,
        "delta": -20697129.0
      },
      {
        "periodo": 202602,
        "valor": 1025556062.0,
        "delta": 105325187.0
      },
      {
        "periodo": 202603,
        "valor": 919614862.0,
        "delta": -105941200.0
      },
      {
        "periodo": 202604,
        "valor": 855099565.0,
        "delta": -64515297.0
      },
      {
        "periodo": 202605,
        "valor": 836486076.0,
        "delta": -18613489.0
      },
      {
        "periodo": 202606,
        "valor": 963653449.0,
        "delta": 127167373.0
      },
      {
        "periodo": 202607,
        "valor": 925898622.0,
        "delta": -37754827.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 4142278089.0,
    "valor_anterior": 3922361858.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3995404994.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4070292722.0,
        "delta": 74887728.0
      },
      {
        "periodo": 202509,
        "valor": 4138555702.0,
        "delta": 68262980.0
      },
      {
        "periodo": 202510,
        "valor": 4070984572.0,
        "delta": -67571130.0
      },
      {
        "periodo": 202511,
        "valor": 4163073723.0,
        "delta": 92089151.0
      },
      {
        "periodo": 202512,
        "valor": 4178680803.0,
        "delta": 15607080.0
      },
      {
        "periodo": 202601,
        "valor": 4079469535.0,
        "delta": -99211268.0
      },
      {
        "periodo": 202602,
        "valor": 4153664571.0,
        "delta": 74195036.0
      },
      {
        "periodo": 202603,
        "valor": 4137693285.0,
        "delta": -15971286.0
      },
      {
        "periodo": 202604,
        "valor": 3910515699.0,
        "delta": -227177586.0
      },
      {
        "periodo": 202605,
        "valor": 4021098636.0,
        "delta": 110582937.0
      },
      {
        "periodo": 202606,
        "valor": 3922361858.0,
        "delta": -98736778.0
      },
      {
        "periodo": 202607,
        "valor": 4142278089.0,
        "delta": 219916231.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 1606964899.75,
    "valor_anterior": 1620252349.18,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1851163777.88,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1820750957.4,
        "delta": -30412820.48
      },
      {
        "periodo": 202509,
        "valor": 1847604027.27,
        "delta": 26853069.87
      },
      {
        "periodo": 202510,
        "valor": 1814122789.98,
        "delta": -33481237.29
      },
      {
        "periodo": 202511,
        "valor": 1825512423.12,
        "delta": 11389633.14
      },
      {
        "periodo": 202512,
        "valor": 1842274452.44,
        "delta": 16762029.32
      },
      {
        "periodo": 202601,
        "valor": 1836916529.25,
        "delta": -5357923.19
      },
      {
        "periodo": 202602,
        "valor": 1569036095.08,
        "delta": -267880434.17
      },
      {
        "periodo": 202603,
        "valor": 1590630451.17,
        "delta": 21594356.09
      },
      {
        "periodo": 202604,
        "valor": 1584275769.8,
        "delta": -6354681.37
      },
      {
        "periodo": 202605,
        "valor": 1595178451.02,
        "delta": 10902681.22
      },
      {
        "periodo": 202606,
        "valor": 1620252349.18,
        "delta": 25073898.16
      },
      {
        "periodo": 202607,
        "valor": 1606964899.75,
        "delta": -13287449.43
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 1702312889.0,
    "valor_anterior": 1693945170.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1417822924.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1454291645.0,
        "delta": 36468721.0
      },
      {
        "periodo": 202509,
        "valor": 1452324996.0,
        "delta": -1966649.0
      },
      {
        "periodo": 202510,
        "valor": 1497310151.0,
        "delta": 44985155.0
      },
      {
        "periodo": 202511,
        "valor": 1568195525.0,
        "delta": 70885374.0
      },
      {
        "periodo": 202512,
        "valor": 1564125218.0,
        "delta": -4070307.0
      },
      {
        "periodo": 202601,
        "valor": 1623699075.0,
        "delta": 59573857.0
      },
      {
        "periodo": 202602,
        "valor": 1606533989.0,
        "delta": -17165086.0
      },
      {
        "periodo": 202603,
        "valor": 1664385988.0,
        "delta": 57851999.0
      },
      {
        "periodo": 202604,
        "valor": 1644012332.0,
        "delta": -20373656.0
      },
      {
        "periodo": 202605,
        "valor": 1721351750.0,
        "delta": 77339418.0
      },
      {
        "periodo": 202606,
        "valor": 1693945170.0,
        "delta": -27406580.0
      },
      {
        "periodo": 202607,
        "valor": 1702312889.0,
        "delta": 8367719.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 599419869.0,
    "valor_anterior": 599533767.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 449906804.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 471653862.0,
        "delta": 21747058.0
      },
      {
        "periodo": 202509,
        "valor": 480115123.0,
        "delta": 8461261.0
      },
      {
        "periodo": 202510,
        "valor": 464655172.0,
        "delta": -15459951.0
      },
      {
        "periodo": 202511,
        "valor": 487845431.0,
        "delta": 23190259.0
      },
      {
        "periodo": 202512,
        "valor": 555038733.0,
        "delta": 67193302.0
      },
      {
        "periodo": 202601,
        "valor": 470911557.0,
        "delta": -84127176.0
      },
      {
        "periodo": 202602,
        "valor": 680115925.0,
        "delta": 209204368.0
      },
      {
        "periodo": 202603,
        "valor": 757027854.0,
        "delta": 76911929.0
      },
      {
        "periodo": 202604,
        "valor": 558937475.0,
        "delta": -198090379.0
      },
      {
        "periodo": 202605,
        "valor": 683649147.0,
        "delta": 124711672.0
      },
      {
        "periodo": 202606,
        "valor": 599533767.0,
        "delta": -84115380.0
      },
      {
        "periodo": 202607,
        "valor": 599419869.0,
        "delta": -113898.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 755817387.0,
    "valor_anterior": 795291604.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 824915541.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 818339641.0,
        "delta": -6575900.0
      },
      {
        "periodo": 202509,
        "valor": 834368835.0,
        "delta": 16029194.0
      },
      {
        "periodo": 202510,
        "valor": 822773266.0,
        "delta": -11595569.0
      },
      {
        "periodo": 202511,
        "valor": 828551096.0,
        "delta": 5777830.0
      },
      {
        "periodo": 202512,
        "valor": 795107186.0,
        "delta": -33443910.0
      },
      {
        "periodo": 202601,
        "valor": 809277190.0,
        "delta": 14170004.0
      },
      {
        "periodo": 202602,
        "valor": 812819514.0,
        "delta": 3542324.0
      },
      {
        "periodo": 202603,
        "valor": 785390499.0,
        "delta": -27429015.0
      },
      {
        "periodo": 202604,
        "valor": 789797686.0,
        "delta": 4407187.0
      },
      {
        "periodo": 202605,
        "valor": 798533722.0,
        "delta": 8736036.0
      },
      {
        "periodo": 202606,
        "valor": 795291604.0,
        "delta": -3242118.0
      },
      {
        "periodo": 202607,
        "valor": 755817387.0,
        "delta": -39474217.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 13370989115.47,
    "valor_anterior": 13037007708.87,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11312379560.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11823259459.68,
        "delta": 510879899.03
      },
      {
        "periodo": 202509,
        "valor": 11803992275.95,
        "delta": -19267183.73
      },
      {
        "periodo": 202510,
        "valor": 11764856351.72,
        "delta": -39135924.23
      },
      {
        "periodo": 202511,
        "valor": 12167742859.25,
        "delta": 402886507.53
      },
      {
        "periodo": 202512,
        "valor": 12235411344.81,
        "delta": 67668485.56
      },
      {
        "periodo": 202601,
        "valor": 12986795028.15,
        "delta": 751383683.34
      },
      {
        "periodo": 202602,
        "valor": 13137144272.21,
        "delta": 150349244.06
      },
      {
        "periodo": 202603,
        "valor": 13229220966.21,
        "delta": 92076694.0
      },
      {
        "periodo": 202604,
        "valor": 13177504374.0,
        "delta": -51716592.21
      },
      {
        "periodo": 202605,
        "valor": 13380819025.25,
        "delta": 203314651.25
      },
      {
        "periodo": 202606,
        "valor": 13037007708.87,
        "delta": -343811316.38
      },
      {
        "periodo": 202607,
        "valor": 13370989115.47,
        "delta": 333981406.6
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 356087818.0,
    "valor_anterior": 366262896.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 436463927.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 434189588.0,
        "delta": -2274339.0
      },
      {
        "periodo": 202509,
        "valor": 532592779.0,
        "delta": 98403191.0
      },
      {
        "periodo": 202510,
        "valor": 461209077.0,
        "delta": -71383702.0
      },
      {
        "periodo": 202511,
        "valor": 438479571.0,
        "delta": -22729506.0
      },
      {
        "periodo": 202512,
        "valor": 439311554.0,
        "delta": 831983.0
      },
      {
        "periodo": 202601,
        "valor": 408816717.0,
        "delta": -30494837.0
      },
      {
        "periodo": 202602,
        "valor": 423214637.0,
        "delta": 14397920.0
      },
      {
        "periodo": 202603,
        "valor": 412850149.0,
        "delta": -10364488.0
      },
      {
        "periodo": 202604,
        "valor": 380229599.0,
        "delta": -32620550.0
      },
      {
        "periodo": 202605,
        "valor": 344487255.0,
        "delta": -35742344.0
      },
      {
        "periodo": 202606,
        "valor": 366262896.0,
        "delta": 21775641.0
      },
      {
        "periodo": 202607,
        "valor": 356087818.0,
        "delta": -10175078.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 56701410.0,
    "valor_anterior": 61524047.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 53737633.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 57881133.0,
        "delta": 4143500.0
      },
      {
        "periodo": 202509,
        "valor": 49944843.0,
        "delta": -7936290.0
      },
      {
        "periodo": 202510,
        "valor": 69239498.0,
        "delta": 19294655.0
      },
      {
        "periodo": 202511,
        "valor": 61429489.0,
        "delta": -7810009.0
      },
      {
        "periodo": 202512,
        "valor": 53843955.0,
        "delta": -7585534.0
      },
      {
        "periodo": 202601,
        "valor": 44233332.0,
        "delta": -9610623.0
      },
      {
        "periodo": 202602,
        "valor": 65188851.0,
        "delta": 20955519.0
      },
      {
        "periodo": 202603,
        "valor": 78441637.0,
        "delta": 13252786.0
      },
      {
        "periodo": 202604,
        "valor": 69053920.0,
        "delta": -9387717.0
      },
      {
        "periodo": 202605,
        "valor": 46553392.0,
        "delta": -22500528.0
      },
      {
        "periodo": 202606,
        "valor": 61524047.0,
        "delta": 14970655.0
      },
      {
        "periodo": 202607,
        "valor": 56701410.0,
        "delta": -4822637.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 178297986.0,
    "valor_anterior": 178189804.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 158366582.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 159501945.0,
        "delta": 1135363.0
      },
      {
        "periodo": 202509,
        "valor": 146027158.0,
        "delta": -13474787.0
      },
      {
        "periodo": 202510,
        "valor": 141735659.0,
        "delta": -4291499.0
      },
      {
        "periodo": 202511,
        "valor": 142636554.0,
        "delta": 900895.0
      },
      {
        "periodo": 202512,
        "valor": 173510119.0,
        "delta": 30873565.0
      },
      {
        "periodo": 202601,
        "valor": 181593179.0,
        "delta": 8083060.0
      },
      {
        "periodo": 202602,
        "valor": 190476915.0,
        "delta": 8883736.0
      },
      {
        "periodo": 202603,
        "valor": 175287665.0,
        "delta": -15189250.0
      },
      {
        "periodo": 202604,
        "valor": 172779711.0,
        "delta": -2507954.0
      },
      {
        "periodo": 202605,
        "valor": 174264474.0,
        "delta": 1484763.0
      },
      {
        "periodo": 202606,
        "valor": 178189804.0,
        "delta": 3925330.0
      },
      {
        "periodo": 202607,
        "valor": 178297986.0,
        "delta": 108182.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 340381136.17,
    "valor_anterior": 351636808.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 364447663.56,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 354317733.38,
        "delta": -10129930.18
      },
      {
        "periodo": 202509,
        "valor": 364452673.64,
        "delta": 10134940.26
      },
      {
        "periodo": 202510,
        "valor": 352396875.05,
        "delta": -12055798.59
      },
      {
        "periodo": 202511,
        "valor": 363546489.31,
        "delta": 11149614.26
      },
      {
        "periodo": 202512,
        "valor": 376035562.15,
        "delta": 12489072.84
      },
      {
        "periodo": 202601,
        "valor": 373438101.37,
        "delta": -2597460.78
      },
      {
        "periodo": 202602,
        "valor": 373201926.69,
        "delta": -236174.68
      },
      {
        "periodo": 202603,
        "valor": 384043404.2,
        "delta": 10841477.51
      },
      {
        "periodo": 202604,
        "valor": 366403631.75,
        "delta": -17639772.45
      },
      {
        "periodo": 202605,
        "valor": 361731274.69,
        "delta": -4672357.06
      },
      {
        "periodo": 202606,
        "valor": 351636808.0,
        "delta": -10094466.69
      },
      {
        "periodo": 202607,
        "valor": 340381136.17,
        "delta": -11255671.83
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 441609203.0,
    "valor_anterior": 472970413.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 396376298.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 368824717.0,
        "delta": -27551581.0
      },
      {
        "periodo": 202509,
        "valor": 399115521.0,
        "delta": 30290804.0
      },
      {
        "periodo": 202510,
        "valor": 387834073.0,
        "delta": -11281448.0
      },
      {
        "periodo": 202511,
        "valor": 396886700.0,
        "delta": 9052627.0
      },
      {
        "periodo": 202512,
        "valor": 410891647.0,
        "delta": 14004947.0
      },
      {
        "periodo": 202601,
        "valor": 396681653.0,
        "delta": -14209994.0
      },
      {
        "periodo": 202602,
        "valor": 460967597.0,
        "delta": 64285944.0
      },
      {
        "periodo": 202603,
        "valor": 464689921.0,
        "delta": 3722324.0
      },
      {
        "periodo": 202604,
        "valor": 432830558.0,
        "delta": -31859363.0
      },
      {
        "periodo": 202605,
        "valor": 423783629.0,
        "delta": -9046929.0
      },
      {
        "periodo": 202606,
        "valor": 472970413.0,
        "delta": 49186784.0
      },
      {
        "periodo": 202607,
        "valor": 441609203.0,
        "delta": -31361210.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 1438222307.4299998,
    "valor_anterior": 1391430042.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1970202690.55,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1920345969.76,
        "delta": -49856720.79
      },
      {
        "periodo": 202509,
        "valor": 1807504763.64,
        "delta": -112841206.12
      },
      {
        "periodo": 202510,
        "valor": 1969364540.65,
        "delta": 161859777.01
      },
      {
        "periodo": 202511,
        "valor": 1893913356.3,
        "delta": -75451184.35
      },
      {
        "periodo": 202512,
        "valor": 1744447661.31,
        "delta": -149465694.99
      },
      {
        "periodo": 202601,
        "valor": 1656813381.9,
        "delta": -87634279.41
      },
      {
        "periodo": 202602,
        "valor": 1664814147.45,
        "delta": 8000765.55
      },
      {
        "periodo": 202603,
        "valor": 1495504948.68,
        "delta": -169309198.77
      },
      {
        "periodo": 202604,
        "valor": 1440784781.57,
        "delta": -54720167.11
      },
      {
        "periodo": 202605,
        "valor": 1389835421.67,
        "delta": -50949359.9
      },
      {
        "periodo": 202606,
        "valor": 1391430042.2,
        "delta": 1594620.53
      },
      {
        "periodo": 202607,
        "valor": 1438222307.43,
        "delta": 46792265.23
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 7018221821.150001,
    "valor_anterior": 6680835354.44,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7437511081.44,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7462278272.08,
        "delta": 24767190.64
      },
      {
        "periodo": 202509,
        "valor": 6923964907.07,
        "delta": -538313365.01
      },
      {
        "periodo": 202510,
        "valor": 6973591689.07,
        "delta": 49626782.0
      },
      {
        "periodo": 202511,
        "valor": 6912371744.97,
        "delta": -61219944.1
      },
      {
        "periodo": 202512,
        "valor": 6859452478.23,
        "delta": -52919266.74
      },
      {
        "periodo": 202601,
        "valor": 6627442554.52,
        "delta": -232009923.71
      },
      {
        "periodo": 202602,
        "valor": 6474663167.32,
        "delta": -152779387.2
      },
      {
        "periodo": 202603,
        "valor": 6268559207.81,
        "delta": -206103959.51
      },
      {
        "periodo": 202604,
        "valor": 5967843684.1,
        "delta": -300715523.71
      },
      {
        "periodo": 202605,
        "valor": 6627093971.01,
        "delta": 659250286.91
      },
      {
        "periodo": 202606,
        "valor": 6680835354.44,
        "delta": 53741383.43
      },
      {
        "periodo": 202607,
        "valor": 7018221821.15,
        "delta": 337386466.71
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 322516436.71,
    "valor_anterior": 330274760.51,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 183123089.61,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 180767672.27,
        "delta": -2355417.34
      },
      {
        "periodo": 202509,
        "valor": 309048082.97,
        "delta": 128280410.7
      },
      {
        "periodo": 202510,
        "valor": 206542217.38,
        "delta": -102505865.59
      },
      {
        "periodo": 202511,
        "valor": 269976140.77,
        "delta": 63433923.39
      },
      {
        "periodo": 202512,
        "valor": 259603697.66,
        "delta": -10372443.11
      },
      {
        "periodo": 202601,
        "valor": 243173766.24,
        "delta": -16429931.42
      },
      {
        "periodo": 202602,
        "valor": 214991838.84,
        "delta": -28181927.4
      },
      {
        "periodo": 202603,
        "valor": 184364181.52,
        "delta": -30627657.32
      },
      {
        "periodo": 202604,
        "valor": 335596087.75,
        "delta": 151231906.23
      },
      {
        "periodo": 202605,
        "valor": 831672571.15,
        "delta": 496076483.4
      },
      {
        "periodo": 202606,
        "valor": 330274760.51,
        "delta": -501397810.64
      },
      {
        "periodo": 202607,
        "valor": 322516436.71,
        "delta": -7758323.8
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 2418209709.0,
    "valor_anterior": 2336193564.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2240224262.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2265407449.0,
        "delta": 25183187.0
      },
      {
        "periodo": 202509,
        "valor": 2345778204.0,
        "delta": 80370755.0
      },
      {
        "periodo": 202510,
        "valor": 2367073597.0,
        "delta": 21295393.0
      },
      {
        "periodo": 202511,
        "valor": 2267931055.0,
        "delta": -99142542.0
      },
      {
        "periodo": 202512,
        "valor": 2311511618.0,
        "delta": 43580563.0
      },
      {
        "periodo": 202601,
        "valor": 2203731827.0,
        "delta": -107779791.0
      },
      {
        "periodo": 202602,
        "valor": 2252957468.0,
        "delta": 49225641.0
      },
      {
        "periodo": 202603,
        "valor": 2290494304.0,
        "delta": 37536836.0
      },
      {
        "periodo": 202604,
        "valor": 2352991638.0,
        "delta": 62497334.0
      },
      {
        "periodo": 202605,
        "valor": 2312436660.0,
        "delta": -40554978.0
      },
      {
        "periodo": 202606,
        "valor": 2336193564.0,
        "delta": 23756904.0
      },
      {
        "periodo": 202607,
        "valor": 2418209709.0,
        "delta": 82016145.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 988841276.0,
    "valor_anterior": 999701595.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 719593238.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 709106547.0,
        "delta": -10486691.0
      },
      {
        "periodo": 202509,
        "valor": 867634025.0,
        "delta": 158527478.0
      },
      {
        "periodo": 202510,
        "valor": 859276118.0,
        "delta": -8357907.0
      },
      {
        "periodo": 202511,
        "valor": 865654697.0,
        "delta": 6378579.0
      },
      {
        "periodo": 202512,
        "valor": 924581185.0,
        "delta": 58926488.0
      },
      {
        "periodo": 202601,
        "valor": 893972206.0,
        "delta": -30608979.0
      },
      {
        "periodo": 202602,
        "valor": 919751367.0,
        "delta": 25779161.0
      },
      {
        "periodo": 202603,
        "valor": 891578786.0,
        "delta": -28172581.0
      },
      {
        "periodo": 202604,
        "valor": 910117824.0,
        "delta": 18539038.0
      },
      {
        "periodo": 202605,
        "valor": 926395495.0,
        "delta": 16277671.0
      },
      {
        "periodo": 202606,
        "valor": 999701595.0,
        "delta": 73306100.0
      },
      {
        "periodo": 202607,
        "valor": 988841276.0,
        "delta": -10860319.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 322830878.0,
    "valor_anterior": 328886476.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 302141343.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 313345561.0,
        "delta": 11204218.0
      },
      {
        "periodo": 202509,
        "valor": 318627800.0,
        "delta": 5282239.0
      },
      {
        "periodo": 202510,
        "valor": 303748215.0,
        "delta": -14879585.0
      },
      {
        "periodo": 202511,
        "valor": 304871618.0,
        "delta": 1123403.0
      },
      {
        "periodo": 202512,
        "valor": 329569545.0,
        "delta": 24697927.0
      },
      {
        "periodo": 202601,
        "valor": 342645798.0,
        "delta": 13076253.0
      },
      {
        "periodo": 202602,
        "valor": 356074224.0,
        "delta": 13428426.0
      },
      {
        "periodo": 202603,
        "valor": 346758009.0,
        "delta": -9316215.0
      },
      {
        "periodo": 202604,
        "valor": 318727262.0,
        "delta": -28030747.0
      },
      {
        "periodo": 202605,
        "valor": 311239380.0,
        "delta": -7487882.0
      },
      {
        "periodo": 202606,
        "valor": 328886476.0,
        "delta": 17647096.0
      },
      {
        "periodo": 202607,
        "valor": 322830878.0,
        "delta": -6055598.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 154974491.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 129589181.0,
        "delta": -25385310.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 2501254918.64,
    "valor_anterior": 2598419381.22,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2312779868.76,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2439044629.79,
        "delta": 126264761.03
      },
      {
        "periodo": 202509,
        "valor": 2450265348.55,
        "delta": 11220718.76
      },
      {
        "periodo": 202510,
        "valor": 2456992425.17,
        "delta": 6727076.62
      },
      {
        "periodo": 202511,
        "valor": 2479792322.39,
        "delta": 22799897.22
      },
      {
        "periodo": 202512,
        "valor": 2568901732.16,
        "delta": 89109409.77
      },
      {
        "periodo": 202601,
        "valor": 2591529904.11,
        "delta": 22628171.95
      },
      {
        "periodo": 202602,
        "valor": 2575610603.87,
        "delta": -15919300.24
      },
      {
        "periodo": 202603,
        "valor": 2521469456.43,
        "delta": -54141147.44
      },
      {
        "periodo": 202604,
        "valor": 2498551009.43,
        "delta": -22918447.0
      },
      {
        "periodo": 202605,
        "valor": 2516736909.64,
        "delta": 18185900.21
      },
      {
        "periodo": 202606,
        "valor": 2598419381.22,
        "delta": 81682471.58
      },
      {
        "periodo": 202607,
        "valor": 2501254918.64,
        "delta": -97164462.58
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 106714891.0,
    "valor_anterior": 107060603.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 52198067.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 53764927.0,
        "delta": 1566860.0
      },
      {
        "periodo": 202509,
        "valor": 66945123.0,
        "delta": 13180196.0
      },
      {
        "periodo": 202510,
        "valor": 70679327.0,
        "delta": 3734204.0
      },
      {
        "periodo": 202511,
        "valor": 75518551.0,
        "delta": 4839224.0
      },
      {
        "periodo": 202512,
        "valor": 76804193.0,
        "delta": 1285642.0
      },
      {
        "periodo": 202601,
        "valor": 78138758.0,
        "delta": 1334565.0
      },
      {
        "periodo": 202602,
        "valor": 85415230.0,
        "delta": 7276472.0
      },
      {
        "periodo": 202603,
        "valor": 92875434.0,
        "delta": 7460204.0
      },
      {
        "periodo": 202604,
        "valor": 98673179.0,
        "delta": 5797745.0
      },
      {
        "periodo": 202605,
        "valor": 103830007.99,
        "delta": 5156828.99
      },
      {
        "periodo": 202606,
        "valor": 107060603.0,
        "delta": 3230595.01
      },
      {
        "periodo": 202607,
        "valor": 106714891.0,
        "delta": -345712.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 1511714.0,
    "valor_anterior": 1472185.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1078552.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1381933.0,
        "delta": 303381.0
      },
      {
        "periodo": 202509,
        "valor": 1410555.0,
        "delta": 28622.0
      },
      {
        "periodo": 202510,
        "valor": 1383301.0,
        "delta": -27254.0
      },
      {
        "periodo": 202511,
        "valor": 1243696.0,
        "delta": -139605.0
      },
      {
        "periodo": 202512,
        "valor": 1258209.0,
        "delta": 14513.0
      },
      {
        "periodo": 202601,
        "valor": 1258209.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 1258209.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1243527.0,
        "delta": -14682.0
      },
      {
        "periodo": 202604,
        "valor": 1243527.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1436036.0,
        "delta": 192509.0
      },
      {
        "periodo": 202606,
        "valor": 1472185.0,
        "delta": 36149.0
      },
      {
        "periodo": 202607,
        "valor": 1511714.0,
        "delta": 39529.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 652582421.0,
    "valor_anterior": 612569786.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 576049491.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 577263951.0,
        "delta": 1214460.0
      },
      {
        "periodo": 202509,
        "valor": 587353983.0,
        "delta": 10090032.0
      },
      {
        "periodo": 202510,
        "valor": 598446447.0,
        "delta": 11092464.0
      },
      {
        "periodo": 202511,
        "valor": 591222306.0,
        "delta": -7224141.0
      },
      {
        "periodo": 202512,
        "valor": 593817516.0,
        "delta": 2595210.0
      },
      {
        "periodo": 202601,
        "valor": 608424908.0,
        "delta": 14607392.0
      },
      {
        "periodo": 202602,
        "valor": 616802505.0,
        "delta": 8377597.0
      },
      {
        "periodo": 202603,
        "valor": 623212938.0,
        "delta": 6410433.0
      },
      {
        "periodo": 202604,
        "valor": 639975588.0,
        "delta": 16762650.0
      },
      {
        "periodo": 202605,
        "valor": 627671534.0,
        "delta": -12304054.0
      },
      {
        "periodo": 202606,
        "valor": 612569786.0,
        "delta": -15101748.0
      },
      {
        "periodo": 202607,
        "valor": 652582421.0,
        "delta": 40012635.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 98013944.0,
    "valor_anterior": 92423171.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 83683706.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 121947816.0,
        "delta": 38264110.0
      },
      {
        "periodo": 202509,
        "valor": 80344030.0,
        "delta": -41603786.0
      },
      {
        "periodo": 202510,
        "valor": 87639659.0,
        "delta": 7295629.0
      },
      {
        "periodo": 202511,
        "valor": 119493600.0,
        "delta": 31853941.0
      },
      {
        "periodo": 202512,
        "valor": 108051901.0,
        "delta": -11441699.0
      },
      {
        "periodo": 202601,
        "valor": 126097631.0,
        "delta": 18045730.0
      },
      {
        "periodo": 202602,
        "valor": 112238598.0,
        "delta": -13859033.0
      },
      {
        "periodo": 202603,
        "valor": 90055023.0,
        "delta": -22183575.0
      },
      {
        "periodo": 202604,
        "valor": 92370568.0,
        "delta": 2315545.0
      },
      {
        "periodo": 202605,
        "valor": 123652639.0,
        "delta": 31282071.0
      },
      {
        "periodo": 202606,
        "valor": 92423171.0,
        "delta": -31229468.0
      },
      {
        "periodo": 202607,
        "valor": 98013944.0,
        "delta": 5590773.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 165198232.8,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 74776858.27,
        "delta": -90421374.53
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 66058441.0,
    "valor_anterior": 69978440.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 78502989.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 68154156.0,
        "delta": -10348833.0
      },
      {
        "periodo": 202509,
        "valor": 74222950.0,
        "delta": 6068794.0
      },
      {
        "periodo": 202510,
        "valor": 74785536.0,
        "delta": 562586.0
      },
      {
        "periodo": 202511,
        "valor": 63806733.0,
        "delta": -10978803.0
      },
      {
        "periodo": 202512,
        "valor": 68322227.0,
        "delta": 4515494.0
      },
      {
        "periodo": 202601,
        "valor": 62642703.0,
        "delta": -5679524.0
      },
      {
        "periodo": 202602,
        "valor": 69941011.0,
        "delta": 7298308.0
      },
      {
        "periodo": 202603,
        "valor": 72423633.0,
        "delta": 2482622.0
      },
      {
        "periodo": 202604,
        "valor": 65457296.0,
        "delta": -6966337.0
      },
      {
        "periodo": 202605,
        "valor": 65216504.0,
        "delta": -240792.0
      },
      {
        "periodo": 202606,
        "valor": 69978440.0,
        "delta": 4761936.0
      },
      {
        "periodo": 202607,
        "valor": 66058441.0,
        "delta": -3919999.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 230569002.88,
    "valor_anterior": 228688110.15,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 185241275.88,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 188132687.92,
        "delta": 2891412.04
      },
      {
        "periodo": 202509,
        "valor": 169326503.99,
        "delta": -18806183.93
      },
      {
        "periodo": 202510,
        "valor": 174299578.86,
        "delta": 4973074.87
      },
      {
        "periodo": 202511,
        "valor": 185756420.87,
        "delta": 11456842.01
      },
      {
        "periodo": 202512,
        "valor": 185346496.89,
        "delta": -409923.98
      },
      {
        "periodo": 202601,
        "valor": 198757534.3,
        "delta": 13411037.41
      },
      {
        "periodo": 202602,
        "valor": 216481589.26,
        "delta": 17724054.96
      },
      {
        "periodo": 202603,
        "valor": 217444863.61,
        "delta": 963274.35
      },
      {
        "periodo": 202604,
        "valor": 221653275.49,
        "delta": 4208411.88
      },
      {
        "periodo": 202605,
        "valor": 230918535.74,
        "delta": 9265260.25
      },
      {
        "periodo": 202606,
        "valor": 228688110.15,
        "delta": -2230425.59
      },
      {
        "periodo": 202607,
        "valor": 230569002.88,
        "delta": 1880892.73
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 14075273.0,
    "valor_anterior": 15465962.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10777028.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13165345.0,
        "delta": 2388317.0
      },
      {
        "periodo": 202509,
        "valor": 18160034.0,
        "delta": 4994689.0
      },
      {
        "periodo": 202510,
        "valor": 18892675.0,
        "delta": 732641.0
      },
      {
        "periodo": 202511,
        "valor": 21736682.0,
        "delta": 2844007.0
      },
      {
        "periodo": 202512,
        "valor": 17665266.0,
        "delta": -4071416.0
      },
      {
        "periodo": 202601,
        "valor": 18146216.0,
        "delta": 480950.0
      },
      {
        "periodo": 202602,
        "valor": 17688072.0,
        "delta": -458144.0
      },
      {
        "periodo": 202603,
        "valor": 18715014.0,
        "delta": 1026942.0
      },
      {
        "periodo": 202604,
        "valor": 17551274.0,
        "delta": -1163740.0
      },
      {
        "periodo": 202605,
        "valor": 16143906.0,
        "delta": -1407368.0
      },
      {
        "periodo": 202606,
        "valor": 15465962.0,
        "delta": -677944.0
      },
      {
        "periodo": 202607,
        "valor": 14075273.0,
        "delta": -1390689.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 84518353.97,
    "valor_anterior": 88609720.43,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 83451953.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 77199657.31,
        "delta": -6252296.38
      },
      {
        "periodo": 202509,
        "valor": 78170754.57,
        "delta": 971097.26
      },
      {
        "periodo": 202510,
        "valor": 83997882.19,
        "delta": 5827127.62
      },
      {
        "periodo": 202511,
        "valor": 84054437.89,
        "delta": 56555.7
      },
      {
        "periodo": 202512,
        "valor": 91248783.39,
        "delta": 7194345.5
      },
      {
        "periodo": 202601,
        "valor": 86001095.8,
        "delta": -5247687.59
      },
      {
        "periodo": 202602,
        "valor": 93166144.69,
        "delta": 7165048.89
      },
      {
        "periodo": 202603,
        "valor": 92135677.08,
        "delta": -1030467.61
      },
      {
        "periodo": 202604,
        "valor": 89668135.7,
        "delta": -2467541.38
      },
      {
        "periodo": 202605,
        "valor": 80147925.2,
        "delta": -9520210.5
      },
      {
        "periodo": 202606,
        "valor": 88609720.43,
        "delta": 8461795.23
      },
      {
        "periodo": 202607,
        "valor": 84518353.97,
        "delta": -4091366.46
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 5827981.0,
    "valor_anterior": 5551566.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7338284.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6932108.0,
        "delta": -406176.0
      },
      {
        "periodo": 202509,
        "valor": 6604634.0,
        "delta": -327474.0
      },
      {
        "periodo": 202510,
        "valor": 6539047.0,
        "delta": -65587.0
      },
      {
        "periodo": 202511,
        "valor": 6475422.0,
        "delta": -63625.0
      },
      {
        "periodo": 202512,
        "valor": 6497074.0,
        "delta": 21652.0
      },
      {
        "periodo": 202601,
        "valor": 5968995.0,
        "delta": -528079.0
      },
      {
        "periodo": 202602,
        "valor": 6045669.0,
        "delta": 76674.0
      },
      {
        "periodo": 202603,
        "valor": 5930298.0,
        "delta": -115371.0
      },
      {
        "periodo": 202604,
        "valor": 5892060.0,
        "delta": -38238.0
      },
      {
        "periodo": 202605,
        "valor": 5612145.0,
        "delta": -279915.0
      },
      {
        "periodo": 202606,
        "valor": 5551566.0,
        "delta": -60579.0
      },
      {
        "periodo": 202607,
        "valor": 5827981.0,
        "delta": 276415.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 329331594.10999995,
    "valor_anterior": 351475039.03,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 295554433.99,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 302882713.49,
        "delta": 7328279.5
      },
      {
        "periodo": 202509,
        "valor": 295806855.6,
        "delta": -7075857.89
      },
      {
        "periodo": 202510,
        "valor": 308896437.1,
        "delta": 13089581.5
      },
      {
        "periodo": 202511,
        "valor": 318463895.59,
        "delta": 9567458.49
      },
      {
        "periodo": 202512,
        "valor": 313862055.8,
        "delta": -4601839.79
      },
      {
        "periodo": 202601,
        "valor": 321138821.26,
        "delta": 7276765.46
      },
      {
        "periodo": 202602,
        "valor": 299422357.0,
        "delta": -21716464.26
      },
      {
        "periodo": 202603,
        "valor": 322210364.71,
        "delta": 22788007.71
      },
      {
        "periodo": 202604,
        "valor": 329530317.69,
        "delta": 7319952.98
      },
      {
        "periodo": 202605,
        "valor": 328033372.84,
        "delta": -1496944.85
      },
      {
        "periodo": 202606,
        "valor": 351475039.03,
        "delta": 23441666.19
      },
      {
        "periodo": 202607,
        "valor": 329331594.11,
        "delta": -22143444.92
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 75916780.14999999,
    "valor_anterior": 73017609.17,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 48393682.97,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 49111022.1,
        "delta": 717339.13
      },
      {
        "periodo": 202509,
        "valor": 57507284.8,
        "delta": 8396262.7
      },
      {
        "periodo": 202510,
        "valor": 56159632.4,
        "delta": -1347652.4
      },
      {
        "periodo": 202511,
        "valor": 58666578.12,
        "delta": 2506945.72
      },
      {
        "periodo": 202512,
        "valor": 62036300.06,
        "delta": 3369721.94
      },
      {
        "periodo": 202601,
        "valor": 63075408.71,
        "delta": 1039108.65
      },
      {
        "periodo": 202602,
        "valor": 62254522.97,
        "delta": -820885.74
      },
      {
        "periodo": 202603,
        "valor": 61869615.35,
        "delta": -384907.62
      },
      {
        "periodo": 202604,
        "valor": 58912166.74,
        "delta": -2957448.61
      },
      {
        "periodo": 202605,
        "valor": 75358426.03,
        "delta": 16446259.29
      },
      {
        "periodo": 202606,
        "valor": 73017609.17,
        "delta": -2340816.86
      },
      {
        "periodo": 202607,
        "valor": 75916780.15,
        "delta": 2899170.98
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 40209726.0,
    "valor_anterior": 40964316.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 35230879.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 37254806.0,
        "delta": 2023927.0
      },
      {
        "periodo": 202509,
        "valor": 31448906.0,
        "delta": -5805900.0
      },
      {
        "periodo": 202510,
        "valor": 33396249.0,
        "delta": 1947343.0
      },
      {
        "periodo": 202511,
        "valor": 33833250.0,
        "delta": 437001.0
      },
      {
        "periodo": 202512,
        "valor": 40772105.0,
        "delta": 6938855.0
      },
      {
        "periodo": 202601,
        "valor": 39679848.0,
        "delta": -1092257.0
      },
      {
        "periodo": 202602,
        "valor": 42202717.0,
        "delta": 2522869.0
      },
      {
        "periodo": 202603,
        "valor": 32223521.0,
        "delta": -9979196.0
      },
      {
        "periodo": 202604,
        "valor": 31533713.0,
        "delta": -689808.0
      },
      {
        "periodo": 202605,
        "valor": 34038766.0,
        "delta": 2505053.0
      },
      {
        "periodo": 202606,
        "valor": 40964316.0,
        "delta": 6925550.0
      },
      {
        "periodo": 202607,
        "valor": 40209726.0,
        "delta": -754590.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 544643679.0,
    "valor_anterior": 535168223.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 542841801.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 540470500.0,
        "delta": -2371301.0
      },
      {
        "periodo": 202509,
        "valor": 530873980.0,
        "delta": -9596520.0
      },
      {
        "periodo": 202510,
        "valor": 536714751.0,
        "delta": 5840771.0
      },
      {
        "periodo": 202511,
        "valor": 528987112.0,
        "delta": -7727639.0
      },
      {
        "periodo": 202512,
        "valor": 557929424.0,
        "delta": 28942312.0
      },
      {
        "periodo": 202601,
        "valor": 551841127.0,
        "delta": -6088297.0
      },
      {
        "periodo": 202602,
        "valor": 572079791.0,
        "delta": 20238664.0
      },
      {
        "periodo": 202603,
        "valor": 571719432.0,
        "delta": -360359.0
      },
      {
        "periodo": 202604,
        "valor": 575341102.0,
        "delta": 3621670.0
      },
      {
        "periodo": 202605,
        "valor": 565351966.0,
        "delta": -9989136.0
      },
      {
        "periodo": 202606,
        "valor": 535168223.0,
        "delta": -30183743.0
      },
      {
        "periodo": 202607,
        "valor": 544643679.0,
        "delta": 9475456.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 16246864.0,
    "valor_anterior": 20732896.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26184546.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21576610.0,
        "delta": -4607936.0
      },
      {
        "periodo": 202509,
        "valor": 20676642.0,
        "delta": -899968.0
      },
      {
        "periodo": 202510,
        "valor": 20351023.0,
        "delta": -325619.0
      },
      {
        "periodo": 202511,
        "valor": 20393316.0,
        "delta": 42293.0
      },
      {
        "periodo": 202512,
        "valor": 20125174.0,
        "delta": -268142.0
      },
      {
        "periodo": 202601,
        "valor": 18726594.0,
        "delta": -1398580.0
      },
      {
        "periodo": 202602,
        "valor": 18333895.0,
        "delta": -392699.0
      },
      {
        "periodo": 202603,
        "valor": 19137504.0,
        "delta": 803609.0
      },
      {
        "periodo": 202604,
        "valor": 18659733.0,
        "delta": -477771.0
      },
      {
        "periodo": 202605,
        "valor": 17788005.0,
        "delta": -871728.0
      },
      {
        "periodo": 202606,
        "valor": 20732896.0,
        "delta": 2944891.0
      },
      {
        "periodo": 202607,
        "valor": 16246864.0,
        "delta": -4486032.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 32116358.25,
    "valor_anterior": 32058894.240000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28253173.35,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28112973.18,
        "delta": -140200.17
      },
      {
        "periodo": 202509,
        "valor": 28318030.37,
        "delta": 205057.19
      },
      {
        "periodo": 202510,
        "valor": 27725590.54,
        "delta": -592439.83
      },
      {
        "periodo": 202511,
        "valor": 11149997.6,
        "delta": -16575592.94
      },
      {
        "periodo": 202512,
        "valor": 11603831.79,
        "delta": 453834.19
      },
      {
        "periodo": 202601,
        "valor": 12053541.31,
        "delta": 449709.52
      },
      {
        "periodo": 202602,
        "valor": 13671554.57,
        "delta": 1618013.26
      },
      {
        "periodo": 202603,
        "valor": 13129475.87,
        "delta": -542078.7
      },
      {
        "periodo": 202604,
        "valor": 31543881.07,
        "delta": 18414405.2
      },
      {
        "periodo": 202605,
        "valor": 32444651.0,
        "delta": 900769.93
      },
      {
        "periodo": 202606,
        "valor": 32058894.24,
        "delta": -385756.76
      },
      {
        "periodo": 202607,
        "valor": 32116358.25,
        "delta": 57464.01
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 24437405.619999997,
    "valor_anterior": 23610641.990000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17405341.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13439374.67,
        "delta": -3965967.07
      },
      {
        "periodo": 202509,
        "valor": 13270286.89,
        "delta": -169087.78
      },
      {
        "periodo": 202510,
        "valor": 15101465.83,
        "delta": 1831178.94
      },
      {
        "periodo": 202511,
        "valor": 14892698.38,
        "delta": -208767.45
      },
      {
        "periodo": 202512,
        "valor": 13737005.01,
        "delta": -1155693.37
      },
      {
        "periodo": 202601,
        "valor": 14325989.67,
        "delta": 588984.66
      },
      {
        "periodo": 202602,
        "valor": 15415487.92,
        "delta": 1089498.25
      },
      {
        "periodo": 202603,
        "valor": 17897617.55,
        "delta": 2482129.63
      },
      {
        "periodo": 202604,
        "valor": 18773963.63,
        "delta": 876346.08
      },
      {
        "periodo": 202605,
        "valor": 18753124.83,
        "delta": -20838.8
      },
      {
        "periodo": 202606,
        "valor": 23610641.99,
        "delta": 4857517.16
      },
      {
        "periodo": 202607,
        "valor": 24437405.62,
        "delta": 826763.63
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 235.77,
    "valor_anterior": 119672.85,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1688531.86,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1276701.56,
        "delta": -411830.3
      },
      {
        "periodo": 202509,
        "valor": 223107.92,
        "delta": -1053593.64
      },
      {
        "periodo": 202510,
        "valor": 253066.57,
        "delta": 29958.65
      },
      {
        "periodo": 202511,
        "valor": 1229514.27,
        "delta": 976447.7
      },
      {
        "periodo": 202512,
        "valor": 85571.09,
        "delta": -1143943.18
      },
      {
        "periodo": 202601,
        "valor": 129073.64,
        "delta": 43502.55
      },
      {
        "periodo": 202602,
        "valor": 70076.61,
        "delta": -58997.03
      },
      {
        "periodo": 202603,
        "valor": 825540.72,
        "delta": 755464.11
      },
      {
        "periodo": 202604,
        "valor": 1106937.61,
        "delta": 281396.89
      },
      {
        "periodo": 202605,
        "valor": 271718.84,
        "delta": -835218.77
      },
      {
        "periodo": 202606,
        "valor": 119672.85,
        "delta": -152045.99
      },
      {
        "periodo": 202607,
        "valor": 235.77,
        "delta": -119437.08
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 14946819.0,
    "valor_anterior": 14980787.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19885598.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18196474.0,
        "delta": -1689124.0
      },
      {
        "periodo": 202509,
        "valor": 18024034.0,
        "delta": -172440.0
      },
      {
        "periodo": 202510,
        "valor": 17763676.0,
        "delta": -260358.0
      },
      {
        "periodo": 202511,
        "valor": 18165293.0,
        "delta": 401617.0
      },
      {
        "periodo": 202512,
        "valor": 17770055.0,
        "delta": -395238.0
      },
      {
        "periodo": 202601,
        "valor": 17447331.0,
        "delta": -322724.0
      },
      {
        "periodo": 202602,
        "valor": 17165966.0,
        "delta": -281365.0
      },
      {
        "periodo": 202603,
        "valor": 17913662.0,
        "delta": 747696.0
      },
      {
        "periodo": 202604,
        "valor": 18139139.0,
        "delta": 225477.0
      },
      {
        "periodo": 202605,
        "valor": 16153272.0,
        "delta": -1985867.0
      },
      {
        "periodo": 202606,
        "valor": 14980787.0,
        "delta": -1172485.0
      },
      {
        "periodo": 202607,
        "valor": 14946819.0,
        "delta": -33968.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 12409.05,
    "valor_anterior": 22262.38,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 539513.45,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 342869.0,
        "delta": -196644.45
      },
      {
        "periodo": 202509,
        "valor": 275586.5,
        "delta": -67282.5
      },
      {
        "periodo": 202510,
        "valor": 204526.72,
        "delta": -71059.78
      },
      {
        "periodo": 202511,
        "valor": 143343.03,
        "delta": -61183.69
      },
      {
        "periodo": 202512,
        "valor": 114182.76,
        "delta": -29160.27
      },
      {
        "periodo": 202601,
        "valor": 79718.05,
        "delta": -34464.71
      },
      {
        "periodo": 202602,
        "valor": 57875.23,
        "delta": -21842.82
      },
      {
        "periodo": 202603,
        "valor": 47044.19,
        "delta": -10831.04
      },
      {
        "periodo": 202604,
        "valor": 39602.26,
        "delta": -7441.93
      },
      {
        "periodo": 202605,
        "valor": 27646.02,
        "delta": -11956.24
      },
      {
        "periodo": 202606,
        "valor": 22262.38,
        "delta": -5383.64
      },
      {
        "periodo": 202607,
        "valor": 12409.05,
        "delta": -9853.33
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 227597671.57,
    "valor_anterior": 229132836.84,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 233544530.75,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 231389868.06,
        "delta": -2154662.69
      },
      {
        "periodo": 202604,
        "valor": 240283824.32,
        "delta": 8893956.26
      },
      {
        "periodo": 202605,
        "valor": 225535563.21,
        "delta": -14748261.11
      },
      {
        "periodo": 202606,
        "valor": 229132836.84,
        "delta": 3597273.63
      },
      {
        "periodo": 202607,
        "valor": 227597671.57,
        "delta": -1535165.27
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 43609293.0,
    "valor_anterior": 41455325.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20095018.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25983222.0,
        "delta": 5888204.0
      },
      {
        "periodo": 202509,
        "valor": 28039653.0,
        "delta": 2056431.0
      },
      {
        "periodo": 202510,
        "valor": 30459848.0,
        "delta": 2420195.0
      },
      {
        "periodo": 202511,
        "valor": 33913705.0,
        "delta": 3453857.0
      },
      {
        "periodo": 202512,
        "valor": 36828940.0,
        "delta": 2915235.0
      },
      {
        "periodo": 202601,
        "valor": 41039973.0,
        "delta": 4211033.0
      },
      {
        "periodo": 202602,
        "valor": 44314733.0,
        "delta": 3274760.0
      },
      {
        "periodo": 202603,
        "valor": 40033151.0,
        "delta": -4281582.0
      },
      {
        "periodo": 202604,
        "valor": 41522948.0,
        "delta": 1489797.0
      },
      {
        "periodo": 202605,
        "valor": 43738033.0,
        "delta": 2215085.0
      },
      {
        "periodo": 202606,
        "valor": 41455325.0,
        "delta": -2282708.0
      },
      {
        "periodo": 202607,
        "valor": 43609293.0,
        "delta": 2153968.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 37528339.0,
    "valor_anterior": 28111685.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 499740.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 1345171.0,
        "delta": 845431.0
      },
      {
        "periodo": 202601,
        "valor": 4483131.0,
        "delta": 3137960.0
      },
      {
        "periodo": 202602,
        "valor": 8970758.0,
        "delta": 4487627.0
      },
      {
        "periodo": 202603,
        "valor": 11841309.0,
        "delta": 2870551.0
      },
      {
        "periodo": 202604,
        "valor": 16939032.0,
        "delta": 5097723.0
      },
      {
        "periodo": 202605,
        "valor": 21652131.0,
        "delta": 4713099.0
      },
      {
        "periodo": 202606,
        "valor": 28111685.0,
        "delta": 6459554.0
      },
      {
        "periodo": 202607,
        "valor": 37528339.0,
        "delta": 9416654.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 1653150907.0,
    "valor_anterior": 1541347419.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 1297842245.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 1365213691.0,
        "delta": 67371446.0
      },
      {
        "periodo": 202605,
        "valor": 1458005801.0,
        "delta": 92792110.0
      },
      {
        "periodo": 202606,
        "valor": 1541347419.0,
        "delta": 83341618.0
      },
      {
        "periodo": 202607,
        "valor": 1653150907.0,
        "delta": 111803488.0
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 111800304005,
    "label": "EPRC Etapa 1",
    "valor_actual": 121510886090.79999,
    "valor_anterior": 120703492062.42,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 102147219190.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 102931125754.41,
        "delta": 783906563.88
      },
      {
        "periodo": 202509,
        "valor": 102896792234.31,
        "delta": -34333520.1
      },
      {
        "periodo": 202510,
        "valor": 103376475884.33,
        "delta": 479683650.02
      },
      {
        "periodo": 202511,
        "valor": 103485012926.51,
        "delta": 108537042.18
      },
      {
        "periodo": 202512,
        "valor": 104514984150.5,
        "delta": 1029971223.99
      },
      {
        "periodo": 202601,
        "valor": 104285436232.03,
        "delta": -229547918.47
      },
      {
        "periodo": 202602,
        "valor": 117556214970.12,
        "delta": 13270778738.09
      },
      {
        "periodo": 202603,
        "valor": 118939833850.47,
        "delta": 1383618880.35
      },
      {
        "periodo": 202604,
        "valor": 117388483331.17,
        "delta": -1551350519.3
      },
      {
        "periodo": 202605,
        "valor": 120290565508.16,
        "delta": 2902082176.99
      },
      {
        "periodo": 202606,
        "valor": 120703492062.42,
        "delta": 412926554.26
      },
      {
        "periodo": 202607,
        "valor": 121510886090.8,
        "delta": 807394028.38
      }
    ],
    "reportes": {
      "ejecutivo": false,
      "comparativo": false,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  }
],

  // Banner 2: Indicadores de tamaño (balance) + resultados financieros
  banner2: [
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 168006811740.0,
    "valor_anterior": 167171087475.9,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 106356187537.6,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 107050130756.6,
        "delta": 693943219.0
      },
      {
        "periodo": 202508,
        "valor": 107970688497.0,
        "delta": 920557740.4
      },
      {
        "periodo": 202509,
        "valor": 108329740426.0,
        "delta": 359051929.0
      },
      {
        "periodo": 202510,
        "valor": 109135865952.4,
        "delta": 806125526.4
      },
      {
        "periodo": 202511,
        "valor": 108001781515.7,
        "delta": -1134084436.7
      },
      {
        "periodo": 202512,
        "valor": 107134320144.1,
        "delta": -867461371.6
      },
      {
        "periodo": 202601,
        "valor": 112237171118.2,
        "delta": 5102850974.1
      },
      {
        "periodo": 202602,
        "valor": 142514380591.9,
        "delta": 30277209473.7
      },
      {
        "periodo": 202603,
        "valor": 144633858827.0,
        "delta": 2119478235.1
      },
      {
        "periodo": 202604,
        "valor": 137668099583.1,
        "delta": -6965759243.9
      },
      {
        "periodo": 202605,
        "valor": 167171087475.9,
        "delta": 29502987892.8
      },
      {
        "periodo": 202606,
        "valor": 168006811740.0,
        "delta": 835724264.1
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 475610695330.1,
    "valor_anterior": 488372130660.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 451098407684.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 458693044612.0,
        "delta": 7594636928.0
      },
      {
        "periodo": 202508,
        "valor": 468439994341.0,
        "delta": 9746949729.0
      },
      {
        "periodo": 202509,
        "valor": 459453999631.0,
        "delta": -8985994710.0
      },
      {
        "periodo": 202510,
        "valor": 469613191284.0,
        "delta": 10159191653.0
      },
      {
        "periodo": 202511,
        "valor": 474035255881.0,
        "delta": 4422064597.0
      },
      {
        "periodo": 202512,
        "valor": 463813050738.0,
        "delta": -10222205143.0
      },
      {
        "periodo": 202601,
        "valor": 472401735224.0,
        "delta": 8588684486.0
      },
      {
        "periodo": 202602,
        "valor": 481575309337.0,
        "delta": 9173574113.0
      },
      {
        "periodo": 202603,
        "valor": 473661679559.0,
        "delta": -7913629778.0
      },
      {
        "periodo": 202604,
        "valor": 479995866695.0,
        "delta": 6334187136.0
      },
      {
        "periodo": 202605,
        "valor": 488372130660.0,
        "delta": 8376263965.0
      },
      {
        "periodo": 202606,
        "valor": 475610695330.1,
        "delta": -12761435329.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 181570262627.6,
    "valor_anterior": 190685303054.125,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 186052765052.5,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 188782220156.4,
        "delta": 2729455103.9
      },
      {
        "periodo": 202508,
        "valor": 190460299598.5,
        "delta": 1678079442.1
      },
      {
        "periodo": 202509,
        "valor": 192107491104.6,
        "delta": 1647191506.1
      },
      {
        "periodo": 202510,
        "valor": 190207796587.0,
        "delta": -1899694517.6
      },
      {
        "periodo": 202511,
        "valor": 190551855737.9,
        "delta": 344059150.9
      },
      {
        "periodo": 202512,
        "valor": 176557406432.6,
        "delta": -13994449305.3
      },
      {
        "periodo": 202601,
        "valor": 179227719610.7,
        "delta": 2670313178.1
      },
      {
        "periodo": 202602,
        "valor": 182585213432.3,
        "delta": 3357493821.6
      },
      {
        "periodo": 202603,
        "valor": 189066567191.0,
        "delta": 6481353758.7
      },
      {
        "periodo": 202604,
        "valor": 187959466529.5,
        "delta": -1107100661.5
      },
      {
        "periodo": 202605,
        "valor": 190685303054.125,
        "delta": 2725836524.625
      },
      {
        "periodo": 202606,
        "valor": 181570262627.6,
        "delta": -9115040426.525
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 107976130115.3,
    "valor_anterior": 113955400026.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 104979270527.8,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 105974568456.2,
        "delta": 995297928.4
      },
      {
        "periodo": 202508,
        "valor": 107042465348.4,
        "delta": 1067896892.2
      },
      {
        "periodo": 202509,
        "valor": 107278286572.3,
        "delta": 235821223.9
      },
      {
        "periodo": 202510,
        "valor": 114047156525.8,
        "delta": 6768869953.5
      },
      {
        "periodo": 202511,
        "valor": 112149304636.5,
        "delta": -1897851889.3
      },
      {
        "periodo": 202512,
        "valor": 110235032819.7,
        "delta": -1914271816.8
      },
      {
        "periodo": 202601,
        "valor": 111156623558.8,
        "delta": 921590739.1
      },
      {
        "periodo": 202602,
        "valor": 112227354304.5,
        "delta": 1070730745.7
      },
      {
        "periodo": 202603,
        "valor": 113661092192.7,
        "delta": 1433737888.2
      },
      {
        "periodo": 202604,
        "valor": 113778013923.9,
        "delta": 116921731.2
      },
      {
        "periodo": 202605,
        "valor": 113955400026.0,
        "delta": 177386102.1
      },
      {
        "periodo": 202606,
        "valor": 107976130115.3,
        "delta": -5979269910.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 41323769807.0,
    "valor_anterior": 40759287223.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 39841337580.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 40504992480.0,
        "delta": 663654900.0
      },
      {
        "periodo": 202508,
        "valor": 40610468043.0,
        "delta": 105475563.0
      },
      {
        "periodo": 202509,
        "valor": 41389390224.0,
        "delta": 778922181.0
      },
      {
        "periodo": 202510,
        "valor": 42118308699.0,
        "delta": 728918475.0
      },
      {
        "periodo": 202511,
        "valor": 41807651271.0,
        "delta": -310657428.0
      },
      {
        "periodo": 202512,
        "valor": 42407825520.0,
        "delta": 600174249.0
      },
      {
        "periodo": 202601,
        "valor": 43096091136.0,
        "delta": 688265616.0
      },
      {
        "periodo": 202602,
        "valor": 43645808124.0,
        "delta": 549716988.0
      },
      {
        "periodo": 202603,
        "valor": 43918734079.0,
        "delta": 272925955.0
      },
      {
        "periodo": 202604,
        "valor": 40087251360.0,
        "delta": -3831482719.0
      },
      {
        "periodo": 202605,
        "valor": 40759287223.0,
        "delta": 672035863.0
      },
      {
        "periodo": 202606,
        "valor": 41323769807.0,
        "delta": 564482584.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 162652050118.0,
    "valor_anterior": 162047276236.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 149305080063.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 152244338570.0,
        "delta": 2939258507.0
      },
      {
        "periodo": 202508,
        "valor": 152706153099.0,
        "delta": 461814529.0
      },
      {
        "periodo": 202509,
        "valor": 153283063691.0,
        "delta": 576910592.0
      },
      {
        "periodo": 202510,
        "valor": 155071429189.0,
        "delta": 1788365498.0
      },
      {
        "periodo": 202511,
        "valor": 156561035919.0,
        "delta": 1489606730.0
      },
      {
        "periodo": 202512,
        "valor": 158708980657.0,
        "delta": 2147944738.0
      },
      {
        "periodo": 202601,
        "valor": 160032842743.0,
        "delta": 1323862086.0
      },
      {
        "periodo": 202602,
        "valor": 160725103047.0,
        "delta": 692260304.0
      },
      {
        "periodo": 202603,
        "valor": 161352042060.0,
        "delta": 626939013.0
      },
      {
        "periodo": 202604,
        "valor": 161141778391.0,
        "delta": -210263669.0
      },
      {
        "periodo": 202605,
        "valor": 162047276236.0,
        "delta": 905497845.0
      },
      {
        "periodo": 202606,
        "valor": 162652050118.0,
        "delta": 604773882.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 22310454788.0,
    "valor_anterior": 22127247485.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14923524917.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 15257970548.0,
        "delta": 334445631.0
      },
      {
        "periodo": 202508,
        "valor": 15525530784.0,
        "delta": 267560236.0
      },
      {
        "periodo": 202509,
        "valor": 15841405423.0,
        "delta": 315874639.0
      },
      {
        "periodo": 202510,
        "valor": 16159618198.0,
        "delta": 318212775.0
      },
      {
        "periodo": 202511,
        "valor": 16542626643.0,
        "delta": 383008445.0
      },
      {
        "periodo": 202512,
        "valor": 16591373712.0,
        "delta": 48747069.0
      },
      {
        "periodo": 202601,
        "valor": 16740358592.0,
        "delta": 148984880.0
      },
      {
        "periodo": 202602,
        "valor": 16948587779.0,
        "delta": 208229187.0
      },
      {
        "periodo": 202603,
        "valor": 17114048985.0,
        "delta": 165461206.0
      },
      {
        "periodo": 202604,
        "valor": 17141638723.0,
        "delta": 27589738.0
      },
      {
        "periodo": 202605,
        "valor": 22127247485.0,
        "delta": 4985608762.0
      },
      {
        "periodo": 202606,
        "valor": 22310454788.0,
        "delta": 183207303.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 98929392582.1,
    "valor_anterior": 97908635241.3,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 88265706752.4,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 89303984733.9,
        "delta": 1038277981.5
      },
      {
        "periodo": 202508,
        "valor": 89783163295.5,
        "delta": 479178561.6
      },
      {
        "periodo": 202509,
        "valor": 89848429743.8,
        "delta": 65266448.3
      },
      {
        "periodo": 202510,
        "valor": 90451574134.2,
        "delta": 603144390.4
      },
      {
        "periodo": 202511,
        "valor": 90719242512.8,
        "delta": 267668378.6
      },
      {
        "periodo": 202512,
        "valor": 95002842492.3,
        "delta": 4283599979.5
      },
      {
        "periodo": 202601,
        "valor": 96264165325.1,
        "delta": 1261322832.8
      },
      {
        "periodo": 202602,
        "valor": 96874573191.6,
        "delta": 610407866.5
      },
      {
        "periodo": 202603,
        "valor": 96780193270.4,
        "delta": -94379921.2
      },
      {
        "periodo": 202604,
        "valor": 97251603676.0,
        "delta": 471410405.6
      },
      {
        "periodo": 202605,
        "valor": 97908635241.3,
        "delta": 657031565.3
      },
      {
        "periodo": 202606,
        "valor": 98929392582.1,
        "delta": 1020757340.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 26171859720.0,
    "valor_anterior": 25809061654.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 24079232777.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 24495375048.0,
        "delta": 416142271.0
      },
      {
        "periodo": 202508,
        "valor": 24922952042.0,
        "delta": 427576994.0
      },
      {
        "periodo": 202509,
        "valor": 25402791910.0,
        "delta": 479839868.0
      },
      {
        "periodo": 202510,
        "valor": 25843200708.0,
        "delta": 440408798.0
      },
      {
        "periodo": 202511,
        "valor": 25114058785.0,
        "delta": -729141923.0
      },
      {
        "periodo": 202512,
        "valor": 25673536830.0,
        "delta": 559478045.0
      },
      {
        "periodo": 202601,
        "valor": 26112472226.0,
        "delta": 438935396.0
      },
      {
        "periodo": 202602,
        "valor": 26328576316.0,
        "delta": 216104090.0
      },
      {
        "periodo": 202603,
        "valor": 24901025243.0,
        "delta": -1427551073.0
      },
      {
        "periodo": 202604,
        "valor": 25419852112.0,
        "delta": 518826869.0
      },
      {
        "periodo": 202605,
        "valor": 25809061654.0,
        "delta": 389209542.0
      },
      {
        "periodo": 202606,
        "valor": 26171859720.0,
        "delta": 362798066.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 11323454587.0,
    "valor_anterior": 11163327299.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 9832429197.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 10053825149.0,
        "delta": 221395952.0
      },
      {
        "periodo": 202508,
        "valor": 10108153818.0,
        "delta": 54328669.0
      },
      {
        "periodo": 202509,
        "valor": 10341340886.0,
        "delta": 233187068.0
      },
      {
        "periodo": 202510,
        "valor": 10540132629.0,
        "delta": 198791743.0
      },
      {
        "periodo": 202511,
        "valor": 10551526872.0,
        "delta": 11394243.0
      },
      {
        "periodo": 202512,
        "valor": 10609178686.0,
        "delta": 57651814.0
      },
      {
        "periodo": 202601,
        "valor": 10561862036.0,
        "delta": -47316650.0
      },
      {
        "periodo": 202602,
        "valor": 10598066364.0,
        "delta": 36204328.0
      },
      {
        "periodo": 202603,
        "valor": 10621966890.0,
        "delta": 23900526.0
      },
      {
        "periodo": 202604,
        "valor": 10802727862.0,
        "delta": 180760972.0
      },
      {
        "periodo": 202605,
        "valor": 11163327299.0,
        "delta": 360599437.0
      },
      {
        "periodo": 202606,
        "valor": 11323454587.0,
        "delta": 160127288.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 8905988404.0,
    "valor_anterior": 8797082934.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 7634519700.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 7737934453.0,
        "delta": 103414753.0
      },
      {
        "periodo": 202508,
        "valor": 7903344030.0,
        "delta": 165409577.0
      },
      {
        "periodo": 202509,
        "valor": 8005295975.0,
        "delta": 101951945.0
      },
      {
        "periodo": 202510,
        "valor": 8224294699.0,
        "delta": 218998724.0
      },
      {
        "periodo": 202511,
        "valor": 8314480141.0,
        "delta": 90185442.0
      },
      {
        "periodo": 202512,
        "valor": 8316530594.0,
        "delta": 2050453.0
      },
      {
        "periodo": 202601,
        "valor": 8380856039.0,
        "delta": 64325445.0
      },
      {
        "periodo": 202602,
        "valor": 8514420118.0,
        "delta": 133564079.0
      },
      {
        "periodo": 202603,
        "valor": 8597498489.0,
        "delta": 83078371.0
      },
      {
        "periodo": 202604,
        "valor": 8700905196.0,
        "delta": 103406707.0
      },
      {
        "periodo": 202605,
        "valor": 8797082934.0,
        "delta": 96177738.0
      },
      {
        "periodo": 202606,
        "valor": 8905988404.0,
        "delta": 108905470.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 12229095190.0,
    "valor_anterior": 12158338624.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 11882665349.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 11964405935.0,
        "delta": 81740586.0
      },
      {
        "periodo": 202508,
        "valor": 11995884369.0,
        "delta": 31478434.0
      },
      {
        "periodo": 202509,
        "valor": 12012087687.0,
        "delta": 16203318.0
      },
      {
        "periodo": 202510,
        "valor": 11793274006.0,
        "delta": -218813681.0
      },
      {
        "periodo": 202511,
        "valor": 11990558339.0,
        "delta": 197284333.0
      },
      {
        "periodo": 202512,
        "valor": 11610589418.0,
        "delta": -379968921.0
      },
      {
        "periodo": 202601,
        "valor": 11670591016.0,
        "delta": 60001598.0
      },
      {
        "periodo": 202602,
        "valor": 11655742926.0,
        "delta": -14848090.0
      },
      {
        "periodo": 202603,
        "valor": 11898708188.0,
        "delta": 242965262.0
      },
      {
        "periodo": 202604,
        "valor": 11946868885.0,
        "delta": 48160697.0
      },
      {
        "periodo": 202605,
        "valor": 12158338624.0,
        "delta": 211469739.0
      },
      {
        "periodo": 202606,
        "valor": 12229095190.0,
        "delta": 70756566.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 240385821426.0,
    "valor_anterior": 212267145604.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 221092398619.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 225506437123.0,
        "delta": 4414038504.0
      },
      {
        "periodo": 202508,
        "valor": 228391474137.0,
        "delta": 2885037014.0
      },
      {
        "periodo": 202509,
        "valor": 229961376147.0,
        "delta": 1569902010.0
      },
      {
        "periodo": 202510,
        "valor": 234344172882.0,
        "delta": 4382796735.0
      },
      {
        "periodo": 202511,
        "valor": 213500747345.0,
        "delta": -20843425537.0
      },
      {
        "periodo": 202512,
        "valor": 209991359809.0,
        "delta": -3509387536.0
      },
      {
        "periodo": 202601,
        "valor": 211354515072.0,
        "delta": 1363155263.0
      },
      {
        "periodo": 202602,
        "valor": 214297592748.0,
        "delta": 2943077676.0
      },
      {
        "periodo": 202603,
        "valor": 220230248533.0,
        "delta": 5932655785.0
      },
      {
        "periodo": 202604,
        "valor": 208596336614.0,
        "delta": -11633911919.0
      },
      {
        "periodo": 202605,
        "valor": 212267145604.0,
        "delta": 3670808990.0
      },
      {
        "periodo": 202606,
        "valor": 240385821426.0,
        "delta": 28118675822.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 24731295494.0,
    "valor_anterior": 24645206311.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 22916362919.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 23056015843.0,
        "delta": 139652924.0
      },
      {
        "periodo": 202508,
        "valor": 23193314767.0,
        "delta": 137298924.0
      },
      {
        "periodo": 202509,
        "valor": 23203790187.0,
        "delta": 10475420.0
      },
      {
        "periodo": 202510,
        "valor": 23422602978.0,
        "delta": 218812791.0
      },
      {
        "periodo": 202511,
        "valor": 23424085580.0,
        "delta": 1482602.0
      },
      {
        "periodo": 202512,
        "valor": 23641486667.0,
        "delta": 217401087.0
      },
      {
        "periodo": 202601,
        "valor": 23870082534.0,
        "delta": 228595867.0
      },
      {
        "periodo": 202602,
        "valor": 24046001829.0,
        "delta": 175919295.0
      },
      {
        "periodo": 202603,
        "valor": 24277496497.0,
        "delta": 231494668.0
      },
      {
        "periodo": 202604,
        "valor": 24627047528.0,
        "delta": 349551031.0
      },
      {
        "periodo": 202605,
        "valor": 24645206311.0,
        "delta": 18158783.0
      },
      {
        "periodo": 202606,
        "valor": 24731295494.0,
        "delta": 86089183.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 9988691926.0,
    "valor_anterior": 9979932025.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 9328695775.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 9423066000.0,
        "delta": 94370225.0
      },
      {
        "periodo": 202508,
        "valor": 9505554392.0,
        "delta": 82488392.0
      },
      {
        "periodo": 202509,
        "valor": 9598747160.0,
        "delta": 93192768.0
      },
      {
        "periodo": 202510,
        "valor": 9658436450.0,
        "delta": 59689290.0
      },
      {
        "periodo": 202511,
        "valor": 9732629574.0,
        "delta": 74193124.0
      },
      {
        "periodo": 202512,
        "valor": 9789396080.0,
        "delta": 56766506.0
      },
      {
        "periodo": 202601,
        "valor": 9708635154.5,
        "delta": -80760925.5
      },
      {
        "periodo": 202602,
        "valor": 9842348116.0,
        "delta": 133712961.5
      },
      {
        "periodo": 202603,
        "valor": 9871841804.0,
        "delta": 29493688.0
      },
      {
        "periodo": 202604,
        "valor": 9932157533.0,
        "delta": 60315729.0
      },
      {
        "periodo": 202605,
        "valor": 9979932025.0,
        "delta": 47774492.0
      },
      {
        "periodo": 202606,
        "valor": 9988691926.0,
        "delta": 8759901.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 40166607084.0,
    "valor_anterior": 39983737528.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 35954193997.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 36270917460.0,
        "delta": 316723463.0
      },
      {
        "periodo": 202508,
        "valor": 36933277061.0,
        "delta": 662359601.0
      },
      {
        "periodo": 202509,
        "valor": 37555950234.0,
        "delta": 622673173.0
      },
      {
        "periodo": 202510,
        "valor": 37946905053.0,
        "delta": 390954819.0
      },
      {
        "periodo": 202511,
        "valor": 38229082961.0,
        "delta": 282177908.0
      },
      {
        "periodo": 202512,
        "valor": 38467441970.0,
        "delta": 238359009.0
      },
      {
        "periodo": 202601,
        "valor": 38590299553.0,
        "delta": 122857583.0
      },
      {
        "periodo": 202602,
        "valor": 39083801221.0,
        "delta": 493501668.0
      },
      {
        "periodo": 202603,
        "valor": 39354466778.0,
        "delta": 270665557.0
      },
      {
        "periodo": 202604,
        "valor": 39651216833.0,
        "delta": 296750055.0
      },
      {
        "periodo": 202605,
        "valor": 39983737528.0,
        "delta": 332520695.0
      },
      {
        "periodo": 202606,
        "valor": 40166607084.0,
        "delta": 182869556.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 17931895433.0,
    "valor_anterior": 17574616251.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 15213248017.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 15467468737.0,
        "delta": 254220720.0
      },
      {
        "periodo": 202508,
        "valor": 15788075760.0,
        "delta": 320607023.0
      },
      {
        "periodo": 202509,
        "valor": 16125280606.0,
        "delta": 337204846.0
      },
      {
        "periodo": 202510,
        "valor": 16478292467.0,
        "delta": 353011861.0
      },
      {
        "periodo": 202511,
        "valor": 16713178174.0,
        "delta": 234885707.0
      },
      {
        "periodo": 202512,
        "valor": 17157390343.0,
        "delta": 444212169.0
      },
      {
        "periodo": 202601,
        "valor": 17566601215.0,
        "delta": 409210872.0
      },
      {
        "periodo": 202602,
        "valor": 17836628385.0,
        "delta": 270027170.0
      },
      {
        "periodo": 202603,
        "valor": 17863535271.0,
        "delta": 26906886.0
      },
      {
        "periodo": 202604,
        "valor": 17250284642.0,
        "delta": -613250629.0
      },
      {
        "periodo": 202605,
        "valor": 17574616251.0,
        "delta": 324331609.0
      },
      {
        "periodo": 202606,
        "valor": 17931895433.0,
        "delta": 357279182.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 8097106240.4,
    "valor_anterior": 7997760728.5,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 7414653006.1,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 7368886294.6,
        "delta": -45766711.5
      },
      {
        "periodo": 202508,
        "valor": 7399032372.0,
        "delta": 30146077.4
      },
      {
        "periodo": 202509,
        "valor": 7501672612.3,
        "delta": 102640240.3
      },
      {
        "periodo": 202510,
        "valor": 7558890143.4,
        "delta": 57217531.1
      },
      {
        "periodo": 202511,
        "valor": 7667261563.0,
        "delta": 108371419.6
      },
      {
        "periodo": 202512,
        "valor": 7663469275.5,
        "delta": -3792287.5
      },
      {
        "periodo": 202601,
        "valor": 7824224995.8,
        "delta": 160755720.3
      },
      {
        "periodo": 202602,
        "valor": 7777378732.7,
        "delta": -46846263.1
      },
      {
        "periodo": 202603,
        "valor": 7909443191.4,
        "delta": 132064458.7
      },
      {
        "periodo": 202604,
        "valor": 8020206476.5,
        "delta": 110763285.1
      },
      {
        "periodo": 202605,
        "valor": 7997760728.5,
        "delta": -22445748.0
      },
      {
        "periodo": 202606,
        "valor": 8097106240.4,
        "delta": 99345511.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 81988480764.0,
    "valor_anterior": 81485843101.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 71151063178.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 72103528805.0,
        "delta": 952465627.0
      },
      {
        "periodo": 202508,
        "valor": 73653620412.0,
        "delta": 1550091607.0
      },
      {
        "periodo": 202509,
        "valor": 74865413276.0,
        "delta": 1211792864.0
      },
      {
        "periodo": 202510,
        "valor": 75795523032.0,
        "delta": 930109756.0
      },
      {
        "periodo": 202511,
        "valor": 76322811638.0,
        "delta": 527288606.0
      },
      {
        "periodo": 202512,
        "valor": 77980364691.0,
        "delta": 1657553053.0
      },
      {
        "periodo": 202601,
        "valor": 79229702495.0,
        "delta": 1249337804.0
      },
      {
        "periodo": 202602,
        "valor": 80055249870.0,
        "delta": 825547375.0
      },
      {
        "periodo": 202603,
        "valor": 79245696659.0,
        "delta": -809553211.0
      },
      {
        "periodo": 202604,
        "valor": 80566831304.0,
        "delta": 1321134645.0
      },
      {
        "periodo": 202605,
        "valor": 81485843101.0,
        "delta": 919011797.0
      },
      {
        "periodo": 202606,
        "valor": 81988480764.0,
        "delta": 502637663.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 2095207014.0,
    "valor_anterior": 2089938884.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2160763546.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2148145170.0,
        "delta": -12618376.0
      },
      {
        "periodo": 202508,
        "valor": 2134753315.0,
        "delta": -13391855.0
      },
      {
        "periodo": 202509,
        "valor": 2124311331.0,
        "delta": -10441984.0
      },
      {
        "periodo": 202510,
        "valor": 2133432924.0,
        "delta": 9121593.0
      },
      {
        "periodo": 202511,
        "valor": 2111966859.0,
        "delta": -21466065.0
      },
      {
        "periodo": 202512,
        "valor": 2133939984.0,
        "delta": 21973125.0
      },
      {
        "periodo": 202601,
        "valor": 2132555635.0,
        "delta": -1384349.0
      },
      {
        "periodo": 202602,
        "valor": 2087625246.0,
        "delta": -44930389.0
      },
      {
        "periodo": 202603,
        "valor": 2084840601.0,
        "delta": -2784645.0
      },
      {
        "periodo": 202604,
        "valor": 2089793489.0,
        "delta": 4952888.0
      },
      {
        "periodo": 202605,
        "valor": 2089938884.0,
        "delta": 145395.0
      },
      {
        "periodo": 202606,
        "valor": 2095207014.0,
        "delta": 5268130.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 48997670671.0,
    "valor_anterior": 49967876677.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 45793986247.5,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 46004900591.25,
        "delta": 210914343.75
      },
      {
        "periodo": 202508,
        "valor": 46490464430.25,
        "delta": 485563839.0
      },
      {
        "periodo": 202509,
        "valor": 49098416950.25,
        "delta": 2607952520.0
      },
      {
        "periodo": 202510,
        "valor": 50002733879.75,
        "delta": 904316929.5
      },
      {
        "periodo": 202511,
        "valor": 50760833420.25,
        "delta": 758099540.5
      },
      {
        "periodo": 202512,
        "valor": 51792240956.0,
        "delta": 1031407535.75
      },
      {
        "periodo": 202601,
        "valor": 51016403176.6662,
        "delta": -775837779.3338
      },
      {
        "periodo": 202602,
        "valor": 51558453436.0662,
        "delta": 542050259.4
      },
      {
        "periodo": 202603,
        "valor": 51967043806.75,
        "delta": 408590370.6838
      },
      {
        "periodo": 202604,
        "valor": 50792144649.75,
        "delta": -1174899157.0
      },
      {
        "periodo": 202605,
        "valor": 49967876677.0,
        "delta": -824267972.75
      },
      {
        "periodo": 202606,
        "valor": 48997670671.0,
        "delta": -970206006.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 5562530148.0,
    "valor_anterior": 5166568402.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1536211677.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1591686281.0,
        "delta": 55474604.0
      },
      {
        "periodo": 202508,
        "valor": 1658691566.0,
        "delta": 67005285.0
      },
      {
        "periodo": 202509,
        "valor": 3730791638.0,
        "delta": 2072100072.0
      },
      {
        "periodo": 202510,
        "valor": 4400252514.0,
        "delta": 669460876.0
      },
      {
        "periodo": 202511,
        "valor": 4361880457.0,
        "delta": -38372057.0
      },
      {
        "periodo": 202512,
        "valor": 4517709086.0,
        "delta": 155828629.0
      },
      {
        "periodo": 202601,
        "valor": 4666291638.0,
        "delta": 148582552.0
      },
      {
        "periodo": 202602,
        "valor": 4864775694.0,
        "delta": 198484056.0
      },
      {
        "periodo": 202603,
        "valor": 5288600710.0,
        "delta": 423825016.0
      },
      {
        "periodo": 202604,
        "valor": 5396030654.0,
        "delta": 107429944.0
      },
      {
        "periodo": 202605,
        "valor": 5166568402.0,
        "delta": -229462252.0
      },
      {
        "periodo": 202606,
        "valor": 5562530148.0,
        "delta": 395961746.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 8766200954.0,
    "valor_anterior": 8753499969.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 9000630997.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 9238125237.0,
        "delta": 237494240.0
      },
      {
        "periodo": 202508,
        "valor": 9189686559.0,
        "delta": -48438678.0
      },
      {
        "periodo": 202509,
        "valor": 9267768475.0,
        "delta": 78081916.0
      },
      {
        "periodo": 202510,
        "valor": 9324010711.0,
        "delta": 56242236.0
      },
      {
        "periodo": 202511,
        "valor": 8583832871.0,
        "delta": -740177840.0
      },
      {
        "periodo": 202512,
        "valor": 8480343839.0,
        "delta": -103489032.0
      },
      {
        "periodo": 202601,
        "valor": 8543498517.0,
        "delta": 63154678.0
      },
      {
        "periodo": 202602,
        "valor": 8624580942.0,
        "delta": 81082425.0
      },
      {
        "periodo": 202603,
        "valor": 8653002027.0,
        "delta": 28421085.0
      },
      {
        "periodo": 202604,
        "valor": 8684696586.0,
        "delta": 31694559.0
      },
      {
        "periodo": 202605,
        "valor": 8753499969.0,
        "delta": 68803383.0
      },
      {
        "periodo": 202606,
        "valor": 8766200954.0,
        "delta": 12700985.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 19504669128.3,
    "valor_anterior": 18903781268.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17208350110.4,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17644500846.4,
        "delta": 436150736.0
      },
      {
        "periodo": 202508,
        "valor": 18097627477.3,
        "delta": 453126630.9
      },
      {
        "periodo": 202509,
        "valor": 18574872203.5,
        "delta": 477244726.2
      },
      {
        "periodo": 202510,
        "valor": 18915102566.9,
        "delta": 340230363.4
      },
      {
        "periodo": 202511,
        "valor": 17777436151.9,
        "delta": -1137666415.0
      },
      {
        "periodo": 202512,
        "valor": 18069550832.5,
        "delta": 292114680.6
      },
      {
        "periodo": 202601,
        "valor": 18763190297.1,
        "delta": 693639464.6
      },
      {
        "periodo": 202602,
        "valor": 19434298698.1,
        "delta": 671108401.0
      },
      {
        "periodo": 202603,
        "valor": 19796334214.7,
        "delta": 362035516.6
      },
      {
        "periodo": 202604,
        "valor": 18143399725.6,
        "delta": -1652934489.1
      },
      {
        "periodo": 202605,
        "valor": 18903781268.0,
        "delta": 760381542.4
      },
      {
        "periodo": 202606,
        "valor": 19504669128.3,
        "delta": 600887860.3
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 12794079736.4,
    "valor_anterior": 12561677121.5,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 10873752710.4,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 10935222290.2,
        "delta": 61469579.8
      },
      {
        "periodo": 202508,
        "valor": 11010103709.0,
        "delta": 74881418.8
      },
      {
        "periodo": 202509,
        "valor": 10943798928.3,
        "delta": -66304780.7
      },
      {
        "periodo": 202510,
        "valor": 11253587691.0,
        "delta": 309788762.7
      },
      {
        "periodo": 202511,
        "valor": 11508991494.5,
        "delta": 255403803.5
      },
      {
        "periodo": 202512,
        "valor": 11943831272.4,
        "delta": 434839777.9
      },
      {
        "periodo": 202601,
        "valor": 12144647779.8,
        "delta": 200816507.4
      },
      {
        "periodo": 202602,
        "valor": 12287731348.0,
        "delta": 143083568.2
      },
      {
        "periodo": 202603,
        "valor": 12418243461.1,
        "delta": 130512113.1
      },
      {
        "periodo": 202604,
        "valor": 12513643576.5,
        "delta": 95400115.4
      },
      {
        "periodo": 202605,
        "valor": 12561677121.5,
        "delta": 48033545.0
      },
      {
        "periodo": 202606,
        "valor": 12794079736.4,
        "delta": 232402614.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 6287101398.0,
    "valor_anterior": 6343453655.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 6229731301.4,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 6271464073.0,
        "delta": 41732771.6
      },
      {
        "periodo": 202508,
        "valor": 6259481772.5,
        "delta": -11982300.5
      },
      {
        "periodo": 202509,
        "valor": 6334849642.0,
        "delta": 75367869.5
      },
      {
        "periodo": 202510,
        "valor": 6370443254.0,
        "delta": 35593612.0
      },
      {
        "periodo": 202511,
        "valor": 6295559259.0,
        "delta": -74883995.0
      },
      {
        "periodo": 202512,
        "valor": 6272704298.0,
        "delta": -22854961.0
      },
      {
        "periodo": 202601,
        "valor": 6270214942.0,
        "delta": -2489356.0
      },
      {
        "periodo": 202602,
        "valor": 6315471791.0,
        "delta": 45256849.0
      },
      {
        "periodo": 202603,
        "valor": 6222050059.0,
        "delta": -93421732.0
      },
      {
        "periodo": 202604,
        "valor": 6251388034.0,
        "delta": 29337975.0
      },
      {
        "periodo": 202605,
        "valor": 6343453655.0,
        "delta": 92065621.0
      },
      {
        "periodo": 202606,
        "valor": 6287101398.0,
        "delta": -56352257.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 3021418347.0,
    "valor_anterior": 3333110687.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 11165014029.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 10924719222.0,
        "delta": -240294807.0
      },
      {
        "periodo": 202508,
        "valor": 10747210148.0,
        "delta": -177509074.0
      },
      {
        "periodo": 202509,
        "valor": 9971087986.0,
        "delta": -776122162.0
      },
      {
        "periodo": 202510,
        "valor": 9877108994.0,
        "delta": -93978992.0
      },
      {
        "periodo": 202511,
        "valor": 3814985210.1,
        "delta": -6062123783.9
      },
      {
        "periodo": 202512,
        "valor": 4000296627.2,
        "delta": 185311417.1
      },
      {
        "periodo": 202601,
        "valor": 3806723175.0,
        "delta": -193573452.2
      },
      {
        "periodo": 202602,
        "valor": 3914795113.7,
        "delta": 108071938.7
      },
      {
        "periodo": 202603,
        "valor": 3898566949.8,
        "delta": -16228163.9
      },
      {
        "periodo": 202604,
        "valor": 3322965168.2,
        "delta": -575601781.6
      },
      {
        "periodo": 202605,
        "valor": 3333110687.2,
        "delta": 10145519.0
      },
      {
        "periodo": 202606,
        "valor": 3021418347.0,
        "delta": -311692340.2
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 22125150154.7,
    "valor_anterior": 21307335985.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 21418749499.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 21429841253.0,
        "delta": 11091754.0
      },
      {
        "periodo": 202508,
        "valor": 22069278210.0,
        "delta": 639436957.0
      },
      {
        "periodo": 202509,
        "valor": 21383615356.0,
        "delta": -685662854.0
      },
      {
        "periodo": 202510,
        "valor": 21689028764.0,
        "delta": 305413408.0
      },
      {
        "periodo": 202511,
        "valor": 21658875743.0,
        "delta": -30153021.0
      },
      {
        "periodo": 202512,
        "valor": 21258510632.0,
        "delta": -400365111.0
      },
      {
        "periodo": 202601,
        "valor": 21533210459.0,
        "delta": 274699827.0
      },
      {
        "periodo": 202602,
        "valor": 22182904466.0,
        "delta": 649694007.0
      },
      {
        "periodo": 202603,
        "valor": 20623160202.5,
        "delta": -1559744263.5
      },
      {
        "periodo": 202604,
        "valor": 21039161713.1,
        "delta": 416001510.6
      },
      {
        "periodo": 202605,
        "valor": 21307335985.2,
        "delta": 268174272.1
      },
      {
        "periodo": 202606,
        "valor": 22125150154.7,
        "delta": 817814169.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 752486413.5,
    "valor_anterior": 573383281.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 914256462.5,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 758157349.5,
        "delta": -156099113.0
      },
      {
        "periodo": 202508,
        "valor": 973730075.7,
        "delta": 215572726.2
      },
      {
        "periodo": 202509,
        "valor": 866854013.3,
        "delta": -106876062.4
      },
      {
        "periodo": 202510,
        "valor": 753280049.6,
        "delta": -113573963.7
      },
      {
        "periodo": 202511,
        "valor": 600936978.0,
        "delta": -152343071.6
      },
      {
        "periodo": 202512,
        "valor": 795021368.8,
        "delta": 194084390.8
      },
      {
        "periodo": 202601,
        "valor": 697919597.6,
        "delta": -97101771.2
      },
      {
        "periodo": 202602,
        "valor": 569747668.8,
        "delta": -128171928.8
      },
      {
        "periodo": 202603,
        "valor": 753919651.9,
        "delta": 184171983.1
      },
      {
        "periodo": 202604,
        "valor": 661043596.0,
        "delta": -92876055.9
      },
      {
        "periodo": 202605,
        "valor": 573383281.0,
        "delta": -87660315.0
      },
      {
        "periodo": 202606,
        "valor": 752486413.5,
        "delta": 179103132.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 1656561058.0,
    "valor_anterior": 1647100058.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1554892248.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1557734815.0,
        "delta": 2842567.0
      },
      {
        "periodo": 202508,
        "valor": 1568220205.0,
        "delta": 10485390.0
      },
      {
        "periodo": 202509,
        "valor": 1591122291.0,
        "delta": 22902086.0
      },
      {
        "periodo": 202510,
        "valor": 1600735277.0,
        "delta": 9612986.0
      },
      {
        "periodo": 202511,
        "valor": 1601239979.0,
        "delta": 504702.0
      },
      {
        "periodo": 202512,
        "valor": 1622811247.0,
        "delta": 21571268.0
      },
      {
        "periodo": 202601,
        "valor": 1626159563.0,
        "delta": 3348316.0
      },
      {
        "periodo": 202602,
        "valor": 1620417634.0,
        "delta": -5741929.0
      },
      {
        "periodo": 202603,
        "valor": 1629004223.0,
        "delta": 8586589.0
      },
      {
        "periodo": 202604,
        "valor": 1635775374.0,
        "delta": 6771151.0
      },
      {
        "periodo": 202605,
        "valor": 1647100058.0,
        "delta": 11324684.0
      },
      {
        "periodo": 202606,
        "valor": 1656561058.0,
        "delta": 9461000.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 5748795535.0,
    "valor_anterior": 5696825734.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4607313926.75,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4735053106.0,
        "delta": 127739179.25
      },
      {
        "periodo": 202508,
        "valor": 4762557367.25,
        "delta": 27504261.25
      },
      {
        "periodo": 202509,
        "valor": 4863144149.25,
        "delta": 100586782.0
      },
      {
        "periodo": 202510,
        "valor": 4931137042.0,
        "delta": 67992892.75
      },
      {
        "periodo": 202511,
        "valor": 5061822149.75,
        "delta": 130685107.75
      },
      {
        "periodo": 202512,
        "valor": 5120150372.0,
        "delta": 58328222.25
      },
      {
        "periodo": 202601,
        "valor": 5269875084.0,
        "delta": 149724712.0
      },
      {
        "periodo": 202602,
        "valor": 5224556624.75,
        "delta": -45318459.25
      },
      {
        "periodo": 202603,
        "valor": 5514986760.0,
        "delta": 290430135.25
      },
      {
        "periodo": 202604,
        "valor": 5602833232.0,
        "delta": 87846472.0
      },
      {
        "periodo": 202605,
        "valor": 5696825734.0,
        "delta": 93992502.0
      },
      {
        "periodo": 202606,
        "valor": 5748795535.0,
        "delta": 51969801.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 3558093926.0,
    "valor_anterior": 3490269647.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 3465540977.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3527287780.0,
        "delta": 61746803.0
      },
      {
        "periodo": 202508,
        "valor": 3546259944.0,
        "delta": 18972164.0
      },
      {
        "periodo": 202509,
        "valor": 3593332302.0,
        "delta": 47072358.0
      },
      {
        "periodo": 202510,
        "valor": 3578844765.0,
        "delta": -14487537.0
      },
      {
        "periodo": 202511,
        "valor": 3580386801.0,
        "delta": 1542036.0
      },
      {
        "periodo": 202512,
        "valor": 3631083997.0,
        "delta": 50697196.0
      },
      {
        "periodo": 202601,
        "valor": 3633400486.0,
        "delta": 2316489.0
      },
      {
        "periodo": 202602,
        "valor": 3686897848.0,
        "delta": 53497362.0
      },
      {
        "periodo": 202603,
        "valor": 3469550387.0,
        "delta": -217347461.0
      },
      {
        "periodo": 202604,
        "valor": 3481226238.0,
        "delta": 11675851.0
      },
      {
        "periodo": 202605,
        "valor": 3490269647.0,
        "delta": 9043409.0
      },
      {
        "periodo": 202606,
        "valor": 3558093926.0,
        "delta": 67824279.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5082317696.875,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 5414697252.5,
        "delta": 332379555.625
      },
      {
        "periodo": 202508,
        "valor": 4293511014.875,
        "delta": -1121186237.625
      },
      {
        "periodo": 202509,
        "valor": 4438784762.5,
        "delta": 145273747.625
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 7827476723.0,
    "valor_anterior": 7689009035.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 7076970881.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 7201608685.0,
        "delta": 124637804.0
      },
      {
        "periodo": 202508,
        "valor": 7369426300.0,
        "delta": 167817615.0
      },
      {
        "periodo": 202509,
        "valor": 6888912545.0,
        "delta": -480513755.0
      },
      {
        "periodo": 202510,
        "valor": 7090495910.0,
        "delta": 201583365.0
      },
      {
        "periodo": 202511,
        "valor": 7170956056.0,
        "delta": 80460146.0
      },
      {
        "periodo": 202512,
        "valor": 7463078389.0,
        "delta": 292122333.0
      },
      {
        "periodo": 202601,
        "valor": 7567001990.0,
        "delta": 103923601.0
      },
      {
        "periodo": 202602,
        "valor": 7686426417.0,
        "delta": 119424427.0
      },
      {
        "periodo": 202603,
        "valor": 7856540374.0,
        "delta": 170113957.0
      },
      {
        "periodo": 202604,
        "valor": 7555635690.0,
        "delta": -300904684.0
      },
      {
        "periodo": 202605,
        "valor": 7689009035.0,
        "delta": 133373345.0
      },
      {
        "periodo": 202606,
        "valor": 7827476723.0,
        "delta": 138467688.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 2668524331.0,
    "valor_anterior": 2383588179.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1918429039.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1940741265.0,
        "delta": 22312226.0
      },
      {
        "periodo": 202508,
        "valor": 2045322113.0,
        "delta": 104580848.0
      },
      {
        "periodo": 202509,
        "valor": 2063324497.0,
        "delta": 18002384.0
      },
      {
        "periodo": 202510,
        "valor": 2107930424.0,
        "delta": 44605927.0
      },
      {
        "periodo": 202511,
        "valor": 2138153470.0,
        "delta": 30223046.0
      },
      {
        "periodo": 202512,
        "valor": 2339255501.0,
        "delta": 201102031.0
      },
      {
        "periodo": 202601,
        "valor": 2346167185.0,
        "delta": 6911684.0
      },
      {
        "periodo": 202602,
        "valor": 2438459036.0,
        "delta": 92291851.0
      },
      {
        "periodo": 202603,
        "valor": 2553064905.0,
        "delta": 114605869.0
      },
      {
        "periodo": 202604,
        "valor": 2427649183.0,
        "delta": -125415722.0
      },
      {
        "periodo": 202605,
        "valor": 2383588179.0,
        "delta": -44061004.0
      },
      {
        "periodo": 202606,
        "valor": 2668524331.0,
        "delta": 284936152.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 306402973.0,
    "valor_anterior": 303948833.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 294400889.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 306111605.0,
        "delta": 11710716.0
      },
      {
        "periodo": 202508,
        "valor": 297429566.0,
        "delta": -8682039.0
      },
      {
        "periodo": 202509,
        "valor": 302667304.0,
        "delta": 5237738.0
      },
      {
        "periodo": 202510,
        "valor": 296034369.0,
        "delta": -6632935.0
      },
      {
        "periodo": 202511,
        "valor": 308423676.0,
        "delta": 12389307.0
      },
      {
        "periodo": 202512,
        "valor": 311479032.0,
        "delta": 3055356.0
      },
      {
        "periodo": 202601,
        "valor": 304923267.0,
        "delta": -6555765.0
      },
      {
        "periodo": 202602,
        "valor": 305860793.0,
        "delta": 937526.0
      },
      {
        "periodo": 202603,
        "valor": 302730987.0,
        "delta": -3129806.0
      },
      {
        "periodo": 202604,
        "valor": 301698117.0,
        "delta": -1032870.0
      },
      {
        "periodo": 202605,
        "valor": 303948833.0,
        "delta": 2250716.0
      },
      {
        "periodo": 202606,
        "valor": 306402973.0,
        "delta": 2454140.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 452966795.0,
    "valor_anterior": 454984724.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 433033517.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 431021909.0,
        "delta": -2011608.0
      },
      {
        "periodo": 202508,
        "valor": 436666778.0,
        "delta": 5644869.0
      },
      {
        "periodo": 202509,
        "valor": 433801176.0,
        "delta": -2865602.0
      },
      {
        "periodo": 202510,
        "valor": 429234599.0,
        "delta": -4566577.0
      },
      {
        "periodo": 202511,
        "valor": 423437029.0,
        "delta": -5797570.0
      },
      {
        "periodo": 202512,
        "valor": 461764082.0,
        "delta": 38327053.0
      },
      {
        "periodo": 202601,
        "valor": 457778374.0,
        "delta": -3985708.0
      },
      {
        "periodo": 202602,
        "valor": 460214345.0,
        "delta": 2435971.0
      },
      {
        "periodo": 202603,
        "valor": 457649724.0,
        "delta": -2564621.0
      },
      {
        "periodo": 202604,
        "valor": 458217767.0,
        "delta": 568043.0
      },
      {
        "periodo": 202605,
        "valor": 454984724.0,
        "delta": -3233043.0
      },
      {
        "periodo": 202606,
        "valor": 452966795.0,
        "delta": -2017929.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 2384909924.6,
    "valor_anterior": 2384128499.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2276073058.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2279971358.0,
        "delta": 3898300.0
      },
      {
        "periodo": 202508,
        "valor": 2283569775.0,
        "delta": 3598417.0
      },
      {
        "periodo": 202509,
        "valor": 2270509272.0,
        "delta": -13060503.0
      },
      {
        "periodo": 202510,
        "valor": 2279225536.0,
        "delta": 8716264.0
      },
      {
        "periodo": 202511,
        "valor": 2260592362.0,
        "delta": -18633174.0
      },
      {
        "periodo": 202512,
        "valor": 2338192418.0,
        "delta": 77600056.0
      },
      {
        "periodo": 202601,
        "valor": 2351821650.0,
        "delta": 13629232.0
      },
      {
        "periodo": 202602,
        "valor": 2358168842.0,
        "delta": 6347192.0
      },
      {
        "periodo": 202603,
        "valor": 2367701791.0,
        "delta": 9532949.0
      },
      {
        "periodo": 202604,
        "valor": 2380902844.0,
        "delta": 13201053.0
      },
      {
        "periodo": 202605,
        "valor": 2384128499.0,
        "delta": 3225655.0
      },
      {
        "periodo": 202606,
        "valor": 2384909924.6,
        "delta": 781425.6
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 478804220.0,
    "valor_anterior": 477819770.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 455210280.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 455367440.0,
        "delta": 157160.0
      },
      {
        "periodo": 202508,
        "valor": 460822930.0,
        "delta": 5455490.0
      },
      {
        "periodo": 202509,
        "valor": 458796690.0,
        "delta": -2026240.0
      },
      {
        "periodo": 202510,
        "valor": 460873050.0,
        "delta": 2076360.0
      },
      {
        "periodo": 202511,
        "valor": 460191620.0,
        "delta": -681430.0
      },
      {
        "periodo": 202512,
        "valor": 471892340.0,
        "delta": 11700720.0
      },
      {
        "periodo": 202601,
        "valor": 477453740.0,
        "delta": 5561400.0
      },
      {
        "periodo": 202602,
        "valor": 477991040.0,
        "delta": 537300.0
      },
      {
        "periodo": 202603,
        "valor": 478552530.0,
        "delta": 561490.0
      },
      {
        "periodo": 202604,
        "valor": 477299190.0,
        "delta": -1253340.0
      },
      {
        "periodo": 202605,
        "valor": 477819770.0,
        "delta": 520580.0
      },
      {
        "periodo": 202606,
        "valor": 478804220.0,
        "delta": 984450.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 6575025884.5,
    "valor_anterior": 6555718589.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5668453418.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 5763792920.0,
        "delta": 95339502.0
      },
      {
        "periodo": 202508,
        "valor": 5810062812.0,
        "delta": 46269892.0
      },
      {
        "periodo": 202509,
        "valor": 5841625364.0,
        "delta": 31562552.0
      },
      {
        "periodo": 202510,
        "valor": 5976917471.0,
        "delta": 135292107.0
      },
      {
        "periodo": 202511,
        "valor": 6068832257.0,
        "delta": 91914786.0
      },
      {
        "periodo": 202512,
        "valor": 6175189556.0,
        "delta": 106357299.0
      },
      {
        "periodo": 202601,
        "valor": 6269970306.0,
        "delta": 94780750.0
      },
      {
        "periodo": 202602,
        "valor": 6336685855.0,
        "delta": 66715549.0
      },
      {
        "periodo": 202603,
        "valor": 6357801616.0,
        "delta": 21115761.0
      },
      {
        "periodo": 202604,
        "valor": 6448950046.9,
        "delta": 91148430.9
      },
      {
        "periodo": 202605,
        "valor": 6555718589.0,
        "delta": 106768542.1
      },
      {
        "periodo": 202606,
        "valor": 6575025884.5,
        "delta": 19307295.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 1314782296.7,
    "valor_anterior": 1302000733.8,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 955712461.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 981709000.0,
        "delta": 25996539.0
      },
      {
        "periodo": 202508,
        "valor": 999001441.0,
        "delta": 17292441.0
      },
      {
        "periodo": 202509,
        "valor": 1042088160.0,
        "delta": 43086719.0
      },
      {
        "periodo": 202510,
        "valor": 1093977256.0,
        "delta": 51889096.0
      },
      {
        "periodo": 202511,
        "valor": 1147984151.2,
        "delta": 54006895.2
      },
      {
        "periodo": 202512,
        "valor": 1162436773.0,
        "delta": 14452621.8
      },
      {
        "periodo": 202601,
        "valor": 1170350513.8,
        "delta": 7913740.8
      },
      {
        "periodo": 202602,
        "valor": 1224629737.3,
        "delta": 54279223.5
      },
      {
        "periodo": 202603,
        "valor": 1259775546.0,
        "delta": 35145808.7
      },
      {
        "periodo": 202604,
        "valor": 1262560740.6,
        "delta": 2785194.6
      },
      {
        "periodo": 202605,
        "valor": 1302000733.8,
        "delta": 39439993.2
      },
      {
        "periodo": 202606,
        "valor": 1314782296.7,
        "delta": 12781562.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 2092075977.0,
    "valor_anterior": 2072115290.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1886154497.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1919898747.0,
        "delta": 33744250.0
      },
      {
        "periodo": 202508,
        "valor": 1945593931.0,
        "delta": 25695184.0
      },
      {
        "periodo": 202509,
        "valor": 1963864459.0,
        "delta": 18270528.0
      },
      {
        "periodo": 202510,
        "valor": 2010788489.0,
        "delta": 46924030.0
      },
      {
        "periodo": 202511,
        "valor": 2042579597.0,
        "delta": 31791108.0
      },
      {
        "periodo": 202512,
        "valor": 2035633799.0,
        "delta": -6945798.0
      },
      {
        "periodo": 202601,
        "valor": 2049372193.0,
        "delta": 13738394.0
      },
      {
        "periodo": 202602,
        "valor": 2038961717.0,
        "delta": -10410476.0
      },
      {
        "periodo": 202603,
        "valor": 2053975223.0,
        "delta": 15013506.0
      },
      {
        "periodo": 202604,
        "valor": 2034244819.0,
        "delta": -19730404.0
      },
      {
        "periodo": 202605,
        "valor": 2072115290.0,
        "delta": 37870471.0
      },
      {
        "periodo": 202606,
        "valor": 2092075977.0,
        "delta": 19960687.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 15995479790.0,
    "valor_anterior": 15855201137.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14500829812.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14654721088.0,
        "delta": 153891276.0
      },
      {
        "periodo": 202508,
        "valor": 14813357780.0,
        "delta": 158636692.0
      },
      {
        "periodo": 202509,
        "valor": 14953579136.0,
        "delta": 140221356.0
      },
      {
        "periodo": 202510,
        "valor": 15078465086.0,
        "delta": 124885950.0
      },
      {
        "periodo": 202511,
        "valor": 15177284071.0,
        "delta": 98818985.0
      },
      {
        "periodo": 202512,
        "valor": 15338815901.0,
        "delta": 161531830.0
      },
      {
        "periodo": 202601,
        "valor": 15326099012.0,
        "delta": -12716889.0
      },
      {
        "periodo": 202602,
        "valor": 15397000201.0,
        "delta": 70901189.0
      },
      {
        "periodo": 202603,
        "valor": 15519430808.0,
        "delta": 122430607.0
      },
      {
        "periodo": 202604,
        "valor": 15675917541.0,
        "delta": 156486733.0
      },
      {
        "periodo": 202605,
        "valor": 15855201137.0,
        "delta": 179283596.0
      },
      {
        "periodo": 202606,
        "valor": 15995479790.0,
        "delta": 140278653.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 1956930276.0,
    "valor_anterior": 1951081442.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1846844922.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1849418923.0,
        "delta": 2574001.0
      },
      {
        "periodo": 202508,
        "valor": 1866173408.0,
        "delta": 16754485.0
      },
      {
        "periodo": 202509,
        "valor": 1874604429.0,
        "delta": 8431021.0
      },
      {
        "periodo": 202510,
        "valor": 1886288516.0,
        "delta": 11684087.0
      },
      {
        "periodo": 202511,
        "valor": 1897329492.0,
        "delta": 11040976.0
      },
      {
        "periodo": 202512,
        "valor": 1898178315.0,
        "delta": 848823.0
      },
      {
        "periodo": 202601,
        "valor": 1906406487.0,
        "delta": 8228172.0
      },
      {
        "periodo": 202602,
        "valor": 1915397283.0,
        "delta": 8990796.0
      },
      {
        "periodo": 202603,
        "valor": 1929274304.0,
        "delta": 13877021.0
      },
      {
        "periodo": 202604,
        "valor": 1938672913.0,
        "delta": 9398609.0
      },
      {
        "periodo": 202605,
        "valor": 1951081442.0,
        "delta": 12408529.0
      },
      {
        "periodo": 202606,
        "valor": 1956930276.0,
        "delta": 5848834.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 4537819535.0,
    "valor_anterior": 4515640675.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4409067665.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4435853320.0,
        "delta": 26785655.0
      },
      {
        "periodo": 202508,
        "valor": 4463014419.0,
        "delta": 27161099.0
      },
      {
        "periodo": 202509,
        "valor": 4521455157.0,
        "delta": 58440738.0
      },
      {
        "periodo": 202510,
        "valor": 4552434549.0,
        "delta": 30979392.0
      },
      {
        "periodo": 202511,
        "valor": 4586609444.0,
        "delta": 34174895.0
      },
      {
        "periodo": 202512,
        "valor": 4589950238.0,
        "delta": 3340794.0
      },
      {
        "periodo": 202601,
        "valor": 4622136002.0,
        "delta": 32185764.0
      },
      {
        "periodo": 202602,
        "valor": 4652995907.0,
        "delta": 30859905.0
      },
      {
        "periodo": 202603,
        "valor": 4665673311.0,
        "delta": 12677404.0
      },
      {
        "periodo": 202604,
        "valor": 4496310431.0,
        "delta": -169362880.0
      },
      {
        "periodo": 202605,
        "valor": 4515640675.0,
        "delta": 19330244.0
      },
      {
        "periodo": 202606,
        "valor": 4537819535.0,
        "delta": 22178860.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 2249337173.0,
    "valor_anterior": 2240204020.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2150829602.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2171305604.0,
        "delta": 20476002.0
      },
      {
        "periodo": 202508,
        "valor": 2197518084.0,
        "delta": 26212480.0
      },
      {
        "periodo": 202509,
        "valor": 2204803064.0,
        "delta": 7284980.0
      },
      {
        "periodo": 202510,
        "valor": 2215179534.0,
        "delta": 10376470.0
      },
      {
        "periodo": 202511,
        "valor": 2213074122.0,
        "delta": -2105412.0
      },
      {
        "periodo": 202512,
        "valor": 2221939535.0,
        "delta": 8865413.0
      },
      {
        "periodo": 202601,
        "valor": 2228814696.0,
        "delta": 6875161.0
      },
      {
        "periodo": 202602,
        "valor": 2238352426.0,
        "delta": 9537730.0
      },
      {
        "periodo": 202603,
        "valor": 2227961880.0,
        "delta": -10390546.0
      },
      {
        "periodo": 202604,
        "valor": 2236373321.0,
        "delta": 8411441.0
      },
      {
        "periodo": 202605,
        "valor": 2240204020.0,
        "delta": 3830699.0
      },
      {
        "periodo": 202606,
        "valor": 2249337173.0,
        "delta": 9133153.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 2753683757.0,
    "valor_anterior": 2720036931.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2433812599.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2465020238.0,
        "delta": 31207639.0
      },
      {
        "periodo": 202508,
        "valor": 2495200765.0,
        "delta": 30180527.0
      },
      {
        "periodo": 202509,
        "valor": 2524852564.0,
        "delta": 29651799.0
      },
      {
        "periodo": 202510,
        "valor": 2548360078.0,
        "delta": 23507514.0
      },
      {
        "periodo": 202511,
        "valor": 2573941591.0,
        "delta": 25581513.0
      },
      {
        "periodo": 202512,
        "valor": 2587433142.0,
        "delta": 13491551.0
      },
      {
        "periodo": 202601,
        "valor": 2614786509.0,
        "delta": 27353367.0
      },
      {
        "periodo": 202602,
        "valor": 2640239469.0,
        "delta": 25452960.0
      },
      {
        "periodo": 202603,
        "valor": 2668259721.0,
        "delta": 28020252.0
      },
      {
        "periodo": 202604,
        "valor": 2694570426.0,
        "delta": 26310705.0
      },
      {
        "periodo": 202605,
        "valor": 2720036931.0,
        "delta": 25466505.0
      },
      {
        "periodo": 202606,
        "valor": 2753683757.0,
        "delta": 33646826.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 1769866122.0,
    "valor_anterior": 1764409777.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1714145252.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1718219125.0,
        "delta": 4073873.0
      },
      {
        "periodo": 202508,
        "valor": 1723442525.0,
        "delta": 5223400.0
      },
      {
        "periodo": 202509,
        "valor": 1728723925.0,
        "delta": 5281400.0
      },
      {
        "periodo": 202510,
        "valor": 1735645927.0,
        "delta": 6922002.0
      },
      {
        "periodo": 202511,
        "valor": 1736496797.0,
        "delta": 850870.0
      },
      {
        "periodo": 202512,
        "valor": 1739584614.0,
        "delta": 3087817.0
      },
      {
        "periodo": 202601,
        "valor": 1742713224.0,
        "delta": 3128610.0
      },
      {
        "periodo": 202602,
        "valor": 1746884767.0,
        "delta": 4171543.0
      },
      {
        "periodo": 202603,
        "valor": 1754778919.0,
        "delta": 7894152.0
      },
      {
        "periodo": 202604,
        "valor": 1757128311.0,
        "delta": 2349392.0
      },
      {
        "periodo": 202605,
        "valor": 1764409777.0,
        "delta": 7281466.0
      },
      {
        "periodo": 202606,
        "valor": 1769866122.0,
        "delta": 5456345.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 5714525537.0,
    "valor_anterior": 5664531113.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5470552972.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 5474516138.0,
        "delta": 3963166.0
      },
      {
        "periodo": 202508,
        "valor": 5517082411.0,
        "delta": 42566273.0
      },
      {
        "periodo": 202509,
        "valor": 5583420492.0,
        "delta": 66338081.0
      },
      {
        "periodo": 202510,
        "valor": 5602593336.0,
        "delta": 19172844.0
      },
      {
        "periodo": 202511,
        "valor": 5590326107.0,
        "delta": -12267229.0
      },
      {
        "periodo": 202512,
        "valor": 5573944347.0,
        "delta": -16381760.0
      },
      {
        "periodo": 202601,
        "valor": 5604669785.0,
        "delta": 30725438.0
      },
      {
        "periodo": 202602,
        "valor": 5639967680.0,
        "delta": 35297895.0
      },
      {
        "periodo": 202603,
        "valor": 5638442424.0,
        "delta": -1525256.0
      },
      {
        "periodo": 202604,
        "valor": 5625540441.0,
        "delta": -12901983.0
      },
      {
        "periodo": 202605,
        "valor": 5664531113.0,
        "delta": 38990672.0
      },
      {
        "periodo": 202606,
        "valor": 5714525537.0,
        "delta": 49994424.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 841702757.0,
    "valor_anterior": 841455265.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 950653155.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 888476216.0,
        "delta": -62176939.0
      },
      {
        "periodo": 202508,
        "valor": 773096004.0,
        "delta": -115380212.0
      },
      {
        "periodo": 202509,
        "valor": 858305874.0,
        "delta": 85209870.0
      },
      {
        "periodo": 202510,
        "valor": 865349154.0,
        "delta": 7043280.0
      },
      {
        "periodo": 202511,
        "valor": 850179715.0,
        "delta": -15169439.0
      },
      {
        "periodo": 202512,
        "valor": 945219835.0,
        "delta": 95040120.0
      },
      {
        "periodo": 202601,
        "valor": 891622864.0,
        "delta": -53596971.0
      },
      {
        "periodo": 202602,
        "valor": 903111521.0,
        "delta": 11488657.0
      },
      {
        "periodo": 202603,
        "valor": 863279110.0,
        "delta": -39832411.0
      },
      {
        "periodo": 202604,
        "valor": 855271846.0,
        "delta": -8007264.0
      },
      {
        "periodo": 202605,
        "valor": 841455265.0,
        "delta": -13816581.0
      },
      {
        "periodo": 202606,
        "valor": 841702757.0,
        "delta": 247492.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 1900616213.9,
    "valor_anterior": 1854953441.6,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1562196664.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1564829002.0,
        "delta": 2632338.0
      },
      {
        "periodo": 202508,
        "valor": 1568105905.0,
        "delta": 3276903.0
      },
      {
        "periodo": 202509,
        "valor": 1571251743.0,
        "delta": 3145838.0
      },
      {
        "periodo": 202510,
        "valor": 1572976651.0,
        "delta": 1724908.0
      },
      {
        "periodo": 202511,
        "valor": 1576221086.0,
        "delta": 3244435.0
      },
      {
        "periodo": 202512,
        "valor": 1578421792.0,
        "delta": 2200706.0
      },
      {
        "periodo": 202601,
        "valor": 1582516739.0,
        "delta": 4094947.0
      },
      {
        "periodo": 202602,
        "valor": 1804725857.8,
        "delta": 222209118.8
      },
      {
        "periodo": 202603,
        "valor": 1832398824.0,
        "delta": 27672966.2
      },
      {
        "periodo": 202604,
        "valor": 1832076268.1,
        "delta": -322555.9
      },
      {
        "periodo": 202605,
        "valor": 1854953441.6,
        "delta": 22877173.5
      },
      {
        "periodo": 202606,
        "valor": 1900616213.9,
        "delta": 45662772.3
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 3074648773.0,
    "valor_anterior": 1582760923.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2113934681.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1989543257.0,
        "delta": -124391424.0
      },
      {
        "periodo": 202508,
        "valor": 1830461754.0,
        "delta": -159081503.0
      },
      {
        "periodo": 202509,
        "valor": 1661381263.0,
        "delta": -169080491.0
      },
      {
        "periodo": 202510,
        "valor": 1423803459.0,
        "delta": -237577804.0
      },
      {
        "periodo": 202511,
        "valor": 1178272374.0,
        "delta": -245531085.0
      },
      {
        "periodo": 202512,
        "valor": 1681072680.0,
        "delta": 502800306.0
      },
      {
        "periodo": 202601,
        "valor": 2692866264.0,
        "delta": 1011793584.0
      },
      {
        "periodo": 202602,
        "valor": 2479196956.0,
        "delta": -213669308.0
      },
      {
        "periodo": 202603,
        "valor": 2065254279.0,
        "delta": -413942677.0
      },
      {
        "periodo": 202604,
        "valor": 1829876118.0,
        "delta": -235378161.0
      },
      {
        "periodo": 202605,
        "valor": 1582760923.0,
        "delta": -247115195.0
      },
      {
        "periodo": 202606,
        "valor": 3074648773.0,
        "delta": 1491887850.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 2178752004.0,
    "valor_anterior": 2257671087.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 1325212615.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 1398768756.0,
        "delta": 73556141.0
      },
      {
        "periodo": 202601,
        "valor": 1374218924.0,
        "delta": -24549832.0
      },
      {
        "periodo": 202602,
        "valor": 1328755837.0,
        "delta": -45463087.0
      },
      {
        "periodo": 202603,
        "valor": 1271674797.0,
        "delta": -57081040.0
      },
      {
        "periodo": 202604,
        "valor": 2324921522.0,
        "delta": 1053246725.0
      },
      {
        "periodo": 202605,
        "valor": 2257671087.0,
        "delta": -67250435.0
      },
      {
        "periodo": 202606,
        "valor": 2178752004.0,
        "delta": -78919083.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 4688474073.1,
    "valor_anterior": 4131933371.4,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 2989288632.9,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 4737104141.9,
        "delta": 1747815509.0
      },
      {
        "periodo": 202605,
        "valor": 4131933371.4,
        "delta": -605170770.5
      },
      {
        "periodo": 202606,
        "valor": 4688474073.1,
        "delta": 556540701.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 1952932632996.2,
    "valor_anterior": 1943726433665.525,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1776450559441.225,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1801932772267.55,
        "delta": 25482212826.325
      },
      {
        "periodo": 202508,
        "valor": 1824030370661.275,
        "delta": 22097598393.7249
      },
      {
        "periodo": 202509,
        "valor": 1827636270638.1,
        "delta": 3605899976.8252
      },
      {
        "periodo": 202510,
        "valor": 1852466937443.05,
        "delta": 24830666804.95
      },
      {
        "periodo": 202511,
        "valor": 1830374020094.6,
        "delta": -22092917348.45
      },
      {
        "periodo": 202512,
        "valor": 1813302022436.1,
        "delta": -17071997658.5
      },
      {
        "periodo": 202601,
        "valor": 1839712329719.0662,
        "delta": 26410307282.9661
      },
      {
        "periodo": 202602,
        "valor": 1893578418630.516,
        "delta": 53866088911.45
      },
      {
        "periodo": 202603,
        "valor": 1904392956467.15,
        "delta": 10814537836.6338
      },
      {
        "periodo": 202604,
        "valor": 1889503177580.65,
        "delta": -14889778886.5
      },
      {
        "periodo": 202605,
        "valor": 1943726433665.525,
        "delta": 54223256084.875
      },
      {
        "periodo": 202606,
        "valor": 1952932632996.2,
        "delta": 9206199330.675
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 1435131163939.1,
    "valor_anterior": 1432406978297.325,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1307149816236.3,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1327554724408.1,
        "delta": 20404908171.8
      },
      {
        "periodo": 202508,
        "valor": 1344794238316.4,
        "delta": 17239513908.2998
      },
      {
        "periodo": 202509,
        "valor": 1340262387315.7,
        "delta": -4531851000.7
      },
      {
        "periodo": 202510,
        "valor": 1362871186554.4,
        "delta": 22608799238.7
      },
      {
        "periodo": 202511,
        "valor": 1345519223547.9,
        "delta": -17351963006.5
      },
      {
        "periodo": 202512,
        "valor": 1321442993092.7,
        "delta": -24076230455.2
      },
      {
        "periodo": 202601,
        "valor": 1342674772651.8,
        "delta": 21231779559.1001
      },
      {
        "periodo": 202602,
        "valor": 1390799526652.3,
        "delta": 48124754000.5
      },
      {
        "periodo": 202603,
        "valor": 1399385681633.1,
        "delta": 8586154980.8
      },
      {
        "periodo": 202604,
        "valor": 1386391165412.5,
        "delta": -12994516220.6001
      },
      {
        "periodo": 202605,
        "valor": 1432406978297.325,
        "delta": 46015812884.825
      },
      {
        "periodo": 202606,
        "valor": 1435131163939.1,
        "delta": 2724185641.7751
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 28780790503.0,
    "valor_anterior": 28596735973.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 38537550623.875,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 39008493896.5,
        "delta": 470943272.625
      },
      {
        "periodo": 202508,
        "valor": 38198223222.875,
        "delta": -810270673.625
      },
      {
        "periodo": 202509,
        "valor": 37424065899.5,
        "delta": -774157323.375
      },
      {
        "periodo": 202510,
        "valor": 33445897371.0,
        "delta": -3978168528.5
      },
      {
        "periodo": 202511,
        "valor": 27699119440.1,
        "delta": -5746777930.9
      },
      {
        "periodo": 202512,
        "valor": 28620765359.2,
        "delta": 921645919.1
      },
      {
        "periodo": 202601,
        "valor": 28940326380.0,
        "delta": 319561020.8
      },
      {
        "periodo": 202602,
        "valor": 29437849915.7,
        "delta": 497523535.7
      },
      {
        "periodo": 202603,
        "valor": 29618642594.8,
        "delta": 180792679.1
      },
      {
        "periodo": 202604,
        "valor": 28128885500.2,
        "delta": -1489757094.6
      },
      {
        "periodo": 202605,
        "valor": 28596735973.2,
        "delta": 467850473.0
      },
      {
        "periodo": 202606,
        "valor": 28780790503.0,
        "delta": 184054529.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 201720206338.0,
    "valor_anterior": 200595440676.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 181980463666.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 184061412395.0,
        "delta": 2080948729.0
      },
      {
        "periodo": 202508,
        "valor": 186592177640.0,
        "delta": 2530765245.0
      },
      {
        "periodo": 202509,
        "valor": 188971471887.0,
        "delta": 2379294247.0
      },
      {
        "periodo": 202510,
        "valor": 190662040843.0,
        "delta": 1690568956.0
      },
      {
        "periodo": 202511,
        "valor": 191020426047.0,
        "delta": 358385204.0
      },
      {
        "periodo": 202512,
        "valor": 192808409103.0,
        "delta": 1787983056.0
      },
      {
        "periodo": 202601,
        "valor": 194457766064.5,
        "delta": 1649356961.5
      },
      {
        "periodo": 202602,
        "valor": 196199902090.0,
        "delta": 1742136025.5
      },
      {
        "periodo": 202603,
        "valor": 196246456799.0,
        "delta": 46554709.0
      },
      {
        "periodo": 202604,
        "valor": 198558924378.0,
        "delta": 2312467579.0
      },
      {
        "periodo": 202605,
        "valor": 200595440676.0,
        "delta": 2036516298.0
      },
      {
        "periodo": 202606,
        "valor": 201720206338.0,
        "delta": 1124765662.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 126692750081.8,
    "valor_anterior": 125110235349.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 111633330802.5,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 113217167748.8,
        "delta": 1583836946.3
      },
      {
        "periodo": 202508,
        "valor": 114281444730.0,
        "delta": 1064276981.2
      },
      {
        "periodo": 202509,
        "valor": 116032638233.6,
        "delta": 1751193503.6
      },
      {
        "periodo": 202510,
        "valor": 118012070525.4,
        "delta": 1979432291.8
      },
      {
        "periodo": 202511,
        "valor": 117817873827.5,
        "delta": -194196697.9
      },
      {
        "periodo": 202512,
        "valor": 119618852510.9,
        "delta": 1800978683.4
      },
      {
        "periodo": 202601,
        "valor": 121243893741.6,
        "delta": 1625041230.7
      },
      {
        "periodo": 202602,
        "valor": 122385082500.7,
        "delta": 1141188759.1
      },
      {
        "periodo": 202603,
        "valor": 121780925767.5,
        "delta": -604156733.2
      },
      {
        "periodo": 202604,
        "valor": 118858509789.0,
        "delta": -2922415978.5
      },
      {
        "periodo": 202605,
        "valor": 125110235349.0,
        "delta": 6251725560.0
      },
      {
        "periodo": 202606,
        "valor": 126692750081.8,
        "delta": 1582514732.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 47536182103.3,
    "valor_anterior": 46527195246.8,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 39595639334.9,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 39875519858.5,
        "delta": 279880523.6
      },
      {
        "periodo": 202508,
        "valor": 40589768882.2,
        "delta": 714249023.7
      },
      {
        "periodo": 202509,
        "valor": 42907586285.3,
        "delta": 2317817403.1
      },
      {
        "periodo": 202510,
        "valor": 44067531268.6,
        "delta": 1159944983.3
      },
      {
        "periodo": 202511,
        "valor": 44124700147.2,
        "delta": 57168878.6
      },
      {
        "periodo": 202512,
        "valor": 44874218435.8,
        "delta": 749518288.6
      },
      {
        "periodo": 202601,
        "valor": 45180488213.4,
        "delta": 306269777.6
      },
      {
        "periodo": 202602,
        "valor": 45692941882.1,
        "delta": 512453668.7
      },
      {
        "periodo": 202603,
        "valor": 46510628934.9,
        "delta": 817687052.8
      },
      {
        "periodo": 202604,
        "valor": 46469459279.5,
        "delta": -41169655.4
      },
      {
        "periodo": 202605,
        "valor": 46527195246.8,
        "delta": 57735967.3
      },
      {
        "periodo": 202606,
        "valor": 47536182103.3,
        "delta": 1008986856.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 4030211,
    "label": "Capital Neto Jun 2026",
    "valor_actual": 113071540031.0,
    "valor_anterior": 110489848123.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 97553758777.65,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 98215453960.65,
        "delta": 661695183.0
      },
      {
        "periodo": 202508,
        "valor": 99574517869.8,
        "delta": 1359063909.15
      },
      {
        "periodo": 202509,
        "valor": 102038121017.0,
        "delta": 2463603147.2
      },
      {
        "periodo": 202510,
        "valor": 103408210880.65,
        "delta": 1370089863.65
      },
      {
        "periodo": 202511,
        "valor": 104192677084.9,
        "delta": 784466204.25
      },
      {
        "periodo": 202512,
        "valor": 105936783934.5,
        "delta": 1744106849.6
      },
      {
        "periodo": 202601,
        "valor": 107215082667.7662,
        "delta": 1278298733.2662
      },
      {
        "periodo": 202602,
        "valor": 109063115589.7162,
        "delta": 1848032921.95
      },
      {
        "periodo": 202603,
        "valor": 110850620737.85,
        "delta": 1787505148.1338
      },
      {
        "periodo": 202604,
        "valor": 111096233221.45,
        "delta": 245612483.6
      },
      {
        "periodo": 202605,
        "valor": 110489848123.2,
        "delta": -606385098.25
      },
      {
        "periodo": 202606,
        "valor": 113071540031.0,
        "delta": 2581691907.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 145177562298.0,
    "valor_anterior": 144682916814.9,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 106356187537.6,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 107050130756.6,
        "delta": 693943219.0
      },
      {
        "periodo": 202508,
        "valor": 107970688497.0,
        "delta": 920557740.4
      },
      {
        "periodo": 202509,
        "valor": 108329740426.0,
        "delta": 359051929.0
      },
      {
        "periodo": 202510,
        "valor": 109135865952.4,
        "delta": 806125526.4
      },
      {
        "periodo": 202511,
        "valor": 108001781515.7,
        "delta": -1134084436.7
      },
      {
        "periodo": 202512,
        "valor": 107134320144.1,
        "delta": -867461371.6
      },
      {
        "periodo": 202601,
        "valor": 112237171118.2,
        "delta": 5102850974.1
      },
      {
        "periodo": 202602,
        "valor": 142514380591.9,
        "delta": 30277209473.7
      },
      {
        "periodo": 202603,
        "valor": 144633858827.0,
        "delta": 2119478235.1
      },
      {
        "periodo": 202604,
        "valor": 137668099583.1,
        "delta": -6965759243.9
      },
      {
        "periodo": 202605,
        "valor": 144682916814.9,
        "delta": 7014817231.8
      },
      {
        "periodo": 202606,
        "valor": 145177562298.0,
        "delta": 494645483.1
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 392703595188.1,
    "valor_anterior": 406020147288.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 363349510286.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 370452803223.0,
        "delta": 7103292937.0
      },
      {
        "periodo": 202508,
        "valor": 381214259503.0,
        "delta": 10761456280.0
      },
      {
        "periodo": 202509,
        "valor": 373853887692.0,
        "delta": -7360371811.0
      },
      {
        "periodo": 202510,
        "valor": 382777806219.0,
        "delta": 8923918527.0
      },
      {
        "periodo": 202511,
        "valor": 388524149709.0,
        "delta": 5746343490.0
      },
      {
        "periodo": 202512,
        "valor": 379332777175.0,
        "delta": -9191372534.0
      },
      {
        "periodo": 202601,
        "valor": 390683942608.0,
        "delta": 11351165433.0
      },
      {
        "periodo": 202602,
        "valor": 400098640860.0,
        "delta": 9414698252.0
      },
      {
        "periodo": 202603,
        "valor": 388033486880.0,
        "delta": -12065153980.0
      },
      {
        "periodo": 202604,
        "valor": 397366205845.0,
        "delta": 9332718965.0
      },
      {
        "periodo": 202605,
        "valor": 406020147288.0,
        "delta": 8653941443.0
      },
      {
        "periodo": 202606,
        "valor": 392703595188.1,
        "delta": -13316552099.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 141455484957.6,
    "valor_anterior": 148947642812.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 133564461422.5,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 135803230284.4,
        "delta": 2238768861.9
      },
      {
        "periodo": 202508,
        "valor": 138943311718.5,
        "delta": 3140081434.1
      },
      {
        "periodo": 202509,
        "valor": 142062589249.6,
        "delta": 3119277531.1
      },
      {
        "periodo": 202510,
        "valor": 143788016544.0,
        "delta": 1725427294.4
      },
      {
        "periodo": 202511,
        "valor": 144324983673.9,
        "delta": 536967129.9
      },
      {
        "periodo": 202512,
        "valor": 131580999115.6,
        "delta": -12743984558.3
      },
      {
        "periodo": 202601,
        "valor": 135712805438.7,
        "delta": 4131806323.1
      },
      {
        "periodo": 202602,
        "valor": 139441294150.3,
        "delta": 3728488711.6
      },
      {
        "periodo": 202603,
        "valor": 144736454077.0,
        "delta": 5295159926.7
      },
      {
        "periodo": 202604,
        "valor": 147910304431.5,
        "delta": 3173850354.5
      },
      {
        "periodo": 202605,
        "valor": 148947642812.2,
        "delta": 1037338380.7
      },
      {
        "periodo": 202606,
        "valor": 141455484957.6,
        "delta": -7492157854.6
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 72929827829.3,
    "valor_anterior": 77141971719.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 72200425549.8,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 72913581124.2,
        "delta": 713155574.4
      },
      {
        "periodo": 202508,
        "valor": 74119064771.4,
        "delta": 1205483647.2
      },
      {
        "periodo": 202509,
        "valor": 74979648035.3,
        "delta": 860583263.9
      },
      {
        "periodo": 202510,
        "valor": 75597595618.8,
        "delta": 617947583.5
      },
      {
        "periodo": 202511,
        "valor": 73830014423.5,
        "delta": -1767581195.3
      },
      {
        "periodo": 202512,
        "valor": 72996242603.7,
        "delta": -833771819.8
      },
      {
        "periodo": 202601,
        "valor": 74397953601.8,
        "delta": 1401710998.1
      },
      {
        "periodo": 202602,
        "valor": 75637302408.5,
        "delta": 1239348806.7
      },
      {
        "periodo": 202603,
        "valor": 76330196442.7,
        "delta": 692894034.2
      },
      {
        "periodo": 202604,
        "valor": 77048412656.9,
        "delta": 718216214.2
      },
      {
        "periodo": 202605,
        "valor": 77141971719.0,
        "delta": 93559062.1
      },
      {
        "periodo": 202606,
        "valor": 72929827829.3,
        "delta": -4212143889.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 41323769807.0,
    "valor_anterior": 40759287223.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 39191251218.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 39835064044.0,
        "delta": 643812826.0
      },
      {
        "periodo": 202508,
        "valor": 40610468043.0,
        "delta": 775403999.0
      },
      {
        "periodo": 202509,
        "valor": 41389390224.0,
        "delta": 778922181.0
      },
      {
        "periodo": 202510,
        "valor": 42118308699.0,
        "delta": 728918475.0
      },
      {
        "periodo": 202511,
        "valor": 41807651271.0,
        "delta": -310657428.0
      },
      {
        "periodo": 202512,
        "valor": 42407825520.0,
        "delta": 600174249.0
      },
      {
        "periodo": 202601,
        "valor": 43096091136.0,
        "delta": 688265616.0
      },
      {
        "periodo": 202602,
        "valor": 43645808124.0,
        "delta": 549716988.0
      },
      {
        "periodo": 202603,
        "valor": 43918734079.0,
        "delta": 272925955.0
      },
      {
        "periodo": 202604,
        "valor": 40087251360.0,
        "delta": -3831482719.0
      },
      {
        "periodo": 202605,
        "valor": 40759287223.0,
        "delta": 672035863.0
      },
      {
        "periodo": 202606,
        "valor": 41323769807.0,
        "delta": 564482584.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 162652050118.0,
    "valor_anterior": 162047276236.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 149305080063.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 152244338570.0,
        "delta": 2939258507.0
      },
      {
        "periodo": 202508,
        "valor": 152706153099.0,
        "delta": 461814529.0
      },
      {
        "periodo": 202509,
        "valor": 153283063691.0,
        "delta": 576910592.0
      },
      {
        "periodo": 202510,
        "valor": 155071429189.0,
        "delta": 1788365498.0
      },
      {
        "periodo": 202511,
        "valor": 156561035919.0,
        "delta": 1489606730.0
      },
      {
        "periodo": 202512,
        "valor": 158708980657.0,
        "delta": 2147944738.0
      },
      {
        "periodo": 202601,
        "valor": 160032842743.0,
        "delta": 1323862086.0
      },
      {
        "periodo": 202602,
        "valor": 160725103047.0,
        "delta": 692260304.0
      },
      {
        "periodo": 202603,
        "valor": 161352042060.0,
        "delta": 626939013.0
      },
      {
        "periodo": 202604,
        "valor": 161141778391.0,
        "delta": -210263669.0
      },
      {
        "periodo": 202605,
        "valor": 162047276236.0,
        "delta": 905497845.0
      },
      {
        "periodo": 202606,
        "valor": 162652050118.0,
        "delta": 604773882.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 22252762785.0,
    "valor_anterior": 22086755482.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14818609446.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 15125391591.0,
        "delta": 306782145.0
      },
      {
        "periodo": 202508,
        "valor": 15416939324.0,
        "delta": 291547733.0
      },
      {
        "periodo": 202509,
        "valor": 15766715265.0,
        "delta": 349775941.0
      },
      {
        "periodo": 202510,
        "valor": 16081156781.0,
        "delta": 314441516.0
      },
      {
        "periodo": 202511,
        "valor": 16456110871.0,
        "delta": 374954090.0
      },
      {
        "periodo": 202512,
        "valor": 16527030790.0,
        "delta": 70919919.0
      },
      {
        "periodo": 202601,
        "valor": 16672821479.0,
        "delta": 145790689.0
      },
      {
        "periodo": 202602,
        "valor": 16886802664.0,
        "delta": 213981185.0
      },
      {
        "periodo": 202603,
        "valor": 16997203508.0,
        "delta": 110400844.0
      },
      {
        "periodo": 202604,
        "valor": 17121146720.0,
        "delta": 123943212.0
      },
      {
        "periodo": 202605,
        "valor": 22086755482.0,
        "delta": 4965608762.0
      },
      {
        "periodo": 202606,
        "valor": 22252762785.0,
        "delta": 166007303.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 98925733385.1,
    "valor_anterior": 97904976044.3,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 88261378438.4,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 89299656419.9,
        "delta": 1038277981.5
      },
      {
        "periodo": 202508,
        "valor": 89778834981.5,
        "delta": 479178561.6
      },
      {
        "periodo": 202509,
        "valor": 89844613877.8,
        "delta": 65778896.3
      },
      {
        "periodo": 202510,
        "valor": 90447758268.2,
        "delta": 603144390.4
      },
      {
        "periodo": 202511,
        "valor": 90715426646.8,
        "delta": 267668378.6
      },
      {
        "periodo": 202512,
        "valor": 94999026626.3,
        "delta": 4283599979.5
      },
      {
        "periodo": 202601,
        "valor": 96260349459.1,
        "delta": 1261322832.8
      },
      {
        "periodo": 202602,
        "valor": 96870757325.6,
        "delta": 610407866.5
      },
      {
        "periodo": 202603,
        "valor": 96776534073.4,
        "delta": -94223252.2
      },
      {
        "periodo": 202604,
        "valor": 97247944479.0,
        "delta": 471410405.6
      },
      {
        "periodo": 202605,
        "valor": 97904976044.3,
        "delta": 657031565.3
      },
      {
        "periodo": 202606,
        "valor": 98925733385.1,
        "delta": 1020757340.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 26169085606.0,
    "valor_anterior": 25806269362.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 24074573952.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 24490394395.0,
        "delta": 415820443.0
      },
      {
        "periodo": 202508,
        "valor": 24918061452.0,
        "delta": 427667057.0
      },
      {
        "periodo": 202509,
        "valor": 25397798491.0,
        "delta": 479737039.0
      },
      {
        "periodo": 202510,
        "valor": 25838025325.0,
        "delta": 440226834.0
      },
      {
        "periodo": 202511,
        "valor": 25111483045.0,
        "delta": -726542280.0
      },
      {
        "periodo": 202512,
        "valor": 25670859942.0,
        "delta": 559376897.0
      },
      {
        "periodo": 202601,
        "valor": 26109621184.0,
        "delta": 438761242.0
      },
      {
        "periodo": 202602,
        "valor": 26326112956.0,
        "delta": 216491772.0
      },
      {
        "periodo": 202603,
        "valor": 24899366050.0,
        "delta": -1426746906.0
      },
      {
        "periodo": 202604,
        "valor": 25417242012.0,
        "delta": 517875962.0
      },
      {
        "periodo": 202605,
        "valor": 25806269362.0,
        "delta": 389027350.0
      },
      {
        "periodo": 202606,
        "valor": 26169085606.0,
        "delta": 362816244.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 11323454587.0,
    "valor_anterior": 11163327299.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 9832429197.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 10053825149.0,
        "delta": 221395952.0
      },
      {
        "periodo": 202508,
        "valor": 10108153818.0,
        "delta": 54328669.0
      },
      {
        "periodo": 202509,
        "valor": 10341340886.0,
        "delta": 233187068.0
      },
      {
        "periodo": 202510,
        "valor": 10540132629.0,
        "delta": 198791743.0
      },
      {
        "periodo": 202511,
        "valor": 10551526872.0,
        "delta": 11394243.0
      },
      {
        "periodo": 202512,
        "valor": 10609178686.0,
        "delta": 57651814.0
      },
      {
        "periodo": 202601,
        "valor": 10561862036.0,
        "delta": -47316650.0
      },
      {
        "periodo": 202602,
        "valor": 10598066364.0,
        "delta": 36204328.0
      },
      {
        "periodo": 202603,
        "valor": 10621966890.0,
        "delta": 23900526.0
      },
      {
        "periodo": 202604,
        "valor": 10802727862.0,
        "delta": 180760972.0
      },
      {
        "periodo": 202605,
        "valor": 11163327299.0,
        "delta": 360599437.0
      },
      {
        "periodo": 202606,
        "valor": 11323454587.0,
        "delta": 160127288.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 8905988404.0,
    "valor_anterior": 8796359811.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 7634519700.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 7737934453.0,
        "delta": 103414753.0
      },
      {
        "periodo": 202508,
        "valor": 7879318229.0,
        "delta": 141383776.0
      },
      {
        "periodo": 202509,
        "valor": 8005295975.0,
        "delta": 125977746.0
      },
      {
        "periodo": 202510,
        "valor": 8099697950.0,
        "delta": 94401975.0
      },
      {
        "periodo": 202511,
        "valor": 8198673888.0,
        "delta": 98975938.0
      },
      {
        "periodo": 202512,
        "valor": 8316530594.0,
        "delta": 117856706.0
      },
      {
        "periodo": 202601,
        "valor": 8372576672.0,
        "delta": 56046078.0
      },
      {
        "periodo": 202602,
        "valor": 8491404097.0,
        "delta": 118827425.0
      },
      {
        "periodo": 202603,
        "valor": 8597498489.0,
        "delta": 106094392.0
      },
      {
        "periodo": 202604,
        "valor": 8700208156.0,
        "delta": 102709667.0
      },
      {
        "periodo": 202605,
        "valor": 8796359811.0,
        "delta": 96151655.0
      },
      {
        "periodo": 202606,
        "valor": 8905988404.0,
        "delta": 109628593.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 9078957872.0,
    "valor_anterior": 9008599617.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 8832032546.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 8908482548.0,
        "delta": 76450002.0
      },
      {
        "periodo": 202508,
        "valor": 8955910580.0,
        "delta": 47428032.0
      },
      {
        "periodo": 202509,
        "valor": 8962026683.0,
        "delta": 6116103.0
      },
      {
        "periodo": 202510,
        "valor": 8813289278.0,
        "delta": -148737405.0
      },
      {
        "periodo": 202511,
        "valor": 8844959178.0,
        "delta": 31669900.0
      },
      {
        "periodo": 202512,
        "valor": 8466853899.0,
        "delta": -378105279.0
      },
      {
        "periodo": 202601,
        "valor": 8523657343.0,
        "delta": 56803444.0
      },
      {
        "periodo": 202602,
        "valor": 8508676268.0,
        "delta": -14981075.0
      },
      {
        "periodo": 202603,
        "valor": 8750774338.0,
        "delta": 242098070.0
      },
      {
        "periodo": 202604,
        "valor": 8799595686.0,
        "delta": 48821348.0
      },
      {
        "periodo": 202605,
        "valor": 9008599617.0,
        "delta": 209003931.0
      },
      {
        "periodo": 202606,
        "valor": 9078957872.0,
        "delta": 70358255.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 235765316179.0,
    "valor_anterior": 207782089538.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 219017961607.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 223354480175.0,
        "delta": 4336518568.0
      },
      {
        "periodo": 202508,
        "valor": 226254800628.0,
        "delta": 2900320453.0
      },
      {
        "periodo": 202509,
        "valor": 227850819992.0,
        "delta": 1596019364.0
      },
      {
        "periodo": 202510,
        "valor": 232213995171.0,
        "delta": 4363175179.0
      },
      {
        "periodo": 202511,
        "valor": 209665620426.0,
        "delta": -22548374745.0
      },
      {
        "periodo": 202512,
        "valor": 205777485371.0,
        "delta": -3888135055.0
      },
      {
        "periodo": 202601,
        "valor": 207203226559.0,
        "delta": 1425741188.0
      },
      {
        "periodo": 202602,
        "valor": 210094405464.0,
        "delta": 2891178905.0
      },
      {
        "periodo": 202603,
        "valor": 215697219142.0,
        "delta": 5602813678.0
      },
      {
        "periodo": 202604,
        "valor": 204101755590.0,
        "delta": -11595463552.0
      },
      {
        "periodo": 202605,
        "valor": 207782089538.0,
        "delta": 3680333948.0
      },
      {
        "periodo": 202606,
        "valor": 235765316179.0,
        "delta": 27983226641.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 24731295494.0,
    "valor_anterior": 24645206311.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 22916362919.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 23056015843.0,
        "delta": 139652924.0
      },
      {
        "periodo": 202508,
        "valor": 23193314767.0,
        "delta": 137298924.0
      },
      {
        "periodo": 202509,
        "valor": 23203790187.0,
        "delta": 10475420.0
      },
      {
        "periodo": 202510,
        "valor": 23422602978.0,
        "delta": 218812791.0
      },
      {
        "periodo": 202511,
        "valor": 23424085580.0,
        "delta": 1482602.0
      },
      {
        "periodo": 202512,
        "valor": 23641486667.0,
        "delta": 217401087.0
      },
      {
        "periodo": 202601,
        "valor": 23870082534.0,
        "delta": 228595867.0
      },
      {
        "periodo": 202602,
        "valor": 24046001829.0,
        "delta": 175919295.0
      },
      {
        "periodo": 202603,
        "valor": 24277496497.0,
        "delta": 231494668.0
      },
      {
        "periodo": 202604,
        "valor": 24627047528.0,
        "delta": 349551031.0
      },
      {
        "periodo": 202605,
        "valor": 24645206311.0,
        "delta": 18158783.0
      },
      {
        "periodo": 202606,
        "valor": 24731295494.0,
        "delta": 86089183.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 9988691926.0,
    "valor_anterior": 9979932025.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 9328695775.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 9423066000.0,
        "delta": 94370225.0
      },
      {
        "periodo": 202508,
        "valor": 9505554392.0,
        "delta": 82488392.0
      },
      {
        "periodo": 202509,
        "valor": 9598747160.0,
        "delta": 93192768.0
      },
      {
        "periodo": 202510,
        "valor": 9658436450.0,
        "delta": 59689290.0
      },
      {
        "periodo": 202511,
        "valor": 9732629574.0,
        "delta": 74193124.0
      },
      {
        "periodo": 202512,
        "valor": 9789396080.0,
        "delta": 56766506.0
      },
      {
        "periodo": 202601,
        "valor": 9708635154.5,
        "delta": -80760925.5
      },
      {
        "periodo": 202602,
        "valor": 9842348116.0,
        "delta": 133712961.5
      },
      {
        "periodo": 202603,
        "valor": 9871841804.0,
        "delta": 29493688.0
      },
      {
        "periodo": 202604,
        "valor": 9932157533.0,
        "delta": 60315729.0
      },
      {
        "periodo": 202605,
        "valor": 9979932025.0,
        "delta": 47774492.0
      },
      {
        "periodo": 202606,
        "valor": 9988691926.0,
        "delta": 8759901.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 40166607084.0,
    "valor_anterior": 39983737528.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 35954193997.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 36270917460.0,
        "delta": 316723463.0
      },
      {
        "periodo": 202508,
        "valor": 36933277061.0,
        "delta": 662359601.0
      },
      {
        "periodo": 202509,
        "valor": 37555950234.0,
        "delta": 622673173.0
      },
      {
        "periodo": 202510,
        "valor": 37946905053.0,
        "delta": 390954819.0
      },
      {
        "periodo": 202511,
        "valor": 38229082961.0,
        "delta": 282177908.0
      },
      {
        "periodo": 202512,
        "valor": 38467441970.0,
        "delta": 238359009.0
      },
      {
        "periodo": 202601,
        "valor": 38590299553.0,
        "delta": 122857583.0
      },
      {
        "periodo": 202602,
        "valor": 39083801221.0,
        "delta": 493501668.0
      },
      {
        "periodo": 202603,
        "valor": 39354466778.0,
        "delta": 270665557.0
      },
      {
        "periodo": 202604,
        "valor": 39651216833.0,
        "delta": 296750055.0
      },
      {
        "periodo": 202605,
        "valor": 39983737528.0,
        "delta": 332520695.0
      },
      {
        "periodo": 202606,
        "valor": 40166607084.0,
        "delta": 182869556.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 17931895433.0,
    "valor_anterior": 17574616251.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 15113248017.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 15367468737.0,
        "delta": 254220720.0
      },
      {
        "periodo": 202508,
        "valor": 15707675760.0,
        "delta": 340207023.0
      },
      {
        "periodo": 202509,
        "valor": 16066480606.0,
        "delta": 358804846.0
      },
      {
        "periodo": 202510,
        "valor": 16461992467.0,
        "delta": 395511861.0
      },
      {
        "periodo": 202511,
        "valor": 16713178174.0,
        "delta": 251185707.0
      },
      {
        "periodo": 202512,
        "valor": 17157390343.0,
        "delta": 444212169.0
      },
      {
        "periodo": 202601,
        "valor": 17566601215.0,
        "delta": 409210872.0
      },
      {
        "periodo": 202602,
        "valor": 17836628385.0,
        "delta": 270027170.0
      },
      {
        "periodo": 202603,
        "valor": 17863535271.0,
        "delta": 26906886.0
      },
      {
        "periodo": 202604,
        "valor": 17250284642.0,
        "delta": -613250629.0
      },
      {
        "periodo": 202605,
        "valor": 17574616251.0,
        "delta": 324331609.0
      },
      {
        "periodo": 202606,
        "valor": 17931895433.0,
        "delta": 357279182.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 8097106240.4,
    "valor_anterior": 7997760728.5,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 7414653006.1,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 7368886294.6,
        "delta": -45766711.5
      },
      {
        "periodo": 202508,
        "valor": 7399032372.0,
        "delta": 30146077.4
      },
      {
        "periodo": 202509,
        "valor": 7501672612.3,
        "delta": 102640240.3
      },
      {
        "periodo": 202510,
        "valor": 7558890143.4,
        "delta": 57217531.1
      },
      {
        "periodo": 202511,
        "valor": 7667261563.0,
        "delta": 108371419.6
      },
      {
        "periodo": 202512,
        "valor": 7663469275.5,
        "delta": -3792287.5
      },
      {
        "periodo": 202601,
        "valor": 7824224995.8,
        "delta": 160755720.3
      },
      {
        "periodo": 202602,
        "valor": 7777378732.7,
        "delta": -46846263.1
      },
      {
        "periodo": 202603,
        "valor": 7909443191.4,
        "delta": 132064458.7
      },
      {
        "periodo": 202604,
        "valor": 8020206476.5,
        "delta": 110763285.1
      },
      {
        "periodo": 202605,
        "valor": 7997760728.5,
        "delta": -22445748.0
      },
      {
        "periodo": 202606,
        "valor": 8097106240.4,
        "delta": 99345511.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 81988480764.0,
    "valor_anterior": 81485843101.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 71151063178.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 72103528805.0,
        "delta": 952465627.0
      },
      {
        "periodo": 202508,
        "valor": 73653620412.0,
        "delta": 1550091607.0
      },
      {
        "periodo": 202509,
        "valor": 74865413276.0,
        "delta": 1211792864.0
      },
      {
        "periodo": 202510,
        "valor": 75795523032.0,
        "delta": 930109756.0
      },
      {
        "periodo": 202511,
        "valor": 76322811638.0,
        "delta": 527288606.0
      },
      {
        "periodo": 202512,
        "valor": 77980364691.0,
        "delta": 1657553053.0
      },
      {
        "periodo": 202601,
        "valor": 79223008147.0,
        "delta": 1242643456.0
      },
      {
        "periodo": 202602,
        "valor": 80032689891.0,
        "delta": 809681744.0
      },
      {
        "periodo": 202603,
        "valor": 79245696659.0,
        "delta": -786993232.0
      },
      {
        "periodo": 202604,
        "valor": 80566831304.0,
        "delta": 1321134645.0
      },
      {
        "periodo": 202605,
        "valor": 81485843101.0,
        "delta": 919011797.0
      },
      {
        "periodo": 202606,
        "valor": 81988480764.0,
        "delta": 502637663.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 2095207014.0,
    "valor_anterior": 2089938884.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2160763546.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2148145170.0,
        "delta": -12618376.0
      },
      {
        "periodo": 202508,
        "valor": 2134753315.0,
        "delta": -13391855.0
      },
      {
        "periodo": 202509,
        "valor": 2124311331.0,
        "delta": -10441984.0
      },
      {
        "periodo": 202510,
        "valor": 2133432924.0,
        "delta": 9121593.0
      },
      {
        "periodo": 202511,
        "valor": 2111966859.0,
        "delta": -21466065.0
      },
      {
        "periodo": 202512,
        "valor": 2133939984.0,
        "delta": 21973125.0
      },
      {
        "periodo": 202601,
        "valor": 2132555635.0,
        "delta": -1384349.0
      },
      {
        "periodo": 202602,
        "valor": 2087625246.0,
        "delta": -44930389.0
      },
      {
        "periodo": 202603,
        "valor": 2084840601.0,
        "delta": -2784645.0
      },
      {
        "periodo": 202604,
        "valor": 2089793489.0,
        "delta": 4952888.0
      },
      {
        "periodo": 202605,
        "valor": 2089938884.0,
        "delta": 145395.0
      },
      {
        "periodo": 202606,
        "valor": 2095207014.0,
        "delta": 5268130.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 47466405061.0,
    "valor_anterior": 48432365766.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 44147851722.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 44481963663.0,
        "delta": 334111941.0
      },
      {
        "periodo": 202508,
        "valor": 44960880035.0,
        "delta": 478916372.0
      },
      {
        "periodo": 202509,
        "valor": 47403408582.0,
        "delta": 2442528547.0
      },
      {
        "periodo": 202510,
        "valor": 48383932697.0,
        "delta": 980524115.0
      },
      {
        "periodo": 202511,
        "valor": 48983667272.0,
        "delta": 599734575.0
      },
      {
        "periodo": 202512,
        "valor": 50026222627.0,
        "delta": 1042555355.0
      },
      {
        "periodo": 202601,
        "valor": 49092984842.0,
        "delta": -933237785.0
      },
      {
        "periodo": 202602,
        "valor": 49628651738.0,
        "delta": 535666896.0
      },
      {
        "periodo": 202603,
        "valor": 50336379717.0,
        "delta": 707727979.0
      },
      {
        "periodo": 202604,
        "valor": 49163645552.0,
        "delta": -1172734165.0
      },
      {
        "periodo": 202605,
        "valor": 48432365766.0,
        "delta": -731279786.0
      },
      {
        "periodo": 202606,
        "valor": 47466405061.0,
        "delta": -965960705.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 5562530148.0,
    "valor_anterior": 5166568402.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1536211677.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1591686281.0,
        "delta": 55474604.0
      },
      {
        "periodo": 202508,
        "valor": 1658691566.0,
        "delta": 67005285.0
      },
      {
        "periodo": 202509,
        "valor": 3730791638.0,
        "delta": 2072100072.0
      },
      {
        "periodo": 202510,
        "valor": 4400252514.0,
        "delta": 669460876.0
      },
      {
        "periodo": 202511,
        "valor": 4361880457.0,
        "delta": -38372057.0
      },
      {
        "periodo": 202512,
        "valor": 4517709086.0,
        "delta": 155828629.0
      },
      {
        "periodo": 202601,
        "valor": 4666291638.0,
        "delta": 148582552.0
      },
      {
        "periodo": 202602,
        "valor": 4864775694.0,
        "delta": 198484056.0
      },
      {
        "periodo": 202603,
        "valor": 5288600710.0,
        "delta": 423825016.0
      },
      {
        "periodo": 202604,
        "valor": 5396030654.0,
        "delta": 107429944.0
      },
      {
        "periodo": 202605,
        "valor": 5166568402.0,
        "delta": -229462252.0
      },
      {
        "periodo": 202606,
        "valor": 5562530148.0,
        "delta": 395961746.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 8766200954.0,
    "valor_anterior": 8753499969.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 9000630997.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 9238125237.0,
        "delta": 237494240.0
      },
      {
        "periodo": 202508,
        "valor": 9189686559.0,
        "delta": -48438678.0
      },
      {
        "periodo": 202509,
        "valor": 9267768475.0,
        "delta": 78081916.0
      },
      {
        "periodo": 202510,
        "valor": 9324010711.0,
        "delta": 56242236.0
      },
      {
        "periodo": 202511,
        "valor": 8583832871.0,
        "delta": -740177840.0
      },
      {
        "periodo": 202512,
        "valor": 8480343839.0,
        "delta": -103489032.0
      },
      {
        "periodo": 202601,
        "valor": 8543498517.0,
        "delta": 63154678.0
      },
      {
        "periodo": 202602,
        "valor": 8624580942.0,
        "delta": 81082425.0
      },
      {
        "periodo": 202603,
        "valor": 8653002027.0,
        "delta": 28421085.0
      },
      {
        "periodo": 202604,
        "valor": 8684696586.0,
        "delta": 31694559.0
      },
      {
        "periodo": 202605,
        "valor": 8753499969.0,
        "delta": 68803383.0
      },
      {
        "periodo": 202606,
        "valor": 8766200954.0,
        "delta": 12700985.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 19504669128.3,
    "valor_anterior": 18903781268.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17208350110.4,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17644500846.4,
        "delta": 436150736.0
      },
      {
        "periodo": 202508,
        "valor": 18097627477.3,
        "delta": 453126630.9
      },
      {
        "periodo": 202509,
        "valor": 18574872203.5,
        "delta": 477244726.2
      },
      {
        "periodo": 202510,
        "valor": 18915102566.9,
        "delta": 340230363.4
      },
      {
        "periodo": 202511,
        "valor": 17777436151.9,
        "delta": -1137666415.0
      },
      {
        "periodo": 202512,
        "valor": 18069550832.5,
        "delta": 292114680.6
      },
      {
        "periodo": 202601,
        "valor": 18763190297.1,
        "delta": 693639464.6
      },
      {
        "periodo": 202602,
        "valor": 19434298698.1,
        "delta": 671108401.0
      },
      {
        "periodo": 202603,
        "valor": 19796334214.7,
        "delta": 362035516.6
      },
      {
        "periodo": 202604,
        "valor": 18143399725.6,
        "delta": -1652934489.1
      },
      {
        "periodo": 202605,
        "valor": 18903781268.0,
        "delta": 760381542.4
      },
      {
        "periodo": 202606,
        "valor": 19504669128.3,
        "delta": 600887860.3
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 10521184555.4,
    "valor_anterior": 10281708206.5,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 9006686787.4,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 9068439098.2,
        "delta": 61752310.8
      },
      {
        "periodo": 202508,
        "valor": 9138541284.0,
        "delta": 70102185.8
      },
      {
        "periodo": 202509,
        "valor": 9073534154.3,
        "delta": -65007129.7
      },
      {
        "periodo": 202510,
        "valor": 9379821885.0,
        "delta": 306287730.7
      },
      {
        "periodo": 202511,
        "valor": 9631942362.5,
        "delta": 252120477.5
      },
      {
        "periodo": 202512,
        "valor": 9664642379.4,
        "delta": 32700016.9
      },
      {
        "periodo": 202601,
        "valor": 9863363328.8,
        "delta": 198720949.4
      },
      {
        "periodo": 202602,
        "valor": 10008797369.0,
        "delta": 145434040.2
      },
      {
        "periodo": 202603,
        "valor": 10140269103.1,
        "delta": 131471734.1
      },
      {
        "periodo": 202604,
        "valor": 10235871248.5,
        "delta": 95602145.4
      },
      {
        "periodo": 202605,
        "valor": 10281708206.5,
        "delta": 45836958.0
      },
      {
        "periodo": 202606,
        "valor": 10521184555.4,
        "delta": 239476348.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 6287101398.0,
    "valor_anterior": 6343453655.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 6229731301.4,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 6271464073.0,
        "delta": 41732771.6
      },
      {
        "periodo": 202508,
        "valor": 6259481772.5,
        "delta": -11982300.5
      },
      {
        "periodo": 202509,
        "valor": 6334849642.0,
        "delta": 75367869.5
      },
      {
        "periodo": 202510,
        "valor": 6370443254.0,
        "delta": 35593612.0
      },
      {
        "periodo": 202511,
        "valor": 6295559259.0,
        "delta": -74883995.0
      },
      {
        "periodo": 202512,
        "valor": 6272704298.0,
        "delta": -22854961.0
      },
      {
        "periodo": 202601,
        "valor": 6270214942.0,
        "delta": -2489356.0
      },
      {
        "periodo": 202602,
        "valor": 6315471791.0,
        "delta": 45256849.0
      },
      {
        "periodo": 202603,
        "valor": 6222050059.0,
        "delta": -93421732.0
      },
      {
        "periodo": 202604,
        "valor": 6251388034.0,
        "delta": 29337975.0
      },
      {
        "periodo": 202605,
        "valor": 6343453655.0,
        "delta": 92065621.0
      },
      {
        "periodo": 202606,
        "valor": 6287101398.0,
        "delta": -56352257.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 3021418347.0,
    "valor_anterior": 3333110687.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 11165014029.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 10924719222.0,
        "delta": -240294807.0
      },
      {
        "periodo": 202508,
        "valor": 10747210148.0,
        "delta": -177509074.0
      },
      {
        "periodo": 202509,
        "valor": 9971087986.0,
        "delta": -776122162.0
      },
      {
        "periodo": 202510,
        "valor": 9877108994.0,
        "delta": -93978992.0
      },
      {
        "periodo": 202511,
        "valor": 3814985210.1,
        "delta": -6062123783.9
      },
      {
        "periodo": 202512,
        "valor": 4000296627.2,
        "delta": 185311417.1
      },
      {
        "periodo": 202601,
        "valor": 3806723175.0,
        "delta": -193573452.2
      },
      {
        "periodo": 202602,
        "valor": 3914795113.7,
        "delta": 108071938.7
      },
      {
        "periodo": 202603,
        "valor": 3898566949.8,
        "delta": -16228163.9
      },
      {
        "periodo": 202604,
        "valor": 3322965168.2,
        "delta": -575601781.6
      },
      {
        "periodo": 202605,
        "valor": 3333110687.2,
        "delta": 10145519.0
      },
      {
        "periodo": 202606,
        "valor": 3021418347.0,
        "delta": -311692340.2
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 22125150154.7,
    "valor_anterior": 21307335985.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 21418749499.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 21429841253.0,
        "delta": 11091754.0
      },
      {
        "periodo": 202508,
        "valor": 22069278210.0,
        "delta": 639436957.0
      },
      {
        "periodo": 202509,
        "valor": 21383615356.0,
        "delta": -685662854.0
      },
      {
        "periodo": 202510,
        "valor": 21689028764.0,
        "delta": 305413408.0
      },
      {
        "periodo": 202511,
        "valor": 21658875743.0,
        "delta": -30153021.0
      },
      {
        "periodo": 202512,
        "valor": 21258510632.0,
        "delta": -400365111.0
      },
      {
        "periodo": 202601,
        "valor": 21533210459.0,
        "delta": 274699827.0
      },
      {
        "periodo": 202602,
        "valor": 22182904466.0,
        "delta": 649694007.0
      },
      {
        "periodo": 202603,
        "valor": 20623160202.5,
        "delta": -1559744263.5
      },
      {
        "periodo": 202604,
        "valor": 21039161713.1,
        "delta": 416001510.6
      },
      {
        "periodo": 202605,
        "valor": 21307335985.2,
        "delta": 268174272.1
      },
      {
        "periodo": 202606,
        "valor": 22125150154.7,
        "delta": 817814169.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 752486413.5,
    "valor_anterior": 573383281.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 914256462.5,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 758157349.5,
        "delta": -156099113.0
      },
      {
        "periodo": 202508,
        "valor": 973730075.7,
        "delta": 215572726.2
      },
      {
        "periodo": 202509,
        "valor": 866854013.3,
        "delta": -106876062.4
      },
      {
        "periodo": 202510,
        "valor": 753280049.6,
        "delta": -113573963.7
      },
      {
        "periodo": 202511,
        "valor": 600936978.0,
        "delta": -152343071.6
      },
      {
        "periodo": 202512,
        "valor": 795021368.8,
        "delta": 194084390.8
      },
      {
        "periodo": 202601,
        "valor": 697919597.6,
        "delta": -97101771.2
      },
      {
        "periodo": 202602,
        "valor": 569747668.8,
        "delta": -128171928.8
      },
      {
        "periodo": 202603,
        "valor": 753919651.9,
        "delta": 184171983.1
      },
      {
        "periodo": 202604,
        "valor": 661043596.0,
        "delta": -92876055.9
      },
      {
        "periodo": 202605,
        "valor": 573383281.0,
        "delta": -87660315.0
      },
      {
        "periodo": 202606,
        "valor": 752486413.5,
        "delta": 179103132.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 1135514604.0,
    "valor_anterior": 1124878085.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1032511656.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1036620862.0,
        "delta": 4109206.0
      },
      {
        "periodo": 202508,
        "valor": 1046808867.0,
        "delta": 10188005.0
      },
      {
        "periodo": 202509,
        "valor": 1069324751.0,
        "delta": 22515884.0
      },
      {
        "periodo": 202510,
        "valor": 1078445356.0,
        "delta": 9120605.0
      },
      {
        "periodo": 202511,
        "valor": 1078593742.0,
        "delta": 148386.0
      },
      {
        "periodo": 202512,
        "valor": 1101202602.0,
        "delta": 22608860.0
      },
      {
        "periodo": 202601,
        "valor": 1103952916.0,
        "delta": 2750314.0
      },
      {
        "periodo": 202602,
        "valor": 1098452524.0,
        "delta": -5500392.0
      },
      {
        "periodo": 202603,
        "valor": 1106536042.0,
        "delta": 8083518.0
      },
      {
        "periodo": 202604,
        "valor": 1113080197.0,
        "delta": 6544155.0
      },
      {
        "periodo": 202605,
        "valor": 1124878085.0,
        "delta": 11797888.0
      },
      {
        "periodo": 202606,
        "valor": 1135514604.0,
        "delta": 10636519.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 5748795535.0,
    "valor_anterior": 5696825734.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4607313926.75,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4735053106.0,
        "delta": 127739179.25
      },
      {
        "periodo": 202508,
        "valor": 4762557367.25,
        "delta": 27504261.25
      },
      {
        "periodo": 202509,
        "valor": 4863144149.25,
        "delta": 100586782.0
      },
      {
        "periodo": 202510,
        "valor": 4931137042.0,
        "delta": 67992892.75
      },
      {
        "periodo": 202511,
        "valor": 5061822149.75,
        "delta": 130685107.75
      },
      {
        "periodo": 202512,
        "valor": 5120150372.0,
        "delta": 58328222.25
      },
      {
        "periodo": 202601,
        "valor": 5269875084.0,
        "delta": 149724712.0
      },
      {
        "periodo": 202602,
        "valor": 5224556624.75,
        "delta": -45318459.25
      },
      {
        "periodo": 202603,
        "valor": 5514986760.0,
        "delta": 290430135.25
      },
      {
        "periodo": 202604,
        "valor": 5602833232.0,
        "delta": 87846472.0
      },
      {
        "periodo": 202605,
        "valor": 5696825734.0,
        "delta": 93992502.0
      },
      {
        "periodo": 202606,
        "valor": 5748795535.0,
        "delta": 51969801.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 3558093926.0,
    "valor_anterior": 3490269647.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 3465540977.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3527287780.0,
        "delta": 61746803.0
      },
      {
        "periodo": 202508,
        "valor": 3546259944.0,
        "delta": 18972164.0
      },
      {
        "periodo": 202509,
        "valor": 3593332302.0,
        "delta": 47072358.0
      },
      {
        "periodo": 202510,
        "valor": 3578844765.0,
        "delta": -14487537.0
      },
      {
        "periodo": 202511,
        "valor": 3580386801.0,
        "delta": 1542036.0
      },
      {
        "periodo": 202512,
        "valor": 3631083997.0,
        "delta": 50697196.0
      },
      {
        "periodo": 202601,
        "valor": 3633400486.0,
        "delta": 2316489.0
      },
      {
        "periodo": 202602,
        "valor": 3686897848.0,
        "delta": 53497362.0
      },
      {
        "periodo": 202603,
        "valor": 3469550387.0,
        "delta": -217347461.0
      },
      {
        "periodo": 202604,
        "valor": 3481226238.0,
        "delta": 11675851.0
      },
      {
        "periodo": 202605,
        "valor": 3490269647.0,
        "delta": 9043409.0
      },
      {
        "periodo": 202606,
        "valor": 3558093926.0,
        "delta": 67824279.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4593097053.875,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4953613798.5,
        "delta": 360516744.625
      },
      {
        "periodo": 202508,
        "valor": 3833939945.875,
        "delta": -1119673852.625
      },
      {
        "periodo": 202509,
        "valor": 3979213693.5,
        "delta": 145273747.625
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 7827476723.0,
    "valor_anterior": 7689009035.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 7076970881.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 7201608685.0,
        "delta": 124637804.0
      },
      {
        "periodo": 202508,
        "valor": 7369426300.0,
        "delta": 167817615.0
      },
      {
        "periodo": 202509,
        "valor": 6888912545.0,
        "delta": -480513755.0
      },
      {
        "periodo": 202510,
        "valor": 7090495910.0,
        "delta": 201583365.0
      },
      {
        "periodo": 202511,
        "valor": 7170956056.0,
        "delta": 80460146.0
      },
      {
        "periodo": 202512,
        "valor": 7463078389.0,
        "delta": 292122333.0
      },
      {
        "periodo": 202601,
        "valor": 7567001990.0,
        "delta": 103923601.0
      },
      {
        "periodo": 202602,
        "valor": 7686426417.0,
        "delta": 119424427.0
      },
      {
        "periodo": 202603,
        "valor": 7856540374.0,
        "delta": 170113957.0
      },
      {
        "periodo": 202604,
        "valor": 7555635690.0,
        "delta": -300904684.0
      },
      {
        "periodo": 202605,
        "valor": 7689009035.0,
        "delta": 133373345.0
      },
      {
        "periodo": 202606,
        "valor": 7827476723.0,
        "delta": 138467688.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 2668524331.0,
    "valor_anterior": 2383588179.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1918429039.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1940741265.0,
        "delta": 22312226.0
      },
      {
        "periodo": 202508,
        "valor": 2045322113.0,
        "delta": 104580848.0
      },
      {
        "periodo": 202509,
        "valor": 2063324497.0,
        "delta": 18002384.0
      },
      {
        "periodo": 202510,
        "valor": 2107930424.0,
        "delta": 44605927.0
      },
      {
        "periodo": 202511,
        "valor": 2138153470.0,
        "delta": 30223046.0
      },
      {
        "periodo": 202512,
        "valor": 2339255501.0,
        "delta": 201102031.0
      },
      {
        "periodo": 202601,
        "valor": 2346167185.0,
        "delta": 6911684.0
      },
      {
        "periodo": 202602,
        "valor": 2438459036.0,
        "delta": 92291851.0
      },
      {
        "periodo": 202603,
        "valor": 2553064905.0,
        "delta": 114605869.0
      },
      {
        "periodo": 202604,
        "valor": 2427649183.0,
        "delta": -125415722.0
      },
      {
        "periodo": 202605,
        "valor": 2383588179.0,
        "delta": -44061004.0
      },
      {
        "periodo": 202606,
        "valor": 2668524331.0,
        "delta": 284936152.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 306402973.0,
    "valor_anterior": 303948833.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 294400889.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 306111605.0,
        "delta": 11710716.0
      },
      {
        "periodo": 202508,
        "valor": 297429566.0,
        "delta": -8682039.0
      },
      {
        "periodo": 202509,
        "valor": 302667304.0,
        "delta": 5237738.0
      },
      {
        "periodo": 202510,
        "valor": 296034369.0,
        "delta": -6632935.0
      },
      {
        "periodo": 202511,
        "valor": 308423676.0,
        "delta": 12389307.0
      },
      {
        "periodo": 202512,
        "valor": 311479032.0,
        "delta": 3055356.0
      },
      {
        "periodo": 202601,
        "valor": 304923267.0,
        "delta": -6555765.0
      },
      {
        "periodo": 202602,
        "valor": 305860793.0,
        "delta": 937526.0
      },
      {
        "periodo": 202603,
        "valor": 302730987.0,
        "delta": -3129806.0
      },
      {
        "periodo": 202604,
        "valor": 301698117.0,
        "delta": -1032870.0
      },
      {
        "periodo": 202605,
        "valor": 303948833.0,
        "delta": 2250716.0
      },
      {
        "periodo": 202606,
        "valor": 306402973.0,
        "delta": 2454140.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 452966795.0,
    "valor_anterior": 454984724.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 433033517.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 431021909.0,
        "delta": -2011608.0
      },
      {
        "periodo": 202508,
        "valor": 436666778.0,
        "delta": 5644869.0
      },
      {
        "periodo": 202509,
        "valor": 433801176.0,
        "delta": -2865602.0
      },
      {
        "periodo": 202510,
        "valor": 429234599.0,
        "delta": -4566577.0
      },
      {
        "periodo": 202511,
        "valor": 423437029.0,
        "delta": -5797570.0
      },
      {
        "periodo": 202512,
        "valor": 461764082.0,
        "delta": 38327053.0
      },
      {
        "periodo": 202601,
        "valor": 457778374.0,
        "delta": -3985708.0
      },
      {
        "periodo": 202602,
        "valor": 460214345.0,
        "delta": 2435971.0
      },
      {
        "periodo": 202603,
        "valor": 457649724.0,
        "delta": -2564621.0
      },
      {
        "periodo": 202604,
        "valor": 458217767.0,
        "delta": 568043.0
      },
      {
        "periodo": 202605,
        "valor": 454984724.0,
        "delta": -3233043.0
      },
      {
        "periodo": 202606,
        "valor": 452966795.0,
        "delta": -2017929.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 1883037860.6,
    "valor_anterior": 1882593763.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1774450501.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1777781033.0,
        "delta": 3330532.0
      },
      {
        "periodo": 202508,
        "valor": 1780781782.0,
        "delta": 3000749.0
      },
      {
        "periodo": 202509,
        "valor": 1797653989.0,
        "delta": 16872207.0
      },
      {
        "periodo": 202510,
        "valor": 1807442953.0,
        "delta": 9788964.0
      },
      {
        "periodo": 202511,
        "valor": 1818982902.0,
        "delta": 11539949.0
      },
      {
        "periodo": 202512,
        "valor": 1840328614.0,
        "delta": 21345712.0
      },
      {
        "periodo": 202601,
        "valor": 1848042929.0,
        "delta": 7714315.0
      },
      {
        "periodo": 202602,
        "valor": 1854326997.0,
        "delta": 6284068.0
      },
      {
        "periodo": 202603,
        "valor": 1863328273.0,
        "delta": 9001276.0
      },
      {
        "periodo": 202604,
        "valor": 1876630493.0,
        "delta": 13302220.0
      },
      {
        "periodo": 202605,
        "valor": 1882593763.0,
        "delta": 5963270.0
      },
      {
        "periodo": 202606,
        "valor": 1883037860.6,
        "delta": 444097.6
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 478804220.0,
    "valor_anterior": 477819770.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 455210280.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 455367440.0,
        "delta": 157160.0
      },
      {
        "periodo": 202508,
        "valor": 460822930.0,
        "delta": 5455490.0
      },
      {
        "periodo": 202509,
        "valor": 458796690.0,
        "delta": -2026240.0
      },
      {
        "periodo": 202510,
        "valor": 460873050.0,
        "delta": 2076360.0
      },
      {
        "periodo": 202511,
        "valor": 460191620.0,
        "delta": -681430.0
      },
      {
        "periodo": 202512,
        "valor": 471892340.0,
        "delta": 11700720.0
      },
      {
        "periodo": 202601,
        "valor": 477453740.0,
        "delta": 5561400.0
      },
      {
        "periodo": 202602,
        "valor": 477991040.0,
        "delta": 537300.0
      },
      {
        "periodo": 202603,
        "valor": 478552530.0,
        "delta": 561490.0
      },
      {
        "periodo": 202604,
        "valor": 477299190.0,
        "delta": -1253340.0
      },
      {
        "periodo": 202605,
        "valor": 477819770.0,
        "delta": 520580.0
      },
      {
        "periodo": 202606,
        "valor": 478804220.0,
        "delta": 984450.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 5368593201.5,
    "valor_anterior": 5350613083.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4460616102.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4559070924.0,
        "delta": 98454822.0
      },
      {
        "periodo": 202508,
        "valor": 4604946296.0,
        "delta": 45875372.0
      },
      {
        "periodo": 202509,
        "valor": 4634966337.0,
        "delta": 30020041.0
      },
      {
        "periodo": 202510,
        "valor": 4775617500.0,
        "delta": 140651163.0
      },
      {
        "periodo": 202511,
        "valor": 4867572280.0,
        "delta": 91954780.0
      },
      {
        "periodo": 202512,
        "valor": 4971884400.0,
        "delta": 104312120.0
      },
      {
        "periodo": 202601,
        "valor": 5067265162.0,
        "delta": 95380762.0
      },
      {
        "periodo": 202602,
        "valor": 5133980544.0,
        "delta": 66715382.0
      },
      {
        "periodo": 202603,
        "valor": 5153576560.0,
        "delta": 19596016.0
      },
      {
        "periodo": 202604,
        "valor": 5244124896.9,
        "delta": 90548336.9
      },
      {
        "periodo": 202605,
        "valor": 5350613083.0,
        "delta": 106488186.1
      },
      {
        "periodo": 202606,
        "valor": 5368593201.5,
        "delta": 17980118.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 1314782296.7,
    "valor_anterior": 1302000733.8,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 955712461.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 981709000.0,
        "delta": 25996539.0
      },
      {
        "periodo": 202508,
        "valor": 999001441.0,
        "delta": 17292441.0
      },
      {
        "periodo": 202509,
        "valor": 1042088160.0,
        "delta": 43086719.0
      },
      {
        "periodo": 202510,
        "valor": 1093977256.0,
        "delta": 51889096.0
      },
      {
        "periodo": 202511,
        "valor": 1147984151.2,
        "delta": 54006895.2
      },
      {
        "periodo": 202512,
        "valor": 1162436773.0,
        "delta": 14452621.8
      },
      {
        "periodo": 202601,
        "valor": 1170350513.8,
        "delta": 7913740.8
      },
      {
        "periodo": 202602,
        "valor": 1224629737.3,
        "delta": 54279223.5
      },
      {
        "periodo": 202603,
        "valor": 1259775546.0,
        "delta": 35145808.7
      },
      {
        "periodo": 202604,
        "valor": 1262560740.6,
        "delta": 2785194.6
      },
      {
        "periodo": 202605,
        "valor": 1302000733.8,
        "delta": 39439993.2
      },
      {
        "periodo": 202606,
        "valor": 1314782296.7,
        "delta": 12781562.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 2092075977.0,
    "valor_anterior": 2072115290.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1858410788.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1892155038.0,
        "delta": 33744250.0
      },
      {
        "periodo": 202508,
        "valor": 1917850222.0,
        "delta": 25695184.0
      },
      {
        "periodo": 202509,
        "valor": 1936120751.0,
        "delta": 18270529.0
      },
      {
        "periodo": 202510,
        "valor": 1983044780.0,
        "delta": 46924029.0
      },
      {
        "periodo": 202511,
        "valor": 2005710451.0,
        "delta": 22665671.0
      },
      {
        "periodo": 202512,
        "valor": 1999046590.0,
        "delta": -6663861.0
      },
      {
        "periodo": 202601,
        "valor": 2013659695.0,
        "delta": 14613105.0
      },
      {
        "periodo": 202602,
        "valor": 2038961717.0,
        "delta": 25302022.0
      },
      {
        "periodo": 202603,
        "valor": 2053975223.0,
        "delta": 15013506.0
      },
      {
        "periodo": 202604,
        "valor": 2034244819.0,
        "delta": -19730404.0
      },
      {
        "periodo": 202605,
        "valor": 2072115290.0,
        "delta": 37870471.0
      },
      {
        "periodo": 202606,
        "valor": 2092075977.0,
        "delta": 19960687.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 15901079636.0,
    "valor_anterior": 15746465065.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14361690430.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14514860848.0,
        "delta": 153170418.0
      },
      {
        "periodo": 202508,
        "valor": 14675271008.0,
        "delta": 160410160.0
      },
      {
        "periodo": 202509,
        "valor": 14812252723.0,
        "delta": 136981715.0
      },
      {
        "periodo": 202510,
        "valor": 14940188971.0,
        "delta": 127936248.0
      },
      {
        "periodo": 202511,
        "valor": 15044622342.0,
        "delta": 104433371.0
      },
      {
        "periodo": 202512,
        "valor": 15080506156.0,
        "delta": 35883814.0
      },
      {
        "periodo": 202601,
        "valor": 15216802256.0,
        "delta": 136296100.0
      },
      {
        "periodo": 202602,
        "valor": 15288750023.0,
        "delta": 71947767.0
      },
      {
        "periodo": 202603,
        "valor": 15409979269.0,
        "delta": 121229246.0
      },
      {
        "periodo": 202604,
        "valor": 15567363378.0,
        "delta": 157384109.0
      },
      {
        "periodo": 202605,
        "valor": 15746465065.0,
        "delta": 179101687.0
      },
      {
        "periodo": 202606,
        "valor": 15901079636.0,
        "delta": 154614571.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 1956930276.0,
    "valor_anterior": 1951081442.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1846844922.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1849418923.0,
        "delta": 2574001.0
      },
      {
        "periodo": 202508,
        "valor": 1866173408.0,
        "delta": 16754485.0
      },
      {
        "periodo": 202509,
        "valor": 1874604429.0,
        "delta": 8431021.0
      },
      {
        "periodo": 202510,
        "valor": 1886288516.0,
        "delta": 11684087.0
      },
      {
        "periodo": 202511,
        "valor": 1897329492.0,
        "delta": 11040976.0
      },
      {
        "periodo": 202512,
        "valor": 1898178315.0,
        "delta": 848823.0
      },
      {
        "periodo": 202601,
        "valor": 1906406487.0,
        "delta": 8228172.0
      },
      {
        "periodo": 202602,
        "valor": 1915397283.0,
        "delta": 8990796.0
      },
      {
        "periodo": 202603,
        "valor": 1929274304.0,
        "delta": 13877021.0
      },
      {
        "periodo": 202604,
        "valor": 1938672913.0,
        "delta": 9398609.0
      },
      {
        "periodo": 202605,
        "valor": 1951081442.0,
        "delta": 12408529.0
      },
      {
        "periodo": 202606,
        "valor": 1956930276.0,
        "delta": 5848834.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 4537819535.0,
    "valor_anterior": 4515640675.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4409067665.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4435853320.0,
        "delta": 26785655.0
      },
      {
        "periodo": 202508,
        "valor": 4463014419.0,
        "delta": 27161099.0
      },
      {
        "periodo": 202509,
        "valor": 4521455157.0,
        "delta": 58440738.0
      },
      {
        "periodo": 202510,
        "valor": 4552434549.0,
        "delta": 30979392.0
      },
      {
        "periodo": 202511,
        "valor": 4586609444.0,
        "delta": 34174895.0
      },
      {
        "periodo": 202512,
        "valor": 4589950238.0,
        "delta": 3340794.0
      },
      {
        "periodo": 202601,
        "valor": 4622136002.0,
        "delta": 32185764.0
      },
      {
        "periodo": 202602,
        "valor": 4652995907.0,
        "delta": 30859905.0
      },
      {
        "periodo": 202603,
        "valor": 4665673311.0,
        "delta": 12677404.0
      },
      {
        "periodo": 202604,
        "valor": 4496310431.0,
        "delta": -169362880.0
      },
      {
        "periodo": 202605,
        "valor": 4515640675.0,
        "delta": 19330244.0
      },
      {
        "periodo": 202606,
        "valor": 4537819535.0,
        "delta": 22178860.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 2247401916.0,
    "valor_anterior": 2238243648.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2146529525.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2166968786.0,
        "delta": 20439261.0
      },
      {
        "periodo": 202508,
        "valor": 2195341534.0,
        "delta": 28372748.0
      },
      {
        "periodo": 202509,
        "valor": 2202712137.0,
        "delta": 7370603.0
      },
      {
        "periodo": 202510,
        "valor": 2213045407.0,
        "delta": 10333270.0
      },
      {
        "periodo": 202511,
        "valor": 2210960305.0,
        "delta": -2085102.0
      },
      {
        "periodo": 202512,
        "valor": 2219903950.0,
        "delta": 8943645.0
      },
      {
        "periodo": 202601,
        "valor": 2226834082.0,
        "delta": 6930132.0
      },
      {
        "periodo": 202602,
        "valor": 2236382962.0,
        "delta": 9548880.0
      },
      {
        "periodo": 202603,
        "valor": 2225957117.0,
        "delta": -10425845.0
      },
      {
        "periodo": 202604,
        "valor": 2234409174.0,
        "delta": 8452057.0
      },
      {
        "periodo": 202605,
        "valor": 2238243648.0,
        "delta": 3834474.0
      },
      {
        "periodo": 202606,
        "valor": 2247401916.0,
        "delta": 9158268.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 2753683757.0,
    "valor_anterior": 2720036931.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2433812599.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2465020238.0,
        "delta": 31207639.0
      },
      {
        "periodo": 202508,
        "valor": 2495200765.0,
        "delta": 30180527.0
      },
      {
        "periodo": 202509,
        "valor": 2524852564.0,
        "delta": 29651799.0
      },
      {
        "periodo": 202510,
        "valor": 2548360078.0,
        "delta": 23507514.0
      },
      {
        "periodo": 202511,
        "valor": 2573941591.0,
        "delta": 25581513.0
      },
      {
        "periodo": 202512,
        "valor": 2587433142.0,
        "delta": 13491551.0
      },
      {
        "periodo": 202601,
        "valor": 2614786509.0,
        "delta": 27353367.0
      },
      {
        "periodo": 202602,
        "valor": 2640239469.0,
        "delta": 25452960.0
      },
      {
        "periodo": 202603,
        "valor": 2668259721.0,
        "delta": 28020252.0
      },
      {
        "periodo": 202604,
        "valor": 2694570426.0,
        "delta": 26310705.0
      },
      {
        "periodo": 202605,
        "valor": 2720036931.0,
        "delta": 25466505.0
      },
      {
        "periodo": 202606,
        "valor": 2753683757.0,
        "delta": 33646826.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 1768796312.0,
    "valor_anterior": 1763291561.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1712860533.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1716997430.0,
        "delta": 4136897.0
      },
      {
        "periodo": 202508,
        "valor": 1722227333.0,
        "delta": 5229903.0
      },
      {
        "periodo": 202509,
        "valor": 1727524741.0,
        "delta": 5297408.0
      },
      {
        "periodo": 202510,
        "valor": 1734422691.0,
        "delta": 6897950.0
      },
      {
        "periodo": 202511,
        "valor": 1735285990.0,
        "delta": 863299.0
      },
      {
        "periodo": 202512,
        "valor": 1738450252.0,
        "delta": 3164262.0
      },
      {
        "periodo": 202601,
        "valor": 1741610548.0,
        "delta": 3160296.0
      },
      {
        "periodo": 202602,
        "valor": 1745789232.0,
        "delta": 4178684.0
      },
      {
        "periodo": 202603,
        "valor": 1753633798.0,
        "delta": 7844566.0
      },
      {
        "periodo": 202604,
        "valor": 1756007158.0,
        "delta": 2373360.0
      },
      {
        "periodo": 202605,
        "valor": 1763291561.0,
        "delta": 7284403.0
      },
      {
        "periodo": 202606,
        "valor": 1768796312.0,
        "delta": 5504751.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 5714525537.0,
    "valor_anterior": 5664531113.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5470552972.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 5474516138.0,
        "delta": 3963166.0
      },
      {
        "periodo": 202508,
        "valor": 5517082411.0,
        "delta": 42566273.0
      },
      {
        "periodo": 202509,
        "valor": 5583420492.0,
        "delta": 66338081.0
      },
      {
        "periodo": 202510,
        "valor": 5602593336.0,
        "delta": 19172844.0
      },
      {
        "periodo": 202511,
        "valor": 5590326107.0,
        "delta": -12267229.0
      },
      {
        "periodo": 202512,
        "valor": 5573944347.0,
        "delta": -16381760.0
      },
      {
        "periodo": 202601,
        "valor": 5604669785.0,
        "delta": 30725438.0
      },
      {
        "periodo": 202602,
        "valor": 5639967680.0,
        "delta": 35297895.0
      },
      {
        "periodo": 202603,
        "valor": 5638442424.0,
        "delta": -1525256.0
      },
      {
        "periodo": 202604,
        "valor": 5625540441.0,
        "delta": -12901983.0
      },
      {
        "periodo": 202605,
        "valor": 5664531113.0,
        "delta": 38990672.0
      },
      {
        "periodo": 202606,
        "valor": 5714525537.0,
        "delta": 49994424.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 841702757.0,
    "valor_anterior": 841455265.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 950653155.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 888476216.0,
        "delta": -62176939.0
      },
      {
        "periodo": 202508,
        "valor": 773096004.0,
        "delta": -115380212.0
      },
      {
        "periodo": 202509,
        "valor": 858305874.0,
        "delta": 85209870.0
      },
      {
        "periodo": 202510,
        "valor": 865349154.0,
        "delta": 7043280.0
      },
      {
        "periodo": 202511,
        "valor": 850179715.0,
        "delta": -15169439.0
      },
      {
        "periodo": 202512,
        "valor": 945219835.0,
        "delta": 95040120.0
      },
      {
        "periodo": 202601,
        "valor": 891622864.0,
        "delta": -53596971.0
      },
      {
        "periodo": 202602,
        "valor": 903111521.0,
        "delta": 11488657.0
      },
      {
        "periodo": 202603,
        "valor": 863279110.0,
        "delta": -39832411.0
      },
      {
        "periodo": 202604,
        "valor": 855271846.0,
        "delta": -8007264.0
      },
      {
        "periodo": 202605,
        "valor": 841455265.0,
        "delta": -13816581.0
      },
      {
        "periodo": 202606,
        "valor": 841702757.0,
        "delta": 247492.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 1900508281.9,
    "valor_anterior": 1854846990.6,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1562196664.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1564829002.0,
        "delta": 2632338.0
      },
      {
        "periodo": 202508,
        "valor": 1568105905.0,
        "delta": 3276903.0
      },
      {
        "periodo": 202509,
        "valor": 1571251743.0,
        "delta": 3145838.0
      },
      {
        "periodo": 202510,
        "valor": 1572976651.0,
        "delta": 1724908.0
      },
      {
        "periodo": 202511,
        "valor": 1576221086.0,
        "delta": 3244435.0
      },
      {
        "periodo": 202512,
        "valor": 1578421792.0,
        "delta": 2200706.0
      },
      {
        "periodo": 202601,
        "valor": 1582516739.0,
        "delta": 4094947.0
      },
      {
        "periodo": 202602,
        "valor": 1804725857.8,
        "delta": 222209118.8
      },
      {
        "periodo": 202603,
        "valor": 1832298465.0,
        "delta": 27572607.2
      },
      {
        "periodo": 202604,
        "valor": 1831981932.1,
        "delta": -316532.9
      },
      {
        "periodo": 202605,
        "valor": 1854846990.6,
        "delta": 22865058.5
      },
      {
        "periodo": 202606,
        "valor": 1900508281.9,
        "delta": 45661291.3
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 3074648773.0,
    "valor_anterior": 1582760923.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2113934681.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1989543257.0,
        "delta": -124391424.0
      },
      {
        "periodo": 202508,
        "valor": 1830461754.0,
        "delta": -159081503.0
      },
      {
        "periodo": 202509,
        "valor": 1661381263.0,
        "delta": -169080491.0
      },
      {
        "periodo": 202510,
        "valor": 1423803459.0,
        "delta": -237577804.0
      },
      {
        "periodo": 202511,
        "valor": 1178272374.0,
        "delta": -245531085.0
      },
      {
        "periodo": 202512,
        "valor": 1681072680.0,
        "delta": 502800306.0
      },
      {
        "periodo": 202601,
        "valor": 2692866264.0,
        "delta": 1011793584.0
      },
      {
        "periodo": 202602,
        "valor": 2479196956.0,
        "delta": -213669308.0
      },
      {
        "periodo": 202603,
        "valor": 2065254279.0,
        "delta": -413942677.0
      },
      {
        "periodo": 202604,
        "valor": 1829876118.0,
        "delta": -235378161.0
      },
      {
        "periodo": 202605,
        "valor": 1582760923.0,
        "delta": -247115195.0
      },
      {
        "periodo": 202606,
        "valor": 3074648773.0,
        "delta": 1491887850.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 2178752004.0,
    "valor_anterior": 2257671087.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 1325212615.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 1398768756.0,
        "delta": 73556141.0
      },
      {
        "periodo": 202601,
        "valor": 1374218924.0,
        "delta": -24549832.0
      },
      {
        "periodo": 202602,
        "valor": 1328755837.0,
        "delta": -45463087.0
      },
      {
        "periodo": 202603,
        "valor": 1271674797.0,
        "delta": -57081040.0
      },
      {
        "periodo": 202604,
        "valor": 2324921522.0,
        "delta": 1053246725.0
      },
      {
        "periodo": 202605,
        "valor": 2257671087.0,
        "delta": -67250435.0
      },
      {
        "periodo": 202606,
        "valor": 2178752004.0,
        "delta": -78919083.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 4688474073.1,
    "valor_anterior": 4131933371.4,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 2989288632.9,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 4737104141.9,
        "delta": 1747815509.0
      },
      {
        "periodo": 202605,
        "valor": 4131933371.4,
        "delta": -605170770.5
      },
      {
        "periodo": 202606,
        "valor": 4688474073.1,
        "delta": 556540701.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 1758069410432.2,
    "valor_anterior": 1746496466243.6,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1591038725204.725,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1615280864669.3,
        "delta": 24242139464.575
      },
      {
        "periodo": 202508,
        "valor": 1640706107944.025,
        "delta": 25425243274.7249
      },
      {
        "periodo": 202509,
        "valor": 1647991185411.85,
        "delta": 7285077467.8252
      },
      {
        "periodo": 202510,
        "valor": 1669566382923.3,
        "delta": 21575197511.45
      },
      {
        "periodo": 202511,
        "valor": 1647134725481.35,
        "delta": -22431657441.95
      },
      {
        "periodo": 202512,
        "valor": 1632612053979.1,
        "delta": -14522671502.25
      },
      {
        "periodo": 202601,
        "valor": 1663752067210.4,
        "delta": 31140013231.2998
      },
      {
        "periodo": 202602,
        "valor": 1718355321572.45,
        "delta": 54603254362.05
      },
      {
        "periodo": 202603,
        "valor": 1723048220831.4,
        "delta": 4692899258.95
      },
      {
        "periodo": 202604,
        "valor": 1716175642899.9,
        "delta": -6872577931.5
      },
      {
        "periodo": 202605,
        "valor": 1746496466243.6,
        "delta": 30320823343.7002
      },
      {
        "periodo": 202606,
        "valor": 1758069410432.2,
        "delta": 11572944188.5999
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 1249609569955.1,
    "valor_anterior": 1244527020452.4,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1132055004904.3,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1151118220553.1,
        "delta": 19063215648.8
      },
      {
        "periodo": 202508,
        "valor": 1170987113198.4,
        "delta": 19868892645.2998
      },
      {
        "periodo": 202509,
        "valor": 1170204362963.7,
        "delta": -782750234.7
      },
      {
        "periodo": 202510,
        "valor": 1189032466962.4,
        "delta": 18828103998.7
      },
      {
        "periodo": 202511,
        "valor": 1171623012313.9,
        "delta": -17409454648.5
      },
      {
        "periodo": 202512,
        "valor": 1150529831692.7,
        "delta": -21093180621.2
      },
      {
        "periodo": 202601,
        "valor": 1176528291527.8,
        "delta": 25998459835.1001
      },
      {
        "periodo": 202602,
        "valor": 1225381883847.3,
        "delta": 48853592319.5
      },
      {
        "periodo": 202603,
        "valor": 1227559791502.1,
        "delta": 2177907654.8
      },
      {
        "periodo": 202604,
        "valor": 1222484500976.5,
        "delta": -5075290525.6001
      },
      {
        "periodo": 202605,
        "valor": 1244527020452.4,
        "delta": 22042519475.8999
      },
      {
        "periodo": 202606,
        "valor": 1249609569955.1,
        "delta": 5082549502.7002
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 28780790503.0,
    "valor_anterior": 28596735973.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 37948329980.875,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 38447410442.5,
        "delta": 499080461.625
      },
      {
        "periodo": 202508,
        "valor": 37658252153.875,
        "delta": -789158288.625
      },
      {
        "periodo": 202509,
        "valor": 36905694830.5,
        "delta": -752557323.375
      },
      {
        "periodo": 202510,
        "valor": 33429597371.0,
        "delta": -3476097459.5
      },
      {
        "periodo": 202511,
        "valor": 27699119440.1,
        "delta": -5730477930.9
      },
      {
        "periodo": 202512,
        "valor": 28620765359.2,
        "delta": 921645919.1
      },
      {
        "periodo": 202601,
        "valor": 28940326380.0,
        "delta": 319561020.8
      },
      {
        "periodo": 202602,
        "valor": 29437849915.7,
        "delta": 497523535.7
      },
      {
        "periodo": 202603,
        "valor": 29618642594.8,
        "delta": 180792679.1
      },
      {
        "periodo": 202604,
        "valor": 28128885500.2,
        "delta": -1489757094.6
      },
      {
        "periodo": 202605,
        "valor": 28596735973.2,
        "delta": 467850473.0
      },
      {
        "periodo": 202606,
        "valor": 28780790503.0,
        "delta": 184054529.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 198049022566.0,
    "valor_anterior": 196923479696.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 178407450271.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 180484375055.0,
        "delta": 2076924784.0
      },
      {
        "periodo": 202508,
        "valor": 183030792513.0,
        "delta": 2546417458.0
      },
      {
        "periodo": 202509,
        "valor": 185399613343.0,
        "delta": 2368820830.0
      },
      {
        "periodo": 202510,
        "valor": 187159766194.0,
        "delta": 1760152851.0
      },
      {
        "periodo": 202511,
        "valor": 187352180649.0,
        "delta": 192414455.0
      },
      {
        "periodo": 202512,
        "valor": 189143064939.0,
        "delta": 1790884290.0
      },
      {
        "periodo": 202601,
        "valor": 190781931396.5,
        "delta": 1638866457.5
      },
      {
        "periodo": 202602,
        "valor": 192508310343.0,
        "delta": 1726378946.5
      },
      {
        "periodo": 202603,
        "valor": 192576054768.0,
        "delta": 67744425.0
      },
      {
        "periodo": 202604,
        "valor": 194888956002.0,
        "delta": 2312901234.0
      },
      {
        "periodo": 202605,
        "valor": 196923479696.0,
        "delta": 2034523694.0
      },
      {
        "periodo": 202606,
        "valor": 198049022566.0,
        "delta": 1125542870.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 124264988629.8,
    "valor_anterior": 122678246067.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 108867464839.5,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 110403036270.8,
        "delta": 1535571431.3
      },
      {
        "periodo": 202508,
        "valor": 112158313483.0,
        "delta": 1755277212.2
      },
      {
        "periodo": 202509,
        "valor": 113941363469.6,
        "delta": 1783049986.6
      },
      {
        "periodo": 202510,
        "valor": 115916391804.4,
        "delta": 1975028334.8
      },
      {
        "periodo": 202511,
        "valor": 115719071454.5,
        "delta": -197320349.9
      },
      {
        "periodo": 202512,
        "valor": 117014334062.9,
        "delta": 1295262608.4
      },
      {
        "periodo": 202601,
        "valor": 118782924379.6,
        "delta": 1768590316.7
      },
      {
        "periodo": 202602,
        "valor": 119933649868.7,
        "delta": 1150725489.1
      },
      {
        "periodo": 202603,
        "valor": 119274995200.5,
        "delta": -658654668.2
      },
      {
        "periodo": 202604,
        "valor": 116449081195.0,
        "delta": -2825914005.5
      },
      {
        "periodo": 202605,
        "valor": 122678246067.0,
        "delta": 6229164872.0
      },
      {
        "periodo": 202606,
        "valor": 124264988629.8,
        "delta": 1586742562.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 45824872289.3,
    "valor_anterior": 44816753293.8,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 37852850956.9,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 38135305315.5,
        "delta": 282454358.6
      },
      {
        "periodo": 202508,
        "valor": 38826703121.2,
        "delta": 691397805.7
      },
      {
        "periodo": 202509,
        "valor": 41197038156.3,
        "delta": 2370335035.1
      },
      {
        "periodo": 202510,
        "valor": 42238750893.6,
        "delta": 1041712737.3
      },
      {
        "periodo": 202511,
        "valor": 42325830687.2,
        "delta": 87079793.6
      },
      {
        "periodo": 202512,
        "valor": 43133292319.8,
        "delta": 807461632.6
      },
      {
        "periodo": 202601,
        "valor": 43426929193.4,
        "delta": 293636873.6
      },
      {
        "periodo": 202602,
        "valor": 43960313706.1,
        "delta": 533384512.7
      },
      {
        "periodo": 202603,
        "valor": 44798880476.9,
        "delta": 838566770.8
      },
      {
        "periodo": 202604,
        "valor": 44756579438.5,
        "delta": -42301038.4
      },
      {
        "periodo": 202605,
        "valor": 44816753293.8,
        "delta": 60173855.3
      },
      {
        "periodo": 202606,
        "valor": 45824872289.3,
        "delta": 1008118995.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 4030212,
    "label": "Capital Básico (Tier 1) Jun 2026",
    "valor_actual": 111540166489.0,
    "valor_anterior": 108954230761.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 95907624252.15,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 96692517032.4,
        "delta": 784892780.25
      },
      {
        "periodo": 202508,
        "valor": 98044933474.55,
        "delta": 1352416442.15
      },
      {
        "periodo": 202509,
        "valor": 100343112648.75,
        "delta": 2298179174.2
      },
      {
        "periodo": 202510,
        "valor": 101789409697.9,
        "delta": 1446297049.15
      },
      {
        "periodo": 202511,
        "valor": 102415510936.65,
        "delta": 626101238.75
      },
      {
        "periodo": 202512,
        "valor": 104170765605.5,
        "delta": 1755254668.85
      },
      {
        "periodo": 202601,
        "valor": 105291664333.1,
        "delta": 1120898727.6
      },
      {
        "periodo": 202602,
        "valor": 107133313891.65,
        "delta": 1841649558.55
      },
      {
        "periodo": 202603,
        "valor": 109219856289.1,
        "delta": 2086542397.45
      },
      {
        "periodo": 202604,
        "valor": 109467639787.7,
        "delta": 247783498.6
      },
      {
        "periodo": 202605,
        "valor": 108954230761.2,
        "delta": -513409026.5
      },
      {
        "periodo": 202606,
        "valor": 111540166489.0,
        "delta": 2585935727.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 129177562298.0,
    "valor_anterior": 128682916814.9,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 90356187537.6,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 91050130756.6,
        "delta": 693943219.0
      },
      {
        "periodo": 202508,
        "valor": 91970688497.0,
        "delta": 920557740.4
      },
      {
        "periodo": 202509,
        "valor": 92329740426.0,
        "delta": 359051929.0
      },
      {
        "periodo": 202510,
        "valor": 93135865952.4,
        "delta": 806125526.4
      },
      {
        "periodo": 202511,
        "valor": 92001781515.7,
        "delta": -1134084436.7
      },
      {
        "periodo": 202512,
        "valor": 91134320144.1,
        "delta": -867461371.6
      },
      {
        "periodo": 202601,
        "valor": 96237171118.2,
        "delta": 5102850974.1
      },
      {
        "periodo": 202602,
        "valor": 126514380591.9,
        "delta": 30277209473.7
      },
      {
        "periodo": 202603,
        "valor": 128633858827.0,
        "delta": 2119478235.1
      },
      {
        "periodo": 202604,
        "valor": 121668099583.1,
        "delta": -6965759243.9
      },
      {
        "periodo": 202605,
        "valor": 128682916814.9,
        "delta": 7014817231.8
      },
      {
        "periodo": 202606,
        "valor": 129177562298.0,
        "delta": 494645483.1
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 392703595188.1,
    "valor_anterior": 406020147288.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 363349510286.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 370452803223.0,
        "delta": 7103292937.0
      },
      {
        "periodo": 202508,
        "valor": 381214259503.0,
        "delta": 10761456280.0
      },
      {
        "periodo": 202509,
        "valor": 373853887692.0,
        "delta": -7360371811.0
      },
      {
        "periodo": 202510,
        "valor": 382777806219.0,
        "delta": 8923918527.0
      },
      {
        "periodo": 202511,
        "valor": 388524149709.0,
        "delta": 5746343490.0
      },
      {
        "periodo": 202512,
        "valor": 379332777175.0,
        "delta": -9191372534.0
      },
      {
        "periodo": 202601,
        "valor": 390683942608.0,
        "delta": 11351165433.0
      },
      {
        "periodo": 202602,
        "valor": 400098640860.0,
        "delta": 9414698252.0
      },
      {
        "periodo": 202603,
        "valor": 388033486880.0,
        "delta": -12065153980.0
      },
      {
        "periodo": 202604,
        "valor": 397366205845.0,
        "delta": 9332718965.0
      },
      {
        "periodo": 202605,
        "valor": 406020147288.0,
        "delta": 8653941443.0
      },
      {
        "periodo": 202606,
        "valor": 392703595188.1,
        "delta": -13316552099.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 129206464957.6,
    "valor_anterior": 136809572812.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 120428681422.5,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 122595630284.4,
        "delta": 2166948861.9
      },
      {
        "periodo": 202508,
        "valor": 125880261718.5,
        "delta": 3284631434.1
      },
      {
        "periodo": 202509,
        "valor": 129242299249.6,
        "delta": 3362037531.1
      },
      {
        "periodo": 202510,
        "valor": 130782296544.0,
        "delta": 1539997294.4
      },
      {
        "periodo": 202511,
        "valor": 131518273673.9,
        "delta": 735977129.9
      },
      {
        "periodo": 202512,
        "valor": 118975399115.6,
        "delta": -12542874558.3
      },
      {
        "periodo": 202601,
        "valor": 123518735438.7,
        "delta": 4543336323.1
      },
      {
        "periodo": 202602,
        "valor": 127379034150.3,
        "delta": 3860298711.6
      },
      {
        "periodo": 202603,
        "valor": 132188814077.0,
        "delta": 4809779926.7
      },
      {
        "periodo": 202604,
        "valor": 135682144431.5,
        "delta": 3493330354.5
      },
      {
        "periodo": 202605,
        "valor": 136809572812.2,
        "delta": 1127428380.7
      },
      {
        "periodo": 202606,
        "valor": 129206464957.6,
        "delta": -7603107854.6
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 72929827829.3,
    "valor_anterior": 77141971719.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 72200425549.8,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 72913581124.2,
        "delta": 713155574.4
      },
      {
        "periodo": 202508,
        "valor": 74119064771.4,
        "delta": 1205483647.2
      },
      {
        "periodo": 202509,
        "valor": 74979648035.3,
        "delta": 860583263.9
      },
      {
        "periodo": 202510,
        "valor": 75597595618.8,
        "delta": 617947583.5
      },
      {
        "periodo": 202511,
        "valor": 73830014423.5,
        "delta": -1767581195.3
      },
      {
        "periodo": 202512,
        "valor": 72996242603.7,
        "delta": -833771819.8
      },
      {
        "periodo": 202601,
        "valor": 74397953601.8,
        "delta": 1401710998.1
      },
      {
        "periodo": 202602,
        "valor": 75637302408.5,
        "delta": 1239348806.7
      },
      {
        "periodo": 202603,
        "valor": 76330196442.7,
        "delta": 692894034.2
      },
      {
        "periodo": 202604,
        "valor": 77048412656.9,
        "delta": 718216214.2
      },
      {
        "periodo": 202605,
        "valor": 77141971719.0,
        "delta": 93559062.1
      },
      {
        "periodo": 202606,
        "valor": 72929827829.3,
        "delta": -4212143889.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 41323769807.0,
    "valor_anterior": 40759287223.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 39191251218.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 39835064044.0,
        "delta": 643812826.0
      },
      {
        "periodo": 202508,
        "valor": 40610468043.0,
        "delta": 775403999.0
      },
      {
        "periodo": 202509,
        "valor": 41389390224.0,
        "delta": 778922181.0
      },
      {
        "periodo": 202510,
        "valor": 42118308699.0,
        "delta": 728918475.0
      },
      {
        "periodo": 202511,
        "valor": 41807651271.0,
        "delta": -310657428.0
      },
      {
        "periodo": 202512,
        "valor": 42407825520.0,
        "delta": 600174249.0
      },
      {
        "periodo": 202601,
        "valor": 43096091136.0,
        "delta": 688265616.0
      },
      {
        "periodo": 202602,
        "valor": 43645808124.0,
        "delta": 549716988.0
      },
      {
        "periodo": 202603,
        "valor": 43918734079.0,
        "delta": 272925955.0
      },
      {
        "periodo": 202604,
        "valor": 40087251360.0,
        "delta": -3831482719.0
      },
      {
        "periodo": 202605,
        "valor": 40759287223.0,
        "delta": 672035863.0
      },
      {
        "periodo": 202606,
        "valor": 41323769807.0,
        "delta": 564482584.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 162652050118.0,
    "valor_anterior": 162047276236.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 149305080063.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 152244338570.0,
        "delta": 2939258507.0
      },
      {
        "periodo": 202508,
        "valor": 152706153099.0,
        "delta": 461814529.0
      },
      {
        "periodo": 202509,
        "valor": 153283063691.0,
        "delta": 576910592.0
      },
      {
        "periodo": 202510,
        "valor": 155071429189.0,
        "delta": 1788365498.0
      },
      {
        "periodo": 202511,
        "valor": 156561035919.0,
        "delta": 1489606730.0
      },
      {
        "periodo": 202512,
        "valor": 158708980657.0,
        "delta": 2147944738.0
      },
      {
        "periodo": 202601,
        "valor": 160032842743.0,
        "delta": 1323862086.0
      },
      {
        "periodo": 202602,
        "valor": 160725103047.0,
        "delta": 692260304.0
      },
      {
        "periodo": 202603,
        "valor": 161352042060.0,
        "delta": 626939013.0
      },
      {
        "periodo": 202604,
        "valor": 161141778391.0,
        "delta": -210263669.0
      },
      {
        "periodo": 202605,
        "valor": 162047276236.0,
        "delta": 905497845.0
      },
      {
        "periodo": 202606,
        "valor": 162652050118.0,
        "delta": 604773882.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 17003182785.0,
    "valor_anterior": 16884725482.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14818609446.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 15125391591.0,
        "delta": 306782145.0
      },
      {
        "periodo": 202508,
        "valor": 15416939324.0,
        "delta": 291547733.0
      },
      {
        "periodo": 202509,
        "valor": 15766715265.0,
        "delta": 349775941.0
      },
      {
        "periodo": 202510,
        "valor": 16081156781.0,
        "delta": 314441516.0
      },
      {
        "periodo": 202511,
        "valor": 16456110871.0,
        "delta": 374954090.0
      },
      {
        "periodo": 202512,
        "valor": 16527030790.0,
        "delta": 70919919.0
      },
      {
        "periodo": 202601,
        "valor": 16672821479.0,
        "delta": 145790689.0
      },
      {
        "periodo": 202602,
        "valor": 16886802664.0,
        "delta": 213981185.0
      },
      {
        "periodo": 202603,
        "valor": 16997203508.0,
        "delta": 110400844.0
      },
      {
        "periodo": 202604,
        "valor": 17121146720.0,
        "delta": 123943212.0
      },
      {
        "periodo": 202605,
        "valor": 16884725482.0,
        "delta": -236421238.0
      },
      {
        "periodo": 202606,
        "valor": 17003182785.0,
        "delta": 118457303.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 86517733385.1,
    "valor_anterior": 85496976044.3,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 79353378438.4,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 80391656419.9,
        "delta": 1038277981.5
      },
      {
        "periodo": 202508,
        "valor": 80870834981.5,
        "delta": 479178561.6
      },
      {
        "periodo": 202509,
        "valor": 80936613877.8,
        "delta": 65778896.3
      },
      {
        "periodo": 202510,
        "valor": 81539758268.2,
        "delta": 603144390.4
      },
      {
        "periodo": 202511,
        "valor": 81807426646.8,
        "delta": 267668378.6
      },
      {
        "periodo": 202512,
        "valor": 82591026626.3,
        "delta": 783599979.5
      },
      {
        "periodo": 202601,
        "valor": 83852349459.1,
        "delta": 1261322832.8
      },
      {
        "periodo": 202602,
        "valor": 84462757325.6,
        "delta": 610407866.5
      },
      {
        "periodo": 202603,
        "valor": 84368534073.4,
        "delta": -94223252.2
      },
      {
        "periodo": 202604,
        "valor": 84839944479.0,
        "delta": 471410405.6
      },
      {
        "periodo": 202605,
        "valor": 85496976044.3,
        "delta": 657031565.3
      },
      {
        "periodo": 202606,
        "valor": 86517733385.1,
        "delta": 1020757340.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 26169085606.0,
    "valor_anterior": 25806269362.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 24074573952.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 24490394395.0,
        "delta": 415820443.0
      },
      {
        "periodo": 202508,
        "valor": 24918061452.0,
        "delta": 427667057.0
      },
      {
        "periodo": 202509,
        "valor": 25397798491.0,
        "delta": 479737039.0
      },
      {
        "periodo": 202510,
        "valor": 25838025325.0,
        "delta": 440226834.0
      },
      {
        "periodo": 202511,
        "valor": 25111483045.0,
        "delta": -726542280.0
      },
      {
        "periodo": 202512,
        "valor": 25670859942.0,
        "delta": 559376897.0
      },
      {
        "periodo": 202601,
        "valor": 26109621184.0,
        "delta": 438761242.0
      },
      {
        "periodo": 202602,
        "valor": 26326112956.0,
        "delta": 216491772.0
      },
      {
        "periodo": 202603,
        "valor": 24899366050.0,
        "delta": -1426746906.0
      },
      {
        "periodo": 202604,
        "valor": 25417242012.0,
        "delta": 517875962.0
      },
      {
        "periodo": 202605,
        "valor": 25806269362.0,
        "delta": 389027350.0
      },
      {
        "periodo": 202606,
        "valor": 26169085606.0,
        "delta": 362816244.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 11323454587.0,
    "valor_anterior": 11163327299.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 9832429197.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 10053825149.0,
        "delta": 221395952.0
      },
      {
        "periodo": 202508,
        "valor": 10108153818.0,
        "delta": 54328669.0
      },
      {
        "periodo": 202509,
        "valor": 10341340886.0,
        "delta": 233187068.0
      },
      {
        "periodo": 202510,
        "valor": 10540132629.0,
        "delta": 198791743.0
      },
      {
        "periodo": 202511,
        "valor": 10551526872.0,
        "delta": 11394243.0
      },
      {
        "periodo": 202512,
        "valor": 10609178686.0,
        "delta": 57651814.0
      },
      {
        "periodo": 202601,
        "valor": 10561862036.0,
        "delta": -47316650.0
      },
      {
        "periodo": 202602,
        "valor": 10598066364.0,
        "delta": 36204328.0
      },
      {
        "periodo": 202603,
        "valor": 10621966890.0,
        "delta": 23900526.0
      },
      {
        "periodo": 202604,
        "valor": 10802727862.0,
        "delta": 180760972.0
      },
      {
        "periodo": 202605,
        "valor": 11163327299.0,
        "delta": 360599437.0
      },
      {
        "periodo": 202606,
        "valor": 11323454587.0,
        "delta": 160127288.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 8905988404.0,
    "valor_anterior": 8796359811.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 7634519700.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 7737934453.0,
        "delta": 103414753.0
      },
      {
        "periodo": 202508,
        "valor": 7879318229.0,
        "delta": 141383776.0
      },
      {
        "periodo": 202509,
        "valor": 8005295975.0,
        "delta": 125977746.0
      },
      {
        "periodo": 202510,
        "valor": 8099697950.0,
        "delta": 94401975.0
      },
      {
        "periodo": 202511,
        "valor": 8198673888.0,
        "delta": 98975938.0
      },
      {
        "periodo": 202512,
        "valor": 8316530594.0,
        "delta": 117856706.0
      },
      {
        "periodo": 202601,
        "valor": 8372576672.0,
        "delta": 56046078.0
      },
      {
        "periodo": 202602,
        "valor": 8491404097.0,
        "delta": 118827425.0
      },
      {
        "periodo": 202603,
        "valor": 8597498489.0,
        "delta": 106094392.0
      },
      {
        "periodo": 202604,
        "valor": 8700208156.0,
        "delta": 102709667.0
      },
      {
        "periodo": 202605,
        "valor": 8796359811.0,
        "delta": 96151655.0
      },
      {
        "periodo": 202606,
        "valor": 8905988404.0,
        "delta": 109628593.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 8270802362.0,
    "valor_anterior": 8207626863.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 8032032546.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 8108482548.0,
        "delta": 76450002.0
      },
      {
        "periodo": 202508,
        "valor": 8155910580.0,
        "delta": 47428032.0
      },
      {
        "periodo": 202509,
        "valor": 8162026683.0,
        "delta": 6116103.0
      },
      {
        "periodo": 202510,
        "valor": 7996036587.0,
        "delta": -165990096.0
      },
      {
        "periodo": 202511,
        "valor": 8042958426.0,
        "delta": 46921839.0
      },
      {
        "periodo": 202512,
        "valor": 7657007513.0,
        "delta": -385950913.0
      },
      {
        "periodo": 202601,
        "valor": 7705838851.0,
        "delta": 48831338.0
      },
      {
        "periodo": 202602,
        "valor": 7708000296.0,
        "delta": 2161445.0
      },
      {
        "periodo": 202603,
        "valor": 7942327488.0,
        "delta": 234327192.0
      },
      {
        "periodo": 202604,
        "valor": 7983690773.0,
        "delta": 41363285.0
      },
      {
        "periodo": 202605,
        "valor": 8207626863.0,
        "delta": 223936090.0
      },
      {
        "periodo": 202606,
        "valor": 8270802362.0,
        "delta": 63175499.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 140397946179.0,
    "valor_anterior": 136687679538.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 142079821607.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 145995680175.0,
        "delta": 3915858568.0
      },
      {
        "periodo": 202508,
        "valor": 149742650628.0,
        "delta": 3746970453.0
      },
      {
        "periodo": 202509,
        "valor": 152760549992.0,
        "delta": 3017899364.0
      },
      {
        "periodo": 202510,
        "valor": 156037635171.0,
        "delta": 3277085179.0
      },
      {
        "periodo": 202511,
        "valor": 134654890426.0,
        "delta": -21382744745.0
      },
      {
        "periodo": 202512,
        "valor": 131944685371.0,
        "delta": -2710205055.0
      },
      {
        "periodo": 202601,
        "valor": 135780816559.0,
        "delta": 3836131188.0
      },
      {
        "periodo": 202602,
        "valor": 139444025464.0,
        "delta": 3663208905.0
      },
      {
        "periodo": 202603,
        "valor": 142203899142.0,
        "delta": 2759873678.0
      },
      {
        "periodo": 202604,
        "valor": 132479675590.0,
        "delta": -9724223552.0
      },
      {
        "periodo": 202605,
        "valor": 136687679538.0,
        "delta": 4208003948.0
      },
      {
        "periodo": 202606,
        "valor": 140397946179.0,
        "delta": 3710266641.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 24731295494.0,
    "valor_anterior": 24645206311.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 22916362919.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 23056015843.0,
        "delta": 139652924.0
      },
      {
        "periodo": 202508,
        "valor": 23193314767.0,
        "delta": 137298924.0
      },
      {
        "periodo": 202509,
        "valor": 23203790187.0,
        "delta": 10475420.0
      },
      {
        "periodo": 202510,
        "valor": 23422602978.0,
        "delta": 218812791.0
      },
      {
        "periodo": 202511,
        "valor": 23424085580.0,
        "delta": 1482602.0
      },
      {
        "periodo": 202512,
        "valor": 23641486667.0,
        "delta": 217401087.0
      },
      {
        "periodo": 202601,
        "valor": 23870082534.0,
        "delta": 228595867.0
      },
      {
        "periodo": 202602,
        "valor": 24046001829.0,
        "delta": 175919295.0
      },
      {
        "periodo": 202603,
        "valor": 24277496497.0,
        "delta": 231494668.0
      },
      {
        "periodo": 202604,
        "valor": 24627047528.0,
        "delta": 349551031.0
      },
      {
        "periodo": 202605,
        "valor": 24645206311.0,
        "delta": 18158783.0
      },
      {
        "periodo": 202606,
        "valor": 24731295494.0,
        "delta": 86089183.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 9988691926.0,
    "valor_anterior": 9979932025.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 9328695775.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 9423066000.0,
        "delta": 94370225.0
      },
      {
        "periodo": 202508,
        "valor": 9505554392.0,
        "delta": 82488392.0
      },
      {
        "periodo": 202509,
        "valor": 9598747160.0,
        "delta": 93192768.0
      },
      {
        "periodo": 202510,
        "valor": 9658436450.0,
        "delta": 59689290.0
      },
      {
        "periodo": 202511,
        "valor": 9732629574.0,
        "delta": 74193124.0
      },
      {
        "periodo": 202512,
        "valor": 9789396080.0,
        "delta": 56766506.0
      },
      {
        "periodo": 202601,
        "valor": 9708635154.5,
        "delta": -80760925.5
      },
      {
        "periodo": 202602,
        "valor": 9842348116.0,
        "delta": 133712961.5
      },
      {
        "periodo": 202603,
        "valor": 9871841804.0,
        "delta": 29493688.0
      },
      {
        "periodo": 202604,
        "valor": 9932157533.0,
        "delta": 60315729.0
      },
      {
        "periodo": 202605,
        "valor": 9979932025.0,
        "delta": 47774492.0
      },
      {
        "periodo": 202606,
        "valor": 9988691926.0,
        "delta": 8759901.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 40166607084.0,
    "valor_anterior": 39983737528.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 35954193997.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 36270917460.0,
        "delta": 316723463.0
      },
      {
        "periodo": 202508,
        "valor": 36933277061.0,
        "delta": 662359601.0
      },
      {
        "periodo": 202509,
        "valor": 37555950234.0,
        "delta": 622673173.0
      },
      {
        "periodo": 202510,
        "valor": 37946905053.0,
        "delta": 390954819.0
      },
      {
        "periodo": 202511,
        "valor": 38229082961.0,
        "delta": 282177908.0
      },
      {
        "periodo": 202512,
        "valor": 38467441970.0,
        "delta": 238359009.0
      },
      {
        "periodo": 202601,
        "valor": 38590299553.0,
        "delta": 122857583.0
      },
      {
        "periodo": 202602,
        "valor": 39083801221.0,
        "delta": 493501668.0
      },
      {
        "periodo": 202603,
        "valor": 39354466778.0,
        "delta": 270665557.0
      },
      {
        "periodo": 202604,
        "valor": 39651216833.0,
        "delta": 296750055.0
      },
      {
        "periodo": 202605,
        "valor": 39983737528.0,
        "delta": 332520695.0
      },
      {
        "periodo": 202606,
        "valor": 40166607084.0,
        "delta": 182869556.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 17931895433.0,
    "valor_anterior": 17574616251.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 15113248017.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 15367468737.0,
        "delta": 254220720.0
      },
      {
        "periodo": 202508,
        "valor": 15707675760.0,
        "delta": 340207023.0
      },
      {
        "periodo": 202509,
        "valor": 16066480606.0,
        "delta": 358804846.0
      },
      {
        "periodo": 202510,
        "valor": 16461992467.0,
        "delta": 395511861.0
      },
      {
        "periodo": 202511,
        "valor": 16713178174.0,
        "delta": 251185707.0
      },
      {
        "periodo": 202512,
        "valor": 17157390343.0,
        "delta": 444212169.0
      },
      {
        "periodo": 202601,
        "valor": 17566601215.0,
        "delta": 409210872.0
      },
      {
        "periodo": 202602,
        "valor": 17836628385.0,
        "delta": 270027170.0
      },
      {
        "periodo": 202603,
        "valor": 17863535271.0,
        "delta": 26906886.0
      },
      {
        "periodo": 202604,
        "valor": 17250284642.0,
        "delta": -613250629.0
      },
      {
        "periodo": 202605,
        "valor": 17574616251.0,
        "delta": 324331609.0
      },
      {
        "periodo": 202606,
        "valor": 17931895433.0,
        "delta": 357279182.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 8097106240.4,
    "valor_anterior": 7997760728.5,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 7414653006.1,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 7368886294.6,
        "delta": -45766711.5
      },
      {
        "periodo": 202508,
        "valor": 7399032372.0,
        "delta": 30146077.4
      },
      {
        "periodo": 202509,
        "valor": 7501672612.3,
        "delta": 102640240.3
      },
      {
        "periodo": 202510,
        "valor": 7558890143.4,
        "delta": 57217531.1
      },
      {
        "periodo": 202511,
        "valor": 7667261563.0,
        "delta": 108371419.6
      },
      {
        "periodo": 202512,
        "valor": 7663469275.5,
        "delta": -3792287.5
      },
      {
        "periodo": 202601,
        "valor": 7824224995.8,
        "delta": 160755720.3
      },
      {
        "periodo": 202602,
        "valor": 7777378732.7,
        "delta": -46846263.1
      },
      {
        "periodo": 202603,
        "valor": 7909443191.4,
        "delta": 132064458.7
      },
      {
        "periodo": 202604,
        "valor": 8020206476.5,
        "delta": 110763285.1
      },
      {
        "periodo": 202605,
        "valor": 7997760728.5,
        "delta": -22445748.0
      },
      {
        "periodo": 202606,
        "valor": 8097106240.4,
        "delta": 99345511.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 81988480764.0,
    "valor_anterior": 81485843101.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 71151063178.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 72103528805.0,
        "delta": 952465627.0
      },
      {
        "periodo": 202508,
        "valor": 73653620412.0,
        "delta": 1550091607.0
      },
      {
        "periodo": 202509,
        "valor": 74865413276.0,
        "delta": 1211792864.0
      },
      {
        "periodo": 202510,
        "valor": 75795523032.0,
        "delta": 930109756.0
      },
      {
        "periodo": 202511,
        "valor": 76322811638.0,
        "delta": 527288606.0
      },
      {
        "periodo": 202512,
        "valor": 77980364691.0,
        "delta": 1657553053.0
      },
      {
        "periodo": 202601,
        "valor": 79223008147.0,
        "delta": 1242643456.0
      },
      {
        "periodo": 202602,
        "valor": 80032689891.0,
        "delta": 809681744.0
      },
      {
        "periodo": 202603,
        "valor": 79245696659.0,
        "delta": -786993232.0
      },
      {
        "periodo": 202604,
        "valor": 80566831304.0,
        "delta": 1321134645.0
      },
      {
        "periodo": 202605,
        "valor": 81485843101.0,
        "delta": 919011797.0
      },
      {
        "periodo": 202606,
        "valor": 81988480764.0,
        "delta": 502637663.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 2095207014.0,
    "valor_anterior": 2089938884.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2160763546.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2148145170.0,
        "delta": -12618376.0
      },
      {
        "periodo": 202508,
        "valor": 2134753315.0,
        "delta": -13391855.0
      },
      {
        "periodo": 202509,
        "valor": 2124311331.0,
        "delta": -10441984.0
      },
      {
        "periodo": 202510,
        "valor": 2133432924.0,
        "delta": 9121593.0
      },
      {
        "periodo": 202511,
        "valor": 2111966859.0,
        "delta": -21466065.0
      },
      {
        "periodo": 202512,
        "valor": 2133939984.0,
        "delta": 21973125.0
      },
      {
        "periodo": 202601,
        "valor": 2132555635.0,
        "delta": -1384349.0
      },
      {
        "periodo": 202602,
        "valor": 2087625246.0,
        "delta": -44930389.0
      },
      {
        "periodo": 202603,
        "valor": 2084840601.0,
        "delta": -2784645.0
      },
      {
        "periodo": 202604,
        "valor": 2089793489.0,
        "delta": 4952888.0
      },
      {
        "periodo": 202605,
        "valor": 2089938884.0,
        "delta": 145395.0
      },
      {
        "periodo": 202606,
        "valor": 2095207014.0,
        "delta": 5268130.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 47466405061.0,
    "valor_anterior": 48432365766.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 44147851722.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 44481963663.0,
        "delta": 334111941.0
      },
      {
        "periodo": 202508,
        "valor": 44960880035.0,
        "delta": 478916372.0
      },
      {
        "periodo": 202509,
        "valor": 47403408582.0,
        "delta": 2442528547.0
      },
      {
        "periodo": 202510,
        "valor": 48383932697.0,
        "delta": 980524115.0
      },
      {
        "periodo": 202511,
        "valor": 48983667272.0,
        "delta": 599734575.0
      },
      {
        "periodo": 202512,
        "valor": 50026222627.0,
        "delta": 1042555355.0
      },
      {
        "periodo": 202601,
        "valor": 49092984842.0,
        "delta": -933237785.0
      },
      {
        "periodo": 202602,
        "valor": 49628651738.0,
        "delta": 535666896.0
      },
      {
        "periodo": 202603,
        "valor": 50336379717.0,
        "delta": 707727979.0
      },
      {
        "periodo": 202604,
        "valor": 49163645552.0,
        "delta": -1172734165.0
      },
      {
        "periodo": 202605,
        "valor": 48432365766.0,
        "delta": -731279786.0
      },
      {
        "periodo": 202606,
        "valor": 47466405061.0,
        "delta": -965960705.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 5562530148.0,
    "valor_anterior": 5166568402.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1536211677.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1591686281.0,
        "delta": 55474604.0
      },
      {
        "periodo": 202508,
        "valor": 1658691566.0,
        "delta": 67005285.0
      },
      {
        "periodo": 202509,
        "valor": 3730791638.0,
        "delta": 2072100072.0
      },
      {
        "periodo": 202510,
        "valor": 4400252514.0,
        "delta": 669460876.0
      },
      {
        "periodo": 202511,
        "valor": 4361880457.0,
        "delta": -38372057.0
      },
      {
        "periodo": 202512,
        "valor": 4517709086.0,
        "delta": 155828629.0
      },
      {
        "periodo": 202601,
        "valor": 4666291638.0,
        "delta": 148582552.0
      },
      {
        "periodo": 202602,
        "valor": 4864775694.0,
        "delta": 198484056.0
      },
      {
        "periodo": 202603,
        "valor": 5288600710.0,
        "delta": 423825016.0
      },
      {
        "periodo": 202604,
        "valor": 5396030654.0,
        "delta": 107429944.0
      },
      {
        "periodo": 202605,
        "valor": 5166568402.0,
        "delta": -229462252.0
      },
      {
        "periodo": 202606,
        "valor": 5562530148.0,
        "delta": 395961746.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 8766200954.0,
    "valor_anterior": 8753499969.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 9000630997.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 9238125237.0,
        "delta": 237494240.0
      },
      {
        "periodo": 202508,
        "valor": 9189686559.0,
        "delta": -48438678.0
      },
      {
        "periodo": 202509,
        "valor": 9267768475.0,
        "delta": 78081916.0
      },
      {
        "periodo": 202510,
        "valor": 9324010711.0,
        "delta": 56242236.0
      },
      {
        "periodo": 202511,
        "valor": 8583832871.0,
        "delta": -740177840.0
      },
      {
        "periodo": 202512,
        "valor": 8480343839.0,
        "delta": -103489032.0
      },
      {
        "periodo": 202601,
        "valor": 8543498517.0,
        "delta": 63154678.0
      },
      {
        "periodo": 202602,
        "valor": 8624580942.0,
        "delta": 81082425.0
      },
      {
        "periodo": 202603,
        "valor": 8653002027.0,
        "delta": 28421085.0
      },
      {
        "periodo": 202604,
        "valor": 8684696586.0,
        "delta": 31694559.0
      },
      {
        "periodo": 202605,
        "valor": 8753499969.0,
        "delta": 68803383.0
      },
      {
        "periodo": 202606,
        "valor": 8766200954.0,
        "delta": 12700985.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 19504669128.3,
    "valor_anterior": 18903781268.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17208350110.4,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17644500846.4,
        "delta": 436150736.0
      },
      {
        "periodo": 202508,
        "valor": 18097627477.3,
        "delta": 453126630.9
      },
      {
        "periodo": 202509,
        "valor": 18574872203.5,
        "delta": 477244726.2
      },
      {
        "periodo": 202510,
        "valor": 18915102566.9,
        "delta": 340230363.4
      },
      {
        "periodo": 202511,
        "valor": 17777436151.9,
        "delta": -1137666415.0
      },
      {
        "periodo": 202512,
        "valor": 18069550832.5,
        "delta": 292114680.6
      },
      {
        "periodo": 202601,
        "valor": 18763190297.1,
        "delta": 693639464.6
      },
      {
        "periodo": 202602,
        "valor": 19434298698.1,
        "delta": 671108401.0
      },
      {
        "periodo": 202603,
        "valor": 19796334214.7,
        "delta": 362035516.6
      },
      {
        "periodo": 202604,
        "valor": 18143399725.6,
        "delta": -1652934489.1
      },
      {
        "periodo": 202605,
        "valor": 18903781268.0,
        "delta": 760381542.4
      },
      {
        "periodo": 202606,
        "valor": 19504669128.3,
        "delta": 600887860.3
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 10521184555.4,
    "valor_anterior": 10281708206.5,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 9006686787.4,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 9068439098.2,
        "delta": 61752310.8
      },
      {
        "periodo": 202508,
        "valor": 9138541284.0,
        "delta": 70102185.8
      },
      {
        "periodo": 202509,
        "valor": 9073534154.3,
        "delta": -65007129.7
      },
      {
        "periodo": 202510,
        "valor": 9379821885.0,
        "delta": 306287730.7
      },
      {
        "periodo": 202511,
        "valor": 9631942362.5,
        "delta": 252120477.5
      },
      {
        "periodo": 202512,
        "valor": 9664642379.4,
        "delta": 32700016.9
      },
      {
        "periodo": 202601,
        "valor": 9863363328.8,
        "delta": 198720949.4
      },
      {
        "periodo": 202602,
        "valor": 10008797369.0,
        "delta": 145434040.2
      },
      {
        "periodo": 202603,
        "valor": 10140269103.1,
        "delta": 131471734.1
      },
      {
        "periodo": 202604,
        "valor": 10235871248.5,
        "delta": 95602145.4
      },
      {
        "periodo": 202605,
        "valor": 10281708206.5,
        "delta": 45836958.0
      },
      {
        "periodo": 202606,
        "valor": 10521184555.4,
        "delta": 239476348.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 6287101398.0,
    "valor_anterior": 6343453655.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 6229731301.4,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 6271464073.0,
        "delta": 41732771.6
      },
      {
        "periodo": 202508,
        "valor": 6259481772.5,
        "delta": -11982300.5
      },
      {
        "periodo": 202509,
        "valor": 6334849642.0,
        "delta": 75367869.5
      },
      {
        "periodo": 202510,
        "valor": 6370443254.0,
        "delta": 35593612.0
      },
      {
        "periodo": 202511,
        "valor": 6295559259.0,
        "delta": -74883995.0
      },
      {
        "periodo": 202512,
        "valor": 6272704298.0,
        "delta": -22854961.0
      },
      {
        "periodo": 202601,
        "valor": 6270214942.0,
        "delta": -2489356.0
      },
      {
        "periodo": 202602,
        "valor": 6315471791.0,
        "delta": 45256849.0
      },
      {
        "periodo": 202603,
        "valor": 6222050059.0,
        "delta": -93421732.0
      },
      {
        "periodo": 202604,
        "valor": 6251388034.0,
        "delta": 29337975.0
      },
      {
        "periodo": 202605,
        "valor": 6343453655.0,
        "delta": 92065621.0
      },
      {
        "periodo": 202606,
        "valor": 6287101398.0,
        "delta": -56352257.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 3021418347.0,
    "valor_anterior": 3333110687.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 11165014029.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 10924719222.0,
        "delta": -240294807.0
      },
      {
        "periodo": 202508,
        "valor": 10747210148.0,
        "delta": -177509074.0
      },
      {
        "periodo": 202509,
        "valor": 9971087986.0,
        "delta": -776122162.0
      },
      {
        "periodo": 202510,
        "valor": 9877108994.0,
        "delta": -93978992.0
      },
      {
        "periodo": 202511,
        "valor": 3814985210.1,
        "delta": -6062123783.9
      },
      {
        "periodo": 202512,
        "valor": 4000296627.2,
        "delta": 185311417.1
      },
      {
        "periodo": 202601,
        "valor": 3806723175.0,
        "delta": -193573452.2
      },
      {
        "periodo": 202602,
        "valor": 3914795113.7,
        "delta": 108071938.7
      },
      {
        "periodo": 202603,
        "valor": 3898566949.8,
        "delta": -16228163.9
      },
      {
        "periodo": 202604,
        "valor": 3322965168.2,
        "delta": -575601781.6
      },
      {
        "periodo": 202605,
        "valor": 3333110687.2,
        "delta": 10145519.0
      },
      {
        "periodo": 202606,
        "valor": 3021418347.0,
        "delta": -311692340.2
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 22125150154.7,
    "valor_anterior": 21307335985.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 21418749499.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 21429841253.0,
        "delta": 11091754.0
      },
      {
        "periodo": 202508,
        "valor": 22069278210.0,
        "delta": 639436957.0
      },
      {
        "periodo": 202509,
        "valor": 21383615356.0,
        "delta": -685662854.0
      },
      {
        "periodo": 202510,
        "valor": 21689028764.0,
        "delta": 305413408.0
      },
      {
        "periodo": 202511,
        "valor": 21658875743.0,
        "delta": -30153021.0
      },
      {
        "periodo": 202512,
        "valor": 21258510632.0,
        "delta": -400365111.0
      },
      {
        "periodo": 202601,
        "valor": 21533210459.0,
        "delta": 274699827.0
      },
      {
        "periodo": 202602,
        "valor": 22182904466.0,
        "delta": 649694007.0
      },
      {
        "periodo": 202603,
        "valor": 20623160202.5,
        "delta": -1559744263.5
      },
      {
        "periodo": 202604,
        "valor": 21039161713.1,
        "delta": 416001510.6
      },
      {
        "periodo": 202605,
        "valor": 21307335985.2,
        "delta": 268174272.1
      },
      {
        "periodo": 202606,
        "valor": 22125150154.7,
        "delta": 817814169.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 752486413.5,
    "valor_anterior": 573383281.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 914256462.5,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 758157349.5,
        "delta": -156099113.0
      },
      {
        "periodo": 202508,
        "valor": 973730075.7,
        "delta": 215572726.2
      },
      {
        "periodo": 202509,
        "valor": 866854013.3,
        "delta": -106876062.4
      },
      {
        "periodo": 202510,
        "valor": 753280049.6,
        "delta": -113573963.7
      },
      {
        "periodo": 202511,
        "valor": 600936978.0,
        "delta": -152343071.6
      },
      {
        "periodo": 202512,
        "valor": 795021368.8,
        "delta": 194084390.8
      },
      {
        "periodo": 202601,
        "valor": 697919597.6,
        "delta": -97101771.2
      },
      {
        "periodo": 202602,
        "valor": 569747668.8,
        "delta": -128171928.8
      },
      {
        "periodo": 202603,
        "valor": 753919651.9,
        "delta": 184171983.1
      },
      {
        "periodo": 202604,
        "valor": 661043596.0,
        "delta": -92876055.9
      },
      {
        "periodo": 202605,
        "valor": 573383281.0,
        "delta": -87660315.0
      },
      {
        "periodo": 202606,
        "valor": 752486413.5,
        "delta": 179103132.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 1135514604.0,
    "valor_anterior": 1124878085.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1032511656.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1036620862.0,
        "delta": 4109206.0
      },
      {
        "periodo": 202508,
        "valor": 1046808867.0,
        "delta": 10188005.0
      },
      {
        "periodo": 202509,
        "valor": 1069324751.0,
        "delta": 22515884.0
      },
      {
        "periodo": 202510,
        "valor": 1078445356.0,
        "delta": 9120605.0
      },
      {
        "periodo": 202511,
        "valor": 1078593742.0,
        "delta": 148386.0
      },
      {
        "periodo": 202512,
        "valor": 1101202602.0,
        "delta": 22608860.0
      },
      {
        "periodo": 202601,
        "valor": 1103952916.0,
        "delta": 2750314.0
      },
      {
        "periodo": 202602,
        "valor": 1098452524.0,
        "delta": -5500392.0
      },
      {
        "periodo": 202603,
        "valor": 1106536042.0,
        "delta": 8083518.0
      },
      {
        "periodo": 202604,
        "valor": 1113080197.0,
        "delta": 6544155.0
      },
      {
        "periodo": 202605,
        "valor": 1124878085.0,
        "delta": 11797888.0
      },
      {
        "periodo": 202606,
        "valor": 1135514604.0,
        "delta": 10636519.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 4248795535.0,
    "valor_anterior": 4196825734.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 3098821715.75,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3225470326.0,
        "delta": 126648610.25
      },
      {
        "periodo": 202508,
        "valor": 3256006806.25,
        "delta": 30536480.25
      },
      {
        "periodo": 202509,
        "valor": 3355797469.25,
        "delta": 99790663.0
      },
      {
        "periodo": 202510,
        "valor": 3422547385.0,
        "delta": 66749915.75
      },
      {
        "periodo": 202511,
        "valor": 3552392107.75,
        "delta": 129844722.75
      },
      {
        "periodo": 202512,
        "valor": 3617819250.0,
        "delta": 65427142.25
      },
      {
        "periodo": 202601,
        "valor": 3766309798.0,
        "delta": 148490548.0
      },
      {
        "periodo": 202602,
        "valor": 3724556624.75,
        "delta": -41753173.25
      },
      {
        "periodo": 202603,
        "valor": 4014986760.0,
        "delta": 290430135.25
      },
      {
        "periodo": 202604,
        "valor": 4102833232.0,
        "delta": 87846472.0
      },
      {
        "periodo": 202605,
        "valor": 4196825734.0,
        "delta": 93992502.0
      },
      {
        "periodo": 202606,
        "valor": 4248795535.0,
        "delta": 51969801.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 3558093926.0,
    "valor_anterior": 3490269647.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 3465540977.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3527287780.0,
        "delta": 61746803.0
      },
      {
        "periodo": 202508,
        "valor": 3546259944.0,
        "delta": 18972164.0
      },
      {
        "periodo": 202509,
        "valor": 3593332302.0,
        "delta": 47072358.0
      },
      {
        "periodo": 202510,
        "valor": 3578844765.0,
        "delta": -14487537.0
      },
      {
        "periodo": 202511,
        "valor": 3580386801.0,
        "delta": 1542036.0
      },
      {
        "periodo": 202512,
        "valor": 3631083997.0,
        "delta": 50697196.0
      },
      {
        "periodo": 202601,
        "valor": 3633400486.0,
        "delta": 2316489.0
      },
      {
        "periodo": 202602,
        "valor": 3686897848.0,
        "delta": 53497362.0
      },
      {
        "periodo": 202603,
        "valor": 3469550387.0,
        "delta": -217347461.0
      },
      {
        "periodo": 202604,
        "valor": 3481226238.0,
        "delta": 11675851.0
      },
      {
        "periodo": 202605,
        "valor": 3490269647.0,
        "delta": 9043409.0
      },
      {
        "periodo": 202606,
        "valor": 3558093926.0,
        "delta": 67824279.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4593097053.875,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4953613798.5,
        "delta": 360516744.625
      },
      {
        "periodo": 202508,
        "valor": 3833939945.875,
        "delta": -1119673852.625
      },
      {
        "periodo": 202509,
        "valor": 3979213693.5,
        "delta": 145273747.625
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 7827476723.0,
    "valor_anterior": 7689009035.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 7076970881.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 7201608685.0,
        "delta": 124637804.0
      },
      {
        "periodo": 202508,
        "valor": 7369426300.0,
        "delta": 167817615.0
      },
      {
        "periodo": 202509,
        "valor": 6888912545.0,
        "delta": -480513755.0
      },
      {
        "periodo": 202510,
        "valor": 7090495910.0,
        "delta": 201583365.0
      },
      {
        "periodo": 202511,
        "valor": 7170956056.0,
        "delta": 80460146.0
      },
      {
        "periodo": 202512,
        "valor": 7463078389.0,
        "delta": 292122333.0
      },
      {
        "periodo": 202601,
        "valor": 7567001990.0,
        "delta": 103923601.0
      },
      {
        "periodo": 202602,
        "valor": 7686426417.0,
        "delta": 119424427.0
      },
      {
        "periodo": 202603,
        "valor": 7856540374.0,
        "delta": 170113957.0
      },
      {
        "periodo": 202604,
        "valor": 7555635690.0,
        "delta": -300904684.0
      },
      {
        "periodo": 202605,
        "valor": 7689009035.0,
        "delta": 133373345.0
      },
      {
        "periodo": 202606,
        "valor": 7827476723.0,
        "delta": 138467688.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 2668524331.0,
    "valor_anterior": 2383588179.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1918429039.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1940741265.0,
        "delta": 22312226.0
      },
      {
        "periodo": 202508,
        "valor": 2045322113.0,
        "delta": 104580848.0
      },
      {
        "periodo": 202509,
        "valor": 2063324497.0,
        "delta": 18002384.0
      },
      {
        "periodo": 202510,
        "valor": 2107930424.0,
        "delta": 44605927.0
      },
      {
        "periodo": 202511,
        "valor": 2138153470.0,
        "delta": 30223046.0
      },
      {
        "periodo": 202512,
        "valor": 2339255501.0,
        "delta": 201102031.0
      },
      {
        "periodo": 202601,
        "valor": 2346167185.0,
        "delta": 6911684.0
      },
      {
        "periodo": 202602,
        "valor": 2438459036.0,
        "delta": 92291851.0
      },
      {
        "periodo": 202603,
        "valor": 2553064905.0,
        "delta": 114605869.0
      },
      {
        "periodo": 202604,
        "valor": 2427649183.0,
        "delta": -125415722.0
      },
      {
        "periodo": 202605,
        "valor": 2383588179.0,
        "delta": -44061004.0
      },
      {
        "periodo": 202606,
        "valor": 2668524331.0,
        "delta": 284936152.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 306402973.0,
    "valor_anterior": 303948833.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 294400889.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 306111605.0,
        "delta": 11710716.0
      },
      {
        "periodo": 202508,
        "valor": 297429566.0,
        "delta": -8682039.0
      },
      {
        "periodo": 202509,
        "valor": 302667304.0,
        "delta": 5237738.0
      },
      {
        "periodo": 202510,
        "valor": 296034369.0,
        "delta": -6632935.0
      },
      {
        "periodo": 202511,
        "valor": 308423676.0,
        "delta": 12389307.0
      },
      {
        "periodo": 202512,
        "valor": 311479032.0,
        "delta": 3055356.0
      },
      {
        "periodo": 202601,
        "valor": 304923267.0,
        "delta": -6555765.0
      },
      {
        "periodo": 202602,
        "valor": 305860793.0,
        "delta": 937526.0
      },
      {
        "periodo": 202603,
        "valor": 302730987.0,
        "delta": -3129806.0
      },
      {
        "periodo": 202604,
        "valor": 301698117.0,
        "delta": -1032870.0
      },
      {
        "periodo": 202605,
        "valor": 303948833.0,
        "delta": 2250716.0
      },
      {
        "periodo": 202606,
        "valor": 306402973.0,
        "delta": 2454140.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 452966795.0,
    "valor_anterior": 454984724.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 433033517.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 431021909.0,
        "delta": -2011608.0
      },
      {
        "periodo": 202508,
        "valor": 436666778.0,
        "delta": 5644869.0
      },
      {
        "periodo": 202509,
        "valor": 433801176.0,
        "delta": -2865602.0
      },
      {
        "periodo": 202510,
        "valor": 429234599.0,
        "delta": -4566577.0
      },
      {
        "periodo": 202511,
        "valor": 423437029.0,
        "delta": -5797570.0
      },
      {
        "periodo": 202512,
        "valor": 461764082.0,
        "delta": 38327053.0
      },
      {
        "periodo": 202601,
        "valor": 457778374.0,
        "delta": -3985708.0
      },
      {
        "periodo": 202602,
        "valor": 460214345.0,
        "delta": 2435971.0
      },
      {
        "periodo": 202603,
        "valor": 457649724.0,
        "delta": -2564621.0
      },
      {
        "periodo": 202604,
        "valor": 458217767.0,
        "delta": 568043.0
      },
      {
        "periodo": 202605,
        "valor": 454984724.0,
        "delta": -3233043.0
      },
      {
        "periodo": 202606,
        "valor": 452966795.0,
        "delta": -2017929.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 1883037860.6,
    "valor_anterior": 1882593763.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1774450501.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1777781033.0,
        "delta": 3330532.0
      },
      {
        "periodo": 202508,
        "valor": 1780781782.0,
        "delta": 3000749.0
      },
      {
        "periodo": 202509,
        "valor": 1797653989.0,
        "delta": 16872207.0
      },
      {
        "periodo": 202510,
        "valor": 1807442953.0,
        "delta": 9788964.0
      },
      {
        "periodo": 202511,
        "valor": 1818982902.0,
        "delta": 11539949.0
      },
      {
        "periodo": 202512,
        "valor": 1840328614.0,
        "delta": 21345712.0
      },
      {
        "periodo": 202601,
        "valor": 1848042929.0,
        "delta": 7714315.0
      },
      {
        "periodo": 202602,
        "valor": 1854326997.0,
        "delta": 6284068.0
      },
      {
        "periodo": 202603,
        "valor": 1863328273.0,
        "delta": 9001276.0
      },
      {
        "periodo": 202604,
        "valor": 1876630493.0,
        "delta": 13302220.0
      },
      {
        "periodo": 202605,
        "valor": 1882593763.0,
        "delta": 5963270.0
      },
      {
        "periodo": 202606,
        "valor": 1883037860.6,
        "delta": 444097.6
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 478804220.0,
    "valor_anterior": 477819770.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 455210280.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 455367440.0,
        "delta": 157160.0
      },
      {
        "periodo": 202508,
        "valor": 460822930.0,
        "delta": 5455490.0
      },
      {
        "periodo": 202509,
        "valor": 458796690.0,
        "delta": -2026240.0
      },
      {
        "periodo": 202510,
        "valor": 460873050.0,
        "delta": 2076360.0
      },
      {
        "periodo": 202511,
        "valor": 460191620.0,
        "delta": -681430.0
      },
      {
        "periodo": 202512,
        "valor": 471892340.0,
        "delta": 11700720.0
      },
      {
        "periodo": 202601,
        "valor": 477453740.0,
        "delta": 5561400.0
      },
      {
        "periodo": 202602,
        "valor": 477991040.0,
        "delta": 537300.0
      },
      {
        "periodo": 202603,
        "valor": 478552530.0,
        "delta": 561490.0
      },
      {
        "periodo": 202604,
        "valor": 477299190.0,
        "delta": -1253340.0
      },
      {
        "periodo": 202605,
        "valor": 477819770.0,
        "delta": 520580.0
      },
      {
        "periodo": 202606,
        "valor": 478804220.0,
        "delta": 984450.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 5098593201.5,
    "valor_anterior": 5080613083.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4190616102.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4289070924.0,
        "delta": 98454822.0
      },
      {
        "periodo": 202508,
        "valor": 4334946296.0,
        "delta": 45875372.0
      },
      {
        "periodo": 202509,
        "valor": 4364966337.0,
        "delta": 30020041.0
      },
      {
        "periodo": 202510,
        "valor": 4505617500.0,
        "delta": 140651163.0
      },
      {
        "periodo": 202511,
        "valor": 4597572280.0,
        "delta": 91954780.0
      },
      {
        "periodo": 202512,
        "valor": 4701884400.0,
        "delta": 104312120.0
      },
      {
        "periodo": 202601,
        "valor": 4797265162.0,
        "delta": 95380762.0
      },
      {
        "periodo": 202602,
        "valor": 4863980544.0,
        "delta": 66715382.0
      },
      {
        "periodo": 202603,
        "valor": 4883576560.0,
        "delta": 19596016.0
      },
      {
        "periodo": 202604,
        "valor": 4974124896.9,
        "delta": 90548336.9
      },
      {
        "periodo": 202605,
        "valor": 5080613083.0,
        "delta": 106488186.1
      },
      {
        "periodo": 202606,
        "valor": 5098593201.5,
        "delta": 17980118.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 1314782296.7,
    "valor_anterior": 1302000733.8,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 955712461.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 981709000.0,
        "delta": 25996539.0
      },
      {
        "periodo": 202508,
        "valor": 999001441.0,
        "delta": 17292441.0
      },
      {
        "periodo": 202509,
        "valor": 1042088160.0,
        "delta": 43086719.0
      },
      {
        "periodo": 202510,
        "valor": 1093977256.0,
        "delta": 51889096.0
      },
      {
        "periodo": 202511,
        "valor": 1147984151.2,
        "delta": 54006895.2
      },
      {
        "periodo": 202512,
        "valor": 1162436773.0,
        "delta": 14452621.8
      },
      {
        "periodo": 202601,
        "valor": 1170350513.8,
        "delta": 7913740.8
      },
      {
        "periodo": 202602,
        "valor": 1224629737.3,
        "delta": 54279223.5
      },
      {
        "periodo": 202603,
        "valor": 1259775546.0,
        "delta": 35145808.7
      },
      {
        "periodo": 202604,
        "valor": 1262560740.6,
        "delta": 2785194.6
      },
      {
        "periodo": 202605,
        "valor": 1302000733.8,
        "delta": 39439993.2
      },
      {
        "periodo": 202606,
        "valor": 1314782296.7,
        "delta": 12781562.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 1558319525.0,
    "valor_anterior": 1537632108.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1295309836.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1321644273.0,
        "delta": 26334437.0
      },
      {
        "periodo": 202508,
        "valor": 1349299734.0,
        "delta": 27655461.0
      },
      {
        "periodo": 202509,
        "valor": 1386548625.0,
        "delta": 37248891.0
      },
      {
        "periodo": 202510,
        "valor": 1421400070.0,
        "delta": 34851445.0
      },
      {
        "periodo": 202511,
        "valor": 1448730274.0,
        "delta": 27330204.0
      },
      {
        "periodo": 202512,
        "valor": 1458558622.0,
        "delta": 9828348.0
      },
      {
        "periodo": 202601,
        "valor": 1487098790.0,
        "delta": 28540168.0
      },
      {
        "periodo": 202602,
        "valor": 1514770672.0,
        "delta": 27671882.0
      },
      {
        "periodo": 202603,
        "valor": 1515012096.0,
        "delta": 241424.0
      },
      {
        "periodo": 202604,
        "valor": 1502741395.0,
        "delta": -12270701.0
      },
      {
        "periodo": 202605,
        "valor": 1537632108.0,
        "delta": 34890713.0
      },
      {
        "periodo": 202606,
        "valor": 1558319525.0,
        "delta": 20687417.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 15901079636.0,
    "valor_anterior": 15746465065.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14361690430.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14514860848.0,
        "delta": 153170418.0
      },
      {
        "periodo": 202508,
        "valor": 14675271008.0,
        "delta": 160410160.0
      },
      {
        "periodo": 202509,
        "valor": 14812252723.0,
        "delta": 136981715.0
      },
      {
        "periodo": 202510,
        "valor": 14940188971.0,
        "delta": 127936248.0
      },
      {
        "periodo": 202511,
        "valor": 15044622342.0,
        "delta": 104433371.0
      },
      {
        "periodo": 202512,
        "valor": 15080506156.0,
        "delta": 35883814.0
      },
      {
        "periodo": 202601,
        "valor": 15216802256.0,
        "delta": 136296100.0
      },
      {
        "periodo": 202602,
        "valor": 15288750023.0,
        "delta": 71947767.0
      },
      {
        "periodo": 202603,
        "valor": 15409979269.0,
        "delta": 121229246.0
      },
      {
        "periodo": 202604,
        "valor": 15567363378.0,
        "delta": 157384109.0
      },
      {
        "periodo": 202605,
        "valor": 15746465065.0,
        "delta": 179101687.0
      },
      {
        "periodo": 202606,
        "valor": 15901079636.0,
        "delta": 154614571.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 1956930276.0,
    "valor_anterior": 1951081442.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1846844922.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1849418923.0,
        "delta": 2574001.0
      },
      {
        "periodo": 202508,
        "valor": 1866173408.0,
        "delta": 16754485.0
      },
      {
        "periodo": 202509,
        "valor": 1874604429.0,
        "delta": 8431021.0
      },
      {
        "periodo": 202510,
        "valor": 1886288516.0,
        "delta": 11684087.0
      },
      {
        "periodo": 202511,
        "valor": 1897329492.0,
        "delta": 11040976.0
      },
      {
        "periodo": 202512,
        "valor": 1898178315.0,
        "delta": 848823.0
      },
      {
        "periodo": 202601,
        "valor": 1906406487.0,
        "delta": 8228172.0
      },
      {
        "periodo": 202602,
        "valor": 1915397283.0,
        "delta": 8990796.0
      },
      {
        "periodo": 202603,
        "valor": 1929274304.0,
        "delta": 13877021.0
      },
      {
        "periodo": 202604,
        "valor": 1938672913.0,
        "delta": 9398609.0
      },
      {
        "periodo": 202605,
        "valor": 1951081442.0,
        "delta": 12408529.0
      },
      {
        "periodo": 202606,
        "valor": 1956930276.0,
        "delta": 5848834.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 4537819535.0,
    "valor_anterior": 4515640675.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4409067665.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4435853320.0,
        "delta": 26785655.0
      },
      {
        "periodo": 202508,
        "valor": 4463014419.0,
        "delta": 27161099.0
      },
      {
        "periodo": 202509,
        "valor": 4521455157.0,
        "delta": 58440738.0
      },
      {
        "periodo": 202510,
        "valor": 4552434549.0,
        "delta": 30979392.0
      },
      {
        "periodo": 202511,
        "valor": 4586609444.0,
        "delta": 34174895.0
      },
      {
        "periodo": 202512,
        "valor": 4589950238.0,
        "delta": 3340794.0
      },
      {
        "periodo": 202601,
        "valor": 4622136002.0,
        "delta": 32185764.0
      },
      {
        "periodo": 202602,
        "valor": 4652995907.0,
        "delta": 30859905.0
      },
      {
        "periodo": 202603,
        "valor": 4665673311.0,
        "delta": 12677404.0
      },
      {
        "periodo": 202604,
        "valor": 4496310431.0,
        "delta": -169362880.0
      },
      {
        "periodo": 202605,
        "valor": 4515640675.0,
        "delta": 19330244.0
      },
      {
        "periodo": 202606,
        "valor": 4537819535.0,
        "delta": 22178860.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 2247401916.0,
    "valor_anterior": 2238243648.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2146529525.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2166968786.0,
        "delta": 20439261.0
      },
      {
        "periodo": 202508,
        "valor": 2195341534.0,
        "delta": 28372748.0
      },
      {
        "periodo": 202509,
        "valor": 2202712137.0,
        "delta": 7370603.0
      },
      {
        "periodo": 202510,
        "valor": 2213045407.0,
        "delta": 10333270.0
      },
      {
        "periodo": 202511,
        "valor": 2210960305.0,
        "delta": -2085102.0
      },
      {
        "periodo": 202512,
        "valor": 2219903950.0,
        "delta": 8943645.0
      },
      {
        "periodo": 202601,
        "valor": 2226834082.0,
        "delta": 6930132.0
      },
      {
        "periodo": 202602,
        "valor": 2236382962.0,
        "delta": 9548880.0
      },
      {
        "periodo": 202603,
        "valor": 2225957117.0,
        "delta": -10425845.0
      },
      {
        "periodo": 202604,
        "valor": 2234409174.0,
        "delta": 8452057.0
      },
      {
        "periodo": 202605,
        "valor": 2238243648.0,
        "delta": 3834474.0
      },
      {
        "periodo": 202606,
        "valor": 2247401916.0,
        "delta": 9158268.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 2753683757.0,
    "valor_anterior": 2720036931.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2433812599.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2465020238.0,
        "delta": 31207639.0
      },
      {
        "periodo": 202508,
        "valor": 2495200765.0,
        "delta": 30180527.0
      },
      {
        "periodo": 202509,
        "valor": 2524852564.0,
        "delta": 29651799.0
      },
      {
        "periodo": 202510,
        "valor": 2548360078.0,
        "delta": 23507514.0
      },
      {
        "periodo": 202511,
        "valor": 2573941591.0,
        "delta": 25581513.0
      },
      {
        "periodo": 202512,
        "valor": 2587433142.0,
        "delta": 13491551.0
      },
      {
        "periodo": 202601,
        "valor": 2614786509.0,
        "delta": 27353367.0
      },
      {
        "periodo": 202602,
        "valor": 2640239469.0,
        "delta": 25452960.0
      },
      {
        "periodo": 202603,
        "valor": 2668259721.0,
        "delta": 28020252.0
      },
      {
        "periodo": 202604,
        "valor": 2694570426.0,
        "delta": 26310705.0
      },
      {
        "periodo": 202605,
        "valor": 2720036931.0,
        "delta": 25466505.0
      },
      {
        "periodo": 202606,
        "valor": 2753683757.0,
        "delta": 33646826.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 1768796312.0,
    "valor_anterior": 1763291561.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1712860533.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1716997430.0,
        "delta": 4136897.0
      },
      {
        "periodo": 202508,
        "valor": 1722227333.0,
        "delta": 5229903.0
      },
      {
        "periodo": 202509,
        "valor": 1727524741.0,
        "delta": 5297408.0
      },
      {
        "periodo": 202510,
        "valor": 1734422691.0,
        "delta": 6897950.0
      },
      {
        "periodo": 202511,
        "valor": 1735285990.0,
        "delta": 863299.0
      },
      {
        "periodo": 202512,
        "valor": 1738450252.0,
        "delta": 3164262.0
      },
      {
        "periodo": 202601,
        "valor": 1741610548.0,
        "delta": 3160296.0
      },
      {
        "periodo": 202602,
        "valor": 1745789232.0,
        "delta": 4178684.0
      },
      {
        "periodo": 202603,
        "valor": 1753633798.0,
        "delta": 7844566.0
      },
      {
        "periodo": 202604,
        "valor": 1756007158.0,
        "delta": 2373360.0
      },
      {
        "periodo": 202605,
        "valor": 1763291561.0,
        "delta": 7284403.0
      },
      {
        "periodo": 202606,
        "valor": 1768796312.0,
        "delta": 5504751.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 5714525537.0,
    "valor_anterior": 5664531113.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5470552972.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 5474516138.0,
        "delta": 3963166.0
      },
      {
        "periodo": 202508,
        "valor": 5517082411.0,
        "delta": 42566273.0
      },
      {
        "periodo": 202509,
        "valor": 5583420492.0,
        "delta": 66338081.0
      },
      {
        "periodo": 202510,
        "valor": 5602593336.0,
        "delta": 19172844.0
      },
      {
        "periodo": 202511,
        "valor": 5590326107.0,
        "delta": -12267229.0
      },
      {
        "periodo": 202512,
        "valor": 5573944347.0,
        "delta": -16381760.0
      },
      {
        "periodo": 202601,
        "valor": 5604669785.0,
        "delta": 30725438.0
      },
      {
        "periodo": 202602,
        "valor": 5639967680.0,
        "delta": 35297895.0
      },
      {
        "periodo": 202603,
        "valor": 5638442424.0,
        "delta": -1525256.0
      },
      {
        "periodo": 202604,
        "valor": 5625540441.0,
        "delta": -12901983.0
      },
      {
        "periodo": 202605,
        "valor": 5664531113.0,
        "delta": 38990672.0
      },
      {
        "periodo": 202606,
        "valor": 5714525537.0,
        "delta": 49994424.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 841702757.0,
    "valor_anterior": 841455265.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 950653155.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 888476216.0,
        "delta": -62176939.0
      },
      {
        "periodo": 202508,
        "valor": 773096004.0,
        "delta": -115380212.0
      },
      {
        "periodo": 202509,
        "valor": 858305874.0,
        "delta": 85209870.0
      },
      {
        "periodo": 202510,
        "valor": 865349154.0,
        "delta": 7043280.0
      },
      {
        "periodo": 202511,
        "valor": 850179715.0,
        "delta": -15169439.0
      },
      {
        "periodo": 202512,
        "valor": 945219835.0,
        "delta": 95040120.0
      },
      {
        "periodo": 202601,
        "valor": 891622864.0,
        "delta": -53596971.0
      },
      {
        "periodo": 202602,
        "valor": 903111521.0,
        "delta": 11488657.0
      },
      {
        "periodo": 202603,
        "valor": 863279110.0,
        "delta": -39832411.0
      },
      {
        "periodo": 202604,
        "valor": 855271846.0,
        "delta": -8007264.0
      },
      {
        "periodo": 202605,
        "valor": 841455265.0,
        "delta": -13816581.0
      },
      {
        "periodo": 202606,
        "valor": 841702757.0,
        "delta": 247492.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 1900508281.9,
    "valor_anterior": 1854846990.6,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1562196664.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1564829002.0,
        "delta": 2632338.0
      },
      {
        "periodo": 202508,
        "valor": 1568105905.0,
        "delta": 3276903.0
      },
      {
        "periodo": 202509,
        "valor": 1571251743.0,
        "delta": 3145838.0
      },
      {
        "periodo": 202510,
        "valor": 1572976651.0,
        "delta": 1724908.0
      },
      {
        "periodo": 202511,
        "valor": 1576221086.0,
        "delta": 3244435.0
      },
      {
        "periodo": 202512,
        "valor": 1578421792.0,
        "delta": 2200706.0
      },
      {
        "periodo": 202601,
        "valor": 1582516739.0,
        "delta": 4094947.0
      },
      {
        "periodo": 202602,
        "valor": 1804725857.8,
        "delta": 222209118.8
      },
      {
        "periodo": 202603,
        "valor": 1832298465.0,
        "delta": 27572607.2
      },
      {
        "periodo": 202604,
        "valor": 1831981932.1,
        "delta": -316532.9
      },
      {
        "periodo": 202605,
        "valor": 1854846990.6,
        "delta": 22865058.5
      },
      {
        "periodo": 202606,
        "valor": 1900508281.9,
        "delta": 45661291.3
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 3074648773.0,
    "valor_anterior": 1582760923.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2113934681.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1989543257.0,
        "delta": -124391424.0
      },
      {
        "periodo": 202508,
        "valor": 1830461754.0,
        "delta": -159081503.0
      },
      {
        "periodo": 202509,
        "valor": 1661381263.0,
        "delta": -169080491.0
      },
      {
        "periodo": 202510,
        "valor": 1423803459.0,
        "delta": -237577804.0
      },
      {
        "periodo": 202511,
        "valor": 1178272374.0,
        "delta": -245531085.0
      },
      {
        "periodo": 202512,
        "valor": 1681072680.0,
        "delta": 502800306.0
      },
      {
        "periodo": 202601,
        "valor": 2692866264.0,
        "delta": 1011793584.0
      },
      {
        "periodo": 202602,
        "valor": 2479196956.0,
        "delta": -213669308.0
      },
      {
        "periodo": 202603,
        "valor": 2065254279.0,
        "delta": -413942677.0
      },
      {
        "periodo": 202604,
        "valor": 1829876118.0,
        "delta": -235378161.0
      },
      {
        "periodo": 202605,
        "valor": 1582760923.0,
        "delta": -247115195.0
      },
      {
        "periodo": 202606,
        "valor": 3074648773.0,
        "delta": 1491887850.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 2178752004.0,
    "valor_anterior": 2257671087.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 1325212615.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 1398768756.0,
        "delta": 73556141.0
      },
      {
        "periodo": 202601,
        "valor": 1374218924.0,
        "delta": -24549832.0
      },
      {
        "periodo": 202602,
        "valor": 1328755837.0,
        "delta": -45463087.0
      },
      {
        "periodo": 202603,
        "valor": 1271674797.0,
        "delta": -57081040.0
      },
      {
        "periodo": 202604,
        "valor": 2324921522.0,
        "delta": 1053246725.0
      },
      {
        "periodo": 202605,
        "valor": 2257671087.0,
        "delta": -67250435.0
      },
      {
        "periodo": 202606,
        "valor": 2178752004.0,
        "delta": -78919083.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 4688474073.1,
    "valor_anterior": 4131933371.4,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 2989288632.9,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 4737104141.9,
        "delta": 1747815509.0
      },
      {
        "periodo": 202605,
        "valor": 4131933371.4,
        "delta": -605170770.5
      },
      {
        "periodo": 202606,
        "valor": 4688474073.1,
        "delta": 556540701.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 1613683528470.2,
    "valor_anterior": 1626548500307.6,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1472915212041.725,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1496656371124.3,
        "delta": 23741159082.575
      },
      {
        "periodo": 202508,
        "valor": 1523077806895.025,
        "delta": 26421435770.7249
      },
      {
        "periodo": 202509,
        "valor": 1532045706605.85,
        "delta": 8967899710.8252
      },
      {
        "periodo": 202510,
        "valor": 1552318815865.3,
        "delta": 20273109259.45
      },
      {
        "periodo": 202511,
        "valor": 1531270874510.35,
        "delta": -21047941354.95
      },
      {
        "periodo": 202512,
        "valor": 1514642988503.1,
        "delta": -16627886007.25
      },
      {
        "periodo": 202601,
        "valor": 1548609642527.4,
        "delta": 33966654024.2998
      },
      {
        "periodo": 202602,
        "valor": 1604139814555.45,
        "delta": 55530172028.05
      },
      {
        "periodo": 202603,
        "valor": 1605481850854.4,
        "delta": 1342036298.95
      },
      {
        "periodo": 202604,
        "valor": 1600799994562.9,
        "delta": -4681856291.5
      },
      {
        "periodo": 202605,
        "valor": 1626548500307.6,
        "delta": 25748505744.7002
      },
      {
        "periodo": 202606,
        "valor": 1613683528470.2,
        "delta": -12864971837.4001
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 1113585179955.1,
    "valor_anterior": 1132886540452.4,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1017073084904.3,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1035643820553.1,
        "delta": 18570735648.7999
      },
      {
        "periodo": 202508,
        "valor": 1056503913198.4,
        "delta": 20860092645.3
      },
      {
        "periodo": 202509,
        "valor": 1057385802963.7,
        "delta": 881889765.2999
      },
      {
        "periodo": 202510,
        "valor": 1074942386962.4,
        "delta": 17556583998.7001
      },
      {
        "periodo": 202511,
        "valor": 1058897572313.9,
        "delta": -16044814648.5
      },
      {
        "periodo": 202512,
        "valor": 1035683431692.7,
        "delta": -23214140621.2001
      },
      {
        "periodo": 202601,
        "valor": 1064503811527.8,
        "delta": 28820379835.1001
      },
      {
        "periodo": 202602,
        "valor": 1114261243847.3,
        "delta": 49757432319.5
      },
      {
        "periodo": 202603,
        "valor": 1113110831502.1,
        "delta": -1150412345.2
      },
      {
        "periodo": 202604,
        "valor": 1110226260976.5,
        "delta": -2884570525.6001
      },
      {
        "periodo": 202605,
        "valor": 1132886540452.4,
        "delta": 22660279475.8999
      },
      {
        "periodo": 202606,
        "valor": 1113585179955.1,
        "delta": -19301360497.2998
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 28780790503.0,
    "valor_anterior": 28596735973.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 37948329980.875,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 38447410442.5,
        "delta": 499080461.625
      },
      {
        "periodo": 202508,
        "valor": 37658252153.875,
        "delta": -789158288.625
      },
      {
        "periodo": 202509,
        "valor": 36905694830.5,
        "delta": -752557323.375
      },
      {
        "periodo": 202510,
        "valor": 33429597371.0,
        "delta": -3476097459.5
      },
      {
        "periodo": 202511,
        "valor": 27699119440.1,
        "delta": -5730477930.9
      },
      {
        "periodo": 202512,
        "valor": 28620765359.2,
        "delta": 921645919.1
      },
      {
        "periodo": 202601,
        "valor": 28940326380.0,
        "delta": 319561020.8
      },
      {
        "periodo": 202602,
        "valor": 29437849915.7,
        "delta": 497523535.7
      },
      {
        "periodo": 202603,
        "valor": 29618642594.8,
        "delta": 180792679.1
      },
      {
        "periodo": 202604,
        "valor": 28128885500.2,
        "delta": -1489757094.6
      },
      {
        "periodo": 202605,
        "valor": 28596735973.2,
        "delta": 467850473.0
      },
      {
        "periodo": 202606,
        "valor": 28780790503.0,
        "delta": 184054529.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 197240867056.0,
    "valor_anterior": 196122506942.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 177607450271.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 179684375055.0,
        "delta": 2076924784.0
      },
      {
        "periodo": 202508,
        "valor": 182230792513.0,
        "delta": 2546417458.0
      },
      {
        "periodo": 202509,
        "valor": 184599613343.0,
        "delta": 2368820830.0
      },
      {
        "periodo": 202510,
        "valor": 186342513503.0,
        "delta": 1742900160.0
      },
      {
        "periodo": 202511,
        "valor": 186550179897.0,
        "delta": 207666394.0
      },
      {
        "periodo": 202512,
        "valor": 188333218553.0,
        "delta": 1783038656.0
      },
      {
        "periodo": 202601,
        "valor": 189964112904.5,
        "delta": 1630894351.5
      },
      {
        "periodo": 202602,
        "valor": 191707634371.0,
        "delta": 1743521466.5
      },
      {
        "periodo": 202603,
        "valor": 191767607918.0,
        "delta": 59973547.0
      },
      {
        "periodo": 202604,
        "valor": 194073051089.0,
        "delta": 2305443171.0
      },
      {
        "periodo": 202605,
        "valor": 196122506942.0,
        "delta": 2049455853.0
      },
      {
        "periodo": 202606,
        "valor": 197240867056.0,
        "delta": 1118360114.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 119015408629.8,
    "valor_anterior": 117476216067.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 108867464839.5,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 110403036270.8,
        "delta": 1535571431.3
      },
      {
        "periodo": 202508,
        "valor": 112158313483.0,
        "delta": 1755277212.2
      },
      {
        "periodo": 202509,
        "valor": 113941363469.6,
        "delta": 1783049986.6
      },
      {
        "periodo": 202510,
        "valor": 115916391804.4,
        "delta": 1975028334.8
      },
      {
        "periodo": 202511,
        "valor": 115719071454.5,
        "delta": -197320349.9
      },
      {
        "periodo": 202512,
        "valor": 117014334062.9,
        "delta": 1295262608.4
      },
      {
        "periodo": 202601,
        "valor": 118782924379.6,
        "delta": 1768590316.7
      },
      {
        "periodo": 202602,
        "valor": 119933649868.7,
        "delta": 1150725489.1
      },
      {
        "periodo": 202603,
        "valor": 119274995200.5,
        "delta": -658654668.2
      },
      {
        "periodo": 202604,
        "valor": 116449081195.0,
        "delta": -2825914005.5
      },
      {
        "periodo": 202605,
        "valor": 117476216067.0,
        "delta": 1027134872.0
      },
      {
        "periodo": 202606,
        "valor": 119015408629.8,
        "delta": 1539192562.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 45021115837.3,
    "valor_anterior": 44012270111.8,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 37019750004.9,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 37294794550.5,
        "delta": 275044545.6
      },
      {
        "periodo": 202508,
        "valor": 37988152633.2,
        "delta": 693358082.7
      },
      {
        "periodo": 202509,
        "valor": 40377466030.3,
        "delta": 2389313397.1
      },
      {
        "periodo": 202510,
        "valor": 41407106183.6,
        "delta": 1029640153.3
      },
      {
        "periodo": 202511,
        "valor": 41498850510.2,
        "delta": 91744326.6
      },
      {
        "periodo": 202512,
        "valor": 42322804351.8,
        "delta": 823953841.6
      },
      {
        "periodo": 202601,
        "valor": 42630368288.4,
        "delta": 307563936.6
      },
      {
        "periodo": 202602,
        "valor": 43166122661.1,
        "delta": 535754372.7
      },
      {
        "periodo": 202603,
        "valor": 43989917349.9,
        "delta": 823794688.8
      },
      {
        "periodo": 202604,
        "valor": 43955076014.5,
        "delta": -34841335.4
      },
      {
        "periodo": 202605,
        "valor": 44012270111.8,
        "delta": 57194097.3
      },
      {
        "periodo": 202606,
        "valor": 45021115837.3,
        "delta": 1008845725.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 4030213,
    "label": "Capital Fundamental (CET1) Jun 2026",
    "valor_actual": 110040166489.0,
    "valor_anterior": 107454230761.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 94399132041.15,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 95182934252.4,
        "delta": 783802211.25
      },
      {
        "periodo": 202508,
        "valor": 96538382913.55,
        "delta": 1355448661.15
      },
      {
        "periodo": 202509,
        "valor": 98835765968.75,
        "delta": 2297383055.2
      },
      {
        "periodo": 202510,
        "valor": 100280820040.9,
        "delta": 1445054072.15
      },
      {
        "periodo": 202511,
        "valor": 100906080894.65,
        "delta": 625260853.75
      },
      {
        "periodo": 202512,
        "valor": 102668434483.5,
        "delta": 1762353588.85
      },
      {
        "periodo": 202601,
        "valor": 103788099047.1,
        "delta": 1119664563.6
      },
      {
        "periodo": 202602,
        "valor": 105633313891.65,
        "delta": 1845214844.55
      },
      {
        "periodo": 202603,
        "valor": 107719856289.1,
        "delta": 2086542397.45
      },
      {
        "periodo": 202604,
        "valor": 107967639787.7,
        "delta": 247783498.6
      },
      {
        "periodo": 202605,
        "valor": 107454230761.2,
        "delta": -513409026.5
      },
      {
        "periodo": 202606,
        "valor": 110040166489.0,
        "delta": 2585935727.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 4030214,
    "label": "Capital No Fundamental (AT1) Jun 2026",
    "valor_actual": 16000000000.0,
    "valor_anterior": 16000000000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 16000000000.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 16000000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 16000000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 16000000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 16000000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 16000000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 16000000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 16000000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 16000000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 16000000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 16000000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 16000000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 16000000000.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 4030214,
    "label": "Capital No Fundamental (AT1) Jun 2026",
    "valor_actual": 12249020000.0,
    "valor_anterior": 12138070000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 13135780000.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13207600000.0,
        "delta": 71820000.0
      },
      {
        "periodo": 202508,
        "valor": 13063050000.0,
        "delta": -144550000.0
      },
      {
        "periodo": 202509,
        "valor": 12820290000.0,
        "delta": -242760000.0
      },
      {
        "periodo": 202510,
        "valor": 13005720000.0,
        "delta": 185430000.0
      },
      {
        "periodo": 202511,
        "valor": 12806710000.0,
        "delta": -199010000.0
      },
      {
        "periodo": 202512,
        "valor": 12605600000.0,
        "delta": -201110000.0
      },
      {
        "periodo": 202601,
        "valor": 12194070000.0,
        "delta": -411530000.0
      },
      {
        "periodo": 202602,
        "valor": 12062260000.0,
        "delta": -131810000.0
      },
      {
        "periodo": 202603,
        "valor": 12547640000.0,
        "delta": 485380000.0
      },
      {
        "periodo": 202604,
        "valor": 12228160000.0,
        "delta": -319480000.0
      },
      {
        "periodo": 202605,
        "valor": 12138070000.0,
        "delta": -90090000.0
      },
      {
        "periodo": 202606,
        "valor": 12249020000.0,
        "delta": 110950000.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 4030214,
    "label": "Capital No Fundamental (AT1) Jun 2026",
    "valor_actual": 5249580000.0,
    "valor_anterior": 5202030000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": 5202030000.0,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": 5249580000.0,
        "delta": 47550000.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 4030214,
    "label": "Capital No Fundamental (AT1) Jun 2026",
    "valor_actual": 12408000000.0,
    "valor_anterior": 12408000000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 8908000000.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 8908000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 8908000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 8908000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 8908000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 8908000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 12408000000.0,
        "delta": 3500000000.0
      },
      {
        "periodo": 202601,
        "valor": 12408000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 12408000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 12408000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 12408000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 12408000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 12408000000.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 4030214,
    "label": "Capital No Fundamental (AT1) Jun 2026",
    "valor_actual": 808155510.0,
    "valor_anterior": 800972754.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 800000000.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 800000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 800000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 800000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 817252691.0,
        "delta": 17252691.0
      },
      {
        "periodo": 202511,
        "valor": 802000752.0,
        "delta": -15251939.0
      },
      {
        "periodo": 202512,
        "valor": 809846386.0,
        "delta": 7845634.0
      },
      {
        "periodo": 202601,
        "valor": 817818492.0,
        "delta": 7972106.0
      },
      {
        "periodo": 202602,
        "valor": 800675972.0,
        "delta": -17142520.0
      },
      {
        "periodo": 202603,
        "valor": 808446850.0,
        "delta": 7770878.0
      },
      {
        "periodo": 202604,
        "valor": 815904913.0,
        "delta": 7458063.0
      },
      {
        "periodo": 202605,
        "valor": 800972754.0,
        "delta": -14932159.0
      },
      {
        "periodo": 202606,
        "valor": 808155510.0,
        "delta": 7182756.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 4030214,
    "label": "Capital No Fundamental (AT1) Jun 2026",
    "valor_actual": 95367370000.0,
    "valor_anterior": 71094410000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 76938140000.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 77358800000.0,
        "delta": 420660000.0
      },
      {
        "periodo": 202508,
        "valor": 76512150000.0,
        "delta": -846650000.0
      },
      {
        "periodo": 202509,
        "valor": 75090270000.0,
        "delta": -1421880000.0
      },
      {
        "periodo": 202510,
        "valor": 76176360000.0,
        "delta": 1086090000.0
      },
      {
        "periodo": 202511,
        "valor": 75010730000.0,
        "delta": -1165630000.0
      },
      {
        "periodo": 202512,
        "valor": 73832800000.0,
        "delta": -1177930000.0
      },
      {
        "periodo": 202601,
        "valor": 71422410000.0,
        "delta": -2410390000.0
      },
      {
        "periodo": 202602,
        "valor": 70650380000.0,
        "delta": -772030000.0
      },
      {
        "periodo": 202603,
        "valor": 73493320000.0,
        "delta": 2842940000.0
      },
      {
        "periodo": 202604,
        "valor": 71622080000.0,
        "delta": -1871240000.0
      },
      {
        "periodo": 202605,
        "valor": 71094410000.0,
        "delta": -527670000.0
      },
      {
        "periodo": 202606,
        "valor": 95367370000.0,
        "delta": 24272960000.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 4030214,
    "label": "Capital No Fundamental (AT1) Jun 2026",
    "valor_actual": 1500000000.0,
    "valor_anterior": 1500000000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1508492211.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1509582780.0,
        "delta": 1090569.0
      },
      {
        "periodo": 202508,
        "valor": 1506550561.0,
        "delta": -3032219.0
      },
      {
        "periodo": 202509,
        "valor": 1507346680.0,
        "delta": 796119.0
      },
      {
        "periodo": 202510,
        "valor": 1508589657.0,
        "delta": 1242977.0
      },
      {
        "periodo": 202511,
        "valor": 1509430042.0,
        "delta": 840385.0
      },
      {
        "periodo": 202512,
        "valor": 1502331122.0,
        "delta": -7098920.0
      },
      {
        "periodo": 202601,
        "valor": 1503565286.0,
        "delta": 1234164.0
      },
      {
        "periodo": 202602,
        "valor": 1500000000.0,
        "delta": -3565286.0
      },
      {
        "periodo": 202603,
        "valor": 1500000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1500000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1500000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1500000000.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 4030214,
    "label": "Capital No Fundamental (AT1) Jun 2026",
    "valor_actual": 270000000.0,
    "valor_anterior": 270000000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 270000000.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 270000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 270000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 270000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 270000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 270000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 270000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 270000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 270000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 270000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 270000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 270000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 270000000.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 4030214,
    "label": "Capital No Fundamental (AT1) Jun 2026",
    "valor_actual": 533756452.0,
    "valor_anterior": 534483182.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 563100952.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 570510765.0,
        "delta": 7409813.0
      },
      {
        "periodo": 202508,
        "valor": 568550488.0,
        "delta": -1960277.0
      },
      {
        "periodo": 202509,
        "valor": 549572126.0,
        "delta": -18978362.0
      },
      {
        "periodo": 202510,
        "valor": 561644710.0,
        "delta": 12072584.0
      },
      {
        "periodo": 202511,
        "valor": 556980177.0,
        "delta": -4664533.0
      },
      {
        "periodo": 202512,
        "valor": 540487968.0,
        "delta": -16492209.0
      },
      {
        "periodo": 202601,
        "valor": 526560905.0,
        "delta": -13927063.0
      },
      {
        "periodo": 202602,
        "valor": 524191045.0,
        "delta": -2369860.0
      },
      {
        "periodo": 202603,
        "valor": 538963127.0,
        "delta": 14772082.0
      },
      {
        "periodo": 202604,
        "valor": 531503424.0,
        "delta": -7459703.0
      },
      {
        "periodo": 202605,
        "valor": 534483182.0,
        "delta": 2979758.0
      },
      {
        "periodo": 202606,
        "valor": 533756452.0,
        "delta": -726730.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 4030214,
    "label": "Capital No Fundamental (AT1) Jun 2026",
    "valor_actual": 144385881962.0,
    "valor_anterior": 119947965936.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 118123513163.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 118624493545.0,
        "delta": 500980382.0
      },
      {
        "periodo": 202508,
        "valor": 117628301049.0,
        "delta": -996192496.0
      },
      {
        "periodo": 202509,
        "valor": 115945478806.0,
        "delta": -1682822243.0
      },
      {
        "periodo": 202510,
        "valor": 117247567058.0,
        "delta": 1302088252.0
      },
      {
        "periodo": 202511,
        "valor": 115863850971.0,
        "delta": -1383716087.0
      },
      {
        "periodo": 202512,
        "valor": 117969065476.0,
        "delta": 2105214505.0
      },
      {
        "periodo": 202601,
        "valor": 115142424683.0,
        "delta": -2826640793.0
      },
      {
        "periodo": 202602,
        "valor": 114215507017.0,
        "delta": -926917666.0
      },
      {
        "periodo": 202603,
        "valor": 117566369977.0,
        "delta": 3350862960.0
      },
      {
        "periodo": 202604,
        "valor": 115375648337.0,
        "delta": -2190721640.0
      },
      {
        "periodo": 202605,
        "valor": 119947965936.0,
        "delta": 4572317599.0
      },
      {
        "periodo": 202606,
        "valor": 144385881962.0,
        "delta": 24437916026.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 4030214,
    "label": "Capital No Fundamental (AT1) Jun 2026",
    "valor_actual": 136024390000.0,
    "valor_anterior": 111640480000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 114981920000.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 115474400000.0,
        "delta": 492480000.0
      },
      {
        "periodo": 202508,
        "valor": 114483200000.0,
        "delta": -991200000.0
      },
      {
        "periodo": 202509,
        "valor": 112818560000.0,
        "delta": -1664640000.0
      },
      {
        "periodo": 202510,
        "valor": 114090080000.0,
        "delta": 1271520000.0
      },
      {
        "periodo": 202511,
        "valor": 112725440000.0,
        "delta": -1364640000.0
      },
      {
        "periodo": 202512,
        "valor": 114846400000.0,
        "delta": 2120960000.0
      },
      {
        "periodo": 202601,
        "valor": 112024480000.0,
        "delta": -2821920000.0
      },
      {
        "periodo": 202602,
        "valor": 111120640000.0,
        "delta": -903840000.0
      },
      {
        "periodo": 202603,
        "valor": 114448960000.0,
        "delta": 3328320000.0
      },
      {
        "periodo": 202604,
        "valor": 112258240000.0,
        "delta": -2190720000.0
      },
      {
        "periodo": 202605,
        "valor": 111640480000.0,
        "delta": -617760000.0
      },
      {
        "periodo": 202606,
        "valor": 136024390000.0,
        "delta": 24383910000.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 4030214,
    "label": "Capital No Fundamental (AT1) Jun 2026",
    "valor_actual": 808155510.0,
    "valor_anterior": 800972754.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 800000000.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 800000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 800000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 800000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 817252691.0,
        "delta": 17252691.0
      },
      {
        "periodo": 202511,
        "valor": 802000752.0,
        "delta": -15251939.0
      },
      {
        "periodo": 202512,
        "valor": 809846386.0,
        "delta": 7845634.0
      },
      {
        "periodo": 202601,
        "valor": 817818492.0,
        "delta": 7972106.0
      },
      {
        "periodo": 202602,
        "valor": 800675972.0,
        "delta": -17142520.0
      },
      {
        "periodo": 202603,
        "valor": 808446850.0,
        "delta": 7770878.0
      },
      {
        "periodo": 202604,
        "valor": 815904913.0,
        "delta": 7458063.0
      },
      {
        "periodo": 202605,
        "valor": 800972754.0,
        "delta": -14932159.0
      },
      {
        "periodo": 202606,
        "valor": 808155510.0,
        "delta": 7182756.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 4030214,
    "label": "Capital No Fundamental (AT1) Jun 2026",
    "valor_actual": 5249580000.0,
    "valor_anterior": 5202030000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": 5202030000.0,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": 5249580000.0,
        "delta": 47550000.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 4030214,
    "label": "Capital No Fundamental (AT1) Jun 2026",
    "valor_actual": 803756452.0,
    "valor_anterior": 804483182.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 833100952.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 840510765.0,
        "delta": 7409813.0
      },
      {
        "periodo": 202508,
        "valor": 838550488.0,
        "delta": -1960277.0
      },
      {
        "periodo": 202509,
        "valor": 819572126.0,
        "delta": -18978362.0
      },
      {
        "periodo": 202510,
        "valor": 831644710.0,
        "delta": 12072584.0
      },
      {
        "periodo": 202511,
        "valor": 826980177.0,
        "delta": -4664533.0
      },
      {
        "periodo": 202512,
        "valor": 810487968.0,
        "delta": -16492209.0
      },
      {
        "periodo": 202601,
        "valor": 796560905.0,
        "delta": -13927063.0
      },
      {
        "periodo": 202602,
        "valor": 794191045.0,
        "delta": -2369860.0
      },
      {
        "periodo": 202603,
        "valor": 808963127.0,
        "delta": 14772082.0
      },
      {
        "periodo": 202604,
        "valor": 801503424.0,
        "delta": -7459703.0
      },
      {
        "periodo": 202605,
        "valor": 804483182.0,
        "delta": 2979758.0
      },
      {
        "periodo": 202606,
        "valor": 803756452.0,
        "delta": -726730.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 4030214,
    "label": "Capital No Fundamental (AT1) Jun 2026",
    "valor_actual": 1500000000.0,
    "valor_anterior": 1500000000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1508492211.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1509582780.0,
        "delta": 1090569.0
      },
      {
        "periodo": 202508,
        "valor": 1506550561.0,
        "delta": -3032219.0
      },
      {
        "periodo": 202509,
        "valor": 1507346680.0,
        "delta": 796119.0
      },
      {
        "periodo": 202510,
        "valor": 1508589657.0,
        "delta": 1242977.0
      },
      {
        "periodo": 202511,
        "valor": 1509430042.0,
        "delta": 840385.0
      },
      {
        "periodo": 202512,
        "valor": 1502331122.0,
        "delta": -7098920.0
      },
      {
        "periodo": 202601,
        "valor": 1503565286.0,
        "delta": 1234164.0
      },
      {
        "periodo": 202602,
        "valor": 1500000000.0,
        "delta": -3565286.0
      },
      {
        "periodo": 202603,
        "valor": 1500000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1500000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1500000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1500000000.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 22829249442.0,
    "valor_anterior": 22488170661.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": 22488170661.0,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": 22829249442.0,
        "delta": 341078781.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 82907100142.0,
    "valor_anterior": 82351983372.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 87748897398.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 88240241389.0,
        "delta": 491343991.0
      },
      {
        "periodo": 202508,
        "valor": 87225734838.0,
        "delta": -1014506551.0
      },
      {
        "periodo": 202509,
        "valor": 85600111939.0,
        "delta": -1625622899.0
      },
      {
        "periodo": 202510,
        "valor": 86835385065.0,
        "delta": 1235273126.0
      },
      {
        "periodo": 202511,
        "valor": 85511106172.0,
        "delta": -1324278893.0
      },
      {
        "periodo": 202512,
        "valor": 84480273563.0,
        "delta": -1030832609.0
      },
      {
        "periodo": 202601,
        "valor": 81717792616.0,
        "delta": -2762480947.0
      },
      {
        "periodo": 202602,
        "valor": 81476668477.0,
        "delta": -241124139.0
      },
      {
        "periodo": 202603,
        "valor": 85628192679.0,
        "delta": 4151524202.0
      },
      {
        "periodo": 202604,
        "valor": 82629660850.0,
        "delta": -2998531829.0
      },
      {
        "periodo": 202605,
        "valor": 82351983372.0,
        "delta": -277677478.0
      },
      {
        "periodo": 202606,
        "valor": 82907100142.0,
        "delta": 555116770.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 40114777670.0,
    "valor_anterior": 41737660241.925,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 52488303630.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 52978989872.0,
        "delta": 490686242.0
      },
      {
        "periodo": 202508,
        "valor": 51516987880.0,
        "delta": -1462001992.0
      },
      {
        "periodo": 202509,
        "valor": 50044901855.0,
        "delta": -1472086025.0
      },
      {
        "periodo": 202510,
        "valor": 46419780043.0,
        "delta": -3625121812.0
      },
      {
        "periodo": 202511,
        "valor": 46226872064.0,
        "delta": -192907979.0
      },
      {
        "periodo": 202512,
        "valor": 44976407317.0,
        "delta": -1250464747.0
      },
      {
        "periodo": 202601,
        "valor": 43514914172.0,
        "delta": -1461493145.0
      },
      {
        "periodo": 202602,
        "valor": 43143919282.0,
        "delta": -370994890.0
      },
      {
        "periodo": 202603,
        "valor": 44330113114.0,
        "delta": 1186193832.0
      },
      {
        "periodo": 202604,
        "valor": 40049162098.0,
        "delta": -4280951016.0
      },
      {
        "periodo": 202605,
        "valor": 41737660241.925,
        "delta": 1688498143.925
      },
      {
        "periodo": 202606,
        "valor": 40114777670.0,
        "delta": -1622882571.925
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 35046302286.0,
    "valor_anterior": 36813428307.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 32778844978.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 33060987332.0,
        "delta": 282142354.0
      },
      {
        "periodo": 202508,
        "valor": 32923400577.0,
        "delta": -137586755.0
      },
      {
        "periodo": 202509,
        "valor": 32298638537.0,
        "delta": -624762040.0
      },
      {
        "periodo": 202510,
        "valor": 38449560907.0,
        "delta": 6150922370.0
      },
      {
        "periodo": 202511,
        "valor": 38319290213.0,
        "delta": -130270694.0
      },
      {
        "periodo": 202512,
        "valor": 37238790216.0,
        "delta": -1080499997.0
      },
      {
        "periodo": 202601,
        "valor": 36758669957.0,
        "delta": -480120259.0
      },
      {
        "periodo": 202602,
        "valor": 36590051896.0,
        "delta": -168618061.0
      },
      {
        "periodo": 202603,
        "valor": 37330895750.0,
        "delta": 740843854.0
      },
      {
        "periodo": 202604,
        "valor": 36729601267.0,
        "delta": -601294483.0
      },
      {
        "periodo": 202605,
        "valor": 36813428307.0,
        "delta": 83827040.0
      },
      {
        "periodo": 202606,
        "valor": 35046302286.0,
        "delta": -1767126021.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 650086362.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 669928436.0,
        "delta": 19842074.0
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 57692003.0,
    "valor_anterior": 40492003.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 104915471.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 132578957.0,
        "delta": 27663486.0
      },
      {
        "periodo": 202508,
        "valor": 108591460.0,
        "delta": -23987497.0
      },
      {
        "periodo": 202509,
        "valor": 74690158.0,
        "delta": -33901302.0
      },
      {
        "periodo": 202510,
        "valor": 78461417.0,
        "delta": 3771259.0
      },
      {
        "periodo": 202511,
        "valor": 86515772.0,
        "delta": 8054355.0
      },
      {
        "periodo": 202512,
        "valor": 64342922.0,
        "delta": -22172850.0
      },
      {
        "periodo": 202601,
        "valor": 67537113.0,
        "delta": 3194191.0
      },
      {
        "periodo": 202602,
        "valor": 61785115.0,
        "delta": -5751998.0
      },
      {
        "periodo": 202603,
        "valor": 116845477.0,
        "delta": 55060362.0
      },
      {
        "periodo": 202604,
        "valor": 20492003.0,
        "delta": -96353474.0
      },
      {
        "periodo": 202605,
        "valor": 40492003.0,
        "delta": 20000000.0
      },
      {
        "periodo": 202606,
        "valor": 57692003.0,
        "delta": 17200000.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 3659197.0,
    "valor_anterior": 3659197.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4328314.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4328314.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 4328314.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 3815866.0,
        "delta": -512448.0
      },
      {
        "periodo": 202510,
        "valor": 3815866.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 3815866.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 3815866.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 3815866.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 3815866.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 3659197.0,
        "delta": -156669.0
      },
      {
        "periodo": 202604,
        "valor": 3659197.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 3659197.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 3659197.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 2774114.0,
    "valor_anterior": 2792292.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4658825.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4980653.0,
        "delta": 321828.0
      },
      {
        "periodo": 202508,
        "valor": 4890590.0,
        "delta": -90063.0
      },
      {
        "periodo": 202509,
        "valor": 4993419.0,
        "delta": 102829.0
      },
      {
        "periodo": 202510,
        "valor": 5175383.0,
        "delta": 181964.0
      },
      {
        "periodo": 202511,
        "valor": 2575740.0,
        "delta": -2599643.0
      },
      {
        "periodo": 202512,
        "valor": 2676888.0,
        "delta": 101148.0
      },
      {
        "periodo": 202601,
        "valor": 2851042.0,
        "delta": 174154.0
      },
      {
        "periodo": 202602,
        "valor": 2463360.0,
        "delta": -387682.0
      },
      {
        "periodo": 202603,
        "valor": 1659193.0,
        "delta": -804167.0
      },
      {
        "periodo": 202604,
        "valor": 2610100.0,
        "delta": 950907.0
      },
      {
        "periodo": 202605,
        "valor": 2792292.0,
        "delta": 182192.0
      },
      {
        "periodo": 202606,
        "valor": 2774114.0,
        "delta": -18178.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": null,
    "valor_anterior": 723123.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24025801.0,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": 124596749.0,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 115806253.0,
        "delta": -8790496.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 8279367.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 23016021.0,
        "delta": 14736654.0
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 697040.0,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": 723123.0,
        "delta": 26083.0
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 3150137318.0,
    "valor_anterior": 3149739007.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 3050632803.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3055923387.0,
        "delta": 5290584.0
      },
      {
        "periodo": 202508,
        "valor": 3039973789.0,
        "delta": -15949598.0
      },
      {
        "periodo": 202509,
        "valor": 3050061004.0,
        "delta": 10087215.0
      },
      {
        "periodo": 202510,
        "valor": 2979984728.0,
        "delta": -70076276.0
      },
      {
        "periodo": 202511,
        "valor": 3145599161.0,
        "delta": 165614433.0
      },
      {
        "periodo": 202512,
        "valor": 3143735519.0,
        "delta": -1863642.0
      },
      {
        "periodo": 202601,
        "valor": 3146933673.0,
        "delta": 3198154.0
      },
      {
        "periodo": 202602,
        "valor": 3147066658.0,
        "delta": 132985.0
      },
      {
        "periodo": 202603,
        "valor": 3147933850.0,
        "delta": 867192.0
      },
      {
        "periodo": 202604,
        "valor": 3147273199.0,
        "delta": -660651.0
      },
      {
        "periodo": 202605,
        "valor": 3149739007.0,
        "delta": 2465808.0
      },
      {
        "periodo": 202606,
        "valor": 3150137318.0,
        "delta": 398311.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 4620505247.0,
    "valor_anterior": 4485056066.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2074437012.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2151956948.0,
        "delta": 77519936.0
      },
      {
        "periodo": 202508,
        "valor": 2136673509.0,
        "delta": -15283439.0
      },
      {
        "periodo": 202509,
        "valor": 2110556155.0,
        "delta": -26117354.0
      },
      {
        "periodo": 202510,
        "valor": 2130177711.0,
        "delta": 19621556.0
      },
      {
        "periodo": 202511,
        "valor": 3835126919.0,
        "delta": 1704949208.0
      },
      {
        "periodo": 202512,
        "valor": 4213874438.0,
        "delta": 378747519.0
      },
      {
        "periodo": 202601,
        "valor": 4151288513.0,
        "delta": -62585925.0
      },
      {
        "periodo": 202602,
        "valor": 4203187284.0,
        "delta": 51898771.0
      },
      {
        "periodo": 202603,
        "valor": 4533029391.0,
        "delta": 329842107.0
      },
      {
        "periodo": 202604,
        "valor": 4494581024.0,
        "delta": -38448367.0
      },
      {
        "periodo": 202605,
        "valor": 4485056066.0,
        "delta": -9524958.0
      },
      {
        "periodo": 202606,
        "valor": 4620505247.0,
        "delta": 135449181.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 100000000.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 100000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 80400000.0,
        "delta": -19600000.0
      },
      {
        "periodo": 202509,
        "valor": 58800000.0,
        "delta": -21600000.0
      },
      {
        "periodo": 202510,
        "valor": 16300000.0,
        "delta": -42500000.0
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 6694348.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 22559979.0,
        "delta": 15865631.0
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 1531265610.0,
    "valor_anterior": 1535510911.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1646134525.5,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1522936928.25,
        "delta": -123197597.25
      },
      {
        "periodo": 202508,
        "valor": 1529584395.25,
        "delta": 6647467.0
      },
      {
        "periodo": 202509,
        "valor": 1695008368.25,
        "delta": 165423973.0
      },
      {
        "periodo": 202510,
        "valor": 1618801182.75,
        "delta": -76207185.5
      },
      {
        "periodo": 202511,
        "valor": 1777166148.25,
        "delta": 158364965.5
      },
      {
        "periodo": 202512,
        "valor": 1766018329.0,
        "delta": -11147819.25
      },
      {
        "periodo": 202601,
        "valor": 1923418334.6662,
        "delta": 157400005.6662
      },
      {
        "periodo": 202602,
        "valor": 1929801698.0662,
        "delta": 6383363.4
      },
      {
        "periodo": 202603,
        "valor": 1630664089.75,
        "delta": -299137608.3162
      },
      {
        "periodo": 202604,
        "valor": 1628499097.75,
        "delta": -2164992.0
      },
      {
        "periodo": 202605,
        "valor": 1535510911.0,
        "delta": -92988186.75
      },
      {
        "periodo": 202606,
        "valor": 1531265610.0,
        "delta": -4245301.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 2272895181.0,
    "valor_anterior": 2279968915.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1867065923.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1866783192.0,
        "delta": -282731.0
      },
      {
        "periodo": 202508,
        "valor": 1871562425.0,
        "delta": 4779233.0
      },
      {
        "periodo": 202509,
        "valor": 1870264774.0,
        "delta": -1297651.0
      },
      {
        "periodo": 202510,
        "valor": 1873765806.0,
        "delta": 3501032.0
      },
      {
        "periodo": 202511,
        "valor": 1877049132.0,
        "delta": 3283326.0
      },
      {
        "periodo": 202512,
        "valor": 2279188893.0,
        "delta": 402139761.0
      },
      {
        "periodo": 202601,
        "valor": 2281284451.0,
        "delta": 2095558.0
      },
      {
        "periodo": 202602,
        "valor": 2278933979.0,
        "delta": -2350472.0
      },
      {
        "periodo": 202603,
        "valor": 2277974358.0,
        "delta": -959621.0
      },
      {
        "periodo": 202604,
        "valor": 2277772328.0,
        "delta": -202030.0
      },
      {
        "periodo": 202605,
        "valor": 2279968915.0,
        "delta": 2196587.0
      },
      {
        "periodo": 202606,
        "valor": 2272895181.0,
        "delta": -7073734.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 521046454.0,
    "valor_anterior": 522221973.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 522380592.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 521113953.0,
        "delta": -1266639.0
      },
      {
        "periodo": 202508,
        "valor": 521411338.0,
        "delta": 297385.0
      },
      {
        "periodo": 202509,
        "valor": 521797540.0,
        "delta": 386202.0
      },
      {
        "periodo": 202510,
        "valor": 522289921.0,
        "delta": 492381.0
      },
      {
        "periodo": 202511,
        "valor": 522646237.0,
        "delta": 356316.0
      },
      {
        "periodo": 202512,
        "valor": 521608645.0,
        "delta": -1037592.0
      },
      {
        "periodo": 202601,
        "valor": 522206647.0,
        "delta": 598002.0
      },
      {
        "periodo": 202602,
        "valor": 521965110.0,
        "delta": -241537.0
      },
      {
        "periodo": 202603,
        "valor": 522468181.0,
        "delta": 503071.0
      },
      {
        "periodo": 202604,
        "valor": 522695177.0,
        "delta": 226996.0
      },
      {
        "periodo": 202605,
        "valor": 522221973.0,
        "delta": -473204.0
      },
      {
        "periodo": 202606,
        "valor": 521046454.0,
        "delta": -1175519.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 489220643.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 461083454.0,
        "delta": -28137189.0
      },
      {
        "periodo": 202508,
        "valor": 459571069.0,
        "delta": -1512385.0
      },
      {
        "periodo": 202509,
        "valor": 459571069.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 501872064.0,
    "valor_anterior": 501534736.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 501622557.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 502190325.0,
        "delta": 567768.0
      },
      {
        "periodo": 202508,
        "valor": 502787993.0,
        "delta": 597668.0
      },
      {
        "periodo": 202509,
        "valor": 472855283.0,
        "delta": -29932710.0
      },
      {
        "periodo": 202510,
        "valor": 471782583.0,
        "delta": -1072700.0
      },
      {
        "periodo": 202511,
        "valor": 441609460.0,
        "delta": -30173123.0
      },
      {
        "periodo": 202512,
        "valor": 497863804.0,
        "delta": 56254344.0
      },
      {
        "periodo": 202601,
        "valor": 503778721.0,
        "delta": 5914917.0
      },
      {
        "periodo": 202602,
        "valor": 503841845.0,
        "delta": 63124.0
      },
      {
        "periodo": 202603,
        "valor": 504373518.0,
        "delta": 531673.0
      },
      {
        "periodo": 202604,
        "valor": 504272351.0,
        "delta": -101167.0
      },
      {
        "periodo": 202605,
        "valor": 501534736.0,
        "delta": -2737615.0
      },
      {
        "periodo": 202606,
        "valor": 501872064.0,
        "delta": 337328.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 1206432683.0,
    "valor_anterior": 1205105506.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1207837316.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1204721996.0,
        "delta": -3115320.0
      },
      {
        "periodo": 202508,
        "valor": 1205116516.0,
        "delta": 394520.0
      },
      {
        "periodo": 202509,
        "valor": 1206659027.0,
        "delta": 1542511.0
      },
      {
        "periodo": 202510,
        "valor": 1201299971.0,
        "delta": -5359056.0
      },
      {
        "periodo": 202511,
        "valor": 1201259977.0,
        "delta": -39994.0
      },
      {
        "periodo": 202512,
        "valor": 1203305156.0,
        "delta": 2045179.0
      },
      {
        "periodo": 202601,
        "valor": 1202705144.0,
        "delta": -600012.0
      },
      {
        "periodo": 202602,
        "valor": 1202705311.0,
        "delta": 167.0
      },
      {
        "periodo": 202603,
        "valor": 1204225056.0,
        "delta": 1519745.0
      },
      {
        "periodo": 202604,
        "valor": 1204825150.0,
        "delta": 600094.0
      },
      {
        "periodo": 202605,
        "valor": 1205105506.0,
        "delta": 280356.0
      },
      {
        "periodo": 202606,
        "valor": 1206432683.0,
        "delta": 1327177.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 27743709.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 27743709.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 27743709.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 27743708.0,
        "delta": -1.0
      },
      {
        "periodo": 202510,
        "valor": 27743709.0,
        "delta": 1.0
      },
      {
        "periodo": 202511,
        "valor": 36869146.0,
        "delta": 9125437.0
      },
      {
        "periodo": 202512,
        "valor": 36587209.0,
        "delta": -281937.0
      },
      {
        "periodo": 202601,
        "valor": 35712498.0,
        "delta": -874711.0
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 94400154.0,
    "valor_anterior": 108736072.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 139139382.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 139860240.0,
        "delta": 720858.0
      },
      {
        "periodo": 202508,
        "valor": 138086772.0,
        "delta": -1773468.0
      },
      {
        "periodo": 202509,
        "valor": 141326413.0,
        "delta": 3239641.0
      },
      {
        "periodo": 202510,
        "valor": 138276115.0,
        "delta": -3050298.0
      },
      {
        "periodo": 202511,
        "valor": 132661729.0,
        "delta": -5614386.0
      },
      {
        "periodo": 202512,
        "valor": 258309745.0,
        "delta": 125648016.0
      },
      {
        "periodo": 202601,
        "valor": 109296756.0,
        "delta": -149012989.0
      },
      {
        "periodo": 202602,
        "valor": 108250178.0,
        "delta": -1046578.0
      },
      {
        "periodo": 202603,
        "valor": 109451539.0,
        "delta": 1201361.0
      },
      {
        "periodo": 202604,
        "valor": 108554163.0,
        "delta": -897376.0
      },
      {
        "periodo": 202605,
        "valor": 108736072.0,
        "delta": 181909.0
      },
      {
        "periodo": 202606,
        "valor": 94400154.0,
        "delta": -14335918.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 1935257.0,
    "valor_anterior": 1960372.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4300077.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4336818.0,
        "delta": 36741.0
      },
      {
        "periodo": 202508,
        "valor": 2176550.0,
        "delta": -2160268.0
      },
      {
        "periodo": 202509,
        "valor": 2090927.0,
        "delta": -85623.0
      },
      {
        "periodo": 202510,
        "valor": 2134127.0,
        "delta": 43200.0
      },
      {
        "periodo": 202511,
        "valor": 2113817.0,
        "delta": -20310.0
      },
      {
        "periodo": 202512,
        "valor": 2035585.0,
        "delta": -78232.0
      },
      {
        "periodo": 202601,
        "valor": 1980614.0,
        "delta": -54971.0
      },
      {
        "periodo": 202602,
        "valor": 1969464.0,
        "delta": -11150.0
      },
      {
        "periodo": 202603,
        "valor": 2004763.0,
        "delta": 35299.0
      },
      {
        "periodo": 202604,
        "valor": 1964147.0,
        "delta": -40616.0
      },
      {
        "periodo": 202605,
        "valor": 1960372.0,
        "delta": -3775.0
      },
      {
        "periodo": 202606,
        "valor": 1935257.0,
        "delta": -25115.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 1069810.0,
    "valor_anterior": 1118216.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1284719.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1221695.0,
        "delta": -63024.0
      },
      {
        "periodo": 202508,
        "valor": 1215192.0,
        "delta": -6503.0
      },
      {
        "periodo": 202509,
        "valor": 1199184.0,
        "delta": -16008.0
      },
      {
        "periodo": 202510,
        "valor": 1223236.0,
        "delta": 24052.0
      },
      {
        "periodo": 202511,
        "valor": 1210807.0,
        "delta": -12429.0
      },
      {
        "periodo": 202512,
        "valor": 1134362.0,
        "delta": -76445.0
      },
      {
        "periodo": 202601,
        "valor": 1102676.0,
        "delta": -31686.0
      },
      {
        "periodo": 202602,
        "valor": 1095535.0,
        "delta": -7141.0
      },
      {
        "periodo": 202603,
        "valor": 1145121.0,
        "delta": 49586.0
      },
      {
        "periodo": 202604,
        "valor": 1121153.0,
        "delta": -23968.0
      },
      {
        "periodo": 202605,
        "valor": 1118216.0,
        "delta": -2937.0
      },
      {
        "periodo": 202606,
        "valor": 1069810.0,
        "delta": -48406.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 107932.0,
    "valor_anterior": 106451.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 100359.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 94336.0,
        "delta": -6023.0
      },
      {
        "periodo": 202605,
        "valor": 106451.0,
        "delta": 12115.0
      },
      {
        "periodo": 202606,
        "valor": 107932.0,
        "delta": 1481.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 194863222564.0,
    "valor_anterior": 197229967421.925,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 185411834236.5,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 186651907598.25,
        "delta": 1240073361.75
      },
      {
        "periodo": 202508,
        "valor": 183324262717.25,
        "delta": -3327644881.0
      },
      {
        "periodo": 202509,
        "valor": 179645085226.25,
        "delta": -3679177491.0
      },
      {
        "periodo": 202510,
        "valor": 182900554519.75,
        "delta": 3255469293.5
      },
      {
        "periodo": 202511,
        "valor": 183239294613.25,
        "delta": 338740093.5
      },
      {
        "periodo": 202512,
        "valor": 180689968457.0,
        "delta": -2549326156.25
      },
      {
        "periodo": 202601,
        "valor": 175960262508.6662,
        "delta": -4729705948.3338
      },
      {
        "periodo": 202602,
        "valor": 175223097058.0662,
        "delta": -737165450.6
      },
      {
        "periodo": 202603,
        "valor": 181344735635.75,
        "delta": 6121638577.6838
      },
      {
        "periodo": 202604,
        "valor": 173327534680.75,
        "delta": -8017200955.0
      },
      {
        "periodo": 202605,
        "valor": 197229967421.925,
        "delta": 23902432741.175
      },
      {
        "periodo": 202606,
        "valor": 194863222564.0,
        "delta": -2366744857.925
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 185521593984.0,
    "valor_anterior": 187879957844.925,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 175094811332.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 176436503855.0,
        "delta": 1341692523.0
      },
      {
        "periodo": 202508,
        "valor": 173807125118.0,
        "delta": -2629378737.0
      },
      {
        "periodo": 202509,
        "valor": 170058024352.0,
        "delta": -3749100766.0
      },
      {
        "periodo": 202510,
        "valor": 173838719592.0,
        "delta": 3780695240.0
      },
      {
        "periodo": 202511,
        "valor": 173896211234.0,
        "delta": 57491642.0
      },
      {
        "periodo": 202512,
        "valor": 170913161400.0,
        "delta": -2983049834.0
      },
      {
        "periodo": 202601,
        "valor": 166146481124.0,
        "delta": -4766680276.0
      },
      {
        "periodo": 202602,
        "valor": 165417642805.0,
        "delta": -728838319.0
      },
      {
        "periodo": 202603,
        "valor": 171825890131.0,
        "delta": 6408247326.0
      },
      {
        "periodo": 202604,
        "valor": 163906664436.0,
        "delta": -7919225695.0
      },
      {
        "periodo": 202605,
        "valor": 187879957844.925,
        "delta": 23973293408.925
      },
      {
        "periodo": 202606,
        "valor": 185521593984.0,
        "delta": -2358363860.925
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 589220643.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 561083454.0,
        "delta": -28137189.0
      },
      {
        "periodo": 202508,
        "valor": 539971069.0,
        "delta": -21112385.0
      },
      {
        "periodo": 202509,
        "valor": 518371069.0,
        "delta": -21600000.0
      },
      {
        "periodo": 202510,
        "valor": 16300000.0,
        "delta": -502071069.0
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 3671183772.0,
    "valor_anterior": 3671960980.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 3573013395.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3577037340.0,
        "delta": 4023945.0
      },
      {
        "periodo": 202508,
        "valor": 3561385127.0,
        "delta": -15652213.0
      },
      {
        "periodo": 202509,
        "valor": 3571858544.0,
        "delta": 10473417.0
      },
      {
        "periodo": 202510,
        "valor": 3502274649.0,
        "delta": -69583895.0
      },
      {
        "periodo": 202511,
        "valor": 3668245398.0,
        "delta": 165970749.0
      },
      {
        "periodo": 202512,
        "valor": 3665344164.0,
        "delta": -2901234.0
      },
      {
        "periodo": 202601,
        "valor": 3675834668.0,
        "delta": 10490504.0
      },
      {
        "periodo": 202602,
        "valor": 3691591747.0,
        "delta": 15757079.0
      },
      {
        "periodo": 202603,
        "valor": 3670402031.0,
        "delta": -21189716.0
      },
      {
        "periodo": 202604,
        "valor": 3669968376.0,
        "delta": -433655.0
      },
      {
        "periodo": 202605,
        "valor": 3671960980.0,
        "delta": 1992604.0
      },
      {
        "periodo": 202606,
        "valor": 3671183772.0,
        "delta": -777208.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 2427761452.0,
    "valor_anterior": 2431989282.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2765865963.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2814131478.0,
        "delta": 48265515.0
      },
      {
        "periodo": 202508,
        "valor": 2123131247.0,
        "delta": -691000231.0
      },
      {
        "periodo": 202509,
        "valor": 2091274764.0,
        "delta": -31856483.0
      },
      {
        "periodo": 202510,
        "valor": 2095678721.0,
        "delta": 4403957.0
      },
      {
        "periodo": 202511,
        "valor": 2098802373.0,
        "delta": 3123652.0
      },
      {
        "periodo": 202512,
        "valor": 2604518448.0,
        "delta": 505716075.0
      },
      {
        "periodo": 202601,
        "valor": 2460969362.0,
        "delta": -143549086.0
      },
      {
        "periodo": 202602,
        "valor": 2451432632.0,
        "delta": -9536730.0
      },
      {
        "periodo": 202603,
        "valor": 2505930567.0,
        "delta": 54497935.0
      },
      {
        "periodo": 202604,
        "valor": 2409428594.0,
        "delta": -96501973.0
      },
      {
        "periodo": 202605,
        "valor": 2431989282.0,
        "delta": 22560688.0
      },
      {
        "periodo": 202606,
        "valor": 2427761452.0,
        "delta": -4227830.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 1711309814.0,
    "valor_anterior": 1710441953.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1742788378.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1740214543.0,
        "delta": -2573835.0
      },
      {
        "periodo": 202508,
        "valor": 1763065761.0,
        "delta": 22851218.0
      },
      {
        "periodo": 202509,
        "valor": 1710548129.0,
        "delta": -52517632.0
      },
      {
        "periodo": 202510,
        "valor": 1828780375.0,
        "delta": 118232246.0
      },
      {
        "periodo": 202511,
        "valor": 1798869460.0,
        "delta": -29910915.0
      },
      {
        "periodo": 202512,
        "valor": 1740926116.0,
        "delta": -57943344.0
      },
      {
        "periodo": 202601,
        "valor": 1753559020.0,
        "delta": 12632904.0
      },
      {
        "periodo": 202602,
        "valor": 1732628176.0,
        "delta": -20930844.0
      },
      {
        "periodo": 202603,
        "valor": 1711748458.0,
        "delta": -20879718.0
      },
      {
        "periodo": 202604,
        "valor": 1712879841.0,
        "delta": 1131383.0
      },
      {
        "periodo": 202605,
        "valor": 1710441953.0,
        "delta": -2437888.0
      },
      {
        "periodo": 202606,
        "valor": 1711309814.0,
        "delta": 867861.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 4030215,
    "label": "Capital Complementario (Tier 2) Jun 2026",
    "valor_actual": 1531373542.0,
    "valor_anterior": 1535617362.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1646134525.5,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1522936928.25,
        "delta": -123197597.25
      },
      {
        "periodo": 202508,
        "valor": 1529584395.25,
        "delta": 6647467.0
      },
      {
        "periodo": 202509,
        "valor": 1695008368.25,
        "delta": 165423973.0
      },
      {
        "periodo": 202510,
        "valor": 1618801182.75,
        "delta": -76207185.5
      },
      {
        "periodo": 202511,
        "valor": 1777166148.25,
        "delta": 158364965.5
      },
      {
        "periodo": 202512,
        "valor": 1766018329.0,
        "delta": -11147819.25
      },
      {
        "periodo": 202601,
        "valor": 1923418334.6662,
        "delta": 157400005.6662
      },
      {
        "periodo": 202602,
        "valor": 1929801698.0662,
        "delta": 6383363.4
      },
      {
        "periodo": 202603,
        "valor": 1630764448.75,
        "delta": -299037249.3162
      },
      {
        "periodo": 202604,
        "valor": 1628593433.75,
        "delta": -2171015.0
      },
      {
        "periodo": 202605,
        "valor": 1535617362.0,
        "delta": -92976071.75
      },
      {
        "periodo": 202606,
        "valor": 1531373542.0,
        "delta": -4243820.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 687712745411.7638,
    "valor_anterior": 681091513911.6312,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 505404305266.6075,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 509590067383.49,
        "delta": 4185762116.8825
      },
      {
        "periodo": 202508,
        "valor": 512129635047.6562,
        "delta": 2539567664.1662
      },
      {
        "periodo": 202509,
        "valor": 525164446166.2037,
        "delta": 13034811118.5475
      },
      {
        "periodo": 202510,
        "valor": 527795556454.5262,
        "delta": 2631110288.3225
      },
      {
        "periodo": 202511,
        "valor": 520550326441.9013,
        "delta": -7245230012.6249
      },
      {
        "periodo": 202512,
        "valor": 514558664298.8713,
        "delta": -5991662143.03
      },
      {
        "periodo": 202601,
        "valor": 524855907624.0,
        "delta": 10297243325.1287
      },
      {
        "periodo": 202602,
        "valor": 676149912352.085,
        "delta": 151294004728.085
      },
      {
        "periodo": 202603,
        "valor": 674973997431.9425,
        "delta": -1175914920.1425
      },
      {
        "periodo": 202604,
        "valor": 673383744047.5526,
        "delta": -1590253384.3899
      },
      {
        "periodo": 202605,
        "valor": 681091513911.6312,
        "delta": 7707769864.0786
      },
      {
        "periodo": 202606,
        "valor": 687712745411.7638,
        "delta": 6621231500.1326
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 2430998313001.484,
    "valor_anterior": 2402495885724.395,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2247771360994.2764,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2296525319423.2173,
        "delta": 48753958428.9409
      },
      {
        "periodo": 202508,
        "valor": 2293709391494.685,
        "delta": -2815927928.5322
      },
      {
        "periodo": 202509,
        "valor": 2300589473776.7173,
        "delta": 6880082282.0322
      },
      {
        "periodo": 202510,
        "valor": 2341111537001.214,
        "delta": 40522063224.4966
      },
      {
        "periodo": 202511,
        "valor": 2353291425765.0825,
        "delta": 12179888763.8687
      },
      {
        "periodo": 202512,
        "valor": 2301663343410.191,
        "delta": -51628082354.8916
      },
      {
        "periodo": 202601,
        "valor": 2342319120894.137,
        "delta": 40655777483.9463
      },
      {
        "periodo": 202602,
        "valor": 2332658300338.2896,
        "delta": -9660820555.8477
      },
      {
        "periodo": 202603,
        "valor": 2352193474320.7964,
        "delta": 19535173982.5068
      },
      {
        "periodo": 202604,
        "valor": 2354298306259.146,
        "delta": 2104831938.3496
      },
      {
        "periodo": 202605,
        "valor": 2402495885724.395,
        "delta": 48197579465.249
      },
      {
        "periodo": 202606,
        "valor": 2430998313001.484,
        "delta": 28502427277.0889
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 946889250936.6075,
    "valor_anterior": 986498667837.3475,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 956922367219.3989,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 931945221005.9425,
        "delta": -24977146213.4564
      },
      {
        "periodo": 202508,
        "valor": 965577911818.7362,
        "delta": 33632690812.7937
      },
      {
        "periodo": 202509,
        "valor": 959613390048.3538,
        "delta": -5964521770.3824
      },
      {
        "periodo": 202510,
        "valor": 954858066984.6063,
        "delta": -4755323063.7474
      },
      {
        "periodo": 202511,
        "valor": 963909484029.925,
        "delta": 9051417045.3187
      },
      {
        "periodo": 202512,
        "valor": 954880550881.1238,
        "delta": -9028933148.8013
      },
      {
        "periodo": 202601,
        "valor": 946742756700.3325,
        "delta": -8137794180.7913
      },
      {
        "periodo": 202602,
        "valor": 953579657188.4224,
        "delta": 6836900488.0898
      },
      {
        "periodo": 202603,
        "valor": 956045769672.9263,
        "delta": 2466112484.5039
      },
      {
        "periodo": 202604,
        "valor": 963250276004.6562,
        "delta": 7204506331.73
      },
      {
        "periodo": 202605,
        "valor": 986498667837.3475,
        "delta": 23248391832.6913
      },
      {
        "periodo": 202606,
        "valor": 946889250936.6075,
        "delta": -39609416900.74
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 556710417553.4489,
    "valor_anterior": 568565857400.9326,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 586470232547.7662,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 581243236248.8538,
        "delta": -5226996298.9125
      },
      {
        "periodo": 202508,
        "valor": 581070492178.0525,
        "delta": -172744070.8013
      },
      {
        "periodo": 202509,
        "valor": 581370115358.33,
        "delta": 299623180.2775
      },
      {
        "periodo": 202510,
        "valor": 572383873413.8162,
        "delta": -8986241944.5138
      },
      {
        "periodo": 202511,
        "valor": 568419112935.54,
        "delta": -3964760478.2761
      },
      {
        "periodo": 202512,
        "valor": 568864841536.0438,
        "delta": 445728600.5038
      },
      {
        "periodo": 202601,
        "valor": 569037217797.4637,
        "delta": 172376261.4199
      },
      {
        "periodo": 202602,
        "valor": 574086784715.32,
        "delta": 5049566917.8562
      },
      {
        "periodo": 202603,
        "valor": 573976653790.3726,
        "delta": -110130924.9474
      },
      {
        "periodo": 202604,
        "valor": 572113244869.4926,
        "delta": -1863408920.88
      },
      {
        "periodo": 202605,
        "valor": 568565857400.9326,
        "delta": -3547387468.5599
      },
      {
        "periodo": 202606,
        "valor": 556710417553.4489,
        "delta": -11855439847.4838
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 281114258397.4,
    "valor_anterior": 276123837472.5262,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 274283526272.8638,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 275366331960.15,
        "delta": 1082805687.2862
      },
      {
        "periodo": 202508,
        "valor": 261459612855.1362,
        "delta": -13906719105.0138
      },
      {
        "periodo": 202509,
        "valor": 260503409160.1687,
        "delta": -956203694.9675
      },
      {
        "periodo": 202510,
        "valor": 263350714579.4462,
        "delta": 2847305419.2775
      },
      {
        "periodo": 202511,
        "valor": 267524072677.4387,
        "delta": 4173358097.9925
      },
      {
        "periodo": 202512,
        "valor": 274224476580.7775,
        "delta": 6700403903.3388
      },
      {
        "periodo": 202601,
        "valor": 268750872666.5388,
        "delta": -5473603914.2387
      },
      {
        "periodo": 202602,
        "valor": 268289482581.1175,
        "delta": -461390085.4213
      },
      {
        "periodo": 202603,
        "valor": 274698087224.9575,
        "delta": 6408604643.84
      },
      {
        "periodo": 202604,
        "valor": 273409971214.3363,
        "delta": -1288116010.6212
      },
      {
        "periodo": 202605,
        "valor": 276123837472.5262,
        "delta": 2713866258.1899
      },
      {
        "periodo": 202606,
        "valor": 281114258397.4,
        "delta": 4990420924.8738
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 701354740905.7238,
    "valor_anterior": 694995915012.7476,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 642341327771.435,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 650550914957.1136,
        "delta": 8209587185.6786
      },
      {
        "periodo": 202508,
        "valor": 648675590404.8901,
        "delta": -1875324552.2235
      },
      {
        "periodo": 202509,
        "valor": 653505321175.0074,
        "delta": 4829730770.1173
      },
      {
        "periodo": 202510,
        "valor": 663543436103.7238,
        "delta": 10038114928.7163
      },
      {
        "periodo": 202511,
        "valor": 661933358369.5775,
        "delta": -1610077734.1462
      },
      {
        "periodo": 202512,
        "valor": 673746491031.9026,
        "delta": 11813132662.3251
      },
      {
        "periodo": 202601,
        "valor": 683246036971.8438,
        "delta": 9499545939.9412
      },
      {
        "periodo": 202602,
        "valor": 690901768312.205,
        "delta": 7655731340.3612
      },
      {
        "periodo": 202603,
        "valor": 694029693612.3962,
        "delta": 3127925300.1913
      },
      {
        "periodo": 202604,
        "valor": 691869122541.4863,
        "delta": -2160571070.9099
      },
      {
        "periodo": 202605,
        "valor": 694995915012.7476,
        "delta": 3126792471.2612
      },
      {
        "periodo": 202606,
        "valor": 701354740905.7238,
        "delta": 6358825892.9762
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 105616516219.7112,
    "valor_anterior": 104816841885.8575,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 89856120044.88,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 91170838635.2925,
        "delta": 1314718590.4125
      },
      {
        "periodo": 202508,
        "valor": 95892695666.7575,
        "delta": 4721857031.465
      },
      {
        "periodo": 202509,
        "valor": 95327192060.49,
        "delta": -565503606.2675
      },
      {
        "periodo": 202510,
        "valor": 96353782791.755,
        "delta": 1026590731.265
      },
      {
        "periodo": 202511,
        "valor": 98963527326.195,
        "delta": 2609744534.44
      },
      {
        "periodo": 202512,
        "valor": 96513919775.685,
        "delta": -2449607550.51
      },
      {
        "periodo": 202601,
        "valor": 98242426095.0462,
        "delta": 1728506319.3612
      },
      {
        "periodo": 202602,
        "valor": 99008861515.2888,
        "delta": 766435420.2426
      },
      {
        "periodo": 202603,
        "valor": 99832061415.1675,
        "delta": 823199899.8787
      },
      {
        "periodo": 202604,
        "valor": 100645066218.2837,
        "delta": 813004803.1162
      },
      {
        "periodo": 202605,
        "valor": 104816841885.8575,
        "delta": 4171775667.5738
      },
      {
        "periodo": 202606,
        "valor": 105616516219.7112,
        "delta": 799674333.8537
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 473117323490.1937,
    "valor_anterior": 475347626461.3163,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 471618406064.0988,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 472026351331.5113,
        "delta": 407945267.4125
      },
      {
        "periodo": 202508,
        "valor": 475971516853.6888,
        "delta": 3945165522.1775
      },
      {
        "periodo": 202509,
        "valor": 467199745478.2762,
        "delta": -8771771375.4126
      },
      {
        "periodo": 202510,
        "valor": 472734860877.1563,
        "delta": 5535115398.8801
      },
      {
        "periodo": 202511,
        "valor": 472805376368.1037,
        "delta": 70515490.9474
      },
      {
        "periodo": 202512,
        "valor": 465427244297.6388,
        "delta": -7378132070.4649
      },
      {
        "periodo": 202601,
        "valor": 474354202832.4125,
        "delta": 8926958534.7737
      },
      {
        "periodo": 202602,
        "valor": 466567230553.3162,
        "delta": -7786972279.0963
      },
      {
        "periodo": 202603,
        "valor": 460521624940.6,
        "delta": -6045605612.7162
      },
      {
        "periodo": 202604,
        "valor": 469380651325.6112,
        "delta": 8859026385.0112
      },
      {
        "periodo": 202605,
        "valor": 475347626461.3163,
        "delta": 5966975135.7051
      },
      {
        "periodo": 202606,
        "valor": 473117323490.1937,
        "delta": -2230302971.1226
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 168888632149.0125,
    "valor_anterior": 169765557926.7488,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 167565839166.6375,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 167818235331.1075,
        "delta": 252396164.47
      },
      {
        "periodo": 202508,
        "valor": 169887467078.6288,
        "delta": 2069231747.5213
      },
      {
        "periodo": 202509,
        "valor": 172449054273.2375,
        "delta": 2561587194.6087
      },
      {
        "periodo": 202510,
        "valor": 171949049047.7975,
        "delta": -500005225.44
      },
      {
        "periodo": 202511,
        "valor": 172464441212.7212,
        "delta": 515392164.9237
      },
      {
        "periodo": 202512,
        "valor": 171036344374.8725,
        "delta": -1428096837.8487
      },
      {
        "periodo": 202601,
        "valor": 173267684481.3812,
        "delta": 2231340106.5087
      },
      {
        "periodo": 202602,
        "valor": 167317655975.8475,
        "delta": -5950028505.5337
      },
      {
        "periodo": 202603,
        "valor": 165353457986.945,
        "delta": -1964197988.9025
      },
      {
        "periodo": 202604,
        "valor": 168601718198.7875,
        "delta": 3248260211.8425
      },
      {
        "periodo": 202605,
        "valor": 169765557926.7488,
        "delta": 1163839727.9613
      },
      {
        "periodo": 202606,
        "valor": 168888632149.0125,
        "delta": -876925777.7363
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 72288927671.135,
    "valor_anterior": 72549593817.6788,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 61151227548.925,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 63082625166.38,
        "delta": 1931397617.455
      },
      {
        "periodo": 202508,
        "valor": 64298110285.2512,
        "delta": 1215485118.8712
      },
      {
        "periodo": 202509,
        "valor": 65612566400.0388,
        "delta": 1314456114.7876
      },
      {
        "periodo": 202510,
        "valor": 65984893967.2538,
        "delta": 372327567.215
      },
      {
        "periodo": 202511,
        "valor": 67025665332.58,
        "delta": 1040771365.3262
      },
      {
        "periodo": 202512,
        "valor": 64780552801.9188,
        "delta": -2245112530.6612
      },
      {
        "periodo": 202601,
        "valor": 67467862912.9275,
        "delta": 2687310111.0087
      },
      {
        "periodo": 202602,
        "valor": 68734465767.1388,
        "delta": 1266602854.2113
      },
      {
        "periodo": 202603,
        "valor": 69915524547.54,
        "delta": 1181058780.4012
      },
      {
        "periodo": 202604,
        "valor": 69186408367.4262,
        "delta": -729116180.1138
      },
      {
        "periodo": 202605,
        "valor": 72549593817.6788,
        "delta": 3363185450.2526
      },
      {
        "periodo": 202606,
        "valor": 72288927671.135,
        "delta": -260666146.5438
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 34434576348.6862,
    "valor_anterior": 35299099522.0225,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 32265893005.7625,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 34771570584.3512,
        "delta": 2505677578.5887
      },
      {
        "periodo": 202508,
        "valor": 36196629079.7688,
        "delta": 1425058495.4176
      },
      {
        "periodo": 202509,
        "valor": 35288385129.52,
        "delta": -908243950.2488
      },
      {
        "periodo": 202510,
        "valor": 35340674755.2575,
        "delta": 52289625.7375
      },
      {
        "periodo": 202511,
        "valor": 37283558279.0888,
        "delta": 1942883523.8313
      },
      {
        "periodo": 202512,
        "valor": 36583389208.9512,
        "delta": -700169070.1376
      },
      {
        "periodo": 202601,
        "valor": 35817773020.3088,
        "delta": -765616188.6424
      },
      {
        "periodo": 202602,
        "valor": 35991994536.7188,
        "delta": 174221516.41
      },
      {
        "periodo": 202603,
        "valor": 34853087637.2925,
        "delta": -1138906899.4263
      },
      {
        "periodo": 202604,
        "valor": 35303287408.1088,
        "delta": 450199770.8163
      },
      {
        "periodo": 202605,
        "valor": 35299099522.0225,
        "delta": -4187886.0863
      },
      {
        "periodo": 202606,
        "valor": 34434576348.6862,
        "delta": -864523173.3363
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 74813649685.4575,
    "valor_anterior": 78196546161.9125,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 78309216690.9175,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 77937234471.2975,
        "delta": -371982219.62
      },
      {
        "periodo": 202508,
        "valor": 78328770357.2888,
        "delta": 391535885.9913
      },
      {
        "periodo": 202509,
        "valor": 78684227908.7538,
        "delta": 355457551.465
      },
      {
        "periodo": 202510,
        "valor": 77961378128.1488,
        "delta": -722849780.605
      },
      {
        "periodo": 202511,
        "valor": 79615851392.11,
        "delta": 1654473263.9612
      },
      {
        "periodo": 202512,
        "valor": 75455847516.7788,
        "delta": -4160003875.3312
      },
      {
        "periodo": 202601,
        "valor": 76698909678.2512,
        "delta": 1243062161.4724
      },
      {
        "periodo": 202602,
        "valor": 76287437674.275,
        "delta": -411472003.9762
      },
      {
        "periodo": 202603,
        "valor": 75581903200.1375,
        "delta": -705534474.1375
      },
      {
        "periodo": 202604,
        "valor": 76591870867.6025,
        "delta": 1009967667.465
      },
      {
        "periodo": 202605,
        "valor": 78196546161.9125,
        "delta": 1604675294.31
      },
      {
        "periodo": 202606,
        "valor": 74813649685.4575,
        "delta": -3382896476.455
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 1118135737339.4563,
    "valor_anterior": 1111726993916.7827,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1018122414816.8188,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1014142110803.3824,
        "delta": -3980304013.4364
      },
      {
        "periodo": 202508,
        "valor": 1030194734016.7177,
        "delta": 16052623213.3352
      },
      {
        "periodo": 202509,
        "valor": 1030639389143.8563,
        "delta": 444655127.1387
      },
      {
        "periodo": 202510,
        "valor": 1043798631656.0625,
        "delta": 13159242512.2062
      },
      {
        "periodo": 202511,
        "valor": 1049134491692.9475,
        "delta": 5335860036.885
      },
      {
        "periodo": 202512,
        "valor": 1046652538554.4564,
        "delta": -2481953138.4911
      },
      {
        "periodo": 202601,
        "valor": 1100812405262.53,
        "delta": 54159866708.0736
      },
      {
        "periodo": 202602,
        "valor": 1100270359685.4875,
        "delta": -542045577.0425
      },
      {
        "periodo": 202603,
        "valor": 1115506809836.1238,
        "delta": 15236450150.6362
      },
      {
        "periodo": 202604,
        "valor": 1107418461160.426,
        "delta": -8088348675.6978
      },
      {
        "periodo": 202605,
        "valor": 1111726993916.7827,
        "delta": 4308532756.3567
      },
      {
        "periodo": 202606,
        "valor": 1118135737339.4563,
        "delta": 6408743422.6736
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 132692123952.705,
    "valor_anterior": 131363747746.7425,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 130135387114.62,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 126917700249.435,
        "delta": -3217686865.185
      },
      {
        "periodo": 202508,
        "valor": 137073697433.2513,
        "delta": 10155997183.8163
      },
      {
        "periodo": 202509,
        "valor": 133221031057.3562,
        "delta": -3852666375.8951
      },
      {
        "periodo": 202510,
        "valor": 131658812849.2225,
        "delta": -1562218208.1337
      },
      {
        "periodo": 202511,
        "valor": 130619017680.7188,
        "delta": -1039795168.5037
      },
      {
        "periodo": 202512,
        "valor": 126118849904.8238,
        "delta": -4500167775.895
      },
      {
        "periodo": 202601,
        "valor": 121800371194.5062,
        "delta": -4318478710.3176
      },
      {
        "periodo": 202602,
        "valor": 128117678751.12,
        "delta": 6317307556.6138
      },
      {
        "periodo": 202603,
        "valor": 127645154283.9962,
        "delta": -472524467.1238
      },
      {
        "periodo": 202604,
        "valor": 126038726100.8138,
        "delta": -1606428183.1824
      },
      {
        "periodo": 202605,
        "valor": 131363747746.7425,
        "delta": 5325021645.9287
      },
      {
        "periodo": 202606,
        "valor": 132692123952.705,
        "delta": 1328376205.9625
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 19156112024.6525,
    "valor_anterior": 22521806516.1488,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 18335018441.9425,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18898842307.2938,
        "delta": 563823865.3513
      },
      {
        "periodo": 202508,
        "valor": 19719298310.3488,
        "delta": 820456003.055
      },
      {
        "periodo": 202509,
        "valor": 18742385539.1325,
        "delta": -976912771.2163
      },
      {
        "periodo": 202510,
        "valor": 22035531223.5388,
        "delta": 3293145684.4063
      },
      {
        "periodo": 202511,
        "valor": 22638845733.1675,
        "delta": 603314509.6287
      },
      {
        "periodo": 202512,
        "valor": 20582631312.2612,
        "delta": -2056214420.9063
      },
      {
        "periodo": 202601,
        "valor": 20375824337.1688,
        "delta": -206806975.0924
      },
      {
        "periodo": 202602,
        "valor": 22599444967.455,
        "delta": 2223620630.2862
      },
      {
        "periodo": 202603,
        "valor": 22556369831.5712,
        "delta": -43075135.8838
      },
      {
        "periodo": 202604,
        "valor": 22332382793.8125,
        "delta": -223987037.7587
      },
      {
        "periodo": 202605,
        "valor": 22521806516.1488,
        "delta": 189423722.3363
      },
      {
        "periodo": 202606,
        "valor": 19156112024.6525,
        "delta": -3365694491.4963
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 85837587658.3825,
    "valor_anterior": 88830361519.4538,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 81512244917.9325,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 80446260760.4375,
        "delta": -1065984157.495
      },
      {
        "periodo": 202508,
        "valor": 81180798647.9712,
        "delta": 734537887.5337
      },
      {
        "periodo": 202509,
        "valor": 81095155305.2188,
        "delta": -85643342.7524
      },
      {
        "periodo": 202510,
        "valor": 83785713108.815,
        "delta": 2690557803.5962
      },
      {
        "periodo": 202511,
        "valor": 82841423549.0225,
        "delta": -944289559.7925
      },
      {
        "periodo": 202512,
        "valor": 77332576178.4512,
        "delta": -5508847370.5713
      },
      {
        "periodo": 202601,
        "valor": 82868893857.1138,
        "delta": 5536317678.6626
      },
      {
        "periodo": 202602,
        "valor": 90461051707.0838,
        "delta": 7592157849.97
      },
      {
        "periodo": 202603,
        "valor": 86963003656.0375,
        "delta": -3498048051.0463
      },
      {
        "periodo": 202604,
        "valor": 88211231589.5838,
        "delta": 1248227933.5463
      },
      {
        "periodo": 202605,
        "valor": 88830361519.4538,
        "delta": 619129929.87
      },
      {
        "periodo": 202606,
        "valor": 85837587658.3825,
        "delta": -2992773861.0713
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 92444130742.8162,
    "valor_anterior": 88550022881.32,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 83637508033.5962,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 86479395441.8488,
        "delta": 2841887408.2526
      },
      {
        "periodo": 202508,
        "valor": 86493609416.8188,
        "delta": 14213974.97
      },
      {
        "periodo": 202509,
        "valor": 84352173036.63,
        "delta": -2141436380.1888
      },
      {
        "periodo": 202510,
        "valor": 84271260167.2888,
        "delta": -80912869.3412
      },
      {
        "periodo": 202511,
        "valor": 85690037570.7788,
        "delta": 1418777403.49
      },
      {
        "periodo": 202512,
        "valor": 91725083190.8738,
        "delta": 6035045620.095
      },
      {
        "periodo": 202601,
        "valor": 92435501389.77,
        "delta": 710418198.8962
      },
      {
        "periodo": 202602,
        "valor": 92785607704.04,
        "delta": 350106314.27
      },
      {
        "periodo": 202603,
        "valor": 90898782051.235,
        "delta": -1886825652.805
      },
      {
        "periodo": 202604,
        "valor": 91624636269.4838,
        "delta": 725854218.2488
      },
      {
        "periodo": 202605,
        "valor": 88550022881.32,
        "delta": -3074613388.1638
      },
      {
        "periodo": 202606,
        "valor": 92444130742.8162,
        "delta": 3894107861.4962
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 53736435386.66,
    "valor_anterior": 52458149167.765,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 50297873026.8175,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 49633293360.0812,
        "delta": -664579666.7363
      },
      {
        "periodo": 202508,
        "valor": 49734993736.3838,
        "delta": 101700376.3026
      },
      {
        "periodo": 202509,
        "valor": 51371874226.6238,
        "delta": 1636880490.24
      },
      {
        "periodo": 202510,
        "valor": 51180773334.8138,
        "delta": -191100891.81
      },
      {
        "periodo": 202511,
        "valor": 53042626044.5212,
        "delta": 1861852709.7074
      },
      {
        "periodo": 202512,
        "valor": 52342908501.2912,
        "delta": -699717543.23
      },
      {
        "periodo": 202601,
        "valor": 52315396023.275,
        "delta": -27512478.0162
      },
      {
        "periodo": 202602,
        "valor": 52213130867.5388,
        "delta": -102265155.7362
      },
      {
        "periodo": 202603,
        "valor": 54295970511.81,
        "delta": 2082839644.2712
      },
      {
        "periodo": 202604,
        "valor": 52697069790.8138,
        "delta": -1598900720.9962
      },
      {
        "periodo": 202605,
        "valor": 52458149167.765,
        "delta": -238920623.0488
      },
      {
        "periodo": 202606,
        "valor": 53736435386.66,
        "delta": 1278286218.895
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 318350194242.9113,
    "valor_anterior": 313715084100.93,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 327877892795.8175,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 323590912222.6213,
        "delta": -4286980573.1962
      },
      {
        "periodo": 202508,
        "valor": 329177289367.9338,
        "delta": 5586377145.3125
      },
      {
        "periodo": 202509,
        "valor": 321732225279.9212,
        "delta": -7445064088.0126
      },
      {
        "periodo": 202510,
        "valor": 329170583283.23,
        "delta": 7438358003.3088
      },
      {
        "periodo": 202511,
        "valor": 331336526554.7938,
        "delta": 2165943271.5638
      },
      {
        "periodo": 202512,
        "valor": 308507266907.6837,
        "delta": -22829259647.1101
      },
      {
        "periodo": 202601,
        "valor": 316863927019.455,
        "delta": 8356660111.7713
      },
      {
        "periodo": 202602,
        "valor": 333876774431.8125,
        "delta": 17012847412.3575
      },
      {
        "periodo": 202603,
        "valor": 325074791574.8963,
        "delta": -8801982856.9162
      },
      {
        "periodo": 202604,
        "valor": 330500302024.6413,
        "delta": 5425510449.745
      },
      {
        "periodo": 202605,
        "valor": 313715084100.93,
        "delta": -16785217923.7113
      },
      {
        "periodo": 202606,
        "valor": 318350194242.9113,
        "delta": 4635110141.9813
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 915837808.48,
    "valor_anterior": 879291347.8988,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1408170362.1325,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1425030115.9488,
        "delta": 16859753.8163
      },
      {
        "periodo": 202508,
        "valor": 1327976523.4138,
        "delta": -97053592.535
      },
      {
        "periodo": 202509,
        "valor": 1205486002.79,
        "delta": -122490520.6238
      },
      {
        "periodo": 202510,
        "valor": 1251431646.1662,
        "delta": 45945643.3762
      },
      {
        "periodo": 202511,
        "valor": 1145702157.1012,
        "delta": -105729489.065
      },
      {
        "periodo": 202512,
        "valor": 1149632635.8088,
        "delta": 3930478.7076
      },
      {
        "periodo": 202601,
        "valor": 1099819997.1375,
        "delta": -49812638.6713
      },
      {
        "periodo": 202602,
        "valor": 1069080356.0875,
        "delta": -30739641.05
      },
      {
        "periodo": 202603,
        "valor": 1007409903.7175,
        "delta": -61670452.37
      },
      {
        "periodo": 202604,
        "valor": 995715228.3525,
        "delta": -11694675.365
      },
      {
        "periodo": 202605,
        "valor": 879291347.8988,
        "delta": -116423880.4537
      },
      {
        "periodo": 202606,
        "valor": 915837808.48,
        "delta": 36546460.5812
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 334032473926.4563,
    "valor_anterior": 336089504020.165,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 311340742777.7712,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 320252065558.9262,
        "delta": 8911322781.155
      },
      {
        "periodo": 202508,
        "valor": 331805922349.9737,
        "delta": 11553856791.0475
      },
      {
        "periodo": 202509,
        "valor": 328636691632.4625,
        "delta": -3169230717.5112
      },
      {
        "periodo": 202510,
        "valor": 329564841658.7988,
        "delta": 928150026.3363
      },
      {
        "periodo": 202511,
        "valor": 335228359606.555,
        "delta": 5663517947.7562
      },
      {
        "periodo": 202512,
        "valor": 334086726255.8875,
        "delta": -1141633350.6675
      },
      {
        "periodo": 202601,
        "valor": 337746747868.6888,
        "delta": 3660021612.8013
      },
      {
        "periodo": 202602,
        "valor": 341509704253.5538,
        "delta": 3762956384.865
      },
      {
        "periodo": 202603,
        "valor": 334485697439.4125,
        "delta": -7024006814.1413
      },
      {
        "periodo": 202604,
        "valor": 331591682178.2187,
        "delta": -2894015261.1938
      },
      {
        "periodo": 202605,
        "valor": 336089504020.165,
        "delta": 4497821841.9463
      },
      {
        "periodo": 202606,
        "valor": 334032473926.4563,
        "delta": -2057030093.7087
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 41743454979.5988,
    "valor_anterior": 39293483122.52,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 11613507808.0025,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 12049940562.5488,
        "delta": 436432754.5463
      },
      {
        "periodo": 202508,
        "valor": 13709347127.8175,
        "delta": 1659406565.2687
      },
      {
        "periodo": 202509,
        "valor": 27990819544.2488,
        "delta": 14281472416.4313
      },
      {
        "periodo": 202510,
        "valor": 28579036652.2,
        "delta": 588217107.9512
      },
      {
        "periodo": 202511,
        "valor": 29591788899.445,
        "delta": 1012752247.245
      },
      {
        "periodo": 202512,
        "valor": 35706077404.9825,
        "delta": 6114288505.5375
      },
      {
        "periodo": 202601,
        "valor": 34542590848.65,
        "delta": -1163486556.3325
      },
      {
        "periodo": 202602,
        "valor": 35067222627.06,
        "delta": 524631778.41
      },
      {
        "periodo": 202603,
        "valor": 37814635415.55,
        "delta": 2747412788.49
      },
      {
        "periodo": 202604,
        "valor": 38740853428.07,
        "delta": 926218012.52
      },
      {
        "periodo": 202605,
        "valor": 39293483122.52,
        "delta": 552629694.45
      },
      {
        "periodo": 202606,
        "valor": 41743454979.5988,
        "delta": 2449971857.0788
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 42756645434.96,
    "valor_anterior": 36342233586.9162,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 38977331267.7412,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 37474345479.64,
        "delta": -1502985788.1012
      },
      {
        "periodo": 202508,
        "valor": 39810268582.8625,
        "delta": 2335923103.2225
      },
      {
        "periodo": 202509,
        "valor": 36667295086.1712,
        "delta": -3142973496.6913
      },
      {
        "periodo": 202510,
        "valor": 36959314029.755,
        "delta": 292018943.5838
      },
      {
        "periodo": 202511,
        "valor": 37235803642.8875,
        "delta": 276489613.1325
      },
      {
        "periodo": 202512,
        "valor": 34957231947.3462,
        "delta": -2278571695.5413
      },
      {
        "periodo": 202601,
        "valor": 38156717951.1425,
        "delta": 3199486003.7963
      },
      {
        "periodo": 202602,
        "valor": 37665310055.4225,
        "delta": -491407895.72
      },
      {
        "periodo": 202603,
        "valor": 41157617843.9525,
        "delta": 3492307788.53
      },
      {
        "periodo": 202604,
        "valor": 41356028931.5112,
        "delta": 198411087.5587
      },
      {
        "periodo": 202605,
        "valor": 36342233586.9162,
        "delta": -5013795344.595
      },
      {
        "periodo": 202606,
        "valor": 42756645434.96,
        "delta": 6414411848.0438
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 60753762589.9662,
    "valor_anterior": 59232197913.305,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 56121945718.6088,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 59110494934.5075,
        "delta": 2988549215.8987
      },
      {
        "periodo": 202508,
        "valor": 59810844497.68,
        "delta": 700349563.1725
      },
      {
        "periodo": 202509,
        "valor": 58574009166.8925,
        "delta": -1236835330.7875
      },
      {
        "periodo": 202510,
        "valor": 59008033055.3362,
        "delta": 434023888.4437
      },
      {
        "periodo": 202511,
        "valor": 61199978583.9188,
        "delta": 2191945528.5826
      },
      {
        "periodo": 202512,
        "valor": 60329654701.56,
        "delta": -870323882.3588
      },
      {
        "periodo": 202601,
        "valor": 58572567295.305,
        "delta": -1757087406.255
      },
      {
        "periodo": 202602,
        "valor": 60088990264.5012,
        "delta": 1516422969.1962
      },
      {
        "periodo": 202603,
        "valor": 61239415608.3575,
        "delta": 1150425343.8563
      },
      {
        "periodo": 202604,
        "valor": 59481632786.195,
        "delta": -1757782822.1625
      },
      {
        "periodo": 202605,
        "valor": 59232197913.305,
        "delta": -249434872.89
      },
      {
        "periodo": 202606,
        "valor": 60753762589.9662,
        "delta": 1521564676.6612
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 84832157657.645,
    "valor_anterior": 80712678292.4337,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 66544439931.7212,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 67857104344.5262,
        "delta": 1312664412.805
      },
      {
        "periodo": 202508,
        "valor": 67362671281.4212,
        "delta": -494433063.105
      },
      {
        "periodo": 202509,
        "valor": 70445910486.8825,
        "delta": 3083239205.4613
      },
      {
        "periodo": 202510,
        "valor": 73284052300.4612,
        "delta": 2838141813.5787
      },
      {
        "periodo": 202511,
        "valor": 72964826394.3,
        "delta": -319225906.1612
      },
      {
        "periodo": 202512,
        "valor": 77489443061.4125,
        "delta": 4524616667.1125
      },
      {
        "periodo": 202601,
        "valor": 75462470585.7988,
        "delta": -2026972475.6137
      },
      {
        "periodo": 202602,
        "valor": 76236915402.265,
        "delta": 774444816.4662
      },
      {
        "periodo": 202603,
        "valor": 74914325076.3762,
        "delta": -1322590325.8888
      },
      {
        "periodo": 202604,
        "valor": 78933643992.3362,
        "delta": 4019318915.96
      },
      {
        "periodo": 202605,
        "valor": 80712678292.4337,
        "delta": 1779034300.0975
      },
      {
        "periodo": 202606,
        "valor": 84832157657.645,
        "delta": 4119479365.2113
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 36453728910.5112,
    "valor_anterior": 35478314344.0988,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 34177757121.0275,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 34464394095.6612,
        "delta": 286636974.6337
      },
      {
        "periodo": 202508,
        "valor": 35841839181.2825,
        "delta": 1377445085.6213
      },
      {
        "periodo": 202509,
        "valor": 35073963506.2162,
        "delta": -767875675.0663
      },
      {
        "periodo": 202510,
        "valor": 35660661882.7675,
        "delta": 586698376.5513
      },
      {
        "periodo": 202511,
        "valor": 37412484040.3,
        "delta": 1751822157.5325
      },
      {
        "periodo": 202512,
        "valor": 37013673302.0812,
        "delta": -398810738.2188
      },
      {
        "periodo": 202601,
        "valor": 36940476354.3812,
        "delta": -73196947.7
      },
      {
        "periodo": 202602,
        "valor": 36710619904.205,
        "delta": -229856450.1762
      },
      {
        "periodo": 202603,
        "valor": 36810937633.9912,
        "delta": 100317729.7862
      },
      {
        "periodo": 202604,
        "valor": 36120821296.3775,
        "delta": -690116337.6137
      },
      {
        "periodo": 202605,
        "valor": 35478314344.0988,
        "delta": -642506952.2787
      },
      {
        "periodo": 202606,
        "valor": 36453728910.5112,
        "delta": 975414566.4124
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 11986284451.52,
    "valor_anterior": 13570000771.2612,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 63380554015.025,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 42357021807.5038,
        "delta": -21023532207.5212
      },
      {
        "periodo": 202508,
        "valor": 32628591055.28,
        "delta": -9728430752.2238
      },
      {
        "periodo": 202509,
        "valor": 18538915229.1362,
        "delta": -14089675826.1438
      },
      {
        "periodo": 202510,
        "valor": 17670150154.2162,
        "delta": -868765074.92
      },
      {
        "periodo": 202511,
        "valor": 17230372867.1862,
        "delta": -439777287.03
      },
      {
        "periodo": 202512,
        "valor": 16752564910.105,
        "delta": -477807957.0812
      },
      {
        "periodo": 202601,
        "valor": 15419545629.4312,
        "delta": -1333019280.6738
      },
      {
        "periodo": 202602,
        "valor": 15195721117.8612,
        "delta": -223824511.57
      },
      {
        "periodo": 202603,
        "valor": 14449023203.2925,
        "delta": -746697914.5687
      },
      {
        "periodo": 202604,
        "valor": 13991259827.5738,
        "delta": -457763375.7187
      },
      {
        "periodo": 202605,
        "valor": 13570000771.2612,
        "delta": -421259056.3126
      },
      {
        "periodo": 202606,
        "valor": 11986284451.52,
        "delta": -1583716319.7412
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 141434086356.5175,
    "valor_anterior": 150149008088.315,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 122606024348.025,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 123864415201.8725,
        "delta": 1258390853.8475
      },
      {
        "periodo": 202508,
        "valor": 139624222515.415,
        "delta": 15759807313.5425
      },
      {
        "periodo": 202509,
        "valor": 134310548123.7712,
        "delta": -5313674391.6438
      },
      {
        "periodo": 202510,
        "valor": 138064220956.77,
        "delta": 3753672832.9988
      },
      {
        "periodo": 202511,
        "valor": 143966292085.4825,
        "delta": 5902071128.7125
      },
      {
        "periodo": 202512,
        "valor": 141633024701.5313,
        "delta": -2333267383.9512
      },
      {
        "periodo": 202601,
        "valor": 144808642978.4625,
        "delta": 3175618276.9312
      },
      {
        "periodo": 202602,
        "valor": 147397362121.08,
        "delta": 2588719142.6175
      },
      {
        "periodo": 202603,
        "valor": 141527766993.795,
        "delta": -5869595127.285
      },
      {
        "periodo": 202604,
        "valor": 141987784893.4037,
        "delta": 460017899.6087
      },
      {
        "periodo": 202605,
        "valor": 150149008088.315,
        "delta": 8161223194.9113
      },
      {
        "periodo": 202606,
        "valor": 141434086356.5175,
        "delta": -8714921731.7975
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 2579815931.6725,
    "valor_anterior": 2545835886.3,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2041441020.6525,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2080475796.5388,
        "delta": 39034775.8863
      },
      {
        "periodo": 202508,
        "valor": 2107679944.2388,
        "delta": 27204147.7
      },
      {
        "periodo": 202509,
        "valor": 2085943098.7225,
        "delta": -21736845.5163
      },
      {
        "periodo": 202510,
        "valor": 2075896758.97,
        "delta": -10046339.7525
      },
      {
        "periodo": 202511,
        "valor": 2079163262.3725,
        "delta": 3266503.4025
      },
      {
        "periodo": 202512,
        "valor": 2098792861.0988,
        "delta": 19629598.7263
      },
      {
        "periodo": 202601,
        "valor": 2076850349.1488,
        "delta": -21942511.95
      },
      {
        "periodo": 202602,
        "valor": 2185686347.8175,
        "delta": 108835998.6687
      },
      {
        "periodo": 202603,
        "valor": 2391328118.7362,
        "delta": 205641770.9187
      },
      {
        "periodo": 202604,
        "valor": 2659560449.1012,
        "delta": 268232330.365
      },
      {
        "periodo": 202605,
        "valor": 2545835886.3,
        "delta": -113724562.8012
      },
      {
        "periodo": 202606,
        "valor": 2579815931.6725,
        "delta": 33980045.3725
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 11015620539.2488,
    "valor_anterior": 10901020648.2188,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 10100647343.3062,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 8781073435.6125,
        "delta": -1319573907.6937
      },
      {
        "periodo": 202508,
        "valor": 9309061220.8038,
        "delta": 527987785.1913
      },
      {
        "periodo": 202509,
        "valor": 9249808887.215,
        "delta": -59252333.5888
      },
      {
        "periodo": 202510,
        "valor": 10201103578.3375,
        "delta": 951294691.1225
      },
      {
        "periodo": 202511,
        "valor": 10445177821.9075,
        "delta": 244074243.57
      },
      {
        "periodo": 202512,
        "valor": 7672194589.6562,
        "delta": -2772983232.2513
      },
      {
        "periodo": 202601,
        "valor": 8932376572.7012,
        "delta": 1260181983.045
      },
      {
        "periodo": 202602,
        "valor": 10468420378.1962,
        "delta": 1536043805.495
      },
      {
        "periodo": 202603,
        "valor": 9533475886.5262,
        "delta": -934944491.67
      },
      {
        "periodo": 202604,
        "valor": 10642421905.5938,
        "delta": 1108946019.0676
      },
      {
        "periodo": 202605,
        "valor": 10901020648.2188,
        "delta": 258598742.625
      },
      {
        "periodo": 202606,
        "valor": 11015620539.2488,
        "delta": 114599891.03
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 40502399851.2612,
    "valor_anterior": 40319704491.325,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 34117543938.905,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 34595636205.02,
        "delta": 478092266.115
      },
      {
        "periodo": 202508,
        "valor": 35446676655.2612,
        "delta": 851040450.2412
      },
      {
        "periodo": 202509,
        "valor": 35402582704.79,
        "delta": -44093950.4712
      },
      {
        "periodo": 202510,
        "valor": 36327028455.2662,
        "delta": 924445750.4762
      },
      {
        "periodo": 202511,
        "valor": 36227006700.1912,
        "delta": -100021755.075
      },
      {
        "periodo": 202512,
        "valor": 36650612735.4288,
        "delta": 423606035.2376
      },
      {
        "periodo": 202601,
        "valor": 38071474364.66,
        "delta": 1420861629.2312
      },
      {
        "periodo": 202602,
        "valor": 38625574745.08,
        "delta": 554100380.42
      },
      {
        "periodo": 202603,
        "valor": 40092169532.6225,
        "delta": 1466594787.5425
      },
      {
        "periodo": 202604,
        "valor": 40830230196.4725,
        "delta": 738060663.85
      },
      {
        "periodo": 202605,
        "valor": 40319704491.325,
        "delta": -510525705.1475
      },
      {
        "periodo": 202606,
        "valor": 40502399851.2612,
        "delta": 182695359.9362
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 11904195814.01,
    "valor_anterior": 11825224204.7225,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 12615656531.86,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 12823810939.92,
        "delta": 208154408.06
      },
      {
        "periodo": 202508,
        "valor": 12962149071.8312,
        "delta": 138338131.9112
      },
      {
        "periodo": 202509,
        "valor": 12555283436.3725,
        "delta": -406865635.4587
      },
      {
        "periodo": 202510,
        "valor": 12808504186.5675,
        "delta": 253220750.195
      },
      {
        "periodo": 202511,
        "valor": 13105244553.315,
        "delta": 296740366.7475
      },
      {
        "periodo": 202512,
        "valor": 13203164914.9525,
        "delta": 97920361.6375
      },
      {
        "periodo": 202601,
        "valor": 13528374541.8488,
        "delta": 325209626.8963
      },
      {
        "periodo": 202602,
        "valor": 13812929849.6862,
        "delta": 284555307.8374
      },
      {
        "periodo": 202603,
        "valor": 13887936411.1125,
        "delta": 75006561.4263
      },
      {
        "periodo": 202604,
        "valor": 11879156269.5938,
        "delta": -2008780141.5187
      },
      {
        "periodo": 202605,
        "valor": 11825224204.7225,
        "delta": -53932064.8713
      },
      {
        "periodo": 202606,
        "valor": 11904195814.01,
        "delta": 78971609.2875
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 46948223327.7862,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 46018167020.1338,
        "delta": -930056307.6524
      },
      {
        "periodo": 202508,
        "valor": 28865048051.595,
        "delta": -17153118968.5388
      },
      {
        "periodo": 202509,
        "valor": 27408777026.1862,
        "delta": -1456271025.4088
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 36218764767.1162,
    "valor_anterior": 34938880997.66,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 33213758611.9862,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 30835459308.8075,
        "delta": -2378299303.1787
      },
      {
        "periodo": 202508,
        "valor": 32752132243.1775,
        "delta": 1916672934.37
      },
      {
        "periodo": 202509,
        "valor": 32318493942.5125,
        "delta": -433638300.665
      },
      {
        "periodo": 202510,
        "valor": 33599912513.5875,
        "delta": 1281418571.075
      },
      {
        "periodo": 202511,
        "valor": 33901402515.965,
        "delta": 301490002.3775
      },
      {
        "periodo": 202512,
        "valor": 34927050691.4188,
        "delta": 1025648175.4538
      },
      {
        "periodo": 202601,
        "valor": 37600680870.8362,
        "delta": 2673630179.4174
      },
      {
        "periodo": 202602,
        "valor": 35367977525.375,
        "delta": -2232703345.4612
      },
      {
        "periodo": 202603,
        "valor": 33959936996.8675,
        "delta": -1408040528.5075
      },
      {
        "periodo": 202604,
        "valor": 36843062658.125,
        "delta": 2883125661.2575
      },
      {
        "periodo": 202605,
        "valor": 34938880997.66,
        "delta": -1904181660.465
      },
      {
        "periodo": 202606,
        "valor": 36218764767.1162,
        "delta": 1279883769.4562
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 21380467694.4325,
    "valor_anterior": 20798299711.8662,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 13008790266.045,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13628848268.9525,
        "delta": 620058002.9075
      },
      {
        "periodo": 202508,
        "valor": 14259941884.2,
        "delta": 631093615.2475
      },
      {
        "periodo": 202509,
        "valor": 15097208527.4312,
        "delta": 837266643.2312
      },
      {
        "periodo": 202510,
        "valor": 15551083801.2275,
        "delta": 453875273.7963
      },
      {
        "periodo": 202511,
        "valor": 16649385820.0388,
        "delta": 1098302018.8113
      },
      {
        "periodo": 202512,
        "valor": 17388723525.4075,
        "delta": 739337705.3687
      },
      {
        "periodo": 202601,
        "valor": 18395335150.6825,
        "delta": 1006611625.275
      },
      {
        "periodo": 202602,
        "valor": 19163962275.16,
        "delta": 768627124.4775
      },
      {
        "periodo": 202603,
        "valor": 19166795592.0088,
        "delta": 2833316.8488
      },
      {
        "periodo": 202604,
        "valor": 19920660891.6425,
        "delta": 753865299.6337
      },
      {
        "periodo": 202605,
        "valor": 20798299711.8662,
        "delta": 877638820.2237
      },
      {
        "periodo": 202606,
        "valor": 21380467694.4325,
        "delta": 582167982.5663
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 265660506.1388,
    "valor_anterior": 286216040.8925,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 195137539.495,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 202619595.6012,
        "delta": 7482056.1062
      },
      {
        "periodo": 202508,
        "valor": 221220970.9188,
        "delta": 18601375.3176
      },
      {
        "periodo": 202509,
        "valor": 206993478.2038,
        "delta": -14227492.715
      },
      {
        "periodo": 202510,
        "valor": 214105856.2175,
        "delta": 7112378.0137
      },
      {
        "periodo": 202511,
        "valor": 233259630.5888,
        "delta": 19153774.3713
      },
      {
        "periodo": 202512,
        "valor": 231064928.5725,
        "delta": -2194702.0163
      },
      {
        "periodo": 202601,
        "valor": 249126935.8762,
        "delta": 18062007.3037
      },
      {
        "periodo": 202602,
        "valor": 249675272.6888,
        "delta": 548336.8126
      },
      {
        "periodo": 202603,
        "valor": 250537181.02,
        "delta": 861908.3312
      },
      {
        "periodo": 202604,
        "valor": 254663614.2825,
        "delta": 4126433.2625
      },
      {
        "periodo": 202605,
        "valor": 286216040.8925,
        "delta": 31552426.61
      },
      {
        "periodo": 202606,
        "valor": 265660506.1388,
        "delta": -20555534.7537
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 613565342.5512,
    "valor_anterior": 612666079.135,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 453007841.2338,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 473428905.8188,
        "delta": 20421064.585
      },
      {
        "periodo": 202508,
        "valor": 510523128.3038,
        "delta": 37094222.485
      },
      {
        "periodo": 202509,
        "valor": 529472694.8175,
        "delta": 18949566.5137
      },
      {
        "periodo": 202510,
        "valor": 559728710.4012,
        "delta": 30256015.5837
      },
      {
        "periodo": 202511,
        "valor": 572650321.7362,
        "delta": 12921611.335
      },
      {
        "periodo": 202512,
        "valor": 599897204.2138,
        "delta": 27246882.4776
      },
      {
        "periodo": 202601,
        "valor": 605651928.0612,
        "delta": 5754723.8474
      },
      {
        "periodo": 202602,
        "valor": 604161138.0888,
        "delta": -1490789.9724
      },
      {
        "periodo": 202603,
        "valor": 617492528.25,
        "delta": 13331390.1612
      },
      {
        "periodo": 202604,
        "valor": 615361621.9612,
        "delta": -2130906.2888
      },
      {
        "periodo": 202605,
        "valor": 612666079.135,
        "delta": -2695542.8262
      },
      {
        "periodo": 202606,
        "valor": 613565342.5512,
        "delta": 899263.4162
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 15256433696.0475,
    "valor_anterior": 15118543329.4088,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 13650328867.1625,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13600922692.1888,
        "delta": -49406174.9737
      },
      {
        "periodo": 202508,
        "valor": 13925000966.6062,
        "delta": 324078274.4174
      },
      {
        "periodo": 202509,
        "valor": 13891651782.4375,
        "delta": -33349184.1687
      },
      {
        "periodo": 202510,
        "valor": 13969488421.2688,
        "delta": 77836638.8313
      },
      {
        "periodo": 202511,
        "valor": 14021906277.6238,
        "delta": 52417856.355
      },
      {
        "periodo": 202512,
        "valor": 14562084220.3325,
        "delta": 540177942.7087
      },
      {
        "periodo": 202601,
        "valor": 14635869525.9012,
        "delta": 73785305.5687
      },
      {
        "periodo": 202602,
        "valor": 14581214089.26,
        "delta": -54655436.6412
      },
      {
        "periodo": 202603,
        "valor": 14834818151.7188,
        "delta": 253604062.4588
      },
      {
        "periodo": 202604,
        "valor": 15018902218.7012,
        "delta": 184084066.9824
      },
      {
        "periodo": 202605,
        "valor": 15118543329.4088,
        "delta": 99641110.7076
      },
      {
        "periodo": 202606,
        "valor": 15256433696.0475,
        "delta": 137890366.6387
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 1776745541.8638,
    "valor_anterior": 1814010899.475,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1967173728.7325,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1939527318.5575,
        "delta": -27646410.175
      },
      {
        "periodo": 202508,
        "valor": 1858058686.9375,
        "delta": -81468631.62
      },
      {
        "periodo": 202509,
        "valor": 1920143588.9538,
        "delta": 62084902.0163
      },
      {
        "periodo": 202510,
        "valor": 1917194289.045,
        "delta": -2949299.9088
      },
      {
        "periodo": 202511,
        "valor": 1915990241.2862,
        "delta": -1204047.7588
      },
      {
        "periodo": 202512,
        "valor": 1899332930.1162,
        "delta": -16657311.17
      },
      {
        "periodo": 202601,
        "valor": 1750576489.565,
        "delta": -148756440.5512
      },
      {
        "periodo": 202602,
        "valor": 1821200674.3325,
        "delta": 70624184.7675
      },
      {
        "periodo": 202603,
        "valor": 1863110791.515,
        "delta": 41910117.1825
      },
      {
        "periodo": 202604,
        "valor": 1882575486.86,
        "delta": 19464695.345
      },
      {
        "periodo": 202605,
        "valor": 1814010899.475,
        "delta": -68564587.385
      },
      {
        "periodo": 202606,
        "valor": 1776745541.8638,
        "delta": -37265357.6112
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 48929816839.7262,
    "valor_anterior": 48750339831.2388,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 40702948952.06,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 40936845756.56,
        "delta": 233896804.5
      },
      {
        "periodo": 202508,
        "valor": 42927057122.9812,
        "delta": 1990211366.4212
      },
      {
        "periodo": 202509,
        "valor": 42478934071.2312,
        "delta": -448123051.75
      },
      {
        "periodo": 202510,
        "valor": 44069285994.2688,
        "delta": 1590351923.0376
      },
      {
        "periodo": 202511,
        "valor": 44927091861.8038,
        "delta": 857805867.535
      },
      {
        "periodo": 202512,
        "valor": 44703619765.2812,
        "delta": -223472096.5226
      },
      {
        "periodo": 202601,
        "valor": 46605293504.97,
        "delta": 1901673739.6888
      },
      {
        "periodo": 202602,
        "valor": 46393803047.6038,
        "delta": -211490457.3662
      },
      {
        "periodo": 202603,
        "valor": 47064842656.2262,
        "delta": 671039608.6224
      },
      {
        "periodo": 202604,
        "valor": 47984683791.3762,
        "delta": 919841135.15
      },
      {
        "periodo": 202605,
        "valor": 48750339831.2388,
        "delta": 765656039.8626
      },
      {
        "periodo": 202606,
        "valor": 48929816839.7262,
        "delta": 179477008.4874
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 9069964247.4425,
    "valor_anterior": 9769391701.8075,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 7284604847.53,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 7360539705.0262,
        "delta": 75934857.4962
      },
      {
        "periodo": 202508,
        "valor": 7574436804.715,
        "delta": 213897099.6888
      },
      {
        "periodo": 202509,
        "valor": 7830893536.28,
        "delta": 256456731.565
      },
      {
        "periodo": 202510,
        "valor": 8326067050.3075,
        "delta": 495173514.0275
      },
      {
        "periodo": 202511,
        "valor": 8642769484.675,
        "delta": 316702434.3675
      },
      {
        "periodo": 202512,
        "valor": 8735825440.5825,
        "delta": 93055955.9075
      },
      {
        "periodo": 202601,
        "valor": 8920811233.24,
        "delta": 184985792.6575
      },
      {
        "periodo": 202602,
        "valor": 9413464354.7488,
        "delta": 492653121.5088
      },
      {
        "periodo": 202603,
        "valor": 9563170410.205,
        "delta": 149706055.4562
      },
      {
        "periodo": 202604,
        "valor": 9605515305.3088,
        "delta": 42344895.1038
      },
      {
        "periodo": 202605,
        "valor": 9769391701.8075,
        "delta": 163876396.4987
      },
      {
        "periodo": 202606,
        "valor": 9069964247.4425,
        "delta": -699427454.365
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 8235378204.4312,
    "valor_anterior": 7454750943.4275,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 7526920357.7125,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 7420886357.6062,
        "delta": -106034000.1063
      },
      {
        "periodo": 202508,
        "valor": 7685169022.0862,
        "delta": 264282664.48
      },
      {
        "periodo": 202509,
        "valor": 7854960930.6938,
        "delta": 169791908.6076
      },
      {
        "periodo": 202510,
        "valor": 8440397302.8738,
        "delta": 585436372.18
      },
      {
        "periodo": 202511,
        "valor": 8227689076.3225,
        "delta": -212708226.5513
      },
      {
        "periodo": 202512,
        "valor": 8427214243.44,
        "delta": 199525167.1175
      },
      {
        "periodo": 202601,
        "valor": 8271144807.8762,
        "delta": -156069435.5638
      },
      {
        "periodo": 202602,
        "valor": 8357305910.4562,
        "delta": 86161102.58
      },
      {
        "periodo": 202603,
        "valor": 7895294368.2175,
        "delta": -462011542.2387
      },
      {
        "periodo": 202604,
        "valor": 7617937021.8538,
        "delta": -277357346.3637
      },
      {
        "periodo": 202605,
        "valor": 7454750943.4275,
        "delta": -163186078.4263
      },
      {
        "periodo": 202606,
        "valor": 8235378204.4312,
        "delta": 780627261.0037
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 109683985896.9187,
    "valor_anterior": 110467795191.0238,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 98404694041.6888,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 99809138352.855,
        "delta": 1404444311.1662
      },
      {
        "periodo": 202508,
        "valor": 99489391309.6162,
        "delta": -319747043.2388
      },
      {
        "periodo": 202509,
        "valor": 100760120532.5313,
        "delta": 1270729222.9151
      },
      {
        "periodo": 202510,
        "valor": 103991599080.5025,
        "delta": 3231478547.9712
      },
      {
        "periodo": 202511,
        "valor": 105443384641.4475,
        "delta": 1451785560.945
      },
      {
        "periodo": 202512,
        "valor": 104041359439.3263,
        "delta": -1402025202.1212
      },
      {
        "periodo": 202601,
        "valor": 105673893878.2925,
        "delta": 1632534438.9662
      },
      {
        "periodo": 202602,
        "valor": 106101649980.9412,
        "delta": 427756102.6487
      },
      {
        "periodo": 202603,
        "valor": 107055060338.4262,
        "delta": 953410357.485
      },
      {
        "periodo": 202604,
        "valor": 109149961197.5862,
        "delta": 2094900859.16
      },
      {
        "periodo": 202605,
        "valor": 110467795191.0238,
        "delta": 1317833993.4376
      },
      {
        "periodo": 202606,
        "valor": 109683985896.9187,
        "delta": -783809294.1051
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 4985474030.7388,
    "valor_anterior": 4588670887.7925,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4603002987.75,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 5235852083.37,
        "delta": 632849095.62
      },
      {
        "periodo": 202508,
        "valor": 5246581902.17,
        "delta": 10729818.8
      },
      {
        "periodo": 202509,
        "valor": 5016244608.325,
        "delta": -230337293.845
      },
      {
        "periodo": 202510,
        "valor": 5002747077.635,
        "delta": -13497530.69
      },
      {
        "periodo": 202511,
        "valor": 4980048500.145,
        "delta": -22698577.49
      },
      {
        "periodo": 202512,
        "valor": 4799617417.0875,
        "delta": -180431083.0575
      },
      {
        "periodo": 202601,
        "valor": 4806844360.77,
        "delta": 7226943.6825
      },
      {
        "periodo": 202602,
        "valor": 4699685921.6125,
        "delta": -107158439.1575
      },
      {
        "periodo": 202603,
        "valor": 4615594115.6062,
        "delta": -84091806.0063
      },
      {
        "periodo": 202604,
        "valor": 4844496690.0225,
        "delta": 228902574.4163
      },
      {
        "periodo": 202605,
        "valor": 4588670887.7925,
        "delta": -255825802.23
      },
      {
        "periodo": 202606,
        "valor": 4985474030.7388,
        "delta": 396803142.9463
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 5843001331.7988,
    "valor_anterior": 5795625346.7762,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4401602969.2225,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4797682368.9838,
        "delta": 396079399.7613
      },
      {
        "periodo": 202508,
        "valor": 4859377799.87,
        "delta": 61695430.8862
      },
      {
        "periodo": 202509,
        "valor": 4801630188.1475,
        "delta": -57747611.7225
      },
      {
        "periodo": 202510,
        "valor": 4926345891.4712,
        "delta": 124715703.3237
      },
      {
        "periodo": 202511,
        "valor": 3916585072.8838,
        "delta": -1009760818.5874
      },
      {
        "periodo": 202512,
        "valor": 4675378732.2762,
        "delta": 758793659.3924
      },
      {
        "periodo": 202601,
        "valor": 4667371266.2775,
        "delta": -8007465.9987
      },
      {
        "periodo": 202602,
        "valor": 5238917903.51,
        "delta": 571546637.2325
      },
      {
        "periodo": 202603,
        "valor": 5418485055.12,
        "delta": 179567151.61
      },
      {
        "periodo": 202604,
        "valor": 5322692753.96,
        "delta": -95792301.16
      },
      {
        "periodo": 202605,
        "valor": 5795625346.7762,
        "delta": 472932592.8162
      },
      {
        "periodo": 202606,
        "valor": 5843001331.7988,
        "delta": 47375985.0226
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 6027527623.99,
    "valor_anterior": 5317201658.8275,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4842310876.8938,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4780585645.1725,
        "delta": -61725231.7213
      },
      {
        "periodo": 202508,
        "valor": 4847674972.8888,
        "delta": 67089327.7163
      },
      {
        "periodo": 202509,
        "valor": 4681423271.0688,
        "delta": -166251701.82
      },
      {
        "periodo": 202510,
        "valor": 4905657552.8962,
        "delta": 224234281.8274
      },
      {
        "periodo": 202511,
        "valor": 4815570002.4688,
        "delta": -90087550.4274
      },
      {
        "periodo": 202512,
        "valor": 4752139325.7425,
        "delta": -63430676.7263
      },
      {
        "periodo": 202601,
        "valor": 5040098988.115,
        "delta": 287959662.3725
      },
      {
        "periodo": 202602,
        "valor": 4787254833.3825,
        "delta": -252844154.7325
      },
      {
        "periodo": 202603,
        "valor": 4766216066.58,
        "delta": -21038766.8025
      },
      {
        "periodo": 202604,
        "valor": 5084151882.2312,
        "delta": 317935815.6512
      },
      {
        "periodo": 202605,
        "valor": 5317201658.8275,
        "delta": 233049776.5963
      },
      {
        "periodo": 202606,
        "valor": 6027527623.99,
        "delta": 710325965.1625
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 1523710975.9688,
    "valor_anterior": 1534041555.5938,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1306292799.3088,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1356900056.61,
        "delta": 50607257.3012
      },
      {
        "periodo": 202508,
        "valor": 1423128282.9538,
        "delta": 66228226.3438
      },
      {
        "periodo": 202509,
        "valor": 1420341460.1562,
        "delta": -2786822.7976
      },
      {
        "periodo": 202510,
        "valor": 1355211571.0425,
        "delta": -65129889.1137
      },
      {
        "periodo": 202511,
        "valor": 1360914425.4312,
        "delta": 5702854.3887
      },
      {
        "periodo": 202512,
        "valor": 1422331765.625,
        "delta": 61417340.1938
      },
      {
        "periodo": 202601,
        "valor": 1375688914.0588,
        "delta": -46642851.5662
      },
      {
        "periodo": 202602,
        "valor": 1332288237.9,
        "delta": -43400676.1588
      },
      {
        "periodo": 202603,
        "valor": 1936579862.3025,
        "delta": 604291624.4025
      },
      {
        "periodo": 202604,
        "valor": 1357837465.8225,
        "delta": -578742396.48
      },
      {
        "periodo": 202605,
        "valor": 1534041555.5938,
        "delta": 176204089.7713
      },
      {
        "periodo": 202606,
        "valor": 1523710975.9688,
        "delta": -10330579.625
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 4111897927.115,
    "valor_anterior": 3908860044.0662,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4084407132.3038,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4186838217.49,
        "delta": 102431085.1862
      },
      {
        "periodo": 202508,
        "valor": 3852204132.525,
        "delta": -334634084.965
      },
      {
        "periodo": 202509,
        "valor": 3859547054.2912,
        "delta": 7342921.7662
      },
      {
        "periodo": 202510,
        "valor": 3961542255.6712,
        "delta": 101995201.38
      },
      {
        "periodo": 202511,
        "valor": 4065286248.3975,
        "delta": 103743992.7263
      },
      {
        "periodo": 202512,
        "valor": 3975741394.1038,
        "delta": -89544854.2937
      },
      {
        "periodo": 202601,
        "valor": 3848532803.8838,
        "delta": -127208590.22
      },
      {
        "periodo": 202602,
        "valor": 3931926526.19,
        "delta": 83393722.3062
      },
      {
        "periodo": 202603,
        "valor": 4053881358.32,
        "delta": 121954832.13
      },
      {
        "periodo": 202604,
        "valor": 4094582752.8338,
        "delta": 40701394.5138
      },
      {
        "periodo": 202605,
        "valor": 3908860044.0662,
        "delta": -185722708.7676
      },
      {
        "periodo": 202606,
        "valor": 4111897927.115,
        "delta": 203037883.0488
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 8539450856.4662,
    "valor_anterior": 9115225902.1562,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 8772114050.5788,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 8346000725.64,
        "delta": -426113324.9388
      },
      {
        "periodo": 202508,
        "valor": 7491522437.965,
        "delta": -854478287.675
      },
      {
        "periodo": 202509,
        "valor": 8039016390.8925,
        "delta": 547493952.9275
      },
      {
        "periodo": 202510,
        "valor": 7455726272.88,
        "delta": -583290118.0125
      },
      {
        "periodo": 202511,
        "valor": 8618674377.855,
        "delta": 1162948104.975
      },
      {
        "periodo": 202512,
        "valor": 8701720797.31,
        "delta": 83046419.455
      },
      {
        "periodo": 202601,
        "valor": 6892704625.4812,
        "delta": -1809016171.8288
      },
      {
        "periodo": 202602,
        "valor": 8356543525.42,
        "delta": 1463838899.9388
      },
      {
        "periodo": 202603,
        "valor": 8189303981.305,
        "delta": -167239544.115
      },
      {
        "periodo": 202604,
        "valor": 10036848587.5,
        "delta": 1847544606.195
      },
      {
        "periodo": 202605,
        "valor": 9115225902.1562,
        "delta": -921622685.3438
      },
      {
        "periodo": 202606,
        "valor": 8539450856.4662,
        "delta": -575775045.69
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 310009466.3112,
    "valor_anterior": 308781346.7662,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 342526482.1638,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 342791002.8288,
        "delta": 264520.665
      },
      {
        "periodo": 202508,
        "valor": 327648548.6738,
        "delta": -15142454.155
      },
      {
        "periodo": 202509,
        "valor": 339441847.7412,
        "delta": 11793299.0674
      },
      {
        "periodo": 202510,
        "valor": 333181487.0912,
        "delta": -6260360.65
      },
      {
        "periodo": 202511,
        "valor": 300005616.48,
        "delta": -33175870.6112
      },
      {
        "periodo": 202512,
        "valor": 334935365.2812,
        "delta": 34929748.8012
      },
      {
        "periodo": 202601,
        "valor": 325859042.1025,
        "delta": -9076323.1787
      },
      {
        "periodo": 202602,
        "valor": 351368631.5575,
        "delta": 25509589.455
      },
      {
        "periodo": 202603,
        "valor": 332097701.7938,
        "delta": -19270929.7637
      },
      {
        "periodo": 202604,
        "valor": 321044568.1938,
        "delta": -11053133.6
      },
      {
        "periodo": 202605,
        "valor": 308781346.7662,
        "delta": -12263221.4276
      },
      {
        "periodo": 202606,
        "valor": 310009466.3112,
        "delta": 1228119.545
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 13372352056.7788,
    "valor_anterior": 13282100418.84,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 337940395.1962,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 349147320.6288,
        "delta": 11206925.4326
      },
      {
        "periodo": 202508,
        "valor": 358954380.3875,
        "delta": 9807059.7587
      },
      {
        "periodo": 202509,
        "valor": 352613363.4762,
        "delta": -6341016.9113
      },
      {
        "periodo": 202510,
        "valor": 358808666.6738,
        "delta": 6195303.1976
      },
      {
        "periodo": 202511,
        "valor": 359446213.6125,
        "delta": 637546.9387
      },
      {
        "periodo": 202512,
        "valor": 353760332.745,
        "delta": -5685880.8675
      },
      {
        "periodo": 202601,
        "valor": 314244225.405,
        "delta": -39516107.34
      },
      {
        "periodo": 202602,
        "valor": 10434430201.8725,
        "delta": 10120185976.4675
      },
      {
        "periodo": 202603,
        "valor": 12406547250.1925,
        "delta": 1972117048.32
      },
      {
        "periodo": 202604,
        "valor": 13207369889.705,
        "delta": 800822639.5125
      },
      {
        "periodo": 202605,
        "valor": 13282100418.84,
        "delta": 74730529.135
      },
      {
        "periodo": 202606,
        "valor": 13372352056.7788,
        "delta": 90251637.9388
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 6415146585.5312,
    "valor_anterior": 6354634738.9312,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1008535341.3275,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1279624752.5212,
        "delta": 271089411.1937
      },
      {
        "periodo": 202508,
        "valor": 1786148097.385,
        "delta": 506523344.8638
      },
      {
        "periodo": 202509,
        "valor": 2225368487.8525,
        "delta": 439220390.4675
      },
      {
        "periodo": 202510,
        "valor": 2865444018.93,
        "delta": 640075531.0775
      },
      {
        "periodo": 202511,
        "valor": 3372801246.7075,
        "delta": 507357227.7775
      },
      {
        "periodo": 202512,
        "valor": 4097216855.0612,
        "delta": 724415608.3537
      },
      {
        "periodo": 202601,
        "valor": 4635806966.7925,
        "delta": 538590111.7313
      },
      {
        "periodo": 202602,
        "valor": 5284534991.84,
        "delta": 648728025.0475
      },
      {
        "periodo": 202603,
        "valor": 7065976700.6025,
        "delta": 1781441708.7625
      },
      {
        "periodo": 202604,
        "valor": 6163484761.475,
        "delta": -902491939.1275
      },
      {
        "periodo": 202605,
        "valor": 6354634738.9312,
        "delta": 191149977.4562
      },
      {
        "periodo": 202606,
        "valor": 6415146585.5312,
        "delta": 60511846.6
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 1488029547.3738,
    "valor_anterior": 1393002578.3338,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 296401808.8962,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 555859757.8475,
        "delta": 259457948.9513
      },
      {
        "periodo": 202601,
        "valor": 767112641.9175,
        "delta": 211252884.07
      },
      {
        "periodo": 202602,
        "valor": 946365093.5138,
        "delta": 179252451.5963
      },
      {
        "periodo": 202603,
        "valor": 898173640.3662,
        "delta": -48191453.1476
      },
      {
        "periodo": 202604,
        "valor": 1399822160.4875,
        "delta": 501648520.1213
      },
      {
        "periodo": 202605,
        "valor": 1393002578.3338,
        "delta": -6819582.1537
      },
      {
        "periodo": 202606,
        "valor": 1488029547.3738,
        "delta": 95026969.04
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 19479672453.6638,
    "valor_anterior": 22572260607.7638,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 14458693003.235,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 24219578564.03,
        "delta": 9760885560.795
      },
      {
        "periodo": 202605,
        "valor": 22572260607.7638,
        "delta": -1647317956.2662
      },
      {
        "periodo": 202606,
        "valor": 19479672453.6638,
        "delta": -3092588154.1
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 9498729192962.46,
    "valor_anterior": 9496432905513.521,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 8881978245342.07,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 8902174075577.387,
        "delta": 20195830235.3164
      },
      {
        "periodo": 202508,
        "valor": 8978780714803.203,
        "delta": 76606639225.8164
      },
      {
        "periodo": 202509,
        "valor": 8968232094212.736,
        "delta": -10548620590.4668
      },
      {
        "periodo": 202510,
        "valor": 9032526932857.277,
        "delta": 64294838644.541
      },
      {
        "periodo": 202511,
        "valor": 9083542632955.541,
        "delta": 51015700098.2637
      },
      {
        "periodo": 202512,
        "valor": 8988925188418.219,
        "delta": -94617444537.3223
      },
      {
        "periodo": 202601,
        "valor": 9129014394255.924,
        "delta": 140089205837.7051
      },
      {
        "periodo": 202602,
        "valor": 9333348867182.832,
        "delta": 204334472926.9082
      },
      {
        "periodo": 202603,
        "valor": 9370640564344.064,
        "delta": 37291697161.2324
      },
      {
        "periodo": 202604,
        "valor": 9401012502318.824,
        "delta": 30371937974.7598
      },
      {
        "periodo": 202605,
        "valor": 9496432905513.521,
        "delta": 95420403194.6973
      },
      {
        "periodo": 202606,
        "valor": 9498729192962.46,
        "delta": 2296287448.9395
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 6914918528638.678,
    "valor_anterior": 6920722460265.152,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 6428650414680.401,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 6456023221153.511,
        "delta": 27372806473.1094
      },
      {
        "periodo": 202508,
        "valor": 6507329271814.427,
        "delta": 51306050660.916
      },
      {
        "periodo": 202509,
        "valor": 6518081881146.744,
        "delta": 10752609332.3174
      },
      {
        "periodo": 202510,
        "valor": 6576225962491.105,
        "delta": 58144081344.3613
      },
      {
        "periodo": 202511,
        "valor": 6590043575603.077,
        "delta": 13817613111.9717
      },
      {
        "periodo": 202512,
        "valor": 6525793674010.228,
        "delta": -64249901592.8496
      },
      {
        "periodo": 202601,
        "valor": 6641367648082.72,
        "delta": 115573974072.4922
      },
      {
        "periodo": 202602,
        "valor": 6794214013145.126,
        "delta": 152846365062.4062
      },
      {
        "periodo": 202603,
        "valor": 6827248023605.158,
        "delta": 33034010460.0322
      },
      {
        "periodo": 202604,
        "valor": 6831713806208.371,
        "delta": 4465782603.2129
      },
      {
        "periodo": 202605,
        "valor": 6920722460265.152,
        "delta": 89008654056.7812
      },
      {
        "periodo": 202606,
        "valor": 6914918528638.678,
        "delta": -5803931626.4746
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 140649179961.4524,
    "valor_anterior": 137058904650.2412,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 227180043988.3936,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 205690043578.2939,
        "delta": -21490000410.0997
      },
      {
        "periodo": 202508,
        "valor": 180739380766.8713,
        "delta": -24950662811.4226
      },
      {
        "periodo": 202509,
        "valor": 162618359234.4649,
        "delta": -18121021532.4064
      },
      {
        "periodo": 202510,
        "valor": 135541322835.0925,
        "delta": -27077036399.3724
      },
      {
        "periodo": 202511,
        "valor": 136821812953.93,
        "delta": 1280490118.8375
      },
      {
        "periodo": 202512,
        "valor": 143404698792.3976,
        "delta": 6582885838.4676
      },
      {
        "periodo": 202601,
        "valor": 145455727890.0374,
        "delta": 2051029097.6398
      },
      {
        "periodo": 202602,
        "valor": 143349306347.2762,
        "delta": -2106421542.7612
      },
      {
        "periodo": 202603,
        "valor": 139307742251.395,
        "delta": -4041564095.8812
      },
      {
        "periodo": 202604,
        "valor": 142458958755.1826,
        "delta": 3151216503.7876
      },
      {
        "periodo": 202605,
        "valor": 137058904650.2412,
        "delta": -5400054104.9414
      },
      {
        "periodo": 202606,
        "valor": 140649179961.4524,
        "delta": 3590275311.2112
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 768155521356.5063,
    "valor_anterior": 766235168944.5427,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 758080680872.7175,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 748459544586.5176,
        "delta": -9621136286.2
      },
      {
        "periodo": 202508,
        "valor": 769361142420.9628,
        "delta": 20901597834.4452
      },
      {
        "periodo": 202509,
        "valor": 755876532795.85,
        "delta": -13484609625.1128
      },
      {
        "periodo": 202510,
        "valor": 768033805514.6075,
        "delta": 12157272718.7576
      },
      {
        "periodo": 202511,
        "valor": 773116862298.1638,
        "delta": 5083056783.5563
      },
      {
        "periodo": 202512,
        "valor": 726911901286.2362,
        "delta": -46204961011.9276
      },
      {
        "periodo": 202601,
        "valor": 742782223995.82,
        "delta": 15870322709.5837
      },
      {
        "periodo": 202602,
        "valor": 779218171124.6001,
        "delta": 36435947128.7802
      },
      {
        "periodo": 202603,
        "valor": 769811671753.0024,
        "delta": -9406499371.5977
      },
      {
        "periodo": 202604,
        "valor": 777504437476.9426,
        "delta": 7692765723.9402
      },
      {
        "periodo": 202605,
        "valor": 766235168944.5427,
        "delta": -11269268532.3999
      },
      {
        "periodo": 202606,
        "valor": 768155521356.5063,
        "delta": 1920352411.9636
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 803871985707.3474,
    "valor_anterior": 794344859936.355,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 746952492484.6088,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 751654941984.0125,
        "delta": 4702449499.4037
      },
      {
        "periodo": 202508,
        "valor": 743826831927.9437,
        "delta": -7828110056.0687
      },
      {
        "periodo": 202509,
        "valor": 750857560739.9338,
        "delta": 7030728811.9901
      },
      {
        "periodo": 202510,
        "valor": 760109971134.7762,
        "delta": 9252410394.8424
      },
      {
        "periodo": 202511,
        "valor": 770402878296.6237,
        "delta": 10292907161.8474
      },
      {
        "periodo": 202512,
        "valor": 775648451733.365,
        "delta": 5245573436.7413
      },
      {
        "periodo": 202601,
        "valor": 773712743730.3325,
        "delta": -1935708003.0325
      },
      {
        "periodo": 202602,
        "valor": 769167696322.9988,
        "delta": -4545047407.3337
      },
      {
        "periodo": 202603,
        "valor": 776148962553.6824,
        "delta": 6981266230.6836
      },
      {
        "periodo": 202604,
        "valor": 783437430612.1437,
        "delta": 7288468058.4613
      },
      {
        "periodo": 202605,
        "valor": 794344859936.355,
        "delta": 10907429324.2113
      },
      {
        "periodo": 202606,
        "valor": 803871985707.3474,
        "delta": 9527125770.9924
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 240828283308.055,
    "valor_anterior": 235932427229.6275,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 182170689940.8576,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 187254909453.0075,
        "delta": 5084219512.1499
      },
      {
        "periodo": 202508,
        "valor": 194890998628.0875,
        "delta": 7636089175.08
      },
      {
        "periodo": 202509,
        "valor": 207871748837.5675,
        "delta": 12980750209.48
      },
      {
        "periodo": 202510,
        "valor": 212726079685.86,
        "delta": 4854330848.2925
      },
      {
        "periodo": 202511,
        "valor": 218529317066.8515,
        "delta": 5803237380.9915
      },
      {
        "periodo": 202512,
        "valor": 225321609771.4836,
        "delta": 6792292704.6321
      },
      {
        "periodo": 202601,
        "valor": 226319568703.77,
        "delta": 997958932.2864
      },
      {
        "periodo": 202602,
        "valor": 228344258952.0576,
        "delta": 2024690248.2876
      },
      {
        "periodo": 202603,
        "valor": 231112197371.0874,
        "delta": 2767938419.0298
      },
      {
        "periodo": 202604,
        "valor": 234200721376.4475,
        "delta": 3088524005.3601
      },
      {
        "periodo": 202605,
        "valor": 235932427229.6275,
        "delta": 1731705853.18
      },
      {
        "periodo": 202606,
        "valor": 240828283308.055,
        "delta": 4895856078.4275
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 4030249,
    "label": "APR Totales Jun 2026",
    "valor_actual": 630305693990.4211,
    "valor_anterior": 642139084487.6025,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 538943923375.0913,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 553091414822.0438,
        "delta": 14147491446.9525
      },
      {
        "periodo": 202508,
        "valor": 582633089244.9113,
        "delta": 29541674422.8674
      },
      {
        "periodo": 202509,
        "valor": 572926011458.1761,
        "delta": -9707077786.7351
      },
      {
        "periodo": 202510,
        "valor": 579889791195.835,
        "delta": 6963779737.6588
      },
      {
        "periodo": 202511,
        "valor": 594628186736.8949,
        "delta": 14738395541.0599
      },
      {
        "periodo": 202512,
        "valor": 591844852824.5088,
        "delta": -2783333912.3861
      },
      {
        "periodo": 202601,
        "valor": 599376481853.2438,
        "delta": 7531629028.735
      },
      {
        "periodo": 202602,
        "valor": 619055421290.7738,
        "delta": 19678939437.53
      },
      {
        "periodo": 202603,
        "valor": 627011966809.74,
        "delta": 7956545518.9662
      },
      {
        "periodo": 202604,
        "valor": 631697147889.7362,
        "delta": 4685181079.9962
      },
      {
        "periodo": 202605,
        "valor": 642139084487.6025,
        "delta": 10441936597.8663
      },
      {
        "periodo": 202606,
        "valor": 630305693990.4211,
        "delta": -11833390497.1814
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 1143122555593.45,
    "valor_anterior": 1135864970821.73,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1106121083342.89,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1110881542823.68,
        "delta": 4760459480.79
      },
      {
        "periodo": 202509,
        "valor": 1117474403892.36,
        "delta": 6592861068.6802
      },
      {
        "periodo": 202510,
        "valor": 1130516409214.34,
        "delta": 13042005321.98
      },
      {
        "periodo": 202511,
        "valor": 1171971668767.33,
        "delta": 41455259552.99
      },
      {
        "periodo": 202512,
        "valor": 1112198222181.92,
        "delta": -59773446585.4102
      },
      {
        "periodo": 202601,
        "valor": 1144543431835.73,
        "delta": 32345209653.8101
      },
      {
        "periodo": 202602,
        "valor": 1107992405081.01,
        "delta": -36551026754.72
      },
      {
        "periodo": 202603,
        "valor": 1107994707701.36,
        "delta": 2302620.3501
      },
      {
        "periodo": 202604,
        "valor": 1103394214754.4,
        "delta": -4600492946.9602
      },
      {
        "periodo": 202605,
        "valor": 1138283733181.96,
        "delta": 34889518427.5601
      },
      {
        "periodo": 202606,
        "valor": 1135864970821.73,
        "delta": -2418762360.23
      },
      {
        "periodo": 202607,
        "valor": 1143122555593.45,
        "delta": 7257584771.72
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 3718387688610.15,
    "valor_anterior": 3620603292501.3906,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3340530363466.21,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3334146876303.82,
        "delta": -6383487162.3901
      },
      {
        "periodo": 202509,
        "valor": 3371171773794.74,
        "delta": 37024897490.9204
      },
      {
        "periodo": 202510,
        "valor": 3395282871655.03,
        "delta": 24111097860.2896
      },
      {
        "periodo": 202511,
        "valor": 3434060734543.79,
        "delta": 38777862888.7603
      },
      {
        "periodo": 202512,
        "valor": 3437869002825.6,
        "delta": 3808268281.8101
      },
      {
        "periodo": 202601,
        "valor": 3475935940677.05,
        "delta": 38066937851.4497
      },
      {
        "periodo": 202602,
        "valor": 3552020082596.27,
        "delta": 76084141919.2202
      },
      {
        "periodo": 202603,
        "valor": 3547437583182.12,
        "delta": -4582499414.1499
      },
      {
        "periodo": 202604,
        "valor": 3615173177595.26,
        "delta": 67735594413.1396
      },
      {
        "periodo": 202605,
        "valor": 3800500223154.45,
        "delta": 185327045559.1904
      },
      {
        "periodo": 202606,
        "valor": 3620603292501.3906,
        "delta": -179896930653.0596
      },
      {
        "periodo": 202607,
        "valor": 3718387688610.15,
        "delta": 97784396108.7593
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 2184742650436.0,
    "valor_anterior": 2133142886922.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1974060019404.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1991916736797.0,
        "delta": 17856717393.0
      },
      {
        "periodo": 202509,
        "valor": 2019417317332.0,
        "delta": 27500580535.0
      },
      {
        "periodo": 202510,
        "valor": 2081302440807.0,
        "delta": 61885123475.0
      },
      {
        "periodo": 202511,
        "valor": 2063071560875.0,
        "delta": -18230879932.0
      },
      {
        "periodo": 202512,
        "valor": 2074455103481.0,
        "delta": 11383542606.0
      },
      {
        "periodo": 202601,
        "valor": 2082647715256.0,
        "delta": 8192611775.0
      },
      {
        "periodo": 202602,
        "valor": 2095811135202.0,
        "delta": 13163419946.0
      },
      {
        "periodo": 202603,
        "valor": 2125492603601.0,
        "delta": 29681468399.0
      },
      {
        "periodo": 202604,
        "valor": 2096525763163.0,
        "delta": -28966840438.0
      },
      {
        "periodo": 202605,
        "valor": 2262783328044.0,
        "delta": 166257564881.0
      },
      {
        "periodo": 202606,
        "valor": 2133142886922.0,
        "delta": -129640441122.0
      },
      {
        "periodo": 202607,
        "valor": 2184742650436.0,
        "delta": 51599763514.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 835505009708.0,
    "valor_anterior": 857749595105.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 907745985295.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 890120350636.0,
        "delta": -17625634659.0
      },
      {
        "periodo": 202509,
        "valor": 897782351816.0,
        "delta": 7662001180.0
      },
      {
        "periodo": 202510,
        "valor": 945159480853.0,
        "delta": 47377129037.0
      },
      {
        "periodo": 202511,
        "valor": 876317462528.0,
        "delta": -68842018325.0
      },
      {
        "periodo": 202512,
        "valor": 873286790631.0,
        "delta": -3030671897.0
      },
      {
        "periodo": 202601,
        "valor": 885450641767.0,
        "delta": 12163851136.0
      },
      {
        "periodo": 202602,
        "valor": 864157075690.0,
        "delta": -21293566077.0
      },
      {
        "periodo": 202603,
        "valor": 858962917315.0,
        "delta": -5194158375.0
      },
      {
        "periodo": 202604,
        "valor": 853932581782.0,
        "delta": -5030335533.0
      },
      {
        "periodo": 202605,
        "valor": 878091879667.0,
        "delta": 24159297885.0
      },
      {
        "periodo": 202606,
        "valor": 857749595105.0,
        "delta": -20342284562.0
      },
      {
        "periodo": 202607,
        "valor": 835505009708.0,
        "delta": -22244585397.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 410066668811.05,
    "valor_anterior": 411128054445.43,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 374884012461.1,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 382977702740.66,
        "delta": 8093690279.56
      },
      {
        "periodo": 202509,
        "valor": 383294546790.68,
        "delta": 316844050.02
      },
      {
        "periodo": 202510,
        "valor": 380695225337.23,
        "delta": -2599321453.45
      },
      {
        "periodo": 202511,
        "valor": 380964373371.86,
        "delta": 269148034.63
      },
      {
        "periodo": 202512,
        "valor": 392969601771.42,
        "delta": 12005228399.56
      },
      {
        "periodo": 202601,
        "valor": 380649587164.14,
        "delta": -12320014607.28
      },
      {
        "periodo": 202602,
        "valor": 384661393052.59,
        "delta": 4011805888.45
      },
      {
        "periodo": 202603,
        "valor": 405366604496.05,
        "delta": 20705211443.46
      },
      {
        "periodo": 202604,
        "valor": 402590179804.97,
        "delta": -2776424691.08
      },
      {
        "periodo": 202605,
        "valor": 402657451896.47,
        "delta": 67272091.5
      },
      {
        "periodo": 202606,
        "valor": 411128054445.43,
        "delta": 8470602548.96
      },
      {
        "periodo": 202607,
        "valor": 410066668811.05,
        "delta": -1061385634.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 722320901151.0,
    "valor_anterior": 725567801099.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 698989330739.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 704687724683.0,
        "delta": 5698393944.0
      },
      {
        "periodo": 202509,
        "valor": 706596951915.0,
        "delta": 1909227232.0
      },
      {
        "periodo": 202510,
        "valor": 696895392474.0,
        "delta": -9701559441.0
      },
      {
        "periodo": 202511,
        "valor": 709724585519.0,
        "delta": 12829193045.0
      },
      {
        "periodo": 202512,
        "valor": 701330694189.0,
        "delta": -8393891330.0
      },
      {
        "periodo": 202601,
        "valor": 710170484636.0,
        "delta": 8839790447.0
      },
      {
        "periodo": 202602,
        "valor": 710291216633.0,
        "delta": 120731997.0
      },
      {
        "periodo": 202603,
        "valor": 708685242898.9999,
        "delta": -1605973734.0001
      },
      {
        "periodo": 202604,
        "valor": 732483025233.0,
        "delta": 23797782334.0001
      },
      {
        "periodo": 202605,
        "valor": 716342547111.0,
        "delta": -16140478122.0
      },
      {
        "periodo": 202606,
        "valor": 725567801099.0,
        "delta": 9225253988.0
      },
      {
        "periodo": 202607,
        "valor": 722320901151.0,
        "delta": -3246899948.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 194371308185.0,
    "valor_anterior": 190425730187.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 165161845408.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 173495753764.0,
        "delta": 8333908356.0
      },
      {
        "periodo": 202509,
        "valor": 171474221671.0,
        "delta": -2021532093.0
      },
      {
        "periodo": 202510,
        "valor": 169504010166.0,
        "delta": -1970211505.0
      },
      {
        "periodo": 202511,
        "valor": 171919652346.0,
        "delta": 2415642180.0
      },
      {
        "periodo": 202512,
        "valor": 171132422503.0,
        "delta": -787229843.0
      },
      {
        "periodo": 202601,
        "valor": 186533209812.0,
        "delta": 15400787309.0
      },
      {
        "periodo": 202602,
        "valor": 187027250629.0,
        "delta": 494040817.0
      },
      {
        "periodo": 202603,
        "valor": 191803558356.0,
        "delta": 4776307727.0
      },
      {
        "periodo": 202604,
        "valor": 194252838554.0,
        "delta": 2449280198.0
      },
      {
        "periodo": 202605,
        "valor": 196096875720.0,
        "delta": 1844037166.0
      },
      {
        "periodo": 202606,
        "valor": 190425730187.0,
        "delta": -5671145533.0
      },
      {
        "periodo": 202607,
        "valor": 194371308185.0,
        "delta": 3945577998.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 903749119552.0,
    "valor_anterior": 908094344910.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 861735428670.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 871850277085.0,
        "delta": 10114848415.0
      },
      {
        "periodo": 202509,
        "valor": 893048679669.0,
        "delta": 21198402584.0
      },
      {
        "periodo": 202510,
        "valor": 920096025782.0,
        "delta": 27047346113.0
      },
      {
        "periodo": 202511,
        "valor": 887743553762.0,
        "delta": -32352472020.0
      },
      {
        "periodo": 202512,
        "valor": 893214389487.0,
        "delta": 5470835725.0
      },
      {
        "periodo": 202601,
        "valor": 882353442972.0,
        "delta": -10860946515.0
      },
      {
        "periodo": 202602,
        "valor": 902290485440.0,
        "delta": 19937042468.0
      },
      {
        "periodo": 202603,
        "valor": 899327790144.0,
        "delta": -2962695296.0
      },
      {
        "periodo": 202604,
        "valor": 895042825326.0,
        "delta": -4284964818.0
      },
      {
        "periodo": 202605,
        "valor": 947769721476.9999,
        "delta": 52726896150.9999
      },
      {
        "periodo": 202606,
        "valor": 908094344910.0,
        "delta": -39675376566.9999
      },
      {
        "periodo": 202607,
        "valor": 903749119552.0,
        "delta": -4345225358.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 281089649636.67,
    "valor_anterior": 279396488169.65,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 263015489805.08,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 266573665720.51,
        "delta": 3558175915.43
      },
      {
        "periodo": 202509,
        "valor": 271942669146.19,
        "delta": 5369003425.68
      },
      {
        "periodo": 202510,
        "valor": 273668728794.1,
        "delta": 1726059647.91
      },
      {
        "periodo": 202511,
        "valor": 277608826565.3,
        "delta": 3940097771.2
      },
      {
        "periodo": 202512,
        "valor": 278376243738.56,
        "delta": 767417173.26
      },
      {
        "periodo": 202601,
        "valor": 282339286406.65,
        "delta": 3963042668.09
      },
      {
        "periodo": 202602,
        "valor": 272555341422.76,
        "delta": -9783944983.89
      },
      {
        "periodo": 202603,
        "valor": 274531303256.52,
        "delta": 1975961833.76
      },
      {
        "periodo": 202604,
        "valor": 274399860004.06,
        "delta": -131443252.46
      },
      {
        "periodo": 202605,
        "valor": 280358529081.93,
        "delta": 5958669077.87
      },
      {
        "periodo": 202606,
        "valor": 279396488169.65,
        "delta": -962040912.28
      },
      {
        "periodo": 202607,
        "valor": 281089649636.67,
        "delta": 1693161467.02
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 218826723503.0,
    "valor_anterior": 218774533547.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 207918739631.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 192841682346.0,
        "delta": -15077057285.0
      },
      {
        "periodo": 202509,
        "valor": 187127195817.0,
        "delta": -5714486529.0
      },
      {
        "periodo": 202510,
        "valor": 201048862764.0,
        "delta": 13921666947.0
      },
      {
        "periodo": 202511,
        "valor": 200479370118.0,
        "delta": -569492646.0
      },
      {
        "periodo": 202512,
        "valor": 200658932232.0,
        "delta": 179562114.0
      },
      {
        "periodo": 202601,
        "valor": 208973734055.0,
        "delta": 8314801823.0
      },
      {
        "periodo": 202602,
        "valor": 215250113127.0,
        "delta": 6276379072.0
      },
      {
        "periodo": 202603,
        "valor": 214168341641.0,
        "delta": -1081771486.0
      },
      {
        "periodo": 202604,
        "valor": 209399917165.0,
        "delta": -4768424476.0
      },
      {
        "periodo": 202605,
        "valor": 226107040451.0,
        "delta": 16707123286.0
      },
      {
        "periodo": 202606,
        "valor": 218774533547.0,
        "delta": -7332506904.0
      },
      {
        "periodo": 202607,
        "valor": 218826723503.0,
        "delta": 52189956.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 62935186258.0,
    "valor_anterior": 65354139546.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 73508827636.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 75334731719.0,
        "delta": 1825904083.0
      },
      {
        "periodo": 202509,
        "valor": 72179339018.0,
        "delta": -3155392701.0
      },
      {
        "periodo": 202510,
        "valor": 71536244815.0,
        "delta": -643094203.0
      },
      {
        "periodo": 202511,
        "valor": 71222062847.0,
        "delta": -314181968.0
      },
      {
        "periodo": 202512,
        "valor": 66386312250.0,
        "delta": -4835750597.0
      },
      {
        "periodo": 202601,
        "valor": 64025570024.0,
        "delta": -2360742226.0
      },
      {
        "periodo": 202602,
        "valor": 67254889335.0,
        "delta": 3229319311.0
      },
      {
        "periodo": 202603,
        "valor": 66253041248.0,
        "delta": -1001848087.0
      },
      {
        "periodo": 202604,
        "valor": 67470109072.0,
        "delta": 1217067824.0
      },
      {
        "periodo": 202605,
        "valor": 64761848159.0,
        "delta": -2708260913.0
      },
      {
        "periodo": 202606,
        "valor": 65354139546.0,
        "delta": 592291387.0
      },
      {
        "periodo": 202607,
        "valor": 62935186258.0,
        "delta": -2418953288.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 302072515376.0,
    "valor_anterior": 279695969709.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 311426655631.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 314172381854.0,
        "delta": 2745726223.0
      },
      {
        "periodo": 202509,
        "valor": 317026410095.0,
        "delta": 2854028241.0
      },
      {
        "periodo": 202510,
        "valor": 307371561379.0,
        "delta": -9654848716.0
      },
      {
        "periodo": 202511,
        "valor": 309829484500.0,
        "delta": 2457923121.0
      },
      {
        "periodo": 202512,
        "valor": 306153451078.0,
        "delta": -3676033422.0
      },
      {
        "periodo": 202601,
        "valor": 311769692552.0,
        "delta": 5616241474.0
      },
      {
        "periodo": 202602,
        "valor": 292354212473.0,
        "delta": -19415480079.0
      },
      {
        "periodo": 202603,
        "valor": 293661391293.0,
        "delta": 1307178820.0
      },
      {
        "periodo": 202604,
        "valor": 285996133161.0,
        "delta": -7665258132.0
      },
      {
        "periodo": 202605,
        "valor": 284139783992.0,
        "delta": -1856349169.0
      },
      {
        "periodo": 202606,
        "valor": 279695969709.0,
        "delta": -4443814283.0
      },
      {
        "periodo": 202607,
        "valor": 302072515376.0,
        "delta": 22376545667.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 2019614485892.17,
    "valor_anterior": 1985187340043.16,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1887469391753.48,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1862911980975.46,
        "delta": -24557410778.02
      },
      {
        "periodo": 202509,
        "valor": 1868293116711.87,
        "delta": 5381135736.4102
      },
      {
        "periodo": 202510,
        "valor": 1879859057261.9,
        "delta": 11565940550.0298
      },
      {
        "periodo": 202511,
        "valor": 1909321356843.69,
        "delta": 29462299581.79
      },
      {
        "periodo": 202512,
        "valor": 1966229952922.41,
        "delta": 56908596078.72
      },
      {
        "periodo": 202601,
        "valor": 1964093972548.3,
        "delta": -2135980374.1099
      },
      {
        "periodo": 202602,
        "valor": 1950945564755.02,
        "delta": -13148407793.28
      },
      {
        "periodo": 202603,
        "valor": 1983244982444.64,
        "delta": 32299417689.6199
      },
      {
        "periodo": 202604,
        "valor": 1945363607595.71,
        "delta": -37881374848.9299
      },
      {
        "periodo": 202605,
        "valor": 1994912244980.4998,
        "delta": 49548637384.7898
      },
      {
        "periodo": 202606,
        "valor": 1985187340043.16,
        "delta": -9724904937.3398
      },
      {
        "periodo": 202607,
        "valor": 2019614485892.17,
        "delta": 34427145849.01
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 125278045684.0,
    "valor_anterior": 136136620055.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 192687761534.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 203787474187.0,
        "delta": 11099712653.0
      },
      {
        "periodo": 202509,
        "valor": 132893634549.0,
        "delta": -70893839638.0
      },
      {
        "periodo": 202510,
        "valor": 231615536717.0,
        "delta": 98721902168.0
      },
      {
        "periodo": 202511,
        "valor": 196544282110.0,
        "delta": -35071254607.0
      },
      {
        "periodo": 202512,
        "valor": 120911730639.0,
        "delta": -75632551471.0
      },
      {
        "periodo": 202601,
        "valor": 167256964787.0,
        "delta": 46345234148.0
      },
      {
        "periodo": 202602,
        "valor": 178929854467.0,
        "delta": 11672889680.0
      },
      {
        "periodo": 202603,
        "valor": 159863297389.0,
        "delta": -19066557078.0
      },
      {
        "periodo": 202604,
        "valor": 164005030292.0,
        "delta": 4141732903.0
      },
      {
        "periodo": 202605,
        "valor": 195577136523.0,
        "delta": 31572106231.0
      },
      {
        "periodo": 202606,
        "valor": 136136620055.0,
        "delta": -59440516468.0
      },
      {
        "periodo": 202607,
        "valor": 125278045684.0,
        "delta": -10858574371.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 45756928491.0,
    "valor_anterior": 46372359331.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40442347176.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 40467075251.0,
        "delta": 24728075.0
      },
      {
        "periodo": 202509,
        "valor": 41992127607.0,
        "delta": 1525052356.0
      },
      {
        "periodo": 202510,
        "valor": 42513082068.0,
        "delta": 520954461.0
      },
      {
        "periodo": 202511,
        "valor": 49185475077.0,
        "delta": 6672393009.0
      },
      {
        "periodo": 202512,
        "valor": 43133519290.0,
        "delta": -6051955787.0
      },
      {
        "periodo": 202601,
        "valor": 43978397302.0,
        "delta": 844878012.0
      },
      {
        "periodo": 202602,
        "valor": 48554165143.0,
        "delta": 4575767841.0
      },
      {
        "periodo": 202603,
        "valor": 45318715381.0,
        "delta": -3235449762.0
      },
      {
        "periodo": 202604,
        "valor": 47938329385.0,
        "delta": 2619614004.0
      },
      {
        "periodo": 202605,
        "valor": 45901297049.5,
        "delta": -2037032335.5
      },
      {
        "periodo": 202606,
        "valor": 46372359331.0,
        "delta": 471062281.5
      },
      {
        "periodo": 202607,
        "valor": 45756928491.0,
        "delta": -615430840.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 208456713166.0,
    "valor_anterior": 213362085774.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 245627215677.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 253819009713.0,
        "delta": 8191794036.0
      },
      {
        "periodo": 202509,
        "valor": 244283492588.0,
        "delta": -9535517125.0
      },
      {
        "periodo": 202510,
        "valor": 223798263112.0,
        "delta": -20485229476.0
      },
      {
        "periodo": 202511,
        "valor": 228005188321.0,
        "delta": 4206925209.0
      },
      {
        "periodo": 202512,
        "valor": 199749020480.0,
        "delta": -28256167841.0
      },
      {
        "periodo": 202601,
        "valor": 188807687255.0,
        "delta": -10941333225.0
      },
      {
        "periodo": 202602,
        "valor": 196375485106.0,
        "delta": 7567797851.0
      },
      {
        "periodo": 202603,
        "valor": 189658715722.0,
        "delta": -6716769384.0
      },
      {
        "periodo": 202604,
        "valor": 228210650817.0,
        "delta": 38551935095.0
      },
      {
        "periodo": 202605,
        "valor": 231866421211.0,
        "delta": 3655770394.0
      },
      {
        "periodo": 202606,
        "valor": 213362085774.0,
        "delta": -18504335437.0
      },
      {
        "periodo": 202607,
        "valor": 208456713166.0,
        "delta": -4905372608.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 296256458289.9199,
    "valor_anterior": 290359011059.78,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 307766017354.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 309578475189.91,
        "delta": 1812457835.17
      },
      {
        "periodo": 202509,
        "valor": 313762982315.63,
        "delta": 4184507125.72
      },
      {
        "periodo": 202510,
        "valor": 288478969580.76,
        "delta": -25284012734.87
      },
      {
        "periodo": 202511,
        "valor": 276370816835.2,
        "delta": -12108152745.56
      },
      {
        "periodo": 202512,
        "valor": 295118454143.77,
        "delta": 18747637308.57
      },
      {
        "periodo": 202601,
        "valor": 275872992094.99,
        "delta": -19245462048.78
      },
      {
        "periodo": 202602,
        "valor": 297370797223.48,
        "delta": 21497805128.49
      },
      {
        "periodo": 202603,
        "valor": 278553827773.22,
        "delta": -18816969450.26
      },
      {
        "periodo": 202604,
        "valor": 279867255467.77,
        "delta": 1313427694.55
      },
      {
        "periodo": 202605,
        "valor": 283519014902.77,
        "delta": 3651759435.0
      },
      {
        "periodo": 202606,
        "valor": 290359011059.78,
        "delta": 6839996157.01
      },
      {
        "periodo": 202607,
        "valor": 296256458289.9199,
        "delta": 5897447230.1399
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 138143390820.0,
    "valor_anterior": 137544784658.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 106211813961.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 107226100191.0,
        "delta": 1014286230.0
      },
      {
        "periodo": 202509,
        "valor": 109859848915.0,
        "delta": 2633748724.0
      },
      {
        "periodo": 202510,
        "valor": 110220408057.0,
        "delta": 360559142.0
      },
      {
        "periodo": 202511,
        "valor": 113103482582.0,
        "delta": 2883074525.0
      },
      {
        "periodo": 202512,
        "valor": 118899463861.0,
        "delta": 5795981279.0
      },
      {
        "periodo": 202601,
        "valor": 127770939079.0,
        "delta": 8871475218.0
      },
      {
        "periodo": 202602,
        "valor": 133582803425.0,
        "delta": 5811864346.0
      },
      {
        "periodo": 202603,
        "valor": 133557634150.0,
        "delta": -25169275.0
      },
      {
        "periodo": 202604,
        "valor": 140577709323.0,
        "delta": 7020075173.0
      },
      {
        "periodo": 202605,
        "valor": 141800879687.0,
        "delta": 1223170364.0
      },
      {
        "periodo": 202606,
        "valor": 137544784658.0,
        "delta": -4256095029.0
      },
      {
        "periodo": 202607,
        "valor": 138143390820.0,
        "delta": 598606162.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 646209497617.66,
    "valor_anterior": 596566181382.12,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 577231709379.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 583611648158.07,
        "delta": 6379938778.88
      },
      {
        "periodo": 202509,
        "valor": 556350636966.8,
        "delta": -27261011191.2699
      },
      {
        "periodo": 202510,
        "valor": 575551294603.67,
        "delta": 19200657636.87
      },
      {
        "periodo": 202511,
        "valor": 585541622929.34,
        "delta": 9990328325.6699
      },
      {
        "periodo": 202512,
        "valor": 582401567496.44,
        "delta": -3140055432.9
      },
      {
        "periodo": 202601,
        "valor": 552554629535.25,
        "delta": -29846937961.1899
      },
      {
        "periodo": 202602,
        "valor": 563869720441.78,
        "delta": 11315090906.53
      },
      {
        "periodo": 202603,
        "valor": 626671242244.23,
        "delta": 62801521802.45
      },
      {
        "periodo": 202604,
        "valor": 605048741205.3201,
        "delta": -21622501038.9099
      },
      {
        "periodo": 202605,
        "valor": 616487574381.67,
        "delta": 11438833176.35
      },
      {
        "periodo": 202606,
        "valor": 596566181382.12,
        "delta": -19921392999.55
      },
      {
        "periodo": 202607,
        "valor": 646209497617.66,
        "delta": 49643316235.54
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 2142871032.0,
    "valor_anterior": 2136289956.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2234552202.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2188569084.0,
        "delta": -45983118.0
      },
      {
        "periodo": 202509,
        "valor": 2180655175.0,
        "delta": -7913909.0
      },
      {
        "periodo": 202510,
        "valor": 2215114806.0,
        "delta": 34459631.0
      },
      {
        "periodo": 202511,
        "valor": 2201378820.0,
        "delta": -13735986.0
      },
      {
        "periodo": 202512,
        "valor": 2147893175.0,
        "delta": -53485645.0
      },
      {
        "periodo": 202601,
        "valor": 2158544591.0,
        "delta": 10651416.0
      },
      {
        "periodo": 202602,
        "valor": 2146809455.0,
        "delta": -11735136.0
      },
      {
        "periodo": 202603,
        "valor": 2153479806.0,
        "delta": 6670351.0
      },
      {
        "periodo": 202604,
        "valor": 2148434620.0,
        "delta": -5045186.0
      },
      {
        "periodo": 202605,
        "valor": 2140991384.0,
        "delta": -7443236.0
      },
      {
        "periodo": 202606,
        "valor": 2136289956.0,
        "delta": -4701428.0
      },
      {
        "periodo": 202607,
        "valor": 2142871032.0,
        "delta": 6581076.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 343445681134.18,
    "valor_anterior": 343638983477.02,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 358130147751.77,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 360844952286.33,
        "delta": 2714804534.56
      },
      {
        "periodo": 202509,
        "valor": 353123750522.39,
        "delta": -7721201763.94
      },
      {
        "periodo": 202510,
        "valor": 356643061738.5601,
        "delta": 3519311216.17
      },
      {
        "periodo": 202511,
        "valor": 375891215838.22,
        "delta": 19248154099.6599
      },
      {
        "periodo": 202512,
        "valor": 355569107288.13,
        "delta": -20322108550.09
      },
      {
        "periodo": 202601,
        "valor": 360726824105.68,
        "delta": 5157716817.55
      },
      {
        "periodo": 202602,
        "valor": 355961680699.92,
        "delta": -4765143405.76
      },
      {
        "periodo": 202603,
        "valor": 350142572974.91,
        "delta": -5819107725.01
      },
      {
        "periodo": 202604,
        "valor": 347177648406.12,
        "delta": -2964924568.79
      },
      {
        "periodo": 202605,
        "valor": 343912977657.84,
        "delta": -3264670748.28
      },
      {
        "periodo": 202606,
        "valor": 343638983477.02,
        "delta": -273994180.82
      },
      {
        "periodo": 202607,
        "valor": 343445681134.18,
        "delta": -193302342.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 86781244150.0,
    "valor_anterior": 93015200813.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21317241299.55,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28842894848.28,
        "delta": 7525653548.73
      },
      {
        "periodo": 202509,
        "valor": 52078841049.0,
        "delta": 23235946200.72
      },
      {
        "periodo": 202510,
        "valor": 55576978633.0,
        "delta": 3498137584.0
      },
      {
        "periodo": 202511,
        "valor": 52983730440.0,
        "delta": -2593248193.0
      },
      {
        "periodo": 202512,
        "valor": 65158188724.0,
        "delta": 12174458284.0
      },
      {
        "periodo": 202601,
        "valor": 62217898314.0,
        "delta": -2940290410.0
      },
      {
        "periodo": 202602,
        "valor": 57701167763.0,
        "delta": -4516730551.0
      },
      {
        "periodo": 202603,
        "valor": 71944599399.0,
        "delta": 14243431636.0
      },
      {
        "periodo": 202604,
        "valor": 61347456359.0,
        "delta": -10597143040.0
      },
      {
        "periodo": 202605,
        "valor": 64486358370.0,
        "delta": 3138902011.0
      },
      {
        "periodo": 202606,
        "valor": 93015200813.0,
        "delta": 28528842443.0
      },
      {
        "periodo": 202607,
        "valor": 86781244150.0,
        "delta": -6233956663.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 156283721273.0,
    "valor_anterior": 109586957276.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 142627335069.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 160700188795.0,
        "delta": 18072853726.0
      },
      {
        "periodo": 202509,
        "valor": 170675897702.0,
        "delta": 9975708907.0
      },
      {
        "periodo": 202510,
        "valor": 161816658233.0,
        "delta": -8859239469.0
      },
      {
        "periodo": 202511,
        "valor": 126033015150.0,
        "delta": -35783643083.0
      },
      {
        "periodo": 202512,
        "valor": 89729653163.0,
        "delta": -36303361987.0
      },
      {
        "periodo": 202601,
        "valor": 110630306164.03,
        "delta": 20900653001.03
      },
      {
        "periodo": 202602,
        "valor": 112974991444.0,
        "delta": 2344685279.97
      },
      {
        "periodo": 202603,
        "valor": 107619729444.0,
        "delta": -5355262000.0
      },
      {
        "periodo": 202604,
        "valor": 140610404601.0,
        "delta": 32990675157.0
      },
      {
        "periodo": 202605,
        "valor": 141234248756.0,
        "delta": 623844155.0
      },
      {
        "periodo": 202606,
        "valor": 109586957276.0,
        "delta": -31647291480.0
      },
      {
        "periodo": 202607,
        "valor": 156283721273.0,
        "delta": 46696763997.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 71877082758.0,
    "valor_anterior": 71692964328.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 65277491666.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 66815164986.0,
        "delta": 1537673320.0
      },
      {
        "periodo": 202509,
        "valor": 67642234333.0,
        "delta": 827069347.0
      },
      {
        "periodo": 202510,
        "valor": 72444560970.0,
        "delta": 4802326637.0
      },
      {
        "periodo": 202511,
        "valor": 71866179352.0,
        "delta": -578381618.0
      },
      {
        "periodo": 202512,
        "valor": 72562345948.0,
        "delta": 696166596.0
      },
      {
        "periodo": 202601,
        "valor": 71891000671.0,
        "delta": -671345277.0
      },
      {
        "periodo": 202602,
        "valor": 73084889729.0,
        "delta": 1193889058.0
      },
      {
        "periodo": 202603,
        "valor": 72693896465.0,
        "delta": -390993264.0
      },
      {
        "periodo": 202604,
        "valor": 70702668913.0,
        "delta": -1991227552.0
      },
      {
        "periodo": 202605,
        "valor": 70543669023.0,
        "delta": -158999890.0
      },
      {
        "periodo": 202606,
        "valor": 71692964328.0,
        "delta": 1149295305.0
      },
      {
        "periodo": 202607,
        "valor": 71877082758.0,
        "delta": 184118430.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 183596930949.0,
    "valor_anterior": 180634390445.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 158622413293.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 175226286759.0,
        "delta": 16603873466.0
      },
      {
        "periodo": 202509,
        "valor": 177181610589.0,
        "delta": 1955323830.0
      },
      {
        "periodo": 202510,
        "valor": 172085328721.0,
        "delta": -5096281868.0
      },
      {
        "periodo": 202511,
        "valor": 162955700817.0,
        "delta": -9129627904.0
      },
      {
        "periodo": 202512,
        "valor": 174373152669.0,
        "delta": 11417451852.0
      },
      {
        "periodo": 202601,
        "valor": 167562738168.0,
        "delta": -6810414501.0
      },
      {
        "periodo": 202602,
        "valor": 178009051838.0,
        "delta": 10446313670.0
      },
      {
        "periodo": 202603,
        "valor": 185185791038.0,
        "delta": 7176739200.0
      },
      {
        "periodo": 202604,
        "valor": 179492259503.0,
        "delta": -5693531535.0
      },
      {
        "periodo": 202605,
        "valor": 186537674301.0,
        "delta": 7045414798.0
      },
      {
        "periodo": 202606,
        "valor": 180634390445.0,
        "delta": -5903283856.0
      },
      {
        "periodo": 202607,
        "valor": 183596930949.0,
        "delta": 2962540504.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 64666560531.0,
    "valor_anterior": 63535583769.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 73175935345.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 77892407557.0,
        "delta": 4716472212.0
      },
      {
        "periodo": 202509,
        "valor": 74182554629.0,
        "delta": -3709852928.0
      },
      {
        "periodo": 202510,
        "valor": 66975940978.0,
        "delta": -7206613651.0
      },
      {
        "periodo": 202511,
        "valor": 71449141792.0,
        "delta": 4473200814.0
      },
      {
        "periodo": 202512,
        "valor": 83992903376.0,
        "delta": 12543761584.0
      },
      {
        "periodo": 202601,
        "valor": 60437591855.0,
        "delta": -23555311521.0
      },
      {
        "periodo": 202602,
        "valor": 58787332233.0,
        "delta": -1650259622.0
      },
      {
        "periodo": 202603,
        "valor": 61678097979.0,
        "delta": 2890765746.0
      },
      {
        "periodo": 202604,
        "valor": 64437788319.0,
        "delta": 2759690340.0
      },
      {
        "periodo": 202605,
        "valor": 60949568803.0,
        "delta": -3488219516.0
      },
      {
        "periodo": 202606,
        "valor": 63535583769.0,
        "delta": 2586014966.0
      },
      {
        "periodo": 202607,
        "valor": 64666560531.0,
        "delta": 1130976762.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 3957329926.0,
    "valor_anterior": 4227285505.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 56634146432.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 32202599261.0,
        "delta": -24431547171.0
      },
      {
        "periodo": 202509,
        "valor": 11449756335.0,
        "delta": -20752842926.0
      },
      {
        "periodo": 202510,
        "valor": 11511588875.0,
        "delta": 61832540.0
      },
      {
        "periodo": 202511,
        "valor": 11508808885.0,
        "delta": -2779990.0
      },
      {
        "periodo": 202512,
        "valor": 11270309197.0,
        "delta": -238499688.0
      },
      {
        "periodo": 202601,
        "valor": 11208523334.0,
        "delta": -61785863.0
      },
      {
        "periodo": 202602,
        "valor": 11232213442.0,
        "delta": 23690108.0
      },
      {
        "periodo": 202603,
        "valor": 5365225280.0,
        "delta": -5866988162.0
      },
      {
        "periodo": 202604,
        "valor": 5403694483.0,
        "delta": 38469203.0
      },
      {
        "periodo": 202605,
        "valor": 5362023886.0,
        "delta": -41670597.0
      },
      {
        "periodo": 202606,
        "valor": 4227285505.0,
        "delta": -1134738381.0
      },
      {
        "periodo": 202607,
        "valor": 3957329926.0,
        "delta": -269955579.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 178573564314.04,
    "valor_anterior": 175616020085.75,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 174014162817.04,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 183517678207.96,
        "delta": 9503515390.92
      },
      {
        "periodo": 202509,
        "valor": 174574610979.81,
        "delta": -8943067228.15
      },
      {
        "periodo": 202510,
        "valor": 180064615340.57,
        "delta": 5490004360.76
      },
      {
        "periodo": 202511,
        "valor": 186350983102.02,
        "delta": 6286367761.45
      },
      {
        "periodo": 202512,
        "valor": 180214237896.63,
        "delta": -6136745205.39
      },
      {
        "periodo": 202601,
        "valor": 181698684905.26,
        "delta": 1484447008.63
      },
      {
        "periodo": 202602,
        "valor": 180739350376.26,
        "delta": -959334529.0
      },
      {
        "periodo": 202603,
        "valor": 176046334478.44,
        "delta": -4693015897.82
      },
      {
        "periodo": 202604,
        "valor": 176837925976.15,
        "delta": 791591497.71
      },
      {
        "periodo": 202605,
        "valor": 184686351859.55,
        "delta": 7848425883.4
      },
      {
        "periodo": 202606,
        "valor": 175616020085.75,
        "delta": -9070331773.8
      },
      {
        "periodo": 202607,
        "valor": 178573564314.04,
        "delta": 2957544228.29
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 6146220208.0,
    "valor_anterior": 6121498064.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6851977488.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7066932638.0,
        "delta": 214955150.0
      },
      {
        "periodo": 202509,
        "valor": 6815734673.0,
        "delta": -251197965.0
      },
      {
        "periodo": 202510,
        "valor": 6370832331.0,
        "delta": -444902342.0
      },
      {
        "periodo": 202511,
        "valor": 6262798013.0,
        "delta": -108034318.0
      },
      {
        "periodo": 202512,
        "valor": 6499602463.0,
        "delta": 236804450.0
      },
      {
        "periodo": 202601,
        "valor": 6323916055.0,
        "delta": -175686408.0
      },
      {
        "periodo": 202602,
        "valor": 6216729048.0,
        "delta": -107187007.0
      },
      {
        "periodo": 202603,
        "valor": 6289212692.0,
        "delta": 72483644.0
      },
      {
        "periodo": 202604,
        "valor": 6032360623.0,
        "delta": -256852069.0
      },
      {
        "periodo": 202605,
        "valor": 5969656669.0,
        "delta": -62703954.0
      },
      {
        "periodo": 202606,
        "valor": 6121498065.0,
        "delta": 151841396.0
      },
      {
        "periodo": 202607,
        "valor": 6146220208.0,
        "delta": 24722143.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 68341527646.0,
    "valor_anterior": 72091992222.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 63277845078.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 62383195506.0,
        "delta": -894649572.0
      },
      {
        "periodo": 202509,
        "valor": 59489394794.0,
        "delta": -2893800712.0
      },
      {
        "periodo": 202510,
        "valor": 60037122803.0,
        "delta": 547728009.0
      },
      {
        "periodo": 202511,
        "valor": 62475112721.0,
        "delta": 2437989918.0
      },
      {
        "periodo": 202512,
        "valor": 54946176649.0,
        "delta": -7528936072.0
      },
      {
        "periodo": 202601,
        "valor": 62642866748.0,
        "delta": 7696690099.0
      },
      {
        "periodo": 202602,
        "valor": 67811437152.0,
        "delta": 5168570404.0
      },
      {
        "periodo": 202603,
        "valor": 68086179925.0,
        "delta": 274742773.0
      },
      {
        "periodo": 202604,
        "valor": 64743298025.0,
        "delta": -3342881900.0
      },
      {
        "periodo": 202605,
        "valor": 67913194593.0,
        "delta": 3169896568.0
      },
      {
        "periodo": 202606,
        "valor": 72091992222.0,
        "delta": 4178797629.0
      },
      {
        "periodo": 202607,
        "valor": 68341527646.0,
        "delta": -3750464576.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 44555858016.0,
    "valor_anterior": 44662428251.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 36548259160.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 37114648096.0,
        "delta": 566388936.0
      },
      {
        "periodo": 202509,
        "valor": 37020445035.0,
        "delta": -94203061.0
      },
      {
        "periodo": 202510,
        "valor": 37827802379.0,
        "delta": 807357344.0
      },
      {
        "periodo": 202511,
        "valor": 37638651960.0,
        "delta": -189150419.0
      },
      {
        "periodo": 202512,
        "valor": 38500846327.0,
        "delta": 862194367.0
      },
      {
        "periodo": 202601,
        "valor": 40425331076.0,
        "delta": 1924484749.0
      },
      {
        "periodo": 202602,
        "valor": 41592072060.0,
        "delta": 1166740984.0
      },
      {
        "periodo": 202603,
        "valor": 43224285919.0,
        "delta": 1632213859.0
      },
      {
        "periodo": 202604,
        "valor": 47056412068.0,
        "delta": 3832126149.0
      },
      {
        "periodo": 202605,
        "valor": 45388004923.0,
        "delta": -1668407145.0
      },
      {
        "periodo": 202606,
        "valor": 44662428251.0,
        "delta": -725576672.0
      },
      {
        "periodo": 202607,
        "valor": 44555858016.0,
        "delta": -106570235.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 9441827664.0,
    "valor_anterior": 9386582567.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7965483286.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7984490088.0,
        "delta": 19006802.0
      },
      {
        "periodo": 202509,
        "valor": 9116002759.0,
        "delta": 1131512671.0
      },
      {
        "periodo": 202510,
        "valor": 9175640742.0,
        "delta": 59637983.0
      },
      {
        "periodo": 202511,
        "valor": 9268936442.0,
        "delta": 93295700.0
      },
      {
        "periodo": 202512,
        "valor": 8863566250.0,
        "delta": -405370192.0
      },
      {
        "periodo": 202601,
        "valor": 8889451532.0,
        "delta": 25885282.0
      },
      {
        "periodo": 202602,
        "valor": 9314633571.0,
        "delta": 425182039.0
      },
      {
        "periodo": 202603,
        "valor": 9448048291.0,
        "delta": 133414720.0
      },
      {
        "periodo": 202604,
        "valor": 9486757116.0,
        "delta": 38708825.0
      },
      {
        "periodo": 202605,
        "valor": 9493836206.0,
        "delta": 7079090.0
      },
      {
        "periodo": 202606,
        "valor": 9386582567.0,
        "delta": -107253639.0
      },
      {
        "periodo": 202607,
        "valor": 9441827664.0,
        "delta": 55245097.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 99168753312.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 68658223984.0,
        "delta": -30510529328.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 210022928073.0,
    "valor_anterior": 209224310032.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 150360129449.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 157334596226.0,
        "delta": 6974466777.0
      },
      {
        "periodo": 202509,
        "valor": 165277239040.0,
        "delta": 7942642814.0
      },
      {
        "periodo": 202510,
        "valor": 174754558147.0,
        "delta": 9477319107.0
      },
      {
        "periodo": 202511,
        "valor": 173597892630.0,
        "delta": -1156665517.0
      },
      {
        "periodo": 202512,
        "valor": 196760060478.0,
        "delta": 23162167848.0
      },
      {
        "periodo": 202601,
        "valor": 186064007924.0,
        "delta": -10696052554.0
      },
      {
        "periodo": 202602,
        "valor": 194422332689.0,
        "delta": 8358324765.0
      },
      {
        "periodo": 202603,
        "valor": 189213577460.0,
        "delta": -5208755229.0
      },
      {
        "periodo": 202604,
        "valor": 189125265087.0,
        "delta": -88312373.0
      },
      {
        "periodo": 202605,
        "valor": 185493722807.0,
        "delta": -3631542280.0
      },
      {
        "periodo": 202606,
        "valor": 209224310032.0,
        "delta": 23730587225.0
      },
      {
        "periodo": 202607,
        "valor": 210022928073.0,
        "delta": 798618041.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 33888511994.0,
    "valor_anterior": 31990620990.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19315866895.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19672837765.0,
        "delta": 356970870.0
      },
      {
        "periodo": 202509,
        "valor": 21351101684.0,
        "delta": 1678263919.0
      },
      {
        "periodo": 202510,
        "valor": 22009040889.0,
        "delta": 657939205.0
      },
      {
        "periodo": 202511,
        "valor": 22572797774.0,
        "delta": 563756885.0
      },
      {
        "periodo": 202512,
        "valor": 29804234297.0,
        "delta": 7231436523.0
      },
      {
        "periodo": 202601,
        "valor": 23759415036.0,
        "delta": -6044819261.0
      },
      {
        "periodo": 202602,
        "valor": 28218867835.0,
        "delta": 4459452799.0
      },
      {
        "periodo": 202603,
        "valor": 30308375415.0,
        "delta": 2089507580.0
      },
      {
        "periodo": 202604,
        "valor": 29771302082.0,
        "delta": -537073333.0
      },
      {
        "periodo": 202605,
        "valor": 31296288124.0,
        "delta": 1524986042.0
      },
      {
        "periodo": 202606,
        "valor": 31990620990.0,
        "delta": 694332866.0
      },
      {
        "periodo": 202607,
        "valor": 33888511994.0,
        "delta": 1897891004.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 1872525020.0,
    "valor_anterior": 1834812962.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 353016744.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1195904921.0,
        "delta": 842888177.0
      },
      {
        "periodo": 202509,
        "valor": 844794280.0,
        "delta": -351110641.0
      },
      {
        "periodo": 202510,
        "valor": 1109430453.0,
        "delta": 264636173.0
      },
      {
        "periodo": 202511,
        "valor": 1250579357.0,
        "delta": 141148904.0
      },
      {
        "periodo": 202512,
        "valor": 1231922504.0,
        "delta": -18656853.0
      },
      {
        "periodo": 202601,
        "valor": 1346564420.0,
        "delta": 114641916.0
      },
      {
        "periodo": 202602,
        "valor": 1311896762.0,
        "delta": -34667658.0
      },
      {
        "periodo": 202603,
        "valor": 1063623091.0,
        "delta": -248273671.0
      },
      {
        "periodo": 202604,
        "valor": 990403634.0,
        "delta": -73219457.0
      },
      {
        "periodo": 202605,
        "valor": 1505978376.0,
        "delta": 515574742.0
      },
      {
        "periodo": 202606,
        "valor": 1834812962.0,
        "delta": 328834586.0
      },
      {
        "periodo": 202607,
        "valor": 1872525020.0,
        "delta": 37712058.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 1155624921.0,
    "valor_anterior": 1120195428.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 913073174.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 928828242.0,
        "delta": 15755068.0
      },
      {
        "periodo": 202509,
        "valor": 947655699.0,
        "delta": 18827457.0
      },
      {
        "periodo": 202510,
        "valor": 961101220.0,
        "delta": 13445521.0
      },
      {
        "periodo": 202511,
        "valor": 964229188.0,
        "delta": 3127968.0
      },
      {
        "periodo": 202512,
        "valor": 1024756739.0,
        "delta": 60527551.0
      },
      {
        "periodo": 202601,
        "valor": 1038015216.0,
        "delta": 13258477.0
      },
      {
        "periodo": 202602,
        "valor": 1050606502.0,
        "delta": 12591286.0
      },
      {
        "periodo": 202603,
        "valor": 1070201379.0,
        "delta": 19594877.0
      },
      {
        "periodo": 202604,
        "valor": 1081163474.0,
        "delta": 10962095.0
      },
      {
        "periodo": 202605,
        "valor": 1095962631.0,
        "delta": 14799157.0
      },
      {
        "periodo": 202606,
        "valor": 1120195428.0,
        "delta": 24232797.0
      },
      {
        "periodo": 202607,
        "valor": 1155624921.0,
        "delta": 35429493.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 17378529937.8,
    "valor_anterior": 17439021092.85,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16233588691.07,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16264339432.27,
        "delta": 30750741.2
      },
      {
        "periodo": 202509,
        "valor": 16161722819.28,
        "delta": -102616612.99
      },
      {
        "periodo": 202510,
        "valor": 16423723124.99,
        "delta": 262000305.71
      },
      {
        "periodo": 202511,
        "valor": 16555598746.13,
        "delta": 131875621.14
      },
      {
        "periodo": 202512,
        "valor": 16668598261.99,
        "delta": 112999515.86
      },
      {
        "periodo": 202601,
        "valor": 16267154860.15,
        "delta": -401443401.84
      },
      {
        "periodo": 202602,
        "valor": 16035373722.5,
        "delta": -231781137.65
      },
      {
        "periodo": 202603,
        "valor": 17154904958.7,
        "delta": 1119531236.2
      },
      {
        "periodo": 202604,
        "valor": 17132442986.22,
        "delta": -22461972.48
      },
      {
        "periodo": 202605,
        "valor": 16917846841.16,
        "delta": -214596145.06
      },
      {
        "periodo": 202606,
        "valor": 17439021092.85,
        "delta": 521174251.69
      },
      {
        "periodo": 202607,
        "valor": 17378529937.8,
        "delta": -60491155.05
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 4554528388.0,
    "valor_anterior": 3594804304.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2505365470.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2765674017.0,
        "delta": 260308547.0
      },
      {
        "periodo": 202509,
        "valor": 2869638021.0,
        "delta": 103964004.0
      },
      {
        "periodo": 202510,
        "valor": 3690547296.0,
        "delta": 820909275.0
      },
      {
        "periodo": 202511,
        "valor": 4094116856.0,
        "delta": 403569560.0
      },
      {
        "periodo": 202512,
        "valor": 3640557909.0,
        "delta": -453558947.0
      },
      {
        "periodo": 202601,
        "valor": 2879008003.0,
        "delta": -761549906.0
      },
      {
        "periodo": 202602,
        "valor": 3489048076.0,
        "delta": 610040073.0
      },
      {
        "periodo": 202603,
        "valor": 3893146376.0,
        "delta": 404098300.0
      },
      {
        "periodo": 202604,
        "valor": 4536773114.0,
        "delta": 643626738.0
      },
      {
        "periodo": 202605,
        "valor": 3784697715.0,
        "delta": -752075399.0
      },
      {
        "periodo": 202606,
        "valor": 3594804304.0,
        "delta": -189893411.0
      },
      {
        "periodo": 202607,
        "valor": 4554528388.0,
        "delta": 959724084.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 62129590711.9,
    "valor_anterior": 62487507287.23,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 53323796476.7,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 53979926771.23,
        "delta": 656130294.53
      },
      {
        "periodo": 202509,
        "valor": 53536188645.12,
        "delta": -443738126.11
      },
      {
        "periodo": 202510,
        "valor": 55350786484.17,
        "delta": 1814597839.05
      },
      {
        "periodo": 202511,
        "valor": 57731031600.06,
        "delta": 2380245115.89
      },
      {
        "periodo": 202512,
        "valor": 60082446787.82,
        "delta": 2351415187.76
      },
      {
        "periodo": 202601,
        "valor": 61073588804.22,
        "delta": 991142016.4
      },
      {
        "periodo": 202602,
        "valor": 59477915545.3,
        "delta": -1595673258.92
      },
      {
        "periodo": 202603,
        "valor": 62116133418.23,
        "delta": 2638217872.93
      },
      {
        "periodo": 202604,
        "valor": 60593698830.42,
        "delta": -1522434587.81
      },
      {
        "periodo": 202605,
        "valor": 60804726096.85,
        "delta": 211027266.43
      },
      {
        "periodo": 202606,
        "valor": 62487507287.23,
        "delta": 1682781190.38
      },
      {
        "periodo": 202607,
        "valor": 62129590711.9,
        "delta": -357916575.33
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 11180953603.330002,
    "valor_anterior": 11095985161.46,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9852610923.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9991303124.52,
        "delta": 138692201.25
      },
      {
        "periodo": 202509,
        "valor": 10135184582.9,
        "delta": 143881458.38
      },
      {
        "periodo": 202510,
        "valor": 9967591025.29,
        "delta": -167593557.61
      },
      {
        "periodo": 202511,
        "valor": 10182389167.35,
        "delta": 214798142.06
      },
      {
        "periodo": 202512,
        "valor": 10322241972.17,
        "delta": 139852804.82
      },
      {
        "periodo": 202601,
        "valor": 10517205365.26,
        "delta": 194963393.09
      },
      {
        "periodo": 202602,
        "valor": 10377147267.46,
        "delta": -140058097.8
      },
      {
        "periodo": 202603,
        "valor": 10870373497.18,
        "delta": 493226229.72
      },
      {
        "periodo": 202604,
        "valor": 10863234156.97,
        "delta": -7139340.21
      },
      {
        "periodo": 202605,
        "valor": 11207048569.47,
        "delta": 343814412.5
      },
      {
        "periodo": 202606,
        "valor": 11095985161.46,
        "delta": -111063408.01
      },
      {
        "periodo": 202607,
        "valor": 11180953603.33,
        "delta": 84968441.87
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 13002523993.0,
    "valor_anterior": 11989062439.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11085151171.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11380088177.0,
        "delta": 294937006.0
      },
      {
        "periodo": 202509,
        "valor": 11989966799.0,
        "delta": 609878622.0
      },
      {
        "periodo": 202510,
        "valor": 12977854209.0,
        "delta": 987887410.0
      },
      {
        "periodo": 202511,
        "valor": 13714043659.0,
        "delta": 736189450.0
      },
      {
        "periodo": 202512,
        "valor": 13010564570.0,
        "delta": -703479089.0
      },
      {
        "periodo": 202601,
        "valor": 13321995922.0,
        "delta": 311431352.0
      },
      {
        "periodo": 202602,
        "valor": 13263583759.0,
        "delta": -58412163.0
      },
      {
        "periodo": 202603,
        "valor": 12932781069.0,
        "delta": -330802690.0
      },
      {
        "periodo": 202604,
        "valor": 12751323492.0,
        "delta": -181457577.0
      },
      {
        "periodo": 202605,
        "valor": 11661498786.0,
        "delta": -1089824706.0
      },
      {
        "periodo": 202606,
        "valor": 11989062439.0,
        "delta": 327563653.0
      },
      {
        "periodo": 202607,
        "valor": 13002523993.0,
        "delta": 1013461554.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 148611368629.0,
    "valor_anterior": 146628342128.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 140368102744.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 142584041853.0,
        "delta": 2215939109.0
      },
      {
        "periodo": 202509,
        "valor": 141562488889.0,
        "delta": -1021552964.0
      },
      {
        "periodo": 202510,
        "valor": 150189855386.0,
        "delta": 8627366497.0
      },
      {
        "periodo": 202511,
        "valor": 144869629906.0,
        "delta": -5320225480.0
      },
      {
        "periodo": 202512,
        "valor": 154072231474.0,
        "delta": 9202601568.0
      },
      {
        "periodo": 202601,
        "valor": 151750658893.0,
        "delta": -2321572581.0
      },
      {
        "periodo": 202602,
        "valor": 151965319041.0,
        "delta": 214660148.0
      },
      {
        "periodo": 202603,
        "valor": 152463254460.0,
        "delta": 497935419.0
      },
      {
        "periodo": 202604,
        "valor": 149192479695.0,
        "delta": -3270774765.0
      },
      {
        "periodo": 202605,
        "valor": 148253920413.0,
        "delta": -938559282.0
      },
      {
        "periodo": 202606,
        "valor": 146628342128.0,
        "delta": -1625578285.0
      },
      {
        "periodo": 202607,
        "valor": 148611368629.0,
        "delta": 1983026501.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 7058598978.0,
    "valor_anterior": 6745845768.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6887506934.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7096498206.0,
        "delta": 208991272.0
      },
      {
        "periodo": 202509,
        "valor": 6930335281.0,
        "delta": -166162925.0
      },
      {
        "periodo": 202510,
        "valor": 7570635675.0,
        "delta": 640300394.0
      },
      {
        "periodo": 202511,
        "valor": 7335407133.0,
        "delta": -235228542.0
      },
      {
        "periodo": 202512,
        "valor": 6658672125.0,
        "delta": -676735008.0
      },
      {
        "periodo": 202601,
        "valor": 7476545562.0,
        "delta": 817873437.0
      },
      {
        "periodo": 202602,
        "valor": 7329757973.0,
        "delta": -146787589.0
      },
      {
        "periodo": 202603,
        "valor": 7091272528.0,
        "delta": -238485445.0
      },
      {
        "periodo": 202604,
        "valor": 7169130719.0,
        "delta": 77858191.0
      },
      {
        "periodo": 202605,
        "valor": 6761763258.0,
        "delta": -407367461.0
      },
      {
        "periodo": 202606,
        "valor": 6745845768.0,
        "delta": -15917490.0
      },
      {
        "periodo": 202607,
        "valor": 7058598978.0,
        "delta": 312753210.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 13141838949.72,
    "valor_anterior": 13316390539.7,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15099570635.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13828821269.78,
        "delta": -1270749366.12
      },
      {
        "periodo": 202509,
        "valor": 14035261882.83,
        "delta": 206440613.05
      },
      {
        "periodo": 202510,
        "valor": 15220320291.72,
        "delta": 1185058408.89
      },
      {
        "periodo": 202511,
        "valor": 15193375234.16,
        "delta": -26945057.56
      },
      {
        "periodo": 202512,
        "valor": 12774884883.89,
        "delta": -2418490350.27
      },
      {
        "periodo": 202601,
        "valor": 14741296794.22,
        "delta": 1966411910.33
      },
      {
        "periodo": 202602,
        "valor": 14650312259.1,
        "delta": -90984535.12
      },
      {
        "periodo": 202603,
        "valor": 14464350008.1,
        "delta": -185962251.0
      },
      {
        "periodo": 202604,
        "valor": 13678305175.38,
        "delta": -786044832.72
      },
      {
        "periodo": 202605,
        "valor": 13647522242.81,
        "delta": -30782932.57
      },
      {
        "periodo": 202606,
        "valor": 13316390539.7,
        "delta": -331131703.11
      },
      {
        "periodo": 202607,
        "valor": 13141838949.72,
        "delta": -174551589.98
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 8179887730.74,
    "valor_anterior": 9110010094.9,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8092591911.16,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7391300275.71,
        "delta": -701291635.45
      },
      {
        "periodo": 202509,
        "valor": 7087776165.8,
        "delta": -303524109.91
      },
      {
        "periodo": 202510,
        "valor": 6492595307.06,
        "delta": -595180858.74
      },
      {
        "periodo": 202511,
        "valor": 6793492551.65,
        "delta": 300897244.59
      },
      {
        "periodo": 202512,
        "valor": 7116127080.41,
        "delta": 322634528.76
      },
      {
        "periodo": 202601,
        "valor": 7574368507.98,
        "delta": 458241427.57
      },
      {
        "periodo": 202602,
        "valor": 7372164097.18,
        "delta": -202204410.8
      },
      {
        "periodo": 202603,
        "valor": 6828892469.25,
        "delta": -543271627.93
      },
      {
        "periodo": 202604,
        "valor": 7678980445.83,
        "delta": 850087976.58
      },
      {
        "periodo": 202605,
        "valor": 9466999875.24,
        "delta": 1788019429.41
      },
      {
        "periodo": 202606,
        "valor": 9110010094.9,
        "delta": -356989780.34
      },
      {
        "periodo": 202607,
        "valor": 8179887730.74,
        "delta": -930122364.16
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 5340594740.0,
    "valor_anterior": 7149858875.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5965574752.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5652191381.0,
        "delta": -313383371.0
      },
      {
        "periodo": 202509,
        "valor": 8473933597.0,
        "delta": 2821742216.0
      },
      {
        "periodo": 202510,
        "valor": 5556950408.0,
        "delta": -2916983189.0
      },
      {
        "periodo": 202511,
        "valor": 6652145174.0,
        "delta": 1095194766.0
      },
      {
        "periodo": 202512,
        "valor": 5168617768.0,
        "delta": -1483527406.0
      },
      {
        "periodo": 202601,
        "valor": 8596145960.0,
        "delta": 3427528192.0
      },
      {
        "periodo": 202602,
        "valor": 6933239855.0,
        "delta": -1662906105.0
      },
      {
        "periodo": 202603,
        "valor": 8659200843.0,
        "delta": 1725960988.0
      },
      {
        "periodo": 202604,
        "valor": 6260769885.0,
        "delta": -2398430958.0
      },
      {
        "periodo": 202605,
        "valor": 8372548909.0,
        "delta": 2111779024.0
      },
      {
        "periodo": 202606,
        "valor": 7149858875.0,
        "delta": -1222690034.0
      },
      {
        "periodo": 202607,
        "valor": 5340594740.0,
        "delta": -1809264135.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 5896707592.999999,
    "valor_anterior": 5833395084.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5793242486.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5467790569.0,
        "delta": -325451917.0
      },
      {
        "periodo": 202509,
        "valor": 5351676337.0,
        "delta": -116114232.0
      },
      {
        "periodo": 202510,
        "valor": 5479734274.0,
        "delta": 128057937.0
      },
      {
        "periodo": 202511,
        "valor": 5820872593.0,
        "delta": 341138319.0
      },
      {
        "periodo": 202512,
        "valor": 5717569855.0,
        "delta": -103302738.0
      },
      {
        "periodo": 202601,
        "valor": 5524112630.0,
        "delta": -193457225.0
      },
      {
        "periodo": 202602,
        "valor": 5609033242.0,
        "delta": 84920612.0
      },
      {
        "periodo": 202603,
        "valor": 5799549549.0,
        "delta": 190516307.0
      },
      {
        "periodo": 202604,
        "valor": 6034816141.0,
        "delta": 235266592.0
      },
      {
        "periodo": 202605,
        "valor": 5586920331.0,
        "delta": -447895810.0
      },
      {
        "periodo": 202606,
        "valor": 5833395084.0,
        "delta": 246474753.0
      },
      {
        "periodo": 202607,
        "valor": 5896707593.0,
        "delta": 63312509.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 21307642275.0,
    "valor_anterior": 19555274135.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22463422043.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19439696349.0,
        "delta": -3023725694.0
      },
      {
        "periodo": 202509,
        "valor": 19907812977.0,
        "delta": 468116628.0
      },
      {
        "periodo": 202510,
        "valor": 23156395390.0,
        "delta": 3248582413.0
      },
      {
        "periodo": 202511,
        "valor": 23738120783.0,
        "delta": 581725393.0
      },
      {
        "periodo": 202512,
        "valor": 21363097763.0,
        "delta": -2375023020.0
      },
      {
        "periodo": 202601,
        "valor": 24556234464.0,
        "delta": 3193136701.0
      },
      {
        "periodo": 202602,
        "valor": 28070755938.0,
        "delta": 3514521474.0
      },
      {
        "periodo": 202603,
        "valor": 27904182225.0,
        "delta": -166573713.0
      },
      {
        "periodo": 202604,
        "valor": 25878477385.0,
        "delta": -2025704840.0
      },
      {
        "periodo": 202605,
        "valor": 22230731010.0,
        "delta": -3647746375.0
      },
      {
        "periodo": 202606,
        "valor": 19555274135.0,
        "delta": -2675456875.0
      },
      {
        "periodo": 202607,
        "valor": 21307642275.0,
        "delta": 1752368140.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 3100843952.27,
    "valor_anterior": 3069579481.37,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3148910282.61,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3070630986.47,
        "delta": -78279296.14
      },
      {
        "periodo": 202509,
        "valor": 3146748811.5,
        "delta": 76117825.03
      },
      {
        "periodo": 202510,
        "valor": 3145398120.14,
        "delta": -1350691.36
      },
      {
        "periodo": 202511,
        "valor": 3153992506.29,
        "delta": 8594386.15
      },
      {
        "periodo": 202512,
        "valor": 3180716978.97,
        "delta": 26724472.68
      },
      {
        "periodo": 202601,
        "valor": 3165051309.12,
        "delta": -15665669.85
      },
      {
        "periodo": 202602,
        "valor": 3183057375.85,
        "delta": 18006066.73
      },
      {
        "periodo": 202603,
        "valor": 3153760565.17,
        "delta": -29296810.68
      },
      {
        "periodo": 202604,
        "valor": 3118603164.96,
        "delta": -35157400.21
      },
      {
        "periodo": 202605,
        "valor": 3060277090.87,
        "delta": -58326074.09
      },
      {
        "periodo": 202606,
        "valor": 3069579481.37,
        "delta": 9302390.5
      },
      {
        "periodo": 202607,
        "valor": 3100843952.27,
        "delta": 31264470.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 15585464026.62,
    "valor_anterior": 15599391675.32,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1569326440.12,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1573954493.15,
        "delta": 4628053.03
      },
      {
        "periodo": 202509,
        "valor": 1577058162.58,
        "delta": 3103669.43
      },
      {
        "periodo": 202510,
        "valor": 1582682501.94,
        "delta": 5624339.36
      },
      {
        "periodo": 202511,
        "valor": 1589359322.89,
        "delta": 6676820.95
      },
      {
        "periodo": 202512,
        "valor": 1592592060.46,
        "delta": 3232737.57
      },
      {
        "periodo": 202601,
        "valor": 1596970232.11,
        "delta": 4378171.65
      },
      {
        "periodo": 202602,
        "valor": 15816723739.95,
        "delta": 14219753507.84
      },
      {
        "periodo": 202603,
        "valor": 15780168514.95,
        "delta": -36555225.0
      },
      {
        "periodo": 202604,
        "valor": 15733365349.9,
        "delta": -46803165.05
      },
      {
        "periodo": 202605,
        "valor": 15614441831.2,
        "delta": -118923518.7
      },
      {
        "periodo": 202606,
        "valor": 15599391675.32,
        "delta": -15050155.88
      },
      {
        "periodo": 202607,
        "valor": 15585464026.62,
        "delta": -13927648.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 27327225357.0,
    "valor_anterior": 27019101118.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7413549287.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9601976018.0,
        "delta": 2188426731.0
      },
      {
        "periodo": 202509,
        "valor": 11827187826.0,
        "delta": 2225211808.0
      },
      {
        "periodo": 202510,
        "valor": 14280018588.0,
        "delta": 2452830762.0
      },
      {
        "periodo": 202511,
        "valor": 16761033776.0,
        "delta": 2481015188.0
      },
      {
        "periodo": 202512,
        "valor": 20574166951.0,
        "delta": 3813133175.0
      },
      {
        "periodo": 202601,
        "valor": 23707850487.0,
        "delta": 3133683536.0
      },
      {
        "periodo": 202602,
        "valor": 25396888304.0,
        "delta": 1689037817.0
      },
      {
        "periodo": 202603,
        "valor": 24756509906.0,
        "delta": -640378398.0
      },
      {
        "periodo": 202604,
        "valor": 24832547016.0,
        "delta": 76037110.0
      },
      {
        "periodo": 202605,
        "valor": 25014783718.0,
        "delta": 182236702.0
      },
      {
        "periodo": 202606,
        "valor": 27019101118.0,
        "delta": 2004317400.0
      },
      {
        "periodo": 202607,
        "valor": 27327225357.0,
        "delta": 308124239.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 9712059037.32,
    "valor_anterior": 11139753850.440002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 1512326374.3,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 1513485553.58,
        "delta": 1159179.28
      },
      {
        "periodo": 202601,
        "valor": 2526153821.33,
        "delta": 1012668267.75
      },
      {
        "periodo": 202602,
        "valor": 4278345377.79,
        "delta": 1752191556.46
      },
      {
        "periodo": 202603,
        "valor": 5672128467.36,
        "delta": 1393783089.57
      },
      {
        "periodo": 202604,
        "valor": 7726699954.06,
        "delta": 2054571486.7
      },
      {
        "periodo": 202605,
        "valor": 9024691013.66,
        "delta": 1297991059.6
      },
      {
        "periodo": 202606,
        "valor": 11139753850.44,
        "delta": 2115062836.78
      },
      {
        "periodo": 202607,
        "valor": 9712059037.32,
        "delta": -1427694813.12
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 30359150032.0,
    "valor_anterior": 27461429535.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 19911835062.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 24264099604.0,
        "delta": 4352264542.0
      },
      {
        "periodo": 202605,
        "valor": 25146386804.0,
        "delta": 882287200.0
      },
      {
        "periodo": 202606,
        "valor": 27461429535.0,
        "delta": 2315042731.0
      },
      {
        "periodo": 202607,
        "valor": 30359150032.0,
        "delta": 2897720497.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 16327523014324.99,
    "valor_anterior": 16051077058007.299,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15389124179033.88,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15431059822311.81,
        "delta": 41935643277.9297
      },
      {
        "periodo": 202509,
        "valor": 15374516960685.48,
        "delta": -56542861626.3301
      },
      {
        "periodo": 202510,
        "valor": 15647778330781.47,
        "delta": 273261370095.9902
      },
      {
        "periodo": 202511,
        "valor": 15623953648105.578,
        "delta": -23824682675.8926
      },
      {
        "periodo": 202512,
        "valor": 15550580404339.17,
        "delta": -73373243766.4082
      },
      {
        "periodo": 202601,
        "valor": 15650024341489.47,
        "delta": 99443937150.3008
      },
      {
        "periodo": 202602,
        "valor": 15775118719415.22,
        "delta": 125094377925.75
      },
      {
        "periodo": 202603,
        "valor": 15891539175190.428,
        "delta": 116420455775.207
      },
      {
        "periodo": 202604,
        "valor": 15935562940104.5,
        "delta": 44023764914.0723
      },
      {
        "periodo": 202605,
        "valor": 16512524843545.9,
        "delta": 576961903441.4004
      },
      {
        "periodo": 202606,
        "valor": 16051077058007.299,
        "delta": -461447785538.6016
      },
      {
        "periodo": 202607,
        "valor": 16327523014324.99,
        "delta": 276445956317.6914
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 11527442410942.77,
    "valor_anterior": 11366210231402.28,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10776651602670.58,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10766515489303.96,
        "delta": -10136113366.6191
      },
      {
        "periodo": 202509,
        "valor": 10873784595130.97,
        "delta": 107269105827.0098
      },
      {
        "periodo": 202510,
        "valor": 11049111678047.27,
        "delta": 175327082916.2988
      },
      {
        "periodo": 202511,
        "valor": 11052210922838.81,
        "delta": 3099244791.541
      },
      {
        "periodo": 202512,
        "valor": 11058584155717.93,
        "delta": 6373232879.1191
      },
      {
        "periodo": 202601,
        "valor": 11145195629692.08,
        "delta": 86611473974.1504
      },
      {
        "periodo": 202602,
        "valor": 11183507965397.3,
        "delta": 38312335705.2207
      },
      {
        "periodo": 202603,
        "valor": 11231145827287.12,
        "delta": 47637861889.8184
      },
      {
        "periodo": 202604,
        "valor": 11241915195449.37,
        "delta": 10769368162.25
      },
      {
        "periodo": 202605,
        "valor": 11738683677615.91,
        "delta": 496768482166.541
      },
      {
        "periodo": 202606,
        "valor": 11366210231402.28,
        "delta": -372473446213.6309
      },
      {
        "periodo": 202607,
        "valor": 11527442410942.77,
        "delta": 161232179540.4902
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 510236716288.92,
    "valor_anterior": 503810606596.78,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 613929046547.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 567773894660.91,
        "delta": -46155151886.83
      },
      {
        "periodo": 202509,
        "valor": 490489977690.63,
        "delta": -77283916970.28
      },
      {
        "periodo": 202510,
        "valor": 474745116602.76,
        "delta": -15744861087.87
      },
      {
        "periodo": 202511,
        "valor": 461477518350.2,
        "delta": -13267598252.56
      },
      {
        "periodo": 202512,
        "valor": 503148823818.77,
        "delta": 41671305468.57
      },
      {
        "periodo": 202601,
        "valor": 473145523352.99,
        "delta": -30003300465.78
      },
      {
        "periodo": 202602,
        "valor": 503025343354.48,
        "delta": 29879820001.49
      },
      {
        "periodo": 202603,
        "valor": 473132630513.22,
        "delta": -29892712841.26
      },
      {
        "periodo": 202604,
        "valor": 474396215037.77,
        "delta": 1263584524.55
      },
      {
        "periodo": 202605,
        "valor": 474374761595.77,
        "delta": -21453442.0
      },
      {
        "periodo": 202606,
        "valor": 503810606596.78,
        "delta": 29435845001.01
      },
      {
        "periodo": 202607,
        "valor": 510236716288.92,
        "delta": 6426109692.14
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 1801889305823.66,
    "valor_anterior": 1703262935224.1204,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1812256174916.1897,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1840259017545.07,
        "delta": 28002842628.8804
      },
      {
        "periodo": 202509,
        "valor": 1741245986147.7998,
        "delta": -99013031397.2703
      },
      {
        "periodo": 202510,
        "valor": 1835790272736.67,
        "delta": 94544286588.8701
      },
      {
        "periodo": 202511,
        "valor": 1791935775060.34,
        "delta": -43854497676.3298
      },
      {
        "periodo": 202512,
        "valor": 1627595582237.44,
        "delta": -164340192822.9001
      },
      {
        "periodo": 202601,
        "valor": 1683271767833.28,
        "delta": 55676185595.8401
      },
      {
        "periodo": 202602,
        "valor": 1714582681363.78,
        "delta": 31310913530.5
      },
      {
        "periodo": 202603,
        "valor": 1744828099004.23,
        "delta": 30245417640.45
      },
      {
        "periodo": 202604,
        "valor": 1781230590175.32,
        "delta": 36402491171.0901
      },
      {
        "periodo": 202605,
        "valor": 1843476946636.17,
        "delta": 62246356460.8499
      },
      {
        "periodo": 202606,
        "valor": 1703262935224.1204,
        "delta": -140214011412.0496
      },
      {
        "periodo": 202607,
        "valor": 1801889305823.66,
        "delta": 98626370599.5396
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 1355879317030.72,
    "valor_anterior": 1345757790033.08,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1208263677672.18,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1248083551028.17,
        "delta": 39819873355.99
      },
      {
        "periodo": 202509,
        "valor": 1255315386000.87,
        "delta": 7231834972.7002
      },
      {
        "periodo": 202510,
        "valor": 1256363556461.33,
        "delta": 1048170460.46
      },
      {
        "periodo": 202511,
        "valor": 1251421665588.16,
        "delta": -4941890873.1702
      },
      {
        "periodo": 202512,
        "valor": 1289823116016.98,
        "delta": 38401450428.8201
      },
      {
        "periodo": 202601,
        "valor": 1296606419522.79,
        "delta": 6783303505.8101
      },
      {
        "periodo": 202602,
        "valor": 1307801159408.35,
        "delta": 11194739885.5601
      },
      {
        "periodo": 202603,
        "valor": 1342908145756.57,
        "delta": 35106986348.22
      },
      {
        "periodo": 202604,
        "valor": 1340505326884.03,
        "delta": -2402818872.54
      },
      {
        "periodo": 202605,
        "valor": 1355705331099.4,
        "delta": 15200004215.3699
      },
      {
        "periodo": 202606,
        "valor": 1345757790033.08,
        "delta": -9947541066.3198
      },
      {
        "periodo": 202607,
        "valor": 1355879317030.72,
        "delta": 10121526997.6399
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 396940883026.49,
    "valor_anterior": 401629064954.14,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 323043273362.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 336975546369.79,
        "delta": 13932273007.14
      },
      {
        "periodo": 202509,
        "valor": 354705321586.9301,
        "delta": 17729775217.1401
      },
      {
        "periodo": 202510,
        "valor": 355642825333.23,
        "delta": 937503746.2999
      },
      {
        "periodo": 202511,
        "valor": 361910858406.35,
        "delta": 6268033073.12
      },
      {
        "periodo": 202512,
        "valor": 387832904555.28,
        "delta": 25922046148.9301
      },
      {
        "periodo": 202601,
        "valor": 356139667732.83,
        "delta": -31693236822.45
      },
      {
        "periodo": 202602,
        "valor": 355783322155.54,
        "delta": -356345577.29
      },
      {
        "periodo": 202603,
        "valor": 377624730606.46,
        "delta": 21841408450.92
      },
      {
        "periodo": 202604,
        "valor": 369497721515.82,
        "delta": -8127009090.64
      },
      {
        "periodo": 202605,
        "valor": 367302743840.53,
        "delta": -2194977675.29
      },
      {
        "periodo": 202606,
        "valor": 401629064954.14,
        "delta": 34326321113.61
      },
      {
        "periodo": 202607,
        "valor": 396940883026.49,
        "delta": -4688181927.65
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100001,
    "label": "Activo",
    "valor_actual": 735134381212.43,
    "valor_anterior": 730406429796.9,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 654980403864.54,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 671452323403.91,
        "delta": 16471919539.37
      },
      {
        "periodo": 202509,
        "valor": 658975694128.28,
        "delta": -12476629275.63
      },
      {
        "periodo": 202510,
        "valor": 676124881600.21,
        "delta": 17149187471.9299
      },
      {
        "periodo": 202511,
        "valor": 704996907861.7198,
        "delta": 28872026261.5099
      },
      {
        "periodo": 202512,
        "valor": 683595821992.77,
        "delta": -21401085868.9498
      },
      {
        "periodo": 202601,
        "valor": 695665333355.5,
        "delta": 12069511362.73
      },
      {
        "periodo": 202602,
        "valor": 710418247735.7699,
        "delta": 14752914380.2699
      },
      {
        "periodo": 202603,
        "valor": 721899742022.83,
        "delta": 11481494287.0601
      },
      {
        "periodo": 202604,
        "valor": 728017891042.19,
        "delta": 6118149019.36
      },
      {
        "periodo": 202605,
        "valor": 732981382758.12,
        "delta": 4963491715.9301
      },
      {
        "periodo": 202606,
        "valor": 730406429796.9,
        "delta": -2574952961.22
      },
      {
        "periodo": 202607,
        "valor": 735134381212.43,
        "delta": 4727951415.53
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 186829710784.2,
    "valor_anterior": 185259924321.14,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 177913345798.66,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 179568573570.12,
        "delta": 1655227771.46
      },
      {
        "periodo": 202509,
        "valor": 180328723595.44,
        "delta": 760150025.32
      },
      {
        "periodo": 202510,
        "valor": 181280670474.91,
        "delta": 951946879.47
      },
      {
        "periodo": 202511,
        "valor": 184845750233.97,
        "delta": 3565079759.06
      },
      {
        "periodo": 202512,
        "valor": 181009859644.17,
        "delta": -3835890589.8
      },
      {
        "periodo": 202601,
        "valor": 183502367225.08,
        "delta": 2492507580.91
      },
      {
        "periodo": 202602,
        "valor": 185440213678.13,
        "delta": 1937846453.05
      },
      {
        "periodo": 202603,
        "valor": 186712248112.85,
        "delta": 1272034434.72
      },
      {
        "periodo": 202604,
        "valor": 180017007778.93,
        "delta": -6695240333.92
      },
      {
        "periodo": 202605,
        "valor": 183563296452.2,
        "delta": 3546288673.27
      },
      {
        "periodo": 202606,
        "valor": 185259924321.14,
        "delta": 1696627868.94
      },
      {
        "periodo": 202607,
        "valor": 186829710784.2,
        "delta": 1569786463.06
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 420659957043.43,
    "valor_anterior": 411851448235.7,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 390680591850.54,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 401144423628.91,
        "delta": 10463831778.37
      },
      {
        "periodo": 202509,
        "valor": 394994215807.09,
        "delta": -6150207821.8199
      },
      {
        "periodo": 202510,
        "valor": 403714489337.93,
        "delta": 8720273530.84
      },
      {
        "periodo": 202511,
        "valor": 410355731754.23,
        "delta": 6641242416.3
      },
      {
        "periodo": 202512,
        "valor": 400027428306.48,
        "delta": -10328303447.75
      },
      {
        "periodo": 202601,
        "valor": 410835406150.31,
        "delta": 10807977843.83
      },
      {
        "periodo": 202602,
        "valor": 417472095161.91,
        "delta": 6636689011.6
      },
      {
        "periodo": 202603,
        "valor": 405371176980.16,
        "delta": -12100918181.75
      },
      {
        "periodo": 202604,
        "valor": 415061921193.5099,
        "delta": 9690744213.35
      },
      {
        "periodo": 202605,
        "valor": 423926845876.86,
        "delta": 8864924683.35
      },
      {
        "periodo": 202606,
        "valor": 411851448235.7,
        "delta": -12075397641.16
      },
      {
        "periodo": 202607,
        "valor": 420659957043.43,
        "delta": 8808508807.73
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 172146891450.00003,
    "valor_anterior": 169442840189.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 161669971695.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 164899948829.0,
        "delta": 3229977134.0
      },
      {
        "periodo": 202509,
        "valor": 167381661529.0,
        "delta": 2481712700.0
      },
      {
        "periodo": 202510,
        "valor": 170321179658.0,
        "delta": 2939518129.0
      },
      {
        "periodo": 202511,
        "valor": 172295548132.0,
        "delta": 1974368474.0
      },
      {
        "periodo": 202512,
        "valor": 162469529989.0,
        "delta": -9826018143.0
      },
      {
        "periodo": 202601,
        "valor": 165843591544.0,
        "delta": 3374061555.0
      },
      {
        "periodo": 202602,
        "valor": 168064656982.0,
        "delta": 2221065438.0
      },
      {
        "periodo": 202603,
        "valor": 172321528334.0,
        "delta": 4256871352.0
      },
      {
        "periodo": 202604,
        "valor": 175516672919.0,
        "delta": 3195144585.0
      },
      {
        "periodo": 202605,
        "valor": 177004999647.0,
        "delta": 1488326728.0
      },
      {
        "periodo": 202606,
        "valor": 169442840189.0,
        "delta": -7562159458.0
      },
      {
        "periodo": 202607,
        "valor": 172146891450.0,
        "delta": 2704051261.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 85996845814.0,
    "valor_anterior": 85538907504.00002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 86701785961.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 87796546573.0,
        "delta": 1094760612.0
      },
      {
        "periodo": 202509,
        "valor": 88567922805.0,
        "delta": 771376232.0
      },
      {
        "periodo": 202510,
        "valor": 88804600066.0,
        "delta": 236677261.0
      },
      {
        "periodo": 202511,
        "valor": 87019626233.0,
        "delta": -1784973833.0
      },
      {
        "periodo": 202512,
        "valor": 86235892334.0,
        "delta": -783733899.0
      },
      {
        "periodo": 202601,
        "valor": 87493491897.0,
        "delta": 1257599563.0
      },
      {
        "periodo": 202602,
        "valor": 88573900963.0,
        "delta": 1080409066.0
      },
      {
        "periodo": 202603,
        "valor": 89434997555.0,
        "delta": 861096592.0
      },
      {
        "periodo": 202604,
        "valor": 89591207640.0,
        "delta": 156210085.0
      },
      {
        "periodo": 202605,
        "valor": 89571897780.0,
        "delta": -19309860.0
      },
      {
        "periodo": 202606,
        "valor": 85538907504.0,
        "delta": -4032990276.0
      },
      {
        "periodo": 202607,
        "valor": 85996845814.0,
        "delta": 457938310.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 48096405171.43,
    "valor_anterior": 47469050457.14,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 45523253304.59,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 46337389371.96,
        "delta": 814136067.37
      },
      {
        "periodo": 202509,
        "valor": 47108401107.23,
        "delta": 771011735.27
      },
      {
        "periodo": 202510,
        "valor": 47851102465.05,
        "delta": 742701357.82
      },
      {
        "periodo": 202511,
        "valor": 47541132625.06,
        "delta": -309969839.99
      },
      {
        "periodo": 202512,
        "valor": 47839304762.59,
        "delta": 298172137.53
      },
      {
        "periodo": 202601,
        "valor": 48903681787.03,
        "delta": 1064377024.44
      },
      {
        "periodo": 202602,
        "valor": 49449007962.2,
        "delta": 545326175.17
      },
      {
        "periodo": 202603,
        "valor": 49840481304.18,
        "delta": 391473341.98
      },
      {
        "periodo": 202604,
        "valor": 46060980664.01,
        "delta": -3779500640.17
      },
      {
        "periodo": 202605,
        "valor": 46796698727.53,
        "delta": 735718063.52
      },
      {
        "periodo": 202606,
        "valor": 47469050457.14,
        "delta": 672351729.61
      },
      {
        "periodo": 202607,
        "valor": 48096405171.43,
        "delta": 627354714.29
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 218037179933.0,
    "valor_anterior": 216790083240.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 200527290219.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 201509512445.0,
        "delta": 982222226.0
      },
      {
        "periodo": 202509,
        "valor": 202541754683.0,
        "delta": 1032242238.0
      },
      {
        "periodo": 202510,
        "valor": 204314845494.0,
        "delta": 1773090811.0
      },
      {
        "periodo": 202511,
        "valor": 205912057615.0,
        "delta": 1597212121.0
      },
      {
        "periodo": 202512,
        "valor": 209141038175.0,
        "delta": 3228980560.0
      },
      {
        "periodo": 202601,
        "valor": 210734633464.0,
        "delta": 1593595289.0
      },
      {
        "periodo": 202602,
        "valor": 211949063609.0,
        "delta": 1214430145.0
      },
      {
        "periodo": 202603,
        "valor": 214213093138.0,
        "delta": 2264029529.0
      },
      {
        "periodo": 202604,
        "valor": 215030957351.0,
        "delta": 817864213.0
      },
      {
        "periodo": 202605,
        "valor": 216025365331.0,
        "delta": 994407980.0
      },
      {
        "periodo": 202606,
        "valor": 216790083240.0,
        "delta": 764717909.0
      },
      {
        "periodo": 202607,
        "valor": 218037179933.0,
        "delta": 1247096693.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 18521363282.0,
    "valor_anterior": 18214899277.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15431919306.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15721823261.0,
        "delta": 289903955.0
      },
      {
        "periodo": 202509,
        "valor": 16021600834.0,
        "delta": 299777573.0
      },
      {
        "periodo": 202510,
        "valor": 16340032340.0,
        "delta": 318431506.0
      },
      {
        "periodo": 202511,
        "valor": 16682467665.0,
        "delta": 342435325.0
      },
      {
        "periodo": 202512,
        "valor": 16942801183.0,
        "delta": 260333518.0
      },
      {
        "periodo": 202601,
        "valor": 17224819402.0,
        "delta": 282018219.0
      },
      {
        "periodo": 202602,
        "valor": 17498127482.0,
        "delta": 273308080.0
      },
      {
        "periodo": 202603,
        "valor": 17820287047.0,
        "delta": 322159565.0
      },
      {
        "periodo": 202604,
        "valor": 18104340755.0,
        "delta": 284053708.0
      },
      {
        "periodo": 202605,
        "valor": 17911039626.0,
        "delta": -193301129.0
      },
      {
        "periodo": 202606,
        "valor": 18214899277.0,
        "delta": 303859651.0
      },
      {
        "periodo": 202607,
        "valor": 18521363282.0,
        "delta": 306464005.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 99243519052.0,
    "valor_anterior": 98163059691.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 91615060883.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 92317678428.0,
        "delta": 702617545.0
      },
      {
        "periodo": 202509,
        "valor": 93061955131.0,
        "delta": 744276703.0
      },
      {
        "periodo": 202510,
        "valor": 93445319086.0,
        "delta": 383363955.0
      },
      {
        "periodo": 202511,
        "valor": 94109022277.0,
        "delta": 663703191.0
      },
      {
        "periodo": 202512,
        "valor": 95155318152.0,
        "delta": 1046295875.0
      },
      {
        "periodo": 202601,
        "valor": 96330380071.0,
        "delta": 1175061919.0
      },
      {
        "periodo": 202602,
        "valor": 97039978803.0,
        "delta": 709598732.0
      },
      {
        "periodo": 202603,
        "valor": 96682950474.0,
        "delta": -357028329.0
      },
      {
        "periodo": 202604,
        "valor": 96679111352.0,
        "delta": -3839122.0
      },
      {
        "periodo": 202605,
        "valor": 97251757559.0,
        "delta": 572646207.0
      },
      {
        "periodo": 202606,
        "valor": 98163059691.0,
        "delta": 911302132.0
      },
      {
        "periodo": 202607,
        "valor": 99243519052.0,
        "delta": 1080459361.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 35788332873.87,
    "valor_anterior": 35257747440.49,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 32804637403.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 33331255099.88,
        "delta": 526617695.98
      },
      {
        "periodo": 202509,
        "valor": 33905245824.41,
        "delta": 573990724.53
      },
      {
        "periodo": 202510,
        "valor": 34458086221.97,
        "delta": 552840397.56
      },
      {
        "periodo": 202511,
        "valor": 33808034049.34,
        "delta": -650052172.63
      },
      {
        "periodo": 202512,
        "valor": 34420829243.57,
        "delta": 612795194.23
      },
      {
        "periodo": 202601,
        "valor": 34955063389.4,
        "delta": 534234145.83
      },
      {
        "periodo": 202602,
        "valor": 35063910117.75,
        "delta": 108846728.35
      },
      {
        "periodo": 202603,
        "valor": 33701057434.0,
        "delta": -1362852683.75
      },
      {
        "periodo": 202604,
        "valor": 34311639658.06,
        "delta": 610582224.06
      },
      {
        "periodo": 202605,
        "valor": 34800543346.48,
        "delta": 488903688.42
      },
      {
        "periodo": 202606,
        "valor": 35257747440.49,
        "delta": 457204094.01
      },
      {
        "periodo": 202607,
        "valor": 35788332873.87,
        "delta": 530585433.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 12108719201.999998,
    "valor_anterior": 11867662565.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10708487027.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10752405981.0,
        "delta": 43918954.0
      },
      {
        "periodo": 202509,
        "valor": 10972741198.0,
        "delta": 220335217.0
      },
      {
        "periodo": 202510,
        "valor": 11187435390.0,
        "delta": 214694192.0
      },
      {
        "periodo": 202511,
        "valor": 11186064726.0,
        "delta": -1370664.0
      },
      {
        "periodo": 202512,
        "valor": 11238572957.0,
        "delta": 52508231.0
      },
      {
        "periodo": 202601,
        "valor": 11207372238.0,
        "delta": -31200719.0
      },
      {
        "periodo": 202602,
        "valor": 11233449305.0,
        "delta": 26077067.0
      },
      {
        "periodo": 202603,
        "valor": 11350154751.0,
        "delta": 116705446.0
      },
      {
        "periodo": 202604,
        "valor": 11399494275.0,
        "delta": 49339524.0
      },
      {
        "periodo": 202605,
        "valor": 11709655889.0,
        "delta": 310161614.0
      },
      {
        "periodo": 202606,
        "valor": 11867662565.0,
        "delta": 158006676.0
      },
      {
        "periodo": 202607,
        "valor": 12108719202.0,
        "delta": 241056637.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 9051879252.0,
    "valor_anterior": 8951248286.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7777430978.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7915639484.0,
        "delta": 138208506.0
      },
      {
        "periodo": 202509,
        "valor": 8051115043.0,
        "delta": 135475559.0
      },
      {
        "periodo": 202510,
        "valor": 8146006330.0,
        "delta": 94891287.0
      },
      {
        "periodo": 202511,
        "valor": 8247638222.0,
        "delta": 101631892.0
      },
      {
        "periodo": 202512,
        "valor": 8379155158.0,
        "delta": 131516936.0
      },
      {
        "periodo": 202601,
        "valor": 8433238597.0,
        "delta": 54083439.0
      },
      {
        "periodo": 202602,
        "valor": 8537378213.0,
        "delta": 104139616.0
      },
      {
        "periodo": 202603,
        "valor": 8652557527.0,
        "delta": 115179314.0
      },
      {
        "periodo": 202604,
        "valor": 8757467034.0,
        "delta": 104909507.0
      },
      {
        "periodo": 202605,
        "valor": 8846985471.0,
        "delta": 89518437.0
      },
      {
        "periodo": 202606,
        "valor": 8951248286.0,
        "delta": 104262815.0
      },
      {
        "periodo": 202607,
        "valor": 9051879252.0,
        "delta": 100630966.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 9591677889.999998,
    "valor_anterior": 9515709120.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9157207421.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9236038458.0,
        "delta": 78831037.0
      },
      {
        "periodo": 202509,
        "valor": 9276104086.0,
        "delta": 40065628.0
      },
      {
        "periodo": 202510,
        "valor": 9131220858.0,
        "delta": -144883228.0
      },
      {
        "periodo": 202511,
        "valor": 9219501727.0,
        "delta": 88280869.0
      },
      {
        "periodo": 202512,
        "valor": 8892703622.0,
        "delta": -326798105.0
      },
      {
        "periodo": 202601,
        "valor": 8980583102.0,
        "delta": 87879480.0
      },
      {
        "periodo": 202602,
        "valor": 8992283733.0,
        "delta": 11700631.0
      },
      {
        "periodo": 202603,
        "valor": 9272460664.0,
        "delta": 280176931.0
      },
      {
        "periodo": 202604,
        "valor": 9352537687.0,
        "delta": 80077023.0
      },
      {
        "periodo": 202605,
        "valor": 9421381788.0,
        "delta": 68844101.0
      },
      {
        "periodo": 202606,
        "valor": 9515709120.0,
        "delta": 94327332.0
      },
      {
        "periodo": 202607,
        "valor": 9591677890.0,
        "delta": 75968770.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 159050471768.32,
    "valor_anterior": 160865475572.64,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 166405231627.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 170852085689.12,
        "delta": 4446854061.25
      },
      {
        "periodo": 202509,
        "valor": 174062427658.15,
        "delta": 3210341969.03
      },
      {
        "periodo": 202510,
        "valor": 177580563051.06,
        "delta": 3518135392.91
      },
      {
        "periodo": 202511,
        "valor": 155558929529.47,
        "delta": -22021633521.59
      },
      {
        "periodo": 202512,
        "valor": 152102514721.89,
        "delta": -3456414807.58
      },
      {
        "periodo": 202601,
        "valor": 155692305486.39,
        "delta": 3589790764.5
      },
      {
        "periodo": 202602,
        "valor": 160116312734.69,
        "delta": 4424007248.3
      },
      {
        "periodo": 202603,
        "valor": 162061994620.01,
        "delta": 1945681885.32
      },
      {
        "periodo": 202604,
        "valor": 152745918351.7,
        "delta": -9316076268.31
      },
      {
        "periodo": 202605,
        "valor": 156207178685.79,
        "delta": 3461260334.09
      },
      {
        "periodo": 202606,
        "valor": 160865475572.64,
        "delta": 4658296886.85
      },
      {
        "periodo": 202607,
        "valor": 159050471768.32,
        "delta": -1815003804.32
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 24917366575.0,
    "valor_anterior": 24736628097.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 23056015843.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23193314767.0,
        "delta": 137298924.0
      },
      {
        "periodo": 202509,
        "valor": 23231558935.0,
        "delta": 38244168.0
      },
      {
        "periodo": 202510,
        "valor": 23493069590.0,
        "delta": 261510655.0
      },
      {
        "periodo": 202511,
        "valor": 23404111582.0,
        "delta": -88958008.0
      },
      {
        "periodo": 202512,
        "valor": 23641486667.0,
        "delta": 237375085.0
      },
      {
        "periodo": 202601,
        "valor": 23870082534.0,
        "delta": 228595867.0
      },
      {
        "periodo": 202602,
        "valor": 24065463768.0,
        "delta": 195381234.0
      },
      {
        "periodo": 202603,
        "valor": 24329756982.0,
        "delta": 264293214.0
      },
      {
        "periodo": 202604,
        "valor": 24665817607.0,
        "delta": 336060625.0
      },
      {
        "periodo": 202605,
        "valor": 24645206318.0,
        "delta": -20611289.0
      },
      {
        "periodo": 202606,
        "valor": 24736628097.0,
        "delta": 91421779.0
      },
      {
        "periodo": 202607,
        "valor": 24917366575.0,
        "delta": 180738478.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 10308927948.0,
    "valor_anterior": 10239722015.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9537338260.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9638699910.0,
        "delta": 101361650.0
      },
      {
        "periodo": 202509,
        "valor": 9739055579.0,
        "delta": 100355669.0
      },
      {
        "periodo": 202510,
        "valor": 9801094350.0,
        "delta": 62038771.0
      },
      {
        "periodo": 202511,
        "valor": 9889116266.0,
        "delta": 88021916.0
      },
      {
        "periodo": 202512,
        "valor": 9969725842.0,
        "delta": 80609576.0
      },
      {
        "periodo": 202601,
        "valor": 10029442258.0,
        "delta": 59716416.0
      },
      {
        "periodo": 202602,
        "valor": 10049759563.0,
        "delta": 20317305.0
      },
      {
        "periodo": 202603,
        "valor": 10081457665.0,
        "delta": 31698102.0
      },
      {
        "periodo": 202604,
        "valor": 10163805882.0,
        "delta": 82348217.0
      },
      {
        "periodo": 202605,
        "valor": 10225310166.0,
        "delta": 61504284.0
      },
      {
        "periodo": 202606,
        "valor": 10239722015.0,
        "delta": 14411849.0
      },
      {
        "periodo": 202607,
        "valor": 10308927948.0,
        "delta": 69205933.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 40538494185.0,
    "valor_anterior": 40274636249.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 36320432270.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 36986561650.0,
        "delta": 666129380.0
      },
      {
        "periodo": 202509,
        "valor": 37594940198.0,
        "delta": 608378548.0
      },
      {
        "periodo": 202510,
        "valor": 38003201145.0,
        "delta": 408260947.0
      },
      {
        "periodo": 202511,
        "valor": 38283137230.0,
        "delta": 279936085.0
      },
      {
        "periodo": 202512,
        "valor": 38534220859.0,
        "delta": 251083629.0
      },
      {
        "periodo": 202601,
        "valor": 38755318252.0,
        "delta": 221097393.0
      },
      {
        "periodo": 202602,
        "valor": 39146394711.0,
        "delta": 391076459.0
      },
      {
        "periodo": 202603,
        "valor": 39505677268.0,
        "delta": 359282557.0
      },
      {
        "periodo": 202604,
        "valor": 39742896841.0,
        "delta": 237219573.0
      },
      {
        "periodo": 202605,
        "valor": 40030240024.0,
        "delta": 287343183.0
      },
      {
        "periodo": 202606,
        "valor": 40274636249.0,
        "delta": 244396225.0
      },
      {
        "periodo": 202607,
        "valor": 40538494185.0,
        "delta": 263857936.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 17813861870.65,
    "valor_anterior": 18553406335.76,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16005033181.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16344358689.05,
        "delta": 339325507.79
      },
      {
        "periodo": 202509,
        "valor": 16694474000.48,
        "delta": 350115311.43
      },
      {
        "periodo": 202510,
        "valor": 17093794580.68,
        "delta": 399320580.2
      },
      {
        "periodo": 202511,
        "valor": 17322984048.11,
        "delta": 229189467.43
      },
      {
        "periodo": 202512,
        "valor": 17751280296.94,
        "delta": 428296248.83
      },
      {
        "periodo": 202601,
        "valor": 18155326084.98,
        "delta": 404045788.04
      },
      {
        "periodo": 202602,
        "valor": 18425656982.09,
        "delta": 270330897.11
      },
      {
        "periodo": 202603,
        "valor": 18453619022.11,
        "delta": 27962040.02
      },
      {
        "periodo": 202604,
        "valor": 17845615463.97,
        "delta": -608003558.14
      },
      {
        "periodo": 202605,
        "valor": 18191632077.96,
        "delta": 346016613.99
      },
      {
        "periodo": 202606,
        "valor": 18553406335.76,
        "delta": 361774257.8
      },
      {
        "periodo": 202607,
        "valor": 17813861870.65,
        "delta": -739544465.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 11247489495.0,
    "valor_anterior": 11235447641.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10261190138.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10310747840.0,
        "delta": 49557702.0
      },
      {
        "periodo": 202509,
        "valor": 10426975483.0,
        "delta": 116227643.0
      },
      {
        "periodo": 202510,
        "valor": 10420226222.0,
        "delta": -6749261.0
      },
      {
        "periodo": 202511,
        "valor": 10501389517.0,
        "delta": 81163295.0
      },
      {
        "periodo": 202512,
        "valor": 10617015679.0,
        "delta": 115626162.0
      },
      {
        "periodo": 202601,
        "valor": 10704964476.0,
        "delta": 87948797.0
      },
      {
        "periodo": 202602,
        "valor": 10726391238.0,
        "delta": 21426762.0
      },
      {
        "periodo": 202603,
        "valor": 10906941629.0,
        "delta": 180550391.0
      },
      {
        "periodo": 202604,
        "valor": 11030849503.0,
        "delta": 123907874.0
      },
      {
        "periodo": 202605,
        "valor": 11106881421.0,
        "delta": 76031918.0
      },
      {
        "periodo": 202606,
        "valor": 11235447641.0,
        "delta": 128566220.0
      },
      {
        "periodo": 202607,
        "valor": 11247489495.0,
        "delta": 12041854.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 85035161535.58,
    "valor_anterior": 84574763285.37,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 75077877754.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 76590888770.86,
        "delta": 1513011015.96
      },
      {
        "periodo": 202509,
        "valor": 77440191175.94,
        "delta": 849302405.08
      },
      {
        "periodo": 202510,
        "valor": 78416245235.98,
        "delta": 976054060.04
      },
      {
        "periodo": 202511,
        "valor": 78834236869.99,
        "delta": 417991634.01
      },
      {
        "periodo": 202512,
        "valor": 80343514051.64,
        "delta": 1509277181.65
      },
      {
        "periodo": 202601,
        "valor": 81611961718.11,
        "delta": 1268447666.47
      },
      {
        "periodo": 202602,
        "valor": 82497356737.12,
        "delta": 885395019.01
      },
      {
        "periodo": 202603,
        "valor": 81776444444.07,
        "delta": -720912293.05
      },
      {
        "periodo": 202604,
        "valor": 83095765365.5,
        "delta": 1319320921.43
      },
      {
        "periodo": 202605,
        "valor": 84123092395.98,
        "delta": 1027327030.48
      },
      {
        "periodo": 202606,
        "valor": 84574763285.37,
        "delta": 451670889.39
      },
      {
        "periodo": 202607,
        "valor": 85035161535.58,
        "delta": 460398250.21
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 2093725155.0,
    "valor_anterior": 2095207014.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2148145170.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2134753315.0,
        "delta": -13391855.0
      },
      {
        "periodo": 202509,
        "valor": 2124311331.0,
        "delta": -10441984.0
      },
      {
        "periodo": 202510,
        "valor": 2133432924.0,
        "delta": 9121593.0
      },
      {
        "periodo": 202511,
        "valor": 2111966859.0,
        "delta": -21466065.0
      },
      {
        "periodo": 202512,
        "valor": 2081844485.0,
        "delta": -30122374.0
      },
      {
        "periodo": 202601,
        "valor": 2087123086.0,
        "delta": 5278601.0
      },
      {
        "periodo": 202602,
        "valor": 2087625246.0,
        "delta": 502160.0
      },
      {
        "periodo": 202603,
        "valor": 2084840601.0,
        "delta": -2784645.0
      },
      {
        "periodo": 202604,
        "valor": 2089793489.0,
        "delta": 4952888.0
      },
      {
        "periodo": 202605,
        "valor": 2089938884.0,
        "delta": 145395.0
      },
      {
        "periodo": 202606,
        "valor": 2095207014.0,
        "delta": 5268130.0
      },
      {
        "periodo": 202607,
        "valor": 2093725155.0,
        "delta": -1481859.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 47160369277.52,
    "valor_anterior": 47498123568.4,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 44506629889.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 44985170455.65,
        "delta": 478540566.46
      },
      {
        "periodo": 202509,
        "valor": 47426020016.17,
        "delta": 2440849560.52
      },
      {
        "periodo": 202510,
        "valor": 48406382497.65,
        "delta": 980362481.48
      },
      {
        "periodo": 202511,
        "valor": 49012257392.68,
        "delta": 605874895.03
      },
      {
        "periodo": 202512,
        "valor": 50065737902.75,
        "delta": 1053480510.07
      },
      {
        "periodo": 202601,
        "valor": 49130692183.28,
        "delta": -935045719.47
      },
      {
        "periodo": 202602,
        "valor": 49665015257.66,
        "delta": 534323074.38
      },
      {
        "periodo": 202603,
        "valor": 50371814757.8,
        "delta": 706799500.14
      },
      {
        "periodo": 202604,
        "valor": 49198364625.49,
        "delta": -1173450132.31
      },
      {
        "periodo": 202605,
        "valor": 48465818538.46,
        "delta": -732546087.03
      },
      {
        "periodo": 202606,
        "valor": 47498123568.4,
        "delta": -967694970.06
      },
      {
        "periodo": 202607,
        "valor": 47160369277.52,
        "delta": -337754290.88
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 6226654683.000001,
    "valor_anterior": 6353104248.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1840513536.59,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1895635381.54,
        "delta": 55121844.95
      },
      {
        "periodo": 202509,
        "valor": 4185233863.0,
        "delta": 2289598481.46
      },
      {
        "periodo": 202510,
        "valor": 4850799262.0,
        "delta": 665565399.0
      },
      {
        "periodo": 202511,
        "valor": 4831741817.0,
        "delta": -19057445.0
      },
      {
        "periodo": 202512,
        "valor": 5000109122.0,
        "delta": 168367305.0
      },
      {
        "periodo": 202601,
        "valor": 5157203906.0,
        "delta": 157094784.0
      },
      {
        "periodo": 202602,
        "valor": 5332739201.0,
        "delta": 175535295.0
      },
      {
        "periodo": 202603,
        "valor": 5728379579.0,
        "delta": 395640378.0
      },
      {
        "periodo": 202604,
        "valor": 5845129872.0,
        "delta": 116750293.0
      },
      {
        "periodo": 202605,
        "valor": 5962645837.0,
        "delta": 117515965.0
      },
      {
        "periodo": 202606,
        "valor": 6353104248.0,
        "delta": 390458411.0
      },
      {
        "periodo": 202607,
        "valor": 6226654683.0,
        "delta": -126449565.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 8811572771.0,
    "valor_anterior": 8818192608.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9238125237.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9189686559.0,
        "delta": -48438678.0
      },
      {
        "periodo": 202509,
        "valor": 9267768475.0,
        "delta": 78081916.0
      },
      {
        "periodo": 202510,
        "valor": 9324010711.0,
        "delta": 56242236.0
      },
      {
        "periodo": 202511,
        "valor": 8583832871.0,
        "delta": -740177840.0
      },
      {
        "periodo": 202512,
        "valor": 8480343839.0,
        "delta": -103489032.0
      },
      {
        "periodo": 202601,
        "valor": 8543498517.0,
        "delta": 63154678.0
      },
      {
        "periodo": 202602,
        "valor": 8650727942.0,
        "delta": 107229425.0
      },
      {
        "periodo": 202603,
        "valor": 8678770027.0,
        "delta": 28042085.0
      },
      {
        "periodo": 202604,
        "valor": 8738631241.0,
        "delta": 59861214.0
      },
      {
        "periodo": 202605,
        "valor": 8806463124.0,
        "delta": 67831883.0
      },
      {
        "periodo": 202606,
        "valor": 8818192608.0,
        "delta": 11729484.0
      },
      {
        "periodo": 202607,
        "valor": 8811572771.0,
        "delta": -6619837.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 20691199904.0,
    "valor_anterior": 20233611611.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18069247367.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18575349177.0,
        "delta": 506101810.0
      },
      {
        "periodo": 202509,
        "valor": 19080195086.0,
        "delta": 504845909.0
      },
      {
        "periodo": 202510,
        "valor": 19508954254.0,
        "delta": 428759168.0
      },
      {
        "periodo": 202511,
        "valor": 18560031326.0,
        "delta": -948922928.0
      },
      {
        "periodo": 202512,
        "valor": 18898898443.0,
        "delta": 338867117.0
      },
      {
        "periodo": 202601,
        "valor": 19521174836.0,
        "delta": 622276393.0
      },
      {
        "periodo": 202602,
        "valor": 20053039323.0,
        "delta": 531864487.0
      },
      {
        "periodo": 202603,
        "valor": 20554363060.0,
        "delta": 501323737.0
      },
      {
        "periodo": 202604,
        "valor": 19093955634.0,
        "delta": -1460407426.0
      },
      {
        "periodo": 202605,
        "valor": 19622954899.0,
        "delta": 528999265.0
      },
      {
        "periodo": 202606,
        "valor": 20233611611.0,
        "delta": 610656712.0
      },
      {
        "periodo": 202607,
        "valor": 20691199904.0,
        "delta": 457588293.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 12020838817.0,
    "valor_anterior": 11839232676.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10193225486.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10295787783.0,
        "delta": 102562297.0
      },
      {
        "periodo": 202509,
        "valor": 10502168409.0,
        "delta": 206380626.0
      },
      {
        "periodo": 202510,
        "valor": 10739194891.0,
        "delta": 237026482.0
      },
      {
        "periodo": 202511,
        "valor": 10891033414.0,
        "delta": 151838523.0
      },
      {
        "periodo": 202512,
        "valor": 10983933744.0,
        "delta": 92900330.0
      },
      {
        "periodo": 202601,
        "valor": 11103541297.0,
        "delta": 119607553.0
      },
      {
        "periodo": 202602,
        "valor": 11194725759.0,
        "delta": 91184462.0
      },
      {
        "periodo": 202603,
        "valor": 11307420347.0,
        "delta": 112694588.0
      },
      {
        "periodo": 202604,
        "valor": 11447294444.0,
        "delta": 139874097.0
      },
      {
        "periodo": 202605,
        "valor": 11608465486.0,
        "delta": 161171042.0
      },
      {
        "periodo": 202606,
        "valor": 11839232676.0,
        "delta": 230767190.0
      },
      {
        "periodo": 202607,
        "valor": 12020838817.0,
        "delta": 181606141.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 7165225502.0,
    "valor_anterior": 7132529800.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6901927538.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6901367831.0,
        "delta": -559707.0
      },
      {
        "periodo": 202509,
        "valor": 6991895082.0,
        "delta": 90527251.0
      },
      {
        "periodo": 202510,
        "valor": 7053556810.0,
        "delta": 61661728.0
      },
      {
        "periodo": 202511,
        "valor": 7037507515.0,
        "delta": -16049295.0
      },
      {
        "periodo": 202512,
        "valor": 7092917793.0,
        "delta": 55410278.0
      },
      {
        "periodo": 202601,
        "valor": 7083242397.0,
        "delta": -9675396.0
      },
      {
        "periodo": 202602,
        "valor": 7107625507.0,
        "delta": 24383110.0
      },
      {
        "periodo": 202603,
        "valor": 7028148148.0,
        "delta": -79477359.0
      },
      {
        "periodo": 202604,
        "valor": 7064828726.0,
        "delta": 36680578.0
      },
      {
        "periodo": 202605,
        "valor": 7153748225.0,
        "delta": 88919499.0
      },
      {
        "periodo": 202606,
        "valor": 7132529801.0,
        "delta": -21218424.0
      },
      {
        "periodo": 202607,
        "valor": 7165225502.0,
        "delta": 32695701.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 3021277819.0,
    "valor_anterior": 3182167491.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11498794077.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11335531566.0,
        "delta": -163262511.0
      },
      {
        "periodo": 202509,
        "valor": 10116644327.0,
        "delta": -1218887239.0
      },
      {
        "periodo": 202510,
        "valor": 10022657081.0,
        "delta": -93987246.0
      },
      {
        "periodo": 202511,
        "valor": 4216275755.0,
        "delta": -5806381326.0
      },
      {
        "periodo": 202512,
        "valor": 4102217108.0,
        "delta": -114058647.0
      },
      {
        "periodo": 202601,
        "valor": 4140432779.0,
        "delta": 38215671.0
      },
      {
        "periodo": 202602,
        "valor": 4206056107.0,
        "delta": 65623328.0
      },
      {
        "periodo": 202603,
        "valor": 4217232152.0,
        "delta": 11176045.0
      },
      {
        "periodo": 202604,
        "valor": 3673074035.0,
        "delta": -544158117.0
      },
      {
        "periodo": 202605,
        "valor": 3648871556.0,
        "delta": -24202479.0
      },
      {
        "periodo": 202606,
        "valor": 3182167491.0,
        "delta": -466704065.0
      },
      {
        "periodo": 202607,
        "valor": 3021277819.0,
        "delta": -160889672.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 24408280487.76,
    "valor_anterior": 24334103618.41,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22937694659.12,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23537743192.17,
        "delta": 600048533.05
      },
      {
        "periodo": 202509,
        "valor": 22856588223.17,
        "delta": -681154969.0
      },
      {
        "periodo": 202510,
        "valor": 23097826550.94,
        "delta": 241238327.77
      },
      {
        "periodo": 202511,
        "valor": 23184904528.19,
        "delta": 87077977.25
      },
      {
        "periodo": 202512,
        "valor": 22990170431.02,
        "delta": -194734097.17
      },
      {
        "periodo": 202601,
        "valor": 23296974098.78,
        "delta": 306803667.76
      },
      {
        "periodo": 202602,
        "valor": 23909493637.36,
        "delta": 612519538.58
      },
      {
        "periodo": 202603,
        "valor": 22870246894.83,
        "delta": -1039246742.53
      },
      {
        "periodo": 202604,
        "valor": 23270772898.28,
        "delta": 400526003.45
      },
      {
        "periodo": 202605,
        "valor": 23649051725.51,
        "delta": 378278827.23
      },
      {
        "periodo": 202606,
        "valor": 24334103618.41,
        "delta": 685051892.9
      },
      {
        "periodo": 202607,
        "valor": 24408280487.76,
        "delta": 74176869.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 787318578.0,
    "valor_anterior": 866784402.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 856485520.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1056884101.0,
        "delta": 200398581.0
      },
      {
        "periodo": 202509,
        "valor": 966112707.0,
        "delta": -90771394.0
      },
      {
        "periodo": 202510,
        "valor": 857339904.0,
        "delta": -108772803.0
      },
      {
        "periodo": 202511,
        "valor": 723778875.0,
        "delta": -133561029.0
      },
      {
        "periodo": 202512,
        "valor": 897741059.0,
        "delta": 173962184.0
      },
      {
        "periodo": 202601,
        "valor": 812565097.0,
        "delta": -85175962.0
      },
      {
        "periodo": 202602,
        "valor": 705421710.0,
        "delta": -107143387.0
      },
      {
        "periodo": 202603,
        "valor": 851632121.0,
        "delta": 146210411.0
      },
      {
        "periodo": 202604,
        "valor": 762402219.0,
        "delta": -89229902.0
      },
      {
        "periodo": 202605,
        "valor": 690967389.0,
        "delta": -71434830.0
      },
      {
        "periodo": 202606,
        "valor": 866784402.0,
        "delta": 175817013.0
      },
      {
        "periodo": 202607,
        "valor": 787318578.0,
        "delta": -79465824.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 1242919414.0,
    "valor_anterior": 1238707319.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1171960641.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1181965600.0,
        "delta": 10004959.0
      },
      {
        "periodo": 202509,
        "valor": 1196330336.0,
        "delta": 14364736.0
      },
      {
        "periodo": 202510,
        "valor": 1205448166.0,
        "delta": 9117830.0
      },
      {
        "periodo": 202511,
        "valor": 1206770685.0,
        "delta": 1322519.0
      },
      {
        "periodo": 202512,
        "valor": 1202856550.0,
        "delta": -3914135.0
      },
      {
        "periodo": 202601,
        "valor": 1205608245.0,
        "delta": 2751695.0
      },
      {
        "periodo": 202602,
        "valor": 1209629000.0,
        "delta": 4020755.0
      },
      {
        "periodo": 202603,
        "valor": 1217491810.0,
        "delta": 7862810.0
      },
      {
        "periodo": 202604,
        "valor": 1223818884.0,
        "delta": 6327074.0
      },
      {
        "periodo": 202605,
        "valor": 1232671231.0,
        "delta": 8852347.0
      },
      {
        "periodo": 202606,
        "valor": 1238707319.0,
        "delta": 6036088.0
      },
      {
        "periodo": 202607,
        "valor": 1242919414.0,
        "delta": 4212095.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 6201943176.999999,
    "valor_anterior": 6156379936.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4842609869.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4960693694.0,
        "delta": 118083825.0
      },
      {
        "periodo": 202509,
        "valor": 5085679181.0,
        "delta": 124985487.0
      },
      {
        "periodo": 202510,
        "valor": 5188260564.0,
        "delta": 102581383.0
      },
      {
        "periodo": 202511,
        "valor": 5341356359.0,
        "delta": 153095795.0
      },
      {
        "periodo": 202512,
        "valor": 5426265468.0,
        "delta": 84909109.0
      },
      {
        "periodo": 202601,
        "valor": 5530394054.0,
        "delta": 104128586.0
      },
      {
        "periodo": 202602,
        "valor": 5668419730.0,
        "delta": 138025676.0
      },
      {
        "periodo": 202603,
        "valor": 5820091856.0,
        "delta": 151672126.0
      },
      {
        "periodo": 202604,
        "valor": 5957692323.0,
        "delta": 137600467.0
      },
      {
        "periodo": 202605,
        "valor": 6069011569.0,
        "delta": 111319246.0
      },
      {
        "periodo": 202606,
        "valor": 6156379937.0,
        "delta": 87368368.0
      },
      {
        "periodo": 202607,
        "valor": 6201943177.0,
        "delta": 45563240.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 4059725423.0,
    "valor_anterior": 4014971865.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3671768360.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3693078697.0,
        "delta": 21310337.0
      },
      {
        "periodo": 202509,
        "valor": 3743006954.0,
        "delta": 49928257.0
      },
      {
        "periodo": 202510,
        "valor": 3738177162.0,
        "delta": -4829792.0
      },
      {
        "periodo": 202511,
        "valor": 3743682758.0,
        "delta": 5505596.0
      },
      {
        "periodo": 202512,
        "valor": 3798114629.0,
        "delta": 54431871.0
      },
      {
        "periodo": 202601,
        "valor": 3820383042.0,
        "delta": 22268413.0
      },
      {
        "periodo": 202602,
        "valor": 3889101984.0,
        "delta": 68718942.0
      },
      {
        "periodo": 202603,
        "valor": 3945275194.0,
        "delta": 56173210.0
      },
      {
        "periodo": 202604,
        "valor": 3940327422.0,
        "delta": -4947772.0
      },
      {
        "periodo": 202605,
        "valor": 3948706778.0,
        "delta": 8379356.0
      },
      {
        "periodo": 202606,
        "valor": 4014971865.0,
        "delta": 66265087.0
      },
      {
        "periodo": 202607,
        "valor": 4059725423.0,
        "delta": 44753558.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6057311705.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5176284990.0,
        "delta": -881026715.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 8101403360.0,
    "valor_anterior": 7952759511.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7380864525.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7536416390.0,
        "delta": 155551865.0
      },
      {
        "periodo": 202509,
        "valor": 7043104889.0,
        "delta": -493311501.0
      },
      {
        "periodo": 202510,
        "valor": 7237220575.0,
        "delta": 194115686.0
      },
      {
        "periodo": 202511,
        "valor": 7314300459.0,
        "delta": 77079884.0
      },
      {
        "periodo": 202512,
        "valor": 7622655794.0,
        "delta": 308355335.0
      },
      {
        "periodo": 202601,
        "valor": 7720766561.0,
        "delta": 98110767.0
      },
      {
        "periodo": 202602,
        "valor": 7834213312.0,
        "delta": 113446751.0
      },
      {
        "periodo": 202603,
        "valor": 8000556774.0,
        "delta": 166343462.0
      },
      {
        "periodo": 202604,
        "valor": 7685921846.0,
        "delta": -314634928.0
      },
      {
        "periodo": 202605,
        "valor": 7815199742.0,
        "delta": 129277896.0
      },
      {
        "periodo": 202606,
        "valor": 7952759511.0,
        "delta": 137559769.0
      },
      {
        "periodo": 202607,
        "valor": 8101403360.0,
        "delta": 148643849.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 2723564582.0,
    "valor_anterior": 2796500970.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2053663010.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2160673062.0,
        "delta": 107010052.0
      },
      {
        "periodo": 202509,
        "valor": 2178518202.0,
        "delta": 17845140.0
      },
      {
        "periodo": 202510,
        "valor": 2228699032.0,
        "delta": 50180830.0
      },
      {
        "periodo": 202511,
        "valor": 2260610850.0,
        "delta": 31911818.0
      },
      {
        "periodo": 202512,
        "valor": 2469551053.0,
        "delta": 208940203.0
      },
      {
        "periodo": 202601,
        "valor": 2476111451.0,
        "delta": 6560398.0
      },
      {
        "periodo": 202602,
        "valor": 2566940858.0,
        "delta": 90829407.0
      },
      {
        "periodo": 202603,
        "valor": 2682349054.0,
        "delta": 115408196.0
      },
      {
        "periodo": 202604,
        "valor": 2556464533.0,
        "delta": -125884521.0
      },
      {
        "periodo": 202605,
        "valor": 2514332054.0,
        "delta": -42132479.0
      },
      {
        "periodo": 202606,
        "valor": 2796500970.0,
        "delta": 282168916.0
      },
      {
        "periodo": 202607,
        "valor": 2723564582.0,
        "delta": -72936388.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 314261856.0,
    "valor_anterior": 310675941.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 311013694.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 302199154.0,
        "delta": -8814540.0
      },
      {
        "periodo": 202509,
        "valor": 307269365.0,
        "delta": 5070211.0
      },
      {
        "periodo": 202510,
        "valor": 300468901.0,
        "delta": -6800464.0
      },
      {
        "periodo": 202511,
        "valor": 312691126.0,
        "delta": 12222225.0
      },
      {
        "periodo": 202512,
        "valor": 315582764.0,
        "delta": 2891638.0
      },
      {
        "periodo": 202601,
        "valor": 308885275.0,
        "delta": -6697489.0
      },
      {
        "periodo": 202602,
        "valor": 309683673.0,
        "delta": 798398.0
      },
      {
        "periodo": 202603,
        "valor": 310438253.0,
        "delta": 754580.0
      },
      {
        "periodo": 202604,
        "valor": 306582025.0,
        "delta": -3856228.0
      },
      {
        "periodo": 202605,
        "valor": 308676099.0,
        "delta": 2094074.0
      },
      {
        "periodo": 202606,
        "valor": 310675941.0,
        "delta": 1999842.0
      },
      {
        "periodo": 202607,
        "valor": 314261856.0,
        "delta": 3585915.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 661008989.0,
    "valor_anterior": 662419390.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 618630440.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 629251539.0,
        "delta": 10621099.0
      },
      {
        "periodo": 202509,
        "valor": 634218867.0,
        "delta": 4967328.0
      },
      {
        "periodo": 202510,
        "valor": 634739652.0,
        "delta": 520785.0
      },
      {
        "periodo": 202511,
        "valor": 630396070.0,
        "delta": -4343582.0
      },
      {
        "periodo": 202512,
        "valor": 663688722.0,
        "delta": 33292652.0
      },
      {
        "periodo": 202601,
        "valor": 660186335.0,
        "delta": -3502387.0
      },
      {
        "periodo": 202602,
        "valor": 662226531.0,
        "delta": 2040196.0
      },
      {
        "periodo": 202603,
        "valor": 665443948.0,
        "delta": 3217417.0
      },
      {
        "periodo": 202604,
        "valor": 666660897.0,
        "delta": 1216949.0
      },
      {
        "periodo": 202605,
        "valor": 663751291.0,
        "delta": -2909606.0
      },
      {
        "periodo": 202606,
        "valor": 662419390.0,
        "delta": -1331901.0
      },
      {
        "periodo": 202607,
        "valor": 661008989.0,
        "delta": -1410401.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 2000492865.73,
    "valor_anterior": 1990411895.7,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1870356564.71,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1872530546.29,
        "delta": 2173981.58
      },
      {
        "periodo": 202509,
        "valor": 1888231691.53,
        "delta": 15701145.24
      },
      {
        "periodo": 202510,
        "valor": 1898263260.91,
        "delta": 10031569.38
      },
      {
        "periodo": 202511,
        "valor": 1908426798.77,
        "delta": 10163537.86
      },
      {
        "periodo": 202512,
        "valor": 1930591514.63,
        "delta": 22164715.86
      },
      {
        "periodo": 202601,
        "valor": 1947167144.05,
        "delta": 16575629.42
      },
      {
        "periodo": 202602,
        "valor": 1956426515.07,
        "delta": 9259371.02
      },
      {
        "periodo": 202603,
        "valor": 1961809848.04,
        "delta": 5383332.97
      },
      {
        "periodo": 202604,
        "valor": 1970216373.79,
        "delta": 8406525.75
      },
      {
        "periodo": 202605,
        "valor": 1978297994.92,
        "delta": 8081621.13
      },
      {
        "periodo": 202606,
        "valor": 1990411895.7,
        "delta": 12113900.78
      },
      {
        "periodo": 202607,
        "valor": 2000492865.73,
        "delta": 10080970.03
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 520221536.0,
    "valor_anterior": 519950783.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 496388151.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 501481858.0,
        "delta": 5093707.0
      },
      {
        "periodo": 202509,
        "valor": 499768059.0,
        "delta": -1713799.0
      },
      {
        "periodo": 202510,
        "valor": 501645234.0,
        "delta": 1877175.0
      },
      {
        "periodo": 202511,
        "valor": 500758914.0,
        "delta": -886320.0
      },
      {
        "periodo": 202512,
        "valor": 512412387.0,
        "delta": 11653473.0
      },
      {
        "periodo": 202601,
        "valor": 517770573.0,
        "delta": 5358186.0
      },
      {
        "periodo": 202602,
        "valor": 518110329.0,
        "delta": 339756.0
      },
      {
        "periodo": 202603,
        "valor": 518473754.0,
        "delta": 363425.0
      },
      {
        "periodo": 202604,
        "valor": 518858280.0,
        "delta": 384526.0
      },
      {
        "periodo": 202605,
        "valor": 519172915.0,
        "delta": 314635.0
      },
      {
        "periodo": 202606,
        "valor": 519950783.0,
        "delta": 777868.0
      },
      {
        "periodo": 202607,
        "valor": 520221536.0,
        "delta": 270753.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 5917140192.88,
    "valor_anterior": 5810346567.76,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4861396511.33,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4915283435.54,
        "delta": 53886924.21
      },
      {
        "periodo": 202509,
        "valor": 4947882362.09,
        "delta": 32598926.55
      },
      {
        "periodo": 202510,
        "valor": 5097862104.75,
        "delta": 149979742.66
      },
      {
        "periodo": 202511,
        "valor": 5198379618.84,
        "delta": 100517514.09
      },
      {
        "periodo": 202512,
        "valor": 5313883394.81,
        "delta": 115503775.97
      },
      {
        "periodo": 202601,
        "valor": 5415671207.4,
        "delta": 101787812.59
      },
      {
        "periodo": 202602,
        "valor": 5490151217.29,
        "delta": 74480009.89
      },
      {
        "periodo": 202603,
        "valor": 5516015917.94,
        "delta": 25864700.65
      },
      {
        "periodo": 202604,
        "valor": 5626188800.11,
        "delta": 110172882.17
      },
      {
        "periodo": 202605,
        "valor": 5746019715.94,
        "delta": 119830915.83
      },
      {
        "periodo": 202606,
        "valor": 5810346567.76,
        "delta": 64326851.82
      },
      {
        "periodo": 202607,
        "valor": 5917140192.88,
        "delta": 106793625.12
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 1704800947.7,
    "valor_anterior": 1669652010.63,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1253651016.57,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1273253936.52,
        "delta": 19602919.95
      },
      {
        "periodo": 202509,
        "valor": 1315455347.12,
        "delta": 42201410.6
      },
      {
        "periodo": 202510,
        "valor": 1368503311.94,
        "delta": 53047964.82
      },
      {
        "periodo": 202511,
        "valor": 1439151637.3,
        "delta": 70648325.36
      },
      {
        "periodo": 202512,
        "valor": 1475549364.77,
        "delta": 36397727.47
      },
      {
        "periodo": 202601,
        "valor": 1493039579.11,
        "delta": 17490214.34
      },
      {
        "periodo": 202602,
        "valor": 1557797713.75,
        "delta": 64758134.64
      },
      {
        "periodo": 202603,
        "valor": 1596331026.88,
        "delta": 38533313.13
      },
      {
        "periodo": 202604,
        "valor": 1606144205.83,
        "delta": 9813178.95
      },
      {
        "periodo": 202605,
        "valor": 1649842646.68,
        "delta": 43698440.85
      },
      {
        "periodo": 202606,
        "valor": 1669652010.63,
        "delta": 19809363.95
      },
      {
        "periodo": 202607,
        "valor": 1704800947.7,
        "delta": 35148937.07
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 1556378050.0,
    "valor_anterior": 1565716942.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1361557837.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1389593535.0,
        "delta": 28035698.0
      },
      {
        "periodo": 202509,
        "valor": 1421100094.0,
        "delta": 31506559.0
      },
      {
        "periodo": 202510,
        "valor": 1450280325.0,
        "delta": 29180231.0
      },
      {
        "periodo": 202511,
        "valor": 1471147088.0,
        "delta": 20866763.0
      },
      {
        "periodo": 202512,
        "valor": 1473624751.0,
        "delta": 2477663.0
      },
      {
        "periodo": 202601,
        "valor": 1497348087.0,
        "delta": 23723336.0
      },
      {
        "periodo": 202602,
        "valor": 1526532775.0,
        "delta": 29184688.0
      },
      {
        "periodo": 202603,
        "valor": 1531128933.0,
        "delta": 4596158.0
      },
      {
        "periodo": 202604,
        "valor": 1518483908.0,
        "delta": -12645025.0
      },
      {
        "periodo": 202605,
        "valor": 1549364015.0,
        "delta": 30880107.0
      },
      {
        "periodo": 202606,
        "valor": 1565716942.0,
        "delta": 16352927.0
      },
      {
        "periodo": 202607,
        "valor": 1556378050.0,
        "delta": -9338892.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 18890159198.0,
    "valor_anterior": 18766793480.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17546304578.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17700943816.0,
        "delta": 154639238.0
      },
      {
        "periodo": 202509,
        "valor": 17809232759.0,
        "delta": 108288943.0
      },
      {
        "periodo": 202510,
        "valor": 17931136414.0,
        "delta": 121903655.0
      },
      {
        "periodo": 202511,
        "valor": 18027357548.0,
        "delta": 96221134.0
      },
      {
        "periodo": 202512,
        "valor": 18094805950.0,
        "delta": 67448402.0
      },
      {
        "periodo": 202601,
        "valor": 18185069107.0,
        "delta": 90263157.0
      },
      {
        "periodo": 202602,
        "valor": 18261744728.0,
        "delta": 76675621.0
      },
      {
        "periodo": 202603,
        "valor": 18369941553.0,
        "delta": 108196825.0
      },
      {
        "periodo": 202604,
        "valor": 18491360143.0,
        "delta": 121418590.0
      },
      {
        "periodo": 202605,
        "valor": 18627840600.0,
        "delta": 136480457.0
      },
      {
        "periodo": 202606,
        "valor": 18766793480.0,
        "delta": 138952880.0
      },
      {
        "periodo": 202607,
        "valor": 18890159198.0,
        "delta": 123365718.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 2019475564.0,
    "valor_anterior": 2001860110.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1892881932.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1909550990.0,
        "delta": 16669058.0
      },
      {
        "periodo": 202509,
        "valor": 1917876683.0,
        "delta": 8325693.0
      },
      {
        "periodo": 202510,
        "valor": 1929471297.0,
        "delta": 11594614.0
      },
      {
        "periodo": 202511,
        "valor": 1940501222.0,
        "delta": 11029925.0
      },
      {
        "periodo": 202512,
        "valor": 1943410928.0,
        "delta": 2909706.0
      },
      {
        "periodo": 202601,
        "valor": 1952215264.0,
        "delta": 8804336.0
      },
      {
        "periodo": 202602,
        "valor": 1961027828.0,
        "delta": 8812564.0
      },
      {
        "periodo": 202603,
        "valor": 1974771448.0,
        "delta": 13743620.0
      },
      {
        "periodo": 202604,
        "valor": 1984028869.0,
        "delta": 9257421.0
      },
      {
        "periodo": 202605,
        "valor": 1996232018.0,
        "delta": 12203149.0
      },
      {
        "periodo": 202606,
        "valor": 2001860110.0,
        "delta": 5628092.0
      },
      {
        "periodo": 202607,
        "valor": 2019475564.0,
        "delta": 17615454.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 4650831621.370001,
    "valor_anterior": 4634184886.61,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4527022781.45,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4552654099.1,
        "delta": 25631317.65
      },
      {
        "periodo": 202509,
        "valor": 4611923216.31,
        "delta": 59269117.21
      },
      {
        "periodo": 202510,
        "valor": 4644362381.63,
        "delta": 32439165.32
      },
      {
        "periodo": 202511,
        "valor": 4678017314.06,
        "delta": 33654932.43
      },
      {
        "periodo": 202512,
        "valor": 4693930387.01,
        "delta": 15913072.95
      },
      {
        "periodo": 202601,
        "valor": 4721766061.9,
        "delta": 27835674.89
      },
      {
        "periodo": 202602,
        "valor": 4755040706.28,
        "delta": 33274644.38
      },
      {
        "periodo": 202603,
        "valor": 4766832149.55,
        "delta": 11791443.27
      },
      {
        "periodo": 202604,
        "valor": 4597358775.89,
        "delta": -169473373.66
      },
      {
        "periodo": 202605,
        "valor": 4614622609.5,
        "delta": 17263833.61
      },
      {
        "periodo": 202606,
        "valor": 4634184886.61,
        "delta": 19562277.11
      },
      {
        "periodo": 202607,
        "valor": 4650831621.37,
        "delta": 16646734.76
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 2389390538.09,
    "valor_anterior": 2382500861.55,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2291105011.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2319427609.87,
        "delta": 28322598.62
      },
      {
        "periodo": 202509,
        "valor": 2326748063.83,
        "delta": 7320453.96
      },
      {
        "periodo": 202510,
        "valor": 2337031185.05,
        "delta": 10283121.22
      },
      {
        "periodo": 202511,
        "valor": 2334996076.83,
        "delta": -2035108.22
      },
      {
        "periodo": 202512,
        "valor": 2343789430.08,
        "delta": 8793353.25
      },
      {
        "periodo": 202601,
        "valor": 2350669411.7,
        "delta": 6879981.62
      },
      {
        "periodo": 202602,
        "valor": 2343683105.58,
        "delta": -6986306.12
      },
      {
        "periodo": 202603,
        "valor": 2361530896.89,
        "delta": 17847791.31
      },
      {
        "periodo": 202604,
        "valor": 2368880678.47,
        "delta": 7349781.58
      },
      {
        "periodo": 202605,
        "valor": 2372496563.51,
        "delta": 3615885.04
      },
      {
        "periodo": 202606,
        "valor": 2382500861.55,
        "delta": 10004298.04
      },
      {
        "periodo": 202607,
        "valor": 2389390538.09,
        "delta": 6889676.54
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 2868654607.0,
    "valor_anterior": 2840762539.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2546176782.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2575373422.0,
        "delta": 29196640.0
      },
      {
        "periodo": 202509,
        "valor": 2603682988.0,
        "delta": 28309566.0
      },
      {
        "periodo": 202510,
        "valor": 2631196590.0,
        "delta": 27513602.0
      },
      {
        "periodo": 202511,
        "valor": 2661471163.0,
        "delta": 30274573.0
      },
      {
        "periodo": 202512,
        "valor": 2677557433.0,
        "delta": 16086270.0
      },
      {
        "periodo": 202601,
        "valor": 2704011364.0,
        "delta": 26453931.0
      },
      {
        "periodo": 202602,
        "valor": 2728686453.0,
        "delta": 24675089.0
      },
      {
        "periodo": 202603,
        "valor": 2755987793.0,
        "delta": 27301340.0
      },
      {
        "periodo": 202604,
        "valor": 2782821174.0,
        "delta": 26833381.0
      },
      {
        "periodo": 202605,
        "valor": 2807556800.0,
        "delta": 24735626.0
      },
      {
        "periodo": 202606,
        "valor": 2840762539.0,
        "delta": 33205739.0
      },
      {
        "periodo": 202607,
        "valor": 2868654607.0,
        "delta": 27892068.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 1793702210.0,
    "valor_anterior": 1791212356.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1752191901.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1756299403.0,
        "delta": 4107502.0
      },
      {
        "periodo": 202509,
        "valor": 1760514259.0,
        "delta": 4214856.0
      },
      {
        "periodo": 202510,
        "valor": 1766289806.0,
        "delta": 5775547.0
      },
      {
        "periodo": 202511,
        "valor": 1765957593.0,
        "delta": -332213.0
      },
      {
        "periodo": 202512,
        "valor": 1767972745.0,
        "delta": 2015152.0
      },
      {
        "periodo": 202601,
        "valor": 1769896568.0,
        "delta": 1923823.0
      },
      {
        "periodo": 202602,
        "valor": 1772958437.0,
        "delta": 3061869.0
      },
      {
        "periodo": 202603,
        "valor": 1779566530.0,
        "delta": 6608093.0
      },
      {
        "periodo": 202604,
        "valor": 1780856264.0,
        "delta": 1289734.0
      },
      {
        "periodo": 202605,
        "valor": 1786904193.0,
        "delta": 6047929.0
      },
      {
        "periodo": 202606,
        "valor": 1791212356.0,
        "delta": 4308163.0
      },
      {
        "periodo": 202607,
        "valor": 1793702210.0,
        "delta": 2489854.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 5696627096.999999,
    "valor_anterior": 5742575710.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5496097554.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5538513200.0,
        "delta": 42415646.0
      },
      {
        "periodo": 202509,
        "valor": 5632344529.0,
        "delta": 93831329.0
      },
      {
        "periodo": 202510,
        "valor": 5651366746.0,
        "delta": 19022217.0
      },
      {
        "periodo": 202511,
        "valor": 5638966823.0,
        "delta": -12399923.0
      },
      {
        "periodo": 202512,
        "valor": 5634033373.0,
        "delta": -4933450.0
      },
      {
        "periodo": 202601,
        "valor": 5646635832.0,
        "delta": 12602459.0
      },
      {
        "periodo": 202602,
        "valor": 5681823215.0,
        "delta": 35187383.0
      },
      {
        "periodo": 202603,
        "valor": 5683784387.0,
        "delta": 1961172.0
      },
      {
        "periodo": 202604,
        "valor": 5670778190.0,
        "delta": -13006197.0
      },
      {
        "periodo": 202605,
        "valor": 5709664648.0,
        "delta": 38886458.0
      },
      {
        "periodo": 202606,
        "valor": 5742575710.0,
        "delta": 32911062.0
      },
      {
        "periodo": 202607,
        "valor": 5696627097.0,
        "delta": -45948613.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 2928168846.76,
    "valor_anterior": 2923116242.79,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3073049757.7,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2995339823.51,
        "delta": -77709934.19
      },
      {
        "periodo": 202509,
        "valor": 3066549774.08,
        "delta": 71209950.57
      },
      {
        "periodo": 202510,
        "valor": 3059593135.22,
        "delta": -6956638.86
      },
      {
        "periodo": 202511,
        "valor": 3059428269.7,
        "delta": -164865.52
      },
      {
        "periodo": 202512,
        "valor": 3111463977.72,
        "delta": 52035708.02
      },
      {
        "periodo": 202601,
        "valor": 3043867088.11,
        "delta": -67596889.61
      },
      {
        "periodo": 202602,
        "valor": 3041355826.85,
        "delta": -2511261.26
      },
      {
        "periodo": 202603,
        "valor": 2987239832.5,
        "delta": -54115994.35
      },
      {
        "periodo": 202604,
        "valor": 2965103025.72,
        "delta": -22136806.78
      },
      {
        "periodo": 202605,
        "valor": 2937174900.43,
        "delta": -27928125.29
      },
      {
        "periodo": 202606,
        "valor": 2923116242.79,
        "delta": -14058657.64
      },
      {
        "periodo": 202607,
        "valor": 2928168846.76,
        "delta": 5052603.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 2108946258.0,
    "valor_anterior": 2097921590.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1564829001.83,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1568105904.37,
        "delta": 3276902.54
      },
      {
        "periodo": 202509,
        "valor": 1571251742.81,
        "delta": 3145838.44
      },
      {
        "periodo": 202510,
        "valor": 1572976650.55,
        "delta": 1724907.74
      },
      {
        "periodo": 202511,
        "valor": 1576221086.22,
        "delta": 3244435.67
      },
      {
        "periodo": 202512,
        "valor": 1578421792.29,
        "delta": 2200706.07
      },
      {
        "periodo": 202601,
        "valor": 1582516738.74,
        "delta": 4094946.45
      },
      {
        "periodo": 202602,
        "valor": 1994401964.48,
        "delta": 411885225.74
      },
      {
        "periodo": 202603,
        "valor": 2027518945.02,
        "delta": 33116980.54
      },
      {
        "periodo": 202604,
        "valor": 2035653080.0,
        "delta": 8134134.98
      },
      {
        "periodo": 202605,
        "valor": 2054629149.0,
        "delta": 18976069.0
      },
      {
        "periodo": 202606,
        "valor": 2097921590.0,
        "delta": 43292441.0
      },
      {
        "periodo": 202607,
        "valor": 2108946258.0,
        "delta": 11024668.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 5342242220.0,
    "valor_anterior": 5563836056.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3845427872.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3721089992.0,
        "delta": -124337880.0
      },
      {
        "periodo": 202509,
        "valor": 3584090023.0,
        "delta": -136999969.0
      },
      {
        "periodo": 202510,
        "valor": 3405871557.0,
        "delta": -178218466.0
      },
      {
        "periodo": 202511,
        "valor": 3221264836.0,
        "delta": -184606721.0
      },
      {
        "periodo": 202512,
        "valor": 3743337958.0,
        "delta": 522073122.0
      },
      {
        "periodo": 202601,
        "valor": 4816382643.0,
        "delta": 1073044685.0
      },
      {
        "periodo": 202602,
        "valor": 4651040027.0,
        "delta": -165342616.0
      },
      {
        "periodo": 202603,
        "valor": 4378228076.0,
        "delta": -272811951.0
      },
      {
        "periodo": 202604,
        "valor": 4203357302.0,
        "delta": -174870774.0
      },
      {
        "periodo": 202605,
        "valor": 3999798926.0,
        "delta": -203558376.0
      },
      {
        "periodo": 202606,
        "valor": 5563836056.0,
        "delta": 1564037130.0
      },
      {
        "periodo": 202607,
        "valor": 5342242220.0,
        "delta": -221593836.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 2101912855.39,
    "valor_anterior": 2182939803.14,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 1423253003.09,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 1398768755.62,
        "delta": -24484247.47
      },
      {
        "periodo": 202601,
        "valor": 1374218923.79,
        "delta": -24549831.83
      },
      {
        "periodo": 202602,
        "valor": 1328755836.9,
        "delta": -45463086.89
      },
      {
        "periodo": 202603,
        "valor": 1271674796.25,
        "delta": -57081040.65
      },
      {
        "periodo": 202604,
        "valor": 2329363126.82,
        "delta": 1057688330.57
      },
      {
        "periodo": 202605,
        "valor": 2261985788.65,
        "delta": -67377338.17
      },
      {
        "periodo": 202606,
        "valor": 2182939803.14,
        "delta": -79045985.51
      },
      {
        "periodo": 202607,
        "valor": 2101912855.39,
        "delta": -81026947.75
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 6718912415.000001,
    "valor_anterior": 6941512904.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 4731679552.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 6601802620.0,
        "delta": 1870123068.0
      },
      {
        "periodo": 202605,
        "valor": 6368946594.0,
        "delta": -232856026.0
      },
      {
        "periodo": 202606,
        "valor": 6941512904.0,
        "delta": 572566310.0
      },
      {
        "periodo": 202607,
        "valor": 6718912415.0,
        "delta": -222600489.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 1889883601943.68,
    "valor_anterior": 1873713426231.23,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1775851148898.46,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1804585806504.46,
        "delta": 28734657606.0
      },
      {
        "periodo": 202509,
        "valor": 1810062781577.85,
        "delta": 5476975073.3901
      },
      {
        "periodo": 202510,
        "valor": 1835576200833.22,
        "delta": 25513419255.3699
      },
      {
        "periodo": 202511,
        "valor": 1821824917953.85,
        "delta": -13751282879.3699
      },
      {
        "periodo": 202512,
        "valor": 1804498374692.98,
        "delta": -17326543260.8701
      },
      {
        "periodo": 202601,
        "valor": 1834881058429.16,
        "delta": 30382683736.1799
      },
      {
        "periodo": 202602,
        "valor": 1858963623200.11,
        "delta": 24082564770.9502
      },
      {
        "periodo": 202603,
        "valor": 1863035894967.08,
        "delta": 4072271766.97
      },
      {
        "periodo": 202604,
        "valor": 1859746977252.08,
        "delta": -3288917715.0
      },
      {
        "periodo": 202605,
        "valor": 1882591833088.4001,
        "delta": 22844855836.3201
      },
      {
        "periodo": 202606,
        "valor": 1873713426231.23,
        "delta": -8878406857.1702
      },
      {
        "periodo": 202607,
        "valor": 1889883601943.68,
        "delta": 16170175712.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 1341964575844.9502,
    "valor_anterior": 1327911738753.48,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1275513278035.07,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1298088769163.15,
        "delta": 22575491128.0798
      },
      {
        "periodo": 202509,
        "valor": 1300938661208.68,
        "delta": 2849892045.53
      },
      {
        "periodo": 202510,
        "valor": 1319461667167.9,
        "delta": 18523005959.22
      },
      {
        "periodo": 202511,
        "valor": 1310096665774.67,
        "delta": -9365001393.23
      },
      {
        "periodo": 202512,
        "valor": 1286141581322.54,
        "delta": -23955084452.1299
      },
      {
        "periodo": 202601,
        "valor": 1310432175837.78,
        "delta": 24290594515.24
      },
      {
        "periodo": 202602,
        "valor": 1328656221931.7302,
        "delta": 18224046093.9502
      },
      {
        "periodo": 202603,
        "valor": 1326797989214.02,
        "delta": -1858232717.7102
      },
      {
        "periodo": 202604,
        "valor": 1324642796586.14,
        "delta": -2155192627.8801
      },
      {
        "periodo": 202605,
        "valor": 1343551341331.85,
        "delta": 18908544745.7102
      },
      {
        "periodo": 202606,
        "valor": 1327911738753.48,
        "delta": -15639602578.3701
      },
      {
        "periodo": 202607,
        "valor": 1341964575844.9502,
        "delta": 14052837091.4702
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 28936543049.65,
    "valor_anterior": 29688333337.76,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40942003488.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 40392591635.05,
        "delta": -549411853.21
      },
      {
        "periodo": 202509,
        "valor": 33854223216.48,
        "delta": -6538368418.57
      },
      {
        "periodo": 202510,
        "valor": 34353672236.68,
        "delta": 499449020.2
      },
      {
        "periodo": 202511,
        "valor": 28853560262.11,
        "delta": -5500111974.57
      },
      {
        "periodo": 202512,
        "valor": 29476153198.94,
        "delta": 622592936.83
      },
      {
        "periodo": 202601,
        "valor": 30016525424.98,
        "delta": 540372226.04
      },
      {
        "periodo": 202602,
        "valor": 30465926401.09,
        "delta": 449400976.11
      },
      {
        "periodo": 202603,
        "valor": 30671407948.11,
        "delta": 205481547.02
      },
      {
        "periodo": 202604,
        "valor": 29204611344.97,
        "delta": -1466796603.14
      },
      {
        "periodo": 202605,
        "valor": 29655703375.96,
        "delta": 451092030.99
      },
      {
        "periodo": 202606,
        "valor": 29688333337.76,
        "delta": 32629961.8
      },
      {
        "periodo": 202607,
        "valor": 28936543049.65,
        "delta": -751790288.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 203528108235.58,
    "valor_anterior": 202255242462.37,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 184768877653.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 187320400786.86,
        "delta": 2551523132.96
      },
      {
        "periodo": 202509,
        "valor": 189386298195.94,
        "delta": 2065897409.08
      },
      {
        "periodo": 202510,
        "valor": 191278190606.98,
        "delta": 1891892411.04
      },
      {
        "periodo": 202511,
        "valor": 191331867927.99,
        "delta": 53677321.01
      },
      {
        "periodo": 202512,
        "valor": 193012442442.64,
        "delta": 1680574514.65
      },
      {
        "periodo": 202601,
        "valor": 194950522421.11,
        "delta": 1938079978.47
      },
      {
        "periodo": 202602,
        "valor": 196652883346.12,
        "delta": 1702360925.01
      },
      {
        "periodo": 202603,
        "valor": 197047264645.07,
        "delta": 394381298.95
      },
      {
        "periodo": 202604,
        "valor": 199232742660.5,
        "delta": 2185478015.43
      },
      {
        "periodo": 202605,
        "valor": 201109857366.98,
        "delta": 1877114706.48
      },
      {
        "periodo": 202606,
        "valor": 202255242462.37,
        "delta": 1145385095.39
      },
      {
        "periodo": 202607,
        "valor": 203528108235.58,
        "delta": 1272865773.21
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 144564588837.3,
    "valor_anterior": 142783170971.63,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 131760530216.49,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 133697947171.84,
        "delta": 1937416955.35
      },
      {
        "periodo": 202509,
        "valor": 135773624416.64,
        "delta": 2075677244.8
      },
      {
        "periodo": 202510,
        "valor": 137739778554.02,
        "delta": 1966154137.38
      },
      {
        "periodo": 202511,
        "valor": 137451414818.4,
        "delta": -288363735.62
      },
      {
        "periodo": 202512,
        "valor": 138898690562.16,
        "delta": 1447275743.76
      },
      {
        "periodo": 202601,
        "valor": 141077139458.43,
        "delta": 2178448896.27
      },
      {
        "periodo": 202602,
        "valor": 142193907286.95,
        "delta": 1116767828.52
      },
      {
        "periodo": 202603,
        "valor": 141946129314.18,
        "delta": -247777972.77
      },
      {
        "periodo": 202604,
        "valor": 139446465167.07,
        "delta": -2499664147.11
      },
      {
        "periodo": 202605,
        "valor": 140851469207.01,
        "delta": 1405004039.94
      },
      {
        "periodo": 202606,
        "valor": 142783170971.63,
        "delta": 1931701764.62
      },
      {
        "periodo": 202607,
        "valor": 144564588837.3,
        "delta": 1781417865.67
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 48507076122.77,
    "valor_anterior": 48466004120.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 39736572288.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 40420275272.86,
        "delta": 683702983.96
      },
      {
        "periodo": 202509,
        "valor": 43062374672.88,
        "delta": 2642099400.02
      },
      {
        "periodo": 202510,
        "valor": 44130110244.28,
        "delta": 1067735571.4
      },
      {
        "periodo": 202511,
        "valor": 44338613541.8,
        "delta": 208503297.52
      },
      {
        "periodo": 202512,
        "valor": 45294639087.3,
        "delta": 956025545.5
      },
      {
        "periodo": 202601,
        "valor": 45627905344.16,
        "delta": 333266256.86
      },
      {
        "periodo": 202602,
        "valor": 46131834115.97,
        "delta": 503928771.81
      },
      {
        "periodo": 202603,
        "valor": 46949526933.3,
        "delta": 817692817.33
      },
      {
        "periodo": 202604,
        "valor": 46957308539.09,
        "delta": 7781605.79
      },
      {
        "periodo": 202605,
        "valor": 47381631647.55,
        "delta": 424323108.46
      },
      {
        "periodo": 202606,
        "valor": 48466004120.25,
        "delta": 1084372472.7
      },
      {
        "periodo": 202607,
        "valor": 48507076122.77,
        "delta": 41072002.52
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100002,
    "label": "Capital Contable",
    "valor_actual": 122382709853.43,
    "valor_anterior": 122608936585.74,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 103129887215.84,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 104665822474.7,
        "delta": 1535935258.86
      },
      {
        "periodo": 202509,
        "valor": 107047599867.23,
        "delta": 2381777392.53
      },
      {
        "periodo": 202510,
        "valor": 108612782023.36,
        "delta": 1565182156.13
      },
      {
        "periodo": 202511,
        "valor": 109752795628.88,
        "delta": 1140013605.52
      },
      {
        "periodo": 202512,
        "valor": 111674868079.4,
        "delta": 1922072450.52
      },
      {
        "periodo": 202601,
        "valor": 112776789942.7,
        "delta": 1101921863.3
      },
      {
        "periodo": 202602,
        "valor": 114862850118.25,
        "delta": 2086060175.55
      },
      {
        "periodo": 202603,
        "valor": 119623576912.4,
        "delta": 4760726794.15
      },
      {
        "periodo": 202604,
        "valor": 120263052954.31,
        "delta": 639476041.91
      },
      {
        "periodo": 202605,
        "valor": 120041830159.05,
        "delta": -221222795.26
      },
      {
        "periodo": 202606,
        "valor": 122608936585.74,
        "delta": 2567106426.69
      },
      {
        "periodo": 202607,
        "valor": 122382709853.43,
        "delta": -226226732.31
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 10851661423.480003,
    "valor_anterior": 10142343548.529999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9955270883.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10589711409.98,
        "delta": 634440526.79
      },
      {
        "periodo": 202509,
        "valor": 11110553259.36,
        "delta": 520841849.38
      },
      {
        "periodo": 202510,
        "valor": 10556080302.52,
        "delta": -554472956.84
      },
      {
        "periodo": 202511,
        "valor": 11151674880.43,
        "delta": 595594577.91
      },
      {
        "periodo": 202512,
        "valor": 11422329089.76,
        "delta": 270654209.33
      },
      {
        "periodo": 202601,
        "valor": 12493931422.42,
        "delta": 1071602332.66
      },
      {
        "periodo": 202602,
        "valor": 10067303549.96,
        "delta": -2426627872.46
      },
      {
        "periodo": 202603,
        "valor": 11028344117.04,
        "delta": 961040567.08
      },
      {
        "periodo": 202604,
        "valor": 11617668224.14,
        "delta": 589324107.1
      },
      {
        "periodo": 202605,
        "valor": 10427607726.29,
        "delta": -1190060497.85
      },
      {
        "periodo": 202606,
        "valor": 10142343548.53,
        "delta": -285264177.76
      },
      {
        "periodo": 202607,
        "valor": 10851661423.48,
        "delta": 709317874.95
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 29959085832.24002,
    "valor_anterior": 29058295682.869995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28841729480.86,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28335014249.54,
        "delta": -506715231.32
      },
      {
        "periodo": 202509,
        "valor": 28048439850.22,
        "delta": -286574399.3199
      },
      {
        "periodo": 202510,
        "valor": 28588351027.84,
        "delta": 539911177.62
      },
      {
        "periodo": 202511,
        "valor": 27973274603.73,
        "delta": -615076424.11
      },
      {
        "periodo": 202512,
        "valor": 29356012979.84,
        "delta": 1382738376.11
      },
      {
        "periodo": 202601,
        "valor": 29480102261.84,
        "delta": 124089282.0
      },
      {
        "periodo": 202602,
        "valor": 27273864280.58,
        "delta": -2206237981.26
      },
      {
        "periodo": 202603,
        "valor": 30302980148.59,
        "delta": 3029115868.01
      },
      {
        "periodo": 202604,
        "valor": 28842583220.77,
        "delta": -1460396927.82
      },
      {
        "periodo": 202605,
        "valor": 29544272117.31,
        "delta": 701688896.54
      },
      {
        "periodo": 202606,
        "valor": 29058295682.87,
        "delta": -485976434.44
      },
      {
        "periodo": 202607,
        "valor": 29959085832.24,
        "delta": 900790149.37
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 15916726930.0,
    "valor_anterior": 15422112984.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16104016614.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16074571659.0,
        "delta": -29444955.0
      },
      {
        "periodo": 202509,
        "valor": 15497785831.0,
        "delta": -576785828.0
      },
      {
        "periodo": 202510,
        "valor": 16247940456.0,
        "delta": 750154625.0
      },
      {
        "periodo": 202511,
        "valor": 15616459671.0,
        "delta": -631480785.0001
      },
      {
        "periodo": 202512,
        "valor": 16187120385.0,
        "delta": 570660714.0
      },
      {
        "periodo": 202601,
        "valor": 15998158483.0,
        "delta": -188961902.0
      },
      {
        "periodo": 202602,
        "valor": 14567710021.0,
        "delta": -1430448462.0
      },
      {
        "periodo": 202603,
        "valor": 15903402648.0,
        "delta": 1335692627.0
      },
      {
        "periodo": 202604,
        "valor": 15729148633.0,
        "delta": -174254015.0
      },
      {
        "periodo": 202605,
        "valor": 15868325982.0,
        "delta": 139177349.0
      },
      {
        "periodo": 202606,
        "valor": 15422112984.0,
        "delta": -446212998.0
      },
      {
        "periodo": 202607,
        "valor": 15916726930.0,
        "delta": 494613946.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 6358896945.0,
    "valor_anterior": 6157300232.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7569314091.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7386506968.0,
        "delta": -182807123.0
      },
      {
        "periodo": 202509,
        "valor": 7090620711.0,
        "delta": -295886257.0
      },
      {
        "periodo": 202510,
        "valor": 7312094248.0,
        "delta": 221473537.0
      },
      {
        "periodo": 202511,
        "valor": 7077506694.0,
        "delta": -234587554.0
      },
      {
        "periodo": 202512,
        "valor": 6954384625.0,
        "delta": -123122069.0
      },
      {
        "periodo": 202601,
        "valor": 6858499957.0,
        "delta": -95884668.0
      },
      {
        "periodo": 202602,
        "valor": 6249574720.0,
        "delta": -608925237.0
      },
      {
        "periodo": 202603,
        "valor": 6602969504.0,
        "delta": 353394784.0
      },
      {
        "periodo": 202604,
        "valor": 6357154912.0,
        "delta": -245814592.0
      },
      {
        "periodo": 202605,
        "valor": 6501846098.0,
        "delta": 144691186.0
      },
      {
        "periodo": 202606,
        "valor": 6157300232.0,
        "delta": -344545866.0
      },
      {
        "periodo": 202607,
        "valor": 6358896945.0,
        "delta": 201596713.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 3149467757.6399994,
    "valor_anterior": 3022462459.380001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3255396732.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3242458922.83,
        "delta": -12937809.17
      },
      {
        "periodo": 202509,
        "valor": 3134827882.55,
        "delta": -107631040.28
      },
      {
        "periodo": 202510,
        "valor": 3208861111.63,
        "delta": 74033229.08
      },
      {
        "periodo": 202511,
        "valor": 3064192329.8,
        "delta": -144668781.83
      },
      {
        "periodo": 202512,
        "valor": 3176923788.65,
        "delta": 112731458.85
      },
      {
        "periodo": 202601,
        "valor": 3090341507.78,
        "delta": -86582280.87
      },
      {
        "periodo": 202602,
        "valor": 2803817662.92,
        "delta": -286523844.86
      },
      {
        "periodo": 202603,
        "valor": 3162019482.13,
        "delta": 358201819.21
      },
      {
        "periodo": 202604,
        "valor": 3069812010.72,
        "delta": -92207471.41
      },
      {
        "periodo": 202605,
        "valor": 3161997109.4,
        "delta": 92185098.68
      },
      {
        "periodo": 202606,
        "valor": 3022462459.38,
        "delta": -139534650.02
      },
      {
        "periodo": 202607,
        "valor": 3149467757.64,
        "delta": 127005298.26
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 7951403624.0,
    "valor_anterior": 7401539657.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8370433288.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8016642373.0,
        "delta": -353790915.0
      },
      {
        "periodo": 202509,
        "valor": 7879713313.0,
        "delta": -136929060.0
      },
      {
        "periodo": 202510,
        "valor": 8056032330.0,
        "delta": 176319017.0
      },
      {
        "periodo": 202511,
        "valor": 7551259653.0,
        "delta": -504772677.0
      },
      {
        "periodo": 202512,
        "valor": 8387434233.0,
        "delta": 836174580.0
      },
      {
        "periodo": 202601,
        "valor": 7639535759.0,
        "delta": -747898474.0
      },
      {
        "periodo": 202602,
        "valor": 6985767816.0,
        "delta": -653767943.0
      },
      {
        "periodo": 202603,
        "valor": 8231107846.0,
        "delta": 1245340030.0
      },
      {
        "periodo": 202604,
        "valor": 7708001666.0,
        "delta": -523106180.0
      },
      {
        "periodo": 202605,
        "valor": 7752674231.0,
        "delta": 44672565.0
      },
      {
        "periodo": 202606,
        "valor": 7401539657.0,
        "delta": -351134574.0
      },
      {
        "periodo": 202607,
        "valor": 7951403624.0,
        "delta": 549863967.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 1531050399.000002,
    "valor_anterior": 1441468163.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1164189929.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1163431725.0,
        "delta": -758204.0
      },
      {
        "periodo": 202509,
        "valor": 1123244351.0,
        "delta": -40187374.0
      },
      {
        "periodo": 202510,
        "valor": 1431589589.0,
        "delta": 308345238.0
      },
      {
        "periodo": 202511,
        "valor": 1432519561.0,
        "delta": 929972.0
      },
      {
        "periodo": 202512,
        "valor": 1966556770.0,
        "delta": 534037209.0
      },
      {
        "periodo": 202601,
        "valor": 1213686274.0,
        "delta": -752870496.0
      },
      {
        "periodo": 202602,
        "valor": 1440111910.0,
        "delta": 226425636.0
      },
      {
        "periodo": 202603,
        "valor": 1582534210.0,
        "delta": 142422300.0
      },
      {
        "periodo": 202604,
        "valor": 1529066569.0,
        "delta": -53467641.0
      },
      {
        "periodo": 202605,
        "valor": 1614682232.0,
        "delta": 85615663.0
      },
      {
        "periodo": 202606,
        "valor": 1441468164.0,
        "delta": -173214068.0
      },
      {
        "periodo": 202607,
        "valor": 1531050399.0,
        "delta": 89582235.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 6238446113.0,
    "valor_anterior": 5830339579.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6227452220.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6254196080.0,
        "delta": 26743860.0
      },
      {
        "periodo": 202509,
        "valor": 6056997382.0,
        "delta": -197198698.0
      },
      {
        "periodo": 202510,
        "valor": 6224767016.0,
        "delta": 167769634.0
      },
      {
        "periodo": 202511,
        "valor": 5996070870.0,
        "delta": -228696146.0
      },
      {
        "periodo": 202512,
        "valor": 6216909185.0,
        "delta": 220838315.0
      },
      {
        "periodo": 202601,
        "valor": 6112253542.0,
        "delta": -104655643.0
      },
      {
        "periodo": 202602,
        "valor": 5499502819.0,
        "delta": -612750723.0
      },
      {
        "periodo": 202603,
        "valor": 6073510424.0,
        "delta": 574007605.0
      },
      {
        "periodo": 202604,
        "valor": 5863177256.0,
        "delta": -210333168.0
      },
      {
        "periodo": 202605,
        "valor": 5948173224.0,
        "delta": 84995968.0
      },
      {
        "periodo": 202606,
        "valor": 5830339579.0,
        "delta": -117833645.0
      },
      {
        "periodo": 202607,
        "valor": 6238446113.0,
        "delta": 408106534.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 2357256640.6900005,
    "valor_anterior": 2274146569.549999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2545058871.18,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2523220795.45,
        "delta": -21838075.73
      },
      {
        "periodo": 202509,
        "valor": 2470374443.84,
        "delta": -52846351.61
      },
      {
        "periodo": 202510,
        "valor": 2563173383.28,
        "delta": 92798939.44
      },
      {
        "periodo": 202511,
        "valor": 2437920628.71,
        "delta": -125252754.57
      },
      {
        "periodo": 202512,
        "valor": 2568783152.39,
        "delta": 130862523.68
      },
      {
        "periodo": 202601,
        "valor": 2490017630.85,
        "delta": -78765521.54
      },
      {
        "periodo": 202602,
        "valor": 2140886560.37,
        "delta": -349131070.48
      },
      {
        "periodo": 202603,
        "valor": 2364189482.97,
        "delta": 223302922.6
      },
      {
        "periodo": 202604,
        "valor": 2291029205.19,
        "delta": -73160277.78
      },
      {
        "periodo": 202605,
        "valor": 2345265854.97,
        "delta": 54236649.78
      },
      {
        "periodo": 202606,
        "valor": 2274146569.55,
        "delta": -71119285.42
      },
      {
        "periodo": 202607,
        "valor": 2357256640.69,
        "delta": 83110071.14
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 2188498124.0,
    "valor_anterior": 1845783976.999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2168952961.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2348427688.0,
        "delta": 179474727.0
      },
      {
        "periodo": 202509,
        "valor": 1838042798.0,
        "delta": -510384890.0
      },
      {
        "periodo": 202510,
        "valor": 1543642842.0,
        "delta": -294399956.0
      },
      {
        "periodo": 202511,
        "valor": 1708993457.0,
        "delta": 165350615.0
      },
      {
        "periodo": 202512,
        "valor": 2064152361.0,
        "delta": 355158904.0
      },
      {
        "periodo": 202601,
        "valor": 2545093290.0,
        "delta": 480940929.0
      },
      {
        "periodo": 202602,
        "valor": 1652952257.0,
        "delta": -892141033.0
      },
      {
        "periodo": 202603,
        "valor": 2141487610.0,
        "delta": 488535353.0
      },
      {
        "periodo": 202604,
        "valor": 1951529746.0,
        "delta": -189957864.0
      },
      {
        "periodo": 202605,
        "valor": 1855788119.0,
        "delta": -95741627.0
      },
      {
        "periodo": 202606,
        "valor": 1845783977.0,
        "delta": -10004142.0
      },
      {
        "periodo": 202607,
        "valor": 2188498124.0,
        "delta": 342714147.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 463396927.0,
    "valor_anterior": 465003282.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 623338460.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 595438547.0,
        "delta": -27899913.0
      },
      {
        "periodo": 202509,
        "valor": 607199059.0,
        "delta": 11760512.0
      },
      {
        "periodo": 202510,
        "valor": 571484459.0,
        "delta": -35714600.0
      },
      {
        "periodo": 202511,
        "valor": 518587269.0,
        "delta": -52897190.0
      },
      {
        "periodo": 202512,
        "valor": 568519475.0,
        "delta": 49932206.0
      },
      {
        "periodo": 202601,
        "valor": 504492450.0,
        "delta": -64027025.0
      },
      {
        "periodo": 202602,
        "valor": 468719356.0,
        "delta": -35773094.0
      },
      {
        "periodo": 202603,
        "valor": 512789415.0,
        "delta": 44070059.0
      },
      {
        "periodo": 202604,
        "valor": 478696995.0,
        "delta": -34092420.0
      },
      {
        "periodo": 202605,
        "valor": 478816165.0,
        "delta": 119170.0
      },
      {
        "periodo": 202606,
        "valor": 465003282.0,
        "delta": -13812883.0
      },
      {
        "periodo": 202607,
        "valor": 463396927.0,
        "delta": -1606355.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 2034806495.0,
    "valor_anterior": 1872937365.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2521342078.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2465656818.0,
        "delta": -55685260.0
      },
      {
        "periodo": 202509,
        "valor": 2367137204.0,
        "delta": -98519614.0
      },
      {
        "periodo": 202510,
        "valor": 2312356717.0,
        "delta": -54780487.0
      },
      {
        "periodo": 202511,
        "valor": 2267096746.0,
        "delta": -45259971.0
      },
      {
        "periodo": 202512,
        "valor": 2341950624.0,
        "delta": 74853878.0
      },
      {
        "periodo": 202601,
        "valor": 2323511576.0,
        "delta": -18439048.0
      },
      {
        "periodo": 202602,
        "valor": 2040237470.0,
        "delta": -283274106.0
      },
      {
        "periodo": 202603,
        "valor": 2220248128.0,
        "delta": 180010658.0
      },
      {
        "periodo": 202604,
        "valor": 2075148407.0,
        "delta": -145099721.0
      },
      {
        "periodo": 202605,
        "valor": 2053733298.0,
        "delta": -21415109.0
      },
      {
        "periodo": 202606,
        "valor": 1872937365.0,
        "delta": -180795933.0
      },
      {
        "periodo": 202607,
        "valor": 2034806495.0,
        "delta": 161869130.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 27800502530.70999,
    "valor_anterior": 27146959606.65999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30398635324.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28941741455.98,
        "delta": -1456893868.89
      },
      {
        "periodo": 202509,
        "valor": 27092791497.83,
        "delta": -1848949958.15
      },
      {
        "periodo": 202510,
        "valor": 28044901854.2,
        "delta": 952110356.3699
      },
      {
        "periodo": 202511,
        "valor": 27071104097.23,
        "delta": -973797756.9699
      },
      {
        "periodo": 202512,
        "valor": 25996868180.58,
        "delta": -1074235916.6501
      },
      {
        "periodo": 202601,
        "valor": 25594421680.71,
        "delta": -402446499.87
      },
      {
        "periodo": 202602,
        "valor": 24341920099.88,
        "delta": -1252501580.83
      },
      {
        "periodo": 202603,
        "valor": 26791407214.97,
        "delta": 2449487115.09
      },
      {
        "periodo": 202604,
        "valor": 26680690433.59,
        "delta": -110716781.38
      },
      {
        "periodo": 202605,
        "valor": 27585474165.53,
        "delta": 904783731.94
      },
      {
        "periodo": 202606,
        "valor": 27146959606.66,
        "delta": -438514558.87
      },
      {
        "periodo": 202607,
        "valor": 27800502530.71,
        "delta": 653542924.05
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 1216410532.999999,
    "valor_anterior": 1182203283.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1412522674.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1429031593.0,
        "delta": 16508919.0
      },
      {
        "periodo": 202509,
        "valor": 1210845179.0,
        "delta": -218186414.0
      },
      {
        "periodo": 202510,
        "valor": 1549523068.0,
        "delta": 338677889.0
      },
      {
        "periodo": 202511,
        "valor": 1389600931.0,
        "delta": -159922137.0
      },
      {
        "periodo": 202512,
        "valor": 1223132103.0,
        "delta": -166468828.0
      },
      {
        "periodo": 202601,
        "valor": 1265898373.0,
        "delta": 42766270.0
      },
      {
        "periodo": 202602,
        "valor": 1331383471.0,
        "delta": 65485098.0
      },
      {
        "periodo": 202603,
        "valor": 2078967792.0,
        "delta": 747584321.0
      },
      {
        "periodo": 202604,
        "valor": 1094884703.0,
        "delta": -984083089.0
      },
      {
        "periodo": 202605,
        "valor": 1065169297.0,
        "delta": -29715406.0
      },
      {
        "periodo": 202606,
        "valor": 1182203283.0,
        "delta": 117033986.0
      },
      {
        "periodo": 202607,
        "valor": 1216410533.0,
        "delta": 34207250.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 204321747.0,
    "valor_anterior": 202743991.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 223419446.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 225637867.0,
        "delta": 2218421.0
      },
      {
        "periodo": 202509,
        "valor": 227355819.0,
        "delta": 1717952.0
      },
      {
        "periodo": 202510,
        "valor": 224477270.0,
        "delta": -2878549.0
      },
      {
        "periodo": 202511,
        "valor": 217290760.0,
        "delta": -7186510.0
      },
      {
        "periodo": 202512,
        "valor": 223609761.0,
        "delta": 6319001.0
      },
      {
        "periodo": 202601,
        "valor": 215420455.0,
        "delta": -8189306.0
      },
      {
        "periodo": 202602,
        "valor": 189436044.0,
        "delta": -25984411.0
      },
      {
        "periodo": 202603,
        "valor": 212379657.0,
        "delta": 22943613.0
      },
      {
        "periodo": 202604,
        "valor": 203260169.0,
        "delta": -9119488.0
      },
      {
        "periodo": 202605,
        "valor": 207539952.0,
        "delta": 4279783.0
      },
      {
        "periodo": 202606,
        "valor": 202743991.0,
        "delta": -4795961.0
      },
      {
        "periodo": 202607,
        "valor": 204321747.0,
        "delta": 1577756.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 803261913.000001,
    "valor_anterior": 788881278.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 831062652.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 788702392.0,
        "delta": -42360260.0
      },
      {
        "periodo": 202509,
        "valor": 749257477.0,
        "delta": -39444915.0
      },
      {
        "periodo": 202510,
        "valor": 722928794.0,
        "delta": -26328683.0
      },
      {
        "periodo": 202511,
        "valor": 685677277.0,
        "delta": -37251517.0
      },
      {
        "periodo": 202512,
        "valor": 773956093.0,
        "delta": 88278816.0
      },
      {
        "periodo": 202601,
        "valor": 773644434.0,
        "delta": -311659.0
      },
      {
        "periodo": 202602,
        "valor": 704507602.0,
        "delta": -69136832.0
      },
      {
        "periodo": 202603,
        "valor": 809923151.0,
        "delta": 105415549.0
      },
      {
        "periodo": 202604,
        "valor": 744565712.0,
        "delta": -65357439.0
      },
      {
        "periodo": 202605,
        "valor": 1115192609.0,
        "delta": 370626897.0
      },
      {
        "periodo": 202606,
        "valor": 788881278.0,
        "delta": -326311331.0
      },
      {
        "periodo": 202607,
        "valor": 803261913.0,
        "delta": 14380635.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 1167315936.5200005,
    "valor_anterior": 1120008762.29,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1351552523.64,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1321297617.46,
        "delta": -30254906.18
      },
      {
        "periodo": 202509,
        "valor": 1374198238.48,
        "delta": 52900621.02
      },
      {
        "periodo": 202510,
        "valor": 1386863990.06,
        "delta": 12665751.58
      },
      {
        "periodo": 202511,
        "valor": 1359101680.49,
        "delta": -27762309.57
      },
      {
        "periodo": 202512,
        "valor": 1364572909.92,
        "delta": 5471229.43
      },
      {
        "periodo": 202601,
        "valor": 1321362254.92,
        "delta": -43210655.0
      },
      {
        "periodo": 202602,
        "valor": 1109514396.12,
        "delta": -211847858.8
      },
      {
        "periodo": 202603,
        "valor": 1297519974.01,
        "delta": 188005577.89
      },
      {
        "periodo": 202604,
        "valor": 1199624518.94,
        "delta": -97895455.07
      },
      {
        "periodo": 202605,
        "valor": 1201980464.37,
        "delta": 2355945.43
      },
      {
        "periodo": 202606,
        "valor": 1120008762.29,
        "delta": -81971702.08
      },
      {
        "periodo": 202607,
        "valor": 1167315936.52,
        "delta": 47307174.23
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 942807230.999999,
    "valor_anterior": 941389421.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 875788564.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 873688093.0,
        "delta": -2100471.0
      },
      {
        "periodo": 202509,
        "valor": 843871939.0,
        "delta": -29816154.0
      },
      {
        "periodo": 202510,
        "valor": 858400578.0,
        "delta": 14528639.0
      },
      {
        "periodo": 202511,
        "valor": 834721614.0,
        "delta": -23678964.0
      },
      {
        "periodo": 202512,
        "valor": 875931393.0,
        "delta": 41209779.0
      },
      {
        "periodo": 202601,
        "valor": 943162811.0,
        "delta": 67231418.0
      },
      {
        "periodo": 202602,
        "valor": 908917606.0,
        "delta": -34245205.0
      },
      {
        "periodo": 202603,
        "valor": 977662110.0,
        "delta": 68744504.0
      },
      {
        "periodo": 202604,
        "valor": 943188607.0,
        "delta": -34473503.0
      },
      {
        "periodo": 202605,
        "valor": 972184495.0,
        "delta": 28995888.0
      },
      {
        "periodo": 202606,
        "valor": 941389421.0,
        "delta": -30795074.0
      },
      {
        "periodo": 202607,
        "valor": 942807231.0,
        "delta": 1417810.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 3142227150.9799995,
    "valor_anterior": 2461538934.529999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3448517618.64,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3457565279.91,
        "delta": 9047661.27
      },
      {
        "periodo": 202509,
        "valor": 2806386728.45,
        "delta": -651178551.46
      },
      {
        "periodo": 202510,
        "valor": 3115758955.36,
        "delta": 309372226.91
      },
      {
        "periodo": 202511,
        "valor": 3150542024.81,
        "delta": 34783069.45
      },
      {
        "periodo": 202512,
        "valor": 3359994255.77,
        "delta": 209452230.96
      },
      {
        "periodo": 202601,
        "valor": 3165560903.4,
        "delta": -194433352.37
      },
      {
        "periodo": 202602,
        "valor": 2789570513.6,
        "delta": -375990389.8
      },
      {
        "periodo": 202603,
        "valor": 4518365951.84,
        "delta": 1728795438.24
      },
      {
        "periodo": 202604,
        "valor": 3781152953.52,
        "delta": -737212998.32
      },
      {
        "periodo": 202605,
        "valor": 2966690196.97,
        "delta": -814462756.55
      },
      {
        "periodo": 202606,
        "valor": 2461538934.53,
        "delta": -505151262.44
      },
      {
        "periodo": 202607,
        "valor": 3142227150.98,
        "delta": 680688216.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 10900924.0,
    "valor_anterior": 10560565.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13466445.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14053041.0,
        "delta": 586596.0
      },
      {
        "periodo": 202509,
        "valor": 12518991.0,
        "delta": -1534050.0
      },
      {
        "periodo": 202510,
        "valor": 13210419.0,
        "delta": 691428.0
      },
      {
        "periodo": 202511,
        "valor": 56566.0,
        "delta": -13153853.0
      },
      {
        "periodo": 202512,
        "valor": 15886690.0,
        "delta": 15830124.0
      },
      {
        "periodo": 202601,
        "valor": 12202530.0,
        "delta": -3684160.0
      },
      {
        "periodo": 202602,
        "valor": 9554808.0,
        "delta": -2647722.0
      },
      {
        "periodo": 202603,
        "valor": 11927924.0,
        "delta": 2373116.0
      },
      {
        "periodo": 202604,
        "valor": 11494943.0,
        "delta": -432981.0
      },
      {
        "periodo": 202605,
        "valor": 11237732.0,
        "delta": -257211.0
      },
      {
        "periodo": 202606,
        "valor": 10560565.0,
        "delta": -677167.0
      },
      {
        "periodo": 202607,
        "valor": 10900924.0,
        "delta": 340359.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 9480457479.309998,
    "valor_anterior": 9039571181.810005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9399829508.02,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9591773599.21,
        "delta": 191944091.19
      },
      {
        "periodo": 202509,
        "valor": 9223036063.02,
        "delta": -368737536.19
      },
      {
        "periodo": 202510,
        "valor": 9511882641.48,
        "delta": 288846578.46
      },
      {
        "periodo": 202511,
        "valor": 9432738318.42,
        "delta": -79144323.06
      },
      {
        "periodo": 202512,
        "valor": 9629627082.33,
        "delta": 196888763.91
      },
      {
        "periodo": 202601,
        "valor": 9668693062.18,
        "delta": 39065979.85
      },
      {
        "periodo": 202602,
        "valor": 8627819217.43,
        "delta": -1040873844.75
      },
      {
        "periodo": 202603,
        "valor": 9471470817.79,
        "delta": 843651600.36
      },
      {
        "periodo": 202604,
        "valor": 9105790168.5,
        "delta": -365680649.29
      },
      {
        "periodo": 202605,
        "valor": 9302973669.62,
        "delta": 197183501.12
      },
      {
        "periodo": 202606,
        "valor": 9039571181.81,
        "delta": -263402487.81
      },
      {
        "periodo": 202607,
        "valor": 9480457479.31,
        "delta": 440886297.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 521891690.0,
    "valor_anterior": 389101688.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 211616531.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 240001047.89,
        "delta": 28384516.64
      },
      {
        "periodo": 202509,
        "valor": 375547977.7,
        "delta": 135546929.81
      },
      {
        "periodo": 202510,
        "valor": 421860059.0,
        "delta": 46312081.3
      },
      {
        "periodo": 202511,
        "valor": 358903303.0,
        "delta": -62956756.0
      },
      {
        "periodo": 202512,
        "valor": 427326134.0,
        "delta": 68422831.0
      },
      {
        "periodo": 202601,
        "valor": 449869666.0,
        "delta": 22543532.0
      },
      {
        "periodo": 202602,
        "valor": 360399933.0,
        "delta": -89469733.0
      },
      {
        "periodo": 202603,
        "valor": 428824557.0,
        "delta": 68424624.0
      },
      {
        "periodo": 202604,
        "valor": 437733673.0,
        "delta": 8909116.0
      },
      {
        "periodo": 202605,
        "valor": 395853917.0,
        "delta": -41879756.0
      },
      {
        "periodo": 202606,
        "valor": 389101688.0,
        "delta": -6752229.0
      },
      {
        "periodo": 202607,
        "valor": 521891690.0,
        "delta": 132790002.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 372264791.0,
    "valor_anterior": 292531255.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 551168154.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 681389282.0,
        "delta": 130221128.0
      },
      {
        "periodo": 202509,
        "valor": 590653910.0,
        "delta": -90735372.0
      },
      {
        "periodo": 202510,
        "valor": 690496620.0,
        "delta": 99842710.0
      },
      {
        "periodo": 202511,
        "valor": 429983677.0,
        "delta": -260512943.0
      },
      {
        "periodo": 202512,
        "valor": 355055500.0,
        "delta": -74928177.0
      },
      {
        "periodo": 202601,
        "valor": 325650227.0,
        "delta": -29405273.0
      },
      {
        "periodo": 202602,
        "valor": 245010108.0,
        "delta": -80640119.0
      },
      {
        "periodo": 202603,
        "valor": 250501541.0,
        "delta": 5491433.0
      },
      {
        "periodo": 202604,
        "valor": 233410099.0,
        "delta": -17091442.0
      },
      {
        "periodo": 202605,
        "valor": 324210335.0,
        "delta": 90800236.0
      },
      {
        "periodo": 202606,
        "valor": 292531255.0,
        "delta": -31679080.0
      },
      {
        "periodo": 202607,
        "valor": 372264791.0,
        "delta": 79733536.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 3297923983.000004,
    "valor_anterior": 3131088697.999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3012510564.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3142251043.0,
        "delta": 129740479.0
      },
      {
        "periodo": 202509,
        "valor": 3037509609.0,
        "delta": -104741434.0
      },
      {
        "periodo": 202510,
        "valor": 3107249487.0,
        "delta": 69739878.0
      },
      {
        "periodo": 202511,
        "valor": 3131971117.0,
        "delta": 24721630.0
      },
      {
        "periodo": 202512,
        "valor": 3278881975.0,
        "delta": 146910858.0
      },
      {
        "periodo": 202601,
        "valor": 3136939616.0,
        "delta": -141942359.0
      },
      {
        "periodo": 202602,
        "valor": 2938872853.0,
        "delta": -198066763.0
      },
      {
        "periodo": 202603,
        "valor": 3230392353.0,
        "delta": 291519500.0
      },
      {
        "periodo": 202604,
        "valor": 3181035667.0,
        "delta": -49356686.0
      },
      {
        "periodo": 202605,
        "valor": 3159528769.0,
        "delta": -21506898.0
      },
      {
        "periodo": 202606,
        "valor": 3131088698.0,
        "delta": -28440071.0
      },
      {
        "periodo": 202607,
        "valor": 3297923983.0,
        "delta": 166835285.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 1326559987.999999,
    "valor_anterior": 1291132209.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1389612039.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1345736945.0,
        "delta": -43875094.0
      },
      {
        "periodo": 202509,
        "valor": 1363487398.0,
        "delta": 17750453.0
      },
      {
        "periodo": 202510,
        "valor": 1413746558.0,
        "delta": 50259160.0
      },
      {
        "periodo": 202511,
        "valor": 1289419015.0,
        "delta": -124327543.0
      },
      {
        "periodo": 202512,
        "valor": 1317232799.0,
        "delta": 27813784.0
      },
      {
        "periodo": 202601,
        "valor": 1317050409.0,
        "delta": -182390.0
      },
      {
        "periodo": 202602,
        "valor": 1230673907.0,
        "delta": -86376502.0
      },
      {
        "periodo": 202603,
        "valor": 1421251491.0,
        "delta": 190577584.0
      },
      {
        "periodo": 202604,
        "valor": 1390094766.0,
        "delta": -31156725.0
      },
      {
        "periodo": 202605,
        "valor": 1355049533.0,
        "delta": -35045233.0
      },
      {
        "periodo": 202606,
        "valor": 1291132209.0,
        "delta": -63917324.0
      },
      {
        "periodo": 202607,
        "valor": 1326559988.0,
        "delta": 35427779.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 437147920.0,
    "valor_anterior": 436685671.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 525615862.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 524395307.0,
        "delta": -1220555.0
      },
      {
        "periodo": 202509,
        "valor": 487234812.0,
        "delta": -37160495.0
      },
      {
        "periodo": 202510,
        "valor": 526552597.0,
        "delta": 39317785.0
      },
      {
        "periodo": 202511,
        "valor": 484631909.0,
        "delta": -41920688.0
      },
      {
        "periodo": 202512,
        "valor": 462253913.0,
        "delta": -22377996.0
      },
      {
        "periodo": 202601,
        "valor": 457093441.0,
        "delta": -5160472.0
      },
      {
        "periodo": 202602,
        "valor": 409714095.0,
        "delta": -47379346.0
      },
      {
        "periodo": 202603,
        "valor": 612178123.0,
        "delta": 202464028.0
      },
      {
        "periodo": 202604,
        "valor": 389500348.0,
        "delta": -222677775.0
      },
      {
        "periodo": 202605,
        "valor": 439148510.0,
        "delta": 49648162.0
      },
      {
        "periodo": 202606,
        "valor": 436685671.0,
        "delta": -2462839.0
      },
      {
        "periodo": 202607,
        "valor": 437147920.0,
        "delta": 462249.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 10978750.0,
    "valor_anterior": 11287337.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 525227573.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 296387207.0,
        "delta": -228840366.0
      },
      {
        "periodo": 202509,
        "valor": 105351231.0,
        "delta": -191035976.0
      },
      {
        "periodo": 202510,
        "valor": 58863149.0,
        "delta": -46488082.0
      },
      {
        "periodo": 202511,
        "valor": 103425926.0,
        "delta": 44562777.0
      },
      {
        "periodo": 202512,
        "valor": 53632237.0,
        "delta": -49793689.0
      },
      {
        "periodo": 202601,
        "valor": 39027307.0,
        "delta": -14604930.0
      },
      {
        "periodo": 202602,
        "valor": 69099624.0,
        "delta": 30072317.0
      },
      {
        "periodo": 202603,
        "valor": 124411682.0,
        "delta": 55312058.0
      },
      {
        "periodo": 202604,
        "valor": 11908724.0,
        "delta": -112502958.0
      },
      {
        "periodo": 202605,
        "valor": 11609149.0,
        "delta": -299575.0
      },
      {
        "periodo": 202606,
        "valor": 11287337.0,
        "delta": -321812.0
      },
      {
        "periodo": 202607,
        "valor": 10978750.0,
        "delta": -308587.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 1874056362.7399998,
    "valor_anterior": 1838931016.6000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1825994522.89,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1801168562.16,
        "delta": -24825960.73
      },
      {
        "periodo": 202509,
        "valor": 1739584381.97,
        "delta": -61584180.19
      },
      {
        "periodo": 202510,
        "valor": 1872200907.32,
        "delta": 132616525.35
      },
      {
        "periodo": 202511,
        "valor": 1999379628.74,
        "delta": 127178721.42
      },
      {
        "periodo": 202512,
        "valor": 1939895135.41,
        "delta": -59484493.33
      },
      {
        "periodo": 202601,
        "valor": 1857594832.35,
        "delta": -82300303.06
      },
      {
        "periodo": 202602,
        "valor": 1773141584.12,
        "delta": -84453248.23
      },
      {
        "periodo": 202603,
        "valor": 1940600279.78,
        "delta": 167458695.66
      },
      {
        "periodo": 202604,
        "valor": 1837739938.49,
        "delta": -102860341.29
      },
      {
        "periodo": 202605,
        "valor": 1835014616.86,
        "delta": -2725321.63
      },
      {
        "periodo": 202606,
        "valor": 1838931016.6,
        "delta": 3916399.74
      },
      {
        "periodo": 202607,
        "valor": 1874056362.74,
        "delta": 35125346.14
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 65594694.0,
    "valor_anterior": 63130870.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 56296169.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 57689874.0,
        "delta": 1393705.0
      },
      {
        "periodo": 202509,
        "valor": 57316188.0,
        "delta": -373686.0
      },
      {
        "periodo": 202510,
        "valor": 58713201.0,
        "delta": 1397013.0
      },
      {
        "periodo": 202511,
        "valor": 56928698.0,
        "delta": -1784503.0
      },
      {
        "periodo": 202512,
        "valor": 58633958.0,
        "delta": 1705260.0
      },
      {
        "periodo": 202601,
        "valor": 60851876.0,
        "delta": 2217918.0
      },
      {
        "periodo": 202602,
        "valor": 55564933.0,
        "delta": -5286943.0
      },
      {
        "periodo": 202603,
        "valor": 62722826.0,
        "delta": 7157893.0
      },
      {
        "periodo": 202604,
        "valor": 60390019.0,
        "delta": -2332807.0
      },
      {
        "periodo": 202605,
        "valor": 62800865.0,
        "delta": 2410846.0
      },
      {
        "periodo": 202606,
        "valor": 63130870.0,
        "delta": 330005.0
      },
      {
        "periodo": 202607,
        "valor": 65594694.0,
        "delta": 2463824.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 411952772.0,
    "valor_anterior": 380827526.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 432605919.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 368088578.0,
        "delta": -64517341.0
      },
      {
        "periodo": 202509,
        "valor": 347816627.0,
        "delta": -20271951.0
      },
      {
        "periodo": 202510,
        "valor": 283320193.0,
        "delta": -64496434.0
      },
      {
        "periodo": 202511,
        "valor": 314844866.0,
        "delta": 31524673.0
      },
      {
        "periodo": 202512,
        "valor": 338407265.0,
        "delta": 23562399.0
      },
      {
        "periodo": 202601,
        "valor": 307287714.0,
        "delta": -31119551.0
      },
      {
        "periodo": 202602,
        "valor": 262735986.0,
        "delta": -44551728.0
      },
      {
        "periodo": 202603,
        "valor": 281802798.0,
        "delta": 19066812.0
      },
      {
        "periodo": 202604,
        "valor": 184468328.0,
        "delta": -97334470.0
      },
      {
        "periodo": 202605,
        "valor": 379160165.0,
        "delta": 194691837.0
      },
      {
        "periodo": 202606,
        "valor": 380827526.0,
        "delta": 1667361.0
      },
      {
        "periodo": 202607,
        "valor": 411952772.0,
        "delta": 31125246.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 834685803.000001,
    "valor_anterior": 821577602.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 727157591.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 733146007.0,
        "delta": 5988416.0
      },
      {
        "periodo": 202509,
        "valor": 737080360.0,
        "delta": 3934353.0
      },
      {
        "periodo": 202510,
        "valor": 759772549.0,
        "delta": 22692189.0
      },
      {
        "periodo": 202511,
        "valor": 765030643.0,
        "delta": 5258094.0
      },
      {
        "periodo": 202512,
        "valor": 769406037.0,
        "delta": 4375394.0
      },
      {
        "periodo": 202601,
        "valor": 785273035.0,
        "delta": 15866998.0
      },
      {
        "periodo": 202602,
        "valor": 757378172.0,
        "delta": -27894863.0
      },
      {
        "periodo": 202603,
        "valor": 777699628.0,
        "delta": 20321456.0
      },
      {
        "periodo": 202604,
        "valor": 812187560.0,
        "delta": 34487932.0
      },
      {
        "periodo": 202605,
        "valor": 818641547.0,
        "delta": 6453987.0
      },
      {
        "periodo": 202606,
        "valor": 821577602.0,
        "delta": 2936055.0
      },
      {
        "periodo": 202607,
        "valor": 834685803.0,
        "delta": 13108201.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 111049422.0,
    "valor_anterior": 112399514.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 98169448.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 102194376.0,
        "delta": 4024928.0
      },
      {
        "periodo": 202509,
        "valor": 106777833.0,
        "delta": 4583457.0
      },
      {
        "periodo": 202510,
        "valor": 108554203.0,
        "delta": 1776370.0
      },
      {
        "periodo": 202511,
        "valor": 109093302.0,
        "delta": 539099.0
      },
      {
        "periodo": 202512,
        "valor": 61001899.0,
        "delta": -48091403.0
      },
      {
        "periodo": 202601,
        "valor": 106098498.0,
        "delta": 45096599.0
      },
      {
        "periodo": 202602,
        "valor": 110126019.0,
        "delta": 4027521.0
      },
      {
        "periodo": 202603,
        "valor": 110207015.0,
        "delta": 80996.0
      },
      {
        "periodo": 202604,
        "valor": 107612072.0,
        "delta": -2594943.0
      },
      {
        "periodo": 202605,
        "valor": 112475026.0,
        "delta": 4862954.0
      },
      {
        "periodo": 202606,
        "valor": 112399514.0,
        "delta": -75512.0
      },
      {
        "periodo": 202607,
        "valor": 111049422.0,
        "delta": -1350092.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 690051496.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 577321060.0,
        "delta": -112730436.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 1195941242.0,
    "valor_anterior": 1069574572.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1049399019.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1031774735.0,
        "delta": -17624284.0
      },
      {
        "periodo": 202509,
        "valor": 1041987954.0,
        "delta": 10213219.0
      },
      {
        "periodo": 202510,
        "valor": 1142544633.0,
        "delta": 100556679.0
      },
      {
        "periodo": 202511,
        "valor": 1028391617.0,
        "delta": -114153016.0
      },
      {
        "periodo": 202512,
        "valor": 1153545982.0,
        "delta": 125154365.0
      },
      {
        "periodo": 202601,
        "valor": 1179197976.0,
        "delta": 25651994.0
      },
      {
        "periodo": 202602,
        "valor": 1008827348.0,
        "delta": -170370628.0
      },
      {
        "periodo": 202603,
        "valor": 1132321178.0,
        "delta": 123493830.0
      },
      {
        "periodo": 202604,
        "valor": 1097554244.0,
        "delta": -34766934.0
      },
      {
        "periodo": 202605,
        "valor": 1001148910.0,
        "delta": -96405334.0
      },
      {
        "periodo": 202606,
        "valor": 1069574572.0,
        "delta": 68425662.0
      },
      {
        "periodo": 202607,
        "valor": 1195941242.0,
        "delta": 126366670.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 297281050.0,
    "valor_anterior": 276672116.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 192384281.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 197508719.0,
        "delta": 5124438.0
      },
      {
        "periodo": 202509,
        "valor": 189567225.0,
        "delta": -7941494.0
      },
      {
        "periodo": 202510,
        "valor": 211854966.0,
        "delta": 22287741.0
      },
      {
        "periodo": 202511,
        "valor": 215598237.0,
        "delta": 3743271.0
      },
      {
        "periodo": 202512,
        "valor": 235261261.0,
        "delta": 19663024.0
      },
      {
        "periodo": 202601,
        "valor": 249102333.0,
        "delta": 13841072.0
      },
      {
        "periodo": 202602,
        "valor": 223235905.0,
        "delta": -25866428.0
      },
      {
        "periodo": 202603,
        "valor": 268674624.0,
        "delta": 45438719.0
      },
      {
        "periodo": 202604,
        "valor": 269026754.0,
        "delta": 352130.0
      },
      {
        "periodo": 202605,
        "valor": 279057846.0,
        "delta": 10031092.0
      },
      {
        "periodo": 202606,
        "valor": 276672116.0,
        "delta": -2385730.0
      },
      {
        "periodo": 202607,
        "valor": 297281050.0,
        "delta": 20608934.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 8378319.0,
    "valor_anterior": 9338693.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1430434.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2614216.0,
        "delta": 1183782.0
      },
      {
        "periodo": 202509,
        "valor": 3919941.0,
        "delta": 1305725.0
      },
      {
        "periodo": 202510,
        "valor": 3048750.0,
        "delta": -871191.0
      },
      {
        "periodo": 202511,
        "valor": 4883213.0,
        "delta": 1834463.0
      },
      {
        "periodo": 202512,
        "valor": 5979549.0,
        "delta": 1096336.0
      },
      {
        "periodo": 202601,
        "valor": 6363333.0,
        "delta": 383784.0
      },
      {
        "periodo": 202602,
        "valor": 5559750.0,
        "delta": -803583.0
      },
      {
        "periodo": 202603,
        "valor": 5683625.0,
        "delta": 123875.0
      },
      {
        "periodo": 202604,
        "valor": 4816481.0,
        "delta": -867144.0
      },
      {
        "periodo": 202605,
        "valor": 5354743.0,
        "delta": 538262.0
      },
      {
        "periodo": 202606,
        "valor": 9338693.0,
        "delta": 3983950.0
      },
      {
        "periodo": 202607,
        "valor": 8378319.0,
        "delta": -960374.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 32874574.0,
    "valor_anterior": 31786049.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 24202772.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26054848.0,
        "delta": 1852076.0
      },
      {
        "periodo": 202509,
        "valor": 27492992.0,
        "delta": 1438144.0
      },
      {
        "periodo": 202510,
        "valor": 30424668.0,
        "delta": 2931676.0
      },
      {
        "periodo": 202511,
        "valor": 31031005.0,
        "delta": 606337.0
      },
      {
        "periodo": 202512,
        "valor": 33238083.0,
        "delta": 2207078.0
      },
      {
        "periodo": 202601,
        "valor": 33393853.0,
        "delta": 155770.0
      },
      {
        "periodo": 202602,
        "valor": 30343668.0,
        "delta": -3050185.0
      },
      {
        "periodo": 202603,
        "valor": 32401340.0,
        "delta": 2057672.0
      },
      {
        "periodo": 202604,
        "valor": 33778665.0,
        "delta": 1377325.0
      },
      {
        "periodo": 202605,
        "valor": 33129702.0,
        "delta": -648963.0
      },
      {
        "periodo": 202606,
        "valor": 31786049.0,
        "delta": -1343653.0
      },
      {
        "periodo": 202607,
        "valor": 32874574.0,
        "delta": 1088525.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 158428988.52999997,
    "valor_anterior": 152162182.09000003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 167354267.33,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 161717713.41,
        "delta": -5636553.92
      },
      {
        "periodo": 202509,
        "valor": 155057857.26,
        "delta": -6659856.15
      },
      {
        "periodo": 202510,
        "valor": 161909327.94,
        "delta": 6851470.68
      },
      {
        "periodo": 202511,
        "valor": 153165245.92,
        "delta": -8744082.02
      },
      {
        "periodo": 202512,
        "valor": 158963244.87,
        "delta": 5797998.95
      },
      {
        "periodo": 202601,
        "valor": 157272687.68,
        "delta": -1690557.19
      },
      {
        "periodo": 202602,
        "valor": 139304069.57,
        "delta": -17968618.11
      },
      {
        "periodo": 202603,
        "valor": 156452059.64,
        "delta": 17147990.07
      },
      {
        "periodo": 202604,
        "valor": 155883354.8,
        "delta": -568704.84
      },
      {
        "periodo": 202605,
        "valor": 155151221.44,
        "delta": -732133.36
      },
      {
        "periodo": 202606,
        "valor": 152162182.09,
        "delta": -2989039.35
      },
      {
        "periodo": 202607,
        "valor": 158428988.53,
        "delta": 6266806.44
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 21937450.0,
    "valor_anterior": 21651130.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20984872.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 20054599.0,
        "delta": -930273.0
      },
      {
        "periodo": 202509,
        "valor": 19187483.0,
        "delta": -867116.0
      },
      {
        "periodo": 202510,
        "valor": 21063764.0,
        "delta": 1876281.0
      },
      {
        "periodo": 202511,
        "valor": 21963148.0,
        "delta": 899384.0
      },
      {
        "periodo": 202512,
        "valor": 24827079.0,
        "delta": 2863931.0
      },
      {
        "periodo": 202601,
        "valor": 21417349.0,
        "delta": -3409730.0
      },
      {
        "periodo": 202602,
        "valor": 16687321.0,
        "delta": -4730028.0
      },
      {
        "periodo": 202603,
        "valor": 20423332.0,
        "delta": 3736011.0
      },
      {
        "periodo": 202604,
        "valor": 22498928.0,
        "delta": 2075596.0
      },
      {
        "periodo": 202605,
        "valor": 21832279.0,
        "delta": -666649.0
      },
      {
        "periodo": 202606,
        "valor": 21651130.0,
        "delta": -181149.0
      },
      {
        "periodo": 202607,
        "valor": 21937450.0,
        "delta": 286320.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 525334272.27000046,
    "valor_anterior": 511854632.27,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 545788333.84,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 535767028.33,
        "delta": -10021305.51
      },
      {
        "periodo": 202509,
        "valor": 518425234.79,
        "delta": -17341793.54
      },
      {
        "periodo": 202510,
        "valor": 545052008.29,
        "delta": 26626773.5
      },
      {
        "periodo": 202511,
        "valor": 528571187.32,
        "delta": -16480820.97
      },
      {
        "periodo": 202512,
        "valor": 561846584.73,
        "delta": 33275397.41
      },
      {
        "periodo": 202601,
        "valor": 546619272.79,
        "delta": -15227311.94
      },
      {
        "periodo": 202602,
        "valor": 485022282.87,
        "delta": -61596989.92
      },
      {
        "periodo": 202603,
        "valor": 539331491.12,
        "delta": 54309208.25
      },
      {
        "periodo": 202604,
        "valor": 519351204.08,
        "delta": -19980287.04
      },
      {
        "periodo": 202605,
        "valor": 539328280.1,
        "delta": 19977076.02
      },
      {
        "periodo": 202606,
        "valor": 511854632.27,
        "delta": -27473647.83
      },
      {
        "periodo": 202607,
        "valor": 525334272.27,
        "delta": 13479640.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 144072596.58000004,
    "valor_anterior": 138282926.34000003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 128648755.77,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 125734641.07,
        "delta": -2914114.7
      },
      {
        "periodo": 202509,
        "valor": 122627721.45,
        "delta": -3106919.62
      },
      {
        "periodo": 202510,
        "valor": 129852531.86,
        "delta": 7224810.41
      },
      {
        "periodo": 202511,
        "valor": 125380731.26,
        "delta": -4471800.6
      },
      {
        "periodo": 202512,
        "valor": 127222264.37,
        "delta": 1841533.11
      },
      {
        "periodo": 202601,
        "valor": 131929916.19,
        "delta": 4707651.82
      },
      {
        "periodo": 202602,
        "valor": 120799163.82,
        "delta": -11130752.37
      },
      {
        "periodo": 202603,
        "valor": 134598432.2,
        "delta": 13799268.38
      },
      {
        "periodo": 202604,
        "valor": 128323105.38,
        "delta": -6275326.82
      },
      {
        "periodo": 202605,
        "valor": 139119159.94,
        "delta": 10796054.56
      },
      {
        "periodo": 202606,
        "valor": 138282926.34,
        "delta": -836233.6
      },
      {
        "periodo": 202607,
        "valor": 144072596.58,
        "delta": 5789670.24
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 61720312.0,
    "valor_anterior": 53745867.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 60536617.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 65670742.0,
        "delta": 5134125.0
      },
      {
        "periodo": 202509,
        "valor": 67146087.0,
        "delta": 1475345.0
      },
      {
        "periodo": 202510,
        "valor": 67851136.0,
        "delta": 705049.0
      },
      {
        "periodo": 202511,
        "valor": 69729444.0,
        "delta": 1878308.0
      },
      {
        "periodo": 202512,
        "valor": 66137909.0,
        "delta": -3591535.0
      },
      {
        "periodo": 202601,
        "valor": 68738945.0,
        "delta": 2601036.0
      },
      {
        "periodo": 202602,
        "valor": 57111506.0,
        "delta": -11627439.0
      },
      {
        "periodo": 202603,
        "valor": 65196658.0,
        "delta": 8085152.0
      },
      {
        "periodo": 202604,
        "valor": 60565697.0,
        "delta": -4630961.0
      },
      {
        "periodo": 202605,
        "valor": 59098104.0,
        "delta": -1467593.0
      },
      {
        "periodo": 202606,
        "valor": 53745867.0,
        "delta": -5352237.0
      },
      {
        "periodo": 202607,
        "valor": 61720312.0,
        "delta": 7974445.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 958438088.999999,
    "valor_anterior": 882530921.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1103757672.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1219215384.0,
        "delta": 115457712.0
      },
      {
        "periodo": 202509,
        "valor": 1279926603.0,
        "delta": 60711219.0
      },
      {
        "periodo": 202510,
        "valor": 1114519963.0,
        "delta": -165406640.0
      },
      {
        "periodo": 202511,
        "valor": 1085988256.0,
        "delta": -28531707.0
      },
      {
        "periodo": 202512,
        "valor": 959984602.0,
        "delta": -126003654.0
      },
      {
        "periodo": 202601,
        "valor": 1031884439.0,
        "delta": 71899837.0
      },
      {
        "periodo": 202602,
        "valor": 965018593.0,
        "delta": -66865846.0
      },
      {
        "periodo": 202603,
        "valor": 993525570.0,
        "delta": 28506977.0
      },
      {
        "periodo": 202604,
        "valor": 968766830.0,
        "delta": -24758740.0
      },
      {
        "periodo": 202605,
        "valor": 1066142246.0,
        "delta": 97375416.0
      },
      {
        "periodo": 202606,
        "valor": 882530921.0,
        "delta": -183611325.0
      },
      {
        "periodo": 202607,
        "valor": 958438089.0,
        "delta": 75907168.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 37521077.0,
    "valor_anterior": 38084202.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 45444555.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 43930267.0,
        "delta": -1514288.0
      },
      {
        "periodo": 202509,
        "valor": 41540949.0,
        "delta": -2389318.0
      },
      {
        "periodo": 202510,
        "valor": 47293360.0,
        "delta": 5752411.0
      },
      {
        "periodo": 202511,
        "valor": 40479644.0,
        "delta": -6813716.0
      },
      {
        "periodo": 202512,
        "valor": 39025294.0,
        "delta": -1454350.0
      },
      {
        "periodo": 202601,
        "valor": 38870720.0,
        "delta": -154574.0
      },
      {
        "periodo": 202602,
        "valor": 35805719.0,
        "delta": -3065001.0
      },
      {
        "periodo": 202603,
        "valor": 51989039.0,
        "delta": 16183320.0
      },
      {
        "periodo": 202604,
        "valor": 38112359.0,
        "delta": -13876680.0
      },
      {
        "periodo": 202605,
        "valor": 38375370.0,
        "delta": 263011.0
      },
      {
        "periodo": 202606,
        "valor": 38084202.0,
        "delta": -291168.0
      },
      {
        "periodo": 202607,
        "valor": 37521077.0,
        "delta": -563125.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 72290392.07,
    "valor_anterior": 73142034.59999996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 96908363.2,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 99963769.5,
        "delta": 3055406.3
      },
      {
        "periodo": 202509,
        "valor": 100549607.92,
        "delta": 585838.42
      },
      {
        "periodo": 202510,
        "valor": 97620873.99,
        "delta": -2928733.93
      },
      {
        "periodo": 202511,
        "valor": 89084683.13,
        "delta": -8536190.86
      },
      {
        "periodo": 202512,
        "valor": 71043560.79,
        "delta": -18041122.34
      },
      {
        "periodo": 202601,
        "valor": 78674910.29,
        "delta": 7631349.5
      },
      {
        "periodo": 202602,
        "valor": 75923989.85,
        "delta": -2750920.44
      },
      {
        "periodo": 202603,
        "valor": 85807618.33,
        "delta": 9883628.48
      },
      {
        "periodo": 202604,
        "valor": 78238663.33,
        "delta": -7568955.0
      },
      {
        "periodo": 202605,
        "valor": 76832877.3,
        "delta": -1405786.03
      },
      {
        "periodo": 202606,
        "valor": 73142034.6,
        "delta": -3690842.7
      },
      {
        "periodo": 202607,
        "valor": 72290392.07,
        "delta": -851642.53
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 37673964.390000015,
    "valor_anterior": 36332783.97999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 44689893.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 52435106.61,
        "delta": 7745212.74
      },
      {
        "periodo": 202509,
        "valor": 32657229.73,
        "delta": -19777876.88
      },
      {
        "periodo": 202510,
        "valor": 33900064.58,
        "delta": 1242834.85
      },
      {
        "periodo": 202511,
        "valor": 31933206.68,
        "delta": -1966857.9
      },
      {
        "periodo": 202512,
        "valor": 30608572.6,
        "delta": -1324634.08
      },
      {
        "periodo": 202601,
        "valor": 31472421.13,
        "delta": 863848.53
      },
      {
        "periodo": 202602,
        "valor": 29581230.6,
        "delta": -1891190.53
      },
      {
        "periodo": 202603,
        "valor": 37281439.14,
        "delta": 7700208.54
      },
      {
        "periodo": 202604,
        "valor": 33548606.36,
        "delta": -3732832.78
      },
      {
        "periodo": 202605,
        "valor": 38250244.93,
        "delta": 4701638.57
      },
      {
        "periodo": 202606,
        "valor": 36332783.98,
        "delta": -1917460.95
      },
      {
        "periodo": 202607,
        "valor": 37673964.39,
        "delta": 1341180.41
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 29797542.0,
    "valor_anterior": 33336779.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 36320129.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 34645017.0,
        "delta": -1675112.0
      },
      {
        "periodo": 202509,
        "valor": 38761504.0,
        "delta": 4116487.0
      },
      {
        "periodo": 202510,
        "valor": 36508646.0,
        "delta": -2252858.0
      },
      {
        "periodo": 202511,
        "valor": 35865105.0,
        "delta": -643541.0
      },
      {
        "periodo": 202512,
        "valor": 46202358.0,
        "delta": 10337253.0
      },
      {
        "periodo": 202601,
        "valor": 35214881.0,
        "delta": -10987477.0
      },
      {
        "periodo": 202602,
        "valor": 35355706.0,
        "delta": 140825.0
      },
      {
        "periodo": 202603,
        "valor": 39428281.0,
        "delta": 4072575.0
      },
      {
        "periodo": 202604,
        "valor": 34683255.0,
        "delta": -4745026.0
      },
      {
        "periodo": 202605,
        "valor": 34287737.0,
        "delta": -395518.0
      },
      {
        "periodo": 202606,
        "valor": 33336779.0,
        "delta": -950958.0
      },
      {
        "periodo": 202607,
        "valor": 29797542.0,
        "delta": -3539237.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 31412977.0,
    "valor_anterior": 28512646.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 33825516.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 32777939.0,
        "delta": -1047577.0
      },
      {
        "periodo": 202509,
        "valor": 30264974.0,
        "delta": -2512965.0
      },
      {
        "periodo": 202510,
        "valor": 31735640.0,
        "delta": 1470666.0
      },
      {
        "periodo": 202511,
        "valor": 31005364.0,
        "delta": -730276.0
      },
      {
        "periodo": 202512,
        "valor": 31604057.0,
        "delta": 598693.0
      },
      {
        "periodo": 202601,
        "valor": 32200473.0,
        "delta": 596416.0
      },
      {
        "periodo": 202602,
        "valor": 26949779.0,
        "delta": -5250694.0
      },
      {
        "periodo": 202603,
        "valor": 32612068.0,
        "delta": 5662289.0
      },
      {
        "periodo": 202604,
        "valor": 28057102.0,
        "delta": -4554966.0
      },
      {
        "periodo": 202605,
        "valor": 31335738.0,
        "delta": 3278636.0
      },
      {
        "periodo": 202606,
        "valor": 28512646.0,
        "delta": -2823092.0
      },
      {
        "periodo": 202607,
        "valor": 31412977.0,
        "delta": 2900331.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 85672115.0,
    "valor_anterior": 87290410.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 102400644.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 89782336.0,
        "delta": -12618308.0
      },
      {
        "periodo": 202509,
        "valor": 84431998.0,
        "delta": -5350338.0
      },
      {
        "periodo": 202510,
        "valor": 96368836.0,
        "delta": 11936838.0
      },
      {
        "periodo": 202511,
        "valor": 96269028.0,
        "delta": -99808.0
      },
      {
        "periodo": 202512,
        "valor": 100115530.0,
        "delta": 3846502.0
      },
      {
        "periodo": 202601,
        "valor": 93775983.0,
        "delta": -6339547.0
      },
      {
        "periodo": 202602,
        "valor": 93106865.0,
        "delta": -669118.0
      },
      {
        "periodo": 202603,
        "valor": 87004284.0,
        "delta": -6102581.0
      },
      {
        "periodo": 202604,
        "valor": 77140202.0,
        "delta": -9864082.0
      },
      {
        "periodo": 202605,
        "valor": 88732726.0,
        "delta": 11592524.0
      },
      {
        "periodo": 202606,
        "valor": 87290410.0,
        "delta": -1442316.0
      },
      {
        "periodo": 202607,
        "valor": 85672115.0,
        "delta": -1618295.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 5447043.280000001,
    "valor_anterior": 5185313.3999999985,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8154974.35,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6021712.02,
        "delta": -2133262.33
      },
      {
        "periodo": 202509,
        "valor": 5308646.03,
        "delta": -713065.99
      },
      {
        "periodo": 202510,
        "valor": 5904681.62,
        "delta": 596035.59
      },
      {
        "periodo": 202511,
        "valor": 5685777.17,
        "delta": -218904.45
      },
      {
        "periodo": 202512,
        "valor": 5891871.73,
        "delta": 206094.56
      },
      {
        "periodo": 202601,
        "valor": 6075589.07,
        "delta": 183717.34
      },
      {
        "periodo": 202602,
        "valor": 5400583.0,
        "delta": -675006.07
      },
      {
        "periodo": 202603,
        "valor": 6028194.12,
        "delta": 627611.12
      },
      {
        "periodo": 202604,
        "valor": 5517168.13,
        "delta": -511025.99
      },
      {
        "periodo": 202605,
        "valor": 5510139.03,
        "delta": -7029.1
      },
      {
        "periodo": 202606,
        "valor": 5185313.4,
        "delta": -324825.63
      },
      {
        "periodo": 202607,
        "valor": 5447043.28,
        "delta": 261729.88
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 178614132.0,
    "valor_anterior": 175576942.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10664276.37,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10414962.21,
        "delta": -249314.16
      },
      {
        "periodo": 202509,
        "valor": 9985303.91,
        "delta": -429658.3
      },
      {
        "periodo": 202510,
        "valor": 10061013.84,
        "delta": 75709.93
      },
      {
        "periodo": 202511,
        "valor": 9474081.76,
        "delta": -586932.08
      },
      {
        "periodo": 202512,
        "valor": 9627389.49,
        "delta": 153307.73
      },
      {
        "periodo": 202601,
        "valor": 9472623.13,
        "delta": -154766.36
      },
      {
        "periodo": 202602,
        "valor": 163351811.87,
        "delta": 153879188.74
      },
      {
        "periodo": 202603,
        "valor": 180612379.0,
        "delta": 17260567.13
      },
      {
        "periodo": 202604,
        "valor": 177276935.0,
        "delta": -3335444.0
      },
      {
        "periodo": 202605,
        "valor": 179042840.0,
        "delta": 1765905.0
      },
      {
        "periodo": 202606,
        "valor": 175576942.0,
        "delta": -3465898.0
      },
      {
        "periodo": 202607,
        "valor": 178614132.0,
        "delta": 3037190.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 150210702.0,
    "valor_anterior": 134438102.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28188263.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 44450602.0,
        "delta": 16262339.0
      },
      {
        "periodo": 202509,
        "valor": 56297649.0,
        "delta": 11847047.0
      },
      {
        "periodo": 202510,
        "valor": 74344420.0,
        "delta": 18046771.0
      },
      {
        "periodo": 202511,
        "valor": 83911984.0,
        "delta": 9567564.0
      },
      {
        "periodo": 202512,
        "valor": 104270062.0,
        "delta": 20358078.0
      },
      {
        "periodo": 202601,
        "valor": 125364265.0,
        "delta": 21094203.0
      },
      {
        "periodo": 202602,
        "valor": 127529175.0,
        "delta": 2164910.0
      },
      {
        "periodo": 202603,
        "valor": 146013096.0,
        "delta": 18483921.0
      },
      {
        "periodo": 202604,
        "valor": 135108515.0,
        "delta": -10904581.0
      },
      {
        "periodo": 202605,
        "valor": 139063540.0,
        "delta": 3955025.0
      },
      {
        "periodo": 202606,
        "valor": 134438102.0,
        "delta": -4625438.0
      },
      {
        "periodo": 202607,
        "valor": 150210702.0,
        "delta": 15772600.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 50878454.24000001,
    "valor_anterior": 48949718.17999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 38093002.17,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 7925483.88,
        "delta": -30167518.29
      },
      {
        "periodo": 202601,
        "valor": 8080843.28,
        "delta": 155359.4
      },
      {
        "periodo": 202602,
        "valor": 11073578.94,
        "delta": 2992735.66
      },
      {
        "periodo": 202603,
        "valor": 23981982.24,
        "delta": 12908403.3
      },
      {
        "periodo": 202604,
        "valor": 31434425.3,
        "delta": 7452443.06
      },
      {
        "periodo": 202605,
        "valor": 41012620.47,
        "delta": 9578195.17
      },
      {
        "periodo": 202606,
        "valor": 48949718.18,
        "delta": 7937097.71
      },
      {
        "periodo": 202607,
        "valor": 50878454.24,
        "delta": 1928736.06
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 1107611808.999999,
    "valor_anterior": 1004154333.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 2406323549.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 1077898140.0,
        "delta": -1328425409.0
      },
      {
        "periodo": 202605,
        "valor": 967077749.0,
        "delta": -110820391.0
      },
      {
        "periodo": 202606,
        "valor": 1004154333.0,
        "delta": 37076584.0
      },
      {
        "periodo": 202607,
        "valor": 1107611809.0,
        "delta": 103457476.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 148224545933.66992,
    "valor_anterior": 141408886263.08008,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 151048399872.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 149309071800.5599,
        "delta": -1739328071.7101
      },
      {
        "periodo": 202509,
        "valor": 137004865048.5103,
        "delta": -12304206752.0497
      },
      {
        "periodo": 202510,
        "valor": 147207509859.8098,
        "delta": 10202644811.2996
      },
      {
        "periodo": 202511,
        "valor": 143706505677.77,
        "delta": -3501004182.0398
      },
      {
        "periodo": 202512,
        "valor": 147509702728.1101,
        "delta": 3803197050.3401
      },
      {
        "periodo": 202601,
        "valor": 146437850093.01,
        "delta": -1071852635.1001
      },
      {
        "periodo": 202602,
        "valor": 133071777440.5,
        "delta": -13366072652.51
      },
      {
        "periodo": 202603,
        "valor": 151981490141.91,
        "delta": 18909712701.41
      },
      {
        "periodo": 202604,
        "valor": 144901330882.2401,
        "delta": -7080159259.6699
      },
      {
        "periodo": 202605,
        "valor": 145814001244.5299,
        "delta": 912670362.2899
      },
      {
        "periodo": 202606,
        "valor": 141408886263.0801,
        "delta": -4405114981.4498
      },
      {
        "periodo": 202607,
        "valor": 148224545933.6699,
        "delta": 6815659670.5898
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 105076723398.42993,
    "valor_anterior": 101158891290.06006,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 107466851901.92,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 105598384195.5,
        "delta": -1868467706.42
      },
      {
        "periodo": 202509,
        "valor": 102776901844.41,
        "delta": -2821482351.09
      },
      {
        "periodo": 202510,
        "valor": 105030167234.5599,
        "delta": 2253265390.1499
      },
      {
        "periodo": 202511,
        "valor": 102437350469.39,
        "delta": -2592816765.1699
      },
      {
        "periodo": 202512,
        "valor": 104521058678.1799,
        "delta": 2083708208.7899
      },
      {
        "periodo": 202601,
        "valor": 104176903105.97,
        "delta": -344155572.2099
      },
      {
        "periodo": 202602,
        "valor": 94985643306.42,
        "delta": -9191259799.55
      },
      {
        "periodo": 202603,
        "valor": 104933721902.6,
        "delta": 9948078596.18
      },
      {
        "periodo": 202604,
        "valor": 102798424345.5,
        "delta": -2135297557.1
      },
      {
        "periodo": 202605,
        "valor": 103628373544.13,
        "delta": 829949198.63
      },
      {
        "periodo": 202606,
        "valor": 101158891290.0601,
        "delta": -2469482254.0699
      },
      {
        "periodo": 202607,
        "valor": 105076723398.4299,
        "delta": 3917832108.3699
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 2374235928.5200005,
    "valor_anterior": 2200870671.289999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3616230611.64,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3226780619.46,
        "delta": -389449992.18
      },
      {
        "periodo": 202509,
        "valor": -4012292833.52,
        "delta": -7239073452.98
      },
      {
        "periodo": 202510,
        "valor": 2588271772.06,
        "delta": 6600564605.58
      },
      {
        "periodo": 202511,
        "valor": 2490919223.49,
        "delta": -97352548.57
      },
      {
        "periodo": 202512,
        "valor": 2571751128.92,
        "delta": 80831905.43
      },
      {
        "periodo": 202601,
        "valor": 2539587537.92,
        "delta": -32163591.0
      },
      {
        "periodo": 202602,
        "valor": 2187441368.12,
        "delta": -352146169.8
      },
      {
        "periodo": 202603,
        "valor": 2554252834.01,
        "delta": 366811465.89
      },
      {
        "periodo": 202604,
        "valor": 2309087486.94,
        "delta": -245165347.07
      },
      {
        "periodo": 202605,
        "valor": 2214738523.37,
        "delta": -94348963.57
      },
      {
        "periodo": 202606,
        "valor": 2200870671.29,
        "delta": -13867852.08
      },
      {
        "periodo": 202607,
        "valor": 2374235928.52,
        "delta": 173365257.23
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 10508492425.979996,
    "valor_anterior": 9167974056.529999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11743209154.64,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11905594107.91,
        "delta": 162384953.27
      },
      {
        "periodo": 202509,
        "valor": 10277128176.45,
        "delta": -1628465931.46
      },
      {
        "periodo": 202510,
        "valor": 10591641110.36,
        "delta": 314512933.91
      },
      {
        "periodo": 202511,
        "valor": 10301103650.81,
        "delta": -290537459.55
      },
      {
        "periodo": 202512,
        "valor": 10848442089.77,
        "delta": 547338438.96
      },
      {
        "periodo": 202601,
        "valor": 11069623699.4,
        "delta": 221181609.63
      },
      {
        "periodo": 202602,
        "valor": 9359410580.6,
        "delta": -1710213118.8
      },
      {
        "periodo": 202603,
        "valor": 12657720742.84,
        "delta": 3298310162.24
      },
      {
        "periodo": 202604,
        "valor": 10396554998.52,
        "delta": -2261165744.32
      },
      {
        "periodo": 202605,
        "valor": 10107096909.97,
        "delta": -289458088.55
      },
      {
        "periodo": 202606,
        "valor": 9167974056.53,
        "delta": -939122853.44
      },
      {
        "periodo": 202607,
        "valor": 10508492425.98,
        "delta": 1340518369.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 10265580105.329994,
    "valor_anterior": 9853129743.93,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10333803807.18,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10367751865.28,
        "delta": 33948058.1
      },
      {
        "periodo": 202509,
        "valor": 10215732617.39,
        "delta": -152019247.89
      },
      {
        "periodo": 202510,
        "valor": 10590291182.91,
        "delta": 374558565.52
      },
      {
        "periodo": 202511,
        "valor": 10144761404.51,
        "delta": -445529778.4
      },
      {
        "periodo": 202512,
        "valor": 10865412505.04,
        "delta": 720651100.53
      },
      {
        "periodo": 202601,
        "valor": 10086143071.63,
        "delta": -779269433.41
      },
      {
        "periodo": 202602,
        "valor": 9489426239.29,
        "delta": -596716832.34
      },
      {
        "periodo": 202603,
        "valor": 10501182346.1,
        "delta": 1011756106.81
      },
      {
        "periodo": 202604,
        "valor": 10191957987.91,
        "delta": -309224358.19
      },
      {
        "periodo": 202605,
        "valor": 10515321470.37,
        "delta": 323363482.46
      },
      {
        "periodo": 202606,
        "valor": 9853129743.93,
        "delta": -662191726.44
      },
      {
        "periodo": 202607,
        "valor": 10265580105.33,
        "delta": 412450361.4
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 2875704310.8399963,
    "valor_anterior": 2684362031.2800007,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2753432477.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2753085300.81,
        "delta": -347176.45
      },
      {
        "periodo": 202509,
        "valor": 2804322405.85,
        "delta": 51237105.04
      },
      {
        "periodo": 202510,
        "valor": 2926743988.66,
        "delta": 122421582.81
      },
      {
        "periodo": 202511,
        "valor": 2725962070.31,
        "delta": -200781918.35
      },
      {
        "periodo": 202512,
        "valor": 2863273307.36,
        "delta": 137311237.05
      },
      {
        "periodo": 202601,
        "valor": 2828606461.08,
        "delta": -34666846.28
      },
      {
        "periodo": 202602,
        "valor": 2504819283.71,
        "delta": -323787177.37
      },
      {
        "periodo": 202603,
        "valor": 3008881682.43,
        "delta": 504062398.72
      },
      {
        "periodo": 202604,
        "valor": 2699926808.95,
        "delta": -308954873.48
      },
      {
        "periodo": 202605,
        "valor": 2755000577.71,
        "delta": 55073768.76
      },
      {
        "periodo": 202606,
        "valor": 2684362031.28,
        "delta": -70638546.43
      },
      {
        "periodo": 202607,
        "valor": 2875704310.84,
        "delta": 191342279.56
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100006,
    "label": "Ingresos por Intereses",
    "valor_actual": 17123809764.569992,
    "valor_anterior": 16343658469.990005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15134871919.63,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15457475711.6,
        "delta": 322603791.97
      },
      {
        "periodo": 202509,
        "valor": 14943072837.93,
        "delta": -514402873.67
      },
      {
        "periodo": 202510,
        "valor": 15480394571.26,
        "delta": 537321733.33
      },
      {
        "periodo": 202511,
        "valor": 15606408859.26,
        "delta": 126014288.0
      },
      {
        "periodo": 202512,
        "valor": 15839765018.84,
        "delta": 233356159.58
      },
      {
        "periodo": 202601,
        "valor": 15736986217.01,
        "delta": -102778801.83
      },
      {
        "periodo": 202602,
        "valor": 14545036662.36,
        "delta": -1191949554.65
      },
      {
        "periodo": 202603,
        "valor": 18325730633.93,
        "delta": 3780693971.57
      },
      {
        "periodo": 202604,
        "valor": 16505379254.42,
        "delta": -1820351379.51
      },
      {
        "periodo": 202605,
        "valor": 16593470218.98,
        "delta": 88090964.56
      },
      {
        "periodo": 202606,
        "valor": 16343658469.99,
        "delta": -249811748.99
      },
      {
        "periodo": 202607,
        "valor": 17123809764.57,
        "delta": 780151294.58
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 2653882104.669998,
    "valor_anterior": 2966128554.1000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2861682778.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2799578341.63,
        "delta": -62104436.66
      },
      {
        "periodo": 202509,
        "valor": 2730159572.51,
        "delta": -69418769.12
      },
      {
        "periodo": 202510,
        "valor": 3561322969.61,
        "delta": 831163397.1
      },
      {
        "periodo": 202511,
        "valor": 2888617921.76,
        "delta": -672705047.85
      },
      {
        "periodo": 202512,
        "valor": 2819435538.16,
        "delta": -69182383.6
      },
      {
        "periodo": 202601,
        "valor": 3161513266.04,
        "delta": 342077727.88
      },
      {
        "periodo": 202602,
        "valor": 2200004331.39,
        "delta": -961508934.65
      },
      {
        "periodo": 202603,
        "valor": 5034326494.18,
        "delta": 2834322162.79
      },
      {
        "periodo": 202604,
        "valor": 2835577133.33,
        "delta": -2198749360.85
      },
      {
        "periodo": 202605,
        "valor": 2411323248.93,
        "delta": -424253884.4
      },
      {
        "periodo": 202606,
        "valor": 2966128554.1,
        "delta": 554805305.17
      },
      {
        "periodo": 202607,
        "valor": 2653882104.67,
        "delta": -312246449.43
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 7978477262.7599945,
    "valor_anterior": 7690369489.599998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8843144470.02,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8884026484.8,
        "delta": 40882014.78
      },
      {
        "periodo": 202509,
        "valor": 8478820335.43,
        "delta": -405206149.37
      },
      {
        "periodo": 202510,
        "valor": 8464679395.36,
        "delta": -14140940.07
      },
      {
        "periodo": 202511,
        "valor": 8081247262.77,
        "delta": -383432132.59
      },
      {
        "periodo": 202512,
        "valor": 9014420723.74,
        "delta": 933173460.97
      },
      {
        "periodo": 202601,
        "valor": 8623572436.06,
        "delta": -390848287.68
      },
      {
        "periodo": 202602,
        "valor": 7552875597.57,
        "delta": -1070696838.49
      },
      {
        "periodo": 202603,
        "valor": 8618989890.25,
        "delta": 1066114292.68
      },
      {
        "periodo": 202604,
        "valor": 7810517839.81,
        "delta": -808472050.44
      },
      {
        "periodo": 202605,
        "valor": 7787633590.04,
        "delta": -22884249.77
      },
      {
        "periodo": 202606,
        "valor": 7690369489.6,
        "delta": -97264100.44
      },
      {
        "periodo": 202607,
        "valor": 7978477262.76,
        "delta": 288107773.16
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 7721315573.999992,
    "valor_anterior": 7752986002.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7945895888.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8147899086.0,
        "delta": 202003198.0
      },
      {
        "periodo": 202509,
        "valor": 7697244265.0,
        "delta": -450654821.0
      },
      {
        "periodo": 202510,
        "valor": 8569945356.0,
        "delta": 872701091.0
      },
      {
        "periodo": 202511,
        "valor": 7632985295.0,
        "delta": -936960061.0
      },
      {
        "periodo": 202512,
        "valor": 7472098398.0,
        "delta": -160886897.0
      },
      {
        "periodo": 202601,
        "valor": 7713130494.0,
        "delta": 241032096.0
      },
      {
        "periodo": 202602,
        "valor": 6904594338.0,
        "delta": -808536156.0
      },
      {
        "periodo": 202603,
        "valor": 7667786302.0,
        "delta": 763191964.0
      },
      {
        "periodo": 202604,
        "valor": 7286624207.0,
        "delta": -381162095.0
      },
      {
        "periodo": 202605,
        "valor": 7524684307.0,
        "delta": 238060100.0
      },
      {
        "periodo": 202606,
        "valor": 7752986002.0,
        "delta": 228301695.0
      },
      {
        "periodo": 202607,
        "valor": 7721315574.0,
        "delta": -31670428.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 2595525109.0,
    "valor_anterior": 2495163282.999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3365487946.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3271072692.0,
        "delta": -94415254.0
      },
      {
        "periodo": 202509,
        "valor": 3041444830.0,
        "delta": -229627862.0
      },
      {
        "periodo": 202510,
        "valor": 3134539717.0,
        "delta": 93094887.0
      },
      {
        "periodo": 202511,
        "valor": 3026284163.0,
        "delta": -108255554.0
      },
      {
        "periodo": 202512,
        "valor": 2975206394.5,
        "delta": -51077768.5
      },
      {
        "periodo": 202601,
        "valor": 2776899490.0,
        "delta": -198306904.5
      },
      {
        "periodo": 202602,
        "valor": 2443665567.0,
        "delta": -333233923.0
      },
      {
        "periodo": 202603,
        "valor": 2571656734.0,
        "delta": 127991167.0
      },
      {
        "periodo": 202604,
        "valor": 2517269283.0,
        "delta": -54387451.0
      },
      {
        "periodo": 202605,
        "valor": 2575438364.0,
        "delta": 58169081.0
      },
      {
        "periodo": 202606,
        "valor": 2495163283.0,
        "delta": -80275081.0
      },
      {
        "periodo": 202607,
        "valor": 2595525109.0,
        "delta": 100361826.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 1378674846.63,
    "valor_anterior": 1300852434.4499998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1462451567.48,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1462336612.88,
        "delta": -114954.6
      },
      {
        "periodo": 202509,
        "valor": 1425650909.0,
        "delta": -36685703.88
      },
      {
        "periodo": 202510,
        "valor": 1409421659.82,
        "delta": -16229249.18
      },
      {
        "periodo": 202511,
        "valor": 1350645467.26,
        "delta": -58776192.56
      },
      {
        "periodo": 202512,
        "valor": 1367420947.9,
        "delta": 16775480.64
      },
      {
        "periodo": 202601,
        "valor": 1351536163.15,
        "delta": -15884784.75
      },
      {
        "periodo": 202602,
        "valor": 1219543883.7,
        "delta": -131992279.45
      },
      {
        "periodo": 202603,
        "valor": 1349508961.59,
        "delta": 129965077.89
      },
      {
        "periodo": 202604,
        "valor": 1358195563.6,
        "delta": 8686602.01
      },
      {
        "periodo": 202605,
        "valor": 1376656304.98,
        "delta": 18460741.38
      },
      {
        "periodo": 202606,
        "valor": 1300852434.45,
        "delta": -75803870.53
      },
      {
        "periodo": 202607,
        "valor": 1378674846.63,
        "delta": 77822412.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 4745186741.000004,
    "valor_anterior": 4349088378.999996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4990992371.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4884783599.0,
        "delta": -106208772.0
      },
      {
        "periodo": 202509,
        "valor": 4660463571.0,
        "delta": -224320028.0
      },
      {
        "periodo": 202510,
        "valor": 4766666042.0,
        "delta": 106202471.0
      },
      {
        "periodo": 202511,
        "valor": 4476422461.0,
        "delta": -290243581.0
      },
      {
        "periodo": 202512,
        "valor": 4740694005.0,
        "delta": 264271544.0
      },
      {
        "periodo": 202601,
        "valor": 4563372353.0,
        "delta": -177321652.0
      },
      {
        "periodo": 202602,
        "valor": 4139632849.0,
        "delta": -423739504.0
      },
      {
        "periodo": 202603,
        "valor": 4733256378.0,
        "delta": 593623529.0
      },
      {
        "periodo": 202604,
        "valor": 4451095275.0,
        "delta": -282161103.0
      },
      {
        "periodo": 202605,
        "valor": 4393782949.0,
        "delta": -57312326.0
      },
      {
        "periodo": 202606,
        "valor": 4349088379.0,
        "delta": -44694570.0
      },
      {
        "periodo": 202607,
        "valor": 4745186741.0,
        "delta": 396098362.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 857554009.000001,
    "valor_anterior": 842477472.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 872800603.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 867484813.0,
        "delta": -5315790.0
      },
      {
        "periodo": 202509,
        "valor": 837470969.0,
        "delta": -30013844.0
      },
      {
        "periodo": 202510,
        "valor": 833398605.0,
        "delta": -4072364.0
      },
      {
        "periodo": 202511,
        "valor": 800517497.0,
        "delta": -32881108.0
      },
      {
        "periodo": 202512,
        "valor": 831881257.0,
        "delta": 31363760.0
      },
      {
        "periodo": 202601,
        "valor": 882827719.0,
        "delta": 50946462.0
      },
      {
        "periodo": 202602,
        "valor": 802210837.0,
        "delta": -80616882.0
      },
      {
        "periodo": 202603,
        "valor": 894298887.0,
        "delta": 92088050.0
      },
      {
        "periodo": 202604,
        "valor": 881478561.0,
        "delta": -12820326.0
      },
      {
        "periodo": 202605,
        "valor": 885480750.0,
        "delta": 4002189.0
      },
      {
        "periodo": 202606,
        "valor": 842477472.0,
        "delta": -43003278.0
      },
      {
        "periodo": 202607,
        "valor": 857554009.0,
        "delta": 15076537.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 3136020266.0,
    "valor_anterior": 3056295774.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3566055037.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3489285917.0,
        "delta": -76769120.0
      },
      {
        "periodo": 202509,
        "valor": 3356644430.0,
        "delta": -132641487.0
      },
      {
        "periodo": 202510,
        "valor": 3427588414.0,
        "delta": 70943984.0
      },
      {
        "periodo": 202511,
        "valor": 3404148501.0,
        "delta": -23439913.0
      },
      {
        "periodo": 202512,
        "valor": 3412791745.0,
        "delta": 8643244.0
      },
      {
        "periodo": 202601,
        "valor": 3289484896.0,
        "delta": -123306849.0
      },
      {
        "periodo": 202602,
        "valor": 2965549117.0,
        "delta": -323935779.0
      },
      {
        "periodo": 202603,
        "valor": 3292912558.0,
        "delta": 327363441.0
      },
      {
        "periodo": 202604,
        "valor": 3093091706.0,
        "delta": -199820852.0
      },
      {
        "periodo": 202605,
        "valor": 3127372179.0,
        "delta": 34280473.0
      },
      {
        "periodo": 202606,
        "valor": 3056295774.0,
        "delta": -71076405.0
      },
      {
        "periodo": 202607,
        "valor": 3136020266.0,
        "delta": 79724492.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 1095906843.9000006,
    "valor_anterior": 1064729461.7299995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1273318258.91,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1230298036.5,
        "delta": -43020222.41
      },
      {
        "periodo": 202509,
        "valor": 1188777270.71,
        "delta": -41520765.79
      },
      {
        "periodo": 202510,
        "valor": 1222149296.87,
        "delta": 33372026.16
      },
      {
        "periodo": 202511,
        "valor": 1167803054.64,
        "delta": -54346242.23
      },
      {
        "periodo": 202512,
        "valor": 1214303761.99,
        "delta": 46500707.35
      },
      {
        "periodo": 202601,
        "valor": 1201116925.46,
        "delta": -13186836.53
      },
      {
        "periodo": 202602,
        "valor": 1037846138.5,
        "delta": -163270786.96
      },
      {
        "periodo": 202603,
        "valor": 1153552565.94,
        "delta": 115706427.44
      },
      {
        "periodo": 202604,
        "valor": 1082851199.87,
        "delta": -70701366.07
      },
      {
        "periodo": 202605,
        "valor": 1112938218.87,
        "delta": 30087019.0
      },
      {
        "periodo": 202606,
        "valor": 1064729461.73,
        "delta": -48208757.14
      },
      {
        "periodo": 202607,
        "valor": 1095906843.9,
        "delta": 31177382.17
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 1275457960.0,
    "valor_anterior": 1170959320.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1826038624.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1121431002.0,
        "delta": -704607622.0
      },
      {
        "periodo": 202509,
        "valor": 1284475272.0,
        "delta": 163044270.0
      },
      {
        "periodo": 202510,
        "valor": 1258619391.0,
        "delta": -25855881.0
      },
      {
        "periodo": 202511,
        "valor": 1461194903.0,
        "delta": 202575512.0
      },
      {
        "periodo": 202512,
        "valor": 1386802273.0,
        "delta": -74392630.0
      },
      {
        "periodo": 202601,
        "valor": 1728301821.0,
        "delta": 341499548.0
      },
      {
        "periodo": 202602,
        "valor": 1275761222.0,
        "delta": -452540599.0
      },
      {
        "periodo": 202603,
        "valor": 1149882792.0,
        "delta": -125878430.0
      },
      {
        "periodo": 202604,
        "valor": 1279392073.0,
        "delta": 129509281.0
      },
      {
        "periodo": 202605,
        "valor": 1255437144.0,
        "delta": -23954929.0
      },
      {
        "periodo": 202606,
        "valor": 1170959320.0,
        "delta": -84477824.0
      },
      {
        "periodo": 202607,
        "valor": 1275457960.0,
        "delta": 104498640.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 237705060.0,
    "valor_anterior": 233383415.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 330128114.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 318618643.0,
        "delta": -11509471.0
      },
      {
        "periodo": 202509,
        "valor": 307237021.0,
        "delta": -11381622.0
      },
      {
        "periodo": 202510,
        "valor": 308652737.0,
        "delta": 1415716.0
      },
      {
        "periodo": 202511,
        "valor": 287324210.0,
        "delta": -21328527.0
      },
      {
        "periodo": 202512,
        "valor": 290352369.0,
        "delta": 3028159.0
      },
      {
        "periodo": 202601,
        "valor": 279655958.0,
        "delta": -10696411.0
      },
      {
        "periodo": 202602,
        "valor": 247185669.0,
        "delta": -32470289.0
      },
      {
        "periodo": 202603,
        "valor": 267436112.0,
        "delta": 20250443.0
      },
      {
        "periodo": 202604,
        "valor": 251637893.0,
        "delta": -15798219.0
      },
      {
        "periodo": 202605,
        "valor": 256301661.0,
        "delta": 4663768.0
      },
      {
        "periodo": 202606,
        "valor": 233383415.0,
        "delta": -22918246.0
      },
      {
        "periodo": 202607,
        "valor": 237705060.0,
        "delta": 4321645.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 1433655424.0,
    "valor_anterior": 1305572911.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1962027499.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1936561013.0,
        "delta": -25466486.0
      },
      {
        "periodo": 202509,
        "valor": 1830224849.0,
        "delta": -106336164.0
      },
      {
        "periodo": 202510,
        "valor": 1744065034.0,
        "delta": -86159815.0
      },
      {
        "periodo": 202511,
        "valor": 1678121377.0,
        "delta": -65943657.0
      },
      {
        "periodo": 202512,
        "valor": 1722971038.0,
        "delta": 44849661.0
      },
      {
        "periodo": 202601,
        "valor": 1719564234.0,
        "delta": -3406804.0
      },
      {
        "periodo": 202602,
        "valor": 1499215713.0,
        "delta": -220348521.0
      },
      {
        "periodo": 202603,
        "valor": 1618133959.0,
        "delta": 118918246.0
      },
      {
        "periodo": 202604,
        "valor": 1486257518.0,
        "delta": -131876441.0
      },
      {
        "periodo": 202605,
        "valor": 1455372700.0,
        "delta": -30884818.0
      },
      {
        "periodo": 202606,
        "valor": 1305572911.0,
        "delta": -149799789.0
      },
      {
        "periodo": 202607,
        "valor": 1433655424.0,
        "delta": 128082513.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 17140653309.039993,
    "valor_anterior": 16668879473.130005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20221492520.66,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18958813198.35,
        "delta": -1262679322.31
      },
      {
        "periodo": 202509,
        "valor": 17294009455.12,
        "delta": -1664803743.23
      },
      {
        "periodo": 202510,
        "valor": 17938918054.69,
        "delta": 644908599.57
      },
      {
        "periodo": 202511,
        "valor": 16861673503.16,
        "delta": -1077244551.53
      },
      {
        "periodo": 202512,
        "valor": 15797623423.65,
        "delta": -1064050079.51
      },
      {
        "periodo": 202601,
        "valor": 15228149006.48,
        "delta": -569474417.17
      },
      {
        "periodo": 202602,
        "valor": 14439610097.8,
        "delta": -788538908.68
      },
      {
        "periodo": 202603,
        "valor": 16314337251.41,
        "delta": 1874727153.61
      },
      {
        "periodo": 202604,
        "valor": 15596591640.36,
        "delta": -717745611.05
      },
      {
        "periodo": 202605,
        "valor": 16961315465.17,
        "delta": 1364723824.81
      },
      {
        "periodo": 202606,
        "valor": 16668879473.13,
        "delta": -292435992.04
      },
      {
        "periodo": 202607,
        "valor": 17140653309.04,
        "delta": 471773835.91
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 892402886.0,
    "valor_anterior": 804793597.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 973860515.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1204921585.0,
        "delta": 231061070.0
      },
      {
        "periodo": 202509,
        "valor": 1048447745.0,
        "delta": -156473840.0
      },
      {
        "periodo": 202510,
        "valor": 1030621985.0,
        "delta": -17825760.0
      },
      {
        "periodo": 202511,
        "valor": 1175905951.0,
        "delta": 145283966.0
      },
      {
        "periodo": 202512,
        "valor": 1061516072.0,
        "delta": -114389879.0
      },
      {
        "periodo": 202601,
        "valor": 1241459819.0,
        "delta": 179943747.0
      },
      {
        "periodo": 202602,
        "valor": 1132602184.0,
        "delta": -108857635.0
      },
      {
        "periodo": 202603,
        "valor": 1498732732.0,
        "delta": 366130548.0
      },
      {
        "periodo": 202604,
        "valor": 889596901.0,
        "delta": -609135831.0
      },
      {
        "periodo": 202605,
        "valor": 798836393.0,
        "delta": -90760508.0
      },
      {
        "periodo": 202606,
        "valor": 804793597.0,
        "delta": 5957204.0
      },
      {
        "periodo": 202607,
        "valor": 892402886.0,
        "delta": 87609289.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 65687529.0,
    "valor_anterior": 65150784.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 57194170.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 59256786.0,
        "delta": 2062616.0
      },
      {
        "periodo": 202509,
        "valor": 59037475.0,
        "delta": -219311.0
      },
      {
        "periodo": 202510,
        "valor": 64504475.0,
        "delta": 5467000.0
      },
      {
        "periodo": 202511,
        "valor": 60605688.0,
        "delta": -3898787.0
      },
      {
        "periodo": 202512,
        "valor": 58584923.0,
        "delta": -2020765.0
      },
      {
        "periodo": 202601,
        "valor": 61464239.0,
        "delta": 2879316.0
      },
      {
        "periodo": 202602,
        "valor": 61649642.0,
        "delta": 185403.0
      },
      {
        "periodo": 202603,
        "valor": 59962682.0,
        "delta": -1686960.0
      },
      {
        "periodo": 202604,
        "valor": 60013502.0,
        "delta": 50820.0
      },
      {
        "periodo": 202605,
        "valor": 65070705.0,
        "delta": 5057203.0
      },
      {
        "periodo": 202606,
        "valor": 65150784.0,
        "delta": 80079.0
      },
      {
        "periodo": 202607,
        "valor": 65687529.0,
        "delta": 536745.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 371718839.0,
    "valor_anterior": 368671682.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 439483297.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 454226175.0,
        "delta": 14742878.0
      },
      {
        "periodo": 202509,
        "valor": 407540800.0,
        "delta": -46685375.0
      },
      {
        "periodo": 202510,
        "valor": 365031881.0,
        "delta": -42508919.0
      },
      {
        "periodo": 202511,
        "valor": 341871026.0,
        "delta": -23160855.0
      },
      {
        "periodo": 202512,
        "valor": 300777538.0,
        "delta": -41093488.0
      },
      {
        "periodo": 202601,
        "valor": 304512976.0,
        "delta": 3735438.0
      },
      {
        "periodo": 202602,
        "valor": 262042526.0,
        "delta": -42470450.0
      },
      {
        "periodo": 202603,
        "valor": 288586547.0,
        "delta": 26544021.0
      },
      {
        "periodo": 202604,
        "valor": 276994034.0,
        "delta": -11592513.0
      },
      {
        "periodo": 202605,
        "valor": 700087115.0,
        "delta": 423093081.0
      },
      {
        "periodo": 202606,
        "valor": 368671682.0,
        "delta": -331415433.0
      },
      {
        "periodo": 202607,
        "valor": 371718839.0,
        "delta": 3047157.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 933299634.0199995,
    "valor_anterior": 828636151.9700003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1192225751.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1195070659.72,
        "delta": 2844908.46
      },
      {
        "periodo": 202509,
        "valor": 1161620302.35,
        "delta": -33450357.37
      },
      {
        "periodo": 202510,
        "valor": 1139068469.79,
        "delta": -22551832.56
      },
      {
        "periodo": 202511,
        "valor": 981688814.63,
        "delta": -157379655.16
      },
      {
        "periodo": 202512,
        "valor": 964500524.0,
        "delta": -17188290.63
      },
      {
        "periodo": 202601,
        "valor": 941029590.71,
        "delta": -23470933.29
      },
      {
        "periodo": 202602,
        "valor": 836325988.95,
        "delta": -104703601.76
      },
      {
        "periodo": 202603,
        "valor": 914914095.68,
        "delta": 78588106.73
      },
      {
        "periodo": 202604,
        "valor": 824294425.15,
        "delta": -90619670.53
      },
      {
        "periodo": 202605,
        "valor": 846876860.6,
        "delta": 22582435.45
      },
      {
        "periodo": 202606,
        "valor": 828636151.97,
        "delta": -18240708.63
      },
      {
        "periodo": 202607,
        "valor": 933299634.02,
        "delta": 104663482.05
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 645940967.0,
    "valor_anterior": 635392217.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 591272289.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 559660462.0,
        "delta": -31611827.0
      },
      {
        "periodo": 202509,
        "valor": 554972113.0,
        "delta": -4688349.0
      },
      {
        "periodo": 202510,
        "valor": 568340439.0,
        "delta": 13368326.0
      },
      {
        "periodo": 202511,
        "valor": 535798962.0,
        "delta": -32541477.0
      },
      {
        "periodo": 202512,
        "valor": 582449413.0,
        "delta": 46650451.0
      },
      {
        "periodo": 202601,
        "valor": 646427121.0,
        "delta": 63977708.0
      },
      {
        "periodo": 202602,
        "valor": 621225801.0,
        "delta": -25201320.0
      },
      {
        "periodo": 202603,
        "valor": 662508240.0,
        "delta": 41282439.0
      },
      {
        "periodo": 202604,
        "valor": 652978915.0,
        "delta": -9529325.0
      },
      {
        "periodo": 202605,
        "valor": 660180889.0,
        "delta": 7201974.0
      },
      {
        "periodo": 202606,
        "valor": 635392217.0,
        "delta": -24788672.0
      },
      {
        "periodo": 202607,
        "valor": 645940967.0,
        "delta": 10548750.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 1579470462.2100048,
    "valor_anterior": 1590616828.4599972,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1866328126.95,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1820229331.64,
        "delta": -46098795.31
      },
      {
        "periodo": 202509,
        "valor": 1962840884.61,
        "delta": 142611552.97
      },
      {
        "periodo": 202510,
        "valor": 1127006954.85,
        "delta": -835833929.76
      },
      {
        "periodo": 202511,
        "valor": 2148011147.12,
        "delta": 1021004192.27
      },
      {
        "periodo": 202512,
        "valor": 2771487476.39,
        "delta": 623476329.27
      },
      {
        "periodo": 202601,
        "valor": 2074975549.07,
        "delta": -696511927.32
      },
      {
        "periodo": 202602,
        "valor": 1519005555.73,
        "delta": -555969993.34
      },
      {
        "periodo": 202603,
        "valor": 1380596212.64,
        "delta": -138409343.09
      },
      {
        "periodo": 202604,
        "valor": 1699233044.59,
        "delta": 318636831.95
      },
      {
        "periodo": 202605,
        "valor": 1628110654.48,
        "delta": -71122390.11
      },
      {
        "periodo": 202606,
        "valor": 1590616828.46,
        "delta": -37493826.02
      },
      {
        "periodo": 202607,
        "valor": 1579470462.21,
        "delta": -11146366.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": -497424.0,
        "delta": -497424.0
      },
      {
        "periodo": 202512,
        "valor": 434137.0,
        "delta": 931561.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -434137.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 830029945.2700005,
    "valor_anterior": 804103440.6400003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1035678644.05,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1025677470.35,
        "delta": -10001173.7
      },
      {
        "periodo": 202509,
        "valor": 997220544.0,
        "delta": -28456926.35
      },
      {
        "periodo": 202510,
        "valor": 955275902.27,
        "delta": -41944641.73
      },
      {
        "periodo": 202511,
        "valor": 981295439.66,
        "delta": 26019537.39
      },
      {
        "periodo": 202512,
        "valor": 1008639930.73,
        "delta": 27344491.07
      },
      {
        "periodo": 202601,
        "valor": 998776621.16,
        "delta": -9863309.57
      },
      {
        "periodo": 202602,
        "valor": 857918151.15,
        "delta": -140858470.01
      },
      {
        "periodo": 202603,
        "valor": 873696240.26,
        "delta": 15778089.11
      },
      {
        "periodo": 202604,
        "valor": 878924800.93,
        "delta": 5228560.67
      },
      {
        "periodo": 202605,
        "valor": 855669106.61,
        "delta": -23255694.32
      },
      {
        "periodo": 202606,
        "valor": 804103440.64,
        "delta": -51565665.97
      },
      {
        "periodo": 202607,
        "valor": 830029945.27,
        "delta": 25926504.63
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 386000955.0,
    "valor_anterior": 268984165.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 142063035.08,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 165378228.91,
        "delta": 23315193.83
      },
      {
        "periodo": 202509,
        "valor": 219440614.86,
        "delta": 54062385.95
      },
      {
        "periodo": 202510,
        "valor": 259357764.0,
        "delta": 39917149.14
      },
      {
        "periodo": 202511,
        "valor": 254659020.0,
        "delta": -4698744.0
      },
      {
        "periodo": 202512,
        "valor": 271649394.0,
        "delta": 16990374.0
      },
      {
        "periodo": 202601,
        "valor": 316896540.0,
        "delta": 45247146.0
      },
      {
        "periodo": 202602,
        "valor": 247916153.0,
        "delta": -68980387.0
      },
      {
        "periodo": 202603,
        "valor": 302060122.0,
        "delta": 54143969.0
      },
      {
        "periodo": 202604,
        "valor": 289808913.0,
        "delta": -12251209.0
      },
      {
        "periodo": 202605,
        "valor": 268629700.0,
        "delta": -21179213.0
      },
      {
        "periodo": 202606,
        "valor": 268984165.0,
        "delta": 354465.0
      },
      {
        "periodo": 202607,
        "valor": 386000955.0,
        "delta": 117016790.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 328878697.0,
    "valor_anterior": 269615631.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 549910145.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 642104325.0,
        "delta": 92194180.0
      },
      {
        "periodo": 202509,
        "valor": 637312413.0,
        "delta": -4791912.0
      },
      {
        "periodo": 202510,
        "valor": 619084470.0,
        "delta": -18227943.0
      },
      {
        "periodo": 202511,
        "valor": 418648369.0,
        "delta": -200436101.0
      },
      {
        "periodo": 202512,
        "valor": 320138833.0,
        "delta": -98509536.0
      },
      {
        "periodo": 202601,
        "valor": 282014908.0,
        "delta": -38123925.0
      },
      {
        "periodo": 202602,
        "valor": 203448513.0,
        "delta": -78566395.0
      },
      {
        "periodo": 202603,
        "valor": 236522920.0,
        "delta": 33074407.0
      },
      {
        "periodo": 202604,
        "valor": 219687774.0,
        "delta": -16835146.0
      },
      {
        "periodo": 202605,
        "valor": 281332271.0,
        "delta": 61644497.0
      },
      {
        "periodo": 202606,
        "valor": 269615631.0,
        "delta": -11716640.0
      },
      {
        "periodo": 202607,
        "valor": 328878697.0,
        "delta": 59263066.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 422918234.0,
    "valor_anterior": 420743435.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 531595388.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 536355337.0,
        "delta": 4759949.0
      },
      {
        "periodo": 202509,
        "valor": 511361231.0,
        "delta": -24994106.0
      },
      {
        "periodo": 202510,
        "valor": 532755545.0,
        "delta": 21394314.0
      },
      {
        "periodo": 202511,
        "valor": 491633532.0,
        "delta": -41122013.0
      },
      {
        "periodo": 202512,
        "valor": 494747173.0,
        "delta": 3113641.0
      },
      {
        "periodo": 202601,
        "valor": 466466714.0,
        "delta": -28280459.0
      },
      {
        "periodo": 202602,
        "valor": 433847498.0,
        "delta": -32619216.0
      },
      {
        "periodo": 202603,
        "valor": 504324606.0,
        "delta": 70477108.0
      },
      {
        "periodo": 202604,
        "valor": 463575279.0,
        "delta": -40749327.0
      },
      {
        "periodo": 202605,
        "valor": 448656936.0,
        "delta": -14918343.0
      },
      {
        "periodo": 202606,
        "valor": 420743435.0,
        "delta": -27913501.0
      },
      {
        "periodo": 202607,
        "valor": 422918234.0,
        "delta": 2174799.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 868512857.000001,
    "valor_anterior": 816598825.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1000804721.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 967922968.0,
        "delta": -32881753.0
      },
      {
        "periodo": 202509,
        "valor": 951186699.0,
        "delta": -16736269.0
      },
      {
        "periodo": 202510,
        "valor": 974754022.0,
        "delta": 23567323.0
      },
      {
        "periodo": 202511,
        "valor": 868310195.0,
        "delta": -106443827.0
      },
      {
        "periodo": 202512,
        "valor": 850953165.0,
        "delta": -17357030.0
      },
      {
        "periodo": 202601,
        "valor": 866680345.0,
        "delta": 15727180.0
      },
      {
        "periodo": 202602,
        "valor": 808986700.0,
        "delta": -57693645.0
      },
      {
        "periodo": 202603,
        "valor": 909323788.0,
        "delta": 100337088.0
      },
      {
        "periodo": 202604,
        "valor": 884325095.0,
        "delta": -24998693.0
      },
      {
        "periodo": 202605,
        "valor": 876249529.0,
        "delta": -8075566.0
      },
      {
        "periodo": 202606,
        "valor": 816598825.0,
        "delta": -59650704.0
      },
      {
        "periodo": 202607,
        "valor": 868512857.0,
        "delta": 51914032.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 293131866.0,
    "valor_anterior": 284364161.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 369949953.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 387051528.0,
        "delta": 17101575.0
      },
      {
        "periodo": 202509,
        "valor": 348536001.0,
        "delta": -38515527.0
      },
      {
        "periodo": 202510,
        "valor": 338594181.0,
        "delta": -9941820.0
      },
      {
        "periodo": 202511,
        "valor": 359997511.0,
        "delta": 21403330.0
      },
      {
        "periodo": 202512,
        "valor": 303100048.0,
        "delta": -56897463.0
      },
      {
        "periodo": 202601,
        "valor": 314592815.0,
        "delta": 11492767.0
      },
      {
        "periodo": 202602,
        "valor": 270487356.0,
        "delta": -44105459.0
      },
      {
        "periodo": 202603,
        "valor": 386666049.0,
        "delta": 116178693.0
      },
      {
        "periodo": 202604,
        "valor": 276430120.0,
        "delta": -110235929.0
      },
      {
        "periodo": 202605,
        "valor": 288701976.0,
        "delta": 12271856.0
      },
      {
        "periodo": 202606,
        "valor": 284364161.0,
        "delta": -4337815.0
      },
      {
        "periodo": 202607,
        "valor": 293131866.0,
        "delta": 8767705.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 74.0,
    "valor_anterior": 5940.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 310482100.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 131243430.0,
        "delta": -179238670.0
      },
      {
        "periodo": 202509,
        "valor": 2170.0,
        "delta": -131241260.0
      },
      {
        "periodo": 202510,
        "valor": 1238.0,
        "delta": -932.0
      },
      {
        "periodo": 202511,
        "valor": -442.0,
        "delta": -1680.0
      },
      {
        "periodo": 202512,
        "valor": 111454.0,
        "delta": 111896.0
      },
      {
        "periodo": 202601,
        "valor": 37603.0,
        "delta": -73851.0
      },
      {
        "periodo": 202602,
        "valor": 22162.0,
        "delta": -15441.0
      },
      {
        "periodo": 202603,
        "valor": 72.0,
        "delta": -22090.0
      },
      {
        "periodo": 202604,
        "valor": 6798.0,
        "delta": 6726.0
      },
      {
        "periodo": 202605,
        "valor": 12616.0,
        "delta": 5818.0
      },
      {
        "periodo": 202606,
        "valor": 5940.0,
        "delta": -6676.0
      },
      {
        "periodo": 202607,
        "valor": 74.0,
        "delta": -5866.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 204516937.6500001,
    "valor_anterior": 178647740.98000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 198815471.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 216132208.48,
        "delta": 17316736.79
      },
      {
        "periodo": 202509,
        "valor": 214204382.04,
        "delta": -1927826.44
      },
      {
        "periodo": 202510,
        "valor": 206064284.77,
        "delta": -8140097.27
      },
      {
        "periodo": 202511,
        "valor": 194600773.05,
        "delta": -11463511.72
      },
      {
        "periodo": 202512,
        "valor": 314992574.75,
        "delta": 120391801.7
      },
      {
        "periodo": 202601,
        "valor": 287453552.15,
        "delta": -27539022.6
      },
      {
        "periodo": 202602,
        "valor": 218890464.17,
        "delta": -68563087.98
      },
      {
        "periodo": 202603,
        "valor": 198583076.29,
        "delta": -20307387.88
      },
      {
        "periodo": 202604,
        "valor": 194545994.96,
        "delta": -4037081.33
      },
      {
        "periodo": 202605,
        "valor": 184261360.03,
        "delta": -10284634.93
      },
      {
        "periodo": 202606,
        "valor": 178647740.98,
        "delta": -5613619.05
      },
      {
        "periodo": 202607,
        "valor": 204516937.65,
        "delta": 25869196.67
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 31737272.0,
    "valor_anterior": 30251697.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 62203045.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 49833962.0,
        "delta": -12369083.0
      },
      {
        "periodo": 202509,
        "valor": 62418598.0,
        "delta": 12584636.0
      },
      {
        "periodo": 202510,
        "valor": 55191050.0,
        "delta": -7227548.0
      },
      {
        "periodo": 202511,
        "valor": 53937206.0,
        "delta": -1253844.0
      },
      {
        "periodo": 202512,
        "valor": 56917536.0,
        "delta": 2980330.0
      },
      {
        "periodo": 202601,
        "valor": 54892708.0,
        "delta": -2024828.0
      },
      {
        "periodo": 202602,
        "valor": 56956885.0,
        "delta": 2064177.0
      },
      {
        "periodo": 202603,
        "valor": 60437601.0,
        "delta": 3480716.0
      },
      {
        "periodo": 202604,
        "valor": 37468863.0,
        "delta": -22968738.0
      },
      {
        "periodo": 202605,
        "valor": 31912349.0,
        "delta": -5556514.0
      },
      {
        "periodo": 202606,
        "valor": 30251697.0,
        "delta": -1660652.0
      },
      {
        "periodo": 202607,
        "valor": 31737272.0,
        "delta": 1485575.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 399485572.0,
    "valor_anterior": 363998552.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 425056786.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 362301475.0,
        "delta": -62755311.0
      },
      {
        "periodo": 202509,
        "valor": 347492207.0,
        "delta": -14809268.0
      },
      {
        "periodo": 202510,
        "valor": 287419296.0,
        "delta": -60072911.0
      },
      {
        "periodo": 202511,
        "valor": 302706046.0,
        "delta": 15286750.0
      },
      {
        "periodo": 202512,
        "valor": 320606901.0,
        "delta": 17900855.0
      },
      {
        "periodo": 202601,
        "valor": 296735559.0,
        "delta": -23871342.0
      },
      {
        "periodo": 202602,
        "valor": 258262505.0,
        "delta": -38473054.0
      },
      {
        "periodo": 202603,
        "valor": 271559476.0,
        "delta": 13296971.0
      },
      {
        "periodo": 202604,
        "valor": 174244707.0,
        "delta": -97314769.0
      },
      {
        "periodo": 202605,
        "valor": 364114527.0,
        "delta": 189869820.0
      },
      {
        "periodo": 202606,
        "valor": 363998552.0,
        "delta": -115975.0
      },
      {
        "periodo": 202607,
        "valor": 399485572.0,
        "delta": 35487020.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 267111331.0,
    "valor_anterior": 262798282.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 292074552.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 279787461.0,
        "delta": -12287091.0
      },
      {
        "periodo": 202509,
        "valor": 267084410.0,
        "delta": -12703051.0
      },
      {
        "periodo": 202510,
        "valor": 274639873.0,
        "delta": 7555463.0
      },
      {
        "periodo": 202511,
        "valor": 258569764.0,
        "delta": -16070109.0
      },
      {
        "periodo": 202512,
        "valor": 268388785.0,
        "delta": 9819021.0
      },
      {
        "periodo": 202601,
        "valor": 270240532.0,
        "delta": 1851747.0
      },
      {
        "periodo": 202602,
        "valor": 307356431.0,
        "delta": 37115899.0
      },
      {
        "periodo": 202603,
        "valor": 207978244.0,
        "delta": -99378187.0
      },
      {
        "periodo": 202604,
        "valor": 264604172.0,
        "delta": 56625928.0
      },
      {
        "periodo": 202605,
        "valor": 268963745.0,
        "delta": 4359573.0
      },
      {
        "periodo": 202606,
        "valor": 262798282.0,
        "delta": -6165463.0
      },
      {
        "periodo": 202607,
        "valor": 267111331.0,
        "delta": 4313049.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 47486969.0,
    "valor_anterior": 47349900.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 33133595.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 32676760.0,
        "delta": -456835.0
      },
      {
        "periodo": 202509,
        "valor": 38780112.0,
        "delta": 6103352.0
      },
      {
        "periodo": 202510,
        "valor": 42922195.0,
        "delta": 4142083.0
      },
      {
        "periodo": 202511,
        "valor": 42078691.0,
        "delta": -843504.0
      },
      {
        "periodo": 202512,
        "valor": 142033359.0,
        "delta": 99954668.0
      },
      {
        "periodo": 202601,
        "valor": 47894128.0,
        "delta": -94139231.0
      },
      {
        "periodo": 202602,
        "valor": 45151669.0,
        "delta": -2742459.0
      },
      {
        "periodo": 202603,
        "valor": 48685656.0,
        "delta": 3533987.0
      },
      {
        "periodo": 202604,
        "valor": 35582055.0,
        "delta": -13103601.0
      },
      {
        "periodo": 202605,
        "valor": 47495875.0,
        "delta": 11913820.0
      },
      {
        "periodo": 202606,
        "valor": 47349900.0,
        "delta": -145975.0
      },
      {
        "periodo": 202607,
        "valor": 47486969.0,
        "delta": 137069.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 508685888.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 444321277.0,
        "delta": -64364611.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 1029540048.0,
    "valor_anterior": 930914357.9999981,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 902706884.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 884743634.0,
        "delta": -17963250.0
      },
      {
        "periodo": 202509,
        "valor": 920796609.0,
        "delta": 36052975.0
      },
      {
        "periodo": 202510,
        "valor": 957446667.0,
        "delta": 36650058.0
      },
      {
        "periodo": 202511,
        "valor": 943153397.0,
        "delta": -14293270.0
      },
      {
        "periodo": 202512,
        "valor": 1015551818.0,
        "delta": 72398421.0
      },
      {
        "periodo": 202601,
        "valor": 1031057504.0,
        "delta": 15505686.0
      },
      {
        "periodo": 202602,
        "valor": 925149727.0,
        "delta": -105907777.0
      },
      {
        "periodo": 202603,
        "valor": 956006750.0,
        "delta": 30857023.0
      },
      {
        "periodo": 202604,
        "valor": 957141375.0,
        "delta": 1134625.0
      },
      {
        "periodo": 202605,
        "valor": 923874523.0,
        "delta": -33266852.0
      },
      {
        "periodo": 202606,
        "valor": 930914358.0,
        "delta": 7039835.0
      },
      {
        "periodo": 202607,
        "valor": 1029540048.0,
        "delta": 98625690.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 114836850.0,
    "valor_anterior": 109791370.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 87835071.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 90355088.0,
        "delta": 2520017.0
      },
      {
        "periodo": 202509,
        "valor": 88651624.0,
        "delta": -1703464.0
      },
      {
        "periodo": 202510,
        "valor": 96160731.0,
        "delta": 7509107.0
      },
      {
        "periodo": 202511,
        "valor": 90215551.0,
        "delta": -5945180.0
      },
      {
        "periodo": 202512,
        "valor": 97089771.0,
        "delta": 6874220.0
      },
      {
        "periodo": 202601,
        "valor": 106968378.0,
        "delta": 9878607.0
      },
      {
        "periodo": 202602,
        "valor": 97557626.0,
        "delta": -9410752.0
      },
      {
        "periodo": 202603,
        "valor": 113052330.0,
        "delta": 15494704.0
      },
      {
        "periodo": 202604,
        "valor": 108917613.0,
        "delta": -4134717.0
      },
      {
        "periodo": 202605,
        "valor": 112659404.0,
        "delta": 3741791.0
      },
      {
        "periodo": 202606,
        "valor": 109791370.0,
        "delta": -2868034.0
      },
      {
        "periodo": 202607,
        "valor": 114836850.0,
        "delta": 5045480.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 3474828.0,
    "valor_anterior": 3471295.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2325726.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2233679.0,
        "delta": -92047.0
      },
      {
        "periodo": 202509,
        "valor": 2381154.0,
        "delta": 147475.0
      },
      {
        "periodo": 202510,
        "valor": 2482855.0,
        "delta": 101701.0
      },
      {
        "periodo": 202511,
        "valor": 2511175.0,
        "delta": 28320.0
      },
      {
        "periodo": 202512,
        "valor": 2690160.0,
        "delta": 178985.0
      },
      {
        "periodo": 202601,
        "valor": 2857016.0,
        "delta": 166856.0
      },
      {
        "periodo": 202602,
        "valor": 2715689.0,
        "delta": -141327.0
      },
      {
        "periodo": 202603,
        "valor": 3113603.0,
        "delta": 397914.0
      },
      {
        "periodo": 202604,
        "valor": 3028814.0,
        "delta": -84789.0
      },
      {
        "periodo": 202605,
        "valor": 3259620.0,
        "delta": 230806.0
      },
      {
        "periodo": 202606,
        "valor": 3471295.0,
        "delta": 211675.0
      },
      {
        "periodo": 202607,
        "valor": 3474828.0,
        "delta": 3533.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 101604430.45999992,
    "valor_anterior": 97656919.22000003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 120139773.68,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 115507015.68,
        "delta": -4632758.0
      },
      {
        "periodo": 202509,
        "valor": 110029402.09,
        "delta": -5477613.59
      },
      {
        "periodo": 202510,
        "valor": 113168795.39,
        "delta": 3139393.3
      },
      {
        "periodo": 202511,
        "valor": 108936489.27,
        "delta": -4232306.12
      },
      {
        "periodo": 202512,
        "valor": 110205938.14,
        "delta": 1269448.87
      },
      {
        "periodo": 202601,
        "valor": 109043491.68,
        "delta": -1162446.46
      },
      {
        "periodo": 202602,
        "valor": 95288935.89,
        "delta": -13754555.79
      },
      {
        "periodo": 202603,
        "valor": 104925988.36,
        "delta": 9637052.47
      },
      {
        "periodo": 202604,
        "valor": 104306447.27,
        "delta": -619541.09
      },
      {
        "periodo": 202605,
        "valor": 103976802.52,
        "delta": -329644.75
      },
      {
        "periodo": 202606,
        "valor": 97656919.22,
        "delta": -6319883.3
      },
      {
        "periodo": 202607,
        "valor": 101604430.46,
        "delta": 3947511.24
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 12917276.0,
    "valor_anterior": 12992679.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12299258.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11407233.0,
        "delta": -892025.0
      },
      {
        "periodo": 202509,
        "valor": 11526231.0,
        "delta": 118998.0
      },
      {
        "periodo": 202510,
        "valor": 11629678.0,
        "delta": 103447.0
      },
      {
        "periodo": 202511,
        "valor": 12256744.0,
        "delta": 627066.0
      },
      {
        "periodo": 202512,
        "valor": 13760172.0,
        "delta": 1503428.0
      },
      {
        "periodo": 202601,
        "valor": 11495485.0,
        "delta": -2264687.0
      },
      {
        "periodo": 202602,
        "valor": 9390134.0,
        "delta": -2105351.0
      },
      {
        "periodo": 202603,
        "valor": 12242817.0,
        "delta": 2852683.0
      },
      {
        "periodo": 202604,
        "valor": 14264953.0,
        "delta": 2022136.0
      },
      {
        "periodo": 202605,
        "valor": 13257309.0,
        "delta": -1007644.0
      },
      {
        "periodo": 202606,
        "valor": 12992679.0,
        "delta": -264630.0
      },
      {
        "periodo": 202607,
        "valor": 12917276.0,
        "delta": -75403.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 295760735.1200001,
    "valor_anterior": 294214704.02,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 336051429.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 319798727.35,
        "delta": -16252701.92
      },
      {
        "periodo": 202509,
        "valor": 306483718.99,
        "delta": -13315008.36
      },
      {
        "periodo": 202510,
        "valor": 319532617.14,
        "delta": 13048898.15
      },
      {
        "periodo": 202511,
        "valor": 307359029.28,
        "delta": -12173587.86
      },
      {
        "periodo": 202512,
        "valor": 342226159.52,
        "delta": 34867130.24
      },
      {
        "periodo": 202601,
        "valor": 308766461.77,
        "delta": -33459697.75
      },
      {
        "periodo": 202602,
        "valor": 277724352.31,
        "delta": -31042109.46
      },
      {
        "periodo": 202603,
        "valor": 313414550.35,
        "delta": 35690198.04
      },
      {
        "periodo": 202604,
        "valor": 296721296.44,
        "delta": -16693253.91
      },
      {
        "periodo": 202605,
        "valor": 306197277.64,
        "delta": 9475981.2
      },
      {
        "periodo": 202606,
        "valor": 294214704.02,
        "delta": -11982573.62
      },
      {
        "periodo": 202607,
        "valor": 295760735.12,
        "delta": 1546031.1
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 72586716.38999999,
    "valor_anterior": 71268394.87,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 71949231.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 72441278.77,
        "delta": 492047.12
      },
      {
        "periodo": 202509,
        "valor": 68574399.11,
        "delta": -3866879.66
      },
      {
        "periodo": 202510,
        "valor": 69171931.86,
        "delta": 597532.75
      },
      {
        "periodo": 202511,
        "valor": 68266033.28,
        "delta": -905898.58
      },
      {
        "periodo": 202512,
        "valor": 73979763.72,
        "delta": 5713730.44
      },
      {
        "periodo": 202601,
        "valor": 70601321.32,
        "delta": -3378442.4
      },
      {
        "periodo": 202602,
        "valor": 63468657.01,
        "delta": -7132664.31
      },
      {
        "periodo": 202603,
        "valor": 68916794.79,
        "delta": 5448137.78
      },
      {
        "periodo": 202604,
        "valor": 68219800.42,
        "delta": -696994.37
      },
      {
        "periodo": 202605,
        "valor": 72053403.5,
        "delta": 3833603.08
      },
      {
        "periodo": 202606,
        "valor": 71268394.87,
        "delta": -785008.63
      },
      {
        "periodo": 202607,
        "valor": 72586716.39,
        "delta": 1318321.52
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 13761089.0,
    "valor_anterior": 12366205.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19853807.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 22501802.0,
        "delta": 2647995.0
      },
      {
        "periodo": 202509,
        "valor": 22039930.0,
        "delta": -461872.0
      },
      {
        "periodo": 202510,
        "valor": 24030348.0,
        "delta": 1990418.0
      },
      {
        "periodo": 202511,
        "valor": 22248524.0,
        "delta": -1781824.0
      },
      {
        "periodo": 202512,
        "valor": 17892555.0,
        "delta": -4355969.0
      },
      {
        "periodo": 202601,
        "valor": 20946084.0,
        "delta": 3053529.0
      },
      {
        "periodo": 202602,
        "valor": 15933950.0,
        "delta": -5012134.0
      },
      {
        "periodo": 202603,
        "valor": 17764823.0,
        "delta": 1830873.0
      },
      {
        "periodo": 202604,
        "valor": 13349332.0,
        "delta": -4415491.0
      },
      {
        "periodo": 202605,
        "valor": 14562671.0,
        "delta": 1213339.0
      },
      {
        "periodo": 202606,
        "valor": 12366205.0,
        "delta": -2196466.0
      },
      {
        "periodo": 202607,
        "valor": 13761089.0,
        "delta": 1394884.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 625883097.0,
    "valor_anterior": 536435365.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 767003364.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 867693093.0,
        "delta": 100689729.0
      },
      {
        "periodo": 202509,
        "valor": 964531669.0,
        "delta": 96838576.0
      },
      {
        "periodo": 202510,
        "valor": 768565851.0,
        "delta": -195965818.0
      },
      {
        "periodo": 202511,
        "valor": 772753552.0,
        "delta": 4187701.0
      },
      {
        "periodo": 202512,
        "valor": 631348105.0,
        "delta": -141405447.0
      },
      {
        "periodo": 202601,
        "valor": 715020995.0,
        "delta": 83672890.0
      },
      {
        "periodo": 202602,
        "valor": 671830571.0,
        "delta": -43190424.0
      },
      {
        "periodo": 202603,
        "valor": 647086804.0,
        "delta": -24743767.0
      },
      {
        "periodo": 202604,
        "valor": 639434396.0,
        "delta": -7652408.0
      },
      {
        "periodo": 202605,
        "valor": 730034270.0,
        "delta": 90599874.0
      },
      {
        "periodo": 202606,
        "valor": 536435365.0,
        "delta": -193598905.0
      },
      {
        "periodo": 202607,
        "valor": 625883097.0,
        "delta": 89447732.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 18880522.0,
    "valor_anterior": 13294903.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16505341.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21821795.0,
        "delta": 5316454.0
      },
      {
        "periodo": 202509,
        "valor": 23407367.0,
        "delta": 1585572.0
      },
      {
        "periodo": 202510,
        "valor": 17571261.0,
        "delta": -5836106.0
      },
      {
        "periodo": 202511,
        "valor": 23067572.0,
        "delta": 5496311.0
      },
      {
        "periodo": 202512,
        "valor": 21732057.0,
        "delta": -1335515.0
      },
      {
        "periodo": 202601,
        "valor": 31557242.0,
        "delta": 9825185.0
      },
      {
        "periodo": 202602,
        "valor": 18818443.0,
        "delta": -12738799.0
      },
      {
        "periodo": 202603,
        "valor": 15758793.0,
        "delta": -3059650.0
      },
      {
        "periodo": 202604,
        "valor": 20852121.0,
        "delta": 5093328.0
      },
      {
        "periodo": 202605,
        "valor": 16647964.0,
        "delta": -4204157.0
      },
      {
        "periodo": 202606,
        "valor": 13294903.0,
        "delta": -3353061.0
      },
      {
        "periodo": 202607,
        "valor": 18880522.0,
        "delta": 5585619.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 29804728.930000007,
    "valor_anterior": 30625350.829999983,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 51568801.05,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55653666.65,
        "delta": 4084865.6
      },
      {
        "periodo": 202509,
        "valor": 56946692.79,
        "delta": 1293026.14
      },
      {
        "periodo": 202510,
        "valor": 53894367.45,
        "delta": -3052325.34
      },
      {
        "periodo": 202511,
        "valor": 45372901.56,
        "delta": -8521465.89
      },
      {
        "periodo": 202512,
        "valor": 34383563.65,
        "delta": -10989337.91
      },
      {
        "periodo": 202601,
        "valor": 40070484.36,
        "delta": 5686920.71
      },
      {
        "periodo": 202602,
        "valor": 40664521.9,
        "delta": 594037.54
      },
      {
        "periodo": 202603,
        "valor": 47904247.41,
        "delta": 7239725.51
      },
      {
        "periodo": 202604,
        "valor": 37033750.38,
        "delta": -10870497.03
      },
      {
        "periodo": 202605,
        "valor": 33516263.29,
        "delta": -3517487.09
      },
      {
        "periodo": 202606,
        "valor": 30625350.83,
        "delta": -2890912.46
      },
      {
        "periodo": 202607,
        "valor": 29804728.93,
        "delta": -820621.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 18496510.400000006,
    "valor_anterior": 16265626.36,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30183142.88,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 54632490.26,
        "delta": 24449347.38
      },
      {
        "periodo": 202509,
        "valor": -22989813.31,
        "delta": -77622303.57
      },
      {
        "periodo": 202510,
        "valor": 12524561.04,
        "delta": 35514374.35
      },
      {
        "periodo": 202511,
        "valor": 15921853.41,
        "delta": 3397292.37
      },
      {
        "periodo": 202512,
        "valor": 13957095.58,
        "delta": -1964757.83
      },
      {
        "periodo": 202601,
        "valor": 16664261.8,
        "delta": 2707166.22
      },
      {
        "periodo": 202602,
        "valor": 13927840.52,
        "delta": -2736421.28
      },
      {
        "periodo": 202603,
        "valor": 14625094.12,
        "delta": 697253.6
      },
      {
        "periodo": 202604,
        "valor": 17876275.67,
        "delta": 3251181.55
      },
      {
        "periodo": 202605,
        "valor": 19369950.67,
        "delta": 1493675.0
      },
      {
        "periodo": 202606,
        "valor": 16265626.36,
        "delta": -3104324.31
      },
      {
        "periodo": 202607,
        "valor": 18496510.4,
        "delta": 2230884.04
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 7374956.0,
    "valor_anterior": 8287412.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8041934.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10217129.0,
        "delta": 2175195.0
      },
      {
        "periodo": 202509,
        "valor": 11206899.0,
        "delta": 989770.0
      },
      {
        "periodo": 202510,
        "valor": 10341029.0,
        "delta": -865870.0
      },
      {
        "periodo": 202511,
        "valor": 11024123.0,
        "delta": 683094.0
      },
      {
        "periodo": 202512,
        "valor": 11669842.0,
        "delta": 645719.0
      },
      {
        "periodo": 202601,
        "valor": 11093629.0,
        "delta": -576213.0
      },
      {
        "periodo": 202602,
        "valor": 12318692.0,
        "delta": 1225063.0
      },
      {
        "periodo": 202603,
        "valor": 14366195.0,
        "delta": 2047503.0
      },
      {
        "periodo": 202604,
        "valor": 10247386.0,
        "delta": -4118809.0
      },
      {
        "periodo": 202605,
        "valor": 8320761.0,
        "delta": -1926625.0
      },
      {
        "periodo": 202606,
        "valor": 8287412.0,
        "delta": -33349.0
      },
      {
        "periodo": 202607,
        "valor": 7374956.0,
        "delta": -912456.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 13957397.0,
    "valor_anterior": 13449900.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15993621.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15824295.0,
        "delta": -169326.0
      },
      {
        "periodo": 202509,
        "valor": 13925206.0,
        "delta": -1899089.0
      },
      {
        "periodo": 202510,
        "valor": 14642601.0,
        "delta": 717395.0
      },
      {
        "periodo": 202511,
        "valor": 14715092.0,
        "delta": 72491.0
      },
      {
        "periodo": 202512,
        "valor": 13828273.0,
        "delta": -886819.0
      },
      {
        "periodo": 202601,
        "valor": 13747033.0,
        "delta": -81240.0
      },
      {
        "periodo": 202602,
        "valor": 11793379.0,
        "delta": -1953654.0
      },
      {
        "periodo": 202603,
        "valor": 14954238.0,
        "delta": 3160859.0
      },
      {
        "periodo": 202604,
        "valor": 12918639.0,
        "delta": -2035599.0
      },
      {
        "periodo": 202605,
        "valor": 14239863.0,
        "delta": 1321224.0
      },
      {
        "periodo": 202606,
        "valor": 13449900.0,
        "delta": -789963.0
      },
      {
        "periodo": 202607,
        "valor": 13957397.0,
        "delta": 507497.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 30728698.0,
    "valor_anterior": 21835206.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 60891037.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 36688412.0,
        "delta": -24202625.0
      },
      {
        "periodo": 202509,
        "valor": 42260921.0,
        "delta": 5572509.0
      },
      {
        "periodo": 202510,
        "valor": 50651335.0,
        "delta": 8390414.0
      },
      {
        "periodo": 202511,
        "valor": 47135173.0,
        "delta": -3516162.0
      },
      {
        "periodo": 202512,
        "valor": 44807731.0,
        "delta": -2327442.0
      },
      {
        "periodo": 202601,
        "valor": 38264569.0,
        "delta": -6543162.0
      },
      {
        "periodo": 202602,
        "valor": 37345524.0,
        "delta": -919045.0
      },
      {
        "periodo": 202603,
        "valor": 29551890.0,
        "delta": -7793634.0
      },
      {
        "periodo": 202604,
        "valor": 26449433.0,
        "delta": -3102457.0
      },
      {
        "periodo": 202605,
        "valor": 38251338.0,
        "delta": 11801905.0
      },
      {
        "periodo": 202606,
        "valor": 21835206.0,
        "delta": -16416132.0
      },
      {
        "periodo": 202607,
        "valor": 30728698.0,
        "delta": 8893492.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 36699.42000000004,
    "valor_anterior": 54591.59999999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 74988.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 85161.4,
        "delta": 10172.87
      },
      {
        "periodo": 202509,
        "valor": 77199.95,
        "delta": -7961.45
      },
      {
        "periodo": 202510,
        "valor": 70962.48,
        "delta": -6237.47
      },
      {
        "periodo": 202511,
        "valor": 64687.56,
        "delta": -6274.92
      },
      {
        "periodo": 202512,
        "valor": 65206.94,
        "delta": 519.38
      },
      {
        "periodo": 202601,
        "valor": 68385.15,
        "delta": 3178.21
      },
      {
        "periodo": 202602,
        "valor": 57413.12,
        "delta": -10972.03
      },
      {
        "periodo": 202603,
        "valor": 65517.13,
        "delta": 8104.01
      },
      {
        "periodo": 202604,
        "valor": 56481.34,
        "delta": -9035.79
      },
      {
        "periodo": 202605,
        "valor": 53162.82,
        "delta": -3318.52
      },
      {
        "periodo": 202606,
        "valor": 54591.6,
        "delta": 1428.78
      },
      {
        "periodo": 202607,
        "valor": 36699.42,
        "delta": -17892.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 85332086.32,
    "valor_anterior": 82178095.29000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 78293159.18,
        "delta": 78293159.18
      },
      {
        "periodo": 202603,
        "valor": 85225689.76,
        "delta": 6932530.58
      },
      {
        "periodo": 202604,
        "valor": 83065162.96,
        "delta": -2160526.8
      },
      {
        "periodo": 202605,
        "valor": 83790993.05,
        "delta": 725830.09
      },
      {
        "periodo": 202606,
        "valor": 82178095.29,
        "delta": -1612897.76
      },
      {
        "periodo": 202607,
        "valor": 85332086.32,
        "delta": 3153991.03
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 159729070.0,
    "valor_anterior": 150157201.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17936899.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 37473326.0,
        "delta": 19536427.0
      },
      {
        "periodo": 202509,
        "valor": 56318635.0,
        "delta": 18845309.0
      },
      {
        "periodo": 202510,
        "valor": 80948175.0,
        "delta": 24629540.0
      },
      {
        "periodo": 202511,
        "valor": 98972791.0,
        "delta": 18024616.0
      },
      {
        "periodo": 202512,
        "valor": 130125913.0,
        "delta": 31153122.0
      },
      {
        "periodo": 202601,
        "valor": 148108434.0,
        "delta": 17982521.0
      },
      {
        "periodo": 202602,
        "valor": 136184424.0,
        "delta": -11924010.0
      },
      {
        "periodo": 202603,
        "valor": 149381906.0,
        "delta": 13197482.0
      },
      {
        "periodo": 202604,
        "valor": 140314420.0,
        "delta": -9067486.0
      },
      {
        "periodo": 202605,
        "valor": 149641990.0,
        "delta": 9327570.0
      },
      {
        "periodo": 202606,
        "valor": 150157201.0,
        "delta": 515211.0
      },
      {
        "periodo": 202607,
        "valor": 159729070.0,
        "delta": 9571869.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 65706755.06999999,
    "valor_anterior": 66743033.75999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 7153208.37,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 197586.0,
        "delta": -6955622.37
      },
      {
        "periodo": 202601,
        "valor": 1500029.74,
        "delta": 1302443.74
      },
      {
        "periodo": 202602,
        "valor": 17801202.1,
        "delta": 16301172.36
      },
      {
        "periodo": 202603,
        "valor": 39416437.71,
        "delta": 21615235.61
      },
      {
        "periodo": 202604,
        "valor": 47019043.11,
        "delta": 7602605.4
      },
      {
        "periodo": 202605,
        "valor": 39978889.2,
        "delta": -7040153.91
      },
      {
        "periodo": 202606,
        "valor": 66743033.76,
        "delta": 26764144.56
      },
      {
        "periodo": 202607,
        "valor": 65706755.07,
        "delta": -1036278.69
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 284121299.0,
    "valor_anterior": 265172349.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 853580548.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 349168058.0,
        "delta": -504412490.0
      },
      {
        "periodo": 202605,
        "valor": 249226418.0,
        "delta": -99941640.0
      },
      {
        "periodo": 202606,
        "valor": 265172349.0,
        "delta": 15945931.0
      },
      {
        "periodo": 202607,
        "valor": 284121299.0,
        "delta": 18948950.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 63802879329.26001,
    "valor_anterior": 61674783958.01001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 72623693459.45,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 70525418695.3699,
        "delta": -2098274764.0801
      },
      {
        "periodo": 202509,
        "valor": 61820241706.25,
        "delta": -8705176989.1199
      },
      {
        "periodo": 202510,
        "valor": 68083434464.39,
        "delta": 6263192758.14
      },
      {
        "periodo": 202511,
        "valor": 65177933782.78,
        "delta": -2905500681.61
      },
      {
        "periodo": 202512,
        "valor": 65713542822.36,
        "delta": 535609039.58
      },
      {
        "periodo": 202601,
        "valor": 64669506887.1,
        "delta": -1044035935.26
      },
      {
        "periodo": 202602,
        "valor": 57396055786.99,
        "delta": -7273451100.11
      },
      {
        "periodo": 202603,
        "valor": 66972572261.87,
        "delta": 9576516474.88
      },
      {
        "periodo": 202604,
        "valor": 61003280084.19,
        "delta": -5969292177.68
      },
      {
        "periodo": 202605,
        "valor": 62671812363.4,
        "delta": 1668532279.21
      },
      {
        "periodo": 202606,
        "valor": 61674783958.01,
        "delta": -997028405.39
      },
      {
        "periodo": 202607,
        "valor": 63802879329.26,
        "delta": 2128095371.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 45971060366.47,
    "valor_anterior": 44978910954.82999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 51794751010.97,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 50435459318.78,
        "delta": -1359291692.1901
      },
      {
        "periodo": 202509,
        "valor": 47258786459.0601,
        "delta": -3176672859.7199
      },
      {
        "periodo": 202510,
        "valor": 49863659948.66,
        "delta": 2604873489.5999
      },
      {
        "periodo": 202511,
        "valor": 46371379107.69,
        "delta": -3492280840.97
      },
      {
        "periodo": 202512,
        "valor": 46232270228.05,
        "delta": -139108879.64
      },
      {
        "periodo": 202601,
        "valor": 45356121941.58,
        "delta": -876148286.47
      },
      {
        "periodo": 202602,
        "valor": 40645931897.76,
        "delta": -4710190043.82
      },
      {
        "periodo": 202603,
        "valor": 48233265607.84,
        "delta": 7587333710.08
      },
      {
        "periodo": 202604,
        "valor": 43590767084.5,
        "delta": -4642498523.34
      },
      {
        "periodo": 202605,
        "valor": 44781550103.14,
        "delta": 1190783018.64
      },
      {
        "periodo": 202606,
        "valor": 44978910954.83,
        "delta": 197360851.69
      },
      {
        "periodo": 202607,
        "valor": 45971060366.47,
        "delta": 992149411.64
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 1962839756.0200005,
    "valor_anterior": 1759556449.9699993,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2914100623.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2655379000.72,
        "delta": -258721622.54
      },
      {
        "periodo": 202509,
        "valor": -2695628508.65,
        "delta": -5351007509.37
      },
      {
        "periodo": 202510,
        "valor": 2096516374.79,
        "delta": 4792144883.44
      },
      {
        "periodo": 202511,
        "valor": 1924841769.63,
        "delta": -171674605.16
      },
      {
        "periodo": 202512,
        "valor": 1980163796.0,
        "delta": 55322026.37
      },
      {
        "periodo": 202601,
        "valor": 1972124697.71,
        "delta": -8039098.29
      },
      {
        "periodo": 202602,
        "valor": 1761497877.95,
        "delta": -210626819.76
      },
      {
        "periodo": 202603,
        "valor": 1870920917.68,
        "delta": 109423039.73
      },
      {
        "periodo": 202604,
        "valor": 1781442598.15,
        "delta": -89478319.53
      },
      {
        "periodo": 202605,
        "valor": 1770763999.6,
        "delta": -10678598.55
      },
      {
        "periodo": 202606,
        "valor": 1759556449.97,
        "delta": -11207549.63
      },
      {
        "periodo": 202607,
        "valor": 1962839756.02,
        "delta": 203283306.05
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 6384861023.209999,
    "valor_anterior": 5969501923.460003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8168832133.95,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7647937233.64,
        "delta": -520894900.31
      },
      {
        "periodo": 202509,
        "valor": 7630839465.61,
        "delta": -17097768.03
      },
      {
        "periodo": 202510,
        "valor": 6557345850.85,
        "delta": -1073493614.76
      },
      {
        "periodo": 202511,
        "valor": 7644726379.12,
        "delta": 1087380528.27
      },
      {
        "periodo": 202512,
        "valor": 7999796764.39,
        "delta": 355070385.27
      },
      {
        "periodo": 202601,
        "valor": 7758387303.07,
        "delta": -241409461.32
      },
      {
        "periodo": 202602,
        "valor": 6261652076.73,
        "delta": -1496735226.34
      },
      {
        "periodo": 202603,
        "valor": 6547895405.64,
        "delta": 286243328.91
      },
      {
        "periodo": 202604,
        "valor": 6122116372.59,
        "delta": -425779033.05
      },
      {
        "periodo": 202605,
        "valor": 6594933608.48,
        "delta": 472817235.89
      },
      {
        "periodo": 202606,
        "valor": 5969501923.46,
        "delta": -625431685.02
      },
      {
        "periodo": 202607,
        "valor": 6384861023.21,
        "delta": 415359099.75
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 5472472620.530003,
    "valor_anterior": 5196485775.18,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5967650803.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5955395985.38,
        "delta": -12254818.01
      },
      {
        "periodo": 202509,
        "valor": 5922589629.71,
        "delta": -32806355.67
      },
      {
        "periodo": 202510,
        "valor": 5776629873.69,
        "delta": -145959756.02
      },
      {
        "periodo": 202511,
        "valor": 5495828727.9,
        "delta": -280801145.79
      },
      {
        "periodo": 202512,
        "valor": 5478356649.89,
        "delta": -17472078.01
      },
      {
        "periodo": 202601,
        "valor": 5663609268.61,
        "delta": 185252618.72
      },
      {
        "periodo": 202602,
        "valor": 5161643931.2,
        "delta": -501965337.41
      },
      {
        "periodo": 202603,
        "valor": 5616279246.53,
        "delta": 454635315.33
      },
      {
        "periodo": 202604,
        "valor": 5499263730.47,
        "delta": -117015516.06
      },
      {
        "periodo": 202605,
        "valor": 5641539961.85,
        "delta": 142276231.38
      },
      {
        "periodo": 202606,
        "valor": 5196485775.18,
        "delta": -445054186.67
      },
      {
        "periodo": 202607,
        "valor": 5472472620.53,
        "delta": 275986845.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 1641181408.2999992,
    "valor_anterior": 1488909490.3000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1666723623.61,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1700825753.62,
        "delta": 34102130.01
      },
      {
        "periodo": 202509,
        "valor": 1616226992.53,
        "delta": -84598761.09
      },
      {
        "periodo": 202510,
        "valor": 1694122623.88,
        "delta": 77895631.35
      },
      {
        "periodo": 202511,
        "valor": 1664277736.8,
        "delta": -29844887.08
      },
      {
        "periodo": 202512,
        "valor": 1661074695.61,
        "delta": -3203041.19
      },
      {
        "periodo": 202601,
        "valor": 1695898263.93,
        "delta": 34823568.32
      },
      {
        "periodo": 202602,
        "valor": 1467113902.63,
        "delta": -228784361.3
      },
      {
        "periodo": 202603,
        "valor": 1740159560.03,
        "delta": 273045657.4
      },
      {
        "periodo": 202604,
        "valor": 1549806017.18,
        "delta": -190353542.85
      },
      {
        "periodo": 202605,
        "valor": 1552026594.62,
        "delta": 2220577.44
      },
      {
        "periodo": 202606,
        "valor": 1488909490.3,
        "delta": -63117104.32
      },
      {
        "periodo": 202607,
        "valor": 1641181408.3,
        "delta": 152271918.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100007,
    "label": "Gastos por Intereses",
    "valor_actual": 2370464154.7299995,
    "valor_anterior": 2281419364.2700005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2111635264.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2130421403.23,
        "delta": 18786138.96
      },
      {
        "periodo": 202509,
        "valor": 2087427667.99,
        "delta": -42993735.24
      },
      {
        "periodo": 202510,
        "valor": 2095159792.52,
        "delta": 7732124.53
      },
      {
        "periodo": 202511,
        "valor": 2076880061.64,
        "delta": -18279730.88
      },
      {
        "periodo": 202512,
        "valor": 2361880688.42,
        "delta": 285000626.78
      },
      {
        "periodo": 202601,
        "valor": 2223365412.2,
        "delta": -138515276.22
      },
      {
        "periodo": 202602,
        "valor": 2098216100.72,
        "delta": -125149311.48
      },
      {
        "periodo": 202603,
        "valor": 2964051524.15,
        "delta": 865835423.43
      },
      {
        "periodo": 202604,
        "valor": 2459884281.3,
        "delta": -504167242.85
      },
      {
        "periodo": 202605,
        "valor": 2330998095.71,
        "delta": -128886185.59
      },
      {
        "periodo": 202606,
        "valor": 2281419364.27,
        "delta": -49578731.44
      },
      {
        "periodo": 202607,
        "valor": 2370464154.73,
        "delta": 89044790.46
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 8197779318.809998,
    "valor_anterior": 7176214994.43,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7093588104.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7790133068.35,
        "delta": 696544963.45
      },
      {
        "periodo": 202509,
        "valor": 8380393686.85,
        "delta": 590260618.5
      },
      {
        "periodo": 202510,
        "valor": 6994757332.91,
        "delta": -1385636353.94
      },
      {
        "periodo": 202511,
        "valor": 8263056958.67,
        "delta": 1268299625.76
      },
      {
        "periodo": 202512,
        "valor": 8602893551.6,
        "delta": 339836592.93
      },
      {
        "periodo": 202601,
        "valor": 9332418156.38,
        "delta": 729524604.78
      },
      {
        "periodo": 202602,
        "valor": 7867299218.57,
        "delta": -1465118937.81
      },
      {
        "periodo": 202603,
        "valor": 5994017622.86,
        "delta": -1873281595.71
      },
      {
        "periodo": 202604,
        "valor": 8782091090.81,
        "delta": 2788073467.95
      },
      {
        "periodo": 202605,
        "valor": 8016284477.36,
        "delta": -765806613.45
      },
      {
        "periodo": 202606,
        "valor": 7176214994.43,
        "delta": -840069482.93
      },
      {
        "periodo": 202607,
        "valor": 8197779318.81,
        "delta": 1021564324.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 21980608569.47998,
    "valor_anterior": 21367926193.270004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19998585010.84,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19450987764.74,
        "delta": -547597246.1
      },
      {
        "periodo": 202509,
        "valor": 19569619514.79,
        "delta": 118631750.05
      },
      {
        "periodo": 202510,
        "valor": 20123671632.48,
        "delta": 554052117.69
      },
      {
        "periodo": 202511,
        "valor": 19892027340.96,
        "delta": -231644291.52
      },
      {
        "periodo": 202512,
        "valor": 20341592256.1,
        "delta": 449564915.14
      },
      {
        "periodo": 202601,
        "valor": 20856529825.78,
        "delta": 514937569.68
      },
      {
        "periodo": 202602,
        "valor": 19720988683.01,
        "delta": -1135541142.77
      },
      {
        "periodo": 202603,
        "valor": 21683990258.34,
        "delta": 1963001575.33
      },
      {
        "periodo": 202604,
        "valor": 21032065380.96,
        "delta": -651924877.38
      },
      {
        "periodo": 202605,
        "valor": 21756638527.27,
        "delta": 724573146.31
      },
      {
        "periodo": 202606,
        "valor": 21367926193.27,
        "delta": -388712334.0
      },
      {
        "periodo": 202607,
        "valor": 21980608569.48,
        "delta": 612682376.21
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 8195411356.0,
    "valor_anterior": 7669126982.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8158120726.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7926672573.0,
        "delta": -231448153.0
      },
      {
        "periodo": 202509,
        "valor": 7800541566.0,
        "delta": -126131007.0
      },
      {
        "periodo": 202510,
        "valor": 7677995100.0,
        "delta": -122546466.0
      },
      {
        "periodo": 202511,
        "valor": 7983474376.0,
        "delta": 305479276.0
      },
      {
        "periodo": 202512,
        "valor": 8715021987.0,
        "delta": 731547611.0
      },
      {
        "periodo": 202601,
        "valor": 8285027989.0,
        "delta": -429993998.0
      },
      {
        "periodo": 202602,
        "valor": 7663115683.0,
        "delta": -621912306.0
      },
      {
        "periodo": 202603,
        "valor": 8235616346.0,
        "delta": 572500663.0
      },
      {
        "periodo": 202604,
        "valor": 8442524426.0,
        "delta": 206908080.0
      },
      {
        "periodo": 202605,
        "valor": 8343641675.0,
        "delta": -98882751.0
      },
      {
        "periodo": 202606,
        "valor": 7669126982.0,
        "delta": -674514693.0
      },
      {
        "periodo": 202607,
        "valor": 8195411356.0,
        "delta": 526284374.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 3763371836.0,
    "valor_anterior": 3662136949.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4203826145.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4115434276.0,
        "delta": -88391869.0
      },
      {
        "periodo": 202509,
        "valor": 4049175881.0,
        "delta": -66258395.0
      },
      {
        "periodo": 202510,
        "valor": 4177554531.0,
        "delta": 128378650.0
      },
      {
        "periodo": 202511,
        "valor": 4051222531.0,
        "delta": -126332000.0
      },
      {
        "periodo": 202512,
        "valor": 3979178230.5,
        "delta": -72044300.5
      },
      {
        "periodo": 202601,
        "valor": 4081600467.0,
        "delta": 102422236.5
      },
      {
        "periodo": 202602,
        "valor": 3805909153.0,
        "delta": -275691314.0
      },
      {
        "periodo": 202603,
        "valor": 4031312770.0,
        "delta": 225403617.0
      },
      {
        "periodo": 202604,
        "valor": 3839885629.0,
        "delta": -191427141.0
      },
      {
        "periodo": 202605,
        "valor": 3926407734.0,
        "delta": 86522105.0
      },
      {
        "periodo": 202606,
        "valor": 3662136949.0,
        "delta": -264270785.0
      },
      {
        "periodo": 202607,
        "valor": 3763371836.0,
        "delta": 101234887.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 1770792911.0100002,
    "valor_anterior": 1721610024.9300003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1792945164.52,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1780122309.95,
        "delta": -12822854.57
      },
      {
        "periodo": 202509,
        "valor": 1709176973.55,
        "delta": -70945336.4
      },
      {
        "periodo": 202510,
        "valor": 1799439451.81,
        "delta": 90262478.26
      },
      {
        "periodo": 202511,
        "valor": 1713546862.54,
        "delta": -85892589.27
      },
      {
        "periodo": 202512,
        "valor": 1809502840.75,
        "delta": 95955978.21
      },
      {
        "periodo": 202601,
        "valor": 1738805344.63,
        "delta": -70697496.12
      },
      {
        "periodo": 202602,
        "valor": 1584273779.22,
        "delta": -154531565.41
      },
      {
        "periodo": 202603,
        "valor": 1812510520.54,
        "delta": 228236741.32
      },
      {
        "periodo": 202604,
        "valor": 1711616447.12,
        "delta": -100894073.42
      },
      {
        "periodo": 202605,
        "valor": 1785340804.42,
        "delta": 73724357.3
      },
      {
        "periodo": 202606,
        "valor": 1721610024.93,
        "delta": -63730779.49
      },
      {
        "periodo": 202607,
        "valor": 1770792911.01,
        "delta": 49182886.08
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 3206216883.0,
    "valor_anterior": 3052451278.000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3379440917.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3131858774.0,
        "delta": -247582143.0
      },
      {
        "periodo": 202509,
        "valor": 3219249742.0,
        "delta": 87390968.0
      },
      {
        "periodo": 202510,
        "valor": 3289366288.0,
        "delta": 70116546.0
      },
      {
        "periodo": 202511,
        "valor": 3074837192.0,
        "delta": -214529096.0
      },
      {
        "periodo": 202512,
        "valor": 3646740228.0,
        "delta": 571903036.0
      },
      {
        "periodo": 202601,
        "valor": 3076163406.0,
        "delta": -570576822.0
      },
      {
        "periodo": 202602,
        "valor": 2846134967.0,
        "delta": -230028439.0
      },
      {
        "periodo": 202603,
        "valor": 3497851468.0,
        "delta": 651716501.0
      },
      {
        "periodo": 202604,
        "valor": 3256906391.0,
        "delta": -240945077.0
      },
      {
        "periodo": 202605,
        "valor": 3358891282.0,
        "delta": 101984891.0
      },
      {
        "periodo": 202606,
        "valor": 3052451278.0,
        "delta": -306440004.0
      },
      {
        "periodo": 202607,
        "valor": 3206216883.0,
        "delta": 153765605.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 673496390.0,
    "valor_anterior": 598990692.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 291389326.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 295946912.0,
        "delta": 4557586.0
      },
      {
        "periodo": 202509,
        "valor": 285773382.0,
        "delta": -10173530.0
      },
      {
        "periodo": 202510,
        "valor": 598190984.0,
        "delta": 312417602.0
      },
      {
        "periodo": 202511,
        "valor": 632002064.0,
        "delta": 33811080.0
      },
      {
        "periodo": 202512,
        "valor": 1134675513.0,
        "delta": 502673449.0
      },
      {
        "periodo": 202601,
        "valor": 330858555.0,
        "delta": -803816958.0
      },
      {
        "periodo": 202602,
        "valor": 637901073.0,
        "delta": 307042518.0
      },
      {
        "periodo": 202603,
        "valor": 688235323.0,
        "delta": 50334250.0
      },
      {
        "periodo": 202604,
        "valor": 647588008.0,
        "delta": -40647315.0
      },
      {
        "periodo": 202605,
        "valor": 729201482.0,
        "delta": 81613474.0
      },
      {
        "periodo": 202606,
        "valor": 598990692.0,
        "delta": -130210790.0
      },
      {
        "periodo": 202607,
        "valor": 673496390.0,
        "delta": 74505698.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 3102425846.999998,
    "valor_anterior": 2774043805.000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2661397183.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2764910163.0,
        "delta": 103512980.0
      },
      {
        "periodo": 202509,
        "valor": 2700352952.0,
        "delta": -64557211.0
      },
      {
        "periodo": 202510,
        "valor": 2797178602.0,
        "delta": 96825650.0
      },
      {
        "periodo": 202511,
        "valor": 2591922369.0,
        "delta": -205256233.0
      },
      {
        "periodo": 202512,
        "valor": 2804117440.0,
        "delta": 212195071.0
      },
      {
        "periodo": 202601,
        "valor": 2822768646.0,
        "delta": 18651206.0
      },
      {
        "periodo": 202602,
        "valor": 2533953702.0,
        "delta": -288814944.0
      },
      {
        "periodo": 202603,
        "valor": 2780597866.0,
        "delta": 246644164.0
      },
      {
        "periodo": 202604,
        "valor": 2770085550.0,
        "delta": -10512316.0
      },
      {
        "periodo": 202605,
        "valor": 2820801045.0,
        "delta": 50715495.0
      },
      {
        "periodo": 202606,
        "valor": 2774043805.0,
        "delta": -46757240.0
      },
      {
        "periodo": 202607,
        "valor": 3102425847.0,
        "delta": 328382042.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 1261349796.79,
    "valor_anterior": 1209417107.8199997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1271740612.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1292922758.95,
        "delta": 21182146.68
      },
      {
        "periodo": 202509,
        "valor": 1281597173.13,
        "delta": -11325585.82
      },
      {
        "periodo": 202510,
        "valor": 1341024086.41,
        "delta": 59426913.28
      },
      {
        "periodo": 202511,
        "valor": 1270117574.07,
        "delta": -70906512.34
      },
      {
        "periodo": 202512,
        "valor": 1354479390.4,
        "delta": 84361816.33
      },
      {
        "periodo": 202601,
        "valor": 1288900705.39,
        "delta": -65578685.01
      },
      {
        "periodo": 202602,
        "valor": 1103040421.87,
        "delta": -185860283.52
      },
      {
        "periodo": 202603,
        "valor": 1210636917.03,
        "delta": 107596495.16
      },
      {
        "periodo": 202604,
        "valor": 1208178005.32,
        "delta": -2458911.71
      },
      {
        "periodo": 202605,
        "valor": 1232327636.1,
        "delta": 24149630.78
      },
      {
        "periodo": 202606,
        "valor": 1209417107.82,
        "delta": -22910528.28
      },
      {
        "periodo": 202607,
        "valor": 1261349796.79,
        "delta": 51932688.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 913040164.000001,
    "valor_anterior": 674824657.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 342914337.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1226996686.0,
        "delta": 884082349.0
      },
      {
        "periodo": 202509,
        "valor": 553567526.0,
        "delta": -673429160.0
      },
      {
        "periodo": 202510,
        "valor": 285023451.0,
        "delta": -268544075.0
      },
      {
        "periodo": 202511,
        "valor": 247798554.0,
        "delta": -37224897.0
      },
      {
        "periodo": 202512,
        "valor": 677350088.0,
        "delta": 429551534.0
      },
      {
        "periodo": 202601,
        "valor": 816791469.0,
        "delta": 139441381.0
      },
      {
        "periodo": 202602,
        "valor": 377191035.0,
        "delta": -439600434.0
      },
      {
        "periodo": 202603,
        "valor": 991604818.0,
        "delta": 614413783.0
      },
      {
        "periodo": 202604,
        "valor": 672137673.0,
        "delta": -319467145.0
      },
      {
        "periodo": 202605,
        "valor": 600350975.0,
        "delta": -71786698.0
      },
      {
        "periodo": 202606,
        "valor": 674824657.0,
        "delta": 74473682.0
      },
      {
        "periodo": 202607,
        "valor": 913040164.0,
        "delta": 238215507.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 225691867.0,
    "valor_anterior": 231619867.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 293210346.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 276819904.0,
        "delta": -16390442.0
      },
      {
        "periodo": 202509,
        "valor": 299962038.0,
        "delta": 23142134.0
      },
      {
        "periodo": 202510,
        "valor": 262831722.0,
        "delta": -37130316.0
      },
      {
        "periodo": 202511,
        "valor": 231263059.0,
        "delta": -31568663.0
      },
      {
        "periodo": 202512,
        "valor": 278167106.0,
        "delta": 46904047.0
      },
      {
        "periodo": 202601,
        "valor": 224836492.0,
        "delta": -53330614.0
      },
      {
        "periodo": 202602,
        "valor": 221533687.0,
        "delta": -3302805.0
      },
      {
        "periodo": 202603,
        "valor": 245353303.0,
        "delta": 23819616.0
      },
      {
        "periodo": 202604,
        "valor": 227059102.0,
        "delta": -18294201.0
      },
      {
        "periodo": 202605,
        "valor": 222514504.0,
        "delta": -4544598.0
      },
      {
        "periodo": 202606,
        "valor": 231619867.0,
        "delta": 9105363.0
      },
      {
        "periodo": 202607,
        "valor": 225691867.0,
        "delta": -5928000.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 601151071.0,
    "valor_anterior": 567364454.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 559314579.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 529095805.0,
        "delta": -30218774.0
      },
      {
        "periodo": 202509,
        "valor": 536912355.0,
        "delta": 7816550.0
      },
      {
        "periodo": 202510,
        "valor": 568291683.0,
        "delta": 31379328.0
      },
      {
        "periodo": 202511,
        "valor": 588975369.0,
        "delta": 20683686.0
      },
      {
        "periodo": 202512,
        "valor": 618979586.0,
        "delta": 30004217.0
      },
      {
        "periodo": 202601,
        "valor": 603947342.0,
        "delta": -15032244.0
      },
      {
        "periodo": 202602,
        "valor": 541021757.0,
        "delta": -62925585.0
      },
      {
        "periodo": 202603,
        "valor": 602114169.0,
        "delta": 61092412.0
      },
      {
        "periodo": 202604,
        "valor": 588890889.0,
        "delta": -13223280.0
      },
      {
        "periodo": 202605,
        "valor": 598360598.0,
        "delta": 9469709.0
      },
      {
        "periodo": 202606,
        "valor": 567364454.0,
        "delta": -30996144.0
      },
      {
        "periodo": 202607,
        "valor": 601151071.0,
        "delta": 33786617.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 10659849221.670013,
    "valor_anterior": 10478080133.529991,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10177142804.21,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9982928257.63,
        "delta": -194214546.58
      },
      {
        "periodo": 202509,
        "valor": 9798782042.71,
        "delta": -184146214.92
      },
      {
        "periodo": 202510,
        "valor": 10105983799.51,
        "delta": 307201756.8
      },
      {
        "periodo": 202511,
        "valor": 10209430594.07,
        "delta": 103446794.56
      },
      {
        "periodo": 202512,
        "valor": 10199244756.93,
        "delta": -10185837.14
      },
      {
        "periodo": 202601,
        "valor": 10366272674.23,
        "delta": 167027917.3
      },
      {
        "periodo": 202602,
        "valor": 9902310002.08,
        "delta": -463962672.15
      },
      {
        "periodo": 202603,
        "valor": 10477069963.56,
        "delta": 574759961.48
      },
      {
        "periodo": 202604,
        "valor": 11084098793.23,
        "delta": 607028829.67
      },
      {
        "periodo": 202605,
        "valor": 10624158700.36,
        "delta": -459940092.87
      },
      {
        "periodo": 202606,
        "valor": 10478080133.53,
        "delta": -146078566.83
      },
      {
        "periodo": 202607,
        "valor": 10659849221.67,
        "delta": 181769088.14
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 324007647.0,
    "valor_anterior": 377409686.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 438662159.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 224110008.0,
        "delta": -214552151.0
      },
      {
        "periodo": 202509,
        "valor": 162397434.0,
        "delta": -61712574.0
      },
      {
        "periodo": 202510,
        "valor": 518901083.0,
        "delta": 356503649.0
      },
      {
        "periodo": 202511,
        "valor": 213694980.0,
        "delta": -305206103.0
      },
      {
        "periodo": 202512,
        "valor": 161616031.0,
        "delta": -52078949.0
      },
      {
        "periodo": 202601,
        "valor": 24438554.0,
        "delta": -137177477.0
      },
      {
        "periodo": 202602,
        "valor": 198781287.0,
        "delta": 174342733.0
      },
      {
        "periodo": 202603,
        "valor": 580235060.0,
        "delta": 381453773.0
      },
      {
        "periodo": 202604,
        "valor": 205287802.0,
        "delta": -374947258.0
      },
      {
        "periodo": 202605,
        "valor": 266332904.0,
        "delta": 61045102.0
      },
      {
        "periodo": 202606,
        "valor": 377409686.0,
        "delta": 111076782.0
      },
      {
        "periodo": 202607,
        "valor": 324007647.0,
        "delta": -53402039.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 138634218.0,
    "valor_anterior": 137593207.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 166225276.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 166381081.0,
        "delta": 155805.0
      },
      {
        "periodo": 202509,
        "valor": 168318344.0,
        "delta": 1937263.0
      },
      {
        "periodo": 202510,
        "valor": 159972795.0,
        "delta": -8345549.0
      },
      {
        "periodo": 202511,
        "valor": 156685072.0,
        "delta": -3287723.0
      },
      {
        "periodo": 202512,
        "valor": 165024838.0,
        "delta": 8339766.0
      },
      {
        "periodo": 202601,
        "valor": 153956216.0,
        "delta": -11068622.0
      },
      {
        "periodo": 202602,
        "valor": 127786402.0,
        "delta": -26169814.0
      },
      {
        "periodo": 202603,
        "valor": 152416975.0,
        "delta": 24630573.0
      },
      {
        "periodo": 202604,
        "valor": 143246667.0,
        "delta": -9170308.0
      },
      {
        "periodo": 202605,
        "valor": 142469247.0,
        "delta": -777420.0
      },
      {
        "periodo": 202606,
        "valor": 137593207.0,
        "delta": -4876040.0
      },
      {
        "periodo": 202607,
        "valor": 138634218.0,
        "delta": 1041011.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 431543074.0,
    "valor_anterior": 420209596.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 391579355.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 334476217.0,
        "delta": -57103138.0
      },
      {
        "periodo": 202509,
        "valor": 341716677.0,
        "delta": 7240460.0
      },
      {
        "periodo": 202510,
        "valor": 357896913.0,
        "delta": 16180236.0
      },
      {
        "periodo": 202511,
        "valor": 343806251.0,
        "delta": -14090662.0
      },
      {
        "periodo": 202512,
        "valor": 473178555.0,
        "delta": 129372304.0
      },
      {
        "periodo": 202601,
        "valor": 469131458.0,
        "delta": -4047097.0
      },
      {
        "periodo": 202602,
        "valor": 442465076.0,
        "delta": -26666382.0
      },
      {
        "periodo": 202603,
        "valor": 521336604.0,
        "delta": 78871528.0
      },
      {
        "periodo": 202604,
        "valor": 467571678.0,
        "delta": -53764926.0
      },
      {
        "periodo": 202605,
        "valor": 415105494.0,
        "delta": -52466184.0
      },
      {
        "periodo": 202606,
        "valor": 420209596.0,
        "delta": 5104102.0
      },
      {
        "periodo": 202607,
        "valor": 431543074.0,
        "delta": 11333478.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 234016302.50000024,
    "valor_anterior": 291372610.31999993,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 159326772.38,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 126226957.74,
        "delta": -33099814.64
      },
      {
        "periodo": 202509,
        "valor": 212577936.13,
        "delta": 86350978.39
      },
      {
        "periodo": 202510,
        "valor": 247795520.27,
        "delta": 35217584.14
      },
      {
        "periodo": 202511,
        "valor": 377412865.86,
        "delta": 129617345.59
      },
      {
        "periodo": 202512,
        "valor": 400072385.92,
        "delta": 22659520.06
      },
      {
        "periodo": 202601,
        "valor": 380332664.21,
        "delta": -19739721.71
      },
      {
        "periodo": 202602,
        "valor": 273188407.17,
        "delta": -107144257.04
      },
      {
        "periodo": 202603,
        "valor": 382605878.33,
        "delta": 109417471.16
      },
      {
        "periodo": 202604,
        "valor": 375330093.79,
        "delta": -7275784.54
      },
      {
        "periodo": 202605,
        "valor": 355103603.77,
        "delta": -20226490.02
      },
      {
        "periodo": 202606,
        "valor": 291372610.32,
        "delta": -63730993.45
      },
      {
        "periodo": 202607,
        "valor": 234016302.5,
        "delta": -57356307.82
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 296866264.0,
    "valor_anterior": 305997204.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 284516275.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 314027631.0,
        "delta": 29511356.0
      },
      {
        "periodo": 202509,
        "valor": 288899826.0,
        "delta": -25127805.0
      },
      {
        "periodo": 202510,
        "valor": 290060139.0,
        "delta": 1160313.0
      },
      {
        "periodo": 202511,
        "valor": 298922652.0,
        "delta": 8862513.0
      },
      {
        "periodo": 202512,
        "valor": 293481980.0,
        "delta": -5440672.0
      },
      {
        "periodo": 202601,
        "valor": 296735690.0,
        "delta": 3253710.0
      },
      {
        "periodo": 202602,
        "valor": 287691805.0,
        "delta": -9043885.0
      },
      {
        "periodo": 202603,
        "valor": 315153870.0,
        "delta": 27462065.0
      },
      {
        "periodo": 202604,
        "valor": 290209692.0,
        "delta": -24944178.0
      },
      {
        "periodo": 202605,
        "valor": 312003606.0,
        "delta": 21793914.0
      },
      {
        "periodo": 202606,
        "valor": 305997204.0,
        "delta": -6006402.0
      },
      {
        "periodo": 202607,
        "valor": 296866264.0,
        "delta": -9130940.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 1562756688.7700005,
    "valor_anterior": 870922106.0699997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1582189491.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1637335948.27,
        "delta": 55146456.58
      },
      {
        "periodo": 202509,
        "valor": 843545843.84,
        "delta": -793790104.43
      },
      {
        "periodo": 202510,
        "valor": 1988752000.51,
        "delta": 1145206156.67
      },
      {
        "periodo": 202511,
        "valor": 1002530877.69,
        "delta": -986221122.82
      },
      {
        "periodo": 202512,
        "valor": 588506779.38,
        "delta": -414024098.31
      },
      {
        "periodo": 202601,
        "valor": 1090585354.33,
        "delta": 502078574.95
      },
      {
        "periodo": 202602,
        "valor": 1270564957.87,
        "delta": 179979603.54
      },
      {
        "periodo": 202603,
        "valor": 3137769739.2,
        "delta": 1867204781.33
      },
      {
        "periodo": 202604,
        "valor": 2081919908.93,
        "delta": -1055849830.27
      },
      {
        "periodo": 202605,
        "valor": 1338579542.49,
        "delta": -743340366.44
      },
      {
        "periodo": 202606,
        "valor": 870922106.07,
        "delta": -467657436.42
      },
      {
        "periodo": 202607,
        "valor": 1562756688.77,
        "delta": 691834582.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 10900924.0,
    "valor_anterior": 10560565.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13466445.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14053041.0,
        "delta": 586596.0
      },
      {
        "periodo": 202509,
        "valor": 12518991.0,
        "delta": -1534050.0
      },
      {
        "periodo": 202510,
        "valor": 13210419.0,
        "delta": 691428.0
      },
      {
        "periodo": 202511,
        "valor": 553990.0,
        "delta": -12656429.0
      },
      {
        "periodo": 202512,
        "valor": 15452553.0,
        "delta": 14898563.0
      },
      {
        "periodo": 202601,
        "valor": 12202530.0,
        "delta": -3250023.0
      },
      {
        "periodo": 202602,
        "valor": 9554808.0,
        "delta": -2647722.0
      },
      {
        "periodo": 202603,
        "valor": 11927924.0,
        "delta": 2373116.0
      },
      {
        "periodo": 202604,
        "valor": 11494943.0,
        "delta": -432981.0
      },
      {
        "periodo": 202605,
        "valor": 11237732.0,
        "delta": -257211.0
      },
      {
        "periodo": 202606,
        "valor": 10560565.0,
        "delta": -677167.0
      },
      {
        "periodo": 202607,
        "valor": 10900924.0,
        "delta": 340359.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 8650427534.04,
    "valor_anterior": 8235467741.169998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8364150863.97,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8566096128.86,
        "delta": 201945264.89
      },
      {
        "periodo": 202509,
        "valor": 8225815519.02,
        "delta": -340280609.84
      },
      {
        "periodo": 202510,
        "valor": 8556606739.21,
        "delta": 330791220.19
      },
      {
        "periodo": 202511,
        "valor": 8451442878.76,
        "delta": -105163860.45
      },
      {
        "periodo": 202512,
        "valor": 8620987151.6,
        "delta": 169544272.84
      },
      {
        "periodo": 202601,
        "valor": 8669916441.02,
        "delta": 48929289.42
      },
      {
        "periodo": 202602,
        "valor": 7769901066.28,
        "delta": -900015374.74
      },
      {
        "periodo": 202603,
        "valor": 8597774577.53,
        "delta": 827873511.25
      },
      {
        "periodo": 202604,
        "valor": 8226865367.57,
        "delta": -370909209.96
      },
      {
        "periodo": 202605,
        "valor": 8447304563.01,
        "delta": 220439195.44
      },
      {
        "periodo": 202606,
        "valor": 8235467741.17,
        "delta": -211836821.84
      },
      {
        "periodo": 202607,
        "valor": 8650427534.04,
        "delta": 414959792.87
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 135890735.0,
    "valor_anterior": 120117523.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 69553496.17,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 74622818.98,
        "delta": 5069322.81
      },
      {
        "periodo": 202509,
        "valor": 156107362.84,
        "delta": 81484543.86
      },
      {
        "periodo": 202510,
        "valor": 162502295.0,
        "delta": 6394932.16
      },
      {
        "periodo": 202511,
        "valor": 104244283.0,
        "delta": -58258012.0
      },
      {
        "periodo": 202512,
        "valor": 155676740.0,
        "delta": 51432457.0
      },
      {
        "periodo": 202601,
        "valor": 132973126.0,
        "delta": -22703614.0
      },
      {
        "periodo": 202602,
        "valor": 112483780.0,
        "delta": -20489346.0
      },
      {
        "periodo": 202603,
        "valor": 126764435.0,
        "delta": 14280655.0
      },
      {
        "periodo": 202604,
        "valor": 147924760.0,
        "delta": 21160325.0
      },
      {
        "periodo": 202605,
        "valor": 127224217.0,
        "delta": -20700543.0
      },
      {
        "periodo": 202606,
        "valor": 120117523.0,
        "delta": -7106694.0
      },
      {
        "periodo": 202607,
        "valor": 135890735.0,
        "delta": 15773212.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 43386094.0,
    "valor_anterior": 22915624.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1258009.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 39284957.0,
        "delta": 38026948.0
      },
      {
        "periodo": 202509,
        "valor": -46658503.0,
        "delta": -85943460.0
      },
      {
        "periodo": 202510,
        "valor": 71412150.0,
        "delta": 118070653.0
      },
      {
        "periodo": 202511,
        "valor": 11335308.0,
        "delta": -60076842.0
      },
      {
        "periodo": 202512,
        "valor": 34916667.0,
        "delta": 23581359.0
      },
      {
        "periodo": 202601,
        "valor": 43635319.0,
        "delta": 8718652.0
      },
      {
        "periodo": 202602,
        "valor": 41561595.0,
        "delta": -2073724.0
      },
      {
        "periodo": 202603,
        "valor": 13978621.0,
        "delta": -27582974.0
      },
      {
        "periodo": 202604,
        "valor": 13722325.0,
        "delta": -256296.0
      },
      {
        "periodo": 202605,
        "valor": 42878064.0,
        "delta": 29155739.0
      },
      {
        "periodo": 202606,
        "valor": 22915624.0,
        "delta": -19962440.0
      },
      {
        "periodo": 202607,
        "valor": 43386094.0,
        "delta": 20470470.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 2875005749.0,
    "valor_anterior": 2710345263.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2480915176.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2605895706.0,
        "delta": 124980530.0
      },
      {
        "periodo": 202509,
        "valor": 2526148378.0,
        "delta": -79747328.0
      },
      {
        "periodo": 202510,
        "valor": 2574493942.0,
        "delta": 48345564.0
      },
      {
        "periodo": 202511,
        "valor": 2640337585.0,
        "delta": 65843643.0
      },
      {
        "periodo": 202512,
        "valor": 2784134802.0,
        "delta": 143797217.0
      },
      {
        "periodo": 202601,
        "valor": 2670472902.0,
        "delta": -113661900.0
      },
      {
        "periodo": 202602,
        "valor": 2505025355.0,
        "delta": -165447547.0
      },
      {
        "periodo": 202603,
        "valor": 2726067747.0,
        "delta": 221042392.0
      },
      {
        "periodo": 202604,
        "valor": 2717460388.0,
        "delta": -8607359.0
      },
      {
        "periodo": 202605,
        "valor": 2710871833.0,
        "delta": -6588555.0
      },
      {
        "periodo": 202606,
        "valor": 2710345263.0,
        "delta": -526570.0
      },
      {
        "periodo": 202607,
        "valor": 2875005749.0,
        "delta": 164660486.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 458047131.0,
    "valor_anterior": 474533384.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 388807318.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 377813977.0,
        "delta": -10993341.0
      },
      {
        "periodo": 202509,
        "valor": 412300699.0,
        "delta": 34486722.0
      },
      {
        "periodo": 202510,
        "valor": 438992536.0,
        "delta": 26691837.0
      },
      {
        "periodo": 202511,
        "valor": 421108820.0,
        "delta": -17883716.0
      },
      {
        "periodo": 202512,
        "valor": 466279634.0,
        "delta": 45170814.0
      },
      {
        "periodo": 202601,
        "valor": 450370064.0,
        "delta": -15909570.0
      },
      {
        "periodo": 202602,
        "valor": 421687207.0,
        "delta": -28682857.0
      },
      {
        "periodo": 202603,
        "valor": 511927703.0,
        "delta": 90240496.0
      },
      {
        "periodo": 202604,
        "valor": 505769671.0,
        "delta": -6158032.0
      },
      {
        "periodo": 202605,
        "valor": 478800004.0,
        "delta": -26969667.0
      },
      {
        "periodo": 202606,
        "valor": 474533384.0,
        "delta": -4266620.0
      },
      {
        "periodo": 202607,
        "valor": 458047131.0,
        "delta": -16486253.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 144016054.0,
    "valor_anterior": 152321510.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 155665909.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 137343779.0,
        "delta": -18322130.0
      },
      {
        "periodo": 202509,
        "valor": 138698811.0,
        "delta": 1355032.0
      },
      {
        "periodo": 202510,
        "valor": 187958416.0,
        "delta": 49259605.0
      },
      {
        "periodo": 202511,
        "valor": 124634398.0,
        "delta": -63324018.0
      },
      {
        "periodo": 202512,
        "valor": 159153865.0,
        "delta": 34519467.0
      },
      {
        "periodo": 202601,
        "valor": 142500626.0,
        "delta": -16653239.0
      },
      {
        "periodo": 202602,
        "valor": 139226739.0,
        "delta": -3273887.0
      },
      {
        "periodo": 202603,
        "valor": 225512074.0,
        "delta": 86285335.0
      },
      {
        "periodo": 202604,
        "valor": 113070228.0,
        "delta": -112441846.0
      },
      {
        "periodo": 202605,
        "valor": 150446534.0,
        "delta": 37376306.0
      },
      {
        "periodo": 202606,
        "valor": 152321510.0,
        "delta": 1874976.0
      },
      {
        "periodo": 202607,
        "valor": 144016054.0,
        "delta": -8305456.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 10978676.0,
    "valor_anterior": 11281397.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 214745473.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 165143777.0,
        "delta": -49601696.0
      },
      {
        "periodo": 202509,
        "valor": 105349061.0,
        "delta": -59794716.0
      },
      {
        "periodo": 202510,
        "valor": 58861911.0,
        "delta": -46487150.0
      },
      {
        "periodo": 202511,
        "valor": 103426368.0,
        "delta": 44564457.0
      },
      {
        "periodo": 202512,
        "valor": 53520783.0,
        "delta": -49905585.0
      },
      {
        "periodo": 202601,
        "valor": 38989704.0,
        "delta": -14531079.0
      },
      {
        "periodo": 202602,
        "valor": 69077462.0,
        "delta": 30087758.0
      },
      {
        "periodo": 202603,
        "valor": 124411610.0,
        "delta": 55334148.0
      },
      {
        "periodo": 202604,
        "valor": 11901926.0,
        "delta": -112509684.0
      },
      {
        "periodo": 202605,
        "valor": 11596533.0,
        "delta": -305393.0
      },
      {
        "periodo": 202606,
        "valor": 11281397.0,
        "delta": -315136.0
      },
      {
        "periodo": 202607,
        "valor": 10978676.0,
        "delta": -302721.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 1669539425.0899982,
    "valor_anterior": 1660283275.6200008,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1627179051.2,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1585036353.68,
        "delta": -42142697.52
      },
      {
        "periodo": 202509,
        "valor": 1525379999.93,
        "delta": -59656353.75
      },
      {
        "periodo": 202510,
        "valor": 1666136622.55,
        "delta": 140756622.62
      },
      {
        "periodo": 202511,
        "valor": 1804778855.69,
        "delta": 138642233.14
      },
      {
        "periodo": 202512,
        "valor": 1624902560.66,
        "delta": -179876295.03
      },
      {
        "periodo": 202601,
        "valor": 1570141280.2,
        "delta": -54761280.46
      },
      {
        "periodo": 202602,
        "valor": 1554251119.95,
        "delta": -15890160.25
      },
      {
        "periodo": 202603,
        "valor": 1742017203.49,
        "delta": 187766083.54
      },
      {
        "periodo": 202604,
        "valor": 1643193943.53,
        "delta": -98823259.96
      },
      {
        "periodo": 202605,
        "valor": 1650753256.83,
        "delta": 7559313.3
      },
      {
        "periodo": 202606,
        "valor": 1660283275.62,
        "delta": 9530018.79
      },
      {
        "periodo": 202607,
        "valor": 1669539425.09,
        "delta": 9256149.47
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 33857422.0,
    "valor_anterior": 32879173.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -5906876.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7855912.0,
        "delta": 13762788.0
      },
      {
        "periodo": 202509,
        "valor": -5102410.0,
        "delta": -12958322.0
      },
      {
        "periodo": 202510,
        "valor": 3522151.0,
        "delta": 8624561.0
      },
      {
        "periodo": 202511,
        "valor": 2991492.0,
        "delta": -530659.0
      },
      {
        "periodo": 202512,
        "valor": 1716422.0,
        "delta": -1275070.0
      },
      {
        "periodo": 202601,
        "valor": 5959168.0,
        "delta": 4242746.0
      },
      {
        "periodo": 202602,
        "valor": -1391952.0,
        "delta": -7351120.0
      },
      {
        "periodo": 202603,
        "valor": 2285225.0,
        "delta": 3677177.0
      },
      {
        "periodo": 202604,
        "valor": 22921156.0,
        "delta": 20635931.0
      },
      {
        "periodo": 202605,
        "valor": 30888516.0,
        "delta": 7967360.0
      },
      {
        "periodo": 202606,
        "valor": 32879173.0,
        "delta": 1990657.0
      },
      {
        "periodo": 202607,
        "valor": 33857422.0,
        "delta": 978249.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 12467200.0,
    "valor_anterior": 16828974.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7549133.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5787103.0,
        "delta": -1762030.0
      },
      {
        "periodo": 202509,
        "valor": 324420.0,
        "delta": -5462683.0
      },
      {
        "periodo": 202510,
        "valor": -4099103.0,
        "delta": -4423523.0
      },
      {
        "periodo": 202511,
        "valor": 12138820.0,
        "delta": 16237923.0
      },
      {
        "periodo": 202512,
        "valor": 17800364.0,
        "delta": 5661544.0
      },
      {
        "periodo": 202601,
        "valor": 10552155.0,
        "delta": -7248209.0
      },
      {
        "periodo": 202602,
        "valor": 4473481.0,
        "delta": -6078674.0
      },
      {
        "periodo": 202603,
        "valor": 10243322.0,
        "delta": 5769841.0
      },
      {
        "periodo": 202604,
        "valor": 10223621.0,
        "delta": -19701.0
      },
      {
        "periodo": 202605,
        "valor": 15045638.0,
        "delta": 4822017.0
      },
      {
        "periodo": 202606,
        "valor": 16828974.0,
        "delta": 1783336.0
      },
      {
        "periodo": 202607,
        "valor": 12467200.0,
        "delta": -4361774.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 567574472.0,
    "valor_anterior": 558779320.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 435083039.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 453358546.0,
        "delta": 18275507.0
      },
      {
        "periodo": 202509,
        "valor": 469995950.0,
        "delta": 16637404.0
      },
      {
        "periodo": 202510,
        "valor": 485132676.0,
        "delta": 15136726.0
      },
      {
        "periodo": 202511,
        "valor": 506460879.0,
        "delta": 21328203.0
      },
      {
        "periodo": 202512,
        "valor": 501017252.0,
        "delta": -5443627.0
      },
      {
        "periodo": 202601,
        "valor": 515032503.0,
        "delta": 14015251.0
      },
      {
        "periodo": 202602,
        "valor": 450021741.0,
        "delta": -65010762.0
      },
      {
        "periodo": 202603,
        "valor": 569721384.0,
        "delta": 119699643.0
      },
      {
        "periodo": 202604,
        "valor": 547583388.0,
        "delta": -22137996.0
      },
      {
        "periodo": 202605,
        "valor": 549677802.0,
        "delta": 2094414.0
      },
      {
        "periodo": 202606,
        "valor": 558779320.0,
        "delta": 9101518.0
      },
      {
        "periodo": 202607,
        "valor": 567574472.0,
        "delta": 8795152.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 63562453.0,
    "valor_anterior": 65049614.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 65035853.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 69517616.0,
        "delta": 4481763.0
      },
      {
        "periodo": 202509,
        "valor": 67997721.0,
        "delta": -1519895.0
      },
      {
        "periodo": 202510,
        "valor": 65632008.0,
        "delta": -2365713.0
      },
      {
        "periodo": 202511,
        "valor": 67014611.0,
        "delta": 1382603.0
      },
      {
        "periodo": 202512,
        "valor": -81031460.0,
        "delta": -148046071.0
      },
      {
        "periodo": 202601,
        "valor": 58204370.0,
        "delta": 139235830.0
      },
      {
        "periodo": 202602,
        "valor": 64974350.0,
        "delta": 6769980.0
      },
      {
        "periodo": 202603,
        "valor": 61521359.0,
        "delta": -3452991.0
      },
      {
        "periodo": 202604,
        "valor": 72030017.0,
        "delta": 10508658.0
      },
      {
        "periodo": 202605,
        "valor": 64979151.0,
        "delta": -7050866.0
      },
      {
        "periodo": 202606,
        "valor": 65049614.0,
        "delta": 70463.0
      },
      {
        "periodo": 202607,
        "valor": 63562453.0,
        "delta": -1487161.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 181365608.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 132999783.0,
        "delta": -48365825.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 166401194.0,
    "valor_anterior": 138660214.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 146692135.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 147031101.0,
        "delta": 338966.0
      },
      {
        "periodo": 202509,
        "valor": 121191345.0,
        "delta": -25839756.0
      },
      {
        "periodo": 202510,
        "valor": 185097966.0,
        "delta": 63906621.0
      },
      {
        "periodo": 202511,
        "valor": 85238220.0,
        "delta": -99859746.0
      },
      {
        "periodo": 202512,
        "valor": 137994164.0,
        "delta": 52755944.0
      },
      {
        "periodo": 202601,
        "valor": 148140472.0,
        "delta": 10146308.0
      },
      {
        "periodo": 202602,
        "valor": 83677621.0,
        "delta": -64462851.0
      },
      {
        "periodo": 202603,
        "valor": 176314428.0,
        "delta": 92636807.0
      },
      {
        "periodo": 202604,
        "valor": 140412869.0,
        "delta": -35901559.0
      },
      {
        "periodo": 202605,
        "valor": 77274387.0,
        "delta": -63138482.0
      },
      {
        "periodo": 202606,
        "valor": 138660214.0,
        "delta": 61385827.0
      },
      {
        "periodo": 202607,
        "valor": 166401194.0,
        "delta": 27740980.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 182444200.0,
    "valor_anterior": 166880746.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 104549210.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 107153631.0,
        "delta": 2604421.0
      },
      {
        "periodo": 202509,
        "valor": 100915601.0,
        "delta": -6238030.0
      },
      {
        "periodo": 202510,
        "valor": 115694235.0,
        "delta": 14778634.0
      },
      {
        "periodo": 202511,
        "valor": 125382686.0,
        "delta": 9688451.0
      },
      {
        "periodo": 202512,
        "valor": 138171490.0,
        "delta": 12788804.0
      },
      {
        "periodo": 202601,
        "valor": 142133955.0,
        "delta": 3962465.0
      },
      {
        "periodo": 202602,
        "valor": 125678279.0,
        "delta": -16455676.0
      },
      {
        "periodo": 202603,
        "valor": 155622294.0,
        "delta": 29944015.0
      },
      {
        "periodo": 202604,
        "valor": 160109141.0,
        "delta": 4486847.0
      },
      {
        "periodo": 202605,
        "valor": 166398442.0,
        "delta": 6289301.0
      },
      {
        "periodo": 202606,
        "valor": 166880746.0,
        "delta": 482304.0
      },
      {
        "periodo": 202607,
        "valor": 182444200.0,
        "delta": 15563454.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 8378319.0,
    "valor_anterior": 9338693.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1430434.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2614216.0,
        "delta": 1183782.0
      },
      {
        "periodo": 202509,
        "valor": 3919941.0,
        "delta": 1305725.0
      },
      {
        "periodo": 202510,
        "valor": 3048750.0,
        "delta": -871191.0
      },
      {
        "periodo": 202511,
        "valor": 4883213.0,
        "delta": 1834463.0
      },
      {
        "periodo": 202512,
        "valor": 5979549.0,
        "delta": 1096336.0
      },
      {
        "periodo": 202601,
        "valor": 6363333.0,
        "delta": 383784.0
      },
      {
        "periodo": 202602,
        "valor": 5559750.0,
        "delta": -803583.0
      },
      {
        "periodo": 202603,
        "valor": 5683625.0,
        "delta": 123875.0
      },
      {
        "periodo": 202604,
        "valor": 4816481.0,
        "delta": -867144.0
      },
      {
        "periodo": 202605,
        "valor": 5354743.0,
        "delta": 538262.0
      },
      {
        "periodo": 202606,
        "valor": 9338693.0,
        "delta": 3983950.0
      },
      {
        "periodo": 202607,
        "valor": 8378319.0,
        "delta": -960374.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 29399746.0,
    "valor_anterior": 28314754.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21877046.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23821169.0,
        "delta": 1944123.0
      },
      {
        "periodo": 202509,
        "valor": 25111838.0,
        "delta": 1290669.0
      },
      {
        "periodo": 202510,
        "valor": 27941813.0,
        "delta": 2829975.0
      },
      {
        "periodo": 202511,
        "valor": 28519830.0,
        "delta": 578017.0
      },
      {
        "periodo": 202512,
        "valor": 30547923.0,
        "delta": 2028093.0
      },
      {
        "periodo": 202601,
        "valor": 30536837.0,
        "delta": -11086.0
      },
      {
        "periodo": 202602,
        "valor": 27627979.0,
        "delta": -2908858.0
      },
      {
        "periodo": 202603,
        "valor": 29287737.0,
        "delta": 1659758.0
      },
      {
        "periodo": 202604,
        "valor": 30749851.0,
        "delta": 1462114.0
      },
      {
        "periodo": 202605,
        "valor": 29870082.0,
        "delta": -879769.0
      },
      {
        "periodo": 202606,
        "valor": 28314754.0,
        "delta": -1555328.0
      },
      {
        "periodo": 202607,
        "valor": 29399746.0,
        "delta": 1084992.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 56824558.07000005,
    "valor_anterior": 54505262.869999975,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 47214493.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 46210697.73,
        "delta": -1003795.92
      },
      {
        "periodo": 202509,
        "valor": 45028455.17,
        "delta": -1182242.56
      },
      {
        "periodo": 202510,
        "valor": 48740532.55,
        "delta": 3712077.38
      },
      {
        "periodo": 202511,
        "valor": 44228756.65,
        "delta": -4511775.9
      },
      {
        "periodo": 202512,
        "valor": 48757306.73,
        "delta": 4528550.08
      },
      {
        "periodo": 202601,
        "valor": 48229196.0,
        "delta": -528110.73
      },
      {
        "periodo": 202602,
        "valor": 44015133.68,
        "delta": -4214062.32
      },
      {
        "periodo": 202603,
        "valor": 51526071.28,
        "delta": 7510937.6
      },
      {
        "periodo": 202604,
        "valor": 51576907.53,
        "delta": 50836.25
      },
      {
        "periodo": 202605,
        "valor": 51174418.92,
        "delta": -402488.61
      },
      {
        "periodo": 202606,
        "valor": 54505262.87,
        "delta": 3330843.95
      },
      {
        "periodo": 202607,
        "valor": 56824558.07,
        "delta": 2319295.2
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 9020174.0,
    "valor_anterior": 8658451.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8685614.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8647366.0,
        "delta": -38248.0
      },
      {
        "periodo": 202509,
        "valor": 7661252.0,
        "delta": -986114.0
      },
      {
        "periodo": 202510,
        "valor": 9434086.0,
        "delta": 1772834.0
      },
      {
        "periodo": 202511,
        "valor": 9706404.0,
        "delta": 272318.0
      },
      {
        "periodo": 202512,
        "valor": 11066907.0,
        "delta": 1360503.0
      },
      {
        "periodo": 202601,
        "valor": 9921864.0,
        "delta": -1145043.0
      },
      {
        "periodo": 202602,
        "valor": 7297187.0,
        "delta": -2624677.0
      },
      {
        "periodo": 202603,
        "valor": 8180515.0,
        "delta": 883328.0
      },
      {
        "periodo": 202604,
        "valor": 8233975.0,
        "delta": 53460.0
      },
      {
        "periodo": 202605,
        "valor": 8574970.0,
        "delta": 340995.0
      },
      {
        "periodo": 202606,
        "valor": 8658451.0,
        "delta": 83481.0
      },
      {
        "periodo": 202607,
        "valor": 9020174.0,
        "delta": 361723.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 229573537.14999986,
    "valor_anterior": 217639928.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 209736904.57,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 215968300.98,
        "delta": 6231396.41
      },
      {
        "periodo": 202509,
        "valor": 211941515.8,
        "delta": -4026785.18
      },
      {
        "periodo": 202510,
        "valor": 225519391.15,
        "delta": 13577875.35
      },
      {
        "periodo": 202511,
        "valor": 221212158.04,
        "delta": -4307233.11
      },
      {
        "periodo": 202512,
        "valor": 219620425.21,
        "delta": -1591732.83
      },
      {
        "periodo": 202601,
        "valor": 237852811.02,
        "delta": 18232385.81
      },
      {
        "periodo": 202602,
        "valor": 207297930.56,
        "delta": -30554880.46
      },
      {
        "periodo": 202603,
        "valor": 225916940.77,
        "delta": 18619010.21
      },
      {
        "periodo": 202604,
        "valor": 222629907.64,
        "delta": -3287033.13
      },
      {
        "periodo": 202605,
        "valor": 233131002.46,
        "delta": 10501094.82
      },
      {
        "periodo": 202606,
        "valor": 217639928.25,
        "delta": -15491074.21
      },
      {
        "periodo": 202607,
        "valor": 229573537.15,
        "delta": 11933608.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 71485880.19,
    "valor_anterior": 67014531.46999997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 56699524.12,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 53293362.3,
        "delta": -3406161.82
      },
      {
        "periodo": 202509,
        "valor": 54053322.34,
        "delta": 759960.04
      },
      {
        "periodo": 202510,
        "valor": 60680600.0,
        "delta": 6627277.66
      },
      {
        "periodo": 202511,
        "valor": 57114697.98,
        "delta": -3565902.02
      },
      {
        "periodo": 202512,
        "valor": 53242500.65,
        "delta": -3872197.33
      },
      {
        "periodo": 202601,
        "valor": 61328594.87,
        "delta": 8086094.22
      },
      {
        "periodo": 202602,
        "valor": 57330506.81,
        "delta": -3998088.06
      },
      {
        "periodo": 202603,
        "valor": 65681637.41,
        "delta": 8351130.6
      },
      {
        "periodo": 202604,
        "valor": 60103304.96,
        "delta": -5578332.45
      },
      {
        "periodo": 202605,
        "valor": 67065756.44,
        "delta": 6962451.48
      },
      {
        "periodo": 202606,
        "valor": 67014531.47,
        "delta": -51224.97
      },
      {
        "periodo": 202607,
        "valor": 71485880.19,
        "delta": 4471348.72
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 47959223.0,
    "valor_anterior": 41379662.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40682810.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 43168940.0,
        "delta": 2486130.0
      },
      {
        "periodo": 202509,
        "valor": 45106157.0,
        "delta": 1937217.0
      },
      {
        "periodo": 202510,
        "valor": 43820788.0,
        "delta": -1285369.0
      },
      {
        "periodo": 202511,
        "valor": 47480920.0,
        "delta": 3660132.0
      },
      {
        "periodo": 202512,
        "valor": 48245354.0,
        "delta": 764434.0
      },
      {
        "periodo": 202601,
        "valor": 47792861.0,
        "delta": -452493.0
      },
      {
        "periodo": 202602,
        "valor": 41177556.0,
        "delta": -6615305.0
      },
      {
        "periodo": 202603,
        "valor": 47431835.0,
        "delta": 6254279.0
      },
      {
        "periodo": 202604,
        "valor": 47216365.0,
        "delta": -215470.0
      },
      {
        "periodo": 202605,
        "valor": 44535433.0,
        "delta": -2680932.0
      },
      {
        "periodo": 202606,
        "valor": 41379662.0,
        "delta": -3155771.0
      },
      {
        "periodo": 202607,
        "valor": 47959223.0,
        "delta": 6579561.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 332554992.0,
    "valor_anterior": 346095556.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 336754308.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 351522291.0,
        "delta": 14767983.0
      },
      {
        "periodo": 202509,
        "valor": 315394934.0,
        "delta": -36127357.0
      },
      {
        "periodo": 202510,
        "valor": 345954112.0,
        "delta": 30559178.0
      },
      {
        "periodo": 202511,
        "valor": 313234704.0,
        "delta": -32719408.0
      },
      {
        "periodo": 202512,
        "valor": 328636497.0,
        "delta": 15401793.0
      },
      {
        "periodo": 202601,
        "valor": 316863444.0,
        "delta": -11773053.0
      },
      {
        "periodo": 202602,
        "valor": 293188022.0,
        "delta": -23675422.0
      },
      {
        "periodo": 202603,
        "valor": 346438766.0,
        "delta": 53250744.0
      },
      {
        "periodo": 202604,
        "valor": 329332434.0,
        "delta": -17106332.0
      },
      {
        "periodo": 202605,
        "valor": 336107976.0,
        "delta": 6775542.0
      },
      {
        "periodo": 202606,
        "valor": 346095556.0,
        "delta": 9987580.0
      },
      {
        "periodo": 202607,
        "valor": 332554992.0,
        "delta": -13540564.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 18640555.0,
    "valor_anterior": 24789299.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28939214.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 22108472.0,
        "delta": -6830742.0
      },
      {
        "periodo": 202509,
        "valor": 18133582.0,
        "delta": -3974890.0
      },
      {
        "periodo": 202510,
        "valor": 29722099.0,
        "delta": 11588517.0
      },
      {
        "periodo": 202511,
        "valor": 17412072.0,
        "delta": -12310027.0
      },
      {
        "periodo": 202512,
        "valor": 17293237.0,
        "delta": -118835.0
      },
      {
        "periodo": 202601,
        "valor": 7313478.0,
        "delta": -9979759.0
      },
      {
        "periodo": 202602,
        "valor": 16987276.0,
        "delta": 9673798.0
      },
      {
        "periodo": 202603,
        "valor": 36230246.0,
        "delta": 19242970.0
      },
      {
        "periodo": 202604,
        "valor": 17260238.0,
        "delta": -18970008.0
      },
      {
        "periodo": 202605,
        "valor": 21727406.0,
        "delta": 4467168.0
      },
      {
        "periodo": 202606,
        "valor": 24789299.0,
        "delta": 3061893.0
      },
      {
        "periodo": 202607,
        "valor": 18640555.0,
        "delta": -6148744.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 42485663.140000015,
    "valor_anterior": 42516683.77000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 45339562.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 44310102.85,
        "delta": -1029459.3
      },
      {
        "periodo": 202509,
        "valor": 43602915.13,
        "delta": -707187.72
      },
      {
        "periodo": 202510,
        "valor": 43726506.54,
        "delta": 123591.41
      },
      {
        "periodo": 202511,
        "valor": 43711781.57,
        "delta": -14724.97
      },
      {
        "periodo": 202512,
        "valor": 36659997.14,
        "delta": -7051784.43
      },
      {
        "periodo": 202601,
        "valor": 38604425.93,
        "delta": 1944428.79
      },
      {
        "periodo": 202602,
        "valor": 35259467.95,
        "delta": -3344957.98
      },
      {
        "periodo": 202603,
        "valor": 37903370.92,
        "delta": 2643902.97
      },
      {
        "periodo": 202604,
        "valor": 41204912.95,
        "delta": 3301542.03
      },
      {
        "periodo": 202605,
        "valor": 43316614.01,
        "delta": 2111701.06
      },
      {
        "periodo": 202606,
        "valor": 42516683.77,
        "delta": -799930.24
      },
      {
        "periodo": 202607,
        "valor": 42485663.14,
        "delta": -31020.63
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 19177453.989999995,
    "valor_anterior": 20067157.620000005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14506750.99,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2197383.65,
        "delta": -16704134.64
      },
      {
        "periodo": 202509,
        "valor": 55647043.04,
        "delta": 57844426.69
      },
      {
        "periodo": 202510,
        "valor": 21375503.54,
        "delta": -34271539.5
      },
      {
        "periodo": 202511,
        "valor": 16011353.27,
        "delta": -5364150.27
      },
      {
        "periodo": 202512,
        "valor": 16651477.02,
        "delta": 640123.75
      },
      {
        "periodo": 202601,
        "valor": 14808159.33,
        "delta": -1843317.69
      },
      {
        "periodo": 202602,
        "valor": 15653390.08,
        "delta": 845230.75
      },
      {
        "periodo": 202603,
        "valor": 22656345.02,
        "delta": 7002954.94
      },
      {
        "periodo": 202604,
        "valor": 15672330.69,
        "delta": -6984014.33
      },
      {
        "periodo": 202605,
        "valor": 18880294.26,
        "delta": 3207963.57
      },
      {
        "periodo": 202606,
        "valor": 20067157.62,
        "delta": 1186863.36
      },
      {
        "periodo": 202607,
        "valor": 19177453.99,
        "delta": -889703.63
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 22422586.0,
    "valor_anterior": 25049367.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28278195.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24427888.0,
        "delta": -3850307.0
      },
      {
        "periodo": 202509,
        "valor": 27554605.0,
        "delta": 3126717.0
      },
      {
        "periodo": 202510,
        "valor": 26167617.0,
        "delta": -1386988.0
      },
      {
        "periodo": 202511,
        "valor": 24840982.0,
        "delta": -1326635.0
      },
      {
        "periodo": 202512,
        "valor": 34532516.0,
        "delta": 9691534.0
      },
      {
        "periodo": 202601,
        "valor": 24121252.0,
        "delta": -10411264.0
      },
      {
        "periodo": 202602,
        "valor": 23037014.0,
        "delta": -1084238.0
      },
      {
        "periodo": 202603,
        "valor": 25062086.0,
        "delta": 2025072.0
      },
      {
        "periodo": 202604,
        "valor": 24435869.0,
        "delta": -626217.0
      },
      {
        "periodo": 202605,
        "valor": 25966976.0,
        "delta": 1531107.0
      },
      {
        "periodo": 202606,
        "valor": 25049367.0,
        "delta": -917609.0
      },
      {
        "periodo": 202607,
        "valor": 22422586.0,
        "delta": -2626781.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 17455580.0,
    "valor_anterior": 15062746.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17831895.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16953644.0,
        "delta": -878251.0
      },
      {
        "periodo": 202509,
        "valor": 16339768.0,
        "delta": -613876.0
      },
      {
        "periodo": 202510,
        "valor": 17093039.0,
        "delta": 753271.0
      },
      {
        "periodo": 202511,
        "valor": 16290272.0,
        "delta": -802767.0
      },
      {
        "periodo": 202512,
        "valor": 17775784.0,
        "delta": 1485512.0
      },
      {
        "periodo": 202601,
        "valor": 18453440.0,
        "delta": 677656.0
      },
      {
        "periodo": 202602,
        "valor": 15156400.0,
        "delta": -3297040.0
      },
      {
        "periodo": 202603,
        "valor": 17657830.0,
        "delta": 2501430.0
      },
      {
        "periodo": 202604,
        "valor": 15138463.0,
        "delta": -2519367.0
      },
      {
        "periodo": 202605,
        "valor": 17095875.0,
        "delta": 1957412.0
      },
      {
        "periodo": 202606,
        "valor": 15062746.0,
        "delta": -2033129.0
      },
      {
        "periodo": 202607,
        "valor": 17455580.0,
        "delta": 2392834.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 54943417.0,
    "valor_anterior": 65455204.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 41509607.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 53093924.0,
        "delta": 11584317.0
      },
      {
        "periodo": 202509,
        "valor": 42171077.0,
        "delta": -10922847.0
      },
      {
        "periodo": 202510,
        "valor": 45717501.0,
        "delta": 3546424.0
      },
      {
        "periodo": 202511,
        "valor": 49133855.0,
        "delta": 3416354.0
      },
      {
        "periodo": 202512,
        "valor": 55307799.0,
        "delta": 6173944.0
      },
      {
        "periodo": 202601,
        "valor": 55511414.0,
        "delta": 203615.0
      },
      {
        "periodo": 202602,
        "valor": 55761341.0,
        "delta": 249927.0
      },
      {
        "periodo": 202603,
        "valor": 57452394.0,
        "delta": 1691053.0
      },
      {
        "periodo": 202604,
        "valor": 50690769.0,
        "delta": -6761625.0
      },
      {
        "periodo": 202605,
        "valor": 50481388.0,
        "delta": -209381.0
      },
      {
        "periodo": 202606,
        "valor": 65455204.0,
        "delta": 14973816.0
      },
      {
        "periodo": 202607,
        "valor": 54943417.0,
        "delta": -10511787.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 5410343.860000003,
    "valor_anterior": 5130721.800000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8079985.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5936550.62,
        "delta": -2143435.2
      },
      {
        "periodo": 202509,
        "valor": 5231446.08,
        "delta": -705104.54
      },
      {
        "periodo": 202510,
        "valor": 5833719.14,
        "delta": 602273.06
      },
      {
        "periodo": 202511,
        "valor": 5621089.61,
        "delta": -212629.53
      },
      {
        "periodo": 202512,
        "valor": 5826664.79,
        "delta": 205575.18
      },
      {
        "periodo": 202601,
        "valor": 6007203.92,
        "delta": 180539.13
      },
      {
        "periodo": 202602,
        "valor": 5343169.88,
        "delta": -664034.04
      },
      {
        "periodo": 202603,
        "valor": 5962676.99,
        "delta": 619507.11
      },
      {
        "periodo": 202604,
        "valor": 5460686.79,
        "delta": -501990.2
      },
      {
        "periodo": 202605,
        "valor": 5456976.21,
        "delta": -3710.58
      },
      {
        "periodo": 202606,
        "valor": 5130721.8,
        "delta": -326254.41
      },
      {
        "periodo": 202607,
        "valor": 5410343.86,
        "delta": 279622.06
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 93282045.68000007,
    "valor_anterior": 93398846.70999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10664276.37,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10414962.21,
        "delta": -249314.16
      },
      {
        "periodo": 202509,
        "valor": 9985303.91,
        "delta": -429658.3
      },
      {
        "periodo": 202510,
        "valor": 10061013.84,
        "delta": 75709.93
      },
      {
        "periodo": 202511,
        "valor": 9474081.76,
        "delta": -586932.08
      },
      {
        "periodo": 202512,
        "valor": 9627389.49,
        "delta": 153307.73
      },
      {
        "periodo": 202601,
        "valor": 9472623.13,
        "delta": -154766.36
      },
      {
        "periodo": 202602,
        "valor": 85058652.69,
        "delta": 75586029.56
      },
      {
        "periodo": 202603,
        "valor": 95386689.24,
        "delta": 10328036.55
      },
      {
        "periodo": 202604,
        "valor": 94211772.04,
        "delta": -1174917.2
      },
      {
        "periodo": 202605,
        "valor": 95251846.95,
        "delta": 1040074.91
      },
      {
        "periodo": 202606,
        "valor": 93398846.71,
        "delta": -1853000.24
      },
      {
        "periodo": 202607,
        "valor": 93282045.68,
        "delta": -116801.03
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": -9518368.0,
    "valor_anterior": -15719099.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10251364.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6977276.0,
        "delta": -3274088.0
      },
      {
        "periodo": 202509,
        "valor": -20986.0,
        "delta": -6998262.0
      },
      {
        "periodo": 202510,
        "valor": -6603755.0,
        "delta": -6582769.0
      },
      {
        "periodo": 202511,
        "valor": -15060807.0,
        "delta": -8457052.0
      },
      {
        "periodo": 202512,
        "valor": -25855851.0,
        "delta": -10795044.0
      },
      {
        "periodo": 202601,
        "valor": -22744169.0,
        "delta": 3111682.0
      },
      {
        "periodo": 202602,
        "valor": -8655249.0,
        "delta": 14088920.0
      },
      {
        "periodo": 202603,
        "valor": -3368810.0,
        "delta": 5286439.0
      },
      {
        "periodo": 202604,
        "valor": -5205905.0,
        "delta": -1837095.0
      },
      {
        "periodo": 202605,
        "valor": -10578450.0,
        "delta": -5372545.0
      },
      {
        "periodo": 202606,
        "valor": -15719099.0,
        "delta": -5140649.0
      },
      {
        "periodo": 202607,
        "valor": -9518368.0,
        "delta": 6200731.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": -14828300.829999998,
    "valor_anterior": -17793315.580000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 30939793.8,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 7727897.88,
        "delta": -23211895.92
      },
      {
        "periodo": 202601,
        "valor": 6580813.54,
        "delta": -1147084.34
      },
      {
        "periodo": 202602,
        "valor": -6727623.16,
        "delta": -13308436.7
      },
      {
        "periodo": 202603,
        "valor": -15434455.47,
        "delta": -8706832.31
      },
      {
        "periodo": 202604,
        "valor": -15584617.81,
        "delta": -150162.34
      },
      {
        "periodo": 202605,
        "valor": 1033731.27,
        "delta": 16618349.08
      },
      {
        "periodo": 202606,
        "valor": -17793315.58,
        "delta": -18827046.85
      },
      {
        "periodo": 202607,
        "valor": -14828300.83,
        "delta": 2965014.75
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 823490510.0,
    "valor_anterior": 738981984.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 1552743001.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 728730082.0,
        "delta": -824012919.0
      },
      {
        "periodo": 202605,
        "valor": 717851331.0,
        "delta": -10878751.0
      },
      {
        "periodo": 202606,
        "valor": 738981984.0,
        "delta": 21130653.0
      },
      {
        "periodo": 202607,
        "valor": 823490510.0,
        "delta": 84508526.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 84421666604.40997,
    "valor_anterior": 79734102305.07,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 78424706412.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 78783653105.1899,
        "delta": 358946692.3699
      },
      {
        "periodo": 202509,
        "valor": 75184623342.26,
        "delta": -3599029762.9299
      },
      {
        "periodo": 202510,
        "valor": 79124075395.42,
        "delta": 3939452053.16
      },
      {
        "periodo": 202511,
        "valor": 78528571894.99,
        "delta": -595503500.4301
      },
      {
        "periodo": 202512,
        "valor": 81796159905.75,
        "delta": 3267588010.76
      },
      {
        "periodo": 202601,
        "valor": 81768343205.91,
        "delta": -27816699.84
      },
      {
        "periodo": 202602,
        "valor": 75675721653.51,
        "delta": -6092621552.4
      },
      {
        "periodo": 202603,
        "valor": 85008917880.04,
        "delta": 9333196226.53
      },
      {
        "periodo": 202604,
        "valor": 83898050798.05,
        "delta": -1110867081.99
      },
      {
        "periodo": 202605,
        "valor": 83142188881.13,
        "delta": -755861916.92
      },
      {
        "periodo": 202606,
        "valor": 79734102305.07,
        "delta": -3408086576.06
      },
      {
        "periodo": 202607,
        "valor": 84421666604.41,
        "delta": 4687564299.34
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 59105663031.95996,
    "valor_anterior": 56179980335.23004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 55672100890.95,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55162924876.72,
        "delta": -509176014.23
      },
      {
        "periodo": 202509,
        "valor": 55518115385.35,
        "delta": 355190508.63
      },
      {
        "periodo": 202510,
        "valor": 55166507285.9,
        "delta": -351608099.45
      },
      {
        "periodo": 202511,
        "valor": 56065971361.7,
        "delta": 899464075.8
      },
      {
        "periodo": 202512,
        "valor": 58288788450.13,
        "delta": 2222817088.43
      },
      {
        "periodo": 202601,
        "valor": 58820781164.39,
        "delta": 531992714.26
      },
      {
        "periodo": 202602,
        "valor": 54339711408.66,
        "delta": -4481069755.73
      },
      {
        "periodo": 202603,
        "valor": 56700456294.76,
        "delta": 2360744886.1
      },
      {
        "periodo": 202604,
        "valor": 59207657261.0,
        "delta": 2507200966.24
      },
      {
        "periodo": 202605,
        "valor": 58846823440.99,
        "delta": -360833820.01
      },
      {
        "periodo": 202606,
        "valor": 56179980335.23,
        "delta": -2666843105.7599
      },
      {
        "periodo": 202607,
        "valor": 59105663031.96,
        "delta": 2925682696.7299
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 411396172.5,
    "valor_anterior": 441314221.3200002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 702129988.38,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 571401618.74,
        "delta": -130728369.64
      },
      {
        "periodo": 202509,
        "valor": -1316664324.87,
        "delta": -1888065943.61
      },
      {
        "periodo": 202510,
        "valor": 491755397.27,
        "delta": 1808419722.14
      },
      {
        "periodo": 202511,
        "valor": 566077453.86,
        "delta": 74322056.59
      },
      {
        "periodo": 202512,
        "valor": 591587332.92,
        "delta": 25509879.06
      },
      {
        "periodo": 202601,
        "valor": 567462840.21,
        "delta": -24124492.71
      },
      {
        "periodo": 202602,
        "valor": 425943490.17,
        "delta": -141519350.04
      },
      {
        "periodo": 202603,
        "valor": 683331916.33,
        "delta": 257388426.16
      },
      {
        "periodo": 202604,
        "valor": 527644888.79,
        "delta": -155687027.54
      },
      {
        "periodo": 202605,
        "valor": 443974523.77,
        "delta": -83670365.02
      },
      {
        "periodo": 202606,
        "valor": 441314221.32,
        "delta": -2660302.45
      },
      {
        "periodo": 202607,
        "valor": 411396172.5,
        "delta": -29918048.82
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 4123631402.7700005,
    "valor_anterior": 3198472133.0699997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3574377020.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4257656874.27,
        "delta": 683279853.58
      },
      {
        "periodo": 202509,
        "valor": 2646288710.84,
        "delta": -1611368163.43
      },
      {
        "periodo": 202510,
        "valor": 4034295259.51,
        "delta": 1388006548.67
      },
      {
        "periodo": 202511,
        "valor": 2656377271.69,
        "delta": -1377917987.82
      },
      {
        "periodo": 202512,
        "valor": 2848645325.38,
        "delta": 192268053.69
      },
      {
        "periodo": 202601,
        "valor": 3311236396.33,
        "delta": 462591070.95
      },
      {
        "periodo": 202602,
        "valor": 3097758503.87,
        "delta": -213477892.46
      },
      {
        "periodo": 202603,
        "valor": 6109825337.2,
        "delta": 3012066833.33
      },
      {
        "periodo": 202604,
        "valor": 4274438625.93,
        "delta": -1835386711.27
      },
      {
        "periodo": 202605,
        "valor": 3512163301.49,
        "delta": -762275324.44
      },
      {
        "periodo": 202606,
        "valor": 3198472133.07,
        "delta": -313691168.42
      },
      {
        "periodo": 202607,
        "valor": 4123631402.77,
        "delta": 925159269.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 4793107484.799999,
    "valor_anterior": 4656643968.75,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4366153003.79,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4412355879.9,
        "delta": 46202876.11
      },
      {
        "periodo": 202509,
        "valor": 4293142987.68,
        "delta": -119212892.22
      },
      {
        "periodo": 202510,
        "valor": 4813661309.22,
        "delta": 520518321.54
      },
      {
        "periodo": 202511,
        "valor": 4648932676.61,
        "delta": -164728632.61
      },
      {
        "periodo": 202512,
        "valor": 5387055855.15,
        "delta": 738123178.54
      },
      {
        "periodo": 202601,
        "valor": 4422533803.02,
        "delta": -964522052.13
      },
      {
        "periodo": 202602,
        "valor": 4327782308.09,
        "delta": -94751494.93
      },
      {
        "periodo": 202603,
        "valor": 4884903099.57,
        "delta": 557120791.48
      },
      {
        "periodo": 202604,
        "valor": 4692694257.44,
        "delta": -192208842.13
      },
      {
        "periodo": 202605,
        "valor": 4873781508.52,
        "delta": 181087251.08
      },
      {
        "periodo": 202606,
        "valor": 4656643968.75,
        "delta": -217137539.77
      },
      {
        "periodo": 202607,
        "valor": 4793107484.8,
        "delta": 136463516.05
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 1234522902.54,
    "valor_anterior": 1195452540.9800005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1086708853.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1052259547.19,
        "delta": -34449306.46
      },
      {
        "periodo": 202509,
        "valor": 1188095413.32,
        "delta": 135835866.13
      },
      {
        "periodo": 202510,
        "valor": 1232621364.78,
        "delta": 44525951.46
      },
      {
        "periodo": 202511,
        "valor": 1061684333.51,
        "delta": -170937031.27
      },
      {
        "periodo": 202512,
        "valor": 1202198611.75,
        "delta": 140514278.24
      },
      {
        "periodo": 202601,
        "valor": 1132708197.15,
        "delta": -69490414.6
      },
      {
        "periodo": 202602,
        "valor": 1037705381.08,
        "delta": -95002816.07
      },
      {
        "periodo": 202603,
        "valor": 1268722122.4,
        "delta": 231016741.32
      },
      {
        "periodo": 202604,
        "valor": 1150120791.77,
        "delta": -118601330.63
      },
      {
        "periodo": 202605,
        "valor": 1202973983.09,
        "delta": 52853191.32
      },
      {
        "periodo": 202606,
        "valor": 1195452540.98,
        "delta": -7521442.11
      },
      {
        "periodo": 202607,
        "valor": 1234522902.54,
        "delta": 39070361.56
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100008,
    "label": "Margen Financiero",
    "valor_actual": 14753345609.839996,
    "valor_anterior": 14062239105.720001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13023236655.36,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13327054308.37,
        "delta": 303817653.01
      },
      {
        "periodo": 202509,
        "valor": 12855645169.94,
        "delta": -471409138.43
      },
      {
        "periodo": 202510,
        "valor": 13385234778.74,
        "delta": 529589608.8
      },
      {
        "periodo": 202511,
        "valor": 13529528797.62,
        "delta": 144294018.88
      },
      {
        "periodo": 202512,
        "valor": 13477884330.42,
        "delta": -51644467.2
      },
      {
        "periodo": 202601,
        "valor": 13513620804.81,
        "delta": 35736474.39
      },
      {
        "periodo": 202602,
        "valor": 12446820561.64,
        "delta": -1066800243.17
      },
      {
        "periodo": 202603,
        "valor": 15361679109.78,
        "delta": 2914858548.14
      },
      {
        "periodo": 202604,
        "valor": 14045494973.12,
        "delta": -1316184136.66
      },
      {
        "periodo": 202605,
        "valor": 14262472123.27,
        "delta": 216977150.15
      },
      {
        "periodo": 202606,
        "valor": 14062239105.72,
        "delta": -200233017.55
      },
      {
        "periodo": 202607,
        "valor": 14753345609.84,
        "delta": 691106504.12
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 5883753432.190002,
    "valor_anterior": 4500735730.389999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5320439352.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5762879469.01,
        "delta": 442440116.32
      },
      {
        "periodo": 202509,
        "valor": 5758556936.79,
        "delta": -4322532.22
      },
      {
        "periodo": 202510,
        "valor": 4400713487.58,
        "delta": -1357843449.21
      },
      {
        "periodo": 202511,
        "valor": 5779967577.86,
        "delta": 1379254090.28
      },
      {
        "periodo": 202512,
        "valor": 6092912384.08,
        "delta": 312944806.22
      },
      {
        "periodo": 202601,
        "valor": 7087776622.28,
        "delta": 994864238.2
      },
      {
        "periodo": 202602,
        "valor": 5860350512.43,
        "delta": -1227426109.85
      },
      {
        "periodo": 202603,
        "valor": 3272685252.79,
        "delta": -2587665259.64
      },
      {
        "periodo": 202604,
        "valor": 6063616005.21,
        "delta": 2790930752.42
      },
      {
        "periodo": 202605,
        "valor": 5461139027.4,
        "delta": -602476977.81
      },
      {
        "periodo": 202606,
        "valor": 4500735730.39,
        "delta": -960403297.01
      },
      {
        "periodo": 202607,
        "valor": 5883753432.19,
        "delta": 1383017701.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 16399980646.39,
    "valor_anterior": 14896497358.539993,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14730666860.64,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14328513392.11,
        "delta": -402153468.53
      },
      {
        "periodo": 202509,
        "valor": 14431373531.35,
        "delta": 102860139.24
      },
      {
        "periodo": 202510,
        "valor": 14406722243.11,
        "delta": -24651288.24
      },
      {
        "periodo": 202511,
        "valor": 14406253832.45,
        "delta": -468410.66
      },
      {
        "periodo": 202512,
        "valor": 14476366244.47,
        "delta": 70112412.02
      },
      {
        "periodo": 202601,
        "valor": 15553329742.87,
        "delta": 1076963498.4
      },
      {
        "periodo": 202602,
        "valor": 10656012123.48,
        "delta": -4897317619.39
      },
      {
        "periodo": 202603,
        "valor": 14749368032.03,
        "delta": 4093355908.55
      },
      {
        "periodo": 202604,
        "valor": 15756988969.74,
        "delta": 1007620937.71
      },
      {
        "periodo": 202605,
        "valor": 15375534613.99,
        "delta": -381454355.75
      },
      {
        "periodo": 202606,
        "valor": 14896497358.54,
        "delta": -479037255.45
      },
      {
        "periodo": 202607,
        "valor": 16399980646.39,
        "delta": 1503483287.85
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 5722744093.0,
    "valor_anterior": 6404202020.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6267774250.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5972652836.0,
        "delta": -295121414.0
      },
      {
        "periodo": 202509,
        "valor": 5256217470.0,
        "delta": -716435366.0
      },
      {
        "periodo": 202510,
        "valor": 5506548055.0,
        "delta": 250330585.0
      },
      {
        "periodo": 202511,
        "valor": 5378524417.0,
        "delta": -128023638.0
      },
      {
        "periodo": 202512,
        "valor": 6487725410.0,
        "delta": 1109200993.0
      },
      {
        "periodo": 202601,
        "valor": 6384202984.0,
        "delta": -103522426.0
      },
      {
        "periodo": 202602,
        "valor": 5199359798.0,
        "delta": -1184843186.0
      },
      {
        "periodo": 202603,
        "valor": 6070873512.0,
        "delta": 871513714.0
      },
      {
        "periodo": 202604,
        "valor": 6333886812.0,
        "delta": 263013300.0
      },
      {
        "periodo": 202605,
        "valor": 3912931647.0,
        "delta": -2420955165.0
      },
      {
        "periodo": 202606,
        "valor": 6404202020.0,
        "delta": 2491270373.0
      },
      {
        "periodo": 202607,
        "valor": 5722744093.0,
        "delta": -681457927.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 2556256625.0,
    "valor_anterior": 2680500657.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2896457224.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3190593189.0,
        "delta": 294135965.0
      },
      {
        "periodo": 202509,
        "valor": 3006741815.0,
        "delta": -183851374.0
      },
      {
        "periodo": 202510,
        "valor": 2764863376.0,
        "delta": -241878439.0
      },
      {
        "periodo": 202511,
        "valor": 3185448424.0,
        "delta": 420585048.0
      },
      {
        "periodo": 202512,
        "valor": 3040804154.5,
        "delta": -144644269.5
      },
      {
        "periodo": 202601,
        "valor": 3311362208.0,
        "delta": 270558053.5
      },
      {
        "periodo": 202602,
        "valor": 2943521174.0,
        "delta": -367841034.0
      },
      {
        "periodo": 202603,
        "valor": 3399654057.0,
        "delta": 456132883.0
      },
      {
        "periodo": 202604,
        "valor": 3059971883.0,
        "delta": -339682174.0
      },
      {
        "periodo": 202605,
        "valor": 3016658238.0,
        "delta": -43313645.0
      },
      {
        "periodo": 202606,
        "valor": 2680500657.0,
        "delta": -336157581.0
      },
      {
        "periodo": 202607,
        "valor": 2556256625.0,
        "delta": -124244032.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 1439043140.8099976,
    "valor_anterior": 1579720483.9000025,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1479467755.59,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1706026785.56,
        "delta": 226559029.97
      },
      {
        "periodo": 202509,
        "valor": 1371307741.59,
        "delta": -334719043.97
      },
      {
        "periodo": 202510,
        "valor": 1620854337.16,
        "delta": 249546595.57
      },
      {
        "periodo": 202511,
        "valor": 1686543112.87,
        "delta": 65688775.71
      },
      {
        "periodo": 202512,
        "valor": 1506101197.6,
        "delta": -180441915.27
      },
      {
        "periodo": 202601,
        "valor": 1631387415.53,
        "delta": 125286217.93
      },
      {
        "periodo": 202602,
        "valor": 1374257275.15,
        "delta": -257130140.38
      },
      {
        "periodo": 202603,
        "valor": 1736360806.08,
        "delta": 362103530.93
      },
      {
        "periodo": 202604,
        "valor": 1584366717.39,
        "delta": -151994088.69
      },
      {
        "periodo": 202605,
        "valor": 1655467956.98,
        "delta": 71101239.59
      },
      {
        "periodo": 202606,
        "valor": 1579720483.9,
        "delta": -75747473.08
      },
      {
        "periodo": 202607,
        "valor": 1439043140.81,
        "delta": -140677343.09
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 2378376876.000004,
    "valor_anterior": 2312178540.999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2918374068.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2519558447.0,
        "delta": -398815621.0
      },
      {
        "periodo": 202509,
        "valor": 2717867007.0,
        "delta": 198308560.0
      },
      {
        "periodo": 202510,
        "valor": 2617523705.0,
        "delta": -100343302.0
      },
      {
        "periodo": 202511,
        "valor": 2637841464.0,
        "delta": 20317759.0
      },
      {
        "periodo": 202512,
        "valor": 3251737014.0,
        "delta": 613895550.0
      },
      {
        "periodo": 202601,
        "valor": 2400303189.0,
        "delta": -851433825.0
      },
      {
        "periodo": 202602,
        "valor": 2174770642.0,
        "delta": -225532547.0
      },
      {
        "periodo": 202603,
        "valor": 2614673045.0,
        "delta": 439902403.0
      },
      {
        "periodo": 202604,
        "valor": 2187605587.0,
        "delta": -427067458.0
      },
      {
        "periodo": 202605,
        "valor": 2755575950.0,
        "delta": 567970363.0
      },
      {
        "periodo": 202606,
        "valor": 2312178541.0,
        "delta": -443397409.0
      },
      {
        "periodo": 202607,
        "valor": 2378376876.0,
        "delta": 66198335.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 697924451.0,
    "valor_anterior": 557334304.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 247849208.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 259382894.0,
        "delta": 11533686.0
      },
      {
        "periodo": 202509,
        "valor": 241242138.0,
        "delta": -18140756.0
      },
      {
        "periodo": 202510,
        "valor": 562026760.0,
        "delta": 320784622.0
      },
      {
        "periodo": 202511,
        "valor": 580511305.0,
        "delta": 18484545.0
      },
      {
        "periodo": 202512,
        "valor": 1050138344.0,
        "delta": 469627039.0
      },
      {
        "periodo": 202601,
        "valor": 284702351.0,
        "delta": -765435993.0
      },
      {
        "periodo": 202602,
        "valor": 585639138.0,
        "delta": 300936787.0
      },
      {
        "periodo": 202603,
        "valor": 612139987.0,
        "delta": 26500849.0
      },
      {
        "periodo": 202604,
        "valor": 561452712.0,
        "delta": -50687275.0
      },
      {
        "periodo": 202605,
        "valor": 652813938.0,
        "delta": 91361226.0
      },
      {
        "periodo": 202606,
        "valor": 557334304.0,
        "delta": -95479634.0
      },
      {
        "periodo": 202607,
        "valor": 697924451.0,
        "delta": 140590147.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 2902888420.0,
    "valor_anterior": 2471273437.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1952316682.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2089016153.0,
        "delta": 136699471.0
      },
      {
        "periodo": 202509,
        "valor": 1892719503.0,
        "delta": -196296650.0
      },
      {
        "periodo": 202510,
        "valor": 2151660479.0,
        "delta": 258940976.0
      },
      {
        "periodo": 202511,
        "valor": 1750225571.0,
        "delta": -401434908.0
      },
      {
        "periodo": 202512,
        "valor": 2537599365.0,
        "delta": 787373794.0
      },
      {
        "periodo": 202601,
        "valor": 2505822022.0,
        "delta": -31777343.0
      },
      {
        "periodo": 202602,
        "valor": 2014877343.0,
        "delta": -490944679.0
      },
      {
        "periodo": 202603,
        "valor": 2374573925.0,
        "delta": 359696582.0
      },
      {
        "periodo": 202604,
        "valor": 1787227282.0,
        "delta": -587346643.0
      },
      {
        "periodo": 202605,
        "valor": 2124978403.0,
        "delta": 337751121.0
      },
      {
        "periodo": 202606,
        "valor": 2471273437.0,
        "delta": 346295034.0
      },
      {
        "periodo": 202607,
        "valor": 2902888420.0,
        "delta": 431614983.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 1150275559.4899998,
    "valor_anterior": 1033068647.9499998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1118475366.67,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1101724736.89,
        "delta": -16750629.78
      },
      {
        "periodo": 202509,
        "valor": 1166797340.99,
        "delta": 65072604.1
      },
      {
        "periodo": 202510,
        "valor": 1115886130.38,
        "delta": -50911210.61
      },
      {
        "periodo": 202511,
        "valor": 1143903561.42,
        "delta": 28017431.04
      },
      {
        "periodo": 202512,
        "valor": 1234738154.78,
        "delta": 90834593.36
      },
      {
        "periodo": 202601,
        "valor": 1119209170.73,
        "delta": -115528984.05
      },
      {
        "periodo": 202602,
        "valor": 1002233977.08,
        "delta": -116975193.65
      },
      {
        "periodo": 202603,
        "valor": 1117580820.32,
        "delta": 115346843.24
      },
      {
        "periodo": 202604,
        "valor": 1146803889.51,
        "delta": 29223069.19
      },
      {
        "periodo": 202605,
        "valor": 1104920503.24,
        "delta": -41883386.27
      },
      {
        "periodo": 202606,
        "valor": 1033068647.95,
        "delta": -71851855.29
      },
      {
        "periodo": 202607,
        "valor": 1150275559.49,
        "delta": 117206911.54
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 377347251.0,
    "valor_anterior": 214096992.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -36293016.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 846255763.0,
        "delta": 882548779.0
      },
      {
        "periodo": 202509,
        "valor": 184017744.0,
        "delta": -662238019.0
      },
      {
        "periodo": 202510,
        "valor": -176397709.0,
        "delta": -360415453.0
      },
      {
        "periodo": 202511,
        "valor": -284383388.0,
        "delta": -107985679.0
      },
      {
        "periodo": 202512,
        "valor": 225984022.0,
        "delta": 510367410.0
      },
      {
        "periodo": 202601,
        "valor": 149109958.0,
        "delta": -76874064.0
      },
      {
        "periodo": 202602,
        "valor": -88056761.0,
        "delta": -237166719.0
      },
      {
        "periodo": 202603,
        "valor": 481782920.0,
        "delta": 569839681.0
      },
      {
        "periodo": 202604,
        "valor": 175025176.0,
        "delta": -306757744.0
      },
      {
        "periodo": 202605,
        "valor": 136041993.0,
        "delta": -38983183.0
      },
      {
        "periodo": 202606,
        "valor": 214096992.0,
        "delta": 78054999.0
      },
      {
        "periodo": 202607,
        "valor": 377347251.0,
        "delta": 163250259.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 208244871.0,
    "valor_anterior": 214573474.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 260981290.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 259316906.0,
        "delta": -1664384.0
      },
      {
        "periodo": 202509,
        "valor": 282510963.0,
        "delta": 23194057.0
      },
      {
        "periodo": 202510,
        "valor": 245201726.0,
        "delta": -37309237.0
      },
      {
        "periodo": 202511,
        "valor": 213575056.0,
        "delta": -31626670.0
      },
      {
        "periodo": 202512,
        "valor": 260377556.0,
        "delta": 46802500.0
      },
      {
        "periodo": 202601,
        "valor": 208586495.0,
        "delta": -51791061.0
      },
      {
        "periodo": 202602,
        "valor": 204142684.0,
        "delta": -4443811.0
      },
      {
        "periodo": 202603,
        "valor": 227401339.0,
        "delta": 23258655.0
      },
      {
        "periodo": 202604,
        "valor": 209594101.0,
        "delta": -17807238.0
      },
      {
        "periodo": 202605,
        "valor": 205089501.0,
        "delta": -4504600.0
      },
      {
        "periodo": 202606,
        "valor": 214573474.0,
        "delta": 9483973.0
      },
      {
        "periodo": 202607,
        "valor": 208244871.0,
        "delta": -6328603.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 346205765.0,
    "valor_anterior": 417811526.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 415543878.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 420290976.0,
        "delta": 4747098.0
      },
      {
        "periodo": 202509,
        "valor": 367147672.0,
        "delta": -53143304.0
      },
      {
        "periodo": 202510,
        "valor": 425600770.0,
        "delta": 58453098.0
      },
      {
        "periodo": 202511,
        "valor": 465153971.0,
        "delta": 39553201.0
      },
      {
        "periodo": 202512,
        "valor": -347471839.0,
        "delta": -812625810.0
      },
      {
        "periodo": 202601,
        "valor": 467446020.0,
        "delta": 814917859.0
      },
      {
        "periodo": 202602,
        "valor": 394916948.0,
        "delta": -72529072.0
      },
      {
        "periodo": 202603,
        "valor": 443292744.0,
        "delta": 48375796.0
      },
      {
        "periodo": 202604,
        "valor": 480566295.0,
        "delta": 37273551.0
      },
      {
        "periodo": 202605,
        "valor": 374363868.0,
        "delta": -106202427.0
      },
      {
        "periodo": 202606,
        "valor": 417811526.0,
        "delta": 43447658.0
      },
      {
        "periodo": 202607,
        "valor": 346205765.0,
        "delta": -71605761.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 8142808907.709999,
    "valor_anterior": 8672681145.54,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8401920828.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7975598915.46,
        "delta": -426321913.23
      },
      {
        "periodo": 202509,
        "valor": 6307907913.63,
        "delta": -1667691001.83
      },
      {
        "periodo": 202510,
        "valor": 8381982742.13,
        "delta": 2074074828.5
      },
      {
        "periodo": 202511,
        "valor": 8230476261.17,
        "delta": -151506480.96
      },
      {
        "periodo": 202512,
        "valor": 9594252380.74,
        "delta": 1363776119.57
      },
      {
        "periodo": 202601,
        "valor": 7870649734.74,
        "delta": -1723602646.0
      },
      {
        "periodo": 202602,
        "valor": 7961858076.57,
        "delta": 91208341.83
      },
      {
        "periodo": 202603,
        "valor": 8203250616.0,
        "delta": 241392539.43
      },
      {
        "periodo": 202604,
        "valor": 9027980259.65,
        "delta": 824729643.65
      },
      {
        "periodo": 202605,
        "valor": 8313693135.42,
        "delta": -714287124.23
      },
      {
        "periodo": 202606,
        "valor": 8672681145.54,
        "delta": 358988010.12
      },
      {
        "periodo": 202607,
        "valor": 8142808907.71,
        "delta": -529872237.83
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 334182722.0,
    "valor_anterior": 355634048.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 328157397.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 226384345.0,
        "delta": -101773052.0
      },
      {
        "periodo": 202509,
        "valor": 63994239.0,
        "delta": -162390106.0
      },
      {
        "periodo": 202510,
        "valor": 590284788.0,
        "delta": 526290549.0
      },
      {
        "periodo": 202511,
        "valor": 236424455.0,
        "delta": -353860333.0
      },
      {
        "periodo": 202512,
        "valor": 160784095.0,
        "delta": -75640360.0
      },
      {
        "periodo": 202601,
        "valor": 54933462.0,
        "delta": -105850633.0
      },
      {
        "periodo": 202602,
        "valor": 184383283.0,
        "delta": 129449821.0
      },
      {
        "periodo": 202603,
        "valor": 590599548.0,
        "delta": 406216265.0
      },
      {
        "periodo": 202604,
        "valor": 237908351.0,
        "delta": -352691197.0
      },
      {
        "periodo": 202605,
        "valor": 302075246.0,
        "delta": 64166895.0
      },
      {
        "periodo": 202606,
        "valor": 355634048.0,
        "delta": 53558802.0
      },
      {
        "periodo": 202607,
        "valor": 334182722.0,
        "delta": -21451326.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 143456855.0,
    "valor_anterior": 122622551.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 171933758.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 162237584.0,
        "delta": -9696174.0
      },
      {
        "periodo": 202509,
        "valor": 176254632.0,
        "delta": 14017048.0
      },
      {
        "periodo": 202510,
        "valor": 140678139.0,
        "delta": -35576493.0
      },
      {
        "periodo": 202511,
        "valor": 164495083.0,
        "delta": 23816944.0
      },
      {
        "periodo": 202512,
        "valor": 172610370.0,
        "delta": 8115287.0
      },
      {
        "periodo": 202601,
        "valor": 163566839.0,
        "delta": -9043531.0
      },
      {
        "periodo": 202602,
        "valor": 106830882.0,
        "delta": -56735957.0
      },
      {
        "periodo": 202603,
        "valor": 139164191.0,
        "delta": 32333309.0
      },
      {
        "periodo": 202604,
        "valor": 152634382.0,
        "delta": 13470191.0
      },
      {
        "periodo": 202605,
        "valor": 164969776.0,
        "delta": 12335394.0
      },
      {
        "periodo": 202606,
        "valor": 122622551.0,
        "delta": -42347225.0
      },
      {
        "periodo": 202607,
        "valor": 143456855.0,
        "delta": 20834304.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 430905088.0,
    "valor_anterior": 416752257.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 394497595.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 332663569.0,
        "delta": -61834026.0
      },
      {
        "periodo": 202509,
        "valor": 354016344.0,
        "delta": 21352775.0
      },
      {
        "periodo": 202510,
        "valor": 362941594.0,
        "delta": 8925250.0
      },
      {
        "periodo": 202511,
        "valor": 342223257.0,
        "delta": -20718337.0
      },
      {
        "periodo": 202512,
        "valor": 441583890.0,
        "delta": 99360633.0
      },
      {
        "periodo": 202601,
        "valor": 459243537.0,
        "delta": 17659647.0
      },
      {
        "periodo": 202602,
        "valor": 433027409.0,
        "delta": -26216128.0
      },
      {
        "periodo": 202603,
        "valor": 538086539.0,
        "delta": 105059130.0
      },
      {
        "periodo": 202604,
        "valor": 467759445.0,
        "delta": -70327094.0
      },
      {
        "periodo": 202605,
        "valor": 413099013.0,
        "delta": -54660432.0
      },
      {
        "periodo": 202606,
        "valor": 416752257.0,
        "delta": 3653244.0
      },
      {
        "periodo": 202607,
        "valor": 430905088.0,
        "delta": 14152831.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 215260829.98000002,
    "valor_anterior": 290953227.18000007,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 142025591.64,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 127834662.96,
        "delta": -14190928.68
      },
      {
        "periodo": 202509,
        "valor": 212525859.84,
        "delta": 84691196.88
      },
      {
        "periodo": 202510,
        "valor": 219651144.11,
        "delta": 7125284.27
      },
      {
        "periodo": 202511,
        "valor": 327316889.38,
        "delta": 107665745.27
      },
      {
        "periodo": 202512,
        "valor": 373083661.03,
        "delta": 45766771.65
      },
      {
        "periodo": 202601,
        "valor": 379043054.7,
        "delta": 5959393.67
      },
      {
        "periodo": 202602,
        "valor": 251733339.84,
        "delta": -127309714.86
      },
      {
        "periodo": 202603,
        "valor": 362032145.88,
        "delta": 110298806.04
      },
      {
        "periodo": 202604,
        "valor": 348740058.08,
        "delta": -13292087.8
      },
      {
        "periodo": 202605,
        "valor": 343662172.74,
        "delta": -5077885.34
      },
      {
        "periodo": 202606,
        "valor": 290953227.18,
        "delta": -52708945.56
      },
      {
        "periodo": 202607,
        "valor": 215260829.98,
        "delta": -75692397.2
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 318503499.0,
    "valor_anterior": 359182539.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 234144976.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 235669934.0,
        "delta": 1524958.0
      },
      {
        "periodo": 202509,
        "valor": 228812775.0,
        "delta": -6857159.0
      },
      {
        "periodo": 202510,
        "valor": 256018972.0,
        "delta": 27206197.0
      },
      {
        "periodo": 202511,
        "valor": 239136787.0,
        "delta": -16882185.0
      },
      {
        "periodo": 202512,
        "valor": 237590961.0,
        "delta": -1545826.0
      },
      {
        "periodo": 202601,
        "valor": 256679675.0,
        "delta": 19088714.0
      },
      {
        "periodo": 202602,
        "valor": 141319049.0,
        "delta": -115360626.0
      },
      {
        "periodo": 202603,
        "valor": 288533058.0,
        "delta": 147214009.0
      },
      {
        "periodo": 202604,
        "valor": 284667458.0,
        "delta": -3865600.0
      },
      {
        "periodo": 202605,
        "valor": 301126137.0,
        "delta": 16458679.0
      },
      {
        "periodo": 202606,
        "valor": 359182539.0,
        "delta": 58056402.0
      },
      {
        "periodo": 202607,
        "valor": 318503499.0,
        "delta": -40679040.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 1509668567.08,
    "valor_anterior": 871465117.960001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1496960924.11,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1652412688.87,
        "delta": 155451764.76
      },
      {
        "periodo": 202509,
        "valor": 924243390.59,
        "delta": -728169298.28
      },
      {
        "periodo": 202510,
        "valor": 1819511973.59,
        "delta": 895268583.0
      },
      {
        "periodo": 202511,
        "valor": 1039582133.3,
        "delta": -779929840.29
      },
      {
        "periodo": 202512,
        "valor": 706788925.68,
        "delta": -332793207.62
      },
      {
        "periodo": 202601,
        "valor": 1309537438.27,
        "delta": 602748512.59
      },
      {
        "periodo": 202602,
        "valor": 1240023516.98,
        "delta": -69513921.29
      },
      {
        "periodo": 202603,
        "valor": 3362435646.0,
        "delta": 2122412129.02
      },
      {
        "periodo": 202604,
        "valor": 2120396005.98,
        "delta": -1242039640.02
      },
      {
        "periodo": 202605,
        "valor": 1384980641.08,
        "delta": -735415364.9
      },
      {
        "periodo": 202606,
        "valor": 871465117.96,
        "delta": -513515523.12
      },
      {
        "periodo": 202607,
        "valor": 1509668567.08,
        "delta": 638203449.12
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 10900924.0,
    "valor_anterior": 10560565.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13466445.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14053041.0,
        "delta": 586596.0
      },
      {
        "periodo": 202509,
        "valor": 12518991.0,
        "delta": -1534050.0
      },
      {
        "periodo": 202510,
        "valor": 13210419.0,
        "delta": 691428.0
      },
      {
        "periodo": 202511,
        "valor": 553990.0,
        "delta": -12656429.0
      },
      {
        "periodo": 202512,
        "valor": 15452553.0,
        "delta": 14898563.0
      },
      {
        "periodo": 202601,
        "valor": 12202530.0,
        "delta": -3250023.0
      },
      {
        "periodo": 202602,
        "valor": 9554808.0,
        "delta": -2647722.0
      },
      {
        "periodo": 202603,
        "valor": 11927924.0,
        "delta": 2373116.0
      },
      {
        "periodo": 202604,
        "valor": 11494943.0,
        "delta": -432981.0
      },
      {
        "periodo": 202605,
        "valor": 11237732.0,
        "delta": -257211.0
      },
      {
        "periodo": 202606,
        "valor": 10560565.0,
        "delta": -677167.0
      },
      {
        "periodo": 202607,
        "valor": 10900924.0,
        "delta": 340359.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 5775425766.549995,
    "valor_anterior": 6222344317.370003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6365312847.12,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6031347990.0,
        "delta": -333964857.12
      },
      {
        "periodo": 202509,
        "valor": 5651258201.95,
        "delta": -380089788.05
      },
      {
        "periodo": 202510,
        "valor": 6090213433.46,
        "delta": 438955231.51
      },
      {
        "periodo": 202511,
        "valor": 6422728475.16,
        "delta": 332515041.7
      },
      {
        "periodo": 202512,
        "valor": 6844367044.79,
        "delta": 421638569.63
      },
      {
        "periodo": 202601,
        "valor": 5746475420.38,
        "delta": -1097891624.41
      },
      {
        "periodo": 202602,
        "valor": 5764746037.45,
        "delta": 18270617.07
      },
      {
        "periodo": 202603,
        "valor": 7544519943.9,
        "delta": 1779773906.45
      },
      {
        "periodo": 202604,
        "valor": 6756864695.56,
        "delta": -787655248.34
      },
      {
        "periodo": 202605,
        "valor": 5665045735.99,
        "delta": -1091818959.57
      },
      {
        "periodo": 202606,
        "valor": 6222344317.37,
        "delta": 557298581.38
      },
      {
        "periodo": 202607,
        "valor": 5775425766.55,
        "delta": -446918550.82
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 78097330.0,
    "valor_anterior": 61898195.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 60984838.35,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 56157917.11,
        "delta": -4826921.24
      },
      {
        "periodo": 202509,
        "valor": 108000924.72,
        "delta": 51843007.61
      },
      {
        "periodo": 202510,
        "valor": 135220805.0,
        "delta": 27219880.28
      },
      {
        "periodo": 202511,
        "valor": 62089552.0,
        "delta": -73131253.0
      },
      {
        "periodo": 202512,
        "valor": 118733078.0,
        "delta": 56643526.0
      },
      {
        "periodo": 202601,
        "valor": 93481495.0,
        "delta": -25251583.0
      },
      {
        "periodo": 202602,
        "valor": 69327348.0,
        "delta": -24154147.0
      },
      {
        "periodo": 202603,
        "valor": 65052021.0,
        "delta": -4275327.0
      },
      {
        "periodo": 202604,
        "valor": 37353496.0,
        "delta": -27698525.0
      },
      {
        "periodo": 202605,
        "valor": 36896085.0,
        "delta": -457411.0
      },
      {
        "periodo": 202606,
        "valor": 61898195.0,
        "delta": 25002110.0
      },
      {
        "periodo": 202607,
        "valor": 78097330.0,
        "delta": 16199135.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 43386094.0,
    "valor_anterior": 22915624.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1258009.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 39284957.0,
        "delta": 38026948.0
      },
      {
        "periodo": 202509,
        "valor": -46658503.0,
        "delta": -85943460.0
      },
      {
        "periodo": 202510,
        "valor": 71412150.0,
        "delta": 118070653.0
      },
      {
        "periodo": 202511,
        "valor": 11335308.0,
        "delta": -60076842.0
      },
      {
        "periodo": 202512,
        "valor": 34916667.0,
        "delta": 23581359.0
      },
      {
        "periodo": 202601,
        "valor": 43635319.0,
        "delta": 8718652.0
      },
      {
        "periodo": 202602,
        "valor": 41561595.0,
        "delta": -2073724.0
      },
      {
        "periodo": 202603,
        "valor": 13978621.0,
        "delta": -27582974.0
      },
      {
        "periodo": 202604,
        "valor": 13722325.0,
        "delta": -256296.0
      },
      {
        "periodo": 202605,
        "valor": 42878064.0,
        "delta": 29155739.0
      },
      {
        "periodo": 202606,
        "valor": 22915624.0,
        "delta": -19962440.0
      },
      {
        "periodo": 202607,
        "valor": 43386094.0,
        "delta": 20470470.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 1978047350.999998,
    "valor_anterior": 1884077784.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1916488529.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1972351943.0,
        "delta": 55863414.0
      },
      {
        "periodo": 202509,
        "valor": 1822365330.0,
        "delta": -149986613.0
      },
      {
        "periodo": 202510,
        "valor": 1833319632.0,
        "delta": 10954302.0
      },
      {
        "periodo": 202511,
        "valor": 1987276639.0,
        "delta": 153957007.0
      },
      {
        "periodo": 202512,
        "valor": 1996160403.0,
        "delta": 8883764.0
      },
      {
        "periodo": 202601,
        "valor": 2022695079.0,
        "delta": 26534676.0
      },
      {
        "periodo": 202602,
        "valor": 1781948086.0,
        "delta": -240746993.0
      },
      {
        "periodo": 202603,
        "valor": 1956098325.0,
        "delta": 174150239.0
      },
      {
        "periodo": 202604,
        "valor": 1851884954.0,
        "delta": -104213371.0
      },
      {
        "periodo": 202605,
        "valor": 1951532703.0,
        "delta": 99647749.0
      },
      {
        "periodo": 202606,
        "valor": 1884077784.0,
        "delta": -67454919.0
      },
      {
        "periodo": 202607,
        "valor": 1978047351.0,
        "delta": 93969567.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 423243214.0,
    "valor_anterior": 450630748.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 345948017.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 350017087.0,
        "delta": 4069070.0
      },
      {
        "periodo": 202509,
        "valor": 287146411.0,
        "delta": -62870676.0
      },
      {
        "periodo": 202510,
        "valor": 358329668.0,
        "delta": 71183257.0
      },
      {
        "periodo": 202511,
        "valor": 432303960.0,
        "delta": 73974292.0
      },
      {
        "periodo": 202512,
        "valor": 371487626.0,
        "delta": -60816334.0
      },
      {
        "periodo": 202601,
        "valor": 463235182.0,
        "delta": 91747556.0
      },
      {
        "periodo": 202602,
        "valor": 379592263.0,
        "delta": -83642919.0
      },
      {
        "periodo": 202603,
        "valor": 529400953.0,
        "delta": 149808690.0
      },
      {
        "periodo": 202604,
        "valor": 280424679.0,
        "delta": -248976274.0
      },
      {
        "periodo": 202605,
        "valor": 486861122.0,
        "delta": 206436443.0
      },
      {
        "periodo": 202606,
        "valor": 450630748.0,
        "delta": -36230374.0
      },
      {
        "periodo": 202607,
        "valor": 423243214.0,
        "delta": -27387534.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 135674792.0,
    "valor_anterior": 100139071.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 177922761.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 114570046.0,
        "delta": -63352715.0
      },
      {
        "periodo": 202509,
        "valor": 148419279.0,
        "delta": 33849233.0
      },
      {
        "periodo": 202510,
        "valor": 200125200.0,
        "delta": 51705921.0
      },
      {
        "periodo": 202511,
        "valor": 107126716.0,
        "delta": -92998484.0
      },
      {
        "periodo": 202512,
        "valor": 103875252.0,
        "delta": -3251464.0
      },
      {
        "periodo": 202601,
        "valor": 59838991.0,
        "delta": -44036261.0
      },
      {
        "periodo": 202602,
        "valor": 128088215.0,
        "delta": 68249224.0
      },
      {
        "periodo": 202603,
        "valor": 209211587.0,
        "delta": 81123372.0
      },
      {
        "periodo": 202604,
        "valor": 119907958.0,
        "delta": -89303629.0
      },
      {
        "periodo": 202605,
        "valor": 162118793.0,
        "delta": 42210835.0
      },
      {
        "periodo": 202606,
        "valor": 100139071.0,
        "delta": -61979722.0
      },
      {
        "periodo": 202607,
        "valor": 135674792.0,
        "delta": 35535721.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": -90223774.0,
    "valor_anterior": 153710897.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 243315204.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 110745697.0,
        "delta": -132569507.0
      },
      {
        "periodo": 202509,
        "valor": 103190698.0,
        "delta": -7554999.0
      },
      {
        "periodo": 202510,
        "valor": -15304826.0,
        "delta": -118495524.0
      },
      {
        "periodo": 202511,
        "valor": 120594318.0,
        "delta": 135899144.0
      },
      {
        "periodo": 202512,
        "valor": 47302732.0,
        "delta": -73291586.0
      },
      {
        "periodo": 202601,
        "valor": 79080474.0,
        "delta": 31777742.0
      },
      {
        "periodo": 202602,
        "valor": 64229564.0,
        "delta": -14850910.0
      },
      {
        "periodo": 202603,
        "valor": 307138493.0,
        "delta": 242908929.0
      },
      {
        "periodo": 202604,
        "valor": 14341539.0,
        "delta": -292796954.0
      },
      {
        "periodo": 202605,
        "valor": 12445538.0,
        "delta": -1896001.0
      },
      {
        "periodo": 202606,
        "valor": 153710897.0,
        "delta": 141265359.0
      },
      {
        "periodo": 202607,
        "valor": -90223774.0,
        "delta": -243934671.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 1223634461.1899996,
    "valor_anterior": 1545634674.96,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1177013028.86,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 871233564.94,
        "delta": -305779463.92
      },
      {
        "periodo": 202509,
        "valor": 1060183073.17,
        "delta": 188949508.23
      },
      {
        "periodo": 202510,
        "valor": 1230480694.36,
        "delta": 170297621.19
      },
      {
        "periodo": 202511,
        "valor": 1136281147.33,
        "delta": -94199547.03
      },
      {
        "periodo": 202512,
        "valor": 1335640958.26,
        "delta": 199359810.93
      },
      {
        "periodo": 202601,
        "valor": 518114468.05,
        "delta": -817526490.21
      },
      {
        "periodo": 202602,
        "valor": 1057990901.25,
        "delta": 539876433.2
      },
      {
        "periodo": 202603,
        "valor": 1115505403.68,
        "delta": 57514502.43
      },
      {
        "periodo": 202604,
        "valor": 980080763.75,
        "delta": -135424639.93
      },
      {
        "periodo": 202605,
        "valor": 1222712546.33,
        "delta": 242631782.58
      },
      {
        "periodo": 202606,
        "valor": 1545634674.96,
        "delta": 322922128.63
      },
      {
        "periodo": 202607,
        "valor": 1223634461.19,
        "delta": -322000213.77
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": -13620967.0,
    "valor_anterior": -14097594.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -31747201.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -20357943.0,
        "delta": 11389258.0
      },
      {
        "periodo": 202509,
        "valor": -38323602.0,
        "delta": -17965659.0
      },
      {
        "periodo": 202510,
        "valor": -28465245.0,
        "delta": 9858357.0
      },
      {
        "periodo": 202511,
        "valor": -31646384.0,
        "delta": -3181139.0
      },
      {
        "periodo": 202512,
        "valor": -21849713.0,
        "delta": 9796671.0
      },
      {
        "periodo": 202601,
        "valor": -20396274.0,
        "delta": 1453439.0
      },
      {
        "periodo": 202602,
        "valor": -43710330.0,
        "delta": -23314056.0
      },
      {
        "periodo": 202603,
        "valor": -42309406.0,
        "delta": 1400924.0
      },
      {
        "periodo": 202604,
        "valor": -18726504.0,
        "delta": 23582902.0
      },
      {
        "periodo": 202605,
        "valor": -13129573.0,
        "delta": 5596931.0
      },
      {
        "periodo": 202606,
        "valor": -14097594.0,
        "delta": -968021.0
      },
      {
        "periodo": 202607,
        "valor": -13620967.0,
        "delta": 476627.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 12427670.0,
    "valor_anterior": 16792827.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7558109.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5483722.0,
        "delta": -2074387.0
      },
      {
        "periodo": 202509,
        "valor": 295799.0,
        "delta": -5187923.0
      },
      {
        "periodo": 202510,
        "valor": -4071849.0,
        "delta": -4367648.0
      },
      {
        "periodo": 202511,
        "valor": 12278424.0,
        "delta": 16350273.0
      },
      {
        "periodo": 202512,
        "valor": 17785851.0,
        "delta": 5507427.0
      },
      {
        "periodo": 202601,
        "valor": 10552155.0,
        "delta": -7233696.0
      },
      {
        "periodo": 202602,
        "valor": 4473481.0,
        "delta": -6078674.0
      },
      {
        "periodo": 202603,
        "valor": 10243322.0,
        "delta": 5769841.0
      },
      {
        "periodo": 202604,
        "valor": 10223621.0,
        "delta": -19701.0
      },
      {
        "periodo": 202605,
        "valor": 14853128.0,
        "delta": 4629507.0
      },
      {
        "periodo": 202606,
        "valor": 16792827.0,
        "delta": 1939699.0
      },
      {
        "periodo": 202607,
        "valor": 12427670.0,
        "delta": -4365157.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 439854364.0,
    "valor_anterior": 500075249.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 391390378.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 421208924.0,
        "delta": 29818546.0
      },
      {
        "periodo": 202509,
        "valor": 440239900.0,
        "delta": 19030976.0
      },
      {
        "periodo": 202510,
        "valor": 437155347.0,
        "delta": -3084553.0
      },
      {
        "periodo": 202511,
        "valor": 481660774.0,
        "delta": 44505427.0
      },
      {
        "periodo": 202512,
        "valor": 456519120.0,
        "delta": -25141654.0
      },
      {
        "periodo": 202601,
        "valor": 455876671.0,
        "delta": -642449.0
      },
      {
        "periodo": 202602,
        "valor": 407219466.0,
        "delta": -48657205.0
      },
      {
        "periodo": 202603,
        "valor": 528818750.0,
        "delta": 121599284.0
      },
      {
        "periodo": 202604,
        "valor": 464344905.0,
        "delta": -64473845.0
      },
      {
        "periodo": 202605,
        "valor": 486653586.0,
        "delta": 22308681.0
      },
      {
        "periodo": 202606,
        "valor": 500075249.0,
        "delta": 13421663.0
      },
      {
        "periodo": 202607,
        "valor": 439854364.0,
        "delta": -60220885.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 47243478.0,
    "valor_anterior": 84864342.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 72181264.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26430817.0,
        "delta": -45750447.0
      },
      {
        "periodo": 202509,
        "valor": 101758816.0,
        "delta": 75327999.0
      },
      {
        "periodo": 202510,
        "valor": 50757256.0,
        "delta": -51001560.0
      },
      {
        "periodo": 202511,
        "valor": 25366316.0,
        "delta": -25390940.0
      },
      {
        "periodo": 202512,
        "valor": -61793861.0,
        "delta": -87160177.0
      },
      {
        "periodo": 202601,
        "valor": 19573997.0,
        "delta": 81367858.0
      },
      {
        "periodo": 202602,
        "valor": 68515396.0,
        "delta": 48941399.0
      },
      {
        "periodo": 202603,
        "valor": 62036731.0,
        "delta": -6478665.0
      },
      {
        "periodo": 202604,
        "valor": 60135577.0,
        "delta": -1901154.0
      },
      {
        "periodo": 202605,
        "valor": 19499457.0,
        "delta": -40636120.0
      },
      {
        "periodo": 202606,
        "valor": 84864342.0,
        "delta": 65364885.0
      },
      {
        "periodo": 202607,
        "valor": 47243478.0,
        "delta": -37620864.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 141784969.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 125154661.0,
        "delta": -16630308.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 169654256.0,
    "valor_anterior": 133776765.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 136704344.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 167926226.0,
        "delta": 31221882.0
      },
      {
        "periodo": 202509,
        "valor": 125645149.0,
        "delta": -42281077.0
      },
      {
        "periodo": 202510,
        "valor": 186874301.0,
        "delta": 61229152.0
      },
      {
        "periodo": 202511,
        "valor": 84264111.0,
        "delta": -102610190.0
      },
      {
        "periodo": 202512,
        "valor": 259403252.0,
        "delta": 175139141.0
      },
      {
        "periodo": 202601,
        "valor": 153209001.0,
        "delta": -106194251.0
      },
      {
        "periodo": 202602,
        "valor": 77644179.0,
        "delta": -75564822.0
      },
      {
        "periodo": 202603,
        "valor": 162294243.0,
        "delta": 84650064.0
      },
      {
        "periodo": 202604,
        "valor": 192548078.0,
        "delta": 30253835.0
      },
      {
        "periodo": 202605,
        "valor": 47138985.0,
        "delta": -145409093.0
      },
      {
        "periodo": 202606,
        "valor": 133776765.0,
        "delta": 86637780.0
      },
      {
        "periodo": 202607,
        "valor": 169654256.0,
        "delta": 35877491.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 159138921.0,
    "valor_anterior": 166834307.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 111091382.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 100940718.0,
        "delta": -10150664.0
      },
      {
        "periodo": 202509,
        "valor": 110461772.0,
        "delta": 9521054.0
      },
      {
        "periodo": 202510,
        "valor": 109671610.0,
        "delta": -790162.0
      },
      {
        "periodo": 202511,
        "valor": 111158888.0,
        "delta": 1487278.0
      },
      {
        "periodo": 202512,
        "valor": 124350804.0,
        "delta": 13191916.0
      },
      {
        "periodo": 202601,
        "valor": 143411182.0,
        "delta": 19060378.0
      },
      {
        "periodo": 202602,
        "valor": 109589246.0,
        "delta": -33821936.0
      },
      {
        "periodo": 202603,
        "valor": 142542698.0,
        "delta": 32953452.0
      },
      {
        "periodo": 202604,
        "valor": 153600486.0,
        "delta": 11057788.0
      },
      {
        "periodo": 202605,
        "valor": 153902264.0,
        "delta": 301778.0
      },
      {
        "periodo": 202606,
        "valor": 166834307.0,
        "delta": 12932043.0
      },
      {
        "periodo": 202607,
        "valor": 159138921.0,
        "delta": -7695386.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 8378319.0,
    "valor_anterior": 9338693.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1430434.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2614216.0,
        "delta": 1183782.0
      },
      {
        "periodo": 202509,
        "valor": 3919941.0,
        "delta": 1305725.0
      },
      {
        "periodo": 202510,
        "valor": 3048750.0,
        "delta": -871191.0
      },
      {
        "periodo": 202511,
        "valor": 4883213.0,
        "delta": 1834463.0
      },
      {
        "periodo": 202512,
        "valor": 5979549.0,
        "delta": 1096336.0
      },
      {
        "periodo": 202601,
        "valor": 6363333.0,
        "delta": 383784.0
      },
      {
        "periodo": 202602,
        "valor": 5559750.0,
        "delta": -803583.0
      },
      {
        "periodo": 202603,
        "valor": 5683625.0,
        "delta": 123875.0
      },
      {
        "periodo": 202604,
        "valor": 4816481.0,
        "delta": -867144.0
      },
      {
        "periodo": 202605,
        "valor": 5354743.0,
        "delta": 538262.0
      },
      {
        "periodo": 202606,
        "valor": 9338693.0,
        "delta": 3983950.0
      },
      {
        "periodo": 202607,
        "valor": 8378319.0,
        "delta": -960374.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 19229753.0,
    "valor_anterior": 19121943.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14764581.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16528922.0,
        "delta": 1764341.0
      },
      {
        "periodo": 202509,
        "valor": 14613570.0,
        "delta": -1915352.0
      },
      {
        "periodo": 202510,
        "valor": 17923070.0,
        "delta": 3309500.0
      },
      {
        "periodo": 202511,
        "valor": 18940521.0,
        "delta": 1017451.0
      },
      {
        "periodo": 202512,
        "valor": 25833093.0,
        "delta": 6892572.0
      },
      {
        "periodo": 202601,
        "valor": 20974117.0,
        "delta": -4858976.0
      },
      {
        "periodo": 202602,
        "valor": 19519972.0,
        "delta": -1454145.0
      },
      {
        "periodo": 202603,
        "valor": 23072073.0,
        "delta": 3552101.0
      },
      {
        "periodo": 202604,
        "valor": 21614638.0,
        "delta": -1457435.0
      },
      {
        "periodo": 202605,
        "valor": 19848114.0,
        "delta": -1766524.0
      },
      {
        "periodo": 202606,
        "valor": 19121943.0,
        "delta": -726171.0
      },
      {
        "periodo": 202607,
        "valor": 19229753.0,
        "delta": 107810.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 63354479.23000002,
    "valor_anterior": 42374181.03,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21502728.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 38809961.56,
        "delta": 17307233.37
      },
      {
        "periodo": 202509,
        "valor": 47504317.75,
        "delta": 8694356.19
      },
      {
        "periodo": 202510,
        "valor": 42524842.54,
        "delta": -4979475.21
      },
      {
        "periodo": 202511,
        "valor": 41616420.47,
        "delta": -908422.07
      },
      {
        "periodo": 202512,
        "valor": 40353480.2,
        "delta": -1262940.27
      },
      {
        "periodo": 202601,
        "valor": 48965696.5,
        "delta": 8612216.3
      },
      {
        "periodo": 202602,
        "valor": 36088711.42,
        "delta": -12876985.08
      },
      {
        "periodo": 202603,
        "valor": 51093609.09,
        "delta": 15004897.67
      },
      {
        "periodo": 202604,
        "valor": 46069314.96,
        "delta": -5024294.13
      },
      {
        "periodo": 202605,
        "valor": 47498350.43,
        "delta": 1429035.47
      },
      {
        "periodo": 202606,
        "valor": 42374181.03,
        "delta": -5124169.4
      },
      {
        "periodo": 202607,
        "valor": 63354479.23,
        "delta": 20980298.2
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 8665363.0,
    "valor_anterior": 8732330.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8747857.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9266124.0,
        "delta": 518267.0
      },
      {
        "periodo": 202509,
        "valor": 8204056.0,
        "delta": -1062068.0
      },
      {
        "periodo": 202510,
        "valor": 11671595.0,
        "delta": 3467539.0
      },
      {
        "periodo": 202511,
        "valor": 9770029.0,
        "delta": -1901566.0
      },
      {
        "periodo": 202512,
        "valor": 11045255.0,
        "delta": 1275226.0
      },
      {
        "periodo": 202601,
        "valor": 10235567.0,
        "delta": -809688.0
      },
      {
        "periodo": 202602,
        "valor": 7220514.0,
        "delta": -3015053.0
      },
      {
        "periodo": 202603,
        "valor": 8156144.0,
        "delta": 935630.0
      },
      {
        "periodo": 202604,
        "valor": 8191515.0,
        "delta": 35371.0
      },
      {
        "periodo": 202605,
        "valor": 8853884.0,
        "delta": 662369.0
      },
      {
        "periodo": 202606,
        "valor": 8732330.0,
        "delta": -121554.0
      },
      {
        "periodo": 202607,
        "valor": 8665363.0,
        "delta": -66967.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 214210276.17000008,
    "valor_anterior": 144022782.24999988,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 207486661.92,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 204850299.63,
        "delta": -2636362.29
      },
      {
        "periodo": 202509,
        "valor": 58402380.52,
        "delta": -146447919.11
      },
      {
        "periodo": 202510,
        "valor": 190805642.44,
        "delta": 132403261.92
      },
      {
        "periodo": 202511,
        "valor": 208206824.51,
        "delta": 17401182.07
      },
      {
        "periodo": 202512,
        "valor": 185113912.27,
        "delta": -23092912.24
      },
      {
        "periodo": 202601,
        "valor": 222178735.72,
        "delta": 37064823.45
      },
      {
        "periodo": 202602,
        "valor": 197663937.5,
        "delta": -24514798.22
      },
      {
        "periodo": 202603,
        "valor": 98098145.51,
        "delta": -99565791.99
      },
      {
        "periodo": 202604,
        "valor": 209295747.59,
        "delta": 111197602.08
      },
      {
        "periodo": 202605,
        "valor": 221476205.25,
        "delta": 12180457.66
      },
      {
        "periodo": 202606,
        "valor": 144022782.25,
        "delta": -77453423.0
      },
      {
        "periodo": 202607,
        "valor": 214210276.17,
        "delta": 70187493.92
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 62010184.70000005,
    "valor_anterior": 62436454.389999986,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 47061557.59,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 43198426.8,
        "delta": -3863130.79
      },
      {
        "periodo": 202509,
        "valor": 36980512.71,
        "delta": -6217914.09
      },
      {
        "periodo": 202510,
        "valor": 47047625.16,
        "delta": 10067112.45
      },
      {
        "periodo": 202511,
        "valor": 44781854.65,
        "delta": -2265770.51
      },
      {
        "periodo": 202512,
        "valor": 36065412.8,
        "delta": -8716441.85
      },
      {
        "periodo": 202601,
        "valor": 53173729.75,
        "delta": 17108316.95
      },
      {
        "periodo": 202602,
        "valor": 54675703.41,
        "delta": 1501973.66
      },
      {
        "periodo": 202603,
        "valor": 58554182.68,
        "delta": 3878479.27
      },
      {
        "periodo": 202604,
        "valor": 55257362.27,
        "delta": -3296820.41
      },
      {
        "periodo": 202605,
        "valor": 49258707.03,
        "delta": -5998655.24
      },
      {
        "periodo": 202606,
        "valor": 62436454.39,
        "delta": 13177747.36
      },
      {
        "periodo": 202607,
        "valor": 62010184.7,
        "delta": -426269.69
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 5498771.0,
    "valor_anterior": 33378060.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 37624161.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 41560264.0,
        "delta": 3936103.0
      },
      {
        "periodo": 202509,
        "valor": 52643442.0,
        "delta": 11083178.0
      },
      {
        "periodo": 202510,
        "valor": 41474794.0,
        "delta": -11168648.0
      },
      {
        "periodo": 202511,
        "valor": 38152697.0,
        "delta": -3322097.0
      },
      {
        "periodo": 202512,
        "valor": 41819111.0,
        "delta": 3666414.0
      },
      {
        "periodo": 202601,
        "valor": 50475502.0,
        "delta": 8656391.0
      },
      {
        "periodo": 202602,
        "valor": 45100485.0,
        "delta": -5375017.0
      },
      {
        "periodo": 202603,
        "valor": -989354.0,
        "delta": -46089839.0
      },
      {
        "periodo": 202604,
        "valor": -3579301.0,
        "delta": -2589947.0
      },
      {
        "periodo": 202605,
        "valor": 47133386.0,
        "delta": 50712687.0
      },
      {
        "periodo": 202606,
        "valor": 33378060.0,
        "delta": -13755326.0
      },
      {
        "periodo": 202607,
        "valor": 5498771.0,
        "delta": -27879289.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 311587342.0,
    "valor_anterior": 367138227.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 316507923.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 430464057.0,
        "delta": 113956134.0
      },
      {
        "periodo": 202509,
        "valor": 302948632.0,
        "delta": -127515425.0
      },
      {
        "periodo": 202510,
        "valor": 316580718.0,
        "delta": 13632086.0
      },
      {
        "periodo": 202511,
        "valor": 323871193.0,
        "delta": 7290475.0
      },
      {
        "periodo": 202512,
        "valor": 143055862.0,
        "delta": -180815331.0
      },
      {
        "periodo": 202601,
        "valor": 260299287.0,
        "delta": 117243425.0
      },
      {
        "periodo": 202602,
        "valor": 268166773.0,
        "delta": 7867486.0
      },
      {
        "periodo": 202603,
        "valor": 295034928.0,
        "delta": 26868155.0
      },
      {
        "periodo": 202604,
        "valor": 311885327.0,
        "delta": 16850399.0
      },
      {
        "periodo": 202605,
        "valor": 342744165.0,
        "delta": 30858838.0
      },
      {
        "periodo": 202606,
        "valor": 367138227.0,
        "delta": 24394062.0
      },
      {
        "periodo": 202607,
        "valor": 311587342.0,
        "delta": -55550885.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 23126586.0,
    "valor_anterior": 21844407.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19720082.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26716408.0,
        "delta": 6996326.0
      },
      {
        "periodo": 202509,
        "valor": 19033549.0,
        "delta": -7682859.0
      },
      {
        "periodo": 202510,
        "valor": 30047720.0,
        "delta": 11014171.0
      },
      {
        "periodo": 202511,
        "valor": 17369778.0,
        "delta": -12677942.0
      },
      {
        "periodo": 202512,
        "valor": 17561379.0,
        "delta": 191601.0
      },
      {
        "periodo": 202601,
        "valor": 8712059.0,
        "delta": -8849320.0
      },
      {
        "periodo": 202602,
        "valor": 17379974.0,
        "delta": 8667915.0
      },
      {
        "periodo": 202603,
        "valor": 35426638.0,
        "delta": 18046664.0
      },
      {
        "periodo": 202604,
        "valor": 20388089.0,
        "delta": -15038549.0
      },
      {
        "periodo": 202605,
        "valor": 22599134.0,
        "delta": 2211045.0
      },
      {
        "periodo": 202606,
        "valor": 21844407.0,
        "delta": -754727.0
      },
      {
        "periodo": 202607,
        "valor": 23126586.0,
        "delta": 1282179.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 42428199.129999995,
    "valor_anterior": 42902440.54000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 42072842.44,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 44450303.02,
        "delta": 2377460.58
      },
      {
        "periodo": 202509,
        "valor": 43397857.95,
        "delta": -1052445.07
      },
      {
        "periodo": 202510,
        "valor": 44318946.37,
        "delta": 921088.42
      },
      {
        "periodo": 202511,
        "valor": 60287374.52,
        "delta": 15968428.15
      },
      {
        "periodo": 202512,
        "valor": 36206162.95,
        "delta": -24081211.57
      },
      {
        "periodo": 202601,
        "valor": 38154716.4,
        "delta": 1948553.45
      },
      {
        "periodo": 202602,
        "valor": 33641454.69,
        "delta": -4513261.71
      },
      {
        "periodo": 202603,
        "valor": 38445449.62,
        "delta": 4803994.93
      },
      {
        "periodo": 202604,
        "valor": 22790507.74,
        "delta": -15654941.88
      },
      {
        "periodo": 202605,
        "valor": 42415844.09,
        "delta": 19625336.35
      },
      {
        "periodo": 202606,
        "valor": 42902440.54,
        "delta": 486596.45
      },
      {
        "periodo": 202607,
        "valor": 42428199.13,
        "delta": -474241.41
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 18350690.36,
    "valor_anterior": 15230208.420000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27161523.75,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6747849.72,
        "delta": -20413674.03
      },
      {
        "periodo": 202509,
        "valor": 60189707.5,
        "delta": 53441857.78
      },
      {
        "periodo": 202510,
        "valor": 24485462.4,
        "delta": -35704245.1
      },
      {
        "periodo": 202511,
        "valor": 13809118.21,
        "delta": -10676344.19
      },
      {
        "periodo": 202512,
        "valor": 17807170.37,
        "delta": 3998052.16
      },
      {
        "periodo": 202601,
        "valor": 14219174.68,
        "delta": -3587995.69
      },
      {
        "periodo": 202602,
        "valor": 14563891.83,
        "delta": 344717.15
      },
      {
        "periodo": 202603,
        "valor": 26123371.26,
        "delta": 11559479.43
      },
      {
        "periodo": 202604,
        "valor": 14795984.61,
        "delta": -11327386.65
      },
      {
        "periodo": 202605,
        "valor": 18880565.1,
        "delta": 4084580.49
      },
      {
        "periodo": 202606,
        "valor": 15230208.42,
        "delta": -3650356.68
      },
      {
        "periodo": 202607,
        "valor": 18350690.36,
        "delta": 3120481.94
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 22542023.0,
    "valor_anterior": 25201413.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28203677.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24839718.0,
        "delta": -3363959.0
      },
      {
        "periodo": 202509,
        "valor": 28608199.0,
        "delta": 3768481.0
      },
      {
        "periodo": 202510,
        "valor": 26137659.0,
        "delta": -2470540.0
      },
      {
        "periodo": 202511,
        "valor": 23864534.0,
        "delta": -2273125.0
      },
      {
        "periodo": 202512,
        "valor": 35676460.0,
        "delta": 11811926.0
      },
      {
        "periodo": 202601,
        "valor": 24077749.0,
        "delta": -11598711.0
      },
      {
        "periodo": 202602,
        "valor": 23096012.0,
        "delta": -981737.0
      },
      {
        "periodo": 202603,
        "valor": 24306621.0,
        "delta": 1210609.0
      },
      {
        "periodo": 202604,
        "valor": 24154472.0,
        "delta": -152149.0
      },
      {
        "periodo": 202605,
        "valor": 26802195.0,
        "delta": 2647723.0
      },
      {
        "periodo": 202606,
        "valor": 25201413.0,
        "delta": -1600782.0
      },
      {
        "periodo": 202607,
        "valor": 22542023.0,
        "delta": -2659390.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 17634332.0,
    "valor_anterior": 16407188.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16505490.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17400140.0,
        "delta": 894650.0
      },
      {
        "periodo": 202509,
        "valor": 16435844.0,
        "delta": -964296.0
      },
      {
        "periodo": 202510,
        "valor": 17217796.0,
        "delta": 781952.0
      },
      {
        "periodo": 202511,
        "valor": 13329140.0,
        "delta": -3888656.0
      },
      {
        "periodo": 202512,
        "valor": 17773954.0,
        "delta": 4444814.0
      },
      {
        "periodo": 202601,
        "valor": 18671141.0,
        "delta": 897187.0
      },
      {
        "periodo": 202602,
        "valor": 15190964.0,
        "delta": -3480177.0
      },
      {
        "periodo": 202603,
        "valor": 16450069.0,
        "delta": 1259105.0
      },
      {
        "periodo": 202604,
        "valor": 14580061.0,
        "delta": -1870008.0
      },
      {
        "periodo": 202605,
        "valor": 19040190.0,
        "delta": 4460129.0
      },
      {
        "periodo": 202606,
        "valor": 16407188.0,
        "delta": -2633002.0
      },
      {
        "periodo": 202607,
        "valor": 17634332.0,
        "delta": 1227144.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 54943417.0,
    "valor_anterior": 65455204.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 41509607.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 53093924.0,
        "delta": 11584317.0
      },
      {
        "periodo": 202509,
        "valor": 42171077.0,
        "delta": -10922847.0
      },
      {
        "periodo": 202510,
        "valor": 45717501.0,
        "delta": 3546424.0
      },
      {
        "periodo": 202511,
        "valor": 49133855.0,
        "delta": 3416354.0
      },
      {
        "periodo": 202512,
        "valor": 55307799.0,
        "delta": 6173944.0
      },
      {
        "periodo": 202601,
        "valor": 55511414.0,
        "delta": 203615.0
      },
      {
        "periodo": 202602,
        "valor": 55761341.0,
        "delta": 249927.0
      },
      {
        "periodo": 202603,
        "valor": 57452394.0,
        "delta": 1691053.0
      },
      {
        "periodo": 202604,
        "valor": 50690769.0,
        "delta": -6761625.0
      },
      {
        "periodo": 202605,
        "valor": 50481388.0,
        "delta": -209381.0
      },
      {
        "periodo": 202606,
        "valor": 65455204.0,
        "delta": 14973816.0
      },
      {
        "periodo": 202607,
        "valor": 54943417.0,
        "delta": -10511787.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 5373566.300000001,
    "valor_anterior": 5125187.650000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6784902.32,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4818346.76,
        "delta": -1966555.56
      },
      {
        "periodo": 202509,
        "valor": 4434001.72,
        "delta": -384345.04
      },
      {
        "periodo": 202510,
        "valor": 5413547.7,
        "delta": 979545.98
      },
      {
        "periodo": 202511,
        "valor": 5390400.57,
        "delta": -23147.13
      },
      {
        "periodo": 202512,
        "valor": 5637329.69,
        "delta": 246929.12
      },
      {
        "periodo": 202601,
        "valor": 5922015.43,
        "delta": 284685.74
      },
      {
        "periodo": 202602,
        "valor": 5314367.28,
        "delta": -607648.15
      },
      {
        "periodo": 202603,
        "valor": 5923218.0,
        "delta": 608850.72
      },
      {
        "periodo": 202604,
        "valor": 5406086.01,
        "delta": -517131.99
      },
      {
        "periodo": 202605,
        "valor": 5446693.0,
        "delta": 40606.99
      },
      {
        "periodo": 202606,
        "valor": 5125187.65,
        "delta": -321505.35
      },
      {
        "periodo": 202607,
        "valor": 5373566.3,
        "delta": 248378.65
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 52340870.67999998,
    "valor_anterior": 57843291.71000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10664276.37,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10414962.21,
        "delta": -249314.16
      },
      {
        "periodo": 202509,
        "valor": 9985303.91,
        "delta": -429658.3
      },
      {
        "periodo": 202510,
        "valor": 10061013.84,
        "delta": 75709.93
      },
      {
        "periodo": 202511,
        "valor": 9474081.76,
        "delta": -586932.08
      },
      {
        "periodo": 202512,
        "valor": 9627389.49,
        "delta": 153307.73
      },
      {
        "periodo": 202601,
        "valor": 9472623.13,
        "delta": -154766.36
      },
      {
        "periodo": 202602,
        "valor": 45486691.04,
        "delta": 36014067.91
      },
      {
        "periodo": 202603,
        "valor": 56161471.73,
        "delta": 10674780.69
      },
      {
        "periodo": 202604,
        "valor": 28331778.96,
        "delta": -27829692.77
      },
      {
        "periodo": 202605,
        "valor": 63229709.2,
        "delta": 34897930.24
      },
      {
        "periodo": 202606,
        "valor": 57843291.71,
        "delta": -5386417.49
      },
      {
        "periodo": 202607,
        "valor": 52340870.68,
        "delta": -5502421.03
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": -35165783.0,
    "valor_anterior": -35207758.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1740863.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -9643543.0,
        "delta": -7902680.0
      },
      {
        "periodo": 202509,
        "valor": -17822783.0,
        "delta": -8179240.0
      },
      {
        "periodo": 202510,
        "valor": -25936725.0,
        "delta": -8113942.0
      },
      {
        "periodo": 202511,
        "valor": -37627680.0,
        "delta": -11690955.0
      },
      {
        "periodo": 202512,
        "valor": -44880648.0,
        "delta": -7252968.0
      },
      {
        "periodo": 202601,
        "valor": -44131617.0,
        "delta": 749031.0
      },
      {
        "periodo": 202602,
        "valor": -31212807.0,
        "delta": 12918810.0
      },
      {
        "periodo": 202603,
        "valor": -17149694.0,
        "delta": 14063113.0
      },
      {
        "periodo": 202604,
        "valor": -27518139.0,
        "delta": -10368445.0
      },
      {
        "periodo": 202605,
        "valor": -33709126.0,
        "delta": -6190987.0
      },
      {
        "periodo": 202606,
        "valor": -35207758.0,
        "delta": -1498632.0
      },
      {
        "periodo": 202607,
        "valor": -35165783.0,
        "delta": 41975.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": -25491702.090000004,
    "valor_anterior": -24745560.049999997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 30935831.57,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 6376339.18,
        "delta": -24559492.39
      },
      {
        "periodo": 202601,
        "valor": 3445469.04,
        "delta": -2930870.14
      },
      {
        "periodo": 202602,
        "valor": -11215995.1,
        "delta": -14661464.14
      },
      {
        "periodo": 202603,
        "valor": -18363226.59,
        "delta": -7147231.49
      },
      {
        "periodo": 202604,
        "valor": -20797953.77,
        "delta": -2434727.18
      },
      {
        "periodo": 202605,
        "valor": -3819492.17,
        "delta": 16978461.6
      },
      {
        "periodo": 202606,
        "valor": -24745560.05,
        "delta": -20926067.88
      },
      {
        "periodo": 202607,
        "valor": -25491702.09,
        "delta": -746142.04
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 450059351.0,
    "valor_anterior": 321102550.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 816410312.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 430398792.0,
        "delta": -386011520.0
      },
      {
        "periodo": 202605,
        "valor": 392914384.0,
        "delta": -37484408.0
      },
      {
        "periodo": 202606,
        "valor": 321102550.0,
        "delta": -71811834.0
      },
      {
        "periodo": 202607,
        "valor": 450059351.0,
        "delta": 128956801.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 62869787518.869934,
    "valor_anterior": 60909143072.73004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 60718374355.94,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 60521692994.61,
        "delta": -196681361.33
      },
      {
        "periodo": 202509,
        "valor": 53968045934.68,
        "delta": -6553647059.93
      },
      {
        "periodo": 202510,
        "valor": 58929741267.33,
        "delta": 4961695332.65
      },
      {
        "periodo": 202511,
        "valor": 59362781191.2001,
        "delta": 433039923.8701
      },
      {
        "periodo": 202512,
        "valor": 63792417068.88,
        "delta": 4429635877.6799
      },
      {
        "periodo": 202601,
        "valor": 62204598322.2,
        "delta": -1587818746.68
      },
      {
        "periodo": 202602,
        "valor": 53363972406.3,
        "delta": -8840625915.9
      },
      {
        "periodo": 202603,
        "valor": 64780837770.98,
        "delta": 11416865364.68
      },
      {
        "periodo": 202604,
        "valor": 64132164438.24,
        "delta": -648673332.74
      },
      {
        "periodo": 202605,
        "valor": 59646216966.1,
        "delta": -4485947472.14
      },
      {
        "periodo": 202606,
        "valor": 60909143072.73,
        "delta": 1262926106.63
      },
      {
        "periodo": 202607,
        "valor": 62869787518.8699,
        "delta": 1960644446.1399
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 43986809000.28998,
    "valor_anterior": 41938068889.47,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 42487949266.02,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 41838812401.58,
        "delta": -649136864.4401
      },
      {
        "periodo": 202509,
        "valor": 39371384176.77,
        "delta": -2467428224.8099
      },
      {
        "periodo": 202510,
        "valor": 40230014087.82,
        "delta": 858629911.05
      },
      {
        "periodo": 202511,
        "valor": 41368737547.48,
        "delta": 1138723459.66
      },
      {
        "periodo": 202512,
        "valor": 45481396952.7901,
        "delta": 4112659405.3101
      },
      {
        "periodo": 202601,
        "valor": 45113446502.89,
        "delta": -367950449.9001
      },
      {
        "periodo": 202602,
        "valor": 36810749669.48,
        "delta": -8302696833.41
      },
      {
        "periodo": 202603,
        "valor": 40685078439.82,
        "delta": 3874328770.34
      },
      {
        "periodo": 202604,
        "valor": 44217276798.6,
        "delta": 3532198358.78
      },
      {
        "periodo": 202605,
        "valor": 40960511014.81,
        "delta": -3256765783.79
      },
      {
        "periodo": 202606,
        "valor": 41938068889.47,
        "delta": 977557874.66
      },
      {
        "periodo": 202607,
        "valor": 43986809000.29,
        "delta": 2048740110.82
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 294691311.98,
    "valor_anterior": 578440889.1800003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 663830108.64,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 531661246.96,
        "delta": -132168861.68
      },
      {
        "periodo": 202509,
        "valor": -1152999224.16,
        "delta": -1684660471.12
      },
      {
        "periodo": 202510,
        "valor": 391220619.11,
        "delta": 1544219843.27
      },
      {
        "periodo": 202511,
        "valor": 532175318.38,
        "delta": 140954699.27
      },
      {
        "periodo": 202512,
        "valor": 679789645.03,
        "delta": 147614326.65
      },
      {
        "periodo": 202601,
        "valor": 611332529.7,
        "delta": -68457115.33
      },
      {
        "periodo": 202602,
        "valor": 393607082.84,
        "delta": -217725446.86
      },
      {
        "periodo": 202603,
        "valor": 831464881.88,
        "delta": 437857799.04
      },
      {
        "periodo": 202604,
        "valor": 555629675.08,
        "delta": -275835206.8
      },
      {
        "periodo": 202605,
        "valor": 403246695.74,
        "delta": -152382979.34
      },
      {
        "periodo": 202606,
        "valor": 578440889.18,
        "delta": 175194193.44
      },
      {
        "periodo": 202607,
        "valor": 294691311.98,
        "delta": -283749577.2
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 3294344695.079998,
    "valor_anterior": 2548646817.959999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2864226817.11,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3779614503.87,
        "delta": 915387686.76
      },
      {
        "periodo": 202509,
        "valor": 2110529525.59,
        "delta": -1669084978.28
      },
      {
        "periodo": 202510,
        "valor": 3318074185.59,
        "delta": 1207544660.0
      },
      {
        "periodo": 202511,
        "valor": 2065544835.3,
        "delta": -1252529350.29
      },
      {
        "periodo": 202512,
        "valor": 1525398342.68,
        "delta": -540146492.62
      },
      {
        "periodo": 202601,
        "valor": 2756179754.27,
        "delta": 1230781411.59
      },
      {
        "periodo": 202602,
        "valor": 2411132264.98,
        "delta": -345047489.29
      },
      {
        "periodo": 202603,
        "valor": 5678954095.0,
        "delta": 3267821830.02
      },
      {
        "periodo": 202604,
        "valor": 3749392265.98,
        "delta": -1929561829.02
      },
      {
        "periodo": 202605,
        "valor": 2927137787.08,
        "delta": -822254478.9
      },
      {
        "periodo": 202606,
        "valor": 2548646817.96,
        "delta": -378490969.12
      },
      {
        "periodo": 202607,
        "valor": 3294344695.08,
        "delta": 745697877.12
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 4340577206.299999,
    "valor_anterior": 4347074949.850002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3742393246.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4083285494.45,
        "delta": 340892248.19
      },
      {
        "periodo": 202509,
        "valor": 3598255038.58,
        "delta": -485030455.87
      },
      {
        "periodo": 202510,
        "valor": 4229696585.54,
        "delta": 631441546.96
      },
      {
        "periodo": 202511,
        "valor": 4406269919.29,
        "delta": 176573333.75
      },
      {
        "periodo": 202512,
        "valor": 4543112145.38,
        "delta": 136842226.09
      },
      {
        "periodo": 202601,
        "valor": 4015513081.26,
        "delta": -527599064.12
      },
      {
        "periodo": 202602,
        "valor": 3751208475.23,
        "delta": -264304606.03
      },
      {
        "periodo": 202603,
        "valor": 4579050552.4,
        "delta": 827842077.17
      },
      {
        "periodo": 202604,
        "valor": 4169600782.9,
        "delta": -409449769.5
      },
      {
        "periodo": 202605,
        "valor": 4543933822.22,
        "delta": 374333039.32
      },
      {
        "periodo": 202606,
        "valor": 4347074949.85,
        "delta": -196858872.37
      },
      {
        "periodo": 202607,
        "valor": 4340577206.3,
        "delta": -6497743.55
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 1022813828.5900002,
    "valor_anterior": 916675504.6300001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1007115974.24,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 943627420.84,
        "delta": -63488553.4
      },
      {
        "periodo": 202509,
        "valor": 953861004.15,
        "delta": 10233583.31
      },
      {
        "periodo": 202510,
        "valor": 1111348519.91,
        "delta": 157487515.76
      },
      {
        "periodo": 202511,
        "valor": 909627064.36,
        "delta": -201721455.55
      },
      {
        "periodo": 202512,
        "valor": 989232814.59,
        "delta": 79605750.23
      },
      {
        "periodo": 202601,
        "valor": 949708211.05,
        "delta": -39524603.54
      },
      {
        "periodo": 202602,
        "valor": 888962798.85,
        "delta": -60745412.2
      },
      {
        "periodo": 202603,
        "valor": 933256494.16,
        "delta": 44293695.31
      },
      {
        "periodo": 202604,
        "valor": 889518818.17,
        "delta": -43737675.99
      },
      {
        "periodo": 202605,
        "valor": 1022033335.9,
        "delta": 132514517.73
      },
      {
        "periodo": 202606,
        "valor": 916675504.63,
        "delta": -105357831.27
      },
      {
        "periodo": 202607,
        "valor": 1022813828.59,
        "delta": 106138323.96
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100009,
    "label": "Margen Financiero Ajustado",
    "valor_actual": 9930551476.630005,
    "valor_anterior": 10580236021.64,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9952858943.67,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9344691926.91,
        "delta": -608167016.76
      },
      {
        "periodo": 202509,
        "valor": 9087015413.75,
        "delta": -257676513.16
      },
      {
        "periodo": 202510,
        "valor": 9649387269.36,
        "delta": 562371855.61
      },
      {
        "periodo": 202511,
        "valor": 10080426506.39,
        "delta": 431039237.03
      },
      {
        "periodo": 202512,
        "valor": 10573487168.41,
        "delta": 493060662.02
      },
      {
        "periodo": 202601,
        "valor": 8758418243.03,
        "delta": -1815068925.38
      },
      {
        "periodo": 202602,
        "valor": 9108312114.92,
        "delta": 349893871.89
      },
      {
        "periodo": 202603,
        "valor": 12073033307.72,
        "delta": 2964721192.8
      },
      {
        "periodo": 202604,
        "valor": 10550746097.51,
        "delta": -1522287210.21
      },
      {
        "periodo": 202605,
        "valor": 9789354310.35,
        "delta": -761391787.16
      },
      {
        "periodo": 202606,
        "valor": 10580236021.64,
        "delta": 790881711.29
      },
      {
        "periodo": 202607,
        "valor": 9930551476.63,
        "delta": -649684545.01
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 2804488393.720001,
    "valor_anterior": 2918338488.869999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3003534740.22,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2923476795.6,
        "delta": -80057944.62
      },
      {
        "periodo": 202509,
        "valor": 2996441716.74,
        "delta": 72964921.14
      },
      {
        "periodo": 202510,
        "valor": 3015421762.29,
        "delta": 18980045.55
      },
      {
        "periodo": 202511,
        "valor": 3299603276.14,
        "delta": 284181513.85
      },
      {
        "periodo": 202512,
        "valor": 3583937974.66,
        "delta": 284334698.52
      },
      {
        "periodo": 202601,
        "valor": 3362801352.61,
        "delta": -221136622.05
      },
      {
        "periodo": 202602,
        "valor": 3060848735.8,
        "delta": -301952616.81
      },
      {
        "periodo": 202603,
        "valor": 3337034519.45,
        "delta": 276185783.65
      },
      {
        "periodo": 202604,
        "valor": 3222747279.61,
        "delta": -114287239.84
      },
      {
        "periodo": 202605,
        "valor": 1829685138.51,
        "delta": -1393062141.1
      },
      {
        "periodo": 202606,
        "valor": 2918338488.87,
        "delta": 1088653350.36
      },
      {
        "periodo": 202607,
        "valor": 2804488393.72,
        "delta": -113850095.15
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 8209178961.779999,
    "valor_anterior": 8581624993.970001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7740578605.73,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7478638200.53,
        "delta": -261940405.2
      },
      {
        "periodo": 202509,
        "valor": 7809151521.64,
        "delta": 330513321.11
      },
      {
        "periodo": 202510,
        "valor": 7964814131.04,
        "delta": 155662609.4
      },
      {
        "periodo": 202511,
        "valor": 8029577679.26,
        "delta": 64763548.22
      },
      {
        "periodo": 202512,
        "valor": 8963597113.58,
        "delta": 934019434.32
      },
      {
        "periodo": 202601,
        "valor": 8172221652.86,
        "delta": -791375460.72
      },
      {
        "periodo": 202602,
        "valor": 7138867684.85,
        "delta": -1033353968.01
      },
      {
        "periodo": 202603,
        "valor": 8304606129.77,
        "delta": 1165738444.92
      },
      {
        "periodo": 202604,
        "valor": 7973858970.06,
        "delta": -330747159.71
      },
      {
        "periodo": 202605,
        "valor": 7832366772.52,
        "delta": -141492197.54
      },
      {
        "periodo": 202606,
        "valor": 8581624993.97,
        "delta": 749258221.45
      },
      {
        "periodo": 202607,
        "valor": 8209178961.78,
        "delta": -372446032.19
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 3072576114.0,
    "valor_anterior": 3390942261.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2785172163.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2817866668.0,
        "delta": 32694505.0
      },
      {
        "periodo": 202509,
        "valor": 2892257374.0,
        "delta": 74390706.0
      },
      {
        "periodo": 202510,
        "valor": 2955657272.0,
        "delta": 63399898.0
      },
      {
        "periodo": 202511,
        "valor": 2932866128.0,
        "delta": -22791144.0
      },
      {
        "periodo": 202512,
        "valor": 3671545194.0,
        "delta": 738679066.0
      },
      {
        "periodo": 202601,
        "valor": 3036795619.0,
        "delta": -634749575.0
      },
      {
        "periodo": 202602,
        "valor": 2788946716.0,
        "delta": -247848903.0
      },
      {
        "periodo": 202603,
        "valor": 3341231070.0,
        "delta": 552284354.0
      },
      {
        "periodo": 202604,
        "valor": 2901557788.0,
        "delta": -439673282.0
      },
      {
        "periodo": 202605,
        "valor": 3058326083.0,
        "delta": 156768295.0
      },
      {
        "periodo": 202606,
        "valor": 3390942261.0,
        "delta": 332616178.0
      },
      {
        "periodo": 202607,
        "valor": 3072576114.0,
        "delta": -318366147.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 1061519166.0,
    "valor_anterior": 1128055846.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1233538823.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1061674138.0,
        "delta": -171864685.0
      },
      {
        "periodo": 202509,
        "valor": 1172281825.0,
        "delta": 110607687.0
      },
      {
        "periodo": 202510,
        "valor": 1115684306.0,
        "delta": -56597519.0
      },
      {
        "periodo": 202511,
        "valor": 1193068333.0,
        "delta": 77384027.0
      },
      {
        "periodo": 202512,
        "valor": 1209145719.0,
        "delta": 16077386.0
      },
      {
        "periodo": 202601,
        "valor": 1112359021.0,
        "delta": -96786698.0
      },
      {
        "periodo": 202602,
        "valor": 1028607790.0,
        "delta": -83751231.0
      },
      {
        "periodo": 202603,
        "valor": 1167874298.0,
        "delta": 139266508.0
      },
      {
        "periodo": 202604,
        "valor": 1061457801.0,
        "delta": -106416497.0
      },
      {
        "periodo": 202605,
        "valor": 1082859342.0,
        "delta": 21401541.0
      },
      {
        "periodo": 202606,
        "valor": 1128055846.0,
        "delta": 45196504.0
      },
      {
        "periodo": 202607,
        "valor": 1061519166.0,
        "delta": -66536680.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 451548234.8699999,
    "valor_anterior": 428488661.8299999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 453791023.98,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 448165863.75,
        "delta": -5625160.23
      },
      {
        "periodo": 202509,
        "valor": 429298826.51,
        "delta": -18867037.24
      },
      {
        "periodo": 202510,
        "valor": 445993286.15,
        "delta": 16694459.64
      },
      {
        "periodo": 202511,
        "valor": 446036998.2,
        "delta": 43712.05
      },
      {
        "periodo": 202512,
        "valor": 490129152.74,
        "delta": 44092154.54
      },
      {
        "periodo": 202601,
        "valor": 468708994.08,
        "delta": -21420158.66
      },
      {
        "periodo": 202602,
        "valor": 413298146.69,
        "delta": -55410847.39
      },
      {
        "periodo": 202603,
        "valor": 467324056.46,
        "delta": 54025909.77
      },
      {
        "periodo": 202604,
        "valor": 438490673.41,
        "delta": -28833383.05
      },
      {
        "periodo": 202605,
        "valor": 441325863.09,
        "delta": 2835189.68
      },
      {
        "periodo": 202606,
        "valor": 428488661.83,
        "delta": -12837201.26
      },
      {
        "periodo": 202607,
        "valor": 451548234.87,
        "delta": 23059573.04
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 654460396.0,
    "valor_anterior": 683277440.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 722774732.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 628651697.0,
        "delta": -94123035.0
      },
      {
        "periodo": 202509,
        "valor": 653999234.0,
        "delta": 25347537.0
      },
      {
        "periodo": 202510,
        "valor": 708611037.0,
        "delta": 54611803.0
      },
      {
        "periodo": 202511,
        "valor": 683659168.0,
        "delta": -24951869.0
      },
      {
        "periodo": 202512,
        "valor": 874416301.0,
        "delta": 190757133.0
      },
      {
        "periodo": 202601,
        "valor": 671460929.0,
        "delta": -202955372.0
      },
      {
        "periodo": 202602,
        "valor": 696662694.0,
        "delta": 25201765.0
      },
      {
        "periodo": 202603,
        "valor": 660951929.0,
        "delta": -35710765.0
      },
      {
        "periodo": 202604,
        "valor": 631235453.0,
        "delta": -29716476.0
      },
      {
        "periodo": 202605,
        "valor": 613861587.0,
        "delta": -17373866.0
      },
      {
        "periodo": 202606,
        "valor": 683277440.0,
        "delta": 69415853.0
      },
      {
        "periodo": 202607,
        "valor": 654460396.0,
        "delta": -28817044.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 164063017.0,
    "valor_anterior": 181485196.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 143898335.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 137595475.0,
        "delta": -6302860.0
      },
      {
        "periodo": 202509,
        "valor": 149840162.0,
        "delta": 12244687.0
      },
      {
        "periodo": 202510,
        "valor": 150297774.0,
        "delta": 457612.0
      },
      {
        "periodo": 202511,
        "valor": 142186922.0,
        "delta": -8110852.0
      },
      {
        "periodo": 202512,
        "valor": 201465027.0,
        "delta": 59278105.0
      },
      {
        "periodo": 202601,
        "valor": 144147206.0,
        "delta": -57317821.0
      },
      {
        "periodo": 202602,
        "valor": 146999622.0,
        "delta": 2852416.0
      },
      {
        "periodo": 202603,
        "valor": 167523066.0,
        "delta": 20523444.0
      },
      {
        "periodo": 202604,
        "valor": 146567245.0,
        "delta": -20955821.0
      },
      {
        "periodo": 202605,
        "valor": 166946104.0,
        "delta": 20378859.0
      },
      {
        "periodo": 202606,
        "valor": 181485196.0,
        "delta": 14539092.0
      },
      {
        "periodo": 202607,
        "valor": 164063017.0,
        "delta": -17422179.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 496969189.0,
    "valor_anterior": 556963701.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 471424299.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 506373599.0,
        "delta": 34949300.0
      },
      {
        "periodo": 202509,
        "valor": 474240498.0,
        "delta": -32133101.0
      },
      {
        "periodo": 202510,
        "valor": 445047783.0,
        "delta": -29192715.0
      },
      {
        "periodo": 202511,
        "valor": 454595816.0,
        "delta": 9548033.0
      },
      {
        "periodo": 202512,
        "valor": 598390912.0,
        "delta": 143795096.0
      },
      {
        "periodo": 202601,
        "valor": 427356363.0,
        "delta": -171034549.0
      },
      {
        "periodo": 202602,
        "valor": 452761672.0,
        "delta": 25405309.0
      },
      {
        "periodo": 202603,
        "valor": 524853642.0,
        "delta": 72091970.0
      },
      {
        "periodo": 202604,
        "valor": 471128862.0,
        "delta": -53724780.0
      },
      {
        "periodo": 202605,
        "valor": 512557516.0,
        "delta": 41428654.0
      },
      {
        "periodo": 202606,
        "valor": 556963701.0,
        "delta": 44406185.0
      },
      {
        "periodo": 202607,
        "valor": 496969189.0,
        "delta": -59994512.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 176356309.26999998,
    "valor_anterior": 182809661.40999997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 386925188.06,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 348151860.95,
        "delta": -38773327.11
      },
      {
        "periodo": 202509,
        "valor": 359647447.85,
        "delta": 11495586.9
      },
      {
        "periodo": 202510,
        "valor": 365082479.32,
        "delta": 5435031.47
      },
      {
        "periodo": 202511,
        "valor": 382874293.38,
        "delta": 17791814.06
      },
      {
        "periodo": 202512,
        "valor": 444676923.97,
        "delta": 61802630.59
      },
      {
        "periodo": 202601,
        "valor": 365689132.82,
        "delta": -78987791.15
      },
      {
        "periodo": 202602,
        "valor": 160345365.91,
        "delta": -205343766.91
      },
      {
        "periodo": 202603,
        "valor": 177716355.47,
        "delta": 17370989.56
      },
      {
        "periodo": 202604,
        "valor": 173491045.39,
        "delta": -4225310.08
      },
      {
        "periodo": 202605,
        "valor": 171048534.53,
        "delta": -2442510.86
      },
      {
        "periodo": 202606,
        "valor": 182809661.41,
        "delta": 11761126.88
      },
      {
        "periodo": 202607,
        "valor": 176356309.27,
        "delta": -6453352.14
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 780665687.0,
    "valor_anterior": 837938648.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 615789202.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 608137570.0,
        "delta": -7651632.0
      },
      {
        "periodo": 202509,
        "valor": 656276704.0,
        "delta": 48139134.0
      },
      {
        "periodo": 202510,
        "valor": 634329786.0,
        "delta": -21946918.0
      },
      {
        "periodo": 202511,
        "valor": 645992439.0,
        "delta": 11662653.0
      },
      {
        "periodo": 202512,
        "valor": 705359805.0,
        "delta": 59367366.0
      },
      {
        "periodo": 202601,
        "valor": 631875090.0,
        "delta": -73484715.0
      },
      {
        "periodo": 202602,
        "valor": 675994130.0,
        "delta": 44119040.0
      },
      {
        "periodo": 202603,
        "valor": 737933301.0,
        "delta": 61939171.0
      },
      {
        "periodo": 202604,
        "valor": 746185754.0,
        "delta": 8252453.0
      },
      {
        "periodo": 202605,
        "valor": 758655868.0,
        "delta": 12470114.0
      },
      {
        "periodo": 202606,
        "valor": 837938648.0,
        "delta": 79282780.0
      },
      {
        "periodo": 202607,
        "valor": 780665687.0,
        "delta": -57272961.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 37277374.0,
    "valor_anterior": 42147618.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 34435323.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55909238.0,
        "delta": 21473915.0
      },
      {
        "periodo": 202509,
        "valor": 33836844.0,
        "delta": -22072394.0
      },
      {
        "periodo": 202510,
        "valor": 32686554.0,
        "delta": -1150290.0
      },
      {
        "periodo": 202511,
        "valor": 7610248.0,
        "delta": -25076306.0
      },
      {
        "periodo": 202512,
        "valor": 38381014.0,
        "delta": 30770766.0
      },
      {
        "periodo": 202601,
        "valor": 35101118.0,
        "delta": -3279896.0
      },
      {
        "periodo": 202602,
        "valor": 36257115.0,
        "delta": 1155997.0
      },
      {
        "periodo": 202603,
        "valor": 44356596.0,
        "delta": 8099481.0
      },
      {
        "periodo": 202604,
        "valor": 36188154.0,
        "delta": -8168442.0
      },
      {
        "periodo": 202605,
        "valor": 38895430.0,
        "delta": 2707276.0
      },
      {
        "periodo": 202606,
        "valor": 42147618.0,
        "delta": 3252188.0
      },
      {
        "periodo": 202607,
        "valor": 37277374.0,
        "delta": -4870244.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 477776597.0,
    "valor_anterior": 484993680.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 418543152.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 422023448.0,
        "delta": 3480296.0
      },
      {
        "periodo": 202509,
        "valor": 429388660.0,
        "delta": 7365212.0
      },
      {
        "periodo": 202510,
        "valor": 421479083.0,
        "delta": -7909577.0
      },
      {
        "periodo": 202511,
        "valor": 430251132.0,
        "delta": 8772049.0
      },
      {
        "periodo": 202512,
        "valor": 509420774.0,
        "delta": 79169642.0
      },
      {
        "periodo": 202601,
        "valor": 454761186.0,
        "delta": -54659588.0
      },
      {
        "periodo": 202602,
        "valor": 403864117.0,
        "delta": -50897069.0
      },
      {
        "periodo": 202603,
        "valor": 463608444.0,
        "delta": 59744327.0
      },
      {
        "periodo": 202604,
        "valor": 420984032.0,
        "delta": -42624412.0
      },
      {
        "periodo": 202605,
        "valor": 432016823.0,
        "delta": 11032791.0
      },
      {
        "periodo": 202606,
        "valor": 484993680.0,
        "delta": 52976857.0
      },
      {
        "periodo": 202607,
        "valor": 477776597.0,
        "delta": -7217083.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 3563587067.1100006,
    "valor_anterior": 3500229844.210001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3480735145.05,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3063528930.42,
        "delta": -417206214.63
      },
      {
        "periodo": 202509,
        "valor": 3104713380.29,
        "delta": 41184449.87
      },
      {
        "periodo": 202510,
        "valor": 3278707161.44,
        "delta": 173993781.15
      },
      {
        "periodo": 202511,
        "valor": 3233168636.27,
        "delta": -45538525.17
      },
      {
        "periodo": 202512,
        "valor": 3814969529.71,
        "delta": 581800893.44
      },
      {
        "periodo": 202601,
        "valor": 3333783074.96,
        "delta": -481186454.75
      },
      {
        "periodo": 202602,
        "valor": 3061781658.26,
        "delta": -272001416.7
      },
      {
        "periodo": 202603,
        "valor": 3640293286.51,
        "delta": 578511628.25
      },
      {
        "periodo": 202604,
        "valor": 3287290842.93,
        "delta": -353002443.58
      },
      {
        "periodo": 202605,
        "valor": 3434354416.47,
        "delta": 147063573.54
      },
      {
        "periodo": 202606,
        "valor": 3500229844.21,
        "delta": 65875427.74
      },
      {
        "periodo": 202607,
        "valor": 3563587067.11,
        "delta": 63357222.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 16252359.0,
    "valor_anterior": 15107256.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14780823.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15320498.0,
        "delta": 539675.0
      },
      {
        "periodo": 202509,
        "valor": 17546573.0,
        "delta": 2226075.0
      },
      {
        "periodo": 202510,
        "valor": 16049120.0,
        "delta": -1497453.0
      },
      {
        "periodo": 202511,
        "valor": 15702223.0,
        "delta": -346897.0
      },
      {
        "periodo": 202512,
        "valor": 17929952.0,
        "delta": 2227729.0
      },
      {
        "periodo": 202601,
        "valor": 13601929.0,
        "delta": -4328023.0
      },
      {
        "periodo": 202602,
        "valor": 15548470.0,
        "delta": 1946541.0
      },
      {
        "periodo": 202603,
        "valor": 12902758.0,
        "delta": -2645712.0
      },
      {
        "periodo": 202604,
        "valor": 15496830.0,
        "delta": 2594072.0
      },
      {
        "periodo": 202605,
        "valor": 15205573.0,
        "delta": -291257.0
      },
      {
        "periodo": 202606,
        "valor": 15107256.0,
        "delta": -98317.0
      },
      {
        "periodo": 202607,
        "valor": 16252359.0,
        "delta": 1145103.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 29099544.0,
    "valor_anterior": 4394134.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2936288.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 30547715.0,
        "delta": 27611427.0
      },
      {
        "periodo": 202509,
        "valor": 3680976.0,
        "delta": -26866739.0
      },
      {
        "periodo": 202510,
        "valor": 3544147.0,
        "delta": -136829.0
      },
      {
        "periodo": 202511,
        "valor": 2421971.0,
        "delta": -1122176.0
      },
      {
        "periodo": 202512,
        "valor": 5113950.0,
        "delta": 2691979.0
      },
      {
        "periodo": 202601,
        "valor": 3243307.0,
        "delta": -1870643.0
      },
      {
        "periodo": 202602,
        "valor": 3922494.0,
        "delta": 679187.0
      },
      {
        "periodo": 202603,
        "valor": 6795252.0,
        "delta": 2872758.0
      },
      {
        "periodo": 202604,
        "valor": 3603188.0,
        "delta": -3192064.0
      },
      {
        "periodo": 202605,
        "valor": 3018173.0,
        "delta": -585015.0
      },
      {
        "periodo": 202606,
        "valor": 4394134.0,
        "delta": 1375961.0
      },
      {
        "periodo": 202607,
        "valor": 29099544.0,
        "delta": 24705410.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 113450487.0,
    "valor_anterior": 81727585.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 167586161.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 474511081.0,
        "delta": 306924920.0
      },
      {
        "periodo": 202509,
        "valor": 675587134.0,
        "delta": 201076053.0
      },
      {
        "periodo": 202510,
        "valor": 144908578.0,
        "delta": -530678556.0
      },
      {
        "periodo": 202511,
        "valor": 150511525.0,
        "delta": 5602947.0
      },
      {
        "periodo": 202512,
        "valor": 155315308.0,
        "delta": 4803783.0
      },
      {
        "periodo": 202601,
        "valor": 81439364.0,
        "delta": -73875944.0
      },
      {
        "periodo": 202602,
        "valor": 210538477.0,
        "delta": 129099113.0
      },
      {
        "periodo": 202603,
        "valor": 125027373.0,
        "delta": -85511104.0
      },
      {
        "periodo": 202604,
        "valor": 112868446.0,
        "delta": -12158927.0
      },
      {
        "periodo": 202605,
        "valor": 148800430.0,
        "delta": 35931984.0
      },
      {
        "periodo": 202606,
        "valor": 81727585.0,
        "delta": -67072845.0
      },
      {
        "periodo": 202607,
        "valor": 113450487.0,
        "delta": 31722902.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 69009952.88,
    "valor_anterior": 65444076.43000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 57125628.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 53790285.76,
        "delta": -3335343.11
      },
      {
        "periodo": 202509,
        "valor": 62995309.41,
        "delta": 9205023.65
      },
      {
        "periodo": 202510,
        "valor": 62622099.79,
        "delta": -373209.62
      },
      {
        "periodo": 202511,
        "valor": 51829297.12,
        "delta": -10792802.67
      },
      {
        "periodo": 202512,
        "valor": 55228008.36,
        "delta": 3398711.24
      },
      {
        "periodo": 202601,
        "valor": 54018627.88,
        "delta": -1209380.48
      },
      {
        "periodo": 202602,
        "valor": 50277566.22,
        "delta": -3741061.66
      },
      {
        "periodo": 202603,
        "valor": 62649660.65,
        "delta": 12372094.43
      },
      {
        "periodo": 202604,
        "valor": 58047460.91,
        "delta": -4602199.74
      },
      {
        "periodo": 202605,
        "valor": 58745168.64,
        "delta": 697707.73
      },
      {
        "periodo": 202606,
        "valor": 65444076.43,
        "delta": 6698907.79
      },
      {
        "periodo": 202607,
        "valor": 69009952.88,
        "delta": 3565876.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 23963335.0,
    "valor_anterior": 22444813.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21211011.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 22612386.0,
        "delta": 1401375.0
      },
      {
        "periodo": 202509,
        "valor": 20232312.0,
        "delta": -2380074.0
      },
      {
        "periodo": 202510,
        "valor": 20772986.0,
        "delta": 540674.0
      },
      {
        "periodo": 202511,
        "valor": 23643343.0,
        "delta": 2870357.0
      },
      {
        "periodo": 202512,
        "valor": 20808091.0,
        "delta": -2835252.0
      },
      {
        "periodo": 202601,
        "valor": 18287785.0,
        "delta": -2520306.0
      },
      {
        "periodo": 202602,
        "valor": 22651122.0,
        "delta": 4363337.0
      },
      {
        "periodo": 202603,
        "valor": 23513442.0,
        "delta": 862320.0
      },
      {
        "periodo": 202604,
        "valor": 34867431.0,
        "delta": 11353989.0
      },
      {
        "periodo": 202605,
        "valor": 23994073.0,
        "delta": -10873358.0
      },
      {
        "periodo": 202606,
        "valor": 22444813.0,
        "delta": -1549260.0
      },
      {
        "periodo": 202607,
        "valor": 23963335.0,
        "delta": 1518522.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 265744827.3800001,
    "valor_anterior": 529111259.76,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2682423.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 790087556.02,
        "delta": 787405133.02
      },
      {
        "periodo": 202509,
        "valor": 561398236.03,
        "delta": -228689319.99
      },
      {
        "periodo": 202510,
        "valor": 400963672.98,
        "delta": -160434563.05
      },
      {
        "periodo": 202511,
        "valor": 253633276.31,
        "delta": -147330396.67
      },
      {
        "periodo": 202512,
        "valor": 733886783.2,
        "delta": 480253506.89
      },
      {
        "periodo": 202601,
        "valor": 340267700.96,
        "delta": -393619082.24
      },
      {
        "periodo": 202602,
        "valor": 308132161.73,
        "delta": -32135539.23
      },
      {
        "periodo": 202603,
        "valor": 405553184.4,
        "delta": 97421022.67
      },
      {
        "periodo": 202604,
        "valor": 429660211.56,
        "delta": 24107027.16
      },
      {
        "periodo": 202605,
        "valor": 635622484.15,
        "delta": 205962272.59
      },
      {
        "periodo": 202606,
        "valor": 529111259.76,
        "delta": -106511224.39
      },
      {
        "periodo": 202607,
        "valor": 265744827.38,
        "delta": -263366432.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 4328194.0,
    "valor_anterior": 4376681.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 797994.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -798007.0,
        "delta": -1596001.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 798007.0
      },
      {
        "periodo": 202510,
        "valor": 11921180.0,
        "delta": 11921180.0
      },
      {
        "periodo": 202511,
        "valor": -1239517.0,
        "delta": -13160697.0
      },
      {
        "periodo": 202512,
        "valor": 34925838.0,
        "delta": 36165355.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -34925838.0
      },
      {
        "periodo": 202602,
        "valor": 5226030.0,
        "delta": 5226030.0
      },
      {
        "periodo": 202603,
        "valor": 8064000.0,
        "delta": 2837970.0
      },
      {
        "periodo": 202604,
        "valor": 4311175.0,
        "delta": -3752825.0
      },
      {
        "periodo": 202605,
        "valor": 4323498.0,
        "delta": 12323.0
      },
      {
        "periodo": 202606,
        "valor": 4376681.0,
        "delta": 53183.0
      },
      {
        "periodo": 202607,
        "valor": 4328194.0,
        "delta": -48487.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 539251445.9900002,
    "valor_anterior": 523819423.75999975,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 503857986.3,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 476767410.63,
        "delta": -27090575.67
      },
      {
        "periodo": 202509,
        "valor": 494080699.87,
        "delta": 17313289.24
      },
      {
        "periodo": 202510,
        "valor": 482267398.32,
        "delta": -11813301.55
      },
      {
        "periodo": 202511,
        "valor": 512029672.39,
        "delta": 29762274.07
      },
      {
        "periodo": 202512,
        "valor": 554030137.69,
        "delta": 42000465.3
      },
      {
        "periodo": 202601,
        "valor": 497329378.94,
        "delta": -56700758.75
      },
      {
        "periodo": 202602,
        "valor": 445599784.93,
        "delta": -51729594.01
      },
      {
        "periodo": 202603,
        "valor": 514877664.09,
        "delta": 69277879.16
      },
      {
        "periodo": 202604,
        "valor": 520096598.26,
        "delta": 5218934.17
      },
      {
        "periodo": 202605,
        "valor": 528730012.12,
        "delta": 8633413.86
      },
      {
        "periodo": 202606,
        "valor": 523819423.76,
        "delta": -4910588.36
      },
      {
        "periodo": 202607,
        "valor": 539251445.99,
        "delta": 15432022.23
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 27036451.0,
    "valor_anterior": 35415789.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14163172.57,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8859697.71,
        "delta": -5303474.86
      },
      {
        "periodo": 202509,
        "valor": 20993386.54,
        "delta": 12133688.83
      },
      {
        "periodo": 202510,
        "valor": 19290815.0,
        "delta": -1702571.54
      },
      {
        "periodo": 202511,
        "valor": 25418362.0,
        "delta": 6127547.0
      },
      {
        "periodo": 202512,
        "valor": 20665044.0,
        "delta": -4753318.0
      },
      {
        "periodo": 202601,
        "valor": 17783512.0,
        "delta": -2881532.0
      },
      {
        "periodo": 202602,
        "valor": 25548843.0,
        "delta": 7765331.0
      },
      {
        "periodo": 202603,
        "valor": 31729045.0,
        "delta": 6180202.0
      },
      {
        "periodo": 202604,
        "valor": 25772840.0,
        "delta": -5956205.0
      },
      {
        "periodo": 202605,
        "valor": 29925349.0,
        "delta": 4152509.0
      },
      {
        "periodo": 202606,
        "valor": 35415789.0,
        "delta": 5490440.0
      },
      {
        "periodo": 202607,
        "valor": 27036451.0,
        "delta": -8379338.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 386949459.0,
    "valor_anterior": 381709180.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 387584095.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 310292225.0,
        "delta": -77291870.0
      },
      {
        "periodo": 202509,
        "valor": 332418253.0,
        "delta": 22126028.0
      },
      {
        "periodo": 202510,
        "valor": 376753327.0,
        "delta": 44335074.0
      },
      {
        "periodo": 202511,
        "valor": 347875110.0,
        "delta": -28878217.0
      },
      {
        "periodo": 202512,
        "valor": 366637611.0,
        "delta": 18762501.0
      },
      {
        "periodo": 202601,
        "valor": 309116451.0,
        "delta": -57521160.0
      },
      {
        "periodo": 202602,
        "valor": 328840066.0,
        "delta": 19723615.0
      },
      {
        "periodo": 202603,
        "valor": 385803734.0,
        "delta": 56963668.0
      },
      {
        "periodo": 202604,
        "valor": 322863114.0,
        "delta": -62940620.0
      },
      {
        "periodo": 202605,
        "valor": 324479545.0,
        "delta": 1616431.0
      },
      {
        "periodo": 202606,
        "valor": 381709180.0,
        "delta": 57229635.0
      },
      {
        "periodo": 202607,
        "valor": 386949459.0,
        "delta": 5240279.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 140485381.0,
    "valor_anterior": 270116867.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 89230561.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 126137213.0,
        "delta": 36906652.0
      },
      {
        "periodo": 202509,
        "valor": 195982816.0,
        "delta": 69845603.0
      },
      {
        "periodo": 202510,
        "valor": 221599046.0,
        "delta": 25616230.0
      },
      {
        "periodo": 202511,
        "valor": 179462484.0,
        "delta": -42136562.0
      },
      {
        "periodo": 202512,
        "valor": 326057550.0,
        "delta": 146595066.0
      },
      {
        "periodo": 202601,
        "valor": 109711001.0,
        "delta": -216346549.0
      },
      {
        "periodo": 202602,
        "valor": 122597273.0,
        "delta": 12886272.0
      },
      {
        "periodo": 202603,
        "valor": 200908372.0,
        "delta": 78311099.0
      },
      {
        "periodo": 202604,
        "valor": 208050245.0,
        "delta": 7141873.0
      },
      {
        "periodo": 202605,
        "valor": 190717244.0,
        "delta": -17333001.0
      },
      {
        "periodo": 202606,
        "valor": 270116867.0,
        "delta": 79399623.0
      },
      {
        "periodo": 202607,
        "valor": 140485381.0,
        "delta": -129631486.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 168092482.0,
    "valor_anterior": 165334487.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 150012000.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 153445757.0,
        "delta": 3433757.0
      },
      {
        "periodo": 202509,
        "valor": 157971381.0,
        "delta": 4525624.0
      },
      {
        "periodo": 202510,
        "valor": 159293618.0,
        "delta": 1322237.0
      },
      {
        "periodo": 202511,
        "valor": 163544623.0,
        "delta": 4251005.0
      },
      {
        "periodo": 202512,
        "valor": 168954800.0,
        "delta": 5410177.0
      },
      {
        "periodo": 202601,
        "valor": 164522434.0,
        "delta": -4432366.0
      },
      {
        "periodo": 202602,
        "valor": 153632652.0,
        "delta": -10889782.0
      },
      {
        "periodo": 202603,
        "valor": 161106541.0,
        "delta": 7473889.0
      },
      {
        "periodo": 202604,
        "valor": 159433085.0,
        "delta": -1673456.0
      },
      {
        "periodo": 202605,
        "valor": 171363798.0,
        "delta": 11930713.0
      },
      {
        "periodo": 202606,
        "valor": 165334487.0,
        "delta": -6029311.0
      },
      {
        "periodo": 202607,
        "valor": 168092482.0,
        "delta": 2757995.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17493868.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10835034.0,
        "delta": -6658834.0
      },
      {
        "periodo": 202509,
        "valor": 26812809.0,
        "delta": 15977775.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": -26812809.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 1027152.0,
        "delta": 1027152.0
      },
      {
        "periodo": 202601,
        "valor": 20.0,
        "delta": -1027132.0
      },
      {
        "periodo": 202602,
        "valor": 110.0,
        "delta": 90.0
      },
      {
        "periodo": 202603,
        "valor": 60.0,
        "delta": -50.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": -60.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 683726848.9599996,
    "valor_anterior": 687997223.0900002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 618401316.1,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 586141704.67,
        "delta": -32259611.43
      },
      {
        "periodo": 202509,
        "valor": 555254051.0,
        "delta": -30887653.67
      },
      {
        "periodo": 202510,
        "valor": 672804694.09,
        "delta": 117550643.09
      },
      {
        "periodo": 202511,
        "valor": 621904274.64,
        "delta": -50900419.45
      },
      {
        "periodo": 202512,
        "valor": 672837232.26,
        "delta": 50932957.62
      },
      {
        "periodo": 202601,
        "valor": 577055265.47,
        "delta": -95781966.79
      },
      {
        "periodo": 202602,
        "valor": 615432321.21,
        "delta": 38377055.74
      },
      {
        "periodo": 202603,
        "valor": 658440801.14,
        "delta": 43008479.93
      },
      {
        "periodo": 202604,
        "valor": 741360855.21,
        "delta": 82920054.07
      },
      {
        "periodo": 202605,
        "valor": 679967260.11,
        "delta": -61393595.1
      },
      {
        "periodo": 202606,
        "valor": 687997223.09,
        "delta": 8029962.98
      },
      {
        "periodo": 202607,
        "valor": 683726848.96,
        "delta": -4270374.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 16083196.0,
    "valor_anterior": 14730938.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6098432.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6236947.0,
        "delta": 138515.0
      },
      {
        "periodo": 202509,
        "valor": 18760534.0,
        "delta": 12523587.0
      },
      {
        "periodo": 202510,
        "valor": 12026935.0,
        "delta": -6733599.0
      },
      {
        "periodo": 202511,
        "valor": 12734222.0,
        "delta": 707287.0
      },
      {
        "periodo": 202512,
        "valor": 15008991.0,
        "delta": 2274769.0
      },
      {
        "periodo": 202601,
        "valor": 13116815.0,
        "delta": -1892176.0
      },
      {
        "periodo": 202602,
        "valor": 15092622.0,
        "delta": 1975807.0
      },
      {
        "periodo": 202603,
        "valor": 16707887.0,
        "delta": 1615265.0
      },
      {
        "periodo": 202604,
        "valor": 16886043.0,
        "delta": 178156.0
      },
      {
        "periodo": 202605,
        "valor": 16283954.0,
        "delta": -602089.0
      },
      {
        "periodo": 202606,
        "valor": 14730938.0,
        "delta": -1553016.0
      },
      {
        "periodo": 202607,
        "valor": 16083196.0,
        "delta": 1352258.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 2921002.0,
    "valor_anterior": 2332925.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2911521.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6268125.0,
        "delta": 3356604.0
      },
      {
        "periodo": 202509,
        "valor": 4064683.0,
        "delta": -2203442.0
      },
      {
        "periodo": 202510,
        "valor": 2975068.0,
        "delta": -1089615.0
      },
      {
        "periodo": 202511,
        "valor": 4069397.0,
        "delta": 1094329.0
      },
      {
        "periodo": 202512,
        "valor": 4806763.0,
        "delta": 737366.0
      },
      {
        "periodo": 202601,
        "valor": 4433415.0,
        "delta": -373348.0
      },
      {
        "periodo": 202602,
        "valor": 4666453.0,
        "delta": 233038.0
      },
      {
        "periodo": 202603,
        "valor": 3228582.0,
        "delta": -1437871.0
      },
      {
        "periodo": 202604,
        "valor": 2922632.0,
        "delta": -305950.0
      },
      {
        "periodo": 202605,
        "valor": 5189132.0,
        "delta": 2266500.0
      },
      {
        "periodo": 202606,
        "valor": 2332925.0,
        "delta": -2856207.0
      },
      {
        "periodo": 202607,
        "valor": 2921002.0,
        "delta": 588077.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 54969852.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 51170414.0,
        "delta": -3799438.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 4469408.0,
    "valor_anterior": 5345280.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4022280.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3923382.0,
        "delta": -98898.0
      },
      {
        "periodo": 202509,
        "valor": 4376565.0,
        "delta": 453183.0
      },
      {
        "periodo": 202510,
        "valor": 4167447.0,
        "delta": -209118.0
      },
      {
        "periodo": 202511,
        "valor": 5091616.0,
        "delta": 924169.0
      },
      {
        "periodo": 202512,
        "valor": 3785996.0,
        "delta": -1305620.0
      },
      {
        "periodo": 202601,
        "valor": 3506706.0,
        "delta": -279290.0
      },
      {
        "periodo": 202602,
        "valor": 4174726.0,
        "delta": 668020.0
      },
      {
        "periodo": 202603,
        "valor": 8423981.0,
        "delta": 4249255.0
      },
      {
        "periodo": 202604,
        "valor": 4871272.0,
        "delta": -3552709.0
      },
      {
        "periodo": 202605,
        "valor": 4193635.0,
        "delta": -677637.0
      },
      {
        "periodo": 202606,
        "valor": 5345280.0,
        "delta": 1151645.0
      },
      {
        "periodo": 202607,
        "valor": 4469408.0,
        "delta": -875872.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 24355185.0,
    "valor_anterior": 33673322.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28488178.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 34405269.0,
        "delta": 5917091.0
      },
      {
        "periodo": 202509,
        "valor": 18503626.0,
        "delta": -15901643.0
      },
      {
        "periodo": 202510,
        "valor": 15208753.0,
        "delta": -3294873.0
      },
      {
        "periodo": 202511,
        "valor": 20692754.0,
        "delta": 5484001.0
      },
      {
        "periodo": 202512,
        "valor": 19423730.0,
        "delta": -1269024.0
      },
      {
        "periodo": 202601,
        "valor": 45121487.0,
        "delta": 25697757.0
      },
      {
        "periodo": 202602,
        "valor": 32732335.0,
        "delta": -12389152.0
      },
      {
        "periodo": 202603,
        "valor": 49322503.0,
        "delta": 16590168.0
      },
      {
        "periodo": 202604,
        "valor": 22441069.0,
        "delta": -26881434.0
      },
      {
        "periodo": 202605,
        "valor": 28093704.0,
        "delta": 5652635.0
      },
      {
        "periodo": 202606,
        "valor": 33673322.0,
        "delta": 5579618.0
      },
      {
        "periodo": 202607,
        "valor": 24355185.0,
        "delta": -9318137.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 2508121.0,
    "valor_anterior": 2205167.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1485268.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1747575.0,
        "delta": 262307.0
      },
      {
        "periodo": 202509,
        "valor": 2659044.0,
        "delta": 911469.0
      },
      {
        "periodo": 202510,
        "valor": 3845845.0,
        "delta": 1186801.0
      },
      {
        "periodo": 202511,
        "valor": 9062081.0,
        "delta": 5216236.0
      },
      {
        "periodo": 202512,
        "valor": 2097145.0,
        "delta": -6964936.0
      },
      {
        "periodo": 202601,
        "valor": 1304694.0,
        "delta": -792451.0
      },
      {
        "periodo": 202602,
        "valor": 1778950.0,
        "delta": 474256.0
      },
      {
        "periodo": 202603,
        "valor": 1715011.0,
        "delta": -63939.0
      },
      {
        "periodo": 202604,
        "valor": 1747675.0,
        "delta": 32664.0
      },
      {
        "periodo": 202605,
        "valor": 1719977.0,
        "delta": -27698.0
      },
      {
        "periodo": 202606,
        "valor": 2205167.0,
        "delta": 485190.0
      },
      {
        "periodo": 202607,
        "valor": 2508121.0,
        "delta": 302954.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 114859.0,
    "valor_anterior": 480059.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 715221.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 655681.0,
        "delta": -59540.0
      },
      {
        "periodo": 202509,
        "valor": 1470076.0,
        "delta": 814395.0
      },
      {
        "periodo": 202510,
        "valor": 832006.0,
        "delta": -638070.0
      },
      {
        "periodo": 202511,
        "valor": 746247.0,
        "delta": -85759.0
      },
      {
        "periodo": 202512,
        "valor": 304933.0,
        "delta": -441314.0
      },
      {
        "periodo": 202601,
        "valor": 104346.0,
        "delta": -200587.0
      },
      {
        "periodo": 202602,
        "valor": 769166.0,
        "delta": 664820.0
      },
      {
        "periodo": 202603,
        "valor": 459410.0,
        "delta": -309756.0
      },
      {
        "periodo": 202604,
        "valor": 481627.0,
        "delta": 22217.0
      },
      {
        "periodo": 202605,
        "valor": 462279.0,
        "delta": -19348.0
      },
      {
        "periodo": 202606,
        "valor": 480059.0,
        "delta": 17780.0
      },
      {
        "periodo": 202607,
        "valor": 114859.0,
        "delta": -365200.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 39976780.68000001,
    "valor_anterior": 48691139.53,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 35357290.75,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 30089796.13,
        "delta": -5267494.62
      },
      {
        "periodo": 202509,
        "valor": 39693439.59,
        "delta": 9603643.46
      },
      {
        "periodo": 202510,
        "valor": 33859652.86,
        "delta": -5833786.73
      },
      {
        "periodo": 202511,
        "valor": 48973443.96,
        "delta": 15113791.1
      },
      {
        "periodo": 202512,
        "valor": 68417411.01,
        "delta": 19443967.05
      },
      {
        "periodo": 202601,
        "valor": 25644023.4,
        "delta": -42773387.61
      },
      {
        "periodo": 202602,
        "valor": 27588202.79,
        "delta": 1944179.39
      },
      {
        "periodo": 202603,
        "valor": 31969228.27,
        "delta": 4381025.48
      },
      {
        "periodo": 202604,
        "valor": 35504935.1,
        "delta": 3535706.83
      },
      {
        "periodo": 202605,
        "valor": 35066328.75,
        "delta": -438606.35
      },
      {
        "periodo": 202606,
        "valor": 48691139.53,
        "delta": 13624810.78
      },
      {
        "periodo": 202607,
        "valor": 39976780.68,
        "delta": -8714358.85
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 3742692.0,
    "valor_anterior": 2261585.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1406272.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3249653.0,
        "delta": 1843381.0
      },
      {
        "periodo": 202509,
        "valor": 1592862.0,
        "delta": -1656791.0
      },
      {
        "periodo": 202510,
        "valor": 2326846.0,
        "delta": 733984.0
      },
      {
        "periodo": 202511,
        "valor": 878794.0,
        "delta": -1448052.0
      },
      {
        "periodo": 202512,
        "valor": 3220929.0,
        "delta": 2342135.0
      },
      {
        "periodo": 202601,
        "valor": 641239.0,
        "delta": -2579690.0
      },
      {
        "periodo": 202602,
        "valor": 2247428.0,
        "delta": 1606189.0
      },
      {
        "periodo": 202603,
        "valor": 2002884.0,
        "delta": -244544.0
      },
      {
        "periodo": 202604,
        "valor": 1796744.0,
        "delta": -206140.0
      },
      {
        "periodo": 202605,
        "valor": 2216979.0,
        "delta": 420235.0
      },
      {
        "periodo": 202606,
        "valor": 2261585.0,
        "delta": 44606.0
      },
      {
        "periodo": 202607,
        "valor": 3742692.0,
        "delta": 1481107.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 11389167.879999995,
    "valor_anterior": 16286933.630000003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8480793.58,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10276398.13,
        "delta": 1795604.55
      },
      {
        "periodo": 202509,
        "valor": 13633890.91,
        "delta": 3357492.78
      },
      {
        "periodo": 202510,
        "valor": 9507552.53,
        "delta": -4126338.38
      },
      {
        "periodo": 202511,
        "valor": 12839609.8,
        "delta": 3332057.27
      },
      {
        "periodo": 202512,
        "valor": 20655189.1,
        "delta": 7815579.3
      },
      {
        "periodo": 202601,
        "valor": 10252045.97,
        "delta": -10403143.13
      },
      {
        "periodo": 202602,
        "valor": 9855062.97,
        "delta": -396983.0
      },
      {
        "periodo": 202603,
        "valor": 14550727.02,
        "delta": 4695664.05
      },
      {
        "periodo": 202604,
        "valor": 14686998.8,
        "delta": 136271.78
      },
      {
        "periodo": 202605,
        "valor": 12480648.5,
        "delta": -2206350.3
      },
      {
        "periodo": 202606,
        "valor": 16286933.63,
        "delta": 3806285.13
      },
      {
        "periodo": 202607,
        "valor": 11389167.88,
        "delta": -4897765.75
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 2555021.469999999,
    "valor_anterior": 2800262.0200000014,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1669302.14,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1057165.17,
        "delta": -612136.97
      },
      {
        "periodo": 202509,
        "valor": 3351901.35,
        "delta": 2294736.18
      },
      {
        "periodo": 202510,
        "valor": 1363191.43,
        "delta": -1988709.92
      },
      {
        "periodo": 202511,
        "valor": 4747974.27,
        "delta": 3384782.84
      },
      {
        "periodo": 202512,
        "valor": 2609310.42,
        "delta": -2138663.85
      },
      {
        "periodo": 202601,
        "valor": 1869135.52,
        "delta": -740174.9
      },
      {
        "periodo": 202602,
        "valor": 2457614.25,
        "delta": 588478.73
      },
      {
        "periodo": 202603,
        "valor": 2759730.1,
        "delta": 302115.85
      },
      {
        "periodo": 202604,
        "valor": 2498098.71,
        "delta": -261631.39
      },
      {
        "periodo": 202605,
        "valor": 3907162.79,
        "delta": 1409064.08
      },
      {
        "periodo": 202606,
        "valor": 2800262.02,
        "delta": -1106900.77
      },
      {
        "periodo": 202607,
        "valor": 2555021.47,
        "delta": -245240.55
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 772233.0,
    "valor_anterior": 1001920.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1187953.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 141591.0,
        "delta": -1046362.0
      },
      {
        "periodo": 202509,
        "valor": 1127631.0,
        "delta": 986040.0
      },
      {
        "periodo": 202510,
        "valor": 1821268.0,
        "delta": 693637.0
      },
      {
        "periodo": 202511,
        "valor": 175331.0,
        "delta": -1645937.0
      },
      {
        "periodo": 202512,
        "valor": 1366502.0,
        "delta": 1191171.0
      },
      {
        "periodo": 202601,
        "valor": 971699.0,
        "delta": -394803.0
      },
      {
        "periodo": 202602,
        "valor": 252572.0,
        "delta": -719127.0
      },
      {
        "periodo": 202603,
        "valor": 1426555.0,
        "delta": 1173983.0
      },
      {
        "periodo": 202604,
        "valor": 1254028.0,
        "delta": -172527.0
      },
      {
        "periodo": 202605,
        "valor": 441058.0,
        "delta": -812970.0
      },
      {
        "periodo": 202606,
        "valor": 1001920.0,
        "delta": 560862.0
      },
      {
        "periodo": 202607,
        "valor": 772233.0,
        "delta": -229687.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 98273089.0,
    "valor_anterior": 42534307.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 42081518.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 32706468.0,
        "delta": -9375050.0
      },
      {
        "periodo": 202509,
        "valor": 39369988.0,
        "delta": 6663520.0
      },
      {
        "periodo": 202510,
        "valor": 54274298.0,
        "delta": 14904310.0
      },
      {
        "periodo": 202511,
        "valor": 27357772.0,
        "delta": -26916526.0
      },
      {
        "periodo": 202512,
        "valor": 127636505.0,
        "delta": 100278733.0
      },
      {
        "periodo": 202601,
        "valor": 65860646.0,
        "delta": -61775859.0
      },
      {
        "periodo": 202602,
        "valor": 29940635.0,
        "delta": -35920011.0
      },
      {
        "periodo": 202603,
        "valor": 45917268.0,
        "delta": 15976633.0
      },
      {
        "periodo": 202604,
        "valor": 59502573.0,
        "delta": 13585305.0
      },
      {
        "periodo": 202605,
        "valor": 49422991.0,
        "delta": -10079582.0
      },
      {
        "periodo": 202606,
        "valor": 42534307.0,
        "delta": -6888684.0
      },
      {
        "periodo": 202607,
        "valor": 98273089.0,
        "delta": 55738782.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 123309.0,
    "valor_anterior": 94450.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 205295.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 156316.0,
        "delta": -48979.0
      },
      {
        "periodo": 202509,
        "valor": 174108.0,
        "delta": 17792.0
      },
      {
        "periodo": 202510,
        "valor": 164354.0,
        "delta": -9754.0
      },
      {
        "periodo": 202511,
        "valor": 166322.0,
        "delta": 1968.0
      },
      {
        "periodo": 202512,
        "valor": 279631.0,
        "delta": 113309.0
      },
      {
        "periodo": 202601,
        "valor": 215177.0,
        "delta": -64454.0
      },
      {
        "periodo": 202602,
        "valor": 136579.0,
        "delta": -78598.0
      },
      {
        "periodo": 202603,
        "valor": 137224.0,
        "delta": 645.0
      },
      {
        "periodo": 202604,
        "valor": 135316.0,
        "delta": -1908.0
      },
      {
        "periodo": 202605,
        "valor": 116203.0,
        "delta": -19113.0
      },
      {
        "periodo": 202606,
        "valor": 94450.0,
        "delta": -21753.0
      },
      {
        "periodo": 202607,
        "valor": 123309.0,
        "delta": 28859.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 7122145.900000006,
    "valor_anterior": 6893594.890000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12202691.92,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13944026.58,
        "delta": 1741334.66
      },
      {
        "periodo": 202509,
        "valor": 13771081.48,
        "delta": -172945.1
      },
      {
        "periodo": 202510,
        "valor": 12978455.83,
        "delta": -792625.65
      },
      {
        "periodo": 202511,
        "valor": 12514245.43,
        "delta": -464210.4
      },
      {
        "periodo": 202512,
        "valor": 12648705.08,
        "delta": 134459.65
      },
      {
        "periodo": 202601,
        "valor": 19062562.04,
        "delta": 6413856.96
      },
      {
        "periodo": 202602,
        "valor": 12491772.36,
        "delta": -6570789.68
      },
      {
        "periodo": 202603,
        "valor": 11640781.65,
        "delta": -850990.71
      },
      {
        "periodo": 202604,
        "valor": 18650116.86,
        "delta": 7009335.21
      },
      {
        "periodo": 202605,
        "valor": 6464274.09,
        "delta": -12185842.77
      },
      {
        "periodo": 202606,
        "valor": 6893594.89,
        "delta": 429320.8
      },
      {
        "periodo": 202607,
        "valor": 7122145.9,
        "delta": 228551.01
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 397556.72000000067,
    "valor_anterior": 2792246.1899999995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1299191.49,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28863.63,
        "delta": -1270327.86
      },
      {
        "periodo": 202509,
        "valor": 1987859.35,
        "delta": 1958995.72
      },
      {
        "periodo": 202510,
        "valor": 725126.83,
        "delta": -1262732.52
      },
      {
        "periodo": 202511,
        "valor": 32128.23,
        "delta": -692998.6
      },
      {
        "periodo": 202512,
        "valor": 4026253.55,
        "delta": 3994125.32
      },
      {
        "periodo": 202601,
        "valor": 1178894.32,
        "delta": -2847359.23
      },
      {
        "periodo": 202602,
        "valor": 29183.52,
        "delta": -1149710.8
      },
      {
        "periodo": 202603,
        "valor": 3824117.64,
        "delta": 3794934.12
      },
      {
        "periodo": 202604,
        "valor": 2698224.33,
        "delta": -1125893.31
      },
      {
        "periodo": 202605,
        "valor": 1879628.25,
        "delta": -818596.08
      },
      {
        "periodo": 202606,
        "valor": 2792246.19,
        "delta": 912617.94
      },
      {
        "periodo": 202607,
        "valor": 397556.72,
        "delta": -2394689.47
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 48576479.0,
    "valor_anterior": 51863301.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 44893476.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 47509612.0,
        "delta": 2616136.0
      },
      {
        "periodo": 202509,
        "valor": 44227050.0,
        "delta": -3282562.0
      },
      {
        "periodo": 202510,
        "valor": 46293535.0,
        "delta": 2066485.0
      },
      {
        "periodo": 202511,
        "valor": 43410253.0,
        "delta": -2883282.0
      },
      {
        "periodo": 202512,
        "valor": 46308890.0,
        "delta": 2898637.0
      },
      {
        "periodo": 202601,
        "valor": 46481205.0,
        "delta": 172315.0
      },
      {
        "periodo": 202602,
        "valor": 45469465.0,
        "delta": -1011740.0
      },
      {
        "periodo": 202603,
        "valor": 47501840.0,
        "delta": 2032375.0
      },
      {
        "periodo": 202604,
        "valor": 47903116.0,
        "delta": 401276.0
      },
      {
        "periodo": 202605,
        "valor": 47205364.0,
        "delta": -697752.0
      },
      {
        "periodo": 202606,
        "valor": 51863301.0,
        "delta": 4657937.0
      },
      {
        "periodo": 202607,
        "valor": 48576479.0,
        "delta": -3286822.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 124.0,
        "delta": 124.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -124.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": -1626287.0,
    "valor_anterior": 158809885.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19722299.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15670111.0,
        "delta": -4052188.0
      },
      {
        "periodo": 202509,
        "valor": 40848465.0,
        "delta": 25178354.0
      },
      {
        "periodo": 202510,
        "valor": 15633709.0,
        "delta": -25214756.0
      },
      {
        "periodo": 202511,
        "valor": 15275370.0,
        "delta": -358339.0
      },
      {
        "periodo": 202512,
        "valor": 86207694.0,
        "delta": 70932324.0
      },
      {
        "periodo": 202601,
        "valor": 23788054.0,
        "delta": -62419640.0
      },
      {
        "periodo": 202602,
        "valor": 15137982.0,
        "delta": -8650072.0
      },
      {
        "periodo": 202603,
        "valor": 81898920.0,
        "delta": 66760938.0
      },
      {
        "periodo": 202604,
        "valor": 3322391.0,
        "delta": -78576529.0
      },
      {
        "periodo": 202605,
        "valor": 20471304.0,
        "delta": 17148913.0
      },
      {
        "periodo": 202606,
        "valor": 158809885.0,
        "delta": 138338581.0
      },
      {
        "periodo": 202607,
        "valor": -1626287.0,
        "delta": -160436172.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 67123.14000000001,
    "valor_anterior": 60471.04999999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 76075.1,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 67016.12,
        "delta": -9058.98
      },
      {
        "periodo": 202509,
        "valor": 82141.08,
        "delta": 15124.96
      },
      {
        "periodo": 202510,
        "valor": 100135.92,
        "delta": 17994.84
      },
      {
        "periodo": 202511,
        "valor": 84265.8,
        "delta": -15870.12
      },
      {
        "periodo": 202512,
        "valor": 103980.16,
        "delta": 19714.36
      },
      {
        "periodo": 202601,
        "valor": 81806.21,
        "delta": -22173.95
      },
      {
        "periodo": 202602,
        "valor": 63001.36,
        "delta": -18804.85
      },
      {
        "periodo": 202603,
        "valor": 69379.26,
        "delta": 6377.9
      },
      {
        "periodo": 202604,
        "valor": 61491.97,
        "delta": -7887.29
      },
      {
        "periodo": 202605,
        "valor": 54636.53,
        "delta": -6855.44
      },
      {
        "periodo": 202606,
        "valor": 60471.05,
        "delta": 5834.52
      },
      {
        "periodo": 202607,
        "valor": 67123.14,
        "delta": 6652.09
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 223651666.4599998,
    "valor_anterior": 239141927.43000007,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 185397294.36,
        "delta": 185397294.36
      },
      {
        "periodo": 202603,
        "valor": 231516750.3,
        "delta": 46119455.94
      },
      {
        "periodo": 202604,
        "valor": 228849199.13,
        "delta": -2667551.17
      },
      {
        "periodo": 202605,
        "valor": 211202037.94,
        "delta": -17647161.19
      },
      {
        "periodo": 202606,
        "valor": 239141927.43,
        "delta": 27939889.49
      },
      {
        "periodo": 202607,
        "valor": 223651666.46,
        "delta": -15490260.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 13105850.0,
    "valor_anterior": 6817574.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2090655.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2694679.0,
        "delta": 604024.0
      },
      {
        "periodo": 202509,
        "valor": 3816659.0,
        "delta": 1121980.0
      },
      {
        "periodo": 202510,
        "valor": 4111220.0,
        "delta": 294561.0
      },
      {
        "periodo": 202511,
        "valor": 4304957.0,
        "delta": 193737.0
      },
      {
        "periodo": 202512,
        "valor": 5119021.0,
        "delta": 814064.0
      },
      {
        "periodo": 202601,
        "valor": 4631862.0,
        "delta": -487159.0
      },
      {
        "periodo": 202602,
        "valor": 4877704.0,
        "delta": 245842.0
      },
      {
        "periodo": 202603,
        "valor": 5858287.0,
        "delta": 980583.0
      },
      {
        "periodo": 202604,
        "valor": 5864553.0,
        "delta": 6266.0
      },
      {
        "periodo": 202605,
        "valor": 6056443.0,
        "delta": 191890.0
      },
      {
        "periodo": 202606,
        "valor": 6817574.0,
        "delta": 761131.0
      },
      {
        "periodo": 202607,
        "valor": 13105850.0,
        "delta": 6288276.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 19605985.459999993,
    "valor_anterior": 13692144.550000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 157229.4,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 614411.87,
        "delta": 457182.47
      },
      {
        "periodo": 202601,
        "valor": 1380935.13,
        "delta": 766523.26
      },
      {
        "periodo": 202602,
        "valor": 3804165.31,
        "delta": 2423230.18
      },
      {
        "periodo": 202603,
        "valor": 6456349.67,
        "delta": 2652184.36
      },
      {
        "periodo": 202604,
        "valor": 8312855.67,
        "delta": 1856506.0
      },
      {
        "periodo": 202605,
        "valor": 10290552.12,
        "delta": 1977696.45
      },
      {
        "periodo": 202606,
        "valor": 13692144.55,
        "delta": 3401592.43
      },
      {
        "periodo": 202607,
        "valor": 19605985.46,
        "delta": 5913840.91
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 236579047.0,
    "valor_anterior": 129889983.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 497146249.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 172021514.0,
        "delta": -325124735.0
      },
      {
        "periodo": 202605,
        "valor": 186790490.0,
        "delta": 14768976.0
      },
      {
        "periodo": 202606,
        "valor": 129889983.0,
        "delta": -56900507.0
      },
      {
        "periodo": 202607,
        "valor": 236579047.0,
        "delta": 106689064.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 25172620904.670013,
    "valor_anterior": 26486694230.61998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 23808367624.86,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23820743253.8,
        "delta": 12375628.94
      },
      {
        "periodo": 202509,
        "valor": 24040407547.64,
        "delta": 219664293.84
      },
      {
        "periodo": 202510,
        "valor": 24348818496.82,
        "delta": 308410949.18
      },
      {
        "periodo": 202511,
        "valor": 24451541726.6,
        "delta": 102723229.78
      },
      {
        "periodo": 202512,
        "valor": 28663494889.36,
        "delta": 4211953162.76
      },
      {
        "periodo": 202601,
        "valor": 24673084263.17,
        "delta": -3990410626.19
      },
      {
        "periodo": 202602,
        "valor": 22772145732.52,
        "delta": -1900938530.65
      },
      {
        "periodo": 202603,
        "valor": 26697212245.85,
        "delta": 3925066513.33
      },
      {
        "periodo": 202604,
        "valor": 24800027853.91,
        "delta": -1897184391.94
      },
      {
        "periodo": 202605,
        "valor": 23837800868.11,
        "delta": -962226985.8
      },
      {
        "periodo": 202606,
        "valor": 26486694230.62,
        "delta": 2648893362.51
      },
      {
        "periodo": 202607,
        "valor": 25172620904.67,
        "delta": -1314073325.95
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 19862779287.609985,
    "valor_anterior": 20759432575.050003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19437758508.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18480210028.55,
        "delta": -957548479.45
      },
      {
        "periodo": 202509,
        "valor": 19103085549.67,
        "delta": 622875521.12
      },
      {
        "periodo": 202510,
        "valor": 19483943452.77,
        "delta": 380857903.1
      },
      {
        "periodo": 202511,
        "valor": 19826539036.67,
        "delta": 342595583.9
      },
      {
        "periodo": 202512,
        "valor": 22716002743.95,
        "delta": 2889463707.28
      },
      {
        "periodo": 202601,
        "valor": 20116778012.43,
        "delta": -2599224731.52
      },
      {
        "periodo": 202602,
        "valor": 18228476950.91,
        "delta": -1888301061.52
      },
      {
        "periodo": 202603,
        "valor": 20976844874.73,
        "delta": 2748367923.82
      },
      {
        "periodo": 202604,
        "valor": 19549276996.6,
        "delta": -1427567878.13
      },
      {
        "periodo": 202605,
        "valor": 18364010855.5,
        "delta": -1185266141.1
      },
      {
        "periodo": 202606,
        "valor": 20759432575.05,
        "delta": 2395421719.55
      },
      {
        "periodo": 202607,
        "valor": 19862779287.61,
        "delta": -896653287.44
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 73479360.88,
    "valor_anterior": 70789356.43,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 133611628.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 119719115.76,
        "delta": -13892513.11
      },
      {
        "periodo": 202509,
        "valor": -405247504.59,
        "delta": -524966620.35
      },
      {
        "periodo": 202510,
        "valor": 66789546.79,
        "delta": 472037051.38
      },
      {
        "periodo": 202511,
        "valor": 56920913.12,
        "delta": -9868633.67
      },
      {
        "periodo": 202512,
        "valor": 60041156.36,
        "delta": 3120243.24
      },
      {
        "periodo": 202601,
        "valor": 57525353.88,
        "delta": -2515802.48
      },
      {
        "periodo": 202602,
        "valor": 54452402.22,
        "delta": -3072951.66
      },
      {
        "periodo": 202603,
        "valor": 71073701.65,
        "delta": 16621299.43
      },
      {
        "periodo": 202604,
        "valor": 62918732.91,
        "delta": -8154968.74
      },
      {
        "periodo": 202605,
        "valor": 62938803.64,
        "delta": 20070.73
      },
      {
        "periodo": 202606,
        "valor": 70789356.43,
        "delta": 7850552.79
      },
      {
        "periodo": 202607,
        "valor": 73479360.88,
        "delta": 2690004.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 1736776008.380001,
    "valor_anterior": 2170527596.76,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1289217086.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2404757159.02,
        "delta": 1115540073.02
      },
      {
        "periodo": 202509,
        "valor": 2431612842.03,
        "delta": 26855683.01
      },
      {
        "periodo": 202510,
        "valor": 1698968655.98,
        "delta": -732644186.05
      },
      {
        "periodo": 202511,
        "valor": 1565020753.31,
        "delta": -133947902.67
      },
      {
        "periodo": 202512,
        "valor": 2296566139.2,
        "delta": 731545385.89
      },
      {
        "periodo": 202601,
        "valor": 1596762529.96,
        "delta": -699803609.24
      },
      {
        "periodo": 202602,
        "valor": 1685612276.73,
        "delta": 88849746.77
      },
      {
        "periodo": 202603,
        "valor": 1891000083.4,
        "delta": 205387806.67
      },
      {
        "periodo": 202604,
        "valor": 1786082818.56,
        "delta": -104917264.84
      },
      {
        "periodo": 202605,
        "valor": 2067039494.15,
        "delta": 280956675.59
      },
      {
        "periodo": 202606,
        "valor": 2170527596.76,
        "delta": 103488102.61
      },
      {
        "periodo": 202607,
        "valor": 1736776008.38,
        "delta": -433751588.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 1054689366.1399994,
    "valor_anterior": 1127879506.2399998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1137137637.04,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1115369266.7,
        "delta": -21768370.34
      },
      {
        "periodo": 202509,
        "valor": 1194371552.36,
        "delta": 79002285.66
      },
      {
        "periodo": 202510,
        "valor": 1258019869.47,
        "delta": 63648317.11
      },
      {
        "periodo": 202511,
        "valor": 1201561812.58,
        "delta": -56458056.89
      },
      {
        "periodo": 202512,
        "valor": 1610773249.71,
        "delta": 409211437.13
      },
      {
        "periodo": 202601,
        "valor": 1172404764.9,
        "delta": -438368484.81
      },
      {
        "periodo": 202602,
        "valor": 895832164.6,
        "delta": -276572600.3
      },
      {
        "periodo": 202603,
        "valor": 1082902559.93,
        "delta": 187070395.33
      },
      {
        "periodo": 202604,
        "valor": 1060969212.8,
        "delta": -21933347.13
      },
      {
        "periodo": 202605,
        "valor": 1043454809.62,
        "delta": -17514403.18
      },
      {
        "periodo": 202606,
        "valor": 1127879506.24,
        "delta": 84424696.62
      },
      {
        "periodo": 202607,
        "valor": 1054689366.14,
        "delta": -73190140.1
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 338923594.64999986,
    "valor_anterior": 372124285.26,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 295005895.45,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 317800842.35,
        "delta": 22794946.9
      },
      {
        "periodo": 202509,
        "valor": 325398545.22,
        "delta": 7597702.87
      },
      {
        "periodo": 202510,
        "valor": 301253122.48,
        "delta": -24145422.74
      },
      {
        "periodo": 202511,
        "valor": 310328057.69,
        "delta": 9074935.21
      },
      {
        "periodo": 202512,
        "valor": 375657510.16,
        "delta": 65329452.47
      },
      {
        "periodo": 202601,
        "valor": 335480142.25,
        "delta": -40177367.91
      },
      {
        "periodo": 202602,
        "valor": 318321981.89,
        "delta": -17158160.36
      },
      {
        "periodo": 202603,
        "valor": 371533819.68,
        "delta": 53211837.79
      },
      {
        "periodo": 202604,
        "valor": 337945652.8,
        "delta": -33588166.88
      },
      {
        "periodo": 202605,
        "valor": 347134517.38,
        "delta": 9188864.58
      },
      {
        "periodo": 202606,
        "valor": 372124285.26,
        "delta": 24989767.88
      },
      {
        "periodo": 202607,
        "valor": 338923594.65,
        "delta": -33200690.61
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100010,
    "label": "Comisiones y Tarifas Cobradas",
    "valor_actual": 2105973287.0100002,
    "valor_anterior": 1985940910.8799973,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1515636869.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1382886841.42,
        "delta": -132750028.08
      },
      {
        "periodo": 202509,
        "valor": 1391186562.95,
        "delta": 8299721.53
      },
      {
        "periodo": 202510,
        "valor": 1539843849.33,
        "delta": 148657286.38
      },
      {
        "periodo": 202511,
        "valor": 1491171153.23,
        "delta": -48672696.1
      },
      {
        "periodo": 202512,
        "valor": 1604454089.98,
        "delta": 113282936.75
      },
      {
        "periodo": 202601,
        "valor": 1394133459.75,
        "delta": -210320630.23
      },
      {
        "periodo": 202602,
        "valor": 1589449956.17,
        "delta": 195316496.42
      },
      {
        "periodo": 202603,
        "valor": 2303857206.46,
        "delta": 714407250.29
      },
      {
        "periodo": 202604,
        "valor": 2002834440.24,
        "delta": -301022766.22
      },
      {
        "periodo": 202605,
        "valor": 1953222387.82,
        "delta": -49612052.42
      },
      {
        "periodo": 202606,
        "valor": 1985940910.88,
        "delta": 32718523.06
      },
      {
        "periodo": 202607,
        "valor": 2105973287.01,
        "delta": 120032376.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 5953564058.779999,
    "valor_anterior": 4769040243.529999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6485690107.85,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6738229698.41,
        "delta": 252539590.56
      },
      {
        "periodo": 202509,
        "valor": 6412816068.21,
        "delta": -325413630.2
      },
      {
        "periodo": 202510,
        "valor": 6547337288.15,
        "delta": 134521219.94
      },
      {
        "periodo": 202511,
        "valor": 2850834731.42,
        "delta": -3696502556.73
      },
      {
        "periodo": 202512,
        "valor": 7107966430.24,
        "delta": 4257131698.82
      },
      {
        "periodo": 202601,
        "valor": 6404058169.76,
        "delta": -703908260.48
      },
      {
        "periodo": 202602,
        "valor": 6651670719.56,
        "delta": 247612549.8
      },
      {
        "periodo": 202603,
        "valor": 6411605393.24,
        "delta": -240065326.32
      },
      {
        "periodo": 202604,
        "valor": 6710028423.74,
        "delta": 298423030.5
      },
      {
        "periodo": 202605,
        "valor": 5063840220.78,
        "delta": -1646188202.96
      },
      {
        "periodo": 202606,
        "valor": 4769040243.53,
        "delta": -294799977.25
      },
      {
        "periodo": 202607,
        "valor": 5953564058.78,
        "delta": 1184523815.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 8819353874.68,
    "valor_anterior": 8414965176.300011,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7940857758.94,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7958387873.9,
        "delta": 17530114.96
      },
      {
        "periodo": 202509,
        "valor": 7604319966.06,
        "delta": -354067907.84
      },
      {
        "periodo": 202510,
        "valor": 8166750926.87,
        "delta": 562430960.81
      },
      {
        "periodo": 202511,
        "valor": 7959605346.4,
        "delta": -207145580.47
      },
      {
        "periodo": 202512,
        "valor": 9319457058.59,
        "delta": 1359851712.19
      },
      {
        "periodo": 202601,
        "valor": 8566417023.27,
        "delta": -753040035.32
      },
      {
        "periodo": 202602,
        "valor": 8631065040.3,
        "delta": 64648017.03
      },
      {
        "periodo": 202603,
        "valor": 8982183198.23,
        "delta": 351118157.93
      },
      {
        "periodo": 202604,
        "valor": 8447927668.16,
        "delta": -534255530.07
      },
      {
        "periodo": 202605,
        "valor": 8439613069.75,
        "delta": -8314598.41
      },
      {
        "periodo": 202606,
        "valor": 8414965176.3,
        "delta": -24647893.45
      },
      {
        "periodo": 202607,
        "valor": 8819353874.68,
        "delta": 404388698.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 4348412293.0,
    "valor_anterior": 4285617728.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4442058626.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4408878867.0,
        "delta": -33179759.0
      },
      {
        "periodo": 202509,
        "valor": 4137298472.0,
        "delta": -271580395.0
      },
      {
        "periodo": 202510,
        "valor": 4652077564.0,
        "delta": 514779092.0
      },
      {
        "periodo": 202511,
        "valor": 4637562918.0,
        "delta": -14514646.0
      },
      {
        "periodo": 202512,
        "valor": 4943120905.0,
        "delta": 305557987.0
      },
      {
        "periodo": 202601,
        "valor": 4021849364.0,
        "delta": -921271541.0
      },
      {
        "periodo": 202602,
        "valor": 4063070722.0,
        "delta": 41221358.0
      },
      {
        "periodo": 202603,
        "valor": 4609856335.0,
        "delta": 546785613.0
      },
      {
        "periodo": 202604,
        "valor": 4276353538.0,
        "delta": -333502797.0
      },
      {
        "periodo": 202605,
        "valor": 4339306346.0,
        "delta": 62952808.0
      },
      {
        "periodo": 202606,
        "valor": 4285617728.0,
        "delta": -53688618.0
      },
      {
        "periodo": 202607,
        "valor": 4348412293.0,
        "delta": 62794565.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 2989256467.0,
    "valor_anterior": 3493988830.000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2841945127.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3037168399.0,
        "delta": 195223272.0
      },
      {
        "periodo": 202509,
        "valor": 2866883334.0,
        "delta": -170285065.0
      },
      {
        "periodo": 202510,
        "valor": 3083652680.0,
        "delta": 216769346.0
      },
      {
        "periodo": 202511,
        "valor": 3163254876.0,
        "delta": 79602196.0
      },
      {
        "periodo": 202512,
        "valor": 4050002016.5,
        "delta": 886747140.5
      },
      {
        "periodo": 202601,
        "valor": 3027023456.0,
        "delta": -1022978560.5
      },
      {
        "periodo": 202602,
        "valor": 2854925934.0,
        "delta": -172097522.0
      },
      {
        "periodo": 202603,
        "valor": 3248947927.0,
        "delta": 394021993.0
      },
      {
        "periodo": 202604,
        "valor": 3189501881.0,
        "delta": -59446046.0
      },
      {
        "periodo": 202605,
        "valor": 3728212804.0,
        "delta": 538710923.0
      },
      {
        "periodo": 202606,
        "valor": 3493988830.0,
        "delta": -234223974.0
      },
      {
        "periodo": 202607,
        "valor": 2989256467.0,
        "delta": -504732363.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 890764843.9800005,
    "valor_anterior": 872517582.6999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 810588822.96,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 851065060.94,
        "delta": 40476237.98
      },
      {
        "periodo": 202509,
        "valor": 826224433.96,
        "delta": -24840626.98
      },
      {
        "periodo": 202510,
        "valor": 838867764.02,
        "delta": 12643330.06
      },
      {
        "periodo": 202511,
        "valor": 873876068.61,
        "delta": 35008304.59
      },
      {
        "periodo": 202512,
        "valor": 951317221.25,
        "delta": 77441152.64
      },
      {
        "periodo": 202601,
        "valor": 831494017.06,
        "delta": -119823204.19
      },
      {
        "periodo": 202602,
        "valor": 826687851.54,
        "delta": -4806165.52
      },
      {
        "periodo": 202603,
        "valor": 892790467.9,
        "delta": 66102616.36
      },
      {
        "periodo": 202604,
        "valor": 886482494.42,
        "delta": -6307973.48
      },
      {
        "periodo": 202605,
        "valor": 873115620.57,
        "delta": -13366873.85
      },
      {
        "periodo": 202606,
        "valor": 872517582.7,
        "delta": -598037.87
      },
      {
        "periodo": 202607,
        "valor": 890764843.98,
        "delta": 18247261.28
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 903182116.0,
    "valor_anterior": 905086056.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 938473347.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 894658492.0,
        "delta": -43814855.0
      },
      {
        "periodo": 202509,
        "valor": 828951470.0,
        "delta": -65707022.0
      },
      {
        "periodo": 202510,
        "valor": 910108143.0,
        "delta": 81156673.0
      },
      {
        "periodo": 202511,
        "valor": 867537535.0,
        "delta": -42570608.0
      },
      {
        "periodo": 202512,
        "valor": 642698443.0,
        "delta": -224839092.0
      },
      {
        "periodo": 202601,
        "valor": 920178467.0,
        "delta": 277480024.0
      },
      {
        "periodo": 202602,
        "valor": 874471994.0,
        "delta": -45706473.0
      },
      {
        "periodo": 202603,
        "valor": 931364796.0,
        "delta": 56892802.0
      },
      {
        "periodo": 202604,
        "valor": 898284351.0,
        "delta": -33080445.0
      },
      {
        "periodo": 202605,
        "valor": 928280120.0,
        "delta": 29995769.0
      },
      {
        "periodo": 202606,
        "valor": 905086056.0,
        "delta": -23194064.0
      },
      {
        "periodo": 202607,
        "valor": 903182116.0,
        "delta": -1903940.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 366993255.0,
    "valor_anterior": 310496214.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 288983741.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 301813047.0,
        "delta": 12829306.0
      },
      {
        "periodo": 202509,
        "valor": 256817471.0,
        "delta": -44995576.0
      },
      {
        "periodo": 202510,
        "valor": 352781684.0,
        "delta": 95964213.0
      },
      {
        "periodo": 202511,
        "valor": 358091914.0,
        "delta": 5310230.0
      },
      {
        "periodo": 202512,
        "valor": 342345378.0,
        "delta": -15746536.0
      },
      {
        "periodo": 202601,
        "valor": 284483236.0,
        "delta": -57862142.0
      },
      {
        "periodo": 202602,
        "valor": 283191638.0,
        "delta": -1291598.0
      },
      {
        "periodo": 202603,
        "valor": 309266071.0,
        "delta": 26074433.0
      },
      {
        "periodo": 202604,
        "valor": 316230307.0,
        "delta": 6964236.0
      },
      {
        "periodo": 202605,
        "valor": 345353071.0,
        "delta": 29122764.0
      },
      {
        "periodo": 202606,
        "valor": 310496214.0,
        "delta": -34856857.0
      },
      {
        "periodo": 202607,
        "valor": 366993255.0,
        "delta": 56497041.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 1864509299.0,
    "valor_anterior": 1798861021.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1663965009.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1579559207.0,
        "delta": -84405802.0
      },
      {
        "periodo": 202509,
        "valor": 1493596568.0,
        "delta": -85962639.0
      },
      {
        "periodo": 202510,
        "valor": 1838388134.0,
        "delta": 344791566.0
      },
      {
        "periodo": 202511,
        "valor": 1617626978.0,
        "delta": -220761156.0
      },
      {
        "periodo": 202512,
        "valor": 1815596237.0,
        "delta": 197969259.0
      },
      {
        "periodo": 202601,
        "valor": 1678378069.0,
        "delta": -137218168.0
      },
      {
        "periodo": 202602,
        "valor": 1682546118.0,
        "delta": 4168049.0
      },
      {
        "periodo": 202603,
        "valor": 1753435691.0,
        "delta": 70889573.0
      },
      {
        "periodo": 202604,
        "valor": 1789630122.0,
        "delta": 36194431.0
      },
      {
        "periodo": 202605,
        "valor": 1797988024.0,
        "delta": 8357902.0
      },
      {
        "periodo": 202606,
        "valor": 1798861021.0,
        "delta": 872997.0
      },
      {
        "periodo": 202607,
        "valor": 1864509299.0,
        "delta": 65648278.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 578311411.0400004,
    "valor_anterior": 575181534.2599998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 618372292.05,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 621418913.73,
        "delta": 3046621.68
      },
      {
        "periodo": 202509,
        "valor": 637986861.76,
        "delta": 16567948.03
      },
      {
        "periodo": 202510,
        "valor": 632729129.34,
        "delta": -5257732.42
      },
      {
        "periodo": 202511,
        "valor": 703437107.22,
        "delta": 70707977.88
      },
      {
        "periodo": 202512,
        "valor": 721339478.99,
        "delta": 17902371.77
      },
      {
        "periodo": 202601,
        "valor": 637643466.06,
        "delta": -83696012.93
      },
      {
        "periodo": 202602,
        "valor": 612578787.93,
        "delta": -25064678.13
      },
      {
        "periodo": 202603,
        "valor": 588797123.01,
        "delta": -23781664.92
      },
      {
        "periodo": 202604,
        "valor": 630781020.07,
        "delta": 41983897.06
      },
      {
        "periodo": 202605,
        "valor": 588938157.16,
        "delta": -41842862.91
      },
      {
        "periodo": 202606,
        "valor": 575181534.26,
        "delta": -13756622.9
      },
      {
        "periodo": 202607,
        "valor": 578311411.04,
        "delta": 3129876.78
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 679206353.0,
    "valor_anterior": 691252684.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 573532156.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 538058451.0,
        "delta": -35473705.0
      },
      {
        "periodo": 202509,
        "valor": 614879704.0,
        "delta": 76821253.0
      },
      {
        "periodo": 202510,
        "valor": 596102251.0,
        "delta": -18777453.0
      },
      {
        "periodo": 202511,
        "valor": 568497639.0,
        "delta": -27604612.0
      },
      {
        "periodo": 202512,
        "valor": 735842714.0,
        "delta": 167345075.0
      },
      {
        "periodo": 202601,
        "valor": 557551552.0,
        "delta": -178291162.0
      },
      {
        "periodo": 202602,
        "valor": 663541961.0,
        "delta": 105990409.0
      },
      {
        "periodo": 202603,
        "valor": 703636684.0,
        "delta": 40094723.0
      },
      {
        "periodo": 202604,
        "valor": 685493521.0,
        "delta": -18143163.0
      },
      {
        "periodo": 202605,
        "valor": 706110393.0,
        "delta": 20616872.0
      },
      {
        "periodo": 202606,
        "valor": 691252684.0,
        "delta": -14857709.0
      },
      {
        "periodo": 202607,
        "valor": 679206353.0,
        "delta": -12046331.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 89711382.0,
    "valor_anterior": 98672911.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 125707221.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 82773626.0,
        "delta": -42933595.0
      },
      {
        "periodo": 202509,
        "valor": 128276593.0,
        "delta": 45502967.0
      },
      {
        "periodo": 202510,
        "valor": 122035220.0,
        "delta": -6241373.0
      },
      {
        "periodo": 202511,
        "valor": 55954217.0,
        "delta": -66081003.0
      },
      {
        "periodo": 202512,
        "valor": 124611696.0,
        "delta": 68657479.0
      },
      {
        "periodo": 202601,
        "valor": 99268628.0,
        "delta": -25343068.0
      },
      {
        "periodo": 202602,
        "valor": 88598327.0,
        "delta": -10670301.0
      },
      {
        "periodo": 202603,
        "valor": 141165264.0,
        "delta": 52566937.0
      },
      {
        "periodo": 202604,
        "valor": 114634967.0,
        "delta": -26530297.0
      },
      {
        "periodo": 202605,
        "valor": 100666783.0,
        "delta": -13968184.0
      },
      {
        "periodo": 202606,
        "valor": 98672911.0,
        "delta": -1993872.0
      },
      {
        "periodo": 202607,
        "valor": 89711382.0,
        "delta": -8961529.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 531493466.0,
    "valor_anterior": 498635878.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 568156808.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 596615246.0,
        "delta": 28458438.0
      },
      {
        "periodo": 202509,
        "valor": 578662652.0,
        "delta": -17952594.0
      },
      {
        "periodo": 202510,
        "valor": 576052577.0,
        "delta": -2610075.0
      },
      {
        "periodo": 202511,
        "valor": 588840612.0,
        "delta": 12788035.0
      },
      {
        "periodo": 202512,
        "valor": 503114084.0,
        "delta": -85726528.0
      },
      {
        "periodo": 202601,
        "valor": 580979641.0,
        "delta": 77865557.0
      },
      {
        "periodo": 202602,
        "valor": 542132076.0,
        "delta": -38847565.0
      },
      {
        "periodo": 202603,
        "valor": 553510318.0,
        "delta": 11378242.0
      },
      {
        "periodo": 202604,
        "valor": 539395593.0,
        "delta": -14114725.0
      },
      {
        "periodo": 202605,
        "valor": 560275556.0,
        "delta": 20879963.0
      },
      {
        "periodo": 202606,
        "valor": 498635878.0,
        "delta": -61639678.0
      },
      {
        "periodo": 202607,
        "valor": 531493466.0,
        "delta": 32857588.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 4838245205.309998,
    "valor_anterior": 4739637069.240002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4331551246.55,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4493295255.47,
        "delta": 161744008.92
      },
      {
        "periodo": 202509,
        "valor": 4173229507.88,
        "delta": -320065747.59
      },
      {
        "periodo": 202510,
        "valor": 4545906844.96,
        "delta": 372677337.08
      },
      {
        "periodo": 202511,
        "valor": 4917065206.29,
        "delta": 371158361.33
      },
      {
        "periodo": 202512,
        "valor": 5123389247.28,
        "delta": 206324040.99
      },
      {
        "periodo": 202601,
        "valor": 4605911683.6,
        "delta": -517477563.68
      },
      {
        "periodo": 202602,
        "valor": 4578708979.07,
        "delta": -27202704.53
      },
      {
        "periodo": 202603,
        "valor": 4341221053.61,
        "delta": -237487925.46
      },
      {
        "periodo": 202604,
        "valor": 4755215495.3,
        "delta": 413994441.69
      },
      {
        "periodo": 202605,
        "valor": 4804102572.37,
        "delta": 48887077.07
      },
      {
        "periodo": 202606,
        "valor": 4739637069.24,
        "delta": -64465503.13
      },
      {
        "periodo": 202607,
        "valor": 4838245205.31,
        "delta": 98608136.07
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 115575904.0,
    "valor_anterior": 142934912.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 162659610.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 160824057.0,
        "delta": -1835553.0
      },
      {
        "periodo": 202509,
        "valor": 75958338.0,
        "delta": -84865719.0
      },
      {
        "periodo": 202510,
        "valor": 94734961.0,
        "delta": 18776623.0
      },
      {
        "periodo": 202511,
        "valor": 330186321.0,
        "delta": 235451360.0
      },
      {
        "periodo": 202512,
        "valor": 289063668.0,
        "delta": -41122653.0
      },
      {
        "periodo": 202601,
        "valor": 120710272.0,
        "delta": -168353396.0
      },
      {
        "periodo": 202602,
        "valor": 95191846.0,
        "delta": -25518426.0
      },
      {
        "periodo": 202603,
        "valor": 117154969.0,
        "delta": 21963123.0
      },
      {
        "periodo": 202604,
        "valor": 185482107.0,
        "delta": 68327138.0
      },
      {
        "periodo": 202605,
        "valor": 190302357.0,
        "delta": 4820250.0
      },
      {
        "periodo": 202606,
        "valor": 142934912.0,
        "delta": -47367445.0
      },
      {
        "periodo": 202607,
        "valor": 115575904.0,
        "delta": -27359008.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 100828496.0,
    "valor_anterior": 112890838.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 98405589.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 84616368.0,
        "delta": -13789221.0
      },
      {
        "periodo": 202509,
        "valor": 78996659.0,
        "delta": -5619709.0
      },
      {
        "periodo": 202510,
        "valor": 76413289.0,
        "delta": -2583370.0
      },
      {
        "periodo": 202511,
        "valor": 88039185.0,
        "delta": 11625896.0
      },
      {
        "periodo": 202512,
        "valor": 114133983.0,
        "delta": 26094798.0
      },
      {
        "periodo": 202601,
        "valor": 85138123.0,
        "delta": -28995860.0
      },
      {
        "periodo": 202602,
        "valor": 110256223.0,
        "delta": 25118100.0
      },
      {
        "periodo": 202603,
        "valor": 91363419.0,
        "delta": -18892804.0
      },
      {
        "periodo": 202604,
        "valor": 88618133.0,
        "delta": -2745286.0
      },
      {
        "periodo": 202605,
        "valor": 107976178.0,
        "delta": 19358045.0
      },
      {
        "periodo": 202606,
        "valor": 112890838.0,
        "delta": 4914660.0
      },
      {
        "periodo": 202607,
        "valor": 100828496.0,
        "delta": -12062342.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 193989539.0,
    "valor_anterior": 252420062.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 221734591.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 177540964.0,
        "delta": -44193627.0
      },
      {
        "periodo": 202509,
        "valor": 218020801.0,
        "delta": 40479837.0
      },
      {
        "periodo": 202510,
        "valor": 176248993.0,
        "delta": -41771808.0
      },
      {
        "periodo": 202511,
        "valor": 186258405.0,
        "delta": 10009412.0
      },
      {
        "periodo": 202512,
        "valor": 363025364.0,
        "delta": 176766959.0
      },
      {
        "periodo": 202601,
        "valor": 341135414.0,
        "delta": -21889950.0
      },
      {
        "periodo": 202602,
        "valor": 224499008.0,
        "delta": -116636406.0
      },
      {
        "periodo": 202603,
        "valor": 254891683.0,
        "delta": 30392675.0
      },
      {
        "periodo": 202604,
        "valor": 231190276.0,
        "delta": -23701407.0
      },
      {
        "periodo": 202605,
        "valor": 161053425.0,
        "delta": -70136851.0
      },
      {
        "periodo": 202606,
        "valor": 252420062.0,
        "delta": 91366637.0
      },
      {
        "periodo": 202607,
        "valor": 193989539.0,
        "delta": -58430523.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 652262687.0400004,
    "valor_anterior": 638879752.6799998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 697775878.83,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 518003096.79,
        "delta": -179772782.04
      },
      {
        "periodo": 202509,
        "valor": 602775406.66,
        "delta": 84772309.87
      },
      {
        "periodo": 202510,
        "valor": 611359359.25,
        "delta": 8583952.59
      },
      {
        "periodo": 202511,
        "valor": 711709208.56,
        "delta": 100349849.31
      },
      {
        "periodo": 202512,
        "valor": 661888182.24,
        "delta": -49821026.32
      },
      {
        "periodo": 202601,
        "valor": 665453355.25,
        "delta": 3565173.01
      },
      {
        "periodo": 202602,
        "valor": 666220169.83,
        "delta": 766814.58
      },
      {
        "periodo": 202603,
        "valor": 774208004.31,
        "delta": 107987834.48
      },
      {
        "periodo": 202604,
        "valor": 702050504.98,
        "delta": -72157499.33
      },
      {
        "periodo": 202605,
        "valor": 642654013.68,
        "delta": -59396491.3
      },
      {
        "periodo": 202606,
        "valor": 638879752.68,
        "delta": -3774261.0
      },
      {
        "periodo": 202607,
        "valor": 652262687.04,
        "delta": 13382934.36
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 200636860.0,
    "valor_anterior": 200007099.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 163699198.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 182659508.0,
        "delta": 18960310.0
      },
      {
        "periodo": 202509,
        "valor": 192671960.0,
        "delta": 10012452.0
      },
      {
        "periodo": 202510,
        "valor": 197548393.0,
        "delta": 4876433.0
      },
      {
        "periodo": 202511,
        "valor": 160075318.0,
        "delta": -37473075.0
      },
      {
        "periodo": 202512,
        "valor": 206096076.0,
        "delta": 46020758.0
      },
      {
        "periodo": 202601,
        "valor": 193541739.0,
        "delta": -12554337.0
      },
      {
        "periodo": 202602,
        "valor": 170063609.0,
        "delta": -23478130.0
      },
      {
        "periodo": 202603,
        "valor": 184186767.0,
        "delta": 14123158.0
      },
      {
        "periodo": 202604,
        "valor": 202318424.0,
        "delta": 18131657.0
      },
      {
        "periodo": 202605,
        "valor": 206156584.0,
        "delta": 3838160.0
      },
      {
        "periodo": 202606,
        "valor": 200007099.0,
        "delta": -6149485.0
      },
      {
        "periodo": 202607,
        "valor": 200636860.0,
        "delta": 629761.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 705965915.2799997,
    "valor_anterior": 1011083217.8099995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1035401822.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1032702059.85,
        "delta": -2699762.65
      },
      {
        "periodo": 202509,
        "valor": 1323222213.41,
        "delta": 290520153.56
      },
      {
        "periodo": 202510,
        "valor": 831464944.56,
        "delta": -491757268.85
      },
      {
        "periodo": 202511,
        "valor": 357127364.55,
        "delta": -474337580.01
      },
      {
        "periodo": 202512,
        "valor": -168686438.02,
        "delta": -525813802.57
      },
      {
        "periodo": 202601,
        "valor": 857139251.38,
        "delta": 1025825689.4
      },
      {
        "periodo": 202602,
        "valor": 1108435253.88,
        "delta": 251296002.5
      },
      {
        "periodo": 202603,
        "valor": 702155684.91,
        "delta": -406279568.97
      },
      {
        "periodo": 202604,
        "valor": 890605061.51,
        "delta": 188449376.6
      },
      {
        "periodo": 202605,
        "valor": 993753528.71,
        "delta": 103148467.2
      },
      {
        "periodo": 202606,
        "valor": 1011083217.81,
        "delta": 17329689.1
      },
      {
        "periodo": 202607,
        "valor": 705965915.28,
        "delta": -305117302.53
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 22500385.0,
    "valor_anterior": 8517316.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26258068.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26863190.0,
        "delta": 605122.0
      },
      {
        "periodo": 202509,
        "valor": 21717167.0,
        "delta": -5146023.0
      },
      {
        "periodo": 202510,
        "valor": 29721427.0,
        "delta": 8004260.0
      },
      {
        "periodo": 202511,
        "valor": 15762849.0,
        "delta": -13958578.0
      },
      {
        "periodo": 202512,
        "valor": 92730516.0,
        "delta": 76967667.0
      },
      {
        "periodo": 202601,
        "valor": 18119075.0,
        "delta": -74611441.0
      },
      {
        "periodo": 202602,
        "valor": 26123042.0,
        "delta": 8003967.0
      },
      {
        "periodo": 202603,
        "valor": 26794514.0,
        "delta": 671472.0
      },
      {
        "periodo": 202604,
        "valor": 16439660.0,
        "delta": -10354854.0
      },
      {
        "periodo": 202605,
        "valor": 9394834.0,
        "delta": -7044826.0
      },
      {
        "periodo": 202606,
        "valor": 8517316.0,
        "delta": -877518.0
      },
      {
        "periodo": 202607,
        "valor": 22500385.0,
        "delta": 13983069.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 6282544048.690002,
    "valor_anterior": 6211585008.970001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6192408370.01,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5979450594.8,
        "delta": -212957775.21
      },
      {
        "periodo": 202509,
        "valor": 6031643963.15,
        "delta": 52193368.35
      },
      {
        "periodo": 202510,
        "valor": 5990960424.38,
        "delta": -40683538.77
      },
      {
        "periodo": 202511,
        "valor": 6186926300.09,
        "delta": 195965875.71
      },
      {
        "periodo": 202512,
        "valor": 6031851584.95,
        "delta": -155074715.14
      },
      {
        "periodo": 202601,
        "valor": 6166966450.29,
        "delta": 135114865.34
      },
      {
        "periodo": 202602,
        "valor": 5856589386.57,
        "delta": -310377063.72
      },
      {
        "periodo": 202603,
        "valor": 5876243827.55,
        "delta": 19654440.98
      },
      {
        "periodo": 202604,
        "valor": 6118100454.05,
        "delta": 241856626.5
      },
      {
        "periodo": 202605,
        "valor": 6402443769.68,
        "delta": 284343315.63
      },
      {
        "periodo": 202606,
        "valor": 6211585008.97,
        "delta": -190858760.71
      },
      {
        "periodo": 202607,
        "valor": 6282544048.69,
        "delta": 70959039.72
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 136479028.0,
    "valor_anterior": 120461476.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 89034432.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 98764937.07,
        "delta": 9730504.17
      },
      {
        "periodo": 202509,
        "valor": 117969611.25,
        "delta": 19204674.18
      },
      {
        "periodo": 202510,
        "valor": 109104935.0,
        "delta": -8864676.25
      },
      {
        "periodo": 202511,
        "valor": 124068557.0,
        "delta": 14963622.0
      },
      {
        "periodo": 202512,
        "valor": 90119311.0,
        "delta": -33949246.0
      },
      {
        "periodo": 202601,
        "valor": 133660670.0,
        "delta": 43541359.0
      },
      {
        "periodo": 202602,
        "valor": 95265294.0,
        "delta": -38395376.0
      },
      {
        "periodo": 202603,
        "valor": 105272996.0,
        "delta": 10007702.0
      },
      {
        "periodo": 202604,
        "valor": 120389413.0,
        "delta": 15116417.0
      },
      {
        "periodo": 202605,
        "valor": 136349112.0,
        "delta": 15959699.0
      },
      {
        "periodo": 202606,
        "valor": 120461476.0,
        "delta": -15887636.0
      },
      {
        "periodo": 202607,
        "valor": 136479028.0,
        "delta": 16017552.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 110385991.0,
    "valor_anterior": 96792602.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 110121505.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 119216240.0,
        "delta": 9094735.0
      },
      {
        "periodo": 202509,
        "valor": 102777870.0,
        "delta": -16438370.0
      },
      {
        "periodo": 202510,
        "valor": 111816021.0,
        "delta": 9038151.0
      },
      {
        "periodo": 202511,
        "valor": 125338222.0,
        "delta": 13522201.0
      },
      {
        "periodo": 202512,
        "valor": 114826672.0,
        "delta": -10511550.0
      },
      {
        "periodo": 202601,
        "valor": 95964067.0,
        "delta": -18862605.0
      },
      {
        "periodo": 202602,
        "valor": 97854135.0,
        "delta": 1890068.0
      },
      {
        "periodo": 202603,
        "valor": 98940889.0,
        "delta": 1086754.0
      },
      {
        "periodo": 202604,
        "valor": 94649724.0,
        "delta": -4291165.0
      },
      {
        "periodo": 202605,
        "valor": 102205009.0,
        "delta": 7555285.0
      },
      {
        "periodo": 202606,
        "valor": 96792602.0,
        "delta": -5412407.0
      },
      {
        "periodo": 202607,
        "valor": 110385991.0,
        "delta": 13593389.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 1573208099.000001,
    "valor_anterior": 1307765233.999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1540945877.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1532145093.0,
        "delta": -8800784.0
      },
      {
        "periodo": 202509,
        "valor": 1345933962.0,
        "delta": -186211131.0
      },
      {
        "periodo": 202510,
        "valor": 1492033082.0,
        "delta": 146099120.0
      },
      {
        "periodo": 202511,
        "valor": 1598184460.0,
        "delta": 106151378.0
      },
      {
        "periodo": 202512,
        "valor": 1564907687.0,
        "delta": -33276773.0
      },
      {
        "periodo": 202601,
        "valor": 1352695519.0,
        "delta": -212212168.0
      },
      {
        "periodo": 202602,
        "valor": 1233894490.0,
        "delta": -118801029.0
      },
      {
        "periodo": 202603,
        "valor": 1552055051.0,
        "delta": 318160561.0
      },
      {
        "periodo": 202604,
        "valor": 1577779622.0,
        "delta": 25724571.0
      },
      {
        "periodo": 202605,
        "valor": 1441721477.0,
        "delta": -136058145.0
      },
      {
        "periodo": 202606,
        "valor": 1307765234.0,
        "delta": -133956243.0
      },
      {
        "periodo": 202607,
        "valor": 1573208099.0,
        "delta": 265442865.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 255123544.0,
    "valor_anterior": 346732032.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 219067276.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 307740823.0,
        "delta": 88673547.0
      },
      {
        "periodo": 202509,
        "valor": 273379827.0,
        "delta": -34360996.0
      },
      {
        "periodo": 202510,
        "valor": 245397059.0,
        "delta": -27982768.0
      },
      {
        "periodo": 202511,
        "valor": 368230655.0,
        "delta": 122833596.0
      },
      {
        "periodo": 202512,
        "valor": 454135206.0,
        "delta": 85904551.0
      },
      {
        "periodo": 202601,
        "valor": 289263701.0,
        "delta": -164871505.0
      },
      {
        "periodo": 202602,
        "valor": 347467545.0,
        "delta": 58203844.0
      },
      {
        "periodo": 202603,
        "valor": 482843538.0,
        "delta": 135375993.0
      },
      {
        "periodo": 202604,
        "valor": 272315033.0,
        "delta": -210528505.0
      },
      {
        "periodo": 202605,
        "valor": 310329067.0,
        "delta": 38014034.0
      },
      {
        "periodo": 202606,
        "valor": 346732032.0,
        "delta": 36402965.0
      },
      {
        "periodo": 202607,
        "valor": 255123544.0,
        "delta": -91608488.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 277495150.0,
    "valor_anterior": 296218932.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 341516825.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 292470567.0,
        "delta": -49046258.0
      },
      {
        "periodo": 202509,
        "valor": 285546026.0,
        "delta": -6924541.0
      },
      {
        "periodo": 202510,
        "valor": 361195918.0,
        "delta": 75649892.0
      },
      {
        "periodo": 202511,
        "valor": 330415868.0,
        "delta": -30780050.0
      },
      {
        "periodo": 202512,
        "valor": 264711977.0,
        "delta": -65703891.0
      },
      {
        "periodo": 202601,
        "valor": 308113716.0,
        "delta": 43401739.0
      },
      {
        "periodo": 202602,
        "valor": 314461727.0,
        "delta": 6348011.0
      },
      {
        "periodo": 202603,
        "valor": 320347848.0,
        "delta": 5886121.0
      },
      {
        "periodo": 202604,
        "valor": 294906377.0,
        "delta": -25441471.0
      },
      {
        "periodo": 202605,
        "valor": 326609590.0,
        "delta": 31703213.0
      },
      {
        "periodo": 202606,
        "valor": 296218932.0,
        "delta": -30390658.0
      },
      {
        "periodo": 202607,
        "valor": 277495150.0,
        "delta": -18723782.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 59189428.0,
    "valor_anterior": 148456681.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 465817996.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 379098369.0,
        "delta": -86719627.0
      },
      {
        "periodo": 202509,
        "valor": 362130496.0,
        "delta": -16967873.0
      },
      {
        "periodo": 202510,
        "valor": 159307570.0,
        "delta": -202822926.0
      },
      {
        "periodo": 202511,
        "valor": 130888856.0,
        "delta": -28418714.0
      },
      {
        "periodo": 202512,
        "valor": 33043933.0,
        "delta": -97844923.0
      },
      {
        "periodo": 202601,
        "valor": 67151275.0,
        "delta": 34107342.0
      },
      {
        "periodo": 202602,
        "valor": 21074403.0,
        "delta": -46076872.0
      },
      {
        "periodo": 202603,
        "valor": 80901504.0,
        "delta": 59827101.0
      },
      {
        "periodo": 202604,
        "valor": 48630005.0,
        "delta": -32271499.0
      },
      {
        "periodo": 202605,
        "valor": 47176035.0,
        "delta": -1453970.0
      },
      {
        "periodo": 202606,
        "valor": 148456681.0,
        "delta": 101280646.0
      },
      {
        "periodo": 202607,
        "valor": 59189428.0,
        "delta": -89267253.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 1368839941.7400007,
    "valor_anterior": 1301750474.46,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1289506484.71,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1324111569.9,
        "delta": 34605085.19
      },
      {
        "periodo": 202509,
        "valor": 1233310947.7,
        "delta": -90800622.2
      },
      {
        "periodo": 202510,
        "valor": 1448672448.07,
        "delta": 215361500.37
      },
      {
        "periodo": 202511,
        "valor": 1318728141.01,
        "delta": -129944307.06
      },
      {
        "periodo": 202512,
        "valor": 1673358616.81,
        "delta": 354630475.8
      },
      {
        "periodo": 202601,
        "valor": 1056966952.96,
        "delta": -616391663.85
      },
      {
        "periodo": 202602,
        "valor": 1157023773.45,
        "delta": 100056820.49
      },
      {
        "periodo": 202603,
        "valor": 1388783780.22,
        "delta": 231760006.77
      },
      {
        "periodo": 202604,
        "valor": 1209167413.01,
        "delta": -179616367.21
      },
      {
        "periodo": 202605,
        "valor": 1264226253.77,
        "delta": 55058840.76
      },
      {
        "periodo": 202606,
        "valor": 1301750474.46,
        "delta": 37524220.69
      },
      {
        "periodo": 202607,
        "valor": 1368839941.74,
        "delta": 67089467.28
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 87875020.0,
    "valor_anterior": 75040881.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 118800729.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 98725472.0,
        "delta": -20075257.0
      },
      {
        "periodo": 202509,
        "valor": 94569735.0,
        "delta": -4155737.0
      },
      {
        "periodo": 202510,
        "valor": 98205662.0,
        "delta": 3635927.0
      },
      {
        "periodo": 202511,
        "valor": 110488148.0,
        "delta": 12282486.0
      },
      {
        "periodo": 202512,
        "valor": 102865462.0,
        "delta": -7622686.0
      },
      {
        "periodo": 202601,
        "valor": 73728413.0,
        "delta": -29137049.0
      },
      {
        "periodo": 202602,
        "valor": 87429628.0,
        "delta": 13701215.0
      },
      {
        "periodo": 202603,
        "valor": 74413855.0,
        "delta": -13015773.0
      },
      {
        "periodo": 202604,
        "valor": 80921064.0,
        "delta": 6507209.0
      },
      {
        "periodo": 202605,
        "valor": 82647051.0,
        "delta": 1725987.0
      },
      {
        "periodo": 202606,
        "valor": 75040881.0,
        "delta": -7606170.0
      },
      {
        "periodo": 202607,
        "valor": 87875020.0,
        "delta": 12834139.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 12209499.0,
    "valor_anterior": 11953700.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13754270.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17578260.0,
        "delta": 3823990.0
      },
      {
        "periodo": 202509,
        "valor": 19105374.0,
        "delta": 1527114.0
      },
      {
        "periodo": 202510,
        "valor": 15660726.0,
        "delta": -3444648.0
      },
      {
        "periodo": 202511,
        "valor": 11171010.0,
        "delta": -4489716.0
      },
      {
        "periodo": 202512,
        "valor": 7488174.0,
        "delta": -3682836.0
      },
      {
        "periodo": 202601,
        "valor": 9403924.0,
        "delta": 1915750.0
      },
      {
        "periodo": 202602,
        "valor": 11571925.0,
        "delta": 2168001.0
      },
      {
        "periodo": 202603,
        "valor": 11681213.0,
        "delta": 109288.0
      },
      {
        "periodo": 202604,
        "valor": 12702056.0,
        "delta": 1020843.0
      },
      {
        "periodo": 202605,
        "valor": 16276416.0,
        "delta": 3574360.0
      },
      {
        "periodo": 202606,
        "valor": 11953700.0,
        "delta": -4322716.0
      },
      {
        "periodo": 202607,
        "valor": 12209499.0,
        "delta": 255799.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 281129453.0,
    "valor_anterior": 226029562.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 194394309.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 202267764.0,
        "delta": 7873455.0
      },
      {
        "periodo": 202509,
        "valor": 176232962.0,
        "delta": -26034802.0
      },
      {
        "periodo": 202510,
        "valor": 198727929.0,
        "delta": 22494967.0
      },
      {
        "periodo": 202511,
        "valor": 193888632.0,
        "delta": -4839297.0
      },
      {
        "periodo": 202512,
        "valor": 273875554.0,
        "delta": 79986922.0
      },
      {
        "periodo": 202601,
        "valor": 249510627.0,
        "delta": -24364927.0
      },
      {
        "periodo": 202602,
        "valor": 176830168.0,
        "delta": -72680459.0
      },
      {
        "periodo": 202603,
        "valor": 214134496.0,
        "delta": 37304328.0
      },
      {
        "periodo": 202604,
        "valor": 243842077.0,
        "delta": 29707581.0
      },
      {
        "periodo": 202605,
        "valor": 231211793.0,
        "delta": -12630284.0
      },
      {
        "periodo": 202606,
        "valor": 226029562.0,
        "delta": -5182231.0
      },
      {
        "periodo": 202607,
        "valor": 281129453.0,
        "delta": 55099891.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 16187997.0,
    "valor_anterior": 12909760.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6236580.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10427217.0,
        "delta": 4190637.0
      },
      {
        "periodo": 202509,
        "valor": 16220733.0,
        "delta": 5793516.0
      },
      {
        "periodo": 202510,
        "valor": 26112685.0,
        "delta": 9891952.0
      },
      {
        "periodo": 202511,
        "valor": 18313687.0,
        "delta": -7798998.0
      },
      {
        "periodo": 202512,
        "valor": 10902372.0,
        "delta": -7411315.0
      },
      {
        "periodo": 202601,
        "valor": 7411065.0,
        "delta": -3491307.0
      },
      {
        "periodo": 202602,
        "valor": 17027510.0,
        "delta": 9616445.0
      },
      {
        "periodo": 202603,
        "valor": 11756202.0,
        "delta": -5271308.0
      },
      {
        "periodo": 202604,
        "valor": 18757566.0,
        "delta": 7001364.0
      },
      {
        "periodo": 202605,
        "valor": 9734225.0,
        "delta": -9023341.0
      },
      {
        "periodo": 202606,
        "valor": 12909760.0,
        "delta": 3175535.0
      },
      {
        "periodo": 202607,
        "valor": 16187997.0,
        "delta": 3278237.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 523298646.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 558109017.0,
        "delta": 34810371.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 397923115.0,
    "valor_anterior": 441615527.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 326036757.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 352935738.0,
        "delta": 26898981.0
      },
      {
        "periodo": 202509,
        "valor": 315214609.0,
        "delta": -37721129.0
      },
      {
        "periodo": 202510,
        "valor": 363703272.0,
        "delta": 48488663.0
      },
      {
        "periodo": 202511,
        "valor": 352080349.0,
        "delta": -11622923.0
      },
      {
        "periodo": 202512,
        "valor": 391612575.0,
        "delta": 39532226.0
      },
      {
        "periodo": 202601,
        "valor": 402642362.0,
        "delta": 11029787.0
      },
      {
        "periodo": 202602,
        "valor": 377624172.0,
        "delta": -25018190.0
      },
      {
        "periodo": 202603,
        "valor": 415758133.0,
        "delta": 38133961.0
      },
      {
        "periodo": 202604,
        "valor": 453678207.0,
        "delta": 37920074.0
      },
      {
        "periodo": 202605,
        "valor": 360787488.0,
        "delta": -92890719.0
      },
      {
        "periodo": 202606,
        "valor": 441615527.0,
        "delta": 80828039.0
      },
      {
        "periodo": 202607,
        "valor": 397923115.0,
        "delta": -43692412.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 232210154.0,
    "valor_anterior": 234287170.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 172630428.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 196661325.0,
        "delta": 24030897.0
      },
      {
        "periodo": 202509,
        "valor": 301581284.0,
        "delta": 104919959.0
      },
      {
        "periodo": 202510,
        "valor": 210266419.0,
        "delta": -91314865.0
      },
      {
        "periodo": 202511,
        "valor": 225825563.0,
        "delta": 15559144.0
      },
      {
        "periodo": 202512,
        "valor": 304888068.0,
        "delta": 79062505.0
      },
      {
        "periodo": 202601,
        "valor": 218803531.0,
        "delta": -86084537.0
      },
      {
        "periodo": 202602,
        "valor": 226715135.0,
        "delta": 7911604.0
      },
      {
        "periodo": 202603,
        "valor": 259680252.0,
        "delta": 32965117.0
      },
      {
        "periodo": 202604,
        "valor": 265581000.0,
        "delta": 5900748.0
      },
      {
        "periodo": 202605,
        "valor": 269374755.0,
        "delta": 3793755.0
      },
      {
        "periodo": 202606,
        "valor": 234287170.0,
        "delta": -35087585.0
      },
      {
        "periodo": 202607,
        "valor": 232210154.0,
        "delta": -2077016.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 10318180.0,
    "valor_anterior": 11079376.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10414550.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13994289.0,
        "delta": 3579739.0
      },
      {
        "periodo": 202509,
        "valor": 12044370.0,
        "delta": -1949919.0
      },
      {
        "periodo": 202510,
        "valor": 14375987.0,
        "delta": 2331617.0
      },
      {
        "periodo": 202511,
        "valor": 7148074.0,
        "delta": -7227913.0
      },
      {
        "periodo": 202512,
        "valor": 16514212.0,
        "delta": 9366138.0
      },
      {
        "periodo": 202601,
        "valor": 15209576.0,
        "delta": -1304636.0
      },
      {
        "periodo": 202602,
        "valor": 9839486.0,
        "delta": -5370090.0
      },
      {
        "periodo": 202603,
        "valor": 16425226.0,
        "delta": 6585740.0
      },
      {
        "periodo": 202604,
        "valor": 11596609.0,
        "delta": -4828617.0
      },
      {
        "periodo": 202605,
        "valor": 10255163.0,
        "delta": -1341446.0
      },
      {
        "periodo": 202606,
        "valor": 11079376.0,
        "delta": 824213.0
      },
      {
        "periodo": 202607,
        "valor": 10318180.0,
        "delta": -761196.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 30937442.0,
    "valor_anterior": 31619926.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21439724.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25685243.0,
        "delta": 4245519.0
      },
      {
        "periodo": 202509,
        "valor": 22307122.0,
        "delta": -3378121.0
      },
      {
        "periodo": 202510,
        "valor": 27638882.0,
        "delta": 5331760.0
      },
      {
        "periodo": 202511,
        "valor": 24739766.0,
        "delta": -2899116.0
      },
      {
        "periodo": 202512,
        "valor": 33255739.0,
        "delta": 8515973.0
      },
      {
        "periodo": 202601,
        "valor": 26037055.0,
        "delta": -7218684.0
      },
      {
        "periodo": 202602,
        "valor": 25573418.0,
        "delta": -463637.0
      },
      {
        "periodo": 202603,
        "valor": 29600538.0,
        "delta": 4027120.0
      },
      {
        "periodo": 202604,
        "valor": 29908772.0,
        "delta": 308234.0
      },
      {
        "periodo": 202605,
        "valor": 30839619.0,
        "delta": 930847.0
      },
      {
        "periodo": 202606,
        "valor": 31619926.0,
        "delta": 780307.0
      },
      {
        "periodo": 202607,
        "valor": 30937442.0,
        "delta": -682484.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 72272338.5,
    "valor_anterior": 65949966.04999995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 64081814.7,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 68230754.87,
        "delta": 4148940.17
      },
      {
        "periodo": 202509,
        "valor": 67090427.13,
        "delta": -1140327.74
      },
      {
        "periodo": 202510,
        "valor": 67362421.92,
        "delta": 271994.79
      },
      {
        "periodo": 202511,
        "valor": 70391196.74,
        "delta": 3028774.82
      },
      {
        "periodo": 202512,
        "valor": 76929539.0,
        "delta": 6538342.26
      },
      {
        "periodo": 202601,
        "valor": 68995317.14,
        "delta": -7934221.86
      },
      {
        "periodo": 202602,
        "valor": 58305031.43,
        "delta": -10690285.71
      },
      {
        "periodo": 202603,
        "valor": 56896328.46,
        "delta": -1408702.97
      },
      {
        "periodo": 202604,
        "valor": 72507974.09,
        "delta": 15611645.63
      },
      {
        "periodo": 202605,
        "valor": 67284535.6,
        "delta": -5223438.49
      },
      {
        "periodo": 202606,
        "valor": 65949966.05,
        "delta": -1334569.55
      },
      {
        "periodo": 202607,
        "valor": 72272338.5,
        "delta": 6322372.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 14490931.0,
    "valor_anterior": 12008331.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20942575.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18608143.0,
        "delta": -2334432.0
      },
      {
        "periodo": 202509,
        "valor": 19879582.0,
        "delta": 1271439.0
      },
      {
        "periodo": 202510,
        "valor": 23261869.0,
        "delta": 3382287.0
      },
      {
        "periodo": 202511,
        "valor": 18321394.0,
        "delta": -4940475.0
      },
      {
        "periodo": 202512,
        "valor": 12079214.0,
        "delta": -6242180.0
      },
      {
        "periodo": 202601,
        "valor": 9369402.0,
        "delta": -2709812.0
      },
      {
        "periodo": 202602,
        "valor": 10630017.0,
        "delta": 1260615.0
      },
      {
        "periodo": 202603,
        "valor": 10081835.0,
        "delta": -548182.0
      },
      {
        "periodo": 202604,
        "valor": 10456873.0,
        "delta": 375038.0
      },
      {
        "periodo": 202605,
        "valor": 11100243.0,
        "delta": 643370.0
      },
      {
        "periodo": 202606,
        "valor": 12008331.0,
        "delta": 908088.0
      },
      {
        "periodo": 202607,
        "valor": 14490931.0,
        "delta": 2482600.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 136893765.62,
    "valor_anterior": 132578824.80999994,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 113457045.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 111338447.37,
        "delta": -2118597.92
      },
      {
        "periodo": 202509,
        "valor": 111031739.27,
        "delta": -306708.1
      },
      {
        "periodo": 202510,
        "valor": 115367118.54,
        "delta": 4335379.27
      },
      {
        "periodo": 202511,
        "valor": 116892783.23,
        "delta": 1525664.69
      },
      {
        "periodo": 202512,
        "valor": 119697556.63,
        "delta": 2804773.4
      },
      {
        "periodo": 202601,
        "valor": 128413298.66,
        "delta": 8715742.03
      },
      {
        "periodo": 202602,
        "valor": 123297048.07,
        "delta": -5116250.59
      },
      {
        "periodo": 202603,
        "valor": 126684122.26,
        "delta": 3387074.19
      },
      {
        "periodo": 202604,
        "valor": 136134308.51,
        "delta": 9450186.25
      },
      {
        "periodo": 202605,
        "valor": 126717167.69,
        "delta": -9417140.82
      },
      {
        "periodo": 202606,
        "valor": 132578824.81,
        "delta": 5861657.12
      },
      {
        "periodo": 202607,
        "valor": 136893765.62,
        "delta": 4314940.81
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 47709850.45000005,
    "valor_anterior": 59812397.79999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 45887738.08,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 43699874.36,
        "delta": -2187863.72
      },
      {
        "periodo": 202509,
        "valor": 47281257.97,
        "delta": 3581383.61
      },
      {
        "periodo": 202510,
        "valor": 51676044.68,
        "delta": 4394786.71
      },
      {
        "periodo": 202511,
        "valor": 40186469.48,
        "delta": -11489575.2
      },
      {
        "periodo": 202512,
        "valor": 43947005.95,
        "delta": 3760536.47
      },
      {
        "periodo": 202601,
        "valor": 45258706.6,
        "delta": 1311700.65
      },
      {
        "periodo": 202602,
        "valor": 50775054.02,
        "delta": 5516347.42
      },
      {
        "periodo": 202603,
        "valor": 53650046.55,
        "delta": 2874992.53
      },
      {
        "periodo": 202604,
        "valor": 39789382.46,
        "delta": -13860664.09
      },
      {
        "periodo": 202605,
        "valor": 43366547.91,
        "delta": 3577165.45
      },
      {
        "periodo": 202606,
        "valor": 59812397.8,
        "delta": 16445849.89
      },
      {
        "periodo": 202607,
        "valor": 47709850.45,
        "delta": -12102547.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 14983195.0,
    "valor_anterior": 18388327.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16259013.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13967436.0,
        "delta": -2291577.0
      },
      {
        "periodo": 202509,
        "valor": 15167242.0,
        "delta": 1199806.0
      },
      {
        "periodo": 202510,
        "valor": 14626546.0,
        "delta": -540696.0
      },
      {
        "periodo": 202511,
        "valor": 11818259.0,
        "delta": -2808287.0
      },
      {
        "periodo": 202512,
        "valor": 34157052.0,
        "delta": 22338793.0
      },
      {
        "periodo": 202601,
        "valor": 17764669.0,
        "delta": -16392383.0
      },
      {
        "periodo": 202602,
        "valor": 12471789.0,
        "delta": -5292880.0
      },
      {
        "periodo": 202603,
        "valor": 15796195.0,
        "delta": 3324406.0
      },
      {
        "periodo": 202604,
        "valor": 10415084.0,
        "delta": -5381111.0
      },
      {
        "periodo": 202605,
        "valor": 17927293.0,
        "delta": 7512209.0
      },
      {
        "periodo": 202606,
        "valor": 18388327.0,
        "delta": 461034.0
      },
      {
        "periodo": 202607,
        "valor": 14983195.0,
        "delta": -3405132.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 195196450.0,
    "valor_anterior": 184663344.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 184590602.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 191065622.0,
        "delta": 6475020.0
      },
      {
        "periodo": 202509,
        "valor": 182977271.0,
        "delta": -8088351.0
      },
      {
        "periodo": 202510,
        "valor": 164670586.0,
        "delta": -18306685.0
      },
      {
        "periodo": 202511,
        "valor": 179328238.0,
        "delta": 14657652.0
      },
      {
        "periodo": 202512,
        "valor": 180285497.0,
        "delta": 957259.0
      },
      {
        "periodo": 202601,
        "valor": 182910632.0,
        "delta": 2625135.0
      },
      {
        "periodo": 202602,
        "valor": 188525048.0,
        "delta": 5614416.0
      },
      {
        "periodo": 202603,
        "valor": 183085861.0,
        "delta": -5439187.0
      },
      {
        "periodo": 202604,
        "valor": 185722586.0,
        "delta": 2636725.0
      },
      {
        "periodo": 202605,
        "valor": 175519777.0,
        "delta": -10202809.0
      },
      {
        "periodo": 202606,
        "valor": 184663344.0,
        "delta": 9143567.0
      },
      {
        "periodo": 202607,
        "valor": 195196450.0,
        "delta": 10533106.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 14915151.0,
    "valor_anterior": 12896058.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13281572.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12643360.0,
        "delta": -638212.0
      },
      {
        "periodo": 202509,
        "valor": 15091380.0,
        "delta": 2448020.0
      },
      {
        "periodo": 202510,
        "valor": 13083394.0,
        "delta": -2007986.0
      },
      {
        "periodo": 202511,
        "valor": 10809913.0,
        "delta": -2273481.0
      },
      {
        "periodo": 202512,
        "valor": 18891085.0,
        "delta": 8081172.0
      },
      {
        "periodo": 202601,
        "valor": 12510440.0,
        "delta": -6380645.0
      },
      {
        "periodo": 202602,
        "valor": 14684563.0,
        "delta": 2174123.0
      },
      {
        "periodo": 202603,
        "valor": 12091888.0,
        "delta": -2592675.0
      },
      {
        "periodo": 202604,
        "valor": 15681780.0,
        "delta": 3589892.0
      },
      {
        "periodo": 202605,
        "valor": 13696785.0,
        "delta": -1984995.0
      },
      {
        "periodo": 202606,
        "valor": 12896058.0,
        "delta": -800727.0
      },
      {
        "periodo": 202607,
        "valor": 14915151.0,
        "delta": 2019093.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 27578687.930000007,
    "valor_anterior": 27794749.99000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30228967.95,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29821429.36,
        "delta": -407538.59
      },
      {
        "periodo": 202509,
        "valor": 28130943.14,
        "delta": -1690486.22
      },
      {
        "periodo": 202510,
        "valor": 27070378.15,
        "delta": -1060564.99
      },
      {
        "periodo": 202511,
        "valor": 27365809.03,
        "delta": 295430.88
      },
      {
        "periodo": 202512,
        "valor": 41924562.5,
        "delta": 14558753.47
      },
      {
        "periodo": 202601,
        "valor": 27233912.53,
        "delta": -14690649.97
      },
      {
        "periodo": 202602,
        "valor": 26576454.72,
        "delta": -657457.81
      },
      {
        "periodo": 202603,
        "valor": 41225853.05,
        "delta": 14649398.33
      },
      {
        "periodo": 202604,
        "valor": 24689410.13,
        "delta": -16536442.92
      },
      {
        "periodo": 202605,
        "valor": 26386489.42,
        "delta": 1697079.29
      },
      {
        "periodo": 202606,
        "valor": 27794749.99,
        "delta": 1408260.57
      },
      {
        "periodo": 202607,
        "valor": 27578687.93,
        "delta": -216062.06
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 13031969.409999996,
    "valor_anterior": 14444047.320000008,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15438884.6,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12934245.17,
        "delta": -2504639.43
      },
      {
        "periodo": 202509,
        "valor": 13945525.05,
        "delta": 1011279.88
      },
      {
        "periodo": 202510,
        "valor": 13805480.37,
        "delta": -140044.68
      },
      {
        "periodo": 202511,
        "valor": 14460108.81,
        "delta": 654628.44
      },
      {
        "periodo": 202512,
        "valor": 17762475.83,
        "delta": 3302367.02
      },
      {
        "periodo": 202601,
        "valor": 12344035.23,
        "delta": -5418440.6
      },
      {
        "periodo": 202602,
        "valor": 12187087.35,
        "delta": -156947.88
      },
      {
        "periodo": 202603,
        "valor": 13840494.27,
        "delta": 1653406.92
      },
      {
        "periodo": 202604,
        "valor": 12423576.98,
        "delta": -1416917.29
      },
      {
        "periodo": 202605,
        "valor": 12227829.0,
        "delta": -195747.98
      },
      {
        "periodo": 202606,
        "valor": 14444047.32,
        "delta": 2216218.32
      },
      {
        "periodo": 202607,
        "valor": 13031969.41,
        "delta": -1412077.91
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 28676834.0,
    "valor_anterior": 28664692.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27594319.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 27232723.0,
        "delta": -361596.0
      },
      {
        "periodo": 202509,
        "valor": 27111295.0,
        "delta": -121428.0
      },
      {
        "periodo": 202510,
        "valor": 29596038.0,
        "delta": 2484743.0
      },
      {
        "periodo": 202511,
        "valor": 27670181.0,
        "delta": -1925857.0
      },
      {
        "periodo": 202512,
        "valor": 46394659.0,
        "delta": 18724478.0
      },
      {
        "periodo": 202601,
        "valor": 27270554.0,
        "delta": -19124105.0
      },
      {
        "periodo": 202602,
        "valor": 27322907.0,
        "delta": 52353.0
      },
      {
        "periodo": 202603,
        "valor": 29995366.0,
        "delta": 2672459.0
      },
      {
        "periodo": 202604,
        "valor": 29388724.0,
        "delta": -606642.0
      },
      {
        "periodo": 202605,
        "valor": 31401001.0,
        "delta": 2012277.0
      },
      {
        "periodo": 202606,
        "valor": 28664692.0,
        "delta": -2736309.0
      },
      {
        "periodo": 202607,
        "valor": 28676834.0,
        "delta": 12142.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 11610717.0,
    "valor_anterior": 12195624.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12401972.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11142713.0,
        "delta": -1259259.0
      },
      {
        "periodo": 202509,
        "valor": 10456072.0,
        "delta": -686641.0
      },
      {
        "periodo": 202510,
        "valor": 10864018.0,
        "delta": 407946.0
      },
      {
        "periodo": 202511,
        "valor": 12212218.0,
        "delta": 1348200.0
      },
      {
        "periodo": 202512,
        "valor": 13013498.0,
        "delta": 801280.0
      },
      {
        "periodo": 202601,
        "valor": 12129240.0,
        "delta": -884258.0
      },
      {
        "periodo": 202602,
        "valor": 10375103.0,
        "delta": -1754137.0
      },
      {
        "periodo": 202603,
        "valor": 10229248.0,
        "delta": -145855.0
      },
      {
        "periodo": 202604,
        "valor": 10535063.0,
        "delta": 305815.0
      },
      {
        "periodo": 202605,
        "valor": 10572679.0,
        "delta": 37616.0
      },
      {
        "periodo": 202606,
        "valor": 12195624.0,
        "delta": 1622945.0
      },
      {
        "periodo": 202607,
        "valor": 11610717.0,
        "delta": -584907.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 63463731.0,
    "valor_anterior": 67368380.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 37897317.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 40177068.0,
        "delta": 2279751.0
      },
      {
        "periodo": 202509,
        "valor": 16868749.0,
        "delta": -23308319.0
      },
      {
        "periodo": 202510,
        "valor": 51540263.0,
        "delta": 34671514.0
      },
      {
        "periodo": 202511,
        "valor": 52931951.0,
        "delta": 1391688.0
      },
      {
        "periodo": 202512,
        "valor": 42985074.0,
        "delta": -9946877.0
      },
      {
        "periodo": 202601,
        "valor": 44384359.0,
        "delta": 1399285.0
      },
      {
        "periodo": 202602,
        "valor": 52391096.0,
        "delta": 8006737.0
      },
      {
        "periodo": 202603,
        "valor": 43877537.0,
        "delta": -8513559.0
      },
      {
        "periodo": 202604,
        "valor": 57297297.0,
        "delta": 13419760.0
      },
      {
        "periodo": 202605,
        "valor": 46253747.0,
        "delta": -11043550.0
      },
      {
        "periodo": 202606,
        "valor": 67368380.0,
        "delta": 21114633.0
      },
      {
        "periodo": 202607,
        "valor": 63463731.0,
        "delta": -3904649.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 69039310.75999999,
    "valor_anterior": 67736103.41000003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 80338578.7,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 79433593.78,
        "delta": -904984.92
      },
      {
        "periodo": 202509,
        "valor": 66036479.45,
        "delta": -13397114.33
      },
      {
        "periodo": 202510,
        "valor": 64809125.85,
        "delta": -1227353.6
      },
      {
        "periodo": 202511,
        "valor": 68450052.41,
        "delta": 3640926.56
      },
      {
        "periodo": 202512,
        "valor": 52181921.71,
        "delta": -16268130.7
      },
      {
        "periodo": 202601,
        "valor": 85919386.53,
        "delta": 33737464.82
      },
      {
        "periodo": 202602,
        "valor": 70516167.88,
        "delta": -15403218.65
      },
      {
        "periodo": 202603,
        "valor": 69182205.64,
        "delta": -1333962.24
      },
      {
        "periodo": 202604,
        "valor": 69140727.12,
        "delta": -41478.52
      },
      {
        "periodo": 202605,
        "valor": 70745385.09,
        "delta": 1604657.97
      },
      {
        "periodo": 202606,
        "valor": 67736103.41,
        "delta": -3009281.68
      },
      {
        "periodo": 202607,
        "valor": 69039310.76,
        "delta": 1303207.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 107629340.16000003,
    "valor_anterior": 88669699.23000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5636842.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5904768.58,
        "delta": 267926.08
      },
      {
        "periodo": 202509,
        "valor": 6995067.69,
        "delta": 1090299.11
      },
      {
        "periodo": 202510,
        "valor": 9774883.8,
        "delta": 2779816.11
      },
      {
        "periodo": 202511,
        "valor": 8944577.51,
        "delta": -830306.29
      },
      {
        "periodo": 202512,
        "valor": 5038093.97,
        "delta": -3906483.54
      },
      {
        "periodo": 202601,
        "valor": 5075615.98,
        "delta": 37522.01
      },
      {
        "periodo": 202602,
        "valor": 74720623.23,
        "delta": 69645007.25
      },
      {
        "periodo": 202603,
        "valor": 85307779.86,
        "delta": 10587156.63
      },
      {
        "periodo": 202604,
        "valor": 90195753.17,
        "delta": 4887973.31
      },
      {
        "periodo": 202605,
        "valor": 134885729.57,
        "delta": 44689976.4
      },
      {
        "periodo": 202606,
        "valor": 88669699.23,
        "delta": -46216030.34
      },
      {
        "periodo": 202607,
        "valor": 107629340.16,
        "delta": 18959640.93
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 229796304.0,
    "valor_anterior": 237597899.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 142021169.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 166566660.0,
        "delta": 24545491.0
      },
      {
        "periodo": 202509,
        "valor": 175671193.0,
        "delta": 9104533.0
      },
      {
        "periodo": 202510,
        "valor": 218624118.0,
        "delta": 42952925.0
      },
      {
        "periodo": 202511,
        "valor": 184058146.0,
        "delta": -34565972.0
      },
      {
        "periodo": 202512,
        "valor": 225141839.0,
        "delta": 41083693.0
      },
      {
        "periodo": 202601,
        "valor": 213091790.0,
        "delta": -12050049.0
      },
      {
        "periodo": 202602,
        "valor": 217907032.0,
        "delta": 4815242.0
      },
      {
        "periodo": 202603,
        "valor": 235621829.0,
        "delta": 17714797.0
      },
      {
        "periodo": 202604,
        "valor": 229808780.0,
        "delta": -5813049.0
      },
      {
        "periodo": 202605,
        "valor": 246076092.0,
        "delta": 16267312.0
      },
      {
        "periodo": 202606,
        "valor": 237597899.0,
        "delta": -8478193.0
      },
      {
        "periodo": 202607,
        "valor": 229796304.0,
        "delta": -7801595.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 59360522.129999995,
    "valor_anterior": 53199871.75999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 292278309.5,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 33878723.4,
        "delta": -258399586.1
      },
      {
        "periodo": 202601,
        "valor": 32739213.18,
        "delta": -1139510.22
      },
      {
        "periodo": 202602,
        "valor": 40746763.52,
        "delta": 8007550.34
      },
      {
        "periodo": 202603,
        "valor": 63151844.94,
        "delta": 22405081.42
      },
      {
        "periodo": 202604,
        "valor": 45385487.55,
        "delta": -17766357.39
      },
      {
        "periodo": 202605,
        "valor": 47386487.82,
        "delta": 2001000.27
      },
      {
        "periodo": 202606,
        "valor": 53199871.76,
        "delta": 5813383.94
      },
      {
        "periodo": 202607,
        "valor": 59360522.13,
        "delta": 6160650.37
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 1035849040.0,
    "valor_anterior": 884393030.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 2032865173.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 858369598.0,
        "delta": -1174495575.0
      },
      {
        "periodo": 202605,
        "valor": 887969239.0,
        "delta": 29599641.0
      },
      {
        "periodo": 202606,
        "valor": 884393030.0,
        "delta": -3576209.0
      },
      {
        "periodo": 202607,
        "valor": 1035849040.0,
        "delta": 151456010.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 48119318039.5,
    "valor_anterior": 46663345813.31998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 46481300191.12,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 46627280738.35,
        "delta": 145980547.23
      },
      {
        "periodo": 202509,
        "valor": 40261320343.74,
        "delta": -6365960394.61
      },
      {
        "periodo": 202510,
        "valor": 46629592877.91,
        "delta": 6368272534.17
      },
      {
        "periodo": 202511,
        "valor": 43273899694.86,
        "delta": -3355693183.05
      },
      {
        "periodo": 202512,
        "valor": 50271717201.82,
        "delta": 6997817506.96
      },
      {
        "periodo": 202601,
        "valor": 45895413478.48,
        "delta": -4376303723.34
      },
      {
        "periodo": 202602,
        "valor": 45801653281.35,
        "delta": -93760197.13
      },
      {
        "periodo": 202603,
        "valor": 49640958319.01,
        "delta": 3839305037.66
      },
      {
        "periodo": 202604,
        "valor": 48307531345.25,
        "delta": -1333426973.76
      },
      {
        "periodo": 202605,
        "valor": 47598797509.57,
        "delta": -708733835.68
      },
      {
        "periodo": 202606,
        "valor": 46663345813.32,
        "delta": -935451696.25
      },
      {
        "periodo": 202607,
        "valor": 48119318039.5,
        "delta": 1455972226.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 29716523313.76999,
    "valor_anterior": 28407196124.070007,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28644541222.34,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29110177792.78,
        "delta": 465636570.44
      },
      {
        "periodo": 202509,
        "valor": 27517095386.15,
        "delta": -1593082406.63
      },
      {
        "periodo": 202510,
        "valor": 29744221580.98,
        "delta": 2227126194.83
      },
      {
        "periodo": 202511,
        "valor": 26013487591.11,
        "delta": -3730733989.87
      },
      {
        "periodo": 202512,
        "valor": 33002230337.61,
        "delta": 6988742746.5001
      },
      {
        "periodo": 202601,
        "valor": 29223816232.63,
        "delta": -3778414104.98
      },
      {
        "periodo": 202602,
        "valor": 29336459506.93,
        "delta": 112643274.3
      },
      {
        "periodo": 202603,
        "valor": 30278614394.08,
        "delta": 942154887.15
      },
      {
        "periodo": 202604,
        "valor": 30066941479.2,
        "delta": -211672914.88
      },
      {
        "periodo": 202605,
        "valor": 29101343156.9,
        "delta": -965598322.3
      },
      {
        "periodo": 202606,
        "valor": 28407196124.07,
        "delta": -694147032.83
      },
      {
        "periodo": 202607,
        "valor": 29716523313.77,
        "delta": 1309327189.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 1109375230.040001,
    "valor_anterior": 1228951960.6799994,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2012929277.83,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1808146220.79,
        "delta": -204783057.04
      },
      {
        "periodo": 202509,
        "valor": -3045567907.34,
        "delta": -4853714128.13
      },
      {
        "periodo": 202510,
        "valor": 1134370201.25,
        "delta": 4179938108.59
      },
      {
        "periodo": 202511,
        "valor": 1194678413.56,
        "delta": 60308212.31
      },
      {
        "periodo": 202512,
        "valor": 1086544690.24,
        "delta": -108133723.32
      },
      {
        "periodo": 202601,
        "valor": 1135246992.25,
        "delta": 48702302.01
      },
      {
        "periodo": 202602,
        "valor": 1064918744.83,
        "delta": -70328247.42
      },
      {
        "periodo": 202603,
        "valor": 1270867641.31,
        "delta": 205948896.48
      },
      {
        "periodo": 202604,
        "valor": 1204358716.98,
        "delta": -66508924.33
      },
      {
        "periodo": 202605,
        "valor": 1050617536.68,
        "delta": -153741180.3
      },
      {
        "periodo": 202606,
        "valor": 1228951960.68,
        "delta": 178334424.0
      },
      {
        "periodo": 202607,
        "valor": 1109375230.04,
        "delta": -119576730.64
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 2574614293.279999,
    "valor_anterior": 2933593657.8100014,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2885930605.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2835418915.85,
        "delta": -50511689.65
      },
      {
        "periodo": 202509,
        "valor": 3089365192.41,
        "delta": 253946276.56
      },
      {
        "periodo": 202510,
        "valor": 2603727477.56,
        "delta": -485637714.85
      },
      {
        "periodo": 202511,
        "valor": 2358971813.55,
        "delta": -244755664.01
      },
      {
        "periodo": 202512,
        "valor": 2157432681.98,
        "delta": -201539131.57
      },
      {
        "periodo": 202601,
        "valor": 2753005808.38,
        "delta": 595573126.4
      },
      {
        "periodo": 202602,
        "valor": 2969158958.88,
        "delta": 216153150.5
      },
      {
        "periodo": 202603,
        "valor": 2650427502.91,
        "delta": -318731455.97
      },
      {
        "periodo": 202604,
        "valor": 2842858761.51,
        "delta": 192431258.6
      },
      {
        "periodo": 202605,
        "valor": 2935257607.71,
        "delta": 92398846.2
      },
      {
        "periodo": 202606,
        "valor": 2933593657.81,
        "delta": -1663949.9
      },
      {
        "periodo": 202607,
        "valor": 2574614293.28,
        "delta": -358979364.53
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 2487026364.0200005,
    "valor_anterior": 2489597805.960001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2285301932.01,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2455762974.67,
        "delta": 170461042.66
      },
      {
        "periodo": 202509,
        "valor": 2370057824.72,
        "delta": -85705149.95
      },
      {
        "periodo": 202510,
        "valor": 2431994615.36,
        "delta": 61936790.64
      },
      {
        "periodo": 202511,
        "valor": 2643039300.83,
        "delta": 211044685.47
      },
      {
        "periodo": 202512,
        "valor": 2855518857.24,
        "delta": 212479556.41
      },
      {
        "periodo": 202601,
        "valor": 2419336791.12,
        "delta": -436182066.12
      },
      {
        "periodo": 202602,
        "valor": 2428514479.47,
        "delta": 9177688.35
      },
      {
        "periodo": 202603,
        "valor": 2640969827.91,
        "delta": 212455348.44
      },
      {
        "periodo": 202604,
        "valor": 2493849864.49,
        "delta": -147119963.42
      },
      {
        "periodo": 202605,
        "valor": 2499412276.73,
        "delta": 5562412.24
      },
      {
        "periodo": 202606,
        "valor": 2489597805.96,
        "delta": -9814470.77
      },
      {
        "periodo": 202607,
        "valor": 2487026364.02,
        "delta": -2571441.94
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 1177257339.9099998,
    "valor_anterior": 1180749695.9700003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1179669218.52,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1091782330.2,
        "delta": -87886888.32
      },
      {
        "periodo": 202509,
        "valor": 1256017417.81,
        "delta": 164235087.61
      },
      {
        "periodo": 202510,
        "valor": 1237925424.66,
        "delta": -18091993.15
      },
      {
        "periodo": 202511,
        "valor": 1169210504.29,
        "delta": -68714920.37
      },
      {
        "periodo": 202512,
        "valor": 1265598502.91,
        "delta": 96387998.62
      },
      {
        "periodo": 202601,
        "valor": 1167593979.16,
        "delta": -98004523.75
      },
      {
        "periodo": 202602,
        "valor": 1131772258.59,
        "delta": -35821720.57
      },
      {
        "periodo": 202603,
        "valor": 1241376225.59,
        "delta": 109603967.0
      },
      {
        "periodo": 202604,
        "valor": 1209066273.17,
        "delta": -32309952.42
      },
      {
        "periodo": 202605,
        "valor": 1244926860.62,
        "delta": 35860587.45
      },
      {
        "periodo": 202606,
        "valor": 1180749695.97,
        "delta": -64177164.65
      },
      {
        "periodo": 202607,
        "valor": 1177257339.91,
        "delta": -3492356.06
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100011,
    "label": "Gastos de Admón y Promoción",
    "valor_actual": 11054521498.480003,
    "valor_anterior": 10423256568.830002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9472927934.92,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9325992504.06,
        "delta": -146935430.86
      },
      {
        "periodo": 202509,
        "valor": 9074352429.99,
        "delta": -251640074.07
      },
      {
        "periodo": 202510,
        "valor": 9477353578.1,
        "delta": 403001148.11
      },
      {
        "periodo": 202511,
        "valor": 9894512071.52,
        "delta": 417158493.42
      },
      {
        "periodo": 202512,
        "valor": 9904392131.84,
        "delta": 9880060.32
      },
      {
        "periodo": 202601,
        "valor": 9196413674.94,
        "delta": -707978456.9
      },
      {
        "periodo": 202602,
        "valor": 8870829332.65,
        "delta": -325584342.29
      },
      {
        "periodo": 202603,
        "valor": 11558702727.21,
        "delta": 2687873394.56
      },
      {
        "periodo": 202604,
        "valor": 10490456249.9,
        "delta": -1068246477.31
      },
      {
        "periodo": 202605,
        "valor": 10767240070.93,
        "delta": 276783821.03
      },
      {
        "periodo": 202606,
        "valor": 10423256568.83,
        "delta": -343983502.1
      },
      {
        "periodo": 202607,
        "valor": 11054521498.48,
        "delta": 631264929.65
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 3642239247.630001,
    "valor_anterior": 3002149962.6000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2282701626.51,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1503810213.75,
        "delta": -778891412.76
      },
      {
        "periodo": 202509,
        "valor": 1367962812.1,
        "delta": -135847401.65
      },
      {
        "periodo": 202510,
        "valor": 988470265.26,
        "delta": -379492546.84
      },
      {
        "periodo": 202511,
        "valor": 4934315845.86,
        "delta": 3945845580.6
      },
      {
        "periodo": 202512,
        "valor": 1739324006.06,
        "delta": -3194991839.8
      },
      {
        "periodo": 202601,
        "valor": 2720659603.0,
        "delta": 981335596.94
      },
      {
        "periodo": 202602,
        "valor": 2089742525.53,
        "delta": -630917077.47
      },
      {
        "periodo": 202603,
        "valor": 4558238723.65,
        "delta": 2468496198.12
      },
      {
        "periodo": 202604,
        "valor": 1312863576.38,
        "delta": -3245375147.27
      },
      {
        "periodo": 202605,
        "valor": 1980427093.11,
        "delta": 667563516.73
      },
      {
        "periodo": 202606,
        "valor": 3002149962.6,
        "delta": 1021722869.49
      },
      {
        "periodo": 202607,
        "valor": 3642239247.63,
        "delta": 640089285.03
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 12569484729.73999,
    "valor_anterior": 11138606085.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11489229302.77,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11888738632.85,
        "delta": 399509330.08
      },
      {
        "periodo": 202509,
        "valor": 11103006469.42,
        "delta": -785732163.43
      },
      {
        "periodo": 202510,
        "valor": 11699574866.51,
        "delta": 596568397.09
      },
      {
        "periodo": 202511,
        "valor": 11538765650.33,
        "delta": -160809216.18
      },
      {
        "periodo": 202512,
        "valor": 11381291489.3,
        "delta": -157474161.03
      },
      {
        "periodo": 202601,
        "valor": 12621728703.42,
        "delta": 1240437214.12
      },
      {
        "periodo": 202602,
        "valor": 7186409336.22,
        "delta": -5435319367.2
      },
      {
        "periodo": 202603,
        "valor": 13094283221.15,
        "delta": 5907873884.93
      },
      {
        "periodo": 202604,
        "valor": 11560079645.48,
        "delta": -1534203575.67
      },
      {
        "periodo": 202605,
        "valor": 11481042981.17,
        "delta": -79036664.31
      },
      {
        "periodo": 202606,
        "valor": 11138606085.25,
        "delta": -342436895.92
      },
      {
        "periodo": 202607,
        "valor": 12569484729.74,
        "delta": 1430878644.49
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 3952681770.999996,
    "valor_anterior": 4596568222.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3974313330.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3907611536.0,
        "delta": -66701794.0
      },
      {
        "periodo": 202509,
        "valor": 3274913355.0,
        "delta": -632698181.0
      },
      {
        "periodo": 202510,
        "valor": 3338772999.0,
        "delta": 63859644.0
      },
      {
        "periodo": 202511,
        "valor": 2980435581.0,
        "delta": -358337418.0
      },
      {
        "periodo": 202512,
        "valor": 4666297599.0,
        "delta": 1685862018.0
      },
      {
        "periodo": 202601,
        "valor": 4812586029.0,
        "delta": 146288430.0
      },
      {
        "periodo": 202602,
        "valor": 3166343697.0,
        "delta": -1646242332.0
      },
      {
        "periodo": 202603,
        "valor": 5877082231.0,
        "delta": 2710738534.0
      },
      {
        "periodo": 202604,
        "valor": 4382817877.0,
        "delta": -1494264354.0
      },
      {
        "periodo": 202605,
        "valor": 2323163473.0,
        "delta": -2059654404.0
      },
      {
        "periodo": 202606,
        "valor": 4596568222.0,
        "delta": 2273404749.0
      },
      {
        "periodo": 202607,
        "valor": 3952681771.0,
        "delta": -643886451.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 558760304.0,
    "valor_anterior": 134869383.00000095,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1076879295.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 907792349.0,
        "delta": -169086946.0
      },
      {
        "periodo": 202509,
        "valor": 1061657564.0,
        "delta": 153865215.0
      },
      {
        "periodo": 202510,
        "valor": 536799568.0,
        "delta": -524857996.0
      },
      {
        "periodo": 202511,
        "valor": 1456650885.0,
        "delta": 919851317.0
      },
      {
        "periodo": 202512,
        "valor": -148781497.0,
        "delta": -1605432382.0
      },
      {
        "periodo": 202601,
        "valor": 1249164091.0,
        "delta": 1397945588.0
      },
      {
        "periodo": 202602,
        "valor": 976207494.0,
        "delta": -272956597.0
      },
      {
        "periodo": 202603,
        "valor": 2338444238.0,
        "delta": 1362236744.0
      },
      {
        "periodo": 202604,
        "valor": 500600017.0,
        "delta": -1837844221.0
      },
      {
        "periodo": 202605,
        "valor": 131157436.0,
        "delta": -369442581.0
      },
      {
        "periodo": 202606,
        "valor": 134869383.0,
        "delta": 3711947.0
      },
      {
        "periodo": 202607,
        "valor": 558760304.0,
        "delta": 423890921.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 878848649.4300003,
    "valor_anterior": 931786236.5299997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 952346682.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1116849100.64,
        "delta": 164502418.49
      },
      {
        "periodo": 202509,
        "valor": 1011023017.02,
        "delta": -105826083.62
      },
      {
        "periodo": 202510,
        "valor": 1018116215.98,
        "delta": 7093198.96
      },
      {
        "periodo": 202511,
        "valor": 1050873916.05,
        "delta": 32757700.07
      },
      {
        "periodo": 202512,
        "valor": 887575709.3,
        "delta": -163298206.75
      },
      {
        "periodo": 202601,
        "valor": 1058447074.4,
        "delta": 170871365.1
      },
      {
        "periodo": 202602,
        "valor": 756206139.31,
        "delta": -302240935.09
      },
      {
        "periodo": 202603,
        "valor": 1022686689.0,
        "delta": 266480549.69
      },
      {
        "periodo": 202604,
        "valor": 992986785.09,
        "delta": -29699903.91
      },
      {
        "periodo": 202605,
        "valor": 1023513762.0,
        "delta": 30526976.91
      },
      {
        "periodo": 202606,
        "valor": 931786236.53,
        "delta": -91727525.47
      },
      {
        "periodo": 202607,
        "valor": 878848649.43,
        "delta": -52937587.1
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 1649177650.999998,
    "valor_anterior": 1046089479.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2143661883.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2167542703.0,
        "delta": 23880820.0
      },
      {
        "periodo": 202509,
        "valor": 2239019449.0,
        "delta": 71476746.0
      },
      {
        "periodo": 202510,
        "valor": 1917257255.0,
        "delta": -321762194.0
      },
      {
        "periodo": 202511,
        "valor": 1942217181.0,
        "delta": 24959926.0
      },
      {
        "periodo": 202512,
        "valor": 3113970064.0,
        "delta": 1171752883.0
      },
      {
        "periodo": 202601,
        "valor": 2287209533.0,
        "delta": -826760531.0
      },
      {
        "periodo": 202602,
        "valor": 1997685621.0,
        "delta": -289523912.0
      },
      {
        "periodo": 202603,
        "valor": 2002642193.0,
        "delta": 4956572.0
      },
      {
        "periodo": 202604,
        "valor": 2227604537.0,
        "delta": 224962344.0
      },
      {
        "periodo": 202605,
        "valor": 1792224628.0,
        "delta": -435379909.0
      },
      {
        "periodo": 202606,
        "valor": 1046089479.0,
        "delta": -746135149.0
      },
      {
        "periodo": 202607,
        "valor": 1649177651.0,
        "delta": 603088172.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 398039896.0,
    "valor_anterior": 399066225.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 362172637.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 364781159.0,
        "delta": 2608522.0
      },
      {
        "periodo": 202509,
        "valor": 380784833.0,
        "delta": 16003674.0
      },
      {
        "periodo": 202510,
        "valor": 397127245.0,
        "delta": 16342412.0
      },
      {
        "periodo": 202511,
        "valor": 402328378.0,
        "delta": 5201133.0
      },
      {
        "periodo": 202512,
        "valor": 359554495.0,
        "delta": -42773883.0
      },
      {
        "periodo": 202601,
        "valor": 347787746.0,
        "delta": -11766749.0
      },
      {
        "periodo": 202602,
        "valor": 371631884.0,
        "delta": 23844138.0
      },
      {
        "periodo": 202603,
        "valor": 358388562.0,
        "delta": -13243322.0
      },
      {
        "periodo": 202604,
        "valor": 395519675.0,
        "delta": 37131113.0
      },
      {
        "periodo": 202605,
        "valor": 392384089.0,
        "delta": -3135586.0
      },
      {
        "periodo": 202606,
        "valor": 399066225.0,
        "delta": 6682136.0
      },
      {
        "periodo": 202607,
        "valor": 398039896.0,
        "delta": -1026329.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 1754817670.999998,
    "valor_anterior": 1570093314.000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1034529648.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1238189184.0,
        "delta": 203659536.0
      },
      {
        "periodo": 202509,
        "valor": 1113785503.0,
        "delta": -124403681.0
      },
      {
        "periodo": 202510,
        "valor": 925711500.0,
        "delta": -188074003.0
      },
      {
        "periodo": 202511,
        "valor": 909855707.0,
        "delta": -15855793.0
      },
      {
        "periodo": 202512,
        "valor": 1561481709.0,
        "delta": 651626002.0
      },
      {
        "periodo": 202601,
        "valor": 1841359760.0,
        "delta": 279878051.0
      },
      {
        "periodo": 202602,
        "valor": 1208120130.0,
        "delta": -633239630.0
      },
      {
        "periodo": 202603,
        "valor": 2602572639.0,
        "delta": 1394452509.0
      },
      {
        "periodo": 202604,
        "valor": 875039967.0,
        "delta": -1727532672.0
      },
      {
        "periodo": 202605,
        "valor": 1199899324.0,
        "delta": 324859357.0
      },
      {
        "periodo": 202606,
        "valor": 1570093314.0,
        "delta": 370193990.0
      },
      {
        "periodo": 202607,
        "valor": 1754817671.0,
        "delta": 184724357.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 730736527.79,
    "valor_anterior": 634879264.9900002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 665287265.13,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 661105899.08,
        "delta": -4181366.05
      },
      {
        "periodo": 202509,
        "valor": 645553323.93,
        "delta": -15552575.15
      },
      {
        "periodo": 202510,
        "valor": 749333812.06,
        "delta": 103780488.13
      },
      {
        "periodo": 202511,
        "valor": 812293623.5,
        "delta": 62959811.44
      },
      {
        "periodo": 202512,
        "valor": 833425011.21,
        "delta": 21131387.71
      },
      {
        "periodo": 202601,
        "valor": 652147431.46,
        "delta": -181277579.75
      },
      {
        "periodo": 202602,
        "valor": 528364801.4,
        "delta": -123782630.06
      },
      {
        "periodo": 202603,
        "valor": 739309354.74,
        "delta": 210944553.34
      },
      {
        "periodo": 202604,
        "valor": 649122282.47,
        "delta": -90187072.27
      },
      {
        "periodo": 202605,
        "valor": 640237742.82,
        "delta": -8884539.65
      },
      {
        "periodo": 202606,
        "valor": 634879264.99,
        "delta": -5358477.83
      },
      {
        "periodo": 202607,
        "valor": 730736527.79,
        "delta": 95857262.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 325289793.0,
    "valor_anterior": 201410781.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 265664119.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 50529092.0,
        "delta": -215135027.0
      },
      {
        "periodo": 202509,
        "valor": 303749932.0,
        "delta": 253220840.0
      },
      {
        "periodo": 202510,
        "valor": 294724568.0,
        "delta": -9025364.0
      },
      {
        "periodo": 202511,
        "valor": -48513781.0,
        "delta": -343238349.0
      },
      {
        "periodo": 202512,
        "valor": 125817958.0,
        "delta": 174331739.0
      },
      {
        "periodo": 202601,
        "valor": -36222648.0,
        "delta": -162040606.0
      },
      {
        "periodo": 202602,
        "valor": 15327756.0,
        "delta": 51550404.0
      },
      {
        "periodo": 202603,
        "valor": 150070284.0,
        "delta": 134742528.0
      },
      {
        "periodo": 202604,
        "valor": 265525236.0,
        "delta": 115454952.0
      },
      {
        "periodo": 202605,
        "valor": 210063516.0,
        "delta": -55461720.0
      },
      {
        "periodo": 202606,
        "valor": 201410781.0,
        "delta": -8652735.0
      },
      {
        "periodo": 202607,
        "valor": 325289793.0,
        "delta": 123879012.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 141922666.0,
    "valor_anterior": 140008415.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 153709368.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 218582238.0,
        "delta": 64872870.0
      },
      {
        "periodo": 202509,
        "valor": 173642765.0,
        "delta": -44939473.0
      },
      {
        "periodo": 202510,
        "valor": 135007516.0,
        "delta": -38635249.0
      },
      {
        "periodo": 202511,
        "valor": 134739435.0,
        "delta": -268081.0
      },
      {
        "periodo": 202512,
        "valor": 143656663.0,
        "delta": 8917228.0
      },
      {
        "periodo": 202601,
        "valor": 136080691.0,
        "delta": -7575972.0
      },
      {
        "periodo": 202602,
        "valor": 145804694.0,
        "delta": 9724003.0
      },
      {
        "periodo": 202603,
        "valor": 90380248.0,
        "delta": -55424446.0
      },
      {
        "periodo": 202604,
        "valor": 139075800.0,
        "delta": 48695552.0
      },
      {
        "periodo": 202605,
        "valor": 131834061.0,
        "delta": -7241739.0
      },
      {
        "periodo": 202606,
        "valor": 140008415.0,
        "delta": 8174354.0
      },
      {
        "periodo": 202607,
        "valor": 141922666.0,
        "delta": 1914251.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 70904532.0,
    "valor_anterior": 152085789.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 98297383.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 139159010.0,
        "delta": 40861627.0
      },
      {
        "periodo": 202509,
        "valor": 112340923.0,
        "delta": -26818087.0
      },
      {
        "periodo": 202510,
        "valor": 125644272.0,
        "delta": 13303349.0
      },
      {
        "periodo": 202511,
        "valor": 102840057.0,
        "delta": -22804215.0
      },
      {
        "periodo": 202512,
        "valor": -590207776.0,
        "delta": -693047833.0
      },
      {
        "periodo": 202601,
        "valor": 147162998.0,
        "delta": 737370774.0
      },
      {
        "periodo": 202602,
        "valor": 67736217.0,
        "delta": -79426781.0
      },
      {
        "periodo": 202603,
        "valor": 200607437.0,
        "delta": 132871220.0
      },
      {
        "periodo": 202604,
        "valor": 166869422.0,
        "delta": -33738015.0
      },
      {
        "periodo": 202605,
        "valor": 104906407.0,
        "delta": -61963015.0
      },
      {
        "periodo": 202606,
        "valor": 152085789.0,
        "delta": 47179382.0
      },
      {
        "periodo": 202607,
        "valor": 70904532.0,
        "delta": -81181257.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 5543774484.230003,
    "valor_anterior": 5983982615.949997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5633941257.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5318851470.63,
        "delta": -315089787.24
      },
      {
        "periodo": 202509,
        "valor": 4036990781.23,
        "delta": -1281860689.4
      },
      {
        "periodo": 202510,
        "valor": 5831946154.19,
        "delta": 1794955372.96
      },
      {
        "periodo": 202511,
        "valor": 5047516252.65,
        "delta": -784429901.54
      },
      {
        "periodo": 202512,
        "valor": 7040802083.29,
        "delta": 1993285830.64
      },
      {
        "periodo": 202601,
        "valor": 5346079625.11,
        "delta": -1694722458.18
      },
      {
        "periodo": 202602,
        "valor": 5271459630.55,
        "delta": -74619994.56
      },
      {
        "periodo": 202603,
        "valor": 6559032513.87,
        "delta": 1287572883.32
      },
      {
        "periodo": 202604,
        "valor": 6038949402.93,
        "delta": -520083110.94
      },
      {
        "periodo": 202605,
        "valor": 5553210038.44,
        "delta": -485739364.49
      },
      {
        "periodo": 202606,
        "valor": 5983982615.95,
        "delta": 430772577.51
      },
      {
        "periodo": 202607,
        "valor": 5543774484.23,
        "delta": -440208131.72
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 268710199.0,
    "valor_anterior": 179510194.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 186889063.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 184239200.0,
        "delta": -2649863.0
      },
      {
        "periodo": 202509,
        "valor": 109071398.0,
        "delta": -75167802.0
      },
      {
        "periodo": 202510,
        "valor": 313572969.0,
        "delta": 204501571.0
      },
      {
        "periodo": 202511,
        "valor": -78402136.0,
        "delta": -391975105.0
      },
      {
        "periodo": 202512,
        "valor": 404639401.0,
        "delta": 483041537.0
      },
      {
        "periodo": 202601,
        "valor": 331991601.0,
        "delta": -72647800.0
      },
      {
        "periodo": 202602,
        "valor": 227169165.0,
        "delta": -104822436.0
      },
      {
        "periodo": 202603,
        "valor": 303571202.0,
        "delta": 76402037.0
      },
      {
        "periodo": 202604,
        "valor": 430365320.0,
        "delta": 126794118.0
      },
      {
        "periodo": 202605,
        "valor": -1715568.0,
        "delta": -432080888.0
      },
      {
        "periodo": 202606,
        "valor": 179510194.0,
        "delta": 181225762.0
      },
      {
        "periodo": 202607,
        "valor": 268710199.0,
        "delta": 89200005.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 92652426.0,
    "valor_anterior": 35839177.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 130519571.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 135178367.0,
        "delta": 4658796.0
      },
      {
        "periodo": 202509,
        "valor": 134305616.0,
        "delta": -872751.0
      },
      {
        "periodo": 202510,
        "valor": 87851353.0,
        "delta": -46454263.0
      },
      {
        "periodo": 202511,
        "valor": 101967214.0,
        "delta": 14115861.0
      },
      {
        "periodo": 202512,
        "valor": 105358056.0,
        "delta": 3390842.0
      },
      {
        "periodo": 202601,
        "valor": 77733246.0,
        "delta": -27624810.0
      },
      {
        "periodo": 202602,
        "valor": 18940176.0,
        "delta": -58793070.0
      },
      {
        "periodo": 202603,
        "valor": 35162370.0,
        "delta": 16222194.0
      },
      {
        "periodo": 202604,
        "valor": 90485199.0,
        "delta": 55322829.0
      },
      {
        "periodo": 202605,
        "valor": 82132215.0,
        "delta": -8352984.0
      },
      {
        "periodo": 202606,
        "valor": 35839177.0,
        "delta": -46293038.0
      },
      {
        "periodo": 202607,
        "valor": 92652426.0,
        "delta": 56813249.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 305026974.0,
    "valor_anterior": 279141298.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 469688161.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 738775828.0,
        "delta": 269087667.0
      },
      {
        "periodo": 202509,
        "valor": 884385688.0,
        "delta": 145609860.0
      },
      {
        "periodo": 202510,
        "valor": 509141271.0,
        "delta": -375244417.0
      },
      {
        "periodo": 202511,
        "valor": 361461735.0,
        "delta": -147679536.0
      },
      {
        "periodo": 202512,
        "valor": 294225171.0,
        "delta": -67236564.0
      },
      {
        "periodo": 202601,
        "valor": 282572249.0,
        "delta": -11652922.0
      },
      {
        "periodo": 202602,
        "valor": 408439904.0,
        "delta": 125867655.0
      },
      {
        "periodo": 202603,
        "valor": 472123573.0,
        "delta": 63683669.0
      },
      {
        "periodo": 202604,
        "valor": 219237659.0,
        "delta": -252885914.0
      },
      {
        "periodo": 202605,
        "valor": 314755749.0,
        "delta": 95518090.0
      },
      {
        "periodo": 202606,
        "valor": 279141298.0,
        "delta": -35614451.0
      },
      {
        "periodo": 202607,
        "valor": 305026974.0,
        "delta": 25885676.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 454148656.02,
    "valor_anterior": 516876862.66999984,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 339322257.58,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 485134710.53,
        "delta": 145812452.95
      },
      {
        "periodo": 202509,
        "valor": 493392797.19,
        "delta": 8258086.66
      },
      {
        "periodo": 202510,
        "valor": 592289437.2,
        "delta": 98896640.01
      },
      {
        "periodo": 202511,
        "valor": 359777237.46,
        "delta": -232512199.74
      },
      {
        "periodo": 202512,
        "valor": 591226437.25,
        "delta": 231449199.79
      },
      {
        "periodo": 202601,
        "valor": 580016096.89,
        "delta": -11210340.36
      },
      {
        "periodo": 202602,
        "valor": 379569478.97,
        "delta": -200446617.92
      },
      {
        "periodo": 202603,
        "valor": 40058992.02,
        "delta": -339510486.95
      },
      {
        "periodo": 202604,
        "valor": 249258258.55,
        "delta": 209199266.53
      },
      {
        "periodo": 202605,
        "valor": 487746131.71,
        "delta": 238487873.16
      },
      {
        "periodo": 202606,
        "valor": 516876862.67,
        "delta": 29130730.96
      },
      {
        "periodo": 202607,
        "valor": 454148656.02,
        "delta": -62728206.65
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 142520292.0,
    "valor_anterior": 187432674.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 92295446.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 113730789.0,
        "delta": 21435343.0
      },
      {
        "periodo": 202509,
        "valor": 149683723.0,
        "delta": 35952934.0
      },
      {
        "periodo": 202510,
        "valor": 138513812.0,
        "delta": -11169911.0
      },
      {
        "periodo": 202511,
        "valor": 125192794.0,
        "delta": -13321018.0
      },
      {
        "periodo": 202512,
        "valor": 156200999.0,
        "delta": 31008205.0
      },
      {
        "periodo": 202601,
        "valor": 123812157.0,
        "delta": -32388842.0
      },
      {
        "periodo": 202602,
        "valor": 21684059.0,
        "delta": -102128098.0
      },
      {
        "periodo": 202603,
        "valor": 174805705.0,
        "delta": 153121646.0
      },
      {
        "periodo": 202604,
        "valor": 191342140.0,
        "delta": 16536435.0
      },
      {
        "periodo": 202605,
        "valor": 146733109.0,
        "delta": -44609031.0
      },
      {
        "periodo": 202606,
        "valor": 187432674.0,
        "delta": 40699565.0
      },
      {
        "periodo": 202607,
        "valor": 142520292.0,
        "delta": -44912382.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 819576482.5,
    "valor_anterior": 1165269868.04,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 855131280.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1533535541.54,
        "delta": 678404261.15
      },
      {
        "periodo": 202509,
        "valor": 1448373310.73,
        "delta": -85162230.81
      },
      {
        "periodo": 202510,
        "valor": 1325382156.36,
        "delta": -122991154.37
      },
      {
        "periodo": 202511,
        "valor": 840747571.73,
        "delta": -484634584.63
      },
      {
        "periodo": 202512,
        "valor": 2556914820.71,
        "delta": 1716167248.98
      },
      {
        "periodo": 202601,
        "valor": 1740280020.17,
        "delta": -816634800.54
      },
      {
        "periodo": 202602,
        "valor": 1092966292.98,
        "delta": -647313727.19
      },
      {
        "periodo": 202603,
        "valor": 1190762512.65,
        "delta": 97796219.67
      },
      {
        "periodo": 202604,
        "valor": 1106174652.49,
        "delta": -84587860.16
      },
      {
        "periodo": 202605,
        "valor": 1116215982.13,
        "delta": 10041329.64
      },
      {
        "periodo": 202606,
        "valor": 1165269868.04,
        "delta": 49053885.91
      },
      {
        "periodo": 202607,
        "valor": 819576482.5,
        "delta": -345693385.54
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": -1481859.0,
    "valor_anterior": 5268130.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -12618376.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -13391855.0,
        "delta": -773479.0
      },
      {
        "periodo": 202509,
        "valor": -10441984.0,
        "delta": 2949871.0
      },
      {
        "periodo": 202510,
        "valor": 9121593.0,
        "delta": 19563577.0
      },
      {
        "periodo": 202511,
        "valor": -21466065.0,
        "delta": -30587658.0
      },
      {
        "periodo": 202512,
        "valor": -30122374.0,
        "delta": -8656309.0
      },
      {
        "periodo": 202601,
        "valor": 5278601.0,
        "delta": 35400975.0
      },
      {
        "periodo": 202602,
        "valor": 502160.0,
        "delta": -4776441.0
      },
      {
        "periodo": 202603,
        "valor": -2784645.0,
        "delta": -3286805.0
      },
      {
        "periodo": 202604,
        "valor": 4952888.0,
        "delta": 7737533.0
      },
      {
        "periodo": 202605,
        "valor": 145395.0,
        "delta": -4807493.0
      },
      {
        "periodo": 202606,
        "valor": 5268130.0,
        "delta": 5122735.0
      },
      {
        "periodo": 202607,
        "valor": -1481859.0,
        "delta": -6749989.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": -487522840.16999996,
    "valor_anterior": -1361050508.7,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 467226763.37,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 667306575.88,
        "delta": 200079812.51
      },
      {
        "periodo": 202509,
        "valor": 566760395.09,
        "delta": -100546180.79
      },
      {
        "periodo": 202510,
        "valor": 1364336123.43,
        "delta": 797575728.34
      },
      {
        "periodo": 202511,
        "valor": 845576550.0,
        "delta": -518759573.43
      },
      {
        "periodo": 202512,
        "valor": 1418766370.44,
        "delta": 573189820.44
      },
      {
        "periodo": 202601,
        "valor": 801783992.9,
        "delta": -616982377.54
      },
      {
        "periodo": 202602,
        "valor": 739722624.75,
        "delta": -62061368.15
      },
      {
        "periodo": 202603,
        "valor": 981187661.55,
        "delta": 241465036.8
      },
      {
        "periodo": 202604,
        "valor": 471457706.28,
        "delta": -509729955.27
      },
      {
        "periodo": 202605,
        "valor": -1030135323.5,
        "delta": -1501593029.78
      },
      {
        "periodo": 202606,
        "valor": -1361050508.7,
        "delta": -330915185.2
      },
      {
        "periodo": 202607,
        "valor": -487522840.17,
        "delta": 873527668.53
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 214401185.0,
    "valor_anterior": 89052207.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25404056.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 54559335.73,
        "delta": 29155278.91
      },
      {
        "periodo": 202509,
        "valor": 298197497.23,
        "delta": 243638161.5
      },
      {
        "periodo": 202510,
        "valor": 97848537.0,
        "delta": -200348960.23
      },
      {
        "periodo": 202511,
        "valor": -18556855.0,
        "delta": -116405392.0
      },
      {
        "periodo": 202512,
        "valor": 166287565.0,
        "delta": 184844420.0
      },
      {
        "periodo": 202601,
        "valor": 159751863.0,
        "delta": -6535702.0
      },
      {
        "periodo": 202602,
        "valor": 127895005.0,
        "delta": -31856858.0
      },
      {
        "periodo": 202603,
        "valor": 247900555.0,
        "delta": 120005550.0
      },
      {
        "periodo": 202604,
        "valor": 119293984.0,
        "delta": -128606571.0
      },
      {
        "periodo": 202605,
        "valor": 113365617.0,
        "delta": -5928367.0
      },
      {
        "periodo": 202606,
        "valor": 89052207.0,
        "delta": -24313410.0
      },
      {
        "periodo": 202607,
        "valor": 214401185.0,
        "delta": 125348978.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 25520159.0,
    "valor_anterior": 45530983.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 341799766.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -60506414.0,
        "delta": -402306180.0
      },
      {
        "periodo": 202509,
        "valor": 126882662.0,
        "delta": 187389076.0
      },
      {
        "periodo": 202510,
        "valor": 101110391.0,
        "delta": -25772271.0
      },
      {
        "periodo": 202511,
        "valor": 43147512.0,
        "delta": -57962879.0
      },
      {
        "periodo": 202512,
        "valor": -56942516.0,
        "delta": -100090028.0
      },
      {
        "periodo": 202601,
        "valor": 98933857.0,
        "delta": 155876373.0
      },
      {
        "periodo": 202602,
        "valor": 164338729.0,
        "delta": 65404872.0
      },
      {
        "periodo": 202603,
        "valor": 2985791.0,
        "delta": -161352938.0
      },
      {
        "periodo": 202604,
        "valor": 80632827.0,
        "delta": 77647036.0
      },
      {
        "periodo": 202605,
        "valor": 111535481.0,
        "delta": 30902654.0
      },
      {
        "periodo": 202606,
        "valor": 45530983.0,
        "delta": -66004498.0
      },
      {
        "periodo": 202607,
        "valor": 25520159.0,
        "delta": -20010824.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 682895594.999999,
    "valor_anterior": 872027829.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 654095262.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 794756777.0,
        "delta": 140661515.0
      },
      {
        "periodo": 202509,
        "valor": 718149943.0,
        "delta": -76606834.0
      },
      {
        "periodo": 202510,
        "valor": 634966493.0,
        "delta": -83183450.0
      },
      {
        "periodo": 202511,
        "valor": 635559580.0,
        "delta": 593087.0
      },
      {
        "periodo": 202512,
        "valor": 708332412.0,
        "delta": 72772832.0
      },
      {
        "periodo": 202601,
        "valor": 903268536.0,
        "delta": 194936124.0
      },
      {
        "periodo": 202602,
        "valor": 793591960.0,
        "delta": -109676576.0
      },
      {
        "periodo": 202603,
        "valor": 717758579.0,
        "delta": -75833381.0
      },
      {
        "periodo": 202604,
        "valor": 497225718.0,
        "delta": -220532861.0
      },
      {
        "periodo": 202605,
        "valor": 738938060.0,
        "delta": 241712342.0
      },
      {
        "periodo": 202606,
        "valor": 872027829.0,
        "delta": 133089769.0
      },
      {
        "periodo": 202607,
        "valor": 682895595.0,
        "delta": -189132234.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 302986657.0,
    "valor_anterior": 357360807.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 119091618.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 131182416.0,
        "delta": 12090798.0
      },
      {
        "periodo": 202509,
        "valor": 139795082.0,
        "delta": 8612666.0
      },
      {
        "periodo": 202510,
        "valor": 298611044.0,
        "delta": 158815962.0
      },
      {
        "periodo": 202511,
        "valor": 185595075.0,
        "delta": -113015969.0
      },
      {
        "periodo": 202512,
        "valor": 156341639.0,
        "delta": -29253436.0
      },
      {
        "periodo": 202601,
        "valor": 165625984.0,
        "delta": 9284345.0
      },
      {
        "periodo": 202602,
        "valor": 125044791.0,
        "delta": -40581193.0
      },
      {
        "periodo": 202603,
        "valor": 158605649.0,
        "delta": 33560858.0
      },
      {
        "periodo": 202604,
        "valor": 168881455.0,
        "delta": 10275806.0
      },
      {
        "periodo": 202605,
        "valor": 243458016.0,
        "delta": 74576561.0
      },
      {
        "periodo": 202606,
        "valor": 357360807.0,
        "delta": 113902791.0
      },
      {
        "periodo": 202607,
        "valor": 302986657.0,
        "delta": -54374150.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 44076768.0,
    "valor_anterior": -35551723.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 56427945.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29959885.0,
        "delta": -26468060.0
      },
      {
        "periodo": 202509,
        "valor": 124665573.0,
        "delta": 94705688.0
      },
      {
        "periodo": 202510,
        "valor": 77737671.0,
        "delta": -46927902.0
      },
      {
        "periodo": 202511,
        "valor": -22239472.0,
        "delta": -99977143.0
      },
      {
        "periodo": 202512,
        "valor": 26724689.0,
        "delta": 48964161.0
      },
      {
        "periodo": 202601,
        "valor": -12791857.0,
        "delta": -39516546.0
      },
      {
        "periodo": 202602,
        "valor": 44050247.0,
        "delta": 56842104.0
      },
      {
        "periodo": 202603,
        "valor": 35751815.0,
        "delta": -8298432.0
      },
      {
        "periodo": 202604,
        "valor": 44319382.0,
        "delta": 8567567.0
      },
      {
        "periodo": 202605,
        "valor": 112675571.0,
        "delta": 68356189.0
      },
      {
        "periodo": 202606,
        "valor": -35551723.0,
        "delta": -148227294.0
      },
      {
        "periodo": 202607,
        "valor": 44076768.0,
        "delta": 79628491.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": -35213025.0,
    "valor_anterior": -302417795.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -401205337.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -236552141.0,
        "delta": 164653196.0
      },
      {
        "periodo": 202509,
        "valor": -168171082.0,
        "delta": 68381059.0
      },
      {
        "periodo": 202510,
        "valor": -80484194.0,
        "delta": 87686888.0
      },
      {
        "periodo": 202511,
        "valor": 32340704.0,
        "delta": 112824898.0
      },
      {
        "periodo": 202512,
        "valor": -209128081.0,
        "delta": -241468785.0
      },
      {
        "periodo": 202601,
        "valor": 51827773.0,
        "delta": 260955854.0
      },
      {
        "periodo": 202602,
        "valor": 97107174.0,
        "delta": 45279401.0
      },
      {
        "periodo": 202603,
        "valor": 34906650.0,
        "delta": -62200524.0
      },
      {
        "periodo": 202604,
        "valor": -38125941.0,
        "delta": -73032591.0
      },
      {
        "periodo": 202605,
        "valor": 5278385.0,
        "delta": 43404326.0
      },
      {
        "periodo": 202606,
        "valor": -302417795.0,
        "delta": -307696180.0
      },
      {
        "periodo": 202607,
        "valor": -35213025.0,
        "delta": 267204770.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 342098144.86000013,
    "valor_anterior": 750642474.5300001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 275764491.85,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 98892938.07,
        "delta": -176871553.78
      },
      {
        "periodo": 202509,
        "valor": 365077608.97,
        "delta": 266184670.9
      },
      {
        "periodo": 202510,
        "valor": 386832468.89,
        "delta": 21754859.92
      },
      {
        "periodo": 202511,
        "valor": 287193380.79,
        "delta": -99639088.1
      },
      {
        "periodo": 202512,
        "valor": 65701768.94,
        "delta": -221491611.85
      },
      {
        "periodo": 202601,
        "valor": -40582947.49,
        "delta": -106284716.43
      },
      {
        "periodo": 202602,
        "valor": 387476800.4,
        "delta": 428059747.89
      },
      {
        "periodo": 202603,
        "valor": -22722077.33,
        "delta": -410198877.73
      },
      {
        "periodo": 202604,
        "valor": 303286942.66,
        "delta": 326009019.99
      },
      {
        "periodo": 202605,
        "valor": 436052292.69,
        "delta": 132765350.03
      },
      {
        "periodo": 202606,
        "valor": 750642474.53,
        "delta": 314590181.84
      },
      {
        "periodo": 202607,
        "valor": 342098144.86,
        "delta": -408544329.67
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": -88712841.0,
    "valor_anterior": -102052055.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -145163505.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -108520833.0,
        "delta": 36642672.0
      },
      {
        "periodo": 202509,
        "valor": -104740158.0,
        "delta": 3780675.0
      },
      {
        "periodo": 202510,
        "valor": -115097748.0,
        "delta": -10357590.0
      },
      {
        "periodo": 202511,
        "valor": -133634471.0,
        "delta": -18536723.0
      },
      {
        "periodo": 202512,
        "valor": -104547995.0,
        "delta": 29086476.0
      },
      {
        "periodo": 202601,
        "valor": -89898062.0,
        "delta": 14649933.0
      },
      {
        "periodo": 202602,
        "valor": -120708252.0,
        "delta": -30810190.0
      },
      {
        "periodo": 202603,
        "valor": -104854825.0,
        "delta": 15853427.0
      },
      {
        "periodo": 202604,
        "valor": -84863364.0,
        "delta": 19991461.0
      },
      {
        "periodo": 202605,
        "valor": -76215320.0,
        "delta": 8648044.0
      },
      {
        "periodo": 202606,
        "valor": -102052055.0,
        "delta": -25836735.0
      },
      {
        "periodo": 202607,
        "valor": -88712841.0,
        "delta": 13339214.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 3008307.0,
    "valor_anterior": 2994909.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4253055.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12654947.0,
        "delta": 8401892.0
      },
      {
        "periodo": 202509,
        "valor": 17664296.0,
        "delta": 5009349.0
      },
      {
        "periodo": 202510,
        "valor": 11312998.0,
        "delta": -6351298.0
      },
      {
        "periodo": 202511,
        "valor": 220570.0,
        "delta": -11092428.0
      },
      {
        "periodo": 202512,
        "valor": -2643427.0,
        "delta": -2863997.0
      },
      {
        "periodo": 202601,
        "valor": 2728717.0,
        "delta": 5372144.0
      },
      {
        "periodo": 202602,
        "valor": 4576380.0,
        "delta": 1847663.0
      },
      {
        "periodo": 202603,
        "valor": 10030429.0,
        "delta": 5454049.0
      },
      {
        "periodo": 202604,
        "valor": 7836337.0,
        "delta": -2194092.0
      },
      {
        "periodo": 202605,
        "valor": 11278403.0,
        "delta": 3442066.0
      },
      {
        "periodo": 202606,
        "valor": 2994909.0,
        "delta": -8283494.0
      },
      {
        "periodo": 202607,
        "valor": 3008307.0,
        "delta": 13398.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 84528061.0,
    "valor_anterior": 186195200.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 159722538.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 177490416.0,
        "delta": 17767878.0
      },
      {
        "periodo": 202509,
        "valor": 187157636.0,
        "delta": 9667220.0
      },
      {
        "periodo": 202510,
        "valor": 149138983.0,
        "delta": -38018653.0
      },
      {
        "periodo": 202511,
        "valor": 206181980.0,
        "delta": 57042997.0
      },
      {
        "periodo": 202512,
        "valor": 132945258.0,
        "delta": -73236722.0
      },
      {
        "periodo": 202601,
        "valor": 161826129.0,
        "delta": 28880871.0
      },
      {
        "periodo": 202602,
        "valor": 213628994.0,
        "delta": 51802865.0
      },
      {
        "periodo": 202603,
        "valor": 222639574.0,
        "delta": 9010580.0
      },
      {
        "periodo": 202604,
        "valor": 201462464.0,
        "delta": -21177110.0
      },
      {
        "periodo": 202605,
        "valor": 161458642.0,
        "delta": -40003822.0
      },
      {
        "periodo": 202606,
        "valor": 186195200.0,
        "delta": 24736558.0
      },
      {
        "periodo": 202607,
        "valor": 84528061.0,
        "delta": -101667139.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 44441308.0,
    "valor_anterior": 81613041.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 67960478.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16582198.0,
        "delta": -51378280.0
      },
      {
        "periodo": 202509,
        "valor": 87773790.0,
        "delta": 71191592.0
      },
      {
        "periodo": 202510,
        "valor": -4389632.0,
        "delta": -92163422.0
      },
      {
        "periodo": 202511,
        "valor": 6334827.0,
        "delta": 10724459.0
      },
      {
        "periodo": 202512,
        "valor": 51317443.0,
        "delta": 44982616.0
      },
      {
        "periodo": 202601,
        "valor": 28854365.0,
        "delta": -22463078.0
      },
      {
        "periodo": 202602,
        "valor": 72170159.0,
        "delta": 43315794.0
      },
      {
        "periodo": 202603,
        "valor": 65976009.0,
        "delta": -6194150.0
      },
      {
        "periodo": 202604,
        "valor": 55830606.0,
        "delta": -10145403.0
      },
      {
        "periodo": 202605,
        "valor": 22894768.0,
        "delta": -32935838.0
      },
      {
        "periodo": 202606,
        "valor": 81613041.0,
        "delta": 58718273.0
      },
      {
        "periodo": 202607,
        "valor": 44441308.0,
        "delta": -37171733.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1173668117.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1018970561.0,
        "delta": 154697556.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 213126370.0,
    "valor_anterior": 196411609.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 143929883.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 234533529.0,
        "delta": 90603646.0
      },
      {
        "periodo": 202509,
        "valor": 174489134.0,
        "delta": -60044395.0
      },
      {
        "periodo": 202510,
        "valor": 275134396.0,
        "delta": 100645262.0
      },
      {
        "periodo": 202511,
        "valor": 125929595.0,
        "delta": -149204801.0
      },
      {
        "periodo": 202512,
        "valor": 363667226.0,
        "delta": 237737631.0
      },
      {
        "periodo": 202601,
        "valor": 137358807.0,
        "delta": -226308419.0
      },
      {
        "periodo": 202602,
        "valor": 163688570.0,
        "delta": 26329763.0
      },
      {
        "periodo": 202603,
        "valor": 231478607.0,
        "delta": 67790037.0
      },
      {
        "periodo": 202604,
        "valor": 225107935.0,
        "delta": -6370672.0
      },
      {
        "periodo": 202605,
        "valor": 177933179.0,
        "delta": -47174756.0
      },
      {
        "periodo": 202606,
        "valor": 196411609.0,
        "delta": 18478430.0
      },
      {
        "periodo": 202607,
        "valor": 213126370.0,
        "delta": 16714761.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": -66966857.0,
    "valor_anterior": 191119414.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22148791.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 67199584.0,
        "delta": 45050793.0
      },
      {
        "periodo": 202509,
        "valor": -8049846.0,
        "delta": -75249430.0
      },
      {
        "periodo": 202510,
        "valor": -16614193.0,
        "delta": -8564347.0
      },
      {
        "periodo": 202511,
        "valor": -38491706.0,
        "delta": -21877513.0
      },
      {
        "periodo": 202512,
        "valor": 21324355.0,
        "delta": 59816061.0
      },
      {
        "periodo": 202601,
        "valor": 6827185.0,
        "delta": -14497170.0
      },
      {
        "periodo": 202602,
        "valor": 7397779.0,
        "delta": 570594.0
      },
      {
        "periodo": 202603,
        "valor": 15335298.0,
        "delta": 7937519.0
      },
      {
        "periodo": 202604,
        "valor": -120819092.0,
        "delta": -136154390.0
      },
      {
        "periodo": 202605,
        "valor": -35686193.0,
        "delta": 85132899.0
      },
      {
        "periodo": 202606,
        "valor": 191119414.0,
        "delta": 226805607.0
      },
      {
        "periodo": 202607,
        "valor": -66966857.0,
        "delta": -258086271.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 3585915.0,
    "valor_anterior": 1999842.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -6331452.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -8814540.0,
        "delta": -2483088.0
      },
      {
        "periodo": 202509,
        "valor": -4929790.0,
        "delta": 3884750.0
      },
      {
        "periodo": 202510,
        "valor": -6800463.0,
        "delta": -1870673.0
      },
      {
        "periodo": 202511,
        "valor": 12222225.0,
        "delta": 19022688.0
      },
      {
        "periodo": 202512,
        "valor": 4963514.0,
        "delta": -7258711.0
      },
      {
        "periodo": 202601,
        "valor": -6697490.0,
        "delta": -11661004.0
      },
      {
        "periodo": 202602,
        "valor": 798398.0,
        "delta": 7495888.0
      },
      {
        "periodo": 202603,
        "valor": 754580.0,
        "delta": -43818.0
      },
      {
        "periodo": 202604,
        "valor": -3856228.0,
        "delta": -4610808.0
      },
      {
        "periodo": 202605,
        "valor": 2094074.0,
        "delta": 5950302.0
      },
      {
        "periodo": 202606,
        "valor": 1999842.0,
        "delta": -94232.0
      },
      {
        "periodo": 202607,
        "valor": 3585915.0,
        "delta": 1586073.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": -11014470.0,
    "valor_anterior": -13143475.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -6851038.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -9453915.0,
        "delta": -2602877.0
      },
      {
        "periodo": 202509,
        "valor": -8009743.0,
        "delta": 1444172.0
      },
      {
        "periodo": 202510,
        "valor": -9963533.0,
        "delta": -1953790.0
      },
      {
        "periodo": 202511,
        "valor": -6304887.0,
        "delta": 3658646.0
      },
      {
        "periodo": 202512,
        "valor": -8580738.0,
        "delta": -2275851.0
      },
      {
        "periodo": 202601,
        "valor": -5821287.0,
        "delta": 2759451.0
      },
      {
        "periodo": 202602,
        "valor": -5836983.0,
        "delta": -15696.0
      },
      {
        "periodo": 202603,
        "valor": -6860023.0,
        "delta": -1023040.0
      },
      {
        "periodo": 202604,
        "valor": -8428720.0,
        "delta": -1568697.0
      },
      {
        "periodo": 202605,
        "valor": -11800860.0,
        "delta": -3372140.0
      },
      {
        "periodo": 202606,
        "valor": -13143475.0,
        "delta": -1342615.0
      },
      {
        "periodo": 202607,
        "valor": -11014470.0,
        "delta": 2129005.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 19707736.0,
    "valor_anterior": 20657720.83,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -3312459.34,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 466887.04,
        "delta": 3779346.38
      },
      {
        "periodo": 202509,
        "valor": 15674132.78,
        "delta": 15207245.74
      },
      {
        "periodo": 202510,
        "valor": 17779771.0,
        "delta": 2105638.22
      },
      {
        "periodo": 202511,
        "valor": 19463466.82,
        "delta": 1683695.82
      },
      {
        "periodo": 202512,
        "valor": 32441463.41,
        "delta": 12977996.59
      },
      {
        "periodo": 202601,
        "valor": 5789616.67,
        "delta": -26651846.74
      },
      {
        "periodo": 202602,
        "valor": 6572887.14,
        "delta": 783270.47
      },
      {
        "periodo": 202603,
        "valor": 3543493.26,
        "delta": -3029393.88
      },
      {
        "periodo": 202604,
        "valor": 10406908.38,
        "delta": 6863415.12
      },
      {
        "periodo": 202605,
        "valor": 10199418.08,
        "delta": -207490.3
      },
      {
        "periodo": 202606,
        "valor": 20657720.83,
        "delta": 10458302.75
      },
      {
        "periodo": 202607,
        "valor": 19707736.0,
        "delta": -949984.83
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": -382340.0,
    "valor_anterior": 1061348.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -12035606.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -6029248.0,
        "delta": 6006358.0
      },
      {
        "periodo": 202509,
        "valor": -9070218.0,
        "delta": -3040970.0
      },
      {
        "periodo": 202510,
        "valor": -6869421.0,
        "delta": 2200797.0
      },
      {
        "periodo": 202511,
        "valor": -9013561.0,
        "delta": -2144140.0
      },
      {
        "periodo": 202512,
        "valor": 1378974.0,
        "delta": 10392535.0
      },
      {
        "periodo": 202601,
        "valor": 1047232.0,
        "delta": -331742.0
      },
      {
        "periodo": 202602,
        "valor": 970002.0,
        "delta": -77230.0
      },
      {
        "periodo": 202603,
        "valor": 533238.0,
        "delta": -436764.0
      },
      {
        "periodo": 202604,
        "valor": -837808.0,
        "delta": -1371046.0
      },
      {
        "periodo": 202605,
        "valor": -1438029.0,
        "delta": -600221.0
      },
      {
        "periodo": 202606,
        "valor": 1061348.0,
        "delta": 2499377.0
      },
      {
        "periodo": 202607,
        "valor": -382340.0,
        "delta": -1443688.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 135097513.82000005,
    "valor_anterior": 80272528.61000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 132965521.35,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 129484744.33,
        "delta": -3480777.02
      },
      {
        "periodo": 202509,
        "valor": 22302290.84,
        "delta": -107182453.49
      },
      {
        "periodo": 202510,
        "valor": 188209202.67,
        "delta": 165906911.83
      },
      {
        "periodo": 202511,
        "valor": 126026692.73,
        "delta": -62182509.94
      },
      {
        "periodo": 202512,
        "valor": 139120917.19,
        "delta": 13094224.46
      },
      {
        "periodo": 202601,
        "valor": 130707497.54,
        "delta": -8413419.65
      },
      {
        "periodo": 202602,
        "valor": 93403981.87,
        "delta": -37303515.67
      },
      {
        "periodo": 202603,
        "valor": 29235414.99,
        "delta": -64168566.88
      },
      {
        "periodo": 202604,
        "valor": 136617405.67,
        "delta": 107381990.68
      },
      {
        "periodo": 202605,
        "valor": 149075384.94,
        "delta": 12457979.27
      },
      {
        "periodo": 202606,
        "valor": 80272528.61,
        "delta": -68802856.33
      },
      {
        "periodo": 202607,
        "valor": 135097513.82,
        "delta": 54824985.21
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 19895271.529999994,
    "valor_anterior": 14589941.61,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7232600.09,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1467718.59,
        "delta": -5764881.5
      },
      {
        "periodo": 202509,
        "valor": -3648810.66,
        "delta": -5116529.25
      },
      {
        "periodo": 202510,
        "valor": 2582575.04,
        "delta": 6231385.7
      },
      {
        "periodo": 202511,
        "valor": 2898256.79,
        "delta": 315681.75
      },
      {
        "periodo": 202512,
        "valor": -3051027.72,
        "delta": -5949284.51
      },
      {
        "periodo": 202601,
        "valor": 9032740.3,
        "delta": 12083768.02
      },
      {
        "periodo": 202602,
        "valor": 9548711.96,
        "delta": 515971.66
      },
      {
        "periodo": 202603,
        "valor": 9000715.75,
        "delta": -547996.21
      },
      {
        "periodo": 202604,
        "valor": 8792813.02,
        "delta": -207902.73
      },
      {
        "periodo": 202605,
        "valor": 12866467.24,
        "delta": 4073654.22
      },
      {
        "periodo": 202606,
        "valor": 14589941.61,
        "delta": 1723474.37
      },
      {
        "periodo": 202607,
        "valor": 19895271.53,
        "delta": 5305329.92
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": -8888021.0,
    "valor_anterior": 19273930.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 24105838.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25831750.0,
        "delta": 1725912.0
      },
      {
        "periodo": 202509,
        "valor": 36439123.0,
        "delta": 10607373.0
      },
      {
        "periodo": 202510,
        "valor": 32722536.0,
        "delta": -3716587.0
      },
      {
        "periodo": 202511,
        "valor": 24963254.0,
        "delta": -7759282.0
      },
      {
        "periodo": 202512,
        "valor": 12532318.0,
        "delta": -12430936.0
      },
      {
        "periodo": 202601,
        "valor": 28046714.0,
        "delta": 15514396.0
      },
      {
        "periodo": 202602,
        "valor": 32880687.0,
        "delta": 4833973.0
      },
      {
        "periodo": 202603,
        "valor": -4182359.0,
        "delta": -37063046.0
      },
      {
        "periodo": 202604,
        "valor": -15053834.0,
        "delta": -10871475.0
      },
      {
        "periodo": 202605,
        "valor": 34376028.0,
        "delta": 49429862.0
      },
      {
        "periodo": 202606,
        "valor": 19273930.0,
        "delta": -15102098.0
      },
      {
        "periodo": 202607,
        "valor": -8888021.0,
        "delta": -28161951.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 169852976.0,
    "valor_anterior": 204939798.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 67480161.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 201157135.0,
        "delta": 133676974.0
      },
      {
        "periodo": 202509,
        "valor": 122662708.0,
        "delta": -78494427.0
      },
      {
        "periodo": 202510,
        "valor": 148317760.0,
        "delta": 25655052.0
      },
      {
        "periodo": 202511,
        "valor": 135999509.0,
        "delta": -12318251.0
      },
      {
        "periodo": 202512,
        "valor": 64512924.0,
        "delta": -71486585.0
      },
      {
        "periodo": 202601,
        "valor": 116668902.0,
        "delta": 52155978.0
      },
      {
        "periodo": 202602,
        "valor": 91547780.0,
        "delta": -25121122.0
      },
      {
        "periodo": 202603,
        "valor": 144970562.0,
        "delta": 53422782.0
      },
      {
        "periodo": 202604,
        "valor": 146476768.0,
        "delta": 1506206.0
      },
      {
        "periodo": 202605,
        "valor": 179308730.0,
        "delta": 32831962.0
      },
      {
        "periodo": 202606,
        "valor": 204939798.0,
        "delta": 25631068.0
      },
      {
        "periodo": 202607,
        "valor": 169852976.0,
        "delta": -35086822.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 19148620.0,
    "valor_anterior": 4311836.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2433354.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16535136.0,
        "delta": 14101782.0
      },
      {
        "periodo": 202509,
        "valor": 8222172.0,
        "delta": -8312964.0
      },
      {
        "periodo": 202510,
        "valor": 11564275.0,
        "delta": 3342103.0
      },
      {
        "periodo": 202511,
        "valor": 11176276.0,
        "delta": -387999.0
      },
      {
        "periodo": 202512,
        "valor": 3359803.0,
        "delta": -7816473.0
      },
      {
        "periodo": 202601,
        "valor": 8255819.0,
        "delta": 4896016.0
      },
      {
        "periodo": 202602,
        "valor": 8107789.0,
        "delta": -148030.0
      },
      {
        "periodo": 202603,
        "valor": 15188214.0,
        "delta": 7080425.0
      },
      {
        "periodo": 202604,
        "valor": 8758719.0,
        "delta": -6429495.0
      },
      {
        "periodo": 202605,
        "valor": 10588893.0,
        "delta": 1830174.0
      },
      {
        "periodo": 202606,
        "valor": 4311836.0,
        "delta": -6277057.0
      },
      {
        "periodo": 202607,
        "valor": 19148620.0,
        "delta": 14836784.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 23497668.75999999,
    "valor_anterior": 23518425.550000012,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 36057940.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 35884350.65,
        "delta": -173590.07
      },
      {
        "periodo": 202509,
        "valor": 81327576.2,
        "delta": 45443225.55
      },
      {
        "periodo": 202510,
        "valor": 35188645.32,
        "delta": -46138930.88
      },
      {
        "periodo": 202511,
        "valor": 47876318.43,
        "delta": 12687673.11
      },
      {
        "periodo": 202512,
        "valor": 16027224.87,
        "delta": -31849093.56
      },
      {
        "periodo": 202601,
        "valor": 36358099.04,
        "delta": 20330874.17
      },
      {
        "periodo": 202602,
        "valor": 21819208.45,
        "delta": -14538890.59
      },
      {
        "periodo": 202603,
        "valor": 23300887.71,
        "delta": 1481679.26
      },
      {
        "periodo": 202604,
        "valor": 18382501.89,
        "delta": -4918385.82
      },
      {
        "periodo": 202605,
        "valor": 22300693.97,
        "delta": 3918192.08
      },
      {
        "periodo": 202606,
        "valor": 23518425.55,
        "delta": 1217731.58
      },
      {
        "periodo": 202607,
        "valor": 23497668.76,
        "delta": -20756.79
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 6889676.539999999,
    "valor_anterior": 6504298.039999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19936354.75,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28322598.61,
        "delta": 8386243.86
      },
      {
        "periodo": 202509,
        "valor": 7320453.96,
        "delta": -21002144.65
      },
      {
        "periodo": 202510,
        "valor": 10283121.22,
        "delta": 2962667.26
      },
      {
        "periodo": 202511,
        "valor": -2035108.22,
        "delta": -12318229.44
      },
      {
        "periodo": 202512,
        "valor": 8793353.25,
        "delta": 10828461.47
      },
      {
        "periodo": 202601,
        "valor": 6879981.62,
        "delta": -1913371.63
      },
      {
        "periodo": 202602,
        "valor": -6986306.12,
        "delta": -13866287.74
      },
      {
        "periodo": 202603,
        "valor": 17847791.31,
        "delta": 24834097.43
      },
      {
        "periodo": 202604,
        "valor": 7349781.58,
        "delta": -10498009.73
      },
      {
        "periodo": 202605,
        "valor": 3615885.04,
        "delta": -3733896.54
      },
      {
        "periodo": 202606,
        "valor": 6504298.04,
        "delta": 2888413.0
      },
      {
        "periodo": 202607,
        "valor": 6889676.54,
        "delta": 385378.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 36245994.0,
    "valor_anterior": 42871634.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40669951.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 38416632.0,
        "delta": -2253319.0
      },
      {
        "periodo": 202509,
        "valor": 37577865.0,
        "delta": -838767.0
      },
      {
        "periodo": 202510,
        "valor": 36202108.0,
        "delta": -1375757.0
      },
      {
        "periodo": 202511,
        "valor": 39834964.0,
        "delta": 3632856.0
      },
      {
        "periodo": 202512,
        "valor": 21369767.0,
        "delta": -18465197.0
      },
      {
        "periodo": 202601,
        "valor": 35038319.0,
        "delta": 13668552.0
      },
      {
        "periodo": 202602,
        "valor": 32682237.0,
        "delta": -2356082.0
      },
      {
        "periodo": 202603,
        "valor": 35463571.0,
        "delta": 2781334.0
      },
      {
        "periodo": 202604,
        "valor": 34843758.0,
        "delta": -619813.0
      },
      {
        "periodo": 202605,
        "valor": 32065274.0,
        "delta": -2778484.0
      },
      {
        "periodo": 202606,
        "valor": 42871634.0,
        "delta": 10806360.0
      },
      {
        "periodo": 202607,
        "valor": 36245994.0,
        "delta": -6625640.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 2469330.0,
    "valor_anterior": 4308163.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2901095.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4107502.0,
        "delta": 1206407.0
      },
      {
        "periodo": 202509,
        "valor": 4214856.0,
        "delta": 107354.0
      },
      {
        "periodo": 202510,
        "valor": 5714361.0,
        "delta": 1499505.0
      },
      {
        "periodo": 202511,
        "valor": -332213.0,
        "delta": -6046574.0
      },
      {
        "periodo": 202512,
        "valor": 2006687.0,
        "delta": 2338900.0
      },
      {
        "periodo": 202601,
        "valor": 1923823.0,
        "delta": -82864.0
      },
      {
        "periodo": 202602,
        "valor": 3061869.0,
        "delta": 1138046.0
      },
      {
        "periodo": 202603,
        "valor": 6608093.0,
        "delta": 3546224.0
      },
      {
        "periodo": 202604,
        "valor": 1275396.0,
        "delta": -5332697.0
      },
      {
        "periodo": 202605,
        "valor": 6047929.0,
        "delta": 4772533.0
      },
      {
        "periodo": 202606,
        "valor": 4308163.0,
        "delta": -1739766.0
      },
      {
        "periodo": 202607,
        "valor": 2469330.0,
        "delta": -1838833.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": -40638522.0,
    "valor_anterior": 102273721.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12177579.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12501059.0,
        "delta": 323480.0
      },
      {
        "periodo": 202509,
        "valor": 58590031.0,
        "delta": 46088972.0
      },
      {
        "periodo": 202510,
        "valor": 8560155.0,
        "delta": -50029876.0
      },
      {
        "periodo": 202511,
        "valor": 3918694.0,
        "delta": -4641461.0
      },
      {
        "periodo": 202512,
        "valor": 56651673.0,
        "delta": 52732979.0
      },
      {
        "periodo": 202601,
        "valor": 12659503.0,
        "delta": -43992170.0
      },
      {
        "periodo": 202602,
        "valor": 9243645.0,
        "delta": -3415858.0
      },
      {
        "periodo": 202603,
        "valor": 38386915.0,
        "delta": 29143270.0
      },
      {
        "periodo": 202604,
        "valor": -32102796.0,
        "delta": -70489711.0
      },
      {
        "periodo": 202605,
        "valor": 24955747.0,
        "delta": 57058543.0
      },
      {
        "periodo": 202606,
        "valor": 102273721.0,
        "delta": 77317974.0
      },
      {
        "periodo": 202607,
        "valor": -40638522.0,
        "delta": -142912243.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": -64626373.67000002,
    "valor_anterior": -61519890.589999974,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -74707247.28,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -75386771.42,
        "delta": -679524.14
      },
      {
        "periodo": 202509,
        "valor": -61244019.65,
        "delta": 14142751.77
      },
      {
        "periodo": 202510,
        "valor": -60161697.47,
        "delta": 1082322.18
      },
      {
        "periodo": 202511,
        "valor": -63676384.04,
        "delta": -3514686.57
      },
      {
        "periodo": 202512,
        "valor": -46836769.6,
        "delta": 16839614.44
      },
      {
        "periodo": 202601,
        "valor": -77360361.65,
        "delta": -30523592.05
      },
      {
        "periodo": 202602,
        "valor": -65665130.0,
        "delta": 11695231.65
      },
      {
        "periodo": 202603,
        "valor": -63462056.3,
        "delta": 2203073.7
      },
      {
        "periodo": 202604,
        "valor": -64489533.22,
        "delta": -1027476.92
      },
      {
        "periodo": 202605,
        "valor": -65620659.33,
        "delta": -1131126.11
      },
      {
        "periodo": 202606,
        "valor": -61519890.59,
        "delta": 4100768.74
      },
      {
        "periodo": 202607,
        "valor": -64626373.67,
        "delta": -3106483.08
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 21314216.27000001,
    "valor_anterior": 50594388.74000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2180054.96,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4383862.74,
        "delta": 2203807.78
      },
      {
        "periodo": 202509,
        "valor": 2918888.12,
        "delta": -1464974.62
      },
      {
        "periodo": 202510,
        "valor": 191897.42,
        "delta": -2726990.7
      },
      {
        "periodo": 202511,
        "valor": 515773.0,
        "delta": 323875.58
      },
      {
        "periodo": 202512,
        "valor": 2588556.41,
        "delta": 2072783.41
      },
      {
        "periodo": 202601,
        "valor": 4332697.16,
        "delta": 1744140.75
      },
      {
        "periodo": 202602,
        "valor": 57657084.93,
        "delta": 53324387.77
      },
      {
        "periodo": 202603,
        "valor": 46567633.62,
        "delta": -11089451.31
      },
      {
        "periodo": 202604,
        "valor": 11422544.94,
        "delta": -35145088.68
      },
      {
        "periodo": 202605,
        "valor": 26692874.11,
        "delta": 15270329.17
      },
      {
        "periodo": 202606,
        "valor": 50594388.74,
        "delta": 23901514.63
      },
      {
        "periodo": 202607,
        "valor": 21314216.27,
        "delta": -29280172.47
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": -293076027.0,
    "valor_anterior": -294307827.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -144448776.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -181024178.0,
        "delta": -36575402.0
      },
      {
        "periodo": 202509,
        "valor": -202366956.0,
        "delta": -21342778.0
      },
      {
        "periodo": 202510,
        "valor": -253491145.0,
        "delta": -51124189.0
      },
      {
        "periodo": 202511,
        "valor": -249454214.0,
        "delta": 4036931.0
      },
      {
        "periodo": 202512,
        "valor": -288054991.0,
        "delta": -38600777.0
      },
      {
        "periodo": 202601,
        "valor": -273821982.0,
        "delta": 14233009.0
      },
      {
        "periodo": 202602,
        "valor": -267460060.0,
        "delta": 6361922.0
      },
      {
        "periodo": 202603,
        "valor": -274551457.0,
        "delta": -7091397.0
      },
      {
        "periodo": 202604,
        "valor": -280203990.0,
        "delta": -5652533.0
      },
      {
        "periodo": 202605,
        "valor": -306366735.0,
        "delta": -26162745.0
      },
      {
        "periodo": 202606,
        "valor": -294307827.0,
        "delta": 12058908.0
      },
      {
        "periodo": 202607,
        "valor": -293076027.0,
        "delta": 1231800.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": -85113920.13,
    "valor_anterior": -80654242.29000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": -271040998.9,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": -29046783.95,
        "delta": 241994214.95
      },
      {
        "periodo": 202601,
        "valor": -29983714.4,
        "delta": -936930.45
      },
      {
        "periodo": 202602,
        "valor": -48053013.59,
        "delta": -18069299.19
      },
      {
        "periodo": 202603,
        "valor": -74949599.49,
        "delta": -26896585.9
      },
      {
        "periodo": 202604,
        "valor": -64993164.94,
        "delta": 9956434.55
      },
      {
        "periodo": 202605,
        "valor": -73870315.6,
        "delta": -8877150.66
      },
      {
        "periodo": 202606,
        "valor": -80654242.29,
        "delta": -6783926.69
      },
      {
        "periodo": 202607,
        "valor": -85113920.13,
        "delta": -4459677.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": -398899574.0,
    "valor_anterior": -493031456.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": -752834492.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": -418035777.0,
        "delta": 334798715.0
      },
      {
        "periodo": 202605,
        "valor": -504518618.0,
        "delta": -86482841.0
      },
      {
        "periodo": 202606,
        "valor": -493031456.0,
        "delta": 11487162.0
      },
      {
        "periodo": 202607,
        "valor": -398899574.0,
        "delta": 94131882.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 35131563755.149994,
    "valor_anterior": 32907331053.360016,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 32912202760.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 33739164545.24,
        "delta": 826961784.55
      },
      {
        "periodo": 202509,
        "valor": 34492538091.5,
        "delta": 753373546.26
      },
      {
        "periodo": 202510,
        "valor": 34274832315.08,
        "delta": -217705776.4201
      },
      {
        "periodo": 202511,
        "valor": 34931792415.98,
        "delta": 656960100.9
      },
      {
        "periodo": 202512,
        "valor": 37920973597.36,
        "delta": 2989181181.3801
      },
      {
        "periodo": 202601,
        "valor": 38704445060.14,
        "delta": 783471462.78
      },
      {
        "periodo": 202602,
        "valor": 28724584911.75,
        "delta": -9979860148.39
      },
      {
        "periodo": 202603,
        "valor": 43598978882.15,
        "delta": 14874393970.4
      },
      {
        "periodo": 202604,
        "valor": 33226722045.65,
        "delta": -10372256836.5
      },
      {
        "periodo": 202605,
        "valor": 29653481325.02,
        "delta": -3573240720.63
      },
      {
        "periodo": 202606,
        "valor": 32907331053.36,
        "delta": 3253849728.34
      },
      {
        "periodo": 202607,
        "valor": 35131563755.15,
        "delta": 2224232701.79
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 29670935858.600006,
    "valor_anterior": 27472359061.799988,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27635256343.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26932536089.23,
        "delta": -702720253.92
      },
      {
        "periodo": 202509,
        "valor": 24197335933.75,
        "delta": -2735200155.48
      },
      {
        "periodo": 202510,
        "valor": 25238532607.96,
        "delta": 1041196674.21
      },
      {
        "periodo": 202511,
        "valor": 28809757102.84,
        "delta": 3571224494.8799
      },
      {
        "periodo": 202512,
        "valor": 29354385453.65,
        "delta": 544628350.8101
      },
      {
        "periodo": 202601,
        "valor": 30878787344.53,
        "delta": 1524401890.88
      },
      {
        "periodo": 202602,
        "valor": 21895968434.3,
        "delta": -8982818910.23
      },
      {
        "periodo": 202603,
        "valor": 37032295759.67,
        "delta": 15136327325.37
      },
      {
        "periodo": 202604,
        "valor": 26897955022.79,
        "delta": -10134340736.88
      },
      {
        "periodo": 202605,
        "valor": 24461124973.72,
        "delta": -2436830049.07
      },
      {
        "periodo": 202606,
        "valor": 27472359061.8,
        "delta": 3011234088.08
      },
      {
        "periodo": 202607,
        "valor": 29670935858.6,
        "delta": 2198576796.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 632062001.02,
    "valor_anterior": 410870676.6700001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1091621313.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -535854462.47,
        "delta": 555766850.95
      },
      {
        "periodo": 202509,
        "valor": 2325414573.19,
        "delta": 2861269035.66
      },
      {
        "periodo": 202510,
        "valor": 786939639.2,
        "delta": -1538474933.99
      },
      {
        "periodo": 202511,
        "valor": 518047536.46,
        "delta": -268892102.74
      },
      {
        "periodo": 202512,
        "valor": 745765582.25,
        "delta": 227718045.79
      },
      {
        "periodo": 202601,
        "valor": 769202676.89,
        "delta": 23437094.64
      },
      {
        "periodo": 202602,
        "valor": 640365222.97,
        "delta": -128837453.92
      },
      {
        "periodo": 202603,
        "valor": 306444249.02,
        "delta": -333920973.95
      },
      {
        "periodo": 202604,
        "valor": 436240252.55,
        "delta": 129796003.53
      },
      {
        "periodo": 202605,
        "valor": 670957695.71,
        "delta": 234717443.16
      },
      {
        "periodo": 202606,
        "valor": 410870676.67,
        "delta": -260087019.04
      },
      {
        "periodo": 202607,
        "valor": 632062001.02,
        "delta": 221191324.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 1908400400.5,
    "valor_anterior": 2214196326.039999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2386140100.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2762276867.54,
        "delta": 376136767.15
      },
      {
        "periodo": 202509,
        "valor": 3217569947.73,
        "delta": 455293080.19
      },
      {
        "periodo": 202510,
        "valor": 2815823371.36,
        "delta": -401746576.37
      },
      {
        "periodo": 202511,
        "valor": 1357978560.73,
        "delta": -1457844810.63
      },
      {
        "periodo": 202512,
        "valor": 2890024267.71,
        "delta": 1532045706.98
      },
      {
        "periodo": 202601,
        "valor": 2691458973.17,
        "delta": -198565294.54
      },
      {
        "periodo": 202602,
        "valor": 2042721059.98,
        "delta": -648737913.19
      },
      {
        "periodo": 202603,
        "valor": 2437134019.65,
        "delta": 394412959.67
      },
      {
        "periodo": 202604,
        "valor": 2370964274.49,
        "delta": -66169745.16
      },
      {
        "periodo": 202605,
        "valor": 2008432675.13,
        "delta": -362531599.36
      },
      {
        "periodo": 202606,
        "valor": 2214196326.04,
        "delta": 205763650.91
      },
      {
        "periodo": 202607,
        "valor": 1908400400.5,
        "delta": -305795925.54
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 2622984998.220001,
    "valor_anterior": 2715465005.5199986,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2258673809.28,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2588806498.72,
        "delta": 330132689.44
      },
      {
        "periodo": 202509,
        "valor": 2449502686.95,
        "delta": -139303811.77
      },
      {
        "periodo": 202510,
        "valor": 2750019889.04,
        "delta": 300517202.09
      },
      {
        "periodo": 202511,
        "valor": 2712283295.55,
        "delta": -37736593.49
      },
      {
        "periodo": 202512,
        "valor": 2457610777.51,
        "delta": -254672518.04
      },
      {
        "periodo": 202601,
        "valor": 2464489294.86,
        "delta": 6878517.35
      },
      {
        "periodo": 202602,
        "valor": 1894479454.71,
        "delta": -570009840.15
      },
      {
        "periodo": 202603,
        "valor": 2598766521.74,
        "delta": 704287067.03
      },
      {
        "periodo": 202604,
        "valor": 2544329105.56,
        "delta": -54437416.18
      },
      {
        "periodo": 202605,
        "valor": 2625635448.82,
        "delta": 81306343.26
      },
      {
        "periodo": 202606,
        "valor": 2715465005.52,
        "delta": 89829556.7
      },
      {
        "periodo": 202607,
        "valor": 2622984998.22,
        "delta": -92480007.3
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": 462156376.6500001,
    "valor_anterior": 457074449.6400001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 322811294.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 497851648.95,
        "delta": 175040354.56
      },
      {
        "periodo": 202509,
        "valor": 646497407.35,
        "delta": 148645758.4
      },
      {
        "periodo": 202510,
        "valor": 476056849.25,
        "delta": -170440558.1
      },
      {
        "periodo": 202511,
        "valor": 142840313.55,
        "delta": -333216535.7
      },
      {
        "periodo": 202512,
        "valor": 466054990.0,
        "delta": 323214676.45
      },
      {
        "periodo": 202601,
        "valor": 428011343.17,
        "delta": -38043646.83
      },
      {
        "periodo": 202602,
        "valor": 373818303.3,
        "delta": -54193039.87
      },
      {
        "periodo": 202603,
        "valor": 385588580.02,
        "delta": 11770276.72
      },
      {
        "periodo": 202604,
        "valor": 272698593.54,
        "delta": -112889986.48
      },
      {
        "periodo": 202605,
        "valor": 493606406.27,
        "delta": 220907812.73
      },
      {
        "periodo": 202606,
        "valor": 457074449.64,
        "delta": -36531956.63
      },
      {
        "periodo": 202607,
        "valor": 462156376.65,
        "delta": 5081927.01
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100012,
    "label": "Resultado de la Operación",
    "valor_actual": -164975879.84000015,
    "valor_anterior": -362634466.30999994,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1400942526.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1493547903.27,
        "delta": 92605376.37
      },
      {
        "periodo": 202509,
        "valor": 1656217542.53,
        "delta": 162669639.26
      },
      {
        "periodo": 202510,
        "valor": 2207459958.27,
        "delta": 551242415.74
      },
      {
        "periodo": 202511,
        "valor": 1390885606.85,
        "delta": -816574351.42
      },
      {
        "periodo": 202512,
        "valor": 2007132526.24,
        "delta": 616246919.39
      },
      {
        "periodo": 202601,
        "valor": 1472495427.52,
        "delta": -534637098.72
      },
      {
        "periodo": 202602,
        "valor": 1877232436.49,
        "delta": 404737008.97
      },
      {
        "periodo": 202603,
        "valor": 838749752.05,
        "delta": -1038482684.44
      },
      {
        "periodo": 202604,
        "valor": 704534796.72,
        "delta": -134214955.33
      },
      {
        "periodo": 202605,
        "valor": -606275874.63,
        "delta": -1310810671.35
      },
      {
        "periodo": 202606,
        "valor": -362634466.31,
        "delta": 243641408.32
      },
      {
        "periodo": 202607,
        "valor": -164975879.84,
        "delta": 197658586.47
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 2299884161.9400005,
    "valor_anterior": 1942392795.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1856472420.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1111678735.1,
        "delta": -744793685.8
      },
      {
        "periodo": 202509,
        "valor": 493091161.27,
        "delta": -618587573.83
      },
      {
        "periodo": 202510,
        "valor": 771432282.36,
        "delta": 278341121.09
      },
      {
        "periodo": 202511,
        "valor": 4308304226.0,
        "delta": 3536871943.64
      },
      {
        "periodo": 202512,
        "valor": 858054332.0,
        "delta": -3450249894.0
      },
      {
        "periodo": 202601,
        "valor": 2258806691.72,
        "delta": 1400752359.72
      },
      {
        "periodo": 202602,
        "valor": 1518684693.8,
        "delta": -740121997.92
      },
      {
        "periodo": 202603,
        "valor": 3105582414.7,
        "delta": 1586897720.9
      },
      {
        "periodo": 202604,
        "valor": 956988252.95,
        "delta": -2148594161.75
      },
      {
        "periodo": 202605,
        "valor": 1411732946.66,
        "delta": 454744693.71
      },
      {
        "periodo": 202606,
        "valor": 1942392795.25,
        "delta": 530659848.59
      },
      {
        "periodo": 202607,
        "valor": 2299884161.94,
        "delta": 357491366.69
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 9275232626.699997,
    "valor_anterior": 7986567801.200005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8268611478.79,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8568888879.13,
        "delta": 300277400.34
      },
      {
        "periodo": 202509,
        "valor": 7931775543.51,
        "delta": -637113335.62
      },
      {
        "periodo": 202510,
        "valor": 8285691708.66,
        "delta": 353916165.15
      },
      {
        "periodo": 202511,
        "valor": 7968676556.99,
        "delta": -317015151.67
      },
      {
        "periodo": 202512,
        "valor": 8478875994.04,
        "delta": 510199437.05
      },
      {
        "periodo": 202601,
        "valor": 9190904957.51,
        "delta": 712028963.47
      },
      {
        "periodo": 202602,
        "valor": 4904298144.14,
        "delta": -4286606813.37
      },
      {
        "periodo": 202603,
        "valor": 9457568041.27,
        "delta": 4553269897.13
      },
      {
        "periodo": 202604,
        "valor": 8292494842.64,
        "delta": -1165073198.63
      },
      {
        "periodo": 202605,
        "valor": 8394923861.75,
        "delta": 102429019.11
      },
      {
        "periodo": 202606,
        "valor": 7986567801.2,
        "delta": -408356060.55
      },
      {
        "periodo": 202607,
        "valor": 9275232626.7,
        "delta": 1288664825.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 2932583868.0,
    "valor_anterior": 3722487949.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2876407711.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2897349748.0,
        "delta": 20942037.0
      },
      {
        "periodo": 202509,
        "valor": 2372700502.0,
        "delta": -524649246.0
      },
      {
        "periodo": 202510,
        "valor": 2976632381.0,
        "delta": 603931879.0
      },
      {
        "periodo": 202511,
        "valor": 2084463568.0,
        "delta": -892168813.0
      },
      {
        "periodo": 202512,
        "valor": 3462686664.0,
        "delta": 1378223096.0
      },
      {
        "periodo": 202601,
        "valor": 3368032681.0,
        "delta": -94653983.0
      },
      {
        "periodo": 202602,
        "valor": 2112039771.0,
        "delta": -1255992910.0
      },
      {
        "periodo": 202603,
        "valor": 4484080674.0,
        "delta": 2372040903.0
      },
      {
        "periodo": 202604,
        "valor": 3093646764.0,
        "delta": -1390433910.0
      },
      {
        "periodo": 202605,
        "valor": 1656168966.0,
        "delta": -1437477798.0
      },
      {
        "periodo": 202606,
        "valor": 3722487949.0,
        "delta": 2066318983.0
      },
      {
        "periodo": 202607,
        "valor": 2932583868.0,
        "delta": -789904081.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 520301647.0,
    "valor_anterior": -184967837.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 897917764.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 787717201.0,
        "delta": -110200563.0
      },
      {
        "periodo": 202509,
        "valor": 834130966.0,
        "delta": 46413765.0
      },
      {
        "periodo": 202510,
        "valor": 77568397.0,
        "delta": -756562569.0
      },
      {
        "periodo": 202511,
        "valor": 1088002417.0,
        "delta": 1010434020.0
      },
      {
        "periodo": 202512,
        "valor": -584174373.0,
        "delta": -1672176790.0
      },
      {
        "periodo": 202601,
        "valor": 1110442795.0,
        "delta": 1694617168.0
      },
      {
        "periodo": 202602,
        "valor": 911393849.0,
        "delta": -199048946.0
      },
      {
        "periodo": 202603,
        "valor": 1606840532.0,
        "delta": 695446683.0
      },
      {
        "periodo": 202604,
        "valor": 65984003.0,
        "delta": -1540856529.0
      },
      {
        "periodo": 202605,
        "valor": -75948436.0,
        "delta": -141932439.0
      },
      {
        "periodo": 202606,
        "valor": -184967837.0,
        "delta": -109019401.0
      },
      {
        "periodo": 202607,
        "valor": 520301647.0,
        "delta": 705269484.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 627843669.4200001,
    "valor_anterior": 672824949.4700003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 710343833.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 814802856.68,
        "delta": 104459023.39
      },
      {
        "periodo": 202509,
        "valor": 742236505.58,
        "delta": -72566351.1
      },
      {
        "periodo": 202510,
        "valor": 743368034.23,
        "delta": 1131528.65
      },
      {
        "periodo": 202511,
        "valor": 759527348.5,
        "delta": 16159314.27
      },
      {
        "periodo": 202512,
        "valor": 652395068.59,
        "delta": -107132279.91
      },
      {
        "periodo": 202601,
        "valor": 750265121.14,
        "delta": 97870052.55
      },
      {
        "periodo": 202602,
        "valor": 545701121.49,
        "delta": -204563999.65
      },
      {
        "periodo": 202603,
        "valor": 745581215.24,
        "delta": 199880093.75
      },
      {
        "periodo": 202604,
        "valor": 709701675.08,
        "delta": -35879540.16
      },
      {
        "periodo": 202605,
        "valor": 736207096.09,
        "delta": 26505421.01
      },
      {
        "periodo": 202606,
        "valor": 672824949.47,
        "delta": -63382146.62
      },
      {
        "periodo": 202607,
        "valor": 627843669.42,
        "delta": -44981280.05
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 1105117457.0,
    "valor_anterior": 1146791316.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2098424613.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1547748166.0,
        "delta": -550676447.0
      },
      {
        "periodo": 202509,
        "valor": 1729347573.0,
        "delta": 181599407.0
      },
      {
        "periodo": 202510,
        "valor": 1630063857.0,
        "delta": -99283716.0
      },
      {
        "periodo": 202511,
        "valor": 1867727544.0,
        "delta": 237663687.0
      },
      {
        "periodo": 202512,
        "valor": 2091734973.0,
        "delta": 224007429.0
      },
      {
        "periodo": 202601,
        "valor": 1746741782.0,
        "delta": -344993191.0
      },
      {
        "periodo": 202602,
        "valor": 1593220292.0,
        "delta": -153521490.0
      },
      {
        "periodo": 202603,
        "valor": 1630163871.0,
        "delta": 36943579.0
      },
      {
        "periodo": 202604,
        "valor": 1542902320.0,
        "delta": -87261551.0
      },
      {
        "periodo": 202605,
        "valor": 1246139197.0,
        "delta": -296763123.0
      },
      {
        "periodo": 202606,
        "valor": 1146791316.0,
        "delta": -99347881.0
      },
      {
        "periodo": 202607,
        "valor": 1105117457.0,
        "delta": -41673859.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 314237751.0,
    "valor_anterior": 309172813.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 291066735.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 297792111.0,
        "delta": 6725376.0
      },
      {
        "periodo": 202509,
        "valor": 301756537.0,
        "delta": 3964426.0
      },
      {
        "periodo": 202510,
        "valor": 323004149.0,
        "delta": 21247612.0
      },
      {
        "periodo": 202511,
        "valor": 336135106.0,
        "delta": 13130957.0
      },
      {
        "periodo": 202512,
        "valor": 285678801.0,
        "delta": -50456305.0
      },
      {
        "periodo": 202601,
        "valor": 286721995.0,
        "delta": 1043194.0
      },
      {
        "periodo": 202602,
        "valor": 282074456.0,
        "delta": -4647539.0
      },
      {
        "periodo": 202603,
        "valor": 294705857.0,
        "delta": 12631401.0
      },
      {
        "periodo": 202604,
        "valor": 293252837.0,
        "delta": -1453020.0
      },
      {
        "periodo": 202605,
        "valor": 299354850.0,
        "delta": 6102013.0
      },
      {
        "periodo": 202606,
        "valor": 309172813.0,
        "delta": 9817963.0
      },
      {
        "periodo": 202607,
        "valor": 314237751.0,
        "delta": 5064938.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 1113900441.000001,
    "valor_anterior": 978526698.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 832422165.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 869448496.0,
        "delta": 37026331.0
      },
      {
        "periodo": 202509,
        "valor": 828542917.0,
        "delta": -40905579.0
      },
      {
        "periodo": 202510,
        "valor": 771477333.0,
        "delta": -57065584.0
      },
      {
        "periodo": 202511,
        "valor": 703025201.0,
        "delta": -68452132.0
      },
      {
        "periodo": 202512,
        "valor": 1286575515.0,
        "delta": 583550314.0
      },
      {
        "periodo": 202601,
        "valor": 1298363914.0,
        "delta": 11788399.0
      },
      {
        "periodo": 202602,
        "valor": 905925489.0,
        "delta": -392438425.0
      },
      {
        "periodo": 202603,
        "valor": 2210650299.0,
        "delta": 1304724810.0
      },
      {
        "periodo": 202604,
        "valor": 605998944.0,
        "delta": -1604651355.0
      },
      {
        "periodo": 202605,
        "valor": 749663494.0,
        "delta": 143664550.0
      },
      {
        "periodo": 202606,
        "valor": 978526698.0,
        "delta": 228863204.0
      },
      {
        "periodo": 202607,
        "valor": 1113900441.0,
        "delta": 135373743.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 539191163.9900002,
    "valor_anterior": 474393081.8800001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 502734957.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 496936631.81,
        "delta": -5798326.06
      },
      {
        "periodo": 202509,
        "valor": 515010662.93,
        "delta": 18074031.12
      },
      {
        "periodo": 202510,
        "valor": 557338230.91,
        "delta": 42327567.98
      },
      {
        "periodo": 202511,
        "valor": 605973639.12,
        "delta": 48635408.21
      },
      {
        "periodo": 202512,
        "valor": 650300503.27,
        "delta": 44326864.15
      },
      {
        "periodo": 202601,
        "valor": 491592760.57,
        "delta": -158707742.7
      },
      {
        "periodo": 202602,
        "valor": 453424483.71,
        "delta": -38168276.86
      },
      {
        "periodo": 202603,
        "valor": 487800879.33,
        "delta": 34376395.62
      },
      {
        "periodo": 202604,
        "valor": 490020555.27,
        "delta": 2219675.94
      },
      {
        "periodo": 202605,
        "valor": 478681763.76,
        "delta": -11338791.51
      },
      {
        "periodo": 202606,
        "valor": 474393081.88,
        "delta": -4288681.88
      },
      {
        "periodo": 202607,
        "valor": 539191163.99,
        "delta": 64798082.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 240717223.0,
    "valor_anterior": 157667263.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 193746012.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 44028872.0,
        "delta": -149717140.0
      },
      {
        "periodo": 202509,
        "valor": 220986496.0,
        "delta": 176957624.0
      },
      {
        "periodo": 202510,
        "valor": 215345472.0,
        "delta": -5641024.0
      },
      {
        "periodo": 202511,
        "valor": -719386.0,
        "delta": -216064858.0
      },
      {
        "periodo": 202512,
        "valor": 91623204.0,
        "delta": 92342590.0
      },
      {
        "periodo": 202601,
        "valor": -31607024.0,
        "delta": -123230228.0
      },
      {
        "periodo": 202602,
        "valor": 25737654.0,
        "delta": 57344678.0
      },
      {
        "periodo": 202603,
        "valor": 116366033.0,
        "delta": 90628379.0
      },
      {
        "periodo": 202604,
        "valor": 199000110.0,
        "delta": 82634077.0
      },
      {
        "periodo": 202605,
        "valor": 159822200.0,
        "delta": -39177910.0
      },
      {
        "periodo": 202606,
        "valor": 157667263.0,
        "delta": -2154937.0
      },
      {
        "periodo": 202607,
        "valor": 240717223.0,
        "delta": 83049960.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 99743420.0,
    "valor_anterior": 104856675.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 103708849.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 138208506.0,
        "delta": 34499657.0
      },
      {
        "periodo": 202509,
        "valor": 135475559.0,
        "delta": -2732947.0
      },
      {
        "periodo": 202510,
        "valor": 94891287.0,
        "delta": -40584272.0
      },
      {
        "periodo": 202511,
        "valor": 113804152.0,
        "delta": 18912865.0
      },
      {
        "periodo": 202512,
        "valor": 133325921.0,
        "delta": 19521769.0
      },
      {
        "periodo": 202601,
        "valor": 97375607.0,
        "delta": -35950314.0
      },
      {
        "periodo": 202602,
        "valor": 103409581.0,
        "delta": 6033974.0
      },
      {
        "periodo": 202603,
        "valor": 114550040.0,
        "delta": 11140459.0
      },
      {
        "periodo": 202604,
        "valor": 103904757.0,
        "delta": -10645283.0
      },
      {
        "periodo": 202605,
        "valor": 91802513.0,
        "delta": -12102244.0
      },
      {
        "periodo": 202606,
        "valor": 104856675.0,
        "delta": 13054162.0
      },
      {
        "periodo": 202607,
        "valor": 99743420.0,
        "delta": -5113255.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 50808698.0,
    "valor_anterior": 111007917.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 81913564.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 110109326.0,
        "delta": 28195762.0
      },
      {
        "periodo": 202509,
        "valor": 93540561.0,
        "delta": -16568765.0
      },
      {
        "periodo": 202510,
        "valor": 94921371.0,
        "delta": 1380810.0
      },
      {
        "periodo": 202511,
        "valor": 80880241.0,
        "delta": -14041130.0
      },
      {
        "periodo": 202512,
        "valor": -406865729.0,
        "delta": -487745970.0
      },
      {
        "periodo": 202601,
        "valor": 107863749.0,
        "delta": 514729478.0
      },
      {
        "periodo": 202602,
        "valor": 55310930.0,
        "delta": -52552819.0
      },
      {
        "periodo": 202603,
        "valor": 131691693.0,
        "delta": 76380763.0
      },
      {
        "periodo": 202604,
        "valor": 125193282.0,
        "delta": -6498411.0
      },
      {
        "periodo": 202605,
        "valor": 77464335.0,
        "delta": -47728947.0
      },
      {
        "periodo": 202606,
        "valor": 111007917.0,
        "delta": 33543582.0
      },
      {
        "periodo": 202607,
        "valor": 50808698.0,
        "delta": -60199219.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 4256042623.6800003,
    "valor_anterior": 4405341428.07,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4199544707.38,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4034773530.7,
        "delta": -164771176.68
      },
      {
        "periodo": 202509,
        "valor": 3117514878.29,
        "delta": -917258652.41
      },
      {
        "periodo": 202510,
        "valor": 4012780420.19,
        "delta": 895265541.9
      },
      {
        "periodo": 202511,
        "valor": 4075313726.43,
        "delta": 62533306.24
      },
      {
        "periodo": 202512,
        "valor": 4785275730.97,
        "delta": 709962004.54
      },
      {
        "periodo": 202601,
        "valor": 3714169369.53,
        "delta": -1071106361.44
      },
      {
        "periodo": 202602,
        "valor": 3684264901.66,
        "delta": -29904467.87
      },
      {
        "periodo": 202603,
        "valor": 4767137283.88,
        "delta": 1082872382.22
      },
      {
        "periodo": 202604,
        "valor": 4348431604.86,
        "delta": -418705679.02
      },
      {
        "periodo": 202605,
        "valor": 3849755200.5,
        "delta": -498676404.36
      },
      {
        "periodo": 202606,
        "valor": 4405341428.07,
        "delta": 555586227.57
      },
      {
        "periodo": 202607,
        "valor": 4256042623.68,
        "delta": -149298804.39
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 178147526.0,
    "valor_anterior": 91033731.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 141894823.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 138751818.0,
        "delta": -3143005.0
      },
      {
        "periodo": 202509,
        "valor": 39952543.0,
        "delta": -98799275.0
      },
      {
        "periodo": 202510,
        "valor": 263829354.0,
        "delta": 223876811.0
      },
      {
        "periodo": 202511,
        "valor": -81733425.0,
        "delta": -345562779.0
      },
      {
        "periodo": 202512,
        "valor": 257973473.0,
        "delta": 339706898.0
      },
      {
        "periodo": 202601,
        "valor": 232283326.0,
        "delta": -25690147.0
      },
      {
        "periodo": 202602,
        "valor": 188622763.0,
        "delta": -43660563.0
      },
      {
        "periodo": 202603,
        "valor": 290243715.0,
        "delta": 101620952.0
      },
      {
        "periodo": 202604,
        "valor": 319677483.0,
        "delta": 29433768.0
      },
      {
        "periodo": 202605,
        "valor": -28937915.0,
        "delta": -348615398.0
      },
      {
        "periodo": 202606,
        "valor": 91033731.0,
        "delta": 119971646.0
      },
      {
        "periodo": 202607,
        "valor": 178147526.0,
        "delta": 87113795.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 69255844.0,
    "valor_anterior": 15005149.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 94406071.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 100996326.0,
        "delta": 6590255.0
      },
      {
        "periodo": 202509,
        "valor": 100311040.0,
        "delta": -685286.0
      },
      {
        "periodo": 202510,
        "valor": 62235197.0,
        "delta": -38075843.0
      },
      {
        "periodo": 202511,
        "valor": 91964082.0,
        "delta": 29728885.0
      },
      {
        "periodo": 202512,
        "valor": 84852134.0,
        "delta": -7111948.0
      },
      {
        "periodo": 202601,
        "valor": 60605018.0,
        "delta": -24247116.0
      },
      {
        "periodo": 202602,
        "valor": 21031908.0,
        "delta": -39573110.0
      },
      {
        "periodo": 202603,
        "valor": 32189306.0,
        "delta": 11157398.0
      },
      {
        "periodo": 202604,
        "valor": 81364698.0,
        "delta": 49175392.0
      },
      {
        "periodo": 202605,
        "valor": 61609478.0,
        "delta": -19755220.0
      },
      {
        "periodo": 202606,
        "valor": 15005149.0,
        "delta": -46604329.0
      },
      {
        "periodo": 202607,
        "valor": 69255844.0,
        "delta": 54250695.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 263857936.0,
    "valor_anterior": 244411820.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 313307077.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 666129380.0,
        "delta": 352822303.0
      },
      {
        "periodo": 202509,
        "valor": 608378548.0,
        "delta": -57750832.0
      },
      {
        "periodo": 202510,
        "valor": 408260947.0,
        "delta": -200117601.0
      },
      {
        "periodo": 202511,
        "valor": 279936085.0,
        "delta": -128324862.0
      },
      {
        "periodo": 202512,
        "valor": 251083627.0,
        "delta": -28852458.0
      },
      {
        "periodo": 202601,
        "valor": 221097441.0,
        "delta": -29986186.0
      },
      {
        "periodo": 202602,
        "valor": 391377390.0,
        "delta": 170279949.0
      },
      {
        "periodo": 202603,
        "valor": 359282558.0,
        "delta": -32094832.0
      },
      {
        "periodo": 202604,
        "valor": 237219574.0,
        "delta": -122062984.0
      },
      {
        "periodo": 202605,
        "valor": 287343184.0,
        "delta": 50123610.0
      },
      {
        "periodo": 202606,
        "valor": 244411820.0,
        "delta": -42931364.0
      },
      {
        "periodo": 202607,
        "valor": 263857936.0,
        "delta": 19446116.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 316455534.89000034,
    "valor_anterior": 361774257.79999995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 240595059.73,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 338890355.76,
        "delta": 98295296.03
      },
      {
        "periodo": 202509,
        "valor": 349707843.96,
        "delta": 10817488.2
      },
      {
        "periodo": 202510,
        "valor": 409814197.46,
        "delta": 60106353.5
      },
      {
        "periodo": 202511,
        "valor": 239737997.81,
        "delta": -170076199.65
      },
      {
        "periodo": 202512,
        "valor": 431134567.43,
        "delta": 191396569.62
      },
      {
        "periodo": 202601,
        "valor": 410233535.08,
        "delta": -20901032.35
      },
      {
        "periodo": 202602,
        "valor": 270330897.11,
        "delta": -139902637.97
      },
      {
        "periodo": 202603,
        "valor": 27962040.02,
        "delta": -242368857.09
      },
      {
        "periodo": 202604,
        "valor": 175996441.86,
        "delta": 148034401.84
      },
      {
        "periodo": 202605,
        "valor": 346016613.99,
        "delta": 170020172.13
      },
      {
        "periodo": 202606,
        "valor": 361774257.8,
        "delta": 15757643.81
      },
      {
        "periodo": 202607,
        "valor": 316455534.89,
        "delta": -45318722.91
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 78539893.0,
    "valor_anterior": 126725033.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 84977958.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 64599861.0,
        "delta": -20378097.0
      },
      {
        "periodo": 202509,
        "valor": 121746975.0,
        "delta": 57147114.0
      },
      {
        "periodo": 202510,
        "valor": 45281538.0,
        "delta": -76465437.0
      },
      {
        "periodo": 202511,
        "valor": 84951868.0,
        "delta": 39670330.0
      },
      {
        "periodo": 202512,
        "valor": 141972007.0,
        "delta": 57020139.0
      },
      {
        "periodo": 202601,
        "valor": 80204297.0,
        "delta": -61767710.0
      },
      {
        "periodo": 202602,
        "valor": 26074595.0,
        "delta": -54129702.0
      },
      {
        "periodo": 202603,
        "valor": 149364503.0,
        "delta": 123289908.0
      },
      {
        "periodo": 202604,
        "valor": 140732076.0,
        "delta": -8632427.0
      },
      {
        "periodo": 202605,
        "valor": 75333856.0,
        "delta": -65398220.0
      },
      {
        "periodo": 202606,
        "valor": 126725033.0,
        "delta": 51391177.0
      },
      {
        "periodo": 202607,
        "valor": 78539893.0,
        "delta": -48185140.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 361930050.0500002,
    "valor_anterior": 616493765.0199995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 686008781.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1131177871.54,
        "delta": 445169090.15
      },
      {
        "periodo": 202509,
        "valor": 691358022.73,
        "delta": -439819848.81
      },
      {
        "periodo": 202510,
        "valor": 818958279.36,
        "delta": 127600256.63
      },
      {
        "periodo": 202511,
        "valor": 395011235.73,
        "delta": -423947043.63
      },
      {
        "periodo": 202512,
        "valor": 1829661048.56,
        "delta": 1434649812.83
      },
      {
        "periodo": 202601,
        "valor": 1178524941.17,
        "delta": -651136107.39
      },
      {
        "periodo": 202602,
        "valor": 725405326.98,
        "delta": -453119614.19
      },
      {
        "periodo": 202603,
        "valor": 364773536.74,
        "delta": -360631790.24
      },
      {
        "periodo": 202604,
        "valor": 1112135778.31,
        "delta": 747362241.57
      },
      {
        "periodo": 202605,
        "valor": 813435413.26,
        "delta": -298700365.05
      },
      {
        "periodo": 202606,
        "valor": 616493765.02,
        "delta": -196941648.24
      },
      {
        "periodo": 202607,
        "valor": 361930050.05,
        "delta": -254563714.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": -1481859.0,
    "valor_anterior": 5268130.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -12618376.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -13391855.0,
        "delta": -773479.0
      },
      {
        "periodo": 202509,
        "valor": -10441984.0,
        "delta": 2949871.0
      },
      {
        "periodo": 202510,
        "valor": 9121593.0,
        "delta": 19563577.0
      },
      {
        "periodo": 202511,
        "valor": -21466065.0,
        "delta": -30587658.0
      },
      {
        "periodo": 202512,
        "valor": -30122374.0,
        "delta": -8656309.0
      },
      {
        "periodo": 202601,
        "valor": 5278601.0,
        "delta": 35400975.0
      },
      {
        "periodo": 202602,
        "valor": 502160.0,
        "delta": -4776441.0
      },
      {
        "periodo": 202603,
        "valor": -2784645.0,
        "delta": -3286805.0
      },
      {
        "periodo": 202604,
        "valor": 4952888.0,
        "delta": 7737533.0
      },
      {
        "periodo": 202605,
        "valor": 145395.0,
        "delta": -4807493.0
      },
      {
        "periodo": 202606,
        "valor": 5268130.0,
        "delta": 5122735.0
      },
      {
        "periodo": 202607,
        "valor": -1481859.0,
        "delta": -6749989.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": -337754290.88,
    "valor_anterior": -967694970.0600002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 332409124.28,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 478540566.46,
        "delta": 146131442.18
      },
      {
        "periodo": 202509,
        "valor": 400849560.52,
        "delta": -77691005.94
      },
      {
        "periodo": 202510,
        "valor": 980362481.48,
        "delta": 579512920.96
      },
      {
        "periodo": 202511,
        "valor": 605874895.03,
        "delta": -374487586.45
      },
      {
        "periodo": 202512,
        "valor": 1009665809.07,
        "delta": 403790914.04
      },
      {
        "periodo": 202601,
        "valor": 564954280.71,
        "delta": -444711528.36
      },
      {
        "periodo": 202602,
        "valor": 534323074.38,
        "delta": -30631206.33
      },
      {
        "periodo": 202603,
        "valor": 706799500.14,
        "delta": 172476425.76
      },
      {
        "periodo": 202604,
        "valor": 326549867.69,
        "delta": -380249632.45
      },
      {
        "periodo": 202605,
        "valor": -732546087.03,
        "delta": -1059095954.72
      },
      {
        "periodo": 202606,
        "valor": -967694970.06,
        "delta": -235148883.03
      },
      {
        "periodo": 202607,
        "valor": -337754290.88,
        "delta": 629940679.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 215854947.0,
    "valor_anterior": 90478329.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25130073.99,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55121844.95,
        "delta": 29991770.96
      },
      {
        "periodo": 202509,
        "valor": 297665115.03,
        "delta": 242543270.08
      },
      {
        "periodo": 202510,
        "valor": 97851802.0,
        "delta": -199813313.03
      },
      {
        "periodo": 202511,
        "valor": -18793948.0,
        "delta": -116645750.0
      },
      {
        "periodo": 202512,
        "valor": 167576813.0,
        "delta": 186370761.0
      },
      {
        "periodo": 202601,
        "valor": 157136337.0,
        "delta": -10440476.0
      },
      {
        "periodo": 202602,
        "valor": 128304008.0,
        "delta": -28832329.0
      },
      {
        "periodo": 202603,
        "valor": 247830112.0,
        "delta": 119526104.0
      },
      {
        "periodo": 202604,
        "valor": 120730052.0,
        "delta": -127100060.0
      },
      {
        "periodo": 202605,
        "valor": 113516388.0,
        "delta": -7213664.0
      },
      {
        "periodo": 202606,
        "valor": 90478329.0,
        "delta": -23038059.0
      },
      {
        "periodo": 202607,
        "valor": 215854947.0,
        "delta": 125376618.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": -6619837.0,
    "valor_anterior": 11729484.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 237494240.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -48438678.0,
        "delta": -285932918.0
      },
      {
        "periodo": 202509,
        "valor": 78081916.0,
        "delta": 126520594.0
      },
      {
        "periodo": 202510,
        "valor": 56242236.0,
        "delta": -21839680.0
      },
      {
        "periodo": 202511,
        "valor": 39822160.0,
        "delta": -16420076.0
      },
      {
        "periodo": 202512,
        "valor": -42922893.0,
        "delta": -82745053.0
      },
      {
        "periodo": 202601,
        "valor": 63154677.0,
        "delta": 106077570.0
      },
      {
        "periodo": 202602,
        "valor": 107229425.0,
        "delta": 44074748.0
      },
      {
        "periodo": 202603,
        "valor": 28042085.0,
        "delta": -79187340.0
      },
      {
        "periodo": 202604,
        "valor": 59861214.0,
        "delta": 31819129.0
      },
      {
        "periodo": 202605,
        "valor": 67831883.0,
        "delta": 7970669.0
      },
      {
        "periodo": 202606,
        "valor": 11729484.0,
        "delta": -56102399.0
      },
      {
        "periodo": 202607,
        "valor": -6619837.0,
        "delta": -18349321.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 457588293.0,
    "valor_anterior": 610656712.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 441982645.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 506101810.0,
        "delta": 64119165.0
      },
      {
        "periodo": 202509,
        "valor": 504845909.0,
        "delta": -1255901.0
      },
      {
        "periodo": 202510,
        "valor": 428759168.0,
        "delta": -76086741.0
      },
      {
        "periodo": 202511,
        "valor": 451077072.0,
        "delta": 22317904.0
      },
      {
        "periodo": 202512,
        "valor": 516393274.0,
        "delta": 65316202.0
      },
      {
        "periodo": 202601,
        "valor": 622276393.0,
        "delta": 105883119.0
      },
      {
        "periodo": 202602,
        "valor": 531864487.0,
        "delta": -90411906.0
      },
      {
        "periodo": 202603,
        "valor": 501323737.0,
        "delta": -30540750.0
      },
      {
        "periodo": 202604,
        "valor": 339592574.0,
        "delta": -161731163.0
      },
      {
        "periodo": 202605,
        "valor": 528999265.0,
        "delta": 189406691.0
      },
      {
        "periodo": 202606,
        "valor": 610656712.0,
        "delta": 81657447.0
      },
      {
        "periodo": 202607,
        "valor": 457588293.0,
        "delta": -153068419.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 182465855.0,
    "valor_anterior": 229919724.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 87938402.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 102514021.0,
        "delta": 14575619.0
      },
      {
        "periodo": 202509,
        "valor": 106504330.0,
        "delta": 3990309.0
      },
      {
        "periodo": 202510,
        "valor": 236906836.0,
        "delta": 130402506.0
      },
      {
        "periodo": 202511,
        "valor": 151765419.0,
        "delta": -85141417.0
      },
      {
        "periodo": 202512,
        "valor": 92849978.0,
        "delta": -58915441.0
      },
      {
        "periodo": 202601,
        "valor": 119497723.0,
        "delta": 26647745.0
      },
      {
        "periodo": 202602,
        "valor": 90986551.0,
        "delta": -28511172.0
      },
      {
        "periodo": 202603,
        "valor": 112483572.0,
        "delta": 21497021.0
      },
      {
        "periodo": 202604,
        "valor": 139707596.0,
        "delta": 27224024.0
      },
      {
        "periodo": 202605,
        "valor": 161453546.0,
        "delta": 21745950.0
      },
      {
        "periodo": 202606,
        "valor": 229919724.0,
        "delta": 68466178.0
      },
      {
        "periodo": 202607,
        "valor": 182465855.0,
        "delta": -47453869.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 24668729.0,
    "valor_anterior": -35843708.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40345980.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21451190.0,
        "delta": -18894790.0
      },
      {
        "periodo": 202509,
        "valor": 87408369.0,
        "delta": 65957179.0
      },
      {
        "periodo": 202510,
        "valor": 55481374.0,
        "delta": -31926995.0
      },
      {
        "periodo": 202511,
        "valor": -15686538.0,
        "delta": -71167912.0
      },
      {
        "periodo": 202512,
        "valor": 36155057.0,
        "delta": 51841595.0
      },
      {
        "periodo": 202601,
        "valor": -9565658.0,
        "delta": -45720715.0
      },
      {
        "periodo": 202602,
        "valor": 32398379.0,
        "delta": 41964037.0
      },
      {
        "periodo": 202603,
        "valor": 21095808.0,
        "delta": -11302571.0
      },
      {
        "periodo": 202604,
        "valor": 29184634.0,
        "delta": 8088826.0
      },
      {
        "periodo": 202605,
        "valor": 77305936.0,
        "delta": 48121302.0
      },
      {
        "periodo": 202606,
        "valor": -35843708.0,
        "delta": -113149644.0
      },
      {
        "periodo": 202607,
        "valor": 24668729.0,
        "delta": 60512437.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": -160889672.0,
    "valor_anterior": -466704065.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -243515754.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -161573979.0,
        "delta": 81941775.0
      },
      {
        "periodo": 202509,
        "valor": -201144304.0,
        "delta": -39570325.0
      },
      {
        "periodo": 202510,
        "valor": -93987246.0,
        "delta": 107157058.0
      },
      {
        "periodo": 202511,
        "valor": 75641421.0,
        "delta": 169628667.0
      },
      {
        "periodo": 202512,
        "valor": -138541784.0,
        "delta": -214183205.0
      },
      {
        "periodo": 202601,
        "valor": 38221811.0,
        "delta": 176763595.0
      },
      {
        "periodo": 202602,
        "valor": 65623328.0,
        "delta": 27401517.0
      },
      {
        "periodo": 202603,
        "valor": 11176069.0,
        "delta": -54447259.0
      },
      {
        "periodo": 202604,
        "valor": -9183422.0,
        "delta": -20359491.0
      },
      {
        "periodo": 202605,
        "valor": -24202479.0,
        "delta": -15019057.0
      },
      {
        "periodo": 202606,
        "valor": -466704065.0,
        "delta": -442501586.0
      },
      {
        "periodo": 202607,
        "valor": -160889672.0,
        "delta": 305814393.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 218963516.90999985,
    "valor_anterior": 507333431.2600001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 197518641.03,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 75159102.89,
        "delta": -122359538.14
      },
      {
        "periodo": 202509,
        "valor": 263667648.5,
        "delta": 188508545.61
      },
      {
        "periodo": 202510,
        "valor": 256238507.76,
        "delta": -7429140.74
      },
      {
        "periodo": 202511,
        "valor": 206363912.03,
        "delta": -49874595.73
      },
      {
        "periodo": 202512,
        "valor": 40405087.63,
        "delta": -165958824.4
      },
      {
        "periodo": 202601,
        "valor": -29597065.79,
        "delta": -70002153.42
      },
      {
        "periodo": 202602,
        "valor": 273734084.44,
        "delta": 303331150.23
      },
      {
        "periodo": 202603,
        "valor": -17784195.83,
        "delta": -291518280.27
      },
      {
        "periodo": 202604,
        "valor": 209441497.38,
        "delta": 227225693.21
      },
      {
        "periodo": 202605,
        "valor": 283984769.43,
        "delta": 74543272.05
      },
      {
        "periodo": 202606,
        "valor": 507333431.26,
        "delta": 223348661.83
      },
      {
        "periodo": 202607,
        "valor": 218963516.91,
        "delta": -288369914.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": -78677676.0,
    "valor_anterior": -81482503.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -134372887.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -102760459.0,
        "delta": 31612428.0
      },
      {
        "periodo": 202509,
        "valor": -92307465.0,
        "delta": 10452994.0
      },
      {
        "periodo": 202510,
        "valor": -109067285.0,
        "delta": -16759820.0
      },
      {
        "periodo": 202511,
        "valor": -130696086.0,
        "delta": -21628801.0
      },
      {
        "periodo": 202512,
        "valor": -104570425.0,
        "delta": 26125661.0
      },
      {
        "periodo": 202601,
        "valor": -86307873.0,
        "delta": 18262552.0
      },
      {
        "periodo": 202602,
        "valor": -108080555.0,
        "delta": -21772682.0
      },
      {
        "periodo": 202603,
        "valor": -128914817.0,
        "delta": -20834262.0
      },
      {
        "periodo": 202604,
        "valor": -90395760.0,
        "delta": 38519057.0
      },
      {
        "periodo": 202605,
        "valor": -67808660.0,
        "delta": 22587100.0
      },
      {
        "periodo": 202606,
        "valor": -81482503.0,
        "delta": -13673843.0
      },
      {
        "periodo": 202607,
        "valor": -78677676.0,
        "delta": 2804827.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 4212094.0,
    "valor_anterior": 6036089.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4095729.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10004958.0,
        "delta": 5909229.0
      },
      {
        "periodo": 202509,
        "valor": 14364736.0,
        "delta": 4359778.0
      },
      {
        "periodo": 202510,
        "valor": 9117834.0,
        "delta": -5246902.0
      },
      {
        "periodo": 202511,
        "valor": 1322515.0,
        "delta": -7795319.0
      },
      {
        "periodo": 202512,
        "valor": -2880505.0,
        "delta": -4203020.0
      },
      {
        "periodo": 202601,
        "valor": 2751697.0,
        "delta": 5632202.0
      },
      {
        "periodo": 202602,
        "valor": 4020751.0,
        "delta": 1269054.0
      },
      {
        "periodo": 202603,
        "valor": 7862809.0,
        "delta": 3842058.0
      },
      {
        "periodo": 202604,
        "valor": 6327076.0,
        "delta": -1535733.0
      },
      {
        "periodo": 202605,
        "valor": 8852345.0,
        "delta": 2525269.0
      },
      {
        "periodo": 202606,
        "valor": 6036089.0,
        "delta": -2816256.0
      },
      {
        "periodo": 202607,
        "valor": 4212094.0,
        "delta": -1823995.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 43218987.0,
    "valor_anterior": 127410408.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 106979164.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 122535417.0,
        "delta": 15556253.0
      },
      {
        "periodo": 202509,
        "valor": 124366682.0,
        "delta": 1831265.0
      },
      {
        "periodo": 202510,
        "valor": 101341126.0,
        "delta": -23025556.0
      },
      {
        "periodo": 202511,
        "valor": 140114117.0,
        "delta": 38772991.0
      },
      {
        "periodo": 202512,
        "valor": 81511294.0,
        "delta": -58602823.0
      },
      {
        "periodo": 202601,
        "valor": 106383772.0,
        "delta": 24872478.0
      },
      {
        "periodo": 202602,
        "valor": 144113271.0,
        "delta": 37729499.0
      },
      {
        "periodo": 202603,
        "valor": 142161079.0,
        "delta": -1952192.0
      },
      {
        "periodo": 202604,
        "valor": 137600467.0,
        "delta": -4560612.0
      },
      {
        "periodo": 202605,
        "valor": 111319246.0,
        "delta": -26281221.0
      },
      {
        "periodo": 202606,
        "valor": 127410408.0,
        "delta": 16091162.0
      },
      {
        "periodo": 202607,
        "valor": 43218987.0,
        "delta": -84191421.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 44753558.0,
    "valor_anterior": 66265087.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 63070640.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21310337.0,
        "delta": -41760303.0
      },
      {
        "periodo": 202509,
        "valor": 49928257.0,
        "delta": 28617920.0
      },
      {
        "periodo": 202510,
        "valor": -4829792.0,
        "delta": -54758049.0
      },
      {
        "periodo": 202511,
        "valor": 5505596.0,
        "delta": 10335388.0
      },
      {
        "periodo": 202512,
        "valor": 62820584.0,
        "delta": 57314988.0
      },
      {
        "periodo": 202601,
        "valor": 22268413.0,
        "delta": -40552171.0
      },
      {
        "periodo": 202602,
        "valor": 68718942.0,
        "delta": 46450529.0
      },
      {
        "periodo": 202603,
        "valor": 56173210.0,
        "delta": -12545732.0
      },
      {
        "periodo": 202604,
        "valor": -4947772.0,
        "delta": -61120982.0
      },
      {
        "periodo": 202605,
        "valor": 8379356.0,
        "delta": 13327128.0
      },
      {
        "periodo": 202606,
        "valor": 66265087.0,
        "delta": 57885731.0
      },
      {
        "periodo": 202607,
        "valor": 44753558.0,
        "delta": -21511529.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 80926615.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -876167041.0,
        "delta": -957093656.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 148643849.0,
    "valor_anterior": 137559769.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 107339029.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 155551865.0,
        "delta": 48212836.0
      },
      {
        "periodo": 202509,
        "valor": 119757325.0,
        "delta": -35794540.0
      },
      {
        "periodo": 202510,
        "valor": 194239196.0,
        "delta": 74481871.0
      },
      {
        "periodo": 202511,
        "valor": 77079884.0,
        "delta": -117159312.0
      },
      {
        "periodo": 202512,
        "valor": 290245430.0,
        "delta": 213165546.0
      },
      {
        "periodo": 202601,
        "valor": 98110759.0,
        "delta": -192134671.0
      },
      {
        "periodo": 202602,
        "valor": 113446751.0,
        "delta": 15335992.0
      },
      {
        "periodo": 202603,
        "valor": 164684746.0,
        "delta": 51237995.0
      },
      {
        "periodo": 202604,
        "valor": 156241447.0,
        "delta": -8443299.0
      },
      {
        "periodo": 202605,
        "valor": 129277896.0,
        "delta": -26963551.0
      },
      {
        "periodo": 202606,
        "valor": 137559769.0,
        "delta": 8281873.0
      },
      {
        "periodo": 202607,
        "valor": 148643849.0,
        "delta": 11084080.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": -72936388.0,
    "valor_anterior": 182168916.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12464901.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 60010052.0,
        "delta": 47545151.0
      },
      {
        "periodo": 202509,
        "valor": -15154860.0,
        "delta": -75164912.0
      },
      {
        "periodo": 202510,
        "valor": -16819170.0,
        "delta": -1664310.0
      },
      {
        "periodo": 202511,
        "valor": -38088182.0,
        "delta": -21269012.0
      },
      {
        "periodo": 202512,
        "valor": 78940203.0,
        "delta": 117028385.0
      },
      {
        "periodo": 202601,
        "valor": 6560343.0,
        "delta": -72379860.0
      },
      {
        "periodo": 202602,
        "valor": -9170593.0,
        "delta": -15730936.0
      },
      {
        "periodo": 202603,
        "valor": 15408196.0,
        "delta": 24578789.0
      },
      {
        "periodo": 202604,
        "valor": -125884521.0,
        "delta": -141292717.0
      },
      {
        "periodo": 202605,
        "valor": -42132479.0,
        "delta": 83752042.0
      },
      {
        "periodo": 202606,
        "valor": 182168916.0,
        "delta": 224301395.0
      },
      {
        "periodo": 202607,
        "valor": -72936388.0,
        "delta": -255105304.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 3585915.0,
    "valor_anterior": 1999842.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -6331452.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -8814540.0,
        "delta": -2483088.0
      },
      {
        "periodo": 202509,
        "valor": -4929790.0,
        "delta": 3884750.0
      },
      {
        "periodo": 202510,
        "valor": -6800463.0,
        "delta": -1870673.0
      },
      {
        "periodo": 202511,
        "valor": 12222225.0,
        "delta": 19022688.0
      },
      {
        "periodo": 202512,
        "valor": 4963514.0,
        "delta": -7258711.0
      },
      {
        "periodo": 202601,
        "valor": -6697490.0,
        "delta": -11661004.0
      },
      {
        "periodo": 202602,
        "valor": 798398.0,
        "delta": 7495888.0
      },
      {
        "periodo": 202603,
        "valor": 754580.0,
        "delta": -43818.0
      },
      {
        "periodo": 202604,
        "valor": -3856228.0,
        "delta": -4610808.0
      },
      {
        "periodo": 202605,
        "valor": 2094074.0,
        "delta": 5950302.0
      },
      {
        "periodo": 202606,
        "valor": 1999842.0,
        "delta": -94232.0
      },
      {
        "periodo": 202607,
        "valor": 3585915.0,
        "delta": 1586073.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": -9410401.0,
    "valor_anterior": -10331901.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -4807297.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -6378901.0,
        "delta": -1571604.0
      },
      {
        "periodo": 202509,
        "valor": -1032672.0,
        "delta": 5346229.0
      },
      {
        "periodo": 202510,
        "valor": -5979215.0,
        "delta": -4946543.0
      },
      {
        "periodo": 202511,
        "valor": -4343582.0,
        "delta": 1635633.0
      },
      {
        "periodo": 202512,
        "valor": -11607348.0,
        "delta": -7263766.0
      },
      {
        "periodo": 202601,
        "valor": -4002392.0,
        "delta": 7604956.0
      },
      {
        "periodo": 202602,
        "valor": -4959804.0,
        "delta": -957412.0
      },
      {
        "periodo": 202603,
        "valor": -6782583.0,
        "delta": -1822779.0
      },
      {
        "periodo": 202604,
        "valor": -4783051.0,
        "delta": 1999532.0
      },
      {
        "periodo": 202605,
        "valor": -8909606.0,
        "delta": -4126555.0
      },
      {
        "periodo": 202606,
        "valor": -10331901.0,
        "delta": -1422295.0
      },
      {
        "periodo": 202607,
        "valor": -9410401.0,
        "delta": 921500.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 10065012.930000007,
    "valor_anterior": 12100903.479999997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2569923.57,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2139277.88,
        "delta": -430645.69
      },
      {
        "periodo": 202509,
        "valor": 15675913.55,
        "delta": 13536635.67
      },
      {
        "periodo": 202510,
        "valor": 10012758.18,
        "delta": -5663155.37
      },
      {
        "periodo": 202511,
        "valor": 10143417.35,
        "delta": 130659.17
      },
      {
        "periodo": 202512,
        "valor": 22130749.96,
        "delta": 11987332.61
      },
      {
        "periodo": 202601,
        "valor": 16526313.02,
        "delta": -5604436.94
      },
      {
        "periodo": 202602,
        "valor": 9268712.95,
        "delta": -7257600.07
      },
      {
        "periodo": 202603,
        "valor": 5369774.47,
        "delta": -3898938.48
      },
      {
        "periodo": 202604,
        "valor": 8378236.35,
        "delta": 3008461.88
      },
      {
        "periodo": 202605,
        "valor": 8064070.64,
        "delta": -314165.71
      },
      {
        "periodo": 202606,
        "valor": 12100903.48,
        "delta": 4036832.84
      },
      {
        "periodo": 202607,
        "valor": 10065012.93,
        "delta": -2035890.55
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 270753.0,
    "valor_anterior": 777868.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -12020192.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -7906293.0,
        "delta": 4113899.0
      },
      {
        "periodo": 202509,
        "valor": -9713799.0,
        "delta": -1807506.0
      },
      {
        "periodo": 202510,
        "valor": -8122825.0,
        "delta": 1590974.0
      },
      {
        "periodo": 202511,
        "valor": -9886320.0,
        "delta": -1763495.0
      },
      {
        "periodo": 202512,
        "valor": 1653473.0,
        "delta": 11539793.0
      },
      {
        "periodo": 202601,
        "valor": 358185.0,
        "delta": -1295288.0
      },
      {
        "periodo": 202602,
        "valor": 339756.0,
        "delta": -18429.0
      },
      {
        "periodo": 202603,
        "valor": 363425.0,
        "delta": 23669.0
      },
      {
        "periodo": 202604,
        "valor": 384526.0,
        "delta": 21101.0
      },
      {
        "periodo": 202605,
        "valor": 314635.0,
        "delta": -69891.0
      },
      {
        "periodo": 202606,
        "valor": 777868.0,
        "delta": 463233.0
      },
      {
        "periodo": 202607,
        "valor": 270753.0,
        "delta": -507115.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 106792634.11000001,
    "valor_anterior": 64326111.26999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 110139995.34,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 103442059.51,
        "delta": -6697935.83
      },
      {
        "periodo": 202509,
        "valor": 32598589.82,
        "delta": -70843469.69
      },
      {
        "periodo": 202510,
        "valor": 149979127.63,
        "delta": 117380537.81
      },
      {
        "periodo": 202511,
        "valor": 100516643.67,
        "delta": -49462483.96
      },
      {
        "periodo": 202512,
        "valor": 115503246.11,
        "delta": 14986602.44
      },
      {
        "periodo": 202601,
        "valor": 102224274.39,
        "delta": -13278971.72
      },
      {
        "periodo": 202602,
        "valor": 74042953.92,
        "delta": -28181320.47
      },
      {
        "periodo": 202603,
        "valor": 25869214.54,
        "delta": -48173739.38
      },
      {
        "periodo": 202604,
        "valor": 110172026.39,
        "delta": 84302811.85
      },
      {
        "periodo": 202605,
        "valor": 119830266.98,
        "delta": 9658240.59
      },
      {
        "periodo": 202606,
        "valor": 64326111.27,
        "delta": -55504155.71
      },
      {
        "periodo": 202607,
        "valor": 106792634.11,
        "delta": 42466522.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 34610469.7,
    "valor_anterior": 23876078.840000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 29957093.54,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11663517.9,
        "delta": -18293575.64
      },
      {
        "periodo": 202509,
        "valor": 4301358.29,
        "delta": -7362159.61
      },
      {
        "periodo": 202510,
        "valor": 13652074.84,
        "delta": 9350716.55
      },
      {
        "periodo": 202511,
        "valor": 16091619.89,
        "delta": 2439545.05
      },
      {
        "periodo": 202512,
        "valor": -7133351.13,
        "delta": -23224971.02
      },
      {
        "periodo": 202601,
        "valor": 17609006.63,
        "delta": 24742357.76
      },
      {
        "periodo": 202602,
        "valor": 19860834.12,
        "delta": 2251827.49
      },
      {
        "periodo": 202603,
        "valor": 13642633.92,
        "delta": -6218200.2
      },
      {
        "periodo": 202604,
        "valor": 12442259.38,
        "delta": -1200374.54
      },
      {
        "periodo": 202605,
        "valor": 18469972.53,
        "delta": 6027713.15
      },
      {
        "periodo": 202606,
        "valor": 23876078.84,
        "delta": 5406106.31
      },
      {
        "periodo": 202607,
        "valor": 34610469.7,
        "delta": 10734390.86
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": -9397123.0,
    "valor_anterior": 16422639.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22008241.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28182127.0,
        "delta": 6173886.0
      },
      {
        "periodo": 202509,
        "valor": 31456323.0,
        "delta": 3274196.0
      },
      {
        "periodo": 202510,
        "valor": 29170650.0,
        "delta": -2285673.0
      },
      {
        "periodo": 202511,
        "valor": 20918745.0,
        "delta": -8251905.0
      },
      {
        "periodo": 202512,
        "valor": 2422923.0,
        "delta": -18495822.0
      },
      {
        "periodo": 202601,
        "valor": 23669922.0,
        "delta": 21246999.0
      },
      {
        "periodo": 202602,
        "valor": 29181563.0,
        "delta": 5511641.0
      },
      {
        "periodo": 202603,
        "valor": 4532401.0,
        "delta": -24649162.0
      },
      {
        "periodo": 202604,
        "valor": -12616344.0,
        "delta": -17148745.0
      },
      {
        "periodo": 202605,
        "valor": 30956283.0,
        "delta": 43572627.0
      },
      {
        "periodo": 202606,
        "valor": 16422639.0,
        "delta": -14533644.0
      },
      {
        "periodo": 202607,
        "valor": -9397123.0,
        "delta": -25819762.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 121476795.0,
    "valor_anterior": 153465432.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 61946953.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 154287189.0,
        "delta": 92340236.0
      },
      {
        "periodo": 202509,
        "valor": 101121383.0,
        "delta": -53165806.0
      },
      {
        "periodo": 202510,
        "valor": 120200411.0,
        "delta": 19079028.0
      },
      {
        "periodo": 202511,
        "valor": 110035702.0,
        "delta": -10164709.0
      },
      {
        "periodo": 202512,
        "valor": 75868049.0,
        "delta": -34167653.0
      },
      {
        "periodo": 202601,
        "valor": 91597397.0,
        "delta": 15729348.0
      },
      {
        "periodo": 202602,
        "valor": 69755268.0,
        "delta": -21842129.0
      },
      {
        "periodo": 202603,
        "valor": 113742640.0,
        "delta": 43987372.0
      },
      {
        "periodo": 202604,
        "valor": 114047780.0,
        "delta": 305140.0
      },
      {
        "periodo": 202605,
        "valor": 133795892.0,
        "delta": 19748112.0
      },
      {
        "periodo": 202606,
        "valor": 153465432.0,
        "delta": 19669540.0
      },
      {
        "periodo": 202607,
        "valor": 121476795.0,
        "delta": -31988637.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 19148620.0,
    "valor_anterior": 4311836.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2433354.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16535136.0,
        "delta": 14101782.0
      },
      {
        "periodo": 202509,
        "valor": 8222172.0,
        "delta": -8312964.0
      },
      {
        "periodo": 202510,
        "valor": 11564275.0,
        "delta": 3342103.0
      },
      {
        "periodo": 202511,
        "valor": 11176276.0,
        "delta": -387999.0
      },
      {
        "periodo": 202512,
        "valor": 3359803.0,
        "delta": -7816473.0
      },
      {
        "periodo": 202601,
        "valor": 8255819.0,
        "delta": 4896016.0
      },
      {
        "periodo": 202602,
        "valor": 8107789.0,
        "delta": -148030.0
      },
      {
        "periodo": 202603,
        "valor": 15188214.0,
        "delta": 7080425.0
      },
      {
        "periodo": 202604,
        "valor": 8758719.0,
        "delta": -6429495.0
      },
      {
        "periodo": 202605,
        "valor": 10588893.0,
        "delta": 1830174.0
      },
      {
        "periodo": 202606,
        "valor": 4311836.0,
        "delta": -6277057.0
      },
      {
        "periodo": 202607,
        "valor": 19148620.0,
        "delta": 14836784.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 16646734.760000005,
    "valor_anterior": 19572677.549999997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30185579.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25631317.65,
        "delta": -4554262.07
      },
      {
        "periodo": 202509,
        "valor": 59269117.2,
        "delta": 33637799.55
      },
      {
        "periodo": 202510,
        "valor": 32439165.32,
        "delta": -26829951.88
      },
      {
        "periodo": 202511,
        "valor": 33654932.43,
        "delta": 1215767.11
      },
      {
        "periodo": 202512,
        "valor": 16027224.87,
        "delta": -17627707.56
      },
      {
        "periodo": 202601,
        "valor": 27642180.04,
        "delta": 11614955.17
      },
      {
        "periodo": 202602,
        "valor": 23908341.45,
        "delta": -3733838.59
      },
      {
        "periodo": 202603,
        "valor": 11794766.71,
        "delta": -12113574.74
      },
      {
        "periodo": 202604,
        "valor": 21546454.89,
        "delta": 9751688.18
      },
      {
        "periodo": 202605,
        "valor": 17306998.97,
        "delta": -4239455.92
      },
      {
        "periodo": 202606,
        "valor": 19572677.55,
        "delta": 2265678.58
      },
      {
        "periodo": 202607,
        "valor": 16646734.76,
        "delta": -2925942.79
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 6889676.539999999,
    "valor_anterior": 10004298.04,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25457260.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28322598.62,
        "delta": 2865337.9
      },
      {
        "periodo": 202509,
        "valor": 7320453.96,
        "delta": -21002144.66
      },
      {
        "periodo": 202510,
        "valor": 10283121.22,
        "delta": 2962667.26
      },
      {
        "periodo": 202511,
        "valor": -2035108.22,
        "delta": -12318229.44
      },
      {
        "periodo": 202512,
        "valor": 8793353.25,
        "delta": 10828461.47
      },
      {
        "periodo": 202601,
        "valor": 6879981.62,
        "delta": -1913371.63
      },
      {
        "periodo": 202602,
        "valor": -6986306.12,
        "delta": -13866287.74
      },
      {
        "periodo": 202603,
        "valor": 17847791.31,
        "delta": 24834097.43
      },
      {
        "periodo": 202604,
        "valor": 7349781.58,
        "delta": -10498009.73
      },
      {
        "periodo": 202605,
        "valor": 3615885.04,
        "delta": -3733896.54
      },
      {
        "periodo": 202606,
        "valor": 10004298.04,
        "delta": 6388413.0
      },
      {
        "periodo": 202607,
        "valor": 6889676.54,
        "delta": -3114621.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 27892068.0,
    "valor_anterior": 32894428.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30909163.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29196640.0,
        "delta": -1712523.0
      },
      {
        "periodo": 202509,
        "valor": 28559177.0,
        "delta": -637463.0
      },
      {
        "periodo": 202510,
        "valor": 27513602.0,
        "delta": -1045575.0
      },
      {
        "periodo": 202511,
        "valor": 30274573.0,
        "delta": 2760971.0
      },
      {
        "periodo": 202512,
        "valor": 16241023.0,
        "delta": -14033550.0
      },
      {
        "periodo": 202601,
        "valor": 26453931.0,
        "delta": 10212908.0
      },
      {
        "periodo": 202602,
        "valor": 24675089.0,
        "delta": -1778842.0
      },
      {
        "periodo": 202603,
        "valor": 27301340.0,
        "delta": 2626251.0
      },
      {
        "periodo": 202604,
        "valor": 26833381.0,
        "delta": -467959.0
      },
      {
        "periodo": 202605,
        "valor": 24735626.0,
        "delta": -2097755.0
      },
      {
        "periodo": 202606,
        "valor": 32894428.0,
        "delta": 8158802.0
      },
      {
        "periodo": 202607,
        "valor": 27892068.0,
        "delta": -5002360.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 2489854.0,
    "valor_anterior": 4308163.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2938158.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4107502.0,
        "delta": 1169344.0
      },
      {
        "periodo": 202509,
        "valor": 4214856.0,
        "delta": 107354.0
      },
      {
        "periodo": 202510,
        "valor": 5775547.0,
        "delta": 1560691.0
      },
      {
        "periodo": 202511,
        "valor": -332213.0,
        "delta": -6107760.0
      },
      {
        "periodo": 202512,
        "valor": 2015152.0,
        "delta": 2347365.0
      },
      {
        "periodo": 202601,
        "valor": 1923823.0,
        "delta": -91329.0
      },
      {
        "periodo": 202602,
        "valor": 3061869.0,
        "delta": 1138046.0
      },
      {
        "periodo": 202603,
        "valor": 6608093.0,
        "delta": 3546224.0
      },
      {
        "periodo": 202604,
        "valor": 1289734.0,
        "delta": -5318359.0
      },
      {
        "periodo": 202605,
        "valor": 6047929.0,
        "delta": 4758195.0
      },
      {
        "periodo": 202606,
        "valor": 4308163.0,
        "delta": -1739766.0
      },
      {
        "periodo": 202607,
        "valor": 2489854.0,
        "delta": -1818309.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": -40638522.0,
    "valor_anterior": 45124213.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13364790.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -319890.0,
        "delta": -13684680.0
      },
      {
        "periodo": 202509,
        "valor": 87418270.0,
        "delta": 87738160.0
      },
      {
        "periodo": 202510,
        "valor": 8560155.0,
        "delta": -78858115.0
      },
      {
        "periodo": 202511,
        "valor": 3918694.0,
        "delta": -4641461.0
      },
      {
        "periodo": 202512,
        "valor": 71007451.0,
        "delta": 67088757.0
      },
      {
        "periodo": 202601,
        "valor": 12659503.0,
        "delta": -58347948.0
      },
      {
        "periodo": 202602,
        "valor": 9243645.0,
        "delta": -3415858.0
      },
      {
        "periodo": 202603,
        "valor": 51081947.0,
        "delta": 41838302.0
      },
      {
        "periodo": 202604,
        "valor": -32102796.0,
        "delta": -83184743.0
      },
      {
        "periodo": 202605,
        "valor": 24955747.0,
        "delta": 57058543.0
      },
      {
        "periodo": 202606,
        "valor": 45124213.0,
        "delta": 20168466.0
      },
      {
        "periodo": 202607,
        "valor": -40638522.0,
        "delta": -85762735.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": -58943350.44999999,
    "valor_anterior": -55054612.06,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -76223256.01,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -77709934.19,
        "delta": -1486678.18
      },
      {
        "periodo": 202509,
        "valor": -57733947.76,
        "delta": 19975986.43
      },
      {
        "periodo": 202510,
        "valor": -58956638.86,
        "delta": -1222691.1
      },
      {
        "periodo": 202511,
        "valor": -59164865.52,
        "delta": -208226.66
      },
      {
        "periodo": 202512,
        "valor": -54344435.65,
        "delta": 4820429.87
      },
      {
        "periodo": 202601,
        "valor": -67592844.03,
        "delta": -13248408.38
      },
      {
        "periodo": 202602,
        "valor": -62507215.68,
        "delta": 5085628.35
      },
      {
        "periodo": 202603,
        "valor": -54111948.77,
        "delta": 8395266.91
      },
      {
        "periodo": 202604,
        "valor": -67132761.2,
        "delta": -13020812.43
      },
      {
        "periodo": 202605,
        "valor": -75924079.71,
        "delta": -8791318.51
      },
      {
        "periodo": 202606,
        "valor": -55054612.06,
        "delta": 20869467.65
      },
      {
        "periodo": 202607,
        "valor": -58943350.45,
        "delta": -3888738.39
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 11000539.110000014,
    "valor_anterior": 43268312.47999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2632337.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3276902.54,
        "delta": 644564.85
      },
      {
        "periodo": 202509,
        "valor": 3145838.44,
        "delta": -131064.1
      },
      {
        "periodo": 202510,
        "valor": 1854958.07,
        "delta": -1290880.37
      },
      {
        "periodo": 202511,
        "valor": 3374486.0,
        "delta": 1519527.93
      },
      {
        "periodo": 202512,
        "valor": 3452108.41,
        "delta": 77622.41
      },
      {
        "periodo": 202601,
        "valor": 4070817.54,
        "delta": 618709.13
      },
      {
        "periodo": 202602,
        "valor": 39912097.84,
        "delta": 35841280.3
      },
      {
        "periodo": 202603,
        "valor": 33092849.63,
        "delta": -6819248.21
      },
      {
        "periodo": 202604,
        "valor": 8110007.07,
        "delta": -24982842.56
      },
      {
        "periodo": 202605,
        "valor": 18951940.45,
        "delta": 10841933.38
      },
      {
        "periodo": 202606,
        "valor": 43268312.48,
        "delta": 24316372.03
      },
      {
        "periodo": 202607,
        "valor": 11000539.11,
        "delta": -32267773.37
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": -205153217.0,
    "valor_anterior": -206513845.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -102558631.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -128527166.0,
        "delta": -25968535.0
      },
      {
        "periodo": 202509,
        "valor": -145704206.0,
        "delta": -17177040.0
      },
      {
        "periodo": 202510,
        "valor": -182513628.0,
        "delta": -36809422.0
      },
      {
        "periodo": 202511,
        "valor": -179607035.0,
        "delta": 2906593.0
      },
      {
        "periodo": 202512,
        "valor": -177471367.0,
        "delta": 2135668.0
      },
      {
        "periodo": 202601,
        "valor": -193198151.0,
        "delta": -15726784.0
      },
      {
        "periodo": 202602,
        "valor": -187222045.0,
        "delta": 5976106.0
      },
      {
        "periodo": 202603,
        "valor": -192836342.0,
        "delta": -5614297.0
      },
      {
        "periodo": 202604,
        "valor": -196142792.0,
        "delta": -3306450.0
      },
      {
        "periodo": 202605,
        "valor": -214456716.0,
        "delta": -18313924.0
      },
      {
        "periodo": 202606,
        "valor": -206513845.0,
        "delta": 7942871.0
      },
      {
        "periodo": 202607,
        "valor": -205153217.0,
        "delta": 1360628.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": -85113920.13,
    "valor_anterior": -80654242.29000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": -271040998.9,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": -29046783.95,
        "delta": 241994214.95
      },
      {
        "periodo": 202601,
        "valor": -29983714.4,
        "delta": -936930.45
      },
      {
        "periodo": 202602,
        "valor": -48053013.59,
        "delta": -18069299.19
      },
      {
        "periodo": 202603,
        "valor": -74949599.49,
        "delta": -26896585.9
      },
      {
        "periodo": 202604,
        "valor": -64993164.94,
        "delta": 9956434.55
      },
      {
        "periodo": 202605,
        "valor": -73870315.6,
        "delta": -8877150.66
      },
      {
        "periodo": 202606,
        "valor": -80654242.29,
        "delta": -6783926.69
      },
      {
        "periodo": 202607,
        "valor": -85113920.13,
        "delta": -4459677.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": -222600489.0,
    "valor_anterior": -475759690.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": -539541526.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": -84205676.0,
        "delta": 455335850.0
      },
      {
        "periodo": 202605,
        "valor": -232856027.0,
        "delta": -148650351.0
      },
      {
        "periodo": 202606,
        "valor": -475759690.0,
        "delta": -242903663.0
      },
      {
        "periodo": 202607,
        "valor": -222600489.0,
        "delta": 253159201.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 25055413690.27002,
    "valor_anterior": 23309745951.19998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25954294770.22,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24743125367.93,
        "delta": -1211169402.29
      },
      {
        "periodo": 202509,
        "valor": 23653174891.82,
        "delta": -1089950476.11
      },
      {
        "periodo": 202510,
        "valor": 24922486172.81,
        "delta": 1269311280.99
      },
      {
        "periodo": 202511,
        "valor": 26356735547.34,
        "delta": 1434249374.53
      },
      {
        "periodo": 202512,
        "valor": 26903523795.4301,
        "delta": 546788248.0901
      },
      {
        "periodo": 202601,
        "valor": 28292143729.45,
        "delta": 1388619934.0199
      },
      {
        "periodo": 202602,
        "valor": 20698770243.6,
        "delta": -7593373485.85
      },
      {
        "periodo": 202603,
        "valor": 31701059428.81,
        "delta": 11002289185.21
      },
      {
        "periodo": 202604,
        "valor": 24047903929.56,
        "delta": -7653155499.25
      },
      {
        "periodo": 202605,
        "valor": 21068656407.71,
        "delta": -2979247521.85
      },
      {
        "periodo": 202606,
        "valor": 23309745951.2,
        "delta": 2241089543.49
      },
      {
        "periodo": 202607,
        "valor": 25055413690.27,
        "delta": 1745667739.07
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 21503062825.320007,
    "valor_anterior": 19997140150.51999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21029800860.07,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19817604755.93,
        "delta": -1212196104.14
      },
      {
        "periodo": 202509,
        "valor": 17307103541.07,
        "delta": -2510501214.86
      },
      {
        "periodo": 202510,
        "valor": 18525646379.21,
        "delta": 1218542838.14
      },
      {
        "periodo": 202511,
        "valor": 22095513239.42,
        "delta": 3569866860.21
      },
      {
        "periodo": 202512,
        "valor": 20379028836.01,
        "delta": -1716484403.41
      },
      {
        "periodo": 202601,
        "valor": 22687462190.76,
        "delta": 2308433354.75
      },
      {
        "periodo": 202602,
        "valor": 15629827140.6,
        "delta": -7057635050.16
      },
      {
        "periodo": 202603,
        "valor": 27262023115.85,
        "delta": 11632195975.25
      },
      {
        "periodo": 202604,
        "valor": 18906446731.45,
        "delta": -8355576384.4
      },
      {
        "periodo": 202605,
        "valor": 17232435229.91,
        "delta": -1674011501.54
      },
      {
        "periodo": 202606,
        "valor": 19997140150.52,
        "delta": 2764704920.61
      },
      {
        "periodo": 202607,
        "valor": 21503062825.32,
        "delta": 1505922674.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 304209711.8900001,
    "valor_anterior": 32629961.799999952,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 185344949.73,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -543298799.24,
        "delta": -728643748.97
      },
      {
        "periodo": 202509,
        "valor": 801350648.96,
        "delta": 1344649448.2
      },
      {
        "periodo": 202510,
        "valor": 510066147.46,
        "delta": -291284501.5
      },
      {
        "periodo": 202511,
        "valor": 392459302.81,
        "delta": -117606844.65
      },
      {
        "periodo": 202512,
        "valor": 582838213.43,
        "delta": 190378910.62
      },
      {
        "periodo": 202601,
        "valor": 546566105.08,
        "delta": -36272108.35
      },
      {
        "periodo": 202602,
        "valor": 449400976.11,
        "delta": -97165128.97
      },
      {
        "periodo": 202603,
        "valor": 203822855.02,
        "delta": -245578121.09
      },
      {
        "periodo": 202604,
        "valor": 323054466.86,
        "delta": 119231611.84
      },
      {
        "periodo": 202605,
        "valor": 451092030.99,
        "delta": 128037564.13
      },
      {
        "periodo": 202606,
        "valor": 32629961.8,
        "delta": -418462069.19
      },
      {
        "periodo": 202607,
        "valor": 304209711.89,
        "delta": 271579750.09
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 1151667136.0500011,
    "valor_anterior": 1338671831.0199995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1778190422.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2159430228.54,
        "delta": 381239806.15
      },
      {
        "periodo": 202509,
        "valor": 1947579535.73,
        "delta": -211850692.81
      },
      {
        "periodo": 202510,
        "valor": 1967305577.36,
        "delta": 19726041.63
      },
      {
        "periodo": 202511,
        "valor": 831432934.73,
        "delta": -1135872642.63
      },
      {
        "periodo": 202512,
        "valor": 2124613973.56,
        "delta": 1293181038.83
      },
      {
        "periodo": 202601,
        "valor": 1872368370.17,
        "delta": -252245603.39
      },
      {
        "periodo": 202602,
        "valor": 1553955439.98,
        "delta": -318412930.19
      },
      {
        "periodo": 202603,
        "valor": 1406804957.74,
        "delta": -147150482.24
      },
      {
        "periodo": 202604,
        "valor": 2136606460.31,
        "delta": 729801502.57
      },
      {
        "periodo": 202605,
        "valor": 1499351765.26,
        "delta": -637254695.05
      },
      {
        "periodo": 202606,
        "valor": 1338671831.02,
        "delta": -160679934.24
      },
      {
        "periodo": 202607,
        "valor": 1151667136.05,
        "delta": -187004694.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 1863755127.4099998,
    "valor_anterior": 1966501033.3500004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1739008839.16,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1930932670.49,
        "delta": 191923831.33
      },
      {
        "periodo": 202509,
        "valor": 1888376393.51,
        "delta": -42556276.98
      },
      {
        "periodo": 202510,
        "valor": 2026099199.14,
        "delta": 137722805.63
      },
      {
        "periodo": 202511,
        "valor": 2048389082.62,
        "delta": 22289883.48
      },
      {
        "periodo": 202512,
        "valor": 1899064406.86,
        "delta": -149324675.76
      },
      {
        "periodo": 202601,
        "valor": 1819879293.71,
        "delta": -79185113.15
      },
      {
        "periodo": 202602,
        "valor": 1468016475.2,
        "delta": -351862818.51
      },
      {
        "periodo": 202603,
        "valor": 1903678666.57,
        "delta": 435662191.37
      },
      {
        "periodo": 202604,
        "valor": 1887462519.35,
        "delta": -16216147.22
      },
      {
        "periodo": 202605,
        "valor": 1884827003.85,
        "delta": -2635515.5
      },
      {
        "periodo": 202606,
        "valor": 1966501033.35,
        "delta": 81674029.5
      },
      {
        "periodo": 202607,
        "valor": 1863755127.41,
        "delta": -102745905.94
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": 376169664.03999996,
    "valor_anterior": 415878284.18000007,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 260946330.88,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 384148377.51,
        "delta": 123202046.63
      },
      {
        "periodo": 202509,
        "valor": 566431702.85,
        "delta": 182283325.34
      },
      {
        "periodo": 202510,
        "valor": 377091902.19,
        "delta": -189339800.66
      },
      {
        "periodo": 202511,
        "valor": 90787391.12,
        "delta": -286304511.07
      },
      {
        "periodo": 202512,
        "valor": 476200143.06,
        "delta": 385412751.94
      },
      {
        "periodo": 202601,
        "valor": 370288260.7,
        "delta": -105911882.36
      },
      {
        "periodo": 202602,
        "valor": 307646333.32,
        "delta": -62641927.38
      },
      {
        "periodo": 202603,
        "valor": 371185652.95,
        "delta": 63539319.63
      },
      {
        "periodo": 202604,
        "valor": 195244555.59,
        "delta": -175941097.36
      },
      {
        "periodo": 202605,
        "valor": 387878632.16,
        "delta": 192634076.57
      },
      {
        "periodo": 202606,
        "valor": 415878284.18,
        "delta": 27999652.02
      },
      {
        "periodo": 202607,
        "valor": 376169664.04,
        "delta": -39708620.14
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100013,
    "label": "Resultado Neto",
    "valor_actual": -143450774.43999958,
    "valor_anterior": -441075309.6700001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 961003367.99,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 994308134.7,
        "delta": 33304766.71
      },
      {
        "periodo": 202509,
        "valor": 1142333069.7,
        "delta": 148024935.0
      },
      {
        "periodo": 202510,
        "valor": 1516276967.45,
        "delta": 373943897.75
      },
      {
        "periodo": 202511,
        "valor": 898153596.64,
        "delta": -618123370.81
      },
      {
        "periodo": 202512,
        "valor": 1441778222.51,
        "delta": 543624625.87
      },
      {
        "periodo": 202601,
        "valor": 995579509.03,
        "delta": -446198713.48
      },
      {
        "periodo": 202602,
        "valor": 1289923878.39,
        "delta": 294344369.36
      },
      {
        "periodo": 202603,
        "valor": 553544180.68,
        "delta": -736379697.71
      },
      {
        "periodo": 202604,
        "valor": 599089196.0,
        "delta": 45545015.32
      },
      {
        "periodo": 202605,
        "valor": -386928254.46,
        "delta": -986017450.46
      },
      {
        "periodo": 202606,
        "valor": -441075309.67,
        "delta": -54147055.21
      },
      {
        "periodo": 202607,
        "valor": -143450774.44,
        "delta": 297624535.23
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 1708554463.0600014,
    "valor_anterior": 1835395868.9399986,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1883019734.37,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1814710240.47,
        "delta": -68309493.9
      },
      {
        "periodo": 202509,
        "valor": 922545379.86,
        "delta": -892164860.61
      },
      {
        "periodo": 202510,
        "valor": 1108229743.56,
        "delta": 185684363.7
      },
      {
        "periodo": 202511,
        "valor": 3718164399.5,
        "delta": 2609934655.94
      },
      {
        "periodo": 202512,
        "valor": -3400985568.95,
        "delta": -7119149968.45
      },
      {
        "periodo": 202601,
        "valor": 2607622418.82,
        "delta": 6008607987.77
      },
      {
        "periodo": 202602,
        "valor": 2126820512.32,
        "delta": -480801906.5
      },
      {
        "periodo": 202603,
        "valor": 1448591371.6,
        "delta": -678229140.72
      },
      {
        "periodo": 202604,
        "valor": 1457550885.44,
        "delta": 8959513.84
      },
      {
        "periodo": 202605,
        "valor": 3815933907.84,
        "delta": 2358383022.4
      },
      {
        "periodo": 202606,
        "valor": 1835395868.94,
        "delta": -1980538038.9
      },
      {
        "periodo": 202607,
        "valor": 1708554463.06,
        "delta": -126841405.88
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 8808508807.729996,
    "valor_anterior": 4674602358.840004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7830874690.21,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10463831778.38,
        "delta": 2632957088.17
      },
      {
        "periodo": 202509,
        "valor": 8849792178.17,
        "delta": -1614039600.21
      },
      {
        "periodo": 202510,
        "valor": 8720273530.85,
        "delta": -129518647.32
      },
      {
        "periodo": 202511,
        "valor": 6641242416.31,
        "delta": -2079031114.54
      },
      {
        "periodo": 202512,
        "valor": 4671696552.24,
        "delta": -1969545864.07
      },
      {
        "periodo": 202601,
        "valor": 10807977843.91,
        "delta": 6136281291.67
      },
      {
        "periodo": 202602,
        "valor": 6636689011.6,
        "delta": -4171288832.31
      },
      {
        "periodo": 202603,
        "valor": 4649081818.25,
        "delta": -1987607193.35
      },
      {
        "periodo": 202604,
        "valor": 9690744213.35,
        "delta": 5041662395.1
      },
      {
        "periodo": 202605,
        "valor": 8864924683.35,
        "delta": -825819530.0
      },
      {
        "periodo": 202606,
        "valor": 4674602358.84,
        "delta": -4190322324.51
      },
      {
        "periodo": 202607,
        "valor": 8808508807.73,
        "delta": 4133906448.89
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 2704051259.999996,
    "valor_anterior": 3686543052.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2779486080.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3229977134.0,
        "delta": 450491054.0
      },
      {
        "periodo": 202509,
        "valor": 2591661219.0,
        "delta": -638315915.0
      },
      {
        "periodo": 202510,
        "valor": 2939518129.0,
        "delta": 347856910.0
      },
      {
        "periodo": 202511,
        "valor": 1974368474.0,
        "delta": -965149655.0
      },
      {
        "periodo": 202512,
        "valor": 2951474856.0,
        "delta": 977106382.0
      },
      {
        "periodo": 202601,
        "valor": 3374061526.0,
        "delta": 422586670.0
      },
      {
        "periodo": 202602,
        "valor": 2221065439.0,
        "delta": -1152996087.0
      },
      {
        "periodo": 202603,
        "valor": 4363716726.0,
        "delta": 2142651287.0
      },
      {
        "periodo": 202604,
        "valor": 3195144585.0,
        "delta": -1168572141.0
      },
      {
        "periodo": 202605,
        "valor": 1488326728.0,
        "delta": -1706817857.0
      },
      {
        "periodo": 202606,
        "valor": 3686543052.0,
        "delta": 2198216324.0
      },
      {
        "periodo": 202607,
        "valor": 2704051260.0,
        "delta": -982491792.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 457938310.0,
    "valor_anterior": -372990276.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 859888723.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1094760612.0,
        "delta": 234871889.0
      },
      {
        "periodo": 202509,
        "valor": 771376232.0,
        "delta": -323384380.0
      },
      {
        "periodo": 202510,
        "valor": 240552212.0,
        "delta": -530824020.0
      },
      {
        "periodo": 202511,
        "valor": 1027026167.0,
        "delta": 786473955.0
      },
      {
        "periodo": 202512,
        "valor": -783733899.0,
        "delta": -1810760066.0
      },
      {
        "periodo": 202601,
        "valor": 1257599563.0,
        "delta": 2041333462.0
      },
      {
        "periodo": 202602,
        "valor": 1080409066.0,
        "delta": -177190497.0
      },
      {
        "periodo": 202603,
        "valor": 861096592.0,
        "delta": -219312474.0
      },
      {
        "periodo": 202604,
        "valor": 156210085.0,
        "delta": -704886507.0
      },
      {
        "periodo": 202605,
        "valor": -19309860.0,
        "delta": -175519945.0
      },
      {
        "periodo": 202606,
        "valor": -372990276.0,
        "delta": -353680416.0
      },
      {
        "periodo": 202607,
        "valor": 457938310.0,
        "delta": 830928586.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 627354714.29,
    "valor_anterior": 672351729.6099997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 708009817.57,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 814136067.34,
        "delta": 106126249.77
      },
      {
        "periodo": 202509,
        "valor": 741588915.6,
        "delta": -72547151.74
      },
      {
        "periodo": 202510,
        "valor": 742701358.04,
        "delta": 1112442.44
      },
      {
        "periodo": 202511,
        "valor": 758879868.01,
        "delta": 16178509.97
      },
      {
        "periodo": 202512,
        "valor": 298172138.16,
        "delta": -460707729.85
      },
      {
        "periodo": 202601,
        "valor": 749849970.16,
        "delta": 451677832.0
      },
      {
        "periodo": 202602,
        "valor": 545326175.17,
        "delta": -204523794.99
      },
      {
        "periodo": 202603,
        "valor": 745137474.67,
        "delta": 199811299.5
      },
      {
        "periodo": 202604,
        "valor": 709228380.24,
        "delta": -35909094.43
      },
      {
        "periodo": 202605,
        "valor": 735718063.52,
        "delta": 26489683.28
      },
      {
        "periodo": 202606,
        "valor": 672351729.61,
        "delta": -63366333.91
      },
      {
        "periodo": 202607,
        "valor": 627354714.29,
        "delta": -44997015.32
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 1245570615.0,
    "valor_anterior": 763241059.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2182408589.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1141668881.0,
        "delta": -1040739708.0
      },
      {
        "periodo": 202509,
        "valor": 1030666249.0,
        "delta": -111002632.0
      },
      {
        "periodo": 202510,
        "valor": 1771556364.0,
        "delta": 740890115.0
      },
      {
        "periodo": 202511,
        "valor": 1595735273.0,
        "delta": -175821091.0
      },
      {
        "periodo": 202512,
        "valor": 3235041350.0,
        "delta": 1639306077.0
      },
      {
        "periodo": 202601,
        "valor": 1690857279.0,
        "delta": -1544184071.0
      },
      {
        "periodo": 202602,
        "valor": 1213051750.0,
        "delta": -477805529.0
      },
      {
        "periodo": 202603,
        "valor": 3635519315.0,
        "delta": 2422467565.0
      },
      {
        "periodo": 202604,
        "valor": 816387365.0,
        "delta": -2819131950.0
      },
      {
        "periodo": 202605,
        "valor": 992881897.0,
        "delta": 176494532.0
      },
      {
        "periodo": 202606,
        "valor": 763241059.0,
        "delta": -229640838.0
      },
      {
        "periodo": 202607,
        "valor": 1245570615.0,
        "delta": 482329556.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 306464005.0,
    "valor_anterior": 303859651.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 287382320.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 289903955.0,
        "delta": 2521635.0
      },
      {
        "periodo": 202509,
        "valor": 299777573.0,
        "delta": 9873618.0
      },
      {
        "periodo": 202510,
        "valor": 318431506.0,
        "delta": 18653933.0
      },
      {
        "periodo": 202511,
        "valor": 342435325.0,
        "delta": 24003819.0
      },
      {
        "periodo": 202512,
        "valor": 260333518.0,
        "delta": -82101807.0
      },
      {
        "periodo": 202601,
        "valor": 282018219.0,
        "delta": 21684701.0
      },
      {
        "periodo": 202602,
        "valor": 273308080.0,
        "delta": -8710139.0
      },
      {
        "periodo": 202603,
        "valor": 322159565.0,
        "delta": 48851485.0
      },
      {
        "periodo": 202604,
        "valor": 284053708.0,
        "delta": -38105857.0
      },
      {
        "periodo": 202605,
        "valor": 306698871.0,
        "delta": 22645163.0
      },
      {
        "periodo": 202606,
        "valor": 303859651.0,
        "delta": -2839220.0
      },
      {
        "periodo": 202607,
        "valor": 306464005.0,
        "delta": 2604354.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 1080459361.000001,
    "valor_anterior": 911302132.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 830534339.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 702617545.0,
        "delta": -127916794.0
      },
      {
        "periodo": 202509,
        "valor": 744276703.0,
        "delta": 41659158.0
      },
      {
        "periodo": 202510,
        "valor": 794397403.0,
        "delta": 50120700.0
      },
      {
        "periodo": 202511,
        "valor": 663703191.0,
        "delta": -130694212.0
      },
      {
        "periodo": 202512,
        "valor": 1041177834.0,
        "delta": 377474643.0
      },
      {
        "periodo": 202601,
        "valor": 1175061920.0,
        "delta": 133884086.0
      },
      {
        "periodo": 202602,
        "valor": 709598732.0,
        "delta": -465463188.0
      },
      {
        "periodo": 202603,
        "valor": 2642971671.0,
        "delta": 1933372939.0
      },
      {
        "periodo": 202604,
        "valor": 404635305.0,
        "delta": -2238336366.0
      },
      {
        "periodo": 202605,
        "valor": 706007753.0,
        "delta": 301372448.0
      },
      {
        "periodo": 202606,
        "valor": 911302132.0,
        "delta": 205294379.0
      },
      {
        "periodo": 202607,
        "valor": 1080459361.0,
        "delta": 169157229.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 530108758.99000025,
    "valor_anterior": 457204079.8800001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 535069338.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 532163853.81,
        "delta": -2905485.06
      },
      {
        "periodo": 202509,
        "valor": 575369169.93,
        "delta": 43205316.12
      },
      {
        "periodo": 202510,
        "valor": 567259541.91,
        "delta": -8109628.02
      },
      {
        "periodo": 202511,
        "valor": 466057363.12,
        "delta": -101202178.79
      },
      {
        "periodo": 202512,
        "valor": 607604243.27,
        "delta": 141546880.15
      },
      {
        "periodo": 202601,
        "valor": 534234130.57,
        "delta": -73370112.7
      },
      {
        "periodo": 202602,
        "valor": 483021900.71,
        "delta": -51212229.86
      },
      {
        "periodo": 202603,
        "valor": 294259907.33,
        "delta": -188761993.38
      },
      {
        "periodo": 202604,
        "valor": 611832972.27,
        "delta": 317573064.94
      },
      {
        "periodo": 202605,
        "valor": 483698520.76,
        "delta": -128134451.51
      },
      {
        "periodo": 202606,
        "valor": 457204079.88,
        "delta": -26494440.88
      },
      {
        "periodo": 202607,
        "valor": 530108758.99,
        "delta": 72904679.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 241056637.0,
    "valor_anterior": 158006676.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 193797919.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 43918954.0,
        "delta": -149878965.0
      },
      {
        "periodo": 202509,
        "valor": 220335216.0,
        "delta": 176416262.0
      },
      {
        "periodo": 202510,
        "valor": 215445014.0,
        "delta": -4890202.0
      },
      {
        "periodo": 202511,
        "valor": -619844.0,
        "delta": -216064858.0
      },
      {
        "periodo": 202512,
        "valor": 51006589.0,
        "delta": 51626433.0
      },
      {
        "periodo": 202601,
        "valor": -35032378.0,
        "delta": -86038967.0
      },
      {
        "periodo": 202602,
        "valor": 30301116.0,
        "delta": 65333494.0
      },
      {
        "periodo": 202603,
        "valor": 116313058.0,
        "delta": 86011942.0
      },
      {
        "periodo": 202604,
        "valor": 199339523.0,
        "delta": 83026465.0
      },
      {
        "periodo": 202605,
        "valor": 160161614.0,
        "delta": -39177909.0
      },
      {
        "periodo": 202606,
        "valor": 158006676.0,
        "delta": -2154938.0
      },
      {
        "periodo": 202607,
        "valor": 241056637.0,
        "delta": 83049961.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 100630964.0,
    "valor_anterior": 104262817.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 103708849.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 138208506.0,
        "delta": 34499657.0
      },
      {
        "periodo": 202509,
        "valor": 135475559.0,
        "delta": -2732947.0
      },
      {
        "periodo": 202510,
        "valor": 94891287.0,
        "delta": -40584272.0
      },
      {
        "periodo": 202511,
        "valor": 113804152.0,
        "delta": 18912865.0
      },
      {
        "periodo": 202512,
        "valor": 119344676.0,
        "delta": 5540524.0
      },
      {
        "periodo": 202601,
        "valor": 96822634.0,
        "delta": -22522042.0
      },
      {
        "periodo": 202602,
        "valor": 104139613.0,
        "delta": 7316979.0
      },
      {
        "periodo": 202603,
        "valor": 115179325.0,
        "delta": 11039712.0
      },
      {
        "periodo": 202604,
        "valor": 104909500.0,
        "delta": -10269825.0
      },
      {
        "periodo": 202605,
        "valor": 89518435.0,
        "delta": -15391065.0
      },
      {
        "periodo": 202606,
        "valor": 104262817.0,
        "delta": 14744382.0
      },
      {
        "periodo": 202607,
        "valor": 100630964.0,
        "delta": -3631853.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 75957540.0,
    "valor_anterior": 94342540.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 93228467.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 78831037.0,
        "delta": -14397430.0
      },
      {
        "periodo": 202509,
        "valor": 80065960.0,
        "delta": 1234923.0
      },
      {
        "periodo": 202510,
        "valor": 95120109.0,
        "delta": 15054149.0
      },
      {
        "periodo": 202511,
        "valor": 88280870.0,
        "delta": -6839239.0
      },
      {
        "periodo": 202512,
        "valor": -390264460.0,
        "delta": -478545330.0
      },
      {
        "periodo": 202601,
        "valor": 87870706.0,
        "delta": 478135166.0
      },
      {
        "periodo": 202602,
        "valor": 11701230.0,
        "delta": -76169476.0
      },
      {
        "periodo": 202603,
        "valor": 280183083.0,
        "delta": 268481853.0
      },
      {
        "periodo": 202604,
        "valor": 80069309.0,
        "delta": -200113774.0
      },
      {
        "periodo": 202605,
        "valor": 68835608.0,
        "delta": -11233701.0
      },
      {
        "periodo": 202606,
        "valor": 94342540.0,
        "delta": 25506932.0
      },
      {
        "periodo": 202607,
        "valor": 75957540.0,
        "delta": -18385000.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 3541576944.9799995,
    "valor_anterior": 4703764397.380001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3683958351.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4951618155.7,
        "delta": 1267659804.41
      },
      {
        "periodo": 202509,
        "valor": 3282563922.83,
        "delta": -1669054232.87
      },
      {
        "periodo": 202510,
        "valor": 4109317625.64,
        "delta": 826753702.81
      },
      {
        "periodo": 202511,
        "valor": 3770500809.85,
        "delta": -338816815.79
      },
      {
        "periodo": 202512,
        "valor": 3026798164.48,
        "delta": -743702645.37
      },
      {
        "periodo": 202601,
        "valor": 4132509178.09,
        "delta": 1105711013.61
      },
      {
        "periodo": 202602,
        "valor": 4850530906.3,
        "delta": 718021728.21
      },
      {
        "periodo": 202603,
        "valor": 1976952017.41,
        "delta": -2873578888.89
      },
      {
        "periodo": 202604,
        "valor": 5212710699.98,
        "delta": 3235758682.57
      },
      {
        "periodo": 202605,
        "valor": 3896392666.0,
        "delta": -1316318033.98
      },
      {
        "periodo": 202606,
        "valor": 4703764397.38,
        "delta": 807371731.38
      },
      {
        "periodo": 202607,
        "valor": 3541576944.98,
        "delta": -1162187452.4
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 180738478.0,
    "valor_anterior": 91421786.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 139653058.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 137298924.0,
        "delta": -2354134.0
      },
      {
        "periodo": 202509,
        "valor": 38244168.0,
        "delta": -99054756.0
      },
      {
        "periodo": 202510,
        "valor": 261510655.0,
        "delta": 223266487.0
      },
      {
        "periodo": 202511,
        "valor": -88958013.0,
        "delta": -350468668.0
      },
      {
        "periodo": 202512,
        "valor": 237375090.0,
        "delta": 326333103.0
      },
      {
        "periodo": 202601,
        "valor": 257621462.0,
        "delta": 20246372.0
      },
      {
        "periodo": 202602,
        "valor": 187518266.0,
        "delta": -70103196.0
      },
      {
        "periodo": 202603,
        "valor": 243130587.0,
        "delta": 55612321.0
      },
      {
        "periodo": 202604,
        "valor": 336060625.0,
        "delta": 92930038.0
      },
      {
        "periodo": 202605,
        "valor": -20611296.0,
        "delta": -356671921.0
      },
      {
        "periodo": 202606,
        "valor": 91421786.0,
        "delta": 112033082.0
      },
      {
        "periodo": 202607,
        "valor": 180738478.0,
        "delta": 89316692.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 70372710.0,
    "valor_anterior": 14411849.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 94231089.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 101361651.0,
        "delta": 7130562.0
      },
      {
        "periodo": 202509,
        "valor": 100355670.0,
        "delta": -1005981.0
      },
      {
        "periodo": 202510,
        "valor": 62038769.0,
        "delta": -38316901.0
      },
      {
        "periodo": 202511,
        "valor": 88021917.0,
        "delta": 25983148.0
      },
      {
        "periodo": 202512,
        "valor": 80609575.0,
        "delta": -7412342.0
      },
      {
        "periodo": 202601,
        "valor": 58549642.0,
        "delta": -22059933.0
      },
      {
        "periodo": 202602,
        "valor": 20317304.0,
        "delta": -38232338.0
      },
      {
        "periodo": 202603,
        "valor": 31698103.0,
        "delta": 11380799.0
      },
      {
        "periodo": 202604,
        "valor": 82348216.0,
        "delta": 50650113.0
      },
      {
        "periodo": 202605,
        "valor": 61504285.0,
        "delta": -20843931.0
      },
      {
        "periodo": 202606,
        "valor": 14411849.0,
        "delta": -47092436.0
      },
      {
        "periodo": 202607,
        "valor": 70372710.0,
        "delta": 55960861.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 263857936.0,
    "valor_anterior": 244411820.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 313307077.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 666129380.0,
        "delta": 352822303.0
      },
      {
        "periodo": 202509,
        "valor": 608378548.0,
        "delta": -57750832.0
      },
      {
        "periodo": 202510,
        "valor": 408260947.0,
        "delta": -200117601.0
      },
      {
        "periodo": 202511,
        "valor": 279936085.0,
        "delta": -128324862.0
      },
      {
        "periodo": 202512,
        "valor": 251083627.0,
        "delta": -28852458.0
      },
      {
        "periodo": 202601,
        "valor": 221097441.0,
        "delta": -29986186.0
      },
      {
        "periodo": 202602,
        "valor": 391377390.0,
        "delta": 170279949.0
      },
      {
        "periodo": 202603,
        "valor": 359282558.0,
        "delta": -32094832.0
      },
      {
        "periodo": 202604,
        "valor": 237219574.0,
        "delta": -122062984.0
      },
      {
        "periodo": 202605,
        "valor": 287343184.0,
        "delta": 50123610.0
      },
      {
        "periodo": 202606,
        "valor": 244411820.0,
        "delta": -42931364.0
      },
      {
        "periodo": 202607,
        "valor": 263857936.0,
        "delta": 19446116.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 316455534.8900001,
    "valor_anterior": 361774257.79999995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 240953071.71,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 339325507.79,
        "delta": 98372436.08
      },
      {
        "periodo": 202509,
        "valor": 350115311.43,
        "delta": 10789803.64
      },
      {
        "periodo": 202510,
        "valor": 399320580.2,
        "delta": 49205268.77
      },
      {
        "periodo": 202511,
        "valor": 229189467.43,
        "delta": -170131112.77
      },
      {
        "periodo": 202512,
        "valor": 428296248.83,
        "delta": 199106781.4
      },
      {
        "periodo": 202601,
        "valor": 404045788.04,
        "delta": -24250460.79
      },
      {
        "periodo": 202602,
        "valor": 270330897.11,
        "delta": -133714890.93
      },
      {
        "periodo": 202603,
        "valor": 27962040.02,
        "delta": -242368857.09
      },
      {
        "periodo": 202604,
        "valor": 175996441.86,
        "delta": 148034401.84
      },
      {
        "periodo": 202605,
        "valor": 346016613.99,
        "delta": 170020172.13
      },
      {
        "periodo": 202606,
        "valor": 361774257.8,
        "delta": 15757643.81
      },
      {
        "periodo": 202607,
        "valor": 316455534.89,
        "delta": -45318722.91
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 79041906.0,
    "valor_anterior": 128566220.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 86211684.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 49557702.0,
        "delta": -36653982.0
      },
      {
        "periodo": 202509,
        "valor": 116227643.0,
        "delta": 66669941.0
      },
      {
        "periodo": 202510,
        "valor": 43250751.0,
        "delta": -72976892.0
      },
      {
        "periodo": 202511,
        "valor": 81163294.0,
        "delta": 37912543.0
      },
      {
        "periodo": 202512,
        "valor": 115626163.0,
        "delta": 34462869.0
      },
      {
        "periodo": 202601,
        "valor": 87948808.0,
        "delta": -27677355.0
      },
      {
        "periodo": 202602,
        "valor": 21426762.0,
        "delta": -66522046.0
      },
      {
        "periodo": 202603,
        "valor": 180550391.0,
        "delta": 159123629.0
      },
      {
        "periodo": 202604,
        "valor": 123907873.0,
        "delta": -56642518.0
      },
      {
        "periodo": 202605,
        "valor": 76031918.0,
        "delta": -47875955.0
      },
      {
        "periodo": 202606,
        "valor": 128566220.0,
        "delta": 52534302.0
      },
      {
        "periodo": 202607,
        "valor": 79041906.0,
        "delta": -49524314.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 460398250.2100005,
    "valor_anterior": 451670889.15999985,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 640818834.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1513011015.96,
        "delta": 872192181.22
      },
      {
        "periodo": 202509,
        "valor": 849302405.08,
        "delta": -663708610.88
      },
      {
        "periodo": 202510,
        "valor": 976054060.04,
        "delta": 126751654.96
      },
      {
        "periodo": 202511,
        "valor": 417991634.01,
        "delta": -558062426.03
      },
      {
        "periodo": 202512,
        "valor": 1509277181.65,
        "delta": 1091285547.64
      },
      {
        "periodo": 202601,
        "valor": 1268533740.84,
        "delta": -240743440.81
      },
      {
        "periodo": 202602,
        "valor": 885395019.01,
        "delta": -383138721.83
      },
      {
        "periodo": 202603,
        "valor": -720998354.74,
        "delta": -1606393373.75
      },
      {
        "periodo": 202604,
        "valor": 1319320921.43,
        "delta": 2040319276.17
      },
      {
        "periodo": 202605,
        "valor": 1027327030.48,
        "delta": -291993890.95
      },
      {
        "periodo": 202606,
        "valor": 451670889.16,
        "delta": -575656141.32
      },
      {
        "periodo": 202607,
        "valor": 460398250.21,
        "delta": 8727361.05
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": -1481859.0,
    "valor_anterior": 5268130.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -12618376.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -13391855.0,
        "delta": -773479.0
      },
      {
        "periodo": 202509,
        "valor": -10441984.0,
        "delta": 2949871.0
      },
      {
        "periodo": 202510,
        "valor": 9121593.0,
        "delta": 19563577.0
      },
      {
        "periodo": 202511,
        "valor": -21466065.0,
        "delta": -30587658.0
      },
      {
        "periodo": 202512,
        "valor": -30122374.0,
        "delta": -8656309.0
      },
      {
        "periodo": 202601,
        "valor": 5278601.0,
        "delta": 35400975.0
      },
      {
        "periodo": 202602,
        "valor": 502160.0,
        "delta": -4776441.0
      },
      {
        "periodo": 202603,
        "valor": -2784645.0,
        "delta": -3286805.0
      },
      {
        "periodo": 202604,
        "valor": 4952888.0,
        "delta": 7737533.0
      },
      {
        "periodo": 202605,
        "valor": 145395.0,
        "delta": -4807493.0
      },
      {
        "periodo": 202606,
        "valor": 5268130.0,
        "delta": 5122735.0
      },
      {
        "periodo": 202607,
        "valor": -1481859.0,
        "delta": -6749989.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": -337754290.88,
    "valor_anterior": -967694970.0600002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 332409124.28,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 478540566.46,
        "delta": 146131442.18
      },
      {
        "periodo": 202509,
        "valor": 400849560.52,
        "delta": -77691005.94
      },
      {
        "periodo": 202510,
        "valor": 980362481.48,
        "delta": 579512920.96
      },
      {
        "periodo": 202511,
        "valor": 605874895.03,
        "delta": -374487586.45
      },
      {
        "periodo": 202512,
        "valor": 1009665809.07,
        "delta": 403790914.04
      },
      {
        "periodo": 202601,
        "valor": 564954280.71,
        "delta": -444711528.36
      },
      {
        "periodo": 202602,
        "valor": 534323074.38,
        "delta": -30631206.33
      },
      {
        "periodo": 202603,
        "valor": 706799500.14,
        "delta": 172476425.76
      },
      {
        "periodo": 202604,
        "valor": 326549867.69,
        "delta": -380249632.45
      },
      {
        "periodo": 202605,
        "valor": -732546087.03,
        "delta": -1059095954.72
      },
      {
        "periodo": 202606,
        "valor": -967694970.06,
        "delta": -235148883.03
      },
      {
        "periodo": 202607,
        "valor": -337754290.88,
        "delta": 629940679.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 215854947.0,
    "valor_anterior": 90478329.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25130073.99,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55121844.95,
        "delta": 29991770.96
      },
      {
        "periodo": 202509,
        "valor": 297665115.03,
        "delta": 242543270.08
      },
      {
        "periodo": 202510,
        "valor": 97851802.0,
        "delta": -199813313.03
      },
      {
        "periodo": 202511,
        "valor": -18793948.0,
        "delta": -116645750.0
      },
      {
        "periodo": 202512,
        "valor": 167576813.0,
        "delta": 186370761.0
      },
      {
        "periodo": 202601,
        "valor": 157136337.0,
        "delta": -10440476.0
      },
      {
        "periodo": 202602,
        "valor": 128304008.0,
        "delta": -28832329.0
      },
      {
        "periodo": 202603,
        "valor": 247830112.0,
        "delta": 119526104.0
      },
      {
        "periodo": 202604,
        "valor": 120730052.0,
        "delta": -127100060.0
      },
      {
        "periodo": 202605,
        "valor": 113516388.0,
        "delta": -7213664.0
      },
      {
        "periodo": 202606,
        "valor": 90478329.0,
        "delta": -23038059.0
      },
      {
        "periodo": 202607,
        "valor": 215854947.0,
        "delta": 125376618.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": -6619837.0,
    "valor_anterior": 11729484.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 237494240.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -48438678.0,
        "delta": -285932918.0
      },
      {
        "periodo": 202509,
        "valor": 78081916.0,
        "delta": 126520594.0
      },
      {
        "periodo": 202510,
        "valor": 56242236.0,
        "delta": -21839680.0
      },
      {
        "periodo": 202511,
        "valor": 39822160.0,
        "delta": -16420076.0
      },
      {
        "periodo": 202512,
        "valor": -42922893.0,
        "delta": -82745053.0
      },
      {
        "periodo": 202601,
        "valor": 63154677.0,
        "delta": 106077570.0
      },
      {
        "periodo": 202602,
        "valor": 107229425.0,
        "delta": 44074748.0
      },
      {
        "periodo": 202603,
        "valor": 28042085.0,
        "delta": -79187340.0
      },
      {
        "periodo": 202604,
        "valor": 59861214.0,
        "delta": 31819129.0
      },
      {
        "periodo": 202605,
        "valor": 67831883.0,
        "delta": 7970669.0
      },
      {
        "periodo": 202606,
        "valor": 11729484.0,
        "delta": -56102399.0
      },
      {
        "periodo": 202607,
        "valor": -6619837.0,
        "delta": -18349321.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 457588293.0,
    "valor_anterior": 610656712.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 441982645.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 506101810.0,
        "delta": 64119165.0
      },
      {
        "periodo": 202509,
        "valor": 504845909.0,
        "delta": -1255901.0
      },
      {
        "periodo": 202510,
        "valor": 428759168.0,
        "delta": -76086741.0
      },
      {
        "periodo": 202511,
        "valor": 451077072.0,
        "delta": 22317904.0
      },
      {
        "periodo": 202512,
        "valor": 338867117.0,
        "delta": -112209955.0
      },
      {
        "periodo": 202601,
        "valor": 622276393.0,
        "delta": 283409276.0
      },
      {
        "periodo": 202602,
        "valor": 531864487.0,
        "delta": -90411906.0
      },
      {
        "periodo": 202603,
        "valor": 501323737.0,
        "delta": -30540750.0
      },
      {
        "periodo": 202604,
        "valor": 339592574.0,
        "delta": -161731163.0
      },
      {
        "periodo": 202605,
        "valor": 528999265.0,
        "delta": 189406691.0
      },
      {
        "periodo": 202606,
        "valor": 610656712.0,
        "delta": 81657447.0
      },
      {
        "periodo": 202607,
        "valor": 457588293.0,
        "delta": -153068419.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 182988186.0,
    "valor_anterior": 230767190.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 88055283.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 102562297.0,
        "delta": 14507014.0
      },
      {
        "periodo": 202509,
        "valor": 106330626.0,
        "delta": 3768329.0
      },
      {
        "periodo": 202510,
        "valor": 237026482.0,
        "delta": 130695856.0
      },
      {
        "periodo": 202511,
        "valor": 151838523.0,
        "delta": -85187959.0
      },
      {
        "periodo": 202512,
        "valor": 92900330.0,
        "delta": -58938193.0
      },
      {
        "periodo": 202601,
        "valor": 119607562.0,
        "delta": 26707232.0
      },
      {
        "periodo": 202602,
        "valor": 91184462.0,
        "delta": -28423100.0
      },
      {
        "periodo": 202603,
        "valor": 112694588.0,
        "delta": 21510126.0
      },
      {
        "periodo": 202604,
        "valor": 139874097.0,
        "delta": 27179509.0
      },
      {
        "periodo": 202605,
        "valor": 161171042.0,
        "delta": 21296945.0
      },
      {
        "periodo": 202606,
        "valor": 230767190.0,
        "delta": 69596148.0
      },
      {
        "periodo": 202607,
        "valor": 182988186.0,
        "delta": -47779004.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 32695701.0,
    "valor_anterior": -21218424.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 39420072.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -559707.0,
        "delta": -39979779.0
      },
      {
        "periodo": 202509,
        "valor": 90527251.0,
        "delta": 91086958.0
      },
      {
        "periodo": 202510,
        "valor": 61661728.0,
        "delta": -28865523.0
      },
      {
        "periodo": 202511,
        "valor": -16049295.0,
        "delta": -77711023.0
      },
      {
        "periodo": 202512,
        "valor": 55410278.0,
        "delta": 71459573.0
      },
      {
        "periodo": 202601,
        "valor": -9675391.0,
        "delta": -65085669.0
      },
      {
        "periodo": 202602,
        "valor": 24383110.0,
        "delta": 34058501.0
      },
      {
        "periodo": 202603,
        "valor": 20522641.0,
        "delta": -3860469.0
      },
      {
        "periodo": 202604,
        "valor": 36680578.0,
        "delta": 16157937.0
      },
      {
        "periodo": 202605,
        "valor": 88919499.0,
        "delta": 52238921.0
      },
      {
        "periodo": 202606,
        "valor": -21218424.0,
        "delta": -110137923.0
      },
      {
        "periodo": 202607,
        "valor": 32695701.0,
        "delta": 53914125.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": -160889672.0,
    "valor_anterior": -466704065.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -242976776.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -163262511.0,
        "delta": 79714265.0
      },
      {
        "periodo": 202509,
        "valor": -188382016.0,
        "delta": -25119505.0
      },
      {
        "periodo": 202510,
        "valor": -93987246.0,
        "delta": 94394770.0
      },
      {
        "periodo": 202511,
        "valor": 79023523.0,
        "delta": 173010769.0
      },
      {
        "periodo": 202512,
        "valor": -115866998.0,
        "delta": -194890521.0
      },
      {
        "periodo": 202601,
        "valor": 38221811.0,
        "delta": 154088809.0
      },
      {
        "periodo": 202602,
        "valor": 65623328.0,
        "delta": 27401517.0
      },
      {
        "periodo": 202603,
        "valor": 11176069.0,
        "delta": -54447259.0
      },
      {
        "periodo": 202604,
        "valor": -9183422.0,
        "delta": -20359491.0
      },
      {
        "periodo": 202605,
        "valor": -24202479.0,
        "delta": -15019057.0
      },
      {
        "periodo": 202606,
        "valor": -466704065.0,
        "delta": -442501586.0
      },
      {
        "periodo": 202607,
        "valor": -160889672.0,
        "delta": 305814393.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 74176869.3499999,
    "valor_anterior": 685051892.9000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 76978720.8,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 600048533.05,
        "delta": 523069812.25
      },
      {
        "periodo": 202509,
        "valor": 518845031.0,
        "delta": -81203502.05
      },
      {
        "periodo": 202510,
        "valor": 241238327.77,
        "delta": -277606703.23
      },
      {
        "periodo": 202511,
        "valor": 87077977.25,
        "delta": -154160350.52
      },
      {
        "periodo": 202512,
        "valor": -194734097.17,
        "delta": -281812074.42
      },
      {
        "periodo": 202601,
        "valor": 306803667.76,
        "delta": 501537764.93
      },
      {
        "periodo": 202602,
        "valor": 612519538.58,
        "delta": 305715870.82
      },
      {
        "periodo": 202603,
        "valor": -1039246742.53,
        "delta": -1651766281.11
      },
      {
        "periodo": 202604,
        "valor": 400526003.45,
        "delta": 1439772745.98
      },
      {
        "periodo": 202605,
        "valor": 378278827.23,
        "delta": -22247176.22
      },
      {
        "periodo": 202606,
        "valor": 685051892.9,
        "delta": 306773065.67
      },
      {
        "periodo": 202607,
        "valor": 74176869.35,
        "delta": -610875023.55
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": -79381990.0,
    "valor_anterior": -82605768.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -134372887.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -89277970.0,
        "delta": 45094917.0
      },
      {
        "periodo": 202509,
        "valor": -90330531.0,
        "delta": -1052561.0
      },
      {
        "periodo": 202510,
        "valor": -108331941.0,
        "delta": -18001410.0
      },
      {
        "periodo": 202511,
        "valor": -135847153.0,
        "delta": -27515212.0
      },
      {
        "periodo": 202512,
        "valor": -105813265.0,
        "delta": 30033888.0
      },
      {
        "periodo": 202601,
        "valor": -85495015.0,
        "delta": 20318250.0
      },
      {
        "periodo": 202602,
        "valor": -107426347.0,
        "delta": -21931332.0
      },
      {
        "periodo": 202603,
        "valor": -134095258.0,
        "delta": -26668911.0
      },
      {
        "periodo": 202604,
        "valor": -89344100.0,
        "delta": 44751158.0
      },
      {
        "periodo": 202605,
        "valor": -72292577.0,
        "delta": 17051523.0
      },
      {
        "periodo": 202606,
        "valor": -82605768.0,
        "delta": -10313191.0
      },
      {
        "periodo": 202607,
        "valor": -79381990.0,
        "delta": 3223778.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 4212094.0,
    "valor_anterior": 6036089.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4095729.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10004958.0,
        "delta": 5909229.0
      },
      {
        "periodo": 202509,
        "valor": 14364736.0,
        "delta": 4359778.0
      },
      {
        "periodo": 202510,
        "valor": 9117834.0,
        "delta": -5246902.0
      },
      {
        "periodo": 202511,
        "valor": 1322515.0,
        "delta": -7795319.0
      },
      {
        "periodo": 202512,
        "valor": -3914132.0,
        "delta": -5236647.0
      },
      {
        "periodo": 202601,
        "valor": 2751697.0,
        "delta": 6665829.0
      },
      {
        "periodo": 202602,
        "valor": 4020751.0,
        "delta": 1269054.0
      },
      {
        "periodo": 202603,
        "valor": 7862809.0,
        "delta": 3842058.0
      },
      {
        "periodo": 202604,
        "valor": 6327076.0,
        "delta": -1535733.0
      },
      {
        "periodo": 202605,
        "valor": 8852345.0,
        "delta": 2525269.0
      },
      {
        "periodo": 202606,
        "valor": 6036089.0,
        "delta": -2816256.0
      },
      {
        "periodo": 202607,
        "valor": 4212094.0,
        "delta": -1823995.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 45563240.0,
    "valor_anterior": 127368368.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 113609158.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 118083825.0,
        "delta": 4474667.0
      },
      {
        "periodo": 202509,
        "valor": 124985487.0,
        "delta": 6901662.0
      },
      {
        "periodo": 202510,
        "valor": 102581383.0,
        "delta": -22404104.0
      },
      {
        "periodo": 202511,
        "valor": 153095795.0,
        "delta": 50514412.0
      },
      {
        "periodo": 202512,
        "valor": 84909109.0,
        "delta": -68186686.0
      },
      {
        "periodo": 202601,
        "valor": 100899926.0,
        "delta": 15990817.0
      },
      {
        "periodo": 202602,
        "valor": 141254339.0,
        "delta": 40354413.0
      },
      {
        "periodo": 202603,
        "valor": 142934100.0,
        "delta": 1679761.0
      },
      {
        "periodo": 202604,
        "valor": 137600467.0,
        "delta": -5333633.0
      },
      {
        "periodo": 202605,
        "valor": 111319246.0,
        "delta": -26281221.0
      },
      {
        "periodo": 202606,
        "valor": 127368368.0,
        "delta": 16049122.0
      },
      {
        "periodo": 202607,
        "valor": 45563240.0,
        "delta": -81805128.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 44753558.0,
    "valor_anterior": 66265087.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 63070640.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21310337.0,
        "delta": -41760303.0
      },
      {
        "periodo": 202509,
        "valor": 49928257.0,
        "delta": 28617920.0
      },
      {
        "periodo": 202510,
        "valor": -4829792.0,
        "delta": -54758049.0
      },
      {
        "periodo": 202511,
        "valor": 5505596.0,
        "delta": 10335388.0
      },
      {
        "periodo": 202512,
        "valor": 54431871.0,
        "delta": 48926275.0
      },
      {
        "periodo": 202601,
        "valor": 22268413.0,
        "delta": -32163458.0
      },
      {
        "periodo": 202602,
        "valor": 68718942.0,
        "delta": 46450529.0
      },
      {
        "periodo": 202603,
        "valor": 56173210.0,
        "delta": -12545732.0
      },
      {
        "periodo": 202604,
        "valor": -4947772.0,
        "delta": -61120982.0
      },
      {
        "periodo": 202605,
        "valor": 8379356.0,
        "delta": 13327128.0
      },
      {
        "periodo": 202606,
        "valor": 66265087.0,
        "delta": 57885731.0
      },
      {
        "periodo": 202607,
        "valor": 44753558.0,
        "delta": -21511529.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 119490773.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -871307367.0,
        "delta": -990798140.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 148643849.0,
    "valor_anterior": 137559769.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 107339029.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 155551865.0,
        "delta": 48212836.0
      },
      {
        "periodo": 202509,
        "valor": 119757325.0,
        "delta": -35794540.0
      },
      {
        "periodo": 202510,
        "valor": 194115687.0,
        "delta": 74358362.0
      },
      {
        "periodo": 202511,
        "valor": 77079884.0,
        "delta": -117035803.0
      },
      {
        "periodo": 202512,
        "valor": 308355335.0,
        "delta": 231275451.0
      },
      {
        "periodo": 202601,
        "valor": 98110759.0,
        "delta": -210244576.0
      },
      {
        "periodo": 202602,
        "valor": 113446751.0,
        "delta": 15335992.0
      },
      {
        "periodo": 202603,
        "valor": 166343462.0,
        "delta": 52896711.0
      },
      {
        "periodo": 202604,
        "valor": 156241447.0,
        "delta": -10102015.0
      },
      {
        "periodo": 202605,
        "valor": 129277896.0,
        "delta": -26963551.0
      },
      {
        "periodo": 202606,
        "valor": 137559769.0,
        "delta": 8281873.0
      },
      {
        "periodo": 202607,
        "valor": 148643849.0,
        "delta": 11084080.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": -72936388.0,
    "valor_anterior": 182168916.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12464901.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 60010052.0,
        "delta": 47545151.0
      },
      {
        "periodo": 202509,
        "valor": -15154860.0,
        "delta": -75164912.0
      },
      {
        "periodo": 202510,
        "valor": -16819170.0,
        "delta": -1664310.0
      },
      {
        "periodo": 202511,
        "valor": -38088182.0,
        "delta": -21269012.0
      },
      {
        "periodo": 202512,
        "valor": 78940203.0,
        "delta": 117028385.0
      },
      {
        "periodo": 202601,
        "valor": 6560343.0,
        "delta": -72379860.0
      },
      {
        "periodo": 202602,
        "valor": -9170593.0,
        "delta": -15730936.0
      },
      {
        "periodo": 202603,
        "valor": 15408196.0,
        "delta": 24578789.0
      },
      {
        "periodo": 202604,
        "valor": -125884521.0,
        "delta": -141292717.0
      },
      {
        "periodo": 202605,
        "valor": -42132479.0,
        "delta": 83752042.0
      },
      {
        "periodo": 202606,
        "valor": 182168916.0,
        "delta": 224301395.0
      },
      {
        "periodo": 202607,
        "valor": -72936388.0,
        "delta": -255105304.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 3585915.0,
    "valor_anterior": 1999842.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -6331452.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -8814540.0,
        "delta": -2483088.0
      },
      {
        "periodo": 202509,
        "valor": -4929790.0,
        "delta": 3884750.0
      },
      {
        "periodo": 202510,
        "valor": -6800463.0,
        "delta": -1870673.0
      },
      {
        "periodo": 202511,
        "valor": 12222225.0,
        "delta": 19022688.0
      },
      {
        "periodo": 202512,
        "valor": 4963514.0,
        "delta": -7258711.0
      },
      {
        "periodo": 202601,
        "valor": -6697490.0,
        "delta": -11661004.0
      },
      {
        "periodo": 202602,
        "valor": 798398.0,
        "delta": 7495888.0
      },
      {
        "periodo": 202603,
        "valor": 754580.0,
        "delta": -43818.0
      },
      {
        "periodo": 202604,
        "valor": -3856228.0,
        "delta": -4610808.0
      },
      {
        "periodo": 202605,
        "valor": 2094074.0,
        "delta": 5950302.0
      },
      {
        "periodo": 202606,
        "valor": 1999842.0,
        "delta": -94232.0
      },
      {
        "periodo": 202607,
        "valor": 3585915.0,
        "delta": 1586073.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": -9410401.0,
    "valor_anterior": -10331901.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -4807297.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -6378901.0,
        "delta": -1571604.0
      },
      {
        "periodo": 202509,
        "valor": -1032672.0,
        "delta": 5346229.0
      },
      {
        "periodo": 202510,
        "valor": -5979215.0,
        "delta": -4946543.0
      },
      {
        "periodo": 202511,
        "valor": -4343582.0,
        "delta": 1635633.0
      },
      {
        "periodo": 202512,
        "valor": -11607348.0,
        "delta": -7263766.0
      },
      {
        "periodo": 202601,
        "valor": -4002392.0,
        "delta": 7604956.0
      },
      {
        "periodo": 202602,
        "valor": -4959804.0,
        "delta": -957412.0
      },
      {
        "periodo": 202603,
        "valor": -6782583.0,
        "delta": -1822779.0
      },
      {
        "periodo": 202604,
        "valor": -4783051.0,
        "delta": 1999532.0
      },
      {
        "periodo": 202605,
        "valor": -8909606.0,
        "delta": -4126555.0
      },
      {
        "periodo": 202606,
        "valor": -10331901.0,
        "delta": -1422295.0
      },
      {
        "periodo": 202607,
        "valor": -9410401.0,
        "delta": 921500.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 10080970.030000001,
    "valor_anterior": 12113900.780000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2578954.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2173981.58,
        "delta": -404973.29
      },
      {
        "periodo": 202509,
        "valor": 15701145.25,
        "delta": 13527163.67
      },
      {
        "periodo": 202510,
        "valor": 10031569.38,
        "delta": -5669575.87
      },
      {
        "periodo": 202511,
        "valor": 10163537.85,
        "delta": 131968.47
      },
      {
        "periodo": 202512,
        "valor": 22164715.86,
        "delta": 12001178.01
      },
      {
        "periodo": 202601,
        "valor": 16575629.42,
        "delta": -5589086.44
      },
      {
        "periodo": 202602,
        "valor": 9259371.02,
        "delta": -7316258.4
      },
      {
        "periodo": 202603,
        "valor": 5383332.97,
        "delta": -3876038.05
      },
      {
        "periodo": 202604,
        "valor": 8406525.75,
        "delta": 3023192.78
      },
      {
        "periodo": 202605,
        "valor": 8081621.14,
        "delta": -324904.61
      },
      {
        "periodo": 202606,
        "valor": 12113900.78,
        "delta": 4032279.64
      },
      {
        "periodo": 202607,
        "valor": 10080970.03,
        "delta": -2032930.75
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 270753.0,
    "valor_anterior": 777868.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -12020192.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -7906293.0,
        "delta": 4113899.0
      },
      {
        "periodo": 202509,
        "valor": -9713799.0,
        "delta": -1807506.0
      },
      {
        "periodo": 202510,
        "valor": -8122825.0,
        "delta": 1590974.0
      },
      {
        "periodo": 202511,
        "valor": -9886320.0,
        "delta": -1763495.0
      },
      {
        "periodo": 202512,
        "valor": 1653473.0,
        "delta": 11539793.0
      },
      {
        "periodo": 202601,
        "valor": 358185.0,
        "delta": -1295288.0
      },
      {
        "periodo": 202602,
        "valor": 339756.0,
        "delta": -18429.0
      },
      {
        "periodo": 202603,
        "valor": 363425.0,
        "delta": 23669.0
      },
      {
        "periodo": 202604,
        "valor": 384526.0,
        "delta": 21101.0
      },
      {
        "periodo": 202605,
        "valor": 314635.0,
        "delta": -69891.0
      },
      {
        "periodo": 202606,
        "valor": 777868.0,
        "delta": 463233.0
      },
      {
        "periodo": 202607,
        "valor": 270753.0,
        "delta": -507115.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 106792634.11000001,
    "valor_anterior": 64326111.26999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 110139995.34,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 103442059.51,
        "delta": -6697935.83
      },
      {
        "periodo": 202509,
        "valor": 32598589.82,
        "delta": -70843469.69
      },
      {
        "periodo": 202510,
        "valor": 149979127.63,
        "delta": 117380537.81
      },
      {
        "periodo": 202511,
        "valor": 100516643.67,
        "delta": -49462483.96
      },
      {
        "periodo": 202512,
        "valor": 115503246.11,
        "delta": 14986602.44
      },
      {
        "periodo": 202601,
        "valor": 102224274.39,
        "delta": -13278971.72
      },
      {
        "periodo": 202602,
        "valor": 74042953.92,
        "delta": -28181320.47
      },
      {
        "periodo": 202603,
        "valor": 25869214.54,
        "delta": -48173739.38
      },
      {
        "periodo": 202604,
        "valor": 110172026.39,
        "delta": 84302811.85
      },
      {
        "periodo": 202605,
        "valor": 119830266.98,
        "delta": 9658240.59
      },
      {
        "periodo": 202606,
        "valor": 64326111.27,
        "delta": -55504155.71
      },
      {
        "periodo": 202607,
        "valor": 106792634.11,
        "delta": 42466522.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 34610469.7,
    "valor_anterior": 23876078.840000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 29957093.54,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11663517.9,
        "delta": -18293575.64
      },
      {
        "periodo": 202509,
        "valor": 4301358.29,
        "delta": -7362159.61
      },
      {
        "periodo": 202510,
        "valor": 13652074.84,
        "delta": 9350716.55
      },
      {
        "periodo": 202511,
        "valor": 16091619.89,
        "delta": 2439545.05
      },
      {
        "periodo": 202512,
        "valor": -7133351.13,
        "delta": -23224971.02
      },
      {
        "periodo": 202601,
        "valor": 17609006.63,
        "delta": 24742357.76
      },
      {
        "periodo": 202602,
        "valor": 19860834.12,
        "delta": 2251827.49
      },
      {
        "periodo": 202603,
        "valor": 13642633.92,
        "delta": -6218200.2
      },
      {
        "periodo": 202604,
        "valor": 12442259.38,
        "delta": -1200374.54
      },
      {
        "periodo": 202605,
        "valor": 18469972.53,
        "delta": 6027713.15
      },
      {
        "periodo": 202606,
        "valor": 23876078.84,
        "delta": 5406106.31
      },
      {
        "periodo": 202607,
        "valor": 34610469.7,
        "delta": 10734390.86
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": -9397123.0,
    "valor_anterior": 16422639.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22008241.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28182127.0,
        "delta": 6173886.0
      },
      {
        "periodo": 202509,
        "valor": 31456323.0,
        "delta": 3274196.0
      },
      {
        "periodo": 202510,
        "valor": 29170650.0,
        "delta": -2285673.0
      },
      {
        "periodo": 202511,
        "valor": 20918745.0,
        "delta": -8251905.0
      },
      {
        "periodo": 202512,
        "valor": 2422923.0,
        "delta": -18495822.0
      },
      {
        "periodo": 202601,
        "valor": 23669922.0,
        "delta": 21246999.0
      },
      {
        "periodo": 202602,
        "valor": 29181563.0,
        "delta": 5511641.0
      },
      {
        "periodo": 202603,
        "valor": 4532401.0,
        "delta": -24649162.0
      },
      {
        "periodo": 202604,
        "valor": -12616344.0,
        "delta": -17148745.0
      },
      {
        "periodo": 202605,
        "valor": 30956283.0,
        "delta": 43572627.0
      },
      {
        "periodo": 202606,
        "valor": 16422639.0,
        "delta": -14533644.0
      },
      {
        "periodo": 202607,
        "valor": -9397123.0,
        "delta": -25819762.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 123365716.0,
    "valor_anterior": 138952879.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 55072662.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 154639238.0,
        "delta": 99566576.0
      },
      {
        "periodo": 202509,
        "valor": 108288942.0,
        "delta": -46350296.0
      },
      {
        "periodo": 202510,
        "valor": 121903655.0,
        "delta": 13614713.0
      },
      {
        "periodo": 202511,
        "valor": 96221133.0,
        "delta": -25682522.0
      },
      {
        "periodo": 202512,
        "valor": 67448402.0,
        "delta": -28772731.0
      },
      {
        "periodo": 202601,
        "valor": 90263152.0,
        "delta": 22814750.0
      },
      {
        "periodo": 202602,
        "valor": 76675621.0,
        "delta": -13587531.0
      },
      {
        "periodo": 202603,
        "valor": 108196824.0,
        "delta": 31521203.0
      },
      {
        "periodo": 202604,
        "valor": 121418592.0,
        "delta": 13221768.0
      },
      {
        "periodo": 202605,
        "valor": 136480457.0,
        "delta": 15061865.0
      },
      {
        "periodo": 202606,
        "valor": 138952879.0,
        "delta": 2472422.0
      },
      {
        "periodo": 202607,
        "valor": 123365716.0,
        "delta": -15587163.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 17615454.0,
    "valor_anterior": 5628092.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2491318.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16669058.0,
        "delta": 14177740.0
      },
      {
        "periodo": 202509,
        "valor": 8325693.0,
        "delta": -8343365.0
      },
      {
        "periodo": 202510,
        "valor": 11594614.0,
        "delta": 3268921.0
      },
      {
        "periodo": 202511,
        "valor": 11029925.0,
        "delta": -564689.0
      },
      {
        "periodo": 202512,
        "valor": 2909706.0,
        "delta": -8120219.0
      },
      {
        "periodo": 202601,
        "valor": 8804336.0,
        "delta": 5894630.0
      },
      {
        "periodo": 202602,
        "valor": 8812564.0,
        "delta": 8228.0
      },
      {
        "periodo": 202603,
        "valor": 13743620.0,
        "delta": 4931056.0
      },
      {
        "periodo": 202604,
        "valor": 9257422.0,
        "delta": -4486198.0
      },
      {
        "periodo": 202605,
        "valor": 12203148.0,
        "delta": 2945726.0
      },
      {
        "periodo": 202606,
        "valor": 5628092.0,
        "delta": -6575056.0
      },
      {
        "periodo": 202607,
        "valor": 17615454.0,
        "delta": 11987362.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 16646734.760000005,
    "valor_anterior": 19562277.11,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30185579.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25631317.65,
        "delta": -4554262.07
      },
      {
        "periodo": 202509,
        "valor": 59269117.2,
        "delta": 33637799.55
      },
      {
        "periodo": 202510,
        "valor": 32439165.32,
        "delta": -26829951.88
      },
      {
        "periodo": 202511,
        "valor": 33654932.43,
        "delta": 1215767.11
      },
      {
        "periodo": 202512,
        "valor": 15913072.95,
        "delta": -17741859.48
      },
      {
        "periodo": 202601,
        "valor": 27835674.9,
        "delta": 11922601.95
      },
      {
        "periodo": 202602,
        "valor": 23920116.38,
        "delta": -3915558.52
      },
      {
        "periodo": 202603,
        "valor": 11791443.27,
        "delta": -12128673.11
      },
      {
        "periodo": 202604,
        "valor": 21512226.34,
        "delta": 9720783.07
      },
      {
        "periodo": 202605,
        "valor": 17149681.61,
        "delta": -4362544.73
      },
      {
        "periodo": 202606,
        "valor": 19562277.11,
        "delta": 2412595.5
      },
      {
        "periodo": 202607,
        "valor": 16646734.76,
        "delta": -2915542.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 6889676.539999999,
    "valor_anterior": 10004298.04,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25457260.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28322598.62,
        "delta": 2865337.9
      },
      {
        "periodo": 202509,
        "valor": 7320453.96,
        "delta": -21002144.66
      },
      {
        "periodo": 202510,
        "valor": 10283121.22,
        "delta": 2962667.26
      },
      {
        "periodo": 202511,
        "valor": -2035108.22,
        "delta": -12318229.44
      },
      {
        "periodo": 202512,
        "valor": 8793353.25,
        "delta": 10828461.47
      },
      {
        "periodo": 202601,
        "valor": 6879981.62,
        "delta": -1913371.63
      },
      {
        "periodo": 202602,
        "valor": -6986306.12,
        "delta": -13866287.74
      },
      {
        "periodo": 202603,
        "valor": 17847791.31,
        "delta": 24834097.43
      },
      {
        "periodo": 202604,
        "valor": 7349781.58,
        "delta": -10498009.73
      },
      {
        "periodo": 202605,
        "valor": 3615885.04,
        "delta": -3733896.54
      },
      {
        "periodo": 202606,
        "valor": 10004298.04,
        "delta": 6388413.0
      },
      {
        "periodo": 202607,
        "valor": 6889676.54,
        "delta": -3114621.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 27892068.0,
    "valor_anterior": 33205739.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30909163.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29196640.0,
        "delta": -1712523.0
      },
      {
        "periodo": 202509,
        "valor": 28309566.0,
        "delta": -887074.0
      },
      {
        "periodo": 202510,
        "valor": 27513602.0,
        "delta": -795964.0
      },
      {
        "periodo": 202511,
        "valor": 30274573.0,
        "delta": 2760971.0
      },
      {
        "periodo": 202512,
        "valor": 16086270.0,
        "delta": -14188303.0
      },
      {
        "periodo": 202601,
        "valor": 26453931.0,
        "delta": 10367661.0
      },
      {
        "periodo": 202602,
        "valor": 24675089.0,
        "delta": -1778842.0
      },
      {
        "periodo": 202603,
        "valor": 27301340.0,
        "delta": 2626251.0
      },
      {
        "periodo": 202604,
        "valor": 26833381.0,
        "delta": -467959.0
      },
      {
        "periodo": 202605,
        "valor": 24735626.0,
        "delta": -2097755.0
      },
      {
        "periodo": 202606,
        "valor": 33205739.0,
        "delta": 8470113.0
      },
      {
        "periodo": 202607,
        "valor": 27892068.0,
        "delta": -5313671.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 2489854.0,
    "valor_anterior": 4308163.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2938158.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4107502.0,
        "delta": 1169344.0
      },
      {
        "periodo": 202509,
        "valor": 4214856.0,
        "delta": 107354.0
      },
      {
        "periodo": 202510,
        "valor": 5775547.0,
        "delta": 1560691.0
      },
      {
        "periodo": 202511,
        "valor": -332213.0,
        "delta": -6107760.0
      },
      {
        "periodo": 202512,
        "valor": 2015152.0,
        "delta": 2347365.0
      },
      {
        "periodo": 202601,
        "valor": 1923823.0,
        "delta": -91329.0
      },
      {
        "periodo": 202602,
        "valor": 3061869.0,
        "delta": 1138046.0
      },
      {
        "periodo": 202603,
        "valor": 6608093.0,
        "delta": 3546224.0
      },
      {
        "periodo": 202604,
        "valor": 1289734.0,
        "delta": -5318359.0
      },
      {
        "periodo": 202605,
        "valor": 6047929.0,
        "delta": 4758195.0
      },
      {
        "periodo": 202606,
        "valor": 4308163.0,
        "delta": -1739766.0
      },
      {
        "periodo": 202607,
        "valor": 2489854.0,
        "delta": -1818309.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": -40638522.0,
    "valor_anterior": 45124213.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13364790.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -319890.0,
        "delta": -13684680.0
      },
      {
        "periodo": 202509,
        "valor": 87418270.0,
        "delta": 87738160.0
      },
      {
        "periodo": 202510,
        "valor": 8560155.0,
        "delta": -78858115.0
      },
      {
        "periodo": 202511,
        "valor": 3918694.0,
        "delta": -4641461.0
      },
      {
        "periodo": 202512,
        "valor": 71007451.0,
        "delta": 67088757.0
      },
      {
        "periodo": 202601,
        "valor": 12659503.0,
        "delta": -58347948.0
      },
      {
        "periodo": 202602,
        "valor": 9243645.0,
        "delta": -3415858.0
      },
      {
        "periodo": 202603,
        "valor": 51081947.0,
        "delta": 41838302.0
      },
      {
        "periodo": 202604,
        "valor": -32102796.0,
        "delta": -83184743.0
      },
      {
        "periodo": 202605,
        "valor": 24955747.0,
        "delta": 57058543.0
      },
      {
        "periodo": 202606,
        "valor": 45124213.0,
        "delta": 20168466.0
      },
      {
        "periodo": 202607,
        "valor": -40638522.0,
        "delta": -85762735.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": -58947396.02999997,
    "valor_anterior": -55058657.639999986,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -76223256.01,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -77709934.19,
        "delta": -1486678.18
      },
      {
        "periodo": 202509,
        "valor": -57733947.76,
        "delta": 19975986.43
      },
      {
        "periodo": 202510,
        "valor": -58956638.86,
        "delta": -1222691.1
      },
      {
        "periodo": 202511,
        "valor": -59164865.52,
        "delta": -208226.66
      },
      {
        "periodo": 202512,
        "valor": -53964291.98,
        "delta": 5200573.54
      },
      {
        "periodo": 202601,
        "valor": -67596889.61,
        "delta": -13632597.63
      },
      {
        "periodo": 202602,
        "valor": -62511261.26,
        "delta": 5085628.35
      },
      {
        "periodo": 202603,
        "valor": -54115994.35,
        "delta": 8395266.91
      },
      {
        "periodo": 202604,
        "valor": -67136806.78,
        "delta": -13020812.43
      },
      {
        "periodo": 202605,
        "valor": -75928125.29,
        "delta": -8791318.51
      },
      {
        "periodo": 202606,
        "valor": -55058657.64,
        "delta": 20869467.65
      },
      {
        "periodo": 202607,
        "valor": -58947396.03,
        "delta": -3888738.39
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 11024668.030000001,
    "valor_anterior": 43292441.39,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2632337.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3276902.54,
        "delta": 644564.85
      },
      {
        "periodo": 202509,
        "valor": 3145838.44,
        "delta": -131064.1
      },
      {
        "periodo": 202510,
        "valor": 1985008.4,
        "delta": -1160830.04
      },
      {
        "periodo": 202511,
        "valor": 3504536.33,
        "delta": 1519527.93
      },
      {
        "periodo": 202512,
        "valor": 4703510.75,
        "delta": 1198974.42
      },
      {
        "periodo": 202601,
        "valor": 5558191.63,
        "delta": 854680.88
      },
      {
        "periodo": 202602,
        "valor": 36961478.57,
        "delta": 31403286.94
      },
      {
        "periodo": 202603,
        "valor": 33116978.54,
        "delta": -3844500.03
      },
      {
        "periodo": 202604,
        "valor": 8134135.98,
        "delta": -24982842.56
      },
      {
        "periodo": 202605,
        "valor": 18976069.36,
        "delta": 10841933.38
      },
      {
        "periodo": 202606,
        "valor": 43292441.39,
        "delta": 24316372.03
      },
      {
        "periodo": 202607,
        "valor": 11024668.03,
        "delta": -32267773.36
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": -221593836.0,
    "valor_anterior": -185962870.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -106734256.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -118378176.0,
        "delta": -11643920.0
      },
      {
        "periodo": 202509,
        "valor": -136999969.0,
        "delta": -18621793.0
      },
      {
        "periodo": 202510,
        "valor": -178218466.0,
        "delta": -41218497.0
      },
      {
        "periodo": 202511,
        "valor": -184606721.0,
        "delta": -6388255.0
      },
      {
        "periodo": 202512,
        "valor": -178981192.0,
        "delta": 5625529.0
      },
      {
        "periodo": 202601,
        "valor": -163291679.0,
        "delta": 15689513.0
      },
      {
        "periodo": 202602,
        "valor": -165342616.0,
        "delta": -2050937.0
      },
      {
        "periodo": 202603,
        "valor": -272811951.0,
        "delta": -107469335.0
      },
      {
        "periodo": 202604,
        "valor": -188534413.0,
        "delta": 84277538.0
      },
      {
        "periodo": 202605,
        "valor": -203558377.0,
        "delta": -15023964.0
      },
      {
        "periodo": 202606,
        "valor": -185962870.0,
        "delta": 17595507.0
      },
      {
        "periodo": 202607,
        "valor": -221593836.0,
        "delta": -35630966.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": -84630053.13000005,
    "valor_anterior": -81549162.82,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": -271040998.9,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": -29046783.95,
        "delta": 241994214.95
      },
      {
        "periodo": 202601,
        "valor": -29978962.0,
        "delta": -932178.05
      },
      {
        "periodo": 202602,
        "valor": -48955160.9,
        "delta": -18976198.9
      },
      {
        "periodo": 202603,
        "valor": -74510286.34,
        "delta": -25555125.44
      },
      {
        "periodo": 202604,
        "valor": -64457896.8,
        "delta": 10052389.54
      },
      {
        "periodo": 202605,
        "valor": -74597452.73,
        "delta": -10139555.93
      },
      {
        "periodo": 202606,
        "valor": -81549162.82,
        "delta": -6951710.09
      },
      {
        "periodo": 202607,
        "valor": -84630053.13,
        "delta": -3080890.31
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": -222600489.0,
    "valor_anterior": -475759690.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": -488269875.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": -135477327.0,
        "delta": 352792548.0
      },
      {
        "periodo": 202605,
        "valor": -232856027.0,
        "delta": -97378700.0
      },
      {
        "periodo": 202606,
        "valor": -475759690.0,
        "delta": -242903663.0
      },
      {
        "periodo": 202607,
        "valor": -222600489.0,
        "delta": 253159201.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 23060556989.630005,
    "valor_anterior": 19510201908.419983,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 24879733483.7,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29211926109.52,
        "delta": 4332192625.82
      },
      {
        "periodo": 202509,
        "valor": 25058595560.65,
        "delta": -4153330548.8701
      },
      {
        "periodo": 202510,
        "valor": 26227050841.42,
        "delta": 1168455280.7701
      },
      {
        "periodo": 202511,
        "valor": 23395502903.04,
        "delta": -2831547938.38
      },
      {
        "periodo": 202512,
        "valor": 16062468807.44,
        "delta": -7333034095.6
      },
      {
        "periodo": 202601,
        "valor": 31141352151.88,
        "delta": 15078883344.44
      },
      {
        "periodo": 202602,
        "valor": 24397184716.91,
        "delta": -6744167434.97
      },
      {
        "periodo": 202603,
        "valor": 21837514047.01,
        "delta": -2559670669.9
      },
      {
        "periodo": 202604,
        "valor": 26515482379.55,
        "delta": 4677968332.54
      },
      {
        "periodo": 202605,
        "valor": 23920979950.78,
        "delta": -2594502428.77
      },
      {
        "periodo": 202606,
        "valor": 19510201908.42,
        "delta": -4410778042.36
      },
      {
        "periodo": 202607,
        "valor": 23060556989.63,
        "delta": 3550355081.21
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 19546659761.770004,
    "valor_anterior": 16201858592.160004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20050170506.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23399184346.55,
        "delta": 3349013839.68
      },
      {
        "periodo": 202509,
        "valor": 18192881883.86,
        "delta": -5206302462.69
      },
      {
        "periodo": 202510,
        "valor": 19683845008.05,
        "delta": 1490963124.19
      },
      {
        "periodo": 202511,
        "valor": 19390740730.66,
        "delta": -293104277.39
      },
      {
        "periodo": 202512,
        "valor": 10741469288.77,
        "delta": -8649271441.89
      },
      {
        "periodo": 202601,
        "valor": 25045689728.82,
        "delta": 14304220440.05
      },
      {
        "periodo": 202602,
        "valor": 18838165417.22,
        "delta": -6207524311.6
      },
      {
        "periodo": 202603,
        "valor": 19577929511.26,
        "delta": 739764094.04
      },
      {
        "periodo": 202604,
        "valor": 20933383138.77,
        "delta": 1355453627.51
      },
      {
        "periodo": 202605,
        "valor": 19745157775.19,
        "delta": -1188225363.58
      },
      {
        "periodo": 202606,
        "valor": 16201858592.16,
        "delta": -3543299183.03
      },
      {
        "periodo": 202607,
        "valor": 19546659761.77,
        "delta": 3344801169.61
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 304209711.8900001,
    "valor_anterior": 32629961.799999952,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 224806097.71,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -539692505.21,
        "delta": -764498602.92
      },
      {
        "periodo": 202509,
        "valor": 850156360.43,
        "delta": 1389848865.64
      },
      {
        "periodo": 202510,
        "valor": 499449021.2,
        "delta": -350707339.23
      },
      {
        "periodo": 202511,
        "valor": 385292874.43,
        "delta": -114156146.77
      },
      {
        "periodo": 202512,
        "valor": 620784585.83,
        "delta": 235491711.4
      },
      {
        "periodo": 202601,
        "valor": 540378358.04,
        "delta": -80406227.79
      },
      {
        "periodo": 202602,
        "valor": 449400976.11,
        "delta": -90977381.93
      },
      {
        "periodo": 202603,
        "valor": 205481571.02,
        "delta": -243919405.09
      },
      {
        "periodo": 202604,
        "valor": 323054466.86,
        "delta": 117572895.84
      },
      {
        "periodo": 202605,
        "valor": 451092030.99,
        "delta": 128037564.13
      },
      {
        "periodo": 202606,
        "valor": 32629961.8,
        "delta": -418462069.19
      },
      {
        "periodo": 202607,
        "valor": 304209711.89,
        "delta": 271579750.09
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 1279331410.209999,
    "valor_anterior": 1157629057.1599998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1741950538.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2508787596.96,
        "delta": 766837058.22
      },
      {
        "periodo": 202509,
        "valor": 2089484681.08,
        "delta": -419302915.88
      },
      {
        "periodo": 202510,
        "valor": 2122184511.04,
        "delta": 32699829.96
      },
      {
        "periodo": 202511,
        "valor": 850746751.01,
        "delta": -1271437760.03
      },
      {
        "periodo": 202512,
        "valor": 1754185438.65,
        "delta": 903438687.64
      },
      {
        "periodo": 202601,
        "valor": 1962241532.84,
        "delta": 208056094.19
      },
      {
        "periodo": 202602,
        "valor": 1673079793.01,
        "delta": -289161739.83
      },
      {
        "periodo": 202603,
        "valor": 421867150.26,
        "delta": -1251212642.75
      },
      {
        "periodo": 202604,
        "valor": 2316373703.43,
        "delta": 1894506553.17
      },
      {
        "periodo": 202605,
        "valor": 1713175495.48,
        "delta": -603198207.95
      },
      {
        "periodo": 202606,
        "valor": 1157629057.16,
        "delta": -555546438.32
      },
      {
        "periodo": 202607,
        "valor": 1279331410.21,
        "delta": 121702353.05
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 1849323286.2800007,
    "valor_anterior": 1931701749.4899998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1759801105.44,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1942963113.15,
        "delta": 183162007.71
      },
      {
        "periodo": 202509,
        "valor": 1947582869.53,
        "delta": 4619756.38
      },
      {
        "periodo": 202510,
        "valor": 2030573293.95,
        "delta": 82990424.42
      },
      {
        "periodo": 202511,
        "valor": 1896595506.13,
        "delta": -133977787.82
      },
      {
        "periodo": 202512,
        "valor": 1442084794.43,
        "delta": -454510711.7
      },
      {
        "periodo": 202601,
        "valor": 1863921841.73,
        "delta": 421837047.3
      },
      {
        "periodo": 202602,
        "valor": 1490943000.88,
        "delta": -372978840.85
      },
      {
        "periodo": 202603,
        "valor": 1762998750.0,
        "delta": 272055749.12
      },
      {
        "periodo": 202604,
        "valor": 1990315622.51,
        "delta": 227316872.51
      },
      {
        "periodo": 202605,
        "valor": 1899798872.28,
        "delta": -90516750.23
      },
      {
        "periodo": 202606,
        "valor": 1931701749.49,
        "delta": 31902877.21
      },
      {
        "periodo": 202607,
        "valor": 1849323286.28,
        "delta": -82378463.21
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": 382862657.1400001,
    "valor_anterior": 430105298.03999996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 260087418.18,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 375788595.21,
        "delta": 115701177.03
      },
      {
        "periodo": 202509,
        "valor": 571656271.55,
        "delta": 195867676.34
      },
      {
        "periodo": 202510,
        "valor": 384056750.39,
        "delta": -187599521.16
      },
      {
        "periodo": 202511,
        "valor": 85147336.62,
        "delta": -298909413.77
      },
      {
        "periodo": 202512,
        "valor": 479700996.04,
        "delta": 394553659.42
      },
      {
        "periodo": 202601,
        "valor": 371229740.96,
        "delta": -108471255.08
      },
      {
        "periodo": 202602,
        "valor": 301722512.32,
        "delta": -69507228.64
      },
      {
        "periodo": 202603,
        "valor": 364626971.01,
        "delta": 62904458.69
      },
      {
        "periodo": 202604,
        "valor": 205289666.44,
        "delta": -159337304.57
      },
      {
        "periodo": 202605,
        "valor": 394198688.3,
        "delta": 188909021.86
      },
      {
        "periodo": 202606,
        "valor": 430105298.04,
        "delta": 35906609.74
      },
      {
        "periodo": 202607,
        "valor": 382862657.14,
        "delta": -47242640.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100014,
    "label": "Resultado Integral",
    "valor_actual": -301829837.65999985,
    "valor_anterior": -243722750.23000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 842917816.76,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1524894962.86,
        "delta": 681977146.1
      },
      {
        "periodo": 202509,
        "valor": 1406833494.2,
        "delta": -118061468.66
      },
      {
        "periodo": 202510,
        "valor": 1506942256.79,
        "delta": 100108762.59
      },
      {
        "periodo": 202511,
        "valor": 786979704.19,
        "delta": -719962552.6
      },
      {
        "periodo": 202512,
        "valor": 1024243703.72,
        "delta": 237263999.53
      },
      {
        "periodo": 202601,
        "valor": 1357890949.49,
        "delta": 333647245.77
      },
      {
        "periodo": 202602,
        "valor": 1643873017.37,
        "delta": 285982067.88
      },
      {
        "periodo": 202603,
        "valor": -495389906.54,
        "delta": -2139262923.91
      },
      {
        "periodo": 202604,
        "valor": 747065781.54,
        "delta": 1242455688.08
      },
      {
        "periodo": 202605,
        "valor": -282442911.46,
        "delta": -1029508693.0
      },
      {
        "periodo": 202606,
        "valor": -243722750.23,
        "delta": 38720161.23
      },
      {
        "periodo": 202607,
        "valor": -301829837.66,
        "delta": -58107087.43
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 806891877548.0701,
    "valor_anterior": 807422311809.34,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 763127058117.12,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 773161296729.55,
        "delta": 10034238612.4301
      },
      {
        "periodo": 202509,
        "valor": 764231241677.32,
        "delta": -8930055052.2301
      },
      {
        "periodo": 202510,
        "valor": 782733254719.67,
        "delta": 18502013042.3501
      },
      {
        "periodo": 202511,
        "valor": 801433897762.6,
        "delta": 18700643042.9299
      },
      {
        "periodo": 202512,
        "valor": 820850021858.45,
        "delta": 19416124095.85
      },
      {
        "periodo": 202601,
        "valor": 803775661122.71,
        "delta": -17074360735.74
      },
      {
        "periodo": 202602,
        "valor": 778483175979.88,
        "delta": -25292485142.83
      },
      {
        "periodo": 202603,
        "valor": 786754608270.22,
        "delta": 8271432290.34
      },
      {
        "periodo": 202604,
        "valor": 799116462621.48,
        "delta": 12361854351.26
      },
      {
        "periodo": 202605,
        "valor": 804629574080.76,
        "delta": 5513111459.28
      },
      {
        "periodo": 202606,
        "valor": 807422311809.34,
        "delta": 2792737728.58
      },
      {
        "periodo": 202607,
        "valor": 806891877548.0701,
        "delta": -530434261.2699
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 2267997763588.81,
    "valor_anterior": 2245310535091.38,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2036733941659.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2053500295043.95,
        "delta": 16766353384.6799
      },
      {
        "periodo": 202509,
        "valor": 2096776805394.22,
        "delta": 43276510350.27
      },
      {
        "periodo": 202510,
        "valor": 2058249187074.07,
        "delta": -38527618320.1499
      },
      {
        "periodo": 202511,
        "valor": 2134206903688.99,
        "delta": 75957716614.9199
      },
      {
        "periodo": 202512,
        "valor": 2202391658229.88,
        "delta": 68184754540.8899
      },
      {
        "periodo": 202601,
        "valor": 2126452652374.21,
        "delta": -75939005855.6699
      },
      {
        "periodo": 202602,
        "valor": 2193113134369.44,
        "delta": 66660481995.23
      },
      {
        "periodo": 202603,
        "valor": 2252525821544.83,
        "delta": 59412687175.3901
      },
      {
        "periodo": 202604,
        "valor": 2253634758982.89,
        "delta": 1108937438.0601
      },
      {
        "periodo": 202605,
        "valor": 2246386528103.74,
        "delta": -7248230879.1499
      },
      {
        "periodo": 202606,
        "valor": 2245310535091.38,
        "delta": -1075993012.3604
      },
      {
        "periodo": 202607,
        "valor": 2267997763588.81,
        "delta": 22687228497.4302
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 1096732393818.0001,
    "valor_anterior": 1124272957143.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1098918513785.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1104934015612.0,
        "delta": 6015501827.0
      },
      {
        "periodo": 202509,
        "valor": 1066511485231.0,
        "delta": -38422530381.0
      },
      {
        "periodo": 202510,
        "valor": 1080420705077.0,
        "delta": 13909219846.0
      },
      {
        "periodo": 202511,
        "valor": 1096231316766.0,
        "delta": 15810611689.0
      },
      {
        "periodo": 202512,
        "valor": 1117056735029.0,
        "delta": 20825418263.0
      },
      {
        "periodo": 202601,
        "valor": 1105136280871.0,
        "delta": -11920454158.0
      },
      {
        "periodo": 202602,
        "valor": 1111155745874.0,
        "delta": 6019465003.0
      },
      {
        "periodo": 202603,
        "valor": 1130635165097.0,
        "delta": 19479419223.0
      },
      {
        "periodo": 202604,
        "valor": 1139524867877.0,
        "delta": 8889702780.0
      },
      {
        "periodo": 202605,
        "valor": 1147384882097.0,
        "delta": 7860014220.0
      },
      {
        "periodo": 202606,
        "valor": 1124272957143.0,
        "delta": -23111924954.0
      },
      {
        "periodo": 202607,
        "valor": 1096732393818.0001,
        "delta": -27540563324.9999
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 526009015425.0,
    "valor_anterior": 531631678568.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 574253190283.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 560878443688.0,
        "delta": -13374746595.0
      },
      {
        "periodo": 202509,
        "valor": 541428008634.0,
        "delta": -19450435054.0
      },
      {
        "periodo": 202510,
        "valor": 572837359121.0,
        "delta": 31409350487.0
      },
      {
        "periodo": 202511,
        "valor": 569252752025.0,
        "delta": -3584607096.0
      },
      {
        "periodo": 202512,
        "valor": 578129204153.0,
        "delta": 8876452128.0
      },
      {
        "periodo": 202601,
        "valor": 550080791998.0,
        "delta": -28048412155.0
      },
      {
        "periodo": 202602,
        "valor": 538911481826.0,
        "delta": -11169310172.0
      },
      {
        "periodo": 202603,
        "valor": 540226892003.0,
        "delta": 1315410177.0
      },
      {
        "periodo": 202604,
        "valor": 514118601990.0,
        "delta": -26108290013.0
      },
      {
        "periodo": 202605,
        "valor": 531086413170.0,
        "delta": 16967811180.0
      },
      {
        "periodo": 202606,
        "valor": 531631678568.0,
        "delta": 545265398.0
      },
      {
        "periodo": 202607,
        "valor": 526009015425.0,
        "delta": -5622663143.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 336789599213.2,
    "valor_anterior": 339553727868.37006,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 310533691289.57,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 316482611150.23,
        "delta": 5948919860.66
      },
      {
        "periodo": 202509,
        "valor": 318804446978.4399,
        "delta": 2321835828.21
      },
      {
        "periodo": 202510,
        "valor": 315340035574.67,
        "delta": -3464411403.77
      },
      {
        "periodo": 202511,
        "valor": 313051603119.91,
        "delta": -2288432454.76
      },
      {
        "periodo": 202512,
        "valor": 326021654384.91,
        "delta": 12970051265.0
      },
      {
        "periodo": 202601,
        "valor": 313959643408.66,
        "delta": -12062010976.25
      },
      {
        "periodo": 202602,
        "valor": 314683049778.74,
        "delta": 723406370.08
      },
      {
        "periodo": 202603,
        "valor": 334773171980.06,
        "delta": 20090122201.32
      },
      {
        "periodo": 202604,
        "valor": 330626479715.43,
        "delta": -4146692264.63
      },
      {
        "periodo": 202605,
        "valor": 332785187951.78,
        "delta": 2158708236.35
      },
      {
        "periodo": 202606,
        "valor": 339553727868.3701,
        "delta": 6768539916.59
      },
      {
        "periodo": 202607,
        "valor": 336789599213.2,
        "delta": -2764128655.17
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 463847376868.0,
    "valor_anterior": 460666572420.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 465217129405.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 466616410218.0,
        "delta": 1399280813.0
      },
      {
        "periodo": 202509,
        "valor": 466402168898.0,
        "delta": -214241320.0
      },
      {
        "periodo": 202510,
        "valor": 454751808835.0,
        "delta": -11650360063.0
      },
      {
        "periodo": 202511,
        "valor": 461456302376.0,
        "delta": 6704493541.0
      },
      {
        "periodo": 202512,
        "valor": 456224253003.0,
        "delta": -5232049373.0
      },
      {
        "periodo": 202601,
        "valor": 455453319466.0,
        "delta": -770933537.0
      },
      {
        "periodo": 202602,
        "valor": 459223815326.0,
        "delta": 3770495860.0
      },
      {
        "periodo": 202603,
        "valor": 462046343179.0,
        "delta": 2822527853.0
      },
      {
        "periodo": 202604,
        "valor": 462650167192.0,
        "delta": 603824013.0
      },
      {
        "periodo": 202605,
        "valor": 458627180109.0,
        "delta": -4022987083.0
      },
      {
        "periodo": 202606,
        "valor": 460666572420.0,
        "delta": 2039392311.0
      },
      {
        "periodo": 202607,
        "valor": 463847376868.0,
        "delta": 3180804448.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 116915649773.0,
    "valor_anterior": 120795316832.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 100213876828.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 103623207710.0,
        "delta": 3409330882.0
      },
      {
        "periodo": 202509,
        "valor": 105294404729.0,
        "delta": 1671197019.0
      },
      {
        "periodo": 202510,
        "valor": 103446415521.0,
        "delta": -1847989208.0
      },
      {
        "periodo": 202511,
        "valor": 106991518935.0,
        "delta": 3545103414.0
      },
      {
        "periodo": 202512,
        "valor": 111778577951.0,
        "delta": 4787059016.0
      },
      {
        "periodo": 202601,
        "valor": 115520228026.0,
        "delta": 3741650075.0
      },
      {
        "periodo": 202602,
        "valor": 117324101273.0,
        "delta": 1803873247.0
      },
      {
        "periodo": 202603,
        "valor": 118795185839.0,
        "delta": 1471084566.0
      },
      {
        "periodo": 202604,
        "valor": 121413544463.0,
        "delta": 2618358624.0
      },
      {
        "periodo": 202605,
        "valor": 120394112882.0,
        "delta": -1019431581.0
      },
      {
        "periodo": 202606,
        "valor": 120795316832.0,
        "delta": 401203950.0
      },
      {
        "periodo": 202607,
        "valor": 116915649773.0,
        "delta": -3879667059.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 592239673626.0,
    "valor_anterior": 590694540487.0001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 589058654254.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 591248136856.0,
        "delta": 2189482602.0
      },
      {
        "periodo": 202509,
        "valor": 589538924666.0,
        "delta": -1709212190.0
      },
      {
        "periodo": 202510,
        "valor": 591035884647.0,
        "delta": 1496959981.0
      },
      {
        "periodo": 202511,
        "valor": 595899905529.0,
        "delta": 4864020882.0
      },
      {
        "periodo": 202512,
        "valor": 576113980690.0,
        "delta": -19785924839.0
      },
      {
        "periodo": 202601,
        "valor": 566424987406.0,
        "delta": -9688993284.0
      },
      {
        "periodo": 202602,
        "valor": 581653574503.0,
        "delta": 15228587097.0
      },
      {
        "periodo": 202603,
        "valor": 570178760378.0,
        "delta": -11474814125.0
      },
      {
        "periodo": 202604,
        "valor": 578019883236.0,
        "delta": 7841122858.0
      },
      {
        "periodo": 202605,
        "valor": 584113217458.0,
        "delta": 6093334222.0
      },
      {
        "periodo": 202606,
        "valor": 590694540487.0001,
        "delta": 6581323029.0001
      },
      {
        "periodo": 202607,
        "valor": 592239673626.0,
        "delta": 1545133138.9999
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 195917287804.19,
    "valor_anterior": 200646164475.65,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 189514898462.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 187213429356.98,
        "delta": -2301469105.84
      },
      {
        "periodo": 202509,
        "valor": 192910495352.68,
        "delta": 5697065995.7
      },
      {
        "periodo": 202510,
        "valor": 188430478625.43,
        "delta": -4480016727.25
      },
      {
        "periodo": 202511,
        "valor": 192770539607.81,
        "delta": 4340060982.38
      },
      {
        "periodo": 202512,
        "valor": 200214176545.27,
        "delta": 7443636937.46
      },
      {
        "periodo": 202601,
        "valor": 190221888260.36,
        "delta": -9992288284.91
      },
      {
        "periodo": 202602,
        "valor": 190778639609.55,
        "delta": 556751349.19
      },
      {
        "periodo": 202603,
        "valor": 196263819520.74,
        "delta": 5485179911.19
      },
      {
        "periodo": 202604,
        "valor": 192261042230.79,
        "delta": -4002777289.95
      },
      {
        "periodo": 202605,
        "valor": 196606280962.23,
        "delta": 4345238731.44
      },
      {
        "periodo": 202606,
        "valor": 200646164475.65,
        "delta": 4039883513.42
      },
      {
        "periodo": 202607,
        "valor": 195917287804.19,
        "delta": -4728876671.46
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 60474410386.0,
    "valor_anterior": 63561649949.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 60711451896.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 56044468711.0,
        "delta": -4666983185.0
      },
      {
        "periodo": 202509,
        "valor": 59226979165.0,
        "delta": 3182510454.0
      },
      {
        "periodo": 202510,
        "valor": 59142619255.0,
        "delta": -84359910.0
      },
      {
        "periodo": 202511,
        "valor": 60471141452.0,
        "delta": 1328522197.0
      },
      {
        "periodo": 202512,
        "valor": 62759868316.0,
        "delta": 2288726864.0
      },
      {
        "periodo": 202601,
        "valor": 65601075828.0,
        "delta": 2841207512.0
      },
      {
        "periodo": 202602,
        "valor": 66838951444.0,
        "delta": 1237875616.0
      },
      {
        "periodo": 202603,
        "valor": 70444036512.0,
        "delta": 3605085068.0
      },
      {
        "periodo": 202604,
        "valor": 68071947405.0,
        "delta": -2372089107.0
      },
      {
        "periodo": 202605,
        "valor": 63161767039.0,
        "delta": -4910180366.0
      },
      {
        "periodo": 202606,
        "valor": 63561649949.0,
        "delta": 399882910.0
      },
      {
        "periodo": 202607,
        "valor": 60474410386.0,
        "delta": -3087239563.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 35459857709.0,
    "valor_anterior": 35859991477.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 47707007402.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 46987617406.0,
        "delta": -719389996.0
      },
      {
        "periodo": 202509,
        "valor": 43736097757.0,
        "delta": -3251519649.0
      },
      {
        "periodo": 202510,
        "valor": 42461045448.0,
        "delta": -1275052309.0
      },
      {
        "periodo": 202511,
        "valor": 42479923748.0,
        "delta": 18878300.0
      },
      {
        "periodo": 202512,
        "valor": 38045828314.0,
        "delta": -4434095434.0
      },
      {
        "periodo": 202601,
        "valor": 37696295825.0,
        "delta": -349532489.0
      },
      {
        "periodo": 202602,
        "valor": 38532171400.0,
        "delta": 835875575.0
      },
      {
        "periodo": 202603,
        "valor": 37314525546.0,
        "delta": -1217645854.0
      },
      {
        "periodo": 202604,
        "valor": 37547513522.0,
        "delta": 232987976.0
      },
      {
        "periodo": 202605,
        "valor": 36559025119.0,
        "delta": -988488403.0
      },
      {
        "periodo": 202606,
        "valor": 35859991477.0,
        "delta": -699033642.0
      },
      {
        "periodo": 202607,
        "valor": 35459857709.0,
        "delta": -400133768.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 88651478235.0,
    "valor_anterior": 89145141481.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 84558258359.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 87043479397.0,
        "delta": 2485221038.0
      },
      {
        "periodo": 202509,
        "valor": 89448350800.0,
        "delta": 2404871403.0
      },
      {
        "periodo": 202510,
        "valor": 90673589781.0,
        "delta": 1225238981.0
      },
      {
        "periodo": 202511,
        "valor": 88505870099.0,
        "delta": -2167719682.0
      },
      {
        "periodo": 202512,
        "valor": 90887028991.0,
        "delta": 2381158892.0
      },
      {
        "periodo": 202601,
        "valor": 91149549746.0,
        "delta": 262520755.0
      },
      {
        "periodo": 202602,
        "valor": 91543069235.0,
        "delta": 393519489.0
      },
      {
        "periodo": 202603,
        "valor": 90652012450.0,
        "delta": -891056785.0
      },
      {
        "periodo": 202604,
        "valor": 87874810652.0,
        "delta": -2777201798.0
      },
      {
        "periodo": 202605,
        "valor": 88259702691.0,
        "delta": 384892039.0
      },
      {
        "periodo": 202606,
        "valor": 89145141481.0,
        "delta": 885438790.0
      },
      {
        "periodo": 202607,
        "valor": 88651478235.0,
        "delta": -493663246.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 1281460745808.15,
    "valor_anterior": 1262569084140.67,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1186183104725.89,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1193359603643.18,
        "delta": 7176498917.29
      },
      {
        "periodo": 202509,
        "valor": 1180061849356.97,
        "delta": -13297754286.21
      },
      {
        "periodo": 202510,
        "valor": 1205236798494.53,
        "delta": 25174949137.5601
      },
      {
        "periodo": 202511,
        "valor": 1223563089331.78,
        "delta": 18326290837.25
      },
      {
        "periodo": 202512,
        "valor": 1271061499830.65,
        "delta": 47498410498.8699
      },
      {
        "periodo": 202601,
        "valor": 1239622133103.93,
        "delta": -31439366726.72
      },
      {
        "periodo": 202602,
        "valor": 1252004738188.24,
        "delta": 12382605084.3101
      },
      {
        "periodo": 202603,
        "valor": 1266843596131.1,
        "delta": 14838857942.8601
      },
      {
        "periodo": 202604,
        "valor": 1271026524513.29,
        "delta": 4182928382.1899
      },
      {
        "periodo": 202605,
        "valor": 1276657932009.74,
        "delta": 5631407496.45
      },
      {
        "periodo": 202606,
        "valor": 1262569084140.67,
        "delta": -14088847869.0701
      },
      {
        "periodo": 202607,
        "valor": 1281460745808.15,
        "delta": 18891661667.48
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 62047238476.0,
    "valor_anterior": 66895237867.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 125573269623.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 127887001102.0,
        "delta": 2313731479.0
      },
      {
        "periodo": 202509,
        "valor": 62033772894.0,
        "delta": -65853228208.0
      },
      {
        "periodo": 202510,
        "valor": 128181946174.0,
        "delta": 66148173280.0
      },
      {
        "periodo": 202511,
        "valor": 129405889779.0,
        "delta": 1223943605.0
      },
      {
        "periodo": 202512,
        "valor": 73106616976.0,
        "delta": -56299272803.0
      },
      {
        "periodo": 202601,
        "valor": 102951979330.0,
        "delta": 29845362354.0
      },
      {
        "periodo": 202602,
        "valor": 105008801757.0,
        "delta": 2056822427.0
      },
      {
        "periodo": 202603,
        "valor": 69321502337.0,
        "delta": -35687299420.0
      },
      {
        "periodo": 202604,
        "valor": 77053514317.0,
        "delta": 7732011980.0
      },
      {
        "periodo": 202605,
        "valor": 77252220456.0,
        "delta": 198706139.0
      },
      {
        "periodo": 202606,
        "valor": 66895237867.0,
        "delta": -10356982589.0
      },
      {
        "periodo": 202607,
        "valor": 62047238476.0,
        "delta": -4847999391.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 27720423943.0,
    "valor_anterior": 29211356763.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28621285908.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28967286203.0,
        "delta": 346000295.0
      },
      {
        "periodo": 202509,
        "valor": 30112139374.0,
        "delta": 1144853171.0
      },
      {
        "periodo": 202510,
        "valor": 30562223434.0,
        "delta": 450084060.0
      },
      {
        "periodo": 202511,
        "valor": 34950161668.0,
        "delta": 4387938234.0
      },
      {
        "periodo": 202512,
        "valor": 30844753299.0,
        "delta": -4105408369.0
      },
      {
        "periodo": 202601,
        "valor": 30121170445.0,
        "delta": -723582854.0
      },
      {
        "periodo": 202602,
        "valor": 31401508154.0,
        "delta": 1280337709.0
      },
      {
        "periodo": 202603,
        "valor": 32890446674.0,
        "delta": 1488938520.0
      },
      {
        "periodo": 202604,
        "valor": 31749450483.0,
        "delta": -1140996191.0
      },
      {
        "periodo": 202605,
        "valor": 31288153848.0,
        "delta": -461296635.0
      },
      {
        "periodo": 202606,
        "valor": 29211356763.0,
        "delta": -2076797085.0
      },
      {
        "periodo": 202607,
        "valor": 27720423943.0,
        "delta": -1490932820.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 80849560357.0,
    "valor_anterior": 83356277585.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 75668219404.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 82874920132.0,
        "delta": 7206700728.0
      },
      {
        "periodo": 202509,
        "valor": 85658553719.0,
        "delta": 2783633587.0
      },
      {
        "periodo": 202510,
        "valor": 84971886898.0,
        "delta": -686666821.0
      },
      {
        "periodo": 202511,
        "valor": 80991146137.0,
        "delta": -3980740761.0
      },
      {
        "periodo": 202512,
        "valor": 87141763484.0,
        "delta": 6150617347.0
      },
      {
        "periodo": 202601,
        "valor": 77269530035.0,
        "delta": -9872233449.0
      },
      {
        "periodo": 202602,
        "valor": 75544459158.0,
        "delta": -1725070877.0
      },
      {
        "periodo": 202603,
        "valor": 78315173831.0,
        "delta": 2770714673.0
      },
      {
        "periodo": 202604,
        "valor": 80257853236.0,
        "delta": 1942679405.0
      },
      {
        "periodo": 202605,
        "valor": 72866051980.0,
        "delta": -7391801256.0
      },
      {
        "periodo": 202606,
        "valor": 83356277585.0,
        "delta": 10490225605.0
      },
      {
        "periodo": 202607,
        "valor": 80849560357.0,
        "delta": -2506717228.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 101289815525.72,
    "valor_anterior": 94931620317.74,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 82268249674.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 84563423344.65,
        "delta": 2295173669.93
      },
      {
        "periodo": 202509,
        "valor": 80095010471.07,
        "delta": -4468412873.58
      },
      {
        "periodo": 202510,
        "valor": 79313750173.45,
        "delta": -781260297.62
      },
      {
        "periodo": 202511,
        "valor": 77539535203.06,
        "delta": -1774214970.39
      },
      {
        "periodo": 202512,
        "valor": 103894328163.23,
        "delta": 26354792960.17
      },
      {
        "periodo": 202601,
        "valor": 89466280868.31,
        "delta": -14428047294.92
      },
      {
        "periodo": 202602,
        "valor": 94580533060.2,
        "delta": 5114252191.89
      },
      {
        "periodo": 202603,
        "valor": 94671180026.29,
        "delta": 90646966.09
      },
      {
        "periodo": 202604,
        "valor": 96686135327.73,
        "delta": 2014955301.44
      },
      {
        "periodo": 202605,
        "valor": 91556553527.22,
        "delta": -5129581800.51
      },
      {
        "periodo": 202606,
        "valor": 94931620317.74,
        "delta": 3375066790.52
      },
      {
        "periodo": 202607,
        "valor": 101289815525.72,
        "delta": 6358195207.98
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 75371742651.0,
    "valor_anterior": 74657034133.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 64188549273.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 62064545451.0,
        "delta": -2124003822.0
      },
      {
        "periodo": 202509,
        "valor": 63481071071.0,
        "delta": 1416525620.0
      },
      {
        "periodo": 202510,
        "valor": 65892153308.0,
        "delta": 2411082237.0
      },
      {
        "periodo": 202511,
        "valor": 69042671768.0,
        "delta": 3150518460.0
      },
      {
        "periodo": 202512,
        "valor": 72180381289.0,
        "delta": 3137709521.0
      },
      {
        "periodo": 202601,
        "valor": 70681854194.0,
        "delta": -1498527095.0
      },
      {
        "periodo": 202602,
        "valor": 72552940042.0,
        "delta": 1871085848.0
      },
      {
        "periodo": 202603,
        "valor": 72995023720.0,
        "delta": 442083678.0
      },
      {
        "periodo": 202604,
        "valor": 74170291448.0,
        "delta": 1175267728.0
      },
      {
        "periodo": 202605,
        "valor": 77504430786.0,
        "delta": 3334139338.0
      },
      {
        "periodo": 202606,
        "valor": 74657034133.0,
        "delta": -2847396653.0
      },
      {
        "periodo": 202607,
        "valor": 75371742651.0,
        "delta": 714708518.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 362958087454.1,
    "valor_anterior": 347129034257.48,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 339318514105.09,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 334183088841.29,
        "delta": -5135425263.8
      },
      {
        "periodo": 202509,
        "valor": 338381485166.12,
        "delta": 4198396324.83
      },
      {
        "periodo": 202510,
        "valor": 322306182873.95,
        "delta": -16075302292.17
      },
      {
        "periodo": 202511,
        "valor": 352221077309.71,
        "delta": 29914894435.76
      },
      {
        "periodo": 202512,
        "valor": 372938265451.94,
        "delta": 20717188142.23
      },
      {
        "periodo": 202601,
        "valor": 336622041778.8,
        "delta": -36316223673.14
      },
      {
        "periodo": 202602,
        "valor": 342736419597.21,
        "delta": 6114377818.41
      },
      {
        "periodo": 202603,
        "valor": 369512286021.35,
        "delta": 26775866424.14
      },
      {
        "periodo": 202604,
        "valor": 336122170345.13,
        "delta": -33390115676.22
      },
      {
        "periodo": 202605,
        "valor": 340139700108.86,
        "delta": 4017529763.73
      },
      {
        "periodo": 202606,
        "valor": 347129034257.48,
        "delta": 6989334148.62
      },
      {
        "periodo": 202607,
        "valor": 362958087454.1,
        "delta": 15829053196.62
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 249850735123.3,
    "valor_anterior": 246593420945.61,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 242117712183.47,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 247637474433.46,
        "delta": 5519762249.99
      },
      {
        "periodo": 202509,
        "valor": 240763787180.3,
        "delta": -6873687253.16
      },
      {
        "periodo": 202510,
        "valor": 247200631685.36,
        "delta": 6436844505.06
      },
      {
        "periodo": 202511,
        "valor": 242105932180.48,
        "delta": -5094699504.88
      },
      {
        "periodo": 202512,
        "valor": 240856482316.22,
        "delta": -1249449864.26
      },
      {
        "periodo": 202601,
        "valor": 244895459511.15,
        "delta": 4038977194.93
      },
      {
        "periodo": 202602,
        "valor": 246321996039.04,
        "delta": 1426536527.89
      },
      {
        "periodo": 202603,
        "valor": 240361226885.5,
        "delta": -5960769153.54
      },
      {
        "periodo": 202604,
        "valor": 247704138054.03,
        "delta": 7342911168.53
      },
      {
        "periodo": 202605,
        "valor": 248134083345.69,
        "delta": 429945291.66
      },
      {
        "periodo": 202606,
        "valor": 246593420945.61,
        "delta": -1540662400.08
      },
      {
        "periodo": 202607,
        "valor": 249850735123.3,
        "delta": 3257314177.69
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 51473039219.0,
    "valor_anterior": 61912749539.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18810475677.96,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24515159242.48,
        "delta": 5704683564.52
      },
      {
        "periodo": 202509,
        "valor": 46550018464.0,
        "delta": 22034859221.52
      },
      {
        "periodo": 202510,
        "valor": 48637903844.0,
        "delta": 2087885380.0
      },
      {
        "periodo": 202511,
        "valor": 45616068918.0,
        "delta": -3021834926.0
      },
      {
        "periodo": 202512,
        "valor": 55734994420.0,
        "delta": 10118925502.0
      },
      {
        "periodo": 202601,
        "valor": 50984774525.0,
        "delta": -4750219895.0
      },
      {
        "periodo": 202602,
        "valor": 46824873588.0,
        "delta": -4159900937.0
      },
      {
        "periodo": 202603,
        "valor": 58422369806.0,
        "delta": 11597496218.0
      },
      {
        "periodo": 202604,
        "valor": 49889865732.0,
        "delta": -8532504074.0
      },
      {
        "periodo": 202605,
        "valor": 50596779278.0,
        "delta": 706913546.0
      },
      {
        "periodo": 202606,
        "valor": 61912749539.0,
        "delta": 11315970261.0
      },
      {
        "periodo": 202607,
        "valor": 51473039219.0,
        "delta": -10439710320.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 259838005.0,
    "valor_anterior": 1417818824.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1486527785.0,
        "delta": 1486527785.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": -1486527785.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 2335006298.0,
        "delta": 2335006298.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -2335006298.0
      },
      {
        "periodo": 202603,
        "valor": 2171911284.0,
        "delta": 2171911284.0
      },
      {
        "periodo": 202604,
        "valor": 1398863981.0,
        "delta": -773047303.0
      },
      {
        "periodo": 202605,
        "valor": 6296870686.0,
        "delta": 4898006705.0
      },
      {
        "periodo": 202606,
        "valor": 1417818824.0,
        "delta": -4879051862.0
      },
      {
        "periodo": 202607,
        "valor": 259838005.0,
        "delta": -1157980819.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 44403109348.0,
    "valor_anterior": 44474478041.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 41025303770.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 41956622742.0,
        "delta": 931318972.0
      },
      {
        "periodo": 202509,
        "valor": 41940414053.0,
        "delta": -16208689.0
      },
      {
        "periodo": 202510,
        "valor": 46010624997.0,
        "delta": 4070210944.0
      },
      {
        "periodo": 202511,
        "valor": 46236154373.0,
        "delta": 225529376.0
      },
      {
        "periodo": 202512,
        "valor": 46488020937.0,
        "delta": 251866564.0
      },
      {
        "periodo": 202601,
        "valor": 45552378693.0,
        "delta": -935642244.0
      },
      {
        "periodo": 202602,
        "valor": 45805683475.0,
        "delta": 253304782.0
      },
      {
        "periodo": 202603,
        "valor": 44479431523.0,
        "delta": -1326251952.0
      },
      {
        "periodo": 202604,
        "valor": 44133973886.0,
        "delta": -345457637.0
      },
      {
        "periodo": 202605,
        "valor": 44472890240.0,
        "delta": 338916354.0
      },
      {
        "periodo": 202606,
        "valor": 44474478041.0,
        "delta": 1587801.0
      },
      {
        "periodo": 202607,
        "valor": 44403109348.0,
        "delta": -71368693.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 135174919636.0,
    "valor_anterior": 132219343116.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 98229440714.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 115076150071.0,
        "delta": 16846709357.0
      },
      {
        "periodo": 202509,
        "valor": 115016202594.0,
        "delta": -59947477.0
      },
      {
        "periodo": 202510,
        "valor": 115413364692.0,
        "delta": 397162098.0
      },
      {
        "periodo": 202511,
        "valor": 111198424313.0,
        "delta": -4214940379.0
      },
      {
        "periodo": 202512,
        "valor": 120866661511.0,
        "delta": 9668237198.0
      },
      {
        "periodo": 202601,
        "valor": 116745278083.0,
        "delta": -4121383428.0
      },
      {
        "periodo": 202602,
        "valor": 127653939404.0,
        "delta": 10908661321.0
      },
      {
        "periodo": 202603,
        "valor": 136611217204.0,
        "delta": 8957277800.0
      },
      {
        "periodo": 202604,
        "valor": 132511470614.0,
        "delta": -4099746590.0
      },
      {
        "periodo": 202605,
        "valor": 137630678851.0,
        "delta": 5119208237.0
      },
      {
        "periodo": 202606,
        "valor": 132219343116.0,
        "delta": -5411335735.0
      },
      {
        "periodo": 202607,
        "valor": 135174919636.0,
        "delta": 2955576520.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 43019905984.0,
    "valor_anterior": 46596483839.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 42128207198.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 48138239093.0,
        "delta": 6010031895.0
      },
      {
        "periodo": 202509,
        "valor": 50618417026.0,
        "delta": 2480177933.0
      },
      {
        "periodo": 202510,
        "valor": 44866870414.0,
        "delta": -5751546612.0
      },
      {
        "periodo": 202511,
        "valor": 44235305832.0,
        "delta": -631564582.0
      },
      {
        "periodo": 202512,
        "valor": 43894333393.0,
        "delta": -340972439.0
      },
      {
        "periodo": 202601,
        "valor": 38906842438.0,
        "delta": -4987490955.0
      },
      {
        "periodo": 202602,
        "valor": 38921183187.0,
        "delta": 14340749.0
      },
      {
        "periodo": 202603,
        "valor": 39661965963.0,
        "delta": 740782776.0
      },
      {
        "periodo": 202604,
        "valor": 40356629221.0,
        "delta": 694663258.0
      },
      {
        "periodo": 202605,
        "valor": 39496398464.0,
        "delta": -860230757.0
      },
      {
        "periodo": 202606,
        "valor": 46596483839.0,
        "delta": 7100085375.0
      },
      {
        "periodo": 202607,
        "valor": 43019905984.0,
        "delta": -3576577855.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 23960391587.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18720003992.0,
        "delta": -5240387595.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -18720003992.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 2.0,
        "delta": 2.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -2.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 145828801720.25,
    "valor_anterior": 143139686174.64,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 146717332153.36,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 147721701358.16,
        "delta": 1004369204.8
      },
      {
        "periodo": 202509,
        "valor": 144253390113.79,
        "delta": -3468311244.37
      },
      {
        "periodo": 202510,
        "valor": 149043017770.0,
        "delta": 4789627656.21
      },
      {
        "periodo": 202511,
        "valor": 149543397404.99,
        "delta": 500379634.99
      },
      {
        "periodo": 202512,
        "valor": 150527715802.68,
        "delta": 984318397.69
      },
      {
        "periodo": 202601,
        "valor": 147311310042.87,
        "delta": -3216405759.81
      },
      {
        "periodo": 202602,
        "valor": 144994532139.66,
        "delta": -2316777903.21
      },
      {
        "periodo": 202603,
        "valor": 145235348013.97,
        "delta": 240815874.31
      },
      {
        "periodo": 202604,
        "valor": 145687676970.54,
        "delta": 452328956.57
      },
      {
        "periodo": 202605,
        "valor": 145181743668.73,
        "delta": -505933301.81
      },
      {
        "periodo": 202606,
        "valor": 143139686174.64,
        "delta": -2042057494.09
      },
      {
        "periodo": 202607,
        "valor": 145828801720.25,
        "delta": 2689115545.61
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 5077041108.999999,
    "valor_anterior": 4995841080.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5722601193.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5766391279.0,
        "delta": 43790086.0
      },
      {
        "periodo": 202509,
        "valor": 5606141575.0,
        "delta": -160249704.0
      },
      {
        "periodo": 202510,
        "valor": 5279127405.0,
        "delta": -327014170.0
      },
      {
        "periodo": 202511,
        "valor": 5275852136.0,
        "delta": -3275269.0
      },
      {
        "periodo": 202512,
        "valor": 5342474891.0,
        "delta": 66622755.0
      },
      {
        "periodo": 202601,
        "valor": 5261732150.0,
        "delta": -80742741.0
      },
      {
        "periodo": 202602,
        "valor": 5227536353.0,
        "delta": -34195797.0
      },
      {
        "periodo": 202603,
        "valor": 5151762280.0,
        "delta": -75774073.0
      },
      {
        "periodo": 202604,
        "valor": 5014101072.0,
        "delta": -137661208.0
      },
      {
        "periodo": 202605,
        "valor": 5028496395.0,
        "delta": 14395323.0
      },
      {
        "periodo": 202606,
        "valor": 4995841080.0,
        "delta": -32655315.0
      },
      {
        "periodo": 202607,
        "valor": 5077041109.0,
        "delta": 81200029.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21262708.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21030542.0,
        "delta": -232166.0
      },
      {
        "periodo": 202509,
        "valor": 20640232.0,
        "delta": -390310.0
      },
      {
        "periodo": 202510,
        "valor": 20939309.0,
        "delta": 299077.0
      },
      {
        "periodo": 202511,
        "valor": 20619417.0,
        "delta": -319892.0
      },
      {
        "periodo": 202512,
        "valor": 20296145.0,
        "delta": -323272.0
      },
      {
        "periodo": 202601,
        "valor": 19634052.0,
        "delta": -662093.0
      },
      {
        "periodo": 202602,
        "valor": 19422273.0,
        "delta": -211779.0
      },
      {
        "periodo": 202603,
        "valor": 20204339.0,
        "delta": 782066.0
      },
      {
        "periodo": 202604,
        "valor": 19690401.0,
        "delta": -513938.0
      },
      {
        "periodo": 202605,
        "valor": 19545838.0,
        "delta": -144563.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": -19545838.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 22521594083.999996,
    "valor_anterior": 23045951542.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20881434848.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21062608578.0,
        "delta": 181173730.0
      },
      {
        "periodo": 202509,
        "valor": 21400063189.0,
        "delta": 337454611.0
      },
      {
        "periodo": 202510,
        "valor": 21287398182.0,
        "delta": -112665007.0
      },
      {
        "periodo": 202511,
        "valor": 21076680937.0,
        "delta": -210717245.0
      },
      {
        "periodo": 202512,
        "valor": 21315846223.0,
        "delta": 239165286.0
      },
      {
        "periodo": 202601,
        "valor": 21816371159.0,
        "delta": 500524936.0
      },
      {
        "periodo": 202602,
        "valor": 21194791288.0,
        "delta": -621579871.0
      },
      {
        "periodo": 202603,
        "valor": 21524049231.0,
        "delta": 329257943.0
      },
      {
        "periodo": 202604,
        "valor": 24454825687.0,
        "delta": 2930776456.0
      },
      {
        "periodo": 202605,
        "valor": 24698868742.0,
        "delta": 244043055.0
      },
      {
        "periodo": 202606,
        "valor": 23045951542.0,
        "delta": -1652917200.0
      },
      {
        "periodo": 202607,
        "valor": 22521594084.0,
        "delta": -524357458.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 4750795954.0,
    "valor_anterior": 4739624903.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3713596981.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3714901371.0,
        "delta": 1304390.0
      },
      {
        "periodo": 202509,
        "valor": 4769066922.0,
        "delta": 1054165551.0
      },
      {
        "periodo": 202510,
        "valor": 4780156848.0,
        "delta": 11089926.0
      },
      {
        "periodo": 202511,
        "valor": 4789904978.0,
        "delta": 9748130.0
      },
      {
        "periodo": 202512,
        "valor": 4491321665.0,
        "delta": -298583313.0
      },
      {
        "periodo": 202601,
        "valor": 4493580403.0,
        "delta": 2258738.0
      },
      {
        "periodo": 202602,
        "valor": 4853397933.0,
        "delta": 359817530.0
      },
      {
        "periodo": 202603,
        "valor": 4912926196.0,
        "delta": 59528263.0
      },
      {
        "periodo": 202604,
        "valor": 4920718809.0,
        "delta": 7792613.0
      },
      {
        "periodo": 202605,
        "valor": 4931350978.0,
        "delta": 10632169.0
      },
      {
        "periodo": 202606,
        "valor": 4739624903.0,
        "delta": -191726075.0
      },
      {
        "periodo": 202607,
        "valor": 4750795954.0,
        "delta": 11171051.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28369049625.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11931171426.0,
        "delta": -16437878199.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 32482139137.0,
    "valor_anterior": 32755082011.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 33850293636.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 34646758134.0,
        "delta": 796464498.0
      },
      {
        "periodo": 202509,
        "valor": 33012406811.0,
        "delta": -1634351323.0
      },
      {
        "periodo": 202510,
        "valor": 33455164721.0,
        "delta": 442757910.0
      },
      {
        "periodo": 202511,
        "valor": 33199490855.0,
        "delta": -255673866.0
      },
      {
        "periodo": 202512,
        "valor": 33172865336.0,
        "delta": -26625519.0
      },
      {
        "periodo": 202601,
        "valor": 31855298525.0,
        "delta": -1317566811.0
      },
      {
        "periodo": 202602,
        "valor": 32664119922.0,
        "delta": 808821397.0
      },
      {
        "periodo": 202603,
        "valor": 32948705239.0,
        "delta": 284585317.0
      },
      {
        "periodo": 202604,
        "valor": 33179863602.0,
        "delta": 231158363.0
      },
      {
        "periodo": 202605,
        "valor": 33213218485.0,
        "delta": 33354883.0
      },
      {
        "periodo": 202606,
        "valor": 32755082011.0,
        "delta": -458136474.0
      },
      {
        "periodo": 202607,
        "valor": 32482139137.0,
        "delta": -272942874.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 29858467863.0,
    "valor_anterior": 28000368455.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16301565533.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16499627351.0,
        "delta": 198061818.0
      },
      {
        "periodo": 202509,
        "valor": 17997496707.0,
        "delta": 1497869356.0
      },
      {
        "periodo": 202510,
        "valor": 18596715900.0,
        "delta": 599219193.0
      },
      {
        "periodo": 202511,
        "valor": 19114528643.0,
        "delta": 517812743.0
      },
      {
        "periodo": 202512,
        "valor": 26372809542.0,
        "delta": 7258280899.0
      },
      {
        "periodo": 202601,
        "valor": 19714489744.0,
        "delta": -6658319798.0
      },
      {
        "periodo": 202602,
        "valor": 23939661936.0,
        "delta": 4225172192.0
      },
      {
        "periodo": 202603,
        "valor": 25326514361.0,
        "delta": 1386852425.0
      },
      {
        "periodo": 202604,
        "valor": 25983538260.0,
        "delta": 657023899.0
      },
      {
        "periodo": 202605,
        "valor": 27442429816.0,
        "delta": 1458891556.0
      },
      {
        "periodo": 202606,
        "valor": 28000368455.0,
        "delta": 557938639.0
      },
      {
        "periodo": 202607,
        "valor": 29858467863.0,
        "delta": 1858099408.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 952740519.0,
    "valor_anterior": 950210484.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27968025.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 858416985.0,
        "delta": 830448960.0
      },
      {
        "periodo": 202509,
        "valor": 500002146.0,
        "delta": -358414839.0
      },
      {
        "periodo": 202510,
        "valor": 484500006.0,
        "delta": -15502140.0
      },
      {
        "periodo": 202511,
        "valor": 578449990.0,
        "delta": 93949984.0
      },
      {
        "periodo": 202512,
        "valor": 119726961.0,
        "delta": -458723029.0
      },
      {
        "periodo": 202601,
        "valor": 261014740.0,
        "delta": 141287779.0
      },
      {
        "periodo": 202602,
        "valor": 274164195.0,
        "delta": 13149455.0
      },
      {
        "periodo": 202603,
        "valor": 60832995.0,
        "delta": -213331200.0
      },
      {
        "periodo": 202604,
        "valor": 39736243.0,
        "delta": -21096752.0
      },
      {
        "periodo": 202605,
        "valor": 579039191.0,
        "delta": 539302948.0
      },
      {
        "periodo": 202606,
        "valor": 950210484.0,
        "delta": 371171293.0
      },
      {
        "periodo": 202607,
        "valor": 952740519.0,
        "delta": 2530035.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 437662531.0,
    "valor_anterior": 398438802.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 247028571.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 251817861.0,
        "delta": 4789290.0
      },
      {
        "periodo": 202509,
        "valor": 261674522.0,
        "delta": 9856661.0
      },
      {
        "periodo": 202510,
        "valor": 269240986.0,
        "delta": 7566464.0
      },
      {
        "periodo": 202511,
        "valor": 274002836.0,
        "delta": 4761850.0
      },
      {
        "periodo": 202512,
        "valor": 302976311.0,
        "delta": 28973475.0
      },
      {
        "periodo": 202601,
        "valor": 324126203.0,
        "delta": 21149892.0
      },
      {
        "periodo": 202602,
        "valor": 339401928.0,
        "delta": 15275725.0
      },
      {
        "periodo": 202603,
        "valor": 348800371.0,
        "delta": 9398443.0
      },
      {
        "periodo": 202604,
        "valor": 361534112.0,
        "delta": 12733741.0
      },
      {
        "periodo": 202605,
        "valor": 380615149.0,
        "delta": 19081037.0
      },
      {
        "periodo": 202606,
        "valor": 398438802.0,
        "delta": 17823653.0
      },
      {
        "periodo": 202607,
        "valor": 437662531.0,
        "delta": 39223729.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 14454458190.14,
    "valor_anterior": 14478589730.34,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13491631052.01,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13505659587.94,
        "delta": 14028535.93
      },
      {
        "periodo": 202509,
        "valor": 13421284911.35,
        "delta": -84374676.59
      },
      {
        "periodo": 202510,
        "valor": 13640756792.84,
        "delta": 219471881.49
      },
      {
        "periodo": 202511,
        "valor": 13859493312.92,
        "delta": 218736520.08
      },
      {
        "periodo": 202512,
        "valor": 13897136166.5,
        "delta": 37642853.58
      },
      {
        "periodo": 202601,
        "valor": 13483334296.17,
        "delta": -413801870.33
      },
      {
        "periodo": 202602,
        "valor": 13241779855.71,
        "delta": -241554440.46
      },
      {
        "periodo": 202603,
        "valor": 14348721377.24,
        "delta": 1106941521.53
      },
      {
        "periodo": 202604,
        "valor": 14295619135.71,
        "delta": -53102241.53
      },
      {
        "periodo": 202605,
        "valor": 14091424986.33,
        "delta": -204194149.38
      },
      {
        "periodo": 202606,
        "valor": 14478589730.34,
        "delta": 387164744.01
      },
      {
        "periodo": 202607,
        "valor": 14454458190.14,
        "delta": -24131540.2
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 3047042628.0,
    "valor_anterior": 2755990754.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1766311853.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1814843326.0,
        "delta": 48531473.0
      },
      {
        "periodo": 202509,
        "valor": 2085725692.0,
        "delta": 270882366.0
      },
      {
        "periodo": 202510,
        "valor": 2674914066.0,
        "delta": 589188374.0
      },
      {
        "periodo": 202511,
        "valor": 3340185220.0,
        "delta": 665271154.0
      },
      {
        "periodo": 202512,
        "valor": 2862054642.0,
        "delta": -478130578.0
      },
      {
        "periodo": 202601,
        "valor": 2238598817.0,
        "delta": -623455825.0
      },
      {
        "periodo": 202602,
        "valor": 2461946047.0,
        "delta": 223347230.0
      },
      {
        "periodo": 202603,
        "valor": 2855681577.0,
        "delta": 393735530.0
      },
      {
        "periodo": 202604,
        "valor": 2759353528.0,
        "delta": -96328049.0
      },
      {
        "periodo": 202605,
        "valor": 2833411036.0,
        "delta": 74057508.0
      },
      {
        "periodo": 202606,
        "valor": 2755990754.0,
        "delta": -77420282.0
      },
      {
        "periodo": 202607,
        "valor": 3047042628.0,
        "delta": 291051874.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 54275967365.94,
    "valor_anterior": 54504371481.82,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 46300567861.73,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 46782148895.14,
        "delta": 481581033.41
      },
      {
        "periodo": 202509,
        "valor": 46453131147.49,
        "delta": -329017747.65
      },
      {
        "periodo": 202510,
        "valor": 47953830019.76,
        "delta": 1500698872.27
      },
      {
        "periodo": 202511,
        "valor": 50140840620.09,
        "delta": 2187010600.33
      },
      {
        "periodo": 202512,
        "valor": 52793008081.77,
        "delta": 2652167461.68
      },
      {
        "periodo": 202601,
        "valor": 51798694842.11,
        "delta": -994313239.66
      },
      {
        "periodo": 202602,
        "valor": 51933275469.87,
        "delta": 134580627.76
      },
      {
        "periodo": 202603,
        "valor": 54761499054.47,
        "delta": 2828223584.6
      },
      {
        "periodo": 202604,
        "valor": 52985818189.26,
        "delta": -1775680865.21
      },
      {
        "periodo": 202605,
        "valor": 53195570529.16,
        "delta": 209752339.9
      },
      {
        "periodo": 202606,
        "valor": 54504371481.82,
        "delta": 1308800952.66
      },
      {
        "periodo": 202607,
        "valor": 54275967365.94,
        "delta": -228404115.88
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 8928270800.25,
    "valor_anterior": 8909346983.17,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8265383197.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8365956350.04,
        "delta": 100573152.78
      },
      {
        "periodo": 202509,
        "valor": 8490076896.03,
        "delta": 124120545.99
      },
      {
        "periodo": 202510,
        "valor": 8232593640.19,
        "delta": -257483255.84
      },
      {
        "periodo": 202511,
        "valor": 8383720472.2,
        "delta": 151126832.01
      },
      {
        "periodo": 202512,
        "valor": 8466874215.42,
        "delta": 83153743.22
      },
      {
        "periodo": 202601,
        "valor": 8610188461.27,
        "delta": 143314245.85
      },
      {
        "periodo": 202602,
        "valor": 8341473192.48,
        "delta": -268715268.79
      },
      {
        "periodo": 202603,
        "valor": 8793473460.01,
        "delta": 452000267.53
      },
      {
        "periodo": 202604,
        "valor": 8784296577.77,
        "delta": -9176882.24
      },
      {
        "periodo": 202605,
        "valor": 9056599672.95,
        "delta": 272303095.18
      },
      {
        "periodo": 202606,
        "valor": 8909346983.17,
        "delta": -147252689.78
      },
      {
        "periodo": 202607,
        "valor": 8928270800.25,
        "delta": 18923817.08
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 10103938832.0,
    "valor_anterior": 8972550875.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8739517471.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9061291810.0,
        "delta": 321774339.0
      },
      {
        "periodo": 202509,
        "valor": 9662500349.0,
        "delta": 601208539.0
      },
      {
        "periodo": 202510,
        "valor": 10545384884.0,
        "delta": 882884535.0
      },
      {
        "periodo": 202511,
        "valor": 11181542170.0,
        "delta": 636157286.0
      },
      {
        "periodo": 202512,
        "valor": 10596540650.0,
        "delta": -585001520.0
      },
      {
        "periodo": 202601,
        "valor": 10776884478.0,
        "delta": 180343828.0
      },
      {
        "periodo": 202602,
        "valor": 10665421965.0,
        "delta": -111462513.0
      },
      {
        "periodo": 202603,
        "valor": 10390925988.0,
        "delta": -274495977.0
      },
      {
        "periodo": 202604,
        "valor": 10258513414.0,
        "delta": -132412574.0
      },
      {
        "periodo": 202605,
        "valor": 9035420427.0,
        "delta": -1223092987.0
      },
      {
        "periodo": 202606,
        "valor": 8972550875.0,
        "delta": -62869552.0
      },
      {
        "periodo": 202607,
        "valor": 10103938832.0,
        "delta": 1131387957.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 128152891221.0,
    "valor_anterior": 125775928567.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 121383011525.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 123074177716.0,
        "delta": 1691166191.0
      },
      {
        "periodo": 202509,
        "valor": 122179694905.0,
        "delta": -894482811.0
      },
      {
        "periodo": 202510,
        "valor": 123658794987.0,
        "delta": 1479100082.0
      },
      {
        "periodo": 202511,
        "valor": 125097842598.0,
        "delta": 1439047611.0
      },
      {
        "periodo": 202512,
        "valor": 132818349322.0,
        "delta": 7720506724.0
      },
      {
        "periodo": 202601,
        "valor": 126353633224.0,
        "delta": -6464716098.0
      },
      {
        "periodo": 202602,
        "valor": 127391958237.0,
        "delta": 1038325013.0
      },
      {
        "periodo": 202603,
        "valor": 128213821408.0,
        "delta": 821863171.0
      },
      {
        "periodo": 202604,
        "valor": 129247733062.0,
        "delta": 1033911654.0
      },
      {
        "periodo": 202605,
        "valor": 124709850306.0,
        "delta": -4537882756.0
      },
      {
        "periodo": 202606,
        "valor": 125775928567.0,
        "delta": 1066078261.0
      },
      {
        "periodo": 202607,
        "valor": 128152891221.0,
        "delta": 2376962654.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 4921032732.999999,
    "valor_anterior": 4624273391.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4956597300.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5149089698.0,
        "delta": 192492398.0
      },
      {
        "periodo": 202509,
        "valor": 4884944911.0,
        "delta": -264144787.0
      },
      {
        "periodo": 202510,
        "valor": 5511169735.0,
        "delta": 626224824.0
      },
      {
        "periodo": 202511,
        "valor": 5264423939.0,
        "delta": -246745796.0
      },
      {
        "periodo": 202512,
        "valor": 4581682551.0,
        "delta": -682741388.0
      },
      {
        "periodo": 202601,
        "valor": 5396384759.0,
        "delta": 814702208.0
      },
      {
        "periodo": 202602,
        "valor": 5246760225.0,
        "delta": -149624534.0
      },
      {
        "periodo": 202603,
        "valor": 4992124034.0,
        "delta": -254636191.0
      },
      {
        "periodo": 202604,
        "valor": 5009994364.0,
        "delta": 17870330.0
      },
      {
        "periodo": 202605,
        "valor": 4647912944.0,
        "delta": -362081420.0
      },
      {
        "periodo": 202606,
        "valor": 4624273391.0,
        "delta": -23639553.0
      },
      {
        "periodo": 202607,
        "valor": 4921032733.0,
        "delta": 296759342.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 8031489735.9,
    "valor_anterior": 8140539815.53,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10302831165.54,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8994957096.71,
        "delta": -1307874068.83
      },
      {
        "periodo": 202509,
        "valor": 9189521814.09,
        "delta": 194564717.38
      },
      {
        "periodo": 202510,
        "valor": 10297822158.61,
        "delta": 1108300344.52
      },
      {
        "periodo": 202511,
        "valor": 9793346234.54,
        "delta": -504475924.07
      },
      {
        "periodo": 202512,
        "valor": 7624731113.66,
        "delta": -2168615120.88
      },
      {
        "periodo": 202601,
        "valor": 9503143221.98,
        "delta": 1878412108.32
      },
      {
        "periodo": 202602,
        "valor": 9420555692.19,
        "delta": -82587529.79
      },
      {
        "periodo": 202603,
        "valor": 9434082933.62,
        "delta": 13527241.43
      },
      {
        "periodo": 202604,
        "valor": 8569586517.38,
        "delta": -864496416.24
      },
      {
        "periodo": 202605,
        "valor": 8440221087.15,
        "delta": -129365430.23
      },
      {
        "periodo": 202606,
        "valor": 8140539815.53,
        "delta": -299681271.62
      },
      {
        "periodo": 202607,
        "valor": 8031489735.9,
        "delta": -109050079.63
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 5737232578.77,
    "valor_anterior": 6681114952.91,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5743074427.61,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4917837131.01,
        "delta": -825237296.6
      },
      {
        "periodo": 202509,
        "valor": 4703554935.24,
        "delta": -214282195.77
      },
      {
        "periodo": 202510,
        "valor": 4104483934.98,
        "delta": -599071000.26
      },
      {
        "periodo": 202511,
        "valor": 4408308125.73,
        "delta": 303824190.75
      },
      {
        "periodo": 202512,
        "valor": 4724038544.21,
        "delta": 315730418.48
      },
      {
        "periodo": 202601,
        "valor": 5178171733.17,
        "delta": 454133188.96
      },
      {
        "periodo": 202602,
        "valor": 4982125206.91,
        "delta": -196046526.26
      },
      {
        "periodo": 202603,
        "valor": 4421518264.84,
        "delta": -560606942.07
      },
      {
        "periodo": 202604,
        "valor": 5264226552.88,
        "delta": 842708288.04
      },
      {
        "periodo": 202605,
        "valor": 7047809728.93,
        "delta": 1783583176.05
      },
      {
        "periodo": 202606,
        "valor": 6681114952.91,
        "delta": -366694776.02
      },
      {
        "periodo": 202607,
        "valor": 5737232578.77,
        "delta": -943882374.14
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 1157450532.0,
    "valor_anterior": 2818586569.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2572072543.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2189228820.0,
        "delta": -382843723.0
      },
      {
        "periodo": 202509,
        "valor": 4814864699.0,
        "delta": 2625635879.0
      },
      {
        "periodo": 202510,
        "valor": 2011124738.0,
        "delta": -2803739961.0
      },
      {
        "periodo": 202511,
        "valor": 3059297276.0,
        "delta": 1048172538.0
      },
      {
        "periodo": 202512,
        "valor": 1117214977.0,
        "delta": -1942082299.0
      },
      {
        "periodo": 202601,
        "valor": 4953763982.0,
        "delta": 3836549005.0
      },
      {
        "periodo": 202602,
        "valor": 3357935450.0,
        "delta": -1595828532.0
      },
      {
        "periodo": 202603,
        "valor": 4874897490.0,
        "delta": 1516962040.0
      },
      {
        "periodo": 202604,
        "valor": 2634059814.0,
        "delta": -2240837676.0
      },
      {
        "periodo": 202605,
        "valor": 3972079814.0,
        "delta": 1338020000.0
      },
      {
        "periodo": 202606,
        "valor": 2818586569.0,
        "delta": -1153493245.0
      },
      {
        "periodo": 202607,
        "valor": 1157450532.0,
        "delta": -1661136037.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 3888021184.0,
    "valor_anterior": 3902400709.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3959242798.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3653114283.0,
        "delta": -306128515.0
      },
      {
        "periodo": 202509,
        "valor": 3524684175.0,
        "delta": -128430108.0
      },
      {
        "periodo": 202510,
        "valor": 3688103302.0,
        "delta": 163419127.0
      },
      {
        "periodo": 202511,
        "valor": 3988930493.0,
        "delta": 300827191.0
      },
      {
        "periodo": 202512,
        "valor": 3923516454.0,
        "delta": -65414039.0
      },
      {
        "periodo": 202601,
        "valor": 3679615589.0,
        "delta": -243900865.0
      },
      {
        "periodo": 202602,
        "valor": 3771898309.0,
        "delta": 92282720.0
      },
      {
        "periodo": 202603,
        "valor": 3961980073.0,
        "delta": 190081764.0
      },
      {
        "periodo": 202604,
        "valor": 4078318001.0,
        "delta": 116337928.0
      },
      {
        "periodo": 202605,
        "valor": 3639500273.0,
        "delta": -438817728.0
      },
      {
        "periodo": 202606,
        "valor": 3902400709.0,
        "delta": 262900436.0
      },
      {
        "periodo": 202607,
        "valor": 3888021184.0,
        "delta": -14379525.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 19544476.85,
    "valor_anterior": 19559478.88,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30201844.62,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 30119782.88,
        "delta": -82061.74
      },
      {
        "periodo": 202509,
        "valor": 27619133.89,
        "delta": -2500648.99
      },
      {
        "periodo": 202510,
        "valor": 27717270.94,
        "delta": 98137.05
      },
      {
        "periodo": 202511,
        "valor": 23565556.63,
        "delta": -4151714.31
      },
      {
        "periodo": 202512,
        "valor": 25051999.27,
        "delta": 1486442.64
      },
      {
        "periodo": 202601,
        "valor": 23121916.69,
        "delta": -1930082.58
      },
      {
        "periodo": 202602,
        "valor": 22183526.49,
        "delta": -938390.2
      },
      {
        "periodo": 202603,
        "valor": 21048425.27,
        "delta": -1135101.22
      },
      {
        "periodo": 202604,
        "valor": 20060681.78,
        "delta": -987743.49
      },
      {
        "periodo": 202605,
        "valor": 19661390.35,
        "delta": -399291.43
      },
      {
        "periodo": 202606,
        "valor": 19559478.88,
        "delta": -101911.47
      },
      {
        "periodo": 202607,
        "valor": 19544476.85,
        "delta": -15002.03
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 12733637566.42,
    "valor_anterior": 12707653884.7,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25000.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25000.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 25000.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 25000.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 25000.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 25000.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 25000.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 13031230222.39,
        "delta": 13031205222.39
      },
      {
        "periodo": 202603,
        "valor": 13061712420.58,
        "delta": 30482198.19
      },
      {
        "periodo": 202604,
        "valor": 12911426134.66,
        "delta": -150286285.92
      },
      {
        "periodo": 202605,
        "valor": 12815656891.42,
        "delta": -95769243.24
      },
      {
        "periodo": 202606,
        "valor": 12707653884.7,
        "delta": -108003006.72
      },
      {
        "periodo": 202607,
        "valor": 12733637566.42,
        "delta": 25983681.72
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 21443260639.0,
    "valor_anterior": 20957216901.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2882696539.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5324411815.0,
        "delta": 2441715276.0
      },
      {
        "periodo": 202509,
        "valor": 7658888088.0,
        "delta": 2334476273.0
      },
      {
        "periodo": 202510,
        "valor": 10278997613.0,
        "delta": 2620109525.0
      },
      {
        "periodo": 202511,
        "valor": 12950815348.0,
        "delta": 2671817735.0
      },
      {
        "periodo": 202512,
        "valor": 16369932341.0,
        "delta": 3419116993.0
      },
      {
        "periodo": 202601,
        "valor": 18439987044.0,
        "delta": 2070054703.0
      },
      {
        "periodo": 202602,
        "valor": 20206598524.0,
        "delta": 1766611480.0
      },
      {
        "periodo": 202603,
        "valor": 19766359847.0,
        "delta": -440238677.0
      },
      {
        "periodo": 202604,
        "valor": 19980786392.0,
        "delta": 214426545.0
      },
      {
        "periodo": 202605,
        "valor": 20510506239.0,
        "delta": 529719847.0
      },
      {
        "periodo": 202606,
        "valor": 20957216901.0,
        "delta": 446710662.0
      },
      {
        "periodo": 202607,
        "valor": 21443260639.0,
        "delta": 486043738.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 7184245190.34,
    "valor_anterior": 7278209445.52,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 5150413.61,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 32893776.52,
        "delta": 27743362.91
      },
      {
        "periodo": 202601,
        "valor": 671672802.72,
        "delta": 638779026.2
      },
      {
        "periodo": 202602,
        "valor": 2384437063.41,
        "delta": 1712764260.69
      },
      {
        "periodo": 202603,
        "valor": 3753035278.11,
        "delta": 1368598214.7
      },
      {
        "periodo": 202604,
        "valor": 5098140961.3,
        "delta": 1345105683.19
      },
      {
        "periodo": 202605,
        "valor": 6365023309.07,
        "delta": 1266882347.77
      },
      {
        "periodo": 202606,
        "valor": 7278209445.52,
        "delta": 913186136.45
      },
      {
        "periodo": 202607,
        "valor": 7184245190.34,
        "delta": -93964255.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 22419297325.0,
    "valor_anterior": 19507780000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 14304495096.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 16860463119.0,
        "delta": 2555968023.0
      },
      {
        "periodo": 202605,
        "valor": 17650750660.0,
        "delta": 790287541.0
      },
      {
        "periodo": 202606,
        "valor": 19507780000.0,
        "delta": 1857029340.0
      },
      {
        "periodo": 202607,
        "valor": 22419297325.0,
        "delta": 2911517325.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 9652212569440.4,
    "valor_anterior": 9641583843960.75,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9174885693436.04,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9233014216366.65,
        "delta": 58128522930.6113
      },
      {
        "periodo": 202509,
        "valor": 9133939529527.0,
        "delta": -99074686839.6504
      },
      {
        "periodo": 202510,
        "valor": 9235445227721.45,
        "delta": 101505698194.4492
      },
      {
        "periodo": 202511,
        "valor": 9405227545899.05,
        "delta": 169782318177.6016
      },
      {
        "periodo": 202512,
        "valor": 9600980171247.578,
        "delta": 195752625348.5273
      },
      {
        "periodo": 202601,
        "valor": 9359791880823.11,
        "delta": -241188290424.4688
      },
      {
        "periodo": 202602,
        "valor": 9471564593222.41,
        "delta": 111772712399.3008
      },
      {
        "periodo": 202603,
        "valor": 9630352193479.2,
        "delta": 158787600256.7891
      },
      {
        "periodo": 202604,
        "valor": 9606341042647.053,
        "delta": -24011150832.1465
      },
      {
        "periodo": 202605,
        "valor": 9643393322801.11,
        "delta": 37052280154.0566
      },
      {
        "periodo": 202606,
        "valor": 9641583843960.75,
        "delta": -1809478840.3594
      },
      {
        "periodo": 202607,
        "valor": 9652212569440.4,
        "delta": 10628725479.6504
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 7035178846682.029,
    "valor_anterior": 7022567679659.39,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6713491592229.28,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6743698201790.68,
        "delta": 30206609561.3994
      },
      {
        "periodo": 202509,
        "valor": 6704950483857.51,
        "delta": -38747717933.1699
      },
      {
        "periodo": 202510,
        "valor": 6745264997968.27,
        "delta": 40314514110.7598
      },
      {
        "periodo": 202511,
        "valor": 6882044167479.37,
        "delta": 136779169511.1006
      },
      {
        "periodo": 202512,
        "valor": 7021827352793.98,
        "delta": 139783185314.6104
      },
      {
        "periodo": 202601,
        "valor": 6846945826341.85,
        "delta": -174881526452.1309
      },
      {
        "periodo": 202602,
        "valor": 6914545666066.56,
        "delta": 67599839724.71
      },
      {
        "periodo": 202603,
        "valor": 7009211186603.15,
        "delta": 94665520536.5908
      },
      {
        "periodo": 202604,
        "valor": 7018091266412.66,
        "delta": 8880079809.5098
      },
      {
        "periodo": 202605,
        "valor": 7048885727028.24,
        "delta": 30794460615.5801
      },
      {
        "periodo": 202606,
        "valor": 7022567679659.39,
        "delta": -26318047368.8506
      },
      {
        "periodo": 202607,
        "valor": 7035178846682.029,
        "delta": 12611167022.6396
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 133771954662.72,
    "valor_anterior": 127686702328.74,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 168447984522.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 149861356896.65,
        "delta": -18586627626.07
      },
      {
        "periodo": 202509,
        "valor": 113107417282.07,
        "delta": -36753939614.58
      },
      {
        "periodo": 202510,
        "valor": 112768914894.45,
        "delta": -338502387.62
      },
      {
        "periodo": 202511,
        "valor": 110739026058.06,
        "delta": -2029888836.39
      },
      {
        "periodo": 202512,
        "valor": 137067193499.23,
        "delta": 26328167441.17
      },
      {
        "periodo": 202601,
        "valor": 121321579395.31,
        "delta": -15745614103.92
      },
      {
        "periodo": 202602,
        "valor": 127244652982.2,
        "delta": 5923073586.89
      },
      {
        "periodo": 202603,
        "valor": 127619885265.29,
        "delta": 375232283.09
      },
      {
        "periodo": 202604,
        "valor": 129865998929.73,
        "delta": 2246113664.44
      },
      {
        "periodo": 202605,
        "valor": 124769772012.22,
        "delta": -5096226917.51
      },
      {
        "periodo": 202606,
        "valor": 127686702328.74,
        "delta": 2916930316.52
      },
      {
        "periodo": 202607,
        "valor": 133771954662.72,
        "delta": 6085252333.98
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 685071227907.1,
    "valor_anterior": 684485313779.48,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 717072302571.09,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 720068920733.29,
        "delta": 2996618162.2001
      },
      {
        "periodo": 202509,
        "valor": 670196788195.12,
        "delta": -49872132538.17
      },
      {
        "periodo": 202510,
        "valor": 719841540253.9498,
        "delta": 49644752058.8298
      },
      {
        "periodo": 202511,
        "valor": 750203653127.71,
        "delta": 30362112873.7601
      },
      {
        "periodo": 202512,
        "valor": 718935534600.94,
        "delta": -31268118526.77
      },
      {
        "periodo": 202601,
        "valor": 711284766234.8,
        "delta": -7650768366.1399
      },
      {
        "periodo": 202602,
        "valor": 716724731263.21,
        "delta": 5439965028.4099
      },
      {
        "periodo": 202603,
        "valor": 718263303933.35,
        "delta": 1538572670.14
      },
      {
        "periodo": 202604,
        "valor": 685222096877.13,
        "delta": -33041207056.22
      },
      {
        "periodo": 202605,
        "valor": 683835131651.86,
        "delta": -1386965225.27
      },
      {
        "periodo": 202606,
        "valor": 684485313779.48,
        "delta": 650182127.62
      },
      {
        "periodo": 202607,
        "valor": 685071227907.1,
        "delta": 585914127.62
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 988322090298.39,
    "valor_anterior": 993647514992.02,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 884063468092.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 907534121455.21,
        "delta": 23470653362.8199
      },
      {
        "periodo": 202509,
        "valor": 917686315630.12,
        "delta": 10152194174.91
      },
      {
        "periodo": 202510,
        "valor": 912181242708.1,
        "delta": -5505072922.02
      },
      {
        "periodo": 202511,
        "valor": 918152600341.72,
        "delta": 5971357633.62
      },
      {
        "periodo": 202512,
        "valor": 963879801003.18,
        "delta": 45727200661.4601
      },
      {
        "periodo": 202601,
        "valor": 933482525196.0199,
        "delta": -30397275807.1602
      },
      {
        "periodo": 202602,
        "valor": 950384628344.29,
        "delta": 16902103148.2701
      },
      {
        "periodo": 202603,
        "valor": 987652239671.8,
        "delta": 37267611327.51
      },
      {
        "periodo": 202604,
        "valor": 980230561533.22,
        "delta": -7421678138.5801
      },
      {
        "periodo": 202605,
        "valor": 989630541739.01,
        "delta": 9399980205.79
      },
      {
        "periodo": 202606,
        "valor": 993647514992.02,
        "delta": 4016973253.01
      },
      {
        "periodo": 202607,
        "valor": 988322090298.39,
        "delta": -5325424693.63
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 278275765932.0,
    "valor_anterior": 290334613082.77,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 234195014130.11,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 244151932549.32,
        "delta": 9956918419.21
      },
      {
        "periodo": 202509,
        "valor": 266923596360.2,
        "delta": 22771663810.88
      },
      {
        "periodo": 202510,
        "valor": 266490721544.38,
        "delta": -432874815.82
      },
      {
        "periodo": 202511,
        "valor": 267082469864.48,
        "delta": 591748320.1
      },
      {
        "periodo": 202512,
        "valor": 278860022978.56,
        "delta": 11777553114.08
      },
      {
        "periodo": 202601,
        "valor": 263229150879.7,
        "delta": -15630872098.86
      },
      {
        "periodo": 202602,
        "valor": 263510662427.16,
        "delta": 281511547.46
      },
      {
        "periodo": 202603,
        "valor": 279837144718.18,
        "delta": 16326482291.02
      },
      {
        "periodo": 202604,
        "valor": 270797374087.0,
        "delta": -9039770631.18
      },
      {
        "periodo": 202605,
        "valor": 271110999756.52,
        "delta": 313625669.52
      },
      {
        "periodo": 202606,
        "valor": 290334613082.77,
        "delta": 19223613326.25
      },
      {
        "periodo": 202607,
        "valor": 278275765932.0,
        "delta": -12058847150.77
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100042,
    "label": "Captación",
    "valor_actual": 531592683958.16,
    "valor_anterior": 522862020118.35,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 457615331890.45,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 467699682941.5,
        "delta": 10084351051.05
      },
      {
        "periodo": 202509,
        "valor": 461074928201.98,
        "delta": -6624754739.52
      },
      {
        "periodo": 202510,
        "valor": 478897810352.3,
        "delta": 17822882150.32
      },
      {
        "periodo": 202511,
        "valor": 477005629027.71,
        "delta": -1892181324.59
      },
      {
        "periodo": 202512,
        "valor": 480410266371.69,
        "delta": 3404637343.98
      },
      {
        "periodo": 202601,
        "valor": 483528032775.43,
        "delta": 3117766403.74
      },
      {
        "periodo": 202602,
        "valor": 499154252138.99,
        "delta": 15626219363.56
      },
      {
        "periodo": 202603,
        "valor": 507768433287.43,
        "delta": 8614181148.44
      },
      {
        "periodo": 202604,
        "valor": 522133744807.31,
        "delta": 14365311519.88
      },
      {
        "periodo": 202605,
        "valor": 525161150613.26,
        "delta": 3027405805.95
      },
      {
        "periodo": 202606,
        "valor": 522862020118.35,
        "delta": -2299130494.91
      },
      {
        "periodo": 202607,
        "valor": 531592683958.16,
        "delta": 8730663839.81
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 29248150088.57,
    "valor_anterior": 26447650428.12,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26275179989.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26453200974.21,
        "delta": 178020984.95
      },
      {
        "periodo": 202509,
        "valor": 24613979763.55,
        "delta": -1839221210.66
      },
      {
        "periodo": 202510,
        "valor": 28912738294.01,
        "delta": 4298758530.46
      },
      {
        "periodo": 202511,
        "valor": 29392568984.55,
        "delta": 479830690.54
      },
      {
        "periodo": 202512,
        "valor": 33020699280.21,
        "delta": 3628130295.66
      },
      {
        "periodo": 202601,
        "valor": 31388296398.99,
        "delta": -1632402881.22
      },
      {
        "periodo": 202602,
        "valor": 28665013768.48,
        "delta": -2723282630.51
      },
      {
        "periodo": 202603,
        "valor": 30835689628.98,
        "delta": 2170675860.5
      },
      {
        "periodo": 202604,
        "valor": 31044854499.28,
        "delta": 209164870.3
      },
      {
        "periodo": 202605,
        "valor": 30557503755.36,
        "delta": -487350743.92
      },
      {
        "periodo": 202606,
        "valor": 26447650428.12,
        "delta": -4109853327.24
      },
      {
        "periodo": 202607,
        "valor": 29248150088.57,
        "delta": 2800499660.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 50743346785.68,
    "valor_anterior": 46532114970.35,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 50108977698.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 42532939694.99,
        "delta": -7576038003.54
      },
      {
        "periodo": 202509,
        "valor": 56938581821.81,
        "delta": 14405642126.82
      },
      {
        "periodo": 202510,
        "valor": 49365692115.69,
        "delta": -7572889706.12
      },
      {
        "periodo": 202511,
        "valor": 60090299629.16,
        "delta": 10724607513.47
      },
      {
        "periodo": 202512,
        "valor": 70811989969.76,
        "delta": 10721690340.6
      },
      {
        "periodo": 202601,
        "valor": 50246639640.04,
        "delta": -20565350329.72
      },
      {
        "periodo": 202602,
        "valor": 47547172207.78,
        "delta": -2699467432.26
      },
      {
        "periodo": 202603,
        "valor": 54558951508.76,
        "delta": 7011779300.98
      },
      {
        "periodo": 202604,
        "valor": 48307945951.93,
        "delta": -6251005556.83
      },
      {
        "periodo": 202605,
        "valor": 51402277044.24,
        "delta": 3094331092.31
      },
      {
        "periodo": 202606,
        "valor": 46532114970.35,
        "delta": -4870162073.89
      },
      {
        "periodo": 202607,
        "valor": 50743346785.68,
        "delta": 4211231815.33
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 32385953752.0,
    "valor_anterior": 34716194898.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 33479179754.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 30710444887.0,
        "delta": -2768734867.0
      },
      {
        "periodo": 202509,
        "valor": 31139715445.0,
        "delta": 429270558.0
      },
      {
        "periodo": 202510,
        "valor": 31111851545.0,
        "delta": -27863900.0
      },
      {
        "periodo": 202511,
        "valor": 33550348186.0,
        "delta": 2438496641.0
      },
      {
        "periodo": 202512,
        "valor": 38383174394.0,
        "delta": 4832826208.0
      },
      {
        "periodo": 202601,
        "valor": 35118036957.0,
        "delta": -3265137437.0
      },
      {
        "periodo": 202602,
        "valor": 33252804858.0,
        "delta": -1865232099.0
      },
      {
        "periodo": 202603,
        "valor": 38218282188.0,
        "delta": 4965477330.0
      },
      {
        "periodo": 202604,
        "valor": 32762307255.0,
        "delta": -5455974933.0
      },
      {
        "periodo": 202605,
        "valor": 35362728403.0,
        "delta": 2600421148.0
      },
      {
        "periodo": 202606,
        "valor": 34716194898.0,
        "delta": -646533505.0
      },
      {
        "periodo": 202607,
        "valor": 32385953752.0,
        "delta": -2330241146.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 28361071875.999996,
    "valor_anterior": 31113189969.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30885912301.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 30319228122.0,
        "delta": -566684179.0
      },
      {
        "periodo": 202509,
        "valor": 30632290912.0,
        "delta": 313062790.0
      },
      {
        "periodo": 202510,
        "valor": 30274523009.0,
        "delta": -357767903.0
      },
      {
        "periodo": 202511,
        "valor": 33041697041.0,
        "delta": 2767174032.0
      },
      {
        "periodo": 202512,
        "valor": 33324001386.0,
        "delta": 282304345.0
      },
      {
        "periodo": 202601,
        "valor": 31129063552.0,
        "delta": -2194937834.0
      },
      {
        "periodo": 202602,
        "valor": 28271359406.0,
        "delta": -2857704146.0
      },
      {
        "periodo": 202603,
        "valor": 26767959092.0,
        "delta": -1503400314.0
      },
      {
        "periodo": 202604,
        "valor": 25108556312.0,
        "delta": -1659402780.0
      },
      {
        "periodo": 202605,
        "valor": 27920245081.0,
        "delta": 2811688769.0
      },
      {
        "periodo": 202606,
        "valor": 31113189969.0,
        "delta": 3192944888.0
      },
      {
        "periodo": 202607,
        "valor": 28361071876.0,
        "delta": -2752118093.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 2182121500.38,
    "valor_anterior": 2021426122.81,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2275724625.4,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1501956779.42,
        "delta": -773767845.98
      },
      {
        "periodo": 202509,
        "valor": 1922770172.99,
        "delta": 420813393.57
      },
      {
        "periodo": 202510,
        "valor": 1991960338.65,
        "delta": 69190165.66
      },
      {
        "periodo": 202511,
        "valor": 1886933027.92,
        "delta": -105027310.73
      },
      {
        "periodo": 202512,
        "valor": 2832185061.16,
        "delta": 945252033.24
      },
      {
        "periodo": 202601,
        "valor": 2039829370.12,
        "delta": -792355691.04
      },
      {
        "periodo": 202602,
        "valor": 1738996203.58,
        "delta": -300833166.54
      },
      {
        "periodo": 202603,
        "valor": 2897943410.2,
        "delta": 1158947206.62
      },
      {
        "periodo": 202604,
        "valor": 2381853458.9,
        "delta": -516089951.3
      },
      {
        "periodo": 202605,
        "valor": 1703685091.75,
        "delta": -678168367.15
      },
      {
        "periodo": 202606,
        "valor": 2021426122.81,
        "delta": 317741031.06
      },
      {
        "periodo": 202607,
        "valor": 2182121500.38,
        "delta": 160695377.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 1924182698.0,
    "valor_anterior": 2163023817.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2012856820.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1800974138.0,
        "delta": -211882682.0
      },
      {
        "periodo": 202509,
        "valor": 1940692739.0,
        "delta": 139718601.0
      },
      {
        "periodo": 202510,
        "valor": 1528104180.0,
        "delta": -412588559.0
      },
      {
        "periodo": 202511,
        "valor": 1985651206.0,
        "delta": 457547026.0
      },
      {
        "periodo": 202512,
        "valor": 2190932443.0,
        "delta": 205281237.0
      },
      {
        "periodo": 202601,
        "valor": 2066046685.0,
        "delta": -124885758.0
      },
      {
        "periodo": 202602,
        "valor": 1988185414.0,
        "delta": -77861271.0
      },
      {
        "periodo": 202603,
        "valor": 2190304813.0,
        "delta": 202119399.0
      },
      {
        "periodo": 202604,
        "valor": 1878758688.0,
        "delta": -311546125.0
      },
      {
        "periodo": 202605,
        "valor": 1661930677.0,
        "delta": -216828011.0
      },
      {
        "periodo": 202606,
        "valor": 2163023817.0,
        "delta": 501093140.0
      },
      {
        "periodo": 202607,
        "valor": 1924182698.0,
        "delta": -238841119.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 560554052.0,
    "valor_anterior": 532742689.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 544998130.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 461867133.0,
        "delta": -83130997.0
      },
      {
        "periodo": 202509,
        "valor": 474918961.0,
        "delta": 13051828.0
      },
      {
        "periodo": 202510,
        "valor": 589659865.0,
        "delta": 114740904.0
      },
      {
        "periodo": 202511,
        "valor": 613580642.0,
        "delta": 23920777.0
      },
      {
        "periodo": 202512,
        "valor": 557458901.0,
        "delta": -56121741.0
      },
      {
        "periodo": 202601,
        "valor": 527484164.0,
        "delta": -29974737.0
      },
      {
        "periodo": 202602,
        "valor": 500018052.0,
        "delta": -27466112.0
      },
      {
        "periodo": 202603,
        "valor": 583041331.0,
        "delta": 83023279.0
      },
      {
        "periodo": 202604,
        "valor": 545565419.0,
        "delta": -37475912.0
      },
      {
        "periodo": 202605,
        "valor": 544526260.0,
        "delta": -1039159.0
      },
      {
        "periodo": 202606,
        "valor": 532742689.0,
        "delta": -11783571.0
      },
      {
        "periodo": 202607,
        "valor": 560554052.0,
        "delta": 27811363.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 6713927564.0,
    "valor_anterior": 7055428687.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6968791971.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6471365096.0,
        "delta": -497426875.0
      },
      {
        "periodo": 202509,
        "valor": 6965233062.0,
        "delta": 493867966.0
      },
      {
        "periodo": 202510,
        "valor": 6257601066.0,
        "delta": -707631996.0
      },
      {
        "periodo": 202511,
        "valor": 7718549770.0,
        "delta": 1460948704.0
      },
      {
        "periodo": 202512,
        "valor": 7518718221.0,
        "delta": -199831549.0
      },
      {
        "periodo": 202601,
        "valor": 7348622486.0,
        "delta": -170095735.0
      },
      {
        "periodo": 202602,
        "valor": 7156995237.0,
        "delta": -191627249.0
      },
      {
        "periodo": 202603,
        "valor": 7993266430.0,
        "delta": 836271193.0
      },
      {
        "periodo": 202604,
        "valor": 7736130876.0,
        "delta": -257135554.0
      },
      {
        "periodo": 202605,
        "valor": 7567870488.0,
        "delta": -168260388.0
      },
      {
        "periodo": 202606,
        "valor": 7055428687.0,
        "delta": -512441801.0
      },
      {
        "periodo": 202607,
        "valor": 6713927564.0,
        "delta": -341501123.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 1718572935.81,
    "valor_anterior": 1921216452.56,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1767509811.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1435233400.86,
        "delta": -332276410.39
      },
      {
        "periodo": 202509,
        "valor": 1627711081.21,
        "delta": 192477680.35
      },
      {
        "periodo": 202510,
        "valor": 1619212608.21,
        "delta": -8498473.0
      },
      {
        "periodo": 202511,
        "valor": 1769060882.63,
        "delta": 149848274.42
      },
      {
        "periodo": 202512,
        "valor": 2172931647.09,
        "delta": 403870764.46
      },
      {
        "periodo": 202601,
        "valor": 1749764772.95,
        "delta": -423166874.14
      },
      {
        "periodo": 202602,
        "valor": 1542775574.54,
        "delta": -206989198.41
      },
      {
        "periodo": 202603,
        "valor": 2376243391.06,
        "delta": 833467816.52
      },
      {
        "periodo": 202604,
        "valor": 1698812725.99,
        "delta": -677430665.07
      },
      {
        "periodo": 202605,
        "valor": 1709533681.38,
        "delta": 10720955.39
      },
      {
        "periodo": 202606,
        "valor": 1921216452.56,
        "delta": 211682771.18
      },
      {
        "periodo": 202607,
        "valor": 1718572935.81,
        "delta": -202643516.75
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 12854907.0,
    "valor_anterior": 12106946.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8606055.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7562740.0,
        "delta": -1043315.0
      },
      {
        "periodo": 202509,
        "valor": 9870616.0,
        "delta": 2307876.0
      },
      {
        "periodo": 202510,
        "valor": 12417857.0,
        "delta": 2547241.0
      },
      {
        "periodo": 202511,
        "valor": 8625095.0,
        "delta": -3792762.0
      },
      {
        "periodo": 202512,
        "valor": 9268581.0,
        "delta": 643486.0
      },
      {
        "periodo": 202601,
        "valor": 8761146.0,
        "delta": -507435.0
      },
      {
        "periodo": 202602,
        "valor": 6005218.0,
        "delta": -2755928.0
      },
      {
        "periodo": 202603,
        "valor": 6970784.0,
        "delta": 965566.0
      },
      {
        "periodo": 202604,
        "valor": 10217065.0,
        "delta": 3246281.0
      },
      {
        "periodo": 202605,
        "valor": 10465884.0,
        "delta": 248819.0
      },
      {
        "periodo": 202606,
        "valor": 12106946.0,
        "delta": 1641062.0
      },
      {
        "periodo": 202607,
        "valor": 12854907.0,
        "delta": 747961.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 182195103.0,
    "valor_anterior": 238295362.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 166654624.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 138325299.0,
        "delta": -28329325.0
      },
      {
        "periodo": 202509,
        "valor": 151390652.0,
        "delta": 13065353.0
      },
      {
        "periodo": 202510,
        "valor": 170769249.0,
        "delta": 19378597.0
      },
      {
        "periodo": 202511,
        "valor": 199855446.0,
        "delta": 29086197.0
      },
      {
        "periodo": 202512,
        "valor": 202237276.0,
        "delta": 2381830.0
      },
      {
        "periodo": 202601,
        "valor": 204996301.0,
        "delta": 2759025.0
      },
      {
        "periodo": 202602,
        "valor": 202709367.0,
        "delta": -2286934.0
      },
      {
        "periodo": 202603,
        "valor": 222425950.0,
        "delta": 19716583.0
      },
      {
        "periodo": 202604,
        "valor": 177555910.0,
        "delta": -44870040.0
      },
      {
        "periodo": 202605,
        "valor": 183654832.0,
        "delta": 6098922.0
      },
      {
        "periodo": 202606,
        "valor": 238295362.0,
        "delta": 54640530.0
      },
      {
        "periodo": 202607,
        "valor": 182195103.0,
        "delta": -56100259.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 2351672570.0,
    "valor_anterior": 1999499454.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1848666731.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2045166919.0,
        "delta": 196500188.0
      },
      {
        "periodo": 202509,
        "valor": 2001615627.0,
        "delta": -43551292.0
      },
      {
        "periodo": 202510,
        "valor": 2271134331.0,
        "delta": 269518704.0
      },
      {
        "periodo": 202511,
        "valor": 2548413685.0,
        "delta": 277279354.0
      },
      {
        "periodo": 202512,
        "valor": 2398023120.0,
        "delta": -150390565.0
      },
      {
        "periodo": 202601,
        "valor": 2251559165.0,
        "delta": -146463955.0
      },
      {
        "periodo": 202602,
        "valor": 2216399794.0,
        "delta": -35159371.0
      },
      {
        "periodo": 202603,
        "valor": 2469890352.0,
        "delta": 253490558.0
      },
      {
        "periodo": 202604,
        "valor": 2181074386.0,
        "delta": -288815966.0
      },
      {
        "periodo": 202605,
        "valor": 2321587545.0,
        "delta": 140513159.0
      },
      {
        "periodo": 202606,
        "valor": 1999499454.0,
        "delta": -322088091.0
      },
      {
        "periodo": 202607,
        "valor": 2351672570.0,
        "delta": 352173116.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 33876217474.09,
    "valor_anterior": 29083101543.89,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 31854995732.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29412181871.53,
        "delta": -2442813860.66
      },
      {
        "periodo": 202509,
        "valor": 27676423129.68,
        "delta": -1735758741.85
      },
      {
        "periodo": 202510,
        "valor": 30484486765.04,
        "delta": 2808063635.36
      },
      {
        "periodo": 202511,
        "valor": 33256747986.81,
        "delta": 2772261221.77
      },
      {
        "periodo": 202512,
        "valor": 30487779721.82,
        "delta": -2768968264.99
      },
      {
        "periodo": 202601,
        "valor": 34774366958.56,
        "delta": 4286587236.74
      },
      {
        "periodo": 202602,
        "valor": 32590310383.54,
        "delta": -2184056575.02
      },
      {
        "periodo": 202603,
        "valor": 29880895469.38,
        "delta": -2709414914.16
      },
      {
        "periodo": 202604,
        "valor": 34876879350.74,
        "delta": 4995983881.36
      },
      {
        "periodo": 202605,
        "valor": 33653476564.1,
        "delta": -1223402786.64
      },
      {
        "periodo": 202606,
        "valor": 29083101543.89,
        "delta": -4570375020.21
      },
      {
        "periodo": 202607,
        "valor": 33876217474.09,
        "delta": 4793115930.2
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 266936.0,
    "valor_anterior": 268751.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 313232.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 311125.0,
        "delta": -2107.0
      },
      {
        "periodo": 202509,
        "valor": 301636.0,
        "delta": -9489.0
      },
      {
        "periodo": 202510,
        "valor": 304338.0,
        "delta": 2702.0
      },
      {
        "periodo": 202511,
        "valor": 301438.0,
        "delta": -2900.0
      },
      {
        "periodo": 202512,
        "valor": 289323.0,
        "delta": -12115.0
      },
      {
        "periodo": 202601,
        "valor": 273833.0,
        "delta": -15490.0
      },
      {
        "periodo": 202602,
        "valor": 271912.0,
        "delta": -1921.0
      },
      {
        "periodo": 202603,
        "valor": 282085.0,
        "delta": 10173.0
      },
      {
        "periodo": 202604,
        "valor": 268447.0,
        "delta": -13638.0
      },
      {
        "periodo": 202605,
        "valor": 267134.0,
        "delta": -1313.0
      },
      {
        "periodo": 202606,
        "valor": 268751.0,
        "delta": 1617.0
      },
      {
        "periodo": 202607,
        "valor": 266936.0,
        "delta": -1815.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 50230.0,
    "valor_anterior": 50746.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 56604.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55985.0,
        "delta": -619.0
      },
      {
        "periodo": 202509,
        "valor": 54944.0,
        "delta": -1041.0
      },
      {
        "periodo": 202510,
        "valor": 55739.0,
        "delta": 795.0
      },
      {
        "periodo": 202511,
        "valor": 54886.0,
        "delta": -853.0
      },
      {
        "periodo": 202512,
        "valor": 54024.0,
        "delta": -862.0
      },
      {
        "periodo": 202601,
        "valor": 52260.0,
        "delta": -1764.0
      },
      {
        "periodo": 202602,
        "valor": 51695.0,
        "delta": -565.0
      },
      {
        "periodo": 202603,
        "valor": 53776.0,
        "delta": 2081.0
      },
      {
        "periodo": 202604,
        "valor": 52406.0,
        "delta": -1370.0
      },
      {
        "periodo": 202605,
        "valor": 50286.0,
        "delta": -2120.0
      },
      {
        "periodo": 202606,
        "valor": 50746.0,
        "delta": 460.0
      },
      {
        "periodo": 202607,
        "valor": 50230.0,
        "delta": -516.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 16023260.72,
    "valor_anterior": 18139611.08,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 23040824.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25796574.11,
        "delta": 2755749.24
      },
      {
        "periodo": 202509,
        "valor": 38537709.08,
        "delta": 12741134.97
      },
      {
        "periodo": 202510,
        "valor": 33566816.76,
        "delta": -4970892.32
      },
      {
        "periodo": 202511,
        "valor": 20907239.86,
        "delta": -12659576.9
      },
      {
        "periodo": 202512,
        "valor": 24797440.22,
        "delta": 3890200.36
      },
      {
        "periodo": 202601,
        "valor": 24210148.24,
        "delta": -587291.98
      },
      {
        "periodo": 202602,
        "valor": 24746888.85,
        "delta": 536740.61
      },
      {
        "periodo": 202603,
        "valor": 20244516.75,
        "delta": -4502372.1
      },
      {
        "periodo": 202604,
        "valor": 20565334.29,
        "delta": 320817.54
      },
      {
        "periodo": 202605,
        "valor": 14579423.52,
        "delta": -5985910.77
      },
      {
        "periodo": 202606,
        "valor": 18139611.08,
        "delta": 3560187.56
      },
      {
        "periodo": 202607,
        "valor": 16023260.72,
        "delta": -2116350.36
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 49188300.0,
    "valor_anterior": 39360644.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 39670551.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 41936713.0,
        "delta": 2266162.0
      },
      {
        "periodo": 202509,
        "valor": 44372999.0,
        "delta": 2436286.0
      },
      {
        "periodo": 202510,
        "valor": 39667675.0,
        "delta": -4705324.0
      },
      {
        "periodo": 202511,
        "valor": 38553554.0,
        "delta": -1114121.0
      },
      {
        "periodo": 202512,
        "valor": 49810567.0,
        "delta": 11257013.0
      },
      {
        "periodo": 202601,
        "valor": 44387655.0,
        "delta": -5422912.0
      },
      {
        "periodo": 202602,
        "valor": 47926902.0,
        "delta": 3539247.0
      },
      {
        "periodo": 202603,
        "valor": 41535812.0,
        "delta": -6391090.0
      },
      {
        "periodo": 202604,
        "valor": 43572797.0,
        "delta": 2036985.0
      },
      {
        "periodo": 202605,
        "valor": 36424540.0,
        "delta": -7148257.0
      },
      {
        "periodo": 202606,
        "valor": 39360644.0,
        "delta": 2936104.0
      },
      {
        "periodo": 202607,
        "valor": 49188300.0,
        "delta": 9827656.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 16663.0,
    "valor_anterior": 16663.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14000.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14000.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 14000.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 14000.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 16663.0,
        "delta": 2663.0
      },
      {
        "periodo": 202512,
        "valor": 14000.0,
        "delta": -2663.0
      },
      {
        "periodo": 202601,
        "valor": 14000.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 14000.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 14000.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 14000.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 16663.0,
        "delta": 2663.0
      },
      {
        "periodo": 202606,
        "valor": 16663.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 16663.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 13976666019.51,
    "valor_anterior": 10875318860.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11758594446.05,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9980010431.06,
        "delta": -1778584014.99
      },
      {
        "periodo": 202509,
        "valor": 10985364932.69,
        "delta": 1005354501.63
      },
      {
        "periodo": 202510,
        "valor": 13865628963.37,
        "delta": 2880264030.68
      },
      {
        "periodo": 202511,
        "valor": 11988253325.77,
        "delta": -1877375637.6
      },
      {
        "periodo": 202512,
        "valor": 12952793462.07,
        "delta": 964540136.3
      },
      {
        "periodo": 202601,
        "valor": 12743735642.19,
        "delta": -209057819.88
      },
      {
        "periodo": 202602,
        "valor": 10969108380.77,
        "delta": -1774627261.42
      },
      {
        "periodo": 202603,
        "valor": 12928814644.03,
        "delta": 1959706263.26
      },
      {
        "periodo": 202604,
        "valor": 13818289595.0,
        "delta": 889474950.97
      },
      {
        "periodo": 202605,
        "valor": 10789589637.74,
        "delta": -3028699957.26
      },
      {
        "periodo": 202606,
        "valor": 10875318860.25,
        "delta": 85729222.51
      },
      {
        "periodo": 202607,
        "valor": 13976666019.51,
        "delta": 3101347159.26
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 2595514451.0,
    "valor_anterior": 2152086362.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 68106679.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 64534144.54,
        "delta": -3572535.39
      },
      {
        "periodo": 202509,
        "valor": 748034286.0,
        "delta": 683500141.46
      },
      {
        "periodo": 202510,
        "valor": 479611874.0,
        "delta": -268422412.0
      },
      {
        "periodo": 202511,
        "valor": 874355757.0,
        "delta": 394743883.0
      },
      {
        "periodo": 202512,
        "valor": 1541773825.0,
        "delta": 667418068.0
      },
      {
        "periodo": 202601,
        "valor": 1911084738.0,
        "delta": 369310913.0
      },
      {
        "periodo": 202602,
        "valor": 3720794922.0,
        "delta": 1809710184.0
      },
      {
        "periodo": 202603,
        "valor": 4339582756.0,
        "delta": 618787834.0
      },
      {
        "periodo": 202604,
        "valor": 1766678620.0,
        "delta": -2572904136.0
      },
      {
        "periodo": 202605,
        "valor": 2124576405.0,
        "delta": 357897785.0
      },
      {
        "periodo": 202606,
        "valor": 2152086362.0,
        "delta": 27509957.0
      },
      {
        "periodo": 202607,
        "valor": 2595514451.0,
        "delta": 443428089.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 22000.0,
    "valor_anterior": 22000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22000.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 22000.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 22000.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 22000.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 22000.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 22000.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 22000.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 22000.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 22000.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 22000.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 22000.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 22000.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 22000.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 1793508941.0,
    "valor_anterior": 2375650549.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1749832145.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1736220774.0,
        "delta": -13611371.0
      },
      {
        "periodo": 202509,
        "valor": 1857278487.0,
        "delta": 121057713.0
      },
      {
        "periodo": 202510,
        "valor": 1846172577.0,
        "delta": -11105910.0
      },
      {
        "periodo": 202511,
        "valor": 2166464949.0,
        "delta": 320292372.0
      },
      {
        "periodo": 202512,
        "valor": 2321225722.0,
        "delta": 154760773.0
      },
      {
        "periodo": 202601,
        "valor": 2066529140.0,
        "delta": -254696582.0
      },
      {
        "periodo": 202602,
        "valor": 1978072888.0,
        "delta": -88456252.0
      },
      {
        "periodo": 202603,
        "valor": 2400918488.0,
        "delta": 422845600.0
      },
      {
        "periodo": 202604,
        "valor": 1765820249.0,
        "delta": -635098239.0
      },
      {
        "periodo": 202605,
        "valor": 1707681664.0,
        "delta": -58138585.0
      },
      {
        "periodo": 202606,
        "valor": 2375650549.0,
        "delta": 667968885.0
      },
      {
        "periodo": 202607,
        "valor": 1793508941.0,
        "delta": -582141608.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 177283689.0,
    "valor_anterior": 197926530.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 195334333.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 199311406.0,
        "delta": 3977073.0
      },
      {
        "periodo": 202509,
        "valor": 178512020.0,
        "delta": -20799386.0
      },
      {
        "periodo": 202510,
        "valor": 176260705.0,
        "delta": -2251315.0
      },
      {
        "periodo": 202511,
        "valor": 208128347.0,
        "delta": 31867642.0
      },
      {
        "periodo": 202512,
        "valor": 189236039.0,
        "delta": -18892308.0
      },
      {
        "periodo": 202601,
        "valor": 191279533.0,
        "delta": 2043494.0
      },
      {
        "periodo": 202602,
        "valor": 189859234.0,
        "delta": -1420299.0
      },
      {
        "periodo": 202603,
        "valor": 183513287.0,
        "delta": -6345947.0
      },
      {
        "periodo": 202604,
        "valor": 199843780.0,
        "delta": 16330493.0
      },
      {
        "periodo": 202605,
        "valor": 188353070.0,
        "delta": -11490710.0
      },
      {
        "periodo": 202606,
        "valor": 197926530.0,
        "delta": 9573460.0
      },
      {
        "periodo": 202607,
        "valor": 177283689.0,
        "delta": -20642841.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 191226502.0,
    "valor_anterior": 197904393.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 187915792.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 203890537.0,
        "delta": 15974745.0
      },
      {
        "periodo": 202509,
        "valor": 194263867.0,
        "delta": -9626670.0
      },
      {
        "periodo": 202510,
        "valor": 236082021.0,
        "delta": 41818154.0
      },
      {
        "periodo": 202511,
        "valor": 192011097.0,
        "delta": -44070924.0
      },
      {
        "periodo": 202512,
        "valor": 214645037.0,
        "delta": 22633940.0
      },
      {
        "periodo": 202601,
        "valor": 240167814.0,
        "delta": 25522777.0
      },
      {
        "periodo": 202602,
        "valor": 183740702.0,
        "delta": -56427112.0
      },
      {
        "periodo": 202603,
        "valor": 198176092.0,
        "delta": 14435390.0
      },
      {
        "periodo": 202604,
        "valor": 198898155.0,
        "delta": 722063.0
      },
      {
        "periodo": 202605,
        "valor": 198271273.0,
        "delta": -626882.0
      },
      {
        "periodo": 202606,
        "valor": 197904393.0,
        "delta": -366880.0
      },
      {
        "periodo": 202607,
        "valor": 191226502.0,
        "delta": -6677891.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 6000.0,
    "valor_anterior": 6000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 545633111.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 866263017.0,
        "delta": 320629906.0
      },
      {
        "periodo": 202509,
        "valor": 114821847.0,
        "delta": -751441170.0
      },
      {
        "periodo": 202510,
        "valor": 115294077.0,
        "delta": 472230.0
      },
      {
        "periodo": 202511,
        "valor": 114683564.0,
        "delta": -610513.0
      },
      {
        "periodo": 202512,
        "valor": 103534404.0,
        "delta": -11149160.0
      },
      {
        "periodo": 202601,
        "valor": 102724388.0,
        "delta": -810016.0
      },
      {
        "periodo": 202602,
        "valor": 5454016.0,
        "delta": -97270372.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": -5454016.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 6000.0,
        "delta": 6000.0
      },
      {
        "periodo": 202607,
        "valor": 6000.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 13413244292.819998,
    "valor_anterior": 13825929376.02,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13136531010.49,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10006605883.82,
        "delta": -3129925126.67
      },
      {
        "periodo": 202509,
        "valor": 13236365055.57,
        "delta": 3229759171.75
      },
      {
        "periodo": 202510,
        "valor": 12409561924.4,
        "delta": -826803131.17
      },
      {
        "periodo": 202511,
        "valor": 10896044122.33,
        "delta": -1513517802.07
      },
      {
        "periodo": 202512,
        "valor": 14501007098.89,
        "delta": 3604962976.56
      },
      {
        "periodo": 202601,
        "valor": 12525072224.09,
        "delta": -1975934874.8
      },
      {
        "periodo": 202602,
        "valor": 12193512228.31,
        "delta": -331559995.78
      },
      {
        "periodo": 202603,
        "valor": 16454422651.97,
        "delta": 4260910423.66
      },
      {
        "periodo": 202604,
        "valor": 14261745349.94,
        "delta": -2192677302.03
      },
      {
        "periodo": 202605,
        "valor": 11711276841.53,
        "delta": -2550468508.41
      },
      {
        "periodo": 202606,
        "valor": 13825929376.02,
        "delta": 2114652534.49
      },
      {
        "periodo": 202607,
        "valor": 13413244292.82,
        "delta": -412685083.2
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 303351.0,
    "valor_anterior": 1083122.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3714816.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7231812.0,
        "delta": 3516996.0
      },
      {
        "periodo": 202509,
        "valor": 7535970.0,
        "delta": 304158.0
      },
      {
        "periodo": 202510,
        "valor": 7155636.0,
        "delta": -380334.0
      },
      {
        "periodo": 202511,
        "valor": 7174577.0,
        "delta": 18941.0
      },
      {
        "periodo": 202512,
        "valor": 6952297.0,
        "delta": -222280.0
      },
      {
        "periodo": 202601,
        "valor": 636442.0,
        "delta": -6315855.0
      },
      {
        "periodo": 202602,
        "valor": 1223701.0,
        "delta": 587259.0
      },
      {
        "periodo": 202603,
        "valor": 742659.0,
        "delta": -481042.0
      },
      {
        "periodo": 202604,
        "valor": 1259618.0,
        "delta": 516959.0
      },
      {
        "periodo": 202605,
        "valor": 1207531.0,
        "delta": -52087.0
      },
      {
        "periodo": 202606,
        "valor": 1083122.0,
        "delta": -124409.0
      },
      {
        "periodo": 202607,
        "valor": 303351.0,
        "delta": -779771.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 4330175.0,
    "valor_anterior": 4374650.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5584928.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5523804.0,
        "delta": -61124.0
      },
      {
        "periodo": 202509,
        "valor": 5421151.0,
        "delta": -102653.0
      },
      {
        "periodo": 202510,
        "valor": 5499562.0,
        "delta": 78411.0
      },
      {
        "periodo": 202511,
        "valor": 5415409.0,
        "delta": -84153.0
      },
      {
        "periodo": 202512,
        "valor": 5330368.0,
        "delta": -85041.0
      },
      {
        "periodo": 202601,
        "valor": 5156350.0,
        "delta": -174018.0
      },
      {
        "periodo": 202602,
        "valor": 5100613.0,
        "delta": -55737.0
      },
      {
        "periodo": 202603,
        "valor": 5305859.0,
        "delta": 205246.0
      },
      {
        "periodo": 202604,
        "valor": 5170765.0,
        "delta": -135094.0
      },
      {
        "periodo": 202605,
        "valor": 5132670.0,
        "delta": -38095.0
      },
      {
        "periodo": 202606,
        "valor": 4374650.0,
        "delta": -758020.0
      },
      {
        "periodo": 202607,
        "valor": 4330175.0,
        "delta": -44475.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 1287824.0,
    "valor_anterior": 1098932.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1799371.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1192147.0,
        "delta": -607224.0
      },
      {
        "periodo": 202509,
        "valor": 1194437.0,
        "delta": 2290.0
      },
      {
        "periodo": 202510,
        "valor": 1417105.0,
        "delta": 222668.0
      },
      {
        "periodo": 202511,
        "valor": 1819747.0,
        "delta": 402642.0
      },
      {
        "periodo": 202512,
        "valor": 1039904.0,
        "delta": -779843.0
      },
      {
        "periodo": 202601,
        "valor": 937791.0,
        "delta": -102113.0
      },
      {
        "periodo": 202602,
        "valor": 963377.0,
        "delta": 25586.0
      },
      {
        "periodo": 202603,
        "valor": 963377.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 960577.0,
        "delta": -2800.0
      },
      {
        "periodo": 202605,
        "valor": 1032656.0,
        "delta": 72079.0
      },
      {
        "periodo": 202606,
        "valor": 1098932.0,
        "delta": 66276.0
      },
      {
        "periodo": 202607,
        "valor": 1287824.0,
        "delta": 188892.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1753955101.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1702942988.0,
        "delta": -51012113.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 14398423.0,
    "valor_anterior": 12645793.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11198723.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11338204.0,
        "delta": 139481.0
      },
      {
        "periodo": 202509,
        "valor": 14121137.0,
        "delta": 2782933.0
      },
      {
        "periodo": 202510,
        "valor": 11994078.0,
        "delta": -2127059.0
      },
      {
        "periodo": 202511,
        "valor": 13819056.0,
        "delta": 1824978.0
      },
      {
        "periodo": 202512,
        "valor": 11966019.0,
        "delta": -1853037.0
      },
      {
        "periodo": 202601,
        "valor": 14914769.0,
        "delta": 2948750.0
      },
      {
        "periodo": 202602,
        "valor": 14122080.0,
        "delta": -792689.0
      },
      {
        "periodo": 202603,
        "valor": 9348396.0,
        "delta": -4773684.0
      },
      {
        "periodo": 202604,
        "valor": 13350572.0,
        "delta": 4002176.0
      },
      {
        "periodo": 202605,
        "valor": 14912802.0,
        "delta": 1562230.0
      },
      {
        "periodo": 202606,
        "valor": 12645793.0,
        "delta": -2267009.0
      },
      {
        "periodo": 202607,
        "valor": 14398423.0,
        "delta": 1752630.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 89482367.0,
    "valor_anterior": 94955739.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 91650215.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 76410668.0,
        "delta": -15239547.0
      },
      {
        "periodo": 202509,
        "valor": 93144950.0,
        "delta": 16734282.0
      },
      {
        "periodo": 202510,
        "valor": 76557172.0,
        "delta": -16587778.0
      },
      {
        "periodo": 202511,
        "valor": 69050253.0,
        "delta": -7506919.0
      },
      {
        "periodo": 202512,
        "valor": 93234944.0,
        "delta": 24184691.0
      },
      {
        "periodo": 202601,
        "valor": 93334715.0,
        "delta": 99771.0
      },
      {
        "periodo": 202602,
        "valor": 78943786.0,
        "delta": -14390929.0
      },
      {
        "periodo": 202603,
        "valor": 96773266.0,
        "delta": 17829480.0
      },
      {
        "periodo": 202604,
        "valor": 88438723.0,
        "delta": -8334543.0
      },
      {
        "periodo": 202605,
        "valor": 87093195.0,
        "delta": -1345528.0
      },
      {
        "periodo": 202606,
        "valor": 94955739.0,
        "delta": 7862544.0
      },
      {
        "periodo": 202607,
        "valor": 89482367.0,
        "delta": -5473372.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 496632.97,
    "valor_anterior": 249845.69,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 131110.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 414272.12,
        "delta": 283162.12
      },
      {
        "periodo": 202509,
        "valor": 179466.5,
        "delta": -234805.62
      },
      {
        "periodo": 202510,
        "valor": 578396.89,
        "delta": 398930.39
      },
      {
        "periodo": 202511,
        "valor": 555398.54,
        "delta": -22998.35
      },
      {
        "periodo": 202512,
        "valor": 354821.7,
        "delta": -200576.84
      },
      {
        "periodo": 202601,
        "valor": 378939.46,
        "delta": 24117.76
      },
      {
        "periodo": 202602,
        "valor": 526704.25,
        "delta": 147764.79
      },
      {
        "periodo": 202603,
        "valor": 389621.45,
        "delta": -137082.8
      },
      {
        "periodo": 202604,
        "valor": 270870.14,
        "delta": -118751.31
      },
      {
        "periodo": 202605,
        "valor": 408715.79,
        "delta": 137845.65
      },
      {
        "periodo": 202606,
        "valor": 249845.69,
        "delta": -158870.1
      },
      {
        "periodo": 202607,
        "valor": 496632.97,
        "delta": 246787.28
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 52738239.49,
    "valor_anterior": 62308404.87,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 52413733.81,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 53216440.82,
        "delta": 802707.01
      },
      {
        "periodo": 202509,
        "valor": 44845155.59,
        "delta": -8371285.23
      },
      {
        "periodo": 202510,
        "valor": 43955194.96,
        "delta": -889960.63
      },
      {
        "periodo": 202511,
        "valor": 47673864.62,
        "delta": 3718669.66
      },
      {
        "periodo": 202512,
        "valor": 54209883.26,
        "delta": 6536018.64
      },
      {
        "periodo": 202601,
        "valor": 59846473.29,
        "delta": 5636590.03
      },
      {
        "periodo": 202602,
        "valor": 52719169.2,
        "delta": -7127304.09
      },
      {
        "periodo": 202603,
        "valor": 53744857.44,
        "delta": 1025688.24
      },
      {
        "periodo": 202604,
        "valor": 62916744.09,
        "delta": 9171886.65
      },
      {
        "periodo": 202605,
        "valor": 62850205.7,
        "delta": -66538.39
      },
      {
        "periodo": 202606,
        "valor": 62308404.87,
        "delta": -541800.83
      },
      {
        "periodo": 202607,
        "valor": 52738239.49,
        "delta": -9570165.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 52475.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 52535.0,
        "delta": 60.0
      },
      {
        "periodo": 202509,
        "valor": 51773.0,
        "delta": -762.0
      },
      {
        "periodo": 202510,
        "valor": 51997.0,
        "delta": 224.0
      },
      {
        "periodo": 202511,
        "valor": 51450.0,
        "delta": -547.0
      },
      {
        "periodo": 202512,
        "valor": 50957.0,
        "delta": -493.0
      },
      {
        "periodo": 202601,
        "valor": 4601.0,
        "delta": -46356.0
      },
      {
        "periodo": 202602,
        "valor": 6.0,
        "delta": -4595.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": -6.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 1935540.0,
    "valor_anterior": 2023260.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 559690.0,
        "delta": 559690.0
      },
      {
        "periodo": 202606,
        "valor": 2023260.0,
        "delta": 1463570.0
      },
      {
        "periodo": 202607,
        "valor": 1935540.0,
        "delta": -87720.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 222638811144.04,
    "valor_anterior": 213697411571.64,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 217823619444.78,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 198273742516.48,
        "delta": -19549876928.3
      },
      {
        "periodo": 202509,
        "valor": 213659631806.67,
        "delta": 15385889290.19
      },
      {
        "periodo": 202510,
        "valor": 213939603075.98,
        "delta": 279971269.31
      },
      {
        "periodo": 202511,
        "valor": 232707688280.19,
        "delta": 18768085204.21
      },
      {
        "periodo": 202512,
        "valor": 255981742138.18,
        "delta": 23274053857.99
      },
      {
        "periodo": 202601,
        "valor": 228878231052.93,
        "delta": -27103511085.25
      },
      {
        "periodo": 202602,
        "valor": 215145920689.3,
        "delta": -13732310363.63
      },
      {
        "periodo": 202603,
        "valor": 235736712493.02,
        "delta": 20590791803.72
      },
      {
        "periodo": 202604,
        "valor": 220958650500.3,
        "delta": -14778061992.72
      },
      {
        "periodo": 202605,
        "valor": 221543791710.11,
        "delta": 585141209.81
      },
      {
        "periodo": 202606,
        "valor": 213697411571.64,
        "delta": -7846380138.47
      },
      {
        "periodo": 202607,
        "valor": 222638811144.04,
        "delta": 8941399572.4
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 183252850238.34,
    "valor_anterior": 177110704313.36,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 181585894265.98,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 167700334783.73,
        "delta": -13885559482.25
      },
      {
        "periodo": 202509,
        "valor": 179906916873.04,
        "delta": 12206582089.31
      },
      {
        "periodo": 202510,
        "valor": 177934996974.74,
        "delta": -1971919898.3
      },
      {
        "periodo": 202511,
        "valor": 199035862803.52,
        "delta": 21100865828.78
      },
      {
        "periodo": 202512,
        "valor": 215737295415.79,
        "delta": 16701432612.27
      },
      {
        "periodo": 202601,
        "valor": 192071072677.59,
        "delta": -23666222738.2
      },
      {
        "periodo": 202602,
        "valor": 179471841274.8,
        "delta": -12599231402.79
      },
      {
        "periodo": 202603,
        "valor": 190445349130.12,
        "delta": 10973507855.32
      },
      {
        "periodo": 202604,
        "valor": 181715432932.95,
        "delta": -8729916197.17
      },
      {
        "periodo": 202605,
        "valor": 188126032012.7,
        "delta": 6410599079.75
      },
      {
        "periodo": 202606,
        "valor": 177110704313.36,
        "delta": -11015327699.34
      },
      {
        "periodo": 202607,
        "valor": 183252850238.34,
        "delta": 6142145924.98
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 30427683.72,
    "valor_anterior": 30791404.08,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2333827759.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2606340783.11,
        "delta": 272513023.24
      },
      {
        "periodo": 202509,
        "valor": 167480693.08,
        "delta": -2438860090.03
      },
      {
        "periodo": 202510,
        "valor": 160854971.76,
        "delta": -6625721.32
      },
      {
        "periodo": 202511,
        "valor": 149409859.86,
        "delta": -11445111.9
      },
      {
        "periodo": 202512,
        "valor": 140297863.22,
        "delta": -9111996.64
      },
      {
        "periodo": 202601,
        "valor": 141849305.24,
        "delta": 1551442.02
      },
      {
        "periodo": 202602,
        "valor": 44322984.85,
        "delta": -97526320.39
      },
      {
        "periodo": 202603,
        "valor": 29592912.75,
        "delta": -14730072.1
      },
      {
        "periodo": 202604,
        "valor": 33915906.29,
        "delta": 4322993.54
      },
      {
        "periodo": 202605,
        "valor": 29492225.52,
        "delta": -4423680.77
      },
      {
        "periodo": 202606,
        "valor": 30791404.08,
        "delta": 1299178.56
      },
      {
        "periodo": 202607,
        "valor": 30427683.72,
        "delta": -363720.36
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 2369213481.0,
    "valor_anterior": 2016339210.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1863263550.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2058656573.0,
        "delta": 195393023.0
      },
      {
        "periodo": 202509,
        "valor": 2017299974.0,
        "delta": -41356599.0
      },
      {
        "periodo": 202510,
        "valor": 2289447827.0,
        "delta": 272147853.0
      },
      {
        "periodo": 202511,
        "valor": 2562849176.0,
        "delta": 273401349.0
      },
      {
        "periodo": 202512,
        "valor": 2413001416.0,
        "delta": -149847760.0
      },
      {
        "periodo": 202601,
        "valor": 2265838754.0,
        "delta": -147162662.0
      },
      {
        "periodo": 202602,
        "valor": 2227865232.0,
        "delta": -37973522.0
      },
      {
        "periodo": 202603,
        "valor": 2482538856.0,
        "delta": 254673624.0
      },
      {
        "periodo": 202604,
        "valor": 2196819069.0,
        "delta": -285719787.0
      },
      {
        "periodo": 202605,
        "valor": 2337542182.0,
        "delta": 140723113.0
      },
      {
        "periodo": 202606,
        "valor": 2016339210.0,
        "delta": -321202972.0
      },
      {
        "periodo": 202607,
        "valor": 2369213481.0,
        "delta": 352874271.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 4687720477.19,
    "valor_anterior": 4712672438.37,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4823289925.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3640357967.28,
        "delta": -1182931958.37
      },
      {
        "periodo": 202509,
        "valor": 4248337007.2,
        "delta": 607979039.92
      },
      {
        "periodo": 202510,
        "valor": 4416813188.86,
        "delta": 168476181.66
      },
      {
        "periodo": 202511,
        "valor": 4516307903.55,
        "delta": 99494714.69
      },
      {
        "periodo": 202512,
        "valor": 5801673172.25,
        "delta": 1285365268.7
      },
      {
        "periodo": 202601,
        "valor": 4552750096.07,
        "delta": -1248923076.18
      },
      {
        "periodo": 202602,
        "valor": 4019575972.12,
        "delta": -533174123.95
      },
      {
        "periodo": 202603,
        "valor": 6082277231.26,
        "delta": 2062701259.14
      },
      {
        "periodo": 202604,
        "valor": 4869648180.89,
        "delta": -1212629050.37
      },
      {
        "periodo": 202605,
        "valor": 4182522643.13,
        "delta": -687125537.76
      },
      {
        "periodo": 202606,
        "valor": 4712672438.37,
        "delta": 530149795.24
      },
      {
        "periodo": 202607,
        "valor": 4687720477.19,
        "delta": -24951961.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 3111956646.46,
    "valor_anterior": 2746883228.56,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 570586970.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 544023173.48,
        "delta": -26563797.26
      },
      {
        "periodo": 202509,
        "valor": 1239394347.09,
        "delta": 695371173.61
      },
      {
        "periodo": 202510,
        "valor": 1014709543.85,
        "delta": -224684803.24
      },
      {
        "periodo": 202511,
        "valor": 1390676393.16,
        "delta": 375966849.31
      },
      {
        "periodo": 202512,
        "valor": 2113408083.96,
        "delta": 722731690.8
      },
      {
        "periodo": 202601,
        "valor": 2510445422.75,
        "delta": 397037338.79
      },
      {
        "periodo": 202602,
        "valor": 4240658351.45,
        "delta": 1730212928.7
      },
      {
        "periodo": 202603,
        "valor": 4911835201.89,
        "delta": 671176850.44
      },
      {
        "periodo": 202604,
        "valor": 2296018640.23,
        "delta": -2615816561.66
      },
      {
        "periodo": 202605,
        "valor": 2658062157.49,
        "delta": 362043517.26
      },
      {
        "periodo": 202606,
        "valor": 2746883228.56,
        "delta": 88821071.07
      },
      {
        "periodo": 202607,
        "valor": 3111956646.46,
        "delta": 365073417.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100046,
    "label": "Caja",
    "valor_actual": 29186642617.329998,
    "valor_anterior": 27080020977.27,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26646756972.54,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21724029235.88,
        "delta": -4922727736.66
      },
      {
        "periodo": 202509,
        "valor": 26080202912.26,
        "delta": 4356173676.38
      },
      {
        "periodo": 202510,
        "valor": 28122780569.77,
        "delta": 2042577657.51
      },
      {
        "periodo": 202511,
        "valor": 25052582144.1,
        "delta": -3070198425.67
      },
      {
        "periodo": 202512,
        "valor": 29776066186.96,
        "delta": 4723484042.86
      },
      {
        "periodo": 202601,
        "valor": 27336274797.28,
        "delta": -2439791389.68
      },
      {
        "periodo": 202602,
        "valor": 25141656874.08,
        "delta": -2194617923.2
      },
      {
        "periodo": 202603,
        "valor": 31785119161.0,
        "delta": 6643462286.92
      },
      {
        "periodo": 202604,
        "valor": 29846815770.94,
        "delta": -1938303390.06
      },
      {
        "periodo": 202605,
        "valor": 24210140489.27,
        "delta": -5636675281.67
      },
      {
        "periodo": 202606,
        "valor": 27080020977.27,
        "delta": 2869880488.0
      },
      {
        "periodo": 202607,
        "valor": 29186642617.33,
        "delta": 2106621640.06
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 1132157124.8,
    "valor_anterior": 3322712957.96,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8125498461.58,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4227093766.88,
        "delta": -3898404694.7
      },
      {
        "periodo": 202509,
        "valor": 13428720657.24,
        "delta": 9201626890.36
      },
      {
        "periodo": 202510,
        "valor": 11341963450.32,
        "delta": -2086757206.92
      },
      {
        "periodo": 202511,
        "valor": 3214485979.19,
        "delta": -8127477471.13
      },
      {
        "periodo": 202512,
        "valor": 5450563588.44,
        "delta": 2236077609.25
      },
      {
        "periodo": 202601,
        "valor": 11200162985.02,
        "delta": 5749599396.58
      },
      {
        "periodo": 202602,
        "valor": 10124539835.48,
        "delta": -1075623149.54
      },
      {
        "periodo": 202603,
        "valor": -3598773104.34,
        "delta": -13723312939.82
      },
      {
        "periodo": 202604,
        "valor": 3239856795.25,
        "delta": 6838629899.59
      },
      {
        "periodo": 202605,
        "valor": 5145474537.6,
        "delta": 1905617742.35
      },
      {
        "periodo": 202606,
        "valor": 3322712957.96,
        "delta": -1822761579.64
      },
      {
        "periodo": 202607,
        "valor": 1132157124.8,
        "delta": -2190555833.16
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 198954247393.98,
    "valor_anterior": 173316180639.11,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 181018313951.98,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 202767310758.71,
        "delta": 21748996806.73
      },
      {
        "periodo": 202509,
        "valor": 172677433696.44,
        "delta": -30089877062.27
      },
      {
        "periodo": 202510,
        "valor": 195481529828.42,
        "delta": 22804096131.98
      },
      {
        "periodo": 202511,
        "valor": 120713638607.37,
        "delta": -74767891221.05
      },
      {
        "periodo": 202512,
        "valor": 112246188571.81,
        "delta": -8467450035.56
      },
      {
        "periodo": 202601,
        "valor": 137545391585.07,
        "delta": 25299203013.26
      },
      {
        "periodo": 202602,
        "valor": 174784636596.16,
        "delta": 37239245011.09
      },
      {
        "periodo": 202603,
        "valor": 104284809388.33,
        "delta": -70499827207.83
      },
      {
        "periodo": 202604,
        "valor": 156251865258.53,
        "delta": 51967055870.2
      },
      {
        "periodo": 202605,
        "valor": 230234746601.96,
        "delta": 73982881343.43
      },
      {
        "periodo": 202606,
        "valor": 173316180639.11,
        "delta": -56918565962.85
      },
      {
        "periodo": 202607,
        "valor": 198954247393.98,
        "delta": 25638066754.87
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 23575471129.0,
    "valor_anterior": 19172759409.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -35707266753.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17121521599.0,
        "delta": 52828788352.0
      },
      {
        "periodo": 202509,
        "valor": 36467747651.0,
        "delta": 19346226052.0
      },
      {
        "periodo": 202510,
        "valor": 25006402269.0,
        "delta": -11461345382.0
      },
      {
        "periodo": 202511,
        "valor": 44127834964.0,
        "delta": 19121432695.0
      },
      {
        "periodo": 202512,
        "valor": -71643596122.0,
        "delta": -115771431086.0
      },
      {
        "periodo": 202601,
        "valor": 29008498706.0,
        "delta": 100652094828.0
      },
      {
        "periodo": 202602,
        "valor": -65263849857.0,
        "delta": -94272348563.0
      },
      {
        "periodo": 202603,
        "valor": 33168130757.0,
        "delta": 98431980614.0
      },
      {
        "periodo": 202604,
        "valor": 28674859418.0,
        "delta": -4493271339.0
      },
      {
        "periodo": 202605,
        "valor": 40464677853.0,
        "delta": 11789818435.0
      },
      {
        "periodo": 202606,
        "valor": 19172759409.0,
        "delta": -21291918444.0
      },
      {
        "periodo": 202607,
        "valor": 23575471129.0,
        "delta": 4402711720.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 24131124787.0,
    "valor_anterior": 39468627884.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17812841492.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4927682883.0,
        "delta": -12885158609.0
      },
      {
        "periodo": 202509,
        "valor": 20731028006.0,
        "delta": 15803345123.0
      },
      {
        "periodo": 202510,
        "valor": 27289096434.0,
        "delta": 6558068428.0
      },
      {
        "periodo": 202511,
        "valor": 27171717001.0,
        "delta": -117379433.0
      },
      {
        "periodo": 202512,
        "valor": 1671570814.0,
        "delta": -25500146187.0
      },
      {
        "periodo": 202601,
        "valor": 12668195785.0,
        "delta": 10996624971.0
      },
      {
        "periodo": 202602,
        "valor": 37629304238.0,
        "delta": 24961108453.0
      },
      {
        "periodo": 202603,
        "valor": 14714294775.0,
        "delta": -22915009463.0
      },
      {
        "periodo": 202604,
        "valor": 16041319877.0,
        "delta": 1327025102.0
      },
      {
        "periodo": 202605,
        "valor": 16523918363.0,
        "delta": 482598486.0
      },
      {
        "periodo": 202606,
        "valor": 39468627884.0,
        "delta": 22944709521.0
      },
      {
        "periodo": 202607,
        "valor": 24131124787.0,
        "delta": -15337503097.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 25763796104.73,
    "valor_anterior": 23121523654.960003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14405153470.2,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14474741595.15,
        "delta": 69588124.95
      },
      {
        "periodo": 202509,
        "valor": 11735723509.8,
        "delta": -2739018085.35
      },
      {
        "periodo": 202510,
        "valor": 13807656994.07,
        "delta": 2071933484.27
      },
      {
        "periodo": 202511,
        "valor": 11858998283.28,
        "delta": -1948658710.79
      },
      {
        "periodo": 202512,
        "valor": 20330024259.33,
        "delta": 8471025976.05
      },
      {
        "periodo": 202601,
        "valor": 18443998975.95,
        "delta": -1886025283.38
      },
      {
        "periodo": 202602,
        "valor": 14967970782.59,
        "delta": -3476028193.36
      },
      {
        "periodo": 202603,
        "valor": 22163731960.93,
        "delta": 7195761178.34
      },
      {
        "periodo": 202604,
        "valor": 23970479359.2,
        "delta": 1806747398.27
      },
      {
        "periodo": 202605,
        "valor": 20192875758.91,
        "delta": -3777603600.29
      },
      {
        "periodo": 202606,
        "valor": 23121523654.96,
        "delta": 2928647896.05
      },
      {
        "periodo": 202607,
        "valor": 25763796104.73,
        "delta": 2642272449.77
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 64106494465.0,
    "valor_anterior": 51812607498.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 67674467714.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 57392401231.0,
        "delta": -10282066483.0
      },
      {
        "periodo": 202509,
        "valor": 59592080788.0,
        "delta": 2199679557.0
      },
      {
        "periodo": 202510,
        "valor": 62524813414.0,
        "delta": 2932732626.0
      },
      {
        "periodo": 202511,
        "valor": 59779557596.0,
        "delta": -2745255818.0
      },
      {
        "periodo": 202512,
        "valor": 66396865248.0,
        "delta": 6617307652.0
      },
      {
        "periodo": 202601,
        "valor": 49277289206.0,
        "delta": -17119576042.0
      },
      {
        "periodo": 202602,
        "valor": 51830332381.0,
        "delta": 2553043175.0
      },
      {
        "periodo": 202603,
        "valor": 46587438994.0,
        "delta": -5242893387.0
      },
      {
        "periodo": 202604,
        "valor": 40409657979.0,
        "delta": -6177781015.0
      },
      {
        "periodo": 202605,
        "valor": 55198308107.0,
        "delta": 14788650128.0
      },
      {
        "periodo": 202606,
        "valor": 51812607498.0,
        "delta": -3385700609.0
      },
      {
        "periodo": 202607,
        "valor": 64106494465.0,
        "delta": 12293886967.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 9956875398.000002,
    "valor_anterior": 8176750936.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6651315302.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13533742154.0,
        "delta": 6882426852.0
      },
      {
        "periodo": 202509,
        "valor": 9782774395.0,
        "delta": -3750967759.0
      },
      {
        "periodo": 202510,
        "valor": 7488160356.0,
        "delta": -2294614039.0
      },
      {
        "periodo": 202511,
        "valor": 8225998275.0,
        "delta": 737837919.0
      },
      {
        "periodo": 202512,
        "valor": 6837056231.0,
        "delta": -1388942044.0
      },
      {
        "periodo": 202601,
        "valor": 10832697083.0,
        "delta": 3995640852.0
      },
      {
        "periodo": 202602,
        "valor": 9365043634.0,
        "delta": -1467653449.0
      },
      {
        "periodo": 202603,
        "valor": 9146108834.0,
        "delta": -218934800.0
      },
      {
        "periodo": 202604,
        "valor": 12037340843.0,
        "delta": 2891232009.0
      },
      {
        "periodo": 202605,
        "valor": 14110166347.0,
        "delta": 2072825504.0
      },
      {
        "periodo": 202606,
        "valor": 8176750937.0,
        "delta": -5933415410.0
      },
      {
        "periodo": 202607,
        "valor": 9956875398.0,
        "delta": 1780124461.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 36782615141.0,
    "valor_anterior": 29408082271.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 35355737276.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25433644003.0,
        "delta": -9922093273.0
      },
      {
        "periodo": 202509,
        "valor": 12401376568.0,
        "delta": -13032267435.0
      },
      {
        "periodo": 202510,
        "valor": 8031984044.0,
        "delta": -4369392524.0
      },
      {
        "periodo": 202511,
        "valor": 9110182107.0,
        "delta": 1078198063.0
      },
      {
        "periodo": 202512,
        "valor": 26108963072.0,
        "delta": 16998780965.0
      },
      {
        "periodo": 202601,
        "valor": 24294278319.0,
        "delta": -1814684753.0
      },
      {
        "periodo": 202602,
        "valor": 22500584240.0,
        "delta": -1793694079.0
      },
      {
        "periodo": 202603,
        "valor": 16541001140.0,
        "delta": -5959583100.0
      },
      {
        "periodo": 202604,
        "valor": 29841862746.0,
        "delta": 13300861606.0
      },
      {
        "periodo": 202605,
        "valor": 9770996638.0,
        "delta": -20070866108.0
      },
      {
        "periodo": 202606,
        "valor": 29408082271.0,
        "delta": 19637085633.0
      },
      {
        "periodo": 202607,
        "valor": 36782615141.0,
        "delta": 7374532870.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 10127381126.17,
    "valor_anterior": 10296993533.59,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11585483883.08,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12618970391.9,
        "delta": 1033486508.82
      },
      {
        "periodo": 202509,
        "valor": 12196718230.77,
        "delta": -422252161.13
      },
      {
        "periodo": 202510,
        "valor": 10025586190.22,
        "delta": -2171132040.55
      },
      {
        "periodo": 202511,
        "valor": 11808632972.09,
        "delta": 1783046781.87
      },
      {
        "periodo": 202512,
        "valor": 14123412288.7,
        "delta": 2314779316.61
      },
      {
        "periodo": 202601,
        "valor": 9133355975.2,
        "delta": -4990056313.5
      },
      {
        "periodo": 202602,
        "valor": 9108860792.74,
        "delta": -24495182.46
      },
      {
        "periodo": 202603,
        "valor": 9940339523.36,
        "delta": 831478730.62
      },
      {
        "periodo": 202604,
        "valor": 9031443190.42,
        "delta": -908896332.94
      },
      {
        "periodo": 202605,
        "valor": 8468996275.57,
        "delta": -562446914.85
      },
      {
        "periodo": 202606,
        "valor": 10296993533.59,
        "delta": 1827997258.02
      },
      {
        "periodo": 202607,
        "valor": 10127381126.17,
        "delta": -169612407.42
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": -2733069566.0,
    "valor_anterior": -710509645.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2896623435.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1903307242.0,
        "delta": 993316193.0
      },
      {
        "periodo": 202509,
        "valor": -2374627616.0,
        "delta": -471320374.0
      },
      {
        "periodo": 202510,
        "valor": -1644013636.0,
        "delta": 730613980.0
      },
      {
        "periodo": 202511,
        "valor": -652687253.0,
        "delta": 991326383.0
      },
      {
        "periodo": 202512,
        "valor": 2045158864.0,
        "delta": 2697846117.0
      },
      {
        "periodo": 202601,
        "valor": -3625659171.0,
        "delta": -5670818035.0
      },
      {
        "periodo": 202602,
        "valor": -3847024854.0,
        "delta": -221365683.0
      },
      {
        "periodo": 202603,
        "valor": -761213437.0,
        "delta": 3085811417.0
      },
      {
        "periodo": 202604,
        "valor": -6060424224.0,
        "delta": -5299210787.0
      },
      {
        "periodo": 202605,
        "valor": -4523974152.0,
        "delta": 1536450072.0
      },
      {
        "periodo": 202606,
        "valor": -710509645.0,
        "delta": 3813464507.0
      },
      {
        "periodo": 202607,
        "valor": -2733069566.0,
        "delta": -2022559921.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 6700242911.000001,
    "valor_anterior": 4937466996.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15380593828.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14316296927.0,
        "delta": -1064296901.0
      },
      {
        "periodo": 202509,
        "valor": 11239555935.0,
        "delta": -3076740992.0
      },
      {
        "periodo": 202510,
        "valor": 11575584705.0,
        "delta": 336028770.0
      },
      {
        "periodo": 202511,
        "valor": 6637243188.0,
        "delta": -4938341517.0
      },
      {
        "periodo": 202512,
        "valor": 6160992863.0,
        "delta": -476250325.0
      },
      {
        "periodo": 202601,
        "valor": 6299582963.0,
        "delta": 138590100.0
      },
      {
        "periodo": 202602,
        "valor": 6087977488.0,
        "delta": -211605475.0
      },
      {
        "periodo": 202603,
        "valor": 7611840875.0,
        "delta": 1523863387.0
      },
      {
        "periodo": 202604,
        "valor": 7914298210.0,
        "delta": 302457335.0
      },
      {
        "periodo": 202605,
        "valor": 4642362274.0,
        "delta": -3271935936.0
      },
      {
        "periodo": 202606,
        "valor": 4937466996.0,
        "delta": 295104722.0
      },
      {
        "periodo": 202607,
        "valor": 6700242911.0,
        "delta": 1762775915.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 6382134680.999999,
    "valor_anterior": 9107637286.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2924753287.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4041424515.0,
        "delta": 1116671228.0
      },
      {
        "periodo": 202509,
        "valor": 6245759816.0,
        "delta": 2204335301.0
      },
      {
        "periodo": 202510,
        "valor": 7738535582.0,
        "delta": 1492775766.0
      },
      {
        "periodo": 202511,
        "valor": 5784000082.0,
        "delta": -1954535500.0
      },
      {
        "periodo": 202512,
        "valor": 4550155558.0,
        "delta": -1233844524.0
      },
      {
        "periodo": 202601,
        "valor": 7278269394.0,
        "delta": 2728113836.0
      },
      {
        "periodo": 202602,
        "valor": 4929398706.0,
        "delta": -2348870688.0
      },
      {
        "periodo": 202603,
        "valor": 3057806211.0,
        "delta": -1871592495.0
      },
      {
        "periodo": 202604,
        "valor": 8773680612.0,
        "delta": 5715874401.0
      },
      {
        "periodo": 202605,
        "valor": 7489401780.0,
        "delta": -1284278832.0
      },
      {
        "periodo": 202606,
        "valor": 9107637286.0,
        "delta": 1618235506.0
      },
      {
        "periodo": 202607,
        "valor": 6382134681.0,
        "delta": -2725502605.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 36158364686.65,
    "valor_anterior": 25340202249.6,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 34108549617.23,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 47531932511.68,
        "delta": 13423382894.45
      },
      {
        "periodo": 202509,
        "valor": 41959503013.74,
        "delta": -5572429497.94
      },
      {
        "periodo": 202510,
        "valor": 27747024461.05,
        "delta": -14212478552.69
      },
      {
        "periodo": 202511,
        "valor": 24704431695.37,
        "delta": -3042592765.68
      },
      {
        "periodo": 202512,
        "valor": 32864930067.3,
        "delta": 8160498371.93
      },
      {
        "periodo": 202601,
        "valor": 36572817268.33,
        "delta": 3707887201.03
      },
      {
        "periodo": 202602,
        "valor": 55197022022.01,
        "delta": 18624204753.68
      },
      {
        "periodo": 202603,
        "valor": 30280826461.19,
        "delta": -24916195560.82
      },
      {
        "periodo": 202604,
        "valor": 40332909265.34,
        "delta": 10052082804.15
      },
      {
        "periodo": 202605,
        "valor": 25893105223.21,
        "delta": -14439804042.13
      },
      {
        "periodo": 202606,
        "valor": 25340202249.6,
        "delta": -552902973.61
      },
      {
        "periodo": 202607,
        "valor": 36158364686.65,
        "delta": 10818162437.05
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 17663328920.0,
    "valor_anterior": 11346872093.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12866775240.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16223131640.0,
        "delta": 3356356400.0
      },
      {
        "periodo": 202509,
        "valor": 14134119638.0,
        "delta": -2089012002.0
      },
      {
        "periodo": 202510,
        "valor": 16283363198.0,
        "delta": 2149243560.0
      },
      {
        "periodo": 202511,
        "valor": 8809207666.0,
        "delta": -7474155532.0
      },
      {
        "periodo": 202512,
        "valor": 26705160194.0,
        "delta": 17895952528.0
      },
      {
        "periodo": 202601,
        "valor": 9439014589.0,
        "delta": -17266145605.0
      },
      {
        "periodo": 202602,
        "valor": 8625521755.0,
        "delta": -813492834.0
      },
      {
        "periodo": 202603,
        "valor": 24686002470.0,
        "delta": 16060480715.0
      },
      {
        "periodo": 202604,
        "valor": 10377133479.0,
        "delta": -14308868991.0
      },
      {
        "periodo": 202605,
        "valor": 25168043112.0,
        "delta": 14790909633.0
      },
      {
        "periodo": 202606,
        "valor": 11346872093.0,
        "delta": -13821171019.0
      },
      {
        "periodo": 202607,
        "valor": 17663328920.0,
        "delta": 6316456827.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 7532684012.999999,
    "valor_anterior": 8887457175.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5502004134.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8387776466.0,
        "delta": 2885772332.0
      },
      {
        "periodo": 202509,
        "valor": 9704511053.0,
        "delta": 1316734587.0
      },
      {
        "periodo": 202510,
        "valor": 6651317907.0,
        "delta": -3053193146.0
      },
      {
        "periodo": 202511,
        "valor": 8692717229.0,
        "delta": 2041399322.0
      },
      {
        "periodo": 202512,
        "valor": 7561599293.0,
        "delta": -1131117936.0
      },
      {
        "periodo": 202601,
        "valor": 9159559045.0,
        "delta": 1597959752.0
      },
      {
        "periodo": 202602,
        "valor": 6828326323.0,
        "delta": -2331232722.0
      },
      {
        "periodo": 202603,
        "valor": 7427291328.0,
        "delta": 598965005.0
      },
      {
        "periodo": 202604,
        "valor": 7549873269.0,
        "delta": 122581941.0
      },
      {
        "periodo": 202605,
        "valor": 9241531553.0,
        "delta": 1691658284.0
      },
      {
        "periodo": 202606,
        "valor": 8887457175.0,
        "delta": -354074378.0
      },
      {
        "periodo": 202607,
        "valor": 7532684013.0,
        "delta": -1354773162.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 3453707321.0,
    "valor_anterior": -17930387191.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3802218182.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3428499465.0,
        "delta": -373718717.0
      },
      {
        "periodo": 202509,
        "valor": 11920309232.0,
        "delta": 8491809767.0
      },
      {
        "periodo": 202510,
        "valor": 3599693593.0,
        "delta": -8320615639.0
      },
      {
        "periodo": 202511,
        "valor": 3485484476.0,
        "delta": -114209117.0
      },
      {
        "periodo": 202512,
        "valor": 25302112099.0,
        "delta": 21816627623.0
      },
      {
        "periodo": 202601,
        "valor": 9385981927.0,
        "delta": -15916130172.0
      },
      {
        "periodo": 202602,
        "valor": 3430517031.0,
        "delta": -5955464896.0
      },
      {
        "periodo": 202603,
        "valor": 13691706908.0,
        "delta": 10261189877.0
      },
      {
        "periodo": 202604,
        "valor": 6612834727.0,
        "delta": -7078872181.0
      },
      {
        "periodo": 202605,
        "valor": 3237664267.0,
        "delta": -3375170460.0
      },
      {
        "periodo": 202606,
        "valor": -17930387191.0,
        "delta": -21168051458.0
      },
      {
        "periodo": 202607,
        "valor": 3453707321.0,
        "delta": 21384094512.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 18556461500.84,
    "valor_anterior": 14353580448.92,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12079615578.22,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18689849506.36,
        "delta": 6610233928.14
      },
      {
        "periodo": 202509,
        "valor": 10536684365.49,
        "delta": -8153165140.87
      },
      {
        "periodo": 202510,
        "valor": 15461797239.01,
        "delta": 4925112873.52
      },
      {
        "periodo": 202511,
        "valor": 3790290093.24,
        "delta": -11671507145.77
      },
      {
        "periodo": 202512,
        "valor": 35938506487.59,
        "delta": 32148216394.35
      },
      {
        "periodo": 202601,
        "valor": 14774598144.65,
        "delta": -21163908342.94
      },
      {
        "periodo": 202602,
        "valor": 14949755962.56,
        "delta": 175157817.91
      },
      {
        "periodo": 202603,
        "valor": 19104544889.34,
        "delta": 4154788926.78
      },
      {
        "periodo": 202604,
        "valor": 15227729543.57,
        "delta": -3876815345.77
      },
      {
        "periodo": 202605,
        "valor": 10552861159.68,
        "delta": -4674868383.89
      },
      {
        "periodo": 202606,
        "valor": 14353580448.92,
        "delta": 3800719289.24
      },
      {
        "periodo": 202607,
        "valor": 18556461500.84,
        "delta": 4202881051.92
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 4885121990.0,
    "valor_anterior": 4127038869.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5251097333.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2958529151.0,
        "delta": -2292568182.0
      },
      {
        "periodo": 202509,
        "valor": 2626285523.0,
        "delta": -332243628.0
      },
      {
        "periodo": 202510,
        "valor": 2744801252.0,
        "delta": 118515729.0
      },
      {
        "periodo": 202511,
        "valor": 3371041951.0,
        "delta": 626240699.0
      },
      {
        "periodo": 202512,
        "valor": 7128857640.0,
        "delta": 3757815689.0
      },
      {
        "periodo": 202601,
        "valor": 4503654702.0,
        "delta": -2625202938.0
      },
      {
        "periodo": 202602,
        "valor": 5581719899.0,
        "delta": 1078065197.0
      },
      {
        "periodo": 202603,
        "valor": 3091789126.0,
        "delta": -2489930773.0
      },
      {
        "periodo": 202604,
        "valor": 4692845701.0,
        "delta": 1601056575.0
      },
      {
        "periodo": 202605,
        "valor": 6052279194.0,
        "delta": 1359433493.0
      },
      {
        "periodo": 202606,
        "valor": 4127038869.0,
        "delta": -1925240325.0
      },
      {
        "periodo": 202607,
        "valor": 4885121990.0,
        "delta": 758083121.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 7146119334.32,
    "valor_anterior": 6880233786.05,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17040390307.02,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13342551480.37,
        "delta": -3697838826.65
      },
      {
        "periodo": 202509,
        "valor": 8440693698.43,
        "delta": -4901857781.94
      },
      {
        "periodo": 202510,
        "valor": 7762057707.66,
        "delta": -678635990.77
      },
      {
        "periodo": 202511,
        "valor": 13959402922.37,
        "delta": 6197345214.71
      },
      {
        "periodo": 202512,
        "valor": 6176791317.3,
        "delta": -7782611605.07
      },
      {
        "periodo": 202601,
        "valor": 2977323263.32,
        "delta": -3199468053.98
      },
      {
        "periodo": 202602,
        "valor": 9847992533.36,
        "delta": 6870669270.04
      },
      {
        "periodo": 202603,
        "valor": 9994438313.13,
        "delta": 146445779.77
      },
      {
        "periodo": 202604,
        "valor": 12329232993.52,
        "delta": 2334794680.39
      },
      {
        "periodo": 202605,
        "valor": 10009112733.55,
        "delta": -2320120259.97
      },
      {
        "periodo": 202606,
        "valor": 6880233786.05,
        "delta": -3128878947.5
      },
      {
        "periodo": 202607,
        "valor": 7146119334.32,
        "delta": 265885548.27
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 107692987.0,
    "valor_anterior": 113830307.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 151395532.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 107195041.0,
        "delta": -44200491.0
      },
      {
        "periodo": 202509,
        "valor": 89027681.0,
        "delta": -18167360.0
      },
      {
        "periodo": 202510,
        "valor": 226477661.0,
        "delta": 137449980.0
      },
      {
        "periodo": 202511,
        "valor": 192798785.0,
        "delta": -33678876.0
      },
      {
        "periodo": 202512,
        "valor": 175711161.0,
        "delta": -17087624.0
      },
      {
        "periodo": 202601,
        "valor": 156196365.0,
        "delta": -19514796.0
      },
      {
        "periodo": 202602,
        "valor": 138304683.0,
        "delta": -17891682.0
      },
      {
        "periodo": 202603,
        "valor": 128875451.0,
        "delta": -9429232.0
      },
      {
        "periodo": 202604,
        "valor": 101244064.0,
        "delta": -27631387.0
      },
      {
        "periodo": 202605,
        "valor": 129249791.0,
        "delta": 28005727.0
      },
      {
        "periodo": 202606,
        "valor": 113830307.0,
        "delta": -15419484.0
      },
      {
        "periodo": 202607,
        "valor": 107692987.0,
        "delta": -6137320.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 7008421373.06,
    "valor_anterior": 5675489309.24,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6353759729.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12088999414.81,
        "delta": 5735239685.66
      },
      {
        "periodo": 202509,
        "valor": 8056424993.27,
        "delta": -4032574421.54
      },
      {
        "periodo": 202510,
        "valor": 10792642882.68,
        "delta": 2736217889.41
      },
      {
        "periodo": 202511,
        "valor": 8480285212.16,
        "delta": -2312357670.52
      },
      {
        "periodo": 202512,
        "valor": 8521121939.17,
        "delta": 40836727.01
      },
      {
        "periodo": 202601,
        "valor": 9380303772.13,
        "delta": 859181832.96
      },
      {
        "periodo": 202602,
        "valor": 8743809537.86,
        "delta": -636494234.27
      },
      {
        "periodo": 202603,
        "valor": 7474720201.01,
        "delta": -1269089336.85
      },
      {
        "periodo": 202604,
        "valor": 8325940531.83,
        "delta": 851220330.82
      },
      {
        "periodo": 202605,
        "valor": 9165978967.61,
        "delta": 840038435.78
      },
      {
        "periodo": 202606,
        "valor": 5675489309.24,
        "delta": -3490489658.37
      },
      {
        "periodo": 202607,
        "valor": 7008421373.06,
        "delta": 1332932063.82
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 8639229860.0,
    "valor_anterior": 14388874137.999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1437252253.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5523696216.86,
        "delta": 4086443963.71
      },
      {
        "periodo": 202509,
        "valor": 9257190067.0,
        "delta": 3733493850.14
      },
      {
        "periodo": 202510,
        "valor": 10284621511.0,
        "delta": 1027431444.0
      },
      {
        "periodo": 202511,
        "valor": 5784895633.0,
        "delta": -4499725878.0
      },
      {
        "periodo": 202512,
        "valor": 10219848539.0,
        "delta": 4434952906.0
      },
      {
        "periodo": 202601,
        "valor": 11811404866.0,
        "delta": 1591556327.0
      },
      {
        "periodo": 202602,
        "valor": 5698035947.0,
        "delta": -6113368919.0
      },
      {
        "periodo": 202603,
        "valor": 15082442686.0,
        "delta": 9384406739.0
      },
      {
        "periodo": 202604,
        "valor": 6077620078.0,
        "delta": -9004822608.0
      },
      {
        "periodo": 202605,
        "valor": 8254847446.0,
        "delta": 2177227368.0
      },
      {
        "periodo": 202606,
        "valor": 14388874138.0,
        "delta": 6134026692.0
      },
      {
        "periodo": 202607,
        "valor": 8639229860.0,
        "delta": -5749644278.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 76916390.0,
    "valor_anterior": 77583406.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 80817230.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 69605319.0,
        "delta": -11211911.0
      },
      {
        "periodo": 202509,
        "valor": 71365833.0,
        "delta": 1760514.0
      },
      {
        "periodo": 202510,
        "valor": 1613550332.0,
        "delta": 1542184499.0
      },
      {
        "periodo": 202511,
        "valor": 1312295246.0,
        "delta": -301255086.0
      },
      {
        "periodo": 202512,
        "valor": 120246922.0,
        "delta": -1192048324.0
      },
      {
        "periodo": 202601,
        "valor": 72660468.0,
        "delta": -47586454.0
      },
      {
        "periodo": 202602,
        "valor": 68053146.0,
        "delta": -4607322.0
      },
      {
        "periodo": 202603,
        "valor": 89456404.0,
        "delta": 21403258.0
      },
      {
        "periodo": 202604,
        "valor": 102716377.0,
        "delta": 13259973.0
      },
      {
        "periodo": 202605,
        "valor": 7066135828.0,
        "delta": 6963419451.0
      },
      {
        "periodo": 202606,
        "valor": 77583406.0,
        "delta": -6988552422.0
      },
      {
        "periodo": 202607,
        "valor": 76916390.0,
        "delta": -667016.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 1573561933.0,
    "valor_anterior": 1480582425.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1379055106.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1324340619.0,
        "delta": -54714487.0
      },
      {
        "periodo": 202509,
        "valor": 1523418486.0,
        "delta": 199077867.0
      },
      {
        "periodo": 202510,
        "valor": 1506850351.0,
        "delta": -16568135.0
      },
      {
        "periodo": 202511,
        "valor": 1569423473.0,
        "delta": 62573122.0
      },
      {
        "periodo": 202512,
        "valor": 1598586517.0,
        "delta": 29163044.0
      },
      {
        "periodo": 202601,
        "valor": 1595642834.0,
        "delta": -2943683.0
      },
      {
        "periodo": 202602,
        "valor": 1644798297.0,
        "delta": 49155463.0
      },
      {
        "periodo": 202603,
        "valor": 1426721474.0,
        "delta": -218076823.0
      },
      {
        "periodo": 202604,
        "valor": 1550567679.0,
        "delta": 123846205.0
      },
      {
        "periodo": 202605,
        "valor": 1565324791.0,
        "delta": 14757112.0
      },
      {
        "periodo": 202606,
        "valor": 1480582425.0,
        "delta": -84742366.0
      },
      {
        "periodo": 202607,
        "valor": 1573561933.0,
        "delta": 92979508.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 22287775432.0,
    "valor_anterior": 18132365519.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9848696082.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19136253944.0,
        "delta": 9287557862.0
      },
      {
        "periodo": 202509,
        "valor": 13914532321.0,
        "delta": -5221721623.0
      },
      {
        "periodo": 202510,
        "valor": 15373560247.0,
        "delta": 1459027926.0
      },
      {
        "periodo": 202511,
        "valor": 13616644521.0,
        "delta": -1756915726.0
      },
      {
        "periodo": 202512,
        "valor": 22248930069.0,
        "delta": 8632285548.0
      },
      {
        "periodo": 202601,
        "valor": 15772334235.0,
        "delta": -6476595834.0
      },
      {
        "periodo": 202602,
        "valor": 16378527979.0,
        "delta": 606193744.0
      },
      {
        "periodo": 202603,
        "valor": 17483258555.0,
        "delta": 1104730576.0
      },
      {
        "periodo": 202604,
        "valor": 16220112123.0,
        "delta": -1263146432.0
      },
      {
        "periodo": 202605,
        "valor": 16401758192.0,
        "delta": 181646069.0
      },
      {
        "periodo": 202606,
        "valor": 18132365519.0,
        "delta": 1730607327.0
      },
      {
        "periodo": 202607,
        "valor": 22287775432.0,
        "delta": 4155409913.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 1569395402.0,
    "valor_anterior": 6019583572.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8525128042.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5261480412.0,
        "delta": -3263647630.0
      },
      {
        "periodo": 202509,
        "valor": 8471059117.0,
        "delta": 3209578705.0
      },
      {
        "periodo": 202510,
        "valor": 4523259639.0,
        "delta": -3947799478.0
      },
      {
        "periodo": 202511,
        "valor": 1993457175.0,
        "delta": -2529802464.0
      },
      {
        "periodo": 202512,
        "valor": 2567350297.0,
        "delta": 573893122.0
      },
      {
        "periodo": 202601,
        "valor": 2879936924.0,
        "delta": 312586627.0
      },
      {
        "periodo": 202602,
        "valor": 3306577382.0,
        "delta": 426640458.0
      },
      {
        "periodo": 202603,
        "valor": 3659803554.0,
        "delta": 353226172.0
      },
      {
        "periodo": 202604,
        "valor": 2324826643.0,
        "delta": -1334976911.0
      },
      {
        "periodo": 202605,
        "valor": 3628052477.0,
        "delta": 1303225834.0
      },
      {
        "periodo": 202606,
        "valor": 6019583572.0,
        "delta": 2391531095.0
      },
      {
        "periodo": 202607,
        "valor": 1569395402.0,
        "delta": -4450188170.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 13863246.0,
    "valor_anterior": 71571006.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8259410984.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4969003491.0,
        "delta": -3290407493.0
      },
      {
        "periodo": 202509,
        "valor": 3552185837.0,
        "delta": -1416817654.0
      },
      {
        "periodo": 202510,
        "valor": 2563732804.0,
        "delta": -988453033.0
      },
      {
        "periodo": 202511,
        "valor": 1814855697.0,
        "delta": -748877107.0
      },
      {
        "periodo": 202512,
        "valor": 1012955087.0,
        "delta": -801900610.0
      },
      {
        "periodo": 202601,
        "valor": 3214049628.0,
        "delta": 2201094541.0
      },
      {
        "periodo": 202602,
        "valor": 760804526.0,
        "delta": -2453245102.0
      },
      {
        "periodo": 202603,
        "valor": 158991415.0,
        "delta": -601813111.0
      },
      {
        "periodo": 202604,
        "valor": 27927062.0,
        "delta": -131064353.0
      },
      {
        "periodo": 202605,
        "valor": 44458859.0,
        "delta": 16531797.0
      },
      {
        "periodo": 202606,
        "valor": 71571006.0,
        "delta": 27112147.0
      },
      {
        "periodo": 202607,
        "valor": 13863246.0,
        "delta": -57707760.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 5337163890.87,
    "valor_anterior": 4566763779.66,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5775706022.71,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6187002393.06,
        "delta": 411296370.35
      },
      {
        "periodo": 202509,
        "valor": 6279721120.88,
        "delta": 92718727.82
      },
      {
        "periodo": 202510,
        "valor": 7709415293.61,
        "delta": 1429694172.73
      },
      {
        "periodo": 202511,
        "valor": 4503483755.98,
        "delta": -3205931537.63
      },
      {
        "periodo": 202512,
        "valor": 5795132141.21,
        "delta": 1291648385.23
      },
      {
        "periodo": 202601,
        "valor": 5301648637.64,
        "delta": -493483503.57
      },
      {
        "periodo": 202602,
        "valor": 5000273818.49,
        "delta": -301374819.15
      },
      {
        "periodo": 202603,
        "valor": 4313415633.18,
        "delta": -686858185.31
      },
      {
        "periodo": 202604,
        "valor": 6115564327.65,
        "delta": 1802148694.47
      },
      {
        "periodo": 202605,
        "valor": 5192192458.18,
        "delta": -923371869.47
      },
      {
        "periodo": 202606,
        "valor": 4566763779.66,
        "delta": -625428678.52
      },
      {
        "periodo": 202607,
        "valor": 5337163890.87,
        "delta": 770400111.21
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 848049437.0,
    "valor_anterior": 909387069.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 988997575.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 912771942.0,
        "delta": -76225633.0
      },
      {
        "periodo": 202509,
        "valor": 596498475.0,
        "delta": -316273467.0
      },
      {
        "periodo": 202510,
        "valor": 639430944.0,
        "delta": 42932469.0
      },
      {
        "periodo": 202511,
        "valor": 644428101.0,
        "delta": 4997157.0
      },
      {
        "periodo": 202512,
        "valor": 653199797.0,
        "delta": 8771696.0
      },
      {
        "periodo": 202601,
        "valor": 560426456.0,
        "delta": -92773341.0
      },
      {
        "periodo": 202602,
        "valor": 570337039.0,
        "delta": 9910583.0
      },
      {
        "periodo": 202603,
        "valor": 566132294.0,
        "delta": -4204745.0
      },
      {
        "periodo": 202604,
        "valor": 585496867.0,
        "delta": 19364573.0
      },
      {
        "periodo": 202605,
        "valor": 631513738.0,
        "delta": 46016871.0
      },
      {
        "periodo": 202606,
        "valor": 909387069.0,
        "delta": 277873331.0
      },
      {
        "periodo": 202607,
        "valor": 848049437.0,
        "delta": -61337632.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 40546002.0,
    "valor_anterior": 45881283.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 36573927.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 66671100.0,
        "delta": 30097173.0
      },
      {
        "periodo": 202509,
        "valor": 62465138.0,
        "delta": -4205962.0
      },
      {
        "periodo": 202510,
        "valor": 113964486.0,
        "delta": 51499348.0
      },
      {
        "periodo": 202511,
        "valor": 49400765.0,
        "delta": -64563721.0
      },
      {
        "periodo": 202512,
        "valor": 70216623.0,
        "delta": 20815858.0
      },
      {
        "periodo": 202601,
        "valor": 40026281.0,
        "delta": -30190342.0
      },
      {
        "periodo": 202602,
        "valor": 94215200.0,
        "delta": 54188919.0
      },
      {
        "periodo": 202603,
        "valor": 101568061.0,
        "delta": 7352861.0
      },
      {
        "periodo": 202604,
        "valor": 92917601.0,
        "delta": -8650460.0
      },
      {
        "periodo": 202605,
        "valor": 13515307.0,
        "delta": -79402294.0
      },
      {
        "periodo": 202606,
        "valor": 45881283.0,
        "delta": 32365976.0
      },
      {
        "periodo": 202607,
        "valor": 40546002.0,
        "delta": -5335281.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 1570317259.0,
    "valor_anterior": 3199833918.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 412464348.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 672960155.0,
        "delta": 260495807.0
      },
      {
        "periodo": 202509,
        "valor": 377523915.0,
        "delta": -295436240.0
      },
      {
        "periodo": 202510,
        "valor": 336603760.0,
        "delta": -40920155.0
      },
      {
        "periodo": 202511,
        "valor": 299483848.0,
        "delta": -37119912.0
      },
      {
        "periodo": 202512,
        "valor": 480626930.0,
        "delta": 181143082.0
      },
      {
        "periodo": 202601,
        "valor": 606016520.0,
        "delta": 125389590.0
      },
      {
        "periodo": 202602,
        "valor": 2024194585.0,
        "delta": 1418178065.0
      },
      {
        "periodo": 202603,
        "valor": 2395564724.0,
        "delta": 371370139.0
      },
      {
        "periodo": 202604,
        "valor": 5011620281.0,
        "delta": 2616055557.0
      },
      {
        "periodo": 202605,
        "valor": 3858533022.0,
        "delta": -1153087259.0
      },
      {
        "periodo": 202606,
        "valor": 3199833918.0,
        "delta": -658699104.0
      },
      {
        "periodo": 202607,
        "valor": 1570317259.0,
        "delta": -1629516659.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 274192637.0,
    "valor_anterior": 325114678.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 366825334.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 271888052.0,
        "delta": -94937282.0
      },
      {
        "periodo": 202509,
        "valor": 1258035368.0,
        "delta": 986147316.0
      },
      {
        "periodo": 202510,
        "valor": 1129441422.0,
        "delta": -128593946.0
      },
      {
        "periodo": 202511,
        "valor": 982608156.0,
        "delta": -146833266.0
      },
      {
        "periodo": 202512,
        "valor": 435209321.0,
        "delta": -547398835.0
      },
      {
        "periodo": 202601,
        "valor": 210748493.0,
        "delta": -224460828.0
      },
      {
        "periodo": 202602,
        "valor": 393722631.0,
        "delta": 182974138.0
      },
      {
        "periodo": 202603,
        "valor": 411064676.0,
        "delta": 17342045.0
      },
      {
        "periodo": 202604,
        "valor": 443716996.0,
        "delta": 32652320.0
      },
      {
        "periodo": 202605,
        "valor": 474147920.0,
        "delta": 30430924.0
      },
      {
        "periodo": 202606,
        "valor": 325114678.0,
        "delta": -149033242.0
      },
      {
        "periodo": 202607,
        "valor": 274192637.0,
        "delta": -50922041.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10370995796.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2788063978.0,
        "delta": -7582931818.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 7669533278.0,
    "valor_anterior": 8028913511.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17202527059.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 20248111890.0,
        "delta": 3045584831.0
      },
      {
        "periodo": 202509,
        "valor": 11728286144.0,
        "delta": -8519825746.0
      },
      {
        "periodo": 202510,
        "valor": 12190614592.0,
        "delta": 462328448.0
      },
      {
        "periodo": 202511,
        "valor": 10710800752.0,
        "delta": -1479813840.0
      },
      {
        "periodo": 202512,
        "valor": 9582541931.0,
        "delta": -1128258821.0
      },
      {
        "periodo": 202601,
        "valor": 7374403800.0,
        "delta": -2208138131.0
      },
      {
        "periodo": 202602,
        "valor": 11723688735.0,
        "delta": 4349284935.0
      },
      {
        "periodo": 202603,
        "valor": 10792268428.0,
        "delta": -931420307.0
      },
      {
        "periodo": 202604,
        "valor": 18133732476.0,
        "delta": 7341464048.0
      },
      {
        "periodo": 202605,
        "valor": 11034459679.0,
        "delta": -7099272797.0
      },
      {
        "periodo": 202606,
        "valor": 8028913511.0,
        "delta": -3005546168.0
      },
      {
        "periodo": 202607,
        "valor": 7669533278.0,
        "delta": -359380233.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 10419817620.0,
    "valor_anterior": 8583385998.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4578381410.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4312108755.0,
        "delta": -266272655.0
      },
      {
        "periodo": 202509,
        "valor": 4988900472.0,
        "delta": 676791717.0
      },
      {
        "periodo": 202510,
        "valor": 5261379254.0,
        "delta": 272478782.0
      },
      {
        "periodo": 202511,
        "valor": 4514949257.0,
        "delta": -746429997.0
      },
      {
        "periodo": 202512,
        "valor": 10388503465.0,
        "delta": 5873554208.0
      },
      {
        "periodo": 202601,
        "valor": 3717056317.0,
        "delta": -6671447148.0
      },
      {
        "periodo": 202602,
        "valor": 7444094260.0,
        "delta": 3727037943.0
      },
      {
        "periodo": 202603,
        "valor": 8841548539.0,
        "delta": 1397454279.0
      },
      {
        "periodo": 202604,
        "valor": 8827414537.0,
        "delta": -14134002.0
      },
      {
        "periodo": 202605,
        "valor": 8949743370.0,
        "delta": 122328833.0
      },
      {
        "periodo": 202606,
        "valor": 8583385998.0,
        "delta": -366357372.0
      },
      {
        "periodo": 202607,
        "valor": 10419817620.0,
        "delta": 1836431622.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 1719259959.0,
    "valor_anterior": 1670495235.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 220689687.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1045053693.0,
        "delta": 824364006.0
      },
      {
        "periodo": 202509,
        "valor": 707828205.0,
        "delta": -337225488.0
      },
      {
        "periodo": 202510,
        "valor": 970845163.0,
        "delta": 263016958.0
      },
      {
        "periodo": 202511,
        "valor": 1094460889.0,
        "delta": 123615726.0
      },
      {
        "periodo": 202512,
        "valor": 1082752472.0,
        "delta": -11708417.0
      },
      {
        "periodo": 202601,
        "valor": 1192821914.0,
        "delta": 110069442.0
      },
      {
        "periodo": 202602,
        "valor": 1159035127.0,
        "delta": -33786787.0
      },
      {
        "periodo": 202603,
        "valor": 901549556.0,
        "delta": -257485571.0
      },
      {
        "periodo": 202604,
        "valor": 831115360.0,
        "delta": -70434196.0
      },
      {
        "periodo": 202605,
        "valor": 1314400387.0,
        "delta": 483285027.0
      },
      {
        "periodo": 202606,
        "valor": 1670495235.0,
        "delta": 356094848.0
      },
      {
        "periodo": 202607,
        "valor": 1719259959.0,
        "delta": 48764724.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 367868723.0,
    "valor_anterior": 333095527.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 318167673.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 283487781.0,
        "delta": -34679892.0
      },
      {
        "periodo": 202509,
        "valor": 262576439.0,
        "delta": -20911342.0
      },
      {
        "periodo": 202510,
        "valor": 237314242.0,
        "delta": -25262197.0
      },
      {
        "periodo": 202511,
        "valor": 220888852.0,
        "delta": -16425390.0
      },
      {
        "periodo": 202512,
        "valor": 266240232.0,
        "delta": 45351380.0
      },
      {
        "periodo": 202601,
        "valor": 275678034.0,
        "delta": 9437802.0
      },
      {
        "periodo": 202602,
        "valor": 293457507.0,
        "delta": 17779473.0
      },
      {
        "periodo": 202603,
        "valor": 290711100.0,
        "delta": -2746407.0
      },
      {
        "periodo": 202604,
        "valor": 300789173.0,
        "delta": 10078073.0
      },
      {
        "periodo": 202605,
        "valor": 316855907.0,
        "delta": 16066734.0
      },
      {
        "periodo": 202606,
        "valor": 333095527.0,
        "delta": 16239620.0
      },
      {
        "periodo": 202607,
        "valor": 367868723.0,
        "delta": 34773196.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 1042939971.86,
    "valor_anterior": 1638962552.08,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2004068997.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1785704871.09,
        "delta": -218364126.16
      },
      {
        "periodo": 202509,
        "valor": 1742720128.19,
        "delta": -42984742.9
      },
      {
        "periodo": 202510,
        "valor": 1897166614.58,
        "delta": 154446486.39
      },
      {
        "periodo": 202511,
        "valor": 1996219213.69,
        "delta": 99052599.11
      },
      {
        "periodo": 202512,
        "valor": 1341533224.21,
        "delta": -654685989.48
      },
      {
        "periodo": 202601,
        "valor": 914753523.41,
        "delta": -426779700.8
      },
      {
        "periodo": 202602,
        "valor": 752559797.76,
        "delta": -162193725.65
      },
      {
        "periodo": 202603,
        "valor": 1707234436.17,
        "delta": 954674638.41
      },
      {
        "periodo": 202604,
        "valor": 1803700773.61,
        "delta": 96466337.44
      },
      {
        "periodo": 202605,
        "valor": 1139539274.47,
        "delta": -664161499.14
      },
      {
        "periodo": 202606,
        "valor": 1638962552.08,
        "delta": 499423277.61
      },
      {
        "periodo": 202607,
        "valor": 1042939971.86,
        "delta": -596022580.22
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 60267717.0,
    "valor_anterior": 17735656.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19999755.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 48714570.0,
        "delta": 28714815.0
      },
      {
        "periodo": 202509,
        "valor": 185154731.0,
        "delta": 136440161.0
      },
      {
        "periodo": 202510,
        "valor": 350688141.0,
        "delta": 165533410.0
      },
      {
        "periodo": 202511,
        "valor": 218871281.0,
        "delta": -131816860.0
      },
      {
        "periodo": 202512,
        "valor": 235065015.0,
        "delta": 16193734.0
      },
      {
        "periodo": 202601,
        "valor": 117417117.0,
        "delta": -117647898.0
      },
      {
        "periodo": 202602,
        "valor": 36608074.0,
        "delta": -80809043.0
      },
      {
        "periodo": 202603,
        "valor": 19401724.0,
        "delta": -17206350.0
      },
      {
        "periodo": 202604,
        "valor": 40594546.0,
        "delta": 21192822.0
      },
      {
        "periodo": 202605,
        "valor": 33591879.0,
        "delta": -7002667.0
      },
      {
        "periodo": 202606,
        "valor": 17735656.0,
        "delta": -15856223.0
      },
      {
        "periodo": 202607,
        "valor": 60267717.0,
        "delta": 42532061.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 6632126056.14,
    "valor_anterior": 7216362489.32,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5884055928.86,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5432806872.91,
        "delta": -451249055.95
      },
      {
        "periodo": 202509,
        "valor": 4855768192.22,
        "delta": -577038680.69
      },
      {
        "periodo": 202510,
        "valor": 4556988726.87,
        "delta": -298779465.35
      },
      {
        "periodo": 202511,
        "valor": 5915537590.31,
        "delta": 1358548863.44
      },
      {
        "periodo": 202512,
        "valor": 8752380929.76,
        "delta": 2836843339.45
      },
      {
        "periodo": 202601,
        "valor": 6734854377.59,
        "delta": -2017526552.17
      },
      {
        "periodo": 202602,
        "valor": 6430272111.63,
        "delta": -304582265.96
      },
      {
        "periodo": 202603,
        "valor": 8483469561.88,
        "delta": 2053197450.25
      },
      {
        "periodo": 202604,
        "valor": 6073553662.37,
        "delta": -2409915899.51
      },
      {
        "periodo": 202605,
        "valor": 5704129800.73,
        "delta": -369423861.64
      },
      {
        "periodo": 202606,
        "valor": 7216362489.32,
        "delta": 1512232688.59
      },
      {
        "periodo": 202607,
        "valor": 6632126056.14,
        "delta": -584236433.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 153932844.58,
    "valor_anterior": 164339913.33,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 196641072.85,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 125074633.48,
        "delta": -71566439.37
      },
      {
        "periodo": 202509,
        "valor": 172768754.31,
        "delta": 47694120.83
      },
      {
        "periodo": 202510,
        "valor": 144244173.13,
        "delta": -28524581.18
      },
      {
        "periodo": 202511,
        "valor": 237731658.3,
        "delta": 93487485.17
      },
      {
        "periodo": 202512,
        "valor": 154006783.3,
        "delta": -83724875.0
      },
      {
        "periodo": 202601,
        "valor": 153223596.87,
        "delta": -783186.43
      },
      {
        "periodo": 202602,
        "valor": 195904987.65,
        "delta": 42681390.78
      },
      {
        "periodo": 202603,
        "valor": 178967330.29,
        "delta": -16937657.36
      },
      {
        "periodo": 202604,
        "valor": 153367220.05,
        "delta": -25600110.24
      },
      {
        "periodo": 202605,
        "valor": 157385344.45,
        "delta": 4018124.4
      },
      {
        "periodo": 202606,
        "valor": 164339913.33,
        "delta": 6954568.88
      },
      {
        "periodo": 202607,
        "valor": 153932844.58,
        "delta": -10407068.75
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 6686412996.999999,
    "valor_anterior": 5497180752.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5673295580.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6090240897.0,
        "delta": 416945317.0
      },
      {
        "periodo": 202509,
        "valor": 6299471655.0,
        "delta": 209230758.0
      },
      {
        "periodo": 202510,
        "valor": 7005689877.0,
        "delta": 706218222.0
      },
      {
        "periodo": 202511,
        "valor": 7538450011.0,
        "delta": 532760134.0
      },
      {
        "periodo": 202512,
        "valor": 6347995132.0,
        "delta": -1190454879.0
      },
      {
        "periodo": 202601,
        "valor": 7367551932.0,
        "delta": 1019556800.0
      },
      {
        "periodo": 202602,
        "valor": 7091555062.0,
        "delta": -275996870.0
      },
      {
        "periodo": 202603,
        "valor": 7282667213.0,
        "delta": 191112151.0
      },
      {
        "periodo": 202604,
        "valor": 7233022674.0,
        "delta": -49644539.0
      },
      {
        "periodo": 202605,
        "valor": 5954914517.0,
        "delta": -1278108157.0
      },
      {
        "periodo": 202606,
        "valor": 5497180753.0,
        "delta": -457733764.0
      },
      {
        "periodo": 202607,
        "valor": 6686412997.0,
        "delta": 1189232244.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 14114131054.000002,
    "valor_anterior": 11633912005.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11367929553.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13538591961.0,
        "delta": 2170662408.0
      },
      {
        "periodo": 202509,
        "valor": 10642845214.0,
        "delta": -2895746747.0
      },
      {
        "periodo": 202510,
        "valor": 10942192630.0,
        "delta": 299347416.0
      },
      {
        "periodo": 202511,
        "valor": 12121350279.0,
        "delta": 1179157649.0
      },
      {
        "periodo": 202512,
        "valor": 15458466367.0,
        "delta": 3337116088.0
      },
      {
        "periodo": 202601,
        "valor": 14462160941.0,
        "delta": -996305426.0
      },
      {
        "periodo": 202602,
        "valor": 14256912375.0,
        "delta": -205248566.0
      },
      {
        "periodo": 202603,
        "valor": 14804723946.0,
        "delta": 547811571.0
      },
      {
        "periodo": 202604,
        "valor": 15024634073.0,
        "delta": 219910127.0
      },
      {
        "periodo": 202605,
        "valor": 12318843957.0,
        "delta": -2705790116.0
      },
      {
        "periodo": 202606,
        "valor": 11633912005.0,
        "delta": -684931952.0
      },
      {
        "periodo": 202607,
        "valor": 14114131054.0,
        "delta": 2480219049.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 467529518.0,
    "valor_anterior": 612627996.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 295222433.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 365542096.0,
        "delta": 70319663.0
      },
      {
        "periodo": 202509,
        "valor": 361201097.0,
        "delta": -4340999.0
      },
      {
        "periodo": 202510,
        "valor": 486538418.0,
        "delta": 125337321.0
      },
      {
        "periodo": 202511,
        "valor": 471756786.0,
        "delta": -14781632.0
      },
      {
        "periodo": 202512,
        "valor": 302859624.0,
        "delta": -168897162.0
      },
      {
        "periodo": 202601,
        "valor": 369385680.0,
        "delta": 66526056.0
      },
      {
        "periodo": 202602,
        "valor": 538074542.0,
        "delta": 168688862.0
      },
      {
        "periodo": 202603,
        "valor": 711354648.0,
        "delta": 173280106.0
      },
      {
        "periodo": 202604,
        "valor": 828388587.0,
        "delta": 117033939.0
      },
      {
        "periodo": 202605,
        "valor": 617817524.0,
        "delta": -210571063.0
      },
      {
        "periodo": 202606,
        "valor": 612627996.0,
        "delta": -5189528.0
      },
      {
        "periodo": 202607,
        "valor": 467529518.0,
        "delta": -145098478.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 1383123145.22,
    "valor_anterior": 2358305210.35,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2479570254.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2701025649.17,
        "delta": 221455394.3
      },
      {
        "periodo": 202509,
        "valor": 2561737827.36,
        "delta": -139287821.81
      },
      {
        "periodo": 202510,
        "valor": 2607333725.88,
        "delta": 45595898.52
      },
      {
        "periodo": 202511,
        "valor": 1083697011.8,
        "delta": -1523636714.08
      },
      {
        "periodo": 202512,
        "valor": 2018294714.2,
        "delta": 934597702.4
      },
      {
        "periodo": 202601,
        "valor": 2346254134.98,
        "delta": 327959420.78
      },
      {
        "periodo": 202602,
        "valor": 3120704726.36,
        "delta": 774450591.38
      },
      {
        "periodo": 202603,
        "valor": 2340994481.1,
        "delta": -779710245.26
      },
      {
        "periodo": 202604,
        "valor": 1259334470.63,
        "delta": -1081660010.47
      },
      {
        "periodo": 202605,
        "valor": 2019509958.76,
        "delta": 760175488.13
      },
      {
        "periodo": 202606,
        "valor": 2358305210.35,
        "delta": 338795251.59
      },
      {
        "periodo": 202607,
        "valor": 1383123145.22,
        "delta": -975182065.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 3487521413.55,
    "valor_anterior": 4704969384.45,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4603210235.04,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4743939351.99,
        "delta": 140729116.95
      },
      {
        "periodo": 202509,
        "valor": 4536159616.88,
        "delta": -207779735.11
      },
      {
        "periodo": 202510,
        "valor": 3600713348.26,
        "delta": -935446268.62
      },
      {
        "periodo": 202511,
        "valor": 3960324726.41,
        "delta": 359611378.15
      },
      {
        "periodo": 202512,
        "valor": 4347487494.64,
        "delta": 387162768.23
      },
      {
        "periodo": 202601,
        "valor": 4660847144.13,
        "delta": 313359649.49
      },
      {
        "periodo": 202602,
        "valor": 4202671480.87,
        "delta": -458175663.26
      },
      {
        "periodo": 202603,
        "valor": 3292563761.14,
        "delta": -910107719.73
      },
      {
        "periodo": 202604,
        "valor": 3799530449.56,
        "delta": 506966688.42
      },
      {
        "periodo": 202605,
        "valor": 5554056130.21,
        "delta": 1754525680.65
      },
      {
        "periodo": 202606,
        "valor": 4704969384.45,
        "delta": -849086745.76
      },
      {
        "periodo": 202607,
        "valor": 3487521413.55,
        "delta": -1217447970.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 4399209765.0,
    "valor_anterior": 6322594526.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4585027816.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4068153256.0,
        "delta": -516874560.0
      },
      {
        "periodo": 202509,
        "valor": 7164208632.0,
        "delta": 3096055376.0
      },
      {
        "periodo": 202510,
        "valor": 4315400516.0,
        "delta": -2848808116.0
      },
      {
        "periodo": 202511,
        "valor": 5273752654.0,
        "delta": 958352138.0
      },
      {
        "periodo": 202512,
        "valor": 3708240834.0,
        "delta": -1565511820.0
      },
      {
        "periodo": 202601,
        "valor": 7128947019.0,
        "delta": 3420706185.0
      },
      {
        "periodo": 202602,
        "valor": 5656684830.0,
        "delta": -1472262189.0
      },
      {
        "periodo": 202603,
        "valor": 4418186572.0,
        "delta": -1238498258.0
      },
      {
        "periodo": 202604,
        "valor": 4751515914.0,
        "delta": 333329342.0
      },
      {
        "periodo": 202605,
        "valor": 7536812627.0,
        "delta": 2785296713.0
      },
      {
        "periodo": 202606,
        "valor": 6322594526.0,
        "delta": -1214218101.0
      },
      {
        "periodo": 202607,
        "valor": 4399209765.0,
        "delta": -1923384761.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 2709471.0,
    "valor_anterior": 46970739.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6246067.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7601108.0,
        "delta": 1355041.0
      },
      {
        "periodo": 202509,
        "valor": 3680050.0,
        "delta": -3921058.0
      },
      {
        "periodo": 202510,
        "valor": 50286064.0,
        "delta": 46606014.0
      },
      {
        "periodo": 202511,
        "valor": 2473236.0,
        "delta": -47812828.0
      },
      {
        "periodo": 202512,
        "valor": 67797271.0,
        "delta": 65324035.0
      },
      {
        "periodo": 202601,
        "valor": 2767754.0,
        "delta": -65029517.0
      },
      {
        "periodo": 202602,
        "valor": 34688579.0,
        "delta": 31920825.0
      },
      {
        "periodo": 202603,
        "valor": 80403444.0,
        "delta": 45714865.0
      },
      {
        "periodo": 202604,
        "valor": 5619557.0,
        "delta": -74783887.0
      },
      {
        "periodo": 202605,
        "valor": 8649096.0,
        "delta": 3029539.0
      },
      {
        "periodo": 202606,
        "valor": 46970739.0,
        "delta": 38321643.0
      },
      {
        "periodo": 202607,
        "valor": 2709471.0,
        "delta": -44261268.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 145323931.0,
    "valor_anterior": 113865636.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2543567898.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 145915559.0,
        "delta": 2689483457.0
      },
      {
        "periodo": 202509,
        "valor": 117768669.0,
        "delta": -28146890.0
      },
      {
        "periodo": 202510,
        "valor": 216192761.0,
        "delta": 98424092.0
      },
      {
        "periodo": 202511,
        "valor": 73750620.0,
        "delta": -142442141.0
      },
      {
        "periodo": 202512,
        "valor": 126923181.0,
        "delta": 53172561.0
      },
      {
        "periodo": 202601,
        "valor": 158819876.0,
        "delta": 31896695.0
      },
      {
        "periodo": 202602,
        "valor": -240425835.0,
        "delta": -399245711.0
      },
      {
        "periodo": 202603,
        "valor": -488589973.0,
        "delta": -248164138.0
      },
      {
        "periodo": 202604,
        "valor": 188009196.0,
        "delta": 676599169.0
      },
      {
        "periodo": 202605,
        "valor": 757448062.0,
        "delta": 569438866.0
      },
      {
        "periodo": 202606,
        "valor": 113865636.0,
        "delta": -643582426.0
      },
      {
        "periodo": 202607,
        "valor": 145323931.0,
        "delta": 31458295.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 1156863344.15,
    "valor_anterior": 1116288159.22,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11052973.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 942222223.28,
        "delta": 931169249.35
      },
      {
        "periodo": 202509,
        "valor": 1033217865.44,
        "delta": 90995642.16
      },
      {
        "periodo": 202510,
        "valor": 1054512845.09,
        "delta": 21294979.65
      },
      {
        "periodo": 202511,
        "valor": 1080722962.56,
        "delta": 26210117.47
      },
      {
        "periodo": 202512,
        "valor": 1131509273.89,
        "delta": 50786311.33
      },
      {
        "periodo": 202601,
        "valor": 1126338955.79,
        "delta": -5170318.1
      },
      {
        "periodo": 202602,
        "valor": 1158927757.26,
        "delta": 32588801.47
      },
      {
        "periodo": 202603,
        "valor": 1139756309.37,
        "delta": -19171447.89
      },
      {
        "periodo": 202604,
        "valor": 1125936802.56,
        "delta": -13819506.81
      },
      {
        "periodo": 202605,
        "valor": 1097775804.37,
        "delta": -28160998.19
      },
      {
        "periodo": 202606,
        "valor": 1116288159.22,
        "delta": 18512354.85
      },
      {
        "periodo": 202607,
        "valor": 1156863344.15,
        "delta": 40575184.93
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 4026921587.45,
    "valor_anterior": 4185010845.88,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1544577885.16,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1547632613.24,
        "delta": 3054728.08
      },
      {
        "periodo": 202509,
        "valor": 1548305409.14,
        "delta": 672795.9
      },
      {
        "periodo": 202510,
        "valor": 1555909916.84,
        "delta": 7604507.7
      },
      {
        "periodo": 202511,
        "valor": 1559611060.36,
        "delta": 3701143.52
      },
      {
        "periodo": 202512,
        "valor": 1561290334.17,
        "delta": 1679273.81
      },
      {
        "periodo": 202601,
        "valor": 1567608631.81,
        "delta": 6318297.64
      },
      {
        "periodo": 202602,
        "valor": 4353739801.79,
        "delta": 2786131169.98
      },
      {
        "periodo": 202603,
        "valor": 4720139701.3,
        "delta": 366399899.51
      },
      {
        "periodo": 202604,
        "valor": 4472711774.59,
        "delta": -247427926.71
      },
      {
        "periodo": 202605,
        "valor": 4336200073.86,
        "delta": -136511700.73
      },
      {
        "periodo": 202606,
        "valor": 4185010845.88,
        "delta": -151189227.98
      },
      {
        "periodo": 202607,
        "valor": 4026921587.45,
        "delta": -158089258.43
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 18415489.0,
    "valor_anterior": 66570336.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 251628917.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 165918544.0,
        "delta": -85710373.0
      },
      {
        "periodo": 202509,
        "valor": 171405166.0,
        "delta": 5486622.0
      },
      {
        "periodo": 202510,
        "valor": 134990578.0,
        "delta": -36414588.0
      },
      {
        "periodo": 202511,
        "valor": 112326584.0,
        "delta": -22663994.0
      },
      {
        "periodo": 202512,
        "valor": 115529503.0,
        "delta": 3202919.0
      },
      {
        "periodo": 202601,
        "valor": 103834801.0,
        "delta": -11694702.0
      },
      {
        "periodo": 202602,
        "valor": 32917044.0,
        "delta": -70917757.0
      },
      {
        "periodo": 202603,
        "valor": 98948036.0,
        "delta": 66030992.0
      },
      {
        "periodo": 202604,
        "valor": 59498272.0,
        "delta": -39449764.0
      },
      {
        "periodo": 202605,
        "valor": 56026315.0,
        "delta": -3471957.0
      },
      {
        "periodo": 202606,
        "valor": 66570336.0,
        "delta": 10544021.0
      },
      {
        "periodo": 202607,
        "valor": 18415489.0,
        "delta": -48154847.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 3993948839.79,
    "valor_anterior": 3474792907.34,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 1343476443.93,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 1286799080.1,
        "delta": -56677363.83
      },
      {
        "periodo": 202601,
        "valor": 2169257847.05,
        "delta": 882458766.95
      },
      {
        "periodo": 202602,
        "valor": 2432706521.84,
        "delta": 263448674.79
      },
      {
        "periodo": 202603,
        "valor": 1955553430.96,
        "delta": -477153090.88
      },
      {
        "periodo": 202604,
        "valor": 3899827492.93,
        "delta": 1944274061.97
      },
      {
        "periodo": 202605,
        "valor": 3784295067.72,
        "delta": -115532425.21
      },
      {
        "periodo": 202606,
        "valor": 3474792907.34,
        "delta": -309502160.38
      },
      {
        "periodo": 202607,
        "valor": 3993948839.79,
        "delta": 519155932.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 9197052118.0,
    "valor_anterior": 7386093768.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 3539895828.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 6100321668.0,
        "delta": 2560425840.0
      },
      {
        "periodo": 202605,
        "valor": 5873125538.0,
        "delta": -227196130.0
      },
      {
        "periodo": 202606,
        "valor": 7386093768.0,
        "delta": 1512968230.0
      },
      {
        "periodo": 202607,
        "valor": 9197052118.0,
        "delta": 1810958350.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 626767293153.16,
    "valor_anterior": 554615164410.06,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 525666722230.2801,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 606491571205.94,
        "delta": 80824848975.6599
      },
      {
        "periodo": 202509,
        "valor": 576039850780.6,
        "delta": -30451720425.34
      },
      {
        "periodo": 202510,
        "valor": 573309907908.69,
        "delta": -2729942871.91
      },
      {
        "periodo": 202511,
        "valor": 475367390071.41,
        "delta": -97942517837.28
      },
      {
        "periodo": 202512,
        "valor": 458130664539.12,
        "delta": -17236725532.29
      },
      {
        "periodo": 202601,
        "valor": 512714389621.94,
        "delta": 54583725082.82
      },
      {
        "periodo": 202602,
        "valor": 492175061765.41,
        "delta": -20539327856.53
      },
      {
        "periodo": 202603,
        "valor": 499535878614.34,
        "delta": 7360816848.9301
      },
      {
        "periodo": 202604,
        "valor": 559141688352.61,
        "delta": 59605809738.27
      },
      {
        "periodo": 202605,
        "valor": 632863836735.84,
        "delta": 73722148383.23
      },
      {
        "periodo": 202606,
        "valor": 554615164410.06,
        "delta": -78248672325.7799
      },
      {
        "periodo": 202607,
        "valor": 626767293153.16,
        "delta": 72152128743.1
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 384840474727.43,
    "valor_anterior": 341841172908.67,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 308388141759.79,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 359401586753.27,
        "delta": 51013444993.48
      },
      {
        "periodo": 202509,
        "valor": 357257890380.42,
        "delta": -2143696372.85
      },
      {
        "periodo": 202510,
        "valor": 357422813900.79,
        "delta": 164923520.37
      },
      {
        "periodo": 202511,
        "valor": 288821847949.93,
        "delta": -68600965950.86
      },
      {
        "periodo": 202512,
        "valor": 173095485239.55,
        "delta": -115726362710.38
      },
      {
        "periodo": 202601,
        "valor": 300566633854.42,
        "delta": 127471148614.87
      },
      {
        "periodo": 202602,
        "valor": 286802569455.65,
        "delta": -13764064398.77
      },
      {
        "periodo": 202603,
        "valor": 241977728411.18,
        "delta": -44824841044.47
      },
      {
        "periodo": 202604,
        "valor": 314792331339.12,
        "delta": 72814602927.94
      },
      {
        "periodo": 202605,
        "valor": 383231227323.77,
        "delta": 68438895984.65
      },
      {
        "periodo": 202606,
        "valor": 341841172908.67,
        "delta": -41390054415.1
      },
      {
        "periodo": 202607,
        "valor": 384840474727.43,
        "delta": 42999301818.76
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 26239858024.84,
    "valor_anterior": 22454064965.92,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 47912549417.22,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 46695028865.36,
        "delta": -1217520551.86
      },
      {
        "periodo": 202509,
        "valor": 25817156346.49,
        "delta": -20877872518.87
      },
      {
        "periodo": 202510,
        "valor": 30216144635.01,
        "delta": 4398988288.52
      },
      {
        "periodo": 202511,
        "valor": 16315946542.24,
        "delta": -13900198092.77
      },
      {
        "periodo": 202512,
        "valor": 46534003505.59,
        "delta": 30218056963.35
      },
      {
        "periodo": 202601,
        "valor": 25363051572.65,
        "delta": -21170951932.94
      },
      {
        "periodo": 202602,
        "valor": 27434249223.56,
        "delta": 2071197650.91
      },
      {
        "periodo": 202603,
        "valor": 30055804732.34,
        "delta": 2621555508.78
      },
      {
        "periodo": 202604,
        "valor": 33389389081.57,
        "delta": 3333584349.23
      },
      {
        "periodo": 202605,
        "valor": 21631779697.68,
        "delta": -11757609383.89
      },
      {
        "periodo": 202606,
        "valor": 22454064965.92,
        "delta": 822285268.24
      },
      {
        "periodo": 202607,
        "valor": 26239858024.84,
        "delta": 3785793058.92
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 45933853737.32,
    "valor_anterior": 25925553897.049995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 41770454009.02,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 49022670292.37,
        "delta": 7252216283.35
      },
      {
        "periodo": 202509,
        "valor": 56283429979.43,
        "delta": 7260759687.06
      },
      {
        "periodo": 202510,
        "valor": 47847385270.66,
        "delta": -8436044708.77
      },
      {
        "periodo": 202511,
        "valor": 48074584081.37,
        "delta": 227198810.71
      },
      {
        "periodo": 202512,
        "valor": 77625068518.3,
        "delta": 29550484436.93
      },
      {
        "periodo": 202601,
        "valor": 43363960970.32,
        "delta": -34261107547.98
      },
      {
        "periodo": 202602,
        "valor": 36690598645.36,
        "delta": -6673362324.96
      },
      {
        "periodo": 202603,
        "valor": 63247077864.13,
        "delta": 26556479218.77
      },
      {
        "periodo": 202604,
        "valor": 45649849368.52,
        "delta": -17597228495.61
      },
      {
        "periodo": 202605,
        "valor": 67439341295.55,
        "delta": 21789491927.03
      },
      {
        "periodo": 202606,
        "valor": 25925553897.05,
        "delta": -41513787398.5
      },
      {
        "periodo": 202607,
        "valor": 45933853737.32,
        "delta": 20008299840.27
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 87135081104.9,
    "valor_anterior": 75488584518.55,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 59109675623.28,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 76260829197.05,
        "delta": 17151153573.77
      },
      {
        "periodo": 202509,
        "valor": 60898879193.57,
        "delta": -15361950003.48
      },
      {
        "periodo": 202510,
        "valor": 60381957669.29,
        "delta": -516921524.28
      },
      {
        "periodo": 202511,
        "valor": 61002666281.37,
        "delta": 620708612.08
      },
      {
        "periodo": 202512,
        "valor": 86126746855.03,
        "delta": 25124080573.66
      },
      {
        "periodo": 202601,
        "valor": 73148201912.15,
        "delta": -12978544942.88
      },
      {
        "periodo": 202602,
        "valor": 69659035462.33,
        "delta": -3489166449.82
      },
      {
        "periodo": 202603,
        "valor": 76629951945.29,
        "delta": 6970916482.96
      },
      {
        "periodo": 202604,
        "valor": 80976855289.62,
        "delta": 4346903344.33
      },
      {
        "periodo": 202605,
        "valor": 77544919724.48,
        "delta": -3431935565.14
      },
      {
        "periodo": 202606,
        "valor": 75488584518.55,
        "delta": -2056335205.93
      },
      {
        "periodo": 202607,
        "valor": 87135081104.9,
        "delta": 11646496586.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 48093298364.35,
    "valor_anterior": 57096152466.53,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 52072663432.02,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 51627004302.5,
        "delta": -445659129.52
      },
      {
        "periodo": 202509,
        "valor": 55271866117.96,
        "delta": 3644861815.46
      },
      {
        "periodo": 202510,
        "valor": 52983925141.72,
        "delta": -2287940976.24
      },
      {
        "periodo": 202511,
        "valor": 41000034868.51,
        "delta": -11983890273.21
      },
      {
        "periodo": 202512,
        "valor": 53557315149.11,
        "delta": 12557280280.6
      },
      {
        "periodo": 202601,
        "valor": 47935462785.98,
        "delta": -5621852363.13
      },
      {
        "periodo": 202602,
        "valor": 45510061477.27,
        "delta": -2425401308.71
      },
      {
        "periodo": 202603,
        "valor": 59858824547.58,
        "delta": 14348763070.31
      },
      {
        "periodo": 202604,
        "valor": 46926768275.22,
        "delta": -12932056272.36
      },
      {
        "periodo": 202605,
        "valor": 47296112829.62,
        "delta": 369344554.4
      },
      {
        "periodo": 202606,
        "valor": 57096152466.53,
        "delta": 9800039636.91
      },
      {
        "periodo": 202607,
        "valor": 48093298364.35,
        "delta": -9002854102.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100047,
    "label": "Bancos",
    "valor_actual": 34524727194.32,
    "valor_anterior": 31809635653.34,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16413237988.95,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23484451795.39,
        "delta": 7071213806.44
      },
      {
        "periodo": 202509,
        "valor": 20510628762.73,
        "delta": -2973823032.66
      },
      {
        "periodo": 202510,
        "valor": 24457681291.22,
        "delta": 3947052528.49
      },
      {
        "periodo": 202511,
        "valor": 20152310347.99,
        "delta": -4305370943.23
      },
      {
        "periodo": 202512,
        "valor": 21192045271.54,
        "delta": 1039734923.55
      },
      {
        "periodo": 202601,
        "valor": 22337078526.42,
        "delta": 1145033254.88
      },
      {
        "periodo": 202602,
        "valor": 26078547501.24,
        "delta": 3741468974.82
      },
      {
        "periodo": 202603,
        "valor": 27766491113.82,
        "delta": 1687943612.58
      },
      {
        "periodo": 202604,
        "valor": 37406494998.56,
        "delta": 9640003884.74
      },
      {
        "periodo": 202605,
        "valor": 35720455864.74,
        "delta": -1686039133.82
      },
      {
        "periodo": 202606,
        "valor": 31809635653.34,
        "delta": -3910820211.4
      },
      {
        "periodo": 202607,
        "valor": 34524727194.32,
        "delta": 2715091540.98
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 352142879701.21,
    "valor_anterior": 356143884786.66,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 416428744646.84,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 402823793345.68,
        "delta": -13604951301.16
      },
      {
        "periodo": 202509,
        "valor": 406459664452.8,
        "delta": 3635871107.1201
      },
      {
        "periodo": 202510,
        "valor": 405712027422.87,
        "delta": -747637029.9301
      },
      {
        "periodo": 202511,
        "valor": 413930451910.23,
        "delta": 8218424487.36
      },
      {
        "periodo": 202512,
        "valor": 371499985701.21,
        "delta": -42430466209.02
      },
      {
        "periodo": 202601,
        "valor": 386907822695.18,
        "delta": 15407836993.97
      },
      {
        "periodo": 202602,
        "valor": 353366251792.91,
        "delta": -33541570902.27
      },
      {
        "periodo": 202603,
        "valor": 317164473325.13,
        "delta": -36201778467.78
      },
      {
        "periodo": 202604,
        "valor": 342892633032.64,
        "delta": 25728159707.51
      },
      {
        "periodo": 202605,
        "valor": 373273774239.4,
        "delta": 30381141206.76
      },
      {
        "periodo": 202606,
        "valor": 356143884786.66,
        "delta": -17129889452.7401
      },
      {
        "periodo": 202607,
        "valor": 352142879701.21,
        "delta": -4001005085.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 724355348455.34,
    "valor_anterior": 733381291748.3,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 598949409345.8002,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 563805881551.86,
        "delta": -35143527793.9402
      },
      {
        "periodo": 202509,
        "valor": 578436153196.34,
        "delta": 14630271644.48
      },
      {
        "periodo": 202510,
        "valor": 590272533544.93,
        "delta": 11836380348.5901
      },
      {
        "periodo": 202511,
        "valor": 617960794530.93,
        "delta": 27688260986.0
      },
      {
        "periodo": 202512,
        "valor": 662341717503.93,
        "delta": 44380922973.0
      },
      {
        "periodo": 202601,
        "valor": 643725158710.35,
        "delta": -18616558793.5801
      },
      {
        "periodo": 202602,
        "valor": 676746601131.11,
        "delta": 33021442420.76
      },
      {
        "periodo": 202603,
        "valor": 681429767189.89,
        "delta": 4683166058.78
      },
      {
        "periodo": 202604,
        "valor": 675576755094.75,
        "delta": -5853012095.14
      },
      {
        "periodo": 202605,
        "valor": 713269091087.28,
        "delta": 37692335992.53
      },
      {
        "periodo": 202606,
        "valor": 733381291748.3,
        "delta": 20112200661.02
      },
      {
        "periodo": 202607,
        "valor": 724355348455.34,
        "delta": -9025943292.9601
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 699773403744.0,
    "valor_anterior": 661519964065.0001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 593626646141.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 599303737922.0,
        "delta": 5677091781.0
      },
      {
        "periodo": 202509,
        "valor": 618043382066.0,
        "delta": 18739644144.0
      },
      {
        "periodo": 202510,
        "valor": 636575887471.0,
        "delta": 18532505405.0
      },
      {
        "periodo": 202511,
        "valor": 651371275200.0,
        "delta": 14795387729.0
      },
      {
        "periodo": 202512,
        "valor": 672341803701.0,
        "delta": 20970528501.0
      },
      {
        "periodo": 202601,
        "valor": 644284201132.0,
        "delta": -28057602569.0
      },
      {
        "periodo": 202602,
        "valor": 638049489482.0,
        "delta": -6234711650.0
      },
      {
        "periodo": 202603,
        "valor": 676902108244.0,
        "delta": 38852618762.0
      },
      {
        "periodo": 202604,
        "valor": 645332004048.0,
        "delta": -31570104196.0
      },
      {
        "periodo": 202605,
        "valor": 679825719472.0,
        "delta": 34493715424.0
      },
      {
        "periodo": 202606,
        "valor": 661519964065.0001,
        "delta": -18305755406.9999
      },
      {
        "periodo": 202607,
        "valor": 699773403744.0,
        "delta": 38253439678.9999
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 189392783260.0,
    "valor_anterior": 198986567330.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 210476265930.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 218382913230.0,
        "delta": 7906647300.0
      },
      {
        "periodo": 202509,
        "valor": 224058653472.0,
        "delta": 5675740242.0
      },
      {
        "periodo": 202510,
        "valor": 214978533844.0,
        "delta": -9080119628.0
      },
      {
        "periodo": 202511,
        "valor": 219976163951.0,
        "delta": 4997630107.0
      },
      {
        "periodo": 202512,
        "valor": 217864738947.0,
        "delta": -2111425004.0
      },
      {
        "periodo": 202601,
        "valor": 212848788853.0,
        "delta": -5015950094.0
      },
      {
        "periodo": 202602,
        "valor": 222767721054.0,
        "delta": 9918932201.0
      },
      {
        "periodo": 202603,
        "valor": 210747446507.0,
        "delta": -12020274547.0
      },
      {
        "periodo": 202604,
        "valor": 197359367114.0,
        "delta": -13388079393.0
      },
      {
        "periodo": 202605,
        "valor": 193136534828.0,
        "delta": -4222832286.0
      },
      {
        "periodo": 202606,
        "valor": 198986567330.0,
        "delta": 5850032502.0
      },
      {
        "periodo": 202607,
        "valor": 189392783260.0,
        "delta": -9593784070.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 38189396824.89,
    "valor_anterior": 37904611532.18,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28262579244.55,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29641296981.22,
        "delta": 1378717736.67
      },
      {
        "periodo": 202509,
        "valor": 31836004425.62,
        "delta": 2194707444.4
      },
      {
        "periodo": 202510,
        "valor": 32174530857.32,
        "delta": 338526431.7
      },
      {
        "periodo": 202511,
        "valor": 33695755002.97,
        "delta": 1521224145.65
      },
      {
        "periodo": 202512,
        "valor": 38969220322.28,
        "delta": 5273465319.31
      },
      {
        "periodo": 202601,
        "valor": 39190494878.11,
        "delta": 221274555.83
      },
      {
        "periodo": 202602,
        "valor": 39197984127.43,
        "delta": 7489249.32
      },
      {
        "periodo": 202603,
        "valor": 39017066044.9,
        "delta": -180918082.53
      },
      {
        "periodo": 202604,
        "valor": 38924252058.89,
        "delta": -92813986.01
      },
      {
        "periodo": 202605,
        "valor": 39138999969.25,
        "delta": 214747910.36
      },
      {
        "periodo": 202606,
        "valor": 37904611532.18,
        "delta": -1234388437.07
      },
      {
        "periodo": 202607,
        "valor": 38189396824.89,
        "delta": 284785292.71
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 69681167379.0,
    "valor_anterior": 76055404837.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 70030352357.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 73588344402.0,
        "delta": 3557992045.0
      },
      {
        "periodo": 202509,
        "valor": 72118810259.0,
        "delta": -1469534143.0
      },
      {
        "periodo": 202510,
        "valor": 65834766232.0,
        "delta": -6284044027.0
      },
      {
        "periodo": 202511,
        "valor": 66343616229.0,
        "delta": 508849997.0
      },
      {
        "periodo": 202512,
        "valor": 79638351086.0,
        "delta": 13294734857.0
      },
      {
        "periodo": 202601,
        "valor": 83980513093.0,
        "delta": 4342162007.0
      },
      {
        "periodo": 202602,
        "valor": 82935582244.0,
        "delta": -1044930849.0
      },
      {
        "periodo": 202603,
        "valor": 85082904167.0,
        "delta": 2147321923.0
      },
      {
        "periodo": 202604,
        "valor": 81268533977.0,
        "delta": -3814370190.0
      },
      {
        "periodo": 202605,
        "valor": 79715321036.0,
        "delta": -1553212941.0
      },
      {
        "periodo": 202606,
        "valor": 76055404837.0,
        "delta": -3659916199.0
      },
      {
        "periodo": 202607,
        "valor": 69681167379.0,
        "delta": -6374237458.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 60433742201.0,
    "valor_anterior": 57960505326.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 52119104778.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 51807520579.0,
        "delta": -311584199.0
      },
      {
        "periodo": 202509,
        "valor": 52424442681.0,
        "delta": 616922102.0
      },
      {
        "periodo": 202510,
        "valor": 50864218573.0,
        "delta": -1560224108.0
      },
      {
        "periodo": 202511,
        "valor": 50374803960.0,
        "delta": -489414613.0
      },
      {
        "periodo": 202512,
        "valor": 48627702043.0,
        "delta": -1747101917.0
      },
      {
        "periodo": 202601,
        "valor": 56716019456.0,
        "delta": 8088317413.0
      },
      {
        "periodo": 202602,
        "valor": 57107652118.0,
        "delta": 391632662.0
      },
      {
        "periodo": 202603,
        "valor": 60796007458.0,
        "delta": 3688355340.0
      },
      {
        "periodo": 202604,
        "valor": 59965495676.0,
        "delta": -830511782.0
      },
      {
        "periodo": 202605,
        "valor": 59479466085.0,
        "delta": -486029591.0
      },
      {
        "periodo": 202606,
        "valor": 57960505326.0,
        "delta": -1518960759.0
      },
      {
        "periodo": 202607,
        "valor": 60433742201.0,
        "delta": 2473236875.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 179790549524.0,
    "valor_anterior": 182911593131.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 166595169440.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 171111932584.0,
        "delta": 4516763144.0
      },
      {
        "periodo": 202509,
        "valor": 177633859911.0,
        "delta": 6521927327.0
      },
      {
        "periodo": 202510,
        "valor": 195000749741.0,
        "delta": 17366889830.0
      },
      {
        "periodo": 202511,
        "valor": 193509608549.0,
        "delta": -1491141192.0
      },
      {
        "periodo": 202512,
        "valor": 193575208397.0,
        "delta": 65599848.0
      },
      {
        "periodo": 202601,
        "valor": 178715028690.0,
        "delta": -14860179707.0
      },
      {
        "periodo": 202602,
        "valor": 188627504319.0,
        "delta": 9912475629.0
      },
      {
        "periodo": 202603,
        "valor": 193545071913.0,
        "delta": 4917567594.0
      },
      {
        "periodo": 202604,
        "valor": 184241239596.0,
        "delta": -9303832317.0
      },
      {
        "periodo": 202605,
        "valor": 198599653218.0,
        "delta": 14358413622.0
      },
      {
        "periodo": 202606,
        "valor": 182911593131.0,
        "delta": -15688060087.0
      },
      {
        "periodo": 202607,
        "valor": 179790549524.0,
        "delta": -3121043607.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 59533424724.89,
    "valor_anterior": 56288775602.85,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 48548964268.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 50042132561.79,
        "delta": 1493168293.4
      },
      {
        "periodo": 202509,
        "valor": 54460140798.33,
        "delta": 4418008236.54
      },
      {
        "periodo": 202510,
        "valor": 56596615175.61,
        "delta": 2136474377.28
      },
      {
        "periodo": 202511,
        "valor": 58043620136.79,
        "delta": 1447004961.18
      },
      {
        "periodo": 202512,
        "valor": 56031091404.41,
        "delta": -2012528732.38
      },
      {
        "periodo": 202601,
        "valor": 58964902341.05,
        "delta": 2933810936.64
      },
      {
        "periodo": 202602,
        "valor": 58878476341.84,
        "delta": -86425999.21
      },
      {
        "periodo": 202603,
        "valor": 58388630516.98,
        "delta": -489845824.86
      },
      {
        "periodo": 202604,
        "valor": 56182904604.69,
        "delta": -2205725912.29
      },
      {
        "periodo": 202605,
        "valor": 59133988482.4,
        "delta": 2951083877.71
      },
      {
        "periodo": 202606,
        "valor": 56288775602.85,
        "delta": -2845212879.55
      },
      {
        "periodo": 202607,
        "valor": 59533424724.89,
        "delta": 3244649122.04
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 141021634104.0,
    "valor_anterior": 152761402884.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 137269288799.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 126332631615.0,
        "delta": -10936657184.0
      },
      {
        "periodo": 202509,
        "valor": 120652299186.0,
        "delta": -5680332429.0
      },
      {
        "periodo": 202510,
        "valor": 130522079152.0,
        "delta": 9869779966.0
      },
      {
        "periodo": 202511,
        "valor": 130213673602.0,
        "delta": -308405550.0
      },
      {
        "periodo": 202512,
        "valor": 123497380519.0,
        "delta": -6716293083.0
      },
      {
        "periodo": 202601,
        "valor": 133699481871.0,
        "delta": 10202101352.0
      },
      {
        "periodo": 202602,
        "valor": 143770389191.0,
        "delta": 10070907320.0
      },
      {
        "periodo": 202603,
        "valor": 135671522872.0,
        "delta": -8098866319.0
      },
      {
        "periodo": 202604,
        "valor": 144990281108.0,
        "delta": 9318758236.0
      },
      {
        "periodo": 202605,
        "valor": 151898629106.0,
        "delta": 6908347998.0
      },
      {
        "periodo": 202606,
        "valor": 152761402884.0,
        "delta": 862773778.0
      },
      {
        "periodo": 202607,
        "valor": 141021634104.0,
        "delta": -11739768780.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 27390389985.0,
    "valor_anterior": 27377501337.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27921421186.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29403285573.0,
        "delta": 1481864387.0
      },
      {
        "periodo": 202509,
        "valor": 29511823939.0,
        "delta": 108538366.0
      },
      {
        "periodo": 202510,
        "valor": 28160573005.0,
        "delta": -1351250934.0
      },
      {
        "periodo": 202511,
        "valor": 27622332072.0,
        "delta": -538240933.0
      },
      {
        "periodo": 202512,
        "valor": 28703777772.0,
        "delta": 1081445700.0
      },
      {
        "periodo": 202601,
        "valor": 26425294366.0,
        "delta": -2278483406.0
      },
      {
        "periodo": 202602,
        "valor": 28031552116.0,
        "delta": 1606257750.0
      },
      {
        "periodo": 202603,
        "valor": 27976940694.0,
        "delta": -54611422.0
      },
      {
        "periodo": 202604,
        "valor": 29162824426.0,
        "delta": 1185883732.0
      },
      {
        "periodo": 202605,
        "valor": 27877606301.0,
        "delta": -1285218125.0
      },
      {
        "periodo": 202606,
        "valor": 27377501337.0,
        "delta": -500104964.0
      },
      {
        "periodo": 202607,
        "valor": 27390389985.0,
        "delta": 12888648.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 170529222025.0,
    "valor_anterior": 139291452050.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 177438465270.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 179170055043.0,
        "delta": 1731589773.0
      },
      {
        "periodo": 202509,
        "valor": 178452958748.0,
        "delta": -717096295.0
      },
      {
        "periodo": 202510,
        "valor": 168214367413.0,
        "delta": -10238591335.0
      },
      {
        "periodo": 202511,
        "valor": 170777449409.0,
        "delta": 2563081996.0
      },
      {
        "periodo": 202512,
        "valor": 178792264377.0,
        "delta": 8014814968.0
      },
      {
        "periodo": 202601,
        "valor": 173188619697.0,
        "delta": -5603644680.0
      },
      {
        "periodo": 202602,
        "valor": 151264945744.0,
        "delta": -21923673953.0
      },
      {
        "periodo": 202603,
        "valor": 153480468094.0,
        "delta": 2215522350.0
      },
      {
        "periodo": 202604,
        "valor": 145712691907.0,
        "delta": -7767776187.0
      },
      {
        "periodo": 202605,
        "valor": 139314508527.0,
        "delta": -6398183380.0
      },
      {
        "periodo": 202606,
        "valor": 139291452050.0,
        "delta": -23056477.0
      },
      {
        "periodo": 202607,
        "valor": 170529222025.0,
        "delta": 31237769975.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 509390206796.19,
    "valor_anterior": 513567890131.99,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 451283267043.6,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 443714167760.0,
        "delta": -7569099283.6
      },
      {
        "periodo": 202509,
        "valor": 442150639717.93,
        "delta": -1563528042.07
      },
      {
        "periodo": 202510,
        "valor": 463405303608.59,
        "delta": 21254663890.66
      },
      {
        "periodo": 202511,
        "valor": 447286405223.66,
        "delta": -16118898384.9301
      },
      {
        "periodo": 202512,
        "valor": 465818270731.63,
        "delta": 18531865507.97
      },
      {
        "periodo": 202601,
        "valor": 469641735885.74,
        "delta": 3823465154.11
      },
      {
        "periodo": 202602,
        "valor": 468799703437.64,
        "delta": -842032448.1
      },
      {
        "periodo": 202603,
        "valor": 503732796944.58,
        "delta": 34933093506.94
      },
      {
        "periodo": 202604,
        "valor": 499273914732.67,
        "delta": -4458882211.91
      },
      {
        "periodo": 202605,
        "valor": 499190420324.11,
        "delta": -83494408.56
      },
      {
        "periodo": 202606,
        "valor": 513567890131.99,
        "delta": 14377469807.88
      },
      {
        "periodo": 202607,
        "valor": 509390206796.19,
        "delta": -4177683335.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 29180774675.0,
    "valor_anterior": 24010546002.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 45837820998.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 41449347384.0,
        "delta": -4388473614.0
      },
      {
        "periodo": 202509,
        "valor": 32834299728.0,
        "delta": -8615047656.0
      },
      {
        "periodo": 202510,
        "valor": 40912044715.0,
        "delta": 8077744987.0
      },
      {
        "periodo": 202511,
        "valor": 47349613902.0,
        "delta": 6437569187.0
      },
      {
        "periodo": 202512,
        "valor": 28427632703.0,
        "delta": -18921981199.0
      },
      {
        "periodo": 202601,
        "valor": 39747419661.0,
        "delta": 11319786958.0
      },
      {
        "periodo": 202602,
        "valor": 39272000952.0,
        "delta": -475418709.0
      },
      {
        "periodo": 202603,
        "valor": 38666944396.0,
        "delta": -605056556.0
      },
      {
        "periodo": 202604,
        "valor": 27301432920.0,
        "delta": -11365511476.0
      },
      {
        "periodo": 202605,
        "valor": 27305875671.0,
        "delta": 4442751.0
      },
      {
        "periodo": 202606,
        "valor": 24010546002.0,
        "delta": -3295329669.0
      },
      {
        "periodo": 202607,
        "valor": 29180774675.0,
        "delta": 5170228673.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 9078386457.0,
    "valor_anterior": 9064188519.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8516955488.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8557317206.0,
        "delta": 40361718.0
      },
      {
        "periodo": 202509,
        "valor": 8416801028.0,
        "delta": -140516178.0
      },
      {
        "periodo": 202510,
        "valor": 8524662876.0,
        "delta": 107861848.0
      },
      {
        "periodo": 202511,
        "valor": 9345485037.0,
        "delta": 820822161.0
      },
      {
        "periodo": 202512,
        "valor": 7771869704.0,
        "delta": -1573615333.0
      },
      {
        "periodo": 202601,
        "valor": 9138607158.0,
        "delta": 1366737454.0
      },
      {
        "periodo": 202602,
        "valor": 8521226409.0,
        "delta": -617380749.0
      },
      {
        "periodo": 202603,
        "valor": 9163418975.0,
        "delta": 642192566.0
      },
      {
        "periodo": 202604,
        "valor": 8066473500.0,
        "delta": -1096945475.0
      },
      {
        "periodo": 202605,
        "valor": 8906380148.0,
        "delta": 839906648.0
      },
      {
        "periodo": 202606,
        "valor": 9064188519.0,
        "delta": 157808371.0
      },
      {
        "periodo": 202607,
        "valor": 9078386457.0,
        "delta": 14197938.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 30980665022.0,
    "valor_anterior": 34132786511.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40790350157.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 44567925537.0,
        "delta": 3777575380.0
      },
      {
        "periodo": 202509,
        "valor": 49214253700.0,
        "delta": 4646328163.0
      },
      {
        "periodo": 202510,
        "valor": 42713947607.0,
        "delta": -6500306093.0
      },
      {
        "periodo": 202511,
        "valor": 46079616194.0,
        "delta": 3365668587.0
      },
      {
        "periodo": 202512,
        "valor": 48300586678.0,
        "delta": 2220970484.0
      },
      {
        "periodo": 202601,
        "valor": 42202183931.0,
        "delta": -6098402747.0
      },
      {
        "periodo": 202602,
        "valor": 43097062003.0,
        "delta": 894878072.0
      },
      {
        "periodo": 202603,
        "valor": 30021496604.0,
        "delta": -13075565399.0
      },
      {
        "periodo": 202604,
        "valor": 34230277793.0,
        "delta": 4208781189.0
      },
      {
        "periodo": 202605,
        "valor": 26790464795.0,
        "delta": -7439812998.0
      },
      {
        "periodo": 202606,
        "valor": 34132786511.0,
        "delta": 7342321716.0
      },
      {
        "periodo": 202607,
        "valor": 30980665022.0,
        "delta": -3152121489.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 127060215643.79,
    "valor_anterior": 123849727035.95,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 144674339269.09,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 142483989629.57,
        "delta": -2190349639.52
      },
      {
        "periodo": 202509,
        "valor": 137477820948.85,
        "delta": -5006168680.72
      },
      {
        "periodo": 202510,
        "valor": 120326501049.91,
        "delta": -17151319898.94
      },
      {
        "periodo": 202511,
        "valor": 119795686539.31,
        "delta": -530814510.6
      },
      {
        "periodo": 202512,
        "valor": 114313859267.15,
        "delta": -5481827272.16
      },
      {
        "periodo": 202601,
        "valor": 103686531008.0,
        "delta": -10627328259.15
      },
      {
        "periodo": 202602,
        "valor": 104517585746.24,
        "delta": 831054738.24
      },
      {
        "periodo": 202603,
        "valor": 92858356345.32,
        "delta": -11659229400.92
      },
      {
        "periodo": 202604,
        "valor": 93862881918.74,
        "delta": 1004525573.42
      },
      {
        "periodo": 202605,
        "valor": 111218548761.23,
        "delta": 17355666842.49
      },
      {
        "periodo": 202606,
        "valor": 123849727035.95,
        "delta": 12631178274.72
      },
      {
        "periodo": 202607,
        "valor": 127060215643.79,
        "delta": 3210488607.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 55973699658.0,
    "valor_anterior": 56272214520.00001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 36627945298.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 39069777691.0,
        "delta": 2441832393.0
      },
      {
        "periodo": 202509,
        "valor": 38852059603.0,
        "delta": -217718088.0
      },
      {
        "periodo": 202510,
        "valor": 37915140854.0,
        "delta": -936918749.0
      },
      {
        "periodo": 202511,
        "valor": 38718084664.0,
        "delta": 802943810.0
      },
      {
        "periodo": 202512,
        "valor": 41496456170.0,
        "delta": 2778371506.0
      },
      {
        "periodo": 202601,
        "valor": 50001059666.0,
        "delta": 8504603496.0
      },
      {
        "periodo": 202602,
        "valor": 54643386842.0,
        "delta": 4642327176.0
      },
      {
        "periodo": 202603,
        "valor": 53742382888.0,
        "delta": -901003954.0
      },
      {
        "periodo": 202604,
        "valor": 56534744971.0,
        "delta": 2792362083.0
      },
      {
        "periodo": 202605,
        "valor": 59518144914.0,
        "delta": 2983399943.0
      },
      {
        "periodo": 202606,
        "valor": 56272214520.0,
        "delta": -3245930394.0
      },
      {
        "periodo": 202607,
        "valor": 55973699658.0,
        "delta": -298514862.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 295217561086.53,
    "valor_anterior": 257625285376.55,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 235392564717.46,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 251623627941.39,
        "delta": 16231063223.93
      },
      {
        "periodo": 202509,
        "valor": 223945361679.98,
        "delta": -27678266261.41
      },
      {
        "periodo": 202510,
        "valor": 239882981452.94,
        "delta": 15937619772.96
      },
      {
        "periodo": 202511,
        "valor": 254121740283.3,
        "delta": 14238758830.36
      },
      {
        "periodo": 202512,
        "valor": 251948575095.37,
        "delta": -2173165187.93
      },
      {
        "periodo": 202601,
        "valor": 253234400448.56,
        "delta": 1285825353.19
      },
      {
        "periodo": 202602,
        "valor": 264913343277.94,
        "delta": 11678942829.38
      },
      {
        "periodo": 202603,
        "valor": 265244599575.28,
        "delta": 331256297.34
      },
      {
        "periodo": 202604,
        "valor": 252882210408.38,
        "delta": -12362389166.9
      },
      {
        "periodo": 202605,
        "valor": 267055326449.76,
        "delta": 14173116041.38
      },
      {
        "periodo": 202606,
        "valor": 257625285376.55,
        "delta": -9430041073.21
      },
      {
        "periodo": 202607,
        "valor": 295217561086.53,
        "delta": 37592275709.98
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 1959296092.0,
    "valor_anterior": 1948482038.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1919965536.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1933787327.0,
        "delta": 13821791.0
      },
      {
        "periodo": 202509,
        "valor": 1946061469.0,
        "delta": 12274142.0
      },
      {
        "periodo": 202510,
        "valor": 1866424325.0,
        "delta": -79637144.0
      },
      {
        "periodo": 202511,
        "valor": 1886180139.0,
        "delta": 19755814.0
      },
      {
        "periodo": 202512,
        "valor": 1897885874.0,
        "delta": 11705735.0
      },
      {
        "periodo": 202601,
        "valor": 1909984683.0,
        "delta": 12098809.0
      },
      {
        "periodo": 202602,
        "valor": 1913062496.0,
        "delta": 3077813.0
      },
      {
        "periodo": 202603,
        "valor": 1924883278.0,
        "delta": 11820782.0
      },
      {
        "periodo": 202604,
        "valor": 1926875042.0,
        "delta": 1991764.0
      },
      {
        "periodo": 202605,
        "valor": 1938008879.0,
        "delta": 11133837.0
      },
      {
        "periodo": 202606,
        "valor": 1948482038.0,
        "delta": 10473159.0
      },
      {
        "periodo": 202607,
        "valor": 1959296092.0,
        "delta": 10814054.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 86050488033.25,
    "valor_anterior": 86463570409.72,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 107881586919.24,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 106765339094.6,
        "delta": -1116247824.64
      },
      {
        "periodo": 202509,
        "valor": 104454189130.28,
        "delta": -2311149964.32
      },
      {
        "periodo": 202510,
        "valor": 96484039159.94,
        "delta": -7970149970.34
      },
      {
        "periodo": 202511,
        "valor": 105245951928.99,
        "delta": 8761912769.05
      },
      {
        "periodo": 202512,
        "valor": 98464926571.67,
        "delta": -6781025357.32
      },
      {
        "periodo": 202601,
        "valor": 96951833325.55,
        "delta": -1513093246.12
      },
      {
        "periodo": 202602,
        "valor": 88912913677.38,
        "delta": -8038919648.17
      },
      {
        "periodo": 202603,
        "valor": 92133901852.92,
        "delta": 3220988175.54
      },
      {
        "periodo": 202604,
        "valor": 84417661936.52,
        "delta": -7716239916.4
      },
      {
        "periodo": 202605,
        "valor": 82171337231.17,
        "delta": -2246324705.35
      },
      {
        "periodo": 202606,
        "valor": 86463570409.72,
        "delta": 4292233178.55
      },
      {
        "periodo": 202607,
        "valor": 86050488033.25,
        "delta": -413082376.47
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 31211765079.0,
    "valor_anterior": 31132664129.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5492702735.23,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5959034775.95,
        "delta": 466332040.72
      },
      {
        "periodo": 202509,
        "valor": 11067334504.0,
        "delta": 5108299728.05
      },
      {
        "periodo": 202510,
        "valor": 9512637242.0,
        "delta": -1554697262.0
      },
      {
        "periodo": 202511,
        "valor": 10106654196.0,
        "delta": 594016954.0
      },
      {
        "periodo": 202512,
        "valor": 9922001600.0,
        "delta": -184652596.0
      },
      {
        "periodo": 202601,
        "valor": 10638777473.0,
        "delta": 716775873.0
      },
      {
        "periodo": 202602,
        "valor": 10144671109.0,
        "delta": -494106364.0
      },
      {
        "periodo": 202603,
        "valor": 9490092586.0,
        "delta": -654578523.0
      },
      {
        "periodo": 202604,
        "valor": 9019163067.0,
        "delta": -470929519.0
      },
      {
        "periodo": 202605,
        "valor": 9366696226.0,
        "delta": 347533159.0
      },
      {
        "periodo": 202606,
        "valor": 31132664129.0,
        "delta": 21765967903.0
      },
      {
        "periodo": 202607,
        "valor": 31211765079.0,
        "delta": 79100950.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 14821743081.0,
    "valor_anterior": 17886843349.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16439942554.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19982312069.0,
        "delta": 3542369515.0
      },
      {
        "periodo": 202509,
        "valor": 19822937460.0,
        "delta": -159374609.0
      },
      {
        "periodo": 202510,
        "valor": 13812586862.0,
        "delta": -6010350598.0
      },
      {
        "periodo": 202511,
        "valor": 15159912151.0,
        "delta": 1347325289.0
      },
      {
        "periodo": 202512,
        "valor": 12417166006.0,
        "delta": -2742746145.0
      },
      {
        "periodo": 202601,
        "valor": 12948199299.0,
        "delta": 531033293.0
      },
      {
        "periodo": 202602,
        "valor": 15472967329.0,
        "delta": 2524768030.0
      },
      {
        "periodo": 202603,
        "valor": 8182504070.0,
        "delta": -7290463259.0
      },
      {
        "periodo": 202604,
        "valor": 16603053272.0,
        "delta": 8420549202.0
      },
      {
        "periodo": 202605,
        "valor": 18438687580.0,
        "delta": 1835634308.0
      },
      {
        "periodo": 202606,
        "valor": 17886843349.0,
        "delta": -551844231.0
      },
      {
        "periodo": 202607,
        "valor": 14821743081.0,
        "delta": -3065100268.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 35644877501.0,
    "valor_anterior": 36753502607.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 54959332766.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 58187559308.0,
        "delta": 3228226542.0
      },
      {
        "periodo": 202509,
        "valor": 61164470976.0,
        "delta": 2976911668.0
      },
      {
        "periodo": 202510,
        "valor": 55717188614.0,
        "delta": -5447282362.0
      },
      {
        "periodo": 202511,
        "valor": 52722179215.0,
        "delta": -2995009399.0
      },
      {
        "periodo": 202512,
        "valor": 45387388807.0,
        "delta": -7334790408.0
      },
      {
        "periodo": 202601,
        "valor": 47222508160.0,
        "delta": 1835119353.0
      },
      {
        "periodo": 202602,
        "valor": 49256821049.0,
        "delta": 2034312889.0
      },
      {
        "periodo": 202603,
        "valor": 51552410832.0,
        "delta": 2295589783.0
      },
      {
        "periodo": 202604,
        "valor": 44916984805.0,
        "delta": -6635426027.0
      },
      {
        "periodo": 202605,
        "valor": 44724055525.0,
        "delta": -192929280.0
      },
      {
        "periodo": 202606,
        "valor": 36753502607.0,
        "delta": -7970552918.0
      },
      {
        "periodo": 202607,
        "valor": 35644877501.0,
        "delta": -1108625106.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 12825016449.999998,
    "valor_anterior": 13029400204.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12322364928.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12303231872.0,
        "delta": -19133056.0
      },
      {
        "periodo": 202509,
        "valor": 12983966165.0,
        "delta": 680734293.0
      },
      {
        "periodo": 202510,
        "valor": 12999178014.0,
        "delta": 15211849.0
      },
      {
        "periodo": 202511,
        "valor": 11354831525.0,
        "delta": -1644346489.0
      },
      {
        "periodo": 202512,
        "valor": 14348900805.0,
        "delta": 2994069280.0
      },
      {
        "periodo": 202601,
        "valor": 10792876476.0,
        "delta": -3556024329.0
      },
      {
        "periodo": 202602,
        "valor": 9544245268.0,
        "delta": -1248631208.0
      },
      {
        "periodo": 202603,
        "valor": 11566693001.0,
        "delta": 2022447733.0
      },
      {
        "periodo": 202604,
        "valor": 10352526817.0,
        "delta": -1214166184.0
      },
      {
        "periodo": 202605,
        "valor": 13374708375.0,
        "delta": 3022181558.0
      },
      {
        "periodo": 202606,
        "valor": 13029400204.0,
        "delta": -345308171.0
      },
      {
        "periodo": 202607,
        "valor": 12825016450.0,
        "delta": -204383754.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 2823860985.0,
    "valor_anterior": 2841128764.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21735400297.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10838547923.0,
        "delta": -10896852374.0
      },
      {
        "periodo": 202509,
        "valor": 5072715865.0,
        "delta": -5765832058.0
      },
      {
        "periodo": 202510,
        "valor": 6429308065.0,
        "delta": 1356592200.0
      },
      {
        "periodo": 202511,
        "valor": 7639161657.0,
        "delta": 1209853592.0
      },
      {
        "periodo": 202512,
        "valor": 7941257073.0,
        "delta": 302095416.0
      },
      {
        "periodo": 202601,
        "valor": 5842792804.0,
        "delta": -2098464269.0
      },
      {
        "periodo": 202602,
        "valor": 8354432340.0,
        "delta": 2511639536.0
      },
      {
        "periodo": 202603,
        "valor": 2807349002.0,
        "delta": -5547083338.0
      },
      {
        "periodo": 202604,
        "valor": 2869576995.0,
        "delta": 62227993.0
      },
      {
        "periodo": 202605,
        "valor": 2873974045.0,
        "delta": 4397050.0
      },
      {
        "periodo": 202606,
        "valor": 2841128764.0,
        "delta": -32845281.0
      },
      {
        "periodo": 202607,
        "valor": 2823860985.0,
        "delta": -17267779.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 64130596000.04,
    "valor_anterior": 63302673505.83,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 76943109720.68,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 73260630718.41,
        "delta": -3682479002.27
      },
      {
        "periodo": 202509,
        "valor": 68932023249.71,
        "delta": -4328607468.7
      },
      {
        "periodo": 202510,
        "valor": 71087492857.01,
        "delta": 2155469607.3
      },
      {
        "periodo": 202511,
        "valor": 72366572882.54,
        "delta": 1279080025.53
      },
      {
        "periodo": 202512,
        "valor": 70247144441.27,
        "delta": -2119428441.27
      },
      {
        "periodo": 202601,
        "valor": 69642360287.51,
        "delta": -604784153.76
      },
      {
        "periodo": 202602,
        "valor": 69075952823.34,
        "delta": -566407464.17
      },
      {
        "periodo": 202603,
        "valor": 65985185445.9,
        "delta": -3090767377.44
      },
      {
        "periodo": 202604,
        "valor": 65502930267.4,
        "delta": -482255178.5
      },
      {
        "periodo": 202605,
        "valor": 66331517067.61,
        "delta": 828586800.21
      },
      {
        "periodo": 202606,
        "valor": 63302673505.83,
        "delta": -3028843561.78
      },
      {
        "periodo": 202607,
        "valor": 64130596000.04,
        "delta": 827922494.21
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 2682273600.0,
    "valor_anterior": 2663231815.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3908003079.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4055465913.0,
        "delta": 147462834.0
      },
      {
        "periodo": 202509,
        "valor": 4096551505.0,
        "delta": 41085592.0
      },
      {
        "periodo": 202510,
        "valor": 3973343588.0,
        "delta": -123207917.0
      },
      {
        "periodo": 202511,
        "valor": 3683971311.0,
        "delta": -289372277.0
      },
      {
        "periodo": 202512,
        "valor": 3605967077.0,
        "delta": -78004234.0
      },
      {
        "periodo": 202601,
        "valor": 3632195121.0,
        "delta": 26228044.0
      },
      {
        "periodo": 202602,
        "valor": 3730203774.0,
        "delta": 98008653.0
      },
      {
        "periodo": 202603,
        "valor": 3524762880.0,
        "delta": -205440894.0
      },
      {
        "periodo": 202604,
        "valor": 3106893658.0,
        "delta": -417869222.0
      },
      {
        "periodo": 202605,
        "valor": 2938258569.0,
        "delta": -168635089.0
      },
      {
        "periodo": 202606,
        "valor": 2663231815.0,
        "delta": -275026754.0
      },
      {
        "periodo": 202607,
        "valor": 2682273600.0,
        "delta": 19041785.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 66557296153.0,
    "valor_anterior": 70310183076.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 61534442274.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 60626776963.0,
        "delta": -907665311.0
      },
      {
        "periodo": 202509,
        "valor": 57716552484.0,
        "delta": -2910224479.0
      },
      {
        "periodo": 202510,
        "valor": 58226515473.0,
        "delta": 509962989.0
      },
      {
        "periodo": 202511,
        "valor": 60704505988.0,
        "delta": 2477990515.0
      },
      {
        "periodo": 202512,
        "valor": 53193790817.0,
        "delta": -7510715171.0
      },
      {
        "periodo": 202601,
        "valor": 60877373737.0,
        "delta": 7683582920.0
      },
      {
        "periodo": 202602,
        "valor": 66040516392.0,
        "delta": 5163142655.0
      },
      {
        "periodo": 202603,
        "valor": 66301921576.0,
        "delta": 261405184.0
      },
      {
        "periodo": 202604,
        "valor": 62961172539.0,
        "delta": -3340749037.0
      },
      {
        "periodo": 202605,
        "valor": 66124665679.0,
        "delta": 3163493140.0
      },
      {
        "periodo": 202606,
        "valor": 70310183076.0,
        "delta": 4185517397.0
      },
      {
        "periodo": 202607,
        "valor": 66557296153.0,
        "delta": -3752886923.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 922235465.0,
    "valor_anterior": 655697376.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1480466384.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 615558039.0,
        "delta": -864908345.0
      },
      {
        "periodo": 202509,
        "valor": 797013260.0,
        "delta": 181455221.0
      },
      {
        "periodo": 202510,
        "valor": 997888067.0,
        "delta": 200874807.0
      },
      {
        "periodo": 202511,
        "valor": 998410026.0,
        "delta": 521959.0
      },
      {
        "periodo": 202512,
        "valor": 1415215116.0,
        "delta": 416805090.0
      },
      {
        "periodo": 202601,
        "valor": 1237558217.0,
        "delta": -177656899.0
      },
      {
        "periodo": 202602,
        "valor": 597112128.0,
        "delta": -640446089.0
      },
      {
        "periodo": 202603,
        "valor": 597431128.0,
        "delta": 319000.0
      },
      {
        "periodo": 202604,
        "valor": 997824445.0,
        "delta": 400393317.0
      },
      {
        "periodo": 202605,
        "valor": 960648920.0,
        "delta": -37175525.0
      },
      {
        "periodo": 202606,
        "valor": 655697376.0,
        "delta": -304951544.0
      },
      {
        "periodo": 202607,
        "valor": 922235465.0,
        "delta": 266538089.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 47507747254.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 46196813992.0,
        "delta": -1310933262.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 171770013100.0,
    "valor_anterior": 169411761213.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 115015018186.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 119405514186.0,
        "delta": 4390496000.0
      },
      {
        "periodo": 202509,
        "valor": 133687984359.0,
        "delta": 14282470173.0
      },
      {
        "periodo": 202510,
        "valor": 136044300586.0,
        "delta": 2356316227.0
      },
      {
        "periodo": 202511,
        "valor": 139119025101.0,
        "delta": 3074724515.0
      },
      {
        "periodo": 202512,
        "valor": 152806140202.0,
        "delta": 13687115101.0
      },
      {
        "periodo": 202601,
        "valor": 150620948452.0,
        "delta": -2185191750.0
      },
      {
        "periodo": 202602,
        "valor": 154191195108.0,
        "delta": 3570246656.0
      },
      {
        "periodo": 202603,
        "valor": 152668131626.0,
        "delta": -1523063482.0
      },
      {
        "periodo": 202604,
        "valor": 150960977624.0,
        "delta": -1707154002.0
      },
      {
        "periodo": 202605,
        "valor": 149103723050.0,
        "delta": -1857254574.0
      },
      {
        "periodo": 202606,
        "valor": 169411761213.0,
        "delta": 20308038163.0
      },
      {
        "periodo": 202607,
        "valor": 171770013100.0,
        "delta": 2358251887.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 9901715.0,
    "valor_anterior": 9847450.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 49566869.0,
        "delta": 49566869.0
      },
      {
        "periodo": 202602,
        "valor": 93761902.0,
        "delta": 44195033.0
      },
      {
        "periodo": 202603,
        "valor": 434819330.0,
        "delta": 341057428.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": -434819330.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 9847450.0,
        "delta": 9847450.0
      },
      {
        "periodo": 202607,
        "valor": 9901715.0,
        "delta": 54265.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 210686110.52,
    "valor_anterior": 210556289.55,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 210492262.1,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 210643067.64,
        "delta": 150805.54
      },
      {
        "periodo": 202509,
        "valor": 210754975.45,
        "delta": 111907.81
      },
      {
        "periodo": 202510,
        "valor": 209994720.85,
        "delta": -760254.6
      },
      {
        "periodo": 202511,
        "valor": 210091997.07,
        "delta": 97276.22
      },
      {
        "periodo": 202512,
        "valor": 209948627.32,
        "delta": -143369.75
      },
      {
        "periodo": 202601,
        "valor": 210079480.62,
        "delta": 130853.3
      },
      {
        "periodo": 202602,
        "valor": 210095289.08,
        "delta": 15808.46
      },
      {
        "periodo": 202603,
        "valor": 210265085.3,
        "delta": 169796.22
      },
      {
        "periodo": 202604,
        "valor": 210355754.68,
        "delta": 90669.38
      },
      {
        "periodo": 202605,
        "valor": 210468004.84,
        "delta": 112250.16
      },
      {
        "periodo": 202606,
        "valor": 210556289.55,
        "delta": 88284.71
      },
      {
        "periodo": 202607,
        "valor": 210686110.52,
        "delta": 129820.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 1599914869.0,
    "valor_anterior": 1000273664.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 195902851.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 176940153.0,
        "delta": -18962698.0
      },
      {
        "periodo": 202509,
        "valor": 76961840.0,
        "delta": -99978313.0
      },
      {
        "periodo": 202510,
        "valor": 227386771.0,
        "delta": 150424931.0
      },
      {
        "periodo": 202511,
        "valor": 224213964.0,
        "delta": -3172807.0
      },
      {
        "periodo": 202512,
        "valor": 228067458.0,
        "delta": 3853494.0
      },
      {
        "periodo": 202601,
        "valor": 678944413.0,
        "delta": 450876955.0
      },
      {
        "periodo": 202602,
        "valor": 679199128.0,
        "delta": 254715.0
      },
      {
        "periodo": 202603,
        "valor": 1072602401.0,
        "delta": 393403273.0
      },
      {
        "periodo": 202604,
        "valor": 1572212018.0,
        "delta": 499609617.0
      },
      {
        "periodo": 202605,
        "valor": 1029396983.0,
        "delta": -542815035.0
      },
      {
        "periodo": 202606,
        "valor": 1000273664.0,
        "delta": -29123319.0
      },
      {
        "periodo": 202607,
        "valor": 1599914869.0,
        "delta": 599641205.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 2524568790.34,
    "valor_anterior": 2524384591.62,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1832618103.97,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2363789656.45,
        "delta": 531171552.48
      },
      {
        "periodo": 202509,
        "valor": 2386244382.97,
        "delta": 22454726.52
      },
      {
        "periodo": 202510,
        "valor": 2466859658.6,
        "delta": 80615275.63
      },
      {
        "periodo": 202511,
        "valor": 2460482433.74,
        "delta": -6377224.86
      },
      {
        "periodo": 202512,
        "valor": 2448752434.07,
        "delta": -11729999.67
      },
      {
        "periodo": 202601,
        "valor": 2394795893.75,
        "delta": -53956540.32
      },
      {
        "periodo": 202602,
        "valor": 2413732342.73,
        "delta": 18936448.98
      },
      {
        "periodo": 202603,
        "valor": 2414967429.16,
        "delta": 1235086.43
      },
      {
        "periodo": 202604,
        "valor": 2399205700.33,
        "delta": -15761728.83
      },
      {
        "periodo": 202605,
        "valor": 2495135811.3,
        "delta": 95930110.97
      },
      {
        "periodo": 202606,
        "valor": 2524384591.62,
        "delta": 29248780.32
      },
      {
        "periodo": 202607,
        "valor": 2524568790.34,
        "delta": 184198.72
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 361698468.1,
    "valor_anterior": 410367313.08,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 195003372.12,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 291189126.62,
        "delta": 96185754.5
      },
      {
        "periodo": 202509,
        "valor": 287007088.73,
        "delta": -4182037.89
      },
      {
        "periodo": 202510,
        "valor": 251577539.18,
        "delta": -35429549.55
      },
      {
        "periodo": 202511,
        "valor": 239157049.48,
        "delta": -12420489.7
      },
      {
        "periodo": 202512,
        "valor": 311391079.89,
        "delta": 72234030.41
      },
      {
        "periodo": 202601,
        "valor": 318511367.7,
        "delta": 7120287.81
      },
      {
        "periodo": 202602,
        "valor": 315536745.67,
        "delta": -2974622.03
      },
      {
        "periodo": 202603,
        "valor": 349798697.89,
        "delta": 34261952.22
      },
      {
        "periodo": 202604,
        "valor": 425337315.2,
        "delta": 75538617.31
      },
      {
        "periodo": 202605,
        "valor": 426800661.69,
        "delta": 1463346.49
      },
      {
        "periodo": 202606,
        "valor": 410367313.08,
        "delta": -16433348.61
      },
      {
        "periodo": 202607,
        "valor": 361698468.1,
        "delta": -48668844.98
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 292806290.0,
    "valor_anterior": 291089200.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 148856700.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 149805135.0,
        "delta": 948435.0
      },
      {
        "periodo": 202509,
        "valor": 98663930.0,
        "delta": -51141205.0
      },
      {
        "periodo": 202510,
        "valor": 99320870.0,
        "delta": 656940.0
      },
      {
        "periodo": 202511,
        "valor": 99877150.0,
        "delta": 556280.0
      },
      {
        "periodo": 202512,
        "valor": 195791670.0,
        "delta": 95914520.0
      },
      {
        "periodo": 202601,
        "valor": 197034110.0,
        "delta": 1242440.0
      },
      {
        "periodo": 202602,
        "valor": 198154240.0,
        "delta": 1120130.0
      },
      {
        "periodo": 202603,
        "valor": 197569810.0,
        "delta": -584430.0
      },
      {
        "periodo": 202604,
        "valor": 198715780.0,
        "delta": 1145970.0
      },
      {
        "periodo": 202605,
        "valor": 99765830.0,
        "delta": -98949950.0
      },
      {
        "periodo": 202606,
        "valor": 291089200.0,
        "delta": 191323370.0
      },
      {
        "periodo": 202607,
        "valor": 292806290.0,
        "delta": 1717090.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 11837915988.0,
    "valor_anterior": 8325981088.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19187912936.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18477710819.0,
        "delta": -710202117.0
      },
      {
        "periodo": 202509,
        "valor": 18276336085.0,
        "delta": -201374734.0
      },
      {
        "periodo": 202510,
        "valor": 23009523801.0,
        "delta": 4733187716.0
      },
      {
        "periodo": 202511,
        "valor": 17782115029.0,
        "delta": -5227408772.0
      },
      {
        "periodo": 202512,
        "valor": 18193150980.0,
        "delta": 411035951.0
      },
      {
        "periodo": 202601,
        "valor": 16303890934.0,
        "delta": -1889260046.0
      },
      {
        "periodo": 202602,
        "valor": 15452668467.0,
        "delta": -851222467.0
      },
      {
        "periodo": 202603,
        "valor": 11986875479.0,
        "delta": -3465792988.0
      },
      {
        "periodo": 202604,
        "valor": 13820550617.0,
        "delta": 1833675138.0
      },
      {
        "periodo": 202605,
        "valor": 13509231695.0,
        "delta": -311318922.0
      },
      {
        "periodo": 202606,
        "valor": 8325981088.0,
        "delta": -5183250607.0
      },
      {
        "periodo": 202607,
        "valor": 11837915988.0,
        "delta": 3511934900.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 1790983499.0,
    "valor_anterior": 1882233354.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1700809414.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1790103172.0,
        "delta": 89293758.0
      },
      {
        "periodo": 202509,
        "valor": 1728752697.0,
        "delta": -61350475.0
      },
      {
        "periodo": 202510,
        "valor": 1794182946.0,
        "delta": 65430249.0
      },
      {
        "periodo": 202511,
        "valor": 1807652427.0,
        "delta": 13469481.0
      },
      {
        "periodo": 202512,
        "valor": 1790582059.0,
        "delta": -17070368.0
      },
      {
        "periodo": 202601,
        "valor": 1805193035.0,
        "delta": 14610976.0
      },
      {
        "periodo": 202602,
        "valor": 1818599387.0,
        "delta": 13406352.0
      },
      {
        "periodo": 202603,
        "valor": 1909513946.0,
        "delta": 90914559.0
      },
      {
        "periodo": 202604,
        "valor": 1855416180.0,
        "delta": -54097766.0
      },
      {
        "periodo": 202605,
        "valor": 1972926033.0,
        "delta": 117509853.0
      },
      {
        "periodo": 202606,
        "valor": 1882233354.0,
        "delta": -90692679.0
      },
      {
        "periodo": 202607,
        "valor": 1790983499.0,
        "delta": -91249855.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 1288744350.0,
        "delta": 1288744350.0
      },
      {
        "periodo": 202601,
        "valor": 669862970.49,
        "delta": -618881379.51
      },
      {
        "periodo": 202602,
        "valor": 352152564.73,
        "delta": -317710405.76
      },
      {
        "periodo": 202603,
        "valor": 354378118.78,
        "delta": 2225554.05
      },
      {
        "periodo": 202604,
        "valor": 297686970.0,
        "delta": -56691148.78
      },
      {
        "periodo": 202605,
        "valor": 299405339.99,
        "delta": 1718369.99
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": -299405339.99
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 658142740.0,
    "valor_anterior": 525332355.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 930820284.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 937358905.0,
        "delta": 6538621.0
      },
      {
        "periodo": 202509,
        "valor": 943686602.0,
        "delta": 6327697.0
      },
      {
        "periodo": 202510,
        "valor": 950225223.0,
        "delta": 6538621.0
      },
      {
        "periodo": 202511,
        "valor": 956552922.0,
        "delta": 6327699.0
      },
      {
        "periodo": 202512,
        "valor": 963091542.0,
        "delta": 6538620.0
      },
      {
        "periodo": 202601,
        "valor": 969630163.0,
        "delta": 6538621.0
      },
      {
        "periodo": 202602,
        "valor": 975536014.0,
        "delta": 5905851.0
      },
      {
        "periodo": 202603,
        "valor": 982074636.0,
        "delta": 6538622.0
      },
      {
        "periodo": 202604,
        "valor": 988402334.0,
        "delta": 6327698.0
      },
      {
        "periodo": 202605,
        "valor": 520008821.0,
        "delta": -468393513.0
      },
      {
        "periodo": 202606,
        "valor": 525332355.0,
        "delta": 5323534.0
      },
      {
        "periodo": 202607,
        "valor": 658142740.0,
        "delta": 132810385.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 2226913866.0,
    "valor_anterior": 2182178296.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1847487321.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1819541918.0,
        "delta": -27945403.0
      },
      {
        "periodo": 202509,
        "valor": 1790761848.0,
        "delta": -28780070.0
      },
      {
        "periodo": 202510,
        "valor": 1884486828.0,
        "delta": 93724980.0
      },
      {
        "periodo": 202511,
        "valor": 2156758309.0,
        "delta": 272271481.0
      },
      {
        "periodo": 202512,
        "valor": 2107743474.0,
        "delta": -49014835.0
      },
      {
        "periodo": 202601,
        "valor": 2058226763.0,
        "delta": -49516711.0
      },
      {
        "periodo": 202602,
        "valor": 2166407139.0,
        "delta": 108180376.0
      },
      {
        "periodo": 202603,
        "valor": 2207515739.0,
        "delta": 41108600.0
      },
      {
        "periodo": 202604,
        "valor": 2461567195.0,
        "delta": 254051456.0
      },
      {
        "periodo": 202605,
        "valor": 2141155422.0,
        "delta": -320411773.0
      },
      {
        "periodo": 202606,
        "valor": 2182178296.0,
        "delta": 41022874.0
      },
      {
        "periodo": 202607,
        "valor": 2226913866.0,
        "delta": 44735570.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 5094062610.0,
    "valor_anterior": 6997607904.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6344031867.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5580617132.0,
        "delta": -763414735.0
      },
      {
        "periodo": 202509,
        "valor": 5927567944.0,
        "delta": 346950812.0
      },
      {
        "periodo": 202510,
        "valor": 5892524550.0,
        "delta": -35043394.0
      },
      {
        "periodo": 202511,
        "valor": 7025884783.0,
        "delta": 1133360233.0
      },
      {
        "periodo": 202512,
        "valor": 6255858751.0,
        "delta": -770026032.0
      },
      {
        "periodo": 202601,
        "valor": 5449699009.0,
        "delta": -806159742.0
      },
      {
        "periodo": 202602,
        "valor": 8399860788.0,
        "delta": 2950161779.0
      },
      {
        "periodo": 202603,
        "valor": 7782519330.0,
        "delta": -617341458.0
      },
      {
        "periodo": 202604,
        "valor": 7107947731.0,
        "delta": -674571599.0
      },
      {
        "periodo": 202605,
        "valor": 8759039679.0,
        "delta": 1651091948.0
      },
      {
        "periodo": 202606,
        "valor": 6997607905.0,
        "delta": -1761431774.0
      },
      {
        "periodo": 202607,
        "valor": 5094062610.0,
        "delta": -1903545295.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 8911640689.0,
    "valor_anterior": 8875895796.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2973069738.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4559517863.0,
        "delta": 1586448125.0
      },
      {
        "periodo": 202509,
        "valor": 6100356075.0,
        "delta": 1540838212.0
      },
      {
        "periodo": 202510,
        "valor": 6323569806.0,
        "delta": 223213731.0
      },
      {
        "periodo": 202511,
        "valor": 6532719659.0,
        "delta": 209149853.0
      },
      {
        "periodo": 202512,
        "valor": 7001042129.0,
        "delta": 468322470.0
      },
      {
        "periodo": 202601,
        "valor": 7471976814.0,
        "delta": 470934685.0
      },
      {
        "periodo": 202602,
        "valor": 7763756570.0,
        "delta": 291779756.0
      },
      {
        "periodo": 202603,
        "valor": 8569536518.0,
        "delta": 805779948.0
      },
      {
        "periodo": 202604,
        "valor": 8826157907.0,
        "delta": 256621389.0
      },
      {
        "periodo": 202605,
        "valor": 8880077591.0,
        "delta": 53919684.0
      },
      {
        "periodo": 202606,
        "valor": 8875895796.0,
        "delta": -4181795.0
      },
      {
        "periodo": 202607,
        "valor": 8911640689.0,
        "delta": 35744893.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 5106519918.02,
    "valor_anterior": 7223065023.590001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 58920203.53,
        "delta": 58920203.53
      },
      {
        "periodo": 202601,
        "valor": 59284764.0,
        "delta": 364560.47
      },
      {
        "periodo": 202602,
        "valor": 1605678514.6,
        "delta": 1546393750.6
      },
      {
        "periodo": 202603,
        "valor": 3454986975.6,
        "delta": 1849308461.0
      },
      {
        "periodo": 202604,
        "valor": 3494054293.84,
        "delta": 39067318.24
      },
      {
        "periodo": 202605,
        "valor": 4752488296.11,
        "delta": 1258434002.27
      },
      {
        "periodo": 202606,
        "valor": 7223065023.59,
        "delta": 2470576727.48
      },
      {
        "periodo": 202607,
        "valor": 5106519918.02,
        "delta": -2116545105.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 988895800.0,
    "valor_anterior": 983510600.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 983510600.0,
        "delta": 983510600.0
      },
      {
        "periodo": 202607,
        "valor": 988895800.0,
        "delta": 5385200.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 4302129564159.11,
    "valor_anterior": 4236947054138.87,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4053496741860.07,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4023367467666.18,
        "delta": -30129274193.8896
      },
      {
        "periodo": 202509,
        "valor": 3996548323435.99,
        "delta": -26819144230.1899
      },
      {
        "periodo": 202510,
        "valor": 4038848020161.75,
        "delta": 42299696725.7598
      },
      {
        "periodo": 202511,
        "valor": 4116999038240.01,
        "delta": 78151018078.2598
      },
      {
        "periodo": 202512,
        "valor": 4142661361270.73,
        "delta": 25662323030.7202
      },
      {
        "periodo": 202601,
        "valor": 4117252368162.61,
        "delta": -25408993108.1201
      },
      {
        "periodo": 202602,
        "valor": 4144187690914.64,
        "delta": 26935322752.0303
      },
      {
        "periodo": 202603,
        "valor": 4142295093527.63,
        "delta": -1892597387.0103
      },
      {
        "periodo": 202604,
        "valor": 4071054169150.73,
        "delta": -71240924376.8999
      },
      {
        "periodo": 202605,
        "valor": 4218090634729.14,
        "delta": 147036465578.4102
      },
      {
        "periodo": 202606,
        "valor": 4236947054138.87,
        "delta": 18856419409.73
      },
      {
        "periodo": 202607,
        "valor": 4302129564159.11,
        "delta": 65182510020.2397
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 2724526338859.74,
    "valor_anterior": 2722566596029.9497,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2507389854904.24,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2472730770795.54,
        "delta": -34659084108.7002
      },
      {
        "periodo": 202509,
        "valor": 2518901163075.07,
        "delta": 46170392279.5298
      },
      {
        "periodo": 202510,
        "valor": 2571779801864.39,
        "delta": 52878638789.3203
      },
      {
        "periodo": 202511,
        "valor": 2610378315593.82,
        "delta": 38598513729.4297
      },
      {
        "periodo": 202512,
        "valor": 2663080076067.77,
        "delta": 52701760473.9502
      },
      {
        "periodo": 202601,
        "valor": 2620103249059.27,
        "delta": -42976827008.5
      },
      {
        "periodo": 202602,
        "valor": 2631292853460.66,
        "delta": 11189604401.3901
      },
      {
        "periodo": 202603,
        "valor": 2668604568290.6,
        "delta": 37311714829.9399
      },
      {
        "periodo": 202604,
        "valor": 2625944447595.06,
        "delta": -42660120695.54
      },
      {
        "periodo": 202605,
        "valor": 2737010514204.79,
        "delta": 111066066609.73
      },
      {
        "periodo": 202606,
        "valor": 2722566596029.9497,
        "delta": -14443918174.8403
      },
      {
        "periodo": 202607,
        "valor": 2724526338859.74,
        "delta": 1959742829.7905
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 301654089728.79,
    "valor_anterior": 296102617012.95,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 328932505006.09,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 318924865730.57,
        "delta": -10007639275.52
      },
      {
        "periodo": 202509,
        "valor": 276238521172.85,
        "delta": -42686344557.72
      },
      {
        "periodo": 202510,
        "valor": 262800109700.91,
        "delta": -13438411471.94
      },
      {
        "periodo": 202511,
        "valor": 266553873297.31,
        "delta": 3753763596.4
      },
      {
        "periodo": 202512,
        "valor": 275061256542.15,
        "delta": 8507383244.84
      },
      {
        "periodo": 202601,
        "valor": 260150272264.0,
        "delta": -14910984278.15
      },
      {
        "periodo": 202602,
        "valor": 267063213194.24,
        "delta": 6912940930.24
      },
      {
        "periodo": 202603,
        "valor": 248333836973.32,
        "delta": -18729376220.92
      },
      {
        "periodo": 202604,
        "valor": 247693436537.74,
        "delta": -640400435.58
      },
      {
        "periodo": 202605,
        "valor": 263196245856.23,
        "delta": 15502809318.49
      },
      {
        "periodo": 202606,
        "valor": 296102617012.95,
        "delta": 32906371156.72
      },
      {
        "periodo": 202607,
        "valor": 301654089728.79,
        "delta": 5551472715.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 765098784045.53,
    "valor_anterior": 714554110065.55,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 732414647944.46,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 740761757122.39,
        "delta": 8347109177.9301
      },
      {
        "periodo": 202509,
        "valor": 699872780028.98,
        "delta": -40888977093.41
      },
      {
        "periodo": 202510,
        "valor": 711518359648.94,
        "delta": 11645579619.96
      },
      {
        "periodo": 202511,
        "valor": 743620614410.3,
        "delta": 32102254761.3601
      },
      {
        "periodo": 202512,
        "valor": 713466102066.37,
        "delta": -30154512343.9301
      },
      {
        "periodo": 202601,
        "valor": 733365599657.56,
        "delta": 19899497591.1901
      },
      {
        "periodo": 202602,
        "valor": 743640910595.94,
        "delta": 10275310938.3799
      },
      {
        "periodo": 202603,
        "valor": 717422353406.28,
        "delta": -26218557189.6599
      },
      {
        "periodo": 202604,
        "valor": 702770818554.38,
        "delta": -14651534851.9
      },
      {
        "periodo": 202605,
        "valor": 717051595334.76,
        "delta": 14280776780.38
      },
      {
        "periodo": 202606,
        "valor": 714554110065.55,
        "delta": -2497485269.21
      },
      {
        "periodo": 202607,
        "valor": 765098784045.53,
        "delta": 50544673979.98
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 261613056897.78,
    "valor_anterior": 253505590676.03,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 239705839290.94,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 247225997940.01,
        "delta": 7520158649.07
      },
      {
        "periodo": 202509,
        "valor": 257013454568.95,
        "delta": 9787456628.94
      },
      {
        "periodo": 202510,
        "valor": 256277217874.93,
        "delta": -736236694.02
      },
      {
        "periodo": 202511,
        "valor": 251336558007.76,
        "delta": -4940659867.17
      },
      {
        "periodo": 202512,
        "valor": 248705009726.69,
        "delta": -2631548281.07
      },
      {
        "periodo": 202601,
        "valor": 268398875435.16,
        "delta": 19693865708.47
      },
      {
        "periodo": 202602,
        "valor": 274536988945.27,
        "delta": 6138113510.11
      },
      {
        "periodo": 202603,
        "valor": 275483373218.88,
        "delta": 946384273.61
      },
      {
        "periodo": 202604,
        "valor": 270344932732.58,
        "delta": -5138440486.3
      },
      {
        "periodo": 202605,
        "valor": 275503886670.65,
        "delta": 5158953938.0701
      },
      {
        "periodo": 202606,
        "valor": 253505590676.03,
        "delta": -21998295994.62
      },
      {
        "periodo": 202607,
        "valor": 261613056897.78,
        "delta": 8107466221.75
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 83126918721.96,
    "valor_anterior": 82713727643.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 55775661952.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 58523030362.66,
        "delta": 2747368410.24
      },
      {
        "periodo": 202509,
        "valor": 64238822875.15,
        "delta": 5715792512.49
      },
      {
        "periodo": 202510,
        "valor": 61579541182.63,
        "delta": -2659281692.52
      },
      {
        "periodo": 202511,
        "valor": 59966022434.29,
        "delta": -1613518748.34
      },
      {
        "periodo": 202512,
        "valor": 65161668406.28,
        "delta": 5195645971.99
      },
      {
        "periodo": 202601,
        "valor": 59871358338.56,
        "delta": -5290310067.72
      },
      {
        "periodo": 202602,
        "valor": 59698311005.21,
        "delta": -173047333.35
      },
      {
        "periodo": 202603,
        "valor": 61709919718.13,
        "delta": 2011608712.92
      },
      {
        "periodo": 202604,
        "valor": 61061904881.21,
        "delta": -648014836.92
      },
      {
        "periodo": 202605,
        "valor": 62232323556.82,
        "delta": 1170418675.61
      },
      {
        "periodo": 202606,
        "valor": 82713727643.25,
        "delta": 20481404086.43
      },
      {
        "periodo": 202607,
        "valor": 83126918721.96,
        "delta": 413191078.71
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100051,
    "label": "Instr. Financieros",
    "valor_actual": 166110375905.31,
    "valor_anterior": 167504412711.14,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 189278232761.92,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 185201045715.01,
        "delta": -4077187046.91
      },
      {
        "periodo": 202509,
        "valor": 180283581714.99,
        "delta": -4917464000.02
      },
      {
        "periodo": 202510,
        "valor": 174892989889.95,
        "delta": -5390591825.04
      },
      {
        "periodo": 202511,
        "valor": 185143654496.53,
        "delta": 10250664606.58
      },
      {
        "periodo": 202512,
        "valor": 177187248461.47,
        "delta": -7956406035.06
      },
      {
        "periodo": 202601,
        "valor": 175363013408.06,
        "delta": -1824235053.41
      },
      {
        "periodo": 202602,
        "valor": 167955413713.32,
        "delta": -7407599694.74
      },
      {
        "periodo": 202603,
        "valor": 170741041920.42,
        "delta": 2785628207.1
      },
      {
        "periodo": 202604,
        "valor": 163238628849.76,
        "delta": -7502413070.66
      },
      {
        "periodo": 202605,
        "valor": 163096069105.89,
        "delta": -142559743.87
      },
      {
        "periodo": 202606,
        "valor": 167504412711.14,
        "delta": 4408343605.25
      },
      {
        "periodo": 202607,
        "valor": 166110375905.31,
        "delta": -1394036805.83
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 570581359889.18,
    "valor_anterior": 569551433172.32,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 537405927092.0601,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 535793153080.66,
        "delta": -1612774011.4001
      },
      {
        "periodo": 202509,
        "valor": 525622684893.48,
        "delta": -10170468187.18
      },
      {
        "periodo": 202510,
        "valor": 531479183198.31,
        "delta": 5856498304.83
      },
      {
        "periodo": 202511,
        "valor": 554136355519.88,
        "delta": 22657172321.57
      },
      {
        "periodo": 202512,
        "valor": 561685471008.27,
        "delta": 7549115488.39
      },
      {
        "periodo": 202601,
        "valor": 552289630182.39,
        "delta": -9395840825.88
      },
      {
        "periodo": 202602,
        "valor": 548568606833.63,
        "delta": -3721023348.76
      },
      {
        "periodo": 202603,
        "valor": 555318184360.58,
        "delta": 6749577526.95
      },
      {
        "periodo": 202604,
        "valor": 566303991674.8,
        "delta": 10985807314.2201
      },
      {
        "periodo": 202605,
        "valor": 571767647488.62,
        "delta": 5463655813.8199
      },
      {
        "periodo": 202606,
        "valor": 569551433172.32,
        "delta": -2216214316.3
      },
      {
        "periodo": 202607,
        "valor": 570581359889.18,
        "delta": 1029926716.8601
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 1699428732854.03,
    "valor_anterior": 1675546892747.49,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1543480391810.2603,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1550178243793.91,
        "delta": 6697851983.6497
      },
      {
        "periodo": 202509,
        "valor": 1584471767016.57,
        "delta": 34293523222.6602
      },
      {
        "periodo": 202510,
        "valor": 1541232767633.13,
        "delta": -43238999383.4402
      },
      {
        "periodo": 202511,
        "valor": 1615768173682.43,
        "delta": 74535406049.3
      },
      {
        "periodo": 202512,
        "valor": 1679513762263.04,
        "delta": 63745588580.6101
      },
      {
        "periodo": 202601,
        "valor": 1605364375183.37,
        "delta": -74149387079.6699
      },
      {
        "periodo": 202602,
        "valor": 1652616534620.37,
        "delta": 47252159437.0
      },
      {
        "periodo": 202603,
        "valor": 1699957224920.97,
        "delta": 47340690300.5999
      },
      {
        "periodo": 202604,
        "valor": 1686095191109.83,
        "delta": -13862033811.1399
      },
      {
        "periodo": 202605,
        "valor": 1689507355530.84,
        "delta": 3412164421.01
      },
      {
        "periodo": 202606,
        "valor": 1675546892747.49,
        "delta": -13960462783.3501
      },
      {
        "periodo": 202607,
        "valor": 1699428732854.03,
        "delta": 23881840106.54
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 647446137581.0001,
    "valor_anterior": 651356573004.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 663304681958.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 663239628823.9999,
        "delta": -65053134.0001
      },
      {
        "periodo": 202509,
        "valor": 625735692943.0,
        "delta": -37503935880.9999
      },
      {
        "periodo": 202510,
        "valor": 632133914663.0,
        "delta": 6398221720.0
      },
      {
        "periodo": 202511,
        "valor": 656611974984.0,
        "delta": 24478060321.0
      },
      {
        "periodo": 202512,
        "valor": 664566018806.0,
        "delta": 7954043822.0
      },
      {
        "periodo": 202601,
        "valor": 655645616767.9999,
        "delta": -8920402038.0001
      },
      {
        "periodo": 202602,
        "valor": 656729523316.0,
        "delta": 1083906548.0001
      },
      {
        "periodo": 202603,
        "valor": 667262166189.0,
        "delta": 10532642873.0
      },
      {
        "periodo": 202604,
        "valor": 672492532389.0,
        "delta": 5230366200.0
      },
      {
        "periodo": 202605,
        "valor": 666842182715.0,
        "delta": -5650349674.0
      },
      {
        "periodo": 202606,
        "valor": 651356573004.0,
        "delta": -15485609711.0
      },
      {
        "periodo": 202607,
        "valor": 647446137581.0001,
        "delta": -3910435422.9999
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 345339853031.0,
    "valor_anterior": 350561450219.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 379318616184.9999,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 365953098246.0,
        "delta": -13365517938.9999
      },
      {
        "periodo": 202509,
        "valor": 347764894506.0,
        "delta": -18188203740.0
      },
      {
        "periodo": 202510,
        "valor": 359728947798.0,
        "delta": 11964053292.0
      },
      {
        "periodo": 202511,
        "valor": 374701643735.0,
        "delta": 14972695937.0
      },
      {
        "periodo": 202512,
        "valor": 386229775406.0,
        "delta": 11528131671.0
      },
      {
        "periodo": 202601,
        "valor": 371207369995.0,
        "delta": -15022405411.0
      },
      {
        "periodo": 202602,
        "valor": 358102610652.0,
        "delta": -13104759343.0
      },
      {
        "periodo": 202603,
        "valor": 363546350669.0,
        "delta": 5443740017.0
      },
      {
        "periodo": 202604,
        "valor": 334532356762.0001,
        "delta": -29013993906.9999
      },
      {
        "periodo": 202605,
        "valor": 349827470093.0,
        "delta": 15295113330.9999
      },
      {
        "periodo": 202606,
        "valor": 350561450219.0,
        "delta": 733980126.0
      },
      {
        "periodo": 202607,
        "valor": 345339853031.0,
        "delta": -5221597188.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 140098067703.13,
    "valor_anterior": 146903060814.92,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 137670740193.92,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 138995675290.19,
        "delta": 1324935096.27
      },
      {
        "periodo": 202509,
        "valor": 140601153700.95,
        "delta": 1605478410.76
      },
      {
        "periodo": 202510,
        "valor": 138614304312.17,
        "delta": -1986849388.78
      },
      {
        "periodo": 202511,
        "valor": 135621233903.82,
        "delta": -2993070408.35
      },
      {
        "periodo": 202512,
        "valor": 134274735609.43,
        "delta": -1346498294.39
      },
      {
        "periodo": 202601,
        "valor": 130993739329.86,
        "delta": -3280996279.57
      },
      {
        "periodo": 202602,
        "valor": 134557226679.01,
        "delta": 3563487349.15
      },
      {
        "periodo": 202603,
        "valor": 138720214163.91,
        "delta": 4162987484.9
      },
      {
        "periodo": 202604,
        "valor": 144689260239.87,
        "delta": 5969046075.96
      },
      {
        "periodo": 202605,
        "valor": 146967935784.09,
        "delta": 2278675544.22
      },
      {
        "periodo": 202606,
        "valor": 146903060814.92,
        "delta": -64874969.17
      },
      {
        "periodo": 202607,
        "valor": 140098067703.13,
        "delta": -6804993111.79
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 362725580652.0,
    "valor_anterior": 359273725065.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 349821503214.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 352020943809.0,
        "delta": 2199440595.0
      },
      {
        "periodo": 202509,
        "valor": 353137345100.0,
        "delta": 1116401291.0
      },
      {
        "periodo": 202510,
        "valor": 341526712831.0,
        "delta": -11610632269.0
      },
      {
        "periodo": 202511,
        "valor": 347511084147.0,
        "delta": 5984371316.0
      },
      {
        "periodo": 202512,
        "valor": 355527269417.0,
        "delta": 8016185270.0
      },
      {
        "periodo": 202601,
        "valor": 355310688458.0,
        "delta": -216580959.0
      },
      {
        "periodo": 202602,
        "valor": 359162753849.0,
        "delta": 3852065391.0
      },
      {
        "periodo": 202603,
        "valor": 360946408359.0,
        "delta": 1783654510.0
      },
      {
        "periodo": 202604,
        "valor": 361779784321.0,
        "delta": 833375962.0
      },
      {
        "periodo": 202605,
        "valor": 357290468379.0,
        "delta": -4489315942.0
      },
      {
        "periodo": 202606,
        "valor": 359273725065.0,
        "delta": 1983256686.0
      },
      {
        "periodo": 202607,
        "valor": 362725580652.0,
        "delta": 3451855587.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 49856106109.0,
    "valor_anterior": 52337273053.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 31609253834.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 36083450773.0,
        "delta": 4474196939.0
      },
      {
        "periodo": 202509,
        "valor": 39758940971.0,
        "delta": 3675490198.0
      },
      {
        "periodo": 202510,
        "valor": 35951302558.0,
        "delta": -3807638413.0
      },
      {
        "periodo": 202511,
        "valor": 35783865805.0,
        "delta": -167436753.0
      },
      {
        "periodo": 202512,
        "valor": 34225593360.0,
        "delta": -1558272445.0
      },
      {
        "periodo": 202601,
        "valor": 37290570445.0,
        "delta": 3064977085.0
      },
      {
        "periodo": 202602,
        "valor": 40669996151.0,
        "delta": 3379425706.0
      },
      {
        "periodo": 202603,
        "valor": 44902533123.0,
        "delta": 4232536972.0
      },
      {
        "periodo": 202604,
        "valor": 47418231519.0,
        "delta": 2515698396.0
      },
      {
        "periodo": 202605,
        "valor": 48983470946.0,
        "delta": 1565239427.0
      },
      {
        "periodo": 202606,
        "valor": 52337273053.0,
        "delta": 3353802107.0
      },
      {
        "periodo": 202607,
        "valor": 49856106109.0,
        "delta": -2481166944.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 290605607782.0,
    "valor_anterior": 294093052083.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 293224857174.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 293570230406.0,
        "delta": 345373232.0
      },
      {
        "periodo": 202509,
        "valor": 289209912494.0,
        "delta": -4360317912.0
      },
      {
        "periodo": 202510,
        "valor": 286054274463.0,
        "delta": -3155638031.0
      },
      {
        "periodo": 202511,
        "valor": 287312411928.0,
        "delta": 1258137465.0
      },
      {
        "periodo": 202512,
        "valor": 281639237624.0,
        "delta": -5673174304.0
      },
      {
        "periodo": 202601,
        "valor": 274119742315.0,
        "delta": -7519495309.0
      },
      {
        "periodo": 202602,
        "valor": 282065534832.0,
        "delta": 7945792517.0
      },
      {
        "periodo": 202603,
        "valor": 286110263445.0,
        "delta": 4044728613.0
      },
      {
        "periodo": 202604,
        "valor": 292708150310.0,
        "delta": 6597886865.0
      },
      {
        "periodo": 202605,
        "valor": 284968499833.0,
        "delta": -7739650477.0
      },
      {
        "periodo": 202606,
        "valor": 294093052083.0,
        "delta": 9124552250.0
      },
      {
        "periodo": 202607,
        "valor": 290605607782.0,
        "delta": -3487444301.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 87643340920.29,
    "valor_anterior": 88644208259.95,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 82267426049.3,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 83750317826.82,
        "delta": 1482891777.52
      },
      {
        "periodo": 202509,
        "valor": 81699442013.02,
        "delta": -2050875813.8
      },
      {
        "periodo": 202510,
        "valor": 85053265476.22,
        "delta": 3353823463.2
      },
      {
        "periodo": 202511,
        "valor": 86534269822.14,
        "delta": 1481004345.92
      },
      {
        "periodo": 202512,
        "valor": 87179406102.92,
        "delta": 645136280.78
      },
      {
        "periodo": 202601,
        "valor": 85564408850.95,
        "delta": -1614997251.97
      },
      {
        "periodo": 202602,
        "valor": 76481776551.88,
        "delta": -9082632299.07
      },
      {
        "periodo": 202603,
        "valor": 79722986172.91,
        "delta": 3241209621.03
      },
      {
        "periodo": 202604,
        "valor": 82034822637.65,
        "delta": 2311836464.74
      },
      {
        "periodo": 202605,
        "valor": 83426619277.95,
        "delta": 1391796640.3
      },
      {
        "periodo": 202606,
        "valor": 88644208259.95,
        "delta": 5217588982.0
      },
      {
        "periodo": 202607,
        "valor": 87643340920.29,
        "delta": -1000867339.66
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 9680702465.0,
    "valor_anterior": 9150557061.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7403381687.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10078127916.0,
        "delta": 2674746229.0
      },
      {
        "periodo": 202509,
        "valor": 10138159788.0,
        "delta": 60031872.0
      },
      {
        "periodo": 202510,
        "valor": 9155274016.0,
        "delta": -982885772.0
      },
      {
        "periodo": 202511,
        "valor": 10213033858.0,
        "delta": 1057759842.0
      },
      {
        "periodo": 202512,
        "valor": 9445043511.0,
        "delta": -767990347.0
      },
      {
        "periodo": 202601,
        "valor": 9409012365.0,
        "delta": -36031146.0
      },
      {
        "periodo": 202602,
        "valor": 9423037184.0,
        "delta": 14024819.0
      },
      {
        "periodo": 202603,
        "valor": 10228271128.0,
        "delta": 805233944.0
      },
      {
        "periodo": 202604,
        "valor": 8561953829.0,
        "delta": -1666317299.0
      },
      {
        "periodo": 202605,
        "valor": 8631678185.0,
        "delta": 69724356.0
      },
      {
        "periodo": 202606,
        "valor": 9150557061.0,
        "delta": 518878876.0
      },
      {
        "periodo": 202607,
        "valor": 9680702465.0,
        "delta": 530145404.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 11066471681.999998,
    "valor_anterior": 10939368141.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17933029128.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19048990976.0,
        "delta": 1115961848.0
      },
      {
        "periodo": 202509,
        "valor": 15985086800.0,
        "delta": -3063904176.0
      },
      {
        "periodo": 202510,
        "valor": 14451769222.0,
        "delta": -1533317578.0
      },
      {
        "periodo": 202511,
        "valor": 14789828739.0,
        "delta": 338059517.0
      },
      {
        "periodo": 202512,
        "valor": 10350951253.0,
        "delta": -4438877486.0
      },
      {
        "periodo": 202601,
        "valor": 10934721071.0,
        "delta": 583769818.0
      },
      {
        "periodo": 202602,
        "valor": 11967987276.0,
        "delta": 1033266205.0
      },
      {
        "periodo": 202603,
        "valor": 11664849851.0,
        "delta": -303137425.0
      },
      {
        "periodo": 202604,
        "valor": 12106427345.0,
        "delta": 441577494.0
      },
      {
        "periodo": 202605,
        "valor": 11026970474.0,
        "delta": -1079456871.0
      },
      {
        "periodo": 202606,
        "valor": 10939368141.0,
        "delta": -87602333.0
      },
      {
        "periodo": 202607,
        "valor": 11066471682.0,
        "delta": 127103541.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 47231602987.0,
    "valor_anterior": 46623893941.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 43282248059.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 44938360587.0,
        "delta": 1656112528.0
      },
      {
        "periodo": 202509,
        "valor": 43424919119.0,
        "delta": -1513441468.0
      },
      {
        "periodo": 202510,
        "valor": 44607261170.0,
        "delta": 1182342051.0
      },
      {
        "periodo": 202511,
        "valor": 45715181154.0,
        "delta": 1107919984.0
      },
      {
        "periodo": 202512,
        "valor": 45783563063.0,
        "delta": 68381909.0
      },
      {
        "periodo": 202601,
        "valor": 43894534366.0,
        "delta": -1889028697.0
      },
      {
        "periodo": 202602,
        "valor": 45432661047.0,
        "delta": 1538126681.0
      },
      {
        "periodo": 202603,
        "valor": 45562101741.0,
        "delta": 129440694.0
      },
      {
        "periodo": 202604,
        "valor": 46629526444.0,
        "delta": 1067424703.0
      },
      {
        "periodo": 202605,
        "valor": 46189578581.0,
        "delta": -439947863.0
      },
      {
        "periodo": 202606,
        "valor": 46623893941.0,
        "delta": 434315360.0
      },
      {
        "periodo": 202607,
        "valor": 47231602987.0,
        "delta": 607709046.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 837362253765.92,
    "valor_anterior": 827709453573.3,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 772141416110.75,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 774270171096.4102,
        "delta": 2128754985.6602
      },
      {
        "periodo": 202509,
        "valor": 755897155862.9,
        "delta": -18373015233.5101
      },
      {
        "periodo": 202510,
        "valor": 773646207080.5999,
        "delta": 17749051217.6998
      },
      {
        "periodo": 202511,
        "valor": 791815288067.39,
        "delta": 18169080986.7902
      },
      {
        "periodo": 202512,
        "valor": 836823949415.43,
        "delta": 45008661348.04
      },
      {
        "periodo": 202601,
        "valor": 788617049464.32,
        "delta": -48206899951.1101
      },
      {
        "periodo": 202602,
        "valor": 808469067976.3899,
        "delta": 19852018512.0699
      },
      {
        "periodo": 202603,
        "valor": 823297287363.9,
        "delta": 14828219387.5101
      },
      {
        "periodo": 202604,
        "valor": 828340113562.32,
        "delta": 5042826198.4199
      },
      {
        "periodo": 202605,
        "valor": 826437985513.5,
        "delta": -1902128048.8199
      },
      {
        "periodo": 202606,
        "valor": 827709453573.3,
        "delta": 1271468059.8
      },
      {
        "periodo": 202607,
        "valor": 837362253765.92,
        "delta": 9652800192.62
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 51257581079.0,
    "valor_anterior": 51754665102.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 39465210460.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 41612627380.0,
        "delta": 2147416920.0
      },
      {
        "periodo": 202509,
        "valor": 45174152283.0,
        "delta": 3561524903.0
      },
      {
        "periodo": 202510,
        "valor": 42617274704.0,
        "delta": -2556877579.0
      },
      {
        "periodo": 202511,
        "valor": 43917214339.0,
        "delta": 1299939635.0
      },
      {
        "periodo": 202512,
        "valor": 56285511398.0,
        "delta": 12368297059.0
      },
      {
        "periodo": 202601,
        "valor": 48245807543.0,
        "delta": -8039703855.0
      },
      {
        "periodo": 202602,
        "valor": 50395242022.0,
        "delta": 2149434479.0
      },
      {
        "periodo": 202603,
        "valor": 52457728257.0,
        "delta": 2062486235.0
      },
      {
        "periodo": 202604,
        "valor": 55028402566.0,
        "delta": 2570674309.0
      },
      {
        "periodo": 202605,
        "valor": 55135933878.0,
        "delta": 107531312.0
      },
      {
        "periodo": 202606,
        "valor": 51754665102.0,
        "delta": -3381268776.0
      },
      {
        "periodo": 202607,
        "valor": 51257581079.0,
        "delta": -497084023.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 15111836742.000002,
    "valor_anterior": 16648427396.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16324097980.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16387149812.0,
        "delta": 63051832.0
      },
      {
        "periodo": 202509,
        "valor": 17785797833.0,
        "delta": 1398648021.0
      },
      {
        "periodo": 202510,
        "valor": 16745346603.0,
        "delta": -1040451230.0
      },
      {
        "periodo": 202511,
        "valor": 20431278306.0,
        "delta": 3685931703.0
      },
      {
        "periodo": 202512,
        "valor": 18060747656.0,
        "delta": -2370530650.0
      },
      {
        "periodo": 202601,
        "valor": 16581188251.0,
        "delta": -1479559405.0
      },
      {
        "periodo": 202602,
        "valor": 17482801207.0,
        "delta": 901612956.0
      },
      {
        "periodo": 202603,
        "valor": 20077470108.0,
        "delta": 2594668901.0
      },
      {
        "periodo": 202604,
        "valor": 17136792977.0,
        "delta": -2940677131.0
      },
      {
        "periodo": 202605,
        "valor": 17077143958.0,
        "delta": -59649019.0
      },
      {
        "periodo": 202606,
        "valor": 16648427396.0,
        "delta": -428716562.0
      },
      {
        "periodo": 202607,
        "valor": 15111836742.0,
        "delta": -1536590654.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 73034177431.0,
    "valor_anterior": 70210559910.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 61888773088.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 66268976766.0,
        "delta": 4380203678.0
      },
      {
        "periodo": 202509,
        "valor": 65292259786.0,
        "delta": -976716980.0
      },
      {
        "periodo": 202510,
        "valor": 73013694113.0,
        "delta": 7721434327.0
      },
      {
        "periodo": 202511,
        "valor": 68497985808.0,
        "delta": -4515708305.0
      },
      {
        "periodo": 202512,
        "valor": 66888993577.0,
        "delta": -1608992231.0
      },
      {
        "periodo": 202601,
        "valor": 63694246374.0,
        "delta": -3194747203.0
      },
      {
        "periodo": 202602,
        "valor": 62614013393.0,
        "delta": -1080232981.0
      },
      {
        "periodo": 202603,
        "valor": 66256806233.0,
        "delta": 3642792840.0
      },
      {
        "periodo": 202604,
        "valor": 70458055933.0,
        "delta": 4201249700.0
      },
      {
        "periodo": 202605,
        "valor": 63139396426.0,
        "delta": -7318659507.0
      },
      {
        "periodo": 202606,
        "valor": 70210559910.0,
        "delta": 7071163484.0
      },
      {
        "periodo": 202607,
        "valor": 73034177431.0,
        "delta": 2823617521.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 37749154365.34999,
    "valor_anterior": 39863347892.52,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 34055884274.96,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 34952608531.66,
        "delta": 896724256.7
      },
      {
        "periodo": 202509,
        "valor": 36190365136.86,
        "delta": 1237756605.2
      },
      {
        "periodo": 202510,
        "valor": 35772460235.43,
        "delta": -417904901.43
      },
      {
        "periodo": 202511,
        "valor": 36166931144.77,
        "delta": 394470909.34
      },
      {
        "periodo": 202512,
        "valor": 37312660231.1,
        "delta": 1145729086.33
      },
      {
        "periodo": 202601,
        "valor": 35984786641.17,
        "delta": -1327873589.93
      },
      {
        "periodo": 202602,
        "valor": 37214499686.77,
        "delta": 1229713045.6
      },
      {
        "periodo": 202603,
        "valor": 40566264606.13,
        "delta": 3351764919.36
      },
      {
        "periodo": 202604,
        "valor": 39696788028.26,
        "delta": -869476577.87
      },
      {
        "periodo": 202605,
        "valor": 38014584905.5,
        "delta": -1682203122.76
      },
      {
        "periodo": 202606,
        "valor": 39863347892.52,
        "delta": 1848762987.02
      },
      {
        "periodo": 202607,
        "valor": 37749154365.35,
        "delta": -2114193527.17
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 40561503167.0,
    "valor_anterior": 39547961566.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 42026455725.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 38258542951.0,
        "delta": -3767912774.0
      },
      {
        "periodo": 202509,
        "valor": 37047612289.0,
        "delta": -1210930662.0
      },
      {
        "periodo": 202510,
        "valor": 37287785806.0,
        "delta": 240173517.0
      },
      {
        "periodo": 202511,
        "valor": 38346346599.0,
        "delta": 1058560793.0
      },
      {
        "periodo": 202512,
        "valor": 38345566622.0,
        "delta": -779977.0
      },
      {
        "periodo": 202601,
        "valor": 38927161336.0,
        "delta": 581594714.0
      },
      {
        "periodo": 202602,
        "valor": 40664107879.0,
        "delta": 1736946543.0
      },
      {
        "periodo": 202603,
        "valor": 39404550669.0,
        "delta": -1259557210.0
      },
      {
        "periodo": 202604,
        "valor": 39899868832.0,
        "delta": 495318163.0
      },
      {
        "periodo": 202605,
        "valor": 40513332317.0,
        "delta": 613463485.0
      },
      {
        "periodo": 202606,
        "valor": 39547961566.0,
        "delta": -965370751.0
      },
      {
        "periodo": 202607,
        "valor": 40561503167.0,
        "delta": 1013541601.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 211099084013.00998,
    "valor_anterior": 227468826115.34,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 210780999010.17,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 209529037675.23,
        "delta": -1251961334.94
      },
      {
        "periodo": 202509,
        "valor": 211538634195.04,
        "delta": 2009596519.81
      },
      {
        "periodo": 202510,
        "valor": 207359355792.87,
        "delta": -4179278402.17
      },
      {
        "periodo": 202511,
        "valor": 233557116992.91,
        "delta": 26197761200.04
      },
      {
        "periodo": 202512,
        "valor": 247173946043.95,
        "delta": 13616829051.04
      },
      {
        "periodo": 202601,
        "valor": 220574319005.35,
        "delta": -26599627038.6
      },
      {
        "periodo": 202602,
        "valor": 227356586880.99,
        "delta": 6782267875.64
      },
      {
        "periodo": 202603,
        "valor": 253723735918.29,
        "delta": 26367149037.3
      },
      {
        "periodo": 202604,
        "valor": 220319222077.83,
        "delta": -33404513840.46
      },
      {
        "periodo": 202605,
        "valor": 224577215851.73,
        "delta": 4257993773.9
      },
      {
        "periodo": 202606,
        "valor": 227468826115.34,
        "delta": 2891610263.61
      },
      {
        "periodo": 202607,
        "valor": 211099084013.01,
        "delta": -16369742102.33
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 199741299534.71,
    "valor_anterior": 198039462989.76,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 186891203137.54,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 192292944650.58,
        "delta": 5401741513.04
      },
      {
        "periodo": 202509,
        "valor": 185862638433.51,
        "delta": -6430306217.07
      },
      {
        "periodo": 202510,
        "valor": 192839641549.93,
        "delta": 6977003116.42
      },
      {
        "periodo": 202511,
        "valor": 187287844961.38,
        "delta": -5551796588.55
      },
      {
        "periodo": 202512,
        "valor": 185571426600.87,
        "delta": -1716418360.51
      },
      {
        "periodo": 202601,
        "valor": 185966207462.85,
        "delta": 394780861.98
      },
      {
        "periodo": 202602,
        "valor": 188803706869.05,
        "delta": 2837499406.2
      },
      {
        "periodo": 202603,
        "valor": 188253308649.35,
        "delta": -550398219.7
      },
      {
        "periodo": 202604,
        "valor": 197569899772.11,
        "delta": 9316591122.76
      },
      {
        "periodo": 202605,
        "valor": 199899195243.92,
        "delta": 2329295471.81
      },
      {
        "periodo": 202606,
        "valor": 198039462989.76,
        "delta": -1859732254.16
      },
      {
        "periodo": 202607,
        "valor": 199741299534.71,
        "delta": 1701836544.95
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 17237746244.0,
    "valor_anterior": 18479300674.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6673116765.98,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11717840821.75,
        "delta": 5044724055.77
      },
      {
        "periodo": 202509,
        "valor": 22906421548.0,
        "delta": 11188580726.25
      },
      {
        "periodo": 202510,
        "valor": 24226583767.0,
        "delta": 1320162219.0
      },
      {
        "periodo": 202511,
        "valor": 20228324125.0,
        "delta": -3998259642.0
      },
      {
        "periodo": 202512,
        "valor": 22885802490.0,
        "delta": 2657478365.0
      },
      {
        "periodo": 202601,
        "valor": 21395453107.0,
        "delta": -1490349383.0
      },
      {
        "periodo": 202602,
        "valor": 17771791479.0,
        "delta": -3623661628.0
      },
      {
        "periodo": 202603,
        "valor": 19212468451.0,
        "delta": 1440676972.0
      },
      {
        "periodo": 202604,
        "valor": 17752425921.0,
        "delta": -1460042530.0
      },
      {
        "periodo": 202605,
        "valor": 17617806761.0,
        "delta": -134619160.0
      },
      {
        "periodo": 202606,
        "valor": 18479300674.0,
        "delta": 861493913.0
      },
      {
        "periodo": 202607,
        "valor": 17237746244.0,
        "delta": -1241554430.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 3988168595.0,
    "valor_anterior": 4087395344.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3674476109.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3411390783.0,
        "delta": -263085326.0
      },
      {
        "periodo": 202509,
        "valor": 3400182205.0,
        "delta": -11208578.0
      },
      {
        "periodo": 202510,
        "valor": 3654925318.0,
        "delta": 254743113.0
      },
      {
        "periodo": 202511,
        "valor": 3926862401.0,
        "delta": 271937083.0
      },
      {
        "periodo": 202512,
        "valor": 3950976848.0,
        "delta": 24114447.0
      },
      {
        "periodo": 202601,
        "valor": 3458541361.0,
        "delta": -492435487.0
      },
      {
        "periodo": 202602,
        "valor": 3600313536.0,
        "delta": 141772175.0
      },
      {
        "periodo": 202603,
        "valor": 3753205544.0,
        "delta": 152892008.0
      },
      {
        "periodo": 202604,
        "valor": 3597859328.0,
        "delta": -155346216.0
      },
      {
        "periodo": 202605,
        "valor": 3809018632.0,
        "delta": 211159304.0
      },
      {
        "periodo": 202606,
        "valor": 4087395344.0,
        "delta": 278376712.0
      },
      {
        "periodo": 202607,
        "valor": 3988168595.0,
        "delta": -99226749.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 57609067062.0,
    "valor_anterior": 59882100258.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 44714542114.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 44793729051.0,
        "delta": 79186937.0
      },
      {
        "periodo": 202509,
        "valor": 48593746021.0,
        "delta": 3800016970.0
      },
      {
        "periodo": 202510,
        "valor": 49668393600.0,
        "delta": 1074647579.0
      },
      {
        "periodo": 202511,
        "valor": 50975508098.0,
        "delta": 1307114498.0
      },
      {
        "periodo": 202512,
        "valor": 49371173767.0,
        "delta": -1604334331.0
      },
      {
        "periodo": 202601,
        "valor": 49746705113.0,
        "delta": 375531346.0
      },
      {
        "periodo": 202602,
        "valor": 49560619816.0,
        "delta": -186085297.0
      },
      {
        "periodo": 202603,
        "valor": 54037800316.0,
        "delta": 4477180500.0
      },
      {
        "periodo": 202604,
        "valor": 53257353110.0,
        "delta": -780447206.0
      },
      {
        "periodo": 202605,
        "valor": 57038503966.0,
        "delta": 3781150856.0
      },
      {
        "periodo": 202606,
        "valor": 59882100258.0,
        "delta": 2843596292.0
      },
      {
        "periodo": 202607,
        "valor": 57609067062.0,
        "delta": -2273033196.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 13436554568.0,
    "valor_anterior": 14954739525.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13098513977.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17862806151.0,
        "delta": 4764292174.0
      },
      {
        "periodo": 202509,
        "valor": 21024086843.0,
        "delta": 3161280692.0
      },
      {
        "periodo": 202510,
        "valor": 15593349135.0,
        "delta": -5430737708.0
      },
      {
        "periodo": 202511,
        "valor": 15549766499.0,
        "delta": -43582636.0
      },
      {
        "periodo": 202512,
        "valor": 16869166614.0,
        "delta": 1319400115.0
      },
      {
        "periodo": 202601,
        "valor": 13991576922.0,
        "delta": -2877589692.0
      },
      {
        "periodo": 202602,
        "valor": 13920590269.0,
        "delta": -70986653.0
      },
      {
        "periodo": 202603,
        "valor": 12676656360.0,
        "delta": -1243933909.0
      },
      {
        "periodo": 202604,
        "valor": 13113092056.0,
        "delta": 436435696.0
      },
      {
        "periodo": 202605,
        "valor": 9464869776.0,
        "delta": -3648222280.0
      },
      {
        "periodo": 202606,
        "valor": 14954739525.0,
        "delta": 5489869749.0
      },
      {
        "periodo": 202607,
        "valor": 13436554568.0,
        "delta": -1518184957.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13503463268.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9438388864.0,
        "delta": -4065074404.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -9438388864.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 133924806265.2,
    "valor_anterior": 132172535392.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 136267937747.06,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 137312537497.64,
        "delta": 1044599750.58
      },
      {
        "periodo": 202509,
        "valor": 134722002895.16,
        "delta": -2590534602.48
      },
      {
        "periodo": 202510,
        "valor": 138697406671.47,
        "delta": 3975403776.31
      },
      {
        "periodo": 202511,
        "valor": 138736079066.82,
        "delta": 38672395.35
      },
      {
        "periodo": 202512,
        "valor": 140177495573.19,
        "delta": 1441416506.37
      },
      {
        "periodo": 202601,
        "valor": 137392810759.4,
        "delta": -2784684813.79
      },
      {
        "periodo": 202602,
        "valor": 135281486795.81,
        "delta": -2111323963.59
      },
      {
        "periodo": 202603,
        "valor": 135154269785.12,
        "delta": -127217010.69
      },
      {
        "periodo": 202604,
        "valor": 136054729016.99,
        "delta": 900459231.87
      },
      {
        "periodo": 202605,
        "valor": 135036786928.82,
        "delta": -1017942088.17
      },
      {
        "periodo": 202606,
        "valor": 132172535392.25,
        "delta": -2864251536.57
      },
      {
        "periodo": 202607,
        "valor": 133924806265.2,
        "delta": 1752270872.95
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 2430194796.0,
    "valor_anterior": 2439378150.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3581577710.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3615543041.0,
        "delta": 33965331.0
      },
      {
        "periodo": 202509,
        "valor": 3446327225.0,
        "delta": -169215816.0
      },
      {
        "periodo": 202510,
        "valor": 2936973602.0,
        "delta": -509353623.0
      },
      {
        "periodo": 202511,
        "valor": 2887567015.0,
        "delta": -49406587.0
      },
      {
        "periodo": 202512,
        "valor": 2911460662.0,
        "delta": 23893647.0
      },
      {
        "periodo": 202601,
        "valor": 2803091580.0,
        "delta": -108369082.0
      },
      {
        "periodo": 202602,
        "valor": 2691526612.0,
        "delta": -111564968.0
      },
      {
        "periodo": 202603,
        "valor": 2576876974.0,
        "delta": -114649638.0
      },
      {
        "periodo": 202604,
        "valor": 2483559659.0,
        "delta": -93317315.0
      },
      {
        "periodo": 202605,
        "valor": 2472826265.0,
        "delta": -10733394.0
      },
      {
        "periodo": 202606,
        "valor": 2439378150.0,
        "delta": -33448115.0
      },
      {
        "periodo": 202607,
        "valor": 2430194796.0,
        "delta": -9183354.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21262708.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21030542.0,
        "delta": -232166.0
      },
      {
        "periodo": 202509,
        "valor": 20640232.0,
        "delta": -390310.0
      },
      {
        "periodo": 202510,
        "valor": 20939309.0,
        "delta": 299077.0
      },
      {
        "periodo": 202511,
        "valor": 20619417.0,
        "delta": -319892.0
      },
      {
        "periodo": 202512,
        "valor": 20296145.0,
        "delta": -323272.0
      },
      {
        "periodo": 202601,
        "valor": 19634052.0,
        "delta": -662093.0
      },
      {
        "periodo": 202602,
        "valor": 19422273.0,
        "delta": -211779.0
      },
      {
        "periodo": 202603,
        "valor": 20204339.0,
        "delta": 782066.0
      },
      {
        "periodo": 202604,
        "valor": 19690401.0,
        "delta": -513938.0
      },
      {
        "periodo": 202605,
        "valor": 19545838.0,
        "delta": -144563.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": -19545838.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 886900049.0,
    "valor_anterior": 825101017.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 555462555.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 545449506.0,
        "delta": -10013049.0
      },
      {
        "periodo": 202509,
        "valor": 464478698.0,
        "delta": -80970808.0
      },
      {
        "periodo": 202510,
        "valor": 460102120.0,
        "delta": -4376578.0
      },
      {
        "periodo": 202511,
        "valor": 748025444.0,
        "delta": 287923324.0
      },
      {
        "periodo": 202512,
        "valor": 589656878.0,
        "delta": -158368566.0
      },
      {
        "periodo": 202601,
        "valor": 788722352.0,
        "delta": 199065474.0
      },
      {
        "periodo": 202602,
        "valor": 787278153.0,
        "delta": -1444199.0
      },
      {
        "periodo": 202603,
        "valor": 634111681.0,
        "delta": -153166472.0
      },
      {
        "periodo": 202604,
        "valor": 970562259.0,
        "delta": 336450578.0
      },
      {
        "periodo": 202605,
        "valor": 778121646.0,
        "delta": -192440613.0
      },
      {
        "periodo": 202606,
        "valor": 825101017.0,
        "delta": 46979371.0
      },
      {
        "periodo": 202607,
        "valor": 886900049.0,
        "delta": 61799032.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 709720.0,
    "valor_anterior": 709721.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1080840.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1080840.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1080837.0,
        "delta": -3.0
      },
      {
        "periodo": 202510,
        "valor": 1080838.0,
        "delta": 1.0
      },
      {
        "periodo": 202511,
        "valor": 1080838.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 1080838.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 1080839.0,
        "delta": 1.0
      },
      {
        "periodo": 202602,
        "valor": 1080843.0,
        "delta": 4.0
      },
      {
        "periodo": 202603,
        "valor": 709716.0,
        "delta": -371127.0
      },
      {
        "periodo": 202604,
        "valor": 709716.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 709715.0,
        "delta": -1.0
      },
      {
        "periodo": 202606,
        "valor": 709721.0,
        "delta": 6.0
      },
      {
        "periodo": 202607,
        "valor": 709720.0,
        "delta": -1.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5163588764.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3194661863.0,
        "delta": -1968926901.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 20894441997.0,
    "valor_anterior": 20734715213.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19560527758.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 20484464632.0,
        "delta": 923936874.0
      },
      {
        "periodo": 202509,
        "valor": 19270846668.0,
        "delta": -1213617964.0
      },
      {
        "periodo": 202510,
        "valor": 19625951827.0,
        "delta": 355105159.0
      },
      {
        "periodo": 202511,
        "valor": 19579501221.0,
        "delta": -46450606.0
      },
      {
        "periodo": 202512,
        "valor": 20569437693.0,
        "delta": 989936472.0
      },
      {
        "periodo": 202601,
        "valor": 19058657745.0,
        "delta": -1510779948.0
      },
      {
        "periodo": 202602,
        "valor": 19513988928.0,
        "delta": 455331183.0
      },
      {
        "periodo": 202603,
        "valor": 20176828488.0,
        "delta": 662839560.0
      },
      {
        "periodo": 202604,
        "valor": 20624402432.0,
        "delta": 447573944.0
      },
      {
        "periodo": 202605,
        "valor": 20782324460.0,
        "delta": 157922028.0
      },
      {
        "periodo": 202606,
        "valor": 20734715213.0,
        "delta": -47609247.0
      },
      {
        "periodo": 202607,
        "valor": 20894441997.0,
        "delta": 159726784.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 16962973585.999998,
    "valor_anterior": 15278464358.000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8033528181.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7845605049.0,
        "delta": -187923132.0
      },
      {
        "periodo": 202509,
        "valor": 8640753114.0,
        "delta": 795148065.0
      },
      {
        "periodo": 202510,
        "valor": 9137773160.0,
        "delta": 497020046.0
      },
      {
        "periodo": 202511,
        "valor": 9341395404.0,
        "delta": 203622244.0
      },
      {
        "periodo": 202512,
        "valor": 15721938513.0,
        "delta": 6380543109.0
      },
      {
        "periodo": 202601,
        "valor": 9314909117.0,
        "delta": -6407029396.0
      },
      {
        "periodo": 202602,
        "valor": 12697489912.0,
        "delta": 3382580795.0
      },
      {
        "periodo": 202603,
        "valor": 13269036900.0,
        "delta": 571546988.0
      },
      {
        "periodo": 202604,
        "valor": 13406818138.0,
        "delta": 137781238.0
      },
      {
        "periodo": 202605,
        "valor": 14486636262.0,
        "delta": 1079818124.0
      },
      {
        "periodo": 202606,
        "valor": 15278464358.0,
        "delta": 791828096.0
      },
      {
        "periodo": 202607,
        "valor": 16962973586.0,
        "delta": 1684509228.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 952727998.0,
    "valor_anterior": 950197988.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27948253.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 858397167.0,
        "delta": 830448914.0
      },
      {
        "periodo": 202509,
        "valor": 499982328.0,
        "delta": -358414839.0
      },
      {
        "periodo": 202510,
        "valor": 484480123.0,
        "delta": -15502205.0
      },
      {
        "periodo": 202511,
        "valor": 578430035.0,
        "delta": 93949912.0
      },
      {
        "periodo": 202512,
        "valor": 119706874.0,
        "delta": -458723161.0
      },
      {
        "periodo": 202601,
        "valor": 261002415.0,
        "delta": 141295541.0
      },
      {
        "periodo": 202602,
        "valor": 274151870.0,
        "delta": 13149455.0
      },
      {
        "periodo": 202603,
        "valor": 60820605.0,
        "delta": -213331265.0
      },
      {
        "periodo": 202604,
        "valor": 39723747.0,
        "delta": -21096858.0
      },
      {
        "periodo": 202605,
        "valor": 579026695.0,
        "delta": 539302948.0
      },
      {
        "periodo": 202606,
        "valor": 950197988.0,
        "delta": 371171293.0
      },
      {
        "periodo": 202607,
        "valor": 952727998.0,
        "delta": 2530010.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 612016883.32,
    "valor_anterior": 667684911.97,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 584168684.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 551528836.71,
        "delta": -32639847.58
      },
      {
        "periodo": 202509,
        "valor": 475774336.36,
        "delta": -75754500.35
      },
      {
        "periodo": 202510,
        "valor": 654002873.03,
        "delta": 178228536.67
      },
      {
        "periodo": 202511,
        "valor": 682249696.33,
        "delta": 28246823.3
      },
      {
        "periodo": 202512,
        "valor": 592246869.48,
        "delta": -90002826.85
      },
      {
        "periodo": 202601,
        "valor": 491016489.05,
        "delta": -101230380.43
      },
      {
        "periodo": 202602,
        "valor": 415579689.42,
        "delta": -75436799.63
      },
      {
        "periodo": 202603,
        "valor": 557740440.84,
        "delta": 142160751.42
      },
      {
        "periodo": 202604,
        "valor": 755229202.93,
        "delta": 197488762.09
      },
      {
        "periodo": 202605,
        "valor": 644966671.93,
        "delta": -110262531.0
      },
      {
        "periodo": 202606,
        "valor": 667684911.97,
        "delta": 22718240.04
      },
      {
        "periodo": 202607,
        "valor": 612016883.32,
        "delta": -55668028.65
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 961985382.0,
    "valor_anterior": 913225534.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 395676609.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 451728862.0,
        "delta": 56052253.0
      },
      {
        "periodo": 202509,
        "valor": 724201496.0,
        "delta": 272472634.0
      },
      {
        "periodo": 202510,
        "valor": 1236728342.0,
        "delta": 512526846.0
      },
      {
        "periodo": 202511,
        "valor": 1019709253.0,
        "delta": -217019089.0
      },
      {
        "periodo": 202512,
        "valor": 1260504525.0,
        "delta": 240795272.0
      },
      {
        "periodo": 202601,
        "valor": 959606246.0,
        "delta": -300898279.0
      },
      {
        "periodo": 202602,
        "valor": 939063598.0,
        "delta": -20542648.0
      },
      {
        "periodo": 202603,
        "valor": 921677066.0,
        "delta": -17386532.0
      },
      {
        "periodo": 202604,
        "valor": 944031577.0,
        "delta": 22354511.0
      },
      {
        "periodo": 202605,
        "valor": 1000923533.0,
        "delta": 56891956.0
      },
      {
        "periodo": 202606,
        "valor": 913225534.0,
        "delta": -87697999.0
      },
      {
        "periodo": 202607,
        "valor": 961985382.0,
        "delta": 48759848.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 7444842020.28,
    "valor_anterior": 8215548153.04,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6392246050.47,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5571078666.8,
        "delta": -821167383.67
      },
      {
        "periodo": 202509,
        "valor": 5168990648.91,
        "delta": -402088017.89
      },
      {
        "periodo": 202510,
        "valor": 5545377630.99,
        "delta": 376386982.08
      },
      {
        "periodo": 202511,
        "valor": 5862143685.82,
        "delta": 316766054.83
      },
      {
        "periodo": 202512,
        "valor": 6396579761.35,
        "delta": 534436075.53
      },
      {
        "periodo": 202601,
        "valor": 6068860672.39,
        "delta": -327719088.96
      },
      {
        "periodo": 202602,
        "valor": 7013172581.04,
        "delta": 944311908.65
      },
      {
        "periodo": 202603,
        "valor": 7865530716.23,
        "delta": 852358135.19
      },
      {
        "periodo": 202604,
        "valor": 7376204351.11,
        "delta": -489326365.12
      },
      {
        "periodo": 202605,
        "valor": 7646728166.84,
        "delta": 270523815.73
      },
      {
        "periodo": 202606,
        "valor": 8215548153.04,
        "delta": 568819986.2
      },
      {
        "periodo": 202607,
        "valor": 7444842020.28,
        "delta": -770706132.76
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 513659819.14,
    "valor_anterior": 420322596.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1623550488.07,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1690293635.05,
        "delta": 66743146.98
      },
      {
        "periodo": 202509,
        "valor": 1650541454.46,
        "delta": -39752180.59
      },
      {
        "periodo": 202510,
        "valor": 1460612818.32,
        "delta": -189928636.14
      },
      {
        "periodo": 202511,
        "valor": 1286975607.69,
        "delta": -173637210.63
      },
      {
        "periodo": 202512,
        "valor": 1251708289.52,
        "delta": -35267318.17
      },
      {
        "periodo": 202601,
        "valor": 1281510344.96,
        "delta": 29802055.44
      },
      {
        "periodo": 202602,
        "valor": 989851464.73,
        "delta": -291658880.23
      },
      {
        "periodo": 202603,
        "valor": 453372922.01,
        "delta": -536478542.72
      },
      {
        "periodo": 202604,
        "valor": 379774588.17,
        "delta": -73598333.84
      },
      {
        "periodo": 202605,
        "valor": 413937537.34,
        "delta": 34162949.17
      },
      {
        "periodo": 202606,
        "valor": 420322596.0,
        "delta": 6385058.66
      },
      {
        "periodo": 202607,
        "valor": 513659819.14,
        "delta": 93337223.14
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 7356643515.000001,
    "valor_anterior": 6521863240.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5749424135.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5850538845.0,
        "delta": 101114710.0
      },
      {
        "periodo": 202509,
        "valor": 6383521486.0,
        "delta": 532982641.0
      },
      {
        "periodo": 202510,
        "valor": 7474367632.0,
        "delta": 1090846146.0
      },
      {
        "periodo": 202511,
        "valor": 7801969535.0,
        "delta": 327601903.0
      },
      {
        "periodo": 202512,
        "valor": 7947342328.0,
        "delta": 145372793.0
      },
      {
        "periodo": 202601,
        "valor": 7272548057.0,
        "delta": -674794271.0
      },
      {
        "periodo": 202602,
        "valor": 7776227464.0,
        "delta": 503679407.0
      },
      {
        "periodo": 202603,
        "valor": 7823762701.0,
        "delta": 47535237.0
      },
      {
        "periodo": 202604,
        "valor": 7863369799.0,
        "delta": 39607098.0
      },
      {
        "periodo": 202605,
        "valor": 6066649423.0,
        "delta": -1796720376.0
      },
      {
        "periodo": 202606,
        "valor": 6521863240.0,
        "delta": 455213817.0
      },
      {
        "periodo": 202607,
        "valor": 7356643515.0,
        "delta": 834780275.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 42979799422.0,
    "valor_anterior": 38321220900.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40732843372.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 41608909624.0,
        "delta": 876066252.0
      },
      {
        "periodo": 202509,
        "valor": 43108905430.0,
        "delta": 1499995806.0
      },
      {
        "periodo": 202510,
        "valor": 42570778873.0,
        "delta": -538126557.0
      },
      {
        "periodo": 202511,
        "valor": 44465510744.0,
        "delta": 1894731871.0
      },
      {
        "periodo": 202512,
        "valor": 42827815417.0,
        "delta": -1637695327.0
      },
      {
        "periodo": 202601,
        "valor": 42175598488.0,
        "delta": -652216929.0
      },
      {
        "periodo": 202602,
        "valor": 40037846414.0,
        "delta": -2137752074.0
      },
      {
        "periodo": 202603,
        "valor": 40468595743.0,
        "delta": 430749329.0
      },
      {
        "periodo": 202604,
        "valor": 43241697509.0,
        "delta": 2773101766.0
      },
      {
        "periodo": 202605,
        "valor": 40278966639.0,
        "delta": -2962730870.0
      },
      {
        "periodo": 202606,
        "valor": 38321220900.0,
        "delta": -1957745739.0
      },
      {
        "periodo": 202607,
        "valor": 42979799422.0,
        "delta": 4658578522.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 1929887148.0,
    "valor_anterior": 1598945608.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1259475877.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1516164225.0,
        "delta": 256688348.0
      },
      {
        "periodo": 202509,
        "valor": 1399962983.0,
        "delta": -116201242.0
      },
      {
        "periodo": 202510,
        "valor": 2110133705.0,
        "delta": 710170722.0
      },
      {
        "periodo": 202511,
        "valor": 1927295359.0,
        "delta": -182838346.0
      },
      {
        "periodo": 202512,
        "valor": 1282471031.0,
        "delta": -644824328.0
      },
      {
        "periodo": 202601,
        "valor": 2021466126.0,
        "delta": 738995095.0
      },
      {
        "periodo": 202602,
        "valor": 1963722181.0,
        "delta": -57743945.0
      },
      {
        "periodo": 202603,
        "valor": 1755023471.0,
        "delta": -208698710.0
      },
      {
        "periodo": 202604,
        "valor": 2068728995.0,
        "delta": 313705524.0
      },
      {
        "periodo": 202605,
        "valor": 1777511933.0,
        "delta": -291217062.0
      },
      {
        "periodo": 202606,
        "valor": 1598945608.0,
        "delta": -178566325.0
      },
      {
        "periodo": 202607,
        "valor": 1929887148.0,
        "delta": 330941540.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 2266864461.41,
    "valor_anterior": 2529063902.27,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1979005279.99,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1635916937.15,
        "delta": -343088342.84
      },
      {
        "periodo": 202509,
        "valor": 1640575665.73,
        "delta": 4658728.58
      },
      {
        "periodo": 202510,
        "valor": 1759411130.9,
        "delta": 118835465.17
      },
      {
        "periodo": 202511,
        "valor": 1721284076.73,
        "delta": -38127054.17
      },
      {
        "periodo": 202512,
        "valor": 2006009713.58,
        "delta": 284725636.85
      },
      {
        "periodo": 202601,
        "valor": 2110200263.44,
        "delta": 104190549.86
      },
      {
        "periodo": 202602,
        "valor": 2045083454.56,
        "delta": -65116808.88
      },
      {
        "periodo": 202603,
        "valor": 2622490860.11,
        "delta": 577407405.55
      },
      {
        "periodo": 202604,
        "valor": 2394966812.64,
        "delta": -227524047.47
      },
      {
        "periodo": 202605,
        "valor": 2290968639.11,
        "delta": -103998173.53
      },
      {
        "periodo": 202606,
        "valor": 2529063902.27,
        "delta": 238095263.16
      },
      {
        "periodo": 202607,
        "valor": 2266864461.41,
        "delta": -262199440.86
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 862965169.65,
    "valor_anterior": 776110998.43,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 587933041.06,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 202553342.1,
        "delta": -385379698.96
      },
      {
        "periodo": 202509,
        "valor": 213510584.24,
        "delta": 10957242.14
      },
      {
        "periodo": 202510,
        "valor": 441739651.9,
        "delta": 228229067.66
      },
      {
        "periodo": 202511,
        "valor": 361767107.85,
        "delta": -79972544.05
      },
      {
        "periodo": 202512,
        "valor": 419634386.21,
        "delta": 57867278.36
      },
      {
        "periodo": 202601,
        "valor": 268729877.91,
        "delta": -150904508.3
      },
      {
        "periodo": 202602,
        "valor": 292986224.04,
        "delta": 24256346.13
      },
      {
        "periodo": 202603,
        "valor": 777915218.67,
        "delta": 484928994.63
      },
      {
        "periodo": 202604,
        "valor": 941178021.56,
        "delta": 163262802.89
      },
      {
        "periodo": 202605,
        "valor": 955916136.24,
        "delta": 14738114.68
      },
      {
        "periodo": 202606,
        "valor": 776110998.43,
        "delta": -179805137.81
      },
      {
        "periodo": 202607,
        "valor": 862965169.65,
        "delta": 86854171.22
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 1157450532.0,
    "valor_anterior": 2818586569.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2572072543.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2189228820.0,
        "delta": -382843723.0
      },
      {
        "periodo": 202509,
        "valor": 4814864699.0,
        "delta": 2625635879.0
      },
      {
        "periodo": 202510,
        "valor": 2011124738.0,
        "delta": -2803739961.0
      },
      {
        "periodo": 202511,
        "valor": 3059297276.0,
        "delta": 1048172538.0
      },
      {
        "periodo": 202512,
        "valor": 1117155550.0,
        "delta": -1942141726.0
      },
      {
        "periodo": 202601,
        "valor": 4953763982.0,
        "delta": 3836608432.0
      },
      {
        "periodo": 202602,
        "valor": 3357935450.0,
        "delta": -1595828532.0
      },
      {
        "periodo": 202603,
        "valor": 4874897490.0,
        "delta": 1516962040.0
      },
      {
        "periodo": 202604,
        "valor": 2634032465.0,
        "delta": -2240865025.0
      },
      {
        "periodo": 202605,
        "valor": 3972030714.0,
        "delta": 1337998249.0
      },
      {
        "periodo": 202606,
        "valor": 2818586569.0,
        "delta": -1153444145.0
      },
      {
        "periodo": 202607,
        "valor": 1157450532.0,
        "delta": -1661136037.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 10042485.0,
        "delta": 10042485.0
      },
      {
        "periodo": 202603,
        "valor": 10049389.0,
        "delta": 6904.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": -10049389.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 19544476.85,
    "valor_anterior": 19559478.88,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30201844.62,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 30119782.88,
        "delta": -82061.74
      },
      {
        "periodo": 202509,
        "valor": 27619133.89,
        "delta": -2500648.99
      },
      {
        "periodo": 202510,
        "valor": 27717270.94,
        "delta": 98137.05
      },
      {
        "periodo": 202511,
        "valor": 23565556.63,
        "delta": -4151714.31
      },
      {
        "periodo": 202512,
        "valor": 25051999.27,
        "delta": 1486442.64
      },
      {
        "periodo": 202601,
        "valor": 23121916.69,
        "delta": -1930082.58
      },
      {
        "periodo": 202602,
        "valor": 22183526.49,
        "delta": -938390.2
      },
      {
        "periodo": 202603,
        "valor": 21048425.27,
        "delta": -1135101.22
      },
      {
        "periodo": 202604,
        "valor": 20060681.78,
        "delta": -987743.49
      },
      {
        "periodo": 202605,
        "valor": 19661390.35,
        "delta": -399291.43
      },
      {
        "periodo": 202606,
        "valor": 19559478.88,
        "delta": -101911.47
      },
      {
        "periodo": 202607,
        "valor": 19544476.85,
        "delta": -15002.03
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 2893054287.32,
    "valor_anterior": 2836803558.68,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25000.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25000.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 25000.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 25000.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 25000.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 25000.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 25000.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 2925387439.34,
        "delta": 2925362439.34
      },
      {
        "periodo": 202603,
        "valor": 2973589861.19,
        "delta": 48202421.85
      },
      {
        "periodo": 202604,
        "valor": 2888349167.06,
        "delta": -85240694.13
      },
      {
        "periodo": 202605,
        "valor": 2847520199.91,
        "delta": -40828967.15
      },
      {
        "periodo": 202606,
        "valor": 2836803558.68,
        "delta": -10716641.23
      },
      {
        "periodo": 202607,
        "valor": 2893054287.32,
        "delta": 56250728.64
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 21443247105.0,
    "valor_anterior": 20957216901.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2882696539.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5324411815.0,
        "delta": 2441715276.0
      },
      {
        "periodo": 202509,
        "valor": 7658888088.0,
        "delta": 2334476273.0
      },
      {
        "periodo": 202510,
        "valor": 10278997613.0,
        "delta": 2620109525.0
      },
      {
        "periodo": 202511,
        "valor": 12950815348.0,
        "delta": 2671817735.0
      },
      {
        "periodo": 202512,
        "valor": 16368984077.0,
        "delta": 3418168729.0
      },
      {
        "periodo": 202601,
        "valor": 18439761890.0,
        "delta": 2070777813.0
      },
      {
        "periodo": 202602,
        "valor": 20206431795.0,
        "delta": 1766669905.0
      },
      {
        "periodo": 202603,
        "valor": 19766356240.0,
        "delta": -440075555.0
      },
      {
        "periodo": 202604,
        "valor": 19980785388.0,
        "delta": 214429148.0
      },
      {
        "periodo": 202605,
        "valor": 20510506239.0,
        "delta": 529720851.0
      },
      {
        "periodo": 202606,
        "valor": 20957216901.0,
        "delta": 446710662.0
      },
      {
        "periodo": 202607,
        "valor": 21443247105.0,
        "delta": 486030204.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 7184245190.34,
    "valor_anterior": 7278209445.52,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 5150413.61,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 32893776.52,
        "delta": 27743362.91
      },
      {
        "periodo": 202601,
        "valor": 671672802.72,
        "delta": 638779026.2
      },
      {
        "periodo": 202602,
        "valor": 2384437063.41,
        "delta": 1712764260.69
      },
      {
        "periodo": 202603,
        "valor": 3753035278.11,
        "delta": 1368598214.7
      },
      {
        "periodo": 202604,
        "valor": 5098140961.3,
        "delta": 1345105683.19
      },
      {
        "periodo": 202605,
        "valor": 6365023309.07,
        "delta": 1266882347.77
      },
      {
        "periodo": 202606,
        "valor": 7278209445.52,
        "delta": 913186136.45
      },
      {
        "periodo": 202607,
        "valor": 7184245190.34,
        "delta": -93964255.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 8980241267.0,
    "valor_anterior": 6581179372.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 1369086763.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 4185761525.0,
        "delta": 2816674762.0
      },
      {
        "periodo": 202605,
        "valor": 5288695851.0,
        "delta": 1102934326.0
      },
      {
        "periodo": 202606,
        "valor": 6581179373.0,
        "delta": 1292483522.0
      },
      {
        "periodo": 202607,
        "valor": 8980241267.0,
        "delta": 2399061894.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 6102551191313.13,
    "valor_anterior": 6096484370916.64,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5769962442384.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5794947704591.541,
        "delta": 24985262207.041
      },
      {
        "periodo": 202509,
        "valor": 5748596544784.08,
        "delta": -46351159807.4609
      },
      {
        "periodo": 202510,
        "valor": 5739349719975.21,
        "delta": -9246824808.8701
      },
      {
        "periodo": 202511,
        "valor": 5928459981720.2,
        "delta": 189110261744.9902
      },
      {
        "periodo": 202512,
        "valor": 6091600244587.13,
        "delta": 163140262866.9297
      },
      {
        "periodo": 202601,
        "valor": 5875585242925.82,
        "delta": -216015001661.3096
      },
      {
        "periodo": 202602,
        "valor": 5955277966222.93,
        "delta": 79692723297.1094
      },
      {
        "periodo": 202603,
        "valor": 6105565867672.59,
        "delta": 150287901449.6602
      },
      {
        "periodo": 202604,
        "valor": 6085894609158.21,
        "delta": -19671258514.3799
      },
      {
        "periodo": 202605,
        "valor": 6092390848708.76,
        "delta": 6496239550.5498
      },
      {
        "periodo": 202606,
        "valor": 6096484370916.64,
        "delta": 4093522207.8799
      },
      {
        "periodo": 202607,
        "valor": 6102551191313.13,
        "delta": 6066820396.4902
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 4753489525555.13,
    "valor_anterior": 4728092579864.11,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4538697393544.07,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4535025469255.98,
        "delta": -3671924288.0898
      },
      {
        "periodo": 202509,
        "valor": 4481839452815.95,
        "delta": -53186016440.0303
      },
      {
        "periodo": 202510,
        "valor": 4465802007667.04,
        "delta": -16037445148.9102
      },
      {
        "periodo": 202511,
        "valor": 4627856932063.7,
        "delta": 162054924396.6602
      },
      {
        "periodo": 202512,
        "valor": 4765985483939.74,
        "delta": 138128551876.04
      },
      {
        "periodo": 202601,
        "valor": 4602554472366.08,
        "delta": -163431011573.6602
      },
      {
        "periodo": 202602,
        "valor": 4665714632079.39,
        "delta": 63160159713.3096
      },
      {
        "periodo": 202603,
        "valor": 4756437885307.45,
        "delta": 90723253228.0605
      },
      {
        "periodo": 202604,
        "valor": 4742252120128.95,
        "delta": -14185765178.5
      },
      {
        "periodo": 202605,
        "valor": 4746641609552.96,
        "delta": 4389489424.0098
      },
      {
        "periodo": 202606,
        "valor": 4728092579864.11,
        "delta": -18549029688.8496
      },
      {
        "periodo": 202607,
        "valor": 4753489525555.13,
        "delta": 25396945691.0195
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 58643596362.35,
    "valor_anterior": 60598063105.52,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 72283464064.96,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 68070123890.66,
        "delta": -4213340174.3
      },
      {
        "periodo": 202509,
        "valor": 55461211804.86,
        "delta": -12608912085.8
      },
      {
        "periodo": 202510,
        "valor": 55398412062.43,
        "delta": -62799742.43
      },
      {
        "periodo": 202511,
        "valor": 55746432365.77,
        "delta": 348020303.34
      },
      {
        "periodo": 202512,
        "valor": 57882097924.1,
        "delta": 2135665558.33
      },
      {
        "periodo": 202601,
        "valor": 55043444386.17,
        "delta": -2838653537.93
      },
      {
        "periodo": 202602,
        "valor": 56728488614.77,
        "delta": 1685044228.6
      },
      {
        "periodo": 202603,
        "valor": 60743093094.13,
        "delta": 4014604479.36
      },
      {
        "periodo": 202604,
        "valor": 60321190460.26,
        "delta": -421902633.87
      },
      {
        "periodo": 202605,
        "valor": 58796909365.5,
        "delta": -1524281094.76
      },
      {
        "periodo": 202606,
        "valor": 60598063105.52,
        "delta": 1801153740.02
      },
      {
        "periodo": 202607,
        "valor": 58643596362.35,
        "delta": -1954466743.17
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 409525163247.01,
    "valor_anterior": 425625714082.34,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 381765993788.17,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 391882936665.23,
        "delta": 10116942877.06
      },
      {
        "periodo": 202509,
        "valor": 398689410263.04,
        "delta": 6806473597.81
      },
      {
        "periodo": 202510,
        "valor": 396014750568.87,
        "delta": -2674659694.17
      },
      {
        "periodo": 202511,
        "valor": 425990157185.91,
        "delta": 29975406617.04
      },
      {
        "periodo": 202512,
        "valor": 444894963817.95,
        "delta": 18904806632.04
      },
      {
        "periodo": 202601,
        "valor": 407633508353.35,
        "delta": -37261455464.6
      },
      {
        "periodo": 202602,
        "valor": 416355851326.99,
        "delta": 8722342973.64
      },
      {
        "periodo": 202603,
        "valor": 453262035819.29,
        "delta": 36906184492.3
      },
      {
        "periodo": 202604,
        "valor": 420827400439.83,
        "delta": -32434635379.46
      },
      {
        "periodo": 202605,
        "valor": 419321550126.73,
        "delta": -1505850313.1
      },
      {
        "periodo": 202606,
        "valor": 425625714082.34,
        "delta": 6304163955.61
      },
      {
        "periodo": 202607,
        "valor": 409525163247.01,
        "delta": -16100550835.33
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 418747884383.42,
    "valor_anterior": 425635824851.87,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 379021261288.22,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 383490625516.01,
        "delta": 4469364227.79
      },
      {
        "periodo": 202509,
        "valor": 390809800424.97,
        "delta": 7319174908.96
      },
      {
        "periodo": 202510,
        "valor": 389145830625.39,
        "delta": -1663969799.58
      },
      {
        "periodo": 202511,
        "valor": 391726734971.96,
        "delta": 2580904346.57
      },
      {
        "periodo": 202512,
        "valor": 386224290878.35,
        "delta": -5502444093.61
      },
      {
        "periodo": 202601,
        "valor": 384698183562.8099,
        "delta": -1526107315.54
      },
      {
        "periodo": 202602,
        "valor": 381971573490.89,
        "delta": -2726610071.92
      },
      {
        "periodo": 202603,
        "valor": 397256680187.82,
        "delta": 15285106696.9301
      },
      {
        "periodo": 202604,
        "valor": 410541233847.52,
        "delta": 13284553659.7
      },
      {
        "periodo": 202605,
        "valor": 417208828930.04,
        "delta": 6667595082.52
      },
      {
        "periodo": 202606,
        "valor": 425635824851.87,
        "delta": 8426995921.83
      },
      {
        "periodo": 202607,
        "valor": 418747884383.42,
        "delta": -6887940468.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 83082805274.8,
    "valor_anterior": 83734015791.71,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 67891245926.86,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 77560589388.56,
        "delta": 9669343461.7
      },
      {
        "periodo": 202509,
        "valor": 89659754184.7,
        "delta": 12099164796.14
      },
      {
        "periodo": 202510,
        "valor": 87028822670.14,
        "delta": -2630931514.56
      },
      {
        "periodo": 202511,
        "valor": 83460276103.42,
        "delta": -3568546566.72
      },
      {
        "periodo": 202512,
        "valor": 89895816436.14,
        "delta": 6435540332.72
      },
      {
        "periodo": 202601,
        "valor": 78913689873.75,
        "delta": -10982126562.39
      },
      {
        "periodo": 202602,
        "valor": 80495114689.79,
        "delta": 1581424816.04
      },
      {
        "periodo": 202603,
        "valor": 82187451320.86,
        "delta": 1692336631.07
      },
      {
        "periodo": 202604,
        "valor": 81585806466.41,
        "delta": -601644854.45
      },
      {
        "periodo": 202605,
        "valor": 75866711578.46,
        "delta": -5719094887.95
      },
      {
        "periodo": 202606,
        "valor": 83734015791.71,
        "delta": 7867304213.25
      },
      {
        "periodo": 202607,
        "valor": 83082805274.8,
        "delta": -651210516.91
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100079,
    "label": "D.E.I.",
    "valor_actual": 379062216490.42,
    "valor_anterior": 372798173221.09,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 330303083772.22,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 338917959875.1,
        "delta": 8614876102.88
      },
      {
        "periodo": 202509,
        "valor": 332136915290.56,
        "delta": -6781044584.54
      },
      {
        "periodo": 202510,
        "valor": 345959896381.3401,
        "delta": 13822981090.7801
      },
      {
        "periodo": 202511,
        "valor": 343679449029.44,
        "delta": -2280447351.9001
      },
      {
        "periodo": 202512,
        "valor": 346717591590.85,
        "delta": 3038142561.41
      },
      {
        "periodo": 202601,
        "valor": 346741944383.66,
        "delta": 24352792.81
      },
      {
        "periodo": 202602,
        "valor": 354012306021.1,
        "delta": 7270361637.44
      },
      {
        "periodo": 202603,
        "valor": 355678721943.04,
        "delta": 1666415921.94
      },
      {
        "periodo": 202604,
        "valor": 370366857815.24,
        "delta": 14688135872.2
      },
      {
        "periodo": 202605,
        "valor": 374555239155.07,
        "delta": 4188381339.83
      },
      {
        "periodo": 202606,
        "valor": 372798173221.09,
        "delta": -1757065933.98
      },
      {
        "periodo": 202607,
        "valor": 379062216490.42,
        "delta": 6264043269.33
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 946253518.75,
    "valor_anterior": 995996636.59,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 24560443276.71,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18817974720.77,
        "delta": -5742468555.94
      },
      {
        "periodo": 202509,
        "valor": 18725344393.64,
        "delta": -92630327.13
      },
      {
        "periodo": 202510,
        "valor": 28906547228.09,
        "delta": 10181202834.45
      },
      {
        "periodo": 202511,
        "valor": 28769498829.85,
        "delta": -137048398.24
      },
      {
        "periodo": 202512,
        "valor": 28769914232.43,
        "delta": 415402.58
      },
      {
        "periodo": 202601,
        "valor": 28680340674.01,
        "delta": -89573558.42
      },
      {
        "periodo": 202602,
        "valor": 838030196.32,
        "delta": -27842310477.69
      },
      {
        "periodo": 202603,
        "valor": 869626927.97,
        "delta": 31596731.65
      },
      {
        "periodo": 202604,
        "valor": 896588559.72,
        "delta": 26961631.75
      },
      {
        "periodo": 202605,
        "valor": 986035835.63,
        "delta": 89447275.91
      },
      {
        "periodo": 202606,
        "valor": 995996636.59,
        "delta": 9960800.96
      },
      {
        "periodo": 202607,
        "valor": 946253518.75,
        "delta": -49743117.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 31787088943.08,
    "valor_anterior": 18263892689.36,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16414324881.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16549135657.23,
        "delta": 134810775.41
      },
      {
        "periodo": 202509,
        "valor": 17412576718.82,
        "delta": 863441061.59
      },
      {
        "periodo": 202510,
        "valor": 17657217884.52,
        "delta": 244641165.7
      },
      {
        "periodo": 202511,
        "valor": 18998154785.68,
        "delta": 1340936901.16
      },
      {
        "periodo": 202512,
        "valor": 17682174203.61,
        "delta": -1315980582.07
      },
      {
        "periodo": 202601,
        "valor": 16959582634.8,
        "delta": -722591568.81
      },
      {
        "periodo": 202602,
        "valor": 17375005919.22,
        "delta": 415423284.42
      },
      {
        "periodo": 202603,
        "valor": 17649691388.79,
        "delta": 274685469.57
      },
      {
        "periodo": 202604,
        "valor": 17691816814.0,
        "delta": 42125425.21
      },
      {
        "periodo": 202605,
        "valor": 18696739189.28,
        "delta": 1004922375.28
      },
      {
        "periodo": 202606,
        "valor": 18263892689.36,
        "delta": -432846499.92
      },
      {
        "periodo": 202607,
        "valor": 31787088943.08,
        "delta": 13523196253.72
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 47446200995.0,
    "valor_anterior": 62618988885.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 38195625261.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 38606443824.0,
        "delta": 410818563.0
      },
      {
        "periodo": 202509,
        "valor": 39128413544.0,
        "delta": 521969720.0
      },
      {
        "periodo": 202510,
        "valor": 39767812997.0,
        "delta": 639399453.0
      },
      {
        "periodo": 202511,
        "valor": 39733181194.0,
        "delta": -34631803.0
      },
      {
        "periodo": 202512,
        "valor": 47878159937.0,
        "delta": 8144978743.0
      },
      {
        "periodo": 202601,
        "valor": 47151313898.0,
        "delta": -726846039.0
      },
      {
        "periodo": 202602,
        "valor": 47156213464.0,
        "delta": 4899566.0
      },
      {
        "periodo": 202603,
        "valor": 47974017207.0,
        "delta": 817803743.0
      },
      {
        "periodo": 202604,
        "valor": 47549883093.0,
        "delta": -424134114.0
      },
      {
        "periodo": 202605,
        "valor": 69465454666.0,
        "delta": 21915571573.0
      },
      {
        "periodo": 202606,
        "valor": 62618988885.0,
        "delta": -6846465781.0
      },
      {
        "periodo": 202607,
        "valor": 47446200995.0,
        "delta": -15172787890.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 8746152815.0,
    "valor_anterior": 6430916208.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9639646031.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9486277038.0,
        "delta": -153368993.0
      },
      {
        "periodo": 202509,
        "valor": 9457702105.0,
        "delta": -28574933.0
      },
      {
        "periodo": 202510,
        "valor": 8209697086.0,
        "delta": -1248005019.0
      },
      {
        "periodo": 202511,
        "valor": 8021430981.0,
        "delta": -188266105.0
      },
      {
        "periodo": 202512,
        "valor": 10368195907.0,
        "delta": 2346764926.0
      },
      {
        "periodo": 202601,
        "valor": 7678763233.0,
        "delta": -2689432674.0
      },
      {
        "periodo": 202602,
        "valor": 7372616083.0,
        "delta": -306147150.0
      },
      {
        "periodo": 202603,
        "valor": 6771779319.0,
        "delta": -600836764.0
      },
      {
        "periodo": 202604,
        "valor": 6094848355.0,
        "delta": -676930964.0
      },
      {
        "periodo": 202605,
        "valor": 6561693290.0,
        "delta": 466844935.0
      },
      {
        "periodo": 202606,
        "valor": 6430916209.0,
        "delta": -130777081.0
      },
      {
        "periodo": 202607,
        "valor": 8746152815.0,
        "delta": 2315236606.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 50723339390.88,
    "valor_anterior": 50821021795.93,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 44417326815.84,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 44288780387.18,
        "delta": -128546428.66
      },
      {
        "periodo": 202509,
        "valor": 44447251290.04,
        "delta": 158470902.86
      },
      {
        "periodo": 202510,
        "valor": 45295616024.34,
        "delta": 848364734.3
      },
      {
        "periodo": 202511,
        "valor": 45858576402.5,
        "delta": 562960378.16
      },
      {
        "periodo": 202512,
        "valor": 52916458969.78,
        "delta": 7057882567.28
      },
      {
        "periodo": 202601,
        "valor": 51259774675.6,
        "delta": -1656684294.18
      },
      {
        "periodo": 202602,
        "valor": 50983060945.87,
        "delta": -276713729.73
      },
      {
        "periodo": 202603,
        "valor": 51855275323.89,
        "delta": 872214378.02
      },
      {
        "periodo": 202604,
        "valor": 48568392661.8,
        "delta": -3286882662.09
      },
      {
        "periodo": 202605,
        "valor": 49732847440.78,
        "delta": 1164454778.98
      },
      {
        "periodo": 202606,
        "valor": 50821021795.93,
        "delta": 1088174355.15
      },
      {
        "periodo": 202607,
        "valor": 50723339390.88,
        "delta": -97682405.05
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 18194199358.0,
    "valor_anterior": 18669595235.999996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27764475839.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 32157864081.0,
        "delta": 4393388242.0
      },
      {
        "periodo": 202509,
        "valor": 31757704032.0,
        "delta": -400160049.0
      },
      {
        "periodo": 202510,
        "valor": 31619328367.0,
        "delta": -138375665.0
      },
      {
        "periodo": 202511,
        "valor": 32679457065.0,
        "delta": 1060128698.0
      },
      {
        "periodo": 202512,
        "valor": 19376648453.0,
        "delta": -13302808612.0
      },
      {
        "periodo": 202601,
        "valor": 18894647079.0,
        "delta": -482001374.0
      },
      {
        "periodo": 202602,
        "valor": 18878958789.0,
        "delta": -15688290.0
      },
      {
        "periodo": 202603,
        "valor": 18853671590.0,
        "delta": -25287199.0
      },
      {
        "periodo": 202604,
        "valor": 18710792643.0,
        "delta": -142878947.0
      },
      {
        "periodo": 202605,
        "valor": 18707961394.0,
        "delta": -2831249.0
      },
      {
        "periodo": 202606,
        "valor": 18669595236.0,
        "delta": -38366158.0
      },
      {
        "periodo": 202607,
        "valor": 18194199358.0,
        "delta": -475395878.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 19862703661.0,
    "valor_anterior": 21509478264.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18815483590.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18603491142.0,
        "delta": -211992448.0
      },
      {
        "periodo": 202509,
        "valor": 16623723016.0,
        "delta": -1979768126.0
      },
      {
        "periodo": 202510,
        "valor": 18570571585.0,
        "delta": 1946848569.0
      },
      {
        "periodo": 202511,
        "valor": 23108490367.0,
        "delta": 4537918782.0
      },
      {
        "periodo": 202512,
        "valor": 25564059260.0,
        "delta": 2455568893.0
      },
      {
        "periodo": 202601,
        "valor": 28255505365.0,
        "delta": 2691446105.0
      },
      {
        "periodo": 202602,
        "valor": 28231534245.0,
        "delta": -23971120.0
      },
      {
        "periodo": 202603,
        "valor": 26489822085.0,
        "delta": -1741712160.0
      },
      {
        "periodo": 202604,
        "valor": 25146775273.0,
        "delta": -1343046812.0
      },
      {
        "periodo": 202605,
        "valor": 23639823081.0,
        "delta": -1506952192.0
      },
      {
        "periodo": 202606,
        "valor": 21509478264.0,
        "delta": -2130344817.0
      },
      {
        "periodo": 202607,
        "valor": 19862703661.0,
        "delta": -1646774603.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 46810305223.0,
    "valor_anterior": 42228069039.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 43918854326.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 44201873713.0,
        "delta": 283019387.0
      },
      {
        "periodo": 202509,
        "valor": 44865148902.0,
        "delta": 663275189.0
      },
      {
        "periodo": 202510,
        "valor": 48852271292.0,
        "delta": 3987122390.0
      },
      {
        "periodo": 202511,
        "valor": 57701213370.0,
        "delta": 8848942078.0
      },
      {
        "periodo": 202512,
        "valor": 47867322426.0,
        "delta": -9833890944.0
      },
      {
        "periodo": 202601,
        "valor": 47058929165.0,
        "delta": -808393261.0
      },
      {
        "periodo": 202602,
        "valor": 45700521574.0,
        "delta": -1358407591.0
      },
      {
        "periodo": 202603,
        "valor": 46084472102.0,
        "delta": 383950528.0
      },
      {
        "periodo": 202604,
        "valor": 41272839013.0,
        "delta": -4811633089.0
      },
      {
        "periodo": 202605,
        "valor": 43194619295.0,
        "delta": 1921780282.0
      },
      {
        "periodo": 202606,
        "valor": 42228069039.0,
        "delta": -966550256.0
      },
      {
        "periodo": 202607,
        "valor": 46810305223.0,
        "delta": 4582236184.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 4287876684.3,
    "valor_anterior": 3926418506.73,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3535839231.96,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3565805148.31,
        "delta": 29965916.35
      },
      {
        "periodo": 202509,
        "valor": 3553113113.42,
        "delta": -12692034.89
      },
      {
        "periodo": 202510,
        "valor": 3525707492.24,
        "delta": -27405621.18
      },
      {
        "periodo": 202511,
        "valor": 3515641624.75,
        "delta": -10065867.49
      },
      {
        "periodo": 202512,
        "valor": 3523578772.47,
        "delta": 7937147.72
      },
      {
        "periodo": 202601,
        "valor": 3515103059.92,
        "delta": -8475712.55
      },
      {
        "periodo": 202602,
        "valor": 4059943712.63,
        "delta": 544840652.71
      },
      {
        "periodo": 202603,
        "valor": 3734872362.78,
        "delta": -325071349.85
      },
      {
        "periodo": 202604,
        "valor": 3892286307.03,
        "delta": 157413944.25
      },
      {
        "periodo": 202605,
        "valor": 4064177208.9,
        "delta": 171890901.87
      },
      {
        "periodo": 202606,
        "valor": 3926418506.73,
        "delta": -137758702.17
      },
      {
        "periodo": 202607,
        "valor": 4287876684.3,
        "delta": 361458177.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 4111926305.0,
    "valor_anterior": 3791116644.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4422177385.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4298678266.0,
        "delta": -123499119.0
      },
      {
        "periodo": 202509,
        "valor": 4461578153.0,
        "delta": 162899887.0
      },
      {
        "periodo": 202510,
        "valor": 4353368086.0,
        "delta": -108210067.0
      },
      {
        "periodo": 202511,
        "valor": 4460747905.0,
        "delta": 107379819.0
      },
      {
        "periodo": 202512,
        "valor": 4216263870.0,
        "delta": -244484035.0
      },
      {
        "periodo": 202601,
        "valor": 4073857284.0,
        "delta": -142406586.0
      },
      {
        "periodo": 202602,
        "valor": 4477091866.0,
        "delta": 403234582.0
      },
      {
        "periodo": 202603,
        "valor": 4049062488.0,
        "delta": -428029378.0
      },
      {
        "periodo": 202604,
        "valor": 3949265720.0,
        "delta": -99796768.0
      },
      {
        "periodo": 202605,
        "valor": 3916880016.0,
        "delta": -32385704.0
      },
      {
        "periodo": 202606,
        "valor": 3791116644.0,
        "delta": -125763372.0
      },
      {
        "periodo": 202607,
        "valor": 4111926305.0,
        "delta": 320809661.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 128879477.0,
    "valor_anterior": 153702458.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 205423802.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 162417368.0,
        "delta": -43006434.0
      },
      {
        "periodo": 202509,
        "valor": 168344006.0,
        "delta": 5926638.0
      },
      {
        "periodo": 202510,
        "valor": 162512881.0,
        "delta": -5831125.0
      },
      {
        "periodo": 202511,
        "valor": 180573151.0,
        "delta": 18060270.0
      },
      {
        "periodo": 202512,
        "valor": 202094863.0,
        "delta": 21521712.0
      },
      {
        "periodo": 202601,
        "valor": 184487108.0,
        "delta": -17607755.0
      },
      {
        "periodo": 202602,
        "valor": 178677119.0,
        "delta": -5809989.0
      },
      {
        "periodo": 202603,
        "valor": 172657361.0,
        "delta": -6019758.0
      },
      {
        "periodo": 202604,
        "valor": 169165314.0,
        "delta": -3492047.0
      },
      {
        "periodo": 202605,
        "valor": 164992498.0,
        "delta": -4172816.0
      },
      {
        "periodo": 202606,
        "valor": 153702458.0,
        "delta": -11290040.0
      },
      {
        "periodo": 202607,
        "valor": 128879477.0,
        "delta": -24822981.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 1992109334.0,
    "valor_anterior": 2018315254.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2646004145.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2678805724.0,
        "delta": 32801579.0
      },
      {
        "periodo": 202509,
        "valor": 4009468651.0,
        "delta": 1330662927.0
      },
      {
        "periodo": 202510,
        "valor": 4291279851.0,
        "delta": 281811200.0
      },
      {
        "periodo": 202511,
        "valor": 3654215372.0,
        "delta": -637064479.0
      },
      {
        "periodo": 202512,
        "valor": 4469065566.0,
        "delta": 814850194.0
      },
      {
        "periodo": 202601,
        "valor": 3563860535.0,
        "delta": -905205031.0
      },
      {
        "periodo": 202602,
        "valor": 2942660392.0,
        "delta": -621200143.0
      },
      {
        "periodo": 202603,
        "valor": 2914937827.0,
        "delta": -27722565.0
      },
      {
        "periodo": 202604,
        "valor": 2083196301.0,
        "delta": -831741526.0
      },
      {
        "periodo": 202605,
        "valor": 2047064867.0,
        "delta": -36131434.0
      },
      {
        "periodo": 202606,
        "valor": 2018315254.0,
        "delta": -28749613.0
      },
      {
        "periodo": 202607,
        "valor": 1992109334.0,
        "delta": -26205920.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 8226591169.34,
    "valor_anterior": 8520236809.18,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8717605503.48,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7530105149.52,
        "delta": -1187500353.96
      },
      {
        "periodo": 202509,
        "valor": 7344888584.43,
        "delta": -185216565.09
      },
      {
        "periodo": 202510,
        "valor": 7318101939.77,
        "delta": -26786644.66
      },
      {
        "periodo": 202511,
        "valor": 7606033295.39,
        "delta": 287931355.62
      },
      {
        "periodo": 202512,
        "valor": 8122466979.55,
        "delta": 516433684.16
      },
      {
        "periodo": 202601,
        "valor": 8057339628.98,
        "delta": -65127350.57
      },
      {
        "periodo": 202602,
        "valor": 7801767378.76,
        "delta": -255572250.22
      },
      {
        "periodo": 202603,
        "valor": 7836835339.75,
        "delta": 35067960.99
      },
      {
        "periodo": 202604,
        "valor": 7667621405.12,
        "delta": -169213934.63
      },
      {
        "periodo": 202605,
        "valor": 7580667501.13,
        "delta": -86953903.99
      },
      {
        "periodo": 202606,
        "valor": 8520236809.18,
        "delta": 939569308.05
      },
      {
        "periodo": 202607,
        "valor": 8226591169.34,
        "delta": -293645639.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 7815382926.0,
    "valor_anterior": 13145717675.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8793441215.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11617407469.0,
        "delta": 2823966254.0
      },
      {
        "periodo": 202509,
        "valor": 15382835387.0,
        "delta": 3765427918.0
      },
      {
        "periodo": 202510,
        "valor": 6984406459.0,
        "delta": -8398428928.0
      },
      {
        "periodo": 202511,
        "valor": 7517678246.0,
        "delta": 533271787.0
      },
      {
        "periodo": 202512,
        "valor": 20252769907.0,
        "delta": 12735091661.0
      },
      {
        "periodo": 202601,
        "valor": 13575283661.0,
        "delta": -6677486246.0
      },
      {
        "periodo": 202602,
        "valor": 12930445765.0,
        "delta": -644837896.0
      },
      {
        "periodo": 202603,
        "valor": 12058367598.0,
        "delta": -872078167.0
      },
      {
        "periodo": 202604,
        "valor": 9799797303.0,
        "delta": -2258570295.0
      },
      {
        "periodo": 202605,
        "valor": 9726655554.0,
        "delta": -73141749.0
      },
      {
        "periodo": 202606,
        "valor": 13145717675.0,
        "delta": 3419062121.0
      },
      {
        "periodo": 202607,
        "valor": 7815382926.0,
        "delta": -5330334749.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 1916000586.08,
    "valor_anterior": 1880941843.95,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1562418719.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1533454751.82,
        "delta": -28963967.43
      },
      {
        "periodo": 202509,
        "valor": 1567759659.18,
        "delta": 34304907.36
      },
      {
        "periodo": 202510,
        "valor": 1592662005.42,
        "delta": 24902346.24
      },
      {
        "periodo": 202511,
        "valor": 2333994558.09,
        "delta": 741332552.67
      },
      {
        "periodo": 202512,
        "valor": 1720796544.73,
        "delta": -613198013.36
      },
      {
        "periodo": 202601,
        "valor": 1665602335.81,
        "delta": -55194208.92
      },
      {
        "periodo": 202602,
        "valor": 1750950420.05,
        "delta": 85348084.24
      },
      {
        "periodo": 202603,
        "valor": 1790620550.25,
        "delta": 39670130.2
      },
      {
        "periodo": 202604,
        "valor": 1898450976.64,
        "delta": 107830426.39
      },
      {
        "periodo": 202605,
        "valor": 2071714147.62,
        "delta": 173263170.98
      },
      {
        "periodo": 202606,
        "valor": 1880941843.95,
        "delta": -190772303.67
      },
      {
        "periodo": 202607,
        "valor": 1916000586.08,
        "delta": 35058742.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 5793840183.000001,
    "valor_anterior": 6319178270.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3715123507.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3376789127.0,
        "delta": -338334380.0
      },
      {
        "periodo": 202509,
        "valor": 4275771673.0,
        "delta": 898982546.0
      },
      {
        "periodo": 202510,
        "valor": 4367808164.0,
        "delta": 92036491.0
      },
      {
        "periodo": 202511,
        "valor": 5650631804.0,
        "delta": 1282823640.0
      },
      {
        "periodo": 202512,
        "valor": 5387830373.0,
        "delta": -262801431.0
      },
      {
        "periodo": 202601,
        "valor": 4171955979.0,
        "delta": -1215874394.0
      },
      {
        "periodo": 202602,
        "valor": 4053716204.0,
        "delta": -118239775.0
      },
      {
        "periodo": 202603,
        "valor": 5955816669.0,
        "delta": 1902100465.0
      },
      {
        "periodo": 202604,
        "valor": 6023861085.0,
        "delta": 68044416.0
      },
      {
        "periodo": 202605,
        "valor": 7120713709.0,
        "delta": 1096852624.0
      },
      {
        "periodo": 202606,
        "valor": 6319178270.0,
        "delta": -801535439.0
      },
      {
        "periodo": 202607,
        "valor": 5793840183.0,
        "delta": -525338087.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 79813463672.0,
    "valor_anterior": 36881053385.43,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 56621041957.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 56263023394.62,
        "delta": -358018562.91
      },
      {
        "periodo": 202509,
        "valor": 46012732175.72,
        "delta": -10250291218.9
      },
      {
        "periodo": 202510,
        "valor": 46462510608.12,
        "delta": 449778432.4
      },
      {
        "periodo": 202511,
        "valor": 45944996911.57,
        "delta": -517513696.55
      },
      {
        "periodo": 202512,
        "valor": 37959040387.43,
        "delta": -7985956524.14
      },
      {
        "periodo": 202601,
        "valor": 36716579609.72,
        "delta": -1242460777.71
      },
      {
        "periodo": 202602,
        "valor": 36306047293.77,
        "delta": -410532315.95
      },
      {
        "periodo": 202603,
        "valor": 37780768398.34,
        "delta": 1474721104.57
      },
      {
        "periodo": 202604,
        "valor": 36818722662.72,
        "delta": -962045735.62
      },
      {
        "periodo": 202605,
        "valor": 36550310830.16,
        "delta": -268411832.56
      },
      {
        "periodo": 202606,
        "valor": 36881053385.43,
        "delta": 330742555.27
      },
      {
        "periodo": 202607,
        "valor": 79813463672.0,
        "delta": 42932410286.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 99580730.36,
        "delta": 99580730.36
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": -99580730.36
      },
      {
        "periodo": 202601,
        "valor": 450173750.0,
        "delta": 450173750.0
      },
      {
        "periodo": 202602,
        "valor": 450173750.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": -450173750.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 3512534.0,
    "valor_anterior": 3507654.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 3507654.0,
        "delta": 3507654.0
      },
      {
        "periodo": 202607,
        "valor": 3512534.0,
        "delta": 4880.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 259838005.0,
    "valor_anterior": 1417818824.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1486527785.0,
        "delta": 1486527785.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": -1486527785.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 2335006298.0,
        "delta": 2335006298.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -2335006298.0
      },
      {
        "periodo": 202603,
        "valor": 2171911284.0,
        "delta": 2171911284.0
      },
      {
        "periodo": 202604,
        "valor": 1398863981.0,
        "delta": -773047303.0
      },
      {
        "periodo": 202605,
        "valor": 6296870686.0,
        "delta": 4898006705.0
      },
      {
        "periodo": 202606,
        "valor": 1417818824.0,
        "delta": -4879051862.0
      },
      {
        "periodo": 202607,
        "valor": 259838005.0,
        "delta": -1157980819.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 20715133118.0,
    "valor_anterior": 20715255592.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21587417126.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 22734821492.0,
        "delta": 1147404366.0
      },
      {
        "periodo": 202509,
        "valor": 22713879045.0,
        "delta": -20942447.0
      },
      {
        "periodo": 202510,
        "valor": 21511931384.0,
        "delta": -1201947661.0
      },
      {
        "periodo": 202511,
        "valor": 21501026967.0,
        "delta": -10904417.0
      },
      {
        "periodo": 202512,
        "valor": 21712405853.0,
        "delta": 211378886.0
      },
      {
        "periodo": 202601,
        "valor": 21204504972.0,
        "delta": -507900881.0
      },
      {
        "periodo": 202602,
        "valor": 21269480332.0,
        "delta": 64975360.0
      },
      {
        "periodo": 202603,
        "valor": 20989477644.0,
        "delta": -280002688.0
      },
      {
        "periodo": 202604,
        "valor": 20869900099.0,
        "delta": -119577545.0
      },
      {
        "periodo": 202605,
        "valor": 21004542332.0,
        "delta": 134642233.0
      },
      {
        "periodo": 202606,
        "valor": 20715255592.0,
        "delta": -289286740.0
      },
      {
        "periodo": 202607,
        "valor": 20715133118.0,
        "delta": -122474.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 14248395398.000002,
    "valor_anterior": 10258501947.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8835420617.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9074525114.0,
        "delta": 239104497.0
      },
      {
        "periodo": 202509,
        "valor": 9114445902.0,
        "delta": 39920788.0
      },
      {
        "periodo": 202510,
        "valor": 6510296312.0,
        "delta": -2604149590.0
      },
      {
        "periodo": 202511,
        "valor": 4790056479.0,
        "delta": -1720239833.0
      },
      {
        "periodo": 202512,
        "valor": 10798923408.0,
        "delta": 6008866929.0
      },
      {
        "periodo": 202601,
        "valor": 10494280562.0,
        "delta": -304642846.0
      },
      {
        "periodo": 202602,
        "valor": 9810611326.0,
        "delta": -683669236.0
      },
      {
        "periodo": 202603,
        "valor": 7555013964.0,
        "delta": -2255597362.0
      },
      {
        "periodo": 202604,
        "valor": 8648511952.0,
        "delta": 1093497988.0
      },
      {
        "periodo": 202605,
        "valor": 8593664749.0,
        "delta": -54847203.0
      },
      {
        "periodo": 202606,
        "valor": 10258501947.0,
        "delta": 1664837198.0
      },
      {
        "periodo": 202607,
        "valor": 14248395398.0,
        "delta": 3989893451.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 532046272.0,
    "valor_anterior": 493182041.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 184681160.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 194341992.0,
        "delta": 9660832.0
      },
      {
        "periodo": 202509,
        "valor": 195752161.0,
        "delta": 1410169.0
      },
      {
        "periodo": 202510,
        "valor": 181286898.0,
        "delta": -14465263.0
      },
      {
        "periodo": 202511,
        "valor": 248943179.0,
        "delta": 67656281.0
      },
      {
        "periodo": 202512,
        "valor": 277225847.0,
        "delta": 28282668.0
      },
      {
        "periodo": 202601,
        "valor": 267966726.0,
        "delta": -9259121.0
      },
      {
        "periodo": 202602,
        "valor": 263441119.0,
        "delta": -4525607.0
      },
      {
        "periodo": 202603,
        "valor": 334618682.0,
        "delta": 71177563.0
      },
      {
        "periodo": 202604,
        "valor": 340019742.0,
        "delta": 5401060.0
      },
      {
        "periodo": 202605,
        "valor": 285032627.0,
        "delta": -54987115.0
      },
      {
        "periodo": 202606,
        "valor": 493182041.0,
        "delta": 208149414.0
      },
      {
        "periodo": 202607,
        "valor": 532046272.0,
        "delta": 38864231.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15792746.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -15792746.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": 1.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -1.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 3789038251.22,
    "valor_anterior": 3923480240.56,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4883148839.64,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4801569936.96,
        "delta": -81578902.68
      },
      {
        "periodo": 202509,
        "valor": 3903494279.28,
        "delta": -898075657.68
      },
      {
        "periodo": 202510,
        "valor": 4712796926.1,
        "delta": 809302646.82
      },
      {
        "periodo": 202511,
        "valor": 5225423181.8,
        "delta": 512626255.7
      },
      {
        "periodo": 202512,
        "valor": 4849098319.16,
        "delta": -376324862.64
      },
      {
        "periodo": 202601,
        "valor": 4708576366.13,
        "delta": -140521953.03
      },
      {
        "periodo": 202602,
        "valor": 4449838879.67,
        "delta": -258737486.46
      },
      {
        "periodo": 202603,
        "valor": 4727573558.87,
        "delta": 277734679.2
      },
      {
        "periodo": 202604,
        "valor": 4238240539.9,
        "delta": -489333018.97
      },
      {
        "periodo": 202605,
        "valor": 4103238924.56,
        "delta": -135001615.34
      },
      {
        "periodo": 202606,
        "valor": 3923480240.56,
        "delta": -179758684.0
      },
      {
        "periodo": 202607,
        "valor": 3789038251.22,
        "delta": -134441989.34
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 465000000.0,
    "valor_anterior": 465000000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 400069472.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 403137881.0,
        "delta": 3068409.0
      },
      {
        "periodo": 202509,
        "valor": 465000000.0,
        "delta": 61862119.0
      },
      {
        "periodo": 202510,
        "valor": 465000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 468259024.0,
        "delta": 3259024.0
      },
      {
        "periodo": 202512,
        "valor": 465000000.0,
        "delta": -3259024.0
      },
      {
        "periodo": 202601,
        "valor": 466803692.0,
        "delta": 1803692.0
      },
      {
        "periodo": 202602,
        "valor": 468091840.0,
        "delta": 1288148.0
      },
      {
        "periodo": 202603,
        "valor": 468259579.0,
        "delta": 167739.0
      },
      {
        "periodo": 202604,
        "valor": 465011513.0,
        "delta": -3248066.0
      },
      {
        "periodo": 202605,
        "valor": 468088140.0,
        "delta": 3076627.0
      },
      {
        "periodo": 202606,
        "valor": 465000000.0,
        "delta": -3088140.0
      },
      {
        "periodo": 202607,
        "valor": 465000000.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 2208548000.0,
    "valor_anterior": 2207075372.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3712204244.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3713507866.0,
        "delta": 1303622.0
      },
      {
        "periodo": 202509,
        "valor": 2255985077.0,
        "delta": -1457522789.0
      },
      {
        "periodo": 202510,
        "valor": 2257506043.0,
        "delta": 1520966.0
      },
      {
        "periodo": 202511,
        "valor": 2258332023.0,
        "delta": 825980.0
      },
      {
        "periodo": 202512,
        "valor": 1953622884.0,
        "delta": -304709139.0
      },
      {
        "periodo": 202601,
        "valor": 1954836680.0,
        "delta": 1213796.0
      },
      {
        "periodo": 202602,
        "valor": 2306653783.0,
        "delta": 351817103.0
      },
      {
        "periodo": 202603,
        "valor": 2408279871.0,
        "delta": 101626088.0
      },
      {
        "periodo": 202604,
        "valor": 2406931011.0,
        "delta": -1348860.0
      },
      {
        "periodo": 202605,
        "valor": 2407926421.0,
        "delta": 995410.0
      },
      {
        "periodo": 202606,
        "valor": 2207075372.0,
        "delta": -200851049.0
      },
      {
        "periodo": 202607,
        "valor": 2208548000.0,
        "delta": 1472628.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 91792500.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2089460099.0,
        "delta": 1997667599.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 36817567.0,
    "valor_anterior": 40575292.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 85445002.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 93390212.0,
        "delta": 7945210.0
      },
      {
        "periodo": 202509,
        "valor": 89472244.0,
        "delta": -3917968.0
      },
      {
        "periodo": 202510,
        "valor": 78150217.0,
        "delta": -11322027.0
      },
      {
        "periodo": 202511,
        "valor": 89713257.0,
        "delta": 11563040.0
      },
      {
        "periodo": 202512,
        "valor": 90299834.0,
        "delta": 586577.0
      },
      {
        "periodo": 202601,
        "valor": 73906021.0,
        "delta": -16393813.0
      },
      {
        "periodo": 202602,
        "valor": 71688892.0,
        "delta": -2217129.0
      },
      {
        "periodo": 202603,
        "valor": 77011392.0,
        "delta": 5322500.0
      },
      {
        "periodo": 202604,
        "valor": 80579879.0,
        "delta": 3568487.0
      },
      {
        "periodo": 202605,
        "valor": 61601726.0,
        "delta": -18978153.0
      },
      {
        "periodo": 202606,
        "valor": 40575292.0,
        "delta": -21026434.0
      },
      {
        "periodo": 202607,
        "valor": 36817567.0,
        "delta": -3757725.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 14324177.0,
    "valor_anterior": 14112330.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25298343.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26162714.0,
        "delta": 864371.0
      },
      {
        "periodo": 202509,
        "valor": 18655485.0,
        "delta": -7507229.0
      },
      {
        "periodo": 202510,
        "valor": 18749036.0,
        "delta": 93551.0
      },
      {
        "periodo": 202511,
        "valor": 18532511.0,
        "delta": -216525.0
      },
      {
        "periodo": 202512,
        "valor": 19110704.0,
        "delta": 578193.0
      },
      {
        "periodo": 202601,
        "valor": 12860688.0,
        "delta": -6250016.0
      },
      {
        "periodo": 202602,
        "valor": 12962844.0,
        "delta": 102156.0
      },
      {
        "periodo": 202603,
        "valor": 13454142.0,
        "delta": 491298.0
      },
      {
        "periodo": 202604,
        "valor": 13565995.0,
        "delta": 111853.0
      },
      {
        "periodo": 202605,
        "valor": 13880488.0,
        "delta": 314493.0
      },
      {
        "periodo": 202606,
        "valor": 14112330.0,
        "delta": 231842.0
      },
      {
        "periodo": 202607,
        "valor": 14324177.0,
        "delta": 211847.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 1320825651.65,
    "valor_anterior": 1192039989.48,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1337609584.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1371174466.84,
        "delta": 33564882.34
      },
      {
        "periodo": 202509,
        "valor": 1276622043.33,
        "delta": -94552423.51
      },
      {
        "periodo": 202510,
        "valor": 1198511062.98,
        "delta": -78110980.35
      },
      {
        "periodo": 202511,
        "valor": 1189502568.98,
        "delta": -9008494.0
      },
      {
        "periodo": 202512,
        "valor": 943088829.45,
        "delta": -246413739.53
      },
      {
        "periodo": 202601,
        "valor": 964952250.01,
        "delta": 21863420.56
      },
      {
        "periodo": 202602,
        "valor": 980999007.16,
        "delta": 16046757.15
      },
      {
        "periodo": 202603,
        "valor": 1067872097.72,
        "delta": 86873090.56
      },
      {
        "periodo": 202604,
        "valor": 901459782.69,
        "delta": -166412315.03
      },
      {
        "periodo": 202605,
        "valor": 802019310.24,
        "delta": -99440472.45
      },
      {
        "periodo": 202606,
        "valor": 1192039989.48,
        "delta": 390020679.24
      },
      {
        "periodo": 202607,
        "valor": 1320825651.65,
        "delta": 128785662.17
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 9929249352.62,
    "valor_anterior": 8990968624.01,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6957456928.49,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7936704255.01,
        "delta": 979247326.52
      },
      {
        "periodo": 202509,
        "valor": 7053577927.58,
        "delta": -883126327.43
      },
      {
        "periodo": 202510,
        "valor": 7732077742.64,
        "delta": 678499815.06
      },
      {
        "periodo": 202511,
        "valor": 8922112772.48,
        "delta": 1190035029.84
      },
      {
        "periodo": 202512,
        "valor": 10691694654.72,
        "delta": 1769581882.24
      },
      {
        "periodo": 202601,
        "valor": 10051026820.19,
        "delta": -640667834.53
      },
      {
        "periodo": 202602,
        "valor": 9518802070.04,
        "delta": -532224750.15
      },
      {
        "periodo": 202603,
        "valor": 10269792626.18,
        "delta": 750990556.14
      },
      {
        "periodo": 202604,
        "valor": 9900042281.33,
        "delta": -369750344.85
      },
      {
        "periodo": 202605,
        "valor": 9473858101.55,
        "delta": -426184179.78
      },
      {
        "periodo": 202606,
        "valor": 8990968624.01,
        "delta": -482889477.54
      },
      {
        "periodo": 202607,
        "valor": 9929249352.62,
        "delta": 938280728.61
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 1417234830.06,
    "valor_anterior": 1458060866.95,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2261116730.95,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2090403271.97,
        "delta": -170713458.98
      },
      {
        "periodo": 202509,
        "valor": 1901982516.41,
        "delta": -188420755.56
      },
      {
        "periodo": 202510,
        "valor": 1818965590.12,
        "delta": -83016926.29
      },
      {
        "periodo": 202511,
        "valor": 1744986232.51,
        "delta": -73979357.61
      },
      {
        "periodo": 202512,
        "valor": 1558032995.57,
        "delta": -186953236.94
      },
      {
        "periodo": 202601,
        "valor": 1460300916.58,
        "delta": -97732078.99
      },
      {
        "periodo": 202602,
        "valor": 1430195930.56,
        "delta": -30104986.02
      },
      {
        "periodo": 202603,
        "valor": 1702218615.08,
        "delta": 272022684.52
      },
      {
        "periodo": 202604,
        "valor": 1648230537.52,
        "delta": -53988077.56
      },
      {
        "periodo": 202605,
        "valor": 1596872228.83,
        "delta": -51358308.69
      },
      {
        "periodo": 202606,
        "valor": 1458060866.95,
        "delta": -138811361.88
      },
      {
        "periodo": 202607,
        "valor": 1417234830.06,
        "delta": -40826036.89
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 1235239005.0,
    "valor_anterior": 1088953790.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1456323587.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1442119311.0,
        "delta": -14204276.0
      },
      {
        "periodo": 202509,
        "valor": 1418166211.0,
        "delta": -23953100.0
      },
      {
        "periodo": 202510,
        "valor": 1440506737.0,
        "delta": 22340526.0
      },
      {
        "periodo": 202511,
        "valor": 1190665142.0,
        "delta": -249841595.0
      },
      {
        "periodo": 202512,
        "valor": 1702265910.0,
        "delta": 511600768.0
      },
      {
        "periodo": 202601,
        "valor": 1665108685.0,
        "delta": -37157225.0
      },
      {
        "periodo": 202602,
        "valor": 1205280105.0,
        "delta": -459828580.0
      },
      {
        "periodo": 202603,
        "valor": 939606542.0,
        "delta": -265673563.0
      },
      {
        "periodo": 202604,
        "valor": 916838415.0,
        "delta": -22768127.0
      },
      {
        "periodo": 202605,
        "valor": 905729562.0,
        "delta": -11108853.0
      },
      {
        "periodo": 202606,
        "valor": 1088953790.0,
        "delta": 183224228.0
      },
      {
        "periodo": 202607,
        "valor": 1235239005.0,
        "delta": 146285215.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 55845331873.0,
    "valor_anterior": 54544370070.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 54334960611.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 54074462850.0,
        "delta": -260497761.0
      },
      {
        "periodo": 202509,
        "valor": 51397130554.0,
        "delta": -2677332296.0
      },
      {
        "periodo": 202510,
        "valor": 53403863986.0,
        "delta": 2006733432.0
      },
      {
        "periodo": 202511,
        "valor": 54430853380.0,
        "delta": 1026989394.0
      },
      {
        "periodo": 202512,
        "valor": 59619501695.0,
        "delta": 5188648315.0
      },
      {
        "periodo": 202601,
        "valor": 56975334705.0,
        "delta": -2644166990.0
      },
      {
        "periodo": 202602,
        "valor": 58597273384.0,
        "delta": 1621938679.0
      },
      {
        "periodo": 202603,
        "valor": 61777352204.0,
        "delta": 3180078820.0
      },
      {
        "periodo": 202604,
        "valor": 61462425477.0,
        "delta": -314926727.0
      },
      {
        "periodo": 202605,
        "valor": 56969727214.0,
        "delta": -4492698263.0
      },
      {
        "periodo": 202606,
        "valor": 54544370070.0,
        "delta": -2425357144.0
      },
      {
        "periodo": 202607,
        "valor": 55845331873.0,
        "delta": 1300961803.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 2787723154.0,
    "valor_anterior": 2865253361.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3388978004.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3351237712.0,
        "delta": -37740292.0
      },
      {
        "periodo": 202509,
        "valor": 3191467145.0,
        "delta": -159770567.0
      },
      {
        "periodo": 202510,
        "valor": 3099012796.0,
        "delta": -92454349.0
      },
      {
        "periodo": 202511,
        "valor": 2937329862.0,
        "delta": -161682934.0
      },
      {
        "periodo": 202512,
        "valor": 2980729878.0,
        "delta": 43400016.0
      },
      {
        "periodo": 202601,
        "valor": 2862368900.0,
        "delta": -118360978.0
      },
      {
        "periodo": 202602,
        "valor": 2765508169.0,
        "delta": -96860731.0
      },
      {
        "periodo": 202603,
        "valor": 2795490284.0,
        "delta": 29982115.0
      },
      {
        "periodo": 202604,
        "valor": 2529117522.0,
        "delta": -266372762.0
      },
      {
        "periodo": 202605,
        "valor": 2634921573.0,
        "delta": 105804051.0
      },
      {
        "periodo": 202606,
        "valor": 2865253361.0,
        "delta": 230331788.0
      },
      {
        "periodo": 202607,
        "valor": 2787723154.0,
        "delta": -77530207.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 151010754.93,
    "valor_anterior": 158286844.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 698579507.88,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 694480014.36,
        "delta": -4099493.52
      },
      {
        "periodo": 202509,
        "valor": 721786456.68,
        "delta": 27306442.32
      },
      {
        "periodo": 202510,
        "valor": 717597882.59,
        "delta": -4188574.09
      },
      {
        "periodo": 202511,
        "valor": 712111782.58,
        "delta": -5486100.01
      },
      {
        "periodo": 202512,
        "valor": 199816574.37,
        "delta": -512295208.21
      },
      {
        "periodo": 202601,
        "valor": 188950619.53,
        "delta": -10865954.84
      },
      {
        "periodo": 202602,
        "valor": 181292463.48,
        "delta": -7658156.05
      },
      {
        "periodo": 202603,
        "valor": 180074508.44,
        "delta": -1217955.04
      },
      {
        "periodo": 202604,
        "valor": 170579644.46,
        "delta": -9494863.98
      },
      {
        "periodo": 202605,
        "valor": 163548345.97,
        "delta": -7031298.49
      },
      {
        "periodo": 202606,
        "valor": 158286844.25,
        "delta": -5261501.72
      },
      {
        "periodo": 202607,
        "valor": 151010754.93,
        "delta": -7276089.32
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 4874267409.12,
    "valor_anterior": 5905003954.48,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5155141386.55,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4715283788.91,
        "delta": -439857597.64
      },
      {
        "periodo": 202509,
        "valor": 4490044351.0,
        "delta": -225239437.91
      },
      {
        "periodo": 202510,
        "valor": 3662744283.08,
        "delta": -827300067.92
      },
      {
        "periodo": 202511,
        "valor": 4046541017.88,
        "delta": 383796734.8
      },
      {
        "periodo": 202512,
        "valor": 4304404158.0,
        "delta": 257863140.12
      },
      {
        "periodo": 202601,
        "valor": 4909441855.26,
        "delta": 605037697.26
      },
      {
        "periodo": 202602,
        "valor": 4689138982.87,
        "delta": -220302872.39
      },
      {
        "periodo": 202603,
        "valor": 3643603046.17,
        "delta": -1045535936.7
      },
      {
        "periodo": 202604,
        "valor": 4323048531.32,
        "delta": 679445485.15
      },
      {
        "periodo": 202605,
        "valor": 6091893592.69,
        "delta": 1768845061.37
      },
      {
        "periodo": 202606,
        "valor": 5905003954.48,
        "delta": -186889638.21
      },
      {
        "periodo": 202607,
        "valor": 4874267409.12,
        "delta": -1030736545.36
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 59427.0,
        "delta": 59427.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -59427.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 27349.0,
        "delta": 27349.0
      },
      {
        "periodo": 202605,
        "valor": 49100.0,
        "delta": 21751.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": -49100.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 3639430464.0,
    "valor_anterior": 3644545605.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3801967515.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3546657261.0,
        "delta": -255310254.0
      },
      {
        "periodo": 202509,
        "valor": 3468520808.0,
        "delta": -78136453.0
      },
      {
        "periodo": 202510,
        "valor": 3616894953.0,
        "delta": 148374145.0
      },
      {
        "periodo": 202511,
        "valor": 3700692584.0,
        "delta": 83797631.0
      },
      {
        "periodo": 202512,
        "valor": 3636085695.0,
        "delta": -64606889.0
      },
      {
        "periodo": 202601,
        "valor": 3468632944.0,
        "delta": -167452751.0
      },
      {
        "periodo": 202602,
        "valor": 3485841582.0,
        "delta": 17208638.0
      },
      {
        "periodo": 202603,
        "valor": 3629108278.0,
        "delta": 143266696.0
      },
      {
        "periodo": 202604,
        "valor": 3558592592.0,
        "delta": -70515686.0
      },
      {
        "periodo": 202605,
        "valor": 3447226473.0,
        "delta": -111366119.0
      },
      {
        "periodo": 202606,
        "valor": 3644545605.0,
        "delta": 197319132.0
      },
      {
        "periodo": 202607,
        "valor": 3639430464.0,
        "delta": -5115141.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 5157930179.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": -5157930179.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 462075280058.03,
    "valor_anterior": 417560631998.9,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 433158659392.6,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 436091767199.5,
        "delta": 2933107806.9
      },
      {
        "periodo": 202509,
        "valor": 422870337610.53,
        "delta": -13221429588.97
      },
      {
        "periodo": 202510,
        "valor": 431849839585.01,
        "delta": 8979501974.48
      },
      {
        "periodo": 202511,
        "valor": 449309178557.42,
        "delta": 17459338972.41
      },
      {
        "periodo": 202512,
        "valor": 462078207318.27,
        "delta": 12769028760.85
      },
      {
        "periodo": 202601,
        "valor": 445977959377.54,
        "delta": -16100247940.73
      },
      {
        "periodo": 202602,
        "valor": 412994515827.4,
        "delta": -32983443550.14
      },
      {
        "periodo": 202603,
        "valor": 422750943035.23,
        "delta": 9756427207.83
      },
      {
        "periodo": 202604,
        "valor": 402106290331.25,
        "delta": -20644652703.98
      },
      {
        "periodo": 202605,
        "valor": 429549042118.34,
        "delta": 27442751787.09
      },
      {
        "periodo": 202606,
        "valor": 417560631998.9,
        "delta": -11988410119.44
      },
      {
        "periodo": 202607,
        "valor": 462075280058.03,
        "delta": 44514648059.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 162156792022.17,
    "valor_anterior": 157727695504.13,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 169210975119.01,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 167349674183.52,
        "delta": -1861300935.49
      },
      {
        "periodo": 202509,
        "valor": 168691778279.89,
        "delta": 1342104096.37
      },
      {
        "periodo": 202510,
        "valor": 182330976794.38,
        "delta": 13639198514.49
      },
      {
        "periodo": 202511,
        "valor": 193508969520.92,
        "delta": 11177992726.54
      },
      {
        "periodo": 202512,
        "valor": 180064882138.59,
        "delta": -13444087382.33
      },
      {
        "periodo": 202601,
        "valor": 174480916312.79,
        "delta": -5583965825.8
      },
      {
        "periodo": 202602,
        "valor": 145123113404.3,
        "delta": -29357802908.49
      },
      {
        "periodo": 202603,
        "valor": 146040093874.51,
        "delta": 916980470.21
      },
      {
        "periodo": 202604,
        "valor": 139884389882.84,
        "delta": -6155703991.67
      },
      {
        "periodo": 202605,
        "valor": 165193171171.04,
        "delta": 25308781288.2
      },
      {
        "periodo": 202606,
        "valor": 157727695504.13,
        "delta": -7465475666.91
      },
      {
        "periodo": 202607,
        "valor": 162156792022.17,
        "delta": 4429096518.04
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 1952818153.08,
    "valor_anterior": 1921517135.95,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1755448967.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3716305062.82,
        "delta": 1960856095.57
      },
      {
        "periodo": 202509,
        "valor": 1657231903.18,
        "delta": -2059073159.64
      },
      {
        "periodo": 202510,
        "valor": 1670812222.42,
        "delta": 13580319.24
      },
      {
        "periodo": 202511,
        "valor": 2423707815.09,
        "delta": 752895592.67
      },
      {
        "periodo": 202512,
        "valor": 1811096378.73,
        "delta": -612611436.36
      },
      {
        "periodo": 202601,
        "valor": 1739508357.81,
        "delta": -71588020.92
      },
      {
        "periodo": 202602,
        "valor": 1822639312.05,
        "delta": 83130954.24
      },
      {
        "periodo": 202603,
        "valor": 1867631942.25,
        "delta": 44992630.2
      },
      {
        "periodo": 202604,
        "valor": 1979030855.64,
        "delta": 111398913.39
      },
      {
        "periodo": 202605,
        "valor": 2133315873.62,
        "delta": 154285017.98
      },
      {
        "periodo": 202606,
        "valor": 1921517135.95,
        "delta": -211798737.67
      },
      {
        "periodo": 202607,
        "valor": 1952818153.08,
        "delta": 31301017.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 93992720242.0,
    "valor_anterior": 57254021782.43,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 72482664702.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 74857914853.62,
        "delta": 2375250151.09
      },
      {
        "periodo": 202509,
        "valor": 69866614366.72,
        "delta": -4991300486.9
      },
      {
        "periodo": 202510,
        "valor": 63578092789.12,
        "delta": -6288521577.6
      },
      {
        "periodo": 202511,
        "valor": 61577638434.57,
        "delta": -2000454354.55
      },
      {
        "periodo": 202512,
        "valor": 66897199157.43,
        "delta": 5319560722.86
      },
      {
        "periodo": 202601,
        "valor": 60264587387.72,
        "delta": -6632611769.71
      },
      {
        "periodo": 202602,
        "valor": 56656245316.77,
        "delta": -3608342070.95
      },
      {
        "periodo": 202603,
        "valor": 58975047595.34,
        "delta": 2318802278.57
      },
      {
        "periodo": 202604,
        "valor": 54049873316.72,
        "delta": -4925174278.62
      },
      {
        "periodo": 202605,
        "valor": 58537831053.16,
        "delta": 4487957736.44
      },
      {
        "periodo": 202606,
        "valor": 57254021782.43,
        "delta": -1283809270.73
      },
      {
        "periodo": 202607,
        "valor": 93992720242.0,
        "delta": 36738698459.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 150761487190.18,
    "valor_anterior": 147378968853.66,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 133654154372.8,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 132983853768.49,
        "delta": -670300604.31
      },
      {
        "periodo": 202509,
        "valor": 129411435548.46,
        "delta": -3572418220.03
      },
      {
        "periodo": 202510,
        "valor": 131673863563.58,
        "delta": 2262428015.12
      },
      {
        "periodo": 202511,
        "valor": 137354250057.25,
        "delta": 5680386493.67
      },
      {
        "periodo": 202512,
        "valor": 157810352478.25,
        "delta": 20456102421.0
      },
      {
        "periodo": 202601,
        "valor": 154671954346.52,
        "delta": -3138398131.73
      },
      {
        "periodo": 202602,
        "valor": 155736139817.5,
        "delta": 1064185470.98
      },
      {
        "periodo": 202603,
        "valor": 157368152608.67,
        "delta": 1632012791.17
      },
      {
        "periodo": 202604,
        "valor": 153742252755.83,
        "delta": -3625899852.84
      },
      {
        "periodo": 202605,
        "valor": 150120953402.68,
        "delta": -3621299353.15
      },
      {
        "periodo": 202606,
        "valor": 147378968853.66,
        "delta": -2741984549.02
      },
      {
        "periodo": 202607,
        "valor": 150761487190.18,
        "delta": 3382518336.52
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 26033743081.38,
    "valor_anterior": 25967617518.17,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25472576549.37,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25530982155.09,
        "delta": 58405605.72
      },
      {
        "periodo": 202509,
        "valor": 23904919111.0,
        "delta": -1626063044.09
      },
      {
        "periodo": 202510,
        "valor": 23648859862.41,
        "delta": -256059248.59
      },
      {
        "periodo": 202511,
        "valor": 24891990803.43,
        "delta": 1243130941.02
      },
      {
        "periodo": 202512,
        "valor": 26514550109.11,
        "delta": 1622559305.68
      },
      {
        "periodo": 202601,
        "valor": 26036097512.57,
        "delta": -478452596.54
      },
      {
        "periodo": 202602,
        "valor": 24712139392.11,
        "delta": -1323958120.46
      },
      {
        "periodo": 202603,
        "valor": 24748496182.59,
        "delta": 36356790.48
      },
      {
        "periodo": 202604,
        "valor": 24470660357.32,
        "delta": -277835825.27
      },
      {
        "periodo": 202605,
        "valor": 25579974800.28,
        "delta": 1109314442.96
      },
      {
        "periodo": 202606,
        "valor": 25967617518.17,
        "delta": 387642717.89
      },
      {
        "periodo": 202607,
        "valor": 26033743081.38,
        "delta": 66125563.21
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100086,
    "label": "Préstamos Interb. y otros",
    "valor_actual": 27177719369.22,
    "valor_anterior": 27310811204.56,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30582839681.64,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 31653037175.96,
        "delta": 1070197494.32
      },
      {
        "periodo": 202509,
        "valor": 29338358401.28,
        "delta": -2314678774.68
      },
      {
        "periodo": 202510,
        "valor": 28947234353.1,
        "delta": -391124048.18
      },
      {
        "periodo": 202511,
        "valor": 29552621926.16,
        "delta": 605387573.06
      },
      {
        "periodo": 202512,
        "valor": 28980127056.16,
        "delta": -572494870.0
      },
      {
        "periodo": 202601,
        "valor": 28784895460.13,
        "delta": -195231596.03
      },
      {
        "periodo": 202602,
        "valor": 28944238584.67,
        "delta": 159343124.54
      },
      {
        "periodo": 202603,
        "valor": 33751520831.87,
        "delta": 4807282247.2
      },
      {
        "periodo": 202604,
        "valor": 27980083162.9,
        "delta": -5771437668.97
      },
      {
        "periodo": 202605,
        "valor": 27983795817.56,
        "delta": 3712654.66
      },
      {
        "periodo": 202606,
        "valor": 27310811204.56,
        "delta": -672984613.0
      },
      {
        "periodo": 202607,
        "valor": 27177719369.22,
        "delta": -133091835.34
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 788644285.57,
    "valor_anterior": 828065807.84,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18406578993.78,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18371671732.85,
        "delta": -34907260.93
      },
      {
        "periodo": 202509,
        "valor": 18371151516.72,
        "delta": -520216.13
      },
      {
        "periodo": 202510,
        "valor": 28513673249.3,
        "delta": 10142521732.58
      },
      {
        "periodo": 202511,
        "valor": 28597563222.91,
        "delta": 83889973.61
      },
      {
        "periodo": 202512,
        "valor": 28600343899.16,
        "delta": 2780676.25
      },
      {
        "periodo": 202601,
        "valor": 28506411741.5,
        "delta": -93932157.66
      },
      {
        "periodo": 202602,
        "valor": 672462725.4,
        "delta": -27833949016.1
      },
      {
        "periodo": 202603,
        "valor": 706313673.44,
        "delta": 33850948.04
      },
      {
        "periodo": 202604,
        "valor": 734632591.12,
        "delta": 28318917.68
      },
      {
        "periodo": 202605,
        "valor": 823648943.14,
        "delta": 89016352.02
      },
      {
        "periodo": 202606,
        "valor": 828065807.84,
        "delta": 4416864.7
      },
      {
        "periodo": 202607,
        "valor": 788644285.57,
        "delta": -39421522.27
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 7419825185.09,
    "valor_anterior": 8520091196.65,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7571216287.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8029677529.52,
        "delta": 458461241.99
      },
      {
        "periodo": 202509,
        "valor": 8129379020.25,
        "delta": 99701490.73
      },
      {
        "periodo": 202510,
        "valor": 7950406114.32,
        "delta": -178972905.93
      },
      {
        "periodo": 202511,
        "valor": 8043498563.29,
        "delta": 93092448.97
      },
      {
        "periodo": 202512,
        "valor": 7977379412.77,
        "delta": -66119150.52
      },
      {
        "periodo": 202601,
        "valor": 7087893980.09,
        "delta": -889485432.68
      },
      {
        "periodo": 202602,
        "valor": 7576534134.25,
        "delta": 488640154.16
      },
      {
        "periodo": 202603,
        "valor": 8091532037.79,
        "delta": 514997903.54
      },
      {
        "periodo": 202604,
        "valor": 8157157808.9,
        "delta": 65625771.11
      },
      {
        "periodo": 202605,
        "valor": 8870180949.54,
        "delta": 713023140.64
      },
      {
        "periodo": 202606,
        "valor": 8520091196.65,
        "delta": -350089752.89
      },
      {
        "periodo": 202607,
        "valor": 7419825185.09,
        "delta": -1100266011.56
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 20453106694.0,
    "valor_anterior": 20426929021.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14346056759.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14335256255.0,
        "delta": -10800504.0
      },
      {
        "periodo": 202509,
        "valor": 13948724198.0,
        "delta": -386532057.0
      },
      {
        "periodo": 202510,
        "valor": 18993325570.0,
        "delta": 5044601372.0
      },
      {
        "periodo": 202511,
        "valor": 18616731800.0,
        "delta": -376593770.0
      },
      {
        "periodo": 202512,
        "valor": 19337800716.0,
        "delta": 721068916.0
      },
      {
        "periodo": 202601,
        "valor": 18940054632.0,
        "delta": -397746084.0
      },
      {
        "periodo": 202602,
        "valor": 19428251376.0,
        "delta": 488196744.0
      },
      {
        "periodo": 202603,
        "valor": 20271195154.0,
        "delta": 842943778.0
      },
      {
        "periodo": 202604,
        "valor": 20228439619.0,
        "delta": -42755535.0
      },
      {
        "periodo": 202605,
        "valor": 19812007295.0,
        "delta": -416432324.0
      },
      {
        "periodo": 202606,
        "valor": 20426929021.0,
        "delta": 614921726.0
      },
      {
        "periodo": 202607,
        "valor": 20453106694.0,
        "delta": 26177673.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 3252563149.0,
    "valor_anterior": 2907114771.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4814094892.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4680279301.0,
        "delta": -133815591.0
      },
      {
        "periodo": 202509,
        "valor": 4757136724.0,
        "delta": 76857423.0
      },
      {
        "periodo": 202510,
        "valor": 4458886614.0,
        "delta": -298250110.0
      },
      {
        "periodo": 202511,
        "valor": 4286918829.0,
        "delta": -171967785.0
      },
      {
        "periodo": 202512,
        "valor": 4363531495.0,
        "delta": 76612666.0
      },
      {
        "periodo": 202601,
        "valor": 3984393357.0,
        "delta": -379138138.0
      },
      {
        "periodo": 202602,
        "valor": 3706928666.0,
        "delta": -277464691.0
      },
      {
        "periodo": 202603,
        "valor": 3146402823.0,
        "delta": -560525843.0
      },
      {
        "periodo": 202604,
        "valor": 2530800108.0,
        "delta": -615602715.0
      },
      {
        "periodo": 202605,
        "valor": 3007648229.0,
        "delta": 476848121.0
      },
      {
        "periodo": 202606,
        "valor": 2907114771.0,
        "delta": -100533458.0
      },
      {
        "periodo": 202607,
        "valor": 3252563149.0,
        "delta": 345448378.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 23474324617.1,
    "valor_anterior": 23473169327.260002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14898934659.99,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14615207950.63,
        "delta": -283726709.36
      },
      {
        "periodo": 202509,
        "valor": 15659632221.4,
        "delta": 1044424270.77
      },
      {
        "periodo": 202510,
        "valor": 15961012078.14,
        "delta": 301379856.74
      },
      {
        "periodo": 202511,
        "valor": 16887215860.74,
        "delta": 926203782.6
      },
      {
        "periodo": 202512,
        "valor": 23956622320.53,
        "delta": 7069406459.79
      },
      {
        "periodo": 202601,
        "valor": 22548682824.45,
        "delta": -1407939496.08
      },
      {
        "periodo": 202602,
        "valor": 22578779385.49,
        "delta": 30096561.04
      },
      {
        "periodo": 202603,
        "valor": 23137960379.63,
        "delta": 559180994.14
      },
      {
        "periodo": 202604,
        "valor": 20115128096.69,
        "delta": -3022832282.94
      },
      {
        "periodo": 202605,
        "valor": 21816555569.44,
        "delta": 1701427472.75
      },
      {
        "periodo": 202606,
        "valor": 23473169327.26,
        "delta": 1656613757.82
      },
      {
        "periodo": 202607,
        "valor": 23474324617.1,
        "delta": 1155289.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1351526972.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5731338917.0,
        "delta": 4379811945.0
      },
      {
        "periodo": 202509,
        "valor": 5367976972.0,
        "delta": -363361945.0
      },
      {
        "periodo": 202510,
        "valor": 4016448781.0,
        "delta": -1351528191.0
      },
      {
        "periodo": 202511,
        "valor": 5075087258.0,
        "delta": 1058638477.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": -5075087258.0
      },
      {
        "periodo": 202601,
        "valor": 2.0,
        "delta": 2.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -2.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 2105530952.0,
    "valor_anterior": 2140985391.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2622045140.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2706741912.0,
        "delta": 84696772.0
      },
      {
        "periodo": 202509,
        "valor": 2576791832.0,
        "delta": -129950080.0
      },
      {
        "periodo": 202510,
        "valor": 2541090744.0,
        "delta": -35701088.0
      },
      {
        "periodo": 202511,
        "valor": 2997924878.0,
        "delta": 456834134.0
      },
      {
        "periodo": 202512,
        "valor": 2909527166.0,
        "delta": -88397712.0
      },
      {
        "periodo": 202601,
        "valor": 3010032141.0,
        "delta": 100504975.0
      },
      {
        "periodo": 202602,
        "valor": 2630322840.0,
        "delta": -379709301.0
      },
      {
        "periodo": 202603,
        "valor": 2584094519.0,
        "delta": -46228321.0
      },
      {
        "periodo": 202604,
        "valor": 2017172035.0,
        "delta": -566922484.0
      },
      {
        "periodo": 202605,
        "valor": 2125008999.0,
        "delta": 107836964.0
      },
      {
        "periodo": 202606,
        "valor": 2140985391.0,
        "delta": 15976392.0
      },
      {
        "periodo": 202607,
        "valor": 2105530952.0,
        "delta": -35454439.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 8987431976.0,
    "valor_anterior": 10399056414.000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21642149593.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19959712989.0,
        "delta": -1682436604.0
      },
      {
        "periodo": 202509,
        "valor": 22296442909.0,
        "delta": 2336729920.0
      },
      {
        "periodo": 202510,
        "valor": 22113565689.0,
        "delta": -182877220.0
      },
      {
        "periodo": 202511,
        "valor": 23208694688.0,
        "delta": 1095128999.0
      },
      {
        "periodo": 202512,
        "valor": 18191117722.0,
        "delta": -5017576966.0
      },
      {
        "periodo": 202601,
        "valor": 17807437651.0,
        "delta": -383680071.0
      },
      {
        "periodo": 202602,
        "valor": 16738724772.0,
        "delta": -1068712879.0
      },
      {
        "periodo": 202603,
        "valor": 17429035117.0,
        "delta": 690310345.0
      },
      {
        "periodo": 202604,
        "valor": 10682260918.0,
        "delta": -6746774199.0
      },
      {
        "periodo": 202605,
        "valor": 10744911781.0,
        "delta": 62650863.0
      },
      {
        "periodo": 202606,
        "valor": 10399056414.0,
        "delta": -345855367.0
      },
      {
        "periodo": 202607,
        "valor": 8987431976.0,
        "delta": -1411624438.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 2428302449.68,
    "valor_anterior": 2188715112.97,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1661278891.36,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1680367059.23,
        "delta": 19088167.87
      },
      {
        "periodo": 202509,
        "valor": 1561988196.9,
        "delta": -118378862.33
      },
      {
        "periodo": 202510,
        "valor": 1544327182.81,
        "delta": -17661014.09
      },
      {
        "periodo": 202511,
        "valor": 1857039566.66,
        "delta": 312712383.85
      },
      {
        "periodo": 202512,
        "valor": 1885935007.67,
        "delta": 28895441.01
      },
      {
        "periodo": 202601,
        "valor": 1880952666.78,
        "delta": -4982340.89
      },
      {
        "periodo": 202602,
        "valor": 1891285321.39,
        "delta": 10332654.61
      },
      {
        "periodo": 202603,
        "valor": 2037671047.8,
        "delta": 146385726.41
      },
      {
        "periodo": 202604,
        "valor": 2149664444.51,
        "delta": 111993396.71
      },
      {
        "periodo": 202605,
        "valor": 2320386489.69,
        "delta": 170722045.18
      },
      {
        "periodo": 202606,
        "valor": 2188715112.97,
        "delta": -131671376.72
      },
      {
        "periodo": 202607,
        "valor": 2428302449.68,
        "delta": 239587336.71
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 1690878395.0,
    "valor_anterior": 1453511398.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1667684839.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1667885116.0,
        "delta": 200277.0
      },
      {
        "periodo": 202509,
        "valor": 1522959381.0,
        "delta": -144925735.0
      },
      {
        "periodo": 202510,
        "valor": 1465880683.0,
        "delta": -57078698.0
      },
      {
        "periodo": 202511,
        "valor": 1463089123.0,
        "delta": -2791560.0
      },
      {
        "periodo": 202512,
        "valor": 1445878086.0,
        "delta": -17211037.0
      },
      {
        "periodo": 202601,
        "valor": 1416168552.0,
        "delta": -29709534.0
      },
      {
        "periodo": 202602,
        "valor": 1469699490.0,
        "delta": 53530938.0
      },
      {
        "periodo": 202603,
        "valor": 1426892824.0,
        "delta": -42806666.0
      },
      {
        "periodo": 202604,
        "valor": 1461273197.0,
        "delta": 34380373.0
      },
      {
        "periodo": 202605,
        "valor": 1462976040.0,
        "delta": 1702843.0
      },
      {
        "periodo": 202606,
        "valor": 1453511398.0,
        "delta": -9464642.0
      },
      {
        "periodo": 202607,
        "valor": 1690878395.0,
        "delta": 237366997.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 96768300.0,
    "valor_anterior": 102115355.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 84819095.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 71740716.0,
        "delta": -13078379.0
      },
      {
        "periodo": 202509,
        "valor": 75824300.0,
        "delta": 4083584.0
      },
      {
        "periodo": 202510,
        "valor": 70969101.0,
        "delta": -4855199.0
      },
      {
        "periodo": 202511,
        "valor": 82534206.0,
        "delta": 11565105.0
      },
      {
        "periodo": 202512,
        "valor": 103939853.0,
        "delta": 21405647.0
      },
      {
        "periodo": 202601,
        "valor": 102858024.0,
        "delta": -1081829.0
      },
      {
        "periodo": 202602,
        "valor": 98659969.0,
        "delta": -4198055.0
      },
      {
        "periodo": 202603,
        "valor": 95354134.0,
        "delta": -3305835.0
      },
      {
        "periodo": 202604,
        "valor": 93543042.0,
        "delta": -1811092.0
      },
      {
        "periodo": 202605,
        "valor": 94619160.0,
        "delta": 1076118.0
      },
      {
        "periodo": 202606,
        "valor": 102115355.0,
        "delta": 7496195.0
      },
      {
        "periodo": 202607,
        "valor": 96768300.0,
        "delta": -5347055.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 439937197.0,
    "valor_anterior": 416261077.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 555576654.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 537167744.0,
        "delta": -18408910.0
      },
      {
        "periodo": 202509,
        "valor": 1706136053.0,
        "delta": 1168968309.0
      },
      {
        "periodo": 202510,
        "valor": 1890212206.0,
        "delta": 184076153.0
      },
      {
        "periodo": 202511,
        "valor": 1254368288.0,
        "delta": -635843918.0
      },
      {
        "periodo": 202512,
        "valor": 2132877416.0,
        "delta": 878509128.0
      },
      {
        "periodo": 202601,
        "valor": 685420478.0,
        "delta": -1447456938.0
      },
      {
        "periodo": 202602,
        "valor": 1317596519.0,
        "delta": 632176041.0
      },
      {
        "periodo": 202603,
        "valor": 1149838536.0,
        "delta": -167757983.0
      },
      {
        "periodo": 202604,
        "valor": 358586816.0,
        "delta": -791251720.0
      },
      {
        "periodo": 202605,
        "valor": 379675596.0,
        "delta": 21088780.0
      },
      {
        "periodo": 202606,
        "valor": 416261077.0,
        "delta": 36585481.0
      },
      {
        "periodo": 202607,
        "valor": 439937197.0,
        "delta": 23676120.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 2754707153.99,
    "valor_anterior": 2828252544.72,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3602019776.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2730168308.65,
        "delta": -871851468.28
      },
      {
        "periodo": 202509,
        "valor": 2644785073.05,
        "delta": -85383235.6
      },
      {
        "periodo": 202510,
        "valor": 2652525558.19,
        "delta": 7740485.14
      },
      {
        "periodo": 202511,
        "valor": 2665627673.01,
        "delta": 13102114.82
      },
      {
        "periodo": 202512,
        "valor": 2664034974.85,
        "delta": -1592698.16
      },
      {
        "periodo": 202601,
        "valor": 2757109644.38,
        "delta": 93074669.53
      },
      {
        "periodo": 202602,
        "valor": 2592056153.02,
        "delta": -165053491.36
      },
      {
        "periodo": 202603,
        "valor": 2582964622.3,
        "delta": -9091530.72
      },
      {
        "periodo": 202604,
        "valor": 2692679819.33,
        "delta": 109715197.03
      },
      {
        "periodo": 202605,
        "valor": 2627646009.56,
        "delta": -65033809.77
      },
      {
        "periodo": 202606,
        "valor": 2828252544.72,
        "delta": 200606535.16
      },
      {
        "periodo": 202607,
        "valor": 2754707153.99,
        "delta": -73545390.73
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 1790125801.22,
    "valor_anterior": 1755066059.09,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1365425316.81,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1336683665.38,
        "delta": -28741651.43
      },
      {
        "periodo": 202509,
        "valor": 1372433603.12,
        "delta": 35749937.74
      },
      {
        "periodo": 202510,
        "valor": 1400228719.91,
        "delta": 27795116.79
      },
      {
        "periodo": 202511,
        "valor": 1486933261.92,
        "delta": 86704542.01
      },
      {
        "periodo": 202512,
        "valor": 1576286885.91,
        "delta": 89353623.99
      },
      {
        "periodo": 202601,
        "valor": 1521939992.99,
        "delta": -54346892.92
      },
      {
        "periodo": 202602,
        "valor": 1612137080.05,
        "delta": 90197087.06
      },
      {
        "periodo": 202603,
        "valor": 1653772305.33,
        "delta": 41635225.28
      },
      {
        "periodo": 202604,
        "valor": 1771174406.52,
        "delta": 117402101.19
      },
      {
        "periodo": 202605,
        "valor": 1944438577.5,
        "delta": 173264170.98
      },
      {
        "periodo": 202606,
        "valor": 1755066059.09,
        "delta": -189372518.41
      },
      {
        "periodo": 202607,
        "valor": 1790125801.22,
        "delta": 35059742.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 2798137406.0,
    "valor_anterior": 3294787213.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2747858410.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2301910424.0,
        "delta": -445947986.0
      },
      {
        "periodo": 202509,
        "valor": 3238649513.0,
        "delta": 936739089.0
      },
      {
        "periodo": 202510,
        "valor": 3338359039.0,
        "delta": 99709526.0
      },
      {
        "periodo": 202511,
        "valor": 4636009148.0,
        "delta": 1297650109.0
      },
      {
        "periodo": 202512,
        "valor": 4394293995.0,
        "delta": -241715153.0
      },
      {
        "periodo": 202601,
        "valor": 3197993821.0,
        "delta": -1196300174.0
      },
      {
        "periodo": 202602,
        "valor": 3093557240.0,
        "delta": -104436581.0
      },
      {
        "periodo": 202603,
        "valor": 5010965942.0,
        "delta": 1917408702.0
      },
      {
        "periodo": 202604,
        "valor": 5081900672.0,
        "delta": 70934730.0
      },
      {
        "periodo": 202605,
        "valor": 4090965999.0,
        "delta": -990934673.0
      },
      {
        "periodo": 202606,
        "valor": 3294787213.0,
        "delta": -796178786.0
      },
      {
        "periodo": 202607,
        "valor": 2798137406.0,
        "delta": -496649807.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 99580730.36,
        "delta": 99580730.36
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": -99580730.36
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 259838005.0,
    "valor_anterior": 1417818824.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1486527785.0,
        "delta": 1486527785.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": -1486527785.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 2335006298.0,
        "delta": 2335006298.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -2335006298.0
      },
      {
        "periodo": 202603,
        "valor": 2171911284.0,
        "delta": 2171911284.0
      },
      {
        "periodo": 202604,
        "valor": 1398863981.0,
        "delta": -773047303.0
      },
      {
        "periodo": 202605,
        "valor": 6296870686.0,
        "delta": 4898006705.0
      },
      {
        "periodo": 202606,
        "valor": 1417818824.0,
        "delta": -4879051862.0
      },
      {
        "periodo": 202607,
        "valor": 259838005.0,
        "delta": -1157980819.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 2145847404.0,
    "valor_anterior": 1652969878.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5530559983.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4731964349.0,
        "delta": -798595634.0
      },
      {
        "periodo": 202509,
        "valor": 3416021902.0,
        "delta": -1315942447.0
      },
      {
        "periodo": 202510,
        "valor": 2030359956.0,
        "delta": -1385661946.0
      },
      {
        "periodo": 202511,
        "valor": 2020455538.0,
        "delta": -9904418.0
      },
      {
        "periodo": 202512,
        "valor": 1284834425.0,
        "delta": -735621113.0
      },
      {
        "periodo": 202601,
        "valor": 1921933543.0,
        "delta": 637099118.0
      },
      {
        "periodo": 202602,
        "valor": 1990908903.0,
        "delta": 68975360.0
      },
      {
        "periodo": 202603,
        "valor": 1215906215.0,
        "delta": -775002688.0
      },
      {
        "periodo": 202604,
        "valor": 1212614385.0,
        "delta": -3291830.0
      },
      {
        "periodo": 202605,
        "valor": 1348256618.0,
        "delta": 135642233.0
      },
      {
        "periodo": 202606,
        "valor": 1652969878.0,
        "delta": 304713260.0
      },
      {
        "periodo": 202607,
        "valor": 2145847404.0,
        "delta": 492877526.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 7238744800.999999,
    "valor_anterior": 3113354927.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6024330937.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6191482247.0,
        "delta": 167151310.0
      },
      {
        "periodo": 202509,
        "valor": 6266862983.0,
        "delta": 75380736.0
      },
      {
        "periodo": 202510,
        "valor": 3616782439.0,
        "delta": -2650080544.0
      },
      {
        "periodo": 202511,
        "valor": 1829877150.0,
        "delta": -1786905289.0
      },
      {
        "periodo": 202512,
        "valor": 4809722795.0,
        "delta": 2979845645.0
      },
      {
        "periodo": 202601,
        "valor": 4450514329.0,
        "delta": -359208466.0
      },
      {
        "periodo": 202602,
        "valor": 3823578894.0,
        "delta": -626935435.0
      },
      {
        "periodo": 202603,
        "valor": 1714969731.0,
        "delta": -2108609163.0
      },
      {
        "periodo": 202604,
        "valor": 1545727810.0,
        "delta": -169241921.0
      },
      {
        "periodo": 202605,
        "valor": 1535059457.0,
        "delta": -10668353.0
      },
      {
        "periodo": 202606,
        "valor": 3113354927.0,
        "delta": 1578295470.0
      },
      {
        "periodo": 202607,
        "valor": 7238744801.0,
        "delta": 4125389874.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 380373939.0,
    "valor_anterior": 339340506.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 111764493.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 123508659.0,
        "delta": 11744166.0
      },
      {
        "periodo": 202509,
        "valor": 127002161.0,
        "delta": 3493502.0
      },
      {
        "periodo": 202510,
        "valor": 114620231.0,
        "delta": -12381930.0
      },
      {
        "periodo": 202511,
        "valor": 184359846.0,
        "delta": 69739615.0
      },
      {
        "periodo": 202512,
        "valor": 214725847.0,
        "delta": 30366001.0
      },
      {
        "periodo": 202601,
        "valor": 207550059.0,
        "delta": -7175788.0
      },
      {
        "periodo": 202602,
        "valor": 205107786.0,
        "delta": -2442273.0
      },
      {
        "periodo": 202603,
        "valor": 204590299.0,
        "delta": -517487.0
      },
      {
        "periodo": 202604,
        "valor": 213864692.0,
        "delta": 9274393.0
      },
      {
        "periodo": 202605,
        "valor": 213198047.0,
        "delta": -666645.0
      },
      {
        "periodo": 202606,
        "valor": 339340506.0,
        "delta": 126142459.0
      },
      {
        "periodo": 202607,
        "valor": 380373939.0,
        "delta": 41033433.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2291986.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -2291986.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": 1.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -1.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 591114147.23,
    "valor_anterior": 678766446.73,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 743126134.14,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 778535482.83,
        "delta": 35409348.69
      },
      {
        "periodo": 202509,
        "valor": 1065321117.66,
        "delta": 286785634.83
      },
      {
        "periodo": 202510,
        "valor": 1170541444.28,
        "delta": 105220326.62
      },
      {
        "periodo": 202511,
        "valor": 1192124153.08,
        "delta": 21582708.8
      },
      {
        "periodo": 202512,
        "valor": 1192193080.39,
        "delta": 68927.31
      },
      {
        "periodo": 202601,
        "valor": 1177939043.97,
        "delta": -14254036.42
      },
      {
        "periodo": 202602,
        "valor": 1226413404.09,
        "delta": 48474360.12
      },
      {
        "periodo": 202603,
        "valor": 1411171481.28,
        "delta": 184758077.19
      },
      {
        "periodo": 202604,
        "valor": 582292689.57,
        "delta": -828878791.71
      },
      {
        "periodo": 202605,
        "valor": 615634195.86,
        "delta": 33341506.29
      },
      {
        "periodo": 202606,
        "valor": 678766446.73,
        "delta": 63132250.87
      },
      {
        "periodo": 202607,
        "valor": 591114147.23,
        "delta": -87652299.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 400069472.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 403137881.0,
        "delta": 3068409.0
      },
      {
        "periodo": 202509,
        "valor": 400000000.0,
        "delta": -3137881.0
      },
      {
        "periodo": 202510,
        "valor": 200000000.0,
        "delta": -200000000.0
      },
      {
        "periodo": 202511,
        "valor": 203259024.0,
        "delta": 3259024.0
      },
      {
        "periodo": 202512,
        "valor": 200000000.0,
        "delta": -3259024.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -200000000.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 508548000.0,
    "valor_anterior": 507075372.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1612204244.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1613507866.0,
        "delta": 1303622.0
      },
      {
        "periodo": 202509,
        "valor": 155985077.0,
        "delta": -1457522789.0
      },
      {
        "periodo": 202510,
        "valor": 157506043.0,
        "delta": 1520966.0
      },
      {
        "periodo": 202511,
        "valor": 158332023.0,
        "delta": 825980.0
      },
      {
        "periodo": 202512,
        "valor": 703622884.0,
        "delta": 545290861.0
      },
      {
        "periodo": 202601,
        "valor": 1204836680.0,
        "delta": 501213796.0
      },
      {
        "periodo": 202602,
        "valor": 1206653783.0,
        "delta": 1817103.0
      },
      {
        "periodo": 202603,
        "valor": 708279871.0,
        "delta": -498373912.0
      },
      {
        "periodo": 202604,
        "valor": 706931011.0,
        "delta": -1348860.0
      },
      {
        "periodo": 202605,
        "valor": 707926421.0,
        "delta": 995410.0
      },
      {
        "periodo": 202606,
        "valor": 507075372.0,
        "delta": -200851049.0
      },
      {
        "periodo": 202607,
        "valor": 508548000.0,
        "delta": 1472628.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4509452.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2089460099.0,
        "delta": 2084950647.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 34284233.0,
    "valor_anterior": 37408625.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 73961669.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 81906879.0,
        "delta": 7945210.0
      },
      {
        "periodo": 202509,
        "valor": 80155577.0,
        "delta": -1751302.0
      },
      {
        "periodo": 202510,
        "valor": 69916884.0,
        "delta": -10238693.0
      },
      {
        "periodo": 202511,
        "valor": 81479924.0,
        "delta": 11563040.0
      },
      {
        "periodo": 202512,
        "valor": 83333167.0,
        "delta": 1853243.0
      },
      {
        "periodo": 202601,
        "valor": 66939354.0,
        "delta": -16393813.0
      },
      {
        "periodo": 202602,
        "valor": 65355558.0,
        "delta": -1583796.0
      },
      {
        "periodo": 202603,
        "valor": 71944725.0,
        "delta": 6589167.0
      },
      {
        "periodo": 202604,
        "valor": 76146545.0,
        "delta": 4201820.0
      },
      {
        "periodo": 202605,
        "valor": 57168392.0,
        "delta": -18978153.0
      },
      {
        "periodo": 202606,
        "valor": 37408625.0,
        "delta": -19759767.0
      },
      {
        "periodo": 202607,
        "valor": 34284233.0,
        "delta": -3124392.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 818331.0,
    "valor_anterior": 713295.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 910000.0,
        "delta": 910000.0
      },
      {
        "periodo": 202509,
        "valor": 710000.0,
        "delta": -200000.0
      },
      {
        "periodo": 202510,
        "valor": 641341.0,
        "delta": -68659.0
      },
      {
        "periodo": 202511,
        "valor": 281196.0,
        "delta": -360145.0
      },
      {
        "periodo": 202512,
        "valor": 723405.0,
        "delta": 442209.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -723405.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 378365.0,
        "delta": 378365.0
      },
      {
        "periodo": 202604,
        "valor": 381405.0,
        "delta": 3040.0
      },
      {
        "periodo": 202605,
        "valor": 585873.0,
        "delta": 204468.0
      },
      {
        "periodo": 202606,
        "valor": 713295.0,
        "delta": 127422.0
      },
      {
        "periodo": 202607,
        "valor": 818331.0,
        "delta": 105036.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 373859769.41,
    "valor_anterior": 112356909.09,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 291387622.92,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 278114665.05,
        "delta": -13272957.87
      },
      {
        "periodo": 202509,
        "valor": 267474001.19,
        "delta": -10640663.86
      },
      {
        "periodo": 202510,
        "valor": 174300802.61,
        "delta": -93173198.58
      },
      {
        "periodo": 202511,
        "valor": 199287110.22,
        "delta": 24986307.61
      },
      {
        "periodo": 202512,
        "valor": 17186562.13,
        "delta": -182100548.09
      },
      {
        "periodo": 202601,
        "valor": 30218522.08,
        "delta": 13031959.95
      },
      {
        "periodo": 202602,
        "valor": 87899197.97,
        "delta": 57680675.89
      },
      {
        "periodo": 202603,
        "valor": 110650384.92,
        "delta": 22751186.95
      },
      {
        "periodo": 202604,
        "valor": 108353040.17,
        "delta": -2297344.75
      },
      {
        "periodo": 202605,
        "valor": 67803467.1,
        "delta": -40549573.07
      },
      {
        "periodo": 202606,
        "valor": 112356909.09,
        "delta": 44553441.99
      },
      {
        "periodo": 202607,
        "valor": 373859769.41,
        "delta": 261502860.32
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 4638040856.47,
    "valor_anterior": 6838454326.95,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5209074341.73,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5838349928.29,
        "delta": 629275586.56
      },
      {
        "periodo": 202509,
        "valor": 5207308670.01,
        "delta": -631041258.28
      },
      {
        "periodo": 202510,
        "valor": 5345866989.41,
        "delta": 138558319.4
      },
      {
        "periodo": 202511,
        "valor": 6403712331.25,
        "delta": 1057845341.84
      },
      {
        "periodo": 202512,
        "valor": 8109432215.32,
        "delta": 1705719884.07
      },
      {
        "periodo": 202601,
        "valor": 7475221227.32,
        "delta": -634210988.0
      },
      {
        "periodo": 202602,
        "valor": 7119902195.81,
        "delta": -355319031.51
      },
      {
        "periodo": 202603,
        "valor": 7948115411.75,
        "delta": 828213215.94
      },
      {
        "periodo": 202604,
        "valor": 7715951903.69,
        "delta": -232163508.06
      },
      {
        "periodo": 202605,
        "valor": 6748015642.37,
        "delta": -967936261.32
      },
      {
        "periodo": 202606,
        "valor": 6838454326.95,
        "delta": 90438684.58
      },
      {
        "periodo": 202607,
        "valor": 4638040856.47,
        "delta": -2200413470.48
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 642704096.69,
    "valor_anterior": 650269425.39,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1044252376.32,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 965603442.82,
        "delta": -78648933.5
      },
      {
        "periodo": 202509,
        "valor": 847020579.73,
        "delta": -118582863.09
      },
      {
        "periodo": 202510,
        "valor": 826366700.07,
        "delta": -20653879.66
      },
      {
        "periodo": 202511,
        "valor": 804376940.56,
        "delta": -21989759.51
      },
      {
        "periodo": 202512,
        "valor": 723494392.87,
        "delta": -80882547.69
      },
      {
        "periodo": 202601,
        "valor": 684983179.59,
        "delta": -38511213.28
      },
      {
        "periodo": 202602,
        "valor": 657174500.98,
        "delta": -27808678.61
      },
      {
        "periodo": 202603,
        "valor": 735243552.57,
        "delta": 78069051.59
      },
      {
        "periodo": 202604,
        "valor": 722030872.04,
        "delta": -13212680.53
      },
      {
        "periodo": 202605,
        "valor": 712239232.25,
        "delta": -9791639.79
      },
      {
        "periodo": 202606,
        "valor": 650269425.39,
        "delta": -61969806.86
      },
      {
        "periodo": 202607,
        "valor": 642704096.69,
        "delta": -7565328.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 698297305.0,
    "valor_anterior": 703984590.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1192171587.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1180858311.0,
        "delta": -11313276.0
      },
      {
        "periodo": 202509,
        "valor": 1161760411.0,
        "delta": -19097900.0
      },
      {
        "periodo": 202510,
        "valor": 1180392337.0,
        "delta": 18631926.0
      },
      {
        "periodo": 202511,
        "valor": 1190665142.0,
        "delta": 10272805.0
      },
      {
        "periodo": 202512,
        "valor": 1486169910.0,
        "delta": 295504768.0
      },
      {
        "periodo": 202601,
        "valor": 1456067485.0,
        "delta": -30102425.0
      },
      {
        "periodo": 202602,
        "valor": 757253305.0,
        "delta": -698814180.0
      },
      {
        "periodo": 202603,
        "valor": 724504142.0,
        "delta": -32749163.0
      },
      {
        "periodo": 202604,
        "valor": 707212815.0,
        "delta": -17291327.0
      },
      {
        "periodo": 202605,
        "valor": 697648362.0,
        "delta": -9564453.0
      },
      {
        "periodo": 202606,
        "valor": 703984590.0,
        "delta": 6336228.0
      },
      {
        "periodo": 202607,
        "valor": 698297305.0,
        "delta": -5687285.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 3324338608.0,
    "valor_anterior": 3623953017.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7140598683.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6824674283.0,
        "delta": -315924400.0
      },
      {
        "periodo": 202509,
        "valor": 6112163741.0,
        "delta": -712510542.0
      },
      {
        "periodo": 202510,
        "valor": 7193625425.0,
        "delta": 1081461684.0
      },
      {
        "periodo": 202511,
        "valor": 7617383682.0,
        "delta": 423758257.0
      },
      {
        "periodo": 202512,
        "valor": 8974950617.0,
        "delta": 1357566935.0
      },
      {
        "periodo": 202601,
        "valor": 5757685991.0,
        "delta": -3217264626.0
      },
      {
        "periodo": 202602,
        "valor": 5406354780.0,
        "delta": -351331211.0
      },
      {
        "periodo": 202603,
        "valor": 4919683732.0,
        "delta": -486671048.0
      },
      {
        "periodo": 202604,
        "valor": 3582051026.0,
        "delta": -1337632706.0
      },
      {
        "periodo": 202605,
        "valor": 2720419215.0,
        "delta": -861631811.0
      },
      {
        "periodo": 202606,
        "valor": 3623953017.0,
        "delta": 903533802.0
      },
      {
        "periodo": 202607,
        "valor": 3324338608.0,
        "delta": -299614409.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 1835044665.0,
    "valor_anterior": 1624152614.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2643558321.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2730124152.0,
        "delta": 86565831.0
      },
      {
        "periodo": 202509,
        "valor": 2628771504.0,
        "delta": -101352648.0
      },
      {
        "periodo": 202510,
        "valor": 2678593370.0,
        "delta": 49821866.0
      },
      {
        "periodo": 202511,
        "valor": 2688708461.0,
        "delta": 10115091.0
      },
      {
        "periodo": 202512,
        "valor": 2618464734.0,
        "delta": -70243727.0
      },
      {
        "periodo": 202601,
        "valor": 2617490380.0,
        "delta": -974354.0
      },
      {
        "periodo": 202602,
        "valor": 2661326096.0,
        "delta": 43835716.0
      },
      {
        "periodo": 202603,
        "valor": 2345034543.0,
        "delta": -316291553.0
      },
      {
        "periodo": 202604,
        "valor": 1792509122.0,
        "delta": -552525421.0
      },
      {
        "periodo": 202605,
        "valor": 1781443499.0,
        "delta": -11065623.0
      },
      {
        "periodo": 202606,
        "valor": 1624152614.0,
        "delta": -157290885.0
      },
      {
        "periodo": 202607,
        "valor": 1835044665.0,
        "delta": 210892051.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 5055226.08,
    "valor_anterior": 6126137.54,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 500119498.61,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 503823955.55,
        "delta": 3704456.94
      },
      {
        "periodo": 202509,
        "valor": 500117123.61,
        "delta": -3706831.94
      },
      {
        "periodo": 202510,
        "valor": 500113630.55,
        "delta": -3493.06
      },
      {
        "periodo": 202511,
        "valor": 503522547.22,
        "delta": 3408916.67
      },
      {
        "periodo": 202512,
        "valor": 12610622.43,
        "delta": -490911924.79
      },
      {
        "periodo": 202601,
        "valor": 11185319.74,
        "delta": -1425302.69
      },
      {
        "periodo": 202602,
        "valor": 10054553.68,
        "delta": -1130766.06
      },
      {
        "periodo": 202603,
        "valor": 9416979.08,
        "delta": -637574.6
      },
      {
        "periodo": 202604,
        "valor": 8156437.58,
        "delta": -1260541.5
      },
      {
        "periodo": 202605,
        "valor": 7085242.89,
        "delta": -1071194.69
      },
      {
        "periodo": 202606,
        "valor": 6126137.54,
        "delta": -959105.35
      },
      {
        "periodo": 202607,
        "valor": 5055226.08,
        "delta": -1070911.46
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 1500687096.56,
    "valor_anterior": 1520538966.95,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 359652591.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 309987799.54,
        "delta": -49664792.18
      },
      {
        "periodo": 202509,
        "valor": 303990340.23,
        "delta": -5997459.31
      },
      {
        "periodo": 202510,
        "valor": 244448595.13,
        "delta": -59541745.1
      },
      {
        "periodo": 202511,
        "valor": 348778020.13,
        "delta": 104329425.0
      },
      {
        "periodo": 202512,
        "valor": 1137249980.68,
        "delta": 788471960.55
      },
      {
        "periodo": 202601,
        "valor": 1013297026.2,
        "delta": -123952954.48
      },
      {
        "periodo": 202602,
        "valor": 1002400803.74,
        "delta": -10896222.46
      },
      {
        "periodo": 202603,
        "valor": 863817669.29,
        "delta": -138583134.45
      },
      {
        "periodo": 202604,
        "valor": 1192235907.77,
        "delta": 328418238.48
      },
      {
        "periodo": 202605,
        "valor": 1043730802.18,
        "delta": -148505105.59
      },
      {
        "periodo": 202606,
        "valor": 1520538966.95,
        "delta": 476808164.77
      },
      {
        "periodo": 202607,
        "valor": 1500687096.56,
        "delta": -19851870.39
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 59427.0,
        "delta": 59427.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -59427.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 27349.0,
        "delta": 27349.0
      },
      {
        "periodo": 202605,
        "valor": 49100.0,
        "delta": 21751.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": -49100.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 3133972436.0,
    "valor_anterior": 3135599149.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3550244016.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3296572823.0,
        "delta": -253671193.0
      },
      {
        "periodo": 202509,
        "valor": 3222826909.0,
        "delta": -73745914.0
      },
      {
        "periodo": 202510,
        "valor": 3518034875.0,
        "delta": 295207966.0
      },
      {
        "periodo": 202511,
        "valor": 3602953095.0,
        "delta": 84918220.0
      },
      {
        "periodo": 202512,
        "valor": 3179892212.0,
        "delta": -423060883.0
      },
      {
        "periodo": 202601,
        "valor": 3026097596.0,
        "delta": -153794616.0
      },
      {
        "periodo": 202602,
        "valor": 3046614296.0,
        "delta": 20516700.0
      },
      {
        "periodo": 202603,
        "valor": 3172327411.0,
        "delta": 125713115.0
      },
      {
        "periodo": 202604,
        "valor": 3147442810.0,
        "delta": -24884601.0
      },
      {
        "periodo": 202605,
        "valor": 3037822165.0,
        "delta": -109620645.0
      },
      {
        "periodo": 202606,
        "valor": 3135599149.0,
        "delta": 97776984.0
      },
      {
        "periodo": 202607,
        "valor": 3133972436.0,
        "delta": -1626713.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 88399937.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": -88399937.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 105791852481.09,
    "valor_anterior": 106697003698.18,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 133771143688.84,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 136698332443.34,
        "delta": 2927188754.5
      },
      {
        "periodo": 202509,
        "valor": 134993503610.87,
        "delta": -1704828832.47
      },
      {
        "periodo": 202510,
        "valor": 147419550177.72,
        "delta": 12426046566.85
      },
      {
        "periodo": 202511,
        "valor": 150288373280.35,
        "delta": 2868823102.63
      },
      {
        "periodo": 202512,
        "valor": 154288235226.71,
        "delta": 3999861946.36
      },
      {
        "periodo": 202601,
        "valor": 146884315543.09,
        "delta": -7403919683.62
      },
      {
        "periodo": 202602,
        "valor": 114673993728.87,
        "delta": -32210321814.22
      },
      {
        "periodo": 202603,
        "valor": 117740338849.18,
        "delta": 3066345120.31
      },
      {
        "periodo": 202604,
        "valor": 102787207375.89,
        "delta": -14953131473.29
      },
      {
        "periodo": 202605,
        "valor": 107711626055.52,
        "delta": 4924418679.63
      },
      {
        "periodo": 202606,
        "valor": 106697003698.18,
        "delta": -1014622357.34
      },
      {
        "periodo": 202607,
        "valor": 105791852481.09,
        "delta": -905151217.09
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 43656278443.65,
    "valor_anterior": 45909509755.21,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 71733643274.24,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 73838105033.02,
        "delta": 2104461758.78
      },
      {
        "periodo": 202509,
        "valor": 75515596413.02,
        "delta": 1677491380.0
      },
      {
        "periodo": 202510,
        "valor": 88698831575.81,
        "delta": 13183235162.79
      },
      {
        "periodo": 202511,
        "valor": 90494122034.21,
        "delta": 1795290458.4
      },
      {
        "periodo": 202512,
        "valor": 81134208219.78,
        "delta": -9359913814.43
      },
      {
        "periodo": 202601,
        "valor": 79083301007.97,
        "delta": -2050907211.81
      },
      {
        "periodo": 202602,
        "valor": 50714957826.67,
        "delta": -28368343181.3
      },
      {
        "periodo": 202603,
        "valor": 52227443427.53,
        "delta": 1512485600.86
      },
      {
        "periodo": 202604,
        "valor": 45025970864.35,
        "delta": -7201472563.18
      },
      {
        "periodo": 202605,
        "valor": 45886043207.24,
        "delta": 860072342.89
      },
      {
        "periodo": 202606,
        "valor": 45909509755.21,
        "delta": 23466547.97
      },
      {
        "periodo": 202607,
        "valor": 43656278443.65,
        "delta": -2253231311.56
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 1824410034.22,
    "valor_anterior": 1792474684.09,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1446188423.81,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3508050643.38,
        "delta": 2061862219.57
      },
      {
        "periodo": 202509,
        "valor": 1452589180.12,
        "delta": -2055461463.26
      },
      {
        "periodo": 202510,
        "valor": 1470145603.91,
        "delta": 17556423.79
      },
      {
        "periodo": 202511,
        "valor": 1568413185.92,
        "delta": 98267582.01
      },
      {
        "periodo": 202512,
        "valor": 1659620052.91,
        "delta": 91206866.99
      },
      {
        "periodo": 202601,
        "valor": 1588879347.99,
        "delta": -70740704.92
      },
      {
        "periodo": 202602,
        "valor": 1677492638.05,
        "delta": 88613290.06
      },
      {
        "periodo": 202603,
        "valor": 1725717030.33,
        "delta": 48224392.28
      },
      {
        "periodo": 202604,
        "valor": 1847320951.52,
        "delta": 121603921.19
      },
      {
        "periodo": 202605,
        "valor": 2001606969.5,
        "delta": 154286017.98
      },
      {
        "periodo": 202606,
        "valor": 1792474684.09,
        "delta": -209132285.41
      },
      {
        "periodo": 202607,
        "valor": 1824410034.22,
        "delta": 31935350.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 2390653597.0,
    "valor_anterior": 3287591299.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2223261493.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2205052860.0,
        "delta": -18208633.0
      },
      {
        "periodo": 202509,
        "valor": 3229095434.0,
        "delta": 1024042574.0
      },
      {
        "periodo": 202510,
        "valor": 4842620674.0,
        "delta": 1613525240.0
      },
      {
        "periodo": 202511,
        "valor": 2717457411.0,
        "delta": -2125163263.0
      },
      {
        "periodo": 202512,
        "valor": 3578814929.0,
        "delta": 861357518.0
      },
      {
        "periodo": 202601,
        "valor": 4436595328.0,
        "delta": 857780399.0
      },
      {
        "periodo": 202602,
        "valor": 2787296009.0,
        "delta": -1649299319.0
      },
      {
        "periodo": 202603,
        "valor": 4748642644.0,
        "delta": 1961346635.0
      },
      {
        "periodo": 202604,
        "valor": 3218751343.0,
        "delta": -1529891301.0
      },
      {
        "periodo": 202605,
        "valor": 8139571422.0,
        "delta": 4920820079.0
      },
      {
        "periodo": 202606,
        "valor": 3287591299.0,
        "delta": -4851980123.0
      },
      {
        "periodo": 202607,
        "valor": 2390653597.0,
        "delta": -896937702.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 41369378833.78,
    "valor_anterior": 37834964988.23,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 35095046721.35,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 34320383875.86,
        "delta": -774662845.49
      },
      {
        "periodo": 202509,
        "valor": 35416088487.3,
        "delta": 1095704611.44
      },
      {
        "periodo": 202510,
        "valor": 34195196907.95,
        "delta": -1220891579.35
      },
      {
        "periodo": 202511,
        "valor": 35825450285.4,
        "delta": 1630253377.45
      },
      {
        "periodo": 202512,
        "valor": 46931051901.2,
        "delta": 11105601615.8
      },
      {
        "periodo": 202601,
        "valor": 40845861773.23,
        "delta": -6085190127.97
      },
      {
        "periodo": 202602,
        "valor": 39423878460.88,
        "delta": -1421983312.35
      },
      {
        "periodo": 202603,
        "valor": 39405345351.43,
        "delta": -18533109.45
      },
      {
        "periodo": 202604,
        "valor": 34491644084.2,
        "delta": -4913701267.23
      },
      {
        "periodo": 202605,
        "valor": 34608395729.13,
        "delta": 116751644.93
      },
      {
        "periodo": 202606,
        "valor": 37834964988.23,
        "delta": 3226569259.1
      },
      {
        "periodo": 202607,
        "valor": 41369378833.78,
        "delta": 3534413845.55
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 13305622021.21,
    "valor_anterior": 15033651274.92,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14987043943.3,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15299594452.25,
        "delta": 312550508.95
      },
      {
        "periodo": 202509,
        "valor": 14342805999.77,
        "delta": -956788452.48
      },
      {
        "periodo": 202510,
        "valor": 14654347972.77,
        "delta": 311541973.0
      },
      {
        "periodo": 202511,
        "valor": 16009178895.38,
        "delta": 1354830922.61
      },
      {
        "periodo": 202512,
        "valor": 17603889734.43,
        "delta": 1594710839.05
      },
      {
        "periodo": 202601,
        "valor": 16624968818.93,
        "delta": -978920915.5
      },
      {
        "periodo": 202602,
        "valor": 15646392704.18,
        "delta": -978576114.75
      },
      {
        "periodo": 202603,
        "valor": 16209432891.61,
        "delta": 563040187.43
      },
      {
        "periodo": 202604,
        "valor": 15701682047.25,
        "delta": -507750844.36
      },
      {
        "periodo": 202605,
        "valor": 14404191492.79,
        "delta": -1297490554.46
      },
      {
        "periodo": 202606,
        "valor": 15033651274.92,
        "delta": 629459782.13
      },
      {
        "periodo": 202607,
        "valor": 13305622021.21,
        "delta": -1728029253.71
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100088,
    "label": "D. Corto Plazo",
    "valor_actual": 3245509551.23,
    "valor_anterior": 2838811696.73,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8285959833.14,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7527145578.83,
        "delta": -758814254.31
      },
      {
        "periodo": 202509,
        "valor": 5037328096.66,
        "delta": -2489817482.17
      },
      {
        "periodo": 202510,
        "valor": 3558407443.28,
        "delta": -1478920653.38
      },
      {
        "periodo": 202511,
        "valor": 3673751468.44,
        "delta": 115344025.16
      },
      {
        "periodo": 202512,
        "valor": 3380650389.39,
        "delta": -293101079.05
      },
      {
        "periodo": 202601,
        "valor": 4304709266.97,
        "delta": 924058877.58
      },
      {
        "periodo": 202602,
        "valor": 4423976090.09,
        "delta": 119266823.12
      },
      {
        "periodo": 202603,
        "valor": 3423757504.28,
        "delta": -1000218585.81
      },
      {
        "periodo": 202604,
        "valor": 2501838085.57,
        "delta": -921919418.71
      },
      {
        "periodo": 202605,
        "valor": 2671817234.86,
        "delta": 169979149.29
      },
      {
        "periodo": 202606,
        "valor": 2838811696.73,
        "delta": 166994461.87
      },
      {
        "periodo": 202607,
        "valor": 3245509551.23,
        "delta": 406697854.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 157609233.18,
    "valor_anterior": 167930828.75,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6153864282.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 446302987.92,
        "delta": -5707561295.01
      },
      {
        "periodo": 202509,
        "valor": 354192876.92,
        "delta": -92110111.0
      },
      {
        "periodo": 202510,
        "valor": 392873978.79,
        "delta": 38681101.87
      },
      {
        "periodo": 202511,
        "valor": 171935606.94,
        "delta": -220938371.85
      },
      {
        "periodo": 202512,
        "valor": 169570333.27,
        "delta": -2365273.67
      },
      {
        "periodo": 202601,
        "valor": 173928932.51,
        "delta": 4358599.24
      },
      {
        "periodo": 202602,
        "valor": 165567470.92,
        "delta": -8361461.59
      },
      {
        "periodo": 202603,
        "valor": 163313254.53,
        "delta": -2254216.39
      },
      {
        "periodo": 202604,
        "valor": 161955968.6,
        "delta": -1357285.93
      },
      {
        "periodo": 202605,
        "valor": 162386892.49,
        "delta": 430923.89
      },
      {
        "periodo": 202606,
        "valor": 167930828.75,
        "delta": 5543936.26
      },
      {
        "periodo": 202607,
        "valor": 157609233.18,
        "delta": -10321595.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 24367263757.98,
    "valor_anterior": 9743801492.7,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8843108594.28,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8519458127.7,
        "delta": -323650466.58
      },
      {
        "periodo": 202509,
        "valor": 9283197698.56,
        "delta": 763739570.86
      },
      {
        "periodo": 202510,
        "valor": 9706811770.19,
        "delta": 423614071.63
      },
      {
        "periodo": 202511,
        "valor": 9307626413.7,
        "delta": -399185356.49
      },
      {
        "periodo": 202512,
        "valor": 9704794790.83,
        "delta": 397168377.13
      },
      {
        "periodo": 202601,
        "valor": 9871688654.7,
        "delta": 166893863.87
      },
      {
        "periodo": 202602,
        "valor": 9798471784.96,
        "delta": -73216869.74
      },
      {
        "periodo": 202603,
        "valor": 9558159350.99,
        "delta": -240312433.97
      },
      {
        "periodo": 202604,
        "valor": 9534659005.09,
        "delta": -23500345.9
      },
      {
        "periodo": 202605,
        "valor": 9826558239.73,
        "delta": 291899234.64
      },
      {
        "periodo": 202606,
        "valor": 9743801492.7,
        "delta": -82756747.03
      },
      {
        "periodo": 202607,
        "valor": 24367263757.98,
        "delta": 14623462265.28
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 26756666907.0,
    "valor_anterior": 27105719753.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 23599234547.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23990257651.0,
        "delta": 391023104.0
      },
      {
        "periodo": 202509,
        "valor": 24964527108.0,
        "delta": 974269457.0
      },
      {
        "periodo": 202510,
        "valor": 20552933754.0,
        "delta": -4411593354.0
      },
      {
        "periodo": 202511,
        "valor": 20616389890.0,
        "delta": 63456136.0
      },
      {
        "periodo": 202512,
        "valor": 28303738858.0,
        "delta": 7687348968.0
      },
      {
        "periodo": 202601,
        "valor": 27724618508.0,
        "delta": -579120350.0
      },
      {
        "periodo": 202602,
        "valor": 27310298080.0,
        "delta": -414320428.0
      },
      {
        "periodo": 202603,
        "valor": 27463232951.0,
        "delta": 152934871.0
      },
      {
        "periodo": 202604,
        "valor": 27089732103.0,
        "delta": -373500848.0
      },
      {
        "periodo": 202605,
        "valor": 26780732010.0,
        "delta": -309000093.0
      },
      {
        "periodo": 202606,
        "valor": 27105719753.0,
        "delta": 324987743.0
      },
      {
        "periodo": 202607,
        "valor": 26756666907.0,
        "delta": -349052846.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 3493228555.0,
    "valor_anterior": 3523801438.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4825551139.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4805997737.0,
        "delta": -19553402.0
      },
      {
        "periodo": 202509,
        "valor": 4700565381.0,
        "delta": -105432356.0
      },
      {
        "periodo": 202510,
        "valor": 3750810472.0,
        "delta": -949754909.0
      },
      {
        "periodo": 202511,
        "valor": 3734512152.0,
        "delta": -16298320.0
      },
      {
        "periodo": 202512,
        "valor": 3704211634.0,
        "delta": -30300518.0
      },
      {
        "periodo": 202601,
        "valor": 3694369876.0,
        "delta": -9841758.0
      },
      {
        "periodo": 202602,
        "valor": 3665687417.0,
        "delta": -28682459.0
      },
      {
        "periodo": 202603,
        "valor": 3625376496.0,
        "delta": -40310921.0
      },
      {
        "periodo": 202604,
        "valor": 3564048247.0,
        "delta": -61328249.0
      },
      {
        "periodo": 202605,
        "valor": 3554045061.0,
        "delta": -10003186.0
      },
      {
        "periodo": 202606,
        "valor": 3523801438.0,
        "delta": -30243623.0
      },
      {
        "periodo": 202607,
        "valor": 3493228555.0,
        "delta": -30572883.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 27249014773.780003,
    "valor_anterior": 27347852468.67,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 29518392155.85,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29673572436.55,
        "delta": 155180280.7
      },
      {
        "periodo": 202509,
        "valor": 28787619068.64,
        "delta": -885953367.91
      },
      {
        "periodo": 202510,
        "valor": 29334603946.2,
        "delta": 546984877.56
      },
      {
        "periodo": 202511,
        "valor": 28971360541.76,
        "delta": -363243404.44
      },
      {
        "periodo": 202512,
        "valor": 28959836649.25,
        "delta": -11523892.51
      },
      {
        "periodo": 202601,
        "valor": 28711091851.15,
        "delta": -248744798.1
      },
      {
        "periodo": 202602,
        "valor": 28404281560.38,
        "delta": -306810290.77
      },
      {
        "periodo": 202603,
        "valor": 28717314944.26,
        "delta": 313033383.88
      },
      {
        "periodo": 202604,
        "valor": 28453264565.11,
        "delta": -264050379.15
      },
      {
        "periodo": 202605,
        "valor": 27916291871.34,
        "delta": -536972693.77
      },
      {
        "periodo": 202606,
        "valor": 27347852468.67,
        "delta": -568439402.67
      },
      {
        "periodo": 202607,
        "valor": 27249014773.78,
        "delta": -98837694.89
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 18194199358.0,
    "valor_anterior": 18669595235.999996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26412948867.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26426525164.0,
        "delta": 13576297.0
      },
      {
        "periodo": 202509,
        "valor": 26389727060.0,
        "delta": -36798104.0
      },
      {
        "periodo": 202510,
        "valor": 27602879586.0,
        "delta": 1213152526.0
      },
      {
        "periodo": 202511,
        "valor": 27604369807.0,
        "delta": 1490221.0
      },
      {
        "periodo": 202512,
        "valor": 19376648453.0,
        "delta": -8227721354.0
      },
      {
        "periodo": 202601,
        "valor": 18894647077.0,
        "delta": -482001376.0
      },
      {
        "periodo": 202602,
        "valor": 18878958789.0,
        "delta": -15688288.0
      },
      {
        "periodo": 202603,
        "valor": 18853671590.0,
        "delta": -25287199.0
      },
      {
        "periodo": 202604,
        "valor": 18710792643.0,
        "delta": -142878947.0
      },
      {
        "periodo": 202605,
        "valor": 18707961394.0,
        "delta": -2831249.0
      },
      {
        "periodo": 202606,
        "valor": 18669595236.0,
        "delta": -38366158.0
      },
      {
        "periodo": 202607,
        "valor": 18194199358.0,
        "delta": -475395878.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 17757172709.0,
    "valor_anterior": 19368492873.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16193438450.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14566757246.0,
        "delta": -1626681204.0
      },
      {
        "periodo": 202509,
        "valor": 14046931184.0,
        "delta": -519826062.0
      },
      {
        "periodo": 202510,
        "valor": 16029480841.0,
        "delta": 1982549657.0
      },
      {
        "periodo": 202511,
        "valor": 20110565489.0,
        "delta": 4081084648.0
      },
      {
        "periodo": 202512,
        "valor": 22654532094.0,
        "delta": 2543966605.0
      },
      {
        "periodo": 202601,
        "valor": 25245473224.0,
        "delta": 2590941130.0
      },
      {
        "periodo": 202602,
        "valor": 25601211405.0,
        "delta": 355738181.0
      },
      {
        "periodo": 202603,
        "valor": 23905727566.0,
        "delta": -1695483839.0
      },
      {
        "periodo": 202604,
        "valor": 23129603238.0,
        "delta": -776124328.0
      },
      {
        "periodo": 202605,
        "valor": 21514814082.0,
        "delta": -1614789156.0
      },
      {
        "periodo": 202606,
        "valor": 19368492873.0,
        "delta": -2146321209.0
      },
      {
        "periodo": 202607,
        "valor": 17757172709.0,
        "delta": -1611320164.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 37822873247.0,
    "valor_anterior": 31829012625.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22276704733.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24242160724.0,
        "delta": 1965455991.0
      },
      {
        "periodo": 202509,
        "valor": 22568705993.0,
        "delta": -1673454731.0
      },
      {
        "periodo": 202510,
        "valor": 26738705603.0,
        "delta": 4169999610.0
      },
      {
        "periodo": 202511,
        "valor": 26987987432.0,
        "delta": 249281829.0
      },
      {
        "periodo": 202512,
        "valor": 29676204704.0,
        "delta": 2688217272.0
      },
      {
        "periodo": 202601,
        "valor": 29251491514.0,
        "delta": -424713190.0
      },
      {
        "periodo": 202602,
        "valor": 28961796802.0,
        "delta": -289694712.0
      },
      {
        "periodo": 202603,
        "valor": 28655436985.0,
        "delta": -306359817.0
      },
      {
        "periodo": 202604,
        "valor": 30590578095.0,
        "delta": 1935141110.0
      },
      {
        "periodo": 202605,
        "valor": 32449707514.0,
        "delta": 1859129419.0
      },
      {
        "periodo": 202606,
        "valor": 31829012625.0,
        "delta": -620694889.0
      },
      {
        "periodo": 202607,
        "valor": 37822873247.0,
        "delta": 5993860622.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 1859574234.62,
    "valor_anterior": 1737703393.76,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1874560340.6,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1885438089.08,
        "delta": 10877748.48
      },
      {
        "periodo": 202509,
        "valor": 1991124916.52,
        "delta": 105686827.44
      },
      {
        "periodo": 202510,
        "valor": 1981380309.43,
        "delta": -9744607.09
      },
      {
        "periodo": 202511,
        "valor": 1658602058.09,
        "delta": -322778251.34
      },
      {
        "periodo": 202512,
        "valor": 1637643764.8,
        "delta": -20958293.29
      },
      {
        "periodo": 202601,
        "valor": 1634150393.14,
        "delta": -3493371.66
      },
      {
        "periodo": 202602,
        "valor": 1668463946.8,
        "delta": 34313553.66
      },
      {
        "periodo": 202603,
        "valor": 1697201314.98,
        "delta": 28737368.18
      },
      {
        "periodo": 202604,
        "valor": 1742621862.52,
        "delta": 45420547.54
      },
      {
        "periodo": 202605,
        "valor": 1743790719.21,
        "delta": 1168856.69
      },
      {
        "periodo": 202606,
        "valor": 1737703393.76,
        "delta": -6087325.45
      },
      {
        "periodo": 202607,
        "valor": 1859574234.62,
        "delta": 121870840.86
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 2246017285.0,
    "valor_anterior": 2302599121.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2732487779.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2600774275.0,
        "delta": -131713504.0
      },
      {
        "periodo": 202509,
        "valor": 2568545800.0,
        "delta": -32228475.0
      },
      {
        "periodo": 202510,
        "valor": 2677444820.0,
        "delta": 108899020.0
      },
      {
        "periodo": 202511,
        "valor": 2607429657.0,
        "delta": -70015163.0
      },
      {
        "periodo": 202512,
        "valor": 2580349895.0,
        "delta": -27079762.0
      },
      {
        "periodo": 202601,
        "valor": 2602647176.0,
        "delta": 22297281.0
      },
      {
        "periodo": 202602,
        "valor": 2557222376.0,
        "delta": -45424800.0
      },
      {
        "periodo": 202603,
        "valor": 2547156018.0,
        "delta": -10066358.0
      },
      {
        "periodo": 202604,
        "valor": 2461987792.0,
        "delta": -85168226.0
      },
      {
        "periodo": 202605,
        "valor": 2333840976.0,
        "delta": -128146816.0
      },
      {
        "periodo": 202606,
        "valor": 2302599121.0,
        "delta": -31241855.0
      },
      {
        "periodo": 202607,
        "valor": 2246017285.0,
        "delta": -56581836.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 32111177.0,
    "valor_anterior": 51587103.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 120604707.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 90676652.0,
        "delta": -29928055.0
      },
      {
        "periodo": 202509,
        "valor": 92519706.0,
        "delta": 1843054.0
      },
      {
        "periodo": 202510,
        "valor": 91543780.0,
        "delta": -975926.0
      },
      {
        "periodo": 202511,
        "valor": 98038945.0,
        "delta": 6495165.0
      },
      {
        "periodo": 202512,
        "valor": 98155010.0,
        "delta": 116065.0
      },
      {
        "periodo": 202601,
        "valor": 81629084.0,
        "delta": -16525926.0
      },
      {
        "periodo": 202602,
        "valor": 80017150.0,
        "delta": -1611934.0
      },
      {
        "periodo": 202603,
        "valor": 77303227.0,
        "delta": -2713923.0
      },
      {
        "periodo": 202604,
        "valor": 75622272.0,
        "delta": -1680955.0
      },
      {
        "periodo": 202605,
        "valor": 70373338.0,
        "delta": -5248934.0
      },
      {
        "periodo": 202606,
        "valor": 51587103.0,
        "delta": -18786235.0
      },
      {
        "periodo": 202607,
        "valor": 32111177.0,
        "delta": -19475926.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 1552172137.0,
    "valor_anterior": 1602054177.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2090427491.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2141637980.0,
        "delta": 51210489.0
      },
      {
        "periodo": 202509,
        "valor": 2303332598.0,
        "delta": 161694618.0
      },
      {
        "periodo": 202510,
        "valor": 2401067645.0,
        "delta": 97735047.0
      },
      {
        "periodo": 202511,
        "valor": 2399847084.0,
        "delta": -1220561.0
      },
      {
        "periodo": 202512,
        "valor": 2336188150.0,
        "delta": -63658934.0
      },
      {
        "periodo": 202601,
        "valor": 2878440057.0,
        "delta": 542251907.0
      },
      {
        "periodo": 202602,
        "valor": 1625063873.0,
        "delta": -1253376184.0
      },
      {
        "periodo": 202603,
        "valor": 1765099291.0,
        "delta": 140035418.0
      },
      {
        "periodo": 202604,
        "valor": 1724609485.0,
        "delta": -40489806.0
      },
      {
        "periodo": 202605,
        "valor": 1667389271.0,
        "delta": -57220214.0
      },
      {
        "periodo": 202606,
        "valor": 1602054177.0,
        "delta": -65335094.0
      },
      {
        "periodo": 202607,
        "valor": 1552172137.0,
        "delta": -49882040.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 5471884015.35,
    "valor_anterior": 5691984264.46,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4058592658.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4799936840.87,
        "delta": 741344182.22
      },
      {
        "periodo": 202509,
        "valor": 4700103511.38,
        "delta": -99833329.49
      },
      {
        "periodo": 202510,
        "valor": 4665576381.58,
        "delta": -34527129.8
      },
      {
        "periodo": 202511,
        "valor": 4940405622.38,
        "delta": 274829240.8
      },
      {
        "periodo": 202512,
        "valor": 5458432004.7,
        "delta": 518026382.32
      },
      {
        "periodo": 202601,
        "valor": 5300229984.6,
        "delta": -158202020.1
      },
      {
        "periodo": 202602,
        "valor": 5209711225.74,
        "delta": -90518758.86
      },
      {
        "periodo": 202603,
        "valor": 5253870717.45,
        "delta": 44159491.71
      },
      {
        "periodo": 202604,
        "valor": 4974941585.79,
        "delta": -278929131.66
      },
      {
        "periodo": 202605,
        "valor": 4953021491.57,
        "delta": -21920094.22
      },
      {
        "periodo": 202606,
        "valor": 5691984264.46,
        "delta": 738962772.89
      },
      {
        "periodo": 202607,
        "valor": 5471884015.35,
        "delta": -220100249.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 7815382926.0,
    "valor_anterior": 13145717675.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7093060604.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7014425136.0,
        "delta": -78635468.0
      },
      {
        "periodo": 202509,
        "valor": 12382210388.0,
        "delta": 5367785252.0
      },
      {
        "periodo": 202510,
        "valor": 6984406459.0,
        "delta": -5397803929.0
      },
      {
        "periodo": 202511,
        "valor": 7517678246.0,
        "delta": 533271787.0
      },
      {
        "periodo": 202512,
        "valor": 7400271298.0,
        "delta": -117406948.0
      },
      {
        "periodo": 202601,
        "valor": 9773774219.0,
        "delta": 2373502921.0
      },
      {
        "periodo": 202602,
        "valor": 11391847654.0,
        "delta": 1618073435.0
      },
      {
        "periodo": 202603,
        "valor": 11853999713.0,
        "delta": 462152059.0
      },
      {
        "periodo": 202604,
        "valor": 9799797303.0,
        "delta": -2054202410.0
      },
      {
        "periodo": 202605,
        "valor": 9726655554.0,
        "delta": -73141749.0
      },
      {
        "periodo": 202606,
        "valor": 13145717675.0,
        "delta": 3419062121.0
      },
      {
        "periodo": 202607,
        "valor": 7815382926.0,
        "delta": -5330334749.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 125874784.86,
    "valor_anterior": 125875784.86,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 196993402.44,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 196771086.44,
        "delta": -222316.0
      },
      {
        "periodo": 202509,
        "valor": 195326056.06,
        "delta": -1445030.38
      },
      {
        "periodo": 202510,
        "valor": 192433285.51,
        "delta": -2892770.55
      },
      {
        "periodo": 202511,
        "valor": 146638379.5,
        "delta": -45794906.01
      },
      {
        "periodo": 202512,
        "valor": 144509658.82,
        "delta": -2128720.68
      },
      {
        "periodo": 202601,
        "valor": 143662342.82,
        "delta": -847316.0
      },
      {
        "periodo": 202602,
        "valor": 138813340.0,
        "delta": -4849002.82
      },
      {
        "periodo": 202603,
        "valor": 136848244.92,
        "delta": -1965095.08
      },
      {
        "periodo": 202604,
        "valor": 127276570.12,
        "delta": -9571674.8
      },
      {
        "periodo": 202605,
        "valor": 127275570.12,
        "delta": -1000.0
      },
      {
        "periodo": 202606,
        "valor": 125875784.86,
        "delta": -1399785.26
      },
      {
        "periodo": 202607,
        "valor": 125874784.86,
        "delta": -1000.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 2995702777.0,
    "valor_anterior": 3024391057.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 967265097.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1074878703.0,
        "delta": 107613606.0
      },
      {
        "periodo": 202509,
        "valor": 1037122160.0,
        "delta": -37756543.0
      },
      {
        "periodo": 202510,
        "valor": 1029449125.0,
        "delta": -7673035.0
      },
      {
        "periodo": 202511,
        "valor": 1014622656.0,
        "delta": -14826469.0
      },
      {
        "periodo": 202512,
        "valor": 993536378.0,
        "delta": -21086278.0
      },
      {
        "periodo": 202601,
        "valor": 973962158.0,
        "delta": -19574220.0
      },
      {
        "periodo": 202602,
        "valor": 960158964.0,
        "delta": -13803194.0
      },
      {
        "periodo": 202603,
        "valor": 944850727.0,
        "delta": -15308237.0
      },
      {
        "periodo": 202604,
        "valor": 941960413.0,
        "delta": -2890314.0
      },
      {
        "periodo": 202605,
        "valor": 3029747710.0,
        "delta": 2087787297.0
      },
      {
        "periodo": 202606,
        "valor": 3024391057.0,
        "delta": -5356653.0
      },
      {
        "periodo": 202607,
        "valor": 2995702777.0,
        "delta": -28688280.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 79813463672.0,
    "valor_anterior": 36881053385.43,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 56621041957.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 56263023394.62,
        "delta": -358018562.91
      },
      {
        "periodo": 202509,
        "valor": 46012732175.72,
        "delta": -10250291218.9
      },
      {
        "periodo": 202510,
        "valor": 46462510608.12,
        "delta": 449778432.4
      },
      {
        "periodo": 202511,
        "valor": 45944996911.57,
        "delta": -517513696.55
      },
      {
        "periodo": 202512,
        "valor": 37959040387.43,
        "delta": -7985956524.14
      },
      {
        "periodo": 202601,
        "valor": 36716579609.72,
        "delta": -1242460777.71
      },
      {
        "periodo": 202602,
        "valor": 36306047293.77,
        "delta": -410532315.95
      },
      {
        "periodo": 202603,
        "valor": 37780768398.34,
        "delta": 1474721104.57
      },
      {
        "periodo": 202604,
        "valor": 36818722662.72,
        "delta": -962045735.62
      },
      {
        "periodo": 202605,
        "valor": 36550310830.16,
        "delta": -268411832.56
      },
      {
        "periodo": 202606,
        "valor": 36881053385.43,
        "delta": 330742555.27
      },
      {
        "periodo": 202607,
        "valor": 79813463672.0,
        "delta": 42932410286.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 3512534.0,
    "valor_anterior": 3507654.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 3507654.0,
        "delta": 3507654.0
      },
      {
        "periodo": 202607,
        "valor": 3512534.0,
        "delta": 4880.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 18569285714.0,
    "valor_anterior": 19062285714.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16056857143.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18002857143.0,
        "delta": 1946000000.0
      },
      {
        "periodo": 202509,
        "valor": 19297857143.0,
        "delta": 1295000000.0
      },
      {
        "periodo": 202510,
        "valor": 19481571428.0,
        "delta": 183714285.0
      },
      {
        "periodo": 202511,
        "valor": 19480571429.0,
        "delta": -999999.0
      },
      {
        "periodo": 202512,
        "valor": 20427571428.0,
        "delta": 946999999.0
      },
      {
        "periodo": 202601,
        "valor": 19282571429.0,
        "delta": -1144999999.0
      },
      {
        "periodo": 202602,
        "valor": 19278571429.0,
        "delta": -4000000.0
      },
      {
        "periodo": 202603,
        "valor": 19773571429.0,
        "delta": 495000000.0
      },
      {
        "periodo": 202604,
        "valor": 19657285714.0,
        "delta": -116285715.0
      },
      {
        "periodo": 202605,
        "valor": 19656285714.0,
        "delta": -1000000.0
      },
      {
        "periodo": 202606,
        "valor": 19062285714.0,
        "delta": -594000000.0
      },
      {
        "periodo": 202607,
        "valor": 18569285714.0,
        "delta": -493000000.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 7009650596.999999,
    "valor_anterior": 7145147020.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2811089680.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2883042867.0,
        "delta": 71953187.0
      },
      {
        "periodo": 202509,
        "valor": 2847582919.0,
        "delta": -35459948.0
      },
      {
        "periodo": 202510,
        "valor": 2893513873.0,
        "delta": 45930954.0
      },
      {
        "periodo": 202511,
        "valor": 2960179329.0,
        "delta": 66665456.0
      },
      {
        "periodo": 202512,
        "valor": 5989200613.0,
        "delta": 3029021284.0
      },
      {
        "periodo": 202601,
        "valor": 6043766233.0,
        "delta": 54565620.0
      },
      {
        "periodo": 202602,
        "valor": 5987032432.0,
        "delta": -56733801.0
      },
      {
        "periodo": 202603,
        "valor": 5840044233.0,
        "delta": -146988199.0
      },
      {
        "periodo": 202604,
        "valor": 7102784142.0,
        "delta": 1262739909.0
      },
      {
        "periodo": 202605,
        "valor": 7058605292.0,
        "delta": -44178850.0
      },
      {
        "periodo": 202606,
        "valor": 7145147020.0,
        "delta": 86541728.0
      },
      {
        "periodo": 202607,
        "valor": 7009650597.0,
        "delta": -135496423.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 151672333.0,
    "valor_anterior": 153841535.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 72916667.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 70833333.0,
        "delta": -2083334.0
      },
      {
        "periodo": 202509,
        "valor": 68750000.0,
        "delta": -2083333.0
      },
      {
        "periodo": 202510,
        "valor": 66666667.0,
        "delta": -2083333.0
      },
      {
        "periodo": 202511,
        "valor": 64583333.0,
        "delta": -2083334.0
      },
      {
        "periodo": 202512,
        "valor": 62500000.0,
        "delta": -2083333.0
      },
      {
        "periodo": 202601,
        "valor": 60416667.0,
        "delta": -2083333.0
      },
      {
        "periodo": 202602,
        "valor": 58333333.0,
        "delta": -2083334.0
      },
      {
        "periodo": 202603,
        "valor": 130028383.0,
        "delta": 71695050.0
      },
      {
        "periodo": 202604,
        "valor": 126155050.0,
        "delta": -3873333.0
      },
      {
        "periodo": 202605,
        "valor": 71834580.0,
        "delta": -54320470.0
      },
      {
        "periodo": 202606,
        "valor": 153841535.0,
        "delta": 82006955.0
      },
      {
        "periodo": 202607,
        "valor": 151672333.0,
        "delta": -2169202.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13500760.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -13500760.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 3197924103.99,
    "valor_anterior": 3244713793.83,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4140022705.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4023034454.13,
        "delta": -116988251.37
      },
      {
        "periodo": 202509,
        "valor": 2838173161.62,
        "delta": -1184861292.51
      },
      {
        "periodo": 202510,
        "valor": 3542255481.82,
        "delta": 704082320.2
      },
      {
        "periodo": 202511,
        "valor": 4033299028.72,
        "delta": 491043546.9
      },
      {
        "periodo": 202512,
        "valor": 3656905238.77,
        "delta": -376393789.95
      },
      {
        "periodo": 202601,
        "valor": 3530637322.16,
        "delta": -126267916.61
      },
      {
        "periodo": 202602,
        "valor": 3223425475.58,
        "delta": -307211846.58
      },
      {
        "periodo": 202603,
        "valor": 3316402077.59,
        "delta": 92976602.01
      },
      {
        "periodo": 202604,
        "valor": 3655947850.33,
        "delta": 339545772.74
      },
      {
        "periodo": 202605,
        "valor": 3487604728.7,
        "delta": -168343121.63
      },
      {
        "periodo": 202606,
        "valor": 3244713793.83,
        "delta": -242890934.87
      },
      {
        "periodo": 202607,
        "valor": 3197924103.99,
        "delta": -46789689.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 465000000.0,
    "valor_anterior": 465000000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 65000000.0,
        "delta": 65000000.0
      },
      {
        "periodo": 202510,
        "valor": 265000000.0,
        "delta": 200000000.0
      },
      {
        "periodo": 202511,
        "valor": 265000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 265000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 466803692.0,
        "delta": 201803692.0
      },
      {
        "periodo": 202602,
        "valor": 468091840.0,
        "delta": 1288148.0
      },
      {
        "periodo": 202603,
        "valor": 468259579.0,
        "delta": 167739.0
      },
      {
        "periodo": 202604,
        "valor": 465011513.0,
        "delta": -3248066.0
      },
      {
        "periodo": 202605,
        "valor": 468088140.0,
        "delta": 3076627.0
      },
      {
        "periodo": 202606,
        "valor": 465000000.0,
        "delta": -3088140.0
      },
      {
        "periodo": 202607,
        "valor": 465000000.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 1700000000.0,
    "valor_anterior": 1700000000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2100000000.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2100000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 2100000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 2100000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 2100000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 1250000000.0,
        "delta": -850000000.0
      },
      {
        "periodo": 202601,
        "valor": 750000000.0,
        "delta": -500000000.0
      },
      {
        "periodo": 202602,
        "valor": 1100000000.0,
        "delta": 350000000.0
      },
      {
        "periodo": 202603,
        "valor": 1700000000.0,
        "delta": 600000000.0
      },
      {
        "periodo": 202604,
        "valor": 1700000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1700000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1700000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 1700000000.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 87283048.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -87283048.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 2533334.0,
    "valor_anterior": 3166667.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11483333.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11483333.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 9316667.0,
        "delta": -2166666.0
      },
      {
        "periodo": 202510,
        "valor": 8233333.0,
        "delta": -1083334.0
      },
      {
        "periodo": 202511,
        "valor": 8233333.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 6966667.0,
        "delta": -1266666.0
      },
      {
        "periodo": 202601,
        "valor": 6966667.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 6333334.0,
        "delta": -633333.0
      },
      {
        "periodo": 202603,
        "valor": 5066667.0,
        "delta": -1266667.0
      },
      {
        "periodo": 202604,
        "valor": 4433334.0,
        "delta": -633333.0
      },
      {
        "periodo": 202605,
        "valor": 4433334.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 3166667.0,
        "delta": -1266667.0
      },
      {
        "periodo": 202607,
        "valor": 2533334.0,
        "delta": -633333.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 13505846.0,
    "valor_anterior": 13399035.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25298343.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25252714.0,
        "delta": -45629.0
      },
      {
        "periodo": 202509,
        "valor": 17945485.0,
        "delta": -7307229.0
      },
      {
        "periodo": 202510,
        "valor": 18107695.0,
        "delta": 162210.0
      },
      {
        "periodo": 202511,
        "valor": 18251315.0,
        "delta": 143620.0
      },
      {
        "periodo": 202512,
        "valor": 18387299.0,
        "delta": 135984.0
      },
      {
        "periodo": 202601,
        "valor": 12860688.0,
        "delta": -5526611.0
      },
      {
        "periodo": 202602,
        "valor": 12962844.0,
        "delta": 102156.0
      },
      {
        "periodo": 202603,
        "valor": 13075777.0,
        "delta": 112933.0
      },
      {
        "periodo": 202604,
        "valor": 13184590.0,
        "delta": 108813.0
      },
      {
        "periodo": 202605,
        "valor": 13294615.0,
        "delta": 110025.0
      },
      {
        "periodo": 202606,
        "valor": 13399035.0,
        "delta": 104420.0
      },
      {
        "periodo": 202607,
        "valor": 13505846.0,
        "delta": 106811.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 946965882.24,
    "valor_anterior": 1079683080.39,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1046221961.58,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1093059801.79,
        "delta": 46837840.21
      },
      {
        "periodo": 202509,
        "valor": 1009148042.14,
        "delta": -83911759.65
      },
      {
        "periodo": 202510,
        "valor": 1024210260.37,
        "delta": 15062218.23
      },
      {
        "periodo": 202511,
        "valor": 990215458.76,
        "delta": -33994801.61
      },
      {
        "periodo": 202512,
        "valor": 925902267.32,
        "delta": -64313191.44
      },
      {
        "periodo": 202601,
        "valor": 934733727.93,
        "delta": 8831460.61
      },
      {
        "periodo": 202602,
        "valor": 893099809.19,
        "delta": -41633918.74
      },
      {
        "periodo": 202603,
        "valor": 957221712.8,
        "delta": 64121903.61
      },
      {
        "periodo": 202604,
        "valor": 793106742.52,
        "delta": -164114970.28
      },
      {
        "periodo": 202605,
        "valor": 734215843.14,
        "delta": -58890899.38
      },
      {
        "periodo": 202606,
        "valor": 1079683080.39,
        "delta": 345467237.25
      },
      {
        "periodo": 202607,
        "valor": 946965882.24,
        "delta": -132717198.15
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 5291208496.15,
    "valor_anterior": 2152514297.06,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1748382586.76,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2098354326.72,
        "delta": 349971739.96
      },
      {
        "periodo": 202509,
        "valor": 1846269257.57,
        "delta": -252085069.15
      },
      {
        "periodo": 202510,
        "valor": 2386210753.23,
        "delta": 539941495.66
      },
      {
        "periodo": 202511,
        "valor": 2518400441.23,
        "delta": 132189688.0
      },
      {
        "periodo": 202512,
        "valor": 2582262439.4,
        "delta": 63861998.17
      },
      {
        "periodo": 202601,
        "valor": 2575805592.87,
        "delta": -6456846.53
      },
      {
        "periodo": 202602,
        "valor": 2398899874.23,
        "delta": -176905718.64
      },
      {
        "periodo": 202603,
        "valor": 2321677214.43,
        "delta": -77222659.8
      },
      {
        "periodo": 202604,
        "valor": 2184090377.64,
        "delta": -137586836.79
      },
      {
        "periodo": 202605,
        "valor": 2725842459.18,
        "delta": 541752081.54
      },
      {
        "periodo": 202606,
        "valor": 2152514297.06,
        "delta": -573328162.12
      },
      {
        "periodo": 202607,
        "valor": 5291208496.15,
        "delta": 3138694199.09
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 774530733.37,
    "valor_anterior": 807791441.56,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1216864354.63,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1124799829.15,
        "delta": -92064525.48
      },
      {
        "periodo": 202509,
        "valor": 1054961936.68,
        "delta": -69837892.47
      },
      {
        "periodo": 202510,
        "valor": 992598890.05,
        "delta": -62363046.63
      },
      {
        "periodo": 202511,
        "valor": 940609291.95,
        "delta": -51989598.1
      },
      {
        "periodo": 202512,
        "valor": 834538602.7,
        "delta": -106070689.25
      },
      {
        "periodo": 202601,
        "valor": 775317736.99,
        "delta": -59220865.71
      },
      {
        "periodo": 202602,
        "valor": 773021429.58,
        "delta": -2296307.41
      },
      {
        "periodo": 202603,
        "valor": 966975062.51,
        "delta": 193953632.93
      },
      {
        "periodo": 202604,
        "valor": 926199665.48,
        "delta": -40775397.03
      },
      {
        "periodo": 202605,
        "valor": 884632996.58,
        "delta": -41566668.9
      },
      {
        "periodo": 202606,
        "valor": 807791441.56,
        "delta": -76841555.02
      },
      {
        "periodo": 202607,
        "valor": 774530733.37,
        "delta": -33260708.19
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 536941700.0,
    "valor_anterior": 384969200.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 264152000.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 261261000.0,
        "delta": -2891000.0
      },
      {
        "periodo": 202509,
        "valor": 256405800.0,
        "delta": -4855200.0
      },
      {
        "periodo": 202510,
        "valor": 260114400.0,
        "delta": 3708600.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": -260114400.0
      },
      {
        "periodo": 202512,
        "valor": 216096000.0,
        "delta": 216096000.0
      },
      {
        "periodo": 202601,
        "valor": 209041200.0,
        "delta": -7054800.0
      },
      {
        "periodo": 202602,
        "valor": 448026800.0,
        "delta": 238985600.0
      },
      {
        "periodo": 202603,
        "valor": 215102400.0,
        "delta": -232924400.0
      },
      {
        "periodo": 202604,
        "valor": 209625600.0,
        "delta": -5476800.0
      },
      {
        "periodo": 202605,
        "valor": 208081200.0,
        "delta": -1544400.0
      },
      {
        "periodo": 202606,
        "valor": 384969200.0,
        "delta": 176888000.0
      },
      {
        "periodo": 202607,
        "valor": 536941700.0,
        "delta": 151972500.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 52520993265.0,
    "valor_anterior": 50920417053.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 47194361928.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 47249788567.0,
        "delta": 55426639.0
      },
      {
        "periodo": 202509,
        "valor": 45284966813.0,
        "delta": -1964821754.0
      },
      {
        "periodo": 202510,
        "valor": 46210238561.0,
        "delta": 925271748.0
      },
      {
        "periodo": 202511,
        "valor": 46813469698.0,
        "delta": 603231137.0
      },
      {
        "periodo": 202512,
        "valor": 50344492745.0,
        "delta": 3531023047.0
      },
      {
        "periodo": 202601,
        "valor": 51217648714.0,
        "delta": 873155969.0
      },
      {
        "periodo": 202602,
        "valor": 52890801104.0,
        "delta": 1673152390.0
      },
      {
        "periodo": 202603,
        "valor": 56857668472.0,
        "delta": 3966867368.0
      },
      {
        "periodo": 202604,
        "valor": 57880374451.0,
        "delta": 1022705979.0
      },
      {
        "periodo": 202605,
        "valor": 54249307999.0,
        "delta": -3631066452.0
      },
      {
        "periodo": 202606,
        "valor": 50920417053.0,
        "delta": -3328890946.0
      },
      {
        "periodo": 202607,
        "valor": 52520993265.0,
        "delta": 1600576212.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 952678489.0,
    "valor_anterior": 1241100747.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 745419683.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 621113560.0,
        "delta": -124306123.0
      },
      {
        "periodo": 202509,
        "valor": 562695641.0,
        "delta": -58417919.0
      },
      {
        "periodo": 202510,
        "valor": 420419426.0,
        "delta": -142276215.0
      },
      {
        "periodo": 202511,
        "valor": 248621401.0,
        "delta": -171798025.0
      },
      {
        "periodo": 202512,
        "valor": 362265144.0,
        "delta": 113643743.0
      },
      {
        "periodo": 202601,
        "valor": 244878520.0,
        "delta": -117386624.0
      },
      {
        "periodo": 202602,
        "valor": 104182073.0,
        "delta": -140696447.0
      },
      {
        "periodo": 202603,
        "valor": 450455741.0,
        "delta": 346273668.0
      },
      {
        "periodo": 202604,
        "valor": 736608400.0,
        "delta": 286152659.0
      },
      {
        "periodo": 202605,
        "valor": 853478074.0,
        "delta": 116869674.0
      },
      {
        "periodo": 202606,
        "valor": 1241100747.0,
        "delta": 387622673.0
      },
      {
        "periodo": 202607,
        "valor": 952678489.0,
        "delta": -288422258.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 145955528.85,
    "valor_anterior": 152160706.71,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 198460009.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 190656058.81,
        "delta": -7803950.46
      },
      {
        "periodo": 202509,
        "valor": 221669333.07,
        "delta": 31013274.26
      },
      {
        "periodo": 202510,
        "valor": 217484252.04,
        "delta": -4185081.03
      },
      {
        "periodo": 202511,
        "valor": 208589235.36,
        "delta": -8895016.68
      },
      {
        "periodo": 202512,
        "valor": 187205951.94,
        "delta": -21383283.42
      },
      {
        "periodo": 202601,
        "valor": 177765299.79,
        "delta": -9440652.15
      },
      {
        "periodo": 202602,
        "valor": 171237909.8,
        "delta": -6527389.99
      },
      {
        "periodo": 202603,
        "valor": 170657529.36,
        "delta": -580380.44
      },
      {
        "periodo": 202604,
        "valor": 162423206.88,
        "delta": -8234322.48
      },
      {
        "periodo": 202605,
        "valor": 156463103.08,
        "delta": -5960103.8
      },
      {
        "periodo": 202606,
        "valor": 152160706.71,
        "delta": -4302396.37
      },
      {
        "periodo": 202607,
        "valor": 145955528.85,
        "delta": -6205177.86
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 1873307395.89,
    "valor_anterior": 1884006654.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3495197461.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2904322572.7,
        "delta": -590874888.8
      },
      {
        "periodo": 202509,
        "valor": 2085599010.77,
        "delta": -818723561.93
      },
      {
        "periodo": 202510,
        "valor": 1917977354.62,
        "delta": -167621656.15
      },
      {
        "periodo": 202511,
        "valor": 1896664997.75,
        "delta": -21312356.87
      },
      {
        "periodo": 202512,
        "valor": 1266771538.43,
        "delta": -629893459.32
      },
      {
        "periodo": 202601,
        "valor": 1395152773.5,
        "delta": 128381235.07
      },
      {
        "periodo": 202602,
        "valor": 1385823290.24,
        "delta": -9329483.26
      },
      {
        "periodo": 202603,
        "valor": 1779595099.1,
        "delta": 393771808.86
      },
      {
        "periodo": 202604,
        "valor": 1730547012.44,
        "delta": -49048086.66
      },
      {
        "periodo": 202605,
        "valor": 2046527790.51,
        "delta": 315980778.07
      },
      {
        "periodo": 202606,
        "valor": 1884006654.2,
        "delta": -162521136.31
      },
      {
        "periodo": 202607,
        "valor": 1873307395.89,
        "delta": -10699258.31
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 505458028.0,
    "valor_anterior": 508946456.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 251723499.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 250084438.0,
        "delta": -1639061.0
      },
      {
        "periodo": 202509,
        "valor": 245693899.0,
        "delta": -4390539.0
      },
      {
        "periodo": 202510,
        "valor": 98860078.0,
        "delta": -146833821.0
      },
      {
        "periodo": 202511,
        "valor": 97739489.0,
        "delta": -1120589.0
      },
      {
        "periodo": 202512,
        "valor": 456193483.0,
        "delta": 358453994.0
      },
      {
        "periodo": 202601,
        "valor": 442535348.0,
        "delta": -13658135.0
      },
      {
        "periodo": 202602,
        "valor": 439227286.0,
        "delta": -3308062.0
      },
      {
        "periodo": 202603,
        "valor": 456780867.0,
        "delta": 17553581.0
      },
      {
        "periodo": 202604,
        "valor": 411149782.0,
        "delta": -45631085.0
      },
      {
        "periodo": 202605,
        "valor": 409404308.0,
        "delta": -1745474.0
      },
      {
        "periodo": 202606,
        "valor": 508946456.0,
        "delta": 99542148.0
      },
      {
        "periodo": 202607,
        "valor": 505458028.0,
        "delta": -3488428.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 5069530242.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": -5069530242.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 352371335530.26,
    "valor_anterior": 293241823731.38,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 295057511969.52,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 291648538229.48,
        "delta": -3408973740.04
      },
      {
        "periodo": 202509,
        "valor": 282190518790.65,
        "delta": -9458019438.83
      },
      {
        "periodo": 202510,
        "valor": 282498374817.95,
        "delta": 307856027.3
      },
      {
        "periodo": 202511,
        "valor": 286477434672.71,
        "delta": 3979059854.76
      },
      {
        "periodo": 202512,
        "valor": 290009923480.66,
        "delta": 3532488807.95
      },
      {
        "periodo": 202601,
        "valor": 291799286272.88,
        "delta": 1789362792.22
      },
      {
        "periodo": 202602,
        "valor": 292362689396.19,
        "delta": 563403123.31
      },
      {
        "periodo": 202603,
        "valor": 303491443275.26,
        "delta": 11128753879.07
      },
      {
        "periodo": 202604,
        "valor": 297661101242.24,
        "delta": -5830342033.02
      },
      {
        "periodo": 202605,
        "valor": 295843002701.81,
        "delta": -1818098540.43
      },
      {
        "periodo": 202606,
        "valor": 293241823731.38,
        "delta": -2601178970.43
      },
      {
        "periodo": 202607,
        "valor": 352371335530.26,
        "delta": 59129511798.88
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 116263725073.51,
    "valor_anterior": 96731845637.91,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 96170004821.86,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 93230639232.49,
        "delta": -2939365589.37
      },
      {
        "periodo": 202509,
        "valor": 92961019628.86,
        "delta": -269619603.63
      },
      {
        "periodo": 202510,
        "valor": 93410591545.56,
        "delta": 449571916.7
      },
      {
        "periodo": 202511,
        "valor": 93363226924.02,
        "delta": -47364621.54
      },
      {
        "periodo": 202512,
        "valor": 96393600777.8,
        "delta": 3030373853.78
      },
      {
        "periodo": 202601,
        "valor": 94910974546.81,
        "delta": -1482626230.99
      },
      {
        "periodo": 202602,
        "valor": 93990491569.62,
        "delta": -920482977.19
      },
      {
        "periodo": 202603,
        "valor": 93573061344.97,
        "delta": -417430224.65
      },
      {
        "periodo": 202604,
        "valor": 94626707647.48,
        "delta": 1053646302.51
      },
      {
        "periodo": 202605,
        "valor": 96434412602.79,
        "delta": 1807704955.31
      },
      {
        "periodo": 202606,
        "valor": 96731845637.91,
        "delta": 297433035.12
      },
      {
        "periodo": 202607,
        "valor": 116263725073.51,
        "delta": 19531879435.6
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 128408118.86,
    "valor_anterior": 129042451.86,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 309260543.44,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 208254419.44,
        "delta": -101006124.0
      },
      {
        "periodo": 202509,
        "valor": 204642723.06,
        "delta": -3611696.38
      },
      {
        "periodo": 202510,
        "valor": 200666618.51,
        "delta": -3976104.55
      },
      {
        "periodo": 202511,
        "valor": 154871712.5,
        "delta": -45794906.01
      },
      {
        "periodo": 202512,
        "valor": 151476325.82,
        "delta": -3395386.68
      },
      {
        "periodo": 202601,
        "valor": 150629009.82,
        "delta": -847316.0
      },
      {
        "periodo": 202602,
        "valor": 145146674.0,
        "delta": -5482335.82
      },
      {
        "periodo": 202603,
        "valor": 141914911.92,
        "delta": -3231762.08
      },
      {
        "periodo": 202604,
        "valor": 131709904.12,
        "delta": -10205007.8
      },
      {
        "periodo": 202605,
        "valor": 131708904.12,
        "delta": -1000.0
      },
      {
        "periodo": 202606,
        "valor": 129042451.86,
        "delta": -2666452.26
      },
      {
        "periodo": 202607,
        "valor": 128408118.86,
        "delta": -634333.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 91427036020.0,
    "valor_anterior": 53931424358.43,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 68537017831.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 68019860785.62,
        "delta": -517157045.91
      },
      {
        "periodo": 202509,
        "valor": 63266820961.72,
        "delta": -4753039823.9
      },
      {
        "periodo": 202510,
        "valor": 58525429532.12,
        "delta": -4741391429.6
      },
      {
        "periodo": 202511,
        "valor": 58469951898.57,
        "delta": -55477633.55
      },
      {
        "periodo": 202512,
        "valor": 50275849730.43,
        "delta": -8194102168.14
      },
      {
        "periodo": 202601,
        "valor": 51971441061.72,
        "delta": 1695591331.29
      },
      {
        "periodo": 202602,
        "valor": 51880181196.77,
        "delta": -91259864.95
      },
      {
        "periodo": 202603,
        "valor": 53947023420.34,
        "delta": 2066842223.57
      },
      {
        "periodo": 202604,
        "valor": 50805117242.72,
        "delta": -3141906177.62
      },
      {
        "periodo": 202605,
        "valor": 50278196631.16,
        "delta": -526920611.56
      },
      {
        "periodo": 202606,
        "valor": 53931424358.43,
        "delta": 3653227727.27
      },
      {
        "periodo": 202607,
        "valor": 91427036020.0,
        "delta": 37495611661.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 109392108356.4,
    "valor_anterior": 109544003865.43,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 98559107651.45,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 97333477908.63,
        "delta": -1225629742.82
      },
      {
        "periodo": 202509,
        "valor": 93995347061.16,
        "delta": -3338130847.47
      },
      {
        "periodo": 202510,
        "valor": 97478666655.63,
        "delta": 3483319594.47
      },
      {
        "periodo": 202511,
        "valor": 101528799771.85,
        "delta": 4050133116.22
      },
      {
        "periodo": 202512,
        "valor": 110579242244.05,
        "delta": 9050442472.2
      },
      {
        "periodo": 202601,
        "valor": 113826092573.29,
        "delta": 3246850329.24
      },
      {
        "periodo": 202602,
        "valor": 115511949412.18,
        "delta": 1685856838.89
      },
      {
        "periodo": 202603,
        "valor": 117962807257.24,
        "delta": 2450857845.06
      },
      {
        "periodo": 202604,
        "valor": 119250608671.63,
        "delta": 1287801414.39
      },
      {
        "periodo": 202605,
        "valor": 115512557673.55,
        "delta": -3738050998.08
      },
      {
        "periodo": 202606,
        "valor": 109544003865.43,
        "delta": -5968553808.12
      },
      {
        "periodo": 202607,
        "valor": 109392108356.4,
        "delta": -151895509.03
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 11227848143.5,
    "valor_anterior": 8433507909.92,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9185241272.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8730414286.17,
        "delta": -454826986.57
      },
      {
        "periodo": 202509,
        "valor": 7461658111.23,
        "delta": -1268756174.94
      },
      {
        "periodo": 202510,
        "valor": 7494193556.31,
        "delta": 32535445.08
      },
      {
        "periodo": 202511,
        "valor": 7081713908.05,
        "delta": -412479648.26
      },
      {
        "periodo": 202512,
        "valor": 7010277735.79,
        "delta": -71436172.26
      },
      {
        "periodo": 202601,
        "valor": 6910136638.08,
        "delta": -100141097.71
      },
      {
        "periodo": 202602,
        "valor": 6764831799.04,
        "delta": -145304839.04
      },
      {
        "periodo": 202603,
        "valor": 7538873013.2,
        "delta": 774041214.16
      },
      {
        "periodo": 202604,
        "valor": 7368712698.96,
        "delta": -170160314.24
      },
      {
        "periodo": 202605,
        "valor": 8174148307.49,
        "delta": 805435608.53
      },
      {
        "periodo": 202606,
        "valor": 8433507909.92,
        "delta": 259359602.43
      },
      {
        "periodo": 202607,
        "valor": 11227848143.5,
        "delta": 2794340233.58
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100089,
    "label": "D.Largo Plazo",
    "valor_actual": 23932209817.99,
    "valor_anterior": 24471999507.83,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22296879848.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24125891597.13,
        "delta": 1829011748.63
      },
      {
        "periodo": 202509,
        "valor": 24301030304.62,
        "delta": 175138707.49
      },
      {
        "periodo": 202510,
        "valor": 25388826909.82,
        "delta": 1087796605.2
      },
      {
        "periodo": 202511,
        "valor": 25878870457.72,
        "delta": 490043547.9
      },
      {
        "periodo": 202512,
        "valor": 25599476666.77,
        "delta": -279393790.95
      },
      {
        "periodo": 202601,
        "valor": 24030012443.16,
        "delta": -1569464223.61
      },
      {
        "periodo": 202602,
        "valor": 24070088744.58,
        "delta": 40076301.42
      },
      {
        "periodo": 202603,
        "valor": 30327763327.59,
        "delta": 6257674583.01
      },
      {
        "periodo": 202604,
        "valor": 25478245077.33,
        "delta": -4849518250.26
      },
      {
        "periodo": 202605,
        "valor": 25311978582.7,
        "delta": -166266494.63
      },
      {
        "periodo": 202606,
        "valor": 24471999507.83,
        "delta": -839979074.87
      },
      {
        "periodo": 202607,
        "valor": 23932209817.99,
        "delta": -539789689.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 956292844809.25,
    "valor_anterior": 950605046500.59,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 928207737544.2301,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 931312969253.5602,
        "delta": 3105231709.3301
      },
      {
        "periodo": 202509,
        "valor": 937145680296.92,
        "delta": 5832711043.3599
      },
      {
        "periodo": 202510,
        "valor": 949235738739.43,
        "delta": 12090058442.51
      },
      {
        "periodo": 202511,
        "valor": 987125918533.36,
        "delta": 37890179793.9299
      },
      {
        "periodo": 202512,
        "valor": 931188362537.75,
        "delta": -55937555995.61
      },
      {
        "periodo": 202601,
        "valor": 961041064610.65,
        "delta": 29852702072.9
      },
      {
        "periodo": 202602,
        "valor": 922552191402.88,
        "delta": -38488873207.77
      },
      {
        "periodo": 202603,
        "valor": 921282459588.51,
        "delta": -1269731814.37
      },
      {
        "periodo": 202604,
        "valor": 923377206975.47,
        "delta": 2094747386.96
      },
      {
        "periodo": 202605,
        "valor": 954720436729.76,
        "delta": 31343229754.29
      },
      {
        "periodo": 202606,
        "valor": 950605046500.59,
        "delta": -4115390229.17
      },
      {
        "periodo": 202607,
        "valor": 956292844809.25,
        "delta": 5687798308.66
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 3297727731566.72,
    "valor_anterior": 3208751844265.69,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2949849771615.67,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2933002452674.91,
        "delta": -16847318940.7598
      },
      {
        "periodo": 202509,
        "valor": 2976177557987.65,
        "delta": 43175105312.7397
      },
      {
        "periodo": 202510,
        "valor": 2991568382317.1,
        "delta": 15390824329.4502
      },
      {
        "periodo": 202511,
        "valor": 3023705002789.56,
        "delta": 32136620472.46
      },
      {
        "periodo": 202512,
        "valor": 3037841574519.12,
        "delta": 14136571729.5601
      },
      {
        "periodo": 202601,
        "valor": 3065100534526.74,
        "delta": 27258960007.6201
      },
      {
        "periodo": 202602,
        "valor": 3134547987434.36,
        "delta": 69447452907.6196
      },
      {
        "periodo": 202603,
        "valor": 3142066406201.96,
        "delta": 7518418767.6001
      },
      {
        "periodo": 202604,
        "valor": 3200111256401.7505,
        "delta": 58044850199.7905
      },
      {
        "periodo": 202605,
        "valor": 3376573377277.59,
        "delta": 176462120875.8394
      },
      {
        "periodo": 202606,
        "valor": 3208751844265.69,
        "delta": -167821533011.8999
      },
      {
        "periodo": 202607,
        "valor": 3297727731566.72,
        "delta": 88975887301.0303
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 2012595758986.0,
    "valor_anterior": 1963700046733.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1812390047709.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1827016787968.0,
        "delta": 14626740259.0
      },
      {
        "periodo": 202509,
        "valor": 1852035655803.0,
        "delta": 25018867835.0
      },
      {
        "periodo": 202510,
        "valor": 1910981261149.0,
        "delta": 58945605346.0
      },
      {
        "periodo": 202511,
        "valor": 1890776012743.0,
        "delta": -20205248406.0
      },
      {
        "periodo": 202512,
        "valor": 1911985573492.0,
        "delta": 21209560749.0
      },
      {
        "periodo": 202601,
        "valor": 1916804123712.0,
        "delta": 4818550220.0
      },
      {
        "periodo": 202602,
        "valor": 1927746478220.0,
        "delta": 10942354508.0
      },
      {
        "periodo": 202603,
        "valor": 1953171075267.0,
        "delta": 25424597047.0
      },
      {
        "periodo": 202604,
        "valor": 1921009090244.0,
        "delta": -32161985023.0
      },
      {
        "periodo": 202605,
        "valor": 2085778328397.0,
        "delta": 164769238153.0
      },
      {
        "periodo": 202606,
        "valor": 1963700046733.0,
        "delta": -122078281664.0
      },
      {
        "periodo": 202607,
        "valor": 2012595758986.0,
        "delta": 48895712253.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 749508163894.0,
    "valor_anterior": 772210687601.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 821044199333.9999,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 802323804063.0,
        "delta": -18720395270.9999
      },
      {
        "periodo": 202509,
        "valor": 809214429011.0,
        "delta": 6890624948.0
      },
      {
        "periodo": 202510,
        "valor": 856354880786.9999,
        "delta": 47140451775.9999
      },
      {
        "periodo": 202511,
        "valor": 789297836295.0,
        "delta": -67057044491.9999
      },
      {
        "periodo": 202512,
        "valor": 787050898297.0,
        "delta": -2246937998.0
      },
      {
        "periodo": 202601,
        "valor": 797957149870.0,
        "delta": 10906251573.0
      },
      {
        "periodo": 202602,
        "valor": 775583174727.0,
        "delta": -22373975143.0
      },
      {
        "periodo": 202603,
        "valor": 769527919760.0,
        "delta": -6055254967.0
      },
      {
        "periodo": 202604,
        "valor": 764341374142.0,
        "delta": -5186545618.0
      },
      {
        "periodo": 202605,
        "valor": 788519981887.0,
        "delta": 24178607745.0
      },
      {
        "periodo": 202606,
        "valor": 772210687601.0,
        "delta": -16309294286.0
      },
      {
        "periodo": 202607,
        "valor": 749508163894.0,
        "delta": -22702523707.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 361970263639.62,
    "valor_anterior": 363659003988.29,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 329360759156.51,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 336640313368.7,
        "delta": 7279554212.19
      },
      {
        "periodo": 202509,
        "valor": 336186145683.45,
        "delta": -454167685.25
      },
      {
        "periodo": 202510,
        "valor": 332844122872.18,
        "delta": -3342022811.27
      },
      {
        "periodo": 202511,
        "valor": 333423240746.8,
        "delta": 579117874.62
      },
      {
        "periodo": 202512,
        "valor": 345130297008.83,
        "delta": 11707056262.03
      },
      {
        "periodo": 202601,
        "valor": 331745905377.11,
        "delta": -13384391631.72
      },
      {
        "periodo": 202602,
        "valor": 335212385090.39,
        "delta": 3466479713.28
      },
      {
        "periodo": 202603,
        "valor": 355526123191.8699,
        "delta": 20313738101.4799
      },
      {
        "periodo": 202604,
        "valor": 356529199140.96,
        "delta": 1003075949.0901
      },
      {
        "periodo": 202605,
        "valor": 355860753168.94,
        "delta": -668445972.02
      },
      {
        "periodo": 202606,
        "valor": 363659003988.29,
        "delta": 7798250819.35
      },
      {
        "periodo": 202607,
        "valor": 361970263639.62,
        "delta": -1688740348.67
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 504283721218.0,
    "valor_anterior": 508777717859.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 498462040520.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 503178212238.0,
        "delta": 4716171718.0
      },
      {
        "periodo": 202509,
        "valor": 504055197232.0,
        "delta": 876984994.0
      },
      {
        "periodo": 202510,
        "valor": 492580546980.0,
        "delta": -11474650252.0
      },
      {
        "periodo": 202511,
        "valor": 503812527904.0,
        "delta": 11231980924.0
      },
      {
        "periodo": 202512,
        "valor": 492189656014.0,
        "delta": -11622871890.0
      },
      {
        "periodo": 202601,
        "valor": 499435851172.0,
        "delta": 7246195158.0
      },
      {
        "periodo": 202602,
        "valor": 498342153023.9999,
        "delta": -1093698148.0001
      },
      {
        "periodo": 202603,
        "valor": 494472149761.0,
        "delta": -3870003262.9999
      },
      {
        "periodo": 202604,
        "valor": 517452067882.0,
        "delta": 22979918121.0
      },
      {
        "periodo": 202605,
        "valor": 500317181780.0,
        "delta": -17134886102.0
      },
      {
        "periodo": 202606,
        "valor": 508777717859.0,
        "delta": 8460536079.0
      },
      {
        "periodo": 202607,
        "valor": 504283721218.0,
        "delta": -4493996641.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 175849944903.0,
    "valor_anterior": 172210830910.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 149729926102.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 157773930503.0,
        "delta": 8044004401.0
      },
      {
        "periodo": 202509,
        "valor": 155452620837.0,
        "delta": -2321309666.0
      },
      {
        "periodo": 202510,
        "valor": 153163977826.0,
        "delta": -2288643011.0
      },
      {
        "periodo": 202511,
        "valor": 155237184681.0,
        "delta": 2073206855.0
      },
      {
        "periodo": 202512,
        "valor": 154189621320.0,
        "delta": -1047563361.0
      },
      {
        "periodo": 202601,
        "valor": 169308390410.0,
        "delta": 15118769090.0
      },
      {
        "periodo": 202602,
        "valor": 169529123147.0,
        "delta": 220732737.0
      },
      {
        "periodo": 202603,
        "valor": 173983271309.0,
        "delta": 4454148162.0
      },
      {
        "periodo": 202604,
        "valor": 176148497799.0,
        "delta": 2165226490.0
      },
      {
        "periodo": 202605,
        "valor": 178185836094.0,
        "delta": 2037338295.0
      },
      {
        "periodo": 202606,
        "valor": 172210830910.0,
        "delta": -5975005184.0
      },
      {
        "periodo": 202607,
        "valor": 175849944903.0,
        "delta": 3639113993.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 804505600500.0,
    "valor_anterior": 809931285219.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 770120367787.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 779532598657.0,
        "delta": 9412230870.0
      },
      {
        "periodo": 202509,
        "valor": 799986724538.0,
        "delta": 20454125881.0
      },
      {
        "periodo": 202510,
        "valor": 826650706696.0,
        "delta": 26663982158.0
      },
      {
        "periodo": 202511,
        "valor": 793634531485.0,
        "delta": -33016175211.0
      },
      {
        "periodo": 202512,
        "valor": 798059071335.0,
        "delta": 4424539850.0
      },
      {
        "periodo": 202601,
        "valor": 786023062901.0,
        "delta": -12036008434.0
      },
      {
        "periodo": 202602,
        "valor": 805250506637.0,
        "delta": 19227443736.0
      },
      {
        "periodo": 202603,
        "valor": 802644839670.0,
        "delta": -2605666967.0
      },
      {
        "periodo": 202604,
        "valor": 798363713974.0,
        "delta": -4281125696.0
      },
      {
        "periodo": 202605,
        "valor": 850517963918.0,
        "delta": 52154249944.0
      },
      {
        "periodo": 202606,
        "valor": 809931285219.0,
        "delta": -40586678699.0
      },
      {
        "periodo": 202607,
        "valor": 804505600500.0,
        "delta": -5425684719.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 245301316762.8,
    "valor_anterior": 244138740729.16,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 230210852401.18,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 233242410620.63,
        "delta": 3031558219.45
      },
      {
        "periodo": 202509,
        "valor": 238037423321.78,
        "delta": 4795012701.15
      },
      {
        "periodo": 202510,
        "valor": 239210642572.13,
        "delta": 1173219250.35
      },
      {
        "periodo": 202511,
        "valor": 243800792515.96,
        "delta": 4590149943.83
      },
      {
        "periodo": 202512,
        "valor": 243955414494.99,
        "delta": 154621979.03
      },
      {
        "periodo": 202601,
        "valor": 247384223017.25,
        "delta": 3428808522.26
      },
      {
        "periodo": 202602,
        "valor": 237491431305.01,
        "delta": -9892791712.24
      },
      {
        "periodo": 202603,
        "valor": 240830245822.52,
        "delta": 3338814517.51
      },
      {
        "periodo": 202604,
        "valor": 240088220346.0,
        "delta": -742025476.52
      },
      {
        "periodo": 202605,
        "valor": 245557985735.45,
        "delta": 5469765389.45
      },
      {
        "periodo": 202606,
        "valor": 244138740729.16,
        "delta": -1419245006.29
      },
      {
        "periodo": 202607,
        "valor": 245301316762.8,
        "delta": 1162576033.64
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 206718004301.00003,
    "valor_anterior": 206906870981.99997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 197210252604.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 182089276365.0,
        "delta": -15120976239.0
      },
      {
        "periodo": 202509,
        "valor": 176154454619.0,
        "delta": -5934821746.0
      },
      {
        "periodo": 202510,
        "valor": 189861427374.0,
        "delta": 13706972755.0
      },
      {
        "periodo": 202511,
        "valor": 189293305392.0,
        "delta": -568121982.0
      },
      {
        "periodo": 202512,
        "valor": 189420359275.0,
        "delta": 127053883.0
      },
      {
        "periodo": 202601,
        "valor": 197766361817.0,
        "delta": 8346002542.0
      },
      {
        "periodo": 202602,
        "valor": 204016663822.0,
        "delta": 6250302005.0
      },
      {
        "periodo": 202603,
        "valor": 202818186890.0,
        "delta": -1198476932.0
      },
      {
        "periodo": 202604,
        "valor": 198000422890.0,
        "delta": -4817764000.0
      },
      {
        "periodo": 202605,
        "valor": 214397384562.0,
        "delta": 16396961672.0
      },
      {
        "periodo": 202606,
        "valor": 206906870982.0,
        "delta": -7490513580.0
      },
      {
        "periodo": 202607,
        "valor": 206718004301.0,
        "delta": -188866680.9999
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 53883307006.0,
    "valor_anterior": 56402891260.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 65731396658.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 67419092235.0,
        "delta": 1687695577.0
      },
      {
        "periodo": 202509,
        "valor": 64128223975.0,
        "delta": -3290868260.0
      },
      {
        "periodo": 202510,
        "valor": 63390238485.0,
        "delta": -737985490.0
      },
      {
        "periodo": 202511,
        "valor": 62974424625.0,
        "delta": -415813860.0
      },
      {
        "periodo": 202512,
        "valor": 58007157092.0,
        "delta": -4967267533.0
      },
      {
        "periodo": 202601,
        "valor": 55592331427.0,
        "delta": -2414825665.0
      },
      {
        "periodo": 202602,
        "valor": 58717511122.0,
        "delta": 3125179695.0
      },
      {
        "periodo": 202603,
        "valor": 57600483721.0,
        "delta": -1117027401.0
      },
      {
        "periodo": 202604,
        "valor": 58712642038.0,
        "delta": 1112158317.0
      },
      {
        "periodo": 202605,
        "valor": 55914862688.0,
        "delta": -2797779350.0
      },
      {
        "periodo": 202606,
        "valor": 56402891260.0,
        "delta": 488028572.0
      },
      {
        "periodo": 202607,
        "valor": 53883307006.0,
        "delta": -2519584254.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 292480837486.0,
    "valor_anterior": 270180260589.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 302269448210.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 304936343396.0,
        "delta": 2666895186.0
      },
      {
        "periodo": 202509,
        "valor": 307750306009.0,
        "delta": 2813962613.0
      },
      {
        "periodo": 202510,
        "valor": 298240340521.0,
        "delta": -9509965488.0
      },
      {
        "periodo": 202511,
        "valor": 300609982773.0,
        "delta": 2369642252.0
      },
      {
        "periodo": 202512,
        "valor": 297260747456.0001,
        "delta": -3349235316.9999
      },
      {
        "periodo": 202601,
        "valor": 302789109450.0,
        "delta": 5528361993.9999
      },
      {
        "periodo": 202602,
        "valor": 283361928740.0,
        "delta": -19427180710.0
      },
      {
        "periodo": 202603,
        "valor": 284388930629.0,
        "delta": 1027001889.0
      },
      {
        "periodo": 202604,
        "valor": 276643595474.0,
        "delta": -7745335155.0
      },
      {
        "periodo": 202605,
        "valor": 274718402204.0,
        "delta": -1925193270.0
      },
      {
        "periodo": 202606,
        "valor": 270180260589.0,
        "delta": -4538141615.0
      },
      {
        "periodo": 202607,
        "valor": 292480837486.0,
        "delta": 22300576897.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 1860564014123.85,
    "valor_anterior": 1824321864470.52,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1721064160125.61,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1692059895286.34,
        "delta": -29004264839.27
      },
      {
        "periodo": 202509,
        "valor": 1694230689053.72,
        "delta": 2170793767.3799
      },
      {
        "periodo": 202510,
        "valor": 1702278494210.84,
        "delta": 8047805157.1201
      },
      {
        "periodo": 202511,
        "valor": 1753762427314.22,
        "delta": 51483933103.3799
      },
      {
        "periodo": 202512,
        "valor": 1814127438200.52,
        "delta": 60365010886.3
      },
      {
        "periodo": 202601,
        "valor": 1808401667061.91,
        "delta": -5725771138.6101
      },
      {
        "periodo": 202602,
        "valor": 1790829252020.33,
        "delta": -17572415041.5798
      },
      {
        "periodo": 202603,
        "valor": 1821182987824.63,
        "delta": 30353735804.2998
      },
      {
        "periodo": 202604,
        "valor": 1792617689244.01,
        "delta": -28565298580.6199
      },
      {
        "periodo": 202605,
        "valor": 1838705066294.71,
        "delta": 46087377050.7
      },
      {
        "periodo": 202606,
        "valor": 1824321864470.52,
        "delta": -14383201824.1899
      },
      {
        "periodo": 202607,
        "valor": 1860564014123.85,
        "delta": 36242149653.3301
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 100360679109.0,
    "valor_anterior": 111399991958.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 169631745691.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 180594159420.0,
        "delta": 10962413729.0
      },
      {
        "periodo": 202509,
        "valor": 109662075614.0,
        "delta": -70932083806.0
      },
      {
        "periodo": 202510,
        "valor": 208122467127.0,
        "delta": 98460391513.0
      },
      {
        "periodo": 202511,
        "valor": 173140170528.0,
        "delta": -34982296599.0
      },
      {
        "periodo": 202512,
        "valor": 97270243972.0,
        "delta": -75869926556.0
      },
      {
        "periodo": 202601,
        "valor": 143386882253.0,
        "delta": 46116638281.0
      },
      {
        "periodo": 202602,
        "valor": 154864390699.0,
        "delta": 11477508446.0
      },
      {
        "periodo": 202603,
        "valor": 135533540407.0,
        "delta": -19330850292.0
      },
      {
        "periodo": 202604,
        "valor": 139339212685.0,
        "delta": 3805672278.0
      },
      {
        "periodo": 202605,
        "valor": 170931930205.0,
        "delta": 31592717520.0
      },
      {
        "periodo": 202606,
        "valor": 111399991958.0,
        "delta": -59531938247.0
      },
      {
        "periodo": 202607,
        "valor": 100360679109.0,
        "delta": -11039312849.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 35448000543.0,
    "valor_anterior": 36132637316.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30905008916.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 30828375341.0,
        "delta": -76633575.0
      },
      {
        "periodo": 202509,
        "valor": 32253072028.0,
        "delta": 1424696687.0
      },
      {
        "periodo": 202510,
        "valor": 32711987718.0,
        "delta": 458915690.0
      },
      {
        "periodo": 202511,
        "valor": 39296358811.0,
        "delta": 6584371093.0
      },
      {
        "periodo": 202512,
        "valor": 33163793448.0,
        "delta": -6132565363.0
      },
      {
        "periodo": 202601,
        "valor": 33948955044.0,
        "delta": 785161596.0
      },
      {
        "periodo": 202602,
        "valor": 38504405580.0,
        "delta": 4555450536.0
      },
      {
        "periodo": 202603,
        "valor": 35237257716.0,
        "delta": -3267147864.0
      },
      {
        "periodo": 202604,
        "valor": 37774523503.0,
        "delta": 2537265787.0
      },
      {
        "periodo": 202605,
        "valor": 35675986883.5,
        "delta": -2098536619.5
      },
      {
        "periodo": 202606,
        "valor": 36132637316.0,
        "delta": 456650432.5
      },
      {
        "periodo": 202607,
        "valor": 35448000543.0,
        "delta": -684636773.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 167918218981.0,
    "valor_anterior": 173087449525.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 209306783407.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 216832448063.0,
        "delta": 7525664656.0
      },
      {
        "periodo": 202509,
        "valor": 206688552390.0,
        "delta": -10143895673.0
      },
      {
        "periodo": 202510,
        "valor": 185795061967.0,
        "delta": -20893490423.0
      },
      {
        "periodo": 202511,
        "valor": 189722051091.0,
        "delta": 3926989124.0
      },
      {
        "periodo": 202512,
        "valor": 161214799621.0,
        "delta": -28507251470.0
      },
      {
        "periodo": 202601,
        "valor": 150052369003.0,
        "delta": -11162430618.0
      },
      {
        "periodo": 202602,
        "valor": 157229090395.0,
        "delta": 7176721392.0
      },
      {
        "periodo": 202603,
        "valor": 150153038454.0,
        "delta": -7076051941.0
      },
      {
        "periodo": 202604,
        "valor": 188467753976.0,
        "delta": 38314715522.0
      },
      {
        "periodo": 202605,
        "valor": 191836181187.0,
        "delta": 3368427211.0
      },
      {
        "periodo": 202606,
        "valor": 173087449525.0,
        "delta": -18748731662.0
      },
      {
        "periodo": 202607,
        "valor": 167918218981.0,
        "delta": -5169230544.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 278442596419.27,
    "valor_anterior": 271805604724.02,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 291760984173.48,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 293234116500.86,
        "delta": 1473132327.38
      },
      {
        "periodo": 202509,
        "valor": 297068508315.15,
        "delta": 3834391814.29
      },
      {
        "periodo": 202510,
        "valor": 271385175000.08,
        "delta": -25683333315.07
      },
      {
        "periodo": 202511,
        "valor": 259047832787.09,
        "delta": -12337342212.99
      },
      {
        "periodo": 202512,
        "valor": 277367173846.83,
        "delta": 18319341059.74
      },
      {
        "periodo": 202601,
        "valor": 257717666010.01,
        "delta": -19649507836.82
      },
      {
        "periodo": 202602,
        "valor": 278945140241.39,
        "delta": 21227474231.38
      },
      {
        "periodo": 202603,
        "valor": 260100208751.11,
        "delta": -18844931490.28
      },
      {
        "periodo": 202604,
        "valor": 262021640003.8,
        "delta": 1921431252.69
      },
      {
        "periodo": 202605,
        "valor": 265327382824.81,
        "delta": 3305742821.01
      },
      {
        "periodo": 202606,
        "valor": 271805604724.02,
        "delta": 6478221899.21
      },
      {
        "periodo": 202607,
        "valor": 278442596419.27,
        "delta": 6636991695.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 126895901325.0,
    "valor_anterior": 126309337017.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 95950623823.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 96915352351.0,
        "delta": 964728528.0
      },
      {
        "periodo": 202509,
        "valor": 99432873432.0,
        "delta": 2517521081.0
      },
      {
        "periodo": 202510,
        "valor": 99800181835.0,
        "delta": 367308403.0
      },
      {
        "periodo": 202511,
        "valor": 102602093065.0,
        "delta": 2801911230.0
      },
      {
        "periodo": 202512,
        "valor": 108282448182.0,
        "delta": 5680355117.0
      },
      {
        "periodo": 202601,
        "valor": 117065974603.0,
        "delta": 8783526421.0
      },
      {
        "periodo": 202602,
        "valor": 122856412187.0,
        "delta": 5790437584.0
      },
      {
        "periodo": 202603,
        "valor": 122650692521.0,
        "delta": -205719666.0
      },
      {
        "periodo": 202604,
        "valor": 129546859820.0,
        "delta": 6896167299.0
      },
      {
        "periodo": 202605,
        "valor": 130693998266.0,
        "delta": 1147138446.0
      },
      {
        "periodo": 202606,
        "valor": 126309337017.0,
        "delta": -4384661249.0
      },
      {
        "periodo": 202607,
        "valor": 126895901325.0,
        "delta": 586564308.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 561174336082.08,
    "valor_anterior": 511991418096.74994,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 502153831624.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 507020759387.21,
        "delta": 4866927762.9199
      },
      {
        "periodo": 202509,
        "valor": 478910445790.86,
        "delta": -28110313596.3499
      },
      {
        "periodo": 202510,
        "valor": 497135049367.69,
        "delta": 18224603576.83
      },
      {
        "periodo": 202511,
        "valor": 506707386059.35,
        "delta": 9572336691.66
      },
      {
        "periodo": 202512,
        "valor": 502058053444.8,
        "delta": -4649332614.5499
      },
      {
        "periodo": 202601,
        "valor": 470942667817.14,
        "delta": -31115385627.66
      },
      {
        "periodo": 202602,
        "valor": 481372363704.66,
        "delta": 10429695887.52
      },
      {
        "periodo": 202603,
        "valor": 544894797800.16,
        "delta": 63522434095.5
      },
      {
        "periodo": 202604,
        "valor": 521952975839.82,
        "delta": -22941821960.34
      },
      {
        "periodo": 202605,
        "valor": 532364481985.69,
        "delta": 10411506145.87
      },
      {
        "periodo": 202606,
        "valor": 511991418096.7499,
        "delta": -20373063888.9401
      },
      {
        "periodo": 202607,
        "valor": 561174336082.08,
        "delta": 49182917985.33
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 49145877.0,
    "valor_anterior": 41082942.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 86407032.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 53815769.0,
        "delta": -32591263.0
      },
      {
        "periodo": 202509,
        "valor": 56343844.0,
        "delta": 2528075.0
      },
      {
        "periodo": 202510,
        "valor": 81681882.0,
        "delta": 25338038.0
      },
      {
        "periodo": 202511,
        "valor": 89411961.0,
        "delta": 7730079.0
      },
      {
        "periodo": 202512,
        "valor": 66048690.0,
        "delta": -23363271.0
      },
      {
        "periodo": 202601,
        "valor": 71421505.0,
        "delta": 5372815.0
      },
      {
        "periodo": 202602,
        "valor": 59184209.0,
        "delta": -12237296.0
      },
      {
        "periodo": 202603,
        "valor": 68639205.0,
        "delta": 9454996.0
      },
      {
        "periodo": 202604,
        "valor": 58641131.0,
        "delta": -9998074.0
      },
      {
        "periodo": 202605,
        "valor": 51052500.0,
        "delta": -7588631.0
      },
      {
        "periodo": 202606,
        "valor": 41082942.0,
        "delta": -9969558.0
      },
      {
        "periodo": 202607,
        "valor": 49145877.0,
        "delta": 8062935.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 296285311856.66,
    "valor_anterior": 296140859908.62006,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 313623517862.58,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 315859781830.68,
        "delta": 2236263968.1
      },
      {
        "periodo": 202509,
        "valor": 305697730506.22,
        "delta": -10162051324.46
      },
      {
        "periodo": 202510,
        "valor": 308236679240.91,
        "delta": 2538948734.69
      },
      {
        "periodo": 202511,
        "valor": 326878958445.54,
        "delta": 18642279204.63
      },
      {
        "periodo": 202512,
        "valor": 305503369385.38,
        "delta": -21375589060.16
      },
      {
        "periodo": 202601,
        "valor": 311596131922.4,
        "delta": 6092762537.02
      },
      {
        "periodo": 202602,
        "valor": 306296665442.26,
        "delta": -5299466480.14
      },
      {
        "periodo": 202603,
        "valor": 299770758217.11,
        "delta": -6525907225.15
      },
      {
        "periodo": 202604,
        "valor": 297979283780.63,
        "delta": -1791474436.48
      },
      {
        "periodo": 202605,
        "valor": 295447159119.38,
        "delta": -2532124661.25
      },
      {
        "periodo": 202606,
        "valor": 296140859908.6201,
        "delta": 693700789.2401
      },
      {
        "periodo": 202607,
        "valor": 296285311856.66,
        "delta": 144451948.0399
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 80554589467.0,
    "valor_anterior": 86662096565.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19476727762.96,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26947259466.74,
        "delta": 7470531703.78
      },
      {
        "periodo": 202509,
        "valor": 47893607186.0,
        "delta": 20946347719.26
      },
      {
        "periodo": 202510,
        "valor": 50726179371.0,
        "delta": 2832572185.0
      },
      {
        "periodo": 202511,
        "valor": 48151988623.0,
        "delta": -2574190748.0
      },
      {
        "periodo": 202512,
        "valor": 60158079602.0,
        "delta": 12006090979.0
      },
      {
        "periodo": 202601,
        "valor": 57060694408.0,
        "delta": -3097385194.0
      },
      {
        "periodo": 202602,
        "valor": 52368428562.0,
        "delta": -4692265846.0
      },
      {
        "periodo": 202603,
        "valor": 66216219820.0,
        "delta": 13847791258.0
      },
      {
        "periodo": 202604,
        "valor": 55502326487.0,
        "delta": -10713893333.0
      },
      {
        "periodo": 202605,
        "valor": 58523712533.0,
        "delta": 3021386046.0
      },
      {
        "periodo": 202606,
        "valor": 86662096565.0,
        "delta": 28138384032.0
      },
      {
        "periodo": 202607,
        "valor": 80554589467.0,
        "delta": -6107507098.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 147472148502.0,
    "valor_anterior": 100768764668.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 133389209832.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 151510502236.0,
        "delta": 18121292404.0
      },
      {
        "periodo": 202509,
        "valor": 161408129227.0,
        "delta": 9897626991.0
      },
      {
        "periodo": 202510,
        "valor": 152492647522.0,
        "delta": -8915481705.0
      },
      {
        "periodo": 202511,
        "valor": 117449182279.0,
        "delta": -35043465243.0
      },
      {
        "periodo": 202512,
        "valor": 81249309324.0,
        "delta": -36199872955.0
      },
      {
        "periodo": 202601,
        "valor": 102086807647.03,
        "delta": 20837498323.03
      },
      {
        "periodo": 202602,
        "valor": 104324263502.0,
        "delta": 2237455854.97
      },
      {
        "periodo": 202603,
        "valor": 98940959417.0,
        "delta": -5383304085.0
      },
      {
        "periodo": 202604,
        "valor": 131871773360.0,
        "delta": 32930813943.0
      },
      {
        "periodo": 202605,
        "valor": 132427785632.0,
        "delta": 556012272.0
      },
      {
        "periodo": 202606,
        "valor": 100768764668.0,
        "delta": -31659020964.0
      },
      {
        "periodo": 202607,
        "valor": 147472148502.0,
        "delta": 46703383834.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 51185882854.0,
    "valor_anterior": 51459352717.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 47208244299.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 48239815809.0,
        "delta": 1031571510.0
      },
      {
        "periodo": 202509,
        "valor": 48562039247.0,
        "delta": 322223438.0
      },
      {
        "periodo": 202510,
        "valor": 52935606716.0,
        "delta": 4373567469.0
      },
      {
        "periodo": 202511,
        "valor": 53306148026.0,
        "delta": 370541310.0
      },
      {
        "periodo": 202512,
        "valor": 53663447505.0,
        "delta": 357299479.0
      },
      {
        "periodo": 202601,
        "valor": 52369825835.0,
        "delta": -1293621670.0
      },
      {
        "periodo": 202602,
        "valor": 53031850406.0,
        "delta": 662024571.0
      },
      {
        "periodo": 202603,
        "valor": 52139533405.0,
        "delta": -892317001.0
      },
      {
        "periodo": 202604,
        "valor": 51608713279.0,
        "delta": -530820126.0
      },
      {
        "periodo": 202605,
        "valor": 50920714124.0,
        "delta": -687999155.0
      },
      {
        "periodo": 202606,
        "valor": 51459352717.0,
        "delta": 538638593.0
      },
      {
        "periodo": 202607,
        "valor": 51185882854.0,
        "delta": -273469863.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 171576092132.0,
    "valor_anterior": 168795157769.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 148429187807.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 164930498976.0,
        "delta": 16501311169.0
      },
      {
        "periodo": 202509,
        "valor": 166679442180.0,
        "delta": 1748943204.0
      },
      {
        "periodo": 202510,
        "valor": 161346133830.0,
        "delta": -5333308350.0
      },
      {
        "periodo": 202511,
        "valor": 152064667403.0,
        "delta": -9281466427.0
      },
      {
        "periodo": 202512,
        "valor": 163389218925.0,
        "delta": 11324551522.0
      },
      {
        "periodo": 202601,
        "valor": 156459196871.0,
        "delta": -6930022054.0
      },
      {
        "periodo": 202602,
        "valor": 166814326079.0,
        "delta": 10355129208.0
      },
      {
        "periodo": 202603,
        "valor": 173878370691.0,
        "delta": 7064044612.0
      },
      {
        "periodo": 202604,
        "valor": 168044965059.0,
        "delta": -5833405632.0
      },
      {
        "periodo": 202605,
        "valor": 174929208815.0,
        "delta": 6884243756.0
      },
      {
        "periodo": 202606,
        "valor": 168795157769.0,
        "delta": -6134051046.0
      },
      {
        "periodo": 202607,
        "valor": 171576092132.0,
        "delta": 2780934363.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 57501335029.0,
    "valor_anterior": 56403053968.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 66274007807.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 70991039726.0,
        "delta": 4717031919.0
      },
      {
        "periodo": 202509,
        "valor": 67190659547.0,
        "delta": -3800380179.0
      },
      {
        "periodo": 202510,
        "valor": 59922384168.0,
        "delta": -7268275379.0
      },
      {
        "periodo": 202511,
        "valor": 64411634277.0,
        "delta": 4489250109.0
      },
      {
        "periodo": 202512,
        "valor": 76899985583.0,
        "delta": 12488351306.0
      },
      {
        "periodo": 202601,
        "valor": 53354349458.0,
        "delta": -23545636125.0
      },
      {
        "periodo": 202602,
        "valor": 51679706726.0,
        "delta": -1674642732.0
      },
      {
        "periodo": 202603,
        "valor": 54649949831.0,
        "delta": 2970243105.0
      },
      {
        "periodo": 202604,
        "valor": 57372959593.0,
        "delta": 2723009762.0
      },
      {
        "periodo": 202605,
        "valor": 53795820578.0,
        "delta": -3577139015.0
      },
      {
        "periodo": 202606,
        "valor": 56403053968.0,
        "delta": 2607233390.0
      },
      {
        "periodo": 202607,
        "valor": 57501335029.0,
        "delta": 1098281061.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 936052107.0,
    "valor_anterior": 1045118014.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 45135352355.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 20867067695.0,
        "delta": -24268284660.0
      },
      {
        "periodo": 202509,
        "valor": 1333112008.0,
        "delta": -19533955687.0
      },
      {
        "periodo": 202510,
        "valor": 1488931794.0,
        "delta": 155819786.0
      },
      {
        "periodo": 202511,
        "valor": 7292533130.0,
        "delta": 5803601336.0
      },
      {
        "periodo": 202512,
        "valor": 7168092089.0,
        "delta": -124441041.0
      },
      {
        "periodo": 202601,
        "valor": 7068090555.0,
        "delta": -100001534.0
      },
      {
        "periodo": 202602,
        "valor": 7026157335.0,
        "delta": -41933220.0
      },
      {
        "periodo": 202603,
        "valor": 1147993128.0,
        "delta": -5878164207.0
      },
      {
        "periodo": 202604,
        "valor": 1730620448.0,
        "delta": 582627320.0
      },
      {
        "periodo": 202605,
        "valor": 1713152330.0,
        "delta": -17468118.0
      },
      {
        "periodo": 202606,
        "valor": 1045118014.0,
        "delta": -668034316.0
      },
      {
        "periodo": 202607,
        "valor": 936052107.0,
        "delta": -109065907.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 154165283826.28,
    "valor_anterior": 151281916467.34,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 151076468157.92,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 159979935015.79,
        "delta": 8903466857.87
      },
      {
        "periodo": 202509,
        "valor": 151718022756.64,
        "delta": -8261912259.15
      },
      {
        "periodo": 202510,
        "valor": 156966788789.63,
        "delta": 5248766032.99
      },
      {
        "periodo": 202511,
        "valor": 163166078573.83,
        "delta": 6199289784.2
      },
      {
        "periodo": 202512,
        "valor": 157224067465.61,
        "delta": -5942011108.22
      },
      {
        "periodo": 202601,
        "valor": 158401710806.48,
        "delta": 1177643340.87
      },
      {
        "periodo": 202602,
        "valor": 156829856738.9,
        "delta": -1571854067.58
      },
      {
        "periodo": 202603,
        "valor": 153176087583.61,
        "delta": -3653769155.29
      },
      {
        "periodo": 202604,
        "valor": 153567153077.87,
        "delta": 391065494.26
      },
      {
        "periodo": 202605,
        "valor": 161037300134.04,
        "delta": 7470147056.17
      },
      {
        "periodo": 202606,
        "valor": 151281916467.34,
        "delta": -9755383666.7
      },
      {
        "periodo": 202607,
        "valor": 154165283826.28,
        "delta": 2883367358.94
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 5358901630.0,
    "valor_anterior": 5254713663.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5995491968.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6010048537.0,
        "delta": 14556569.0
      },
      {
        "periodo": 202509,
        "valor": 5849621966.0,
        "delta": -160426571.0
      },
      {
        "periodo": 202510,
        "valor": 5513492427.0,
        "delta": -336129539.0
      },
      {
        "periodo": 202511,
        "valor": 5539019138.0,
        "delta": 25526711.0
      },
      {
        "periodo": 202512,
        "valor": 5601861404.0,
        "delta": 62842266.0
      },
      {
        "periodo": 202601,
        "valor": 5511350958.0,
        "delta": -90510446.0
      },
      {
        "periodo": 202602,
        "valor": 5511307338.0,
        "delta": -43620.0
      },
      {
        "periodo": 202603,
        "valor": 5437580571.0,
        "delta": -73726767.0
      },
      {
        "periodo": 202604,
        "valor": 5269958404.0,
        "delta": -167622167.0
      },
      {
        "periodo": 202605,
        "valor": 5278689280.0,
        "delta": 8730876.0
      },
      {
        "periodo": 202606,
        "valor": 5254713663.0,
        "delta": -23975617.0
      },
      {
        "periodo": 202607,
        "valor": 5358901630.0,
        "delta": 104187967.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 67098608231.99999,
    "valor_anterior": 70853284903.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 62105884437.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 61201229906.0,
        "delta": -904654531.0
      },
      {
        "periodo": 202509,
        "valor": 58293064458.0,
        "delta": -2908165448.0
      },
      {
        "periodo": 202510,
        "valor": 58831674637.0,
        "delta": 538610179.0
      },
      {
        "periodo": 202511,
        "valor": 61268342036.0,
        "delta": 2436667399.0
      },
      {
        "periodo": 202512,
        "valor": 53743320099.0,
        "delta": -7525021937.0
      },
      {
        "periodo": 202601,
        "valor": 61437258503.0,
        "delta": 7693938404.0
      },
      {
        "periodo": 202602,
        "valor": 66601808152.0,
        "delta": 5164549649.0
      },
      {
        "periodo": 202603,
        "valor": 66868688115.0,
        "delta": 266879963.0
      },
      {
        "periodo": 202604,
        "valor": 63519479141.0,
        "delta": -3349208974.0
      },
      {
        "periodo": 202605,
        "valor": 66680523362.0,
        "delta": 3161044221.0
      },
      {
        "periodo": 202606,
        "valor": 70853284903.0,
        "delta": 4172761541.0
      },
      {
        "periodo": 202607,
        "valor": 67098608232.0,
        "delta": -3754676671.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 38353914839.0,
    "valor_anterior": 38506048314.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 31705649291.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 32153954402.0,
        "delta": 448305111.0
      },
      {
        "periodo": 202509,
        "valor": 31934765854.0,
        "delta": -219188548.0
      },
      {
        "periodo": 202510,
        "valor": 32639541815.0,
        "delta": 704775961.0
      },
      {
        "periodo": 202511,
        "valor": 32297295601.0,
        "delta": -342246214.0
      },
      {
        "periodo": 202512,
        "valor": 33074580859.0,
        "delta": 777285258.0
      },
      {
        "periodo": 202601,
        "valor": 34894937022.0,
        "delta": 1820356163.0
      },
      {
        "periodo": 202602,
        "valor": 35923652330.0,
        "delta": 1028715308.0
      },
      {
        "periodo": 202603,
        "valor": 37404194063.0,
        "delta": 1480541733.0
      },
      {
        "periodo": 202604,
        "valor": 41098719745.0,
        "delta": 3694525682.0
      },
      {
        "periodo": 202605,
        "valor": 39318993354.0,
        "delta": -1779726391.0
      },
      {
        "periodo": 202606,
        "valor": 38506048314.0,
        "delta": -812945040.0
      },
      {
        "periodo": 202607,
        "valor": 38353914839.0,
        "delta": -152133475.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 5382102240.999999,
    "valor_anterior": 5371610702.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4293714926.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4291411391.0,
        "delta": -2303535.0
      },
      {
        "periodo": 202509,
        "valor": 5372995805.0,
        "delta": 1081584414.0
      },
      {
        "periodo": 202510,
        "valor": 5437463580.0,
        "delta": 64467775.0
      },
      {
        "periodo": 202511,
        "valor": 5525253684.0,
        "delta": 87790104.0
      },
      {
        "periodo": 202512,
        "valor": 5065451621.0,
        "delta": -459802063.0
      },
      {
        "periodo": 202601,
        "valor": 5069068490.0,
        "delta": 3616869.0
      },
      {
        "periodo": 202602,
        "valor": 5425531587.0,
        "delta": 356463097.0
      },
      {
        "periodo": 202603,
        "valor": 5502773097.0,
        "delta": 77241510.0
      },
      {
        "periodo": 202604,
        "valor": 5546429694.0,
        "delta": 43656597.0
      },
      {
        "periodo": 202605,
        "valor": 5545129428.0,
        "delta": -1300266.0
      },
      {
        "periodo": 202606,
        "valor": 5371610702.0,
        "delta": -173518726.0
      },
      {
        "periodo": 202607,
        "valor": 5382102241.0,
        "delta": 10491539.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 93111441607.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 63481938994.0,
        "delta": -29629502613.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 201921524713.0,
    "valor_anterior": 201271550521.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 142979264924.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 149798179836.0,
        "delta": 6818914912.0
      },
      {
        "periodo": 202509,
        "valor": 158234134151.0,
        "delta": 8435954315.0
      },
      {
        "periodo": 202510,
        "valor": 167517337572.0,
        "delta": 9283203421.0
      },
      {
        "periodo": 202511,
        "valor": 166283592171.0,
        "delta": -1233745401.0
      },
      {
        "periodo": 202512,
        "valor": 189137404684.0,
        "delta": 22853812513.0
      },
      {
        "periodo": 202601,
        "valor": 178343241363.0,
        "delta": -10794163321.0
      },
      {
        "periodo": 202602,
        "valor": 186588119377.0,
        "delta": 8244878014.0
      },
      {
        "periodo": 202603,
        "valor": 181213020686.0,
        "delta": -5375098691.0
      },
      {
        "periodo": 202604,
        "valor": 181439343241.0,
        "delta": 226322555.0
      },
      {
        "periodo": 202605,
        "valor": 177678523065.0,
        "delta": -3760820176.0
      },
      {
        "periodo": 202606,
        "valor": 201271550521.0,
        "delta": 23593027456.0
      },
      {
        "periodo": 202607,
        "valor": 201921524713.0,
        "delta": 649974192.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 31164947411.999996,
    "valor_anterior": 29194120019.999996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17262203885.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17512164703.0,
        "delta": 249960818.0
      },
      {
        "periodo": 202509,
        "valor": 19172583482.0,
        "delta": 1660418779.0
      },
      {
        "periodo": 202510,
        "valor": 19780341857.0,
        "delta": 607758375.0
      },
      {
        "periodo": 202511,
        "valor": 20312186924.0,
        "delta": 531845067.0
      },
      {
        "periodo": 202512,
        "valor": 27334683244.0,
        "delta": 7022496320.0
      },
      {
        "periodo": 202601,
        "valor": 21283303585.0,
        "delta": -6051379659.0
      },
      {
        "periodo": 202602,
        "valor": 25651926977.0,
        "delta": 4368623392.0
      },
      {
        "periodo": 202603,
        "valor": 27626026361.0,
        "delta": 1974099384.0
      },
      {
        "periodo": 202604,
        "valor": 27214837549.0,
        "delta": -411188812.0
      },
      {
        "periodo": 202605,
        "valor": 28781956070.0,
        "delta": 1567118521.0
      },
      {
        "periodo": 202606,
        "valor": 29194120020.0,
        "delta": 412163950.0
      },
      {
        "periodo": 202607,
        "valor": 31164947412.0,
        "delta": 1970827392.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 1558263164.0,
    "valor_anterior": 1524137021.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 42003050.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 893705767.0,
        "delta": 851702717.0
      },
      {
        "periodo": 202509,
        "valor": 537524915.0,
        "delta": -356180852.0
      },
      {
        "periodo": 202510,
        "valor": 808961552.0,
        "delta": 271436637.0
      },
      {
        "periodo": 202511,
        "valor": 937888231.0,
        "delta": 128926679.0
      },
      {
        "periodo": 202512,
        "valor": 916339740.0,
        "delta": -21548491.0
      },
      {
        "periodo": 202601,
        "valor": 1037679145.0,
        "delta": 121339405.0
      },
      {
        "periodo": 202602,
        "valor": 1002213089.0,
        "delta": -35466056.0
      },
      {
        "periodo": 202603,
        "valor": 753184838.0,
        "delta": -249028251.0
      },
      {
        "periodo": 202604,
        "valor": 683821609.0,
        "delta": -69363229.0
      },
      {
        "periodo": 202605,
        "valor": 1197302277.0,
        "delta": 513480668.0
      },
      {
        "periodo": 202606,
        "valor": 1524137021.0,
        "delta": 326834744.0
      },
      {
        "periodo": 202607,
        "valor": 1558263164.0,
        "delta": 34126143.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 494615932.0,
    "valor_anterior": 457776038.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 294442734.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 299576703.0,
        "delta": 5133969.0
      },
      {
        "periodo": 202509,
        "valor": 313436832.0,
        "delta": 13860129.0
      },
      {
        "periodo": 202510,
        "valor": 326361568.0,
        "delta": 12924736.0
      },
      {
        "periodo": 202511,
        "valor": 333833118.0,
        "delta": 7471550.0
      },
      {
        "periodo": 202512,
        "valor": 361068017.0,
        "delta": 27234899.0
      },
      {
        "periodo": 202601,
        "valor": 377828881.0,
        "delta": 16760864.0
      },
      {
        "periodo": 202602,
        "valor": 388379971.0,
        "delta": 10551090.0
      },
      {
        "periodo": 202603,
        "valor": 404757431.0,
        "delta": 16377460.0
      },
      {
        "periodo": 202604,
        "valor": 414502577.0,
        "delta": 9745146.0
      },
      {
        "periodo": 202605,
        "valor": 432211340.0,
        "delta": 17708763.0
      },
      {
        "periodo": 202606,
        "valor": 457776038.0,
        "delta": 25564698.0
      },
      {
        "periodo": 202607,
        "valor": 494615932.0,
        "delta": 36839894.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 15378037072.07,
    "valor_anterior": 15448609197.15,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14363232126.36,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14391808885.98,
        "delta": 28576759.62
      },
      {
        "periodo": 202509,
        "valor": 14273491127.75,
        "delta": -118317758.23
      },
      {
        "periodo": 202510,
        "valor": 14525459864.08,
        "delta": 251968736.33
      },
      {
        "periodo": 202511,
        "valor": 14647171947.36,
        "delta": 121712083.28
      },
      {
        "periodo": 202512,
        "valor": 14738006747.36,
        "delta": 90834800.0
      },
      {
        "periodo": 202601,
        "valor": 14319987716.1,
        "delta": -418019031.26
      },
      {
        "periodo": 202602,
        "valor": 14078947207.43,
        "delta": -241040508.67
      },
      {
        "periodo": 202603,
        "valor": 15193095110.66,
        "delta": 1114147903.23
      },
      {
        "periodo": 202604,
        "valor": 15162226612.43,
        "delta": -30868498.23
      },
      {
        "periodo": 202605,
        "valor": 14939548846.24,
        "delta": -222677766.19
      },
      {
        "periodo": 202606,
        "valor": 15448609197.15,
        "delta": 509060350.91
      },
      {
        "periodo": 202607,
        "valor": 15378037072.07,
        "delta": -70572125.08
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 4034306852.0,
    "valor_anterior": 3074853521.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2008977319.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2264192159.0,
        "delta": 255214840.0
      },
      {
        "periodo": 202509,
        "valor": 2369869962.0,
        "delta": 105677803.0
      },
      {
        "periodo": 202510,
        "valor": 3188902062.0,
        "delta": 819032100.0
      },
      {
        "periodo": 202511,
        "valor": 3593357942.0,
        "delta": 404455880.0
      },
      {
        "periodo": 202512,
        "valor": 3128145522.0,
        "delta": -465212420.0
      },
      {
        "periodo": 202601,
        "valor": 2361237430.0,
        "delta": -766908092.0
      },
      {
        "periodo": 202602,
        "valor": 2970937747.0,
        "delta": 609700317.0
      },
      {
        "periodo": 202603,
        "valor": 3374672622.0,
        "delta": 403734875.0
      },
      {
        "periodo": 202604,
        "valor": 4017914834.0,
        "delta": 643242212.0
      },
      {
        "periodo": 202605,
        "valor": 3265524800.0,
        "delta": -752390034.0
      },
      {
        "periodo": 202606,
        "valor": 3074853521.0,
        "delta": -190671279.0
      },
      {
        "periodo": 202607,
        "valor": 4034306852.0,
        "delta": 959453331.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 56212450519.02,
    "valor_anterior": 56677160719.47,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 48462399965.37,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 49064643335.69,
        "delta": 602243370.32
      },
      {
        "periodo": 202509,
        "valor": 48588306283.03,
        "delta": -476337052.66
      },
      {
        "periodo": 202510,
        "valor": 50252924379.42,
        "delta": 1664618096.39
      },
      {
        "periodo": 202511,
        "valor": 52532651981.22,
        "delta": 2279727601.8
      },
      {
        "periodo": 202512,
        "valor": 54768563393.01,
        "delta": 2235911411.79
      },
      {
        "periodo": 202601,
        "valor": 55657917596.82,
        "delta": 889354203.81
      },
      {
        "periodo": 202602,
        "valor": 53987764328.01,
        "delta": -1670153268.81
      },
      {
        "periodo": 202603,
        "valor": 56600117500.29,
        "delta": 2612353172.28
      },
      {
        "periodo": 202604,
        "valor": 54967510030.31,
        "delta": -1632607469.98
      },
      {
        "periodo": 202605,
        "valor": 55058706380.91,
        "delta": 91196350.6
      },
      {
        "periodo": 202606,
        "valor": 56677160719.47,
        "delta": 1618454338.56
      },
      {
        "periodo": 202607,
        "valor": 56212450519.02,
        "delta": -464710200.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 9476152655.630001,
    "valor_anterior": 9426333150.83,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8598959906.7,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8718049188.0,
        "delta": 119089281.3
      },
      {
        "periodo": 202509,
        "valor": 8819729235.78,
        "delta": 101680047.78
      },
      {
        "periodo": 202510,
        "valor": 8599087713.35,
        "delta": -220641522.43
      },
      {
        "periodo": 202511,
        "valor": 8743237530.05,
        "delta": 144149816.7
      },
      {
        "periodo": 202512,
        "valor": 8846692607.4,
        "delta": 103455077.35
      },
      {
        "periodo": 202601,
        "valor": 9024165786.15,
        "delta": 177473178.75
      },
      {
        "periodo": 202602,
        "valor": 8819349553.71,
        "delta": -204816232.44
      },
      {
        "periodo": 202603,
        "valor": 9274042470.3,
        "delta": 454692916.59
      },
      {
        "periodo": 202604,
        "valor": 9257089951.14,
        "delta": -16952519.16
      },
      {
        "periodo": 202605,
        "valor": 9557205922.79,
        "delta": 300115971.65
      },
      {
        "periodo": 202606,
        "valor": 9426333150.83,
        "delta": -130872771.96
      },
      {
        "periodo": 202607,
        "valor": 9476152655.63,
        "delta": 49819504.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 11446145943.0,
    "valor_anterior": 10423345497.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9723593334.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9990494642.0,
        "delta": 266901308.0
      },
      {
        "periodo": 202509,
        "valor": 10568866705.0,
        "delta": 578372063.0
      },
      {
        "periodo": 202510,
        "valor": 11527573884.0,
        "delta": 958707179.0
      },
      {
        "periodo": 202511,
        "valor": 12242896571.0,
        "delta": 715322687.0
      },
      {
        "periodo": 202512,
        "valor": 11536939819.0,
        "delta": -705956752.0
      },
      {
        "periodo": 202601,
        "valor": 11824647835.0,
        "delta": 287708016.0
      },
      {
        "periodo": 202602,
        "valor": 11737050984.0,
        "delta": -87596851.0
      },
      {
        "periodo": 202603,
        "valor": 11401652136.0,
        "delta": -335398848.0
      },
      {
        "periodo": 202604,
        "valor": 11232839584.0,
        "delta": -168812552.0
      },
      {
        "periodo": 202605,
        "valor": 10112134771.0,
        "delta": -1120704813.0
      },
      {
        "periodo": 202606,
        "valor": 10423345497.0,
        "delta": 311210726.0
      },
      {
        "periodo": 202607,
        "valor": 11446145943.0,
        "delta": 1022800446.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 129721209431.0,
    "valor_anterior": 127861548648.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 122821798166.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 124883098037.0,
        "delta": 2061299871.0
      },
      {
        "periodo": 202509,
        "valor": 123753256130.0,
        "delta": -1129841907.0
      },
      {
        "periodo": 202510,
        "valor": 132258718972.0,
        "delta": 8505462842.0
      },
      {
        "periodo": 202511,
        "valor": 126842272358.0,
        "delta": -5416446614.0
      },
      {
        "periodo": 202512,
        "valor": 135977425524.0,
        "delta": 9135153166.0
      },
      {
        "periodo": 202601,
        "valor": 133565589786.0,
        "delta": -2411835738.0
      },
      {
        "periodo": 202602,
        "valor": 133703574313.0,
        "delta": 137984527.0
      },
      {
        "periodo": 202603,
        "valor": 134093312907.0,
        "delta": 389738594.0
      },
      {
        "periodo": 202604,
        "valor": 130701119552.0,
        "delta": -3392193355.0
      },
      {
        "periodo": 202605,
        "valor": 129626079813.0,
        "delta": -1075039739.0
      },
      {
        "periodo": 202606,
        "valor": 127861548648.0,
        "delta": -1764531165.0
      },
      {
        "periodo": 202607,
        "valor": 129721209431.0,
        "delta": 1859660783.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 5039123414.0,
    "valor_anterior": 4743985658.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4994625002.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5186947216.0,
        "delta": 192322214.0
      },
      {
        "periodo": 202509,
        "valor": 5012458598.0,
        "delta": -174488618.0
      },
      {
        "periodo": 202510,
        "valor": 5641164378.0,
        "delta": 628705780.0
      },
      {
        "periodo": 202511,
        "valor": 5394905911.0,
        "delta": -246258467.0
      },
      {
        "periodo": 202512,
        "valor": 4715261197.0,
        "delta": -679644714.0
      },
      {
        "periodo": 202601,
        "valor": 5524330298.0,
        "delta": 809069101.0
      },
      {
        "periodo": 202602,
        "valor": 5368730145.0,
        "delta": -155600153.0
      },
      {
        "periodo": 202603,
        "valor": 5116501080.0,
        "delta": -252229065.0
      },
      {
        "periodo": 202604,
        "valor": 5185101850.0,
        "delta": 68600770.0
      },
      {
        "periodo": 202605,
        "valor": 4765531240.0,
        "delta": -419570610.0
      },
      {
        "periodo": 202606,
        "valor": 4743985658.0,
        "delta": -21545582.0
      },
      {
        "periodo": 202607,
        "valor": 5039123414.0,
        "delta": 295137756.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 8491007328.35,
    "valor_anterior": 8682205653.09,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10572547854.45,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9276167170.68,
        "delta": -1296380683.77
      },
      {
        "periodo": 202509,
        "valor": 9423338666.52,
        "delta": 147171495.84
      },
      {
        "periodo": 202510,
        "valor": 10575957910.09,
        "delta": 1152619243.57
      },
      {
        "periodo": 202511,
        "valor": 10515357920.1,
        "delta": -60599989.99
      },
      {
        "periodo": 202512,
        "valor": 8080954496.88,
        "delta": -2434403423.22
      },
      {
        "periodo": 202601,
        "valor": 10019530732.32,
        "delta": 1938576235.44
      },
      {
        "periodo": 202602,
        "valor": 9895271552.82,
        "delta": -124259179.5
      },
      {
        "periodo": 202603,
        "valor": 9697517858.55,
        "delta": -197753694.27
      },
      {
        "periodo": 202604,
        "valor": 9080946399.49,
        "delta": -616571459.06
      },
      {
        "periodo": 202605,
        "valor": 9032899633.31,
        "delta": -48046766.18
      },
      {
        "periodo": 202606,
        "valor": 8682205653.09,
        "delta": -350693980.22
      },
      {
        "periodo": 202607,
        "valor": 8491007328.35,
        "delta": -191198324.74
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 5790497192.65,
    "valor_anterior": 6727509233.35,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5801486899.91,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5071872665.84,
        "delta": -729614234.07
      },
      {
        "periodo": 202509,
        "valor": 4761028101.97,
        "delta": -310844563.87
      },
      {
        "periodo": 202510,
        "valor": 4155564122.01,
        "delta": -605463979.96
      },
      {
        "periodo": 202511,
        "valor": 4458496474.82,
        "delta": 302932352.81
      },
      {
        "periodo": 202512,
        "valor": 4772337650.33,
        "delta": 313841175.51
      },
      {
        "periodo": 202601,
        "valor": 5223699096.28,
        "delta": 451361445.95
      },
      {
        "periodo": 202602,
        "valor": 5028480991.6,
        "delta": -195218104.68
      },
      {
        "periodo": 202603,
        "valor": 4467361572.36,
        "delta": -561119419.24
      },
      {
        "periodo": 202604,
        "valor": 5310099767.36,
        "delta": 842738195.0
      },
      {
        "periodo": 202605,
        "valor": 7094503311.73,
        "delta": 1784403544.37
      },
      {
        "periodo": 202606,
        "valor": 6727509233.35,
        "delta": -366994078.38
      },
      {
        "periodo": 202607,
        "valor": 5790497192.65,
        "delta": -937012040.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 2471940133.0,
    "valor_anterior": 4309096336.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3419397970.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3076817959.0,
        "delta": -342580011.0
      },
      {
        "periodo": 202509,
        "valor": 5870250609.0,
        "delta": 2793432650.0
      },
      {
        "periodo": 202510,
        "valor": 2925753818.0,
        "delta": -2944496791.0
      },
      {
        "periodo": 202511,
        "valor": 3990674011.0,
        "delta": 1064920193.0
      },
      {
        "periodo": 202512,
        "valor": 2491060335.0,
        "delta": -1499613676.0
      },
      {
        "periodo": 202601,
        "valor": 5892134596.0,
        "delta": 3401074261.0
      },
      {
        "periodo": 202602,
        "valor": 4204553402.0,
        "delta": -1687581194.0
      },
      {
        "periodo": 202603,
        "valor": 5903213050.0,
        "delta": 1698659648.0
      },
      {
        "periodo": 202604,
        "valor": 3477948711.0,
        "delta": -2425264339.0
      },
      {
        "periodo": 202605,
        "valor": 5564992109.0,
        "delta": 2087043398.0
      },
      {
        "periodo": 202606,
        "valor": 4309096336.0,
        "delta": -1255895773.0
      },
      {
        "periodo": 202607,
        "valor": 2471940133.0,
        "delta": -1837156203.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 4103005383.0,
    "valor_anterior": 4042182728.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4041050585.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3711491166.0,
        "delta": -329559419.0
      },
      {
        "periodo": 202509,
        "valor": 3591162078.0,
        "delta": -120329088.0
      },
      {
        "periodo": 202510,
        "valor": 3713444468.0,
        "delta": 122282390.0
      },
      {
        "periodo": 202511,
        "valor": 4054915000.0,
        "delta": 341470532.0
      },
      {
        "periodo": 202512,
        "valor": 3949597110.0,
        "delta": -105317890.0
      },
      {
        "periodo": 202601,
        "valor": 3754216062.0,
        "delta": -195381048.0
      },
      {
        "periodo": 202602,
        "valor": 3836074805.0,
        "delta": 81858743.0
      },
      {
        "periodo": 202603,
        "valor": 4019983019.0,
        "delta": 183908214.0
      },
      {
        "periodo": 202604,
        "valor": 4253959877.0,
        "delta": 233976858.0
      },
      {
        "periodo": 202605,
        "valor": 3800016138.0,
        "delta": -453943739.0
      },
      {
        "periodo": 202606,
        "valor": 4042182728.0,
        "delta": 242166590.0
      },
      {
        "periodo": 202607,
        "valor": 4103005383.0,
        "delta": 60822655.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 15611015177.999998,
    "valor_anterior": 13812698425.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16967324489.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13901183149.0,
        "delta": -3066141340.0
      },
      {
        "periodo": 202509,
        "valor": 14275468448.0,
        "delta": 374285299.0
      },
      {
        "periodo": 202510,
        "valor": 17505028644.0,
        "delta": 3229560196.0
      },
      {
        "periodo": 202511,
        "valor": 18099153960.0,
        "delta": 594125316.0
      },
      {
        "periodo": 202512,
        "valor": 15729064390.0,
        "delta": -2370089570.0
      },
      {
        "periodo": 202601,
        "valor": 18909598632.0,
        "delta": 3180534242.0
      },
      {
        "periodo": 202602,
        "valor": 22388932723.0,
        "delta": 3479334091.0
      },
      {
        "periodo": 202603,
        "valor": 22220397838.0,
        "delta": -168534885.0
      },
      {
        "periodo": 202604,
        "valor": 20207699195.0,
        "delta": -2012698643.0
      },
      {
        "periodo": 202605,
        "valor": 16521066362.0,
        "delta": -3686632833.0
      },
      {
        "periodo": 202606,
        "valor": 13812698425.0,
        "delta": -2708367937.0
      },
      {
        "periodo": 202607,
        "valor": 15611015178.0,
        "delta": 1798316753.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 172675105.51,
    "valor_anterior": 146463238.58,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 75860524.91,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 75291162.96,
        "delta": -569361.95
      },
      {
        "periodo": 202509,
        "valor": 80199037.42,
        "delta": 4907874.46
      },
      {
        "periodo": 202510,
        "valor": 85804984.92,
        "delta": 5605947.5
      },
      {
        "periodo": 202511,
        "valor": 94564236.59,
        "delta": 8759251.67
      },
      {
        "periodo": 202512,
        "valor": 69253001.25,
        "delta": -25311235.34
      },
      {
        "periodo": 202601,
        "valor": 121184221.01,
        "delta": 51931219.76
      },
      {
        "periodo": 202602,
        "valor": 141701549.0,
        "delta": 20517327.99
      },
      {
        "periodo": 202603,
        "valor": 166520732.67,
        "delta": 24819183.67
      },
      {
        "periodo": 202604,
        "valor": 153500139.24,
        "delta": -13020593.43
      },
      {
        "periodo": 202605,
        "valor": 123102190.44,
        "delta": -30397948.8
      },
      {
        "periodo": 202606,
        "valor": 146463238.58,
        "delta": 23361048.14
      },
      {
        "periodo": 202607,
        "valor": 172675105.51,
        "delta": 26211866.93
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 13476517768.62,
    "valor_anterior": 13501470085.32,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4497438.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5848588.78,
        "delta": 1351150.49
      },
      {
        "periodo": 202509,
        "valor": 5806419.77,
        "delta": -42169.01
      },
      {
        "periodo": 202510,
        "valor": 9705851.39,
        "delta": 3899431.62
      },
      {
        "periodo": 202511,
        "valor": 13138236.67,
        "delta": 3432385.28
      },
      {
        "periodo": 202512,
        "valor": 14170268.17,
        "delta": 1032031.5
      },
      {
        "periodo": 202601,
        "valor": 14453493.37,
        "delta": 283225.2
      },
      {
        "periodo": 202602,
        "valor": 13822321775.47,
        "delta": 13807868282.1
      },
      {
        "periodo": 202603,
        "valor": 13752649569.93,
        "delta": -69672205.54
      },
      {
        "periodo": 202604,
        "valor": 13697712269.9,
        "delta": -54937300.03
      },
      {
        "periodo": 202605,
        "valor": 13559812682.2,
        "delta": -137899587.7
      },
      {
        "periodo": 202606,
        "valor": 13501470085.32,
        "delta": -58342596.88
      },
      {
        "periodo": 202607,
        "valor": 13476517768.62,
        "delta": -24952316.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 21984983137.0,
    "valor_anterior": 21455265062.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3568121415.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5880886026.0,
        "delta": 2312764611.0
      },
      {
        "periodo": 202509,
        "valor": 8243097803.0,
        "delta": 2362211777.0
      },
      {
        "periodo": 202510,
        "valor": 10874147031.0,
        "delta": 2631049228.0
      },
      {
        "periodo": 202511,
        "valor": 13539768940.0,
        "delta": 2665621909.0
      },
      {
        "periodo": 202512,
        "valor": 16830828993.0,
        "delta": 3291060053.0
      },
      {
        "periodo": 202601,
        "valor": 18891467844.0,
        "delta": 2060638851.0
      },
      {
        "periodo": 202602,
        "valor": 20745848277.0,
        "delta": 1854380433.0
      },
      {
        "periodo": 202603,
        "valor": 20378281830.0,
        "delta": -367566447.0
      },
      {
        "periodo": 202604,
        "valor": 20629189714.0,
        "delta": 250907884.0
      },
      {
        "periodo": 202605,
        "valor": 21014984792.0,
        "delta": 385795078.0
      },
      {
        "periodo": 202606,
        "valor": 21455265062.0,
        "delta": 440280270.0
      },
      {
        "periodo": 202607,
        "valor": 21984983137.0,
        "delta": 529718075.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 7610146181.93,
    "valor_anterior": 8956814047.3,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 89073371.21,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 114716797.96,
        "delta": 25643426.75
      },
      {
        "periodo": 202601,
        "valor": 1151934897.54,
        "delta": 1037218099.58
      },
      {
        "periodo": 202602,
        "valor": 2949589540.89,
        "delta": 1797654643.35
      },
      {
        "periodo": 202603,
        "valor": 4400453671.11,
        "delta": 1450864130.22
      },
      {
        "periodo": 202604,
        "valor": 5397336827.24,
        "delta": 996883156.13
      },
      {
        "periodo": 202605,
        "valor": 6762705225.01,
        "delta": 1365368397.77
      },
      {
        "periodo": 202606,
        "valor": 8956814047.3,
        "delta": 2194108822.29
      },
      {
        "periodo": 202607,
        "valor": 7610146181.93,
        "delta": -1346667865.37
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 23640237617.0,
    "valor_anterior": 20519916631.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 15180155510.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 17662296984.0,
        "delta": 2482141474.0
      },
      {
        "periodo": 202605,
        "valor": 18777440210.0,
        "delta": 1115143226.0
      },
      {
        "periodo": 202606,
        "valor": 20519916631.0,
        "delta": 1742476421.0
      },
      {
        "periodo": 202607,
        "valor": 23640237617.0,
        "delta": 3120320986.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 14437639412381.31,
    "valor_anterior": 14177363631776.07,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13613273030135.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13626474015807.35,
        "delta": 13200985671.9297
      },
      {
        "periodo": 202509,
        "valor": 13564454179107.63,
        "delta": -62019836699.7188
      },
      {
        "periodo": 202510,
        "valor": 13812202129948.25,
        "delta": 247747950840.6191
      },
      {
        "periodo": 202511,
        "valor": 13802128730151.73,
        "delta": -10073399796.5195
      },
      {
        "periodo": 202512,
        "valor": 13746082029646.19,
        "delta": -56046700505.541
      },
      {
        "periodo": 202601,
        "valor": 13815143283060.31,
        "delta": 69061253414.1211
      },
      {
        "periodo": 202602,
        "valor": 13916155096215.11,
        "delta": 101011813154.7988
      },
      {
        "periodo": 202603,
        "valor": 14028503280223.35,
        "delta": 112348184008.2402
      },
      {
        "periodo": 202604,
        "valor": 14075815962852.42,
        "delta": 47312682629.0703
      },
      {
        "periodo": 202605,
        "valor": 14629933010457.5,
        "delta": 554117047605.0801
      },
      {
        "periodo": 202606,
        "valor": 14177363631776.07,
        "delta": -452569378681.4297
      },
      {
        "periodo": 202607,
        "valor": 14437639412381.31,
        "delta": 260275780605.2402
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 10185477835097.818,
    "valor_anterior": 10038298492648.8,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9501138324635.51,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9468426720140.81,
        "delta": -32711604494.6992
      },
      {
        "periodo": 202509,
        "valor": 9572845933922.29,
        "delta": 104419213781.4785
      },
      {
        "periodo": 202510,
        "valor": 9729650010879.37,
        "delta": 156804076957.0801
      },
      {
        "periodo": 202511,
        "valor": 9742114257064.14,
        "delta": 12464246184.7715
      },
      {
        "periodo": 202512,
        "valor": 9772442574395.39,
        "delta": 30328317331.25
      },
      {
        "periodo": 202601,
        "valor": 9834763453854.3,
        "delta": 62320879458.9102
      },
      {
        "periodo": 202602,
        "valor": 9854851743465.57,
        "delta": 20088289611.2695
      },
      {
        "periodo": 202603,
        "valor": 9904347838073.1,
        "delta": 49496094607.5293
      },
      {
        "periodo": 202604,
        "valor": 9917272398863.23,
        "delta": 12924560790.1309
      },
      {
        "periodo": 202605,
        "valor": 10395132336284.06,
        "delta": 477859937420.8301
      },
      {
        "periodo": 202606,
        "valor": 10038298492648.8,
        "delta": -356833843635.2598
      },
      {
        "periodo": 202607,
        "valor": 10185477835097.818,
        "delta": 147179342449.0176
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 481300173239.27,
    "valor_anterior": 474122273259.02,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 572987043059.48,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 527381303025.8599,
        "delta": -45605740033.6201
      },
      {
        "periodo": 202509,
        "valor": 456635754474.15,
        "delta": -70745548551.7099
      },
      {
        "periodo": 202510,
        "valor": 440391444366.08,
        "delta": -16244310108.07
      },
      {
        "periodo": 202511,
        "valor": 432623958088.0901,
        "delta": -7767486277.9899
      },
      {
        "periodo": 202512,
        "valor": 473672670619.83,
        "delta": 41048712531.7399
      },
      {
        "periodo": 202601,
        "valor": 443128997928.01,
        "delta": -30543672691.82
      },
      {
        "periodo": 202602,
        "valor": 472559416953.39,
        "delta": 29430419025.38
      },
      {
        "periodo": 202603,
        "valor": 442461222565.11,
        "delta": -30098194388.28
      },
      {
        "periodo": 202604,
        "valor": 445191603692.8,
        "delta": 2730381127.69
      },
      {
        "periodo": 202605,
        "valor": 444719058219.8101,
        "delta": -472545472.9899
      },
      {
        "periodo": 202606,
        "valor": 474122273259.02,
        "delta": 29403215039.21
      },
      {
        "periodo": 202607,
        "valor": 481300173239.27,
        "delta": 7177899980.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 1598361197588.08,
    "valor_anterior": 1501007692761.75,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1627487297262.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1652938616758.21,
        "delta": 25451319495.9199
      },
      {
        "periodo": 202509,
        "valor": 1551859687951.8604,
        "delta": -101078928806.3496
      },
      {
        "periodo": 202510,
        "valor": 1644512082129.69,
        "delta": 92652394177.8296
      },
      {
        "periodo": 202511,
        "valor": 1600603907132.35,
        "delta": -43908174997.3398
      },
      {
        "periodo": 202512,
        "valor": 1434583139794.8,
        "delta": -166020767337.55
      },
      {
        "periodo": 202601,
        "valor": 1488321245412.17,
        "delta": 53738105617.3699
      },
      {
        "periodo": 202602,
        "valor": 1517929798017.66,
        "delta": 29608552605.49
      },
      {
        "periodo": 202603,
        "valor": 1547780834359.16,
        "delta": 29851036341.5
      },
      {
        "periodo": 202604,
        "valor": 1581997847514.82,
        "delta": 34217013155.6602
      },
      {
        "periodo": 202605,
        "valor": 1642367089269.19,
        "delta": 60369241754.3699
      },
      {
        "periodo": 202606,
        "valor": 1501007692761.75,
        "delta": -141359396507.4399
      },
      {
        "periodo": 202607,
        "valor": 1598361197588.08,
        "delta": 97353504826.3301
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 1211314728193.42,
    "valor_anterior": 1202974619061.45,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1076503147455.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1114385603856.33,
        "delta": 37882456400.6401
      },
      {
        "periodo": 202509,
        "valor": 1119541761584.23,
        "delta": 5156157727.8999
      },
      {
        "periodo": 202510,
        "valor": 1118623777907.31,
        "delta": -917983676.9199
      },
      {
        "periodo": 202511,
        "valor": 1113970250769.76,
        "delta": -4653527137.55
      },
      {
        "periodo": 202512,
        "valor": 1150924425454.82,
        "delta": 36954174685.0601
      },
      {
        "periodo": 202601,
        "valor": 1155529280064.36,
        "delta": 4604854609.54
      },
      {
        "periodo": 202602,
        "valor": 1165607252121.4,
        "delta": 10077972057.0398
      },
      {
        "periodo": 202603,
        "valor": 1200962016442.39,
        "delta": 35354764320.99
      },
      {
        "periodo": 202604,
        "valor": 1201058861716.96,
        "delta": 96845274.5701
      },
      {
        "periodo": 202605,
        "valor": 1214853861892.39,
        "delta": 13795000175.4299
      },
      {
        "periodo": 202606,
        "valor": 1202974619061.45,
        "delta": -11879242830.9399
      },
      {
        "periodo": 202607,
        "valor": 1211314728193.42,
        "delta": 8340109131.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 348433806903.72,
    "valor_anterior": 353163060833.89,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 283306701073.75,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 296555271096.93,
        "delta": 13248570023.18
      },
      {
        "periodo": 202509,
        "valor": 311642946914.05,
        "delta": 15087675817.12
      },
      {
        "periodo": 202510,
        "valor": 311512715088.95,
        "delta": -130231825.1
      },
      {
        "periodo": 202511,
        "valor": 317572244864.55,
        "delta": 6059529775.6
      },
      {
        "periodo": 202512,
        "valor": 342538265467.98,
        "delta": 24966020603.43
      },
      {
        "periodo": 202601,
        "valor": 310511762388.67,
        "delta": -32026503079.31
      },
      {
        "periodo": 202602,
        "valor": 309651488039.57,
        "delta": -860274349.1
      },
      {
        "periodo": 202603,
        "valor": 330675203673.16,
        "delta": 21023715633.59
      },
      {
        "periodo": 202604,
        "valor": 322540412976.7299,
        "delta": -8134790696.4301
      },
      {
        "periodo": 202605,
        "valor": 319921112192.98,
        "delta": -2619300783.7499
      },
      {
        "periodo": 202606,
        "valor": 353163060833.89,
        "delta": 33241948640.91
      },
      {
        "periodo": 202607,
        "valor": 348433806903.72,
        "delta": -4729253930.17
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100096,
    "label": "Pasivo",
    "valor_actual": 612751671359.0,
    "valor_anterior": 607797493211.16,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 551850516648.7,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 566786500929.21,
        "delta": 14935984280.51
      },
      {
        "periodo": 202509,
        "valor": 551928094261.05,
        "delta": -14858406668.1599
      },
      {
        "periodo": 202510,
        "valor": 567512099576.85,
        "delta": 15584005315.7999
      },
      {
        "periodo": 202511,
        "valor": 595244112232.84,
        "delta": 27732012655.99
      },
      {
        "periodo": 202512,
        "valor": 571920953913.37,
        "delta": -23323158319.47
      },
      {
        "periodo": 202601,
        "valor": 582888543412.8,
        "delta": 10967589499.4301
      },
      {
        "periodo": 202602,
        "valor": 595555397617.5201,
        "delta": 12666854204.7201
      },
      {
        "periodo": 202603,
        "valor": 602276165110.43,
        "delta": 6720767492.9099
      },
      {
        "periodo": 202604,
        "valor": 607754838087.88,
        "delta": 5478672977.45
      },
      {
        "periodo": 202605,
        "valor": 612939552599.07,
        "delta": 5184714511.1899
      },
      {
        "periodo": 202606,
        "valor": 607797493211.16,
        "delta": -5142059387.9099
      },
      {
        "periodo": 202607,
        "valor": 612751671359.0,
        "delta": 4954178147.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 156935485487.62,
    "valor_anterior": 155365699024.56,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 148019124824.14,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 149674352173.18,
        "delta": 1655227349.04
      },
      {
        "periodo": 202509,
        "valor": 150434502300.57,
        "delta": 760150127.39
      },
      {
        "periodo": 202510,
        "valor": 151386448919.67,
        "delta": 951946619.1
      },
      {
        "periodo": 202511,
        "valor": 154951526481.86,
        "delta": 3565077562.19
      },
      {
        "periodo": 202512,
        "valor": 151115637817.9,
        "delta": -3835888663.96
      },
      {
        "periodo": 202601,
        "valor": 153608145205.25,
        "delta": 2492507387.35
      },
      {
        "periodo": 202602,
        "valor": 155545988381.55,
        "delta": 1937843176.3
      },
      {
        "periodo": 202603,
        "valor": 156818022816.27,
        "delta": 1272034434.72
      },
      {
        "periodo": 202604,
        "valor": 150122782482.35,
        "delta": -6695240333.92
      },
      {
        "periodo": 202605,
        "valor": 153669071155.62,
        "delta": 3546288673.27
      },
      {
        "periodo": 202606,
        "valor": 155365699024.56,
        "delta": 1696627868.94
      },
      {
        "periodo": 202607,
        "valor": 156935485487.62,
        "delta": 1569786463.06
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 380657117142.4501,
    "valor_anterior": 371848608334.72,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 350677751949.56,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 361141583727.93,
        "delta": 10463831778.37
      },
      {
        "periodo": 202509,
        "valor": 354991375906.11,
        "delta": -6150207821.82
      },
      {
        "periodo": 202510,
        "valor": 363711649436.95,
        "delta": 8720273530.84
      },
      {
        "periodo": 202511,
        "valor": 370352891853.25,
        "delta": 6641242416.3
      },
      {
        "periodo": 202512,
        "valor": 360024588405.5,
        "delta": -10328303447.75
      },
      {
        "periodo": 202601,
        "valor": 370832566249.3301,
        "delta": 10807977843.8301
      },
      {
        "periodo": 202602,
        "valor": 377469255260.93,
        "delta": 6636689011.5999
      },
      {
        "periodo": 202603,
        "valor": 365368337079.18,
        "delta": -12100918181.75
      },
      {
        "periodo": 202604,
        "valor": 375059081292.53,
        "delta": 9690744213.35
      },
      {
        "periodo": 202605,
        "valor": 383924005975.88,
        "delta": 8864924683.35
      },
      {
        "periodo": 202606,
        "valor": 371848608334.72,
        "delta": -12075397641.16
      },
      {
        "periodo": 202607,
        "valor": 380657117142.4501,
        "delta": 8808508807.7301
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 137444576164.0,
    "valor_anterior": 134740524903.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 126967656409.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 130197633543.0,
        "delta": 3229977134.0
      },
      {
        "periodo": 202509,
        "valor": 132679346243.0,
        "delta": 2481712700.0
      },
      {
        "periodo": 202510,
        "valor": 135618864372.0,
        "delta": 2939518129.0
      },
      {
        "periodo": 202511,
        "valor": 137593232846.0,
        "delta": 1974368474.0
      },
      {
        "periodo": 202512,
        "valor": 127767214703.0,
        "delta": -9826018143.0
      },
      {
        "periodo": 202601,
        "valor": 131141276258.0,
        "delta": 3374061555.0
      },
      {
        "periodo": 202602,
        "valor": 133362341696.0,
        "delta": 2221065438.0
      },
      {
        "periodo": 202603,
        "valor": 137619213048.0,
        "delta": 4256871352.0
      },
      {
        "periodo": 202604,
        "valor": 140814357633.0,
        "delta": 3195144585.0
      },
      {
        "periodo": 202605,
        "valor": 142302684361.0,
        "delta": 1488326728.0
      },
      {
        "periodo": 202606,
        "valor": 134740524903.0,
        "delta": -7562159458.0
      },
      {
        "periodo": 202607,
        "valor": 137444576164.0,
        "delta": 2704051261.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 47678322646.0,
    "valor_anterior": 47220384336.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 48383262793.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 49478023405.0,
        "delta": 1094760612.0
      },
      {
        "periodo": 202509,
        "valor": 50249399637.0,
        "delta": 771376232.0
      },
      {
        "periodo": 202510,
        "valor": 50486076898.0,
        "delta": 236677261.0
      },
      {
        "periodo": 202511,
        "valor": 48701103065.0,
        "delta": -1784973833.0
      },
      {
        "periodo": 202512,
        "valor": 47917369166.0,
        "delta": -783733899.0
      },
      {
        "periodo": 202601,
        "valor": 49174968729.0,
        "delta": 1257599563.0
      },
      {
        "periodo": 202602,
        "valor": 50255377795.0,
        "delta": 1080409066.0
      },
      {
        "periodo": 202603,
        "valor": 51116474387.0,
        "delta": 861096592.0
      },
      {
        "periodo": 202604,
        "valor": 51272684472.0,
        "delta": 156210085.0
      },
      {
        "periodo": 202605,
        "valor": 51253374612.0,
        "delta": -19309860.0
      },
      {
        "periodo": 202606,
        "valor": 47220384336.0,
        "delta": -4032990276.0
      },
      {
        "periodo": 202607,
        "valor": 47678322646.0,
        "delta": 457938310.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 34277487035.68,
    "valor_anterior": 33650132378.93,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 31717801032.71,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 32531937032.67,
        "delta": 814135999.96
      },
      {
        "periodo": 202509,
        "valor": 33300067862.42,
        "delta": 768130829.75
      },
      {
        "periodo": 202510,
        "valor": 34042769143.02,
        "delta": 742701280.6
      },
      {
        "periodo": 202511,
        "valor": 33732799283.36,
        "delta": -309969859.66
      },
      {
        "periodo": 202512,
        "valor": 34030971334.93,
        "delta": 298172051.57
      },
      {
        "periodo": 202601,
        "valor": 35095348290.55,
        "delta": 1064376955.62
      },
      {
        "periodo": 202602,
        "valor": 35640674414.29,
        "delta": 545326123.74
      },
      {
        "periodo": 202603,
        "valor": 36032147704.38,
        "delta": 391473290.09
      },
      {
        "periodo": 202604,
        "valor": 32242062728.95,
        "delta": -3790084975.43
      },
      {
        "periodo": 202605,
        "valor": 32977780721.09,
        "delta": 735717992.14
      },
      {
        "periodo": 202606,
        "valor": 33650132378.93,
        "delta": 672351657.84
      },
      {
        "periodo": 202607,
        "valor": 34277487035.68,
        "delta": 627354656.75
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 180934142758.0,
    "valor_anterior": 179703513036.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 162329740548.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 163295287533.0,
        "delta": 965546985.0
      },
      {
        "periodo": 202509,
        "valor": 164298004334.0,
        "delta": 1002716801.0
      },
      {
        "periodo": 202510,
        "valor": 166038240575.0,
        "delta": 1740236241.0
      },
      {
        "periodo": 202511,
        "valor": 167602154695.0,
        "delta": 1563914120.0
      },
      {
        "periodo": 202512,
        "valor": 170780893123.0,
        "delta": 3178738428.0
      },
      {
        "periodo": 202601,
        "valor": 172351255455.0,
        "delta": 1570362332.0
      },
      {
        "periodo": 202602,
        "valor": 173540489811.0,
        "delta": 1189234356.0
      },
      {
        "periodo": 202603,
        "valor": 177158951934.0,
        "delta": 3618462123.0
      },
      {
        "periodo": 202604,
        "valor": 177964461882.0,
        "delta": 805509948.0
      },
      {
        "periodo": 202605,
        "valor": 178948636120.0,
        "delta": 984174238.0
      },
      {
        "periodo": 202606,
        "valor": 179703513036.0,
        "delta": 754876916.0
      },
      {
        "periodo": 202607,
        "valor": 180934142758.0,
        "delta": 1230629722.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 15645720700.0,
    "valor_anterior": 15339256695.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12556276724.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12846180679.0,
        "delta": 289903955.0
      },
      {
        "periodo": 202509,
        "valor": 13145958252.0,
        "delta": 299777573.0
      },
      {
        "periodo": 202510,
        "valor": 13464389758.0,
        "delta": 318431506.0
      },
      {
        "periodo": 202511,
        "valor": 13806825083.0,
        "delta": 342435325.0
      },
      {
        "periodo": 202512,
        "valor": 14067158601.0,
        "delta": 260333518.0
      },
      {
        "periodo": 202601,
        "valor": 14349176820.0,
        "delta": 282018219.0
      },
      {
        "periodo": 202602,
        "valor": 14622484900.0,
        "delta": 273308080.0
      },
      {
        "periodo": 202603,
        "valor": 14944644465.0,
        "delta": 322159565.0
      },
      {
        "periodo": 202604,
        "valor": 15228698173.0,
        "delta": 284053708.0
      },
      {
        "periodo": 202605,
        "valor": 15035397044.0,
        "delta": -193301129.0
      },
      {
        "periodo": 202606,
        "valor": 15339256695.0,
        "delta": 303859651.0
      },
      {
        "periodo": 202607,
        "valor": 15645720700.0,
        "delta": 306464005.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 85775183490.99998,
    "valor_anterior": 84694724130.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 78146725322.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 78849342867.0,
        "delta": 702617545.0
      },
      {
        "periodo": 202509,
        "valor": 79593619570.0,
        "delta": 744276703.0
      },
      {
        "periodo": 202510,
        "valor": 79976983525.0,
        "delta": 383363955.0
      },
      {
        "periodo": 202511,
        "valor": 80640686716.0,
        "delta": 663703191.0
      },
      {
        "periodo": 202512,
        "valor": 81686982591.0,
        "delta": 1046295875.0
      },
      {
        "periodo": 202601,
        "valor": 82862044510.0,
        "delta": 1175061919.0
      },
      {
        "periodo": 202602,
        "valor": 83571643242.0,
        "delta": 709598732.0
      },
      {
        "periodo": 202603,
        "valor": 83214614913.0,
        "delta": -357028329.0
      },
      {
        "periodo": 202604,
        "valor": 83210775791.0,
        "delta": -3839122.0
      },
      {
        "periodo": 202605,
        "valor": 83783421998.0,
        "delta": 572646207.0
      },
      {
        "periodo": 202606,
        "valor": 84694724130.0,
        "delta": 911302132.0
      },
      {
        "periodo": 202607,
        "valor": 85775183491.0,
        "delta": 1080459361.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 29891219098.229996,
    "valor_anterior": 29360633664.85,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26814414295.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 27341031991.24,
        "delta": 526617695.98
      },
      {
        "periodo": 202509,
        "valor": 27915022715.77,
        "delta": 573990724.53
      },
      {
        "periodo": 202510,
        "valor": 28467863112.33,
        "delta": 552840396.56
      },
      {
        "periodo": 202511,
        "valor": 27817810940.7,
        "delta": -650052171.63
      },
      {
        "periodo": 202512,
        "valor": 28430606138.93,
        "delta": 612795198.23
      },
      {
        "periodo": 202601,
        "valor": 28964840118.76,
        "delta": 534233979.83
      },
      {
        "periodo": 202602,
        "valor": 29166796342.11,
        "delta": 201956223.35
      },
      {
        "periodo": 202603,
        "valor": 27803943659.36,
        "delta": -1362852682.75
      },
      {
        "periodo": 202604,
        "valor": 28414525882.42,
        "delta": 610582223.06
      },
      {
        "periodo": 202605,
        "valor": 28903429571.84,
        "delta": 488903689.42
      },
      {
        "periodo": 202606,
        "valor": 29360633664.85,
        "delta": 457204093.01
      },
      {
        "periodo": 202607,
        "valor": 29891219098.23,
        "delta": 530585433.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 10411005629.0,
    "valor_anterior": 10169948992.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9010773454.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9054692408.0,
        "delta": 43918954.0
      },
      {
        "periodo": 202509,
        "valor": 9275027625.0,
        "delta": 220335217.0
      },
      {
        "periodo": 202510,
        "valor": 9489721817.0,
        "delta": 214694192.0
      },
      {
        "periodo": 202511,
        "valor": 9488351153.0,
        "delta": -1370664.0
      },
      {
        "periodo": 202512,
        "valor": 9540859384.0,
        "delta": 52508231.0
      },
      {
        "periodo": 202601,
        "valor": 9509658665.0,
        "delta": -31200719.0
      },
      {
        "periodo": 202602,
        "valor": 9535735732.0,
        "delta": 26077067.0
      },
      {
        "periodo": 202603,
        "valor": 9652441178.0,
        "delta": 116705446.0
      },
      {
        "periodo": 202604,
        "valor": 9701780702.0,
        "delta": 49339524.0
      },
      {
        "periodo": 202605,
        "valor": 10011942316.0,
        "delta": 310161614.0
      },
      {
        "periodo": 202606,
        "valor": 10169948992.0,
        "delta": 158006676.0
      },
      {
        "periodo": 202607,
        "valor": 10411005629.0,
        "delta": 241056637.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 4609839252.0,
    "valor_anterior": 4509208286.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3299774978.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3437983484.0,
        "delta": 138208506.0
      },
      {
        "periodo": 202509,
        "valor": 3573459043.0,
        "delta": 135475559.0
      },
      {
        "periodo": 202510,
        "valor": 3668350330.0,
        "delta": 94891287.0
      },
      {
        "periodo": 202511,
        "valor": 3769982222.0,
        "delta": 101631892.0
      },
      {
        "periodo": 202512,
        "valor": 3901499158.0,
        "delta": 131516936.0
      },
      {
        "periodo": 202601,
        "valor": 3991198597.0,
        "delta": 89699439.0
      },
      {
        "periodo": 202602,
        "valor": 4095338213.0,
        "delta": 104139616.0
      },
      {
        "periodo": 202603,
        "valor": 4210517527.0,
        "delta": 115179314.0
      },
      {
        "periodo": 202604,
        "valor": 4315427034.0,
        "delta": 104909507.0
      },
      {
        "periodo": 202605,
        "valor": 4404945471.0,
        "delta": 89518437.0
      },
      {
        "periodo": 202606,
        "valor": 4509208286.0,
        "delta": 104262815.0
      },
      {
        "periodo": 202607,
        "valor": 4609839252.0,
        "delta": 100630966.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 5229414970.0,
    "valor_anterior": 5153461678.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4858445689.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4937274226.0,
        "delta": 78828537.0
      },
      {
        "periodo": 202509,
        "valor": 4977338655.0,
        "delta": 40064429.0
      },
      {
        "periodo": 202510,
        "valor": 4832453487.0,
        "delta": -144885168.0
      },
      {
        "periodo": 202511,
        "valor": 4920733226.0,
        "delta": 88279739.0
      },
      {
        "periodo": 202512,
        "valor": 4530468262.0,
        "delta": -390264964.0
      },
      {
        "periodo": 202601,
        "valor": 4618336334.0,
        "delta": 87868072.0
      },
      {
        "periodo": 202602,
        "valor": 4630036691.0,
        "delta": 11700357.0
      },
      {
        "periodo": 202603,
        "valor": 4910219260.0,
        "delta": 280182569.0
      },
      {
        "periodo": 202604,
        "valor": 4990288537.0,
        "delta": 80069277.0
      },
      {
        "periodo": 202605,
        "valor": 5059121823.0,
        "delta": 68833286.0
      },
      {
        "periodo": 202606,
        "valor": 5153461678.0,
        "delta": 94339855.0
      },
      {
        "periodo": 202607,
        "valor": 5229414970.0,
        "delta": 75953292.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 138743348570.91,
    "valor_anterior": 140854239843.33,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 141212524226.08,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 145561892523.11,
        "delta": 4349368297.03
      },
      {
        "periodo": 202509,
        "valor": 148674327397.92,
        "delta": 3112434874.81
      },
      {
        "periodo": 202510,
        "valor": 152094131403.28,
        "delta": 3419804005.36
      },
      {
        "periodo": 202511,
        "valor": 129974166494.14,
        "delta": -22119964909.14
      },
      {
        "periodo": 202512,
        "valor": 132832512844.68,
        "delta": 2858346350.54
      },
      {
        "periodo": 202601,
        "valor": 136303754816.59,
        "delta": 3471241971.91
      },
      {
        "periodo": 202602,
        "valor": 140607960460.3,
        "delta": 4304205643.71
      },
      {
        "periodo": 202603,
        "valor": 142414561505.62,
        "delta": 1806601045.32
      },
      {
        "periodo": 202604,
        "valor": 132973625268.92,
        "delta": -9440936236.7
      },
      {
        "periodo": 202605,
        "valor": 136314971218.23,
        "delta": 3341345949.31
      },
      {
        "periodo": 202606,
        "valor": 140854239843.33,
        "delta": 4539268625.1
      },
      {
        "periodo": 202607,
        "valor": 138743348570.91,
        "delta": -2110891272.42
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 17870901229.0,
    "valor_anterior": 17690162751.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16009550497.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16146849421.0,
        "delta": 137298924.0
      },
      {
        "periodo": 202509,
        "valor": 16185093589.0,
        "delta": 38244168.0
      },
      {
        "periodo": 202510,
        "valor": 16446604244.0,
        "delta": 261510655.0
      },
      {
        "periodo": 202511,
        "valor": 16357646236.0,
        "delta": -88958008.0
      },
      {
        "periodo": 202512,
        "valor": 16595021321.0,
        "delta": 237375085.0
      },
      {
        "periodo": 202601,
        "valor": 16823617188.0,
        "delta": 228595867.0
      },
      {
        "periodo": 202602,
        "valor": 17018998422.0,
        "delta": 195381234.0
      },
      {
        "periodo": 202603,
        "valor": 17283291636.0,
        "delta": 264293214.0
      },
      {
        "periodo": 202604,
        "valor": 17619352261.0,
        "delta": 336060625.0
      },
      {
        "periodo": 202605,
        "valor": 17598740972.0,
        "delta": -20611289.0
      },
      {
        "periodo": 202606,
        "valor": 17690162751.0,
        "delta": 91421779.0
      },
      {
        "periodo": 202607,
        "valor": 17870901229.0,
        "delta": 180738478.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 6874927948.0,
    "valor_anterior": 6805722015.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6103338260.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6204699910.0,
        "delta": 101361650.0
      },
      {
        "periodo": 202509,
        "valor": 6305055579.0,
        "delta": 100355669.0
      },
      {
        "periodo": 202510,
        "valor": 6367094350.0,
        "delta": 62038771.0
      },
      {
        "periodo": 202511,
        "valor": 6455116266.0,
        "delta": 88021916.0
      },
      {
        "periodo": 202512,
        "valor": 6535725842.0,
        "delta": 80609576.0
      },
      {
        "periodo": 202601,
        "valor": 6595442258.0,
        "delta": 59716416.0
      },
      {
        "periodo": 202602,
        "valor": 6615759563.0,
        "delta": 20317305.0
      },
      {
        "periodo": 202603,
        "valor": 6647457665.0,
        "delta": 31698102.0
      },
      {
        "periodo": 202604,
        "valor": 6729805882.0,
        "delta": 82348217.0
      },
      {
        "periodo": 202605,
        "valor": 6791310166.0,
        "delta": 61504284.0
      },
      {
        "periodo": 202606,
        "valor": 6805722015.0,
        "delta": 14411849.0
      },
      {
        "periodo": 202607,
        "valor": 6874927948.0,
        "delta": 69205933.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 24843313659.0,
    "valor_anterior": 24579455723.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20625251744.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21291381124.0,
        "delta": 666129380.0
      },
      {
        "periodo": 202509,
        "valor": 21899759672.0,
        "delta": 608378548.0
      },
      {
        "periodo": 202510,
        "valor": 22308020619.0,
        "delta": 408260947.0
      },
      {
        "periodo": 202511,
        "valor": 22587956704.0,
        "delta": 279936085.0
      },
      {
        "periodo": 202512,
        "valor": 22839040333.0,
        "delta": 251083629.0
      },
      {
        "periodo": 202601,
        "valor": 23060137726.0,
        "delta": 221097393.0
      },
      {
        "periodo": 202602,
        "valor": 23451214185.0,
        "delta": 391076459.0
      },
      {
        "periodo": 202603,
        "valor": 23810496742.0,
        "delta": 359282557.0
      },
      {
        "periodo": 202604,
        "valor": 24047716315.0,
        "delta": 237219573.0
      },
      {
        "periodo": 202605,
        "valor": 24335059498.0,
        "delta": 287343183.0
      },
      {
        "periodo": 202606,
        "valor": 24579455723.0,
        "delta": 244396225.0
      },
      {
        "periodo": 202607,
        "valor": 24843313659.0,
        "delta": 263857936.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 14573388870.65,
    "valor_anterior": 15312933335.76,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12764560181.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13103885689.05,
        "delta": 339325507.79
      },
      {
        "periodo": 202509,
        "valor": 13454001000.48,
        "delta": 350115311.43
      },
      {
        "periodo": 202510,
        "valor": 13853321580.68,
        "delta": 399320580.2
      },
      {
        "periodo": 202511,
        "valor": 14082511048.11,
        "delta": 229189467.43
      },
      {
        "periodo": 202512,
        "valor": 14510807296.94,
        "delta": 428296248.83
      },
      {
        "periodo": 202601,
        "valor": 14914853084.98,
        "delta": 404045788.04
      },
      {
        "periodo": 202602,
        "valor": 15185183982.09,
        "delta": 270330897.11
      },
      {
        "periodo": 202603,
        "valor": 15213146022.11,
        "delta": 27962040.02
      },
      {
        "periodo": 202604,
        "valor": 14605142463.97,
        "delta": -608003558.14
      },
      {
        "periodo": 202605,
        "valor": 14951159077.96,
        "delta": 346016613.99
      },
      {
        "periodo": 202606,
        "valor": 15312933335.76,
        "delta": 361774257.8
      },
      {
        "periodo": 202607,
        "valor": 14573388870.65,
        "delta": -739544465.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 7338270628.999999,
    "valor_anterior": 7326228727.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6351971254.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6401528951.0,
        "delta": 49557697.0
      },
      {
        "periodo": 202509,
        "valor": 6517756593.0,
        "delta": 116227642.0
      },
      {
        "periodo": 202510,
        "valor": 6511007341.0,
        "delta": -6749252.0
      },
      {
        "periodo": 202511,
        "valor": 6592170638.0,
        "delta": 81163297.0
      },
      {
        "periodo": 202512,
        "valor": 6707796795.0,
        "delta": 115626157.0
      },
      {
        "periodo": 202601,
        "valor": 6795745588.0,
        "delta": 87948793.0
      },
      {
        "periodo": 202602,
        "valor": 6817172344.0,
        "delta": 21426756.0
      },
      {
        "periodo": 202603,
        "valor": 6997722729.0,
        "delta": 180550385.0
      },
      {
        "periodo": 202604,
        "valor": 7121630599.0,
        "delta": 123907870.0
      },
      {
        "periodo": 202605,
        "valor": 7197662513.0,
        "delta": 76031914.0
      },
      {
        "periodo": 202606,
        "valor": 7326228727.0,
        "delta": 128566214.0
      },
      {
        "periodo": 202607,
        "valor": 7338270629.0,
        "delta": 12041902.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 72364175797.99,
    "valor_anterior": 71903777547.78,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 62406892017.54,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 63919903033.5,
        "delta": 1513011015.96
      },
      {
        "periodo": 202509,
        "valor": 64769205438.58,
        "delta": 849302405.08
      },
      {
        "periodo": 202510,
        "valor": 65745259498.62,
        "delta": 976054060.04
      },
      {
        "periodo": 202511,
        "valor": 66163251132.63,
        "delta": 417991634.01
      },
      {
        "periodo": 202512,
        "valor": 67672528314.28,
        "delta": 1509277181.65
      },
      {
        "periodo": 202601,
        "valor": 68940975980.75,
        "delta": 1268447666.47
      },
      {
        "periodo": 202602,
        "valor": 69826370999.76,
        "delta": 885395019.01
      },
      {
        "periodo": 202603,
        "valor": 69105458706.71,
        "delta": -720912293.05
      },
      {
        "periodo": 202604,
        "valor": 70424779628.14,
        "delta": 1319320921.43
      },
      {
        "periodo": 202605,
        "valor": 71452106658.62,
        "delta": 1027327030.48
      },
      {
        "periodo": 202606,
        "valor": 71903777547.78,
        "delta": 451670889.16
      },
      {
        "periodo": 202607,
        "valor": 72364175797.99,
        "delta": 460398250.21
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": -1653433540.0,
    "valor_anterior": -1651951681.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1599013525.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1612405380.0,
        "delta": -13391855.0
      },
      {
        "periodo": 202509,
        "valor": -1622847364.0,
        "delta": -10441984.0
      },
      {
        "periodo": 202510,
        "valor": -1613725771.0,
        "delta": 9121593.0
      },
      {
        "periodo": 202511,
        "valor": -1635191836.0,
        "delta": -21466065.0
      },
      {
        "periodo": 202512,
        "valor": -1665314210.0,
        "delta": -30122374.0
      },
      {
        "periodo": 202601,
        "valor": -1660035609.0,
        "delta": 5278601.0
      },
      {
        "periodo": 202602,
        "valor": -1659533449.0,
        "delta": 502160.0
      },
      {
        "periodo": 202603,
        "valor": -1662318094.0,
        "delta": -2784645.0
      },
      {
        "periodo": 202604,
        "valor": -1657365206.0,
        "delta": 4952888.0
      },
      {
        "periodo": 202605,
        "valor": -1657219811.0,
        "delta": 145395.0
      },
      {
        "periodo": 202606,
        "valor": -1651951681.0,
        "delta": 5268130.0
      },
      {
        "periodo": 202607,
        "valor": -1653433540.0,
        "delta": -1481859.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 24324041844.19,
    "valor_anterior": 24661796135.07,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 23870302455.86,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24348843022.32,
        "delta": 478540566.46
      },
      {
        "periodo": 202509,
        "valor": 24589692582.84,
        "delta": 240849560.52
      },
      {
        "periodo": 202510,
        "valor": 25570055064.32,
        "delta": 980362481.48
      },
      {
        "periodo": 202511,
        "valor": 26175929959.35,
        "delta": 605874895.03
      },
      {
        "periodo": 202512,
        "valor": 27229410469.42,
        "delta": 1053480510.07
      },
      {
        "periodo": 202601,
        "valor": 26294364749.95,
        "delta": -935045719.47
      },
      {
        "periodo": 202602,
        "valor": 26828687824.33,
        "delta": 534323074.38
      },
      {
        "periodo": 202603,
        "valor": 27535487324.47,
        "delta": 706799500.14
      },
      {
        "periodo": 202604,
        "valor": 26362037192.16,
        "delta": -1173450132.31
      },
      {
        "periodo": 202605,
        "valor": 25629491105.13,
        "delta": -732546087.03
      },
      {
        "periodo": 202606,
        "valor": 24661796135.07,
        "delta": -967694970.06
      },
      {
        "periodo": 202607,
        "valor": 24324041844.19,
        "delta": -337754290.88
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 1594332368.0,
    "valor_anterior": 2120781933.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -856784173.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -801662328.47,
        "delta": 55121844.95
      },
      {
        "periodo": 202509,
        "valor": 1015888543.0,
        "delta": 1817550871.47
      },
      {
        "periodo": 202510,
        "valor": 1113476847.0,
        "delta": 97588304.0
      },
      {
        "periodo": 202511,
        "valor": 1094419402.0,
        "delta": -19057445.0
      },
      {
        "periodo": 202512,
        "valor": 1262786707.0,
        "delta": 168367305.0
      },
      {
        "periodo": 202601,
        "valor": 1419881491.0,
        "delta": 157094784.0
      },
      {
        "periodo": 202602,
        "valor": 1530416786.0,
        "delta": 110535295.0
      },
      {
        "periodo": 202603,
        "valor": 1796057164.0,
        "delta": 265640378.0
      },
      {
        "periodo": 202604,
        "valor": 1912807457.0,
        "delta": 116750293.0
      },
      {
        "periodo": 202605,
        "valor": 2030323422.0,
        "delta": 117515965.0
      },
      {
        "periodo": 202606,
        "valor": 2120781933.0,
        "delta": 90458511.0
      },
      {
        "periodo": 202607,
        "valor": 1594332368.0,
        "delta": -526449565.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 4969009116.0,
    "valor_anterior": 4975628952.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5395561582.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5347122904.0,
        "delta": -48438678.0
      },
      {
        "periodo": 202509,
        "valor": 5425204820.0,
        "delta": 78081916.0
      },
      {
        "periodo": 202510,
        "valor": 5481447056.0,
        "delta": 56242236.0
      },
      {
        "periodo": 202511,
        "valor": 4741269216.0,
        "delta": -740177840.0
      },
      {
        "periodo": 202512,
        "valor": 4637780184.0,
        "delta": -103489032.0
      },
      {
        "periodo": 202601,
        "valor": 4700934862.0,
        "delta": 63154678.0
      },
      {
        "periodo": 202602,
        "valor": 4808164287.0,
        "delta": 107229425.0
      },
      {
        "periodo": 202603,
        "valor": 4836206372.0,
        "delta": 28042085.0
      },
      {
        "periodo": 202604,
        "valor": 4896067586.0,
        "delta": 59861214.0
      },
      {
        "periodo": 202605,
        "valor": 4963899469.0,
        "delta": 67831883.0
      },
      {
        "periodo": 202606,
        "valor": 4975628953.0,
        "delta": 11729484.0
      },
      {
        "periodo": 202607,
        "valor": 4969009116.0,
        "delta": -6619837.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 19652660073.0,
    "valor_anterior": 19195071779.999996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17121355536.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17627457346.0,
        "delta": 506101810.0
      },
      {
        "periodo": 202509,
        "valor": 18132303255.0,
        "delta": 504845909.0
      },
      {
        "periodo": 202510,
        "valor": 18561062423.0,
        "delta": 428759168.0
      },
      {
        "periodo": 202511,
        "valor": 17612139495.0,
        "delta": -948922928.0
      },
      {
        "periodo": 202512,
        "valor": 17951006612.0,
        "delta": 338867117.0
      },
      {
        "periodo": 202601,
        "valor": 18573283005.0,
        "delta": 622276393.0
      },
      {
        "periodo": 202602,
        "valor": 19105147492.0,
        "delta": 531864487.0
      },
      {
        "periodo": 202603,
        "valor": 19606471229.0,
        "delta": 501323737.0
      },
      {
        "periodo": 202604,
        "valor": 18055415803.0,
        "delta": -1551055426.0
      },
      {
        "periodo": 202605,
        "valor": 18584415068.0,
        "delta": 528999265.0
      },
      {
        "periodo": 202606,
        "valor": 19195071780.0,
        "delta": 610656712.0
      },
      {
        "periodo": 202607,
        "valor": 19652660073.0,
        "delta": 457588293.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 8187497816.999999,
    "valor_anterior": 8005891676.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6459934486.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6562496783.0,
        "delta": 102562297.0
      },
      {
        "periodo": 202509,
        "valor": 6668827409.0,
        "delta": 106330626.0
      },
      {
        "periodo": 202510,
        "valor": 6905853891.0,
        "delta": 237026482.0
      },
      {
        "periodo": 202511,
        "valor": 7057692414.0,
        "delta": 151838523.0
      },
      {
        "periodo": 202512,
        "valor": 7150592744.0,
        "delta": 92900330.0
      },
      {
        "periodo": 202601,
        "valor": 7270200297.0,
        "delta": 119607553.0
      },
      {
        "periodo": 202602,
        "valor": 7361384759.0,
        "delta": 91184462.0
      },
      {
        "periodo": 202603,
        "valor": 7474079347.0,
        "delta": 112694588.0
      },
      {
        "periodo": 202604,
        "valor": 7613953444.0,
        "delta": 139874097.0
      },
      {
        "periodo": 202605,
        "valor": 7775124486.0,
        "delta": 161171042.0
      },
      {
        "periodo": 202606,
        "valor": 8005891676.0,
        "delta": 230767190.0
      },
      {
        "periodo": 202607,
        "valor": 8187497817.0,
        "delta": 181606141.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 4010331994.0,
    "valor_anterior": 3977636293.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3747034030.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3746474323.0,
        "delta": -559707.0
      },
      {
        "periodo": 202509,
        "valor": 3837001574.0,
        "delta": 90527251.0
      },
      {
        "periodo": 202510,
        "valor": 3898663302.0,
        "delta": 61661728.0
      },
      {
        "periodo": 202511,
        "valor": 3882614007.0,
        "delta": -16049295.0
      },
      {
        "periodo": 202512,
        "valor": 3938024285.0,
        "delta": 55410278.0
      },
      {
        "periodo": 202601,
        "valor": 3928348889.0,
        "delta": -9675396.0
      },
      {
        "periodo": 202602,
        "valor": 3952731999.0,
        "delta": 24383110.0
      },
      {
        "periodo": 202603,
        "valor": 3873254640.0,
        "delta": -79477359.0
      },
      {
        "periodo": 202604,
        "valor": 3909935218.0,
        "delta": 36680578.0
      },
      {
        "periodo": 202605,
        "valor": 3998854717.0,
        "delta": 88919499.0
      },
      {
        "periodo": 202606,
        "valor": 3977636293.0,
        "delta": -21218424.0
      },
      {
        "periodo": 202607,
        "valor": 4010331994.0,
        "delta": 32695701.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 518546428.0,
    "valor_anterior": 679436100.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8665515076.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8502252565.0,
        "delta": -163262511.0
      },
      {
        "periodo": 202509,
        "valor": 7613912936.0,
        "delta": -888339629.0
      },
      {
        "periodo": 202510,
        "valor": 7519925690.0,
        "delta": -93987246.0
      },
      {
        "periodo": 202511,
        "valor": 1713544364.0,
        "delta": -5806381326.0
      },
      {
        "periodo": 202512,
        "valor": 1599485717.0,
        "delta": -114058647.0
      },
      {
        "periodo": 202601,
        "valor": 1637701388.0,
        "delta": 38215671.0
      },
      {
        "periodo": 202602,
        "valor": 1703324716.0,
        "delta": 65623328.0
      },
      {
        "periodo": 202603,
        "valor": 1714500761.0,
        "delta": 11176045.0
      },
      {
        "periodo": 202604,
        "valor": 1170342644.0,
        "delta": -544158117.0
      },
      {
        "periodo": 202605,
        "valor": 1146140165.0,
        "delta": -24202479.0
      },
      {
        "periodo": 202606,
        "valor": 679436100.0,
        "delta": -466704065.0
      },
      {
        "periodo": 202607,
        "valor": 518546428.0,
        "delta": -160889672.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 21842761137.01,
    "valor_anterior": 21768584267.66,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20372175308.37,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 20972223841.42,
        "delta": 600048533.05
      },
      {
        "periodo": 202509,
        "valor": 20291068872.42,
        "delta": -681154969.0
      },
      {
        "periodo": 202510,
        "valor": 20532307200.19,
        "delta": 241238327.77
      },
      {
        "periodo": 202511,
        "valor": 20619385177.44,
        "delta": 87077977.25
      },
      {
        "periodo": 202512,
        "valor": 20424651080.27,
        "delta": -194734097.17
      },
      {
        "periodo": 202601,
        "valor": 20731454748.03,
        "delta": 306803667.76
      },
      {
        "periodo": 202602,
        "valor": 21343974286.61,
        "delta": 612519538.58
      },
      {
        "periodo": 202603,
        "valor": 20304727544.08,
        "delta": -1039246742.53
      },
      {
        "periodo": 202604,
        "valor": 20705253547.53,
        "delta": 400526003.45
      },
      {
        "periodo": 202605,
        "valor": 21083532374.76,
        "delta": 378278827.23
      },
      {
        "periodo": 202606,
        "valor": 21768584267.66,
        "delta": 685051892.9
      },
      {
        "periodo": 202607,
        "valor": 21842761137.01,
        "delta": 74176869.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": -5461259104.999999,
    "valor_anterior": -5381793280.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -4272088948.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -4371691171.0,
        "delta": -99602223.0
      },
      {
        "periodo": 202509,
        "valor": -4462462565.0,
        "delta": -90771394.0
      },
      {
        "periodo": 202510,
        "valor": -4571235368.0,
        "delta": -108772803.0
      },
      {
        "periodo": 202511,
        "valor": -4704796397.0,
        "delta": -133561029.0
      },
      {
        "periodo": 202512,
        "valor": -4810835017.0,
        "delta": -106038620.0
      },
      {
        "periodo": 202601,
        "valor": -4896010979.0,
        "delta": -85175962.0
      },
      {
        "periodo": 202602,
        "valor": -5003154366.0,
        "delta": -107143387.0
      },
      {
        "periodo": 202603,
        "valor": -5136944758.0,
        "delta": -133790392.0
      },
      {
        "periodo": 202604,
        "valor": -5226174660.0,
        "delta": -89229902.0
      },
      {
        "periodo": 202605,
        "valor": -5297609490.0,
        "delta": -71434830.0
      },
      {
        "periodo": 202606,
        "valor": -5381793281.0,
        "delta": -84183791.0
      },
      {
        "periodo": 202607,
        "valor": -5461259105.0,
        "delta": -79465824.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 346967582.0,
    "valor_anterior": 342755488.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 276008810.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 286013768.0,
        "delta": 10004958.0
      },
      {
        "periodo": 202509,
        "valor": 300378504.0,
        "delta": 14364736.0
      },
      {
        "periodo": 202510,
        "valor": 309496338.0,
        "delta": 9117834.0
      },
      {
        "periodo": 202511,
        "valor": 310818853.0,
        "delta": 1322515.0
      },
      {
        "periodo": 202512,
        "valor": 306904721.0,
        "delta": -3914132.0
      },
      {
        "periodo": 202601,
        "valor": 309656418.0,
        "delta": 2751697.0
      },
      {
        "periodo": 202602,
        "valor": 313677169.0,
        "delta": 4020751.0
      },
      {
        "periodo": 202603,
        "valor": 321539978.0,
        "delta": 7862809.0
      },
      {
        "periodo": 202604,
        "valor": 327867054.0,
        "delta": 6327076.0
      },
      {
        "periodo": 202605,
        "valor": 336719399.0,
        "delta": 8852345.0
      },
      {
        "periodo": 202606,
        "valor": 342755488.0,
        "delta": 6036089.0
      },
      {
        "periodo": 202607,
        "valor": 346967582.0,
        "delta": 4212094.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 4585562601.0,
    "valor_anterior": 4539999361.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3226229293.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3344313118.0,
        "delta": 118083825.0
      },
      {
        "periodo": 202509,
        "valor": 3469298605.0,
        "delta": 124985487.0
      },
      {
        "periodo": 202510,
        "valor": 3571879988.0,
        "delta": 102581383.0
      },
      {
        "periodo": 202511,
        "valor": 3724975783.0,
        "delta": 153095795.0
      },
      {
        "periodo": 202512,
        "valor": 3809884892.0,
        "delta": 84909109.0
      },
      {
        "periodo": 202601,
        "valor": 3914013478.0,
        "delta": 104128586.0
      },
      {
        "periodo": 202602,
        "valor": 4052039154.0,
        "delta": 138025676.0
      },
      {
        "periodo": 202603,
        "valor": 4203711280.0,
        "delta": 151672126.0
      },
      {
        "periodo": 202604,
        "valor": 4341311747.0,
        "delta": 137600467.0
      },
      {
        "periodo": 202605,
        "valor": 4452630993.0,
        "delta": 111319246.0
      },
      {
        "periodo": 202606,
        "valor": 4539999361.0,
        "delta": 87368368.0
      },
      {
        "periodo": 202607,
        "valor": 4585562601.0,
        "delta": 45563240.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 2978586423.0,
    "valor_anterior": 2933832865.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2590629360.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2611939697.0,
        "delta": 21310337.0
      },
      {
        "periodo": 202509,
        "valor": 2661867954.0,
        "delta": 49928257.0
      },
      {
        "periodo": 202510,
        "valor": 2657038162.0,
        "delta": -4829792.0
      },
      {
        "periodo": 202511,
        "valor": 2662543758.0,
        "delta": 5505596.0
      },
      {
        "periodo": 202512,
        "valor": 2716975629.0,
        "delta": 54431871.0
      },
      {
        "periodo": 202601,
        "valor": 2739244042.0,
        "delta": 22268413.0
      },
      {
        "periodo": 202602,
        "valor": 2807962984.0,
        "delta": 68718942.0
      },
      {
        "periodo": 202603,
        "valor": 2864136194.0,
        "delta": 56173210.0
      },
      {
        "periodo": 202604,
        "valor": 2859188422.0,
        "delta": -4947772.0
      },
      {
        "periodo": 202605,
        "valor": 2867567778.0,
        "delta": 8379356.0
      },
      {
        "periodo": 202606,
        "valor": 2933832865.0,
        "delta": 66265087.0
      },
      {
        "periodo": 202607,
        "valor": 2978586423.0,
        "delta": 44753558.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3307285015.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2426258300.0,
        "delta": -881026715.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 7101403216.0,
    "valor_anterior": 6952759368.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6549046826.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6704598692.0,
        "delta": 155551866.0
      },
      {
        "periodo": 202509,
        "valor": 6211287192.0,
        "delta": -493311500.0
      },
      {
        "periodo": 202510,
        "valor": 6405402878.0,
        "delta": 194115686.0
      },
      {
        "periodo": 202511,
        "valor": 6482482760.0,
        "delta": 77079882.0
      },
      {
        "periodo": 202512,
        "valor": 6790838096.0,
        "delta": 308355336.0
      },
      {
        "periodo": 202601,
        "valor": 6888948863.0,
        "delta": 98110767.0
      },
      {
        "periodo": 202602,
        "valor": 7002395613.0,
        "delta": 113446750.0
      },
      {
        "periodo": 202603,
        "valor": 7000556632.0,
        "delta": -1838981.0
      },
      {
        "periodo": 202604,
        "valor": 6685921702.0,
        "delta": -314634930.0
      },
      {
        "periodo": 202605,
        "valor": 6815199598.0,
        "delta": 129277896.0
      },
      {
        "periodo": 202606,
        "valor": 6952759368.0,
        "delta": 137559770.0
      },
      {
        "periodo": 202607,
        "valor": 7101403216.0,
        "delta": 148643848.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": -567777494.0,
    "valor_anterior": -494841106.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -590679066.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -530669014.0,
        "delta": 60010052.0
      },
      {
        "periodo": 202509,
        "valor": -545823874.0,
        "delta": -15154860.0
      },
      {
        "periodo": 202510,
        "valor": -562643044.0,
        "delta": -16819170.0
      },
      {
        "periodo": 202511,
        "valor": -600731226.0,
        "delta": -38088182.0
      },
      {
        "periodo": 202512,
        "valor": -521791023.0,
        "delta": 78940203.0
      },
      {
        "periodo": 202601,
        "valor": -515230625.0,
        "delta": 6560398.0
      },
      {
        "periodo": 202602,
        "valor": -524401218.0,
        "delta": -9170593.0
      },
      {
        "periodo": 202603,
        "valor": -508993022.0,
        "delta": 15408196.0
      },
      {
        "periodo": 202604,
        "valor": -634877543.0,
        "delta": -125884521.0
      },
      {
        "periodo": 202605,
        "valor": -677010022.0,
        "delta": -42132479.0
      },
      {
        "periodo": 202606,
        "valor": -494841106.0,
        "delta": 182168916.0
      },
      {
        "periodo": 202607,
        "valor": -567777494.0,
        "delta": -72936388.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": -424038144.0,
    "valor_anterior": -427624059.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -417286306.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -426100846.0,
        "delta": -8814540.0
      },
      {
        "periodo": 202509,
        "valor": -431030635.0,
        "delta": -4929789.0
      },
      {
        "periodo": 202510,
        "valor": -437831099.0,
        "delta": -6800464.0
      },
      {
        "periodo": 202511,
        "valor": -425608874.0,
        "delta": 12222225.0
      },
      {
        "periodo": 202512,
        "valor": -422717236.0,
        "delta": 2891638.0
      },
      {
        "periodo": 202601,
        "valor": -429414725.0,
        "delta": -6697489.0
      },
      {
        "periodo": 202602,
        "valor": -428616327.0,
        "delta": 798398.0
      },
      {
        "periodo": 202603,
        "valor": -427861747.0,
        "delta": 754580.0
      },
      {
        "periodo": 202604,
        "valor": -431717975.0,
        "delta": -3856228.0
      },
      {
        "periodo": 202605,
        "valor": -429623901.0,
        "delta": 2094074.0
      },
      {
        "periodo": 202606,
        "valor": -427624059.0,
        "delta": 1999842.0
      },
      {
        "periodo": 202607,
        "valor": -424038144.0,
        "delta": 3585915.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": -461258961.0,
    "valor_anterior": -451848560.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -382737510.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -389116411.0,
        "delta": -6378901.0
      },
      {
        "periodo": 202509,
        "valor": -390149083.0,
        "delta": -1032672.0
      },
      {
        "periodo": 202510,
        "valor": -396128298.0,
        "delta": -5979215.0
      },
      {
        "periodo": 202511,
        "valor": -400471880.0,
        "delta": -4343582.0
      },
      {
        "periodo": 202512,
        "valor": -412079228.0,
        "delta": -11607348.0
      },
      {
        "periodo": 202601,
        "valor": -416081615.0,
        "delta": -4002387.0
      },
      {
        "periodo": 202602,
        "valor": -421041419.0,
        "delta": -4959804.0
      },
      {
        "periodo": 202603,
        "valor": -427824002.0,
        "delta": -6782583.0
      },
      {
        "periodo": 202604,
        "valor": -432607053.0,
        "delta": -4783051.0
      },
      {
        "periodo": 202605,
        "valor": -441516659.0,
        "delta": -8909606.0
      },
      {
        "periodo": 202606,
        "valor": -451848560.0,
        "delta": -10331901.0
      },
      {
        "periodo": 202607,
        "valor": -461258961.0,
        "delta": -9410401.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 159916436.38,
    "valor_anterior": 149835466.35,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 329707135.36,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 331881116.94,
        "delta": 2173981.58
      },
      {
        "periodo": 202509,
        "valor": 175798562.18,
        "delta": -156082554.76
      },
      {
        "periodo": 202510,
        "valor": 185830131.55,
        "delta": 10031569.37
      },
      {
        "periodo": 202511,
        "valor": 195993669.41,
        "delta": 10163537.86
      },
      {
        "periodo": 202512,
        "valor": 218158385.27,
        "delta": 22164715.86
      },
      {
        "periodo": 202601,
        "valor": 234734014.69,
        "delta": 16575629.42
      },
      {
        "periodo": 202602,
        "valor": 243993385.72,
        "delta": 9259371.03
      },
      {
        "periodo": 202603,
        "valor": 249376718.69,
        "delta": 5383332.97
      },
      {
        "periodo": 202604,
        "valor": 257783244.44,
        "delta": 8406525.75
      },
      {
        "periodo": 202605,
        "valor": 137721565.57,
        "delta": -120061678.87
      },
      {
        "periodo": 202606,
        "valor": 149835466.35,
        "delta": 12113900.78
      },
      {
        "periodo": 202607,
        "valor": 159916436.38,
        "delta": 10080970.03
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": -423778464.0,
    "valor_anterior": -424049217.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -392611849.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -400518142.0,
        "delta": -7906293.0
      },
      {
        "periodo": 202509,
        "valor": -410231941.0,
        "delta": -9713799.0
      },
      {
        "periodo": 202510,
        "valor": -418354766.0,
        "delta": -8122825.0
      },
      {
        "periodo": 202511,
        "valor": -428241086.0,
        "delta": -9886320.0
      },
      {
        "periodo": 202512,
        "valor": -426587613.0,
        "delta": 1653473.0
      },
      {
        "periodo": 202601,
        "valor": -426229427.0,
        "delta": 358186.0
      },
      {
        "periodo": 202602,
        "valor": -425889671.0,
        "delta": 339756.0
      },
      {
        "periodo": 202603,
        "valor": -425526246.0,
        "delta": 363425.0
      },
      {
        "periodo": 202604,
        "valor": -425141720.0,
        "delta": 384526.0
      },
      {
        "periodo": 202605,
        "valor": -424827085.0,
        "delta": 314635.0
      },
      {
        "periodo": 202606,
        "valor": -424049217.0,
        "delta": 777868.0
      },
      {
        "periodo": 202607,
        "valor": -423778464.0,
        "delta": 270753.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 3777093627.34,
    "valor_anterior": 3670300991.76,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2721352347.06,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2775238537.61,
        "delta": 53886190.55
      },
      {
        "periodo": 202509,
        "valor": 2807837127.43,
        "delta": 32598589.82
      },
      {
        "periodo": 202510,
        "valor": 2957816255.06,
        "delta": 149979127.63
      },
      {
        "periodo": 202511,
        "valor": 3058332898.73,
        "delta": 100516643.67
      },
      {
        "periodo": 202512,
        "valor": 3173836144.84,
        "delta": 115503246.11
      },
      {
        "periodo": 202601,
        "valor": 3275622996.67,
        "delta": 101786851.83
      },
      {
        "periodo": 202602,
        "valor": 3350102126.29,
        "delta": 74479129.62
      },
      {
        "periodo": 202603,
        "valor": 3375972588.94,
        "delta": 25870462.65
      },
      {
        "periodo": 202604,
        "valor": 3486144615.11,
        "delta": 110172026.17
      },
      {
        "periodo": 202605,
        "valor": 3605974881.94,
        "delta": 119830266.83
      },
      {
        "periodo": 202606,
        "valor": 3670300991.76,
        "delta": 64326109.82
      },
      {
        "periodo": 202607,
        "valor": 3777093627.34,
        "delta": 106792635.58
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": -937727448.01,
    "valor_anterior": -972876385.08,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1103877379.14,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1094274459.19,
        "delta": 9602919.95
      },
      {
        "periodo": 202509,
        "valor": -1092073048.59,
        "delta": 2201410.6
      },
      {
        "periodo": 202510,
        "valor": -1079025083.77,
        "delta": 13047964.82
      },
      {
        "periodo": 202511,
        "valor": -1063376758.41,
        "delta": 15648325.36
      },
      {
        "periodo": 202512,
        "valor": -1071979030.94,
        "delta": -8602272.53
      },
      {
        "periodo": 202601,
        "valor": -1054488816.6,
        "delta": 17490214.34
      },
      {
        "periodo": 202602,
        "valor": -1034730681.96,
        "delta": 19758134.64
      },
      {
        "periodo": 202603,
        "valor": -1021197368.83,
        "delta": 13533313.13
      },
      {
        "periodo": 202604,
        "valor": -1011384189.88,
        "delta": 9813178.95
      },
      {
        "periodo": 202605,
        "valor": -992685749.03,
        "delta": 18698440.85
      },
      {
        "periodo": 202606,
        "valor": -972876385.08,
        "delta": 19809363.95
      },
      {
        "periodo": 202607,
        "valor": -937727448.01,
        "delta": 35148937.07
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": -40976950.0,
    "valor_anterior": -31638058.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -235797163.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -207761465.0,
        "delta": 28035698.0
      },
      {
        "periodo": 202509,
        "valor": -176254906.0,
        "delta": 31506559.0
      },
      {
        "periodo": 202510,
        "valor": -147074675.0,
        "delta": 29180231.0
      },
      {
        "periodo": 202511,
        "valor": -126207912.0,
        "delta": 20866763.0
      },
      {
        "periodo": 202512,
        "valor": -123730249.0,
        "delta": 2477663.0
      },
      {
        "periodo": 202601,
        "valor": -100006913.0,
        "delta": 23723336.0
      },
      {
        "periodo": 202602,
        "valor": -70822225.0,
        "delta": 29184688.0
      },
      {
        "periodo": 202603,
        "valor": -66226067.0,
        "delta": 4596158.0
      },
      {
        "periodo": 202604,
        "valor": -78871092.0,
        "delta": -12645025.0
      },
      {
        "periodo": 202605,
        "valor": -47990985.0,
        "delta": 30880107.0
      },
      {
        "periodo": 202606,
        "valor": -31638058.0,
        "delta": 16352927.0
      },
      {
        "periodo": 202607,
        "valor": -40976950.0,
        "delta": -9338892.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 2433318582.0,
    "valor_anterior": 2309952864.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1089463962.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1244103200.0,
        "delta": 154639238.0
      },
      {
        "periodo": 202509,
        "valor": 1352392143.0,
        "delta": 108288943.0
      },
      {
        "periodo": 202510,
        "valor": 1474295798.0,
        "delta": 121903655.0
      },
      {
        "periodo": 202511,
        "valor": 1570516932.0,
        "delta": 96221134.0
      },
      {
        "periodo": 202512,
        "valor": 1637965334.0,
        "delta": 67448402.0
      },
      {
        "periodo": 202601,
        "valor": 1728228491.0,
        "delta": 90263157.0
      },
      {
        "periodo": 202602,
        "valor": 1804904112.0,
        "delta": 76675621.0
      },
      {
        "periodo": 202603,
        "valor": 1913100937.0,
        "delta": 108196825.0
      },
      {
        "periodo": 202604,
        "valor": 2034519527.0,
        "delta": 121418590.0
      },
      {
        "periodo": 202605,
        "valor": 2170999984.0,
        "delta": 136480457.0
      },
      {
        "periodo": 202606,
        "valor": 2309952864.0,
        "delta": 138952880.0
      },
      {
        "periodo": 202607,
        "valor": 2433318582.0,
        "delta": 123365718.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 436475564.0,
    "valor_anterior": 418860110.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 309881932.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 326550990.0,
        "delta": 16669058.0
      },
      {
        "periodo": 202509,
        "valor": 334876683.0,
        "delta": 8325693.0
      },
      {
        "periodo": 202510,
        "valor": 346471297.0,
        "delta": 11594614.0
      },
      {
        "periodo": 202511,
        "valor": 357501222.0,
        "delta": 11029925.0
      },
      {
        "periodo": 202512,
        "valor": 360410928.0,
        "delta": 2909706.0
      },
      {
        "periodo": 202601,
        "valor": 369215264.0,
        "delta": 8804336.0
      },
      {
        "periodo": 202602,
        "valor": 378027828.0,
        "delta": 8812564.0
      },
      {
        "periodo": 202603,
        "valor": 391771448.0,
        "delta": 13743620.0
      },
      {
        "periodo": 202604,
        "valor": 401028869.0,
        "delta": 9257421.0
      },
      {
        "periodo": 202605,
        "valor": 413232018.0,
        "delta": 12203149.0
      },
      {
        "periodo": 202606,
        "valor": 418860110.0,
        "delta": 5628092.0
      },
      {
        "periodo": 202607,
        "valor": 436475564.0,
        "delta": 17615454.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 2050831621.37,
    "valor_anterior": 2034184886.61,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1927022781.45,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1952654099.1,
        "delta": 25631317.65
      },
      {
        "periodo": 202509,
        "valor": 2011923216.31,
        "delta": 59269117.21
      },
      {
        "periodo": 202510,
        "valor": 2044362381.63,
        "delta": 32439165.32
      },
      {
        "periodo": 202511,
        "valor": 2078017314.06,
        "delta": 33654932.43
      },
      {
        "periodo": 202512,
        "valor": 2093930387.01,
        "delta": 15913072.95
      },
      {
        "periodo": 202601,
        "valor": 2121766061.9,
        "delta": 27835674.89
      },
      {
        "periodo": 202602,
        "valor": 2155040706.28,
        "delta": 33274644.38
      },
      {
        "periodo": 202603,
        "valor": 2166832149.55,
        "delta": 11791443.27
      },
      {
        "periodo": 202604,
        "valor": 1997358775.89,
        "delta": -169473373.66
      },
      {
        "periodo": 202605,
        "valor": 2014622609.5,
        "delta": 17263833.61
      },
      {
        "periodo": 202606,
        "valor": 2034184886.61,
        "delta": 19562277.11
      },
      {
        "periodo": 202607,
        "valor": 2050831621.37,
        "delta": 16646734.76
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 242372538.09,
    "valor_anterior": 235482861.55,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 144087011.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 172409609.87,
        "delta": 28322598.62
      },
      {
        "periodo": 202509,
        "valor": 179730063.83,
        "delta": 7320453.96
      },
      {
        "periodo": 202510,
        "valor": 190013185.05,
        "delta": 10283121.22
      },
      {
        "periodo": 202511,
        "valor": 187978076.83,
        "delta": -2035108.22
      },
      {
        "periodo": 202512,
        "valor": 196771430.08,
        "delta": 8793353.25
      },
      {
        "periodo": 202601,
        "valor": 203651411.7,
        "delta": 6879981.62
      },
      {
        "periodo": 202602,
        "valor": 196665105.58,
        "delta": -6986306.12
      },
      {
        "periodo": 202603,
        "valor": 214512896.89,
        "delta": 17847791.31
      },
      {
        "periodo": 202604,
        "valor": 221862678.47,
        "delta": 7349781.58
      },
      {
        "periodo": 202605,
        "valor": 225478563.51,
        "delta": 3615885.04
      },
      {
        "periodo": 202606,
        "valor": 235482861.55,
        "delta": 10004298.04
      },
      {
        "periodo": 202607,
        "valor": 242372538.09,
        "delta": 6889676.54
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 1218654607.0,
    "valor_anterior": 1190762539.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 896176782.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 925373422.0,
        "delta": 29196640.0
      },
      {
        "periodo": 202509,
        "valor": 953682988.0,
        "delta": 28309566.0
      },
      {
        "periodo": 202510,
        "valor": 981196590.0,
        "delta": 27513602.0
      },
      {
        "periodo": 202511,
        "valor": 1011471163.0,
        "delta": 30274573.0
      },
      {
        "periodo": 202512,
        "valor": 1027557433.0,
        "delta": 16086270.0
      },
      {
        "periodo": 202601,
        "valor": 1054011364.0,
        "delta": 26453931.0
      },
      {
        "periodo": 202602,
        "valor": 1078686453.0,
        "delta": 24675089.0
      },
      {
        "periodo": 202603,
        "valor": 1105987793.0,
        "delta": 27301340.0
      },
      {
        "periodo": 202604,
        "valor": 1132821174.0,
        "delta": 26833381.0
      },
      {
        "periodo": 202605,
        "valor": 1157556800.0,
        "delta": 24735626.0
      },
      {
        "periodo": 202606,
        "valor": 1190762539.0,
        "delta": 33205739.0
      },
      {
        "periodo": 202607,
        "valor": 1218654607.0,
        "delta": 27892068.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 126874210.0,
    "valor_anterior": 124384356.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 85363901.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 89471403.0,
        "delta": 4107502.0
      },
      {
        "periodo": 202509,
        "valor": 93686259.0,
        "delta": 4214856.0
      },
      {
        "periodo": 202510,
        "valor": 99461806.0,
        "delta": 5775547.0
      },
      {
        "periodo": 202511,
        "valor": 99129593.0,
        "delta": -332213.0
      },
      {
        "periodo": 202512,
        "valor": 101144745.0,
        "delta": 2015152.0
      },
      {
        "periodo": 202601,
        "valor": 103068568.0,
        "delta": 1923823.0
      },
      {
        "periodo": 202602,
        "valor": 106130437.0,
        "delta": 3061869.0
      },
      {
        "periodo": 202603,
        "valor": 112738530.0,
        "delta": 6608093.0
      },
      {
        "periodo": 202604,
        "valor": 114028264.0,
        "delta": 1289734.0
      },
      {
        "periodo": 202605,
        "valor": 120076193.0,
        "delta": 6047929.0
      },
      {
        "periodo": 202606,
        "valor": 124384356.0,
        "delta": 4308163.0
      },
      {
        "periodo": 202607,
        "valor": 126874210.0,
        "delta": 2489854.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 1196627097.0,
    "valor_anterior": 1242575710.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 996097554.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1038513200.0,
        "delta": 42415646.0
      },
      {
        "periodo": 202509,
        "valor": 1132344529.0,
        "delta": 93831329.0
      },
      {
        "periodo": 202510,
        "valor": 1151366746.0,
        "delta": 19022217.0
      },
      {
        "periodo": 202511,
        "valor": 1138966823.0,
        "delta": -12399923.0
      },
      {
        "periodo": 202512,
        "valor": 1134033373.0,
        "delta": -4933450.0
      },
      {
        "periodo": 202601,
        "valor": 1146635832.0,
        "delta": 12602459.0
      },
      {
        "periodo": 202602,
        "valor": 1181823215.0,
        "delta": 35187383.0
      },
      {
        "periodo": 202603,
        "valor": 1183784387.0,
        "delta": 1961172.0
      },
      {
        "periodo": 202604,
        "valor": 1170778190.0,
        "delta": -13006197.0
      },
      {
        "periodo": 202605,
        "valor": 1209664648.0,
        "delta": 38886458.0
      },
      {
        "periodo": 202606,
        "valor": 1242575710.0,
        "delta": 32911062.0
      },
      {
        "periodo": 202607,
        "valor": 1196627097.0,
        "delta": -45948613.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": -2258146098.99,
    "valor_anterior": -2199198702.96,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1509321289.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1587031223.91,
        "delta": -77709934.19
      },
      {
        "periodo": 202509,
        "valor": -1644765171.67,
        "delta": -57733947.76
      },
      {
        "periodo": 202510,
        "valor": -1703721810.53,
        "delta": -58956638.86
      },
      {
        "periodo": 202511,
        "valor": -1762886676.05,
        "delta": -59164865.52
      },
      {
        "periodo": 202512,
        "valor": -1816850968.03,
        "delta": -53964291.98
      },
      {
        "periodo": 202601,
        "valor": -1884447857.64,
        "delta": -67596889.61
      },
      {
        "periodo": 202602,
        "valor": -1946959118.9,
        "delta": -62511261.26
      },
      {
        "periodo": 202603,
        "valor": -2001075113.25,
        "delta": -54115994.35
      },
      {
        "periodo": 202604,
        "valor": -2068211920.03,
        "delta": -67136806.78
      },
      {
        "periodo": 202605,
        "valor": -2144140045.32,
        "delta": -75928125.29
      },
      {
        "periodo": 202606,
        "valor": -2199198702.96,
        "delta": -55058657.64
      },
      {
        "periodo": 202607,
        "valor": -2258146098.99,
        "delta": -58947396.03
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 545835269.0,
    "valor_anterior": 534810601.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 94827508.12,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 98104410.66,
        "delta": 3276902.54
      },
      {
        "periodo": 202509,
        "valor": 101250249.1,
        "delta": 3145838.44
      },
      {
        "periodo": 202510,
        "valor": 102975156.84,
        "delta": 1724907.74
      },
      {
        "periodo": 202511,
        "valor": 106219592.51,
        "delta": 3244435.67
      },
      {
        "periodo": 202512,
        "valor": 108420298.58,
        "delta": 2200706.07
      },
      {
        "periodo": 202601,
        "valor": 112515245.03,
        "delta": 4094946.45
      },
      {
        "periodo": 202602,
        "valor": 431290975.77,
        "delta": 318775730.74
      },
      {
        "periodo": 202603,
        "valor": 464407956.31,
        "delta": 33116980.54
      },
      {
        "periodo": 202604,
        "valor": 472542091.29,
        "delta": 8134134.98
      },
      {
        "periodo": 202605,
        "valor": 491518160.29,
        "delta": 18976069.0
      },
      {
        "periodo": 202606,
        "valor": 534810601.0,
        "delta": 43292440.71
      },
      {
        "periodo": 202607,
        "valor": 545835269.0,
        "delta": 11024668.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": -3366178000.0,
    "valor_anterior": -3144584164.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1162992348.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1287330228.0,
        "delta": -124337880.0
      },
      {
        "periodo": 202509,
        "valor": -1424330197.0,
        "delta": -136999969.0
      },
      {
        "periodo": 202510,
        "valor": -1602548663.0,
        "delta": -178218466.0
      },
      {
        "periodo": 202511,
        "valor": -1787155384.0,
        "delta": -184606721.0
      },
      {
        "periodo": 202512,
        "valor": -1965082262.0,
        "delta": -177926878.0
      },
      {
        "periodo": 202601,
        "valor": -2142037577.0,
        "delta": -176955315.0
      },
      {
        "periodo": 202602,
        "valor": -2307380193.0,
        "delta": -165342616.0
      },
      {
        "periodo": 202603,
        "valor": -2580192144.0,
        "delta": -272811951.0
      },
      {
        "periodo": 202604,
        "valor": -2755062918.0,
        "delta": -174870774.0
      },
      {
        "periodo": 202605,
        "valor": -2958621294.0,
        "delta": -203558376.0
      },
      {
        "periodo": 202606,
        "valor": -3144584164.0,
        "delta": -185962870.0
      },
      {
        "periodo": 202607,
        "valor": -3366178000.0,
        "delta": -221593836.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": -830329999.61,
    "valor_anterior": -749303051.86,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": -388538051.91,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": -413022299.38,
        "delta": -24484247.47
      },
      {
        "periodo": 202601,
        "valor": -437572131.21,
        "delta": -24549831.83
      },
      {
        "periodo": 202602,
        "valor": -483035218.1,
        "delta": -45463086.89
      },
      {
        "periodo": 202603,
        "valor": -540116258.75,
        "delta": -57081040.65
      },
      {
        "periodo": 202604,
        "valor": -602879728.18,
        "delta": -62763469.43
      },
      {
        "periodo": 202605,
        "valor": -670257066.35,
        "delta": -67377338.17
      },
      {
        "periodo": 202606,
        "valor": -749303051.86,
        "delta": -79045985.51
      },
      {
        "periodo": 202607,
        "valor": -830329999.61,
        "delta": -81026947.75
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": -6671695008.0,
    "valor_anterior": -6449094519.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": -5605001475.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": -5740478802.0,
        "delta": -135477327.0
      },
      {
        "periodo": 202605,
        "valor": -5973334829.0,
        "delta": -232856027.0
      },
      {
        "periodo": 202606,
        "valor": -6449094519.0,
        "delta": -475759690.0
      },
      {
        "periodo": 202607,
        "valor": -6671695008.0,
        "delta": -222600489.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 1461300942017.3,
    "valor_anterior": 1445915137223.03,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1365907705333.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1394141197402.03,
        "delta": 28233492068.29
      },
      {
        "periodo": 202509,
        "valor": 1399398606696.7,
        "delta": 5257409294.6699
      },
      {
        "periodo": 202510,
        "valor": 1424037360018.89,
        "delta": 24638753322.1899
      },
      {
        "periodo": 202511,
        "valor": 1408149652476.01,
        "delta": -15887707542.8799
      },
      {
        "periodo": 202512,
        "valor": 1395708261891.28,
        "delta": -12441390584.73
      },
      {
        "periodo": 202601,
        "valor": 1424729267078.73,
        "delta": 29021005187.45
      },
      {
        "periodo": 202602,
        "valor": 1448389829962.65,
        "delta": 23660562883.9199
      },
      {
        "periodo": 202603,
        "valor": 1442627600552.73,
        "delta": -5762229409.9199
      },
      {
        "periodo": 202604,
        "valor": 1435923175467.08,
        "delta": -6704425085.6499
      },
      {
        "periodo": 202605,
        "valor": 1458430728335.24,
        "delta": 22507552868.1599
      },
      {
        "periodo": 202606,
        "valor": 1445915137223.03,
        "delta": -12515591112.21
      },
      {
        "periodo": 202607,
        "valor": 1461300942017.3,
        "delta": 15385804794.27
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 1128168176259.98,
    "valor_anterior": 1114427693607.61,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1055736786071.78,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1078198115772.22,
        "delta": 22461329700.4399
      },
      {
        "periodo": 202509,
        "valor": 1080920575388.6,
        "delta": 2722459616.38
      },
      {
        "periodo": 202510,
        "valor": 1099312395129.9,
        "delta": 18391819741.3
      },
      {
        "periodo": 202511,
        "valor": 1089815762151.2499,
        "delta": -9496632978.6501
      },
      {
        "periodo": 202512,
        "valor": 1072125198651.08,
        "delta": -17690563500.1699
      },
      {
        "periodo": 202601,
        "valor": 1096274011223.17,
        "delta": 24148812572.0901
      },
      {
        "periodo": 202602,
        "valor": 1114353056646.78,
        "delta": 18079045423.61
      },
      {
        "periodo": 202603,
        "valor": 1113710175683.07,
        "delta": -642880963.71
      },
      {
        "periodo": 202604,
        "valor": 1111417768821.8,
        "delta": -2292406861.27
      },
      {
        "periodo": 202605,
        "valor": 1130196165440.73,
        "delta": 18778396618.9299
      },
      {
        "periodo": 202606,
        "valor": 1114427693607.61,
        "delta": -15768471833.1199
      },
      {
        "periodo": 202607,
        "valor": 1128168176259.98,
        "delta": 13740482652.3699
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 22193338514.65,
    "valor_anterior": 22945128803.76,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 31286407098.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 30736995246.05,
        "delta": -549411852.21
      },
      {
        "periodo": 202509,
        "valor": 27279201128.48,
        "delta": -3457794117.57
      },
      {
        "periodo": 202510,
        "valor": 27778650148.68,
        "delta": 499449020.2
      },
      {
        "periodo": 202511,
        "valor": 22278538172.11,
        "delta": -5500111976.57
      },
      {
        "periodo": 202512,
        "valor": 22901131109.94,
        "delta": 622592937.83
      },
      {
        "periodo": 202601,
        "valor": 23441503335.98,
        "delta": 540372226.04
      },
      {
        "periodo": 202602,
        "valor": 23890904311.09,
        "delta": 449400975.11
      },
      {
        "periodo": 202603,
        "valor": 23928203415.11,
        "delta": 37299104.02
      },
      {
        "periodo": 202604,
        "valor": 22461406809.97,
        "delta": -1466796605.14
      },
      {
        "periodo": 202605,
        "valor": 22912498840.96,
        "delta": 451092030.99
      },
      {
        "periodo": 202606,
        "valor": 22945128803.76,
        "delta": 32629962.8
      },
      {
        "periodo": 202607,
        "valor": 22193338514.65,
        "delta": -751790289.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 143247525950.99,
    "valor_anterior": 141974675656.78,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 124561796558.54,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 127113317190.5,
        "delta": 2551520631.96
      },
      {
        "periodo": 202509,
        "valor": 129169213400.58,
        "delta": 2055896210.08
      },
      {
        "periodo": 202510,
        "valor": 131061103875.62,
        "delta": 1891890475.04
      },
      {
        "periodo": 202511,
        "valor": 131114780062.63,
        "delta": 53676187.01
      },
      {
        "periodo": 202512,
        "valor": 132731887721.28,
        "delta": 1617107658.65
      },
      {
        "periodo": 202601,
        "valor": 134669956293.75,
        "delta": 1938068572.47
      },
      {
        "periodo": 202602,
        "valor": 136372316940.76,
        "delta": 1702360647.01
      },
      {
        "periodo": 202603,
        "valor": 136766703876.71,
        "delta": 394386935.95
      },
      {
        "periodo": 202604,
        "valor": 138952174148.14,
        "delta": 2185470271.43
      },
      {
        "periodo": 202605,
        "valor": 140829278037.62,
        "delta": 1877103889.48
      },
      {
        "periodo": 202606,
        "valor": 141974675656.78,
        "delta": 1145397619.16
      },
      {
        "periodo": 202607,
        "valor": 143247525950.99,
        "delta": 1272850294.21
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 97773513861.91,
    "valor_anterior": 95992096005.78,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 84989861753.97,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 86927278636.91,
        "delta": 1937416882.94
      },
      {
        "periodo": 202509,
        "valor": 88900024975.19,
        "delta": 1972746338.28
      },
      {
        "periodo": 202510,
        "valor": 90866179043.35,
        "delta": 1966154068.16
      },
      {
        "periodo": 202511,
        "valor": 90577815291.06,
        "delta": -288363752.29
      },
      {
        "periodo": 202512,
        "valor": 92025090947.86,
        "delta": 1447275656.8
      },
      {
        "periodo": 202601,
        "valor": 94203539605.31,
        "delta": 2178448657.45
      },
      {
        "periodo": 202602,
        "valor": 95413416871.4,
        "delta": 1209877266.09
      },
      {
        "periodo": 202603,
        "valor": 95165638841.74,
        "delta": -247778029.66
      },
      {
        "periodo": 202604,
        "valor": 92655390354.37,
        "delta": -2510248487.37
      },
      {
        "periodo": 202605,
        "valor": 94060394319.93,
        "delta": 1405003965.56
      },
      {
        "periodo": 202606,
        "valor": 95992096005.78,
        "delta": 1931701685.85
      },
      {
        "periodo": 202607,
        "valor": 97773513861.91,
        "delta": 1781417856.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 9576548150.17,
    "valor_anterior": 9935477137.19,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5112385537.56,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5426086983.86,
        "delta": 313701446.3
      },
      {
        "periodo": 202509,
        "valor": 7343354737.16,
        "delta": 1917267753.3
      },
      {
        "periodo": 202510,
        "valor": 7726112598.52,
        "delta": 382757861.36
      },
      {
        "periodo": 202511,
        "valor": 7800615025.62,
        "delta": 74502427.1
      },
      {
        "periodo": 202512,
        "valor": 8291639237.26,
        "delta": 491024211.64
      },
      {
        "periodo": 202601,
        "valor": 8655520533.36,
        "delta": 363881296.1
      },
      {
        "periodo": 202602,
        "valor": 8949448424.91,
        "delta": 293927891.55
      },
      {
        "periodo": 202603,
        "valor": 9232146201.24,
        "delta": 282697776.33
      },
      {
        "periodo": 202604,
        "valor": 9239926951.03,
        "delta": 7780749.79
      },
      {
        "periodo": 202605,
        "valor": 9511106110.49,
        "delta": 271179159.46
      },
      {
        "periodo": 202606,
        "valor": 9935477137.19,
        "delta": 424371026.7
      },
      {
        "periodo": 202607,
        "valor": 9576548150.17,
        "delta": -358928987.02
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100099,
    "label": "Capital Ganado",
    "valor_actual": 60341839279.6,
    "valor_anterior": 60640066011.91,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 64220468313.63,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 65739403572.49,
        "delta": 1518935258.86
      },
      {
        "periodo": 202509,
        "valor": 65786237066.69,
        "delta": 46833494.2
      },
      {
        "periodo": 202510,
        "valor": 67292919222.82,
        "delta": 1506682156.13
      },
      {
        "periodo": 202511,
        "valor": 66562141773.34,
        "delta": -730777449.48
      },
      {
        "periodo": 202512,
        "valor": 67633314223.86,
        "delta": 1071172450.52
      },
      {
        "periodo": 202601,
        "valor": 67484736087.16,
        "delta": -148578136.7
      },
      {
        "periodo": 202602,
        "valor": 69410686767.71,
        "delta": 1925950680.55
      },
      {
        "periodo": 202603,
        "valor": 63824732534.86,
        "delta": -5585954232.85
      },
      {
        "periodo": 202604,
        "valor": 61196508381.77,
        "delta": -2628224153.09
      },
      {
        "periodo": 202605,
        "valor": 60921285585.51,
        "delta": -275222796.26
      },
      {
        "periodo": 202606,
        "valor": 60640066011.91,
        "delta": -281219573.6
      },
      {
        "periodo": 202607,
        "valor": 60341839279.6,
        "delta": -298226732.31
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 90388611.07,
    "valor_anterior": 76062596.65000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 83168500.13,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 66156564.0,
        "delta": -17011936.13
      },
      {
        "periodo": 202509,
        "valor": 63510403.38,
        "delta": -2646160.62
      },
      {
        "periodo": 202510,
        "valor": 74378382.93,
        "delta": 10867979.55
      },
      {
        "periodo": 202511,
        "valor": 70391836.35,
        "delta": -3986546.58
      },
      {
        "periodo": 202512,
        "valor": 80008651.83,
        "delta": 9616815.48
      },
      {
        "periodo": 202601,
        "valor": 74118184.7,
        "delta": -5890467.13
      },
      {
        "periodo": 202602,
        "valor": 67175267.04,
        "delta": -6942917.66
      },
      {
        "periodo": 202603,
        "valor": 60541819.36,
        "delta": -6633447.68
      },
      {
        "periodo": 202604,
        "valor": 73014263.21,
        "delta": 12472443.85
      },
      {
        "periodo": 202605,
        "valor": 58442920.59,
        "delta": -14571342.62
      },
      {
        "periodo": 202606,
        "valor": 76062596.65,
        "delta": 17619676.06
      },
      {
        "periodo": 202607,
        "valor": 90388611.07,
        "delta": 14326014.42
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 287784420.98,
    "valor_anterior": 311135033.99,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 278210746.44,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 212786539.92,
        "delta": -65424206.52
      },
      {
        "periodo": 202509,
        "valor": 229531207.22,
        "delta": 16744667.3
      },
      {
        "periodo": 202510,
        "valor": 301522605.3,
        "delta": 71991398.08
      },
      {
        "periodo": 202511,
        "valor": 269990763.23,
        "delta": -31531842.07
      },
      {
        "periodo": 202512,
        "valor": 264130641.34,
        "delta": -5860121.89
      },
      {
        "periodo": 202601,
        "valor": 197802207.3,
        "delta": -66328434.04
      },
      {
        "periodo": 202602,
        "valor": 272336337.38,
        "delta": 74534130.08
      },
      {
        "periodo": 202603,
        "valor": 314868611.54,
        "delta": 42532274.16
      },
      {
        "periodo": 202604,
        "valor": 284193772.12,
        "delta": -30674839.42
      },
      {
        "periodo": 202605,
        "valor": 283693882.16,
        "delta": -499889.96
      },
      {
        "periodo": 202606,
        "valor": 311135033.99,
        "delta": 27441151.83
      },
      {
        "periodo": 202607,
        "valor": 287784420.98,
        "delta": -23350613.01
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 55407501.0,
    "valor_anterior": 63137522.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 57984891.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 52759546.0,
        "delta": -5225345.0
      },
      {
        "periodo": 202509,
        "valor": 49959529.0,
        "delta": -2800017.0
      },
      {
        "periodo": 202510,
        "valor": 52662976.0,
        "delta": 2703447.0
      },
      {
        "periodo": 202511,
        "valor": 51372849.0,
        "delta": -1290127.0
      },
      {
        "periodo": 202512,
        "valor": 48842320.0,
        "delta": -2530529.0
      },
      {
        "periodo": 202601,
        "valor": 51906878.0,
        "delta": 3064558.0
      },
      {
        "periodo": 202602,
        "valor": 56614705.0,
        "delta": 4707827.0
      },
      {
        "periodo": 202603,
        "valor": 53464106.0,
        "delta": -3150599.0
      },
      {
        "periodo": 202604,
        "valor": 47784518.0,
        "delta": -5679588.0
      },
      {
        "periodo": 202605,
        "valor": 55548818.0,
        "delta": 7764300.0
      },
      {
        "periodo": 202606,
        "valor": 63137522.0,
        "delta": 7588704.0
      },
      {
        "periodo": 202607,
        "valor": 55407501.0,
        "delta": -7730021.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 90338588.0,
    "valor_anterior": 99508736.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 103044851.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 103425258.0,
        "delta": 380407.0
      },
      {
        "periodo": 202509,
        "valor": 99693130.0,
        "delta": -3732128.0
      },
      {
        "periodo": 202510,
        "valor": 105052887.0,
        "delta": 5359757.0
      },
      {
        "periodo": 202511,
        "valor": 113230572.0,
        "delta": 8177685.0
      },
      {
        "periodo": 202512,
        "valor": 96967226.0,
        "delta": -16263346.0
      },
      {
        "periodo": 202601,
        "valor": 98135297.0,
        "delta": 1168071.0
      },
      {
        "periodo": 202602,
        "valor": 100775172.0,
        "delta": 2639875.0
      },
      {
        "periodo": 202603,
        "valor": 98247986.0,
        "delta": -2527186.0
      },
      {
        "periodo": 202604,
        "valor": 100846475.0,
        "delta": 2598489.0
      },
      {
        "periodo": 202605,
        "valor": 109943901.0,
        "delta": 9097426.0
      },
      {
        "periodo": 202606,
        "valor": 99508736.0,
        "delta": -10435165.0
      },
      {
        "periodo": 202607,
        "valor": 90338588.0,
        "delta": -9170148.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 107940192.12,
    "valor_anterior": 98798561.70000005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 88536326.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 84375542.6,
        "delta": -4160783.9
      },
      {
        "periodo": 202509,
        "valor": 79995780.15,
        "delta": -4379762.45
      },
      {
        "periodo": 202510,
        "valor": 90241713.65,
        "delta": 10245933.5
      },
      {
        "periodo": 202511,
        "valor": 95376737.0,
        "delta": 5135023.35
      },
      {
        "periodo": 202512,
        "valor": 101479988.52,
        "delta": 6103251.52
      },
      {
        "periodo": 202601,
        "valor": 98522935.07,
        "delta": -2957053.45
      },
      {
        "periodo": 202602,
        "valor": 90844904.07,
        "delta": -7678031.0
      },
      {
        "periodo": 202603,
        "valor": 105492880.3,
        "delta": 14647976.23
      },
      {
        "periodo": 202604,
        "valor": 100755027.68,
        "delta": -4737852.62
      },
      {
        "periodo": 202605,
        "valor": 111609865.26,
        "delta": 10854837.58
      },
      {
        "periodo": 202606,
        "valor": 98798561.7,
        "delta": -12811303.56
      },
      {
        "periodo": 202607,
        "valor": 107940192.12,
        "delta": 9141630.42
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 87515279.0,
    "valor_anterior": 99050651.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 43594590.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 51671156.0,
        "delta": 8076566.0
      },
      {
        "periodo": 202509,
        "valor": 48679039.0,
        "delta": -2992117.0
      },
      {
        "periodo": 202510,
        "valor": 46944664.0,
        "delta": -1734375.0
      },
      {
        "periodo": 202511,
        "valor": 62143879.0,
        "delta": 15199215.0
      },
      {
        "periodo": 202512,
        "valor": 599500833.0,
        "delta": 537356954.0
      },
      {
        "periodo": 202601,
        "valor": 45726100.0,
        "delta": -553774733.0
      },
      {
        "periodo": 202602,
        "valor": 117259655.0,
        "delta": 71533555.0
      },
      {
        "periodo": 202603,
        "valor": 82240717.0,
        "delta": -35018938.0
      },
      {
        "periodo": 202604,
        "valor": 78763940.0,
        "delta": -3476777.0
      },
      {
        "periodo": 202605,
        "valor": 215563011.0,
        "delta": 136799071.0
      },
      {
        "periodo": 202606,
        "valor": 99050651.0,
        "delta": -116512360.0
      },
      {
        "periodo": 202607,
        "valor": 87515279.0,
        "delta": -11535372.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 3816548.0,
    "valor_anterior": 2253531.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3959001.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2711214.0,
        "delta": -1247787.0
      },
      {
        "periodo": 202509,
        "valor": 2509150.0,
        "delta": -202064.0
      },
      {
        "periodo": 202510,
        "valor": 2124532.0,
        "delta": -384618.0
      },
      {
        "periodo": 202511,
        "valor": 4724234.0,
        "delta": 2599702.0
      },
      {
        "periodo": 202512,
        "valor": 7307823.0,
        "delta": 2583589.0
      },
      {
        "periodo": 202601,
        "valor": 2421928.0,
        "delta": -4885895.0
      },
      {
        "periodo": 202602,
        "valor": 2598551.0,
        "delta": 176623.0
      },
      {
        "periodo": 202603,
        "valor": 3088103.0,
        "delta": 489552.0
      },
      {
        "periodo": 202604,
        "valor": 1653855.0,
        "delta": -1434248.0
      },
      {
        "periodo": 202605,
        "valor": 2317946.0,
        "delta": 664091.0
      },
      {
        "periodo": 202606,
        "valor": 2253531.0,
        "delta": -64415.0
      },
      {
        "periodo": 202607,
        "valor": 3816548.0,
        "delta": 1563017.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 44684161.0,
    "valor_anterior": 48386142.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 47553849.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 52183780.0,
        "delta": 4629931.0
      },
      {
        "periodo": 202509,
        "valor": 40385126.0,
        "delta": -11798654.0
      },
      {
        "periodo": 202510,
        "valor": 41412237.0,
        "delta": 1027111.0
      },
      {
        "periodo": 202511,
        "valor": 41916867.0,
        "delta": 504630.0
      },
      {
        "periodo": 202512,
        "valor": 48595337.0,
        "delta": 6678470.0
      },
      {
        "periodo": 202601,
        "valor": 42485260.0,
        "delta": -6110077.0
      },
      {
        "periodo": 202602,
        "valor": 46301162.0,
        "delta": 3815902.0
      },
      {
        "periodo": 202603,
        "valor": 42162426.0,
        "delta": -4138736.0
      },
      {
        "periodo": 202604,
        "valor": 42534083.0,
        "delta": 371657.0
      },
      {
        "periodo": 202605,
        "valor": 46038148.0,
        "delta": 3504065.0
      },
      {
        "periodo": 202606,
        "valor": 48386142.0,
        "delta": 2347994.0
      },
      {
        "periodo": 202607,
        "valor": 44684161.0,
        "delta": -3701981.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 65909902.40999997,
    "valor_anterior": 69612580.55000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 70463921.96,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 72479229.8,
        "delta": 2015307.84
      },
      {
        "periodo": 202509,
        "valor": 79897902.74,
        "delta": 7418672.94
      },
      {
        "periodo": 202510,
        "valor": 75818625.15,
        "delta": -4079277.59
      },
      {
        "periodo": 202511,
        "valor": 69886060.2,
        "delta": -5932564.95
      },
      {
        "periodo": 202512,
        "valor": 93153240.38,
        "delta": 23267180.18
      },
      {
        "periodo": 202601,
        "valor": 70502798.92,
        "delta": -22650441.46
      },
      {
        "periodo": 202602,
        "valor": 64479680.17,
        "delta": -6023118.75
      },
      {
        "periodo": 202603,
        "valor": 69784430.05,
        "delta": 5304749.88
      },
      {
        "periodo": 202604,
        "valor": 65778112.58,
        "delta": -4006317.47
      },
      {
        "periodo": 202605,
        "valor": 66038738.89,
        "delta": 260626.31
      },
      {
        "periodo": 202606,
        "valor": 69612580.55,
        "delta": 3573841.66
      },
      {
        "periodo": 202607,
        "valor": 65909902.41,
        "delta": -3702678.14
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 4005486.0,
    "valor_anterior": 6071633.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5709554.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3102063.0,
        "delta": -2607491.0
      },
      {
        "periodo": 202509,
        "valor": 9284295.0,
        "delta": 6182232.0
      },
      {
        "periodo": 202510,
        "valor": 11713779.0,
        "delta": 2429484.0
      },
      {
        "periodo": 202511,
        "valor": 3345477.0,
        "delta": -8368302.0
      },
      {
        "periodo": 202512,
        "valor": 5992661.0,
        "delta": 2647184.0
      },
      {
        "periodo": 202601,
        "valor": 10024624.0,
        "delta": 4031963.0
      },
      {
        "periodo": 202602,
        "valor": 5261448.0,
        "delta": -4763176.0
      },
      {
        "periodo": 202603,
        "valor": 10353073.0,
        "delta": 5091625.0
      },
      {
        "periodo": 202604,
        "valor": 2686033.0,
        "delta": -7667040.0
      },
      {
        "periodo": 202605,
        "valor": 5807240.0,
        "delta": 3121207.0
      },
      {
        "periodo": 202606,
        "valor": 6071633.0,
        "delta": 264393.0
      },
      {
        "periodo": 202607,
        "valor": 4005486.0,
        "delta": -2066147.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 20450312.0,
    "valor_anterior": 20697072.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15904862.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9823282.0,
        "delta": -6081580.0
      },
      {
        "periodo": 202509,
        "valor": 18822408.0,
        "delta": 8999126.0
      },
      {
        "periodo": 202510,
        "valor": 13409619.0,
        "delta": -5412789.0
      },
      {
        "periodo": 202511,
        "valor": 11640419.0,
        "delta": -1769200.0
      },
      {
        "periodo": 202512,
        "valor": 23218635.0,
        "delta": 11578216.0
      },
      {
        "periodo": 202601,
        "valor": 14103263.0,
        "delta": -9115372.0
      },
      {
        "periodo": 202602,
        "valor": 14330161.0,
        "delta": 226898.0
      },
      {
        "periodo": 202603,
        "valor": 22488470.0,
        "delta": 8158309.0
      },
      {
        "periodo": 202604,
        "valor": 18193056.0,
        "delta": -4295414.0
      },
      {
        "periodo": 202605,
        "valor": 12053032.0,
        "delta": -6140024.0
      },
      {
        "periodo": 202606,
        "valor": 20697072.0,
        "delta": 8644040.0
      },
      {
        "periodo": 202607,
        "valor": 20450312.0,
        "delta": -246760.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 14951018.0,
    "valor_anterior": 16552959.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16750755.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19162082.0,
        "delta": 2411327.0
      },
      {
        "periodo": 202509,
        "valor": 16624238.0,
        "delta": -2537844.0
      },
      {
        "periodo": 202510,
        "valor": 15178317.0,
        "delta": -1445921.0
      },
      {
        "periodo": 202511,
        "valor": 14912136.0,
        "delta": -266181.0
      },
      {
        "periodo": 202512,
        "valor": 14309261.0,
        "delta": -602875.0
      },
      {
        "periodo": 202601,
        "valor": 14650805.0,
        "delta": 341544.0
      },
      {
        "periodo": 202602,
        "valor": 15353694.0,
        "delta": 702889.0
      },
      {
        "periodo": 202603,
        "valor": 15577670.0,
        "delta": 223976.0
      },
      {
        "periodo": 202604,
        "valor": 15915619.0,
        "delta": 337949.0
      },
      {
        "periodo": 202605,
        "valor": 13721780.0,
        "delta": -2193839.0
      },
      {
        "periodo": 202606,
        "valor": 16552959.0,
        "delta": 2831179.0
      },
      {
        "periodo": 202607,
        "valor": 14951018.0,
        "delta": -1601941.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 173859625.01999998,
    "valor_anterior": 175137155.1600001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 168394714.98,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 158923051.17,
        "delta": -9471663.81
      },
      {
        "periodo": 202509,
        "valor": 173527107.08,
        "delta": 14604055.91
      },
      {
        "periodo": 202510,
        "valor": 168837422.65,
        "delta": -4689684.43
      },
      {
        "periodo": 202511,
        "valor": 159387932.2,
        "delta": -9449490.45
      },
      {
        "periodo": 202512,
        "valor": 178739694.92,
        "delta": 19351762.72
      },
      {
        "periodo": 202601,
        "valor": 160904434.71,
        "delta": -17835260.21
      },
      {
        "periodo": 202602,
        "valor": 161533519.66,
        "delta": 629084.95
      },
      {
        "periodo": 202603,
        "valor": 173429030.89,
        "delta": 11895511.23
      },
      {
        "periodo": 202604,
        "valor": 337521468.51,
        "delta": 164092437.62
      },
      {
        "periodo": 202605,
        "valor": 161846582.79,
        "delta": -175674885.72
      },
      {
        "periodo": 202606,
        "valor": 175137155.16,
        "delta": 13290572.37
      },
      {
        "periodo": 202607,
        "valor": 173859625.02,
        "delta": -1277530.14
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 5471165.0,
    "valor_anterior": 950256.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 936859.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 886979.0,
        "delta": -49880.0
      },
      {
        "periodo": 202509,
        "valor": 853815.0,
        "delta": -33164.0
      },
      {
        "periodo": 202510,
        "valor": 919060.0,
        "delta": 65245.0
      },
      {
        "periodo": 202511,
        "valor": 1745059.0,
        "delta": 825999.0
      },
      {
        "periodo": 202512,
        "valor": 918943.0,
        "delta": -826116.0
      },
      {
        "periodo": 202601,
        "valor": 910755.0,
        "delta": -8188.0
      },
      {
        "periodo": 202602,
        "valor": 831009.0,
        "delta": -79746.0
      },
      {
        "periodo": 202603,
        "valor": 935953.0,
        "delta": 104944.0
      },
      {
        "periodo": 202604,
        "valor": 898250.0,
        "delta": -37703.0
      },
      {
        "periodo": 202605,
        "valor": 937523.0,
        "delta": 39273.0
      },
      {
        "periodo": 202606,
        "valor": 950256.0,
        "delta": 12733.0
      },
      {
        "periodo": 202607,
        "valor": 5471165.0,
        "delta": 4520909.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 150038.0,
    "valor_anterior": 161699.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 174268.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 174268.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 174268.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 174269.0,
        "delta": 1.0
      },
      {
        "periodo": 202511,
        "valor": 174268.0,
        "delta": -1.0
      },
      {
        "periodo": 202512,
        "valor": 174268.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 161700.0,
        "delta": -12568.0
      },
      {
        "periodo": 202602,
        "valor": 161700.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 161700.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 161700.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 161700.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 161699.0,
        "delta": -1.0
      },
      {
        "periodo": 202607,
        "valor": 150038.0,
        "delta": -11661.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 3187355.6999999993,
    "valor_anterior": 6069343.559999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4342922.51,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3184999.19,
        "delta": -1157923.32
      },
      {
        "periodo": 202509,
        "valor": 7921463.07,
        "delta": 4736463.88
      },
      {
        "periodo": 202510,
        "valor": 3310402.66,
        "delta": -4611060.41
      },
      {
        "periodo": 202511,
        "valor": 4078449.06,
        "delta": 768046.4
      },
      {
        "periodo": 202512,
        "valor": 3973759.78,
        "delta": -104689.28
      },
      {
        "periodo": 202601,
        "valor": 5406307.63,
        "delta": 1432547.85
      },
      {
        "periodo": 202602,
        "valor": 3373460.14,
        "delta": -2032847.49
      },
      {
        "periodo": 202603,
        "valor": 3863888.41,
        "delta": 490428.27
      },
      {
        "periodo": 202604,
        "valor": 4261310.51,
        "delta": 397422.1
      },
      {
        "periodo": 202605,
        "valor": 3647131.02,
        "delta": -614179.49
      },
      {
        "periodo": 202606,
        "valor": 6069343.56,
        "delta": 2422212.54
      },
      {
        "periodo": 202607,
        "valor": 3187355.7,
        "delta": -2881987.86
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 20833298.0,
    "valor_anterior": 36217963.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20934248.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 31404809.0,
        "delta": 10470561.0
      },
      {
        "periodo": 202509,
        "valor": 19145851.0,
        "delta": -12258958.0
      },
      {
        "periodo": 202510,
        "valor": 25396401.0,
        "delta": 6250550.0
      },
      {
        "periodo": 202511,
        "valor": 20205176.0,
        "delta": -5191225.0
      },
      {
        "periodo": 202512,
        "valor": 24961369.0,
        "delta": 4756193.0
      },
      {
        "periodo": 202601,
        "valor": 17627841.0,
        "delta": -7333528.0
      },
      {
        "periodo": 202602,
        "valor": 20039730.0,
        "delta": 2411889.0
      },
      {
        "periodo": 202603,
        "valor": 18075333.0,
        "delta": -1964397.0
      },
      {
        "periodo": 202604,
        "valor": 19154507.0,
        "delta": 1079174.0
      },
      {
        "periodo": 202605,
        "valor": 21122977.0,
        "delta": 1968470.0
      },
      {
        "periodo": 202606,
        "valor": 36217963.0,
        "delta": 15094986.0
      },
      {
        "periodo": 202607,
        "valor": 20833298.0,
        "delta": -15384665.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 25510980.78999999,
    "valor_anterior": 29248906.080000013,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17015967.52,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14197334.48,
        "delta": -2818633.04
      },
      {
        "periodo": 202509,
        "valor": 43049361.34,
        "delta": 28852026.86
      },
      {
        "periodo": 202510,
        "valor": 21045179.4,
        "delta": -22004181.94
      },
      {
        "periodo": 202511,
        "valor": 16848639.67,
        "delta": -4196539.73
      },
      {
        "periodo": 202512,
        "valor": 33527895.81,
        "delta": 16679256.14
      },
      {
        "periodo": 202601,
        "valor": 16003532.58,
        "delta": -17524363.23
      },
      {
        "periodo": 202602,
        "valor": 65842187.55,
        "delta": 49838654.97
      },
      {
        "periodo": 202603,
        "valor": 23790898.58,
        "delta": -42051288.97
      },
      {
        "periodo": 202604,
        "valor": 22511314.24,
        "delta": -1279584.34
      },
      {
        "periodo": 202605,
        "valor": 13498896.71,
        "delta": -9012417.53
      },
      {
        "periodo": 202606,
        "valor": 29248906.08,
        "delta": 15750009.37
      },
      {
        "periodo": 202607,
        "valor": 25510980.79,
        "delta": -3737925.29
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 12758644.72999999,
    "valor_anterior": 17568010.52000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 82171488.79,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 57539939.0,
        "delta": -24631549.79
      },
      {
        "periodo": 202509,
        "valor": 15763285.5,
        "delta": -41776653.5
      },
      {
        "periodo": 202510,
        "valor": 14854291.37,
        "delta": -908994.13
      },
      {
        "periodo": 202511,
        "valor": 12831610.47,
        "delta": -2022680.9
      },
      {
        "periodo": 202512,
        "valor": 14098331.12,
        "delta": 1266720.65
      },
      {
        "periodo": 202601,
        "valor": 84254624.34,
        "delta": 70156293.22
      },
      {
        "periodo": 202602,
        "valor": 10868736.86,
        "delta": -73385887.48
      },
      {
        "periodo": 202603,
        "valor": 12432327.2,
        "delta": 1563590.34
      },
      {
        "periodo": 202604,
        "valor": 13658239.36,
        "delta": 1225912.16
      },
      {
        "periodo": 202605,
        "valor": 9988269.87,
        "delta": -3669969.49
      },
      {
        "periodo": 202606,
        "valor": 17568010.52,
        "delta": 7579740.65
      },
      {
        "periodo": 202607,
        "valor": 12758644.73,
        "delta": -4809365.79
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 6711960.0,
    "valor_anterior": 12903033.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7762759.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6601969.44,
        "delta": -1160789.71
      },
      {
        "periodo": 202509,
        "valor": 15710799.58,
        "delta": 9108830.14
      },
      {
        "periodo": 202510,
        "valor": 15937582.0,
        "delta": 226782.42
      },
      {
        "periodo": 202511,
        "valor": 7732589.0,
        "delta": -8204993.0
      },
      {
        "periodo": 202512,
        "valor": 10064448.0,
        "delta": 2331859.0
      },
      {
        "periodo": 202601,
        "valor": 9006127.0,
        "delta": -1058321.0
      },
      {
        "periodo": 202602,
        "valor": 10099523.0,
        "delta": 1093396.0
      },
      {
        "periodo": 202603,
        "valor": 12245929.0,
        "delta": 2146406.0
      },
      {
        "periodo": 202604,
        "valor": 12151769.0,
        "delta": -94160.0
      },
      {
        "periodo": 202605,
        "valor": 10146247.0,
        "delta": -2005522.0
      },
      {
        "periodo": 202606,
        "valor": 12903033.0,
        "delta": 2756786.0
      },
      {
        "periodo": 202607,
        "valor": 6711960.0,
        "delta": -6191073.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 1172782.0,
    "valor_anterior": 1721034.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8970406.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1664706.0,
        "delta": -7305700.0
      },
      {
        "periodo": 202509,
        "valor": 2179047.0,
        "delta": 514341.0
      },
      {
        "periodo": 202510,
        "valor": 1496790.0,
        "delta": -682257.0
      },
      {
        "periodo": 202511,
        "valor": 1524216.0,
        "delta": 27426.0
      },
      {
        "periodo": 202512,
        "valor": 1520757.0,
        "delta": -3459.0
      },
      {
        "periodo": 202601,
        "valor": 1533122.0,
        "delta": 12365.0
      },
      {
        "periodo": 202602,
        "valor": 1744900.0,
        "delta": 211778.0
      },
      {
        "periodo": 202603,
        "valor": 1475445.0,
        "delta": -269455.0
      },
      {
        "periodo": 202604,
        "valor": 1416694.0,
        "delta": -58751.0
      },
      {
        "periodo": 202605,
        "valor": 1722637.0,
        "delta": 305943.0
      },
      {
        "periodo": 202606,
        "valor": 1721034.0,
        "delta": -1603.0
      },
      {
        "periodo": 202607,
        "valor": 1172782.0,
        "delta": -548252.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 5332960.0,
    "valor_anterior": 6750685.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8564776.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7328182.0,
        "delta": -1236594.0
      },
      {
        "periodo": 202509,
        "valor": 7482725.0,
        "delta": 154543.0
      },
      {
        "periodo": 202510,
        "valor": 7174850.0,
        "delta": -307875.0
      },
      {
        "periodo": 202511,
        "valor": 6447678.0,
        "delta": -727172.0
      },
      {
        "periodo": 202512,
        "valor": 8492847.0,
        "delta": 2045169.0
      },
      {
        "periodo": 202601,
        "valor": 6715338.0,
        "delta": -1777509.0
      },
      {
        "periodo": 202602,
        "valor": 4554947.0,
        "delta": -2160391.0
      },
      {
        "periodo": 202603,
        "valor": 4410102.0,
        "delta": -144845.0
      },
      {
        "periodo": 202604,
        "valor": 5004580.0,
        "delta": 594478.0
      },
      {
        "periodo": 202605,
        "valor": 6223057.0,
        "delta": 1218477.0
      },
      {
        "periodo": 202606,
        "valor": 6750685.0,
        "delta": 527628.0
      },
      {
        "periodo": 202607,
        "valor": 5332960.0,
        "delta": -1417725.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1978162.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2021774.0,
        "delta": 43612.0
      },
      {
        "periodo": 202509,
        "valor": 11442320.0,
        "delta": 9420546.0
      },
      {
        "periodo": 202510,
        "valor": 86598.0,
        "delta": -11355722.0
      },
      {
        "periodo": 202511,
        "valor": 34211133.0,
        "delta": 34124535.0
      },
      {
        "periodo": 202512,
        "valor": 163037.0,
        "delta": -34048096.0
      },
      {
        "periodo": 202601,
        "valor": 29932.0,
        "delta": -133105.0
      },
      {
        "periodo": 202602,
        "valor": 57594.0,
        "delta": 27662.0
      },
      {
        "periodo": 202603,
        "valor": 25494.0,
        "delta": -32100.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": -25494.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 4550718.670000002,
    "valor_anterior": 4639222.109999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5138467.51,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4999534.73,
        "delta": -138932.78
      },
      {
        "periodo": 202509,
        "valor": 4721070.04,
        "delta": -278464.69
      },
      {
        "periodo": 202510,
        "valor": 5841608.71,
        "delta": 1120538.67
      },
      {
        "periodo": 202511,
        "valor": 5540445.52,
        "delta": -301163.19
      },
      {
        "periodo": 202512,
        "valor": 6131161.07,
        "delta": 590715.55
      },
      {
        "periodo": 202601,
        "valor": 5260386.83,
        "delta": -870774.24
      },
      {
        "periodo": 202602,
        "valor": 4425694.17,
        "delta": -834692.66
      },
      {
        "periodo": 202603,
        "valor": 4303772.07,
        "delta": -121922.1
      },
      {
        "periodo": 202604,
        "valor": 4381413.97,
        "delta": 77641.9
      },
      {
        "periodo": 202605,
        "valor": 4751549.64,
        "delta": 370135.67
      },
      {
        "periodo": 202606,
        "valor": 4639222.11,
        "delta": -112327.53
      },
      {
        "periodo": 202607,
        "valor": 4550718.67,
        "delta": -88503.44
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 304416.0,
    "valor_anterior": 304416.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11152.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11153.0,
        "delta": 1.0
      },
      {
        "periodo": 202509,
        "valor": 11152.0,
        "delta": -1.0
      },
      {
        "periodo": 202510,
        "valor": 13374.0,
        "delta": 2222.0
      },
      {
        "periodo": 202511,
        "valor": 16707.0,
        "delta": 3333.0
      },
      {
        "periodo": 202512,
        "valor": 16708.0,
        "delta": 1.0
      },
      {
        "periodo": 202601,
        "valor": 16707.0,
        "delta": -1.0
      },
      {
        "periodo": 202602,
        "valor": 34416.0,
        "delta": 17709.0
      },
      {
        "periodo": 202603,
        "valor": 54416.0,
        "delta": 20000.0
      },
      {
        "periodo": 202604,
        "valor": 54416.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 304415.0,
        "delta": 249999.0
      },
      {
        "periodo": 202606,
        "valor": 304416.0,
        "delta": 1.0
      },
      {
        "periodo": 202607,
        "valor": 304416.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19687.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19688.0,
        "delta": 1.0
      },
      {
        "periodo": 202509,
        "valor": 19687.0,
        "delta": -1.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": -19687.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 333.0,
        "delta": 333.0
      },
      {
        "periodo": 202601,
        "valor": 333.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 334.0,
        "delta": 1.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": -334.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 3891220.0,
    "valor_anterior": 3788748.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 666713.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 641160.0,
        "delta": -25553.0
      },
      {
        "periodo": 202509,
        "valor": 486787.0,
        "delta": -154373.0
      },
      {
        "periodo": 202510,
        "valor": 552386.0,
        "delta": 65599.0
      },
      {
        "periodo": 202511,
        "valor": 271681.0,
        "delta": -280705.0
      },
      {
        "periodo": 202512,
        "valor": 32501766.0,
        "delta": 32230085.0
      },
      {
        "periodo": 202601,
        "valor": 3721757.0,
        "delta": -28780009.0
      },
      {
        "periodo": 202602,
        "valor": 3584034.0,
        "delta": -137723.0
      },
      {
        "periodo": 202603,
        "valor": 3625415.0,
        "delta": 41381.0
      },
      {
        "periodo": 202604,
        "valor": 52621.0,
        "delta": -3572794.0
      },
      {
        "periodo": 202605,
        "valor": 3381849.0,
        "delta": 3329228.0
      },
      {
        "periodo": 202606,
        "valor": 3788748.0,
        "delta": 406899.0
      },
      {
        "periodo": 202607,
        "valor": 3891220.0,
        "delta": 102472.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18918440.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 83529768.0,
        "delta": 64611328.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 3765065.0,
    "valor_anterior": 4502880.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4919669.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4393585.0,
        "delta": -526084.0
      },
      {
        "periodo": 202509,
        "valor": 4859961.0,
        "delta": 466376.0
      },
      {
        "periodo": 202510,
        "valor": 5270100.0,
        "delta": 410139.0
      },
      {
        "periodo": 202511,
        "valor": 3872826.0,
        "delta": -1397274.0
      },
      {
        "periodo": 202512,
        "valor": 6749381.0,
        "delta": 2876555.0
      },
      {
        "periodo": 202601,
        "valor": 5977477.0,
        "delta": -771904.0
      },
      {
        "periodo": 202602,
        "valor": 3737793.0,
        "delta": -2239684.0
      },
      {
        "periodo": 202603,
        "valor": 3921412.0,
        "delta": 183619.0
      },
      {
        "periodo": 202604,
        "valor": 4037004.0,
        "delta": 115592.0
      },
      {
        "periodo": 202605,
        "valor": 3107604.0,
        "delta": -929400.0
      },
      {
        "periodo": 202606,
        "valor": 4502880.0,
        "delta": 1395276.0
      },
      {
        "periodo": 202607,
        "valor": 3765065.0,
        "delta": -737815.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 3861303.0,
    "valor_anterior": 4826033.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3228485.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3277254.0,
        "delta": 48769.0
      },
      {
        "periodo": 202509,
        "valor": 3556136.0,
        "delta": 278882.0
      },
      {
        "periodo": 202510,
        "valor": 3515662.0,
        "delta": -40474.0
      },
      {
        "periodo": 202511,
        "valor": 3778945.0,
        "delta": 263283.0
      },
      {
        "periodo": 202512,
        "valor": 3670576.0,
        "delta": -108369.0
      },
      {
        "periodo": 202601,
        "valor": 3584457.0,
        "delta": -86119.0
      },
      {
        "periodo": 202602,
        "valor": 3909164.0,
        "delta": 324707.0
      },
      {
        "periodo": 202603,
        "valor": 3080645.0,
        "delta": -828519.0
      },
      {
        "periodo": 202604,
        "valor": 2492432.0,
        "delta": -588213.0
      },
      {
        "periodo": 202605,
        "valor": 2798442.0,
        "delta": 306010.0
      },
      {
        "periodo": 202606,
        "valor": 4826033.0,
        "delta": 2027591.0
      },
      {
        "periodo": 202607,
        "valor": 3861303.0,
        "delta": -964730.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 367.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 202.0,
        "delta": -165.0
      },
      {
        "periodo": 202509,
        "valor": 2399.0,
        "delta": 2197.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": -2399.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 3947055.4000000022,
    "valor_anterior": 3807415.829999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4041025.32,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4204236.01,
        "delta": 163210.69
      },
      {
        "periodo": 202509,
        "valor": 3919985.42,
        "delta": -284250.59
      },
      {
        "periodo": 202510,
        "valor": 4200641.79,
        "delta": 280656.37
      },
      {
        "periodo": 202511,
        "valor": 4161540.71,
        "delta": -39101.08
      },
      {
        "periodo": 202512,
        "valor": 3847872.25,
        "delta": -313668.46
      },
      {
        "periodo": 202601,
        "valor": 3560521.51,
        "delta": -287350.74
      },
      {
        "periodo": 202602,
        "valor": 3987009.62,
        "delta": 426488.11
      },
      {
        "periodo": 202603,
        "valor": 3896865.73,
        "delta": -90143.89
      },
      {
        "periodo": 202604,
        "valor": 4297325.47,
        "delta": 400459.74
      },
      {
        "periodo": 202605,
        "valor": 4235807.63,
        "delta": -61517.84
      },
      {
        "periodo": 202606,
        "valor": 3807415.83,
        "delta": -428391.8
      },
      {
        "periodo": 202607,
        "valor": 3947055.4,
        "delta": 139639.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 32935.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 759844.0,
        "delta": 726909.0
      },
      {
        "periodo": 202509,
        "valor": 9207.0,
        "delta": -750637.0
      },
      {
        "periodo": 202510,
        "valor": 32075.0,
        "delta": 22868.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": -32075.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 3744587.7699999996,
    "valor_anterior": 3077664.4700000025,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3514418.99,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3021669.69,
        "delta": -492749.3
      },
      {
        "periodo": 202509,
        "valor": 3392476.21,
        "delta": 370806.52
      },
      {
        "periodo": 202510,
        "valor": 3721006.3,
        "delta": 328530.09
      },
      {
        "periodo": 202511,
        "valor": 2424062.63,
        "delta": -1296943.67
      },
      {
        "periodo": 202512,
        "valor": 4573994.24,
        "delta": 2149931.61
      },
      {
        "periodo": 202601,
        "valor": 3541596.76,
        "delta": -1032397.48
      },
      {
        "periodo": 202602,
        "valor": 7078724.83,
        "delta": 3537128.07
      },
      {
        "periodo": 202603,
        "valor": 6697588.67,
        "delta": -381136.16
      },
      {
        "periodo": 202604,
        "valor": 6589588.7,
        "delta": -107999.97
      },
      {
        "periodo": 202605,
        "valor": 6534255.19,
        "delta": -55333.51
      },
      {
        "periodo": 202606,
        "valor": 3077664.47,
        "delta": -3456590.72
      },
      {
        "periodo": 202607,
        "valor": 3744587.77,
        "delta": 666923.3
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 3081732.129999999,
    "valor_anterior": 6275947.449999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5465222.86,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3617990.62,
        "delta": -1847232.24
      },
      {
        "periodo": 202509,
        "valor": 4852871.5,
        "delta": 1234880.88
      },
      {
        "periodo": 202510,
        "valor": 4251642.51,
        "delta": -601228.99
      },
      {
        "periodo": 202511,
        "valor": 3657627.63,
        "delta": -594014.88
      },
      {
        "periodo": 202512,
        "valor": 2553159.07,
        "delta": -1104468.56
      },
      {
        "periodo": 202601,
        "valor": 3911672.5,
        "delta": 1358513.43
      },
      {
        "periodo": 202602,
        "valor": 4515609.04,
        "delta": 603936.54
      },
      {
        "periodo": 202603,
        "valor": 4672920.92,
        "delta": 157311.88
      },
      {
        "periodo": 202604,
        "valor": 3207236.23,
        "delta": -1465684.69
      },
      {
        "periodo": 202605,
        "valor": 5188652.18,
        "delta": 1981415.95
      },
      {
        "periodo": 202606,
        "valor": 6275947.45,
        "delta": 1087295.27
      },
      {
        "periodo": 202607,
        "valor": 3081732.13,
        "delta": -3194215.32
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 735486.0,
    "valor_anterior": 780444.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 614551.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 668841.0,
        "delta": 54290.0
      },
      {
        "periodo": 202509,
        "valor": 3930885.0,
        "delta": 3262044.0
      },
      {
        "periodo": 202510,
        "valor": 568654.0,
        "delta": -3362231.0
      },
      {
        "periodo": 202511,
        "valor": 548455.0,
        "delta": -20199.0
      },
      {
        "periodo": 202512,
        "valor": 561506.0,
        "delta": 13051.0
      },
      {
        "periodo": 202601,
        "valor": 576050.0,
        "delta": 14544.0
      },
      {
        "periodo": 202602,
        "valor": 510238.0,
        "delta": -65812.0
      },
      {
        "periodo": 202603,
        "valor": 1123566.0,
        "delta": 613328.0
      },
      {
        "periodo": 202604,
        "valor": 672229.0,
        "delta": -451337.0
      },
      {
        "periodo": 202605,
        "valor": 659591.0,
        "delta": -12638.0
      },
      {
        "periodo": 202606,
        "valor": 780444.0,
        "delta": 120853.0
      },
      {
        "periodo": 202607,
        "valor": 735486.0,
        "delta": -44958.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 10783631.0,
    "valor_anterior": 6943506.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6925059.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6219934.0,
        "delta": -705125.0
      },
      {
        "periodo": 202509,
        "valor": 6476851.0,
        "delta": 256917.0
      },
      {
        "periodo": 202510,
        "valor": 8079853.0,
        "delta": 1603002.0
      },
      {
        "periodo": 202511,
        "valor": 6530074.0,
        "delta": -1549779.0
      },
      {
        "periodo": 202512,
        "valor": 7237462.0,
        "delta": 707388.0
      },
      {
        "periodo": 202601,
        "valor": 6443902.0,
        "delta": -793560.0
      },
      {
        "periodo": 202602,
        "valor": 7538947.0,
        "delta": 1095045.0
      },
      {
        "periodo": 202603,
        "valor": 7753157.0,
        "delta": 214210.0
      },
      {
        "periodo": 202604,
        "valor": 6079184.0,
        "delta": -1673973.0
      },
      {
        "periodo": 202605,
        "valor": 7545227.0,
        "delta": 1466043.0
      },
      {
        "periodo": 202606,
        "valor": 6943506.0,
        "delta": -601721.0
      },
      {
        "periodo": 202607,
        "valor": 10783631.0,
        "delta": 3840125.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 571286.0,
    "valor_anterior": 531515.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 519002.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 456053.0,
        "delta": -62949.0
      },
      {
        "periodo": 202509,
        "valor": 600190.0,
        "delta": 144137.0
      },
      {
        "periodo": 202510,
        "valor": 545309.0,
        "delta": -54881.0
      },
      {
        "periodo": 202511,
        "valor": 496279.0,
        "delta": -49030.0
      },
      {
        "periodo": 202512,
        "valor": 518488.0,
        "delta": 22209.0
      },
      {
        "periodo": 202601,
        "valor": 436094.0,
        "delta": -82394.0
      },
      {
        "periodo": 202602,
        "valor": 389408.0,
        "delta": -46686.0
      },
      {
        "periodo": 202603,
        "valor": 448331.0,
        "delta": 58923.0
      },
      {
        "periodo": 202604,
        "valor": 414048.0,
        "delta": -34283.0
      },
      {
        "periodo": 202605,
        "valor": 387950.0,
        "delta": -26098.0
      },
      {
        "periodo": 202606,
        "valor": 531515.0,
        "delta": 143565.0
      },
      {
        "periodo": 202607,
        "valor": 571286.0,
        "delta": 39771.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 29697.940000000002,
    "valor_anterior": 28406.26000000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 447115.43,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 423871.4,
        "delta": -23244.03
      },
      {
        "periodo": 202509,
        "valor": 468365.63,
        "delta": 44494.23
      },
      {
        "periodo": 202510,
        "valor": 460174.85,
        "delta": -8190.78
      },
      {
        "periodo": 202511,
        "valor": 861806.84,
        "delta": 401631.99
      },
      {
        "periodo": 202512,
        "valor": 28087.01,
        "delta": -833719.83
      },
      {
        "periodo": 202601,
        "valor": 28446.77,
        "delta": 359.76
      },
      {
        "periodo": 202602,
        "valor": 25693.86,
        "delta": -2752.91
      },
      {
        "periodo": 202603,
        "valor": 28739.35,
        "delta": 3045.49
      },
      {
        "periodo": 202604,
        "valor": 28114.3,
        "delta": -625.05
      },
      {
        "periodo": 202605,
        "valor": 29051.44,
        "delta": 937.14
      },
      {
        "periodo": 202606,
        "valor": 28406.26,
        "delta": -645.18
      },
      {
        "periodo": 202607,
        "valor": 29697.94,
        "delta": 1291.68
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10581033.18,
        "delta": 10581033.18
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -10581033.18
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 277.0,
    "valor_anterior": 278.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 278.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 277.0,
        "delta": -1.0
      },
      {
        "periodo": 202509,
        "valor": 278.0,
        "delta": 1.0
      },
      {
        "periodo": 202510,
        "valor": 278.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 278.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 277.0,
        "delta": -1.0
      },
      {
        "periodo": 202601,
        "valor": 278.0,
        "delta": 1.0
      },
      {
        "periodo": 202602,
        "valor": 278.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 277.0,
        "delta": -1.0
      },
      {
        "periodo": 202604,
        "valor": 278.0,
        "delta": 1.0
      },
      {
        "periodo": 202605,
        "valor": 278.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 278.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 277.0,
        "delta": -1.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 147884.0,
    "valor_anterior": 142168.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 200607.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 201635.0,
        "delta": 1028.0
      },
      {
        "periodo": 202509,
        "valor": 198480.0,
        "delta": -3155.0
      },
      {
        "periodo": 202510,
        "valor": 200517.0,
        "delta": 2037.0
      },
      {
        "periodo": 202511,
        "valor": 170334.0,
        "delta": -30183.0
      },
      {
        "periodo": 202512,
        "valor": 171245.0,
        "delta": 911.0
      },
      {
        "periodo": 202601,
        "valor": 160868.0,
        "delta": -10377.0
      },
      {
        "periodo": 202602,
        "valor": 136144.0,
        "delta": -24724.0
      },
      {
        "periodo": 202603,
        "valor": 147007.0,
        "delta": 10863.0
      },
      {
        "periodo": 202604,
        "valor": 134727.0,
        "delta": -12280.0
      },
      {
        "periodo": 202605,
        "valor": 140762.0,
        "delta": 6035.0
      },
      {
        "periodo": 202606,
        "valor": 142168.0,
        "delta": 1406.0
      },
      {
        "periodo": 202607,
        "valor": 147884.0,
        "delta": 5716.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 5745084.719999999,
    "valor_anterior": 5342830.920000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 5000395.43,
        "delta": 5000395.43
      },
      {
        "periodo": 202603,
        "valor": 5600510.22,
        "delta": 600114.79
      },
      {
        "periodo": 202604,
        "valor": 5473011.28,
        "delta": -127498.94
      },
      {
        "periodo": 202605,
        "valor": 5577626.52,
        "delta": 104615.24
      },
      {
        "periodo": 202606,
        "valor": 5342830.92,
        "delta": -234795.6
      },
      {
        "periodo": 202607,
        "valor": 5745084.72,
        "delta": 402253.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 435080554.0,
    "valor_anterior": 402983334.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 876824440.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 470227533.0,
        "delta": -406596907.0
      },
      {
        "periodo": 202605,
        "valor": 379552836.0,
        "delta": -90674697.0
      },
      {
        "periodo": 202606,
        "valor": 402983334.0,
        "delta": 23430498.0
      },
      {
        "periodo": 202607,
        "valor": 435080554.0,
        "delta": 32097220.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 1608420827.4499989,
    "valor_anterior": 1645969913.250001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1190791615.09,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1141591998.23,
        "delta": -49199616.86
      },
      {
        "periodo": 202509,
        "valor": 931915205.86,
        "delta": -209676792.37
      },
      {
        "periodo": 202510,
        "valor": 1126946466.27,
        "delta": 195031260.41
      },
      {
        "periodo": 202511,
        "valor": 1106449642.51,
        "delta": -20496823.76
      },
      {
        "periodo": 202512,
        "valor": 1728703984.34,
        "delta": 622254341.83
      },
      {
        "periodo": 202601,
        "valor": 1060174542.62,
        "delta": -668529441.72
      },
      {
        "periodo": 202602,
        "valor": 1177311926.82,
        "delta": 117137384.2
      },
      {
        "periodo": 202603,
        "valor": 2051335456.29,
        "delta": 874023529.47
      },
      {
        "periodo": 202604,
        "valor": 1756999749.16,
        "delta": -294335707.13
      },
      {
        "periodo": 202605,
        "valor": 1634270200.89,
        "delta": -122729548.27
      },
      {
        "periodo": 202606,
        "valor": 1645969913.25,
        "delta": 11699712.36
      },
      {
        "periodo": 202607,
        "valor": 1608420827.45,
        "delta": -37549085.8
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 829978186.0699997,
    "valor_anterior": 872417836.8000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 781952142.55,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 697905895.09,
        "delta": -84046247.46
      },
      {
        "periodo": 202509,
        "valor": 705285541.68,
        "delta": 7379646.59
      },
      {
        "periodo": 202510,
        "valor": 790811174.88,
        "delta": 85525633.2
      },
      {
        "periodo": 202511,
        "valor": 768434698.78,
        "delta": -22376476.1
      },
      {
        "periodo": 202512,
        "valor": 1316784704.09,
        "delta": 548350005.31
      },
      {
        "periodo": 202601,
        "valor": 671078361.71,
        "delta": -645706342.38
      },
      {
        "periodo": 202602,
        "valor": 821995818.08,
        "delta": 150917456.37
      },
      {
        "periodo": 202603,
        "valor": 824954696.79,
        "delta": 2958878.71
      },
      {
        "periodo": 202604,
        "valor": 964658519.84,
        "delta": 139703823.05
      },
      {
        "periodo": 202605,
        "valor": 931077263.54,
        "delta": -33581256.3
      },
      {
        "periodo": 202606,
        "valor": 872417836.8,
        "delta": -58659426.74
      },
      {
        "periodo": 202607,
        "valor": 829978186.07,
        "delta": -42439650.73
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 6952420.6999999955,
    "valor_anterior": 10572223.560000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30159193.51,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 93130126.19,
        "delta": 62970932.68
      },
      {
        "periodo": 202509,
        "valor": -117510082.93,
        "delta": -210640209.12
      },
      {
        "periodo": 202510,
        "valor": 8667100.66,
        "delta": 126177183.59
      },
      {
        "periodo": 202511,
        "valor": 42162408.06,
        "delta": 33495307.4
      },
      {
        "periodo": 202512,
        "valor": 10886177.78,
        "delta": -31276230.28
      },
      {
        "periodo": 202601,
        "valor": 11413716.63,
        "delta": 527538.85
      },
      {
        "periodo": 202602,
        "valor": 7168847.14,
        "delta": -4244869.49
      },
      {
        "periodo": 202603,
        "valor": 7810794.41,
        "delta": 641947.27
      },
      {
        "periodo": 202604,
        "valor": 8298314.51,
        "delta": 487520.1
      },
      {
        "periodo": 202605,
        "valor": 6754735.02,
        "delta": -1543579.49
      },
      {
        "periodo": 202606,
        "valor": 10572223.56,
        "delta": 3817488.54
      },
      {
        "periodo": 202607,
        "valor": 6952420.7,
        "delta": -3619802.86
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 50088964.78999996,
    "valor_anterior": 52985731.08000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40607368.52,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 37542691.48,
        "delta": -3064677.04
      },
      {
        "periodo": 202509,
        "valor": 70005942.34,
        "delta": 32463250.86
      },
      {
        "periodo": 202510,
        "valor": 49030882.4,
        "delta": -20975059.94
      },
      {
        "periodo": 202511,
        "valor": 37025857.67,
        "delta": -12005024.73
      },
      {
        "periodo": 202512,
        "valor": 54923638.81,
        "delta": 17897781.14
      },
      {
        "periodo": 202601,
        "valor": 41752027.58,
        "delta": -13171611.23
      },
      {
        "periodo": 202602,
        "valor": 87450650.55,
        "delta": 45698622.97
      },
      {
        "periodo": 202603,
        "valor": 50819571.58,
        "delta": -36631078.97
      },
      {
        "periodo": 202604,
        "valor": 42173194.24,
        "delta": -8646377.34
      },
      {
        "periodo": 202605,
        "valor": 34127417.71,
        "delta": -8045776.53
      },
      {
        "periodo": 202606,
        "valor": 52985731.08,
        "delta": 18858313.37
      },
      {
        "periodo": 202607,
        "valor": 50088964.79,
        "delta": -2896766.29
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 210456353.52999997,
    "valor_anterior": 215547176.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 199788962.46,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 198855435.4,
        "delta": -933527.06
      },
      {
        "periodo": 202509,
        "valor": 190204581.89,
        "delta": -8650853.51
      },
      {
        "periodo": 202510,
        "valor": 203157914.8,
        "delta": 12953332.91
      },
      {
        "periodo": 202511,
        "valor": 198246497.2,
        "delta": -4911417.6
      },
      {
        "periodo": 202512,
        "valor": 235660639.9,
        "delta": 37414142.7
      },
      {
        "periodo": 202601,
        "valor": 197052526.99,
        "delta": -38608112.91
      },
      {
        "periodo": 202602,
        "valor": 187246712.24,
        "delta": -9805814.75
      },
      {
        "periodo": 202603,
        "valor": 205669348.35,
        "delta": 18422636.11
      },
      {
        "periodo": 202604,
        "valor": 194837380.26,
        "delta": -10831968.09
      },
      {
        "periodo": 202605,
        "valor": 210357391.15,
        "delta": 15520010.89
      },
      {
        "periodo": 202606,
        "valor": 215547176.25,
        "delta": 5189785.1
      },
      {
        "periodo": 202607,
        "valor": 210456353.53,
        "delta": -5090822.72
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 48918680.24000001,
    "valor_anterior": 60124800.00999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 50306911.75,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 50977014.34,
        "delta": 670102.59
      },
      {
        "periodo": 202509,
        "valor": 62955681.34,
        "delta": 11978667.0
      },
      {
        "periodo": 202510,
        "valor": 54031107.45,
        "delta": -8924573.89
      },
      {
        "periodo": 202511,
        "valor": 41936443.81,
        "delta": -12094663.64
      },
      {
        "periodo": 202512,
        "valor": 57717565.57,
        "delta": 15781121.76
      },
      {
        "periodo": 202601,
        "valor": 45641141.54,
        "delta": -12076424.03
      },
      {
        "periodo": 202602,
        "valor": 49571038.35,
        "delta": 3929896.81
      },
      {
        "periodo": 202603,
        "valor": 59294580.67,
        "delta": 9723542.32
      },
      {
        "periodo": 202604,
        "valor": 53239521.7,
        "delta": -6055058.97
      },
      {
        "periodo": 202605,
        "valor": 48701262.44,
        "delta": -4538259.26
      },
      {
        "periodo": 202606,
        "valor": 60124800.01,
        "delta": 11423537.57
      },
      {
        "periodo": 202607,
        "valor": 48918680.24,
        "delta": -11206119.77
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100108,
    "label": "Comisiones Otorg.",
    "valor_actual": 462026222.1199999,
    "valor_anterior": 434322145.54999995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 87977036.3,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 63180835.73,
        "delta": -24796200.57
      },
      {
        "periodo": 202509,
        "valor": 20973541.54,
        "delta": -42207294.19
      },
      {
        "periodo": 202510,
        "valor": 21248286.08,
        "delta": 274744.54
      },
      {
        "periodo": 202511,
        "valor": 18643736.99,
        "delta": -2604549.09
      },
      {
        "periodo": 202512,
        "valor": 52731258.19,
        "delta": 34087521.2
      },
      {
        "periodo": 202601,
        "valor": 93236768.17,
        "delta": 40505509.98
      },
      {
        "periodo": 202602,
        "valor": 23878860.46,
        "delta": -69357907.71
      },
      {
        "periodo": 202603,
        "valor": 902786464.49,
        "delta": 878907604.03
      },
      {
        "periodo": 202604,
        "valor": 493792818.61,
        "delta": -408993645.88
      },
      {
        "periodo": 202605,
        "valor": 403252131.03,
        "delta": -90540687.58
      },
      {
        "periodo": 202606,
        "valor": 434322145.55,
        "delta": 31070014.52
      },
      {
        "periodo": 202607,
        "valor": 462026222.12,
        "delta": 27704076.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 434837538.1300001,
    "valor_anterior": 411181814.46000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 487729764.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 466201508.16,
        "delta": -21528256.66
      },
      {
        "periodo": 202509,
        "valor": 446096039.62,
        "delta": -20105468.54
      },
      {
        "periodo": 202510,
        "valor": 490967831.37,
        "delta": 44871791.75
      },
      {
        "periodo": 202511,
        "valor": 437826479.7,
        "delta": -53141351.67
      },
      {
        "periodo": 202512,
        "valor": 438413396.72,
        "delta": 586917.02
      },
      {
        "periodo": 202601,
        "valor": 403837709.57,
        "delta": -34575687.15
      },
      {
        "periodo": 202602,
        "valor": 346464878.85,
        "delta": -57372830.72
      },
      {
        "periodo": 202603,
        "valor": 402392985.75,
        "delta": 55928106.9
      },
      {
        "periodo": 202604,
        "valor": 419549257.73,
        "delta": 17156271.98
      },
      {
        "periodo": 202605,
        "valor": 404284914.45,
        "delta": -15264343.28
      },
      {
        "periodo": 202606,
        "valor": 411181814.46,
        "delta": 6896900.01
      },
      {
        "periodo": 202607,
        "valor": 434837538.13,
        "delta": 23655723.67
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 1970435929.6399994,
    "valor_anterior": 1891296279.3400002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2040868814.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1801177788.61,
        "delta": -239691026.29
      },
      {
        "periodo": 202509,
        "valor": 1833237543.87,
        "delta": 32059755.26
      },
      {
        "periodo": 202510,
        "valor": 1850121536.4,
        "delta": 16883992.53
      },
      {
        "periodo": 202511,
        "valor": 1709476634.93,
        "delta": -140644901.47
      },
      {
        "periodo": 202512,
        "valor": 1827245952.54,
        "delta": 117769317.61
      },
      {
        "periodo": 202601,
        "valor": 1915182275.39,
        "delta": 87936322.85
      },
      {
        "periodo": 202602,
        "valor": 1687155631.16,
        "delta": -228026644.23
      },
      {
        "periodo": 202603,
        "valor": 2092885628.11,
        "delta": 405729996.95
      },
      {
        "periodo": 202604,
        "valor": 2017549763.43,
        "delta": -75335864.68
      },
      {
        "periodo": 202605,
        "valor": 1937142936.14,
        "delta": -80406827.29
      },
      {
        "periodo": 202606,
        "valor": 1891296279.34,
        "delta": -45846656.8
      },
      {
        "periodo": 202607,
        "valor": 1970435929.64,
        "delta": 79139650.3
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 1096411420.0,
    "valor_anterior": 1082721792.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1488598889.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1400357113.0,
        "delta": -88241776.0
      },
      {
        "periodo": 202509,
        "valor": 1285927497.0,
        "delta": -114429616.0
      },
      {
        "periodo": 202510,
        "valor": 1180917962.0,
        "delta": -105009535.0
      },
      {
        "periodo": 202511,
        "valor": 1173180846.0,
        "delta": -7737116.0
      },
      {
        "periodo": 202512,
        "valor": 1110588663.0,
        "delta": -62592183.0
      },
      {
        "periodo": 202601,
        "valor": 1060889592.0,
        "delta": -49699071.0
      },
      {
        "periodo": 202602,
        "valor": 974729190.0,
        "delta": -86160402.0
      },
      {
        "periodo": 202603,
        "valor": 1167803269.0,
        "delta": 193074079.0
      },
      {
        "periodo": 202604,
        "valor": 1133784522.0,
        "delta": -34018747.0
      },
      {
        "periodo": 202605,
        "valor": 1134613986.0,
        "delta": 829464.0
      },
      {
        "periodo": 202606,
        "valor": 1082721793.0,
        "delta": -51892193.0
      },
      {
        "periodo": 202607,
        "valor": 1096411420.0,
        "delta": 13689627.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 725030079.0,
    "valor_anterior": 665758478.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 872597562.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 906541263.0,
        "delta": 33943701.0
      },
      {
        "periodo": 202509,
        "valor": 786085565.0,
        "delta": -120455698.0
      },
      {
        "periodo": 202510,
        "valor": 822817599.0,
        "delta": 36732034.0
      },
      {
        "periodo": 202511,
        "valor": 774079874.0,
        "delta": -48737725.0
      },
      {
        "periodo": 202512,
        "valor": 782851648.0,
        "delta": 8771774.0
      },
      {
        "periodo": 202601,
        "valor": 669648478.0,
        "delta": -113203170.0
      },
      {
        "periodo": 202602,
        "valor": 754848146.0,
        "delta": 85199668.0
      },
      {
        "periodo": 202603,
        "valor": 642926154.0,
        "delta": -111921992.0
      },
      {
        "periodo": 202604,
        "valor": 600030739.0,
        "delta": -42895415.0
      },
      {
        "periodo": 202605,
        "valor": 643444816.0,
        "delta": 43414077.0
      },
      {
        "periodo": 202606,
        "valor": 665758478.0,
        "delta": 22313662.0
      },
      {
        "periodo": 202607,
        "valor": 725030079.0,
        "delta": 59271601.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 310616652.79999995,
    "valor_anterior": 308828883.31999993,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 345916777.79,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 371215836.73,
        "delta": 25299058.94
      },
      {
        "periodo": 202509,
        "valor": 357801498.94,
        "delta": -13414337.79
      },
      {
        "periodo": 202510,
        "valor": 348137204.09,
        "delta": -9664294.85
      },
      {
        "periodo": 202511,
        "valor": 329059869.67,
        "delta": -19077334.42
      },
      {
        "periodo": 202512,
        "valor": 313210992.49,
        "delta": -15848877.18
      },
      {
        "periodo": 202601,
        "valor": 279705422.04,
        "delta": -33505570.45
      },
      {
        "periodo": 202602,
        "valor": 269650984.48,
        "delta": -10054437.56
      },
      {
        "periodo": 202603,
        "valor": 307135911.6,
        "delta": 37484927.12
      },
      {
        "periodo": 202604,
        "valor": 320939664.67,
        "delta": 13803753.07
      },
      {
        "periodo": 202605,
        "valor": 333512873.86,
        "delta": 12573209.19
      },
      {
        "periodo": 202606,
        "valor": 308828883.32,
        "delta": -24683990.54
      },
      {
        "periodo": 202607,
        "valor": 310616652.8,
        "delta": 1787769.48
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 1757557468.0,
    "valor_anterior": 1706488812.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2155679651.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2071423276.0,
        "delta": -84256375.0
      },
      {
        "periodo": 202509,
        "valor": 1968800278.0,
        "delta": -102622998.0
      },
      {
        "periodo": 202510,
        "valor": 1979362064.0,
        "delta": 10561786.0
      },
      {
        "periodo": 202511,
        "valor": 1870711516.0,
        "delta": -108650548.0
      },
      {
        "periodo": 202512,
        "valor": 1971383412.0,
        "delta": 100671896.0
      },
      {
        "periodo": 202601,
        "valor": 1972300314.0,
        "delta": 916902.0
      },
      {
        "periodo": 202602,
        "valor": 1725251238.0,
        "delta": -247049076.0
      },
      {
        "periodo": 202603,
        "valor": 1907888811.0,
        "delta": 182637573.0
      },
      {
        "periodo": 202604,
        "valor": 1786782648.0,
        "delta": -121106163.0
      },
      {
        "periodo": 202605,
        "valor": 1815348914.0,
        "delta": 28566266.0
      },
      {
        "periodo": 202606,
        "valor": 1706488812.0,
        "delta": -108860102.0
      },
      {
        "periodo": 202607,
        "valor": 1757557468.0,
        "delta": 51068656.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 215516283.0,
    "valor_anterior": 199591459.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 96014378.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 115955306.0,
        "delta": 19940928.0
      },
      {
        "periodo": 202509,
        "valor": 117777078.0,
        "delta": 1821772.0
      },
      {
        "periodo": 202510,
        "valor": 133561720.0,
        "delta": 15784642.0
      },
      {
        "periodo": 202511,
        "valor": 106583537.0,
        "delta": -26978183.0
      },
      {
        "periodo": 202512,
        "valor": 117640177.0,
        "delta": 11056640.0
      },
      {
        "periodo": 202601,
        "valor": 131685512.0,
        "delta": 14045335.0
      },
      {
        "periodo": 202602,
        "valor": 124688135.0,
        "delta": -6997377.0
      },
      {
        "periodo": 202603,
        "valor": 156265168.0,
        "delta": 31577033.0
      },
      {
        "periodo": 202604,
        "valor": 172530737.0,
        "delta": 16265569.0
      },
      {
        "periodo": 202605,
        "valor": 191995457.0,
        "delta": 19464720.0
      },
      {
        "periodo": 202606,
        "valor": 199591459.0,
        "delta": 7596002.0
      },
      {
        "periodo": 202607,
        "valor": 215516283.0,
        "delta": 15924824.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 905143900.0,
    "valor_anterior": 879185935.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1086099398.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1066811640.0,
        "delta": -19287758.0
      },
      {
        "periodo": 202509,
        "valor": 1038736296.0,
        "delta": -28075344.0
      },
      {
        "periodo": 202510,
        "valor": 1034928385.0,
        "delta": -3807911.0
      },
      {
        "periodo": 202511,
        "valor": 964317761.0,
        "delta": -70610624.0
      },
      {
        "periodo": 202512,
        "valor": 919255866.0,
        "delta": -45061895.0
      },
      {
        "periodo": 202601,
        "valor": 882231819.0,
        "delta": -37024047.0
      },
      {
        "periodo": 202602,
        "valor": 804703664.0,
        "delta": -77528155.0
      },
      {
        "periodo": 202603,
        "valor": 940657103.0,
        "delta": 135953439.0
      },
      {
        "periodo": 202604,
        "valor": 907751526.0,
        "delta": -32905577.0
      },
      {
        "periodo": 202605,
        "valor": 884478080.0,
        "delta": -23273446.0
      },
      {
        "periodo": 202606,
        "valor": 879185935.0,
        "delta": -5292145.0
      },
      {
        "periodo": 202607,
        "valor": 905143900.0,
        "delta": 25957965.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 112773837.59000003,
    "valor_anterior": 105046039.80000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 107412940.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 110676085.76,
        "delta": 3263145.37
      },
      {
        "periodo": 202509,
        "valor": 102370851.51,
        "delta": -8305234.25
      },
      {
        "periodo": 202510,
        "valor": 105128318.24,
        "delta": 2757466.73
      },
      {
        "periodo": 202511,
        "valor": 111778946.92,
        "delta": 6650628.68
      },
      {
        "periodo": 202512,
        "valor": 93231350.52,
        "delta": -18547596.4
      },
      {
        "periodo": 202601,
        "valor": 109337525.55,
        "delta": 16106175.03
      },
      {
        "periodo": 202602,
        "valor": 94537185.82,
        "delta": -14800339.73
      },
      {
        "periodo": 202603,
        "valor": 84486484.54,
        "delta": -10050701.28
      },
      {
        "periodo": 202604,
        "valor": 87142642.04,
        "delta": 2656157.5
      },
      {
        "periodo": 202605,
        "valor": 97894626.75,
        "delta": 10751984.71
      },
      {
        "periodo": 202606,
        "valor": 105046039.8,
        "delta": 7151413.05
      },
      {
        "periodo": 202607,
        "valor": 112773837.59,
        "delta": 7727797.79
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 11569797.0,
    "valor_anterior": 11406964.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10161580.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10720978.0,
        "delta": 559398.0
      },
      {
        "periodo": 202509,
        "valor": 12041044.0,
        "delta": 1320066.0
      },
      {
        "periodo": 202510,
        "valor": 11891743.0,
        "delta": -149301.0
      },
      {
        "periodo": 202511,
        "valor": 11463463.0,
        "delta": -428280.0
      },
      {
        "periodo": 202512,
        "valor": 11807009.0,
        "delta": 343546.0
      },
      {
        "periodo": 202601,
        "valor": 11351961.0,
        "delta": -455048.0
      },
      {
        "periodo": 202602,
        "valor": 9218993.0,
        "delta": -2132968.0
      },
      {
        "periodo": 202603,
        "valor": 10760310.0,
        "delta": 1541317.0
      },
      {
        "periodo": 202604,
        "valor": 10118163.0,
        "delta": -642147.0
      },
      {
        "periodo": 202605,
        "valor": 10046733.0,
        "delta": -71430.0
      },
      {
        "periodo": 202606,
        "valor": 11406964.0,
        "delta": 1360231.0
      },
      {
        "periodo": 202607,
        "valor": 11569797.0,
        "delta": 162833.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 8403281.0,
    "valor_anterior": 8169734.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10138849.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9597384.0,
        "delta": -541465.0
      },
      {
        "periodo": 202509,
        "valor": 10533754.0,
        "delta": 936370.0
      },
      {
        "periodo": 202510,
        "valor": 9051367.0,
        "delta": -1482387.0
      },
      {
        "periodo": 202511,
        "valor": 8963184.0,
        "delta": -88183.0
      },
      {
        "periodo": 202512,
        "valor": 71049708.0,
        "delta": 62086524.0
      },
      {
        "periodo": 202601,
        "valor": 8691777.0,
        "delta": -62357931.0
      },
      {
        "periodo": 202602,
        "valor": 8645100.0,
        "delta": -46677.0
      },
      {
        "periodo": 202603,
        "valor": 9681710.0,
        "delta": 1036610.0
      },
      {
        "periodo": 202604,
        "valor": 9143772.0,
        "delta": -537938.0
      },
      {
        "periodo": 202605,
        "valor": 9127436.0,
        "delta": -16336.0
      },
      {
        "periodo": 202606,
        "valor": 8169734.0,
        "delta": -957702.0
      },
      {
        "periodo": 202607,
        "valor": 8403281.0,
        "delta": 233547.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 77686045.0,
    "valor_anterior": 73981910.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 98720497.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 97250243.0,
        "delta": -1470254.0
      },
      {
        "periodo": 202509,
        "valor": 88791775.0,
        "delta": -8458468.0
      },
      {
        "periodo": 202510,
        "valor": 87466455.0,
        "delta": -1325320.0
      },
      {
        "periodo": 202511,
        "valor": 81775212.0,
        "delta": -5691243.0
      },
      {
        "periodo": 202512,
        "valor": 81889206.0,
        "delta": 113994.0
      },
      {
        "periodo": 202601,
        "valor": 72721954.0,
        "delta": -9167252.0
      },
      {
        "periodo": 202602,
        "valor": 66525254.0,
        "delta": -6196700.0
      },
      {
        "periodo": 202603,
        "valor": 82857858.0,
        "delta": 16332604.0
      },
      {
        "periodo": 202604,
        "valor": 77016881.0,
        "delta": -5840977.0
      },
      {
        "periodo": 202605,
        "valor": 80660260.0,
        "delta": 3643379.0
      },
      {
        "periodo": 202606,
        "valor": 73981910.0,
        "delta": -6678350.0
      },
      {
        "periodo": 202607,
        "valor": 77686045.0,
        "delta": 3704135.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 1055177396.5900002,
    "valor_anterior": 1017535834.4299994,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1353806058.83,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1235967027.95,
        "delta": -117839030.88
      },
      {
        "periodo": 202509,
        "valor": 1133956627.15,
        "delta": -102010400.8
      },
      {
        "periodo": 202510,
        "valor": 1152820072.77,
        "delta": 18863445.62
      },
      {
        "periodo": 202511,
        "valor": 1141983329.97,
        "delta": -10836742.8
      },
      {
        "periodo": 202512,
        "valor": 1173001988.04,
        "delta": 31018658.07
      },
      {
        "periodo": 202601,
        "valor": 1183367817.16,
        "delta": 10365829.12
      },
      {
        "periodo": 202602,
        "valor": 987769396.9,
        "delta": -195598420.26
      },
      {
        "periodo": 202603,
        "valor": 1119110539.57,
        "delta": 131341142.67
      },
      {
        "periodo": 202604,
        "valor": 1062355023.31,
        "delta": -56755516.26
      },
      {
        "periodo": 202605,
        "valor": 1076024008.16,
        "delta": 13668984.85
      },
      {
        "periodo": 202606,
        "valor": 1017535834.43,
        "delta": -58488173.73
      },
      {
        "periodo": 202607,
        "valor": 1055177396.59,
        "delta": 37641562.16
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 138271142.0,
    "valor_anterior": 128213748.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 91528031.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 83361962.0,
        "delta": -8166069.0
      },
      {
        "periodo": 202509,
        "valor": 88978029.0,
        "delta": 5616067.0
      },
      {
        "periodo": 202510,
        "valor": 101037499.0,
        "delta": 12059470.0
      },
      {
        "periodo": 202511,
        "valor": 95939427.0,
        "delta": -5098072.0
      },
      {
        "periodo": 202512,
        "valor": 124336549.0,
        "delta": 28397122.0
      },
      {
        "periodo": 202601,
        "valor": 127264482.0,
        "delta": 2927933.0
      },
      {
        "periodo": 202602,
        "valor": 106767891.0,
        "delta": -20496591.0
      },
      {
        "periodo": 202603,
        "valor": 131114063.0,
        "delta": 24346172.0
      },
      {
        "periodo": 202604,
        "valor": 134146101.0,
        "delta": 3032038.0
      },
      {
        "periodo": 202605,
        "valor": 146980882.0,
        "delta": 12834781.0
      },
      {
        "periodo": 202606,
        "valor": 128213748.0,
        "delta": -18767134.0
      },
      {
        "periodo": 202607,
        "valor": 138271142.0,
        "delta": 10057394.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 993831.0,
    "valor_anterior": 746773.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1206830.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 794317.0,
        "delta": -412513.0
      },
      {
        "periodo": 202509,
        "valor": 888913.0,
        "delta": 94596.0
      },
      {
        "periodo": 202510,
        "valor": 1084540.0,
        "delta": 195627.0
      },
      {
        "periodo": 202511,
        "valor": 922526.0,
        "delta": -162014.0
      },
      {
        "periodo": 202512,
        "valor": 937499.0,
        "delta": 14973.0
      },
      {
        "periodo": 202601,
        "valor": 972675.0,
        "delta": 35176.0
      },
      {
        "periodo": 202602,
        "valor": 778413.0,
        "delta": -194262.0
      },
      {
        "periodo": 202603,
        "valor": 1008281.0,
        "delta": 229868.0
      },
      {
        "periodo": 202604,
        "valor": 1144700.0,
        "delta": 136419.0
      },
      {
        "periodo": 202605,
        "valor": 858636.0,
        "delta": -286064.0
      },
      {
        "periodo": 202606,
        "valor": 746773.0,
        "delta": -111863.0
      },
      {
        "periodo": 202607,
        "valor": 993831.0,
        "delta": 247058.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 202580453.0,
    "valor_anterior": 183015594.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 259163976.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 266054064.0,
        "delta": 6890088.0
      },
      {
        "periodo": 202509,
        "valor": 259480074.0,
        "delta": -6573990.0
      },
      {
        "periodo": 202510,
        "valor": 260364875.0,
        "delta": 884801.0
      },
      {
        "periodo": 202511,
        "valor": 219136862.0,
        "delta": -41228013.0
      },
      {
        "periodo": 202512,
        "valor": 202242110.0,
        "delta": -16894752.0
      },
      {
        "periodo": 202601,
        "valor": 218916820.0,
        "delta": 16674710.0
      },
      {
        "periodo": 202602,
        "valor": 183446545.0,
        "delta": -35470275.0
      },
      {
        "periodo": 202603,
        "valor": 218060331.0,
        "delta": 34613786.0
      },
      {
        "periodo": 202604,
        "valor": 213302542.0,
        "delta": -4757789.0
      },
      {
        "periodo": 202605,
        "valor": 188435711.0,
        "delta": -24866831.0
      },
      {
        "periodo": 202606,
        "valor": 183015594.0,
        "delta": -5420117.0
      },
      {
        "periodo": 202607,
        "valor": 202580453.0,
        "delta": 19564859.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 1618636.0600000005,
    "valor_anterior": 1789835.9299999997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2763319.57,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3032475.42,
        "delta": 269155.85
      },
      {
        "periodo": 202509,
        "valor": 2575868.95,
        "delta": -456606.47
      },
      {
        "periodo": 202510,
        "valor": 2815171.32,
        "delta": 239302.37
      },
      {
        "periodo": 202511,
        "valor": 2558136.18,
        "delta": -257035.14
      },
      {
        "periodo": 202512,
        "valor": 2606975.13,
        "delta": 48838.95
      },
      {
        "periodo": 202601,
        "valor": 2738099.87,
        "delta": 131124.74
      },
      {
        "periodo": 202602,
        "valor": 3254280.43,
        "delta": 516180.56
      },
      {
        "periodo": 202603,
        "valor": 2735787.96,
        "delta": -518492.47
      },
      {
        "periodo": 202604,
        "valor": 3016418.64,
        "delta": 280630.68
      },
      {
        "periodo": 202605,
        "valor": 3036168.07,
        "delta": 19749.43
      },
      {
        "periodo": 202606,
        "valor": 1789835.93,
        "delta": -1246332.14
      },
      {
        "periodo": 202607,
        "valor": 1618636.06,
        "delta": -171199.87
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 155183496.0,
    "valor_anterior": 154478629.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 194747964.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 183080810.0,
        "delta": -11667154.0
      },
      {
        "periodo": 202509,
        "valor": 166988214.0,
        "delta": -16092596.0
      },
      {
        "periodo": 202510,
        "valor": 168176714.0,
        "delta": 1188500.0
      },
      {
        "periodo": 202511,
        "valor": 164810753.0,
        "delta": -3365961.0
      },
      {
        "periodo": 202512,
        "valor": 169821521.0,
        "delta": 5010768.0
      },
      {
        "periodo": 202601,
        "valor": 169686227.0,
        "delta": -135294.0
      },
      {
        "periodo": 202602,
        "valor": 154409443.0,
        "delta": -15276784.0
      },
      {
        "periodo": 202603,
        "valor": 172019897.0,
        "delta": 17610454.0
      },
      {
        "periodo": 202604,
        "valor": 159251694.0,
        "delta": -12768203.0
      },
      {
        "periodo": 202605,
        "valor": 152420934.0,
        "delta": -6830760.0
      },
      {
        "periodo": 202606,
        "valor": 154478629.0,
        "delta": 2057695.0
      },
      {
        "periodo": 202607,
        "valor": 155183496.0,
        "delta": 704867.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 510240702.3199997,
    "valor_anterior": 522722084.44000006,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 621873058.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 504758367.13,
        "delta": -117114691.13
      },
      {
        "periodo": 202509,
        "valor": 510878382.41,
        "delta": 6120015.28
      },
      {
        "periodo": 202510,
        "valor": 526234965.5,
        "delta": 15356583.09
      },
      {
        "periodo": 202511,
        "valor": 536052495.61,
        "delta": 9817530.11
      },
      {
        "periodo": 202512,
        "valor": 595301411.04,
        "delta": 59248915.43
      },
      {
        "periodo": 202601,
        "valor": 592581300.27,
        "delta": -2720110.77
      },
      {
        "periodo": 202602,
        "valor": 505497621.18,
        "delta": -87083679.09
      },
      {
        "periodo": 202603,
        "valor": 643360371.74,
        "delta": 137862750.56
      },
      {
        "periodo": 202604,
        "valor": 581764075.99,
        "delta": -61596295.75
      },
      {
        "periodo": 202605,
        "valor": 522295560.97,
        "delta": -59468515.02
      },
      {
        "periodo": 202606,
        "valor": 522722084.44,
        "delta": 426523.47
      },
      {
        "periodo": 202607,
        "valor": 510240702.32,
        "delta": -12481382.12
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 291816594.0700002,
    "valor_anterior": 285507925.74,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 310029559.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 295974243.89,
        "delta": -14055315.98
      },
      {
        "periodo": 202509,
        "valor": 284628024.99,
        "delta": -11346218.9
      },
      {
        "periodo": 202510,
        "valor": 296422108.96,
        "delta": 11794083.97
      },
      {
        "periodo": 202511,
        "valor": 281426493.6,
        "delta": -14995615.36
      },
      {
        "periodo": 202512,
        "valor": 275127229.83,
        "delta": -6299263.77
      },
      {
        "periodo": 202601,
        "valor": 258521832.84,
        "delta": -16605396.99
      },
      {
        "periodo": 202602,
        "valor": 233754241.7,
        "delta": -24767591.14
      },
      {
        "periodo": 202603,
        "valor": 258436889.41,
        "delta": 24682647.71
      },
      {
        "periodo": 202604,
        "valor": 285867365.36,
        "delta": 27430475.95
      },
      {
        "periodo": 202605,
        "valor": 290616062.54,
        "delta": 4748697.18
      },
      {
        "periodo": 202606,
        "valor": 285507925.74,
        "delta": -5108136.8
      },
      {
        "periodo": 202607,
        "valor": 291816594.07,
        "delta": 6308668.33
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 31047803.0,
    "valor_anterior": 29624033.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14379460.46,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28931554.46,
        "delta": 14552094.0
      },
      {
        "periodo": 202509,
        "valor": 48018911.75,
        "delta": 19087357.29
      },
      {
        "periodo": 202510,
        "valor": 58233078.0,
        "delta": 10214166.25
      },
      {
        "periodo": 202511,
        "valor": 56717037.0,
        "delta": -1516041.0
      },
      {
        "periodo": 202512,
        "valor": 56673382.0,
        "delta": -43655.0
      },
      {
        "periodo": 202601,
        "valor": 76267866.0,
        "delta": 19594484.0
      },
      {
        "periodo": 202602,
        "valor": 40348253.0,
        "delta": -35919613.0
      },
      {
        "periodo": 202603,
        "valor": 38835169.0,
        "delta": -1513084.0
      },
      {
        "periodo": 202604,
        "valor": 35771618.0,
        "delta": -3063551.0
      },
      {
        "periodo": 202605,
        "valor": 30374709.0,
        "delta": -5396909.0
      },
      {
        "periodo": 202606,
        "valor": 29624033.0,
        "delta": -750676.0
      },
      {
        "periodo": 202607,
        "valor": 31047803.0,
        "delta": 1423770.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 948874.0,
    "valor_anterior": 917462.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4221379.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4224730.0,
        "delta": 3351.0
      },
      {
        "periodo": 202509,
        "valor": 3780842.0,
        "delta": -443888.0
      },
      {
        "periodo": 202510,
        "valor": 4044803.0,
        "delta": 263961.0
      },
      {
        "periodo": 202511,
        "valor": 4107123.0,
        "delta": 62320.0
      },
      {
        "periodo": 202512,
        "valor": 4543878.0,
        "delta": 436755.0
      },
      {
        "periodo": 202601,
        "valor": 3061380.0,
        "delta": -1482498.0
      },
      {
        "periodo": 202602,
        "valor": 1072051.0,
        "delta": -1989329.0
      },
      {
        "periodo": 202603,
        "valor": 1259935.0,
        "delta": 187884.0
      },
      {
        "periodo": 202604,
        "valor": 1365014.0,
        "delta": 105079.0
      },
      {
        "periodo": 202605,
        "valor": 990788.0,
        "delta": -374226.0
      },
      {
        "periodo": 202606,
        "valor": 917462.0,
        "delta": -73326.0
      },
      {
        "periodo": 202607,
        "valor": 948874.0,
        "delta": 31412.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 236986914.0,
    "valor_anterior": 236636315.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 239920354.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 239046466.0,
        "delta": -873888.0
      },
      {
        "periodo": 202509,
        "valor": 239405766.0,
        "delta": 359300.0
      },
      {
        "periodo": 202510,
        "valor": 251435007.0,
        "delta": 12029241.0
      },
      {
        "periodo": 202511,
        "valor": 238099538.0,
        "delta": -13335469.0
      },
      {
        "periodo": 202512,
        "valor": 239904824.0,
        "delta": 1805286.0
      },
      {
        "periodo": 202601,
        "valor": 226229788.0,
        "delta": -13675036.0
      },
      {
        "periodo": 202602,
        "valor": 228598285.0,
        "delta": 2368497.0
      },
      {
        "periodo": 202603,
        "valor": 236730717.0,
        "delta": 8132432.0
      },
      {
        "periodo": 202604,
        "valor": 232373135.0,
        "delta": -4357582.0
      },
      {
        "periodo": 202605,
        "valor": 229561479.0,
        "delta": -2811656.0
      },
      {
        "periodo": 202606,
        "valor": 236636315.0,
        "delta": 7074836.0
      },
      {
        "periodo": 202607,
        "valor": 236986914.0,
        "delta": 350599.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 4407104.0,
    "valor_anterior": 4435772.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5149424.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4970403.0,
        "delta": -179021.0
      },
      {
        "periodo": 202509,
        "valor": 4865024.0,
        "delta": -105379.0
      },
      {
        "periodo": 202510,
        "valor": 4877957.0,
        "delta": 12933.0
      },
      {
        "periodo": 202511,
        "valor": 4573023.0,
        "delta": -304934.0
      },
      {
        "periodo": 202512,
        "valor": 4881716.0,
        "delta": 308693.0
      },
      {
        "periodo": 202601,
        "valor": 4770634.0,
        "delta": -111082.0
      },
      {
        "periodo": 202602,
        "valor": 4301774.0,
        "delta": -468860.0
      },
      {
        "periodo": 202603,
        "valor": 4806876.0,
        "delta": 505102.0
      },
      {
        "periodo": 202604,
        "valor": 4531838.0,
        "delta": -275038.0
      },
      {
        "periodo": 202605,
        "valor": 4527397.0,
        "delta": -4441.0
      },
      {
        "periodo": 202606,
        "valor": 4435772.0,
        "delta": -91625.0
      },
      {
        "periodo": 202607,
        "valor": 4407104.0,
        "delta": -28668.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 74.0,
    "valor_anterior": 63.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8372894.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7082695.0,
        "delta": -1290199.0
      },
      {
        "periodo": 202509,
        "valor": 2170.0,
        "delta": -7080525.0
      },
      {
        "periodo": 202510,
        "valor": 1238.0,
        "delta": -932.0
      },
      {
        "periodo": 202511,
        "valor": -442.0,
        "delta": -1680.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 442.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 14569.0,
        "delta": 14569.0
      },
      {
        "periodo": 202603,
        "valor": 72.0,
        "delta": -14497.0
      },
      {
        "periodo": 202604,
        "valor": 139.0,
        "delta": 67.0
      },
      {
        "periodo": 202605,
        "valor": 75.0,
        "delta": -64.0
      },
      {
        "periodo": 202606,
        "valor": 63.0,
        "delta": -12.0
      },
      {
        "periodo": 202607,
        "valor": 74.0,
        "delta": 11.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 120801982.25,
    "valor_anterior": 111217254.17000008,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 161156895.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 151778788.5,
        "delta": -9378107.43
      },
      {
        "periodo": 202509,
        "valor": 139283556.2,
        "delta": -12495232.3
      },
      {
        "periodo": 202510,
        "valor": 142734226.63,
        "delta": 3450670.43
      },
      {
        "periodo": 202511,
        "valor": 144316635.87,
        "delta": 1582409.24
      },
      {
        "periodo": 202512,
        "valor": 177605200.62,
        "delta": 33288564.75
      },
      {
        "periodo": 202601,
        "valor": 193317077.37,
        "delta": 15711876.75
      },
      {
        "periodo": 202602,
        "valor": 161711175.71,
        "delta": -31605901.66
      },
      {
        "periodo": 202603,
        "valor": 162066341.6,
        "delta": 355165.89
      },
      {
        "periodo": 202604,
        "valor": 112441617.41,
        "delta": -49624724.19
      },
      {
        "periodo": 202605,
        "valor": 115364254.34,
        "delta": 2922636.93
      },
      {
        "periodo": 202606,
        "valor": 111217254.17,
        "delta": -4147000.17
      },
      {
        "periodo": 202607,
        "valor": 120801982.25,
        "delta": 9584728.08
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 14697338.0,
    "valor_anterior": 14297393.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27567663.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26495747.0,
        "delta": -1071916.0
      },
      {
        "periodo": 202509,
        "valor": 24087602.0,
        "delta": -2408145.0
      },
      {
        "periodo": 202510,
        "valor": 17232771.0,
        "delta": -6854831.0
      },
      {
        "periodo": 202511,
        "valor": 16854199.0,
        "delta": -378572.0
      },
      {
        "periodo": 202512,
        "valor": 17105736.0,
        "delta": 251537.0
      },
      {
        "periodo": 202601,
        "valor": 16693118.0,
        "delta": -412618.0
      },
      {
        "periodo": 202602,
        "valor": 14084912.0,
        "delta": -2608206.0
      },
      {
        "periodo": 202603,
        "valor": 15737041.0,
        "delta": 1652129.0
      },
      {
        "periodo": 202604,
        "valor": 14256618.0,
        "delta": -1480423.0
      },
      {
        "periodo": 202605,
        "valor": 15248514.0,
        "delta": 991896.0
      },
      {
        "periodo": 202606,
        "valor": 14297393.0,
        "delta": -951121.0
      },
      {
        "periodo": 202607,
        "valor": 14697338.0,
        "delta": 399945.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 0.0,
    "valor_anterior": -1.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 544.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 545.0,
        "delta": 1.0
      },
      {
        "periodo": 202509,
        "valor": 520.0,
        "delta": -25.0
      },
      {
        "periodo": 202510,
        "valor": 537.0,
        "delta": 17.0
      },
      {
        "periodo": 202511,
        "valor": 518.0,
        "delta": -19.0
      },
      {
        "periodo": 202512,
        "valor": 526.0,
        "delta": 8.0
      },
      {
        "periodo": 202601,
        "valor": 514.0,
        "delta": -12.0
      },
      {
        "periodo": 202602,
        "valor": 453.0,
        "delta": -61.0
      },
      {
        "periodo": 202603,
        "valor": 517.0,
        "delta": 64.0
      },
      {
        "periodo": 202604,
        "valor": 492.0,
        "delta": -25.0
      },
      {
        "periodo": 202605,
        "valor": 504.0,
        "delta": 12.0
      },
      {
        "periodo": 202606,
        "valor": -1.0,
        "delta": -505.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 1.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 463242.0,
    "valor_anterior": 451451.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 249641.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9072.0,
        "delta": -240569.0
      },
      {
        "periodo": 202509,
        "valor": 39667.0,
        "delta": 30595.0
      },
      {
        "periodo": 202510,
        "valor": 15275.0,
        "delta": -24392.0
      },
      {
        "periodo": 202511,
        "valor": 8985.0,
        "delta": -6290.0
      },
      {
        "periodo": 202512,
        "valor": 15110.0,
        "delta": 6125.0
      },
      {
        "periodo": 202601,
        "valor": 12608.0,
        "delta": -2502.0
      },
      {
        "periodo": 202602,
        "valor": 107081.0,
        "delta": 94473.0
      },
      {
        "periodo": 202603,
        "valor": 150784.0,
        "delta": 43703.0
      },
      {
        "periodo": 202604,
        "valor": 68982.0,
        "delta": -81802.0
      },
      {
        "periodo": 202605,
        "valor": 428189.0,
        "delta": 359207.0
      },
      {
        "periodo": 202606,
        "valor": 451451.0,
        "delta": 23262.0
      },
      {
        "periodo": 202607,
        "valor": 463242.0,
        "delta": 11791.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 302.0,
    "valor_anterior": 293.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 462.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 462.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 447.0,
        "delta": -15.0
      },
      {
        "periodo": 202510,
        "valor": 463.0,
        "delta": 16.0
      },
      {
        "periodo": 202511,
        "valor": 447.0,
        "delta": -16.0
      },
      {
        "periodo": 202512,
        "valor": 462.0,
        "delta": 15.0
      },
      {
        "periodo": 202601,
        "valor": 462.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 418.0,
        "delta": -44.0
      },
      {
        "periodo": 202603,
        "valor": 307.0,
        "delta": -111.0
      },
      {
        "periodo": 202604,
        "valor": 293.0,
        "delta": -14.0
      },
      {
        "periodo": 202605,
        "valor": 302.0,
        "delta": 9.0
      },
      {
        "periodo": 202606,
        "valor": 293.0,
        "delta": -9.0
      },
      {
        "periodo": 202607,
        "valor": 302.0,
        "delta": 9.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 524017.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 593177.0,
        "delta": 69160.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 19241081.0,
    "valor_anterior": 19990226.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21087924.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23472382.0,
        "delta": 2384458.0
      },
      {
        "periodo": 202509,
        "valor": 21135091.0,
        "delta": -2337291.0
      },
      {
        "periodo": 202510,
        "valor": 24018321.0,
        "delta": 2883230.0
      },
      {
        "periodo": 202511,
        "valor": 21988803.0,
        "delta": -2029518.0
      },
      {
        "periodo": 202512,
        "valor": 23243556.0,
        "delta": 1254753.0
      },
      {
        "periodo": 202601,
        "valor": 20717036.0,
        "delta": -2526520.0
      },
      {
        "periodo": 202602,
        "valor": 17646582.0,
        "delta": -3070454.0
      },
      {
        "periodo": 202603,
        "valor": 21064991.0,
        "delta": 3418409.0
      },
      {
        "periodo": 202604,
        "valor": 20591401.0,
        "delta": -473590.0
      },
      {
        "periodo": 202605,
        "valor": 20493734.0,
        "delta": -97667.0
      },
      {
        "periodo": 202606,
        "valor": 19990226.0,
        "delta": -503508.0
      },
      {
        "periodo": 202607,
        "valor": 19241081.0,
        "delta": -749145.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 19163962.0,
    "valor_anterior": 16206566.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17291091.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18817363.0,
        "delta": 1526272.0
      },
      {
        "periodo": 202509,
        "valor": 18130261.0,
        "delta": -687102.0
      },
      {
        "periodo": 202510,
        "valor": 19714810.0,
        "delta": 1584549.0
      },
      {
        "periodo": 202511,
        "valor": 19203961.0,
        "delta": -510849.0
      },
      {
        "periodo": 202512,
        "valor": 21931977.0,
        "delta": 2728016.0
      },
      {
        "periodo": 202601,
        "valor": 26910640.0,
        "delta": 4978663.0
      },
      {
        "periodo": 202602,
        "valor": 17193069.0,
        "delta": -9717571.0
      },
      {
        "periodo": 202603,
        "valor": 20507386.0,
        "delta": 3314317.0
      },
      {
        "periodo": 202604,
        "valor": 16392802.0,
        "delta": -4114584.0
      },
      {
        "periodo": 202605,
        "valor": 18003863.0,
        "delta": 1611061.0
      },
      {
        "periodo": 202606,
        "valor": 16206566.0,
        "delta": -1797297.0
      },
      {
        "periodo": 202607,
        "valor": 19163962.0,
        "delta": 2957396.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 1150840.3499999996,
    "valor_anterior": 1142976.96,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1545644.32,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1516769.98,
        "delta": -28874.34
      },
      {
        "periodo": 202509,
        "valor": 1407432.33,
        "delta": -109337.65
      },
      {
        "periodo": 202510,
        "valor": 1542873.69,
        "delta": 135441.36
      },
      {
        "periodo": 202511,
        "valor": 1238002.25,
        "delta": -304871.44
      },
      {
        "periodo": 202512,
        "valor": 1195773.14,
        "delta": -42229.11
      },
      {
        "periodo": 202601,
        "valor": 945641.84,
        "delta": -250131.3
      },
      {
        "periodo": 202602,
        "valor": 658247.15,
        "delta": -287394.69
      },
      {
        "periodo": 202603,
        "valor": 630830.83,
        "delta": -27416.32
      },
      {
        "periodo": 202604,
        "valor": 1025290.28,
        "delta": 394459.45
      },
      {
        "periodo": 202605,
        "valor": 1191343.98,
        "delta": 166053.7
      },
      {
        "periodo": 202606,
        "valor": 1142976.96,
        "delta": -48367.02
      },
      {
        "periodo": 202607,
        "valor": 1150840.35,
        "delta": 7863.39
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 1746109.0,
    "valor_anterior": 2136078.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1944341.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1916127.0,
        "delta": -28214.0
      },
      {
        "periodo": 202509,
        "valor": 2001017.0,
        "delta": 84890.0
      },
      {
        "periodo": 202510,
        "valor": 2415087.0,
        "delta": 414070.0
      },
      {
        "periodo": 202511,
        "valor": 2633482.0,
        "delta": 218395.0
      },
      {
        "periodo": 202512,
        "valor": 2589913.0,
        "delta": -43569.0
      },
      {
        "periodo": 202601,
        "valor": 2141384.0,
        "delta": -448529.0
      },
      {
        "periodo": 202602,
        "valor": 1981404.0,
        "delta": -159980.0
      },
      {
        "periodo": 202603,
        "valor": 2104785.0,
        "delta": 123381.0
      },
      {
        "periodo": 202604,
        "valor": 2182088.0,
        "delta": 77303.0
      },
      {
        "periodo": 202605,
        "valor": 2099444.0,
        "delta": -82644.0
      },
      {
        "periodo": 202606,
        "valor": 2136078.0,
        "delta": 36634.0
      },
      {
        "periodo": 202607,
        "valor": 1746109.0,
        "delta": -389969.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 17858889.22,
    "valor_anterior": 18335453.11,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17322188.85,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15555749.93,
        "delta": -1766438.92
      },
      {
        "periodo": 202509,
        "valor": 13477597.45,
        "delta": -2078152.48
      },
      {
        "periodo": 202510,
        "valor": 13985959.07,
        "delta": 508361.62
      },
      {
        "periodo": 202511,
        "valor": 13181175.39,
        "delta": -804783.68
      },
      {
        "periodo": 202512,
        "valor": 13688376.99,
        "delta": 507201.6
      },
      {
        "periodo": 202601,
        "valor": 11415411.45,
        "delta": -2272965.54
      },
      {
        "periodo": 202602,
        "valor": 14740658.13,
        "delta": 3325246.68
      },
      {
        "periodo": 202603,
        "valor": 18119032.01,
        "delta": 3378373.88
      },
      {
        "periodo": 202604,
        "valor": 17988286.74,
        "delta": -130745.27
      },
      {
        "periodo": 202605,
        "valor": 17004573.73,
        "delta": -983713.01
      },
      {
        "periodo": 202606,
        "valor": 18335453.11,
        "delta": 1330879.38
      },
      {
        "periodo": 202607,
        "valor": 17858889.22,
        "delta": -476563.89
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 1680335.0,
    "valor_anterior": 1239838.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4035601.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5052818.0,
        "delta": 1017217.0
      },
      {
        "periodo": 202509,
        "valor": 4555265.0,
        "delta": -497553.0
      },
      {
        "periodo": 202510,
        "valor": 6335900.0,
        "delta": 1780635.0
      },
      {
        "periodo": 202511,
        "valor": 5075308.0,
        "delta": -1260592.0
      },
      {
        "periodo": 202512,
        "valor": 3015961.0,
        "delta": -2059347.0
      },
      {
        "periodo": 202601,
        "valor": 4615932.0,
        "delta": 1599971.0
      },
      {
        "periodo": 202602,
        "valor": 2920857.0,
        "delta": -1695075.0
      },
      {
        "periodo": 202603,
        "valor": 3215239.0,
        "delta": 294382.0
      },
      {
        "periodo": 202604,
        "valor": 2983568.0,
        "delta": -231671.0
      },
      {
        "periodo": 202605,
        "valor": 2643385.0,
        "delta": -340183.0
      },
      {
        "periodo": 202606,
        "valor": 1239838.0,
        "delta": -1403547.0
      },
      {
        "periodo": 202607,
        "valor": 1680335.0,
        "delta": 440497.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 172959051.0,
    "valor_anterior": 160415579.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 219047813.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 212895114.0,
        "delta": -6152699.0
      },
      {
        "periodo": 202509,
        "valor": 200883011.0,
        "delta": -12012103.0
      },
      {
        "periodo": 202510,
        "valor": 213607938.0,
        "delta": 12724927.0
      },
      {
        "periodo": 202511,
        "valor": 203601738.0,
        "delta": -10006200.0
      },
      {
        "periodo": 202512,
        "valor": 203787778.0,
        "delta": 186040.0
      },
      {
        "periodo": 202601,
        "valor": 199211372.0,
        "delta": -4576406.0
      },
      {
        "periodo": 202602,
        "valor": 170825377.0,
        "delta": -28385995.0
      },
      {
        "periodo": 202603,
        "valor": 180185482.0,
        "delta": 9360105.0
      },
      {
        "periodo": 202604,
        "valor": 178204288.0,
        "delta": -1981194.0
      },
      {
        "periodo": 202605,
        "valor": 175567159.0,
        "delta": -2637129.0
      },
      {
        "periodo": 202606,
        "valor": 160415579.0,
        "delta": -15151580.0
      },
      {
        "periodo": 202607,
        "valor": 172959051.0,
        "delta": 12543472.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 3029141.0,
    "valor_anterior": 3073362.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2347887.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2942604.0,
        "delta": 594717.0
      },
      {
        "periodo": 202509,
        "valor": 2807327.0,
        "delta": -135277.0
      },
      {
        "periodo": 202510,
        "valor": 3789663.0,
        "delta": 982336.0
      },
      {
        "periodo": 202511,
        "valor": 3691285.0,
        "delta": -98378.0
      },
      {
        "periodo": 202512,
        "valor": 2616320.0,
        "delta": -1074965.0
      },
      {
        "periodo": 202601,
        "valor": 3178041.0,
        "delta": 561721.0
      },
      {
        "periodo": 202602,
        "valor": 3768771.0,
        "delta": 590730.0
      },
      {
        "periodo": 202603,
        "valor": 3649655.0,
        "delta": -119116.0
      },
      {
        "periodo": 202604,
        "valor": 3969088.0,
        "delta": 319433.0
      },
      {
        "periodo": 202605,
        "valor": 4123590.0,
        "delta": 154502.0
      },
      {
        "periodo": 202606,
        "valor": 3073362.0,
        "delta": -1050228.0
      },
      {
        "periodo": 202607,
        "valor": 3029141.0,
        "delta": -44221.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 1184867.7200000007,
    "valor_anterior": 1342918.709999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 135051.75,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 139029.73,
        "delta": 3977.98
      },
      {
        "periodo": 202509,
        "valor": 124546.66,
        "delta": -14483.07
      },
      {
        "periodo": 202510,
        "valor": 150062.82,
        "delta": 25516.16
      },
      {
        "periodo": 202511,
        "valor": 145836.49,
        "delta": -4226.33
      },
      {
        "periodo": 202512,
        "valor": 143200.57,
        "delta": -2635.92
      },
      {
        "periodo": 202601,
        "valor": 152578.91,
        "delta": 9378.34
      },
      {
        "periodo": 202602,
        "valor": 138671.98,
        "delta": -13906.93
      },
      {
        "periodo": 202603,
        "valor": 4200952.91,
        "delta": 4062280.93
      },
      {
        "periodo": 202604,
        "valor": 1591287.64,
        "delta": -2609665.27
      },
      {
        "periodo": 202605,
        "valor": 1225340.8,
        "delta": -365946.84
      },
      {
        "periodo": 202606,
        "valor": 1342918.71,
        "delta": 117577.91
      },
      {
        "periodo": 202607,
        "valor": 1184867.72,
        "delta": -158050.99
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 3098767.0700000003,
    "valor_anterior": 3212566.4000000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1694064.4,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 951250.4,
        "delta": -742814.0
      },
      {
        "periodo": 202509,
        "valor": 687938.08,
        "delta": -263312.32
      },
      {
        "periodo": 202510,
        "valor": 580912.94,
        "delta": -107025.14
      },
      {
        "periodo": 202511,
        "valor": 1348232.5,
        "delta": 767319.56
      },
      {
        "periodo": 202512,
        "valor": 1070562.77,
        "delta": -277669.73
      },
      {
        "periodo": 202601,
        "valor": 1292853.14,
        "delta": 222290.37
      },
      {
        "periodo": 202602,
        "valor": 1052706.49,
        "delta": -240146.65
      },
      {
        "periodo": 202603,
        "valor": 2672872.35,
        "delta": 1620165.86
      },
      {
        "periodo": 202604,
        "valor": 3418231.48,
        "delta": 745359.13
      },
      {
        "periodo": 202605,
        "valor": 3362122.35,
        "delta": -56109.13
      },
      {
        "periodo": 202606,
        "valor": 3212566.4,
        "delta": -149555.95
      },
      {
        "periodo": 202607,
        "valor": 3098767.07,
        "delta": -113799.33
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 7308206.0,
    "valor_anterior": 8218570.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7954844.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10131853.0,
        "delta": 2177009.0
      },
      {
        "periodo": 202509,
        "valor": 11044229.0,
        "delta": 912376.0
      },
      {
        "periodo": 202510,
        "valor": 10259423.0,
        "delta": -784806.0
      },
      {
        "periodo": 202511,
        "valor": 10944372.0,
        "delta": 684949.0
      },
      {
        "periodo": 202512,
        "valor": 11567713.0,
        "delta": 623341.0
      },
      {
        "periodo": 202601,
        "valor": 11017391.0,
        "delta": -550322.0
      },
      {
        "periodo": 202602,
        "valor": 12244236.0,
        "delta": 1226845.0
      },
      {
        "periodo": 202603,
        "valor": 14285813.0,
        "delta": 2041577.0
      },
      {
        "periodo": 202604,
        "valor": 10147115.0,
        "delta": -4138698.0
      },
      {
        "periodo": 202605,
        "valor": 8277353.0,
        "delta": -1869762.0
      },
      {
        "periodo": 202606,
        "valor": 8218570.0,
        "delta": -58783.0
      },
      {
        "periodo": 202607,
        "valor": 7308206.0,
        "delta": -910364.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 36319.27000000002,
    "valor_anterior": 53096.47999999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 85299.94,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 85104.85,
        "delta": -195.09
      },
      {
        "periodo": 202509,
        "valor": 77039.31,
        "delta": -8065.54
      },
      {
        "periodo": 202510,
        "valor": 69970.04,
        "delta": -7069.27
      },
      {
        "periodo": 202511,
        "valor": 64257.69,
        "delta": -5712.35
      },
      {
        "periodo": 202512,
        "valor": 65158.74,
        "delta": 901.05
      },
      {
        "periodo": 202601,
        "valor": 64661.71,
        "delta": -497.03
      },
      {
        "periodo": 202602,
        "valor": 56602.98,
        "delta": -8058.73
      },
      {
        "periodo": 202603,
        "valor": 65539.94,
        "delta": 8936.96
      },
      {
        "periodo": 202604,
        "valor": 55871.61,
        "delta": -9668.33
      },
      {
        "periodo": 202605,
        "valor": 54913.27,
        "delta": -958.34
      },
      {
        "periodo": 202606,
        "valor": 53096.48,
        "delta": -1816.79
      },
      {
        "periodo": 202607,
        "valor": 36319.27,
        "delta": -16777.21
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 1450152.6300000008,
    "valor_anterior": 1413732.0899999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 1916346.33,
        "delta": 1916346.33
      },
      {
        "periodo": 202603,
        "valor": 966844.63,
        "delta": -949501.7
      },
      {
        "periodo": 202604,
        "valor": 1398141.01,
        "delta": 431296.38
      },
      {
        "periodo": 202605,
        "valor": 1495556.54,
        "delta": 97415.53
      },
      {
        "periodo": 202606,
        "valor": 1413732.09,
        "delta": -81824.45
      },
      {
        "periodo": 202607,
        "valor": 1450152.63,
        "delta": 36420.54
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 159559604.0,
    "valor_anterior": 149982758.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17718774.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 37259604.0,
        "delta": 19540830.0
      },
      {
        "periodo": 202509,
        "valor": 56023589.0,
        "delta": 18763985.0
      },
      {
        "periodo": 202510,
        "valor": 80734770.0,
        "delta": 24711181.0
      },
      {
        "periodo": 202511,
        "valor": 98764101.0,
        "delta": 18029331.0
      },
      {
        "periodo": 202512,
        "valor": 129918123.0,
        "delta": 31154022.0
      },
      {
        "periodo": 202601,
        "valor": 147899347.0,
        "delta": 17981224.0
      },
      {
        "periodo": 202602,
        "valor": 135989137.0,
        "delta": -11910210.0
      },
      {
        "periodo": 202603,
        "valor": 149192004.0,
        "delta": 13202867.0
      },
      {
        "periodo": 202604,
        "valor": 140129323.0,
        "delta": -9062681.0
      },
      {
        "periodo": 202605,
        "valor": 149462513.0,
        "delta": 9333190.0
      },
      {
        "periodo": 202606,
        "valor": 149982758.0,
        "delta": 520245.0
      },
      {
        "periodo": 202607,
        "valor": 159559604.0,
        "delta": 9576846.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 63924472.70000002,
    "valor_anterior": 62545607.67999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 486417.62,
        "delta": 486417.62
      },
      {
        "periodo": 202602,
        "valor": 14289378.71,
        "delta": 13802961.09
      },
      {
        "periodo": 202603,
        "valor": 30656135.0,
        "delta": 16366756.29
      },
      {
        "periodo": 202604,
        "valor": 41402152.66,
        "delta": 10746017.66
      },
      {
        "periodo": 202605,
        "valor": 54087141.75,
        "delta": 12684989.09
      },
      {
        "periodo": 202606,
        "valor": 62545607.68,
        "delta": 8458465.93
      },
      {
        "periodo": 202607,
        "valor": 63924472.7,
        "delta": 1378865.02
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 62962467.0,
    "valor_anterior": 47873448.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 2502900.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 26821537.0,
        "delta": 24318637.0
      },
      {
        "periodo": 202605,
        "valor": 40930854.0,
        "delta": 14109317.0
      },
      {
        "periodo": 202606,
        "valor": 47873448.0,
        "delta": 6942594.0
      },
      {
        "periodo": 202607,
        "valor": 62962467.0,
        "delta": 15089019.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 10927572380.410011,
    "valor_anterior": 10532431338.05999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12408811158.08,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11794821099.5,
        "delta": -613990058.58
      },
      {
        "periodo": 202509,
        "valor": 11262954330.22,
        "delta": -531866769.28
      },
      {
        "periodo": 202510,
        "valor": 11419089177.84,
        "delta": 156134847.62
      },
      {
        "periodo": 202511,
        "valor": 10868604965.77,
        "delta": -550484212.07
      },
      {
        "periodo": 202512,
        "valor": 11197507912.14,
        "delta": 328902946.37
      },
      {
        "periodo": 202601,
        "valor": 11022035748.73,
        "delta": -175472163.41
      },
      {
        "periodo": 202602,
        "valor": 9887757249.0,
        "delta": -1134278499.73
      },
      {
        "periodo": 202603,
        "valor": 11265195775.95,
        "delta": 1377438526.95
      },
      {
        "periodo": 202604,
        "valor": 10852298454.0,
        "delta": -412897321.95
      },
      {
        "periodo": 202605,
        "valor": 10819738094.7,
        "delta": -32560359.3
      },
      {
        "periodo": 202606,
        "valor": 10532431338.06,
        "delta": -287306756.64
      },
      {
        "periodo": 202607,
        "valor": 10927572380.41,
        "delta": 395141042.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 7944593731.359993,
    "valor_anterior": 7654168946.230003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9485380138.55,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8948479616.72,
        "delta": -536900521.83
      },
      {
        "periodo": 202509,
        "valor": 8492839846.64,
        "delta": -455639770.08
      },
      {
        "periodo": 202510,
        "valor": 8511935450.54,
        "delta": 19095603.9
      },
      {
        "periodo": 202511,
        "valor": 8071576441.6,
        "delta": -440359008.94
      },
      {
        "periodo": 202512,
        "valor": 8222740926.3,
        "delta": 151164484.7
      },
      {
        "periodo": 202601,
        "valor": 8087458005.12,
        "delta": -135282921.18
      },
      {
        "periodo": 202602,
        "valor": 7280922144.91,
        "delta": -806535860.21
      },
      {
        "periodo": 202603,
        "valor": 8273664490.43,
        "delta": 992742345.52
      },
      {
        "periodo": 202604,
        "valor": 7927803479.47,
        "delta": -345861010.96
      },
      {
        "periodo": 202605,
        "valor": 7895337654.75,
        "delta": -32465824.72
      },
      {
        "periodo": 202606,
        "valor": 7654168946.23,
        "delta": -241168708.52
      },
      {
        "periodo": 202607,
        "valor": 7944593731.36,
        "delta": 290424785.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 20859791.060000002,
    "valor_anterior": 21780124.930000007,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 32748154.57,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 34180729.42,
        "delta": 1432574.85
      },
      {
        "periodo": 202509,
        "valor": -1744744.05,
        "delta": -35925473.47
      },
      {
        "periodo": 202510,
        "valor": 26834730.32,
        "delta": 28579474.37
      },
      {
        "periodo": 202511,
        "valor": 24546497.18,
        "delta": -2288233.14
      },
      {
        "periodo": 202512,
        "valor": 25850531.13,
        "delta": 1304033.95
      },
      {
        "periodo": 202601,
        "valor": 23455135.87,
        "delta": -2395395.26
      },
      {
        "periodo": 202602,
        "valor": 20915431.43,
        "delta": -2539704.44
      },
      {
        "periodo": 202603,
        "valor": 23800850.96,
        "delta": 2885419.53
      },
      {
        "periodo": 202604,
        "valor": 23607958.64,
        "delta": -192892.32
      },
      {
        "periodo": 202605,
        "valor": 23529977.07,
        "delta": -77981.57
      },
      {
        "periodo": 202606,
        "valor": 21780124.93,
        "delta": -1749852.14
      },
      {
        "periodo": 202607,
        "valor": 20859791.06,
        "delta": -920333.87
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 948650176.3199997,
    "valor_anterior": 928305642.4400005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1090609360.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 973072329.13,
        "delta": -117537031.13
      },
      {
        "periodo": 202509,
        "valor": 972102966.41,
        "delta": -969362.72
      },
      {
        "periodo": 202510,
        "valor": 998340037.5,
        "delta": 26237071.09
      },
      {
        "periodo": 202511,
        "valor": 956234875.61,
        "delta": -42105161.89
      },
      {
        "periodo": 202512,
        "valor": 1028082023.04,
        "delta": 71847147.43
      },
      {
        "periodo": 202601,
        "valor": 1034827097.27,
        "delta": 6745074.23
      },
      {
        "periodo": 202602,
        "valor": 884479406.18,
        "delta": -150347691.09
      },
      {
        "periodo": 202603,
        "valor": 1101447544.74,
        "delta": 216968138.56
      },
      {
        "periodo": 202604,
        "valor": 1027640069.99,
        "delta": -73807474.75
      },
      {
        "periodo": 202605,
        "valor": 957555639.97,
        "delta": -70084430.02
      },
      {
        "periodo": 202606,
        "valor": 928305642.44,
        "delta": -29249997.53
      },
      {
        "periodo": 202607,
        "valor": 948650176.32,
        "delta": 20344533.88
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 1204036234.3899994,
    "valor_anterior": 1164996905.12,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1203060227.18,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1232869618.49,
        "delta": 29809391.31
      },
      {
        "periodo": 202509,
        "valor": 1185226419.45,
        "delta": -47643199.04
      },
      {
        "periodo": 202510,
        "valor": 1220046901.33,
        "delta": 34820481.88
      },
      {
        "periodo": 202511,
        "valor": 1153934382.59,
        "delta": -66112518.74
      },
      {
        "periodo": 202512,
        "valor": 1137596643.01,
        "delta": -16337739.58
      },
      {
        "periodo": 202601,
        "valor": 1115855846.59,
        "delta": -21740796.42
      },
      {
        "periodo": 202602,
        "valor": 1042709410.3,
        "delta": -73146436.29
      },
      {
        "periodo": 202603,
        "valor": 1136823660.14,
        "delta": 94114249.84
      },
      {
        "periodo": 202604,
        "valor": 1150442160.71,
        "delta": 13618500.57
      },
      {
        "periodo": 202605,
        "valor": 1180952529.61,
        "delta": 30510368.9
      },
      {
        "periodo": 202606,
        "valor": 1164996905.12,
        "delta": -15955624.49
      },
      {
        "periodo": 202607,
        "valor": 1204036234.39,
        "delta": 39039329.27
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 107468437.36000001,
    "valor_anterior": 103216691.17999995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 103551265.78,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 116886800.5,
        "delta": 13335534.72
      },
      {
        "periodo": 202509,
        "valor": 130696676.27,
        "delta": 13809875.77
      },
      {
        "periodo": 202510,
        "valor": 137910441.52,
        "delta": 7213765.25
      },
      {
        "periodo": 202511,
        "valor": 133624725.63,
        "delta": -4285715.89
      },
      {
        "periodo": 202512,
        "valor": 195962626.47,
        "delta": 62337900.84
      },
      {
        "periodo": 202601,
        "valor": 157075877.34,
        "delta": -38886749.13
      },
      {
        "periodo": 202602,
        "valor": 109834423.75,
        "delta": -47241453.59
      },
      {
        "periodo": 202603,
        "valor": 124161549.1,
        "delta": 14327125.35
      },
      {
        "periodo": 202604,
        "valor": 113254488.14,
        "delta": -10907060.96
      },
      {
        "periodo": 202605,
        "valor": 108931718.86,
        "delta": -4322769.28
      },
      {
        "periodo": 202606,
        "valor": 103216691.18,
        "delta": -5715027.68
      },
      {
        "periodo": 202607,
        "valor": 107468437.36,
        "delta": 4251746.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100118,
    "label": "Intereses por D.E.I.",
    "valor_actual": 701964009.9200001,
    "valor_anterior": 659963028.1599998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 493462011.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 489332005.24,
        "delta": -4130006.5
      },
      {
        "periodo": 202509,
        "valor": 483833165.5,
        "delta": -5498839.74
      },
      {
        "periodo": 202510,
        "valor": 524021616.63,
        "delta": 40188451.13
      },
      {
        "periodo": 202511,
        "valor": 528688043.16,
        "delta": 4666426.53
      },
      {
        "periodo": 202512,
        "valor": 587275162.19,
        "delta": 58587119.03
      },
      {
        "periodo": 202601,
        "valor": 603363786.54,
        "delta": 16088624.35
      },
      {
        "periodo": 202602,
        "valor": 548896432.43,
        "delta": -54467354.11
      },
      {
        "periodo": 202603,
        "valor": 605297680.58,
        "delta": 56401248.15
      },
      {
        "periodo": 202604,
        "valor": 609550297.05,
        "delta": 4252616.47
      },
      {
        "periodo": 202605,
        "valor": 653430574.44,
        "delta": 43880277.39
      },
      {
        "periodo": 202606,
        "valor": 659963028.16,
        "delta": 6532453.72
      },
      {
        "periodo": 202607,
        "valor": 701964009.92,
        "delta": 42000981.76
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 874820942.4200001,
    "valor_anterior": 836530329.6499996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 932527083.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 913433499.2,
        "delta": -19093584.06
      },
      {
        "periodo": 202509,
        "valor": 841882936.91,
        "delta": -71550562.29
      },
      {
        "periodo": 202510,
        "valor": 870723657.32,
        "delta": 28840720.41
      },
      {
        "periodo": 202511,
        "valor": 882113350.61,
        "delta": 11389693.29
      },
      {
        "periodo": 202512,
        "valor": 948145409.94,
        "delta": 66032059.33
      },
      {
        "periodo": 202601,
        "valor": 913902226.94,
        "delta": -34243183.0
      },
      {
        "periodo": 202602,
        "valor": 848487464.8,
        "delta": -65414762.14
      },
      {
        "periodo": 202603,
        "valor": 864029392.57,
        "delta": 15541927.77
      },
      {
        "periodo": 202604,
        "valor": 841630583.84,
        "delta": -22398808.73
      },
      {
        "periodo": 202605,
        "valor": 900996496.07,
        "delta": 59365912.23
      },
      {
        "periodo": 202606,
        "valor": 836530329.65,
        "delta": -64466166.42
      },
      {
        "periodo": 202607,
        "valor": 874820942.42,
        "delta": 38290612.77
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 1740818495.25,
    "valor_anterior": 1684179663.6000013,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1886927362.52,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1891909672.43,
        "delta": 4982309.91
      },
      {
        "periodo": 202509,
        "valor": 1819538468.66,
        "delta": -72371203.77
      },
      {
        "periodo": 202510,
        "valor": 1819604704.7,
        "delta": 66236.04
      },
      {
        "periodo": 202511,
        "valor": 1730594217.38,
        "delta": -89010487.32
      },
      {
        "periodo": 202512,
        "valor": 1760276911.67,
        "delta": 29682694.29
      },
      {
        "periodo": 202601,
        "valor": 1698054571.51,
        "delta": -62222340.16
      },
      {
        "periodo": 202602,
        "valor": 1548331919.53,
        "delta": -149722651.98
      },
      {
        "periodo": 202603,
        "valor": 1751027715.19,
        "delta": 202695795.66
      },
      {
        "periodo": 202604,
        "valor": 1722980773.31,
        "delta": -28046941.88
      },
      {
        "periodo": 202605,
        "valor": 1767516478.65,
        "delta": 44535705.34
      },
      {
        "periodo": 202606,
        "valor": 1684179663.6,
        "delta": -83336815.05
      },
      {
        "periodo": 202607,
        "valor": 1740818495.25,
        "delta": 56638831.65
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 1665776793.000002,
    "valor_anterior": 1632151338.999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2062698294.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2028666502.0,
        "delta": -34031792.0
      },
      {
        "periodo": 202509,
        "valor": 1890826528.0,
        "delta": -137839974.0
      },
      {
        "periodo": 202510,
        "valor": 1866245981.0,
        "delta": -24580547.0
      },
      {
        "periodo": 202511,
        "valor": 1726334755.0,
        "delta": -139911226.0
      },
      {
        "periodo": 202512,
        "valor": 1798662068.0,
        "delta": 72327313.0
      },
      {
        "periodo": 202601,
        "valor": 1753622851.0,
        "delta": -45039217.0
      },
      {
        "periodo": 202602,
        "valor": 1574656625.0,
        "delta": -178966226.0
      },
      {
        "periodo": 202603,
        "valor": 1804205263.0,
        "delta": 229548638.0
      },
      {
        "periodo": 202604,
        "valor": 1739577133.0,
        "delta": -64628130.0
      },
      {
        "periodo": 202605,
        "valor": 1739349759.0,
        "delta": -227374.0
      },
      {
        "periodo": 202606,
        "valor": 1632151339.0,
        "delta": -107198420.0
      },
      {
        "periodo": 202607,
        "valor": 1665776793.0,
        "delta": 33625454.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 686507579.999999,
    "valor_anterior": 637558381.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 929487256.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 888454815.0,
        "delta": -41032441.0
      },
      {
        "periodo": 202509,
        "valor": 842183922.0,
        "delta": -46270893.0
      },
      {
        "periodo": 202510,
        "valor": 912281118.0,
        "delta": 70097196.0
      },
      {
        "periodo": 202511,
        "valor": 838036626.0,
        "delta": -74244492.0
      },
      {
        "periodo": 202512,
        "valor": 799539976.0,
        "delta": -38496650.0
      },
      {
        "periodo": 202601,
        "valor": 870094844.0,
        "delta": 70554868.0
      },
      {
        "periodo": 202602,
        "valor": 538137428.0,
        "delta": -331957416.0
      },
      {
        "periodo": 202603,
        "valor": 702643119.0,
        "delta": 164505691.0
      },
      {
        "periodo": 202604,
        "valor": 660343822.0,
        "delta": -42299297.0
      },
      {
        "periodo": 202605,
        "valor": 689631791.0,
        "delta": 29287969.0
      },
      {
        "periodo": 202606,
        "valor": 637558381.0,
        "delta": -52073410.0
      },
      {
        "periodo": 202607,
        "valor": 686507580.0,
        "delta": 48949199.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 701758341.0999999,
    "valor_anterior": 657845136.1100001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 773870395.97,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 755215474.04,
        "delta": -18654921.93
      },
      {
        "periodo": 202509,
        "valor": 734721225.07,
        "delta": -20494248.97
      },
      {
        "periodo": 202510,
        "valor": 735518478.07,
        "delta": 797253.0
      },
      {
        "periodo": 202511,
        "valor": 691620462.25,
        "delta": -43898015.82
      },
      {
        "periodo": 202512,
        "valor": 697010898.77,
        "delta": 5390436.52
      },
      {
        "periodo": 202601,
        "valor": 698615755.24,
        "delta": 1604856.47
      },
      {
        "periodo": 202602,
        "valor": 618732029.1,
        "delta": -79883726.14
      },
      {
        "periodo": 202603,
        "valor": 711747456.79,
        "delta": 93015427.69
      },
      {
        "periodo": 202604,
        "valor": 675674353.01,
        "delta": -36073103.78
      },
      {
        "periodo": 202605,
        "valor": 682102015.35,
        "delta": 6427662.34
      },
      {
        "periodo": 202606,
        "valor": 657845136.11,
        "delta": -24256879.24
      },
      {
        "periodo": 202607,
        "valor": 701758341.1,
        "delta": 43913204.99
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 320360602.0,
    "valor_anterior": 313900184.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 385636829.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 381830665.0,
        "delta": -3806164.0
      },
      {
        "periodo": 202509,
        "valor": 351995007.0,
        "delta": -29835658.0
      },
      {
        "periodo": 202510,
        "valor": 359242850.0,
        "delta": 7247843.0
      },
      {
        "periodo": 202511,
        "valor": 339908609.0,
        "delta": -19334241.0
      },
      {
        "periodo": 202512,
        "valor": 345413616.0,
        "delta": 5505007.0
      },
      {
        "periodo": 202601,
        "valor": 340940100.0,
        "delta": -4473516.0
      },
      {
        "periodo": 202602,
        "valor": 306679706.0,
        "delta": -34260394.0
      },
      {
        "periodo": 202603,
        "valor": 336100929.0,
        "delta": 29421223.0
      },
      {
        "periodo": 202604,
        "valor": 324283635.0,
        "delta": -11817294.0
      },
      {
        "periodo": 202605,
        "valor": 331673873.0,
        "delta": 7390238.0
      },
      {
        "periodo": 202606,
        "valor": 313900184.0,
        "delta": -17773689.0
      },
      {
        "periodo": 202607,
        "valor": 320360602.0,
        "delta": 6460418.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 257163046.0,
    "valor_anterior": 253361852.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 348127165.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 333724288.0,
        "delta": -14402877.0
      },
      {
        "periodo": 202509,
        "valor": 307959294.0,
        "delta": -25764994.0
      },
      {
        "periodo": 202510,
        "valor": 312391095.0,
        "delta": 4431801.0
      },
      {
        "periodo": 202511,
        "valor": 295764541.0,
        "delta": -16626554.0
      },
      {
        "periodo": 202512,
        "valor": 295353679.0,
        "delta": -410862.0
      },
      {
        "periodo": 202601,
        "valor": 304323493.0,
        "delta": 8969814.0
      },
      {
        "periodo": 202602,
        "valor": 259423792.0,
        "delta": -44899701.0
      },
      {
        "periodo": 202603,
        "valor": 277829769.0,
        "delta": 18405977.0
      },
      {
        "periodo": 202604,
        "valor": 268136664.0,
        "delta": -9693105.0
      },
      {
        "periodo": 202605,
        "valor": 271593755.0,
        "delta": 3457091.0
      },
      {
        "periodo": 202606,
        "valor": 253361852.0,
        "delta": -18231903.0
      },
      {
        "periodo": 202607,
        "valor": 257163046.0,
        "delta": 3801194.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 1212436834.999999,
    "valor_anterior": 1188017325.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1412525036.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1385636538.0,
        "delta": -26888498.0
      },
      {
        "periodo": 202509,
        "valor": 1313044601.0,
        "delta": -72591937.0
      },
      {
        "periodo": 202510,
        "valor": 1349283265.0,
        "delta": 36238664.0
      },
      {
        "periodo": 202511,
        "valor": 1254780073.0,
        "delta": -94503192.0
      },
      {
        "periodo": 202512,
        "valor": 1264897204.0,
        "delta": 10117131.0
      },
      {
        "periodo": 202601,
        "valor": 1239353098.0,
        "delta": -25544106.0
      },
      {
        "periodo": 202602,
        "valor": 1128601259.0,
        "delta": -110751839.0
      },
      {
        "periodo": 202603,
        "valor": 1226091546.0,
        "delta": 97490287.0
      },
      {
        "periodo": 202604,
        "valor": 1144268107.0,
        "delta": -81823439.0
      },
      {
        "periodo": 202605,
        "valor": 1185844152.0,
        "delta": 41576045.0
      },
      {
        "periodo": 202606,
        "valor": 1188017325.0,
        "delta": 2173173.0
      },
      {
        "periodo": 202607,
        "valor": 1212436835.0,
        "delta": 24419510.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 478042532.05999994,
    "valor_anterior": 504480054.48,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 617374164.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 598190212.92,
        "delta": -19183951.61
      },
      {
        "periodo": 202509,
        "valor": 575212078.19,
        "delta": -22978134.73
      },
      {
        "periodo": 202510,
        "valor": 580021918.95,
        "delta": 4809840.76
      },
      {
        "periodo": 202511,
        "valor": 522268941.7,
        "delta": -57752977.25
      },
      {
        "periodo": 202512,
        "valor": 566035585.51,
        "delta": 43766643.81
      },
      {
        "periodo": 202601,
        "valor": 554897382.37,
        "delta": -11138203.14
      },
      {
        "periodo": 202602,
        "valor": 484492916.51,
        "delta": -70404465.86
      },
      {
        "periodo": 202603,
        "valor": 566016008.08,
        "delta": 81523091.57
      },
      {
        "periodo": 202604,
        "valor": 516240010.13,
        "delta": -49775997.95
      },
      {
        "periodo": 202605,
        "valor": 528221643.29,
        "delta": 11981633.16
      },
      {
        "periodo": 202606,
        "valor": 504480054.48,
        "delta": -23741588.81
      },
      {
        "periodo": 202607,
        "valor": 478042532.06,
        "delta": -26437522.42
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 217399950.0,
    "valor_anterior": 222917767.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 321878087.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 330586007.0,
        "delta": 8707920.0
      },
      {
        "periodo": 202509,
        "valor": 296470987.0,
        "delta": -34115020.0
      },
      {
        "periodo": 202510,
        "valor": 308419957.0,
        "delta": 11948970.0
      },
      {
        "periodo": 202511,
        "valor": 255374066.0,
        "delta": -53045891.0
      },
      {
        "periodo": 202512,
        "valor": 265550615.0,
        "delta": 10176549.0
      },
      {
        "periodo": 202601,
        "valor": 282217222.0,
        "delta": 16666607.0
      },
      {
        "periodo": 202602,
        "valor": 268072454.0,
        "delta": -14144768.0
      },
      {
        "periodo": 202603,
        "valor": 296873768.0,
        "delta": 28801314.0
      },
      {
        "periodo": 202604,
        "valor": 293884303.0,
        "delta": -2989465.0
      },
      {
        "periodo": 202605,
        "valor": 281748646.0,
        "delta": -12135657.0
      },
      {
        "periodo": 202606,
        "valor": 222917767.0,
        "delta": -58830879.0
      },
      {
        "periodo": 202607,
        "valor": 217399950.0,
        "delta": -5517817.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 131084221.0,
    "valor_anterior": 132105342.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 195219966.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 184341509.0,
        "delta": -10878457.0
      },
      {
        "periodo": 202509,
        "valor": 175157848.0,
        "delta": -9183661.0
      },
      {
        "periodo": 202510,
        "valor": 177558690.0,
        "delta": 2400842.0
      },
      {
        "periodo": 202511,
        "valor": 166945866.0,
        "delta": -10612824.0
      },
      {
        "periodo": 202512,
        "valor": 104244826.0,
        "delta": -62701040.0
      },
      {
        "periodo": 202601,
        "valor": 157504987.0,
        "delta": 53260161.0
      },
      {
        "periodo": 202602,
        "valor": 139614835.0,
        "delta": -17890152.0
      },
      {
        "periodo": 202603,
        "valor": 150083783.0,
        "delta": 10468948.0
      },
      {
        "periodo": 202604,
        "valor": 139285880.0,
        "delta": -10797903.0
      },
      {
        "periodo": 202605,
        "valor": 139796586.0,
        "delta": 510706.0
      },
      {
        "periodo": 202606,
        "valor": 132105342.0,
        "delta": -7691244.0
      },
      {
        "periodo": 202607,
        "valor": 131084221.0,
        "delta": -1021121.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 203709084.0,
    "valor_anterior": 200198735.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 239747079.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 231387101.0,
        "delta": -8359978.0
      },
      {
        "periodo": 202509,
        "valor": 229448391.0,
        "delta": -1938710.0
      },
      {
        "periodo": 202510,
        "valor": 237611116.0,
        "delta": 8162725.0
      },
      {
        "periodo": 202511,
        "valor": 218565314.0,
        "delta": -19045802.0
      },
      {
        "periodo": 202512,
        "valor": 221145977.0,
        "delta": 2580663.0
      },
      {
        "periodo": 202601,
        "valor": 232255048.0,
        "delta": 11109071.0
      },
      {
        "periodo": 202602,
        "valor": 214652436.0,
        "delta": -17602612.0
      },
      {
        "periodo": 202603,
        "valor": 225163267.0,
        "delta": 10510831.0
      },
      {
        "periodo": 202604,
        "valor": 209566482.0,
        "delta": -15596785.0
      },
      {
        "periodo": 202605,
        "valor": 209468800.0,
        "delta": -97682.0
      },
      {
        "periodo": 202606,
        "valor": 200198735.0,
        "delta": -9270065.0
      },
      {
        "periodo": 202607,
        "valor": 203709084.0,
        "delta": 3510349.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 1690339564.5300007,
    "valor_anterior": 1709680319.9699993,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1979189894.16,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1912728379.88,
        "delta": -66461514.28
      },
      {
        "periodo": 202509,
        "valor": 1804632330.03,
        "delta": -108096049.85
      },
      {
        "periodo": 202510,
        "valor": 1878762821.84,
        "delta": 74130491.81
      },
      {
        "periodo": 202511,
        "valor": 1811873206.09,
        "delta": -66889615.75
      },
      {
        "periodo": 202512,
        "valor": 1873435146.01,
        "delta": 61561939.92
      },
      {
        "periodo": 202601,
        "valor": 1882300227.6,
        "delta": 8865081.59
      },
      {
        "periodo": 202602,
        "valor": 1671830883.22,
        "delta": -210469344.38
      },
      {
        "periodo": 202603,
        "valor": 1824474457.73,
        "delta": 152643574.51
      },
      {
        "periodo": 202604,
        "valor": 1756642335.02,
        "delta": -67832122.71
      },
      {
        "periodo": 202605,
        "valor": 1785826961.68,
        "delta": 29184626.66
      },
      {
        "periodo": 202606,
        "valor": 1709680319.97,
        "delta": -76146641.71
      },
      {
        "periodo": 202607,
        "valor": 1690339564.53,
        "delta": -19340755.44
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 64011989.0,
    "valor_anterior": 116807151.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 459479149.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 577356631.0,
        "delta": 117877482.0
      },
      {
        "periodo": 202509,
        "valor": 357474012.0,
        "delta": -219882619.0
      },
      {
        "periodo": 202510,
        "valor": 527251931.0,
        "delta": 169777919.0
      },
      {
        "periodo": 202511,
        "valor": 524689829.0,
        "delta": -2562102.0
      },
      {
        "periodo": 202512,
        "valor": 387033558.0,
        "delta": -137656271.0
      },
      {
        "periodo": 202601,
        "valor": 292532548.0,
        "delta": -94501010.0
      },
      {
        "periodo": 202602,
        "valor": 300079730.0,
        "delta": 7547182.0
      },
      {
        "periodo": 202603,
        "valor": 134889920.0,
        "delta": -165189810.0
      },
      {
        "periodo": 202604,
        "valor": 110590427.0,
        "delta": -24299493.0
      },
      {
        "periodo": 202605,
        "valor": 126885172.0,
        "delta": 16294745.0
      },
      {
        "periodo": 202606,
        "valor": 116807151.0,
        "delta": -10078021.0
      },
      {
        "periodo": 202607,
        "valor": 64011989.0,
        "delta": -52795162.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 47046729.0,
    "valor_anterior": 51240972.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 52517151.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55107448.0,
        "delta": 2590297.0
      },
      {
        "periodo": 202509,
        "valor": 55131592.0,
        "delta": 24144.0
      },
      {
        "periodo": 202510,
        "valor": 60105385.0,
        "delta": 4973793.0
      },
      {
        "periodo": 202511,
        "valor": 55942730.0,
        "delta": -4162655.0
      },
      {
        "periodo": 202512,
        "valor": 53366219.0,
        "delta": -2576511.0
      },
      {
        "periodo": 202601,
        "valor": 55004357.0,
        "delta": 1638138.0
      },
      {
        "periodo": 202602,
        "valor": 50166060.0,
        "delta": -4838297.0
      },
      {
        "periodo": 202603,
        "valor": 52851024.0,
        "delta": 2684964.0
      },
      {
        "periodo": 202604,
        "valor": 51578030.0,
        "delta": -1272994.0
      },
      {
        "periodo": 202605,
        "valor": 52297314.0,
        "delta": 719284.0
      },
      {
        "periodo": 202606,
        "valor": 51240972.0,
        "delta": -1056342.0
      },
      {
        "periodo": 202607,
        "valor": 47046729.0,
        "delta": -4194243.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17225104.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 32756298.0,
        "delta": 15531194.0
      },
      {
        "periodo": 202509,
        "valor": 25938544.0,
        "delta": -6817754.0
      },
      {
        "periodo": 202510,
        "valor": 18557528.0,
        "delta": -7381016.0
      },
      {
        "periodo": 202511,
        "valor": 29154362.0,
        "delta": 10596834.0
      },
      {
        "periodo": 202512,
        "valor": 24517914.0,
        "delta": -4636448.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -24517914.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 236946511.56000018,
    "valor_anterior": 188050884.3499999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 206817946.13,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 180720429.34,
        "delta": -26097516.79
      },
      {
        "periodo": 202509,
        "valor": 183760881.68,
        "delta": 3040452.34
      },
      {
        "periodo": 202510,
        "valor": 167724190.38,
        "delta": -16036691.3
      },
      {
        "periodo": 202511,
        "valor": 176793760.12,
        "delta": 9069569.74
      },
      {
        "periodo": 202512,
        "valor": 212188192.26,
        "delta": 35394432.14
      },
      {
        "periodo": 202601,
        "valor": 245263026.83,
        "delta": 33074834.57
      },
      {
        "periodo": 202602,
        "valor": 207746833.42,
        "delta": -37516193.41
      },
      {
        "periodo": 202603,
        "valor": 222874354.57,
        "delta": 15127521.15
      },
      {
        "periodo": 202604,
        "valor": 226696387.72,
        "delta": 3822033.15
      },
      {
        "periodo": 202605,
        "valor": 216572411.71,
        "delta": -10123976.01
      },
      {
        "periodo": 202606,
        "valor": 188050884.35,
        "delta": -28521527.36
      },
      {
        "periodo": 202607,
        "valor": 236946511.56,
        "delta": 48895627.21
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 162782046.0,
    "valor_anterior": 158150496.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 137330892.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 131541154.0,
        "delta": -5789738.0
      },
      {
        "periodo": 202509,
        "valor": 137329657.0,
        "delta": 5788503.0
      },
      {
        "periodo": 202510,
        "valor": 150990354.0,
        "delta": 13660697.0
      },
      {
        "periodo": 202511,
        "valor": 149078257.0,
        "delta": -1912097.0
      },
      {
        "periodo": 202512,
        "valor": 161396760.0,
        "delta": 12318503.0
      },
      {
        "periodo": 202601,
        "valor": 171490053.0,
        "delta": 10093293.0
      },
      {
        "periodo": 202602,
        "valor": 149651427.0,
        "delta": -21838626.0
      },
      {
        "periodo": 202603,
        "valor": 162181471.0,
        "delta": 12530044.0
      },
      {
        "periodo": 202604,
        "valor": 161442537.0,
        "delta": -738934.0
      },
      {
        "periodo": 202605,
        "valor": 164935722.0,
        "delta": 3493185.0
      },
      {
        "periodo": 202606,
        "valor": 158150496.0,
        "delta": -6785226.0
      },
      {
        "periodo": 202607,
        "valor": 162782046.0,
        "delta": 4631550.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 321038624.75999975,
    "valor_anterior": 335584113.99000025,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 512763618.4,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 385976876.0,
        "delta": -126786742.4
      },
      {
        "periodo": 202509,
        "valor": 417745989.92,
        "delta": 31769113.92
      },
      {
        "periodo": 202510,
        "valor": 445008809.82,
        "delta": 27262819.9
      },
      {
        "periodo": 202511,
        "valor": 380287636.81,
        "delta": -64721173.01
      },
      {
        "periodo": 202512,
        "valor": 386737645.23,
        "delta": 6450008.42
      },
      {
        "periodo": 202601,
        "valor": 404253045.9,
        "delta": 17515400.67
      },
      {
        "periodo": 202602,
        "valor": 444682751.19,
        "delta": 40429705.29
      },
      {
        "periodo": 202603,
        "valor": 368813611.25,
        "delta": -75869139.94
      },
      {
        "periodo": 202604,
        "valor": 344359858.38,
        "delta": -24453752.87
      },
      {
        "periodo": 202605,
        "valor": 358565760.61,
        "delta": 14205902.23
      },
      {
        "periodo": 202606,
        "valor": 335584113.99,
        "delta": -22981646.62
      },
      {
        "periodo": 202607,
        "valor": 321038624.76,
        "delta": -14545489.23
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 256867034.4500003,
    "valor_anterior": 242534760.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 347468707.1,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 340872002.98,
        "delta": -6596704.12
      },
      {
        "periodo": 202509,
        "valor": 314804406.77,
        "delta": -26067596.21
      },
      {
        "periodo": 202510,
        "valor": 313568062.72,
        "delta": -1236344.05
      },
      {
        "periodo": 202511,
        "valor": 297252522.49,
        "delta": -16315540.23
      },
      {
        "periodo": 202512,
        "valor": 306823498.0,
        "delta": 9570975.51
      },
      {
        "periodo": 202601,
        "valor": 306364497.55,
        "delta": -459000.45
      },
      {
        "periodo": 202602,
        "valor": 275465587.57,
        "delta": -30898909.98
      },
      {
        "periodo": 202603,
        "valor": 288348720.8,
        "delta": 12883133.23
      },
      {
        "periodo": 202604,
        "valor": 259703563.58,
        "delta": -28645157.22
      },
      {
        "periodo": 202605,
        "valor": 251263285.75,
        "delta": -8440277.83
      },
      {
        "periodo": 202606,
        "valor": 242534760.0,
        "delta": -8728525.75
      },
      {
        "periodo": 202607,
        "valor": 256867034.45,
        "delta": 14332274.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 241931551.0,
    "valor_anterior": 217788020.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 112927023.92,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 116965972.32,
        "delta": 4038948.4
      },
      {
        "periodo": 202509,
        "valor": 181277997.58,
        "delta": 64312025.26
      },
      {
        "periodo": 202510,
        "valor": 193938678.0,
        "delta": 12660680.42
      },
      {
        "periodo": 202511,
        "valor": 190156409.0,
        "delta": -3782269.0
      },
      {
        "periodo": 202512,
        "valor": 207006157.0,
        "delta": 16849748.0
      },
      {
        "periodo": 202601,
        "valor": 218600826.0,
        "delta": 11594669.0
      },
      {
        "periodo": 202602,
        "valor": 190802140.0,
        "delta": -27798686.0
      },
      {
        "periodo": 202603,
        "valor": 224957943.0,
        "delta": 34155803.0
      },
      {
        "periodo": 202604,
        "valor": 234400276.0,
        "delta": 9442333.0
      },
      {
        "periodo": 202605,
        "valor": 220735169.0,
        "delta": -13665107.0
      },
      {
        "periodo": 202606,
        "valor": 217788020.0,
        "delta": -2947149.0
      },
      {
        "periodo": 202607,
        "valor": 241931551.0,
        "delta": 24143531.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 14597348.0,
    "valor_anterior": 15675161.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17535741.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16288093.0,
        "delta": -1247648.0
      },
      {
        "periodo": 202509,
        "valor": 17344264.0,
        "delta": 1056171.0
      },
      {
        "periodo": 202510,
        "valor": 16480963.0,
        "delta": -863301.0
      },
      {
        "periodo": 202511,
        "valor": 13219741.0,
        "delta": -3261222.0
      },
      {
        "periodo": 202512,
        "valor": 17326000.0,
        "delta": 4106259.0
      },
      {
        "periodo": 202601,
        "valor": 15062641.0,
        "delta": -2263359.0
      },
      {
        "periodo": 202602,
        "valor": 14205904.0,
        "delta": -856737.0
      },
      {
        "periodo": 202603,
        "valor": 15832091.0,
        "delta": 1626187.0
      },
      {
        "periodo": 202604,
        "valor": 14776102.0,
        "delta": -1055989.0
      },
      {
        "periodo": 202605,
        "valor": 13453741.0,
        "delta": -1322361.0
      },
      {
        "periodo": 202606,
        "valor": 15675161.0,
        "delta": 2221420.0
      },
      {
        "periodo": 202607,
        "valor": 14597348.0,
        "delta": -1077813.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 324251164.0,
    "valor_anterior": 309910439.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 321519903.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 311074772.0,
        "delta": -10445131.0
      },
      {
        "periodo": 202509,
        "valor": 329168088.0,
        "delta": 18093316.0
      },
      {
        "periodo": 202510,
        "valor": 340034025.0,
        "delta": 10865937.0
      },
      {
        "periodo": 202511,
        "valor": 314414752.0,
        "delta": -25619273.0
      },
      {
        "periodo": 202512,
        "valor": 310967054.0,
        "delta": -3447698.0
      },
      {
        "periodo": 202601,
        "valor": 314599069.0,
        "delta": 3632015.0
      },
      {
        "periodo": 202602,
        "valor": 300941414.0,
        "delta": -13657655.0
      },
      {
        "periodo": 202603,
        "valor": 370150343.0,
        "delta": 69208929.0
      },
      {
        "periodo": 202604,
        "valor": 371257604.0,
        "delta": 1107261.0
      },
      {
        "periodo": 202605,
        "valor": 365770153.0,
        "delta": -5487451.0
      },
      {
        "periodo": 202606,
        "valor": 309910439.0,
        "delta": -55859714.0
      },
      {
        "periodo": 202607,
        "valor": 324251164.0,
        "delta": 14340725.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 115182478.0,
    "valor_anterior": 112857478.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 117885620.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 131837665.0,
        "delta": 13952045.0
      },
      {
        "periodo": 202509,
        "valor": 128841285.0,
        "delta": -2996380.0
      },
      {
        "periodo": 202510,
        "valor": 131502866.0,
        "delta": 2661581.0
      },
      {
        "periodo": 202511,
        "valor": 122701569.0,
        "delta": -8801297.0
      },
      {
        "periodo": 202512,
        "valor": 118491055.0,
        "delta": -4210514.0
      },
      {
        "periodo": 202601,
        "valor": 102381301.0,
        "delta": -16109754.0
      },
      {
        "periodo": 202602,
        "valor": 83797203.0,
        "delta": -18584098.0
      },
      {
        "periodo": 202603,
        "valor": 93884887.0,
        "delta": 10087684.0
      },
      {
        "periodo": 202604,
        "valor": 90540951.0,
        "delta": -3343936.0
      },
      {
        "periodo": 202605,
        "valor": 103424680.0,
        "delta": 12883729.0
      },
      {
        "periodo": 202606,
        "valor": 112857478.0,
        "delta": 9432798.0
      },
      {
        "periodo": 202607,
        "valor": 115182478.0,
        "delta": 2325000.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 69339323.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 64005434.0,
        "delta": -5333889.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -64005434.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 23404194.499999993,
    "valor_anterior": 16533414.740000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11759214.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11641151.91,
        "delta": -118062.28
      },
      {
        "periodo": 202509,
        "valor": 11141661.13,
        "delta": -499490.78
      },
      {
        "periodo": 202510,
        "valor": 11391846.8,
        "delta": 250185.67
      },
      {
        "periodo": 202511,
        "valor": 10769041.26,
        "delta": -622805.54
      },
      {
        "periodo": 202512,
        "valor": 10740331.28,
        "delta": -28709.98
      },
      {
        "periodo": 202601,
        "valor": 10302962.65,
        "delta": -437368.63
      },
      {
        "periodo": 202602,
        "valor": 8989309.39,
        "delta": -1313653.26
      },
      {
        "periodo": 202603,
        "valor": 9698328.22,
        "delta": 709018.83
      },
      {
        "periodo": 202604,
        "valor": 9353829.45,
        "delta": -344498.77
      },
      {
        "periodo": 202605,
        "valor": 11149659.12,
        "delta": 1795829.67
      },
      {
        "periodo": 202606,
        "valor": 16533414.74,
        "delta": 5383755.62
      },
      {
        "periodo": 202607,
        "valor": 23404194.5,
        "delta": 6870779.76
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 16084266.0,
    "valor_anterior": 15278488.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15637855.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15091744.0,
        "delta": -546111.0
      },
      {
        "periodo": 202509,
        "valor": 14346290.0,
        "delta": -745454.0
      },
      {
        "periodo": 202510,
        "valor": 15449569.0,
        "delta": 1103279.0
      },
      {
        "periodo": 202511,
        "valor": 15316993.0,
        "delta": -132576.0
      },
      {
        "periodo": 202512,
        "valor": 15949127.0,
        "delta": 632134.0
      },
      {
        "periodo": 202601,
        "valor": 15928948.0,
        "delta": -20179.0
      },
      {
        "periodo": 202602,
        "valor": 14428675.0,
        "delta": -1500273.0
      },
      {
        "periodo": 202603,
        "valor": 16281351.0,
        "delta": 1852676.0
      },
      {
        "periodo": 202604,
        "valor": 15635835.0,
        "delta": -645516.0
      },
      {
        "periodo": 202605,
        "valor": 15951634.0,
        "delta": 315799.0
      },
      {
        "periodo": 202606,
        "valor": 15278488.0,
        "delta": -673146.0
      },
      {
        "periodo": 202607,
        "valor": 16084266.0,
        "delta": 805778.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 115648115.0,
    "valor_anterior": 115157510.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 133229518.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 133828055.0,
        "delta": 598537.0
      },
      {
        "periodo": 202509,
        "valor": 128716689.0,
        "delta": -5111366.0
      },
      {
        "periodo": 202510,
        "valor": 130997065.0,
        "delta": 2280376.0
      },
      {
        "periodo": 202511,
        "valor": 120464160.0,
        "delta": -10532905.0
      },
      {
        "periodo": 202512,
        "valor": 123123188.0,
        "delta": 2659028.0
      },
      {
        "periodo": 202601,
        "valor": 122403785.0,
        "delta": -719403.0
      },
      {
        "periodo": 202602,
        "valor": 114685993.0,
        "delta": -7717792.0
      },
      {
        "periodo": 202603,
        "valor": 120837924.0,
        "delta": 6151931.0
      },
      {
        "periodo": 202604,
        "valor": 120493281.0,
        "delta": -344643.0
      },
      {
        "periodo": 202605,
        "valor": 123986246.0,
        "delta": 3492965.0
      },
      {
        "periodo": 202606,
        "valor": 115157510.0,
        "delta": -8828736.0
      },
      {
        "periodo": 202607,
        "valor": 115648115.0,
        "delta": 490605.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 104769824.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 70577086.0,
        "delta": -34192738.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 60235918.0,
    "valor_anterior": 61235514.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 97156231.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 88680817.0,
        "delta": -8475414.0
      },
      {
        "periodo": 202509,
        "valor": 83443427.0,
        "delta": -5237390.0
      },
      {
        "periodo": 202510,
        "valor": 83636240.0,
        "delta": 192813.0
      },
      {
        "periodo": 202511,
        "valor": 77907332.0,
        "delta": -5728908.0
      },
      {
        "periodo": 202512,
        "valor": 76603643.0,
        "delta": -1303689.0
      },
      {
        "periodo": 202601,
        "valor": 73423131.0,
        "delta": -3180512.0
      },
      {
        "periodo": 202602,
        "valor": 66066080.0,
        "delta": -7357051.0
      },
      {
        "periodo": 202603,
        "valor": 73138826.0,
        "delta": 7072746.0
      },
      {
        "periodo": 202604,
        "valor": 66397524.0,
        "delta": -6741302.0
      },
      {
        "periodo": 202605,
        "valor": 64918713.0,
        "delta": -1478811.0
      },
      {
        "periodo": 202606,
        "valor": 61235514.0,
        "delta": -3683199.0
      },
      {
        "periodo": 202607,
        "valor": 60235918.0,
        "delta": -999596.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 91881452.0,
    "valor_anterior": 88842271.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 67515473.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 68744655.0,
        "delta": 1229182.0
      },
      {
        "periodo": 202509,
        "valor": 67780754.0,
        "delta": -963901.0
      },
      {
        "periodo": 202510,
        "valor": 73855672.0,
        "delta": 6074918.0
      },
      {
        "periodo": 202511,
        "valor": 68454356.0,
        "delta": -5401316.0
      },
      {
        "periodo": 202512,
        "valor": 71929213.0,
        "delta": 3474857.0
      },
      {
        "periodo": 202601,
        "valor": 76378253.0,
        "delta": 4449040.0
      },
      {
        "periodo": 202602,
        "valor": 71134718.0,
        "delta": -5243535.0
      },
      {
        "periodo": 202603,
        "valor": 85544444.0,
        "delta": 14409726.0
      },
      {
        "periodo": 202604,
        "valor": 86532068.0,
        "delta": 987624.0
      },
      {
        "periodo": 202605,
        "valor": 90159308.0,
        "delta": 3627240.0
      },
      {
        "periodo": 202606,
        "valor": 88842271.0,
        "delta": -1317037.0
      },
      {
        "periodo": 202607,
        "valor": 91881452.0,
        "delta": 3039181.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 3417408.0,
    "valor_anterior": 3405982.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2269742.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2179792.0,
        "delta": -89950.0
      },
      {
        "periodo": 202509,
        "valor": 2301573.0,
        "delta": 121781.0
      },
      {
        "periodo": 202510,
        "valor": 2441177.0,
        "delta": 139604.0
      },
      {
        "periodo": 202511,
        "valor": 2401182.0,
        "delta": -39995.0
      },
      {
        "periodo": 202512,
        "valor": 2617867.0,
        "delta": 216685.0
      },
      {
        "periodo": 202601,
        "valor": 2789138.0,
        "delta": 171271.0
      },
      {
        "periodo": 202602,
        "valor": 2646433.0,
        "delta": -142705.0
      },
      {
        "periodo": 202603,
        "valor": 3042475.0,
        "delta": 396042.0
      },
      {
        "periodo": 202604,
        "valor": 2990979.0,
        "delta": -51496.0
      },
      {
        "periodo": 202605,
        "valor": 3223520.0,
        "delta": 232541.0
      },
      {
        "periodo": 202606,
        "valor": 3405982.0,
        "delta": 182462.0
      },
      {
        "periodo": 202607,
        "valor": 3417408.0,
        "delta": 11426.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 78021379.22000003,
    "valor_anterior": 78264722.84999996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 98611629.66,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 95499750.11,
        "delta": -3111879.55
      },
      {
        "periodo": 202509,
        "valor": 90740712.89,
        "delta": -4759037.22
      },
      {
        "periodo": 202510,
        "valor": 93831192.14,
        "delta": 3090479.25
      },
      {
        "periodo": 202511,
        "valor": 91260961.34,
        "delta": -2570230.8
      },
      {
        "periodo": 202512,
        "valor": 94166306.65,
        "delta": 2905345.31
      },
      {
        "periodo": 202601,
        "valor": 93974922.18,
        "delta": -191384.47
      },
      {
        "periodo": 202602,
        "valor": 81643621.63,
        "delta": -12331300.55
      },
      {
        "periodo": 202603,
        "valor": 87947899.94,
        "delta": 6304278.31
      },
      {
        "periodo": 202604,
        "valor": 82727875.33,
        "delta": -5220024.61
      },
      {
        "periodo": 202605,
        "valor": 83321401.59,
        "delta": 593526.26
      },
      {
        "periodo": 202606,
        "valor": 78264722.85,
        "delta": -5056678.74
      },
      {
        "periodo": 202607,
        "valor": 78021379.22,
        "delta": -243343.63
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 11171167.0,
    "valor_anterior": 10856602.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10303633.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9452493.0,
        "delta": -851140.0
      },
      {
        "periodo": 202509,
        "valor": 9452757.0,
        "delta": 264.0
      },
      {
        "periodo": 202510,
        "valor": 9196129.0,
        "delta": -256628.0
      },
      {
        "periodo": 202511,
        "valor": 9612425.0,
        "delta": 416296.0
      },
      {
        "periodo": 202512,
        "valor": 11152797.0,
        "delta": 1540372.0
      },
      {
        "periodo": 202601,
        "valor": 9142272.0,
        "delta": -2010525.0
      },
      {
        "periodo": 202602,
        "valor": 7320445.0,
        "delta": -1821827.0
      },
      {
        "periodo": 202603,
        "valor": 10138032.0,
        "delta": 2817587.0
      },
      {
        "periodo": 202604,
        "valor": 12082865.0,
        "delta": 1944833.0
      },
      {
        "periodo": 202605,
        "valor": 11157864.0,
        "delta": -925001.0
      },
      {
        "periodo": 202606,
        "valor": 10856602.0,
        "delta": -301262.0
      },
      {
        "periodo": 202607,
        "valor": 11171167.0,
        "delta": 314565.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 199547932.7099998,
    "valor_anterior": 189490904.4000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 238666949.11,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 224862596.0,
        "delta": -13804353.11
      },
      {
        "periodo": 202509,
        "valor": 215209893.95,
        "delta": -9652702.05
      },
      {
        "periodo": 202510,
        "valor": 220796098.04,
        "delta": 5586204.09
      },
      {
        "periodo": 202511,
        "valor": 214578283.82,
        "delta": -6217814.22
      },
      {
        "periodo": 202512,
        "valor": 235588757.78,
        "delta": 21010473.96
      },
      {
        "periodo": 202601,
        "valor": 214700795.89,
        "delta": -20887961.89
      },
      {
        "periodo": 202602,
        "valor": 190323095.44,
        "delta": -24377700.45
      },
      {
        "periodo": 202603,
        "valor": 209175872.78,
        "delta": 18852777.34
      },
      {
        "periodo": 202604,
        "valor": 201235755.79,
        "delta": -7940116.99
      },
      {
        "periodo": 202605,
        "valor": 208254876.83,
        "delta": 7019121.04
      },
      {
        "periodo": 202606,
        "valor": 189490904.4,
        "delta": -18763972.43
      },
      {
        "periodo": 202607,
        "valor": 199547932.71,
        "delta": 10057028.31
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 55462624.5,
    "valor_anterior": 54563945.910000026,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 48119558.6,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 50318616.5,
        "delta": 2199057.9
      },
      {
        "periodo": 202509,
        "valor": 50686369.09,
        "delta": 367752.59
      },
      {
        "periodo": 202510,
        "valor": 52413776.35,
        "delta": 1727407.26
      },
      {
        "periodo": 202511,
        "valor": 51490281.6,
        "delta": -923494.75
      },
      {
        "periodo": 202512,
        "valor": 55424752.11,
        "delta": 3934470.51
      },
      {
        "periodo": 202601,
        "valor": 55625147.55,
        "delta": 200395.44
      },
      {
        "periodo": 202602,
        "valor": 51325326.12,
        "delta": -4299821.43
      },
      {
        "periodo": 202603,
        "valor": 54490699.39,
        "delta": 3165373.27
      },
      {
        "periodo": 202604,
        "valor": 52743357.76,
        "delta": -1747341.63
      },
      {
        "periodo": 202605,
        "valor": 54815252.37,
        "delta": 2071894.61
      },
      {
        "periodo": 202606,
        "valor": 54563945.91,
        "delta": -251306.46
      },
      {
        "periodo": 202607,
        "valor": 55462624.5,
        "delta": 898678.59
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 4480782.0,
    "valor_anterior": 4460261.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4690391.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5826097.0,
        "delta": 1135706.0
      },
      {
        "periodo": 202509,
        "valor": 6486312.0,
        "delta": 660215.0
      },
      {
        "periodo": 202510,
        "valor": 6478630.0,
        "delta": -7682.0
      },
      {
        "periodo": 202511,
        "valor": 6199570.0,
        "delta": -279060.0
      },
      {
        "periodo": 202512,
        "valor": 5349513.0,
        "delta": -850057.0
      },
      {
        "periodo": 202601,
        "valor": 4503498.0,
        "delta": -846015.0
      },
      {
        "periodo": 202602,
        "valor": 4804467.0,
        "delta": 300969.0
      },
      {
        "periodo": 202603,
        "valor": 5309599.0,
        "delta": 505132.0
      },
      {
        "periodo": 202604,
        "valor": 3861953.0,
        "delta": -1447646.0
      },
      {
        "periodo": 202605,
        "valor": 4767370.0,
        "delta": 905417.0
      },
      {
        "periodo": 202606,
        "valor": 4460261.0,
        "delta": -307109.0
      },
      {
        "periodo": 202607,
        "valor": 4480782.0,
        "delta": 20521.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 136150420.0,
    "valor_anterior": 141343499.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 174494022.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 166185965.0,
        "delta": -8308057.0
      },
      {
        "periodo": 202509,
        "valor": 156841822.0,
        "delta": -9344143.0
      },
      {
        "periodo": 202510,
        "valor": 167205802.0,
        "delta": 10363980.0
      },
      {
        "periodo": 202511,
        "valor": 157806868.0,
        "delta": -9398934.0
      },
      {
        "periodo": 202512,
        "valor": 163584890.0,
        "delta": 5778022.0
      },
      {
        "periodo": 202601,
        "valor": 149157611.0,
        "delta": -14427279.0
      },
      {
        "periodo": 202602,
        "valor": 136551365.0,
        "delta": -12606246.0
      },
      {
        "periodo": 202603,
        "valor": 154234896.0,
        "delta": 17683531.0
      },
      {
        "periodo": 202604,
        "valor": 127409438.0,
        "delta": -26825458.0
      },
      {
        "periodo": 202605,
        "valor": 137879883.0,
        "delta": 10470445.0
      },
      {
        "periodo": 202606,
        "valor": 141343499.0,
        "delta": 3463616.0
      },
      {
        "periodo": 202607,
        "valor": 136150420.0,
        "delta": -5193079.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 726827.0,
    "valor_anterior": 562524.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 976555.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1151843.0,
        "delta": 175288.0
      },
      {
        "periodo": 202509,
        "valor": 1190373.0,
        "delta": 38530.0
      },
      {
        "periodo": 202510,
        "valor": 946272.0,
        "delta": -244101.0
      },
      {
        "periodo": 202511,
        "valor": 936878.0,
        "delta": -9394.0
      },
      {
        "periodo": 202512,
        "valor": 957890.0,
        "delta": 21012.0
      },
      {
        "periodo": 202601,
        "valor": 953937.0,
        "delta": -3953.0
      },
      {
        "periodo": 202602,
        "valor": 1384095.0,
        "delta": 430158.0
      },
      {
        "periodo": 202603,
        "valor": 1421182.0,
        "delta": 37087.0
      },
      {
        "periodo": 202604,
        "valor": 1365583.0,
        "delta": -55599.0
      },
      {
        "periodo": 202605,
        "valor": 1159578.0,
        "delta": -206005.0
      },
      {
        "periodo": 202606,
        "valor": 562524.0,
        "delta": -597054.0
      },
      {
        "periodo": 202607,
        "valor": 726827.0,
        "delta": 164303.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 27441030.330000013,
    "valor_anterior": 28057661.939999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 46498320.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 50740324.56,
        "delta": 4242004.3
      },
      {
        "periodo": 202509,
        "valor": 52305078.13,
        "delta": 1564753.57
      },
      {
        "periodo": 202510,
        "valor": 48713266.84,
        "delta": -3591811.29
      },
      {
        "periodo": 202511,
        "valor": 40136487.06,
        "delta": -8576779.78
      },
      {
        "periodo": 202512,
        "valor": 32433847.1,
        "delta": -7702639.96
      },
      {
        "periodo": 202601,
        "valor": 38165194.49,
        "delta": 5731347.39
      },
      {
        "periodo": 202602,
        "valor": 38889213.56,
        "delta": 724019.07
      },
      {
        "periodo": 202603,
        "valor": 42071382.29,
        "delta": 3182168.73
      },
      {
        "periodo": 202604,
        "valor": 33976945.2,
        "delta": -8094437.09
      },
      {
        "periodo": 202605,
        "valor": 31004693.27,
        "delta": -2972251.93
      },
      {
        "periodo": 202606,
        "valor": 28057661.94,
        "delta": -2947031.33
      },
      {
        "periodo": 202607,
        "valor": 27441030.33,
        "delta": -616631.61
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 772798.0,
    "valor_anterior": 802052.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1056767.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 789211.0,
        "delta": -267556.0
      },
      {
        "periodo": 202509,
        "valor": 338778.0,
        "delta": -450433.0
      },
      {
        "periodo": 202510,
        "valor": 383024.0,
        "delta": 44246.0
      },
      {
        "periodo": 202511,
        "valor": 716839.0,
        "delta": 333815.0
      },
      {
        "periodo": 202512,
        "valor": 936065.0,
        "delta": 219226.0
      },
      {
        "periodo": 202601,
        "valor": 1116290.0,
        "delta": 180225.0
      },
      {
        "periodo": 202602,
        "valor": 622625.0,
        "delta": -493665.0
      },
      {
        "periodo": 202603,
        "valor": 1146409.0,
        "delta": 523784.0
      },
      {
        "periodo": 202604,
        "valor": 989126.0,
        "delta": -157283.0
      },
      {
        "periodo": 202605,
        "valor": 1596552.0,
        "delta": 607426.0
      },
      {
        "periodo": 202606,
        "valor": 802052.0,
        "delta": -794500.0
      },
      {
        "periodo": 202607,
        "valor": 772798.0,
        "delta": -29254.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 60582813.899999976,
    "valor_anterior": 58655264.57000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 56548975.16,
        "delta": 56548975.16
      },
      {
        "periodo": 202603,
        "valor": 61809805.02,
        "delta": 5260829.86
      },
      {
        "periodo": 202604,
        "valor": 59607742.36,
        "delta": -2202062.66
      },
      {
        "periodo": 202605,
        "valor": 60922088.36,
        "delta": 1314346.0
      },
      {
        "periodo": 202606,
        "valor": 58655264.57,
        "delta": -2266823.79
      },
      {
        "periodo": 202607,
        "valor": 60582813.9,
        "delta": 1927549.33
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 97.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 3859.0,
        "delta": 3859.0
      },
      {
        "periodo": 202601,
        "valor": 2120.0,
        "delta": -1739.0
      },
      {
        "periodo": 202602,
        "valor": 1005.0,
        "delta": -1115.0
      },
      {
        "periodo": 202603,
        "valor": 512.0,
        "delta": -493.0
      },
      {
        "periodo": 202604,
        "valor": 644.0,
        "delta": 132.0
      },
      {
        "periodo": 202605,
        "valor": 6.0,
        "delta": -638.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": -6.0
      },
      {
        "periodo": 202607,
        "valor": 97.0,
        "delta": 97.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 14743831.0,
    "valor_anterior": 9372980.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 47629.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 536550.0,
        "delta": 488921.0
      },
      {
        "periodo": 202605,
        "valor": 4319373.0,
        "delta": 3782823.0
      },
      {
        "periodo": 202606,
        "valor": 9372980.0,
        "delta": 5053607.0
      },
      {
        "periodo": 202607,
        "valor": 14743831.0,
        "delta": 5370851.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 12864646518.289993,
    "valor_anterior": 12598409501.560005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15513774473.81,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15176177636.19,
        "delta": -337596837.62
      },
      {
        "periodo": 202509,
        "valor": 12942129917.0,
        "delta": -2234047719.19
      },
      {
        "periodo": 202510,
        "valor": 14690564205.97,
        "delta": 1748434288.97
      },
      {
        "periodo": 202511,
        "valor": 13855923254.53,
        "delta": -834640951.44
      },
      {
        "periodo": 202512,
        "valor": 14026128012.31,
        "delta": 170204757.78
      },
      {
        "periodo": 202601,
        "valor": 13922201177.7,
        "delta": -103926834.61
      },
      {
        "periodo": 202602,
        "valor": 12466618240.64,
        "delta": -1455582937.06
      },
      {
        "periodo": 202603,
        "valor": 13607408106.62,
        "delta": 1140789865.98
      },
      {
        "periodo": 202604,
        "valor": 13035801169.88,
        "delta": -571606936.74
      },
      {
        "periodo": 202605,
        "valor": 13296262384.65,
        "delta": 260461214.77
      },
      {
        "periodo": 202606,
        "valor": 12598409501.56,
        "delta": -697852883.09
      },
      {
        "periodo": 202607,
        "valor": 12864646518.29,
        "delta": 266237016.73
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 8191060812.200005,
    "valor_anterior": 8002017542.219994,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9588991754.94,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9402660071.51,
        "delta": -186331683.43
      },
      {
        "periodo": 202509,
        "valor": 8864103793.6,
        "delta": -538556277.91
      },
      {
        "periodo": 202510,
        "valor": 9056144397.86,
        "delta": 192040604.26
      },
      {
        "periodo": 202511,
        "valor": 8583640837.08,
        "delta": -472503560.78
      },
      {
        "periodo": 202512,
        "valor": 8790370331.62,
        "delta": 206729494.54
      },
      {
        "periodo": 202601,
        "valor": 8698267919.05,
        "delta": -92102412.57
      },
      {
        "periodo": 202602,
        "valor": 7616725285.55,
        "delta": -1081542633.5
      },
      {
        "periodo": 202603,
        "valor": 8508572422.49,
        "delta": 891847136.94
      },
      {
        "periodo": 202604,
        "valor": 8189726389.17,
        "delta": -318846033.32
      },
      {
        "periodo": 202605,
        "valor": 8400839511.4,
        "delta": 211113122.23
      },
      {
        "periodo": 202606,
        "valor": 8002017542.22,
        "delta": -398821969.18
      },
      {
        "periodo": 202607,
        "valor": 8191060812.2,
        "delta": 189043269.98
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 297182429.5600002,
    "valor_anterior": 249286398.35000014,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 478083324.13,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 403983766.34,
        "delta": -74099557.79
      },
      {
        "periodo": 202509,
        "valor": -1013538599.32,
        "delta": -1417522365.66
      },
      {
        "periodo": 202510,
        "valor": 251360430.38,
        "delta": 1264899029.7
      },
      {
        "periodo": 202511,
        "valor": 254701092.12,
        "delta": 3340661.74
      },
      {
        "periodo": 202512,
        "valor": 288791835.26,
        "delta": 34090743.14
      },
      {
        "periodo": 202601,
        "valor": 318686157.83,
        "delta": 29894322.57
      },
      {
        "periodo": 202602,
        "valor": 273812913.42,
        "delta": -44873244.41
      },
      {
        "periodo": 202603,
        "valor": 296013180.57,
        "delta": 22200267.15
      },
      {
        "periodo": 202604,
        "valor": 293093911.72,
        "delta": -2919268.85
      },
      {
        "periodo": 202605,
        "valor": 281491124.71,
        "delta": -11602787.01
      },
      {
        "periodo": 202606,
        "valor": 249286398.35,
        "delta": -32204726.36
      },
      {
        "periodo": 202607,
        "valor": 297182429.56,
        "delta": 47896031.21
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 853206376.7600002,
    "valor_anterior": 926748738.9899998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1603610188.4,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1613170361.0,
        "delta": 9560172.6
      },
      {
        "periodo": 202509,
        "valor": 1382209515.92,
        "delta": -230960845.08
      },
      {
        "periodo": 202510,
        "valor": 1596954726.82,
        "delta": 214745210.9
      },
      {
        "periodo": 202511,
        "valor": 1464013937.81,
        "delta": -132940789.01
      },
      {
        "periodo": 202512,
        "valor": 1338351928.23,
        "delta": -125662009.58
      },
      {
        "periodo": 202601,
        "valor": 1266262220.9,
        "delta": -72089707.33
      },
      {
        "periodo": 202602,
        "valor": 1277653431.19,
        "delta": 11391210.29
      },
      {
        "periodo": 202603,
        "valor": 1078591590.25,
        "delta": -199061840.94
      },
      {
        "periodo": 202604,
        "valor": 1009979100.38,
        "delta": -68612489.87
      },
      {
        "periodo": 202605,
        "valor": 1028965692.61,
        "delta": 18986592.23
      },
      {
        "periodo": 202606,
        "valor": 926748738.99,
        "delta": -102216953.62
      },
      {
        "periodo": 202607,
        "valor": 853206376.76,
        "delta": -73542362.23
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 2060147549.1600018,
    "valor_anterior": 2025091476.5899982,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2372716542.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2295931865.96,
        "delta": -76784676.54
      },
      {
        "periodo": 202509,
        "valor": 2241232164.26,
        "delta": -54699701.7
      },
      {
        "periodo": 202510,
        "valor": 2286161673.02,
        "delta": 44929508.76
      },
      {
        "periodo": 202511,
        "valor": 2130953821.95,
        "delta": -155207851.07
      },
      {
        "periodo": 202512,
        "valor": 2194348867.28,
        "delta": 63395045.33
      },
      {
        "periodo": 202601,
        "valor": 2193083363.61,
        "delta": -1265503.67
      },
      {
        "periodo": 202602,
        "valor": 1949792943.61,
        "delta": -243290420.0
      },
      {
        "periodo": 202603,
        "valor": 2242159943.87,
        "delta": 292367000.26
      },
      {
        "periodo": 202604,
        "valor": 2120160606.14,
        "delta": -121999337.73
      },
      {
        "periodo": 202605,
        "valor": 2150503171.64,
        "delta": 30342565.5
      },
      {
        "periodo": 202606,
        "valor": 2025091476.59,
        "delta": -125411695.05
      },
      {
        "periodo": 202607,
        "valor": 2060147549.16,
        "delta": 35056072.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 973788508.7599993,
    "valor_anterior": 933930273.1000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 958109741.55,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 955622476.49,
        "delta": -2487265.06
      },
      {
        "periodo": 202509,
        "valor": 993814448.64,
        "delta": 38191972.15
      },
      {
        "periodo": 202510,
        "valor": 1025063863.37,
        "delta": 31249414.73
      },
      {
        "periodo": 202511,
        "valor": 978506918.82,
        "delta": -46556944.55
      },
      {
        "periodo": 202512,
        "valor": 953630306.64,
        "delta": -24876612.18
      },
      {
        "periodo": 202601,
        "valor": 988976372.11,
        "delta": 35346065.47
      },
      {
        "periodo": 202602,
        "valor": 876090459.75,
        "delta": -112885912.36
      },
      {
        "periodo": 202603,
        "valor": 982453484.4,
        "delta": 106363024.65
      },
      {
        "periodo": 202604,
        "valor": 955378471.08,
        "delta": -27075013.32
      },
      {
        "periodo": 202605,
        "valor": 966144965.06,
        "delta": 10766493.98
      },
      {
        "periodo": 202606,
        "valor": 933930273.1,
        "delta": -32214691.96
      },
      {
        "periodo": 202607,
        "valor": 973788508.76,
        "delta": 39858235.66
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100119,
    "label": "Intereses por Dep. a Plazo",
    "valor_actual": 489260841.8499999,
    "valor_anterior": 461335072.30999994,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 512262922.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 504809094.89,
        "delta": -7453827.4
      },
      {
        "periodo": 202509,
        "valor": 474308593.9,
        "delta": -30500500.99
      },
      {
        "periodo": 202510,
        "valor": 474879114.52,
        "delta": 570520.62
      },
      {
        "periodo": 202511,
        "valor": 444106646.75,
        "delta": -30772467.77
      },
      {
        "periodo": 202512,
        "valor": 460634743.28,
        "delta": 16528096.53
      },
      {
        "periodo": 202601,
        "valor": 456925144.2,
        "delta": -3709599.08
      },
      {
        "periodo": 202602,
        "valor": 472543207.12,
        "delta": 15618062.92
      },
      {
        "periodo": 202603,
        "valor": 499617485.04,
        "delta": 27074277.92
      },
      {
        "periodo": 202604,
        "valor": 467462691.39,
        "delta": -32154793.65
      },
      {
        "periodo": 202605,
        "valor": 468317919.23,
        "delta": 855227.84
      },
      {
        "periodo": 202606,
        "valor": 461335072.31,
        "delta": -6982846.92
      },
      {
        "periodo": 202607,
        "valor": 489260841.85,
        "delta": 27925769.54
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 4474971.569999993,
    "valor_anterior": 4772387.450000018,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 175520967.1,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 143029532.29,
        "delta": -32491434.81
      },
      {
        "periodo": 202509,
        "valor": 130118164.89,
        "delta": -12911367.4
      },
      {
        "periodo": 202510,
        "valor": 158283904.21,
        "delta": 28165739.32
      },
      {
        "periodo": 202511,
        "valor": 195628395.94,
        "delta": 37344491.73
      },
      {
        "periodo": 202512,
        "valor": 203037465.8,
        "delta": 7409069.86
      },
      {
        "periodo": 202601,
        "valor": 200759027.81,
        "delta": -2278437.99
      },
      {
        "periodo": 202602,
        "valor": 22519393.13,
        "delta": -178239634.68
      },
      {
        "periodo": 202603,
        "valor": 5671325.72,
        "delta": -16848067.41
      },
      {
        "periodo": 202604,
        "valor": 5262035.98,
        "delta": -409289.74
      },
      {
        "periodo": 202605,
        "valor": 18279372.53,
        "delta": 13017336.55
      },
      {
        "periodo": 202606,
        "valor": 4772387.45,
        "delta": -13506985.08
      },
      {
        "periodo": 202607,
        "valor": 4474971.57,
        "delta": -297415.88
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 101097837.63999999,
    "valor_anterior": 110995098.32000005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 124663448.18,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 103362485.35,
        "delta": -21300962.83
      },
      {
        "periodo": 202509,
        "valor": 72805798.86,
        "delta": -30556686.49
      },
      {
        "periodo": 202510,
        "valor": 161355556.06,
        "delta": 88549757.2
      },
      {
        "periodo": 202511,
        "valor": 77060560.03,
        "delta": -84294996.03
      },
      {
        "periodo": 202512,
        "valor": 143038680.73,
        "delta": 65978120.7
      },
      {
        "periodo": 202601,
        "valor": 110815797.3,
        "delta": -32222883.43
      },
      {
        "periodo": 202602,
        "valor": 111366392.44,
        "delta": 550595.14
      },
      {
        "periodo": 202603,
        "valor": 115131101.51,
        "delta": 3764709.07
      },
      {
        "periodo": 202604,
        "valor": 97838598.18,
        "delta": -17292503.33
      },
      {
        "periodo": 202605,
        "valor": 109013026.13,
        "delta": 11174427.95
      },
      {
        "periodo": 202606,
        "valor": 110995098.32,
        "delta": 1982072.19
      },
      {
        "periodo": 202607,
        "valor": 101097837.64,
        "delta": -9897260.68
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 344980302.0,
    "valor_anterior": 340570860.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1671213856.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -989101318.0,
        "delta": -2660315174.0
      },
      {
        "periodo": 202509,
        "valor": 335003785.0,
        "delta": 1324105103.0
      },
      {
        "periodo": 202510,
        "valor": 355758216.0,
        "delta": 20754431.0
      },
      {
        "periodo": 202511,
        "valor": 321870038.0,
        "delta": -33888178.0
      },
      {
        "periodo": 202512,
        "valor": 299495491.0,
        "delta": -22374547.0
      },
      {
        "periodo": 202601,
        "valor": 343013797.0,
        "delta": 43518306.0
      },
      {
        "periodo": 202602,
        "valor": 282000725.0,
        "delta": -61013072.0
      },
      {
        "periodo": 202603,
        "valor": 326232159.0,
        "delta": 44231434.0
      },
      {
        "periodo": 202604,
        "valor": 299822933.0,
        "delta": -26409226.0
      },
      {
        "periodo": 202605,
        "valor": 345807303.0,
        "delta": 45984370.0
      },
      {
        "periodo": 202606,
        "valor": 340570860.0,
        "delta": -5236443.0
      },
      {
        "periodo": 202607,
        "valor": 344980302.0,
        "delta": 4409442.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 42567428.0,
    "valor_anterior": 42026647.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 89902385.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 72538624.0,
        "delta": -17363761.0
      },
      {
        "periodo": 202509,
        "valor": 83268747.0,
        "delta": 10730123.0
      },
      {
        "periodo": 202510,
        "valor": 67007575.0,
        "delta": -16261172.0
      },
      {
        "periodo": 202511,
        "valor": 54598945.0,
        "delta": -12408630.0
      },
      {
        "periodo": 202512,
        "valor": 55023748.0,
        "delta": 424803.0
      },
      {
        "periodo": 202601,
        "valor": 50536266.0,
        "delta": -4487482.0
      },
      {
        "periodo": 202602,
        "valor": 51433225.0,
        "delta": 896959.0
      },
      {
        "periodo": 202603,
        "valor": 48569618.0,
        "delta": -2863607.0
      },
      {
        "periodo": 202604,
        "valor": 41206094.0,
        "delta": -7363524.0
      },
      {
        "periodo": 202605,
        "valor": 38600531.0,
        "delta": -2605563.0
      },
      {
        "periodo": 202606,
        "valor": 42026647.0,
        "delta": 3426116.0
      },
      {
        "periodo": 202607,
        "valor": 42567428.0,
        "delta": 540781.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 286989392.25,
    "valor_anterior": 275168280.75,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 288380954.64,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 278342739.04,
        "delta": -10038215.6
      },
      {
        "periodo": 202509,
        "valor": 269486494.4,
        "delta": -8856244.64
      },
      {
        "periodo": 202510,
        "valor": 277729907.74,
        "delta": 8243413.34
      },
      {
        "periodo": 202511,
        "valor": 264439973.59,
        "delta": -13289934.15
      },
      {
        "periodo": 202512,
        "valor": 286014168.22,
        "delta": 21574194.63
      },
      {
        "periodo": 202601,
        "valor": 295683918.59,
        "delta": 9669750.37
      },
      {
        "periodo": 202602,
        "valor": 264756198.38,
        "delta": -30927720.21
      },
      {
        "periodo": 202603,
        "valor": 291679472.28,
        "delta": 26923273.9
      },
      {
        "periodo": 202604,
        "valor": 275258150.28,
        "delta": -16421322.0
      },
      {
        "periodo": 202605,
        "valor": 286191810.03,
        "delta": 10933659.75
      },
      {
        "periodo": 202606,
        "valor": 275168280.75,
        "delta": -11023529.28
      },
      {
        "periodo": 202607,
        "valor": 286989392.25,
        "delta": 11821111.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 115402604.0,
    "valor_anterior": 117056393.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 219182094.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 235037480.0,
        "delta": 15855386.0
      },
      {
        "periodo": 202509,
        "valor": 225669357.0,
        "delta": -9368123.0
      },
      {
        "periodo": 202510,
        "valor": 233955009.0,
        "delta": 8285652.0
      },
      {
        "periodo": 202511,
        "valor": 223457236.0,
        "delta": -10497773.0
      },
      {
        "periodo": 202512,
        "valor": 162801533.0,
        "delta": -60655703.0
      },
      {
        "periodo": 202601,
        "valor": 132728366.0,
        "delta": -30073167.0
      },
      {
        "periodo": 202602,
        "valor": 117783983.0,
        "delta": -14944383.0
      },
      {
        "periodo": 202603,
        "valor": 129790939.0,
        "delta": 12006956.0
      },
      {
        "periodo": 202604,
        "valor": 121013814.0,
        "delta": -8777125.0
      },
      {
        "periodo": 202605,
        "valor": 124371754.0,
        "delta": 3357940.0
      },
      {
        "periodo": 202606,
        "valor": 117056393.0,
        "delta": -7315361.0
      },
      {
        "periodo": 202607,
        "valor": 115402604.0,
        "delta": -1653789.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 113684495.0,
    "valor_anterior": 118577433.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 126117592.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 116650895.0,
        "delta": -9466697.0
      },
      {
        "periodo": 202509,
        "valor": 104392612.0,
        "delta": -12258283.0
      },
      {
        "periodo": 202510,
        "valor": 105523236.0,
        "delta": 1130624.0
      },
      {
        "periodo": 202511,
        "valor": 121494389.0,
        "delta": 15971153.0
      },
      {
        "periodo": 202512,
        "valor": 146609390.0,
        "delta": 25115001.0
      },
      {
        "periodo": 202601,
        "valor": 170320783.0,
        "delta": 23711393.0
      },
      {
        "periodo": 202602,
        "valor": 153110306.0,
        "delta": -17210477.0
      },
      {
        "periodo": 202603,
        "valor": 162670163.0,
        "delta": 9559857.0
      },
      {
        "periodo": 202604,
        "valor": 146346175.0,
        "delta": -16323988.0
      },
      {
        "periodo": 202605,
        "valor": 138808621.0,
        "delta": -7537554.0
      },
      {
        "periodo": 202606,
        "valor": 118577433.0,
        "delta": -20231188.0
      },
      {
        "periodo": 202607,
        "valor": 113684495.0,
        "delta": -4892938.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 233883860.0,
    "valor_anterior": 216821152.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 263648465.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 257171994.0,
        "delta": -6476471.0
      },
      {
        "periodo": 202509,
        "valor": 248206101.0,
        "delta": -8965893.0
      },
      {
        "periodo": 202510,
        "valor": 258605602.0,
        "delta": 10399501.0
      },
      {
        "periodo": 202511,
        "valor": 264533036.0,
        "delta": 5927434.0
      },
      {
        "periodo": 202512,
        "valor": 257689776.0,
        "delta": -6843260.0
      },
      {
        "periodo": 202601,
        "valor": 251488079.0,
        "delta": -6201697.0
      },
      {
        "periodo": 202602,
        "valor": 219142850.0,
        "delta": -32345229.0
      },
      {
        "periodo": 202603,
        "valor": 245675399.0,
        "delta": 26532549.0
      },
      {
        "periodo": 202604,
        "valor": 225206241.0,
        "delta": -20469158.0
      },
      {
        "periodo": 202605,
        "valor": 219757246.0,
        "delta": -5448995.0
      },
      {
        "periodo": 202606,
        "valor": 216821152.0,
        "delta": -2936094.0
      },
      {
        "periodo": 202607,
        "valor": 233883860.0,
        "delta": 17062708.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 24164887.150000006,
    "valor_anterior": 23100347.059999987,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 23044815.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23653092.83,
        "delta": 608277.54
      },
      {
        "periodo": 202509,
        "valor": 20640255.14,
        "delta": -3012837.69
      },
      {
        "periodo": 202510,
        "valor": 22378729.92,
        "delta": 1738474.78
      },
      {
        "periodo": 202511,
        "valor": 22137909.12,
        "delta": -240820.8
      },
      {
        "periodo": 202512,
        "valor": 20644690.44,
        "delta": -1493218.68
      },
      {
        "periodo": 202601,
        "valor": 22529420.1,
        "delta": 1884729.66
      },
      {
        "periodo": 202602,
        "valor": 23574034.68,
        "delta": 1044614.58
      },
      {
        "periodo": 202603,
        "valor": 24959718.54,
        "delta": 1385683.86
      },
      {
        "periodo": 202604,
        "valor": 23331835.25,
        "delta": -1627883.29
      },
      {
        "periodo": 202605,
        "valor": 24583198.88,
        "delta": 1251363.63
      },
      {
        "periodo": 202606,
        "valor": 23100347.06,
        "delta": -1482851.82
      },
      {
        "periodo": 202607,
        "valor": 24164887.15,
        "delta": 1064540.09
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 23770866.0,
    "valor_anterior": 22663500.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28336767.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 30037265.0,
        "delta": 1700498.0
      },
      {
        "periodo": 202509,
        "valor": 26848829.0,
        "delta": -3188436.0
      },
      {
        "periodo": 202510,
        "valor": 29123343.0,
        "delta": 2274514.0
      },
      {
        "periodo": 202511,
        "valor": 27268292.0,
        "delta": -1855051.0
      },
      {
        "periodo": 202512,
        "valor": 27819907.0,
        "delta": 551615.0
      },
      {
        "periodo": 202601,
        "valor": 26578463.0,
        "delta": -1241444.0
      },
      {
        "periodo": 202602,
        "valor": 22288780.0,
        "delta": -4289683.0
      },
      {
        "periodo": 202603,
        "valor": 29772512.0,
        "delta": 7483732.0
      },
      {
        "periodo": 202604,
        "valor": 20653459.0,
        "delta": -9119053.0
      },
      {
        "periodo": 202605,
        "valor": 24355675.0,
        "delta": 3702216.0
      },
      {
        "periodo": 202606,
        "valor": 22663500.0,
        "delta": -1692175.0
      },
      {
        "periodo": 202607,
        "valor": 23770866.0,
        "delta": 1107366.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 898792.0,
    "valor_anterior": 944029.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1688315.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1374472.0,
        "delta": -313843.0
      },
      {
        "periodo": 202509,
        "valor": 1167904.0,
        "delta": -206568.0
      },
      {
        "periodo": 202510,
        "valor": 1199070.0,
        "delta": 31166.0
      },
      {
        "periodo": 202511,
        "valor": 1093750.0,
        "delta": -105320.0
      },
      {
        "periodo": 202512,
        "valor": 1349420.0,
        "delta": 255670.0
      },
      {
        "periodo": 202601,
        "valor": 1327805.0,
        "delta": -21615.0
      },
      {
        "periodo": 202602,
        "valor": 1089415.0,
        "delta": -238390.0
      },
      {
        "periodo": 202603,
        "valor": 1150651.0,
        "delta": 61236.0
      },
      {
        "periodo": 202604,
        "valor": 1098314.0,
        "delta": -52337.0
      },
      {
        "periodo": 202605,
        "valor": 1072229.0,
        "delta": -26085.0
      },
      {
        "periodo": 202606,
        "valor": 944029.0,
        "delta": -128200.0
      },
      {
        "periodo": 202607,
        "valor": 898792.0,
        "delta": -45237.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 10112622.0,
    "valor_anterior": -18413.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15434411.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15669752.0,
        "delta": 235341.0
      },
      {
        "periodo": 202509,
        "valor": 15012363.0,
        "delta": -657389.0
      },
      {
        "periodo": 202510,
        "valor": 19972181.0,
        "delta": 4959818.0
      },
      {
        "periodo": 202511,
        "valor": 27269713.0,
        "delta": 7297532.0
      },
      {
        "periodo": 202512,
        "valor": 21981327.0,
        "delta": -5288386.0
      },
      {
        "periodo": 202601,
        "valor": 19937705.0,
        "delta": -2043622.0
      },
      {
        "periodo": 202602,
        "valor": 19330063.0,
        "delta": -607642.0
      },
      {
        "periodo": 202603,
        "valor": 20091874.0,
        "delta": 761811.0
      },
      {
        "periodo": 202604,
        "valor": 17300787.0,
        "delta": -2791087.0
      },
      {
        "periodo": 202605,
        "valor": 22084691.0,
        "delta": 4783904.0
      },
      {
        "periodo": 202606,
        "valor": -18413.0,
        "delta": -22103104.0
      },
      {
        "periodo": 202607,
        "valor": 10112622.0,
        "delta": 10131035.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 51500046.29999995,
    "valor_anterior": 52822726.410000026,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 58743450.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 56845615.46,
        "delta": -1897834.93
      },
      {
        "periodo": 202509,
        "valor": 48610177.4,
        "delta": -8235438.06
      },
      {
        "periodo": 202510,
        "valor": 49266281.19,
        "delta": 656103.79
      },
      {
        "periodo": 202511,
        "valor": 45716557.75,
        "delta": -3549723.44
      },
      {
        "periodo": 202512,
        "valor": 46139893.41,
        "delta": 423335.66
      },
      {
        "periodo": 202601,
        "valor": 54996710.66,
        "delta": 8856817.25
      },
      {
        "periodo": 202602,
        "valor": 47731165.98,
        "delta": -7265544.68
      },
      {
        "periodo": 202603,
        "valor": 47724295.22,
        "delta": -6870.76
      },
      {
        "periodo": 202604,
        "valor": 46613566.88,
        "delta": -1110728.34
      },
      {
        "periodo": 202605,
        "valor": 46033333.01,
        "delta": -580233.87
      },
      {
        "periodo": 202606,
        "valor": 52822726.41,
        "delta": 6789393.4
      },
      {
        "periodo": 202607,
        "valor": 51500046.3,
        "delta": -1322680.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 0.0,
    "valor_anterior": 131805.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 258750.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 122708.0,
        "delta": -136042.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -122708.0
      },
      {
        "periodo": 202510,
        "valor": 431250.0,
        "delta": 431250.0
      },
      {
        "periodo": 202511,
        "valor": 302083.0,
        "delta": -129167.0
      },
      {
        "periodo": 202512,
        "valor": 311320.0,
        "delta": 9237.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -311320.0
      },
      {
        "periodo": 202602,
        "valor": 534722.0,
        "delta": 534722.0
      },
      {
        "periodo": 202603,
        "valor": 486111.0,
        "delta": -48611.0
      },
      {
        "periodo": 202604,
        "valor": 106875.0,
        "delta": -379236.0
      },
      {
        "periodo": 202605,
        "valor": 277695.0,
        "delta": 170820.0
      },
      {
        "periodo": 202606,
        "valor": 131805.0,
        "delta": -145890.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": -131805.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 86.0,
        "delta": 86.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": -86.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 18002.0,
        "delta": 18002.0
      },
      {
        "periodo": 202603,
        "valor": 4.0,
        "delta": -17998.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": -4.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 41865707.0,
    "valor_anterior": 36435169.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 41925658.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 40416429.0,
        "delta": -1509229.0
      },
      {
        "periodo": 202509,
        "valor": -129638597.0,
        "delta": -170055026.0
      },
      {
        "periodo": 202510,
        "valor": 36633305.0,
        "delta": 166271902.0
      },
      {
        "periodo": 202511,
        "valor": 36684949.0,
        "delta": 51644.0
      },
      {
        "periodo": 202512,
        "valor": 39071327.0,
        "delta": 2386378.0
      },
      {
        "periodo": 202601,
        "valor": 43838152.0,
        "delta": 4766825.0
      },
      {
        "periodo": 202602,
        "valor": 50772248.0,
        "delta": 6934096.0
      },
      {
        "periodo": 202603,
        "valor": 47984142.0,
        "delta": -2788106.0
      },
      {
        "periodo": 202604,
        "valor": 40023476.0,
        "delta": -7960666.0
      },
      {
        "periodo": 202605,
        "valor": 43582299.0,
        "delta": 3558823.0
      },
      {
        "periodo": 202606,
        "valor": 36435169.0,
        "delta": -7147130.0
      },
      {
        "periodo": 202607,
        "valor": 41865707.0,
        "delta": 5430538.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 11600729.960000008,
    "valor_anterior": 13034865.829999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 24160326.35,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12118346.39,
        "delta": -12041979.96
      },
      {
        "periodo": 202509,
        "valor": 10664785.78,
        "delta": -1453560.61
      },
      {
        "periodo": 202510,
        "valor": 12667545.57,
        "delta": 2002759.79
      },
      {
        "periodo": 202511,
        "valor": 11368362.62,
        "delta": -1299182.95
      },
      {
        "periodo": 202512,
        "valor": 12221603.95,
        "delta": 853241.33
      },
      {
        "periodo": 202601,
        "valor": 10829502.99,
        "delta": -1392100.96
      },
      {
        "periodo": 202602,
        "valor": 10360397.84,
        "delta": -469105.15
      },
      {
        "periodo": 202603,
        "valor": 11568766.31,
        "delta": 1208368.47
      },
      {
        "periodo": 202604,
        "valor": 12769342.01,
        "delta": 1200575.7
      },
      {
        "periodo": 202605,
        "valor": 13349008.51,
        "delta": 579666.5
      },
      {
        "periodo": 202606,
        "valor": 13034865.83,
        "delta": -314142.68
      },
      {
        "periodo": 202607,
        "valor": 11600729.96,
        "delta": -1434135.87
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 40057140.0,
    "valor_anterior": 40890589.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26892660.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25950557.0,
        "delta": -942103.0
      },
      {
        "periodo": 202509,
        "valor": 24945987.0,
        "delta": -1004570.0
      },
      {
        "periodo": 202510,
        "valor": 31496626.0,
        "delta": 6550639.0
      },
      {
        "periodo": 202511,
        "valor": 31252690.0,
        "delta": -243936.0
      },
      {
        "periodo": 202512,
        "valor": 37958240.0,
        "delta": 6705550.0
      },
      {
        "periodo": 202601,
        "valor": 36100874.0,
        "delta": -1857366.0
      },
      {
        "periodo": 202602,
        "valor": 27704111.0,
        "delta": -8396763.0
      },
      {
        "periodo": 202603,
        "valor": 31407805.0,
        "delta": 3703694.0
      },
      {
        "periodo": 202604,
        "valor": 41948532.0,
        "delta": 10540727.0
      },
      {
        "periodo": 202605,
        "valor": 35939258.0,
        "delta": -6009274.0
      },
      {
        "periodo": 202606,
        "valor": 40890589.0,
        "delta": 4951331.0
      },
      {
        "periodo": 202607,
        "valor": 40057140.0,
        "delta": -833449.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 144126214.54999995,
    "valor_anterior": 137802623.76,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 261606536.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 268069648.4,
        "delta": 6463111.68
      },
      {
        "periodo": 202509,
        "valor": 222303072.7,
        "delta": -45766575.7
      },
      {
        "periodo": 202510,
        "valor": 212113925.04,
        "delta": -10189147.66
      },
      {
        "periodo": 202511,
        "valor": 195517954.08,
        "delta": -16595970.96
      },
      {
        "periodo": 202512,
        "valor": 164312180.3,
        "delta": -31205773.78
      },
      {
        "periodo": 202601,
        "valor": 152307697.7,
        "delta": -12004482.6
      },
      {
        "periodo": 202602,
        "valor": 128385078.75,
        "delta": -23922618.95
      },
      {
        "periodo": 202603,
        "valor": 147546247.21,
        "delta": 19161168.46
      },
      {
        "periodo": 202604,
        "valor": 140959915.1,
        "delta": -6586332.11
      },
      {
        "periodo": 202605,
        "valor": 141183855.81,
        "delta": 223940.71
      },
      {
        "periodo": 202606,
        "valor": 137802623.76,
        "delta": -3381232.05
      },
      {
        "periodo": 202607,
        "valor": 144126214.55,
        "delta": 6323590.79
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 5204845.940000001,
    "valor_anterior": 5546958.619999997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18147364.31,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3875899.6,
        "delta": -14271464.71
      },
      {
        "periodo": 202509,
        "valor": 11923995.46,
        "delta": 8048095.86
      },
      {
        "periodo": 202510,
        "valor": 8103752.94,
        "delta": -3820242.52
      },
      {
        "periodo": 202511,
        "valor": 7283240.24,
        "delta": -820512.7
      },
      {
        "periodo": 202512,
        "valor": -1935670.97,
        "delta": -9218911.21
      },
      {
        "periodo": 202601,
        "valor": 4612625.57,
        "delta": 6548296.54
      },
      {
        "periodo": 202602,
        "valor": 10775175.07,
        "delta": 6162549.5
      },
      {
        "periodo": 202603,
        "valor": 9067716.04,
        "delta": -1707459.03
      },
      {
        "periodo": 202604,
        "valor": -7235972.88,
        "delta": -16303688.92
      },
      {
        "periodo": 202605,
        "valor": 5446789.73,
        "delta": 12682762.61
      },
      {
        "periodo": 202606,
        "valor": 5546958.62,
        "delta": 100168.89
      },
      {
        "periodo": 202607,
        "valor": 5204845.94,
        "delta": -342112.68
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 23074.0,
    "valor_anterior": 7654.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": -0.24,
        "delta": -0.24
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.24
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 7654.0,
        "delta": 7654.0
      },
      {
        "periodo": 202607,
        "valor": 23074.0,
        "delta": 15420.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 4376445.0,
    "valor_anterior": 2644664.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 174958.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 140214.0,
        "delta": -34744.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -140214.0
      },
      {
        "periodo": 202510,
        "valor": 1433557.0,
        "delta": 1433557.0
      },
      {
        "periodo": 202511,
        "valor": 1251045.0,
        "delta": -182512.0
      },
      {
        "periodo": 202512,
        "valor": 546498.0,
        "delta": -704547.0
      },
      {
        "periodo": 202601,
        "valor": 7035189.0,
        "delta": 6488691.0
      },
      {
        "periodo": 202602,
        "valor": 5667600.0,
        "delta": -1367589.0
      },
      {
        "periodo": 202603,
        "valor": 10750612.0,
        "delta": 5083012.0
      },
      {
        "periodo": 202604,
        "valor": 5397268.0,
        "delta": -5353344.0
      },
      {
        "periodo": 202605,
        "valor": 5374805.0,
        "delta": -22463.0
      },
      {
        "periodo": 202606,
        "valor": 2644664.0,
        "delta": -2730141.0
      },
      {
        "periodo": 202607,
        "valor": 4376445.0,
        "delta": 1731781.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 132352507.0,
    "valor_anterior": 128904209.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 168119910.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 163353958.0,
        "delta": -4765952.0
      },
      {
        "periodo": 202509,
        "valor": 165186370.0,
        "delta": 1832412.0
      },
      {
        "periodo": 202510,
        "valor": 162321687.0,
        "delta": -2864683.0
      },
      {
        "periodo": 202511,
        "valor": 150363970.0,
        "delta": -11957717.0
      },
      {
        "periodo": 202512,
        "valor": 154000413.0,
        "delta": 3636443.0
      },
      {
        "periodo": 202601,
        "valor": 150104750.0,
        "delta": -3895663.0
      },
      {
        "periodo": 202602,
        "valor": 130595243.0,
        "delta": -19509507.0
      },
      {
        "periodo": 202603,
        "valor": 142335364.0,
        "delta": 11740121.0
      },
      {
        "periodo": 202604,
        "valor": 135897360.0,
        "delta": -6438004.0
      },
      {
        "periodo": 202605,
        "valor": 137975478.0,
        "delta": 2078118.0
      },
      {
        "periodo": 202606,
        "valor": 128904209.0,
        "delta": -9071269.0
      },
      {
        "periodo": 202607,
        "valor": 132352507.0,
        "delta": 3448298.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 78706255.0,
    "valor_anterior": 54054244.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 74434087.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 67201490.0,
        "delta": -7232597.0
      },
      {
        "periodo": 202509,
        "valor": 64959445.0,
        "delta": -2242045.0
      },
      {
        "periodo": 202510,
        "valor": 49345040.0,
        "delta": -15614405.0
      },
      {
        "periodo": 202511,
        "valor": 37589187.0,
        "delta": -11755853.0
      },
      {
        "periodo": 202512,
        "valor": 46204586.0,
        "delta": 8615399.0
      },
      {
        "periodo": 202601,
        "valor": 75795862.0,
        "delta": 29591276.0
      },
      {
        "periodo": 202602,
        "valor": 63575353.0,
        "delta": -12220509.0
      },
      {
        "periodo": 202603,
        "valor": 68989374.0,
        "delta": 5414021.0
      },
      {
        "periodo": 202604,
        "valor": 55820011.0,
        "delta": -13169363.0
      },
      {
        "periodo": 202605,
        "valor": 59462602.0,
        "delta": 3642591.0
      },
      {
        "periodo": 202606,
        "valor": 54054244.0,
        "delta": -5408358.0
      },
      {
        "periodo": 202607,
        "valor": 78706255.0,
        "delta": 24652011.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 2813195.0,
    "valor_anterior": 2476205.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1381148.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1435085.0,
        "delta": 53937.0
      },
      {
        "periodo": 202509,
        "valor": 1385386.0,
        "delta": -49699.0
      },
      {
        "periodo": 202510,
        "valor": 1325532.0,
        "delta": -59854.0
      },
      {
        "periodo": 202511,
        "valor": 1527660.0,
        "delta": 202128.0
      },
      {
        "periodo": 202512,
        "valor": 1991250.0,
        "delta": 463590.0
      },
      {
        "periodo": 202601,
        "valor": 1799985.0,
        "delta": -191265.0
      },
      {
        "periodo": 202602,
        "valor": 1529699.0,
        "delta": -270286.0
      },
      {
        "periodo": 202603,
        "valor": 1866115.0,
        "delta": 336416.0
      },
      {
        "periodo": 202604,
        "valor": 2034328.0,
        "delta": 168213.0
      },
      {
        "periodo": 202605,
        "valor": 2391481.0,
        "delta": 357153.0
      },
      {
        "periodo": 202606,
        "valor": 2476205.0,
        "delta": 84724.0
      },
      {
        "periodo": 202607,
        "valor": 2813195.0,
        "delta": 336990.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 459857.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -459857.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 17625636.53,
    "valor_anterior": 21698003.61,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22847211.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21584917.13,
        "delta": -1262294.06
      },
      {
        "periodo": 202509,
        "valor": 19890053.16,
        "delta": -1694863.97
      },
      {
        "periodo": 202510,
        "valor": 40494607.07,
        "delta": 20604553.91
      },
      {
        "periodo": 202511,
        "valor": 18883877.71,
        "delta": -21610729.36
      },
      {
        "periodo": 202512,
        "valor": 20368467.59,
        "delta": 1484589.88
      },
      {
        "periodo": 202601,
        "valor": 18764560.76,
        "delta": -1603906.83
      },
      {
        "periodo": 202602,
        "valor": 12245391.42,
        "delta": -6519169.34
      },
      {
        "periodo": 202603,
        "valor": 18427061.26,
        "delta": 6181669.84
      },
      {
        "periodo": 202604,
        "valor": 21468263.56,
        "delta": 3041202.3
      },
      {
        "periodo": 202605,
        "valor": 13719886.98,
        "delta": -7748376.58
      },
      {
        "periodo": 202606,
        "valor": 21698003.61,
        "delta": 7978116.63
      },
      {
        "periodo": 202607,
        "valor": 17625636.53,
        "delta": -4072367.08
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 47632250.0,
    "valor_anterior": 46234906.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 47765640.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 39825976.0,
        "delta": -7939664.0
      },
      {
        "periodo": 202509,
        "valor": 37898593.0,
        "delta": -1927383.0
      },
      {
        "periodo": 202510,
        "valor": 38983452.0,
        "delta": 1084859.0
      },
      {
        "periodo": 202511,
        "valor": 37185091.0,
        "delta": -1798361.0
      },
      {
        "periodo": 202512,
        "valor": 42458530.0,
        "delta": 5273439.0
      },
      {
        "periodo": 202601,
        "valor": 44929690.0,
        "delta": 2471160.0
      },
      {
        "periodo": 202602,
        "valor": 40945646.0,
        "delta": -3984044.0
      },
      {
        "periodo": 202603,
        "valor": 45346017.0,
        "delta": 4400371.0
      },
      {
        "periodo": 202604,
        "valor": 43396774.0,
        "delta": -1949243.0
      },
      {
        "periodo": 202605,
        "valor": 43923137.0,
        "delta": 526363.0
      },
      {
        "periodo": 202606,
        "valor": 46234906.0,
        "delta": 2311769.0
      },
      {
        "periodo": 202607,
        "valor": 47632250.0,
        "delta": 1397344.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 15109946.0,
    "valor_anterior": 15926943.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 29798647.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29627599.0,
        "delta": -171048.0
      },
      {
        "periodo": 202509,
        "valor": 21377312.0,
        "delta": -8250287.0
      },
      {
        "periodo": 202510,
        "valor": 17836251.0,
        "delta": -3541061.0
      },
      {
        "periodo": 202511,
        "valor": 16924350.0,
        "delta": -911901.0
      },
      {
        "periodo": 202512,
        "valor": 16082040.0,
        "delta": -842310.0
      },
      {
        "periodo": 202601,
        "valor": 14572385.0,
        "delta": -1509655.0
      },
      {
        "periodo": 202602,
        "valor": 14980424.0,
        "delta": 408039.0
      },
      {
        "periodo": 202603,
        "valor": 17006843.0,
        "delta": 2026419.0
      },
      {
        "periodo": 202604,
        "valor": 16696457.0,
        "delta": -310386.0
      },
      {
        "periodo": 202605,
        "valor": 16887923.0,
        "delta": 191466.0
      },
      {
        "periodo": 202606,
        "valor": 15926943.0,
        "delta": -960980.0
      },
      {
        "periodo": 202607,
        "valor": 15109946.0,
        "delta": -816997.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 680217.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 433342.0,
        "delta": -246875.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 95090.0,
    "valor_anterior": 996121.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 789754.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 696603.0,
        "delta": -93151.0
      },
      {
        "periodo": 202509,
        "valor": 581172.0,
        "delta": -115431.0
      },
      {
        "periodo": 202510,
        "valor": 631697.0,
        "delta": 50525.0
      },
      {
        "periodo": 202511,
        "valor": 575932.0,
        "delta": -55765.0
      },
      {
        "periodo": 202512,
        "valor": 689938.0,
        "delta": 114006.0
      },
      {
        "periodo": 202601,
        "valor": 539730.0,
        "delta": -150208.0
      },
      {
        "periodo": 202602,
        "valor": 746329.0,
        "delta": 206599.0
      },
      {
        "periodo": 202603,
        "valor": 467462.0,
        "delta": -278867.0
      },
      {
        "periodo": 202604,
        "valor": 455197.0,
        "delta": -12265.0
      },
      {
        "periodo": 202605,
        "valor": 477005.0,
        "delta": 21808.0
      },
      {
        "periodo": 202606,
        "valor": 996121.0,
        "delta": 519116.0
      },
      {
        "periodo": 202607,
        "valor": 95090.0,
        "delta": -901031.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 112196.0,
    "valor_anterior": 110239.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 248367.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 245418.0,
        "delta": -2949.0
      },
      {
        "periodo": 202509,
        "valor": 181706.0,
        "delta": -63712.0
      },
      {
        "periodo": 202510,
        "valor": 162210.0,
        "delta": -19496.0
      },
      {
        "periodo": 202511,
        "valor": 151934.0,
        "delta": -10276.0
      },
      {
        "periodo": 202512,
        "valor": 156186.0,
        "delta": 4252.0
      },
      {
        "periodo": 202601,
        "valor": 124401.0,
        "delta": -31785.0
      },
      {
        "periodo": 202602,
        "valor": 102157.0,
        "delta": -22244.0
      },
      {
        "periodo": 202603,
        "valor": 117022.0,
        "delta": 14865.0
      },
      {
        "periodo": 202604,
        "valor": 111853.0,
        "delta": -5169.0
      },
      {
        "periodo": 202605,
        "valor": 114494.0,
        "delta": 2641.0
      },
      {
        "periodo": 202606,
        "valor": 110239.0,
        "delta": -4255.0
      },
      {
        "periodo": 202607,
        "valor": 112196.0,
        "delta": 1957.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 9877882.839999996,
    "valor_anterior": 5880281.390000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12440614.44,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11294408.95,
        "delta": -1146205.49
      },
      {
        "periodo": 202509,
        "valor": 10815943.15,
        "delta": -478465.8
      },
      {
        "periodo": 202510,
        "valor": 10652932.06,
        "delta": -163011.09
      },
      {
        "periodo": 202511,
        "valor": 9673028.66,
        "delta": -979903.4
      },
      {
        "periodo": 202512,
        "valor": 8090299.85,
        "delta": -1582728.81
      },
      {
        "periodo": 202601,
        "valor": 7592175.62,
        "delta": -498124.23
      },
      {
        "periodo": 202602,
        "valor": 6891949.9,
        "delta": -700225.72
      },
      {
        "periodo": 202603,
        "valor": 8234719.25,
        "delta": 1342769.35
      },
      {
        "periodo": 202604,
        "valor": 7653663.27,
        "delta": -581055.98
      },
      {
        "periodo": 202605,
        "valor": 6445245.46,
        "delta": -1208417.81
      },
      {
        "periodo": 202606,
        "valor": 5880281.39,
        "delta": -564964.07
      },
      {
        "periodo": 202607,
        "valor": 9877882.84,
        "delta": 3997601.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 5243.0,
        "delta": 5243.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": -5243.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 52158483.889999986,
    "valor_anterior": 60615344.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 58150383.63,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 57171250.16,
        "delta": -979133.47
      },
      {
        "periodo": 202509,
        "valor": 54984409.03,
        "delta": -2186841.13
      },
      {
        "periodo": 202510,
        "valor": 56507352.67,
        "delta": 1522943.64
      },
      {
        "periodo": 202511,
        "valor": 59139787.18,
        "delta": 2632434.51
      },
      {
        "periodo": 202512,
        "valor": 69300902.62,
        "delta": 10161115.44
      },
      {
        "periodo": 202601,
        "valor": 59278445.88,
        "delta": -10022456.74
      },
      {
        "periodo": 202602,
        "valor": 50011857.28,
        "delta": -9266588.6
      },
      {
        "periodo": 202603,
        "valor": 61222592.13,
        "delta": 11210734.85
      },
      {
        "periodo": 202604,
        "valor": 52123789.16,
        "delta": -9098802.97
      },
      {
        "periodo": 202605,
        "valor": 56619450.62,
        "delta": 4495661.46
      },
      {
        "periodo": 202606,
        "valor": 60615344.25,
        "delta": 3995893.63
      },
      {
        "periodo": 202607,
        "valor": 52158483.89,
        "delta": -8456860.36
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 11088680.820000008,
    "valor_anterior": 11332585.21,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20616184.12,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18257711.83,
        "delta": -2358472.29
      },
      {
        "periodo": 202509,
        "valor": 15813838.82,
        "delta": -2443873.01
      },
      {
        "periodo": 202510,
        "valor": 15448873.31,
        "delta": -364965.51
      },
      {
        "periodo": 202511,
        "valor": 13843619.98,
        "delta": -1605253.33
      },
      {
        "periodo": 202512,
        "valor": 13665222.86,
        "delta": -178397.12
      },
      {
        "periodo": 202601,
        "valor": 12125767.23,
        "delta": -1539455.63
      },
      {
        "periodo": 202602,
        "valor": 10472877.88,
        "delta": -1652889.35
      },
      {
        "periodo": 202603,
        "valor": 11681969.26,
        "delta": 1209091.38
      },
      {
        "periodo": 202604,
        "valor": 12592255.42,
        "delta": 910286.16
      },
      {
        "periodo": 202605,
        "valor": 12505546.86,
        "delta": -86708.56
      },
      {
        "periodo": 202606,
        "valor": 11332585.21,
        "delta": -1172961.65
      },
      {
        "periodo": 202607,
        "valor": 11088680.82,
        "delta": -243904.39
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 4382024.0,
    "valor_anterior": 3521427.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5388286.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5923052.0,
        "delta": 534766.0
      },
      {
        "periodo": 202509,
        "valor": 5555018.0,
        "delta": -368034.0
      },
      {
        "periodo": 202510,
        "valor": 5660800.0,
        "delta": 105782.0
      },
      {
        "periodo": 202511,
        "valor": 5648661.0,
        "delta": -12139.0
      },
      {
        "periodo": 202512,
        "valor": 4096123.0,
        "delta": -1552538.0
      },
      {
        "periodo": 202601,
        "valor": 6660056.0,
        "delta": 2563933.0
      },
      {
        "periodo": 202602,
        "valor": 3562994.0,
        "delta": -3097062.0
      },
      {
        "periodo": 202603,
        "valor": 3920829.0,
        "delta": 357835.0
      },
      {
        "periodo": 202604,
        "valor": 3387117.0,
        "delta": -533712.0
      },
      {
        "periodo": 202605,
        "valor": 3922225.0,
        "delta": 535108.0
      },
      {
        "periodo": 202606,
        "valor": 3521427.0,
        "delta": -400798.0
      },
      {
        "periodo": 202607,
        "valor": 4382024.0,
        "delta": 860597.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 244707755.0,
    "valor_anterior": 246688503.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 276602769.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 276972429.0,
        "delta": 369660.0
      },
      {
        "periodo": 202509,
        "valor": 252144330.0,
        "delta": -24828099.0
      },
      {
        "periodo": 202510,
        "valor": 257396670.0,
        "delta": 5252340.0
      },
      {
        "periodo": 202511,
        "valor": 256607642.0,
        "delta": -789028.0
      },
      {
        "periodo": 202512,
        "valor": 279451967.0,
        "delta": 22844325.0
      },
      {
        "periodo": 202601,
        "valor": 274677294.0,
        "delta": -4774673.0
      },
      {
        "periodo": 202602,
        "valor": 247835599.0,
        "delta": -26841695.0
      },
      {
        "periodo": 202603,
        "valor": 290760144.0,
        "delta": 42924545.0
      },
      {
        "periodo": 202604,
        "valor": 284819543.0,
        "delta": -5940601.0
      },
      {
        "periodo": 202605,
        "valor": 275885948.0,
        "delta": -8933595.0
      },
      {
        "periodo": 202606,
        "valor": 246688503.0,
        "delta": -29197445.0
      },
      {
        "periodo": 202607,
        "valor": 244707755.0,
        "delta": -1980748.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 10385518.0,
    "valor_anterior": 9213707.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13129118.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13855721.0,
        "delta": 726603.0
      },
      {
        "periodo": 202509,
        "valor": 12858253.0,
        "delta": -997468.0
      },
      {
        "periodo": 202510,
        "valor": 12614485.0,
        "delta": -243768.0
      },
      {
        "periodo": 202511,
        "valor": 11307625.0,
        "delta": -1306860.0
      },
      {
        "periodo": 202512,
        "valor": 11160461.0,
        "delta": -147164.0
      },
      {
        "periodo": 202601,
        "valor": 10772364.0,
        "delta": -388097.0
      },
      {
        "periodo": 202602,
        "valor": 9213120.0,
        "delta": -1559244.0
      },
      {
        "periodo": 202603,
        "valor": 10219434.0,
        "delta": 1006314.0
      },
      {
        "periodo": 202604,
        "valor": 9165819.0,
        "delta": -1053615.0
      },
      {
        "periodo": 202605,
        "valor": 9377134.0,
        "delta": 211315.0
      },
      {
        "periodo": 202606,
        "valor": 9213707.0,
        "delta": -163427.0
      },
      {
        "periodo": 202607,
        "valor": 10385518.0,
        "delta": 1171811.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 830040.4699999997,
    "valor_anterior": 835646.3500000006,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4845914.75,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4596872.25,
        "delta": -249042.5
      },
      {
        "periodo": 202509,
        "valor": 4346888.99,
        "delta": -249983.26
      },
      {
        "periodo": 202510,
        "valor": 4764660.59,
        "delta": 417771.6
      },
      {
        "periodo": 202511,
        "valor": 4480261.42,
        "delta": -284399.17
      },
      {
        "periodo": 202512,
        "valor": 1176108.77,
        "delta": -3304152.65
      },
      {
        "periodo": 202601,
        "valor": 1018701.47,
        "delta": -157407.3
      },
      {
        "periodo": 202602,
        "valor": 885297.45,
        "delta": -133404.02
      },
      {
        "periodo": 202603,
        "valor": 960866.47,
        "delta": 75569.02
      },
      {
        "periodo": 202604,
        "valor": 894706.21,
        "delta": -66160.26
      },
      {
        "periodo": 202605,
        "valor": 885740.04,
        "delta": -8966.17
      },
      {
        "periodo": 202606,
        "valor": 835646.35,
        "delta": -50093.69
      },
      {
        "periodo": 202607,
        "valor": 830040.47,
        "delta": -5605.88
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 14449723.180000007,
    "valor_anterior": 12998836.130000003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20093163.1,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19210651.8,
        "delta": -882511.3
      },
      {
        "periodo": 202509,
        "valor": 13642241.18,
        "delta": -5568410.62
      },
      {
        "periodo": 202510,
        "valor": 11830351.62,
        "delta": -1811889.56
      },
      {
        "periodo": 202511,
        "valor": 12345162.69,
        "delta": 514811.07
      },
      {
        "periodo": 202512,
        "valor": 11233748.91,
        "delta": -1111413.78
      },
      {
        "periodo": 202601,
        "valor": 11876143.63,
        "delta": 642394.72
      },
      {
        "periodo": 202602,
        "valor": 11679384.86,
        "delta": -196758.77
      },
      {
        "periodo": 202603,
        "valor": 11875491.19,
        "delta": 196106.33
      },
      {
        "periodo": 202604,
        "valor": 11715016.67,
        "delta": -160474.52
      },
      {
        "periodo": 202605,
        "valor": 15276464.77,
        "delta": 3561448.1
      },
      {
        "periodo": 202606,
        "valor": 12998836.13,
        "delta": -2277628.64
      },
      {
        "periodo": 202607,
        "valor": 14449723.18,
        "delta": 1450887.05
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 0.0,
    "valor_anterior": 45.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 36166.0,
        "delta": 36166.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": -36166.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 1.0
      },
      {
        "periodo": 202512,
        "valor": -36166.0,
        "delta": -36167.0
      },
      {
        "periodo": 202601,
        "valor": 244.0,
        "delta": 36410.0
      },
      {
        "periodo": 202602,
        "valor": 361.0,
        "delta": 117.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": -361.0
      },
      {
        "periodo": 202604,
        "valor": 27427.0,
        "delta": 27427.0
      },
      {
        "periodo": 202605,
        "valor": -27420.0,
        "delta": -54847.0
      },
      {
        "periodo": 202606,
        "valor": 45.0,
        "delta": 27465.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": -45.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 13122465.0,
    "valor_anterior": 12578082.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15138049.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14743195.0,
        "delta": -394854.0
      },
      {
        "periodo": 202509,
        "valor": 13480484.0,
        "delta": -1262711.0
      },
      {
        "periodo": 202510,
        "valor": 14406826.0,
        "delta": 926342.0
      },
      {
        "periodo": 202511,
        "valor": 13415108.0,
        "delta": -991718.0
      },
      {
        "periodo": 202512,
        "valor": 13471645.0,
        "delta": 56537.0
      },
      {
        "periodo": 202601,
        "valor": 12564745.0,
        "delta": -906900.0
      },
      {
        "periodo": 202602,
        "valor": 11108296.0,
        "delta": -1456449.0
      },
      {
        "periodo": 202603,
        "valor": 13737298.0,
        "delta": 2629002.0
      },
      {
        "periodo": 202604,
        "valor": 11869812.0,
        "delta": -1867486.0
      },
      {
        "periodo": 202605,
        "valor": 12579897.0,
        "delta": 710085.0
      },
      {
        "periodo": 202606,
        "valor": 12578082.0,
        "delta": -1815.0
      },
      {
        "periodo": 202607,
        "valor": 13122465.0,
        "delta": 544383.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 0.0,
    "valor_anterior": 18055.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4819.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 258369.0,
        "delta": 253550.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -258369.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 10061.0,
        "delta": 10061.0
      },
      {
        "periodo": 202601,
        "valor": 2421.0,
        "delta": -7640.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -2421.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 18055.0,
        "delta": 18055.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": -18055.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 0.0,
    "valor_anterior": 817.17,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 6694693.11,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": -6694693.11
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 817.17,
        "delta": 817.17
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": -817.17
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 139542916.0,
    "valor_anterior": 150618287.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 543086971.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 194757976.0,
        "delta": -348328995.0
      },
      {
        "periodo": 202605,
        "valor": 162034164.0,
        "delta": -32723812.0
      },
      {
        "periodo": 202606,
        "valor": 150618287.0,
        "delta": -11415877.0
      },
      {
        "periodo": 202607,
        "valor": 139542916.0,
        "delta": -11075371.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 2395774825.090002,
    "valor_anterior": 2346697257.3099995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4231977913.21,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1441994480.48,
        "delta": -2789983432.73
      },
      {
        "periodo": 202509,
        "valor": 2413925280.72,
        "delta": 971930800.24
      },
      {
        "periodo": 202510,
        "valor": 2743421999.99,
        "delta": 329496719.27
      },
      {
        "periodo": 202511,
        "valor": 2586586797.12,
        "delta": -156835202.87
      },
      {
        "periodo": 202512,
        "valor": 2617702773.48,
        "delta": 31115976.36
      },
      {
        "periodo": 202601,
        "valor": 2638639901.31,
        "delta": 20937127.83
      },
      {
        "periodo": 202602,
        "valor": 2186725846.06,
        "delta": -451914055.25
      },
      {
        "periodo": 202603,
        "valor": 2958186204.39,
        "delta": 771460358.33
      },
      {
        "periodo": 202604,
        "valor": 2419808807.09,
        "delta": -538377397.3
      },
      {
        "periodo": 202605,
        "valor": 2474568904.36,
        "delta": 54760097.27
      },
      {
        "periodo": 202606,
        "valor": 2346697257.31,
        "delta": -127871647.05
      },
      {
        "periodo": 202607,
        "valor": 2395774825.09,
        "delta": 49077567.78
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 893907049.5100002,
    "valor_anterior": 885065264.1800003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2602874665.67,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -121115586.9,
        "delta": -2723990252.57
      },
      {
        "periodo": 202509,
        "valor": 1143682131.15,
        "delta": 1264797718.05
      },
      {
        "periodo": 202510,
        "valor": 1284232143.46,
        "delta": 140550012.31
      },
      {
        "periodo": 202511,
        "valor": 1182864768.72,
        "delta": -101367374.74
      },
      {
        "periodo": 202512,
        "valor": 1167226587.94,
        "delta": -15638180.78
      },
      {
        "periodo": 202601,
        "valor": 1144338043.77,
        "delta": -22888544.17
      },
      {
        "periodo": 202602,
        "valor": 851977734.55,
        "delta": -292360309.22
      },
      {
        "periodo": 202603,
        "valor": 918794837.45,
        "delta": 66817102.9
      },
      {
        "periodo": 202604,
        "valor": 836963283.04,
        "delta": -81831554.41
      },
      {
        "periodo": 202605,
        "valor": 901862565.67,
        "delta": 64899282.63
      },
      {
        "periodo": 202606,
        "valor": 885065264.18,
        "delta": -16797301.49
      },
      {
        "periodo": 202607,
        "valor": 893907049.51,
        "delta": 8841785.33
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 11695819.960000008,
    "valor_anterior": 14030986.829999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26090154.35,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13248291.39,
        "delta": -12841862.96
      },
      {
        "periodo": 202509,
        "valor": 8598553.78,
        "delta": -4649737.61
      },
      {
        "periodo": 202510,
        "valor": 13299242.57,
        "delta": 4700688.79
      },
      {
        "periodo": 202511,
        "valor": 11944294.62,
        "delta": -1354947.95
      },
      {
        "periodo": 202512,
        "valor": 12911541.95,
        "delta": 967247.33
      },
      {
        "periodo": 202601,
        "valor": 11369232.99,
        "delta": -1542308.96
      },
      {
        "periodo": 202602,
        "valor": 11106726.84,
        "delta": -262506.15
      },
      {
        "periodo": 202603,
        "valor": 12036228.31,
        "delta": 929501.47
      },
      {
        "periodo": 202604,
        "valor": 13224539.01,
        "delta": 1188310.7
      },
      {
        "periodo": 202605,
        "valor": 13826013.51,
        "delta": 601474.5
      },
      {
        "periodo": 202606,
        "valor": 14030986.83,
        "delta": 204973.32
      },
      {
        "periodo": 202607,
        "valor": 11695819.96,
        "delta": -2335166.87
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 224251854.5500002,
    "valor_anterior": 199677448.76,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 347741899.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 354714385.4,
        "delta": 6972485.68
      },
      {
        "periodo": 202509,
        "valor": 134561833.7,
        "delta": -220152551.7
      },
      {
        "periodo": 202510,
        "valor": 299707561.04,
        "delta": 165145727.34
      },
      {
        "periodo": 202511,
        "valor": 288294123.08,
        "delta": -11413437.96
      },
      {
        "periodo": 202512,
        "valor": 254016454.3,
        "delta": -34277668.78
      },
      {
        "periodo": 202601,
        "valor": 249699871.7,
        "delta": -4316582.6
      },
      {
        "periodo": 202602,
        "valor": 226996854.75,
        "delta": -22703016.95
      },
      {
        "periodo": 202603,
        "valor": 256631502.21,
        "delta": 29634647.46
      },
      {
        "periodo": 202604,
        "valor": 224469207.1,
        "delta": -32162295.11
      },
      {
        "periodo": 202605,
        "valor": 236831600.81,
        "delta": 12362393.71
      },
      {
        "periodo": 202606,
        "valor": 199677448.76,
        "delta": -37154152.05
      },
      {
        "periodo": 202607,
        "valor": 224251854.55,
        "delta": 24574405.79
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 788309924.4000006,
    "valor_anterior": 758479396.8099995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 815472877.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 788771202.87,
        "delta": -26701675.06
      },
      {
        "periodo": 202509,
        "valor": 736569123.54,
        "delta": -52202079.33
      },
      {
        "periodo": 202510,
        "valor": 743870209.66,
        "delta": 7301086.12
      },
      {
        "periodo": 202511,
        "valor": 733521790.71,
        "delta": -10348418.95
      },
      {
        "periodo": 202512,
        "valor": 816883041.66,
        "delta": 83361250.95
      },
      {
        "periodo": 202601,
        "valor": 875108151.69,
        "delta": 58225110.03
      },
      {
        "periodo": 202602,
        "valor": 780555602.06,
        "delta": -94552549.63
      },
      {
        "periodo": 202603,
        "valor": 870466676.82,
        "delta": 89911074.76
      },
      {
        "periodo": 202604,
        "valor": 827524246.53,
        "delta": -42942430.29
      },
      {
        "periodo": 202605,
        "valor": 820871437.91,
        "delta": -6652808.62
      },
      {
        "periodo": 202606,
        "valor": 758479396.81,
        "delta": -62392041.1
      },
      {
        "periodo": 202607,
        "valor": 788309924.4,
        "delta": 29830527.59
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 120142075.20000005,
    "valor_anterior": 120514036.32999992,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 153119543.04,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 148107837.99,
        "delta": -5011705.05
      },
      {
        "periodo": 202509,
        "valor": 134237314.93,
        "delta": -13870523.06
      },
      {
        "periodo": 202510,
        "valor": 134573093.25,
        "delta": 335778.32
      },
      {
        "periodo": 202511,
        "valor": 132626597.93,
        "delta": -1946495.32
      },
      {
        "periodo": 202512,
        "valor": 135691368.01,
        "delta": 3064770.08
      },
      {
        "periodo": 202601,
        "valor": 125140589.83,
        "delta": -10550778.18
      },
      {
        "periodo": 202602,
        "valor": 106547048.37,
        "delta": -18593541.46
      },
      {
        "periodo": 202603,
        "valor": 124986987.3,
        "delta": 18439938.93
      },
      {
        "periodo": 202604,
        "valor": 112646673.73,
        "delta": -12340313.57
      },
      {
        "periodo": 202605,
        "valor": 121189907.75,
        "delta": 8543234.02
      },
      {
        "periodo": 202606,
        "valor": 120514036.33,
        "delta": -675871.42
      },
      {
        "periodo": 202607,
        "valor": 120142075.2,
        "delta": -371961.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100120,
    "label": "Intereses por Prest. Interb.",
    "valor_actual": 357468101.47000027,
    "valor_anterior": 368930124.39999986,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 286678772.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 258268349.73,
        "delta": -28410422.77
      },
      {
        "periodo": 202509,
        "valor": 256276323.62,
        "delta": -1992026.11
      },
      {
        "periodo": 202510,
        "valor": 267739750.01,
        "delta": 11463426.39
      },
      {
        "periodo": 202511,
        "valor": 237335222.06,
        "delta": -30404527.95
      },
      {
        "periodo": 202512,
        "valor": 230973779.62,
        "delta": -6361442.44
      },
      {
        "periodo": 202601,
        "valor": 232984011.33,
        "delta": 2010231.71
      },
      {
        "periodo": 202602,
        "valor": 209541879.49,
        "delta": -23442131.84
      },
      {
        "periodo": 202603,
        "valor": 775269972.3,
        "delta": 565728092.81
      },
      {
        "periodo": 202604,
        "valor": 404980857.68,
        "delta": -370289114.62
      },
      {
        "periodo": 202605,
        "valor": 379987378.71,
        "delta": -24993478.97
      },
      {
        "periodo": 202606,
        "valor": 368930124.4,
        "delta": -11057254.31
      },
      {
        "periodo": 202607,
        "valor": 357468101.47,
        "delta": -11462022.93
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 2314025886.619999,
    "valor_anterior": 2675479264.039999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1773148752.21,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2027253599.34,
        "delta": 254104847.13
      },
      {
        "periodo": 202509,
        "valor": 2621836750.06,
        "delta": 594583150.72
      },
      {
        "periodo": 202510,
        "valor": 2594043845.33,
        "delta": -27792904.73
      },
      {
        "periodo": 202511,
        "valor": 2483089380.81,
        "delta": -110954464.52
      },
      {
        "periodo": 202512,
        "valor": 2509981167.52,
        "delta": 26891786.71
      },
      {
        "periodo": 202601,
        "valor": 2244641534.1,
        "delta": -265339633.42
      },
      {
        "periodo": 202602,
        "valor": 2006948706.14,
        "delta": -237692827.96
      },
      {
        "periodo": 202603,
        "valor": 2721332370.07,
        "delta": 714383663.93
      },
      {
        "periodo": 202604,
        "valor": 2718475085.6,
        "delta": -2857284.47
      },
      {
        "periodo": 202605,
        "valor": 2555145449.96,
        "delta": -163329635.64
      },
      {
        "periodo": 202606,
        "valor": 2675479264.04,
        "delta": 120333814.08
      },
      {
        "periodo": 202607,
        "valor": 2314025886.62,
        "delta": -361453377.42
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 5580627923.089996,
    "valor_anterior": 6471428834.730003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5267918150.2,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5122474372.63,
        "delta": -145443777.57
      },
      {
        "periodo": 202509,
        "valor": 5138245983.44,
        "delta": 15771610.81
      },
      {
        "periodo": 202510,
        "valor": 5716949389.37,
        "delta": 578703405.93
      },
      {
        "periodo": 202511,
        "valor": 5485773508.51,
        "delta": -231175880.86
      },
      {
        "periodo": 202512,
        "valor": 5865226011.63,
        "delta": 379452503.12
      },
      {
        "periodo": 202601,
        "valor": 5303200082.91,
        "delta": -562025928.72
      },
      {
        "periodo": 202602,
        "valor": 9064976559.53,
        "delta": 3761776476.62
      },
      {
        "periodo": 202603,
        "valor": 6934622226.31,
        "delta": -2130354333.22
      },
      {
        "periodo": 202604,
        "valor": 5275076411.22,
        "delta": -1659545815.09
      },
      {
        "periodo": 202605,
        "valor": 6381103913.28,
        "delta": 1106027502.06
      },
      {
        "periodo": 202606,
        "valor": 6471428834.73,
        "delta": 90324921.45
      },
      {
        "periodo": 202607,
        "valor": 5580627923.09,
        "delta": -890800911.64
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 2472667263.0,
    "valor_anterior": 1264924961.999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1890346476.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1954019737.0,
        "delta": 63673261.0
      },
      {
        "periodo": 202509,
        "valor": 2544324096.0,
        "delta": 590304359.0
      },
      {
        "periodo": 202510,
        "valor": 2171447045.0,
        "delta": -372877051.0
      },
      {
        "periodo": 202511,
        "valor": 2604949959.0,
        "delta": 433502914.0
      },
      {
        "periodo": 202512,
        "valor": 2227296577.0,
        "delta": -377653382.0
      },
      {
        "periodo": 202601,
        "valor": 1900825005.0,
        "delta": -326471572.0
      },
      {
        "periodo": 202602,
        "valor": 2463755885.0,
        "delta": 562930880.0
      },
      {
        "periodo": 202603,
        "valor": 2164742834.0,
        "delta": -299013051.0
      },
      {
        "periodo": 202604,
        "valor": 2108637614.0,
        "delta": -56105220.0
      },
      {
        "periodo": 202605,
        "valor": 4430710028.0,
        "delta": 2322072414.0
      },
      {
        "periodo": 202606,
        "valor": 1264924962.0,
        "delta": -3165785066.0
      },
      {
        "periodo": 202607,
        "valor": 2472667263.0,
        "delta": 1207742301.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 1207115211.000001,
    "valor_anterior": 981636291.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1307368921.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 924841087.0,
        "delta": -382527834.0
      },
      {
        "periodo": 202509,
        "valor": 1042434066.0,
        "delta": 117592979.0
      },
      {
        "periodo": 202510,
        "valor": 1412691155.0,
        "delta": 370257089.0
      },
      {
        "periodo": 202511,
        "valor": 865774107.0,
        "delta": -546917048.0
      },
      {
        "periodo": 202512,
        "valor": 938374076.0,
        "delta": 72599969.0
      },
      {
        "periodo": 202601,
        "valor": 770238259.0,
        "delta": -168135817.0
      },
      {
        "periodo": 202602,
        "valor": 862387979.0,
        "delta": 92149720.0
      },
      {
        "periodo": 202603,
        "valor": 631658713.0,
        "delta": -230729266.0
      },
      {
        "periodo": 202604,
        "valor": 779913746.0,
        "delta": 148255033.0
      },
      {
        "periodo": 202605,
        "valor": 909749496.0,
        "delta": 129835750.0
      },
      {
        "periodo": 202606,
        "valor": 981636292.0,
        "delta": 71886796.0
      },
      {
        "periodo": 202607,
        "valor": 1207115211.0,
        "delta": 225478919.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 331749770.1999999,
    "valor_anterior": 141889541.0300001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 313477408.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 74095524.39,
        "delta": -239381884.54
      },
      {
        "periodo": 202509,
        "valor": 337869231.96,
        "delta": 263773707.57
      },
      {
        "periodo": 202510,
        "valor": 178585114.65,
        "delta": -159284117.31
      },
      {
        "periodo": 202511,
        "valor": 27003749.67,
        "delta": -151581364.98
      },
      {
        "periodo": 202512,
        "valor": 303401643.15,
        "delta": 276397893.48
      },
      {
        "periodo": 202601,
        "valor": 107417929.1,
        "delta": -195983714.05
      },
      {
        "periodo": 202602,
        "valor": 210016504.07,
        "delta": 102598574.97
      },
      {
        "periodo": 202603,
        "valor": 76149714.46,
        "delta": -133866789.61
      },
      {
        "periodo": 202604,
        "valor": 127249729.73,
        "delta": 51100015.27
      },
      {
        "periodo": 202605,
        "valor": 129872847.44,
        "delta": 2623117.71
      },
      {
        "periodo": 202606,
        "valor": 141889541.03,
        "delta": 12016693.59
      },
      {
        "periodo": 202607,
        "valor": 331749770.2,
        "delta": 189860229.17
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 827840006.999999,
    "valor_anterior": 740272737.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 461066849.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 612300327.0,
        "delta": 151233478.0
      },
      {
        "periodo": 202509,
        "valor": 501382735.0,
        "delta": -110917592.0
      },
      {
        "periodo": 202510,
        "valor": 671842583.0,
        "delta": 170459848.0
      },
      {
        "periodo": 202511,
        "valor": 436995728.0,
        "delta": -234846855.0
      },
      {
        "periodo": 202512,
        "valor": 395003214.0,
        "delta": -41992514.0
      },
      {
        "periodo": 202601,
        "valor": 675860217.0,
        "delta": 280857003.0
      },
      {
        "periodo": 202602,
        "valor": 671364325.0,
        "delta": -4495892.0
      },
      {
        "periodo": 202603,
        "valor": 883178423.0,
        "delta": 211814098.0
      },
      {
        "periodo": 202604,
        "valor": 1069300804.0,
        "delta": 186122381.0
      },
      {
        "periodo": 202605,
        "valor": 603315332.0,
        "delta": -465985472.0
      },
      {
        "periodo": 202606,
        "valor": 740272737.0,
        "delta": 136957405.0
      },
      {
        "periodo": 202607,
        "valor": 827840007.0,
        "delta": 87567270.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": -24428061.0,
    "valor_anterior": 41656388.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 43540118.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 36564018.0,
        "delta": -6976100.0
      },
      {
        "periodo": 202509,
        "valor": 44531244.0,
        "delta": 7967226.0
      },
      {
        "periodo": 202510,
        "valor": 36164224.0,
        "delta": -8367020.0
      },
      {
        "periodo": 202511,
        "valor": 51490759.0,
        "delta": 15326535.0
      },
      {
        "periodo": 202512,
        "valor": 84537169.0,
        "delta": 33046410.0
      },
      {
        "periodo": 202601,
        "valor": 46156204.0,
        "delta": -38380965.0
      },
      {
        "periodo": 202602,
        "valor": 52261935.0,
        "delta": 6105731.0
      },
      {
        "periodo": 202603,
        "valor": 76095336.0,
        "delta": 23833401.0
      },
      {
        "periodo": 202604,
        "valor": 86135296.0,
        "delta": 10039960.0
      },
      {
        "periodo": 202605,
        "valor": 76387544.0,
        "delta": -9747752.0
      },
      {
        "periodo": 202606,
        "valor": 41656388.0,
        "delta": -34731156.0
      },
      {
        "periodo": 202607,
        "valor": -24428061.0,
        "delta": -66084449.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 199537427.0,
    "valor_anterior": 302770368.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 709080501.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 675894010.0,
        "delta": -33186491.0
      },
      {
        "periodo": 202509,
        "valor": 807633449.0,
        "delta": 131739439.0
      },
      {
        "periodo": 202510,
        "valor": 645518123.0,
        "delta": -162115326.0
      },
      {
        "periodo": 202511,
        "valor": 841696798.0,
        "delta": 196178675.0
      },
      {
        "periodo": 202512,
        "valor": 266518075.0,
        "delta": -575178723.0
      },
      {
        "periodo": 202601,
        "valor": 316946624.0,
        "delta": 50428549.0
      },
      {
        "periodo": 202602,
        "valor": 519076359.0,
        "delta": 202129735.0
      },
      {
        "periodo": 202603,
        "valor": 406023941.0,
        "delta": -113052418.0
      },
      {
        "periodo": 202604,
        "valor": 982858268.0,
        "delta": 576834327.0
      },
      {
        "periodo": 202605,
        "valor": 695822642.0,
        "delta": -287035626.0
      },
      {
        "periodo": 202606,
        "valor": 302770368.0,
        "delta": -393052274.0
      },
      {
        "periodo": 202607,
        "valor": 199537427.0,
        "delta": -103232941.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 111074237.29999995,
    "valor_anterior": 176348459.87,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 153265245.6,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 191198022.06,
        "delta": 37932776.46
      },
      {
        "periodo": 202509,
        "valor": 114799832.14,
        "delta": -76398189.92
      },
      {
        "periodo": 202510,
        "valor": 225137956.03,
        "delta": 110338123.89
      },
      {
        "periodo": 202511,
        "valor": 126214012.65,
        "delta": -98923943.38
      },
      {
        "periodo": 202512,
        "valor": 119741235.62,
        "delta": -6472777.03
      },
      {
        "periodo": 202601,
        "valor": 169691534.66,
        "delta": 49950299.04
      },
      {
        "periodo": 202602,
        "valor": 100806444.79,
        "delta": -68885089.87
      },
      {
        "periodo": 202603,
        "valor": 93056096.71,
        "delta": -7750348.08
      },
      {
        "periodo": 202604,
        "valor": 61374115.81,
        "delta": -31681980.9
      },
      {
        "periodo": 202605,
        "valor": 127407132.86,
        "delta": 66033017.05
      },
      {
        "periodo": 202606,
        "valor": 176348459.87,
        "delta": 48941327.01
      },
      {
        "periodo": 202607,
        "valor": 111074237.3,
        "delta": -65274222.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 535692913.0,
    "valor_anterior": 460727665.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 379207353.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 380740923.0,
        "delta": 1533570.0
      },
      {
        "periodo": 202509,
        "valor": 369549782.0,
        "delta": -11191141.0
      },
      {
        "periodo": 202510,
        "valor": 461421160.0,
        "delta": 91871378.0
      },
      {
        "periodo": 202511,
        "valor": 532181942.0,
        "delta": 70760782.0
      },
      {
        "periodo": 202512,
        "valor": 451366066.0,
        "delta": -80815876.0
      },
      {
        "periodo": 202601,
        "valor": 667681511.0,
        "delta": 216315445.0
      },
      {
        "periodo": 202602,
        "valor": 465247796.0,
        "delta": -202433715.0
      },
      {
        "periodo": 202603,
        "valor": 509821898.0,
        "delta": 44574102.0
      },
      {
        "periodo": 202604,
        "valor": 497112497.0,
        "delta": -12709401.0
      },
      {
        "periodo": 202605,
        "valor": 464308982.0,
        "delta": -32803515.0
      },
      {
        "periodo": 202606,
        "valor": 460727665.0,
        "delta": -3581317.0
      },
      {
        "periodo": 202607,
        "valor": 535692913.0,
        "delta": 74965248.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 17446996.0,
    "valor_anterior": 17046393.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 32229056.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17502998.0,
        "delta": -14726058.0
      },
      {
        "periodo": 202509,
        "valor": 17451075.0,
        "delta": -51923.0
      },
      {
        "periodo": 202510,
        "valor": 17629996.0,
        "delta": 178921.0
      },
      {
        "periodo": 202511,
        "valor": 17688003.0,
        "delta": 58007.0
      },
      {
        "periodo": 202512,
        "valor": 17789550.0,
        "delta": 101547.0
      },
      {
        "periodo": 202601,
        "valor": 16249997.0,
        "delta": -1539553.0
      },
      {
        "periodo": 202602,
        "valor": 17391003.0,
        "delta": 1141006.0
      },
      {
        "periodo": 202603,
        "valor": 17951964.0,
        "delta": 560961.0
      },
      {
        "periodo": 202604,
        "valor": 17465001.0,
        "delta": -486963.0
      },
      {
        "periodo": 202605,
        "valor": 17425003.0,
        "delta": -39998.0
      },
      {
        "periodo": 202606,
        "valor": 17046393.0,
        "delta": -378610.0
      },
      {
        "periodo": 202607,
        "valor": 17446996.0,
        "delta": 400603.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 254945306.0,
    "valor_anterior": 149552928.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 143770701.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 108804829.0,
        "delta": -34965872.0
      },
      {
        "periodo": 202509,
        "valor": 169764683.0,
        "delta": 60959854.0
      },
      {
        "periodo": 202510,
        "valor": 142690913.0,
        "delta": -27073770.0
      },
      {
        "periodo": 202511,
        "valor": 123821398.0,
        "delta": -18869515.0
      },
      {
        "periodo": 202512,
        "valor": 966451425.0,
        "delta": 842630027.0
      },
      {
        "periodo": 202601,
        "valor": 136501322.0,
        "delta": -829950103.0
      },
      {
        "periodo": 202602,
        "valor": 146104809.0,
        "delta": 9603487.0
      },
      {
        "periodo": 202603,
        "valor": 158821425.0,
        "delta": 12716616.0
      },
      {
        "periodo": 202604,
        "valor": 108324594.0,
        "delta": -50496831.0
      },
      {
        "periodo": 202605,
        "valor": 223996730.0,
        "delta": 115672136.0
      },
      {
        "periodo": 202606,
        "valor": 149552928.0,
        "delta": -74443802.0
      },
      {
        "periodo": 202607,
        "valor": 254945306.0,
        "delta": 105392378.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 2517040313.960001,
    "valor_anterior": 1805398987.9899998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1775221975.52,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2007329342.17,
        "delta": 232107366.65
      },
      {
        "periodo": 202509,
        "valor": 3490874129.08,
        "delta": 1483544786.91
      },
      {
        "periodo": 202510,
        "valor": 1724001057.38,
        "delta": -1766873071.7
      },
      {
        "periodo": 202511,
        "valor": 1978954332.9,
        "delta": 254953275.52
      },
      {
        "periodo": 202512,
        "valor": 604992376.19,
        "delta": -1373961956.71
      },
      {
        "periodo": 202601,
        "valor": 2495622939.49,
        "delta": 1890630563.3
      },
      {
        "periodo": 202602,
        "valor": 1940451925.51,
        "delta": -555171013.98
      },
      {
        "periodo": 202603,
        "valor": 2273819347.56,
        "delta": 333367422.05
      },
      {
        "periodo": 202604,
        "valor": 2056118533.58,
        "delta": -217700813.98
      },
      {
        "periodo": 202605,
        "valor": 2310465564.94,
        "delta": 254347031.36
      },
      {
        "periodo": 202606,
        "valor": 1805398987.99,
        "delta": -505066576.95
      },
      {
        "periodo": 202607,
        "valor": 2517040313.96,
        "delta": 711641325.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": -10175075.0,
    "valor_anterior": 21775638.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 110504762.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2274337.0,
        "delta": -112779099.0
      },
      {
        "periodo": 202509,
        "valor": 98403195.0,
        "delta": 100677532.0
      },
      {
        "periodo": 202510,
        "valor": -71383705.0,
        "delta": -169786900.0
      },
      {
        "periodo": 202511,
        "valor": -22729475.0,
        "delta": 48654230.0
      },
      {
        "periodo": 202512,
        "valor": 831936.0,
        "delta": 23561411.0
      },
      {
        "periodo": 202601,
        "valor": -30494908.0,
        "delta": -31326844.0
      },
      {
        "periodo": 202602,
        "valor": 14398004.0,
        "delta": 44892912.0
      },
      {
        "periodo": 202603,
        "valor": -10364488.0,
        "delta": -24762492.0
      },
      {
        "periodo": 202604,
        "valor": -32620549.0,
        "delta": -22256061.0
      },
      {
        "periodo": 202605,
        "valor": -35742342.0,
        "delta": -3121793.0
      },
      {
        "periodo": 202606,
        "valor": 21775638.0,
        "delta": 57517980.0
      },
      {
        "periodo": 202607,
        "valor": -10175075.0,
        "delta": -31950713.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": -4822637.0,
    "valor_anterior": 14970656.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -5708482.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4143497.0,
        "delta": 9851979.0
      },
      {
        "periodo": 202509,
        "valor": -7936288.0,
        "delta": -12079785.0
      },
      {
        "periodo": 202510,
        "valor": 19294656.0,
        "delta": 27230944.0
      },
      {
        "periodo": 202511,
        "valor": -7810011.0,
        "delta": -27104667.0
      },
      {
        "periodo": 202512,
        "valor": -7585532.0,
        "delta": 224479.0
      },
      {
        "periodo": 202601,
        "valor": -9610623.0,
        "delta": -2025091.0
      },
      {
        "periodo": 202602,
        "valor": 20955520.0,
        "delta": 30566143.0
      },
      {
        "periodo": 202603,
        "valor": 13252784.0,
        "delta": -7702736.0
      },
      {
        "periodo": 202604,
        "valor": -9387715.0,
        "delta": -22640499.0
      },
      {
        "periodo": 202605,
        "valor": -22500529.0,
        "delta": -13112814.0
      },
      {
        "periodo": 202606,
        "valor": 14970656.0,
        "delta": 37471185.0
      },
      {
        "periodo": 202607,
        "valor": -4822637.0,
        "delta": -19793293.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 637986.0,
    "valor_anterior": 3457339.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2918240.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1812648.0,
        "delta": 4730888.0
      },
      {
        "periodo": 202509,
        "valor": -12299667.0,
        "delta": -14112315.0
      },
      {
        "periodo": 202510,
        "valor": -5044681.0,
        "delta": 7254986.0
      },
      {
        "periodo": 202511,
        "valor": 1582994.0,
        "delta": 6627675.0
      },
      {
        "periodo": 202512,
        "valor": 31594665.0,
        "delta": 30011671.0
      },
      {
        "periodo": 202601,
        "valor": 9887921.0,
        "delta": -21706744.0
      },
      {
        "periodo": 202602,
        "valor": 9437667.0,
        "delta": -450254.0
      },
      {
        "periodo": 202603,
        "valor": -16749935.0,
        "delta": -26187602.0
      },
      {
        "periodo": 202604,
        "valor": -187767.0,
        "delta": 16562168.0
      },
      {
        "periodo": 202605,
        "valor": 2006481.0,
        "delta": 2194248.0
      },
      {
        "periodo": 202606,
        "valor": 3457339.0,
        "delta": 1450858.0
      },
      {
        "periodo": 202607,
        "valor": 637986.0,
        "delta": -2819353.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 18755472.519999996,
    "valor_anterior": 419383.1400000006,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17301180.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1607705.22,
        "delta": -18908885.96
      },
      {
        "periodo": 202509,
        "valor": 52076.29,
        "delta": 1659781.51
      },
      {
        "periodo": 202510,
        "valor": 28144376.16,
        "delta": 28092299.87
      },
      {
        "periodo": 202511,
        "valor": 50095976.48,
        "delta": 21951600.32
      },
      {
        "periodo": 202512,
        "valor": 26988724.89,
        "delta": -23107251.59
      },
      {
        "periodo": 202601,
        "valor": 1289609.51,
        "delta": -25699115.38
      },
      {
        "periodo": 202602,
        "valor": 21455067.33,
        "delta": 20165457.82
      },
      {
        "periodo": 202603,
        "valor": 20573732.45,
        "delta": -881334.88
      },
      {
        "periodo": 202604,
        "valor": 26590035.71,
        "delta": 6016303.26
      },
      {
        "periodo": 202605,
        "valor": 11441431.03,
        "delta": -15148604.68
      },
      {
        "periodo": 202606,
        "valor": 419383.14,
        "delta": -11022047.89
      },
      {
        "periodo": 202607,
        "valor": 18755472.52,
        "delta": 18336089.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": -21637235.0,
    "valor_anterior": -53185335.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 50371299.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 78357697.0,
        "delta": 27986398.0
      },
      {
        "periodo": 202509,
        "valor": 60087051.0,
        "delta": -18270646.0
      },
      {
        "periodo": 202510,
        "valor": 34041167.0,
        "delta": -26045884.0
      },
      {
        "periodo": 202511,
        "valor": 59785865.0,
        "delta": 25744698.0
      },
      {
        "periodo": 202512,
        "valor": 55891019.0,
        "delta": -3894846.0
      },
      {
        "periodo": 202601,
        "valor": 40056015.0,
        "delta": -15835004.0
      },
      {
        "periodo": 202602,
        "valor": 146372756.0,
        "delta": 106316741.0
      },
      {
        "periodo": 202603,
        "valor": 26620812.0,
        "delta": -119751944.0
      },
      {
        "periodo": 202604,
        "valor": 5542234.0,
        "delta": -21078578.0
      },
      {
        "periodo": 202605,
        "valor": 10877469.0,
        "delta": 5335235.0
      },
      {
        "periodo": 202606,
        "valor": -53185335.0,
        "delta": -64062804.0
      },
      {
        "periodo": 202607,
        "valor": -21637235.0,
        "delta": 31548100.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 53088121.69,
    "valor_anterior": -543011.8899999857,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 85228567.58,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -15076740.6,
        "delta": -100305308.18
      },
      {
        "periodo": 202509,
        "valor": -80697546.75,
        "delta": -65620806.15
      },
      {
        "periodo": 202510,
        "valor": 169240026.92,
        "delta": 249937573.67
      },
      {
        "periodo": 202511,
        "valor": -37051255.61,
        "delta": -206291282.53
      },
      {
        "periodo": 202512,
        "valor": -118282146.3,
        "delta": -81230890.69
      },
      {
        "periodo": 202601,
        "valor": -218952083.94,
        "delta": -100669937.64
      },
      {
        "periodo": 202602,
        "valor": 30541440.89,
        "delta": 249493524.83
      },
      {
        "periodo": 202603,
        "valor": -224665906.8,
        "delta": -255207347.69
      },
      {
        "periodo": 202604,
        "valor": -38476097.05,
        "delta": 186189809.75
      },
      {
        "periodo": 202605,
        "valor": -46401098.59,
        "delta": -7925001.54
      },
      {
        "periodo": 202606,
        "valor": -543011.89,
        "delta": 45858086.7
      },
      {
        "periodo": 202607,
        "valor": 53088121.69,
        "delta": 53631133.58
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 2875001767.49,
    "valor_anterior": 2013123423.8000011,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1998838016.85,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2534748138.86,
        "delta": 535910122.01
      },
      {
        "periodo": 202509,
        "valor": 2574557317.07,
        "delta": 39809178.21
      },
      {
        "periodo": 202510,
        "valor": 2466393305.75,
        "delta": -108164011.32
      },
      {
        "periodo": 202511,
        "valor": 2028714403.6,
        "delta": -437678902.15
      },
      {
        "periodo": 202512,
        "valor": 1776620106.81,
        "delta": -252094296.79
      },
      {
        "periodo": 202601,
        "valor": 2923441020.64,
        "delta": 1146820913.83
      },
      {
        "periodo": 202602,
        "valor": 2005155028.83,
        "delta": -918285991.81
      },
      {
        "periodo": 202603,
        "valor": 1053254633.63,
        "delta": -951900395.2
      },
      {
        "periodo": 202604,
        "valor": 1470000672.01,
        "delta": 416746038.38
      },
      {
        "periodo": 202605,
        "valor": 2782258827.02,
        "delta": 1312258155.01
      },
      {
        "periodo": 202606,
        "valor": 2013123423.8,
        "delta": -769135403.22
      },
      {
        "periodo": 202607,
        "valor": 2875001767.49,
        "delta": 861878343.69
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 57793405.0,
    "valor_anterior": 58219328.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8568657.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18464901.87,
        "delta": 9896244.05
      },
      {
        "periodo": 202509,
        "valor": 48106438.12,
        "delta": 29641536.25
      },
      {
        "periodo": 202510,
        "valor": 27281490.0,
        "delta": -20824948.12
      },
      {
        "periodo": 202511,
        "valor": 42154731.0,
        "delta": 14873241.0
      },
      {
        "periodo": 202512,
        "valor": 36943662.0,
        "delta": -5211069.0
      },
      {
        "periodo": 202601,
        "valor": 39491631.0,
        "delta": 2547969.0
      },
      {
        "periodo": 202602,
        "valor": 43156432.0,
        "delta": 3664801.0
      },
      {
        "periodo": 202603,
        "valor": 61712414.0,
        "delta": 18555982.0
      },
      {
        "periodo": 202604,
        "valor": 110571264.0,
        "delta": 48858850.0
      },
      {
        "periodo": 202605,
        "valor": 90328132.0,
        "delta": -20243132.0
      },
      {
        "periodo": 202606,
        "valor": 58219328.0,
        "delta": -32108804.0
      },
      {
        "periodo": 202607,
        "valor": 57793405.0,
        "delta": -425923.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 896958398.000001,
    "valor_anterior": 826267479.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 564426647.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 633543763.0,
        "delta": 69117116.0
      },
      {
        "periodo": 202509,
        "valor": 703783048.0,
        "delta": 70239285.0
      },
      {
        "periodo": 202510,
        "valor": 741174310.0,
        "delta": 37391262.0
      },
      {
        "periodo": 202511,
        "valor": 653060946.0,
        "delta": -88113364.0
      },
      {
        "periodo": 202512,
        "valor": 787974399.0,
        "delta": 134913453.0
      },
      {
        "periodo": 202601,
        "valor": 647777823.0,
        "delta": -140196576.0
      },
      {
        "periodo": 202602,
        "valor": 723077269.0,
        "delta": 75299446.0
      },
      {
        "periodo": 202603,
        "valor": 769969422.0,
        "delta": 46892153.0
      },
      {
        "periodo": 202604,
        "valor": 865575434.0,
        "delta": 95606012.0
      },
      {
        "periodo": 202605,
        "valor": 759339130.0,
        "delta": -106236304.0
      },
      {
        "periodo": 202606,
        "valor": 826267479.0,
        "delta": 66928349.0
      },
      {
        "periodo": 202607,
        "valor": 896958398.0,
        "delta": 70690919.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 34803917.0,
    "valor_anterior": 23902636.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 42859301.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 27796890.0,
        "delta": -15062411.0
      },
      {
        "periodo": 202509,
        "valor": 125154288.0,
        "delta": 97357398.0
      },
      {
        "periodo": 202510,
        "valor": 80662868.0,
        "delta": -44491420.0
      },
      {
        "periodo": 202511,
        "valor": -11195140.0,
        "delta": -91858008.0
      },
      {
        "periodo": 202512,
        "valor": 94792008.0,
        "delta": 105987148.0
      },
      {
        "periodo": 202601,
        "valor": -12865118.0,
        "delta": -107657126.0
      },
      {
        "periodo": 202602,
        "valor": 42094944.0,
        "delta": 54960062.0
      },
      {
        "periodo": 202603,
        "valor": -17473250.0,
        "delta": -59568194.0
      },
      {
        "periodo": 202604,
        "valor": 225344992.0,
        "delta": 242818242.0
      },
      {
        "periodo": 202605,
        "valor": -8061118.0,
        "delta": -233406110.0
      },
      {
        "periodo": 202606,
        "valor": 23902636.0,
        "delta": 31963754.0
      },
      {
        "periodo": 202607,
        "valor": 34803917.0,
        "delta": 10901281.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 8341262.0,
    "valor_anterior": 52182439.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -22256852.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 22773733.0,
        "delta": 45030585.0
      },
      {
        "periodo": 202509,
        "valor": -9720468.0,
        "delta": -32494201.0
      },
      {
        "periodo": 202510,
        "valor": -12166784.0,
        "delta": -2446316.0
      },
      {
        "periodo": 202511,
        "valor": 17507682.0,
        "delta": 29674466.0
      },
      {
        "periodo": 202512,
        "valor": 55278613.0,
        "delta": 37770931.0
      },
      {
        "periodo": 202601,
        "valor": 82661635.0,
        "delta": 27383022.0
      },
      {
        "periodo": 202602,
        "valor": 11138524.0,
        "delta": -71523111.0
      },
      {
        "periodo": 202603,
        "valor": 16300487.0,
        "delta": 5161963.0
      },
      {
        "periodo": 202604,
        "valor": -6837730.0,
        "delta": -23138217.0
      },
      {
        "periodo": 202605,
        "valor": -11672259.0,
        "delta": -4834529.0
      },
      {
        "periodo": 202606,
        "valor": 52182439.0,
        "delta": 63854698.0
      },
      {
        "periodo": 202607,
        "valor": 8341262.0,
        "delta": -43841177.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 101202450.0,
    "valor_anterior": -142429500.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -28569731.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 54398080.0,
        "delta": 82967811.0
      },
      {
        "periodo": 202509,
        "valor": 2158363.0,
        "delta": -52239717.0
      },
      {
        "periodo": 202510,
        "valor": 74166737.0,
        "delta": 72008374.0
      },
      {
        "periodo": 202511,
        "valor": -17167950.0,
        "delta": -91334687.0
      },
      {
        "periodo": 202512,
        "valor": 6218051.0,
        "delta": 23386001.0
      },
      {
        "periodo": 202601,
        "valor": -40090770.0,
        "delta": -46308821.0
      },
      {
        "periodo": 202602,
        "valor": 4847898.0,
        "delta": 44938668.0
      },
      {
        "periodo": 202603,
        "valor": -182726883.0,
        "delta": -187574781.0
      },
      {
        "periodo": 202604,
        "valor": -2439613.0,
        "delta": 180287270.0
      },
      {
        "periodo": 202605,
        "valor": -849005.0,
        "delta": 1590608.0
      },
      {
        "periodo": 202606,
        "valor": -142429500.0,
        "delta": -141580495.0
      },
      {
        "periodo": 202607,
        "valor": 101202450.0,
        "delta": 243631950.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 445904963.9000006,
    "valor_anterior": 114648600.65999985,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 450166022.34,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 713802788.74,
        "delta": 263636766.4
      },
      {
        "periodo": 202509,
        "valor": 465196926.76,
        "delta": -248605861.98
      },
      {
        "periodo": 202510,
        "valor": 435655928.19,
        "delta": -29540998.57
      },
      {
        "periodo": 202511,
        "valor": 668497708.36,
        "delta": 232841780.17
      },
      {
        "periodo": 202512,
        "valor": 289261602.4,
        "delta": -379236105.96
      },
      {
        "periodo": 202601,
        "valor": 1052026812.15,
        "delta": 762765209.75
      },
      {
        "periodo": 202602,
        "valor": 496260218.7,
        "delta": -555766593.45
      },
      {
        "periodo": 202603,
        "valor": 626511799.81,
        "delta": 130251581.11
      },
      {
        "periodo": 202604,
        "valor": 663113179.78,
        "delta": 36601379.97
      },
      {
        "periodo": 202605,
        "valor": 428040710.5,
        "delta": -235072469.28
      },
      {
        "periodo": 202606,
        "valor": 114648600.66,
        "delta": -313392109.84
      },
      {
        "periodo": 202607,
        "valor": 445904963.9,
        "delta": 331256363.24
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 47478389.0,
    "valor_anterior": 46976767.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25840325.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28213855.0,
        "delta": 2373530.0
      },
      {
        "periodo": 202509,
        "valor": 33221192.0,
        "delta": 5007337.0
      },
      {
        "periodo": 202510,
        "valor": 31987396.0,
        "delta": -1233796.0
      },
      {
        "periodo": 202511,
        "valor": 34637876.0,
        "delta": 2650480.0
      },
      {
        "periodo": 202512,
        "valor": 23566135.0,
        "delta": -11071741.0
      },
      {
        "periodo": 202601,
        "valor": 26355442.0,
        "delta": 2789307.0
      },
      {
        "periodo": 202602,
        "valor": 42318378.0,
        "delta": 15962936.0
      },
      {
        "periodo": 202603,
        "valor": 44594631.0,
        "delta": 2276253.0
      },
      {
        "periodo": 202604,
        "valor": 41647660.0,
        "delta": -2946971.0
      },
      {
        "periodo": 202605,
        "valor": 44018089.0,
        "delta": 2370429.0
      },
      {
        "periodo": 202606,
        "valor": 46976767.0,
        "delta": 2958678.0
      },
      {
        "periodo": 202607,
        "valor": 47478389.0,
        "delta": 501622.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 39530.0,
    "valor_anterior": 36147.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -8976.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 303381.0,
        "delta": 312357.0
      },
      {
        "periodo": 202509,
        "valor": 28621.0,
        "delta": -274760.0
      },
      {
        "periodo": 202510,
        "valor": -27254.0,
        "delta": -55875.0
      },
      {
        "periodo": 202511,
        "valor": -139604.0,
        "delta": -112350.0
      },
      {
        "periodo": 202512,
        "valor": 14513.0,
        "delta": 154117.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -14513.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 192510.0,
        "delta": 192510.0
      },
      {
        "periodo": 202606,
        "valor": 36147.0,
        "delta": -156363.0
      },
      {
        "periodo": 202607,
        "valor": 39530.0,
        "delta": 3383.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 127720108.0,
    "valor_anterior": 58704071.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 43692661.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 32149622.0,
        "delta": -11543039.0
      },
      {
        "periodo": 202509,
        "valor": 29756050.0,
        "delta": -2393572.0
      },
      {
        "periodo": 202510,
        "valor": 47977329.0,
        "delta": 18221279.0
      },
      {
        "periodo": 202511,
        "valor": 24800105.0,
        "delta": -23177224.0
      },
      {
        "periodo": 202512,
        "valor": 44498132.0,
        "delta": 19698027.0
      },
      {
        "periodo": 202601,
        "valor": 59155832.0,
        "delta": 14657700.0
      },
      {
        "periodo": 202602,
        "valor": 42802275.0,
        "delta": -16353557.0
      },
      {
        "periodo": 202603,
        "valor": 40902634.0,
        "delta": -1899641.0
      },
      {
        "periodo": 202604,
        "valor": 83238483.0,
        "delta": 42335849.0
      },
      {
        "periodo": 202605,
        "valor": 63024216.0,
        "delta": -20214267.0
      },
      {
        "periodo": 202606,
        "valor": 58704071.0,
        "delta": -4320145.0
      },
      {
        "periodo": 202607,
        "valor": 127720108.0,
        "delta": 69016037.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 16318975.0,
    "valor_anterior": -19814728.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -7145411.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 43086799.0,
        "delta": 50232210.0
      },
      {
        "periodo": 202509,
        "valor": -33761095.0,
        "delta": -76847894.0
      },
      {
        "periodo": 202510,
        "valor": 14874752.0,
        "delta": 48635847.0
      },
      {
        "periodo": 202511,
        "valor": 41648295.0,
        "delta": 26773543.0
      },
      {
        "periodo": 202512,
        "valor": -19237599.0,
        "delta": -60885894.0
      },
      {
        "periodo": 202601,
        "valor": 38630373.0,
        "delta": 57867972.0
      },
      {
        "periodo": 202602,
        "valor": -3541046.0,
        "delta": -42171419.0
      },
      {
        "periodo": 202603,
        "valor": -515372.0,
        "delta": 3025674.0
      },
      {
        "periodo": 202604,
        "valor": 11894440.0,
        "delta": 12409812.0
      },
      {
        "periodo": 202605,
        "valor": 45479694.0,
        "delta": 33585254.0
      },
      {
        "periodo": 202606,
        "valor": -19814728.0,
        "delta": -65294422.0
      },
      {
        "periodo": 202607,
        "valor": 16318975.0,
        "delta": 36133703.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 39580639.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7845122.0,
        "delta": -31735517.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": -3253062.0,
    "valor_anterior": 4883449.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9987791.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -20895125.0,
        "delta": -30882916.0
      },
      {
        "periodo": 202509,
        "valor": -4453804.0,
        "delta": 16441321.0
      },
      {
        "periodo": 202510,
        "valor": -1776335.0,
        "delta": 2677469.0
      },
      {
        "periodo": 202511,
        "valor": 974109.0,
        "delta": 2750444.0
      },
      {
        "periodo": 202512,
        "valor": -121409088.0,
        "delta": -122383197.0
      },
      {
        "periodo": 202601,
        "valor": -5068529.0,
        "delta": 116340559.0
      },
      {
        "periodo": 202602,
        "valor": 6033442.0,
        "delta": 11101971.0
      },
      {
        "periodo": 202603,
        "valor": 14020185.0,
        "delta": 7986743.0
      },
      {
        "periodo": 202604,
        "valor": -52135209.0,
        "delta": -66155394.0
      },
      {
        "periodo": 202605,
        "valor": 30135402.0,
        "delta": 82270611.0
      },
      {
        "periodo": 202606,
        "valor": 4883449.0,
        "delta": -25251953.0
      },
      {
        "periodo": 202607,
        "valor": -3253062.0,
        "delta": -8136511.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 23305279.0,
    "valor_anterior": 46439.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -6542172.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6212913.0,
        "delta": 12755085.0
      },
      {
        "periodo": 202509,
        "valor": -9546171.0,
        "delta": -15759084.0
      },
      {
        "periodo": 202510,
        "valor": 6022625.0,
        "delta": 15568796.0
      },
      {
        "periodo": 202511,
        "valor": 14223798.0,
        "delta": 8201173.0
      },
      {
        "periodo": 202512,
        "valor": 13820686.0,
        "delta": -403112.0
      },
      {
        "periodo": 202601,
        "valor": -1277227.0,
        "delta": -15097913.0
      },
      {
        "periodo": 202602,
        "valor": 16089033.0,
        "delta": 17366260.0
      },
      {
        "periodo": 202603,
        "valor": 13079596.0,
        "delta": -3009437.0
      },
      {
        "periodo": 202604,
        "valor": 6508655.0,
        "delta": -6570941.0
      },
      {
        "periodo": 202605,
        "valor": 12496178.0,
        "delta": 5987523.0
      },
      {
        "periodo": 202606,
        "valor": 46439.0,
        "delta": -12449739.0
      },
      {
        "periodo": 202607,
        "valor": 23305279.0,
        "delta": 23258840.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 10169993.0,
    "valor_anterior": 9192811.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7112465.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7292247.0,
        "delta": 179782.0
      },
      {
        "periodo": 202509,
        "valor": 10498268.0,
        "delta": 3206021.0
      },
      {
        "periodo": 202510,
        "valor": 10018743.0,
        "delta": -479525.0
      },
      {
        "periodo": 202511,
        "valor": 9579309.0,
        "delta": -439434.0
      },
      {
        "periodo": 202512,
        "valor": 4714830.0,
        "delta": -4864479.0
      },
      {
        "periodo": 202601,
        "valor": 9562720.0,
        "delta": 4847890.0
      },
      {
        "periodo": 202602,
        "valor": 8108007.0,
        "delta": -1454713.0
      },
      {
        "periodo": 202603,
        "valor": 6215664.0,
        "delta": -1892343.0
      },
      {
        "periodo": 202604,
        "valor": 9135213.0,
        "delta": 2919549.0
      },
      {
        "periodo": 202605,
        "valor": 10021968.0,
        "delta": 886755.0
      },
      {
        "periodo": 202606,
        "valor": 9192811.0,
        "delta": -829157.0
      },
      {
        "periodo": 202607,
        "valor": 10169993.0,
        "delta": 977182.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": -6529921.16,
    "valor_anterior": 12131081.84,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25711765.46,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7400736.17,
        "delta": -18311029.29
      },
      {
        "periodo": 202509,
        "valor": -2475862.58,
        "delta": -9876598.75
      },
      {
        "periodo": 202510,
        "valor": 6215690.01,
        "delta": 8691552.59
      },
      {
        "periodo": 202511,
        "valor": 2612336.18,
        "delta": -3603353.83
      },
      {
        "periodo": 202512,
        "valor": 8403826.53,
        "delta": 5791490.35
      },
      {
        "periodo": 202601,
        "valor": -736500.5,
        "delta": -9140327.03
      },
      {
        "periodo": 202602,
        "valor": 7926422.26,
        "delta": 8662922.76
      },
      {
        "periodo": 202603,
        "valor": 432462.19,
        "delta": -7493960.07
      },
      {
        "periodo": 202604,
        "valor": 5507592.57,
        "delta": 5075130.38
      },
      {
        "periodo": 202605,
        "valor": 3676068.49,
        "delta": -1831524.08
      },
      {
        "periodo": 202606,
        "valor": 12131081.84,
        "delta": 8455013.35
      },
      {
        "periodo": 202607,
        "valor": -6529921.16,
        "delta": -18661003.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 354811.0,
    "valor_anterior": -73879.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -62243.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -618758.0,
        "delta": -556515.0
      },
      {
        "periodo": 202509,
        "valor": -542804.0,
        "delta": 75954.0
      },
      {
        "periodo": 202510,
        "valor": -2237509.0,
        "delta": -1694705.0
      },
      {
        "periodo": 202511,
        "valor": -63625.0,
        "delta": 2173884.0
      },
      {
        "periodo": 202512,
        "valor": 21652.0,
        "delta": 85277.0
      },
      {
        "periodo": 202601,
        "valor": -313703.0,
        "delta": -335355.0
      },
      {
        "periodo": 202602,
        "valor": 76673.0,
        "delta": 390376.0
      },
      {
        "periodo": 202603,
        "valor": 24371.0,
        "delta": -52302.0
      },
      {
        "periodo": 202604,
        "valor": 42460.0,
        "delta": 18089.0
      },
      {
        "periodo": 202605,
        "valor": -278914.0,
        "delta": -321374.0
      },
      {
        "periodo": 202606,
        "valor": -73879.0,
        "delta": 205035.0
      },
      {
        "periodo": 202607,
        "valor": 354811.0,
        "delta": 428690.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 15363260.98000002,
    "valor_anterior": 73617146.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2250242.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11118001.35,
        "delta": 8867758.7
      },
      {
        "periodo": 202509,
        "valor": 153539135.28,
        "delta": 142421133.93
      },
      {
        "periodo": 202510,
        "valor": 34713748.71,
        "delta": -118825386.57
      },
      {
        "periodo": 202511,
        "valor": 13005333.53,
        "delta": -21708415.18
      },
      {
        "periodo": 202512,
        "valor": 34506512.94,
        "delta": 21501179.41
      },
      {
        "periodo": 202601,
        "valor": 15674075.3,
        "delta": -18832437.64
      },
      {
        "periodo": 202602,
        "valor": 9633993.06,
        "delta": -6040082.24
      },
      {
        "periodo": 202603,
        "valor": 127818795.26,
        "delta": 118184802.2
      },
      {
        "periodo": 202604,
        "valor": 13334160.05,
        "delta": -114484635.21
      },
      {
        "periodo": 202605,
        "valor": 11654797.21,
        "delta": -1679362.84
      },
      {
        "periodo": 202606,
        "valor": 73617146.0,
        "delta": 61962348.79
      },
      {
        "periodo": 202607,
        "valor": 15363260.98,
        "delta": -58253885.02
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 9475695.490000002,
    "valor_anterior": 4578077.079999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9637966.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10094935.5,
        "delta": 456968.97
      },
      {
        "periodo": 202509,
        "valor": 17072809.63,
        "delta": 6977874.13
      },
      {
        "periodo": 202510,
        "valor": 13632974.84,
        "delta": -3439834.79
      },
      {
        "periodo": 202511,
        "valor": 12332843.33,
        "delta": -1300131.51
      },
      {
        "periodo": 202512,
        "valor": 17177087.85,
        "delta": 4844244.52
      },
      {
        "periodo": 202601,
        "valor": 8154865.12,
        "delta": -9022222.73
      },
      {
        "periodo": 202602,
        "valor": 2654803.4,
        "delta": -5500061.72
      },
      {
        "periodo": 202603,
        "valor": 7127454.73,
        "delta": 4472651.33
      },
      {
        "periodo": 202604,
        "valor": 4845942.69,
        "delta": -2281512.04
      },
      {
        "periodo": 202605,
        "valor": 17807049.41,
        "delta": 12961106.72
      },
      {
        "periodo": 202606,
        "valor": 4578077.08,
        "delta": -13228972.33
      },
      {
        "periodo": 202607,
        "valor": 9475695.49,
        "delta": 4897618.41
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 42460452.0,
    "valor_anterior": 8001602.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3058649.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1608676.0,
        "delta": -1449973.0
      },
      {
        "periodo": 202509,
        "valor": -7537285.0,
        "delta": -9145961.0
      },
      {
        "periodo": 202510,
        "valor": 2345994.0,
        "delta": 9883279.0
      },
      {
        "periodo": 202511,
        "valor": 9328223.0,
        "delta": 6982229.0
      },
      {
        "periodo": 202512,
        "valor": 6426243.0,
        "delta": -2901980.0
      },
      {
        "periodo": 202601,
        "valor": -2682641.0,
        "delta": -9108884.0
      },
      {
        "periodo": 202602,
        "valor": -3922929.0,
        "delta": -1240288.0
      },
      {
        "periodo": 202603,
        "valor": 48421189.0,
        "delta": 52344118.0
      },
      {
        "periodo": 202604,
        "valor": 50795666.0,
        "delta": 2374477.0
      },
      {
        "periodo": 202605,
        "valor": -2597953.0,
        "delta": -53393619.0
      },
      {
        "periodo": 202606,
        "valor": 8001602.0,
        "delta": 10599555.0
      },
      {
        "periodo": 202607,
        "valor": 42460452.0,
        "delta": 34458850.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 20967650.0,
    "valor_anterior": -21042671.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20246385.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -78941766.0,
        "delta": -99188151.0
      },
      {
        "periodo": 202509,
        "valor": 12446302.0,
        "delta": 91388068.0
      },
      {
        "periodo": 202510,
        "valor": 29373394.0,
        "delta": 16927092.0
      },
      {
        "periodo": 202511,
        "valor": -10636489.0,
        "delta": -40009883.0
      },
      {
        "periodo": 202512,
        "valor": 185580635.0,
        "delta": 196217124.0
      },
      {
        "periodo": 202601,
        "valor": 56564157.0,
        "delta": -129016478.0
      },
      {
        "periodo": 202602,
        "valor": 25021249.0,
        "delta": -31542908.0
      },
      {
        "periodo": 202603,
        "valor": 51403838.0,
        "delta": 26382589.0
      },
      {
        "periodo": 202604,
        "valor": 17447107.0,
        "delta": -33956731.0
      },
      {
        "periodo": 202605,
        "valor": -6636189.0,
        "delta": -24083296.0
      },
      {
        "periodo": 202606,
        "valor": -21042671.0,
        "delta": -14406482.0
      },
      {
        "periodo": 202607,
        "valor": 20967650.0,
        "delta": 42010321.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": -4486031.0,
    "valor_anterior": 2944892.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9219132.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -4607936.0,
        "delta": -13827068.0
      },
      {
        "periodo": 202509,
        "valor": -899967.0,
        "delta": 3707969.0
      },
      {
        "periodo": 202510,
        "valor": -325621.0,
        "delta": 574346.0
      },
      {
        "periodo": 202511,
        "valor": 42294.0,
        "delta": 367915.0
      },
      {
        "periodo": 202512,
        "valor": -268142.0,
        "delta": -310436.0
      },
      {
        "periodo": 202601,
        "valor": -1398581.0,
        "delta": -1130439.0
      },
      {
        "periodo": 202602,
        "valor": -392698.0,
        "delta": 1005883.0
      },
      {
        "periodo": 202603,
        "valor": 803608.0,
        "delta": 1196306.0
      },
      {
        "periodo": 202604,
        "valor": -3127851.0,
        "delta": -3931459.0
      },
      {
        "periodo": 202605,
        "valor": -871728.0,
        "delta": 2256123.0
      },
      {
        "periodo": 202606,
        "valor": 2944892.0,
        "delta": 3816620.0
      },
      {
        "periodo": 202607,
        "valor": -4486031.0,
        "delta": -7430923.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 57464.01000000164,
    "valor_anterior": -385756.76999999955,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3266719.71,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -140200.17,
        "delta": -3406919.88
      },
      {
        "periodo": 202509,
        "valor": 205057.18,
        "delta": 345257.35
      },
      {
        "periodo": 202510,
        "valor": -592439.83,
        "delta": -797497.01
      },
      {
        "periodo": 202511,
        "valor": -16575592.95,
        "delta": -15983153.12
      },
      {
        "periodo": 202512,
        "valor": 453834.19,
        "delta": 17029427.14
      },
      {
        "periodo": 202601,
        "valor": 449709.53,
        "delta": -4124.66
      },
      {
        "periodo": 202602,
        "valor": 1618013.26,
        "delta": 1168303.73
      },
      {
        "periodo": 202603,
        "valor": -542078.7,
        "delta": -2160091.96
      },
      {
        "periodo": 202604,
        "valor": 18414405.21,
        "delta": 18956483.91
      },
      {
        "periodo": 202605,
        "valor": 900769.92,
        "delta": -17513635.29
      },
      {
        "periodo": 202606,
        "valor": -385756.77,
        "delta": -1286526.69
      },
      {
        "periodo": 202607,
        "valor": 57464.01,
        "delta": 443220.78
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 826763.6300000004,
    "valor_anterior": 4836949.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -12654772.76,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -8945233.37,
        "delta": 3709539.39
      },
      {
        "periodo": 202509,
        "valor": -4542664.46,
        "delta": 4402568.91
      },
      {
        "periodo": 202510,
        "valor": -3109958.86,
        "delta": 1432705.6
      },
      {
        "periodo": 202511,
        "valor": 2202235.06,
        "delta": 5312193.92
      },
      {
        "periodo": 202512,
        "valor": -1155693.35,
        "delta": -3357928.41
      },
      {
        "periodo": 202601,
        "valor": 588984.65,
        "delta": 1744678.0
      },
      {
        "periodo": 202602,
        "valor": 1089498.25,
        "delta": 500513.6
      },
      {
        "periodo": 202603,
        "valor": -3467026.24,
        "delta": -4556524.49
      },
      {
        "periodo": 202604,
        "valor": 876346.08,
        "delta": 4343372.32
      },
      {
        "periodo": 202605,
        "valor": -270.84,
        "delta": -876616.92
      },
      {
        "periodo": 202606,
        "valor": 4836949.2,
        "delta": 4837220.04
      },
      {
        "periodo": 202607,
        "valor": 826763.63,
        "delta": -4010185.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": -119437.0,
    "valor_anterior": -152046.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 74518.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -411830.0,
        "delta": -486348.0
      },
      {
        "periodo": 202509,
        "valor": -1053594.0,
        "delta": -641764.0
      },
      {
        "periodo": 202510,
        "valor": 29958.0,
        "delta": 1083552.0
      },
      {
        "periodo": 202511,
        "valor": 976448.0,
        "delta": 946490.0
      },
      {
        "periodo": 202512,
        "valor": -1143944.0,
        "delta": -2120392.0
      },
      {
        "periodo": 202601,
        "valor": 43503.0,
        "delta": 1187447.0
      },
      {
        "periodo": 202602,
        "valor": -58998.0,
        "delta": -102501.0
      },
      {
        "periodo": 202603,
        "valor": 755465.0,
        "delta": 814463.0
      },
      {
        "periodo": 202604,
        "valor": 281397.0,
        "delta": -474068.0
      },
      {
        "periodo": 202605,
        "valor": -835219.0,
        "delta": -1116616.0
      },
      {
        "periodo": 202606,
        "valor": -152046.0,
        "delta": 683173.0
      },
      {
        "periodo": 202607,
        "valor": -119437.0,
        "delta": 32609.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": -178752.0,
    "valor_anterior": -1344442.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1326405.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -446496.0,
        "delta": -1772901.0
      },
      {
        "periodo": 202509,
        "valor": -96076.0,
        "delta": 350420.0
      },
      {
        "periodo": 202510,
        "valor": -124757.0,
        "delta": -28681.0
      },
      {
        "periodo": 202511,
        "valor": 2961132.0,
        "delta": 3085889.0
      },
      {
        "periodo": 202512,
        "valor": 1830.0,
        "delta": -2959302.0
      },
      {
        "periodo": 202601,
        "valor": -217701.0,
        "delta": -219531.0
      },
      {
        "periodo": 202602,
        "valor": -34564.0,
        "delta": 183137.0
      },
      {
        "periodo": 202603,
        "valor": 1207761.0,
        "delta": 1242325.0
      },
      {
        "periodo": 202604,
        "valor": 558402.0,
        "delta": -649359.0
      },
      {
        "periodo": 202605,
        "valor": -1944315.0,
        "delta": -2502717.0
      },
      {
        "periodo": 202606,
        "valor": -1344442.0,
        "delta": 599873.0
      },
      {
        "periodo": 202607,
        "valor": -178752.0,
        "delta": 1165690.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 36777.56,
    "valor_anterior": 5534.149999999994,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1295083.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1118203.86,
        "delta": -176879.64
      },
      {
        "periodo": 202509,
        "valor": 797444.36,
        "delta": -320759.5
      },
      {
        "periodo": 202510,
        "valor": 420171.44,
        "delta": -377272.92
      },
      {
        "periodo": 202511,
        "valor": 230689.04,
        "delta": -189482.4
      },
      {
        "periodo": 202512,
        "valor": 189335.1,
        "delta": -41353.94
      },
      {
        "periodo": 202601,
        "valor": 85188.49,
        "delta": -104146.61
      },
      {
        "periodo": 202602,
        "valor": 28802.6,
        "delta": -56385.89
      },
      {
        "periodo": 202603,
        "valor": 39458.99,
        "delta": 10656.39
      },
      {
        "periodo": 202604,
        "valor": 54600.78,
        "delta": 15141.79
      },
      {
        "periodo": 202605,
        "valor": 10283.21,
        "delta": -44317.57
      },
      {
        "periodo": 202606,
        "valor": 5534.15,
        "delta": -4749.06
      },
      {
        "periodo": 202607,
        "valor": 36777.56,
        "delta": 31243.41
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 40941175.0,
    "valor_anterior": 35555555.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 39571961.65,
        "delta": 39571961.65
      },
      {
        "periodo": 202603,
        "valor": 39225217.51,
        "delta": -346744.14
      },
      {
        "periodo": 202604,
        "valor": 65879993.08,
        "delta": 26654775.57
      },
      {
        "periodo": 202605,
        "valor": 32022137.75,
        "delta": -33857855.33
      },
      {
        "periodo": 202606,
        "valor": 35555555.0,
        "delta": 3533417.25
      },
      {
        "periodo": 202607,
        "valor": 40941175.0,
        "delta": 5385620.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 25647415.0,
    "valor_anterior": 19488659.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11992227.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16620819.0,
        "delta": 4628592.0
      },
      {
        "periodo": 202509,
        "valor": 17801797.0,
        "delta": 1180978.0
      },
      {
        "periodo": 202510,
        "valor": 19332970.0,
        "delta": 1531173.0
      },
      {
        "periodo": 202511,
        "valor": 22566873.0,
        "delta": 3233903.0
      },
      {
        "periodo": 202512,
        "valor": 19024797.0,
        "delta": -3542076.0
      },
      {
        "periodo": 202601,
        "valor": 21387448.0,
        "delta": 2362651.0
      },
      {
        "periodo": 202602,
        "valor": 22557558.0,
        "delta": 1170110.0
      },
      {
        "periodo": 202603,
        "valor": 13780884.0,
        "delta": -8776674.0
      },
      {
        "periodo": 202604,
        "valor": 22312234.0,
        "delta": 8531350.0
      },
      {
        "periodo": 202605,
        "valor": 23130676.0,
        "delta": 818442.0
      },
      {
        "periodo": 202606,
        "valor": 19488659.0,
        "delta": -3642017.0
      },
      {
        "periodo": 202607,
        "valor": 25647415.0,
        "delta": 6158756.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 10663401.259999998,
    "valor_anterior": 6952244.469999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 3962.23,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 1351558.7,
        "delta": 1347596.47
      },
      {
        "periodo": 202601,
        "valor": 3135344.5,
        "delta": 1783785.8
      },
      {
        "periodo": 202602,
        "valor": 4488371.94,
        "delta": 1353027.44
      },
      {
        "periodo": 202603,
        "valor": 2928771.12,
        "delta": -1559600.82
      },
      {
        "periodo": 202604,
        "valor": 5213335.96,
        "delta": 2284564.84
      },
      {
        "periodo": 202605,
        "valor": 4853223.44,
        "delta": -360112.52
      },
      {
        "periodo": 202606,
        "valor": 6952244.47,
        "delta": 2099021.03
      },
      {
        "periodo": 202607,
        "valor": 10663401.26,
        "delta": 3711156.79
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 373431159.0,
    "valor_anterior": 417879434.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 736332689.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 298331290.0,
        "delta": -438001399.0
      },
      {
        "periodo": 202605,
        "valor": 324936947.0,
        "delta": 26605657.0
      },
      {
        "periodo": 202606,
        "valor": 417879434.0,
        "delta": 92942487.0
      },
      {
        "periodo": 202607,
        "valor": 373431159.0,
        "delta": -44448275.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 21551879085.54001,
    "valor_anterior": 18824959232.339996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17706332056.88,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18261960110.58,
        "delta": 555628053.7
      },
      {
        "periodo": 202509,
        "valor": 21216577407.58,
        "delta": 2954617297.0
      },
      {
        "periodo": 202510,
        "valor": 20194334128.09,
        "delta": -1022243279.4899
      },
      {
        "periodo": 202511,
        "valor": 19165790703.79,
        "delta": -1028543424.3
      },
      {
        "periodo": 202512,
        "valor": 18003742836.87,
        "delta": -1162047866.92
      },
      {
        "periodo": 202601,
        "valor": 19563744883.71,
        "delta": 1560002046.84
      },
      {
        "periodo": 202602,
        "valor": 22311749247.21,
        "delta": 2748004363.5
      },
      {
        "periodo": 202603,
        "valor": 20228080109.06,
        "delta": -2083669138.15
      },
      {
        "periodo": 202604,
        "valor": 19765886359.81,
        "delta": -462193749.25
      },
      {
        "periodo": 202605,
        "valor": 23495971915.03,
        "delta": 3730085555.22
      },
      {
        "periodo": 202606,
        "valor": 18824959232.34,
        "delta": -4671012682.69
      },
      {
        "periodo": 202607,
        "valor": 21551879085.54,
        "delta": 2726919853.2
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 15118854031.669983,
    "valor_anterior": 14241911445.76001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13184151624.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13324112475.14,
        "delta": 139960850.21
      },
      {
        "periodo": 202509,
        "valor": 16146731208.58,
        "delta": 2822618733.44
      },
      {
        "periodo": 202510,
        "valor": 14936493198.08,
        "delta": -1210238010.5
      },
      {
        "periodo": 202511,
        "valor": 14697233814.22,
        "delta": -239259383.86
      },
      {
        "periodo": 202512,
        "valor": 12807391497.34,
        "delta": -1889842316.88
      },
      {
        "periodo": 202601,
        "valor": 13707334661.5,
        "delta": 899943164.16
      },
      {
        "periodo": 202602,
        "valor": 17528961739.18,
        "delta": 3821627077.68
      },
      {
        "periodo": 202603,
        "valor": 16015377854.94,
        "delta": -1513583884.24
      },
      {
        "periodo": 202604,
        "valor": 14990380462.4,
        "delta": -1024997392.54
      },
      {
        "periodo": 202605,
        "valor": 17886312426.18,
        "delta": 2895931963.78
      },
      {
        "periodo": 202606,
        "valor": 14241911445.76,
        "delta": -3644400980.42
      },
      {
        "periodo": 202607,
        "valor": 15118854031.67,
        "delta": 876942585.91
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 116704860.51999998,
    "valor_anterior": -137126667.85999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 38299879.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 39740371.78,
        "delta": 1440492.04
      },
      {
        "periodo": 202509,
        "valor": -163665100.71,
        "delta": -203405472.49
      },
      {
        "periodo": 202510,
        "valor": 100534778.16,
        "delta": 264199878.87
      },
      {
        "periodo": 202511,
        "valor": 33902135.48,
        "delta": -66632642.68
      },
      {
        "periodo": 202512,
        "valor": -88202312.11,
        "delta": -122104447.59
      },
      {
        "periodo": 202601,
        "valor": -43869689.49,
        "delta": 44332622.62
      },
      {
        "periodo": 202602,
        "valor": 32336407.33,
        "delta": 76206096.82
      },
      {
        "periodo": 202603,
        "valor": -148132965.55,
        "delta": -180469372.88
      },
      {
        "periodo": 202604,
        "valor": -27984786.29,
        "delta": 120148179.26
      },
      {
        "periodo": 202605,
        "valor": 40727828.03,
        "delta": 68712614.32
      },
      {
        "periodo": 202606,
        "valor": -137126667.86,
        "delta": -177854495.89
      },
      {
        "periodo": 202607,
        "valor": 116704860.52,
        "delta": 253831528.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 829286707.69,
    "valor_anterior": 649825315.1099997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 710150203.58,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 478042370.4,
        "delta": -232107833.18
      },
      {
        "periodo": 202509,
        "valor": 535759185.25,
        "delta": 57716814.85
      },
      {
        "periodo": 202510,
        "valor": 716221073.92,
        "delta": 180461888.67
      },
      {
        "periodo": 202511,
        "valor": 590832436.39,
        "delta": -125388637.53
      },
      {
        "periodo": 202512,
        "valor": 1323246982.7,
        "delta": 732414546.31
      },
      {
        "periodo": 202601,
        "valor": 555056642.06,
        "delta": -768190340.64
      },
      {
        "periodo": 202602,
        "valor": 686626238.89,
        "delta": 131569596.83
      },
      {
        "periodo": 202603,
        "valor": 430871242.2,
        "delta": -255754996.69
      },
      {
        "periodo": 202604,
        "valor": 525046359.95,
        "delta": 94175117.75
      },
      {
        "periodo": 202605,
        "valor": 585025514.41,
        "delta": 59979154.46
      },
      {
        "periodo": 202606,
        "valor": 649825315.11,
        "delta": 64799800.7
      },
      {
        "periodo": 202607,
        "valor": 829286707.69,
        "delta": 179461392.58
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 452530278.5,
    "valor_anterior": 309569018.9000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 623759757.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 329070385.45,
        "delta": -294689372.08
      },
      {
        "periodo": 202509,
        "valor": 694887949.1,
        "delta": 365817563.65
      },
      {
        "periodo": 202510,
        "valor": 583964723.68,
        "delta": -110923225.42
      },
      {
        "periodo": 202511,
        "valor": 242662757.32,
        "delta": -341301966.36
      },
      {
        "periodo": 202512,
        "valor": 843943709.77,
        "delta": 601280952.45
      },
      {
        "periodo": 202601,
        "valor": 407020721.76,
        "delta": -436922988.01
      },
      {
        "periodo": 202602,
        "valor": 576573832.86,
        "delta": 169553111.1
      },
      {
        "periodo": 202603,
        "valor": 305852547.17,
        "delta": -270721285.69
      },
      {
        "periodo": 202604,
        "valor": 523093474.54,
        "delta": 217240927.37
      },
      {
        "periodo": 202605,
        "valor": 329847686.3,
        "delta": -193245788.24
      },
      {
        "periodo": 202606,
        "valor": 309569018.9,
        "delta": -20278667.4
      },
      {
        "periodo": 202607,
        "valor": 452530278.5,
        "delta": 142961259.6
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 211709073.95000005,
    "valor_anterior": 278777036.35000014,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 79592879.41,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 108632126.35,
        "delta": 29039246.94
      },
      {
        "periodo": 202509,
        "valor": 234234409.17,
        "delta": 125602282.82
      },
      {
        "periodo": 202510,
        "valor": 121272844.87,
        "delta": -112961564.3
      },
      {
        "periodo": 202511,
        "valor": 152057269.15,
        "delta": 30784424.28
      },
      {
        "periodo": 202512,
        "valor": 212965797.16,
        "delta": 60908528.01
      },
      {
        "periodo": 202601,
        "valor": 182999986.1,
        "delta": -29965811.06
      },
      {
        "periodo": 202602,
        "valor": 148742582.23,
        "delta": -34257403.87
      },
      {
        "periodo": 202603,
        "valor": 335465628.24,
        "delta": 186723046.01
      },
      {
        "periodo": 202604,
        "valor": 260601973.6,
        "delta": -74863654.64
      },
      {
        "periodo": 202605,
        "valor": 180940647.19,
        "delta": -79661326.41
      },
      {
        "periodo": 202606,
        "valor": 278777036.35,
        "delta": 97836389.16
      },
      {
        "periodo": 202607,
        "valor": 211709073.95,
        "delta": -67067962.4
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100131,
    "label": "EPRC",
    "valor_actual": 4822794133.210003,
    "valor_anterior": 3482003084.079998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3070377711.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3982362381.46,
        "delta": 911984669.77
      },
      {
        "periodo": 202509,
        "valor": 3768629756.19,
        "delta": -213732625.27
      },
      {
        "periodo": 202510,
        "valor": 3735847509.38,
        "delta": -32782246.81
      },
      {
        "periodo": 202511,
        "valor": 3449102291.23,
        "delta": -286745218.15
      },
      {
        "periodo": 202512,
        "valor": 2904397162.01,
        "delta": -544705129.22
      },
      {
        "periodo": 202601,
        "valor": 4755202561.78,
        "delta": 1850805399.77
      },
      {
        "periodo": 202602,
        "valor": 3338508446.72,
        "delta": -1416694115.06
      },
      {
        "periodo": 202603,
        "valor": 3288645802.06,
        "delta": -49862644.66
      },
      {
        "periodo": 202604,
        "valor": 3494748875.61,
        "delta": 206103073.55
      },
      {
        "periodo": 202605,
        "valor": 4473117812.92,
        "delta": 978368937.31
      },
      {
        "periodo": 202606,
        "valor": 3482003084.08,
        "delta": -991114728.84
      },
      {
        "periodo": 202607,
        "valor": 4822794133.21,
        "delta": 1340791049.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 20900868.939999938,
    "valor_anterior": 125062375.25999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 258088379.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -147212341.64,
        "delta": -405300720.89
      },
      {
        "periodo": 202509,
        "valor": 88029029.87,
        "delta": 235241371.51
      },
      {
        "periodo": 202510,
        "valor": 165614828.3,
        "delta": 77585798.43
      },
      {
        "periodo": 202511,
        "valor": 149061864.62,
        "delta": -16552963.68
      },
      {
        "periodo": 202512,
        "valor": 229087772.02,
        "delta": 80025907.4
      },
      {
        "periodo": 202601,
        "valor": 111758817.86,
        "delta": -117328954.16
      },
      {
        "periodo": 202602,
        "valor": 123098756.98,
        "delta": 11339939.12
      },
      {
        "periodo": 202603,
        "valor": 194396615.51,
        "delta": 71297858.53
      },
      {
        "periodo": 202604,
        "valor": 194885269.31,
        "delta": 488653.8
      },
      {
        "periodo": 202605,
        "valor": 164362066.04,
        "delta": -30523203.27
      },
      {
        "periodo": 202606,
        "valor": 125062375.26,
        "delta": -39299690.78
      },
      {
        "periodo": 202607,
        "valor": 20900868.94,
        "delta": -104161506.32
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 3763655242.209999,
    "valor_anterior": 4405705522.439999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3729607528.47,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3435500823.2,
        "delta": -294106705.27
      },
      {
        "periodo": 202509,
        "valor": 3700133948.67,
        "delta": 264633125.47
      },
      {
        "periodo": 202510,
        "valor": 3590432026.98,
        "delta": -109701921.69
      },
      {
        "periodo": 202511,
        "valor": 4111443946.35,
        "delta": 521011919.37
      },
      {
        "periodo": 202512,
        "valor": 4494648228.48,
        "delta": 383204282.13
      },
      {
        "periodo": 202601,
        "valor": 3761452599.76,
        "delta": -733195628.72
      },
      {
        "periodo": 202602,
        "valor": 3394158978.58,
        "delta": -367293621.18
      },
      {
        "periodo": 202603,
        "valor": 3846374695.01,
        "delta": 452215716.43
      },
      {
        "periodo": 202604,
        "valor": 3608930385.1,
        "delta": -237444309.91
      },
      {
        "periodo": 202605,
        "valor": 3588200882.88,
        "delta": -20729502.22
      },
      {
        "periodo": 202606,
        "valor": 4405705522.44,
        "delta": 817504639.56
      },
      {
        "periodo": 202607,
        "valor": 3763655242.21,
        "delta": -642050280.23
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 741204176.999999,
    "valor_anterior": 770311867.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 891070321.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 867472406.0,
        "delta": -23597915.0
      },
      {
        "periodo": 202509,
        "valor": 775704695.0,
        "delta": -91767711.0
      },
      {
        "periodo": 202510,
        "valor": 752911943.0,
        "delta": -22792752.0
      },
      {
        "periodo": 202511,
        "valor": 672854051.0,
        "delta": -80057892.0
      },
      {
        "periodo": 202512,
        "valor": 667500096.0,
        "delta": -5353955.0
      },
      {
        "periodo": 202601,
        "valor": 871657136.0,
        "delta": 204157040.0
      },
      {
        "periodo": 202602,
        "valor": 751691314.0,
        "delta": -119965822.0
      },
      {
        "periodo": 202603,
        "valor": 730098472.0,
        "delta": -21592842.0
      },
      {
        "periodo": 202604,
        "valor": 791925402.0,
        "delta": 61826930.0
      },
      {
        "periodo": 202605,
        "valor": 835818180.0,
        "delta": 43892778.0
      },
      {
        "periodo": 202606,
        "valor": 770311867.0,
        "delta": -65506313.0
      },
      {
        "periodo": 202607,
        "valor": 741204177.0,
        "delta": -29107690.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 263712727.0,
    "valor_anterior": 300289940.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 270526950.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 292899883.0,
        "delta": 22372933.0
      },
      {
        "periodo": 202509,
        "valor": 282150374.0,
        "delta": -10749509.0
      },
      {
        "periodo": 202510,
        "valor": 311088888.0,
        "delta": 28938514.0
      },
      {
        "periodo": 202511,
        "valor": 399841430.0,
        "delta": 88752542.0
      },
      {
        "periodo": 202512,
        "valor": 292269644.0,
        "delta": -107571786.0
      },
      {
        "periodo": 202601,
        "valor": 256519761.0,
        "delta": -35749883.0
      },
      {
        "periodo": 202602,
        "valor": 253650514.0,
        "delta": -2869247.0
      },
      {
        "periodo": 202603,
        "valor": 246188405.0,
        "delta": -7462109.0
      },
      {
        "periodo": 202604,
        "valor": 251051561.0,
        "delta": 4863156.0
      },
      {
        "periodo": 202605,
        "valor": 331811698.0,
        "delta": 80760137.0
      },
      {
        "periodo": 202606,
        "valor": 300289940.0,
        "delta": -31521758.0
      },
      {
        "periodo": 202607,
        "valor": 263712727.0,
        "delta": -36577213.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 196271937.0300002,
    "valor_anterior": 182063016.82999992,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 195792217.48,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 182968294.26,
        "delta": -12823923.22
      },
      {
        "periodo": 202509,
        "valor": 181027748.67,
        "delta": -1940545.59
      },
      {
        "periodo": 202510,
        "valor": 188271456.37,
        "delta": 7243707.7
      },
      {
        "periodo": 202511,
        "valor": 186938528.59,
        "delta": -1332927.78
      },
      {
        "periodo": 202512,
        "valor": 210186812.54,
        "delta": 23248283.95
      },
      {
        "periodo": 202601,
        "valor": 201551297.95,
        "delta": -8635514.59
      },
      {
        "periodo": 202602,
        "valor": 181016420.64,
        "delta": -20534877.31
      },
      {
        "periodo": 202603,
        "valor": 197238173.98,
        "delta": 16221753.34
      },
      {
        "periodo": 202604,
        "valor": 193565802.71,
        "delta": -3672371.27
      },
      {
        "periodo": 202605,
        "valor": 183745473.99,
        "delta": -9820328.72
      },
      {
        "periodo": 202606,
        "valor": 182063016.83,
        "delta": -1682457.16
      },
      {
        "periodo": 202607,
        "valor": 196271937.03,
        "delta": 14208920.2
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 178052925.0,
    "valor_anterior": 161220330.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 178771060.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 203894793.0,
        "delta": 25123733.0
      },
      {
        "periodo": 202509,
        "valor": 177915346.0,
        "delta": -25979447.0
      },
      {
        "periodo": 202510,
        "valor": 185797361.0,
        "delta": 7882015.0
      },
      {
        "periodo": 202511,
        "valor": 184637243.0,
        "delta": -1160118.0
      },
      {
        "periodo": 202512,
        "valor": 253108676.0,
        "delta": 68471433.0
      },
      {
        "periodo": 202601,
        "valor": 206568515.0,
        "delta": -46540161.0
      },
      {
        "periodo": 202602,
        "valor": 161850834.0,
        "delta": -44717681.0
      },
      {
        "periodo": 202603,
        "valor": 165082157.0,
        "delta": 3231323.0
      },
      {
        "periodo": 202604,
        "valor": 157195272.0,
        "delta": -7886885.0
      },
      {
        "periodo": 202605,
        "valor": 149793047.0,
        "delta": -7402225.0
      },
      {
        "periodo": 202606,
        "valor": 161220330.0,
        "delta": 11427283.0
      },
      {
        "periodo": 202607,
        "valor": 178052925.0,
        "delta": 16832595.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 104378098.0,
    "valor_anterior": 100054545.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 97015996.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 66936179.0,
        "delta": -30079817.0
      },
      {
        "periodo": 202509,
        "valor": 105094789.0,
        "delta": 38158610.0
      },
      {
        "periodo": 202510,
        "valor": 117695073.0,
        "delta": 12600284.0
      },
      {
        "periodo": 202511,
        "valor": 105365387.0,
        "delta": -12329686.0
      },
      {
        "periodo": 202512,
        "valor": 156665951.0,
        "delta": 51300564.0
      },
      {
        "periodo": 202601,
        "valor": 97702200.0,
        "delta": -58963751.0
      },
      {
        "periodo": 202602,
        "valor": 90920866.0,
        "delta": -6781334.0
      },
      {
        "periodo": 202603,
        "valor": 107143160.0,
        "delta": 16222294.0
      },
      {
        "periodo": 202604,
        "valor": 86773953.0,
        "delta": -20369207.0
      },
      {
        "periodo": 202605,
        "valor": 76524074.0,
        "delta": -10249879.0
      },
      {
        "periodo": 202606,
        "valor": 100054545.0,
        "delta": 23530471.0
      },
      {
        "periodo": 202607,
        "valor": 104378098.0,
        "delta": 4323553.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 27513538.0,
    "valor_anterior": 29542384.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30531412.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 27208471.0,
        "delta": -3322941.0
      },
      {
        "periodo": 202509,
        "valor": 28438984.0,
        "delta": 1230513.0
      },
      {
        "periodo": 202510,
        "valor": 24882085.0,
        "delta": -3556899.0
      },
      {
        "periodo": 202511,
        "valor": 33233884.0,
        "delta": 8351799.0
      },
      {
        "periodo": 202512,
        "valor": 30968926.0,
        "delta": -2264958.0
      },
      {
        "periodo": 202601,
        "valor": 30038198.0,
        "delta": -930728.0
      },
      {
        "periodo": 202602,
        "valor": 27443925.0,
        "delta": -2594273.0
      },
      {
        "periodo": 202603,
        "valor": 29821394.0,
        "delta": 2377469.0
      },
      {
        "periodo": 202604,
        "valor": 29910700.0,
        "delta": 89306.0
      },
      {
        "periodo": 202605,
        "valor": 29449149.0,
        "delta": -461551.0
      },
      {
        "periodo": 202606,
        "valor": 29542384.0,
        "delta": 93235.0
      },
      {
        "periodo": 202607,
        "valor": 27513538.0,
        "delta": -2028846.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 241431300.04999995,
    "valor_anterior": 217185361.42000008,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 215391969.71,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 199467703.24,
        "delta": -15924266.47
      },
      {
        "periodo": 202509,
        "valor": 199322085.63,
        "delta": -145617.61
      },
      {
        "periodo": 202510,
        "valor": 198290938.11,
        "delta": -1031147.52
      },
      {
        "periodo": 202511,
        "valor": 215753663.22,
        "delta": 17462725.11
      },
      {
        "periodo": 202512,
        "valor": 259230785.09,
        "delta": 43477121.87
      },
      {
        "periodo": 202601,
        "valor": 210853197.3,
        "delta": -48377587.79
      },
      {
        "periodo": 202602,
        "valor": 183508931.54,
        "delta": -27344265.76
      },
      {
        "periodo": 202603,
        "valor": 216498841.84,
        "delta": 32989910.3
      },
      {
        "periodo": 202604,
        "valor": 229263987.81,
        "delta": 12765145.97
      },
      {
        "periodo": 202605,
        "valor": 198683170.25,
        "delta": -30580817.56
      },
      {
        "periodo": 202606,
        "valor": 217185361.42,
        "delta": 18502191.17
      },
      {
        "periodo": 202607,
        "valor": 241431300.05,
        "delta": 24245938.63
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 148971199.0,
    "valor_anterior": 151095519.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 100982838.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 106683565.0,
        "delta": 5700727.0
      },
      {
        "periodo": 202509,
        "valor": 100846353.0,
        "delta": -5837212.0
      },
      {
        "periodo": 202510,
        "valor": 108127451.0,
        "delta": 7281098.0
      },
      {
        "periodo": 202511,
        "valor": 136116772.0,
        "delta": 27989321.0
      },
      {
        "periodo": 202512,
        "valor": 142244570.0,
        "delta": 6127798.0
      },
      {
        "periodo": 202601,
        "valor": 145792864.0,
        "delta": 3548294.0
      },
      {
        "periodo": 202602,
        "valor": 135826501.0,
        "delta": -9966363.0
      },
      {
        "periodo": 202603,
        "valor": 187023591.0,
        "delta": 51197090.0
      },
      {
        "periodo": 202604,
        "valor": 153710569.0,
        "delta": -33313022.0
      },
      {
        "periodo": 202605,
        "valor": 164750035.0,
        "delta": 11039466.0
      },
      {
        "periodo": 202606,
        "valor": 151095519.0,
        "delta": -13654516.0
      },
      {
        "periodo": 202607,
        "valor": 148971199.0,
        "delta": -2124320.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 17501594.0,
    "valor_anterior": 21243268.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14455411.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13876179.0,
        "delta": -579232.0
      },
      {
        "periodo": 202509,
        "valor": 11853913.0,
        "delta": -2022266.0
      },
      {
        "periodo": 202510,
        "valor": 15072601.0,
        "delta": 3218688.0
      },
      {
        "periodo": 202511,
        "valor": 17375597.0,
        "delta": 2302996.0
      },
      {
        "periodo": 202512,
        "valor": 18655997.0,
        "delta": 1280400.0
      },
      {
        "periodo": 202601,
        "valor": 20694498.0,
        "delta": 2038501.0
      },
      {
        "periodo": 202602,
        "valor": 18944806.0,
        "delta": -1749692.0
      },
      {
        "periodo": 202603,
        "valor": 28147877.0,
        "delta": 9203071.0
      },
      {
        "periodo": 202604,
        "valor": 19787538.0,
        "delta": -8360339.0
      },
      {
        "periodo": 202605,
        "valor": 20670915.0,
        "delta": 883377.0
      },
      {
        "periodo": 202606,
        "valor": 21243268.0,
        "delta": 572353.0
      },
      {
        "periodo": 202607,
        "valor": 17501594.0,
        "delta": -3741674.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 227236695.0,
    "valor_anterior": 227760662.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 189797620.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 177754778.0,
        "delta": -12042842.0
      },
      {
        "periodo": 202509,
        "valor": 200065273.0,
        "delta": 22310495.0
      },
      {
        "periodo": 202510,
        "valor": 192925040.0,
        "delta": -7140233.0
      },
      {
        "periodo": 202511,
        "valor": 206999326.0,
        "delta": 14074286.0
      },
      {
        "periodo": 202512,
        "valor": 229224731.0,
        "delta": 22225405.0
      },
      {
        "periodo": 202601,
        "valor": 205844251.0,
        "delta": -23380480.0
      },
      {
        "periodo": 202602,
        "valor": 185234593.0,
        "delta": -20609658.0
      },
      {
        "periodo": 202603,
        "valor": 198374113.0,
        "delta": 13139520.0
      },
      {
        "periodo": 202604,
        "valor": 199432952.0,
        "delta": 1058839.0
      },
      {
        "periodo": 202605,
        "valor": 189165428.0,
        "delta": -10267524.0
      },
      {
        "periodo": 202606,
        "valor": 227760662.0,
        "delta": 38595234.0
      },
      {
        "periodo": 202607,
        "valor": 227236695.0,
        "delta": -523967.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 1303735241.38,
    "valor_anterior": 1371389877.8400002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1643619295.48,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1325075580.79,
        "delta": -318543714.69
      },
      {
        "periodo": 202509,
        "valor": 1403999482.06,
        "delta": 78923901.27
      },
      {
        "periodo": 202510,
        "valor": 1275005029.47,
        "delta": -128994452.59
      },
      {
        "periodo": 202511,
        "valor": 1297536890.42,
        "delta": 22531860.95
      },
      {
        "periodo": 202512,
        "valor": 1425642261.53,
        "delta": 128105371.11
      },
      {
        "periodo": 202601,
        "valor": 1343127887.84,
        "delta": -82514373.69
      },
      {
        "periodo": 202602,
        "valor": 1269845937.92,
        "delta": -73281949.92
      },
      {
        "periodo": 202603,
        "valor": 1383111575.07,
        "delta": 113265637.15
      },
      {
        "periodo": 202604,
        "valor": 1217797551.27,
        "delta": -165314023.8
      },
      {
        "periodo": 202605,
        "valor": 1222245106.78,
        "delta": 4447555.51
      },
      {
        "periodo": 202606,
        "valor": 1371389877.84,
        "delta": 149144771.06
      },
      {
        "periodo": 202607,
        "valor": 1303735241.38,
        "delta": -67654636.46
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 4823199.0,
    "valor_anterior": 9231665.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11459082.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4691294.0,
        "delta": -6767788.0
      },
      {
        "periodo": 202509,
        "valor": 4323276.0,
        "delta": -368018.0
      },
      {
        "periodo": 202510,
        "valor": 10596804.0,
        "delta": 6273528.0
      },
      {
        "periodo": 202511,
        "valor": 3780273.0,
        "delta": -6816531.0
      },
      {
        "periodo": 202512,
        "valor": 10655124.0,
        "delta": 6874851.0
      },
      {
        "periodo": 202601,
        "valor": 4414305.0,
        "delta": -6240819.0
      },
      {
        "periodo": 202602,
        "valor": 8117695.0,
        "delta": 3703390.0
      },
      {
        "periodo": 202603,
        "valor": 4910821.0,
        "delta": -3206874.0
      },
      {
        "periodo": 202604,
        "valor": 8445042.0,
        "delta": 3534221.0
      },
      {
        "periodo": 202605,
        "valor": 2608896.0,
        "delta": -5836146.0
      },
      {
        "periodo": 202606,
        "valor": 9231665.0,
        "delta": 6622769.0
      },
      {
        "periodo": 202607,
        "valor": 4823199.0,
        "delta": -4408466.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 2729742.0,
    "valor_anterior": 2007055.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2102735.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 393255.0,
        "delta": -1709480.0
      },
      {
        "periodo": 202509,
        "valor": 4202133.0,
        "delta": 3808878.0
      },
      {
        "periodo": 202510,
        "valor": 2136210.0,
        "delta": -2065923.0
      },
      {
        "periodo": 202511,
        "valor": 2287466.0,
        "delta": 151256.0
      },
      {
        "periodo": 202512,
        "valor": 1977041.0,
        "delta": -310425.0
      },
      {
        "periodo": 202601,
        "valor": 2043723.0,
        "delta": 66682.0
      },
      {
        "periodo": 202602,
        "valor": 2482138.0,
        "delta": 438415.0
      },
      {
        "periodo": 202603,
        "valor": 2042627.0,
        "delta": -439511.0
      },
      {
        "periodo": 202604,
        "valor": 2218618.0,
        "delta": 175991.0
      },
      {
        "periodo": 202605,
        "valor": 2071636.0,
        "delta": -146982.0
      },
      {
        "periodo": 202606,
        "valor": 2007055.0,
        "delta": -64581.0
      },
      {
        "periodo": 202607,
        "valor": 2729742.0,
        "delta": 722687.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 5498574.0,
    "valor_anterior": -11701018.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7577550.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6916074.0,
        "delta": -661476.0
      },
      {
        "periodo": 202509,
        "valor": -2058917.0,
        "delta": -8974991.0
      },
      {
        "periodo": 202510,
        "valor": 8683175.0,
        "delta": 10742092.0
      },
      {
        "periodo": 202511,
        "valor": 5874591.0,
        "delta": -2808584.0
      },
      {
        "periodo": 202512,
        "valor": -1876.0,
        "delta": -5876467.0
      },
      {
        "periodo": 202601,
        "valor": 6987816.0,
        "delta": 6989692.0
      },
      {
        "periodo": 202602,
        "valor": 4245983.0,
        "delta": -2741833.0
      },
      {
        "periodo": 202603,
        "valor": 6432253.0,
        "delta": 2186270.0
      },
      {
        "periodo": 202604,
        "valor": 10102533.0,
        "delta": 3670280.0
      },
      {
        "periodo": 202605,
        "valor": 8187295.0,
        "delta": -1915238.0
      },
      {
        "periodo": 202606,
        "valor": -11701018.0,
        "delta": -19888313.0
      },
      {
        "periodo": 202607,
        "valor": 5498574.0,
        "delta": 17199592.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 22649274.28,
    "valor_anterior": 21568832.209999993,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19801429.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 22374829.26,
        "delta": 2573399.73
      },
      {
        "periodo": 202509,
        "valor": 37041849.66,
        "delta": 14667020.4
      },
      {
        "periodo": 202510,
        "valor": 21108124.0,
        "delta": -15933725.66
      },
      {
        "periodo": 202511,
        "valor": -1076267.33,
        "delta": -22184391.33
      },
      {
        "periodo": 202512,
        "valor": 28238479.73,
        "delta": 29314747.06
      },
      {
        "periodo": 202601,
        "valor": 22264651.77,
        "delta": -5973827.96
      },
      {
        "periodo": 202602,
        "valor": 21013770.65,
        "delta": -1250881.12
      },
      {
        "periodo": 202603,
        "valor": 32251963.3,
        "delta": 11238192.65
      },
      {
        "periodo": 202604,
        "valor": 25625095.4,
        "delta": -6626867.9
      },
      {
        "periodo": 202605,
        "valor": 14964628.33,
        "delta": -10660467.07
      },
      {
        "periodo": 202606,
        "valor": 21568832.21,
        "delta": 6604203.88
      },
      {
        "periodo": 202607,
        "valor": 22649274.28,
        "delta": 1080442.07
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 31582368.0,
    "valor_anterior": 53031953.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20296290.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 52939589.0,
        "delta": 32643299.0
      },
      {
        "periodo": 202509,
        "valor": 151030121.0,
        "delta": 98090532.0
      },
      {
        "periodo": 202510,
        "valor": 147927067.0,
        "delta": -3103054.0
      },
      {
        "periodo": 202511,
        "valor": 45080663.0,
        "delta": -102846404.0
      },
      {
        "periodo": 202512,
        "valor": 43275965.0,
        "delta": -1804698.0
      },
      {
        "periodo": 202601,
        "valor": 85377607.0,
        "delta": 42101642.0
      },
      {
        "periodo": 202602,
        "valor": 46994996.0,
        "delta": -38382611.0
      },
      {
        "periodo": 202603,
        "valor": 33842322.0,
        "delta": -13152674.0
      },
      {
        "periodo": 202604,
        "valor": 80675075.0,
        "delta": 46832753.0
      },
      {
        "periodo": 202605,
        "valor": 49917902.0,
        "delta": -30757173.0
      },
      {
        "periodo": 202606,
        "valor": 53031953.0,
        "delta": 3114051.0
      },
      {
        "periodo": 202607,
        "valor": 31582368.0,
        "delta": -21449585.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 71513775.76000005,
    "valor_anterior": 60186250.25999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 192335630.13,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15282415.54,
        "delta": -177053214.59
      },
      {
        "periodo": 202509,
        "valor": 54863536.07,
        "delta": 39581120.53
      },
      {
        "periodo": 202510,
        "valor": 94548396.79,
        "delta": 39684860.72
      },
      {
        "periodo": 202511,
        "valor": 68458615.74,
        "delta": -26089781.05
      },
      {
        "periodo": 202512,
        "valor": 223066964.8,
        "delta": 154608349.06
      },
      {
        "periodo": 202601,
        "valor": 82857626.29,
        "delta": -140209338.51
      },
      {
        "periodo": 202602,
        "valor": 66417341.07,
        "delta": -16440285.22
      },
      {
        "periodo": 202603,
        "valor": 112330546.22,
        "delta": 45913205.15
      },
      {
        "periodo": 202604,
        "valor": 73732224.19,
        "delta": -38598322.03
      },
      {
        "periodo": 202605,
        "valor": 68463706.31,
        "delta": -5268517.88
      },
      {
        "periodo": 202606,
        "valor": 60186250.26,
        "delta": -8277456.05
      },
      {
        "periodo": 202607,
        "valor": 71513775.76,
        "delta": 11327525.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 436593.0,
    "valor_anterior": 64164.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 77183.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 195066.0,
        "delta": 117883.0
      },
      {
        "periodo": 202509,
        "valor": 76829.0,
        "delta": -118237.0
      },
      {
        "periodo": 202510,
        "valor": 76728.0,
        "delta": -101.0
      },
      {
        "periodo": 202511,
        "valor": 734603.0,
        "delta": 657875.0
      },
      {
        "periodo": 202512,
        "valor": 1348540.0,
        "delta": 613937.0
      },
      {
        "periodo": 202601,
        "valor": 89785.0,
        "delta": -1258755.0
      },
      {
        "periodo": 202602,
        "valor": 75722.0,
        "delta": -14063.0
      },
      {
        "periodo": 202603,
        "valor": 284012.0,
        "delta": 208290.0
      },
      {
        "periodo": 202604,
        "valor": 123236.0,
        "delta": -160776.0
      },
      {
        "periodo": 202605,
        "valor": 127429.0,
        "delta": 4193.0
      },
      {
        "periodo": 202606,
        "valor": 64164.0,
        "delta": -63265.0
      },
      {
        "periodo": 202607,
        "valor": 436593.0,
        "delta": 372429.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 437753229.55999994,
    "valor_anterior": 401642689.6500001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 347892634.66,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 369758068.94,
        "delta": 21865434.28
      },
      {
        "periodo": 202509,
        "valor": 362179458.56,
        "delta": -7578610.38
      },
      {
        "periodo": 202510,
        "valor": 375981427.28,
        "delta": 13801968.72
      },
      {
        "periodo": 202511,
        "valor": 375289205.76,
        "delta": -692221.52
      },
      {
        "periodo": 202512,
        "valor": 409764452.56,
        "delta": 34475246.8
      },
      {
        "periodo": 202601,
        "valor": 367206635.7,
        "delta": -42557816.86
      },
      {
        "periodo": 202602,
        "valor": 378680642.67,
        "delta": 11474006.97
      },
      {
        "periodo": 202603,
        "valor": 381353708.55,
        "delta": 2673065.88
      },
      {
        "periodo": 202604,
        "valor": 435112085.88,
        "delta": 53758377.33
      },
      {
        "periodo": 202605,
        "valor": 380431418.22,
        "delta": -54680667.66
      },
      {
        "periodo": 202606,
        "valor": 401642689.65,
        "delta": 21211271.43
      },
      {
        "periodo": 202607,
        "valor": 437753229.56,
        "delta": 36110539.91
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 16778286.0,
    "valor_anterior": 12570949.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 916123.75,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5664363.91,
        "delta": 4748240.16
      },
      {
        "periodo": 202509,
        "valor": 9678431.33,
        "delta": 4014067.42
      },
      {
        "periodo": 202510,
        "valor": 8976363.0,
        "delta": -702068.33
      },
      {
        "periodo": 202511,
        "valor": 5136417.0,
        "delta": -3839946.0
      },
      {
        "periodo": 202512,
        "valor": 15162086.0,
        "delta": 10025669.0
      },
      {
        "periodo": 202601,
        "valor": 3720230.0,
        "delta": -11441856.0
      },
      {
        "periodo": 202602,
        "valor": 4223124.0,
        "delta": 502894.0
      },
      {
        "periodo": 202603,
        "valor": 11648395.0,
        "delta": 7425271.0
      },
      {
        "periodo": 202604,
        "valor": 15947962.0,
        "delta": 4299567.0
      },
      {
        "periodo": 202605,
        "valor": 18603173.0,
        "delta": 2655211.0
      },
      {
        "periodo": 202606,
        "valor": 12570949.0,
        "delta": -6032224.0
      },
      {
        "periodo": 202607,
        "valor": 16778286.0,
        "delta": 4207337.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 4786776.0,
    "valor_anterior": 3711799.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6086275.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6643476.0,
        "delta": 557201.0
      },
      {
        "periodo": 202509,
        "valor": 5012392.0,
        "delta": -1631084.0
      },
      {
        "periodo": 202510,
        "valor": 6090480.0,
        "delta": 1078088.0
      },
      {
        "periodo": 202511,
        "valor": 4431518.0,
        "delta": -1658962.0
      },
      {
        "periodo": 202512,
        "valor": 6910708.0,
        "delta": 2479190.0
      },
      {
        "periodo": 202601,
        "valor": 5636882.0,
        "delta": -1273826.0
      },
      {
        "periodo": 202602,
        "valor": 4157290.0,
        "delta": -1479592.0
      },
      {
        "periodo": 202603,
        "valor": 4646249.0,
        "delta": 488959.0
      },
      {
        "periodo": 202604,
        "valor": 4907574.0,
        "delta": 261325.0
      },
      {
        "periodo": 202605,
        "valor": 5060214.0,
        "delta": 152640.0
      },
      {
        "periodo": 202606,
        "valor": 3711799.0,
        "delta": -1348415.0
      },
      {
        "periodo": 202607,
        "valor": 4786776.0,
        "delta": 1074977.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 60814932.0,
    "valor_anterior": 63486166.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 60737182.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 57654908.0,
        "delta": -3082274.0
      },
      {
        "periodo": 202509,
        "valor": 59678562.0,
        "delta": 2023654.0
      },
      {
        "periodo": 202510,
        "valor": 62097773.0,
        "delta": 2419211.0
      },
      {
        "periodo": 202511,
        "valor": 57700564.0,
        "delta": -4397209.0
      },
      {
        "periodo": 202512,
        "valor": 61058109.0,
        "delta": 3357545.0
      },
      {
        "periodo": 202601,
        "valor": 58842726.0,
        "delta": -2215383.0
      },
      {
        "periodo": 202602,
        "valor": 56080525.0,
        "delta": -2762201.0
      },
      {
        "periodo": 202603,
        "valor": 61702401.0,
        "delta": 5621876.0
      },
      {
        "periodo": 202604,
        "valor": 54897557.0,
        "delta": -6804844.0
      },
      {
        "periodo": 202605,
        "valor": 62625517.0,
        "delta": 7727960.0
      },
      {
        "periodo": 202606,
        "valor": 63486166.0,
        "delta": 860649.0
      },
      {
        "periodo": 202607,
        "valor": 60814932.0,
        "delta": -2671234.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 28045045.0,
    "valor_anterior": 31607588.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28619864.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26038915.0,
        "delta": -2580949.0
      },
      {
        "periodo": 202509,
        "valor": 24778044.0,
        "delta": -1260871.0
      },
      {
        "periodo": 202510,
        "valor": 29592431.0,
        "delta": 4814387.0
      },
      {
        "periodo": 202511,
        "valor": 26364239.0,
        "delta": -3228192.0
      },
      {
        "periodo": 202512,
        "valor": 41227190.0,
        "delta": 14862951.0
      },
      {
        "periodo": 202601,
        "valor": 28761349.0,
        "delta": -12465841.0
      },
      {
        "periodo": 202602,
        "valor": 29378792.0,
        "delta": 617443.0
      },
      {
        "periodo": 202603,
        "valor": 27605966.0,
        "delta": -1772826.0
      },
      {
        "periodo": 202604,
        "valor": 27977381.0,
        "delta": 371415.0
      },
      {
        "periodo": 202605,
        "valor": 31342865.0,
        "delta": 3365484.0
      },
      {
        "periodo": 202606,
        "valor": 31607588.0,
        "delta": 264723.0
      },
      {
        "periodo": 202607,
        "valor": 28045045.0,
        "delta": -3562543.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 6127859.0,
    "valor_anterior": 7339849.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6650131.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8060037.0,
        "delta": 1409906.0
      },
      {
        "periodo": 202509,
        "valor": 7696388.0,
        "delta": -363649.0
      },
      {
        "periodo": 202510,
        "valor": 6643708.0,
        "delta": -1052680.0
      },
      {
        "periodo": 202511,
        "valor": 6325878.0,
        "delta": -317830.0
      },
      {
        "periodo": 202512,
        "valor": 6578557.0,
        "delta": 252679.0
      },
      {
        "periodo": 202601,
        "valor": 12500786.0,
        "delta": 5922229.0
      },
      {
        "periodo": 202602,
        "valor": 1887280.0,
        "delta": -10613506.0
      },
      {
        "periodo": 202603,
        "valor": 6268020.0,
        "delta": 4380740.0
      },
      {
        "periodo": 202604,
        "valor": 6009083.0,
        "delta": -258937.0
      },
      {
        "periodo": 202605,
        "valor": 6647765.0,
        "delta": 638682.0
      },
      {
        "periodo": 202606,
        "valor": 7339849.0,
        "delta": 692084.0
      },
      {
        "periodo": 202607,
        "valor": 6127859.0,
        "delta": -1211990.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 0.0,
    "valor_anterior": 3571334.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11973966.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28262261.0,
        "delta": 16288295.0
      },
      {
        "periodo": 202509,
        "valor": 827114.0,
        "delta": -27435147.0
      },
      {
        "periodo": 202510,
        "valor": 1744807.0,
        "delta": 917693.0
      },
      {
        "periodo": 202511,
        "valor": 2385877.0,
        "delta": 641070.0
      },
      {
        "periodo": 202512,
        "valor": 2496719.0,
        "delta": 110842.0
      },
      {
        "periodo": 202601,
        "valor": 1764212.0,
        "delta": -732507.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -1764212.0
      },
      {
        "periodo": 202603,
        "valor": 1561465.0,
        "delta": 1561465.0
      },
      {
        "periodo": 202604,
        "valor": 2229843.0,
        "delta": 668378.0
      },
      {
        "periodo": 202605,
        "valor": 532646.0,
        "delta": -1697197.0
      },
      {
        "periodo": 202606,
        "valor": 3571334.0,
        "delta": 3038688.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": -3571334.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 135817087.60000002,
    "valor_anterior": 115376250.91999996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 114156822.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 115626520.66,
        "delta": 1469697.92
      },
      {
        "periodo": 202509,
        "valor": 109564067.77,
        "delta": -6062452.89
      },
      {
        "periodo": 202510,
        "valor": 111271720.34,
        "delta": 1707652.57
      },
      {
        "periodo": 202511,
        "valor": 114732557.46,
        "delta": 3460837.12
      },
      {
        "periodo": 202512,
        "valor": 128061407.72,
        "delta": 13328850.26
      },
      {
        "periodo": 202601,
        "valor": 105383061.82,
        "delta": -22678345.9
      },
      {
        "periodo": 202602,
        "valor": 104100146.06,
        "delta": -1282915.76
      },
      {
        "periodo": 202603,
        "valor": 120666002.12,
        "delta": 16565856.06
      },
      {
        "periodo": 202604,
        "valor": 117489998.31,
        "delta": -3176003.81
      },
      {
        "periodo": 202605,
        "valor": 115549053.4,
        "delta": -1940944.91
      },
      {
        "periodo": 202606,
        "valor": 115376250.92,
        "delta": -172802.48
      },
      {
        "periodo": 202607,
        "valor": 135817087.6,
        "delta": 20440836.68
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 378750.0,
    "valor_anterior": 368927.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 754410.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 536868.0,
        "delta": -217542.0
      },
      {
        "periodo": 202509,
        "valor": 740847.0,
        "delta": 203979.0
      },
      {
        "periodo": 202510,
        "valor": 306536.0,
        "delta": -434311.0
      },
      {
        "periodo": 202511,
        "valor": 386420.0,
        "delta": 79884.0
      },
      {
        "periodo": 202512,
        "valor": 433960.0,
        "delta": 47540.0
      },
      {
        "periodo": 202601,
        "valor": 565849.0,
        "delta": 131889.0
      },
      {
        "periodo": 202602,
        "valor": 350984.0,
        "delta": -214865.0
      },
      {
        "periodo": 202603,
        "valor": 605759.0,
        "delta": 254775.0
      },
      {
        "periodo": 202604,
        "valor": 380810.0,
        "delta": -224949.0
      },
      {
        "periodo": 202605,
        "valor": 410275.0,
        "delta": 29465.0
      },
      {
        "periodo": 202606,
        "valor": 368927.0,
        "delta": -41348.0
      },
      {
        "periodo": 202607,
        "valor": 378750.0,
        "delta": 9823.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 20664.0,
    "valor_anterior": 50094.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 428.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 340.0,
        "delta": -88.0
      },
      {
        "periodo": 202509,
        "valor": 169677.0,
        "delta": 169337.0
      },
      {
        "periodo": 202510,
        "valor": 81293.0,
        "delta": -88384.0
      },
      {
        "periodo": 202511,
        "valor": 11501.0,
        "delta": -69792.0
      },
      {
        "periodo": 202512,
        "valor": 29745.0,
        "delta": 18244.0
      },
      {
        "periodo": 202601,
        "valor": 58583.0,
        "delta": 28838.0
      },
      {
        "periodo": 202602,
        "valor": 148785.0,
        "delta": 90202.0
      },
      {
        "periodo": 202603,
        "valor": 89465.0,
        "delta": -59320.0
      },
      {
        "periodo": 202604,
        "valor": 1739.0,
        "delta": -87726.0
      },
      {
        "periodo": 202605,
        "valor": 15973.0,
        "delta": 14234.0
      },
      {
        "periodo": 202606,
        "valor": 50094.0,
        "delta": 34121.0
      },
      {
        "periodo": 202607,
        "valor": 20664.0,
        "delta": -29430.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 19285290.0,
    "valor_anterior": 14602802.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13182322.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12679291.0,
        "delta": -503031.0
      },
      {
        "periodo": 202509,
        "valor": 14024047.0,
        "delta": 1344756.0
      },
      {
        "periodo": 202510,
        "valor": 17033272.0,
        "delta": 3009225.0
      },
      {
        "periodo": 202511,
        "valor": 16159841.0,
        "delta": -873431.0
      },
      {
        "periodo": 202512,
        "valor": 14322471.0,
        "delta": -1837370.0
      },
      {
        "periodo": 202601,
        "valor": 14690871.0,
        "delta": 368400.0
      },
      {
        "periodo": 202602,
        "valor": 11318378.0,
        "delta": -3372493.0
      },
      {
        "periodo": 202603,
        "valor": 13789871.0,
        "delta": 2471493.0
      },
      {
        "periodo": 202604,
        "valor": 11286244.0,
        "delta": -2503627.0
      },
      {
        "periodo": 202605,
        "valor": 17271415.0,
        "delta": 5985171.0
      },
      {
        "periodo": 202606,
        "valor": 14602802.0,
        "delta": -2668613.0
      },
      {
        "periodo": 202607,
        "valor": 19285290.0,
        "delta": 4682488.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 874090.0,
    "valor_anterior": 3367113.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 569049.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 617968.0,
        "delta": 48919.0
      },
      {
        "periodo": 202509,
        "valor": 502472.0,
        "delta": -115496.0
      },
      {
        "periodo": 202510,
        "valor": 1063542.0,
        "delta": 561070.0
      },
      {
        "periodo": 202511,
        "valor": 1430702.0,
        "delta": 367160.0
      },
      {
        "periodo": 202512,
        "valor": 618452.0,
        "delta": -812250.0
      },
      {
        "periodo": 202601,
        "valor": 872910.0,
        "delta": 254458.0
      },
      {
        "periodo": 202602,
        "valor": 805911.0,
        "delta": -66999.0
      },
      {
        "periodo": 202603,
        "valor": 715785.0,
        "delta": -90126.0
      },
      {
        "periodo": 202604,
        "valor": 698130.0,
        "delta": -17655.0
      },
      {
        "periodo": 202605,
        "valor": 1071678.0,
        "delta": 373548.0
      },
      {
        "periodo": 202606,
        "valor": 3367113.0,
        "delta": 2295435.0
      },
      {
        "periodo": 202607,
        "valor": 874090.0,
        "delta": -2493023.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 105219114.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 107460314.0,
        "delta": 2241200.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 14647856.0,
    "valor_anterior": 15442736.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13873113.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17805413.0,
        "delta": 3932300.0
      },
      {
        "periodo": 202509,
        "valor": 14363561.0,
        "delta": -3441852.0
      },
      {
        "periodo": 202510,
        "valor": 15763726.0,
        "delta": 1400165.0
      },
      {
        "periodo": 202511,
        "valor": 16984430.0,
        "delta": 1220704.0
      },
      {
        "periodo": 202512,
        "valor": 11383801.0,
        "delta": -5600629.0
      },
      {
        "periodo": 202601,
        "valor": 14225717.0,
        "delta": 2841916.0
      },
      {
        "periodo": 202602,
        "valor": 12693423.0,
        "delta": -1532294.0
      },
      {
        "periodo": 202603,
        "valor": 16096185.0,
        "delta": 3402762.0
      },
      {
        "periodo": 202604,
        "valor": 16681631.0,
        "delta": 585446.0
      },
      {
        "periodo": 202605,
        "valor": 16906578.0,
        "delta": 224947.0
      },
      {
        "periodo": 202606,
        "valor": 15442736.0,
        "delta": -1463842.0
      },
      {
        "periodo": 202607,
        "valor": 14647856.0,
        "delta": -794880.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 23517562.0,
    "valor_anterior": 21184695.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26470264.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19925392.0,
        "delta": -6544872.0
      },
      {
        "periodo": 202509,
        "valor": 15223806.0,
        "delta": -4701586.0
      },
      {
        "periodo": 202510,
        "valor": 14010214.0,
        "delta": -1213592.0
      },
      {
        "periodo": 202511,
        "valor": 19020705.0,
        "delta": 5010491.0
      },
      {
        "periodo": 202512,
        "valor": 24725180.0,
        "delta": 5704475.0
      },
      {
        "periodo": 202601,
        "valor": 23517249.0,
        "delta": -1207931.0
      },
      {
        "periodo": 202602,
        "valor": 22596484.0,
        "delta": -920765.0
      },
      {
        "periodo": 202603,
        "valor": 23421329.0,
        "delta": 824845.0
      },
      {
        "periodo": 202604,
        "valor": 24357556.0,
        "delta": 936227.0
      },
      {
        "periodo": 202605,
        "valor": 18388437.0,
        "delta": -5969119.0
      },
      {
        "periodo": 202606,
        "valor": 21184695.0,
        "delta": 2796258.0
      },
      {
        "periodo": 202607,
        "valor": 23517562.0,
        "delta": 2332867.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 503084.0,
    "valor_anterior": 485374.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 570464.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 704494.0,
        "delta": 134030.0
      },
      {
        "periodo": 202509,
        "valor": 901339.0,
        "delta": 196845.0
      },
      {
        "periodo": 202510,
        "valor": 1959296.0,
        "delta": 1057957.0
      },
      {
        "periodo": 202511,
        "valor": 5588600.0,
        "delta": 3629304.0
      },
      {
        "periodo": 202512,
        "valor": 706893.0,
        "delta": -4881707.0
      },
      {
        "periodo": 202601,
        "valor": 437487.0,
        "delta": -269406.0
      },
      {
        "periodo": 202602,
        "valor": 483864.0,
        "delta": 46377.0
      },
      {
        "periodo": 202603,
        "valor": 471156.0,
        "delta": -12708.0
      },
      {
        "periodo": 202604,
        "valor": 454215.0,
        "delta": -16941.0
      },
      {
        "periodo": 202605,
        "valor": 425698.0,
        "delta": -28517.0
      },
      {
        "periodo": 202606,
        "valor": 485374.0,
        "delta": 59676.0
      },
      {
        "periodo": 202607,
        "valor": 503084.0,
        "delta": 17710.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 976865.0,
    "valor_anterior": 899389.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 339508.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 364257.0,
        "delta": 24749.0
      },
      {
        "periodo": 202509,
        "valor": 1152384.0,
        "delta": 788127.0
      },
      {
        "periodo": 202510,
        "valor": 478009.0,
        "delta": -674375.0
      },
      {
        "periodo": 202511,
        "valor": 622483.0,
        "delta": 144474.0
      },
      {
        "periodo": 202512,
        "valor": 842777.0,
        "delta": 220294.0
      },
      {
        "periodo": 202601,
        "valor": 703796.0,
        "delta": -138981.0
      },
      {
        "periodo": 202602,
        "valor": 658145.0,
        "delta": -45651.0
      },
      {
        "periodo": 202603,
        "valor": 783476.0,
        "delta": 125331.0
      },
      {
        "periodo": 202604,
        "valor": 754787.0,
        "delta": -28689.0
      },
      {
        "periodo": 202605,
        "valor": 1054236.0,
        "delta": 299449.0
      },
      {
        "periodo": 202606,
        "valor": 899389.0,
        "delta": -154847.0
      },
      {
        "periodo": 202607,
        "valor": 976865.0,
        "delta": 77476.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 450196.56000000006,
    "valor_anterior": 498198.73,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 650240.51,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 579514.98,
        "delta": -70725.53
      },
      {
        "periodo": 202509,
        "valor": 563713.88,
        "delta": -15801.1
      },
      {
        "periodo": 202510,
        "valor": 618470.05,
        "delta": 54756.17
      },
      {
        "periodo": 202511,
        "valor": 372125.51,
        "delta": -246344.54
      },
      {
        "periodo": 202512,
        "valor": 617965.56,
        "delta": 245840.05
      },
      {
        "periodo": 202601,
        "valor": 500542.97,
        "delta": -117422.59
      },
      {
        "periodo": 202602,
        "valor": 550646.59,
        "delta": 50103.62
      },
      {
        "periodo": 202603,
        "valor": 436194.23,
        "delta": -114452.36
      },
      {
        "periodo": 202604,
        "valor": 458232.8,
        "delta": 22038.57
      },
      {
        "periodo": 202605,
        "valor": 549412.05,
        "delta": 91179.25
      },
      {
        "periodo": 202606,
        "valor": 498198.73,
        "delta": -51213.32
      },
      {
        "periodo": 202607,
        "valor": 450196.56,
        "delta": -48002.17
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 1434874.0,
    "valor_anterior": 1459510.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1713230.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1199844.0,
        "delta": -513386.0
      },
      {
        "periodo": 202509,
        "valor": 1155789.0,
        "delta": -44055.0
      },
      {
        "periodo": 202510,
        "valor": 1840360.0,
        "delta": 684571.0
      },
      {
        "periodo": 202511,
        "valor": 3087149.0,
        "delta": 1246789.0
      },
      {
        "periodo": 202512,
        "valor": 2650831.0,
        "delta": -436318.0
      },
      {
        "periodo": 202601,
        "valor": 1307691.0,
        "delta": -1343140.0
      },
      {
        "periodo": 202602,
        "valor": 1270688.0,
        "delta": -37003.0
      },
      {
        "periodo": 202603,
        "valor": 1285400.0,
        "delta": 14712.0
      },
      {
        "periodo": 202604,
        "valor": 1728735.0,
        "delta": 443335.0
      },
      {
        "periodo": 202605,
        "valor": 1454532.0,
        "delta": -274203.0
      },
      {
        "periodo": 202606,
        "valor": 1459510.0,
        "delta": 4978.0
      },
      {
        "periodo": 202607,
        "valor": 1434874.0,
        "delta": -24636.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 2457112.33,
    "valor_anterior": 2242850.76,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1578510.94,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1435300.58,
        "delta": -143210.36
      },
      {
        "periodo": 202509,
        "valor": 1857326.47,
        "delta": 422025.89
      },
      {
        "periodo": 202510,
        "valor": 1627147.74,
        "delta": -230178.73
      },
      {
        "periodo": 202511,
        "valor": 1623500.01,
        "delta": -3647.73
      },
      {
        "periodo": 202512,
        "valor": 1470163.13,
        "delta": -153336.88
      },
      {
        "periodo": 202601,
        "valor": 2018380.93,
        "delta": 548217.8
      },
      {
        "periodo": 202602,
        "valor": 1349840.61,
        "delta": -668540.32
      },
      {
        "periodo": 202603,
        "valor": 2034327.42,
        "delta": 684486.81
      },
      {
        "periodo": 202604,
        "valor": 2200104.52,
        "delta": 165777.1
      },
      {
        "periodo": 202605,
        "valor": 2007403.51,
        "delta": -192701.01
      },
      {
        "periodo": 202606,
        "valor": 2242850.76,
        "delta": 235447.25
      },
      {
        "periodo": 202607,
        "valor": 2457112.33,
        "delta": 214261.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 1992251.5899999999,
    "valor_anterior": 2828309.5199999996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2734112.31,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2474918.47,
        "delta": -259193.84
      },
      {
        "periodo": 202509,
        "valor": 1898720.1,
        "delta": -576198.37
      },
      {
        "periodo": 202510,
        "valor": 1842729.3,
        "delta": -55990.8
      },
      {
        "periodo": 202511,
        "valor": 2353624.65,
        "delta": 510895.35
      },
      {
        "periodo": 202512,
        "valor": 3426570.99,
        "delta": 1072946.34
      },
      {
        "periodo": 202601,
        "valor": 1802985.93,
        "delta": -1623585.06
      },
      {
        "periodo": 202602,
        "valor": 2506906.45,
        "delta": 703920.52
      },
      {
        "periodo": 202603,
        "valor": 2396264.88,
        "delta": -110641.57
      },
      {
        "periodo": 202604,
        "valor": 3892808.18,
        "delta": 1496543.3
      },
      {
        "periodo": 202605,
        "valor": 2442467.97,
        "delta": -1450340.21
      },
      {
        "periodo": 202606,
        "valor": 2828309.52,
        "delta": 385841.55
      },
      {
        "periodo": 202607,
        "valor": 1992251.59,
        "delta": -836057.93
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 3232526.0,
    "valor_anterior": 149948.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 139494.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 163604.0,
        "delta": 24110.0
      },
      {
        "periodo": 202509,
        "valor": 162417.0,
        "delta": -1187.0
      },
      {
        "periodo": 202510,
        "valor": 184584.0,
        "delta": 22167.0
      },
      {
        "periodo": 202511,
        "valor": 161812.0,
        "delta": -22772.0
      },
      {
        "periodo": 202512,
        "valor": 631432.0,
        "delta": 469620.0
      },
      {
        "periodo": 202601,
        "valor": 166658.0,
        "delta": -464774.0
      },
      {
        "periodo": 202602,
        "valor": 141198.0,
        "delta": -25460.0
      },
      {
        "periodo": 202603,
        "valor": 132136.0,
        "delta": -9062.0
      },
      {
        "periodo": 202604,
        "valor": 478991.0,
        "delta": 346855.0
      },
      {
        "periodo": 202605,
        "valor": 187710.0,
        "delta": -291281.0
      },
      {
        "periodo": 202606,
        "valor": 149948.0,
        "delta": -37762.0
      },
      {
        "periodo": 202607,
        "valor": 3232526.0,
        "delta": 3082578.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 14105739.0,
    "valor_anterior": 1220892.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1513366.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 835550.0,
        "delta": -677816.0
      },
      {
        "periodo": 202509,
        "valor": 723001.0,
        "delta": -112549.0
      },
      {
        "periodo": 202510,
        "valor": 32752.0,
        "delta": -690249.0
      },
      {
        "periodo": 202511,
        "valor": 126503.0,
        "delta": 93751.0
      },
      {
        "periodo": 202512,
        "valor": 2805269.0,
        "delta": 2678766.0
      },
      {
        "periodo": 202601,
        "valor": 1483106.0,
        "delta": -1322163.0
      },
      {
        "periodo": 202602,
        "valor": 707160.0,
        "delta": -775946.0
      },
      {
        "periodo": 202603,
        "valor": 1090498.0,
        "delta": 383338.0
      },
      {
        "periodo": 202604,
        "valor": 756403.0,
        "delta": -334095.0
      },
      {
        "periodo": 202605,
        "valor": 690505.0,
        "delta": -65898.0
      },
      {
        "periodo": 202606,
        "valor": 1220892.0,
        "delta": 530387.0
      },
      {
        "periodo": 202607,
        "valor": 14105739.0,
        "delta": 12884847.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 204226.0,
    "valor_anterior": 198164.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 167960.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 174899.0,
        "delta": 6939.0
      },
      {
        "periodo": 202509,
        "valor": 164270.0,
        "delta": -10629.0
      },
      {
        "periodo": 202510,
        "valor": 164926.0,
        "delta": 656.0
      },
      {
        "periodo": 202511,
        "valor": 174864.0,
        "delta": 9938.0
      },
      {
        "periodo": 202512,
        "valor": 177737.0,
        "delta": 2873.0
      },
      {
        "periodo": 202601,
        "valor": 173199.0,
        "delta": -4538.0
      },
      {
        "periodo": 202602,
        "valor": 185836.0,
        "delta": 12637.0
      },
      {
        "periodo": 202603,
        "valor": 175329.0,
        "delta": -10507.0
      },
      {
        "periodo": 202604,
        "valor": 211463.0,
        "delta": 36134.0
      },
      {
        "periodo": 202605,
        "valor": 200206.0,
        "delta": -11257.0
      },
      {
        "periodo": 202606,
        "valor": 198164.0,
        "delta": -2042.0
      },
      {
        "periodo": 202607,
        "valor": 204226.0,
        "delta": 6062.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 291153.70999999973,
    "valor_anterior": 284154.89000000013,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 351236.77,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 321978.55,
        "delta": -29258.22
      },
      {
        "periodo": 202509,
        "valor": 332032.93,
        "delta": 10054.38
      },
      {
        "periodo": 202510,
        "valor": 327604.05,
        "delta": -4428.88
      },
      {
        "periodo": 202511,
        "valor": 320519.3,
        "delta": -7084.75
      },
      {
        "periodo": 202512,
        "valor": 371171.74,
        "delta": 50652.44
      },
      {
        "periodo": 202601,
        "valor": 287296.32,
        "delta": -83875.42
      },
      {
        "periodo": 202602,
        "valor": 323324.34,
        "delta": 36028.02
      },
      {
        "periodo": 202603,
        "valor": 302542.86,
        "delta": -20781.48
      },
      {
        "periodo": 202604,
        "valor": 336096.7,
        "delta": 33553.84
      },
      {
        "periodo": 202605,
        "valor": 304527.94,
        "delta": -31568.76
      },
      {
        "periodo": 202606,
        "valor": 284154.89,
        "delta": -20373.05
      },
      {
        "periodo": 202607,
        "valor": 291153.71,
        "delta": 6998.82
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 111584.70999999996,
    "valor_anterior": 100339.26000000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 197083.45,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 185776.1,
        "delta": -11307.35
      },
      {
        "periodo": 202509,
        "valor": 158279.8,
        "delta": -27496.3
      },
      {
        "periodo": 202510,
        "valor": 128881.96,
        "delta": -29397.84
      },
      {
        "periodo": 202511,
        "valor": 84172.72,
        "delta": -44709.24
      },
      {
        "periodo": 202512,
        "valor": 73969.02,
        "delta": -10203.7
      },
      {
        "periodo": 202601,
        "valor": 76834.94,
        "delta": 2865.92
      },
      {
        "periodo": 202602,
        "valor": 98667.94,
        "delta": 21833.0
      },
      {
        "periodo": 202603,
        "valor": 76173.54,
        "delta": -22494.4
      },
      {
        "periodo": 202604,
        "valor": 77809.67,
        "delta": 1636.13
      },
      {
        "periodo": 202605,
        "valor": 80775.88,
        "delta": 2966.21
      },
      {
        "periodo": 202606,
        "valor": 100339.26,
        "delta": 19563.38
      },
      {
        "periodo": 202607,
        "valor": 111584.71,
        "delta": 11245.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 10948928.0,
    "valor_anterior": 13592106.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10823214.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10467076.0,
        "delta": -356138.0
      },
      {
        "periodo": 202509,
        "valor": 10513847.0,
        "delta": 46771.0
      },
      {
        "periodo": 202510,
        "valor": 10846489.0,
        "delta": 332642.0
      },
      {
        "periodo": 202511,
        "valor": 9952141.0,
        "delta": -894348.0
      },
      {
        "periodo": 202512,
        "valor": 11845081.0,
        "delta": 1892940.0
      },
      {
        "periodo": 202601,
        "valor": 11211342.0,
        "delta": -633739.0
      },
      {
        "periodo": 202602,
        "valor": 10666169.0,
        "delta": -545173.0
      },
      {
        "periodo": 202603,
        "valor": 12427030.0,
        "delta": 1760861.0
      },
      {
        "periodo": 202604,
        "valor": 11356402.0,
        "delta": -1070628.0
      },
      {
        "periodo": 202605,
        "valor": 11461447.0,
        "delta": 105045.0
      },
      {
        "periodo": 202606,
        "valor": 13592106.0,
        "delta": 2130659.0
      },
      {
        "periodo": 202607,
        "valor": 10948928.0,
        "delta": -2643178.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 20421.0,
    "valor_anterior": 16953.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27717.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28386.0,
        "delta": 669.0
      },
      {
        "periodo": 202509,
        "valor": 25290.0,
        "delta": -3096.0
      },
      {
        "periodo": 202510,
        "valor": 21665.0,
        "delta": -3625.0
      },
      {
        "periodo": 202511,
        "valor": 29780.0,
        "delta": 8115.0
      },
      {
        "periodo": 202512,
        "valor": 26788.0,
        "delta": -2992.0
      },
      {
        "periodo": 202601,
        "valor": 22825.0,
        "delta": -3963.0
      },
      {
        "periodo": 202602,
        "valor": 22733.0,
        "delta": -92.0
      },
      {
        "periodo": 202603,
        "valor": 16479.0,
        "delta": -6254.0
      },
      {
        "periodo": 202604,
        "valor": 18610.0,
        "delta": 2131.0
      },
      {
        "periodo": 202605,
        "valor": 23883.0,
        "delta": 5273.0
      },
      {
        "periodo": 202606,
        "valor": 16953.0,
        "delta": -6930.0
      },
      {
        "periodo": 202607,
        "valor": 20421.0,
        "delta": 3468.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 4356309.0,
    "valor_anterior": 39098413.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7205748.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7576547.0,
        "delta": 370799.0
      },
      {
        "periodo": 202509,
        "valor": 23369698.0,
        "delta": 15793151.0
      },
      {
        "periodo": 202510,
        "valor": 5945306.0,
        "delta": -17424392.0
      },
      {
        "periodo": 202511,
        "valor": 2503052.0,
        "delta": -3442254.0
      },
      {
        "periodo": 202512,
        "valor": 60591651.0,
        "delta": 58088599.0
      },
      {
        "periodo": 202601,
        "valor": 5926128.0,
        "delta": -54665523.0
      },
      {
        "periodo": 202602,
        "valor": 3406795.0,
        "delta": -2519333.0
      },
      {
        "periodo": 202603,
        "valor": 33862831.0,
        "delta": 30456036.0
      },
      {
        "periodo": 202604,
        "valor": 3328697.0,
        "delta": -30534134.0
      },
      {
        "periodo": 202605,
        "valor": 4456637.0,
        "delta": 1127940.0
      },
      {
        "periodo": 202606,
        "valor": 39098413.0,
        "delta": 34641776.0
      },
      {
        "periodo": 202607,
        "valor": 4356309.0,
        "delta": -34742104.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 1035188.6300000004,
    "valor_anterior": 608466.3700000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1167831.7,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 834179.97,
        "delta": -333651.73
      },
      {
        "periodo": 202509,
        "valor": 640777.48,
        "delta": -193402.49
      },
      {
        "periodo": 202510,
        "valor": 1013030.81,
        "delta": 372253.33
      },
      {
        "periodo": 202511,
        "valor": 758738.21,
        "delta": -254292.6
      },
      {
        "periodo": 202512,
        "valor": 446990.77,
        "delta": -311747.44
      },
      {
        "periodo": 202601,
        "valor": 709181.83,
        "delta": 262191.06
      },
      {
        "periodo": 202602,
        "valor": 596516.63,
        "delta": -112665.2
      },
      {
        "periodo": 202603,
        "valor": 418780.03,
        "delta": -177736.6
      },
      {
        "periodo": 202604,
        "valor": 900419.83,
        "delta": 481639.8
      },
      {
        "periodo": 202605,
        "valor": 460219.0,
        "delta": -440200.83
      },
      {
        "periodo": 202606,
        "valor": 608466.37,
        "delta": 148247.37
      },
      {
        "periodo": 202607,
        "valor": 1035188.63,
        "delta": 426722.26
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 157139040.09000003,
    "valor_anterior": 161518342.16999996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 123643.52,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 141672.46,
        "delta": 18028.94
      },
      {
        "periodo": 202509,
        "valor": 86425.57,
        "delta": -55246.89
      },
      {
        "periodo": 202510,
        "valor": 108025.0,
        "delta": 21599.43
      },
      {
        "periodo": 202511,
        "valor": 22587.83,
        "delta": -85437.17
      },
      {
        "periodo": 202512,
        "valor": 92097.76,
        "delta": 69509.93
      },
      {
        "periodo": 202601,
        "valor": 72320.59,
        "delta": -19777.17
      },
      {
        "periodo": 202602,
        "valor": 123729060.55,
        "delta": 123656739.96
      },
      {
        "periodo": 202603,
        "valor": 155999041.0,
        "delta": 32269980.45
      },
      {
        "periodo": 202604,
        "valor": 154446312.88,
        "delta": -1552728.12
      },
      {
        "periodo": 202605,
        "valor": 144523838.2,
        "delta": -9922474.68
      },
      {
        "periodo": 202606,
        "valor": 161518342.17,
        "delta": 16994503.97
      },
      {
        "periodo": 202607,
        "valor": 157139040.09,
        "delta": -4379302.08
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 20283992.0,
    "valor_anterior": 20566425.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8257101.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4207094.0,
        "delta": -4050007.0
      },
      {
        "periodo": 202509,
        "valor": 7670449.0,
        "delta": 3463355.0
      },
      {
        "periodo": 202510,
        "valor": 9781708.0,
        "delta": 2111259.0
      },
      {
        "periodo": 202511,
        "valor": 27393463.0,
        "delta": 17611755.0
      },
      {
        "periodo": 202512,
        "valor": 16323484.0,
        "delta": -11069979.0
      },
      {
        "periodo": 202601,
        "valor": 14211273.0,
        "delta": -2112211.0
      },
      {
        "periodo": 202602,
        "valor": 14620871.0,
        "delta": 409598.0
      },
      {
        "periodo": 202603,
        "valor": 19827238.0,
        "delta": 5206367.0
      },
      {
        "periodo": 202604,
        "valor": 21009728.0,
        "delta": 1182490.0
      },
      {
        "periodo": 202605,
        "valor": 25360944.0,
        "delta": 4351216.0
      },
      {
        "periodo": 202606,
        "valor": 20566425.0,
        "delta": -4794519.0
      },
      {
        "periodo": 202607,
        "valor": 20283992.0,
        "delta": -282433.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 16933559.730000004,
    "valor_anterior": 22529648.08,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 6302050.96,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 2015228.06,
        "delta": -4286822.9
      },
      {
        "periodo": 202601,
        "valor": 2326827.7,
        "delta": 311599.64
      },
      {
        "periodo": 202602,
        "valor": 361996.23,
        "delta": -1964831.47
      },
      {
        "periodo": 202603,
        "valor": 1533888.48,
        "delta": 1171892.25
      },
      {
        "periodo": 202604,
        "valor": 7323082.24,
        "delta": 5789193.76
      },
      {
        "periodo": 202605,
        "valor": 30994124.94,
        "delta": 23671042.7
      },
      {
        "periodo": 202606,
        "valor": 22529648.08,
        "delta": -8464476.86
      },
      {
        "periodo": 202607,
        "valor": 16933559.73,
        "delta": -5596088.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 45134436.0,
    "valor_anterior": 49763152.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 67353482.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 200261373.0,
        "delta": 132907891.0
      },
      {
        "periodo": 202605,
        "valor": 193995543.0,
        "delta": -6265830.0
      },
      {
        "periodo": 202606,
        "valor": 49763152.0,
        "delta": -144232391.0
      },
      {
        "periodo": 202607,
        "valor": 45134436.0,
        "delta": -4628716.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 8404257983.160004,
    "valor_anterior": 9209697198.609993,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8843963058.4,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7663748065.27,
        "delta": -1180214993.13
      },
      {
        "periodo": 202509,
        "valor": 7435336488.52,
        "delta": -228411576.75
      },
      {
        "periodo": 202510,
        "valor": 8098769502.55,
        "delta": 663433014.03
      },
      {
        "periodo": 202511,
        "valor": 8550135549.02,
        "delta": 451366046.47
      },
      {
        "periodo": 202512,
        "valor": 9545883627.5,
        "delta": 995748078.48
      },
      {
        "periodo": 202601,
        "valor": 8348781675.5,
        "delta": -1197101952.0
      },
      {
        "periodo": 202602,
        "valor": 7714642207.45,
        "delta": -634139468.05
      },
      {
        "periodo": 202603,
        "valor": 8692386483.04,
        "delta": 977744275.59
      },
      {
        "periodo": 202604,
        "valor": 8463124631.8,
        "delta": -229261851.24
      },
      {
        "periodo": 202605,
        "valor": 8397091836.69,
        "delta": -66032795.11
      },
      {
        "periodo": 202606,
        "valor": 9209697198.61,
        "delta": 812605361.92
      },
      {
        "periodo": 202607,
        "valor": 8404257983.16,
        "delta": -805439215.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 6298774719.530006,
    "valor_anterior": 7163522296.539997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7002214946.2,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6004839615.35,
        "delta": -997375330.85
      },
      {
        "periodo": 202509,
        "valor": 6456371859.6,
        "delta": 451532244.25
      },
      {
        "periodo": 202510,
        "valor": 6305732161.75,
        "delta": -150639697.85
      },
      {
        "periodo": 202511,
        "valor": 6848609309.39,
        "delta": 542877147.64
      },
      {
        "periodo": 202512,
        "valor": 7393225604.03,
        "delta": 544616294.64
      },
      {
        "periodo": 202601,
        "valor": 6581122915.46,
        "delta": -812102688.57
      },
      {
        "periodo": 202602,
        "valor": 5981740260.48,
        "delta": -599382654.98
      },
      {
        "periodo": 202603,
        "valor": 6595073313.59,
        "delta": 613333053.11
      },
      {
        "periodo": 202604,
        "valor": 6251696140.68,
        "delta": -343377172.91
      },
      {
        "periodo": 202605,
        "valor": 6321680129.7,
        "delta": 69983989.02
      },
      {
        "periodo": 202606,
        "valor": 7163522296.54,
        "delta": 841842166.84
      },
      {
        "periodo": 202607,
        "valor": 6298774719.53,
        "delta": -864747577.01
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 37297130.28,
    "valor_anterior": 40582902.21000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 150867622.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 175902817.26,
        "delta": 25035194.73
      },
      {
        "periodo": 202509,
        "valor": -692306464.34,
        "delta": -868209281.6
      },
      {
        "periodo": 202510,
        "valor": 38616657.0,
        "delta": 730923121.34
      },
      {
        "periodo": 202511,
        "valor": 18294039.67,
        "delta": -20322617.33
      },
      {
        "periodo": 202512,
        "valor": 42118999.73,
        "delta": 23824960.06
      },
      {
        "periodo": 202601,
        "valor": 38254580.77,
        "delta": -3864418.96
      },
      {
        "periodo": 202602,
        "valor": 33707193.65,
        "delta": -4547387.12
      },
      {
        "periodo": 202603,
        "valor": 49909613.3,
        "delta": 16202419.65
      },
      {
        "periodo": 202604,
        "valor": 44536569.4,
        "delta": -5373043.9
      },
      {
        "periodo": 202605,
        "valor": 32403852.33,
        "delta": -12132717.07
      },
      {
        "periodo": 202606,
        "valor": 40582902.21,
        "delta": 8179049.88
      },
      {
        "periodo": 202607,
        "valor": 37297130.28,
        "delta": -3285771.93
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 481825538.75999975,
    "valor_anterior": 495582083.2600002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 529018767.13,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 337308380.54,
        "delta": -191710386.59
      },
      {
        "periodo": 202509,
        "valor": 402285436.07,
        "delta": 64977055.53
      },
      {
        "periodo": 202510,
        "valor": 442016668.79,
        "delta": 39731232.72
      },
      {
        "periodo": 202511,
        "valor": 446738458.74,
        "delta": 4721789.95
      },
      {
        "periodo": 202512,
        "valor": 688599172.8,
        "delta": 241860714.06
      },
      {
        "periodo": 202601,
        "valor": 471300792.29,
        "delta": -217298380.51
      },
      {
        "periodo": 202602,
        "valor": 421262876.07,
        "delta": -50037916.22
      },
      {
        "periodo": 202603,
        "valor": 562894694.22,
        "delta": 141631818.15
      },
      {
        "periodo": 202604,
        "valor": 467813801.19,
        "delta": -95080893.03
      },
      {
        "periodo": 202605,
        "valor": 456794394.31,
        "delta": -11019406.88
      },
      {
        "periodo": 202606,
        "valor": 495582083.26,
        "delta": 38787688.95
      },
      {
        "periodo": 202607,
        "valor": 481825538.76,
        "delta": -13756544.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 615814487.0799999,
    "valor_anterior": 585163356.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 558629703.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 529186230.5,
        "delta": -29443472.69
      },
      {
        "periodo": 202509,
        "valor": 661975789.3,
        "delta": 132789558.8
      },
      {
        "periodo": 202510,
        "valor": 681809717.48,
        "delta": 19833928.18
      },
      {
        "periodo": 202511,
        "valor": 579628983.81,
        "delta": -102180733.67
      },
      {
        "periodo": 202512,
        "valor": 713391972.63,
        "delta": 133762988.82
      },
      {
        "periodo": 202601,
        "valor": 625728757.25,
        "delta": -87663215.38
      },
      {
        "periodo": 202602,
        "valor": 532527166.18,
        "delta": -93201591.07
      },
      {
        "periodo": 202603,
        "valor": 583418961.82,
        "delta": 50891795.64
      },
      {
        "periodo": 202604,
        "valor": 619012602.52,
        "delta": 35593640.7
      },
      {
        "periodo": 202605,
        "valor": 540903990.24,
        "delta": -78108612.28
      },
      {
        "periodo": 202606,
        "valor": 585163356.25,
        "delta": 44259366.01
      },
      {
        "periodo": 202607,
        "valor": 615814487.08,
        "delta": 30651130.83
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 74498396.90000004,
    "valor_anterior": 70486116.15999997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 56805924.73,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 54627061.59,
        "delta": -2178863.14
      },
      {
        "periodo": 202509,
        "valor": 51511224.51,
        "delta": -3115837.08
      },
      {
        "periodo": 202510,
        "valor": 51765790.1,
        "delta": 254565.59
      },
      {
        "periodo": 202511,
        "valor": 56452564.19,
        "delta": 4686774.09
      },
      {
        "periodo": 202512,
        "valor": 75002408.44,
        "delta": 18549844.25
      },
      {
        "periodo": 202601,
        "valor": 67355026.09,
        "delta": -7647382.35
      },
      {
        "periodo": 202602,
        "valor": 54452518.93,
        "delta": -12902507.16
      },
      {
        "periodo": 202603,
        "valor": 76946226.93,
        "delta": 22493708.0
      },
      {
        "periodo": 202604,
        "valor": 75885799.87,
        "delta": -1060427.06
      },
      {
        "periodo": 202605,
        "valor": 71971483.35,
        "delta": -3914316.52
      },
      {
        "periodo": 202606,
        "valor": 70486116.16,
        "delta": -1485367.19
      },
      {
        "periodo": 202607,
        "valor": 74498396.9,
        "delta": 4012280.74
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100167,
    "label": "Comisiones y Tarifas Pagadas",
    "valor_actual": 896047710.6099997,
    "valor_anterior": 854360444.19,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 546426094.62,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 561883960.03,
        "delta": 15457865.41
      },
      {
        "periodo": 202509,
        "valor": 555498643.38,
        "delta": -6385316.65
      },
      {
        "periodo": 202510,
        "valor": 578828507.43,
        "delta": 23329864.05
      },
      {
        "periodo": 202511,
        "valor": 600412193.22,
        "delta": 21583685.79
      },
      {
        "periodo": 202512,
        "valor": 633545469.87,
        "delta": 33133276.65
      },
      {
        "periodo": 202601,
        "valor": 565019603.64,
        "delta": -68525866.23
      },
      {
        "periodo": 202602,
        "valor": 690952192.14,
        "delta": 125932588.5
      },
      {
        "periodo": 202603,
        "valor": 824143673.18,
        "delta": 133191481.04
      },
      {
        "periodo": 202604,
        "valor": 1004179718.14,
        "delta": 180036044.96
      },
      {
        "periodo": 202605,
        "valor": 973337986.76,
        "delta": -30841731.38
      },
      {
        "periodo": 202606,
        "valor": 854360444.19,
        "delta": -118977542.57
      },
      {
        "periodo": 202607,
        "valor": 896047710.61,
        "delta": 41687266.42
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 1234804217.7399998,
    "valor_anterior": 963477009.28,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 901478510.76,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -149167381.68,
        "delta": -1050645892.44
      },
      {
        "periodo": 202509,
        "valor": -542090335.37,
        "delta": -392922953.69
      },
      {
        "periodo": 202510,
        "valor": 973869563.11,
        "delta": 1515959898.48
      },
      {
        "periodo": 202511,
        "valor": -503952833.01,
        "delta": -1477822396.12
      },
      {
        "periodo": 202512,
        "valor": -519863168.85,
        "delta": -15910335.84
      },
      {
        "periodo": 202601,
        "valor": -1400680753.05,
        "delta": -880817584.2
      },
      {
        "periodo": 202602,
        "valor": -34270591.57,
        "delta": 1366410161.48
      },
      {
        "periodo": 202603,
        "valor": 2278769379.06,
        "delta": 2313039970.63
      },
      {
        "periodo": 202604,
        "valor": -857751085.43,
        "delta": -3136520464.49
      },
      {
        "periodo": 202605,
        "valor": 83157546.94,
        "delta": 940908632.37
      },
      {
        "periodo": 202606,
        "valor": 963477009.28,
        "delta": 880319462.34
      },
      {
        "periodo": 202607,
        "valor": 1234804217.74,
        "delta": 271327208.46
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 1333827909.75,
    "valor_anterior": 1337203553.42,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1215871778.86,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2161911735.19,
        "delta": 946039956.33
      },
      {
        "periodo": 202509,
        "valor": 1166320432.07,
        "delta": -995591303.12
      },
      {
        "periodo": 202510,
        "valor": 1775164962.51,
        "delta": 608844530.44
      },
      {
        "periodo": 202511,
        "valor": 1919896077.13,
        "delta": 144731114.62
      },
      {
        "periodo": 202512,
        "valor": 1663319760.74,
        "delta": -256576316.39
      },
      {
        "periodo": 202601,
        "valor": 1945395797.98,
        "delta": 282076037.24
      },
      {
        "periodo": 202602,
        "valor": 2277610261.1,
        "delta": 332214463.12
      },
      {
        "periodo": 202603,
        "valor": 1010116125.18,
        "delta": -1267494135.92
      },
      {
        "periodo": 202604,
        "valor": 645141452.65,
        "delta": -364974672.53
      },
      {
        "periodo": 202605,
        "valor": 1053166816.57,
        "delta": 408025363.92
      },
      {
        "periodo": 202606,
        "valor": 1337203553.42,
        "delta": 284036736.85
      },
      {
        "periodo": 202607,
        "valor": 1333827909.75,
        "delta": -3375643.67
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 697014931.999999,
    "valor_anterior": 744620081.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 868725944.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 926008102.0,
        "delta": 57282158.0
      },
      {
        "periodo": 202509,
        "valor": 902210562.0,
        "delta": -23797540.0
      },
      {
        "periodo": 202510,
        "valor": 819189321.0,
        "delta": -83021241.0
      },
      {
        "periodo": 202511,
        "valor": 644935520.0,
        "delta": -174253801.0
      },
      {
        "periodo": 202512,
        "valor": 770128308.0,
        "delta": 125192788.0
      },
      {
        "periodo": 202601,
        "valor": 904654551.0,
        "delta": 134526243.0
      },
      {
        "periodo": 202602,
        "valor": 571718633.0,
        "delta": -332935918.0
      },
      {
        "periodo": 202603,
        "valor": -146047867.0,
        "delta": -717766500.0
      },
      {
        "periodo": 202604,
        "valor": 880760855.0,
        "delta": 1026808722.0
      },
      {
        "periodo": 202605,
        "valor": 1043332124.0,
        "delta": 162571269.0
      },
      {
        "periodo": 202606,
        "valor": 744620081.0,
        "delta": -298712043.0
      },
      {
        "periodo": 202607,
        "valor": 697014932.0,
        "delta": -47605149.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 180185482.0,
    "valor_anterior": 162804079.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 158096057.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 81916228.0,
        "delta": -76179829.0
      },
      {
        "periodo": 202509,
        "valor": 89178718.0,
        "delta": 7262490.0
      },
      {
        "periodo": 202510,
        "valor": 94647379.0,
        "delta": 5468661.0
      },
      {
        "periodo": 202511,
        "valor": 1741462.0,
        "delta": -92905917.0
      },
      {
        "periodo": 202512,
        "valor": -90987137.0,
        "delta": -92728599.0
      },
      {
        "periodo": 202601,
        "valor": 169157701.0,
        "delta": 260144838.0
      },
      {
        "periodo": 202602,
        "valor": 111690312.0,
        "delta": -57467389.0
      },
      {
        "periodo": 202603,
        "valor": 93785705.0,
        "delta": -17904607.0
      },
      {
        "periodo": 202604,
        "valor": 66895421.0,
        "delta": -26890284.0
      },
      {
        "periodo": 202605,
        "valor": 96752899.0,
        "delta": 29857478.0
      },
      {
        "periodo": 202606,
        "valor": 162804079.0,
        "delta": 66051180.0
      },
      {
        "periodo": 202607,
        "valor": 180185482.0,
        "delta": 17381403.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 165701339.67000002,
    "valor_anterior": 69240276.90999997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 100662624.03,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 102842485.77,
        "delta": 2179861.74
      },
      {
        "periodo": 202509,
        "valor": 104019252.07,
        "delta": 1176766.3
      },
      {
        "periodo": 202510,
        "valor": 101438302.1,
        "delta": -2580949.97
      },
      {
        "periodo": 202511,
        "valor": 72517760.56,
        "delta": -28920541.54
      },
      {
        "periodo": 202512,
        "valor": 57732384.21,
        "delta": -14785376.35
      },
      {
        "periodo": 202601,
        "valor": 110289623.3,
        "delta": 52557239.09
      },
      {
        "periodo": 202602,
        "valor": 102896581.73,
        "delta": -7393041.57
      },
      {
        "periodo": 202603,
        "valor": 9330336.24,
        "delta": -93566245.49
      },
      {
        "periodo": 202604,
        "valor": 138478082.16,
        "delta": 129147745.92
      },
      {
        "periodo": 202605,
        "valor": 83658767.86,
        "delta": -54819314.3
      },
      {
        "periodo": 202606,
        "valor": 69240276.91,
        "delta": -14418490.95
      },
      {
        "periodo": 202607,
        "valor": 165701339.67,
        "delta": 96461062.76
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -180435263.0,
    "valor_anterior": -743376268.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -264752127.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 195661816.0,
        "delta": 460413943.0
      },
      {
        "periodo": 202509,
        "valor": 62518387.0,
        "delta": -133143429.0
      },
      {
        "periodo": 202510,
        "valor": -251325896.0,
        "delta": -313844283.0
      },
      {
        "periodo": 202511,
        "valor": -206389073.0,
        "delta": 44936823.0
      },
      {
        "periodo": 202512,
        "valor": 38478892.0,
        "delta": 244867965.0
      },
      {
        "periodo": 202601,
        "valor": 459204265.0,
        "delta": 420725373.0
      },
      {
        "periodo": 202602,
        "valor": 285757405.0,
        "delta": -173446860.0
      },
      {
        "periodo": 202603,
        "valor": -2098968.0,
        "delta": -287856373.0
      },
      {
        "periodo": 202604,
        "valor": 598593620.0,
        "delta": 600692588.0
      },
      {
        "periodo": 202605,
        "valor": -375515051.0,
        "delta": -974108671.0
      },
      {
        "periodo": 202606,
        "valor": -743376268.0,
        "delta": -367861217.0
      },
      {
        "periodo": 202607,
        "valor": -180435263.0,
        "delta": 562941005.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 46005660.0,
    "valor_anterior": 61636704.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 67423043.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 45679055.0,
        "delta": -21743988.0
      },
      {
        "periodo": 202509,
        "valor": 52610219.0,
        "delta": 6931164.0
      },
      {
        "periodo": 202510,
        "valor": 83626848.0,
        "delta": 31016629.0
      },
      {
        "periodo": 202511,
        "valor": 40429724.0,
        "delta": -43197124.0
      },
      {
        "periodo": 202512,
        "valor": 70046357.0,
        "delta": 29616633.0
      },
      {
        "periodo": 202601,
        "valor": 90505238.0,
        "delta": 20458881.0
      },
      {
        "periodo": 202602,
        "valor": 50537068.0,
        "delta": -39968170.0
      },
      {
        "periodo": 202603,
        "valor": 47492939.0,
        "delta": -3044129.0
      },
      {
        "periodo": 202604,
        "valor": 131744503.0,
        "delta": 84251564.0
      },
      {
        "periodo": 202605,
        "valor": 28954706.0,
        "delta": -102789797.0
      },
      {
        "periodo": 202606,
        "valor": 61636704.0,
        "delta": 32681998.0
      },
      {
        "periodo": 202607,
        "valor": 46005660.0,
        "delta": -15631044.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -14267249.0,
    "valor_anterior": 102375945.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 96678760.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 114366735.0,
        "delta": 17687975.0
      },
      {
        "periodo": 202509,
        "valor": 180743478.0,
        "delta": 66376743.0
      },
      {
        "periodo": 202510,
        "valor": 155607989.0,
        "delta": -25135489.0
      },
      {
        "periodo": 202511,
        "valor": 203843605.0,
        "delta": 48235616.0
      },
      {
        "periodo": 202512,
        "valor": 133659070.0,
        "delta": -70184535.0
      },
      {
        "periodo": 202601,
        "valor": 178333652.0,
        "delta": 44674582.0
      },
      {
        "periodo": 202602,
        "valor": 202187634.0,
        "delta": 23853982.0
      },
      {
        "periodo": 202603,
        "valor": 162022515.0,
        "delta": -40165119.0
      },
      {
        "periodo": 202604,
        "valor": 211667567.0,
        "delta": 49645052.0
      },
      {
        "periodo": 202605,
        "valor": 141009733.0,
        "delta": -70657834.0
      },
      {
        "periodo": 202606,
        "valor": 102375945.0,
        "delta": -38633788.0
      },
      {
        "periodo": 202607,
        "valor": -14267249.0,
        "delta": -116643194.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 82130551.20999998,
    "valor_anterior": 90257377.65999997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 66055653.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18819195.26,
        "delta": -47236458.03
      },
      {
        "periodo": 202509,
        "valor": 35794133.58,
        "delta": 16974938.32
      },
      {
        "periodo": 202510,
        "valor": 99906377.69,
        "delta": 64112244.11
      },
      {
        "periodo": 202511,
        "valor": 203029815.06,
        "delta": 103123437.37
      },
      {
        "periodo": 202512,
        "valor": 82879706.74,
        "delta": -120150108.32
      },
      {
        "periodo": 202601,
        "valor": 65359670.99,
        "delta": -17520035.75
      },
      {
        "periodo": 202602,
        "valor": 60995492.96,
        "delta": -4364178.03
      },
      {
        "periodo": 202603,
        "valor": 117365855.77,
        "delta": 56370362.81
      },
      {
        "periodo": 202604,
        "valor": 67727098.43,
        "delta": -49638757.34
      },
      {
        "periodo": 202605,
        "valor": 62868190.39,
        "delta": -4858908.04
      },
      {
        "periodo": 202606,
        "valor": 90257377.66,
        "delta": 27389187.27
      },
      {
        "periodo": 202607,
        "valor": 82130551.21,
        "delta": -8126826.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -25188960.0,
    "valor_anterior": -3349366.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 341326842.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -768864781.0,
        "delta": -1110191623.0
      },
      {
        "periodo": 202509,
        "valor": 170703736.0,
        "delta": 939568517.0
      },
      {
        "periodo": 202510,
        "valor": 533820223.0,
        "delta": 363116487.0
      },
      {
        "periodo": 202511,
        "valor": 295367991.0,
        "delta": -238452232.0
      },
      {
        "periodo": 202512,
        "valor": 105460762.0,
        "delta": -189907229.0
      },
      {
        "periodo": 202601,
        "valor": -112806067.0,
        "delta": -218266829.0
      },
      {
        "periodo": 202602,
        "valor": 210164537.0,
        "delta": 322970604.0
      },
      {
        "periodo": 202603,
        "valor": -197959318.0,
        "delta": -408123855.0
      },
      {
        "periodo": 202604,
        "valor": 153977580.0,
        "delta": 351936898.0
      },
      {
        "periodo": 202605,
        "valor": 182867561.0,
        "delta": 28889981.0
      },
      {
        "periodo": 202606,
        "valor": -3349366.0,
        "delta": -186216927.0
      },
      {
        "periodo": 202607,
        "valor": -25188960.0,
        "delta": -21839594.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 4896650.0,
    "valor_anterior": 4549402.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -11073021.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11386845.0,
        "delta": 22459866.0
      },
      {
        "periodo": 202509,
        "valor": 6042292.0,
        "delta": -5344553.0
      },
      {
        "periodo": 202510,
        "valor": 2722053.0,
        "delta": -3320239.0
      },
      {
        "periodo": 202511,
        "valor": -5230533.0,
        "delta": -7952586.0
      },
      {
        "periodo": 202512,
        "valor": -2288241.0,
        "delta": 2942292.0
      },
      {
        "periodo": 202601,
        "valor": 14365019.0,
        "delta": 16653260.0
      },
      {
        "periodo": 202602,
        "valor": 14423735.0,
        "delta": 58716.0
      },
      {
        "periodo": 202603,
        "valor": -10428022.0,
        "delta": -24851757.0
      },
      {
        "periodo": 202604,
        "valor": 13662269.0,
        "delta": 24090291.0
      },
      {
        "periodo": 202605,
        "valor": 8594159.0,
        "delta": -5068110.0
      },
      {
        "periodo": 202606,
        "valor": 4549402.0,
        "delta": -4044757.0
      },
      {
        "periodo": 202607,
        "valor": 4896650.0,
        "delta": 347248.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 13576280.0,
    "valor_anterior": 39420044.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 23905349.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 73926676.0,
        "delta": 50021327.0
      },
      {
        "periodo": 202509,
        "valor": 74534772.0,
        "delta": 608096.0
      },
      {
        "periodo": 202510,
        "valor": 46623465.0,
        "delta": -27911307.0
      },
      {
        "periodo": 202511,
        "valor": -3942436.0,
        "delta": -50565901.0
      },
      {
        "periodo": 202512,
        "valor": 57659731.0,
        "delta": 61602167.0
      },
      {
        "periodo": 202601,
        "valor": 9233623.0,
        "delta": -48426108.0
      },
      {
        "periodo": 202602,
        "valor": 2848185.0,
        "delta": -6385438.0
      },
      {
        "periodo": 202603,
        "valor": 19733402.0,
        "delta": 16885217.0
      },
      {
        "periodo": 202604,
        "valor": 18474475.0,
        "delta": -1258927.0
      },
      {
        "periodo": 202605,
        "valor": 14276397.0,
        "delta": -4198078.0
      },
      {
        "periodo": 202606,
        "valor": 39420044.0,
        "delta": 25143647.0
      },
      {
        "periodo": 202607,
        "valor": 13576280.0,
        "delta": -25843764.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 230531392.30999994,
    "valor_anterior": 422736869.93000007,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 62866247.76,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 375018058.95,
        "delta": 312151811.19
      },
      {
        "periodo": 202509,
        "valor": 737499974.36,
        "delta": 362481915.41
      },
      {
        "periodo": 202510,
        "valor": 486478716.61,
        "delta": -251021257.75
      },
      {
        "periodo": 202511,
        "valor": 323113442.3,
        "delta": -163365274.31
      },
      {
        "periodo": 202512,
        "valor": 472492388.66,
        "delta": 149378946.36
      },
      {
        "periodo": 202601,
        "valor": 231191882.34,
        "delta": -241300506.32
      },
      {
        "periodo": 202602,
        "valor": 341502018.4,
        "delta": 110310136.06
      },
      {
        "periodo": 202603,
        "valor": -41656963.33,
        "delta": -383158981.73
      },
      {
        "periodo": 202604,
        "valor": 284613206.72,
        "delta": 326270170.05
      },
      {
        "periodo": 202605,
        "valor": 270354489.62,
        "delta": -14258717.1
      },
      {
        "periodo": 202606,
        "valor": 422736869.93,
        "delta": 152382380.31
      },
      {
        "periodo": 202607,
        "valor": 230531392.31,
        "delta": -192205477.62
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 55280838.0,
    "valor_anterior": -32610466.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30303543.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 131117137.0,
        "delta": 100813594.0
      },
      {
        "periodo": 202509,
        "valor": 115067631.0,
        "delta": -16049506.0
      },
      {
        "periodo": 202510,
        "valor": -93060109.0,
        "delta": -208127740.0
      },
      {
        "periodo": 202511,
        "valor": 24142183.0,
        "delta": 117202292.0
      },
      {
        "periodo": 202512,
        "valor": 532475026.0,
        "delta": 508332843.0
      },
      {
        "periodo": 202601,
        "valor": 388094694.0,
        "delta": -144380332.0
      },
      {
        "periodo": 202602,
        "valor": 134412815.0,
        "delta": -253681879.0
      },
      {
        "periodo": 202603,
        "valor": -192556216.0,
        "delta": -326969031.0
      },
      {
        "periodo": 202604,
        "valor": 364994466.0,
        "delta": 557550682.0
      },
      {
        "periodo": 202605,
        "valor": -119920838.0,
        "delta": -484915304.0
      },
      {
        "periodo": 202606,
        "valor": -32610466.0,
        "delta": 87310372.0
      },
      {
        "periodo": 202607,
        "valor": 55280838.0,
        "delta": 87891304.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 32378177.0,
    "valor_anterior": 34053821.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 60011046.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 35084875.0,
        "delta": -24926171.0
      },
      {
        "periodo": 202509,
        "valor": 47396059.0,
        "delta": 12311184.0
      },
      {
        "periodo": 202510,
        "valor": 30804588.0,
        "delta": -16591471.0
      },
      {
        "periodo": 202511,
        "valor": 34159511.0,
        "delta": 3354923.0
      },
      {
        "periodo": 202512,
        "valor": 48022958.0,
        "delta": 13863447.0
      },
      {
        "periodo": 202601,
        "valor": 6316774.0,
        "delta": -41706184.0
      },
      {
        "periodo": 202602,
        "valor": 25899126.0,
        "delta": 19582352.0
      },
      {
        "periodo": 202603,
        "valor": 28097760.0,
        "delta": 2198634.0
      },
      {
        "periodo": 202604,
        "valor": 34327239.0,
        "delta": 6229479.0
      },
      {
        "periodo": 202605,
        "valor": 30641453.0,
        "delta": -3685786.0
      },
      {
        "periodo": 202606,
        "valor": 34053821.0,
        "delta": 3412368.0
      },
      {
        "periodo": 202607,
        "valor": 32378177.0,
        "delta": -1675644.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -3368960.0,
    "valor_anterior": 65754571.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 136582886.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 145782476.0,
        "delta": 9199590.0
      },
      {
        "periodo": 202509,
        "valor": 131481073.0,
        "delta": -14301403.0
      },
      {
        "periodo": 202510,
        "valor": 206774101.0,
        "delta": 75293028.0
      },
      {
        "periodo": 202511,
        "valor": 98601980.0,
        "delta": -108172121.0
      },
      {
        "periodo": 202512,
        "valor": 77271642.0,
        "delta": -21330338.0
      },
      {
        "periodo": 202601,
        "valor": 22463476.0,
        "delta": -54808166.0
      },
      {
        "periodo": 202602,
        "valor": 4385301.0,
        "delta": -18078175.0
      },
      {
        "periodo": 202603,
        "valor": 211961486.0,
        "delta": 207576185.0
      },
      {
        "periodo": 202604,
        "valor": -198414707.0,
        "delta": -410376193.0
      },
      {
        "periodo": 202605,
        "valor": 10985421.0,
        "delta": 209400128.0
      },
      {
        "periodo": 202606,
        "valor": 65754571.0,
        "delta": 54769150.0
      },
      {
        "periodo": 202607,
        "valor": -3368960.0,
        "delta": -69123531.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 840938939.0,
    "valor_anterior": 835532371.5900002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 851226858.12,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 882190150.35,
        "delta": 30963292.23
      },
      {
        "periodo": 202509,
        "valor": 888180245.77,
        "delta": 5990095.42
      },
      {
        "periodo": 202510,
        "valor": 939722966.58,
        "delta": 51542720.81
      },
      {
        "periodo": 202511,
        "valor": 686769991.43,
        "delta": -252952975.15
      },
      {
        "periodo": 202512,
        "valor": 840859654.7,
        "delta": 154089663.27
      },
      {
        "periodo": 202601,
        "valor": 840241222.61,
        "delta": -618432.09
      },
      {
        "periodo": 202602,
        "valor": 803136614.59,
        "delta": -37104608.02
      },
      {
        "periodo": 202603,
        "valor": 448160733.41,
        "delta": -354975881.18
      },
      {
        "periodo": 202604,
        "valor": 607263323.18,
        "delta": 159102589.77
      },
      {
        "periodo": 202605,
        "valor": 767802997.58,
        "delta": 160539674.4
      },
      {
        "periodo": 202606,
        "valor": 835532371.59,
        "delta": 67729374.01
      },
      {
        "periodo": 202607,
        "valor": 840938939.0,
        "delta": 5406567.41
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 59632745.0,
    "valor_anterior": 102494715.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 43590505.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 106397298.0,
        "delta": 62806793.0
      },
      {
        "periodo": 202509,
        "valor": 267517232.0,
        "delta": 161119934.0
      },
      {
        "periodo": 202510,
        "valor": 270073900.0,
        "delta": 2556668.0
      },
      {
        "periodo": 202511,
        "valor": 84386016.0,
        "delta": -185687884.0
      },
      {
        "periodo": 202512,
        "valor": 145251256.0,
        "delta": 60865240.0
      },
      {
        "periodo": 202601,
        "valor": 162002200.0,
        "delta": 16750944.0
      },
      {
        "periodo": 202602,
        "valor": 93694166.0,
        "delta": -68308034.0
      },
      {
        "periodo": 202603,
        "valor": 79973770.0,
        "delta": -13720396.0
      },
      {
        "periodo": 202604,
        "valor": 175876722.0,
        "delta": 95902952.0
      },
      {
        "periodo": 202605,
        "valor": 100233786.0,
        "delta": -75642936.0
      },
      {
        "periodo": 202606,
        "valor": 102494715.0,
        "delta": 2260929.0
      },
      {
        "periodo": 202607,
        "valor": 59632745.0,
        "delta": -42861970.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -236167551.6500001,
    "valor_anterior": 876248354.36,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 491008346.3,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 516004175.31,
        "delta": 24995829.01
      },
      {
        "periodo": 202509,
        "valor": 1260601546.93,
        "delta": 744597371.62
      },
      {
        "periodo": 202510,
        "valor": 42468231.78,
        "delta": -1218133315.15
      },
      {
        "periodo": 202511,
        "valor": 493685296.38,
        "delta": 451217064.6
      },
      {
        "periodo": 202512,
        "valor": 1657007483.68,
        "delta": 1163322187.3
      },
      {
        "periodo": 202601,
        "valor": 1213735346.94,
        "delta": -443272136.74
      },
      {
        "periodo": 202602,
        "valor": 761816419.86,
        "delta": -451918927.08
      },
      {
        "periodo": 202603,
        "valor": -1470476467.19,
        "delta": -2232292887.05
      },
      {
        "periodo": 202604,
        "valor": -342778822.2,
        "delta": 1127697644.99
      },
      {
        "periodo": 202605,
        "valor": 379373149.41,
        "delta": 722151971.61
      },
      {
        "periodo": 202606,
        "valor": 876248354.36,
        "delta": 496875204.95
      },
      {
        "periodo": 202607,
        "valor": -236167551.65,
        "delta": -1112415906.01
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -454009.0,
    "valor_anterior": 264752.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -876678.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 365602.0,
        "delta": 1242280.0
      },
      {
        "periodo": 202509,
        "valor": -843848.0,
        "delta": -1209450.0
      },
      {
        "periodo": 202510,
        "valor": 223369.0,
        "delta": 1067217.0
      },
      {
        "periodo": 202511,
        "valor": -6361707.0,
        "delta": -6585076.0
      },
      {
        "periodo": 202512,
        "valor": 12319527.0,
        "delta": 18681234.0
      },
      {
        "periodo": 202601,
        "valor": -532658.0,
        "delta": -12852185.0
      },
      {
        "periodo": 202602,
        "valor": -5029657.0,
        "delta": -4496999.0
      },
      {
        "periodo": 202603,
        "valor": 2561962.0,
        "delta": 7591619.0
      },
      {
        "periodo": 202604,
        "valor": -1628356.0,
        "delta": -4190318.0
      },
      {
        "periodo": 202605,
        "valor": -2003562.0,
        "delta": -375206.0
      },
      {
        "periodo": 202606,
        "valor": 264752.0,
        "delta": 2268314.0
      },
      {
        "periodo": 202607,
        "valor": -454009.0,
        "delta": -718761.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 84458406.97000003,
    "valor_anterior": 153348445.96000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 45481955.13,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 247006127.37,
        "delta": 201524172.24
      },
      {
        "periodo": 202509,
        "valor": 83836767.49,
        "delta": -163169359.88
      },
      {
        "periodo": 202510,
        "valor": 378106719.51,
        "delta": 294269952.02
      },
      {
        "periodo": 202511,
        "valor": 148148222.15,
        "delta": -229958497.36
      },
      {
        "periodo": 202512,
        "valor": 130104686.67,
        "delta": -18043535.48
      },
      {
        "periodo": 202601,
        "valor": 413784378.05,
        "delta": 283679691.38
      },
      {
        "periodo": 202602,
        "valor": 441782459.59,
        "delta": 27998081.54
      },
      {
        "periodo": 202603,
        "valor": -135799733.32,
        "delta": -577582192.91
      },
      {
        "periodo": 202604,
        "valor": 136695691.84,
        "delta": 272495425.16
      },
      {
        "periodo": 202605,
        "valor": -40662102.65,
        "delta": -177357794.49
      },
      {
        "periodo": 202606,
        "valor": 153348445.96,
        "delta": 194010548.61
      },
      {
        "periodo": 202607,
        "valor": 84458406.97,
        "delta": -68890038.99
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 279397265.0,
    "valor_anterior": 271168778.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -549356.66,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8783540.15,
        "delta": 9332896.81
      },
      {
        "periodo": 202509,
        "valor": 303773192.92,
        "delta": 294989652.77
      },
      {
        "periodo": 202510,
        "valor": 85284108.0,
        "delta": -218489084.92
      },
      {
        "periodo": 202511,
        "valor": 64084684.0,
        "delta": -21199424.0
      },
      {
        "periodo": 202512,
        "valor": 184971074.0,
        "delta": 120886390.0
      },
      {
        "periodo": 202601,
        "valor": 137199530.0,
        "delta": -47771544.0
      },
      {
        "periodo": 202602,
        "valor": 161188794.0,
        "delta": 23989264.0
      },
      {
        "periodo": 202603,
        "valor": 296042038.0,
        "delta": 134853244.0
      },
      {
        "periodo": 202604,
        "valor": 216022420.0,
        "delta": -80019618.0
      },
      {
        "periodo": 202605,
        "valor": 269982221.0,
        "delta": 53959801.0
      },
      {
        "periodo": 202606,
        "valor": 271168778.0,
        "delta": 1186557.0
      },
      {
        "periodo": 202607,
        "valor": 279397265.0,
        "delta": 8228487.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 16310604.0,
    "valor_anterior": 48348766.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 117586437.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 148421387.0,
        "delta": 30834950.0
      },
      {
        "periodo": 202509,
        "valor": 210390224.0,
        "delta": 61968837.0
      },
      {
        "periodo": 202510,
        "valor": 77486432.0,
        "delta": -132903792.0
      },
      {
        "periodo": 202511,
        "valor": 82006465.0,
        "delta": 4520033.0
      },
      {
        "periodo": 202512,
        "valor": 54461400.0,
        "delta": -27545065.0
      },
      {
        "periodo": 202601,
        "valor": 88865896.0,
        "delta": 34404496.0
      },
      {
        "periodo": 202602,
        "valor": 156193239.0,
        "delta": 67327343.0
      },
      {
        "periodo": 202603,
        "valor": 11945582.0,
        "delta": -144247657.0
      },
      {
        "periodo": 202604,
        "valor": 114436352.0,
        "delta": 102490770.0
      },
      {
        "periodo": 202605,
        "valor": 123436029.0,
        "delta": 8999677.0
      },
      {
        "periodo": 202606,
        "valor": 48348766.0,
        "delta": -75087263.0
      },
      {
        "periodo": 202607,
        "valor": 16310604.0,
        "delta": -32038162.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -2365675.0,
    "valor_anterior": 2748713.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 316565.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -278097.0,
        "delta": -594662.0
      },
      {
        "periodo": 202509,
        "valor": 73326.0,
        "delta": 351423.0
      },
      {
        "periodo": 202510,
        "valor": 393307.0,
        "delta": 319981.0
      },
      {
        "periodo": 202511,
        "valor": -188920.0,
        "delta": -582227.0
      },
      {
        "periodo": 202512,
        "valor": -158667.0,
        "delta": 30253.0
      },
      {
        "periodo": 202601,
        "valor": 259861.0,
        "delta": 418528.0
      },
      {
        "periodo": 202602,
        "valor": -870523.0,
        "delta": -1130384.0
      },
      {
        "periodo": 202603,
        "valor": 3683232.0,
        "delta": 4553755.0
      },
      {
        "periodo": 202604,
        "valor": -4834969.0,
        "delta": -8518201.0
      },
      {
        "periodo": 202605,
        "valor": -2203362.0,
        "delta": 2631607.0
      },
      {
        "periodo": 202606,
        "valor": 2748713.0,
        "delta": 4952075.0
      },
      {
        "periodo": 202607,
        "valor": -2365675.0,
        "delta": -5114388.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 41209600.0,
    "valor_anterior": 51131778.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -11215970.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13207298.0,
        "delta": 24423268.0
      },
      {
        "periodo": 202509,
        "valor": 15582702.0,
        "delta": 2375404.0
      },
      {
        "periodo": 202510,
        "valor": 28983337.0,
        "delta": 13400635.0
      },
      {
        "periodo": 202511,
        "valor": 10473353.0,
        "delta": -18509984.0
      },
      {
        "periodo": 202512,
        "valor": 1423360.0,
        "delta": -9049993.0
      },
      {
        "periodo": 202601,
        "valor": 23488099.0,
        "delta": 22064739.0
      },
      {
        "periodo": 202602,
        "valor": 12903131.0,
        "delta": -10584968.0
      },
      {
        "periodo": 202603,
        "valor": 21638702.0,
        "delta": 8735571.0
      },
      {
        "periodo": 202604,
        "valor": 10326675.0,
        "delta": -11312027.0
      },
      {
        "periodo": 202605,
        "valor": 18101139.0,
        "delta": 7774464.0
      },
      {
        "periodo": 202606,
        "valor": 51131778.0,
        "delta": 33030639.0
      },
      {
        "periodo": 202607,
        "valor": 41209600.0,
        "delta": -9922178.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 50919203.0,
    "valor_anterior": -126875084.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 32576282.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -101600964.0,
        "delta": -134177246.0
      },
      {
        "periodo": 202509,
        "valor": 102016188.0,
        "delta": 203617152.0
      },
      {
        "periodo": 202510,
        "valor": 25495102.0,
        "delta": -76521086.0
      },
      {
        "periodo": 202511,
        "valor": 17350820.0,
        "delta": -8144282.0
      },
      {
        "periodo": 202512,
        "valor": 58496246.0,
        "delta": 41145426.0
      },
      {
        "periodo": 202601,
        "valor": 193678555.0,
        "delta": 135182309.0
      },
      {
        "periodo": 202602,
        "valor": -220930104.0,
        "delta": -414608659.0
      },
      {
        "periodo": 202603,
        "valor": -161418135.0,
        "delta": 59511969.0
      },
      {
        "periodo": 202604,
        "valor": 95650418.0,
        "delta": 257068553.0
      },
      {
        "periodo": 202605,
        "valor": 29469685.0,
        "delta": -66180733.0
      },
      {
        "periodo": 202606,
        "valor": -126875084.0,
        "delta": -156344769.0
      },
      {
        "periodo": 202607,
        "valor": 50919203.0,
        "delta": 177794287.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 123468557.0,
    "valor_anterior": -106146282.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -120972280.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2348253.0,
        "delta": 123320533.0
      },
      {
        "periodo": 202509,
        "valor": 559807.0,
        "delta": -1788446.0
      },
      {
        "periodo": 202510,
        "valor": 18123423.0,
        "delta": 17563616.0
      },
      {
        "periodo": 202511,
        "valor": 4806293.0,
        "delta": -13317130.0
      },
      {
        "periodo": 202512,
        "valor": 17512321.0,
        "delta": 12706028.0
      },
      {
        "periodo": 202601,
        "valor": 26836481.0,
        "delta": 9324160.0
      },
      {
        "periodo": 202602,
        "valor": 27400414.0,
        "delta": 563933.0
      },
      {
        "periodo": 202603,
        "valor": -89100018.0,
        "delta": -116500432.0
      },
      {
        "periodo": 202604,
        "valor": 10474874.0,
        "delta": 99574892.0
      },
      {
        "periodo": 202605,
        "valor": 3200053.0,
        "delta": -7274821.0
      },
      {
        "periodo": 202606,
        "valor": -106146282.0,
        "delta": -109346335.0
      },
      {
        "periodo": 202607,
        "valor": 123468557.0,
        "delta": 229614839.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -8250619.3999999985,
    "valor_anterior": 43740113.169999994,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -18145948.88,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 156235652.36,
        "delta": 174381601.24
      },
      {
        "periodo": 202509,
        "valor": 120294503.67,
        "delta": -35941148.69
      },
      {
        "periodo": 202510,
        "valor": 70773152.59,
        "delta": -49521351.08
      },
      {
        "periodo": 202511,
        "valor": 741166.42,
        "delta": -70031986.17
      },
      {
        "periodo": 202512,
        "valor": -79543032.08,
        "delta": -80284198.5
      },
      {
        "periodo": 202601,
        "valor": 63535504.97,
        "delta": 143078537.05
      },
      {
        "periodo": 202602,
        "valor": 72374668.16,
        "delta": 8839163.19
      },
      {
        "periodo": 202603,
        "valor": -201350454.65,
        "delta": -273725122.81
      },
      {
        "periodo": 202604,
        "valor": 34916717.35,
        "delta": 236267172.0
      },
      {
        "periodo": 202605,
        "valor": 28829457.69,
        "delta": -6087259.66
      },
      {
        "periodo": 202606,
        "valor": 43740113.17,
        "delta": 14910655.48
      },
      {
        "periodo": 202607,
        "valor": -8250619.4,
        "delta": -51990732.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 133890.0,
    "valor_anterior": 1369094.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 366188.0,
        "delta": 366188.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": -366188.0
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": 1.0
      },
      {
        "periodo": 202602,
        "valor": 1118.0,
        "delta": 1117.0
      },
      {
        "periodo": 202603,
        "valor": 1048224.0,
        "delta": 1047106.0
      },
      {
        "periodo": 202604,
        "valor": 139693.0,
        "delta": -908531.0
      },
      {
        "periodo": 202605,
        "valor": 5710136.0,
        "delta": 5570443.0
      },
      {
        "periodo": 202606,
        "valor": 1369094.0,
        "delta": -4341042.0
      },
      {
        "periodo": 202607,
        "valor": 133890.0,
        "delta": -1235204.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 2985229.0,
    "valor_anterior": -1617981.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10614241.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24931064.0,
        "delta": 14316823.0
      },
      {
        "periodo": 202509,
        "valor": 36824640.0,
        "delta": 11893576.0
      },
      {
        "periodo": 202510,
        "valor": 31309376.0,
        "delta": -5515264.0
      },
      {
        "periodo": 202511,
        "valor": -694208.0,
        "delta": -32003584.0
      },
      {
        "periodo": 202512,
        "valor": -12730830.0,
        "delta": -12036622.0
      },
      {
        "periodo": 202601,
        "valor": 1820563.0,
        "delta": 14551393.0
      },
      {
        "periodo": 202602,
        "valor": 9353448.0,
        "delta": 7532885.0
      },
      {
        "periodo": 202603,
        "valor": 11741794.0,
        "delta": 2388346.0
      },
      {
        "periodo": 202604,
        "valor": 10497063.0,
        "delta": -1244731.0
      },
      {
        "periodo": 202605,
        "valor": 12898277.0,
        "delta": 2401214.0
      },
      {
        "periodo": 202606,
        "valor": -1617981.0,
        "delta": -14516258.0
      },
      {
        "periodo": 202607,
        "valor": 2985229.0,
        "delta": 4603210.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 7357115.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2147465.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5253163.0,
        "delta": 7400628.0
      },
      {
        "periodo": 202509,
        "valor": 331722.0,
        "delta": -4921441.0
      },
      {
        "periodo": 202510,
        "valor": -914655.0,
        "delta": -1246377.0
      },
      {
        "periodo": 202511,
        "valor": -1559161.0,
        "delta": -644506.0
      },
      {
        "periodo": 202512,
        "valor": -718476.0,
        "delta": 840685.0
      },
      {
        "periodo": 202601,
        "valor": 7776652.0,
        "delta": 8495128.0
      },
      {
        "periodo": 202602,
        "valor": 1316397.0,
        "delta": -6460255.0
      },
      {
        "periodo": 202603,
        "valor": 3116510.0,
        "delta": 1800113.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": -3116510.0
      },
      {
        "periodo": 202605,
        "valor": -450686.0,
        "delta": -450686.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 450686.0
      },
      {
        "periodo": 202607,
        "valor": 7357115.0,
        "delta": 7357115.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -768079846.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 409825625.0,
        "delta": 1177905471.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 448355087.0,
    "valor_anterior": 524875269.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 359522061.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 444718333.0,
        "delta": 85196272.0
      },
      {
        "periodo": 202509,
        "valor": 408815443.0,
        "delta": -35902890.0
      },
      {
        "periodo": 202510,
        "valor": 470863401.0,
        "delta": 62047958.0
      },
      {
        "periodo": 202511,
        "valor": 443271497.0,
        "delta": -27591904.0
      },
      {
        "periodo": 202512,
        "valor": 477016685.0,
        "delta": 33745188.0
      },
      {
        "periodo": 202601,
        "valor": 467718147.0,
        "delta": -9298538.0
      },
      {
        "periodo": 202602,
        "valor": 510049295.0,
        "delta": 42331148.0
      },
      {
        "periodo": 202603,
        "valor": 456621511.0,
        "delta": -53427784.0
      },
      {
        "periodo": 202604,
        "valor": 511223238.0,
        "delta": 54601727.0
      },
      {
        "periodo": 202605,
        "valor": 534418215.0,
        "delta": 23194977.0
      },
      {
        "periodo": 202606,
        "valor": 524875269.0,
        "delta": -9542946.0
      },
      {
        "periodo": 202607,
        "valor": 448355087.0,
        "delta": -76520182.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 25205341.0,
    "valor_anterior": 13593695.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -3475194.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2223442.0,
        "delta": 1251752.0
      },
      {
        "periodo": 202509,
        "valor": -1813056.0,
        "delta": 410386.0
      },
      {
        "periodo": 202510,
        "valor": 1035864.0,
        "delta": 2848920.0
      },
      {
        "periodo": 202511,
        "valor": -1679606.0,
        "delta": -2715470.0
      },
      {
        "periodo": 202512,
        "valor": -3089291.0,
        "delta": -1409685.0
      },
      {
        "periodo": 202601,
        "valor": 317071.0,
        "delta": 3406362.0
      },
      {
        "periodo": 202602,
        "valor": -1135409.0,
        "delta": -1452480.0
      },
      {
        "periodo": 202603,
        "valor": 7955790.0,
        "delta": 9091199.0
      },
      {
        "periodo": 202604,
        "valor": 3810973.0,
        "delta": -4144817.0
      },
      {
        "periodo": 202605,
        "valor": 11174383.0,
        "delta": 7363410.0
      },
      {
        "periodo": 202606,
        "valor": 13593695.0,
        "delta": 2419312.0
      },
      {
        "periodo": 202607,
        "valor": 25205341.0,
        "delta": 11611646.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 610607.0,
    "valor_anterior": 1856247.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1037383.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1297206.0,
        "delta": 259823.0
      },
      {
        "periodo": 202509,
        "valor": 2316640.0,
        "delta": 1019434.0
      },
      {
        "periodo": 202510,
        "valor": 3759017.0,
        "delta": 1442377.0
      },
      {
        "periodo": 202511,
        "valor": 2213955.0,
        "delta": -1545062.0
      },
      {
        "periodo": 202512,
        "valor": 2567338.0,
        "delta": 353383.0
      },
      {
        "periodo": 202601,
        "valor": 2505796.0,
        "delta": -61542.0
      },
      {
        "periodo": 202602,
        "valor": 3768794.0,
        "delta": 1262998.0
      },
      {
        "periodo": 202603,
        "valor": 1985625.0,
        "delta": -1783169.0
      },
      {
        "periodo": 202604,
        "valor": 1974766.0,
        "delta": -10859.0
      },
      {
        "periodo": 202605,
        "valor": 866037.0,
        "delta": -1108729.0
      },
      {
        "periodo": 202606,
        "valor": 1856247.0,
        "delta": 990210.0
      },
      {
        "periodo": 202607,
        "valor": 610607.0,
        "delta": -1245640.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 47933897.82000002,
    "valor_anterior": 46134236.79999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27671303.81,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28748062.48,
        "delta": 1076758.67
      },
      {
        "periodo": 202509,
        "valor": 24482859.18,
        "delta": -4265203.3
      },
      {
        "periodo": 202510,
        "valor": 29534711.38,
        "delta": 5051852.2
      },
      {
        "periodo": 202511,
        "valor": 31402747.97,
        "delta": 1868036.59
      },
      {
        "periodo": 202512,
        "valor": 39401984.5,
        "delta": 7999236.53
      },
      {
        "periodo": 202601,
        "valor": 37900107.83,
        "delta": -1501876.67
      },
      {
        "periodo": 202602,
        "valor": 34409430.27,
        "delta": -3490677.56
      },
      {
        "periodo": 202603,
        "valor": 45492658.83,
        "delta": 11083228.56
      },
      {
        "periodo": 202604,
        "valor": 41140927.61,
        "delta": -4351731.22
      },
      {
        "periodo": 202605,
        "valor": 42824122.01,
        "delta": 1683194.4
      },
      {
        "periodo": 202606,
        "valor": 46134236.8,
        "delta": 3310114.79
      },
      {
        "periodo": 202607,
        "valor": 47933897.82,
        "delta": 1799661.02
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -97550.03999999998,
    "valor_anterior": -23049.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -59490.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -127225.0,
        "delta": -67735.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 127225.0
      },
      {
        "periodo": 202510,
        "valor": -5335.0,
        "delta": -5335.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 5335.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": -16360.0,
        "delta": -16360.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 16360.0
      },
      {
        "periodo": 202603,
        "valor": -973221.77,
        "delta": -973221.77
      },
      {
        "periodo": 202604,
        "valor": 864202.27,
        "delta": 1837424.04
      },
      {
        "periodo": 202605,
        "valor": -65118.43,
        "delta": -929320.7
      },
      {
        "periodo": 202606,
        "valor": -23049.0,
        "delta": 42069.43
      },
      {
        "periodo": 202607,
        "valor": -97550.04,
        "delta": -74501.04
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 12296006.0,
    "valor_anterior": 5912920.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2701720.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5778367.0,
        "delta": 3076647.0
      },
      {
        "periodo": 202509,
        "valor": 9578324.0,
        "delta": 3799957.0
      },
      {
        "periodo": 202510,
        "valor": 1318255.0,
        "delta": -8260069.0
      },
      {
        "periodo": 202511,
        "valor": 9814149.0,
        "delta": 8495894.0
      },
      {
        "periodo": 202512,
        "valor": 15391843.0,
        "delta": 5577694.0
      },
      {
        "periodo": 202601,
        "valor": 14675666.0,
        "delta": -716177.0
      },
      {
        "periodo": 202602,
        "valor": 9336682.0,
        "delta": -5338984.0
      },
      {
        "periodo": 202603,
        "valor": -3459700.0,
        "delta": -12796382.0
      },
      {
        "periodo": 202604,
        "valor": 14445243.0,
        "delta": 17904943.0
      },
      {
        "periodo": 202605,
        "valor": 8306380.0,
        "delta": -6138863.0
      },
      {
        "periodo": 202606,
        "valor": 5912920.0,
        "delta": -2393460.0
      },
      {
        "periodo": 202607,
        "valor": 12296006.0,
        "delta": 6383086.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 10492334.0,
    "valor_anterior": 25124684.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14675797.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -26503513.0,
        "delta": -41179310.0
      },
      {
        "periodo": 202509,
        "valor": -742851.0,
        "delta": 25760662.0
      },
      {
        "periodo": 202510,
        "valor": 4845574.0,
        "delta": 5588425.0
      },
      {
        "periodo": 202511,
        "valor": 12682192.0,
        "delta": 7836618.0
      },
      {
        "periodo": 202512,
        "valor": 21017794.0,
        "delta": 8335602.0
      },
      {
        "periodo": 202601,
        "valor": 9261124.0,
        "delta": -11756670.0
      },
      {
        "periodo": 202602,
        "valor": 5136201.0,
        "delta": -4124923.0
      },
      {
        "periodo": 202603,
        "valor": 36346687.0,
        "delta": 31210486.0
      },
      {
        "periodo": 202604,
        "valor": -1132001.0,
        "delta": -37478688.0
      },
      {
        "periodo": 202605,
        "valor": 3721465.0,
        "delta": 4853466.0
      },
      {
        "periodo": 202606,
        "valor": 25124684.0,
        "delta": 21403219.0
      },
      {
        "periodo": 202607,
        "valor": 10492334.0,
        "delta": -14632350.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 1899987.0,
    "valor_anterior": 361041.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1461923.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1147961.0,
        "delta": -313962.0
      },
      {
        "periodo": 202509,
        "valor": 1133476.0,
        "delta": -14485.0
      },
      {
        "periodo": 202510,
        "valor": 871513.0,
        "delta": -261963.0
      },
      {
        "periodo": 202511,
        "valor": 598890.0,
        "delta": -272623.0
      },
      {
        "periodo": 202512,
        "valor": 910771.0,
        "delta": 311881.0
      },
      {
        "periodo": 202601,
        "valor": 528537.0,
        "delta": -382234.0
      },
      {
        "periodo": 202602,
        "valor": 1399197.0,
        "delta": 870660.0
      },
      {
        "periodo": 202603,
        "valor": 1102311.0,
        "delta": -296886.0
      },
      {
        "periodo": 202604,
        "valor": 339399.0,
        "delta": -762912.0
      },
      {
        "periodo": 202605,
        "valor": 872342.0,
        "delta": 532943.0
      },
      {
        "periodo": 202606,
        "valor": 361041.0,
        "delta": -511301.0
      },
      {
        "periodo": 202607,
        "valor": 1899987.0,
        "delta": 1538946.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 4462330.310000002,
    "valor_anterior": 4712259.189999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15577403.95,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11225058.65,
        "delta": -4352345.3
      },
      {
        "periodo": 202509,
        "valor": 56528169.76,
        "delta": 45303111.11
      },
      {
        "periodo": 202510,
        "valor": 8629234.03,
        "delta": -47898935.73
      },
      {
        "periodo": 202511,
        "valor": 5866877.0,
        "delta": -2762357.03
      },
      {
        "periodo": 202512,
        "valor": 12269133.23,
        "delta": 6402256.23
      },
      {
        "periodo": 202601,
        "valor": 9540499.97,
        "delta": -2728633.26
      },
      {
        "periodo": 202602,
        "valor": 5505501.1,
        "delta": -4034998.87
      },
      {
        "periodo": 202603,
        "valor": 10230807.88,
        "delta": 4725306.78
      },
      {
        "periodo": 202604,
        "valor": 4860450.69,
        "delta": -5370357.19
      },
      {
        "periodo": 202605,
        "valor": 3703352.74,
        "delta": -1157097.95
      },
      {
        "periodo": 202606,
        "valor": 4712259.19,
        "delta": 1008906.45
      },
      {
        "periodo": 202607,
        "valor": 4462330.31,
        "delta": -249928.88
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 662149.44,
    "valor_anterior": 1918137.6300000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9795077.14,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 31577529.79,
        "delta": 21782452.65
      },
      {
        "periodo": 202509,
        "valor": -41124632.44,
        "delta": -72702162.23
      },
      {
        "periodo": 202510,
        "valor": 58835.18,
        "delta": 41183467.62
      },
      {
        "periodo": 202511,
        "valor": 12032.94,
        "delta": -46802.24
      },
      {
        "periodo": 202512,
        "valor": 251539.65,
        "delta": 239506.71
      },
      {
        "periodo": 202601,
        "valor": 116361.1,
        "delta": -135178.55
      },
      {
        "periodo": 202602,
        "valor": 7196.95,
        "delta": -109164.15
      },
      {
        "periodo": 202603,
        "valor": -9321.96,
        "delta": -16518.91
      },
      {
        "periodo": 202604,
        "valor": -24039.34,
        "delta": -14717.38
      },
      {
        "periodo": 202605,
        "valor": 19321.2,
        "delta": 43360.54
      },
      {
        "periodo": 202606,
        "valor": 1918137.63,
        "delta": 1898816.43
      },
      {
        "periodo": 202607,
        "valor": 662149.44,
        "delta": -1255988.19
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -366435.0,
    "valor_anterior": 2757045.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 319700.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -203067.0,
        "delta": -522767.0
      },
      {
        "periodo": 202509,
        "valor": -505724.0,
        "delta": -302657.0
      },
      {
        "periodo": 202510,
        "valor": 497862.0,
        "delta": 1003586.0
      },
      {
        "periodo": 202511,
        "valor": -204670.0,
        "delta": -702532.0
      },
      {
        "periodo": 202512,
        "valor": -546912.0,
        "delta": -342242.0
      },
      {
        "periodo": 202601,
        "valor": -760171.0,
        "delta": -213259.0
      },
      {
        "periodo": 202602,
        "valor": -161668.0,
        "delta": 598503.0
      },
      {
        "periodo": 202603,
        "valor": 1230431.0,
        "delta": 1392099.0
      },
      {
        "periodo": 202604,
        "valor": -881919.0,
        "delta": -2112350.0
      },
      {
        "periodo": 202605,
        "valor": -2784013.0,
        "delta": -1902094.0
      },
      {
        "periodo": 202606,
        "valor": 2757045.0,
        "delta": 5541058.0
      },
      {
        "periodo": 202607,
        "valor": -366435.0,
        "delta": -3123480.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -2236880.0,
    "valor_anterior": 1286407.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 89210.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -842592.0,
        "delta": -931802.0
      },
      {
        "periodo": 202509,
        "valor": -780624.0,
        "delta": 61968.0
      },
      {
        "periodo": 202510,
        "valor": 329466.0,
        "delta": 1110090.0
      },
      {
        "periodo": 202511,
        "valor": -181404.0,
        "delta": -510870.0
      },
      {
        "periodo": 202512,
        "valor": -1512120.0,
        "delta": -1330716.0
      },
      {
        "periodo": 202601,
        "valor": -3267755.0,
        "delta": -1755635.0
      },
      {
        "periodo": 202602,
        "valor": -607701.0,
        "delta": 2660054.0
      },
      {
        "periodo": 202603,
        "valor": 1988011.0,
        "delta": 2595712.0
      },
      {
        "periodo": 202604,
        "valor": -1471889.0,
        "delta": -3459900.0
      },
      {
        "periodo": 202605,
        "valor": -1337803.0,
        "delta": 134086.0
      },
      {
        "periodo": 202606,
        "valor": 1286407.0,
        "delta": 2624210.0
      },
      {
        "periodo": 202607,
        "valor": -2236880.0,
        "delta": -3523287.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -26052466.0,
    "valor_anterior": -15396638.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -3916639.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -8661483.0,
        "delta": -4744844.0
      },
      {
        "periodo": 202509,
        "valor": 15912276.0,
        "delta": 24573759.0
      },
      {
        "periodo": 202510,
        "valor": 4755867.0,
        "delta": -11156409.0
      },
      {
        "periodo": 202511,
        "valor": -5050787.0,
        "delta": -9806654.0
      },
      {
        "periodo": 202512,
        "valor": 18708324.0,
        "delta": 23759111.0
      },
      {
        "periodo": 202601,
        "valor": -16329470.0,
        "delta": -35037794.0
      },
      {
        "periodo": 202602,
        "valor": -5593416.0,
        "delta": 10736054.0
      },
      {
        "periodo": 202603,
        "valor": -23082232.0,
        "delta": -17488816.0
      },
      {
        "periodo": 202604,
        "valor": -25380810.0,
        "delta": -2298578.0
      },
      {
        "periodo": 202605,
        "valor": 4838563.0,
        "delta": 30219373.0
      },
      {
        "periodo": 202606,
        "valor": -15396638.0,
        "delta": -20235201.0
      },
      {
        "periodo": 202607,
        "valor": -26052466.0,
        "delta": -10655828.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -10910.690000000002,
    "valor_anterior": -32278.1,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -22549.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -5246.28,
        "delta": 17303.14
      },
      {
        "periodo": 202509,
        "valor": -21478.08,
        "delta": -16231.8
      },
      {
        "periodo": 202510,
        "valor": 32468.69,
        "delta": 53946.77
      },
      {
        "periodo": 202511,
        "valor": -23260.56,
        "delta": -55729.25
      },
      {
        "periodo": 202512,
        "valor": 50490.78,
        "delta": 73751.34
      },
      {
        "periodo": 202601,
        "valor": -75993.24,
        "delta": -126484.02
      },
      {
        "periodo": 202602,
        "valor": 19664.7,
        "delta": 95657.94
      },
      {
        "periodo": 202603,
        "valor": -23873.4,
        "delta": -43538.1
      },
      {
        "periodo": 202604,
        "valor": 12901.05,
        "delta": 36774.45
      },
      {
        "periodo": 202605,
        "valor": 9770.41,
        "delta": -3130.64
      },
      {
        "periodo": 202606,
        "valor": -32278.1,
        "delta": -42048.51
      },
      {
        "periodo": 202607,
        "valor": -10910.69,
        "delta": 21367.41
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -223007.0,
    "valor_anterior": 608085.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4091823.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1405130.0,
        "delta": -5496953.0
      },
      {
        "periodo": 202509,
        "valor": -2643347.0,
        "delta": -1238217.0
      },
      {
        "periodo": 202510,
        "valor": 1631115.0,
        "delta": 4274462.0
      },
      {
        "periodo": 202511,
        "valor": -882426.0,
        "delta": -2513541.0
      },
      {
        "periodo": 202512,
        "valor": -909254.0,
        "delta": -26828.0
      },
      {
        "periodo": 202601,
        "valor": -781158.0,
        "delta": 128096.0
      },
      {
        "periodo": 202602,
        "valor": 1026454.0,
        "delta": 1807612.0
      },
      {
        "periodo": 202603,
        "valor": 422786.0,
        "delta": -603668.0
      },
      {
        "periodo": 202604,
        "valor": -149538.0,
        "delta": -572324.0
      },
      {
        "periodo": 202605,
        "valor": 12254.0,
        "delta": 161792.0
      },
      {
        "periodo": 202606,
        "valor": 608085.0,
        "delta": 595831.0
      },
      {
        "periodo": 202607,
        "valor": -223007.0,
        "delta": -831092.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -78544.73000000045,
    "valor_anterior": 6021481.450000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": -785535.67,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": -27651.28,
        "delta": 757884.39
      },
      {
        "periodo": 202601,
        "valor": 384111.79,
        "delta": 411763.07
      },
      {
        "periodo": 202602,
        "valor": 703601.58,
        "delta": 319489.79
      },
      {
        "periodo": 202603,
        "valor": 3333682.77,
        "delta": 2630081.19
      },
      {
        "periodo": 202604,
        "valor": 124948.46,
        "delta": -3208734.31
      },
      {
        "periodo": 202605,
        "valor": -872746.33,
        "delta": -997694.79
      },
      {
        "periodo": 202606,
        "valor": 6021481.45,
        "delta": 6894227.78
      },
      {
        "periodo": 202607,
        "valor": -78544.73,
        "delta": -6100026.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -176883.0,
    "valor_anterior": 196848.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": -2941200.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 37529217.0,
        "delta": 40470417.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": -37529217.0
      },
      {
        "periodo": 202606,
        "valor": 196848.0,
        "delta": 196848.0
      },
      {
        "periodo": 202607,
        "valor": -176883.0,
        "delta": -373731.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 5635321759.709999,
    "valor_anterior": 6090456559.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4954046311.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6405100351.67,
        "delta": 1451054040.48
      },
      {
        "periodo": 202509,
        "valor": 5540439217.91,
        "delta": -864661133.76
      },
      {
        "periodo": 202510,
        "valor": 7561974501.76,
        "delta": 2021535283.85
      },
      {
        "periodo": 202511,
        "valor": 5223333347.1,
        "delta": -2338641154.66
      },
      {
        "periodo": 202512,
        "valor": 7087245118.35,
        "delta": 1863911771.25
      },
      {
        "periodo": 202601,
        "valor": 6775487294.58,
        "delta": -311757823.77
      },
      {
        "periodo": 202602,
        "valor": 7240952922.42,
        "delta": 465465627.84
      },
      {
        "periodo": 202603,
        "valor": 2745916640.52,
        "delta": -4495036281.9
      },
      {
        "periodo": 202604,
        "valor": 4205235914.44,
        "delta": 1459319273.92
      },
      {
        "periodo": 202605,
        "valor": 4914608118.01,
        "delta": 709372203.57
      },
      {
        "periodo": 202606,
        "valor": 6090456559.25,
        "delta": 1175848441.24
      },
      {
        "periodo": 202607,
        "valor": 5635321759.71,
        "delta": -455134799.54
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 3481661421.800001,
    "valor_anterior": 2989841269.629999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3038965171.38,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3705715293.46,
        "delta": 666750122.08
      },
      {
        "periodo": 202509,
        "valor": 2596381216.06,
        "delta": -1109334077.4
      },
      {
        "periodo": 202510,
        "valor": 4053632035.23,
        "delta": 1457250819.17
      },
      {
        "periodo": 202511,
        "valor": 2383188200.42,
        "delta": -1670443834.81
      },
      {
        "periodo": 202512,
        "valor": 2467228113.55,
        "delta": 84039913.13
      },
      {
        "periodo": 202601,
        "valor": 2487257096.27,
        "delta": 20028982.72
      },
      {
        "periodo": 202602,
        "valor": 3756195671.93,
        "delta": 1268938575.66
      },
      {
        "periodo": 202603,
        "valor": 3354889925.91,
        "delta": -401305746.02
      },
      {
        "periodo": 202604,
        "valor": 1829921036.94,
        "delta": -1524968888.97
      },
      {
        "periodo": 202605,
        "valor": 2312258558.13,
        "delta": 482337521.19
      },
      {
        "periodo": 202606,
        "valor": 2989841269.63,
        "delta": 677582711.5
      },
      {
        "periodo": 202607,
        "valor": 3481661421.8,
        "delta": 491820152.17
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 1412762582.999999,
    "valor_anterior": 1254261358.5899992,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 321696793.12,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1739082361.35,
        "delta": 1417385568.23
      },
      {
        "periodo": 202509,
        "valor": -256309395.23,
        "delta": -1995391756.58
      },
      {
        "periodo": 202510,
        "valor": 1428709790.58,
        "delta": 1685019185.81
      },
      {
        "periodo": 202511,
        "valor": 1134847781.43,
        "delta": -293862009.15
      },
      {
        "periodo": 202512,
        "valor": 1335388660.7,
        "delta": 200540879.27
      },
      {
        "periodo": 202601,
        "valor": 1334795850.61,
        "delta": -592810.09
      },
      {
        "periodo": 202602,
        "valor": 1340586323.59,
        "delta": 5790472.98
      },
      {
        "periodo": 202603,
        "valor": 815682226.41,
        "delta": -524904097.18
      },
      {
        "periodo": 202604,
        "valor": 1128961435.18,
        "delta": 313279208.77
      },
      {
        "periodo": 202605,
        "valor": 1305421265.58,
        "delta": 176459830.4
      },
      {
        "periodo": 202606,
        "valor": 1254261358.59,
        "delta": -51159906.99
      },
      {
        "periodo": 202607,
        "valor": 1412762583.0,
        "delta": 158501224.41
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": -171067253.64999962,
    "valor_anterior": 1013872902.3599999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1206865073.3,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 297904061.31,
        "delta": -908961011.99
      },
      {
        "periodo": 202509,
        "valor": 2061562385.93,
        "delta": 1763658324.62
      },
      {
        "periodo": 202510,
        "valor": 881703405.78,
        "delta": -1179858980.15
      },
      {
        "periodo": 202511,
        "valor": 1011709618.38,
        "delta": 130006212.6
      },
      {
        "periodo": 202512,
        "valor": 2550109111.68,
        "delta": 1538399493.3
      },
      {
        "periodo": 202601,
        "valor": 1600102006.94,
        "delta": -950007104.74
      },
      {
        "periodo": 202602,
        "valor": 1294288329.86,
        "delta": -305813677.08
      },
      {
        "periodo": 202603,
        "valor": -1596801816.19,
        "delta": -2891090146.05
      },
      {
        "periodo": 202604,
        "valor": 127622560.8,
        "delta": 1724424376.99
      },
      {
        "periodo": 202605,
        "valor": 634608437.41,
        "delta": 506985876.61
      },
      {
        "periodo": 202606,
        "valor": 1013872902.36,
        "delta": 379264464.95
      },
      {
        "periodo": 202607,
        "valor": -171067253.65,
        "delta": -1184940156.01
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 405172229.8800001,
    "valor_anterior": 399885535.5700002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 281191652.32,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 260441819.03,
        "delta": -20749833.29
      },
      {
        "periodo": 202509,
        "valor": 474780687.65,
        "delta": 214338868.62
      },
      {
        "periodo": 202510,
        "valor": 588874338.79,
        "delta": 114093651.14
      },
      {
        "periodo": 202511,
        "valor": 423518860.62,
        "delta": -165355478.17
      },
      {
        "periodo": 202512,
        "valor": 378350857.95,
        "delta": -45168002.67
      },
      {
        "periodo": 202601,
        "valor": 460905955.29,
        "delta": 82555097.34
      },
      {
        "periodo": 202602,
        "valor": 326162640.69,
        "delta": -134743314.6
      },
      {
        "periodo": 202603,
        "valor": 312148290.01,
        "delta": -14014350.68
      },
      {
        "periodo": 202604,
        "valor": 523021079.59,
        "delta": 210872789.58
      },
      {
        "periodo": 202605,
        "valor": 297538054.25,
        "delta": -225483025.34
      },
      {
        "periodo": 202606,
        "valor": 399885535.57,
        "delta": 102347481.32
      },
      {
        "periodo": 202607,
        "valor": 405172229.88,
        "delta": 5286694.31
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 426082896.53,
    "valor_anterior": 225964084.6199999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 75753241.24,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -4849652.93,
        "delta": -80602894.17
      },
      {
        "periodo": 202509,
        "valor": 462152829.42,
        "delta": 467002482.35
      },
      {
        "periodo": 202510,
        "valor": 159032823.59,
        "delta": -303120005.83
      },
      {
        "periodo": 202511,
        "valor": 124618800.91,
        "delta": -34414022.68
      },
      {
        "periodo": 202512,
        "valor": 307370277.38,
        "delta": 182751476.47
      },
      {
        "periodo": 202601,
        "valor": 407543028.9,
        "delta": 100172751.52
      },
      {
        "periodo": 202602,
        "valor": 7367234.32,
        "delta": -400175794.58
      },
      {
        "periodo": 202603,
        "valor": 189557064.98,
        "delta": 182189830.66
      },
      {
        "periodo": 202604,
        "valor": 391414833.23,
        "delta": 201857768.25
      },
      {
        "periodo": 202605,
        "valor": 380119217.52,
        "delta": -11295615.71
      },
      {
        "periodo": 202606,
        "valor": 225964084.62,
        "delta": -154155132.9
      },
      {
        "periodo": 202607,
        "valor": 426082896.53,
        "delta": 200118811.91
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100168,
    "label": "Resultado por Intermediación",
    "valor_actual": 80709882.1500001,
    "valor_anterior": 206631408.4799999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 29574379.83,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 406806469.45,
        "delta": 377232089.62
      },
      {
        "periodo": 202509,
        "valor": 201871494.08,
        "delta": -204934975.37
      },
      {
        "periodo": 202510,
        "valor": 450022107.79,
        "delta": 248150613.71
      },
      {
        "periodo": 202511,
        "valor": 145450085.34,
        "delta": -304572022.45
      },
      {
        "periodo": 202512,
        "valor": 48798097.09,
        "delta": -96651988.25
      },
      {
        "periodo": 202601,
        "valor": 484883356.57,
        "delta": 436085259.48
      },
      {
        "periodo": 202602,
        "valor": 516352722.03,
        "delta": 31469365.46
      },
      {
        "periodo": 202603,
        "valor": -329559050.6,
        "delta": -845911772.63
      },
      {
        "periodo": 202604,
        "valor": 204294968.7,
        "delta": 533854019.3
      },
      {
        "periodo": 202605,
        "valor": -15337414.88,
        "delta": -219632383.58
      },
      {
        "periodo": 202606,
        "valor": 206631408.48,
        "delta": 221968823.36
      },
      {
        "periodo": 202607,
        "valor": 80709882.15,
        "delta": -125921526.33
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -306341868.29999995,
    "valor_anterior": -486298647.1500001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -198972490.06,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -442361312.41,
        "delta": -243388822.35
      },
      {
        "periodo": 202509,
        "valor": -344100407.98,
        "delta": 98260904.43
      },
      {
        "periodo": 202510,
        "valor": -688582431.27,
        "delta": -344482023.29
      },
      {
        "periodo": 202511,
        "valor": -641405579.09,
        "delta": 47176852.18
      },
      {
        "periodo": 202512,
        "valor": -80608981.57,
        "delta": 560796597.52
      },
      {
        "periodo": 202601,
        "valor": 186579368.78,
        "delta": 267188350.35
      },
      {
        "periodo": 202602,
        "valor": -22416654.59,
        "delta": -208996023.37
      },
      {
        "periodo": 202603,
        "valor": 2275751581.1,
        "delta": 2298168235.69
      },
      {
        "periodo": 202604,
        "valor": -210834929.96,
        "delta": -2486586511.06
      },
      {
        "periodo": 202605,
        "valor": -165352332.92,
        "delta": 45482597.04
      },
      {
        "periodo": 202606,
        "valor": -486298647.15,
        "delta": -320946314.23
      },
      {
        "periodo": 202607,
        "valor": -306341868.3,
        "delta": 179956778.85
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -790493671.2900002,
    "valor_anterior": -856049121.9399998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -527422655.05,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -686435997.88,
        "delta": -159013342.83
      },
      {
        "periodo": 202509,
        "valor": -999385100.91,
        "delta": -312949103.03
      },
      {
        "periodo": 202510,
        "valor": -689943516.3,
        "delta": 309441584.61
      },
      {
        "periodo": 202511,
        "valor": -745912645.76,
        "delta": -55969129.46
      },
      {
        "periodo": 202512,
        "valor": 92113657.58,
        "delta": 838026303.34
      },
      {
        "periodo": 202601,
        "valor": -721348867.26,
        "delta": -813462524.84
      },
      {
        "periodo": 202602,
        "valor": -860856714.33,
        "delta": -139507847.07
      },
      {
        "periodo": 202603,
        "valor": 1858750827.41,
        "delta": 2719607541.74
      },
      {
        "periodo": 202604,
        "valor": -759051693.71,
        "delta": -2617802521.12
      },
      {
        "periodo": 202605,
        "valor": -752211269.28,
        "delta": 6840424.43
      },
      {
        "periodo": 202606,
        "valor": -856049121.94,
        "delta": -103837852.66
      },
      {
        "periodo": 202607,
        "valor": -790493671.29,
        "delta": 65555450.65
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -450036898.0,
    "valor_anterior": -887266545.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -614230080.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -532564797.0,
        "delta": 81665283.0
      },
      {
        "periodo": 202509,
        "valor": -862768884.0,
        "delta": -330204087.0
      },
      {
        "periodo": 202510,
        "valor": -537632142.0,
        "delta": 325136742.0
      },
      {
        "periodo": 202511,
        "valor": -665473515.0,
        "delta": -127841373.0
      },
      {
        "periodo": 202512,
        "valor": -652480312.0,
        "delta": 12993203.0
      },
      {
        "periodo": 202601,
        "valor": -619560625.0,
        "delta": 32919687.0
      },
      {
        "periodo": 202602,
        "valor": -578919414.0,
        "delta": 40641211.0
      },
      {
        "periodo": 202603,
        "valor": 1950980323.0,
        "delta": 2529899737.0
      },
      {
        "periodo": 202604,
        "valor": -665108638.0,
        "delta": -2616088961.0
      },
      {
        "periodo": 202605,
        "valor": -516301855.0,
        "delta": 148806783.0
      },
      {
        "periodo": 202606,
        "valor": -887266545.0,
        "delta": -370964690.0
      },
      {
        "periodo": 202607,
        "valor": -450036898.0,
        "delta": 437229647.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 13768225.0,
    "valor_anterior": -42212429.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -98740732.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -96322924.0,
        "delta": 2417808.0
      },
      {
        "periodo": 202509,
        "valor": -57511086.0,
        "delta": 38811838.0
      },
      {
        "periodo": 202510,
        "valor": -43653925.0,
        "delta": 13857161.0
      },
      {
        "periodo": 202511,
        "valor": 639488972.0,
        "delta": 683142897.0
      },
      {
        "periodo": 202512,
        "valor": 34527427.0,
        "delta": -604961545.0
      },
      {
        "periodo": 202601,
        "valor": -60171622.0,
        "delta": -94699049.0
      },
      {
        "periodo": 202602,
        "valor": 964666.0,
        "delta": 61136288.0
      },
      {
        "periodo": 202603,
        "valor": 1172266510.0,
        "delta": 1171301844.0
      },
      {
        "periodo": 202604,
        "valor": -247171646.0,
        "delta": -1419438156.0
      },
      {
        "periodo": 202605,
        "valor": -5088541.0,
        "delta": 242083105.0
      },
      {
        "periodo": 202606,
        "valor": -42212429.0,
        "delta": -37123888.0
      },
      {
        "periodo": 202607,
        "valor": 13768225.0,
        "delta": 55980654.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -90407284.91000009,
    "valor_anterior": -91082586.57999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -75193681.01,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -106152679.24,
        "delta": -30958998.23
      },
      {
        "periodo": 202509,
        "valor": 113649379.48,
        "delta": 219802058.72
      },
      {
        "periodo": 202510,
        "valor": -123030489.04,
        "delta": -236679868.52
      },
      {
        "periodo": 202511,
        "valor": -93409358.38,
        "delta": 29621130.66
      },
      {
        "periodo": 202512,
        "valor": -4882991.46,
        "delta": 88526366.92
      },
      {
        "periodo": 202601,
        "valor": -118893643.5,
        "delta": -114010652.04
      },
      {
        "periodo": 202602,
        "valor": -126541592.08,
        "delta": -7647948.58
      },
      {
        "periodo": 202603,
        "valor": -100299867.9,
        "delta": 26241724.18
      },
      {
        "periodo": 202604,
        "valor": -88300390.74,
        "delta": 11999477.16
      },
      {
        "periodo": 202605,
        "valor": -100077731.37,
        "delta": -11777340.63
      },
      {
        "periodo": 202606,
        "valor": -91082586.58,
        "delta": 8995144.79
      },
      {
        "periodo": 202607,
        "valor": -90407284.91,
        "delta": 675301.67
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -121989317.0,
    "valor_anterior": -139683848.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -115490383.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -77775972.0,
        "delta": 37714411.0
      },
      {
        "periodo": 202509,
        "valor": -188498363.0,
        "delta": -110722391.0
      },
      {
        "periodo": 202510,
        "valor": -61646087.0,
        "delta": 126852276.0
      },
      {
        "periodo": 202511,
        "valor": -120719600.0,
        "delta": -59073513.0
      },
      {
        "periodo": 202512,
        "valor": -154855024.0,
        "delta": -34135424.0
      },
      {
        "periodo": 202601,
        "valor": -117011868.0,
        "delta": 37843156.0
      },
      {
        "periodo": 202602,
        "valor": -123182292.0,
        "delta": -6170424.0
      },
      {
        "periodo": 202603,
        "valor": -174436860.0,
        "delta": -51254568.0
      },
      {
        "periodo": 202604,
        "valor": -134350500.0,
        "delta": 40086360.0
      },
      {
        "periodo": 202605,
        "valor": -123624691.0,
        "delta": 10725809.0
      },
      {
        "periodo": 202606,
        "valor": -139683848.0,
        "delta": -16059157.0
      },
      {
        "periodo": 202607,
        "valor": -121989317.0,
        "delta": 17694531.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -38581879.0,
    "valor_anterior": 9160780.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 289001788.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 290872961.0,
        "delta": 1871173.0
      },
      {
        "periodo": 202509,
        "valor": 299004574.0,
        "delta": 8131613.0
      },
      {
        "periodo": 202510,
        "valor": 71652620.0,
        "delta": -227351954.0
      },
      {
        "periodo": 202511,
        "valor": 102657728.0,
        "delta": 31005108.0
      },
      {
        "periodo": 202512,
        "valor": -463083904.0,
        "delta": -565741632.0
      },
      {
        "periodo": 202601,
        "valor": 210618387.0,
        "delta": 673702291.0
      },
      {
        "periodo": 202602,
        "valor": -37431440.0,
        "delta": -248049827.0
      },
      {
        "periodo": 202603,
        "valor": -52358199.0,
        "delta": -14926759.0
      },
      {
        "periodo": 202604,
        "valor": -41240525.0,
        "delta": 11117674.0
      },
      {
        "periodo": 202605,
        "valor": -34453514.0,
        "delta": 6787011.0
      },
      {
        "periodo": 202606,
        "valor": 9160780.0,
        "delta": 43614294.0
      },
      {
        "periodo": 202607,
        "valor": -38581879.0,
        "delta": -47742659.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 261250148.0,
    "valor_anterior": 267883636.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 208606328.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 135200375.0,
        "delta": -73405953.0
      },
      {
        "periodo": 202509,
        "valor": 88117576.0,
        "delta": -47082799.0
      },
      {
        "periodo": 202510,
        "valor": 36665468.0,
        "delta": -51452108.0
      },
      {
        "periodo": 202511,
        "valor": 152051577.0,
        "delta": 115386109.0
      },
      {
        "periodo": 202512,
        "valor": 138397525.0,
        "delta": -13654052.0
      },
      {
        "periodo": 202601,
        "valor": 438263990.0,
        "delta": 299866465.0
      },
      {
        "periodo": 202602,
        "valor": 248283524.0,
        "delta": -189980466.0
      },
      {
        "periodo": 202603,
        "valor": 1324379642.0,
        "delta": 1076096118.0
      },
      {
        "periodo": 202604,
        "valor": 224557078.0,
        "delta": -1099822564.0
      },
      {
        "periodo": 202605,
        "valor": 248790845.0,
        "delta": 24233767.0
      },
      {
        "periodo": 202606,
        "valor": 267883636.0,
        "delta": 19092791.0
      },
      {
        "periodo": 202607,
        "valor": 261250148.0,
        "delta": -6633488.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 141716818.90999997,
    "valor_anterior": 121110473.65000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -72404681.13,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13296722.95,
        "delta": 85701404.08
      },
      {
        "periodo": 202509,
        "valor": -79376651.1,
        "delta": -92673374.05
      },
      {
        "periodo": 202510,
        "valor": -521107.88,
        "delta": 78855543.22
      },
      {
        "periodo": 202511,
        "valor": 1676724.08,
        "delta": 2197831.96
      },
      {
        "periodo": 202512,
        "valor": 51700489.8,
        "delta": 50023765.72
      },
      {
        "periodo": 202601,
        "valor": -49613879.72,
        "delta": -101314369.52
      },
      {
        "periodo": 202602,
        "valor": 100877684.92,
        "delta": 150491564.64
      },
      {
        "periodo": 202603,
        "valor": 131942288.03,
        "delta": 31064603.11
      },
      {
        "periodo": 202604,
        "valor": 121145257.02,
        "delta": -10797031.01
      },
      {
        "periodo": 202605,
        "valor": 89021842.07,
        "delta": -32123414.95
      },
      {
        "periodo": 202606,
        "valor": 121110473.65,
        "delta": 32088631.58
      },
      {
        "periodo": 202607,
        "valor": 141716818.91,
        "delta": 20606345.26
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 20643367.0,
    "valor_anterior": -4927290.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19356085.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9742556.0,
        "delta": -9613529.0
      },
      {
        "periodo": 202509,
        "valor": 8477805.0,
        "delta": -1264751.0
      },
      {
        "periodo": 202510,
        "valor": 7201970.0,
        "delta": -1275835.0
      },
      {
        "periodo": 202511,
        "valor": -876412.0,
        "delta": -8078382.0
      },
      {
        "periodo": 202512,
        "valor": -32899347.0,
        "delta": -32022935.0
      },
      {
        "periodo": 202601,
        "valor": -1057213.0,
        "delta": 31842134.0
      },
      {
        "periodo": 202602,
        "valor": 16594312.0,
        "delta": 17651525.0
      },
      {
        "periodo": 202603,
        "valor": 18973656.0,
        "delta": 2379344.0
      },
      {
        "periodo": 202604,
        "valor": 29540816.0,
        "delta": 10567160.0
      },
      {
        "periodo": 202605,
        "valor": 3358522.0,
        "delta": -26182294.0
      },
      {
        "periodo": 202606,
        "valor": -4927290.0,
        "delta": -8285812.0
      },
      {
        "periodo": 202607,
        "valor": 20643367.0,
        "delta": 25570657.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -1283253.0,
    "valor_anterior": -1345900.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9528408.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -11380946.0,
        "delta": -20909354.0
      },
      {
        "periodo": 202509,
        "valor": -8616828.0,
        "delta": 2764118.0
      },
      {
        "periodo": 202510,
        "valor": -8494996.0,
        "delta": 121832.0
      },
      {
        "periodo": 202511,
        "valor": -7885522.0,
        "delta": 609474.0
      },
      {
        "periodo": 202512,
        "valor": -9545973.0,
        "delta": -1660451.0
      },
      {
        "periodo": 202601,
        "valor": -2008815.0,
        "delta": 7537158.0
      },
      {
        "periodo": 202602,
        "valor": -1475707.0,
        "delta": 533108.0
      },
      {
        "periodo": 202603,
        "valor": -1636524.0,
        "delta": -160817.0
      },
      {
        "periodo": 202604,
        "valor": 14053781.0,
        "delta": 15690305.0
      },
      {
        "periodo": 202605,
        "valor": 592669.0,
        "delta": -13461112.0
      },
      {
        "periodo": 202606,
        "valor": -1345900.0,
        "delta": -1938569.0
      },
      {
        "periodo": 202607,
        "valor": -1283253.0,
        "delta": 62647.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -7923949.0,
    "valor_anterior": -63742921.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1740568.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2712066.0,
        "delta": -971498.0
      },
      {
        "periodo": 202509,
        "valor": 19997744.0,
        "delta": 22709810.0
      },
      {
        "periodo": 202510,
        "valor": 918571.0,
        "delta": -19079173.0
      },
      {
        "periodo": 202511,
        "valor": 7217328.0,
        "delta": 6298757.0
      },
      {
        "periodo": 202512,
        "valor": -77477627.0,
        "delta": -84694955.0
      },
      {
        "periodo": 202601,
        "valor": 2546061.0,
        "delta": 80023688.0
      },
      {
        "periodo": 202602,
        "valor": -6526364.0,
        "delta": -9072425.0
      },
      {
        "periodo": 202603,
        "valor": 25857278.0,
        "delta": 32383642.0
      },
      {
        "periodo": 202604,
        "valor": -14326835.0,
        "delta": -40184113.0
      },
      {
        "periodo": 202605,
        "valor": 33690303.0,
        "delta": 48017138.0
      },
      {
        "periodo": 202606,
        "valor": -63742921.0,
        "delta": -97433224.0
      },
      {
        "periodo": 202607,
        "valor": -7923949.0,
        "delta": 55818972.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -251172436.21000004,
    "valor_anterior": -500638296.6500001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -336410421.6,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -276923597.94,
        "delta": 59486823.66
      },
      {
        "periodo": 202509,
        "valor": -535901497.11,
        "delta": -258977899.17
      },
      {
        "periodo": 202510,
        "valor": -494310591.56,
        "delta": 41590905.55
      },
      {
        "periodo": 202511,
        "valor": -524639990.38,
        "delta": -30329398.82
      },
      {
        "periodo": 202512,
        "valor": -291880707.01,
        "delta": 232759283.37
      },
      {
        "periodo": 202601,
        "valor": -140505495.49,
        "delta": 151375211.52
      },
      {
        "periodo": 202602,
        "valor": -245127205.69,
        "delta": -104621710.2
      },
      {
        "periodo": 202603,
        "valor": 481478203.37,
        "delta": 726605409.06
      },
      {
        "periodo": 202604,
        "valor": -587921859.8,
        "delta": -1069400063.17
      },
      {
        "periodo": 202605,
        "valor": -438844323.92,
        "delta": 149077535.88
      },
      {
        "periodo": 202606,
        "valor": -500638296.65,
        "delta": -61793972.73
      },
      {
        "periodo": 202607,
        "valor": -251172436.21,
        "delta": 249465860.44
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -16606617.0,
    "valor_anterior": -6454067.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -12234008.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -23067429.0,
        "delta": -10833421.0
      },
      {
        "periodo": 202509,
        "valor": -7255431.0,
        "delta": 15811998.0
      },
      {
        "periodo": 202510,
        "valor": -94369065.0,
        "delta": -87113634.0
      },
      {
        "periodo": 202511,
        "valor": -20704403.0,
        "delta": 73664662.0
      },
      {
        "periodo": 202512,
        "valor": -6830880.0,
        "delta": 13873523.0
      },
      {
        "periodo": 202601,
        "valor": 486093.0,
        "delta": 7316973.0
      },
      {
        "periodo": 202602,
        "valor": -3865862.0,
        "delta": -4351955.0
      },
      {
        "periodo": 202603,
        "valor": 14690902.0,
        "delta": 18556764.0
      },
      {
        "periodo": 202604,
        "valor": 5892822.0,
        "delta": -8798080.0
      },
      {
        "periodo": 202605,
        "valor": -6164296.0,
        "delta": -12057118.0
      },
      {
        "periodo": 202606,
        "valor": -6454067.0,
        "delta": -289771.0
      },
      {
        "periodo": 202607,
        "valor": -16606617.0,
        "delta": -10152550.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -8723912.0,
    "valor_anterior": -10333436.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -3853197.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -7682184.0,
        "delta": -3828987.0
      },
      {
        "periodo": 202509,
        "valor": -9827259.0,
        "delta": -2145075.0
      },
      {
        "periodo": 202510,
        "valor": -8626022.0,
        "delta": 1201237.0
      },
      {
        "periodo": 202511,
        "valor": -8782700.0,
        "delta": -156678.0
      },
      {
        "periodo": 202512,
        "valor": -4278198.0,
        "delta": 4504502.0
      },
      {
        "periodo": 202601,
        "valor": -8211828.0,
        "delta": -3933630.0
      },
      {
        "periodo": 202602,
        "valor": -4973965.0,
        "delta": 3237863.0
      },
      {
        "periodo": 202603,
        "valor": -45488787.0,
        "delta": -40514822.0
      },
      {
        "periodo": 202604,
        "valor": -9242859.0,
        "delta": 36245928.0
      },
      {
        "periodo": 202605,
        "valor": -6449373.0,
        "delta": 2793486.0
      },
      {
        "periodo": 202606,
        "valor": -10333436.0,
        "delta": -3884063.0
      },
      {
        "periodo": 202607,
        "valor": -8723912.0,
        "delta": 1609524.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -36471528.0,
    "valor_anterior": -44374071.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 333660.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -29724260.0,
        "delta": -30057920.0
      },
      {
        "periodo": 202509,
        "valor": -60736979.0,
        "delta": -31012719.0
      },
      {
        "periodo": 202510,
        "valor": -20550834.0,
        "delta": 40186145.0
      },
      {
        "periodo": 202511,
        "valor": -37742031.0,
        "delta": -17191197.0
      },
      {
        "periodo": 202512,
        "valor": -16922181.0,
        "delta": 20819850.0
      },
      {
        "periodo": 202601,
        "valor": 67549102.0,
        "delta": 84471283.0
      },
      {
        "periodo": 202602,
        "valor": -10766292.0,
        "delta": -78315394.0
      },
      {
        "periodo": 202603,
        "valor": -141627889.0,
        "delta": -130861597.0
      },
      {
        "periodo": 202604,
        "valor": 78317284.0,
        "delta": 219945173.0
      },
      {
        "periodo": 202605,
        "valor": -88888395.0,
        "delta": -167205679.0
      },
      {
        "periodo": 202606,
        "valor": -44374071.0,
        "delta": 44514324.0
      },
      {
        "periodo": 202607,
        "valor": -36471528.0,
        "delta": 7902543.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 3850895.4799999893,
    "valor_anterior": -14604227.64,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6521487.31,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -38302462.49,
        "delta": -44823949.8
      },
      {
        "periodo": 202509,
        "valor": -30491361.51,
        "delta": 7811100.98
      },
      {
        "periodo": 202510,
        "valor": 2760709.97,
        "delta": 33252071.48
      },
      {
        "periodo": 202511,
        "valor": 4494000.76,
        "delta": 1733290.79
      },
      {
        "periodo": 202512,
        "valor": 12181775.13,
        "delta": 7687774.37
      },
      {
        "periodo": 202601,
        "valor": -5568801.28,
        "delta": -17750576.41
      },
      {
        "periodo": 202602,
        "valor": -38344101.2,
        "delta": -32775299.92
      },
      {
        "periodo": 202603,
        "valor": -26323580.31,
        "delta": 12020520.89
      },
      {
        "periodo": 202604,
        "valor": -37116983.24,
        "delta": -10793402.93
      },
      {
        "periodo": 202605,
        "valor": -24845565.24,
        "delta": 12271418.0
      },
      {
        "periodo": 202606,
        "valor": -14604227.64,
        "delta": 10241337.6
      },
      {
        "periodo": 202607,
        "valor": 3850895.48,
        "delta": 18455123.12
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -27360059.0,
    "valor_anterior": -43650341.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -22655558.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -15349732.0,
        "delta": 7305826.0
      },
      {
        "periodo": 202509,
        "valor": -23176515.0,
        "delta": -7826783.0
      },
      {
        "periodo": 202510,
        "valor": -62876586.0,
        "delta": -39700071.0
      },
      {
        "periodo": 202511,
        "valor": -16817371.0,
        "delta": 46059215.0
      },
      {
        "periodo": 202512,
        "valor": 1922732.0,
        "delta": 18740103.0
      },
      {
        "periodo": 202601,
        "valor": -34238157.0,
        "delta": -36160889.0
      },
      {
        "periodo": 202602,
        "valor": -18921673.0,
        "delta": 15316484.0
      },
      {
        "periodo": 202603,
        "valor": 814524.0,
        "delta": 19736197.0
      },
      {
        "periodo": 202604,
        "valor": -21075972.0,
        "delta": -21890496.0
      },
      {
        "periodo": 202605,
        "valor": -22546401.0,
        "delta": -1470429.0
      },
      {
        "periodo": 202606,
        "valor": -43650341.0,
        "delta": -21103940.0
      },
      {
        "periodo": 202607,
        "valor": -27360059.0,
        "delta": 16290282.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 57810330.73000002,
    "valor_anterior": -40285395.97000003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 92217039.61,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -376984403.27,
        "delta": -469201442.88
      },
      {
        "periodo": 202509,
        "valor": 80215886.66,
        "delta": 457200289.93
      },
      {
        "periodo": 202510,
        "valor": -11548380.64,
        "delta": -91764267.3
      },
      {
        "periodo": 202511,
        "valor": -520567153.97,
        "delta": -509018773.33
      },
      {
        "periodo": 202512,
        "valor": -486387845.07,
        "delta": 34179308.9
      },
      {
        "periodo": 202601,
        "valor": -183263588.33,
        "delta": 303124256.74
      },
      {
        "periodo": 202602,
        "valor": -42153210.64,
        "delta": 141110377.69
      },
      {
        "periodo": 202603,
        "valor": -292263619.43,
        "delta": -250110408.79
      },
      {
        "periodo": 202604,
        "valor": -136765457.15,
        "delta": 155498162.28
      },
      {
        "periodo": 202605,
        "valor": -221543057.49,
        "delta": -84777600.34
      },
      {
        "periodo": 202606,
        "valor": -40285395.97,
        "delta": 181257661.52
      },
      {
        "periodo": 202607,
        "valor": 57810330.73,
        "delta": 98095726.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 6680010.0,
    "valor_anterior": -1352388.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 329114.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 45765.0,
        "delta": -283349.0
      },
      {
        "periodo": 202509,
        "valor": -323131.0,
        "delta": -368896.0
      },
      {
        "periodo": 202510,
        "valor": 13564780.0,
        "delta": 13887911.0
      },
      {
        "periodo": 202511,
        "valor": 2078621.0,
        "delta": -11486159.0
      },
      {
        "periodo": 202512,
        "valor": 1258764.0,
        "delta": -819857.0
      },
      {
        "periodo": 202601,
        "valor": 11817589.0,
        "delta": 10558825.0
      },
      {
        "periodo": 202602,
        "valor": 16949743.0,
        "delta": 5132154.0
      },
      {
        "periodo": 202603,
        "valor": 1739995.0,
        "delta": -15209748.0
      },
      {
        "periodo": 202604,
        "valor": 7338022.0,
        "delta": 5598027.0
      },
      {
        "periodo": 202605,
        "valor": -3890010.0,
        "delta": -11228032.0
      },
      {
        "periodo": 202606,
        "valor": -1352388.0,
        "delta": 2537622.0
      },
      {
        "periodo": 202607,
        "valor": 6680010.0,
        "delta": 8032398.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -166361181.43000007,
    "valor_anterior": -1647334997.17,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 92874979.49,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 261393711.62,
        "delta": 168518732.13
      },
      {
        "periodo": 202509,
        "valor": 731408147.49,
        "delta": 470014435.87
      },
      {
        "periodo": 202510,
        "valor": 780690423.8,
        "delta": 49282276.31
      },
      {
        "periodo": 202511,
        "valor": 324885686.15,
        "delta": -455804737.65
      },
      {
        "periodo": 202512,
        "valor": 331880538.8,
        "delta": 6994852.65
      },
      {
        "periodo": 202601,
        "valor": 678367901.52,
        "delta": 346487362.72
      },
      {
        "periodo": 202602,
        "valor": 322864372.02,
        "delta": -355503529.5
      },
      {
        "periodo": 202603,
        "valor": -684812677.02,
        "delta": -1007677049.04
      },
      {
        "periodo": 202604,
        "valor": -388986739.45,
        "delta": 295825937.57
      },
      {
        "periodo": 202605,
        "valor": -400373781.06,
        "delta": -11387041.61
      },
      {
        "periodo": 202606,
        "valor": -1647334997.17,
        "delta": -1246961216.11
      },
      {
        "periodo": 202607,
        "valor": -166361181.43,
        "delta": 1480973815.74
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -16872547.0,
    "valor_anterior": -146398130.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40755959.21,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 85187481.74,
        "delta": 44431522.53
      },
      {
        "periodo": 202509,
        "valor": -6921964.37,
        "delta": -92109446.11
      },
      {
        "periodo": 202510,
        "valor": -23865893.0,
        "delta": -16943928.63
      },
      {
        "periodo": 202511,
        "valor": -40944479.0,
        "delta": -17078586.0
      },
      {
        "periodo": 202512,
        "valor": -52800234.0,
        "delta": -11855755.0
      },
      {
        "periodo": 202601,
        "valor": 48668226.0,
        "delta": 101468460.0
      },
      {
        "periodo": 202602,
        "valor": -28681562.0,
        "delta": -77349788.0
      },
      {
        "periodo": 202603,
        "valor": -28001158.0,
        "delta": 680404.0
      },
      {
        "periodo": 202604,
        "valor": -23517397.0,
        "delta": 4483761.0
      },
      {
        "periodo": 202605,
        "valor": -68485753.0,
        "delta": -44968356.0
      },
      {
        "periodo": 202606,
        "valor": -146398130.0,
        "delta": -77912377.0
      },
      {
        "periodo": 202607,
        "valor": -16872547.0,
        "delta": 129525583.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 80996228.0,
    "valor_anterior": 74770994.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 339163100.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -122353042.0,
        "delta": -461516142.0
      },
      {
        "periodo": 202509,
        "valor": 70941203.0,
        "delta": 193294245.0
      },
      {
        "periodo": 202510,
        "valor": 70118310.0,
        "delta": -822893.0
      },
      {
        "periodo": 202511,
        "valor": 79575479.0,
        "delta": 9457169.0
      },
      {
        "periodo": 202512,
        "valor": -24583203.0,
        "delta": -104158682.0
      },
      {
        "periodo": 202601,
        "valor": 68033591.0,
        "delta": 92616794.0
      },
      {
        "periodo": 202602,
        "valor": 68595320.0,
        "delta": 561729.0
      },
      {
        "periodo": 202603,
        "valor": 80648726.0,
        "delta": 12053406.0
      },
      {
        "periodo": 202604,
        "valor": 52031448.0,
        "delta": -28617278.0
      },
      {
        "periodo": 202605,
        "valor": 52486611.0,
        "delta": 455163.0
      },
      {
        "periodo": 202606,
        "valor": 74770994.0,
        "delta": 22284383.0
      },
      {
        "periodo": 202607,
        "valor": 80996228.0,
        "delta": 6225234.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -45712509.0,
    "valor_anterior": -25256448.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -48610868.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 102190707.0,
        "delta": 150801575.0
      },
      {
        "periodo": 202509,
        "valor": -31094442.0,
        "delta": -133285149.0
      },
      {
        "periodo": 202510,
        "valor": -21368918.0,
        "delta": 9725524.0
      },
      {
        "periodo": 202511,
        "valor": -43518225.0,
        "delta": -22149307.0
      },
      {
        "periodo": 202512,
        "valor": -28341139.0,
        "delta": 15177086.0
      },
      {
        "periodo": 202601,
        "valor": -17264610.0,
        "delta": 11076529.0
      },
      {
        "periodo": 202602,
        "valor": -26350654.0,
        "delta": -9086044.0
      },
      {
        "periodo": 202603,
        "valor": -14069260.0,
        "delta": 12281394.0
      },
      {
        "periodo": 202604,
        "valor": -40010202.0,
        "delta": -25940942.0
      },
      {
        "periodo": 202605,
        "valor": -30523832.0,
        "delta": 9486370.0
      },
      {
        "periodo": 202606,
        "valor": -25256448.0,
        "delta": 5267384.0
      },
      {
        "periodo": 202607,
        "valor": -45712509.0,
        "delta": -20456061.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -18782949.0,
    "valor_anterior": -36178966.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -57183850.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -24399444.0,
        "delta": 32784406.0
      },
      {
        "periodo": 202509,
        "valor": -60758976.0,
        "delta": -36359532.0
      },
      {
        "periodo": 202510,
        "valor": -35311517.0,
        "delta": 25447459.0
      },
      {
        "periodo": 202511,
        "valor": -42049828.0,
        "delta": -6738311.0
      },
      {
        "periodo": 202512,
        "valor": -47264501.0,
        "delta": -5214673.0
      },
      {
        "periodo": 202601,
        "valor": -112783248.0,
        "delta": -65518747.0
      },
      {
        "periodo": 202602,
        "valor": -13201539.0,
        "delta": 99581709.0
      },
      {
        "periodo": 202603,
        "valor": -82892874.0,
        "delta": -69691335.0
      },
      {
        "periodo": 202604,
        "valor": -29627730.0,
        "delta": 53265144.0
      },
      {
        "periodo": 202605,
        "valor": -110549557.0,
        "delta": -80921827.0
      },
      {
        "periodo": 202606,
        "valor": -36178966.0,
        "delta": 74370591.0
      },
      {
        "periodo": 202607,
        "valor": -18782949.0,
        "delta": 17396017.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -26986700.0,
    "valor_anterior": 129408584.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 44083858.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 164075650.0,
        "delta": 119991792.0
      },
      {
        "periodo": 202509,
        "valor": 9501139.0,
        "delta": -154574511.0
      },
      {
        "periodo": 202510,
        "valor": 60663377.0,
        "delta": 51162238.0
      },
      {
        "periodo": 202511,
        "valor": 26480115.0,
        "delta": -34183262.0
      },
      {
        "periodo": 202512,
        "valor": -33311075.0,
        "delta": -59791190.0
      },
      {
        "periodo": 202601,
        "valor": -110217335.0,
        "delta": -76906260.0
      },
      {
        "periodo": 202602,
        "valor": 299608491.0,
        "delta": 409825826.0
      },
      {
        "periodo": 202603,
        "valor": 153467690.0,
        "delta": -146140801.0
      },
      {
        "periodo": 202604,
        "valor": -29756619.0,
        "delta": -183224309.0
      },
      {
        "periodo": 202605,
        "valor": 82980650.0,
        "delta": 112737269.0
      },
      {
        "periodo": 202606,
        "valor": 129408584.0,
        "delta": 46427934.0
      },
      {
        "periodo": 202607,
        "valor": -26986700.0,
        "delta": -156395284.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -9268380.0,
    "valor_anterior": -197954395.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -63250167.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 46879505.0,
        "delta": 110129672.0
      },
      {
        "periodo": 202509,
        "valor": 64223214.0,
        "delta": 17343709.0
      },
      {
        "periodo": 202510,
        "valor": 77749586.0,
        "delta": 13526372.0
      },
      {
        "periodo": 202511,
        "valor": 40214826.0,
        "delta": -37534760.0
      },
      {
        "periodo": 202512,
        "valor": -239429634.0,
        "delta": -279644460.0
      },
      {
        "periodo": 202601,
        "valor": 14826285.0,
        "delta": 254255919.0
      },
      {
        "periodo": 202602,
        "valor": 26551489.0,
        "delta": 11725204.0
      },
      {
        "periodo": 202603,
        "valor": -100668916.0,
        "delta": -127220405.0
      },
      {
        "periodo": 202604,
        "valor": -12082506.0,
        "delta": 88586410.0
      },
      {
        "periodo": 202605,
        "valor": 37341475.0,
        "delta": 49423981.0
      },
      {
        "periodo": 202606,
        "valor": -197954395.0,
        "delta": -235295870.0
      },
      {
        "periodo": 202607,
        "valor": -9268380.0,
        "delta": 188686015.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -52355516.54999995,
    "valor_anterior": -109602811.31,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -97840596.78,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -74979893.34,
        "delta": 22860703.44
      },
      {
        "periodo": 202509,
        "valor": -27779003.4,
        "delta": 47200889.94
      },
      {
        "periodo": 202510,
        "valor": -27281903.74,
        "delta": 497099.66
      },
      {
        "periodo": 202511,
        "valor": -38272509.13,
        "delta": -10990605.39
      },
      {
        "periodo": 202512,
        "valor": -61813364.97,
        "delta": -23540855.84
      },
      {
        "periodo": 202601,
        "valor": -36938171.2,
        "delta": 24875193.77
      },
      {
        "periodo": 202602,
        "valor": -97197170.71,
        "delta": -60258999.51
      },
      {
        "periodo": 202603,
        "valor": -85868045.16,
        "delta": 11329125.55
      },
      {
        "periodo": 202604,
        "valor": -126413982.33,
        "delta": -40545937.17
      },
      {
        "periodo": 202605,
        "valor": -115681664.27,
        "delta": 10732318.06
      },
      {
        "periodo": 202606,
        "valor": -109602811.31,
        "delta": 6078852.96
      },
      {
        "periodo": 202607,
        "valor": -52355516.55,
        "delta": 57247294.76
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -3055190.0,
    "valor_anterior": -28644685.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40403.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4862503.0,
        "delta": 4822100.0
      },
      {
        "periodo": 202509,
        "valor": 10133492.0,
        "delta": 5270989.0
      },
      {
        "periodo": 202510,
        "valor": -147240.0,
        "delta": -10280732.0
      },
      {
        "periodo": 202511,
        "valor": -4213929.0,
        "delta": -4066689.0
      },
      {
        "periodo": 202512,
        "valor": 5592149.0,
        "delta": 9806078.0
      },
      {
        "periodo": 202601,
        "valor": -8324342.0,
        "delta": -13916491.0
      },
      {
        "periodo": 202602,
        "valor": -4311050.0,
        "delta": 4013292.0
      },
      {
        "periodo": 202603,
        "valor": -5281916.0,
        "delta": -970866.0
      },
      {
        "periodo": 202604,
        "valor": -1860722.0,
        "delta": 3421194.0
      },
      {
        "periodo": 202605,
        "valor": -2022511.0,
        "delta": -161789.0
      },
      {
        "periodo": 202606,
        "valor": -28644685.0,
        "delta": -26622174.0
      },
      {
        "periodo": 202607,
        "valor": -3055190.0,
        "delta": 25589495.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -174429.0,
    "valor_anterior": -176143.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -164597.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -181239.0,
        "delta": -16642.0
      },
      {
        "periodo": 202509,
        "valor": -181092.0,
        "delta": 147.0
      },
      {
        "periodo": 202510,
        "valor": -182510.0,
        "delta": -1418.0
      },
      {
        "periodo": 202511,
        "valor": -181135.0,
        "delta": 1375.0
      },
      {
        "periodo": 202512,
        "valor": -180529.0,
        "delta": 606.0
      },
      {
        "periodo": 202601,
        "valor": -181494.0,
        "delta": -965.0
      },
      {
        "periodo": 202602,
        "valor": 2470161.0,
        "delta": 2651655.0
      },
      {
        "periodo": 202603,
        "valor": -184009.0,
        "delta": -2654170.0
      },
      {
        "periodo": 202604,
        "valor": -180552.0,
        "delta": 3457.0
      },
      {
        "periodo": 202605,
        "valor": -180613.0,
        "delta": -61.0
      },
      {
        "periodo": 202606,
        "valor": -176143.0,
        "delta": 4470.0
      },
      {
        "periodo": 202607,
        "valor": -174429.0,
        "delta": 1714.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -65189677.0,
    "valor_anterior": -75580610.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -24855265.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -40292741.0,
        "delta": -15437476.0
      },
      {
        "periodo": 202509,
        "valor": -67221660.0,
        "delta": -26928919.0
      },
      {
        "periodo": 202510,
        "valor": -74315576.0,
        "delta": -7093916.0
      },
      {
        "periodo": 202511,
        "valor": -67940557.0,
        "delta": 6375019.0
      },
      {
        "periodo": 202512,
        "valor": -39464124.0,
        "delta": 28476433.0
      },
      {
        "periodo": 202601,
        "valor": -42059111.0,
        "delta": -2594987.0
      },
      {
        "periodo": 202602,
        "valor": -11424776.0,
        "delta": 30634335.0
      },
      {
        "periodo": 202603,
        "valor": -84599901.0,
        "delta": -73175125.0
      },
      {
        "periodo": 202604,
        "valor": -10676752.0,
        "delta": 73923149.0
      },
      {
        "periodo": 202605,
        "valor": -81450182.0,
        "delta": -70773430.0
      },
      {
        "periodo": 202606,
        "valor": -75580610.0,
        "delta": 5869572.0
      },
      {
        "periodo": 202607,
        "valor": -65189677.0,
        "delta": 10390933.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 14259917.0,
    "valor_anterior": 13025572.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2584843.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1196566.0,
        "delta": -1388277.0
      },
      {
        "periodo": 202509,
        "valor": 2738179.0,
        "delta": 1541613.0
      },
      {
        "periodo": 202510,
        "valor": -27970661.0,
        "delta": -30708840.0
      },
      {
        "periodo": 202511,
        "valor": 712900.0,
        "delta": 28683561.0
      },
      {
        "periodo": 202512,
        "valor": 124632128.0,
        "delta": 123919228.0
      },
      {
        "periodo": 202601,
        "valor": 17564343.0,
        "delta": -107067785.0
      },
      {
        "periodo": 202602,
        "valor": 21488184.0,
        "delta": 3923841.0
      },
      {
        "periodo": 202603,
        "valor": 16411265.0,
        "delta": -5076919.0
      },
      {
        "periodo": 202604,
        "valor": 15150725.0,
        "delta": -1260540.0
      },
      {
        "periodo": 202605,
        "valor": 14201214.0,
        "delta": -949511.0
      },
      {
        "periodo": 202606,
        "valor": 13025572.0,
        "delta": -1175642.0
      },
      {
        "periodo": 202607,
        "valor": 14259917.0,
        "delta": 1234345.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26174668.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -939551930.0,
        "delta": -965726598.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 3218590.0,
    "valor_anterior": -10527442.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -16408932.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -11293261.0,
        "delta": 5115671.0
      },
      {
        "periodo": 202509,
        "valor": -34769853.0,
        "delta": -23476592.0
      },
      {
        "periodo": 202510,
        "valor": -7303755.0,
        "delta": 27466098.0
      },
      {
        "periodo": 202511,
        "valor": -37632850.0,
        "delta": -30329095.0
      },
      {
        "periodo": 202512,
        "valor": 26457669.0,
        "delta": 64090519.0
      },
      {
        "periodo": 202601,
        "valor": -70206968.0,
        "delta": -96664637.0
      },
      {
        "periodo": 202602,
        "valor": -37862035.0,
        "delta": 32344933.0
      },
      {
        "periodo": 202603,
        "valor": 35993190.0,
        "delta": 73855225.0
      },
      {
        "periodo": 202604,
        "valor": -13174815.0,
        "delta": -49168005.0
      },
      {
        "periodo": 202605,
        "valor": -30123590.0,
        "delta": -16948775.0
      },
      {
        "periodo": 202606,
        "valor": -10527442.0,
        "delta": 19596148.0
      },
      {
        "periodo": 202607,
        "valor": 3218590.0,
        "delta": 13746032.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -19938588.0,
    "valor_anterior": 232489955.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 85145117.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 150663756.0,
        "delta": 65518639.0
      },
      {
        "periodo": 202509,
        "valor": 181602902.0,
        "delta": 30939146.0
      },
      {
        "periodo": 202510,
        "valor": 81746213.0,
        "delta": -99856689.0
      },
      {
        "periodo": 202511,
        "valor": 76182526.0,
        "delta": -5563687.0
      },
      {
        "periodo": 202512,
        "valor": 210252360.0,
        "delta": 134069834.0
      },
      {
        "periodo": 202601,
        "valor": 60298225.0,
        "delta": -149954135.0
      },
      {
        "periodo": 202602,
        "valor": 115523226.0,
        "delta": 55225001.0
      },
      {
        "periodo": 202603,
        "valor": 98615888.0,
        "delta": -16907338.0
      },
      {
        "periodo": 202604,
        "valor": -10733064.0,
        "delta": -109348952.0
      },
      {
        "periodo": 202605,
        "valor": 58906648.0,
        "delta": 69639712.0
      },
      {
        "periodo": 202606,
        "valor": 232489955.0,
        "delta": 173583307.0
      },
      {
        "periodo": 202607,
        "valor": -19938588.0,
        "delta": -252428543.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 3520739.0,
    "valor_anterior": 2020732.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1737860.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1522452.0,
        "delta": -215408.0
      },
      {
        "periodo": 202509,
        "valor": 1436934.0,
        "delta": -85518.0
      },
      {
        "periodo": 202510,
        "valor": 2640225.0,
        "delta": 1203291.0
      },
      {
        "periodo": 202511,
        "valor": 11013605.0,
        "delta": 8373380.0
      },
      {
        "periodo": 202512,
        "valor": 14107925.0,
        "delta": 3094320.0
      },
      {
        "periodo": 202601,
        "valor": 1281546.0,
        "delta": -12826379.0
      },
      {
        "periodo": 202602,
        "valor": 3783048.0,
        "delta": 2501502.0
      },
      {
        "periodo": 202603,
        "valor": 10252326.0,
        "delta": 6469278.0
      },
      {
        "periodo": 202604,
        "valor": 1630440.0,
        "delta": -8621886.0
      },
      {
        "periodo": 202605,
        "valor": 5700215.0,
        "delta": 4069775.0
      },
      {
        "periodo": 202606,
        "valor": 2020732.0,
        "delta": -3679483.0
      },
      {
        "periodo": 202607,
        "valor": 3520739.0,
        "delta": 1500007.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 1555225.0,
    "valor_anterior": -226162.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -551608.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -589018.0,
        "delta": -37410.0
      },
      {
        "periodo": 202509,
        "valor": -633883.0,
        "delta": -44865.0
      },
      {
        "periodo": 202510,
        "valor": -601718.0,
        "delta": 32165.0
      },
      {
        "periodo": 202511,
        "valor": -629406.0,
        "delta": -27688.0
      },
      {
        "periodo": 202512,
        "valor": -620248.0,
        "delta": 9158.0
      },
      {
        "periodo": 202601,
        "valor": -158899.0,
        "delta": 461349.0
      },
      {
        "periodo": 202602,
        "valor": 105442.0,
        "delta": 264341.0
      },
      {
        "periodo": 202603,
        "valor": -7492.0,
        "delta": -112934.0
      },
      {
        "periodo": 202604,
        "valor": 138574.0,
        "delta": 146066.0
      },
      {
        "periodo": 202605,
        "valor": -217398.0,
        "delta": -355972.0
      },
      {
        "periodo": 202606,
        "valor": -226162.0,
        "delta": -8764.0
      },
      {
        "periodo": 202607,
        "valor": 1555225.0,
        "delta": 1781387.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -10900988.849999998,
    "valor_anterior": -3959434.9499999993,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4559576.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 377399.2,
        "delta": -4182177.73
      },
      {
        "periodo": 202509,
        "valor": -3869483.55,
        "delta": -4246882.75
      },
      {
        "periodo": 202510,
        "valor": 9376167.57,
        "delta": 13245651.12
      },
      {
        "periodo": 202511,
        "valor": -363075.36,
        "delta": -9739242.93
      },
      {
        "periodo": 202512,
        "valor": 1218076.76,
        "delta": 1581152.12
      },
      {
        "periodo": 202601,
        "valor": 675756.88,
        "delta": -542319.88
      },
      {
        "periodo": 202602,
        "valor": 1751650.95,
        "delta": 1075894.07
      },
      {
        "periodo": 202603,
        "valor": -22186821.41,
        "delta": -23938472.36
      },
      {
        "periodo": 202604,
        "valor": 1798865.21,
        "delta": 23985686.62
      },
      {
        "periodo": 202605,
        "valor": -4531313.45,
        "delta": -6330178.66
      },
      {
        "periodo": 202606,
        "valor": -3959434.95,
        "delta": 571878.5
      },
      {
        "periodo": 202607,
        "valor": -10900988.85,
        "delta": -6941553.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 2524803.0,
    "valor_anterior": 1679027.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -571313.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -34244.0,
        "delta": 537069.0
      },
      {
        "periodo": 202509,
        "valor": -148405.0,
        "delta": -114161.0
      },
      {
        "periodo": 202510,
        "valor": 475350.0,
        "delta": 623755.0
      },
      {
        "periodo": 202511,
        "valor": -467796.0,
        "delta": -943146.0
      },
      {
        "periodo": 202512,
        "valor": -724503.0,
        "delta": -256707.0
      },
      {
        "periodo": 202601,
        "valor": -1658277.0,
        "delta": -933774.0
      },
      {
        "periodo": 202602,
        "valor": -366029.0,
        "delta": 1292248.0
      },
      {
        "periodo": 202603,
        "valor": -244180.0,
        "delta": 121849.0
      },
      {
        "periodo": 202604,
        "valor": -615225.0,
        "delta": -371045.0
      },
      {
        "periodo": 202605,
        "valor": -820154.0,
        "delta": -204929.0
      },
      {
        "periodo": 202606,
        "valor": 1679027.0,
        "delta": 2499181.0
      },
      {
        "periodo": 202607,
        "valor": 2524803.0,
        "delta": 845776.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 915049.9000000004,
    "valor_anterior": 8650251.500000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4362318.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1616267.96,
        "delta": -5978586.23
      },
      {
        "periodo": 202509,
        "valor": 38672225.97,
        "delta": 40288493.93
      },
      {
        "periodo": 202510,
        "valor": 75355562.6,
        "delta": 36683336.63
      },
      {
        "periodo": 202511,
        "valor": -7906206.31,
        "delta": -83261768.91
      },
      {
        "periodo": 202512,
        "valor": 15117551.08,
        "delta": 23023757.39
      },
      {
        "periodo": 202601,
        "valor": -9191712.39,
        "delta": -24309263.47
      },
      {
        "periodo": 202602,
        "valor": -23877560.19,
        "delta": -14685847.8
      },
      {
        "periodo": 202603,
        "valor": -187666.69,
        "delta": 23689893.5
      },
      {
        "periodo": 202604,
        "valor": 9828144.7,
        "delta": 10015811.39
      },
      {
        "periodo": 202605,
        "valor": 1018980.38,
        "delta": -8809164.32
      },
      {
        "periodo": 202606,
        "valor": 8650251.5,
        "delta": 7631271.12
      },
      {
        "periodo": 202607,
        "valor": 915049.9,
        "delta": -7735201.6
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 5129717.440000001,
    "valor_anterior": 12016981.52,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7183080.75,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3514144.45,
        "delta": -3668936.3
      },
      {
        "periodo": 202509,
        "valor": 5198753.35,
        "delta": 1684608.9
      },
      {
        "periodo": 202510,
        "valor": 7695867.43,
        "delta": 2497114.08
      },
      {
        "periodo": 202511,
        "valor": -4091478.0,
        "delta": -11787345.43
      },
      {
        "periodo": 202512,
        "valor": 5647826.0,
        "delta": 9739304.0
      },
      {
        "periodo": 202601,
        "valor": 1067927.56,
        "delta": -4579898.44
      },
      {
        "periodo": 202602,
        "valor": 5697354.77,
        "delta": 4629427.21
      },
      {
        "periodo": 202603,
        "valor": 4706336.17,
        "delta": -991018.6
      },
      {
        "periodo": 202604,
        "valor": -6144659.59,
        "delta": -10850995.76
      },
      {
        "periodo": 202605,
        "valor": 5574731.73,
        "delta": 11719391.32
      },
      {
        "periodo": 202606,
        "valor": 12016981.52,
        "delta": 6442249.79
      },
      {
        "periodo": 202607,
        "valor": 5129717.44,
        "delta": -6887264.08
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -9239310.0,
    "valor_anterior": -2480695.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1009489.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -7517432.0,
        "delta": -6507943.0
      },
      {
        "periodo": 202509,
        "valor": -11580615.0,
        "delta": -4063183.0
      },
      {
        "periodo": 202510,
        "valor": 2919349.0,
        "delta": 14499964.0
      },
      {
        "periodo": 202511,
        "valor": -11198852.0,
        "delta": -14118201.0
      },
      {
        "periodo": 202512,
        "valor": -11256654.0,
        "delta": -57802.0
      },
      {
        "periodo": 202601,
        "valor": -20144826.0,
        "delta": -8888172.0
      },
      {
        "periodo": 202602,
        "valor": -9196065.0,
        "delta": 10948761.0
      },
      {
        "periodo": 202603,
        "valor": 14768471.0,
        "delta": 23964536.0
      },
      {
        "periodo": 202604,
        "valor": -16279729.0,
        "delta": -31048200.0
      },
      {
        "periodo": 202605,
        "valor": -3389793.0,
        "delta": 12889936.0
      },
      {
        "periodo": 202606,
        "valor": -2480695.0,
        "delta": 909098.0
      },
      {
        "periodo": 202607,
        "valor": -9239310.0,
        "delta": -6758615.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -41197600.0,
    "valor_anterior": -43973184.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -119681109.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -43608705.0,
        "delta": 76072404.0
      },
      {
        "periodo": 202509,
        "valor": -35212789.0,
        "delta": 8395916.0
      },
      {
        "periodo": 202510,
        "valor": -62679492.0,
        "delta": -27466703.0
      },
      {
        "periodo": 202511,
        "valor": -48456907.0,
        "delta": 14222585.0
      },
      {
        "periodo": 202512,
        "valor": -44106471.0,
        "delta": 4350436.0
      },
      {
        "periodo": 202601,
        "valor": -34358417.0,
        "delta": 9748054.0
      },
      {
        "periodo": 202602,
        "valor": -22463621.0,
        "delta": 11894796.0
      },
      {
        "periodo": 202603,
        "valor": -48151962.0,
        "delta": -25688341.0
      },
      {
        "periodo": 202604,
        "valor": -37300142.0,
        "delta": 10851820.0
      },
      {
        "periodo": 202605,
        "valor": -40369609.0,
        "delta": -3069467.0
      },
      {
        "periodo": 202606,
        "valor": -43973184.0,
        "delta": -3603575.0
      },
      {
        "periodo": 202607,
        "valor": -41197600.0,
        "delta": 2775584.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 9118115.0,
    "valor_anterior": -4893840.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -5504414.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1332710.0,
        "delta": 6837124.0
      },
      {
        "periodo": 202509,
        "valor": 3136689.0,
        "delta": 1803979.0
      },
      {
        "periodo": 202510,
        "valor": -6270992.0,
        "delta": -9407681.0
      },
      {
        "periodo": 202511,
        "valor": 4026063.0,
        "delta": 10297055.0
      },
      {
        "periodo": 202512,
        "valor": 3676844.0,
        "delta": -349219.0
      },
      {
        "periodo": 202601,
        "valor": 11483685.0,
        "delta": 7806841.0
      },
      {
        "periodo": 202602,
        "valor": 4062438.0,
        "delta": -7421247.0
      },
      {
        "periodo": 202603,
        "valor": -9210742.0,
        "delta": -13273180.0
      },
      {
        "periodo": 202604,
        "valor": 3789158.0,
        "delta": 12999900.0
      },
      {
        "periodo": 202605,
        "valor": 898205.0,
        "delta": -2890953.0
      },
      {
        "periodo": 202606,
        "valor": -4893840.0,
        "delta": -5792045.0
      },
      {
        "periodo": 202607,
        "valor": 9118115.0,
        "delta": 14011955.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -2645164.9400000013,
    "valor_anterior": -2910964.1899999995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -3214792.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -3591629.69,
        "delta": -376836.82
      },
      {
        "periodo": 202509,
        "valor": -3906556.92,
        "delta": -314927.23
      },
      {
        "periodo": 202510,
        "valor": -3340008.71,
        "delta": 566548.21
      },
      {
        "periodo": 202511,
        "valor": -3105850.19,
        "delta": 234158.52
      },
      {
        "periodo": 202512,
        "valor": -2801042.15,
        "delta": 304808.04
      },
      {
        "periodo": 202601,
        "valor": -2878470.52,
        "delta": -77428.37
      },
      {
        "periodo": 202602,
        "valor": -2919740.64,
        "delta": -41270.12
      },
      {
        "periodo": 202603,
        "valor": 4512244.47,
        "delta": 7431985.11
      },
      {
        "periodo": 202604,
        "valor": -2893066.57,
        "delta": -7405311.04
      },
      {
        "periodo": 202605,
        "valor": -3591759.59,
        "delta": -698693.02
      },
      {
        "periodo": 202606,
        "valor": -2910964.19,
        "delta": 680795.4
      },
      {
        "periodo": 202607,
        "valor": -2645164.94,
        "delta": 265799.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 622834.1399999997,
    "valor_anterior": 1108092.38,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2683469.58,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3088376.74,
        "delta": 5771846.32
      },
      {
        "periodo": 202509,
        "valor": 371324.4,
        "delta": -2717052.34
      },
      {
        "periodo": 202510,
        "valor": -1051940.86,
        "delta": -1423265.26
      },
      {
        "periodo": 202511,
        "valor": -1344106.07,
        "delta": -292165.21
      },
      {
        "periodo": 202512,
        "valor": 4544834.53,
        "delta": 5888940.6
      },
      {
        "periodo": 202601,
        "valor": 3786421.69,
        "delta": -758412.84
      },
      {
        "periodo": 202602,
        "valor": -9300823.13,
        "delta": -13087244.82
      },
      {
        "periodo": 202603,
        "valor": 1826292.18,
        "delta": 11127115.31
      },
      {
        "periodo": 202604,
        "valor": 2380998.63,
        "delta": 554706.45
      },
      {
        "periodo": 202605,
        "valor": -4855024.63,
        "delta": -7236023.26
      },
      {
        "periodo": 202606,
        "valor": 1108092.38,
        "delta": 5963117.01
      },
      {
        "periodo": 202607,
        "valor": 622834.14,
        "delta": -485258.24
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 5119689.0,
    "valor_anterior": 5306673.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5670631.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3970168.0,
        "delta": -1700463.0
      },
      {
        "periodo": 202509,
        "valor": 2873482.0,
        "delta": -1096686.0
      },
      {
        "periodo": 202510,
        "valor": 3715579.0,
        "delta": 842097.0
      },
      {
        "periodo": 202511,
        "valor": 10387169.0,
        "delta": 6671590.0
      },
      {
        "periodo": 202512,
        "valor": -1828931.0,
        "delta": -12216100.0
      },
      {
        "periodo": 202601,
        "valor": 3721432.0,
        "delta": 5550363.0
      },
      {
        "periodo": 202602,
        "valor": 2267504.0,
        "delta": -1453928.0
      },
      {
        "periodo": 202603,
        "valor": 4847075.0,
        "delta": 2579571.0
      },
      {
        "periodo": 202604,
        "valor": 4413215.0,
        "delta": -433860.0
      },
      {
        "periodo": 202605,
        "valor": 3704176.0,
        "delta": -709039.0
      },
      {
        "periodo": 202606,
        "valor": 5306673.0,
        "delta": 1602497.0
      },
      {
        "periodo": 202607,
        "valor": 5119689.0,
        "delta": -186984.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -1296984.0,
    "valor_anterior": -1172855.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1263916.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1279071.0,
        "delta": -15155.0
      },
      {
        "periodo": 202509,
        "valor": -959002.0,
        "delta": 320069.0
      },
      {
        "periodo": 202510,
        "valor": -947218.0,
        "delta": 11784.0
      },
      {
        "periodo": 202511,
        "valor": -1237951.0,
        "delta": -290733.0
      },
      {
        "periodo": 202512,
        "valor": -1214861.0,
        "delta": 23090.0
      },
      {
        "periodo": 202601,
        "valor": -1327498.0,
        "delta": -112637.0
      },
      {
        "periodo": 202602,
        "valor": -1123558.0,
        "delta": 203940.0
      },
      {
        "periodo": 202603,
        "valor": -1584260.0,
        "delta": -460702.0
      },
      {
        "periodo": 202604,
        "valor": -1279103.0,
        "delta": 305157.0
      },
      {
        "periodo": 202605,
        "valor": -1057896.0,
        "delta": 221207.0
      },
      {
        "periodo": 202606,
        "valor": -1172855.0,
        "delta": -114959.0
      },
      {
        "periodo": 202607,
        "valor": -1296984.0,
        "delta": -124129.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -83146.0,
    "valor_anterior": -127937.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -34623.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 152122.0,
        "delta": 186745.0
      },
      {
        "periodo": 202509,
        "valor": -103340.0,
        "delta": -255462.0
      },
      {
        "periodo": 202510,
        "valor": -61353.0,
        "delta": 41987.0
      },
      {
        "periodo": 202511,
        "valor": -4741.0,
        "delta": 56612.0
      },
      {
        "periodo": 202512,
        "valor": 4581.0,
        "delta": 9322.0
      },
      {
        "periodo": 202601,
        "valor": -8.0,
        "delta": -4589.0
      },
      {
        "periodo": 202602,
        "valor": -264371.0,
        "delta": -264363.0
      },
      {
        "periodo": 202603,
        "valor": -141799.0,
        "delta": 122572.0
      },
      {
        "periodo": 202604,
        "valor": -109152.0,
        "delta": 32647.0
      },
      {
        "periodo": 202605,
        "valor": -125124.0,
        "delta": -15972.0
      },
      {
        "periodo": 202606,
        "valor": -127937.0,
        "delta": -2813.0
      },
      {
        "periodo": 202607,
        "valor": -83146.0,
        "delta": 44791.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 18346.97000000067,
    "valor_anterior": 1671298.5899999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -39264.88,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 885.73,
        "delta": 40150.61
      },
      {
        "periodo": 202509,
        "valor": 938572.56,
        "delta": 937686.83
      },
      {
        "periodo": 202510,
        "valor": 114306.88,
        "delta": -824265.68
      },
      {
        "periodo": 202511,
        "valor": 81000.77,
        "delta": -33306.11
      },
      {
        "periodo": 202512,
        "valor": 342.25,
        "delta": -80658.52
      },
      {
        "periodo": 202601,
        "valor": 3340378.31,
        "delta": 3340036.06
      },
      {
        "periodo": 202602,
        "valor": 50521.17,
        "delta": -3289857.14
      },
      {
        "periodo": 202603,
        "valor": 170205.51,
        "delta": 119684.34
      },
      {
        "periodo": 202604,
        "valor": 71134.7,
        "delta": -99070.81
      },
      {
        "periodo": 202605,
        "valor": 73844.82,
        "delta": 2710.12
      },
      {
        "periodo": 202606,
        "valor": 1671298.59,
        "delta": 1597453.77
      },
      {
        "periodo": 202607,
        "valor": 18346.97,
        "delta": -1652951.62
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 10090059.379999995,
    "valor_anterior": 3797211.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2723735.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15341.57,
        "delta": 2739076.96
      },
      {
        "periodo": 202509,
        "valor": 15077.47,
        "delta": -264.1
      },
      {
        "periodo": 202510,
        "valor": 13792.38,
        "delta": -1285.09
      },
      {
        "periodo": 202511,
        "valor": 8856.58,
        "delta": -4935.8
      },
      {
        "periodo": 202512,
        "valor": -1908641.35,
        "delta": -1917497.93
      },
      {
        "periodo": 202601,
        "valor": 8010.6,
        "delta": 1916651.95
      },
      {
        "periodo": 202602,
        "valor": 25222783.31,
        "delta": 25214772.71
      },
      {
        "periodo": 202603,
        "valor": 196232.45,
        "delta": -25026550.86
      },
      {
        "periodo": 202604,
        "valor": -1116367.1,
        "delta": -1312599.55
      },
      {
        "periodo": 202605,
        "valor": 31670694.74,
        "delta": 32787061.84
      },
      {
        "periodo": 202606,
        "valor": 3797211.0,
        "delta": -27873483.74
      },
      {
        "periodo": 202607,
        "valor": 10090059.38,
        "delta": 6292848.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -20712791.0,
    "valor_anterior": -8361404.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1387879.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1896430.0,
        "delta": -3284309.0
      },
      {
        "periodo": 202509,
        "valor": -2375843.0,
        "delta": -479413.0
      },
      {
        "periodo": 202510,
        "valor": -4890929.0,
        "delta": -2515086.0
      },
      {
        "periodo": 202511,
        "valor": -3797456.0,
        "delta": 1093473.0
      },
      {
        "periodo": 202512,
        "valor": -5918787.0,
        "delta": -2121331.0
      },
      {
        "periodo": 202601,
        "valor": -6238006.0,
        "delta": -319219.0
      },
      {
        "periodo": 202602,
        "valor": -9623508.0,
        "delta": -3385502.0
      },
      {
        "periodo": 202603,
        "valor": -8233769.0,
        "delta": 1389739.0
      },
      {
        "periodo": 202604,
        "valor": -7582358.0,
        "delta": 651411.0
      },
      {
        "periodo": 202605,
        "valor": -7289270.0,
        "delta": 293088.0
      },
      {
        "periodo": 202606,
        "valor": -8361404.0,
        "delta": -1072134.0
      },
      {
        "periodo": 202607,
        "valor": -20712791.0,
        "delta": -12351387.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -2855576.9099999997,
    "valor_anterior": 107211.6000000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": -2768163.74,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": -115932.26,
        "delta": 2652231.48
      },
      {
        "periodo": 202601,
        "valor": -128189.48,
        "delta": -12257.22
      },
      {
        "periodo": 202602,
        "valor": -236025.63,
        "delta": -107836.15
      },
      {
        "periodo": 202603,
        "valor": -1690671.92,
        "delta": -1454646.29
      },
      {
        "periodo": 202604,
        "valor": 75554.49,
        "delta": 1766226.41
      },
      {
        "periodo": 202605,
        "valor": -1088016.46,
        "delta": -1163570.95
      },
      {
        "periodo": 202606,
        "valor": 107211.6,
        "delta": 1195228.06
      },
      {
        "periodo": 202607,
        "valor": -2855576.91,
        "delta": -2962788.51
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -4377613.0,
    "valor_anterior": -10064655.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 36768802.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 645671.0,
        "delta": -36123131.0
      },
      {
        "periodo": 202605,
        "valor": -2258710.0,
        "delta": -2904381.0
      },
      {
        "periodo": 202606,
        "valor": -10064655.0,
        "delta": -7805945.0
      },
      {
        "periodo": 202607,
        "valor": -4377613.0,
        "delta": 5687042.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -2022590405.4399996,
    "valor_anterior": -4705919797.31,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1243322281.78,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2717343251.22,
        "delta": -1474020969.44
      },
      {
        "periodo": 202509,
        "valor": -1359697776.47,
        "delta": 1357645474.75
      },
      {
        "periodo": 202510,
        "valor": -1837339570.37,
        "delta": -477641793.9
      },
      {
        "periodo": 202511,
        "valor": -2281828605.04,
        "delta": -444489034.67
      },
      {
        "periodo": 202512,
        "valor": -1804582649.91,
        "delta": 477245955.13
      },
      {
        "periodo": 202601,
        "valor": -704529665.83,
        "delta": 1100052984.08
      },
      {
        "periodo": 202602,
        "valor": -1136190660.69,
        "delta": -431660994.86
      },
      {
        "periodo": 202603,
        "valor": 7708357026.85,
        "delta": 8844547687.54
      },
      {
        "periodo": 202604,
        "valor": -3140050183.89,
        "delta": -10848407210.74
      },
      {
        "periodo": 202605,
        "valor": -2749255280.94,
        "delta": 390794902.95
      },
      {
        "periodo": 202606,
        "valor": -4705919797.31,
        "delta": -1956664516.37
      },
      {
        "periodo": 202607,
        "valor": -2022590405.44,
        "delta": 2683329391.87
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -1645015817.8,
    "valor_anterior": -2644265251.74,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1682660433.71,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1977184226.23,
        "delta": -294523792.52
      },
      {
        "periodo": 202509,
        "valor": -2900047763.0,
        "delta": -922863536.77
      },
      {
        "periodo": 202510,
        "valor": -2479103225.13,
        "delta": 420944537.87
      },
      {
        "periodo": 202511,
        "valor": -1906610781.23,
        "delta": 572492443.9
      },
      {
        "periodo": 202512,
        "valor": -914786415.0,
        "delta": 991824366.23
      },
      {
        "periodo": 202601,
        "valor": -1033755118.97,
        "delta": -118968703.97
      },
      {
        "periodo": 202602,
        "valor": -1581254090.61,
        "delta": -547498971.64
      },
      {
        "periodo": 202603,
        "valor": 8889170226.88,
        "delta": 10470424317.49
      },
      {
        "periodo": 202604,
        "valor": -2379882189.47,
        "delta": -11269052416.35
      },
      {
        "periodo": 202605,
        "valor": -1752632168.12,
        "delta": 627250021.35
      },
      {
        "periodo": 202606,
        "valor": -2644265251.74,
        "delta": -891633083.62
      },
      {
        "periodo": 202607,
        "valor": -1645015817.8,
        "delta": 999249433.94
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -2198894.519999981,
    "valor_anterior": -223086064.64000005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -46962943.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -942268148.49,
        "delta": -895305204.8
      },
      {
        "periodo": 202509,
        "valor": 402096325.49,
        "delta": 1344364473.98
      },
      {
        "periodo": 202510,
        "valor": 73206540.97,
        "delta": -328889784.52
      },
      {
        "periodo": 202511,
        "valor": 7075976.76,
        "delta": -66130564.21
      },
      {
        "periodo": 202512,
        "valor": -200790189.87,
        "delta": -207866166.63
      },
      {
        "periodo": 202601,
        "valor": -60949484.28,
        "delta": 139840705.59
      },
      {
        "periodo": 202602,
        "valor": -49654647.2,
        "delta": 11294837.08
      },
      {
        "periodo": 202603,
        "valor": -90999306.31,
        "delta": -41344659.11
      },
      {
        "periodo": 202604,
        "valor": -62374304.24,
        "delta": 28625002.07
      },
      {
        "periodo": 202605,
        "valor": -17627680.24,
        "delta": 44746624.0
      },
      {
        "periodo": 202606,
        "valor": -223086064.64,
        "delta": -205458384.4
      },
      {
        "periodo": 202607,
        "valor": -2198894.52,
        "delta": 220887170.12
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": 104786782.73000002,
    "valor_anterior": -89675249.96999997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 440780496.61,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -547271560.27,
        "delta": -988052056.88
      },
      {
        "periodo": 202509,
        "valor": 105515822.66,
        "delta": 652787382.93
      },
      {
        "periodo": 202510,
        "valor": -37178729.64,
        "delta": -142694552.3
      },
      {
        "periodo": 202511,
        "valor": -478586373.97,
        "delta": -441407644.33
      },
      {
        "periodo": 202512,
        "valor": -636017471.07,
        "delta": -157431097.1
      },
      {
        "periodo": 202601,
        "valor": -37278717.33,
        "delta": 598738753.74
      },
      {
        "periodo": 202602,
        "valor": 42110023.36,
        "delta": 79388740.69
      },
      {
        "periodo": 202603,
        "valor": -322696145.43,
        "delta": -364806168.79
      },
      {
        "periodo": 202604,
        "valor": 18539191.85,
        "delta": 341235337.28
      },
      {
        "periodo": 202605,
        "valor": -228301041.49,
        "delta": -246840233.34
      },
      {
        "periodo": 202606,
        "valor": -89675249.97,
        "delta": 138625791.52
      },
      {
        "periodo": 202607,
        "valor": 104786782.73,
        "delta": 194462032.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -74612953.0,
    "valor_anterior": -84613823.93000007,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -58117091.14,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 114659123.71,
        "delta": 172776214.85
      },
      {
        "periodo": 202509,
        "valor": 214129022.38,
        "delta": 99469898.67
      },
      {
        "periodo": 202510,
        "valor": -212766571.92,
        "delta": -426895594.3
      },
      {
        "periodo": 202511,
        "valor": -96399012.3,
        "delta": 116367559.62
      },
      {
        "periodo": 202512,
        "valor": -505714645.66,
        "delta": -409315633.36
      },
      {
        "periodo": 202601,
        "valor": -139268958.22,
        "delta": 366445687.44
      },
      {
        "periodo": 202602,
        "valor": -117682180.16,
        "delta": 21586778.06
      },
      {
        "periodo": 202603,
        "valor": -150946090.87,
        "delta": -33263910.71
      },
      {
        "periodo": 202604,
        "valor": -96399502.72,
        "delta": 54546588.15
      },
      {
        "periodo": 202605,
        "valor": -218974970.3,
        "delta": -122575467.58
      },
      {
        "periodo": 202606,
        "valor": -84613823.93,
        "delta": 134361146.37
      },
      {
        "periodo": 202607,
        "valor": -74612953.0,
        "delta": 10000870.93
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -73908206.30999994,
    "valor_anterior": 193546387.26,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 181411326.71,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 387682430.48,
        "delta": 206271103.77
      },
      {
        "periodo": 202509,
        "valor": 212613670.88,
        "delta": -175068759.6
      },
      {
        "periodo": 202510,
        "valor": 194113598.03,
        "delta": -18500072.85
      },
      {
        "periodo": 202511,
        "valor": 23929459.07,
        "delta": -170184138.96
      },
      {
        "periodo": 202512,
        "valor": 134395299.22,
        "delta": 110465840.15
      },
      {
        "periodo": 202601,
        "valor": -29771033.78,
        "delta": -164166333.0
      },
      {
        "periodo": 202602,
        "valor": 345391065.76,
        "delta": 375162099.54
      },
      {
        "periodo": 202603,
        "valor": 209563653.72,
        "delta": -135827412.04
      },
      {
        "periodo": 202604,
        "valor": -61228637.62,
        "delta": -270792291.34
      },
      {
        "periodo": 202605,
        "valor": 61217679.44,
        "delta": 122446317.06
      },
      {
        "periodo": 202606,
        "valor": 193546387.26,
        "delta": 132328707.82
      },
      {
        "periodo": 202607,
        "valor": -73908206.31,
        "delta": -267454593.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100169,
    "label": "Otros Ingresos (Egresos) Op.",
    "valor_actual": -331641316.53999996,
    "valor_anterior": -1857825794.29,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -77773636.56,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 247039129.58,
        "delta": 324812766.14
      },
      {
        "periodo": 202509,
        "valor": 605995145.12,
        "delta": 358956015.54
      },
      {
        "periodo": 202510,
        "valor": 624388817.32,
        "delta": 18393672.2
      },
      {
        "periodo": 202511,
        "valor": 168762126.63,
        "delta": -455626690.69
      },
      {
        "periodo": 202512,
        "valor": 318330772.47,
        "delta": 149568645.84
      },
      {
        "periodo": 202601,
        "valor": 596493646.75,
        "delta": 278162874.28
      },
      {
        "periodo": 202602,
        "valor": 224899168.16,
        "delta": -371594478.59
      },
      {
        "periodo": 202603,
        "valor": -825735311.14,
        "delta": -1050634479.3
      },
      {
        "periodo": 202604,
        "valor": -558704741.69,
        "delta": 267030569.45
      },
      {
        "periodo": 202605,
        "valor": -592937100.23,
        "delta": -34232358.54
      },
      {
        "periodo": 202606,
        "valor": -1857825794.29,
        "delta": -1264888694.06
      },
      {
        "periodo": 202607,
        "valor": -331641316.54,
        "delta": 1526184477.75
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 96471923.30999994,
    "valor_anterior": 92829264.65000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 113257355.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 117471828.79,
        "delta": 4214473.4
      },
      {
        "periodo": 202509,
        "valor": 118551575.44,
        "delta": 1079746.65
      },
      {
        "periodo": 202510,
        "valor": 113815832.1,
        "delta": -4735743.34
      },
      {
        "periodo": 202511,
        "valor": 129389438.14,
        "delta": 15573606.04
      },
      {
        "periodo": 202512,
        "valor": 132647776.94,
        "delta": 3258338.8
      },
      {
        "periodo": 202601,
        "valor": 126219324.72,
        "delta": -6428452.22
      },
      {
        "periodo": 202602,
        "valor": 130623123.27,
        "delta": 4403798.55
      },
      {
        "periodo": 202603,
        "valor": 67753217.08,
        "delta": -62869906.19
      },
      {
        "periodo": 202604,
        "valor": 91564117.57,
        "delta": 23810900.49
      },
      {
        "periodo": 202605,
        "valor": 85440922.55,
        "delta": -6123195.02
      },
      {
        "periodo": 202606,
        "valor": 92829264.65,
        "delta": 7388342.1
      },
      {
        "periodo": 202607,
        "valor": 96471923.31,
        "delta": 3642658.66
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 44812325.360000014,
    "valor_anterior": 38821011.67000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 36400326.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 39896246.27,
        "delta": 3495920.08
      },
      {
        "periodo": 202509,
        "valor": 48515475.91,
        "delta": 8619229.64
      },
      {
        "periodo": 202510,
        "valor": 51925442.87,
        "delta": 3409966.96
      },
      {
        "periodo": 202511,
        "valor": 41767452.2,
        "delta": -10157990.67
      },
      {
        "periodo": 202512,
        "valor": 44359413.94,
        "delta": 2591961.74
      },
      {
        "periodo": 202601,
        "valor": 207189868.12,
        "delta": 162830454.18
      },
      {
        "periodo": 202602,
        "valor": 29095886.9,
        "delta": -178093981.22
      },
      {
        "periodo": 202603,
        "valor": 153509633.26,
        "delta": 124413746.36
      },
      {
        "periodo": 202604,
        "valor": 39026666.86,
        "delta": -114482966.4
      },
      {
        "periodo": 202605,
        "valor": 49644599.93,
        "delta": 10617933.07
      },
      {
        "periodo": 202606,
        "valor": 38821011.67,
        "delta": -10823588.26
      },
      {
        "periodo": 202607,
        "valor": 44812325.36,
        "delta": 5991313.69
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 193590618.0,
    "valor_anterior": 700383904.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 29375415.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 67629704.0,
        "delta": 38254289.0
      },
      {
        "periodo": 202509,
        "valor": 12408998.0,
        "delta": -55220706.0
      },
      {
        "periodo": 202510,
        "valor": 709387170.0,
        "delta": 696978172.0
      },
      {
        "periodo": 202511,
        "valor": -96696563.0,
        "delta": -806083733.0
      },
      {
        "periodo": 202512,
        "valor": 151768355.0,
        "delta": 248464918.0
      },
      {
        "periodo": 202601,
        "valor": 56612263.0,
        "delta": -95156092.0
      },
      {
        "periodo": 202602,
        "valor": -110514286.0,
        "delta": -167126549.0
      },
      {
        "periodo": 202603,
        "valor": 619652704.0,
        "delta": 730166990.0
      },
      {
        "periodo": 202604,
        "valor": 64690052.0,
        "delta": -554962652.0
      },
      {
        "periodo": 202605,
        "valor": 39882585.0,
        "delta": -24807467.0
      },
      {
        "periodo": 202606,
        "valor": 700383904.0,
        "delta": 660501319.0
      },
      {
        "periodo": 202607,
        "valor": 193590618.0,
        "delta": -506793286.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 57837123.0,
    "valor_anterior": 46442181.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 36152265.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 39070766.0,
        "delta": 2918501.0
      },
      {
        "periodo": 202509,
        "valor": 41609284.0,
        "delta": 2538518.0
      },
      {
        "periodo": 202510,
        "valor": 35291021.0,
        "delta": -6318263.0
      },
      {
        "periodo": 202511,
        "valor": 44308371.0,
        "delta": 9017350.0
      },
      {
        "periodo": 202512,
        "valor": 33703856.0,
        "delta": -10604515.0
      },
      {
        "periodo": 202601,
        "valor": 16003645.0,
        "delta": -17700211.0
      },
      {
        "periodo": 202602,
        "valor": 47259481.0,
        "delta": 31255836.0
      },
      {
        "periodo": 202603,
        "valor": 119120942.0,
        "delta": 71861461.0
      },
      {
        "periodo": 202604,
        "valor": 50485678.0,
        "delta": -68635264.0
      },
      {
        "periodo": 202605,
        "valor": 39725792.0,
        "delta": -10759886.0
      },
      {
        "periodo": 202606,
        "valor": 46442181.0,
        "delta": 6716389.0
      },
      {
        "periodo": 202607,
        "valor": 57837123.0,
        "delta": 11394942.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 213576.41000000015,
    "valor_anterior": 155271.08999999985,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 276520.67,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 275535.41,
        "delta": -985.26
      },
      {
        "periodo": 202509,
        "valor": 246241.34,
        "delta": -29294.07
      },
      {
        "periodo": 202510,
        "valor": 229025.72,
        "delta": -17215.62
      },
      {
        "periodo": 202511,
        "valor": 187961.0,
        "delta": -41064.72
      },
      {
        "periodo": 202512,
        "valor": 1460544.25,
        "delta": 1272583.25
      },
      {
        "periodo": 202601,
        "valor": 234332.09,
        "delta": -1226212.16
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -234332.09
      },
      {
        "periodo": 202603,
        "valor": 1730122.45,
        "delta": 1730122.45
      },
      {
        "periodo": 202604,
        "valor": 250129.2,
        "delta": -1479993.25
      },
      {
        "periodo": 202605,
        "valor": 213256.67,
        "delta": -36872.53
      },
      {
        "periodo": 202606,
        "valor": 155271.09,
        "delta": -57985.58
      },
      {
        "periodo": 202607,
        "valor": 213576.41,
        "delta": 58305.32
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 181989263.0,
    "valor_anterior": 549870072.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 527917582.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 207724504.0,
        "delta": -320193078.0
      },
      {
        "periodo": 202509,
        "valor": 137908519.0,
        "delta": -69815985.0
      },
      {
        "periodo": 202510,
        "valor": 201426486.0,
        "delta": 63517967.0
      },
      {
        "periodo": 202511,
        "valor": 262261728.0,
        "delta": 60835242.0
      },
      {
        "periodo": 202512,
        "valor": -238238842.0,
        "delta": -500500570.0
      },
      {
        "periodo": 202601,
        "valor": 72111971.0,
        "delta": 310350813.0
      },
      {
        "periodo": 202602,
        "valor": 113208813.0,
        "delta": 41096842.0
      },
      {
        "periodo": 202603,
        "valor": 92071606.0,
        "delta": -21137207.0
      },
      {
        "periodo": 202604,
        "valor": 131471440.0,
        "delta": 39399834.0
      },
      {
        "periodo": 202605,
        "valor": 104141268.0,
        "delta": -27330172.0
      },
      {
        "periodo": 202606,
        "valor": 549870072.0,
        "delta": 445728804.0
      },
      {
        "periodo": 202607,
        "valor": 181989263.0,
        "delta": -367880809.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 359188.0,
    "valor_anterior": 391149.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 456111.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 475452.0,
        "delta": 19341.0
      },
      {
        "periodo": 202509,
        "valor": 573264.0,
        "delta": 97812.0
      },
      {
        "periodo": 202510,
        "valor": -124709.0,
        "delta": -697973.0
      },
      {
        "periodo": 202511,
        "valor": 615043.0,
        "delta": 739752.0
      },
      {
        "periodo": 202512,
        "valor": 739491.0,
        "delta": 124448.0
      },
      {
        "periodo": 202601,
        "valor": -105958.0,
        "delta": -845449.0
      },
      {
        "periodo": 202602,
        "valor": 822034.0,
        "delta": 927992.0
      },
      {
        "periodo": 202603,
        "valor": 334184.0,
        "delta": -487850.0
      },
      {
        "periodo": 202604,
        "valor": 325178.0,
        "delta": -9006.0
      },
      {
        "periodo": 202605,
        "valor": 394146.0,
        "delta": 68968.0
      },
      {
        "periodo": 202606,
        "valor": 391149.0,
        "delta": -2997.0
      },
      {
        "periodo": 202607,
        "valor": 359188.0,
        "delta": -31961.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 28395532.0,
    "valor_anterior": 42581285.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 46664388.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 34454112.0,
        "delta": -12210276.0
      },
      {
        "periodo": 202509,
        "valor": 33833505.0,
        "delta": -620607.0
      },
      {
        "periodo": 202510,
        "valor": 47967120.0,
        "delta": 14133615.0
      },
      {
        "periodo": 202511,
        "valor": 42061273.0,
        "delta": -5905847.0
      },
      {
        "periodo": 202512,
        "valor": 24377923.0,
        "delta": -17683350.0
      },
      {
        "periodo": 202601,
        "valor": 20124880.0,
        "delta": -4253043.0
      },
      {
        "periodo": 202602,
        "valor": 38639168.0,
        "delta": 18514288.0
      },
      {
        "periodo": 202603,
        "valor": 140542630.0,
        "delta": 101903462.0
      },
      {
        "periodo": 202604,
        "valor": 50034235.0,
        "delta": -90508395.0
      },
      {
        "periodo": 202605,
        "valor": 35631359.0,
        "delta": -14402876.0
      },
      {
        "periodo": 202606,
        "valor": 42581285.0,
        "delta": 6949926.0
      },
      {
        "periodo": 202607,
        "valor": 28395532.0,
        "delta": -14185753.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 23888408.53,
    "valor_anterior": 26016169.450000003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22078321.36,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21411481.45,
        "delta": -666839.91
      },
      {
        "periodo": 202509,
        "valor": 52993659.69,
        "delta": 31582178.24
      },
      {
        "periodo": 202510,
        "valor": 21612771.54,
        "delta": -31380888.15
      },
      {
        "periodo": 202511,
        "valor": 24644681.26,
        "delta": 3031909.72
      },
      {
        "periodo": 202512,
        "valor": 23917419.71,
        "delta": -727261.55
      },
      {
        "periodo": 202601,
        "valor": 30357834.11,
        "delta": 6440414.4
      },
      {
        "periodo": 202602,
        "valor": 75410933.95,
        "delta": 45053099.84
      },
      {
        "periodo": 202603,
        "valor": -35149411.79,
        "delta": -110560345.74
      },
      {
        "periodo": 202604,
        "valor": 30885381.45,
        "delta": 66034793.24
      },
      {
        "periodo": 202605,
        "valor": 27096782.23,
        "delta": -3788599.22
      },
      {
        "periodo": 202606,
        "valor": 26016169.45,
        "delta": -1080612.78
      },
      {
        "periodo": 202607,
        "valor": 23888408.53,
        "delta": -2127760.92
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 18591949.0,
    "valor_anterior": 23828169.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11115737.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12369299.0,
        "delta": 1253562.0
      },
      {
        "periodo": 202509,
        "valor": 10474892.0,
        "delta": -1894407.0
      },
      {
        "periodo": 202510,
        "valor": 12911816.0,
        "delta": 2436924.0
      },
      {
        "periodo": 202511,
        "valor": 13206625.0,
        "delta": 294809.0
      },
      {
        "periodo": 202512,
        "valor": 4489386.0,
        "delta": -8717239.0
      },
      {
        "periodo": 202601,
        "valor": -8930242.0,
        "delta": -13419628.0
      },
      {
        "periodo": 202602,
        "valor": 21440319.0,
        "delta": 30370561.0
      },
      {
        "periodo": 202603,
        "valor": 16166907.0,
        "delta": -5273412.0
      },
      {
        "periodo": 202604,
        "valor": 18760637.0,
        "delta": 2593730.0
      },
      {
        "periodo": 202605,
        "valor": 18253911.0,
        "delta": -506726.0
      },
      {
        "periodo": 202606,
        "valor": 23828169.0,
        "delta": 5574258.0
      },
      {
        "periodo": 202607,
        "valor": 18591949.0,
        "delta": -5236220.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 7028869.0,
    "valor_anterior": 8557044.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10983854.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10899504.0,
        "delta": -84350.0
      },
      {
        "periodo": 202509,
        "valor": 12344652.0,
        "delta": 1445148.0
      },
      {
        "periodo": 202510,
        "valor": 5393416.0,
        "delta": -6951236.0
      },
      {
        "periodo": 202511,
        "valor": 7898611.0,
        "delta": 2505195.0
      },
      {
        "periodo": 202512,
        "valor": 10884618.0,
        "delta": 2986007.0
      },
      {
        "periodo": 202601,
        "valor": 7626641.0,
        "delta": -3257977.0
      },
      {
        "periodo": 202602,
        "valor": 10888166.0,
        "delta": 3261525.0
      },
      {
        "periodo": 202603,
        "valor": 11591570.0,
        "delta": 703404.0
      },
      {
        "periodo": 202604,
        "valor": 10674486.0,
        "delta": -917084.0
      },
      {
        "periodo": 202605,
        "valor": 8126142.0,
        "delta": -2548344.0
      },
      {
        "periodo": 202606,
        "valor": 8557044.0,
        "delta": 430902.0
      },
      {
        "periodo": 202607,
        "valor": 7028869.0,
        "delta": -1528175.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 37168763.17999998,
    "valor_anterior": 40377274.890000015,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 51224670.22,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 22096376.69,
        "delta": -29128293.53
      },
      {
        "periodo": 202509,
        "valor": 56746796.79,
        "delta": 34650420.1
      },
      {
        "periodo": 202510,
        "valor": 52098775.56,
        "delta": -4648021.23
      },
      {
        "periodo": 202511,
        "valor": 100201829.53,
        "delta": 48103053.97
      },
      {
        "periodo": 202512,
        "valor": 92245587.44,
        "delta": -7956242.09
      },
      {
        "periodo": 202601,
        "valor": 3166831.59,
        "delta": -89078755.85
      },
      {
        "periodo": 202602,
        "valor": 42437373.41,
        "delta": 39270541.82
      },
      {
        "periodo": 202603,
        "valor": 49696266.9,
        "delta": 7258893.49
      },
      {
        "periodo": 202604,
        "valor": 36365670.51,
        "delta": -13330596.39
      },
      {
        "periodo": 202605,
        "valor": 42229714.78,
        "delta": 5864044.27
      },
      {
        "periodo": 202606,
        "valor": 40377274.89,
        "delta": -1852439.89
      },
      {
        "periodo": 202607,
        "valor": 37168763.18,
        "delta": -3208511.71
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 350277.0,
    "valor_anterior": 331614.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 356494.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 350131.0,
        "delta": -6363.0
      },
      {
        "periodo": 202509,
        "valor": 445447.0,
        "delta": 95316.0
      },
      {
        "periodo": 202510,
        "valor": -231164.0,
        "delta": -676611.0
      },
      {
        "periodo": 202511,
        "valor": 455076.0,
        "delta": 686240.0
      },
      {
        "periodo": 202512,
        "valor": 646314.0,
        "delta": 191238.0
      },
      {
        "periodo": 202601,
        "valor": -300932.0,
        "delta": -947246.0
      },
      {
        "periodo": 202602,
        "valor": 1002634.0,
        "delta": 1303566.0
      },
      {
        "periodo": 202603,
        "valor": 252855.0,
        "delta": -749779.0
      },
      {
        "periodo": 202604,
        "valor": 312238.0,
        "delta": 59383.0
      },
      {
        "periodo": 202605,
        "valor": 472036.0,
        "delta": 159798.0
      },
      {
        "periodo": 202606,
        "valor": 331614.0,
        "delta": -140422.0
      },
      {
        "periodo": 202607,
        "valor": 350277.0,
        "delta": 18663.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 2241568.290000001,
    "valor_anterior": 6276003.64,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1511214.09,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2457660.58,
        "delta": 3968874.67
      },
      {
        "periodo": 202509,
        "valor": -5169809.57,
        "delta": -7627470.15
      },
      {
        "periodo": 202510,
        "valor": 4836930.05,
        "delta": 10006739.62
      },
      {
        "periodo": 202511,
        "valor": 1892231.03,
        "delta": -2944699.02
      },
      {
        "periodo": 202512,
        "valor": -6188931.37,
        "delta": -8081162.4
      },
      {
        "periodo": 202601,
        "valor": -10341605.19,
        "delta": -4152673.82
      },
      {
        "periodo": 202602,
        "valor": 8278760.63,
        "delta": 18620365.82
      },
      {
        "periodo": 202603,
        "valor": 7851086.74,
        "delta": -427673.89
      },
      {
        "periodo": 202604,
        "valor": -5468471.59,
        "delta": -13319558.33
      },
      {
        "periodo": 202605,
        "valor": 5697020.47,
        "delta": 11165492.06
      },
      {
        "periodo": 202606,
        "valor": 6276003.64,
        "delta": 578983.17
      },
      {
        "periodo": 202607,
        "valor": 2241568.29,
        "delta": -4034435.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 1453762.0,
    "valor_anterior": 1426122.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -273982.83,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 562509.22,
        "delta": 836492.05
      },
      {
        "periodo": 202509,
        "valor": -532382.2,
        "delta": -1094891.42
      },
      {
        "periodo": 202510,
        "valor": 3265.0,
        "delta": 535647.2
      },
      {
        "periodo": 202511,
        "valor": -237093.0,
        "delta": -240358.0
      },
      {
        "periodo": 202512,
        "valor": 1289248.0,
        "delta": 1526341.0
      },
      {
        "periodo": 202601,
        "valor": -2615526.0,
        "delta": -3904774.0
      },
      {
        "periodo": 202602,
        "valor": 409003.0,
        "delta": 3024529.0
      },
      {
        "periodo": 202603,
        "valor": -70443.0,
        "delta": -479446.0
      },
      {
        "periodo": 202604,
        "valor": 1436068.0,
        "delta": 1506511.0
      },
      {
        "periodo": 202605,
        "valor": 150771.0,
        "delta": -1285297.0
      },
      {
        "periodo": 202606,
        "valor": 1426122.0,
        "delta": 1275351.0
      },
      {
        "periodo": 202607,
        "valor": 1453762.0,
        "delta": 27640.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": -42277092.0,
    "valor_anterior": 2198476.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2176654.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2202396.0,
        "delta": 25742.0
      },
      {
        "periodo": 202509,
        "valor": 2707678.0,
        "delta": 505282.0
      },
      {
        "periodo": 202510,
        "valor": 2476526.0,
        "delta": -231152.0
      },
      {
        "periodo": 202511,
        "valor": 1939395.0,
        "delta": -537131.0
      },
      {
        "periodo": 202512,
        "valor": 1368840.0,
        "delta": -570555.0
      },
      {
        "periodo": 202601,
        "valor": 1920240.0,
        "delta": 551400.0
      },
      {
        "periodo": 202602,
        "valor": 2144273.0,
        "delta": 224033.0
      },
      {
        "periodo": 202603,
        "valor": 2326446.0,
        "delta": 182173.0
      },
      {
        "periodo": 202604,
        "valor": 2396404.0,
        "delta": 69958.0
      },
      {
        "periodo": 202605,
        "valor": 2339747.0,
        "delta": -56657.0
      },
      {
        "periodo": 202606,
        "valor": 2198476.0,
        "delta": -141271.0
      },
      {
        "periodo": 202607,
        "valor": -42277092.0,
        "delta": -44475568.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1430314.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -7550546.0,
        "delta": -6120232.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 7550546.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 350277.0,
    "valor_anterior": 316019.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 356493.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 350132.0,
        "delta": -6361.0
      },
      {
        "periodo": 202509,
        "valor": 445446.0,
        "delta": 95314.0
      },
      {
        "periodo": 202510,
        "valor": -231164.0,
        "delta": -676610.0
      },
      {
        "periodo": 202511,
        "valor": 455076.0,
        "delta": 686240.0
      },
      {
        "periodo": 202512,
        "valor": 646314.0,
        "delta": 191238.0
      },
      {
        "periodo": 202601,
        "valor": -300932.0,
        "delta": -947246.0
      },
      {
        "periodo": 202602,
        "valor": 701703.0,
        "delta": 1002635.0
      },
      {
        "periodo": 202603,
        "valor": 252854.0,
        "delta": -448849.0
      },
      {
        "periodo": 202604,
        "valor": 312238.0,
        "delta": 59384.0
      },
      {
        "periodo": 202605,
        "valor": 472036.0,
        "delta": 159798.0
      },
      {
        "periodo": 202606,
        "valor": 316019.0,
        "delta": -156017.0
      },
      {
        "periodo": 202607,
        "valor": 350277.0,
        "delta": 34258.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 133491.0,
    "valor_anterior": 501578.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 357065.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 350693.0,
        "delta": -6372.0
      },
      {
        "periodo": 202509,
        "valor": 446160.0,
        "delta": 95467.0
      },
      {
        "periodo": 202510,
        "valor": -231534.0,
        "delta": -677694.0
      },
      {
        "periodo": 202511,
        "valor": 455806.0,
        "delta": 687340.0
      },
      {
        "periodo": 202512,
        "valor": 647349.0,
        "delta": 191543.0
      },
      {
        "periodo": 202601,
        "valor": -301415.0,
        "delta": -948764.0
      },
      {
        "periodo": 202602,
        "valor": 702828.0,
        "delta": 1004243.0
      },
      {
        "periodo": 202603,
        "valor": 253259.0,
        "delta": -449569.0
      },
      {
        "periodo": 202604,
        "valor": 312738.0,
        "delta": 59479.0
      },
      {
        "periodo": 202605,
        "valor": 472793.0,
        "delta": 160055.0
      },
      {
        "periodo": 202606,
        "valor": 501578.0,
        "delta": 28785.0
      },
      {
        "periodo": 202607,
        "valor": 133491.0,
        "delta": -368087.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 1539552.0,
    "valor_anterior": 10518353.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -296872.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7226593.0,
        "delta": 7523465.0
      },
      {
        "periodo": 202509,
        "valor": -11961513.0,
        "delta": -19188106.0
      },
      {
        "periodo": 202510,
        "valor": 6132149.0,
        "delta": 18093662.0
      },
      {
        "periodo": 202511,
        "valor": -1385539.0,
        "delta": -7517688.0
      },
      {
        "periodo": 202512,
        "valor": 11047295.0,
        "delta": 12432834.0
      },
      {
        "periodo": 202601,
        "valor": 5524574.0,
        "delta": -5522721.0
      },
      {
        "periodo": 202602,
        "valor": 7421187.0,
        "delta": 1896613.0
      },
      {
        "periodo": 202603,
        "valor": -11157483.0,
        "delta": -18578670.0
      },
      {
        "periodo": 202604,
        "valor": 7495330.0,
        "delta": 18652813.0
      },
      {
        "periodo": 202605,
        "valor": -9569180.0,
        "delta": -17064510.0
      },
      {
        "periodo": 202606,
        "valor": 10518353.0,
        "delta": 20087533.0
      },
      {
        "periodo": 202607,
        "valor": 1539552.0,
        "delta": -8978801.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1248996.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1205641.0,
        "delta": -43355.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 302330.0,
    "valor_anterior": -187112.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 316110.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 310468.0,
        "delta": -5642.0
      },
      {
        "periodo": 202509,
        "valor": 394986.0,
        "delta": 84518.0
      },
      {
        "periodo": 202510,
        "valor": -204977.0,
        "delta": -599963.0
      },
      {
        "periodo": 202511,
        "valor": 403524.0,
        "delta": 608501.0
      },
      {
        "periodo": 202512,
        "valor": 573099.0,
        "delta": 169575.0
      },
      {
        "periodo": 202601,
        "valor": -266842.0,
        "delta": -839941.0
      },
      {
        "periodo": 202602,
        "valor": 622213.0,
        "delta": 889055.0
      },
      {
        "periodo": 202603,
        "valor": 224210.0,
        "delta": -398003.0
      },
      {
        "periodo": 202604,
        "valor": 276867.0,
        "delta": 52657.0
      },
      {
        "periodo": 202605,
        "valor": 418564.0,
        "delta": 141697.0
      },
      {
        "periodo": 202606,
        "valor": -187112.0,
        "delta": -605676.0
      },
      {
        "periodo": 202607,
        "valor": 302330.0,
        "delta": 489442.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 350486.92999999993,
    "valor_anterior": 296680.65000000014,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 357064.91,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 350692.84,
        "delta": -6372.07
      },
      {
        "periodo": 202509,
        "valor": 446159.77,
        "delta": 95466.93
      },
      {
        "periodo": 202510,
        "valor": -231533.82,
        "delta": -677693.59
      },
      {
        "periodo": 202511,
        "valor": 455805.53,
        "delta": 687339.35
      },
      {
        "periodo": 202512,
        "valor": 647349.55,
        "delta": 191544.02
      },
      {
        "periodo": 202601,
        "valor": -301414.65,
        "delta": -948764.2
      },
      {
        "periodo": 202602,
        "valor": 702827.81,
        "delta": 1004242.46
      },
      {
        "periodo": 202603,
        "valor": 253259.21,
        "delta": -449568.6
      },
      {
        "periodo": 202604,
        "valor": 312737.97,
        "delta": 59478.76
      },
      {
        "periodo": 202605,
        "valor": 472792.56,
        "delta": 160054.59
      },
      {
        "periodo": 202606,
        "valor": 296680.65,
        "delta": -176111.91
      },
      {
        "periodo": 202607,
        "valor": 350486.93,
        "delta": 53806.28
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 350487.0,
    "valor_anterior": 296681.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 358019.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 355774.0,
        "delta": -2245.0
      },
      {
        "periodo": 202509,
        "valor": 457485.0,
        "delta": 101711.0
      },
      {
        "periodo": 202510,
        "valor": -231534.0,
        "delta": -689019.0
      },
      {
        "periodo": 202511,
        "valor": 455806.0,
        "delta": 687340.0
      },
      {
        "periodo": 202512,
        "valor": 647350.0,
        "delta": 191544.0
      },
      {
        "periodo": 202601,
        "valor": -301415.0,
        "delta": -948765.0
      },
      {
        "periodo": 202602,
        "valor": 702828.0,
        "delta": 1004243.0
      },
      {
        "periodo": 202603,
        "valor": 253259.0,
        "delta": -449569.0
      },
      {
        "periodo": 202604,
        "valor": 312738.0,
        "delta": 59479.0
      },
      {
        "periodo": 202605,
        "valor": 472793.0,
        "delta": 160055.0
      },
      {
        "periodo": 202606,
        "valor": 296681.0,
        "delta": -176112.0
      },
      {
        "periodo": 202607,
        "valor": 350487.0,
        "delta": 53806.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 349286.29000000004,
    "valor_anterior": 283326.22,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3541112.78,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 570781.58,
        "delta": -2970331.2
      },
      {
        "periodo": 202509,
        "valor": 419349.78,
        "delta": -151431.8
      },
      {
        "periodo": 202510,
        "valor": 379136.55,
        "delta": -40213.23
      },
      {
        "periodo": 202511,
        "valor": 33267.37,
        "delta": -345869.18
      },
      {
        "periodo": 202512,
        "valor": -770999.02,
        "delta": -804266.39
      },
      {
        "periodo": 202601,
        "valor": -301894.21,
        "delta": 469104.81
      },
      {
        "periodo": 202602,
        "valor": 700822.83,
        "delta": 1002717.04
      },
      {
        "periodo": 202603,
        "valor": 252089.06,
        "delta": -448733.77
      },
      {
        "periodo": 202604,
        "valor": 311381.73,
        "delta": 59292.67
      },
      {
        "periodo": 202605,
        "valor": 471387.88,
        "delta": 160006.15
      },
      {
        "periodo": 202606,
        "valor": 283326.22,
        "delta": -188061.66
      },
      {
        "periodo": 202607,
        "valor": 349286.29,
        "delta": 65960.07
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 340954.0,
    "valor_anterior": -211016.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 356494.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 350132.0,
        "delta": -6362.0
      },
      {
        "periodo": 202509,
        "valor": 445446.0,
        "delta": 95314.0
      },
      {
        "periodo": 202510,
        "valor": -231164.0,
        "delta": -676610.0
      },
      {
        "periodo": 202511,
        "valor": 455077.0,
        "delta": 686241.0
      },
      {
        "periodo": 202512,
        "valor": 646313.0,
        "delta": 191236.0
      },
      {
        "periodo": 202601,
        "valor": -300932.0,
        "delta": -947245.0
      },
      {
        "periodo": 202602,
        "valor": 701703.0,
        "delta": 1002635.0
      },
      {
        "periodo": 202603,
        "valor": 252854.0,
        "delta": -448849.0
      },
      {
        "periodo": 202604,
        "valor": 312237.0,
        "delta": 59383.0
      },
      {
        "periodo": 202605,
        "valor": 472037.0,
        "delta": 159800.0
      },
      {
        "periodo": 202606,
        "valor": -211016.0,
        "delta": -683053.0
      },
      {
        "periodo": 202607,
        "valor": 340954.0,
        "delta": 551970.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 655832918.3000002,
    "valor_anterior": 1592299521.2599998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 891814665.6,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 582867867.83,
        "delta": -308946797.77
      },
      {
        "periodo": 202509,
        "valor": 495499031.95,
        "delta": -87368835.88
      },
      {
        "periodo": 202510,
        "valor": 1264169103.57,
        "delta": 768670071.62
      },
      {
        "periodo": 202511,
        "valor": 575224882.06,
        "delta": -688944221.51
      },
      {
        "periodo": 202512,
        "valor": 293555070.44,
        "delta": -281669811.62
      },
      {
        "periodo": 202601,
        "valor": 522723296.58,
        "delta": 229168226.14
      },
      {
        "periodo": 202602,
        "valor": 423401795.8,
        "delta": -99321500.78
      },
      {
        "periodo": 202603,
        "valor": 1237964616.91,
        "delta": 814562821.11
      },
      {
        "periodo": 202604,
        "valor": 532856177.7,
        "delta": -705108439.21
      },
      {
        "periodo": 202605,
        "valor": 453123277.07,
        "delta": -79732900.63
      },
      {
        "periodo": 202606,
        "valor": 1592299521.26,
        "delta": 1139176244.19
      },
      {
        "periodo": 202607,
        "valor": 655832918.3,
        "delta": -936466602.96
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 640265547.8500004,
    "valor_anterior": 1511304993.21,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 840992001.8,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 528343537.75,
        "delta": -312648464.05
      },
      {
        "periodo": 202509,
        "valor": 449574154.14,
        "delta": -78769383.61
      },
      {
        "periodo": 202510,
        "valor": 1211911847.53,
        "delta": 762337693.39
      },
      {
        "periodo": 202511,
        "valor": 523293528.87,
        "delta": -688618318.66
      },
      {
        "periodo": 202512,
        "valor": 240864070.32,
        "delta": -282429458.55
      },
      {
        "periodo": 202601,
        "valor": 501428783.43,
        "delta": 260564713.11
      },
      {
        "periodo": 202602,
        "valor": 290749559.58,
        "delta": -210679223.85
      },
      {
        "periodo": 202603,
        "valor": 1242346999.24,
        "delta": 951597439.66
      },
      {
        "periodo": 202604,
        "valor": 463637859.94,
        "delta": -778709139.3
      },
      {
        "periodo": 202605,
        "valor": 396696241.26,
        "delta": -66941618.68
      },
      {
        "periodo": 202606,
        "valor": 1511304993.21,
        "delta": 1114608751.95
      },
      {
        "periodo": 202607,
        "valor": 640265547.85,
        "delta": -871039445.36
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -181318.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -6344905.0,
        "delta": -6163587.0
      },
      {
        "periodo": 202509,
        "valor": -19252284.0,
        "delta": -12907379.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 19252284.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 25971095.0,
    "valor_anterior": 32716827.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22456085.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23618934.0,
        "delta": 1162849.0
      },
      {
        "periodo": 202509,
        "valor": 23264991.0,
        "delta": -353943.0
      },
      {
        "periodo": 202510,
        "valor": 18074068.0,
        "delta": -5190923.0
      },
      {
        "periodo": 202511,
        "valor": 21560312.0,
        "delta": 3486244.0
      },
      {
        "periodo": 202512,
        "valor": 16020318.0,
        "delta": -5539994.0
      },
      {
        "periodo": 202601,
        "valor": -1604533.0,
        "delta": -17624851.0
      },
      {
        "periodo": 202602,
        "valor": 33331119.0,
        "delta": 34935652.0
      },
      {
        "periodo": 202603,
        "valor": 28011332.0,
        "delta": -5319787.0
      },
      {
        "periodo": 202604,
        "valor": 29747361.0,
        "delta": 1736029.0
      },
      {
        "periodo": 202605,
        "valor": 26852089.0,
        "delta": -2895272.0
      },
      {
        "periodo": 202606,
        "valor": 32716827.0,
        "delta": 5864738.0
      },
      {
        "periodo": 202607,
        "valor": 25971095.0,
        "delta": -6745732.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": -17474965.060000002,
    "valor_anterior": 28550049.53999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25344101.03,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24714996.86,
        "delta": -629104.17
      },
      {
        "periodo": 202509,
        "valor": 56966289.03,
        "delta": 32251292.17
      },
      {
        "periodo": 202510,
        "valor": 23962450.26,
        "delta": -33003838.77
      },
      {
        "periodo": 202511,
        "valor": 27842157.26,
        "delta": 3879707.0
      },
      {
        "periodo": 202512,
        "valor": 28132607.96,
        "delta": 290450.7
      },
      {
        "periodo": 202601,
        "valor": 32105516.2,
        "delta": 3972908.24
      },
      {
        "periodo": 202602,
        "valor": 79078943.95,
        "delta": 46973427.75
      },
      {
        "periodo": 202603,
        "valor": -30505805.34,
        "delta": -109584749.29
      },
      {
        "periodo": 202604,
        "valor": 34169329.65,
        "delta": 64675134.99
      },
      {
        "periodo": 202605,
        "valor": 30515968.9,
        "delta": -3653360.75
      },
      {
        "periodo": 202606,
        "valor": 28550049.54,
        "delta": -1965919.36
      },
      {
        "periodo": 202607,
        "valor": -17474965.06,
        "delta": -46025014.6
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 3156629.219999999,
    "valor_anterior": 2431716.87,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4654816.86,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2500357.64,
        "delta": -2154459.22
      },
      {
        "periodo": 202509,
        "valor": 1631044.35,
        "delta": -869313.29
      },
      {
        "periodo": 202510,
        "valor": -516807.27,
        "delta": -2147851.62
      },
      {
        "periodo": 202511,
        "valor": 1566385.9,
        "delta": 2083193.17
      },
      {
        "periodo": 202512,
        "valor": 3032361.53,
        "delta": 1465975.63
      },
      {
        "periodo": 202601,
        "valor": -4088023.86,
        "delta": -7120385.39
      },
      {
        "periodo": 202602,
        "valor": 3839397.64,
        "delta": 7927421.5
      },
      {
        "periodo": 202603,
        "valor": 1165228.27,
        "delta": -2674169.37
      },
      {
        "periodo": 202604,
        "valor": 2962030.7,
        "delta": 1796802.43
      },
      {
        "periodo": 202605,
        "valor": 2458344.44,
        "delta": -503686.26
      },
      {
        "periodo": 202606,
        "valor": 2431716.87,
        "delta": -26627.57
      },
      {
        "periodo": 202607,
        "valor": 3156629.22,
        "delta": 724912.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100173,
    "label": "Part. en Rdo. de Otras Entidades",
    "valor_actual": 3914611.289999999,
    "valor_anterior": 17295934.64,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1451021.09,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10034946.58,
        "delta": 11485967.67
      },
      {
        "periodo": 202509,
        "valor": -16685162.57,
        "delta": -26720109.15
      },
      {
        "periodo": 202510,
        "valor": 10737545.05,
        "delta": 27422707.62
      },
      {
        "periodo": 202511,
        "valor": 962498.03,
        "delta": -9775047.02
      },
      {
        "periodo": 202512,
        "valor": 5505712.63,
        "delta": 4543214.6
      },
      {
        "periodo": 202601,
        "valor": -5118446.19,
        "delta": -10624158.82
      },
      {
        "periodo": 202602,
        "valor": 16402775.63,
        "delta": 21521221.82
      },
      {
        "periodo": 202603,
        "valor": -3053137.26,
        "delta": -19455912.89
      },
      {
        "periodo": 202604,
        "valor": 2339596.41,
        "delta": 5392733.67
      },
      {
        "periodo": 202605,
        "valor": -3399366.53,
        "delta": -5738962.94
      },
      {
        "periodo": 202606,
        "valor": 17295934.64,
        "delta": 20695301.17
      },
      {
        "periodo": 202607,
        "valor": 3914611.29,
        "delta": -13381323.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 3738711170.939995,
    "valor_anterior": 3094979227.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2395958981.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1621282042.54,
        "delta": -774676939.36
      },
      {
        "periodo": 202509,
        "valor": 1486514387.54,
        "delta": -134767655.0
      },
      {
        "periodo": 202510,
        "valor": 1102286097.36,
        "delta": -384228290.18
      },
      {
        "periodo": 202511,
        "valor": 5063705284.0,
        "delta": 3961419186.64
      },
      {
        "periodo": 202512,
        "valor": 1871971783.0,
        "delta": -3191733501.0
      },
      {
        "periodo": 202601,
        "valor": 2846878927.72,
        "delta": 974907144.72
      },
      {
        "periodo": 202602,
        "valor": 2220365648.8,
        "delta": -626513278.92
      },
      {
        "periodo": 202603,
        "valor": 4625991940.73,
        "delta": 2405626291.93
      },
      {
        "periodo": 202604,
        "valor": 1404427693.95,
        "delta": -3221564246.78
      },
      {
        "periodo": 202605,
        "valor": 2065868015.66,
        "delta": 661440321.71
      },
      {
        "periodo": 202606,
        "valor": 3094979227.25,
        "delta": 1029111211.59
      },
      {
        "periodo": 202607,
        "valor": 3738711170.94,
        "delta": 643731943.69
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 12614297055.099983,
    "valor_anterior": 11177427096.920006,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11525629628.96,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11928634879.12,
        "delta": 403005250.16
      },
      {
        "periodo": 202509,
        "valor": 11151521945.33,
        "delta": -777112933.79
      },
      {
        "periodo": 202510,
        "valor": 11751500309.38,
        "delta": 599978364.05
      },
      {
        "periodo": 202511,
        "valor": 11580533102.53,
        "delta": -170967206.85
      },
      {
        "periodo": 202512,
        "valor": 11425650903.24,
        "delta": -154882199.29
      },
      {
        "periodo": 202601,
        "valor": 12828918571.54,
        "delta": 1403267668.3
      },
      {
        "periodo": 202602,
        "valor": 7215505223.12,
        "delta": -5613413348.42
      },
      {
        "periodo": 202603,
        "valor": 13247792854.41,
        "delta": 6032287631.29
      },
      {
        "periodo": 202604,
        "valor": 11599106312.34,
        "delta": -1648686542.07
      },
      {
        "periodo": 202605,
        "valor": 11530687581.1,
        "delta": -68418731.24
      },
      {
        "periodo": 202606,
        "valor": 11177427096.92,
        "delta": -353260484.18
      },
      {
        "periodo": 202607,
        "valor": 12614297055.1,
        "delta": 1436869958.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 4146272388.999996,
    "valor_anterior": 5296952126.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4003688745.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3975241240.0,
        "delta": -28447505.0
      },
      {
        "periodo": 202509,
        "valor": 3287322353.0,
        "delta": -687918887.0
      },
      {
        "periodo": 202510,
        "valor": 4048160169.0,
        "delta": 760837816.0
      },
      {
        "periodo": 202511,
        "valor": 2883739018.0,
        "delta": -1164421151.0
      },
      {
        "periodo": 202512,
        "valor": 4818065954.0,
        "delta": 1934326936.0
      },
      {
        "periodo": 202601,
        "valor": 4869198292.0,
        "delta": 51132338.0
      },
      {
        "periodo": 202602,
        "valor": 3055829411.0,
        "delta": -1813368881.0
      },
      {
        "periodo": 202603,
        "valor": 6496734935.0,
        "delta": 3440905524.0
      },
      {
        "periodo": 202604,
        "valor": 4447507929.0,
        "delta": -2049227006.0
      },
      {
        "periodo": 202605,
        "valor": 2363046058.0,
        "delta": -2084461871.0
      },
      {
        "periodo": 202606,
        "valor": 5296952126.0,
        "delta": 2933906068.0
      },
      {
        "periodo": 202607,
        "valor": 4146272389.0,
        "delta": -1150679737.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 616597426.999999,
    "valor_anterior": 181311564.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1113031560.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 946863115.0,
        "delta": -166168445.0
      },
      {
        "periodo": 202509,
        "valor": 1103266848.0,
        "delta": 156403733.0
      },
      {
        "periodo": 202510,
        "valor": 572090589.0,
        "delta": -531176259.0
      },
      {
        "periodo": 202511,
        "valor": 1500959256.0,
        "delta": 928868667.0
      },
      {
        "periodo": 202512,
        "valor": -115077641.0,
        "delta": -1616036897.0
      },
      {
        "periodo": 202601,
        "valor": 1265167736.0,
        "delta": 1380245377.0
      },
      {
        "periodo": 202602,
        "valor": 1023466975.0,
        "delta": -241700761.0
      },
      {
        "periodo": 202603,
        "valor": 2457565180.0,
        "delta": 1434098205.0
      },
      {
        "periodo": 202604,
        "valor": 551085695.0,
        "delta": -1906479485.0
      },
      {
        "periodo": 202605,
        "valor": 170883228.0,
        "delta": -380202467.0
      },
      {
        "periodo": 202606,
        "valor": 181311564.0,
        "delta": 10428336.0
      },
      {
        "periodo": 202607,
        "valor": 616597427.0,
        "delta": 435285863.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 879062225.8400002,
    "valor_anterior": 931941507.6199999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 952623202.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1117124636.05,
        "delta": 164501433.23
      },
      {
        "periodo": 202509,
        "valor": 1011269258.36,
        "delta": -105855377.69
      },
      {
        "periodo": 202510,
        "valor": 1018345241.7,
        "delta": 7075983.34
      },
      {
        "periodo": 202511,
        "valor": 1051061877.05,
        "delta": 32716635.35
      },
      {
        "periodo": 202512,
        "valor": 889036253.55,
        "delta": -162025623.5
      },
      {
        "periodo": 202601,
        "valor": 1058681406.49,
        "delta": 169645152.94
      },
      {
        "periodo": 202602,
        "valor": 756206139.31,
        "delta": -302475267.18
      },
      {
        "periodo": 202603,
        "valor": 1024416811.45,
        "delta": 268210672.14
      },
      {
        "periodo": 202604,
        "valor": 993236914.29,
        "delta": -31179897.16
      },
      {
        "periodo": 202605,
        "valor": 1023727018.67,
        "delta": 30490104.38
      },
      {
        "periodo": 202606,
        "valor": 931941507.62,
        "delta": -91785511.05
      },
      {
        "periodo": 202607,
        "valor": 879062225.84,
        "delta": -52879281.78
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 1831166914.0,
    "valor_anterior": 1595959551.000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2671579465.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2375267207.0,
        "delta": -296312258.0
      },
      {
        "periodo": 202509,
        "valor": 2376927968.0,
        "delta": 1660761.0
      },
      {
        "periodo": 202510,
        "valor": 2118683741.0,
        "delta": -258244227.0
      },
      {
        "periodo": 202511,
        "valor": 2204478909.0,
        "delta": 85795168.0
      },
      {
        "periodo": 202512,
        "valor": 2875731222.0,
        "delta": 671252313.0
      },
      {
        "periodo": 202601,
        "valor": 2359321504.0,
        "delta": -516409718.0
      },
      {
        "periodo": 202602,
        "valor": 2110894434.0,
        "delta": -248427070.0
      },
      {
        "periodo": 202603,
        "valor": 2094713799.0,
        "delta": -16180635.0
      },
      {
        "periodo": 202604,
        "valor": 2359075977.0,
        "delta": 264362178.0
      },
      {
        "periodo": 202605,
        "valor": 1896365896.0,
        "delta": -462710081.0
      },
      {
        "periodo": 202606,
        "valor": 1595959551.0,
        "delta": -300406345.0
      },
      {
        "periodo": 202607,
        "valor": 1831166914.0,
        "delta": 235207363.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 398399084.0,
    "valor_anterior": 399457374.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 362628748.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 365256611.0,
        "delta": 2627863.0
      },
      {
        "periodo": 202509,
        "valor": 381358097.0,
        "delta": 16101486.0
      },
      {
        "periodo": 202510,
        "valor": 397002536.0,
        "delta": 15644439.0
      },
      {
        "periodo": 202511,
        "valor": 402943421.0,
        "delta": 5940885.0
      },
      {
        "periodo": 202512,
        "valor": 360293986.0,
        "delta": -42649435.0
      },
      {
        "periodo": 202601,
        "valor": 347681788.0,
        "delta": -12612198.0
      },
      {
        "periodo": 202602,
        "valor": 372453918.0,
        "delta": 24772130.0
      },
      {
        "periodo": 202603,
        "valor": 358722746.0,
        "delta": -13731172.0
      },
      {
        "periodo": 202604,
        "valor": 395844853.0,
        "delta": 37122107.0
      },
      {
        "periodo": 202605,
        "valor": 392778235.0,
        "delta": -3066618.0
      },
      {
        "periodo": 202606,
        "valor": 399457374.0,
        "delta": 6679139.0
      },
      {
        "periodo": 202607,
        "valor": 398399084.0,
        "delta": -1058290.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 1783213203.000002,
    "valor_anterior": 1612674599.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1081194036.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1272643296.0,
        "delta": 191449260.0
      },
      {
        "periodo": 202509,
        "valor": 1147619008.0,
        "delta": -125024288.0
      },
      {
        "periodo": 202510,
        "valor": 973678620.0,
        "delta": -173940388.0
      },
      {
        "periodo": 202511,
        "valor": 951916980.0,
        "delta": -21761640.0
      },
      {
        "periodo": 202512,
        "valor": 1585859632.0,
        "delta": 633942652.0
      },
      {
        "periodo": 202601,
        "valor": 1861484640.0,
        "delta": 275625008.0
      },
      {
        "periodo": 202602,
        "valor": 1246759298.0,
        "delta": -614725342.0
      },
      {
        "periodo": 202603,
        "valor": 2743115269.0,
        "delta": 1496355971.0
      },
      {
        "periodo": 202604,
        "valor": 925074202.0,
        "delta": -1818041067.0
      },
      {
        "periodo": 202605,
        "valor": 1235530683.0,
        "delta": 310456481.0
      },
      {
        "periodo": 202606,
        "valor": 1612674599.0,
        "delta": 377143916.0
      },
      {
        "periodo": 202607,
        "valor": 1783213203.0,
        "delta": 170538604.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 754624936.3200002,
    "valor_anterior": 660895434.44,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 687365586.49,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 682517380.53,
        "delta": -4848205.96
      },
      {
        "periodo": 202509,
        "valor": 698546983.62,
        "delta": 16029603.09
      },
      {
        "periodo": 202510,
        "valor": 770946583.6,
        "delta": 72399599.98
      },
      {
        "periodo": 202511,
        "valor": 836938304.76,
        "delta": 65991721.16
      },
      {
        "periodo": 202512,
        "valor": 857342430.92,
        "delta": 20404126.16
      },
      {
        "periodo": 202601,
        "valor": 682505265.57,
        "delta": -174837165.35
      },
      {
        "periodo": 202602,
        "valor": 603775735.35,
        "delta": -78729530.22
      },
      {
        "periodo": 202603,
        "valor": 704159942.95,
        "delta": 100384207.6
      },
      {
        "periodo": 202604,
        "valor": 680007663.92,
        "delta": -24152279.03
      },
      {
        "periodo": 202605,
        "valor": 667334525.05,
        "delta": -12673138.87
      },
      {
        "periodo": 202606,
        "valor": 660895434.44,
        "delta": -6439090.61
      },
      {
        "periodo": 202607,
        "valor": 754624936.32,
        "delta": 93729501.88
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 343881742.0,
    "valor_anterior": 225238950.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 276779856.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 62898391.0,
        "delta": -213881465.0
      },
      {
        "periodo": 202509,
        "valor": 314224824.0,
        "delta": 251326433.0
      },
      {
        "periodo": 202510,
        "valor": 307636384.0,
        "delta": -6588440.0
      },
      {
        "periodo": 202511,
        "valor": -35307156.0,
        "delta": -342943540.0
      },
      {
        "periodo": 202512,
        "valor": 130307344.0,
        "delta": 165614500.0
      },
      {
        "periodo": 202601,
        "valor": -45152890.0,
        "delta": -175460234.0
      },
      {
        "periodo": 202602,
        "valor": 36768075.0,
        "delta": 81920965.0
      },
      {
        "periodo": 202603,
        "valor": 166237191.0,
        "delta": 129469116.0
      },
      {
        "periodo": 202604,
        "valor": 284285873.0,
        "delta": 118048682.0
      },
      {
        "periodo": 202605,
        "valor": 228317427.0,
        "delta": -55968446.0
      },
      {
        "periodo": 202606,
        "valor": 225238950.0,
        "delta": -3078477.0
      },
      {
        "periodo": 202607,
        "valor": 343881742.0,
        "delta": 118642792.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 141922666.0,
    "valor_anterior": 140008415.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 153709368.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 218582238.0,
        "delta": 64872870.0
      },
      {
        "periodo": 202509,
        "valor": 173642765.0,
        "delta": -44939473.0
      },
      {
        "periodo": 202510,
        "valor": 135007516.0,
        "delta": -38635249.0
      },
      {
        "periodo": 202511,
        "valor": 134739435.0,
        "delta": -268081.0
      },
      {
        "periodo": 202512,
        "valor": 143656663.0,
        "delta": 8917228.0
      },
      {
        "periodo": 202601,
        "valor": 136080691.0,
        "delta": -7575972.0
      },
      {
        "periodo": 202602,
        "valor": 145804694.0,
        "delta": 9724003.0
      },
      {
        "periodo": 202603,
        "valor": 90380248.0,
        "delta": -55424446.0
      },
      {
        "periodo": 202604,
        "valor": 139075800.0,
        "delta": 48695552.0
      },
      {
        "periodo": 202605,
        "valor": 131834061.0,
        "delta": -7241739.0
      },
      {
        "periodo": 202606,
        "valor": 140008415.0,
        "delta": 8174354.0
      },
      {
        "periodo": 202607,
        "valor": 141922666.0,
        "delta": 1914251.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 77933401.0,
    "valor_anterior": 160642833.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 109281237.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 150058514.0,
        "delta": 40777277.0
      },
      {
        "periodo": 202509,
        "valor": 124685575.0,
        "delta": -25372939.0
      },
      {
        "periodo": 202510,
        "valor": 131037688.0,
        "delta": 6352113.0
      },
      {
        "periodo": 202511,
        "valor": 110738668.0,
        "delta": -20299020.0
      },
      {
        "periodo": 202512,
        "valor": -579323158.0,
        "delta": -690061826.0
      },
      {
        "periodo": 202601,
        "valor": 154789639.0,
        "delta": 734112797.0
      },
      {
        "periodo": 202602,
        "valor": 78624383.0,
        "delta": -76165256.0
      },
      {
        "periodo": 202603,
        "valor": 212199007.0,
        "delta": 133574624.0
      },
      {
        "periodo": 202604,
        "valor": 177543908.0,
        "delta": -34655099.0
      },
      {
        "periodo": 202605,
        "valor": 113032549.0,
        "delta": -64511359.0
      },
      {
        "periodo": 202606,
        "valor": 160642833.0,
        "delta": 47610284.0
      },
      {
        "periodo": 202607,
        "valor": 77933401.0,
        "delta": -82709432.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 5580943247.409996,
    "valor_anterior": 6024359890.84,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5685165928.09,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5340947847.32,
        "delta": -344218080.77
      },
      {
        "periodo": 202509,
        "valor": 4093737578.02,
        "delta": -1247210269.3
      },
      {
        "periodo": 202510,
        "valor": 5884044929.75,
        "delta": 1790307351.73
      },
      {
        "periodo": 202511,
        "valor": 5147718082.18,
        "delta": -736326847.57
      },
      {
        "periodo": 202512,
        "valor": 7133047670.73,
        "delta": 1985329588.55
      },
      {
        "periodo": 202601,
        "valor": 5349246456.7,
        "delta": -1783801214.03
      },
      {
        "periodo": 202602,
        "valor": 5313897003.96,
        "delta": -35349452.74
      },
      {
        "periodo": 202603,
        "valor": 6608728780.77,
        "delta": 1294831776.81
      },
      {
        "periodo": 202604,
        "valor": 6075315073.44,
        "delta": -533413707.33
      },
      {
        "periodo": 202605,
        "valor": 5595439753.22,
        "delta": -479875320.22
      },
      {
        "periodo": 202606,
        "valor": 6024359890.84,
        "delta": 428920137.62
      },
      {
        "periodo": 202607,
        "valor": 5580943247.41,
        "delta": -443416643.43
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 268710199.0,
    "valor_anterior": 179510194.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 186889063.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 184239200.0,
        "delta": -2649863.0
      },
      {
        "periodo": 202509,
        "valor": 109071398.0,
        "delta": -75167802.0
      },
      {
        "periodo": 202510,
        "valor": 313572969.0,
        "delta": 204501571.0
      },
      {
        "periodo": 202511,
        "valor": -78402136.0,
        "delta": -391975105.0
      },
      {
        "periodo": 202512,
        "valor": 404639401.0,
        "delta": 483041537.0
      },
      {
        "periodo": 202601,
        "valor": 331991601.0,
        "delta": -72647800.0
      },
      {
        "periodo": 202602,
        "valor": 227169165.0,
        "delta": -104822436.0
      },
      {
        "periodo": 202603,
        "valor": 303571202.0,
        "delta": 76402037.0
      },
      {
        "periodo": 202604,
        "valor": 430365320.0,
        "delta": 126794118.0
      },
      {
        "periodo": 202605,
        "valor": -1715568.0,
        "delta": -432080888.0
      },
      {
        "periodo": 202606,
        "valor": 179510194.0,
        "delta": 181225762.0
      },
      {
        "periodo": 202607,
        "valor": 268710199.0,
        "delta": 89200005.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 92652426.0,
    "valor_anterior": 35839177.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 130519571.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 135178367.0,
        "delta": 4658796.0
      },
      {
        "periodo": 202509,
        "valor": 134305616.0,
        "delta": -872751.0
      },
      {
        "periodo": 202510,
        "valor": 87851353.0,
        "delta": -46454263.0
      },
      {
        "periodo": 202511,
        "valor": 101967214.0,
        "delta": 14115861.0
      },
      {
        "periodo": 202512,
        "valor": 105358056.0,
        "delta": 3390842.0
      },
      {
        "periodo": 202601,
        "valor": 77733246.0,
        "delta": -27624810.0
      },
      {
        "periodo": 202602,
        "valor": 18940176.0,
        "delta": -58793070.0
      },
      {
        "periodo": 202603,
        "valor": 35162370.0,
        "delta": 16222194.0
      },
      {
        "periodo": 202604,
        "valor": 90485199.0,
        "delta": 55322829.0
      },
      {
        "periodo": 202605,
        "valor": 82132215.0,
        "delta": -8352984.0
      },
      {
        "periodo": 202606,
        "valor": 35839177.0,
        "delta": -46293038.0
      },
      {
        "periodo": 202607,
        "valor": 92652426.0,
        "delta": 56813249.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 305377251.0,
    "valor_anterior": 279472912.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 470044655.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 739125959.0,
        "delta": 269081304.0
      },
      {
        "periodo": 202509,
        "valor": 884831135.0,
        "delta": 145705176.0
      },
      {
        "periodo": 202510,
        "valor": 508910107.0,
        "delta": -375921028.0
      },
      {
        "periodo": 202511,
        "valor": 361916811.0,
        "delta": -146993296.0
      },
      {
        "periodo": 202512,
        "valor": 294871485.0,
        "delta": -67045326.0
      },
      {
        "periodo": 202601,
        "valor": 282271317.0,
        "delta": -12600168.0
      },
      {
        "periodo": 202602,
        "valor": 409442538.0,
        "delta": 127171221.0
      },
      {
        "periodo": 202603,
        "valor": 472376428.0,
        "delta": 62933890.0
      },
      {
        "periodo": 202604,
        "valor": 219549897.0,
        "delta": -252826531.0
      },
      {
        "periodo": 202605,
        "valor": 315227785.0,
        "delta": 95677888.0
      },
      {
        "periodo": 202606,
        "valor": 279472912.0,
        "delta": -35754873.0
      },
      {
        "periodo": 202607,
        "valor": 305377251.0,
        "delta": 25904339.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 454148656.02,
    "valor_anterior": 516876862.66999984,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 339322257.58,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 485134710.53,
        "delta": 145812452.95
      },
      {
        "periodo": 202509,
        "valor": 493392797.19,
        "delta": 8258086.66
      },
      {
        "periodo": 202510,
        "valor": 592289437.2,
        "delta": 98896640.01
      },
      {
        "periodo": 202511,
        "valor": 359777237.46,
        "delta": -232512199.74
      },
      {
        "periodo": 202512,
        "valor": 591226437.25,
        "delta": 231449199.79
      },
      {
        "periodo": 202601,
        "valor": 580016096.89,
        "delta": -11210340.36
      },
      {
        "periodo": 202602,
        "valor": 379569478.97,
        "delta": -200446617.92
      },
      {
        "periodo": 202603,
        "valor": 40058992.02,
        "delta": -339510486.95
      },
      {
        "periodo": 202604,
        "valor": 249258258.55,
        "delta": 209199266.53
      },
      {
        "periodo": 202605,
        "valor": 487746131.71,
        "delta": 238487873.16
      },
      {
        "periodo": 202606,
        "valor": 516876862.67,
        "delta": 29130730.96
      },
      {
        "periodo": 202607,
        "valor": 454148656.02,
        "delta": -62728206.65
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 142520292.0,
    "valor_anterior": 187432674.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 92295446.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 113730789.0,
        "delta": 21435343.0
      },
      {
        "periodo": 202509,
        "valor": 149683723.0,
        "delta": 35952934.0
      },
      {
        "periodo": 202510,
        "valor": 138513812.0,
        "delta": -11169911.0
      },
      {
        "periodo": 202511,
        "valor": 125192794.0,
        "delta": -13321018.0
      },
      {
        "periodo": 202512,
        "valor": 156200999.0,
        "delta": 31008205.0
      },
      {
        "periodo": 202601,
        "valor": 123812157.0,
        "delta": -32388842.0
      },
      {
        "periodo": 202602,
        "valor": 21684059.0,
        "delta": -102128098.0
      },
      {
        "periodo": 202603,
        "valor": 174805705.0,
        "delta": 153121646.0
      },
      {
        "periodo": 202604,
        "valor": 191342140.0,
        "delta": 16536435.0
      },
      {
        "periodo": 202605,
        "valor": 146733109.0,
        "delta": -44609031.0
      },
      {
        "periodo": 202606,
        "valor": 187432674.0,
        "delta": 40699565.0
      },
      {
        "periodo": 202607,
        "valor": 142520292.0,
        "delta": -44912382.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 819576482.5,
    "valor_anterior": 1165269868.04,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 855131280.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1533535541.54,
        "delta": 678404261.15
      },
      {
        "periodo": 202509,
        "valor": 1448373310.73,
        "delta": -85162230.81
      },
      {
        "periodo": 202510,
        "valor": 1325382156.36,
        "delta": -122991154.37
      },
      {
        "periodo": 202511,
        "valor": 840747571.73,
        "delta": -484634584.63
      },
      {
        "periodo": 202512,
        "valor": 2556914820.71,
        "delta": 1716167248.98
      },
      {
        "periodo": 202601,
        "valor": 1740280020.17,
        "delta": -816634800.54
      },
      {
        "periodo": 202602,
        "valor": 1092966292.98,
        "delta": -647313727.19
      },
      {
        "periodo": 202603,
        "valor": 1190762512.65,
        "delta": 97796219.67
      },
      {
        "periodo": 202604,
        "valor": 1106174652.49,
        "delta": -84587860.16
      },
      {
        "periodo": 202605,
        "valor": 1116215982.13,
        "delta": 10041329.64
      },
      {
        "periodo": 202606,
        "valor": 1165269868.04,
        "delta": 49053885.91
      },
      {
        "periodo": 202607,
        "valor": 819576482.5,
        "delta": -345693385.54
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": -1481859.0,
    "valor_anterior": 5268130.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -12618376.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -13391855.0,
        "delta": -773479.0
      },
      {
        "periodo": 202509,
        "valor": -10441984.0,
        "delta": 2949871.0
      },
      {
        "periodo": 202510,
        "valor": 9121593.0,
        "delta": 19563577.0
      },
      {
        "periodo": 202511,
        "valor": -21466065.0,
        "delta": -30587658.0
      },
      {
        "periodo": 202512,
        "valor": -30122374.0,
        "delta": -8656309.0
      },
      {
        "periodo": 202601,
        "valor": 5278601.0,
        "delta": 35400975.0
      },
      {
        "periodo": 202602,
        "valor": 502160.0,
        "delta": -4776441.0
      },
      {
        "periodo": 202603,
        "valor": -2784645.0,
        "delta": -3286805.0
      },
      {
        "periodo": 202604,
        "valor": 4952888.0,
        "delta": 7737533.0
      },
      {
        "periodo": 202605,
        "valor": 145395.0,
        "delta": -4807493.0
      },
      {
        "periodo": 202606,
        "valor": 5268130.0,
        "delta": 5122735.0
      },
      {
        "periodo": 202607,
        "valor": -1481859.0,
        "delta": -6749989.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": -485281271.88,
    "valor_anterior": -1354774505.06,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 465715549.28,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 669764236.46,
        "delta": 204048687.18
      },
      {
        "periodo": 202509,
        "valor": 561590585.52,
        "delta": -108173650.94
      },
      {
        "periodo": 202510,
        "valor": 1369173053.48,
        "delta": 807582467.96
      },
      {
        "periodo": 202511,
        "valor": 847468781.03,
        "delta": -521704272.45
      },
      {
        "periodo": 202512,
        "valor": 1412577439.07,
        "delta": 565108658.04
      },
      {
        "periodo": 202601,
        "valor": 791442387.71,
        "delta": -621135051.36
      },
      {
        "periodo": 202602,
        "valor": 748001385.38,
        "delta": -43441002.33
      },
      {
        "periodo": 202603,
        "valor": 989038748.29,
        "delta": 241037362.91
      },
      {
        "periodo": 202604,
        "valor": 465989234.69,
        "delta": -523049513.6
      },
      {
        "periodo": 202605,
        "valor": -1024438303.03,
        "delta": -1490427537.72
      },
      {
        "periodo": 202606,
        "valor": -1354774505.06,
        "delta": -330336202.03
      },
      {
        "periodo": 202607,
        "valor": -485281271.88,
        "delta": 869493233.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 215854947.0,
    "valor_anterior": 90478329.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25130073.99,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55121844.95,
        "delta": 29991770.96
      },
      {
        "periodo": 202509,
        "valor": 297665115.03,
        "delta": 242543270.08
      },
      {
        "periodo": 202510,
        "valor": 97851802.0,
        "delta": -199813313.03
      },
      {
        "periodo": 202511,
        "valor": -18793948.0,
        "delta": -116645750.0
      },
      {
        "periodo": 202512,
        "valor": 167576813.0,
        "delta": 186370761.0
      },
      {
        "periodo": 202601,
        "valor": 157136337.0,
        "delta": -10440476.0
      },
      {
        "periodo": 202602,
        "valor": 128304008.0,
        "delta": -28832329.0
      },
      {
        "periodo": 202603,
        "valor": 247830112.0,
        "delta": 119526104.0
      },
      {
        "periodo": 202604,
        "valor": 120730052.0,
        "delta": -127100060.0
      },
      {
        "periodo": 202605,
        "valor": 113516388.0,
        "delta": -7213664.0
      },
      {
        "periodo": 202606,
        "valor": 90478329.0,
        "delta": -23038059.0
      },
      {
        "periodo": 202607,
        "valor": 215854947.0,
        "delta": 125376618.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 25520159.0,
    "valor_anterior": 45530983.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 341799766.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -60506414.0,
        "delta": -402306180.0
      },
      {
        "periodo": 202509,
        "valor": 126882662.0,
        "delta": 187389076.0
      },
      {
        "periodo": 202510,
        "valor": 101110391.0,
        "delta": -25772271.0
      },
      {
        "periodo": 202511,
        "valor": 43147512.0,
        "delta": -57962879.0
      },
      {
        "periodo": 202512,
        "valor": -56942516.0,
        "delta": -100090028.0
      },
      {
        "periodo": 202601,
        "valor": 98933857.0,
        "delta": 155876373.0
      },
      {
        "periodo": 202602,
        "valor": 164338729.0,
        "delta": 65404872.0
      },
      {
        "periodo": 202603,
        "valor": 2985791.0,
        "delta": -161352938.0
      },
      {
        "periodo": 202604,
        "valor": 80632827.0,
        "delta": 77647036.0
      },
      {
        "periodo": 202605,
        "valor": 111535481.0,
        "delta": 30902654.0
      },
      {
        "periodo": 202606,
        "valor": 45530983.0,
        "delta": -66004498.0
      },
      {
        "periodo": 202607,
        "valor": 25520159.0,
        "delta": -20010824.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 682895594.999999,
    "valor_anterior": 872027829.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 654095262.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 794756777.0,
        "delta": 140661515.0
      },
      {
        "periodo": 202509,
        "valor": 718149943.0,
        "delta": -76606834.0
      },
      {
        "periodo": 202510,
        "valor": 634966493.0,
        "delta": -83183450.0
      },
      {
        "periodo": 202511,
        "valor": 635559580.0,
        "delta": 593087.0
      },
      {
        "periodo": 202512,
        "valor": 708332412.0,
        "delta": 72772832.0
      },
      {
        "periodo": 202601,
        "valor": 903268536.0,
        "delta": 194936124.0
      },
      {
        "periodo": 202602,
        "valor": 793591960.0,
        "delta": -109676576.0
      },
      {
        "periodo": 202603,
        "valor": 717758579.0,
        "delta": -75833381.0
      },
      {
        "periodo": 202604,
        "valor": 497225718.0,
        "delta": -220532861.0
      },
      {
        "periodo": 202605,
        "valor": 738938060.0,
        "delta": 241712342.0
      },
      {
        "periodo": 202606,
        "valor": 872027829.0,
        "delta": 133089769.0
      },
      {
        "periodo": 202607,
        "valor": 682895595.0,
        "delta": -189132234.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 260709565.0,
    "valor_anterior": 359559283.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 121268272.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 133384812.0,
        "delta": 12116540.0
      },
      {
        "periodo": 202509,
        "valor": 142502760.0,
        "delta": 9117948.0
      },
      {
        "periodo": 202510,
        "valor": 301087570.0,
        "delta": 158584810.0
      },
      {
        "periodo": 202511,
        "valor": 187534470.0,
        "delta": -113553100.0
      },
      {
        "periodo": 202512,
        "valor": 157710479.0,
        "delta": -29823991.0
      },
      {
        "periodo": 202601,
        "valor": 167546224.0,
        "delta": 9835745.0
      },
      {
        "periodo": 202602,
        "valor": 127189064.0,
        "delta": -40357160.0
      },
      {
        "periodo": 202603,
        "valor": 160932095.0,
        "delta": 33743031.0
      },
      {
        "periodo": 202604,
        "valor": 171277859.0,
        "delta": 10345764.0
      },
      {
        "periodo": 202605,
        "valor": 245797763.0,
        "delta": 74519904.0
      },
      {
        "periodo": 202606,
        "valor": 359559283.0,
        "delta": 113761520.0
      },
      {
        "periodo": 202607,
        "valor": 260709565.0,
        "delta": -98849718.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 44076768.0,
    "valor_anterior": -35551723.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 56427945.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29959885.0,
        "delta": -26468060.0
      },
      {
        "periodo": 202509,
        "valor": 124665573.0,
        "delta": 94705688.0
      },
      {
        "periodo": 202510,
        "valor": 77737671.0,
        "delta": -46927902.0
      },
      {
        "periodo": 202511,
        "valor": -22239472.0,
        "delta": -99977143.0
      },
      {
        "periodo": 202512,
        "valor": 26724689.0,
        "delta": 48964161.0
      },
      {
        "periodo": 202601,
        "valor": -12791857.0,
        "delta": -39516546.0
      },
      {
        "periodo": 202602,
        "valor": 44050247.0,
        "delta": 56842104.0
      },
      {
        "periodo": 202603,
        "valor": 35751815.0,
        "delta": -8298432.0
      },
      {
        "periodo": 202604,
        "valor": 44319382.0,
        "delta": 8567567.0
      },
      {
        "periodo": 202605,
        "valor": 112675571.0,
        "delta": 68356189.0
      },
      {
        "periodo": 202606,
        "valor": -35551723.0,
        "delta": -148227294.0
      },
      {
        "periodo": 202607,
        "valor": 44076768.0,
        "delta": 79628491.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": -35213025.0,
    "valor_anterior": -302417795.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -402635651.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -244102687.0,
        "delta": 158532964.0
      },
      {
        "periodo": 202509,
        "valor": -168171082.0,
        "delta": 75931605.0
      },
      {
        "periodo": 202510,
        "valor": -80484194.0,
        "delta": 87686888.0
      },
      {
        "periodo": 202511,
        "valor": 32340704.0,
        "delta": 112824898.0
      },
      {
        "periodo": 202512,
        "valor": -209128081.0,
        "delta": -241468785.0
      },
      {
        "periodo": 202601,
        "valor": 51827773.0,
        "delta": 260955854.0
      },
      {
        "periodo": 202602,
        "valor": 97107174.0,
        "delta": 45279401.0
      },
      {
        "periodo": 202603,
        "valor": 34906650.0,
        "delta": -62200524.0
      },
      {
        "periodo": 202604,
        "valor": -38125941.0,
        "delta": -73032591.0
      },
      {
        "periodo": 202605,
        "valor": 5278385.0,
        "delta": 43404326.0
      },
      {
        "periodo": 202606,
        "valor": -302417795.0,
        "delta": -307696180.0
      },
      {
        "periodo": 202607,
        "valor": -35213025.0,
        "delta": 267204770.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 342098144.86000013,
    "valor_anterior": 750642474.5300001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 275764491.85,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 98892938.07,
        "delta": -176871553.78
      },
      {
        "periodo": 202509,
        "valor": 365077608.97,
        "delta": 266184670.9
      },
      {
        "periodo": 202510,
        "valor": 386832468.89,
        "delta": 21754859.92
      },
      {
        "periodo": 202511,
        "valor": 287193380.79,
        "delta": -99639088.1
      },
      {
        "periodo": 202512,
        "valor": 65701768.94,
        "delta": -221491611.85
      },
      {
        "periodo": 202601,
        "valor": -40582947.49,
        "delta": -106284716.43
      },
      {
        "periodo": 202602,
        "valor": 387476800.4,
        "delta": 428059747.89
      },
      {
        "periodo": 202603,
        "valor": -22722077.33,
        "delta": -410198877.73
      },
      {
        "periodo": 202604,
        "valor": 303286942.66,
        "delta": 326009019.99
      },
      {
        "periodo": 202605,
        "valor": 436052292.69,
        "delta": 132765350.03
      },
      {
        "periodo": 202606,
        "valor": 750642474.53,
        "delta": 314590181.84
      },
      {
        "periodo": 202607,
        "valor": 342098144.86,
        "delta": -408544329.67
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": -88362564.0,
    "valor_anterior": -101736036.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -144807012.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -108170701.0,
        "delta": 36636311.0
      },
      {
        "periodo": 202509,
        "valor": -104294712.0,
        "delta": 3875989.0
      },
      {
        "periodo": 202510,
        "valor": -115328912.0,
        "delta": -11034200.0
      },
      {
        "periodo": 202511,
        "valor": -133179395.0,
        "delta": -17850483.0
      },
      {
        "periodo": 202512,
        "valor": -103901681.0,
        "delta": 29277714.0
      },
      {
        "periodo": 202601,
        "valor": -90198994.0,
        "delta": 13702687.0
      },
      {
        "periodo": 202602,
        "valor": -120006549.0,
        "delta": -29807555.0
      },
      {
        "periodo": 202603,
        "valor": -104601971.0,
        "delta": 15404578.0
      },
      {
        "periodo": 202604,
        "valor": -84551126.0,
        "delta": 20050845.0
      },
      {
        "periodo": 202605,
        "valor": -75743284.0,
        "delta": 8807842.0
      },
      {
        "periodo": 202606,
        "valor": -101736036.0,
        "delta": -25992752.0
      },
      {
        "periodo": 202607,
        "valor": -88362564.0,
        "delta": 13373472.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 3008307.0,
    "valor_anterior": 2994909.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4253055.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12654947.0,
        "delta": 8401892.0
      },
      {
        "periodo": 202509,
        "valor": 17664296.0,
        "delta": 5009349.0
      },
      {
        "periodo": 202510,
        "valor": 11312998.0,
        "delta": -6351298.0
      },
      {
        "periodo": 202511,
        "valor": 220570.0,
        "delta": -11092428.0
      },
      {
        "periodo": 202512,
        "valor": -2643427.0,
        "delta": -2863997.0
      },
      {
        "periodo": 202601,
        "valor": 2728717.0,
        "delta": 5372144.0
      },
      {
        "periodo": 202602,
        "valor": 4576380.0,
        "delta": 1847663.0
      },
      {
        "periodo": 202603,
        "valor": 10030429.0,
        "delta": 5454049.0
      },
      {
        "periodo": 202604,
        "valor": 7836337.0,
        "delta": -2194092.0
      },
      {
        "periodo": 202605,
        "valor": 11278403.0,
        "delta": 3442066.0
      },
      {
        "periodo": 202606,
        "valor": 2994909.0,
        "delta": -8283494.0
      },
      {
        "periodo": 202607,
        "valor": 3008307.0,
        "delta": 13398.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 84661552.0,
    "valor_anterior": 186696778.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 160079603.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 177841109.0,
        "delta": 17761506.0
      },
      {
        "periodo": 202509,
        "valor": 187603796.0,
        "delta": 9762687.0
      },
      {
        "periodo": 202510,
        "valor": 148907449.0,
        "delta": -38696347.0
      },
      {
        "periodo": 202511,
        "valor": 206637786.0,
        "delta": 57730337.0
      },
      {
        "periodo": 202512,
        "valor": 133592607.0,
        "delta": -73045179.0
      },
      {
        "periodo": 202601,
        "valor": 161524714.0,
        "delta": 27932107.0
      },
      {
        "periodo": 202602,
        "valor": 214331822.0,
        "delta": 52807108.0
      },
      {
        "periodo": 202603,
        "valor": 222892833.0,
        "delta": 8561011.0
      },
      {
        "periodo": 202604,
        "valor": 201775202.0,
        "delta": -21117631.0
      },
      {
        "periodo": 202605,
        "valor": 161931435.0,
        "delta": -39843767.0
      },
      {
        "periodo": 202606,
        "valor": 186696778.0,
        "delta": 24765343.0
      },
      {
        "periodo": 202607,
        "valor": 84661552.0,
        "delta": -102035226.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 45980860.0,
    "valor_anterior": 92131394.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 67663606.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23808791.0,
        "delta": -43854815.0
      },
      {
        "periodo": 202509,
        "valor": 75812277.0,
        "delta": 52003486.0
      },
      {
        "periodo": 202510,
        "valor": 1742517.0,
        "delta": -74069760.0
      },
      {
        "periodo": 202511,
        "valor": 4949288.0,
        "delta": 3206771.0
      },
      {
        "periodo": 202512,
        "valor": 62364738.0,
        "delta": 57415450.0
      },
      {
        "periodo": 202601,
        "valor": 34378939.0,
        "delta": -27985799.0
      },
      {
        "periodo": 202602,
        "valor": 79591346.0,
        "delta": 45212407.0
      },
      {
        "periodo": 202603,
        "valor": 54818526.0,
        "delta": -24772820.0
      },
      {
        "periodo": 202604,
        "valor": 63325936.0,
        "delta": 8507410.0
      },
      {
        "periodo": 202605,
        "valor": 13325588.0,
        "delta": -50000348.0
      },
      {
        "periodo": 202606,
        "valor": 92131394.0,
        "delta": 78805806.0
      },
      {
        "periodo": 202607,
        "valor": 45980860.0,
        "delta": -46150534.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1172419121.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1017764920.0,
        "delta": 154654201.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 213126370.0,
    "valor_anterior": 196411609.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 143929883.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 234533529.0,
        "delta": 90603646.0
      },
      {
        "periodo": 202509,
        "valor": 174489134.0,
        "delta": -60044395.0
      },
      {
        "periodo": 202510,
        "valor": 275134396.0,
        "delta": 100645262.0
      },
      {
        "periodo": 202511,
        "valor": 125929595.0,
        "delta": -149204801.0
      },
      {
        "periodo": 202512,
        "valor": 363667226.0,
        "delta": 237737631.0
      },
      {
        "periodo": 202601,
        "valor": 137358807.0,
        "delta": -226308419.0
      },
      {
        "periodo": 202602,
        "valor": 163688570.0,
        "delta": 26329763.0
      },
      {
        "periodo": 202603,
        "valor": 231478607.0,
        "delta": 67790037.0
      },
      {
        "periodo": 202604,
        "valor": 225107935.0,
        "delta": -6370672.0
      },
      {
        "periodo": 202605,
        "valor": 177933179.0,
        "delta": -47174756.0
      },
      {
        "periodo": 202606,
        "valor": 196411609.0,
        "delta": 18478430.0
      },
      {
        "periodo": 202607,
        "valor": 213126370.0,
        "delta": 16714761.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": -66664527.0,
    "valor_anterior": 190932302.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22464901.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 67510052.0,
        "delta": 45045151.0
      },
      {
        "periodo": 202509,
        "valor": -7654860.0,
        "delta": -75164912.0
      },
      {
        "periodo": 202510,
        "valor": -16819170.0,
        "delta": -9164310.0
      },
      {
        "periodo": 202511,
        "valor": -38088182.0,
        "delta": -21269012.0
      },
      {
        "periodo": 202512,
        "valor": 21897454.0,
        "delta": 59985636.0
      },
      {
        "periodo": 202601,
        "valor": 6560343.0,
        "delta": -15337111.0
      },
      {
        "periodo": 202602,
        "valor": 8019992.0,
        "delta": 1459649.0
      },
      {
        "periodo": 202603,
        "valor": 15559508.0,
        "delta": 7539516.0
      },
      {
        "periodo": 202604,
        "valor": -120542225.0,
        "delta": -136101733.0
      },
      {
        "periodo": 202605,
        "valor": -35267629.0,
        "delta": 85274596.0
      },
      {
        "periodo": 202606,
        "valor": 190932302.0,
        "delta": 226199931.0
      },
      {
        "periodo": 202607,
        "valor": -66664527.0,
        "delta": -257596829.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 3585915.0,
    "valor_anterior": 1999842.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -6331452.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -8814540.0,
        "delta": -2483088.0
      },
      {
        "periodo": 202509,
        "valor": -4929790.0,
        "delta": 3884750.0
      },
      {
        "periodo": 202510,
        "valor": -6800463.0,
        "delta": -1870673.0
      },
      {
        "periodo": 202511,
        "valor": 12222225.0,
        "delta": 19022688.0
      },
      {
        "periodo": 202512,
        "valor": 4963514.0,
        "delta": -7258711.0
      },
      {
        "periodo": 202601,
        "valor": -6697490.0,
        "delta": -11661004.0
      },
      {
        "periodo": 202602,
        "valor": 798398.0,
        "delta": 7495888.0
      },
      {
        "periodo": 202603,
        "valor": 754580.0,
        "delta": -43818.0
      },
      {
        "periodo": 202604,
        "valor": -3856228.0,
        "delta": -4610808.0
      },
      {
        "periodo": 202605,
        "valor": 2094074.0,
        "delta": 5950302.0
      },
      {
        "periodo": 202606,
        "valor": 1999842.0,
        "delta": -94232.0
      },
      {
        "periodo": 202607,
        "valor": 3585915.0,
        "delta": 1586073.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": -11014470.0,
    "valor_anterior": -13143475.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -6851038.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -9453915.0,
        "delta": -2602877.0
      },
      {
        "periodo": 202509,
        "valor": -8009743.0,
        "delta": 1444172.0
      },
      {
        "periodo": 202510,
        "valor": -9963533.0,
        "delta": -1953790.0
      },
      {
        "periodo": 202511,
        "valor": -6304887.0,
        "delta": 3658646.0
      },
      {
        "periodo": 202512,
        "valor": -8580738.0,
        "delta": -2275851.0
      },
      {
        "periodo": 202601,
        "valor": -5821287.0,
        "delta": 2759451.0
      },
      {
        "periodo": 202602,
        "valor": -5836983.0,
        "delta": -15696.0
      },
      {
        "periodo": 202603,
        "valor": -6860023.0,
        "delta": -1023040.0
      },
      {
        "periodo": 202604,
        "valor": -8428720.0,
        "delta": -1568697.0
      },
      {
        "periodo": 202605,
        "valor": -11800860.0,
        "delta": -3372140.0
      },
      {
        "periodo": 202606,
        "valor": -13143475.0,
        "delta": -1342615.0
      },
      {
        "periodo": 202607,
        "valor": -11014470.0,
        "delta": 2129005.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 20058222.930000007,
    "valor_anterior": 20954401.479999997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2955394.43,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 817579.88,
        "delta": 3772974.31
      },
      {
        "periodo": 202509,
        "valor": 16120292.55,
        "delta": 15302712.67
      },
      {
        "periodo": 202510,
        "valor": 17548237.18,
        "delta": 1427944.63
      },
      {
        "periodo": 202511,
        "valor": 19919272.35,
        "delta": 2371035.17
      },
      {
        "periodo": 202512,
        "valor": 33088812.96,
        "delta": 13169540.61
      },
      {
        "periodo": 202601,
        "valor": 5488202.02,
        "delta": -27600610.94
      },
      {
        "periodo": 202602,
        "valor": 7275714.95,
        "delta": 1787512.93
      },
      {
        "periodo": 202603,
        "valor": 3796752.47,
        "delta": -3478962.48
      },
      {
        "periodo": 202604,
        "valor": 10719646.35,
        "delta": 6922893.88
      },
      {
        "periodo": 202605,
        "valor": 10672210.64,
        "delta": -47435.71
      },
      {
        "periodo": 202606,
        "valor": 20954401.48,
        "delta": 10282190.84
      },
      {
        "periodo": 202607,
        "valor": 20058222.93,
        "delta": -896178.55
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": -31853.0,
    "valor_anterior": 1358029.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -11677587.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -5673474.0,
        "delta": 6004113.0
      },
      {
        "periodo": 202509,
        "valor": -8612733.0,
        "delta": -2939259.0
      },
      {
        "periodo": 202510,
        "valor": -7100955.0,
        "delta": 1511778.0
      },
      {
        "periodo": 202511,
        "valor": -8557755.0,
        "delta": -1456800.0
      },
      {
        "periodo": 202512,
        "valor": 2026324.0,
        "delta": 10584079.0
      },
      {
        "periodo": 202601,
        "valor": 745817.0,
        "delta": -1280507.0
      },
      {
        "periodo": 202602,
        "valor": 1672830.0,
        "delta": 927013.0
      },
      {
        "periodo": 202603,
        "valor": 786497.0,
        "delta": -886333.0
      },
      {
        "periodo": 202604,
        "valor": -525070.0,
        "delta": -1311567.0
      },
      {
        "periodo": 202605,
        "valor": -965236.0,
        "delta": -440166.0
      },
      {
        "periodo": 202606,
        "valor": 1358029.0,
        "delta": 2323265.0
      },
      {
        "periodo": 202607,
        "valor": -31853.0,
        "delta": -1389882.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 135446800.11,
    "valor_anterior": 80555854.83000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 136506634.13,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 130055525.91,
        "delta": -6451108.22
      },
      {
        "periodo": 202509,
        "valor": 22721640.62,
        "delta": -107333885.29
      },
      {
        "periodo": 202510,
        "valor": 188588339.22,
        "delta": 165866698.6
      },
      {
        "periodo": 202511,
        "valor": 126059960.1,
        "delta": -62528379.12
      },
      {
        "periodo": 202512,
        "valor": 138349918.17,
        "delta": 12289958.07
      },
      {
        "periodo": 202601,
        "valor": 130405603.33,
        "delta": -7944314.84
      },
      {
        "periodo": 202602,
        "valor": 94104804.7,
        "delta": -36300798.63
      },
      {
        "periodo": 202603,
        "valor": 29487504.05,
        "delta": -64617300.65
      },
      {
        "periodo": 202604,
        "valor": 136928787.4,
        "delta": 107441283.35
      },
      {
        "periodo": 202605,
        "valor": 149546772.82,
        "delta": 12617985.42
      },
      {
        "periodo": 202606,
        "valor": 80555854.83,
        "delta": -68990917.99
      },
      {
        "periodo": 202607,
        "valor": 135446800.11,
        "delta": 54890945.28
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 19895271.529999994,
    "valor_anterior": 14589941.61,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7232600.09,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1467718.59,
        "delta": -5764881.5
      },
      {
        "periodo": 202509,
        "valor": -3648810.66,
        "delta": -5116529.25
      },
      {
        "periodo": 202510,
        "valor": 2582575.04,
        "delta": 6231385.7
      },
      {
        "periodo": 202511,
        "valor": 2898256.79,
        "delta": 315681.75
      },
      {
        "periodo": 202512,
        "valor": -3051027.72,
        "delta": -5949284.51
      },
      {
        "periodo": 202601,
        "valor": 9032740.3,
        "delta": 12083768.02
      },
      {
        "periodo": 202602,
        "valor": 9548711.96,
        "delta": 515971.66
      },
      {
        "periodo": 202603,
        "valor": 9000715.75,
        "delta": -547996.21
      },
      {
        "periodo": 202604,
        "valor": 8792813.02,
        "delta": -207902.73
      },
      {
        "periodo": 202605,
        "valor": 12866467.24,
        "delta": 4073654.22
      },
      {
        "periodo": 202606,
        "valor": 14589941.61,
        "delta": 1723474.37
      },
      {
        "periodo": 202607,
        "valor": 19895271.53,
        "delta": 5305329.92
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": -8888021.0,
    "valor_anterior": 19273930.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 24105838.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25831750.0,
        "delta": 1725912.0
      },
      {
        "periodo": 202509,
        "valor": 36439123.0,
        "delta": 10607373.0
      },
      {
        "periodo": 202510,
        "valor": 32722536.0,
        "delta": -3716587.0
      },
      {
        "periodo": 202511,
        "valor": 24963254.0,
        "delta": -7759282.0
      },
      {
        "periodo": 202512,
        "valor": 12532318.0,
        "delta": -12430936.0
      },
      {
        "periodo": 202601,
        "valor": 28046714.0,
        "delta": 15514396.0
      },
      {
        "periodo": 202602,
        "valor": 32880687.0,
        "delta": 4833973.0
      },
      {
        "periodo": 202603,
        "valor": -4182359.0,
        "delta": -37063046.0
      },
      {
        "periodo": 202604,
        "valor": -15053834.0,
        "delta": -10871475.0
      },
      {
        "periodo": 202605,
        "valor": 34376028.0,
        "delta": 49429862.0
      },
      {
        "periodo": 202606,
        "valor": 19273930.0,
        "delta": -15102098.0
      },
      {
        "periodo": 202607,
        "valor": -8888021.0,
        "delta": -28161951.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 170193930.0,
    "valor_anterior": 204728782.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 67836655.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 201507267.0,
        "delta": 133670612.0
      },
      {
        "periodo": 202509,
        "valor": 123108154.0,
        "delta": -78399113.0
      },
      {
        "periodo": 202510,
        "valor": 148086596.0,
        "delta": 24978442.0
      },
      {
        "periodo": 202511,
        "valor": 136454586.0,
        "delta": -11632010.0
      },
      {
        "periodo": 202512,
        "valor": 65159237.0,
        "delta": -71295349.0
      },
      {
        "periodo": 202601,
        "valor": 116367970.0,
        "delta": 51208733.0
      },
      {
        "periodo": 202602,
        "valor": 92249483.0,
        "delta": -24118487.0
      },
      {
        "periodo": 202603,
        "valor": 145223416.0,
        "delta": 52973933.0
      },
      {
        "periodo": 202604,
        "valor": 146789005.0,
        "delta": 1565589.0
      },
      {
        "periodo": 202605,
        "valor": 179780767.0,
        "delta": 32991762.0
      },
      {
        "periodo": 202606,
        "valor": 204728782.0,
        "delta": 24948015.0
      },
      {
        "periodo": 202607,
        "valor": 170193930.0,
        "delta": -34534852.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 19148620.0,
    "valor_anterior": 4311836.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2433354.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16535136.0,
        "delta": 14101782.0
      },
      {
        "periodo": 202509,
        "valor": 8222172.0,
        "delta": -8312964.0
      },
      {
        "periodo": 202510,
        "valor": 11564275.0,
        "delta": 3342103.0
      },
      {
        "periodo": 202511,
        "valor": 11176276.0,
        "delta": -387999.0
      },
      {
        "periodo": 202512,
        "valor": 3359803.0,
        "delta": -7816473.0
      },
      {
        "periodo": 202601,
        "valor": 8255819.0,
        "delta": 4896016.0
      },
      {
        "periodo": 202602,
        "valor": 8107789.0,
        "delta": -148030.0
      },
      {
        "periodo": 202603,
        "valor": 15188214.0,
        "delta": 7080425.0
      },
      {
        "periodo": 202604,
        "valor": 8758719.0,
        "delta": -6429495.0
      },
      {
        "periodo": 202605,
        "valor": 10588893.0,
        "delta": 1830174.0
      },
      {
        "periodo": 202606,
        "valor": 4311836.0,
        "delta": -6277057.0
      },
      {
        "periodo": 202607,
        "valor": 19148620.0,
        "delta": 14836784.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 23497668.75999999,
    "valor_anterior": 23518425.550000012,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 36057940.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 35884350.65,
        "delta": -173590.07
      },
      {
        "periodo": 202509,
        "valor": 81327576.2,
        "delta": 45443225.55
      },
      {
        "periodo": 202510,
        "valor": 35188645.32,
        "delta": -46138930.88
      },
      {
        "periodo": 202511,
        "valor": 47876318.43,
        "delta": 12687673.11
      },
      {
        "periodo": 202512,
        "valor": 16027224.87,
        "delta": -31849093.56
      },
      {
        "periodo": 202601,
        "valor": 36358099.04,
        "delta": 20330874.17
      },
      {
        "periodo": 202602,
        "valor": 21819208.45,
        "delta": -14538890.59
      },
      {
        "periodo": 202603,
        "valor": 23300887.71,
        "delta": 1481679.26
      },
      {
        "periodo": 202604,
        "valor": 18382501.89,
        "delta": -4918385.82
      },
      {
        "periodo": 202605,
        "valor": 22300693.97,
        "delta": 3918192.08
      },
      {
        "periodo": 202606,
        "valor": 23518425.55,
        "delta": 1217731.58
      },
      {
        "periodo": 202607,
        "valor": 23497668.76,
        "delta": -20756.79
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 6889676.539999999,
    "valor_anterior": 6504298.039999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19936354.75,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28322598.61,
        "delta": 8386243.86
      },
      {
        "periodo": 202509,
        "valor": 7320453.96,
        "delta": -21002144.65
      },
      {
        "periodo": 202510,
        "valor": 10283121.22,
        "delta": 2962667.26
      },
      {
        "periodo": 202511,
        "valor": -2035108.22,
        "delta": -12318229.44
      },
      {
        "periodo": 202512,
        "valor": 8793353.25,
        "delta": 10828461.47
      },
      {
        "periodo": 202601,
        "valor": 6879981.62,
        "delta": -1913371.63
      },
      {
        "periodo": 202602,
        "valor": -6986306.12,
        "delta": -13866287.74
      },
      {
        "periodo": 202603,
        "valor": 17847791.31,
        "delta": 24834097.43
      },
      {
        "periodo": 202604,
        "valor": 7349781.58,
        "delta": -10498009.73
      },
      {
        "periodo": 202605,
        "valor": 3615885.04,
        "delta": -3733896.54
      },
      {
        "periodo": 202606,
        "valor": 6504298.04,
        "delta": 2888413.0
      },
      {
        "periodo": 202607,
        "valor": 6889676.54,
        "delta": 385378.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 36245994.0,
    "valor_anterior": 42871634.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40669951.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 38416632.0,
        "delta": -2253319.0
      },
      {
        "periodo": 202509,
        "valor": 37577865.0,
        "delta": -838767.0
      },
      {
        "periodo": 202510,
        "valor": 36202108.0,
        "delta": -1375757.0
      },
      {
        "periodo": 202511,
        "valor": 39834964.0,
        "delta": 3632856.0
      },
      {
        "periodo": 202512,
        "valor": 21369767.0,
        "delta": -18465197.0
      },
      {
        "periodo": 202601,
        "valor": 35038319.0,
        "delta": 13668552.0
      },
      {
        "periodo": 202602,
        "valor": 32682237.0,
        "delta": -2356082.0
      },
      {
        "periodo": 202603,
        "valor": 35463571.0,
        "delta": 2781334.0
      },
      {
        "periodo": 202604,
        "valor": 34843758.0,
        "delta": -619813.0
      },
      {
        "periodo": 202605,
        "valor": 32065274.0,
        "delta": -2778484.0
      },
      {
        "periodo": 202606,
        "valor": 42871634.0,
        "delta": 10806360.0
      },
      {
        "periodo": 202607,
        "valor": 36245994.0,
        "delta": -6625640.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 2469330.0,
    "valor_anterior": 4308163.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2901095.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4107502.0,
        "delta": 1206407.0
      },
      {
        "periodo": 202509,
        "valor": 4214856.0,
        "delta": 107354.0
      },
      {
        "periodo": 202510,
        "valor": 5714361.0,
        "delta": 1499505.0
      },
      {
        "periodo": 202511,
        "valor": -332213.0,
        "delta": -6046574.0
      },
      {
        "periodo": 202512,
        "valor": 2006687.0,
        "delta": 2338900.0
      },
      {
        "periodo": 202601,
        "valor": 1923823.0,
        "delta": -82864.0
      },
      {
        "periodo": 202602,
        "valor": 3061869.0,
        "delta": 1138046.0
      },
      {
        "periodo": 202603,
        "valor": 6608093.0,
        "delta": 3546224.0
      },
      {
        "periodo": 202604,
        "valor": 1275396.0,
        "delta": -5332697.0
      },
      {
        "periodo": 202605,
        "valor": 6047929.0,
        "delta": 4772533.0
      },
      {
        "periodo": 202606,
        "valor": 4308163.0,
        "delta": -1739766.0
      },
      {
        "periodo": 202607,
        "valor": 2469330.0,
        "delta": -1838833.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": -40638522.0,
    "valor_anterior": 102273721.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12177579.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12501059.0,
        "delta": 323480.0
      },
      {
        "periodo": 202509,
        "valor": 58590031.0,
        "delta": 46088972.0
      },
      {
        "periodo": 202510,
        "valor": 8560155.0,
        "delta": -50029876.0
      },
      {
        "periodo": 202511,
        "valor": 3918694.0,
        "delta": -4641461.0
      },
      {
        "periodo": 202512,
        "valor": 56651673.0,
        "delta": 52732979.0
      },
      {
        "periodo": 202601,
        "valor": 12659503.0,
        "delta": -43992170.0
      },
      {
        "periodo": 202602,
        "valor": 9243645.0,
        "delta": -3415858.0
      },
      {
        "periodo": 202603,
        "valor": 38386915.0,
        "delta": 29143270.0
      },
      {
        "periodo": 202604,
        "valor": -32102796.0,
        "delta": -70489711.0
      },
      {
        "periodo": 202605,
        "valor": 24955747.0,
        "delta": 57058543.0
      },
      {
        "periodo": 202606,
        "valor": 102273721.0,
        "delta": 77317974.0
      },
      {
        "periodo": 202607,
        "valor": -40638522.0,
        "delta": -142912243.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": -64626373.67000002,
    "valor_anterior": -61519890.589999974,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -74707247.28,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -75386771.42,
        "delta": -679524.14
      },
      {
        "periodo": 202509,
        "valor": -61244019.65,
        "delta": 14142751.77
      },
      {
        "periodo": 202510,
        "valor": -60161697.47,
        "delta": 1082322.18
      },
      {
        "periodo": 202511,
        "valor": -63676384.04,
        "delta": -3514686.57
      },
      {
        "periodo": 202512,
        "valor": -46836769.6,
        "delta": 16839614.44
      },
      {
        "periodo": 202601,
        "valor": -77360361.65,
        "delta": -30523592.05
      },
      {
        "periodo": 202602,
        "valor": -65665130.0,
        "delta": 11695231.65
      },
      {
        "periodo": 202603,
        "valor": -63462056.3,
        "delta": 2203073.7
      },
      {
        "periodo": 202604,
        "valor": -64489533.22,
        "delta": -1027476.92
      },
      {
        "periodo": 202605,
        "valor": -65620659.33,
        "delta": -1131126.11
      },
      {
        "periodo": 202606,
        "valor": -61519890.59,
        "delta": 4100768.74
      },
      {
        "periodo": 202607,
        "valor": -64626373.67,
        "delta": -3106483.08
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 21314216.27000001,
    "valor_anterior": 50594388.74000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2180054.96,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4383862.74,
        "delta": 2203807.78
      },
      {
        "periodo": 202509,
        "valor": 2918888.12,
        "delta": -1464974.62
      },
      {
        "periodo": 202510,
        "valor": 191897.42,
        "delta": -2726990.7
      },
      {
        "periodo": 202511,
        "valor": 515773.0,
        "delta": 323875.58
      },
      {
        "periodo": 202512,
        "valor": 2588556.41,
        "delta": 2072783.41
      },
      {
        "periodo": 202601,
        "valor": 4332697.16,
        "delta": 1744140.75
      },
      {
        "periodo": 202602,
        "valor": 57657084.93,
        "delta": 53324387.77
      },
      {
        "periodo": 202603,
        "valor": 46567633.62,
        "delta": -11089451.31
      },
      {
        "periodo": 202604,
        "valor": 11422544.94,
        "delta": -35145088.68
      },
      {
        "periodo": 202605,
        "valor": 26692874.11,
        "delta": 15270329.17
      },
      {
        "periodo": 202606,
        "valor": 50594388.74,
        "delta": 23901514.63
      },
      {
        "periodo": 202607,
        "valor": 21314216.27,
        "delta": -29280172.47
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": -293076027.0,
    "valor_anterior": -294307827.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -144448776.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -181024178.0,
        "delta": -36575402.0
      },
      {
        "periodo": 202509,
        "valor": -202366956.0,
        "delta": -21342778.0
      },
      {
        "periodo": 202510,
        "valor": -253491145.0,
        "delta": -51124189.0
      },
      {
        "periodo": 202511,
        "valor": -249454214.0,
        "delta": 4036931.0
      },
      {
        "periodo": 202512,
        "valor": -288054991.0,
        "delta": -38600777.0
      },
      {
        "periodo": 202601,
        "valor": -273821982.0,
        "delta": 14233009.0
      },
      {
        "periodo": 202602,
        "valor": -267460060.0,
        "delta": 6361922.0
      },
      {
        "periodo": 202603,
        "valor": -274551457.0,
        "delta": -7091397.0
      },
      {
        "periodo": 202604,
        "valor": -280203990.0,
        "delta": -5652533.0
      },
      {
        "periodo": 202605,
        "valor": -306366735.0,
        "delta": -26162745.0
      },
      {
        "periodo": 202606,
        "valor": -294307827.0,
        "delta": 12058908.0
      },
      {
        "periodo": 202607,
        "valor": -293076027.0,
        "delta": 1231800.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": -85113920.13,
    "valor_anterior": -80654242.29000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": -271040998.9,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": -29046783.95,
        "delta": 241994214.95
      },
      {
        "periodo": 202601,
        "valor": -29983714.4,
        "delta": -936930.45
      },
      {
        "periodo": 202602,
        "valor": -48053013.59,
        "delta": -18069299.19
      },
      {
        "periodo": 202603,
        "valor": -74949599.49,
        "delta": -26896585.9
      },
      {
        "periodo": 202604,
        "valor": -64993164.94,
        "delta": 9956434.55
      },
      {
        "periodo": 202605,
        "valor": -73870315.6,
        "delta": -8877150.66
      },
      {
        "periodo": 202606,
        "valor": -80654242.29,
        "delta": -6783926.69
      },
      {
        "periodo": 202607,
        "valor": -85113920.13,
        "delta": -4459677.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": -398899574.0,
    "valor_anterior": -493031456.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": -752834492.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": -418035777.0,
        "delta": 334798715.0
      },
      {
        "periodo": 202605,
        "valor": -504518618.0,
        "delta": -86482841.0
      },
      {
        "periodo": 202606,
        "valor": -493031456.0,
        "delta": 11487162.0
      },
      {
        "periodo": 202607,
        "valor": -398899574.0,
        "delta": 94131882.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 35787396673.44998,
    "valor_anterior": 34499630574.620026,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 33804017426.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 34322032413.07,
        "delta": 518014986.78
      },
      {
        "periodo": 202509,
        "valor": 34988037123.45,
        "delta": 666004710.38
      },
      {
        "periodo": 202510,
        "valor": 35539001418.65,
        "delta": 550964295.2
      },
      {
        "periodo": 202511,
        "valor": 35507017298.04,
        "delta": -31984120.61
      },
      {
        "periodo": 202512,
        "valor": 38214528667.8,
        "delta": 2707511369.76
      },
      {
        "periodo": 202601,
        "valor": 39227168356.72,
        "delta": 1012639688.92
      },
      {
        "periodo": 202602,
        "valor": 29147986707.55,
        "delta": -10079181649.17
      },
      {
        "periodo": 202603,
        "valor": 44836943499.06,
        "delta": 15688956791.51
      },
      {
        "periodo": 202604,
        "valor": 33759578223.35,
        "delta": -11077365275.71
      },
      {
        "periodo": 202605,
        "valor": 30106604602.09,
        "delta": -3652973621.26
      },
      {
        "periodo": 202606,
        "valor": 34499630574.62,
        "delta": 4393025972.53
      },
      {
        "periodo": 202607,
        "valor": 35787396673.45,
        "delta": 1287766098.83
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 30311201406.450012,
    "valor_anterior": 28983664055.01001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28476248344.95,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 27460879626.98,
        "delta": -1015368717.97
      },
      {
        "periodo": 202509,
        "valor": 24646910087.89,
        "delta": -2813969539.09
      },
      {
        "periodo": 202510,
        "valor": 26450444455.49,
        "delta": 1803534367.6
      },
      {
        "periodo": 202511,
        "valor": 29333050631.71,
        "delta": 2882606176.22
      },
      {
        "periodo": 202512,
        "valor": 29595249523.97,
        "delta": 262198892.26
      },
      {
        "periodo": 202601,
        "valor": 31380216127.96,
        "delta": 1784966603.99
      },
      {
        "periodo": 202602,
        "valor": 22186717993.88,
        "delta": -9193498134.08
      },
      {
        "periodo": 202603,
        "valor": 38274642758.91,
        "delta": 16087924765.03
      },
      {
        "periodo": 202604,
        "valor": 27361592882.73,
        "delta": -10913049876.18
      },
      {
        "periodo": 202605,
        "valor": 24857821214.98,
        "delta": -2503771667.75
      },
      {
        "periodo": 202606,
        "valor": 28983664055.01,
        "delta": 4125842840.03
      },
      {
        "periodo": 202607,
        "valor": 30311201406.45,
        "delta": 1327537351.44
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 632062001.02,
    "valor_anterior": 410870676.6700001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1091802631.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -542199367.47,
        "delta": 549603263.95
      },
      {
        "periodo": 202509,
        "valor": 2306162289.19,
        "delta": 2848361656.66
      },
      {
        "periodo": 202510,
        "valor": 786939639.2,
        "delta": -1519222649.99
      },
      {
        "periodo": 202511,
        "valor": 518047536.46,
        "delta": -268892102.74
      },
      {
        "periodo": 202512,
        "valor": 745765582.25,
        "delta": 227718045.79
      },
      {
        "periodo": 202601,
        "valor": 769202676.89,
        "delta": 23437094.64
      },
      {
        "periodo": 202602,
        "valor": 640365222.97,
        "delta": -128837453.92
      },
      {
        "periodo": 202603,
        "valor": 306444249.02,
        "delta": -333920973.95
      },
      {
        "periodo": 202604,
        "valor": 436240252.55,
        "delta": 129796003.53
      },
      {
        "periodo": 202605,
        "valor": 670957695.71,
        "delta": 234717443.16
      },
      {
        "periodo": 202606,
        "valor": 410870676.67,
        "delta": -260087019.04
      },
      {
        "periodo": 202607,
        "valor": 632062001.02,
        "delta": 221191324.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 1934371495.5,
    "valor_anterior": 2246913153.039999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2408596185.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2785895801.54,
        "delta": 377299616.15
      },
      {
        "periodo": 202509,
        "valor": 3240834938.73,
        "delta": 454939137.19
      },
      {
        "periodo": 202510,
        "valor": 2833897439.36,
        "delta": -406937499.37
      },
      {
        "periodo": 202511,
        "valor": 1379538872.73,
        "delta": -1454358566.63
      },
      {
        "periodo": 202512,
        "valor": 2906044585.71,
        "delta": 1526505712.98
      },
      {
        "periodo": 202601,
        "valor": 2689854440.17,
        "delta": -216190145.54
      },
      {
        "periodo": 202602,
        "valor": 2076052178.98,
        "delta": -613802261.19
      },
      {
        "periodo": 202603,
        "valor": 2465145351.65,
        "delta": 389093172.67
      },
      {
        "periodo": 202604,
        "valor": 2400711635.49,
        "delta": -64433716.16
      },
      {
        "periodo": 202605,
        "valor": 2035284764.13,
        "delta": -365426871.36
      },
      {
        "periodo": 202606,
        "valor": 2246913153.04,
        "delta": 211628388.91
      },
      {
        "periodo": 202607,
        "valor": 1934371495.5,
        "delta": -312541657.54
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 2605510033.16,
    "valor_anterior": 2744015055.0600014,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2284017910.31,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2613521495.58,
        "delta": 329503585.27
      },
      {
        "periodo": 202509,
        "valor": 2506468975.98,
        "delta": -107052519.6
      },
      {
        "periodo": 202510,
        "valor": 2773982339.3,
        "delta": 267513363.32
      },
      {
        "periodo": 202511,
        "valor": 2740125452.81,
        "delta": -33856886.49
      },
      {
        "periodo": 202512,
        "valor": 2485743385.47,
        "delta": -254382067.34
      },
      {
        "periodo": 202601,
        "valor": 2496594811.06,
        "delta": 10851425.59
      },
      {
        "periodo": 202602,
        "valor": 1973558398.66,
        "delta": -523036412.4
      },
      {
        "periodo": 202603,
        "valor": 2568260716.4,
        "delta": 594702317.74
      },
      {
        "periodo": 202604,
        "valor": 2578498435.21,
        "delta": 10237718.81
      },
      {
        "periodo": 202605,
        "valor": 2656151417.72,
        "delta": 77652982.51
      },
      {
        "periodo": 202606,
        "valor": 2744015055.06,
        "delta": 87863637.34
      },
      {
        "periodo": 202607,
        "valor": 2605510033.16,
        "delta": -138505021.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": 465313005.87000036,
    "valor_anterior": 459506166.51,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 327466111.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 500352006.59,
        "delta": 172885895.34
      },
      {
        "periodo": 202509,
        "valor": 648128451.7,
        "delta": 147776445.11
      },
      {
        "periodo": 202510,
        "valor": 475540041.98,
        "delta": -172588409.72
      },
      {
        "periodo": 202511,
        "valor": 144406699.45,
        "delta": -331133342.53
      },
      {
        "periodo": 202512,
        "valor": 469087351.53,
        "delta": 324680652.08
      },
      {
        "periodo": 202601,
        "valor": 423923319.31,
        "delta": -45164032.22
      },
      {
        "periodo": 202602,
        "valor": 377657700.94,
        "delta": -46265618.37
      },
      {
        "periodo": 202603,
        "valor": 386753808.29,
        "delta": 9096107.35
      },
      {
        "periodo": 202604,
        "valor": 275660624.24,
        "delta": -111093184.05
      },
      {
        "periodo": 202605,
        "valor": 496064750.71,
        "delta": 220404126.47
      },
      {
        "periodo": 202606,
        "valor": 459506166.51,
        "delta": -36558584.2
      },
      {
        "periodo": 202607,
        "valor": 465313005.87,
        "delta": 5806839.36
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100174,
    "label": "Resultado Antes de Impuestos",
    "valor_actual": -161061268.5500002,
    "valor_anterior": -345338531.6700001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1399491505.81,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1503582849.85,
        "delta": 104091344.04
      },
      {
        "periodo": 202509,
        "valor": 1639532379.96,
        "delta": 135949530.11
      },
      {
        "periodo": 202510,
        "valor": 2218197503.32,
        "delta": 578665123.36
      },
      {
        "periodo": 202511,
        "valor": 1391848104.88,
        "delta": -826349398.44
      },
      {
        "periodo": 202512,
        "valor": 2012638238.87,
        "delta": 620790133.99
      },
      {
        "periodo": 202601,
        "valor": 1467376981.33,
        "delta": -545261257.54
      },
      {
        "periodo": 202602,
        "valor": 1893635212.12,
        "delta": 426258230.79
      },
      {
        "periodo": 202603,
        "valor": 835696614.79,
        "delta": -1057938597.33
      },
      {
        "periodo": 202604,
        "valor": 706874393.13,
        "delta": -128822221.66
      },
      {
        "periodo": 202605,
        "valor": -609675241.16,
        "delta": -1316549634.29
      },
      {
        "periodo": 202606,
        "valor": -345338531.67,
        "delta": 264336709.49
      },
      {
        "periodo": 202607,
        "valor": -161061268.55,
        "delta": 184277263.12
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 2299884161.9400005,
    "valor_anterior": 1942392795.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1856472420.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1111678735.1,
        "delta": -744793685.8
      },
      {
        "periodo": 202509,
        "valor": 493091161.27,
        "delta": -618587573.83
      },
      {
        "periodo": 202510,
        "valor": 771432282.36,
        "delta": 278341121.09
      },
      {
        "periodo": 202511,
        "valor": 4308304226.0,
        "delta": 3536871943.64
      },
      {
        "periodo": 202512,
        "valor": 858054332.0,
        "delta": -3450249894.0
      },
      {
        "periodo": 202601,
        "valor": 2258806691.72,
        "delta": 1400752359.72
      },
      {
        "periodo": 202602,
        "valor": 1518684693.8,
        "delta": -740121997.92
      },
      {
        "periodo": 202603,
        "valor": 3105582414.7,
        "delta": 1586897720.9
      },
      {
        "periodo": 202604,
        "valor": 956988252.95,
        "delta": -2148594161.75
      },
      {
        "periodo": 202605,
        "valor": 1411732946.66,
        "delta": 454744693.71
      },
      {
        "periodo": 202606,
        "valor": 1942392795.25,
        "delta": 530659848.59
      },
      {
        "periodo": 202607,
        "valor": 2299884161.94,
        "delta": 357491366.69
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 9275232626.699997,
    "valor_anterior": 7986567801.200005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8268611478.79,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8568888879.13,
        "delta": 300277400.34
      },
      {
        "periodo": 202509,
        "valor": 7931775543.51,
        "delta": -637113335.62
      },
      {
        "periodo": 202510,
        "valor": 8285691711.15,
        "delta": 353916167.64
      },
      {
        "periodo": 202511,
        "valor": 7968676554.5,
        "delta": -317015156.65
      },
      {
        "periodo": 202512,
        "valor": 8478875993.99,
        "delta": 510199439.49
      },
      {
        "periodo": 202601,
        "valor": 9190904957.51,
        "delta": 712028963.52
      },
      {
        "periodo": 202602,
        "valor": 4904298144.14,
        "delta": -4286606813.37
      },
      {
        "periodo": 202603,
        "valor": 9457568041.27,
        "delta": 4553269897.13
      },
      {
        "periodo": 202604,
        "valor": 8292494842.64,
        "delta": -1165073198.63
      },
      {
        "periodo": 202605,
        "valor": 8394923861.75,
        "delta": 102429019.11
      },
      {
        "periodo": 202606,
        "valor": 7986567801.2,
        "delta": -408356060.55
      },
      {
        "periodo": 202607,
        "valor": 9275232626.7,
        "delta": 1288664825.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 2932583868.0,
    "valor_anterior": 3722487949.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2876407711.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2897349748.0,
        "delta": 20942037.0
      },
      {
        "periodo": 202509,
        "valor": 2372700502.0,
        "delta": -524649246.0
      },
      {
        "periodo": 202510,
        "valor": 2976632381.0,
        "delta": 603931879.0
      },
      {
        "periodo": 202511,
        "valor": 2084463568.0,
        "delta": -892168813.0
      },
      {
        "periodo": 202512,
        "valor": 3462686664.0,
        "delta": 1378223096.0
      },
      {
        "periodo": 202601,
        "valor": 3368032681.0,
        "delta": -94653983.0
      },
      {
        "periodo": 202602,
        "valor": 2112039771.0,
        "delta": -1255992910.0
      },
      {
        "periodo": 202603,
        "valor": 4484080674.0,
        "delta": 2372040903.0
      },
      {
        "periodo": 202604,
        "valor": 3093646764.0,
        "delta": -1390433910.0
      },
      {
        "periodo": 202605,
        "valor": 1656168966.0,
        "delta": -1437477798.0
      },
      {
        "periodo": 202606,
        "valor": 3722487949.0,
        "delta": 2066318983.0
      },
      {
        "periodo": 202607,
        "valor": 2932583868.0,
        "delta": -789904081.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 520301647.0,
    "valor_anterior": -184967837.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 897917764.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 787717201.0,
        "delta": -110200563.0
      },
      {
        "periodo": 202509,
        "valor": 834130966.0,
        "delta": 46413765.0
      },
      {
        "periodo": 202510,
        "valor": 77568397.0,
        "delta": -756562569.0
      },
      {
        "periodo": 202511,
        "valor": 1088002417.0,
        "delta": 1010434020.0
      },
      {
        "periodo": 202512,
        "valor": -584174373.0,
        "delta": -1672176790.0
      },
      {
        "periodo": 202601,
        "valor": 1110442795.0,
        "delta": 1694617168.0
      },
      {
        "periodo": 202602,
        "valor": 911393849.0,
        "delta": -199048946.0
      },
      {
        "periodo": 202603,
        "valor": 1606840532.0,
        "delta": 695446683.0
      },
      {
        "periodo": 202604,
        "valor": 65984003.0,
        "delta": -1540856529.0
      },
      {
        "periodo": 202605,
        "valor": -75948436.0,
        "delta": -141932439.0
      },
      {
        "periodo": 202606,
        "valor": -184967837.0,
        "delta": -109019401.0
      },
      {
        "periodo": 202607,
        "valor": 520301647.0,
        "delta": 705269484.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 627843669.4200001,
    "valor_anterior": 672824949.4700003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 710343833.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 814802856.68,
        "delta": 104459023.39
      },
      {
        "periodo": 202509,
        "valor": 742236505.58,
        "delta": -72566351.1
      },
      {
        "periodo": 202510,
        "valor": 743368034.23,
        "delta": 1131528.65
      },
      {
        "periodo": 202511,
        "valor": 759527348.5,
        "delta": 16159314.27
      },
      {
        "periodo": 202512,
        "valor": 652395068.59,
        "delta": -107132279.91
      },
      {
        "periodo": 202601,
        "valor": 750265121.14,
        "delta": 97870052.55
      },
      {
        "periodo": 202602,
        "valor": 545701121.49,
        "delta": -204563999.65
      },
      {
        "periodo": 202603,
        "valor": 745581215.24,
        "delta": 199880093.75
      },
      {
        "periodo": 202604,
        "valor": 709701675.08,
        "delta": -35879540.16
      },
      {
        "periodo": 202605,
        "valor": 736207096.09,
        "delta": 26505421.01
      },
      {
        "periodo": 202606,
        "valor": 672824949.47,
        "delta": -63382146.62
      },
      {
        "periodo": 202607,
        "valor": 627843669.42,
        "delta": -44981280.05
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 1105117457.0,
    "valor_anterior": 1146791316.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2098424613.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1547748166.0,
        "delta": -550676447.0
      },
      {
        "periodo": 202509,
        "valor": 1729347573.0,
        "delta": 181599407.0
      },
      {
        "periodo": 202510,
        "valor": 1630063857.0,
        "delta": -99283716.0
      },
      {
        "periodo": 202511,
        "valor": 1867727544.0,
        "delta": 237663687.0
      },
      {
        "periodo": 202512,
        "valor": 2091734973.0,
        "delta": 224007429.0
      },
      {
        "periodo": 202601,
        "valor": 1746741782.0,
        "delta": -344993191.0
      },
      {
        "periodo": 202602,
        "valor": 1593220292.0,
        "delta": -153521490.0
      },
      {
        "periodo": 202603,
        "valor": 1630163871.0,
        "delta": 36943579.0
      },
      {
        "periodo": 202604,
        "valor": 1542902320.0,
        "delta": -87261551.0
      },
      {
        "periodo": 202605,
        "valor": 1246139197.0,
        "delta": -296763123.0
      },
      {
        "periodo": 202606,
        "valor": 1146791316.0,
        "delta": -99347881.0
      },
      {
        "periodo": 202607,
        "valor": 1105117457.0,
        "delta": -41673859.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 314237751.0,
    "valor_anterior": 309172813.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 291066735.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 297792111.0,
        "delta": 6725376.0
      },
      {
        "periodo": 202509,
        "valor": 301756537.0,
        "delta": 3964426.0
      },
      {
        "periodo": 202510,
        "valor": 323004149.0,
        "delta": 21247612.0
      },
      {
        "periodo": 202511,
        "valor": 336135106.0,
        "delta": 13130957.0
      },
      {
        "periodo": 202512,
        "valor": 285678801.0,
        "delta": -50456305.0
      },
      {
        "periodo": 202601,
        "valor": 286721995.0,
        "delta": 1043194.0
      },
      {
        "periodo": 202602,
        "valor": 282074456.0,
        "delta": -4647539.0
      },
      {
        "periodo": 202603,
        "valor": 294705857.0,
        "delta": 12631401.0
      },
      {
        "periodo": 202604,
        "valor": 293252837.0,
        "delta": -1453020.0
      },
      {
        "periodo": 202605,
        "valor": 299354850.0,
        "delta": 6102013.0
      },
      {
        "periodo": 202606,
        "valor": 309172813.0,
        "delta": 9817963.0
      },
      {
        "periodo": 202607,
        "valor": 314237751.0,
        "delta": 5064938.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 1113900441.000001,
    "valor_anterior": 978526698.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 832422165.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 869448496.0,
        "delta": 37026331.0
      },
      {
        "periodo": 202509,
        "valor": 828542917.0,
        "delta": -40905579.0
      },
      {
        "periodo": 202510,
        "valor": 771477333.0,
        "delta": -57065584.0
      },
      {
        "periodo": 202511,
        "valor": 703025201.0,
        "delta": -68452132.0
      },
      {
        "periodo": 202512,
        "valor": 1286575515.0,
        "delta": 583550314.0
      },
      {
        "periodo": 202601,
        "valor": 1298363914.0,
        "delta": 11788399.0
      },
      {
        "periodo": 202602,
        "valor": 905925489.0,
        "delta": -392438425.0
      },
      {
        "periodo": 202603,
        "valor": 2210650299.0,
        "delta": 1304724810.0
      },
      {
        "periodo": 202604,
        "valor": 605998944.0,
        "delta": -1604651355.0
      },
      {
        "periodo": 202605,
        "valor": 749663494.0,
        "delta": 143664550.0
      },
      {
        "periodo": 202606,
        "valor": 978526698.0,
        "delta": 228863204.0
      },
      {
        "periodo": 202607,
        "valor": 1113900441.0,
        "delta": 135373743.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 539191163.9900002,
    "valor_anterior": 474393081.8800001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 502734957.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 496936631.81,
        "delta": -5798326.06
      },
      {
        "periodo": 202509,
        "valor": 515010662.93,
        "delta": 18074031.12
      },
      {
        "periodo": 202510,
        "valor": 557338230.91,
        "delta": 42327567.98
      },
      {
        "periodo": 202511,
        "valor": 605973639.12,
        "delta": 48635408.21
      },
      {
        "periodo": 202512,
        "valor": 650300503.27,
        "delta": 44326864.15
      },
      {
        "periodo": 202601,
        "valor": 491592760.57,
        "delta": -158707742.7
      },
      {
        "periodo": 202602,
        "valor": 453424483.71,
        "delta": -38168276.86
      },
      {
        "periodo": 202603,
        "valor": 487800879.33,
        "delta": 34376395.62
      },
      {
        "periodo": 202604,
        "valor": 490020555.27,
        "delta": 2219675.94
      },
      {
        "periodo": 202605,
        "valor": 478681763.76,
        "delta": -11338791.51
      },
      {
        "periodo": 202606,
        "valor": 474393081.88,
        "delta": -4288681.88
      },
      {
        "periodo": 202607,
        "valor": 539191163.99,
        "delta": 64798082.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 240717223.0,
    "valor_anterior": 157667263.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 193746012.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 44028872.0,
        "delta": -149717140.0
      },
      {
        "periodo": 202509,
        "valor": 220986496.0,
        "delta": 176957624.0
      },
      {
        "periodo": 202510,
        "valor": 215345472.0,
        "delta": -5641024.0
      },
      {
        "periodo": 202511,
        "valor": -719386.0,
        "delta": -216064858.0
      },
      {
        "periodo": 202512,
        "valor": 91623204.0,
        "delta": 92342590.0
      },
      {
        "periodo": 202601,
        "valor": -31607024.0,
        "delta": -123230228.0
      },
      {
        "periodo": 202602,
        "valor": 25737654.0,
        "delta": 57344678.0
      },
      {
        "periodo": 202603,
        "valor": 116366033.0,
        "delta": 90628379.0
      },
      {
        "periodo": 202604,
        "valor": 199000110.0,
        "delta": 82634077.0
      },
      {
        "periodo": 202605,
        "valor": 159822200.0,
        "delta": -39177910.0
      },
      {
        "periodo": 202606,
        "valor": 157667263.0,
        "delta": -2154937.0
      },
      {
        "periodo": 202607,
        "valor": 240717223.0,
        "delta": 83049960.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 99743420.0,
    "valor_anterior": 104856675.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 103708849.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 138208506.0,
        "delta": 34499657.0
      },
      {
        "periodo": 202509,
        "valor": 135475559.0,
        "delta": -2732947.0
      },
      {
        "periodo": 202510,
        "valor": 94891287.0,
        "delta": -40584272.0
      },
      {
        "periodo": 202511,
        "valor": 113804152.0,
        "delta": 18912865.0
      },
      {
        "periodo": 202512,
        "valor": 133325921.0,
        "delta": 19521769.0
      },
      {
        "periodo": 202601,
        "valor": 97375607.0,
        "delta": -35950314.0
      },
      {
        "periodo": 202602,
        "valor": 103409581.0,
        "delta": 6033974.0
      },
      {
        "periodo": 202603,
        "valor": 114550040.0,
        "delta": 11140459.0
      },
      {
        "periodo": 202604,
        "valor": 103904757.0,
        "delta": -10645283.0
      },
      {
        "periodo": 202605,
        "valor": 91802513.0,
        "delta": -12102244.0
      },
      {
        "periodo": 202606,
        "valor": 104856675.0,
        "delta": 13054162.0
      },
      {
        "periodo": 202607,
        "valor": 99743420.0,
        "delta": -5113255.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 50808698.0,
    "valor_anterior": 111007917.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 81913564.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 110109326.0,
        "delta": 28195762.0
      },
      {
        "periodo": 202509,
        "valor": 93540561.0,
        "delta": -16568765.0
      },
      {
        "periodo": 202510,
        "valor": 94921371.0,
        "delta": 1380810.0
      },
      {
        "periodo": 202511,
        "valor": 80880241.0,
        "delta": -14041130.0
      },
      {
        "periodo": 202512,
        "valor": -406865729.0,
        "delta": -487745970.0
      },
      {
        "periodo": 202601,
        "valor": 107863749.0,
        "delta": 514729478.0
      },
      {
        "periodo": 202602,
        "valor": 55310930.0,
        "delta": -52552819.0
      },
      {
        "periodo": 202603,
        "valor": 131691693.0,
        "delta": 76380763.0
      },
      {
        "periodo": 202604,
        "valor": 125193282.0,
        "delta": -6498411.0
      },
      {
        "periodo": 202605,
        "valor": 77464335.0,
        "delta": -47728947.0
      },
      {
        "periodo": 202606,
        "valor": 111007917.0,
        "delta": 33543582.0
      },
      {
        "periodo": 202607,
        "valor": 50808698.0,
        "delta": -60199219.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 4284803036.8499985,
    "valor_anterior": 4433279677.790001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4199544707.38,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4034773530.7,
        "delta": -164771176.68
      },
      {
        "periodo": 202509,
        "valor": 3117514878.29,
        "delta": -917258652.41
      },
      {
        "periodo": 202510,
        "valor": 4012780420.19,
        "delta": 895265541.9
      },
      {
        "periodo": 202511,
        "valor": 4075313726.43,
        "delta": 62533306.24
      },
      {
        "periodo": 202512,
        "valor": 4780346372.2,
        "delta": 705032645.77
      },
      {
        "periodo": 202601,
        "valor": 3762883341.3,
        "delta": -1017463030.9
      },
      {
        "periodo": 202602,
        "valor": 3735504694.68,
        "delta": -27378646.62
      },
      {
        "periodo": 202603,
        "valor": 4796365780.0,
        "delta": 1060861085.32
      },
      {
        "periodo": 202604,
        "valor": 4393572804.0,
        "delta": -402792976.0
      },
      {
        "periodo": 202605,
        "valor": 3887069618.55,
        "delta": -506503185.45
      },
      {
        "periodo": 202606,
        "valor": 4433279677.79,
        "delta": 546210059.24
      },
      {
        "periodo": 202607,
        "valor": 4284803036.85,
        "delta": -148476640.94
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 178147526.0,
    "valor_anterior": 91033731.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 141894823.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 138751818.0,
        "delta": -3143005.0
      },
      {
        "periodo": 202509,
        "valor": 39952543.0,
        "delta": -98799275.0
      },
      {
        "periodo": 202510,
        "valor": 263829354.0,
        "delta": 223876811.0
      },
      {
        "periodo": 202511,
        "valor": -81733425.0,
        "delta": -345562779.0
      },
      {
        "periodo": 202512,
        "valor": 257973473.0,
        "delta": 339706898.0
      },
      {
        "periodo": 202601,
        "valor": 232283326.0,
        "delta": -25690147.0
      },
      {
        "periodo": 202602,
        "valor": 188622763.0,
        "delta": -43660563.0
      },
      {
        "periodo": 202603,
        "valor": 290243715.0,
        "delta": 101620952.0
      },
      {
        "periodo": 202604,
        "valor": 319677483.0,
        "delta": 29433768.0
      },
      {
        "periodo": 202605,
        "valor": -28937915.0,
        "delta": -348615398.0
      },
      {
        "periodo": 202606,
        "valor": 91033731.0,
        "delta": 119971646.0
      },
      {
        "periodo": 202607,
        "valor": 178147526.0,
        "delta": 87113795.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 69255844.0,
    "valor_anterior": 15005149.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 94406071.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 100996326.0,
        "delta": 6590255.0
      },
      {
        "periodo": 202509,
        "valor": 100311040.0,
        "delta": -685286.0
      },
      {
        "periodo": 202510,
        "valor": 62235197.0,
        "delta": -38075843.0
      },
      {
        "periodo": 202511,
        "valor": 91964082.0,
        "delta": 29728885.0
      },
      {
        "periodo": 202512,
        "valor": 84852134.0,
        "delta": -7111948.0
      },
      {
        "periodo": 202601,
        "valor": 60605018.0,
        "delta": -24247116.0
      },
      {
        "periodo": 202602,
        "valor": 21031908.0,
        "delta": -39573110.0
      },
      {
        "periodo": 202603,
        "valor": 32189306.0,
        "delta": 11157398.0
      },
      {
        "periodo": 202604,
        "valor": 81364698.0,
        "delta": 49175392.0
      },
      {
        "periodo": 202605,
        "valor": 61609478.0,
        "delta": -19755220.0
      },
      {
        "periodo": 202606,
        "valor": 15005149.0,
        "delta": -46604329.0
      },
      {
        "periodo": 202607,
        "valor": 69255844.0,
        "delta": 54250695.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 263857936.0,
    "valor_anterior": 244411820.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 313307077.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 666129380.0,
        "delta": 352822303.0
      },
      {
        "periodo": 202509,
        "valor": 608378548.0,
        "delta": -57750832.0
      },
      {
        "periodo": 202510,
        "valor": 408260947.0,
        "delta": -200117601.0
      },
      {
        "periodo": 202511,
        "valor": 279936085.0,
        "delta": -128324862.0
      },
      {
        "periodo": 202512,
        "valor": 251083627.0,
        "delta": -28852458.0
      },
      {
        "periodo": 202601,
        "valor": 221097441.0,
        "delta": -29986186.0
      },
      {
        "periodo": 202602,
        "valor": 391377390.0,
        "delta": 170279949.0
      },
      {
        "periodo": 202603,
        "valor": 359282558.0,
        "delta": -32094832.0
      },
      {
        "periodo": 202604,
        "valor": 237219574.0,
        "delta": -122062984.0
      },
      {
        "periodo": 202605,
        "valor": 287343184.0,
        "delta": 50123610.0
      },
      {
        "periodo": 202606,
        "valor": 244411820.0,
        "delta": -42931364.0
      },
      {
        "periodo": 202607,
        "valor": 263857936.0,
        "delta": 19446116.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 316455534.89000034,
    "valor_anterior": 361774257.79999995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 240595059.73,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 338890355.76,
        "delta": 98295296.03
      },
      {
        "periodo": 202509,
        "valor": 349707843.96,
        "delta": 10817488.2
      },
      {
        "periodo": 202510,
        "valor": 409814197.46,
        "delta": 60106353.5
      },
      {
        "periodo": 202511,
        "valor": 239737997.81,
        "delta": -170076199.65
      },
      {
        "periodo": 202512,
        "valor": 431134567.43,
        "delta": 191396569.62
      },
      {
        "periodo": 202601,
        "valor": 410233535.08,
        "delta": -20901032.35
      },
      {
        "periodo": 202602,
        "valor": 270330897.11,
        "delta": -139902637.97
      },
      {
        "periodo": 202603,
        "valor": 27962040.02,
        "delta": -242368857.09
      },
      {
        "periodo": 202604,
        "valor": 175996441.86,
        "delta": 148034401.84
      },
      {
        "periodo": 202605,
        "valor": 346016613.99,
        "delta": 170020172.13
      },
      {
        "periodo": 202606,
        "valor": 361774257.8,
        "delta": 15757643.81
      },
      {
        "periodo": 202607,
        "valor": 316455534.89,
        "delta": -45318722.91
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 78539893.0,
    "valor_anterior": 126725033.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 84977958.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 64599861.0,
        "delta": -20378097.0
      },
      {
        "periodo": 202509,
        "valor": 121746975.0,
        "delta": 57147114.0
      },
      {
        "periodo": 202510,
        "valor": 45281538.0,
        "delta": -76465437.0
      },
      {
        "periodo": 202511,
        "valor": 84951868.0,
        "delta": 39670330.0
      },
      {
        "periodo": 202512,
        "valor": 141972007.0,
        "delta": 57020139.0
      },
      {
        "periodo": 202601,
        "valor": 80204297.0,
        "delta": -61767710.0
      },
      {
        "periodo": 202602,
        "valor": 26074595.0,
        "delta": -54129702.0
      },
      {
        "periodo": 202603,
        "valor": 149364503.0,
        "delta": 123289908.0
      },
      {
        "periodo": 202604,
        "valor": 140732076.0,
        "delta": -8632427.0
      },
      {
        "periodo": 202605,
        "valor": 75333856.0,
        "delta": -65398220.0
      },
      {
        "periodo": 202606,
        "valor": 126725033.0,
        "delta": 51391177.0
      },
      {
        "periodo": 202607,
        "valor": 78539893.0,
        "delta": -48185140.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 361930050.0500002,
    "valor_anterior": 616493765.0199995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 686008781.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1131177871.54,
        "delta": 445169090.15
      },
      {
        "periodo": 202509,
        "valor": 691358022.73,
        "delta": -439819848.81
      },
      {
        "periodo": 202510,
        "valor": 818958279.36,
        "delta": 127600256.63
      },
      {
        "periodo": 202511,
        "valor": 395011235.73,
        "delta": -423947043.63
      },
      {
        "periodo": 202512,
        "valor": 1829661048.56,
        "delta": 1434649812.83
      },
      {
        "periodo": 202601,
        "valor": 1178524941.17,
        "delta": -651136107.39
      },
      {
        "periodo": 202602,
        "valor": 725405326.98,
        "delta": -453119614.19
      },
      {
        "periodo": 202603,
        "valor": 364773536.74,
        "delta": -360631790.24
      },
      {
        "periodo": 202604,
        "valor": 1112135778.31,
        "delta": 747362241.57
      },
      {
        "periodo": 202605,
        "valor": 813435413.26,
        "delta": -298700365.05
      },
      {
        "periodo": 202606,
        "valor": 616493765.02,
        "delta": -196941648.24
      },
      {
        "periodo": 202607,
        "valor": 361930050.05,
        "delta": -254563714.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": -1481859.0,
    "valor_anterior": 5268130.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -12618376.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -13391855.0,
        "delta": -773479.0
      },
      {
        "periodo": 202509,
        "valor": -10441984.0,
        "delta": 2949871.0
      },
      {
        "periodo": 202510,
        "valor": 9121593.0,
        "delta": 19563577.0
      },
      {
        "periodo": 202511,
        "valor": -21466065.0,
        "delta": -30587658.0
      },
      {
        "periodo": 202512,
        "valor": -30122374.0,
        "delta": -8656309.0
      },
      {
        "periodo": 202601,
        "valor": 5278601.0,
        "delta": 35400975.0
      },
      {
        "periodo": 202602,
        "valor": 502160.0,
        "delta": -4776441.0
      },
      {
        "periodo": 202603,
        "valor": -2784645.0,
        "delta": -3286805.0
      },
      {
        "periodo": 202604,
        "valor": 4952888.0,
        "delta": 7737533.0
      },
      {
        "periodo": 202605,
        "valor": 145395.0,
        "delta": -4807493.0
      },
      {
        "periodo": 202606,
        "valor": 5268130.0,
        "delta": 5122735.0
      },
      {
        "periodo": 202607,
        "valor": -1481859.0,
        "delta": -6749989.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": -337754290.88,
    "valor_anterior": -967694970.0600002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 332409124.28,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 478540566.46,
        "delta": 146131442.18
      },
      {
        "periodo": 202509,
        "valor": 400849560.52,
        "delta": -77691005.94
      },
      {
        "periodo": 202510,
        "valor": 980362481.48,
        "delta": 579512920.96
      },
      {
        "periodo": 202511,
        "valor": 605874895.03,
        "delta": -374487586.45
      },
      {
        "periodo": 202512,
        "valor": 1009665809.07,
        "delta": 403790914.04
      },
      {
        "periodo": 202601,
        "valor": 564954280.71,
        "delta": -444711528.36
      },
      {
        "periodo": 202602,
        "valor": 534323074.38,
        "delta": -30631206.33
      },
      {
        "periodo": 202603,
        "valor": 706799500.14,
        "delta": 172476425.76
      },
      {
        "periodo": 202604,
        "valor": 326549867.69,
        "delta": -380249632.45
      },
      {
        "periodo": 202605,
        "valor": -732546087.03,
        "delta": -1059095954.72
      },
      {
        "periodo": 202606,
        "valor": -967694970.06,
        "delta": -235148883.03
      },
      {
        "periodo": 202607,
        "valor": -337754290.88,
        "delta": 629940679.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 215854947.0,
    "valor_anterior": 90478329.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25130073.99,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55121844.95,
        "delta": 29991770.96
      },
      {
        "periodo": 202509,
        "valor": 297665115.03,
        "delta": 242543270.08
      },
      {
        "periodo": 202510,
        "valor": 97851802.0,
        "delta": -199813313.03
      },
      {
        "periodo": 202511,
        "valor": -18793948.0,
        "delta": -116645750.0
      },
      {
        "periodo": 202512,
        "valor": 167576813.0,
        "delta": 186370761.0
      },
      {
        "periodo": 202601,
        "valor": 157136337.0,
        "delta": -10440476.0
      },
      {
        "periodo": 202602,
        "valor": 128304008.0,
        "delta": -28832329.0
      },
      {
        "periodo": 202603,
        "valor": 247830112.0,
        "delta": 119526104.0
      },
      {
        "periodo": 202604,
        "valor": 120730052.0,
        "delta": -127100060.0
      },
      {
        "periodo": 202605,
        "valor": 113516388.0,
        "delta": -7213664.0
      },
      {
        "periodo": 202606,
        "valor": 90478329.0,
        "delta": -23038059.0
      },
      {
        "periodo": 202607,
        "valor": 215854947.0,
        "delta": 125376618.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": -6619837.0,
    "valor_anterior": 11729484.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 237494240.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -48438678.0,
        "delta": -285932918.0
      },
      {
        "periodo": 202509,
        "valor": 78081916.0,
        "delta": 126520594.0
      },
      {
        "periodo": 202510,
        "valor": 56242236.0,
        "delta": -21839680.0
      },
      {
        "periodo": 202511,
        "valor": 39822160.0,
        "delta": -16420076.0
      },
      {
        "periodo": 202512,
        "valor": -42922893.0,
        "delta": -82745053.0
      },
      {
        "periodo": 202601,
        "valor": 63154677.0,
        "delta": 106077570.0
      },
      {
        "periodo": 202602,
        "valor": 107229425.0,
        "delta": 44074748.0
      },
      {
        "periodo": 202603,
        "valor": 28042085.0,
        "delta": -79187340.0
      },
      {
        "periodo": 202604,
        "valor": 59861214.0,
        "delta": 31819129.0
      },
      {
        "periodo": 202605,
        "valor": 67831883.0,
        "delta": 7970669.0
      },
      {
        "periodo": 202606,
        "valor": 11729484.0,
        "delta": -56102399.0
      },
      {
        "periodo": 202607,
        "valor": -6619837.0,
        "delta": -18349321.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 457588293.0,
    "valor_anterior": 610656712.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 441982645.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 506101810.0,
        "delta": 64119165.0
      },
      {
        "periodo": 202509,
        "valor": 504845909.0,
        "delta": -1255901.0
      },
      {
        "periodo": 202510,
        "valor": 428759168.0,
        "delta": -76086741.0
      },
      {
        "periodo": 202511,
        "valor": 451077072.0,
        "delta": 22317904.0
      },
      {
        "periodo": 202512,
        "valor": 516393274.0,
        "delta": 65316202.0
      },
      {
        "periodo": 202601,
        "valor": 622276393.0,
        "delta": 105883119.0
      },
      {
        "periodo": 202602,
        "valor": 531864487.0,
        "delta": -90411906.0
      },
      {
        "periodo": 202603,
        "valor": 501323737.0,
        "delta": -30540750.0
      },
      {
        "periodo": 202604,
        "valor": 339592574.0,
        "delta": -161731163.0
      },
      {
        "periodo": 202605,
        "valor": 528999265.0,
        "delta": 189406691.0
      },
      {
        "periodo": 202606,
        "valor": 610656712.0,
        "delta": 81657447.0
      },
      {
        "periodo": 202607,
        "valor": 457588293.0,
        "delta": -153068419.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 182465855.0,
    "valor_anterior": 229919724.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 87938402.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 102514021.0,
        "delta": 14575619.0
      },
      {
        "periodo": 202509,
        "valor": 106504330.0,
        "delta": 3990309.0
      },
      {
        "periodo": 202510,
        "valor": 236906836.0,
        "delta": 130402506.0
      },
      {
        "periodo": 202511,
        "valor": 151765419.0,
        "delta": -85141417.0
      },
      {
        "periodo": 202512,
        "valor": 92849978.0,
        "delta": -58915441.0
      },
      {
        "periodo": 202601,
        "valor": 119497723.0,
        "delta": 26647745.0
      },
      {
        "periodo": 202602,
        "valor": 90986551.0,
        "delta": -28511172.0
      },
      {
        "periodo": 202603,
        "valor": 112483572.0,
        "delta": 21497021.0
      },
      {
        "periodo": 202604,
        "valor": 139707596.0,
        "delta": 27224024.0
      },
      {
        "periodo": 202605,
        "valor": 161453546.0,
        "delta": 21745950.0
      },
      {
        "periodo": 202606,
        "valor": 229919724.0,
        "delta": 68466178.0
      },
      {
        "periodo": 202607,
        "valor": 182465855.0,
        "delta": -47453869.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 24668729.0,
    "valor_anterior": -35843708.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40345980.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21451190.0,
        "delta": -18894790.0
      },
      {
        "periodo": 202509,
        "valor": 87408369.0,
        "delta": 65957179.0
      },
      {
        "periodo": 202510,
        "valor": 55481374.0,
        "delta": -31926995.0
      },
      {
        "periodo": 202511,
        "valor": -15686538.0,
        "delta": -71167912.0
      },
      {
        "periodo": 202512,
        "valor": 36155057.0,
        "delta": 51841595.0
      },
      {
        "periodo": 202601,
        "valor": -9565658.0,
        "delta": -45720715.0
      },
      {
        "periodo": 202602,
        "valor": 32398379.0,
        "delta": 41964037.0
      },
      {
        "periodo": 202603,
        "valor": 21095808.0,
        "delta": -11302571.0
      },
      {
        "periodo": 202604,
        "valor": 29184634.0,
        "delta": 8088826.0
      },
      {
        "periodo": 202605,
        "valor": 77305936.0,
        "delta": 48121302.0
      },
      {
        "periodo": 202606,
        "valor": -35843708.0,
        "delta": -113149644.0
      },
      {
        "periodo": 202607,
        "valor": 24668729.0,
        "delta": 60512437.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": -160889672.0,
    "valor_anterior": -466704065.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -243515754.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -161573979.0,
        "delta": 81941775.0
      },
      {
        "periodo": 202509,
        "valor": -201144304.0,
        "delta": -39570325.0
      },
      {
        "periodo": 202510,
        "valor": -93987246.0,
        "delta": 107157058.0
      },
      {
        "periodo": 202511,
        "valor": 75641421.0,
        "delta": 169628667.0
      },
      {
        "periodo": 202512,
        "valor": -138541784.0,
        "delta": -214183205.0
      },
      {
        "periodo": 202601,
        "valor": 38221811.0,
        "delta": 176763595.0
      },
      {
        "periodo": 202602,
        "valor": 65623328.0,
        "delta": 27401517.0
      },
      {
        "periodo": 202603,
        "valor": 11176069.0,
        "delta": -54447259.0
      },
      {
        "periodo": 202604,
        "valor": -9183422.0,
        "delta": -20359491.0
      },
      {
        "periodo": 202605,
        "valor": -24202479.0,
        "delta": -15019057.0
      },
      {
        "periodo": 202606,
        "valor": -466704065.0,
        "delta": -442501586.0
      },
      {
        "periodo": 202607,
        "valor": -160889672.0,
        "delta": 305814393.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 218963516.90999985,
    "valor_anterior": 507333431.2600001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 197518641.03,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 75159102.89,
        "delta": -122359538.14
      },
      {
        "periodo": 202509,
        "valor": 263667648.5,
        "delta": 188508545.61
      },
      {
        "periodo": 202510,
        "valor": 256238507.76,
        "delta": -7429140.74
      },
      {
        "periodo": 202511,
        "valor": 206363912.03,
        "delta": -49874595.73
      },
      {
        "periodo": 202512,
        "valor": 40405087.63,
        "delta": -165958824.4
      },
      {
        "periodo": 202601,
        "valor": -29597065.79,
        "delta": -70002153.42
      },
      {
        "periodo": 202602,
        "valor": 273734084.44,
        "delta": 303331150.23
      },
      {
        "periodo": 202603,
        "valor": -17784195.83,
        "delta": -291518280.27
      },
      {
        "periodo": 202604,
        "valor": 209441497.38,
        "delta": 227225693.21
      },
      {
        "periodo": 202605,
        "valor": 283984769.43,
        "delta": 74543272.05
      },
      {
        "periodo": 202606,
        "valor": 507333431.26,
        "delta": 223348661.83
      },
      {
        "periodo": 202607,
        "valor": 218963516.91,
        "delta": -288369914.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": -78677676.0,
    "valor_anterior": -81482503.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -134372887.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -102760459.0,
        "delta": 31612428.0
      },
      {
        "periodo": 202509,
        "valor": -92307465.0,
        "delta": 10452994.0
      },
      {
        "periodo": 202510,
        "valor": -109067285.0,
        "delta": -16759820.0
      },
      {
        "periodo": 202511,
        "valor": -130696086.0,
        "delta": -21628801.0
      },
      {
        "periodo": 202512,
        "valor": -104570425.0,
        "delta": 26125661.0
      },
      {
        "periodo": 202601,
        "valor": -86307873.0,
        "delta": 18262552.0
      },
      {
        "periodo": 202602,
        "valor": -108080555.0,
        "delta": -21772682.0
      },
      {
        "periodo": 202603,
        "valor": -128914817.0,
        "delta": -20834262.0
      },
      {
        "periodo": 202604,
        "valor": -90395760.0,
        "delta": 38519057.0
      },
      {
        "periodo": 202605,
        "valor": -67808660.0,
        "delta": 22587100.0
      },
      {
        "periodo": 202606,
        "valor": -81482503.0,
        "delta": -13673843.0
      },
      {
        "periodo": 202607,
        "valor": -78677676.0,
        "delta": 2804827.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 4212094.0,
    "valor_anterior": 6036089.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4095729.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10004958.0,
        "delta": 5909229.0
      },
      {
        "periodo": 202509,
        "valor": 14364736.0,
        "delta": 4359778.0
      },
      {
        "periodo": 202510,
        "valor": 9117834.0,
        "delta": -5246902.0
      },
      {
        "periodo": 202511,
        "valor": 1322515.0,
        "delta": -7795319.0
      },
      {
        "periodo": 202512,
        "valor": -2880505.0,
        "delta": -4203020.0
      },
      {
        "periodo": 202601,
        "valor": 2751697.0,
        "delta": 5632202.0
      },
      {
        "periodo": 202602,
        "valor": 4020751.0,
        "delta": 1269054.0
      },
      {
        "periodo": 202603,
        "valor": 7862809.0,
        "delta": 3842058.0
      },
      {
        "periodo": 202604,
        "valor": 6327076.0,
        "delta": -1535733.0
      },
      {
        "periodo": 202605,
        "valor": 8852345.0,
        "delta": 2525269.0
      },
      {
        "periodo": 202606,
        "valor": 6036089.0,
        "delta": -2816256.0
      },
      {
        "periodo": 202607,
        "valor": 4212094.0,
        "delta": -1823995.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 43218987.0,
    "valor_anterior": 127410408.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 106979164.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 122535417.0,
        "delta": 15556253.0
      },
      {
        "periodo": 202509,
        "valor": 124366682.0,
        "delta": 1831265.0
      },
      {
        "periodo": 202510,
        "valor": 101341126.0,
        "delta": -23025556.0
      },
      {
        "periodo": 202511,
        "valor": 140114117.0,
        "delta": 38772991.0
      },
      {
        "periodo": 202512,
        "valor": 81511294.0,
        "delta": -58602823.0
      },
      {
        "periodo": 202601,
        "valor": 106383772.0,
        "delta": 24872478.0
      },
      {
        "periodo": 202602,
        "valor": 144113271.0,
        "delta": 37729499.0
      },
      {
        "periodo": 202603,
        "valor": 142161079.0,
        "delta": -1952192.0
      },
      {
        "periodo": 202604,
        "valor": 137600467.0,
        "delta": -4560612.0
      },
      {
        "periodo": 202605,
        "valor": 111319246.0,
        "delta": -26281221.0
      },
      {
        "periodo": 202606,
        "valor": 127410408.0,
        "delta": 16091162.0
      },
      {
        "periodo": 202607,
        "valor": 43218987.0,
        "delta": -84191421.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 44753558.0,
    "valor_anterior": 66265087.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 63070640.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21310337.0,
        "delta": -41760303.0
      },
      {
        "periodo": 202509,
        "valor": 49928257.0,
        "delta": 28617920.0
      },
      {
        "periodo": 202510,
        "valor": -4829792.0,
        "delta": -54758049.0
      },
      {
        "periodo": 202511,
        "valor": 5505596.0,
        "delta": 10335388.0
      },
      {
        "periodo": 202512,
        "valor": 62820584.0,
        "delta": 57314988.0
      },
      {
        "periodo": 202601,
        "valor": 22268413.0,
        "delta": -40552171.0
      },
      {
        "periodo": 202602,
        "valor": 68718942.0,
        "delta": 46450529.0
      },
      {
        "periodo": 202603,
        "valor": 56173210.0,
        "delta": -12545732.0
      },
      {
        "periodo": 202604,
        "valor": -4947772.0,
        "delta": -61120982.0
      },
      {
        "periodo": 202605,
        "valor": 8379356.0,
        "delta": 13327128.0
      },
      {
        "periodo": 202606,
        "valor": 66265087.0,
        "delta": 57885731.0
      },
      {
        "periodo": 202607,
        "valor": 44753558.0,
        "delta": -21511529.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1210617544.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -876167041.0,
        "delta": 334450503.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 148643849.0,
    "valor_anterior": 137559769.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 107339029.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 155551865.0,
        "delta": 48212836.0
      },
      {
        "periodo": 202509,
        "valor": 119757325.0,
        "delta": -35794540.0
      },
      {
        "periodo": 202510,
        "valor": 194239196.0,
        "delta": 74481871.0
      },
      {
        "periodo": 202511,
        "valor": 77079884.0,
        "delta": -117159312.0
      },
      {
        "periodo": 202512,
        "valor": 290245430.0,
        "delta": 213165546.0
      },
      {
        "periodo": 202601,
        "valor": 98110759.0,
        "delta": -192134671.0
      },
      {
        "periodo": 202602,
        "valor": 113446751.0,
        "delta": 15335992.0
      },
      {
        "periodo": 202603,
        "valor": 164684746.0,
        "delta": 51237995.0
      },
      {
        "periodo": 202604,
        "valor": 156241447.0,
        "delta": -8443299.0
      },
      {
        "periodo": 202605,
        "valor": 129277896.0,
        "delta": -26963551.0
      },
      {
        "periodo": 202606,
        "valor": 137559769.0,
        "delta": 8281873.0
      },
      {
        "periodo": 202607,
        "valor": 148643849.0,
        "delta": 11084080.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": -72936388.0,
    "valor_anterior": 182168916.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12464901.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 60010052.0,
        "delta": 47545151.0
      },
      {
        "periodo": 202509,
        "valor": -15154860.0,
        "delta": -75164912.0
      },
      {
        "periodo": 202510,
        "valor": -16819170.0,
        "delta": -1664310.0
      },
      {
        "periodo": 202511,
        "valor": -38088182.0,
        "delta": -21269012.0
      },
      {
        "periodo": 202512,
        "valor": 78940203.0,
        "delta": 117028385.0
      },
      {
        "periodo": 202601,
        "valor": 6560343.0,
        "delta": -72379860.0
      },
      {
        "periodo": 202602,
        "valor": -9170593.0,
        "delta": -15730936.0
      },
      {
        "periodo": 202603,
        "valor": 15408196.0,
        "delta": 24578789.0
      },
      {
        "periodo": 202604,
        "valor": -125884521.0,
        "delta": -141292717.0
      },
      {
        "periodo": 202605,
        "valor": -42132479.0,
        "delta": 83752042.0
      },
      {
        "periodo": 202606,
        "valor": 182168916.0,
        "delta": 224301395.0
      },
      {
        "periodo": 202607,
        "valor": -72936388.0,
        "delta": -255105304.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 3585915.0,
    "valor_anterior": 1999842.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -6331452.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -8814540.0,
        "delta": -2483088.0
      },
      {
        "periodo": 202509,
        "valor": -4929790.0,
        "delta": 3884750.0
      },
      {
        "periodo": 202510,
        "valor": -6800463.0,
        "delta": -1870673.0
      },
      {
        "periodo": 202511,
        "valor": 12222225.0,
        "delta": 19022688.0
      },
      {
        "periodo": 202512,
        "valor": 4963514.0,
        "delta": -7258711.0
      },
      {
        "periodo": 202601,
        "valor": -6697490.0,
        "delta": -11661004.0
      },
      {
        "periodo": 202602,
        "valor": 798398.0,
        "delta": 7495888.0
      },
      {
        "periodo": 202603,
        "valor": 754580.0,
        "delta": -43818.0
      },
      {
        "periodo": 202604,
        "valor": -3856228.0,
        "delta": -4610808.0
      },
      {
        "periodo": 202605,
        "valor": 2094074.0,
        "delta": 5950302.0
      },
      {
        "periodo": 202606,
        "valor": 1999842.0,
        "delta": -94232.0
      },
      {
        "periodo": 202607,
        "valor": 3585915.0,
        "delta": 1586073.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": -9410401.0,
    "valor_anterior": -10331901.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -4807297.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -6378901.0,
        "delta": -1571604.0
      },
      {
        "periodo": 202509,
        "valor": -1032672.0,
        "delta": 5346229.0
      },
      {
        "periodo": 202510,
        "valor": -5979215.0,
        "delta": -4946543.0
      },
      {
        "periodo": 202511,
        "valor": -4343582.0,
        "delta": 1635633.0
      },
      {
        "periodo": 202512,
        "valor": -11607348.0,
        "delta": -7263766.0
      },
      {
        "periodo": 202601,
        "valor": -4002392.0,
        "delta": 7604956.0
      },
      {
        "periodo": 202602,
        "valor": -4959804.0,
        "delta": -957412.0
      },
      {
        "periodo": 202603,
        "valor": -6782583.0,
        "delta": -1822779.0
      },
      {
        "periodo": 202604,
        "valor": -4783051.0,
        "delta": 1999532.0
      },
      {
        "periodo": 202605,
        "valor": -8909606.0,
        "delta": -4126555.0
      },
      {
        "periodo": 202606,
        "valor": -10331901.0,
        "delta": -1422295.0
      },
      {
        "periodo": 202607,
        "valor": -9410401.0,
        "delta": 921500.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 10065012.930000007,
    "valor_anterior": 12100903.479999997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2569923.57,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2139277.88,
        "delta": -430645.69
      },
      {
        "periodo": 202509,
        "valor": 15675913.55,
        "delta": 13536635.67
      },
      {
        "periodo": 202510,
        "valor": 10012758.18,
        "delta": -5663155.37
      },
      {
        "periodo": 202511,
        "valor": 10143417.35,
        "delta": 130659.17
      },
      {
        "periodo": 202512,
        "valor": 22130749.96,
        "delta": 11987332.61
      },
      {
        "periodo": 202601,
        "valor": 16526313.02,
        "delta": -5604436.94
      },
      {
        "periodo": 202602,
        "valor": 9268712.95,
        "delta": -7257600.07
      },
      {
        "periodo": 202603,
        "valor": 5369774.47,
        "delta": -3898938.48
      },
      {
        "periodo": 202604,
        "valor": 8378236.35,
        "delta": 3008461.88
      },
      {
        "periodo": 202605,
        "valor": 8064070.64,
        "delta": -314165.71
      },
      {
        "periodo": 202606,
        "valor": 12100903.48,
        "delta": 4036832.84
      },
      {
        "periodo": 202607,
        "valor": 10065012.93,
        "delta": -2035890.55
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 270753.0,
    "valor_anterior": 777868.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -12020192.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -7906293.0,
        "delta": 4113899.0
      },
      {
        "periodo": 202509,
        "valor": -9713799.0,
        "delta": -1807506.0
      },
      {
        "periodo": 202510,
        "valor": -8122825.0,
        "delta": 1590974.0
      },
      {
        "periodo": 202511,
        "valor": -9886320.0,
        "delta": -1763495.0
      },
      {
        "periodo": 202512,
        "valor": 1653473.0,
        "delta": 11539793.0
      },
      {
        "periodo": 202601,
        "valor": 358185.0,
        "delta": -1295288.0
      },
      {
        "periodo": 202602,
        "valor": 339756.0,
        "delta": -18429.0
      },
      {
        "periodo": 202603,
        "valor": 363425.0,
        "delta": 23669.0
      },
      {
        "periodo": 202604,
        "valor": 384526.0,
        "delta": 21101.0
      },
      {
        "periodo": 202605,
        "valor": 314635.0,
        "delta": -69891.0
      },
      {
        "periodo": 202606,
        "valor": 777868.0,
        "delta": 463233.0
      },
      {
        "periodo": 202607,
        "valor": 270753.0,
        "delta": -507115.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 106792634.11000001,
    "valor_anterior": 64326111.26999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 110139995.34,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 103442059.51,
        "delta": -6697935.83
      },
      {
        "periodo": 202509,
        "valor": 32598589.82,
        "delta": -70843469.69
      },
      {
        "periodo": 202510,
        "valor": 149979127.63,
        "delta": 117380537.81
      },
      {
        "periodo": 202511,
        "valor": 100516643.67,
        "delta": -49462483.96
      },
      {
        "periodo": 202512,
        "valor": 115503246.11,
        "delta": 14986602.44
      },
      {
        "periodo": 202601,
        "valor": 102224274.39,
        "delta": -13278971.72
      },
      {
        "periodo": 202602,
        "valor": 74042953.92,
        "delta": -28181320.47
      },
      {
        "periodo": 202603,
        "valor": 25869214.54,
        "delta": -48173739.38
      },
      {
        "periodo": 202604,
        "valor": 110172026.39,
        "delta": 84302811.85
      },
      {
        "periodo": 202605,
        "valor": 119830266.98,
        "delta": 9658240.59
      },
      {
        "periodo": 202606,
        "valor": 64326111.27,
        "delta": -55504155.71
      },
      {
        "periodo": 202607,
        "valor": 106792634.11,
        "delta": 42466522.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 34610469.7,
    "valor_anterior": 23876078.840000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 29957093.54,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11663517.9,
        "delta": -18293575.64
      },
      {
        "periodo": 202509,
        "valor": 4301358.29,
        "delta": -7362159.61
      },
      {
        "periodo": 202510,
        "valor": 13652074.84,
        "delta": 9350716.55
      },
      {
        "periodo": 202511,
        "valor": 16091619.89,
        "delta": 2439545.05
      },
      {
        "periodo": 202512,
        "valor": -7133351.13,
        "delta": -23224971.02
      },
      {
        "periodo": 202601,
        "valor": 17609006.63,
        "delta": 24742357.76
      },
      {
        "periodo": 202602,
        "valor": 19860834.12,
        "delta": 2251827.49
      },
      {
        "periodo": 202603,
        "valor": 13642633.92,
        "delta": -6218200.2
      },
      {
        "periodo": 202604,
        "valor": 12442259.38,
        "delta": -1200374.54
      },
      {
        "periodo": 202605,
        "valor": 18469972.53,
        "delta": 6027713.15
      },
      {
        "periodo": 202606,
        "valor": 23876078.84,
        "delta": 5406106.31
      },
      {
        "periodo": 202607,
        "valor": 34610469.7,
        "delta": 10734390.86
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": -9397123.0,
    "valor_anterior": 16422639.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22008241.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28182127.0,
        "delta": 6173886.0
      },
      {
        "periodo": 202509,
        "valor": 31456323.0,
        "delta": 3274196.0
      },
      {
        "periodo": 202510,
        "valor": 29170650.0,
        "delta": -2285673.0
      },
      {
        "periodo": 202511,
        "valor": 20918745.0,
        "delta": -8251905.0
      },
      {
        "periodo": 202512,
        "valor": 2422923.0,
        "delta": -18495822.0
      },
      {
        "periodo": 202601,
        "valor": 23669922.0,
        "delta": 21246999.0
      },
      {
        "periodo": 202602,
        "valor": 29181563.0,
        "delta": 5511641.0
      },
      {
        "periodo": 202603,
        "valor": 4532401.0,
        "delta": -24649162.0
      },
      {
        "periodo": 202604,
        "valor": -12616344.0,
        "delta": -17148745.0
      },
      {
        "periodo": 202605,
        "valor": 30956283.0,
        "delta": 43572627.0
      },
      {
        "periodo": 202606,
        "valor": 16422639.0,
        "delta": -14533644.0
      },
      {
        "periodo": 202607,
        "valor": -9397123.0,
        "delta": -25819762.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 121476795.0,
    "valor_anterior": 153465432.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 61946953.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 154287189.0,
        "delta": 92340236.0
      },
      {
        "periodo": 202509,
        "valor": 101121383.0,
        "delta": -53165806.0
      },
      {
        "periodo": 202510,
        "valor": 120200411.0,
        "delta": 19079028.0
      },
      {
        "periodo": 202511,
        "valor": 110035702.0,
        "delta": -10164709.0
      },
      {
        "periodo": 202512,
        "valor": 75868049.0,
        "delta": -34167653.0
      },
      {
        "periodo": 202601,
        "valor": 91597397.0,
        "delta": 15729348.0
      },
      {
        "periodo": 202602,
        "valor": 69755268.0,
        "delta": -21842129.0
      },
      {
        "periodo": 202603,
        "valor": 113742640.0,
        "delta": 43987372.0
      },
      {
        "periodo": 202604,
        "valor": 114047780.0,
        "delta": 305140.0
      },
      {
        "periodo": 202605,
        "valor": 133795892.0,
        "delta": 19748112.0
      },
      {
        "periodo": 202606,
        "valor": 153465432.0,
        "delta": 19669540.0
      },
      {
        "periodo": 202607,
        "valor": 121476795.0,
        "delta": -31988637.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 19148620.0,
    "valor_anterior": 4311836.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2433354.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16535136.0,
        "delta": 14101782.0
      },
      {
        "periodo": 202509,
        "valor": 8222172.0,
        "delta": -8312964.0
      },
      {
        "periodo": 202510,
        "valor": 11564275.0,
        "delta": 3342103.0
      },
      {
        "periodo": 202511,
        "valor": 11176276.0,
        "delta": -387999.0
      },
      {
        "periodo": 202512,
        "valor": 3359803.0,
        "delta": -7816473.0
      },
      {
        "periodo": 202601,
        "valor": 8255819.0,
        "delta": 4896016.0
      },
      {
        "periodo": 202602,
        "valor": 8107789.0,
        "delta": -148030.0
      },
      {
        "periodo": 202603,
        "valor": 15188214.0,
        "delta": 7080425.0
      },
      {
        "periodo": 202604,
        "valor": 8758719.0,
        "delta": -6429495.0
      },
      {
        "periodo": 202605,
        "valor": 10588893.0,
        "delta": 1830174.0
      },
      {
        "periodo": 202606,
        "valor": 4311836.0,
        "delta": -6277057.0
      },
      {
        "periodo": 202607,
        "valor": 19148620.0,
        "delta": 14836784.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 16646734.760000005,
    "valor_anterior": 19572677.549999997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30185579.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25631317.65,
        "delta": -4554262.07
      },
      {
        "periodo": 202509,
        "valor": 59269117.2,
        "delta": 33637799.55
      },
      {
        "periodo": 202510,
        "valor": 32439165.32,
        "delta": -26829951.88
      },
      {
        "periodo": 202511,
        "valor": 33654932.43,
        "delta": 1215767.11
      },
      {
        "periodo": 202512,
        "valor": 16027224.87,
        "delta": -17627707.56
      },
      {
        "periodo": 202601,
        "valor": 27642180.04,
        "delta": 11614955.17
      },
      {
        "periodo": 202602,
        "valor": 23908341.45,
        "delta": -3733838.59
      },
      {
        "periodo": 202603,
        "valor": 11794766.71,
        "delta": -12113574.74
      },
      {
        "periodo": 202604,
        "valor": 21546454.89,
        "delta": 9751688.18
      },
      {
        "periodo": 202605,
        "valor": 17306998.97,
        "delta": -4239455.92
      },
      {
        "periodo": 202606,
        "valor": 19572677.55,
        "delta": 2265678.58
      },
      {
        "periodo": 202607,
        "valor": 16646734.76,
        "delta": -2925942.79
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 6889676.539999999,
    "valor_anterior": 10004298.04,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25457260.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28322598.62,
        "delta": 2865337.9
      },
      {
        "periodo": 202509,
        "valor": 7320453.96,
        "delta": -21002144.66
      },
      {
        "periodo": 202510,
        "valor": 10283121.22,
        "delta": 2962667.26
      },
      {
        "periodo": 202511,
        "valor": -2035108.22,
        "delta": -12318229.44
      },
      {
        "periodo": 202512,
        "valor": 8793353.25,
        "delta": 10828461.47
      },
      {
        "periodo": 202601,
        "valor": 6879981.62,
        "delta": -1913371.63
      },
      {
        "periodo": 202602,
        "valor": -6986306.12,
        "delta": -13866287.74
      },
      {
        "periodo": 202603,
        "valor": 17847791.31,
        "delta": 24834097.43
      },
      {
        "periodo": 202604,
        "valor": 7349781.58,
        "delta": -10498009.73
      },
      {
        "periodo": 202605,
        "valor": 3615885.04,
        "delta": -3733896.54
      },
      {
        "periodo": 202606,
        "valor": 10004298.04,
        "delta": 6388413.0
      },
      {
        "periodo": 202607,
        "valor": 6889676.54,
        "delta": -3114621.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 27892068.0,
    "valor_anterior": 32894428.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30909163.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29196640.0,
        "delta": -1712523.0
      },
      {
        "periodo": 202509,
        "valor": 28559177.0,
        "delta": -637463.0
      },
      {
        "periodo": 202510,
        "valor": 27513602.0,
        "delta": -1045575.0
      },
      {
        "periodo": 202511,
        "valor": 30274573.0,
        "delta": 2760971.0
      },
      {
        "periodo": 202512,
        "valor": 16241023.0,
        "delta": -14033550.0
      },
      {
        "periodo": 202601,
        "valor": 26453931.0,
        "delta": 10212908.0
      },
      {
        "periodo": 202602,
        "valor": 24675089.0,
        "delta": -1778842.0
      },
      {
        "periodo": 202603,
        "valor": 27301340.0,
        "delta": 2626251.0
      },
      {
        "periodo": 202604,
        "valor": 26833381.0,
        "delta": -467959.0
      },
      {
        "periodo": 202605,
        "valor": 24735626.0,
        "delta": -2097755.0
      },
      {
        "periodo": 202606,
        "valor": 32894428.0,
        "delta": 8158802.0
      },
      {
        "periodo": 202607,
        "valor": 27892068.0,
        "delta": -5002360.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 2489854.0,
    "valor_anterior": 4308163.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2938158.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4107502.0,
        "delta": 1169344.0
      },
      {
        "periodo": 202509,
        "valor": 4214856.0,
        "delta": 107354.0
      },
      {
        "periodo": 202510,
        "valor": 5775547.0,
        "delta": 1560691.0
      },
      {
        "periodo": 202511,
        "valor": -332213.0,
        "delta": -6107760.0
      },
      {
        "periodo": 202512,
        "valor": 2015152.0,
        "delta": 2347365.0
      },
      {
        "periodo": 202601,
        "valor": 1923823.0,
        "delta": -91329.0
      },
      {
        "periodo": 202602,
        "valor": 3061869.0,
        "delta": 1138046.0
      },
      {
        "periodo": 202603,
        "valor": 6608093.0,
        "delta": 3546224.0
      },
      {
        "periodo": 202604,
        "valor": 1289734.0,
        "delta": -5318359.0
      },
      {
        "periodo": 202605,
        "valor": 6047929.0,
        "delta": 4758195.0
      },
      {
        "periodo": 202606,
        "valor": 4308163.0,
        "delta": -1739766.0
      },
      {
        "periodo": 202607,
        "valor": 2489854.0,
        "delta": -1818309.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": -40638522.0,
    "valor_anterior": 45124213.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13364790.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -319890.0,
        "delta": -13684680.0
      },
      {
        "periodo": 202509,
        "valor": 87418270.0,
        "delta": 87738160.0
      },
      {
        "periodo": 202510,
        "valor": 8560155.0,
        "delta": -78858115.0
      },
      {
        "periodo": 202511,
        "valor": 3918694.0,
        "delta": -4641461.0
      },
      {
        "periodo": 202512,
        "valor": 71007451.0,
        "delta": 67088757.0
      },
      {
        "periodo": 202601,
        "valor": 12659503.0,
        "delta": -58347948.0
      },
      {
        "periodo": 202602,
        "valor": 9243645.0,
        "delta": -3415858.0
      },
      {
        "periodo": 202603,
        "valor": 51081947.0,
        "delta": 41838302.0
      },
      {
        "periodo": 202604,
        "valor": -32102796.0,
        "delta": -83184743.0
      },
      {
        "periodo": 202605,
        "valor": 24955747.0,
        "delta": 57058543.0
      },
      {
        "periodo": 202606,
        "valor": 45124213.0,
        "delta": 20168466.0
      },
      {
        "periodo": 202607,
        "valor": -40638522.0,
        "delta": -85762735.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": -58943350.44999999,
    "valor_anterior": -55054612.06,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -76223256.01,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -77709934.19,
        "delta": -1486678.18
      },
      {
        "periodo": 202509,
        "valor": -57733947.76,
        "delta": 19975986.43
      },
      {
        "periodo": 202510,
        "valor": -58956638.86,
        "delta": -1222691.1
      },
      {
        "periodo": 202511,
        "valor": -59164865.52,
        "delta": -208226.66
      },
      {
        "periodo": 202512,
        "valor": -54344435.65,
        "delta": 4820429.87
      },
      {
        "periodo": 202601,
        "valor": -67592844.03,
        "delta": -13248408.38
      },
      {
        "periodo": 202602,
        "valor": -62507215.68,
        "delta": 5085628.35
      },
      {
        "periodo": 202603,
        "valor": -54111948.77,
        "delta": 8395266.91
      },
      {
        "periodo": 202604,
        "valor": -67132761.2,
        "delta": -13020812.43
      },
      {
        "periodo": 202605,
        "valor": -75924079.71,
        "delta": -8791318.51
      },
      {
        "periodo": 202606,
        "valor": -55054612.06,
        "delta": 20869467.65
      },
      {
        "periodo": 202607,
        "valor": -58943350.45,
        "delta": -3888738.39
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 11000539.110000014,
    "valor_anterior": 43268312.47999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2632337.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3276902.54,
        "delta": 644564.85
      },
      {
        "periodo": 202509,
        "valor": 3145838.44,
        "delta": -131064.1
      },
      {
        "periodo": 202510,
        "valor": 1854958.07,
        "delta": -1290880.37
      },
      {
        "periodo": 202511,
        "valor": 3374486.0,
        "delta": 1519527.93
      },
      {
        "periodo": 202512,
        "valor": 3452108.41,
        "delta": 77622.41
      },
      {
        "periodo": 202601,
        "valor": 4070817.54,
        "delta": 618709.13
      },
      {
        "periodo": 202602,
        "valor": 39912097.84,
        "delta": 35841280.3
      },
      {
        "periodo": 202603,
        "valor": 33092849.63,
        "delta": -6819248.21
      },
      {
        "periodo": 202604,
        "valor": 8110007.07,
        "delta": -24982842.56
      },
      {
        "periodo": 202605,
        "valor": 18951940.45,
        "delta": 10841933.38
      },
      {
        "periodo": 202606,
        "valor": 43268312.48,
        "delta": 24316372.03
      },
      {
        "periodo": 202607,
        "valor": 11000539.11,
        "delta": -32267773.37
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": -205153217.0,
    "valor_anterior": -206513845.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -102558631.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -128527166.0,
        "delta": -25968535.0
      },
      {
        "periodo": 202509,
        "valor": -145704206.0,
        "delta": -17177040.0
      },
      {
        "periodo": 202510,
        "valor": -182513628.0,
        "delta": -36809422.0
      },
      {
        "periodo": 202511,
        "valor": -179607035.0,
        "delta": 2906593.0
      },
      {
        "periodo": 202512,
        "valor": -177471367.0,
        "delta": 2135668.0
      },
      {
        "periodo": 202601,
        "valor": -193198151.0,
        "delta": -15726784.0
      },
      {
        "periodo": 202602,
        "valor": -187222045.0,
        "delta": 5976106.0
      },
      {
        "periodo": 202603,
        "valor": -192836342.0,
        "delta": -5614297.0
      },
      {
        "periodo": 202604,
        "valor": -196142792.0,
        "delta": -3306450.0
      },
      {
        "periodo": 202605,
        "valor": -214456716.0,
        "delta": -18313924.0
      },
      {
        "periodo": 202606,
        "valor": -206513845.0,
        "delta": 7942871.0
      },
      {
        "periodo": 202607,
        "valor": -205153217.0,
        "delta": 1360628.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": -85113920.13,
    "valor_anterior": -80654242.29000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": -271040998.9,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": -29046783.95,
        "delta": 241994214.95
      },
      {
        "periodo": 202601,
        "valor": -29983714.4,
        "delta": -936930.45
      },
      {
        "periodo": 202602,
        "valor": -48053013.59,
        "delta": -18069299.19
      },
      {
        "periodo": 202603,
        "valor": -74949599.49,
        "delta": -26896585.9
      },
      {
        "periodo": 202604,
        "valor": -64993164.94,
        "delta": 9956434.55
      },
      {
        "periodo": 202605,
        "valor": -73870315.6,
        "delta": -8877150.66
      },
      {
        "periodo": 202606,
        "valor": -80654242.29,
        "delta": -6783926.69
      },
      {
        "periodo": 202607,
        "valor": -85113920.13,
        "delta": -4459677.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": -222600489.0,
    "valor_anterior": -475759690.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": -539541526.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": -84205676.0,
        "delta": 455335850.0
      },
      {
        "periodo": 202605,
        "valor": -232856027.0,
        "delta": -148650351.0
      },
      {
        "periodo": 202606,
        "valor": -475759690.0,
        "delta": -242903663.0
      },
      {
        "periodo": 202607,
        "valor": -222600489.0,
        "delta": 253159201.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 25084174103.440002,
    "valor_anterior": 23337684200.92,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 24662750611.22,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24743125367.93,
        "delta": 80374756.71
      },
      {
        "periodo": 202509,
        "valor": 24944719050.82,
        "delta": 201593682.89
      },
      {
        "periodo": 202510,
        "valor": 24922486175.3,
        "delta": -22232875.52
      },
      {
        "periodo": 202511,
        "valor": 26356735544.85,
        "delta": 1434249369.55
      },
      {
        "periodo": 202512,
        "valor": 26898594436.61,
        "delta": 541858891.7601
      },
      {
        "periodo": 202601,
        "valor": 28340857701.22,
        "delta": 1442263264.61
      },
      {
        "periodo": 202602,
        "valor": 20750010036.62,
        "delta": -7590847664.6
      },
      {
        "periodo": 202603,
        "valor": 31730287924.93,
        "delta": 10980277888.31
      },
      {
        "periodo": 202604,
        "valor": 24093045128.7,
        "delta": -7637242796.23
      },
      {
        "periodo": 202605,
        "valor": 21105970825.76,
        "delta": -2987074302.94
      },
      {
        "periodo": 202606,
        "valor": 23337684200.92,
        "delta": 2231713375.16
      },
      {
        "periodo": 202607,
        "valor": 25084174103.44,
        "delta": 1746489902.52
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 21531823238.48999,
    "valor_anterior": 20025078400.240005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21029800860.07,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19817604755.93,
        "delta": -1212196104.14
      },
      {
        "periodo": 202509,
        "valor": 17307103541.07,
        "delta": -2510501214.86
      },
      {
        "periodo": 202510,
        "valor": 18525646381.7,
        "delta": 1218542840.63
      },
      {
        "periodo": 202511,
        "valor": 22095513236.93,
        "delta": 3569866855.23
      },
      {
        "periodo": 202512,
        "valor": 20374099477.19,
        "delta": -1721413759.74
      },
      {
        "periodo": 202601,
        "valor": 22736176162.53,
        "delta": 2362076685.34
      },
      {
        "periodo": 202602,
        "valor": 15681066933.62,
        "delta": -7055109228.91
      },
      {
        "periodo": 202603,
        "valor": 27291251611.97,
        "delta": 11610184678.35
      },
      {
        "periodo": 202604,
        "valor": 18951587930.59,
        "delta": -8339663681.38
      },
      {
        "periodo": 202605,
        "valor": 17269749647.96,
        "delta": -1681838282.63
      },
      {
        "periodo": 202606,
        "valor": 20025078400.24,
        "delta": 2755328752.28
      },
      {
        "periodo": 202607,
        "valor": 21531823238.49,
        "delta": 1506744838.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 304209711.8900001,
    "valor_anterior": 32629961.799999952,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1106199209.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -543298799.24,
        "delta": 562900410.03
      },
      {
        "periodo": 202509,
        "valor": 2092894807.96,
        "delta": 2636193607.2
      },
      {
        "periodo": 202510,
        "valor": 510066147.46,
        "delta": -1582828660.5
      },
      {
        "periodo": 202511,
        "valor": 392459302.81,
        "delta": -117606844.65
      },
      {
        "periodo": 202512,
        "valor": 582838213.43,
        "delta": 190378910.62
      },
      {
        "periodo": 202601,
        "valor": 546566105.08,
        "delta": -36272108.35
      },
      {
        "periodo": 202602,
        "valor": 449400976.11,
        "delta": -97165128.97
      },
      {
        "periodo": 202603,
        "valor": 203822855.02,
        "delta": -245578121.09
      },
      {
        "periodo": 202604,
        "valor": 323054466.86,
        "delta": 119231611.84
      },
      {
        "periodo": 202605,
        "valor": 451092030.99,
        "delta": 128037564.13
      },
      {
        "periodo": 202606,
        "valor": 32629961.8,
        "delta": -418462069.19
      },
      {
        "periodo": 202607,
        "valor": 304209711.89,
        "delta": 271579750.09
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 1151667136.0500011,
    "valor_anterior": 1338671831.0199995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1778190422.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2159430228.54,
        "delta": 381239806.15
      },
      {
        "periodo": 202509,
        "valor": 1947579535.73,
        "delta": -211850692.81
      },
      {
        "periodo": 202510,
        "valor": 1967305577.36,
        "delta": 19726041.63
      },
      {
        "periodo": 202511,
        "valor": 831432934.73,
        "delta": -1135872642.63
      },
      {
        "periodo": 202512,
        "valor": 2124613973.56,
        "delta": 1293181038.83
      },
      {
        "periodo": 202601,
        "valor": 1872368370.17,
        "delta": -252245603.39
      },
      {
        "periodo": 202602,
        "valor": 1553955439.98,
        "delta": -318412930.19
      },
      {
        "periodo": 202603,
        "valor": 1406804957.74,
        "delta": -147150482.24
      },
      {
        "periodo": 202604,
        "valor": 2136606460.31,
        "delta": 729801502.57
      },
      {
        "periodo": 202605,
        "valor": 1499351765.26,
        "delta": -637254695.05
      },
      {
        "periodo": 202606,
        "valor": 1338671831.02,
        "delta": -160679934.24
      },
      {
        "periodo": 202607,
        "valor": 1151667136.05,
        "delta": -187004694.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 1863755127.4099998,
    "valor_anterior": 1966501033.3500004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1739008839.16,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1930932670.49,
        "delta": 191923831.33
      },
      {
        "periodo": 202509,
        "valor": 1888376393.51,
        "delta": -42556276.98
      },
      {
        "periodo": 202510,
        "valor": 2026099199.14,
        "delta": 137722805.63
      },
      {
        "periodo": 202511,
        "valor": 2048389082.62,
        "delta": 22289883.48
      },
      {
        "periodo": 202512,
        "valor": 1899064406.86,
        "delta": -149324675.76
      },
      {
        "periodo": 202601,
        "valor": 1819879293.71,
        "delta": -79185113.15
      },
      {
        "periodo": 202602,
        "valor": 1468016475.2,
        "delta": -351862818.51
      },
      {
        "periodo": 202603,
        "valor": 1903678666.57,
        "delta": 435662191.37
      },
      {
        "periodo": 202604,
        "valor": 1887462519.35,
        "delta": -16216147.22
      },
      {
        "periodo": 202605,
        "valor": 1884827003.85,
        "delta": -2635515.5
      },
      {
        "periodo": 202606,
        "valor": 1966501033.35,
        "delta": 81674029.5
      },
      {
        "periodo": 202607,
        "valor": 1863755127.41,
        "delta": -102745905.94
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": 376169664.03999996,
    "valor_anterior": 415878284.18000007,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 260946330.88,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 384148377.51,
        "delta": 123202046.63
      },
      {
        "periodo": 202509,
        "valor": 566431702.85,
        "delta": 182283325.34
      },
      {
        "periodo": 202510,
        "valor": 377091902.19,
        "delta": -189339800.66
      },
      {
        "periodo": 202511,
        "valor": 90787391.12,
        "delta": -286304511.07
      },
      {
        "periodo": 202512,
        "valor": 476200143.06,
        "delta": 385412751.94
      },
      {
        "periodo": 202601,
        "valor": 370288260.7,
        "delta": -105911882.36
      },
      {
        "periodo": 202602,
        "valor": 307646333.32,
        "delta": -62641927.38
      },
      {
        "periodo": 202603,
        "valor": 371185652.95,
        "delta": 63539319.63
      },
      {
        "periodo": 202604,
        "valor": 195244555.59,
        "delta": -175941097.36
      },
      {
        "periodo": 202605,
        "valor": 387878632.16,
        "delta": 192634076.57
      },
      {
        "periodo": 202606,
        "valor": 415878284.18,
        "delta": 27999652.02
      },
      {
        "periodo": 202607,
        "valor": 376169664.04,
        "delta": -39708620.14
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100180,
    "label": "Resultado de Operaciones Continuas",
    "valor_actual": -143450774.43999958,
    "valor_anterior": -441075309.6700001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 961003367.99,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 994308134.7,
        "delta": 33304766.71
      },
      {
        "periodo": 202509,
        "valor": 1142333069.7,
        "delta": 148024935.0
      },
      {
        "periodo": 202510,
        "valor": 1516276967.45,
        "delta": 373943897.75
      },
      {
        "periodo": 202511,
        "valor": 898153596.64,
        "delta": -618123370.81
      },
      {
        "periodo": 202512,
        "valor": 1441778222.51,
        "delta": 543624625.87
      },
      {
        "periodo": 202601,
        "valor": 995579509.03,
        "delta": -446198713.48
      },
      {
        "periodo": 202602,
        "valor": 1289923878.39,
        "delta": 294344369.36
      },
      {
        "periodo": 202603,
        "valor": 553544180.68,
        "delta": -736379697.71
      },
      {
        "periodo": 202604,
        "valor": 599089196.0,
        "delta": 45545015.32
      },
      {
        "periodo": 202605,
        "valor": -386928254.46,
        "delta": -986017450.46
      },
      {
        "periodo": 202606,
        "valor": -441075309.67,
        "delta": -54147055.21
      },
      {
        "periodo": 202607,
        "valor": -143450774.44,
        "delta": 297624535.23
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": -2.49,
        "delta": -2.49
      },
      {
        "periodo": 202511,
        "valor": 2.49,
        "delta": 4.98
      },
      {
        "periodo": 202512,
        "valor": 0.05,
        "delta": -2.44
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -0.05
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": -28760413.170000017,
    "valor_anterior": -27938249.72,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 4929358.77,
        "delta": 4929358.77
      },
      {
        "periodo": 202601,
        "valor": -48713971.77,
        "delta": -53643330.54
      },
      {
        "periodo": 202602,
        "valor": -51239793.02,
        "delta": -2525821.25
      },
      {
        "periodo": 202603,
        "valor": -29228496.12,
        "delta": 22011296.9
      },
      {
        "periodo": 202604,
        "valor": -45141199.14,
        "delta": -15912703.02
      },
      {
        "periodo": 202605,
        "valor": -37314418.05,
        "delta": 7826781.09
      },
      {
        "periodo": 202606,
        "valor": -27938249.72,
        "delta": 9376168.33
      },
      {
        "periodo": 202607,
        "valor": -28760413.17,
        "delta": -822163.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1291544159.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -1291544159.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": -28760413.170000017,
    "valor_anterior": -27938249.72,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1291544159.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -1291544159.0
      },
      {
        "periodo": 202509,
        "valor": -1291544159.0,
        "delta": -1291544159.0
      },
      {
        "periodo": 202510,
        "valor": -2.49,
        "delta": 1291544156.51
      },
      {
        "periodo": 202511,
        "valor": 2.49,
        "delta": 4.98
      },
      {
        "periodo": 202512,
        "valor": 4929358.82,
        "delta": 4929356.33
      },
      {
        "periodo": 202601,
        "valor": -48713971.77,
        "delta": -53643330.59
      },
      {
        "periodo": 202602,
        "valor": -51239793.02,
        "delta": -2525821.25
      },
      {
        "periodo": 202603,
        "valor": -29228496.12,
        "delta": 22011296.9
      },
      {
        "periodo": 202604,
        "valor": -45141199.14,
        "delta": -15912703.02
      },
      {
        "periodo": 202605,
        "valor": -37314418.05,
        "delta": 7826781.09
      },
      {
        "periodo": 202606,
        "valor": -27938249.72,
        "delta": 9376168.33
      },
      {
        "periodo": 202607,
        "valor": -28760413.17,
        "delta": -822163.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": -28760413.170000017,
    "valor_anterior": -27938249.72,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": -2.49,
        "delta": -2.49
      },
      {
        "periodo": 202511,
        "valor": 2.49,
        "delta": 4.98
      },
      {
        "periodo": 202512,
        "valor": 4929358.82,
        "delta": 4929356.33
      },
      {
        "periodo": 202601,
        "valor": -48713971.77,
        "delta": -53643330.59
      },
      {
        "periodo": 202602,
        "valor": -51239793.02,
        "delta": -2525821.25
      },
      {
        "periodo": 202603,
        "valor": -29228496.12,
        "delta": 22011296.9
      },
      {
        "periodo": 202604,
        "valor": -45141199.14,
        "delta": -15912703.02
      },
      {
        "periodo": 202605,
        "valor": -37314418.05,
        "delta": 7826781.09
      },
      {
        "periodo": 202606,
        "valor": -27938249.72,
        "delta": 9376168.33
      },
      {
        "periodo": 202607,
        "valor": -28760413.17,
        "delta": -822163.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1291544159.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -1291544159.0
      },
      {
        "periodo": 202509,
        "valor": -1291544159.0,
        "delta": -1291544159.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 1291544159.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100181,
    "label": "Operaciones Discontinuadas",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 544061611767.06,
    "valor_anterior": 542011584237.56,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 486300072120.32,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 492087337629.34,
        "delta": 5787265509.02
      },
      {
        "periodo": 202509,
        "valor": 503424348430.59,
        "delta": 11337010801.25
      },
      {
        "periodo": 202510,
        "valor": 509930408494.71,
        "delta": 6506060064.12
      },
      {
        "periodo": 202511,
        "valor": 527670788920.7001,
        "delta": 17740380425.9901
      },
      {
        "periodo": 202512,
        "valor": 521572320826.79,
        "delta": -6098468093.9101
      },
      {
        "periodo": 202601,
        "valor": 523123056820.19,
        "delta": 1550735993.4
      },
      {
        "periodo": 202602,
        "valor": 523776186904.15,
        "delta": 653130083.96
      },
      {
        "periodo": 202603,
        "valor": 529170081496.69,
        "delta": 5393894592.54
      },
      {
        "periodo": 202604,
        "valor": 530927255302.82,
        "delta": 1757173806.13
      },
      {
        "periodo": 202605,
        "valor": 536417785601.49,
        "delta": 5490530298.67
      },
      {
        "periodo": 202606,
        "valor": 542011584237.56,
        "delta": 5593798636.07
      },
      {
        "periodo": 202607,
        "valor": 544061611767.06,
        "delta": 2050027529.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 2200309921207.82,
    "valor_anterior": 2196534521928.73,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2015513163671.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2012068882959.98,
        "delta": -3444280711.3101
      },
      {
        "periodo": 202509,
        "valor": 2016789398853.8997,
        "delta": 4720515893.9197
      },
      {
        "periodo": 202510,
        "valor": 2034145102027.15,
        "delta": 17355703173.2502
      },
      {
        "periodo": 202511,
        "valor": 2065493725187.71,
        "delta": 31348623160.5601
      },
      {
        "periodo": 202512,
        "valor": 2089062083692.68,
        "delta": 23568358504.97
      },
      {
        "periodo": 202601,
        "valor": 2096460628694.56,
        "delta": 7398545001.8801
      },
      {
        "periodo": 202602,
        "valor": 2095562247539.28,
        "delta": -898381155.28
      },
      {
        "periodo": 202603,
        "valor": 2146296884614.96,
        "delta": 50734637075.6799
      },
      {
        "periodo": 202604,
        "valor": 2156488041082.36,
        "delta": 10191156467.4001
      },
      {
        "periodo": 202605,
        "valor": 2176489836466.95,
        "delta": 20001795384.5898
      },
      {
        "periodo": 202606,
        "valor": 2196534521928.73,
        "delta": 20044685461.78
      },
      {
        "periodo": 202607,
        "valor": 2200309921207.82,
        "delta": 3775399279.0898
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 1007048775730.0,
    "valor_anterior": 1003490008722.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 934236434483.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 929316632501.0,
        "delta": -4919801982.0
      },
      {
        "periodo": 202509,
        "valor": 926658927737.0,
        "delta": -2657704764.0
      },
      {
        "periodo": 202510,
        "valor": 937892034131.0,
        "delta": 11233106394.0
      },
      {
        "periodo": 202511,
        "valor": 948768079258.0,
        "delta": 10876045127.0
      },
      {
        "periodo": 202512,
        "valor": 985628515267.0,
        "delta": 36860436009.0
      },
      {
        "periodo": 202601,
        "valor": 987020613260.0,
        "delta": 1392097993.0
      },
      {
        "periodo": 202602,
        "valor": 988797162688.0,
        "delta": 1776549428.0
      },
      {
        "periodo": 202603,
        "valor": 986446347433.0,
        "delta": -2350815255.0
      },
      {
        "periodo": 202604,
        "valor": 989156212141.0,
        "delta": 2709864708.0
      },
      {
        "periodo": 202605,
        "valor": 995432852953.0,
        "delta": 6276640812.0
      },
      {
        "periodo": 202606,
        "valor": 1003490008722.0,
        "delta": 8057155769.0
      },
      {
        "periodo": 202607,
        "valor": 1007048775730.0,
        "delta": 3558767008.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 446456179560.0,
    "valor_anterior": 448940943386.00006,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 493741750737.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 490989814062.0,
        "delta": -2751936675.0
      },
      {
        "periodo": 202509,
        "valor": 483659837055.0,
        "delta": -7329977007.0
      },
      {
        "periodo": 202510,
        "valor": 483167085815.0,
        "delta": -492751240.0
      },
      {
        "periodo": 202511,
        "valor": 480322808600.0,
        "delta": -2844277215.0
      },
      {
        "periodo": 202512,
        "valor": 478622457523.0,
        "delta": -1700351077.0
      },
      {
        "periodo": 202601,
        "valor": 476286946238.0,
        "delta": -2335511285.0
      },
      {
        "periodo": 202602,
        "valor": 472079165682.0,
        "delta": -4207780556.0
      },
      {
        "periodo": 202603,
        "valor": 457135226655.0,
        "delta": -14943939027.0
      },
      {
        "periodo": 202604,
        "valor": 455586507548.0,
        "delta": -1548719107.0
      },
      {
        "periodo": 202605,
        "valor": 457617081848.0,
        "delta": 2030574300.0
      },
      {
        "periodo": 202606,
        "valor": 448940943386.0001,
        "delta": -8676138461.9999
      },
      {
        "periodo": 202607,
        "valor": 446456179560.0,
        "delta": -2484763826.0001
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 297586945212.61,
    "valor_anterior": 296354432214.87,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 264080647704.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 266968830227.37,
        "delta": 2888182523.18
      },
      {
        "periodo": 202509,
        "valor": 268199205438.4,
        "delta": 1230375211.03
      },
      {
        "periodo": 202510,
        "valor": 269283100232.84,
        "delta": 1083894794.44
      },
      {
        "periodo": 202511,
        "valor": 273908380409.69,
        "delta": 4625280176.85
      },
      {
        "periodo": 202512,
        "valor": 278283141102.12,
        "delta": 4374760692.43
      },
      {
        "periodo": 202601,
        "valor": 277222691550.27,
        "delta": -1060449551.85
      },
      {
        "periodo": 202602,
        "valor": 278760539646.77,
        "delta": 1537848096.5
      },
      {
        "periodo": 202603,
        "valor": 286439583687.33,
        "delta": 7679044040.56
      },
      {
        "periodo": 202604,
        "valor": 285926201489.51,
        "delta": -513382197.82
      },
      {
        "periodo": 202605,
        "valor": 290126310312.21,
        "delta": 4200108822.7
      },
      {
        "periodo": 202606,
        "valor": 296354432214.87,
        "delta": 6228121902.66
      },
      {
        "periodo": 202607,
        "valor": 297586945212.61,
        "delta": 1232512997.74
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 496855994853.99994,
    "valor_anterior": 498415113333.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 461921580241.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 466601032654.0,
        "delta": 4679452413.0
      },
      {
        "periodo": 202509,
        "valor": 467303129543.0,
        "delta": 702096889.0
      },
      {
        "periodo": 202510,
        "valor": 471582646653.0,
        "delta": 4279517110.0
      },
      {
        "periodo": 202511,
        "valor": 475911427356.0,
        "delta": 4328780703.0
      },
      {
        "periodo": 202512,
        "valor": 476395338194.9999,
        "delta": 483910838.9999
      },
      {
        "periodo": 202601,
        "valor": 480464371270.0,
        "delta": 4069033075.0001
      },
      {
        "periodo": 202602,
        "valor": 484729205499.0,
        "delta": 4264834229.0
      },
      {
        "periodo": 202603,
        "valor": 487189480435.0,
        "delta": 2460274936.0
      },
      {
        "periodo": 202604,
        "valor": 488154771375.0,
        "delta": 965290940.0
      },
      {
        "periodo": 202605,
        "valor": 494964231344.0,
        "delta": 6809459969.0
      },
      {
        "periodo": 202606,
        "valor": 498415113333.0,
        "delta": 3450881989.0
      },
      {
        "periodo": 202607,
        "valor": 496855994853.9999,
        "delta": -1559118479.0001
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 96456453988.0,
    "valor_anterior": 96463328787.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 83334565506.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 84449257768.0,
        "delta": 1114692262.0
      },
      {
        "periodo": 202509,
        "valor": 83911034545.0,
        "delta": -538223223.0
      },
      {
        "periodo": 202510,
        "valor": 85635777125.0,
        "delta": 1724742580.0
      },
      {
        "periodo": 202511,
        "valor": 87207479280.0,
        "delta": 1571702155.0
      },
      {
        "periodo": 202512,
        "valor": 92728971274.0,
        "delta": 5521491994.0
      },
      {
        "periodo": 202601,
        "valor": 93068364653.0,
        "delta": 339393379.0
      },
      {
        "periodo": 202602,
        "valor": 93855986208.0,
        "delta": 787621555.0
      },
      {
        "periodo": 202603,
        "valor": 95540931912.0,
        "delta": 1684945704.0
      },
      {
        "periodo": 202604,
        "valor": 94350960593.0,
        "delta": -1189971319.0
      },
      {
        "periodo": 202605,
        "valor": 95291215837.0,
        "delta": 940255244.0
      },
      {
        "periodo": 202606,
        "valor": 96463328787.0,
        "delta": 1172112950.0
      },
      {
        "periodo": 202607,
        "valor": 96456453988.0,
        "delta": -6874799.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 547770069174.0,
    "valor_anterior": 542886338751.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 527986991177.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 532170627505.0,
        "delta": 4183636328.0
      },
      {
        "periodo": 202509,
        "valor": 529339294929.0,
        "delta": -2831332576.0
      },
      {
        "periodo": 202510,
        "valor": 533407092274.0,
        "delta": 4067797345.0
      },
      {
        "periodo": 202511,
        "valor": 534227191995.0,
        "delta": 820099721.0
      },
      {
        "periodo": 202512,
        "valor": 535207165736.0,
        "delta": 979973741.0
      },
      {
        "periodo": 202601,
        "valor": 530852220492.0,
        "delta": -4354945244.0
      },
      {
        "periodo": 202602,
        "valor": 531078987939.0,
        "delta": 226767447.0
      },
      {
        "periodo": 202603,
        "valor": 536805577736.0,
        "delta": 5726589797.0
      },
      {
        "periodo": 202604,
        "valor": 537420137332.0001,
        "delta": 614559596.0001
      },
      {
        "periodo": 202605,
        "valor": 539438521161.0,
        "delta": 2018383828.9999
      },
      {
        "periodo": 202606,
        "valor": 542886338751.0,
        "delta": 3447817590.0
      },
      {
        "periodo": 202607,
        "valor": 547770069174.0,
        "delta": 4883730423.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 192614306531.64996,
    "valor_anterior": 192800298926.66,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 184818186834.85,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 186462781386.0,
        "delta": 1644594551.15
      },
      {
        "periodo": 202509,
        "valor": 188494801369.32,
        "delta": 2032019983.32
      },
      {
        "periodo": 202510,
        "valor": 188951636496.93,
        "delta": 456835127.61
      },
      {
        "periodo": 202511,
        "valor": 189274221370.09,
        "delta": 322584873.16
      },
      {
        "periodo": 202512,
        "valor": 191278420746.7,
        "delta": 2004199376.61
      },
      {
        "periodo": 202601,
        "valor": 192658632857.4,
        "delta": 1380212110.7
      },
      {
        "periodo": 202602,
        "valor": 185800446011.77,
        "delta": -6858186845.63
      },
      {
        "periodo": 202603,
        "valor": 187000660194.14,
        "delta": 1200214182.37
      },
      {
        "periodo": 202604,
        "valor": 189792259425.49,
        "delta": 2791599231.35
      },
      {
        "periodo": 202605,
        "valor": 192526752906.22,
        "delta": 2734493480.73
      },
      {
        "periodo": 202606,
        "valor": 192800298926.66,
        "delta": 273546020.44
      },
      {
        "periodo": 202607,
        "valor": 192614306531.65,
        "delta": -185992395.01
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 57684686433.0,
    "valor_anterior": 56682396553.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 49386651297.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 49339463081.0,
        "delta": -47188216.0
      },
      {
        "periodo": 202509,
        "valor": 49754432341.0,
        "delta": 414969260.0
      },
      {
        "periodo": 202510,
        "valor": 50608634993.0,
        "delta": 854202652.0
      },
      {
        "periodo": 202511,
        "valor": 52311733550.0,
        "delta": 1703098557.0
      },
      {
        "periodo": 202512,
        "valor": 51911959665.0,
        "delta": -399773885.0
      },
      {
        "periodo": 202601,
        "valor": 51863347396.0,
        "delta": -48612269.0
      },
      {
        "periodo": 202602,
        "valor": 52159507148.0,
        "delta": 296159752.0
      },
      {
        "periodo": 202603,
        "valor": 53658423087.0,
        "delta": 1498915939.0
      },
      {
        "periodo": 202604,
        "valor": 54330087593.0,
        "delta": 671664506.0
      },
      {
        "periodo": 202605,
        "valor": 55641093143.0,
        "delta": 1311005550.0
      },
      {
        "periodo": 202606,
        "valor": 56682396553.0,
        "delta": 1041303410.0
      },
      {
        "periodo": 202607,
        "valor": 57684686433.0,
        "delta": 1002289880.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 27757711346.0,
    "valor_anterior": 27418329344.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 29730698556.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 30139469685.0,
        "delta": 408771129.0
      },
      {
        "periodo": 202509,
        "valor": 29578352905.0,
        "delta": -561116780.0
      },
      {
        "periodo": 202510,
        "valor": 29454492434.0,
        "delta": -123860471.0
      },
      {
        "periodo": 202511,
        "valor": 30124362147.0,
        "delta": 669869713.0
      },
      {
        "periodo": 202512,
        "valor": 30589744358.0,
        "delta": 465382211.0
      },
      {
        "periodo": 202601,
        "valor": 29808733547.0,
        "delta": -781010811.0
      },
      {
        "periodo": 202602,
        "valor": 29521816273.0,
        "delta": -286917274.0
      },
      {
        "periodo": 202603,
        "valor": 28423547098.0,
        "delta": -1098269175.0
      },
      {
        "periodo": 202604,
        "valor": 28511695673.0,
        "delta": 88148575.0
      },
      {
        "periodo": 202605,
        "valor": 28351880018.0,
        "delta": -159815655.0
      },
      {
        "periodo": 202606,
        "valor": 27418329344.0,
        "delta": -933550674.0
      },
      {
        "periodo": 202607,
        "valor": 27757711346.0,
        "delta": 339382002.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 67888876961.0,
    "valor_anterior": 68040972714.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 68150646307.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 68901896935.0,
        "delta": 751250628.0
      },
      {
        "periodo": 202509,
        "valor": 69893806048.0,
        "delta": 991909113.0
      },
      {
        "periodo": 202510,
        "valor": 70086528533.0,
        "delta": 192722485.0
      },
      {
        "periodo": 202511,
        "valor": 70935003883.0,
        "delta": 848475350.0
      },
      {
        "periodo": 202512,
        "valor": 69503802459.0,
        "delta": -1431201424.0
      },
      {
        "periodo": 202601,
        "valor": 70249788021.0,
        "delta": 745985562.0
      },
      {
        "periodo": 202602,
        "valor": 70524029416.0,
        "delta": 274241395.0
      },
      {
        "periodo": 202603,
        "valor": 69353191371.0,
        "delta": -1170838045.0
      },
      {
        "periodo": 202604,
        "valor": 68920241197.0,
        "delta": -432950174.0
      },
      {
        "periodo": 202605,
        "valor": 69278389691.0,
        "delta": 358148494.0
      },
      {
        "periodo": 202606,
        "valor": 68040972714.0,
        "delta": -1237416977.0
      },
      {
        "periodo": 202607,
        "valor": 67888876961.0,
        "delta": -152095753.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 1261818183638.38,
    "valor_anterior": 1234758334332.43,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1148959585368.24,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1158655450802.65,
        "delta": 9695865434.4099
      },
      {
        "periodo": 202509,
        "valor": 1164148354753.76,
        "delta": 5492903951.1101
      },
      {
        "periodo": 202510,
        "valor": 1186567368182.9,
        "delta": 22419013429.1399
      },
      {
        "periodo": 202511,
        "valor": 1219401047411.41,
        "delta": 32833679228.51
      },
      {
        "periodo": 202512,
        "valor": 1231946084329.52,
        "delta": 12545036918.1101
      },
      {
        "periodo": 202601,
        "valor": 1212495647301.42,
        "delta": -19450437028.1001
      },
      {
        "periodo": 202602,
        "valor": 1200288489688.87,
        "delta": -12207157612.5498
      },
      {
        "periodo": 202603,
        "valor": 1213112564619.04,
        "delta": 12824074930.1699
      },
      {
        "periodo": 202604,
        "valor": 1217242346606.51,
        "delta": 4129781987.47
      },
      {
        "periodo": 202605,
        "valor": 1226444586200.54,
        "delta": 9202239594.03
      },
      {
        "periodo": 202606,
        "valor": 1234758334332.43,
        "delta": 8313748131.8899
      },
      {
        "periodo": 202607,
        "valor": 1261818183638.38,
        "delta": 27059849305.95
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 46805649902.0,
    "valor_anterior": 45803376036.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 41861689535.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 43913816520.0,
        "delta": 2052126985.0
      },
      {
        "periodo": 202509,
        "valor": 45436847170.0,
        "delta": 1523030650.0
      },
      {
        "periodo": 202510,
        "valor": 44382432956.0,
        "delta": -1054414214.0
      },
      {
        "periodo": 202511,
        "valor": 44509238192.0,
        "delta": 126805236.0
      },
      {
        "periodo": 202512,
        "valor": 44516738187.0,
        "delta": 7499995.0
      },
      {
        "periodo": 202601,
        "valor": 42048483083.0,
        "delta": -2468255104.0
      },
      {
        "periodo": 202602,
        "valor": 43045845768.0,
        "delta": 997362685.0
      },
      {
        "periodo": 202603,
        "valor": 44900530216.0,
        "delta": 1854684448.0
      },
      {
        "periodo": 202604,
        "valor": 43997985017.0,
        "delta": -902545199.0
      },
      {
        "periodo": 202605,
        "valor": 43305575018.0,
        "delta": -692409999.0
      },
      {
        "periodo": 202606,
        "valor": 45803376036.0,
        "delta": 2497801018.0
      },
      {
        "periodo": 202607,
        "valor": 46805649902.0,
        "delta": 1002273866.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 7418721848.0,
    "valor_anterior": 7584066794.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6866094915.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7477133506.0,
        "delta": 611038591.0
      },
      {
        "periodo": 202509,
        "valor": 5841381443.0,
        "delta": -1635752063.0
      },
      {
        "periodo": 202510,
        "valor": 8988013317.0,
        "delta": 3146631874.0
      },
      {
        "periodo": 202511,
        "valor": 8047175943.0,
        "delta": -940837374.0
      },
      {
        "periodo": 202512,
        "valor": 8097031848.0,
        "delta": 49855905.0
      },
      {
        "periodo": 202601,
        "valor": 6390949077.0,
        "delta": -1706082771.0
      },
      {
        "periodo": 202602,
        "valor": 7429362901.0,
        "delta": 1038413824.0
      },
      {
        "periodo": 202603,
        "valor": 9352720660.0,
        "delta": 1923357759.0
      },
      {
        "periodo": 202604,
        "valor": 8618180392.0,
        "delta": -734540268.0
      },
      {
        "periodo": 202605,
        "valor": 7956178204.0,
        "delta": -662002188.0
      },
      {
        "periodo": 202606,
        "valor": 7584066794.0,
        "delta": -372111410.0
      },
      {
        "periodo": 202607,
        "valor": 7418721848.0,
        "delta": -165344946.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 24650823984.0,
    "valor_anterior": 24474641335.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25545122399.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24842326109.0,
        "delta": -702796290.0
      },
      {
        "periodo": 202509,
        "valor": 23631979119.0,
        "delta": -1210346990.0
      },
      {
        "periodo": 202510,
        "valor": 21132987128.0,
        "delta": -2498991991.0
      },
      {
        "periodo": 202511,
        "valor": 21358685592.0,
        "delta": 225698464.0
      },
      {
        "periodo": 202512,
        "valor": 22098821182.0,
        "delta": 740135590.0
      },
      {
        "periodo": 202601,
        "valor": 22952808889.0,
        "delta": 853987707.0
      },
      {
        "periodo": 202602,
        "valor": 24652618566.0,
        "delta": 1699809677.0
      },
      {
        "periodo": 202603,
        "valor": 24621486321.0,
        "delta": -31132245.0
      },
      {
        "periodo": 202604,
        "valor": 24578089713.0,
        "delta": -43396608.0
      },
      {
        "periodo": 202605,
        "valor": 24720795604.0,
        "delta": 142705891.0
      },
      {
        "periodo": 202606,
        "valor": 24474641335.0,
        "delta": -246154269.0
      },
      {
        "periodo": 202607,
        "valor": 24650823984.0,
        "delta": 176182649.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 61567175668.84,
    "valor_anterior": 63059126424.84,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 55679670252.34,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55196869182.23,
        "delta": -482801070.11
      },
      {
        "periodo": 202509,
        "valor": 54595986018.76,
        "delta": -600883163.47
      },
      {
        "periodo": 202510,
        "valor": 56279342832.9,
        "delta": 1683356814.14
      },
      {
        "periodo": 202511,
        "valor": 56770923753.26,
        "delta": 491580920.36
      },
      {
        "periodo": 202512,
        "valor": 63531646148.23,
        "delta": 6760722394.97
      },
      {
        "periodo": 202601,
        "valor": 63194184089.89,
        "delta": -337462058.34
      },
      {
        "periodo": 202602,
        "valor": 63295261985.32,
        "delta": 101077895.43
      },
      {
        "periodo": 202603,
        "valor": 64633034267.84,
        "delta": 1337772282.52
      },
      {
        "periodo": 202604,
        "valor": 64236018764.26,
        "delta": -397015503.58
      },
      {
        "periodo": 202605,
        "valor": 63883881818.91,
        "delta": -352136945.35
      },
      {
        "periodo": 202606,
        "valor": 63059126424.84,
        "delta": -824755394.07
      },
      {
        "periodo": 202607,
        "valor": 61567175668.84,
        "delta": -1491950756.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 69557866953.0,
    "valor_anterior": 70827717672.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 60019799622.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 59826378868.0,
        "delta": -193420754.0
      },
      {
        "periodo": 202509,
        "valor": 62000729441.0,
        "delta": 2174350573.0
      },
      {
        "periodo": 202510,
        "valor": 62177112859.0,
        "delta": 176383418.0
      },
      {
        "periodo": 202511,
        "valor": 63047959000.0,
        "delta": 870846141.0
      },
      {
        "periodo": 202512,
        "valor": 66019539713.0,
        "delta": 2971580713.0
      },
      {
        "periodo": 202601,
        "valor": 66566730753.0,
        "delta": 547191040.0
      },
      {
        "periodo": 202602,
        "valor": 68028033414.0,
        "delta": 1461302661.0
      },
      {
        "periodo": 202603,
        "valor": 69192490092.0,
        "delta": 1164456678.0
      },
      {
        "periodo": 202604,
        "valor": 68616136670.0,
        "delta": -576353422.0
      },
      {
        "periodo": 202605,
        "valor": 70064346898.0,
        "delta": 1448210228.0
      },
      {
        "periodo": 202606,
        "valor": 70827717672.0,
        "delta": 763370774.0
      },
      {
        "periodo": 202607,
        "valor": 69557866953.0,
        "delta": -1269850719.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 153108285562.55,
    "valor_anterior": 145303047045.85,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 167718591079.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 162838462235.99,
        "delta": -4880128843.54
      },
      {
        "periodo": 202509,
        "valor": 157921075873.59,
        "delta": -4917386362.4
      },
      {
        "periodo": 202510,
        "valor": 160432813984.34,
        "delta": 2511738110.75
      },
      {
        "periodo": 202511,
        "valor": 157994170997.88,
        "delta": -2438642986.46
      },
      {
        "periodo": 202512,
        "valor": 157536082750.48,
        "delta": -458088247.4
      },
      {
        "periodo": 202601,
        "valor": 156148550899.24,
        "delta": -1387531851.24
      },
      {
        "periodo": 202602,
        "valor": 146602319976.72,
        "delta": -9546230922.52
      },
      {
        "periodo": 202603,
        "valor": 156531493617.15,
        "delta": 9929173640.43
      },
      {
        "periodo": 202604,
        "valor": 145639963437.25,
        "delta": -10891530179.9
      },
      {
        "periodo": 202605,
        "valor": 143340024579.11,
        "delta": -2299938858.14
      },
      {
        "periodo": 202606,
        "valor": 145303047045.85,
        "delta": 1963022466.74
      },
      {
        "periodo": 202607,
        "valor": 153108285562.55,
        "delta": 7805238516.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 210354560660.7,
    "valor_anterior": 209279210414.51,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 201079602501.58,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 204657336576.24,
        "delta": 3577734074.66
      },
      {
        "periodo": 202509,
        "valor": 203994870158.9,
        "delta": -662466417.34
      },
      {
        "periodo": 202510,
        "valor": 206885836653.25,
        "delta": 2890966494.35
      },
      {
        "periodo": 202511,
        "valor": 208667913353.51,
        "delta": 1782076700.26
      },
      {
        "periodo": 202512,
        "valor": 208486650063.16,
        "delta": -181263290.35
      },
      {
        "periodo": 202601,
        "valor": 212008286802.58,
        "delta": 3521636739.42
      },
      {
        "periodo": 202602,
        "valor": 211823937806.55,
        "delta": -184348996.03
      },
      {
        "periodo": 202603,
        "valor": 208269899328.97,
        "delta": -3554038477.58
      },
      {
        "periodo": 202604,
        "valor": 208770115825.77,
        "delta": 500216496.8
      },
      {
        "periodo": 202605,
        "valor": 208241359949.49,
        "delta": -528755876.28
      },
      {
        "periodo": 202606,
        "valor": 209279210414.51,
        "delta": 1037850465.02
      },
      {
        "periodo": 202607,
        "valor": 210354560660.7,
        "delta": 1075350246.19
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 29847621036.000004,
    "valor_anterior": 29684916744.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9513442689.22,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10101269311.66,
        "delta": 587826622.44
      },
      {
        "periodo": 202509,
        "valor": 22058982069.0,
        "delta": 11957712757.34
      },
      {
        "periodo": 202510,
        "valor": 22161140165.0,
        "delta": 102158096.0
      },
      {
        "periodo": 202511,
        "valor": 23717247156.0,
        "delta": 1556106991.0
      },
      {
        "periodo": 202512,
        "valor": 23730683283.0,
        "delta": 13436127.0
      },
      {
        "periodo": 202601,
        "valor": 24042407750.0,
        "delta": 311724467.0
      },
      {
        "periodo": 202602,
        "valor": 24623200198.0,
        "delta": 580792448.0
      },
      {
        "periodo": 202603,
        "valor": 26569633409.0,
        "delta": 1946433211.0
      },
      {
        "periodo": 202604,
        "valor": 27482964738.0,
        "delta": 913331329.0
      },
      {
        "periodo": 202605,
        "valor": 28591278816.0,
        "delta": 1108314078.0
      },
      {
        "periodo": 202606,
        "valor": 29684916744.0,
        "delta": 1093637928.0
      },
      {
        "periodo": 202607,
        "valor": 29847621036.0,
        "delta": 162704292.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 63344225774.0,
    "valor_anterior": 62518987550.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 58883972262.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 59110491326.0,
        "delta": 226519064.0
      },
      {
        "periodo": 202509,
        "valor": 58108318914.0,
        "delta": -1002172412.0
      },
      {
        "periodo": 202510,
        "valor": 59605438543.0,
        "delta": 1497119629.0
      },
      {
        "periodo": 202511,
        "valor": 62195503319.0,
        "delta": 2590064776.0
      },
      {
        "periodo": 202512,
        "valor": 61886449497.0,
        "delta": -309053822.0
      },
      {
        "periodo": 202601,
        "valor": 59623337239.0,
        "delta": -2263112258.0
      },
      {
        "periodo": 202602,
        "valor": 61087618525.0,
        "delta": 1464281286.0
      },
      {
        "periodo": 202603,
        "valor": 63486784896.0,
        "delta": 2399166371.0
      },
      {
        "periodo": 202604,
        "valor": 61307139129.0,
        "delta": -2179645767.0
      },
      {
        "periodo": 202605,
        "valor": 60139791662.0,
        "delta": -1167347467.0
      },
      {
        "periodo": 202606,
        "valor": 62518987550.0,
        "delta": 2379195888.0
      },
      {
        "periodo": 202607,
        "valor": 63344225774.0,
        "delta": 825238224.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 116329031221.0,
    "valor_anterior": 113834026949.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 80241469263.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 81408031058.0,
        "delta": 1166561795.0
      },
      {
        "periodo": 202509,
        "valor": 86876488318.0,
        "delta": 5468457260.0
      },
      {
        "periodo": 202510,
        "valor": 85878221705.0,
        "delta": -998266613.0
      },
      {
        "periodo": 202511,
        "valor": 88282648874.0,
        "delta": 2404427169.0
      },
      {
        "periodo": 202512,
        "valor": 100444091561.0,
        "delta": 12161442687.0
      },
      {
        "periodo": 202601,
        "valor": 97811277148.0,
        "delta": -2632814413.0
      },
      {
        "periodo": 202602,
        "valor": 100973253149.0,
        "delta": 3161976001.0
      },
      {
        "periodo": 202603,
        "valor": 102129299543.0,
        "delta": 1156046394.0
      },
      {
        "periodo": 202604,
        "valor": 106219255472.0,
        "delta": 4089955929.0
      },
      {
        "periodo": 202605,
        "valor": 109929783706.0,
        "delta": 3710528234.0
      },
      {
        "periodo": 202606,
        "valor": 113834026949.0,
        "delta": 3904243243.0
      },
      {
        "periodo": 202607,
        "valor": 116329031221.0,
        "delta": 2495004272.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 30094916377.0,
    "valor_anterior": 30307161715.999996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28375644160.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29803299266.0,
        "delta": 1427655106.0
      },
      {
        "periodo": 202509,
        "valor": 29502670844.0,
        "delta": -300628422.0
      },
      {
        "periodo": 202510,
        "valor": 28654772458.0,
        "delta": -847898386.0
      },
      {
        "periodo": 202511,
        "valor": 29200842753.0,
        "delta": 546070295.0
      },
      {
        "periodo": 202512,
        "valor": 30776162711.0,
        "delta": 1575319958.0
      },
      {
        "periodo": 202601,
        "valor": 30180335300.0,
        "delta": -595827411.0
      },
      {
        "periodo": 202602,
        "valor": 30222628386.0,
        "delta": 42293086.0
      },
      {
        "periodo": 202603,
        "valor": 30792528920.0,
        "delta": 569900534.0
      },
      {
        "periodo": 202604,
        "valor": 30560836695.0,
        "delta": -231692225.0
      },
      {
        "periodo": 202605,
        "valor": 30350352122.0,
        "delta": -210484573.0
      },
      {
        "periodo": 202606,
        "valor": 30307161716.0,
        "delta": -43190406.0
      },
      {
        "periodo": 202607,
        "valor": 30094916377.0,
        "delta": -212245339.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 245443295.0,
    "valor_anterior": 610652743.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18997184223.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13701469044.0,
        "delta": -5295715179.0
      },
      {
        "periodo": 202509,
        "valor": 1742195278.0,
        "delta": -11959273766.0
      },
      {
        "periodo": 202510,
        "valor": 1726769737.0,
        "delta": -15425541.0
      },
      {
        "periodo": 202511,
        "valor": 1302280193.0,
        "delta": -424489544.0
      },
      {
        "periodo": 202512,
        "valor": 891247102.0,
        "delta": -411033091.0
      },
      {
        "periodo": 202601,
        "valor": 837034445.0,
        "delta": -54212657.0
      },
      {
        "periodo": 202602,
        "valor": 818580445.0,
        "delta": -18454000.0
      },
      {
        "periodo": 202603,
        "valor": 647999324.0,
        "delta": -170581121.0
      },
      {
        "periodo": 202604,
        "valor": 637736282.0,
        "delta": -10263042.0
      },
      {
        "periodo": 202605,
        "valor": 635075552.0,
        "delta": -2660730.0
      },
      {
        "periodo": 202606,
        "valor": 610652743.0,
        "delta": -24422809.0
      },
      {
        "periodo": 202607,
        "valor": 245443295.0,
        "delta": -365209448.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 87607194760.5,
    "valor_anterior": 85418558228.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 69846328875.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 79132111178.1,
        "delta": 9285782302.2
      },
      {
        "periodo": 202509,
        "valor": 78285568729.8,
        "delta": -846542448.3
      },
      {
        "periodo": 202510,
        "valor": 79286988935.39,
        "delta": 1001420205.59
      },
      {
        "periodo": 202511,
        "valor": 81148276395.9,
        "delta": 1861287460.51
      },
      {
        "periodo": 202512,
        "valor": 82285275248.09,
        "delta": 1136998852.19
      },
      {
        "periodo": 202601,
        "valor": 82396002353.42,
        "delta": 110727105.33
      },
      {
        "periodo": 202602,
        "valor": 83565840985.81,
        "delta": 1169838632.39
      },
      {
        "periodo": 202603,
        "valor": 84621294794.49,
        "delta": 1055453808.68
      },
      {
        "periodo": 202604,
        "valor": 83703930588.24,
        "delta": -917364206.25
      },
      {
        "periodo": 202605,
        "valor": 84514189786.9,
        "delta": 810259198.66
      },
      {
        "periodo": 202606,
        "valor": 85418558228.25,
        "delta": 904368441.35
      },
      {
        "periodo": 202607,
        "valor": 87607194760.5,
        "delta": 2188636532.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 1737729554.0,
    "valor_anterior": 1745084880.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 753479030.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 807732719.0,
        "delta": 54253689.0
      },
      {
        "periodo": 202509,
        "valor": 845319949.0,
        "delta": 37587230.0
      },
      {
        "periodo": 202510,
        "valor": 897894008.0,
        "delta": 52574059.0
      },
      {
        "periodo": 202511,
        "valor": 997695158.0,
        "delta": 99801150.0
      },
      {
        "periodo": 202512,
        "valor": 1031517206.0,
        "delta": 33822048.0
      },
      {
        "periodo": 202601,
        "valor": 1084696958.0,
        "delta": 53179752.0
      },
      {
        "periodo": 202602,
        "valor": 1183402903.0,
        "delta": 98705945.0
      },
      {
        "periodo": 202603,
        "valor": 1379421061.0,
        "delta": 196018158.0
      },
      {
        "periodo": 202604,
        "valor": 1500801976.0,
        "delta": 121380915.0
      },
      {
        "periodo": 202605,
        "valor": 1723952143.0,
        "delta": 223150167.0
      },
      {
        "periodo": 202606,
        "valor": 1745084880.0,
        "delta": 21132737.0
      },
      {
        "periodo": 202607,
        "valor": 1737729554.0,
        "delta": -7355326.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 301700000.0,
    "valor_anterior": 292500000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 244166075.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 244074767.0,
        "delta": -91308.0
      },
      {
        "periodo": 202509,
        "valor": 241494682.0,
        "delta": -2580085.0
      },
      {
        "periodo": 202510,
        "valor": 238746135.0,
        "delta": -2748547.0
      },
      {
        "periodo": 202511,
        "valor": 223500000.0,
        "delta": -15246135.0
      },
      {
        "periodo": 202512,
        "valor": 225000000.0,
        "delta": 1500000.0
      },
      {
        "periodo": 202601,
        "valor": 225000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 225000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 225000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 225000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 280043963.0,
        "delta": 55043963.0
      },
      {
        "periodo": 202606,
        "valor": 292500000.0,
        "delta": 12456037.0
      },
      {
        "periodo": 202607,
        "valor": 301700000.0,
        "delta": 9200000.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 35956092470.0,
    "valor_anterior": 35507199182.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30750111316.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 31460825303.0,
        "delta": 710713987.0
      },
      {
        "periodo": 202509,
        "valor": 31736663479.0,
        "delta": 275838176.0
      },
      {
        "periodo": 202510,
        "valor": 32189683841.0,
        "delta": 453020362.0
      },
      {
        "periodo": 202511,
        "valor": 31883978762.0,
        "delta": -305705079.0
      },
      {
        "periodo": 202512,
        "valor": 32109403569.0,
        "delta": 225424807.0
      },
      {
        "periodo": 202601,
        "valor": 32865747270.0,
        "delta": 756343701.0
      },
      {
        "periodo": 202602,
        "valor": 33113770111.0,
        "delta": 248022841.0
      },
      {
        "periodo": 202603,
        "valor": 33775439874.0,
        "delta": 661669763.0
      },
      {
        "periodo": 202604,
        "valor": 34833116342.0,
        "delta": 1057676468.0
      },
      {
        "periodo": 202605,
        "valor": 34630736940.0,
        "delta": -202379402.0
      },
      {
        "periodo": 202606,
        "valor": 35507199182.0,
        "delta": 876462242.0
      },
      {
        "periodo": 202607,
        "valor": 35956092470.0,
        "delta": 448893288.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 8513966594.0,
    "valor_anterior": 8389249619.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7276972022.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7404209130.0,
        "delta": 127237108.0
      },
      {
        "periodo": 202509,
        "valor": 7533604076.0,
        "delta": 129394946.0
      },
      {
        "periodo": 202510,
        "valor": 7698465813.0,
        "delta": 164861737.0
      },
      {
        "periodo": 202511,
        "valor": 7951339962.0,
        "delta": 252874149.0
      },
      {
        "periodo": 202512,
        "valor": 7817462009.0,
        "delta": -133877953.0
      },
      {
        "periodo": 202601,
        "valor": 8056481499.0,
        "delta": 239019490.0
      },
      {
        "periodo": 202602,
        "valor": 8233452457.0,
        "delta": 176970958.0
      },
      {
        "periodo": 202603,
        "valor": 8309479550.0,
        "delta": 76027093.0
      },
      {
        "periodo": 202604,
        "valor": 8343519485.0,
        "delta": 34039935.0
      },
      {
        "periodo": 202605,
        "valor": 8356289312.0,
        "delta": 12769827.0
      },
      {
        "periodo": 202606,
        "valor": 8389249619.0,
        "delta": 32960307.0
      },
      {
        "periodo": 202607,
        "valor": 8513966594.0,
        "delta": 124716975.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16743919238.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6940855395.0,
        "delta": -9803063843.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 10794083871.0,
    "valor_anterior": 10940443257.999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10522092604.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10437396816.0,
        "delta": -84695788.0
      },
      {
        "periodo": 202509,
        "valor": 10461585842.0,
        "delta": 24189026.0
      },
      {
        "periodo": 202510,
        "valor": 10095733738.0,
        "delta": -365852104.0
      },
      {
        "periodo": 202511,
        "valor": 10276628616.0,
        "delta": 180894878.0
      },
      {
        "periodo": 202512,
        "valor": 10109265225.0,
        "delta": -167363391.0
      },
      {
        "periodo": 202601,
        "valor": 10196544166.0,
        "delta": 87278941.0
      },
      {
        "periodo": 202602,
        "valor": 10381183192.0,
        "delta": 184639026.0
      },
      {
        "periodo": 202603,
        "valor": 10254994908.0,
        "delta": -126188284.0
      },
      {
        "periodo": 202604,
        "valor": 10417899313.0,
        "delta": 162904405.0
      },
      {
        "periodo": 202605,
        "valor": 10693919652.0,
        "delta": 276020339.0
      },
      {
        "periodo": 202606,
        "valor": 10940443258.0,
        "delta": 246523606.0
      },
      {
        "periodo": 202607,
        "valor": 10794083871.0,
        "delta": -146359387.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 21399078546.0,
    "valor_anterior": 20633840330.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12586945581.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12973416789.0,
        "delta": 386471208.0
      },
      {
        "periodo": 202509,
        "valor": 13865611383.0,
        "delta": 892194594.0
      },
      {
        "periodo": 202510,
        "valor": 14504241193.0,
        "delta": 638629810.0
      },
      {
        "periodo": 202511,
        "valor": 15288609085.0,
        "delta": 784367892.0
      },
      {
        "periodo": 202512,
        "valor": 15859543175.0,
        "delta": 570934090.0
      },
      {
        "periodo": 202601,
        "valor": 16744507324.0,
        "delta": 884964149.0
      },
      {
        "periodo": 202602,
        "valor": 17454161519.0,
        "delta": 709654195.0
      },
      {
        "periodo": 202603,
        "valor": 18114147027.0,
        "delta": 659985508.0
      },
      {
        "periodo": 202604,
        "valor": 19043519997.0,
        "delta": 929372970.0
      },
      {
        "periodo": 202605,
        "valor": 19902514997.0,
        "delta": 858995000.0
      },
      {
        "periodo": 202606,
        "valor": 20633840330.0,
        "delta": 731325333.0
      },
      {
        "periodo": 202607,
        "valor": 21399078546.0,
        "delta": 765238216.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 525284342.0,
    "valor_anterior": 534373423.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 381862345.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 404250303.0,
        "delta": 22387958.0
      },
      {
        "periodo": 202509,
        "valor": 438991776.0,
        "delta": 34741473.0
      },
      {
        "periodo": 202510,
        "valor": 462877256.0,
        "delta": 23885480.0
      },
      {
        "periodo": 202511,
        "valor": 484369654.0,
        "delta": 21492398.0
      },
      {
        "periodo": 202512,
        "valor": 506303116.0,
        "delta": 21933462.0
      },
      {
        "periodo": 202601,
        "valor": 505096178.0,
        "delta": -1206938.0
      },
      {
        "periodo": 202602,
        "valor": 502487353.0,
        "delta": -2608825.0
      },
      {
        "periodo": 202603,
        "valor": 521429369.0,
        "delta": 18942016.0
      },
      {
        "periodo": 202604,
        "valor": 522959164.0,
        "delta": 1529795.0
      },
      {
        "periodo": 202605,
        "valor": 523964100.0,
        "delta": 1004936.0
      },
      {
        "periodo": 202606,
        "valor": 534373423.0,
        "delta": 10409323.0
      },
      {
        "periodo": 202607,
        "valor": 525284342.0,
        "delta": -9089081.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 14138278487.27,
    "valor_anterior": 13855921189.02,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12477746862.02,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12581466051.29,
        "delta": 103719189.27
      },
      {
        "periodo": 202509,
        "valor": 12639049899.39,
        "delta": 57583848.1
      },
      {
        "periodo": 202510,
        "valor": 12739998812.82,
        "delta": 100948913.43
      },
      {
        "periodo": 202511,
        "valor": 12735849936.98,
        "delta": -4148875.84
      },
      {
        "periodo": 202512,
        "valor": 13222475547.97,
        "delta": 486625610.99
      },
      {
        "periodo": 202601,
        "valor": 13230582344.82,
        "delta": 8106796.85
      },
      {
        "periodo": 202602,
        "valor": 13246870563.9,
        "delta": 16288219.08
      },
      {
        "periodo": 202603,
        "valor": 13450577849.64,
        "delta": 203707285.74
      },
      {
        "periodo": 202604,
        "valor": 13414723069.31,
        "delta": -35854780.33
      },
      {
        "periodo": 202605,
        "valor": 13632987429.9,
        "delta": 218264360.59
      },
      {
        "periodo": 202606,
        "valor": 13855921189.02,
        "delta": 222933759.12
      },
      {
        "periodo": 202607,
        "valor": 14138278487.27,
        "delta": 282357298.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 1266362868.0,
    "valor_anterior": 1201536096.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1640468088.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1565196007.0,
        "delta": -75272081.0
      },
      {
        "periodo": 202509,
        "valor": 1512995989.0,
        "delta": -52200018.0
      },
      {
        "periodo": 202510,
        "valor": 1479116239.0,
        "delta": -33879750.0
      },
      {
        "periodo": 202511,
        "valor": 1455458492.0,
        "delta": -23657747.0
      },
      {
        "periodo": 202512,
        "valor": 1488759384.0,
        "delta": 33300892.0
      },
      {
        "periodo": 202601,
        "valor": 1379919794.0,
        "delta": -108839590.0
      },
      {
        "periodo": 202602,
        "valor": 1361457447.0,
        "delta": -18462347.0
      },
      {
        "periodo": 202603,
        "valor": 1373149791.0,
        "delta": 11692344.0
      },
      {
        "periodo": 202604,
        "valor": 1361712095.0,
        "delta": -11437696.0
      },
      {
        "periodo": 202605,
        "valor": 1285042886.0,
        "delta": -76669209.0
      },
      {
        "periodo": 202606,
        "valor": 1201536096.0,
        "delta": -83506790.0
      },
      {
        "periodo": 202607,
        "valor": 1266362868.0,
        "delta": 64826772.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 50119723099.86,
    "valor_anterior": 49809234514.91,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 43235348847.59,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 43738995001.94,
        "delta": 503646154.35
      },
      {
        "periodo": 202509,
        "valor": 44154664378.87,
        "delta": 415669376.93
      },
      {
        "periodo": 202510,
        "valor": 45456765787.78,
        "delta": 1302101408.91
      },
      {
        "periodo": 202511,
        "valor": 46393594666.03,
        "delta": 936828878.25
      },
      {
        "periodo": 202512,
        "valor": 46217028852.18,
        "delta": -176565813.85
      },
      {
        "periodo": 202601,
        "valor": 46984756068.61,
        "delta": 767727216.43
      },
      {
        "periodo": 202602,
        "valor": 47403648397.07,
        "delta": 418892328.46
      },
      {
        "periodo": 202603,
        "valor": 48641792808.35,
        "delta": 1238144411.28
      },
      {
        "periodo": 202604,
        "valor": 49380614456.67,
        "delta": 738821648.32
      },
      {
        "periodo": 202605,
        "valor": 49949411393.61,
        "delta": 568796936.94
      },
      {
        "periodo": 202606,
        "valor": 49809234514.91,
        "delta": -140176878.7
      },
      {
        "periodo": 202607,
        "valor": 50119723099.86,
        "delta": 310488584.95
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 9420452930.45,
    "valor_anterior": 9061657668.28,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6995659313.83,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7229072075.54,
        "delta": 233412761.71
      },
      {
        "periodo": 202509,
        "valor": 7422878974.55,
        "delta": 193806899.01
      },
      {
        "periodo": 202510,
        "valor": 7766014313.84,
        "delta": 343135339.29
      },
      {
        "periodo": 202511,
        "valor": 7959168838.02,
        "delta": 193154524.18
      },
      {
        "periodo": 202512,
        "valor": 8100131413.37,
        "delta": 140962575.35
      },
      {
        "periodo": 202601,
        "valor": 8263751505.82,
        "delta": 163620092.45
      },
      {
        "periodo": 202602,
        "valor": 8621532591.84,
        "delta": 357781086.02
      },
      {
        "periodo": 202603,
        "valor": 8730796866.4,
        "delta": 109264274.56
      },
      {
        "periodo": 202604,
        "valor": 8806093407.33,
        "delta": 75296540.93
      },
      {
        "periodo": 202605,
        "valor": 9110614043.85,
        "delta": 304520636.52
      },
      {
        "periodo": 202606,
        "valor": 9061657668.28,
        "delta": -48956375.57
      },
      {
        "periodo": 202607,
        "valor": 9420452930.45,
        "delta": 358795262.17
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 5735906798.0,
    "valor_anterior": 5867555380.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4847786461.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4986133014.0,
        "delta": 138346553.0
      },
      {
        "periodo": 202509,
        "valor": 5056296336.0,
        "delta": 70163322.0
      },
      {
        "periodo": 202510,
        "valor": 5482384406.0,
        "delta": 426088070.0
      },
      {
        "periodo": 202511,
        "valor": 5286317699.0,
        "delta": -196066707.0
      },
      {
        "periodo": 202512,
        "valor": 5486377766.0,
        "delta": 200060067.0
      },
      {
        "periodo": 202601,
        "valor": 5361864823.0,
        "delta": -124512943.0
      },
      {
        "periodo": 202602,
        "valor": 5301157015.0,
        "delta": -60707808.0
      },
      {
        "periodo": 202603,
        "valor": 5075999498.0,
        "delta": -225157517.0
      },
      {
        "periodo": 202604,
        "valor": 4989167959.0,
        "delta": -86831539.0
      },
      {
        "periodo": 202605,
        "valor": 5231333916.0,
        "delta": 242165957.0
      },
      {
        "periodo": 202606,
        "valor": 5867555381.0,
        "delta": 636221465.0
      },
      {
        "periodo": 202607,
        "valor": 5735906798.0,
        "delta": -131648583.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 111525890886.0,
    "valor_anterior": 111183566138.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 100065775679.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 100285573934.0,
        "delta": 219798255.0
      },
      {
        "periodo": 202509,
        "valor": 101304317693.0,
        "delta": 1018743759.0
      },
      {
        "periodo": 202510,
        "valor": 102836404061.0,
        "delta": 1532086368.0
      },
      {
        "periodo": 202511,
        "valor": 103047714188.0,
        "delta": 211310127.0
      },
      {
        "periodo": 202512,
        "valor": 107462586025.0,
        "delta": 4414871837.0
      },
      {
        "periodo": 202601,
        "valor": 107426350855.0,
        "delta": -36235170.0
      },
      {
        "periodo": 202602,
        "valor": 110188146001.0,
        "delta": 2761795146.0
      },
      {
        "periodo": 202603,
        "valor": 112490740431.0,
        "delta": 2302594430.0
      },
      {
        "periodo": 202604,
        "valor": 111806640833.0,
        "delta": -684099598.0
      },
      {
        "periodo": 202605,
        "valor": 111030480217.0,
        "delta": -776160616.0
      },
      {
        "periodo": 202606,
        "valor": 111183566138.0,
        "delta": 153085921.0
      },
      {
        "periodo": 202607,
        "valor": 111525890886.0,
        "delta": 342324748.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 4115418620.0,
    "valor_anterior": 4010904875.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4552784399.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4488866096.0,
        "delta": -63918303.0
      },
      {
        "periodo": 202509,
        "valor": 4352655494.0,
        "delta": -136210602.0
      },
      {
        "periodo": 202510,
        "valor": 4089141601.0,
        "delta": -263513893.0
      },
      {
        "periodo": 202511,
        "valor": 4102034309.0,
        "delta": 12892708.0
      },
      {
        "periodo": 202512,
        "valor": 4023845748.0,
        "delta": -78188561.0
      },
      {
        "periodo": 202601,
        "valor": 3852684373.0,
        "delta": -171161375.0
      },
      {
        "periodo": 202602,
        "valor": 3796557817.0,
        "delta": -56126556.0
      },
      {
        "periodo": 202603,
        "valor": 3877796558.0,
        "delta": 81238741.0
      },
      {
        "periodo": 202604,
        "valor": 3966184918.0,
        "delta": 88388360.0
      },
      {
        "periodo": 202605,
        "valor": 3795727360.0,
        "delta": -170457558.0
      },
      {
        "periodo": 202606,
        "valor": 4010904875.0,
        "delta": 215177515.0
      },
      {
        "periodo": 202607,
        "valor": 4115418620.0,
        "delta": 104513745.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 7215073431.31,
    "valor_anterior": 7453308411.62,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6063780273.73,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6064050000.44,
        "delta": 269726.71
      },
      {
        "periodo": 202509,
        "valor": 6089653427.38,
        "delta": 25603426.94
      },
      {
        "periodo": 202510,
        "valor": 5851998516.46,
        "delta": -237654910.92
      },
      {
        "periodo": 202511,
        "valor": 2617640055.9,
        "delta": -3234358460.56
      },
      {
        "periodo": 202512,
        "valor": 2740035373.47,
        "delta": 122395317.57
      },
      {
        "periodo": 202601,
        "valor": 2811546109.15,
        "delta": 71510735.68
      },
      {
        "periodo": 202602,
        "valor": 3266334064.1,
        "delta": 454787954.95
      },
      {
        "periodo": 202603,
        "valor": 3059409039.36,
        "delta": -206925024.74
      },
      {
        "periodo": 202604,
        "valor": 7106010412.39,
        "delta": 4046601373.03
      },
      {
        "periodo": 202605,
        "valor": 7358557589.23,
        "delta": 252547176.84
      },
      {
        "periodo": 202606,
        "valor": 7453308411.62,
        "delta": 94750822.39
      },
      {
        "periodo": 202607,
        "valor": 7215073431.31,
        "delta": -238234980.31
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 4661344049.38,
    "valor_anterior": 4374387130.11,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3537130159.63,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2680198649.07,
        "delta": -856931510.56
      },
      {
        "periodo": 202509,
        "valor": 2572106704.65,
        "delta": -108091944.42
      },
      {
        "periodo": 202510,
        "valor": 2866966908.01,
        "delta": 294860203.36
      },
      {
        "periodo": 202511,
        "valor": 2815029798.91,
        "delta": -51937109.1
      },
      {
        "periodo": 202512,
        "valor": 2741187659.87,
        "delta": -73842139.04
      },
      {
        "periodo": 202601,
        "valor": 2878476035.48,
        "delta": 137288375.61
      },
      {
        "periodo": 202602,
        "valor": 3147121497.56,
        "delta": 268645462.08
      },
      {
        "periodo": 202603,
        "valor": 3499791884.58,
        "delta": 352670387.02
      },
      {
        "periodo": 202604,
        "valor": 3842484007.08,
        "delta": 342692122.5
      },
      {
        "periodo": 202605,
        "valor": 3885488023.22,
        "delta": 43004016.14
      },
      {
        "periodo": 202606,
        "valor": 4374387130.11,
        "delta": 488899106.89
      },
      {
        "periodo": 202607,
        "valor": 4661344049.38,
        "delta": 286956919.27
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 29217.0,
    "valor_anterior": 14100586.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 159360791.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 149064575.0,
        "delta": -10296216.0
      },
      {
        "periodo": 202509,
        "valor": 48470706.0,
        "delta": -100593869.0
      },
      {
        "periodo": 202510,
        "valor": 19792050.0,
        "delta": -28678656.0
      },
      {
        "periodo": 202511,
        "valor": 152028960.0,
        "delta": 132236910.0
      },
      {
        "periodo": 202512,
        "valor": 10126466.0,
        "delta": -141902494.0
      },
      {
        "periodo": 202601,
        "valor": 15093062.0,
        "delta": 4966596.0
      },
      {
        "periodo": 202602,
        "valor": 8740527.0,
        "delta": -6352535.0
      },
      {
        "periodo": 202603,
        "valor": 258023564.0,
        "delta": 249283037.0
      },
      {
        "periodo": 202604,
        "valor": 230181356.0,
        "delta": -27842208.0
      },
      {
        "periodo": 202605,
        "valor": 33850128.0,
        "delta": -196331228.0
      },
      {
        "periodo": 202606,
        "valor": 14100586.0,
        "delta": -19749542.0
      },
      {
        "periodo": 202607,
        "valor": 29217.0,
        "delta": -14071369.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 3495350873.0,
    "valor_anterior": 3507499297.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3885129515.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3613103719.0,
        "delta": -272025796.0
      },
      {
        "periodo": 202509,
        "valor": 3523981864.0,
        "delta": -89121855.0
      },
      {
        "periodo": 202510,
        "valor": 3556341671.0,
        "delta": 32359807.0
      },
      {
        "periodo": 202511,
        "valor": 3638434199.0,
        "delta": 82092528.0
      },
      {
        "periodo": 202512,
        "valor": 3563285747.0,
        "delta": -75148452.0
      },
      {
        "periodo": 202601,
        "valor": 3435501152.0,
        "delta": -127784595.0
      },
      {
        "periodo": 202602,
        "valor": 3385579927.0,
        "delta": -49921225.0
      },
      {
        "periodo": 202603,
        "valor": 3490434764.0,
        "delta": 104854837.0
      },
      {
        "periodo": 202604,
        "valor": 3431297011.0,
        "delta": -59137753.0
      },
      {
        "periodo": 202605,
        "valor": 3316228079.0,
        "delta": -115068932.0
      },
      {
        "periodo": 202606,
        "valor": 3507499297.0,
        "delta": 191271218.0
      },
      {
        "periodo": 202607,
        "valor": 3495350873.0,
        "delta": -12148424.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 248627.5,
    "valor_anterior": 460793.28,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13728231.92,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9802579.58,
        "delta": -3925652.34
      },
      {
        "periodo": 202509,
        "valor": 6531860.53,
        "delta": -3270719.05
      },
      {
        "periodo": 202510,
        "valor": 4560909.86,
        "delta": -1970950.67
      },
      {
        "periodo": 202511,
        "valor": 3291148.9,
        "delta": -1269760.96
      },
      {
        "periodo": 202512,
        "valor": 2257117.92,
        "delta": -1034030.98
      },
      {
        "periodo": 202601,
        "valor": 1606383.8,
        "delta": -650734.12
      },
      {
        "periodo": 202602,
        "valor": 1280720.57,
        "delta": -325663.23
      },
      {
        "periodo": 202603,
        "valor": 966781.08,
        "delta": -313939.49
      },
      {
        "periodo": 202604,
        "valor": 674752.22,
        "delta": -292028.86
      },
      {
        "periodo": 202605,
        "valor": 564268.31,
        "delta": -110483.91
      },
      {
        "periodo": 202606,
        "valor": 460793.28,
        "delta": -103475.03
      },
      {
        "periodo": 202607,
        "valor": 248627.5,
        "delta": -212165.78
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 11097241204.35,
    "valor_anterior": 10953805570.98,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 10432155350.63,
        "delta": 10432155350.63
      },
      {
        "periodo": 202603,
        "valor": 10652009343.6,
        "delta": 219853992.97
      },
      {
        "periodo": 202604,
        "valor": 10736267256.28,
        "delta": 84257912.68
      },
      {
        "periodo": 202605,
        "valor": 10845084128.72,
        "delta": 108816872.44
      },
      {
        "periodo": 202606,
        "valor": 10953805570.98,
        "delta": 108721442.26
      },
      {
        "periodo": 202607,
        "valor": 11097241204.35,
        "delta": 143435633.37
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 445706967.0,
    "valor_anterior": 433487715.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 137804335.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 181248346.0,
        "delta": 43444011.0
      },
      {
        "periodo": 202509,
        "valor": 227567008.0,
        "delta": 46318662.0
      },
      {
        "periodo": 202510,
        "valor": 260255527.0,
        "delta": 32688519.0
      },
      {
        "periodo": 202511,
        "valor": 311067666.0,
        "delta": 50812139.0
      },
      {
        "periodo": 202512,
        "valor": 334835808.0,
        "delta": 23768142.0
      },
      {
        "periodo": 202601,
        "valor": 340819224.0,
        "delta": 5983416.0
      },
      {
        "periodo": 202602,
        "valor": 351691940.0,
        "delta": 10872716.0
      },
      {
        "periodo": 202603,
        "valor": 381301906.0,
        "delta": 29609966.0
      },
      {
        "periodo": 202604,
        "valor": 388553565.0,
        "delta": 7251659.0
      },
      {
        "periodo": 202605,
        "valor": 405485934.0,
        "delta": 16932369.0
      },
      {
        "periodo": 202606,
        "valor": 433487715.0,
        "delta": 28001781.0
      },
      {
        "periodo": 202607,
        "valor": 445706967.0,
        "delta": 12219252.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 254396321.89,
    "valor_anterior": 182250918.69,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 319703.23,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 3154015.5,
        "delta": 2834312.27
      },
      {
        "periodo": 202601,
        "valor": 8682968.15,
        "delta": 5528952.65
      },
      {
        "periodo": 202602,
        "valor": 22225148.95,
        "delta": 13542180.8
      },
      {
        "periodo": 202603,
        "valor": 47080414.01,
        "delta": 24855265.06
      },
      {
        "periodo": 202604,
        "valor": 84144906.26,
        "delta": 37064492.25
      },
      {
        "periodo": 202605,
        "valor": 129704308.54,
        "delta": 45559402.28
      },
      {
        "periodo": 202606,
        "valor": 182250918.69,
        "delta": 52546610.15
      },
      {
        "periodo": 202607,
        "valor": 254396321.89,
        "delta": 72145403.2
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 17455009838.0,
    "valor_anterior": 15949816833.999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 13375620425.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 14353155513.0,
        "delta": 977535088.0
      },
      {
        "periodo": 202605,
        "valor": 15406802938.0,
        "delta": 1053647425.0
      },
      {
        "periodo": 202606,
        "valor": 15949816834.0,
        "delta": 543013896.0
      },
      {
        "periodo": 202607,
        "valor": 17455009838.0,
        "delta": 1505193004.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 8465415603042.121,
    "valor_anterior": 8409404276693.591,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7839661636948.18,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7858406002648.419,
        "delta": 18744365700.2393
      },
      {
        "periodo": 202509,
        "valor": 7865186458848.39,
        "delta": 6780456199.9707
      },
      {
        "periodo": 202510,
        "valor": 7946801161454.18,
        "delta": 81614702605.79
      },
      {
        "periodo": 202511,
        "valor": 8059423185789.12,
        "delta": 112622024334.9404
      },
      {
        "periodo": 202512,
        "valor": 8166085005693.05,
        "delta": 106661819903.9297
      },
      {
        "periodo": 202601,
        "valor": 8151445138023.8,
        "delta": -14639867669.25
      },
      {
        "periodo": 202602,
        "valor": 8154730229293.86,
        "delta": 3285091270.0605
      },
      {
        "periodo": 202603,
        "valor": 8263307099441.63,
        "delta": 108576870147.7695
      },
      {
        "periodo": 202604,
        "valor": 8279959791876.75,
        "delta": 16652692435.1201
      },
      {
        "periodo": 202605,
        "valor": 8345221954949.2,
        "delta": 65262163072.4502
      },
      {
        "periodo": 202606,
        "valor": 8409404276693.591,
        "delta": 64182321744.3906
      },
      {
        "periodo": 202607,
        "valor": 8465415603042.121,
        "delta": 56011326348.5303
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 6504320735931.26,
    "valor_anterior": 6467036844690.72,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6068659577797.85,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6081889778113.97,
        "delta": 13230200316.1201
      },
      {
        "periodo": 202509,
        "valor": 6091323291302.25,
        "delta": 9433513188.2803
      },
      {
        "periodo": 202510,
        "valor": 6156691737577.76,
        "delta": 65368446275.5098
      },
      {
        "periodo": 202511,
        "valor": 6251795068728.82,
        "delta": 95103331151.0605
      },
      {
        "periodo": 202512,
        "valor": 6318433965569.99,
        "delta": 66638896841.1699
      },
      {
        "periodo": 202601,
        "valor": 6306703484076.171,
        "delta": -11730481493.8193
      },
      {
        "periodo": 202602,
        "valor": 6296311445940.3,
        "delta": -10392038135.8711
      },
      {
        "periodo": 202603,
        "valor": 6356156162989.69,
        "delta": 59844717049.3906
      },
      {
        "periodo": 202604,
        "valor": 6374975271387.69,
        "delta": 18819108398.0
      },
      {
        "periodo": 202605,
        "valor": 6426804895574.98,
        "delta": 51829624187.29
      },
      {
        "periodo": 202606,
        "valor": 6467036844690.72,
        "delta": 40231949115.7393
      },
      {
        "periodo": 202607,
        "valor": 6504320735931.26,
        "delta": 37283891240.54
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 72606702834.84,
    "valor_anterior": 74610222425.84,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 101942866317.34,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 86276590437.23,
        "delta": -15666275880.11
      },
      {
        "periodo": 202509,
        "valor": 66799767138.76,
        "delta": -19476823298.47
      },
      {
        "periodo": 202510,
        "valor": 68101846307.9,
        "delta": 1302079169.14
      },
      {
        "periodo": 202511,
        "valor": 68349832562.26,
        "delta": 247986254.36
      },
      {
        "periodo": 202512,
        "valor": 74532158475.23,
        "delta": 6182325912.97
      },
      {
        "periodo": 202601,
        "valor": 74227762700.89,
        "delta": -304395774.34
      },
      {
        "periodo": 202602,
        "valor": 74495025622.32,
        "delta": 267262921.43
      },
      {
        "periodo": 202603,
        "valor": 75536028499.84,
        "delta": 1041002877.52
      },
      {
        "periodo": 202604,
        "valor": 75291654359.26,
        "delta": -244374140.58
      },
      {
        "periodo": 202605,
        "valor": 75212877022.91,
        "delta": -78777336.35
      },
      {
        "periodo": 202606,
        "valor": 74610222425.84,
        "delta": -602654597.07
      },
      {
        "periodo": 202607,
        "valor": 72606702834.84,
        "delta": -2003519591.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 357858773907.55,
    "valor_anterior": 348195101063.85,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 359932322398.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 357706237728.99,
        "delta": -2226084669.54
      },
      {
        "periodo": 202509,
        "valor": 352769487382.59,
        "delta": -4936750346.4
      },
      {
        "periodo": 202510,
        "valor": 355889949096.34,
        "delta": 3120461713.75
      },
      {
        "periodo": 202511,
        "valor": 355531537117.88,
        "delta": -358411978.46
      },
      {
        "periodo": 202512,
        "valor": 353899562557.48,
        "delta": -1631974560.4
      },
      {
        "periodo": 202601,
        "valor": 349894020427.24,
        "delta": -4005542130.24
      },
      {
        "periodo": 202602,
        "valor": 344647424302.72,
        "delta": -5246596124.52
      },
      {
        "periodo": 202603,
        "valor": 358900868836.15,
        "delta": 14253444533.4301
      },
      {
        "periodo": 202604,
        "valor": 346539728705.25,
        "delta": -12361140130.9
      },
      {
        "periodo": 202605,
        "valor": 344555950330.11,
        "delta": -1983778375.14
      },
      {
        "periodo": 202606,
        "valor": 348195101063.85,
        "delta": 3639150733.7399
      },
      {
        "periodo": 202607,
        "valor": 357858773907.55,
        "delta": 9663672843.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 884070494792.26,
    "valor_anterior": 881463370687.53,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 772560444609.04,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 779400853241.37,
        "delta": 6840408632.33
      },
      {
        "periodo": 202509,
        "valor": 790786576804.72,
        "delta": 11385723563.35
      },
      {
        "periodo": 202510,
        "valor": 794762252479.77,
        "delta": 3975675675.05
      },
      {
        "periodo": 202511,
        "valor": 804768403121.78,
        "delta": 10006150642.01
      },
      {
        "periodo": 202512,
        "valor": 836216750421.82,
        "delta": 31448347300.0399
      },
      {
        "periodo": 202601,
        "valor": 834754047816.67,
        "delta": -1462702605.1499
      },
      {
        "periodo": 202602,
        "valor": 837606404430.54,
        "delta": 2852356613.87
      },
      {
        "periodo": 202603,
        "valor": 852793705859.47,
        "delta": 15187301428.9299
      },
      {
        "periodo": 202604,
        "valor": 856711454482.9999,
        "delta": 3917748623.5299
      },
      {
        "periodo": 202605,
        "valor": 868968889876.43,
        "delta": 12257435393.4302
      },
      {
        "periodo": 202606,
        "valor": 881463370687.53,
        "delta": 12494480811.1
      },
      {
        "periodo": 202607,
        "valor": 884070494792.26,
        "delta": 2607124104.73
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 211004968016.27,
    "valor_anterior": 208931337576.94,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 168196043936.02,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 170772268384.94,
        "delta": 2576224448.92
      },
      {
        "periodo": 202509,
        "valor": 183175220217.84,
        "delta": 12402951832.9
      },
      {
        "periodo": 202510,
        "valor": 184961268513.91,
        "delta": 1786048296.07
      },
      {
        "periodo": 202511,
        "valor": 186332284293.84,
        "delta": 1371015779.93
      },
      {
        "periodo": 202512,
        "valor": 189570778224.86,
        "delta": 3238493931.02
      },
      {
        "periodo": 202601,
        "valor": 190059763084.88,
        "delta": 488984860.02
      },
      {
        "periodo": 202602,
        "valor": 192535468599.47,
        "delta": 2475705514.59
      },
      {
        "periodo": 202603,
        "valor": 196479026574.33,
        "delta": 3943557974.86
      },
      {
        "periodo": 202604,
        "valor": 203398106414.78,
        "delta": 6919079840.45
      },
      {
        "periodo": 202605,
        "valor": 206485368816.81,
        "delta": 3087262402.03
      },
      {
        "periodo": 202606,
        "valor": 208931337576.94,
        "delta": 2445968760.13
      },
      {
        "periodo": 202607,
        "valor": 211004968016.27,
        "delta": 2073630439.33
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100185,
    "label": "Cartera",
    "valor_actual": 435553927559.94,
    "valor_anterior": 429167400248.71,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 368370381889.4,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 382360274741.92,
        "delta": 13989892852.52
      },
      {
        "periodo": 202509,
        "valor": 380332116002.23,
        "delta": -2028158739.69
      },
      {
        "periodo": 202510,
        "valor": 386394107478.5,
        "delta": 6061991476.27
      },
      {
        "periodo": 202511,
        "valor": 392646059964.54,
        "delta": 6251952486.04
      },
      {
        "periodo": 202512,
        "valor": 393431790443.67,
        "delta": 785730479.13
      },
      {
        "periodo": 202601,
        "valor": 395806059917.95,
        "delta": 2374269474.28
      },
      {
        "periodo": 202602,
        "valor": 409134460398.51,
        "delta": 13328400480.56
      },
      {
        "periodo": 202603,
        "valor": 423441306682.15,
        "delta": 14306846283.64
      },
      {
        "periodo": 202604,
        "valor": 423043576526.77,
        "delta": -397730155.38
      },
      {
        "periodo": 202605,
        "valor": 423193973327.96,
        "delta": 150396801.19
      },
      {
        "periodo": 202606,
        "valor": 429167400248.71,
        "delta": 5973426920.75
      },
      {
        "periodo": 202607,
        "valor": 435553927559.94,
        "delta": 6386527311.23
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 187916422399.11,
    "valor_anterior": 186633104266.79,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 163310878187.06,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 164701849840.19,
        "delta": 1390971653.13
      },
      {
        "periodo": 202509,
        "valor": 172807009725.08,
        "delta": 8105159884.89
      },
      {
        "periodo": 202510,
        "valor": 175221967636.98,
        "delta": 2414957911.9
      },
      {
        "periodo": 202511,
        "valor": 176635255219.84,
        "delta": 1413287582.86
      },
      {
        "periodo": 202512,
        "valor": 175710933001.49,
        "delta": -924322218.35
      },
      {
        "periodo": 202601,
        "valor": 176557083833.83,
        "delta": 846150832.34
      },
      {
        "periodo": 202602,
        "valor": 178720761621.77,
        "delta": 2163677787.94
      },
      {
        "periodo": 202603,
        "valor": 182718471869.58,
        "delta": 3997710247.81
      },
      {
        "periodo": 202604,
        "valor": 181130527436.57,
        "delta": -1587944433.01
      },
      {
        "periodo": 202605,
        "valor": 183518581821.17,
        "delta": 2388054384.6
      },
      {
        "periodo": 202606,
        "valor": 186633104266.79,
        "delta": 3114522445.62
      },
      {
        "periodo": 202607,
        "valor": 187916422399.11,
        "delta": 1283318132.32
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 1193088622614.87,
    "valor_anterior": 1192760625792.4,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1096376929119.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1082429050272.61,
        "delta": -13947878847.29
      },
      {
        "periodo": 202509,
        "valor": 1077288012804.21,
        "delta": -5141037468.4
      },
      {
        "periodo": 202510,
        "valor": 1083399139938.93,
        "delta": 6111127134.7201
      },
      {
        "periodo": 202511,
        "valor": 1094808590907.92,
        "delta": 11409450968.99
      },
      {
        "periodo": 202512,
        "valor": 1119862943283.89,
        "delta": 25054352375.9698
      },
      {
        "periodo": 202601,
        "valor": 1124594244003.76,
        "delta": 4731300719.8701
      },
      {
        "periodo": 202602,
        "valor": 1120831709188.84,
        "delta": -3762534814.9199
      },
      {
        "periodo": 202603,
        "valor": 1165170103412.77,
        "delta": 44338394223.9299
      },
      {
        "periodo": 202604,
        "valor": 1167946707877.15,
        "delta": 2776604464.3799
      },
      {
        "periodo": 202605,
        "valor": 1182260737180.98,
        "delta": 14314029303.8301
      },
      {
        "periodo": 202606,
        "valor": 1192760625792.4,
        "delta": 10499888611.4199
      },
      {
        "periodo": 202607,
        "valor": 1193088622614.87,
        "delta": 327996822.4702
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 512223544395.0,
    "valor_anterior": 510821421799.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 473449162685.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 465764842700.0,
        "delta": -7684319985.0
      },
      {
        "periodo": 202509,
        "valor": 461446644893.0,
        "delta": -4318197807.0
      },
      {
        "periodo": 202510,
        "valor": 468370656558.0,
        "delta": 6924011665.0
      },
      {
        "periodo": 202511,
        "valor": 472090259908.0,
        "delta": 3719603350.0
      },
      {
        "periodo": 202512,
        "valor": 508601877782.0,
        "delta": 36511617874.0
      },
      {
        "periodo": 202601,
        "valor": 508279057606.0,
        "delta": -322820176.0
      },
      {
        "periodo": 202602,
        "valor": 508461410433.0,
        "delta": 182352827.0
      },
      {
        "periodo": 202603,
        "valor": 504997546259.0,
        "delta": -3463864174.0
      },
      {
        "periodo": 202604,
        "valor": 504019441540.0,
        "delta": -978104719.0
      },
      {
        "periodo": 202605,
        "valor": 506437255533.0,
        "delta": 2417813993.0
      },
      {
        "periodo": 202606,
        "valor": 510821421799.0,
        "delta": 4384166266.0
      },
      {
        "periodo": 202607,
        "valor": 512223544395.0,
        "delta": 1402122596.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 218310739166.0,
    "valor_anterior": 218651074504.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 242676923969.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 241249342733.0,
        "delta": -1427581236.0
      },
      {
        "periodo": 202509,
        "valor": 236408116436.0,
        "delta": -4841226297.0
      },
      {
        "periodo": 202510,
        "valor": 238102627443.0,
        "delta": 1694511007.0
      },
      {
        "periodo": 202511,
        "valor": 234837572191.0,
        "delta": -3265055252.0
      },
      {
        "periodo": 202512,
        "valor": 236945650894.0,
        "delta": 2108078703.0
      },
      {
        "periodo": 202601,
        "valor": 237079646532.0,
        "delta": 133995638.0
      },
      {
        "periodo": 202602,
        "valor": 234656272658.0,
        "delta": -2423373874.0
      },
      {
        "periodo": 202603,
        "valor": 222653760987.0,
        "delta": -12002511671.0
      },
      {
        "periodo": 202604,
        "valor": 222484197772.0,
        "delta": -169563215.0
      },
      {
        "periodo": 202605,
        "valor": 225466278174.0,
        "delta": 2982080402.0
      },
      {
        "periodo": 202606,
        "valor": 218651074504.0,
        "delta": -6815203670.0
      },
      {
        "periodo": 202607,
        "valor": 218310739166.0,
        "delta": -340335338.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 286080690666.7,
    "valor_anterior": 284913389849.98,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 252950871852.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 255756595677.74,
        "delta": 2805723824.81
      },
      {
        "periodo": 202509,
        "valor": 257041889914.45,
        "delta": 1285294236.7101
      },
      {
        "periodo": 202510,
        "valor": 258081252398.71,
        "delta": 1039362484.26
      },
      {
        "periodo": 202511,
        "valor": 262543729372.58,
        "delta": 4462476973.87
      },
      {
        "periodo": 202512,
        "valor": 266989369858.33,
        "delta": 4445640485.75
      },
      {
        "periodo": 202601,
        "valor": 265912804055.74,
        "delta": -1076565802.59
      },
      {
        "periodo": 202602,
        "valor": 267502010033.73,
        "delta": 1589205977.99
      },
      {
        "periodo": 202603,
        "valor": 275269838599.28,
        "delta": 7767828565.55
      },
      {
        "periodo": 202604,
        "valor": 274669865239.07,
        "delta": -599973360.21
      },
      {
        "periodo": 202605,
        "valor": 278771475888.41,
        "delta": 4101610649.34
      },
      {
        "periodo": 202606,
        "valor": 284913389849.98,
        "delta": 6141913961.57
      },
      {
        "periodo": 202607,
        "valor": 286080690666.7,
        "delta": 1167300816.72
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 387849897413.0,
    "valor_anterior": 390345529088.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 362925823892.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 366408149586.9999,
        "delta": 3482325694.9999
      },
      {
        "periodo": 202509,
        "valor": 366490764983.0,
        "delta": 82615396.0001
      },
      {
        "periodo": 202510,
        "valor": 369767746915.0,
        "delta": 3276981932.0
      },
      {
        "periodo": 202511,
        "valor": 371422110890.0,
        "delta": 1654363975.0
      },
      {
        "periodo": 202512,
        "valor": 370942117531.0,
        "delta": -479993359.0
      },
      {
        "periodo": 202601,
        "valor": 374045175322.0001,
        "delta": 3103057791.0001
      },
      {
        "periodo": 202602,
        "valor": 378327758922.0,
        "delta": 4282583599.9999
      },
      {
        "periodo": 202603,
        "valor": 380452081279.0,
        "delta": 2124322357.0
      },
      {
        "periodo": 202604,
        "valor": 381238379463.0,
        "delta": 786298184.0
      },
      {
        "periodo": 202605,
        "valor": 387123220056.0,
        "delta": 5884840593.0
      },
      {
        "periodo": 202606,
        "valor": 390345529088.0,
        "delta": 3222309032.0
      },
      {
        "periodo": 202607,
        "valor": 387849897413.0,
        "delta": -2495631675.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 79776596727.0,
    "valor_anterior": 79842363525.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 65484859027.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 66877098197.0,
        "delta": 1392239170.0
      },
      {
        "periodo": 202509,
        "valor": 66367926476.0,
        "delta": -509171721.0
      },
      {
        "periodo": 202510,
        "valor": 68322447257.0,
        "delta": 1954520781.0
      },
      {
        "periodo": 202511,
        "valor": 69822620279.0,
        "delta": 1500173022.0
      },
      {
        "periodo": 202512,
        "valor": 75753402115.0,
        "delta": 5930781836.0
      },
      {
        "periodo": 202601,
        "valor": 76030026573.0,
        "delta": 276624458.0
      },
      {
        "periodo": 202602,
        "valor": 76976857432.0,
        "delta": 946830859.0
      },
      {
        "periodo": 202603,
        "valor": 78525071820.0,
        "delta": 1548214388.0
      },
      {
        "periodo": 202604,
        "valor": 77470722948.0,
        "delta": -1054348872.0
      },
      {
        "periodo": 202605,
        "valor": 78411864475.0,
        "delta": 941141527.0
      },
      {
        "periodo": 202606,
        "valor": 79842363525.0,
        "delta": 1430499050.0
      },
      {
        "periodo": 202607,
        "valor": 79776596727.0,
        "delta": -65766798.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 223040636240.0,
    "valor_anterior": 219981387964.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 224414285480.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 226815192159.0,
        "delta": 2400906679.0
      },
      {
        "periodo": 202509,
        "valor": 221984264409.0,
        "delta": -4830927750.0
      },
      {
        "periodo": 202510,
        "valor": 223975505208.0,
        "delta": 1991240799.0
      },
      {
        "periodo": 202511,
        "valor": 222113014850.0,
        "delta": -1862490358.0
      },
      {
        "periodo": 202512,
        "valor": 221893095992.0,
        "delta": -219918858.0
      },
      {
        "periodo": 202601,
        "valor": 216659331382.0,
        "delta": -5233764610.0
      },
      {
        "periodo": 202602,
        "valor": 216307837863.0,
        "delta": -351493519.0
      },
      {
        "periodo": 202603,
        "valor": 220419123137.0,
        "delta": 4111285274.0
      },
      {
        "periodo": 202604,
        "valor": 219059259592.0,
        "delta": -1359863545.0
      },
      {
        "periodo": 202605,
        "valor": 218304492331.0,
        "delta": -754767261.0
      },
      {
        "periodo": 202606,
        "valor": 219981387964.0,
        "delta": 1676895633.0
      },
      {
        "periodo": 202607,
        "valor": 223040636240.0,
        "delta": 3059248276.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 165055073097.96,
    "valor_anterior": 165440742182.15,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 154368425839.89,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 155751765709.81,
        "delta": 1383339869.92
      },
      {
        "periodo": 202509,
        "valor": 157612349564.54,
        "delta": 1860583854.73
      },
      {
        "periodo": 202510,
        "valor": 157908516793.71,
        "delta": 296167229.17
      },
      {
        "periodo": 202511,
        "valor": 157830556958.84,
        "delta": -77959834.87
      },
      {
        "periodo": 202512,
        "valor": 159582465949.56,
        "delta": 1751908990.72
      },
      {
        "periodo": 202601,
        "valor": 160759577148.29,
        "delta": 1177111198.73
      },
      {
        "periodo": 202602,
        "valor": 159534032929.42,
        "delta": -1225544218.87
      },
      {
        "periodo": 202603,
        "valor": 160432718718.33,
        "delta": 898685788.91
      },
      {
        "periodo": 202604,
        "valor": 163094009044.69,
        "delta": 2661290326.36
      },
      {
        "periodo": 202605,
        "valor": 165569845441.11,
        "delta": 2475836396.42
      },
      {
        "periodo": 202606,
        "valor": 165440742182.15,
        "delta": -129103258.96
      },
      {
        "periodo": 202607,
        "valor": 165055073097.96,
        "delta": -385669084.19
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 17657646500.0,
    "valor_anterior": 17025714029.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16680672898.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16204194309.0,
        "delta": -476478589.0
      },
      {
        "periodo": 202509,
        "valor": 15956689215.0,
        "delta": -247505094.0
      },
      {
        "periodo": 202510,
        "valor": 16402586992.0,
        "delta": 445897777.0
      },
      {
        "periodo": 202511,
        "valor": 16270118429.0,
        "delta": -132468563.0
      },
      {
        "periodo": 202512,
        "valor": 15843739553.0,
        "delta": -426378876.0
      },
      {
        "periodo": 202601,
        "valor": 15662391373.0,
        "delta": -181348180.0
      },
      {
        "periodo": 202602,
        "valor": 15780416667.0,
        "delta": 118025294.0
      },
      {
        "periodo": 202603,
        "valor": 16529892872.0,
        "delta": 749476205.0
      },
      {
        "periodo": 202604,
        "valor": 16264390734.0,
        "delta": -265502138.0
      },
      {
        "periodo": 202605,
        "valor": 16815322154.0,
        "delta": 550931420.0
      },
      {
        "periodo": 202606,
        "valor": 17025714029.0,
        "delta": 210391875.0
      },
      {
        "periodo": 202607,
        "valor": 17657646500.0,
        "delta": 631932471.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 26718138089.0,
    "valor_anterior": 26403341704.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28859459604.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29257804359.0,
        "delta": 398344755.0
      },
      {
        "periodo": 202509,
        "valor": 28695212921.0,
        "delta": -562591438.0
      },
      {
        "periodo": 202510,
        "valor": 28555983035.0,
        "delta": -139229886.0
      },
      {
        "periodo": 202511,
        "valor": 29221493616.0,
        "delta": 665510581.0
      },
      {
        "periodo": 202512,
        "valor": 29623530383.0,
        "delta": 402036767.0
      },
      {
        "periodo": 202601,
        "valor": 28838993853.0,
        "delta": -784536530.0
      },
      {
        "periodo": 202602,
        "valor": 28546340026.0,
        "delta": -292653827.0
      },
      {
        "periodo": 202603,
        "valor": 27449720963.0,
        "delta": -1096619063.0
      },
      {
        "periodo": 202604,
        "valor": 27540811534.0,
        "delta": 91090571.0
      },
      {
        "periodo": 202605,
        "valor": 27347030488.0,
        "delta": -193781046.0
      },
      {
        "periodo": 202606,
        "valor": 26403341704.0,
        "delta": -943688784.0
      },
      {
        "periodo": 202607,
        "valor": 26718138089.0,
        "delta": 314796385.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 38698924553.0,
    "valor_anterior": 39016693409.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40708975548.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 41267851641.0,
        "delta": 558876093.0
      },
      {
        "periodo": 202509,
        "valor": 42051676040.0,
        "delta": 783824399.0
      },
      {
        "periodo": 202510,
        "valor": 42115772210.0,
        "delta": 64096170.0
      },
      {
        "periodo": 202511,
        "valor": 42687409516.0,
        "delta": 571637306.0
      },
      {
        "periodo": 202512,
        "valor": 41379398993.0,
        "delta": -1308010523.0
      },
      {
        "periodo": 202601,
        "valor": 42101221129.0,
        "delta": 721822136.0
      },
      {
        "periodo": 202602,
        "valor": 42289565487.0,
        "delta": 188344358.0
      },
      {
        "periodo": 202603,
        "valor": 40930307455.0,
        "delta": -1359258032.0
      },
      {
        "periodo": 202604,
        "valor": 40369607241.0,
        "delta": -560700214.0
      },
      {
        "periodo": 202605,
        "valor": 40548443662.0,
        "delta": 178836421.0
      },
      {
        "periodo": 202606,
        "valor": 39016693409.0,
        "delta": -1531750253.0
      },
      {
        "periodo": 202607,
        "valor": 38698924553.0,
        "delta": -317768856.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 694648510207.5,
    "valor_anterior": 670652441869.65,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 639447473913.43,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 643953855824.07,
        "delta": 4506381910.6399
      },
      {
        "periodo": 202509,
        "valor": 643787492499.62,
        "delta": -166363324.45
      },
      {
        "periodo": 202510,
        "valor": 661251975302.0,
        "delta": 17464482802.38
      },
      {
        "periodo": 202511,
        "valor": 686068683469.3,
        "delta": 24816708167.3
      },
      {
        "periodo": 202512,
        "valor": 691527659932.69,
        "delta": 5458976463.3899
      },
      {
        "periodo": 202601,
        "valor": 668700245003.56,
        "delta": -22827414929.1299
      },
      {
        "periodo": 202602,
        "valor": 653681802437.31,
        "delta": -15018442566.25
      },
      {
        "periodo": 202603,
        "valor": 661895549136.8398,
        "delta": 8213746699.5298
      },
      {
        "periodo": 202604,
        "valor": 661187623748.43,
        "delta": -707925388.4098
      },
      {
        "periodo": 202605,
        "valor": 666318726323.8801,
        "delta": 5131102575.4501
      },
      {
        "periodo": 202606,
        "valor": 670652441869.65,
        "delta": 4333715545.7699
      },
      {
        "periodo": 202607,
        "valor": 694648510207.5,
        "delta": 23996068337.85
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 46805649902.0,
    "valor_anterior": 45803376036.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 41861689535.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 43913816520.0,
        "delta": 2052126985.0
      },
      {
        "periodo": 202509,
        "valor": 45436847170.0,
        "delta": 1523030650.0
      },
      {
        "periodo": 202510,
        "valor": 44382432956.0,
        "delta": -1054414214.0
      },
      {
        "periodo": 202511,
        "valor": 44509238192.0,
        "delta": 126805236.0
      },
      {
        "periodo": 202512,
        "valor": 44516738187.0,
        "delta": 7499995.0
      },
      {
        "periodo": 202601,
        "valor": 42048483083.0,
        "delta": -2468255104.0
      },
      {
        "periodo": 202602,
        "valor": 43045845768.0,
        "delta": 997362685.0
      },
      {
        "periodo": 202603,
        "valor": 44900530216.0,
        "delta": 1854684448.0
      },
      {
        "periodo": 202604,
        "valor": 43997985017.0,
        "delta": -902545199.0
      },
      {
        "periodo": 202605,
        "valor": 43305575018.0,
        "delta": -692409999.0
      },
      {
        "periodo": 202606,
        "valor": 45803376036.0,
        "delta": 2497801018.0
      },
      {
        "periodo": 202607,
        "valor": 46805649902.0,
        "delta": 1002273866.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 7418721848.0,
    "valor_anterior": 7584066794.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6866094915.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7477133506.0,
        "delta": 611038591.0
      },
      {
        "periodo": 202509,
        "valor": 5841381443.0,
        "delta": -1635752063.0
      },
      {
        "periodo": 202510,
        "valor": 8988013317.0,
        "delta": 3146631874.0
      },
      {
        "periodo": 202511,
        "valor": 8047175943.0,
        "delta": -940837374.0
      },
      {
        "periodo": 202512,
        "valor": 8097031848.0,
        "delta": 49855905.0
      },
      {
        "periodo": 202601,
        "valor": 6390949077.0,
        "delta": -1706082771.0
      },
      {
        "periodo": 202602,
        "valor": 7429362901.0,
        "delta": 1038413824.0
      },
      {
        "periodo": 202603,
        "valor": 9352720660.0,
        "delta": 1923357759.0
      },
      {
        "periodo": 202604,
        "valor": 8618180392.0,
        "delta": -734540268.0
      },
      {
        "periodo": 202605,
        "valor": 7956178204.0,
        "delta": -662002188.0
      },
      {
        "periodo": 202606,
        "valor": 7584066794.0,
        "delta": -372111410.0
      },
      {
        "periodo": 202607,
        "valor": 7418721848.0,
        "delta": -165344946.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 24650823984.0,
    "valor_anterior": 24474641335.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25545122399.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24842326109.0,
        "delta": -702796290.0
      },
      {
        "periodo": 202509,
        "valor": 23631979119.0,
        "delta": -1210346990.0
      },
      {
        "periodo": 202510,
        "valor": 21132987128.0,
        "delta": -2498991991.0
      },
      {
        "periodo": 202511,
        "valor": 21358685592.0,
        "delta": 225698464.0
      },
      {
        "periodo": 202512,
        "valor": 22098821182.0,
        "delta": 740135590.0
      },
      {
        "periodo": 202601,
        "valor": 22952808889.0,
        "delta": 853987707.0
      },
      {
        "periodo": 202602,
        "valor": 24652618566.0,
        "delta": 1699809677.0
      },
      {
        "periodo": 202603,
        "valor": 24621486321.0,
        "delta": -31132245.0
      },
      {
        "periodo": 202604,
        "valor": 24578089713.0,
        "delta": -43396608.0
      },
      {
        "periodo": 202605,
        "valor": 24720795604.0,
        "delta": 142705891.0
      },
      {
        "periodo": 202606,
        "valor": 24474641335.0,
        "delta": -246154269.0
      },
      {
        "periodo": 202607,
        "valor": 24650823984.0,
        "delta": 176182649.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 61567175668.84,
    "valor_anterior": 63059126424.84,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 55679670252.34,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55196869182.23,
        "delta": -482801070.11
      },
      {
        "periodo": 202509,
        "valor": 54595986018.76,
        "delta": -600883163.47
      },
      {
        "periodo": 202510,
        "valor": 56279342832.9,
        "delta": 1683356814.14
      },
      {
        "periodo": 202511,
        "valor": 56770923753.26,
        "delta": 491580920.36
      },
      {
        "periodo": 202512,
        "valor": 63531646148.23,
        "delta": 6760722394.97
      },
      {
        "periodo": 202601,
        "valor": 63194184089.89,
        "delta": -337462058.34
      },
      {
        "periodo": 202602,
        "valor": 63295261985.32,
        "delta": 101077895.43
      },
      {
        "periodo": 202603,
        "valor": 64633034267.84,
        "delta": 1337772282.52
      },
      {
        "periodo": 202604,
        "valor": 64236018764.26,
        "delta": -397015503.58
      },
      {
        "periodo": 202605,
        "valor": 63883881818.91,
        "delta": -352136945.35
      },
      {
        "periodo": 202606,
        "valor": 63059126424.84,
        "delta": -824755394.07
      },
      {
        "periodo": 202607,
        "valor": 61567175668.84,
        "delta": -1491950756.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 59136030894.0,
    "valor_anterior": 60452151303.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 49211227630.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 49114565443.0,
        "delta": -96662187.0
      },
      {
        "periodo": 202509,
        "valor": 51256973720.0,
        "delta": 2142408277.0
      },
      {
        "periodo": 202510,
        "valor": 51584278906.0,
        "delta": 327305186.0
      },
      {
        "periodo": 202511,
        "valor": 52452081106.0,
        "delta": 867802200.0
      },
      {
        "periodo": 202512,
        "valor": 55369619527.0,
        "delta": 2917538421.0
      },
      {
        "periodo": 202601,
        "valor": 55878604445.0,
        "delta": 508984918.0
      },
      {
        "periodo": 202602,
        "valor": 57432337597.0,
        "delta": 1553733152.0
      },
      {
        "periodo": 202603,
        "valor": 58692287714.0,
        "delta": 1259950117.0
      },
      {
        "periodo": 202604,
        "valor": 58155915989.0,
        "delta": -536371725.0
      },
      {
        "periodo": 202605,
        "valor": 59569146414.0,
        "delta": 1413230425.0
      },
      {
        "periodo": 202606,
        "valor": 60452151303.0,
        "delta": 883004889.0
      },
      {
        "periodo": 202607,
        "valor": 59136030894.0,
        "delta": -1316120409.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 153108285562.55,
    "valor_anterior": 145303047045.85,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 167718591079.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 162838462235.99,
        "delta": -4880128843.54
      },
      {
        "periodo": 202509,
        "valor": 157921075873.59,
        "delta": -4917386362.4
      },
      {
        "periodo": 202510,
        "valor": 160432813984.34,
        "delta": 2511738110.75
      },
      {
        "periodo": 202511,
        "valor": 157994170997.88,
        "delta": -2438642986.46
      },
      {
        "periodo": 202512,
        "valor": 157536082750.48,
        "delta": -458088247.4
      },
      {
        "periodo": 202601,
        "valor": 156148550899.24,
        "delta": -1387531851.24
      },
      {
        "periodo": 202602,
        "valor": 146602319976.72,
        "delta": -9546230922.52
      },
      {
        "periodo": 202603,
        "valor": 156531493617.15,
        "delta": 9929173640.43
      },
      {
        "periodo": 202604,
        "valor": 145639963437.25,
        "delta": -10891530179.9
      },
      {
        "periodo": 202605,
        "valor": 143340024579.11,
        "delta": -2299938858.14
      },
      {
        "periodo": 202606,
        "valor": 145303047045.85,
        "delta": 1963022466.74
      },
      {
        "periodo": 202607,
        "valor": 153108285562.55,
        "delta": 7805238516.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 63058602026.92,
    "valor_anterior": 63113243320.27,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 62368148363.09,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 64023448457.38,
        "delta": 1655300094.29
      },
      {
        "periodo": 202509,
        "valor": 61399363337.8,
        "delta": -2624085119.58
      },
      {
        "periodo": 202510,
        "valor": 63053321788.93,
        "delta": 1653958451.13
      },
      {
        "periodo": 202511,
        "valor": 63405746397.56,
        "delta": 352424608.63
      },
      {
        "periodo": 202512,
        "valor": 62071091594.47,
        "delta": -1334654803.09
      },
      {
        "periodo": 202601,
        "valor": 66581742844.53,
        "delta": 4510651250.06
      },
      {
        "periodo": 202602,
        "valor": 66830519099.41,
        "delta": 248776254.88
      },
      {
        "periodo": 202603,
        "valor": 63524294158.68,
        "delta": -3306224940.73
      },
      {
        "periodo": 202604,
        "valor": 63619506854.25,
        "delta": 95212695.57
      },
      {
        "periodo": 202605,
        "valor": 63148287188.41,
        "delta": -471219665.84
      },
      {
        "periodo": 202606,
        "valor": 63113243320.27,
        "delta": -35043868.14
      },
      {
        "periodo": 202607,
        "valor": 63058602026.92,
        "delta": -54641293.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 28957893149.0,
    "valor_anterior": 28770493397.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8827244908.68,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9415233186.84,
        "delta": 587988278.16
      },
      {
        "periodo": 202509,
        "valor": 20964578537.0,
        "delta": 11549345350.16
      },
      {
        "periodo": 202510,
        "valor": 21103891646.0,
        "delta": 139313109.0
      },
      {
        "periodo": 202511,
        "valor": 22690646224.0,
        "delta": 1586754578.0
      },
      {
        "periodo": 202512,
        "valor": 22742556224.0,
        "delta": 51910000.0
      },
      {
        "periodo": 202601,
        "valor": 23153160039.0,
        "delta": 410603815.0
      },
      {
        "periodo": 202602,
        "valor": 23759904434.0,
        "delta": 606744395.0
      },
      {
        "periodo": 202603,
        "valor": 25588782358.0,
        "delta": 1828877924.0
      },
      {
        "periodo": 202604,
        "valor": 26545092184.0,
        "delta": 956309826.0
      },
      {
        "periodo": 202605,
        "valor": 27637634360.0,
        "delta": 1092542176.0
      },
      {
        "periodo": 202606,
        "valor": 28770493397.0,
        "delta": 1132859037.0
      },
      {
        "periodo": 202607,
        "valor": 28957893149.0,
        "delta": 187399752.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 107773745285.0,
    "valor_anterior": 105415330859.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 73561898987.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 74558741215.0,
        "delta": 996842228.0
      },
      {
        "periodo": 202509,
        "valor": 79803091084.0,
        "delta": 5244349869.0
      },
      {
        "periodo": 202510,
        "valor": 78281727100.0,
        "delta": -1521363984.0
      },
      {
        "periodo": 202511,
        "valor": 80710746557.0,
        "delta": 2429019457.0
      },
      {
        "periodo": 202512,
        "valor": 93359577756.0,
        "delta": 12648831199.0
      },
      {
        "periodo": 202601,
        "valor": 90605054109.0,
        "delta": -2754523647.0
      },
      {
        "periodo": 202602,
        "valor": 93774455853.0,
        "delta": 3169401744.0
      },
      {
        "periodo": 202603,
        "valor": 94728405202.0,
        "delta": 953949349.0
      },
      {
        "periodo": 202604,
        "valor": 98662872781.0,
        "delta": 3934467579.0
      },
      {
        "periodo": 202605,
        "valor": 102192480316.0,
        "delta": 3529607535.0
      },
      {
        "periodo": 202606,
        "valor": 105415330859.0,
        "delta": 3222850543.0
      },
      {
        "periodo": 202607,
        "valor": 107773745285.0,
        "delta": 2358414426.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 26653274265.0,
    "valor_anterior": 26992426147.999996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 24758878172.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26156649969.0,
        "delta": 1397771797.0
      },
      {
        "periodo": 202509,
        "valor": 25926015401.0,
        "delta": -230634568.0
      },
      {
        "periodo": 202510,
        "valor": 25049660374.0,
        "delta": -876355027.0
      },
      {
        "periodo": 202511,
        "valor": 25595453543.0,
        "delta": 545793169.0
      },
      {
        "periodo": 202512,
        "valor": 27124986484.0,
        "delta": 1529532941.0
      },
      {
        "periodo": 202601,
        "valor": 26527903111.0,
        "delta": -597083373.0
      },
      {
        "periodo": 202602,
        "valor": 26632238044.0,
        "delta": 104334933.0
      },
      {
        "periodo": 202603,
        "valor": 27587796761.0,
        "delta": 955558717.0
      },
      {
        "periodo": 202604,
        "valor": 27316817201.0,
        "delta": -270979560.0
      },
      {
        "periodo": 202605,
        "valor": 27248228676.0,
        "delta": -68588525.0
      },
      {
        "periodo": 202606,
        "valor": 26992426148.0,
        "delta": -255802528.0
      },
      {
        "periodo": 202607,
        "valor": 26653274265.0,
        "delta": -339151883.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 239350187.0,
    "valor_anterior": 604559635.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18522233719.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13232848212.0,
        "delta": -5289385507.0
      },
      {
        "periodo": 202509,
        "valor": 1684211067.0,
        "delta": -11548637145.0
      },
      {
        "periodo": 202510,
        "valor": 1667985465.0,
        "delta": -16225602.0
      },
      {
        "periodo": 202511,
        "valor": 1242961191.0,
        "delta": -425024274.0
      },
      {
        "periodo": 202512,
        "valor": 834014069.0,
        "delta": -408947122.0
      },
      {
        "periodo": 202601,
        "valor": 784517987.0,
        "delta": -49496082.0
      },
      {
        "periodo": 202602,
        "valor": 769930224.0,
        "delta": -14587763.0
      },
      {
        "periodo": 202603,
        "valor": 641906216.0,
        "delta": -128024008.0
      },
      {
        "periodo": 202604,
        "valor": 631643174.0,
        "delta": -10263042.0
      },
      {
        "periodo": 202605,
        "valor": 628982444.0,
        "delta": -2660730.0
      },
      {
        "periodo": 202606,
        "valor": 604559635.0,
        "delta": -24422809.0
      },
      {
        "periodo": 202607,
        "valor": 239350187.0,
        "delta": -365209448.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 50360717105.64,
    "valor_anterior": 48644906187.23,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 42807876220.56,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 43608759112.48,
        "delta": 800882891.92
      },
      {
        "periodo": 202509,
        "valor": 42853532410.32,
        "delta": -755226702.16
      },
      {
        "periodo": 202510,
        "valor": 43402548898.5,
        "delta": 549016488.18
      },
      {
        "periodo": 202511,
        "valor": 45185421594.78,
        "delta": 1782872696.28
      },
      {
        "periodo": 202512,
        "valor": 46707845186.53,
        "delta": 1522423591.75
      },
      {
        "periodo": 202601,
        "valor": 46962398243.09,
        "delta": 254553056.56
      },
      {
        "periodo": 202602,
        "valor": 48328119912.89,
        "delta": 1365721669.8
      },
      {
        "periodo": 202603,
        "valor": 49326119952.85,
        "delta": 998000039.96
      },
      {
        "periodo": 202604,
        "valor": 48365357972.98,
        "delta": -960761979.87
      },
      {
        "periodo": 202605,
        "valor": 49424765724.78,
        "delta": 1059407751.8
      },
      {
        "periodo": 202606,
        "valor": 48644906187.23,
        "delta": -779859537.55
      },
      {
        "periodo": 202607,
        "valor": 50360717105.64,
        "delta": 1715810918.41
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 612795450.0,
    "valor_anterior": 623729892.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 236745785.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 226244001.0,
        "delta": -10501784.0
      },
      {
        "periodo": 202509,
        "valor": 213071698.0,
        "delta": -13172303.0
      },
      {
        "periodo": 202510,
        "valor": 223883615.0,
        "delta": 10811917.0
      },
      {
        "periodo": 202511,
        "valor": 251953312.0,
        "delta": 28069697.0
      },
      {
        "periodo": 202512,
        "valor": 236156323.0,
        "delta": -15796989.0
      },
      {
        "periodo": 202601,
        "valor": 247235413.0,
        "delta": 11079090.0
      },
      {
        "periodo": 202602,
        "valor": 284134222.0,
        "delta": 36898809.0
      },
      {
        "periodo": 202603,
        "valor": 400833404.0,
        "delta": 116699182.0
      },
      {
        "periodo": 202604,
        "valor": 432808280.0,
        "delta": 31974876.0
      },
      {
        "periodo": 202605,
        "valor": 633998889.0,
        "delta": 201190609.0
      },
      {
        "periodo": 202606,
        "valor": 623729892.0,
        "delta": -10268997.0
      },
      {
        "periodo": 202607,
        "valor": 612795450.0,
        "delta": -10934442.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 301700000.0,
    "valor_anterior": 292500000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 244166075.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 244074767.0,
        "delta": -91308.0
      },
      {
        "periodo": 202509,
        "valor": 241494682.0,
        "delta": -2580085.0
      },
      {
        "periodo": 202510,
        "valor": 238746135.0,
        "delta": -2748547.0
      },
      {
        "periodo": 202511,
        "valor": 223500000.0,
        "delta": -15246135.0
      },
      {
        "periodo": 202512,
        "valor": 225000000.0,
        "delta": 1500000.0
      },
      {
        "periodo": 202601,
        "valor": 225000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 225000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 225000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 225000000.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 280043963.0,
        "delta": 55043963.0
      },
      {
        "periodo": 202606,
        "valor": 292500000.0,
        "delta": 12456037.0
      },
      {
        "periodo": 202607,
        "valor": 301700000.0,
        "delta": 9200000.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 10153594140.0,
    "valor_anterior": 10219358993.999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9129740153.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9378771977.0,
        "delta": 249031824.0
      },
      {
        "periodo": 202509,
        "valor": 9218900971.0,
        "delta": -159871006.0
      },
      {
        "periodo": 202510,
        "valor": 9114830107.0,
        "delta": -104070864.0
      },
      {
        "periodo": 202511,
        "valor": 8454794498.0,
        "delta": -660035609.0
      },
      {
        "periodo": 202512,
        "valor": 8318599666.0,
        "delta": -136194832.0
      },
      {
        "periodo": 202601,
        "valor": 8680226060.0,
        "delta": 361626394.0
      },
      {
        "periodo": 202602,
        "valor": 9045550740.0,
        "delta": 365324680.0
      },
      {
        "periodo": 202603,
        "valor": 9285379438.0,
        "delta": 239828698.0
      },
      {
        "periodo": 202604,
        "valor": 9482385862.0,
        "delta": 197006424.0
      },
      {
        "periodo": 202605,
        "valor": 9724713750.0,
        "delta": 242327888.0
      },
      {
        "periodo": 202606,
        "valor": 10219358994.0,
        "delta": 494645244.0
      },
      {
        "periodo": 202607,
        "valor": 10153594140.0,
        "delta": -65764854.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7071062352.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5502125099.0,
        "delta": -1568937253.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 10794083871.0,
    "valor_anterior": 10940443257.999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10522092604.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10437396816.0,
        "delta": -84695788.0
      },
      {
        "periodo": 202509,
        "valor": 10461585842.0,
        "delta": 24189026.0
      },
      {
        "periodo": 202510,
        "valor": 10095733738.0,
        "delta": -365852104.0
      },
      {
        "periodo": 202511,
        "valor": 10276628616.0,
        "delta": 180894878.0
      },
      {
        "periodo": 202512,
        "valor": 10109265225.0,
        "delta": -167363391.0
      },
      {
        "periodo": 202601,
        "valor": 10196544166.0,
        "delta": 87278941.0
      },
      {
        "periodo": 202602,
        "valor": 10381183192.0,
        "delta": 184639026.0
      },
      {
        "periodo": 202603,
        "valor": 10254994908.0,
        "delta": -126188284.0
      },
      {
        "periodo": 202604,
        "valor": 10417899313.0,
        "delta": 162904405.0
      },
      {
        "periodo": 202605,
        "valor": 10693919652.0,
        "delta": 276020339.0
      },
      {
        "periodo": 202606,
        "valor": 10940443258.0,
        "delta": 246523606.0
      },
      {
        "periodo": 202607,
        "valor": 10794083871.0,
        "delta": -146359387.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 21360624206.0,
    "valor_anterior": 20599388142.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12560242400.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12948577812.0,
        "delta": 388335412.0
      },
      {
        "periodo": 202509,
        "valor": 13830043669.0,
        "delta": 881465857.0
      },
      {
        "periodo": 202510,
        "valor": 14467410794.0,
        "delta": 637367125.0
      },
      {
        "periodo": 202511,
        "valor": 15252426299.0,
        "delta": 785015505.0
      },
      {
        "periodo": 202512,
        "valor": 15839697303.0,
        "delta": 587271004.0
      },
      {
        "periodo": 202601,
        "valor": 16727341382.0,
        "delta": 887644079.0
      },
      {
        "periodo": 202602,
        "valor": 17434169011.0,
        "delta": 706827629.0
      },
      {
        "periodo": 202603,
        "valor": 18092935075.0,
        "delta": 658766064.0
      },
      {
        "periodo": 202604,
        "valor": 19019549495.0,
        "delta": 926614420.0
      },
      {
        "periodo": 202605,
        "valor": 19871117943.0,
        "delta": 851568448.0
      },
      {
        "periodo": 202606,
        "valor": 20599388142.0,
        "delta": 728270199.0
      },
      {
        "periodo": 202607,
        "valor": 21360624206.0,
        "delta": 761236064.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 13963448971.59,
    "valor_anterior": 13678169175.3,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12256341500.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12368033098.26,
        "delta": 111691597.39
      },
      {
        "periodo": 202509,
        "valor": 12429007753.59,
        "delta": 60974655.33
      },
      {
        "periodo": 202510,
        "valor": 12533413834.23,
        "delta": 104406080.64
      },
      {
        "periodo": 202511,
        "valor": 12535009560.77,
        "delta": 1595726.54
      },
      {
        "periodo": 202512,
        "valor": 13026583468.12,
        "delta": 491573907.35
      },
      {
        "periodo": 202601,
        "valor": 13038144483.31,
        "delta": 11561015.19
      },
      {
        "periodo": 202602,
        "valor": 13057317502.59,
        "delta": 19173019.28
      },
      {
        "periodo": 202603,
        "valor": 13264170727.97,
        "delta": 206853225.38
      },
      {
        "periodo": 202604,
        "valor": 13230905407.95,
        "delta": -33265320.02
      },
      {
        "periodo": 202605,
        "valor": 13452437434.86,
        "delta": 221532026.91
      },
      {
        "periodo": 202606,
        "valor": 13678169175.3,
        "delta": 225731740.44
      },
      {
        "periodo": 202607,
        "valor": 13963448971.59,
        "delta": 285279796.29
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 1266362868.0,
    "valor_anterior": 1201536096.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1640468088.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1565196007.0,
        "delta": -75272081.0
      },
      {
        "periodo": 202509,
        "valor": 1512995989.0,
        "delta": -52200018.0
      },
      {
        "periodo": 202510,
        "valor": 1479116239.0,
        "delta": -33879750.0
      },
      {
        "periodo": 202511,
        "valor": 1455458492.0,
        "delta": -23657747.0
      },
      {
        "periodo": 202512,
        "valor": 1488759384.0,
        "delta": 33300892.0
      },
      {
        "periodo": 202601,
        "valor": 1379919794.0,
        "delta": -108839590.0
      },
      {
        "periodo": 202602,
        "valor": 1361457447.0,
        "delta": -18462347.0
      },
      {
        "periodo": 202603,
        "valor": 1373149791.0,
        "delta": 11692344.0
      },
      {
        "periodo": 202604,
        "valor": 1361712095.0,
        "delta": -11437696.0
      },
      {
        "periodo": 202605,
        "valor": 1285042886.0,
        "delta": -76669209.0
      },
      {
        "periodo": 202606,
        "valor": 1201536096.0,
        "delta": -83506790.0
      },
      {
        "periodo": 202607,
        "valor": 1266362868.0,
        "delta": 64826772.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 47131894673.98,
    "valor_anterior": 46923410023.51,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40881630689.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 41354304989.28,
        "delta": 472674300.01
      },
      {
        "periodo": 202509,
        "valor": 41722390265.86,
        "delta": 368085276.58
      },
      {
        "periodo": 202510,
        "valor": 43077621556.08,
        "delta": 1355231290.22
      },
      {
        "periodo": 202511,
        "valor": 44007532409.05,
        "delta": 929910852.97
      },
      {
        "periodo": 202512,
        "valor": 43804343801.15,
        "delta": -203188607.9
      },
      {
        "periodo": 202601,
        "valor": 44536725175.48,
        "delta": 732381374.33
      },
      {
        "periodo": 202602,
        "valor": 44844766002.79,
        "delta": 308040827.31
      },
      {
        "periodo": 202603,
        "valor": 45987710886.45,
        "delta": 1142944883.66
      },
      {
        "periodo": 202604,
        "valor": 46650308554.37,
        "delta": 662597667.92
      },
      {
        "periodo": 202605,
        "valor": 47146583154.32,
        "delta": 496274599.95
      },
      {
        "periodo": 202606,
        "valor": 46923410023.51,
        "delta": -223173130.81
      },
      {
        "periodo": 202607,
        "valor": 47131894673.98,
        "delta": 208484650.47
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 9420452930.45,
    "valor_anterior": 9061657668.28,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6995659313.83,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7229072075.54,
        "delta": 233412761.71
      },
      {
        "periodo": 202509,
        "valor": 7422878974.55,
        "delta": 193806899.01
      },
      {
        "periodo": 202510,
        "valor": 7766014313.84,
        "delta": 343135339.29
      },
      {
        "periodo": 202511,
        "valor": 7959168838.02,
        "delta": 193154524.18
      },
      {
        "periodo": 202512,
        "valor": 8100131413.37,
        "delta": 140962575.35
      },
      {
        "periodo": 202601,
        "valor": 8263751505.82,
        "delta": 163620092.45
      },
      {
        "periodo": 202602,
        "valor": 8621532591.84,
        "delta": 357781086.02
      },
      {
        "periodo": 202603,
        "valor": 8730796866.4,
        "delta": 109264274.56
      },
      {
        "periodo": 202604,
        "valor": 8806093407.33,
        "delta": 75296540.93
      },
      {
        "periodo": 202605,
        "valor": 9110614043.85,
        "delta": 304520636.52
      },
      {
        "periodo": 202606,
        "valor": 9061657668.28,
        "delta": -48956375.57
      },
      {
        "periodo": 202607,
        "valor": 9420452930.45,
        "delta": 358795262.17
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 5735906798.0,
    "valor_anterior": 5867555380.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4847786461.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4986133014.0,
        "delta": 138346553.0
      },
      {
        "periodo": 202509,
        "valor": 5056296336.0,
        "delta": 70163322.0
      },
      {
        "periodo": 202510,
        "valor": 5482384406.0,
        "delta": 426088070.0
      },
      {
        "periodo": 202511,
        "valor": 5286317699.0,
        "delta": -196066707.0
      },
      {
        "periodo": 202512,
        "valor": 5486377766.0,
        "delta": 200060067.0
      },
      {
        "periodo": 202601,
        "valor": 5361864823.0,
        "delta": -124512943.0
      },
      {
        "periodo": 202602,
        "valor": 5301157015.0,
        "delta": -60707808.0
      },
      {
        "periodo": 202603,
        "valor": 5075999498.0,
        "delta": -225157517.0
      },
      {
        "periodo": 202604,
        "valor": 4989167959.0,
        "delta": -86831539.0
      },
      {
        "periodo": 202605,
        "valor": 5231333916.0,
        "delta": 242165957.0
      },
      {
        "periodo": 202606,
        "valor": 5867555381.0,
        "delta": 636221465.0
      },
      {
        "periodo": 202607,
        "valor": 5735906798.0,
        "delta": -131648583.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 111466021267.0,
    "valor_anterior": 111126821576.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 100008234970.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 100236366798.0,
        "delta": 228131828.0
      },
      {
        "periodo": 202509,
        "valor": 101253127216.0,
        "delta": 1016760418.0
      },
      {
        "periodo": 202510,
        "valor": 102783961140.0,
        "delta": 1530833924.0
      },
      {
        "periodo": 202511,
        "valor": 102998940892.0,
        "delta": 214979752.0
      },
      {
        "periodo": 202512,
        "valor": 107413889470.0,
        "delta": 4414948578.0
      },
      {
        "periodo": 202601,
        "valor": 107378485099.0,
        "delta": -35404371.0
      },
      {
        "periodo": 202602,
        "valor": 110141322462.0,
        "delta": 2762837363.0
      },
      {
        "periodo": 202603,
        "valor": 112434276262.0,
        "delta": 2292953800.0
      },
      {
        "periodo": 202604,
        "valor": 111747707850.0,
        "delta": -686568412.0
      },
      {
        "periodo": 202605,
        "valor": 110971463959.0,
        "delta": -776243891.0
      },
      {
        "periodo": 202606,
        "valor": 111126821576.0,
        "delta": 155357617.0
      },
      {
        "periodo": 202607,
        "valor": 111466021267.0,
        "delta": 339199691.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 4115418620.0,
    "valor_anterior": 4010904875.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4552784399.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4488866096.0,
        "delta": -63918303.0
      },
      {
        "periodo": 202509,
        "valor": 4352655494.0,
        "delta": -136210602.0
      },
      {
        "periodo": 202510,
        "valor": 4089141601.0,
        "delta": -263513893.0
      },
      {
        "periodo": 202511,
        "valor": 4102034309.0,
        "delta": 12892708.0
      },
      {
        "periodo": 202512,
        "valor": 4023845748.0,
        "delta": -78188561.0
      },
      {
        "periodo": 202601,
        "valor": 3852684373.0,
        "delta": -171161375.0
      },
      {
        "periodo": 202602,
        "valor": 3796557817.0,
        "delta": -56126556.0
      },
      {
        "periodo": 202603,
        "valor": 3877796558.0,
        "delta": 81238741.0
      },
      {
        "periodo": 202604,
        "valor": 3966184918.0,
        "delta": 88388360.0
      },
      {
        "periodo": 202605,
        "valor": 3795727360.0,
        "delta": -170457558.0
      },
      {
        "periodo": 202606,
        "valor": 4010904875.0,
        "delta": 215177515.0
      },
      {
        "periodo": 202607,
        "valor": 4115418620.0,
        "delta": 104513745.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 7215073431.31,
    "valor_anterior": 7453308411.62,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6063780273.73,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6064050000.44,
        "delta": 269726.71
      },
      {
        "periodo": 202509,
        "valor": 6089653427.38,
        "delta": 25603426.94
      },
      {
        "periodo": 202510,
        "valor": 5851998516.46,
        "delta": -237654910.92
      },
      {
        "periodo": 202511,
        "valor": 2617640055.9,
        "delta": -3234358460.56
      },
      {
        "periodo": 202512,
        "valor": 2740035373.47,
        "delta": 122395317.57
      },
      {
        "periodo": 202601,
        "valor": 2811546109.15,
        "delta": 71510735.68
      },
      {
        "periodo": 202602,
        "valor": 3266334064.1,
        "delta": 454787954.95
      },
      {
        "periodo": 202603,
        "valor": 3059409039.36,
        "delta": -206925024.74
      },
      {
        "periodo": 202604,
        "valor": 7106010412.39,
        "delta": 4046601373.03
      },
      {
        "periodo": 202605,
        "valor": 7358557589.23,
        "delta": 252547176.84
      },
      {
        "periodo": 202606,
        "valor": 7453308411.62,
        "delta": 94750822.39
      },
      {
        "periodo": 202607,
        "valor": 7215073431.31,
        "delta": -238234980.31
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 4661344049.38,
    "valor_anterior": 4374387130.11,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3537130159.63,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2680198649.07,
        "delta": -856931510.56
      },
      {
        "periodo": 202509,
        "valor": 2572106704.65,
        "delta": -108091944.42
      },
      {
        "periodo": 202510,
        "valor": 2866966908.01,
        "delta": 294860203.36
      },
      {
        "periodo": 202511,
        "valor": 2815029798.91,
        "delta": -51937109.1
      },
      {
        "periodo": 202512,
        "valor": 2741187659.87,
        "delta": -73842139.04
      },
      {
        "periodo": 202601,
        "valor": 2878476035.48,
        "delta": 137288375.61
      },
      {
        "periodo": 202602,
        "valor": 3147121497.56,
        "delta": 268645462.08
      },
      {
        "periodo": 202603,
        "valor": 3499791884.58,
        "delta": 352670387.02
      },
      {
        "periodo": 202604,
        "valor": 3842484007.08,
        "delta": 342692122.5
      },
      {
        "periodo": 202605,
        "valor": 3885488023.22,
        "delta": 43004016.14
      },
      {
        "periodo": 202606,
        "valor": 4374387130.11,
        "delta": 488899106.89
      },
      {
        "periodo": 202607,
        "valor": 4661344049.38,
        "delta": 286956919.27
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 29217.0,
    "valor_anterior": 14100586.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 159360791.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 149064575.0,
        "delta": -10296216.0
      },
      {
        "periodo": 202509,
        "valor": 48470706.0,
        "delta": -100593869.0
      },
      {
        "periodo": 202510,
        "valor": 19792050.0,
        "delta": -28678656.0
      },
      {
        "periodo": 202511,
        "valor": 152028960.0,
        "delta": 132236910.0
      },
      {
        "periodo": 202512,
        "valor": 10126466.0,
        "delta": -141902494.0
      },
      {
        "periodo": 202601,
        "valor": 15093062.0,
        "delta": 4966596.0
      },
      {
        "periodo": 202602,
        "valor": 8740527.0,
        "delta": -6352535.0
      },
      {
        "periodo": 202603,
        "valor": 258023564.0,
        "delta": 249283037.0
      },
      {
        "periodo": 202604,
        "valor": 230181356.0,
        "delta": -27842208.0
      },
      {
        "periodo": 202605,
        "valor": 33850128.0,
        "delta": -196331228.0
      },
      {
        "periodo": 202606,
        "valor": 14100586.0,
        "delta": -19749542.0
      },
      {
        "periodo": 202607,
        "valor": 29217.0,
        "delta": -14071369.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 3495350873.0,
    "valor_anterior": 3507499297.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3885129515.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3613103719.0,
        "delta": -272025796.0
      },
      {
        "periodo": 202509,
        "valor": 3523981864.0,
        "delta": -89121855.0
      },
      {
        "periodo": 202510,
        "valor": 3556341671.0,
        "delta": 32359807.0
      },
      {
        "periodo": 202511,
        "valor": 3638434199.0,
        "delta": 82092528.0
      },
      {
        "periodo": 202512,
        "valor": 3563285747.0,
        "delta": -75148452.0
      },
      {
        "periodo": 202601,
        "valor": 3435501152.0,
        "delta": -127784595.0
      },
      {
        "periodo": 202602,
        "valor": 3385579927.0,
        "delta": -49921225.0
      },
      {
        "periodo": 202603,
        "valor": 3490434764.0,
        "delta": 104854837.0
      },
      {
        "periodo": 202604,
        "valor": 3431297011.0,
        "delta": -59137753.0
      },
      {
        "periodo": 202605,
        "valor": 3316228079.0,
        "delta": -115068932.0
      },
      {
        "periodo": 202606,
        "valor": 3507499297.0,
        "delta": 191271218.0
      },
      {
        "periodo": 202607,
        "valor": 3495350873.0,
        "delta": -12148424.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 4968534291.01,
    "valor_anterior": 4956417279.42,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 4715671063.64,
        "delta": 4715671063.64
      },
      {
        "periodo": 202603,
        "valor": 4894564580.49,
        "delta": 178893516.85
      },
      {
        "periodo": 202604,
        "valor": 4939416035.87,
        "delta": 44851455.38
      },
      {
        "periodo": 202605,
        "valor": 4963754334.69,
        "delta": 24338298.82
      },
      {
        "periodo": 202606,
        "valor": 4956417279.42,
        "delta": -7337055.27
      },
      {
        "periodo": 202607,
        "valor": 4968534291.01,
        "delta": 12117011.59
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 4917458347604.81,
    "valor_anterior": 4877556386253.4,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4563975773727.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4554288025651.93,
        "delta": -9687748075.8105
      },
      {
        "periodo": 202509,
        "valor": 4539201746655.4,
        "delta": -15086278996.5293
      },
      {
        "periodo": 202510,
        "valor": 4590482538709.62,
        "delta": 51280792054.2197
      },
      {
        "periodo": 202511,
        "valor": 4638341564637.61,
        "delta": 47859025927.9902
      },
      {
        "periodo": 202512,
        "valor": 4745773481039.65,
        "delta": 107431916402.04
      },
      {
        "periodo": 202601,
        "valor": 4725476693265.17,
        "delta": -20296787774.4805
      },
      {
        "periodo": 202602,
        "valor": 4723187285142.93,
        "delta": -2289408122.2402
      },
      {
        "periodo": 202603,
        "valor": 4801778311200.569,
        "delta": 78591026057.6396
      },
      {
        "periodo": 202604,
        "valor": 4796722099613.64,
        "delta": -5056211586.9297
      },
      {
        "periodo": 202605,
        "valor": 4841704128980.93,
        "delta": 44982029367.29
      },
      {
        "periodo": 202606,
        "valor": 4877556386253.4,
        "delta": 35852257272.4707
      },
      {
        "periodo": 202607,
        "valor": 4917458347604.81,
        "delta": 39901961351.4092
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 3417078372435.48,
    "valor_anterior": 3389845585283.84,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3202601477246.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3191322283115.87,
        "delta": -11279194130.52
      },
      {
        "periodo": 202509,
        "valor": 3180212305749.91,
        "delta": -11109977365.96
      },
      {
        "periodo": 202510,
        "valor": 3220089619001.91,
        "delta": 39877313252.0
      },
      {
        "periodo": 202511,
        "valor": 3257975487436.06,
        "delta": 37885868434.1499
      },
      {
        "periodo": 202512,
        "valor": 3325484278417.07,
        "delta": 67508790981.0098
      },
      {
        "periodo": 202601,
        "valor": 3305914783683.15,
        "delta": -19569494733.9199
      },
      {
        "periodo": 202602,
        "valor": 3290987553123.92,
        "delta": -14927230559.23
      },
      {
        "periodo": 202603,
        "valor": 3338306636081.19,
        "delta": 47319082957.27
      },
      {
        "periodo": 202604,
        "valor": 3337066137429.15,
        "delta": -1240498652.04
      },
      {
        "periodo": 202605,
        "valor": 3369429291420.03,
        "delta": 32363153990.8799
      },
      {
        "periodo": 202606,
        "valor": 3389845585283.84,
        "delta": 20416293863.8101
      },
      {
        "periodo": 202607,
        "valor": 3417078372435.48,
        "delta": 27232787151.6401
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 72600609726.84,
    "valor_anterior": 74604129317.84,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 91795058927.34,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 84369239309.23,
        "delta": -7425819618.11
      },
      {
        "periodo": 202509,
        "valor": 66741782927.76,
        "delta": -17627456381.47
      },
      {
        "periodo": 202510,
        "valor": 68043062035.9,
        "delta": 1301279108.14
      },
      {
        "periodo": 202511,
        "valor": 68290513560.26,
        "delta": 247451524.36
      },
      {
        "periodo": 202512,
        "valor": 74474925442.23,
        "delta": 6184411881.97
      },
      {
        "periodo": 202601,
        "valor": 74175246242.89,
        "delta": -299679199.34
      },
      {
        "periodo": 202602,
        "valor": 74446375401.32,
        "delta": 271129158.43
      },
      {
        "periodo": 202603,
        "valor": 75529935391.84,
        "delta": 1083559990.52
      },
      {
        "periodo": 202604,
        "valor": 75285561251.26,
        "delta": -244374140.58
      },
      {
        "periodo": 202605,
        "valor": 75206783914.91,
        "delta": -78777336.35
      },
      {
        "periodo": 202606,
        "valor": 74604129317.84,
        "delta": -602654597.07
      },
      {
        "periodo": 202607,
        "valor": 72600609726.84,
        "delta": -2003519591.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 288641781566.55,
    "valor_anterior": 279514139234.85,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 299784673240.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 296936923662.99,
        "delta": -2847749577.54
      },
      {
        "periodo": 202509,
        "valor": 291129614248.59,
        "delta": -5807309414.4
      },
      {
        "periodo": 202510,
        "valor": 293713144772.34,
        "delta": 2583530523.75
      },
      {
        "periodo": 202511,
        "valor": 291242327629.88,
        "delta": -2470817142.46
      },
      {
        "periodo": 202512,
        "valor": 289706938979.48,
        "delta": -1535388650.4
      },
      {
        "periodo": 202601,
        "valor": 285544497512.24,
        "delta": -4162441467.24
      },
      {
        "periodo": 202602,
        "valor": 280033869892.72,
        "delta": -5510627619.52
      },
      {
        "periodo": 202603,
        "valor": 293349454705.15,
        "delta": 13315584812.4301
      },
      {
        "periodo": 202604,
        "valor": 279923397890.25,
        "delta": -13426056814.9
      },
      {
        "periodo": 202605,
        "valor": 277000233312.11,
        "delta": -2923164578.14
      },
      {
        "periodo": 202606,
        "valor": 279514139234.85,
        "delta": 2513905922.74
      },
      {
        "periodo": 202607,
        "valor": 288641781566.55,
        "delta": 9127642331.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 809288157937.66,
    "valor_anterior": 807190799295.13,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 695585518306.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 702295133040.55,
        "delta": 6709614733.7301
      },
      {
        "periodo": 202509,
        "valor": 713335357974.99,
        "delta": 11040224934.4399
      },
      {
        "periodo": 202510,
        "valor": 716962183595.42,
        "delta": 3626825620.4301
      },
      {
        "periodo": 202511,
        "valor": 726358675165.42,
        "delta": 9396491570.0
      },
      {
        "periodo": 202512,
        "valor": 758468324675.89,
        "delta": 32109649510.47
      },
      {
        "periodo": 202601,
        "valor": 756564551430.0299,
        "delta": -1903773245.8601
      },
      {
        "periodo": 202602,
        "valor": 765361016307.1499,
        "delta": 8796464877.12
      },
      {
        "periodo": 202603,
        "valor": 780082598315.61,
        "delta": 14721582008.4601
      },
      {
        "periodo": 202604,
        "valor": 783801093851.76,
        "delta": 3718495536.15
      },
      {
        "periodo": 202605,
        "valor": 795486276493.52,
        "delta": 11685182641.76
      },
      {
        "periodo": 202606,
        "valor": 807190799295.13,
        "delta": 11704522801.61
      },
      {
        "periodo": 202607,
        "valor": 809288157937.66,
        "delta": 2097358642.53
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 201307978374.71,
    "valor_anterior": 199467807340.82,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 159903281270.01,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 162353466976.43,
        "delta": 2450185706.42
      },
      {
        "periodo": 202509,
        "valor": 174310889035.03,
        "delta": 11957422058.6
      },
      {
        "periodo": 202510,
        "valor": 176103828509.62,
        "delta": 1792939474.59
      },
      {
        "periodo": 202511,
        "valor": 177428598355.65,
        "delta": 1324769846.03
      },
      {
        "periodo": 202512,
        "valor": 180541477077.98,
        "delta": 3112878722.33
      },
      {
        "periodo": 202601,
        "valor": 181053247249.24,
        "delta": 511770171.26
      },
      {
        "periodo": 202602,
        "valor": 183438609601.88,
        "delta": 2385362352.64
      },
      {
        "periodo": 202603,
        "valor": 187479328576.76,
        "delta": 4040718974.88
      },
      {
        "periodo": 202604,
        "valor": 194239242466.12,
        "delta": 6759913889.36
      },
      {
        "periodo": 202605,
        "valor": 197320022842.48,
        "delta": 3080780376.36
      },
      {
        "periodo": 202606,
        "valor": 199467807340.82,
        "delta": 2147784498.34
      },
      {
        "periodo": 202607,
        "valor": 201307978374.71,
        "delta": 1840171033.89
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100186,
    "label": "Créditos Comerciales",
    "valor_actual": 128541447563.57,
    "valor_anterior": 126933925780.92,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 114305764736.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 117010979546.86,
        "delta": 2705214810.21
      },
      {
        "periodo": 202509,
        "valor": 113471796719.12,
        "delta": -3539182827.74
      },
      {
        "periodo": 202510,
        "valor": 115570700794.43,
        "delta": 2098904075.31
      },
      {
        "periodo": 202511,
        "valor": 117045962490.34,
        "delta": 1475261695.91
      },
      {
        "periodo": 202512,
        "valor": 117097536447.0,
        "delta": 51573956.66
      },
      {
        "periodo": 202601,
        "valor": 122224367147.62,
        "delta": 5126830700.62
      },
      {
        "periodo": 202602,
        "valor": 128919860815.94,
        "delta": 6695493668.32
      },
      {
        "periodo": 202603,
        "valor": 127030358130.02,
        "delta": -1889502685.92
      },
      {
        "periodo": 202604,
        "valor": 126406666725.1,
        "delta": -623691404.92
      },
      {
        "periodo": 202605,
        "valor": 127261520997.88,
        "delta": 854854272.78
      },
      {
        "periodo": 202606,
        "valor": 126933925780.92,
        "delta": -327595216.96
      },
      {
        "periodo": 202607,
        "valor": 128541447563.57,
        "delta": 1607521782.65
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 273217471033.84,
    "valor_anterior": 273250995000.51,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 244484247183.28,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 248744953233.87,
        "delta": 4260706050.59
      },
      {
        "periodo": 202509,
        "valor": 251357642362.17,
        "delta": 2612689128.3
      },
      {
        "periodo": 202510,
        "valor": 255157092946.48,
        "delta": 3799450584.31
      },
      {
        "periodo": 202511,
        "valor": 270742191233.86,
        "delta": 15585098287.38
      },
      {
        "periodo": 202512,
        "valor": 265490019309.27,
        "delta": -5252171924.59
      },
      {
        "periodo": 202601,
        "valor": 266196209572.62,
        "delta": 706190263.35
      },
      {
        "periodo": 202602,
        "valor": 264676320071.96,
        "delta": -1519889500.66
      },
      {
        "periodo": 202603,
        "valor": 265419547051.97,
        "delta": 743226980.01
      },
      {
        "periodo": 202604,
        "valor": 268537677342.63,
        "delta": 3118130290.66
      },
      {
        "periodo": 202605,
        "valor": 271048109239.91,
        "delta": 2510431897.28
      },
      {
        "periodo": 202606,
        "valor": 273250995000.51,
        "delta": 2202885760.6
      },
      {
        "periodo": 202607,
        "valor": 273217471033.84,
        "delta": -33523966.67
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 594952175923.26,
    "valor_anterior": 593066066696.8,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 533772291121.07,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 541506774673.49,
        "delta": 7734483552.42
      },
      {
        "periodo": 202509,
        "valor": 549421992430.91,
        "delta": 7915217757.42
      },
      {
        "periodo": 202510,
        "valor": 557160984590.58,
        "delta": 7738992159.67
      },
      {
        "periodo": 202511,
        "valor": 573580800496.62,
        "delta": 16419815906.04
      },
      {
        "periodo": 202512,
        "valor": 569789111739.42,
        "delta": -3791688757.2
      },
      {
        "periodo": 202601,
        "valor": 571222102976.02,
        "delta": 1432991236.6
      },
      {
        "periodo": 202602,
        "valor": 571833398531.79,
        "delta": 611295555.77
      },
      {
        "periodo": 202603,
        "valor": 576114414968.49,
        "delta": 4281016436.7
      },
      {
        "periodo": 202604,
        "valor": 581900162307.07,
        "delta": 5785747338.58
      },
      {
        "periodo": 202605,
        "valor": 584935343794.58,
        "delta": 3035181487.51
      },
      {
        "periodo": 202606,
        "valor": 593066066696.8,
        "delta": 8130722902.2201
      },
      {
        "periodo": 202607,
        "valor": 594952175923.26,
        "delta": 1886109226.46
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 224001908622.0,
    "valor_anterior": 224097397203.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 211070478309.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 212286105837.0,
        "delta": 1215627528.0
      },
      {
        "periodo": 202509,
        "valor": 212045471332.0,
        "delta": -240634505.0
      },
      {
        "periodo": 202510,
        "valor": 214234399815.0,
        "delta": 2188928483.0
      },
      {
        "periodo": 202511,
        "valor": 220506184132.0,
        "delta": 6271784317.0
      },
      {
        "periodo": 202512,
        "valor": 218586856493.0,
        "delta": -1919327639.0
      },
      {
        "periodo": 202601,
        "valor": 219754677900.0,
        "delta": 1167821407.0
      },
      {
        "periodo": 202602,
        "valor": 220333235057.0,
        "delta": 578557157.0
      },
      {
        "periodo": 202603,
        "valor": 218987929386.0,
        "delta": -1345305671.0
      },
      {
        "periodo": 202604,
        "valor": 221083374094.0,
        "delta": 2095444708.0
      },
      {
        "periodo": 202605,
        "valor": 222600767159.0,
        "delta": 1517393065.0
      },
      {
        "periodo": 202606,
        "valor": 224097397203.0,
        "delta": 1496630044.0
      },
      {
        "periodo": 202607,
        "valor": 224001908622.0,
        "delta": -95488581.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 82709925549.0,
    "valor_anterior": 84584045547.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 99988103394.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 99132472493.0,
        "delta": -855630901.0
      },
      {
        "periodo": 202509,
        "valor": 97179157787.0,
        "delta": -1953314706.0
      },
      {
        "periodo": 202510,
        "valor": 95654817101.0,
        "delta": -1524340686.0
      },
      {
        "periodo": 202511,
        "valor": 96435482699.0,
        "delta": 780665598.0
      },
      {
        "periodo": 202512,
        "valor": 93006086742.0,
        "delta": -3429395957.0
      },
      {
        "periodo": 202601,
        "valor": 91242821091.0,
        "delta": -1763265651.0
      },
      {
        "periodo": 202602,
        "valor": 90051688945.0,
        "delta": -1191132146.0
      },
      {
        "periodo": 202603,
        "valor": 87459846944.0,
        "delta": -2591842001.0
      },
      {
        "periodo": 202604,
        "valor": 86488262428.0,
        "delta": -971584516.0
      },
      {
        "periodo": 202605,
        "valor": 85975960230.0,
        "delta": -512302198.0
      },
      {
        "periodo": 202606,
        "valor": 84584045547.0,
        "delta": -1391914683.0
      },
      {
        "periodo": 202607,
        "valor": 82709925549.0,
        "delta": -1874119998.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 8329767783.93,
    "valor_anterior": 8229886073.86,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7462359298.11,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7559271547.83,
        "delta": 96912249.72
      },
      {
        "periodo": 202509,
        "valor": 7603658126.51,
        "delta": 44386578.68
      },
      {
        "periodo": 202510,
        "valor": 7691571480.51,
        "delta": 87913354.0
      },
      {
        "periodo": 202511,
        "valor": 7854669203.02,
        "delta": 163097722.51
      },
      {
        "periodo": 202512,
        "valor": 7857247584.61,
        "delta": 2578381.59
      },
      {
        "periodo": 202601,
        "valor": 7899552839.62,
        "delta": 42305255.01
      },
      {
        "periodo": 202602,
        "valor": 7867464587.24,
        "delta": -32088252.38
      },
      {
        "periodo": 202603,
        "valor": 7855518372.08,
        "delta": -11946215.16
      },
      {
        "periodo": 202604,
        "valor": 7945797256.07,
        "delta": 90278883.99
      },
      {
        "periodo": 202605,
        "valor": 8089314963.53,
        "delta": 143517707.46
      },
      {
        "periodo": 202606,
        "valor": 8229886073.86,
        "delta": 140571110.33
      },
      {
        "periodo": 202607,
        "valor": 8329767783.93,
        "delta": 99881710.07
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 105009249026.99998,
    "valor_anterior": 104049887426.99998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 94558223796.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 95775571554.0,
        "delta": 1217347758.0
      },
      {
        "periodo": 202509,
        "valor": 96438414303.0,
        "delta": 662842749.0
      },
      {
        "periodo": 202510,
        "valor": 97465185363.0,
        "delta": 1026771060.0
      },
      {
        "periodo": 202511,
        "valor": 100134052136.0,
        "delta": 2668866773.0
      },
      {
        "periodo": 202512,
        "valor": 101157879014.0,
        "delta": 1023826878.0
      },
      {
        "periodo": 202601,
        "valor": 102183774864.0,
        "delta": 1025895850.0
      },
      {
        "periodo": 202602,
        "valor": 102224938862.0,
        "delta": 41163998.0
      },
      {
        "periodo": 202603,
        "valor": 102621195344.0,
        "delta": 396256482.0
      },
      {
        "periodo": 202604,
        "valor": 102834319875.0,
        "delta": 213124531.0
      },
      {
        "periodo": 202605,
        "valor": 103806168924.0,
        "delta": 971849049.0
      },
      {
        "periodo": 202606,
        "valor": 104049887427.0,
        "delta": 243718503.0
      },
      {
        "periodo": 202607,
        "valor": 105009249027.0,
        "delta": 959361600.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 588468056.0,
    "valor_anterior": 584167333.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 433824707.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 432435639.0,
        "delta": -1389068.0
      },
      {
        "periodo": 202509,
        "valor": 440510649.0,
        "delta": 8075010.0
      },
      {
        "periodo": 202510,
        "valor": 448634626.0,
        "delta": 8123977.0
      },
      {
        "periodo": 202511,
        "valor": 465510135.0,
        "delta": 16875509.0
      },
      {
        "periodo": 202512,
        "valor": 470046762.0,
        "delta": 4536627.0
      },
      {
        "periodo": 202601,
        "valor": 508118334.0,
        "delta": 38071572.0
      },
      {
        "periodo": 202602,
        "valor": 514094186.0,
        "delta": 5975852.0
      },
      {
        "periodo": 202603,
        "valor": 513987326.0,
        "delta": -106860.0
      },
      {
        "periodo": 202604,
        "valor": 535369278.0,
        "delta": 21381952.0
      },
      {
        "periodo": 202605,
        "valor": 558297248.0,
        "delta": 22927970.0
      },
      {
        "periodo": 202606,
        "valor": 584167333.0,
        "delta": 25870085.0
      },
      {
        "periodo": 202607,
        "valor": 588468056.0,
        "delta": 4300723.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 62695680432.0,
    "valor_anterior": 61860507367.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 54528826251.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55377446620.0,
        "delta": 848620369.0
      },
      {
        "periodo": 202509,
        "valor": 56073571421.0,
        "delta": 696124801.0
      },
      {
        "periodo": 202510,
        "valor": 56762320781.0,
        "delta": 688749360.0
      },
      {
        "periodo": 202511,
        "valor": 57998754706.0,
        "delta": 1236433925.0
      },
      {
        "periodo": 202512,
        "valor": 58051704238.0,
        "delta": 52949532.0
      },
      {
        "periodo": 202601,
        "valor": 58632226406.0,
        "delta": 580522168.0
      },
      {
        "periodo": 202602,
        "valor": 59034032714.0,
        "delta": 401806308.0
      },
      {
        "periodo": 202603,
        "valor": 59573023298.0,
        "delta": 538990584.0
      },
      {
        "periodo": 202604,
        "valor": 60507346358.0,
        "delta": 934323060.0
      },
      {
        "periodo": 202605,
        "valor": 61253889654.0,
        "delta": 746543296.0
      },
      {
        "periodo": 202606,
        "valor": 61860507367.0,
        "delta": 606617713.0
      },
      {
        "periodo": 202607,
        "valor": 62695680432.0,
        "delta": 835173065.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 8899216874.0,
    "valor_anterior": 8921281792.13,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13346973562.54,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13480463294.05,
        "delta": 133489731.51
      },
      {
        "periodo": 202509,
        "valor": 13571787821.1,
        "delta": 91324527.05
      },
      {
        "periodo": 202510,
        "valor": 13732644895.08,
        "delta": 160857073.98
      },
      {
        "periodo": 202511,
        "valor": 14037735212.18,
        "delta": 305090317.1
      },
      {
        "periodo": 202512,
        "valor": 14143971683.64,
        "delta": 106236471.46
      },
      {
        "periodo": 202601,
        "valor": 14276742254.28,
        "delta": 132770570.64
      },
      {
        "periodo": 202602,
        "valor": 8491215328.78,
        "delta": -5785526925.5
      },
      {
        "periodo": 202603,
        "valor": 8585594801.42,
        "delta": 94379472.64
      },
      {
        "periodo": 202604,
        "valor": 8642863868.18,
        "delta": 57269066.76
      },
      {
        "periodo": 202605,
        "valor": 8765399878.17,
        "delta": 122536009.99
      },
      {
        "periodo": 202606,
        "valor": 8921281792.13,
        "delta": 155881913.96
      },
      {
        "periodo": 202607,
        "valor": 8899216874.0,
        "delta": -22064918.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 39980400564.0,
    "valor_anterior": 39616587302.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 32652582469.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 33080121935.0,
        "delta": 427539466.0
      },
      {
        "periodo": 202509,
        "valor": 33743568100.0,
        "delta": 663446165.0
      },
      {
        "periodo": 202510,
        "valor": 34152326747.0,
        "delta": 408758647.0
      },
      {
        "periodo": 202511,
        "valor": 35988863866.0,
        "delta": 1836537119.0
      },
      {
        "periodo": 202512,
        "valor": 36016431676.0,
        "delta": 27567810.0
      },
      {
        "periodo": 202601,
        "valor": 36159579269.0,
        "delta": 143147593.0
      },
      {
        "periodo": 202602,
        "valor": 36338086318.0,
        "delta": 178507049.0
      },
      {
        "periodo": 202603,
        "valor": 37091199556.0,
        "delta": 753113238.0
      },
      {
        "periodo": 202604,
        "valor": 38028687281.0,
        "delta": 937487725.0
      },
      {
        "periodo": 202605,
        "valor": 38788740212.0,
        "delta": 760052931.0
      },
      {
        "periodo": 202606,
        "valor": 39616587302.0,
        "delta": 827847090.0
      },
      {
        "periodo": 202607,
        "valor": 39980400564.0,
        "delta": 363813262.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 1025144805.0,
    "valor_anterior": 1000268533.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 855705460.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 866555848.0,
        "delta": 10850388.0
      },
      {
        "periodo": 202509,
        "valor": 870312134.0,
        "delta": 3756286.0
      },
      {
        "periodo": 202510,
        "valor": 885935606.0,
        "delta": 15623472.0
      },
      {
        "periodo": 202511,
        "valor": 891017438.0,
        "delta": 5081832.0
      },
      {
        "periodo": 202512,
        "valor": 954659162.0,
        "delta": 63641724.0
      },
      {
        "periodo": 202601,
        "valor": 958318244.0,
        "delta": 3659082.0
      },
      {
        "periodo": 202602,
        "valor": 964155386.0,
        "delta": 5837142.0
      },
      {
        "periodo": 202603,
        "valor": 962806413.0,
        "delta": -1348973.0
      },
      {
        "periodo": 202604,
        "valor": 959965569.0,
        "delta": -2840844.0
      },
      {
        "periodo": 202605,
        "valor": 994043877.0,
        "delta": 34078308.0
      },
      {
        "periodo": 202606,
        "valor": 1000268533.0,
        "delta": 6224656.0
      },
      {
        "periodo": 202607,
        "valor": 1025144805.0,
        "delta": 24876272.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 14177388603.0,
    "valor_anterior": 14082583711.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13234525040.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13324259619.0,
        "delta": 89734579.0
      },
      {
        "periodo": 202509,
        "valor": 13422301537.0,
        "delta": 98041918.0
      },
      {
        "periodo": 202510,
        "valor": 13496867720.0,
        "delta": 74566183.0
      },
      {
        "periodo": 202511,
        "valor": 13635486957.0,
        "delta": 138619237.0
      },
      {
        "periodo": 202512,
        "valor": 13600381626.0,
        "delta": -35105331.0
      },
      {
        "periodo": 202601,
        "valor": 13590947177.0,
        "delta": -9434449.0
      },
      {
        "periodo": 202602,
        "valor": 13634595108.0,
        "delta": 43647931.0
      },
      {
        "periodo": 202603,
        "valor": 13727007896.0,
        "delta": 92412788.0
      },
      {
        "periodo": 202604,
        "valor": 13739396597.0,
        "delta": 12388701.0
      },
      {
        "periodo": 202605,
        "valor": 13852346226.0,
        "delta": 112949629.0
      },
      {
        "periodo": 202606,
        "valor": 14082583711.0,
        "delta": 230237485.0
      },
      {
        "periodo": 202607,
        "valor": 14177388603.0,
        "delta": 94804892.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 263313295889.53,
    "valor_anterior": 262346539899.24,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 222368010950.32,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 225836760393.69,
        "delta": 3468749443.37
      },
      {
        "periodo": 202509,
        "valor": 229954734780.83,
        "delta": 4117974387.14
      },
      {
        "periodo": 202510,
        "valor": 233034318979.26,
        "delta": 3079584198.43
      },
      {
        "periodo": 202511,
        "valor": 239310660322.57,
        "delta": 6276341343.31
      },
      {
        "periodo": 202512,
        "valor": 245000406507.9,
        "delta": 5689746185.33
      },
      {
        "periodo": 202601,
        "valor": 248426355158.18,
        "delta": 3425948650.28
      },
      {
        "periodo": 202602,
        "valor": 250453801069.19,
        "delta": 2027445911.01
      },
      {
        "periodo": 202603,
        "valor": 253307016616.71,
        "delta": 2853215547.52
      },
      {
        "periodo": 202604,
        "valor": 257174273481.58,
        "delta": 3867256864.87
      },
      {
        "periodo": 202605,
        "valor": 259902744593.86,
        "delta": 2728471112.28
      },
      {
        "periodo": 202606,
        "valor": 262346539899.24,
        "delta": 2443795305.38
      },
      {
        "periodo": 202607,
        "valor": 263313295889.53,
        "delta": 966755990.29
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 168345122.0,
    "valor_anterior": 170090849.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 153455366.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 157215505.0,
        "delta": 3760139.0
      },
      {
        "periodo": 202509,
        "valor": 157838273.0,
        "delta": 622768.0
      },
      {
        "periodo": 202510,
        "valor": 133777001.0,
        "delta": -24061272.0
      },
      {
        "periodo": 202511,
        "valor": 136454988.0,
        "delta": 2677987.0
      },
      {
        "periodo": 202512,
        "valor": 140593629.0,
        "delta": 4138641.0
      },
      {
        "periodo": 202601,
        "valor": 115759627.0,
        "delta": -24834002.0
      },
      {
        "periodo": 202602,
        "valor": 114995003.0,
        "delta": -764624.0
      },
      {
        "periodo": 202603,
        "valor": 110620534.0,
        "delta": -4374469.0
      },
      {
        "periodo": 202604,
        "valor": 125601615.0,
        "delta": 14981081.0
      },
      {
        "periodo": 202605,
        "valor": 173944192.0,
        "delta": 48342577.0
      },
      {
        "periodo": 202606,
        "valor": 170090849.0,
        "delta": -3853343.0
      },
      {
        "periodo": 202607,
        "valor": 168345122.0,
        "delta": -1745727.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 146572896515.15,
    "valor_anterior": 145462335690.29,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 138102774990.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 140020542082.36,
        "delta": 1917767091.43
      },
      {
        "periodo": 202509,
        "valor": 141990021819.57,
        "delta": 1969479737.21
      },
      {
        "periodo": 202510,
        "valor": 143224336580.71,
        "delta": 1234314761.14
      },
      {
        "periodo": 202511,
        "valor": 144663531442.59,
        "delta": 1439194861.88
      },
      {
        "periodo": 202512,
        "valor": 145827386351.38,
        "delta": 1163854908.79
      },
      {
        "periodo": 202601,
        "valor": 144833837292.28,
        "delta": -993549059.1
      },
      {
        "periodo": 202602,
        "valor": 144408144343.15,
        "delta": -425692949.13
      },
      {
        "periodo": 202603,
        "valor": 144150368461.46,
        "delta": -257775881.69
      },
      {
        "periodo": 202604,
        "valor": 144470087511.0,
        "delta": 319719049.54
      },
      {
        "periodo": 202605,
        "valor": 144414482975.55,
        "delta": -55604535.45
      },
      {
        "periodo": 202606,
        "valor": 145462335690.29,
        "delta": 1047852714.74
      },
      {
        "periodo": 202607,
        "valor": 146572896515.15,
        "delta": 1110560824.86
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 725588045.0,
    "valor_anterior": 762503557.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 573044242.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 559646825.99,
        "delta": -13397416.91
      },
      {
        "periodo": 202509,
        "valor": 938386098.0,
        "delta": 378739272.01
      },
      {
        "periodo": 202510,
        "valor": 901443255.0,
        "delta": -36942843.0
      },
      {
        "periodo": 202511,
        "valor": 877191187.0,
        "delta": -24252068.0
      },
      {
        "periodo": 202512,
        "valor": 840340469.0,
        "delta": -36850718.0
      },
      {
        "periodo": 202601,
        "valor": 744133505.0,
        "delta": -96206964.0
      },
      {
        "periodo": 202602,
        "valor": 718406752.0,
        "delta": -25726753.0
      },
      {
        "periodo": 202603,
        "valor": 836457561.0,
        "delta": 118050809.0
      },
      {
        "periodo": 202604,
        "valor": 793863873.0,
        "delta": -42593688.0
      },
      {
        "periodo": 202605,
        "valor": 797878048.0,
        "delta": 4014175.0
      },
      {
        "periodo": 202606,
        "valor": 762503557.0,
        "delta": -35374491.0
      },
      {
        "periodo": 202607,
        "valor": 725588045.0,
        "delta": -36915512.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 63344225774.0,
    "valor_anterior": 62518987550.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 58883972262.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 59110491326.0,
        "delta": 226519064.0
      },
      {
        "periodo": 202509,
        "valor": 58108318914.0,
        "delta": -1002172412.0
      },
      {
        "periodo": 202510,
        "valor": 59605438543.0,
        "delta": 1497119629.0
      },
      {
        "periodo": 202511,
        "valor": 62195503319.0,
        "delta": 2590064776.0
      },
      {
        "periodo": 202512,
        "valor": 61886449497.0,
        "delta": -309053822.0
      },
      {
        "periodo": 202601,
        "valor": 59623337239.0,
        "delta": -2263112258.0
      },
      {
        "periodo": 202602,
        "valor": 61087618525.0,
        "delta": 1464281286.0
      },
      {
        "periodo": 202603,
        "valor": 63486784896.0,
        "delta": 2399166371.0
      },
      {
        "periodo": 202604,
        "valor": 61307139129.0,
        "delta": -2179645767.0
      },
      {
        "periodo": 202605,
        "valor": 60139791662.0,
        "delta": -1167347467.0
      },
      {
        "periodo": 202606,
        "valor": 62518987550.0,
        "delta": 2379195888.0
      },
      {
        "periodo": 202607,
        "valor": 63344225774.0,
        "delta": 825238224.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 8108801338.0,
    "valor_anterior": 7969236582.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6243778779.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6416821518.0,
        "delta": 173042739.0
      },
      {
        "periodo": 202509,
        "valor": 6641457217.0,
        "delta": 224635699.0
      },
      {
        "periodo": 202510,
        "valor": 7147820762.0,
        "delta": 506363545.0
      },
      {
        "periodo": 202511,
        "valor": 7125274449.0,
        "delta": -22546313.0
      },
      {
        "periodo": 202512,
        "valor": 6641451222.0,
        "delta": -483823227.0
      },
      {
        "periodo": 202601,
        "valor": 6766103741.0,
        "delta": 124652519.0
      },
      {
        "periodo": 202602,
        "valor": 6759571957.0,
        "delta": -6531784.0
      },
      {
        "periodo": 202603,
        "valor": 6961282778.0,
        "delta": 201710821.0
      },
      {
        "periodo": 202604,
        "valor": 7098962723.0,
        "delta": 137679945.0
      },
      {
        "periodo": 202605,
        "valor": 7279013486.0,
        "delta": 180050763.0
      },
      {
        "periodo": 202606,
        "valor": 7969236582.0,
        "delta": 690223096.0
      },
      {
        "periodo": 202607,
        "valor": 8108801338.0,
        "delta": 139564756.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 3441642112.0,
    "valor_anterior": 3314735568.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3616765988.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3646649297.0,
        "delta": 29883309.0
      },
      {
        "periodo": 202509,
        "valor": 3576655443.0,
        "delta": -69993854.0
      },
      {
        "periodo": 202510,
        "valor": 3605112084.0,
        "delta": 28456641.0
      },
      {
        "periodo": 202511,
        "valor": 3605389210.0,
        "delta": 277126.0
      },
      {
        "periodo": 202512,
        "valor": 3651176227.0,
        "delta": 45787017.0
      },
      {
        "periodo": 202601,
        "valor": 3652432189.0,
        "delta": 1255962.0
      },
      {
        "periodo": 202602,
        "valor": 3590390342.0,
        "delta": -62041847.0
      },
      {
        "periodo": 202603,
        "valor": 3204732159.0,
        "delta": -385658183.0
      },
      {
        "periodo": 202604,
        "valor": 3244019494.0,
        "delta": 39287335.0
      },
      {
        "periodo": 202605,
        "valor": 3102123446.0,
        "delta": -141896048.0
      },
      {
        "periodo": 202606,
        "valor": 3314735568.0,
        "delta": 212612122.0
      },
      {
        "periodo": 202607,
        "valor": 3441642112.0,
        "delta": 126906544.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 6093108.0,
    "valor_anterior": 6093108.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 474950504.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 468620832.0,
        "delta": -6329672.0
      },
      {
        "periodo": 202509,
        "valor": 57984211.0,
        "delta": -410636621.0
      },
      {
        "periodo": 202510,
        "valor": 58784272.0,
        "delta": 800061.0
      },
      {
        "periodo": 202511,
        "valor": 59319002.0,
        "delta": 534730.0
      },
      {
        "periodo": 202512,
        "valor": 57233033.0,
        "delta": -2085969.0
      },
      {
        "periodo": 202601,
        "valor": 52516458.0,
        "delta": -4716575.0
      },
      {
        "periodo": 202602,
        "valor": 48650221.0,
        "delta": -3866237.0
      },
      {
        "periodo": 202603,
        "valor": 6093108.0,
        "delta": -42557113.0
      },
      {
        "periodo": 202604,
        "valor": 6093108.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 6093108.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 6093108.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 6093108.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 32349562058.62,
    "valor_anterior": 31920400875.37,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22527042784.03,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 31042911084.35,
        "delta": 8515868300.32
      },
      {
        "periodo": 202509,
        "valor": 30870396836.95,
        "delta": -172514247.4
      },
      {
        "periodo": 202510,
        "valor": 31326091339.47,
        "delta": 455694502.52
      },
      {
        "periodo": 202511,
        "valor": 31341613304.74,
        "delta": 15521965.27
      },
      {
        "periodo": 202512,
        "valor": 30676342195.25,
        "delta": -665271109.49
      },
      {
        "periodo": 202601,
        "valor": 30515471884.41,
        "delta": -160870310.84
      },
      {
        "periodo": 202602,
        "valor": 30369908378.3,
        "delta": -145563506.11
      },
      {
        "periodo": 202603,
        "valor": 30362013196.0,
        "delta": -7895182.3
      },
      {
        "periodo": 202604,
        "valor": 30447351465.92,
        "delta": 85338269.92
      },
      {
        "periodo": 202605,
        "valor": 30172099765.28,
        "delta": -275251700.64
      },
      {
        "periodo": 202606,
        "valor": 31920400875.37,
        "delta": 1748301110.09
      },
      {
        "periodo": 202607,
        "valor": 32349562058.62,
        "delta": 429161183.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 1107930000.0,
    "valor_anterior": 1104273457.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 498933444.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 563714020.0,
        "delta": 64780576.0
      },
      {
        "periodo": 202509,
        "valor": 614567353.0,
        "delta": 50853333.0
      },
      {
        "periodo": 202510,
        "valor": 656392126.0,
        "delta": 41824773.0
      },
      {
        "periodo": 202511,
        "valor": 728158195.0,
        "delta": 71766069.0
      },
      {
        "periodo": 202512,
        "valor": 777889798.0,
        "delta": 49731603.0
      },
      {
        "periodo": 202601,
        "valor": 820021675.0,
        "delta": 42131877.0
      },
      {
        "periodo": 202602,
        "valor": 881901509.0,
        "delta": 61879834.0
      },
      {
        "periodo": 202603,
        "valor": 961338183.0,
        "delta": 79436674.0
      },
      {
        "periodo": 202604,
        "valor": 1050803501.0,
        "delta": 89465318.0
      },
      {
        "periodo": 202605,
        "valor": 1072769387.0,
        "delta": 21965886.0
      },
      {
        "periodo": 202606,
        "valor": 1104273457.0,
        "delta": 31504070.0
      },
      {
        "periodo": 202607,
        "valor": 1107930000.0,
        "delta": 3656543.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 25802498330.0,
    "valor_anterior": 25287840188.000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21620371163.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 22082053326.0,
        "delta": 461682163.0
      },
      {
        "periodo": 202509,
        "valor": 22517762508.0,
        "delta": 435709182.0
      },
      {
        "periodo": 202510,
        "valor": 23074853734.0,
        "delta": 557091226.0
      },
      {
        "periodo": 202511,
        "valor": 23429184264.0,
        "delta": 354330530.0
      },
      {
        "periodo": 202512,
        "valor": 23790803903.0,
        "delta": 361619639.0
      },
      {
        "periodo": 202601,
        "valor": 24185521210.0,
        "delta": 394717307.0
      },
      {
        "periodo": 202602,
        "valor": 24068219371.0,
        "delta": -117301839.0
      },
      {
        "periodo": 202603,
        "valor": 24490060436.0,
        "delta": 421841065.0
      },
      {
        "periodo": 202604,
        "valor": 25350730480.0,
        "delta": 860670044.0
      },
      {
        "periodo": 202605,
        "valor": 24906023190.0,
        "delta": -444707290.0
      },
      {
        "periodo": 202606,
        "valor": 25287840188.0,
        "delta": 381816998.0
      },
      {
        "periodo": 202607,
        "valor": 25802498330.0,
        "delta": 514658142.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 8513966594.0,
    "valor_anterior": 8389249619.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7276972022.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7404209130.0,
        "delta": 127237108.0
      },
      {
        "periodo": 202509,
        "valor": 7533604076.0,
        "delta": 129394946.0
      },
      {
        "periodo": 202510,
        "valor": 7698465813.0,
        "delta": 164861737.0
      },
      {
        "periodo": 202511,
        "valor": 7951339962.0,
        "delta": 252874149.0
      },
      {
        "periodo": 202512,
        "valor": 7817462009.0,
        "delta": -133877953.0
      },
      {
        "periodo": 202601,
        "valor": 8056481499.0,
        "delta": 239019490.0
      },
      {
        "periodo": 202602,
        "valor": 8233452457.0,
        "delta": 176970958.0
      },
      {
        "periodo": 202603,
        "valor": 8309479550.0,
        "delta": 76027093.0
      },
      {
        "periodo": 202604,
        "valor": 8343519485.0,
        "delta": 34039935.0
      },
      {
        "periodo": 202605,
        "valor": 8356289312.0,
        "delta": 12769827.0
      },
      {
        "periodo": 202606,
        "valor": 8389249619.0,
        "delta": 32960307.0
      },
      {
        "periodo": 202607,
        "valor": 8513966594.0,
        "delta": 124716975.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8962139067.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 762244295.0,
        "delta": -8199894772.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 38454340.0,
    "valor_anterior": 34452188.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26703181.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24838977.0,
        "delta": -1864204.0
      },
      {
        "periodo": 202509,
        "valor": 35567714.0,
        "delta": 10728737.0
      },
      {
        "periodo": 202510,
        "valor": 36830399.0,
        "delta": 1262685.0
      },
      {
        "periodo": 202511,
        "valor": 36182786.0,
        "delta": -647613.0
      },
      {
        "periodo": 202512,
        "valor": 19845872.0,
        "delta": -16336914.0
      },
      {
        "periodo": 202601,
        "valor": 17165942.0,
        "delta": -2679930.0
      },
      {
        "periodo": 202602,
        "valor": 19992508.0,
        "delta": 2826566.0
      },
      {
        "periodo": 202603,
        "valor": 21211952.0,
        "delta": 1219444.0
      },
      {
        "periodo": 202604,
        "valor": 23970502.0,
        "delta": 2758550.0
      },
      {
        "periodo": 202605,
        "valor": 31397054.0,
        "delta": 7426552.0
      },
      {
        "periodo": 202606,
        "valor": 34452188.0,
        "delta": 3055134.0
      },
      {
        "periodo": 202607,
        "valor": 38454340.0,
        "delta": 4002152.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 525284342.0,
    "valor_anterior": 534373423.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 381862345.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 404250303.0,
        "delta": 22387958.0
      },
      {
        "periodo": 202509,
        "valor": 438991776.0,
        "delta": 34741473.0
      },
      {
        "periodo": 202510,
        "valor": 462877256.0,
        "delta": 23885480.0
      },
      {
        "periodo": 202511,
        "valor": 484369654.0,
        "delta": 21492398.0
      },
      {
        "periodo": 202512,
        "valor": 506303116.0,
        "delta": 21933462.0
      },
      {
        "periodo": 202601,
        "valor": 505096178.0,
        "delta": -1206938.0
      },
      {
        "periodo": 202602,
        "valor": 502487353.0,
        "delta": -2608825.0
      },
      {
        "periodo": 202603,
        "valor": 521429369.0,
        "delta": 18942016.0
      },
      {
        "periodo": 202604,
        "valor": 522959164.0,
        "delta": 1529795.0
      },
      {
        "periodo": 202605,
        "valor": 523964100.0,
        "delta": 1004936.0
      },
      {
        "periodo": 202606,
        "valor": 534373423.0,
        "delta": 10409323.0
      },
      {
        "periodo": 202607,
        "valor": 525284342.0,
        "delta": -9089081.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 2987828425.88,
    "valor_anterior": 2885824491.4,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2353718158.32,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2384690012.66,
        "delta": 30971854.34
      },
      {
        "periodo": 202509,
        "valor": 2432274113.01,
        "delta": 47584100.35
      },
      {
        "periodo": 202510,
        "valor": 2379144231.7,
        "delta": -53129881.31
      },
      {
        "periodo": 202511,
        "valor": 2386062256.98,
        "delta": 6918025.28
      },
      {
        "periodo": 202512,
        "valor": 2412685051.03,
        "delta": 26622794.05
      },
      {
        "periodo": 202601,
        "valor": 2448030893.13,
        "delta": 35345842.1
      },
      {
        "periodo": 202602,
        "valor": 2558882394.28,
        "delta": 110851501.15
      },
      {
        "periodo": 202603,
        "valor": 2654081921.9,
        "delta": 95199527.62
      },
      {
        "periodo": 202604,
        "valor": 2730305902.3,
        "delta": 76223980.4
      },
      {
        "periodo": 202605,
        "valor": 2802828239.29,
        "delta": 72522336.99
      },
      {
        "periodo": 202606,
        "valor": 2885824491.4,
        "delta": 82996252.11
      },
      {
        "periodo": 202607,
        "valor": 2987828425.88,
        "delta": 102003934.48
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 11981106.0,
    "valor_anterior": 10394388.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11580522.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10144499.0,
        "delta": -1436023.0
      },
      {
        "periodo": 202509,
        "valor": 10757736.0,
        "delta": 613237.0
      },
      {
        "periodo": 202510,
        "valor": 10304359.0,
        "delta": -453377.0
      },
      {
        "periodo": 202511,
        "valor": 9331842.0,
        "delta": -972517.0
      },
      {
        "periodo": 202512,
        "valor": 9358927.0,
        "delta": 27085.0
      },
      {
        "periodo": 202601,
        "valor": 8839736.0,
        "delta": -519191.0
      },
      {
        "periodo": 202602,
        "valor": 8491257.0,
        "delta": -348479.0
      },
      {
        "periodo": 202603,
        "valor": 9836748.0,
        "delta": 1345491.0
      },
      {
        "periodo": 202604,
        "valor": 9119970.0,
        "delta": -716778.0
      },
      {
        "periodo": 202605,
        "valor": 9500193.0,
        "delta": 380223.0
      },
      {
        "periodo": 202606,
        "valor": 10394388.0,
        "delta": 894195.0
      },
      {
        "periodo": 202607,
        "valor": 11981106.0,
        "delta": 1586718.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 248627.5,
    "valor_anterior": 460793.28,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13728231.92,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9802579.58,
        "delta": -3925652.34
      },
      {
        "periodo": 202509,
        "valor": 6531860.53,
        "delta": -3270719.05
      },
      {
        "periodo": 202510,
        "valor": 4560909.86,
        "delta": -1970950.67
      },
      {
        "periodo": 202511,
        "valor": 3291148.9,
        "delta": -1269760.96
      },
      {
        "periodo": 202512,
        "valor": 2257117.92,
        "delta": -1034030.98
      },
      {
        "periodo": 202601,
        "valor": 1606383.8,
        "delta": -650734.12
      },
      {
        "periodo": 202602,
        "valor": 1280720.57,
        "delta": -325663.23
      },
      {
        "periodo": 202603,
        "valor": 966781.08,
        "delta": -313939.49
      },
      {
        "periodo": 202604,
        "valor": 674752.22,
        "delta": -292028.86
      },
      {
        "periodo": 202605,
        "valor": 564268.31,
        "delta": -110483.91
      },
      {
        "periodo": 202606,
        "valor": 460793.28,
        "delta": -103475.03
      },
      {
        "periodo": 202607,
        "valor": 248627.5,
        "delta": -212165.78
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 6128706913.34,
    "valor_anterior": 5997388291.56,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 5716484286.99,
        "delta": 5716484286.99
      },
      {
        "periodo": 202603,
        "valor": 5757444763.11,
        "delta": 40960476.12
      },
      {
        "periodo": 202604,
        "valor": 5796851220.41,
        "delta": 39406457.3
      },
      {
        "periodo": 202605,
        "valor": 5881329794.03,
        "delta": 84478573.62
      },
      {
        "periodo": 202606,
        "valor": 5997388291.56,
        "delta": 116058497.53
      },
      {
        "periodo": 202607,
        "valor": 6128706913.34,
        "delta": 131318621.78
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 445706967.0,
    "valor_anterior": 433487715.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 137804335.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 181248346.0,
        "delta": 43444011.0
      },
      {
        "periodo": 202509,
        "valor": 227567008.0,
        "delta": 46318662.0
      },
      {
        "periodo": 202510,
        "valor": 260255527.0,
        "delta": 32688519.0
      },
      {
        "periodo": 202511,
        "valor": 311067666.0,
        "delta": 50812139.0
      },
      {
        "periodo": 202512,
        "valor": 334835808.0,
        "delta": 23768142.0
      },
      {
        "periodo": 202601,
        "valor": 340819224.0,
        "delta": 5983416.0
      },
      {
        "periodo": 202602,
        "valor": 351691940.0,
        "delta": 10872716.0
      },
      {
        "periodo": 202603,
        "valor": 381301906.0,
        "delta": 29609966.0
      },
      {
        "periodo": 202604,
        "valor": 388553565.0,
        "delta": 7251659.0
      },
      {
        "periodo": 202605,
        "valor": 405485934.0,
        "delta": 16932369.0
      },
      {
        "periodo": 202606,
        "valor": 433487715.0,
        "delta": 28001781.0
      },
      {
        "periodo": 202607,
        "valor": 445706967.0,
        "delta": 12219252.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 254396321.89,
    "valor_anterior": 182250918.69,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 319703.23,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 3154015.5,
        "delta": 2834312.27
      },
      {
        "periodo": 202601,
        "valor": 8682968.15,
        "delta": 5528952.65
      },
      {
        "periodo": 202602,
        "valor": 22225148.95,
        "delta": 13542180.8
      },
      {
        "periodo": 202603,
        "valor": 47080414.01,
        "delta": 24855265.06
      },
      {
        "periodo": 202604,
        "valor": 84144906.26,
        "delta": 37064492.25
      },
      {
        "periodo": 202605,
        "valor": 129704308.54,
        "delta": 45559402.28
      },
      {
        "periodo": 202606,
        "valor": 182250918.69,
        "delta": 52546610.15
      },
      {
        "periodo": 202607,
        "valor": 254396321.89,
        "delta": 72145403.2
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 17455009838.0,
    "valor_anterior": 15949816833.999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 13375620425.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 14353155513.0,
        "delta": 977535088.0
      },
      {
        "periodo": 202605,
        "valor": 15406802938.0,
        "delta": 1053647425.0
      },
      {
        "periodo": 202606,
        "valor": 15949816834.0,
        "delta": 543013896.0
      },
      {
        "periodo": 202607,
        "valor": 17455009838.0,
        "delta": 1505193004.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 1996889259040.94,
    "valor_anterior": 1988624409972.13,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1800615748927.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1822653286646.87,
        "delta": 22037537719.4502
      },
      {
        "periodo": 202509,
        "valor": 1838281805741.58,
        "delta": 15628519094.71
      },
      {
        "periodo": 202510,
        "valor": 1860463588843.65,
        "delta": 22181783102.0698
      },
      {
        "periodo": 202511,
        "valor": 1916924992917.69,
        "delta": 56461404074.04
      },
      {
        "periodo": 202512,
        "valor": 1909520370778.92,
        "delta": -7404622138.77
      },
      {
        "periodo": 202601,
        "valor": 1913747283730.49,
        "delta": 4226912951.5701
      },
      {
        "periodo": 202602,
        "valor": 1915879820632.2,
        "delta": 2132536901.71
      },
      {
        "periodo": 202603,
        "valor": 1937867293116.23,
        "delta": 21987472484.03
      },
      {
        "periodo": 202604,
        "valor": 1954525403615.64,
        "delta": 16658110499.4099
      },
      {
        "periodo": 202605,
        "valor": 1966183211401.05,
        "delta": 11657807785.4102
      },
      {
        "periodo": 202606,
        "valor": 1988624409972.13,
        "delta": 22441198571.0798
      },
      {
        "periodo": 202607,
        "valor": 1996889259040.94,
        "delta": 8264849068.8101
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 1605899706476.63,
    "valor_anterior": 1603255439140.55,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1460770181004.67,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1478660084805.05,
        "delta": 17889903800.3801
      },
      {
        "periodo": 202509,
        "valor": 1492470984416.91,
        "delta": 13810899611.8599
      },
      {
        "periodo": 202510,
        "valor": 1509469119576.32,
        "delta": 16998135159.4102
      },
      {
        "periodo": 202511,
        "valor": 1558708125726.05,
        "delta": 49239006149.73
      },
      {
        "periodo": 202512,
        "valor": 1551082064043.59,
        "delta": -7626061682.46
      },
      {
        "periodo": 202601,
        "valor": 1557658167967.82,
        "delta": 6576103924.23
      },
      {
        "periodo": 202602,
        "valor": 1558607415250.9402,
        "delta": 949247283.1201
      },
      {
        "periodo": 202603,
        "valor": 1563482973609.17,
        "delta": 4875558358.2297
      },
      {
        "periodo": 202604,
        "valor": 1578525415886.28,
        "delta": 15042442277.1101
      },
      {
        "periodo": 202605,
        "valor": 1589522983595.35,
        "delta": 10997567709.0701
      },
      {
        "periodo": 202606,
        "valor": 1603255439140.55,
        "delta": 13732455545.2
      },
      {
        "periodo": 202607,
        "valor": 1605899706476.63,
        "delta": 2644267336.0798
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 6093108.0,
    "valor_anterior": 6093108.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9437089571.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1230865127.0,
        "delta": -8206224444.0
      },
      {
        "periodo": 202509,
        "valor": 57984211.0,
        "delta": -1172880916.0
      },
      {
        "periodo": 202510,
        "valor": 58784272.0,
        "delta": 800061.0
      },
      {
        "periodo": 202511,
        "valor": 59319002.0,
        "delta": 534730.0
      },
      {
        "periodo": 202512,
        "valor": 57233033.0,
        "delta": -2085969.0
      },
      {
        "periodo": 202601,
        "valor": 52516458.0,
        "delta": -4716575.0
      },
      {
        "periodo": 202602,
        "valor": 48650221.0,
        "delta": -3866237.0
      },
      {
        "periodo": 202603,
        "valor": 6093108.0,
        "delta": -42557113.0
      },
      {
        "periodo": 202604,
        "valor": 6093108.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 6093108.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 6093108.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 6093108.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 54157789167.0,
    "valor_anterior": 53699171013.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 45887107509.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 46404381554.0,
        "delta": 517274045.0
      },
      {
        "periodo": 202509,
        "valor": 47165869637.0,
        "delta": 761488083.0
      },
      {
        "periodo": 202510,
        "valor": 47649194467.0,
        "delta": 483324830.0
      },
      {
        "periodo": 202511,
        "valor": 49624350823.0,
        "delta": 1975156356.0
      },
      {
        "periodo": 202512,
        "valor": 49616813302.0,
        "delta": -7537521.0
      },
      {
        "periodo": 202601,
        "valor": 49750526446.0,
        "delta": 133713144.0
      },
      {
        "periodo": 202602,
        "valor": 49972681426.0,
        "delta": 222154980.0
      },
      {
        "periodo": 202603,
        "valor": 50818207452.0,
        "delta": 845526026.0
      },
      {
        "periodo": 202604,
        "valor": 51768083878.0,
        "delta": 949876426.0
      },
      {
        "periodo": 202605,
        "valor": 52641086438.0,
        "delta": 873002560.0
      },
      {
        "periodo": 202606,
        "valor": 53699171013.0,
        "delta": 1058084575.0
      },
      {
        "periodo": 202607,
        "valor": 54157789167.0,
        "delta": 458618154.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 26106580279.93,
    "valor_anterior": 25885057017.99,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27651972234.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28056352002.88,
        "delta": 404379768.23
      },
      {
        "periodo": 202509,
        "valor": 28426009822.61,
        "delta": 369657819.73
      },
      {
        "periodo": 202510,
        "valor": 29164753123.59,
        "delta": 738743300.98
      },
      {
        "periodo": 202511,
        "valor": 29628975829.2,
        "delta": 464222705.61
      },
      {
        "periodo": 202512,
        "valor": 29262669808.25,
        "delta": -366306020.95
      },
      {
        "periodo": 202601,
        "valor": 29575116531.9,
        "delta": 312446723.65
      },
      {
        "periodo": 202602,
        "valor": 23755832319.02,
        "delta": -5819284212.88
      },
      {
        "periodo": 202603,
        "valor": 24036840559.5,
        "delta": 281008240.48
      },
      {
        "periodo": 202604,
        "valor": 24357714710.25,
        "delta": 320874150.75
      },
      {
        "periodo": 202605,
        "valor": 24875469960.7,
        "delta": 517755250.45
      },
      {
        "periodo": 202606,
        "valor": 25885057017.99,
        "delta": 1009587057.29
      },
      {
        "periodo": 202607,
        "valor": 26106580279.93,
        "delta": 221523261.94
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 9326587727.88,
    "valor_anterior": 9102057794.4,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7924870474.22,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8046094980.65,
        "delta": 121224506.43
      },
      {
        "periodo": 202509,
        "valor": 8467762855.01,
        "delta": 421667874.36
      },
      {
        "periodo": 202510,
        "valor": 8464857701.7,
        "delta": -2905153.31
      },
      {
        "periodo": 202511,
        "valor": 8524001072.98,
        "delta": 59143371.28
      },
      {
        "periodo": 202512,
        "valor": 8656596579.03,
        "delta": 132595506.05
      },
      {
        "periodo": 202601,
        "valor": 8640102448.13,
        "delta": -16494130.9
      },
      {
        "periodo": 202602,
        "valor": 8733728891.28,
        "delta": 93626443.15
      },
      {
        "periodo": 202603,
        "valor": 8640628189.9,
        "delta": -93100701.38
      },
      {
        "periodo": 202604,
        "valor": 8802928841.3,
        "delta": 162300651.4
      },
      {
        "periodo": 202605,
        "valor": 8801040051.29,
        "delta": -1888790.01
      },
      {
        "periodo": 202606,
        "valor": 9102057794.4,
        "delta": 301017743.11
      },
      {
        "periodo": 202607,
        "valor": 9326587727.88,
        "delta": 224529933.48
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100206,
    "label": "Créditos de Consumo",
    "valor_actual": 301392502281.49994,
    "valor_anterior": 296676591898.19,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 248944528133.88,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 260255508177.29,
        "delta": 11310980043.41
      },
      {
        "periodo": 202509,
        "valor": 261693194799.05,
        "delta": 1437686621.76
      },
      {
        "periodo": 202510,
        "valor": 265656879703.04,
        "delta": 3963684903.99
      },
      {
        "periodo": 202511,
        "valor": 270380220464.46,
        "delta": 4723340761.42
      },
      {
        "periodo": 202512,
        "valor": 270844994013.05,
        "delta": 464773548.59
      },
      {
        "periodo": 202601,
        "valor": 268070853878.64,
        "delta": -2774140134.41
      },
      {
        "periodo": 202602,
        "valor": 274761512523.96,
        "delta": 6690658645.32
      },
      {
        "periodo": 202603,
        "valor": 290882550197.66,
        "delta": 16121037673.7
      },
      {
        "periodo": 202604,
        "valor": 291065167191.81,
        "delta": 182616994.15
      },
      {
        "periodo": 202605,
        "valor": 290336538247.71,
        "delta": -728628944.1
      },
      {
        "periodo": 202606,
        "valor": 296676591898.19,
        "delta": 6340053650.48
      },
      {
        "periodo": 202607,
        "valor": 301392502281.4999,
        "delta": 4715910383.3099
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 82927718334.11,
    "valor_anterior": 82127484970.26,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 78504946749.98,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 78640534555.28,
        "delta": 135587805.3
      },
      {
        "periodo": 202509,
        "valor": 79259696343.34,
        "delta": 619161788.06
      },
      {
        "periodo": 202510,
        "valor": 79551347911.25,
        "delta": 291651567.91
      },
      {
        "periodo": 202511,
        "valor": 80293342467.0,
        "delta": 741994555.75
      },
      {
        "periodo": 202512,
        "valor": 80371368516.03,
        "delta": 78026049.03
      },
      {
        "periodo": 202601,
        "valor": 80369763413.74,
        "delta": -1605102.29
      },
      {
        "periodo": 202602,
        "valor": 80379105210.42,
        "delta": 9341796.68
      },
      {
        "periodo": 202603,
        "valor": 81032062575.14,
        "delta": 652957364.72
      },
      {
        "periodo": 202604,
        "valor": 81259050523.62,
        "delta": 226987948.48
      },
      {
        "periodo": 202605,
        "valor": 81851094540.41,
        "delta": 592044016.79
      },
      {
        "periodo": 202606,
        "valor": 82127484970.26,
        "delta": 276390429.85
      },
      {
        "periodo": 202607,
        "valor": 82927718334.11,
        "delta": 800233363.85
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 412269122669.69,
    "valor_anterior": 410707829439.53,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 385363943430.32,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 388133058013.88,
        "delta": 2769114583.56
      },
      {
        "periodo": 202509,
        "valor": 390079393618.78,
        "delta": 1946335604.9
      },
      {
        "periodo": 202510,
        "valor": 393584977497.64,
        "delta": 3505583878.86
      },
      {
        "periodo": 202511,
        "valor": 397104333783.17,
        "delta": 3519356285.53
      },
      {
        "periodo": 202512,
        "valor": 399410028669.37,
        "delta": 2305694886.2
      },
      {
        "periodo": 202601,
        "valor": 400644281714.78,
        "delta": 1234253045.41
      },
      {
        "periodo": 202602,
        "valor": 402897139818.65,
        "delta": 2252858103.87
      },
      {
        "periodo": 202603,
        "valor": 405012366233.7,
        "delta": 2115226415.05
      },
      {
        "periodo": 202604,
        "valor": 406641170898.14,
        "delta": 1628804664.44
      },
      {
        "periodo": 202605,
        "valor": 409293755491.39,
        "delta": 2652584593.25
      },
      {
        "periodo": 202606,
        "valor": 410707829439.53,
        "delta": 1414073948.14
      },
      {
        "periodo": 202607,
        "valor": 412269122669.69,
        "delta": 1561293230.16
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 270823322713.0,
    "valor_anterior": 268571189720.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 249716793489.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 251265683964.0,
        "delta": 1548890475.0
      },
      {
        "periodo": 202509,
        "valor": 253166811512.0,
        "delta": 1901127548.0
      },
      {
        "periodo": 202510,
        "valor": 255286977758.0,
        "delta": 2120166246.0
      },
      {
        "periodo": 202511,
        "valor": 256171635218.0,
        "delta": 884657460.0
      },
      {
        "periodo": 202512,
        "valor": 258439780992.0,
        "delta": 2268145774.0
      },
      {
        "periodo": 202601,
        "valor": 258986877754.0,
        "delta": 547096762.0
      },
      {
        "periodo": 202602,
        "valor": 260002517198.0,
        "delta": 1015639444.0
      },
      {
        "periodo": 202603,
        "valor": 262460871788.0,
        "delta": 2458354590.0
      },
      {
        "periodo": 202604,
        "valor": 264053396507.0,
        "delta": 1592524719.0
      },
      {
        "periodo": 202605,
        "valor": 266394830261.0,
        "delta": 2341433754.0
      },
      {
        "periodo": 202606,
        "valor": 268571189720.0,
        "delta": 2176359459.0
      },
      {
        "periodo": 202607,
        "valor": 270823322713.0,
        "delta": 2252132993.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 145435514845.0,
    "valor_anterior": 145705823335.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 151076723374.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 150607998836.0,
        "delta": -468724538.0
      },
      {
        "periodo": 202509,
        "valor": 150072562832.0,
        "delta": -535436004.0
      },
      {
        "periodo": 202510,
        "valor": 149409641271.0,
        "delta": -662921561.0
      },
      {
        "periodo": 202511,
        "valor": 149049753710.0,
        "delta": -359887561.0
      },
      {
        "periodo": 202512,
        "valor": 148670719887.0,
        "delta": -379033823.0
      },
      {
        "periodo": 202601,
        "valor": 147964478615.0,
        "delta": -706241272.0
      },
      {
        "periodo": 202602,
        "valor": 147371204079.0,
        "delta": -593274536.0
      },
      {
        "periodo": 202603,
        "valor": 147021618724.0,
        "delta": -349585355.0
      },
      {
        "periodo": 202604,
        "valor": 146614047348.0,
        "delta": -407571376.0
      },
      {
        "periodo": 202605,
        "valor": 146174843444.0,
        "delta": -439203904.0
      },
      {
        "periodo": 202606,
        "valor": 145705823335.0,
        "delta": -469020109.0
      },
      {
        "periodo": 202607,
        "valor": 145435514845.0,
        "delta": -270308490.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 3176486761.98,
    "valor_anterior": 3211156291.03,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3667416553.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3652963001.8,
        "delta": -14453551.35
      },
      {
        "periodo": 202509,
        "valor": 3553657397.44,
        "delta": -99305604.36
      },
      {
        "periodo": 202510,
        "valor": 3510276353.62,
        "delta": -43381043.82
      },
      {
        "periodo": 202511,
        "valor": 3509981834.09,
        "delta": -294519.53
      },
      {
        "periodo": 202512,
        "valor": 3436523659.18,
        "delta": -73458174.91
      },
      {
        "periodo": 202601,
        "valor": 3410334654.91,
        "delta": -26189004.27
      },
      {
        "periodo": 202602,
        "valor": 3391065025.8,
        "delta": -19269629.11
      },
      {
        "periodo": 202603,
        "valor": 3314226715.97,
        "delta": -76838309.83
      },
      {
        "periodo": 202604,
        "valor": 3310538994.37,
        "delta": -3687721.6
      },
      {
        "periodo": 202605,
        "valor": 3265519460.27,
        "delta": -45019534.1
      },
      {
        "periodo": 202606,
        "valor": 3211156291.03,
        "delta": -54363169.24
      },
      {
        "periodo": 202607,
        "valor": 3176486761.98,
        "delta": -34669529.05
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 3996848414.0,
    "valor_anterior": 4019696818.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4437532553.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4417311513.0,
        "delta": -20221040.0
      },
      {
        "periodo": 202509,
        "valor": 4373950257.0,
        "delta": -43361256.0
      },
      {
        "periodo": 202510,
        "valor": 4349714375.0,
        "delta": -24235882.0
      },
      {
        "periodo": 202511,
        "valor": 4355264330.0,
        "delta": 5549955.0
      },
      {
        "periodo": 202512,
        "valor": 4295341650.0,
        "delta": -59922680.0
      },
      {
        "periodo": 202601,
        "valor": 4235421084.0,
        "delta": -59920566.0
      },
      {
        "periodo": 202602,
        "valor": 4176507715.0,
        "delta": -58913369.0
      },
      {
        "periodo": 202603,
        "valor": 4116203812.0,
        "delta": -60303903.0
      },
      {
        "periodo": 202604,
        "valor": 4082072037.0,
        "delta": -34131775.0
      },
      {
        "periodo": 202605,
        "valor": 4034842364.0,
        "delta": -47229673.0
      },
      {
        "periodo": 202606,
        "valor": 4019696818.0,
        "delta": -15145546.0
      },
      {
        "periodo": 202607,
        "valor": 3996848414.0,
        "delta": -22848404.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 16091389205.0,
    "valor_anterior": 16036797929.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17415881772.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17139723932.0,
        "delta": -276157840.0
      },
      {
        "periodo": 202509,
        "valor": 17102597420.0,
        "delta": -37126512.0
      },
      {
        "periodo": 202510,
        "valor": 16864695242.0,
        "delta": -237902178.0
      },
      {
        "periodo": 202511,
        "valor": 16919348866.0,
        "delta": 54653624.0
      },
      {
        "periodo": 202512,
        "valor": 16505522397.0,
        "delta": -413826469.0
      },
      {
        "periodo": 202601,
        "valor": 16530219746.0,
        "delta": 24697349.0
      },
      {
        "periodo": 202602,
        "valor": 16365034590.0,
        "delta": -165185156.0
      },
      {
        "periodo": 202603,
        "valor": 16501872766.0,
        "delta": 136838176.0
      },
      {
        "periodo": 202604,
        "valor": 16344868367.0,
        "delta": -157004399.0
      },
      {
        "periodo": 202605,
        "valor": 16321054114.0,
        "delta": -23814253.0
      },
      {
        "periodo": 202606,
        "valor": 16036797929.0,
        "delta": -284256185.0
      },
      {
        "periodo": 202607,
        "valor": 16091389205.0,
        "delta": 54591276.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 262033752502.0,
    "valor_anterior": 261044443420.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 249043879446.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 249977988726.0,
        "delta": 934109280.0
      },
      {
        "periodo": 202509,
        "valor": 251281459099.0,
        "delta": 1303470373.0
      },
      {
        "periodo": 202510,
        "valor": 252669266285.0,
        "delta": 1387807186.0
      },
      {
        "periodo": 202511,
        "valor": 254115422439.0,
        "delta": 1446156154.0
      },
      {
        "periodo": 202512,
        "valor": 255262365506.0,
        "delta": 1146943067.0
      },
      {
        "periodo": 202601,
        "valor": 255560662704.0,
        "delta": 298297198.0
      },
      {
        "periodo": 202602,
        "valor": 255737117362.0,
        "delta": 176454658.0
      },
      {
        "periodo": 202603,
        "valor": 256813431301.0,
        "delta": 1076313939.0
      },
      {
        "periodo": 202604,
        "valor": 257853531382.0,
        "delta": 1040100081.0
      },
      {
        "periodo": 202605,
        "valor": 259880139176.0,
        "delta": 2026607794.0
      },
      {
        "periodo": 202606,
        "valor": 261044443420.0,
        "delta": 1164304244.0
      },
      {
        "periodo": 202607,
        "valor": 262033752502.0,
        "delta": 989309082.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 18660016559.69,
    "valor_anterior": 18438274952.38,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17102787432.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17230552382.14,
        "delta": 127764949.72
      },
      {
        "periodo": 202509,
        "valor": 17310663983.68,
        "delta": 80111601.54
      },
      {
        "periodo": 202510,
        "valor": 17310474808.14,
        "delta": -189175.54
      },
      {
        "periodo": 202511,
        "valor": 17405929199.07,
        "delta": 95454390.93
      },
      {
        "periodo": 202512,
        "valor": 17551983113.5,
        "delta": 146053914.43
      },
      {
        "periodo": 202601,
        "valor": 17622313454.83,
        "delta": 70330341.33
      },
      {
        "periodo": 202602,
        "valor": 17775197753.57,
        "delta": 152884298.74
      },
      {
        "periodo": 202603,
        "valor": 17982346674.39,
        "delta": 207148920.82
      },
      {
        "periodo": 202604,
        "valor": 18055386512.62,
        "delta": 73039838.23
      },
      {
        "periodo": 202605,
        "valor": 18191507586.94,
        "delta": 136121074.32
      },
      {
        "periodo": 202606,
        "valor": 18438274952.38,
        "delta": 246767365.44
      },
      {
        "periodo": 202607,
        "valor": 18660016559.69,
        "delta": 221741607.31
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 46639369.0,
    "valor_anterior": 40095222.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 53395930.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55146837.0,
        "delta": 1750907.0
      },
      {
        "periodo": 202509,
        "valor": 54175026.0,
        "delta": -971811.0
      },
      {
        "periodo": 202510,
        "valor": 53721254.0,
        "delta": -453772.0
      },
      {
        "periodo": 202511,
        "valor": 52751255.0,
        "delta": -969999.0
      },
      {
        "periodo": 202512,
        "valor": 51788436.0,
        "delta": -962819.0
      },
      {
        "periodo": 202601,
        "valor": 41376754.0,
        "delta": -10411682.0
      },
      {
        "periodo": 202602,
        "valor": 41004163.0,
        "delta": -372591.0
      },
      {
        "periodo": 202603,
        "valor": 37330659.0,
        "delta": -3673504.0
      },
      {
        "periodo": 202604,
        "valor": 37009578.0,
        "delta": -321081.0
      },
      {
        "periodo": 202605,
        "valor": 37030777.0,
        "delta": 21199.0
      },
      {
        "periodo": 202606,
        "valor": 40095222.0,
        "delta": 3064445.0
      },
      {
        "periodo": 202607,
        "valor": 46639369.0,
        "delta": 6544147.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 14428452.0,
    "valor_anterior": 14719107.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15533492.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15109478.0,
        "delta": -424014.0
      },
      {
        "periodo": 202509,
        "valor": 12827850.0,
        "delta": -2281628.0
      },
      {
        "periodo": 202510,
        "valor": 12573793.0,
        "delta": -254057.0
      },
      {
        "periodo": 202511,
        "valor": 11851093.0,
        "delta": -722700.0
      },
      {
        "periodo": 202512,
        "valor": 11554813.0,
        "delta": -296280.0
      },
      {
        "periodo": 202601,
        "valor": 11421450.0,
        "delta": -133363.0
      },
      {
        "periodo": 202602,
        "valor": 11320861.0,
        "delta": -100589.0
      },
      {
        "periodo": 202603,
        "valor": 11019722.0,
        "delta": -301139.0
      },
      {
        "periodo": 202604,
        "valor": 10918570.0,
        "delta": -101152.0
      },
      {
        "periodo": 202605,
        "valor": 10805653.0,
        "delta": -112917.0
      },
      {
        "periodo": 202606,
        "valor": 14719107.0,
        "delta": 3913454.0
      },
      {
        "periodo": 202607,
        "valor": 14428452.0,
        "delta": -290655.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 15012563805.0,
    "valor_anterior": 14941695593.999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14207145719.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14309785675.0,
        "delta": 102639956.0
      },
      {
        "periodo": 202509,
        "valor": 14419828471.0,
        "delta": 110042796.0
      },
      {
        "periodo": 202510,
        "valor": 14473888603.0,
        "delta": 54060132.0
      },
      {
        "periodo": 202511,
        "valor": 14612107410.0,
        "delta": 138218807.0
      },
      {
        "periodo": 202512,
        "valor": 14524021840.0,
        "delta": -88085570.0
      },
      {
        "periodo": 202601,
        "valor": 14557619715.0,
        "delta": 33597875.0
      },
      {
        "periodo": 202602,
        "valor": 14599868821.0,
        "delta": 42249106.0
      },
      {
        "periodo": 202603,
        "valor": 14695876020.0,
        "delta": 96007199.0
      },
      {
        "periodo": 202604,
        "valor": 14811237359.0,
        "delta": 115361339.0
      },
      {
        "periodo": 202605,
        "valor": 14877599803.0,
        "delta": 66362444.0
      },
      {
        "periodo": 202606,
        "valor": 14941695594.0,
        "delta": 64095791.0
      },
      {
        "periodo": 202607,
        "valor": 15012563805.0,
        "delta": 70868211.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 303856377541.35,
    "valor_anterior": 301759352563.54,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 287144100504.49,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 288864834584.89,
        "delta": 1720734080.4
      },
      {
        "periodo": 202509,
        "valor": 290406127473.31,
        "delta": 1541292888.42
      },
      {
        "periodo": 202510,
        "valor": 292281073901.64,
        "delta": 1874946428.33
      },
      {
        "periodo": 202511,
        "valor": 294021703619.54,
        "delta": 1740629717.9
      },
      {
        "periodo": 202512,
        "valor": 295418017888.93,
        "delta": 1396314269.39
      },
      {
        "periodo": 202601,
        "valor": 295369047139.68,
        "delta": -48970749.25
      },
      {
        "periodo": 202602,
        "valor": 296152886182.37,
        "delta": 783839042.69
      },
      {
        "periodo": 202603,
        "valor": 297909998865.49,
        "delta": 1757112683.12
      },
      {
        "periodo": 202604,
        "valor": 298880449376.5,
        "delta": 970450511.01
      },
      {
        "periodo": 202605,
        "valor": 300223115282.8,
        "delta": 1342665906.3
      },
      {
        "periodo": 202606,
        "valor": 301759352563.54,
        "delta": 1536237280.74
      },
      {
        "periodo": 202607,
        "valor": 303856377541.35,
        "delta": 2097024977.81
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 10253490937.0,
    "valor_anterior": 10205475520.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10655116626.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10554597920.0,
        "delta": -100518706.0
      },
      {
        "periodo": 202509,
        "valor": 10585917448.0,
        "delta": 31319528.0
      },
      {
        "periodo": 202510,
        "valor": 10459056952.0,
        "delta": -126860496.0
      },
      {
        "periodo": 202511,
        "valor": 10459422906.0,
        "delta": 365954.0
      },
      {
        "periodo": 202512,
        "valor": 10509326557.0,
        "delta": 49903651.0
      },
      {
        "periodo": 202601,
        "valor": 10572366681.0,
        "delta": 63040124.0
      },
      {
        "periodo": 202602,
        "valor": 10480700814.0,
        "delta": -91665867.0
      },
      {
        "periodo": 202603,
        "valor": 10389581844.0,
        "delta": -91118970.0
      },
      {
        "periodo": 202604,
        "valor": 10334619066.0,
        "delta": -54962778.0
      },
      {
        "periodo": 202605,
        "valor": 10321256292.0,
        "delta": -13362774.0
      },
      {
        "periodo": 202606,
        "valor": 10205475520.0,
        "delta": -115780772.0
      },
      {
        "periodo": 202607,
        "valor": 10253490937.0,
        "delta": 48015417.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 723062118.63,
    "valor_anterior": 703631403.95,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 608679147.56,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 613346036.5,
        "delta": 4666888.94
      },
      {
        "periodo": 202509,
        "valor": 605485001.53,
        "delta": -7861034.97
      },
      {
        "periodo": 202510,
        "valor": 608178283.61,
        "delta": 2693282.08
      },
      {
        "periodo": 202511,
        "valor": 598635513.36,
        "delta": -9542770.25
      },
      {
        "periodo": 202512,
        "valor": 588172117.31,
        "delta": -10463396.05
      },
      {
        "periodo": 202601,
        "valor": 592706665.77,
        "delta": 4534548.46
      },
      {
        "periodo": 202602,
        "valor": 585274363.99,
        "delta": -7432301.78
      },
      {
        "periodo": 202603,
        "valor": 595236708.83,
        "delta": 9962344.84
      },
      {
        "periodo": 202604,
        "valor": 680521460.52,
        "delta": 85284751.69
      },
      {
        "periodo": 202605,
        "valor": 678589785.53,
        "delta": -1931674.99
      },
      {
        "periodo": 202606,
        "valor": 703631403.95,
        "delta": 25041618.42
      },
      {
        "periodo": 202607,
        "valor": 723062118.63,
        "delta": 19430714.68
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 164139842.0,
    "valor_anterior": 151919790.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 113153537.64,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 126389298.83,
        "delta": 13235761.19
      },
      {
        "periodo": 202509,
        "valor": 156017434.0,
        "delta": 29628135.17
      },
      {
        "periodo": 202510,
        "valor": 155805264.0,
        "delta": -212170.0
      },
      {
        "periodo": 202511,
        "valor": 149409745.0,
        "delta": -6395519.0
      },
      {
        "periodo": 202512,
        "valor": 147786590.0,
        "delta": -1623155.0
      },
      {
        "periodo": 202601,
        "valor": 145114206.0,
        "delta": -2672384.0
      },
      {
        "periodo": 202602,
        "valor": 144889012.0,
        "delta": -225194.0
      },
      {
        "periodo": 202603,
        "valor": 144393490.0,
        "delta": -495522.0
      },
      {
        "periodo": 202604,
        "valor": 144008681.0,
        "delta": -384809.0
      },
      {
        "periodo": 202605,
        "valor": 155766408.0,
        "delta": 11757727.0
      },
      {
        "periodo": 202606,
        "valor": 151919790.0,
        "delta": -3846618.0
      },
      {
        "periodo": 202607,
        "valor": 164139842.0,
        "delta": 12220052.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 446484598.0,
    "valor_anterior": 449459508.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 435791497.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 432468325.0,
        "delta": -3323172.0
      },
      {
        "periodo": 202509,
        "valor": 431940017.0,
        "delta": -528308.0
      },
      {
        "periodo": 202510,
        "valor": 448673843.0,
        "delta": 16733826.0
      },
      {
        "periodo": 202511,
        "valor": 446627868.0,
        "delta": -2045975.0
      },
      {
        "periodo": 202512,
        "valor": 443062583.0,
        "delta": -3565285.0
      },
      {
        "periodo": 202601,
        "valor": 440119298.0,
        "delta": -2943285.0
      },
      {
        "periodo": 202602,
        "valor": 439225339.0,
        "delta": -893959.0
      },
      {
        "periodo": 202603,
        "valor": 439611563.0,
        "delta": 386224.0
      },
      {
        "periodo": 202604,
        "valor": 457419968.0,
        "delta": 17808405.0
      },
      {
        "periodo": 202605,
        "valor": 458289904.0,
        "delta": 869936.0
      },
      {
        "periodo": 202606,
        "valor": 449459508.0,
        "delta": -8830396.0
      },
      {
        "periodo": 202607,
        "valor": 446484598.0,
        "delta": -2974910.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 4896915596.24,
    "valor_anterior": 4853251165.65,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4511409871.31,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4480440981.27,
        "delta": -30968890.04
      },
      {
        "periodo": 202509,
        "valor": 4561639482.53,
        "delta": 81198501.26
      },
      {
        "periodo": 202510,
        "valor": 4558348697.42,
        "delta": -3290785.11
      },
      {
        "periodo": 202511,
        "valor": 4621241496.38,
        "delta": 62892798.96
      },
      {
        "periodo": 202512,
        "valor": 4901087866.31,
        "delta": 279846369.93
      },
      {
        "periodo": 202601,
        "valor": 4918132225.92,
        "delta": 17044359.61
      },
      {
        "periodo": 202602,
        "valor": 4867812694.62,
        "delta": -50319531.3
      },
      {
        "periodo": 202603,
        "valor": 4933161645.64,
        "delta": 65348951.02
      },
      {
        "periodo": 202604,
        "valor": 4891221149.34,
        "delta": -41940496.3
      },
      {
        "periodo": 202605,
        "valor": 4917324296.84,
        "delta": 26103147.5
      },
      {
        "periodo": 202606,
        "valor": 4853251165.65,
        "delta": -64073131.19
      },
      {
        "periodo": 202607,
        "valor": 4896915596.24,
        "delta": 43664430.59
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 17004104.0,
    "valor_anterior": 17081531.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17799801.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17774698.0,
        "delta": -25103.0
      },
      {
        "periodo": 202509,
        "valor": 17680898.0,
        "delta": -93800.0
      },
      {
        "periodo": 202510,
        "valor": 17618267.0,
        "delta": -62631.0
      },
      {
        "periodo": 202511,
        "valor": 17583651.0,
        "delta": -34616.0
      },
      {
        "periodo": 202512,
        "valor": 17471085.0,
        "delta": -112566.0
      },
      {
        "periodo": 202601,
        "valor": 17439870.0,
        "delta": -31215.0
      },
      {
        "periodo": 202602,
        "valor": 17367172.0,
        "delta": -72698.0
      },
      {
        "periodo": 202603,
        "valor": 17249474.0,
        "delta": -117698.0
      },
      {
        "periodo": 202604,
        "valor": 17190195.0,
        "delta": -59279.0
      },
      {
        "periodo": 202605,
        "valor": 17183867.0,
        "delta": -6328.0
      },
      {
        "periodo": 202606,
        "valor": 17081531.0,
        "delta": -102336.0
      },
      {
        "periodo": 202607,
        "valor": 17004104.0,
        "delta": -77427.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 710717819.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 676486001.0,
        "delta": -34231818.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 174829515.68,
    "valor_anterior": 177752013.72,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 221405361.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 213432953.03,
        "delta": -7972408.12
      },
      {
        "periodo": 202509,
        "valor": 210042145.8,
        "delta": -3390807.23
      },
      {
        "periodo": 202510,
        "valor": 206584978.59,
        "delta": -3457167.21
      },
      {
        "periodo": 202511,
        "valor": 200840376.21,
        "delta": -5744602.38
      },
      {
        "periodo": 202512,
        "valor": 195892079.85,
        "delta": -4948296.36
      },
      {
        "periodo": 202601,
        "valor": 192437861.51,
        "delta": -3454218.34
      },
      {
        "periodo": 202602,
        "valor": 189553061.31,
        "delta": -2884800.2
      },
      {
        "periodo": 202603,
        "valor": 186407121.67,
        "delta": -3145939.64
      },
      {
        "periodo": 202604,
        "valor": 183817661.36,
        "delta": -2589460.31
      },
      {
        "periodo": 202605,
        "valor": 180549995.04,
        "delta": -3267666.32
      },
      {
        "periodo": 202606,
        "valor": 177752013.72,
        "delta": -2797981.32
      },
      {
        "periodo": 202607,
        "valor": 174829515.68,
        "delta": -2922498.04
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 47888513.0,
    "valor_anterior": 46350174.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 45960187.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 39062637.0,
        "delta": -6897550.0
      },
      {
        "periodo": 202509,
        "valor": 40432741.0,
        "delta": 1370104.0
      },
      {
        "periodo": 202510,
        "valor": 42138562.0,
        "delta": 1705821.0
      },
      {
        "periodo": 202511,
        "valor": 39441454.0,
        "delta": -2697108.0
      },
      {
        "periodo": 202512,
        "valor": 39337628.0,
        "delta": -103826.0
      },
      {
        "periodo": 202601,
        "valor": 39026020.0,
        "delta": -311608.0
      },
      {
        "periodo": 202602,
        "valor": 38332282.0,
        "delta": -693738.0
      },
      {
        "periodo": 202603,
        "valor": 46627421.0,
        "delta": 8295139.0
      },
      {
        "periodo": 202604,
        "valor": 49813013.0,
        "delta": 3185592.0
      },
      {
        "periodo": 202605,
        "valor": 49516065.0,
        "delta": -296948.0
      },
      {
        "periodo": 202606,
        "valor": 46350174.0,
        "delta": -3165891.0
      },
      {
        "periodo": 202607,
        "valor": 47888513.0,
        "delta": 1538339.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 1551067996396.37,
    "valor_anterior": 1543223480468.06,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1475070114293.02,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1481464690349.62,
        "delta": 6394576056.6001
      },
      {
        "periodo": 202509,
        "valor": 1487702906451.41,
        "delta": 6238216101.7898
      },
      {
        "periodo": 202510,
        "valor": 1495855033900.91,
        "delta": 8152127449.5
      },
      {
        "periodo": 202511,
        "valor": 1504156628233.82,
        "delta": 8301594332.9102
      },
      {
        "periodo": 202512,
        "valor": 1510791153874.48,
        "delta": 6634525640.6599
      },
      {
        "periodo": 202601,
        "valor": 1512221161028.14,
        "delta": 1430007153.6599
      },
      {
        "periodo": 202602,
        "valor": 1515663123518.73,
        "delta": 3441962490.5901
      },
      {
        "periodo": 202603,
        "valor": 1523661495124.83,
        "delta": 7998371606.1001
      },
      {
        "periodo": 202604,
        "valor": 1528712288647.47,
        "delta": 5050793522.6399
      },
      {
        "periodo": 202605,
        "valor": 1537334614567.22,
        "delta": 8622325919.75
      },
      {
        "periodo": 202606,
        "valor": 1543223480468.06,
        "delta": 5888865900.8401
      },
      {
        "periodo": 202607,
        "valor": 1551067996396.37,
        "delta": 7844515928.3101
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 1481342657019.15,
    "valor_anterior": 1473935820266.33,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1405287919546.79,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1411907410193.05,
        "delta": 6619490646.26
      },
      {
        "periodo": 202509,
        "valor": 1418640001135.43,
        "delta": 6732590942.3799
      },
      {
        "periodo": 202510,
        "valor": 1427132998999.53,
        "delta": 8492997864.1001
      },
      {
        "periodo": 202511,
        "valor": 1435111455566.71,
        "delta": 7978456567.1799
      },
      {
        "periodo": 202512,
        "valor": 1441867623109.3303,
        "delta": 6756167542.6204
      },
      {
        "periodo": 202601,
        "valor": 1443130532425.2,
        "delta": 1262909315.8696
      },
      {
        "periodo": 202602,
        "valor": 1446716477565.44,
        "delta": 3585945140.24
      },
      {
        "periodo": 202603,
        "valor": 1454366553299.33,
        "delta": 7650075733.8901
      },
      {
        "periodo": 202604,
        "valor": 1459383718072.26,
        "delta": 5017164772.9299
      },
      {
        "periodo": 202605,
        "valor": 1467852620559.6,
        "delta": 8468902487.3401
      },
      {
        "periodo": 202606,
        "valor": 1473935820266.33,
        "delta": 6083199706.73
      },
      {
        "periodo": 202607,
        "valor": 1481342657019.15,
        "delta": 7406836752.8198
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 710717819.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 676486001.0,
        "delta": -34231818.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -676486001.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 15059203174.000002,
    "valor_anterior": 14981790816.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14260541649.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14364932512.0,
        "delta": 104390863.0
      },
      {
        "periodo": 202509,
        "valor": 14474003497.0,
        "delta": 109070985.0
      },
      {
        "periodo": 202510,
        "valor": 14527609857.0,
        "delta": 53606360.0
      },
      {
        "periodo": 202511,
        "valor": 14664858665.0,
        "delta": 137248808.0
      },
      {
        "periodo": 202512,
        "valor": 14575810276.0,
        "delta": -89048389.0
      },
      {
        "periodo": 202601,
        "valor": 14598996469.0,
        "delta": 23186193.0
      },
      {
        "periodo": 202602,
        "valor": 14640872984.0,
        "delta": 41876515.0
      },
      {
        "periodo": 202603,
        "valor": 14733206679.0,
        "delta": 92333695.0
      },
      {
        "periodo": 202604,
        "valor": 14848246937.0,
        "delta": 115040258.0
      },
      {
        "periodo": 202605,
        "valor": 14914630580.0,
        "delta": 66383643.0
      },
      {
        "periodo": 202606,
        "valor": 14981790816.0,
        "delta": 67160236.0
      },
      {
        "periodo": 202607,
        "valor": 15059203174.0,
        "delta": 77412358.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 48675756574.67,
    "valor_anterior": 48387514374.41,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 49322954067.57,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 49049368197.94,
        "delta": -273585869.63
      },
      {
        "periodo": 202509,
        "valor": 49025209007.12,
        "delta": -24159190.82
      },
      {
        "periodo": 202510,
        "valor": 48635315760.76,
        "delta": -389893246.36
      },
      {
        "periodo": 202511,
        "valor": 48780752127.16,
        "delta": 145436366.4
      },
      {
        "periodo": 202512,
        "valor": 48485755937.68,
        "delta": -294996189.48
      },
      {
        "periodo": 202601,
        "valor": 48614379854.74,
        "delta": 128623917.06
      },
      {
        "periodo": 202602,
        "valor": 48489555804.37,
        "delta": -124824050.37
      },
      {
        "periodo": 202603,
        "valor": 48674266984.36,
        "delta": 184711179.99
      },
      {
        "periodo": 202604,
        "valor": 48552645920.99,
        "delta": -121621063.37
      },
      {
        "periodo": 202605,
        "valor": 48607143422.21,
        "delta": 54497501.22
      },
      {
        "periodo": 202606,
        "valor": 48387514374.41,
        "delta": -219629047.8
      },
      {
        "periodo": 202607,
        "valor": 48675756574.67,
        "delta": 288242200.26
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 370401913.68,
    "valor_anterior": 361472441.72,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 367892191.79,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 372706427.86,
        "delta": 4814236.07
      },
      {
        "periodo": 202509,
        "valor": 396568327.8,
        "delta": 23861899.94
      },
      {
        "periodo": 202510,
        "valor": 392582302.59,
        "delta": -3986025.21
      },
      {
        "periodo": 202511,
        "valor": 379684865.21,
        "delta": -12897437.38
      },
      {
        "periodo": 202512,
        "valor": 372704567.85,
        "delta": -6980297.36
      },
      {
        "periodo": 202601,
        "valor": 366413387.51,
        "delta": -6291180.34
      },
      {
        "periodo": 202602,
        "valor": 363130106.31,
        "delta": -3283281.2
      },
      {
        "periodo": 202603,
        "valor": 359069807.67,
        "delta": -4060298.64
      },
      {
        "periodo": 202604,
        "valor": 355935107.36,
        "delta": -3134700.31
      },
      {
        "periodo": 202605,
        "valor": 364305923.04,
        "delta": 8370815.68
      },
      {
        "periodo": 202606,
        "valor": 361472441.72,
        "delta": -2833481.32
      },
      {
        "periodo": 202607,
        "valor": 370401913.68,
        "delta": 8929471.96
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100217,
    "label": "Créditos Hipotecarios",
    "valor_actual": 5619977714.87,
    "valor_anterior": 5556882569.6,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5120089018.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5093787017.77,
        "delta": -26302001.1
      },
      {
        "periodo": 202509,
        "valor": 5167124484.06,
        "delta": 73337466.29
      },
      {
        "periodo": 202510,
        "valor": 5166526981.03,
        "delta": -597503.03
      },
      {
        "periodo": 202511,
        "valor": 5219877009.74,
        "delta": 53350028.71
      },
      {
        "periodo": 202512,
        "valor": 5489259983.62,
        "delta": 269382973.88
      },
      {
        "periodo": 202601,
        "valor": 5510838891.69,
        "delta": 21578908.07
      },
      {
        "periodo": 202602,
        "valor": 5453087058.61,
        "delta": -57751833.08
      },
      {
        "periodo": 202603,
        "valor": 5528398354.47,
        "delta": 75311295.86
      },
      {
        "periodo": 202604,
        "valor": 5571742609.86,
        "delta": 43344255.39
      },
      {
        "periodo": 202605,
        "valor": 5595914082.37,
        "delta": 24171472.51
      },
      {
        "periodo": 202606,
        "valor": 5556882569.6,
        "delta": -39031512.77
      },
      {
        "periodo": 202607,
        "valor": 5619977714.87,
        "delta": 63095145.27
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 17301518330.29,
    "valor_anterior": 17166474710.95,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13758931084.09,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13809374405.58,
        "delta": 50443321.49
      },
      {
        "periodo": 202509,
        "valor": 14092311710.05,
        "delta": 282937304.47
      },
      {
        "periodo": 202510,
        "valor": 14624238933.19,
        "delta": 531927223.14
      },
      {
        "periodo": 202511,
        "valor": 15039505106.84,
        "delta": 415266173.65
      },
      {
        "periodo": 202512,
        "valor": 15510434432.97,
        "delta": 470929326.13
      },
      {
        "periodo": 202601,
        "valor": 15959051520.36,
        "delta": 448617087.39
      },
      {
        "periodo": 202602,
        "valor": 16240965803.84,
        "delta": 281914283.48
      },
      {
        "periodo": 202603,
        "valor": 16095191678.6,
        "delta": -145774125.24
      },
      {
        "periodo": 202604,
        "valor": 16233212152.93,
        "delta": 138020474.33
      },
      {
        "periodo": 202605,
        "valor": 16861603970.96,
        "delta": 628391818.03
      },
      {
        "periodo": 202606,
        "valor": 17166474710.95,
        "delta": 304870739.99
      },
      {
        "periodo": 202607,
        "valor": 17301518330.29,
        "delta": 135043619.34
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 37153990723.51,
    "valor_anterior": 36411367767.6,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 32796919494.43,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 33059837850.66,
        "delta": 262918356.23
      },
      {
        "periodo": 202509,
        "valor": 34609793034.17,
        "delta": 1549955183.51
      },
      {
        "periodo": 202510,
        "valor": 35002612416.31,
        "delta": 392819382.14
      },
      {
        "periodo": 202511,
        "valor": 34831526300.66,
        "delta": -171086115.65
      },
      {
        "periodo": 202512,
        "valor": 34154949873.72,
        "delta": -676576426.94
      },
      {
        "periodo": 202601,
        "valor": 34551514553.04,
        "delta": 396564679.32
      },
      {
        "periodo": 202602,
        "valor": 33529104763.23,
        "delta": -1022409789.81
      },
      {
        "periodo": 202603,
        "valor": 33446588317.15,
        "delta": -82516446.08
      },
      {
        "periodo": 202604,
        "valor": 34817344583.98,
        "delta": 1370756266.83
      },
      {
        "periodo": 202605,
        "valor": 36281539385.5,
        "delta": 1464194801.52
      },
      {
        "periodo": 202606,
        "valor": 36411367767.6,
        "delta": 129828382.1
      },
      {
        "periodo": 202607,
        "valor": 37153990723.51,
        "delta": 742622955.91
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 23863154418.0,
    "valor_anterior": 23582700899.999996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21696819748.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21355034727.0,
        "delta": -341785021.0
      },
      {
        "periodo": 202509,
        "valor": 22065011289.0,
        "delta": 709976562.0
      },
      {
        "periodo": 202510,
        "valor": 22158613367.0,
        "delta": 93602078.0
      },
      {
        "periodo": 202511,
        "valor": 21161200158.0,
        "delta": -997413209.0
      },
      {
        "periodo": 202512,
        "valor": 20129685171.0,
        "delta": -1031514987.0
      },
      {
        "periodo": 202601,
        "valor": 20306127931.0,
        "delta": 176442760.0
      },
      {
        "periodo": 202602,
        "valor": 21467729907.0,
        "delta": 1161601976.0
      },
      {
        "periodo": 202603,
        "valor": 21645519047.0,
        "delta": 177789140.0
      },
      {
        "periodo": 202604,
        "valor": 21906838943.0,
        "delta": 261319896.0
      },
      {
        "periodo": 202605,
        "valor": 23196890804.0,
        "delta": 1290051861.0
      },
      {
        "periodo": 202606,
        "valor": 23582700900.0,
        "delta": 385810096.0
      },
      {
        "periodo": 202607,
        "valor": 23863154418.0,
        "delta": 280453518.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 14049107157.0,
    "valor_anterior": 14105895917.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13522540842.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14530491607.0,
        "delta": 1007950765.0
      },
      {
        "periodo": 202509,
        "valor": 14463762669.0,
        "delta": -66728938.0
      },
      {
        "periodo": 202510,
        "valor": 14451258033.0,
        "delta": -12504636.0
      },
      {
        "periodo": 202511,
        "valor": 14058677661.0,
        "delta": -392580372.0
      },
      {
        "periodo": 202512,
        "valor": 14579664971.0,
        "delta": 520987310.0
      },
      {
        "periodo": 202601,
        "valor": 14603847823.0,
        "delta": 24182852.0
      },
      {
        "periodo": 202602,
        "valor": 14420181271.0,
        "delta": -183666552.0
      },
      {
        "periodo": 202603,
        "valor": 14344126093.0,
        "delta": -76055178.0
      },
      {
        "periodo": 202604,
        "valor": 13885677886.0,
        "delta": -458448207.0
      },
      {
        "periodo": 202605,
        "valor": 14034563508.0,
        "delta": 148885622.0
      },
      {
        "periodo": 202606,
        "valor": 14105895917.0,
        "delta": 71332409.0
      },
      {
        "periodo": 202607,
        "valor": 14049107157.0,
        "delta": -56788760.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 5514549701.68,
    "valor_anterior": 5367498369.1,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4939387106.11,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4925823268.36,
        "delta": -13563837.75
      },
      {
        "periodo": 202509,
        "valor": 5293258491.12,
        "delta": 367435222.76
      },
      {
        "periodo": 202510,
        "valor": 5138445364.98,
        "delta": -154813126.14
      },
      {
        "periodo": 202511,
        "valor": 4889320989.17,
        "delta": -249124375.81
      },
      {
        "periodo": 202512,
        "valor": 4152848959.03,
        "delta": -736472030.14
      },
      {
        "periodo": 202601,
        "valor": 4165711187.32,
        "delta": 12862228.29
      },
      {
        "periodo": 202602,
        "valor": 4206030410.58,
        "delta": 40319223.26
      },
      {
        "periodo": 202603,
        "valor": 4429382256.28,
        "delta": 223351845.7
      },
      {
        "periodo": 202604,
        "valor": 5019305409.41,
        "delta": 589923153.13
      },
      {
        "periodo": 202605,
        "valor": 5129654410.62,
        "delta": 110349001.21
      },
      {
        "periodo": 202606,
        "valor": 5367498369.1,
        "delta": 237843958.48
      },
      {
        "periodo": 202607,
        "valor": 5514549701.68,
        "delta": 147051332.58
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 9860630628.0,
    "valor_anterior": 10103051664.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6829974080.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7028633534.0,
        "delta": 198659454.0
      },
      {
        "periodo": 202509,
        "valor": 6869542452.0,
        "delta": -159091082.0
      },
      {
        "periodo": 202510,
        "valor": 7050861114.0,
        "delta": 181318662.0
      },
      {
        "periodo": 202511,
        "valor": 6986976459.0,
        "delta": -63884655.0
      },
      {
        "periodo": 202512,
        "valor": 6867722246.0,
        "delta": -119254213.0
      },
      {
        "periodo": 202601,
        "valor": 6666099929.0,
        "delta": -201622317.0
      },
      {
        "periodo": 202602,
        "valor": 6578872531.0,
        "delta": -87227398.0
      },
      {
        "periodo": 202603,
        "valor": 6811039871.0,
        "delta": 232167340.0
      },
      {
        "periodo": 202604,
        "valor": 9158358794.0,
        "delta": 2347318923.0
      },
      {
        "periodo": 202605,
        "valor": 9716639964.0,
        "delta": 558281170.0
      },
      {
        "periodo": 202606,
        "valor": 10103051664.0,
        "delta": 386411700.0
      },
      {
        "periodo": 202607,
        "valor": 9860630628.0,
        "delta": -242421036.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 2859867497.0,
    "valor_anterior": 2810319026.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2210540899.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2405019996.0,
        "delta": 194479097.0
      },
      {
        "periodo": 202509,
        "valor": 2678768793.0,
        "delta": 273748797.0
      },
      {
        "periodo": 202510,
        "valor": 2648267705.0,
        "delta": -30501088.0
      },
      {
        "periodo": 202511,
        "valor": 2611342487.0,
        "delta": -36925218.0
      },
      {
        "periodo": 202512,
        "valor": 2131303880.0,
        "delta": -480038607.0
      },
      {
        "periodo": 202601,
        "valor": 2243923767.0,
        "delta": 112619887.0
      },
      {
        "periodo": 202602,
        "valor": 2290599418.0,
        "delta": 46675651.0
      },
      {
        "periodo": 202603,
        "valor": 2289660266.0,
        "delta": -939152.0
      },
      {
        "periodo": 202604,
        "valor": 2526485890.0,
        "delta": 236825624.0
      },
      {
        "periodo": 202605,
        "valor": 2841446457.0,
        "delta": 314960567.0
      },
      {
        "periodo": 202606,
        "valor": 2810319026.0,
        "delta": -31127431.0
      },
      {
        "periodo": 202607,
        "valor": 2859867497.0,
        "delta": 49548471.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 21516025605.0,
    "valor_anterior": 21562852117.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21392740948.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21512587943.0,
        "delta": 119846995.0
      },
      {
        "periodo": 202509,
        "valor": 21787262762.0,
        "delta": 274674819.0
      },
      {
        "periodo": 202510,
        "valor": 22016479459.0,
        "delta": 229216697.0
      },
      {
        "periodo": 202511,
        "valor": 22162125312.0,
        "delta": 145645853.0
      },
      {
        "periodo": 202512,
        "valor": 22250081181.0,
        "delta": 87955869.0
      },
      {
        "periodo": 202601,
        "valor": 22304849284.0,
        "delta": 54768103.0
      },
      {
        "periodo": 202602,
        "valor": 22172337929.0,
        "delta": -132511355.0
      },
      {
        "periodo": 202603,
        "valor": 22000793056.0,
        "delta": -171544873.0
      },
      {
        "periodo": 202604,
        "valor": 21814294058.0,
        "delta": -186498998.0
      },
      {
        "periodo": 202605,
        "valor": 21807933541.0,
        "delta": -6360517.0
      },
      {
        "periodo": 202606,
        "valor": 21562852117.0,
        "delta": -245081424.0
      },
      {
        "periodo": 202607,
        "valor": 21516025605.0,
        "delta": -46826512.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 2649266950.71,
    "valor_anterior": 2583928430.6,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2762233617.88,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2939128143.83,
        "delta": 176894525.95
      },
      {
        "periodo": 202509,
        "valor": 3042316713.23,
        "delta": 103188569.4
      },
      {
        "periodo": 202510,
        "valor": 3300153445.54,
        "delta": 257836732.31
      },
      {
        "periodo": 202511,
        "valor": 3357520166.44,
        "delta": 57366720.9
      },
      {
        "periodo": 202512,
        "valor": 2423587327.88,
        "delta": -933932838.56
      },
      {
        "periodo": 202601,
        "valor": 2225562357.24,
        "delta": -198024970.64
      },
      {
        "periodo": 202602,
        "valor": 2482035466.35,
        "delta": 256473109.11
      },
      {
        "periodo": 202603,
        "valor": 2394129082.49,
        "delta": -87906383.86
      },
      {
        "periodo": 202604,
        "valor": 2483718408.66,
        "delta": 89589326.17
      },
      {
        "periodo": 202605,
        "valor": 2482500486.79,
        "delta": -1217921.87
      },
      {
        "periodo": 202606,
        "valor": 2583928430.6,
        "delta": 101427943.81
      },
      {
        "periodo": 202607,
        "valor": 2649266950.71,
        "delta": 65338520.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 1574264058.0,
    "valor_anterior": 1557346316.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1071827448.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1162087445.0,
        "delta": 90259997.0
      },
      {
        "periodo": 202509,
        "valor": 1120013433.0,
        "delta": -42074012.0
      },
      {
        "periodo": 202510,
        "valor": 1204831444.0,
        "delta": 84818011.0
      },
      {
        "periodo": 202511,
        "valor": 1316653236.0,
        "delta": 111821792.0
      },
      {
        "periodo": 202512,
        "valor": 1375125557.0,
        "delta": 58472321.0
      },
      {
        "periodo": 202601,
        "valor": 1592983769.0,
        "delta": 217858212.0
      },
      {
        "periodo": 202602,
        "valor": 1650882390.0,
        "delta": 57898621.0
      },
      {
        "periodo": 202603,
        "valor": 1391381340.0,
        "delta": -259501050.0
      },
      {
        "periodo": 202604,
        "valor": 1434295066.0,
        "delta": 42913726.0
      },
      {
        "periodo": 202605,
        "valor": 1492488267.0,
        "delta": 58193201.0
      },
      {
        "periodo": 202606,
        "valor": 1557346316.0,
        "delta": 64858049.0
      },
      {
        "periodo": 202607,
        "valor": 1574264058.0,
        "delta": 16917742.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 1361901685.0,
    "valor_anterior": 1251673618.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1099312847.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1067490734.0,
        "delta": -31822113.0
      },
      {
        "periodo": 202509,
        "valor": 1087665122.0,
        "delta": 20174388.0
      },
      {
        "periodo": 202510,
        "valor": 1067279626.0,
        "delta": -20385496.0
      },
      {
        "periodo": 202511,
        "valor": 1066704458.0,
        "delta": -575168.0
      },
      {
        "periodo": 202512,
        "valor": 1064684728.0,
        "delta": -2019730.0
      },
      {
        "periodo": 202601,
        "valor": 1117213480.0,
        "delta": 52528752.0
      },
      {
        "periodo": 202602,
        "valor": 1119393913.0,
        "delta": 2180433.0
      },
      {
        "periodo": 202603,
        "valor": 1225311818.0,
        "delta": 105917905.0
      },
      {
        "periodo": 202604,
        "valor": 1309853212.0,
        "delta": 84541394.0
      },
      {
        "periodo": 202605,
        "valor": 1282557383.0,
        "delta": -27295829.0
      },
      {
        "periodo": 202606,
        "valor": 1251673618.0,
        "delta": -30883765.0
      },
      {
        "periodo": 202607,
        "valor": 1361901685.0,
        "delta": 110228067.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 1965769027.0,
    "valor_anterior": 1962305475.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2694926049.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2716162814.0,
        "delta": 21236765.0
      },
      {
        "periodo": 202509,
        "valor": 2731851181.0,
        "delta": 15688367.0
      },
      {
        "periodo": 202510,
        "valor": 2737562518.0,
        "delta": 5711337.0
      },
      {
        "periodo": 202511,
        "valor": 2764302409.0,
        "delta": 26739891.0
      },
      {
        "periodo": 202512,
        "valor": 1697378757.0,
        "delta": -1066923652.0
      },
      {
        "periodo": 202601,
        "valor": 1732739422.0,
        "delta": 35360665.0
      },
      {
        "periodo": 202602,
        "valor": 1755160600.0,
        "delta": 22421178.0
      },
      {
        "periodo": 202603,
        "valor": 1803229181.0,
        "delta": 48068581.0
      },
      {
        "periodo": 202604,
        "valor": 1801326608.0,
        "delta": -1902573.0
      },
      {
        "periodo": 202605,
        "valor": 1918597253.0,
        "delta": 117270645.0
      },
      {
        "periodo": 202606,
        "valor": 1962305475.0,
        "delta": 43708222.0
      },
      {
        "periodo": 202607,
        "valor": 1965769027.0,
        "delta": 3463552.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 19040908729.32,
    "valor_anterior": 19012880482.89,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12679704690.49,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12492747938.94,
        "delta": -186956751.55
      },
      {
        "periodo": 202509,
        "valor": 15964469737.18,
        "delta": 3471721798.24
      },
      {
        "periodo": 202510,
        "valor": 16439110565.77,
        "delta": 474640828.59
      },
      {
        "periodo": 202511,
        "valor": 17038693557.22,
        "delta": 599582991.45
      },
      {
        "periodo": 202512,
        "valor": 17353555731.48,
        "delta": 314862174.26
      },
      {
        "periodo": 202601,
        "valor": 17708278513.75,
        "delta": 354722782.27
      },
      {
        "periodo": 202602,
        "valor": 17651786259.36,
        "delta": -56492254.39
      },
      {
        "periodo": 202603,
        "valor": 17571738215.33,
        "delta": -80048044.03
      },
      {
        "periodo": 202604,
        "valor": 17931989636.48,
        "delta": 360251421.15
      },
      {
        "periodo": 202605,
        "valor": 18676172735.89,
        "delta": 744183099.41
      },
      {
        "periodo": 202606,
        "valor": 19012880482.89,
        "delta": 336707747.0
      },
      {
        "periodo": 202607,
        "valor": 19040908729.32,
        "delta": 28028246.43
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 587358693.74,
    "valor_anterior": 588658070.69,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 826209710.51,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 813879243.85,
        "delta": -12330466.66
      },
      {
        "periodo": 202509,
        "valor": 802231373.87,
        "delta": -11647869.98
      },
      {
        "periodo": 202510,
        "valor": 725070635.94,
        "delta": -77160737.93
      },
      {
        "periodo": 202511,
        "valor": 661533357.39,
        "delta": -63537278.55
      },
      {
        "periodo": 202512,
        "valor": 425947572.69,
        "delta": -235585784.7
      },
      {
        "periodo": 202601,
        "valor": 411781947.17,
        "delta": -14165625.52
      },
      {
        "periodo": 202602,
        "valor": 440467277.55,
        "delta": 28685330.38
      },
      {
        "periodo": 202603,
        "valor": 457525289.48,
        "delta": 17058011.93
      },
      {
        "periodo": 202604,
        "valor": 554651932.03,
        "delta": 97126642.55
      },
      {
        "periodo": 202605,
        "valor": 593469972.67,
        "delta": 38818040.64
      },
      {
        "periodo": 202606,
        "valor": 588658070.69,
        "delta": -4811901.98
      },
      {
        "periodo": 202607,
        "valor": 587358693.74,
        "delta": -1299376.95
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 1558927628.0,
    "valor_anterior": 1572503677.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1724873992.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1732272261.0,
        "delta": 7398269.0
      },
      {
        "periodo": 202509,
        "valor": 1710757509.0,
        "delta": -21514752.0
      },
      {
        "periodo": 202510,
        "valor": 1666465987.0,
        "delta": -44291522.0
      },
      {
        "periodo": 202511,
        "valor": 2021622474.0,
        "delta": 355156487.0
      },
      {
        "periodo": 202512,
        "valor": 2169851653.0,
        "delta": 148229179.0
      },
      {
        "periodo": 202601,
        "valor": 2222740290.0,
        "delta": 52888637.0
      },
      {
        "periodo": 202602,
        "valor": 1969683888.0,
        "delta": -253056402.0
      },
      {
        "periodo": 202603,
        "valor": 2086515130.0,
        "delta": 116831242.0
      },
      {
        "periodo": 202604,
        "valor": 2004291883.0,
        "delta": -82223247.0
      },
      {
        "periodo": 202605,
        "valor": 1989850500.0,
        "delta": -14441383.0
      },
      {
        "periodo": 202606,
        "valor": 1572503677.0,
        "delta": -417346823.0
      },
      {
        "periodo": 202607,
        "valor": 1558927628.0,
        "delta": -13576049.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 2261093895.75,
    "valor_anterior": 2261424464.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2264814843.54,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2264787946.32,
        "delta": -26897.22
      },
      {
        "periodo": 202509,
        "valor": 2265503100.45,
        "delta": 715154.13
      },
      {
        "periodo": 202510,
        "valor": 2264862004.86,
        "delta": -641095.59
      },
      {
        "periodo": 202511,
        "valor": 2264045632.68,
        "delta": -816372.18
      },
      {
        "periodo": 202512,
        "valor": 2261974014.01,
        "delta": -2071618.67
      },
      {
        "periodo": 202601,
        "valor": 2261010059.73,
        "delta": -963954.28
      },
      {
        "periodo": 202602,
        "valor": 2260694536.07,
        "delta": -315523.66
      },
      {
        "periodo": 202603,
        "valor": 2260538959.32,
        "delta": -155576.75
      },
      {
        "periodo": 202604,
        "valor": 2261354124.55,
        "delta": 815165.23
      },
      {
        "periodo": 202605,
        "valor": 2261791209.91,
        "delta": 437085.36
      },
      {
        "periodo": 202606,
        "valor": 2261424464.25,
        "delta": -366745.66
      },
      {
        "periodo": 202607,
        "valor": 2261093895.75,
        "delta": -330568.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 11742199714.43,
    "valor_anterior": 11186802531.72,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8504606770.21,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9542684826.86,
        "delta": 1038078056.65
      },
      {
        "periodo": 202509,
        "valor": 9940231327.64,
        "delta": 397546500.78
      },
      {
        "periodo": 202510,
        "valor": 11617640562.13,
        "delta": 1677409234.49
      },
      {
        "periodo": 202511,
        "valor": 12770448823.65,
        "delta": 1152808261.52
      },
      {
        "periodo": 202512,
        "valor": 13236260885.56,
        "delta": 465812061.91
      },
      {
        "periodo": 202601,
        "valor": 12821474064.37,
        "delta": -414786821.19
      },
      {
        "periodo": 202602,
        "valor": 12246201255.4,
        "delta": -575272808.97
      },
      {
        "periodo": 202603,
        "valor": 11959119373.33,
        "delta": -287081882.07
      },
      {
        "periodo": 202604,
        "valor": 11605758288.66,
        "delta": -353361084.67
      },
      {
        "periodo": 202605,
        "valor": 11444785423.85,
        "delta": -160972864.81
      },
      {
        "periodo": 202606,
        "valor": 11186802531.72,
        "delta": -257982892.13
      },
      {
        "periodo": 202607,
        "valor": 11742199714.43,
        "delta": 555397182.71
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 905366603.0,
    "valor_anterior": 849130406.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 305976651.86,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 274320089.0,
        "delta": -31656562.86
      },
      {
        "periodo": 202509,
        "valor": 319901483.0,
        "delta": 45581394.0
      },
      {
        "periodo": 202510,
        "valor": 406777424.0,
        "delta": 86875941.0
      },
      {
        "periodo": 202511,
        "valor": 463289168.0,
        "delta": 56511744.0
      },
      {
        "periodo": 202512,
        "valor": 592801310.0,
        "delta": 129512142.0
      },
      {
        "periodo": 202601,
        "valor": 738254875.0,
        "delta": 145453565.0
      },
      {
        "periodo": 202602,
        "valor": 725906974.0,
        "delta": -12347901.0
      },
      {
        "periodo": 202603,
        "valor": 754202480.0,
        "delta": 28295506.0
      },
      {
        "periodo": 202604,
        "valor": 795593087.0,
        "delta": 41390607.0
      },
      {
        "periodo": 202605,
        "valor": 925228650.0,
        "delta": 129635563.0
      },
      {
        "periodo": 202606,
        "valor": 849130406.0,
        "delta": -76098244.0
      },
      {
        "periodo": 202607,
        "valor": 905366603.0,
        "delta": 56236197.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 2923957807.0,
    "valor_anterior": 2872565390.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1875463573.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1928586477.0,
        "delta": 53122904.0
      },
      {
        "periodo": 202509,
        "valor": 2037623336.0,
        "delta": 109036859.0
      },
      {
        "periodo": 202510,
        "valor": 2143287390.0,
        "delta": 105664054.0
      },
      {
        "periodo": 202511,
        "valor": 2298379994.0,
        "delta": 155092604.0
      },
      {
        "periodo": 202512,
        "valor": 2619408661.0,
        "delta": 321028667.0
      },
      {
        "periodo": 202601,
        "valor": 2665370795.0,
        "delta": 45962134.0
      },
      {
        "periodo": 202602,
        "valor": 2935553647.0,
        "delta": 270182852.0
      },
      {
        "periodo": 202603,
        "valor": 3088485432.0,
        "delta": 152931785.0
      },
      {
        "periodo": 202604,
        "valor": 2897536137.0,
        "delta": -190949295.0
      },
      {
        "periodo": 202605,
        "valor": 2937192453.0,
        "delta": 39656316.0
      },
      {
        "periodo": 202606,
        "valor": 2872565390.0,
        "delta": -64627063.0
      },
      {
        "periodo": 202607,
        "valor": 2923957807.0,
        "delta": 51392417.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 2534430344.0,
    "valor_anterior": 2520811946.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2102444913.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2091267286.0,
        "delta": -11177627.0
      },
      {
        "periodo": 202509,
        "valor": 2337294235.0,
        "delta": 246026949.0
      },
      {
        "periodo": 202510,
        "valor": 2306163169.0,
        "delta": -31131066.0
      },
      {
        "periodo": 202511,
        "valor": 2256213223.0,
        "delta": -49949946.0
      },
      {
        "periodo": 202512,
        "valor": 2215497375.0,
        "delta": -40715848.0
      },
      {
        "periodo": 202601,
        "valor": 2258565380.0,
        "delta": 43068005.0
      },
      {
        "periodo": 202602,
        "valor": 1956508062.0,
        "delta": -302057318.0
      },
      {
        "periodo": 202603,
        "valor": 1923188644.0,
        "delta": -33319418.0
      },
      {
        "periodo": 202604,
        "valor": 2276983760.0,
        "delta": 353795116.0
      },
      {
        "periodo": 202605,
        "valor": 2608468354.0,
        "delta": 331484594.0
      },
      {
        "periodo": 202606,
        "valor": 2520811946.0,
        "delta": -87656408.0
      },
      {
        "periodo": 202607,
        "valor": 2534430344.0,
        "delta": 13618398.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 538015052.0,
    "valor_anterior": 539680982.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 945446571.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 933050938.0,
        "delta": -12395633.0
      },
      {
        "periodo": 202509,
        "valor": 877440448.0,
        "delta": -55610490.0
      },
      {
        "periodo": 202510,
        "valor": 885885385.0,
        "delta": 8444937.0
      },
      {
        "periodo": 202511,
        "valor": 771162386.0,
        "delta": -114722999.0
      },
      {
        "periodo": 202512,
        "valor": 720625562.0,
        "delta": -50536824.0
      },
      {
        "periodo": 202601,
        "valor": 717215727.0,
        "delta": -3409835.0
      },
      {
        "periodo": 202602,
        "valor": 715272280.0,
        "delta": -1943447.0
      },
      {
        "periodo": 202603,
        "valor": 721406889.0,
        "delta": 6134609.0
      },
      {
        "periodo": 202604,
        "valor": 719137289.0,
        "delta": -2269600.0
      },
      {
        "periodo": 202605,
        "valor": 533839230.0,
        "delta": -185298059.0
      },
      {
        "periodo": 202606,
        "valor": 539680982.0,
        "delta": 5841752.0
      },
      {
        "periodo": 202607,
        "valor": 538015052.0,
        "delta": -1665930.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 198469758.0,
    "valor_anterior": 555901417.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 924213676.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 969591629.0,
        "delta": 45377953.0
      },
      {
        "periodo": 202509,
        "valor": 994358565.0,
        "delta": 24766936.0
      },
      {
        "periodo": 202510,
        "valor": 1127822817.0,
        "delta": 133464252.0
      },
      {
        "periodo": 202511,
        "valor": 1104166742.0,
        "delta": -23656075.0
      },
      {
        "periodo": 202512,
        "valor": 657022380.0,
        "delta": -447144362.0
      },
      {
        "periodo": 202601,
        "valor": 630345131.0,
        "delta": -26677249.0
      },
      {
        "periodo": 202602,
        "valor": 573662742.0,
        "delta": -56682389.0
      },
      {
        "periodo": 202603,
        "valor": 592165078.0,
        "delta": 18502336.0
      },
      {
        "periodo": 202604,
        "valor": 582142345.0,
        "delta": -10022733.0
      },
      {
        "periodo": 202605,
        "valor": 579316039.0,
        "delta": -2826306.0
      },
      {
        "periodo": 202606,
        "valor": 555901417.0,
        "delta": -23414622.0
      },
      {
        "periodo": 202607,
        "valor": 198469758.0,
        "delta": -357431659.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 5315757792.31,
    "valor_anterior": 5301813893.77,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4107751338.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4279856736.11,
        "delta": 172105397.37
      },
      {
        "periodo": 202509,
        "valor": 4304007854.28,
        "delta": 24151118.17
      },
      {
        "periodo": 202510,
        "valor": 3568902632.06,
        "delta": -735105222.22
      },
      {
        "periodo": 202511,
        "valor": 4060283092.3,
        "delta": 491380460.24
      },
      {
        "periodo": 202512,
        "valor": 3707444374.56,
        "delta": -352838717.74
      },
      {
        "periodo": 202601,
        "valor": 5214919417.32,
        "delta": 1507475042.76
      },
      {
        "periodo": 202602,
        "valor": 5376161080.02,
        "delta": 161241662.7
      },
      {
        "periodo": 202603,
        "valor": 5524377087.72,
        "delta": 148216007.7
      },
      {
        "periodo": 202604,
        "valor": 5607154464.55,
        "delta": 82777376.83
      },
      {
        "periodo": 202605,
        "valor": 5805172501.76,
        "delta": 198018037.21
      },
      {
        "periodo": 202606,
        "valor": 5301813893.77,
        "delta": -503358607.99
      },
      {
        "periodo": 202607,
        "valor": 5315757792.31,
        "delta": 13943898.54
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 202345204.0,
    "valor_anterior": 195128070.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 125209537.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 133377139.0,
        "delta": 8167602.0
      },
      {
        "periodo": 202509,
        "valor": 137521869.0,
        "delta": 4144730.0
      },
      {
        "periodo": 202510,
        "valor": 146392555.0,
        "delta": 8870686.0
      },
      {
        "periodo": 202511,
        "valor": 150328265.0,
        "delta": 3935710.0
      },
      {
        "periodo": 202512,
        "valor": 160015629.0,
        "delta": 9687364.0
      },
      {
        "periodo": 202601,
        "valor": 164792792.0,
        "delta": 4777163.0
      },
      {
        "periodo": 202602,
        "valor": 172953012.0,
        "delta": 8160220.0
      },
      {
        "periodo": 202603,
        "valor": 173679513.0,
        "delta": 726501.0
      },
      {
        "periodo": 202604,
        "valor": 175006003.0,
        "delta": 1326490.0
      },
      {
        "periodo": 202605,
        "valor": 184093356.0,
        "delta": 9087353.0
      },
      {
        "periodo": 202606,
        "valor": 195128070.0,
        "delta": 11034714.0
      },
      {
        "periodo": 202607,
        "valor": 202345204.0,
        "delta": 7217134.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 578752678.0,
    "valor_anterior": 518124881.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 497558170.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 475193148.0,
        "delta": -22365022.0
      },
      {
        "periodo": 202509,
        "valor": 467121372.0,
        "delta": -8071776.0
      },
      {
        "periodo": 202510,
        "valor": 487397456.0,
        "delta": 20276084.0
      },
      {
        "periodo": 202511,
        "valor": 498082341.0,
        "delta": 10684885.0
      },
      {
        "periodo": 202512,
        "valor": 508483819.0,
        "delta": 10401478.0
      },
      {
        "periodo": 202601,
        "valor": 494382492.0,
        "delta": -14101327.0
      },
      {
        "periodo": 202602,
        "valor": 507813669.0,
        "delta": 13431177.0
      },
      {
        "periodo": 202603,
        "valor": 474010839.0,
        "delta": -33802830.0
      },
      {
        "periodo": 202604,
        "valor": 507010659.0,
        "delta": 32999820.0
      },
      {
        "periodo": 202605,
        "valor": 479163413.0,
        "delta": -27847246.0
      },
      {
        "periodo": 202606,
        "valor": 518124881.0,
        "delta": 38961468.0
      },
      {
        "periodo": 202607,
        "valor": 578752678.0,
        "delta": 60627797.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 153031867.0,
    "valor_anterior": 138212015.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 78096579.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 82712261.0,
        "delta": 4615682.0
      },
      {
        "periodo": 202509,
        "valor": 87524748.0,
        "delta": 4812487.0
      },
      {
        "periodo": 202510,
        "valor": 92180944.0,
        "delta": 4656196.0
      },
      {
        "periodo": 202511,
        "valor": 99843093.0,
        "delta": 7662149.0
      },
      {
        "periodo": 202512,
        "valor": 99099985.0,
        "delta": -743108.0
      },
      {
        "periodo": 202601,
        "valor": 101820508.0,
        "delta": 2720523.0
      },
      {
        "periodo": 202602,
        "valor": 102990893.0,
        "delta": 1170385.0
      },
      {
        "periodo": 202603,
        "valor": 132256175.0,
        "delta": 29265282.0
      },
      {
        "periodo": 202604,
        "valor": 142934045.0,
        "delta": 10677870.0
      },
      {
        "periodo": 202605,
        "valor": 158549401.0,
        "delta": 15615356.0
      },
      {
        "periodo": 202606,
        "valor": 138212015.0,
        "delta": -20337386.0
      },
      {
        "periodo": 202607,
        "valor": 153031867.0,
        "delta": 14819852.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 557113372.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 562694827.0,
        "delta": 5581455.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 371834155.0,
    "valor_anterior": 373257428.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 330572778.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 349687351.0,
        "delta": 19114573.0
      },
      {
        "periodo": 202509,
        "valor": 336475850.0,
        "delta": -13211501.0
      },
      {
        "periodo": 202510,
        "valor": 337643762.0,
        "delta": 1167912.0
      },
      {
        "periodo": 202511,
        "valor": 340045104.0,
        "delta": 2401342.0
      },
      {
        "periodo": 202512,
        "valor": 342351147.0,
        "delta": 2306043.0
      },
      {
        "periodo": 202601,
        "valor": 342200963.0,
        "delta": -150184.0
      },
      {
        "periodo": 202602,
        "valor": 348690173.0,
        "delta": 6489210.0
      },
      {
        "periodo": 202603,
        "valor": 371305975.0,
        "delta": 22615802.0
      },
      {
        "periodo": 202604,
        "valor": 298544981.0,
        "delta": -72760994.0
      },
      {
        "periodo": 202605,
        "valor": 363135653.0,
        "delta": 64590672.0
      },
      {
        "periodo": 202606,
        "valor": 373257428.0,
        "delta": 10121775.0
      },
      {
        "periodo": 202607,
        "valor": 371834155.0,
        "delta": -1423273.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 133058731.0,
    "valor_anterior": 133023683.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 110860277.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 109709251.0,
        "delta": -1151026.0
      },
      {
        "periodo": 202509,
        "valor": 108454255.0,
        "delta": -1254996.0
      },
      {
        "periodo": 202510,
        "valor": 123734181.0,
        "delta": 15279926.0
      },
      {
        "periodo": 202511,
        "valor": 123787946.0,
        "delta": 53765.0
      },
      {
        "periodo": 202512,
        "valor": 123795625.0,
        "delta": 7679.0
      },
      {
        "periodo": 202601,
        "valor": 123435259.0,
        "delta": -360366.0
      },
      {
        "periodo": 202602,
        "valor": 123096990.0,
        "delta": -338269.0
      },
      {
        "periodo": 202603,
        "valor": 123044502.0,
        "delta": -52488.0
      },
      {
        "periodo": 202604,
        "valor": 125307729.0,
        "delta": 2263227.0
      },
      {
        "periodo": 202605,
        "valor": 122594682.0,
        "delta": -2713047.0
      },
      {
        "periodo": 202606,
        "valor": 133023683.0,
        "delta": 10429001.0
      },
      {
        "periodo": 202607,
        "valor": 133058731.0,
        "delta": 35048.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 72999996.0,
    "valor_anterior": 68911807.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 37054376.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 34080858.0,
        "delta": -2973518.0
      },
      {
        "periodo": 202509,
        "valor": 31948016.0,
        "delta": -2132842.0
      },
      {
        "periodo": 202510,
        "valor": 31900090.0,
        "delta": -47926.0
      },
      {
        "periodo": 202511,
        "valor": 34369232.0,
        "delta": 2469142.0
      },
      {
        "periodo": 202512,
        "valor": 39784833.0,
        "delta": 5415601.0
      },
      {
        "periodo": 202601,
        "valor": 42162112.0,
        "delta": 2377279.0
      },
      {
        "periodo": 202602,
        "valor": 45431526.0,
        "delta": 3269414.0
      },
      {
        "periodo": 202603,
        "valor": 49300031.0,
        "delta": 3868505.0
      },
      {
        "periodo": 202604,
        "valor": 54563584.0,
        "delta": 5263553.0
      },
      {
        "periodo": 202605,
        "valor": 62505164.0,
        "delta": 7941580.0
      },
      {
        "periodo": 202606,
        "valor": 68911807.0,
        "delta": 6406643.0
      },
      {
        "periodo": 202607,
        "valor": 72999996.0,
        "delta": 4088189.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 344960670.95,
    "valor_anterior": 343344118.17,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 358184188.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 355473845.86,
        "delta": -2710342.79
      },
      {
        "periodo": 202509,
        "valor": 348703315.03,
        "delta": -6770530.83
      },
      {
        "periodo": 202510,
        "valor": 349312996.48,
        "delta": 609681.45
      },
      {
        "periodo": 202511,
        "valor": 347435051.52,
        "delta": -1877944.96
      },
      {
        "periodo": 202512,
        "valor": 314890400.0,
        "delta": -32544651.52
      },
      {
        "periodo": 202601,
        "valor": 311034500.58,
        "delta": -3855899.42
      },
      {
        "periodo": 202602,
        "valor": 311666237.34,
        "delta": 631736.76
      },
      {
        "periodo": 202603,
        "valor": 312196197.58,
        "delta": 529960.24
      },
      {
        "periodo": 202604,
        "valor": 333231065.82,
        "delta": 21034868.24
      },
      {
        "periodo": 202605,
        "valor": 333186983.47,
        "delta": -44082.35
      },
      {
        "periodo": 202606,
        "valor": 343344118.17,
        "delta": 10157134.7
      },
      {
        "periodo": 202607,
        "valor": 344960670.95,
        "delta": 1616552.78
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 3244675.0,
    "valor_anterior": 3244675.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3244675.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3244675.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 3244675.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 3244675.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 3244675.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 3244675.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 3244675.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 3244675.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 3244675.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 3244675.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 3244675.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 3244675.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 3244675.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 1430867947.49,
    "valor_anterior": 1423455626.06,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 447560206.41,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 933914308.66,
        "delta": 486354102.25
      },
      {
        "periodo": 202509,
        "valor": 944308800.6,
        "delta": 10394491.94
      },
      {
        "periodo": 202510,
        "valor": 944995899.96,
        "delta": 687099.36
      },
      {
        "periodo": 202511,
        "valor": 916571772.48,
        "delta": -28424127.48
      },
      {
        "periodo": 202512,
        "valor": 878916300.49,
        "delta": -37655471.99
      },
      {
        "periodo": 202601,
        "valor": 1272305011.01,
        "delta": 393388710.52
      },
      {
        "periodo": 202602,
        "valor": 1281606873.36,
        "delta": 9301862.35
      },
      {
        "periodo": 202603,
        "valor": 1287297592.41,
        "delta": 5690719.05
      },
      {
        "periodo": 202604,
        "valor": 1302468613.37,
        "delta": 15171020.96
      },
      {
        "periodo": 202605,
        "valor": 1407597372.7,
        "delta": 105128759.33
      },
      {
        "periodo": 202606,
        "valor": 1423455626.06,
        "delta": 15858253.36
      },
      {
        "periodo": 202607,
        "valor": 1430867947.49,
        "delta": 7412321.43
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 448417819.49,
    "valor_anterior": 445633258.52,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 358389246.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 370003425.84,
        "delta": 11614178.91
      },
      {
        "periodo": 202509,
        "valor": 388463984.13,
        "delta": 18460558.29
      },
      {
        "periodo": 202510,
        "valor": 407633555.88,
        "delta": 19169571.75
      },
      {
        "periodo": 202511,
        "valor": 416384187.04,
        "delta": 8750631.16
      },
      {
        "periodo": 202512,
        "valor": 436976295.69,
        "delta": 20592108.65
      },
      {
        "periodo": 202601,
        "valor": 487537005.97,
        "delta": 50560710.28
      },
      {
        "periodo": 202602,
        "valor": 480943082.09,
        "delta": -6593923.88
      },
      {
        "periodo": 202603,
        "valor": 480101927.51,
        "delta": -841154.58
      },
      {
        "periodo": 202604,
        "valor": 475327506.67,
        "delta": -4774420.84
      },
      {
        "periodo": 202605,
        "valor": 485063277.98,
        "delta": 9735771.31
      },
      {
        "periodo": 202606,
        "valor": 445633258.52,
        "delta": -39430019.46
      },
      {
        "periodo": 202607,
        "valor": 448417819.49,
        "delta": 2784560.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 261310591.0,
    "valor_anterior": 263994499.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 64931813.0,
        "delta": 64931813.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -64931813.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 263544918.0,
        "delta": 263544918.0
      },
      {
        "periodo": 202605,
        "valor": 261603271.0,
        "delta": -1941647.0
      },
      {
        "periodo": 202606,
        "valor": 263994499.0,
        "delta": 2391228.0
      },
      {
        "periodo": 202607,
        "valor": 261310591.0,
        "delta": -2683908.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 2291422536.0,
    "valor_anterior": 2330587141.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2253405528.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2042815014.0,
        "delta": -210590514.0
      },
      {
        "periodo": 202509,
        "valor": 1908128943.0,
        "delta": -134686071.0
      },
      {
        "periodo": 202510,
        "valor": 1858835748.0,
        "delta": -49293195.0
      },
      {
        "periodo": 202511,
        "valor": 1848038997.0,
        "delta": -10796751.0
      },
      {
        "periodo": 202512,
        "valor": 1850844845.0,
        "delta": 2805848.0
      },
      {
        "periodo": 202601,
        "valor": 2090129655.0,
        "delta": 239284810.0
      },
      {
        "periodo": 202602,
        "valor": 2084369214.0,
        "delta": -5760441.0
      },
      {
        "periodo": 202603,
        "valor": 2215218698.0,
        "delta": 130849484.0
      },
      {
        "periodo": 202604,
        "valor": 2225391722.0,
        "delta": 10173024.0
      },
      {
        "periodo": 202605,
        "valor": 2220032667.0,
        "delta": -5359055.0
      },
      {
        "periodo": 202606,
        "valor": 2330587141.0,
        "delta": 110554474.0
      },
      {
        "periodo": 202607,
        "valor": 2291422536.0,
        "delta": -39164605.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 22959535.0,
    "valor_anterior": 49058366.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 55683567.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55683567.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 55683567.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 55683567.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 55683567.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 55683567.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 55683567.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 55683567.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 55683567.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 49058366.0,
        "delta": -6625201.0
      },
      {
        "periodo": 202605,
        "valor": 49058366.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 49058366.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 22959535.0,
        "delta": -26098831.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 54325907.29,
    "valor_anterior": 54325907.29,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 119157441.75,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 112869733.73,
        "delta": -6287708.02
      },
      {
        "periodo": 202509,
        "valor": 108496157.07,
        "delta": -4373576.66
      },
      {
        "periodo": 202510,
        "valor": 60275063.16,
        "delta": -48221093.91
      },
      {
        "periodo": 202511,
        "valor": 60275063.16,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 60275063.16,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 60275063.16,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 60275063.16,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 54325907.29,
        "delta": -5949155.87
      },
      {
        "periodo": 202604,
        "valor": 54325907.29,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 54325907.29,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 54325907.29,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 54325907.29,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 59534578.0,
    "valor_anterior": 59679361.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 57716784.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 57808754.0,
        "delta": 91970.0
      },
      {
        "periodo": 202509,
        "valor": 57888302.0,
        "delta": 79548.0
      },
      {
        "periodo": 202510,
        "valor": 58029552.0,
        "delta": 141250.0
      },
      {
        "periodo": 202511,
        "valor": 58267884.0,
        "delta": 238332.0
      },
      {
        "periodo": 202512,
        "valor": 58664953.0,
        "delta": 397069.0
      },
      {
        "periodo": 202601,
        "valor": 58769977.0,
        "delta": 105024.0
      },
      {
        "periodo": 202602,
        "valor": 59016778.0,
        "delta": 246801.0
      },
      {
        "periodo": 202603,
        "valor": 59476842.0,
        "delta": 460064.0
      },
      {
        "periodo": 202604,
        "valor": 59809766.0,
        "delta": 332924.0
      },
      {
        "periodo": 202605,
        "valor": 59851320.0,
        "delta": 41554.0
      },
      {
        "periodo": 202606,
        "valor": 59679361.0,
        "delta": -171959.0
      },
      {
        "periodo": 202607,
        "valor": 59534578.0,
        "delta": -144783.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 31445.94,
    "valor_anterior": 83552.77,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5650081.21,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4186699.98,
        "delta": -1463381.23
      },
      {
        "periodo": 202509,
        "valor": 2464706.83,
        "delta": -1721993.15
      },
      {
        "periodo": 202510,
        "valor": 1615520.5,
        "delta": -849186.33
      },
      {
        "periodo": 202511,
        "valor": 921287.16,
        "delta": -694233.34
      },
      {
        "periodo": 202512,
        "valor": 569782.26,
        "delta": -351504.9
      },
      {
        "periodo": 202601,
        "valor": 340000.71,
        "delta": -229781.55
      },
      {
        "periodo": 202602,
        "valor": 300513.92,
        "delta": -39486.79
      },
      {
        "periodo": 202603,
        "valor": 217575.44,
        "delta": -82938.48
      },
      {
        "periodo": 202604,
        "valor": 123166.94,
        "delta": -94408.5
      },
      {
        "periodo": 202605,
        "valor": 104697.75,
        "delta": -18469.19
      },
      {
        "periodo": 202606,
        "valor": 83552.77,
        "delta": -21144.98
      },
      {
        "periodo": 202607,
        "valor": 31445.94,
        "delta": -52106.83
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 199408519.06,
    "valor_anterior": 182259871.74,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 166936155.72,
        "delta": 166936155.72
      },
      {
        "periodo": 202603,
        "valor": 164203407.24,
        "delta": -2732748.48
      },
      {
        "periodo": 202604,
        "valor": 167681945.58,
        "delta": 3478538.34
      },
      {
        "periodo": 202605,
        "valor": 185076547.54,
        "delta": 17394601.96
      },
      {
        "periodo": 202606,
        "valor": 182259871.74,
        "delta": -2816675.8
      },
      {
        "periodo": 202607,
        "valor": 199408519.06,
        "delta": 17148647.32
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 51301111.0,
    "valor_anterior": 49720603.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1253314.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4234354.0,
        "delta": 2981040.0
      },
      {
        "periodo": 202509,
        "valor": 10200301.0,
        "delta": 5965947.0
      },
      {
        "periodo": 202510,
        "valor": 25434830.0,
        "delta": 15234529.0
      },
      {
        "periodo": 202511,
        "valor": 45378071.0,
        "delta": 19943241.0
      },
      {
        "periodo": 202512,
        "valor": 49864025.0,
        "delta": 4485954.0
      },
      {
        "periodo": 202601,
        "valor": 48059560.0,
        "delta": -1804465.0
      },
      {
        "periodo": 202602,
        "valor": 37804522.0,
        "delta": -10255038.0
      },
      {
        "periodo": 202603,
        "valor": 35420602.0,
        "delta": -2383920.0
      },
      {
        "periodo": 202604,
        "valor": 39239499.0,
        "delta": 3818897.0
      },
      {
        "periodo": 202605,
        "valor": 45647047.0,
        "delta": 6407548.0
      },
      {
        "periodo": 202606,
        "valor": 49720603.0,
        "delta": 4073556.0
      },
      {
        "periodo": 202607,
        "valor": 51301111.0,
        "delta": 1580508.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 540620.91,
    "valor_anterior": 326432.84,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 7570.13,
        "delta": 7570.13
      },
      {
        "periodo": 202604,
        "valor": 8932.8,
        "delta": 1362.67
      },
      {
        "periodo": 202605,
        "valor": 245850.83,
        "delta": 236918.03
      },
      {
        "periodo": 202606,
        "valor": 326432.84,
        "delta": 80582.01
      },
      {
        "periodo": 202607,
        "valor": 540620.91,
        "delta": 214188.07
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 1077099000.0,
    "valor_anterior": 801147878.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 634139938.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 865554872.0,
        "delta": 231414934.0
      },
      {
        "periodo": 202605,
        "valor": 1142058975.0,
        "delta": 276504103.0
      },
      {
        "periodo": 202606,
        "valor": 801147878.0,
        "delta": -340911097.0
      },
      {
        "periodo": 202607,
        "valor": 1077099000.0,
        "delta": 275951122.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 195033979386.87,
    "valor_anterior": 193161106746.96,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 166434371015.81,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 169522407053.58,
        "delta": 3088036037.77
      },
      {
        "periodo": 202509,
        "valor": 176392005480.65,
        "delta": 6869598427.07
      },
      {
        "periodo": 202510,
        "valor": 179536902394.76,
        "delta": 3144896914.11
      },
      {
        "periodo": 202511,
        "valor": 180954349729.71,
        "delta": 1417447334.95
      },
      {
        "periodo": 202512,
        "valor": 177281317548.5,
        "delta": -3673032181.21
      },
      {
        "periodo": 202601,
        "valor": 180840686177.73,
        "delta": 3559368629.23
      },
      {
        "periodo": 202602,
        "valor": 180608015348.99,
        "delta": -232670828.74
      },
      {
        "periodo": 202603,
        "valor": 181440746119.3,
        "delta": 832730770.31
      },
      {
        "periodo": 202604,
        "valor": 186769681916.72,
        "delta": 5328935797.42
      },
      {
        "periodo": 202605,
        "valor": 193018841128.51,
        "delta": 6249159211.79
      },
      {
        "periodo": 202606,
        "valor": 193161106746.96,
        "delta": 142265618.45
      },
      {
        "periodo": 202607,
        "valor": 195033979386.87,
        "delta": 1872872639.91
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 142785335591.12,
    "valor_anterior": 141945223559.44,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 122677630887.01,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 123788708006.18,
        "delta": 1111077119.17
      },
      {
        "periodo": 202509,
        "valor": 129852153653.4,
        "delta": 6063445647.22
      },
      {
        "periodo": 202510,
        "valor": 131743173888.27,
        "delta": 1891020234.87
      },
      {
        "periodo": 202511,
        "valor": 131278704554.72,
        "delta": -464469333.55
      },
      {
        "periodo": 202512,
        "valor": 130846093607.17,
        "delta": -432610947.55
      },
      {
        "periodo": 202601,
        "valor": 132099769554.15,
        "delta": 1253675946.98
      },
      {
        "periodo": 202602,
        "valor": 132060978464.43,
        "delta": -38791089.72
      },
      {
        "periodo": 202603,
        "valor": 131914996278.08,
        "delta": -145982186.35
      },
      {
        "periodo": 202604,
        "valor": 135747716054.39,
        "delta": 3832719776.31
      },
      {
        "periodo": 202605,
        "valor": 140575343909.35,
        "delta": 4827627854.96
      },
      {
        "periodo": 202606,
        "valor": 141945223559.44,
        "delta": 1369879650.09
      },
      {
        "periodo": 202607,
        "valor": 142785335591.12,
        "delta": 840112031.68
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 1157662606.74,
    "valor_anterior": 1517816915.69,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2638109536.51,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2695853050.85,
        "delta": 57743514.34
      },
      {
        "periodo": 202509,
        "valor": 2133065788.87,
        "delta": -562787261.98
      },
      {
        "periodo": 202510,
        "valor": 2190537214.94,
        "delta": 57471426.07
      },
      {
        "periodo": 202511,
        "valor": 2105745203.39,
        "delta": -84792011.55
      },
      {
        "periodo": 202512,
        "valor": 1425321099.69,
        "delta": -680424103.7
      },
      {
        "periodo": 202601,
        "valor": 1384328041.17,
        "delta": -40993058.52
      },
      {
        "periodo": 202602,
        "valor": 1362820192.55,
        "delta": -21507848.62
      },
      {
        "periodo": 202603,
        "valor": 1420996342.48,
        "delta": 58176149.93
      },
      {
        "periodo": 202604,
        "valor": 1435339258.03,
        "delta": 14342915.55
      },
      {
        "periodo": 202605,
        "valor": 1535921664.67,
        "delta": 100582406.64
      },
      {
        "periodo": 202606,
        "valor": 1517816915.69,
        "delta": -18104748.98
      },
      {
        "periodo": 202607,
        "valor": 1157662606.74,
        "delta": -360154308.95
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 5801126980.75,
    "valor_anterior": 5781076255.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6031568340.54,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6143038205.32,
        "delta": 111469864.78
      },
      {
        "periodo": 202509,
        "valor": 6117367714.45,
        "delta": -25670490.87
      },
      {
        "periodo": 202510,
        "valor": 6207255966.86,
        "delta": 89888252.41
      },
      {
        "periodo": 202511,
        "valor": 6345001277.68,
        "delta": 137745310.82
      },
      {
        "periodo": 202512,
        "valor": 5334478328.01,
        "delta": -1010522949.67
      },
      {
        "periodo": 202601,
        "valor": 5586733250.73,
        "delta": 252254922.72
      },
      {
        "periodo": 202602,
        "valor": 5666737526.07,
        "delta": 80004275.34
      },
      {
        "periodo": 202603,
        "valor": 5455149480.32,
        "delta": -211588045.75
      },
      {
        "periodo": 202604,
        "valor": 5496975798.55,
        "delta": 41826318.23
      },
      {
        "periodo": 202605,
        "valor": 5672876729.91,
        "delta": 175900931.36
      },
      {
        "periodo": 202606,
        "valor": 5781076255.25,
        "delta": 108199525.34
      },
      {
        "periodo": 202607,
        "valor": 5801126980.75,
        "delta": 20050725.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 17408464657.39,
    "valor_anterior": 17185648589.7,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15992886055.99,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16136325969.19,
        "delta": 143439913.2
      },
      {
        "periodo": 202509,
        "valor": 16970524684.35,
        "delta": 834198715.16
      },
      {
        "periodo": 202510,
        "valor": 16918331419.52,
        "delta": -52193264.83
      },
      {
        "periodo": 202511,
        "valor": 16984058336.61,
        "delta": 65726917.09
      },
      {
        "periodo": 202512,
        "valor": 14943934039.91,
        "delta": -2040124296.7
      },
      {
        "periodo": 202601,
        "valor": 15206632636.56,
        "delta": 262698596.65
      },
      {
        "periodo": 202602,
        "valor": 14989226458.93,
        "delta": -217406177.63
      },
      {
        "periodo": 202603,
        "valor": 15338094076.77,
        "delta": 348867617.84
      },
      {
        "periodo": 202604,
        "valor": 16536177073.07,
        "delta": 1198082996.3
      },
      {
        "periodo": 202605,
        "valor": 17271952875.41,
        "delta": 735775802.34
      },
      {
        "periodo": 202606,
        "valor": 17185648589.7,
        "delta": -86304285.71
      },
      {
        "periodo": 202607,
        "valor": 17408464657.39,
        "delta": 222816067.69
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 5766308999.220001,
    "valor_anterior": 5611372570.04,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3986741993.6,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4406946461.09,
        "delta": 420204467.49
      },
      {
        "periodo": 202509,
        "valor": 4437771977.83,
        "delta": 30825516.74
      },
      {
        "periodo": 202510,
        "valor": 4509244480.48,
        "delta": 71472502.65
      },
      {
        "periodo": 202511,
        "valor": 4433134423.2,
        "delta": -76110057.28
      },
      {
        "periodo": 202512,
        "valor": 4470574108.34,
        "delta": 37439685.14
      },
      {
        "periodo": 202601,
        "valor": 5174693745.72,
        "delta": 704119637.38
      },
      {
        "periodo": 202602,
        "valor": 5109059444.95,
        "delta": -65634300.77
      },
      {
        "periodo": 202603,
        "valor": 5249971910.79,
        "delta": 140912465.84
      },
      {
        "periodo": 202604,
        "valor": 5665908138.15,
        "delta": 415936227.36
      },
      {
        "periodo": 202605,
        "valor": 5702244474.44,
        "delta": 36336336.29
      },
      {
        "periodo": 202606,
        "valor": 5611372570.04,
        "delta": -90871904.4
      },
      {
        "periodo": 202607,
        "valor": 5766308999.22,
        "delta": 154936429.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100341,
    "label": "Cartera Etapa 3",
    "valor_actual": 22115080551.65,
    "valor_anterior": 21119968856.84,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15107434202.16,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16351535360.95,
        "delta": 1244101158.79
      },
      {
        "periodo": 202509,
        "valor": 16881121661.75,
        "delta": 529586300.8
      },
      {
        "periodo": 202510,
        "valor": 17968359424.69,
        "delta": 1087237762.94
      },
      {
        "periodo": 202511,
        "valor": 19807705934.11,
        "delta": 1839346509.42
      },
      {
        "periodo": 202512,
        "valor": 20260916365.38,
        "delta": 453210431.27
      },
      {
        "periodo": 202601,
        "valor": 21388528949.4,
        "delta": 1127612584.02
      },
      {
        "periodo": 202602,
        "valor": 21419193262.06,
        "delta": 30664312.66
      },
      {
        "periodo": 202603,
        "valor": 22061538030.86,
        "delta": 642344768.8
      },
      {
        "periodo": 202604,
        "valor": 21887565594.53,
        "delta": -173972436.33
      },
      {
        "periodo": 202605,
        "valor": 22260501474.73,
        "delta": 372935880.2
      },
      {
        "periodo": 202606,
        "valor": 21119968856.84,
        "delta": -1140532617.89
      },
      {
        "periodo": 202607,
        "valor": 22115080551.65,
        "delta": 995111694.81
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 7283421879.550003,
    "valor_anterior": 7161992374.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6731729701.31,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6758839839.27,
        "delta": 27110137.96
      },
      {
        "periodo": 202509,
        "valor": 6802305287.92,
        "delta": 43465448.65
      },
      {
        "periodo": 202510,
        "valor": 7028576805.89,
        "delta": 226271517.97
      },
      {
        "periodo": 202511,
        "valor": 6987034998.04,
        "delta": -41541807.85
      },
      {
        "periodo": 202512,
        "valor": 6937028953.59,
        "delta": -50006044.45
      },
      {
        "periodo": 202601,
        "valor": 6898629089.89,
        "delta": -38399863.7
      },
      {
        "periodo": 202602,
        "valor": 6647540701.26,
        "delta": -251088388.63
      },
      {
        "periodo": 202603,
        "valor": 7108672988.98,
        "delta": 461132287.72
      },
      {
        "periodo": 202604,
        "valor": 7046507247.02,
        "delta": -62165741.96
      },
      {
        "periodo": 202605,
        "valor": 7093206826.8,
        "delta": 46699579.78
      },
      {
        "periodo": 202606,
        "valor": 7161992374.25,
        "delta": 68785547.45
      },
      {
        "periodo": 202607,
        "valor": 7283421879.55,
        "delta": 121429505.3
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 23624934479.83998,
    "valor_anterior": 23053402368.940002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22669776886.85,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 22502421151.34,
        "delta": -167355735.51
      },
      {
        "periodo": 202509,
        "valor": 22040818801.12,
        "delta": -461602350.22
      },
      {
        "periodo": 202510,
        "valor": 22834674969.23,
        "delta": 793856168.11
      },
      {
        "periodo": 202511,
        "valor": 22156517630.39,
        "delta": -678157338.84
      },
      {
        "periodo": 202512,
        "valor": 22672162043.02,
        "delta": 515644412.63
      },
      {
        "periodo": 202601,
        "valor": 22872827334.24,
        "delta": 200665291.22
      },
      {
        "periodo": 202602,
        "valor": 21126654238.29,
        "delta": -1746173095.95
      },
      {
        "periodo": 202603,
        "valor": 23422746540.14,
        "delta": 2296092301.85
      },
      {
        "periodo": 202604,
        "valor": 22944491376.27,
        "delta": -478255163.87
      },
      {
        "periodo": 202605,
        "valor": 23379802145.89,
        "delta": 435310769.62
      },
      {
        "periodo": 202606,
        "valor": 23053402368.94,
        "delta": -326399776.95
      },
      {
        "periodo": 202607,
        "valor": 23624934479.84,
        "delta": 571532110.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 10314781955.0,
    "valor_anterior": 9972264330.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10602483827.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10429129685.0,
        "delta": -173354142.0
      },
      {
        "periodo": 202509,
        "valor": 10018365528.0,
        "delta": -410764157.0
      },
      {
        "periodo": 202510,
        "valor": 10235809547.0,
        "delta": 217444019.0
      },
      {
        "periodo": 202511,
        "valor": 9942907502.0,
        "delta": -292902045.0
      },
      {
        "periodo": 202512,
        "valor": 10312714651.0,
        "delta": 369807149.0
      },
      {
        "periodo": 202601,
        "valor": 10324799790.0,
        "delta": 12085139.0
      },
      {
        "periodo": 202602,
        "valor": 9561021536.0,
        "delta": -763778254.0
      },
      {
        "periodo": 202603,
        "valor": 10068645746.0,
        "delta": 507624210.0
      },
      {
        "periodo": 202604,
        "valor": 10162675556.0,
        "delta": 94029810.0
      },
      {
        "periodo": 202605,
        "valor": 10255456940.0,
        "delta": 92781384.0
      },
      {
        "periodo": 202606,
        "valor": 9972264330.0,
        "delta": -283192610.0
      },
      {
        "periodo": 202607,
        "valor": 10314781955.0,
        "delta": 342517625.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 4486401053.0,
    "valor_anterior": 4360600936.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5384600405.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5248608653.0,
        "delta": -135991752.0
      },
      {
        "periodo": 202509,
        "valor": 5075116330.0,
        "delta": -173492323.0
      },
      {
        "periodo": 202510,
        "valor": 5204673187.0,
        "delta": 129556857.0
      },
      {
        "periodo": 202511,
        "valor": 4924020652.0,
        "delta": -280652535.0
      },
      {
        "periodo": 202512,
        "valor": 4985558603.0,
        "delta": 61537951.0
      },
      {
        "periodo": 202601,
        "valor": 4918723450.0,
        "delta": -66835153.0
      },
      {
        "periodo": 202602,
        "valor": 4543454687.0,
        "delta": -375268763.0
      },
      {
        "periodo": 202603,
        "valor": 4739749103.0,
        "delta": 196294416.0
      },
      {
        "periodo": 202604,
        "valor": 4550691777.0,
        "delta": -189057326.0
      },
      {
        "periodo": 202605,
        "valor": 4596098277.0,
        "delta": 45406500.0
      },
      {
        "periodo": 202606,
        "valor": 4360600936.0,
        "delta": -235497341.0
      },
      {
        "periodo": 202607,
        "valor": 4486401053.0,
        "delta": 125800117.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 2465067605.0599995,
    "valor_anterior": 2387071681.299999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2530630309.58,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2501334303.35,
        "delta": -29296006.23
      },
      {
        "periodo": 202509,
        "valor": 2421750636.64,
        "delta": -79583666.71
      },
      {
        "periodo": 202510,
        "valor": 2498755123.38,
        "delta": 77004486.74
      },
      {
        "periodo": 202511,
        "valor": 2389870002.85,
        "delta": -108885120.53
      },
      {
        "periodo": 202512,
        "valor": 2478184206.27,
        "delta": 88314203.42
      },
      {
        "periodo": 202601,
        "valor": 2441004254.95,
        "delta": -37179951.32
      },
      {
        "periodo": 202602,
        "valor": 2201474325.5,
        "delta": -239529929.45
      },
      {
        "periodo": 202603,
        "valor": 2463251679.21,
        "delta": 261777353.71
      },
      {
        "periodo": 202604,
        "valor": 2389064523.43,
        "delta": -74187155.78
      },
      {
        "periodo": 202605,
        "valor": 2462023248.2,
        "delta": 72958724.77
      },
      {
        "periodo": 202606,
        "valor": 2387071681.3,
        "delta": -74951566.9
      },
      {
        "periodo": 202607,
        "valor": 2465067605.06,
        "delta": 77995923.76
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 4303589840.0,
    "valor_anterior": 4130722725.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4543971688.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4436126064.0,
        "delta": -107845624.0
      },
      {
        "periodo": 202509,
        "valor": 4319206046.0,
        "delta": -116920018.0
      },
      {
        "periodo": 202510,
        "valor": 4491042088.0,
        "delta": 171836042.0
      },
      {
        "periodo": 202511,
        "valor": 4258239377.0,
        "delta": -232802711.0
      },
      {
        "periodo": 202512,
        "valor": 3913388176.0,
        "delta": -344851201.0
      },
      {
        "periodo": 202601,
        "valor": 4268234993.0,
        "delta": 354846817.0
      },
      {
        "periodo": 202602,
        "valor": 3842702480.0,
        "delta": -425532513.0
      },
      {
        "periodo": 202603,
        "valor": 4533709159.0,
        "delta": 691006679.0
      },
      {
        "periodo": 202604,
        "valor": 4248378088.0,
        "delta": -285331071.0
      },
      {
        "periodo": 202605,
        "valor": 4324792313.0,
        "delta": 76414225.0
      },
      {
        "periodo": 202606,
        "valor": 4130722725.0,
        "delta": -194069588.0
      },
      {
        "periodo": 202607,
        "valor": 4303589840.0,
        "delta": 172867115.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 1104370486.0,
    "valor_anterior": 1013221790.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 724463296.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 714174356.0,
        "delta": -10288940.0
      },
      {
        "periodo": 202509,
        "valor": 692177967.0,
        "delta": -21996389.0
      },
      {
        "periodo": 202510,
        "valor": 1011524636.0,
        "delta": 319346669.0
      },
      {
        "periodo": 202511,
        "valor": 1026886429.0,
        "delta": 15361793.0
      },
      {
        "periodo": 202512,
        "valor": 1545804543.0,
        "delta": 518918114.0
      },
      {
        "periodo": 202601,
        "valor": 775979386.0,
        "delta": -769825157.0
      },
      {
        "periodo": 202602,
        "valor": 1040046940.0,
        "delta": 264067554.0
      },
      {
        "periodo": 202603,
        "valor": 1129716559.0,
        "delta": 89669619.0
      },
      {
        "periodo": 202604,
        "valor": 1077208754.0,
        "delta": -52507805.0
      },
      {
        "periodo": 202605,
        "valor": 1156969307.0,
        "delta": 79760553.0
      },
      {
        "periodo": 202606,
        "valor": 1013221790.0,
        "delta": -143747517.0
      },
      {
        "periodo": 202607,
        "valor": 1104370486.0,
        "delta": 91148696.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 4718806642.000004,
    "valor_anterior": 4557697885.999996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4759038171.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4810097752.0,
        "delta": 51059581.0
      },
      {
        "periodo": 202509,
        "valor": 4660071646.0,
        "delta": -150026106.0
      },
      {
        "periodo": 202510,
        "valor": 4747272625.0,
        "delta": 87200979.0
      },
      {
        "periodo": 202511,
        "valor": 4611553237.0,
        "delta": -135719388.0
      },
      {
        "periodo": 202512,
        "valor": 4723073765.0,
        "delta": 111520528.0
      },
      {
        "periodo": 202601,
        "valor": 4713366401.0,
        "delta": -9707364.0
      },
      {
        "periodo": 202602,
        "valor": 4256999429.0,
        "delta": -456366972.0
      },
      {
        "periodo": 202603,
        "valor": 4640535781.0,
        "delta": 383536352.0
      },
      {
        "periodo": 202604,
        "valor": 4547663586.0,
        "delta": -92872195.0
      },
      {
        "periodo": 202605,
        "valor": 4648753983.0,
        "delta": 101090397.0
      },
      {
        "periodo": 202606,
        "valor": 4557697886.0,
        "delta": -91056097.0
      },
      {
        "periodo": 202607,
        "valor": 4718806642.0,
        "delta": 161108756.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 1729836786.1599998,
    "valor_anterior": 1672620795.0500002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1892659493.56,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1878765578.43,
        "delta": -13893915.13
      },
      {
        "periodo": 202509,
        "valor": 1822806834.5,
        "delta": -55958743.93
      },
      {
        "periodo": 202510,
        "valor": 1878573128.61,
        "delta": 55766294.11
      },
      {
        "periodo": 202511,
        "valor": 1796390565.36,
        "delta": -82182563.25
      },
      {
        "periodo": 202512,
        "valor": 1857579072.3,
        "delta": 61188506.94
      },
      {
        "periodo": 202601,
        "valor": 1832757729.67,
        "delta": -24821342.63
      },
      {
        "periodo": 202602,
        "valor": 1550254959.93,
        "delta": -282502769.74
      },
      {
        "periodo": 202603,
        "valor": 1711975497.07,
        "delta": 161720537.14
      },
      {
        "periodo": 202604,
        "valor": 1685854417.83,
        "delta": -26121079.24
      },
      {
        "periodo": 202605,
        "valor": 1727498702.88,
        "delta": 41644285.05
      },
      {
        "periodo": 202606,
        "valor": 1672620795.05,
        "delta": -54877907.83
      },
      {
        "periodo": 202607,
        "valor": 1729836786.16,
        "delta": 57215991.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 869836710.0000019,
    "valor_anterior": 870805737.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 772940219.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 720078950.0,
        "delta": -52861269.0
      },
      {
        "periodo": 202509,
        "valor": 796964550.0,
        "delta": 76885600.0
      },
      {
        "periodo": 202510,
        "valor": 797957416.0,
        "delta": 992866.0
      },
      {
        "periodo": 202511,
        "valor": 790467178.0,
        "delta": -7490238.0
      },
      {
        "periodo": 202512,
        "valor": 823830595.0,
        "delta": 33363417.0
      },
      {
        "periodo": 202601,
        "valor": 783759854.0,
        "delta": -40070741.0
      },
      {
        "periodo": 202602,
        "valor": 794731352.0,
        "delta": 10971498.0
      },
      {
        "periodo": 202603,
        "valor": 792841471.0,
        "delta": -1889881.0
      },
      {
        "periodo": 202604,
        "valor": 887803050.0,
        "delta": 94961579.0
      },
      {
        "periodo": 202605,
        "valor": 824840448.0,
        "delta": -62962602.0
      },
      {
        "periodo": 202606,
        "valor": 870805738.0,
        "delta": 45965290.0
      },
      {
        "periodo": 202607,
        "valor": 869836710.0,
        "delta": -969028.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 248834207.0,
    "valor_anterior": 254100530.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 291865636.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 292880203.0,
        "delta": 1014567.0
      },
      {
        "periodo": 202509,
        "valor": 320068727.0,
        "delta": 27188524.0
      },
      {
        "periodo": 202510,
        "valor": 295084720.0,
        "delta": -24984007.0
      },
      {
        "periodo": 202511,
        "valor": 269144795.0,
        "delta": -25939925.0
      },
      {
        "periodo": 202512,
        "valor": 314521279.0,
        "delta": 45376484.0
      },
      {
        "periodo": 202601,
        "valor": 279976071.0,
        "delta": -34545208.0
      },
      {
        "periodo": 202602,
        "valor": 262870698.0,
        "delta": -17105373.0
      },
      {
        "periodo": 202603,
        "valor": 273620865.0,
        "delta": 10750167.0
      },
      {
        "periodo": 202604,
        "valor": 258028185.0,
        "delta": -15592680.0
      },
      {
        "periodo": 202605,
        "valor": 257696676.0,
        "delta": -331509.0
      },
      {
        "periodo": 202606,
        "valor": 254100530.0,
        "delta": -3596146.0
      },
      {
        "periodo": 202607,
        "valor": 248834207.0,
        "delta": -5266323.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 775951532.0,
    "valor_anterior": 747528635.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 798332715.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 797824128.0,
        "delta": -508587.0
      },
      {
        "periodo": 202509,
        "valor": 784886378.0,
        "delta": -12937750.0
      },
      {
        "periodo": 202510,
        "valor": 807919165.0,
        "delta": 23032787.0
      },
      {
        "periodo": 202511,
        "valor": 799329084.0,
        "delta": -8590081.0
      },
      {
        "periodo": 202512,
        "valor": 811552971.0,
        "delta": 12223887.0
      },
      {
        "periodo": 202601,
        "valor": 808298022.0,
        "delta": -3254949.0
      },
      {
        "periodo": 202602,
        "valor": 740034199.0,
        "delta": -68263823.0
      },
      {
        "periodo": 202603,
        "valor": 808570458.0,
        "delta": 68536259.0
      },
      {
        "periodo": 202604,
        "valor": 777870257.0,
        "delta": -30700201.0
      },
      {
        "periodo": 202605,
        "valor": 803955463.0,
        "delta": 26085206.0
      },
      {
        "periodo": 202606,
        "valor": 747528635.0,
        "delta": -56426828.0
      },
      {
        "periodo": 202607,
        "valor": 775951532.0,
        "delta": 28422897.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 12146578426.5,
    "valor_anterior": 11951344278.120003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11847486550.43,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11901784324.4,
        "delta": 54297773.97
      },
      {
        "periodo": 202509,
        "valor": 11668784932.88,
        "delta": -232999391.52
      },
      {
        "periodo": 202510,
        "valor": 11852689615.47,
        "delta": 183904682.59
      },
      {
        "periodo": 202511,
        "valor": 11867858684.23,
        "delta": 15169068.76
      },
      {
        "periodo": 202512,
        "valor": 12124850301.76,
        "delta": 256991617.53
      },
      {
        "periodo": 202601,
        "valor": 12120653538.84,
        "delta": -4196762.92
      },
      {
        "periodo": 202602,
        "valor": 11526928902.97,
        "delta": -593724635.87
      },
      {
        "periodo": 202603,
        "valor": 11951193787.57,
        "delta": 424264884.6
      },
      {
        "periodo": 202604,
        "valor": 11857106541.62,
        "delta": -94087245.95
      },
      {
        "periodo": 202605,
        "valor": 12104568172.21,
        "delta": 247461630.59
      },
      {
        "periodo": 202606,
        "valor": 11951344278.12,
        "delta": -153223894.09
      },
      {
        "periodo": 202607,
        "valor": 12146578426.5,
        "delta": 195234148.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 285776590.0,
    "valor_anterior": 276231834.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 312250342.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 311808082.0,
        "delta": -442260.0
      },
      {
        "periodo": 202509,
        "valor": 313237520.0,
        "delta": 1429438.0
      },
      {
        "periodo": 202510,
        "valor": 321159323.0,
        "delta": 7921803.0
      },
      {
        "periodo": 202511,
        "valor": 301063999.0,
        "delta": -20095324.0
      },
      {
        "periodo": 202512,
        "valor": 312913320.0,
        "delta": 11849321.0
      },
      {
        "periodo": 202601,
        "valor": 282951840.0,
        "delta": -29961480.0
      },
      {
        "periodo": 202602,
        "valor": 255390850.0,
        "delta": -27560990.0
      },
      {
        "periodo": 202603,
        "valor": 292343007.0,
        "delta": 36952157.0
      },
      {
        "periodo": 202604,
        "valor": 283933247.0,
        "delta": -8409760.0
      },
      {
        "periodo": 202605,
        "valor": 282717283.0,
        "delta": -1215964.0
      },
      {
        "periodo": 202606,
        "valor": 276231834.0,
        "delta": -6485449.0
      },
      {
        "periodo": 202607,
        "valor": 285776590.0,
        "delta": 9544756.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 41819000.0,
    "valor_anterior": 39109589.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 41238388.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 39682979.0,
        "delta": -1555409.0
      },
      {
        "periodo": 202509,
        "valor": 38222752.0,
        "delta": -1460227.0
      },
      {
        "periodo": 202510,
        "valor": 40093637.0,
        "delta": 1870885.0
      },
      {
        "periodo": 202511,
        "valor": 44754694.0,
        "delta": 4661057.0
      },
      {
        "periodo": 202512,
        "valor": 42054155.0,
        "delta": -2700539.0
      },
      {
        "periodo": 202601,
        "valor": 40419173.0,
        "delta": -1634982.0
      },
      {
        "periodo": 202602,
        "valor": 35391132.0,
        "delta": -5028041.0
      },
      {
        "periodo": 202603,
        "valor": 41713325.0,
        "delta": 6322193.0
      },
      {
        "periodo": 202604,
        "valor": 42220849.0,
        "delta": 507524.0
      },
      {
        "periodo": 202605,
        "valor": 44244251.0,
        "delta": 2023402.0
      },
      {
        "periodo": 202606,
        "valor": 39109589.0,
        "delta": -5134662.0
      },
      {
        "periodo": 202607,
        "valor": 41819000.0,
        "delta": 2709411.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 160874966.0,
    "valor_anterior": 155616832.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 190222033.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 175906771.0,
        "delta": -14315262.0
      },
      {
        "periodo": 202509,
        "valor": 142861200.0,
        "delta": -33045571.0
      },
      {
        "periodo": 202510,
        "valor": 158380533.0,
        "delta": 15519333.0
      },
      {
        "periodo": 202511,
        "valor": 143996080.0,
        "delta": -14384453.0
      },
      {
        "periodo": 202512,
        "valor": 150033700.0,
        "delta": 6037620.0
      },
      {
        "periodo": 202601,
        "valor": 151017642.0,
        "delta": 983942.0
      },
      {
        "periodo": 202602,
        "valor": 144223087.0,
        "delta": -6794555.0
      },
      {
        "periodo": 202603,
        "valor": 165934253.0,
        "delta": 21711166.0
      },
      {
        "periodo": 202604,
        "valor": 160482981.0,
        "delta": -5451272.0
      },
      {
        "periodo": 202605,
        "valor": 162874739.0,
        "delta": 2391758.0
      },
      {
        "periodo": 202606,
        "valor": 155616832.0,
        "delta": -7257907.0
      },
      {
        "periodo": 202607,
        "valor": 160874966.0,
        "delta": 5258134.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 402524274.6300001,
    "valor_anterior": 405874792.71000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 400326736.67,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 402767852.1,
        "delta": 2441115.43
      },
      {
        "periodo": 202509,
        "valor": 381537651.4,
        "delta": -21230200.7
      },
      {
        "periodo": 202510,
        "valor": 400173713.28,
        "delta": 18636061.88
      },
      {
        "periodo": 202511,
        "valor": 390326133.39,
        "delta": -9847579.89
      },
      {
        "periodo": 202512,
        "valor": 402687534.6,
        "delta": 12361401.21
      },
      {
        "periodo": 202601,
        "valor": 436946819.09,
        "delta": 34259284.49
      },
      {
        "periodo": 202602,
        "valor": 390321019.57,
        "delta": -46625799.52
      },
      {
        "periodo": 202603,
        "valor": 444925617.08,
        "delta": 54604597.51
      },
      {
        "periodo": 202604,
        "valor": 413080998.29,
        "delta": -31844618.79
      },
      {
        "periodo": 202605,
        "valor": 422610352.14,
        "delta": 9529353.85
      },
      {
        "periodo": 202606,
        "valor": 405874792.71,
        "delta": -16735559.43
      },
      {
        "periodo": 202607,
        "valor": 402524274.63,
        "delta": -3350518.08
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 557479971.0,
    "valor_anterior": 554072249.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 553275192.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 548226943.0,
        "delta": -5048249.0
      },
      {
        "periodo": 202509,
        "valor": 526470862.0,
        "delta": -21756081.0
      },
      {
        "periodo": 202510,
        "valor": 548855111.0,
        "delta": 22384249.0
      },
      {
        "periodo": 202511,
        "valor": 534454018.0,
        "delta": -14401093.0
      },
      {
        "periodo": 202512,
        "valor": 551705090.0,
        "delta": 17251072.0
      },
      {
        "periodo": 202601,
        "valor": 550743095.0,
        "delta": -961995.0
      },
      {
        "periodo": 202602,
        "valor": 531366693.0,
        "delta": -19376402.0
      },
      {
        "periodo": 202603,
        "valor": 571946886.0,
        "delta": 40580193.0
      },
      {
        "periodo": 202604,
        "valor": 549426229.0,
        "delta": -22520657.0
      },
      {
        "periodo": 202605,
        "valor": 559298856.0,
        "delta": 9872627.0
      },
      {
        "periodo": 202606,
        "valor": 554072249.0,
        "delta": -5226607.0
      },
      {
        "periodo": 202607,
        "valor": 557479971.0,
        "delta": 3407722.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 913768669.46,
    "valor_anterior": 803728430.1900005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1285172332.3,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1170797027.36,
        "delta": -114375304.94
      },
      {
        "periodo": 202509,
        "valor": 1080430224.84,
        "delta": -90366802.52
      },
      {
        "periodo": 202510,
        "valor": 1090238210.75,
        "delta": 9807985.91
      },
      {
        "periodo": 202511,
        "valor": 961286566.95,
        "delta": -128951643.8
      },
      {
        "periodo": 202512,
        "valor": 1081326897.7,
        "delta": 120040330.75
      },
      {
        "periodo": 202601,
        "valor": 1012600088.83,
        "delta": -68726808.87
      },
      {
        "periodo": 202602,
        "valor": 837614352.72,
        "delta": -174985736.11
      },
      {
        "periodo": 202603,
        "valor": 944330008.93,
        "delta": 106715656.21
      },
      {
        "periodo": 202604,
        "valor": 878153254.31,
        "delta": -66176754.62
      },
      {
        "periodo": 202605,
        "valor": 884316103.58,
        "delta": 6162849.27
      },
      {
        "periodo": 202606,
        "valor": 803728430.19,
        "delta": -80587673.39
      },
      {
        "periodo": 202607,
        "valor": 913768669.46,
        "delta": 110040239.27
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 8767453374.239998,
    "valor_anterior": 8348711466.129997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8402604165.08,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8654594605.14,
        "delta": 251990440.06
      },
      {
        "periodo": 202509,
        "valor": 8360956642.47,
        "delta": -293637962.67
      },
      {
        "periodo": 202510,
        "valor": 8660264186.56,
        "delta": 299307544.09
      },
      {
        "periodo": 202511,
        "valor": 8600456915.29,
        "delta": -59807271.27
      },
      {
        "periodo": 202512,
        "valor": 8701551664.31,
        "delta": 101094749.02
      },
      {
        "periodo": 202601,
        "valor": 8755552161.24,
        "delta": 54000496.93
      },
      {
        "periodo": 202602,
        "valor": 7904726159.13,
        "delta": -850826002.11
      },
      {
        "periodo": 202603,
        "valor": 8705166889.9,
        "delta": 800440730.77
      },
      {
        "periodo": 202604,
        "valor": 8385093030.17,
        "delta": -320073859.73
      },
      {
        "periodo": 202605,
        "valor": 8567805746.61,
        "delta": 182712716.44
      },
      {
        "periodo": 202606,
        "valor": 8348711466.13,
        "delta": -219094280.48
      },
      {
        "periodo": 202607,
        "valor": 8767453374.24,
        "delta": 418741908.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 308428791.0,
    "valor_anterior": 271558212.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 142894801.18,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 156909875.06,
        "delta": 14015073.88
      },
      {
        "periodo": 202509,
        "valor": 243210496.41,
        "delta": 86300621.35
      },
      {
        "periodo": 202510,
        "valor": 253388768.0,
        "delta": 10178271.59
      },
      {
        "periodo": 202511,
        "valor": 245376607.0,
        "delta": -8012161.0
      },
      {
        "periodo": 202512,
        "valor": 266121406.0,
        "delta": 20744799.0
      },
      {
        "periodo": 202601,
        "valor": 260717746.0,
        "delta": -5403660.0
      },
      {
        "periodo": 202602,
        "valor": 244776149.0,
        "delta": -15941597.0
      },
      {
        "periodo": 202603,
        "valor": 281729613.0,
        "delta": 36953464.0
      },
      {
        "periodo": 202604,
        "valor": 303205381.0,
        "delta": 21475768.0
      },
      {
        "periodo": 202605,
        "valor": 295211196.0,
        "delta": -7994185.0
      },
      {
        "periodo": 202606,
        "valor": 271558212.0,
        "delta": -23652984.0
      },
      {
        "periodo": 202607,
        "valor": 308428791.0,
        "delta": 36870579.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 3263036930.0,
    "valor_anterior": 3088920790.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2974320435.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3111576509.0,
        "delta": 137256074.0
      },
      {
        "periodo": 202509,
        "valor": 2985613925.0,
        "delta": -125962584.0
      },
      {
        "periodo": 202510,
        "valor": 3032436133.0,
        "delta": 46822208.0
      },
      {
        "periodo": 202511,
        "valor": 3071676013.0,
        "delta": 39239880.0
      },
      {
        "periodo": 202512,
        "valor": 3207762955.0,
        "delta": 136086942.0
      },
      {
        "periodo": 202601,
        "valor": 3069147833.0,
        "delta": -138615122.0
      },
      {
        "periodo": 202602,
        "valor": 2888192653.0,
        "delta": -180955180.0
      },
      {
        "periodo": 202603,
        "valor": 3188081669.0,
        "delta": 299889016.0
      },
      {
        "periodo": 202604,
        "valor": 3143287475.0,
        "delta": -44794194.0
      },
      {
        "periodo": 202605,
        "valor": 3114379593.0,
        "delta": -28907882.0
      },
      {
        "periodo": 202606,
        "valor": 3088920790.0,
        "delta": -25458803.0
      },
      {
        "periodo": 202607,
        "valor": 3263036930.0,
        "delta": 174116140.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 1010778605.000001,
    "valor_anterior": 961625730.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 811614903.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 821192415.0,
        "delta": 9577512.0
      },
      {
        "periodo": 202509,
        "valor": 803322963.0,
        "delta": -17869452.0
      },
      {
        "periodo": 202510,
        "valor": 876588803.0,
        "delta": 73265840.0
      },
      {
        "periodo": 202511,
        "valor": 828548050.0,
        "delta": -48040753.0
      },
      {
        "periodo": 202512,
        "valor": 894439553.0,
        "delta": 65891503.0
      },
      {
        "periodo": 202601,
        "valor": 920019476.0,
        "delta": 25579923.0
      },
      {
        "periodo": 202602,
        "valor": 855427833.0,
        "delta": -64591643.0
      },
      {
        "periodo": 202603,
        "valor": 978829183.0,
        "delta": 123401350.0
      },
      {
        "periodo": 202604,
        "valor": 957635124.0,
        "delta": -21194059.0
      },
      {
        "periodo": 202605,
        "valor": 974537142.0,
        "delta": 16902018.0
      },
      {
        "periodo": 202606,
        "valor": 961625731.0,
        "delta": -12911411.0
      },
      {
        "periodo": 202607,
        "valor": 1010778605.0,
        "delta": 49152874.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 245464201.0,
    "valor_anterior": 233049194.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 266076515.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 270009592.0,
        "delta": 3933077.0
      },
      {
        "periodo": 202509,
        "valor": 264542739.0,
        "delta": -5466853.0
      },
      {
        "periodo": 202510,
        "valor": 264263763.0,
        "delta": -278976.0
      },
      {
        "periodo": 202511,
        "valor": 246147104.0,
        "delta": -18116659.0
      },
      {
        "periodo": 202512,
        "valor": 264003438.0,
        "delta": 17856334.0
      },
      {
        "periodo": 202601,
        "valor": 268885252.0,
        "delta": 4881814.0
      },
      {
        "periodo": 202602,
        "valor": 232638842.0,
        "delta": -36246410.0
      },
      {
        "periodo": 202603,
        "valor": 254838119.0,
        "delta": 22199277.0
      },
      {
        "periodo": 202604,
        "valor": 245969377.0,
        "delta": -8868742.0
      },
      {
        "periodo": 202605,
        "valor": 252001757.0,
        "delta": 6032380.0
      },
      {
        "periodo": 202606,
        "valor": 233049194.0,
        "delta": -18952563.0
      },
      {
        "periodo": 202607,
        "valor": 245464201.0,
        "delta": 12415007.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 665090.0,
    "valor_anterior": 339778.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 183100505.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 142726954.0,
        "delta": -40373551.0
      },
      {
        "periodo": 202509,
        "valor": 58748093.0,
        "delta": -83978861.0
      },
      {
        "periodo": 202510,
        "valor": 23106262.0,
        "delta": -35641831.0
      },
      {
        "periodo": 202511,
        "valor": 30166767.0,
        "delta": 7060505.0
      },
      {
        "periodo": 202512,
        "valor": 15125031.0,
        "delta": -15041736.0
      },
      {
        "periodo": 202601,
        "valor": 1849101.0,
        "delta": -13275930.0
      },
      {
        "periodo": 202602,
        "valor": 34390357.0,
        "delta": 32541256.0
      },
      {
        "periodo": 202603,
        "valor": 2539113.0,
        "delta": -31851244.0
      },
      {
        "periodo": 202604,
        "valor": 1578124.0,
        "delta": -960989.0
      },
      {
        "periodo": 202605,
        "valor": 1180785.0,
        "delta": -397339.0
      },
      {
        "periodo": 202606,
        "valor": 339778.0,
        "delta": -841007.0
      },
      {
        "periodo": 202607,
        "valor": 665090.0,
        "delta": 325312.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 1388190913.4300013,
    "valor_anterior": 1381749528.33,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1173781557.55,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1181067244.39,
        "delta": 7285686.84
      },
      {
        "periodo": 202509,
        "valor": 1205637377.83,
        "delta": 24570133.44
      },
      {
        "periodo": 202510,
        "valor": 1308697460.87,
        "delta": 103060083.04
      },
      {
        "periodo": 202511,
        "valor": 1432614314.01,
        "delta": 123916853.14
      },
      {
        "periodo": 202512,
        "valor": 1331625399.17,
        "delta": -100988914.84
      },
      {
        "periodo": 202601,
        "valor": 1317004963.62,
        "delta": -14620435.55
      },
      {
        "periodo": 202602,
        "valor": 1283758057.15,
        "delta": -33246906.47
      },
      {
        "periodo": 202603,
        "valor": 1364615378.1,
        "delta": 80857320.95
      },
      {
        "periodo": 202604,
        "valor": 1301660990.5,
        "delta": -62954387.6
      },
      {
        "periodo": 202605,
        "valor": 1350821147.66,
        "delta": 49160157.16
      },
      {
        "periodo": 202606,
        "valor": 1381749528.33,
        "delta": 30928380.67
      },
      {
        "periodo": 202607,
        "valor": 1388190913.43,
        "delta": 6441385.1
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 37885961.0,
    "valor_anterior": 37466808.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14826005.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16795450.0,
        "delta": 1969445.0
      },
      {
        "periodo": 202509,
        "valor": 17903546.0,
        "delta": 1108096.0
      },
      {
        "periodo": 202510,
        "valor": 20744002.0,
        "delta": 2840456.0
      },
      {
        "periodo": 202511,
        "valor": 22083024.0,
        "delta": 1339022.0
      },
      {
        "periodo": 202512,
        "valor": 23897609.0,
        "delta": 1814585.0
      },
      {
        "periodo": 202601,
        "valor": 25599467.0,
        "delta": 1701858.0
      },
      {
        "periodo": 202602,
        "valor": 25057297.0,
        "delta": -542170.0
      },
      {
        "periodo": 202603,
        "valor": 30335815.0,
        "delta": 5278518.0
      },
      {
        "periodo": 202604,
        "valor": 30464627.0,
        "delta": 128812.0
      },
      {
        "periodo": 202605,
        "valor": 34315799.0,
        "delta": 3851172.0
      },
      {
        "periodo": 202606,
        "valor": 37466808.0,
        "delta": 3151009.0
      },
      {
        "periodo": 202607,
        "valor": 37885961.0,
        "delta": 419153.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 2103307.0,
    "valor_anterior": 1880580.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1996477.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1943346.0,
        "delta": -53131.0
      },
      {
        "periodo": 202509,
        "valor": 1839472.0,
        "delta": -103874.0
      },
      {
        "periodo": 202510,
        "valor": 1833772.0,
        "delta": -5700.0
      },
      {
        "periodo": 202511,
        "valor": 5995807.0,
        "delta": 4162035.0
      },
      {
        "periodo": 202512,
        "valor": 1610570.0,
        "delta": -4385237.0
      },
      {
        "periodo": 202601,
        "valor": 1580350.0,
        "delta": -30220.0
      },
      {
        "periodo": 202602,
        "valor": 1419982.0,
        "delta": -160368.0
      },
      {
        "periodo": 202603,
        "valor": 1566278.0,
        "delta": 146296.0
      },
      {
        "periodo": 202604,
        "valor": 1485013.0,
        "delta": -81265.0
      },
      {
        "periodo": 202605,
        "valor": 1546480.0,
        "delta": 61467.0
      },
      {
        "periodo": 202606,
        "valor": 1880580.0,
        "delta": 334100.0
      },
      {
        "periodo": 202607,
        "valor": 2103307.0,
        "delta": 222727.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 826652980.0,
    "valor_anterior": 807771369.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 712246517.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 723639234.0,
        "delta": 11392717.0
      },
      {
        "periodo": 202509,
        "valor": 731285394.0,
        "delta": 7646160.0
      },
      {
        "periodo": 202510,
        "valor": 746870837.0,
        "delta": 15585443.0
      },
      {
        "periodo": 202511,
        "valor": 747557845.0,
        "delta": 687008.0
      },
      {
        "periodo": 202512,
        "valor": 757281452.0,
        "delta": 9723607.0
      },
      {
        "periodo": 202601,
        "valor": 769493780.0,
        "delta": 12212328.0
      },
      {
        "periodo": 202602,
        "valor": 746832941.0,
        "delta": -22660839.0
      },
      {
        "periodo": 202603,
        "valor": 772397362.0,
        "delta": 25564421.0
      },
      {
        "periodo": 202604,
        "valor": 796267238.0,
        "delta": 23869876.0
      },
      {
        "periodo": 202605,
        "valor": 803723293.0,
        "delta": 7456055.0
      },
      {
        "periodo": 202606,
        "valor": 807771369.0,
        "delta": 4048076.0
      },
      {
        "periodo": 202607,
        "valor": 826652980.0,
        "delta": 18881611.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 105814790.0,
    "valor_anterior": 106433693.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 95700026.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 99787303.0,
        "delta": 4087277.0
      },
      {
        "periodo": 202509,
        "valor": 100996428.0,
        "delta": 1209125.0
      },
      {
        "periodo": 202510,
        "valor": 100913491.0,
        "delta": -82937.0
      },
      {
        "periodo": 202511,
        "valor": 102711409.0,
        "delta": 1797918.0
      },
      {
        "periodo": 202512,
        "valor": 24516385.0,
        "delta": -78195024.0
      },
      {
        "periodo": 202601,
        "valor": 100714657.0,
        "delta": 76198272.0
      },
      {
        "periodo": 202602,
        "valor": 104589853.0,
        "delta": 3875196.0
      },
      {
        "periodo": 202603,
        "valor": 104904883.0,
        "delta": 315030.0
      },
      {
        "periodo": 202604,
        "valor": 105490934.0,
        "delta": 586051.0
      },
      {
        "periodo": 202605,
        "valor": 106793136.0,
        "delta": 1302202.0
      },
      {
        "periodo": 202606,
        "valor": 106433693.0,
        "delta": -359443.0
      },
      {
        "periodo": 202607,
        "valor": 105814790.0,
        "delta": -618903.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 178768384.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 73324220.0,
        "delta": -105444164.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 79931025.0,
    "valor_anterior": 76623863.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 90447916.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 87712613.0,
        "delta": -2735303.0
      },
      {
        "periodo": 202509,
        "valor": 86012707.0,
        "delta": -1699906.0
      },
      {
        "periodo": 202510,
        "valor": 84813255.0,
        "delta": -1199452.0
      },
      {
        "periodo": 202511,
        "valor": 78997215.0,
        "delta": -5816040.0
      },
      {
        "periodo": 202512,
        "valor": 81868343.0,
        "delta": 2871128.0
      },
      {
        "periodo": 202601,
        "valor": 78569585.0,
        "delta": -3298758.0
      },
      {
        "periodo": 202602,
        "valor": 71609956.0,
        "delta": -6959629.0
      },
      {
        "periodo": 202603,
        "valor": 79871235.0,
        "delta": 8261279.0
      },
      {
        "periodo": 202604,
        "valor": 76036808.0,
        "delta": -3834427.0
      },
      {
        "periodo": 202605,
        "valor": 80069574.0,
        "delta": 4032766.0
      },
      {
        "periodo": 202606,
        "valor": 76623863.0,
        "delta": -3445711.0
      },
      {
        "periodo": 202607,
        "valor": 79931025.0,
        "delta": 3307162.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 250967715.0,
    "valor_anterior": 232783895.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 168848593.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 172948687.0,
        "delta": 4100094.0
      },
      {
        "periodo": 202509,
        "valor": 168678016.0,
        "delta": -4270671.0
      },
      {
        "periodo": 202510,
        "valor": 185606859.0,
        "delta": 16928843.0
      },
      {
        "periodo": 202511,
        "valor": 187117303.0,
        "delta": 1510444.0
      },
      {
        "periodo": 202512,
        "valor": 201813395.0,
        "delta": 14696092.0
      },
      {
        "periodo": 202601,
        "valor": 206669641.0,
        "delta": 4856246.0
      },
      {
        "periodo": 202602,
        "valor": 193388723.0,
        "delta": -13280918.0
      },
      {
        "periodo": 202603,
        "valor": 223482031.0,
        "delta": 30093308.0
      },
      {
        "periodo": 202604,
        "valor": 227297432.0,
        "delta": 3815401.0
      },
      {
        "periodo": 202605,
        "valor": 236372374.0,
        "delta": 9074942.0
      },
      {
        "periodo": 202606,
        "valor": 232783895.0,
        "delta": -3588479.0
      },
      {
        "periodo": 202607,
        "valor": 250967715.0,
        "delta": 18183820.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 31118897.0,
    "valor_anterior": 30215878.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22300343.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24441689.0,
        "delta": 2141346.0
      },
      {
        "periodo": 202509,
        "valor": 26042902.0,
        "delta": 1601213.0
      },
      {
        "periodo": 202510,
        "valor": 29061777.0,
        "delta": 3018875.0
      },
      {
        "periodo": 202511,
        "valor": 29848312.0,
        "delta": 786535.0
      },
      {
        "periodo": 202512,
        "valor": 31952909.0,
        "delta": 2104597.0
      },
      {
        "periodo": 202601,
        "valor": 31993060.0,
        "delta": 40151.0
      },
      {
        "periodo": 202602,
        "valor": 28966294.0,
        "delta": -3026766.0
      },
      {
        "periodo": 202603,
        "valor": 30823178.0,
        "delta": 1856884.0
      },
      {
        "periodo": 202604,
        "valor": 32283718.0,
        "delta": 1460540.0
      },
      {
        "periodo": 202605,
        "valor": 31567715.0,
        "delta": -716003.0
      },
      {
        "periodo": 202606,
        "valor": 30215878.0,
        "delta": -1351837.0
      },
      {
        "periodo": 202607,
        "valor": 31118897.0,
        "delta": 903019.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 139841532.48000002,
    "valor_anterior": 134198611.29000008,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 142103277.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 139163995.68,
        "delta": -2939281.61
      },
      {
        "periodo": 202509,
        "valor": 133266990.97,
        "delta": -5897004.71
      },
      {
        "periodo": 202510,
        "valor": 139147120.77,
        "delta": 5880129.8
      },
      {
        "periodo": 202511,
        "valor": 132349158.84,
        "delta": -6797961.93
      },
      {
        "periodo": 202512,
        "valor": 138800853.17,
        "delta": 6451694.33
      },
      {
        "periodo": 202601,
        "valor": 139222565.92,
        "delta": 421712.75
      },
      {
        "periodo": 202602,
        "valor": 124689705.57,
        "delta": -14532860.35
      },
      {
        "periodo": 202603,
        "valor": 139157336.69,
        "delta": 14467631.12
      },
      {
        "periodo": 202604,
        "valor": 133892487.02,
        "delta": -5264849.67
      },
      {
        "periodo": 202605,
        "valor": 137168719.35,
        "delta": 3276232.33
      },
      {
        "periodo": 202606,
        "valor": 134198611.29,
        "delta": -2970108.06
      },
      {
        "periodo": 202607,
        "valor": 139841532.48,
        "delta": 5642921.19
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 11385866.0,
    "valor_anterior": 11162824.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17796392.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16474174.0,
        "delta": -1322218.0
      },
      {
        "periodo": 202509,
        "valor": 16568725.0,
        "delta": 94551.0
      },
      {
        "periodo": 202510,
        "valor": 15476679.0,
        "delta": -1092046.0
      },
      {
        "periodo": 202511,
        "valor": 14679573.0,
        "delta": -797106.0
      },
      {
        "periodo": 202512,
        "valor": 14877673.0,
        "delta": 198100.0
      },
      {
        "periodo": 202601,
        "valor": 13883139.0,
        "delta": -994534.0
      },
      {
        "periodo": 202602,
        "valor": 12128962.0,
        "delta": -1754177.0
      },
      {
        "periodo": 202603,
        "valor": 13323460.0,
        "delta": 1194498.0
      },
      {
        "periodo": 202604,
        "valor": 12903131.0,
        "delta": -420329.0
      },
      {
        "periodo": 202605,
        "valor": 12125500.0,
        "delta": -777631.0
      },
      {
        "periodo": 202606,
        "valor": 11162824.0,
        "delta": -962676.0
      },
      {
        "periodo": 202607,
        "valor": 11385866.0,
        "delta": 223042.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 470903205.71000004,
    "valor_anterior": 455623573.4199996,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 473025038.01,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 474289252.39,
        "delta": 1264214.38
      },
      {
        "periodo": 202509,
        "valor": 452452758.84,
        "delta": -21836493.55
      },
      {
        "periodo": 202510,
        "valor": 483848143.69,
        "delta": 31395384.85
      },
      {
        "periodo": 202511,
        "valor": 472243314.68,
        "delta": -11604829.01
      },
      {
        "periodo": 202512,
        "valor": 473608520.54,
        "delta": 1365205.86
      },
      {
        "periodo": 202601,
        "valor": 482047924.1,
        "delta": 8439403.56
      },
      {
        "periodo": 202602,
        "valor": 428650084.43,
        "delta": -53397839.67
      },
      {
        "periodo": 202603,
        "valor": 473859297.69,
        "delta": 45209213.26
      },
      {
        "periodo": 202604,
        "valor": 460711511.39,
        "delta": -13147786.3
      },
      {
        "periodo": 202605,
        "valor": 479693627.9,
        "delta": 18982116.51
      },
      {
        "periodo": 202606,
        "valor": 455623573.42,
        "delta": -24070054.48
      },
      {
        "periodo": 202607,
        "valor": 470903205.71,
        "delta": 15279632.29
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 120879375.09000003,
    "valor_anterior": 112802779.36000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 103245879.85,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 103683505.45,
        "delta": 437625.6
      },
      {
        "periodo": 202509,
        "valor": 101674685.54,
        "delta": -2008819.91
      },
      {
        "periodo": 202510,
        "valor": 109312482.58,
        "delta": 7637797.04
      },
      {
        "periodo": 202511,
        "valor": 108874670.52,
        "delta": -437812.06
      },
      {
        "periodo": 202512,
        "valor": 110258925.14,
        "delta": 1384254.62
      },
      {
        "periodo": 202601,
        "valor": 111613789.25,
        "delta": 1354864.11
      },
      {
        "periodo": 202602,
        "valor": 102218762.23,
        "delta": -9395027.02
      },
      {
        "periodo": 202603,
        "valor": 116306963.3,
        "delta": 14088201.07
      },
      {
        "periodo": 202604,
        "valor": 111670359.87,
        "delta": -4636603.43
      },
      {
        "periodo": 202605,
        "valor": 118377647.9,
        "delta": 6707288.03
      },
      {
        "periodo": 202606,
        "valor": 112802779.36,
        "delta": -5574868.54
      },
      {
        "periodo": 202607,
        "valor": 120879375.09,
        "delta": 8076595.73
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 32852521.0,
    "valor_anterior": 29684227.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 31829432.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 35545106.0,
        "delta": 3715674.0
      },
      {
        "periodo": 202509,
        "valor": 34052976.0,
        "delta": -1492130.0
      },
      {
        "periodo": 202510,
        "valor": 36472871.0,
        "delta": 2419895.0
      },
      {
        "periodo": 202511,
        "valor": 34819431.0,
        "delta": -1653440.0
      },
      {
        "periodo": 202512,
        "valor": 33325960.0,
        "delta": -1493471.0
      },
      {
        "periodo": 202601,
        "valor": 34793976.0,
        "delta": 1468016.0
      },
      {
        "periodo": 202602,
        "valor": 28437307.0,
        "delta": -6356669.0
      },
      {
        "periodo": 202603,
        "valor": 31896020.0,
        "delta": 3458713.0
      },
      {
        "periodo": 202604,
        "valor": 28913102.0,
        "delta": -2982918.0
      },
      {
        "periodo": 202605,
        "valor": 29770390.0,
        "delta": 857288.0
      },
      {
        "periodo": 202606,
        "valor": 29684227.0,
        "delta": -86163.0
      },
      {
        "periodo": 202607,
        "valor": 32852521.0,
        "delta": 3168294.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 744099069.0,
    "valor_anterior": 727882024.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 757868018.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 750480965.0,
        "delta": -7387053.0
      },
      {
        "periodo": 202509,
        "valor": 727273641.0,
        "delta": -23207324.0
      },
      {
        "periodo": 202510,
        "valor": 756392714.0,
        "delta": 29119073.0
      },
      {
        "periodo": 202511,
        "valor": 716812718.0,
        "delta": -39579996.0
      },
      {
        "periodo": 202512,
        "valor": 751079464.0,
        "delta": 34266746.0
      },
      {
        "periodo": 202601,
        "valor": 747099111.0,
        "delta": -3980353.0
      },
      {
        "periodo": 202602,
        "valor": 681249113.0,
        "delta": -65849998.0
      },
      {
        "periodo": 202603,
        "valor": 779227640.0,
        "delta": 97978527.0
      },
      {
        "periodo": 202604,
        "valor": 749527791.0,
        "delta": -29699849.0
      },
      {
        "periodo": 202605,
        "valor": 751868304.0,
        "delta": 2340513.0
      },
      {
        "periodo": 202606,
        "valor": 727882024.0,
        "delta": -23986280.0
      },
      {
        "periodo": 202607,
        "valor": 744099069.0,
        "delta": 16217045.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 20979374.0,
    "valor_anterior": 19177420.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 24815764.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25554489.0,
        "delta": 738725.0
      },
      {
        "periodo": 202509,
        "valor": 24001245.0,
        "delta": -1553244.0
      },
      {
        "periodo": 202510,
        "valor": 22554861.0,
        "delta": -1446384.0
      },
      {
        "periodo": 202511,
        "valor": 21283255.0,
        "delta": -1271606.0
      },
      {
        "periodo": 202512,
        "valor": 21389799.0,
        "delta": 106544.0
      },
      {
        "periodo": 202601,
        "valor": 20324359.0,
        "delta": -1065440.0
      },
      {
        "periodo": 202602,
        "valor": 17546471.0,
        "delta": -2777888.0
      },
      {
        "periodo": 202603,
        "valor": 19689917.0,
        "delta": 2143446.0
      },
      {
        "periodo": 202604,
        "valor": 18942121.0,
        "delta": -747796.0
      },
      {
        "periodo": 202605,
        "valor": 19435575.0,
        "delta": 493454.0
      },
      {
        "periodo": 202606,
        "valor": 19177420.0,
        "delta": -258155.0
      },
      {
        "periodo": 202607,
        "valor": 20979374.0,
        "delta": 1801954.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 45289546.649999976,
    "valor_anterior": 44316142.07000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 46095340.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 48815339.89,
        "delta": 2719999.7
      },
      {
        "periodo": 202509,
        "valor": 45324532.92,
        "delta": -3490806.97
      },
      {
        "periodo": 202510,
        "valor": 46568847.64,
        "delta": 1244314.72
      },
      {
        "periodo": 202511,
        "valor": 39356536.03,
        "delta": -7212311.61
      },
      {
        "periodo": 202512,
        "valor": 18734471.32,
        "delta": -20622064.71
      },
      {
        "periodo": 202601,
        "valor": 18415930.43,
        "delta": -318540.89
      },
      {
        "periodo": 202602,
        "valor": 17224220.94,
        "delta": -1191709.49
      },
      {
        "periodo": 202603,
        "valor": 20092694.29,
        "delta": 2868473.35
      },
      {
        "periodo": 202604,
        "valor": 38652555.83,
        "delta": 18559861.54
      },
      {
        "periodo": 202605,
        "valor": 46279246.43,
        "delta": 7626690.6
      },
      {
        "periodo": 202606,
        "valor": 44316142.07,
        "delta": -1963104.36
      },
      {
        "periodo": 202607,
        "valor": 45289546.65,
        "delta": 973404.58
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 27537509.929999992,
    "valor_anterior": 23982451.820000008,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26527180.78,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24599060.01,
        "delta": -1928120.77
      },
      {
        "periodo": 202509,
        "valor": 18014631.39,
        "delta": -6584428.62
      },
      {
        "periodo": 202510,
        "valor": 19518100.19,
        "delta": 1503468.8
      },
      {
        "periodo": 202511,
        "valor": 19226734.88,
        "delta": -291365.31
      },
      {
        "periodo": 202512,
        "valor": 19147310.61,
        "delta": -79424.27
      },
      {
        "periodo": 202601,
        "valor": 18457221.68,
        "delta": -690088.93
      },
      {
        "periodo": 202602,
        "valor": 18095784.42,
        "delta": -361437.26
      },
      {
        "periodo": 202603,
        "valor": 21291307.7,
        "delta": 3195523.28
      },
      {
        "periodo": 202604,
        "valor": 21840538.27,
        "delta": 549230.57
      },
      {
        "periodo": 202605,
        "valor": 23817183.75,
        "delta": 1976645.48
      },
      {
        "periodo": 202606,
        "valor": 23982451.82,
        "delta": 165268.07
      },
      {
        "periodo": 202607,
        "valor": 27537509.93,
        "delta": 3555058.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 695225.0,
    "valor_anterior": 1032586.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 552006.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1160706.0,
        "delta": 608700.0
      },
      {
        "periodo": 202509,
        "valor": 2198603.0,
        "delta": 1037897.0
      },
      {
        "periodo": 202510,
        "valor": 727957.0,
        "delta": -1470646.0
      },
      {
        "periodo": 202511,
        "valor": 1806886.0,
        "delta": 1078929.0
      },
      {
        "periodo": 202512,
        "valor": 903651.0,
        "delta": -903235.0
      },
      {
        "periodo": 202601,
        "valor": 728246.0,
        "delta": -175405.0
      },
      {
        "periodo": 202602,
        "valor": 977785.0,
        "delta": 249539.0
      },
      {
        "periodo": 202603,
        "valor": 513788.0,
        "delta": -463997.0
      },
      {
        "periodo": 202604,
        "valor": 1182970.0,
        "delta": 669182.0
      },
      {
        "periodo": 202605,
        "valor": 1041975.0,
        "delta": -140995.0
      },
      {
        "periodo": 202606,
        "valor": 1032586.0,
        "delta": -9389.0
      },
      {
        "periodo": 202607,
        "valor": 695225.0,
        "delta": -337361.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 16358634.0,
    "valor_anterior": 15744321.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19762677.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19170695.0,
        "delta": -591982.0
      },
      {
        "periodo": 202509,
        "valor": 17739866.0,
        "delta": -1430829.0
      },
      {
        "periodo": 202510,
        "valor": 18548764.0,
        "delta": 808898.0
      },
      {
        "periodo": 202511,
        "valor": 17358505.0,
        "delta": -1190259.0
      },
      {
        "periodo": 202512,
        "valor": 17014466.0,
        "delta": -344039.0
      },
      {
        "periodo": 202601,
        "valor": 16207719.0,
        "delta": -806747.0
      },
      {
        "periodo": 202602,
        "valor": 14473928.0,
        "delta": -1733791.0
      },
      {
        "periodo": 202603,
        "valor": 17137407.0,
        "delta": 2663479.0
      },
      {
        "periodo": 202604,
        "valor": 15095902.0,
        "delta": -2041505.0
      },
      {
        "periodo": 202605,
        "valor": 15705301.0,
        "delta": 609399.0
      },
      {
        "periodo": 202606,
        "valor": 15744321.0,
        "delta": 39020.0
      },
      {
        "periodo": 202607,
        "valor": 16358634.0,
        "delta": 614313.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 6031.9100000000035,
    "valor_anterior": 8118.779999999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 285632.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 190820.41,
        "delta": -94812.12
      },
      {
        "periodo": 202509,
        "valor": 125859.21,
        "delta": -64961.2
      },
      {
        "periodo": 202510,
        "valor": 91158.34,
        "delta": -34700.87
      },
      {
        "periodo": 202511,
        "valor": 64145.36,
        "delta": -27012.98
      },
      {
        "periodo": 202512,
        "valor": 47321.31,
        "delta": -16824.05
      },
      {
        "periodo": 202601,
        "valor": 33087.32,
        "delta": -14233.99
      },
      {
        "periodo": 202602,
        "valor": 21708.19,
        "delta": -11379.13
      },
      {
        "periodo": 202603,
        "valor": 17963.25,
        "delta": -3744.94
      },
      {
        "periodo": 202604,
        "valor": 12883.97,
        "delta": -5079.28
      },
      {
        "periodo": 202605,
        "valor": 10248.38,
        "delta": -2635.59
      },
      {
        "periodo": 202606,
        "valor": 8118.78,
        "delta": -2129.6
      },
      {
        "periodo": 202607,
        "valor": 6031.91,
        "delta": -2086.87
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 149678060.63,
    "valor_anterior": 146688279.71000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 134035515.4,
        "delta": 134035515.4
      },
      {
        "periodo": 202603,
        "valor": 146749352.54,
        "delta": 12713837.14
      },
      {
        "periodo": 202604,
        "valor": 145453593.7,
        "delta": -1295758.84
      },
      {
        "periodo": 202605,
        "valor": 148479820.5,
        "delta": 3026226.8
      },
      {
        "periodo": 202606,
        "valor": 146688279.71,
        "delta": -1791540.79
      },
      {
        "periodo": 202607,
        "valor": 149678060.63,
        "delta": 2989780.92
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 9912481.0,
    "valor_anterior": 9180617.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1466061.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2458710.0,
        "delta": 992649.0
      },
      {
        "periodo": 202509,
        "valor": 3842094.0,
        "delta": 1383384.0
      },
      {
        "periodo": 202510,
        "valor": 4653795.0,
        "delta": 811701.0
      },
      {
        "periodo": 202511,
        "valor": 4274424.0,
        "delta": -379371.0
      },
      {
        "periodo": 202512,
        "valor": 4530200.0,
        "delta": 255776.0
      },
      {
        "periodo": 202601,
        "valor": 5090838.0,
        "delta": 560638.0
      },
      {
        "periodo": 202602,
        "valor": 6793428.0,
        "delta": 1702590.0
      },
      {
        "periodo": 202603,
        "valor": 8502388.0,
        "delta": 1708960.0
      },
      {
        "periodo": 202604,
        "valor": 8211602.0,
        "delta": -290786.0
      },
      {
        "periodo": 202605,
        "valor": 9028129.0,
        "delta": 816527.0
      },
      {
        "periodo": 202606,
        "valor": 9180617.0,
        "delta": 152488.0
      },
      {
        "periodo": 202607,
        "valor": 9912481.0,
        "delta": 731864.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 1779126.8499999999,
    "valor_anterior": 1034107.36,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 15974.7,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 4039.93,
        "delta": -11934.77
      },
      {
        "periodo": 202601,
        "valor": 10361.29,
        "delta": 6321.36
      },
      {
        "periodo": 202602,
        "valor": 25856.63,
        "delta": 15495.34
      },
      {
        "periodo": 202603,
        "valor": 75073.33,
        "delta": 49216.7
      },
      {
        "periodo": 202604,
        "valor": 217129.73,
        "delta": 142056.4
      },
      {
        "periodo": 202605,
        "valor": 533959.34,
        "delta": 316829.61
      },
      {
        "periodo": 202606,
        "valor": 1034107.36,
        "delta": 500148.02
      },
      {
        "periodo": 202607,
        "valor": 1779126.85,
        "delta": 745019.49
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 564692695.0,
    "valor_anterior": 512196249.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 1206908210.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 454137223.0,
        "delta": -752770987.0
      },
      {
        "periodo": 202605,
        "valor": 493992982.0,
        "delta": 39855759.0
      },
      {
        "periodo": 202606,
        "valor": 512196249.0,
        "delta": 18203267.0
      },
      {
        "periodo": 202607,
        "valor": 564692695.0,
        "delta": 52496446.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 95110037907.12,
    "valor_anterior": 92191852911.83002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 93217363764.1599,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 92821511197.67,
        "delta": -395852566.4899
      },
      {
        "periodo": 202509,
        "valor": 89271868012.88,
        "delta": -3549643184.79
      },
      {
        "periodo": 202510,
        "valor": 93485356418.25,
        "delta": 4213488405.37
      },
      {
        "periodo": 202511,
        "valor": 91408563638.5199,
        "delta": -2076792779.7301
      },
      {
        "periodo": 202512,
        "valor": 93448262621.74,
        "delta": 2039698983.2201
      },
      {
        "periodo": 202601,
        "valor": 92929413913.36,
        "delta": -518848708.38
      },
      {
        "periodo": 202602,
        "valor": 86491365311.33,
        "delta": -6438048602.03
      },
      {
        "periodo": 202603,
        "valor": 95120352297.77,
        "delta": 8628986986.44
      },
      {
        "periodo": 202604,
        "valor": 92569761091.22,
        "delta": -2550591206.55
      },
      {
        "periodo": 202605,
        "valor": 94129378435.52,
        "delta": 1559617344.3
      },
      {
        "periodo": 202606,
        "valor": 92191852911.83,
        "delta": -1937525523.69
      },
      {
        "periodo": 202607,
        "valor": 95110037907.12,
        "delta": 2918184995.29
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 66878514275.890015,
    "valor_anterior": 65188024898.31,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 66539087229.59,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 66087007469.01,
        "delta": -452079760.58
      },
      {
        "periodo": 202509,
        "valor": 64584668571.92,
        "delta": -1502338897.09
      },
      {
        "periodo": 202510,
        "valor": 66394738837.59,
        "delta": 1810070265.67
      },
      {
        "periodo": 202511,
        "valor": 64748132080.66,
        "delta": -1646606756.9299
      },
      {
        "periodo": 202512,
        "valor": 65668776493.37,
        "delta": 920644412.71
      },
      {
        "periodo": 202601,
        "valor": 66117234596.97,
        "delta": 448458103.6
      },
      {
        "periodo": 202602,
        "valor": 61505301974.52,
        "delta": -4611932622.45
      },
      {
        "periodo": 202603,
        "valor": 66465253105.69,
        "delta": 4959951131.17
      },
      {
        "periodo": 202604,
        "valor": 65357514171.91,
        "delta": -1107738933.78
      },
      {
        "periodo": 202605,
        "valor": 66402678657.9,
        "delta": 1045164485.99
      },
      {
        "periodo": 202606,
        "valor": 65188024898.31,
        "delta": -1214653759.59
      },
      {
        "periodo": 202607,
        "valor": 66878514275.89,
        "delta": 1690489377.58
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 483120389.6300001,
    "valor_anterior": 482838433.71000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 852643541.67,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 706531639.1,
        "delta": -146111902.57
      },
      {
        "periodo": 202509,
        "valor": -739244721.6,
        "delta": -1445776360.7
      },
      {
        "periodo": 202510,
        "valor": 508093230.28,
        "delta": 1247337951.88
      },
      {
        "periodo": 202511,
        "valor": 499490115.39,
        "delta": -8603114.89
      },
      {
        "periodo": 202512,
        "valor": 499680908.6,
        "delta": 190793.21
      },
      {
        "periodo": 202601,
        "valor": 517365505.09,
        "delta": 17684596.49
      },
      {
        "periodo": 202602,
        "valor": 496321332.57,
        "delta": -21044172.52
      },
      {
        "periodo": 202603,
        "valor": 527335965.08,
        "delta": 31014632.51
      },
      {
        "periodo": 202604,
        "valor": 490695930.29,
        "delta": -36640034.79
      },
      {
        "periodo": 202605,
        "valor": 503860711.14,
        "delta": 13164780.85
      },
      {
        "periodo": 202606,
        "valor": 482838433.71,
        "delta": -21022277.43
      },
      {
        "periodo": 202607,
        "valor": 483120389.63,
        "delta": 281955.92
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 3050825999.459999,
    "valor_anterior": 2895934224.1900024,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3402704512.3,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3219201989.36,
        "delta": -183502522.94
      },
      {
        "periodo": 202509,
        "valor": 3160640699.84,
        "delta": -58561289.52
      },
      {
        "periodo": 202510,
        "valor": 3218310013.75,
        "delta": 57669313.91
      },
      {
        "periodo": 202511,
        "valor": 3048700294.95,
        "delta": -169609718.8
      },
      {
        "periodo": 202512,
        "valor": 3224225859.7,
        "delta": 175525564.75
      },
      {
        "periodo": 202601,
        "valor": 3081355215.83,
        "delta": -142870643.87
      },
      {
        "periodo": 202602,
        "valor": 2809782739.72,
        "delta": -271572476.11
      },
      {
        "periodo": 202603,
        "valor": 3047812588.93,
        "delta": 238029849.21
      },
      {
        "periodo": 202604,
        "valor": 3033131621.31,
        "delta": -14680967.62
      },
      {
        "periodo": 202605,
        "valor": 3005536742.58,
        "delta": -27594878.73
      },
      {
        "periodo": 202606,
        "valor": 2895934224.19,
        "delta": -109602518.39
      },
      {
        "periodo": 202607,
        "valor": 3050825999.46,
        "delta": 154891775.27
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 7611632522.220001,
    "valor_anterior": 7316494270.349998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7270511212.14,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7214174560.78,
        "delta": -56336651.36
      },
      {
        "periodo": 202509,
        "valor": 6993802904.14,
        "delta": -220371656.64
      },
      {
        "periodo": 202510,
        "valor": 7570689515.99,
        "delta": 576886611.85
      },
      {
        "periodo": 202511,
        "valor": 7292961783.21,
        "delta": -277727732.78
      },
      {
        "periodo": 202512,
        "valor": 8078791928.57,
        "delta": 785830145.36
      },
      {
        "periodo": 202601,
        "valor": 7267603052.62,
        "delta": -811188875.95
      },
      {
        "periodo": 202602,
        "valor": 6859819864.43,
        "delta": -407783188.19
      },
      {
        "periodo": 202603,
        "valor": 7634947444.28,
        "delta": 775127579.85
      },
      {
        "periodo": 202604,
        "valor": 7408716839.26,
        "delta": -226230605.02
      },
      {
        "periodo": 202605,
        "valor": 7632195560.08,
        "delta": 223478720.82
      },
      {
        "periodo": 202606,
        "valor": 7316494270.35,
        "delta": -315701289.73
      },
      {
        "periodo": 202607,
        "valor": 7611632522.22,
        "delta": 295138251.87
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 1977608439.8600006,
    "valor_anterior": 1875650988.959999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1769712531.3,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1796839424.48,
        "delta": 27126893.18
      },
      {
        "periodo": 202509,
        "valor": 1857499936.07,
        "delta": 60660511.59
      },
      {
        "periodo": 202510,
        "valor": 1910535981.87,
        "delta": 53036045.8
      },
      {
        "periodo": 202511,
        "valor": 1830060011.95,
        "delta": -80475969.92
      },
      {
        "periodo": 202512,
        "valor": 1917515105.78,
        "delta": 87455093.83
      },
      {
        "periodo": 202601,
        "valor": 1896814801.38,
        "delta": -20700304.4
      },
      {
        "periodo": 202602,
        "valor": 1722196934.59,
        "delta": -174617866.79
      },
      {
        "periodo": 202603,
        "valor": 1916760846.67,
        "delta": 194563912.08
      },
      {
        "periodo": 202604,
        "valor": 1907586710.38,
        "delta": -9174136.29
      },
      {
        "periodo": 202605,
        "valor": 1957970993.33,
        "delta": 50384282.95
      },
      {
        "periodo": 202606,
        "valor": 1875650988.96,
        "delta": -82320004.37
      },
      {
        "periodo": 202607,
        "valor": 1977608439.86,
        "delta": 101957450.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100419,
    "label": "Intereses de Cartera",
    "valor_actual": 15108336280.059998,
    "valor_anterior": 14432910096.310013,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13382704737.16,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13797756114.94,
        "delta": 415051377.78
      },
      {
        "periodo": 202509,
        "valor": 13414500622.51,
        "delta": -383255492.43
      },
      {
        "periodo": 202510,
        "valor": 13882988838.77,
        "delta": 468488216.26
      },
      {
        "periodo": 202511,
        "valor": 13989219352.36,
        "delta": 106230513.59
      },
      {
        "periodo": 202512,
        "valor": 14059272325.72,
        "delta": 70052973.36
      },
      {
        "periodo": 202601,
        "valor": 14049040741.47,
        "delta": -10231584.25
      },
      {
        "periodo": 202602,
        "valor": 13097942465.5,
        "delta": -951098275.97
      },
      {
        "periodo": 202603,
        "valor": 15528242347.12,
        "delta": 2430299881.62
      },
      {
        "periodo": 202604,
        "valor": 14372115818.07,
        "delta": -1156126529.05
      },
      {
        "periodo": 202605,
        "valor": 14627135770.49,
        "delta": 255019952.42
      },
      {
        "periodo": 202606,
        "valor": 14432910096.31,
        "delta": -194225674.18
      },
      {
        "periodo": 202607,
        "valor": 15108336280.06,
        "delta": 675426183.75
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 7190025496.969994,
    "valor_anterior": 7044801034.93,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6644318030.07,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6654337229.78,
        "delta": 10019199.71
      },
      {
        "periodo": 202509,
        "valor": 6708639751.01,
        "delta": 54302521.23
      },
      {
        "periodo": 202510,
        "valor": 6923902420.37,
        "delta": 215262669.36
      },
      {
        "periodo": 202511,
        "valor": 6886822078.87,
        "delta": -37080341.5
      },
      {
        "periodo": 202512,
        "valor": 6801973904.96,
        "delta": -84848173.91
      },
      {
        "periodo": 202601,
        "valor": 6770634538.48,
        "delta": -31339366.48
      },
      {
        "periodo": 202602,
        "valor": 6565001655.43,
        "delta": -205632883.05
      },
      {
        "periodo": 202603,
        "valor": 7025672874.58,
        "delta": 460671219.15
      },
      {
        "periodo": 202604,
        "valor": 6946399516.83,
        "delta": -79273357.75
      },
      {
        "periodo": 202605,
        "valor": 6982722161.29,
        "delta": 36322644.46
      },
      {
        "periodo": 202606,
        "valor": 7044801034.93,
        "delta": 62078873.64
      },
      {
        "periodo": 202607,
        "valor": 7190025496.97,
        "delta": 145224462.04
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 23474110010.76999,
    "valor_anterior": 22885311014.259995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22428552517.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 22377267501.53,
        "delta": -51285015.86
      },
      {
        "periodo": 202509,
        "valor": 21869396764.26,
        "delta": -507870737.27
      },
      {
        "periodo": 202510,
        "valor": 22694063677.71,
        "delta": 824666913.45
      },
      {
        "periodo": 202511,
        "valor": 22011185822.79,
        "delta": -682877854.92
      },
      {
        "periodo": 202512,
        "valor": 22490997422.32,
        "delta": 479811599.53
      },
      {
        "periodo": 202601,
        "valor": 22737500296.98,
        "delta": 246502874.66
      },
      {
        "periodo": 202602,
        "valor": 20995981079.7,
        "delta": -1741519217.28
      },
      {
        "periodo": 202603,
        "valor": 23264179444.81,
        "delta": 2268198365.11
      },
      {
        "periodo": 202604,
        "valor": 22752369914.57,
        "delta": -511809530.24
      },
      {
        "periodo": 202605,
        "valor": 23226317007.46,
        "delta": 473947092.89
      },
      {
        "periodo": 202606,
        "valor": 22885311014.26,
        "delta": -341005993.2
      },
      {
        "periodo": 202607,
        "valor": 23474110010.77,
        "delta": 588798996.51
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 10295293813.0,
    "valor_anterior": 9954573027.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10551678515.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10405202031.0,
        "delta": -146476484.0
      },
      {
        "periodo": 202509,
        "valor": 9995152546.0,
        "delta": -410049485.0
      },
      {
        "periodo": 202510,
        "valor": 10206295799.0,
        "delta": 211143253.0
      },
      {
        "periodo": 202511,
        "valor": 9919628620.0,
        "delta": -286667179.0
      },
      {
        "periodo": 202512,
        "valor": 10286285764.0,
        "delta": 366657144.0
      },
      {
        "periodo": 202601,
        "valor": 10300361143.0,
        "delta": 14075379.0
      },
      {
        "periodo": 202602,
        "valor": 9540490671.0,
        "delta": -759870472.0
      },
      {
        "periodo": 202603,
        "valor": 10053268628.0,
        "delta": 512777957.0
      },
      {
        "periodo": 202604,
        "valor": 10147781953.0,
        "delta": 94513325.0
      },
      {
        "periodo": 202605,
        "valor": 10241607212.0,
        "delta": 93825259.0
      },
      {
        "periodo": 202606,
        "valor": 9954573027.0,
        "delta": -287034185.0
      },
      {
        "periodo": 202607,
        "valor": 10295293813.0,
        "delta": 340720786.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 4412667998.0,
    "valor_anterior": 4306454100.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5325322070.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5220646554.0,
        "delta": -104675516.0
      },
      {
        "periodo": 202509,
        "valor": 5046806953.0,
        "delta": -173839601.0
      },
      {
        "periodo": 202510,
        "valor": 5099241072.0,
        "delta": 52434119.0
      },
      {
        "periodo": 202511,
        "valor": 4917452926.0,
        "delta": -181788146.0
      },
      {
        "periodo": 202512,
        "valor": 4942575297.0,
        "delta": 25122371.0
      },
      {
        "periodo": 202601,
        "valor": 4810939051.0,
        "delta": -131636246.0
      },
      {
        "periodo": 202602,
        "valor": 4495467822.0,
        "delta": -315471229.0
      },
      {
        "periodo": 202603,
        "valor": 4680415544.0,
        "delta": 184947722.0
      },
      {
        "periodo": 202604,
        "valor": 4491974478.0,
        "delta": -188441066.0
      },
      {
        "periodo": 202605,
        "valor": 4540542124.0,
        "delta": 48567646.0
      },
      {
        "periodo": 202606,
        "valor": 4306454100.0,
        "delta": -234088024.0
      },
      {
        "periodo": 202607,
        "valor": 4412667998.0,
        "delta": 106213898.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 2458214737.6600018,
    "valor_anterior": 2378016669.279997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2519915925.71,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2490574202.7,
        "delta": -29341723.01
      },
      {
        "periodo": 202509,
        "valor": 2409109048.35,
        "delta": -81465154.35
      },
      {
        "periodo": 202510,
        "valor": 2483136482.85,
        "delta": 74027434.5
      },
      {
        "periodo": 202511,
        "valor": 2382354386.33,
        "delta": -100782096.52
      },
      {
        "periodo": 202512,
        "valor": 2471528353.88,
        "delta": 89173967.55
      },
      {
        "periodo": 202601,
        "valor": 2430379755.47,
        "delta": -41148598.41
      },
      {
        "periodo": 202602,
        "valor": 2190867393.17,
        "delta": -239512362.3
      },
      {
        "periodo": 202603,
        "valor": 2452507600.08,
        "delta": 261640206.91
      },
      {
        "periodo": 202604,
        "valor": 2380378630.95,
        "delta": -72128969.13
      },
      {
        "periodo": 202605,
        "valor": 2452505860.02,
        "delta": 72127229.07
      },
      {
        "periodo": 202606,
        "valor": 2378016669.28,
        "delta": -74489190.74
      },
      {
        "periodo": 202607,
        "valor": 2458214737.66,
        "delta": 80198068.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 4282160733.0,
    "valor_anterior": 4113808270.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4526125443.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4416820957.0,
        "delta": -109304486.0
      },
      {
        "periodo": 202509,
        "valor": 4289888827.0,
        "delta": -126932130.0
      },
      {
        "periodo": 202510,
        "valor": 4474640777.0,
        "delta": 184751950.0
      },
      {
        "periodo": 202511,
        "valor": 4240332688.0,
        "delta": -234308089.0
      },
      {
        "periodo": 202512,
        "valor": 3904824672.0,
        "delta": -335508016.0
      },
      {
        "periodo": 202601,
        "valor": 4254938685.0,
        "delta": 350114013.0
      },
      {
        "periodo": 202602,
        "valor": 3828898854.0,
        "delta": -426039831.0
      },
      {
        "periodo": 202603,
        "valor": 4516546705.0,
        "delta": 687647851.0
      },
      {
        "periodo": 202604,
        "valor": 4140390389.0,
        "delta": -376156316.0
      },
      {
        "periodo": 202605,
        "valor": 4309832988.0,
        "delta": 169442599.0
      },
      {
        "periodo": 202606,
        "valor": 4113808270.0,
        "delta": -196024718.0
      },
      {
        "periodo": 202607,
        "valor": 4282160733.0,
        "delta": 168352463.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 1097543174.999999,
    "valor_anterior": 995408023.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 709384760.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 706362187.0,
        "delta": -3022573.0
      },
      {
        "periodo": 202509,
        "valor": 680288344.0,
        "delta": -26073843.0
      },
      {
        "periodo": 202510,
        "valor": 1004788383.0,
        "delta": 324500039.0
      },
      {
        "periodo": 202511,
        "valor": 1020496180.0,
        "delta": 15707797.0
      },
      {
        "periodo": 202512,
        "valor": 1510509882.0,
        "delta": 490013702.0
      },
      {
        "periodo": 202601,
        "valor": 771795313.0,
        "delta": -738714569.0
      },
      {
        "periodo": 202602,
        "valor": 1031353180.0,
        "delta": 259557867.0
      },
      {
        "periodo": 202603,
        "valor": 1123756855.0,
        "delta": 92403675.0
      },
      {
        "periodo": 202604,
        "valor": 1066015956.0,
        "delta": -57740899.0
      },
      {
        "periodo": 202605,
        "valor": 1144903836.0,
        "delta": 78887880.0
      },
      {
        "periodo": 202606,
        "valor": 995408023.0,
        "delta": -149495813.0
      },
      {
        "periodo": 202607,
        "valor": 1097543175.0,
        "delta": 102135152.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 4699096926.0,
    "valor_anterior": 4526627816.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4726950793.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4765181989.0,
        "delta": 38231196.0
      },
      {
        "periodo": 202509,
        "valor": 4621557660.0,
        "delta": -143624329.0
      },
      {
        "periodo": 202510,
        "valor": 4708059890.0,
        "delta": 86502230.0
      },
      {
        "periodo": 202511,
        "valor": 4568261875.0,
        "delta": -139798015.0
      },
      {
        "periodo": 202512,
        "valor": 4672309332.0,
        "delta": 104047457.0
      },
      {
        "periodo": 202601,
        "valor": 4676844410.0,
        "delta": 4535078.0
      },
      {
        "periodo": 202602,
        "valor": 4225188029.0,
        "delta": -451656381.0
      },
      {
        "periodo": 202603,
        "valor": 4609261117.0,
        "delta": 384073088.0
      },
      {
        "periodo": 202604,
        "valor": 4516432224.0,
        "delta": -92828893.0
      },
      {
        "periodo": 202605,
        "valor": 4619783163.0,
        "delta": 103350939.0
      },
      {
        "periodo": 202606,
        "valor": 4526627816.0,
        "delta": -93155347.0
      },
      {
        "periodo": 202607,
        "valor": 4699096926.0,
        "delta": 172469110.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 1719556225.5,
    "valor_anterior": 1662953918.1900005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1877543679.23,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1864648697.81,
        "delta": -12894981.42
      },
      {
        "periodo": 202509,
        "valor": 1808645696.1,
        "delta": -56003001.71
      },
      {
        "periodo": 202510,
        "valor": 1864114168.26,
        "delta": 55468472.16
      },
      {
        "periodo": 202511,
        "valor": 1781183903.33,
        "delta": -82930264.93
      },
      {
        "periodo": 202512,
        "valor": 1844146300.66,
        "delta": 62962397.33
      },
      {
        "periodo": 202601,
        "valor": 1822191366.46,
        "delta": -21954934.2
      },
      {
        "periodo": 202602,
        "valor": 1541134959.24,
        "delta": -281056407.22
      },
      {
        "periodo": 202603,
        "valor": 1703010558.75,
        "delta": 161875599.51
      },
      {
        "periodo": 202604,
        "valor": 1676192988.28,
        "delta": -26817570.47
      },
      {
        "periodo": 202605,
        "valor": 1717546475.69,
        "delta": 41353487.41
      },
      {
        "periodo": 202606,
        "valor": 1662953918.19,
        "delta": -54592557.5
      },
      {
        "periodo": 202607,
        "valor": 1719556225.5,
        "delta": 56602307.31
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 869836710.0000019,
    "valor_anterior": 870583524.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 772939578.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 720049703.0,
        "delta": -52889875.0
      },
      {
        "periodo": 202509,
        "valor": 796964550.0,
        "delta": 76914847.0
      },
      {
        "periodo": 202510,
        "valor": 797904942.0,
        "delta": 940392.0
      },
      {
        "periodo": 202511,
        "valor": 790467118.0,
        "delta": -7437824.0
      },
      {
        "periodo": 202512,
        "valor": 823830505.0,
        "delta": 33363387.0
      },
      {
        "periodo": 202601,
        "valor": 783448025.0,
        "delta": -40382480.0
      },
      {
        "periodo": 202602,
        "valor": 794731352.0,
        "delta": 11283327.0
      },
      {
        "periodo": 202603,
        "valor": 782352073.0,
        "delta": -12379279.0
      },
      {
        "periodo": 202604,
        "valor": 887574658.0,
        "delta": 105222585.0
      },
      {
        "periodo": 202605,
        "valor": 824342856.0,
        "delta": -63231802.0
      },
      {
        "periodo": 202606,
        "valor": 870583525.0,
        "delta": 46240669.0
      },
      {
        "periodo": 202607,
        "valor": 869836710.0,
        "delta": -746815.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 231211534.0,
    "valor_anterior": 241949248.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 287322614.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 285704670.0,
        "delta": -1617944.0
      },
      {
        "periodo": 202509,
        "valor": 305038348.0,
        "delta": 19333678.0
      },
      {
        "periodo": 202510,
        "valor": 285656564.0,
        "delta": -19381784.0
      },
      {
        "periodo": 202511,
        "valor": 261467475.0,
        "delta": -24189089.0
      },
      {
        "periodo": 202512,
        "valor": 305878048.0,
        "delta": 44410573.0
      },
      {
        "periodo": 202601,
        "valor": 269482736.0,
        "delta": -36395312.0
      },
      {
        "periodo": 202602,
        "valor": 252780632.0,
        "delta": -16702104.0
      },
      {
        "periodo": 202603,
        "valor": 259007130.0,
        "delta": 6226498.0
      },
      {
        "periodo": 202604,
        "valor": 243862006.0,
        "delta": -15145124.0
      },
      {
        "periodo": 202605,
        "valor": 246795440.0,
        "delta": 2933434.0
      },
      {
        "periodo": 202606,
        "valor": 241949248.0,
        "delta": -4846192.0
      },
      {
        "periodo": 202607,
        "valor": 231211534.0,
        "delta": -10737714.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 775286040.0,
    "valor_anterior": 747526138.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 798004466.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 797600048.0,
        "delta": -404418.0
      },
      {
        "periodo": 202509,
        "valor": 784885464.0,
        "delta": -12714584.0
      },
      {
        "periodo": 202510,
        "valor": 807914471.0,
        "delta": 23029007.0
      },
      {
        "periodo": 202511,
        "valor": 799328958.0,
        "delta": -8585513.0
      },
      {
        "periodo": 202512,
        "valor": 811549560.0,
        "delta": 12220602.0
      },
      {
        "periodo": 202601,
        "valor": 808169106.0,
        "delta": -3380454.0
      },
      {
        "periodo": 202602,
        "valor": 740030387.0,
        "delta": -68138719.0
      },
      {
        "periodo": 202603,
        "valor": 808568837.0,
        "delta": 68538450.0
      },
      {
        "periodo": 202604,
        "valor": 777870257.0,
        "delta": -30698580.0
      },
      {
        "periodo": 202605,
        "valor": 803955455.0,
        "delta": 26085198.0
      },
      {
        "periodo": 202606,
        "valor": 747526138.0,
        "delta": -56429317.0
      },
      {
        "periodo": 202607,
        "valor": 775286040.0,
        "delta": 27759902.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 12103280458.330002,
    "valor_anterior": 11924401161.050003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11810075374.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11876693027.61,
        "delta": 66617653.19
      },
      {
        "periodo": 202509,
        "valor": 11636394655.1,
        "delta": -240298372.51
      },
      {
        "periodo": 202510,
        "valor": 11829394123.25,
        "delta": 192999468.15
      },
      {
        "periodo": 202511,
        "valor": 11838722993.39,
        "delta": 9328870.14
      },
      {
        "periodo": 202512,
        "valor": 12096394781.08,
        "delta": 257671787.69
      },
      {
        "periodo": 202601,
        "valor": 12096568575.04,
        "delta": 173793.96
      },
      {
        "periodo": 202602,
        "valor": 11500126498.95,
        "delta": -596442076.09
      },
      {
        "periodo": 202603,
        "valor": 11922774619.44,
        "delta": 422648120.49
      },
      {
        "periodo": 202604,
        "valor": 11838097708.27,
        "delta": -84676911.17
      },
      {
        "periodo": 202605,
        "valor": 12075194665.13,
        "delta": 237096956.86
      },
      {
        "periodo": 202606,
        "valor": 11924401161.05,
        "delta": -150793504.08
      },
      {
        "periodo": 202607,
        "valor": 12103280458.33,
        "delta": 178879297.28
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 285776590.0,
    "valor_anterior": 276231834.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 312250342.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 311808082.0,
        "delta": -442260.0
      },
      {
        "periodo": 202509,
        "valor": 313237520.0,
        "delta": 1429438.0
      },
      {
        "periodo": 202510,
        "valor": 321159323.0,
        "delta": 7921803.0
      },
      {
        "periodo": 202511,
        "valor": 301063999.0,
        "delta": -20095324.0
      },
      {
        "periodo": 202512,
        "valor": 312913320.0,
        "delta": 11849321.0
      },
      {
        "periodo": 202601,
        "valor": 282951840.0,
        "delta": -29961480.0
      },
      {
        "periodo": 202602,
        "valor": 255390850.0,
        "delta": -27560990.0
      },
      {
        "periodo": 202603,
        "valor": 292343007.0,
        "delta": 36952157.0
      },
      {
        "periodo": 202604,
        "valor": 283933247.0,
        "delta": -8409760.0
      },
      {
        "periodo": 202605,
        "valor": 282717283.0,
        "delta": -1215964.0
      },
      {
        "periodo": 202606,
        "valor": 276231834.0,
        "delta": -6485449.0
      },
      {
        "periodo": 202607,
        "valor": 285776590.0,
        "delta": 9544756.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 41819000.0,
    "valor_anterior": 39109589.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 41238388.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 39682979.0,
        "delta": -1555409.0
      },
      {
        "periodo": 202509,
        "valor": 38222752.0,
        "delta": -1460227.0
      },
      {
        "periodo": 202510,
        "valor": 40093637.0,
        "delta": 1870885.0
      },
      {
        "periodo": 202511,
        "valor": 44754694.0,
        "delta": 4661057.0
      },
      {
        "periodo": 202512,
        "valor": 42054155.0,
        "delta": -2700539.0
      },
      {
        "periodo": 202601,
        "valor": 40419173.0,
        "delta": -1634982.0
      },
      {
        "periodo": 202602,
        "valor": 35391132.0,
        "delta": -5028041.0
      },
      {
        "periodo": 202603,
        "valor": 41713325.0,
        "delta": 6322193.0
      },
      {
        "periodo": 202604,
        "valor": 42220849.0,
        "delta": 507524.0
      },
      {
        "periodo": 202605,
        "valor": 44244251.0,
        "delta": 2023402.0
      },
      {
        "periodo": 202606,
        "valor": 39109589.0,
        "delta": -5134662.0
      },
      {
        "periodo": 202607,
        "valor": 41819000.0,
        "delta": 2709411.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 160874966.0,
    "valor_anterior": 155616832.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 190222033.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 175906771.0,
        "delta": -14315262.0
      },
      {
        "periodo": 202509,
        "valor": 142861200.0,
        "delta": -33045571.0
      },
      {
        "periodo": 202510,
        "valor": 158380533.0,
        "delta": 15519333.0
      },
      {
        "periodo": 202511,
        "valor": 143996080.0,
        "delta": -14384453.0
      },
      {
        "periodo": 202512,
        "valor": 150033700.0,
        "delta": 6037620.0
      },
      {
        "periodo": 202601,
        "valor": 151017642.0,
        "delta": 983942.0
      },
      {
        "periodo": 202602,
        "valor": 144223087.0,
        "delta": -6794555.0
      },
      {
        "periodo": 202603,
        "valor": 165934253.0,
        "delta": 21711166.0
      },
      {
        "periodo": 202604,
        "valor": 160482981.0,
        "delta": -5451272.0
      },
      {
        "periodo": 202605,
        "valor": 162874739.0,
        "delta": 2391758.0
      },
      {
        "periodo": 202606,
        "valor": 155616832.0,
        "delta": -7257907.0
      },
      {
        "periodo": 202607,
        "valor": 160874966.0,
        "delta": 5258134.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 402440498.02,
    "valor_anterior": 405743865.66999984,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 400184686.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 402486469.47,
        "delta": 2301783.08
      },
      {
        "periodo": 202509,
        "valor": 380951336.72,
        "delta": -21535132.75
      },
      {
        "periodo": 202510,
        "valor": 399073039.54,
        "delta": 18121702.82
      },
      {
        "periodo": 202511,
        "valor": 390112663.43,
        "delta": -8960376.11
      },
      {
        "periodo": 202512,
        "valor": 402591221.44,
        "delta": 12478558.01
      },
      {
        "periodo": 202601,
        "valor": 436581950.84,
        "delta": 33990729.4
      },
      {
        "periodo": 202602,
        "valor": 390218063.36,
        "delta": -46363887.48
      },
      {
        "periodo": 202603,
        "valor": 444788741.28,
        "delta": 54570677.92
      },
      {
        "periodo": 202604,
        "valor": 412840780.13,
        "delta": -31947961.15
      },
      {
        "periodo": 202605,
        "valor": 422440244.03,
        "delta": 9599463.9
      },
      {
        "periodo": 202606,
        "valor": 405743865.67,
        "delta": -16696378.36
      },
      {
        "periodo": 202607,
        "valor": 402440498.02,
        "delta": -3303367.65
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 557033038.0,
    "valor_anterior": 553515934.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 552786941.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 547965922.0,
        "delta": -4821019.0
      },
      {
        "periodo": 202509,
        "valor": 526035147.0,
        "delta": -21930775.0
      },
      {
        "periodo": 202510,
        "valor": 548549743.0,
        "delta": 22514596.0
      },
      {
        "periodo": 202511,
        "valor": 534026660.0,
        "delta": -14523083.0
      },
      {
        "periodo": 202512,
        "valor": 551287441.0,
        "delta": 17260781.0
      },
      {
        "periodo": 202601,
        "valor": 550372994.0,
        "delta": -914447.0
      },
      {
        "periodo": 202602,
        "valor": 523598527.0,
        "delta": -26774467.0
      },
      {
        "periodo": 202603,
        "valor": 571270997.0,
        "delta": 47672470.0
      },
      {
        "periodo": 202604,
        "valor": 549139700.0,
        "delta": -22131297.0
      },
      {
        "periodo": 202605,
        "valor": 558932514.0,
        "delta": 9792814.0
      },
      {
        "periodo": 202606,
        "valor": 553515934.0,
        "delta": -5416580.0
      },
      {
        "periodo": 202607,
        "valor": 557033038.0,
        "delta": 3517104.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 913548830.0100002,
    "valor_anterior": 803639650.5,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1264406644.28,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1170797027.36,
        "delta": -93609616.92
      },
      {
        "periodo": 202509,
        "valor": 1069974497.02,
        "delta": -100822530.34
      },
      {
        "periodo": 202510,
        "valor": 1088719637.27,
        "delta": 18745140.25
      },
      {
        "periodo": 202511,
        "valor": 953459675.3,
        "delta": -135259961.97
      },
      {
        "periodo": 202512,
        "valor": 1062705717.37,
        "delta": 109246042.07
      },
      {
        "periodo": 202601,
        "valor": 1002489615.05,
        "delta": -60216102.32
      },
      {
        "periodo": 202602,
        "valor": 837521607.8,
        "delta": -164968007.25
      },
      {
        "periodo": 202603,
        "valor": 941385054.61,
        "delta": 103863446.81
      },
      {
        "periodo": 202604,
        "valor": 878098248.6,
        "delta": -63286806.01
      },
      {
        "periodo": 202605,
        "valor": 882780573.72,
        "delta": 4682325.12
      },
      {
        "periodo": 202606,
        "valor": 803639650.5,
        "delta": -79140923.22
      },
      {
        "periodo": 202607,
        "valor": 913548830.01,
        "delta": 109909179.51
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 8461424032.440002,
    "valor_anterior": 8024068958.269997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8074944401.12,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8333848394.48,
        "delta": 258903993.36
      },
      {
        "periodo": 202509,
        "valor": 7999721621.28,
        "delta": -334126773.2
      },
      {
        "periodo": 202510,
        "valor": 8232569204.42,
        "delta": 232847583.14
      },
      {
        "periodo": 202511,
        "valor": 8194960687.02,
        "delta": -37608517.4
      },
      {
        "periodo": 202512,
        "valor": 8319705848.79,
        "delta": 124745161.77
      },
      {
        "periodo": 202601,
        "valor": 8391002120.41,
        "delta": 71296271.62
      },
      {
        "periodo": 202602,
        "valor": 7605267434.24,
        "delta": -785734686.17
      },
      {
        "periodo": 202603,
        "valor": 8372593559.12,
        "delta": 767326124.88
      },
      {
        "periodo": 202604,
        "valor": 8078993363.17,
        "delta": -293600195.95
      },
      {
        "periodo": 202605,
        "valor": 8240766898.57,
        "delta": 161773535.4
      },
      {
        "periodo": 202606,
        "valor": 8024068958.27,
        "delta": -216697940.3
      },
      {
        "periodo": 202607,
        "valor": 8461424032.44,
        "delta": 437355074.17
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 297524844.0,
    "valor_anterior": 264202754.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 122228175.49,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 171195731.17,
        "delta": 48967555.68
      },
      {
        "periodo": 202509,
        "valor": 224920198.81,
        "delta": 53724467.64
      },
      {
        "periodo": 202510,
        "valor": 241014788.0,
        "delta": 16094589.19
      },
      {
        "periodo": 202511,
        "valor": 235915340.0,
        "delta": -5099448.0
      },
      {
        "periodo": 202512,
        "valor": 247652702.0,
        "delta": 11737362.0
      },
      {
        "periodo": 202601,
        "valor": 257870295.0,
        "delta": 10217593.0
      },
      {
        "periodo": 202602,
        "valor": 241147851.0,
        "delta": -16722444.0
      },
      {
        "periodo": 202603,
        "valor": 277381365.0,
        "delta": 36233514.0
      },
      {
        "periodo": 202604,
        "valor": 298531601.0,
        "delta": 21150236.0
      },
      {
        "periodo": 202605,
        "valor": 291150904.0,
        "delta": -7380697.0
      },
      {
        "periodo": 202606,
        "valor": 264202754.0,
        "delta": -26948150.0
      },
      {
        "periodo": 202607,
        "valor": 297524844.0,
        "delta": 33322090.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 3262471219.0,
    "valor_anterior": 3088267252.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2973668469.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3110972411.0,
        "delta": 137303942.0
      },
      {
        "periodo": 202509,
        "valor": 2985027010.0,
        "delta": -125945401.0
      },
      {
        "periodo": 202510,
        "valor": 3031976758.0,
        "delta": 46949748.0
      },
      {
        "periodo": 202511,
        "valor": 3071254634.0,
        "delta": 39277876.0
      },
      {
        "periodo": 202512,
        "valor": 3207143212.0,
        "delta": 135888578.0
      },
      {
        "periodo": 202601,
        "valor": 3068663228.0,
        "delta": -138479984.0
      },
      {
        "periodo": 202602,
        "valor": 2887753436.0,
        "delta": -180909792.0
      },
      {
        "periodo": 202603,
        "valor": 3187319792.0,
        "delta": 299566356.0
      },
      {
        "periodo": 202604,
        "valor": 3142663349.0,
        "delta": -44656443.0
      },
      {
        "periodo": 202605,
        "valor": 3113855375.0,
        "delta": -28807974.0
      },
      {
        "periodo": 202606,
        "valor": 3088267252.0,
        "delta": -25588123.0
      },
      {
        "periodo": 202607,
        "valor": 3262471219.0,
        "delta": 174203967.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 1010323594.0000019,
    "valor_anterior": 957671373.9999981,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 806638003.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 816582087.0,
        "delta": 9944084.0
      },
      {
        "periodo": 202509,
        "valor": 798180803.0,
        "delta": -18401284.0
      },
      {
        "periodo": 202510,
        "valor": 862042406.0,
        "delta": 63861603.0
      },
      {
        "periodo": 202511,
        "valor": 826726328.0,
        "delta": -35316078.0
      },
      {
        "periodo": 202512,
        "valor": 890451379.0,
        "delta": 63725051.0
      },
      {
        "periodo": 202601,
        "valor": 917824551.0,
        "delta": 27373172.0
      },
      {
        "periodo": 202602,
        "valor": 852133884.0,
        "delta": -65690667.0
      },
      {
        "periodo": 202603,
        "valor": 974836825.0,
        "delta": 122702941.0
      },
      {
        "periodo": 202604,
        "valor": 953680177.0,
        "delta": -21156648.0
      },
      {
        "periodo": 202605,
        "valor": 971184830.0,
        "delta": 17504653.0
      },
      {
        "periodo": 202606,
        "valor": 957671374.0,
        "delta": -13513456.0
      },
      {
        "periodo": 202607,
        "valor": 1010323594.0,
        "delta": 52652220.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 244926276.0,
    "valor_anterior": 232808226.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 264343715.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 268761492.0,
        "delta": 4417777.0
      },
      {
        "periodo": 202509,
        "valor": 263015191.0,
        "delta": -5746301.0
      },
      {
        "periodo": 202510,
        "valor": 263681538.0,
        "delta": 666347.0
      },
      {
        "periodo": 202511,
        "valor": 245723274.0,
        "delta": -17958264.0
      },
      {
        "periodo": 202512,
        "valor": 260939602.0,
        "delta": 15216328.0
      },
      {
        "periodo": 202601,
        "valor": 260085120.0,
        "delta": -854482.0
      },
      {
        "periodo": 202602,
        "valor": 230862659.0,
        "delta": -29222461.0
      },
      {
        "periodo": 202603,
        "valor": 253780286.0,
        "delta": 22917627.0
      },
      {
        "periodo": 202604,
        "valor": 245576531.0,
        "delta": -8203755.0
      },
      {
        "periodo": 202605,
        "valor": 251811033.0,
        "delta": 6234502.0
      },
      {
        "periodo": 202606,
        "valor": 232808226.0,
        "delta": -19002807.0
      },
      {
        "periodo": 202607,
        "valor": 244926276.0,
        "delta": 12118050.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 265322.0,
    "valor_anterior": 339778.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 175806468.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 138448215.0,
        "delta": -37358253.0
      },
      {
        "periodo": 202509,
        "valor": 57541894.0,
        "delta": -80906321.0
      },
      {
        "periodo": 202510,
        "valor": 4474832.0,
        "delta": -53067062.0
      },
      {
        "periodo": 202511,
        "valor": 27819597.0,
        "delta": 23344765.0
      },
      {
        "periodo": 202512,
        "valor": 3577652.0,
        "delta": -24241945.0
      },
      {
        "periodo": 202601,
        "valor": 1539170.0,
        "delta": -2038482.0
      },
      {
        "periodo": 202602,
        "valor": 2953947.0,
        "delta": 1414777.0
      },
      {
        "periodo": 202603,
        "valor": 1018913.0,
        "delta": -1935034.0
      },
      {
        "periodo": 202604,
        "valor": 374441.0,
        "delta": -644472.0
      },
      {
        "periodo": 202605,
        "valor": 310178.0,
        "delta": -64263.0
      },
      {
        "periodo": 202606,
        "valor": 339778.0,
        "delta": 29600.0
      },
      {
        "periodo": 202607,
        "valor": 265322.0,
        "delta": -74456.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 1355195736.5100002,
    "valor_anterior": 1308158080.21,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1146162038.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1154378087.85,
        "delta": 8216049.43
      },
      {
        "periodo": 202509,
        "valor": 1178162007.72,
        "delta": 23783919.87
      },
      {
        "periodo": 202510,
        "valor": 1285256199.93,
        "delta": 107094192.21
      },
      {
        "periodo": 202511,
        "valor": 1405312966.07,
        "delta": 120056766.14
      },
      {
        "periodo": 202512,
        "valor": 1303430758.88,
        "delta": -101882207.19
      },
      {
        "periodo": 202601,
        "valor": 1290105346.21,
        "delta": -13325412.67
      },
      {
        "periodo": 202602,
        "valor": 1260705956.6,
        "delta": -29399389.61
      },
      {
        "periodo": 202603,
        "valor": 1335789523.39,
        "delta": 75083566.79
      },
      {
        "periodo": 202604,
        "valor": 1269817056.18,
        "delta": -65972467.21
      },
      {
        "periodo": 202605,
        "valor": 1321190873.23,
        "delta": 51373817.05
      },
      {
        "periodo": 202606,
        "valor": 1308158080.21,
        "delta": -13032793.02
      },
      {
        "periodo": 202607,
        "valor": 1355195736.51,
        "delta": 47037656.3
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 37657143.0,
    "valor_anterior": 36975916.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14762624.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16694643.0,
        "delta": 1932019.0
      },
      {
        "periodo": 202509,
        "valor": 17820993.0,
        "delta": 1126350.0
      },
      {
        "periodo": 202510,
        "valor": 20673131.0,
        "delta": 2852138.0
      },
      {
        "periodo": 202511,
        "valor": 21991139.0,
        "delta": 1318008.0
      },
      {
        "periodo": 202512,
        "valor": 23752345.0,
        "delta": 1761206.0
      },
      {
        "periodo": 202601,
        "valor": 25482965.0,
        "delta": 1730620.0
      },
      {
        "periodo": 202602,
        "valor": 24820121.0,
        "delta": -662844.0
      },
      {
        "periodo": 202603,
        "valor": 30158749.0,
        "delta": 5338628.0
      },
      {
        "periodo": 202604,
        "valor": 30317943.0,
        "delta": 159194.0
      },
      {
        "periodo": 202605,
        "valor": 34152256.0,
        "delta": 3834313.0
      },
      {
        "periodo": 202606,
        "valor": 36975916.0,
        "delta": 2823660.0
      },
      {
        "periodo": 202607,
        "valor": 37657143.0,
        "delta": 681227.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 2103307.0,
    "valor_anterior": 1880580.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1996477.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1943346.0,
        "delta": -53131.0
      },
      {
        "periodo": 202509,
        "valor": 1839472.0,
        "delta": -103874.0
      },
      {
        "periodo": 202510,
        "valor": 1833772.0,
        "delta": -5700.0
      },
      {
        "periodo": 202511,
        "valor": 5995807.0,
        "delta": 4162035.0
      },
      {
        "periodo": 202512,
        "valor": 1610570.0,
        "delta": -4385237.0
      },
      {
        "periodo": 202601,
        "valor": 1580350.0,
        "delta": -30220.0
      },
      {
        "periodo": 202602,
        "valor": 1419982.0,
        "delta": -160368.0
      },
      {
        "periodo": 202603,
        "valor": 1566278.0,
        "delta": 146296.0
      },
      {
        "periodo": 202604,
        "valor": 1485013.0,
        "delta": -81265.0
      },
      {
        "periodo": 202605,
        "valor": 1546480.0,
        "delta": 61467.0
      },
      {
        "periodo": 202606,
        "valor": 1880580.0,
        "delta": 334100.0
      },
      {
        "periodo": 202607,
        "valor": 2103307.0,
        "delta": 222727.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 826652980.0,
    "valor_anterior": 807771369.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 712246517.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 723639234.0,
        "delta": 11392717.0
      },
      {
        "periodo": 202509,
        "valor": 731285394.0,
        "delta": 7646160.0
      },
      {
        "periodo": 202510,
        "valor": 746870837.0,
        "delta": 15585443.0
      },
      {
        "periodo": 202511,
        "valor": 747557845.0,
        "delta": 687008.0
      },
      {
        "periodo": 202512,
        "valor": 757281452.0,
        "delta": 9723607.0
      },
      {
        "periodo": 202601,
        "valor": 769493780.0,
        "delta": 12212328.0
      },
      {
        "periodo": 202602,
        "valor": 746832941.0,
        "delta": -22660839.0
      },
      {
        "periodo": 202603,
        "valor": 772397362.0,
        "delta": 25564421.0
      },
      {
        "periodo": 202604,
        "valor": 796267238.0,
        "delta": 23869876.0
      },
      {
        "periodo": 202605,
        "valor": 803723293.0,
        "delta": 7456055.0
      },
      {
        "periodo": 202606,
        "valor": 807771369.0,
        "delta": 4048076.0
      },
      {
        "periodo": 202607,
        "valor": 826652980.0,
        "delta": 18881611.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 103527652.0,
    "valor_anterior": 104176658.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 94392934.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 98436825.0,
        "delta": 4043891.0
      },
      {
        "periodo": 202509,
        "valor": 99603195.0,
        "delta": 1166370.0
      },
      {
        "periodo": 202510,
        "valor": 99469261.0,
        "delta": -133934.0
      },
      {
        "periodo": 202511,
        "valor": 101143724.0,
        "delta": 1674463.0
      },
      {
        "periodo": 202512,
        "valor": 23817233.0,
        "delta": -77326491.0
      },
      {
        "periodo": 202601,
        "valor": 99242852.0,
        "delta": 75425619.0
      },
      {
        "periodo": 202602,
        "valor": 103074780.0,
        "delta": 3831928.0
      },
      {
        "periodo": 202603,
        "valor": 102961658.0,
        "delta": -113122.0
      },
      {
        "periodo": 202604,
        "valor": 103380689.0,
        "delta": 419031.0
      },
      {
        "periodo": 202605,
        "valor": 104480541.0,
        "delta": 1099852.0
      },
      {
        "periodo": 202606,
        "valor": 104176658.0,
        "delta": -303883.0
      },
      {
        "periodo": 202607,
        "valor": 103527652.0,
        "delta": -649006.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 177936798.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 71705569.0,
        "delta": -106231229.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 79921609.0,
    "valor_anterior": 76536027.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 90447916.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 87712613.0,
        "delta": -2735303.0
      },
      {
        "periodo": 202509,
        "valor": 84049538.0,
        "delta": -3663075.0
      },
      {
        "periodo": 202510,
        "valor": 84346311.0,
        "delta": 296773.0
      },
      {
        "periodo": 202511,
        "valor": 78997215.0,
        "delta": -5349096.0
      },
      {
        "periodo": 202512,
        "valor": 81868343.0,
        "delta": 2871128.0
      },
      {
        "periodo": 202601,
        "valor": 78569585.0,
        "delta": -3298758.0
      },
      {
        "periodo": 202602,
        "valor": 71571357.0,
        "delta": -6998228.0
      },
      {
        "periodo": 202603,
        "valor": 79871235.0,
        "delta": 8299878.0
      },
      {
        "periodo": 202604,
        "valor": 76036808.0,
        "delta": -3834427.0
      },
      {
        "periodo": 202605,
        "valor": 79374789.0,
        "delta": 3337981.0
      },
      {
        "periodo": 202606,
        "valor": 76536027.0,
        "delta": -2838762.0
      },
      {
        "periodo": 202607,
        "valor": 79921609.0,
        "delta": 3385582.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 249934898.0,
    "valor_anterior": 223315172.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 168801984.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 172804256.0,
        "delta": 4002272.0
      },
      {
        "periodo": 202509,
        "valor": 168527275.0,
        "delta": -4276981.0
      },
      {
        "periodo": 202510,
        "valor": 185570900.0,
        "delta": 17043625.0
      },
      {
        "periodo": 202511,
        "valor": 187114291.0,
        "delta": 1543391.0
      },
      {
        "periodo": 202512,
        "valor": 201717615.0,
        "delta": 14603324.0
      },
      {
        "periodo": 202601,
        "valor": 206057025.0,
        "delta": 4339410.0
      },
      {
        "periodo": 202602,
        "valor": 193359082.0,
        "delta": -12697943.0
      },
      {
        "periodo": 202603,
        "valor": 223470904.0,
        "delta": 30111822.0
      },
      {
        "periodo": 202604,
        "valor": 227292650.0,
        "delta": 3821746.0
      },
      {
        "periodo": 202605,
        "valor": 236000530.0,
        "delta": 8707880.0
      },
      {
        "periodo": 202606,
        "valor": 223315172.0,
        "delta": -12685358.0
      },
      {
        "periodo": 202607,
        "valor": 249934898.0,
        "delta": 26619726.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 31112081.0,
    "valor_anterior": 30177142.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22297068.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24437430.0,
        "delta": 2140362.0
      },
      {
        "periodo": 202509,
        "valor": 26041303.0,
        "delta": 1603873.0
      },
      {
        "periodo": 202510,
        "valor": 29062191.0,
        "delta": 3020888.0
      },
      {
        "periodo": 202511,
        "valor": 29735227.0,
        "delta": 673036.0
      },
      {
        "periodo": 202512,
        "valor": 31961749.0,
        "delta": 2226522.0
      },
      {
        "periodo": 202601,
        "valor": 31940963.0,
        "delta": -20786.0
      },
      {
        "periodo": 202602,
        "valor": 28888282.0,
        "delta": -3052681.0
      },
      {
        "periodo": 202603,
        "valor": 30809751.0,
        "delta": 1921469.0
      },
      {
        "periodo": 202604,
        "valor": 32272974.0,
        "delta": 1463223.0
      },
      {
        "periodo": 202605,
        "valor": 31539785.0,
        "delta": -733189.0
      },
      {
        "periodo": 202606,
        "valor": 30177142.0,
        "delta": -1362643.0
      },
      {
        "periodo": 202607,
        "valor": 31112081.0,
        "delta": 934939.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 139605016.49,
    "valor_anterior": 134062121.07999992,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 142001819.94,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 139096498.32,
        "delta": -2905321.62
      },
      {
        "periodo": 202509,
        "valor": 133181257.73,
        "delta": -5915240.59
      },
      {
        "periodo": 202510,
        "valor": 139108983.3,
        "delta": 5927725.57
      },
      {
        "periodo": 202511,
        "valor": 132233330.83,
        "delta": -6875652.47
      },
      {
        "periodo": 202512,
        "valor": 138730360.09,
        "delta": 6497029.26
      },
      {
        "periodo": 202601,
        "valor": 139168853.24,
        "delta": 438493.15
      },
      {
        "periodo": 202602,
        "valor": 124647616.61,
        "delta": -14521236.63
      },
      {
        "periodo": 202603,
        "valor": 139124680.81,
        "delta": 14477064.2
      },
      {
        "periodo": 202604,
        "valor": 133830861.27,
        "delta": -5293819.54
      },
      {
        "periodo": 202605,
        "valor": 137033437.66,
        "delta": 3202576.39
      },
      {
        "periodo": 202606,
        "valor": 134062121.08,
        "delta": -2971316.58
      },
      {
        "periodo": 202607,
        "valor": 139605016.49,
        "delta": 5542895.41
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 11385866.0,
    "valor_anterior": 11162824.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17796392.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16474174.0,
        "delta": -1322218.0
      },
      {
        "periodo": 202509,
        "valor": 16568725.0,
        "delta": 94551.0
      },
      {
        "periodo": 202510,
        "valor": 15476679.0,
        "delta": -1092046.0
      },
      {
        "periodo": 202511,
        "valor": 14679573.0,
        "delta": -797106.0
      },
      {
        "periodo": 202512,
        "valor": 14877673.0,
        "delta": 198100.0
      },
      {
        "periodo": 202601,
        "valor": 13883139.0,
        "delta": -994534.0
      },
      {
        "periodo": 202602,
        "valor": 12128962.0,
        "delta": -1754177.0
      },
      {
        "periodo": 202603,
        "valor": 13323460.0,
        "delta": 1194498.0
      },
      {
        "periodo": 202604,
        "valor": 12903131.0,
        "delta": -420329.0
      },
      {
        "periodo": 202605,
        "valor": 12125500.0,
        "delta": -777631.0
      },
      {
        "periodo": 202606,
        "valor": 11162824.0,
        "delta": -962676.0
      },
      {
        "periodo": 202607,
        "valor": 11385866.0,
        "delta": 223042.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 469792875.0699997,
    "valor_anterior": 454976441.0100002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 471914774.45,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 473453011.32,
        "delta": 1538236.87
      },
      {
        "periodo": 202509,
        "valor": 451026189.16,
        "delta": -22426822.16
      },
      {
        "periodo": 202510,
        "valor": 483074733.13,
        "delta": 32048543.97
      },
      {
        "periodo": 202511,
        "valor": 470780379.47,
        "delta": -12294353.66
      },
      {
        "periodo": 202512,
        "valor": 472929065.0,
        "delta": 2148685.53
      },
      {
        "periodo": 202601,
        "valor": 467459101.56,
        "delta": -5469963.44
      },
      {
        "periodo": 202602,
        "valor": 427280227.88,
        "delta": -40178873.68
      },
      {
        "periodo": 202603,
        "valor": 473036692.08,
        "delta": 45756464.2
      },
      {
        "periodo": 202604,
        "valor": 460217309.42,
        "delta": -12819382.66
      },
      {
        "periodo": 202605,
        "valor": 478954667.83,
        "delta": 18737358.41
      },
      {
        "periodo": 202606,
        "valor": 454976441.01,
        "delta": -23978226.82
      },
      {
        "periodo": 202607,
        "valor": 469792875.07,
        "delta": 14816434.06
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 119796109.28000009,
    "valor_anterior": 111714258.30999994,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 102173783.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 102928622.16,
        "delta": 754838.23
      },
      {
        "periodo": 202509,
        "valor": 99722615.61,
        "delta": -3206006.55
      },
      {
        "periodo": 202510,
        "valor": 107032376.26,
        "delta": 7309760.65
      },
      {
        "periodo": 202511,
        "valor": 105292225.53,
        "delta": -1740150.73
      },
      {
        "periodo": 202512,
        "valor": 109003848.14,
        "delta": 3711622.61
      },
      {
        "periodo": 202601,
        "valor": 108703721.29,
        "delta": -300126.85
      },
      {
        "periodo": 202602,
        "valor": 101304364.47,
        "delta": -7399356.82
      },
      {
        "periodo": 202603,
        "valor": 115112698.01,
        "delta": 13808333.54
      },
      {
        "periodo": 202604,
        "valor": 111199090.3,
        "delta": -3913607.71
      },
      {
        "periodo": 202605,
        "valor": 116919605.55,
        "delta": 5720515.25
      },
      {
        "periodo": 202606,
        "valor": 111714258.31,
        "delta": -5205347.24
      },
      {
        "periodo": 202607,
        "valor": 119796109.28,
        "delta": 8081850.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 32852521.0,
    "valor_anterior": 29684227.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 31829432.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 35545106.0,
        "delta": 3715674.0
      },
      {
        "periodo": 202509,
        "valor": 34052976.0,
        "delta": -1492130.0
      },
      {
        "periodo": 202510,
        "valor": 36472871.0,
        "delta": 2419895.0
      },
      {
        "periodo": 202511,
        "valor": 34819431.0,
        "delta": -1653440.0
      },
      {
        "periodo": 202512,
        "valor": 33325960.0,
        "delta": -1493471.0
      },
      {
        "periodo": 202601,
        "valor": 34793976.0,
        "delta": 1468016.0
      },
      {
        "periodo": 202602,
        "valor": 28437307.0,
        "delta": -6356669.0
      },
      {
        "periodo": 202603,
        "valor": 31896020.0,
        "delta": 3458713.0
      },
      {
        "periodo": 202604,
        "valor": 28913102.0,
        "delta": -2982918.0
      },
      {
        "periodo": 202605,
        "valor": 29770390.0,
        "delta": 857288.0
      },
      {
        "periodo": 202606,
        "valor": 29684227.0,
        "delta": -86163.0
      },
      {
        "periodo": 202607,
        "valor": 32852521.0,
        "delta": 3168294.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 742975364.0,
    "valor_anterior": 725952060.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 756385142.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 749455268.0,
        "delta": -6929874.0
      },
      {
        "periodo": 202509,
        "valor": 724090629.0,
        "delta": -25364639.0
      },
      {
        "periodo": 202510,
        "valor": 755219368.0,
        "delta": 31128739.0
      },
      {
        "periodo": 202511,
        "valor": 715596079.0,
        "delta": -39623289.0
      },
      {
        "periodo": 202512,
        "valor": 748207032.0,
        "delta": 32610953.0
      },
      {
        "periodo": 202601,
        "valor": 745952604.0,
        "delta": -2254428.0
      },
      {
        "periodo": 202602,
        "valor": 679992459.0,
        "delta": -65960145.0
      },
      {
        "periodo": 202603,
        "valor": 774632929.0,
        "delta": 94640470.0
      },
      {
        "periodo": 202604,
        "valor": 748086217.0,
        "delta": -26546712.0
      },
      {
        "periodo": 202605,
        "valor": 750673547.0,
        "delta": 2587330.0
      },
      {
        "periodo": 202606,
        "valor": 725952060.0,
        "delta": -24721487.0
      },
      {
        "periodo": 202607,
        "valor": 742975364.0,
        "delta": 17023304.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 20979374.0,
    "valor_anterior": 19177420.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 24815764.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25554489.0,
        "delta": 738725.0
      },
      {
        "periodo": 202509,
        "valor": 24001245.0,
        "delta": -1553244.0
      },
      {
        "periodo": 202510,
        "valor": 22554861.0,
        "delta": -1446384.0
      },
      {
        "periodo": 202511,
        "valor": 21283255.0,
        "delta": -1271606.0
      },
      {
        "periodo": 202512,
        "valor": 21389799.0,
        "delta": 106544.0
      },
      {
        "periodo": 202601,
        "valor": 20324359.0,
        "delta": -1065440.0
      },
      {
        "periodo": 202602,
        "valor": 17546471.0,
        "delta": -2777888.0
      },
      {
        "periodo": 202603,
        "valor": 19689917.0,
        "delta": 2143446.0
      },
      {
        "periodo": 202604,
        "valor": 18626045.0,
        "delta": -1063872.0
      },
      {
        "periodo": 202605,
        "valor": 19435575.0,
        "delta": 809530.0
      },
      {
        "periodo": 202606,
        "valor": 19177420.0,
        "delta": -258155.0
      },
      {
        "periodo": 202607,
        "valor": 20979374.0,
        "delta": 1801954.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 45289546.649999976,
    "valor_anterior": 44316142.07000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 46095340.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 48815339.89,
        "delta": 2719999.7
      },
      {
        "periodo": 202509,
        "valor": 45324532.92,
        "delta": -3490806.97
      },
      {
        "periodo": 202510,
        "valor": 46568847.64,
        "delta": 1244314.72
      },
      {
        "periodo": 202511,
        "valor": 39356536.03,
        "delta": -7212311.61
      },
      {
        "periodo": 202512,
        "valor": 18734471.32,
        "delta": -20622064.71
      },
      {
        "periodo": 202601,
        "valor": 18415930.43,
        "delta": -318540.89
      },
      {
        "periodo": 202602,
        "valor": 17224220.94,
        "delta": -1191709.49
      },
      {
        "periodo": 202603,
        "valor": 20092694.29,
        "delta": 2868473.35
      },
      {
        "periodo": 202604,
        "valor": 38652555.83,
        "delta": 18559861.54
      },
      {
        "periodo": 202605,
        "valor": 46279246.43,
        "delta": 7626690.6
      },
      {
        "periodo": 202606,
        "valor": 44316142.07,
        "delta": -1963104.36
      },
      {
        "periodo": 202607,
        "valor": 45289546.65,
        "delta": 973404.58
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 27537509.929999992,
    "valor_anterior": 23982451.820000008,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26527180.78,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24599060.01,
        "delta": -1928120.77
      },
      {
        "periodo": 202509,
        "valor": 18014631.39,
        "delta": -6584428.62
      },
      {
        "periodo": 202510,
        "valor": 19518100.19,
        "delta": 1503468.8
      },
      {
        "periodo": 202511,
        "valor": 19226734.88,
        "delta": -291365.31
      },
      {
        "periodo": 202512,
        "valor": 19147310.61,
        "delta": -79424.27
      },
      {
        "periodo": 202601,
        "valor": 18457221.68,
        "delta": -690088.93
      },
      {
        "periodo": 202602,
        "valor": 18095784.42,
        "delta": -361437.26
      },
      {
        "periodo": 202603,
        "valor": 21291307.7,
        "delta": 3195523.28
      },
      {
        "periodo": 202604,
        "valor": 21840538.27,
        "delta": 549230.57
      },
      {
        "periodo": 202605,
        "valor": 23817183.75,
        "delta": 1976645.48
      },
      {
        "periodo": 202606,
        "valor": 23982451.82,
        "delta": 165268.07
      },
      {
        "periodo": 202607,
        "valor": 27537509.93,
        "delta": 3555058.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 695225.0,
    "valor_anterior": 1032586.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 552006.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1160706.0,
        "delta": 608700.0
      },
      {
        "periodo": 202509,
        "valor": 2198603.0,
        "delta": 1037897.0
      },
      {
        "periodo": 202510,
        "valor": 727957.0,
        "delta": -1470646.0
      },
      {
        "periodo": 202511,
        "valor": 1806886.0,
        "delta": 1078929.0
      },
      {
        "periodo": 202512,
        "valor": 903651.0,
        "delta": -903235.0
      },
      {
        "periodo": 202601,
        "valor": 728246.0,
        "delta": -175405.0
      },
      {
        "periodo": 202602,
        "valor": 977785.0,
        "delta": 249539.0
      },
      {
        "periodo": 202603,
        "valor": 513788.0,
        "delta": -463997.0
      },
      {
        "periodo": 202604,
        "valor": 1182970.0,
        "delta": 669182.0
      },
      {
        "periodo": 202605,
        "valor": 1041975.0,
        "delta": -140995.0
      },
      {
        "periodo": 202606,
        "valor": 1032586.0,
        "delta": -9389.0
      },
      {
        "periodo": 202607,
        "valor": 695225.0,
        "delta": -337361.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 16358634.0,
    "valor_anterior": 15744321.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19762677.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19170695.0,
        "delta": -591982.0
      },
      {
        "periodo": 202509,
        "valor": 17739866.0,
        "delta": -1430829.0
      },
      {
        "periodo": 202510,
        "valor": 18548764.0,
        "delta": 808898.0
      },
      {
        "periodo": 202511,
        "valor": 17358505.0,
        "delta": -1190259.0
      },
      {
        "periodo": 202512,
        "valor": 17014466.0,
        "delta": -344039.0
      },
      {
        "periodo": 202601,
        "valor": 16207719.0,
        "delta": -806747.0
      },
      {
        "periodo": 202602,
        "valor": 14473928.0,
        "delta": -1733791.0
      },
      {
        "periodo": 202603,
        "valor": 17137407.0,
        "delta": 2663479.0
      },
      {
        "periodo": 202604,
        "valor": 15095902.0,
        "delta": -2041505.0
      },
      {
        "periodo": 202605,
        "valor": 15705301.0,
        "delta": 609399.0
      },
      {
        "periodo": 202606,
        "valor": 15744321.0,
        "delta": 39020.0
      },
      {
        "periodo": 202607,
        "valor": 16358634.0,
        "delta": 614313.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 6031.9100000000035,
    "valor_anterior": 8118.779999999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 285632.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 190820.41,
        "delta": -94812.12
      },
      {
        "periodo": 202509,
        "valor": 125859.21,
        "delta": -64961.2
      },
      {
        "periodo": 202510,
        "valor": 91158.34,
        "delta": -34700.87
      },
      {
        "periodo": 202511,
        "valor": 64145.36,
        "delta": -27012.98
      },
      {
        "periodo": 202512,
        "valor": 47321.31,
        "delta": -16824.05
      },
      {
        "periodo": 202601,
        "valor": 33087.32,
        "delta": -14233.99
      },
      {
        "periodo": 202602,
        "valor": 21708.19,
        "delta": -11379.13
      },
      {
        "periodo": 202603,
        "valor": 17963.25,
        "delta": -3744.94
      },
      {
        "periodo": 202604,
        "valor": 12883.97,
        "delta": -5079.28
      },
      {
        "periodo": 202605,
        "valor": 10248.38,
        "delta": -2635.59
      },
      {
        "periodo": 202606,
        "valor": 8118.78,
        "delta": -2129.6
      },
      {
        "periodo": 202607,
        "valor": 6031.91,
        "delta": -2086.87
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 146879878.06999993,
    "valor_anterior": 143515564.37,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 131597912.83,
        "delta": 131597912.83
      },
      {
        "periodo": 202603,
        "valor": 144277518.63,
        "delta": 12679605.8
      },
      {
        "periodo": 202604,
        "valor": 142841719.06,
        "delta": -1435799.57
      },
      {
        "periodo": 202605,
        "valor": 145584806.31,
        "delta": 2743087.25
      },
      {
        "periodo": 202606,
        "valor": 143515564.37,
        "delta": -2069241.94
      },
      {
        "periodo": 202607,
        "valor": 146879878.07,
        "delta": 3364313.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 9878573.0,
    "valor_anterior": 9133968.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1466061.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2458710.0,
        "delta": 992649.0
      },
      {
        "periodo": 202509,
        "valor": 3842094.0,
        "delta": 1383384.0
      },
      {
        "periodo": 202510,
        "valor": 4653795.0,
        "delta": 811701.0
      },
      {
        "periodo": 202511,
        "valor": 4274424.0,
        "delta": -379371.0
      },
      {
        "periodo": 202512,
        "valor": 4530200.0,
        "delta": 255776.0
      },
      {
        "periodo": 202601,
        "valor": 5090838.0,
        "delta": 560638.0
      },
      {
        "periodo": 202602,
        "valor": 6753955.0,
        "delta": 1663117.0
      },
      {
        "periodo": 202603,
        "valor": 8475073.0,
        "delta": 1721118.0
      },
      {
        "periodo": 202604,
        "valor": 8247592.0,
        "delta": -227481.0
      },
      {
        "periodo": 202605,
        "valor": 9025083.0,
        "delta": 777491.0
      },
      {
        "periodo": 202606,
        "valor": 9133968.0,
        "delta": 108885.0
      },
      {
        "periodo": 202607,
        "valor": 9878573.0,
        "delta": 744605.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 1779126.8499999999,
    "valor_anterior": 1034107.36,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 15974.7,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 4039.93,
        "delta": -11934.77
      },
      {
        "periodo": 202601,
        "valor": 10361.29,
        "delta": 6321.36
      },
      {
        "periodo": 202602,
        "valor": 25856.63,
        "delta": 15495.34
      },
      {
        "periodo": 202603,
        "valor": 75073.33,
        "delta": 49216.7
      },
      {
        "periodo": 202604,
        "valor": 217129.73,
        "delta": 142056.4
      },
      {
        "periodo": 202605,
        "valor": 533959.34,
        "delta": 316829.61
      },
      {
        "periodo": 202606,
        "valor": 1034107.36,
        "delta": 500148.02
      },
      {
        "periodo": 202607,
        "valor": 1779126.85,
        "delta": 745019.49
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 564692695.0,
    "valor_anterior": 512196249.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 1206908210.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 454137223.0,
        "delta": -752770987.0
      },
      {
        "periodo": 202605,
        "valor": 493992982.0,
        "delta": 39855759.0
      },
      {
        "periodo": 202606,
        "valor": 512196249.0,
        "delta": 18203267.0
      },
      {
        "periodo": 202607,
        "valor": 564692695.0,
        "delta": 52496446.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 94283321820.45984,
    "valor_anterior": 91280313796.15997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 92227502394.34,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 92060198883.87,
        "delta": -167303510.47
      },
      {
        "periodo": 202509,
        "valor": 88370152168.39,
        "delta": -3690046715.48
      },
      {
        "periodo": 202510,
        "valor": 92472979306.46,
        "delta": 4102827138.0699
      },
      {
        "periodo": 202511,
        "valor": 90542154350.3301,
        "delta": -1930824956.1299
      },
      {
        "periodo": 202512,
        "valor": 92438145036.7799,
        "delta": 1895990686.4498
      },
      {
        "periodo": 202601,
        "valor": 91985772724.75,
        "delta": -452372312.0299
      },
      {
        "periodo": 202602,
        "valor": 85719696052.46,
        "delta": -6266076672.29
      },
      {
        "periodo": 202603,
        "valor": 94288318997.16,
        "delta": 8568622944.7
      },
      {
        "periodo": 202604,
        "valor": 91644750588.83,
        "delta": -2643568408.33
      },
      {
        "periodo": 202605,
        "valor": 93302030122.39,
        "delta": 1657279533.56
      },
      {
        "periodo": 202606,
        "valor": 91280313796.16,
        "delta": -2021716326.23
      },
      {
        "periodo": 202607,
        "valor": 94283321820.4598,
        "delta": 3003008024.2999
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 66456635436.07001,
    "valor_anterior": 64755976423.23999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 66013022742.88,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 65716149289.92,
        "delta": -296873452.96
      },
      {
        "periodo": 202509,
        "valor": 64167837156.3701,
        "delta": -1548312133.5499
      },
      {
        "periodo": 202510,
        "valor": 65935597759.3301,
        "delta": 1767760602.96
      },
      {
        "periodo": 202511,
        "valor": 64382407004.0499,
        "delta": -1553190755.2802
      },
      {
        "periodo": 202512,
        "valor": 65195361173.36,
        "delta": 812954169.3101
      },
      {
        "periodo": 202601,
        "valor": 65647786699.5,
        "delta": 452425526.14
      },
      {
        "periodo": 202602,
        "valor": 61151154610.08,
        "delta": -4496632089.42
      },
      {
        "periodo": 202603,
        "valor": 66072118932.83,
        "delta": 4920964322.75
      },
      {
        "periodo": 202604,
        "valor": 64833446183.67,
        "delta": -1238672749.16
      },
      {
        "periodo": 202605,
        "valor": 65995999320.88,
        "delta": 1162553137.21
      },
      {
        "periodo": 202606,
        "valor": 64755976423.24,
        "delta": -1240022897.64
      },
      {
        "periodo": 202607,
        "valor": 66456635436.07,
        "delta": 1700659012.83
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 482627429.02,
    "valor_anterior": 482619670.6700001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 844375868.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 700352866.47,
        "delta": -144023001.92
      },
      {
        "periodo": 202509,
        "valor": -736981242.28,
        "delta": -1437334108.75
      },
      {
        "periodo": 202510,
        "valor": 487894182.54,
        "delta": 1224875424.82
      },
      {
        "periodo": 202511,
        "valor": 496929475.43,
        "delta": 9035292.89
      },
      {
        "periodo": 202512,
        "valor": 488037216.44,
        "delta": -8892258.99
      },
      {
        "periodo": 202601,
        "valor": 516690705.84,
        "delta": 28653489.4
      },
      {
        "periodo": 202602,
        "valor": 464743367.36,
        "delta": -51947338.48
      },
      {
        "periodo": 202603,
        "valor": 525678889.28,
        "delta": 60935521.92
      },
      {
        "periodo": 202604,
        "valor": 489252029.13,
        "delta": -36426860.15
      },
      {
        "periodo": 202605,
        "valor": 502125211.03,
        "delta": 12873181.9
      },
      {
        "periodo": 202606,
        "valor": 482619670.67,
        "delta": -19505540.36
      },
      {
        "periodo": 202607,
        "valor": 482627429.02,
        "delta": 7758.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 3049940668.010002,
    "valor_anterior": 2895620734.499998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3381609934.28,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3218948662.36,
        "delta": -162661271.92
      },
      {
        "periodo": 202509,
        "valor": 3150184058.02,
        "delta": -68764604.34
      },
      {
        "periodo": 202510,
        "valor": 3216734272.27,
        "delta": 66550214.25
      },
      {
        "periodo": 202511,
        "valor": 3040873217.3,
        "delta": -175861054.97
      },
      {
        "periodo": 202512,
        "valor": 3205601178.37,
        "delta": 164727961.07
      },
      {
        "periodo": 202601,
        "valor": 3070803997.05,
        "delta": -134797181.32
      },
      {
        "periodo": 202602,
        "valor": 2809686182.8,
        "delta": -261117814.25
      },
      {
        "periodo": 202603,
        "valor": 3034376615.61,
        "delta": 224690432.81
      },
      {
        "periodo": 202604,
        "valor": 3032848223.6,
        "delta": -1528392.01
      },
      {
        "periodo": 202605,
        "valor": 3003503612.72,
        "delta": -29344610.88
      },
      {
        "periodo": 202606,
        "valor": 2895620734.5,
        "delta": -107882878.22
      },
      {
        "periodo": 202607,
        "valor": 3049940668.01,
        "delta": 154319933.51
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 7585646134.159996,
    "valor_anterior": 7273517978.470001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7222654450.94,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7175588364.51,
        "delta": -47066086.43
      },
      {
        "periodo": 202509,
        "valor": 6946349667.45,
        "delta": -229238697.06
      },
      {
        "periodo": 202510,
        "valor": 7517850551.11,
        "delta": 571500883.66
      },
      {
        "periodo": 202511,
        "valor": 7260383536.66,
        "delta": -257467014.45
      },
      {
        "periodo": 202512,
        "valor": 8016130388.54,
        "delta": 755746851.88
      },
      {
        "periodo": 202601,
        "valor": 7238516583.93,
        "delta": -777613804.61
      },
      {
        "periodo": 202602,
        "valor": 6819080402.41,
        "delta": -419436181.52
      },
      {
        "periodo": 202603,
        "valor": 7600015764.83,
        "delta": 780935362.42
      },
      {
        "periodo": 202604,
        "valor": 7373493669.23,
        "delta": -226522095.6
      },
      {
        "periodo": 202605,
        "valor": 7595747062.71,
        "delta": 222253393.48
      },
      {
        "periodo": 202606,
        "valor": 7273517978.47,
        "delta": -322229084.24
      },
      {
        "periodo": 202607,
        "valor": 7585646134.16,
        "delta": 312128155.69
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 1944852147.42,
    "valor_anterior": 1844071522.290001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1740376276.78,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1800797787.87,
        "delta": 60421511.09
      },
      {
        "periodo": 202509,
        "valor": 1818954044.62,
        "delta": 18156256.75
      },
      {
        "periodo": 202510,
        "valor": 1884953136.52,
        "delta": 65999091.9
      },
      {
        "periodo": 202511,
        "valor": 1807241489.74,
        "delta": -77711646.78
      },
      {
        "periodo": 202512,
        "valor": 1885093265.16,
        "delta": 77851775.42
      },
      {
        "periodo": 202601,
        "valor": 1856392162.2,
        "delta": -28701102.96
      },
      {
        "periodo": 202602,
        "valor": 1704109227.32,
        "delta": -152282934.88
      },
      {
        "periodo": 202603,
        "valor": 1894503310.89,
        "delta": 190394083.57
      },
      {
        "periodo": 202604,
        "valor": 1886859266.09,
        "delta": -7644044.8
      },
      {
        "periodo": 202605,
        "valor": 1939951070.22,
        "delta": 53091804.13
      },
      {
        "periodo": 202606,
        "valor": 1844071522.29,
        "delta": -95879547.93
      },
      {
        "periodo": 202607,
        "valor": 1944852147.42,
        "delta": 100780625.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100441,
    "label": "Intereses de Cartera Etapa 1+2",
    "valor_actual": 14763620005.779999,
    "valor_anterior": 14028507466.98999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13025463121.07,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13448361912.74,
        "delta": 422898791.67
      },
      {
        "periodo": 202509,
        "valor": 13023808484.21,
        "delta": -424553428.53
      },
      {
        "periodo": 202510,
        "valor": 13429949404.69,
        "delta": 406140920.48
      },
      {
        "periodo": 202511,
        "valor": 13554319627.15,
        "delta": 124370222.46
      },
      {
        "periodo": 202512,
        "valor": 13647921814.91,
        "delta": 93602187.76
      },
      {
        "periodo": 202601,
        "valor": 13655582576.23,
        "delta": 7660761.32
      },
      {
        "periodo": 202602,
        "valor": 12770922262.49,
        "delta": -884660313.74
      },
      {
        "periodo": 202603,
        "valor": 15161625483.72,
        "delta": 2390703221.23
      },
      {
        "periodo": 202604,
        "valor": 14028851217.11,
        "delta": -1132774266.61
      },
      {
        "periodo": 202605,
        "valor": 14264703844.83,
        "delta": 235852627.72
      },
      {
        "periodo": 202606,
        "valor": 14028507466.99,
        "delta": -236196377.84
      },
      {
        "periodo": 202607,
        "valor": 14763620005.78,
        "delta": 735112538.79
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 1438827009.000001,
    "valor_anterior": 1152586431.9999995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 539486561.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 509603307.44,
        "delta": -29883253.56
      },
      {
        "periodo": 202509,
        "valor": 993423226.27,
        "delta": 483819918.83
      },
      {
        "periodo": 202510,
        "valor": 330853815.0,
        "delta": -662569411.27
      },
      {
        "periodo": 202511,
        "valor": 755401058.0,
        "delta": 424547243.0
      },
      {
        "periodo": 202512,
        "valor": 1013917451.0,
        "delta": 258516393.0
      },
      {
        "periodo": 202601,
        "valor": 588072236.0,
        "delta": -425845215.0
      },
      {
        "periodo": 202602,
        "valor": 701680955.0,
        "delta": 113608719.0
      },
      {
        "periodo": 202603,
        "valor": 1520409526.03,
        "delta": 818728571.03
      },
      {
        "periodo": 202604,
        "valor": 447439441.0,
        "delta": -1072970085.03
      },
      {
        "periodo": 202605,
        "valor": 654135069.0,
        "delta": 206695628.0
      },
      {
        "periodo": 202606,
        "valor": 1152586432.0,
        "delta": 498451363.0
      },
      {
        "periodo": 202607,
        "valor": 1438827009.0,
        "delta": 286240577.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 3339064428.4000015,
    "valor_anterior": 3190859295.7199974,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3257018150.17,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3359745999.99,
        "delta": 102727849.82
      },
      {
        "periodo": 202509,
        "valor": 3219746401.82,
        "delta": -139999598.17
      },
      {
        "periodo": 202510,
        "valor": 3465808598.23,
        "delta": 246062196.41
      },
      {
        "periodo": 202511,
        "valor": 3611856548.03,
        "delta": 146047949.8
      },
      {
        "periodo": 202512,
        "valor": 2946774909.25,
        "delta": -665081638.78
      },
      {
        "periodo": 202601,
        "valor": 3638013614.03,
        "delta": 691238704.78
      },
      {
        "periodo": 202602,
        "valor": 2311207078.98,
        "delta": -1326806535.05
      },
      {
        "periodo": 202603,
        "valor": 3790224813.14,
        "delta": 1479017734.16
      },
      {
        "periodo": 202604,
        "valor": 3306611469.7,
        "delta": -483613343.44
      },
      {
        "periodo": 202605,
        "valor": 3135763719.35,
        "delta": -170847750.35
      },
      {
        "periodo": 202606,
        "valor": 3190859295.72,
        "delta": 55095576.37
      },
      {
        "periodo": 202607,
        "valor": 3339064428.4,
        "delta": 148205132.68
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 1213688521.0,
    "valor_anterior": 1574464177.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1127281034.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1077891492.0,
        "delta": -49389542.0
      },
      {
        "periodo": 202509,
        "valor": 914621851.0,
        "delta": -163269641.0
      },
      {
        "periodo": 202510,
        "valor": 1071527788.0,
        "delta": 156905937.0
      },
      {
        "periodo": 202511,
        "valor": 799275450.0,
        "delta": -272252338.0
      },
      {
        "periodo": 202512,
        "valor": 1355379290.0,
        "delta": 556103840.0
      },
      {
        "periodo": 202601,
        "valor": 1501165611.0,
        "delta": 145786321.0
      },
      {
        "periodo": 202602,
        "valor": 943789640.0,
        "delta": -557375971.0
      },
      {
        "periodo": 202603,
        "valor": 2012654261.0,
        "delta": 1068864621.0
      },
      {
        "periodo": 202604,
        "valor": 1353861165.0,
        "delta": -658793096.0
      },
      {
        "periodo": 202605,
        "valor": 706877092.0,
        "delta": -646984073.0
      },
      {
        "periodo": 202606,
        "valor": 1574464177.0,
        "delta": 867587085.0
      },
      {
        "periodo": 202607,
        "valor": 1213688521.0,
        "delta": -360775656.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 96295780.0,
    "valor_anterior": 366279401.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 215113796.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 159145914.0,
        "delta": -55967882.0
      },
      {
        "periodo": 202509,
        "valor": 269135882.0,
        "delta": 109989968.0
      },
      {
        "periodo": 202510,
        "valor": 494522192.0,
        "delta": 225386310.0
      },
      {
        "periodo": 202511,
        "valor": 412956839.0,
        "delta": -81565353.0
      },
      {
        "periodo": 202512,
        "valor": 469096732.0,
        "delta": 56139893.0
      },
      {
        "periodo": 202601,
        "valor": 154724941.0,
        "delta": -314371791.0
      },
      {
        "periodo": 202602,
        "valor": 112073126.0,
        "delta": -42651815.0
      },
      {
        "periodo": 202603,
        "valor": 850724648.0,
        "delta": 738651522.0
      },
      {
        "periodo": 202604,
        "valor": 485101692.0,
        "delta": -365622956.0
      },
      {
        "periodo": 202605,
        "valor": 246831664.0,
        "delta": -238270028.0
      },
      {
        "periodo": 202606,
        "valor": 366279401.0,
        "delta": 119447737.0
      },
      {
        "periodo": 202607,
        "valor": 96295780.0,
        "delta": -269983621.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 251218556.42000008,
    "valor_anterior": 259116558.14999986,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 242279369.53,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 302321779.37,
        "delta": 60042409.84
      },
      {
        "periodo": 202509,
        "valor": 269032752.78,
        "delta": -33289026.59
      },
      {
        "periodo": 202510,
        "valor": 274977207.47,
        "delta": 5944454.69
      },
      {
        "periodo": 202511,
        "valor": 291534528.55,
        "delta": 16557321.08
      },
      {
        "periodo": 202512,
        "valor": 236641184.96,
        "delta": -54893343.59
      },
      {
        "periodo": 202601,
        "valor": 308416285.35,
        "delta": 71775100.39
      },
      {
        "periodo": 202602,
        "valor": 210505017.82,
        "delta": -97911267.53
      },
      {
        "periodo": 202603,
        "valor": 278835596.21,
        "delta": 68330578.39
      },
      {
        "periodo": 202604,
        "valor": 283535239.21,
        "delta": 4699643.0
      },
      {
        "periodo": 202605,
        "valor": 287519922.58,
        "delta": 3984683.37
      },
      {
        "periodo": 202606,
        "valor": 259116558.15,
        "delta": -28403364.43
      },
      {
        "periodo": 202607,
        "valor": 251218556.42,
        "delta": -7898001.73
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 726049457.0,
    "valor_anterior": 449168235.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 573154852.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 827519041.0,
        "delta": 254364189.0
      },
      {
        "periodo": 202509,
        "valor": 647580395.0,
        "delta": -179938646.0
      },
      {
        "periodo": 202510,
        "valor": 488619884.0,
        "delta": -158960511.0
      },
      {
        "periodo": 202511,
        "valor": 336751365.0,
        "delta": -151868519.0
      },
      {
        "periodo": 202512,
        "valor": 783996249.0,
        "delta": 447244884.0
      },
      {
        "periodo": 202601,
        "valor": 612579722.0,
        "delta": -171416527.0
      },
      {
        "periodo": 202602,
        "valor": 517674142.0,
        "delta": -94905580.0
      },
      {
        "periodo": 202603,
        "valor": 464549928.0,
        "delta": -53124214.0
      },
      {
        "periodo": 202604,
        "valor": 816173657.0,
        "delta": 351623729.0
      },
      {
        "periodo": 202605,
        "valor": 650226699.0,
        "delta": -165946958.0
      },
      {
        "periodo": 202606,
        "valor": 449168235.0,
        "delta": -201058464.0
      },
      {
        "periodo": 202607,
        "valor": 726049457.0,
        "delta": 276881222.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 84161333.0,
    "valor_anterior": 90284561.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 71562013.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 67464500.0,
        "delta": -4097513.0
      },
      {
        "periodo": 202509,
        "valor": 79601560.0,
        "delta": 12137060.0
      },
      {
        "periodo": 202510,
        "valor": 73998387.0,
        "delta": -5603173.0
      },
      {
        "periodo": 202511,
        "valor": 66808315.0,
        "delta": -7190072.0
      },
      {
        "periodo": 202512,
        "valor": 74615185.0,
        "delta": 7806870.0
      },
      {
        "periodo": 202601,
        "valor": 60959793.0,
        "delta": -13655392.0
      },
      {
        "periodo": 202602,
        "valor": 90379462.0,
        "delta": 29419669.0
      },
      {
        "periodo": 202603,
        "valor": 64016889.0,
        "delta": -26362573.0
      },
      {
        "periodo": 202604,
        "valor": 102592016.0,
        "delta": 38575127.0
      },
      {
        "periodo": 202605,
        "valor": 93423385.0,
        "delta": -9168631.0
      },
      {
        "periodo": 202606,
        "valor": 90284561.0,
        "delta": -3138824.0
      },
      {
        "periodo": 202607,
        "valor": 84161333.0,
        "delta": -6123228.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 669312762.0,
    "valor_anterior": 634147901.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 248771871.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 403194800.0,
        "delta": 154422929.0
      },
      {
        "periodo": 202509,
        "valor": 319076091.0,
        "delta": -84118709.0
      },
      {
        "periodo": 202510,
        "valor": 202201287.0,
        "delta": -116874804.0
      },
      {
        "periodo": 202511,
        "valor": 248891779.0,
        "delta": 46690492.0
      },
      {
        "periodo": 202512,
        "valor": 299284117.0,
        "delta": 50392338.0
      },
      {
        "periodo": 202601,
        "valor": 563120726.0,
        "delta": 263836609.0
      },
      {
        "periodo": 202602,
        "valor": 340833809.0,
        "delta": -222286917.0
      },
      {
        "periodo": 202603,
        "valor": 532464970.0,
        "delta": 191631161.0
      },
      {
        "periodo": 202604,
        "valor": 319075258.0,
        "delta": -213389712.0
      },
      {
        "periodo": 202605,
        "valor": 485867189.0,
        "delta": 166791931.0
      },
      {
        "periodo": 202606,
        "valor": 634147901.0,
        "delta": 148280712.0
      },
      {
        "periodo": 202607,
        "valor": 669312762.0,
        "delta": 35164861.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 215433772.32999992,
    "valor_anterior": 186502352.55999994,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 184630628.62,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 185580748.72,
        "delta": 950120.1
      },
      {
        "periodo": 202509,
        "valor": 183536320.69,
        "delta": -2044428.03
      },
      {
        "periodo": 202510,
        "valor": 213608352.69,
        "delta": 30072032.0
      },
      {
        "periodo": 202511,
        "valor": 230964665.64,
        "delta": 17356312.95
      },
      {
        "periodo": 202512,
        "valor": 207041927.65,
        "delta": -23922737.99
      },
      {
        "periodo": 202601,
        "valor": 190912505.0,
        "delta": -16129422.65
      },
      {
        "periodo": 202602,
        "valor": 150351251.64,
        "delta": -40561253.36
      },
      {
        "periodo": 202603,
        "valor": 216359063.62,
        "delta": 66007811.98
      },
      {
        "periodo": 202604,
        "valor": 189987108.65,
        "delta": -26371954.97
      },
      {
        "periodo": 202605,
        "valor": 188652761.29,
        "delta": -1334347.36
      },
      {
        "periodo": 202606,
        "valor": 186502352.56,
        "delta": -2150408.73
      },
      {
        "periodo": 202607,
        "valor": 215433772.33,
        "delta": 28931419.77
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 103164519.0,
    "valor_anterior": 67571687.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 83033844.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18869519.0,
        "delta": -64164325.0
      },
      {
        "periodo": 202509,
        "valor": 93238328.0,
        "delta": 74368809.0
      },
      {
        "periodo": 202510,
        "valor": 92290912.0,
        "delta": -947416.0
      },
      {
        "periodo": 202511,
        "valor": -34587770.0,
        "delta": -126878682.0
      },
      {
        "periodo": 202512,
        "valor": 38684140.0,
        "delta": 73271910.0
      },
      {
        "periodo": 202601,
        "valor": 13545866.0,
        "delta": -25138274.0
      },
      {
        "periodo": 202602,
        "valor": -11030421.0,
        "delta": -24576287.0
      },
      {
        "periodo": 202603,
        "valor": 44840268.0,
        "delta": 55870689.0
      },
      {
        "periodo": 202604,
        "valor": 85285763.0,
        "delta": 40445495.0
      },
      {
        "periodo": 202605,
        "valor": 68495227.0,
        "delta": -16790536.0
      },
      {
        "periodo": 202606,
        "valor": 67571687.0,
        "delta": -923540.0
      },
      {
        "periodo": 202607,
        "valor": 103164519.0,
        "delta": 35592832.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 42179246.0,
    "valor_anterior": 35151740.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 50000519.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 80373732.0,
        "delta": 30373213.0
      },
      {
        "periodo": 202509,
        "valor": 38167206.0,
        "delta": -42206526.0
      },
      {
        "periodo": 202510,
        "valor": 40116229.0,
        "delta": 1949023.0
      },
      {
        "periodo": 202511,
        "valor": 20935283.0,
        "delta": -19180946.0
      },
      {
        "periodo": 202512,
        "valor": 10330742.0,
        "delta": -10604541.0
      },
      {
        "periodo": 202601,
        "valor": 38705084.0,
        "delta": 28374342.0
      },
      {
        "periodo": 202602,
        "valor": 42395113.0,
        "delta": 3690029.0
      },
      {
        "periodo": 202603,
        "valor": -24169792.0,
        "delta": -66564905.0
      },
      {
        "periodo": 202604,
        "valor": 35171043.0,
        "delta": 59340835.0
      },
      {
        "periodo": 202605,
        "valor": 40031548.0,
        "delta": 4860505.0
      },
      {
        "periodo": 202606,
        "valor": 35151740.0,
        "delta": -4879808.0
      },
      {
        "periodo": 202607,
        "valor": 42179246.0,
        "delta": 7027506.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 27124703.0,
    "valor_anterior": 49634916.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27367673.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 39949188.0,
        "delta": 12581515.0
      },
      {
        "periodo": 202509,
        "valor": 31145014.0,
        "delta": -8804174.0
      },
      {
        "periodo": 202510,
        "valor": 36116317.0,
        "delta": 4971303.0
      },
      {
        "periodo": 202511,
        "valor": 29858427.0,
        "delta": -6257890.0
      },
      {
        "periodo": 202512,
        "valor": -172457429.0,
        "delta": -202315856.0
      },
      {
        "periodo": 202601,
        "valor": 46925890.0,
        "delta": 219383319.0
      },
      {
        "periodo": 202602,
        "valor": 23313453.0,
        "delta": -23612437.0
      },
      {
        "periodo": 202603,
        "valor": 80507314.0,
        "delta": 57193861.0
      },
      {
        "periodo": 202604,
        "valor": 52350626.0,
        "delta": -28156688.0
      },
      {
        "periodo": 202605,
        "valor": 35568214.0,
        "delta": -16782412.0
      },
      {
        "periodo": 202606,
        "valor": 49634916.0,
        "delta": 14066702.0
      },
      {
        "periodo": 202607,
        "valor": 27124703.0,
        "delta": -22510213.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 1296140210.5600014,
    "valor_anterior": 1591080213.0499983,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1485621220.71,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1306174316.62,
        "delta": -179446904.09
      },
      {
        "periodo": 202509,
        "valor": 976222699.73,
        "delta": -329951616.89
      },
      {
        "periodo": 202510,
        "valor": 1871264509.56,
        "delta": 895041809.83
      },
      {
        "periodo": 202511,
        "valor": 1072404355.75,
        "delta": -798860153.81
      },
      {
        "periodo": 202512,
        "valor": 2352701298.53,
        "delta": 1280296942.78
      },
      {
        "periodo": 202601,
        "valor": 1586363115.4,
        "delta": -766338183.13
      },
      {
        "periodo": 202602,
        "valor": 1578392309.28,
        "delta": -7970806.12
      },
      {
        "periodo": 202603,
        "valor": 1812363000.77,
        "delta": 233970691.49
      },
      {
        "periodo": 202604,
        "valor": 1681742269.44,
        "delta": -130620731.33
      },
      {
        "periodo": 202605,
        "valor": 1708370134.67,
        "delta": 26627865.23
      },
      {
        "periodo": 202606,
        "valor": 1591080213.05,
        "delta": -117289921.62
      },
      {
        "periodo": 202607,
        "valor": 1296140210.56,
        "delta": -294940002.49
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 90562673.0,
    "valor_anterior": 88476463.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 44994240.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 45487382.0,
        "delta": 493142.0
      },
      {
        "periodo": 202509,
        "valor": 69118855.0,
        "delta": 23631473.0
      },
      {
        "periodo": 202510,
        "valor": 49743615.0,
        "delta": -19375240.0
      },
      {
        "periodo": 202511,
        "valor": 3331289.0,
        "delta": -46412326.0
      },
      {
        "periodo": 202512,
        "valor": 146665928.0,
        "delta": 143334639.0
      },
      {
        "periodo": 202601,
        "valor": 99708275.0,
        "delta": -46957653.0
      },
      {
        "periodo": 202602,
        "valor": 38546402.0,
        "delta": -61161873.0
      },
      {
        "periodo": 202603,
        "valor": 13327487.0,
        "delta": -25218915.0
      },
      {
        "periodo": 202604,
        "valor": 110687837.0,
        "delta": 97360350.0
      },
      {
        "periodo": 202605,
        "valor": 27222347.0,
        "delta": -83465490.0
      },
      {
        "periodo": 202606,
        "valor": 88476463.0,
        "delta": 61254116.0
      },
      {
        "periodo": 202607,
        "valor": 90562673.0,
        "delta": 2086210.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 23396582.0,
    "valor_anterior": 20834028.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 36113500.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 34182041.0,
        "delta": -1931459.0
      },
      {
        "periodo": 202509,
        "valor": 33994576.0,
        "delta": -187465.0
      },
      {
        "periodo": 202510,
        "valor": 25616156.0,
        "delta": -8378420.0
      },
      {
        "periodo": 202511,
        "valor": 10003132.0,
        "delta": -15613024.0
      },
      {
        "periodo": 202512,
        "valor": 20505922.0,
        "delta": 10502790.0
      },
      {
        "periodo": 202601,
        "valor": 17128228.0,
        "delta": -3377694.0
      },
      {
        "periodo": 202602,
        "valor": -2091732.0,
        "delta": -19219960.0
      },
      {
        "periodo": 202603,
        "valor": 2973064.0,
        "delta": 5064796.0
      },
      {
        "periodo": 202604,
        "valor": 9120501.0,
        "delta": 6147437.0
      },
      {
        "periodo": 202605,
        "valor": 20522737.0,
        "delta": 11402236.0
      },
      {
        "periodo": 202606,
        "valor": 20834028.0,
        "delta": 311291.0
      },
      {
        "periodo": 202607,
        "valor": 23396582.0,
        "delta": 2562554.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 41519315.0,
    "valor_anterior": 35061092.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 156737578.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 72996579.0,
        "delta": -83740999.0
      },
      {
        "periodo": 202509,
        "valor": 276452587.0,
        "delta": 203456008.0
      },
      {
        "periodo": 202510,
        "valor": 100649160.0,
        "delta": -175803427.0
      },
      {
        "periodo": 202511,
        "valor": 81980726.0,
        "delta": -18668434.0
      },
      {
        "periodo": 202512,
        "valor": 43787858.0,
        "delta": -38192868.0
      },
      {
        "periodo": 202601,
        "valor": 61173876.0,
        "delta": 17386018.0
      },
      {
        "periodo": 202602,
        "valor": 18065148.0,
        "delta": -43108728.0
      },
      {
        "periodo": 202603,
        "valor": 113093870.0,
        "delta": 95028722.0
      },
      {
        "periodo": 202604,
        "valor": -17669677.0,
        "delta": -130763547.0
      },
      {
        "periodo": 202605,
        "valor": 27884601.0,
        "delta": 45554278.0
      },
      {
        "periodo": 202606,
        "valor": 35061092.0,
        "delta": 7176491.0
      },
      {
        "periodo": 202607,
        "valor": 41519315.0,
        "delta": 6458223.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 137693121.13,
    "valor_anterior": 155102604.87000006,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 98727197.85,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 146244354.77,
        "delta": 47517156.92
      },
      {
        "periodo": 202509,
        "valor": 143684953.23,
        "delta": -2559401.54
      },
      {
        "periodo": 202510,
        "valor": 182475239.74,
        "delta": 38790286.51
      },
      {
        "periodo": 202511,
        "valor": 120039239.65,
        "delta": -62436000.09
      },
      {
        "periodo": 202512,
        "valor": 160091869.82,
        "delta": 40052630.17
      },
      {
        "periodo": 202601,
        "valor": 169782561.81,
        "delta": 9690691.99
      },
      {
        "periodo": 202602,
        "valor": 109238581.86,
        "delta": -60543979.95
      },
      {
        "periodo": 202603,
        "valor": 12096952.0,
        "delta": -97141629.86
      },
      {
        "periodo": 202604,
        "valor": 73261816.69,
        "delta": 61164864.69
      },
      {
        "periodo": 202605,
        "valor": 141729517.72,
        "delta": 68467701.03
      },
      {
        "periodo": 202606,
        "valor": 155102604.87,
        "delta": 13373087.15
      },
      {
        "periodo": 202607,
        "valor": 137693121.13,
        "delta": -17409483.74
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 63980399.0,
    "valor_anterior": 60707641.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7317488.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 49130928.0,
        "delta": 41813440.0
      },
      {
        "periodo": 202509,
        "valor": 27936748.0,
        "delta": -21194180.0
      },
      {
        "periodo": 202510,
        "valor": 93232274.0,
        "delta": 65295526.0
      },
      {
        "periodo": 202511,
        "valor": 40240926.0,
        "delta": -52991348.0
      },
      {
        "periodo": 202512,
        "valor": 14228992.0,
        "delta": -26011934.0
      },
      {
        "periodo": 202601,
        "valor": 43607860.0,
        "delta": 29378868.0
      },
      {
        "periodo": 202602,
        "valor": -4390536.0,
        "delta": -47998396.0
      },
      {
        "periodo": 202603,
        "valor": 25441202.0,
        "delta": 29831738.0
      },
      {
        "periodo": 202604,
        "valor": 50610064.0,
        "delta": 25168862.0
      },
      {
        "periodo": 202605,
        "valor": 71399253.0,
        "delta": 20789189.0
      },
      {
        "periodo": 202606,
        "valor": 60707641.0,
        "delta": -10691612.0
      },
      {
        "periodo": 202607,
        "valor": 63980399.0,
        "delta": 3272758.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 457646432.4499998,
    "valor_anterior": 548776103.02,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 169122499.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 402357670.0,
        "delta": 233235171.0
      },
      {
        "periodo": 202509,
        "valor": 757015288.0,
        "delta": 354657618.0
      },
      {
        "periodo": 202510,
        "valor": 506423877.0,
        "delta": -250591411.0
      },
      {
        "periodo": 202511,
        "valor": 445736336.0,
        "delta": -60687541.0
      },
      {
        "periodo": 202512,
        "valor": 727253772.15,
        "delta": 281517436.15
      },
      {
        "periodo": 202601,
        "valor": 561755079.0,
        "delta": -165498693.15
      },
      {
        "periodo": 202602,
        "valor": 367560966.0,
        "delta": -194194113.0
      },
      {
        "periodo": 202603,
        "valor": 825988975.91,
        "delta": 458428009.91
      },
      {
        "periodo": 202604,
        "valor": -5961125.82,
        "delta": -831950101.73
      },
      {
        "periodo": 202605,
        "valor": 302780568.87,
        "delta": 308741694.69
      },
      {
        "periodo": 202606,
        "valor": 548776103.02,
        "delta": 245995534.15
      },
      {
        "periodo": 202607,
        "valor": 457646432.45,
        "delta": -91129670.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": -147526981.0,
    "valor_anterior": -387079535.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 133306425.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 191223670.0,
        "delta": 57917245.0
      },
      {
        "periodo": 202509,
        "valor": 160741025.0,
        "delta": -30482645.0
      },
      {
        "periodo": 202510,
        "valor": 388810572.0,
        "delta": 228069547.0
      },
      {
        "periodo": 202511,
        "valor": 241593886.0,
        "delta": -147216686.0
      },
      {
        "periodo": 202512,
        "valor": 402911630.0,
        "delta": 161317744.0
      },
      {
        "periodo": 202601,
        "valor": 226488107.0,
        "delta": -176423523.0
      },
      {
        "periodo": 202602,
        "valor": 213678311.0,
        "delta": -12809796.0
      },
      {
        "periodo": 202603,
        "valor": 282239248.15,
        "delta": 68560937.15
      },
      {
        "periodo": 202604,
        "valor": 139439367.0,
        "delta": -142799881.15
      },
      {
        "periodo": 202605,
        "valor": -291892216.0,
        "delta": -431331583.0
      },
      {
        "periodo": 202606,
        "valor": -387079535.0,
        "delta": -95187319.0
      },
      {
        "periodo": 202607,
        "valor": -147526981.0,
        "delta": 239552554.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 32139996.0,
    "valor_anterior": 33801499.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 104305526.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -12067736.0,
        "delta": -116373262.0
      },
      {
        "periodo": 202509,
        "valor": 48800746.0,
        "delta": 60868482.0
      },
      {
        "periodo": 202510,
        "valor": 44868155.0,
        "delta": -3932591.0
      },
      {
        "periodo": 202511,
        "valor": 3325352.0,
        "delta": -41542803.0
      },
      {
        "periodo": 202512,
        "valor": -14019623.0,
        "delta": -17344975.0
      },
      {
        "periodo": 202601,
        "valor": 35779180.0,
        "delta": 49798803.0
      },
      {
        "periodo": 202602,
        "valor": 57109304.0,
        "delta": 21330124.0
      },
      {
        "periodo": 202603,
        "valor": -25056294.0,
        "delta": -82165598.0
      },
      {
        "periodo": 202604,
        "valor": 20771613.0,
        "delta": 45827907.0
      },
      {
        "periodo": 202605,
        "valor": 43703598.0,
        "delta": 22931985.0
      },
      {
        "periodo": 202606,
        "valor": 33801499.0,
        "delta": -9902099.0
      },
      {
        "periodo": 202607,
        "valor": 32139996.0,
        "delta": -1661503.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 225307302.0,
    "valor_anterior": 261371117.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 212112617.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 288654967.0,
        "delta": 76542350.0
      },
      {
        "periodo": 202509,
        "valor": 213304034.0,
        "delta": -75350933.0
      },
      {
        "periodo": 202510,
        "valor": 206207325.0,
        "delta": -7096709.0
      },
      {
        "periodo": 202511,
        "valor": 184482508.0,
        "delta": -21724817.0
      },
      {
        "periodo": 202512,
        "valor": 191939138.0,
        "delta": 7456630.0
      },
      {
        "periodo": 202601,
        "valor": 280992143.0,
        "delta": 89053005.0
      },
      {
        "periodo": 202602,
        "valor": 261727473.0,
        "delta": -19264670.0
      },
      {
        "periodo": 202603,
        "valor": 216434842.0,
        "delta": -45292631.0
      },
      {
        "periodo": 202604,
        "valor": 157633144.0,
        "delta": -58801698.0
      },
      {
        "periodo": 202605,
        "valor": 209938795.0,
        "delta": 52305651.0
      },
      {
        "periodo": 202606,
        "valor": 261371117.0,
        "delta": 51432322.0
      },
      {
        "periodo": 202607,
        "valor": 225307302.0,
        "delta": -36063815.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 78243710.0,
    "valor_anterior": 129639559.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 33329870.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 30870791.0,
        "delta": -2459079.0
      },
      {
        "periodo": 202509,
        "valor": 35998430.0,
        "delta": 5127639.0
      },
      {
        "periodo": 202510,
        "valor": 64180734.0,
        "delta": 28182304.0
      },
      {
        "periodo": 202511,
        "valor": 35769051.0,
        "delta": -28411683.0
      },
      {
        "periodo": 202512,
        "valor": 64860501.0,
        "delta": 29091450.0
      },
      {
        "periodo": 202601,
        "valor": 48048501.0,
        "delta": -16812000.0
      },
      {
        "periodo": 202602,
        "valor": 36202513.0,
        "delta": -11845988.0
      },
      {
        "periodo": 202603,
        "valor": 48448523.0,
        "delta": 12246010.0
      },
      {
        "periodo": 202604,
        "valor": 31570263.0,
        "delta": -16878260.0
      },
      {
        "periodo": 202605,
        "valor": 84344217.0,
        "delta": 52773954.0
      },
      {
        "periodo": 202606,
        "valor": 129639559.0,
        "delta": 45295342.0
      },
      {
        "periodo": 202607,
        "valor": 78243710.0,
        "delta": -51395849.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 19408039.0,
    "valor_anterior": 291985.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16081965.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8508695.0,
        "delta": -7573270.0
      },
      {
        "periodo": 202509,
        "valor": 37257204.0,
        "delta": 28748509.0
      },
      {
        "periodo": 202510,
        "valor": 22256297.0,
        "delta": -15000907.0
      },
      {
        "periodo": 202511,
        "valor": -6552934.0,
        "delta": -28809231.0
      },
      {
        "periodo": 202512,
        "valor": -9430368.0,
        "delta": -2877434.0
      },
      {
        "periodo": 202601,
        "valor": 3226199.0,
        "delta": 12656567.0
      },
      {
        "periodo": 202602,
        "valor": 5199470.0,
        "delta": 1973271.0
      },
      {
        "periodo": 202603,
        "valor": 14656007.0,
        "delta": 9456537.0
      },
      {
        "periodo": 202604,
        "valor": 15134748.0,
        "delta": 478741.0
      },
      {
        "periodo": 202605,
        "valor": 35369635.0,
        "delta": 20234887.0
      },
      {
        "periodo": 202606,
        "valor": 291985.0,
        "delta": -35077650.0
      },
      {
        "periodo": 202607,
        "valor": 19408039.0,
        "delta": 19116054.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 125676647.0,
    "valor_anterior": 164286270.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -159119897.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -82528708.0,
        "delta": 76591189.0
      },
      {
        "periodo": 202509,
        "valor": 32973222.0,
        "delta": 115501930.0
      },
      {
        "periodo": 202510,
        "valor": 13503052.0,
        "delta": -19470170.0
      },
      {
        "periodo": 202511,
        "valor": -43300717.0,
        "delta": -56803769.0
      },
      {
        "periodo": 202512,
        "valor": -70586297.0,
        "delta": -27285580.0
      },
      {
        "periodo": 202601,
        "valor": 13605962.0,
        "delta": 84192259.0
      },
      {
        "periodo": 202602,
        "valor": 31483846.0,
        "delta": 17877884.0
      },
      {
        "periodo": 202603,
        "valor": 23730581.0,
        "delta": -7753265.0
      },
      {
        "periodo": 202604,
        "valor": -28942519.0,
        "delta": -52673100.0
      },
      {
        "periodo": 202605,
        "valor": 29480864.0,
        "delta": 58423383.0
      },
      {
        "periodo": 202606,
        "valor": 164286270.0,
        "delta": 134805406.0
      },
      {
        "periodo": 202607,
        "valor": 125676647.0,
        "delta": -38609623.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 123134627.94999993,
    "valor_anterior": 243309043.27000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 78245850.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23733835.18,
        "delta": -54512015.64
      },
      {
        "periodo": 202509,
        "valor": 101409960.47,
        "delta": 77676125.29
      },
      {
        "periodo": 202510,
        "valor": 130593961.13,
        "delta": 29184000.66
      },
      {
        "periodo": 202511,
        "valor": 80829468.76,
        "delta": -49764492.37
      },
      {
        "periodo": 202512,
        "valor": 25296681.31,
        "delta": -55532787.45
      },
      {
        "periodo": 202601,
        "valor": 10985881.7,
        "delta": -14310799.61
      },
      {
        "periodo": 202602,
        "valor": 91770952.56,
        "delta": 80785070.86
      },
      {
        "periodo": 202603,
        "valor": -4937881.5,
        "delta": -96708834.06
      },
      {
        "periodo": 202604,
        "valor": 93845445.28,
        "delta": 98783326.78
      },
      {
        "periodo": 202605,
        "valor": 152067523.26,
        "delta": 58222077.98
      },
      {
        "periodo": 202606,
        "valor": 243309043.27,
        "delta": 91241520.01
      },
      {
        "periodo": 202607,
        "valor": 123134627.95,
        "delta": -120174415.32
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 9684888.0,
    "valor_anterior": 7442051.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -10434125.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -5410242.0,
        "delta": 5023883.0
      },
      {
        "periodo": 202509,
        "valor": 10996543.0,
        "delta": 16406785.0
      },
      {
        "periodo": 202510,
        "valor": 6261627.0,
        "delta": -4734916.0
      },
      {
        "periodo": 202511,
        "valor": 2483309.0,
        "delta": -3778318.0
      },
      {
        "periodo": 202512,
        "valor": -668744.0,
        "delta": -3152053.0
      },
      {
        "periodo": 202601,
        "valor": 3891121.0,
        "delta": 4559865.0
      },
      {
        "periodo": 202602,
        "valor": 11925994.0,
        "delta": 8034873.0
      },
      {
        "periodo": 202603,
        "valor": -7321384.0,
        "delta": -19247378.0
      },
      {
        "periodo": 202604,
        "valor": 5844634.0,
        "delta": 13166018.0
      },
      {
        "periodo": 202605,
        "valor": -7934624.0,
        "delta": -13779258.0
      },
      {
        "periodo": 202606,
        "valor": 7442051.0,
        "delta": 15376675.0
      },
      {
        "periodo": 202607,
        "valor": 9684888.0,
        "delta": 2242837.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": -1203787.0,
    "valor_anterior": -3041180.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 157326.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2649989.0,
        "delta": 2492663.0
      },
      {
        "periodo": 202509,
        "valor": 3299560.0,
        "delta": 649571.0
      },
      {
        "periodo": 202510,
        "valor": 2195164.0,
        "delta": -1104396.0
      },
      {
        "periodo": 202511,
        "valor": -1101945.0,
        "delta": -3297109.0
      },
      {
        "periodo": 202512,
        "valor": 237078.0,
        "delta": 1339023.0
      },
      {
        "periodo": 202601,
        "valor": 22980.0,
        "delta": -214098.0
      },
      {
        "periodo": 202602,
        "valor": 509669.0,
        "delta": 486689.0
      },
      {
        "periodo": 202603,
        "valor": 2167620.0,
        "delta": 1657951.0
      },
      {
        "periodo": 202604,
        "valor": 1509261.0,
        "delta": -658359.0
      },
      {
        "periodo": 202605,
        "valor": 2426058.0,
        "delta": 916797.0
      },
      {
        "periodo": 202606,
        "valor": -3041180.0,
        "delta": -5467238.0
      },
      {
        "periodo": 202607,
        "valor": -1203787.0,
        "delta": 1837393.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 41442565.0,
    "valor_anterior": 59286370.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 53100439.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55305692.0,
        "delta": 2205253.0
      },
      {
        "periodo": 202509,
        "valor": 63237114.0,
        "delta": 7931422.0
      },
      {
        "periodo": 202510,
        "valor": 47566323.0,
        "delta": -15670791.0
      },
      {
        "periodo": 202511,
        "valor": 66523669.0,
        "delta": 18957346.0
      },
      {
        "periodo": 202512,
        "valor": 52081313.0,
        "delta": -14442356.0
      },
      {
        "periodo": 202601,
        "valor": 55140942.0,
        "delta": 3059629.0
      },
      {
        "periodo": 202602,
        "valor": 70218551.0,
        "delta": 15077609.0
      },
      {
        "periodo": 202603,
        "valor": 80731754.0,
        "delta": 10513203.0
      },
      {
        "periodo": 202604,
        "valor": 64174735.0,
        "delta": -16557019.0
      },
      {
        "periodo": 202605,
        "valor": 50612189.0,
        "delta": -13562546.0
      },
      {
        "periodo": 202606,
        "valor": 59286370.0,
        "delta": 8674181.0
      },
      {
        "periodo": 202607,
        "valor": 41442565.0,
        "delta": -17843805.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 1227302.0,
    "valor_anterior": 25866307.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4592966.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2498454.0,
        "delta": -2094512.0
      },
      {
        "periodo": 202509,
        "valor": 25884020.0,
        "delta": 23385566.0
      },
      {
        "periodo": 202510,
        "valor": 6572309.0,
        "delta": -19311711.0
      },
      {
        "periodo": 202511,
        "valor": -556308.0,
        "delta": -7128617.0
      },
      {
        "periodo": 202512,
        "valor": -455846.0,
        "delta": 100462.0
      },
      {
        "periodo": 202601,
        "valor": 12110526.0,
        "delta": 12566372.0
      },
      {
        "periodo": 202602,
        "valor": 10872404.0,
        "delta": -1238122.0
      },
      {
        "periodo": 202603,
        "valor": -1354684.0,
        "delta": -12227088.0
      },
      {
        "periodo": 202604,
        "valor": 68273708.0,
        "delta": 69628392.0
      },
      {
        "periodo": 202605,
        "valor": 4946232.0,
        "delta": -63327476.0
      },
      {
        "periodo": 202606,
        "valor": 25866307.0,
        "delta": 20920075.0
      },
      {
        "periodo": 202607,
        "valor": 1227302.0,
        "delta": -24639005.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 38198423.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -141597879.0,
        "delta": -179796302.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 64482521.0,
    "valor_anterior": 58851840.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 36590854.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 78981664.0,
        "delta": 42390810.0
      },
      {
        "periodo": 202509,
        "valor": 54731809.0,
        "delta": -24249855.0
      },
      {
        "periodo": 202510,
        "valor": 80895200.0,
        "delta": 26163391.0
      },
      {
        "periodo": 202511,
        "valor": 48849711.0,
        "delta": -32045489.0
      },
      {
        "periodo": 202512,
        "valor": 73421796.0,
        "delta": 24572085.0
      },
      {
        "periodo": 202601,
        "valor": 39248048.0,
        "delta": -34173748.0
      },
      {
        "periodo": 202602,
        "valor": 50241819.0,
        "delta": 10993771.0
      },
      {
        "periodo": 202603,
        "valor": 66793861.0,
        "delta": 16552042.0
      },
      {
        "periodo": 202604,
        "valor": 68866488.0,
        "delta": 2072627.0
      },
      {
        "periodo": 202605,
        "valor": 48655283.0,
        "delta": -20211205.0
      },
      {
        "periodo": 202606,
        "valor": 58851840.0,
        "delta": 10196557.0
      },
      {
        "periodo": 202607,
        "valor": 64482521.0,
        "delta": 5630681.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 6271861.0,
    "valor_anterior": 8763386.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10000000.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7500000.0,
        "delta": -2500000.0
      },
      {
        "periodo": 202509,
        "valor": 7500000.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": -7500000.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": -27957251.0,
        "delta": -27957251.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 27957251.0
      },
      {
        "periodo": 202602,
        "valor": 17190585.0,
        "delta": 17190585.0
      },
      {
        "periodo": 202603,
        "valor": 151312.0,
        "delta": -17039273.0
      },
      {
        "periodo": 202604,
        "valor": 5342296.0,
        "delta": 5190984.0
      },
      {
        "periodo": 202605,
        "valor": 6864850.0,
        "delta": 1522554.0
      },
      {
        "periodo": 202606,
        "valor": 8763386.0,
        "delta": 1898536.0
      },
      {
        "periodo": 202607,
        "valor": 6271861.0,
        "delta": -2491525.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 1604069.0,
    "valor_anterior": 2811574.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2043741.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3075014.0,
        "delta": 1031273.0
      },
      {
        "periodo": 202509,
        "valor": 6977071.0,
        "delta": 3902057.0
      },
      {
        "periodo": 202510,
        "valor": 3984318.0,
        "delta": -2992753.0
      },
      {
        "periodo": 202511,
        "valor": 1961305.0,
        "delta": -2023013.0
      },
      {
        "periodo": 202512,
        "valor": -3026610.0,
        "delta": -4987915.0
      },
      {
        "periodo": 202601,
        "valor": 1818895.0,
        "delta": 4845505.0
      },
      {
        "periodo": 202602,
        "valor": 877179.0,
        "delta": -941716.0
      },
      {
        "periodo": 202603,
        "valor": 77440.0,
        "delta": -799739.0
      },
      {
        "periodo": 202604,
        "valor": 3645669.0,
        "delta": 3568229.0
      },
      {
        "periodo": 202605,
        "valor": 2891254.0,
        "delta": -754415.0
      },
      {
        "periodo": 202606,
        "valor": 2811574.0,
        "delta": -79680.0
      },
      {
        "periodo": 202607,
        "valor": 1604069.0,
        "delta": -1207505.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 8391044.0,
    "valor_anterior": -8853498.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -112772.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1321698.0,
        "delta": 1434470.0
      },
      {
        "periodo": 202509,
        "valor": -444379.0,
        "delta": -1766077.0
      },
      {
        "periodo": 202510,
        "valor": 368295.0,
        "delta": 812674.0
      },
      {
        "periodo": 202511,
        "valor": 9775855.0,
        "delta": 9407560.0
      },
      {
        "periodo": 202512,
        "valor": 10958063.0,
        "delta": 1182208.0
      },
      {
        "periodo": 202601,
        "valor": 11038111.0,
        "delta": 80048.0
      },
      {
        "periodo": 202602,
        "valor": 1992998.0,
        "delta": -9045113.0
      },
      {
        "periodo": 202603,
        "valor": 1573022.0,
        "delta": -419976.0
      },
      {
        "periodo": 202604,
        "valor": -2341410.0,
        "delta": -3914432.0
      },
      {
        "periodo": 202605,
        "valor": -2608140.0,
        "delta": -266730.0
      },
      {
        "periodo": 202606,
        "valor": -8853498.0,
        "delta": -6245358.0
      },
      {
        "periodo": 202607,
        "valor": 8391044.0,
        "delta": 17244542.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": -302606.0,
    "valor_anterior": 488783.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -342605.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -5103.0,
        "delta": 337502.0
      },
      {
        "periodo": 202509,
        "valor": 1101066.0,
        "delta": 1106169.0
      },
      {
        "periodo": 202510,
        "valor": 1021870.0,
        "delta": -79196.0
      },
      {
        "periodo": 202511,
        "valor": 1328565.0,
        "delta": 306695.0
      },
      {
        "periodo": 202512,
        "valor": 372851.0,
        "delta": -955714.0
      },
      {
        "periodo": 202601,
        "valor": 387632.0,
        "delta": 14781.0
      },
      {
        "periodo": 202602,
        "valor": 1333074.0,
        "delta": 945442.0
      },
      {
        "periodo": 202603,
        "valor": 423072.0,
        "delta": -910002.0
      },
      {
        "periodo": 202604,
        "valor": -909596.0,
        "delta": -1332668.0
      },
      {
        "periodo": 202605,
        "valor": -1188493.0,
        "delta": -278897.0
      },
      {
        "periodo": 202606,
        "valor": 488783.0,
        "delta": 1677276.0
      },
      {
        "periodo": 202607,
        "valor": -302606.0,
        "delta": -791389.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 28654165.999999985,
    "valor_anterior": 16229743.560000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26366638.79,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26613466.4,
        "delta": 246827.61
      },
      {
        "periodo": 202509,
        "valor": -9876949.2,
        "delta": -36490415.6
      },
      {
        "periodo": 202510,
        "valor": 38609211.59,
        "delta": 48486160.79
      },
      {
        "periodo": 202511,
        "valor": 25543316.43,
        "delta": -13065895.16
      },
      {
        "periodo": 202512,
        "valor": 22846672.06,
        "delta": -2696644.37
      },
      {
        "periodo": 202601,
        "valor": 28181328.94,
        "delta": 5334656.88
      },
      {
        "periodo": 202602,
        "valor": 20061850.78,
        "delta": -8119478.16
      },
      {
        "periodo": 202603,
        "valor": 3618289.51,
        "delta": -16443561.27
      },
      {
        "periodo": 202604,
        "valor": 26756761.01,
        "delta": 23138471.5
      },
      {
        "periodo": 202605,
        "valor": 29716505.84,
        "delta": 2959744.83
      },
      {
        "periodo": 202606,
        "valor": 16229743.56,
        "delta": -13486762.28
      },
      {
        "periodo": 202607,
        "valor": 28654166.0,
        "delta": 12424422.44
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 14715198.170000002,
    "valor_anterior": 9286137.23,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22724493.45,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10195799.31,
        "delta": -12528694.14
      },
      {
        "periodo": 202509,
        "valor": 7950168.95,
        "delta": -2245630.36
      },
      {
        "periodo": 202510,
        "valor": 11069499.8,
        "delta": 3119330.85
      },
      {
        "periodo": 202511,
        "valor": 13193363.1,
        "delta": 2123863.3
      },
      {
        "periodo": 202512,
        "valor": -4082323.41,
        "delta": -17275686.51
      },
      {
        "periodo": 202601,
        "valor": 8576266.33,
        "delta": 12658589.74
      },
      {
        "periodo": 202602,
        "valor": 10312122.16,
        "delta": 1735855.83
      },
      {
        "periodo": 202603,
        "valor": 4641918.17,
        "delta": -5670203.99
      },
      {
        "periodo": 202604,
        "valor": 3649446.36,
        "delta": -992471.81
      },
      {
        "periodo": 202605,
        "valor": 5603505.29,
        "delta": 1954058.93
      },
      {
        "periodo": 202606,
        "valor": 9286137.23,
        "delta": 3682631.94
      },
      {
        "periodo": 202607,
        "valor": 14715198.17,
        "delta": 5429060.94
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 509102.0,
    "valor_anterior": 2851291.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2097597.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2350377.0,
        "delta": -4447974.0
      },
      {
        "periodo": 202509,
        "valor": 4982800.0,
        "delta": 7333177.0
      },
      {
        "periodo": 202510,
        "valor": 3551886.0,
        "delta": -1430914.0
      },
      {
        "periodo": 202511,
        "valor": 4044509.0,
        "delta": 492623.0
      },
      {
        "periodo": 202512,
        "valor": 10109395.0,
        "delta": 6064886.0
      },
      {
        "periodo": 202601,
        "valor": 4376792.0,
        "delta": -5732603.0
      },
      {
        "periodo": 202602,
        "valor": 3699124.0,
        "delta": -677668.0
      },
      {
        "periodo": 202603,
        "valor": -7437072.0,
        "delta": -11136196.0
      },
      {
        "periodo": 202604,
        "valor": 2437490.0,
        "delta": 9874562.0
      },
      {
        "periodo": 202605,
        "valor": -2732923.0,
        "delta": -5170413.0
      },
      {
        "periodo": 202606,
        "valor": 2851291.0,
        "delta": 5584214.0
      },
      {
        "periodo": 202607,
        "valor": 509102.0,
        "delta": -2342189.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 48717135.0,
    "valor_anterior": 51263350.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5889702.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 47220078.0,
        "delta": 41330376.0
      },
      {
        "periodo": 202509,
        "valor": 21986771.0,
        "delta": -25233307.0
      },
      {
        "periodo": 202510,
        "valor": 27886185.0,
        "delta": 5899414.0
      },
      {
        "periodo": 202511,
        "valor": 26418884.0,
        "delta": -1467301.0
      },
      {
        "periodo": 202512,
        "valor": -10708812.0,
        "delta": -37127696.0
      },
      {
        "periodo": 202601,
        "valor": 24770573.0,
        "delta": 35479385.0
      },
      {
        "periodo": 202602,
        "valor": 22494215.0,
        "delta": -2276358.0
      },
      {
        "periodo": 202603,
        "valor": 31480776.0,
        "delta": 8986561.0
      },
      {
        "periodo": 202604,
        "valor": 32741225.0,
        "delta": 1260449.0
      },
      {
        "periodo": 202605,
        "valor": 45984875.0,
        "delta": 13243650.0
      },
      {
        "periodo": 202606,
        "valor": 51263350.0,
        "delta": 5278475.0
      },
      {
        "periodo": 202607,
        "valor": 48717135.0,
        "delta": -2546215.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 6850934.0,
    "valor_anterior": 3945748.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5872361.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10253033.0,
        "delta": 4380672.0
      },
      {
        "periodo": 202509,
        "valor": 22058459.0,
        "delta": 11805426.0
      },
      {
        "periodo": 202510,
        "valor": 2749480.0,
        "delta": -19308979.0
      },
      {
        "periodo": 202511,
        "valor": 14221386.0,
        "delta": 11471906.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": -14221386.0
      },
      {
        "periodo": 202601,
        "valor": 8715919.0,
        "delta": 8715919.0
      },
      {
        "periodo": 202602,
        "valor": -2089133.0,
        "delta": -10805052.0
      },
      {
        "periodo": 202603,
        "valor": 11506121.0,
        "delta": 13595254.0
      },
      {
        "periodo": 202604,
        "valor": -3163953.0,
        "delta": -14670074.0
      },
      {
        "periodo": 202605,
        "valor": 4993695.0,
        "delta": 8157648.0
      },
      {
        "periodo": 202606,
        "valor": 3945748.0,
        "delta": -1047947.0
      },
      {
        "periodo": 202607,
        "valor": 6850934.0,
        "delta": 2905186.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 0.0,
    "valor_anterior": 3500000.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5520905.97,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.01,
        "delta": -5520905.96
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -0.01
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 3500000.0,
        "delta": 3500000.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": -3500000.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 8353926.0,
    "valor_anterior": 9977206.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9760788.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9219992.0,
        "delta": -540796.0
      },
      {
        "periodo": 202509,
        "valor": 9018688.0,
        "delta": -201304.0
      },
      {
        "periodo": 202510,
        "valor": 8688506.0,
        "delta": -330182.0
      },
      {
        "periodo": 202511,
        "valor": 9560391.0,
        "delta": 871885.0
      },
      {
        "periodo": 202512,
        "valor": 5128744.0,
        "delta": -4431647.0
      },
      {
        "periodo": 202601,
        "valor": 8584388.0,
        "delta": 3455644.0
      },
      {
        "periodo": 202602,
        "valor": 8007148.0,
        "delta": -577240.0
      },
      {
        "periodo": 202603,
        "valor": 8162231.0,
        "delta": 155083.0
      },
      {
        "periodo": 202604,
        "valor": 8010377.0,
        "delta": -151854.0
      },
      {
        "periodo": 202605,
        "valor": 7329648.0,
        "delta": -680729.0
      },
      {
        "periodo": 202606,
        "valor": 9977206.0,
        "delta": 2647558.0
      },
      {
        "periodo": 202607,
        "valor": 8353926.0,
        "delta": -1623280.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 20524.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 37063.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -37063.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 61186.0,
        "delta": 61186.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": -61186.0
      },
      {
        "periodo": 202512,
        "valor": 8465.0,
        "delta": 8465.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -8465.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 14338.0,
        "delta": 14338.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": -14338.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 20524.0,
        "delta": 20524.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 0.0,
    "valor_anterior": 31759444.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1187211.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12820949.0,
        "delta": 14008160.0
      },
      {
        "periodo": 202509,
        "valor": -28828239.0,
        "delta": -41649188.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 28828239.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": -14355778.0,
        "delta": -14355778.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 14355778.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 12695032.0,
        "delta": 12695032.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": -12695032.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 31759444.0,
        "delta": 31759444.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": -31759444.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 5683023.219999999,
    "valor_anterior": 6465278.530000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1516008.73,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -323496.39,
        "delta": 1192512.34
      },
      {
        "periodo": 202509,
        "valor": 1510405.51,
        "delta": 1833901.9
      },
      {
        "periodo": 202510,
        "valor": 1205058.61,
        "delta": -305346.9
      },
      {
        "periodo": 202511,
        "valor": 4511518.52,
        "delta": 3306459.91
      },
      {
        "periodo": 202512,
        "valor": -7507666.05,
        "delta": -12019184.57
      },
      {
        "periodo": 202601,
        "valor": 9767517.62,
        "delta": 17275183.67
      },
      {
        "periodo": 202602,
        "valor": 3157914.32,
        "delta": -6609603.3
      },
      {
        "periodo": 202603,
        "valor": 9350107.53,
        "delta": 6192193.21
      },
      {
        "periodo": 202604,
        "valor": -2643227.98,
        "delta": -11993335.51
      },
      {
        "periodo": 202605,
        "valor": -10303420.38,
        "delta": -7660192.4
      },
      {
        "periodo": 202606,
        "valor": 6465278.53,
        "delta": 16768698.91
      },
      {
        "periodo": 202607,
        "valor": 5683023.22,
        "delta": -782255.31
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 10313677.159999996,
    "valor_anterior": 7326076.260000005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -452282.73,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1106960.2,
        "delta": 1559242.93
      },
      {
        "periodo": 202509,
        "valor": -226950.32,
        "delta": -1333910.52
      },
      {
        "periodo": 202510,
        "valor": -1663060.65,
        "delta": -1436110.33
      },
      {
        "periodo": 202511,
        "valor": -2858713.0,
        "delta": -1195652.35
      },
      {
        "periodo": 202512,
        "valor": -863552.0,
        "delta": 1995161.0
      },
      {
        "periodo": 202601,
        "valor": 261879.62,
        "delta": 1125431.62
      },
      {
        "periodo": 202602,
        "valor": 17744987.09,
        "delta": 17483107.47
      },
      {
        "periodo": 202603,
        "valor": 13474783.99,
        "delta": -4270203.1
      },
      {
        "periodo": 202604,
        "valor": 3312537.87,
        "delta": -10162246.12
      },
      {
        "periodo": 202605,
        "valor": 7740933.66,
        "delta": 4428395.79
      },
      {
        "periodo": 202606,
        "valor": 7326076.26,
        "delta": -414857.4
      },
      {
        "periodo": 202607,
        "valor": 10313677.16,
        "delta": 2987600.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 87922810.0,
    "valor_anterior": 87793982.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 41890145.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 52497012.0,
        "delta": 10606867.0
      },
      {
        "periodo": 202509,
        "valor": 56662750.0,
        "delta": 4165738.0
      },
      {
        "periodo": 202510,
        "valor": 70977517.0,
        "delta": 14314767.0
      },
      {
        "periodo": 202511,
        "valor": 69847179.0,
        "delta": -1130338.0
      },
      {
        "periodo": 202512,
        "valor": 110583624.0,
        "delta": 40736445.0
      },
      {
        "periodo": 202601,
        "valor": 80623831.0,
        "delta": -29959793.0
      },
      {
        "periodo": 202602,
        "valor": 80238015.0,
        "delta": -385816.0
      },
      {
        "periodo": 202603,
        "valor": 81715115.0,
        "delta": 1477100.0
      },
      {
        "periodo": 202604,
        "valor": 84061198.0,
        "delta": 2346083.0
      },
      {
        "periodo": 202605,
        "valor": 91910019.0,
        "delta": 7848821.0
      },
      {
        "periodo": 202606,
        "valor": 87793982.0,
        "delta": -4116037.0
      },
      {
        "periodo": 202607,
        "valor": 87922810.0,
        "delta": 128828.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 176299085.0,
    "valor_anterior": 17271766.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 213292966.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 333830101.0,
        "delta": 120537135.0
      },
      {
        "periodo": 202605,
        "valor": 271662591.0,
        "delta": -62167510.0
      },
      {
        "periodo": 202606,
        "valor": 17271766.0,
        "delta": -254390825.0
      },
      {
        "periodo": 202607,
        "valor": 176299085.0,
        "delta": 159027319.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 10703222570.009995,
    "valor_anterior": 11161946373.699997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9141266815.07,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9578907045.14,
        "delta": 437640230.07
      },
      {
        "periodo": 202509,
        "valor": 10043318072.63,
        "delta": 464411027.49
      },
      {
        "periodo": 202510,
        "valor": 10616515243.35,
        "delta": 573197170.72
      },
      {
        "periodo": 202511,
        "valor": 9150281753.19,
        "delta": -1466233490.16
      },
      {
        "periodo": 202512,
        "valor": 11315934231.19,
        "delta": 2165652478.0
      },
      {
        "periodo": 202601,
        "valor": 10886310655.5,
        "delta": -429623575.69
      },
      {
        "periodo": 202602,
        "valor": 8397976670.93,
        "delta": -2488333984.57
      },
      {
        "periodo": 202603,
        "valor": 13106655574.13,
        "delta": 4708678903.2
      },
      {
        "periodo": 202604,
        "valor": 9666533094.65,
        "delta": -3440122479.48
      },
      {
        "periodo": 202605,
        "valor": 9000633776.33,
        "delta": -665899318.32
      },
      {
        "periodo": 202606,
        "valor": 11161946373.7,
        "delta": 2161312597.37
      },
      {
        "periodo": 202607,
        "valor": 10703222570.01,
        "delta": -458723803.69
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 8779378167.960007,
    "valor_anterior": 8958585654.769997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7446447484.88,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7643274871.05,
        "delta": 196827386.17
      },
      {
        "periodo": 202509,
        "valor": 7339806546.82,
        "delta": -303468324.23
      },
      {
        "periodo": 202510,
        "valor": 7924798073.79,
        "delta": 584991526.97
      },
      {
        "periodo": 202511,
        "valor": 7237537394.78,
        "delta": -687260679.01
      },
      {
        "periodo": 202512,
        "valor": 9221150046.78,
        "delta": 1983612652.0
      },
      {
        "periodo": 202601,
        "valor": 8644039965.43,
        "delta": -577110081.35
      },
      {
        "periodo": 202602,
        "valor": 6505651060.26,
        "delta": -2138388905.17
      },
      {
        "periodo": 202603,
        "valor": 10983391146.94,
        "delta": 4477740086.68
      },
      {
        "periodo": 202604,
        "valor": 8410004952.14,
        "delta": -2573386194.8
      },
      {
        "periodo": 202605,
        "valor": 7588071567.02,
        "delta": -821933385.12
      },
      {
        "periodo": 202606,
        "valor": 8958585654.77,
        "delta": 1370514087.75
      },
      {
        "periodo": 202607,
        "valor": 8779378167.96,
        "delta": -179207486.81
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 327852289.1299999,
    "valor_anterior": 378240714.87,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14396577.85,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1099431.77,
        "delta": -13297146.08
      },
      {
        "periodo": 202509,
        "valor": 213267481.23,
        "delta": 212168049.46
      },
      {
        "periodo": 202510,
        "valor": 276873491.74,
        "delta": 63606010.51
      },
      {
        "periodo": 202511,
        "valor": 125588233.65,
        "delta": -151285258.09
      },
      {
        "periodo": 202512,
        "valor": 162927368.82,
        "delta": 37339135.17
      },
      {
        "periodo": 202601,
        "valor": 222636571.81,
        "delta": 59709202.99
      },
      {
        "periodo": 202602,
        "valor": 190964246.86,
        "delta": -31672324.95
      },
      {
        "periodo": 202603,
        "valor": 102621394.0,
        "delta": -88342852.86
      },
      {
        "periodo": 202604,
        "valor": 113185785.69,
        "delta": 10564391.69
      },
      {
        "periodo": 202605,
        "valor": 219865664.72,
        "delta": 106679879.03
      },
      {
        "periodo": 202606,
        "valor": 378240714.87,
        "delta": 158375050.15
      },
      {
        "periodo": 202607,
        "valor": 327852289.13,
        "delta": -50388425.74
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 782704359.4500003,
    "valor_anterior": 908241322.02,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 630405763.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 626465573.0,
        "delta": -3940190.0
      },
      {
        "periodo": 202509,
        "valor": 1293255403.0,
        "delta": 666789830.0
      },
      {
        "periodo": 202510,
        "valor": 866591862.0,
        "delta": -426663541.0
      },
      {
        "periodo": 202511,
        "valor": 548105938.0,
        "delta": -318485924.0
      },
      {
        "periodo": 202512,
        "valor": 781430612.15,
        "delta": 233324674.15
      },
      {
        "periodo": 202601,
        "valor": 817486070.0,
        "delta": 36055457.85
      },
      {
        "periodo": 202602,
        "valor": 522096739.0,
        "delta": -295389331.0
      },
      {
        "periodo": 202603,
        "valor": 1058340393.91,
        "delta": 536243654.91
      },
      {
        "periodo": 202604,
        "valor": 264105175.18,
        "delta": -794235218.73
      },
      {
        "periodo": 202605,
        "valor": 535932998.87,
        "delta": 271827823.69
      },
      {
        "periodo": 202606,
        "valor": 908241322.02,
        "delta": 372308323.15
      },
      {
        "periodo": 202607,
        "valor": 782704359.45,
        "delta": -125536962.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 741754905.75,
    "valor_anterior": 777514021.71,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 545009071.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 682588825.09,
        "delta": 137579753.94
      },
      {
        "periodo": 202509,
        "valor": 618092582.47,
        "delta": -64496242.62
      },
      {
        "periodo": 202510,
        "valor": 747883140.16,
        "delta": 129790557.69
      },
      {
        "periodo": 202511,
        "valor": 691736370.19,
        "delta": -56146769.97
      },
      {
        "periodo": 202512,
        "valor": 586678978.61,
        "delta": -105057391.58
      },
      {
        "periodo": 202601,
        "valor": 676715517.35,
        "delta": 90036538.74
      },
      {
        "periodo": 202602,
        "valor": 505541923.46,
        "delta": -171173593.89
      },
      {
        "periodo": 202603,
        "valor": 664582049.83,
        "delta": 159040126.37
      },
      {
        "periodo": 202604,
        "valor": 691035915.86,
        "delta": 26453866.03
      },
      {
        "periodo": 202605,
        "valor": 771324413.87,
        "delta": 80288498.01
      },
      {
        "periodo": 202606,
        "valor": 777514021.71,
        "delta": 6189607.84
      },
      {
        "periodo": 202607,
        "valor": 741754905.75,
        "delta": -35759115.96
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": 89143341.82999998,
    "valor_anterior": 43627882.33000004,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 66519780.37,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 116203629.08,
        "delta": 49683848.71
      },
      {
        "periodo": 202509,
        "valor": 81696748.85,
        "delta": -34506880.23
      },
      {
        "periodo": 202510,
        "valor": 98448139.79,
        "delta": 16751390.94
      },
      {
        "periodo": 202511,
        "valor": 53619308.33,
        "delta": -44828831.46
      },
      {
        "periodo": 202512,
        "valor": -7112791.53,
        "delta": -60732099.86
      },
      {
        "periodo": 202601,
        "valor": 53635058.61,
        "delta": 60747850.14
      },
      {
        "periodo": 202602,
        "valor": 70011367.62,
        "delta": 16376309.01
      },
      {
        "periodo": 202603,
        "valor": 15568155.34,
        "delta": -54443212.28
      },
      {
        "periodo": 202604,
        "valor": 80416068.65,
        "delta": 64847913.31
      },
      {
        "periodo": 202605,
        "valor": 108186118.55,
        "delta": 27770049.9
      },
      {
        "periodo": 202606,
        "valor": 43627882.33,
        "delta": -64558236.22
      },
      {
        "periodo": 202607,
        "valor": 89143341.83,
        "delta": 45515459.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200217,
    "label": "Impuestos a la Utilidad",
    "valor_actual": -17610494.109999895,
    "valor_anterior": 95736778.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 438488137.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 509274715.15,
        "delta": 70786577.33
      },
      {
        "periodo": 202509,
        "valor": 497199310.26,
        "delta": -12075404.89
      },
      {
        "periodo": 202510,
        "valor": 701920535.87,
        "delta": 204721225.61
      },
      {
        "periodo": 202511,
        "valor": 493694508.24,
        "delta": -208226027.63
      },
      {
        "periodo": 202512,
        "valor": 570860016.36,
        "delta": 77165508.12
      },
      {
        "periodo": 202601,
        "valor": 471797472.3,
        "delta": -99062544.06
      },
      {
        "periodo": 202602,
        "valor": 603711333.73,
        "delta": 131913861.43
      },
      {
        "periodo": 202603,
        "valor": 282152434.11,
        "delta": -321558899.62
      },
      {
        "periodo": 202604,
        "valor": 107785197.13,
        "delta": -174367236.98
      },
      {
        "periodo": 202605,
        "valor": -222746986.7,
        "delta": -330532183.83
      },
      {
        "periodo": 202606,
        "valor": 95736778.0,
        "delta": 318483764.7
      },
      {
        "periodo": 202607,
        "valor": -17610494.11,
        "delta": -113347272.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  }
],

  // Banner 3: Indicadores de riesgo crediticio + intermedios (flujo 12 meses)
  banner3: [
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 3.053724,
    "valor_anterior": 3.068073,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.6305,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.6259,
        "delta": -0.0046
      },
      {
        "periodo": 202508,
        "valor": 2.6353,
        "delta": 0.0094
      },
      {
        "periodo": 202509,
        "valor": 2.5785,
        "delta": -0.0569
      },
      {
        "periodo": 202510,
        "valor": 2.5847,
        "delta": 0.0062
      },
      {
        "periodo": 202511,
        "valor": 2.5935,
        "delta": 0.0087
      },
      {
        "periodo": 202512,
        "valor": 2.6026,
        "delta": 0.0091
      },
      {
        "periodo": 202601,
        "valor": 2.673,
        "delta": 0.0705
      },
      {
        "periodo": 202602,
        "valor": 2.6347,
        "delta": -0.0384
      },
      {
        "periodo": 202603,
        "valor": 2.6785,
        "delta": 0.0438
      },
      {
        "periodo": 202604,
        "valor": 2.5555,
        "delta": -0.123
      },
      {
        "periodo": 202605,
        "valor": 3.0681,
        "delta": 0.5125
      },
      {
        "periodo": 202606,
        "valor": 3.0537,
        "delta": -0.0143
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.445552,
    "valor_anterior": 2.540962,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.5086,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.4967,
        "delta": -0.0119
      },
      {
        "periodo": 202508,
        "valor": 2.5529,
        "delta": 0.0562
      },
      {
        "periodo": 202509,
        "valor": 2.4964,
        "delta": -0.0565
      },
      {
        "periodo": 202510,
        "valor": 2.5074,
        "delta": 0.011
      },
      {
        "periodo": 202511,
        "valor": 2.5179,
        "delta": 0.0105
      },
      {
        "periodo": 202512,
        "valor": 2.5189,
        "delta": 0.001
      },
      {
        "periodo": 202601,
        "valor": 2.521,
        "delta": 0.0021
      },
      {
        "periodo": 202602,
        "valor": 2.5806,
        "delta": 0.0596
      },
      {
        "periodo": 202603,
        "valor": 2.5171,
        "delta": -0.0635
      },
      {
        "periodo": 202604,
        "valor": 2.5485,
        "delta": 0.0314
      },
      {
        "periodo": 202605,
        "valor": 2.541,
        "delta": -0.0075
      },
      {
        "periodo": 202606,
        "valor": 2.4456,
        "delta": -0.0954
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.396931,
    "valor_anterior": 2.416188,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.4304,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.5321,
        "delta": 0.1017
      },
      {
        "periodo": 202508,
        "valor": 2.4656,
        "delta": -0.0665
      },
      {
        "periodo": 202509,
        "valor": 2.5024,
        "delta": 0.0368
      },
      {
        "periodo": 202510,
        "valor": 2.49,
        "delta": -0.0124
      },
      {
        "periodo": 202511,
        "valor": 2.4711,
        "delta": -0.0189
      },
      {
        "periodo": 202512,
        "valor": 2.3112,
        "delta": -0.1598
      },
      {
        "periodo": 202601,
        "valor": 2.3664,
        "delta": 0.0551
      },
      {
        "periodo": 202602,
        "valor": 2.3934,
        "delta": 0.027
      },
      {
        "periodo": 202603,
        "valor": 2.472,
        "delta": 0.0786
      },
      {
        "periodo": 202604,
        "valor": 2.4391,
        "delta": -0.0329
      },
      {
        "periodo": 202605,
        "valor": 2.4162,
        "delta": -0.0229
      },
      {
        "periodo": 202606,
        "valor": 2.3969,
        "delta": -0.0193
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.424423,
    "valor_anterior": 2.505325,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.2375,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.279,
        "delta": 0.0415
      },
      {
        "periodo": 202508,
        "valor": 2.3027,
        "delta": 0.0237
      },
      {
        "periodo": 202509,
        "valor": 2.3066,
        "delta": 0.0039
      },
      {
        "periodo": 202510,
        "valor": 2.4906,
        "delta": 0.184
      },
      {
        "periodo": 202511,
        "valor": 2.4663,
        "delta": -0.0244
      },
      {
        "periodo": 202512,
        "valor": 2.4223,
        "delta": -0.044
      },
      {
        "periodo": 202601,
        "valor": 2.4418,
        "delta": 0.0195
      },
      {
        "periodo": 202602,
        "valor": 2.4436,
        "delta": 0.0018
      },
      {
        "periodo": 202603,
        "valor": 2.4753,
        "delta": 0.0317
      },
      {
        "periodo": 202604,
        "valor": 2.4859,
        "delta": 0.0106
      },
      {
        "periodo": 202605,
        "valor": 2.5053,
        "delta": 0.0194
      },
      {
        "periodo": 202606,
        "valor": 2.4244,
        "delta": -0.0809
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.837499,
    "valor_anterior": 1.845154,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.8157,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.8387,
        "delta": 0.023
      },
      {
        "periodo": 202508,
        "valor": 1.9415,
        "delta": 0.1028
      },
      {
        "periodo": 202509,
        "valor": 1.986,
        "delta": 0.0445
      },
      {
        "periodo": 202510,
        "valor": 1.9992,
        "delta": 0.0131
      },
      {
        "periodo": 202511,
        "valor": 1.9535,
        "delta": -0.0457
      },
      {
        "periodo": 202512,
        "valor": 1.9331,
        "delta": -0.0204
      },
      {
        "periodo": 202601,
        "valor": 2.0045,
        "delta": 0.0714
      },
      {
        "periodo": 202602,
        "valor": 2.0335,
        "delta": 0.0291
      },
      {
        "periodo": 202603,
        "valor": 1.9985,
        "delta": -0.035
      },
      {
        "periodo": 202604,
        "valor": 1.8327,
        "delta": -0.1658
      },
      {
        "periodo": 202605,
        "valor": 1.8452,
        "delta": 0.0124
      },
      {
        "periodo": 202606,
        "valor": 1.8375,
        "delta": -0.0077
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.898891,
    "valor_anterior": 2.914536,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.9055,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.9253,
        "delta": 0.0198
      },
      {
        "periodo": 202508,
        "valor": 2.9427,
        "delta": 0.0174
      },
      {
        "periodo": 202509,
        "valor": 2.9319,
        "delta": -0.0107
      },
      {
        "periodo": 202510,
        "valor": 2.9213,
        "delta": -0.0107
      },
      {
        "periodo": 202511,
        "valor": 2.9565,
        "delta": 0.0352
      },
      {
        "periodo": 202512,
        "valor": 2.9445,
        "delta": -0.012
      },
      {
        "periodo": 202601,
        "valor": 2.9278,
        "delta": -0.0167
      },
      {
        "periodo": 202602,
        "valor": 2.9079,
        "delta": -0.0199
      },
      {
        "periodo": 202603,
        "valor": 2.9061,
        "delta": -0.0018
      },
      {
        "periodo": 202604,
        "valor": 2.9113,
        "delta": 0.0053
      },
      {
        "periodo": 202605,
        "valor": 2.9145,
        "delta": 0.0032
      },
      {
        "periodo": 202606,
        "valor": 2.8989,
        "delta": -0.0156
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.640503,
    "valor_anterior": 2.638799,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.076,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.0919,
        "delta": 0.0159
      },
      {
        "periodo": 202508,
        "valor": 2.0238,
        "delta": -0.0681
      },
      {
        "periodo": 202509,
        "valor": 2.0772,
        "delta": 0.0534
      },
      {
        "periodo": 202510,
        "valor": 2.0964,
        "delta": 0.0192
      },
      {
        "periodo": 202511,
        "valor": 2.0895,
        "delta": -0.0069
      },
      {
        "periodo": 202512,
        "valor": 2.1488,
        "delta": 0.0593
      },
      {
        "periodo": 202601,
        "valor": 2.13,
        "delta": -0.0189
      },
      {
        "periodo": 202602,
        "valor": 2.1398,
        "delta": 0.0098
      },
      {
        "periodo": 202603,
        "valor": 2.1429,
        "delta": 0.0031
      },
      {
        "periodo": 202604,
        "valor": 2.129,
        "delta": -0.0139
      },
      {
        "periodo": 202605,
        "valor": 2.6388,
        "delta": 0.5098
      },
      {
        "periodo": 202606,
        "valor": 2.6405,
        "delta": 0.0017
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.613765,
    "valor_anterior": 2.574659,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.3394,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.3649,
        "delta": 0.0255
      },
      {
        "periodo": 202508,
        "valor": 2.3579,
        "delta": -0.007
      },
      {
        "periodo": 202509,
        "valor": 2.4039,
        "delta": 0.046
      },
      {
        "periodo": 202510,
        "valor": 2.3917,
        "delta": -0.0122
      },
      {
        "periodo": 202511,
        "valor": 2.3984,
        "delta": 0.0067
      },
      {
        "periodo": 202512,
        "valor": 2.5515,
        "delta": 0.1531
      },
      {
        "periodo": 202601,
        "valor": 2.5367,
        "delta": -0.0148
      },
      {
        "periodo": 202602,
        "valor": 2.5954,
        "delta": 0.0587
      },
      {
        "periodo": 202603,
        "valor": 2.6269,
        "delta": 0.0315
      },
      {
        "periodo": 202604,
        "valor": 2.5899,
        "delta": -0.037
      },
      {
        "periodo": 202605,
        "valor": 2.5747,
        "delta": -0.0152
      },
      {
        "periodo": 202606,
        "valor": 2.6138,
        "delta": 0.0391
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.937065,
    "valor_anterior": 1.900346,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.7963,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.8245,
        "delta": 0.0283
      },
      {
        "periodo": 202508,
        "valor": 1.8338,
        "delta": 0.0092
      },
      {
        "periodo": 202509,
        "valor": 1.8413,
        "delta": 0.0075
      },
      {
        "periodo": 202510,
        "valor": 1.8787,
        "delta": 0.0374
      },
      {
        "periodo": 202511,
        "valor": 1.8202,
        "delta": -0.0585
      },
      {
        "periodo": 202512,
        "valor": 1.8763,
        "delta": 0.0561
      },
      {
        "periodo": 202601,
        "valor": 1.8838,
        "delta": 0.0075
      },
      {
        "periodo": 202602,
        "valor": 1.967,
        "delta": 0.0831
      },
      {
        "periodo": 202603,
        "valor": 1.8824,
        "delta": -0.0846
      },
      {
        "periodo": 202604,
        "valor": 1.8846,
        "delta": 0.0022
      },
      {
        "periodo": 202605,
        "valor": 1.9003,
        "delta": 0.0157
      },
      {
        "periodo": 202606,
        "valor": 1.9371,
        "delta": 0.0367
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.95802,
    "valor_anterior": 1.923396,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.0099,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.9922,
        "delta": -0.0177
      },
      {
        "periodo": 202508,
        "valor": 1.9651,
        "delta": -0.0271
      },
      {
        "periodo": 202509,
        "valor": 1.9702,
        "delta": 0.0051
      },
      {
        "periodo": 202510,
        "valor": 1.9967,
        "delta": 0.0265
      },
      {
        "periodo": 202511,
        "valor": 1.9678,
        "delta": -0.0289
      },
      {
        "periodo": 202512,
        "valor": 2.0471,
        "delta": 0.0793
      },
      {
        "periodo": 202601,
        "valor": 1.9568,
        "delta": -0.0903
      },
      {
        "periodo": 202602,
        "valor": 1.9274,
        "delta": -0.0295
      },
      {
        "periodo": 202603,
        "valor": 1.8991,
        "delta": -0.0283
      },
      {
        "periodo": 202604,
        "valor": 1.9517,
        "delta": 0.0527
      },
      {
        "periodo": 202605,
        "valor": 1.9234,
        "delta": -0.0283
      },
      {
        "periodo": 202606,
        "valor": 1.958,
        "delta": 0.0346
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 3.232938,
    "valor_anterior": 3.115194,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.9577,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.7817,
        "delta": -0.176
      },
      {
        "periodo": 202508,
        "valor": 2.7293,
        "delta": -0.0524
      },
      {
        "periodo": 202509,
        "valor": 2.8357,
        "delta": 0.1064
      },
      {
        "periodo": 202510,
        "valor": 2.9089,
        "delta": 0.0733
      },
      {
        "periodo": 202511,
        "valor": 2.7876,
        "delta": -0.1214
      },
      {
        "periodo": 202512,
        "valor": 2.8416,
        "delta": 0.0541
      },
      {
        "periodo": 202601,
        "valor": 2.9248,
        "delta": 0.0832
      },
      {
        "periodo": 202602,
        "valor": 2.9571,
        "delta": 0.0322
      },
      {
        "periodo": 202603,
        "valor": 3.0835,
        "delta": 0.1264
      },
      {
        "periodo": 202604,
        "valor": 3.0808,
        "delta": -0.0027
      },
      {
        "periodo": 202605,
        "valor": 3.1152,
        "delta": 0.0344
      },
      {
        "periodo": 202606,
        "valor": 3.2329,
        "delta": 0.1177
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.043259,
    "valor_anterior": 1.943554,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.8968,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.9189,
        "delta": 0.0222
      },
      {
        "periodo": 202508,
        "valor": 1.9143,
        "delta": -0.0046
      },
      {
        "periodo": 202509,
        "valor": 1.9083,
        "delta": -0.0061
      },
      {
        "periodo": 202510,
        "valor": 1.8909,
        "delta": -0.0174
      },
      {
        "periodo": 202511,
        "valor": 1.8826,
        "delta": -0.0083
      },
      {
        "periodo": 202512,
        "valor": 1.9234,
        "delta": 0.0408
      },
      {
        "periodo": 202601,
        "valor": 1.902,
        "delta": -0.0214
      },
      {
        "periodo": 202602,
        "valor": 1.9098,
        "delta": 0.0078
      },
      {
        "periodo": 202603,
        "valor": 1.9679,
        "delta": 0.058
      },
      {
        "periodo": 202604,
        "valor": 1.9498,
        "delta": -0.0181
      },
      {
        "periodo": 202605,
        "valor": 1.9436,
        "delta": -0.0062
      },
      {
        "periodo": 202606,
        "valor": 2.0433,
        "delta": 0.0997
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.687351,
    "valor_anterior": 2.386682,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.7145,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.7795,
        "delta": 0.0651
      },
      {
        "periodo": 202508,
        "valor": 2.7712,
        "delta": -0.0083
      },
      {
        "periodo": 202509,
        "valor": 2.7891,
        "delta": 0.0178
      },
      {
        "periodo": 202510,
        "valor": 2.8064,
        "delta": 0.0173
      },
      {
        "periodo": 202511,
        "valor": 2.5438,
        "delta": -0.2626
      },
      {
        "periodo": 202512,
        "valor": 2.5079,
        "delta": -0.0359
      },
      {
        "periodo": 202601,
        "valor": 2.4,
        "delta": -0.1079
      },
      {
        "periodo": 202602,
        "valor": 2.4346,
        "delta": 0.0346
      },
      {
        "periodo": 202603,
        "valor": 2.4678,
        "delta": 0.0332
      },
      {
        "periodo": 202604,
        "valor": 2.3545,
        "delta": -0.1133
      },
      {
        "periodo": 202605,
        "valor": 2.3867,
        "delta": 0.0321
      },
      {
        "periodo": 202606,
        "valor": 2.6874,
        "delta": 0.3007
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.329763,
    "valor_anterior": 2.34513,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.2012,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.2708,
        "delta": 0.0696
      },
      {
        "periodo": 202508,
        "valor": 2.115,
        "delta": -0.1557
      },
      {
        "periodo": 202509,
        "valor": 2.1772,
        "delta": 0.0621
      },
      {
        "periodo": 202510,
        "valor": 2.2238,
        "delta": 0.0466
      },
      {
        "periodo": 202511,
        "valor": 2.2416,
        "delta": 0.0178
      },
      {
        "periodo": 202512,
        "valor": 2.3432,
        "delta": 0.1015
      },
      {
        "periodo": 202601,
        "valor": 2.4497,
        "delta": 0.1065
      },
      {
        "periodo": 202602,
        "valor": 2.3461,
        "delta": -0.1036
      },
      {
        "periodo": 202603,
        "valor": 2.3774,
        "delta": 0.0314
      },
      {
        "periodo": 202604,
        "valor": 2.4424,
        "delta": 0.065
      },
      {
        "periodo": 202605,
        "valor": 2.3451,
        "delta": -0.0973
      },
      {
        "periodo": 202606,
        "valor": 2.3298,
        "delta": -0.0154
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 6.517954,
    "valor_anterior": 5.539038,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 6.3599,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 6.2326,
        "delta": -0.1273
      },
      {
        "periodo": 202508,
        "valor": 6.0255,
        "delta": -0.207
      },
      {
        "periodo": 202509,
        "valor": 6.4018,
        "delta": 0.3762
      },
      {
        "periodo": 202510,
        "valor": 5.4789,
        "delta": -0.9229
      },
      {
        "periodo": 202511,
        "valor": 5.3739,
        "delta": -0.105
      },
      {
        "periodo": 202512,
        "valor": 5.9452,
        "delta": 0.5713
      },
      {
        "periodo": 202601,
        "valor": 5.956,
        "delta": 0.0108
      },
      {
        "periodo": 202602,
        "valor": 5.4439,
        "delta": -0.5121
      },
      {
        "periodo": 202603,
        "valor": 5.4707,
        "delta": 0.0267
      },
      {
        "periodo": 202604,
        "valor": 5.5593,
        "delta": 0.0886
      },
      {
        "periodo": 202605,
        "valor": 5.539,
        "delta": -0.0202
      },
      {
        "periodo": 202606,
        "valor": 6.518,
        "delta": 0.9789
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 5.849216,
    "valor_anterior": 5.626418,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5.5136,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 5.6359,
        "delta": 0.1223
      },
      {
        "periodo": 202508,
        "valor": 5.6869,
        "delta": 0.051
      },
      {
        "periodo": 202509,
        "valor": 5.7889,
        "delta": 0.102
      },
      {
        "periodo": 202510,
        "valor": 5.6613,
        "delta": -0.1276
      },
      {
        "periodo": 202511,
        "valor": 5.7684,
        "delta": 0.1071
      },
      {
        "periodo": 202512,
        "valor": 6.2179,
        "delta": 0.4494
      },
      {
        "periodo": 202601,
        "valor": 5.821,
        "delta": -0.3969
      },
      {
        "periodo": 202602,
        "valor": 5.4006,
        "delta": -0.4203
      },
      {
        "periodo": 202603,
        "valor": 5.6568,
        "delta": 0.2561
      },
      {
        "periodo": 202604,
        "valor": 5.6188,
        "delta": -0.038
      },
      {
        "periodo": 202605,
        "valor": 5.6264,
        "delta": 0.0076
      },
      {
        "periodo": 202606,
        "valor": 5.8492,
        "delta": 0.2228
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.424694,
    "valor_anterior": 2.480888,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.2737,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.2357,
        "delta": -0.038
      },
      {
        "periodo": 202508,
        "valor": 2.2817,
        "delta": 0.046
      },
      {
        "periodo": 202509,
        "valor": 2.3896,
        "delta": 0.1079
      },
      {
        "periodo": 202510,
        "valor": 2.4442,
        "delta": 0.0547
      },
      {
        "periodo": 202511,
        "valor": 2.438,
        "delta": -0.0062
      },
      {
        "periodo": 202512,
        "valor": 2.3382,
        "delta": -0.0999
      },
      {
        "periodo": 202601,
        "valor": 2.3755,
        "delta": 0.0374
      },
      {
        "periodo": 202602,
        "valor": 2.4029,
        "delta": 0.0274
      },
      {
        "periodo": 202603,
        "valor": 2.4565,
        "delta": 0.0536
      },
      {
        "periodo": 202604,
        "valor": 2.3534,
        "delta": -0.1031
      },
      {
        "periodo": 202605,
        "valor": 2.4809,
        "delta": 0.1275
      },
      {
        "periodo": 202606,
        "valor": 2.4247,
        "delta": -0.0562
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.883523,
    "valor_anterior": 1.905748,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.8427,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.8558,
        "delta": 0.0131
      },
      {
        "periodo": 202508,
        "valor": 1.8596,
        "delta": 0.0038
      },
      {
        "periodo": 202509,
        "valor": 1.8253,
        "delta": -0.0343
      },
      {
        "periodo": 202510,
        "valor": 1.8461,
        "delta": 0.0208
      },
      {
        "periodo": 202511,
        "valor": 1.8069,
        "delta": -0.0393
      },
      {
        "periodo": 202512,
        "valor": 1.8301,
        "delta": 0.0232
      },
      {
        "periodo": 202601,
        "valor": 1.8695,
        "delta": 0.0394
      },
      {
        "periodo": 202602,
        "valor": 1.8619,
        "delta": -0.0076
      },
      {
        "periodo": 202603,
        "valor": 1.8209,
        "delta": -0.041
      },
      {
        "periodo": 202604,
        "valor": 1.9024,
        "delta": 0.0815
      },
      {
        "periodo": 202605,
        "valor": 1.9057,
        "delta": 0.0033
      },
      {
        "periodo": 202606,
        "valor": 1.8835,
        "delta": -0.0222
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 3.219272,
    "valor_anterior": 3.246809,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.7126,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.7853,
        "delta": 0.0727
      },
      {
        "periodo": 202508,
        "valor": 2.7969,
        "delta": 0.0116
      },
      {
        "periodo": 202509,
        "valor": 2.9087,
        "delta": 0.1118
      },
      {
        "periodo": 202510,
        "valor": 2.8783,
        "delta": -0.0304
      },
      {
        "periodo": 202511,
        "valor": 2.8794,
        "delta": 0.0011
      },
      {
        "periodo": 202512,
        "valor": 3.1596,
        "delta": 0.2802
      },
      {
        "periodo": 202601,
        "valor": 3.1255,
        "delta": -0.034
      },
      {
        "periodo": 202602,
        "valor": 2.9972,
        "delta": -0.1284
      },
      {
        "periodo": 202603,
        "valor": 3.0472,
        "delta": 0.05
      },
      {
        "periodo": 202604,
        "valor": 3.0472,
        "delta": -0.0001
      },
      {
        "periodo": 202605,
        "valor": 3.2468,
        "delta": 0.1997
      },
      {
        "periodo": 202606,
        "valor": 3.2193,
        "delta": -0.0275
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 28.596862,
    "valor_anterior": 29.710557,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 19.1806,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18.843,
        "delta": -0.3376
      },
      {
        "periodo": 202508,
        "valor": 20.094,
        "delta": 1.2511
      },
      {
        "periodo": 202509,
        "valor": 22.0275,
        "delta": 1.9335
      },
      {
        "periodo": 202510,
        "valor": 21.3099,
        "delta": -0.7176
      },
      {
        "periodo": 202511,
        "valor": 23.0423,
        "delta": 1.7324
      },
      {
        "periodo": 202512,
        "valor": 23.2024,
        "delta": 0.1601
      },
      {
        "periodo": 202601,
        "valor": 24.2376,
        "delta": 1.0351
      },
      {
        "periodo": 202602,
        "valor": 24.4091,
        "delta": 0.1716
      },
      {
        "periodo": 202603,
        "valor": 25.8688,
        "delta": 1.4597
      },
      {
        "periodo": 202604,
        "valor": 26.2348,
        "delta": 0.366
      },
      {
        "periodo": 202605,
        "valor": 29.7106,
        "delta": 3.4757
      },
      {
        "periodo": 202606,
        "valor": 28.5969,
        "delta": -1.1137
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.833567,
    "valor_anterior": 1.858429,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.8386,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.7957,
        "delta": -0.0429
      },
      {
        "periodo": 202508,
        "valor": 1.7514,
        "delta": -0.0442
      },
      {
        "periodo": 202509,
        "valor": 1.8675,
        "delta": 0.1161
      },
      {
        "periodo": 202510,
        "valor": 1.8965,
        "delta": 0.029
      },
      {
        "periodo": 202511,
        "valor": 1.8928,
        "delta": -0.0038
      },
      {
        "periodo": 202512,
        "valor": 1.9378,
        "delta": 0.0451
      },
      {
        "periodo": 202601,
        "valor": 1.8881,
        "delta": -0.0497
      },
      {
        "periodo": 202602,
        "valor": 1.8872,
        "delta": -0.001
      },
      {
        "periodo": 202603,
        "valor": 1.9421,
        "delta": 0.0549
      },
      {
        "periodo": 202604,
        "valor": 1.9147,
        "delta": -0.0273
      },
      {
        "periodo": 202605,
        "valor": 1.8584,
        "delta": -0.0563
      },
      {
        "periodo": 202606,
        "valor": 1.8336,
        "delta": -0.0249
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.665689,
    "valor_anterior": 1.643583,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.6535,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.6511,
        "delta": -0.0023
      },
      {
        "periodo": 202508,
        "valor": 1.5124,
        "delta": -0.1388
      },
      {
        "periodo": 202509,
        "valor": 1.6661,
        "delta": 0.1537
      },
      {
        "periodo": 202510,
        "valor": 1.9246,
        "delta": 0.2585
      },
      {
        "periodo": 202511,
        "valor": 1.8425,
        "delta": -0.0821
      },
      {
        "periodo": 202512,
        "valor": 1.5816,
        "delta": -0.261
      },
      {
        "periodo": 202601,
        "valor": 1.6886,
        "delta": 0.107
      },
      {
        "periodo": 202602,
        "valor": 1.7341,
        "delta": 0.0455
      },
      {
        "periodo": 202603,
        "valor": 1.7482,
        "delta": 0.0141
      },
      {
        "periodo": 202604,
        "valor": 1.7411,
        "delta": -0.0071
      },
      {
        "periodo": 202605,
        "valor": 1.6436,
        "delta": -0.0975
      },
      {
        "periodo": 202606,
        "valor": 1.6657,
        "delta": 0.0221
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.562818,
    "valor_anterior": 3.010788,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.8865,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3.0815,
        "delta": 0.195
      },
      {
        "periodo": 202508,
        "valor": 2.8855,
        "delta": -0.196
      },
      {
        "periodo": 202509,
        "valor": 3.1594,
        "delta": 0.2739
      },
      {
        "periodo": 202510,
        "valor": 3.1535,
        "delta": -0.0059
      },
      {
        "periodo": 202511,
        "valor": 2.8816,
        "delta": -0.2719
      },
      {
        "periodo": 202512,
        "valor": 3.0324,
        "delta": 0.1508
      },
      {
        "periodo": 202601,
        "valor": 2.7988,
        "delta": -0.2336
      },
      {
        "periodo": 202602,
        "valor": 2.8622,
        "delta": 0.0634
      },
      {
        "periodo": 202603,
        "valor": 2.628,
        "delta": -0.2342
      },
      {
        "periodo": 202604,
        "valor": 2.625,
        "delta": -0.003
      },
      {
        "periodo": 202605,
        "valor": 3.0108,
        "delta": 0.3858
      },
      {
        "periodo": 202606,
        "valor": 2.5628,
        "delta": -0.448
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 4.013058,
    "valor_anterior": 3.989338,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 3.8328,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3.7313,
        "delta": -0.1015
      },
      {
        "periodo": 202508,
        "valor": 3.7823,
        "delta": 0.051
      },
      {
        "periodo": 202509,
        "valor": 3.964,
        "delta": 0.1817
      },
      {
        "periodo": 202510,
        "valor": 4.0069,
        "delta": 0.0429
      },
      {
        "periodo": 202511,
        "valor": 3.631,
        "delta": -0.3759
      },
      {
        "periodo": 202512,
        "valor": 3.7439,
        "delta": 0.1129
      },
      {
        "periodo": 202601,
        "valor": 4.0043,
        "delta": 0.2603
      },
      {
        "periodo": 202602,
        "valor": 4.0428,
        "delta": 0.0386
      },
      {
        "periodo": 202603,
        "valor": 4.0408,
        "delta": -0.0021
      },
      {
        "periodo": 202604,
        "valor": 3.8128,
        "delta": -0.2279
      },
      {
        "periodo": 202605,
        "valor": 3.9893,
        "delta": 0.1765
      },
      {
        "periodo": 202606,
        "valor": 4.0131,
        "delta": 0.0237
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.885205,
    "valor_anterior": 1.945431,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.0426,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.0144,
        "delta": -0.0282
      },
      {
        "periodo": 202508,
        "valor": 2.0431,
        "delta": 0.0287
      },
      {
        "periodo": 202509,
        "valor": 1.9419,
        "delta": -0.1012
      },
      {
        "periodo": 202510,
        "valor": 1.9195,
        "delta": -0.0224
      },
      {
        "periodo": 202511,
        "valor": 1.9717,
        "delta": 0.0522
      },
      {
        "periodo": 202512,
        "valor": 1.9267,
        "delta": -0.045
      },
      {
        "periodo": 202601,
        "valor": 2.0117,
        "delta": 0.085
      },
      {
        "periodo": 202602,
        "valor": 2.0147,
        "delta": 0.003
      },
      {
        "periodo": 202603,
        "valor": 2.0721,
        "delta": 0.0573
      },
      {
        "periodo": 202604,
        "valor": 1.9817,
        "delta": -0.0904
      },
      {
        "periodo": 202605,
        "valor": 1.9454,
        "delta": -0.0362
      },
      {
        "periodo": 202606,
        "valor": 1.8852,
        "delta": -0.0602
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.15585,
    "valor_anterior": 2.234976,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.2784,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.2746,
        "delta": -0.0038
      },
      {
        "periodo": 202508,
        "valor": 2.183,
        "delta": -0.0916
      },
      {
        "periodo": 202509,
        "valor": 2.2577,
        "delta": 0.0747
      },
      {
        "periodo": 202510,
        "valor": 2.233,
        "delta": -0.0247
      },
      {
        "periodo": 202511,
        "valor": 2.1034,
        "delta": -0.1296
      },
      {
        "periodo": 202512,
        "valor": 2.1184,
        "delta": 0.0149
      },
      {
        "periodo": 202601,
        "valor": 2.1217,
        "delta": 0.0034
      },
      {
        "periodo": 202602,
        "valor": 2.1504,
        "delta": 0.0287
      },
      {
        "periodo": 202603,
        "valor": 2.1128,
        "delta": -0.0376
      },
      {
        "periodo": 202604,
        "valor": 2.1634,
        "delta": 0.0505
      },
      {
        "periodo": 202605,
        "valor": 2.235,
        "delta": 0.0716
      },
      {
        "periodo": 202606,
        "valor": 2.1559,
        "delta": -0.0791
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 3.150912,
    "valor_anterior": 3.070293,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.202,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3.224,
        "delta": 1.022
      },
      {
        "periodo": 202508,
        "valor": 4.1173,
        "delta": 0.8933
      },
      {
        "periodo": 202509,
        "valor": 6.7231,
        "delta": 2.6058
      },
      {
        "periodo": 202510,
        "valor": 6.9871,
        "delta": 0.2641
      },
      {
        "periodo": 202511,
        "valor": 2.7676,
        "delta": -4.2195
      },
      {
        "periodo": 202512,
        "valor": 2.9848,
        "delta": 0.2172
      },
      {
        "periodo": 202601,
        "valor": 3.086,
        "delta": 0.1011
      },
      {
        "periodo": 202602,
        "valor": 3.2203,
        "delta": 0.1344
      },
      {
        "periodo": 202603,
        "valor": 3.3727,
        "delta": 0.1524
      },
      {
        "periodo": 202604,
        "valor": 2.9688,
        "delta": -0.4039
      },
      {
        "periodo": 202605,
        "valor": 3.0703,
        "delta": 0.1015
      },
      {
        "periodo": 202606,
        "valor": 3.1509,
        "delta": 0.0806
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.955429,
    "valor_anterior": 1.773849,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.1837,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.1626,
        "delta": -0.0211
      },
      {
        "periodo": 202508,
        "valor": 1.9758,
        "delta": -0.1869
      },
      {
        "periodo": 202509,
        "valor": 1.9901,
        "delta": 0.0144
      },
      {
        "periodo": 202510,
        "valor": 1.9637,
        "delta": -0.0265
      },
      {
        "periodo": 202511,
        "valor": 1.8806,
        "delta": -0.0831
      },
      {
        "periodo": 202512,
        "valor": 1.8762,
        "delta": -0.0044
      },
      {
        "periodo": 202601,
        "valor": 1.8588,
        "delta": -0.0174
      },
      {
        "periodo": 202602,
        "valor": 1.8812,
        "delta": 0.0225
      },
      {
        "periodo": 202603,
        "valor": 1.8215,
        "delta": -0.0597
      },
      {
        "periodo": 202604,
        "valor": 1.8522,
        "delta": 0.0307
      },
      {
        "periodo": 202605,
        "valor": 1.7738,
        "delta": -0.0783
      },
      {
        "periodo": 202606,
        "valor": 1.9554,
        "delta": 0.1816
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 3.646028,
    "valor_anterior": 2.8153,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5.5981,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4.5552,
        "delta": -1.0429
      },
      {
        "periodo": 202508,
        "valor": 5.7749,
        "delta": 1.2197
      },
      {
        "periodo": 202509,
        "valor": 5.1946,
        "delta": -0.5803
      },
      {
        "periodo": 202510,
        "valor": 4.5359,
        "delta": -0.6587
      },
      {
        "periodo": 202511,
        "valor": 3.6129,
        "delta": -0.923
      },
      {
        "periodo": 202512,
        "valor": 4.735,
        "delta": 1.1221
      },
      {
        "periodo": 202601,
        "valor": 4.2006,
        "delta": -0.5344
      },
      {
        "periodo": 202602,
        "valor": 3.2584,
        "delta": -0.9422
      },
      {
        "periodo": 202603,
        "valor": 3.9409,
        "delta": 0.6825
      },
      {
        "periodo": 202604,
        "valor": 3.1069,
        "delta": -0.834
      },
      {
        "periodo": 202605,
        "valor": 2.8153,
        "delta": -0.2916
      },
      {
        "periodo": 202606,
        "valor": 3.646,
        "delta": 0.8307
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.879786,
    "valor_anterior": 1.888699,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.9242,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.2175,
        "delta": 0.2932
      },
      {
        "periodo": 202508,
        "valor": 2.1058,
        "delta": -0.1117
      },
      {
        "periodo": 202509,
        "valor": 2.1502,
        "delta": 0.0444
      },
      {
        "periodo": 202510,
        "valor": 1.9615,
        "delta": -0.1887
      },
      {
        "periodo": 202511,
        "valor": 1.9162,
        "delta": -0.0452
      },
      {
        "periodo": 202512,
        "valor": 2.644,
        "delta": 0.7277
      },
      {
        "periodo": 202601,
        "valor": 2.2757,
        "delta": -0.3683
      },
      {
        "periodo": 202602,
        "valor": 1.9349,
        "delta": -0.3408
      },
      {
        "periodo": 202603,
        "valor": 2.1359,
        "delta": 0.201
      },
      {
        "periodo": 202604,
        "valor": 1.9213,
        "delta": -0.2146
      },
      {
        "periodo": 202605,
        "valor": 1.8887,
        "delta": -0.0326
      },
      {
        "periodo": 202606,
        "valor": 1.8798,
        "delta": -0.0089
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.774214,
    "valor_anterior": 1.766142,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.688,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.7109,
        "delta": 0.0228
      },
      {
        "periodo": 202508,
        "valor": 1.6795,
        "delta": -0.0314
      },
      {
        "periodo": 202509,
        "valor": 1.7171,
        "delta": 0.0376
      },
      {
        "periodo": 202510,
        "valor": 1.6968,
        "delta": -0.0203
      },
      {
        "periodo": 202511,
        "valor": 1.7466,
        "delta": 0.0498
      },
      {
        "periodo": 202512,
        "valor": 1.7463,
        "delta": -0.0003
      },
      {
        "periodo": 202601,
        "valor": 1.7303,
        "delta": -0.016
      },
      {
        "periodo": 202602,
        "valor": 1.6908,
        "delta": -0.0395
      },
      {
        "periodo": 202603,
        "valor": 1.7195,
        "delta": 0.0287
      },
      {
        "periodo": 202604,
        "valor": 1.7153,
        "delta": -0.0042
      },
      {
        "periodo": 202605,
        "valor": 1.7661,
        "delta": 0.0509
      },
      {
        "periodo": 202606,
        "valor": 1.7742,
        "delta": 0.0081
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 3.736176,
    "valor_anterior": 3.689433,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 3.4338,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3.4382,
        "delta": 0.0045
      },
      {
        "periodo": 202508,
        "valor": 3.4198,
        "delta": -0.0184
      },
      {
        "periodo": 202509,
        "valor": 3.5775,
        "delta": 0.1577
      },
      {
        "periodo": 202510,
        "valor": 3.4926,
        "delta": -0.0849
      },
      {
        "periodo": 202511,
        "valor": 3.415,
        "delta": -0.0776
      },
      {
        "periodo": 202512,
        "valor": 3.4377,
        "delta": 0.0227
      },
      {
        "periodo": 202601,
        "valor": 3.3572,
        "delta": -0.0805
      },
      {
        "periodo": 202602,
        "valor": 3.3365,
        "delta": -0.0207
      },
      {
        "periodo": 202603,
        "valor": 3.1228,
        "delta": -0.2136
      },
      {
        "periodo": 202604,
        "valor": 3.6632,
        "delta": 0.5404
      },
      {
        "periodo": 202605,
        "valor": 3.6894,
        "delta": 0.0263
      },
      {
        "periodo": 202606,
        "valor": 3.7362,
        "delta": 0.0467
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.3532,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.4708,
        "delta": 0.1176
      },
      {
        "periodo": 202508,
        "valor": 1.8593,
        "delta": 0.3885
      },
      {
        "periodo": 202509,
        "valor": 2.0243,
        "delta": 0.165
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.701458,
    "valor_anterior": 2.750878,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.6634,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.9194,
        "delta": 0.256
      },
      {
        "periodo": 202508,
        "valor": 2.8126,
        "delta": -0.1068
      },
      {
        "periodo": 202509,
        "valor": 2.6645,
        "delta": -0.1481
      },
      {
        "periodo": 202510,
        "valor": 2.6378,
        "delta": -0.0266
      },
      {
        "periodo": 202511,
        "valor": 2.644,
        "delta": 0.0062
      },
      {
        "periodo": 202512,
        "valor": 2.671,
        "delta": 0.0269
      },
      {
        "periodo": 202601,
        "valor": 2.5156,
        "delta": -0.1554
      },
      {
        "periodo": 202602,
        "valor": 2.7166,
        "delta": 0.201
      },
      {
        "periodo": 202603,
        "valor": 2.8918,
        "delta": 0.1752
      },
      {
        "periodo": 202604,
        "valor": 2.5635,
        "delta": -0.3284
      },
      {
        "periodo": 202605,
        "valor": 2.7509,
        "delta": 0.1874
      },
      {
        "periodo": 202606,
        "valor": 2.7015,
        "delta": -0.0494
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.560141,
    "valor_anterior": 1.432562,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.8434,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.78,
        "delta": -0.0634
      },
      {
        "periodo": 202508,
        "valor": 1.7929,
        "delta": 0.0129
      },
      {
        "periodo": 202509,
        "valor": 1.7084,
        "delta": -0.0845
      },
      {
        "periodo": 202510,
        "valor": 1.6944,
        "delta": -0.014
      },
      {
        "periodo": 202511,
        "valor": 1.6053,
        "delta": -0.0891
      },
      {
        "periodo": 202512,
        "valor": 1.6816,
        "delta": 0.0763
      },
      {
        "periodo": 202601,
        "valor": 1.5943,
        "delta": -0.0873
      },
      {
        "periodo": 202602,
        "valor": 1.5905,
        "delta": -0.0037
      },
      {
        "periodo": 202603,
        "valor": 1.665,
        "delta": 0.0745
      },
      {
        "periodo": 202604,
        "valor": 1.5233,
        "delta": -0.1417
      },
      {
        "periodo": 202605,
        "valor": 1.4326,
        "delta": -0.0908
      },
      {
        "periodo": 202606,
        "valor": 1.5601,
        "delta": 0.1276
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 14.417036,
    "valor_anterior": 13.27445,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 18.8586,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18.8846,
        "delta": 0.0261
      },
      {
        "periodo": 202508,
        "valor": 16.8061,
        "delta": -2.0785
      },
      {
        "periodo": 202509,
        "valor": 18.2776,
        "delta": 1.4715
      },
      {
        "periodo": 202510,
        "valor": 17.2832,
        "delta": -0.9944
      },
      {
        "periodo": 202511,
        "valor": 16.5279,
        "delta": -0.7553
      },
      {
        "periodo": 202512,
        "valor": 16.8502,
        "delta": 0.3223
      },
      {
        "periodo": 202601,
        "valor": 15.2996,
        "delta": -1.5506
      },
      {
        "periodo": 202602,
        "valor": 15.3129,
        "delta": 0.0133
      },
      {
        "periodo": 202603,
        "valor": 15.1041,
        "delta": -0.2088
      },
      {
        "periodo": 202604,
        "valor": 14.8087,
        "delta": -0.2954
      },
      {
        "periodo": 202605,
        "valor": 13.2744,
        "delta": -1.5342
      },
      {
        "periodo": 202606,
        "valor": 14.417,
        "delta": 1.1426
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 9.228169,
    "valor_anterior": 9.282885,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 11.9488,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 11.3803,
        "delta": -0.5685
      },
      {
        "periodo": 202508,
        "valor": 10.6916,
        "delta": -0.6887
      },
      {
        "periodo": 202509,
        "valor": 10.2413,
        "delta": -0.4503
      },
      {
        "periodo": 202510,
        "valor": 9.5858,
        "delta": -0.6556
      },
      {
        "periodo": 202511,
        "valor": 9.2429,
        "delta": -0.3429
      },
      {
        "periodo": 202512,
        "valor": 9.6217,
        "delta": 0.3788
      },
      {
        "periodo": 202601,
        "valor": 9.4481,
        "delta": -0.1737
      },
      {
        "periodo": 202602,
        "valor": 9.5218,
        "delta": 0.0737
      },
      {
        "periodo": 202603,
        "valor": 9.2643,
        "delta": -0.2575
      },
      {
        "periodo": 202604,
        "valor": 9.3079,
        "delta": 0.0436
      },
      {
        "periodo": 202605,
        "valor": 9.2829,
        "delta": -0.025
      },
      {
        "periodo": 202606,
        "valor": 9.2282,
        "delta": -0.0547
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.95402,
    "valor_anterior": 1.971196,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.0843,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.0954,
        "delta": 0.0112
      },
      {
        "periodo": 202508,
        "valor": 2.0499,
        "delta": -0.0455
      },
      {
        "periodo": 202509,
        "valor": 2.0431,
        "delta": -0.0068
      },
      {
        "periodo": 202510,
        "valor": 2.0395,
        "delta": -0.0036
      },
      {
        "periodo": 202511,
        "valor": 2.0152,
        "delta": -0.0242
      },
      {
        "periodo": 202512,
        "valor": 2.0071,
        "delta": -0.0081
      },
      {
        "periodo": 202601,
        "valor": 2.0086,
        "delta": 0.0015
      },
      {
        "periodo": 202602,
        "valor": 2.0216,
        "delta": 0.013
      },
      {
        "periodo": 202603,
        "valor": 1.9951,
        "delta": -0.0265
      },
      {
        "periodo": 202604,
        "valor": 1.9816,
        "delta": -0.0135
      },
      {
        "periodo": 202605,
        "valor": 1.9712,
        "delta": -0.0104
      },
      {
        "periodo": 202606,
        "valor": 1.954,
        "delta": -0.0172
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 3.368548,
    "valor_anterior": 3.292564,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.8925,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.9348,
        "delta": 0.0422
      },
      {
        "periodo": 202508,
        "valor": 3.1002,
        "delta": 0.1654
      },
      {
        "periodo": 202509,
        "valor": 2.9867,
        "delta": -0.1134
      },
      {
        "periodo": 202510,
        "valor": 3.0049,
        "delta": 0.0181
      },
      {
        "periodo": 202511,
        "valor": 3.0023,
        "delta": -0.0026
      },
      {
        "periodo": 202512,
        "valor": 3.1056,
        "delta": 0.1033
      },
      {
        "periodo": 202601,
        "valor": 3.4093,
        "delta": 0.3036
      },
      {
        "periodo": 202602,
        "valor": 3.2807,
        "delta": -0.1285
      },
      {
        "periodo": 202603,
        "valor": 3.2107,
        "delta": -0.07
      },
      {
        "periodo": 202604,
        "valor": 3.1692,
        "delta": -0.0415
      },
      {
        "periodo": 202605,
        "valor": 3.2926,
        "delta": 0.1234
      },
      {
        "periodo": 202606,
        "valor": 3.3685,
        "delta": 0.076
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.679708,
    "valor_anterior": 1.680942,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.7408,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.76,
        "delta": 0.0192
      },
      {
        "periodo": 202508,
        "valor": 1.6918,
        "delta": -0.0681
      },
      {
        "periodo": 202509,
        "valor": 1.719,
        "delta": 0.0271
      },
      {
        "periodo": 202510,
        "valor": 1.6953,
        "delta": -0.0237
      },
      {
        "periodo": 202511,
        "valor": 1.6885,
        "delta": -0.0068
      },
      {
        "periodo": 202512,
        "valor": 1.7267,
        "delta": 0.0382
      },
      {
        "periodo": 202601,
        "valor": 1.6817,
        "delta": -0.045
      },
      {
        "periodo": 202602,
        "valor": 1.7073,
        "delta": 0.0256
      },
      {
        "periodo": 202603,
        "valor": 1.6886,
        "delta": -0.0187
      },
      {
        "periodo": 202604,
        "valor": 1.68,
        "delta": -0.0086
      },
      {
        "periodo": 202605,
        "valor": 1.6809,
        "delta": 0.001
      },
      {
        "periodo": 202606,
        "valor": 1.6797,
        "delta": -0.0012
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.812,
    "valor_anterior": 1.665918,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.64,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.6672,
        "delta": 0.0272
      },
      {
        "periodo": 202508,
        "valor": 1.6486,
        "delta": -0.0185
      },
      {
        "periodo": 202509,
        "valor": 1.6634,
        "delta": 0.0148
      },
      {
        "periodo": 202510,
        "valor": 1.6424,
        "delta": -0.021
      },
      {
        "periodo": 202511,
        "valor": 1.6603,
        "delta": 0.0179
      },
      {
        "periodo": 202512,
        "valor": 1.6633,
        "delta": 0.003
      },
      {
        "periodo": 202601,
        "valor": 1.6399,
        "delta": -0.0234
      },
      {
        "periodo": 202602,
        "valor": 1.6262,
        "delta": -0.0137
      },
      {
        "periodo": 202603,
        "valor": 1.6466,
        "delta": 0.0205
      },
      {
        "periodo": 202604,
        "valor": 1.643,
        "delta": -0.0036
      },
      {
        "periodo": 202605,
        "valor": 1.6659,
        "delta": 0.0229
      },
      {
        "periodo": 202606,
        "valor": 1.812,
        "delta": 0.1461
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 3.17544,
    "valor_anterior": 3.474488,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 3.1323,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3.2339,
        "delta": 0.1016
      },
      {
        "periodo": 202508,
        "valor": 3.1645,
        "delta": -0.0694
      },
      {
        "periodo": 202509,
        "valor": 3.1252,
        "delta": -0.0393
      },
      {
        "periodo": 202510,
        "valor": 2.9779,
        "delta": -0.1473
      },
      {
        "periodo": 202511,
        "valor": 3.1032,
        "delta": 0.1253
      },
      {
        "periodo": 202512,
        "valor": 3.0194,
        "delta": -0.0838
      },
      {
        "periodo": 202601,
        "valor": 3.0972,
        "delta": 0.0777
      },
      {
        "periodo": 202602,
        "valor": 3.0497,
        "delta": -0.0475
      },
      {
        "periodo": 202603,
        "valor": 3.2519,
        "delta": 0.2022
      },
      {
        "periodo": 202604,
        "valor": 3.3379,
        "delta": 0.086
      },
      {
        "periodo": 202605,
        "valor": 3.4745,
        "delta": 0.1366
      },
      {
        "periodo": 202606,
        "valor": 3.1754,
        "delta": -0.299
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.822905,
    "valor_anterior": 1.794098,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.842,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.8353,
        "delta": -0.0066
      },
      {
        "periodo": 202508,
        "valor": 1.8612,
        "delta": 0.0258
      },
      {
        "periodo": 202509,
        "valor": 1.8551,
        "delta": -0.0061
      },
      {
        "periodo": 202510,
        "valor": 1.8125,
        "delta": -0.0426
      },
      {
        "periodo": 202511,
        "valor": 1.7992,
        "delta": -0.0132
      },
      {
        "periodo": 202512,
        "valor": 1.8429,
        "delta": 0.0437
      },
      {
        "periodo": 202601,
        "valor": 1.8129,
        "delta": -0.03
      },
      {
        "periodo": 202602,
        "valor": 1.8139,
        "delta": 0.001
      },
      {
        "periodo": 202603,
        "valor": 1.8121,
        "delta": -0.0019
      },
      {
        "periodo": 202604,
        "valor": 1.7952,
        "delta": -0.0169
      },
      {
        "periodo": 202605,
        "valor": 1.7941,
        "delta": -0.0011
      },
      {
        "periodo": 202606,
        "valor": 1.8229,
        "delta": 0.0288
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 4.90658,
    "valor_anterior": 5.314942,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5.0153,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4.4153,
        "delta": -0.6
      },
      {
        "periodo": 202508,
        "valor": 4.4462,
        "delta": 0.0309
      },
      {
        "periodo": 202509,
        "valor": 4.6713,
        "delta": 0.2252
      },
      {
        "periodo": 202510,
        "valor": 4.7131,
        "delta": 0.0418
      },
      {
        "periodo": 202511,
        "valor": 4.7623,
        "delta": 0.0492
      },
      {
        "periodo": 202512,
        "valor": 4.9436,
        "delta": 0.1812
      },
      {
        "periodo": 202601,
        "valor": 4.9575,
        "delta": 0.014
      },
      {
        "periodo": 202602,
        "valor": 5.0945,
        "delta": 0.137
      },
      {
        "periodo": 202603,
        "valor": 5.2249,
        "delta": 0.1304
      },
      {
        "periodo": 202604,
        "valor": 5.0023,
        "delta": -0.2226
      },
      {
        "periodo": 202605,
        "valor": 5.3149,
        "delta": 0.3127
      },
      {
        "periodo": 202606,
        "valor": 4.9066,
        "delta": -0.4084
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 9.70781,
    "valor_anterior": 9.73933,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 12.5212,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 11.5573,
        "delta": -0.9639
      },
      {
        "periodo": 202508,
        "valor": 11.4804,
        "delta": -0.0769
      },
      {
        "periodo": 202509,
        "valor": 11.7706,
        "delta": 0.2902
      },
      {
        "periodo": 202510,
        "valor": 11.5512,
        "delta": -0.2194
      },
      {
        "periodo": 202511,
        "valor": 14.6384,
        "delta": 3.0872
      },
      {
        "periodo": 202512,
        "valor": 12.2716,
        "delta": -2.3668
      },
      {
        "periodo": 202601,
        "valor": 12.3789,
        "delta": 0.1073
      },
      {
        "periodo": 202602,
        "valor": 11.102,
        "delta": -1.2769
      },
      {
        "periodo": 202603,
        "valor": 10.7633,
        "delta": -0.3387
      },
      {
        "periodo": 202604,
        "valor": 10.5593,
        "delta": -0.204
      },
      {
        "periodo": 202605,
        "valor": 9.7393,
        "delta": -0.82
      },
      {
        "periodo": 202606,
        "valor": 9.7078,
        "delta": -0.0315
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 4.664718,
    "valor_anterior": 5.266407,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5.5522,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 5.6774,
        "delta": 0.1252
      },
      {
        "periodo": 202508,
        "valor": 5.6664,
        "delta": -0.011
      },
      {
        "periodo": 202509,
        "valor": 5.8871,
        "delta": 0.2207
      },
      {
        "periodo": 202510,
        "valor": 5.6445,
        "delta": -0.2427
      },
      {
        "periodo": 202511,
        "valor": 5.7446,
        "delta": 0.1001
      },
      {
        "periodo": 202512,
        "valor": 5.8446,
        "delta": 0.1
      },
      {
        "periodo": 202601,
        "valor": 5.5277,
        "delta": -0.3169
      },
      {
        "periodo": 202602,
        "valor": 5.8446,
        "delta": 0.3169
      },
      {
        "periodo": 202603,
        "valor": 5.8431,
        "delta": -0.0015
      },
      {
        "periodo": 202604,
        "valor": 5.4984,
        "delta": -0.3447
      },
      {
        "periodo": 202605,
        "valor": 5.2664,
        "delta": -0.232
      },
      {
        "periodo": 202606,
        "valor": 4.6647,
        "delta": -0.6017
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 22.590273,
    "valor_anterior": 22.163977,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 23.2893,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 22.7082,
        "delta": -0.5811
      },
      {
        "periodo": 202508,
        "valor": 21.9165,
        "delta": -0.7917
      },
      {
        "periodo": 202509,
        "valor": 22.2205,
        "delta": 0.304
      },
      {
        "periodo": 202510,
        "valor": 23.5052,
        "delta": 1.2847
      },
      {
        "periodo": 202511,
        "valor": 23.6417,
        "delta": 0.1365
      },
      {
        "periodo": 202512,
        "valor": 22.7394,
        "delta": -0.9023
      },
      {
        "periodo": 202601,
        "valor": 23.7589,
        "delta": 1.0195
      },
      {
        "periodo": 202602,
        "valor": 24.7717,
        "delta": 1.0128
      },
      {
        "periodo": 202603,
        "valor": 17.2228,
        "delta": -7.5489
      },
      {
        "periodo": 202604,
        "valor": 24.8057,
        "delta": 7.583
      },
      {
        "periodo": 202605,
        "valor": 22.164,
        "delta": -2.6417
      },
      {
        "periodo": 202606,
        "valor": 22.5903,
        "delta": 0.4263
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 5.38032,
    "valor_anterior": 5.642341,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5.246,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 5.1298,
        "delta": -0.1162
      },
      {
        "periodo": 202508,
        "valor": 5.5924,
        "delta": 0.4626
      },
      {
        "periodo": 202509,
        "valor": 5.5989,
        "delta": 0.0065
      },
      {
        "periodo": 202510,
        "valor": 5.4765,
        "delta": -0.1223
      },
      {
        "periodo": 202511,
        "valor": 5.3394,
        "delta": -0.1371
      },
      {
        "periodo": 202512,
        "valor": 5.4694,
        "delta": 0.13
      },
      {
        "periodo": 202601,
        "valor": 5.6603,
        "delta": 0.1909
      },
      {
        "periodo": 202602,
        "valor": 5.5535,
        "delta": -0.1068
      },
      {
        "periodo": 202603,
        "valor": 5.4108,
        "delta": -0.1427
      },
      {
        "periodo": 202604,
        "valor": 5.3642,
        "delta": -0.0466
      },
      {
        "periodo": 202605,
        "valor": 5.6423,
        "delta": 0.2782
      },
      {
        "periodo": 202606,
        "valor": 5.3803,
        "delta": -0.262
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 8.36489,
    "valor_anterior": 7.767952,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 7.7954,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 8.1993,
        "delta": 0.4039
      },
      {
        "periodo": 202508,
        "valor": 9.2055,
        "delta": 1.0062
      },
      {
        "periodo": 202509,
        "valor": 8.6818,
        "delta": -0.5238
      },
      {
        "periodo": 202510,
        "valor": 9.3931,
        "delta": 0.7114
      },
      {
        "periodo": 202511,
        "valor": 8.1079,
        "delta": -1.2852
      },
      {
        "periodo": 202512,
        "valor": 8.007,
        "delta": -0.1009
      },
      {
        "periodo": 202601,
        "valor": 10.1641,
        "delta": 2.1572
      },
      {
        "periodo": 202602,
        "valor": 8.4365,
        "delta": -1.7277
      },
      {
        "periodo": 202603,
        "valor": 8.6064,
        "delta": 0.17
      },
      {
        "periodo": 202604,
        "valor": 7.0061,
        "delta": -1.6003
      },
      {
        "periodo": 202605,
        "valor": 7.768,
        "delta": 0.7618
      },
      {
        "periodo": 202606,
        "valor": 8.3649,
        "delta": 0.5969
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 33.938591,
    "valor_anterior": 34.063556,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 34.6927,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 32.3986,
        "delta": -2.2941
      },
      {
        "periodo": 202508,
        "valor": 29.4941,
        "delta": -2.9045
      },
      {
        "periodo": 202509,
        "valor": 31.6073,
        "delta": 2.1131
      },
      {
        "periodo": 202510,
        "valor": 32.4654,
        "delta": 0.8581
      },
      {
        "periodo": 202511,
        "valor": 35.4235,
        "delta": 2.9581
      },
      {
        "periodo": 202512,
        "valor": 35.2762,
        "delta": -0.1473
      },
      {
        "periodo": 202601,
        "valor": 34.2028,
        "delta": -1.0734
      },
      {
        "periodo": 202602,
        "valor": 32.1283,
        "delta": -2.0744
      },
      {
        "periodo": 202603,
        "valor": 32.4934,
        "delta": 0.3651
      },
      {
        "periodo": 202604,
        "valor": 33.3004,
        "delta": 0.8069
      },
      {
        "periodo": 202605,
        "valor": 34.0636,
        "delta": 0.7632
      },
      {
        "periodo": 202606,
        "valor": 33.9386,
        "delta": -0.125
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.776629,
    "valor_anterior": 1.745727,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 57.7837,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 56.0232,
        "delta": -1.7605
      },
      {
        "periodo": 202508,
        "valor": 54.6067,
        "delta": -1.4165
      },
      {
        "periodo": 202509,
        "valor": 55.7002,
        "delta": 1.0935
      },
      {
        "periodo": 202510,
        "valor": 54.7986,
        "delta": -0.9016
      },
      {
        "periodo": 202511,
        "valor": 54.8142,
        "delta": 0.0156
      },
      {
        "periodo": 202512,
        "valor": 55.773,
        "delta": 0.9588
      },
      {
        "periodo": 202601,
        "valor": 62.9493,
        "delta": 7.1763
      },
      {
        "periodo": 202602,
        "valor": 2.162,
        "delta": -60.7873
      },
      {
        "periodo": 202603,
        "valor": 1.8462,
        "delta": -0.3158
      },
      {
        "periodo": 202604,
        "valor": 1.734,
        "delta": -0.1122
      },
      {
        "periodo": 202605,
        "valor": 1.7457,
        "delta": 0.0118
      },
      {
        "periodo": 202606,
        "valor": 1.7766,
        "delta": 0.0309
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 5.990995,
    "valor_anterior": 3.113399,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 26.2006,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 19.4348,
        "delta": -6.7657
      },
      {
        "periodo": 202508,
        "valor": 12.8101,
        "delta": -6.6247
      },
      {
        "periodo": 202509,
        "valor": 9.3321,
        "delta": -3.4781
      },
      {
        "periodo": 202510,
        "valor": 6.2111,
        "delta": -3.121
      },
      {
        "periodo": 202511,
        "valor": 4.3668,
        "delta": -1.8443
      },
      {
        "periodo": 202512,
        "valor": 5.1287,
        "delta": 0.7619
      },
      {
        "periodo": 202601,
        "valor": 7.2611,
        "delta": 2.1323
      },
      {
        "periodo": 202602,
        "valor": 5.8643,
        "delta": -1.3968
      },
      {
        "periodo": 202603,
        "valor": 3.6535,
        "delta": -2.2108
      },
      {
        "periodo": 202604,
        "valor": 3.7111,
        "delta": 0.0576
      },
      {
        "periodo": 202605,
        "valor": 3.1134,
        "delta": -0.5977
      },
      {
        "periodo": 202606,
        "valor": 5.991,
        "delta": 2.8776
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 18.302325,
    "valor_anterior": 20.259035,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 55.8875,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 31.4551,
        "delta": -24.4324
      },
      {
        "periodo": 202601,
        "valor": 22.3927,
        "delta": -9.0624
      },
      {
        "periodo": 202602,
        "valor": 17.5508,
        "delta": -4.8419
      },
      {
        "periodo": 202603,
        "valor": 17.6981,
        "delta": 0.1473
      },
      {
        "periodo": 202604,
        "valor": 20.7609,
        "delta": 3.0628
      },
      {
        "periodo": 202605,
        "valor": 20.259,
        "delta": -0.5018
      },
      {
        "periodo": 202606,
        "valor": 18.3023,
        "delta": -1.9567
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 3.008568,
    "valor_anterior": 2.28817,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 2.5843,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 2.4449,
        "delta": -0.1395
      },
      {
        "periodo": 202605,
        "valor": 2.2882,
        "delta": -0.1567
      },
      {
        "periodo": 202606,
        "valor": 3.0086,
        "delta": 0.7204
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.569992,
    "valor_anterior": 2.558495,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.5001,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.5302,
        "delta": 0.0301
      },
      {
        "periodo": 202508,
        "valor": 2.5394,
        "delta": 0.0092
      },
      {
        "periodo": 202509,
        "valor": 2.5474,
        "delta": 0.008
      },
      {
        "periodo": 202510,
        "valor": 2.5636,
        "delta": 0.0162
      },
      {
        "periodo": 202511,
        "valor": 2.5188,
        "delta": -0.0448
      },
      {
        "periodo": 202512,
        "valor": 2.5216,
        "delta": 0.0028
      },
      {
        "periodo": 202601,
        "valor": 2.519,
        "delta": -0.0025
      },
      {
        "periodo": 202602,
        "valor": 2.536,
        "delta": 0.017
      },
      {
        "periodo": 202603,
        "valor": 2.5404,
        "delta": 0.0043
      },
      {
        "periodo": 202604,
        "valor": 2.5124,
        "delta": -0.028
      },
      {
        "periodo": 202605,
        "valor": 2.5585,
        "delta": 0.0461
      },
      {
        "periodo": 202606,
        "valor": 2.57,
        "delta": 0.0115
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.594266,
    "valor_anterior": 2.58717,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.5416,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.5704,
        "delta": 0.0287
      },
      {
        "periodo": 202508,
        "valor": 2.5832,
        "delta": 0.0128
      },
      {
        "periodo": 202509,
        "valor": 2.5703,
        "delta": -0.013
      },
      {
        "periodo": 202510,
        "valor": 2.5905,
        "delta": 0.0202
      },
      {
        "periodo": 202511,
        "valor": 2.5522,
        "delta": -0.0383
      },
      {
        "periodo": 202512,
        "valor": 2.5312,
        "delta": -0.021
      },
      {
        "periodo": 202601,
        "valor": 2.5271,
        "delta": -0.0041
      },
      {
        "periodo": 202602,
        "valor": 2.5588,
        "delta": 0.0317
      },
      {
        "periodo": 202603,
        "valor": 2.5621,
        "delta": 0.0033
      },
      {
        "periodo": 202604,
        "valor": 2.5367,
        "delta": -0.0255
      },
      {
        "periodo": 202605,
        "valor": 2.5872,
        "delta": 0.0505
      },
      {
        "periodo": 202606,
        "valor": 2.5943,
        "delta": 0.0071
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.557853,
    "valor_anterior": 2.60807,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.1204,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.3706,
        "delta": 0.2502
      },
      {
        "periodo": 202508,
        "valor": 2.6418,
        "delta": 0.2712
      },
      {
        "periodo": 202509,
        "valor": 2.8767,
        "delta": 0.2349
      },
      {
        "periodo": 202510,
        "valor": 3.0845,
        "delta": 0.2078
      },
      {
        "periodo": 202511,
        "valor": 2.5306,
        "delta": -0.5539
      },
      {
        "periodo": 202512,
        "valor": 2.4948,
        "delta": -0.0358
      },
      {
        "periodo": 202601,
        "valor": 2.487,
        "delta": -0.0077
      },
      {
        "periodo": 202602,
        "valor": 2.567,
        "delta": 0.0799
      },
      {
        "periodo": 202603,
        "valor": 2.6577,
        "delta": 0.0907
      },
      {
        "periodo": 202604,
        "valor": 2.4682,
        "delta": -0.1895
      },
      {
        "periodo": 202605,
        "valor": 2.6081,
        "delta": 0.1399
      },
      {
        "periodo": 202606,
        "valor": 2.5579,
        "delta": -0.0502
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 3.282542,
    "valor_anterior": 3.27242,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 3.0007,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3.074,
        "delta": 0.0733
      },
      {
        "periodo": 202508,
        "valor": 3.0316,
        "delta": -0.0424
      },
      {
        "periodo": 202509,
        "valor": 3.125,
        "delta": 0.0934
      },
      {
        "periodo": 202510,
        "valor": 3.1031,
        "delta": -0.022
      },
      {
        "periodo": 202511,
        "valor": 3.0885,
        "delta": -0.0146
      },
      {
        "periodo": 202512,
        "valor": 3.3155,
        "delta": 0.2271
      },
      {
        "periodo": 202601,
        "valor": 3.2725,
        "delta": -0.0431
      },
      {
        "periodo": 202602,
        "valor": 3.1474,
        "delta": -0.1251
      },
      {
        "periodo": 202603,
        "valor": 3.1866,
        "delta": 0.0392
      },
      {
        "periodo": 202604,
        "valor": 3.1922,
        "delta": 0.0056
      },
      {
        "periodo": 202605,
        "valor": 3.2724,
        "delta": 0.0802
      },
      {
        "periodo": 202606,
        "valor": 3.2825,
        "delta": 0.0101
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 1.970039,
    "valor_anterior": 1.968764,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.8681,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.8828,
        "delta": 0.0147
      },
      {
        "periodo": 202508,
        "valor": 1.9205,
        "delta": 0.0377
      },
      {
        "periodo": 202509,
        "valor": 1.9317,
        "delta": 0.0112
      },
      {
        "periodo": 202510,
        "valor": 1.9407,
        "delta": 0.009
      },
      {
        "periodo": 202511,
        "valor": 1.9116,
        "delta": -0.0291
      },
      {
        "periodo": 202512,
        "valor": 1.9277,
        "delta": 0.0161
      },
      {
        "periodo": 202601,
        "valor": 1.9588,
        "delta": 0.0311
      },
      {
        "periodo": 202602,
        "valor": 1.9889,
        "delta": 0.0301
      },
      {
        "periodo": 202603,
        "valor": 1.9613,
        "delta": -0.0276
      },
      {
        "periodo": 202604,
        "valor": 1.8964,
        "delta": -0.0649
      },
      {
        "periodo": 202605,
        "valor": 1.9688,
        "delta": 0.0723
      },
      {
        "periodo": 202606,
        "valor": 1.97,
        "delta": 0.0013
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.467328,
    "valor_anterior": 2.46507,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.7169,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.6618,
        "delta": -0.0551
      },
      {
        "periodo": 202508,
        "valor": 2.6034,
        "delta": -0.0585
      },
      {
        "periodo": 202509,
        "valor": 2.5802,
        "delta": -0.0232
      },
      {
        "periodo": 202510,
        "valor": 2.5895,
        "delta": 0.0093
      },
      {
        "periodo": 202511,
        "valor": 2.524,
        "delta": -0.0655
      },
      {
        "periodo": 202512,
        "valor": 2.4895,
        "delta": -0.0345
      },
      {
        "periodo": 202601,
        "valor": 2.4954,
        "delta": 0.0059
      },
      {
        "periodo": 202602,
        "valor": 2.5013,
        "delta": 0.0059
      },
      {
        "periodo": 202603,
        "valor": 2.5156,
        "delta": 0.0143
      },
      {
        "periodo": 202604,
        "valor": 2.4802,
        "delta": -0.0354
      },
      {
        "periodo": 202605,
        "valor": 2.4651,
        "delta": -0.0151
      },
      {
        "periodo": 202606,
        "valor": 2.4673,
        "delta": 0.0023
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 4020699,
    "label": "CN / Requerimiento (veces) Jun 2026",
    "valor_actual": 2.242395,
    "valor_anterior": 2.150816,
    "tipo": "porcentaje",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.2626,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.2197,
        "delta": -0.0429
      },
      {
        "periodo": 202508,
        "valor": 2.1363,
        "delta": -0.0834
      },
      {
        "periodo": 202509,
        "valor": 2.2262,
        "delta": 0.0899
      },
      {
        "periodo": 202510,
        "valor": 2.229,
        "delta": 0.0028
      },
      {
        "periodo": 202511,
        "valor": 2.1903,
        "delta": -0.0388
      },
      {
        "periodo": 202512,
        "valor": 2.2374,
        "delta": 0.0471
      },
      {
        "periodo": 202601,
        "valor": 2.236,
        "delta": -0.0015
      },
      {
        "periodo": 202602,
        "valor": 2.2022,
        "delta": -0.0338
      },
      {
        "periodo": 202603,
        "valor": 2.2099,
        "delta": 0.0077
      },
      {
        "periodo": 202604,
        "valor": 2.1984,
        "delta": -0.0115
      },
      {
        "periodo": 202605,
        "valor": 2.1508,
        "delta": -0.0476
      },
      {
        "periodo": 202606,
        "valor": 2.2424,
        "delta": 0.0916
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 4020740,
    "label": "Alertas Tempranas (Clasificación CNBV) Jun 2026",
    "valor_actual": 1.0,
    "valor_anterior": 1.0,
    "tipo": "categoria",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 1.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 24.429795,
    "valor_anterior": 24.544585,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 21.0438,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 21.0071,
        "delta": -0.0367
      },
      {
        "periodo": 202508,
        "valor": 21.0827,
        "delta": 0.0756
      },
      {
        "periodo": 202509,
        "valor": 20.6278,
        "delta": -0.4549
      },
      {
        "periodo": 202510,
        "valor": 20.6777,
        "delta": 0.0499
      },
      {
        "periodo": 202511,
        "valor": 20.7476,
        "delta": 0.0699
      },
      {
        "periodo": 202512,
        "valor": 20.8206,
        "delta": 0.073
      },
      {
        "periodo": 202601,
        "valor": 21.3844,
        "delta": 0.5638
      },
      {
        "periodo": 202602,
        "valor": 21.0773,
        "delta": -0.307
      },
      {
        "periodo": 202603,
        "valor": 21.4281,
        "delta": 0.3507
      },
      {
        "periodo": 202604,
        "valor": 20.4442,
        "delta": -0.9838
      },
      {
        "periodo": 202605,
        "valor": 24.5446,
        "delta": 4.1004
      },
      {
        "periodo": 202606,
        "valor": 24.4298,
        "delta": -0.1148
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 19.564419,
    "valor_anterior": 20.327699,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 20.0687,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 19.9733,
        "delta": -0.0953
      },
      {
        "periodo": 202508,
        "valor": 20.4228,
        "delta": 0.4495
      },
      {
        "periodo": 202509,
        "valor": 19.9711,
        "delta": -0.4517
      },
      {
        "periodo": 202510,
        "valor": 20.0594,
        "delta": 0.0883
      },
      {
        "periodo": 202511,
        "valor": 20.1435,
        "delta": 0.0841
      },
      {
        "periodo": 202512,
        "valor": 20.1512,
        "delta": 0.0077
      },
      {
        "periodo": 202601,
        "valor": 20.1681,
        "delta": 0.0169
      },
      {
        "periodo": 202602,
        "valor": 20.6449,
        "delta": 0.4768
      },
      {
        "periodo": 202603,
        "valor": 20.137,
        "delta": -0.5079
      },
      {
        "periodo": 202604,
        "valor": 20.3881,
        "delta": 0.251
      },
      {
        "periodo": 202605,
        "valor": 20.3277,
        "delta": -0.0604
      },
      {
        "periodo": 202606,
        "valor": 19.5644,
        "delta": -0.7633
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 19.175449,
    "valor_anterior": 19.329504,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 19.4428,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 20.2568,
        "delta": 0.814
      },
      {
        "periodo": 202508,
        "valor": 19.725,
        "delta": -0.5318
      },
      {
        "periodo": 202509,
        "valor": 20.0193,
        "delta": 0.2943
      },
      {
        "periodo": 202510,
        "valor": 19.92,
        "delta": -0.0993
      },
      {
        "periodo": 202511,
        "valor": 19.7686,
        "delta": -0.1514
      },
      {
        "periodo": 202512,
        "valor": 18.49,
        "delta": -1.2786
      },
      {
        "periodo": 202601,
        "valor": 18.931,
        "delta": 0.441
      },
      {
        "periodo": 202602,
        "valor": 19.1473,
        "delta": 0.2164
      },
      {
        "periodo": 202603,
        "valor": 19.7759,
        "delta": 0.6285
      },
      {
        "periodo": 202604,
        "valor": 19.513,
        "delta": -0.2628
      },
      {
        "periodo": 202605,
        "valor": 19.3295,
        "delta": -0.1835
      },
      {
        "periodo": 202606,
        "valor": 19.1754,
        "delta": -0.1541
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 19.395385,
    "valor_anterior": 20.042603,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17.9002,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18.2324,
        "delta": 0.3322
      },
      {
        "periodo": 202508,
        "valor": 18.4216,
        "delta": 0.1892
      },
      {
        "periodo": 202509,
        "valor": 18.4527,
        "delta": 0.0311
      },
      {
        "periodo": 202510,
        "valor": 19.9249,
        "delta": 1.4723
      },
      {
        "periodo": 202511,
        "valor": 19.73,
        "delta": -0.1949
      },
      {
        "periodo": 202512,
        "valor": 19.3781,
        "delta": -0.352
      },
      {
        "periodo": 202601,
        "valor": 19.5342,
        "delta": 0.1561
      },
      {
        "periodo": 202602,
        "valor": 19.5488,
        "delta": 0.0147
      },
      {
        "periodo": 202603,
        "valor": 19.8024,
        "delta": 0.2535
      },
      {
        "periodo": 202604,
        "valor": 19.8873,
        "delta": 0.0849
      },
      {
        "periodo": 202605,
        "valor": 20.0426,
        "delta": 0.1553
      },
      {
        "periodo": 202606,
        "valor": 19.3954,
        "delta": -0.6472
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 14.699991,
    "valor_anterior": 14.761235,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.5256,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.7095,
        "delta": 0.1839
      },
      {
        "periodo": 202508,
        "valor": 15.5322,
        "delta": 0.8227
      },
      {
        "periodo": 202509,
        "valor": 15.8882,
        "delta": 0.356
      },
      {
        "periodo": 202510,
        "valor": 15.9932,
        "delta": 0.105
      },
      {
        "periodo": 202511,
        "valor": 15.6276,
        "delta": -0.3656
      },
      {
        "periodo": 202512,
        "valor": 15.4646,
        "delta": -0.163
      },
      {
        "periodo": 202601,
        "valor": 16.0357,
        "delta": 0.5711
      },
      {
        "periodo": 202602,
        "valor": 16.2682,
        "delta": 0.2325
      },
      {
        "periodo": 202603,
        "valor": 15.988,
        "delta": -0.2802
      },
      {
        "periodo": 202604,
        "valor": 14.662,
        "delta": -1.326
      },
      {
        "periodo": 202605,
        "valor": 14.7612,
        "delta": 0.0993
      },
      {
        "periodo": 202606,
        "valor": 14.7,
        "delta": -0.0612
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 23.191124,
    "valor_anterior": 23.316292,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 23.2439,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 23.4024,
        "delta": 0.1585
      },
      {
        "periodo": 202508,
        "valor": 23.5412,
        "delta": 0.1389
      },
      {
        "periodo": 202509,
        "valor": 23.4555,
        "delta": -0.0857
      },
      {
        "periodo": 202510,
        "valor": 23.3702,
        "delta": -0.0853
      },
      {
        "periodo": 202511,
        "valor": 23.6521,
        "delta": 0.2819
      },
      {
        "periodo": 202512,
        "valor": 23.5562,
        "delta": -0.0959
      },
      {
        "periodo": 202601,
        "valor": 23.4224,
        "delta": -0.1338
      },
      {
        "periodo": 202602,
        "valor": 23.2631,
        "delta": -0.1593
      },
      {
        "periodo": 202603,
        "valor": 23.2486,
        "delta": -0.0145
      },
      {
        "periodo": 202604,
        "valor": 23.2908,
        "delta": 0.0422
      },
      {
        "periodo": 202605,
        "valor": 23.3163,
        "delta": 0.0255
      },
      {
        "periodo": 202606,
        "valor": 23.1911,
        "delta": -0.1252
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 21.124021,
    "valor_anterior": 21.110393,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 16.6082,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 16.7356,
        "delta": 0.1273
      },
      {
        "periodo": 202508,
        "valor": 16.1905,
        "delta": -0.5451
      },
      {
        "periodo": 202509,
        "valor": 16.6179,
        "delta": 0.4274
      },
      {
        "periodo": 202510,
        "valor": 16.7711,
        "delta": 0.1532
      },
      {
        "periodo": 202511,
        "valor": 16.7159,
        "delta": -0.0552
      },
      {
        "periodo": 202512,
        "valor": 17.1907,
        "delta": 0.4748
      },
      {
        "periodo": 202601,
        "valor": 17.0398,
        "delta": -0.1508
      },
      {
        "periodo": 202602,
        "valor": 17.1183,
        "delta": 0.0784
      },
      {
        "periodo": 202603,
        "valor": 17.1428,
        "delta": 0.0246
      },
      {
        "periodo": 202604,
        "valor": 17.0318,
        "delta": -0.1111
      },
      {
        "periodo": 202605,
        "valor": 21.1104,
        "delta": 4.0786
      },
      {
        "periodo": 202606,
        "valor": 21.124,
        "delta": 0.0136
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 20.910118,
    "valor_anterior": 20.59727,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 18.7155,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18.9193,
        "delta": 0.2038
      },
      {
        "periodo": 202508,
        "valor": 18.8631,
        "delta": -0.0561
      },
      {
        "periodo": 202509,
        "valor": 19.2313,
        "delta": 0.3681
      },
      {
        "periodo": 202510,
        "valor": 19.1337,
        "delta": -0.0976
      },
      {
        "periodo": 202511,
        "valor": 19.1874,
        "delta": 0.0538
      },
      {
        "periodo": 202512,
        "valor": 20.412,
        "delta": 1.2245
      },
      {
        "periodo": 202601,
        "valor": 20.2937,
        "delta": -0.1182
      },
      {
        "periodo": 202602,
        "valor": 20.7633,
        "delta": 0.4695
      },
      {
        "periodo": 202603,
        "valor": 21.0153,
        "delta": 0.2521
      },
      {
        "periodo": 202604,
        "valor": 20.7191,
        "delta": -0.2962
      },
      {
        "periodo": 202605,
        "valor": 20.5973,
        "delta": -0.1219
      },
      {
        "periodo": 202606,
        "valor": 20.9101,
        "delta": 0.3128
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 15.496519,
    "valor_anterior": 15.202767,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.37,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.5964,
        "delta": 0.2264
      },
      {
        "periodo": 202508,
        "valor": 14.6703,
        "delta": 0.0739
      },
      {
        "periodo": 202509,
        "valor": 14.7306,
        "delta": 0.0603
      },
      {
        "periodo": 202510,
        "valor": 15.0296,
        "delta": 0.299
      },
      {
        "periodo": 202511,
        "valor": 14.5619,
        "delta": -0.4677
      },
      {
        "periodo": 202512,
        "valor": 15.0106,
        "delta": 0.4487
      },
      {
        "periodo": 202601,
        "valor": 15.0706,
        "delta": 0.06
      },
      {
        "periodo": 202602,
        "valor": 15.7357,
        "delta": 0.6651
      },
      {
        "periodo": 202603,
        "valor": 15.0593,
        "delta": -0.6764
      },
      {
        "periodo": 202604,
        "valor": 15.0769,
        "delta": 0.0176
      },
      {
        "periodo": 202605,
        "valor": 15.2028,
        "delta": 0.1259
      },
      {
        "periodo": 202606,
        "valor": 15.4965,
        "delta": 0.2938
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 15.664162,
    "valor_anterior": 15.387167,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 16.0789,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 15.9375,
        "delta": -0.1413
      },
      {
        "periodo": 202508,
        "valor": 15.7208,
        "delta": -0.2168
      },
      {
        "periodo": 202509,
        "valor": 15.7612,
        "delta": 0.0405
      },
      {
        "periodo": 202510,
        "valor": 15.9736,
        "delta": 0.2123
      },
      {
        "periodo": 202511,
        "valor": 15.7425,
        "delta": -0.231
      },
      {
        "periodo": 202512,
        "valor": 16.3771,
        "delta": 0.6346
      },
      {
        "periodo": 202601,
        "valor": 15.6547,
        "delta": -0.7224
      },
      {
        "periodo": 202602,
        "valor": 15.4189,
        "delta": -0.2358
      },
      {
        "periodo": 202603,
        "valor": 15.1926,
        "delta": -0.2263
      },
      {
        "periodo": 202604,
        "valor": 15.6139,
        "delta": 0.4214
      },
      {
        "periodo": 202605,
        "valor": 15.3872,
        "delta": -0.2268
      },
      {
        "periodo": 202606,
        "valor": 15.6642,
        "delta": 0.277
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 25.863505,
    "valor_anterior": 24.921551,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 23.6613,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 22.2536,
        "delta": -1.4076
      },
      {
        "periodo": 202508,
        "valor": 21.8345,
        "delta": -0.4191
      },
      {
        "periodo": 202509,
        "valor": 22.6854,
        "delta": 0.8509
      },
      {
        "periodo": 202510,
        "valor": 23.2715,
        "delta": 0.5861
      },
      {
        "periodo": 202511,
        "valor": 22.3007,
        "delta": -0.9708
      },
      {
        "periodo": 202512,
        "valor": 22.7331,
        "delta": 0.4324
      },
      {
        "periodo": 202601,
        "valor": 23.3986,
        "delta": 0.6655
      },
      {
        "periodo": 202602,
        "valor": 23.6564,
        "delta": 0.2578
      },
      {
        "periodo": 202603,
        "valor": 24.6678,
        "delta": 1.0114
      },
      {
        "periodo": 202604,
        "valor": 24.6462,
        "delta": -0.0217
      },
      {
        "periodo": 202605,
        "valor": 24.9216,
        "delta": 0.2754
      },
      {
        "periodo": 202606,
        "valor": 25.8635,
        "delta": 0.942
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 16.346075,
    "valor_anterior": 15.548434,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 15.174,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 15.3513,
        "delta": 0.1773
      },
      {
        "periodo": 202508,
        "valor": 15.3148,
        "delta": -0.0365
      },
      {
        "periodo": 202509,
        "valor": 15.2662,
        "delta": -0.0486
      },
      {
        "periodo": 202510,
        "valor": 15.1271,
        "delta": -0.1391
      },
      {
        "periodo": 202511,
        "valor": 15.0605,
        "delta": -0.0666
      },
      {
        "periodo": 202512,
        "valor": 15.3873,
        "delta": 0.3267
      },
      {
        "periodo": 202601,
        "valor": 15.2161,
        "delta": -0.1712
      },
      {
        "periodo": 202602,
        "valor": 15.2787,
        "delta": 0.0626
      },
      {
        "periodo": 202603,
        "valor": 15.7428,
        "delta": 0.4641
      },
      {
        "periodo": 202604,
        "valor": 15.5981,
        "delta": -0.1447
      },
      {
        "periodo": 202605,
        "valor": 15.5484,
        "delta": -0.0497
      },
      {
        "periodo": 202606,
        "valor": 16.3461,
        "delta": 0.7976
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 21.498805,
    "valor_anterior": 19.09346,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 21.7157,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 22.2362,
        "delta": 0.5205
      },
      {
        "periodo": 202508,
        "valor": 22.1697,
        "delta": -0.0664
      },
      {
        "periodo": 202509,
        "valor": 22.3125,
        "delta": 0.1428
      },
      {
        "periodo": 202510,
        "valor": 22.4511,
        "delta": 0.1386
      },
      {
        "periodo": 202511,
        "valor": 20.3502,
        "delta": -2.1009
      },
      {
        "periodo": 202512,
        "valor": 20.0631,
        "delta": -0.287
      },
      {
        "periodo": 202601,
        "valor": 19.1999,
        "delta": -0.8633
      },
      {
        "periodo": 202602,
        "valor": 19.4768,
        "delta": 0.2769
      },
      {
        "periodo": 202603,
        "valor": 19.7426,
        "delta": 0.2658
      },
      {
        "periodo": 202604,
        "valor": 18.8363,
        "delta": -0.9063
      },
      {
        "periodo": 202605,
        "valor": 19.0935,
        "delta": 0.2572
      },
      {
        "periodo": 202606,
        "valor": 21.4988,
        "delta": 2.4053
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 18.638104,
    "valor_anterior": 18.761041,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17.6096,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18.1661,
        "delta": 0.5565
      },
      {
        "periodo": 202508,
        "valor": 16.9203,
        "delta": -1.2458
      },
      {
        "periodo": 202509,
        "valor": 17.4175,
        "delta": 0.4972
      },
      {
        "periodo": 202510,
        "valor": 17.7904,
        "delta": 0.3729
      },
      {
        "periodo": 202511,
        "valor": 17.9331,
        "delta": 0.1428
      },
      {
        "periodo": 202512,
        "valor": 18.7454,
        "delta": 0.8123
      },
      {
        "periodo": 202601,
        "valor": 19.5977,
        "delta": 0.8523
      },
      {
        "periodo": 202602,
        "valor": 18.7687,
        "delta": -0.829
      },
      {
        "periodo": 202603,
        "valor": 19.0195,
        "delta": 0.2508
      },
      {
        "periodo": 202604,
        "valor": 19.5393,
        "delta": 0.5197
      },
      {
        "periodo": 202605,
        "valor": 18.761,
        "delta": -0.7782
      },
      {
        "periodo": 202606,
        "valor": 18.6381,
        "delta": -0.1229
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 52.143629,
    "valor_anterior": 44.312307,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 50.8791,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 49.8605,
        "delta": -1.0186
      },
      {
        "periodo": 202508,
        "valor": 48.2043,
        "delta": -1.6562
      },
      {
        "periodo": 202509,
        "valor": 51.2141,
        "delta": 3.0098
      },
      {
        "periodo": 202510,
        "valor": 43.8312,
        "delta": -7.3829
      },
      {
        "periodo": 202511,
        "valor": 42.9908,
        "delta": -0.8404
      },
      {
        "periodo": 202512,
        "valor": 47.5614,
        "delta": 4.5706
      },
      {
        "periodo": 202601,
        "valor": 47.6478,
        "delta": 0.0864
      },
      {
        "periodo": 202602,
        "valor": 43.5513,
        "delta": -4.0965
      },
      {
        "periodo": 202603,
        "valor": 43.7652,
        "delta": 0.2139
      },
      {
        "periodo": 202604,
        "valor": 44.4742,
        "delta": 0.709
      },
      {
        "periodo": 202605,
        "valor": 44.3123,
        "delta": -0.1619
      },
      {
        "periodo": 202606,
        "valor": 52.1436,
        "delta": 7.8313
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 46.793728,
    "valor_anterior": 45.011342,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 44.1089,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 45.0871,
        "delta": 0.9782
      },
      {
        "periodo": 202508,
        "valor": 45.4951,
        "delta": 0.408
      },
      {
        "periodo": 202509,
        "valor": 46.311,
        "delta": 0.8159
      },
      {
        "periodo": 202510,
        "valor": 45.2904,
        "delta": -1.0205
      },
      {
        "periodo": 202511,
        "valor": 46.1473,
        "delta": 0.8569
      },
      {
        "periodo": 202512,
        "valor": 49.7429,
        "delta": 3.5956
      },
      {
        "periodo": 202601,
        "valor": 46.5679,
        "delta": -3.175
      },
      {
        "periodo": 202602,
        "valor": 43.2051,
        "delta": -3.3628
      },
      {
        "periodo": 202603,
        "valor": 45.2543,
        "delta": 2.0491
      },
      {
        "periodo": 202604,
        "valor": 44.9503,
        "delta": -0.304
      },
      {
        "periodo": 202605,
        "valor": 45.0113,
        "delta": 0.061
      },
      {
        "periodo": 202606,
        "valor": 46.7937,
        "delta": 1.7824
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 19.397549,
    "valor_anterior": 19.847105,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 18.1895,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17.8857,
        "delta": -0.3038
      },
      {
        "periodo": 202508,
        "valor": 18.2535,
        "delta": 0.3677
      },
      {
        "periodo": 202509,
        "valor": 19.1166,
        "delta": 0.8632
      },
      {
        "periodo": 202510,
        "valor": 19.5539,
        "delta": 0.4373
      },
      {
        "periodo": 202511,
        "valor": 19.5042,
        "delta": -0.0496
      },
      {
        "periodo": 202512,
        "valor": 18.7052,
        "delta": -0.799
      },
      {
        "periodo": 202601,
        "valor": 19.0042,
        "delta": 0.2989
      },
      {
        "periodo": 202602,
        "valor": 19.2235,
        "delta": 0.2193
      },
      {
        "periodo": 202603,
        "valor": 19.6521,
        "delta": 0.4286
      },
      {
        "periodo": 202604,
        "valor": 18.8271,
        "delta": -0.825
      },
      {
        "periodo": 202605,
        "valor": 19.8471,
        "delta": 1.02
      },
      {
        "periodo": 202606,
        "valor": 19.3975,
        "delta": -0.4496
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 15.068186,
    "valor_anterior": 15.245983,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.7415,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.8467,
        "delta": 0.1052
      },
      {
        "periodo": 202508,
        "valor": 14.8769,
        "delta": 0.0303
      },
      {
        "periodo": 202509,
        "valor": 14.6027,
        "delta": -0.2742
      },
      {
        "periodo": 202510,
        "valor": 14.769,
        "delta": 0.1663
      },
      {
        "periodo": 202511,
        "valor": 14.4549,
        "delta": -0.3141
      },
      {
        "periodo": 202512,
        "valor": 14.6409,
        "delta": 0.186
      },
      {
        "periodo": 202601,
        "valor": 14.9559,
        "delta": 0.315
      },
      {
        "periodo": 202602,
        "valor": 14.8954,
        "delta": -0.0604
      },
      {
        "periodo": 202603,
        "valor": 14.5673,
        "delta": -0.3282
      },
      {
        "periodo": 202604,
        "valor": 15.2195,
        "delta": 0.6522
      },
      {
        "periodo": 202605,
        "valor": 15.246,
        "delta": 0.0265
      },
      {
        "periodo": 202606,
        "valor": 15.0682,
        "delta": -0.1778
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 25.75418,
    "valor_anterior": 25.974474,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 21.7005,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 22.2823,
        "delta": 0.5818
      },
      {
        "periodo": 202508,
        "valor": 22.3751,
        "delta": 0.0928
      },
      {
        "periodo": 202509,
        "valor": 23.2695,
        "delta": 0.8944
      },
      {
        "periodo": 202510,
        "valor": 23.0262,
        "delta": -0.2433
      },
      {
        "periodo": 202511,
        "valor": 23.0348,
        "delta": 0.0086
      },
      {
        "periodo": 202512,
        "valor": 25.2767,
        "delta": 2.2418
      },
      {
        "periodo": 202601,
        "valor": 25.0043,
        "delta": -0.2723
      },
      {
        "periodo": 202602,
        "valor": 23.9775,
        "delta": -1.0268
      },
      {
        "periodo": 202603,
        "valor": 24.3777,
        "delta": 0.4002
      },
      {
        "periodo": 202604,
        "valor": 24.3772,
        "delta": -0.0004
      },
      {
        "periodo": 202605,
        "valor": 25.9745,
        "delta": 1.5972
      },
      {
        "periodo": 202606,
        "valor": 25.7542,
        "delta": -0.2203
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 228.774898,
    "valor_anterior": 237.684459,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 153.4448,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 150.7438,
        "delta": -2.7009
      },
      {
        "periodo": 202508,
        "valor": 160.7523,
        "delta": 10.0085
      },
      {
        "periodo": 202509,
        "valor": 176.2203,
        "delta": 15.468
      },
      {
        "periodo": 202510,
        "valor": 170.4794,
        "delta": -5.7409
      },
      {
        "periodo": 202511,
        "valor": 184.3382,
        "delta": 13.8588
      },
      {
        "periodo": 202512,
        "valor": 185.6193,
        "delta": 1.2811
      },
      {
        "periodo": 202601,
        "valor": 193.9004,
        "delta": 8.2811
      },
      {
        "periodo": 202602,
        "valor": 195.273,
        "delta": 1.3726
      },
      {
        "periodo": 202603,
        "valor": 206.9506,
        "delta": 11.6776
      },
      {
        "periodo": 202604,
        "valor": 209.8786,
        "delta": 2.9281
      },
      {
        "periodo": 202605,
        "valor": 237.6845,
        "delta": 27.8058
      },
      {
        "periodo": 202606,
        "valor": 228.7749,
        "delta": -8.9096
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 14.668535,
    "valor_anterior": 14.867431,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.7086,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.3652,
        "delta": -0.3434
      },
      {
        "periodo": 202508,
        "valor": 14.0113,
        "delta": -0.3539
      },
      {
        "periodo": 202509,
        "valor": 14.94,
        "delta": 0.9287
      },
      {
        "periodo": 202510,
        "valor": 15.1724,
        "delta": 0.2323
      },
      {
        "periodo": 202511,
        "valor": 15.1422,
        "delta": -0.0302
      },
      {
        "periodo": 202512,
        "valor": 15.5026,
        "delta": 0.3605
      },
      {
        "periodo": 202601,
        "valor": 15.1049,
        "delta": -0.3977
      },
      {
        "periodo": 202602,
        "valor": 15.0972,
        "delta": -0.0077
      },
      {
        "periodo": 202603,
        "valor": 15.5364,
        "delta": 0.4392
      },
      {
        "periodo": 202604,
        "valor": 15.3177,
        "delta": -0.2187
      },
      {
        "periodo": 202605,
        "valor": 14.8674,
        "delta": -0.4502
      },
      {
        "periodo": 202606,
        "valor": 14.6685,
        "delta": -0.1989
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 13.325515,
    "valor_anterior": 13.148665,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 13.2278,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13.2091,
        "delta": -0.0187
      },
      {
        "periodo": 202508,
        "valor": 12.099,
        "delta": -1.1101
      },
      {
        "periodo": 202509,
        "valor": 13.3286,
        "delta": 1.2296
      },
      {
        "periodo": 202510,
        "valor": 15.3968,
        "delta": 2.0682
      },
      {
        "periodo": 202511,
        "valor": 14.7402,
        "delta": -0.6566
      },
      {
        "periodo": 202512,
        "valor": 12.6525,
        "delta": -2.0877
      },
      {
        "periodo": 202601,
        "valor": 13.5088,
        "delta": 0.8563
      },
      {
        "periodo": 202602,
        "valor": 13.8727,
        "delta": 0.3639
      },
      {
        "periodo": 202603,
        "valor": 13.9856,
        "delta": 0.1129
      },
      {
        "periodo": 202604,
        "valor": 13.9285,
        "delta": -0.0571
      },
      {
        "periodo": 202605,
        "valor": 13.1487,
        "delta": -0.7799
      },
      {
        "periodo": 202606,
        "valor": 13.3255,
        "delta": 0.1768
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 20.502546,
    "valor_anterior": 24.086302,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 23.092,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 24.6519,
        "delta": 1.5599
      },
      {
        "periodo": 202508,
        "valor": 23.0837,
        "delta": -1.5682
      },
      {
        "periodo": 202509,
        "valor": 25.2753,
        "delta": 2.1916
      },
      {
        "periodo": 202510,
        "valor": 25.2278,
        "delta": -0.0475
      },
      {
        "periodo": 202511,
        "valor": 23.0526,
        "delta": -2.1751
      },
      {
        "periodo": 202512,
        "valor": 24.2592,
        "delta": 1.2066
      },
      {
        "periodo": 202601,
        "valor": 22.3905,
        "delta": -1.8686
      },
      {
        "periodo": 202602,
        "valor": 22.8979,
        "delta": 0.5074
      },
      {
        "periodo": 202603,
        "valor": 21.0241,
        "delta": -1.8739
      },
      {
        "periodo": 202604,
        "valor": 20.9998,
        "delta": -0.0242
      },
      {
        "periodo": 202605,
        "valor": 24.0863,
        "delta": 3.0865
      },
      {
        "periodo": 202606,
        "valor": 20.5025,
        "delta": -3.5838
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 32.104463,
    "valor_anterior": 31.914705,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 30.6624,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 29.85,
        "delta": -0.8124
      },
      {
        "periodo": 202508,
        "valor": 30.2581,
        "delta": 0.4081
      },
      {
        "periodo": 202509,
        "valor": 31.7118,
        "delta": 1.4537
      },
      {
        "periodo": 202510,
        "valor": 32.0551,
        "delta": 0.3433
      },
      {
        "periodo": 202511,
        "valor": 29.0481,
        "delta": -3.007
      },
      {
        "periodo": 202512,
        "valor": 29.9514,
        "delta": 0.9032
      },
      {
        "periodo": 202601,
        "valor": 32.0341,
        "delta": 2.0827
      },
      {
        "periodo": 202602,
        "valor": 32.3425,
        "delta": 0.3084
      },
      {
        "periodo": 202603,
        "valor": 32.3261,
        "delta": -0.0164
      },
      {
        "periodo": 202604,
        "valor": 30.5025,
        "delta": -1.8236
      },
      {
        "periodo": 202605,
        "valor": 31.9147,
        "delta": 1.4122
      },
      {
        "periodo": 202606,
        "valor": 32.1045,
        "delta": 0.1898
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 15.081639,
    "valor_anterior": 15.56345,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 16.3406,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 16.1151,
        "delta": -0.2255
      },
      {
        "periodo": 202508,
        "valor": 16.3445,
        "delta": 0.2294
      },
      {
        "periodo": 202509,
        "valor": 15.535,
        "delta": -0.8095
      },
      {
        "periodo": 202510,
        "valor": 15.3561,
        "delta": -0.1789
      },
      {
        "periodo": 202511,
        "valor": 15.7733,
        "delta": 0.4172
      },
      {
        "periodo": 202512,
        "valor": 15.4135,
        "delta": -0.3598
      },
      {
        "periodo": 202601,
        "valor": 16.0936,
        "delta": 0.6801
      },
      {
        "periodo": 202602,
        "valor": 16.1178,
        "delta": 0.0242
      },
      {
        "periodo": 202603,
        "valor": 16.5766,
        "delta": 0.4588
      },
      {
        "periodo": 202604,
        "valor": 15.8534,
        "delta": -0.7232
      },
      {
        "periodo": 202605,
        "valor": 15.5634,
        "delta": -0.2899
      },
      {
        "periodo": 202606,
        "valor": 15.0816,
        "delta": -0.4818
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 17.246799,
    "valor_anterior": 17.879806,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 18.2274,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18.1969,
        "delta": -0.0305
      },
      {
        "periodo": 202508,
        "valor": 17.4642,
        "delta": -0.7328
      },
      {
        "periodo": 202509,
        "valor": 18.0614,
        "delta": 0.5972
      },
      {
        "periodo": 202510,
        "valor": 17.8641,
        "delta": -0.1973
      },
      {
        "periodo": 202511,
        "valor": 16.8274,
        "delta": -1.0366
      },
      {
        "periodo": 202512,
        "valor": 16.947,
        "delta": 0.1196
      },
      {
        "periodo": 202601,
        "valor": 16.9738,
        "delta": 0.0268
      },
      {
        "periodo": 202602,
        "valor": 17.2034,
        "delta": 0.2296
      },
      {
        "periodo": 202603,
        "valor": 16.9027,
        "delta": -0.3007
      },
      {
        "periodo": 202604,
        "valor": 17.3069,
        "delta": 0.4042
      },
      {
        "periodo": 202605,
        "valor": 17.8798,
        "delta": 0.5729
      },
      {
        "periodo": 202606,
        "valor": 17.2468,
        "delta": -0.633
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 25.207297,
    "valor_anterior": 24.562347,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17.6158,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 25.792,
        "delta": 8.1762
      },
      {
        "periodo": 202508,
        "valor": 32.938,
        "delta": 7.146
      },
      {
        "periodo": 202509,
        "valor": 53.7846,
        "delta": 20.8466
      },
      {
        "periodo": 202510,
        "valor": 55.8971,
        "delta": 2.1125
      },
      {
        "periodo": 202511,
        "valor": 22.141,
        "delta": -33.7561
      },
      {
        "periodo": 202512,
        "valor": 23.8787,
        "delta": 1.7377
      },
      {
        "periodo": 202601,
        "valor": 24.6876,
        "delta": 0.8089
      },
      {
        "periodo": 202602,
        "valor": 25.7625,
        "delta": 1.0748
      },
      {
        "periodo": 202603,
        "valor": 26.9815,
        "delta": 1.219
      },
      {
        "periodo": 202604,
        "valor": 23.7503,
        "delta": -3.2312
      },
      {
        "periodo": 202605,
        "valor": 24.5623,
        "delta": 0.8121
      },
      {
        "periodo": 202606,
        "valor": 25.2073,
        "delta": 0.645
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 15.643436,
    "valor_anterior": 14.190794,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17.4696,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17.301,
        "delta": -0.1685
      },
      {
        "periodo": 202508,
        "valor": 15.8062,
        "delta": -1.4949
      },
      {
        "periodo": 202509,
        "valor": 15.921,
        "delta": 0.1148
      },
      {
        "periodo": 202510,
        "valor": 15.7094,
        "delta": -0.2116
      },
      {
        "periodo": 202511,
        "valor": 15.0444,
        "delta": -0.665
      },
      {
        "periodo": 202512,
        "valor": 15.0096,
        "delta": -0.0348
      },
      {
        "periodo": 202601,
        "valor": 14.8701,
        "delta": -0.1395
      },
      {
        "periodo": 202602,
        "valor": 15.0497,
        "delta": 0.1796
      },
      {
        "periodo": 202603,
        "valor": 14.5718,
        "delta": -0.4779
      },
      {
        "periodo": 202604,
        "valor": 14.8176,
        "delta": 0.2458
      },
      {
        "periodo": 202605,
        "valor": 14.1908,
        "delta": -0.6268
      },
      {
        "periodo": 202606,
        "valor": 15.6434,
        "delta": 1.4526
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 29.168221,
    "valor_anterior": 22.522398,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 44.7849,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 36.4415,
        "delta": -8.3433
      },
      {
        "periodo": 202508,
        "valor": 46.1991,
        "delta": 9.7576
      },
      {
        "periodo": 202509,
        "valor": 41.5569,
        "delta": -4.6422
      },
      {
        "periodo": 202510,
        "valor": 36.287,
        "delta": -5.27
      },
      {
        "periodo": 202511,
        "valor": 28.9028,
        "delta": -7.3841
      },
      {
        "periodo": 202512,
        "valor": 37.8799,
        "delta": 8.9771
      },
      {
        "periodo": 202601,
        "valor": 33.6047,
        "delta": -4.2752
      },
      {
        "periodo": 202602,
        "valor": 26.0672,
        "delta": -7.5375
      },
      {
        "periodo": 202603,
        "valor": 31.5272,
        "delta": 5.46
      },
      {
        "periodo": 202604,
        "valor": 24.8554,
        "delta": -6.6719
      },
      {
        "periodo": 202605,
        "valor": 22.5224,
        "delta": -2.333
      },
      {
        "periodo": 202606,
        "valor": 29.1682,
        "delta": 6.6458
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 15.038291,
    "valor_anterior": 15.109595,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 15.394,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17.7397,
        "delta": 2.3457
      },
      {
        "periodo": 202508,
        "valor": 16.8462,
        "delta": -0.8935
      },
      {
        "periodo": 202509,
        "valor": 17.2017,
        "delta": 0.3555
      },
      {
        "periodo": 202510,
        "valor": 15.6918,
        "delta": -1.5099
      },
      {
        "periodo": 202511,
        "valor": 15.3299,
        "delta": -0.3618
      },
      {
        "periodo": 202512,
        "valor": 21.1519,
        "delta": 5.8219
      },
      {
        "periodo": 202601,
        "valor": 18.2052,
        "delta": -2.9466
      },
      {
        "periodo": 202602,
        "valor": 15.4791,
        "delta": -2.7261
      },
      {
        "periodo": 202603,
        "valor": 17.0872,
        "delta": 1.6081
      },
      {
        "periodo": 202604,
        "valor": 15.3703,
        "delta": -1.7169
      },
      {
        "periodo": 202605,
        "valor": 15.1096,
        "delta": -0.2607
      },
      {
        "periodo": 202606,
        "valor": 15.0383,
        "delta": -0.0713
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 14.193716,
    "valor_anterior": 14.129136,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 13.5042,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13.6869,
        "delta": 0.1826
      },
      {
        "periodo": 202508,
        "valor": 13.4358,
        "delta": -0.251
      },
      {
        "periodo": 202509,
        "valor": 13.7367,
        "delta": 0.3009
      },
      {
        "periodo": 202510,
        "valor": 13.5743,
        "delta": -0.1624
      },
      {
        "periodo": 202511,
        "valor": 13.9725,
        "delta": 0.3982
      },
      {
        "periodo": 202512,
        "valor": 13.9702,
        "delta": -0.0023
      },
      {
        "periodo": 202601,
        "valor": 13.8421,
        "delta": -0.1281
      },
      {
        "periodo": 202602,
        "valor": 13.5262,
        "delta": -0.3159
      },
      {
        "periodo": 202603,
        "valor": 13.7558,
        "delta": 0.2296
      },
      {
        "periodo": 202604,
        "valor": 13.7223,
        "delta": -0.0335
      },
      {
        "periodo": 202605,
        "valor": 14.1291,
        "delta": 0.4069
      },
      {
        "periodo": 202606,
        "valor": 14.1937,
        "delta": 0.0646
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 29.88941,
    "valor_anterior": 29.515463,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 27.4702,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 27.5058,
        "delta": 0.0356
      },
      {
        "periodo": 202508,
        "valor": 27.3586,
        "delta": -0.1472
      },
      {
        "periodo": 202509,
        "valor": 28.6201,
        "delta": 1.2615
      },
      {
        "periodo": 202510,
        "valor": 27.9412,
        "delta": -0.6789
      },
      {
        "periodo": 202511,
        "valor": 27.3203,
        "delta": -0.6209
      },
      {
        "periodo": 202512,
        "valor": 27.5016,
        "delta": 0.1814
      },
      {
        "periodo": 202601,
        "valor": 26.8576,
        "delta": -0.644
      },
      {
        "periodo": 202602,
        "valor": 26.6916,
        "delta": -0.166
      },
      {
        "periodo": 202603,
        "valor": 24.9825,
        "delta": -1.7092
      },
      {
        "periodo": 202604,
        "valor": 29.3053,
        "delta": 4.3229
      },
      {
        "periodo": 202605,
        "valor": 29.5155,
        "delta": 0.2101
      },
      {
        "periodo": 202606,
        "valor": 29.8894,
        "delta": 0.3739
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 10.8254,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 11.7664,
        "delta": 0.9411
      },
      {
        "periodo": 202508,
        "valor": 14.8744,
        "delta": 3.108
      },
      {
        "periodo": 202509,
        "valor": 16.1948,
        "delta": 1.3203
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 21.611661,
    "valor_anterior": 22.007027,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 21.3073,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 23.355,
        "delta": 2.0476
      },
      {
        "periodo": 202508,
        "valor": 22.5006,
        "delta": -0.8544
      },
      {
        "periodo": 202509,
        "valor": 21.3157,
        "delta": -1.1849
      },
      {
        "periodo": 202510,
        "valor": 21.1027,
        "delta": -0.213
      },
      {
        "periodo": 202511,
        "valor": 21.1524,
        "delta": 0.0497
      },
      {
        "periodo": 202512,
        "valor": 21.3676,
        "delta": 0.2152
      },
      {
        "periodo": 202601,
        "valor": 20.1246,
        "delta": -1.243
      },
      {
        "periodo": 202602,
        "valor": 21.7327,
        "delta": 1.6081
      },
      {
        "periodo": 202603,
        "valor": 23.1347,
        "delta": 1.402
      },
      {
        "periodo": 202604,
        "valor": 20.5076,
        "delta": -2.6271
      },
      {
        "periodo": 202605,
        "valor": 22.007,
        "delta": 1.4994
      },
      {
        "periodo": 202606,
        "valor": 21.6117,
        "delta": -0.3954
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 12.481132,
    "valor_anterior": 11.460495,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.7472,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.24,
        "delta": -0.5072
      },
      {
        "periodo": 202508,
        "valor": 14.3431,
        "delta": 0.1032
      },
      {
        "periodo": 202509,
        "valor": 13.6669,
        "delta": -0.6762
      },
      {
        "periodo": 202510,
        "valor": 13.5549,
        "delta": -0.112
      },
      {
        "periodo": 202511,
        "valor": 12.8422,
        "delta": -0.7126
      },
      {
        "periodo": 202512,
        "valor": 13.4527,
        "delta": 0.6105
      },
      {
        "periodo": 202601,
        "valor": 12.7541,
        "delta": -0.6986
      },
      {
        "periodo": 202602,
        "valor": 12.7242,
        "delta": -0.03
      },
      {
        "periodo": 202603,
        "valor": 13.3202,
        "delta": 0.5961
      },
      {
        "periodo": 202604,
        "valor": 12.1866,
        "delta": -1.1337
      },
      {
        "periodo": 202605,
        "valor": 11.4605,
        "delta": -0.7261
      },
      {
        "periodo": 202606,
        "valor": 12.4811,
        "delta": 1.0206
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 115.33629,
    "valor_anterior": 106.195597,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 150.8684,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 151.077,
        "delta": 0.2086
      },
      {
        "periodo": 202508,
        "valor": 134.4491,
        "delta": -16.6279
      },
      {
        "periodo": 202509,
        "valor": 146.2207,
        "delta": 11.7716
      },
      {
        "periodo": 202510,
        "valor": 138.2654,
        "delta": -7.9553
      },
      {
        "periodo": 202511,
        "valor": 132.2233,
        "delta": -6.0421
      },
      {
        "periodo": 202512,
        "valor": 134.8015,
        "delta": 2.5782
      },
      {
        "periodo": 202601,
        "valor": 122.3967,
        "delta": -12.4048
      },
      {
        "periodo": 202602,
        "valor": 122.5034,
        "delta": 0.1067
      },
      {
        "periodo": 202603,
        "valor": 120.8328,
        "delta": -1.6707
      },
      {
        "periodo": 202604,
        "valor": 118.4693,
        "delta": -2.3635
      },
      {
        "periodo": 202605,
        "valor": 106.1956,
        "delta": -12.2737
      },
      {
        "periodo": 202606,
        "valor": 115.3363,
        "delta": 9.1407
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 73.825355,
    "valor_anterior": 74.263084,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 95.5907,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 91.0426,
        "delta": -4.5481
      },
      {
        "periodo": 202508,
        "valor": 85.5332,
        "delta": -5.5094
      },
      {
        "periodo": 202509,
        "valor": 81.9308,
        "delta": -3.6024
      },
      {
        "periodo": 202510,
        "valor": 76.6862,
        "delta": -5.2446
      },
      {
        "periodo": 202511,
        "valor": 73.9434,
        "delta": -2.7428
      },
      {
        "periodo": 202512,
        "valor": 76.9739,
        "delta": 3.0305
      },
      {
        "periodo": 202601,
        "valor": 75.5844,
        "delta": -1.3895
      },
      {
        "periodo": 202602,
        "valor": 76.1741,
        "delta": 0.5897
      },
      {
        "periodo": 202603,
        "valor": 74.1142,
        "delta": -2.0599
      },
      {
        "periodo": 202604,
        "valor": 74.4632,
        "delta": 0.349
      },
      {
        "periodo": 202605,
        "valor": 74.2631,
        "delta": -0.2001
      },
      {
        "periodo": 202606,
        "valor": 73.8254,
        "delta": -0.4377
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 15.632159,
    "valor_anterior": 15.769565,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 16.6741,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 16.7634,
        "delta": 0.0892
      },
      {
        "periodo": 202508,
        "valor": 16.3991,
        "delta": -0.3643
      },
      {
        "periodo": 202509,
        "valor": 16.3444,
        "delta": -0.0546
      },
      {
        "periodo": 202510,
        "valor": 16.3157,
        "delta": -0.0287
      },
      {
        "periodo": 202511,
        "valor": 16.1219,
        "delta": -0.1939
      },
      {
        "periodo": 202512,
        "valor": 16.0567,
        "delta": -0.0651
      },
      {
        "periodo": 202601,
        "valor": 16.0689,
        "delta": 0.0122
      },
      {
        "periodo": 202602,
        "valor": 16.1727,
        "delta": 0.1038
      },
      {
        "periodo": 202603,
        "valor": 15.9604,
        "delta": -0.2122
      },
      {
        "periodo": 202604,
        "valor": 15.8527,
        "delta": -0.1077
      },
      {
        "periodo": 202605,
        "valor": 15.7696,
        "delta": -0.0831
      },
      {
        "periodo": 202606,
        "valor": 15.6322,
        "delta": -0.1374
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 26.948384,
    "valor_anterior": 26.340513,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 23.1403,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 23.4783,
        "delta": 0.3379
      },
      {
        "periodo": 202508,
        "valor": 24.8013,
        "delta": 1.323
      },
      {
        "periodo": 202509,
        "valor": 23.8939,
        "delta": -0.9074
      },
      {
        "periodo": 202510,
        "valor": 24.0389,
        "delta": 0.1451
      },
      {
        "periodo": 202511,
        "valor": 24.0185,
        "delta": -0.0205
      },
      {
        "periodo": 202512,
        "valor": 24.8452,
        "delta": 0.8267
      },
      {
        "periodo": 202601,
        "valor": 27.2741,
        "delta": 2.4289
      },
      {
        "periodo": 202602,
        "valor": 26.2459,
        "delta": -1.0282
      },
      {
        "periodo": 202603,
        "valor": 25.6857,
        "delta": -0.5603
      },
      {
        "periodo": 202604,
        "valor": 25.3535,
        "delta": -0.3321
      },
      {
        "periodo": 202605,
        "valor": 26.3405,
        "delta": 0.987
      },
      {
        "periodo": 202606,
        "valor": 26.9484,
        "delta": 0.6079
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 13.437667,
    "valor_anterior": 13.447534,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 13.9264,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.0797,
        "delta": 0.1533
      },
      {
        "periodo": 202508,
        "valor": 13.5347,
        "delta": -0.545
      },
      {
        "periodo": 202509,
        "valor": 13.7518,
        "delta": 0.2171
      },
      {
        "periodo": 202510,
        "valor": 13.5625,
        "delta": -0.1893
      },
      {
        "periodo": 202511,
        "valor": 13.5082,
        "delta": -0.0544
      },
      {
        "periodo": 202512,
        "valor": 13.8136,
        "delta": 0.3054
      },
      {
        "periodo": 202601,
        "valor": 13.4533,
        "delta": -0.3603
      },
      {
        "periodo": 202602,
        "valor": 13.6585,
        "delta": 0.2051
      },
      {
        "periodo": 202603,
        "valor": 13.5086,
        "delta": -0.1499
      },
      {
        "periodo": 202604,
        "valor": 13.4396,
        "delta": -0.069
      },
      {
        "periodo": 202605,
        "valor": 13.4475,
        "delta": 0.0079
      },
      {
        "periodo": 202606,
        "valor": 13.4377,
        "delta": -0.0099
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 14.496003,
    "valor_anterior": 13.327347,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 13.1196,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13.3375,
        "delta": 0.2178
      },
      {
        "periodo": 202508,
        "valor": 13.1891,
        "delta": -0.1483
      },
      {
        "periodo": 202509,
        "valor": 13.3074,
        "delta": 0.1183
      },
      {
        "periodo": 202510,
        "valor": 13.1392,
        "delta": -0.1682
      },
      {
        "periodo": 202511,
        "valor": 13.2826,
        "delta": 0.1434
      },
      {
        "periodo": 202512,
        "valor": 13.3065,
        "delta": 0.024
      },
      {
        "periodo": 202601,
        "valor": 13.1193,
        "delta": -0.1872
      },
      {
        "periodo": 202602,
        "valor": 13.0093,
        "delta": -0.11
      },
      {
        "periodo": 202603,
        "valor": 13.1732,
        "delta": 0.1639
      },
      {
        "periodo": 202604,
        "valor": 13.1441,
        "delta": -0.0291
      },
      {
        "periodo": 202605,
        "valor": 13.3273,
        "delta": 0.1832
      },
      {
        "periodo": 202606,
        "valor": 14.496,
        "delta": 1.1687
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 25.40352,
    "valor_anterior": 27.795902,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 25.0588,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 25.8716,
        "delta": 0.8128
      },
      {
        "periodo": 202508,
        "valor": 25.3162,
        "delta": -0.5553
      },
      {
        "periodo": 202509,
        "valor": 25.0016,
        "delta": -0.3146
      },
      {
        "periodo": 202510,
        "valor": 23.8234,
        "delta": -1.1782
      },
      {
        "periodo": 202511,
        "valor": 24.8257,
        "delta": 1.0023
      },
      {
        "periodo": 202512,
        "valor": 24.1555,
        "delta": -0.6702
      },
      {
        "periodo": 202601,
        "valor": 24.7774,
        "delta": 0.6219
      },
      {
        "periodo": 202602,
        "valor": 24.3974,
        "delta": -0.38
      },
      {
        "periodo": 202603,
        "valor": 26.0152,
        "delta": 1.6178
      },
      {
        "periodo": 202604,
        "valor": 26.7034,
        "delta": 0.6882
      },
      {
        "periodo": 202605,
        "valor": 27.7959,
        "delta": 1.0925
      },
      {
        "periodo": 202606,
        "valor": 25.4035,
        "delta": -2.3924
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 14.583241,
    "valor_anterior": 14.352781,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.7359,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.6827,
        "delta": -0.0532
      },
      {
        "periodo": 202508,
        "valor": 14.8894,
        "delta": 0.2066
      },
      {
        "periodo": 202509,
        "valor": 14.8408,
        "delta": -0.0486
      },
      {
        "periodo": 202510,
        "valor": 14.4997,
        "delta": -0.3411
      },
      {
        "periodo": 202511,
        "valor": 14.3938,
        "delta": -0.1059
      },
      {
        "periodo": 202512,
        "valor": 14.743,
        "delta": 0.3492
      },
      {
        "periodo": 202601,
        "valor": 14.5032,
        "delta": -0.2398
      },
      {
        "periodo": 202602,
        "valor": 14.5116,
        "delta": 0.0084
      },
      {
        "periodo": 202603,
        "valor": 14.4967,
        "delta": -0.0149
      },
      {
        "periodo": 202604,
        "valor": 14.3618,
        "delta": -0.1349
      },
      {
        "periodo": 202605,
        "valor": 14.3528,
        "delta": -0.009
      },
      {
        "periodo": 202606,
        "valor": 14.5832,
        "delta": 0.2305
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 39.252642,
    "valor_anterior": 42.519533,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 40.1226,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 35.3222,
        "delta": -4.8004
      },
      {
        "periodo": 202508,
        "valor": 35.5693,
        "delta": 0.2471
      },
      {
        "periodo": 202509,
        "valor": 37.3707,
        "delta": 1.8014
      },
      {
        "periodo": 202510,
        "valor": 37.7051,
        "delta": 0.3344
      },
      {
        "periodo": 202511,
        "valor": 38.0986,
        "delta": 0.3936
      },
      {
        "periodo": 202512,
        "valor": 39.5485,
        "delta": 1.4499
      },
      {
        "periodo": 202601,
        "valor": 39.6602,
        "delta": 0.1117
      },
      {
        "periodo": 202602,
        "valor": 40.7559,
        "delta": 1.0956
      },
      {
        "periodo": 202603,
        "valor": 41.799,
        "delta": 1.0432
      },
      {
        "periodo": 202604,
        "valor": 40.018,
        "delta": -1.781
      },
      {
        "periodo": 202605,
        "valor": 42.5195,
        "delta": 2.5015
      },
      {
        "periodo": 202606,
        "valor": 39.2526,
        "delta": -3.2669
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 77.662476,
    "valor_anterior": 77.914641,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 100.1696,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 92.4583,
        "delta": -7.7113
      },
      {
        "periodo": 202508,
        "valor": 91.8433,
        "delta": -0.6149
      },
      {
        "periodo": 202509,
        "valor": 94.165,
        "delta": 2.3217
      },
      {
        "periodo": 202510,
        "valor": 92.41,
        "delta": -1.755
      },
      {
        "periodo": 202511,
        "valor": 117.1074,
        "delta": 24.6974
      },
      {
        "periodo": 202512,
        "valor": 98.1728,
        "delta": -18.9346
      },
      {
        "periodo": 202601,
        "valor": 99.0308,
        "delta": 0.858
      },
      {
        "periodo": 202602,
        "valor": 88.816,
        "delta": -10.2148
      },
      {
        "periodo": 202603,
        "valor": 86.1066,
        "delta": -2.7094
      },
      {
        "periodo": 202604,
        "valor": 84.4744,
        "delta": -1.6322
      },
      {
        "periodo": 202605,
        "valor": 77.9146,
        "delta": -6.5597
      },
      {
        "periodo": 202606,
        "valor": 77.6625,
        "delta": -0.2522
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 37.317741,
    "valor_anterior": 42.131259,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 44.4174,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 45.4192,
        "delta": 1.0018
      },
      {
        "periodo": 202508,
        "valor": 45.3314,
        "delta": -0.0879
      },
      {
        "periodo": 202509,
        "valor": 47.0969,
        "delta": 1.7655
      },
      {
        "periodo": 202510,
        "valor": 45.1556,
        "delta": -1.9412
      },
      {
        "periodo": 202511,
        "valor": 45.9566,
        "delta": 0.801
      },
      {
        "periodo": 202512,
        "valor": 46.7566,
        "delta": 0.8
      },
      {
        "periodo": 202601,
        "valor": 44.2216,
        "delta": -2.535
      },
      {
        "periodo": 202602,
        "valor": 46.7565,
        "delta": 2.5348
      },
      {
        "periodo": 202603,
        "valor": 46.7449,
        "delta": -0.0116
      },
      {
        "periodo": 202604,
        "valor": 43.9871,
        "delta": -2.7577
      },
      {
        "periodo": 202605,
        "valor": 42.1313,
        "delta": -1.8559
      },
      {
        "periodo": 202606,
        "valor": 37.3177,
        "delta": -4.8135
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 180.722184,
    "valor_anterior": 177.311815,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 186.3145,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 181.6656,
        "delta": -4.6489
      },
      {
        "periodo": 202508,
        "valor": 175.3321,
        "delta": -6.3335
      },
      {
        "periodo": 202509,
        "valor": 177.7638,
        "delta": 2.4317
      },
      {
        "periodo": 202510,
        "valor": 188.0415,
        "delta": 10.2777
      },
      {
        "periodo": 202511,
        "valor": 189.1332,
        "delta": 1.0917
      },
      {
        "periodo": 202512,
        "valor": 181.9149,
        "delta": -7.2184
      },
      {
        "periodo": 202601,
        "valor": 190.0711,
        "delta": 8.1562
      },
      {
        "periodo": 202602,
        "valor": 198.1733,
        "delta": 8.1022
      },
      {
        "periodo": 202603,
        "valor": 137.7821,
        "delta": -60.3912
      },
      {
        "periodo": 202604,
        "valor": 198.4457,
        "delta": 60.6637
      },
      {
        "periodo": 202605,
        "valor": 177.3118,
        "delta": -21.1339
      },
      {
        "periodo": 202606,
        "valor": 180.7222,
        "delta": 3.4104
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 43.04256,
    "valor_anterior": 45.13873,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 41.968,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 41.0386,
        "delta": -0.9294
      },
      {
        "periodo": 202508,
        "valor": 44.7391,
        "delta": 3.7005
      },
      {
        "periodo": 202509,
        "valor": 44.7908,
        "delta": 0.0517
      },
      {
        "periodo": 202510,
        "valor": 43.8124,
        "delta": -0.9785
      },
      {
        "periodo": 202511,
        "valor": 42.7152,
        "delta": -1.0971
      },
      {
        "periodo": 202512,
        "valor": 43.755,
        "delta": 1.0397
      },
      {
        "periodo": 202601,
        "valor": 45.2825,
        "delta": 1.5276
      },
      {
        "periodo": 202602,
        "valor": 44.4282,
        "delta": -0.8543
      },
      {
        "periodo": 202603,
        "valor": 43.2864,
        "delta": -1.1418
      },
      {
        "periodo": 202604,
        "valor": 42.9135,
        "delta": -0.3729
      },
      {
        "periodo": 202605,
        "valor": 45.1387,
        "delta": 2.2252
      },
      {
        "periodo": 202606,
        "valor": 43.0426,
        "delta": -2.0962
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 66.919122,
    "valor_anterior": 62.143617,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 62.363,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 65.5945,
        "delta": 3.2315
      },
      {
        "periodo": 202508,
        "valor": 73.6443,
        "delta": 8.0499
      },
      {
        "periodo": 202509,
        "valor": 69.454,
        "delta": -4.1903
      },
      {
        "periodo": 202510,
        "valor": 75.1448,
        "delta": 5.6908
      },
      {
        "periodo": 202511,
        "valor": 64.8629,
        "delta": -10.2819
      },
      {
        "periodo": 202512,
        "valor": 64.0557,
        "delta": -0.8073
      },
      {
        "periodo": 202601,
        "valor": 81.3131,
        "delta": 17.2574
      },
      {
        "periodo": 202602,
        "valor": 67.4916,
        "delta": -13.8214
      },
      {
        "periodo": 202603,
        "valor": 68.8513,
        "delta": 1.3597
      },
      {
        "periodo": 202604,
        "valor": 56.0489,
        "delta": -12.8024
      },
      {
        "periodo": 202605,
        "valor": 62.1436,
        "delta": 6.0947
      },
      {
        "periodo": 202606,
        "valor": 66.9191,
        "delta": 4.7755
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 271.508727,
    "valor_anterior": 272.508451,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 277.5415,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 259.1889,
        "delta": -18.3526
      },
      {
        "periodo": 202508,
        "valor": 235.9528,
        "delta": -23.2361
      },
      {
        "periodo": 202509,
        "valor": 252.858,
        "delta": 16.9052
      },
      {
        "periodo": 202510,
        "valor": 259.7231,
        "delta": 6.8651
      },
      {
        "periodo": 202511,
        "valor": 283.3879,
        "delta": 23.6649
      },
      {
        "periodo": 202512,
        "valor": 282.2096,
        "delta": -1.1783
      },
      {
        "periodo": 202601,
        "valor": 273.6223,
        "delta": -8.5874
      },
      {
        "periodo": 202602,
        "valor": 257.0268,
        "delta": -16.5955
      },
      {
        "periodo": 202603,
        "valor": 259.9473,
        "delta": 2.9205
      },
      {
        "periodo": 202604,
        "valor": 266.4028,
        "delta": 6.4555
      },
      {
        "periodo": 202605,
        "valor": 272.5085,
        "delta": 6.1056
      },
      {
        "periodo": 202606,
        "valor": 271.5087,
        "delta": -0.9997
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 14.213029,
    "valor_anterior": 13.965814,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 462.2699,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 448.1859,
        "delta": -14.084
      },
      {
        "periodo": 202508,
        "valor": 436.8538,
        "delta": -11.3321
      },
      {
        "periodo": 202509,
        "valor": 445.6019,
        "delta": 8.7481
      },
      {
        "periodo": 202510,
        "valor": 438.3887,
        "delta": -7.2132
      },
      {
        "periodo": 202511,
        "valor": 438.5138,
        "delta": 0.1251
      },
      {
        "periodo": 202512,
        "valor": 446.1839,
        "delta": 7.6702
      },
      {
        "periodo": 202601,
        "valor": 503.5945,
        "delta": 57.4106
      },
      {
        "periodo": 202602,
        "valor": 17.2959,
        "delta": -486.2987
      },
      {
        "periodo": 202603,
        "valor": 14.7696,
        "delta": -2.5263
      },
      {
        "periodo": 202604,
        "valor": 13.8716,
        "delta": -0.898
      },
      {
        "periodo": 202605,
        "valor": 13.9658,
        "delta": 0.0942
      },
      {
        "periodo": 202606,
        "valor": 14.213,
        "delta": 0.2472
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 47.927958,
    "valor_anterior": 24.90719,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 209.6044,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 155.4786,
        "delta": -54.1258
      },
      {
        "periodo": 202508,
        "valor": 102.481,
        "delta": -52.9977
      },
      {
        "periodo": 202509,
        "valor": 74.6565,
        "delta": -27.8245
      },
      {
        "periodo": 202510,
        "valor": 49.6888,
        "delta": -24.9677
      },
      {
        "periodo": 202511,
        "valor": 34.9345,
        "delta": -14.7542
      },
      {
        "periodo": 202512,
        "valor": 41.0296,
        "delta": 6.0951
      },
      {
        "periodo": 202601,
        "valor": 58.0884,
        "delta": 17.0588
      },
      {
        "periodo": 202602,
        "valor": 46.9142,
        "delta": -11.1742
      },
      {
        "periodo": 202603,
        "valor": 29.2281,
        "delta": -17.686
      },
      {
        "periodo": 202604,
        "valor": 29.689,
        "delta": 0.4608
      },
      {
        "periodo": 202605,
        "valor": 24.9072,
        "delta": -4.7818
      },
      {
        "periodo": 202606,
        "valor": 47.928,
        "delta": 23.0208
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 146.418598,
    "valor_anterior": 162.072283,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 447.1,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 251.6406,
        "delta": -195.4595
      },
      {
        "periodo": 202601,
        "valor": 179.1417,
        "delta": -72.4988
      },
      {
        "periodo": 202602,
        "valor": 140.4063,
        "delta": -38.7355
      },
      {
        "periodo": 202603,
        "valor": 141.5845,
        "delta": 1.1783
      },
      {
        "periodo": 202604,
        "valor": 166.0869,
        "delta": 24.5024
      },
      {
        "periodo": 202605,
        "valor": 162.0723,
        "delta": -4.0146
      },
      {
        "periodo": 202606,
        "valor": 146.4186,
        "delta": -15.6537
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 24.068547,
    "valor_anterior": 18.305359,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 20.6747,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 19.559,
        "delta": -1.1157
      },
      {
        "periodo": 202605,
        "valor": 18.3054,
        "delta": -1.2536
      },
      {
        "periodo": 202606,
        "valor": 24.0685,
        "delta": 5.7632
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 20.559936,
    "valor_anterior": 20.467964,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 20.0006,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 20.2415,
        "delta": 0.2409
      },
      {
        "periodo": 202508,
        "valor": 20.3149,
        "delta": 0.0734
      },
      {
        "periodo": 202509,
        "valor": 20.379,
        "delta": 0.0641
      },
      {
        "periodo": 202510,
        "valor": 20.5088,
        "delta": 0.1298
      },
      {
        "periodo": 202511,
        "valor": 20.1504,
        "delta": -0.3584
      },
      {
        "periodo": 202512,
        "valor": 20.1726,
        "delta": 0.0222
      },
      {
        "periodo": 202601,
        "valor": 20.1524,
        "delta": -0.0203
      },
      {
        "periodo": 202602,
        "valor": 20.2883,
        "delta": 0.1359
      },
      {
        "periodo": 202603,
        "valor": 20.323,
        "delta": 0.0347
      },
      {
        "periodo": 202604,
        "valor": 20.0989,
        "delta": -0.224
      },
      {
        "periodo": 202605,
        "valor": 20.468,
        "delta": 0.369
      },
      {
        "periodo": 202606,
        "valor": 20.5599,
        "delta": 0.092
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 20.75413,
    "valor_anterior": 20.697362,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 20.3332,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 20.563,
        "delta": 0.2298
      },
      {
        "periodo": 202508,
        "valor": 20.6658,
        "delta": 0.1028
      },
      {
        "periodo": 202509,
        "valor": 20.5622,
        "delta": -0.1036
      },
      {
        "periodo": 202510,
        "valor": 20.7242,
        "delta": 0.162
      },
      {
        "periodo": 202511,
        "valor": 20.4175,
        "delta": -0.3068
      },
      {
        "periodo": 202512,
        "valor": 20.2495,
        "delta": -0.1679
      },
      {
        "periodo": 202601,
        "valor": 20.2168,
        "delta": -0.0327
      },
      {
        "periodo": 202602,
        "valor": 20.4704,
        "delta": 0.2535
      },
      {
        "periodo": 202603,
        "valor": 20.4971,
        "delta": 0.0267
      },
      {
        "periodo": 202604,
        "valor": 20.2935,
        "delta": -0.2036
      },
      {
        "periodo": 202605,
        "valor": 20.6974,
        "delta": 0.4039
      },
      {
        "periodo": 202606,
        "valor": 20.7541,
        "delta": 0.0568
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 20.462821,
    "valor_anterior": 20.864559,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 16.9634,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18.9647,
        "delta": 2.0013
      },
      {
        "periodo": 202508,
        "valor": 21.1344,
        "delta": 2.1697
      },
      {
        "periodo": 202509,
        "valor": 23.0134,
        "delta": 1.879
      },
      {
        "periodo": 202510,
        "valor": 24.6758,
        "delta": 1.6624
      },
      {
        "periodo": 202511,
        "valor": 20.2447,
        "delta": -4.4311
      },
      {
        "periodo": 202512,
        "valor": 19.958,
        "delta": -0.2866
      },
      {
        "periodo": 202601,
        "valor": 19.8963,
        "delta": -0.0617
      },
      {
        "periodo": 202602,
        "valor": 20.5357,
        "delta": 0.6394
      },
      {
        "periodo": 202603,
        "valor": 21.2613,
        "delta": 0.7256
      },
      {
        "periodo": 202604,
        "valor": 19.7453,
        "delta": -1.516
      },
      {
        "periodo": 202605,
        "valor": 20.8646,
        "delta": 1.1193
      },
      {
        "periodo": 202606,
        "valor": 20.4628,
        "delta": -0.4017
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 26.260334,
    "valor_anterior": 26.179357,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 24.0054,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 24.592,
        "delta": 0.5866
      },
      {
        "periodo": 202508,
        "valor": 24.2529,
        "delta": -0.3392
      },
      {
        "periodo": 202509,
        "valor": 25.0003,
        "delta": 0.7474
      },
      {
        "periodo": 202510,
        "valor": 24.8247,
        "delta": -0.1756
      },
      {
        "periodo": 202511,
        "valor": 24.7078,
        "delta": -0.1169
      },
      {
        "periodo": 202512,
        "valor": 26.5243,
        "delta": 1.8165
      },
      {
        "periodo": 202601,
        "valor": 26.1796,
        "delta": -0.3447
      },
      {
        "periodo": 202602,
        "valor": 25.1791,
        "delta": -1.0006
      },
      {
        "periodo": 202603,
        "valor": 25.4928,
        "delta": 0.3137
      },
      {
        "periodo": 202604,
        "valor": 25.538,
        "delta": 0.0452
      },
      {
        "periodo": 202605,
        "valor": 26.1794,
        "delta": 0.6414
      },
      {
        "periodo": 202606,
        "valor": 26.2603,
        "delta": 0.081
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 15.760314,
    "valor_anterior": 15.750116,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.9452,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 15.0624,
        "delta": 0.1172
      },
      {
        "periodo": 202508,
        "valor": 15.364,
        "delta": 0.3016
      },
      {
        "periodo": 202509,
        "valor": 15.4533,
        "delta": 0.0894
      },
      {
        "periodo": 202510,
        "valor": 15.5257,
        "delta": 0.0723
      },
      {
        "periodo": 202511,
        "valor": 15.293,
        "delta": -0.2326
      },
      {
        "periodo": 202512,
        "valor": 15.4218,
        "delta": 0.1288
      },
      {
        "periodo": 202601,
        "valor": 15.6704,
        "delta": 0.2486
      },
      {
        "periodo": 202602,
        "valor": 15.9114,
        "delta": 0.241
      },
      {
        "periodo": 202603,
        "valor": 15.6904,
        "delta": -0.221
      },
      {
        "periodo": 202604,
        "valor": 15.1714,
        "delta": -0.519
      },
      {
        "periodo": 202605,
        "valor": 15.7501,
        "delta": 0.5787
      },
      {
        "periodo": 202606,
        "valor": 15.7603,
        "delta": 0.0102
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 19.738621,
    "valor_anterior": 19.72056,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 21.7355,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 21.2948,
        "delta": -0.4407
      },
      {
        "periodo": 202508,
        "valor": 20.8269,
        "delta": -0.4679
      },
      {
        "periodo": 202509,
        "valor": 20.6414,
        "delta": -0.1855
      },
      {
        "periodo": 202510,
        "valor": 20.7156,
        "delta": 0.0742
      },
      {
        "periodo": 202511,
        "valor": 20.1917,
        "delta": -0.524
      },
      {
        "periodo": 202512,
        "valor": 19.9156,
        "delta": -0.276
      },
      {
        "periodo": 202601,
        "valor": 19.9631,
        "delta": 0.0475
      },
      {
        "periodo": 202602,
        "valor": 20.0105,
        "delta": 0.0474
      },
      {
        "periodo": 202603,
        "valor": 20.1247,
        "delta": 0.1141
      },
      {
        "periodo": 202604,
        "valor": 19.8417,
        "delta": -0.283
      },
      {
        "periodo": 202605,
        "valor": 19.7206,
        "delta": -0.1212
      },
      {
        "periodo": 202606,
        "valor": 19.7386,
        "delta": 0.0181
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 4021750,
    "label": "ICAP T Jun 2026",
    "valor_actual": 17.939159,
    "valor_anterior": 17.206529,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 18.1009,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17.7575,
        "delta": -0.3434
      },
      {
        "periodo": 202508,
        "valor": 17.0904,
        "delta": -0.6671
      },
      {
        "periodo": 202509,
        "valor": 17.81,
        "delta": 0.7196
      },
      {
        "periodo": 202510,
        "valor": 17.8324,
        "delta": 0.0224
      },
      {
        "periodo": 202511,
        "valor": 17.5223,
        "delta": -0.3101
      },
      {
        "periodo": 202512,
        "valor": 17.8994,
        "delta": 0.3771
      },
      {
        "periodo": 202601,
        "valor": 17.8878,
        "delta": -0.0116
      },
      {
        "periodo": 202602,
        "valor": 17.6177,
        "delta": -0.2701
      },
      {
        "periodo": 202603,
        "valor": 17.6792,
        "delta": 0.0615
      },
      {
        "periodo": 202604,
        "valor": 17.5869,
        "delta": -0.0922
      },
      {
        "periodo": 202605,
        "valor": 17.2065,
        "delta": -0.3804
      },
      {
        "periodo": 202606,
        "valor": 17.9392,
        "delta": 0.7326
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 21.110204,
    "valor_anterior": 21.242801,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 21.0438,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 21.0071,
        "delta": -0.0367
      },
      {
        "periodo": 202508,
        "valor": 21.0827,
        "delta": 0.0756
      },
      {
        "periodo": 202509,
        "valor": 20.6278,
        "delta": -0.4549
      },
      {
        "periodo": 202510,
        "valor": 20.6777,
        "delta": 0.0499
      },
      {
        "periodo": 202511,
        "valor": 20.7476,
        "delta": 0.0699
      },
      {
        "periodo": 202512,
        "valor": 20.8206,
        "delta": 0.073
      },
      {
        "periodo": 202601,
        "valor": 21.3844,
        "delta": 0.5638
      },
      {
        "periodo": 202602,
        "valor": 21.0773,
        "delta": -0.307
      },
      {
        "periodo": 202603,
        "valor": 21.4281,
        "delta": 0.3507
      },
      {
        "periodo": 202604,
        "valor": 20.4442,
        "delta": -0.9838
      },
      {
        "periodo": 202605,
        "valor": 21.2428,
        "delta": 0.7986
      },
      {
        "periodo": 202606,
        "valor": 21.1102,
        "delta": -0.1326
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 16.154005,
    "valor_anterior": 16.899931,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 16.1649,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 16.131,
        "delta": -0.0339
      },
      {
        "periodo": 202508,
        "valor": 16.62,
        "delta": 0.489
      },
      {
        "periodo": 202509,
        "valor": 16.2504,
        "delta": -0.3696
      },
      {
        "periodo": 202510,
        "valor": 16.3503,
        "delta": 0.0999
      },
      {
        "periodo": 202511,
        "valor": 16.5098,
        "delta": 0.1596
      },
      {
        "periodo": 202512,
        "valor": 16.4808,
        "delta": -0.029
      },
      {
        "periodo": 202601,
        "valor": 16.6794,
        "delta": 0.1986
      },
      {
        "periodo": 202602,
        "valor": 17.152,
        "delta": 0.4727
      },
      {
        "periodo": 202603,
        "valor": 16.4967,
        "delta": -0.6554
      },
      {
        "periodo": 202604,
        "valor": 16.8783,
        "delta": 0.3817
      },
      {
        "periodo": 202605,
        "valor": 16.8999,
        "delta": 0.0216
      },
      {
        "periodo": 202606,
        "valor": 16.154,
        "delta": -0.7459
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 14.938968,
    "valor_anterior": 15.098616,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 13.9577,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.572,
        "delta": 0.6143
      },
      {
        "periodo": 202508,
        "valor": 14.3897,
        "delta": -0.1824
      },
      {
        "periodo": 202509,
        "valor": 14.8041,
        "delta": 0.4145
      },
      {
        "periodo": 202510,
        "valor": 15.0586,
        "delta": 0.2544
      },
      {
        "periodo": 202511,
        "valor": 14.9729,
        "delta": -0.0857
      },
      {
        "periodo": 202512,
        "valor": 13.7798,
        "delta": -1.193
      },
      {
        "periodo": 202601,
        "valor": 14.3347,
        "delta": 0.5549
      },
      {
        "periodo": 202602,
        "valor": 14.6229,
        "delta": 0.2882
      },
      {
        "periodo": 202603,
        "valor": 15.1391,
        "delta": 0.5161
      },
      {
        "periodo": 202604,
        "valor": 15.3553,
        "delta": 0.2163
      },
      {
        "periodo": 202605,
        "valor": 15.0986,
        "delta": -0.2567
      },
      {
        "periodo": 202606,
        "valor": 14.939,
        "delta": -0.1596
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 13.100137,
    "valor_anterior": 13.567816,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 12.311,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 12.5444,
        "delta": 0.2334
      },
      {
        "periodo": 202508,
        "valor": 12.7556,
        "delta": 0.2112
      },
      {
        "periodo": 202509,
        "valor": 12.8971,
        "delta": 0.1415
      },
      {
        "periodo": 202510,
        "valor": 13.2075,
        "delta": 0.3104
      },
      {
        "periodo": 202511,
        "valor": 12.9887,
        "delta": -0.2188
      },
      {
        "periodo": 202512,
        "valor": 12.8319,
        "delta": -0.1567
      },
      {
        "periodo": 202601,
        "valor": 13.0744,
        "delta": 0.2424
      },
      {
        "periodo": 202602,
        "valor": 13.1752,
        "delta": 0.1009
      },
      {
        "periodo": 202603,
        "valor": 13.2985,
        "delta": 0.1232
      },
      {
        "periodo": 202604,
        "valor": 13.4673,
        "delta": 0.1689
      },
      {
        "periodo": 202605,
        "valor": 13.5678,
        "delta": 0.1005
      },
      {
        "periodo": 202606,
        "valor": 13.1001,
        "delta": -0.4677
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 14.699991,
    "valor_anterior": 14.761235,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.2886,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.4662,
        "delta": 0.1776
      },
      {
        "periodo": 202508,
        "valor": 15.5322,
        "delta": 1.066
      },
      {
        "periodo": 202509,
        "valor": 15.8882,
        "delta": 0.356
      },
      {
        "periodo": 202510,
        "valor": 15.9932,
        "delta": 0.105
      },
      {
        "periodo": 202511,
        "valor": 15.6276,
        "delta": -0.3656
      },
      {
        "periodo": 202512,
        "valor": 15.4646,
        "delta": -0.163
      },
      {
        "periodo": 202601,
        "valor": 16.0357,
        "delta": 0.5711
      },
      {
        "periodo": 202602,
        "valor": 16.2682,
        "delta": 0.2325
      },
      {
        "periodo": 202603,
        "valor": 15.988,
        "delta": -0.2802
      },
      {
        "periodo": 202604,
        "valor": 14.662,
        "delta": -1.326
      },
      {
        "periodo": 202605,
        "valor": 14.7612,
        "delta": 0.0993
      },
      {
        "periodo": 202606,
        "valor": 14.7,
        "delta": -0.0612
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 23.191124,
    "valor_anterior": 23.316292,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 23.2439,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 23.4024,
        "delta": 0.1585
      },
      {
        "periodo": 202508,
        "valor": 23.5412,
        "delta": 0.1389
      },
      {
        "periodo": 202509,
        "valor": 23.4555,
        "delta": -0.0857
      },
      {
        "periodo": 202510,
        "valor": 23.3702,
        "delta": -0.0853
      },
      {
        "periodo": 202511,
        "valor": 23.6521,
        "delta": 0.2819
      },
      {
        "periodo": 202512,
        "valor": 23.5562,
        "delta": -0.0959
      },
      {
        "periodo": 202601,
        "valor": 23.4224,
        "delta": -0.1338
      },
      {
        "periodo": 202602,
        "valor": 23.2631,
        "delta": -0.1593
      },
      {
        "periodo": 202603,
        "valor": 23.2486,
        "delta": -0.0145
      },
      {
        "periodo": 202604,
        "valor": 23.2908,
        "delta": 0.0422
      },
      {
        "periodo": 202605,
        "valor": 23.3163,
        "delta": 0.0255
      },
      {
        "periodo": 202606,
        "valor": 23.1911,
        "delta": -0.1252
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 21.069397,
    "valor_anterior": 21.071762,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 16.4915,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 16.5902,
        "delta": 0.0987
      },
      {
        "periodo": 202508,
        "valor": 16.0773,
        "delta": -0.5129
      },
      {
        "periodo": 202509,
        "valor": 16.5396,
        "delta": 0.4623
      },
      {
        "periodo": 202510,
        "valor": 16.6897,
        "delta": 0.1501
      },
      {
        "periodo": 202511,
        "valor": 16.6285,
        "delta": -0.0612
      },
      {
        "periodo": 202512,
        "valor": 17.124,
        "delta": 0.4955
      },
      {
        "periodo": 202601,
        "valor": 16.9711,
        "delta": -0.1529
      },
      {
        "periodo": 202602,
        "valor": 17.0558,
        "delta": 0.0847
      },
      {
        "periodo": 202603,
        "valor": 17.0258,
        "delta": -0.0301
      },
      {
        "periodo": 202604,
        "valor": 17.0114,
        "delta": -0.0144
      },
      {
        "periodo": 202605,
        "valor": 21.0718,
        "delta": 4.0603
      },
      {
        "periodo": 202606,
        "valor": 21.0694,
        "delta": -0.0024
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 20.909345,
    "valor_anterior": 20.5965,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 18.7146,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18.9184,
        "delta": 0.2038
      },
      {
        "periodo": 202508,
        "valor": 18.8622,
        "delta": -0.0561
      },
      {
        "periodo": 202509,
        "valor": 19.2305,
        "delta": 0.3682
      },
      {
        "periodo": 202510,
        "valor": 19.1329,
        "delta": -0.0976
      },
      {
        "periodo": 202511,
        "valor": 19.1866,
        "delta": 0.0538
      },
      {
        "periodo": 202512,
        "valor": 20.4111,
        "delta": 1.2245
      },
      {
        "periodo": 202601,
        "valor": 20.2929,
        "delta": -0.1182
      },
      {
        "periodo": 202602,
        "valor": 20.7624,
        "delta": 0.4695
      },
      {
        "periodo": 202603,
        "valor": 21.0145,
        "delta": 0.2521
      },
      {
        "periodo": 202604,
        "valor": 20.7184,
        "delta": -0.2962
      },
      {
        "periodo": 202605,
        "valor": 20.5965,
        "delta": -0.1219
      },
      {
        "periodo": 202606,
        "valor": 20.9093,
        "delta": 0.3128
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 15.494877,
    "valor_anterior": 15.201122,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.3672,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.5934,
        "delta": 0.2262
      },
      {
        "periodo": 202508,
        "valor": 14.6674,
        "delta": 0.074
      },
      {
        "periodo": 202509,
        "valor": 14.7277,
        "delta": 0.0603
      },
      {
        "periodo": 202510,
        "valor": 15.0266,
        "delta": 0.2988
      },
      {
        "periodo": 202511,
        "valor": 14.5604,
        "delta": -0.4662
      },
      {
        "periodo": 202512,
        "valor": 15.009,
        "delta": 0.4486
      },
      {
        "periodo": 202601,
        "valor": 15.0689,
        "delta": 0.0599
      },
      {
        "periodo": 202602,
        "valor": 15.7342,
        "delta": 0.6653
      },
      {
        "periodo": 202603,
        "valor": 15.0583,
        "delta": -0.6759
      },
      {
        "periodo": 202604,
        "valor": 15.0753,
        "delta": 0.017
      },
      {
        "periodo": 202605,
        "valor": 15.2011,
        "delta": 0.1258
      },
      {
        "periodo": 202606,
        "valor": 15.4949,
        "delta": 0.2938
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 15.664162,
    "valor_anterior": 15.387167,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 16.0789,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 15.9375,
        "delta": -0.1413
      },
      {
        "periodo": 202508,
        "valor": 15.7208,
        "delta": -0.2168
      },
      {
        "periodo": 202509,
        "valor": 15.7612,
        "delta": 0.0405
      },
      {
        "periodo": 202510,
        "valor": 15.9736,
        "delta": 0.2123
      },
      {
        "periodo": 202511,
        "valor": 15.7425,
        "delta": -0.231
      },
      {
        "periodo": 202512,
        "valor": 16.3771,
        "delta": 0.6346
      },
      {
        "periodo": 202601,
        "valor": 15.6547,
        "delta": -0.7224
      },
      {
        "periodo": 202602,
        "valor": 15.4189,
        "delta": -0.2358
      },
      {
        "periodo": 202603,
        "valor": 15.1926,
        "delta": -0.2263
      },
      {
        "periodo": 202604,
        "valor": 15.6139,
        "delta": 0.4214
      },
      {
        "periodo": 202605,
        "valor": 15.3872,
        "delta": -0.2268
      },
      {
        "periodo": 202606,
        "valor": 15.6642,
        "delta": 0.277
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 25.863505,
    "valor_anterior": 24.919502,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 23.6613,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 22.2536,
        "delta": -1.4076
      },
      {
        "periodo": 202508,
        "valor": 21.7681,
        "delta": -0.4855
      },
      {
        "periodo": 202509,
        "valor": 22.6854,
        "delta": 0.9173
      },
      {
        "periodo": 202510,
        "valor": 22.9189,
        "delta": 0.2336
      },
      {
        "periodo": 202511,
        "valor": 21.9901,
        "delta": -0.9289
      },
      {
        "periodo": 202512,
        "valor": 22.7331,
        "delta": 0.743
      },
      {
        "periodo": 202601,
        "valor": 23.3755,
        "delta": 0.6424
      },
      {
        "periodo": 202602,
        "valor": 23.5925,
        "delta": 0.217
      },
      {
        "periodo": 202603,
        "valor": 24.6678,
        "delta": 1.0753
      },
      {
        "periodo": 202604,
        "valor": 24.6442,
        "delta": -0.0236
      },
      {
        "periodo": 202605,
        "valor": 24.9195,
        "delta": 0.2753
      },
      {
        "periodo": 202606,
        "valor": 25.8635,
        "delta": 0.944
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 12.13543,
    "valor_anterior": 11.520457,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 11.2784,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 11.4303,
        "delta": 0.1519
      },
      {
        "periodo": 202508,
        "valor": 11.4337,
        "delta": 0.0034
      },
      {
        "periodo": 202509,
        "valor": 11.3899,
        "delta": -0.0439
      },
      {
        "periodo": 202510,
        "valor": 11.3047,
        "delta": -0.0852
      },
      {
        "periodo": 202511,
        "valor": 11.1095,
        "delta": -0.1951
      },
      {
        "periodo": 202512,
        "valor": 11.2209,
        "delta": 0.1114
      },
      {
        "periodo": 202601,
        "valor": 11.1131,
        "delta": -0.1078
      },
      {
        "periodo": 202602,
        "valor": 11.1534,
        "delta": 0.0403
      },
      {
        "periodo": 202603,
        "valor": 11.5779,
        "delta": 0.4244
      },
      {
        "periodo": 202604,
        "valor": 11.4889,
        "delta": -0.0889
      },
      {
        "periodo": 202605,
        "valor": 11.5205,
        "delta": 0.0315
      },
      {
        "periodo": 202606,
        "valor": 12.1354,
        "delta": 0.615
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 21.085572,
    "valor_anterior": 18.690028,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 21.5119,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 22.024,
        "delta": 0.512
      },
      {
        "periodo": 202508,
        "valor": 21.9623,
        "delta": -0.0616
      },
      {
        "periodo": 202509,
        "valor": 22.1077,
        "delta": 0.1454
      },
      {
        "periodo": 202510,
        "valor": 22.247,
        "delta": 0.1393
      },
      {
        "periodo": 202511,
        "valor": 19.9846,
        "delta": -2.2624
      },
      {
        "periodo": 202512,
        "valor": 19.6605,
        "delta": -0.3241
      },
      {
        "periodo": 202601,
        "valor": 18.8228,
        "delta": -0.8378
      },
      {
        "periodo": 202602,
        "valor": 19.0948,
        "delta": 0.272
      },
      {
        "periodo": 202603,
        "valor": 19.3363,
        "delta": 0.2415
      },
      {
        "periodo": 202604,
        "valor": 18.4304,
        "delta": -0.9058
      },
      {
        "periodo": 202605,
        "valor": 18.69,
        "delta": 0.2596
      },
      {
        "periodo": 202606,
        "valor": 21.0856,
        "delta": 2.3955
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 18.638104,
    "valor_anterior": 18.761041,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17.6096,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18.1661,
        "delta": 0.5565
      },
      {
        "periodo": 202508,
        "valor": 16.9203,
        "delta": -1.2458
      },
      {
        "periodo": 202509,
        "valor": 17.4175,
        "delta": 0.4972
      },
      {
        "periodo": 202510,
        "valor": 17.7904,
        "delta": 0.3729
      },
      {
        "periodo": 202511,
        "valor": 17.9331,
        "delta": 0.1428
      },
      {
        "periodo": 202512,
        "valor": 18.7454,
        "delta": 0.8123
      },
      {
        "periodo": 202601,
        "valor": 19.5977,
        "delta": 0.8523
      },
      {
        "periodo": 202602,
        "valor": 18.7687,
        "delta": -0.829
      },
      {
        "periodo": 202603,
        "valor": 19.0195,
        "delta": 0.2508
      },
      {
        "periodo": 202604,
        "valor": 19.5393,
        "delta": 0.5197
      },
      {
        "periodo": 202605,
        "valor": 18.761,
        "delta": -0.7782
      },
      {
        "periodo": 202606,
        "valor": 18.6381,
        "delta": -0.1229
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 52.143629,
    "valor_anterior": 44.312307,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 50.8791,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 49.8605,
        "delta": -1.0186
      },
      {
        "periodo": 202508,
        "valor": 48.2043,
        "delta": -1.6562
      },
      {
        "periodo": 202509,
        "valor": 51.2141,
        "delta": 3.0098
      },
      {
        "periodo": 202510,
        "valor": 43.8312,
        "delta": -7.3829
      },
      {
        "periodo": 202511,
        "valor": 42.9908,
        "delta": -0.8404
      },
      {
        "periodo": 202512,
        "valor": 47.5614,
        "delta": 4.5706
      },
      {
        "periodo": 202601,
        "valor": 47.6478,
        "delta": 0.0864
      },
      {
        "periodo": 202602,
        "valor": 43.5513,
        "delta": -4.0965
      },
      {
        "periodo": 202603,
        "valor": 43.7652,
        "delta": 0.2139
      },
      {
        "periodo": 202604,
        "valor": 44.4742,
        "delta": 0.709
      },
      {
        "periodo": 202605,
        "valor": 44.3123,
        "delta": -0.1619
      },
      {
        "periodo": 202606,
        "valor": 52.1436,
        "delta": 7.8313
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 46.793728,
    "valor_anterior": 45.011342,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 44.1089,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 45.0871,
        "delta": 0.9782
      },
      {
        "periodo": 202508,
        "valor": 45.4951,
        "delta": 0.408
      },
      {
        "periodo": 202509,
        "valor": 46.311,
        "delta": 0.8159
      },
      {
        "periodo": 202510,
        "valor": 45.2904,
        "delta": -1.0205
      },
      {
        "periodo": 202511,
        "valor": 46.1473,
        "delta": 0.8569
      },
      {
        "periodo": 202512,
        "valor": 49.7429,
        "delta": 3.5956
      },
      {
        "periodo": 202601,
        "valor": 46.5679,
        "delta": -3.175
      },
      {
        "periodo": 202602,
        "valor": 43.2051,
        "delta": -3.3628
      },
      {
        "periodo": 202603,
        "valor": 45.2543,
        "delta": 2.0491
      },
      {
        "periodo": 202604,
        "valor": 44.9503,
        "delta": -0.304
      },
      {
        "periodo": 202605,
        "valor": 45.0113,
        "delta": 0.061
      },
      {
        "periodo": 202606,
        "valor": 46.7937,
        "delta": 1.7824
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 19.397549,
    "valor_anterior": 19.847105,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 18.0699,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17.7701,
        "delta": -0.2998
      },
      {
        "periodo": 202508,
        "valor": 18.1605,
        "delta": 0.3904
      },
      {
        "periodo": 202509,
        "valor": 19.0469,
        "delta": 0.8864
      },
      {
        "periodo": 202510,
        "valor": 19.5345,
        "delta": 0.4876
      },
      {
        "periodo": 202511,
        "valor": 19.5042,
        "delta": -0.0303
      },
      {
        "periodo": 202512,
        "valor": 18.7052,
        "delta": -0.799
      },
      {
        "periodo": 202601,
        "valor": 19.0042,
        "delta": 0.2989
      },
      {
        "periodo": 202602,
        "valor": 19.2235,
        "delta": 0.2193
      },
      {
        "periodo": 202603,
        "valor": 19.6521,
        "delta": 0.4286
      },
      {
        "periodo": 202604,
        "valor": 18.8271,
        "delta": -0.825
      },
      {
        "periodo": 202605,
        "valor": 19.8471,
        "delta": 1.02
      },
      {
        "periodo": 202606,
        "valor": 19.3975,
        "delta": -0.4496
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 15.068186,
    "valor_anterior": 15.245983,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.7415,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.8467,
        "delta": 0.1052
      },
      {
        "periodo": 202508,
        "valor": 14.8769,
        "delta": 0.0303
      },
      {
        "periodo": 202509,
        "valor": 14.6027,
        "delta": -0.2742
      },
      {
        "periodo": 202510,
        "valor": 14.769,
        "delta": 0.1663
      },
      {
        "periodo": 202511,
        "valor": 14.4549,
        "delta": -0.3141
      },
      {
        "periodo": 202512,
        "valor": 14.6409,
        "delta": 0.186
      },
      {
        "periodo": 202601,
        "valor": 14.9559,
        "delta": 0.315
      },
      {
        "periodo": 202602,
        "valor": 14.8954,
        "delta": -0.0604
      },
      {
        "periodo": 202603,
        "valor": 14.5673,
        "delta": -0.3282
      },
      {
        "periodo": 202604,
        "valor": 15.2195,
        "delta": 0.6522
      },
      {
        "periodo": 202605,
        "valor": 15.246,
        "delta": 0.0265
      },
      {
        "periodo": 202606,
        "valor": 15.0682,
        "delta": -0.1778
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 25.75418,
    "valor_anterior": 25.974474,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 21.7005,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 22.2823,
        "delta": 0.5818
      },
      {
        "periodo": 202508,
        "valor": 22.3751,
        "delta": 0.0928
      },
      {
        "periodo": 202509,
        "valor": 23.2695,
        "delta": 0.8944
      },
      {
        "periodo": 202510,
        "valor": 23.0262,
        "delta": -0.2433
      },
      {
        "periodo": 202511,
        "valor": 23.0348,
        "delta": 0.0086
      },
      {
        "periodo": 202512,
        "valor": 25.2767,
        "delta": 2.2418
      },
      {
        "periodo": 202601,
        "valor": 25.0022,
        "delta": -0.2745
      },
      {
        "periodo": 202602,
        "valor": 23.9707,
        "delta": -1.0315
      },
      {
        "periodo": 202603,
        "valor": 24.3777,
        "delta": 0.407
      },
      {
        "periodo": 202604,
        "valor": 24.3772,
        "delta": -0.0004
      },
      {
        "periodo": 202605,
        "valor": 25.9745,
        "delta": 1.5972
      },
      {
        "periodo": 202606,
        "valor": 25.7542,
        "delta": -0.2203
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 228.774898,
    "valor_anterior": 237.684459,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 153.4448,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 150.7438,
        "delta": -2.7009
      },
      {
        "periodo": 202508,
        "valor": 160.7523,
        "delta": 10.0085
      },
      {
        "periodo": 202509,
        "valor": 176.2203,
        "delta": 15.468
      },
      {
        "periodo": 202510,
        "valor": 170.4794,
        "delta": -5.7409
      },
      {
        "periodo": 202511,
        "valor": 184.3382,
        "delta": 13.8588
      },
      {
        "periodo": 202512,
        "valor": 185.6193,
        "delta": 1.2811
      },
      {
        "periodo": 202601,
        "valor": 193.9004,
        "delta": 8.2811
      },
      {
        "periodo": 202602,
        "valor": 195.273,
        "delta": 1.3726
      },
      {
        "periodo": 202603,
        "valor": 206.9506,
        "delta": 11.6776
      },
      {
        "periodo": 202604,
        "valor": 209.8786,
        "delta": 2.9281
      },
      {
        "periodo": 202605,
        "valor": 237.6845,
        "delta": 27.8058
      },
      {
        "periodo": 202606,
        "valor": 228.7749,
        "delta": -8.9096
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 14.210117,
    "valor_anterior": 14.410556,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.1799,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13.8897,
        "delta": -0.2902
      },
      {
        "periodo": 202508,
        "valor": 13.5504,
        "delta": -0.3393
      },
      {
        "periodo": 202509,
        "valor": 14.4243,
        "delta": 0.8739
      },
      {
        "periodo": 202510,
        "valor": 14.6812,
        "delta": 0.2569
      },
      {
        "periodo": 202511,
        "valor": 14.612,
        "delta": -0.0691
      },
      {
        "periodo": 202512,
        "valor": 14.974,
        "delta": 0.362
      },
      {
        "periodo": 202601,
        "valor": 14.5354,
        "delta": -0.4386
      },
      {
        "periodo": 202602,
        "valor": 14.5321,
        "delta": -0.0033
      },
      {
        "periodo": 202603,
        "valor": 15.0489,
        "delta": 0.5168
      },
      {
        "periodo": 202604,
        "valor": 14.8266,
        "delta": -0.2223
      },
      {
        "periodo": 202605,
        "valor": 14.4106,
        "delta": -0.416
      },
      {
        "periodo": 202606,
        "valor": 14.2101,
        "delta": -0.2004
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 13.325515,
    "valor_anterior": 13.148665,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 13.2278,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13.2091,
        "delta": -0.0187
      },
      {
        "periodo": 202508,
        "valor": 12.099,
        "delta": -1.1101
      },
      {
        "periodo": 202509,
        "valor": 13.3286,
        "delta": 1.2296
      },
      {
        "periodo": 202510,
        "valor": 15.3968,
        "delta": 2.0682
      },
      {
        "periodo": 202511,
        "valor": 14.7402,
        "delta": -0.6566
      },
      {
        "periodo": 202512,
        "valor": 12.6525,
        "delta": -2.0877
      },
      {
        "periodo": 202601,
        "valor": 13.5088,
        "delta": 0.8563
      },
      {
        "periodo": 202602,
        "valor": 13.8727,
        "delta": 0.3639
      },
      {
        "periodo": 202603,
        "valor": 13.9856,
        "delta": 0.1129
      },
      {
        "periodo": 202604,
        "valor": 13.9285,
        "delta": -0.0571
      },
      {
        "periodo": 202605,
        "valor": 13.1487,
        "delta": -0.7799
      },
      {
        "periodo": 202606,
        "valor": 13.3255,
        "delta": 0.1768
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 20.502546,
    "valor_anterior": 24.086302,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 23.092,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 24.6519,
        "delta": 1.5599
      },
      {
        "periodo": 202508,
        "valor": 23.0837,
        "delta": -1.5682
      },
      {
        "periodo": 202509,
        "valor": 25.2753,
        "delta": 2.1916
      },
      {
        "periodo": 202510,
        "valor": 25.2278,
        "delta": -0.0475
      },
      {
        "periodo": 202511,
        "valor": 23.0526,
        "delta": -2.1751
      },
      {
        "periodo": 202512,
        "valor": 24.2592,
        "delta": 1.2066
      },
      {
        "periodo": 202601,
        "valor": 22.3905,
        "delta": -1.8686
      },
      {
        "periodo": 202602,
        "valor": 22.8979,
        "delta": 0.5074
      },
      {
        "periodo": 202603,
        "valor": 21.0241,
        "delta": -1.8739
      },
      {
        "periodo": 202604,
        "valor": 20.9998,
        "delta": -0.0242
      },
      {
        "periodo": 202605,
        "valor": 24.0863,
        "delta": 3.0865
      },
      {
        "periodo": 202606,
        "valor": 20.5025,
        "delta": -3.5838
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 32.104463,
    "valor_anterior": 31.914705,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 30.6624,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 29.85,
        "delta": -0.8124
      },
      {
        "periodo": 202508,
        "valor": 30.2581,
        "delta": 0.4081
      },
      {
        "periodo": 202509,
        "valor": 31.7118,
        "delta": 1.4537
      },
      {
        "periodo": 202510,
        "valor": 32.0551,
        "delta": 0.3433
      },
      {
        "periodo": 202511,
        "valor": 29.0481,
        "delta": -3.007
      },
      {
        "periodo": 202512,
        "valor": 29.9514,
        "delta": 0.9032
      },
      {
        "periodo": 202601,
        "valor": 32.0341,
        "delta": 2.0827
      },
      {
        "periodo": 202602,
        "valor": 32.3425,
        "delta": 0.3084
      },
      {
        "periodo": 202603,
        "valor": 32.3261,
        "delta": -0.0164
      },
      {
        "periodo": 202604,
        "valor": 30.5025,
        "delta": -1.8236
      },
      {
        "periodo": 202605,
        "valor": 31.9147,
        "delta": 1.4122
      },
      {
        "periodo": 202606,
        "valor": 32.1045,
        "delta": 0.1898
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 12.402354,
    "valor_anterior": 12.738653,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 13.5348,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13.364,
        "delta": -0.1708
      },
      {
        "periodo": 202508,
        "valor": 13.5662,
        "delta": 0.2022
      },
      {
        "periodo": 202509,
        "valor": 12.8801,
        "delta": -0.686
      },
      {
        "periodo": 202510,
        "valor": 12.7993,
        "delta": -0.0809
      },
      {
        "periodo": 202511,
        "valor": 13.2008,
        "delta": 0.4015
      },
      {
        "periodo": 202512,
        "valor": 12.4722,
        "delta": -0.7286
      },
      {
        "periodo": 202601,
        "valor": 13.0706,
        "delta": 0.5983
      },
      {
        "periodo": 202602,
        "valor": 13.1285,
        "delta": 0.058
      },
      {
        "periodo": 202603,
        "valor": 13.5358,
        "delta": 0.4073
      },
      {
        "periodo": 202604,
        "valor": 12.9677,
        "delta": -0.5681
      },
      {
        "periodo": 202605,
        "valor": 12.7387,
        "delta": -0.229
      },
      {
        "periodo": 202606,
        "valor": 12.4024,
        "delta": -0.3363
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 17.246799,
    "valor_anterior": 17.879806,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 18.2274,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18.1969,
        "delta": -0.0305
      },
      {
        "periodo": 202508,
        "valor": 17.4642,
        "delta": -0.7328
      },
      {
        "periodo": 202509,
        "valor": 18.0614,
        "delta": 0.5972
      },
      {
        "periodo": 202510,
        "valor": 17.8641,
        "delta": -0.1973
      },
      {
        "periodo": 202511,
        "valor": 16.8274,
        "delta": -1.0366
      },
      {
        "periodo": 202512,
        "valor": 16.947,
        "delta": 0.1196
      },
      {
        "periodo": 202601,
        "valor": 16.9738,
        "delta": 0.0268
      },
      {
        "periodo": 202602,
        "valor": 17.2034,
        "delta": 0.2296
      },
      {
        "periodo": 202603,
        "valor": 16.9027,
        "delta": -0.3007
      },
      {
        "periodo": 202604,
        "valor": 17.3069,
        "delta": 0.4042
      },
      {
        "periodo": 202605,
        "valor": 17.8798,
        "delta": 0.5729
      },
      {
        "periodo": 202606,
        "valor": 17.2468,
        "delta": -0.633
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 25.207297,
    "valor_anterior": 24.562347,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17.6158,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 25.792,
        "delta": 8.1762
      },
      {
        "periodo": 202508,
        "valor": 32.938,
        "delta": 7.146
      },
      {
        "periodo": 202509,
        "valor": 53.7846,
        "delta": 20.8466
      },
      {
        "periodo": 202510,
        "valor": 55.8971,
        "delta": 2.1125
      },
      {
        "periodo": 202511,
        "valor": 22.141,
        "delta": -33.7561
      },
      {
        "periodo": 202512,
        "valor": 23.8787,
        "delta": 1.7377
      },
      {
        "periodo": 202601,
        "valor": 24.6876,
        "delta": 0.8089
      },
      {
        "periodo": 202602,
        "valor": 25.7625,
        "delta": 1.0748
      },
      {
        "periodo": 202603,
        "valor": 26.9815,
        "delta": 1.219
      },
      {
        "periodo": 202604,
        "valor": 23.7503,
        "delta": -3.2312
      },
      {
        "periodo": 202605,
        "valor": 24.5623,
        "delta": 0.8121
      },
      {
        "periodo": 202606,
        "valor": 25.2073,
        "delta": 0.645
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 15.643436,
    "valor_anterior": 14.190794,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17.4696,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17.301,
        "delta": -0.1685
      },
      {
        "periodo": 202508,
        "valor": 15.8062,
        "delta": -1.4949
      },
      {
        "periodo": 202509,
        "valor": 15.921,
        "delta": 0.1148
      },
      {
        "periodo": 202510,
        "valor": 15.7094,
        "delta": -0.2116
      },
      {
        "periodo": 202511,
        "valor": 15.0444,
        "delta": -0.665
      },
      {
        "periodo": 202512,
        "valor": 15.0096,
        "delta": -0.0348
      },
      {
        "periodo": 202601,
        "valor": 14.8701,
        "delta": -0.1395
      },
      {
        "periodo": 202602,
        "valor": 15.0497,
        "delta": 0.1796
      },
      {
        "periodo": 202603,
        "valor": 14.5718,
        "delta": -0.4779
      },
      {
        "periodo": 202604,
        "valor": 14.8176,
        "delta": 0.2458
      },
      {
        "periodo": 202605,
        "valor": 14.1908,
        "delta": -0.6268
      },
      {
        "periodo": 202606,
        "valor": 15.6434,
        "delta": 1.4526
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 29.168221,
    "valor_anterior": 22.522398,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 44.7849,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 36.4415,
        "delta": -8.3433
      },
      {
        "periodo": 202508,
        "valor": 46.1991,
        "delta": 9.7576
      },
      {
        "periodo": 202509,
        "valor": 41.5569,
        "delta": -4.6422
      },
      {
        "periodo": 202510,
        "valor": 36.287,
        "delta": -5.27
      },
      {
        "periodo": 202511,
        "valor": 28.9028,
        "delta": -7.3841
      },
      {
        "periodo": 202512,
        "valor": 37.8799,
        "delta": 8.9771
      },
      {
        "periodo": 202601,
        "valor": 33.6047,
        "delta": -4.2752
      },
      {
        "periodo": 202602,
        "valor": 26.0672,
        "delta": -7.5375
      },
      {
        "periodo": 202603,
        "valor": 31.5272,
        "delta": 5.46
      },
      {
        "periodo": 202604,
        "valor": 24.8554,
        "delta": -6.6719
      },
      {
        "periodo": 202605,
        "valor": 22.5224,
        "delta": -2.333
      },
      {
        "periodo": 202606,
        "valor": 29.1682,
        "delta": 6.6458
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 10.308222,
    "valor_anterior": 10.319016,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 10.2222,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 11.8052,
        "delta": 1.5829
      },
      {
        "periodo": 202508,
        "valor": 11.2451,
        "delta": -0.5601
      },
      {
        "periodo": 202509,
        "valor": 11.5605,
        "delta": 0.3155
      },
      {
        "periodo": 202510,
        "valor": 10.5718,
        "delta": -0.9887
      },
      {
        "periodo": 202511,
        "valor": 10.3262,
        "delta": -0.2456
      },
      {
        "periodo": 202512,
        "valor": 14.3532,
        "delta": 4.0269
      },
      {
        "periodo": 202601,
        "valor": 12.359,
        "delta": -1.9942
      },
      {
        "periodo": 202602,
        "valor": 10.493,
        "delta": -1.866
      },
      {
        "periodo": 202603,
        "valor": 11.6068,
        "delta": 1.1138
      },
      {
        "periodo": 202604,
        "valor": 10.4589,
        "delta": -1.1479
      },
      {
        "periodo": 202605,
        "valor": 10.319,
        "delta": -0.1399
      },
      {
        "periodo": 202606,
        "valor": 10.3082,
        "delta": -0.0108
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 14.193716,
    "valor_anterior": 14.129136,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 13.5042,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13.6869,
        "delta": 0.1826
      },
      {
        "periodo": 202508,
        "valor": 13.4358,
        "delta": -0.251
      },
      {
        "periodo": 202509,
        "valor": 13.7367,
        "delta": 0.3009
      },
      {
        "periodo": 202510,
        "valor": 13.5743,
        "delta": -0.1624
      },
      {
        "periodo": 202511,
        "valor": 13.9725,
        "delta": 0.3982
      },
      {
        "periodo": 202512,
        "valor": 13.9702,
        "delta": -0.0023
      },
      {
        "periodo": 202601,
        "valor": 13.8421,
        "delta": -0.1281
      },
      {
        "periodo": 202602,
        "valor": 13.5262,
        "delta": -0.3159
      },
      {
        "periodo": 202603,
        "valor": 13.7558,
        "delta": 0.2296
      },
      {
        "periodo": 202604,
        "valor": 13.7223,
        "delta": -0.0335
      },
      {
        "periodo": 202605,
        "valor": 14.1291,
        "delta": 0.4069
      },
      {
        "periodo": 202606,
        "valor": 14.1937,
        "delta": 0.0646
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 29.88941,
    "valor_anterior": 29.515463,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 27.4702,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 27.5058,
        "delta": 0.0356
      },
      {
        "periodo": 202508,
        "valor": 27.3586,
        "delta": -0.1472
      },
      {
        "periodo": 202509,
        "valor": 28.6201,
        "delta": 1.2615
      },
      {
        "periodo": 202510,
        "valor": 27.9412,
        "delta": -0.6789
      },
      {
        "periodo": 202511,
        "valor": 27.3203,
        "delta": -0.6209
      },
      {
        "periodo": 202512,
        "valor": 27.5016,
        "delta": 0.1814
      },
      {
        "periodo": 202601,
        "valor": 26.8576,
        "delta": -0.644
      },
      {
        "periodo": 202602,
        "valor": 26.6916,
        "delta": -0.166
      },
      {
        "periodo": 202603,
        "valor": 24.9825,
        "delta": -1.7092
      },
      {
        "periodo": 202604,
        "valor": 29.3053,
        "delta": 4.3229
      },
      {
        "periodo": 202605,
        "valor": 29.5155,
        "delta": 0.2101
      },
      {
        "periodo": 202606,
        "valor": 29.8894,
        "delta": 0.3739
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 9.7833,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 10.7645,
        "delta": 0.9811
      },
      {
        "periodo": 202508,
        "valor": 13.2823,
        "delta": 2.5178
      },
      {
        "periodo": 202509,
        "valor": 14.518,
        "delta": 1.2357
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 21.611661,
    "valor_anterior": 22.007027,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 21.3073,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 23.355,
        "delta": 2.0476
      },
      {
        "periodo": 202508,
        "valor": 22.5006,
        "delta": -0.8544
      },
      {
        "periodo": 202509,
        "valor": 21.3157,
        "delta": -1.1849
      },
      {
        "periodo": 202510,
        "valor": 21.1027,
        "delta": -0.213
      },
      {
        "periodo": 202511,
        "valor": 21.1524,
        "delta": 0.0497
      },
      {
        "periodo": 202512,
        "valor": 21.3676,
        "delta": 0.2152
      },
      {
        "periodo": 202601,
        "valor": 20.1246,
        "delta": -1.243
      },
      {
        "periodo": 202602,
        "valor": 21.7327,
        "delta": 1.6081
      },
      {
        "periodo": 202603,
        "valor": 23.1347,
        "delta": 1.402
      },
      {
        "periodo": 202604,
        "valor": 20.5076,
        "delta": -2.6271
      },
      {
        "periodo": 202605,
        "valor": 22.007,
        "delta": 1.4994
      },
      {
        "periodo": 202606,
        "valor": 21.6117,
        "delta": -0.3954
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 12.481132,
    "valor_anterior": 11.460495,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.7472,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.24,
        "delta": -0.5072
      },
      {
        "periodo": 202508,
        "valor": 14.3431,
        "delta": 0.1032
      },
      {
        "periodo": 202509,
        "valor": 13.6669,
        "delta": -0.6762
      },
      {
        "periodo": 202510,
        "valor": 13.5549,
        "delta": -0.112
      },
      {
        "periodo": 202511,
        "valor": 12.8422,
        "delta": -0.7126
      },
      {
        "periodo": 202512,
        "valor": 13.4527,
        "delta": 0.6105
      },
      {
        "periodo": 202601,
        "valor": 12.7541,
        "delta": -0.6986
      },
      {
        "periodo": 202602,
        "valor": 12.7242,
        "delta": -0.03
      },
      {
        "periodo": 202603,
        "valor": 13.3202,
        "delta": 0.5961
      },
      {
        "periodo": 202604,
        "valor": 12.1866,
        "delta": -1.1337
      },
      {
        "periodo": 202605,
        "valor": 11.4605,
        "delta": -0.7261
      },
      {
        "periodo": 202606,
        "valor": 12.4811,
        "delta": 1.0206
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 115.33629,
    "valor_anterior": 106.195597,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 150.8684,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 151.077,
        "delta": 0.2086
      },
      {
        "periodo": 202508,
        "valor": 134.4491,
        "delta": -16.6279
      },
      {
        "periodo": 202509,
        "valor": 146.2207,
        "delta": 11.7716
      },
      {
        "periodo": 202510,
        "valor": 138.2654,
        "delta": -7.9553
      },
      {
        "periodo": 202511,
        "valor": 132.2233,
        "delta": -6.0421
      },
      {
        "periodo": 202512,
        "valor": 134.8015,
        "delta": 2.5782
      },
      {
        "periodo": 202601,
        "valor": 122.3967,
        "delta": -12.4048
      },
      {
        "periodo": 202602,
        "valor": 122.5034,
        "delta": 0.1067
      },
      {
        "periodo": 202603,
        "valor": 120.8328,
        "delta": -1.6707
      },
      {
        "periodo": 202604,
        "valor": 118.4693,
        "delta": -2.3635
      },
      {
        "periodo": 202605,
        "valor": 106.1956,
        "delta": -12.2737
      },
      {
        "periodo": 202606,
        "valor": 115.3363,
        "delta": 9.1407
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 73.825355,
    "valor_anterior": 74.263084,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 95.5907,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 91.0426,
        "delta": -4.5481
      },
      {
        "periodo": 202508,
        "valor": 85.5332,
        "delta": -5.5094
      },
      {
        "periodo": 202509,
        "valor": 81.9308,
        "delta": -3.6024
      },
      {
        "periodo": 202510,
        "valor": 76.6862,
        "delta": -5.2446
      },
      {
        "periodo": 202511,
        "valor": 73.9434,
        "delta": -2.7428
      },
      {
        "periodo": 202512,
        "valor": 76.9739,
        "delta": 3.0305
      },
      {
        "periodo": 202601,
        "valor": 75.5844,
        "delta": -1.3895
      },
      {
        "periodo": 202602,
        "valor": 76.1741,
        "delta": 0.5897
      },
      {
        "periodo": 202603,
        "valor": 74.1142,
        "delta": -2.0599
      },
      {
        "periodo": 202604,
        "valor": 74.4632,
        "delta": 0.349
      },
      {
        "periodo": 202605,
        "valor": 74.2631,
        "delta": -0.2001
      },
      {
        "periodo": 202606,
        "valor": 73.8254,
        "delta": -0.4377
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 12.342582,
    "valor_anterior": 12.452217,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 12.9993,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13.071,
        "delta": 0.0717
      },
      {
        "periodo": 202508,
        "valor": 12.7884,
        "delta": -0.2827
      },
      {
        "periodo": 202509,
        "valor": 12.9405,
        "delta": 0.1522
      },
      {
        "periodo": 202510,
        "valor": 12.9385,
        "delta": -0.002
      },
      {
        "periodo": 202511,
        "valor": 12.9724,
        "delta": 0.0339
      },
      {
        "periodo": 202512,
        "valor": 12.6378,
        "delta": -0.3346
      },
      {
        "periodo": 202601,
        "valor": 12.6268,
        "delta": -0.011
      },
      {
        "periodo": 202602,
        "valor": 12.7172,
        "delta": 0.0904
      },
      {
        "periodo": 202603,
        "valor": 12.5605,
        "delta": -0.1567
      },
      {
        "periodo": 202604,
        "valor": 12.4951,
        "delta": -0.0654
      },
      {
        "periodo": 202605,
        "valor": 12.4522,
        "delta": -0.0429
      },
      {
        "periodo": 202606,
        "valor": 12.3426,
        "delta": -0.1096
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 26.948384,
    "valor_anterior": 26.340513,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 23.1403,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 23.4783,
        "delta": 0.3379
      },
      {
        "periodo": 202508,
        "valor": 24.8013,
        "delta": 1.323
      },
      {
        "periodo": 202509,
        "valor": 23.8939,
        "delta": -0.9074
      },
      {
        "periodo": 202510,
        "valor": 24.0389,
        "delta": 0.1451
      },
      {
        "periodo": 202511,
        "valor": 24.0185,
        "delta": -0.0205
      },
      {
        "periodo": 202512,
        "valor": 24.8452,
        "delta": 0.8267
      },
      {
        "periodo": 202601,
        "valor": 27.2741,
        "delta": 2.4289
      },
      {
        "periodo": 202602,
        "valor": 26.2459,
        "delta": -1.0282
      },
      {
        "periodo": 202603,
        "valor": 25.6857,
        "delta": -0.5603
      },
      {
        "periodo": 202604,
        "valor": 25.3535,
        "delta": -0.3321
      },
      {
        "periodo": 202605,
        "valor": 26.3405,
        "delta": 0.987
      },
      {
        "periodo": 202606,
        "valor": 26.9484,
        "delta": 0.6079
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 10.972028,
    "valor_anterior": 10.97554,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 10.959,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 11.1368,
        "delta": 0.1779
      },
      {
        "periodo": 202508,
        "valor": 10.7274,
        "delta": -0.4095
      },
      {
        "periodo": 202509,
        "valor": 10.9112,
        "delta": 0.1838
      },
      {
        "periodo": 202510,
        "valor": 10.8366,
        "delta": -0.0746
      },
      {
        "periodo": 202511,
        "valor": 10.8344,
        "delta": -0.0022
      },
      {
        "periodo": 202512,
        "valor": 11.1219,
        "delta": 0.2875
      },
      {
        "periodo": 202601,
        "valor": 10.8727,
        "delta": -0.2492
      },
      {
        "periodo": 202602,
        "valor": 11.0661,
        "delta": 0.1934
      },
      {
        "periodo": 202603,
        "valor": 10.9499,
        "delta": -0.1161
      },
      {
        "periodo": 202604,
        "valor": 10.9287,
        "delta": -0.0212
      },
      {
        "periodo": 202605,
        "valor": 10.9755,
        "delta": 0.0468
      },
      {
        "periodo": 202606,
        "valor": 10.972,
        "delta": -0.0035
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 14.496003,
    "valor_anterior": 13.327347,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 13.1196,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13.3375,
        "delta": 0.2178
      },
      {
        "periodo": 202508,
        "valor": 13.1891,
        "delta": -0.1483
      },
      {
        "periodo": 202509,
        "valor": 13.3074,
        "delta": 0.1183
      },
      {
        "periodo": 202510,
        "valor": 13.1392,
        "delta": -0.1682
      },
      {
        "periodo": 202511,
        "valor": 13.2826,
        "delta": 0.1434
      },
      {
        "periodo": 202512,
        "valor": 13.3065,
        "delta": 0.024
      },
      {
        "periodo": 202601,
        "valor": 13.1193,
        "delta": -0.1872
      },
      {
        "periodo": 202602,
        "valor": 13.0093,
        "delta": -0.11
      },
      {
        "periodo": 202603,
        "valor": 13.1732,
        "delta": 0.1639
      },
      {
        "periodo": 202604,
        "valor": 13.1441,
        "delta": -0.0291
      },
      {
        "periodo": 202605,
        "valor": 13.3273,
        "delta": 0.1832
      },
      {
        "periodo": 202606,
        "valor": 14.496,
        "delta": 1.1687
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 25.40352,
    "valor_anterior": 27.795902,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 24.6902,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 25.4977,
        "delta": 0.8075
      },
      {
        "periodo": 202508,
        "valor": 24.9552,
        "delta": -0.5425
      },
      {
        "periodo": 202509,
        "valor": 24.6484,
        "delta": -0.3068
      },
      {
        "periodo": 202510,
        "valor": 23.4947,
        "delta": -1.1537
      },
      {
        "periodo": 202511,
        "valor": 24.3776,
        "delta": 0.8829
      },
      {
        "periodo": 202512,
        "valor": 23.7213,
        "delta": -0.6562
      },
      {
        "periodo": 202601,
        "valor": 24.3456,
        "delta": 0.6243
      },
      {
        "periodo": 202602,
        "valor": 24.3974,
        "delta": 0.0518
      },
      {
        "periodo": 202603,
        "valor": 26.0152,
        "delta": 1.6178
      },
      {
        "periodo": 202604,
        "valor": 26.7034,
        "delta": 0.6882
      },
      {
        "periodo": 202605,
        "valor": 27.7959,
        "delta": 1.0925
      },
      {
        "periodo": 202606,
        "valor": 25.4035,
        "delta": -2.3924
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 14.497175,
    "valor_anterior": 14.254349,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.5945,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.5426,
        "delta": -0.0519
      },
      {
        "periodo": 202508,
        "valor": 14.7506,
        "delta": 0.208
      },
      {
        "periodo": 202509,
        "valor": 14.7005,
        "delta": -0.0501
      },
      {
        "periodo": 202510,
        "valor": 14.3667,
        "delta": -0.3338
      },
      {
        "periodo": 202511,
        "valor": 14.268,
        "delta": -0.0988
      },
      {
        "periodo": 202512,
        "valor": 14.4947,
        "delta": 0.2268
      },
      {
        "periodo": 202601,
        "valor": 14.3998,
        "delta": -0.0949
      },
      {
        "periodo": 202602,
        "valor": 14.4095,
        "delta": 0.0098
      },
      {
        "periodo": 202603,
        "valor": 14.3944,
        "delta": -0.0151
      },
      {
        "periodo": 202604,
        "valor": 14.2624,
        "delta": -0.1321
      },
      {
        "periodo": 202605,
        "valor": 14.2543,
        "delta": -0.008
      },
      {
        "periodo": 202606,
        "valor": 14.4972,
        "delta": 0.2428
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 39.252642,
    "valor_anterior": 42.519533,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 40.1226,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 35.3222,
        "delta": -4.8004
      },
      {
        "periodo": 202508,
        "valor": 35.5693,
        "delta": 0.2471
      },
      {
        "periodo": 202509,
        "valor": 37.3707,
        "delta": 1.8014
      },
      {
        "periodo": 202510,
        "valor": 37.7051,
        "delta": 0.3344
      },
      {
        "periodo": 202511,
        "valor": 38.0986,
        "delta": 0.3936
      },
      {
        "periodo": 202512,
        "valor": 39.5485,
        "delta": 1.4499
      },
      {
        "periodo": 202601,
        "valor": 39.6602,
        "delta": 0.1117
      },
      {
        "periodo": 202602,
        "valor": 40.7559,
        "delta": 1.0956
      },
      {
        "periodo": 202603,
        "valor": 41.799,
        "delta": 1.0432
      },
      {
        "periodo": 202604,
        "valor": 40.018,
        "delta": -1.781
      },
      {
        "periodo": 202605,
        "valor": 42.5195,
        "delta": 2.5015
      },
      {
        "periodo": 202606,
        "valor": 39.2526,
        "delta": -3.2669
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 77.662476,
    "valor_anterior": 77.914641,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 100.1696,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 92.4583,
        "delta": -7.7113
      },
      {
        "periodo": 202508,
        "valor": 91.8433,
        "delta": -0.6149
      },
      {
        "periodo": 202509,
        "valor": 94.165,
        "delta": 2.3217
      },
      {
        "periodo": 202510,
        "valor": 92.41,
        "delta": -1.755
      },
      {
        "periodo": 202511,
        "valor": 117.1074,
        "delta": 24.6974
      },
      {
        "periodo": 202512,
        "valor": 98.1728,
        "delta": -18.9346
      },
      {
        "periodo": 202601,
        "valor": 99.0308,
        "delta": 0.858
      },
      {
        "periodo": 202602,
        "valor": 88.816,
        "delta": -10.2148
      },
      {
        "periodo": 202603,
        "valor": 86.1066,
        "delta": -2.7094
      },
      {
        "periodo": 202604,
        "valor": 84.4744,
        "delta": -1.6322
      },
      {
        "periodo": 202605,
        "valor": 77.9146,
        "delta": -6.5597
      },
      {
        "periodo": 202606,
        "valor": 77.6625,
        "delta": -0.2522
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 37.285634,
    "valor_anterior": 42.094391,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 44.3286,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 45.3285,
        "delta": 0.9999
      },
      {
        "periodo": 202508,
        "valor": 45.2865,
        "delta": -0.042
      },
      {
        "periodo": 202509,
        "valor": 47.0522,
        "delta": 1.7657
      },
      {
        "periodo": 202510,
        "valor": 45.1121,
        "delta": -1.9401
      },
      {
        "periodo": 202511,
        "valor": 45.9127,
        "delta": 0.8006
      },
      {
        "periodo": 202512,
        "valor": 46.7138,
        "delta": 0.801
      },
      {
        "periodo": 202601,
        "valor": 44.1823,
        "delta": -2.5314
      },
      {
        "periodo": 202602,
        "valor": 46.7154,
        "delta": 2.533
      },
      {
        "periodo": 202603,
        "valor": 46.7028,
        "delta": -0.0125
      },
      {
        "periodo": 202604,
        "valor": 43.9485,
        "delta": -2.7543
      },
      {
        "periodo": 202605,
        "valor": 42.0944,
        "delta": -1.8541
      },
      {
        "periodo": 202606,
        "valor": 37.2856,
        "delta": -4.8088
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 180.722184,
    "valor_anterior": 177.311815,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 186.3145,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 181.6656,
        "delta": -4.6489
      },
      {
        "periodo": 202508,
        "valor": 175.3321,
        "delta": -6.3335
      },
      {
        "periodo": 202509,
        "valor": 177.7638,
        "delta": 2.4317
      },
      {
        "periodo": 202510,
        "valor": 188.0415,
        "delta": 10.2777
      },
      {
        "periodo": 202511,
        "valor": 189.1332,
        "delta": 1.0917
      },
      {
        "periodo": 202512,
        "valor": 181.9149,
        "delta": -7.2184
      },
      {
        "periodo": 202601,
        "valor": 190.0711,
        "delta": 8.1562
      },
      {
        "periodo": 202602,
        "valor": 198.1733,
        "delta": 8.1022
      },
      {
        "periodo": 202603,
        "valor": 137.7821,
        "delta": -60.3912
      },
      {
        "periodo": 202604,
        "valor": 198.4457,
        "delta": 60.6637
      },
      {
        "periodo": 202605,
        "valor": 177.3118,
        "delta": -21.1339
      },
      {
        "periodo": 202606,
        "valor": 180.7222,
        "delta": 3.4104
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 43.016542,
    "valor_anterior": 45.110123,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 41.9366,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 41.0094,
        "delta": -0.9272
      },
      {
        "periodo": 202508,
        "valor": 44.7076,
        "delta": 3.6982
      },
      {
        "periodo": 202509,
        "valor": 44.7598,
        "delta": 0.0522
      },
      {
        "periodo": 202510,
        "valor": 43.7815,
        "delta": -0.9783
      },
      {
        "periodo": 202511,
        "valor": 42.6855,
        "delta": -1.096
      },
      {
        "periodo": 202512,
        "valor": 43.7264,
        "delta": 1.041
      },
      {
        "periodo": 202601,
        "valor": 45.2539,
        "delta": 1.5274
      },
      {
        "periodo": 202602,
        "valor": 44.4004,
        "delta": -0.8535
      },
      {
        "periodo": 202603,
        "valor": 43.2581,
        "delta": -1.1422
      },
      {
        "periodo": 202604,
        "valor": 42.8861,
        "delta": -0.372
      },
      {
        "periodo": 202605,
        "valor": 45.1101,
        "delta": 2.224
      },
      {
        "periodo": 202606,
        "valor": 43.0165,
        "delta": -2.0936
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 66.919122,
    "valor_anterior": 62.143617,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 62.363,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 65.5945,
        "delta": 3.2315
      },
      {
        "periodo": 202508,
        "valor": 73.6443,
        "delta": 8.0499
      },
      {
        "periodo": 202509,
        "valor": 69.454,
        "delta": -4.1903
      },
      {
        "periodo": 202510,
        "valor": 75.1448,
        "delta": 5.6908
      },
      {
        "periodo": 202511,
        "valor": 64.8629,
        "delta": -10.2819
      },
      {
        "periodo": 202512,
        "valor": 64.0557,
        "delta": -0.8073
      },
      {
        "periodo": 202601,
        "valor": 81.3131,
        "delta": 17.2574
      },
      {
        "periodo": 202602,
        "valor": 67.4916,
        "delta": -13.8214
      },
      {
        "periodo": 202603,
        "valor": 68.8513,
        "delta": 1.3597
      },
      {
        "periodo": 202604,
        "valor": 56.0489,
        "delta": -12.8024
      },
      {
        "periodo": 202605,
        "valor": 62.1436,
        "delta": 6.0947
      },
      {
        "periodo": 202606,
        "valor": 66.9191,
        "delta": 4.7755
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 271.508727,
    "valor_anterior": 272.508451,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 277.5415,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 259.1889,
        "delta": -18.3526
      },
      {
        "periodo": 202508,
        "valor": 235.9528,
        "delta": -23.2361
      },
      {
        "periodo": 202509,
        "valor": 252.858,
        "delta": 16.9052
      },
      {
        "periodo": 202510,
        "valor": 259.7231,
        "delta": 6.8651
      },
      {
        "periodo": 202511,
        "valor": 283.3879,
        "delta": 23.6649
      },
      {
        "periodo": 202512,
        "valor": 282.2096,
        "delta": -1.1783
      },
      {
        "periodo": 202601,
        "valor": 273.6223,
        "delta": -8.5874
      },
      {
        "periodo": 202602,
        "valor": 257.0268,
        "delta": -16.5955
      },
      {
        "periodo": 202603,
        "valor": 259.9473,
        "delta": 2.9205
      },
      {
        "periodo": 202604,
        "valor": 266.4028,
        "delta": 6.4555
      },
      {
        "periodo": 202605,
        "valor": 272.5085,
        "delta": 6.1056
      },
      {
        "periodo": 202606,
        "valor": 271.5087,
        "delta": -0.9997
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 14.212221,
    "valor_anterior": 13.965013,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 462.2699,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 448.1859,
        "delta": -14.084
      },
      {
        "periodo": 202508,
        "valor": 436.8538,
        "delta": -11.3321
      },
      {
        "periodo": 202509,
        "valor": 445.6019,
        "delta": 8.7481
      },
      {
        "periodo": 202510,
        "valor": 438.3887,
        "delta": -7.2132
      },
      {
        "periodo": 202511,
        "valor": 438.5138,
        "delta": 0.1251
      },
      {
        "periodo": 202512,
        "valor": 446.1839,
        "delta": 7.6702
      },
      {
        "periodo": 202601,
        "valor": 503.5945,
        "delta": 57.4106
      },
      {
        "periodo": 202602,
        "valor": 17.2959,
        "delta": -486.2987
      },
      {
        "periodo": 202603,
        "valor": 14.7688,
        "delta": -2.5271
      },
      {
        "periodo": 202604,
        "valor": 13.8709,
        "delta": -0.8979
      },
      {
        "periodo": 202605,
        "valor": 13.965,
        "delta": 0.0941
      },
      {
        "periodo": 202606,
        "valor": 14.2122,
        "delta": 0.2472
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 47.927958,
    "valor_anterior": 24.90719,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 209.6044,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 155.4786,
        "delta": -54.1258
      },
      {
        "periodo": 202508,
        "valor": 102.481,
        "delta": -52.9977
      },
      {
        "periodo": 202509,
        "valor": 74.6565,
        "delta": -27.8245
      },
      {
        "periodo": 202510,
        "valor": 49.6888,
        "delta": -24.9677
      },
      {
        "periodo": 202511,
        "valor": 34.9345,
        "delta": -14.7542
      },
      {
        "periodo": 202512,
        "valor": 41.0296,
        "delta": 6.0951
      },
      {
        "periodo": 202601,
        "valor": 58.0884,
        "delta": 17.0588
      },
      {
        "periodo": 202602,
        "valor": 46.9142,
        "delta": -11.1742
      },
      {
        "periodo": 202603,
        "valor": 29.2281,
        "delta": -17.686
      },
      {
        "periodo": 202604,
        "valor": 29.689,
        "delta": 0.4608
      },
      {
        "periodo": 202605,
        "valor": 24.9072,
        "delta": -4.7818
      },
      {
        "periodo": 202606,
        "valor": 47.928,
        "delta": 23.0208
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 146.418598,
    "valor_anterior": 162.072283,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 447.1,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 251.6406,
        "delta": -195.4595
      },
      {
        "periodo": 202601,
        "valor": 179.1417,
        "delta": -72.4988
      },
      {
        "periodo": 202602,
        "valor": 140.4063,
        "delta": -38.7355
      },
      {
        "periodo": 202603,
        "valor": 141.5845,
        "delta": 1.1783
      },
      {
        "periodo": 202604,
        "valor": 166.0869,
        "delta": 24.5024
      },
      {
        "periodo": 202605,
        "valor": 162.0723,
        "delta": -4.0146
      },
      {
        "periodo": 202606,
        "valor": 146.4186,
        "delta": -15.6537
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 24.068547,
    "valor_anterior": 18.305359,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 20.6747,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 19.559,
        "delta": -1.1157
      },
      {
        "periodo": 202605,
        "valor": 18.3054,
        "delta": -1.2536
      },
      {
        "periodo": 202606,
        "valor": 24.0685,
        "delta": 5.7632
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 18.50847,
    "valor_anterior": 18.391079,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17.9131,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18.1448,
        "delta": 0.2317
      },
      {
        "periodo": 202508,
        "valor": 18.2732,
        "delta": 0.1284
      },
      {
        "periodo": 202509,
        "valor": 18.3759,
        "delta": 0.1027
      },
      {
        "periodo": 202510,
        "valor": 18.4839,
        "delta": 0.1081
      },
      {
        "periodo": 202511,
        "valor": 18.1332,
        "delta": -0.3508
      },
      {
        "periodo": 202512,
        "valor": 18.1625,
        "delta": 0.0293
      },
      {
        "periodo": 202601,
        "valor": 18.2249,
        "delta": 0.0624
      },
      {
        "periodo": 202602,
        "valor": 18.4109,
        "delta": 0.186
      },
      {
        "periodo": 202603,
        "valor": 18.3877,
        "delta": -0.0232
      },
      {
        "periodo": 202604,
        "valor": 18.2552,
        "delta": -0.1325
      },
      {
        "periodo": 202605,
        "valor": 18.3911,
        "delta": 0.1359
      },
      {
        "periodo": 202606,
        "valor": 18.5085,
        "delta": 0.1174
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 18.071212,
    "valor_anterior": 17.982617,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17.6095,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17.8301,
        "delta": 0.2206
      },
      {
        "periodo": 202508,
        "valor": 17.9949,
        "delta": 0.1648
      },
      {
        "periodo": 202509,
        "valor": 17.9532,
        "delta": -0.0417
      },
      {
        "periodo": 202510,
        "valor": 18.0808,
        "delta": 0.1276
      },
      {
        "periodo": 202511,
        "valor": 17.7787,
        "delta": -0.3021
      },
      {
        "periodo": 202512,
        "valor": 17.6305,
        "delta": -0.1482
      },
      {
        "periodo": 202601,
        "valor": 17.7152,
        "delta": 0.0847
      },
      {
        "periodo": 202602,
        "valor": 18.0357,
        "delta": 0.3205
      },
      {
        "periodo": 202603,
        "valor": 17.9803,
        "delta": -0.0554
      },
      {
        "periodo": 202604,
        "valor": 17.8943,
        "delta": -0.086
      },
      {
        "periodo": 202605,
        "valor": 17.9826,
        "delta": 0.0884
      },
      {
        "periodo": 202606,
        "valor": 18.0712,
        "delta": 0.0886
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 20.462821,
    "valor_anterior": 20.864559,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 16.7041,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18.6919,
        "delta": 1.9878
      },
      {
        "periodo": 202508,
        "valor": 20.8357,
        "delta": 2.1437
      },
      {
        "periodo": 202509,
        "valor": 22.6947,
        "delta": 1.859
      },
      {
        "periodo": 202510,
        "valor": 24.6638,
        "delta": 1.9691
      },
      {
        "periodo": 202511,
        "valor": 20.2447,
        "delta": -4.4191
      },
      {
        "periodo": 202512,
        "valor": 19.958,
        "delta": -0.2866
      },
      {
        "periodo": 202601,
        "valor": 19.8963,
        "delta": -0.0617
      },
      {
        "periodo": 202602,
        "valor": 20.5357,
        "delta": 0.6394
      },
      {
        "periodo": 202603,
        "valor": 21.2613,
        "delta": 0.7256
      },
      {
        "periodo": 202604,
        "valor": 19.7453,
        "delta": -1.516
      },
      {
        "periodo": 202605,
        "valor": 20.8646,
        "delta": 1.1193
      },
      {
        "periodo": 202606,
        "valor": 20.4628,
        "delta": -0.4017
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 25.782412,
    "valor_anterior": 25.700136,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 23.5341,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 24.1141,
        "delta": 0.58
      },
      {
        "periodo": 202508,
        "valor": 23.79,
        "delta": -0.3241
      },
      {
        "periodo": 202509,
        "valor": 24.5278,
        "delta": 0.7378
      },
      {
        "periodo": 202510,
        "valor": 24.3687,
        "delta": -0.1591
      },
      {
        "periodo": 202511,
        "valor": 24.2334,
        "delta": -0.1353
      },
      {
        "periodo": 202512,
        "valor": 26.0201,
        "delta": 1.7867
      },
      {
        "periodo": 202601,
        "valor": 25.6848,
        "delta": -0.3353
      },
      {
        "periodo": 202602,
        "valor": 24.7053,
        "delta": -0.9795
      },
      {
        "periodo": 202603,
        "valor": 25.016,
        "delta": 0.3107
      },
      {
        "periodo": 202604,
        "valor": 25.066,
        "delta": 0.05
      },
      {
        "periodo": 202605,
        "valor": 25.7001,
        "delta": 0.6342
      },
      {
        "periodo": 202606,
        "valor": 25.7824,
        "delta": 0.0823
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 15.458306,
    "valor_anterior": 15.443953,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.5749,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.688,
        "delta": 0.1131
      },
      {
        "periodo": 202508,
        "valor": 15.0786,
        "delta": 0.3906
      },
      {
        "periodo": 202509,
        "valor": 15.1748,
        "delta": 0.0963
      },
      {
        "periodo": 202510,
        "valor": 15.25,
        "delta": 0.0751
      },
      {
        "periodo": 202511,
        "valor": 15.0206,
        "delta": -0.2294
      },
      {
        "periodo": 202512,
        "valor": 15.086,
        "delta": 0.0654
      },
      {
        "periodo": 202601,
        "valor": 15.3523,
        "delta": 0.2663
      },
      {
        "periodo": 202602,
        "valor": 15.5927,
        "delta": 0.2403
      },
      {
        "periodo": 202603,
        "valor": 15.3675,
        "delta": -0.2251
      },
      {
        "periodo": 202604,
        "valor": 14.8639,
        "delta": -0.5037
      },
      {
        "periodo": 202605,
        "valor": 15.444,
        "delta": 0.5801
      },
      {
        "periodo": 202606,
        "valor": 15.4583,
        "delta": 0.0144
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 19.028028,
    "valor_anterior": 18.995589,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 20.7788,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 20.3654,
        "delta": -0.4133
      },
      {
        "periodo": 202508,
        "valor": 19.9223,
        "delta": -0.4432
      },
      {
        "periodo": 202509,
        "valor": 19.8185,
        "delta": -0.1038
      },
      {
        "periodo": 202510,
        "valor": 19.8559,
        "delta": 0.0374
      },
      {
        "periodo": 202511,
        "valor": 19.3685,
        "delta": -0.4874
      },
      {
        "periodo": 202512,
        "valor": 19.143,
        "delta": -0.2255
      },
      {
        "periodo": 202601,
        "valor": 19.1883,
        "delta": 0.0453
      },
      {
        "periodo": 202602,
        "valor": 19.2518,
        "delta": 0.0634
      },
      {
        "periodo": 202603,
        "valor": 19.384,
        "delta": 0.1323
      },
      {
        "periodo": 202604,
        "valor": 19.1104,
        "delta": -0.2737
      },
      {
        "periodo": 202605,
        "valor": 18.9956,
        "delta": -0.1148
      },
      {
        "periodo": 202606,
        "valor": 19.028,
        "delta": 0.0324
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 4021754,
    "label": "CCB Jun 2026",
    "valor_actual": 17.696202,
    "valor_anterior": 16.967388,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17.7955,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17.4822,
        "delta": -0.3133
      },
      {
        "periodo": 202508,
        "valor": 16.8279,
        "delta": -0.6543
      },
      {
        "periodo": 202509,
        "valor": 17.5141,
        "delta": 0.6862
      },
      {
        "periodo": 202510,
        "valor": 17.5532,
        "delta": 0.0391
      },
      {
        "periodo": 202511,
        "valor": 17.2235,
        "delta": -0.3298
      },
      {
        "periodo": 202512,
        "valor": 17.601,
        "delta": 0.3776
      },
      {
        "periodo": 202601,
        "valor": 17.5669,
        "delta": -0.0342
      },
      {
        "periodo": 202602,
        "valor": 17.3059,
        "delta": -0.2609
      },
      {
        "periodo": 202603,
        "valor": 17.4191,
        "delta": 0.1132
      },
      {
        "periodo": 202604,
        "valor": 17.3291,
        "delta": -0.09
      },
      {
        "periodo": 202605,
        "valor": 16.9674,
        "delta": -0.3617
      },
      {
        "periodo": 202606,
        "valor": 17.6962,
        "delta": 0.7288
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 18.783651,
    "valor_anterior": 18.893631,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17.878,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17.8673,
        "delta": -0.0107
      },
      {
        "periodo": 202508,
        "valor": 17.9585,
        "delta": 0.0911
      },
      {
        "periodo": 202509,
        "valor": 17.5811,
        "delta": -0.3774
      },
      {
        "periodo": 202510,
        "valor": 17.6462,
        "delta": 0.0651
      },
      {
        "periodo": 202511,
        "valor": 17.6739,
        "delta": 0.0277
      },
      {
        "periodo": 202512,
        "valor": 17.7112,
        "delta": 0.0372
      },
      {
        "periodo": 202601,
        "valor": 18.3359,
        "delta": 0.6248
      },
      {
        "periodo": 202602,
        "valor": 18.711,
        "delta": 0.3751
      },
      {
        "periodo": 202603,
        "valor": 19.0576,
        "delta": 0.3466
      },
      {
        "periodo": 202604,
        "valor": 18.0682,
        "delta": -0.9894
      },
      {
        "periodo": 202605,
        "valor": 18.8936,
        "delta": 0.8255
      },
      {
        "periodo": 202606,
        "valor": 18.7837,
        "delta": -0.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 16.154005,
    "valor_anterior": 16.899931,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 16.1649,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 16.131,
        "delta": -0.0339
      },
      {
        "periodo": 202508,
        "valor": 16.62,
        "delta": 0.489
      },
      {
        "periodo": 202509,
        "valor": 16.2504,
        "delta": -0.3696
      },
      {
        "periodo": 202510,
        "valor": 16.3503,
        "delta": 0.0999
      },
      {
        "periodo": 202511,
        "valor": 16.5098,
        "delta": 0.1596
      },
      {
        "periodo": 202512,
        "valor": 16.4808,
        "delta": -0.029
      },
      {
        "periodo": 202601,
        "valor": 16.6794,
        "delta": 0.1986
      },
      {
        "periodo": 202602,
        "valor": 17.152,
        "delta": 0.4727
      },
      {
        "periodo": 202603,
        "valor": 16.4967,
        "delta": -0.6554
      },
      {
        "periodo": 202604,
        "valor": 16.8783,
        "delta": 0.3817
      },
      {
        "periodo": 202605,
        "valor": 16.8999,
        "delta": 0.0216
      },
      {
        "periodo": 202606,
        "valor": 16.154,
        "delta": -0.7459
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 13.645362,
    "valor_anterior": 13.868196,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 12.585,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13.1548,
        "delta": 0.5698
      },
      {
        "periodo": 202508,
        "valor": 13.0368,
        "delta": -0.118
      },
      {
        "periodo": 202509,
        "valor": 13.4682,
        "delta": 0.4314
      },
      {
        "periodo": 202510,
        "valor": 13.6965,
        "delta": 0.2284
      },
      {
        "periodo": 202511,
        "valor": 13.6443,
        "delta": -0.0523
      },
      {
        "periodo": 202512,
        "valor": 12.4597,
        "delta": -1.1845
      },
      {
        "periodo": 202601,
        "valor": 13.0467,
        "delta": 0.587
      },
      {
        "periodo": 202602,
        "valor": 13.358,
        "delta": 0.3113
      },
      {
        "periodo": 202603,
        "valor": 13.8266,
        "delta": 0.4686
      },
      {
        "periodo": 202604,
        "valor": 14.0859,
        "delta": 0.2592
      },
      {
        "periodo": 202605,
        "valor": 13.8682,
        "delta": -0.2177
      },
      {
        "periodo": 202606,
        "valor": 13.6454,
        "delta": -0.2228
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 13.100137,
    "valor_anterior": 13.567816,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 12.311,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 12.5444,
        "delta": 0.2334
      },
      {
        "periodo": 202508,
        "valor": 12.7556,
        "delta": 0.2112
      },
      {
        "periodo": 202509,
        "valor": 12.8971,
        "delta": 0.1415
      },
      {
        "periodo": 202510,
        "valor": 13.2075,
        "delta": 0.3104
      },
      {
        "periodo": 202511,
        "valor": 12.9887,
        "delta": -0.2188
      },
      {
        "periodo": 202512,
        "valor": 12.8319,
        "delta": -0.1567
      },
      {
        "periodo": 202601,
        "valor": 13.0744,
        "delta": 0.2424
      },
      {
        "periodo": 202602,
        "valor": 13.1752,
        "delta": 0.1009
      },
      {
        "periodo": 202603,
        "valor": 13.2985,
        "delta": 0.1232
      },
      {
        "periodo": 202604,
        "valor": 13.4673,
        "delta": 0.1689
      },
      {
        "periodo": 202605,
        "valor": 13.5678,
        "delta": 0.1005
      },
      {
        "periodo": 202606,
        "valor": 13.1001,
        "delta": -0.4677
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 14.699991,
    "valor_anterior": 14.761235,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.2886,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.4662,
        "delta": 0.1776
      },
      {
        "periodo": 202508,
        "valor": 15.5322,
        "delta": 1.066
      },
      {
        "periodo": 202509,
        "valor": 15.8882,
        "delta": 0.356
      },
      {
        "periodo": 202510,
        "valor": 15.9932,
        "delta": 0.105
      },
      {
        "periodo": 202511,
        "valor": 15.6276,
        "delta": -0.3656
      },
      {
        "periodo": 202512,
        "valor": 15.4646,
        "delta": -0.163
      },
      {
        "periodo": 202601,
        "valor": 16.0357,
        "delta": 0.5711
      },
      {
        "periodo": 202602,
        "valor": 16.2682,
        "delta": 0.2325
      },
      {
        "periodo": 202603,
        "valor": 15.988,
        "delta": -0.2802
      },
      {
        "periodo": 202604,
        "valor": 14.662,
        "delta": -1.326
      },
      {
        "periodo": 202605,
        "valor": 14.7612,
        "delta": 0.0993
      },
      {
        "periodo": 202606,
        "valor": 14.7,
        "delta": -0.0612
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 23.191124,
    "valor_anterior": 23.316292,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 23.2439,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 23.4024,
        "delta": 0.1585
      },
      {
        "periodo": 202508,
        "valor": 23.5412,
        "delta": 0.1389
      },
      {
        "periodo": 202509,
        "valor": 23.4555,
        "delta": -0.0857
      },
      {
        "periodo": 202510,
        "valor": 23.3702,
        "delta": -0.0853
      },
      {
        "periodo": 202511,
        "valor": 23.6521,
        "delta": 0.2819
      },
      {
        "periodo": 202512,
        "valor": 23.5562,
        "delta": -0.0959
      },
      {
        "periodo": 202601,
        "valor": 23.4224,
        "delta": -0.1338
      },
      {
        "periodo": 202602,
        "valor": 23.2631,
        "delta": -0.1593
      },
      {
        "periodo": 202603,
        "valor": 23.2486,
        "delta": -0.0145
      },
      {
        "periodo": 202604,
        "valor": 23.2908,
        "delta": 0.0422
      },
      {
        "periodo": 202605,
        "valor": 23.3163,
        "delta": 0.0255
      },
      {
        "periodo": 202606,
        "valor": 23.1911,
        "delta": -0.1252
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 16.098981,
    "valor_anterior": 16.108791,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 16.4915,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 16.5902,
        "delta": 0.0987
      },
      {
        "periodo": 202508,
        "valor": 16.0773,
        "delta": -0.5129
      },
      {
        "periodo": 202509,
        "valor": 16.5396,
        "delta": 0.4623
      },
      {
        "periodo": 202510,
        "valor": 16.6897,
        "delta": 0.1501
      },
      {
        "periodo": 202511,
        "valor": 16.6285,
        "delta": -0.0612
      },
      {
        "periodo": 202512,
        "valor": 17.124,
        "delta": 0.4955
      },
      {
        "periodo": 202601,
        "valor": 16.9711,
        "delta": -0.1529
      },
      {
        "periodo": 202602,
        "valor": 17.0558,
        "delta": 0.0847
      },
      {
        "periodo": 202603,
        "valor": 17.0258,
        "delta": -0.0301
      },
      {
        "periodo": 202604,
        "valor": 17.0114,
        "delta": -0.0144
      },
      {
        "periodo": 202605,
        "valor": 16.1088,
        "delta": -0.9026
      },
      {
        "periodo": 202606,
        "valor": 16.099,
        "delta": -0.0098
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 18.28674,
    "valor_anterior": 17.9862,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 16.8258,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17.0312,
        "delta": 0.2054
      },
      {
        "periodo": 202508,
        "valor": 16.9907,
        "delta": -0.0405
      },
      {
        "periodo": 202509,
        "valor": 17.3238,
        "delta": 0.3331
      },
      {
        "periodo": 202510,
        "valor": 17.2485,
        "delta": -0.0753
      },
      {
        "periodo": 202511,
        "valor": 17.3026,
        "delta": 0.054
      },
      {
        "periodo": 202512,
        "valor": 17.7452,
        "delta": 0.4426
      },
      {
        "periodo": 202601,
        "valor": 17.6772,
        "delta": -0.068
      },
      {
        "periodo": 202602,
        "valor": 18.103,
        "delta": 0.4259
      },
      {
        "periodo": 202603,
        "valor": 18.3202,
        "delta": 0.2172
      },
      {
        "periodo": 202604,
        "valor": 18.0749,
        "delta": -0.2453
      },
      {
        "periodo": 202605,
        "valor": 17.9862,
        "delta": -0.0887
      },
      {
        "periodo": 202606,
        "valor": 18.2867,
        "delta": 0.3005
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 15.494877,
    "valor_anterior": 15.201122,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.3672,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.5934,
        "delta": 0.2262
      },
      {
        "periodo": 202508,
        "valor": 14.6674,
        "delta": 0.074
      },
      {
        "periodo": 202509,
        "valor": 14.7277,
        "delta": 0.0603
      },
      {
        "periodo": 202510,
        "valor": 15.0266,
        "delta": 0.2988
      },
      {
        "periodo": 202511,
        "valor": 14.5604,
        "delta": -0.4662
      },
      {
        "periodo": 202512,
        "valor": 15.009,
        "delta": 0.4486
      },
      {
        "periodo": 202601,
        "valor": 15.0689,
        "delta": 0.0599
      },
      {
        "periodo": 202602,
        "valor": 15.7342,
        "delta": 0.6653
      },
      {
        "periodo": 202603,
        "valor": 15.0583,
        "delta": -0.6759
      },
      {
        "periodo": 202604,
        "valor": 15.0753,
        "delta": 0.017
      },
      {
        "periodo": 202605,
        "valor": 15.2011,
        "delta": 0.1258
      },
      {
        "periodo": 202606,
        "valor": 15.4949,
        "delta": 0.2938
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 15.664162,
    "valor_anterior": 15.387167,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 16.0789,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 15.9375,
        "delta": -0.1413
      },
      {
        "periodo": 202508,
        "valor": 15.7208,
        "delta": -0.2168
      },
      {
        "periodo": 202509,
        "valor": 15.7612,
        "delta": 0.0405
      },
      {
        "periodo": 202510,
        "valor": 15.9736,
        "delta": 0.2123
      },
      {
        "periodo": 202511,
        "valor": 15.7425,
        "delta": -0.231
      },
      {
        "periodo": 202512,
        "valor": 16.3771,
        "delta": 0.6346
      },
      {
        "periodo": 202601,
        "valor": 15.6547,
        "delta": -0.7224
      },
      {
        "periodo": 202602,
        "valor": 15.4189,
        "delta": -0.2358
      },
      {
        "periodo": 202603,
        "valor": 15.1926,
        "delta": -0.2263
      },
      {
        "periodo": 202604,
        "valor": 15.6139,
        "delta": 0.4214
      },
      {
        "periodo": 202605,
        "valor": 15.3872,
        "delta": -0.2268
      },
      {
        "periodo": 202606,
        "valor": 15.6642,
        "delta": 0.277
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 25.863505,
    "valor_anterior": 24.919502,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 23.6613,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 22.2536,
        "delta": -1.4076
      },
      {
        "periodo": 202508,
        "valor": 21.7681,
        "delta": -0.4855
      },
      {
        "periodo": 202509,
        "valor": 22.6854,
        "delta": 0.9173
      },
      {
        "periodo": 202510,
        "valor": 22.9189,
        "delta": 0.2336
      },
      {
        "periodo": 202511,
        "valor": 21.9901,
        "delta": -0.9289
      },
      {
        "periodo": 202512,
        "valor": 22.7331,
        "delta": 0.743
      },
      {
        "periodo": 202601,
        "valor": 23.3755,
        "delta": 0.6424
      },
      {
        "periodo": 202602,
        "valor": 23.5925,
        "delta": 0.217
      },
      {
        "periodo": 202603,
        "valor": 24.6678,
        "delta": 1.0753
      },
      {
        "periodo": 202604,
        "valor": 24.6442,
        "delta": -0.0236
      },
      {
        "periodo": 202605,
        "valor": 24.9195,
        "delta": 0.2753
      },
      {
        "periodo": 202606,
        "valor": 25.8635,
        "delta": 0.944
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 11.055205,
    "valor_anterior": 10.49615,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 10.2568,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 10.4039,
        "delta": 0.147
      },
      {
        "periodo": 202508,
        "valor": 10.4124,
        "delta": 0.0085
      },
      {
        "periodo": 202509,
        "valor": 10.3731,
        "delta": -0.0393
      },
      {
        "periodo": 202510,
        "valor": 10.2564,
        "delta": -0.1167
      },
      {
        "periodo": 202511,
        "valor": 10.1022,
        "delta": -0.1542
      },
      {
        "periodo": 202512,
        "valor": 10.1477,
        "delta": 0.0455
      },
      {
        "periodo": 202601,
        "valor": 10.0469,
        "delta": -0.1008
      },
      {
        "periodo": 202602,
        "valor": 10.1039,
        "delta": 0.057
      },
      {
        "periodo": 202603,
        "valor": 10.5082,
        "delta": 0.4043
      },
      {
        "periodo": 202604,
        "valor": 10.4237,
        "delta": -0.0846
      },
      {
        "periodo": 202605,
        "valor": 10.4962,
        "delta": 0.0725
      },
      {
        "periodo": 202606,
        "valor": 11.0552,
        "delta": 0.5591
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 12.556431,
    "valor_anterior": 12.295076,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 13.9551,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.396,
        "delta": 0.4409
      },
      {
        "periodo": 202508,
        "valor": 14.5354,
        "delta": 0.1394
      },
      {
        "periodo": 202509,
        "valor": 14.8219,
        "delta": 0.2865
      },
      {
        "periodo": 202510,
        "valor": 14.949,
        "delta": 0.1271
      },
      {
        "periodo": 202511,
        "valor": 12.8349,
        "delta": -2.1142
      },
      {
        "periodo": 202512,
        "valor": 12.6064,
        "delta": -0.2285
      },
      {
        "periodo": 202601,
        "valor": 12.3346,
        "delta": -0.2717
      },
      {
        "periodo": 202602,
        "valor": 12.6736,
        "delta": 0.339
      },
      {
        "periodo": 202603,
        "valor": 12.7479,
        "delta": 0.0743
      },
      {
        "periodo": 202604,
        "valor": 11.9629,
        "delta": -0.785
      },
      {
        "periodo": 202605,
        "valor": 12.2951,
        "delta": 0.3321
      },
      {
        "periodo": 202606,
        "valor": 12.5564,
        "delta": 0.2614
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 18.638104,
    "valor_anterior": 18.761041,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17.6096,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18.1661,
        "delta": 0.5565
      },
      {
        "periodo": 202508,
        "valor": 16.9203,
        "delta": -1.2458
      },
      {
        "periodo": 202509,
        "valor": 17.4175,
        "delta": 0.4972
      },
      {
        "periodo": 202510,
        "valor": 17.7904,
        "delta": 0.3729
      },
      {
        "periodo": 202511,
        "valor": 17.9331,
        "delta": 0.1428
      },
      {
        "periodo": 202512,
        "valor": 18.7454,
        "delta": 0.8123
      },
      {
        "periodo": 202601,
        "valor": 19.5977,
        "delta": 0.8523
      },
      {
        "periodo": 202602,
        "valor": 18.7687,
        "delta": -0.829
      },
      {
        "periodo": 202603,
        "valor": 19.0195,
        "delta": 0.2508
      },
      {
        "periodo": 202604,
        "valor": 19.5393,
        "delta": 0.5197
      },
      {
        "periodo": 202605,
        "valor": 18.761,
        "delta": -0.7782
      },
      {
        "periodo": 202606,
        "valor": 18.6381,
        "delta": -0.1229
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 52.143629,
    "valor_anterior": 44.312307,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 50.8791,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 49.8605,
        "delta": -1.0186
      },
      {
        "periodo": 202508,
        "valor": 48.2043,
        "delta": -1.6562
      },
      {
        "periodo": 202509,
        "valor": 51.2141,
        "delta": 3.0098
      },
      {
        "periodo": 202510,
        "valor": 43.8312,
        "delta": -7.3829
      },
      {
        "periodo": 202511,
        "valor": 42.9908,
        "delta": -0.8404
      },
      {
        "periodo": 202512,
        "valor": 47.5614,
        "delta": 4.5706
      },
      {
        "periodo": 202601,
        "valor": 47.6478,
        "delta": 0.0864
      },
      {
        "periodo": 202602,
        "valor": 43.5513,
        "delta": -4.0965
      },
      {
        "periodo": 202603,
        "valor": 43.7652,
        "delta": 0.2139
      },
      {
        "periodo": 202604,
        "valor": 44.4742,
        "delta": 0.709
      },
      {
        "periodo": 202605,
        "valor": 44.3123,
        "delta": -0.1619
      },
      {
        "periodo": 202606,
        "valor": 52.1436,
        "delta": 7.8313
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 46.793728,
    "valor_anterior": 45.011342,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 44.1089,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 45.0871,
        "delta": 0.9782
      },
      {
        "periodo": 202508,
        "valor": 45.4951,
        "delta": 0.408
      },
      {
        "periodo": 202509,
        "valor": 46.311,
        "delta": 0.8159
      },
      {
        "periodo": 202510,
        "valor": 45.2904,
        "delta": -1.0205
      },
      {
        "periodo": 202511,
        "valor": 46.1473,
        "delta": 0.8569
      },
      {
        "periodo": 202512,
        "valor": 49.7429,
        "delta": 3.5956
      },
      {
        "periodo": 202601,
        "valor": 46.5679,
        "delta": -3.175
      },
      {
        "periodo": 202602,
        "valor": 43.2051,
        "delta": -3.3628
      },
      {
        "periodo": 202603,
        "valor": 45.2543,
        "delta": 2.0491
      },
      {
        "periodo": 202604,
        "valor": 44.9503,
        "delta": -0.304
      },
      {
        "periodo": 202605,
        "valor": 45.0113,
        "delta": 0.061
      },
      {
        "periodo": 202606,
        "valor": 46.7937,
        "delta": 1.7824
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 19.397549,
    "valor_anterior": 19.847105,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 18.0699,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17.7701,
        "delta": -0.2998
      },
      {
        "periodo": 202508,
        "valor": 18.1605,
        "delta": 0.3904
      },
      {
        "periodo": 202509,
        "valor": 19.0469,
        "delta": 0.8864
      },
      {
        "periodo": 202510,
        "valor": 19.5345,
        "delta": 0.4876
      },
      {
        "periodo": 202511,
        "valor": 19.5042,
        "delta": -0.0303
      },
      {
        "periodo": 202512,
        "valor": 18.7052,
        "delta": -0.799
      },
      {
        "periodo": 202601,
        "valor": 19.0042,
        "delta": 0.2989
      },
      {
        "periodo": 202602,
        "valor": 19.2235,
        "delta": 0.2193
      },
      {
        "periodo": 202603,
        "valor": 19.6521,
        "delta": 0.4286
      },
      {
        "periodo": 202604,
        "valor": 18.8271,
        "delta": -0.825
      },
      {
        "periodo": 202605,
        "valor": 19.8471,
        "delta": 1.02
      },
      {
        "periodo": 202606,
        "valor": 19.3975,
        "delta": -0.4496
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 15.068186,
    "valor_anterior": 15.245983,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.7415,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.8467,
        "delta": 0.1052
      },
      {
        "periodo": 202508,
        "valor": 14.8769,
        "delta": 0.0303
      },
      {
        "periodo": 202509,
        "valor": 14.6027,
        "delta": -0.2742
      },
      {
        "periodo": 202510,
        "valor": 14.769,
        "delta": 0.1663
      },
      {
        "periodo": 202511,
        "valor": 14.4549,
        "delta": -0.3141
      },
      {
        "periodo": 202512,
        "valor": 14.6409,
        "delta": 0.186
      },
      {
        "periodo": 202601,
        "valor": 14.9559,
        "delta": 0.315
      },
      {
        "periodo": 202602,
        "valor": 14.8954,
        "delta": -0.0604
      },
      {
        "periodo": 202603,
        "valor": 14.5673,
        "delta": -0.3282
      },
      {
        "periodo": 202604,
        "valor": 15.2195,
        "delta": 0.6522
      },
      {
        "periodo": 202605,
        "valor": 15.246,
        "delta": 0.0265
      },
      {
        "periodo": 202606,
        "valor": 15.0682,
        "delta": -0.1778
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 25.75418,
    "valor_anterior": 25.974474,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 21.7005,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 22.2823,
        "delta": 0.5818
      },
      {
        "periodo": 202508,
        "valor": 22.3751,
        "delta": 0.0928
      },
      {
        "periodo": 202509,
        "valor": 23.2695,
        "delta": 0.8944
      },
      {
        "periodo": 202510,
        "valor": 23.0262,
        "delta": -0.2433
      },
      {
        "periodo": 202511,
        "valor": 23.0348,
        "delta": 0.0086
      },
      {
        "periodo": 202512,
        "valor": 25.2767,
        "delta": 2.2418
      },
      {
        "periodo": 202601,
        "valor": 25.0022,
        "delta": -0.2745
      },
      {
        "periodo": 202602,
        "valor": 23.9707,
        "delta": -1.0315
      },
      {
        "periodo": 202603,
        "valor": 24.3777,
        "delta": 0.407
      },
      {
        "periodo": 202604,
        "valor": 24.3772,
        "delta": -0.0004
      },
      {
        "periodo": 202605,
        "valor": 25.9745,
        "delta": 1.5972
      },
      {
        "periodo": 202606,
        "valor": 25.7542,
        "delta": -0.2203
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 228.774898,
    "valor_anterior": 237.684459,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 153.4448,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 150.7438,
        "delta": -2.7009
      },
      {
        "periodo": 202508,
        "valor": 160.7523,
        "delta": 10.0085
      },
      {
        "periodo": 202509,
        "valor": 176.2203,
        "delta": 15.468
      },
      {
        "periodo": 202510,
        "valor": 170.4794,
        "delta": -5.7409
      },
      {
        "periodo": 202511,
        "valor": 184.3382,
        "delta": 13.8588
      },
      {
        "periodo": 202512,
        "valor": 185.6193,
        "delta": 1.2811
      },
      {
        "periodo": 202601,
        "valor": 193.9004,
        "delta": 8.2811
      },
      {
        "periodo": 202602,
        "valor": 195.273,
        "delta": 1.3726
      },
      {
        "periodo": 202603,
        "valor": 206.9506,
        "delta": 11.6776
      },
      {
        "periodo": 202604,
        "valor": 209.8786,
        "delta": 2.9281
      },
      {
        "periodo": 202605,
        "valor": 237.6845,
        "delta": 27.8058
      },
      {
        "periodo": 202606,
        "valor": 228.7749,
        "delta": -8.9096
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 14.210117,
    "valor_anterior": 14.410556,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.1799,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13.8897,
        "delta": -0.2902
      },
      {
        "periodo": 202508,
        "valor": 13.5504,
        "delta": -0.3393
      },
      {
        "periodo": 202509,
        "valor": 14.4243,
        "delta": 0.8739
      },
      {
        "periodo": 202510,
        "valor": 14.6812,
        "delta": 0.2569
      },
      {
        "periodo": 202511,
        "valor": 14.612,
        "delta": -0.0691
      },
      {
        "periodo": 202512,
        "valor": 14.974,
        "delta": 0.362
      },
      {
        "periodo": 202601,
        "valor": 14.5354,
        "delta": -0.4386
      },
      {
        "periodo": 202602,
        "valor": 14.5321,
        "delta": -0.0033
      },
      {
        "periodo": 202603,
        "valor": 15.0489,
        "delta": 0.5168
      },
      {
        "periodo": 202604,
        "valor": 14.8266,
        "delta": -0.2223
      },
      {
        "periodo": 202605,
        "valor": 14.4106,
        "delta": -0.416
      },
      {
        "periodo": 202606,
        "valor": 14.2101,
        "delta": -0.2004
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 13.325515,
    "valor_anterior": 13.148665,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 13.2278,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13.2091,
        "delta": -0.0187
      },
      {
        "periodo": 202508,
        "valor": 12.099,
        "delta": -1.1101
      },
      {
        "periodo": 202509,
        "valor": 13.3286,
        "delta": 1.2296
      },
      {
        "periodo": 202510,
        "valor": 15.3968,
        "delta": 2.0682
      },
      {
        "periodo": 202511,
        "valor": 14.7402,
        "delta": -0.6566
      },
      {
        "periodo": 202512,
        "valor": 12.6525,
        "delta": -2.0877
      },
      {
        "periodo": 202601,
        "valor": 13.5088,
        "delta": 0.8563
      },
      {
        "periodo": 202602,
        "valor": 13.8727,
        "delta": 0.3639
      },
      {
        "periodo": 202603,
        "valor": 13.9856,
        "delta": 0.1129
      },
      {
        "periodo": 202604,
        "valor": 13.9285,
        "delta": -0.0571
      },
      {
        "periodo": 202605,
        "valor": 13.1487,
        "delta": -0.7799
      },
      {
        "periodo": 202606,
        "valor": 13.3255,
        "delta": 0.1768
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 20.502546,
    "valor_anterior": 24.086302,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 23.092,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 24.6519,
        "delta": 1.5599
      },
      {
        "periodo": 202508,
        "valor": 23.0837,
        "delta": -1.5682
      },
      {
        "periodo": 202509,
        "valor": 25.2753,
        "delta": 2.1916
      },
      {
        "periodo": 202510,
        "valor": 25.2278,
        "delta": -0.0475
      },
      {
        "periodo": 202511,
        "valor": 23.0526,
        "delta": -2.1751
      },
      {
        "periodo": 202512,
        "valor": 24.2592,
        "delta": 1.2066
      },
      {
        "periodo": 202601,
        "valor": 22.3905,
        "delta": -1.8686
      },
      {
        "periodo": 202602,
        "valor": 22.8979,
        "delta": 0.5074
      },
      {
        "periodo": 202603,
        "valor": 21.0241,
        "delta": -1.8739
      },
      {
        "periodo": 202604,
        "valor": 20.9998,
        "delta": -0.0242
      },
      {
        "periodo": 202605,
        "valor": 24.0863,
        "delta": 3.0865
      },
      {
        "periodo": 202606,
        "valor": 20.5025,
        "delta": -3.5838
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 32.104463,
    "valor_anterior": 31.914705,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 30.6624,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 29.85,
        "delta": -0.8124
      },
      {
        "periodo": 202508,
        "valor": 30.2581,
        "delta": 0.4081
      },
      {
        "periodo": 202509,
        "valor": 31.7118,
        "delta": 1.4537
      },
      {
        "periodo": 202510,
        "valor": 32.0551,
        "delta": 0.3433
      },
      {
        "periodo": 202511,
        "valor": 29.0481,
        "delta": -3.007
      },
      {
        "periodo": 202512,
        "valor": 29.9514,
        "delta": 0.9032
      },
      {
        "periodo": 202601,
        "valor": 32.0341,
        "delta": 2.0827
      },
      {
        "periodo": 202602,
        "valor": 32.3425,
        "delta": 0.3084
      },
      {
        "periodo": 202603,
        "valor": 32.3261,
        "delta": -0.0164
      },
      {
        "periodo": 202604,
        "valor": 30.5025,
        "delta": -1.8236
      },
      {
        "periodo": 202605,
        "valor": 31.9147,
        "delta": 1.4122
      },
      {
        "periodo": 202606,
        "valor": 32.1045,
        "delta": 0.1898
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 12.402354,
    "valor_anterior": 12.738653,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 13.5348,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13.364,
        "delta": -0.1708
      },
      {
        "periodo": 202508,
        "valor": 13.5662,
        "delta": 0.2022
      },
      {
        "periodo": 202509,
        "valor": 12.8801,
        "delta": -0.686
      },
      {
        "periodo": 202510,
        "valor": 12.7993,
        "delta": -0.0809
      },
      {
        "periodo": 202511,
        "valor": 13.2008,
        "delta": 0.4015
      },
      {
        "periodo": 202512,
        "valor": 12.4722,
        "delta": -0.7286
      },
      {
        "periodo": 202601,
        "valor": 13.0706,
        "delta": 0.5983
      },
      {
        "periodo": 202602,
        "valor": 13.1285,
        "delta": 0.058
      },
      {
        "periodo": 202603,
        "valor": 13.5358,
        "delta": 0.4073
      },
      {
        "periodo": 202604,
        "valor": 12.9677,
        "delta": -0.5681
      },
      {
        "periodo": 202605,
        "valor": 12.7387,
        "delta": -0.229
      },
      {
        "periodo": 202606,
        "valor": 12.4024,
        "delta": -0.3363
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 17.246799,
    "valor_anterior": 17.879806,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 18.2274,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18.1969,
        "delta": -0.0305
      },
      {
        "periodo": 202508,
        "valor": 17.4642,
        "delta": -0.7328
      },
      {
        "periodo": 202509,
        "valor": 18.0614,
        "delta": 0.5972
      },
      {
        "periodo": 202510,
        "valor": 17.8641,
        "delta": -0.1973
      },
      {
        "periodo": 202511,
        "valor": 16.8274,
        "delta": -1.0366
      },
      {
        "periodo": 202512,
        "valor": 16.947,
        "delta": 0.1196
      },
      {
        "periodo": 202601,
        "valor": 16.9738,
        "delta": 0.0268
      },
      {
        "periodo": 202602,
        "valor": 17.2034,
        "delta": 0.2296
      },
      {
        "periodo": 202603,
        "valor": 16.9027,
        "delta": -0.3007
      },
      {
        "periodo": 202604,
        "valor": 17.3069,
        "delta": 0.4042
      },
      {
        "periodo": 202605,
        "valor": 17.8798,
        "delta": 0.5729
      },
      {
        "periodo": 202606,
        "valor": 17.2468,
        "delta": -0.633
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 25.207297,
    "valor_anterior": 24.562347,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17.6158,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 25.792,
        "delta": 8.1762
      },
      {
        "periodo": 202508,
        "valor": 32.938,
        "delta": 7.146
      },
      {
        "periodo": 202509,
        "valor": 53.7846,
        "delta": 20.8466
      },
      {
        "periodo": 202510,
        "valor": 55.8971,
        "delta": 2.1125
      },
      {
        "periodo": 202511,
        "valor": 22.141,
        "delta": -33.7561
      },
      {
        "periodo": 202512,
        "valor": 23.8787,
        "delta": 1.7377
      },
      {
        "periodo": 202601,
        "valor": 24.6876,
        "delta": 0.8089
      },
      {
        "periodo": 202602,
        "valor": 25.7625,
        "delta": 1.0748
      },
      {
        "periodo": 202603,
        "valor": 26.9815,
        "delta": 1.219
      },
      {
        "periodo": 202604,
        "valor": 23.7503,
        "delta": -3.2312
      },
      {
        "periodo": 202605,
        "valor": 24.5623,
        "delta": 0.8121
      },
      {
        "periodo": 202606,
        "valor": 25.2073,
        "delta": 0.645
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 15.643436,
    "valor_anterior": 14.190794,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17.4696,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17.301,
        "delta": -0.1685
      },
      {
        "periodo": 202508,
        "valor": 15.8062,
        "delta": -1.4949
      },
      {
        "periodo": 202509,
        "valor": 15.921,
        "delta": 0.1148
      },
      {
        "periodo": 202510,
        "valor": 15.7094,
        "delta": -0.2116
      },
      {
        "periodo": 202511,
        "valor": 15.0444,
        "delta": -0.665
      },
      {
        "periodo": 202512,
        "valor": 15.0096,
        "delta": -0.0348
      },
      {
        "periodo": 202601,
        "valor": 14.8701,
        "delta": -0.1395
      },
      {
        "periodo": 202602,
        "valor": 15.0497,
        "delta": 0.1796
      },
      {
        "periodo": 202603,
        "valor": 14.5718,
        "delta": -0.4779
      },
      {
        "periodo": 202604,
        "valor": 14.8176,
        "delta": 0.2458
      },
      {
        "periodo": 202605,
        "valor": 14.1908,
        "delta": -0.6268
      },
      {
        "periodo": 202606,
        "valor": 15.6434,
        "delta": 1.4526
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 29.168221,
    "valor_anterior": 22.522398,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 44.7849,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 36.4415,
        "delta": -8.3433
      },
      {
        "periodo": 202508,
        "valor": 46.1991,
        "delta": 9.7576
      },
      {
        "periodo": 202509,
        "valor": 41.5569,
        "delta": -4.6422
      },
      {
        "periodo": 202510,
        "valor": 36.287,
        "delta": -5.27
      },
      {
        "periodo": 202511,
        "valor": 28.9028,
        "delta": -7.3841
      },
      {
        "periodo": 202512,
        "valor": 37.8799,
        "delta": 8.9771
      },
      {
        "periodo": 202601,
        "valor": 33.6047,
        "delta": -4.2752
      },
      {
        "periodo": 202602,
        "valor": 26.0672,
        "delta": -7.5375
      },
      {
        "periodo": 202603,
        "valor": 31.5272,
        "delta": 5.46
      },
      {
        "periodo": 202604,
        "valor": 24.8554,
        "delta": -6.6719
      },
      {
        "periodo": 202605,
        "valor": 22.5224,
        "delta": -2.333
      },
      {
        "periodo": 202606,
        "valor": 29.1682,
        "delta": 6.6458
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 10.308222,
    "valor_anterior": 10.319016,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 10.2222,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 11.8052,
        "delta": 1.5829
      },
      {
        "periodo": 202508,
        "valor": 11.2451,
        "delta": -0.5601
      },
      {
        "periodo": 202509,
        "valor": 11.5605,
        "delta": 0.3155
      },
      {
        "periodo": 202510,
        "valor": 10.5718,
        "delta": -0.9887
      },
      {
        "periodo": 202511,
        "valor": 10.3262,
        "delta": -0.2456
      },
      {
        "periodo": 202512,
        "valor": 14.3532,
        "delta": 4.0269
      },
      {
        "periodo": 202601,
        "valor": 12.359,
        "delta": -1.9942
      },
      {
        "periodo": 202602,
        "valor": 10.493,
        "delta": -1.866
      },
      {
        "periodo": 202603,
        "valor": 11.6068,
        "delta": 1.1138
      },
      {
        "periodo": 202604,
        "valor": 10.4589,
        "delta": -1.1479
      },
      {
        "periodo": 202605,
        "valor": 10.319,
        "delta": -0.1399
      },
      {
        "periodo": 202606,
        "valor": 10.3082,
        "delta": -0.0108
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 10.490232,
    "valor_anterior": 10.40887,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 9.0828,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 9.3233,
        "delta": 0.2406
      },
      {
        "periodo": 202508,
        "valor": 9.1856,
        "delta": -0.1377
      },
      {
        "periodo": 202509,
        "valor": 9.479,
        "delta": 0.2933
      },
      {
        "periodo": 202510,
        "valor": 9.4215,
        "delta": -0.0575
      },
      {
        "periodo": 202511,
        "valor": 9.8059,
        "delta": 0.3844
      },
      {
        "periodo": 202512,
        "valor": 9.8711,
        "delta": 0.0652
      },
      {
        "periodo": 202601,
        "valor": 9.8927,
        "delta": 0.0216
      },
      {
        "periodo": 202602,
        "valor": 9.6427,
        "delta": -0.25
      },
      {
        "periodo": 202603,
        "valor": 10.0144,
        "delta": 0.3717
      },
      {
        "periodo": 202604,
        "valor": 10.0485,
        "delta": 0.0341
      },
      {
        "periodo": 202605,
        "valor": 10.4089,
        "delta": 0.3604
      },
      {
        "periodo": 202606,
        "valor": 10.4902,
        "delta": 0.0814
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 29.88941,
    "valor_anterior": 29.515463,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 27.4702,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 27.5058,
        "delta": 0.0356
      },
      {
        "periodo": 202508,
        "valor": 27.3586,
        "delta": -0.1472
      },
      {
        "periodo": 202509,
        "valor": 28.6201,
        "delta": 1.2615
      },
      {
        "periodo": 202510,
        "valor": 27.9412,
        "delta": -0.6789
      },
      {
        "periodo": 202511,
        "valor": 27.3203,
        "delta": -0.6209
      },
      {
        "periodo": 202512,
        "valor": 27.5016,
        "delta": 0.1814
      },
      {
        "periodo": 202601,
        "valor": 26.8576,
        "delta": -0.644
      },
      {
        "periodo": 202602,
        "valor": 26.6916,
        "delta": -0.166
      },
      {
        "periodo": 202603,
        "valor": 24.9825,
        "delta": -1.7092
      },
      {
        "periodo": 202604,
        "valor": 29.3053,
        "delta": 4.3229
      },
      {
        "periodo": 202605,
        "valor": 29.5155,
        "delta": 0.2101
      },
      {
        "periodo": 202606,
        "valor": 29.8894,
        "delta": 0.3739
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 9.7833,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 10.7645,
        "delta": 0.9811
      },
      {
        "periodo": 202508,
        "valor": 13.2823,
        "delta": 2.5178
      },
      {
        "periodo": 202509,
        "valor": 14.518,
        "delta": 1.2357
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 21.611661,
    "valor_anterior": 22.007027,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 21.3073,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 23.355,
        "delta": 2.0476
      },
      {
        "periodo": 202508,
        "valor": 22.5006,
        "delta": -0.8544
      },
      {
        "periodo": 202509,
        "valor": 21.3157,
        "delta": -1.1849
      },
      {
        "periodo": 202510,
        "valor": 21.1027,
        "delta": -0.213
      },
      {
        "periodo": 202511,
        "valor": 21.1524,
        "delta": 0.0497
      },
      {
        "periodo": 202512,
        "valor": 21.3676,
        "delta": 0.2152
      },
      {
        "periodo": 202601,
        "valor": 20.1246,
        "delta": -1.243
      },
      {
        "periodo": 202602,
        "valor": 21.7327,
        "delta": 1.6081
      },
      {
        "periodo": 202603,
        "valor": 23.1347,
        "delta": 1.402
      },
      {
        "periodo": 202604,
        "valor": 20.5076,
        "delta": -2.6271
      },
      {
        "periodo": 202605,
        "valor": 22.007,
        "delta": 1.4994
      },
      {
        "periodo": 202606,
        "valor": 21.6117,
        "delta": -0.3954
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 12.481132,
    "valor_anterior": 11.460495,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.7472,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.24,
        "delta": -0.5072
      },
      {
        "periodo": 202508,
        "valor": 14.3431,
        "delta": 0.1032
      },
      {
        "periodo": 202509,
        "valor": 13.6669,
        "delta": -0.6762
      },
      {
        "periodo": 202510,
        "valor": 13.5549,
        "delta": -0.112
      },
      {
        "periodo": 202511,
        "valor": 12.8422,
        "delta": -0.7126
      },
      {
        "periodo": 202512,
        "valor": 13.4527,
        "delta": 0.6105
      },
      {
        "periodo": 202601,
        "valor": 12.7541,
        "delta": -0.6986
      },
      {
        "periodo": 202602,
        "valor": 12.7242,
        "delta": -0.03
      },
      {
        "periodo": 202603,
        "valor": 13.3202,
        "delta": 0.5961
      },
      {
        "periodo": 202604,
        "valor": 12.1866,
        "delta": -1.1337
      },
      {
        "periodo": 202605,
        "valor": 11.4605,
        "delta": -0.7261
      },
      {
        "periodo": 202606,
        "valor": 12.4811,
        "delta": 1.0206
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 115.33629,
    "valor_anterior": 106.195597,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 150.8684,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 151.077,
        "delta": 0.2086
      },
      {
        "periodo": 202508,
        "valor": 134.4491,
        "delta": -16.6279
      },
      {
        "periodo": 202509,
        "valor": 146.2207,
        "delta": 11.7716
      },
      {
        "periodo": 202510,
        "valor": 138.2654,
        "delta": -7.9553
      },
      {
        "periodo": 202511,
        "valor": 132.2233,
        "delta": -6.0421
      },
      {
        "periodo": 202512,
        "valor": 134.8015,
        "delta": 2.5782
      },
      {
        "periodo": 202601,
        "valor": 122.3967,
        "delta": -12.4048
      },
      {
        "periodo": 202602,
        "valor": 122.5034,
        "delta": 0.1067
      },
      {
        "periodo": 202603,
        "valor": 120.8328,
        "delta": -1.6707
      },
      {
        "periodo": 202604,
        "valor": 118.4693,
        "delta": -2.3635
      },
      {
        "periodo": 202605,
        "valor": 106.1956,
        "delta": -12.2737
      },
      {
        "periodo": 202606,
        "valor": 115.3363,
        "delta": 9.1407
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 73.825355,
    "valor_anterior": 74.263084,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 95.5907,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 91.0426,
        "delta": -4.5481
      },
      {
        "periodo": 202508,
        "valor": 85.5332,
        "delta": -5.5094
      },
      {
        "periodo": 202509,
        "valor": 81.9308,
        "delta": -3.6024
      },
      {
        "periodo": 202510,
        "valor": 76.6862,
        "delta": -5.2446
      },
      {
        "periodo": 202511,
        "valor": 73.9434,
        "delta": -2.7428
      },
      {
        "periodo": 202512,
        "valor": 76.9739,
        "delta": 3.0305
      },
      {
        "periodo": 202601,
        "valor": 75.5844,
        "delta": -1.3895
      },
      {
        "periodo": 202602,
        "valor": 76.1741,
        "delta": 0.5897
      },
      {
        "periodo": 202603,
        "valor": 74.1142,
        "delta": -2.0599
      },
      {
        "periodo": 202604,
        "valor": 74.4632,
        "delta": 0.349
      },
      {
        "periodo": 202605,
        "valor": 74.2631,
        "delta": -0.2001
      },
      {
        "periodo": 202606,
        "valor": 73.8254,
        "delta": -0.4377
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 12.342582,
    "valor_anterior": 12.452217,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 12.9993,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13.071,
        "delta": 0.0717
      },
      {
        "periodo": 202508,
        "valor": 12.7884,
        "delta": -0.2827
      },
      {
        "periodo": 202509,
        "valor": 12.9405,
        "delta": 0.1522
      },
      {
        "periodo": 202510,
        "valor": 12.9385,
        "delta": -0.002
      },
      {
        "periodo": 202511,
        "valor": 12.9724,
        "delta": 0.0339
      },
      {
        "periodo": 202512,
        "valor": 12.6378,
        "delta": -0.3346
      },
      {
        "periodo": 202601,
        "valor": 12.6268,
        "delta": -0.011
      },
      {
        "periodo": 202602,
        "valor": 12.7172,
        "delta": 0.0904
      },
      {
        "periodo": 202603,
        "valor": 12.5605,
        "delta": -0.1567
      },
      {
        "periodo": 202604,
        "valor": 12.4951,
        "delta": -0.0654
      },
      {
        "periodo": 202605,
        "valor": 12.4522,
        "delta": -0.0429
      },
      {
        "periodo": 202606,
        "valor": 12.3426,
        "delta": -0.1096
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 26.948384,
    "valor_anterior": 26.340513,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 23.1403,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 23.4783,
        "delta": 0.3379
      },
      {
        "periodo": 202508,
        "valor": 24.8013,
        "delta": 1.323
      },
      {
        "periodo": 202509,
        "valor": 23.8939,
        "delta": -0.9074
      },
      {
        "periodo": 202510,
        "valor": 24.0389,
        "delta": 0.1451
      },
      {
        "periodo": 202511,
        "valor": 24.0185,
        "delta": -0.0205
      },
      {
        "periodo": 202512,
        "valor": 24.8452,
        "delta": 0.8267
      },
      {
        "periodo": 202601,
        "valor": 27.2741,
        "delta": 2.4289
      },
      {
        "periodo": 202602,
        "valor": 26.2459,
        "delta": -1.0282
      },
      {
        "periodo": 202603,
        "valor": 25.6857,
        "delta": -0.5603
      },
      {
        "periodo": 202604,
        "valor": 25.3535,
        "delta": -0.3321
      },
      {
        "periodo": 202605,
        "valor": 26.3405,
        "delta": 0.987
      },
      {
        "periodo": 202606,
        "valor": 26.9484,
        "delta": 0.6079
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 10.420217,
    "valor_anterior": 10.421698,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 10.2956,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 10.4773,
        "delta": 0.1817
      },
      {
        "periodo": 202508,
        "valor": 10.0984,
        "delta": -0.3789
      },
      {
        "periodo": 202509,
        "valor": 10.2756,
        "delta": 0.1772
      },
      {
        "periodo": 202510,
        "valor": 10.2239,
        "delta": -0.0517
      },
      {
        "periodo": 202511,
        "valor": 10.2334,
        "delta": 0.0095
      },
      {
        "periodo": 202512,
        "valor": 10.5179,
        "delta": 0.2845
      },
      {
        "periodo": 202601,
        "valor": 10.2934,
        "delta": -0.2245
      },
      {
        "periodo": 202602,
        "valor": 10.4841,
        "delta": 0.1907
      },
      {
        "periodo": 202603,
        "valor": 10.3763,
        "delta": -0.1078
      },
      {
        "periodo": 202604,
        "valor": 10.3661,
        "delta": -0.0102
      },
      {
        "periodo": 202605,
        "valor": 10.4217,
        "delta": 0.0556
      },
      {
        "periodo": 202606,
        "valor": 10.4202,
        "delta": -0.0015
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 14.496003,
    "valor_anterior": 13.327347,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 13.1196,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 13.3375,
        "delta": 0.2178
      },
      {
        "periodo": 202508,
        "valor": 13.1891,
        "delta": -0.1483
      },
      {
        "periodo": 202509,
        "valor": 13.3074,
        "delta": 0.1183
      },
      {
        "periodo": 202510,
        "valor": 13.1392,
        "delta": -0.1682
      },
      {
        "periodo": 202511,
        "valor": 13.2826,
        "delta": 0.1434
      },
      {
        "periodo": 202512,
        "valor": 13.3065,
        "delta": 0.024
      },
      {
        "periodo": 202601,
        "valor": 13.1193,
        "delta": -0.1872
      },
      {
        "periodo": 202602,
        "valor": 13.0093,
        "delta": -0.11
      },
      {
        "periodo": 202603,
        "valor": 13.1732,
        "delta": 0.1639
      },
      {
        "periodo": 202604,
        "valor": 13.1441,
        "delta": -0.0291
      },
      {
        "periodo": 202605,
        "valor": 13.3273,
        "delta": 0.1832
      },
      {
        "periodo": 202606,
        "valor": 14.496,
        "delta": 1.1687
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 18.922258,
    "valor_anterior": 20.626204,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17.209,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17.8098,
        "delta": 0.6008
      },
      {
        "periodo": 202508,
        "valor": 17.5572,
        "delta": -0.2526
      },
      {
        "periodo": 202509,
        "valor": 17.6519,
        "delta": 0.0947
      },
      {
        "periodo": 202510,
        "valor": 16.8404,
        "delta": -0.8114
      },
      {
        "periodo": 202511,
        "valor": 17.608,
        "delta": 0.7675
      },
      {
        "periodo": 202512,
        "valor": 17.3077,
        "delta": -0.3003
      },
      {
        "periodo": 202601,
        "valor": 17.9794,
        "delta": 0.6716
      },
      {
        "periodo": 202602,
        "valor": 18.1251,
        "delta": 0.1457
      },
      {
        "periodo": 202603,
        "valor": 19.1888,
        "delta": 1.0637
      },
      {
        "periodo": 202604,
        "valor": 19.7264,
        "delta": 0.5376
      },
      {
        "periodo": 202605,
        "valor": 20.6262,
        "delta": 0.8998
      },
      {
        "periodo": 202606,
        "valor": 18.9223,
        "delta": -1.7039
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 14.497175,
    "valor_anterior": 14.254349,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.5945,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.5426,
        "delta": -0.0519
      },
      {
        "periodo": 202508,
        "valor": 14.7506,
        "delta": 0.208
      },
      {
        "periodo": 202509,
        "valor": 14.7005,
        "delta": -0.0501
      },
      {
        "periodo": 202510,
        "valor": 14.3667,
        "delta": -0.3338
      },
      {
        "periodo": 202511,
        "valor": 14.268,
        "delta": -0.0988
      },
      {
        "periodo": 202512,
        "valor": 14.4947,
        "delta": 0.2268
      },
      {
        "periodo": 202601,
        "valor": 14.3998,
        "delta": -0.0949
      },
      {
        "periodo": 202602,
        "valor": 14.4095,
        "delta": 0.0098
      },
      {
        "periodo": 202603,
        "valor": 14.3944,
        "delta": -0.0151
      },
      {
        "periodo": 202604,
        "valor": 14.2624,
        "delta": -0.1321
      },
      {
        "periodo": 202605,
        "valor": 14.2543,
        "delta": -0.008
      },
      {
        "periodo": 202606,
        "valor": 14.4972,
        "delta": 0.2428
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 39.252642,
    "valor_anterior": 42.519533,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 40.1226,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 35.3222,
        "delta": -4.8004
      },
      {
        "periodo": 202508,
        "valor": 35.5693,
        "delta": 0.2471
      },
      {
        "periodo": 202509,
        "valor": 37.3707,
        "delta": 1.8014
      },
      {
        "periodo": 202510,
        "valor": 37.7051,
        "delta": 0.3344
      },
      {
        "periodo": 202511,
        "valor": 38.0986,
        "delta": 0.3936
      },
      {
        "periodo": 202512,
        "valor": 39.5485,
        "delta": 1.4499
      },
      {
        "periodo": 202601,
        "valor": 39.6602,
        "delta": 0.1117
      },
      {
        "periodo": 202602,
        "valor": 40.7559,
        "delta": 1.0956
      },
      {
        "periodo": 202603,
        "valor": 41.799,
        "delta": 1.0432
      },
      {
        "periodo": 202604,
        "valor": 40.018,
        "delta": -1.781
      },
      {
        "periodo": 202605,
        "valor": 42.5195,
        "delta": 2.5015
      },
      {
        "periodo": 202606,
        "valor": 39.2526,
        "delta": -3.2669
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 77.662476,
    "valor_anterior": 77.914641,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 100.1696,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 92.4583,
        "delta": -7.7113
      },
      {
        "periodo": 202508,
        "valor": 91.8433,
        "delta": -0.6149
      },
      {
        "periodo": 202509,
        "valor": 94.165,
        "delta": 2.3217
      },
      {
        "periodo": 202510,
        "valor": 92.41,
        "delta": -1.755
      },
      {
        "periodo": 202511,
        "valor": 117.1074,
        "delta": 24.6974
      },
      {
        "periodo": 202512,
        "valor": 98.1728,
        "delta": -18.9346
      },
      {
        "periodo": 202601,
        "valor": 99.0308,
        "delta": 0.858
      },
      {
        "periodo": 202602,
        "valor": 88.816,
        "delta": -10.2148
      },
      {
        "periodo": 202603,
        "valor": 86.1066,
        "delta": -2.7094
      },
      {
        "periodo": 202604,
        "valor": 84.4744,
        "delta": -1.6322
      },
      {
        "periodo": 202605,
        "valor": 77.9146,
        "delta": -6.5597
      },
      {
        "periodo": 202606,
        "valor": 77.6625,
        "delta": -0.2522
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 37.285634,
    "valor_anterior": 42.094391,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 44.3286,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 45.3285,
        "delta": 0.9999
      },
      {
        "periodo": 202508,
        "valor": 45.2865,
        "delta": -0.042
      },
      {
        "periodo": 202509,
        "valor": 47.0522,
        "delta": 1.7657
      },
      {
        "periodo": 202510,
        "valor": 45.1121,
        "delta": -1.9401
      },
      {
        "periodo": 202511,
        "valor": 45.9127,
        "delta": 0.8006
      },
      {
        "periodo": 202512,
        "valor": 46.7138,
        "delta": 0.801
      },
      {
        "periodo": 202601,
        "valor": 44.1823,
        "delta": -2.5314
      },
      {
        "periodo": 202602,
        "valor": 46.7154,
        "delta": 2.533
      },
      {
        "periodo": 202603,
        "valor": 46.7028,
        "delta": -0.0125
      },
      {
        "periodo": 202604,
        "valor": 43.9485,
        "delta": -2.7543
      },
      {
        "periodo": 202605,
        "valor": 42.0944,
        "delta": -1.8541
      },
      {
        "periodo": 202606,
        "valor": 37.2856,
        "delta": -4.8088
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 180.722184,
    "valor_anterior": 177.311815,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 186.3145,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 181.6656,
        "delta": -4.6489
      },
      {
        "periodo": 202508,
        "valor": 175.3321,
        "delta": -6.3335
      },
      {
        "periodo": 202509,
        "valor": 177.7638,
        "delta": 2.4317
      },
      {
        "periodo": 202510,
        "valor": 188.0415,
        "delta": 10.2777
      },
      {
        "periodo": 202511,
        "valor": 189.1332,
        "delta": 1.0917
      },
      {
        "periodo": 202512,
        "valor": 181.9149,
        "delta": -7.2184
      },
      {
        "periodo": 202601,
        "valor": 190.0711,
        "delta": 8.1562
      },
      {
        "periodo": 202602,
        "valor": 198.1733,
        "delta": 8.1022
      },
      {
        "periodo": 202603,
        "valor": 137.7821,
        "delta": -60.3912
      },
      {
        "periodo": 202604,
        "valor": 198.4457,
        "delta": 60.6637
      },
      {
        "periodo": 202605,
        "valor": 177.3118,
        "delta": -21.1339
      },
      {
        "periodo": 202606,
        "valor": 180.7222,
        "delta": 3.4104
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 43.016542,
    "valor_anterior": 45.110123,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 41.9366,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 41.0094,
        "delta": -0.9272
      },
      {
        "periodo": 202508,
        "valor": 44.7076,
        "delta": 3.6982
      },
      {
        "periodo": 202509,
        "valor": 44.7598,
        "delta": 0.0522
      },
      {
        "periodo": 202510,
        "valor": 43.7815,
        "delta": -0.9783
      },
      {
        "periodo": 202511,
        "valor": 42.6855,
        "delta": -1.096
      },
      {
        "periodo": 202512,
        "valor": 43.7264,
        "delta": 1.041
      },
      {
        "periodo": 202601,
        "valor": 45.2539,
        "delta": 1.5274
      },
      {
        "periodo": 202602,
        "valor": 44.4004,
        "delta": -0.8535
      },
      {
        "periodo": 202603,
        "valor": 43.2581,
        "delta": -1.1422
      },
      {
        "periodo": 202604,
        "valor": 42.8861,
        "delta": -0.372
      },
      {
        "periodo": 202605,
        "valor": 45.1101,
        "delta": 2.224
      },
      {
        "periodo": 202606,
        "valor": 43.0165,
        "delta": -2.0936
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 66.919122,
    "valor_anterior": 62.143617,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 62.363,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 65.5945,
        "delta": 3.2315
      },
      {
        "periodo": 202508,
        "valor": 73.6443,
        "delta": 8.0499
      },
      {
        "periodo": 202509,
        "valor": 69.454,
        "delta": -4.1903
      },
      {
        "periodo": 202510,
        "valor": 75.1448,
        "delta": 5.6908
      },
      {
        "periodo": 202511,
        "valor": 64.8629,
        "delta": -10.2819
      },
      {
        "periodo": 202512,
        "valor": 64.0557,
        "delta": -0.8073
      },
      {
        "periodo": 202601,
        "valor": 81.3131,
        "delta": 17.2574
      },
      {
        "periodo": 202602,
        "valor": 67.4916,
        "delta": -13.8214
      },
      {
        "periodo": 202603,
        "valor": 68.8513,
        "delta": 1.3597
      },
      {
        "periodo": 202604,
        "valor": 56.0489,
        "delta": -12.8024
      },
      {
        "periodo": 202605,
        "valor": 62.1436,
        "delta": 6.0947
      },
      {
        "periodo": 202606,
        "valor": 66.9191,
        "delta": 4.7755
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 271.508727,
    "valor_anterior": 272.508451,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 277.5415,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 259.1889,
        "delta": -18.3526
      },
      {
        "periodo": 202508,
        "valor": 235.9528,
        "delta": -23.2361
      },
      {
        "periodo": 202509,
        "valor": 252.858,
        "delta": 16.9052
      },
      {
        "periodo": 202510,
        "valor": 259.7231,
        "delta": 6.8651
      },
      {
        "periodo": 202511,
        "valor": 283.3879,
        "delta": 23.6649
      },
      {
        "periodo": 202512,
        "valor": 282.2096,
        "delta": -1.1783
      },
      {
        "periodo": 202601,
        "valor": 273.6223,
        "delta": -8.5874
      },
      {
        "periodo": 202602,
        "valor": 257.0268,
        "delta": -16.5955
      },
      {
        "periodo": 202603,
        "valor": 259.9473,
        "delta": 2.9205
      },
      {
        "periodo": 202604,
        "valor": 266.4028,
        "delta": 6.4555
      },
      {
        "periodo": 202605,
        "valor": 272.5085,
        "delta": 6.1056
      },
      {
        "periodo": 202606,
        "valor": 271.5087,
        "delta": -0.9997
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 14.212221,
    "valor_anterior": 13.965013,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 462.2699,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 448.1859,
        "delta": -14.084
      },
      {
        "periodo": 202508,
        "valor": 436.8538,
        "delta": -11.3321
      },
      {
        "periodo": 202509,
        "valor": 445.6019,
        "delta": 8.7481
      },
      {
        "periodo": 202510,
        "valor": 438.3887,
        "delta": -7.2132
      },
      {
        "periodo": 202511,
        "valor": 438.5138,
        "delta": 0.1251
      },
      {
        "periodo": 202512,
        "valor": 446.1839,
        "delta": 7.6702
      },
      {
        "periodo": 202601,
        "valor": 503.5945,
        "delta": 57.4106
      },
      {
        "periodo": 202602,
        "valor": 17.2959,
        "delta": -486.2987
      },
      {
        "periodo": 202603,
        "valor": 14.7688,
        "delta": -2.5271
      },
      {
        "periodo": 202604,
        "valor": 13.8709,
        "delta": -0.8979
      },
      {
        "periodo": 202605,
        "valor": 13.965,
        "delta": 0.0941
      },
      {
        "periodo": 202606,
        "valor": 14.2122,
        "delta": 0.2472
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 47.927958,
    "valor_anterior": 24.90719,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 209.6044,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 155.4786,
        "delta": -54.1258
      },
      {
        "periodo": 202508,
        "valor": 102.481,
        "delta": -52.9977
      },
      {
        "periodo": 202509,
        "valor": 74.6565,
        "delta": -27.8245
      },
      {
        "periodo": 202510,
        "valor": 49.6888,
        "delta": -24.9677
      },
      {
        "periodo": 202511,
        "valor": 34.9345,
        "delta": -14.7542
      },
      {
        "periodo": 202512,
        "valor": 41.0296,
        "delta": 6.0951
      },
      {
        "periodo": 202601,
        "valor": 58.0884,
        "delta": 17.0588
      },
      {
        "periodo": 202602,
        "valor": 46.9142,
        "delta": -11.1742
      },
      {
        "periodo": 202603,
        "valor": 29.2281,
        "delta": -17.686
      },
      {
        "periodo": 202604,
        "valor": 29.689,
        "delta": 0.4608
      },
      {
        "periodo": 202605,
        "valor": 24.9072,
        "delta": -4.7818
      },
      {
        "periodo": 202606,
        "valor": 47.928,
        "delta": 23.0208
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 146.418598,
    "valor_anterior": 162.072283,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 447.1,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 251.6406,
        "delta": -195.4595
      },
      {
        "periodo": 202601,
        "valor": 179.1417,
        "delta": -72.4988
      },
      {
        "periodo": 202602,
        "valor": 140.4063,
        "delta": -38.7355
      },
      {
        "periodo": 202603,
        "valor": 141.5845,
        "delta": 1.1783
      },
      {
        "periodo": 202604,
        "valor": 166.0869,
        "delta": 24.5024
      },
      {
        "periodo": 202605,
        "valor": 162.0723,
        "delta": -4.0146
      },
      {
        "periodo": 202606,
        "valor": 146.4186,
        "delta": -15.6537
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 24.068547,
    "valor_anterior": 18.305359,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 20.6747,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 19.559,
        "delta": -1.1157
      },
      {
        "periodo": 202605,
        "valor": 18.3054,
        "delta": -1.2536
      },
      {
        "periodo": 202606,
        "valor": 24.0685,
        "delta": 5.7632
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 16.988415,
    "valor_anterior": 17.127994,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 16.5832,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 16.8123,
        "delta": 0.2291
      },
      {
        "periodo": 202508,
        "valor": 16.9631,
        "delta": 0.1508
      },
      {
        "periodo": 202509,
        "valor": 17.083,
        "delta": 0.1199
      },
      {
        "periodo": 202510,
        "valor": 17.1859,
        "delta": 0.1028
      },
      {
        "periodo": 202511,
        "valor": 16.8576,
        "delta": -0.3282
      },
      {
        "periodo": 202512,
        "valor": 16.8501,
        "delta": -0.0075
      },
      {
        "periodo": 202601,
        "valor": 16.9636,
        "delta": 0.1135
      },
      {
        "periodo": 202602,
        "valor": 17.1872,
        "delta": 0.2236
      },
      {
        "periodo": 202603,
        "valor": 17.1331,
        "delta": -0.0541
      },
      {
        "periodo": 202604,
        "valor": 17.028,
        "delta": -0.1052
      },
      {
        "periodo": 202605,
        "valor": 17.128,
        "delta": 0.1
      },
      {
        "periodo": 202606,
        "valor": 16.9884,
        "delta": -0.1396
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 16.104097,
    "valor_anterior": 16.369484,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 15.8209,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 16.0415,
        "delta": 0.2206
      },
      {
        "periodo": 202508,
        "valor": 16.2356,
        "delta": 0.1941
      },
      {
        "periodo": 202509,
        "valor": 16.2223,
        "delta": -0.0133
      },
      {
        "periodo": 202510,
        "valor": 16.3459,
        "delta": 0.1235
      },
      {
        "periodo": 202511,
        "valor": 16.0681,
        "delta": -0.2777
      },
      {
        "periodo": 202512,
        "valor": 15.8706,
        "delta": -0.1975
      },
      {
        "periodo": 202601,
        "valor": 16.0284,
        "delta": 0.1578
      },
      {
        "periodo": 202602,
        "valor": 16.4001,
        "delta": 0.3718
      },
      {
        "periodo": 202603,
        "valor": 16.3039,
        "delta": -0.0962
      },
      {
        "periodo": 202604,
        "valor": 16.2511,
        "delta": -0.0529
      },
      {
        "periodo": 202605,
        "valor": 16.3695,
        "delta": 0.1184
      },
      {
        "periodo": 202606,
        "valor": 16.1041,
        "delta": -0.2654
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 20.462821,
    "valor_anterior": 20.864559,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 16.7041,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18.6919,
        "delta": 1.9878
      },
      {
        "periodo": 202508,
        "valor": 20.8357,
        "delta": 2.1437
      },
      {
        "periodo": 202509,
        "valor": 22.6947,
        "delta": 1.859
      },
      {
        "periodo": 202510,
        "valor": 24.6638,
        "delta": 1.9691
      },
      {
        "periodo": 202511,
        "valor": 20.2447,
        "delta": -4.4191
      },
      {
        "periodo": 202512,
        "valor": 19.958,
        "delta": -0.2866
      },
      {
        "periodo": 202601,
        "valor": 19.8963,
        "delta": -0.0617
      },
      {
        "periodo": 202602,
        "valor": 20.5357,
        "delta": 0.6394
      },
      {
        "periodo": 202603,
        "valor": 21.2613,
        "delta": 0.7256
      },
      {
        "periodo": 202604,
        "valor": 19.7453,
        "delta": -1.516
      },
      {
        "periodo": 202605,
        "valor": 20.8646,
        "delta": 1.1193
      },
      {
        "periodo": 202606,
        "valor": 20.4628,
        "delta": -0.4017
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 25.677205,
    "valor_anterior": 25.595602,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 23.4286,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 24.0072,
        "delta": 0.5787
      },
      {
        "periodo": 202508,
        "valor": 23.686,
        "delta": -0.3212
      },
      {
        "periodo": 202509,
        "valor": 24.4219,
        "delta": 0.7359
      },
      {
        "periodo": 202510,
        "valor": 24.2623,
        "delta": -0.1596
      },
      {
        "periodo": 202511,
        "valor": 24.1296,
        "delta": -0.1327
      },
      {
        "periodo": 202512,
        "valor": 25.9087,
        "delta": 1.779
      },
      {
        "periodo": 202601,
        "valor": 25.5747,
        "delta": -0.334
      },
      {
        "periodo": 202602,
        "valor": 24.6026,
        "delta": -0.9721
      },
      {
        "periodo": 202603,
        "valor": 24.911,
        "delta": 0.3084
      },
      {
        "periodo": 202604,
        "valor": 24.961,
        "delta": 0.05
      },
      {
        "periodo": 202605,
        "valor": 25.5956,
        "delta": 0.6346
      },
      {
        "periodo": 202606,
        "valor": 25.6772,
        "delta": 0.0816
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 14.805269,
    "valor_anterior": 14.78907,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 14.5749,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 14.688,
        "delta": 0.1131
      },
      {
        "periodo": 202508,
        "valor": 15.0786,
        "delta": 0.3906
      },
      {
        "periodo": 202509,
        "valor": 15.1748,
        "delta": 0.0963
      },
      {
        "periodo": 202510,
        "valor": 15.25,
        "delta": 0.0751
      },
      {
        "periodo": 202511,
        "valor": 15.0206,
        "delta": -0.2294
      },
      {
        "periodo": 202512,
        "valor": 15.086,
        "delta": 0.0654
      },
      {
        "periodo": 202601,
        "valor": 15.3523,
        "delta": 0.2663
      },
      {
        "periodo": 202602,
        "valor": 15.5927,
        "delta": 0.2403
      },
      {
        "periodo": 202603,
        "valor": 15.3675,
        "delta": -0.2251
      },
      {
        "periodo": 202604,
        "valor": 14.8639,
        "delta": -0.5037
      },
      {
        "periodo": 202605,
        "valor": 14.7891,
        "delta": -0.0748
      },
      {
        "periodo": 202606,
        "valor": 14.8053,
        "delta": 0.0162
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 18.694281,
    "valor_anterior": 18.654608,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 20.3215,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 19.9166,
        "delta": -0.4049
      },
      {
        "periodo": 202508,
        "valor": 19.492,
        "delta": -0.4246
      },
      {
        "periodo": 202509,
        "valor": 19.4242,
        "delta": -0.0678
      },
      {
        "periodo": 202510,
        "valor": 19.465,
        "delta": 0.0408
      },
      {
        "periodo": 202511,
        "valor": 18.9901,
        "delta": -0.4749
      },
      {
        "periodo": 202512,
        "valor": 18.7833,
        "delta": -0.2068
      },
      {
        "periodo": 202601,
        "valor": 18.8364,
        "delta": 0.0531
      },
      {
        "periodo": 202602,
        "valor": 18.904,
        "delta": 0.0676
      },
      {
        "periodo": 202603,
        "valor": 19.034,
        "delta": 0.13
      },
      {
        "periodo": 202604,
        "valor": 18.7681,
        "delta": -0.2659
      },
      {
        "periodo": 202605,
        "valor": 18.6546,
        "delta": -0.1135
      },
      {
        "periodo": 202606,
        "valor": 18.6943,
        "delta": 0.0397
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 4021755,
    "label": "CCF Jun 2026",
    "valor_actual": 17.458222,
    "valor_anterior": 16.733794,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17.5156,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 17.2093,
        "delta": -0.3063
      },
      {
        "periodo": 202508,
        "valor": 16.5693,
        "delta": -0.6399
      },
      {
        "periodo": 202509,
        "valor": 17.2511,
        "delta": 0.6817
      },
      {
        "periodo": 202510,
        "valor": 17.2931,
        "delta": 0.042
      },
      {
        "periodo": 202511,
        "valor": 16.9696,
        "delta": -0.3235
      },
      {
        "periodo": 202512,
        "valor": 17.3472,
        "delta": 0.3776
      },
      {
        "periodo": 202601,
        "valor": 17.316,
        "delta": -0.0312
      },
      {
        "periodo": 202602,
        "valor": 17.0636,
        "delta": -0.2524
      },
      {
        "periodo": 202603,
        "valor": 17.1799,
        "delta": 0.1162
      },
      {
        "periodo": 202604,
        "valor": 17.0917,
        "delta": -0.0882
      },
      {
        "periodo": 202605,
        "valor": 16.7338,
        "delta": -0.3579
      },
      {
        "periodo": 202606,
        "valor": 17.4582,
        "delta": 0.7244
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 3.319591,
    "valor_anterior": 3.301784,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": 3.3018,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": 3.3196,
        "delta": 0.0178
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 3.410414,
    "valor_anterior": 3.427768,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 3.9038,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3.8423,
        "delta": -0.0615
      },
      {
        "periodo": 202508,
        "valor": 3.8028,
        "delta": -0.0395
      },
      {
        "periodo": 202509,
        "valor": 3.7208,
        "delta": -0.082
      },
      {
        "periodo": 202510,
        "valor": 3.7092,
        "delta": -0.0116
      },
      {
        "periodo": 202511,
        "valor": 3.6337,
        "delta": -0.0755
      },
      {
        "periodo": 202512,
        "valor": 3.6704,
        "delta": 0.0367
      },
      {
        "periodo": 202601,
        "valor": 3.4888,
        "delta": -0.1816
      },
      {
        "periodo": 202602,
        "valor": 3.4929,
        "delta": 0.0041
      },
      {
        "periodo": 202603,
        "valor": 3.6404,
        "delta": 0.1475
      },
      {
        "periodo": 202604,
        "valor": 3.5097,
        "delta": -0.1306
      },
      {
        "periodo": 202605,
        "valor": 3.4278,
        "delta": -0.082
      },
      {
        "periodo": 202606,
        "valor": 3.4104,
        "delta": -0.0174
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 4.23648,
    "valor_anterior": 4.230889,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5.4851,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 5.6848,
        "delta": 0.1997
      },
      {
        "periodo": 202508,
        "valor": 5.3354,
        "delta": -0.3494
      },
      {
        "periodo": 202509,
        "valor": 5.2151,
        "delta": -0.1202
      },
      {
        "periodo": 202510,
        "valor": 4.8614,
        "delta": -0.3537
      },
      {
        "periodo": 202511,
        "valor": 4.7958,
        "delta": -0.0657
      },
      {
        "periodo": 202512,
        "valor": 4.7102,
        "delta": -0.0856
      },
      {
        "periodo": 202601,
        "valor": 4.5963,
        "delta": -0.1139
      },
      {
        "periodo": 202602,
        "valor": 4.5244,
        "delta": -0.0719
      },
      {
        "periodo": 202603,
        "valor": 4.6368,
        "delta": 0.1124
      },
      {
        "periodo": 202604,
        "valor": 4.1577,
        "delta": -0.4791
      },
      {
        "periodo": 202605,
        "valor": 4.2309,
        "delta": 0.0732
      },
      {
        "periodo": 202606,
        "valor": 4.2365,
        "delta": 0.0056
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 6.295248,
    "valor_anterior": 6.474787,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5.5892,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 5.688,
        "delta": 0.0988
      },
      {
        "periodo": 202508,
        "valor": 5.666,
        "delta": -0.022
      },
      {
        "periodo": 202509,
        "valor": 5.5556,
        "delta": -0.1104
      },
      {
        "periodo": 202510,
        "valor": 6.7174,
        "delta": 1.1618
      },
      {
        "periodo": 202511,
        "valor": 6.7414,
        "delta": 0.0239
      },
      {
        "periodo": 202512,
        "valor": 6.5462,
        "delta": -0.1952
      },
      {
        "periodo": 202601,
        "valor": 6.4598,
        "delta": -0.0864
      },
      {
        "periodo": 202602,
        "valor": 6.3736,
        "delta": -0.0862
      },
      {
        "periodo": 202603,
        "valor": 6.5039,
        "delta": 0.1303
      },
      {
        "periodo": 202604,
        "valor": 6.42,
        "delta": -0.0839
      },
      {
        "periodo": 202605,
        "valor": 6.4748,
        "delta": 0.0548
      },
      {
        "periodo": 202606,
        "valor": 6.2952,
        "delta": -0.1795
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.237,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.2433,
        "delta": 0.0063
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -0.2433
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.054624,
    "valor_anterior": 0.038631,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.1168,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.1454,
        "delta": 0.0287
      },
      {
        "periodo": 202508,
        "valor": 0.1132,
        "delta": -0.0322
      },
      {
        "periodo": 202509,
        "valor": 0.0784,
        "delta": -0.0349
      },
      {
        "periodo": 202510,
        "valor": 0.0814,
        "delta": 0.0031
      },
      {
        "periodo": 202511,
        "valor": 0.0874,
        "delta": 0.006
      },
      {
        "periodo": 202512,
        "valor": 0.0667,
        "delta": -0.0208
      },
      {
        "periodo": 202601,
        "valor": 0.0687,
        "delta": 0.0021
      },
      {
        "periodo": 202602,
        "valor": 0.0624,
        "delta": -0.0063
      },
      {
        "periodo": 202603,
        "valor": 0.117,
        "delta": 0.0546
      },
      {
        "periodo": 202604,
        "valor": 0.0204,
        "delta": -0.0967
      },
      {
        "periodo": 202605,
        "valor": 0.0386,
        "delta": 0.0183
      },
      {
        "periodo": 202606,
        "valor": 0.0546,
        "delta": 0.016
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.000773,
    "valor_anterior": 0.00077,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.0009,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.0009,
        "delta": -0.0
      },
      {
        "periodo": 202508,
        "valor": 0.0009,
        "delta": -0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0008,
        "delta": -0.0001
      },
      {
        "periodo": 202510,
        "valor": 0.0008,
        "delta": -0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0008,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0008,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0008,
        "delta": -0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0008,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0008,
        "delta": -0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0008,
        "delta": -0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0008,
        "delta": -0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0008,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.001643,
    "valor_anterior": 0.001645,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.0028,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.003,
        "delta": 0.0002
      },
      {
        "periodo": 202508,
        "valor": 0.0029,
        "delta": -0.0001
      },
      {
        "periodo": 202509,
        "valor": 0.0029,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.003,
        "delta": 0.0001
      },
      {
        "periodo": 202511,
        "valor": 0.0015,
        "delta": -0.0015
      },
      {
        "periodo": 202512,
        "valor": 0.0016,
        "delta": 0.0001
      },
      {
        "periodo": 202601,
        "valor": 0.0016,
        "delta": 0.0001
      },
      {
        "periodo": 202602,
        "valor": 0.0015,
        "delta": -0.0002
      },
      {
        "periodo": 202603,
        "valor": 0.001,
        "delta": -0.0005
      },
      {
        "periodo": 202604,
        "valor": 0.0015,
        "delta": 0.0005
      },
      {
        "periodo": 202605,
        "valor": 0.0016,
        "delta": 0.0001
      },
      {
        "periodo": 202606,
        "valor": 0.0016,
        "delta": -0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.0,
    "valor_anterior": 0.002049,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 0.0664,
        "delta": 0.0664
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -0.0664
      },
      {
        "periodo": 202510,
        "valor": 0.3526,
        "delta": 0.3526
      },
      {
        "periodo": 202511,
        "valor": 0.3106,
        "delta": -0.0419
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": -0.3106
      },
      {
        "periodo": 202601,
        "valor": 0.0231,
        "delta": 0.0231
      },
      {
        "periodo": 202602,
        "valor": 0.0639,
        "delta": 0.0408
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": -0.0639
      },
      {
        "periodo": 202604,
        "valor": 0.002,
        "delta": 0.002
      },
      {
        "periodo": 202605,
        "valor": 0.002,
        "delta": 0.0001
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": -0.002
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 4.210645,
    "valor_anterior": 4.027977,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 3.8956,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3.921,
        "delta": 0.0254
      },
      {
        "periodo": 202508,
        "valor": 3.881,
        "delta": -0.04
      },
      {
        "periodo": 202509,
        "valor": 3.8763,
        "delta": -0.0047
      },
      {
        "periodo": 202510,
        "valor": 3.8224,
        "delta": -0.0539
      },
      {
        "periodo": 202511,
        "valor": 3.951,
        "delta": 0.1286
      },
      {
        "periodo": 202512,
        "valor": 4.1663,
        "delta": 0.2154
      },
      {
        "periodo": 202601,
        "valor": 4.103,
        "delta": -0.0634
      },
      {
        "periodo": 202602,
        "valor": 4.1253,
        "delta": 0.0223
      },
      {
        "periodo": 202603,
        "valor": 4.1649,
        "delta": 0.0397
      },
      {
        "periodo": 202604,
        "valor": 4.1091,
        "delta": -0.0558
      },
      {
        "periodo": 202605,
        "valor": 4.028,
        "delta": -0.0812
      },
      {
        "periodo": 202606,
        "valor": 4.2106,
        "delta": 0.1827
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.413233,
    "valor_anterior": 0.403431,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.2038,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.2122,
        "delta": 0.0084
      },
      {
        "periodo": 202508,
        "valor": 0.2074,
        "delta": -0.0048
      },
      {
        "periodo": 202509,
        "valor": 0.2048,
        "delta": -0.0026
      },
      {
        "periodo": 202510,
        "valor": 0.2041,
        "delta": -0.0007
      },
      {
        "periodo": 202511,
        "valor": 0.3656,
        "delta": 0.1615
      },
      {
        "periodo": 202512,
        "valor": 0.4026,
        "delta": 0.0371
      },
      {
        "periodo": 202601,
        "valor": 0.3771,
        "delta": -0.0255
      },
      {
        "periodo": 202602,
        "valor": 0.382,
        "delta": 0.0049
      },
      {
        "periodo": 202603,
        "valor": 0.4064,
        "delta": 0.0244
      },
      {
        "periodo": 202604,
        "valor": 0.4059,
        "delta": -0.0005
      },
      {
        "periodo": 202605,
        "valor": 0.4034,
        "delta": -0.0024
      },
      {
        "periodo": 202606,
        "valor": 0.4132,
        "delta": 0.0098
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.1196,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.1156,
        "delta": -0.0039
      },
      {
        "periodo": 202508,
        "valor": 0.093,
        "delta": -0.0227
      },
      {
        "periodo": 202509,
        "valor": 0.0697,
        "delta": -0.0232
      },
      {
        "periodo": 202510,
        "valor": 0.0193,
        "delta": -0.0504
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": -0.0193
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 0.0021,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 0.0068,
        "delta": 0.0046
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": -0.0068
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.458418,
    "valor_anterior": 0.456876,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.5287,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.4755,
        "delta": -0.0532
      },
      {
        "periodo": 202508,
        "valor": 0.461,
        "delta": -0.0146
      },
      {
        "periodo": 202509,
        "valor": 0.5158,
        "delta": 0.0548
      },
      {
        "periodo": 202510,
        "valor": 0.4912,
        "delta": -0.0246
      },
      {
        "periodo": 202511,
        "valor": 0.5301,
        "delta": 0.0389
      },
      {
        "periodo": 202512,
        "valor": 0.5286,
        "delta": -0.0015
      },
      {
        "periodo": 202601,
        "valor": 0.5695,
        "delta": 0.0409
      },
      {
        "periodo": 202602,
        "valor": 0.5651,
        "delta": -0.0044
      },
      {
        "periodo": 202603,
        "valor": 0.4875,
        "delta": -0.0776
      },
      {
        "periodo": 202604,
        "valor": 0.4911,
        "delta": 0.0036
      },
      {
        "periodo": 202605,
        "valor": 0.4569,
        "delta": -0.0342
      },
      {
        "periodo": 202606,
        "valor": 0.4584,
        "delta": 0.0015
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 2.679285,
    "valor_anterior": 2.824797,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.8057,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.7511,
        "delta": -0.0547
      },
      {
        "periodo": 202508,
        "valor": 2.7783,
        "delta": 0.0273
      },
      {
        "periodo": 202509,
        "valor": 2.6549,
        "delta": -0.1234
      },
      {
        "periodo": 202510,
        "valor": 2.5569,
        "delta": -0.098
      },
      {
        "periodo": 202511,
        "valor": 2.5725,
        "delta": 0.0157
      },
      {
        "periodo": 202512,
        "valor": 2.9413,
        "delta": 0.3687
      },
      {
        "periodo": 202601,
        "valor": 3.0231,
        "delta": 0.0818
      },
      {
        "periodo": 202602,
        "valor": 2.9893,
        "delta": -0.0338
      },
      {
        "periodo": 202603,
        "valor": 3.0408,
        "delta": 0.0515
      },
      {
        "periodo": 202604,
        "valor": 2.8857,
        "delta": -0.1551
      },
      {
        "periodo": 202605,
        "valor": 2.8248,
        "delta": -0.0609
      },
      {
        "periodo": 202606,
        "valor": 2.6793,
        "delta": -0.1455
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 4.730069,
    "valor_anterior": 4.790579,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5.1718,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 5.9345,
        "delta": 0.7628
      },
      {
        "periodo": 202508,
        "valor": 5.6011,
        "delta": -0.3334
      },
      {
        "periodo": 202509,
        "valor": 5.6412,
        "delta": 0.0401
      },
      {
        "periodo": 202510,
        "valor": 5.1199,
        "delta": -0.5212
      },
      {
        "periodo": 202511,
        "valor": 5.0037,
        "delta": -0.1162
      },
      {
        "periodo": 202512,
        "valor": 6.7987,
        "delta": 1.795
      },
      {
        "periodo": 202601,
        "valor": 5.8462,
        "delta": -0.9525
      },
      {
        "periodo": 202602,
        "valor": 4.9861,
        "delta": -0.8601
      },
      {
        "periodo": 202603,
        "valor": 5.4804,
        "delta": 0.4943
      },
      {
        "periodo": 202604,
        "valor": 4.9114,
        "delta": -0.5689
      },
      {
        "periodo": 202605,
        "valor": 4.7906,
        "delta": -0.1209
      },
      {
        "periodo": 202606,
        "valor": 4.7301,
        "delta": -0.0605
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1.042,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1.002,
        "delta": -0.0401
      },
      {
        "periodo": 202508,
        "valor": 1.5921,
        "delta": 0.5902
      },
      {
        "periodo": 202509,
        "valor": 1.6767,
        "delta": 0.0846
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 3.289577,
    "valor_anterior": 3.317348,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 3.6748,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3.6923,
        "delta": 0.0175
      },
      {
        "periodo": 202508,
        "valor": 3.6107,
        "delta": -0.0816
      },
      {
        "periodo": 202509,
        "valor": 3.4039,
        "delta": -0.2068
      },
      {
        "periodo": 202510,
        "valor": 3.3772,
        "delta": -0.0266
      },
      {
        "periodo": 202511,
        "valor": 3.1494,
        "delta": -0.2278
      },
      {
        "periodo": 202512,
        "valor": 3.4189,
        "delta": 0.2695
      },
      {
        "periodo": 202601,
        "valor": 3.4421,
        "delta": 0.0232
      },
      {
        "periodo": 202602,
        "valor": 3.4554,
        "delta": 0.0133
      },
      {
        "periodo": 202603,
        "valor": 3.3999,
        "delta": -0.0555
      },
      {
        "periodo": 202604,
        "valor": 3.3576,
        "delta": -0.0423
      },
      {
        "periodo": 202605,
        "valor": 3.3173,
        "delta": -0.0402
      },
      {
        "periodo": 202606,
        "valor": 3.2896,
        "delta": -0.0278
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 2.465639,
    "valor_anterior": 2.471994,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.9674,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.9429,
        "delta": -0.0246
      },
      {
        "periodo": 202508,
        "valor": 2.8074,
        "delta": -0.1355
      },
      {
        "periodo": 202509,
        "valor": 2.8406,
        "delta": 0.0332
      },
      {
        "periodo": 202510,
        "valor": 2.7259,
        "delta": -0.1147
      },
      {
        "periodo": 202511,
        "valor": 2.6738,
        "delta": -0.0521
      },
      {
        "periodo": 202512,
        "valor": 2.6917,
        "delta": 0.0179
      },
      {
        "periodo": 202601,
        "valor": 2.5806,
        "delta": -0.1111
      },
      {
        "periodo": 202602,
        "valor": 2.5924,
        "delta": 0.0118
      },
      {
        "periodo": 202603,
        "valor": 2.5587,
        "delta": -0.0337
      },
      {
        "periodo": 202604,
        "valor": 2.5109,
        "delta": -0.0478
      },
      {
        "periodo": 202605,
        "valor": 2.472,
        "delta": -0.0389
      },
      {
        "periodo": 202606,
        "valor": 2.4656,
        "delta": -0.0064
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.3686,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.3739,
        "delta": 0.0053
      },
      {
        "periodo": 202508,
        "valor": 0.361,
        "delta": -0.0129
      },
      {
        "periodo": 202509,
        "valor": 0.3532,
        "delta": -0.0078
      },
      {
        "periodo": 202510,
        "valor": 0.3287,
        "delta": -0.0245
      },
      {
        "periodo": 202511,
        "valor": 0.4481,
        "delta": 0.1194
      },
      {
        "periodo": 202512,
        "valor": 0.4342,
        "delta": -0.014
      },
      {
        "periodo": 202601,
        "valor": 0.4318,
        "delta": -0.0024
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -0.4318
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.086066,
    "valor_anterior": 0.098432,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.1414,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.1401,
        "delta": -0.0013
      },
      {
        "periodo": 202508,
        "valor": 0.1388,
        "delta": -0.0013
      },
      {
        "periodo": 202509,
        "valor": 0.1403,
        "delta": 0.0015
      },
      {
        "periodo": 202510,
        "valor": 0.133,
        "delta": -0.0073
      },
      {
        "periodo": 202511,
        "valor": 0.1258,
        "delta": -0.0072
      },
      {
        "periodo": 202512,
        "valor": 0.2483,
        "delta": 0.1225
      },
      {
        "periodo": 202601,
        "valor": 0.1034,
        "delta": -0.1448
      },
      {
        "periodo": 202602,
        "valor": 0.102,
        "delta": -0.0014
      },
      {
        "periodo": 202603,
        "valor": 0.1022,
        "delta": 0.0002
      },
      {
        "periodo": 202604,
        "valor": 0.0995,
        "delta": -0.0028
      },
      {
        "periodo": 202605,
        "valor": 0.0984,
        "delta": -0.001
      },
      {
        "periodo": 202606,
        "valor": 0.0861,
        "delta": -0.0124
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.032107,
    "valor_anterior": 0.036868,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.0888,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.0907,
        "delta": 0.0019
      },
      {
        "periodo": 202508,
        "valor": 0.0449,
        "delta": -0.0458
      },
      {
        "periodo": 202509,
        "valor": 0.0447,
        "delta": -0.0002
      },
      {
        "periodo": 202510,
        "valor": 0.0435,
        "delta": -0.0012
      },
      {
        "periodo": 202511,
        "valor": 0.0439,
        "delta": 0.0004
      },
      {
        "periodo": 202512,
        "valor": 0.0428,
        "delta": -0.0011
      },
      {
        "periodo": 202601,
        "valor": 0.0393,
        "delta": -0.0035
      },
      {
        "periodo": 202602,
        "valor": 0.0411,
        "delta": 0.0018
      },
      {
        "periodo": 202603,
        "valor": 0.0421,
        "delta": 0.0009
      },
      {
        "periodo": 202604,
        "valor": 0.0386,
        "delta": -0.0034
      },
      {
        "periodo": 202605,
        "valor": 0.0369,
        "delta": -0.0018
      },
      {
        "periodo": 202606,
        "valor": 0.0321,
        "delta": -0.0048
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.026017,
    "valor_anterior": 0.028607,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.0315,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.0292,
        "delta": -0.0023
      },
      {
        "periodo": 202508,
        "valor": 0.0315,
        "delta": 0.0024
      },
      {
        "periodo": 202509,
        "valor": 0.0311,
        "delta": -0.0005
      },
      {
        "periodo": 202510,
        "valor": 0.0309,
        "delta": -0.0002
      },
      {
        "periodo": 202511,
        "valor": 0.0298,
        "delta": -0.0011
      },
      {
        "periodo": 202512,
        "valor": 0.0285,
        "delta": -0.0013
      },
      {
        "periodo": 202601,
        "valor": 0.0287,
        "delta": 0.0001
      },
      {
        "periodo": 202602,
        "valor": 0.0279,
        "delta": -0.0008
      },
      {
        "periodo": 202603,
        "valor": 0.0282,
        "delta": 0.0004
      },
      {
        "periodo": 202604,
        "valor": 0.0274,
        "delta": -0.0009
      },
      {
        "periodo": 202605,
        "valor": 0.0286,
        "delta": 0.0012
      },
      {
        "periodo": 202606,
        "valor": 0.026,
        "delta": -0.0026
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.000807,
    "valor_anterior": 0.000801,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 0.0008,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 0.0007,
        "delta": -0.0001
      },
      {
        "periodo": 202605,
        "valor": 0.0008,
        "delta": 0.0001
      },
      {
        "periodo": 202606,
        "valor": 0.0008,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 2.051466,
    "valor_anterior": 2.076885,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.0875,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.0967,
        "delta": 0.0092
      },
      {
        "periodo": 202508,
        "valor": 2.0417,
        "delta": -0.0549
      },
      {
        "periodo": 202509,
        "valor": 2.0031,
        "delta": -0.0386
      },
      {
        "periodo": 202510,
        "valor": 2.0249,
        "delta": 0.0218
      },
      {
        "periodo": 202511,
        "valor": 2.0173,
        "delta": -0.0076
      },
      {
        "periodo": 202512,
        "valor": 2.0101,
        "delta": -0.0071
      },
      {
        "periodo": 202601,
        "valor": 1.9275,
        "delta": -0.0827
      },
      {
        "periodo": 202602,
        "valor": 1.8774,
        "delta": -0.0501
      },
      {
        "periodo": 202603,
        "valor": 1.9352,
        "delta": 0.0579
      },
      {
        "periodo": 202604,
        "valor": 1.8437,
        "delta": -0.0915
      },
      {
        "periodo": 202605,
        "valor": 2.0769,
        "delta": 0.2332
      },
      {
        "periodo": 202606,
        "valor": 2.0515,
        "delta": -0.0254
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 2.682918,
    "valor_anterior": 2.714745,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2.7237,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2.7329,
        "delta": 0.0092
      },
      {
        "periodo": 202508,
        "valor": 2.6709,
        "delta": -0.062
      },
      {
        "periodo": 202509,
        "valor": 2.609,
        "delta": -0.0619
      },
      {
        "periodo": 202510,
        "valor": 2.6434,
        "delta": 0.0344
      },
      {
        "periodo": 202511,
        "valor": 2.6388,
        "delta": -0.0047
      },
      {
        "periodo": 202512,
        "valor": 2.619,
        "delta": -0.0197
      },
      {
        "periodo": 202601,
        "valor": 2.5017,
        "delta": -0.1173
      },
      {
        "periodo": 202602,
        "valor": 2.4347,
        "delta": -0.067
      },
      {
        "periodo": 202603,
        "valor": 2.5168,
        "delta": 0.0821
      },
      {
        "periodo": 202604,
        "valor": 2.3992,
        "delta": -0.1176
      },
      {
        "periodo": 202605,
        "valor": 2.7147,
        "delta": 0.3155
      },
      {
        "periodo": 202606,
        "valor": 2.6829,
        "delta": -0.0318
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.2594,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.2728,
        "delta": 0.0134
      },
      {
        "periodo": 202508,
        "valor": 0.2988,
        "delta": 0.026
      },
      {
        "periodo": 202509,
        "valor": 0.3188,
        "delta": 0.02
      },
      {
        "periodo": 202510,
        "valor": 0.012,
        "delta": -0.3067
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": -0.012
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.477922,
    "valor_anterior": 0.479221,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.4713,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.4779,
        "delta": 0.0066
      },
      {
        "periodo": 202508,
        "valor": 0.4629,
        "delta": -0.015
      },
      {
        "periodo": 202509,
        "valor": 0.4725,
        "delta": 0.0096
      },
      {
        "periodo": 202510,
        "valor": 0.456,
        "delta": -0.0165
      },
      {
        "periodo": 202511,
        "valor": 0.4745,
        "delta": 0.0185
      },
      {
        "periodo": 202512,
        "valor": 0.5042,
        "delta": 0.0298
      },
      {
        "periodo": 202601,
        "valor": 0.4949,
        "delta": -0.0094
      },
      {
        "periodo": 202602,
        "valor": 0.4738,
        "delta": -0.0211
      },
      {
        "periodo": 202603,
        "valor": 0.4768,
        "delta": 0.003
      },
      {
        "periodo": 202604,
        "valor": 0.472,
        "delta": -0.0048
      },
      {
        "periodo": 202605,
        "valor": 0.4792,
        "delta": 0.0072
      },
      {
        "periodo": 202606,
        "valor": 0.4779,
        "delta": -0.0013
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.302008,
    "valor_anterior": 0.306163,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.3703,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.3744,
        "delta": 0.0041
      },
      {
        "periodo": 202508,
        "valor": 0.2854,
        "delta": -0.089
      },
      {
        "periodo": 202509,
        "valor": 0.2785,
        "delta": -0.0069
      },
      {
        "periodo": 202510,
        "valor": 0.2757,
        "delta": -0.0028
      },
      {
        "periodo": 202511,
        "valor": 0.2724,
        "delta": -0.0033
      },
      {
        "periodo": 202512,
        "valor": 0.3358,
        "delta": 0.0634
      },
      {
        "periodo": 202601,
        "valor": 0.3181,
        "delta": -0.0177
      },
      {
        "periodo": 202602,
        "valor": 0.3187,
        "delta": 0.0006
      },
      {
        "periodo": 202603,
        "valor": 0.3229,
        "delta": 0.0042
      },
      {
        "periodo": 202604,
        "valor": 0.3075,
        "delta": -0.0153
      },
      {
        "periodo": 202605,
        "valor": 0.3062,
        "delta": -0.0014
      },
      {
        "periodo": 202606,
        "valor": 0.302,
        "delta": -0.0042
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.710593,
    "valor_anterior": 0.724971,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.9567,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.9293,
        "delta": -0.0273
      },
      {
        "periodo": 202508,
        "valor": 0.9046,
        "delta": -0.0247
      },
      {
        "periodo": 202509,
        "valor": 0.8229,
        "delta": -0.0818
      },
      {
        "periodo": 202510,
        "valor": 0.8597,
        "delta": 0.0368
      },
      {
        "periodo": 202511,
        "valor": 0.8232,
        "delta": -0.0365
      },
      {
        "periodo": 202512,
        "valor": 0.7726,
        "delta": -0.0505
      },
      {
        "periodo": 202601,
        "valor": 0.7748,
        "delta": 0.0022
      },
      {
        "periodo": 202602,
        "valor": 0.7588,
        "delta": -0.016
      },
      {
        "periodo": 202603,
        "valor": 0.7407,
        "delta": -0.0181
      },
      {
        "periodo": 202604,
        "valor": 0.7314,
        "delta": -0.0093
      },
      {
        "periodo": 202605,
        "valor": 0.725,
        "delta": -0.0064
      },
      {
        "periodo": 202606,
        "valor": 0.7106,
        "delta": -0.0144
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 4021756,
    "label": "CCom Jun 2026",
    "valor_actual": 0.242957,
    "valor_anterior": 0.239141,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 0.3054,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 0.2753,
        "delta": -0.0301
      },
      {
        "periodo": 202508,
        "valor": 0.2625,
        "delta": -0.0128
      },
      {
        "periodo": 202509,
        "valor": 0.2959,
        "delta": 0.0333
      },
      {
        "periodo": 202510,
        "valor": 0.2792,
        "delta": -0.0167
      },
      {
        "periodo": 202511,
        "valor": 0.2989,
        "delta": 0.0197
      },
      {
        "periodo": 202512,
        "valor": 0.2984,
        "delta": -0.0005
      },
      {
        "periodo": 202601,
        "valor": 0.3209,
        "delta": 0.0225
      },
      {
        "periodo": 202602,
        "valor": 0.3117,
        "delta": -0.0092
      },
      {
        "periodo": 202603,
        "valor": 0.2601,
        "delta": -0.0516
      },
      {
        "periodo": 202604,
        "valor": 0.2578,
        "delta": -0.0023
      },
      {
        "periodo": 202605,
        "valor": 0.2391,
        "delta": -0.0187
      },
      {
        "periodo": 202606,
        "valor": 0.243,
        "delta": 0.0038
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 112989792107.0589,
    "valor_anterior": 112683766362.9695,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 65923843116.2714,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 66282925365.9208,
        "delta": 359082249.6494
      },
      {
        "periodo": 202508,
        "valor": 67000317693.1875,
        "delta": 717392327.2667
      },
      {
        "periodo": 202509,
        "valor": 66316584732.7037,
        "delta": -683732960.4838
      },
      {
        "periodo": 202510,
        "valor": 66912221436.0379,
        "delta": 595636703.3342
      },
      {
        "periodo": 202511,
        "valor": 66357755400.3479,
        "delta": -554466035.69
      },
      {
        "periodo": 202512,
        "valor": 65969627000.1903,
        "delta": -388128400.1576
      },
      {
        "periodo": 202601,
        "valor": 70248698508.28,
        "delta": 4279071508.0897
      },
      {
        "periodo": 202602,
        "valor": 88422387603.7332,
        "delta": 18173689095.4532
      },
      {
        "periodo": 202603,
        "valor": 90635939032.4446,
        "delta": 2213551428.7114
      },
      {
        "periodo": 202604,
        "valor": 83797400059.2958,
        "delta": -6838538973.1488
      },
      {
        "periodo": 202605,
        "valor": 112683766362.9695,
        "delta": 28886366303.6737
      },
      {
        "periodo": 202606,
        "valor": 112989792107.0589,
        "delta": 306025744.0894
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 281130830289.9813,
    "valor_anterior": 296172459802.0484,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 271276698804.4579,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 274971019058.1426,
        "delta": 3694320253.6847
      },
      {
        "periodo": 202508,
        "valor": 284943243021.4252,
        "delta": 9972223963.2826
      },
      {
        "periodo": 202509,
        "valor": 275406841728.8626,
        "delta": -9536401292.5626
      },
      {
        "periodo": 202510,
        "valor": 282324268323.9029,
        "delta": 6917426595.0403
      },
      {
        "periodo": 202511,
        "valor": 285771941819.7934,
        "delta": 3447673495.8905
      },
      {
        "periodo": 202512,
        "valor": 279679983265.1847,
        "delta": -6091958554.6087
      },
      {
        "periodo": 202601,
        "valor": 285016205552.469,
        "delta": 5336222287.2843
      },
      {
        "periodo": 202602,
        "valor": 294962645309.9368,
        "delta": 9946439757.4678
      },
      {
        "periodo": 202603,
        "valor": 285486201613.3363,
        "delta": -9476443696.6005
      },
      {
        "periodo": 202604,
        "valor": 291652002194.2683,
        "delta": 6165800580.932
      },
      {
        "periodo": 202605,
        "valor": 296172459802.0484,
        "delta": 4520457607.7801
      },
      {
        "periodo": 202606,
        "valor": 281130830289.9813,
        "delta": -15041629512.0671
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 105819122552.6714,
    "valor_anterior": 111765409627.1372,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 109498975674.9481,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 114226602475.9246,
        "delta": 4727626800.9765
      },
      {
        "periodo": 202508,
        "valor": 113214066653.0011,
        "delta": -1012535822.9235
      },
      {
        "periodo": 202509,
        "valor": 115338419900.7317,
        "delta": 2124353247.7306
      },
      {
        "periodo": 202510,
        "valor": 113819151228.2315,
        "delta": -1519268672.5002
      },
      {
        "periodo": 202511,
        "valor": 113439097015.506,
        "delta": -380054212.7255
      },
      {
        "periodo": 202512,
        "valor": 100166962362.1101,
        "delta": -13272134653.3959
      },
      {
        "periodo": 202601,
        "valor": 103488299074.6734,
        "delta": 3321336712.5633
      },
      {
        "periodo": 202602,
        "valor": 106298840857.2262,
        "delta": 2810541782.5528
      },
      {
        "periodo": 202603,
        "valor": 112582905617.1659,
        "delta": 6284064759.9397
      },
      {
        "periodo": 202604,
        "valor": 110899444449.1275,
        "delta": -1683461168.0384
      },
      {
        "periodo": 202605,
        "valor": 111765409627.1372,
        "delta": 865965178.0097
      },
      {
        "periodo": 202606,
        "valor": 105819122552.6714,
        "delta": -5946287074.4658
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 63439296711.0241,
    "valor_anterior": 68470131433.9254,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 58061651923.9787,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 59475109556.2917,
        "delta": 1413457632.313
      },
      {
        "periodo": 202508,
        "valor": 60556825974.1558,
        "delta": 1081716417.8641
      },
      {
        "periodo": 202509,
        "valor": 60768677343.6336,
        "delta": 211851369.4778
      },
      {
        "periodo": 202510,
        "valor": 68256446652.6947,
        "delta": 7487769309.0611
      },
      {
        "periodo": 202511,
        "valor": 66675775601.6568,
        "delta": -1580671051.0379
      },
      {
        "periodo": 202512,
        "valor": 64725845496.8165,
        "delta": -1949930104.8403
      },
      {
        "periodo": 202601,
        "valor": 65633646135.0029,
        "delta": 907800638.1864
      },
      {
        "periodo": 202602,
        "valor": 66300411527.2744,
        "delta": 666765392.2715
      },
      {
        "periodo": 202603,
        "valor": 67742959889.4702,
        "delta": 1442548362.1958
      },
      {
        "periodo": 202604,
        "valor": 68008954334.3406,
        "delta": 265994444.8704
      },
      {
        "periodo": 202605,
        "valor": 68470131433.9254,
        "delta": 461177099.5848
      },
      {
        "periodo": 202606,
        "valor": 63439296711.0241,
        "delta": -5030834722.9013
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 18834629135.208,
    "valor_anterior": 18669380225.1979,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 17898655478.1709,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 18475685923.188,
        "delta": 577030445.0171
      },
      {
        "periodo": 202508,
        "valor": 19693699014.5891,
        "delta": 1218013091.4011
      },
      {
        "periodo": 202509,
        "valor": 20549117491.1865,
        "delta": 855418476.5974
      },
      {
        "periodo": 202510,
        "valor": 21050251532.6443,
        "delta": 501134041.4578
      },
      {
        "periodo": 202511,
        "valor": 20405725456.8049,
        "delta": -644526075.8394
      },
      {
        "periodo": 202512,
        "valor": 20469867393.5378,
        "delta": 64141936.7329
      },
      {
        "periodo": 202601,
        "valor": 21596021322.6769,
        "delta": 1126153929.1391
      },
      {
        "periodo": 202602,
        "valor": 22182649517.5106,
        "delta": 586628194.8337
      },
      {
        "periodo": 202603,
        "valor": 21942887101.0034,
        "delta": -239762416.5072
      },
      {
        "periodo": 202604,
        "valor": 18214453662.8531,
        "delta": -3728433438.1503
      },
      {
        "periodo": 202605,
        "valor": 18669380225.1979,
        "delta": 454926562.3448
      },
      {
        "periodo": 202606,
        "valor": 18834629135.208,
        "delta": 165248910.0101
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 106543670845.5421,
    "valor_anterior": 106447603034.9802,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 97917773841.2852,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 100200265373.4309,
        "delta": 2282491532.1457
      },
      {
        "periodo": 202508,
        "valor": 100812105866.6088,
        "delta": 611840493.1779
      },
      {
        "periodo": 202509,
        "valor": 101002637996.9994,
        "delta": 190532130.3906
      },
      {
        "periodo": 202510,
        "valor": 101987954300.7021,
        "delta": 985316303.7027
      },
      {
        "periodo": 202511,
        "valor": 103606367249.4338,
        "delta": 1618412948.7317
      },
      {
        "periodo": 202512,
        "valor": 104809261374.4478,
        "delta": 1202894125.014
      },
      {
        "periodo": 202601,
        "valor": 105373159785.2525,
        "delta": 563898410.8047
      },
      {
        "periodo": 202602,
        "valor": 105452961582.0236,
        "delta": 79801796.7711
      },
      {
        "periodo": 202603,
        "valor": 105829666571.0083,
        "delta": 376704988.9847
      },
      {
        "periodo": 202604,
        "valor": 105792248587.6811,
        "delta": -37417983.3272
      },
      {
        "periodo": 202605,
        "valor": 106447603034.9802,
        "delta": 655354447.2991
      },
      {
        "periodo": 202606,
        "valor": 106543670845.5421,
        "delta": 96067810.5619
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 13861133490.4231,
    "valor_anterior": 13741900134.1314,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 7735035313.4096,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 7964303457.1766,
        "delta": 229268143.767
      },
      {
        "periodo": 202508,
        "valor": 7854115130.6594,
        "delta": -110188326.5172
      },
      {
        "periodo": 202509,
        "valor": 8215230058.1608,
        "delta": 361114927.5014
      },
      {
        "periodo": 202510,
        "valor": 8451315574.6596,
        "delta": 236085516.4988
      },
      {
        "periodo": 202511,
        "valor": 8625544456.9044,
        "delta": 174228882.2448
      },
      {
        "periodo": 202512,
        "valor": 8870260129.9452,
        "delta": 244715673.0408
      },
      {
        "periodo": 202601,
        "valor": 8880964504.3963,
        "delta": 10704374.4511
      },
      {
        "periodo": 202602,
        "valor": 9027878857.7769,
        "delta": 146914353.3806
      },
      {
        "periodo": 202603,
        "valor": 9127484071.7866,
        "delta": 99605214.0097
      },
      {
        "periodo": 202604,
        "valor": 9090033425.5373,
        "delta": -37450646.2493
      },
      {
        "periodo": 202605,
        "valor": 13741900134.1314,
        "delta": 4651866708.5941
      },
      {
        "periodo": 202606,
        "valor": 13861133490.4231,
        "delta": 119233356.2917
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 61080006702.8845,
    "valor_anterior": 59880825124.3947,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 50536234267.2721,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 51541876627.3791,
        "delta": 1005642360.107
      },
      {
        "periodo": 202508,
        "valor": 51705441947.2049,
        "delta": 163565319.8258
      },
      {
        "periodo": 202509,
        "valor": 52472450105.5379,
        "delta": 767008158.333
      },
      {
        "periodo": 202510,
        "valor": 52632785264.0275,
        "delta": 160335158.4896
      },
      {
        "periodo": 202511,
        "valor": 52894812403.3517,
        "delta": 262027139.3242
      },
      {
        "periodo": 202512,
        "valor": 57768662948.4889,
        "delta": 4873850545.1372
      },
      {
        "periodo": 202601,
        "valor": 58315829098.507,
        "delta": 547166150.0181
      },
      {
        "periodo": 202602,
        "valor": 59549194747.3347,
        "delta": 1233365648.8277
      },
      {
        "periodo": 202603,
        "valor": 59938463275.152,
        "delta": 389268527.8173
      },
      {
        "periodo": 202604,
        "valor": 59701151569.9511,
        "delta": -237311705.2009
      },
      {
        "periodo": 202605,
        "valor": 59880825124.3947,
        "delta": 179673554.4436
      },
      {
        "periodo": 202606,
        "valor": 61080006702.8845,
        "delta": 1199181578.4898
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 12660769148.079,
    "valor_anterior": 12227817019.8601,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 10673965643.669,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 11069916221.5114,
        "delta": 395950577.8424
      },
      {
        "periodo": 202508,
        "valor": 11331954675.7097,
        "delta": 262038454.1983
      },
      {
        "periodo": 202509,
        "valor": 11606867568.141,
        "delta": 274912892.4313
      },
      {
        "periodo": 202510,
        "valor": 12087276784.1762,
        "delta": 480409216.0352
      },
      {
        "periodo": 202511,
        "valor": 11316903487.9823,
        "delta": -770373296.1939
      },
      {
        "periodo": 202512,
        "valor": 11990629280.0102,
        "delta": 673725792.0279
      },
      {
        "periodo": 202601,
        "valor": 12251057467.4895,
        "delta": 260428187.4793
      },
      {
        "periodo": 202602,
        "valor": 12943163837.9322,
        "delta": 692106370.4427
      },
      {
        "periodo": 202603,
        "valor": 11672748604.0444,
        "delta": -1270415233.8878
      },
      {
        "periodo": 202604,
        "valor": 11931714656.097,
        "delta": 258966052.0526
      },
      {
        "periodo": 202605,
        "valor": 12227817019.8601,
        "delta": 296102363.7631
      },
      {
        "periodo": 202606,
        "valor": 12660769148.079,
        "delta": 432952128.2189
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 5540340373.3092,
    "valor_anterior": 5359359793.5857,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4940330993.086,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 5007215135.6896,
        "delta": 66884142.6036
      },
      {
        "periodo": 202508,
        "valor": 4964304995.1799,
        "delta": -42910140.5097
      },
      {
        "periodo": 202509,
        "valor": 5092335573.9969,
        "delta": 128030578.817
      },
      {
        "periodo": 202510,
        "valor": 5261341111.6197,
        "delta": 169005537.6228
      },
      {
        "periodo": 202511,
        "valor": 5189473645.3936,
        "delta": -71867466.2261
      },
      {
        "periodo": 202512,
        "valor": 5426734461.8465,
        "delta": 237260816.4529
      },
      {
        "periodo": 202601,
        "valor": 5164433002.9658,
        "delta": -262301458.8807
      },
      {
        "periodo": 202602,
        "valor": 5099309102.6289,
        "delta": -65123900.3369
      },
      {
        "periodo": 202603,
        "valor": 5028724926.1968,
        "delta": -70584176.4321
      },
      {
        "periodo": 202604,
        "valor": 5267815192.6059,
        "delta": 239090266.4091
      },
      {
        "periodo": 202605,
        "valor": 5359359793.5857,
        "delta": 91544600.9798
      },
      {
        "periodo": 202606,
        "valor": 5540340373.3092,
        "delta": 180980579.7235
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 6151222296.1051,
    "valor_anterior": 5973154972.2382,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5053248259.539,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4956208806.2519,
        "delta": -97039453.2871
      },
      {
        "periodo": 202508,
        "valor": 5007613703.6185,
        "delta": 51404897.3666
      },
      {
        "periodo": 202509,
        "valor": 5182225164.6384,
        "delta": 174611461.0199
      },
      {
        "periodo": 202510,
        "valor": 5397040718.5794,
        "delta": 214815553.941
      },
      {
        "periodo": 202511,
        "valor": 5331795478.6729,
        "delta": -65245239.9065
      },
      {
        "periodo": 202512,
        "valor": 5389859457.2839,
        "delta": 58063978.611
      },
      {
        "periodo": 202601,
        "valor": 5515434197.3753,
        "delta": 125574740.0914
      },
      {
        "periodo": 202602,
        "valor": 5635060555.0625,
        "delta": 119626357.6872
      },
      {
        "periodo": 202603,
        "valor": 5809251478.0166,
        "delta": 174190922.9541
      },
      {
        "periodo": 202604,
        "valor": 5876642203.3513,
        "delta": 67390725.3347
      },
      {
        "periodo": 202605,
        "valor": 5973154972.2382,
        "delta": 96512768.8869
      },
      {
        "periodo": 202606,
        "valor": 6151222296.1051,
        "delta": 178067323.8669
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 6244003215.1634,
    "valor_anterior": 5902614931.047,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5617928013.7266,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 5729427177.2962,
        "delta": 111499163.5696
      },
      {
        "periodo": 202508,
        "valor": 5729582740.4169,
        "delta": 155563.1207
      },
      {
        "periodo": 202509,
        "valor": 5717349454.2997,
        "delta": -12233286.1172
      },
      {
        "periodo": 202510,
        "valor": 5556363755.7481,
        "delta": -160985698.5516
      },
      {
        "periodo": 202511,
        "valor": 5621290227.6312,
        "delta": 64926471.8831
      },
      {
        "periodo": 202512,
        "valor": 5574121616.6577,
        "delta": -47168610.9735
      },
      {
        "periodo": 202601,
        "valor": 5534678241.7399,
        "delta": -39443374.9178
      },
      {
        "periodo": 202602,
        "valor": 5552747912.058,
        "delta": 18069670.3181
      },
      {
        "periodo": 202603,
        "valor": 5852155931.989,
        "delta": 299408019.931
      },
      {
        "periodo": 202604,
        "valor": 5819519215.5918,
        "delta": -32636716.3972
      },
      {
        "periodo": 202605,
        "valor": 5902614931.047,
        "delta": 83095715.4552
      },
      {
        "periodo": 202606,
        "valor": 6244003215.1634,
        "delta": 341388284.1164
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 150934962438.8435,
    "valor_anterior": 123328986090.6574,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 139642605433.6545,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 144375068258.7294,
        "delta": 4732462825.0749
      },
      {
        "periodo": 202508,
        "valor": 145975895415.6626,
        "delta": 1600827156.9332
      },
      {
        "periodo": 202509,
        "valor": 147510225015.4915,
        "delta": 1534329599.8289
      },
      {
        "periodo": 202510,
        "valor": 150840282349.515,
        "delta": 3330057334.0235
      },
      {
        "periodo": 202511,
        "valor": 129569988009.5642,
        "delta": -21270294339.9508
      },
      {
        "periodo": 202512,
        "valor": 126259156724.6435,
        "delta": -3310831284.9207
      },
      {
        "periodo": 202601,
        "valor": 123289522650.9976,
        "delta": -2969634073.6459
      },
      {
        "periodo": 202602,
        "valor": 126275963973.161,
        "delta": 2986441322.1634
      },
      {
        "periodo": 202603,
        "valor": 130989703746.1101,
        "delta": 4713739772.9491
      },
      {
        "periodo": 202604,
        "valor": 120002859721.1659,
        "delta": -10986844024.9442
      },
      {
        "periodo": 202605,
        "valor": 123328986090.6574,
        "delta": 3326126369.4915
      },
      {
        "periodo": 202606,
        "valor": 150934962438.8435,
        "delta": 27605976348.1861
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 14115925577.7836,
    "valor_anterior": 14136106491.2606,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 12505531949.8304,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 12902599823.0452,
        "delta": 397067873.2148
      },
      {
        "periodo": 202508,
        "valor": 12227418972.3399,
        "delta": -675180850.7053
      },
      {
        "periodo": 202509,
        "valor": 12546107702.4115,
        "delta": 318688730.0716
      },
      {
        "periodo": 202510,
        "valor": 12889897950.0622,
        "delta": 343790247.6507
      },
      {
        "periodo": 202511,
        "valor": 12974564165.5425,
        "delta": 84666215.4803
      },
      {
        "periodo": 202512,
        "valor": 13551978674.6141,
        "delta": 577414509.0716
      },
      {
        "periodo": 202601,
        "valor": 14126052838.4395,
        "delta": 574074163.8254
      },
      {
        "periodo": 202602,
        "valor": 13796587528.9104,
        "delta": -329465309.5291
      },
      {
        "periodo": 202603,
        "valor": 14065884154.2803,
        "delta": 269296625.3699
      },
      {
        "periodo": 202604,
        "valor": 14543949439.9349,
        "delta": 478065285.6546
      },
      {
        "periodo": 202605,
        "valor": 14136106491.2606,
        "delta": -407842948.6743
      },
      {
        "periodo": 202606,
        "valor": 14115925577.7836,
        "delta": -20180913.477
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 8456202964.0278,
    "valor_anterior": 8178187503.7081,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 7861894299.6446,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 7911158615.4165,
        "delta": 49264315.7719
      },
      {
        "periodo": 202508,
        "valor": 7928010527.1721,
        "delta": 16851911.7556
      },
      {
        "periodo": 202509,
        "valor": 8099356316.8694,
        "delta": 171345789.6973
      },
      {
        "periodo": 202510,
        "valor": 7895593952.1169,
        "delta": -203762364.7525
      },
      {
        "periodo": 202511,
        "valor": 7921521915.3466,
        "delta": 25927963.2297
      },
      {
        "periodo": 202512,
        "valor": 8142785575.0191,
        "delta": 221263659.6725
      },
      {
        "periodo": 202601,
        "valor": 8078569207.5265,
        "delta": -64216367.4926
      },
      {
        "periodo": 202602,
        "valor": 8034392518.6036,
        "delta": -44176688.9229
      },
      {
        "periodo": 202603,
        "valor": 8067332217.4743,
        "delta": 32939698.8707
      },
      {
        "periodo": 202604,
        "valor": 8145566909.495,
        "delta": 78234692.0207
      },
      {
        "periodo": 202605,
        "valor": 8178187503.7081,
        "delta": 32620594.2131
      },
      {
        "periodo": 202606,
        "valor": 8456202964.0278,
        "delta": 278015460.3197
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 33299600071.3294,
    "valor_anterior": 32877308606.4437,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 29433214403.5654,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 29835216599.165,
        "delta": 402002195.5996
      },
      {
        "periodo": 202508,
        "valor": 30438813169.1623,
        "delta": 603596569.9973
      },
      {
        "periodo": 202509,
        "valor": 31068337809.5825,
        "delta": 629524640.4202
      },
      {
        "periodo": 202510,
        "valor": 31244048004.2948,
        "delta": 175710194.7123
      },
      {
        "periodo": 202511,
        "valor": 31601769077.0782,
        "delta": 357721072.7834
      },
      {
        "periodo": 202512,
        "valor": 32280835875.7239,
        "delta": 679066798.6457
      },
      {
        "periodo": 202601,
        "valor": 31960788044.4309,
        "delta": -320047831.293
      },
      {
        "periodo": 202602,
        "valor": 31846917084.4333,
        "delta": -113870959.9976
      },
      {
        "periodo": 202603,
        "valor": 32397426485.517,
        "delta": 550509401.0837
      },
      {
        "periodo": 202604,
        "valor": 32594318305.8333,
        "delta": 196891820.3163
      },
      {
        "periodo": 202605,
        "valor": 32877308606.4437,
        "delta": 282990300.6104
      },
      {
        "periodo": 202606,
        "valor": 33299600071.3294,
        "delta": 422291464.8857
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 10536364973.5747,
    "valor_anterior": 10490614420.4944,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 8522247374.3123,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 8549117101.6521,
        "delta": 26869727.3398
      },
      {
        "periodo": 202508,
        "valor": 8868587006.6545,
        "delta": 319469905.0024
      },
      {
        "periodo": 202509,
        "valor": 9377106763.0696,
        "delta": 508519756.4151
      },
      {
        "periodo": 202510,
        "valor": 9736591653.6169,
        "delta": 359484890.5473
      },
      {
        "periodo": 202511,
        "valor": 9857975168.3377,
        "delta": 121383514.7208
      },
      {
        "periodo": 202512,
        "valor": 9819383687.7301,
        "delta": -38591480.6076
      },
      {
        "periodo": 202601,
        "valor": 10171761103.8184,
        "delta": 352377416.0883
      },
      {
        "periodo": 202602,
        "valor": 10413779768.6768,
        "delta": 242018664.8584
      },
      {
        "periodo": 202603,
        "valor": 10591632706.9012,
        "delta": 177852938.2244
      },
      {
        "periodo": 202604,
        "valor": 9920313740.4413,
        "delta": -671318966.4599
      },
      {
        "periodo": 202605,
        "valor": 10490614420.4944,
        "delta": 570300680.0531
      },
      {
        "periodo": 202606,
        "valor": 10536364973.5747,
        "delta": 45750553.0803
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 3798191409.4672,
    "valor_anterior": 3801108795.0788,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 3390823163.9546,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3398222825.7935,
        "delta": 7399661.8389
      },
      {
        "periodo": 202508,
        "valor": 3420232873.0893,
        "delta": 22010047.2958
      },
      {
        "periodo": 202509,
        "valor": 3391922674.1701,
        "delta": -28310198.9192
      },
      {
        "periodo": 202510,
        "valor": 3464428276.6149,
        "delta": 72505602.4448
      },
      {
        "periodo": 202511,
        "valor": 3423851479.4383,
        "delta": -40576797.1766
      },
      {
        "periodo": 202512,
        "valor": 3476036595.3967,
        "delta": 52185115.9584
      },
      {
        "periodo": 202601,
        "valor": 3638993313.938,
        "delta": 162956718.5413
      },
      {
        "periodo": 202602,
        "valor": 3600328263.2969,
        "delta": -38665050.6411
      },
      {
        "periodo": 202603,
        "valor": 3565765550.4552,
        "delta": -34562712.8417
      },
      {
        "periodo": 202604,
        "valor": 3804440893.2349,
        "delta": 238675342.7797
      },
      {
        "periodo": 202605,
        "valor": 3801108795.0788,
        "delta": -3332098.1561
      },
      {
        "periodo": 202606,
        "valor": 3798191409.4672,
        "delta": -2917385.6116
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 56520465224.5671,
    "valor_anterior": 56388636372.9256,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 44920831754.3346,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 46216255827.1903,
        "delta": 1295424072.8557
      },
      {
        "periodo": 202508,
        "valor": 47319437262.5653,
        "delta": 1103181435.375
      },
      {
        "periodo": 202509,
        "valor": 49126835253.6063,
        "delta": 1807397991.041
      },
      {
        "periodo": 202510,
        "valor": 49461876369.3416,
        "delta": 335041115.7353
      },
      {
        "periodo": 202511,
        "valor": 49815889513.6165,
        "delta": 354013144.2749
      },
      {
        "periodo": 202512,
        "valor": 53299783338.3853,
        "delta": 3483893824.7688
      },
      {
        "periodo": 202601,
        "valor": 53880588333.4436,
        "delta": 580804995.0583
      },
      {
        "periodo": 202602,
        "valor": 53345107915.455,
        "delta": -535480417.9886
      },
      {
        "periodo": 202603,
        "valor": 53239713333.0083,
        "delta": -105394582.4467
      },
      {
        "periodo": 202604,
        "valor": 54126807142.0287,
        "delta": 887093809.0204
      },
      {
        "periodo": 202605,
        "valor": 56388636372.9256,
        "delta": 2261829230.8969
      },
      {
        "periodo": 202606,
        "valor": 56520465224.5671,
        "delta": 131828851.6415
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 2021939989.3216,
    "valor_anterior": 2019595576.1681,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2048109917.0294,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2034142760.7241,
        "delta": -13967156.3053
      },
      {
        "periodo": 202508,
        "valor": 2028515193.1269,
        "delta": -5627567.5972
      },
      {
        "periodo": 202509,
        "valor": 2027872450.7768,
        "delta": -642742.3501
      },
      {
        "periodo": 202510,
        "valor": 2033318392.3067,
        "delta": 5445941.5299
      },
      {
        "periodo": 202511,
        "valor": 2020310686.4319,
        "delta": -13007705.8748
      },
      {
        "periodo": 202512,
        "valor": 2041969373.1353,
        "delta": 21658686.7034
      },
      {
        "periodo": 202601,
        "valor": 2044570035.229,
        "delta": 2600662.0937
      },
      {
        "periodo": 202602,
        "valor": 2002098817.513,
        "delta": -42471217.716
      },
      {
        "periodo": 202603,
        "valor": 2004247808.7026,
        "delta": 2148991.1896
      },
      {
        "periodo": 202604,
        "valor": 2010136270.7318,
        "delta": 5888462.0292
      },
      {
        "periodo": 202605,
        "valor": 2019595576.1681,
        "delta": 9459305.4363
      },
      {
        "periodo": 202606,
        "valor": 2021939989.3216,
        "delta": 2344413.1535
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 22275072756.8835,
    "valor_anterior": 23080716355.3868,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 20886726825.2783,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 20384735346.5359,
        "delta": -501991478.7424
      },
      {
        "periodo": 202508,
        "valor": 19945990642.2521,
        "delta": -438744704.2838
      },
      {
        "periodo": 202509,
        "valor": 22807481619.653,
        "delta": 2861490977.4009
      },
      {
        "periodo": 202510,
        "valor": 23637546547.0461,
        "delta": 830064927.3931
      },
      {
        "periodo": 202511,
        "valor": 23942564651.7256,
        "delta": 305018104.6795
      },
      {
        "periodo": 202512,
        "valor": 25065302855.529,
        "delta": 1122738203.8034
      },
      {
        "periodo": 202601,
        "valor": 23996663347.1711,
        "delta": -1068639508.3579
      },
      {
        "periodo": 202602,
        "valor": 24237677095.7819,
        "delta": 241013748.6108
      },
      {
        "periodo": 202603,
        "valor": 25208188011.597,
        "delta": 970510915.8151
      },
      {
        "periodo": 202604,
        "valor": 24264810075.4925,
        "delta": -943377936.1045
      },
      {
        "periodo": 202605,
        "valor": 23080716355.3868,
        "delta": -1184093720.1057
      },
      {
        "periodo": 202606,
        "valor": 22275072756.8835,
        "delta": -805643598.5033
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 2223053749.6321,
    "valor_anterior": 2023089752.1984,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 607131052.3598,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 627691035.9961,
        "delta": 20559983.6363
      },
      {
        "periodo": 202508,
        "valor": 561943795.7746,
        "delta": -65747240.2215
      },
      {
        "periodo": 202509,
        "valor": 1491526074.4601,
        "delta": 929582278.6855
      },
      {
        "periodo": 202510,
        "valor": 2113929581.824,
        "delta": 622403507.3639
      },
      {
        "periodo": 202511,
        "valor": 1994537345.0444,
        "delta": -119392236.7796
      },
      {
        "periodo": 202512,
        "valor": 1661222893.6014,
        "delta": -333314451.443
      },
      {
        "periodo": 202601,
        "valor": 1902884370.108,
        "delta": 241661476.5066
      },
      {
        "periodo": 202602,
        "valor": 2059397883.8352,
        "delta": 156513513.7272
      },
      {
        "periodo": 202603,
        "valor": 2263429876.756,
        "delta": 204031992.9208
      },
      {
        "periodo": 202604,
        "valor": 2296762379.7544,
        "delta": 33332502.9984
      },
      {
        "periodo": 202605,
        "valor": 2023089752.1984,
        "delta": -273672627.556
      },
      {
        "periodo": 202606,
        "valor": 2223053749.6321,
        "delta": 199963997.4337
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 5345669319.2032,
    "valor_anterior": 5846121282.0467,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5882444495.5807,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 6240177598.6288,
        "delta": 357733103.0481
      },
      {
        "periodo": 202508,
        "valor": 6004865072.371,
        "delta": -235312526.2578
      },
      {
        "periodo": 202509,
        "valor": 6334384868.1063,
        "delta": 329519795.7353
      },
      {
        "periodo": 202510,
        "valor": 6367265588.6196,
        "delta": 32880720.5133
      },
      {
        "periodo": 202511,
        "valor": 5604968579.569,
        "delta": -762297009.0506
      },
      {
        "periodo": 202512,
        "valor": 5683765283.2123,
        "delta": 78796703.6433
      },
      {
        "periodo": 202601,
        "valor": 5490961080.9086,
        "delta": -192804202.3037
      },
      {
        "periodo": 202602,
        "valor": 5611356137.5662,
        "delta": 120395056.6576
      },
      {
        "periodo": 202603,
        "valor": 5360392599.4838,
        "delta": -250963538.0824
      },
      {
        "periodo": 202604,
        "valor": 5376214271.4791,
        "delta": 15821671.9953
      },
      {
        "periodo": 202605,
        "valor": 5846121282.0467,
        "delta": 469907010.5676
      },
      {
        "periodo": 202606,
        "valor": 5345669319.2032,
        "delta": -500451962.8435
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 14644368121.1027,
    "valor_anterior": 14165205434.9356,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 12718594452.9113,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 12915661251.6394,
        "delta": 197066798.7281
      },
      {
        "periodo": 202508,
        "valor": 13312759917.4856,
        "delta": 397098665.8462
      },
      {
        "periodo": 202509,
        "valor": 13888951470.1486,
        "delta": 576191552.663
      },
      {
        "periodo": 202510,
        "valor": 14194459922.4731,
        "delta": 305508452.3245
      },
      {
        "periodo": 202511,
        "valor": 12881437865.1865,
        "delta": -1313022057.2866
      },
      {
        "periodo": 202512,
        "valor": 13243178456.3752,
        "delta": 361740591.1887
      },
      {
        "periodo": 202601,
        "valor": 14077384913.4756,
        "delta": 834206457.1004
      },
      {
        "periodo": 202602,
        "valor": 14627179476.9399,
        "delta": 549794563.4643
      },
      {
        "periodo": 202603,
        "valor": 14897180966.0314,
        "delta": 270001489.0915
      },
      {
        "periodo": 202604,
        "valor": 13384869102.7044,
        "delta": -1512311863.327
      },
      {
        "periodo": 202605,
        "valor": 14165205434.9356,
        "delta": 780336332.2312
      },
      {
        "periodo": 202606,
        "valor": 14644368121.1027,
        "delta": 479162686.1671
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 6007507123.7884,
    "valor_anterior": 6104662858.1053,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 5550197515.8623,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 5506653942.6379,
        "delta": -43543573.2244
      },
      {
        "periodo": 202508,
        "valor": 5621090006.4863,
        "delta": 114436063.8484
      },
      {
        "periodo": 202509,
        "valor": 5308126089.3494,
        "delta": -312963917.1369
      },
      {
        "periodo": 202510,
        "valor": 5390863506.9631,
        "delta": 82737417.6137
      },
      {
        "periodo": 202511,
        "valor": 5671805382.956,
        "delta": 280941875.9929
      },
      {
        "periodo": 202512,
        "valor": 5744675827.487,
        "delta": 72870444.531
      },
      {
        "periodo": 202601,
        "valor": 6107650132.9361,
        "delta": 362974305.4491
      },
      {
        "periodo": 202602,
        "valor": 6188778115.8188,
        "delta": 81127982.8827
      },
      {
        "periodo": 202603,
        "valor": 6425097454.9899,
        "delta": 236319339.1711
      },
      {
        "periodo": 202604,
        "valor": 6198952057.1131,
        "delta": -226145397.8768
      },
      {
        "periodo": 202605,
        "valor": 6104662858.1053,
        "delta": -94289199.0078
      },
      {
        "periodo": 202606,
        "valor": 6007507123.7884,
        "delta": -97155734.3169
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 3370803085.1591,
    "valor_anterior": 3505188507.4721,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 3495510731.7178,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 3514312545.3471,
        "delta": 18801813.6293
      },
      {
        "periodo": 202508,
        "valor": 3392134637.9974,
        "delta": -122177907.3497
      },
      {
        "periodo": 202509,
        "valor": 3528932561.5027,
        "delta": 136797923.5053
      },
      {
        "periodo": 202510,
        "valor": 3517590303.3786,
        "delta": -11342258.1241
      },
      {
        "periodo": 202511,
        "valor": 3302560535.776,
        "delta": -215029767.6026
      },
      {
        "periodo": 202512,
        "valor": 3311610433.8335,
        "delta": 9049898.0575
      },
      {
        "periodo": 202601,
        "valor": 3314976833.6495,
        "delta": 3366399.816
      },
      {
        "periodo": 202602,
        "valor": 3378622198.6636,
        "delta": 63645365.0141
      },
      {
        "periodo": 202603,
        "valor": 3277175048.2807,
        "delta": -101447150.3829
      },
      {
        "periodo": 202604,
        "valor": 3361722330.2898,
        "delta": 84547282.0091
      },
      {
        "periodo": 202605,
        "valor": 3505188507.4721,
        "delta": 143466177.1823
      },
      {
        "periodo": 202606,
        "valor": 3370803085.1591,
        "delta": -134385422.313
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 2062515590.8784,
    "valor_anterior": 2247510625.4991,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 6094569707.798,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 7536157477.3997,
        "delta": 1441587769.6017
      },
      {
        "periodo": 202508,
        "valor": 8136922863.5776,
        "delta": 600765386.1779
      },
      {
        "periodo": 202509,
        "valor": 8487974767.6691,
        "delta": 351051904.0915
      },
      {
        "periodo": 202510,
        "valor": 8463496981.6627,
        "delta": -24477786.0064
      },
      {
        "periodo": 202511,
        "valor": 2436555380.7251,
        "delta": -6026941600.9376
      },
      {
        "periodo": 202512,
        "valor": 2660091434.3916,
        "delta": 223536053.6665
      },
      {
        "periodo": 202601,
        "valor": 2573159524.6455,
        "delta": -86931909.7461
      },
      {
        "periodo": 202602,
        "valor": 2699137424.2711,
        "delta": 125977899.6256
      },
      {
        "periodo": 202603,
        "valor": 2742645093.5366,
        "delta": 43507669.2655
      },
      {
        "periodo": 202604,
        "valor": 2203664381.9941,
        "delta": -538980711.5425
      },
      {
        "periodo": 202605,
        "valor": 2247510625.4991,
        "delta": 43846243.505
      },
      {
        "periodo": 202606,
        "valor": 2062515590.8784,
        "delta": -184995034.6207
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 10810423246.1786,
    "valor_anterior": 9295415338.1348,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 11610267551.158,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 11520688036.8502,
        "delta": -89579514.3078
      },
      {
        "periodo": 202508,
        "valor": 10899340408.7668,
        "delta": -621347628.0834
      },
      {
        "periodo": 202509,
        "valor": 10638771506.0983,
        "delta": -260568902.6685
      },
      {
        "periodo": 202510,
        "valor": 10643891087.4584,
        "delta": 5119581.3601
      },
      {
        "periodo": 202511,
        "valor": 10141572376.1614,
        "delta": -502318711.297
      },
      {
        "periodo": 202512,
        "valor": 9927868655.8775,
        "delta": -213703720.2839
      },
      {
        "periodo": 202601,
        "valor": 9948519020.723,
        "delta": 20650364.8455
      },
      {
        "periodo": 202602,
        "valor": 10391115496.3136,
        "delta": 442596475.5906
      },
      {
        "periodo": 202603,
        "valor": 9300938842.9964,
        "delta": -1090176653.3172
      },
      {
        "periodo": 202604,
        "valor": 9680138921.6277,
        "delta": 379200078.6313
      },
      {
        "periodo": 202605,
        "valor": 9295415338.1348,
        "delta": -384723583.4929
      },
      {
        "periodo": 202606,
        "valor": 10810423246.1786,
        "delta": 1515007908.0438
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 546101138.9662,
    "valor_anterior": 369716410.096,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 750941180.8478,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 591719285.7769,
        "delta": -159221895.0709
      },
      {
        "periodo": 202508,
        "valor": 805115680.1609,
        "delta": 213396394.384
      },
      {
        "periodo": 202509,
        "valor": 699978565.4022,
        "delta": -105137114.7587
      },
      {
        "periodo": 202510,
        "valor": 587208308.8824,
        "delta": -112770256.5198
      },
      {
        "periodo": 202511,
        "valor": 434603917.0102,
        "delta": -152604391.8722
      },
      {
        "periodo": 202512,
        "valor": 627117939.9121,
        "delta": 192514022.9019
      },
      {
        "periodo": 202601,
        "valor": 531771569.6681,
        "delta": -95346370.244
      },
      {
        "periodo": 202602,
        "valor": 394892760.9746,
        "delta": -136878808.6935
      },
      {
        "periodo": 202603,
        "valor": 562613402.4011,
        "delta": 167720641.4265
      },
      {
        "periodo": 202604,
        "valor": 448278760.0719,
        "delta": -114334642.3292
      },
      {
        "periodo": 202605,
        "valor": 369716410.096,
        "delta": -78562349.9759
      },
      {
        "periodo": 202606,
        "valor": 546101138.9662,
        "delta": 176384728.8702
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 775311414.8601,
    "valor_anterior": 775018406.1425,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 746840460.5355,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 855248940.151,
        "delta": 108408479.6155
      },
      {
        "periodo": 202508,
        "valor": 823495307.3357,
        "delta": -31753632.8153
      },
      {
        "periodo": 202509,
        "valor": 851137580.0228,
        "delta": 27642272.6871
      },
      {
        "periodo": 202510,
        "valor": 784646990.733,
        "delta": -66490589.2898
      },
      {
        "periodo": 202511,
        "valor": 765625753.2474,
        "delta": -19021237.4856
      },
      {
        "periodo": 202512,
        "valor": 1009035679.8275,
        "delta": 243409926.5801
      },
      {
        "periodo": 202601,
        "valor": 911569437.1839,
        "delta": -97466242.6436
      },
      {
        "periodo": 202602,
        "valor": 782944003.7443,
        "delta": -128625433.4396
      },
      {
        "periodo": 202603,
        "valor": 866326152.0779,
        "delta": 83382148.3336
      },
      {
        "periodo": 202604,
        "valor": 784381621.5525,
        "delta": -81944530.5254
      },
      {
        "periodo": 202605,
        "valor": 775018406.1425,
        "delta": -9363215.41
      },
      {
        "periodo": 202606,
        "valor": 775311414.8601,
        "delta": 293008.7176
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 2508603546.8991,
    "valor_anterior": 2471249374.694,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1877910411.6376,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1967402209.5984,
        "delta": 89491797.9608
      },
      {
        "periodo": 202508,
        "valor": 1926823234.8291,
        "delta": -40578974.7693
      },
      {
        "periodo": 202509,
        "valor": 2030937532.8668,
        "delta": 104114298.0377
      },
      {
        "periodo": 202510,
        "valor": 2024974765.5787,
        "delta": -5962767.2881
      },
      {
        "periodo": 202511,
        "valor": 2163661613.7347,
        "delta": 138686848.156
      },
      {
        "periodo": 202512,
        "valor": 2188101353.1657,
        "delta": 24439739.431
      },
      {
        "periodo": 202601,
        "valor": 2224157134.8272,
        "delta": 36055781.6615
      },
      {
        "periodo": 202602,
        "valor": 2134510645.1436,
        "delta": -89646489.6836
      },
      {
        "periodo": 202603,
        "valor": 2307613197.3902,
        "delta": 173102552.2466
      },
      {
        "periodo": 202604,
        "valor": 2336414816.2822,
        "delta": 28801618.892
      },
      {
        "periodo": 202605,
        "valor": 2471249374.694,
        "delta": 134834558.4118
      },
      {
        "periodo": 202606,
        "valor": 2508603546.8991,
        "delta": 37354172.2051
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 2605758260.8792,
    "valor_anterior": 2544251710.6222,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2456288454.4512,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2501382904.8064,
        "delta": 45094450.3552
      },
      {
        "periodo": 202508,
        "valor": 2509288018.2535,
        "delta": 7905113.4471
      },
      {
        "periodo": 202509,
        "valor": 2588909627.0902,
        "delta": 79621608.8367
      },
      {
        "periodo": 202510,
        "valor": 2554164430.0746,
        "delta": -34745197.0156
      },
      {
        "periodo": 202511,
        "valor": 2531967236.7348,
        "delta": -22197193.3398
      },
      {
        "periodo": 202512,
        "valor": 2574830803.8038,
        "delta": 42863567.069
      },
      {
        "periodo": 202601,
        "valor": 2551130522.6521,
        "delta": -23700281.1517
      },
      {
        "periodo": 202602,
        "valor": 2581863460.0251,
        "delta": 30732937.373
      },
      {
        "periodo": 202603,
        "valor": 2358515474.111,
        "delta": -223347985.9141
      },
      {
        "periodo": 202604,
        "valor": 2530893736.4325,
        "delta": 172378262.3215
      },
      {
        "periodo": 202605,
        "valor": 2544251710.6222,
        "delta": 13357974.1897
      },
      {
        "periodo": 202606,
        "valor": 2605758260.8792,
        "delta": 61506550.257
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1326459830.6521,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1733243890.8893,
        "delta": 406784060.2372
      },
      {
        "periodo": 202508,
        "valor": 1984307170.7474,
        "delta": 251063279.8581
      },
      {
        "periodo": 202509,
        "valor": 2246082600.4051,
        "delta": 261775429.6577
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 4929975541.6307,
    "valor_anterior": 4893898555.1872,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4419870192.0411,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4734771940.2954,
        "delta": 314901748.2543
      },
      {
        "periodo": 202508,
        "valor": 4749255720.5458,
        "delta": 14483780.2504
      },
      {
        "periodo": 202509,
        "valor": 4303433029.599,
        "delta": -445822690.9468
      },
      {
        "periodo": 202510,
        "valor": 4402502908.913,
        "delta": 99069879.314
      },
      {
        "periodo": 202511,
        "valor": 4458843854.7228,
        "delta": 56340945.8098
      },
      {
        "periodo": 202512,
        "valor": 4668914333.6865,
        "delta": 210070478.9637
      },
      {
        "periodo": 202601,
        "valor": 4558947520.3331,
        "delta": -109966813.3534
      },
      {
        "periodo": 202602,
        "valor": 4856988214.97,
        "delta": 298040694.6369
      },
      {
        "periodo": 202603,
        "valor": 5139745414.2506,
        "delta": 282757199.2806
      },
      {
        "periodo": 202604,
        "valor": 4608190677.35,
        "delta": -531554736.9006
      },
      {
        "periodo": 202605,
        "valor": 4893898555.1872,
        "delta": 285707877.8372
      },
      {
        "periodo": 202606,
        "valor": 4929975541.6307,
        "delta": 36076986.4435
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 958086915.4454,
    "valor_anterior": 719724202.0507,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 877725817.7164,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 850433403.4838,
        "delta": -27292414.2326
      },
      {
        "periodo": 202508,
        "valor": 904526762.264,
        "delta": 54093358.7802
      },
      {
        "periodo": 202509,
        "valor": 855547814.8055,
        "delta": -48978947.4585
      },
      {
        "periodo": 202510,
        "valor": 863843719.9018,
        "delta": 8295905.0963
      },
      {
        "periodo": 202511,
        "valor": 806202604.3969,
        "delta": -57641115.5049
      },
      {
        "periodo": 202512,
        "valor": 948157618.9674,
        "delta": 141955014.5705
      },
      {
        "periodo": 202601,
        "valor": 874540372.9454,
        "delta": -73617246.022
      },
      {
        "periodo": 202602,
        "valor": 905342053.9872,
        "delta": 30801681.0418
      },
      {
        "periodo": 202603,
        "valor": 1019721257.6393,
        "delta": 114379203.6521
      },
      {
        "periodo": 202604,
        "valor": 833996311.6686,
        "delta": -185724945.9707
      },
      {
        "periodo": 202605,
        "valor": 719724202.0507,
        "delta": -114272109.6179
      },
      {
        "periodo": 202606,
        "valor": 958086915.4454,
        "delta": 238362713.3947
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 285150132.5089,
    "valor_anterior": 281051549.7286,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 278789885.8404,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 289902037.3519,
        "delta": 11112151.5115
      },
      {
        "periodo": 202508,
        "valor": 279731888.3265,
        "delta": -10170149.0254
      },
      {
        "periodo": 202509,
        "valor": 286107825.7437,
        "delta": 6375937.4172
      },
      {
        "periodo": 202510,
        "valor": 278905900.5026,
        "delta": -7201925.2411
      },
      {
        "periodo": 202511,
        "valor": 289762905.5529,
        "delta": 10857005.0503
      },
      {
        "periodo": 202512,
        "valor": 292993837.7142,
        "delta": 3230932.1613
      },
      {
        "periodo": 202601,
        "valor": 284993112.1299,
        "delta": -8000725.5843
      },
      {
        "periodo": 202602,
        "valor": 285886771.1849,
        "delta": 893659.055
      },
      {
        "periodo": 202603,
        "valor": 282688012.5184,
        "delta": -3198758.6665
      },
      {
        "periodo": 202604,
        "valor": 281325027.8574,
        "delta": -1362984.661
      },
      {
        "periodo": 202605,
        "valor": 281051549.7286,
        "delta": -273478.1288
      },
      {
        "periodo": 202606,
        "valor": 285150132.5089,
        "delta": 4098582.7803
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 403881567.5959,
    "valor_anterior": 405971437.6692,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 396792889.7013,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 393147596.5345,
        "delta": -3645293.1668
      },
      {
        "periodo": 202508,
        "valor": 395824927.7357,
        "delta": 2677331.2012
      },
      {
        "periodo": 202509,
        "valor": 391443360.4146,
        "delta": -4381567.3211
      },
      {
        "periodo": 202510,
        "valor": 384456302.1679,
        "delta": -6987058.2467
      },
      {
        "periodo": 202511,
        "valor": 377625003.2611,
        "delta": -6831298.9068
      },
      {
        "periodo": 202512,
        "valor": 413772305.6629,
        "delta": 36147302.4018
      },
      {
        "periodo": 202601,
        "valor": 409326219.7551,
        "delta": -4446085.9078
      },
      {
        "periodo": 202602,
        "valor": 411881453.9529,
        "delta": 2555234.1978
      },
      {
        "periodo": 202603,
        "valor": 408250321.74,
        "delta": -3631132.2129
      },
      {
        "periodo": 202604,
        "valor": 408988837.2431,
        "delta": 738515.5031
      },
      {
        "periodo": 202605,
        "valor": 405971437.6692,
        "delta": -3017399.5739
      },
      {
        "periodo": 202606,
        "valor": 403881567.5959,
        "delta": -2089870.0733
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 1164395228.9162,
    "valor_anterior": 1174645032.6473,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1184046748.627,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1191897542.6249,
        "delta": 7850793.9979
      },
      {
        "periodo": 202508,
        "valor": 1169569697.6715,
        "delta": -22327844.9534
      },
      {
        "periodo": 202509,
        "valor": 1159177129.405,
        "delta": -10392568.2665
      },
      {
        "periodo": 202510,
        "valor": 1161666462.2985,
        "delta": 2489332.8935
      },
      {
        "periodo": 202511,
        "valor": 1138839859.7901,
        "delta": -22826602.5084
      },
      {
        "periodo": 202512,
        "valor": 1173225680.3734,
        "delta": 34385820.5833
      },
      {
        "periodo": 202601,
        "valor": 1180952087.9279,
        "delta": 7726407.5545
      },
      {
        "periodo": 202602,
        "valor": 1191671714.8592,
        "delta": 10719626.9313
      },
      {
        "periodo": 202603,
        "valor": 1180916338.8625,
        "delta": -10755375.9967
      },
      {
        "periodo": 202604,
        "valor": 1179390666.5039,
        "delta": -1525672.3586
      },
      {
        "periodo": 202605,
        "valor": 1174645032.6473,
        "delta": -4745633.8566
      },
      {
        "periodo": 202606,
        "valor": 1164395228.9162,
        "delta": -10249803.7311
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 336664576.6509,
    "valor_anterior": 332698898.042,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 297836381.7014,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 300205254.5154,
        "delta": 2368872.814
      },
      {
        "periodo": 202508,
        "valor": 312178235.045,
        "delta": 11972980.5296
      },
      {
        "periodo": 202509,
        "valor": 305185202.8837,
        "delta": -6993032.1613
      },
      {
        "periodo": 202510,
        "valor": 307497506.8764,
        "delta": 2312303.9927
      },
      {
        "periodo": 202511,
        "valor": 306912400.6971,
        "delta": -585106.1793
      },
      {
        "periodo": 202512,
        "valor": 319945705.5907,
        "delta": 13033304.8936
      },
      {
        "periodo": 202601,
        "valor": 337407620.8348,
        "delta": 17461915.2441
      },
      {
        "periodo": 202602,
        "valor": 332294986.0534,
        "delta": -5112634.7814
      },
      {
        "periodo": 202603,
        "valor": 329503666.6788,
        "delta": -2791319.3746
      },
      {
        "periodo": 202604,
        "valor": 326693151.0512,
        "delta": -2810515.6276
      },
      {
        "periodo": 202605,
        "valor": 332698898.042,
        "delta": 6005746.9908
      },
      {
        "periodo": 202606,
        "valor": 336664576.6509,
        "delta": 3965678.6089
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 2660640537.3219,
    "valor_anterior": 2655691402.5009,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2412217501.8352,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2488845259.4752,
        "delta": 76627757.64
      },
      {
        "periodo": 202508,
        "valor": 2375898242.1615,
        "delta": -112947017.3137
      },
      {
        "periodo": 202509,
        "valor": 2443310638.3015,
        "delta": 67412396.14
      },
      {
        "periodo": 202510,
        "valor": 2451374591.4585,
        "delta": 8063953.157
      },
      {
        "periodo": 202511,
        "valor": 2474664908.0557,
        "delta": 23290316.5972
      },
      {
        "periodo": 202512,
        "valor": 2598899974.7775,
        "delta": 124235066.7218
      },
      {
        "periodo": 202601,
        "valor": 2541546825.6024,
        "delta": -57353149.1751
      },
      {
        "periodo": 202602,
        "valor": 2625181611.1917,
        "delta": 83634785.5893
      },
      {
        "periodo": 202603,
        "valor": 2592614203.5019,
        "delta": -32567407.6898
      },
      {
        "periodo": 202604,
        "valor": 2610175343.5899,
        "delta": 17561140.088
      },
      {
        "periodo": 202605,
        "valor": 2655691402.5009,
        "delta": 45516058.911
      },
      {
        "periodo": 202606,
        "valor": 2660640537.3219,
        "delta": 4949134.821
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 589185156.9046,
    "valor_anterior": 520449397.6554,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 372944073.1976,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 392865823.5979,
        "delta": 19921750.4003
      },
      {
        "periodo": 202508,
        "valor": 393046496.6228,
        "delta": 180673.0249
      },
      {
        "periodo": 202509,
        "valor": 415616677.0976,
        "delta": 22570180.4748
      },
      {
        "periodo": 202510,
        "valor": 427891891.9754,
        "delta": 12275214.8778
      },
      {
        "periodo": 202511,
        "valor": 456562592.426,
        "delta": 28670700.4506
      },
      {
        "periodo": 202512,
        "valor": 463570737.7534,
        "delta": 7008145.3274
      },
      {
        "periodo": 202601,
        "valor": 456685615.1408,
        "delta": -6885122.6126
      },
      {
        "periodo": 202602,
        "valor": 471552588.9201,
        "delta": 14866973.7793
      },
      {
        "periodo": 202603,
        "valor": 494721913.1836,
        "delta": 23169324.2635
      },
      {
        "periodo": 202604,
        "valor": 494119516.1753,
        "delta": -602397.0083
      },
      {
        "periodo": 202605,
        "valor": 520449397.6554,
        "delta": 26329881.4801
      },
      {
        "periodo": 202606,
        "valor": 589185156.9046,
        "delta": 68735759.2492
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 1433245720.6455,
    "valor_anterior": 1475735214.5258,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1284000868.383,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1326227838.3915,
        "delta": 42226970.0085
      },
      {
        "periodo": 202508,
        "valor": 1330780409.2331,
        "delta": 4552570.8416
      },
      {
        "periodo": 202509,
        "valor": 1335467584.5445,
        "delta": 4687175.3114
      },
      {
        "periodo": 202510,
        "valor": 1335556704.7701,
        "delta": 89120.2256
      },
      {
        "periodo": 202511,
        "valor": 1384364470.8942,
        "delta": 48807766.1241
      },
      {
        "periodo": 202512,
        "valor": 1361456659.5248,
        "delta": -22907811.3694
      },
      {
        "periodo": 202601,
        "valor": 1387680608.3699,
        "delta": 26223948.8451
      },
      {
        "periodo": 202602,
        "valor": 1370377244.1635,
        "delta": -17303364.2064
      },
      {
        "periodo": 202603,
        "valor": 1422351673.5426,
        "delta": 51974429.3791
      },
      {
        "periodo": 202604,
        "valor": 1424809857.2517,
        "delta": 2458183.7091
      },
      {
        "periodo": 202605,
        "valor": 1475735214.5258,
        "delta": 50925357.2741
      },
      {
        "periodo": 202606,
        "valor": 1433245720.6455,
        "delta": -42489493.8803
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 7220760918.2465,
    "valor_anterior": 7017777521.7181,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 6628454288.6649,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 6669990019.7716,
        "delta": 41535731.1067
      },
      {
        "periodo": 202508,
        "valor": 6854206475.2307,
        "delta": 184216455.4591
      },
      {
        "periodo": 202509,
        "valor": 6892769493.3975,
        "delta": 38563018.1668
      },
      {
        "periodo": 202510,
        "valor": 6759137159.5598,
        "delta": -133632333.8377
      },
      {
        "periodo": 202511,
        "valor": 6741813299.6842,
        "delta": -17323859.8756
      },
      {
        "periodo": 202512,
        "valor": 7015507145.8539,
        "delta": 273693846.1697
      },
      {
        "periodo": 202601,
        "valor": 6872187501.7366,
        "delta": -143319644.1173
      },
      {
        "periodo": 202602,
        "valor": 6908868202.5247,
        "delta": 36680700.7881
      },
      {
        "periodo": 202603,
        "valor": 6955025980.9259,
        "delta": 46157778.4012
      },
      {
        "periodo": 202604,
        "valor": 6943920645.1931,
        "delta": -11105335.7328
      },
      {
        "periodo": 202605,
        "valor": 7017777521.7181,
        "delta": 73856876.525
      },
      {
        "periodo": 202606,
        "valor": 7220760918.2465,
        "delta": 202983396.5284
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 1558092353.5409,
    "valor_anterior": 1583987770.9766,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1478604682.98,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1430550756.3304,
        "delta": -48053926.6496
      },
      {
        "periodo": 202508,
        "valor": 1446446855.8264,
        "delta": 15896099.496
      },
      {
        "periodo": 202509,
        "valor": 1473304860.334,
        "delta": 26858004.5076
      },
      {
        "periodo": 202510,
        "valor": 1486068749.7892,
        "delta": 12763889.4552
      },
      {
        "periodo": 202511,
        "valor": 1498925611.9884,
        "delta": 12856862.1992
      },
      {
        "periodo": 202512,
        "valor": 1514208921.633,
        "delta": 15283309.6446
      },
      {
        "periodo": 202601,
        "valor": 1521858938.1384,
        "delta": 7650016.5054
      },
      {
        "periodo": 202602,
        "valor": 1539422409.271,
        "delta": 17563471.1326
      },
      {
        "periodo": 202603,
        "valor": 1560026774.7515,
        "delta": 20604365.4805
      },
      {
        "periodo": 202604,
        "valor": 1551113177.7982,
        "delta": -8913596.9533
      },
      {
        "periodo": 202605,
        "valor": 1583987770.9766,
        "delta": 32874593.1784
      },
      {
        "periodo": 202606,
        "valor": 1558092353.5409,
        "delta": -25895417.4357
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 4070379428.4561,
    "valor_anterior": 4051990647.2579,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4056939427.4622,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4052038730.4813,
        "delta": -4900696.9809
      },
      {
        "periodo": 202508,
        "valor": 4074264195.0104,
        "delta": 22225464.5291
      },
      {
        "periodo": 202509,
        "valor": 4137324741.9482,
        "delta": 63060546.9378
      },
      {
        "periodo": 202510,
        "valor": 4158326877.6823,
        "delta": 21002135.7341
      },
      {
        "periodo": 202511,
        "valor": 4273282638.1693,
        "delta": 114955760.487
      },
      {
        "periodo": 202512,
        "valor": 4215919939.4179,
        "delta": -57362698.7514
      },
      {
        "periodo": 202601,
        "valor": 4248746300.6978,
        "delta": 32826361.2799
      },
      {
        "periodo": 202602,
        "valor": 4233882474.7192,
        "delta": -14863825.9786
      },
      {
        "periodo": 202603,
        "valor": 4232194506.5904,
        "delta": -1687968.1288
      },
      {
        "periodo": 202604,
        "valor": 4070495010.6832,
        "delta": -161699495.9072
      },
      {
        "periodo": 202605,
        "valor": 4051990647.2579,
        "delta": -18504363.4253
      },
      {
        "periodo": 202606,
        "valor": 4070379428.4561,
        "delta": 18388781.1982
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 1767134963.0808,
    "valor_anterior": 1814827887.2938,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1763444731.8485,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1788858752.3862,
        "delta": 25414020.5377
      },
      {
        "periodo": 202508,
        "valor": 1809704086.1689,
        "delta": 20845333.7827
      },
      {
        "periodo": 202509,
        "valor": 1830289202.3145,
        "delta": 20585116.1456
      },
      {
        "periodo": 202510,
        "valor": 1822726929.7683,
        "delta": -7562272.5462
      },
      {
        "periodo": 202511,
        "valor": 1827828521.8025,
        "delta": 5101592.0342
      },
      {
        "periodo": 202512,
        "valor": 1841768388.9406,
        "delta": 13939867.1381
      },
      {
        "periodo": 202601,
        "valor": 1825606776.9508,
        "delta": -16161611.9898
      },
      {
        "periodo": 202602,
        "valor": 1855372039.3294,
        "delta": 29765262.3786
      },
      {
        "periodo": 202603,
        "valor": 1846664594.6736,
        "delta": -8707444.6558
      },
      {
        "periodo": 202604,
        "valor": 1829641170.4215,
        "delta": -17023424.2521
      },
      {
        "periodo": 202605,
        "valor": 1814827887.2938,
        "delta": -14813283.1277
      },
      {
        "periodo": 202606,
        "valor": 1767134963.0808,
        "delta": -47692924.213
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 2631786878.9225,
    "valor_anterior": 2597313606.5525,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2329309175.0553,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 2356468233.4712,
        "delta": 27159058.4159
      },
      {
        "periodo": 202508,
        "valor": 2381350502.3637,
        "delta": 24882268.8925
      },
      {
        "periodo": 202509,
        "valor": 2411225247.1875,
        "delta": 29874744.8238
      },
      {
        "periodo": 202510,
        "valor": 2439943152.3166,
        "delta": 28717905.1291
      },
      {
        "periodo": 202511,
        "valor": 2465068436.9655,
        "delta": 25125284.6489
      },
      {
        "periodo": 202512,
        "valor": 2473646600.75,
        "delta": 8578163.7845
      },
      {
        "periodo": 202601,
        "valor": 2504731395.8753,
        "delta": 31084795.1253
      },
      {
        "periodo": 202602,
        "valor": 2533656409.968,
        "delta": 28925014.0927
      },
      {
        "periodo": 202603,
        "valor": 2513333332.0158,
        "delta": -20323077.9522
      },
      {
        "periodo": 202604,
        "valor": 2585943428.7342,
        "delta": 72610096.7184
      },
      {
        "periodo": 202605,
        "valor": 2597313606.5525,
        "delta": 11370177.8183
      },
      {
        "periodo": 202606,
        "valor": 2631786878.9225,
        "delta": 34473272.37
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 1440914287.8308,
    "valor_anterior": 1451700973.4747,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1387392681.4157,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1383272067.6008,
        "delta": -4120613.8149
      },
      {
        "periodo": 202508,
        "valor": 1415266194.398,
        "delta": 31994126.7972
      },
      {
        "periodo": 202509,
        "valor": 1419960160.6567,
        "delta": 4693966.2587
      },
      {
        "periodo": 202510,
        "valor": 1418722546.5463,
        "delta": -1237614.1104
      },
      {
        "periodo": 202511,
        "valor": 1411273897.1282,
        "delta": -7448649.4181
      },
      {
        "periodo": 202512,
        "valor": 1421525302.4717,
        "delta": 10251405.3435
      },
      {
        "periodo": 202601,
        "valor": 1434830599.6893,
        "delta": 13305297.2176
      },
      {
        "periodo": 202602,
        "valor": 1432330644.9048,
        "delta": -2499954.7845
      },
      {
        "periodo": 202603,
        "valor": 1430468410.3344,
        "delta": -1862234.5704
      },
      {
        "periodo": 202604,
        "valor": 1429561690.7733,
        "delta": -906719.5611
      },
      {
        "periodo": 202605,
        "valor": 1451700973.4747,
        "delta": 22139282.7014
      },
      {
        "periodo": 202606,
        "valor": 1440914287.8308,
        "delta": -10786685.6439
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 5031369468.4827,
    "valor_anterior": 4935313040.8275,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 4768783847.9537,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 4806836079.9488,
        "delta": 38052231.9951
      },
      {
        "periodo": 202508,
        "valor": 4917760615.9628,
        "delta": 110924536.014
      },
      {
        "periodo": 202509,
        "valor": 4940299180.7286,
        "delta": 22538564.7658
      },
      {
        "periodo": 202510,
        "valor": 5006135234.1696,
        "delta": 65836053.441
      },
      {
        "periodo": 202511,
        "valor": 4900832156.7716,
        "delta": -105303077.398
      },
      {
        "periodo": 202512,
        "valor": 4877806683.2152,
        "delta": -23025473.5564
      },
      {
        "periodo": 202601,
        "valor": 5053253414.9615,
        "delta": 175446731.7463
      },
      {
        "periodo": 202602,
        "valor": 4971444197.9664,
        "delta": -81809216.9951
      },
      {
        "periodo": 202603,
        "valor": 4983298105.4956,
        "delta": 11853907.5292
      },
      {
        "periodo": 202604,
        "valor": 4822592554.0,
        "delta": -160705551.4956
      },
      {
        "periodo": 202605,
        "valor": 4935313040.8275,
        "delta": 112720486.8275
      },
      {
        "periodo": 202606,
        "valor": 5031369468.4827,
        "delta": 96056427.6552
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 816901999.6951,
    "valor_anterior": 816752757.2587,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 923251036.4269,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 861052935.7737,
        "delta": -62198100.6532
      },
      {
        "periodo": 202508,
        "valor": 746884120.1061,
        "delta": -114168815.6676
      },
      {
        "periodo": 202509,
        "valor": 831150526.1807,
        "delta": 84266406.0746
      },
      {
        "periodo": 202510,
        "valor": 838694635.0327,
        "delta": 7544108.852
      },
      {
        "periodo": 202511,
        "valor": 826179265.6816,
        "delta": -12515369.3511
      },
      {
        "periodo": 202512,
        "valor": 918425005.7775,
        "delta": 92245740.0959
      },
      {
        "periodo": 202601,
        "valor": 865554140.6318,
        "delta": -52870865.1457
      },
      {
        "periodo": 202602,
        "valor": 875002030.4754,
        "delta": 9447889.8436
      },
      {
        "periodo": 202603,
        "valor": 836711293.8565,
        "delta": -38290736.6189
      },
      {
        "periodo": 202604,
        "valor": 829588280.5445,
        "delta": -7123013.312
      },
      {
        "periodo": 202605,
        "valor": 816752757.2587,
        "delta": -12835523.2858
      },
      {
        "periodo": 202606,
        "valor": 816901999.6951,
        "delta": 149242.4364
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 830828049.3577,
    "valor_anterior": 792385408.0928,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1535161432.3843,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1536897216.3497,
        "delta": 1735783.9654
      },
      {
        "periodo": 202508,
        "valor": 1539389554.569,
        "delta": 2492338.2193
      },
      {
        "periodo": 202509,
        "valor": 1543042673.9219,
        "delta": 3653119.3529
      },
      {
        "periodo": 202510,
        "valor": 1544271957.6661,
        "delta": 1229283.7442
      },
      {
        "periodo": 202511,
        "valor": 1547465388.911,
        "delta": 3193431.2449
      },
      {
        "periodo": 202512,
        "valor": 1550120965.3804,
        "delta": 2655576.4694
      },
      {
        "periodo": 202601,
        "valor": 1557377200.9676,
        "delta": 7256235.5872
      },
      {
        "periodo": 202602,
        "valor": 969971441.6502,
        "delta": -587405759.3174
      },
      {
        "periodo": 202603,
        "valor": 839875043.9846,
        "delta": -130096397.6656
      },
      {
        "periodo": 202604,
        "valor": 775486676.9236,
        "delta": -64388367.061
      },
      {
        "periodo": 202605,
        "valor": 792385408.0928,
        "delta": 16898731.1692
      },
      {
        "periodo": 202606,
        "valor": 830828049.3577,
        "delta": 38442641.2649
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 2561437046.1575,
    "valor_anterior": 1074390143.8855,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 2033251853.6938,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1887173276.7983,
        "delta": -146078576.8955
      },
      {
        "periodo": 202508,
        "valor": 1687569906.2092,
        "delta": -199603370.5891
      },
      {
        "periodo": 202509,
        "valor": 1483351783.9718,
        "delta": -204218122.2374
      },
      {
        "periodo": 202510,
        "valor": 1194567937.4856,
        "delta": -288783846.4862
      },
      {
        "periodo": 202511,
        "valor": 908448274.2634,
        "delta": -286119663.2222
      },
      {
        "periodo": 202512,
        "valor": 1353295331.5951,
        "delta": 444847057.3317
      },
      {
        "periodo": 202601,
        "valor": 2322001706.6566,
        "delta": 968706375.0615
      },
      {
        "periodo": 202602,
        "valor": 2056434156.6528,
        "delta": -265567550.0038
      },
      {
        "periodo": 202603,
        "valor": 1499976142.9518,
        "delta": -556458013.701
      },
      {
        "periodo": 202604,
        "valor": 1336797337.082,
        "delta": -163178805.8698
      },
      {
        "periodo": 202605,
        "valor": 1074390143.8855,
        "delta": -262407193.1965
      },
      {
        "periodo": 202606,
        "valor": 2561437046.1575,
        "delta": 1487046902.272
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 2059709640.2101,
    "valor_anterior": 2146230880.7333,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 1301500470.2883,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 1354299975.3722,
        "delta": 52799505.0839
      },
      {
        "periodo": 202601,
        "valor": 1312849912.6466,
        "delta": -41450062.7256
      },
      {
        "periodo": 202602,
        "valor": 1253046629.5189,
        "delta": -59803283.1277
      },
      {
        "periodo": 202603,
        "valor": 1199820905.7707,
        "delta": -53225723.7482
      },
      {
        "periodo": 202604,
        "valor": 2212935749.161,
        "delta": 1013114843.3903
      },
      {
        "periodo": 202605,
        "valor": 2146230880.7333,
        "delta": -66704868.4277
      },
      {
        "periodo": 202606,
        "valor": 2059709640.2101,
        "delta": -86521240.5232
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 3130100276.8069,
    "valor_anterior": 2326152522.7789,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 1832593192.6412,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 2799537856.7776,
        "delta": 966944664.1364
      },
      {
        "periodo": 202605,
        "valor": 2326152522.7789,
        "delta": -473385333.9987
      },
      {
        "periodo": 202606,
        "valor": 3130100276.8069,
        "delta": 803947754.028
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 1193034297559.2031,
    "valor_anterior": 1184011801224.4434,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 1065892299813.8594,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 1089758846221.3591,
        "delta": 23866546407.4998
      },
      {
        "periodo": 202508,
        "valor": 1105727913477.0188,
        "delta": 15969067255.6597
      },
      {
        "periodo": 202509,
        "valor": 1110177703101.081,
        "delta": 4449789624.0623
      },
      {
        "periodo": 202510,
        "valor": 1129864782814.468,
        "delta": 19687079713.387
      },
      {
        "periodo": 202511,
        "valor": 1103690609458.1567,
        "delta": -26174173356.3113
      },
      {
        "periodo": 202512,
        "valor": 1094188007362.6425,
        "delta": -9502602095.5143
      },
      {
        "periodo": 202601,
        "valor": 1109391178178.5923,
        "delta": 15203170815.9498
      },
      {
        "periodo": 202602,
        "valor": 1146910509255.8896,
        "delta": 37519331077.2974
      },
      {
        "periodo": 202603,
        "valor": 1154741711319.6248,
        "delta": 7831202063.7351
      },
      {
        "periodo": 202604,
        "valor": 1137422177395.144,
        "delta": -17319533924.4807
      },
      {
        "periodo": 202605,
        "valor": 1184011801224.4434,
        "delta": 46589623829.2993
      },
      {
        "periodo": 202606,
        "valor": 1193034297559.2031,
        "delta": 9022496334.7598
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 881937681648.0059,
    "valor_anterior": 878749181476.1128,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 792857783061.8679,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 811072866715.8191,
        "delta": 18215083653.9512
      },
      {
        "periodo": 202508,
        "valor": 824207896571.2458,
        "delta": 13135029855.4268
      },
      {
        "periodo": 202509,
        "valor": 818815836823.9604,
        "delta": -5392059747.2854
      },
      {
        "periodo": 202510,
        "valor": 836773109555.1116,
        "delta": 17957272731.1511
      },
      {
        "periodo": 202511,
        "valor": 818315737499.6538,
        "delta": -18457372055.4578
      },
      {
        "periodo": 202512,
        "valor": 799379499171.8818,
        "delta": -18936238327.772
      },
      {
        "periodo": 202601,
        "valor": 811365360805.1824,
        "delta": 11985861633.3005
      },
      {
        "periodo": 202602,
        "valor": 847262405600.69,
        "delta": 35897044795.5076
      },
      {
        "periodo": 202603,
        "valor": 853205839744.6874,
        "delta": 5943434143.9974
      },
      {
        "periodo": 202604,
        "valor": 839854060915.8303,
        "delta": -13351778828.8571
      },
      {
        "periodo": 202605,
        "valor": 878749181476.1128,
        "delta": 38895120560.2825
      },
      {
        "periodo": 202606,
        "valor": 881937681648.0059,
        "delta": 3188500171.8931
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 17528856106.0838,
    "valor_anterior": 17632023601.1807,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 20363147104.8035,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 22553290410.2365,
        "delta": 2190143305.433
      },
      {
        "periodo": 202508,
        "valor": 23739072761.5253,
        "delta": 1185782351.2888
      },
      {
        "periodo": 202509,
        "valor": 24414597160.7428,
        "delta": 675524399.2175
      },
      {
        "periodo": 202510,
        "valor": 22602591544.1926,
        "delta": -1812005616.5502
      },
      {
        "periodo": 202511,
        "valor": 16753374403.7856,
        "delta": -5849217140.407
      },
      {
        "periodo": 202512,
        "valor": 17148389455.8082,
        "delta": 395015052.0226
      },
      {
        "periodo": 202601,
        "valor": 17303868148.797,
        "delta": 155478692.9888
      },
      {
        "periodo": 202602,
        "valor": 17969905407.9179,
        "delta": 666037259.1209
      },
      {
        "periodo": 202603,
        "valor": 18474023214.6884,
        "delta": 504117806.7705
      },
      {
        "periodo": 202604,
        "valor": 16732168799.7854,
        "delta": -1741854414.903
      },
      {
        "periodo": 202605,
        "valor": 17632023601.1807,
        "delta": 899854801.3953
      },
      {
        "periodo": 202606,
        "valor": 17528856106.0838,
        "delta": -103167495.0969
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 140267764629.4795,
    "valor_anterior": 139296627160.4366,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 121334009196.1826,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 124184648828.0786,
        "delta": 2850639631.896
      },
      {
        "periodo": 202508,
        "valor": 125043286246.323,
        "delta": 858637418.2444
      },
      {
        "periodo": 202509,
        "valor": 128501349263.332,
        "delta": 3458063017.009
      },
      {
        "periodo": 202510,
        "valor": 129219336401.8314,
        "delta": 717987138.4994
      },
      {
        "periodo": 202511,
        "valor": 129171077063.1469,
        "delta": -48259338.6845
      },
      {
        "periodo": 202512,
        "valor": 134655457000.1011,
        "delta": 5484379936.9542
      },
      {
        "periodo": 202601,
        "valor": 135035188144.8344,
        "delta": 379731144.7333
      },
      {
        "periodo": 202602,
        "valor": 133862448400.032,
        "delta": -1172739744.8024
      },
      {
        "periodo": 202603,
        "valor": 134661523058.7598,
        "delta": 799074658.7278
      },
      {
        "periodo": 202604,
        "valor": 136358569379.8446,
        "delta": 1697046321.0848
      },
      {
        "periodo": 202605,
        "valor": 139296627160.4366,
        "delta": 2938057780.592
      },
      {
        "periodo": 202606,
        "valor": 140267764629.4795,
        "delta": 971137469.0429
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 62382991225.2122,
    "valor_anterior": 61562646554.0916,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 51877131403.7313,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 53084772390.079,
        "delta": 1207640986.3477
      },
      {
        "periodo": 202508,
        "valor": 54775298175.7645,
        "delta": 1690525785.6855
      },
      {
        "periodo": 202509,
        "valor": 55964033374.4053,
        "delta": 1188735198.6408
      },
      {
        "periodo": 202510,
        "valor": 57203272834.6179,
        "delta": 1239239460.2126
      },
      {
        "periodo": 202511,
        "valor": 56185643563.7701,
        "delta": -1017629270.8478
      },
      {
        "periodo": 202512,
        "valor": 57566976372.2308,
        "delta": 1381332808.4607
      },
      {
        "periodo": 202601,
        "valor": 59346874243.1734,
        "delta": 1779897870.9426
      },
      {
        "periodo": 202602,
        "valor": 60851666794.8601,
        "delta": 1504792551.6867
      },
      {
        "periodo": 202603,
        "valor": 59689008763.2054,
        "delta": -1162658031.6547
      },
      {
        "periodo": 202604,
        "valor": 56183515340.0285,
        "delta": -3505493423.1769
      },
      {
        "periodo": 202605,
        "valor": 61562646554.0916,
        "delta": 5379131214.0631
      },
      {
        "periodo": 202606,
        "valor": 62382991225.2122,
        "delta": 820344671.1206
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 28269919438.6556,
    "valor_anterior": 27652601068.4298,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 25021984139.6314,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 24895127102.2594,
        "delta": -126857037.372
      },
      {
        "periodo": 202508,
        "valor": 24998488991.953,
        "delta": 103361889.6936
      },
      {
        "periodo": 202509,
        "valor": 26277846378.2946,
        "delta": 1279357386.3416
      },
      {
        "periodo": 202510,
        "valor": 27049444893.7312,
        "delta": 771598515.4366
      },
      {
        "periodo": 202511,
        "valor": 26642354781.8519,
        "delta": -407090111.8793
      },
      {
        "periodo": 202512,
        "valor": 26848489654.0813,
        "delta": 206134872.2294
      },
      {
        "periodo": 202601,
        "valor": 27074922717.0984,
        "delta": 226433063.0171
      },
      {
        "periodo": 202602,
        "valor": 27425401165.9354,
        "delta": 350478448.837
      },
      {
        "periodo": 202603,
        "valor": 28021653145.213,
        "delta": 596251979.2776
      },
      {
        "periodo": 202604,
        "valor": 27733401569.3842,
        "delta": -288251575.8288
      },
      {
        "periodo": 202605,
        "valor": 27652601068.4298,
        "delta": -80800500.9544
      },
      {
        "periodo": 202606,
        "valor": 28269919438.6556,
        "delta": 617318370.2258
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 4030216,
    "label": "Sobrante / (Faltante) de Capital Jun 2026",
    "valor_actual": 62647084511.7663,
    "valor_anterior": 59118721364.1918,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202506,
        "valor": 54438244907.6427,
        "delta": null
      },
      {
        "periodo": 202507,
        "valor": 53968140774.8865,
        "delta": -470104132.7562
      },
      {
        "periodo": 202508,
        "valor": 52963870730.2071,
        "delta": -1004270044.6794
      },
      {
        "periodo": 202509,
        "valor": 56204040100.3459,
        "delta": 3240169370.1388
      },
      {
        "periodo": 202510,
        "valor": 57017027584.9832,
        "delta": 812987484.6373
      },
      {
        "periodo": 202511,
        "valor": 56622422145.9484,
        "delta": -394605439.0348
      },
      {
        "periodo": 202512,
        "valor": 58589195708.5393,
        "delta": 1966773562.5909
      },
      {
        "periodo": 202601,
        "valor": 59264964119.5067,
        "delta": 675768410.9674
      },
      {
        "periodo": 202602,
        "valor": 59538681886.4543,
        "delta": 273717766.9476
      },
      {
        "periodo": 202603,
        "valor": 60689663393.0708,
        "delta": 1150981506.6165
      },
      {
        "periodo": 202604,
        "valor": 60560461390.2711,
        "delta": -129202002.7997
      },
      {
        "periodo": 202605,
        "valor": 59118721364.1918,
        "delta": -1441740026.0793
      },
      {
        "periodo": 202606,
        "valor": 62647084511.7663,
        "delta": 3528363147.5745
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -29500121053.91,
    "valor_anterior": -29436380363.86,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -26028892767.66,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -26257443025.9,
        "delta": -228550258.24
      },
      {
        "periodo": 202509,
        "valor": -26853186069.35,
        "delta": -595743043.45
      },
      {
        "periodo": 202510,
        "valor": -27510188801.84,
        "delta": -657002732.49
      },
      {
        "periodo": 202511,
        "valor": -28020509327.69,
        "delta": -510320525.85
      },
      {
        "periodo": 202512,
        "valor": -28247281060.06,
        "delta": -226771732.37
      },
      {
        "periodo": 202601,
        "valor": -28333519896.32,
        "delta": -86238836.26
      },
      {
        "periodo": 202602,
        "valor": -28272363033.66,
        "delta": 61156862.66
      },
      {
        "periodo": 202603,
        "valor": -28485103328.97,
        "delta": -212740295.31
      },
      {
        "periodo": 202604,
        "valor": -28736268810.59,
        "delta": -251165481.62
      },
      {
        "periodo": 202605,
        "valor": -29198842056.86,
        "delta": -462573246.27
      },
      {
        "periodo": 202606,
        "valor": -29436380363.86,
        "delta": -237538307.0
      },
      {
        "periodo": 202607,
        "valor": -29500121053.91,
        "delta": -63740690.05
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -71437982598.22,
    "valor_anterior": -71065705448.63,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -62019893350.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -62796002053.32,
        "delta": -776108703.07
      },
      {
        "periodo": 202509,
        "valor": -63178180221.43,
        "delta": -382178168.11
      },
      {
        "periodo": 202510,
        "valor": -64206436418.82,
        "delta": -1028256197.39
      },
      {
        "periodo": 202511,
        "valor": -64064395775.67,
        "delta": 142040643.15
      },
      {
        "periodo": 202512,
        "valor": -63457648396.09,
        "delta": 606747379.58
      },
      {
        "periodo": 202601,
        "valor": -63536244704.28,
        "delta": -78596308.19
      },
      {
        "periodo": 202602,
        "valor": -66951381470.06,
        "delta": -3415136765.78
      },
      {
        "periodo": 202603,
        "valor": -68407593748.2,
        "delta": -1456212278.14
      },
      {
        "periodo": 202604,
        "valor": -68491972769.73,
        "delta": -84379021.53
      },
      {
        "periodo": 202605,
        "valor": -69860390626.35,
        "delta": -1368417856.62
      },
      {
        "periodo": 202606,
        "valor": -71065705448.63,
        "delta": -1205314822.28
      },
      {
        "periodo": 202607,
        "valor": -71437982598.22,
        "delta": -372277149.59
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -32710671446.0,
    "valor_anterior": -32492277273.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -29216775833.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -29016167772.0,
        "delta": 200608061.0
      },
      {
        "periodo": 202509,
        "valor": -29584926104.0,
        "delta": -568758332.0
      },
      {
        "periodo": 202510,
        "valor": -29914972324.0,
        "delta": -330046220.0
      },
      {
        "periodo": 202511,
        "valor": -29997522561.0,
        "delta": -82550237.0
      },
      {
        "periodo": 202512,
        "valor": -29814295973.0,
        "delta": 183226588.0
      },
      {
        "periodo": 202601,
        "valor": -29737096313.0,
        "delta": 77199660.0
      },
      {
        "periodo": 202602,
        "valor": -30467568303.0,
        "delta": -730471990.0
      },
      {
        "periodo": 202603,
        "valor": -30785099014.0,
        "delta": -317530711.0
      },
      {
        "periodo": 202604,
        "valor": -30714194650.0,
        "delta": 70904364.0
      },
      {
        "periodo": 202605,
        "valor": -33300974067.0,
        "delta": -2586779417.0
      },
      {
        "periodo": 202606,
        "valor": -32492277273.0,
        "delta": 808696794.0
      },
      {
        "periodo": 202607,
        "valor": -32710671446.0,
        "delta": -218394173.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -16708977239.0,
    "valor_anterior": -16533168272.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -18924897544.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -18846895176.0,
        "delta": 78002368.0
      },
      {
        "periodo": 202509,
        "valor": -18692196095.0,
        "delta": 154699081.0
      },
      {
        "periodo": 202510,
        "valor": -18944777032.0,
        "delta": -252580937.0
      },
      {
        "periodo": 202511,
        "valor": -18260683449.0,
        "delta": 684093583.0
      },
      {
        "periodo": 202512,
        "valor": -18130978966.0,
        "delta": 129704483.0
      },
      {
        "periodo": 202601,
        "valor": -17786099112.0,
        "delta": 344879854.0
      },
      {
        "periodo": 202602,
        "valor": -17513348295.0,
        "delta": 272750817.0
      },
      {
        "periodo": 202603,
        "valor": -16967935858.0,
        "delta": 545412437.0
      },
      {
        "periodo": 202604,
        "valor": -16650270788.0,
        "delta": 317665070.0
      },
      {
        "periodo": 202605,
        "valor": -16613311296.0,
        "delta": 36959492.0
      },
      {
        "periodo": 202606,
        "valor": -16533168272.0,
        "delta": 80143024.0
      },
      {
        "periodo": 202607,
        "valor": -16708977239.0,
        "delta": -175808967.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -5516527181.48,
    "valor_anterior": -5332622995.27,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -6005105443.63,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -5909015343.79,
        "delta": 96090099.84
      },
      {
        "periodo": 202509,
        "valor": -6126750519.63,
        "delta": -217735175.84
      },
      {
        "periodo": 202510,
        "valor": -6034542198.49,
        "delta": 92208321.14
      },
      {
        "periodo": 202511,
        "valor": -5736982392.73,
        "delta": 297559805.76
      },
      {
        "periodo": 202512,
        "valor": -5253947400.08,
        "delta": 483034992.65
      },
      {
        "periodo": 202601,
        "valor": -5277980692.61,
        "delta": -24033292.53
      },
      {
        "periodo": 202602,
        "valor": -5420141921.2,
        "delta": -142161228.59
      },
      {
        "periodo": 202603,
        "valor": -5392497901.77,
        "delta": 27644019.43
      },
      {
        "periodo": 202604,
        "valor": -5334549004.49,
        "delta": 57948897.28
      },
      {
        "periodo": 202605,
        "valor": -5345335946.72,
        "delta": -10786942.23
      },
      {
        "periodo": 202606,
        "valor": -5332622995.27,
        "delta": 12712951.45
      },
      {
        "periodo": 202607,
        "valor": -5516527181.48,
        "delta": -183904186.21
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -12818476767.0,
    "valor_anterior": -12486333707.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -10227902417.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -10486817849.0,
        "delta": -258915432.0
      },
      {
        "periodo": 202509,
        "valor": -10590378579.0,
        "delta": -103560730.0
      },
      {
        "periodo": 202510,
        "valor": -10834443274.0,
        "delta": -244064695.0
      },
      {
        "periodo": 202511,
        "valor": -10828076005.0,
        "delta": 6367269.0
      },
      {
        "periodo": 202512,
        "valor": -10761897668.0,
        "delta": 66178337.0
      },
      {
        "periodo": 202601,
        "valor": -10872527011.0,
        "delta": -110629343.0
      },
      {
        "periodo": 202602,
        "valor": -11090398556.0,
        "delta": -217871545.0
      },
      {
        "periodo": 202603,
        "valor": -11599984011.0,
        "delta": -509585455.0
      },
      {
        "periodo": 202604,
        "valor": -12122744961.0,
        "delta": -522760950.0
      },
      {
        "periodo": 202605,
        "valor": -12242965657.0,
        "delta": -120220696.0
      },
      {
        "periodo": 202606,
        "valor": -12486333707.0,
        "delta": -243368050.0
      },
      {
        "periodo": 202607,
        "valor": -12818476767.0,
        "delta": -332143060.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -2107736121.0,
    "valor_anterior": -2111462323.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1913238386.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1914974243.0,
        "delta": -1735857.0
      },
      {
        "periodo": 202509,
        "valor": -1910314520.0,
        "delta": 4659723.0
      },
      {
        "periodo": 202510,
        "valor": -1917149350.0,
        "delta": -6834830.0
      },
      {
        "periodo": 202511,
        "valor": -1975962692.0,
        "delta": -58813342.0
      },
      {
        "periodo": 202512,
        "valor": -1826115805.0,
        "delta": 149846887.0
      },
      {
        "periodo": 202601,
        "valor": -1858665537.0,
        "delta": -32549732.0
      },
      {
        "periodo": 202602,
        "valor": -1897547030.0,
        "delta": -38881493.0
      },
      {
        "periodo": 202603,
        "valor": -1943178257.0,
        "delta": -45631227.0
      },
      {
        "periodo": 202604,
        "valor": -2003235597.0,
        "delta": -60057340.0
      },
      {
        "periodo": 202605,
        "valor": -2074963324.0,
        "delta": -71727727.0
      },
      {
        "periodo": 202606,
        "valor": -2111462323.0,
        "delta": -36498999.0
      },
      {
        "periodo": 202607,
        "valor": -2107736121.0,
        "delta": 3726202.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -15589442259.0,
    "valor_anterior": -15839227288.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -14686606733.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -14849049395.0,
        "delta": -162442662.0
      },
      {
        "periodo": 202509,
        "valor": -15133307619.0,
        "delta": -284258224.0
      },
      {
        "periodo": 202510,
        "valor": -15348828087.0,
        "delta": -215520468.0
      },
      {
        "periodo": 202511,
        "valor": -15714238480.0,
        "delta": -365410393.0
      },
      {
        "periodo": 202512,
        "valor": -15450546047.0,
        "delta": 263692433.0
      },
      {
        "periodo": 202601,
        "valor": -15325851029.0,
        "delta": 124695018.0
      },
      {
        "periodo": 202602,
        "valor": -15497180355.0,
        "delta": -171329326.0
      },
      {
        "periodo": 202603,
        "valor": -15430635036.0,
        "delta": 66545319.0
      },
      {
        "periodo": 202604,
        "valor": -15805109931.0,
        "delta": -374474895.0
      },
      {
        "periodo": 202605,
        "valor": -16093957465.0,
        "delta": -288847534.0
      },
      {
        "periodo": 202606,
        "valor": -15839227288.0,
        "delta": 254730177.0
      },
      {
        "periodo": 202607,
        "valor": -15589442259.0,
        "delta": 249785029.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -3517744729.52,
    "valor_anterior": -3467197321.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -3964310604.46,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -3951288993.06,
        "delta": 13021611.4
      },
      {
        "periodo": 202509,
        "valor": -3967899820.16,
        "delta": -16610827.1
      },
      {
        "periodo": 202510,
        "valor": -4061562283.03,
        "delta": -93662462.87
      },
      {
        "periodo": 202511,
        "valor": -4091626904.98,
        "delta": -30064621.95
      },
      {
        "periodo": 202512,
        "valor": -3708770387.41,
        "delta": 382856517.57
      },
      {
        "periodo": 202601,
        "valor": -3650795449.36,
        "delta": 57974938.05
      },
      {
        "periodo": 202602,
        "valor": -3256637914.73,
        "delta": 394157534.63
      },
      {
        "periodo": 202603,
        "valor": -3295523379.32,
        "delta": -38885464.59
      },
      {
        "periodo": 202604,
        "valor": -3309053364.81,
        "delta": -13529985.49
      },
      {
        "periodo": 202605,
        "valor": -3362823113.59,
        "delta": -53769748.78
      },
      {
        "periodo": 202606,
        "valor": -3467197321.2,
        "delta": -104374207.61
      },
      {
        "periodo": 202607,
        "valor": -3517744729.52,
        "delta": -50547408.32
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -3516262973.0,
    "valor_anterior": -3438447370.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2761189132.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2810165222.0,
        "delta": -48976090.0
      },
      {
        "periodo": 202509,
        "valor": -2863325676.0,
        "delta": -53160454.0
      },
      {
        "periodo": 202510,
        "valor": -2941862119.0,
        "delta": -78536443.0
      },
      {
        "periodo": 202511,
        "valor": -3155640623.0,
        "delta": -213778504.0
      },
      {
        "periodo": 202512,
        "valor": -3254723505.0,
        "delta": -99082882.0
      },
      {
        "periodo": 202601,
        "valor": -3310548387.0,
        "delta": -55824882.0
      },
      {
        "periodo": 202602,
        "valor": -3317923296.0,
        "delta": -7374909.0
      },
      {
        "periodo": 202603,
        "valor": -3215342287.0,
        "delta": 102581009.0
      },
      {
        "periodo": 202604,
        "valor": -3307411981.0,
        "delta": -92069694.0
      },
      {
        "periodo": 202605,
        "valor": -3385653665.0,
        "delta": -78241684.0
      },
      {
        "periodo": 202606,
        "valor": -3438447370.0,
        "delta": -52793705.0
      },
      {
        "periodo": 202607,
        "valor": -3516262973.0,
        "delta": -77815603.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -2041245552.0,
    "valor_anterior": -2023798553.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1832385781.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1849888780.0,
        "delta": -17502999.0
      },
      {
        "periodo": 202509,
        "valor": -1867339853.0,
        "delta": -17451073.0
      },
      {
        "periodo": 202510,
        "valor": -1884844246.0,
        "delta": -17504393.0
      },
      {
        "periodo": 202511,
        "valor": -1902532243.0,
        "delta": -17687997.0
      },
      {
        "periodo": 202512,
        "valor": -1920269193.0,
        "delta": -17736950.0
      },
      {
        "periodo": 202601,
        "valor": -1936519191.0,
        "delta": -16249998.0
      },
      {
        "periodo": 202602,
        "valor": -1953910195.0,
        "delta": -17391004.0
      },
      {
        "periodo": 202603,
        "valor": -1971862157.0,
        "delta": -17951962.0
      },
      {
        "periodo": 202604,
        "valor": -1989327158.0,
        "delta": -17465001.0
      },
      {
        "periodo": 202605,
        "valor": -2006752160.0,
        "delta": -17425002.0
      },
      {
        "periodo": 202606,
        "valor": -2023798553.0,
        "delta": -17046393.0
      },
      {
        "periodo": 202607,
        "valor": -2041245552.0,
        "delta": -17446999.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -2494108812.0,
    "valor_anterior": -2370442034.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2334458039.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2305553003.0,
        "delta": 28905036.0
      },
      {
        "periodo": 202509,
        "valor": -2355975889.0,
        "delta": -50422886.0
      },
      {
        "periodo": 202510,
        "valor": -2328381435.0,
        "delta": 27594454.0
      },
      {
        "periodo": 202511,
        "valor": -2347977924.0,
        "delta": -19596489.0
      },
      {
        "periodo": 202512,
        "valor": -2210202291.0,
        "delta": 137775633.0
      },
      {
        "periodo": 202601,
        "valor": -2206496268.0,
        "delta": 3706023.0
      },
      {
        "periodo": 202602,
        "valor": -2232682454.0,
        "delta": -26186186.0
      },
      {
        "periodo": 202603,
        "valor": -2258456345.0,
        "delta": -25773891.0
      },
      {
        "periodo": 202604,
        "valor": -2226979137.0,
        "delta": 31477208.0
      },
      {
        "periodo": 202605,
        "valor": -2339752982.0,
        "delta": -112773845.0
      },
      {
        "periodo": 202606,
        "valor": -2370442034.0,
        "delta": -30689052.0
      },
      {
        "periodo": 202607,
        "valor": -2494108812.0,
        "delta": -123666778.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -25650966168.19,
    "valor_anterior": -25172157845.15,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -19310491421.06,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -19604621480.02,
        "delta": -294130058.96
      },
      {
        "periodo": 202509,
        "valor": -21543128269.01,
        "delta": -1938506788.99
      },
      {
        "periodo": 202510,
        "valor": -21860878096.0,
        "delta": -317749826.99
      },
      {
        "periodo": 202511,
        "valor": -22484755642.88,
        "delta": -623877546.88
      },
      {
        "periodo": 202512,
        "valor": -23218475743.06,
        "delta": -733720100.18
      },
      {
        "periodo": 202601,
        "valor": -23953783661.41,
        "delta": -735307918.35
      },
      {
        "periodo": 202602,
        "valor": -23940183158.74,
        "delta": 13600502.67
      },
      {
        "periodo": 202603,
        "valor": -24433933858.18,
        "delta": -493750699.44
      },
      {
        "periodo": 202604,
        "valor": -24632633832.93,
        "delta": -198699974.75
      },
      {
        "periodo": 202605,
        "valor": -25130784771.13,
        "delta": -498150938.2
      },
      {
        "periodo": 202606,
        "valor": -25172157845.15,
        "delta": -41373074.02
      },
      {
        "periodo": 202607,
        "valor": -25650966168.19,
        "delta": -478808323.04
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -356087818.0,
    "valor_anterior": -366262896.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -436463926.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -434189587.0,
        "delta": 2274339.0
      },
      {
        "periodo": 202509,
        "valor": -532592779.0,
        "delta": -98403192.0
      },
      {
        "periodo": 202510,
        "valor": -461209077.0,
        "delta": 71383702.0
      },
      {
        "periodo": 202511,
        "valor": -438479571.0,
        "delta": 22729506.0
      },
      {
        "periodo": 202512,
        "valor": -439311554.0,
        "delta": -831983.0
      },
      {
        "periodo": 202601,
        "valor": -408816717.0,
        "delta": 30494837.0
      },
      {
        "periodo": 202602,
        "valor": -423214637.0,
        "delta": -14397920.0
      },
      {
        "periodo": 202603,
        "valor": -412850149.0,
        "delta": 10364488.0
      },
      {
        "periodo": 202604,
        "valor": -380229599.0,
        "delta": 32620550.0
      },
      {
        "periodo": 202605,
        "valor": -344487255.0,
        "delta": 35742344.0
      },
      {
        "periodo": 202606,
        "valor": -366262896.0,
        "delta": -21775641.0
      },
      {
        "periodo": 202607,
        "valor": -356087818.0,
        "delta": 10175078.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -56701410.0,
    "valor_anterior": -61524047.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -53737633.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -57881133.0,
        "delta": -4143500.0
      },
      {
        "periodo": 202509,
        "valor": -49944843.0,
        "delta": 7936290.0
      },
      {
        "periodo": 202510,
        "valor": -69239498.0,
        "delta": -19294655.0
      },
      {
        "periodo": 202511,
        "valor": -61429489.0,
        "delta": 7810009.0
      },
      {
        "periodo": 202512,
        "valor": -53843955.0,
        "delta": 7585534.0
      },
      {
        "periodo": 202601,
        "valor": -44233332.0,
        "delta": 9610623.0
      },
      {
        "periodo": 202602,
        "valor": -65188851.0,
        "delta": -20955519.0
      },
      {
        "periodo": 202603,
        "valor": -78441637.0,
        "delta": -13252786.0
      },
      {
        "periodo": 202604,
        "valor": -69053920.0,
        "delta": 9387717.0
      },
      {
        "periodo": 202605,
        "valor": -46553392.0,
        "delta": 22500528.0
      },
      {
        "periodo": 202606,
        "valor": -61524047.0,
        "delta": -14970655.0
      },
      {
        "periodo": 202607,
        "valor": -56701410.0,
        "delta": 4822637.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -179773531.0,
    "valor_anterior": -179696978.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -158366582.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -159501945.0,
        "delta": -1135363.0
      },
      {
        "periodo": 202509,
        "valor": -146027158.0,
        "delta": 13474787.0
      },
      {
        "periodo": 202510,
        "valor": -141799876.0,
        "delta": 4227282.0
      },
      {
        "periodo": 202511,
        "valor": -142662278.0,
        "delta": -862402.0
      },
      {
        "periodo": 202512,
        "valor": -173524812.0,
        "delta": -30862534.0
      },
      {
        "periodo": 202601,
        "valor": -181616152.0,
        "delta": -8091340.0
      },
      {
        "periodo": 202602,
        "valor": -190478610.0,
        "delta": -8862458.0
      },
      {
        "periodo": 202603,
        "valor": -175779700.0,
        "delta": 14698910.0
      },
      {
        "periodo": 202604,
        "valor": -174131922.0,
        "delta": 1647778.0
      },
      {
        "periodo": 202605,
        "valor": -175737275.0,
        "delta": -1605353.0
      },
      {
        "periodo": 202606,
        "valor": -179696978.0,
        "delta": -3959703.0
      },
      {
        "periodo": 202607,
        "valor": -179773531.0,
        "delta": -76553.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -816696066.79,
    "valor_anterior": -799808343.79,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1060921097.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1047319361.46,
        "delta": 13601735.81
      },
      {
        "periodo": 202509,
        "valor": -1042842028.6,
        "delta": 4477332.86
      },
      {
        "periodo": 202510,
        "valor": -1006587675.56,
        "delta": 36254353.04
      },
      {
        "periodo": 202511,
        "valor": -969428444.48,
        "delta": 37159231.08
      },
      {
        "periodo": 202512,
        "valor": -749718208.75,
        "delta": 219710235.73
      },
      {
        "periodo": 202601,
        "valor": -739968143.64,
        "delta": 9750065.11
      },
      {
        "periodo": 202602,
        "valor": -760428064.25,
        "delta": -20459920.61
      },
      {
        "periodo": 202603,
        "valor": -779298641.87,
        "delta": -18870577.62
      },
      {
        "periodo": 202604,
        "valor": -793442218.66,
        "delta": -14143576.79
      },
      {
        "periodo": 202605,
        "valor": -809622299.91,
        "delta": -16180081.25
      },
      {
        "periodo": 202606,
        "valor": -799808343.79,
        "delta": 9813956.12
      },
      {
        "periodo": 202607,
        "valor": -816696066.79,
        "delta": -16887723.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -1918310945.0,
    "valor_anterior": -1959291651.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1857931504.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1925553675.0,
        "delta": -67622171.0
      },
      {
        "periodo": 202509,
        "valor": -1970855832.0,
        "delta": -45302157.0
      },
      {
        "periodo": 202510,
        "valor": -1931758035.0,
        "delta": 39097797.0
      },
      {
        "periodo": 202511,
        "valor": -1933411681.0,
        "delta": -1653646.0
      },
      {
        "periodo": 202512,
        "valor": -1988764614.0,
        "delta": -55352933.0
      },
      {
        "periodo": 202601,
        "valor": -2028114711.0,
        "delta": -39350097.0
      },
      {
        "periodo": 202602,
        "valor": -2167079247.0,
        "delta": -138964536.0
      },
      {
        "periodo": 202603,
        "valor": -2133761440.0,
        "delta": 33317807.0
      },
      {
        "periodo": 202604,
        "valor": -2012426610.0,
        "delta": 121334830.0
      },
      {
        "periodo": 202605,
        "valor": -2023437695.0,
        "delta": -11011085.0
      },
      {
        "periodo": 202606,
        "valor": -1959291651.0,
        "delta": 64146044.0
      },
      {
        "periodo": 202607,
        "valor": -1918310945.0,
        "delta": 40980706.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -3703886611.58,
    "valor_anterior": -3656904392.6,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -4295836699.89,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -4271181418.56,
        "delta": 24655281.33
      },
      {
        "periodo": 202509,
        "valor": -4175322132.13,
        "delta": 95859286.43
      },
      {
        "periodo": 202510,
        "valor": -4356401951.08,
        "delta": -181079818.95
      },
      {
        "periodo": 202511,
        "valor": -4306095553.86,
        "delta": 50306397.22
      },
      {
        "periodo": 202512,
        "valor": -4174819675.07,
        "delta": 131275878.79
      },
      {
        "periodo": 202601,
        "valor": -3928057013.84,
        "delta": 246762661.23
      },
      {
        "periodo": 202602,
        "valor": -3950576944.83,
        "delta": -22519930.99
      },
      {
        "periodo": 202603,
        "valor": -3757801736.95,
        "delta": 192775207.88
      },
      {
        "periodo": 202604,
        "valor": -3702660442.81,
        "delta": 55141294.14
      },
      {
        "periodo": 202605,
        "valor": -3651426623.22,
        "delta": 51233819.59
      },
      {
        "periodo": 202606,
        "valor": -3656904392.6,
        "delta": -5477769.38
      },
      {
        "periodo": 202607,
        "valor": -3703886611.58,
        "delta": -46982218.98
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -24868906899.33,
    "valor_anterior": -24621166001.48,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -23306373685.97,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -24341951058.44,
        "delta": -1035577372.47
      },
      {
        "periodo": 202509,
        "valor": -25259435881.21,
        "delta": -917484822.77
      },
      {
        "periodo": 202510,
        "valor": -25915503133.86,
        "delta": -656067252.65
      },
      {
        "periodo": 202511,
        "valor": -25787231039.84,
        "delta": 128272094.02
      },
      {
        "periodo": 202512,
        "valor": -25848323567.82,
        "delta": -61092527.98
      },
      {
        "periodo": 202601,
        "valor": -26374652410.38,
        "delta": -526328842.56
      },
      {
        "periodo": 202602,
        "valor": -26221604068.19,
        "delta": 153048342.19
      },
      {
        "periodo": 202603,
        "valor": -24992078271.32,
        "delta": 1229525796.87
      },
      {
        "periodo": 202604,
        "valor": -24253607584.14,
        "delta": 738470687.18
      },
      {
        "periodo": 202605,
        "valor": -24788226879.45,
        "delta": -534619295.31
      },
      {
        "periodo": 202606,
        "valor": -24621166001.48,
        "delta": 167060877.97
      },
      {
        "periodo": 202607,
        "valor": -24868906899.33,
        "delta": -247740897.85
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -1001378720.0,
    "valor_anterior": -943547169.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -403525740.18,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -421697276.38,
        "delta": -18171536.2
      },
      {
        "periodo": 202509,
        "valor": -572476441.0,
        "delta": -150779164.62
      },
      {
        "periodo": 202510,
        "valor": -599500102.0,
        "delta": -27023661.0
      },
      {
        "periodo": 202511,
        "valor": -640654510.0,
        "delta": -41154408.0
      },
      {
        "periodo": 202512,
        "valor": -667765891.0,
        "delta": -27111381.0
      },
      {
        "periodo": 202601,
        "valor": -703961758.0,
        "delta": -36195867.0
      },
      {
        "periodo": 202602,
        "valor": -748030141.0,
        "delta": -44068383.0
      },
      {
        "periodo": 202603,
        "valor": -809471035.0,
        "delta": -61440894.0
      },
      {
        "periodo": 202604,
        "valor": -920433454.0,
        "delta": -110962419.0
      },
      {
        "periodo": 202605,
        "valor": -1010533772.0,
        "delta": -90100318.0
      },
      {
        "periodo": 202606,
        "valor": -943547169.0,
        "delta": 66986603.0
      },
      {
        "periodo": 202607,
        "valor": -1001378720.0,
        "delta": -57831551.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -5945483359.000001,
    "valor_anterior": -5840823396.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -4397351417.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -4568402399.0,
        "delta": -171050982.0
      },
      {
        "periodo": 202509,
        "valor": -4821251913.0,
        "delta": -252849514.0
      },
      {
        "periodo": 202510,
        "valor": -5042454984.0,
        "delta": -221203071.0
      },
      {
        "periodo": 202511,
        "valor": -5183264830.0,
        "delta": -140809846.0
      },
      {
        "periodo": 202512,
        "valor": -5491517014.0,
        "delta": -308252184.0
      },
      {
        "periodo": 202601,
        "valor": -5479058983.0,
        "delta": 12458031.0
      },
      {
        "periodo": 202602,
        "valor": -5630485549.0,
        "delta": -151426566.0
      },
      {
        "periodo": 202603,
        "valor": -5779959184.0,
        "delta": -149473635.0
      },
      {
        "periodo": 202604,
        "valor": -5741252889.0,
        "delta": 38706295.0
      },
      {
        "periodo": 202605,
        "valor": -5744326904.0,
        "delta": -3074015.0
      },
      {
        "periodo": 202606,
        "valor": -5840823396.0,
        "delta": -96496492.0
      },
      {
        "periodo": 202607,
        "valor": -5945483359.0,
        "delta": -104659963.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -2891999641.0,
    "valor_anterior": -2857116876.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2363549033.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2391365360.0,
        "delta": -27816327.0
      },
      {
        "periodo": 202509,
        "valor": -2569306952.0,
        "delta": -177941592.0
      },
      {
        "periodo": 202510,
        "valor": -2551907859.0,
        "delta": 17399093.0
      },
      {
        "periodo": 202511,
        "valor": -2540733063.0,
        "delta": 11174796.0
      },
      {
        "periodo": 202512,
        "valor": -2635532611.0,
        "delta": -94799548.0
      },
      {
        "periodo": 202601,
        "valor": -2621078614.0,
        "delta": 14453997.0
      },
      {
        "periodo": 202602,
        "valor": -2635422801.0,
        "delta": -14344187.0
      },
      {
        "periodo": 202603,
        "valor": -2616655341.0,
        "delta": 18767460.0
      },
      {
        "periodo": 202604,
        "valor": -2841651405.0,
        "delta": -224996064.0
      },
      {
        "periodo": 202605,
        "valor": -2833658097.0,
        "delta": 7993308.0
      },
      {
        "periodo": 202606,
        "valor": -2857116876.0,
        "delta": -23458779.0
      },
      {
        "periodo": 202607,
        "valor": -2891999641.0,
        "delta": -34882765.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -771813407.0,
    "valor_anterior": -769044087.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1016889366.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1036810823.0,
        "delta": -19921457.0
      },
      {
        "periodo": 202509,
        "valor": -995576173.0,
        "delta": 41234650.0
      },
      {
        "periodo": 202510,
        "valor": -985928429.0,
        "delta": 9647744.0
      },
      {
        "periodo": 202511,
        "valor": -890646438.0,
        "delta": 95281991.0
      },
      {
        "periodo": 202512,
        "valor": -940173912.0,
        "delta": -49527474.0
      },
      {
        "periodo": 202601,
        "valor": -964694362.0,
        "delta": -24520450.0
      },
      {
        "periodo": 202602,
        "valor": -926645370.0,
        "delta": 38048992.0
      },
      {
        "periodo": 202603,
        "valor": -938744326.0,
        "delta": -12098956.0
      },
      {
        "periodo": 202604,
        "valor": -909636099.0,
        "delta": 29108227.0
      },
      {
        "periodo": 202605,
        "valor": -719609518.0,
        "delta": 190026581.0
      },
      {
        "periodo": 202606,
        "valor": -769044087.0,
        "delta": -49434569.0
      },
      {
        "periodo": 202607,
        "valor": -771813407.0,
        "delta": -2769320.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -245443295.0,
    "valor_anterior": -610652743.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1338174995.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1388776907.0,
        "delta": -50601912.0
      },
      {
        "periodo": 202509,
        "valor": -1279598118.0,
        "delta": 109178789.0
      },
      {
        "periodo": 202510,
        "valor": -1359730819.0,
        "delta": -80132701.0
      },
      {
        "periodo": 202511,
        "valor": -1302280191.0,
        "delta": 57450628.0
      },
      {
        "periodo": 202512,
        "valor": -891247103.0,
        "delta": 411033088.0
      },
      {
        "periodo": 202601,
        "valor": -837034445.0,
        "delta": 54212658.0
      },
      {
        "periodo": 202602,
        "valor": -818580445.0,
        "delta": 18454000.0
      },
      {
        "periodo": 202603,
        "valor": -647999324.0,
        "delta": 170581121.0
      },
      {
        "periodo": 202604,
        "valor": -637736282.0,
        "delta": 10263042.0
      },
      {
        "periodo": 202605,
        "valor": -635075552.0,
        "delta": 2660730.0
      },
      {
        "periodo": 202606,
        "valor": -610652743.0,
        "delta": 24422809.0
      },
      {
        "periodo": 202607,
        "valor": -245443295.0,
        "delta": 365209448.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -7311758801.02,
    "valor_anterior": -7251618500.62,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -6143547979.52,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -6427030748.0,
        "delta": -283482768.48
      },
      {
        "periodo": 202509,
        "valor": -6470790062.27,
        "delta": -43759314.27
      },
      {
        "periodo": 202510,
        "valor": -5944059989.56,
        "delta": 526730072.71
      },
      {
        "periodo": 202511,
        "valor": -6298985086.24,
        "delta": -354925096.68
      },
      {
        "periodo": 202512,
        "valor": -6222175105.49,
        "delta": 76809980.75
      },
      {
        "periodo": 202601,
        "valor": -6950751693.67,
        "delta": -728576588.18
      },
      {
        "periodo": 202602,
        "valor": -7110995479.15,
        "delta": -160243785.48
      },
      {
        "periodo": 202603,
        "valor": -7263526791.82,
        "delta": -152531312.67
      },
      {
        "periodo": 202604,
        "valor": -7511289475.71,
        "delta": -247762683.89
      },
      {
        "periodo": 202605,
        "valor": -7498491536.27,
        "delta": 12797939.44
      },
      {
        "periodo": 202606,
        "valor": -7251618500.62,
        "delta": 246873035.65
      },
      {
        "periodo": 202607,
        "valor": -7311758801.02,
        "delta": -60140300.4
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -301099768.0,
    "valor_anterior": -286003623.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -150024523.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -162881563.0,
        "delta": -12857040.0
      },
      {
        "periodo": 202509,
        "valor": -179319874.0,
        "delta": -16438311.0
      },
      {
        "periodo": 202510,
        "valor": -193194308.0,
        "delta": -13874434.0
      },
      {
        "periodo": 202511,
        "valor": -206871013.0,
        "delta": -13676705.0
      },
      {
        "periodo": 202512,
        "valor": -216801242.0,
        "delta": -9930229.0
      },
      {
        "periodo": 202601,
        "valor": -217614519.0,
        "delta": -813277.0
      },
      {
        "periodo": 202602,
        "valor": -235123169.0,
        "delta": -17508650.0
      },
      {
        "periodo": 202603,
        "valor": -247626155.0,
        "delta": -12502986.0
      },
      {
        "periodo": 202604,
        "valor": -257684531.0,
        "delta": -10058376.0
      },
      {
        "periodo": 202605,
        "valor": -269492133.0,
        "delta": -11807602.0
      },
      {
        "periodo": 202606,
        "valor": -286003623.0,
        "delta": -16511490.0
      },
      {
        "periodo": 202607,
        "valor": -301099768.0,
        "delta": -15096145.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -1511714.0,
    "valor_anterior": -1472185.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1078552.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1381933.0,
        "delta": -303381.0
      },
      {
        "periodo": 202509,
        "valor": -1410555.0,
        "delta": -28622.0
      },
      {
        "periodo": 202510,
        "valor": -1383301.0,
        "delta": 27254.0
      },
      {
        "periodo": 202511,
        "valor": -1243696.0,
        "delta": 139605.0
      },
      {
        "periodo": 202512,
        "valor": -1258209.0,
        "delta": -14513.0
      },
      {
        "periodo": 202601,
        "valor": -1258209.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": -1258209.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": -1243527.0,
        "delta": 14682.0
      },
      {
        "periodo": 202604,
        "valor": -1243527.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": -1436036.0,
        "delta": -192509.0
      },
      {
        "periodo": 202606,
        "valor": -1472185.0,
        "delta": -36149.0
      },
      {
        "periodo": 202607,
        "valor": -1511714.0,
        "delta": -39529.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -1278593181.0,
    "valor_anterior": -1201412879.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1114665733.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1107031301.0,
        "delta": 7634432.0
      },
      {
        "periodo": 202509,
        "valor": -1107792748.0,
        "delta": -761447.0
      },
      {
        "periodo": 202510,
        "valor": -1131992909.0,
        "delta": -24200161.0
      },
      {
        "periodo": 202511,
        "valor": -1131922843.0,
        "delta": 70066.0
      },
      {
        "periodo": 202512,
        "valor": -1140550550.0,
        "delta": -8627707.0
      },
      {
        "periodo": 202601,
        "valor": -1154797586.0,
        "delta": -14247036.0
      },
      {
        "periodo": 202602,
        "valor": -1165673305.0,
        "delta": -10875719.0
      },
      {
        "periodo": 202603,
        "valor": -1140914291.0,
        "delta": 24759014.0
      },
      {
        "periodo": 202604,
        "valor": -1199599588.0,
        "delta": -58685297.0
      },
      {
        "periodo": 202605,
        "valor": -1165630020.0,
        "delta": 33969568.0
      },
      {
        "periodo": 202606,
        "valor": -1201412879.0,
        "delta": -35782859.0
      },
      {
        "periodo": 202607,
        "valor": -1278593181.0,
        "delta": -77180302.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -253745237.0,
    "valor_anterior": -238676757.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -164392758.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -206714095.0,
        "delta": -42321337.0
      },
      {
        "periodo": 202509,
        "valor": -172574114.0,
        "delta": 34139981.0
      },
      {
        "periodo": 202510,
        "valor": -186613404.0,
        "delta": -14039290.0
      },
      {
        "periodo": 202511,
        "valor": -227464567.0,
        "delta": -40851163.0
      },
      {
        "periodo": 202512,
        "valor": -207217147.0,
        "delta": 20247420.0
      },
      {
        "periodo": 202601,
        "valor": -245201328.0,
        "delta": -37984181.0
      },
      {
        "periodo": 202602,
        "valor": -240888349.0,
        "delta": 4312979.0
      },
      {
        "periodo": 202603,
        "valor": -239453236.0,
        "delta": 1435113.0
      },
      {
        "periodo": 202604,
        "valor": -249612470.0,
        "delta": -10159234.0
      },
      {
        "periodo": 202605,
        "valor": -294340385.0,
        "delta": -44727915.0
      },
      {
        "periodo": 202606,
        "valor": -238676757.0,
        "delta": 55663628.0
      },
      {
        "periodo": 202607,
        "valor": -253745237.0,
        "delta": -15068480.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -568416483.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -364122798.0,
        "delta": 204293685.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -350004587.0,
    "valor_anterior": -351455131.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -344430580.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -353500540.0,
        "delta": -9069960.0
      },
      {
        "periodo": 202509,
        "valor": -348487978.0,
        "delta": 5012562.0
      },
      {
        "periodo": 202510,
        "valor": -349367928.0,
        "delta": -879950.0
      },
      {
        "periodo": 202511,
        "valor": -349014012.0,
        "delta": 353916.0
      },
      {
        "periodo": 202512,
        "valor": -350722935.0,
        "delta": -1708923.0
      },
      {
        "periodo": 202601,
        "valor": -345643032.0,
        "delta": 5079903.0
      },
      {
        "periodo": 202602,
        "valor": -352023687.0,
        "delta": -6380655.0
      },
      {
        "periodo": 202603,
        "valor": -370204274.0,
        "delta": -18180587.0
      },
      {
        "periodo": 202604,
        "valor": -315154553.0,
        "delta": 55049721.0
      },
      {
        "periodo": 202605,
        "valor": -344797738.0,
        "delta": -29643185.0
      },
      {
        "periodo": 202606,
        "valor": -351455131.0,
        "delta": -6657393.0
      },
      {
        "periodo": 202607,
        "valor": -350004587.0,
        "delta": 1450544.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -318575412.0,
    "valor_anterior": -295270129.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -231835062.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -237975422.0,
        "delta": -6140360.0
      },
      {
        "periodo": 202509,
        "valor": -219305737.0,
        "delta": 18669685.0
      },
      {
        "periodo": 202510,
        "valor": -225328365.0,
        "delta": -6022628.0
      },
      {
        "periodo": 202511,
        "valor": -239552158.0,
        "delta": -14223793.0
      },
      {
        "periodo": 202512,
        "valor": -253293228.0,
        "delta": -13741070.0
      },
      {
        "periodo": 202601,
        "valor": -252016000.0,
        "delta": 1277228.0
      },
      {
        "periodo": 202602,
        "valor": -268105034.0,
        "delta": -16089034.0
      },
      {
        "periodo": 202603,
        "valor": -281184632.0,
        "delta": -13079598.0
      },
      {
        "periodo": 202604,
        "valor": -287693283.0,
        "delta": -6508651.0
      },
      {
        "periodo": 202605,
        "valor": -298451614.0,
        "delta": -10758331.0
      },
      {
        "periodo": 202606,
        "valor": -295270129.0,
        "delta": 3181485.0
      },
      {
        "periodo": 202607,
        "valor": -318575412.0,
        "delta": -23305283.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -84545673.0,
    "valor_anterior": -83167474.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -46525190.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -46028343.0,
        "delta": 496847.0
      },
      {
        "periodo": 202509,
        "valor": -49755149.0,
        "delta": -3726806.0
      },
      {
        "periodo": 202510,
        "valor": -55726915.0,
        "delta": -5971766.0
      },
      {
        "periodo": 202511,
        "valor": -61061027.0,
        "delta": -5334112.0
      },
      {
        "periodo": 202512,
        "valor": -60602053.0,
        "delta": 458974.0
      },
      {
        "periodo": 202601,
        "valor": -63260876.0,
        "delta": -2658823.0
      },
      {
        "periodo": 202602,
        "valor": -66901241.0,
        "delta": -3640365.0
      },
      {
        "periodo": 202603,
        "valor": -68642470.0,
        "delta": -1741229.0
      },
      {
        "periodo": 202604,
        "valor": -74890568.0,
        "delta": -6248098.0
      },
      {
        "periodo": 202605,
        "valor": -79416894.0,
        "delta": -4526326.0
      },
      {
        "periodo": 202606,
        "valor": -83167474.0,
        "delta": -3750580.0
      },
      {
        "periodo": 202607,
        "valor": -84545673.0,
        "delta": -1378199.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -230047473.77,
    "valor_anterior": -239749675.24,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -235989881.03,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -229134864.22,
        "delta": 6855016.81
      },
      {
        "periodo": 202509,
        "valor": -223545674.54,
        "delta": 5589189.68
      },
      {
        "periodo": 202510,
        "valor": -229761364.53,
        "delta": -6215689.99
      },
      {
        "periodo": 202511,
        "valor": -227005627.86,
        "delta": 2755736.67
      },
      {
        "periodo": 202512,
        "valor": -211668834.57,
        "delta": 15336793.29
      },
      {
        "periodo": 202601,
        "valor": -210932334.07,
        "delta": 736500.5
      },
      {
        "periodo": 202602,
        "valor": -218858756.36,
        "delta": -7926422.29
      },
      {
        "periodo": 202603,
        "valor": -219291218.53,
        "delta": -432462.17
      },
      {
        "periodo": 202604,
        "valor": -224798811.1,
        "delta": -5507592.57
      },
      {
        "periodo": 202605,
        "valor": -228474879.59,
        "delta": -3676068.49
      },
      {
        "periodo": 202606,
        "valor": -239749675.24,
        "delta": -11274795.65
      },
      {
        "periodo": 202607,
        "valor": -230047473.77,
        "delta": 9702201.47
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -8991692.0,
    "valor_anterior": -8636882.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -12600917.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -11982159.0,
        "delta": 618758.0
      },
      {
        "periodo": 202509,
        "valor": -11439356.0,
        "delta": 542803.0
      },
      {
        "periodo": 202510,
        "valor": -9201847.0,
        "delta": 2237509.0
      },
      {
        "periodo": 202511,
        "valor": -9138222.0,
        "delta": 63625.0
      },
      {
        "periodo": 202512,
        "valor": -9159874.0,
        "delta": -21652.0
      },
      {
        "periodo": 202601,
        "valor": -8846170.0,
        "delta": 313704.0
      },
      {
        "periodo": 202602,
        "valor": -8922844.0,
        "delta": -76674.0
      },
      {
        "periodo": 202603,
        "valor": -8947214.0,
        "delta": -24370.0
      },
      {
        "periodo": 202604,
        "valor": -8989674.0,
        "delta": -42460.0
      },
      {
        "periodo": 202605,
        "valor": -8710761.0,
        "delta": 278913.0
      },
      {
        "periodo": 202606,
        "valor": -8636882.0,
        "delta": 73879.0
      },
      {
        "periodo": 202607,
        "valor": -8991692.0,
        "delta": -354810.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -1061487452.89,
    "valor_anterior": -1052631301.56,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -668466377.17,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -675913548.25,
        "delta": -7447171.08
      },
      {
        "periodo": 202509,
        "valor": -825431701.85,
        "delta": -149518153.6
      },
      {
        "periodo": 202510,
        "valor": -798769263.42,
        "delta": 26662438.43
      },
      {
        "periodo": 202511,
        "valor": -801886604.83,
        "delta": -3117341.41
      },
      {
        "periodo": 202512,
        "valor": -808856071.12,
        "delta": -6969466.29
      },
      {
        "periodo": 202601,
        "valor": -819481132.36,
        "delta": -10625061.24
      },
      {
        "periodo": 202602,
        "valor": -827555255.21,
        "delta": -8074122.85
      },
      {
        "periodo": 202603,
        "valor": -952118377.95,
        "delta": -124563122.74
      },
      {
        "periodo": 202604,
        "valor": -963770338.73,
        "delta": -11651960.78
      },
      {
        "periodo": 202605,
        "valor": -969901697.71,
        "delta": -6131358.98
      },
      {
        "periodo": 202606,
        "valor": -1052631301.56,
        "delta": -82729603.85
      },
      {
        "periodo": 202607,
        "valor": -1061487452.89,
        "delta": -8856151.33
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -332129766.51,
    "valor_anterior": -334254277.44,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -248280372.7,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -258378827.88,
        "delta": -10098455.18
      },
      {
        "periodo": 202509,
        "valor": -275452682.34,
        "delta": -17073854.46
      },
      {
        "periodo": 202510,
        "valor": -289085273.78,
        "delta": -13632591.44
      },
      {
        "periodo": 202511,
        "valor": -301419748.47,
        "delta": -12334474.69
      },
      {
        "periodo": 202512,
        "valor": -318607518.48,
        "delta": -17187770.01
      },
      {
        "periodo": 202601,
        "valor": -326774174.98,
        "delta": -8166656.5
      },
      {
        "periodo": 202602,
        "valor": -329426614.69,
        "delta": -2652439.71
      },
      {
        "periodo": 202603,
        "valor": -336493635.42,
        "delta": -7067020.73
      },
      {
        "periodo": 202604,
        "valor": -341353905.62,
        "delta": -4860270.2
      },
      {
        "periodo": 202605,
        "valor": -359174514.51,
        "delta": -17820608.89
      },
      {
        "periodo": 202606,
        "valor": -334254277.44,
        "delta": 24920237.07
      },
      {
        "periodo": 202607,
        "valor": -332129766.51,
        "delta": 2124510.93
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -202222294.0,
    "valor_anterior": -159761841.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -95122452.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -96731126.0,
        "delta": -1608674.0
      },
      {
        "periodo": 202509,
        "valor": -89193842.0,
        "delta": 7537284.0
      },
      {
        "periodo": 202510,
        "valor": -91539836.0,
        "delta": -2345994.0
      },
      {
        "periodo": 202511,
        "valor": -100868060.0,
        "delta": -9328224.0
      },
      {
        "periodo": 202512,
        "valor": -107294302.0,
        "delta": -6426242.0
      },
      {
        "periodo": 202601,
        "valor": -104611661.0,
        "delta": 2682641.0
      },
      {
        "periodo": 202602,
        "valor": -42202716.0,
        "delta": 62408945.0
      },
      {
        "periodo": 202603,
        "valor": -90874728.0,
        "delta": -48672012.0
      },
      {
        "periodo": 202604,
        "valor": -150128927.0,
        "delta": -59254199.0
      },
      {
        "periodo": 202605,
        "valor": -151760238.0,
        "delta": -1631311.0
      },
      {
        "periodo": 202606,
        "valor": -159761841.0,
        "delta": -8001603.0
      },
      {
        "periodo": 202607,
        "valor": -202222294.0,
        "delta": -42460453.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -1547825326.0,
    "valor_anterior": -1542974935.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1488439980.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1409503224.0,
        "delta": 78936756.0
      },
      {
        "periodo": 202509,
        "valor": -1327787831.0,
        "delta": 81715393.0
      },
      {
        "periodo": 202510,
        "valor": -1329286459.0,
        "delta": -1498628.0
      },
      {
        "periodo": 202511,
        "valor": -1318716376.0,
        "delta": 10570083.0
      },
      {
        "periodo": 202512,
        "valor": -1504289276.0,
        "delta": -185572900.0
      },
      {
        "periodo": 202601,
        "valor": -1477956458.0,
        "delta": 26332818.0
      },
      {
        "periodo": 202602,
        "valor": -1506165527.0,
        "delta": -28209069.0
      },
      {
        "periodo": 202603,
        "valor": -1556684906.0,
        "delta": -50519379.0
      },
      {
        "periodo": 202604,
        "valor": -1577211679.0,
        "delta": -20526773.0
      },
      {
        "periodo": 202605,
        "valor": -1570515278.0,
        "delta": 6696401.0
      },
      {
        "periodo": 202606,
        "valor": -1542974935.0,
        "delta": 27540343.0
      },
      {
        "periodo": 202607,
        "valor": -1547825326.0,
        "delta": -4850391.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -24282701.0,
    "valor_anterior": -37903324.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -46005055.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -41397119.0,
        "delta": 4607936.0
      },
      {
        "periodo": 202509,
        "valor": -40497151.0,
        "delta": 899968.0
      },
      {
        "periodo": 202510,
        "valor": -40171532.0,
        "delta": 325619.0
      },
      {
        "periodo": 202511,
        "valor": -40213825.0,
        "delta": -42293.0
      },
      {
        "periodo": 202512,
        "valor": -39945683.0,
        "delta": 268142.0
      },
      {
        "periodo": 202601,
        "valor": -38547103.0,
        "delta": 1398580.0
      },
      {
        "periodo": 202602,
        "valor": -38154404.0,
        "delta": 392699.0
      },
      {
        "periodo": 202603,
        "valor": -38958013.0,
        "delta": -803609.0
      },
      {
        "periodo": 202604,
        "valor": -35830161.0,
        "delta": 3127852.0
      },
      {
        "periodo": 202605,
        "valor": -34958433.0,
        "delta": 871728.0
      },
      {
        "periodo": 202606,
        "valor": -37903324.0,
        "delta": -2944891.0
      },
      {
        "periodo": 202607,
        "valor": -24282701.0,
        "delta": 13620623.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -32116358.25,
    "valor_anterior": -32058894.24,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -28253173.35,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -28112973.18,
        "delta": 140200.17
      },
      {
        "periodo": 202509,
        "valor": -28318030.37,
        "delta": -205057.19
      },
      {
        "periodo": 202510,
        "valor": -27725590.54,
        "delta": 592439.83
      },
      {
        "periodo": 202511,
        "valor": -11149997.6,
        "delta": 16575592.94
      },
      {
        "periodo": 202512,
        "valor": -11603831.79,
        "delta": -453834.19
      },
      {
        "periodo": 202601,
        "valor": -12053541.31,
        "delta": -449709.52
      },
      {
        "periodo": 202602,
        "valor": -13671554.54,
        "delta": -1618013.23
      },
      {
        "periodo": 202603,
        "valor": -13129475.87,
        "delta": 542078.67
      },
      {
        "periodo": 202604,
        "valor": -31543881.07,
        "delta": -18414405.2
      },
      {
        "periodo": 202605,
        "valor": -32444651.0,
        "delta": -900769.93
      },
      {
        "periodo": 202606,
        "valor": -32058894.24,
        "delta": 385756.76
      },
      {
        "periodo": 202607,
        "valor": -32116358.25,
        "delta": -57464.01
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -78763312.91,
    "valor_anterior": -77936549.28,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -132637458.51,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -123692225.14,
        "delta": 8945233.37
      },
      {
        "periodo": 202509,
        "valor": -119149560.68,
        "delta": 4542664.46
      },
      {
        "periodo": 202510,
        "valor": -72965526.47,
        "delta": 46184034.21
      },
      {
        "periodo": 202511,
        "valor": -75167761.53,
        "delta": -2202235.06
      },
      {
        "periodo": 202512,
        "valor": -74012068.18,
        "delta": 1155693.35
      },
      {
        "periodo": 202601,
        "valor": -74601052.83,
        "delta": -588984.65
      },
      {
        "periodo": 202602,
        "valor": -75690551.08,
        "delta": -1089498.25
      },
      {
        "periodo": 202603,
        "valor": -72223524.84,
        "delta": 3467026.24
      },
      {
        "periodo": 202604,
        "valor": -73099870.92,
        "delta": -876346.08
      },
      {
        "periodo": 202605,
        "valor": -73099600.08,
        "delta": 270.84
      },
      {
        "periodo": 202606,
        "valor": -77936549.28,
        "delta": -4836949.2
      },
      {
        "periodo": 202607,
        "valor": -78763312.91,
        "delta": -826763.63
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -236.0,
    "valor_anterior": -119673.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1688532.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1276702.0,
        "delta": 411830.0
      },
      {
        "periodo": 202509,
        "valor": -223108.0,
        "delta": 1053594.0
      },
      {
        "periodo": 202510,
        "valor": -253066.0,
        "delta": -29958.0
      },
      {
        "periodo": 202511,
        "valor": -1229514.0,
        "delta": -976448.0
      },
      {
        "periodo": 202512,
        "valor": -85571.0,
        "delta": 1143943.0
      },
      {
        "periodo": 202601,
        "valor": -129074.0,
        "delta": -43503.0
      },
      {
        "periodo": 202602,
        "valor": -70077.0,
        "delta": 58997.0
      },
      {
        "periodo": 202603,
        "valor": -825541.0,
        "delta": -755464.0
      },
      {
        "periodo": 202604,
        "valor": -1106937.0,
        "delta": -281396.0
      },
      {
        "periodo": 202605,
        "valor": -271719.0,
        "delta": 835218.0
      },
      {
        "periodo": 202606,
        "valor": -119673.0,
        "delta": 152046.0
      },
      {
        "periodo": 202607,
        "valor": -236.0,
        "delta": 119437.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -74481397.0,
    "valor_anterior": -74660148.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -74139374.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -73692878.0,
        "delta": 446496.0
      },
      {
        "periodo": 202509,
        "valor": -73596804.0,
        "delta": 96074.0
      },
      {
        "periodo": 202510,
        "valor": -73472046.0,
        "delta": 124758.0
      },
      {
        "periodo": 202511,
        "valor": -76433177.0,
        "delta": -2961131.0
      },
      {
        "periodo": 202512,
        "valor": -76435008.0,
        "delta": -1831.0
      },
      {
        "periodo": 202601,
        "valor": -76217308.0,
        "delta": 217700.0
      },
      {
        "periodo": 202602,
        "valor": -76182744.0,
        "delta": 34564.0
      },
      {
        "periodo": 202603,
        "valor": -77390505.0,
        "delta": -1207761.0
      },
      {
        "periodo": 202604,
        "valor": -77948906.0,
        "delta": -558401.0
      },
      {
        "periodo": 202605,
        "valor": -76004591.0,
        "delta": 1944315.0
      },
      {
        "periodo": 202606,
        "valor": -74660148.0,
        "delta": 1344443.0
      },
      {
        "periodo": 202607,
        "valor": -74481397.0,
        "delta": 178751.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -37464.2,
    "valor_anterior": -102780.26,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -5543221.76,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -3949615.38,
        "delta": 1593606.38
      },
      {
        "periodo": 202509,
        "valor": -2365594.97,
        "delta": 1584020.41
      },
      {
        "periodo": 202510,
        "valor": -1559090.11,
        "delta": 806504.86
      },
      {
        "periodo": 202511,
        "valor": -1013699.5,
        "delta": 545390.61
      },
      {
        "periodo": 202512,
        "valor": -580631.68,
        "delta": 433067.82
      },
      {
        "periodo": 202601,
        "valor": -372245.16,
        "delta": 208386.52
      },
      {
        "periodo": 202602,
        "valor": -331404.74,
        "delta": 40840.42
      },
      {
        "periodo": 202603,
        "valor": -269184.27,
        "delta": 62220.47
      },
      {
        "periodo": 202604,
        "valor": -135180.59,
        "delta": 134003.68
      },
      {
        "periodo": 202605,
        "valor": -118545.27,
        "delta": 16635.32
      },
      {
        "periodo": 202606,
        "valor": -102780.26,
        "delta": 15765.01
      },
      {
        "periodo": 202607,
        "valor": -37464.2,
        "delta": 65316.06
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -479976502.08,
    "valor_anterior": -469719859.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": -444286050.0,
        "delta": -444286050.0
      },
      {
        "periodo": 202603,
        "valor": -444571794.0,
        "delta": -285744.0
      },
      {
        "periodo": 202604,
        "valor": -471474970.62,
        "delta": -26903176.62
      },
      {
        "periodo": 202605,
        "valor": -470023044.0,
        "delta": 1451926.62
      },
      {
        "periodo": 202606,
        "valor": -469719859.0,
        "delta": 303185.0
      },
      {
        "periodo": 202607,
        "valor": -479976502.08,
        "delta": -10256643.08
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -110832462.0,
    "valor_anterior": -107234624.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -27243160.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -43813655.0,
        "delta": -16570495.0
      },
      {
        "periodo": 202509,
        "valor": -60464751.0,
        "delta": -16651096.0
      },
      {
        "periodo": 202510,
        "valor": -78137614.0,
        "delta": -17672863.0
      },
      {
        "periodo": 202511,
        "valor": -95031856.0,
        "delta": -16894242.0
      },
      {
        "periodo": 202512,
        "valor": -97002617.0,
        "delta": -1970761.0
      },
      {
        "periodo": 202601,
        "valor": -97207151.0,
        "delta": -204534.0
      },
      {
        "periodo": 202602,
        "valor": -96194206.0,
        "delta": 1012945.0
      },
      {
        "periodo": 202603,
        "valor": -91211258.0,
        "delta": 4982948.0
      },
      {
        "periodo": 202604,
        "valor": -99105554.0,
        "delta": -7894296.0
      },
      {
        "periodo": 202605,
        "valor": -107115241.0,
        "delta": -8009687.0
      },
      {
        "periodo": 202606,
        "valor": -107234624.0,
        "delta": -119383.0
      },
      {
        "periodo": 202607,
        "valor": -110832462.0,
        "delta": -3597838.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -39560999.54,
    "valor_anterior": -28907578.82,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": -499740.43,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": -1345170.93,
        "delta": -845430.5
      },
      {
        "periodo": 202601,
        "valor": -4486903.2,
        "delta": -3141732.27
      },
      {
        "periodo": 202602,
        "valor": -8975275.14,
        "delta": -4488371.94
      },
      {
        "periodo": 202603,
        "valor": -11904046.26,
        "delta": -2928771.12
      },
      {
        "periodo": 202604,
        "valor": -17102110.91,
        "delta": -5198064.65
      },
      {
        "periodo": 202605,
        "valor": -21955334.35,
        "delta": -4853223.44
      },
      {
        "periodo": 202606,
        "valor": -28907578.82,
        "delta": -6952244.47
      },
      {
        "periodo": 202607,
        "valor": -39560999.54,
        "delta": -10653420.72
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -2907107202.0,
    "valor_anterior": -2529641403.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": -2103840407.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": -2405346104.0,
        "delta": -301505697.0
      },
      {
        "periodo": 202605,
        "valor": -2733362506.0,
        "delta": -328016402.0
      },
      {
        "periodo": 202606,
        "valor": -2529641403.0,
        "delta": 203721103.0
      },
      {
        "periodo": 202607,
        "valor": -2907107202.0,
        "delta": -377465799.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -283396441617.19,
    "valor_anterior": -280840429799.44,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -251744595946.41,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -254546758939.98,
        "delta": -2802162993.57
      },
      {
        "periodo": 202509,
        "valor": -259709041790.54,
        "delta": -5162282850.56
      },
      {
        "periodo": 202510,
        "valor": -263340482733.09,
        "delta": -3631440942.55
      },
      {
        "periodo": 202511,
        "valor": -264353109722.59,
        "delta": -1012626989.5
      },
      {
        "periodo": 202512,
        "valor": -263023202279.58,
        "delta": 1329907443.01
      },
      {
        "periodo": 202601,
        "valor": -264580173446.42,
        "delta": -1556971166.84
      },
      {
        "periodo": 202602,
        "valor": -269476657163.57,
        "delta": -4896483717.15
      },
      {
        "periodo": 202603,
        "valor": -272941515173.54,
        "delta": -3464858009.97
      },
      {
        "periodo": 202604,
        "valor": -274136129418.43,
        "delta": -1194614244.89
      },
      {
        "periodo": 202605,
        "valor": -280529149783.01,
        "delta": -6393020364.58
      },
      {
        "periodo": 202606,
        "valor": -280840429799.44,
        "delta": -311280016.43
      },
      {
        "periodo": 202607,
        "valor": -283396441617.19,
        "delta": -2556011817.75
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -204416637531.32,
    "valor_anterior": -203025250197.64,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -180415460065.97,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -181856996751.24,
        "delta": -1441536685.27
      },
      {
        "periodo": 202509,
        "valor": -185575302956.79,
        "delta": -3718306205.55
      },
      {
        "periodo": 202510,
        "valor": -188620524033.66,
        "delta": -3045221076.87
      },
      {
        "periodo": 202511,
        "valor": -189370181241.24,
        "delta": -749657207.58
      },
      {
        "periodo": 202512,
        "valor": -189081123853.21,
        "delta": 289057388.03
      },
      {
        "periodo": 202601,
        "valor": -189545121727.01,
        "delta": -463997873.8
      },
      {
        "periodo": 202602,
        "valor": -193732423171.46,
        "delta": -4187301444.45
      },
      {
        "periodo": 202603,
        "valor": -196110284854.35,
        "delta": -2377861682.89
      },
      {
        "periodo": 202604,
        "valor": -197153195743.25,
        "delta": -1042910888.9
      },
      {
        "periodo": 202605,
        "valor": -202441225939.34,
        "delta": -5288030196.09
      },
      {
        "periodo": 202606,
        "valor": -203025250197.64,
        "delta": -584024258.3
      },
      {
        "periodo": 202607,
        "valor": -204416637531.32,
        "delta": -1391387333.68
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -1412143948.79,
    "valor_anterior": -1761916217.79,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -3311943155.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -3153719606.46,
        "delta": 158223548.81
      },
      {
        "periodo": 202509,
        "valor": -2670928124.6,
        "delta": 482791481.86
      },
      {
        "periodo": 202510,
        "valor": -2715686422.56,
        "delta": -44758297.96
      },
      {
        "periodo": 202511,
        "valor": -2620722647.48,
        "delta": 94963775.08
      },
      {
        "periodo": 202512,
        "valor": -1991688246.75,
        "delta": 629034400.73
      },
      {
        "periodo": 202601,
        "valor": -1922645620.64,
        "delta": 69042626.11
      },
      {
        "periodo": 202602,
        "valor": -1931032196.25,
        "delta": -8386575.61
      },
      {
        "periodo": 202603,
        "valor": -1797502239.87,
        "delta": 133529956.38
      },
      {
        "periodo": 202604,
        "valor": -1746333053.66,
        "delta": 51169186.21
      },
      {
        "periodo": 202605,
        "valor": -1789495589.91,
        "delta": -43162536.25
      },
      {
        "periodo": 202606,
        "valor": -1761916217.79,
        "delta": 27579372.12
      },
      {
        "periodo": 202607,
        "valor": -1412143948.79,
        "delta": 349772269.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -10308333105.58,
    "valor_anterior": -10074869575.6,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -10042819095.89,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -10041130943.56,
        "delta": 1688152.33
      },
      {
        "periodo": 202509,
        "valor": -10124822140.13,
        "delta": -83691196.57
      },
      {
        "periodo": 202510,
        "valor": -10300530323.08,
        "delta": -175708182.95
      },
      {
        "periodo": 202511,
        "valor": -10454758648.86,
        "delta": -154228325.78
      },
      {
        "periodo": 202512,
        "valor": -10307769572.07,
        "delta": 146989076.79
      },
      {
        "periodo": 202601,
        "valor": -10081155152.84,
        "delta": 226614419.23
      },
      {
        "periodo": 202602,
        "valor": -10181393078.83,
        "delta": -100237925.99
      },
      {
        "periodo": 202603,
        "valor": -9900740922.95,
        "delta": 280652155.88
      },
      {
        "periodo": 202604,
        "valor": -9862817465.81,
        "delta": 37923457.14
      },
      {
        "periodo": 202605,
        "valor": -9945318947.22,
        "delta": -82501481.41
      },
      {
        "periodo": 202606,
        "valor": -10074869575.6,
        "delta": -129550628.38
      },
      {
        "periodo": 202607,
        "valor": -10308333105.58,
        "delta": -233463529.98
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -17500143944.0,
    "valor_anterior": -17270666101.47,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -17592574951.09,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -17501700838.85,
        "delta": 90874112.24
      },
      {
        "periodo": 202509,
        "valor": -17872915474.79,
        "delta": -371214635.94
      },
      {
        "periodo": 202510,
        "valor": -17826206184.52,
        "delta": 46709290.27
      },
      {
        "periodo": 202511,
        "valor": -17597433109.71,
        "delta": 228773074.81
      },
      {
        "periodo": 202512,
        "valor": -16917420093.49,
        "delta": 680013016.22
      },
      {
        "periodo": 202601,
        "valor": -16914591461.97,
        "delta": 2828631.52
      },
      {
        "periodo": 202602,
        "valor": -16882994440.93,
        "delta": 31597021.04
      },
      {
        "periodo": 202603,
        "valor": -16938301225.09,
        "delta": -55306784.16
      },
      {
        "periodo": 202604,
        "valor": -17078127660.3,
        "delta": -139826435.21
      },
      {
        "periodo": 202605,
        "valor": -17210733454.31,
        "delta": -132605794.01
      },
      {
        "periodo": 202606,
        "valor": -17270666101.47,
        "delta": -59932647.16
      },
      {
        "periodo": 202607,
        "valor": -17500143944.0,
        "delta": -229477842.53
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -6478635307.33,
    "valor_anterior": -6335256453.76,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -5176155532.94,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -5248289585.05,
        "delta": -72134052.11
      },
      {
        "periodo": 202509,
        "valor": -5520642880.78,
        "delta": -272353295.73
      },
      {
        "periodo": 202510,
        "valor": -5521487729.74,
        "delta": -844848.96
      },
      {
        "periodo": 202511,
        "valor": -5523539386.29,
        "delta": -2051656.55
      },
      {
        "periodo": 202512,
        "valor": -5655886657.14,
        "delta": -132347270.85
      },
      {
        "periodo": 202601,
        "valor": -5746870307.55,
        "delta": -90983650.41
      },
      {
        "periodo": 202602,
        "valor": -5762479348.88,
        "delta": -15609041.33
      },
      {
        "periodo": 202603,
        "valor": -6058314997.61,
        "delta": -295835648.73
      },
      {
        "periodo": 202604,
        "valor": -6272239000.44,
        "delta": -213924002.83
      },
      {
        "periodo": 202605,
        "valor": -6239368562.89,
        "delta": 32870437.55
      },
      {
        "periodo": 202606,
        "valor": -6335256453.76,
        "delta": -95887890.87
      },
      {
        "periodo": 202607,
        "valor": -6478635307.33,
        "delta": -143378853.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100031,
    "label": "EPRC Balance (Total)",
    "valor_actual": -43280547780.17,
    "valor_anterior": -42372471253.18,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -35205643145.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -36744921214.82,
        "delta": -1539278069.57
      },
      {
        "periodo": 202509,
        "valor": -37944430213.45,
        "delta": -1199508998.63
      },
      {
        "periodo": 202510,
        "valor": -38356048039.53,
        "delta": -411617826.08
      },
      {
        "periodo": 202511,
        "valor": -38786474689.01,
        "delta": -430426649.48
      },
      {
        "periodo": 202512,
        "valor": -39069313856.92,
        "delta": -282839167.91
      },
      {
        "periodo": 202601,
        "valor": -40369789176.41,
        "delta": -1300475319.49
      },
      {
        "periodo": 202602,
        "valor": -40986334927.22,
        "delta": -616545750.81
      },
      {
        "periodo": 202603,
        "valor": -42136370933.67,
        "delta": -1150036006.45
      },
      {
        "periodo": 202604,
        "valor": -42023416494.97,
        "delta": 112954438.7
      },
      {
        "periodo": 202605,
        "valor": -42903007289.34,
        "delta": -879590794.37
      },
      {
        "periodo": 202606,
        "valor": -42372471253.18,
        "delta": 530536036.16
      },
      {
        "periodo": 202607,
        "valor": -43280547780.17,
        "delta": -908076526.99
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -4244954989.86,
    "valor_anterior": -4192040718.58,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -3905281755.37,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -3759291030.01,
        "delta": 145990725.36
      },
      {
        "periodo": 202509,
        "valor": -3845325651.06,
        "delta": -86034621.05
      },
      {
        "periodo": 202510,
        "valor": -3989520752.98,
        "delta": -144195101.92
      },
      {
        "periodo": 202511,
        "valor": -4080346460.72,
        "delta": -90825707.74
      },
      {
        "periodo": 202512,
        "valor": -4125228151.01,
        "delta": -44881690.29
      },
      {
        "periodo": 202601,
        "valor": -4210840784.57,
        "delta": -85612633.56
      },
      {
        "periodo": 202602,
        "valor": -3895453698.63,
        "delta": 315387085.94
      },
      {
        "periodo": 202603,
        "valor": -4015502921.93,
        "delta": -120049223.3
      },
      {
        "periodo": 202604,
        "valor": -4076397798.26,
        "delta": -60894876.33
      },
      {
        "periodo": 202605,
        "valor": -4114758898.25,
        "delta": -38361099.99
      },
      {
        "periodo": 202606,
        "valor": -4192040718.58,
        "delta": -77281820.33
      },
      {
        "periodo": 202607,
        "valor": -4244954989.86,
        "delta": -52914271.28
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -11800441987.19,
    "valor_anterior": -12527817840.05,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -11185112398.04,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -11562997312.08,
        "delta": -377884914.04
      },
      {
        "periodo": 202509,
        "valor": -11482948736.92,
        "delta": 80048575.16
      },
      {
        "periodo": 202510,
        "valor": -11703400978.43,
        "delta": -220452241.51
      },
      {
        "periodo": 202511,
        "valor": -11815596141.51,
        "delta": -112195163.08
      },
      {
        "periodo": 202512,
        "valor": -10739908727.02,
        "delta": 1075687414.49
      },
      {
        "periodo": 202601,
        "valor": -10907995339.8,
        "delta": -168086612.78
      },
      {
        "periodo": 202602,
        "valor": -10820828633.71,
        "delta": 87166706.09
      },
      {
        "periodo": 202603,
        "valor": -11211488771.45,
        "delta": -390660137.74
      },
      {
        "periodo": 202604,
        "valor": -11695861956.67,
        "delta": -484373185.22
      },
      {
        "periodo": 202605,
        "valor": -11988043096.3,
        "delta": -292181139.63
      },
      {
        "periodo": 202606,
        "valor": -12527817840.05,
        "delta": -539774743.75
      },
      {
        "periodo": 202607,
        "valor": -11800441987.19,
        "delta": 727375852.86
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -6909108398.0,
    "valor_anterior": -6807969772.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -6414842103.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -6573028918.0,
        "delta": -158186815.0
      },
      {
        "periodo": 202509,
        "valor": -6602301404.0,
        "delta": -29272486.0
      },
      {
        "periodo": 202510,
        "valor": -6797596641.0,
        "delta": -195295237.0
      },
      {
        "periodo": 202511,
        "valor": -7191697987.0,
        "delta": -394101346.0
      },
      {
        "periodo": 202512,
        "valor": -6945270905.0,
        "delta": 246427082.0
      },
      {
        "periodo": 202601,
        "valor": -6811457952.0,
        "delta": 133812953.0
      },
      {
        "periodo": 202602,
        "valor": -7238736245.0,
        "delta": -427278293.0
      },
      {
        "periodo": 202603,
        "valor": -7538464930.0,
        "delta": -299728685.0
      },
      {
        "periodo": 202604,
        "valor": -7147424778.0,
        "delta": 391040152.0
      },
      {
        "periodo": 202605,
        "valor": -7304481419.0,
        "delta": -157056641.0
      },
      {
        "periodo": 202606,
        "valor": -6807969772.0,
        "delta": 496511647.0
      },
      {
        "periodo": 202607,
        "valor": -6909108398.0,
        "delta": -101138626.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -5216340590.0,
    "valor_anterior": -5049999870.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -5919159424.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -5982411865.0,
        "delta": -63252441.0
      },
      {
        "periodo": 202509,
        "valor": -5964319714.0,
        "delta": 18092151.0
      },
      {
        "periodo": 202510,
        "valor": -5961884324.0,
        "delta": 2435390.0
      },
      {
        "periodo": 202511,
        "valor": -5542227562.0,
        "delta": 419656762.0
      },
      {
        "periodo": 202512,
        "valor": -5755148181.0,
        "delta": -212920619.0
      },
      {
        "periodo": 202601,
        "valor": -5489364373.0,
        "delta": 265783808.0
      },
      {
        "periodo": 202602,
        "valor": -5416281953.0,
        "delta": 73082420.0
      },
      {
        "periodo": 202603,
        "valor": -4964554914.0,
        "delta": 451727039.0
      },
      {
        "periodo": 202604,
        "valor": -4778902913.0,
        "delta": 185652001.0
      },
      {
        "periodo": 202605,
        "valor": -4877012713.0,
        "delta": -98109800.0
      },
      {
        "periodo": 202606,
        "valor": -5049999870.0,
        "delta": -172987157.0
      },
      {
        "periodo": 202607,
        "valor": -5216340590.0,
        "delta": -166340720.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -4763661261.12,
    "valor_anterior": -4576335228.22,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -4592238461.16,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -4555283507.45,
        "delta": 36954953.71
      },
      {
        "periodo": 202509,
        "valor": -4700103384.63,
        "delta": -144819877.18
      },
      {
        "periodo": 202510,
        "valor": -4646101076.25,
        "delta": 54002308.38
      },
      {
        "periodo": 202511,
        "valor": -4523846675.41,
        "delta": 122254400.84
      },
      {
        "periodo": 202512,
        "valor": -4209284555.63,
        "delta": 314562119.78
      },
      {
        "periodo": 202601,
        "valor": -4258813568.45,
        "delta": -49529012.82
      },
      {
        "periodo": 202602,
        "valor": -4409664002.28,
        "delta": -150850433.83
      },
      {
        "periodo": 202603,
        "valor": -4359581497.34,
        "delta": 50082504.94
      },
      {
        "periodo": 202604,
        "valor": -4497111431.5,
        "delta": -137529934.16
      },
      {
        "periodo": 202605,
        "valor": -4507460612.3,
        "delta": -10349180.8
      },
      {
        "periodo": 202606,
        "valor": -4576335228.22,
        "delta": -68874615.92
      },
      {
        "periodo": 202607,
        "valor": -4763661261.12,
        "delta": -187326032.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -7958819655.000001,
    "valor_anterior": -7676258100.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -6031994425.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -6172604427.0,
        "delta": -140610002.0
      },
      {
        "periodo": 202509,
        "valor": -6153037795.0,
        "delta": 19566632.0
      },
      {
        "periodo": 202510,
        "valor": -6279153657.0,
        "delta": -126115862.0
      },
      {
        "periodo": 202511,
        "valor": -6233081214.0,
        "delta": 46072443.0
      },
      {
        "periodo": 202512,
        "valor": -6249566644.0,
        "delta": -16485430.0
      },
      {
        "periodo": 202601,
        "valor": -6327440567.0,
        "delta": -77873923.0
      },
      {
        "periodo": 202602,
        "valor": -6560449821.0,
        "delta": -233009254.0
      },
      {
        "periodo": 202603,
        "valor": -6989607046.0,
        "delta": -429157225.0
      },
      {
        "periodo": 202604,
        "valor": -7458626487.0,
        "delta": -469019441.0
      },
      {
        "periodo": 202605,
        "valor": -7503054402.0,
        "delta": -44427915.0
      },
      {
        "periodo": 202606,
        "valor": -7676258100.0,
        "delta": -173203698.0
      },
      {
        "periodo": 202607,
        "valor": -7958819655.0,
        "delta": -282561555.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -1285510936.0,
    "valor_anterior": -1315621912.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1071095068.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1094169228.0,
        "delta": -23074160.0
      },
      {
        "periodo": 202509,
        "valor": -1129912837.0,
        "delta": -35743609.0
      },
      {
        "periodo": 202510,
        "valor": -1130861776.0,
        "delta": -948939.0
      },
      {
        "periodo": 202511,
        "valor": -1178797850.0,
        "delta": -47936074.0
      },
      {
        "periodo": 202512,
        "valor": -1090915230.0,
        "delta": 87882620.0
      },
      {
        "periodo": 202601,
        "valor": -1103009294.0,
        "delta": -12094064.0
      },
      {
        "periodo": 202602,
        "valor": -1140297665.0,
        "delta": -37288371.0
      },
      {
        "periodo": 202603,
        "valor": -1119231418.0,
        "delta": 21066247.0
      },
      {
        "periodo": 202604,
        "valor": -1238333074.0,
        "delta": -119101656.0
      },
      {
        "periodo": 202605,
        "valor": -1281882684.0,
        "delta": -43549610.0
      },
      {
        "periodo": 202606,
        "valor": -1315621912.0,
        "delta": -33739228.0
      },
      {
        "periodo": 202607,
        "valor": -1285510936.0,
        "delta": 30110976.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -4571814281.0,
    "valor_anterior": -5005160728.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -4535581702.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -4549648881.0,
        "delta": -14067179.0
      },
      {
        "periodo": 202509,
        "valor": -4724015837.0,
        "delta": -174366956.0
      },
      {
        "periodo": 202510,
        "valor": -4634396649.0,
        "delta": 89619188.0
      },
      {
        "periodo": 202511,
        "valor": -4535619142.0,
        "delta": 98777507.0
      },
      {
        "periodo": 202512,
        "valor": -4537614302.0,
        "delta": -1995160.0
      },
      {
        "periodo": 202601,
        "valor": -4528181689.0,
        "delta": 9432613.0
      },
      {
        "periodo": 202602,
        "valor": -4580063532.0,
        "delta": -51881843.0
      },
      {
        "periodo": 202603,
        "valor": -4597288013.0,
        "delta": -17224481.0
      },
      {
        "periodo": 202604,
        "valor": -5092671171.0,
        "delta": -495383158.0
      },
      {
        "periodo": 202605,
        "valor": -5201124857.0,
        "delta": -108453686.0
      },
      {
        "periodo": 202606,
        "valor": -5005160729.0,
        "delta": 195964128.0
      },
      {
        "periodo": 202607,
        "valor": -4571814281.0,
        "delta": 433346448.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -2559933077.7,
    "valor_anterior": -2510437722.03,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2705792641.73,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2687437004.72,
        "delta": 18355637.01
      },
      {
        "periodo": 202509,
        "valor": -2726847296.25,
        "delta": -39410291.53
      },
      {
        "periodo": 202510,
        "valor": -2817584753.05,
        "delta": -90737456.8
      },
      {
        "periodo": 202511,
        "valor": -2797166441.16,
        "delta": 20418311.89
      },
      {
        "periodo": 202512,
        "valor": -2410013138.47,
        "delta": 387153302.69
      },
      {
        "periodo": 202601,
        "valor": -2383647271.57,
        "delta": 26365866.9
      },
      {
        "periodo": 202602,
        "valor": -2347342813.02,
        "delta": 36304458.55
      },
      {
        "periodo": 202603,
        "valor": -2366918199.58,
        "delta": -19575386.56
      },
      {
        "periodo": 202604,
        "valor": -2385071381.86,
        "delta": -18153182.28
      },
      {
        "periodo": 202605,
        "valor": -2429918947.62,
        "delta": -44847565.76
      },
      {
        "periodo": 202606,
        "valor": -2510437722.03,
        "delta": -80518774.41
      },
      {
        "periodo": 202607,
        "valor": -2559933077.7,
        "delta": -49495355.67
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -362932283.0,
    "valor_anterior": -340401419.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -336290842.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -345131291.0,
        "delta": -8840449.0
      },
      {
        "periodo": 202509,
        "valor": -335646862.0,
        "delta": 9484429.0
      },
      {
        "periodo": 202510,
        "valor": -384668419.0,
        "delta": -49021557.0
      },
      {
        "periodo": 202511,
        "valor": -460803683.0,
        "delta": -76135264.0
      },
      {
        "periodo": 202512,
        "valor": -474936887.0,
        "delta": -14133204.0
      },
      {
        "periodo": 202601,
        "valor": -493084448.0,
        "delta": -18147561.0
      },
      {
        "periodo": 202602,
        "valor": -489331075.0,
        "delta": 3753373.0
      },
      {
        "periodo": 202603,
        "valor": -308423047.0,
        "delta": 180908028.0
      },
      {
        "periodo": 202604,
        "valor": -331452435.0,
        "delta": -23029388.0
      },
      {
        "periodo": 202605,
        "valor": -325169177.0,
        "delta": 6283258.0
      },
      {
        "periodo": 202606,
        "valor": -340401419.0,
        "delta": -15232242.0
      },
      {
        "periodo": 202607,
        "valor": -362932283.0,
        "delta": -22530864.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -1967557040.0,
    "valor_anterior": -1951318730.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1765501673.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1757468804.0,
        "delta": 8032869.0
      },
      {
        "periodo": 202509,
        "valor": -1795899128.0,
        "delta": -38430324.0
      },
      {
        "periodo": 202510,
        "valor": -1697287097.0,
        "delta": 98612031.0
      },
      {
        "periodo": 202511,
        "valor": -1721553196.0,
        "delta": -24266099.0
      },
      {
        "periodo": 202512,
        "valor": -1853262644.0,
        "delta": -131709448.0
      },
      {
        "periodo": 202601,
        "valor": -1860498762.0,
        "delta": -7236118.0
      },
      {
        "periodo": 202602,
        "valor": -1862893635.0,
        "delta": -2394873.0
      },
      {
        "periodo": 202603,
        "valor": -1900953268.0,
        "delta": -38059633.0
      },
      {
        "periodo": 202604,
        "valor": -1917297217.0,
        "delta": -16343949.0
      },
      {
        "periodo": 202605,
        "valor": -1932775359.0,
        "delta": -15478142.0
      },
      {
        "periodo": 202606,
        "valor": -1951318730.0,
        "delta": -18543371.0
      },
      {
        "periodo": 202607,
        "valor": -1967557040.0,
        "delta": -16238310.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -972670089.0,
    "valor_anterior": -947151435.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -986270360.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -924450119.0,
        "delta": 61820241.0
      },
      {
        "periodo": 202509,
        "valor": -961880533.0,
        "delta": -37430414.0
      },
      {
        "periodo": 202510,
        "valor": -941996671.0,
        "delta": 19883862.0
      },
      {
        "periodo": 202511,
        "valor": -929883133.0,
        "delta": 12113538.0
      },
      {
        "periodo": 202512,
        "valor": -839870717.0,
        "delta": 90012416.0
      },
      {
        "periodo": 202601,
        "valor": -820563030.0,
        "delta": 19307687.0
      },
      {
        "periodo": 202602,
        "valor": -837972370.0,
        "delta": -17409340.0
      },
      {
        "periodo": 202603,
        "valor": -872718274.0,
        "delta": -34745904.0
      },
      {
        "periodo": 202604,
        "valor": -844542192.0,
        "delta": 28176082.0
      },
      {
        "periodo": 202605,
        "valor": -945385248.0,
        "delta": -100843056.0
      },
      {
        "periodo": 202606,
        "valor": -947151435.0,
        "delta": -1766187.0
      },
      {
        "periodo": 202607,
        "valor": -972670089.0,
        "delta": -25518654.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -7374258027.36,
    "valor_anterior": -7200838109.13,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -4376584886.85,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -4530428597.23,
        "delta": -153843710.38
      },
      {
        "periodo": 202509,
        "valor": -6209287017.06,
        "delta": -1678858419.83
      },
      {
        "periodo": 202510,
        "valor": -6298166521.78,
        "delta": -88879504.72
      },
      {
        "periodo": 202511,
        "valor": -6444871086.71,
        "delta": -146704564.93
      },
      {
        "periodo": 202512,
        "valor": -6633452796.99,
        "delta": -188581710.28
      },
      {
        "periodo": 202601,
        "valor": -6818475017.2,
        "delta": -185022220.21
      },
      {
        "periodo": 202602,
        "valor": -6872708506.02,
        "delta": -54233488.82
      },
      {
        "periodo": 202603,
        "valor": -7249469797.4,
        "delta": -376761291.38
      },
      {
        "periodo": 202604,
        "valor": -7298074086.17,
        "delta": -48604288.77
      },
      {
        "periodo": 202605,
        "valor": -7398822118.15,
        "delta": -100748031.98
      },
      {
        "periodo": 202606,
        "valor": -7200838109.13,
        "delta": 197984009.02
      },
      {
        "periodo": 202607,
        "valor": -7374258027.36,
        "delta": -173419918.23
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -356087818.0,
    "valor_anterior": -366262896.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -436463926.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -434189587.0,
        "delta": 2274339.0
      },
      {
        "periodo": 202509,
        "valor": -532592779.0,
        "delta": -98403192.0
      },
      {
        "periodo": 202510,
        "valor": -461209077.0,
        "delta": 71383702.0
      },
      {
        "periodo": 202511,
        "valor": -438479571.0,
        "delta": 22729506.0
      },
      {
        "periodo": 202512,
        "valor": -439311554.0,
        "delta": -831983.0
      },
      {
        "periodo": 202601,
        "valor": -408816717.0,
        "delta": 30494837.0
      },
      {
        "periodo": 202602,
        "valor": -423214637.0,
        "delta": -14397920.0
      },
      {
        "periodo": 202603,
        "valor": -412850149.0,
        "delta": 10364488.0
      },
      {
        "periodo": 202604,
        "valor": -380229599.0,
        "delta": 32620550.0
      },
      {
        "periodo": 202605,
        "valor": -344487255.0,
        "delta": 35742344.0
      },
      {
        "periodo": 202606,
        "valor": -366262896.0,
        "delta": -21775641.0
      },
      {
        "periodo": 202607,
        "valor": -356087818.0,
        "delta": 10175078.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -56518363.0,
    "valor_anterior": -61339120.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -53418333.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -57548914.0,
        "delta": -4130581.0
      },
      {
        "periodo": 202509,
        "valor": -49659801.0,
        "delta": 7889113.0
      },
      {
        "periodo": 202510,
        "valor": -68535686.0,
        "delta": -18875885.0
      },
      {
        "periodo": 202511,
        "valor": -61119880.0,
        "delta": 7415806.0
      },
      {
        "periodo": 202512,
        "valor": -53523370.0,
        "delta": 7596510.0
      },
      {
        "periodo": 202601,
        "valor": -43927240.0,
        "delta": 9596130.0
      },
      {
        "periodo": 202602,
        "valor": -64932098.0,
        "delta": -21004858.0
      },
      {
        "periodo": 202603,
        "valor": -78174552.0,
        "delta": -13242454.0
      },
      {
        "periodo": 202604,
        "valor": -68793636.0,
        "delta": 9380916.0
      },
      {
        "periodo": 202605,
        "valor": -46201831.0,
        "delta": 22591805.0
      },
      {
        "periodo": 202606,
        "valor": -61339120.0,
        "delta": -15137289.0
      },
      {
        "periodo": 202607,
        "valor": -56518363.0,
        "delta": 4820757.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -177160992.0,
    "valor_anterior": -177070307.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -156027285.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -156873714.0,
        "delta": -846429.0
      },
      {
        "periodo": 202509,
        "valor": -142560012.0,
        "delta": 14313702.0
      },
      {
        "periodo": 202510,
        "valor": -139156368.0,
        "delta": 3403644.0
      },
      {
        "periodo": 202511,
        "valor": -139966733.0,
        "delta": -810365.0
      },
      {
        "periodo": 202512,
        "valor": -171161031.0,
        "delta": -31194298.0
      },
      {
        "periodo": 202601,
        "valor": -179341103.0,
        "delta": -8180072.0
      },
      {
        "periodo": 202602,
        "valor": -188151532.0,
        "delta": -8810429.0
      },
      {
        "periodo": 202603,
        "valor": -173341723.0,
        "delta": 14809809.0
      },
      {
        "periodo": 202604,
        "valor": -171740156.0,
        "delta": 1601567.0
      },
      {
        "periodo": 202605,
        "valor": -173355515.0,
        "delta": -1615359.0
      },
      {
        "periodo": 202606,
        "valor": -177070307.0,
        "delta": -3714792.0
      },
      {
        "periodo": 202607,
        "valor": -177160992.0,
        "delta": -90685.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -816696066.79,
    "valor_anterior": -799808343.79,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -960921097.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -966919361.46,
        "delta": -5998264.19
      },
      {
        "periodo": 202509,
        "valor": -984042028.6,
        "delta": -17122667.14
      },
      {
        "periodo": 202510,
        "valor": -990287675.56,
        "delta": -6245646.96
      },
      {
        "periodo": 202511,
        "valor": -969428444.48,
        "delta": 20859231.08
      },
      {
        "periodo": 202512,
        "valor": -749718208.75,
        "delta": 219710235.73
      },
      {
        "periodo": 202601,
        "valor": -739968143.64,
        "delta": 9750065.11
      },
      {
        "periodo": 202602,
        "valor": -760428064.25,
        "delta": -20459920.61
      },
      {
        "periodo": 202603,
        "valor": -779298641.87,
        "delta": -18870577.62
      },
      {
        "periodo": 202604,
        "valor": -793442218.66,
        "delta": -14143576.79
      },
      {
        "periodo": 202605,
        "valor": -809622299.91,
        "delta": -16180081.25
      },
      {
        "periodo": 202606,
        "valor": -799808343.79,
        "delta": 9813956.12
      },
      {
        "periodo": 202607,
        "valor": -816696066.79,
        "delta": -16887723.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -1353903574.0,
    "valor_anterior": -1393835948.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1376887266.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1435325099.0,
        "delta": -58437833.0
      },
      {
        "periodo": 202509,
        "valor": -1468078414.0,
        "delta": -32753315.0
      },
      {
        "periodo": 202510,
        "valor": -1409731633.0,
        "delta": 58346781.0
      },
      {
        "periodo": 202511,
        "valor": -1402086505.0,
        "delta": 7645128.0
      },
      {
        "periodo": 202512,
        "valor": -1437939301.0,
        "delta": -35852796.0
      },
      {
        "periodo": 202601,
        "valor": -1462811514.0,
        "delta": -24872213.0
      },
      {
        "periodo": 202602,
        "valor": -1614046378.0,
        "delta": -151234864.0
      },
      {
        "periodo": 202603,
        "valor": -1630633335.0,
        "delta": -16586957.0
      },
      {
        "periodo": 202604,
        "valor": -1505002194.0,
        "delta": 125631141.0
      },
      {
        "periodo": 202605,
        "valor": -1515435194.0,
        "delta": -10433000.0
      },
      {
        "periodo": 202606,
        "valor": -1393835948.0,
        "delta": 121599246.0
      },
      {
        "periodo": 202607,
        "valor": -1353903574.0,
        "delta": 39932374.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -3481476606.63,
    "valor_anterior": -3466247597.64,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -4031167601.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -3968737973.21,
        "delta": 62429628.72
      },
      {
        "periodo": 202509,
        "valor": -3893623037.07,
        "delta": 75114936.14
      },
      {
        "periodo": 202510,
        "valor": -4053788374.64,
        "delta": -160165337.57
      },
      {
        "periodo": 202511,
        "valor": -3971265409.43,
        "delta": 82522965.21
      },
      {
        "periodo": 202512,
        "valor": -3832632907.57,
        "delta": 138632501.86
      },
      {
        "periodo": 202601,
        "valor": -3729010586.7,
        "delta": 103622320.87
      },
      {
        "periodo": 202602,
        "valor": -3703828321.2,
        "delta": 25182265.5
      },
      {
        "periodo": 202603,
        "valor": -3545984815.75,
        "delta": 157843505.45
      },
      {
        "periodo": 202604,
        "valor": -3492914941.67,
        "delta": 53069874.08
      },
      {
        "periodo": 202605,
        "valor": -3440138991.88,
        "delta": 52775949.79
      },
      {
        "periodo": 202606,
        "valor": -3466247597.64,
        "delta": -26108605.76
      },
      {
        "periodo": 202607,
        "valor": -3481476606.63,
        "delta": -15229008.99
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -1585802555.02,
    "valor_anterior": -1067000415.34,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -849100668.07,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1091389522.56,
        "delta": -242288854.49
      },
      {
        "periodo": 202509,
        "valor": -891848606.24,
        "delta": 199540916.32
      },
      {
        "periodo": 202510,
        "valor": -909849360.19,
        "delta": -18000753.95
      },
      {
        "periodo": 202511,
        "valor": -904122785.81,
        "delta": 5726574.38
      },
      {
        "periodo": 202512,
        "valor": -910097106.5,
        "delta": -5974320.69
      },
      {
        "periodo": 202601,
        "valor": -940196888.62,
        "delta": -30099782.12
      },
      {
        "periodo": 202602,
        "valor": -935582262.85,
        "delta": 4614625.77
      },
      {
        "periodo": 202603,
        "valor": -934993465.9,
        "delta": 588796.95
      },
      {
        "periodo": 202604,
        "valor": -929814511.8,
        "delta": 5178954.1
      },
      {
        "periodo": 202605,
        "valor": -943326693.77,
        "delta": -13512181.97
      },
      {
        "periodo": 202606,
        "valor": -1067000415.34,
        "delta": -123673721.57
      },
      {
        "periodo": 202607,
        "valor": -1585802555.02,
        "delta": -518802139.68
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -917684842.0,
    "valor_anterior": -871570250.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -355288871.56,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -372551172.75,
        "delta": -17262301.19
      },
      {
        "periodo": 202509,
        "valor": -500164039.0,
        "delta": -127612866.25
      },
      {
        "periodo": 202510,
        "valor": -519508774.0,
        "delta": -19344735.0
      },
      {
        "periodo": 202511,
        "valor": -561849546.0,
        "delta": -42340772.0
      },
      {
        "periodo": 202512,
        "valor": -598759443.0,
        "delta": -36909897.0
      },
      {
        "periodo": 202601,
        "valor": -638329348.0,
        "delta": -39569905.0
      },
      {
        "periodo": 202602,
        "valor": -676585641.0,
        "delta": -38256293.0
      },
      {
        "periodo": 202603,
        "valor": -732481707.0,
        "delta": -55896066.0
      },
      {
        "periodo": 202604,
        "valor": -829371592.0,
        "delta": -96889885.0
      },
      {
        "periodo": 202605,
        "valor": -911684335.0,
        "delta": -82312743.0
      },
      {
        "periodo": 202606,
        "valor": -871570250.0,
        "delta": 40114085.0
      },
      {
        "periodo": 202607,
        "valor": -917684842.0,
        "delta": -46114592.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -2370082825.0,
    "valor_anterior": -2325528511.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1866512797.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1896573173.0,
        "delta": -30060376.0
      },
      {
        "periodo": 202509,
        "valor": -2072255882.0,
        "delta": -175682709.0
      },
      {
        "periodo": 202510,
        "valor": -2023945244.0,
        "delta": 48310638.0
      },
      {
        "periodo": 202511,
        "valor": -2021508402.0,
        "delta": 2436842.0
      },
      {
        "periodo": 202512,
        "valor": -2120473989.0,
        "delta": -98965587.0
      },
      {
        "periodo": 202601,
        "valor": -2094524577.0,
        "delta": 25949412.0
      },
      {
        "periodo": 202602,
        "valor": -2159415675.0,
        "delta": -64891098.0
      },
      {
        "periodo": 202603,
        "valor": -2137314868.0,
        "delta": 22100807.0
      },
      {
        "periodo": 202604,
        "valor": -2351964426.0,
        "delta": -214649558.0
      },
      {
        "periodo": 202605,
        "valor": -2319114175.0,
        "delta": 32850251.0
      },
      {
        "periodo": 202606,
        "valor": -2325528511.0,
        "delta": -6414336.0
      },
      {
        "periodo": 202607,
        "valor": -2370082825.0,
        "delta": -44554314.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -441307118.0,
    "valor_anterior": -435127336.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -639222799.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -658208533.0,
        "delta": -18985734.0
      },
      {
        "periodo": 202509,
        "valor": -622619457.0,
        "delta": 35589076.0
      },
      {
        "periodo": 202510,
        "valor": -614429773.0,
        "delta": 8189684.0
      },
      {
        "periodo": 202511,
        "valor": -536489090.0,
        "delta": 77940683.0
      },
      {
        "periodo": 202512,
        "valor": -574052450.0,
        "delta": -37563360.0
      },
      {
        "periodo": 202601,
        "valor": -572927286.0,
        "delta": 1125164.0
      },
      {
        "periodo": 202602,
        "valor": -553429045.0,
        "delta": 19498241.0
      },
      {
        "periodo": 202603,
        "valor": -596666055.0,
        "delta": -43237010.0
      },
      {
        "periodo": 202604,
        "valor": -579941487.0,
        "delta": 16724568.0
      },
      {
        "periodo": 202605,
        "valor": -404186070.0,
        "delta": 175755417.0
      },
      {
        "periodo": 202606,
        "valor": -435127336.0,
        "delta": -30941266.0
      },
      {
        "periodo": 202607,
        "valor": -441307118.0,
        "delta": -6179782.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -174391334.0,
    "valor_anterior": -531912392.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -792430772.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -810641833.0,
        "delta": -18211061.0
      },
      {
        "periodo": 202509,
        "valor": -742133215.0,
        "delta": 68508618.0
      },
      {
        "periodo": 202510,
        "valor": -796755399.0,
        "delta": -54622184.0
      },
      {
        "periodo": 202511,
        "valor": -741769944.0,
        "delta": 54985455.0
      },
      {
        "periodo": 202512,
        "valor": -484477682.0,
        "delta": 257292262.0
      },
      {
        "periodo": 202601,
        "valor": -462482024.0,
        "delta": 21995658.0
      },
      {
        "periodo": 202602,
        "valor": -463588733.0,
        "delta": -1106709.0
      },
      {
        "periodo": 202603,
        "valor": -478827399.0,
        "delta": -15238666.0
      },
      {
        "periodo": 202604,
        "valor": -471006903.0,
        "delta": 7820496.0
      },
      {
        "periodo": 202605,
        "valor": -470918314.0,
        "delta": 88589.0
      },
      {
        "periodo": 202606,
        "valor": -531912392.0,
        "delta": -60994078.0
      },
      {
        "periodo": 202607,
        "valor": -174391334.0,
        "delta": 357521058.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -1284461557.68,
    "valor_anterior": -1236282914.03,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1394413651.92,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1423375216.67,
        "delta": -28961564.75
      },
      {
        "periodo": 202509,
        "valor": -1425858680.5,
        "delta": -2483463.83
      },
      {
        "periodo": 202510,
        "valor": -826510051.95,
        "delta": 599348628.55
      },
      {
        "periodo": 202511,
        "valor": -972238547.23,
        "delta": -145728495.28
      },
      {
        "periodo": 202512,
        "valor": -748920061.89,
        "delta": 223318485.34
      },
      {
        "periodo": 202601,
        "valor": -1239824081.19,
        "delta": -490904019.3
      },
      {
        "periodo": 202602,
        "valor": -1245914825.43,
        "delta": -6090744.24
      },
      {
        "periodo": 202603,
        "valor": -1410825428.86,
        "delta": -164910603.43
      },
      {
        "periodo": 202604,
        "valor": -1557978272.85,
        "delta": -147152843.99
      },
      {
        "periodo": 202605,
        "valor": -1627091377.53,
        "delta": -69113104.68
      },
      {
        "periodo": 202606,
        "valor": -1236282914.03,
        "delta": 390808463.5
      },
      {
        "periodo": 202607,
        "valor": -1284461557.68,
        "delta": -48178643.65
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -27175196.0,
    "valor_anterior": -26820554.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -26526056.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -28884908.0,
        "delta": -2358852.0
      },
      {
        "periodo": 202509,
        "valor": -27802809.0,
        "delta": 1082099.0
      },
      {
        "periodo": 202510,
        "valor": -27490594.0,
        "delta": 312215.0
      },
      {
        "periodo": 202511,
        "valor": -26137139.0,
        "delta": 1353455.0
      },
      {
        "periodo": 202512,
        "valor": -24961475.0,
        "delta": 1175664.0
      },
      {
        "periodo": 202601,
        "valor": -24867382.0,
        "delta": 94093.0
      },
      {
        "periodo": 202602,
        "valor": -25249528.0,
        "delta": -382146.0
      },
      {
        "periodo": 202603,
        "valor": -25362780.0,
        "delta": -113252.0
      },
      {
        "periodo": 202604,
        "valor": -25475815.0,
        "delta": -113035.0
      },
      {
        "periodo": 202605,
        "valor": -26642596.0,
        "delta": -1166781.0
      },
      {
        "periodo": 202606,
        "valor": -26820554.0,
        "delta": -177958.0
      },
      {
        "periodo": 202607,
        "valor": -27175196.0,
        "delta": -354642.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -1511714.0,
    "valor_anterior": -1472185.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1078552.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1381933.0,
        "delta": -303381.0
      },
      {
        "periodo": 202509,
        "valor": -1410555.0,
        "delta": -28622.0
      },
      {
        "periodo": 202510,
        "valor": -1383301.0,
        "delta": 27254.0
      },
      {
        "periodo": 202511,
        "valor": -1243696.0,
        "delta": 139605.0
      },
      {
        "periodo": 202512,
        "valor": -1258209.0,
        "delta": -14513.0
      },
      {
        "periodo": 202601,
        "valor": -1258209.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": -1258209.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": -1243527.0,
        "delta": 14682.0
      },
      {
        "periodo": 202604,
        "valor": -1243527.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": -1436036.0,
        "delta": -192509.0
      },
      {
        "periodo": 202606,
        "valor": -1472185.0,
        "delta": -36149.0
      },
      {
        "periodo": 202607,
        "valor": -1511714.0,
        "delta": -39529.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -144322382.0,
    "valor_anterior": -118174568.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -145569258.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -140424943.0,
        "delta": 5144315.0
      },
      {
        "periodo": 202509,
        "valor": -140048614.0,
        "delta": 376329.0
      },
      {
        "periodo": 202510,
        "valor": -144194394.0,
        "delta": -4145780.0
      },
      {
        "periodo": 202511,
        "valor": -131848005.0,
        "delta": 12346389.0
      },
      {
        "periodo": 202512,
        "valor": -129288779.0,
        "delta": 2559226.0
      },
      {
        "periodo": 202601,
        "valor": -131715449.0,
        "delta": -2426670.0
      },
      {
        "periodo": 202602,
        "valor": -139150659.0,
        "delta": -7435210.0
      },
      {
        "periodo": 202603,
        "valor": -128588558.0,
        "delta": 10562101.0
      },
      {
        "periodo": 202604,
        "valor": -128739230.0,
        "delta": -150672.0
      },
      {
        "periodo": 202605,
        "valor": -129243532.0,
        "delta": -504302.0
      },
      {
        "periodo": 202606,
        "valor": -118174568.0,
        "delta": 11068964.0
      },
      {
        "periodo": 202607,
        "valor": -144322382.0,
        "delta": -26147814.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -243615599.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -244421727.0,
        "delta": -806128.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -316963639.0,
    "valor_anterior": -315853551.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -284791225.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -288858080.0,
        "delta": -4066855.0
      },
      {
        "periodo": 202509,
        "valor": -293723879.0,
        "delta": -4865799.0
      },
      {
        "periodo": 202510,
        "valor": -295575782.0,
        "delta": -1851903.0
      },
      {
        "periodo": 202511,
        "valor": -291471974.0,
        "delta": 4103808.0
      },
      {
        "periodo": 202512,
        "valor": -301981492.0,
        "delta": -10509518.0
      },
      {
        "periodo": 202601,
        "valor": -294865083.0,
        "delta": 7116409.0
      },
      {
        "periodo": 202602,
        "valor": -303932899.0,
        "delta": -9067816.0
      },
      {
        "periodo": 202603,
        "valor": -329769971.0,
        "delta": -25837072.0
      },
      {
        "periodo": 202604,
        "valor": -275275744.0,
        "delta": 54494227.0
      },
      {
        "periodo": 202605,
        "valor": -304933103.0,
        "delta": -29657359.0
      },
      {
        "periodo": 202606,
        "valor": -315853551.0,
        "delta": -10920448.0
      },
      {
        "periodo": 202607,
        "valor": -316963639.0,
        "delta": -1110088.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -309662293.0,
    "valor_anterior": -287051647.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -226247391.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -232273105.0,
        "delta": -6025714.0
      },
      {
        "periodo": 202509,
        "valor": -213868104.0,
        "delta": 18405001.0
      },
      {
        "periodo": 202510,
        "valor": -218055693.0,
        "delta": -4187589.0
      },
      {
        "periodo": 202511,
        "valor": -232240436.0,
        "delta": -14184743.0
      },
      {
        "periodo": 202512,
        "valor": -245891599.0,
        "delta": -13651163.0
      },
      {
        "periodo": 202601,
        "valor": -244391580.0,
        "delta": 1500019.0
      },
      {
        "periodo": 202602,
        "valor": -260440312.0,
        "delta": -16048732.0
      },
      {
        "periodo": 202603,
        "valor": -273589307.0,
        "delta": -13148995.0
      },
      {
        "periodo": 202604,
        "valor": -279692241.0,
        "delta": -6102934.0
      },
      {
        "periodo": 202605,
        "valor": -291588998.0,
        "delta": -11896757.0
      },
      {
        "periodo": 202606,
        "valor": -287051647.0,
        "delta": 4537351.0
      },
      {
        "periodo": 202607,
        "valor": -309662293.0,
        "delta": -22610646.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -229429170.25,
    "valor_anterior": -239027903.22,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -233428692.11,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -227592692.2,
        "delta": 5835999.91
      },
      {
        "periodo": 202509,
        "valor": -221979113.72,
        "delta": 5613578.48
      },
      {
        "periodo": 202510,
        "valor": -228153645.2,
        "delta": -6174531.48
      },
      {
        "periodo": 202511,
        "valor": -226137357.9,
        "delta": 2016287.3
      },
      {
        "periodo": 202512,
        "valor": -210830818.33,
        "delta": 15306539.57
      },
      {
        "periodo": 202601,
        "valor": -210178136.04,
        "delta": 652682.29
      },
      {
        "periodo": 202602,
        "valor": -217979734.91,
        "delta": -7801598.87
      },
      {
        "periodo": 202603,
        "valor": -218379930.08,
        "delta": -400195.17
      },
      {
        "periodo": 202604,
        "valor": -223969655.54,
        "delta": -5589725.46
      },
      {
        "periodo": 202605,
        "valor": -227756874.81,
        "delta": -3787219.27
      },
      {
        "periodo": 202606,
        "valor": -239027903.22,
        "delta": -11271028.41
      },
      {
        "periodo": 202607,
        "valor": -229429170.25,
        "delta": 9598732.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -8980761.0,
    "valor_anterior": -8620486.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -12560838.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -11942080.0,
        "delta": 618758.0
      },
      {
        "periodo": 202509,
        "valor": -11399277.0,
        "delta": 542803.0
      },
      {
        "periodo": 202510,
        "valor": -9167234.0,
        "delta": 2232043.0
      },
      {
        "periodo": 202511,
        "valor": -9103609.0,
        "delta": 63625.0
      },
      {
        "periodo": 202512,
        "valor": -9125261.0,
        "delta": -21652.0
      },
      {
        "periodo": 202601,
        "valor": -8824309.0,
        "delta": 300952.0
      },
      {
        "periodo": 202602,
        "valor": -8900983.0,
        "delta": -76674.0
      },
      {
        "periodo": 202603,
        "valor": -8925353.0,
        "delta": -24370.0
      },
      {
        "periodo": 202604,
        "valor": -8973278.0,
        "delta": -47925.0
      },
      {
        "periodo": 202605,
        "valor": -8694365.0,
        "delta": 278913.0
      },
      {
        "periodo": 202606,
        "valor": -8620486.0,
        "delta": 73879.0
      },
      {
        "periodo": 202607,
        "valor": -8980761.0,
        "delta": -360275.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -957008091.48,
    "valor_anterior": -949278011.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -611104499.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -593337511.41,
        "delta": 17766988.01
      },
      {
        "periodo": 202509,
        "valor": -766296210.83,
        "delta": -172958699.42
      },
      {
        "periodo": 202510,
        "valor": -725820211.6,
        "delta": 40475999.23
      },
      {
        "periodo": 202511,
        "valor": -725957438.91,
        "delta": -137227.31
      },
      {
        "periodo": 202512,
        "valor": -724873192.81,
        "delta": 1084246.1
      },
      {
        "periodo": 202601,
        "valor": -729948181.07,
        "delta": -5074988.26
      },
      {
        "periodo": 202602,
        "valor": -736595618.72,
        "delta": -6647437.65
      },
      {
        "periodo": 202603,
        "valor": -857552730.64,
        "delta": -120957111.92
      },
      {
        "periodo": 202604,
        "valor": -865258979.8,
        "delta": -7706249.16
      },
      {
        "periodo": 202605,
        "valor": -868955430.99,
        "delta": -3696451.19
      },
      {
        "periodo": 202606,
        "valor": -949278011.0,
        "delta": -80322580.01
      },
      {
        "periodo": 202607,
        "valor": -957008091.48,
        "delta": -7730080.48
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -332129766.51,
    "valor_anterior": -334254277.44,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -248280372.7,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -258378827.88,
        "delta": -10098455.18
      },
      {
        "periodo": 202509,
        "valor": -275452682.34,
        "delta": -17073854.46
      },
      {
        "periodo": 202510,
        "valor": -289085273.78,
        "delta": -13632591.44
      },
      {
        "periodo": 202511,
        "valor": -301419748.47,
        "delta": -12334474.69
      },
      {
        "periodo": 202512,
        "valor": -318607518.48,
        "delta": -17187770.01
      },
      {
        "periodo": 202601,
        "valor": -326774174.98,
        "delta": -8166656.5
      },
      {
        "periodo": 202602,
        "valor": -329426614.69,
        "delta": -2652439.71
      },
      {
        "periodo": 202603,
        "valor": -336493635.42,
        "delta": -7067020.73
      },
      {
        "periodo": 202604,
        "valor": -341353905.62,
        "delta": -4860270.2
      },
      {
        "periodo": 202605,
        "valor": -359174514.51,
        "delta": -17820608.89
      },
      {
        "periodo": 202606,
        "valor": -334254277.44,
        "delta": 24920237.07
      },
      {
        "periodo": 202607,
        "valor": -332129766.51,
        "delta": 2124510.93
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -201452129.0,
    "valor_anterior": -158987460.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -66548751.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -68161069.0,
        "delta": -1612318.0
      },
      {
        "periodo": 202509,
        "valor": -60588200.0,
        "delta": 7572869.0
      },
      {
        "periodo": 202510,
        "valor": -62925193.0,
        "delta": -2336993.0
      },
      {
        "periodo": 202511,
        "valor": -63133020.0,
        "delta": -207827.0
      },
      {
        "periodo": 202512,
        "valor": -69825098.0,
        "delta": -6692078.0
      },
      {
        "periodo": 202601,
        "valor": -68025987.0,
        "delta": 1799111.0
      },
      {
        "periodo": 202602,
        "valor": -41294990.0,
        "delta": 26730997.0
      },
      {
        "periodo": 202603,
        "valor": -89950708.0,
        "delta": -48655718.0
      },
      {
        "periodo": 202604,
        "valor": -149210018.0,
        "delta": -59259310.0
      },
      {
        "periodo": 202605,
        "valor": -150963308.0,
        "delta": -1753290.0
      },
      {
        "periodo": 202606,
        "valor": -158987460.0,
        "delta": -8024152.0
      },
      {
        "periodo": 202607,
        "valor": -201452129.0,
        "delta": -42464669.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -1544247368.0,
    "valor_anterior": -1540005634.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1485357498.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1406529168.0,
        "delta": 78828330.0
      },
      {
        "periodo": 202509,
        "valor": -1322009824.0,
        "delta": 84519344.0
      },
      {
        "periodo": 202510,
        "valor": -1323316814.0,
        "delta": -1306990.0
      },
      {
        "periodo": 202511,
        "valor": -1312615084.0,
        "delta": 10701730.0
      },
      {
        "periodo": 202512,
        "valor": -1367158481.0,
        "delta": -54543397.0
      },
      {
        "periodo": 202601,
        "valor": -1474669362.0,
        "delta": -107510881.0
      },
      {
        "periodo": 202602,
        "valor": -1502663436.0,
        "delta": -27994074.0
      },
      {
        "periodo": 202603,
        "valor": -1553688632.0,
        "delta": -51025196.0
      },
      {
        "periodo": 202604,
        "valor": -1573708251.0,
        "delta": -20019619.0
      },
      {
        "periodo": 202605,
        "valor": -1567641719.0,
        "delta": 6066532.0
      },
      {
        "periodo": 202606,
        "valor": -1540005634.0,
        "delta": 27636085.0
      },
      {
        "periodo": 202607,
        "valor": -1544247368.0,
        "delta": -4241734.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -24282701.0,
    "valor_anterior": -37903324.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -46005055.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -41397119.0,
        "delta": 4607936.0
      },
      {
        "periodo": 202509,
        "valor": -40497151.0,
        "delta": 899968.0
      },
      {
        "periodo": 202510,
        "valor": -40171532.0,
        "delta": 325619.0
      },
      {
        "periodo": 202511,
        "valor": -40213825.0,
        "delta": -42293.0
      },
      {
        "periodo": 202512,
        "valor": -39945683.0,
        "delta": 268142.0
      },
      {
        "periodo": 202601,
        "valor": -38547103.0,
        "delta": 1398580.0
      },
      {
        "periodo": 202602,
        "valor": -38154404.0,
        "delta": 392699.0
      },
      {
        "periodo": 202603,
        "valor": -38958013.0,
        "delta": -803609.0
      },
      {
        "periodo": 202604,
        "valor": -35830161.0,
        "delta": 3127852.0
      },
      {
        "periodo": 202605,
        "valor": -34958433.0,
        "delta": 871728.0
      },
      {
        "periodo": 202606,
        "valor": -37903324.0,
        "delta": -2944891.0
      },
      {
        "periodo": 202607,
        "valor": -24282701.0,
        "delta": 13620623.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -31632175.62,
    "valor_anterior": -31662237.22,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -27829226.18,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -27683304.83,
        "delta": 145921.35
      },
      {
        "periodo": 202509,
        "valor": -27902282.29,
        "delta": -218977.46
      },
      {
        "periodo": 202510,
        "valor": -27334089.21,
        "delta": 568193.08
      },
      {
        "periodo": 202511,
        "valor": -10762163.95,
        "delta": 16571925.26
      },
      {
        "periodo": 202512,
        "valor": -11216213.69,
        "delta": -454049.74
      },
      {
        "periodo": 202601,
        "valor": -11673505.44,
        "delta": -457291.75
      },
      {
        "periodo": 202602,
        "valor": -13294049.6,
        "delta": -1620544.16
      },
      {
        "periodo": 202603,
        "valor": -12741478.62,
        "delta": 552570.98
      },
      {
        "periodo": 202604,
        "valor": -31164218.28,
        "delta": -18422739.66
      },
      {
        "periodo": 202605,
        "valor": -32066696.56,
        "delta": -902478.28
      },
      {
        "periodo": 202606,
        "valor": -31662237.22,
        "delta": 404459.34
      },
      {
        "periodo": 202607,
        "valor": -31632175.62,
        "delta": 30061.6
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -78013949.53,
    "valor_anterior": -77179489.23,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -129891896.6,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -122782638.88,
        "delta": 7109257.72
      },
      {
        "periodo": 202509,
        "valor": -118173140.64,
        "delta": 4609498.24
      },
      {
        "periodo": 202510,
        "valor": -71974983.7,
        "delta": 46198156.94
      },
      {
        "periodo": 202511,
        "valor": -74192375.77,
        "delta": -2217392.07
      },
      {
        "periodo": 202512,
        "valor": -73097169.09,
        "delta": 1095206.68
      },
      {
        "periodo": 202601,
        "valor": -73652186.79,
        "delta": -555017.7
      },
      {
        "periodo": 202602,
        "valor": -74815086.94,
        "delta": -1162900.15
      },
      {
        "periodo": 202603,
        "valor": -71368012.58,
        "delta": 3447074.36
      },
      {
        "periodo": 202604,
        "valor": -72266141.17,
        "delta": -898128.59
      },
      {
        "periodo": 202605,
        "valor": -72272012.76,
        "delta": -5871.59
      },
      {
        "periodo": 202606,
        "valor": -77179489.23,
        "delta": -4907476.47
      },
      {
        "periodo": 202607,
        "valor": -78013949.53,
        "delta": -834460.3
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -236.0,
    "valor_anterior": -119673.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1688532.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1276702.0,
        "delta": 411830.0
      },
      {
        "periodo": 202509,
        "valor": -223108.0,
        "delta": 1053594.0
      },
      {
        "periodo": 202510,
        "valor": -253066.0,
        "delta": -29958.0
      },
      {
        "periodo": 202511,
        "valor": -1229514.0,
        "delta": -976448.0
      },
      {
        "periodo": 202512,
        "valor": -85571.0,
        "delta": 1143943.0
      },
      {
        "periodo": 202601,
        "valor": -129074.0,
        "delta": -43503.0
      },
      {
        "periodo": 202602,
        "valor": -70077.0,
        "delta": 58997.0
      },
      {
        "periodo": 202603,
        "valor": -825541.0,
        "delta": -755464.0
      },
      {
        "periodo": 202604,
        "valor": -1106937.0,
        "delta": -281396.0
      },
      {
        "periodo": 202605,
        "valor": -271719.0,
        "delta": 835218.0
      },
      {
        "periodo": 202606,
        "valor": -119673.0,
        "delta": 152046.0
      },
      {
        "periodo": 202607,
        "valor": -236.0,
        "delta": 119437.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -74481397.0,
    "valor_anterior": -74660148.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -74139374.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -73692878.0,
        "delta": 446496.0
      },
      {
        "periodo": 202509,
        "valor": -73596804.0,
        "delta": 96074.0
      },
      {
        "periodo": 202510,
        "valor": -73472046.0,
        "delta": 124758.0
      },
      {
        "periodo": 202511,
        "valor": -76433177.0,
        "delta": -2961131.0
      },
      {
        "periodo": 202512,
        "valor": -76435008.0,
        "delta": -1831.0
      },
      {
        "periodo": 202601,
        "valor": -76217308.0,
        "delta": 217700.0
      },
      {
        "periodo": 202602,
        "valor": -76182744.0,
        "delta": 34564.0
      },
      {
        "periodo": 202603,
        "valor": -77390505.0,
        "delta": -1207761.0
      },
      {
        "periodo": 202604,
        "valor": -77948906.0,
        "delta": -558401.0
      },
      {
        "periodo": 202605,
        "valor": -76004591.0,
        "delta": 1944315.0
      },
      {
        "periodo": 202606,
        "valor": -74660148.0,
        "delta": 1344443.0
      },
      {
        "periodo": 202607,
        "valor": -74481397.0,
        "delta": 178751.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -159323879.26,
    "valor_anterior": -147350716.83,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": -95760226.38,
        "delta": -95760226.38
      },
      {
        "periodo": 202603,
        "valor": -99867000.13,
        "delta": -4106773.75
      },
      {
        "periodo": 202604,
        "valor": -128533473.69,
        "delta": -28666473.56
      },
      {
        "periodo": 202605,
        "valor": -143718744.14,
        "delta": -15185270.45
      },
      {
        "periodo": 202606,
        "valor": -147350716.83,
        "delta": -3631972.69
      },
      {
        "periodo": 202607,
        "valor": -159323879.26,
        "delta": -11973162.43
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -77444193116.0,
    "valor_anterior": -77181759480.75,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -70602263624.91,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -71535703771.34,
        "delta": -933440146.43
      },
      {
        "periodo": 202509,
        "valor": -73551933902.15,
        "delta": -2016230130.81
      },
      {
        "periodo": 202510,
        "valor": -73634700585.32,
        "delta": -82766683.17
      },
      {
        "periodo": 202511,
        "valor": -73699953994.46,
        "delta": -65253409.14
      },
      {
        "periodo": 202512,
        "valor": -71590121552.23,
        "delta": 2109832442.23
      },
      {
        "periodo": 202601,
        "valor": -72241268636.06,
        "delta": -651147083.83
      },
      {
        "periodo": 202602,
        "valor": -73126310734.63,
        "delta": -885042098.57
      },
      {
        "periodo": 202603,
        "valor": -74530289920.55,
        "delta": -1403979185.92
      },
      {
        "periodo": 202604,
        "valor": -76113717341.54,
        "delta": -1583427420.99
      },
      {
        "periodo": 202605,
        "valor": -77111774257.48,
        "delta": -998056915.94
      },
      {
        "periodo": 202606,
        "valor": -77181759480.75,
        "delta": -69985223.27
      },
      {
        "periodo": 202607,
        "valor": -77444193116.0,
        "delta": -262433635.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -48075737928.41,
    "valor_anterior": -48460085138.76,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -42368556694.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -43130411030.32,
        "delta": -761854336.06
      },
      {
        "periodo": 202509,
        "valor": -44981236155.04,
        "delta": -1850825124.72
      },
      {
        "periodo": 202510,
        "valor": -45664119524.19,
        "delta": -682883369.15
      },
      {
        "periodo": 202511,
        "valor": -45843439593.94,
        "delta": -179320069.75
      },
      {
        "periodo": 202512,
        "valor": -44986189707.02,
        "delta": 857249886.92
      },
      {
        "periodo": 202601,
        "valor": -45093755722.57,
        "delta": -107566015.55
      },
      {
        "periodo": 202602,
        "valor": -45384522389.36,
        "delta": -290766666.79
      },
      {
        "periodo": 202603,
        "valor": -46566376393.78,
        "delta": -1181854004.42
      },
      {
        "periodo": 202604,
        "valor": -47547959190.1,
        "delta": -981582796.32
      },
      {
        "periodo": 202605,
        "valor": -48387297503.7,
        "delta": -839338313.6
      },
      {
        "periodo": 202606,
        "valor": -48460085138.76,
        "delta": -72787635.06
      },
      {
        "periodo": 202607,
        "valor": -48075737928.41,
        "delta": 384347210.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -1308051039.79,
    "valor_anterior": -1647574286.79,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2281758693.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2310841001.46,
        "delta": -29082308.19
      },
      {
        "periodo": 202509,
        "valor": -2019899122.6,
        "delta": 290941878.86
      },
      {
        "periodo": 202510,
        "valor": -2082618856.56,
        "delta": -62719733.96
      },
      {
        "periodo": 202511,
        "valor": -2002670362.48,
        "delta": 79948494.08
      },
      {
        "periodo": 202512,
        "valor": -1536177382.75,
        "delta": 466492979.73
      },
      {
        "periodo": 202601,
        "valor": -1497315250.64,
        "delta": 38862132.11
      },
      {
        "periodo": 202602,
        "valor": -1527949696.25,
        "delta": -30634445.61
      },
      {
        "periodo": 202603,
        "valor": -1587896011.87,
        "delta": -59946315.62
      },
      {
        "periodo": 202604,
        "valor": -1539724865.66,
        "delta": 48171146.21
      },
      {
        "periodo": 202605,
        "valor": -1585473716.91,
        "delta": -45748851.25
      },
      {
        "periodo": 202606,
        "valor": -1647574286.79,
        "delta": -62100569.88
      },
      {
        "periodo": 202607,
        "valor": -1308051039.79,
        "delta": 339523247.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -5408358101.63,
    "valor_anterior": -5360064632.64,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -6002405431.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -5889590233.21,
        "delta": 112815198.72
      },
      {
        "periodo": 202509,
        "valor": -5917596687.07,
        "delta": -28006453.86
      },
      {
        "periodo": 202510,
        "valor": -6050990962.64,
        "delta": -133394275.57
      },
      {
        "periodo": 202511,
        "valor": -6003991619.43,
        "delta": 46999343.21
      },
      {
        "periodo": 202512,
        "valor": -5812780246.57,
        "delta": 191211372.86
      },
      {
        "periodo": 202601,
        "valor": -5676130407.7,
        "delta": 136649838.87
      },
      {
        "periodo": 202602,
        "valor": -5708758319.2,
        "delta": -32627911.5
      },
      {
        "periodo": 202603,
        "valor": -5393561628.75,
        "delta": 315196690.45
      },
      {
        "periodo": 202604,
        "valor": -5292023423.67,
        "delta": 101538205.08
      },
      {
        "periodo": 202605,
        "valor": -5276445772.88,
        "delta": 15577650.79
      },
      {
        "periodo": 202606,
        "valor": -5360064632.64,
        "delta": -83618859.76
      },
      {
        "periodo": 202607,
        "valor": -5408358101.63,
        "delta": -48293468.99
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -13877339041.82,
    "valor_anterior": -13661764955.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -13097883731.89,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -13075317180.17,
        "delta": 22566551.72
      },
      {
        "periodo": 202509,
        "valor": -13419207637.88,
        "delta": -343890457.71
      },
      {
        "periodo": 202510,
        "valor": -13351541296.3,
        "delta": 67666341.58
      },
      {
        "periodo": 202511,
        "valor": -13236020957.57,
        "delta": 115520338.73
      },
      {
        "periodo": 202512,
        "valor": -12635784695.1,
        "delta": 600236262.47
      },
      {
        "periodo": 202601,
        "valor": -12777475587.02,
        "delta": -141690891.92
      },
      {
        "periodo": 202602,
        "valor": -13173429969.3,
        "delta": -395954382.28
      },
      {
        "periodo": 202603,
        "valor": -13167367949.92,
        "delta": 6062019.38
      },
      {
        "periodo": 202604,
        "valor": -13551190758.36,
        "delta": -383822808.44
      },
      {
        "periodo": 202605,
        "valor": -13621453331.92,
        "delta": -70262573.56
      },
      {
        "periodo": 202606,
        "valor": -13661764955.25,
        "delta": -40311623.33
      },
      {
        "periodo": 202607,
        "valor": -13877339041.82,
        "delta": -215574086.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -5600796630.39,
    "valor_anterior": -5483461853.11,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -4462575495.57,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -4474354643.95,
        "delta": -11779148.38
      },
      {
        "periodo": 202509,
        "valor": -4756238398.82,
        "delta": -281883754.87
      },
      {
        "periodo": 202510,
        "valor": -4604876139.49,
        "delta": 151362259.33
      },
      {
        "periodo": 202511,
        "valor": -4605622123.0,
        "delta": -745983.51
      },
      {
        "periodo": 202512,
        "valor": -4830883573.4,
        "delta": -225261450.4
      },
      {
        "periodo": 202601,
        "valor": -4884855249.32,
        "delta": -53971675.92
      },
      {
        "periodo": 202602,
        "valor": -4915242386.86,
        "delta": -30387137.54
      },
      {
        "periodo": 202603,
        "valor": -5240813483.34,
        "delta": -325571096.48
      },
      {
        "periodo": 202604,
        "valor": -5437753615.41,
        "delta": -196940132.07
      },
      {
        "periodo": 202605,
        "valor": -5397723584.63,
        "delta": 40030030.78
      },
      {
        "periodo": 202606,
        "valor": -5483461853.11,
        "delta": -85738268.48
      },
      {
        "periodo": 202607,
        "valor": -5600796630.39,
        "delta": -117334777.28
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100032,
    "label": "EPRC Balance Comercial",
    "valor_actual": -3173910373.96,
    "valor_anterior": -2568808614.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2389083577.99,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2655189682.23,
        "delta": -266106104.24
      },
      {
        "periodo": 202509,
        "valor": -2457755900.74,
        "delta": 197433781.49
      },
      {
        "periodo": 202510,
        "valor": -1880553806.14,
        "delta": 577202094.6
      },
      {
        "periodo": 202511,
        "valor": -2008209338.04,
        "delta": -127655531.9
      },
      {
        "periodo": 202512,
        "valor": -1788305947.39,
        "delta": 219903390.65
      },
      {
        "periodo": 202601,
        "valor": -2311736418.81,
        "delta": -523430471.42
      },
      {
        "periodo": 202602,
        "valor": -2416407973.66,
        "delta": -104671554.85
      },
      {
        "periodo": 202603,
        "valor": -2574274452.89,
        "delta": -157866479.23
      },
      {
        "periodo": 202604,
        "valor": -2745065488.34,
        "delta": -170791035.45
      },
      {
        "periodo": 202605,
        "valor": -2843380347.44,
        "delta": -98314859.1
      },
      {
        "periodo": 202606,
        "valor": -2568808614.2,
        "delta": 274571733.24
      },
      {
        "periodo": 202607,
        "valor": -3173910373.96,
        "delta": -605101759.76
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -23267845771.06,
    "valor_anterior": -23259325160.41,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -20285738616.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -20641152554.61,
        "delta": -355413938.61
      },
      {
        "periodo": 202509,
        "valor": -21146924990.82,
        "delta": -505772436.21
      },
      {
        "periodo": 202510,
        "valor": -21620852368.92,
        "delta": -473927378.1
      },
      {
        "periodo": 202511,
        "valor": -21994132305.54,
        "delta": -373279936.62
      },
      {
        "periodo": 202512,
        "valor": -22161862518.49,
        "delta": -167730212.95
      },
      {
        "periodo": 202601,
        "valor": -22174591748.74,
        "delta": -12729230.25
      },
      {
        "periodo": 202602,
        "valor": -22406446723.56,
        "delta": -231854974.82
      },
      {
        "periodo": 202603,
        "valor": -22550955064.65,
        "delta": -144508341.09
      },
      {
        "periodo": 202604,
        "valor": -22791041995.15,
        "delta": -240086930.5
      },
      {
        "periodo": 202605,
        "valor": -23140839588.31,
        "delta": -349797593.16
      },
      {
        "periodo": 202606,
        "valor": -23259325160.41,
        "delta": -118485572.1
      },
      {
        "periodo": 202607,
        "valor": -23267845771.06,
        "delta": -8520610.65
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -51707661612.729996,
    "valor_anterior": -50625063217.6,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -42743314727.91,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -43284630074.32,
        "delta": -541315346.41
      },
      {
        "periodo": 202509,
        "valor": -44388926542.03,
        "delta": -1104296467.71
      },
      {
        "periodo": 202510,
        "valor": -45605664293.62,
        "delta": -1216737751.59
      },
      {
        "periodo": 202511,
        "valor": -45879245995.74,
        "delta": -273581702.12
      },
      {
        "periodo": 202512,
        "valor": -46724577419.95,
        "delta": -845331424.21
      },
      {
        "periodo": 202601,
        "valor": -46358829365.3,
        "delta": 365748054.65
      },
      {
        "periodo": 202602,
        "valor": -48691692380.68,
        "delta": -2332863015.38
      },
      {
        "periodo": 202603,
        "valor": -49667911986.83,
        "delta": -976219606.15
      },
      {
        "periodo": 202604,
        "valor": -49214603021.95,
        "delta": 453308964.88
      },
      {
        "periodo": 202605,
        "valor": -49928701479.65,
        "delta": -714098457.7
      },
      {
        "periodo": 202606,
        "valor": -50625063217.6,
        "delta": -696361737.95
      },
      {
        "periodo": 202607,
        "valor": -51707661612.73,
        "delta": -1082598395.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -20223877089.0,
    "valor_anterior": -20110108650.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -16934157343.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -16493834300.0,
        "delta": 440323043.0
      },
      {
        "periodo": 202509,
        "valor": -16650917973.0,
        "delta": -157083673.0
      },
      {
        "periodo": 202510,
        "valor": -16795270010.0,
        "delta": -144352037.0
      },
      {
        "periodo": 202511,
        "valor": -16979399287.0,
        "delta": -184129277.0
      },
      {
        "periodo": 202512,
        "valor": -16968599137.0,
        "delta": 10800150.0
      },
      {
        "periodo": 202601,
        "valor": -16952485300.0,
        "delta": 16113837.0
      },
      {
        "periodo": 202602,
        "valor": -17140626032.0,
        "delta": -188140732.0
      },
      {
        "periodo": 202603,
        "valor": -17191415461.0,
        "delta": -50789429.0
      },
      {
        "periodo": 202604,
        "valor": -17346618405.0,
        "delta": -155202944.0
      },
      {
        "periodo": 202605,
        "valor": -20128100966.0,
        "delta": -2781482561.0
      },
      {
        "periodo": 202606,
        "valor": -20110108650.0,
        "delta": 17992316.0
      },
      {
        "periodo": 202607,
        "valor": -20223877089.0,
        "delta": -113768439.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -8974911822.0,
    "valor_anterior": -8946653054.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -10657498929.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -10479679046.0,
        "delta": 177819883.0
      },
      {
        "periodo": 202509,
        "valor": -10360783642.0,
        "delta": 118895404.0
      },
      {
        "periodo": 202510,
        "valor": -10604745499.0,
        "delta": -243961857.0
      },
      {
        "periodo": 202511,
        "valor": -10223797939.0,
        "delta": 380947560.0
      },
      {
        "periodo": 202512,
        "valor": -9879768718.0,
        "delta": 344029221.0
      },
      {
        "periodo": 202601,
        "valor": -9771662441.0,
        "delta": 108106277.0
      },
      {
        "periodo": 202602,
        "valor": -9594302317.0,
        "delta": 177360124.0
      },
      {
        "periodo": 202603,
        "valor": -9482148742.0,
        "delta": 112153575.0
      },
      {
        "periodo": 202604,
        "valor": -9365877210.0,
        "delta": 116271532.0
      },
      {
        "periodo": 202605,
        "valor": -9164337965.0,
        "delta": 201539245.0
      },
      {
        "periodo": 202606,
        "valor": -8946653054.0,
        "delta": 217684911.0
      },
      {
        "periodo": 202607,
        "valor": -8974911822.0,
        "delta": -28258768.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -690960032.9,
    "valor_anterior": -694133454.91,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -668936616.28,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -659658280.16,
        "delta": 9278336.12
      },
      {
        "periodo": 202509,
        "valor": -672435483.44,
        "delta": -12777203.28
      },
      {
        "periodo": 202510,
        "valor": -654172065.71,
        "delta": 18263417.73
      },
      {
        "periodo": 202511,
        "valor": -638419673.1,
        "delta": 15752392.61
      },
      {
        "periodo": 202512,
        "valor": -639185864.75,
        "delta": -766191.65
      },
      {
        "periodo": 202601,
        "valor": -638529881.64,
        "delta": 655983.11
      },
      {
        "periodo": 202602,
        "valor": -638535818.01,
        "delta": -5936.37
      },
      {
        "periodo": 202603,
        "valor": -665026767.23,
        "delta": -26490949.22
      },
      {
        "periodo": 202604,
        "valor": -667158108.37,
        "delta": -2131341.14
      },
      {
        "periodo": 202605,
        "valor": -683054410.92,
        "delta": -15896302.55
      },
      {
        "periodo": 202606,
        "valor": -694133454.91,
        "delta": -11079043.99
      },
      {
        "periodo": 202607,
        "valor": -690960032.9,
        "delta": 3173422.01
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -4693001736.0,
    "valor_anterior": -4644156248.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -4028585528.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -4145157979.0,
        "delta": -116572451.0
      },
      {
        "periodo": 202509,
        "valor": -4260452646.0,
        "delta": -115294667.0
      },
      {
        "periodo": 202510,
        "valor": -4374856620.0,
        "delta": -114403974.0
      },
      {
        "periodo": 202511,
        "valor": -4413787427.0,
        "delta": -38930807.0
      },
      {
        "periodo": 202512,
        "valor": -4333460521.0,
        "delta": 80326906.0
      },
      {
        "periodo": 202601,
        "valor": -4382386682.0,
        "delta": -48926161.0
      },
      {
        "periodo": 202602,
        "valor": -4367958269.0,
        "delta": 14428413.0
      },
      {
        "periodo": 202603,
        "valor": -4442703787.0,
        "delta": -74745518.0
      },
      {
        "periodo": 202604,
        "valor": -4497155106.0,
        "delta": -54451319.0
      },
      {
        "periodo": 202605,
        "valor": -4582305695.0,
        "delta": -85150589.0
      },
      {
        "periodo": 202606,
        "valor": -4644156249.0,
        "delta": -61850554.0
      },
      {
        "periodo": 202607,
        "valor": -4693001736.0,
        "delta": -48845487.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -105854897.0,
    "valor_anterior": -116055231.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -74534895.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -82897532.0,
        "delta": -8362637.0
      },
      {
        "periodo": 202509,
        "valor": -85968573.0,
        "delta": -3071041.0
      },
      {
        "periodo": 202510,
        "valor": -85707828.0,
        "delta": 260745.0
      },
      {
        "periodo": 202511,
        "valor": -90629652.0,
        "delta": -4921824.0
      },
      {
        "periodo": 202512,
        "valor": -93002243.0,
        "delta": -2372591.0
      },
      {
        "periodo": 202601,
        "valor": -101177209.0,
        "delta": -8174966.0
      },
      {
        "periodo": 202602,
        "valor": -102345735.0,
        "delta": -1168526.0
      },
      {
        "periodo": 202603,
        "valor": -102922050.0,
        "delta": -576315.0
      },
      {
        "periodo": 202604,
        "valor": -109794158.0,
        "delta": -6872108.0
      },
      {
        "periodo": 202605,
        "valor": -120457672.0,
        "delta": -10663514.0
      },
      {
        "periodo": 202606,
        "valor": -116055231.0,
        "delta": 4402441.0
      },
      {
        "periodo": 202607,
        "valor": -105854897.0,
        "delta": 10200334.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -4275759752.0,
    "valor_anterior": -4129084494.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -3792958647.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -3858566439.0,
        "delta": -65607792.0
      },
      {
        "periodo": 202509,
        "valor": -3912265939.0,
        "delta": -53699500.0
      },
      {
        "periodo": 202510,
        "valor": -4034146173.0,
        "delta": -121880234.0
      },
      {
        "periodo": 202511,
        "valor": -4198679484.0,
        "delta": -164533311.0
      },
      {
        "periodo": 202512,
        "valor": -4095401890.0,
        "delta": 103277594.0
      },
      {
        "periodo": 202601,
        "valor": -4073437341.0,
        "delta": 21964549.0
      },
      {
        "periodo": 202602,
        "valor": -4174792921.0,
        "delta": -101355580.0
      },
      {
        "periodo": 202603,
        "valor": -4095866603.0,
        "delta": 78926318.0
      },
      {
        "periodo": 202604,
        "valor": -4092778925.0,
        "delta": 3087678.0
      },
      {
        "periodo": 202605,
        "valor": -4166359811.0,
        "delta": -73580886.0
      },
      {
        "periodo": 202606,
        "valor": -4129084494.0,
        "delta": 37275317.0
      },
      {
        "periodo": 202607,
        "valor": -4275759752.0,
        "delta": -146675258.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -767010231.9,
    "valor_anterior": -770778722.28,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1075459505.55,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1080081571.95,
        "delta": -4622066.4
      },
      {
        "periodo": 202509,
        "valor": -1055202584.24,
        "delta": 24878987.71
      },
      {
        "periodo": 202510,
        "valor": -1056492462.64,
        "delta": -1289878.4
      },
      {
        "periodo": 202511,
        "valor": -1101234085.57,
        "delta": -44741622.93
      },
      {
        "periodo": 202512,
        "valor": -1116518316.68,
        "delta": -15284231.11
      },
      {
        "periodo": 202601,
        "valor": -1102987252.65,
        "delta": 13531064.03
      },
      {
        "periodo": 202602,
        "valor": -742400430.7,
        "delta": 360586821.95
      },
      {
        "periodo": 202603,
        "valor": -759270584.52,
        "delta": -16870153.82
      },
      {
        "periodo": 202604,
        "valor": -753521038.63,
        "delta": 5749545.89
      },
      {
        "periodo": 202605,
        "valor": -752762124.31,
        "delta": 758914.32
      },
      {
        "periodo": 202606,
        "valor": -770778722.28,
        "delta": -18016597.97
      },
      {
        "periodo": 202607,
        "valor": -767010231.9,
        "delta": 3768490.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -3133004136.0,
    "valor_anterior": -3077659939.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2414797279.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2454636266.0,
        "delta": -39838987.0
      },
      {
        "periodo": 202509,
        "valor": -2513200808.0,
        "delta": -58564542.0
      },
      {
        "periodo": 202510,
        "valor": -2542676039.0,
        "delta": -29475231.0
      },
      {
        "periodo": 202511,
        "valor": -2680096956.0,
        "delta": -137420917.0
      },
      {
        "periodo": 202512,
        "valor": -2764905149.0,
        "delta": -84808193.0
      },
      {
        "periodo": 202601,
        "valor": -2801678144.0,
        "delta": -36772995.0
      },
      {
        "periodo": 202602,
        "valor": -2812777041.0,
        "delta": -11098897.0
      },
      {
        "periodo": 202603,
        "valor": -2889656377.0,
        "delta": -76879336.0
      },
      {
        "periodo": 202604,
        "valor": -2957962864.0,
        "delta": -68306487.0
      },
      {
        "periodo": 202605,
        "valor": -3042016044.0,
        "delta": -84053180.0
      },
      {
        "periodo": 202606,
        "valor": -3077659939.0,
        "delta": -35643895.0
      },
      {
        "periodo": 202607,
        "valor": -3133004136.0,
        "delta": -55344197.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -71542589.0,
    "valor_anterior": -71218118.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -65802606.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -67159922.0,
        "delta": -1357316.0
      },
      {
        "periodo": 202509,
        "valor": -70120102.0,
        "delta": -2960180.0
      },
      {
        "periodo": 202510,
        "valor": -61704148.0,
        "delta": 8415954.0
      },
      {
        "periodo": 202511,
        "valor": -63926433.0,
        "delta": -2222285.0
      },
      {
        "periodo": 202512,
        "valor": -65785244.0,
        "delta": -1858811.0
      },
      {
        "periodo": 202601,
        "valor": -66565158.0,
        "delta": -779914.0
      },
      {
        "periodo": 202602,
        "valor": -66658080.0,
        "delta": -92922.0
      },
      {
        "periodo": 202603,
        "valor": -69618350.0,
        "delta": -2960270.0
      },
      {
        "periodo": 202604,
        "valor": -70060338.0,
        "delta": -441988.0
      },
      {
        "periodo": 202605,
        "valor": -71994441.0,
        "delta": -1934103.0
      },
      {
        "periodo": 202606,
        "valor": -71218118.0,
        "delta": 776323.0
      },
      {
        "periodo": 202607,
        "valor": -71542589.0,
        "delta": -324471.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -1034217102.0,
    "valor_anterior": -1044951070.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1015245473.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1036012852.0,
        "delta": -20767379.0
      },
      {
        "periodo": 202509,
        "valor": -1041278201.0,
        "delta": -5265349.0
      },
      {
        "periodo": 202510,
        "valor": -1029839173.0,
        "delta": 11439028.0
      },
      {
        "periodo": 202511,
        "valor": -1051616627.0,
        "delta": -21777454.0
      },
      {
        "periodo": 202512,
        "valor": -1046533866.0,
        "delta": 5082761.0
      },
      {
        "periodo": 202601,
        "valor": -1054027644.0,
        "delta": -7493778.0
      },
      {
        "periodo": 202602,
        "valor": -1051897044.0,
        "delta": 2130600.0
      },
      {
        "periodo": 202603,
        "valor": -1041090160.0,
        "delta": 10806884.0
      },
      {
        "periodo": 202604,
        "valor": -1028141029.0,
        "delta": 12949131.0
      },
      {
        "periodo": 202605,
        "valor": -1027932457.0,
        "delta": 208572.0
      },
      {
        "periodo": 202606,
        "valor": -1044951070.0,
        "delta": -17018613.0
      },
      {
        "periodo": 202607,
        "valor": -1034217102.0,
        "delta": 10733968.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -16616426204.47,
    "valor_anterior": -16275100436.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -13606279733.17,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -13747058494.87,
        "delta": -140778761.7
      },
      {
        "periodo": 202509,
        "valor": -13972435079.0,
        "delta": -225376584.13
      },
      {
        "periodo": 202510,
        "valor": -14194693583.02,
        "delta": -222258504.02
      },
      {
        "periodo": 202511,
        "valor": -14603175850.99,
        "delta": -408482267.97
      },
      {
        "periodo": 202512,
        "valor": -15164037139.24,
        "delta": -560861288.25
      },
      {
        "periodo": 202601,
        "valor": -15644390713.45,
        "delta": -480353574.21
      },
      {
        "periodo": 202602,
        "valor": -15520912931.38,
        "delta": 123477782.07
      },
      {
        "periodo": 202603,
        "valor": -15564279203.38,
        "delta": -43366272.0
      },
      {
        "periodo": 202604,
        "valor": -15692230002.6,
        "delta": -127950799.22
      },
      {
        "periodo": 202605,
        "valor": -16069936363.12,
        "delta": -377706360.52
      },
      {
        "periodo": 202606,
        "valor": -16275100436.2,
        "delta": -205164073.08
      },
      {
        "periodo": 202607,
        "valor": -16616426204.47,
        "delta": -341325768.27
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -3310292.0,
    "valor_anterior": -3098987.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -5284389.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -6786140.0,
        "delta": -1501751.0
      },
      {
        "periodo": 202509,
        "valor": -5811257.0,
        "delta": 974883.0
      },
      {
        "periodo": 202510,
        "valor": -4535508.0,
        "delta": 1275749.0
      },
      {
        "periodo": 202511,
        "valor": -4052945.0,
        "delta": 482563.0
      },
      {
        "periodo": 202512,
        "valor": -3616053.0,
        "delta": 436892.0
      },
      {
        "periodo": 202601,
        "valor": -4444029.0,
        "delta": -827976.0
      },
      {
        "periodo": 202602,
        "valor": -5502058.0,
        "delta": -1058029.0
      },
      {
        "periodo": 202603,
        "valor": -6351145.0,
        "delta": -849087.0
      },
      {
        "periodo": 202604,
        "valor": -4333625.0,
        "delta": 2017520.0
      },
      {
        "periodo": 202605,
        "valor": -3127507.0,
        "delta": 1206118.0
      },
      {
        "periodo": 202606,
        "valor": -3098987.0,
        "delta": 28520.0
      },
      {
        "periodo": 202607,
        "valor": -3310292.0,
        "delta": -211305.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -15725982431.330002,
    "valor_anterior": -15896561796.1,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -14828041250.8,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -15931918185.06,
        "delta": -1103876934.26
      },
      {
        "periodo": 202509,
        "valor": -16391817767.89,
        "delta": -459899582.83
      },
      {
        "periodo": 202510,
        "valor": -17006155881.62,
        "delta": -614338113.73
      },
      {
        "periodo": 202511,
        "valor": -17072198700.02,
        "delta": -66042818.4
      },
      {
        "periodo": 202512,
        "valor": -17049112359.68,
        "delta": 23086340.34
      },
      {
        "periodo": 202601,
        "valor": -16554558137.23,
        "delta": 494554222.45
      },
      {
        "periodo": 202602,
        "valor": -16529064722.4,
        "delta": 25493414.83
      },
      {
        "periodo": 202603,
        "valor": -16254812742.51,
        "delta": 274251979.89
      },
      {
        "periodo": 202604,
        "valor": -15593241499.42,
        "delta": 661571243.09
      },
      {
        "periodo": 202605,
        "valor": -16157862719.2,
        "delta": -564621219.78
      },
      {
        "periodo": 202606,
        "valor": -15896561796.1,
        "delta": 261300923.1
      },
      {
        "periodo": 202607,
        "valor": -15725982431.33,
        "delta": 170579364.77
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -55545359.0,
    "valor_anterior": -50139663.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -31895933.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -34224164.43,
        "delta": -2328230.78
      },
      {
        "periodo": 202509,
        "valor": -57390463.0,
        "delta": -23166298.57
      },
      {
        "periodo": 202510,
        "valor": -62939520.0,
        "delta": -5549057.0
      },
      {
        "periodo": 202511,
        "valor": -66770119.0,
        "delta": -3830599.0
      },
      {
        "periodo": 202512,
        "valor": -56709966.0,
        "delta": 10060153.0
      },
      {
        "periodo": 202601,
        "valor": -53418808.0,
        "delta": 3291158.0
      },
      {
        "periodo": 202602,
        "valor": -59071295.0,
        "delta": -5652487.0
      },
      {
        "periodo": 202603,
        "valor": -64995403.0,
        "delta": -5924108.0
      },
      {
        "periodo": 202604,
        "valor": -70124039.0,
        "delta": -5128636.0
      },
      {
        "periodo": 202605,
        "valor": -74854277.0,
        "delta": -4730238.0
      },
      {
        "periodo": 202606,
        "valor": -50139663.0,
        "delta": 24714614.0
      },
      {
        "periodo": 202607,
        "valor": -55545359.0,
        "delta": -5405696.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -5943971052.0,
    "valor_anterior": -5839311088.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -4395839110.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -4566890092.0,
        "delta": -171050982.0
      },
      {
        "periodo": 202509,
        "valor": -4819739606.0,
        "delta": -252849514.0
      },
      {
        "periodo": 202510,
        "valor": -5040942677.0,
        "delta": -221203071.0
      },
      {
        "periodo": 202511,
        "valor": -5181752523.0,
        "delta": -140809846.0
      },
      {
        "periodo": 202512,
        "valor": -5490004707.0,
        "delta": -308252184.0
      },
      {
        "periodo": 202601,
        "valor": -5477546676.0,
        "delta": 12458031.0
      },
      {
        "periodo": 202602,
        "valor": -5628973242.0,
        "delta": -151426566.0
      },
      {
        "periodo": 202603,
        "valor": -5778446877.0,
        "delta": -149473635.0
      },
      {
        "periodo": 202604,
        "valor": -5739740582.0,
        "delta": 38706295.0
      },
      {
        "periodo": 202605,
        "valor": -5742814597.0,
        "delta": -3074015.0
      },
      {
        "periodo": 202606,
        "valor": -5839311089.0,
        "delta": -96496492.0
      },
      {
        "periodo": 202607,
        "valor": -5943971052.0,
        "delta": -104659963.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -225409013.0,
    "valor_anterior": -234406140.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -204440587.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -202266917.0,
        "delta": 2173670.0
      },
      {
        "periodo": 202509,
        "valor": -203511330.0,
        "delta": -1244413.0
      },
      {
        "periodo": 202510,
        "valor": -229835296.0,
        "delta": -26323966.0
      },
      {
        "periodo": 202511,
        "valor": -221589698.0,
        "delta": 8245598.0
      },
      {
        "periodo": 202512,
        "valor": -219440912.0,
        "delta": 2148786.0
      },
      {
        "periodo": 202601,
        "valor": -230415041.0,
        "delta": -10974129.0
      },
      {
        "periodo": 202602,
        "valor": -187401454.0,
        "delta": 43013587.0
      },
      {
        "periodo": 202603,
        "valor": -193962861.0,
        "delta": -6561407.0
      },
      {
        "periodo": 202604,
        "valor": -201905085.0,
        "delta": -7942224.0
      },
      {
        "periodo": 202605,
        "valor": -215931867.0,
        "delta": -14026782.0
      },
      {
        "periodo": 202606,
        "valor": -234406140.0,
        "delta": -18474273.0
      },
      {
        "periodo": 202607,
        "valor": -225409013.0,
        "delta": 8997127.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -330261091.0,
    "valor_anterior": -333652091.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -368455418.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -369435708.0,
        "delta": -980290.0
      },
      {
        "periodo": 202509,
        "valor": -364389676.0,
        "delta": 5046032.0
      },
      {
        "periodo": 202510,
        "valor": -362938738.0,
        "delta": 1450938.0
      },
      {
        "periodo": 202511,
        "valor": -345669377.0,
        "delta": 17269361.0
      },
      {
        "periodo": 202512,
        "valor": -360232985.0,
        "delta": -14563608.0
      },
      {
        "periodo": 202601,
        "valor": -386895882.0,
        "delta": -26662897.0
      },
      {
        "periodo": 202602,
        "valor": -368364859.0,
        "delta": 18531023.0
      },
      {
        "periodo": 202603,
        "valor": -338119906.0,
        "delta": 30244953.0
      },
      {
        "periodo": 202604,
        "valor": -325765772.0,
        "delta": 12354134.0
      },
      {
        "periodo": 202605,
        "valor": -312020796.0,
        "delta": 13744976.0
      },
      {
        "periodo": 202606,
        "valor": -333652091.0,
        "delta": -21631295.0
      },
      {
        "periodo": 202607,
        "valor": -330261091.0,
        "delta": 3391000.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -4326107.0,
    "valor_anterior": -4326107.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -59973178.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -61860248.0,
        "delta": -1887070.0
      },
      {
        "periodo": 202509,
        "valor": -41595071.0,
        "delta": 20265177.0
      },
      {
        "periodo": 202510,
        "valor": -43478161.0,
        "delta": -1883090.0
      },
      {
        "periodo": 202511,
        "valor": -46711878.0,
        "delta": -3233717.0
      },
      {
        "periodo": 202512,
        "valor": -47461048.0,
        "delta": -749170.0
      },
      {
        "periodo": 202601,
        "valor": -43063495.0,
        "delta": 4397553.0
      },
      {
        "periodo": 202602,
        "valor": -15694943.0,
        "delta": 27368552.0
      },
      {
        "periodo": 202603,
        "valor": -4326107.0,
        "delta": 11368836.0
      },
      {
        "periodo": 202604,
        "valor": -4326107.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": -4326107.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": -4326107.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": -4326107.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -5759044897.39,
    "valor_anterior": -5751447170.81,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -4518892377.33,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -4768870684.27,
        "delta": -249978306.94
      },
      {
        "periodo": 202509,
        "valor": -4799048837.11,
        "delta": -30178152.84
      },
      {
        "periodo": 202510,
        "valor": -4902602211.25,
        "delta": -103553374.14
      },
      {
        "periodo": 202511,
        "valor": -5105664760.42,
        "delta": -203062549.17
      },
      {
        "periodo": 202512,
        "valor": -5247409158.59,
        "delta": -141744398.17
      },
      {
        "periodo": 202601,
        "valor": -5475711725.0,
        "delta": -228302566.41
      },
      {
        "periodo": 202602,
        "valor": -5616995791.06,
        "delta": -141284066.06
      },
      {
        "periodo": 202603,
        "valor": -5597448244.82,
        "delta": 19547546.24
      },
      {
        "periodo": 202604,
        "valor": -5696983068.24,
        "delta": -99534823.42
      },
      {
        "periodo": 202605,
        "valor": -5606444730.38,
        "delta": 90538337.86
      },
      {
        "periodo": 202606,
        "valor": -5751447170.81,
        "delta": -145002440.43
      },
      {
        "periodo": 202607,
        "valor": -5759044897.39,
        "delta": -7597726.58
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -273644869.0,
    "valor_anterior": -258989116.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -121865484.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -132355288.0,
        "delta": -10489804.0
      },
      {
        "periodo": 202509,
        "valor": -149853015.0,
        "delta": -17497727.0
      },
      {
        "periodo": 202510,
        "valor": -165550799.0,
        "delta": -15697784.0
      },
      {
        "periodo": 202511,
        "valor": -180568930.0,
        "delta": -15018131.0
      },
      {
        "periodo": 202512,
        "valor": -191675043.0,
        "delta": -11106113.0
      },
      {
        "periodo": 202601,
        "valor": -192582518.0,
        "delta": -907475.0
      },
      {
        "periodo": 202602,
        "valor": -209701992.0,
        "delta": -17119474.0
      },
      {
        "periodo": 202603,
        "valor": -222092000.0,
        "delta": -12390008.0
      },
      {
        "periodo": 202604,
        "valor": -232037514.0,
        "delta": -9945514.0
      },
      {
        "periodo": 202605,
        "valor": -242632476.0,
        "delta": -10594962.0
      },
      {
        "periodo": 202606,
        "valor": -258989116.0,
        "delta": -16356640.0
      },
      {
        "periodo": 202607,
        "valor": -273644869.0,
        "delta": -14655753.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -1134270799.0,
    "valor_anterior": -1083238311.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -969096475.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -966606358.0,
        "delta": 2490117.0
      },
      {
        "periodo": 202509,
        "valor": -967744134.0,
        "delta": -1137776.0
      },
      {
        "periodo": 202510,
        "valor": -987798515.0,
        "delta": -20054381.0
      },
      {
        "periodo": 202511,
        "valor": -1000074838.0,
        "delta": -12276323.0
      },
      {
        "periodo": 202512,
        "valor": -1011261771.0,
        "delta": -11186933.0
      },
      {
        "periodo": 202601,
        "valor": -1023082137.0,
        "delta": -11820366.0
      },
      {
        "periodo": 202602,
        "valor": -1026522646.0,
        "delta": -3440509.0
      },
      {
        "periodo": 202603,
        "valor": -1012325733.0,
        "delta": 14196913.0
      },
      {
        "periodo": 202604,
        "valor": -1070860358.0,
        "delta": -58534625.0
      },
      {
        "periodo": 202605,
        "valor": -1036386488.0,
        "delta": 34473870.0
      },
      {
        "periodo": 202606,
        "valor": -1083238311.0,
        "delta": -46851823.0
      },
      {
        "periodo": 202607,
        "valor": -1134270799.0,
        "delta": -51032488.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -253745237.0,
    "valor_anterior": -238676757.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -164392758.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -206714095.0,
        "delta": -42321337.0
      },
      {
        "periodo": 202509,
        "valor": -172574114.0,
        "delta": 34139981.0
      },
      {
        "periodo": 202510,
        "valor": -186613404.0,
        "delta": -14039290.0
      },
      {
        "periodo": 202511,
        "valor": -227464567.0,
        "delta": -40851163.0
      },
      {
        "periodo": 202512,
        "valor": -207217147.0,
        "delta": 20247420.0
      },
      {
        "periodo": 202601,
        "valor": -245201328.0,
        "delta": -37984181.0
      },
      {
        "periodo": 202602,
        "valor": -240888349.0,
        "delta": 4312979.0
      },
      {
        "periodo": 202603,
        "valor": -239453236.0,
        "delta": 1435113.0
      },
      {
        "periodo": 202604,
        "valor": -249612470.0,
        "delta": -10159234.0
      },
      {
        "periodo": 202605,
        "valor": -294340385.0,
        "delta": -44727915.0
      },
      {
        "periodo": 202606,
        "valor": -238676757.0,
        "delta": 55663628.0
      },
      {
        "periodo": 202607,
        "valor": -253745237.0,
        "delta": -15068480.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -305930964.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -78862192.0,
        "delta": 227068772.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -2268194.0,
    "valor_anterior": -1572678.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1580029.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1693003.0,
        "delta": -112974.0
      },
      {
        "periodo": 202509,
        "valor": -1531963.0,
        "delta": 161040.0
      },
      {
        "periodo": 202510,
        "valor": -1756213.0,
        "delta": -224250.0
      },
      {
        "periodo": 202511,
        "valor": -1796689.0,
        "delta": -40476.0
      },
      {
        "periodo": 202512,
        "valor": -1889013.0,
        "delta": -92324.0
      },
      {
        "periodo": 202601,
        "valor": -2076903.0,
        "delta": -187890.0
      },
      {
        "periodo": 202602,
        "valor": -2142299.0,
        "delta": -65396.0
      },
      {
        "periodo": 202603,
        "valor": -2074488.0,
        "delta": 67811.0
      },
      {
        "periodo": 202604,
        "valor": -2357986.0,
        "delta": -283498.0
      },
      {
        "periodo": 202605,
        "valor": -1252365.0,
        "delta": 1105621.0
      },
      {
        "periodo": 202606,
        "valor": -1572678.0,
        "delta": -320313.0
      },
      {
        "periodo": 202607,
        "valor": -2268194.0,
        "delta": -695516.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -71033930.0,
    "valor_anterior": -70889934.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -43373516.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -42983219.0,
        "delta": 390297.0
      },
      {
        "periodo": 202509,
        "valor": -46919749.0,
        "delta": -3936530.0
      },
      {
        "periodo": 202510,
        "valor": -52634538.0,
        "delta": -5714789.0
      },
      {
        "periodo": 202511,
        "valor": -57224270.0,
        "delta": -4589732.0
      },
      {
        "periodo": 202512,
        "valor": -55166110.0,
        "delta": 2058160.0
      },
      {
        "periodo": 202601,
        "valor": -56859870.0,
        "delta": -1693760.0
      },
      {
        "periodo": 202602,
        "valor": -59782566.0,
        "delta": -2922696.0
      },
      {
        "periodo": 202603,
        "valor": -60611534.0,
        "delta": -828968.0
      },
      {
        "periodo": 202604,
        "valor": -65869963.0,
        "delta": -5258429.0
      },
      {
        "periodo": 202605,
        "valor": -68428715.0,
        "delta": -2558752.0
      },
      {
        "periodo": 202606,
        "valor": -70889934.0,
        "delta": -2461219.0
      },
      {
        "periodo": 202607,
        "valor": -71033930.0,
        "delta": -143996.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -104479361.41,
    "valor_anterior": -103353290.56,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -57361877.75,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -58494245.0,
        "delta": -1132367.25
      },
      {
        "periodo": 202509,
        "valor": -59135491.02,
        "delta": -641246.02
      },
      {
        "periodo": 202510,
        "valor": -72949051.82,
        "delta": -13813560.8
      },
      {
        "periodo": 202511,
        "valor": -75929165.92,
        "delta": -2980114.1
      },
      {
        "periodo": 202512,
        "valor": -83982878.31,
        "delta": -8053712.39
      },
      {
        "periodo": 202601,
        "valor": -89532951.29,
        "delta": -5550072.98
      },
      {
        "periodo": 202602,
        "valor": -90959636.49,
        "delta": -1426685.2
      },
      {
        "periodo": 202603,
        "valor": -94565647.31,
        "delta": -3606010.82
      },
      {
        "periodo": 202604,
        "valor": -98511358.93,
        "delta": -3945711.62
      },
      {
        "periodo": 202605,
        "valor": -100946266.72,
        "delta": -2434907.79
      },
      {
        "periodo": 202606,
        "valor": -103353290.56,
        "delta": -2407023.84
      },
      {
        "periodo": 202607,
        "valor": -104479361.41,
        "delta": -1126070.85
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -1187198.0,
    "valor_anterior": -1116089.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1143948.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1074246.0,
        "delta": 69702.0
      },
      {
        "periodo": 202509,
        "valor": -1088018.0,
        "delta": -13772.0
      },
      {
        "periodo": 202510,
        "valor": -1160748.0,
        "delta": -72730.0
      },
      {
        "periodo": 202511,
        "valor": -1046714.0,
        "delta": 114034.0
      },
      {
        "periodo": 202512,
        "valor": -1083186.0,
        "delta": -36472.0
      },
      {
        "periodo": 202601,
        "valor": -1055364.0,
        "delta": 27822.0
      },
      {
        "periodo": 202602,
        "valor": -1168661.0,
        "delta": -113297.0
      },
      {
        "periodo": 202603,
        "valor": -1266836.0,
        "delta": -98175.0
      },
      {
        "periodo": 202604,
        "valor": -1139055.0,
        "delta": 127781.0
      },
      {
        "periodo": 202605,
        "valor": -1105141.0,
        "delta": 33914.0
      },
      {
        "periodo": 202606,
        "valor": -1116089.0,
        "delta": -10948.0
      },
      {
        "periodo": 202607,
        "valor": -1187198.0,
        "delta": -71109.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -37464.2,
    "valor_anterior": -102780.26,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -5543221.76,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -3949615.38,
        "delta": 1593606.38
      },
      {
        "periodo": 202509,
        "valor": -2365594.97,
        "delta": 1584020.41
      },
      {
        "periodo": 202510,
        "valor": -1559090.11,
        "delta": 806504.86
      },
      {
        "periodo": 202511,
        "valor": -1013699.5,
        "delta": 545390.61
      },
      {
        "periodo": 202512,
        "valor": -580631.68,
        "delta": 433067.82
      },
      {
        "periodo": 202601,
        "valor": -372245.16,
        "delta": 208386.52
      },
      {
        "periodo": 202602,
        "valor": -331404.74,
        "delta": 40840.42
      },
      {
        "periodo": 202603,
        "valor": -269184.27,
        "delta": 62220.47
      },
      {
        "periodo": 202604,
        "valor": -135180.59,
        "delta": 134003.68
      },
      {
        "periodo": 202605,
        "valor": -118545.27,
        "delta": 16635.32
      },
      {
        "periodo": 202606,
        "valor": -102780.26,
        "delta": 15765.01
      },
      {
        "periodo": 202607,
        "valor": -37464.2,
        "delta": 65316.06
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -320547428.45,
    "valor_anterior": -322261210.15,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": -348441494.37,
        "delta": -348441494.37
      },
      {
        "periodo": 202603,
        "valor": -344604433.88,
        "delta": 3837060.49
      },
      {
        "periodo": 202604,
        "valor": -342847160.38,
        "delta": 1757273.5
      },
      {
        "periodo": 202605,
        "valor": -326197848.03,
        "delta": 16649312.35
      },
      {
        "periodo": 202606,
        "valor": -322261210.15,
        "delta": 3936637.88
      },
      {
        "periodo": 202607,
        "valor": -320547428.45,
        "delta": 1713781.7
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -110832462.0,
    "valor_anterior": -107234624.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -17755365.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -31737990.0,
        "delta": -13982625.0
      },
      {
        "periodo": 202509,
        "valor": -47480237.0,
        "delta": -15742247.0
      },
      {
        "periodo": 202510,
        "valor": -62771230.0,
        "delta": -15290993.0
      },
      {
        "periodo": 202511,
        "valor": -76465151.0,
        "delta": -13693921.0
      },
      {
        "periodo": 202512,
        "valor": -77002034.0,
        "delta": -536883.0
      },
      {
        "periodo": 202601,
        "valor": -74710748.0,
        "delta": 2291286.0
      },
      {
        "periodo": 202602,
        "valor": -72538292.0,
        "delta": 2172456.0
      },
      {
        "periodo": 202603,
        "valor": -68305689.0,
        "delta": 4232603.0
      },
      {
        "periodo": 202604,
        "valor": -74274354.0,
        "delta": -5968665.0
      },
      {
        "periodo": 202605,
        "valor": -80937635.0,
        "delta": -6663281.0
      },
      {
        "periodo": 202606,
        "valor": -107234624.0,
        "delta": -26296989.0
      },
      {
        "periodo": 202607,
        "valor": -110832462.0,
        "delta": -3597838.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -39560999.54,
    "valor_anterior": -28907578.82,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": -499740.43,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": -1345170.93,
        "delta": -845430.5
      },
      {
        "periodo": 202601,
        "valor": -4486903.2,
        "delta": -3141732.27
      },
      {
        "periodo": 202602,
        "valor": -8975275.14,
        "delta": -4488371.94
      },
      {
        "periodo": 202603,
        "valor": -11904046.26,
        "delta": -2928771.12
      },
      {
        "periodo": 202604,
        "valor": -17102110.91,
        "delta": -5198064.65
      },
      {
        "periodo": 202605,
        "valor": -21955334.35,
        "delta": -4853223.44
      },
      {
        "periodo": 202606,
        "valor": -28907578.82,
        "delta": -6952244.47
      },
      {
        "periodo": 202607,
        "valor": -39560999.54,
        "delta": -10653420.72
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -2891262416.0,
    "valor_anterior": -2515262335.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": -2089984577.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": -2391874557.0,
        "delta": -301889980.0
      },
      {
        "periodo": 202605,
        "valor": -2718995045.0,
        "delta": -327120488.0
      },
      {
        "periodo": 202606,
        "valor": -2515262335.0,
        "delta": 203732710.0
      },
      {
        "periodo": 202607,
        "valor": -2891262416.0,
        "delta": -376000081.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -168812793577.38004,
    "valor_anterior": -166608835544.1,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -143464175781.2,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -145497247702.05,
        "delta": -2033071920.85
      },
      {
        "periodo": 202509,
        "valor": -148262908887.52,
        "delta": -2765661185.47
      },
      {
        "periodo": 202510,
        "valor": -151847041845.71,
        "delta": -3584132958.19
      },
      {
        "periodo": 202511,
        "valor": -153584635481.23,
        "delta": -1737593635.52
      },
      {
        "periodo": 202512,
        "valor": -155158828201.3,
        "delta": -1574192720.07
      },
      {
        "periodo": 202601,
        "valor": -155038763641.66,
        "delta": 120064559.64
      },
      {
        "periodo": 202602,
        "valor": -157783866703.53,
        "delta": -2745103061.87
      },
      {
        "periodo": 202603,
        "valor": -160908785827.66,
        "delta": -3124919124.13
      },
      {
        "periodo": 202604,
        "valor": -160769984047.17,
        "delta": 138801780.49
      },
      {
        "periodo": 202605,
        "valor": -165889477862.26,
        "delta": -5119493815.09
      },
      {
        "periodo": 202606,
        "valor": -166608835544.1,
        "delta": -719357681.84
      },
      {
        "periodo": 202607,
        "valor": -168812793577.38,
        "delta": -2203958033.28
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -129759483987.26,
    "valor_anterior": -127989491261.21,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -112048533524.08,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -112650078887.8,
        "delta": -601545363.72
      },
      {
        "periodo": 202509,
        "valor": -114692706811.85,
        "delta": -2042627924.05
      },
      {
        "periodo": 202510,
        "valor": -117230228547.56,
        "delta": -2537521735.71
      },
      {
        "periodo": 202511,
        "valor": -118292218289.27,
        "delta": -1061989741.71
      },
      {
        "periodo": 202512,
        "valor": -119327707343.68,
        "delta": -1035489054.41
      },
      {
        "periodo": 202601,
        "valor": -119357783591.49,
        "delta": -30076247.81
      },
      {
        "periodo": 202602,
        "valor": -121896731574.62,
        "delta": -2538947983.13
      },
      {
        "periodo": 202603,
        "valor": -122995280847.86,
        "delta": -1098549273.24
      },
      {
        "periodo": 202604,
        "valor": -123000304665.7,
        "delta": -5023817.84
      },
      {
        "periodo": 202605,
        "valor": -127180581868.08,
        "delta": -4180277202.38
      },
      {
        "periodo": 202606,
        "valor": -127989491261.21,
        "delta": -808909393.13
      },
      {
        "periodo": 202607,
        "valor": -129759483987.26,
        "delta": -1769992726.05
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -4326107.0,
    "valor_anterior": -4326107.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -365904142.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -140722440.0,
        "delta": 225181702.0
      },
      {
        "periodo": 202509,
        "valor": -41595071.0,
        "delta": 99127369.0
      },
      {
        "periodo": 202510,
        "valor": -43478161.0,
        "delta": -1883090.0
      },
      {
        "periodo": 202511,
        "valor": -46711878.0,
        "delta": -3233717.0
      },
      {
        "periodo": 202512,
        "valor": -47461048.0,
        "delta": -749170.0
      },
      {
        "periodo": 202601,
        "valor": -43063495.0,
        "delta": 4397553.0
      },
      {
        "periodo": 202602,
        "valor": -15694943.0,
        "delta": 27368552.0
      },
      {
        "periodo": 202603,
        "valor": -4326107.0,
        "delta": 11368836.0
      },
      {
        "periodo": 202604,
        "valor": -4326107.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": -4326107.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": -4326107.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": -4326107.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -4167221238.0,
    "valor_anterior": -4122611009.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -3430042752.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -3490649118.0,
        "delta": -60606366.0
      },
      {
        "periodo": 202509,
        "valor": -3554479009.0,
        "delta": -63829891.0
      },
      {
        "periodo": 202510,
        "valor": -3572515212.0,
        "delta": -18036203.0
      },
      {
        "periodo": 202511,
        "valor": -3731713583.0,
        "delta": -159198371.0
      },
      {
        "periodo": 202512,
        "valor": -3811439015.0,
        "delta": -79725432.0
      },
      {
        "periodo": 202601,
        "valor": -3855705788.0,
        "delta": -44266773.0
      },
      {
        "periodo": 202602,
        "valor": -3864674085.0,
        "delta": -8968297.0
      },
      {
        "periodo": 202603,
        "valor": -3930746537.0,
        "delta": -66072452.0
      },
      {
        "periodo": 202604,
        "valor": -3986103893.0,
        "delta": -55357356.0
      },
      {
        "periodo": 202605,
        "valor": -4069948501.0,
        "delta": -83844608.0
      },
      {
        "periodo": 202606,
        "valor": -4122611009.0,
        "delta": -52662508.0
      },
      {
        "periodo": 202607,
        "valor": -4167221238.0,
        "delta": -44610229.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -1793731664.8,
    "valor_anterior": -1819588624.19,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2029799940.83,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2032764687.11,
        "delta": -2964746.28
      },
      {
        "periodo": 202509,
        "valor": -2024017245.68,
        "delta": 8747441.43
      },
      {
        "periodo": 202510,
        "valor": -2031903908.35,
        "delta": -7886662.67
      },
      {
        "periodo": 202511,
        "valor": -2056972767.67,
        "delta": -25068859.32
      },
      {
        "periodo": 202512,
        "valor": -2072846575.43,
        "delta": -15873807.76
      },
      {
        "periodo": 202601,
        "valor": -2078608777.29,
        "delta": -5762201.86
      },
      {
        "periodo": 202602,
        "valor": -1677354156.71,
        "delta": 401254620.58
      },
      {
        "periodo": 202603,
        "valor": -1728800243.75,
        "delta": -51446087.04
      },
      {
        "periodo": 202604,
        "valor": -1737851070.0,
        "delta": -9050826.25
      },
      {
        "periodo": 202605,
        "valor": -1776438722.23,
        "delta": -38587652.23
      },
      {
        "periodo": 202606,
        "valor": -1819588624.19,
        "delta": -43149901.96
      },
      {
        "periodo": 202607,
        "valor": -1793731664.8,
        "delta": 25856959.39
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -837741463.41,
    "valor_anterior": -818924956.56,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -646961348.4,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -663362330.43,
        "delta": -16400982.03
      },
      {
        "periodo": 202509,
        "valor": -702420710.02,
        "delta": -39058379.59
      },
      {
        "periodo": 202510,
        "valor": -727838469.82,
        "delta": -25417759.8
      },
      {
        "periodo": 202511,
        "valor": -734660713.92,
        "delta": -6822244.1
      },
      {
        "periodo": 202512,
        "valor": -760275129.31,
        "delta": -25614415.39
      },
      {
        "periodo": 202601,
        "valor": -791072220.29,
        "delta": -30797090.98
      },
      {
        "periodo": 202602,
        "valor": -796898161.49,
        "delta": -5825941.2
      },
      {
        "periodo": 202603,
        "valor": -791465794.31,
        "delta": 5432367.18
      },
      {
        "periodo": 202604,
        "valor": -798857007.93,
        "delta": -7391213.62
      },
      {
        "periodo": 202605,
        "valor": -803700621.72,
        "delta": -4843613.79
      },
      {
        "periodo": 202606,
        "valor": -818924956.56,
        "delta": -15224334.84
      },
      {
        "periodo": 202607,
        "valor": -837741463.41,
        "delta": -18816506.85
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100033,
    "label": "EPRC Balance Consumo",
    "valor_actual": -32250289116.91,
    "valor_anterior": -31853893586.14,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -24942934073.89,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -26519670238.71,
        "delta": -1576736164.82
      },
      {
        "periodo": 202509,
        "valor": -27247690039.97,
        "delta": -728019801.26
      },
      {
        "periodo": 202510,
        "valor": -28241077546.98,
        "delta": -993387507.01
      },
      {
        "periodo": 202511,
        "valor": -28722358249.37,
        "delta": -481280702.39
      },
      {
        "periodo": 202512,
        "valor": -29139099089.88,
        "delta": -416740840.51
      },
      {
        "periodo": 202601,
        "valor": -28912529769.59,
        "delta": 226569320.29
      },
      {
        "periodo": 202602,
        "valor": -29532513782.71,
        "delta": -619984013.12
      },
      {
        "periodo": 202603,
        "valor": -31458166297.74,
        "delta": -1925652515.03
      },
      {
        "periodo": 202604,
        "valor": -31242541303.54,
        "delta": 215624994.2
      },
      {
        "periodo": 202605,
        "valor": -32054482042.23,
        "delta": -811940738.69
      },
      {
        "periodo": 202606,
        "valor": -31853893586.14,
        "delta": 200588456.09
      },
      {
        "periodo": 202607,
        "valor": -32250289116.91,
        "delta": -396395530.77
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -788256467.87,
    "valor_anterior": -798771430.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -840117603.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -838663066.4,
        "delta": 1454536.85
      },
      {
        "periodo": 202509,
        "valor": -839716068.04,
        "delta": -1053001.64
      },
      {
        "periodo": 202510,
        "valor": -845133123.59,
        "delta": -5417055.55
      },
      {
        "periodo": 202511,
        "valor": -874366296.17,
        "delta": -29233172.58
      },
      {
        "periodo": 202512,
        "valor": -861824488.61,
        "delta": 12541807.56
      },
      {
        "periodo": 202601,
        "valor": -815239158.57,
        "delta": 46585330.04
      },
      {
        "periodo": 202602,
        "valor": -818762360.66,
        "delta": -3523202.09
      },
      {
        "periodo": 202603,
        "valor": -815673395.19,
        "delta": 3088965.47
      },
      {
        "periodo": 202604,
        "valor": -781391195.06,
        "delta": 34282200.13
      },
      {
        "periodo": 202605,
        "valor": -803773127.27,
        "delta": -22381932.21
      },
      {
        "periodo": 202606,
        "valor": -798771430.2,
        "delta": 5001697.07
      },
      {
        "periodo": 202607,
        "valor": -788256467.87,
        "delta": 10514962.33
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -7856706955.02,
    "valor_anterior": -7828289087.84,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -6091041888.73,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -6312069509.25,
        "delta": -221027620.52
      },
      {
        "periodo": 202509,
        "valor": -6057439603.28,
        "delta": 254629905.97
      },
      {
        "periodo": 202510,
        "valor": -6036804511.99,
        "delta": 20635091.29
      },
      {
        "periodo": 202511,
        "valor": -5900219602.88,
        "delta": 136584909.11
      },
      {
        "periodo": 202512,
        "valor": -5891309200.5,
        "delta": 8910402.38
      },
      {
        "periodo": 202601,
        "valor": -6182363111.21,
        "delta": -291053910.71
      },
      {
        "periodo": 202602,
        "valor": -7372475361.07,
        "delta": -1190112249.86
      },
      {
        "periodo": 202603,
        "valor": -7461034944.59,
        "delta": -88559583.52
      },
      {
        "periodo": 202604,
        "valor": -7515088171.19,
        "delta": -54053226.6
      },
      {
        "periodo": 202605,
        "valor": -7861900420.29,
        "delta": -346812249.1
      },
      {
        "periodo": 202606,
        "valor": -7828289087.84,
        "delta": 33611332.45
      },
      {
        "periodo": 202607,
        "valor": -7856706955.02,
        "delta": -28417867.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -5090716351.000001,
    "valor_anterior": -5085383522.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -5702979063.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -5789853950.0,
        "delta": -86874887.0
      },
      {
        "periodo": 202509,
        "valor": -6122228429.0,
        "delta": -332374479.0
      },
      {
        "periodo": 202510,
        "valor": -6097282765.0,
        "delta": 24945664.0
      },
      {
        "periodo": 202511,
        "valor": -5596888850.0,
        "delta": 500393915.0
      },
      {
        "periodo": 202512,
        "valor": -5263620301.0,
        "delta": 333268549.0
      },
      {
        "periodo": 202601,
        "valor": -5393204076.0,
        "delta": -129583775.0
      },
      {
        "periodo": 202602,
        "valor": -5545479462.0,
        "delta": -152275386.0
      },
      {
        "periodo": 202603,
        "valor": -5526147419.0,
        "delta": 19332043.0
      },
      {
        "periodo": 202604,
        "valor": -5697954091.0,
        "delta": -171806672.0
      },
      {
        "periodo": 202605,
        "valor": -5355261869.0,
        "delta": 342692222.0
      },
      {
        "periodo": 202606,
        "valor": -5085383522.0,
        "delta": 269878347.0
      },
      {
        "periodo": 202607,
        "valor": -5090716351.0,
        "delta": -5332829.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -2314446372.0,
    "valor_anterior": -2314829845.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2191811057.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2226628922.0,
        "delta": -34817865.0
      },
      {
        "periodo": 202509,
        "valor": -2214631354.0,
        "delta": 11997568.0
      },
      {
        "periodo": 202510,
        "valor": -2215673799.0,
        "delta": -1042445.0
      },
      {
        "periodo": 202511,
        "valor": -2273995139.0,
        "delta": -58321340.0
      },
      {
        "periodo": 202512,
        "valor": -2257461393.0,
        "delta": 16533746.0
      },
      {
        "periodo": 202601,
        "valor": -2291132727.0,
        "delta": -33671334.0
      },
      {
        "periodo": 202602,
        "valor": -2279807263.0,
        "delta": 11325464.0
      },
      {
        "periodo": 202603,
        "valor": -2269700709.0,
        "delta": 10106554.0
      },
      {
        "periodo": 202604,
        "valor": -2263912064.0,
        "delta": 5788645.0
      },
      {
        "periodo": 202605,
        "valor": -2314959972.0,
        "delta": -51047908.0
      },
      {
        "periodo": 202606,
        "valor": -2314829845.0,
        "delta": 130127.0
      },
      {
        "periodo": 202607,
        "valor": -2314446372.0,
        "delta": 383473.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -54822995.45,
    "valor_anterior": -54721805.05,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -63014406.12,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -52863803.92,
        "delta": 10150602.2
      },
      {
        "periodo": 202509,
        "valor": -65190741.9,
        "delta": -12326937.98
      },
      {
        "periodo": 202510,
        "valor": -66393303.09,
        "delta": -1202561.19
      },
      {
        "periodo": 202511,
        "valor": -55584535.36,
        "delta": 10808767.73
      },
      {
        "periodo": 202512,
        "valor": -63972183.93,
        "delta": -8387648.57
      },
      {
        "periodo": 202601,
        "valor": -49573574.33,
        "delta": 14398609.6
      },
      {
        "periodo": 202602,
        "valor": -48845651.12,
        "delta": 727923.21
      },
      {
        "periodo": 202603,
        "valor": -59679546.48,
        "delta": -10833895.36
      },
      {
        "periodo": 202604,
        "valor": -60359309.84,
        "delta": -679763.36
      },
      {
        "periodo": 202605,
        "valor": -48091833.69,
        "delta": 12267476.15
      },
      {
        "periodo": 202606,
        "valor": -54721805.05,
        "delta": -6629971.36
      },
      {
        "periodo": 202607,
        "valor": -54822995.45,
        "delta": -101190.4
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -141093269.0,
    "valor_anterior": -139953749.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -144326227.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -145480301.0,
        "delta": -1154074.0
      },
      {
        "periodo": 202509,
        "valor": -153410440.0,
        "delta": -7930139.0
      },
      {
        "periodo": 202510,
        "valor": -156279602.0,
        "delta": -2869162.0
      },
      {
        "periodo": 202511,
        "valor": -157119316.0,
        "delta": -839714.0
      },
      {
        "periodo": 202512,
        "valor": -155364250.0,
        "delta": 1755066.0
      },
      {
        "periodo": 202601,
        "valor": -141253614.0,
        "delta": 14110636.0
      },
      {
        "periodo": 202602,
        "valor": -139842717.0,
        "delta": 1410897.0
      },
      {
        "periodo": 202603,
        "valor": -142156906.0,
        "delta": -2314189.0
      },
      {
        "periodo": 202604,
        "valor": -144430241.0,
        "delta": -2273335.0
      },
      {
        "periodo": 202605,
        "valor": -135172145.0,
        "delta": 9258096.0
      },
      {
        "periodo": 202606,
        "valor": -139953749.0,
        "delta": -4781604.0
      },
      {
        "periodo": 202607,
        "valor": -141093269.0,
        "delta": -1139520.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -648878285.0,
    "valor_anterior": -622093177.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -635029466.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -629316023.0,
        "delta": 5713443.0
      },
      {
        "periodo": 202509,
        "valor": -619742952.0,
        "delta": 9573071.0
      },
      {
        "periodo": 202510,
        "valor": -622118329.0,
        "delta": -2375377.0
      },
      {
        "periodo": 202511,
        "valor": -620019418.0,
        "delta": 2098911.0
      },
      {
        "periodo": 202512,
        "valor": -577855410.0,
        "delta": 42164008.0
      },
      {
        "periodo": 202601,
        "valor": -586941921.0,
        "delta": -9086511.0
      },
      {
        "periodo": 202602,
        "valor": -593118515.0,
        "delta": -6176594.0
      },
      {
        "periodo": 202603,
        "valor": -604179312.0,
        "delta": -11060797.0
      },
      {
        "periodo": 202604,
        "valor": -634616362.0,
        "delta": -30437050.0
      },
      {
        "periodo": 202605,
        "valor": -632130965.0,
        "delta": 2485397.0
      },
      {
        "periodo": 202606,
        "valor": -622093177.0,
        "delta": 10037788.0
      },
      {
        "periodo": 202607,
        "valor": -648878285.0,
        "delta": -26785108.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -6504369218.0,
    "valor_anterior": -6396475248.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -6064656030.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -6135914510.0,
        "delta": -71258480.0
      },
      {
        "periodo": 202509,
        "valor": -6204773599.0,
        "delta": -68859089.0
      },
      {
        "periodo": 202510,
        "valor": -6281133471.0,
        "delta": -76359872.0
      },
      {
        "periodo": 202511,
        "valor": -6458386875.0,
        "delta": -177253404.0
      },
      {
        "periodo": 202512,
        "valor": -6437161760.0,
        "delta": 21225115.0
      },
      {
        "periodo": 202601,
        "valor": -6419558446.0,
        "delta": 17603314.0
      },
      {
        "periodo": 202602,
        "valor": -6425830528.0,
        "delta": -6272082.0
      },
      {
        "periodo": 202603,
        "valor": -6394691026.0,
        "delta": 31139502.0
      },
      {
        "periodo": 202604,
        "valor": -6334244396.0,
        "delta": 60446630.0
      },
      {
        "periodo": 202605,
        "valor": -6410439283.0,
        "delta": -76194887.0
      },
      {
        "periodo": 202606,
        "valor": -6396475249.0,
        "delta": 13964034.0
      },
      {
        "periodo": 202607,
        "valor": -6504369218.0,
        "delta": -107893969.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -186416816.96,
    "valor_anterior": -181419549.33,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -176377969.51,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -177136572.27,
        "delta": -758602.76
      },
      {
        "periodo": 202509,
        "valor": -179282568.15,
        "delta": -2145995.88
      },
      {
        "periodo": 202510,
        "valor": -180649880.7,
        "delta": -1367312.55
      },
      {
        "periodo": 202511,
        "valor": -188987560.2,
        "delta": -8337679.5
      },
      {
        "periodo": 202512,
        "valor": -177977576.6,
        "delta": 11009983.6
      },
      {
        "periodo": 202601,
        "valor": -159583723.24,
        "delta": 18393853.36
      },
      {
        "periodo": 202602,
        "valor": -162830613.06,
        "delta": -3246889.82
      },
      {
        "periodo": 202603,
        "valor": -166100603.35,
        "delta": -3269990.29
      },
      {
        "periodo": 202604,
        "valor": -166263722.71,
        "delta": -163119.36
      },
      {
        "periodo": 202605,
        "valor": -175653648.88,
        "delta": -9389926.17
      },
      {
        "periodo": 202606,
        "valor": -181419549.33,
        "delta": -5765900.45
      },
      {
        "periodo": 202607,
        "valor": -186416816.96,
        "delta": -4997267.63
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -83701.0,
    "valor_anterior": -62753.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -63379.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -72751.0,
        "delta": -9372.0
      },
      {
        "periodo": 202509,
        "valor": -75555.0,
        "delta": -2804.0
      },
      {
        "periodo": 202510,
        "valor": -84354.0,
        "delta": -8799.0
      },
      {
        "periodo": 202511,
        "valor": -71034.0,
        "delta": 13320.0
      },
      {
        "periodo": 202512,
        "valor": -68840.0,
        "delta": 2194.0
      },
      {
        "periodo": 202601,
        "valor": -60011.0,
        "delta": 8829.0
      },
      {
        "periodo": 202602,
        "valor": -70287.0,
        "delta": -10276.0
      },
      {
        "periodo": 202603,
        "valor": -66077.0,
        "delta": 4210.0
      },
      {
        "periodo": 202604,
        "valor": -54451.0,
        "delta": 11626.0
      },
      {
        "periodo": 202605,
        "valor": -53451.0,
        "delta": 1000.0
      },
      {
        "periodo": 202606,
        "valor": -62753.0,
        "delta": -9302.0
      },
      {
        "periodo": 202607,
        "valor": -83701.0,
        "delta": -20948.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -1216904.0,
    "valor_anterior": -1261705.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1081502.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1234253.0,
        "delta": -152751.0
      },
      {
        "periodo": 202509,
        "valor": -1320623.0,
        "delta": -86370.0
      },
      {
        "periodo": 202510,
        "valor": -1256252.0,
        "delta": 64371.0
      },
      {
        "periodo": 202511,
        "valor": -1246361.0,
        "delta": 9891.0
      },
      {
        "periodo": 202512,
        "valor": -1221305.0,
        "delta": 25056.0
      },
      {
        "periodo": 202601,
        "valor": -1175904.0,
        "delta": 45401.0
      },
      {
        "periodo": 202602,
        "valor": -1342459.0,
        "delta": -166555.0
      },
      {
        "periodo": 202603,
        "valor": -1290539.0,
        "delta": 51920.0
      },
      {
        "periodo": 202604,
        "valor": -1272563.0,
        "delta": 17976.0
      },
      {
        "periodo": 202605,
        "valor": -1259237.0,
        "delta": 13326.0
      },
      {
        "periodo": 202606,
        "valor": -1261705.0,
        "delta": -2468.0
      },
      {
        "periodo": 202607,
        "valor": -1216904.0,
        "delta": 44801.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -315222817.0,
    "valor_anterior": -309609419.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -272274238.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -283145789.0,
        "delta": -10871551.0
      },
      {
        "periodo": 202509,
        "valor": -290493740.0,
        "delta": -7347951.0
      },
      {
        "periodo": 202510,
        "valor": -294492637.0,
        "delta": -3998897.0
      },
      {
        "periodo": 202511,
        "valor": -303400721.0,
        "delta": -8908084.0
      },
      {
        "periodo": 202512,
        "valor": -263635967.0,
        "delta": 39764754.0
      },
      {
        "periodo": 202601,
        "valor": -269560016.0,
        "delta": -5924049.0
      },
      {
        "periodo": 202602,
        "valor": -279861668.0,
        "delta": -10301652.0
      },
      {
        "periodo": 202603,
        "valor": -279798330.0,
        "delta": 63338.0
      },
      {
        "periodo": 202604,
        "valor": -289018128.0,
        "delta": -9219798.0
      },
      {
        "periodo": 202605,
        "valor": -298532626.0,
        "delta": -9514498.0
      },
      {
        "periodo": 202606,
        "valor": -309609419.0,
        "delta": -11076793.0
      },
      {
        "periodo": 202607,
        "valor": -315222817.0,
        "delta": -5613398.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -1637778646.58,
    "valor_anterior": -1681784504.18,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1321769753.67,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1319332251.95,
        "delta": 2437501.72
      },
      {
        "periodo": 202509,
        "valor": -1354189569.66,
        "delta": -34857317.71
      },
      {
        "periodo": 202510,
        "valor": -1360940911.92,
        "delta": -6751342.26
      },
      {
        "periodo": 202511,
        "valor": -1415588895.25,
        "delta": -54647983.33
      },
      {
        "periodo": 202512,
        "valor": -1399852975.53,
        "delta": 15735919.72
      },
      {
        "periodo": 202601,
        "valor": -1471259956.83,
        "delta": -71406981.3
      },
      {
        "periodo": 202602,
        "valor": -1534512316.61,
        "delta": -63252359.78
      },
      {
        "periodo": 202603,
        "valor": -1611274966.18,
        "delta": -76762649.57
      },
      {
        "periodo": 202604,
        "valor": -1631713036.42,
        "delta": -20438070.24
      },
      {
        "periodo": 202605,
        "valor": -1650506749.08,
        "delta": -18793712.66
      },
      {
        "periodo": 202606,
        "valor": -1681784504.18,
        "delta": -31277755.1
      },
      {
        "periodo": 202607,
        "valor": -1637778646.58,
        "delta": 44005857.6
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -451092653.0,
    "valor_anterior": -409423432.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -404786286.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -403724179.0,
        "delta": 1062107.0
      },
      {
        "periodo": 202509,
        "valor": -417659170.0,
        "delta": -13934991.0
      },
      {
        "periodo": 202510,
        "valor": -429529600.0,
        "delta": -11870430.0
      },
      {
        "periodo": 202511,
        "valor": -436026830.0,
        "delta": -6497230.0
      },
      {
        "periodo": 202512,
        "valor": -455662389.0,
        "delta": -19635559.0
      },
      {
        "periodo": 202601,
        "valor": -467817700.0,
        "delta": -12155311.0
      },
      {
        "periodo": 202602,
        "valor": -457581210.0,
        "delta": 10236490.0
      },
      {
        "periodo": 202603,
        "valor": -407805789.0,
        "delta": 49775421.0
      },
      {
        "periodo": 202604,
        "valor": -414219960.0,
        "delta": -6414171.0
      },
      {
        "periodo": 202605,
        "valor": -417096906.0,
        "delta": -2876946.0
      },
      {
        "periodo": 202606,
        "valor": -409423432.0,
        "delta": 7673474.0
      },
      {
        "periodo": 202607,
        "valor": -451092653.0,
        "delta": -41669221.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -14245176.9,
    "valor_anterior": -12017051.29,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -7803243.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -9369880.14,
        "delta": -1566636.27
      },
      {
        "periodo": 202509,
        "valor": -7086203.52,
        "delta": 2283676.62
      },
      {
        "periodo": 202510,
        "valor": -8960587.78,
        "delta": -1874384.26
      },
      {
        "periodo": 202511,
        "valor": -8471303.9,
        "delta": 489283.88
      },
      {
        "periodo": 202512,
        "valor": -10415224.24,
        "delta": -1943920.34
      },
      {
        "periodo": 202601,
        "valor": -11595668.72,
        "delta": -1180444.48
      },
      {
        "periodo": 202602,
        "valor": -10737516.71,
        "delta": 858152.01
      },
      {
        "periodo": 202603,
        "valor": -12354176.53,
        "delta": -1616659.82
      },
      {
        "periodo": 202604,
        "valor": -10830053.05,
        "delta": 1524123.48
      },
      {
        "periodo": 202605,
        "valor": -16691268.18,
        "delta": -5861215.13
      },
      {
        "periodo": 202606,
        "valor": -12017051.29,
        "delta": 4674216.89
      },
      {
        "periodo": 202607,
        "valor": -14245176.9,
        "delta": -2228125.61
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -14307894.0,
    "valor_anterior": -9927957.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -16340934.97,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -14921939.2,
        "delta": 1418995.77
      },
      {
        "periodo": 202509,
        "valor": -14921939.0,
        "delta": 0.2
      },
      {
        "periodo": 202510,
        "valor": -17051808.0,
        "delta": -2129869.0
      },
      {
        "periodo": 202511,
        "valor": -12034845.0,
        "delta": 5016963.0
      },
      {
        "periodo": 202512,
        "valor": -12296482.0,
        "delta": -261637.0
      },
      {
        "periodo": 202601,
        "valor": -12213602.0,
        "delta": 82880.0
      },
      {
        "periodo": 202602,
        "valor": -12373205.0,
        "delta": -159603.0
      },
      {
        "periodo": 202603,
        "valor": -11993925.0,
        "delta": 379280.0
      },
      {
        "periodo": 202604,
        "valor": -13138692.0,
        "delta": -1144767.0
      },
      {
        "periodo": 202605,
        "valor": -13160339.0,
        "delta": -21647.0
      },
      {
        "periodo": 202606,
        "valor": -9927957.0,
        "delta": 3232382.0
      },
      {
        "periodo": 202607,
        "valor": -14307894.0,
        "delta": -4379937.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -273741967.0,
    "valor_anterior": -274394180.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -284744903.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -283126331.0,
        "delta": 1618572.0
      },
      {
        "periodo": 202509,
        "valor": -282855978.0,
        "delta": 270353.0
      },
      {
        "periodo": 202510,
        "valor": -281391250.0,
        "delta": 1464728.0
      },
      {
        "periodo": 202511,
        "valor": -281015050.0,
        "delta": 376200.0
      },
      {
        "periodo": 202512,
        "valor": -279704045.0,
        "delta": 1311005.0
      },
      {
        "periodo": 202601,
        "valor": -279328524.0,
        "delta": 375521.0
      },
      {
        "periodo": 202602,
        "valor": -277872618.0,
        "delta": 1455906.0
      },
      {
        "periodo": 202603,
        "valor": -277563225.0,
        "delta": 309393.0
      },
      {
        "periodo": 202604,
        "valor": -276282852.0,
        "delta": 1280373.0
      },
      {
        "periodo": 202605,
        "valor": -276185703.0,
        "delta": 97149.0
      },
      {
        "periodo": 202606,
        "valor": -274394180.0,
        "delta": 1791523.0
      },
      {
        "periodo": 202607,
        "valor": -273741967.0,
        "delta": 652213.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -214674438.09,
    "valor_anterior": -210692001.69,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -162307808.38,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -168775297.49,
        "delta": -6467489.11
      },
      {
        "periodo": 202509,
        "valor": -181334408.19,
        "delta": -12559110.7
      },
      {
        "periodo": 202510,
        "valor": -178688887.55,
        "delta": 2645520.64
      },
      {
        "periodo": 202511,
        "valor": -183385714.7,
        "delta": -4696827.15
      },
      {
        "periodo": 202512,
        "valor": -189765027.75,
        "delta": -6379313.05
      },
      {
        "periodo": 202601,
        "valor": -195835823.73,
        "delta": -6070795.98
      },
      {
        "periodo": 202602,
        "valor": -199004189.29,
        "delta": -3168365.56
      },
      {
        "periodo": 202603,
        "valor": -204480593.4,
        "delta": -5476404.11
      },
      {
        "periodo": 202604,
        "valor": -204107013.3,
        "delta": 373580.1
      },
      {
        "periodo": 202605,
        "valor": -211095866.38,
        "delta": -6988853.08
      },
      {
        "periodo": 202606,
        "valor": -210692001.69,
        "delta": 403864.69
      },
      {
        "periodo": 202607,
        "valor": -214674438.09,
        "delta": -3982436.4
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -279703.0,
    "valor_anterior": -193953.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -151110.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -151078.0,
        "delta": 32.0
      },
      {
        "periodo": 202509,
        "valor": -152783.0,
        "delta": -1705.0
      },
      {
        "periodo": 202510,
        "valor": -152915.0,
        "delta": -132.0
      },
      {
        "periodo": 202511,
        "valor": -164944.0,
        "delta": -12029.0
      },
      {
        "periodo": 202512,
        "valor": -164724.0,
        "delta": 220.0
      },
      {
        "periodo": 202601,
        "valor": -164619.0,
        "delta": 105.0
      },
      {
        "periodo": 202602,
        "valor": -171649.0,
        "delta": -7030.0
      },
      {
        "periodo": 202603,
        "valor": -171375.0,
        "delta": 274.0
      },
      {
        "periodo": 202604,
        "valor": -171202.0,
        "delta": 173.0
      },
      {
        "periodo": 202605,
        "valor": -217061.0,
        "delta": -45859.0
      },
      {
        "periodo": 202606,
        "valor": -193953.0,
        "delta": 23108.0
      },
      {
        "periodo": 202607,
        "valor": -279703.0,
        "delta": -85750.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -18398295.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -40385329.0,
        "delta": -21987034.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -618303.52,
    "valor_anterior": -721772.02,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2561188.92,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1542172.02,
        "delta": 1019016.9
      },
      {
        "periodo": 202509,
        "valor": -1566560.82,
        "delta": -24388.8
      },
      {
        "periodo": 202510,
        "valor": -1607719.33,
        "delta": -41158.51
      },
      {
        "periodo": 202511,
        "valor": -868269.96,
        "delta": 739449.37
      },
      {
        "periodo": 202512,
        "valor": -838016.24,
        "delta": 30253.72
      },
      {
        "periodo": 202601,
        "valor": -754198.03,
        "delta": 83818.21
      },
      {
        "periodo": 202602,
        "valor": -879021.45,
        "delta": -124823.42
      },
      {
        "periodo": 202603,
        "valor": -911288.45,
        "delta": -32267.0
      },
      {
        "periodo": 202604,
        "valor": -829155.56,
        "delta": 82132.89
      },
      {
        "periodo": 202605,
        "valor": -718004.78,
        "delta": 111150.78
      },
      {
        "periodo": 202606,
        "valor": -721772.02,
        "delta": -3767.24
      },
      {
        "periodo": 202607,
        "valor": -618303.52,
        "delta": 103468.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -1162976.0,
    "valor_anterior": -407647.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -387179.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -162454.0,
        "delta": 224725.0
      },
      {
        "periodo": 202509,
        "valor": -225611.0,
        "delta": -63157.0
      },
      {
        "periodo": 202510,
        "valor": -188758.0,
        "delta": 36853.0
      },
      {
        "periodo": 202511,
        "valor": -95835.0,
        "delta": 92923.0
      },
      {
        "periodo": 202512,
        "valor": -107992.0,
        "delta": -12157.0
      },
      {
        "periodo": 202601,
        "valor": -102885.0,
        "delta": 5107.0
      },
      {
        "periodo": 202602,
        "valor": -177730.0,
        "delta": -74845.0
      },
      {
        "periodo": 202603,
        "valor": -237733.0,
        "delta": -60003.0
      },
      {
        "periodo": 202604,
        "valor": -214283.0,
        "delta": 23450.0
      },
      {
        "periodo": 202605,
        "valor": -318700.0,
        "delta": -104417.0
      },
      {
        "periodo": 202606,
        "valor": -407647.0,
        "delta": -88947.0
      },
      {
        "periodo": 202607,
        "valor": -1162976.0,
        "delta": -755329.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -26510131910.39,
    "valor_anterior": -26332433789.6,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -24402023532.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -24833870362.64,
        "delta": -431846830.22
      },
      {
        "periodo": 202509,
        "valor": -25008297896.56,
        "delta": -174427533.92
      },
      {
        "periodo": 202510,
        "valor": -25075814465.95,
        "delta": -67516569.39
      },
      {
        "periodo": 202511,
        "valor": -24767937396.42,
        "delta": 307877069.53
      },
      {
        "periodo": 202512,
        "valor": -24300279551.4,
        "delta": 467657845.02
      },
      {
        "periodo": 202601,
        "valor": -24748719259.66,
        "delta": -448439708.26
      },
      {
        "periodo": 202602,
        "valor": -26161576340.97,
        "delta": -1412857081.31
      },
      {
        "periodo": 202603,
        "valor": -26247311879.17,
        "delta": -85735538.2
      },
      {
        "periodo": 202604,
        "valor": -26440110942.13,
        "delta": -192799062.96
      },
      {
        "periodo": 202605,
        "valor": -26623219175.55,
        "delta": -183108233.42
      },
      {
        "periodo": 202606,
        "valor": -26332433789.6,
        "delta": 290785385.95
      },
      {
        "periodo": 202607,
        "valor": -26510131910.39,
        "delta": -177698120.79
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -24333367279.47,
    "valor_anterior": -24245487387.22,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -22356701622.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -22767942510.6,
        "delta": -411240887.95
      },
      {
        "periodo": 202509,
        "valor": -22946389062.98,
        "delta": -178446552.38
      },
      {
        "periodo": 202510,
        "valor": -22993248184.5,
        "delta": -46859121.52
      },
      {
        "periodo": 202511,
        "valor": -22676564974.3,
        "delta": 316683210.2
      },
      {
        "periodo": 202512,
        "valor": -22266594368.64,
        "delta": 409970605.66
      },
      {
        "periodo": 202601,
        "valor": -22714011089.61,
        "delta": -447416720.97
      },
      {
        "periodo": 202602,
        "valor": -24116710008.34,
        "delta": -1402698918.73
      },
      {
        "periodo": 202603,
        "valor": -24220679365.96,
        "delta": -103969357.62
      },
      {
        "periodo": 202604,
        "valor": -24368733194.67,
        "delta": -148053828.71
      },
      {
        "periodo": 202605,
        "valor": -24532013565.64,
        "delta": -163280370.97
      },
      {
        "periodo": 202606,
        "valor": -24245487387.22,
        "delta": 286526178.42
      },
      {
        "periodo": 202607,
        "valor": -24333367279.47,
        "delta": -87879892.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -18398295.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -40385329.0,
        "delta": -21987034.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 40385329.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -315306518.0,
    "valor_anterior": -309672172.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -272337617.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -283218540.0,
        "delta": -10880923.0
      },
      {
        "periodo": 202509,
        "valor": -290569295.0,
        "delta": -7350755.0
      },
      {
        "periodo": 202510,
        "valor": -294576991.0,
        "delta": -4007696.0
      },
      {
        "periodo": 202511,
        "valor": -303471755.0,
        "delta": -8894764.0
      },
      {
        "periodo": 202512,
        "valor": -263704807.0,
        "delta": 39766948.0
      },
      {
        "periodo": 202601,
        "valor": -269620027.0,
        "delta": -5915220.0
      },
      {
        "periodo": 202602,
        "valor": -279931955.0,
        "delta": -10311928.0
      },
      {
        "periodo": 202603,
        "valor": -279864407.0,
        "delta": 67548.0
      },
      {
        "periodo": 202604,
        "valor": -289072579.0,
        "delta": -9208172.0
      },
      {
        "periodo": 202605,
        "valor": -298586077.0,
        "delta": -9513498.0
      },
      {
        "periodo": 202606,
        "valor": -309672172.0,
        "delta": -11086095.0
      },
      {
        "periodo": 202607,
        "valor": -315306518.0,
        "delta": -5634346.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -1616115693.41,
    "valor_anterior": -1542459790.38,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1564340209.63,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1546329363.19,
        "delta": 18010846.44
      },
      {
        "periodo": 202509,
        "valor": -1564957021.05,
        "delta": -18627657.86
      },
      {
        "periodo": 202510,
        "valor": -1580271120.79,
        "delta": -15314099.74
      },
      {
        "periodo": 202511,
        "valor": -1581729228.56,
        "delta": -1458107.77
      },
      {
        "periodo": 202512,
        "valor": -1555279596.53,
        "delta": 26449632.03
      },
      {
        "periodo": 202601,
        "valor": -1543348327.57,
        "delta": 11931268.96
      },
      {
        "periodo": 202602,
        "valor": -1540426337.18,
        "delta": 2921990.39
      },
      {
        "periodo": 202603,
        "valor": -1515566208.83,
        "delta": 24860128.35
      },
      {
        "periodo": 202604,
        "valor": -1551956489.55,
        "delta": -36390280.72
      },
      {
        "periodo": 202605,
        "valor": -1549477756.57,
        "delta": 2478732.98
      },
      {
        "periodo": 202606,
        "valor": -1542459790.38,
        "delta": 7017966.19
      },
      {
        "periodo": 202607,
        "valor": -1616115693.41,
        "delta": -73655903.03
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -16422804.52,
    "valor_anterior": -12105387.02,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -20134735.89,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -17849442.22,
        "delta": 2285293.67
      },
      {
        "periodo": 202509,
        "valor": -17961905.82,
        "delta": -112463.6
      },
      {
        "periodo": 202510,
        "valor": -20068694.33,
        "delta": -2106788.51
      },
      {
        "periodo": 202511,
        "valor": -14314419.96,
        "delta": 5754274.37
      },
      {
        "periodo": 202512,
        "valor": -14520527.24,
        "delta": -206107.28
      },
      {
        "periodo": 202601,
        "valor": -14308323.03,
        "delta": 212204.21
      },
      {
        "periodo": 202602,
        "valor": -14766334.45,
        "delta": -458011.42
      },
      {
        "periodo": 202603,
        "valor": -14367127.45,
        "delta": 399207.0
      },
      {
        "periodo": 202604,
        "valor": -15411612.56,
        "delta": -1044485.11
      },
      {
        "periodo": 202605,
        "valor": -15354641.78,
        "delta": 56970.78
      },
      {
        "periodo": 202606,
        "valor": -12105387.02,
        "delta": 3249254.76
      },
      {
        "periodo": 202607,
        "valor": -16422804.52,
        "delta": -4317417.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100034,
    "label": "EPRC Balance Vivienda",
    "valor_actual": -228919614.99,
    "valor_anterior": -222709052.98,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": -170111052.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -178145177.63,
        "delta": -8034125.38
      },
      {
        "periodo": 202509,
        "valor": -188420611.71,
        "delta": -10275434.08
      },
      {
        "periodo": 202510,
        "valor": -187649475.33,
        "delta": 771136.38
      },
      {
        "periodo": 202511,
        "valor": -191857018.6,
        "delta": -4207543.27
      },
      {
        "periodo": 202512,
        "valor": -200180251.99,
        "delta": -8323233.39
      },
      {
        "periodo": 202601,
        "valor": -207431492.45,
        "delta": -7251240.46
      },
      {
        "periodo": 202602,
        "valor": -209741706.0,
        "delta": -2310213.55
      },
      {
        "periodo": 202603,
        "valor": -216834769.93,
        "delta": -7093063.93
      },
      {
        "periodo": 202604,
        "valor": -214937066.35,
        "delta": 1897703.58
      },
      {
        "periodo": 202605,
        "valor": -227787134.56,
        "delta": -12850068.21
      },
      {
        "periodo": 202606,
        "valor": -222709052.98,
        "delta": 5078081.58
      },
      {
        "periodo": 202607,
        "valor": -228919614.99,
        "delta": -6210562.01
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 2548230326.01,
    "valor_anterior": 2669213874.4999995,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2025793862.38,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2028448868.05,
        "delta": 2655005.67
      },
      {
        "periodo": 202509,
        "valor": 2207849946.28,
        "delta": 179401078.23
      },
      {
        "periodo": 202510,
        "valor": 2145522369.2,
        "delta": -62327577.08
      },
      {
        "periodo": 202511,
        "valor": 2217053346.01,
        "delta": 71530976.81
      },
      {
        "periodo": 202512,
        "valor": 2412316339.51,
        "delta": 195262993.5
      },
      {
        "periodo": 202601,
        "valor": 2365589765.05,
        "delta": -46726574.46
      },
      {
        "periodo": 202602,
        "valor": 2135477996.84,
        "delta": -230111768.21
      },
      {
        "periodo": 202603,
        "valor": 2718448438.09,
        "delta": 582970441.25
      },
      {
        "periodo": 202604,
        "valor": 2573549829.68,
        "delta": -144898608.41
      },
      {
        "periodo": 202605,
        "valor": 2394916565.08,
        "delta": -178633264.6
      },
      {
        "periodo": 202606,
        "valor": 2669213874.5,
        "delta": 274297309.42
      },
      {
        "periodo": 202607,
        "valor": 2548230326.01,
        "delta": -120983548.49
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 5384233092.0,
    "valor_anterior": 5469511300.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4765021323.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4455782304.0,
        "delta": -309239019.0
      },
      {
        "periodo": 202509,
        "valor": 4890477079.0,
        "delta": 434694775.0
      },
      {
        "periodo": 202510,
        "valor": 4927480246.28,
        "delta": 37003167.28
      },
      {
        "periodo": 202511,
        "valor": 5748667429.61,
        "delta": 821187183.33
      },
      {
        "periodo": 202512,
        "valor": 6688416718.45,
        "delta": 939749288.84
      },
      {
        "periodo": 202601,
        "valor": 5289183363.08,
        "delta": -1399233355.37
      },
      {
        "periodo": 202602,
        "valor": 5803170949.79,
        "delta": 513987586.71
      },
      {
        "periodo": 202603,
        "valor": 5699051093.58,
        "delta": -104119856.21
      },
      {
        "periodo": 202604,
        "valor": 5374019739.7,
        "delta": -325031353.88
      },
      {
        "periodo": 202605,
        "valor": 5288797049.0,
        "delta": -85222690.7
      },
      {
        "periodo": 202606,
        "valor": 5469511301.0,
        "delta": 180714252.0
      },
      {
        "periodo": 202607,
        "valor": 5384233092.0,
        "delta": -85278209.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 2642480229.0,
    "valor_anterior": 2340477615.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2383307350.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2595783001.0,
        "delta": 212475651.0
      },
      {
        "periodo": 202509,
        "valor": 2339611753.0,
        "delta": -256171248.0
      },
      {
        "periodo": 202510,
        "valor": 2292315907.0,
        "delta": -47295846.0
      },
      {
        "periodo": 202511,
        "valor": 3239879428.0,
        "delta": 947563521.0
      },
      {
        "periodo": 202512,
        "valor": 3111233553.0,
        "delta": -128645875.0
      },
      {
        "periodo": 202601,
        "valor": 2203175561.0,
        "delta": -908057992.0
      },
      {
        "periodo": 202602,
        "valor": 2166389260.0,
        "delta": -36786301.0
      },
      {
        "periodo": 202603,
        "valor": 2321850983.0,
        "delta": 155461723.0
      },
      {
        "periodo": 202604,
        "valor": 2481366684.0,
        "delta": 159515701.0
      },
      {
        "periodo": 202605,
        "valor": 2364633067.0,
        "delta": -116733617.0
      },
      {
        "periodo": 202606,
        "valor": 2340477615.0,
        "delta": -24155452.0
      },
      {
        "periodo": 202607,
        "valor": 2642480229.0,
        "delta": 302002614.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 1101437107.0,
    "valor_anterior": 1122195233.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1243954131.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1082845018.0,
        "delta": -161109113.0
      },
      {
        "periodo": 202509,
        "valor": 1270007889.0,
        "delta": 187162871.0
      },
      {
        "periodo": 202510,
        "valor": 1228030731.0,
        "delta": -41977158.0
      },
      {
        "periodo": 202511,
        "valor": 1602689693.0,
        "delta": 374658962.0
      },
      {
        "periodo": 202512,
        "valor": 1197435541.0,
        "delta": -405254152.0
      },
      {
        "periodo": 202601,
        "valor": 1206081579.0,
        "delta": 8646038.0
      },
      {
        "periodo": 202602,
        "valor": 1213642035.0,
        "delta": 7560456.0
      },
      {
        "periodo": 202603,
        "valor": 1247909730.0,
        "delta": 34267695.0
      },
      {
        "periodo": 202604,
        "valor": 1151766670.0,
        "delta": -96143060.0
      },
      {
        "periodo": 202605,
        "valor": 1002453488.0,
        "delta": -149313182.0
      },
      {
        "periodo": 202606,
        "valor": 1122195233.0,
        "delta": 119741745.0
      },
      {
        "periodo": 202607,
        "valor": 1101437107.0,
        "delta": -20758126.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 154978391.09,
    "valor_anterior": 180483646.62,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 111849484.6,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 177742827.4,
        "delta": 65893342.8
      },
      {
        "periodo": 202509,
        "valor": 133247555.15,
        "delta": -44495272.25
      },
      {
        "periodo": 202510,
        "valor": 282511963.16,
        "delta": 149264408.01
      },
      {
        "periodo": 202511,
        "valor": 358346418.66,
        "delta": 75834455.5
      },
      {
        "periodo": 202512,
        "valor": 757102794.46,
        "delta": 398756375.8
      },
      {
        "periodo": 202601,
        "valor": 99089426.1,
        "delta": -658013368.36
      },
      {
        "periodo": 202602,
        "valor": 79799899.3,
        "delta": -19289526.8
      },
      {
        "periodo": 202603,
        "valor": 117430989.6,
        "delta": 37631090.3
      },
      {
        "periodo": 202604,
        "valor": 200807569.46,
        "delta": 83376579.86
      },
      {
        "periodo": 202605,
        "valor": 132328341.61,
        "delta": -68479227.85
      },
      {
        "periodo": 202606,
        "valor": 180483646.62,
        "delta": 48155305.01
      },
      {
        "periodo": 202607,
        "valor": 154978391.09,
        "delta": -25505255.53
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 511742584.0,
    "valor_anterior": 585926786.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 427691801.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 381656848.0,
        "delta": -46034953.0
      },
      {
        "periodo": 202509,
        "valor": 419628245.0,
        "delta": 37971397.0
      },
      {
        "periodo": 202510,
        "valor": 491519798.0,
        "delta": 71891553.0
      },
      {
        "periodo": 202511,
        "valor": 470688036.0,
        "delta": -20831762.0
      },
      {
        "periodo": 202512,
        "valor": 491804877.0,
        "delta": 21116841.0
      },
      {
        "periodo": 202601,
        "valor": 487174156.0,
        "delta": -4630721.0
      },
      {
        "periodo": 202602,
        "valor": 480557167.0,
        "delta": -6616989.0
      },
      {
        "periodo": 202603,
        "valor": 495703252.0,
        "delta": 15146085.0
      },
      {
        "periodo": 202604,
        "valor": 532572889.0,
        "delta": 36869637.0
      },
      {
        "periodo": 202605,
        "valor": 507467079.0,
        "delta": -25105810.0
      },
      {
        "periodo": 202606,
        "valor": 585926786.0,
        "delta": 78459707.0
      },
      {
        "periodo": 202607,
        "valor": 511742584.0,
        "delta": -74184202.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 63234615.0,
    "valor_anterior": 15654334.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 52256154.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 59138432.0,
        "delta": 6882278.0
      },
      {
        "periodo": 202509,
        "valor": 77654946.0,
        "delta": 18516514.0
      },
      {
        "periodo": 202510,
        "valor": 69844628.0,
        "delta": -7810318.0
      },
      {
        "periodo": 202511,
        "valor": 23444750.0,
        "delta": -46399878.0
      },
      {
        "periodo": 202512,
        "valor": 229190812.0,
        "delta": 205746062.0
      },
      {
        "periodo": 202601,
        "valor": 12542583.0,
        "delta": -216648229.0
      },
      {
        "periodo": 202602,
        "valor": 19842752.0,
        "delta": 7300169.0
      },
      {
        "periodo": 202603,
        "valor": 5332455.0,
        "delta": -14510297.0
      },
      {
        "periodo": 202604,
        "valor": 22175627.0,
        "delta": 16843172.0
      },
      {
        "periodo": 202605,
        "valor": 9681170.0,
        "delta": -12494457.0
      },
      {
        "periodo": 202606,
        "valor": 15654334.0,
        "delta": 5973164.0
      },
      {
        "periodo": 202607,
        "valor": 63234615.0,
        "delta": 47580281.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 446271367.0,
    "valor_anterior": 471147682.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 510847507.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 475442425.0,
        "delta": -35405082.0
      },
      {
        "periodo": 202509,
        "valor": 497289617.0,
        "delta": 21847192.0
      },
      {
        "periodo": 202510,
        "valor": 440177715.0,
        "delta": -57111902.0
      },
      {
        "periodo": 202511,
        "valor": 465493187.0,
        "delta": 25315472.0
      },
      {
        "periodo": 202512,
        "valor": 576250028.0,
        "delta": 110756841.0
      },
      {
        "periodo": 202601,
        "valor": 427126756.0,
        "delta": -149123272.0
      },
      {
        "periodo": 202602,
        "valor": 347614400.0,
        "delta": -79512356.0
      },
      {
        "periodo": 202603,
        "valor": 512369228.0,
        "delta": 164754828.0
      },
      {
        "periodo": 202604,
        "valor": 607010577.0,
        "delta": 94641349.0
      },
      {
        "periodo": 202605,
        "valor": 397882073.0,
        "delta": -209128504.0
      },
      {
        "periodo": 202606,
        "valor": 471147682.0,
        "delta": 73265609.0
      },
      {
        "periodo": 202607,
        "valor": 446271367.0,
        "delta": -24876315.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 61922100.18,
    "valor_anterior": 77704202.01,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 79859412.55,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 203815873.45,
        "delta": 123956460.9
      },
      {
        "periodo": 202509,
        "valor": 104457083.44,
        "delta": -99358790.01
      },
      {
        "periodo": 202510,
        "valor": 134618415.11,
        "delta": 30161331.67
      },
      {
        "periodo": 202511,
        "valor": 105501716.44,
        "delta": -29116698.67
      },
      {
        "periodo": 202512,
        "valor": 522825282.64,
        "delta": 417323566.2
      },
      {
        "periodo": 202601,
        "valor": 234948791.25,
        "delta": -287876491.39
      },
      {
        "periodo": 202602,
        "valor": 497461732.81,
        "delta": 262512941.56
      },
      {
        "periodo": 202603,
        "valor": 62235554.55,
        "delta": -435226178.26
      },
      {
        "periodo": 202604,
        "valor": 55958208.16,
        "delta": -6277346.39
      },
      {
        "periodo": 202605,
        "valor": 83821942.38,
        "delta": 27863734.22
      },
      {
        "periodo": 202606,
        "valor": 77704202.01,
        "delta": -6117740.37
      },
      {
        "periodo": 202607,
        "valor": 61922100.18,
        "delta": -15782101.83
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 457374190.0,
    "valor_anterior": 423165524.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 347133895.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 331540663.0,
        "delta": -15593232.0
      },
      {
        "periodo": 202509,
        "valor": 316017523.0,
        "delta": -15523140.0
      },
      {
        "periodo": 202510,
        "valor": 383206751.0,
        "delta": 67189228.0
      },
      {
        "periodo": 202511,
        "valor": 318008359.0,
        "delta": -65198392.0
      },
      {
        "periodo": 202512,
        "valor": 351875741.0,
        "delta": 33867382.0
      },
      {
        "periodo": 202601,
        "valor": 248091474.0,
        "delta": -103784267.0
      },
      {
        "periodo": 202602,
        "valor": 398868771.0,
        "delta": 150777297.0
      },
      {
        "periodo": 202603,
        "valor": 414115129.0,
        "delta": 15246358.0
      },
      {
        "periodo": 202604,
        "valor": 412537127.0,
        "delta": -1578002.0
      },
      {
        "periodo": 202605,
        "valor": 399732879.0,
        "delta": -12804248.0
      },
      {
        "periodo": 202606,
        "valor": 423165524.0,
        "delta": 23432645.0
      },
      {
        "periodo": 202607,
        "valor": 457374190.0,
        "delta": 34208666.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 125611.0,
        "delta": 125611.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": -125611.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 130558663.0,
    "valor_anterior": 118600185.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 141045082.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 137294039.0,
        "delta": -3751043.0
      },
      {
        "periodo": 202509,
        "valor": 119170060.0,
        "delta": -18123979.0
      },
      {
        "periodo": 202510,
        "valor": 170421679.0,
        "delta": 51251619.0
      },
      {
        "periodo": 202511,
        "valor": 104065496.0,
        "delta": -66356183.0
      },
      {
        "periodo": 202512,
        "valor": 1103887462.0,
        "delta": 999821966.0
      },
      {
        "periodo": 202601,
        "valor": 128733837.0,
        "delta": -975153625.0
      },
      {
        "periodo": 202602,
        "valor": 119102825.0,
        "delta": -9631012.0
      },
      {
        "periodo": 202603,
        "valor": 132444012.0,
        "delta": 13341187.0
      },
      {
        "periodo": 202604,
        "valor": 138820750.0,
        "delta": 6376738.0
      },
      {
        "periodo": 202605,
        "valor": 110497800.0,
        "delta": -28322950.0
      },
      {
        "periodo": 202606,
        "valor": 118600185.0,
        "delta": 8102385.0
      },
      {
        "periodo": 202607,
        "valor": 130558663.0,
        "delta": 11958478.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 2263802795.38,
    "valor_anterior": 2013568765.01,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1764869739.67,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1918977105.56,
        "delta": 154107365.89
      },
      {
        "periodo": 202509,
        "valor": 1803529075.07,
        "delta": -115448030.49
      },
      {
        "periodo": 202510,
        "valor": 1639582889.15,
        "delta": -163946185.92
      },
      {
        "periodo": 202511,
        "valor": 1554379339.14,
        "delta": -85203550.01
      },
      {
        "periodo": 202512,
        "valor": 2006939014.64,
        "delta": 452559675.5
      },
      {
        "periodo": 202601,
        "valor": 1927358366.15,
        "delta": -79580648.49
      },
      {
        "periodo": 202602,
        "valor": 2134756905.02,
        "delta": 207398538.87
      },
      {
        "periodo": 202603,
        "valor": 2019466234.43,
        "delta": -115290670.59
      },
      {
        "periodo": 202604,
        "valor": 2047843371.19,
        "delta": 28377136.76
      },
      {
        "periodo": 202605,
        "valor": 2038923044.51,
        "delta": -8920326.68
      },
      {
        "periodo": 202606,
        "valor": 2013568765.01,
        "delta": -25354279.5
      },
      {
        "periodo": 202607,
        "valor": 2263802795.38,
        "delta": 250234030.37
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 34923204.38,
    "valor_anterior": 101364295.67,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 886803.41,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10957587.58,
        "delta": 10070784.17
      },
      {
        "periodo": 202509,
        "valor": 2297372.96,
        "delta": -8660214.62
      },
      {
        "periodo": 202510,
        "valor": 73335330.19,
        "delta": 71037957.23
      },
      {
        "periodo": 202511,
        "valor": 84872289.02,
        "delta": 11536958.83
      },
      {
        "periodo": 202512,
        "valor": 246996799.42,
        "delta": 162124510.4
      },
      {
        "periodo": 202601,
        "valor": 6258223.09,
        "delta": -240738576.33
      },
      {
        "periodo": 202602,
        "valor": 2648259.33,
        "delta": -3609963.76
      },
      {
        "periodo": 202603,
        "valor": 3146088.0,
        "delta": 497828.67
      },
      {
        "periodo": 202604,
        "valor": 525349.1,
        "delta": -2620738.9
      },
      {
        "periodo": 202605,
        "valor": 4551819.02,
        "delta": 4026469.92
      },
      {
        "periodo": 202606,
        "valor": 101364295.67,
        "delta": 96812476.65
      },
      {
        "periodo": 202607,
        "valor": 34923204.38,
        "delta": -66441091.29
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 18158286.0,
    "valor_anterior": 12034738.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1354077.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12239851.0,
        "delta": 10885774.0
      },
      {
        "periodo": 202509,
        "valor": 14789565.0,
        "delta": 2549714.0
      },
      {
        "periodo": 202510,
        "valor": 74413904.0,
        "delta": 59624339.0
      },
      {
        "periodo": 202511,
        "valor": 54586319.0,
        "delta": -19827585.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": -54586319.0
      },
      {
        "periodo": 202601,
        "valor": 134547.0,
        "delta": 134547.0
      },
      {
        "periodo": 202602,
        "valor": 9115451.0,
        "delta": 8980904.0
      },
      {
        "periodo": 202603,
        "valor": 9872.0,
        "delta": -9105579.0
      },
      {
        "periodo": 202604,
        "valor": 127584246.0,
        "delta": 127574374.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": -127584246.0
      },
      {
        "periodo": 202606,
        "valor": 12034738.0,
        "delta": 12034738.0
      },
      {
        "periodo": 202607,
        "valor": 18158286.0,
        "delta": 6123548.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 2053716019.7500002,
    "valor_anterior": 1723351897.22,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 987236915.81,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1030824148.25,
        "delta": 43587232.44
      },
      {
        "periodo": 202509,
        "valor": 1155269027.15,
        "delta": 124444878.9
      },
      {
        "periodo": 202510,
        "valor": 1241380333.89,
        "delta": 86111306.74
      },
      {
        "periodo": 202511,
        "valor": 1440087235.01,
        "delta": 198706901.12
      },
      {
        "periodo": 202512,
        "valor": 1144779649.81,
        "delta": -295307585.2
      },
      {
        "periodo": 202601,
        "valor": 1606879867.19,
        "delta": 462100217.38
      },
      {
        "periodo": 202602,
        "valor": 1388499963.17,
        "delta": -218379904.02
      },
      {
        "periodo": 202603,
        "valor": 1703754746.88,
        "delta": 315254783.71
      },
      {
        "periodo": 202604,
        "valor": 1740901192.32,
        "delta": 37146445.44
      },
      {
        "periodo": 202605,
        "valor": 1802662768.59,
        "delta": 61761576.27
      },
      {
        "periodo": 202606,
        "valor": 1723351897.22,
        "delta": -79310871.37
      },
      {
        "periodo": 202607,
        "valor": 2053716019.75,
        "delta": 330364122.53
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 3704251.13,
    "valor_anterior": 125259450.15,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5423306.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -5423306.19
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 125259450.15,
        "delta": 125259450.15
      },
      {
        "periodo": 202607,
        "valor": 3704251.13,
        "delta": -121555199.02
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 792899789.0,
    "valor_anterior": 730496473.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 494375426.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 463314818.0,
        "delta": -31060608.0
      },
      {
        "periodo": 202509,
        "valor": 451663902.0,
        "delta": -11650916.0
      },
      {
        "periodo": 202510,
        "valor": 520818882.0,
        "delta": 69154980.0
      },
      {
        "periodo": 202511,
        "valor": 512823930.0,
        "delta": -7994952.0
      },
      {
        "periodo": 202512,
        "valor": 480416710.0,
        "delta": -32407220.0
      },
      {
        "periodo": 202601,
        "valor": 660824535.0,
        "delta": 180407825.0
      },
      {
        "periodo": 202602,
        "valor": 572243194.0,
        "delta": -88581341.0
      },
      {
        "periodo": 202603,
        "valor": 621325147.0,
        "delta": 49081953.0
      },
      {
        "periodo": 202604,
        "valor": 905095524.0,
        "delta": 283770377.0
      },
      {
        "periodo": 202605,
        "valor": 757047490.0,
        "delta": -148048034.0
      },
      {
        "periodo": 202606,
        "valor": 730496473.0,
        "delta": -26551017.0
      },
      {
        "periodo": 202607,
        "valor": 792899789.0,
        "delta": 62403316.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 628251.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4368406.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10.0,
        "delta": -4368396.0
      },
      {
        "periodo": 202509,
        "valor": 18669076.0,
        "delta": 18669066.0
      },
      {
        "periodo": 202510,
        "valor": 98069500.0,
        "delta": 79400424.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": -98069500.0
      },
      {
        "periodo": 202512,
        "valor": 4.0,
        "delta": 4.0
      },
      {
        "periodo": 202601,
        "valor": 1596287.0,
        "delta": 1596283.0
      },
      {
        "periodo": 202602,
        "valor": 27765005.0,
        "delta": 26168718.0
      },
      {
        "periodo": 202603,
        "valor": 1199036.0,
        "delta": -26565969.0
      },
      {
        "periodo": 202604,
        "valor": 685523.0,
        "delta": -513513.0
      },
      {
        "periodo": 202605,
        "valor": 13.0,
        "delta": -685510.0
      },
      {
        "periodo": 202606,
        "valor": 628251.0,
        "delta": 628238.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": -628251.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 13492161.77,
    "valor_anterior": 18845677.55,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17391634.56,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12673188.82,
        "delta": -4718445.74
      },
      {
        "periodo": 202509,
        "valor": 13783594.64,
        "delta": 1110405.82
      },
      {
        "periodo": 202510,
        "valor": 682214522.46,
        "delta": 668430927.82
      },
      {
        "periodo": 202511,
        "valor": 14637468.02,
        "delta": -667577054.44
      },
      {
        "periodo": 202512,
        "valor": 78285420.9,
        "delta": 63647952.88
      },
      {
        "periodo": 202601,
        "valor": 19771648.4,
        "delta": -58513772.5
      },
      {
        "periodo": 202602,
        "valor": 16266159.43,
        "delta": -3505488.97
      },
      {
        "periodo": 202603,
        "valor": 97481626.66,
        "delta": 81215467.23
      },
      {
        "periodo": 202604,
        "valor": 18120883.18,
        "delta": -79360743.48
      },
      {
        "periodo": 202605,
        "valor": 19601532.12,
        "delta": 1480648.94
      },
      {
        "periodo": 202606,
        "valor": 18845677.55,
        "delta": -755854.57
      },
      {
        "periodo": 202607,
        "valor": 13492161.77,
        "delta": -5353515.78
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 33282288.0,
    "valor_anterior": 31019079.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14534507.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15733416.0,
        "delta": 1198909.0
      },
      {
        "periodo": 202509,
        "valor": 17213561.0,
        "delta": 1480145.0
      },
      {
        "periodo": 202510,
        "valor": 18397364.0,
        "delta": 1183803.0
      },
      {
        "periodo": 202511,
        "valor": 21307467.0,
        "delta": 2910103.0
      },
      {
        "periodo": 202512,
        "valor": 22719048.0,
        "delta": 1411581.0
      },
      {
        "periodo": 202601,
        "valor": 27870263.0,
        "delta": 5151215.0
      },
      {
        "periodo": 202602,
        "valor": 25399539.0,
        "delta": -2470724.0
      },
      {
        "periodo": 202603,
        "valor": 32471975.0,
        "delta": 7072436.0
      },
      {
        "periodo": 202604,
        "valor": 32060202.0,
        "delta": -411773.0
      },
      {
        "periodo": 202605,
        "valor": 32691925.0,
        "delta": 631723.0
      },
      {
        "periodo": 202606,
        "valor": 31019079.0,
        "delta": -1672846.0
      },
      {
        "periodo": 202607,
        "valor": 33282288.0,
        "delta": 2263209.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 50957342.0,
    "valor_anterior": 23415529.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 44451485.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 53462216.0,
        "delta": 9010731.0
      },
      {
        "periodo": 202509,
        "valor": 42053085.0,
        "delta": -11409131.0
      },
      {
        "periodo": 202510,
        "valor": 36686395.0,
        "delta": -5366690.0
      },
      {
        "periodo": 202511,
        "valor": 36871592.0,
        "delta": 185197.0
      },
      {
        "periodo": 202512,
        "valor": 35982033.0,
        "delta": -889559.0
      },
      {
        "periodo": 202601,
        "valor": 46003141.0,
        "delta": 10021108.0
      },
      {
        "periodo": 202602,
        "valor": 32442951.0,
        "delta": -13560190.0
      },
      {
        "periodo": 202603,
        "valor": 66184402.0,
        "delta": 33741451.0
      },
      {
        "periodo": 202604,
        "valor": 25132857.0,
        "delta": -41051545.0
      },
      {
        "periodo": 202605,
        "valor": 97980791.0,
        "delta": 72847934.0
      },
      {
        "periodo": 202606,
        "valor": 23415529.0,
        "delta": -74565262.0
      },
      {
        "periodo": 202607,
        "valor": 50957342.0,
        "delta": 27541813.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 34611483.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17491656.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 519835.0,
        "delta": -16971821.0
      },
      {
        "periodo": 202509,
        "valor": 65966.0,
        "delta": -453869.0
      },
      {
        "periodo": 202510,
        "valor": 645921.0,
        "delta": 579955.0
      },
      {
        "periodo": 202511,
        "valor": 150247.0,
        "delta": -495674.0
      },
      {
        "periodo": 202512,
        "valor": 659684.0,
        "delta": 509437.0
      },
      {
        "periodo": 202601,
        "valor": 134563.0,
        "delta": -525121.0
      },
      {
        "periodo": 202602,
        "valor": 146190.0,
        "delta": 11627.0
      },
      {
        "periodo": 202603,
        "valor": 311082.0,
        "delta": 164892.0
      },
      {
        "periodo": 202604,
        "valor": 791790.0,
        "delta": 480708.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": -791790.0
      },
      {
        "periodo": 202606,
        "valor": 34611483.0,
        "delta": 34611483.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": -34611483.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20661862.76,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 228412214.68,
        "delta": 207750351.92
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -228412214.68
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 72551.59,
        "delta": 72551.59
      },
      {
        "periodo": 202509,
        "valor": 71632.22,
        "delta": -919.37
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": -71632.22
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 79618.57,
        "delta": 79618.57
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -79618.57
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 8800097.0,
    "valor_anterior": 5489034.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11207139.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7816795.0,
        "delta": -3390344.0
      },
      {
        "periodo": 202509,
        "valor": 7053297.0,
        "delta": -763498.0
      },
      {
        "periodo": 202510,
        "valor": 4240020.0,
        "delta": -2813277.0
      },
      {
        "periodo": 202511,
        "valor": 4398272.0,
        "delta": 158252.0
      },
      {
        "periodo": 202512,
        "valor": 5325147.0,
        "delta": 926875.0
      },
      {
        "periodo": 202601,
        "valor": 6976553.0,
        "delta": 1651406.0
      },
      {
        "periodo": 202602,
        "valor": 4578364.0,
        "delta": -2398189.0
      },
      {
        "periodo": 202603,
        "valor": 4510608.0,
        "delta": -67756.0
      },
      {
        "periodo": 202604,
        "valor": 2891868.0,
        "delta": -1618740.0
      },
      {
        "periodo": 202605,
        "valor": 5592274.0,
        "delta": 2700406.0
      },
      {
        "periodo": 202606,
        "valor": 5489034.0,
        "delta": -103240.0
      },
      {
        "periodo": 202607,
        "valor": 8800097.0,
        "delta": 3311063.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 2982169.32,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17028224.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 382364.01,
        "delta": -16645860.81
      },
      {
        "periodo": 202509,
        "valor": 482940.92,
        "delta": 100576.91
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": -482940.92
      },
      {
        "periodo": 202511,
        "valor": 1992760.31,
        "delta": 1992760.31
      },
      {
        "periodo": 202512,
        "valor": 309389.02,
        "delta": -1683371.29
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -309389.02
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 2982169.32,
        "delta": 2982169.32
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 12254327.49,
    "valor_anterior": 31181606.67,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 456688.8,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -456688.8
      },
      {
        "periodo": 202509,
        "valor": 45652.15,
        "delta": 45652.15
      },
      {
        "periodo": 202510,
        "valor": 103171.0,
        "delta": 57518.85
      },
      {
        "periodo": 202511,
        "valor": 1069941.27,
        "delta": 966770.27
      },
      {
        "periodo": 202512,
        "valor": 308018.13,
        "delta": -761923.14
      },
      {
        "periodo": 202601,
        "valor": 1083359.78,
        "delta": 775341.65
      },
      {
        "periodo": 202602,
        "valor": 131071.09,
        "delta": -952288.69
      },
      {
        "periodo": 202603,
        "valor": 1348130.22,
        "delta": 1217059.13
      },
      {
        "periodo": 202604,
        "valor": 6812981.49,
        "delta": 5464851.27
      },
      {
        "periodo": 202605,
        "valor": 1357937.47,
        "delta": -5455044.02
      },
      {
        "periodo": 202606,
        "valor": 31181606.67,
        "delta": 29823669.2
      },
      {
        "periodo": 202607,
        "valor": 12254327.49,
        "delta": -18927279.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 29244836.0,
        "delta": 29244836.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": -29244836.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 43074075.35,
        "delta": 43074075.35
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": -43074075.35
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 102093.62,
    "valor_anterior": 21299.16,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3185109.89,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2711810.25,
        "delta": -473299.64
      },
      {
        "periodo": 202509,
        "valor": 2381464.77,
        "delta": -330345.48
      },
      {
        "periodo": 202510,
        "valor": 1226676.25,
        "delta": -1154788.52
      },
      {
        "periodo": 202511,
        "valor": 776079.7,
        "delta": -450596.55
      },
      {
        "periodo": 202512,
        "valor": 622402.92,
        "delta": -153676.78
      },
      {
        "periodo": 202601,
        "valor": 293575.01,
        "delta": -328827.91
      },
      {
        "periodo": 202602,
        "valor": 69643.02,
        "delta": -223931.99
      },
      {
        "periodo": 202603,
        "valor": 101679.46,
        "delta": 32036.44
      },
      {
        "periodo": 202604,
        "valor": 188604.46,
        "delta": 86925.0
      },
      {
        "periodo": 202605,
        "valor": 26918.53,
        "delta": -161685.93
      },
      {
        "periodo": 202606,
        "valor": 21299.16,
        "delta": -5619.37
      },
      {
        "periodo": 202607,
        "valor": 102093.62,
        "delta": 80794.46
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 35160790.73,
    "valor_anterior": 40387690.13,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 39774663.92,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 43531075.71,
        "delta": 3756411.79
      },
      {
        "periodo": 202604,
        "valor": 42031034.45,
        "delta": -1500041.26
      },
      {
        "periodo": 202605,
        "valor": 36825659.27,
        "delta": -5205375.18
      },
      {
        "periodo": 202606,
        "valor": 40387690.13,
        "delta": 3562030.86
      },
      {
        "periodo": 202607,
        "valor": 35160790.73,
        "delta": -5226899.4
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 20743114.0,
    "valor_anterior": 19369278.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 50325.0,
        "delta": 50325.0
      },
      {
        "periodo": 202509,
        "valor": 1149865.0,
        "delta": 1099540.0
      },
      {
        "periodo": 202510,
        "valor": 1660940.0,
        "delta": 511075.0
      },
      {
        "periodo": 202511,
        "valor": 5672631.0,
        "delta": 4011691.0
      },
      {
        "periodo": 202512,
        "valor": 17054038.0,
        "delta": 11381407.0
      },
      {
        "periodo": 202601,
        "valor": 21182906.0,
        "delta": 4128868.0
      },
      {
        "periodo": 202602,
        "valor": 23570403.0,
        "delta": 2387497.0
      },
      {
        "periodo": 202603,
        "valor": 18763836.0,
        "delta": -4806567.0
      },
      {
        "periodo": 202604,
        "valor": 14416594.0,
        "delta": -4347242.0
      },
      {
        "periodo": 202605,
        "valor": 15122332.0,
        "delta": 705738.0
      },
      {
        "periodo": 202606,
        "valor": 19369278.0,
        "delta": 4246946.0
      },
      {
        "periodo": 202607,
        "valor": 20743114.0,
        "delta": 1373836.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 7145.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 420.0,
        "delta": 420.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": -420.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 7145.0,
        "delta": 7145.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 0.0,
    "valor_anterior": 518371713.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 417389921.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": -417389921.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 518371713.0,
        "delta": 518371713.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": -518371713.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 18847448538.85,
    "valor_anterior": 18903496642.69,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15493682984.44,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15687638535.64,
        "delta": 193955551.2
      },
      {
        "periodo": 202509,
        "valor": 15905930773.75,
        "delta": 218292238.11
      },
      {
        "periodo": 202510,
        "valor": 17001625738.04,
        "delta": 1095694964.29
      },
      {
        "periodo": 202511,
        "valor": 18387463430.19,
        "delta": 1385837692.15
      },
      {
        "periodo": 202512,
        "valor": 21482816126.47,
        "delta": 3095352696.28
      },
      {
        "periodo": 202601,
        "valor": 17028105126.1,
        "delta": -4454711000.37
      },
      {
        "periodo": 202602,
        "valor": 17568580386.72,
        "delta": 540475260.62
      },
      {
        "periodo": 202603,
        "valor": 18757886325.18,
        "delta": 1189305938.46
      },
      {
        "periodo": 202604,
        "valor": 18515668111.19,
        "delta": -242218213.99
      },
      {
        "periodo": 202605,
        "valor": 17504595958.58,
        "delta": -1011072152.61
      },
      {
        "periodo": 202606,
        "valor": 18903496642.69,
        "delta": 1398900684.11
      },
      {
        "periodo": 202607,
        "valor": 18847448538.85,
        "delta": -56048103.84
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 14898197500.39,
    "valor_anterior": 14672041256.51,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13121485714.05,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12938935569.61,
        "delta": -182550144.44
      },
      {
        "periodo": 202509,
        "valor": 13428393604.35,
        "delta": 489458034.74
      },
      {
        "periodo": 202510,
        "valor": 13164629655.63,
        "delta": -263763948.72
      },
      {
        "periodo": 202511,
        "valor": 15298850458.76,
        "delta": 2134220803.13
      },
      {
        "periodo": 202512,
        "valor": 16484396071.6,
        "delta": 1185545612.84
      },
      {
        "periodo": 202601,
        "valor": 13905689546.28,
        "delta": -2578706525.32
      },
      {
        "periodo": 202602,
        "valor": 14281608713.65,
        "delta": 375919167.37
      },
      {
        "periodo": 202603,
        "valor": 15014798959.1,
        "delta": 733190245.45
      },
      {
        "periodo": 202604,
        "valor": 14768129760.57,
        "delta": -246669198.53
      },
      {
        "periodo": 202605,
        "valor": 13995072365.59,
        "delta": -773057394.98
      },
      {
        "periodo": 202606,
        "valor": 14672041256.51,
        "delta": 676968890.92
      },
      {
        "periodo": 202607,
        "valor": 14898197500.39,
        "delta": 226156243.88
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 34923204.38,
    "valor_anterior": 101364295.67,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21548666.17,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 239369802.26,
        "delta": 217821136.09
      },
      {
        "periodo": 202509,
        "valor": 2297372.96,
        "delta": -237072429.3
      },
      {
        "periodo": 202510,
        "valor": 73335330.19,
        "delta": 71037957.23
      },
      {
        "periodo": 202511,
        "valor": 84872289.02,
        "delta": 11536958.83
      },
      {
        "periodo": 202512,
        "valor": 246996799.42,
        "delta": 162124510.4
      },
      {
        "periodo": 202601,
        "valor": 6258223.09,
        "delta": -240738576.33
      },
      {
        "periodo": 202602,
        "valor": 2648259.33,
        "delta": -3609963.76
      },
      {
        "periodo": 202603,
        "valor": 3146088.0,
        "delta": 497828.67
      },
      {
        "periodo": 202604,
        "valor": 525349.1,
        "delta": -2620738.9
      },
      {
        "periodo": 202605,
        "valor": 4551819.02,
        "delta": 4026469.92
      },
      {
        "periodo": 202606,
        "valor": 101364295.67,
        "delta": 96812476.65
      },
      {
        "periodo": 202607,
        "valor": 34923204.38,
        "delta": -66441091.29
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 587932853.0,
    "valor_anterior": 541765709.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 488178977.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 468834702.0,
        "delta": -19344275.0
      },
      {
        "periodo": 202509,
        "valor": 435187583.0,
        "delta": -33647119.0
      },
      {
        "periodo": 202510,
        "valor": 553628430.0,
        "delta": 118440847.0
      },
      {
        "periodo": 202511,
        "valor": 422073855.0,
        "delta": -131554575.0
      },
      {
        "periodo": 202512,
        "valor": 1455763203.0,
        "delta": 1033689348.0
      },
      {
        "periodo": 202601,
        "valor": 376825311.0,
        "delta": -1078937892.0
      },
      {
        "periodo": 202602,
        "valor": 517971596.0,
        "delta": 141146285.0
      },
      {
        "periodo": 202603,
        "valor": 546559141.0,
        "delta": 28587545.0
      },
      {
        "periodo": 202604,
        "valor": 551357877.0,
        "delta": 4798736.0
      },
      {
        "periodo": 202605,
        "valor": 510230679.0,
        "delta": -41127198.0
      },
      {
        "periodo": 202606,
        "valor": 541765709.0,
        "delta": 31535030.0
      },
      {
        "periodo": 202607,
        "valor": 587932853.0,
        "delta": 46167144.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 298293392.27,
    "valor_anterior": 286505171.63,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 249687534.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 452936993.85,
        "delta": 203249459.7
      },
      {
        "periodo": 202509,
        "valor": 348818225.59,
        "delta": -104118768.26
      },
      {
        "periodo": 202510,
        "valor": 659458410.27,
        "delta": 310640184.68
      },
      {
        "periodo": 202511,
        "valor": 541879204.1,
        "delta": -117579206.17
      },
      {
        "periodo": 202512,
        "valor": 1509118893.1,
        "delta": 967239689.0
      },
      {
        "periodo": 202601,
        "valor": 348311634.35,
        "delta": -1160807258.75
      },
      {
        "periodo": 202602,
        "valor": 633984840.11,
        "delta": 285673205.76
      },
      {
        "periodo": 202603,
        "valor": 186207907.15,
        "delta": -447776932.96
      },
      {
        "periodo": 202604,
        "valor": 407211173.62,
        "delta": 221003266.47
      },
      {
        "periodo": 202605,
        "valor": 225831466.99,
        "delta": -181379706.63
      },
      {
        "periodo": 202606,
        "valor": 286505171.63,
        "delta": 60673704.64
      },
      {
        "periodo": 202607,
        "valor": 298293392.27,
        "delta": 11788220.64
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 52223035.94,
    "valor_anterior": 187460135.82,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 37442726.81,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16188331.6,
        "delta": -21254395.21
      },
      {
        "periodo": 202509,
        "valor": 17813786.29,
        "delta": 1625454.69
      },
      {
        "periodo": 202510,
        "valor": 61700221.35,
        "delta": 43886435.06
      },
      {
        "periodo": 202511,
        "valor": 24370168.58,
        "delta": -37330052.77
      },
      {
        "periodo": 202512,
        "valor": 23416073.72,
        "delta": -954094.86
      },
      {
        "periodo": 202601,
        "valor": 28953622.78,
        "delta": 5537549.06
      },
      {
        "periodo": 202602,
        "valor": 54775446.09,
        "delta": 25821823.31
      },
      {
        "periodo": 202603,
        "valor": 33820105.22,
        "delta": -20955340.87
      },
      {
        "periodo": 202604,
        "valor": 38873183.49,
        "delta": 5053078.27
      },
      {
        "periodo": 202605,
        "valor": 34049862.47,
        "delta": -4823321.02
      },
      {
        "periodo": 202606,
        "valor": 187460135.82,
        "delta": 153410273.35
      },
      {
        "periodo": 202607,
        "valor": 52223035.94,
        "delta": -135237099.88
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100038,
    "label": "Quitas y Castigos Total",
    "valor_actual": 2975878552.8700004,
    "valor_anterior": 3114360074.06,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1575339366.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1571373136.32,
        "delta": -3966229.94
      },
      {
        "periodo": 202509,
        "valor": 1673420201.56,
        "delta": 102047065.24
      },
      {
        "periodo": 202510,
        "valor": 2488873690.6,
        "delta": 815453489.04
      },
      {
        "periodo": 202511,
        "valor": 2015417454.73,
        "delta": -473456235.87
      },
      {
        "periodo": 202512,
        "valor": 1763125085.63,
        "delta": -252292369.1
      },
      {
        "periodo": 202601,
        "valor": 2362066788.6,
        "delta": 598941702.97
      },
      {
        "periodo": 202602,
        "valor": 2077591531.54,
        "delta": -284475257.06
      },
      {
        "periodo": 202603,
        "valor": 2973354124.71,
        "delta": 895762593.17
      },
      {
        "periodo": 202604,
        "valor": 2749570767.41,
        "delta": -223783357.3
      },
      {
        "periodo": 202605,
        "valor": 2734859765.51,
        "delta": -14711001.9
      },
      {
        "periodo": 202606,
        "valor": 3114360074.06,
        "delta": 379500308.55
      },
      {
        "periodo": 202607,
        "valor": 2975878552.87,
        "delta": -138481521.19
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 77054688.24,
    "valor_anterior": 149908048.53,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 90007331.9,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 77440223.28,
        "delta": -12567108.62
      },
      {
        "periodo": 202509,
        "valor": 119170025.75,
        "delta": 41729802.47
      },
      {
        "periodo": 202510,
        "valor": 85061723.96,
        "delta": -34108301.79
      },
      {
        "periodo": 202511,
        "valor": 53655410.06,
        "delta": -31406313.9
      },
      {
        "periodo": 202512,
        "valor": 108548892.67,
        "delta": 54893482.61
      },
      {
        "periodo": 202601,
        "valor": 69808464.19,
        "delta": -38740428.48
      },
      {
        "periodo": 202602,
        "valor": 46104931.33,
        "delta": -23703532.86
      },
      {
        "periodo": 202603,
        "valor": 65897488.13,
        "delta": 19792556.8
      },
      {
        "periodo": 202604,
        "valor": 86559307.07,
        "delta": 20661818.94
      },
      {
        "periodo": 202605,
        "valor": 89152552.18,
        "delta": 2593245.11
      },
      {
        "periodo": 202606,
        "valor": 149908048.53,
        "delta": 60755496.35
      },
      {
        "periodo": 202607,
        "valor": 77054688.24,
        "delta": -72853360.29
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 358223635.0,
    "valor_anterior": 382730297.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 343836808.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 297467509.0,
        "delta": -46369299.0
      },
      {
        "periodo": 202509,
        "valor": 265389152.0,
        "delta": -32078357.0
      },
      {
        "periodo": 202510,
        "valor": 267763600.28,
        "delta": 2374448.28
      },
      {
        "periodo": 202511,
        "valor": 316238476.43,
        "delta": 48474876.15
      },
      {
        "periodo": 202512,
        "valor": 1555471189.57,
        "delta": 1239232713.14
      },
      {
        "periodo": 202601,
        "valor": 314553259.23,
        "delta": -1240917930.34
      },
      {
        "periodo": 202602,
        "valor": 577697889.79,
        "delta": 263144630.56
      },
      {
        "periodo": 202603,
        "valor": 357203340.55,
        "delta": -220494549.24
      },
      {
        "periodo": 202604,
        "valor": 281292598.47,
        "delta": -75910742.08
      },
      {
        "periodo": 202605,
        "valor": 410461832.0,
        "delta": 129169233.53
      },
      {
        "periodo": 202606,
        "valor": 382730297.0,
        "delta": -27731535.0
      },
      {
        "periodo": 202607,
        "valor": 358223635.0,
        "delta": -24506662.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 561015242.0,
    "valor_anterior": 613453765.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 394644411.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 351390757.0,
        "delta": -43253654.0
      },
      {
        "periodo": 202509,
        "valor": 423752368.0,
        "delta": 72361611.0
      },
      {
        "periodo": 202510,
        "valor": 361622423.0,
        "delta": -62129945.0
      },
      {
        "periodo": 202511,
        "valor": 397215508.0,
        "delta": 35593085.0
      },
      {
        "periodo": 202512,
        "valor": 1084794250.0,
        "delta": 687578742.0
      },
      {
        "periodo": 202601,
        "valor": 383723271.0,
        "delta": -701070979.0
      },
      {
        "periodo": 202602,
        "valor": 521371886.0,
        "delta": 137648615.0
      },
      {
        "periodo": 202603,
        "valor": 412345565.0,
        "delta": -109026321.0
      },
      {
        "periodo": 202604,
        "valor": 683187964.0,
        "delta": 270842399.0
      },
      {
        "periodo": 202605,
        "valor": 642404540.0,
        "delta": -40783424.0
      },
      {
        "periodo": 202606,
        "valor": 613453765.0,
        "delta": -28950775.0
      },
      {
        "periodo": 202607,
        "valor": 561015242.0,
        "delta": -52438523.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 58407353.0,
    "valor_anterior": 86910015.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 64003603.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 96459907.0,
        "delta": 32456304.0
      },
      {
        "periodo": 202509,
        "valor": 112612485.0,
        "delta": 16152578.0
      },
      {
        "periodo": 202510,
        "valor": 155680172.0,
        "delta": 43067687.0
      },
      {
        "periodo": 202511,
        "valor": 431554188.0,
        "delta": 275874016.0
      },
      {
        "periodo": 202512,
        "valor": 108025992.0,
        "delta": -323528196.0
      },
      {
        "periodo": 202601,
        "valor": 82857466.0,
        "delta": -25168526.0
      },
      {
        "periodo": 202602,
        "valor": 101039321.0,
        "delta": 18181855.0
      },
      {
        "periodo": 202603,
        "valor": 109664943.0,
        "delta": 8625622.0
      },
      {
        "periodo": 202604,
        "valor": 66541959.0,
        "delta": -43122984.0
      },
      {
        "periodo": 202605,
        "valor": 62445381.0,
        "delta": -4096578.0
      },
      {
        "periodo": 202606,
        "valor": 86910015.0,
        "delta": 24464634.0
      },
      {
        "periodo": 202607,
        "valor": 58407353.0,
        "delta": -28502662.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 67425716.66,
    "valor_anterior": 112265107.66,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 35615244.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 103087044.83,
        "delta": 67471800.64
      },
      {
        "periodo": 202509,
        "valor": 62748518.25,
        "delta": -40338526.58
      },
      {
        "periodo": 202510,
        "valor": 213653248.76,
        "delta": 150904730.51
      },
      {
        "periodo": 202511,
        "valor": 277422336.06,
        "delta": 63769087.3
      },
      {
        "periodo": 202512,
        "valor": 681668816.81,
        "delta": 404246480.75
      },
      {
        "periodo": 202601,
        "valor": 16627941.78,
        "delta": -665040875.03
      },
      {
        "periodo": 202602,
        "valor": 13483303.8,
        "delta": -3144637.98
      },
      {
        "periodo": 202603,
        "valor": 54957954.27,
        "delta": 41474650.47
      },
      {
        "periodo": 202604,
        "valor": 118328196.34,
        "delta": 63370242.07
      },
      {
        "periodo": 202605,
        "valor": 66616039.65,
        "delta": -51712156.69
      },
      {
        "periodo": 202606,
        "valor": 112265107.66,
        "delta": 45649068.01
      },
      {
        "periodo": 202607,
        "valor": 67425716.66,
        "delta": -44839391.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 23636644.0,
    "valor_anterior": 61451544.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26044588.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14064906.0,
        "delta": -11979682.0
      },
      {
        "periodo": 202509,
        "valor": 24950120.0,
        "delta": 10885214.0
      },
      {
        "periodo": 202510,
        "valor": 21719538.0,
        "delta": -3230582.0
      },
      {
        "periodo": 202511,
        "valor": 21578774.0,
        "delta": -140764.0
      },
      {
        "periodo": 202512,
        "valor": 22254226.0,
        "delta": 675452.0
      },
      {
        "periodo": 202601,
        "valor": 24934043.0,
        "delta": 2679817.0
      },
      {
        "periodo": 202602,
        "valor": 16864546.0,
        "delta": -8069497.0
      },
      {
        "periodo": 202603,
        "valor": 25308644.0,
        "delta": 8444098.0
      },
      {
        "periodo": 202604,
        "valor": 70858702.0,
        "delta": 45550058.0
      },
      {
        "periodo": 202605,
        "valor": 21696115.0,
        "delta": -49162587.0
      },
      {
        "periodo": 202606,
        "valor": 61451544.0,
        "delta": 39755429.0
      },
      {
        "periodo": 202607,
        "valor": 23636644.0,
        "delta": -37814900.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 47184288.0,
    "valor_anterior": 4714365.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 51481851.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18848624.0,
        "delta": -32633227.0
      },
      {
        "periodo": 202509,
        "valor": 61679859.0,
        "delta": 42831235.0
      },
      {
        "periodo": 202510,
        "valor": 56147582.0,
        "delta": -5532277.0
      },
      {
        "periodo": 202511,
        "valor": 18722142.0,
        "delta": -37425440.0
      },
      {
        "periodo": 202512,
        "valor": 213820209.0,
        "delta": 195098067.0
      },
      {
        "periodo": 202601,
        "valor": 6828022.0,
        "delta": -206992187.0
      },
      {
        "periodo": 202602,
        "valor": 12905353.0,
        "delta": 6077331.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": -12905353.0
      },
      {
        "periodo": 202604,
        "valor": 16063562.0,
        "delta": 16063562.0
      },
      {
        "periodo": 202605,
        "valor": 8972649.0,
        "delta": -7090913.0
      },
      {
        "periodo": 202606,
        "valor": 4714365.0,
        "delta": -4258284.0
      },
      {
        "periodo": 202607,
        "valor": 47184288.0,
        "delta": 42469923.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 5481530.0,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18124.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2676638.0,
        "delta": 2658514.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": 43516.0,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 121369609.0,
        "delta": 121326093.0
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 278522.0,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 92755550.0,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": 5481530.0,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 22270614.5,
    "valor_anterior": 46021250.47,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7629035.51,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 134040363.7,
        "delta": 126411328.19
      },
      {
        "periodo": 202509,
        "valor": 31353688.94,
        "delta": -102686674.76
      },
      {
        "periodo": 202510,
        "valor": 50084705.08,
        "delta": 18731016.14
      },
      {
        "periodo": 202511,
        "valor": 44616210.32,
        "delta": -5468494.76
      },
      {
        "periodo": 202512,
        "valor": 455597690.0,
        "delta": 410981479.68
      },
      {
        "periodo": 202601,
        "valor": 128341668.97,
        "delta": -327256021.03
      },
      {
        "periodo": 202602,
        "valor": 11166238.42,
        "delta": -117175430.55
      },
      {
        "periodo": 202603,
        "valor": 37870584.51,
        "delta": 26704346.09
      },
      {
        "periodo": 202604,
        "valor": 18004610.85,
        "delta": -19865973.66
      },
      {
        "periodo": 202605,
        "valor": 49104896.03,
        "delta": 31100285.18
      },
      {
        "periodo": 202606,
        "valor": 46021250.47,
        "delta": -3083645.56
      },
      {
        "periodo": 202607,
        "valor": 22270614.5,
        "delta": -23750635.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 2225763.0,
    "valor_anterior": 9070762.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1270365.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 46093435.0,
        "delta": 44823070.0
      },
      {
        "periodo": 202509,
        "valor": 5935317.0,
        "delta": -40158118.0
      },
      {
        "periodo": 202510,
        "valor": 24312864.0,
        "delta": 18377547.0
      },
      {
        "periodo": 202511,
        "valor": 19128975.0,
        "delta": -5183889.0
      },
      {
        "periodo": 202512,
        "valor": 1000266863.0,
        "delta": 981137888.0
      },
      {
        "periodo": 202601,
        "valor": 8472130.0,
        "delta": -991794733.0
      },
      {
        "periodo": 202602,
        "valor": 9106220.0,
        "delta": 634090.0
      },
      {
        "periodo": 202603,
        "valor": 502275.0,
        "delta": -8603945.0
      },
      {
        "periodo": 202604,
        "valor": 14580514.0,
        "delta": 14078239.0
      },
      {
        "periodo": 202605,
        "valor": 1091691.0,
        "delta": -13488823.0
      },
      {
        "periodo": 202606,
        "valor": 9070762.0,
        "delta": 7979071.0
      },
      {
        "periodo": 202607,
        "valor": 2225763.0,
        "delta": -6844999.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 150214081.95,
    "valor_anterior": 195598401.69,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 139023010.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 139907318.58,
        "delta": 884308.19
      },
      {
        "periodo": 202509,
        "valor": 181623816.96,
        "delta": 41716498.38
      },
      {
        "periodo": 202510,
        "valor": 126315126.89,
        "delta": -55308690.07
      },
      {
        "periodo": 202511,
        "valor": 170298454.75,
        "delta": 43983327.86
      },
      {
        "periodo": 202512,
        "valor": 280985867.26,
        "delta": 110687412.51
      },
      {
        "periodo": 202601,
        "valor": 127796476.69,
        "delta": -153189390.57
      },
      {
        "periodo": 202602,
        "valor": 145235994.84,
        "delta": 17439518.15
      },
      {
        "periodo": 202603,
        "valor": 116415874.82,
        "delta": -28820120.02
      },
      {
        "periodo": 202604,
        "valor": 130157944.08,
        "delta": 13742069.26
      },
      {
        "periodo": 202605,
        "valor": 127293419.8,
        "delta": -2864524.28
      },
      {
        "periodo": 202606,
        "valor": 195598401.69,
        "delta": 68304981.89
      },
      {
        "periodo": 202607,
        "valor": 150214081.95,
        "delta": -45384319.74
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 34923204.38,
    "valor_anterior": 101364295.67,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 886803.41,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10957587.58,
        "delta": 10070784.17
      },
      {
        "periodo": 202509,
        "valor": 2297372.96,
        "delta": -8660214.62
      },
      {
        "periodo": 202510,
        "valor": 73335330.19,
        "delta": 71037957.23
      },
      {
        "periodo": 202511,
        "valor": 84872289.02,
        "delta": 11536958.83
      },
      {
        "periodo": 202512,
        "valor": 246996799.42,
        "delta": 162124510.4
      },
      {
        "periodo": 202601,
        "valor": 6258223.09,
        "delta": -240738576.33
      },
      {
        "periodo": 202602,
        "valor": 2648259.33,
        "delta": -3609963.76
      },
      {
        "periodo": 202603,
        "valor": 3146088.0,
        "delta": 497828.67
      },
      {
        "periodo": 202604,
        "valor": 525349.1,
        "delta": -2620738.9
      },
      {
        "periodo": 202605,
        "valor": 4551819.02,
        "delta": 4026469.92
      },
      {
        "periodo": 202606,
        "valor": 101364295.67,
        "delta": 96812476.65
      },
      {
        "periodo": 202607,
        "valor": 34923204.38,
        "delta": -66441091.29
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 18158286.0,
    "valor_anterior": 11839939.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 36000.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12239851.0,
        "delta": 12203851.0
      },
      {
        "periodo": 202509,
        "valor": 14784702.0,
        "delta": 2544851.0
      },
      {
        "periodo": 202510,
        "valor": 74299872.0,
        "delta": 59515170.0
      },
      {
        "periodo": 202511,
        "valor": 54256478.0,
        "delta": -20043394.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": -54256478.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 9103385.0,
        "delta": 9103385.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": -9103385.0
      },
      {
        "periodo": 202604,
        "valor": 127584246.0,
        "delta": 127584246.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": -127584246.0
      },
      {
        "periodo": 202606,
        "valor": 11839939.0,
        "delta": 11839939.0
      },
      {
        "periodo": 202607,
        "valor": 18158286.0,
        "delta": 6318347.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 103821506.07,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 103821506.07,
        "delta": 103821506.07
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": -103821506.07
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4368387.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -4368387.0
      },
      {
        "periodo": 202509,
        "valor": 15986663.0,
        "delta": 15986663.0
      },
      {
        "periodo": 202510,
        "valor": 98069500.0,
        "delta": 82082837.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": -98069500.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 1589105.0,
        "delta": 1589105.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -1589105.0
      },
      {
        "periodo": 202603,
        "valor": 1176008.0,
        "delta": 1176008.0
      },
      {
        "periodo": 202604,
        "valor": 685512.0,
        "delta": -490496.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": -685512.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 667003082.97,
        "delta": 667003082.97
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": -667003082.97
      },
      {
        "periodo": 202512,
        "valor": 71702494.37,
        "delta": 71702494.37
      },
      {
        "periodo": 202601,
        "valor": 223899.91,
        "delta": -71478594.46
      },
      {
        "periodo": 202602,
        "valor": 160660.33,
        "delta": -63239.58
      },
      {
        "periodo": 202603,
        "valor": 15976.47,
        "delta": -144683.86
      },
      {
        "periodo": 202604,
        "valor": 26976.69,
        "delta": 11000.22
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": -26976.69
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8109433.79,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18684366.05,
        "delta": 10574932.26
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -18684366.05
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 2982169.32,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17028224.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 382364.01,
        "delta": -16645860.81
      },
      {
        "periodo": 202509,
        "valor": 482940.92,
        "delta": 100576.91
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": -482940.92
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 309389.02,
        "delta": 309389.02
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -309389.02
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 2982169.32,
        "delta": 2982169.32
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 12254327.49,
    "valor_anterior": 31181606.67,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 456688.8,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -456688.8
      },
      {
        "periodo": 202509,
        "valor": 45652.15,
        "delta": 45652.15
      },
      {
        "periodo": 202510,
        "valor": 103171.0,
        "delta": 57518.85
      },
      {
        "periodo": 202511,
        "valor": 1069941.27,
        "delta": 966770.27
      },
      {
        "periodo": 202512,
        "valor": 308018.13,
        "delta": -761923.14
      },
      {
        "periodo": 202601,
        "valor": 1083359.78,
        "delta": 775341.65
      },
      {
        "periodo": 202602,
        "valor": 131071.09,
        "delta": -952288.69
      },
      {
        "periodo": 202603,
        "valor": 1348130.22,
        "delta": 1217059.13
      },
      {
        "periodo": 202604,
        "valor": 6812981.49,
        "delta": 5464851.27
      },
      {
        "periodo": 202605,
        "valor": 1357937.47,
        "delta": -5455044.02
      },
      {
        "periodo": 202606,
        "valor": 31181606.67,
        "delta": 29823669.2
      },
      {
        "periodo": 202607,
        "valor": 12254327.49,
        "delta": -18927279.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 29244836.0,
        "delta": 29244836.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": -29244836.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 3705933.67,
    "valor_anterior": 3743941.12,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 545154.17,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 4381658.38,
        "delta": 3836504.21
      },
      {
        "periodo": 202604,
        "valor": 2998865.39,
        "delta": -1382792.99
      },
      {
        "periodo": 202605,
        "valor": 2438936.84,
        "delta": -559928.55
      },
      {
        "periodo": 202606,
        "valor": 3743941.12,
        "delta": 1305004.28
      },
      {
        "periodo": 202607,
        "valor": 3705933.67,
        "delta": -38007.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 1445163477.21,
    "valor_anterior": 1914074844.88,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1184459909.81,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1323740895.03,
        "delta": 139280985.22
      },
      {
        "periodo": 202509,
        "valor": 1322812681.93,
        "delta": -928213.1
      },
      {
        "periodo": 202510,
        "valor": 2275215456.13,
        "delta": 952402774.2
      },
      {
        "periodo": 202511,
        "valor": 2011998791.91,
        "delta": -263216664.22
      },
      {
        "periodo": 202512,
        "valor": 5830750697.25,
        "delta": 3818751905.34
      },
      {
        "periodo": 202601,
        "valor": 1173097330.64,
        "delta": -4657653366.61
      },
      {
        "periodo": 202602,
        "valor": 1497087572.1,
        "delta": 323990241.46
      },
      {
        "periodo": 202603,
        "valor": 1190234530.35,
        "delta": -306853041.75
      },
      {
        "periodo": 202604,
        "valor": 1716964838.48,
        "delta": 526730308.13
      },
      {
        "periodo": 202605,
        "valor": 1487587808.99,
        "delta": -229377029.49
      },
      {
        "periodo": 202606,
        "valor": 1914074844.88,
        "delta": 426487035.89
      },
      {
        "periodo": 202607,
        "valor": 1445163477.21,
        "delta": -468911367.67
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 1234033174.19,
    "valor_anterior": 1490052071.22,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1057577876.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 979407258.86,
        "delta": -78170617.43
      },
      {
        "periodo": 202509,
        "valor": 1127497967.71,
        "delta": 148090708.85
      },
      {
        "periodo": 202510,
        "valor": 1018206100.13,
        "delta": -109291867.58
      },
      {
        "periodo": 202511,
        "valor": 1511910420.24,
        "delta": 493704320.11
      },
      {
        "periodo": 202512,
        "valor": 3160080417.5,
        "delta": 1648169997.26
      },
      {
        "periodo": 202601,
        "valor": 1003672980.11,
        "delta": -2156407437.39
      },
      {
        "periodo": 202602,
        "valor": 1408593090.96,
        "delta": 404920110.85
      },
      {
        "periodo": 202603,
        "valor": 1086835855.5,
        "delta": -321757235.46
      },
      {
        "periodo": 202604,
        "valor": 1411354024.62,
        "delta": 324518169.12
      },
      {
        "periodo": 202605,
        "valor": 1353453839.98,
        "delta": -57900184.64
      },
      {
        "periodo": 202606,
        "valor": 1490052071.22,
        "delta": 136598231.24
      },
      {
        "periodo": 202607,
        "valor": 1234033174.19,
        "delta": -256018897.03
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 34923204.38,
    "valor_anterior": 101364295.67,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8996237.2,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29641953.63,
        "delta": 20645716.43
      },
      {
        "periodo": 202509,
        "valor": 2297372.96,
        "delta": -27344580.67
      },
      {
        "periodo": 202510,
        "valor": 73335330.19,
        "delta": 71037957.23
      },
      {
        "periodo": 202511,
        "valor": 84872289.02,
        "delta": 11536958.83
      },
      {
        "periodo": 202512,
        "valor": 246996799.42,
        "delta": 162124510.4
      },
      {
        "periodo": 202601,
        "valor": 6258223.09,
        "delta": -240738576.33
      },
      {
        "periodo": 202602,
        "valor": 2648259.33,
        "delta": -3609963.76
      },
      {
        "periodo": 202603,
        "valor": 3146088.0,
        "delta": 497828.67
      },
      {
        "periodo": 202604,
        "valor": 525349.1,
        "delta": -2620738.9
      },
      {
        "periodo": 202605,
        "valor": 4551819.02,
        "delta": 4026469.92
      },
      {
        "periodo": 202606,
        "valor": 101364295.67,
        "delta": 96812476.65
      },
      {
        "periodo": 202607,
        "valor": 34923204.38,
        "delta": -66441091.29
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 2225763.0,
    "valor_anterior": 9070762.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1270365.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 46093435.0,
        "delta": 44823070.0
      },
      {
        "periodo": 202509,
        "valor": 5935317.0,
        "delta": -40158118.0
      },
      {
        "periodo": 202510,
        "valor": 24312864.0,
        "delta": 18377547.0
      },
      {
        "periodo": 202511,
        "valor": 19128975.0,
        "delta": -5183889.0
      },
      {
        "periodo": 202512,
        "valor": 1000266863.0,
        "delta": 981137888.0
      },
      {
        "periodo": 202601,
        "valor": 8472130.0,
        "delta": -991794733.0
      },
      {
        "periodo": 202602,
        "valor": 9106220.0,
        "delta": 634090.0
      },
      {
        "periodo": 202603,
        "valor": 502275.0,
        "delta": -8603945.0
      },
      {
        "periodo": 202604,
        "valor": 14580514.0,
        "delta": 14078239.0
      },
      {
        "periodo": 202605,
        "valor": 1091691.0,
        "delta": -13488823.0
      },
      {
        "periodo": 202606,
        "valor": 9070762.0,
        "delta": 7979071.0
      },
      {
        "periodo": 202607,
        "valor": 2225763.0,
        "delta": -6844999.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 155038905.16,
    "valor_anterior": 174840662.13,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 99130517.7,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 268215883.53,
        "delta": 169085365.83
      },
      {
        "periodo": 202509,
        "valor": 186553431.19,
        "delta": -81662452.34
      },
      {
        "periodo": 202510,
        "valor": 492254907.84,
        "delta": 305701476.65
      },
      {
        "periodo": 202511,
        "valor": 395017166.38,
        "delta": -97237741.46
      },
      {
        "periodo": 202512,
        "valor": 1351086715.81,
        "delta": 956069549.43
      },
      {
        "periodo": 202601,
        "valor": 153386737.75,
        "delta": -1197699978.06
      },
      {
        "periodo": 202602,
        "valor": 46658280.22,
        "delta": -106728457.53
      },
      {
        "periodo": 202603,
        "valor": 94004546.78,
        "delta": 47346266.56
      },
      {
        "periodo": 202604,
        "valor": 280666127.19,
        "delta": 186661580.41
      },
      {
        "periodo": 202605,
        "valor": 124693584.68,
        "delta": -155972542.51
      },
      {
        "periodo": 202606,
        "valor": 174840662.13,
        "delta": 50147077.45
      },
      {
        "periodo": 202607,
        "valor": 155038905.16,
        "delta": -19801756.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 15236496.81,
    "valor_anterior": 135003112.74,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17484913.62,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 382364.01,
        "delta": -17102549.61
      },
      {
        "periodo": 202509,
        "valor": 528593.07,
        "delta": 146229.06
      },
      {
        "periodo": 202510,
        "valor": 103171.0,
        "delta": -425422.07
      },
      {
        "periodo": 202511,
        "valor": 1069941.27,
        "delta": 966770.27
      },
      {
        "periodo": 202512,
        "valor": 617407.15,
        "delta": -452534.12
      },
      {
        "periodo": 202601,
        "valor": 1083359.78,
        "delta": 465952.63
      },
      {
        "periodo": 202602,
        "valor": 29375907.09,
        "delta": 28292547.31
      },
      {
        "periodo": 202603,
        "valor": 1348130.22,
        "delta": -28027776.87
      },
      {
        "periodo": 202604,
        "valor": 6812981.49,
        "delta": 5464851.27
      },
      {
        "periodo": 202605,
        "valor": 1357937.47,
        "delta": -5455044.02
      },
      {
        "periodo": 202606,
        "valor": 135003112.74,
        "delta": 133645175.27
      },
      {
        "periodo": 202607,
        "valor": 15236496.81,
        "delta": -119766615.93
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100039,
    "label": "Quitas y Castigos Comercial",
    "valor_actual": 3705933.67,
    "valor_anterior": 3743941.12,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 667003082.97,
        "delta": 667003082.97
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": -667003082.97
      },
      {
        "periodo": 202512,
        "valor": 71702494.37,
        "delta": 71702494.37
      },
      {
        "periodo": 202601,
        "valor": 223899.91,
        "delta": -71478594.46
      },
      {
        "periodo": 202602,
        "valor": 705814.5,
        "delta": 481914.59
      },
      {
        "periodo": 202603,
        "valor": 4397634.85,
        "delta": 3691820.35
      },
      {
        "periodo": 202604,
        "valor": 3025842.08,
        "delta": -1371792.77
      },
      {
        "periodo": 202605,
        "valor": 2438936.84,
        "delta": -586905.24
      },
      {
        "periodo": 202606,
        "valor": 3743941.12,
        "delta": 1305004.28
      },
      {
        "periodo": 202607,
        "valor": 3705933.67,
        "delta": -38007.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 2326712565.98,
    "valor_anterior": 2376341200.45,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1823889610.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1867435014.91,
        "delta": 43545404.76
      },
      {
        "periodo": 202509,
        "valor": 1980097210.68,
        "delta": 112662195.77
      },
      {
        "periodo": 202510,
        "valor": 1967493998.57,
        "delta": -12603212.11
      },
      {
        "periodo": 202511,
        "valor": 2083741670.68,
        "delta": 116247672.11
      },
      {
        "periodo": 202512,
        "valor": 2180165335.84,
        "delta": 96423665.16
      },
      {
        "periodo": 202601,
        "valor": 2156681031.85,
        "delta": -23484303.99
      },
      {
        "periodo": 202602,
        "valor": 2037292833.78,
        "delta": -119388198.07
      },
      {
        "periodo": 202603,
        "valor": 2498435216.92,
        "delta": 461142383.14
      },
      {
        "periodo": 202604,
        "valor": 2353690568.03,
        "delta": -144744648.89
      },
      {
        "periodo": 202605,
        "valor": 2205279655.44,
        "delta": -148410912.59
      },
      {
        "periodo": 202606,
        "valor": 2376341200.45,
        "delta": 171061545.01
      },
      {
        "periodo": 202607,
        "valor": 2326712565.98,
        "delta": -49628634.47
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 4791792970.0,
    "valor_anterior": 4690523782.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4258206710.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4077076480.0,
        "delta": -181130230.0
      },
      {
        "periodo": 202509,
        "valor": 4222843384.0,
        "delta": 145766904.0
      },
      {
        "periodo": 202510,
        "valor": 4373203802.0,
        "delta": 150360418.0
      },
      {
        "periodo": 202511,
        "valor": 5330293041.66,
        "delta": 957089239.66
      },
      {
        "periodo": 202512,
        "valor": 4712465392.67,
        "delta": -617827648.99
      },
      {
        "periodo": 202601,
        "valor": 4925043279.66,
        "delta": 212577886.99
      },
      {
        "periodo": 202602,
        "valor": 5015522329.4,
        "delta": 90479049.74
      },
      {
        "periodo": 202603,
        "valor": 4903347815.14,
        "delta": -112174514.26
      },
      {
        "periodo": 202604,
        "valor": 4852789091.46,
        "delta": -50558723.68
      },
      {
        "periodo": 202605,
        "valor": 4811017456.0,
        "delta": -41771635.46
      },
      {
        "periodo": 202606,
        "valor": 4690523782.0,
        "delta": -120493674.0
      },
      {
        "periodo": 202607,
        "valor": 4791792970.0,
        "delta": 101269188.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 1980879430.0,
    "valor_anterior": 1643843948.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1866246045.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2051200095.0,
        "delta": 184954050.0
      },
      {
        "periodo": 202509,
        "valor": 1771109386.0,
        "delta": -280090709.0
      },
      {
        "periodo": 202510,
        "valor": 1713240357.0,
        "delta": -57869029.0
      },
      {
        "periodo": 202511,
        "valor": 1577501395.0,
        "delta": -135738962.0
      },
      {
        "periodo": 202512,
        "valor": 1812295767.0,
        "delta": 234794372.0
      },
      {
        "periodo": 202601,
        "valor": 1750317793.0,
        "delta": -61977974.0
      },
      {
        "periodo": 202602,
        "valor": 1562512951.0,
        "delta": -187804842.0
      },
      {
        "periodo": 202603,
        "valor": 1836741957.0,
        "delta": 274229006.0
      },
      {
        "periodo": 202604,
        "valor": 1723463809.0,
        "delta": -113278148.0
      },
      {
        "periodo": 202605,
        "valor": 1641165801.0,
        "delta": -82298008.0
      },
      {
        "periodo": 202606,
        "valor": 1643843948.0,
        "delta": 2678147.0
      },
      {
        "periodo": 202607,
        "valor": 1980879430.0,
        "delta": 337035482.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 995245466.0,
    "valor_anterior": 983009554.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1127336219.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 925670517.0,
        "delta": -201665702.0
      },
      {
        "periodo": 202509,
        "valor": 1081009647.0,
        "delta": 155339130.0
      },
      {
        "periodo": 202510,
        "valor": 1022272890.0,
        "delta": -58736757.0
      },
      {
        "periodo": 202511,
        "valor": 1123200092.0,
        "delta": 100927202.0
      },
      {
        "periodo": 202512,
        "valor": 1048301076.0,
        "delta": -74899016.0
      },
      {
        "periodo": 202601,
        "valor": 1077689919.0,
        "delta": 29388843.0
      },
      {
        "periodo": 202602,
        "valor": 1008465776.0,
        "delta": -69224143.0
      },
      {
        "periodo": 202603,
        "valor": 1063486280.0,
        "delta": 55020504.0
      },
      {
        "periodo": 202604,
        "valor": 1040290924.0,
        "delta": -23195356.0
      },
      {
        "periodo": 202605,
        "valor": 900229165.0,
        "delta": -140061759.0
      },
      {
        "periodo": 202606,
        "valor": 983009554.0,
        "delta": 82780389.0
      },
      {
        "periodo": 202607,
        "valor": 995245466.0,
        "delta": 12235912.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 82339256.08,
    "valor_anterior": 61998257.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 72968361.33,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 73155997.34,
        "delta": 187636.01
      },
      {
        "periodo": 202509,
        "valor": 70008637.07,
        "delta": -3147360.27
      },
      {
        "periodo": 202510,
        "valor": 68188332.31,
        "delta": -1820304.76
      },
      {
        "periodo": 202511,
        "valor": 78949247.51,
        "delta": 10760915.2
      },
      {
        "periodo": 202512,
        "valor": 73224139.43,
        "delta": -5725108.08
      },
      {
        "periodo": 202601,
        "valor": 72374467.5,
        "delta": -849671.93
      },
      {
        "periodo": 202602,
        "valor": 65205512.15,
        "delta": -7168955.35
      },
      {
        "periodo": 202603,
        "valor": 61807214.52,
        "delta": -3398297.63
      },
      {
        "periodo": 202604,
        "valor": 79314701.14,
        "delta": 17507486.62
      },
      {
        "periodo": 202605,
        "valor": 63809588.5,
        "delta": -15505112.64
      },
      {
        "periodo": 202606,
        "valor": 61998257.25,
        "delta": -1811331.25
      },
      {
        "periodo": 202607,
        "valor": 82339256.08,
        "delta": 20340998.83
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 482985289.0,
    "valor_anterior": 524473781.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 401639272.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 367590193.0,
        "delta": -34049079.0
      },
      {
        "periodo": 202509,
        "valor": 394670257.0,
        "delta": 27080064.0
      },
      {
        "periodo": 202510,
        "valor": 469798450.0,
        "delta": 75128193.0
      },
      {
        "periodo": 202511,
        "valor": 449105943.0,
        "delta": -20692507.0
      },
      {
        "periodo": 202512,
        "valor": 469546919.0,
        "delta": 20440976.0
      },
      {
        "periodo": 202601,
        "valor": 462240113.0,
        "delta": -7306806.0
      },
      {
        "periodo": 202602,
        "valor": 463626164.0,
        "delta": 1386051.0
      },
      {
        "periodo": 202603,
        "valor": 470279907.0,
        "delta": 6653743.0
      },
      {
        "periodo": 202604,
        "valor": 461556065.0,
        "delta": -8723842.0
      },
      {
        "periodo": 202605,
        "valor": 461834062.0,
        "delta": 277997.0
      },
      {
        "periodo": 202606,
        "valor": 524473781.0,
        "delta": 62639719.0
      },
      {
        "periodo": 202607,
        "valor": 482985289.0,
        "delta": -41488492.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 16050327.0,
    "valor_anterior": 10939969.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 774303.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2898726.0,
        "delta": 2124423.0
      },
      {
        "periodo": 202509,
        "valor": 4690768.0,
        "delta": 1792042.0
      },
      {
        "periodo": 202510,
        "valor": 7779004.0,
        "delta": 3088236.0
      },
      {
        "periodo": 202511,
        "valor": 4722608.0,
        "delta": -3056396.0
      },
      {
        "periodo": 202512,
        "valor": 4567345.0,
        "delta": -155263.0
      },
      {
        "periodo": 202601,
        "valor": 5714561.0,
        "delta": 1147216.0
      },
      {
        "periodo": 202602,
        "valor": 6937399.0,
        "delta": 1222838.0
      },
      {
        "periodo": 202603,
        "valor": 5332455.0,
        "delta": -1604944.0
      },
      {
        "periodo": 202604,
        "valor": 1133458.0,
        "delta": -4198997.0
      },
      {
        "periodo": 202605,
        "valor": 708521.0,
        "delta": -424937.0
      },
      {
        "periodo": 202606,
        "valor": 10939969.0,
        "delta": 10231448.0
      },
      {
        "periodo": 202607,
        "valor": 16050327.0,
        "delta": 5110358.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 341996597.0,
    "valor_anterior": 343910499.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 309472958.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 334910381.0,
        "delta": 25437423.0
      },
      {
        "periodo": 202509,
        "valor": 396511315.0,
        "delta": 61600934.0
      },
      {
        "periodo": 202510,
        "valor": 318635560.0,
        "delta": -77875755.0
      },
      {
        "periodo": 202511,
        "valor": 238753732.0,
        "delta": -79881828.0
      },
      {
        "periodo": 202512,
        "valor": 475243452.0,
        "delta": 236489720.0
      },
      {
        "periodo": 202601,
        "valor": 371057082.0,
        "delta": -104186370.0
      },
      {
        "periodo": 202602,
        "valor": 259902666.0,
        "delta": -111154416.0
      },
      {
        "periodo": 202603,
        "valor": 402145095.0,
        "delta": 142242429.0
      },
      {
        "periodo": 202604,
        "valor": 393243658.0,
        "delta": -8901437.0
      },
      {
        "periodo": 202605,
        "valor": 331833520.0,
        "delta": -61410138.0
      },
      {
        "periodo": 202606,
        "valor": 343910499.0,
        "delta": 12076979.0
      },
      {
        "periodo": 202607,
        "valor": 341996597.0,
        "delta": -1913902.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 38884423.72,
    "valor_anterior": 31605497.41,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 70675035.32,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 68848564.98,
        "delta": -1826470.34
      },
      {
        "periodo": 202509,
        "valor": 71417302.9,
        "delta": 2568737.92
      },
      {
        "periodo": 202510,
        "valor": 79424753.41,
        "delta": 8007450.51
      },
      {
        "periodo": 202511,
        "valor": 59850649.61,
        "delta": -19574103.8
      },
      {
        "periodo": 202512,
        "valor": 64295856.64,
        "delta": 4445207.03
      },
      {
        "periodo": 202601,
        "valor": 81537418.93,
        "delta": 17241562.29
      },
      {
        "periodo": 202602,
        "valor": 42413741.46,
        "delta": -39123677.47
      },
      {
        "periodo": 202603,
        "valor": 23384098.52,
        "delta": -19029642.94
      },
      {
        "periodo": 202604,
        "valor": 33404753.09,
        "delta": 10020654.57
      },
      {
        "periodo": 202605,
        "valor": 34715590.12,
        "delta": 1310837.03
      },
      {
        "periodo": 202606,
        "valor": 31605497.41,
        "delta": -3110092.71
      },
      {
        "periodo": 202607,
        "valor": 38884423.72,
        "delta": 7278926.31
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 457374190.0,
    "valor_anterior": 423165524.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 347133895.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 331540663.0,
        "delta": -15593232.0
      },
      {
        "periodo": 202509,
        "valor": 316017523.0,
        "delta": -15523140.0
      },
      {
        "periodo": 202510,
        "valor": 383206751.0,
        "delta": 67189228.0
      },
      {
        "periodo": 202511,
        "valor": 318008359.0,
        "delta": -65198392.0
      },
      {
        "periodo": 202512,
        "valor": 351875741.0,
        "delta": 33867382.0
      },
      {
        "periodo": 202601,
        "valor": 248091474.0,
        "delta": -103784267.0
      },
      {
        "periodo": 202602,
        "valor": 398868771.0,
        "delta": 150777297.0
      },
      {
        "periodo": 202603,
        "valor": 414115129.0,
        "delta": 15246358.0
      },
      {
        "periodo": 202604,
        "valor": 412537127.0,
        "delta": -1578002.0
      },
      {
        "periodo": 202605,
        "valor": 399732879.0,
        "delta": -12804248.0
      },
      {
        "periodo": 202606,
        "valor": 423165524.0,
        "delta": 23432645.0
      },
      {
        "periodo": 202607,
        "valor": 457374190.0,
        "delta": 34208666.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 125611.0,
        "delta": 125611.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": -125611.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 128245815.0,
    "valor_anterior": 109420299.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 139711049.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 91198615.0,
        "delta": -48512434.0
      },
      {
        "periodo": 202509,
        "valor": 112912876.0,
        "delta": 21714261.0
      },
      {
        "periodo": 202510,
        "valor": 146091129.0,
        "delta": 33178253.0
      },
      {
        "periodo": 202511,
        "valor": 84914676.0,
        "delta": -61176453.0
      },
      {
        "periodo": 202512,
        "valor": 103613964.0,
        "delta": 18699288.0
      },
      {
        "periodo": 202601,
        "valor": 120253545.0,
        "delta": 16639581.0
      },
      {
        "periodo": 202602,
        "valor": 109953228.0,
        "delta": -10300317.0
      },
      {
        "periodo": 202603,
        "valor": 131928923.0,
        "delta": 21975695.0
      },
      {
        "periodo": 202604,
        "valor": 124230266.0,
        "delta": -7698657.0
      },
      {
        "periodo": 202605,
        "valor": 109365179.0,
        "delta": -14865087.0
      },
      {
        "periodo": 202606,
        "valor": 109420299.0,
        "delta": 55120.0
      },
      {
        "periodo": 202607,
        "valor": 128245815.0,
        "delta": 18825516.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 1818085018.02,
    "valor_anterior": 1648581061.49,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1443346251.49,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1562079715.43,
        "delta": 118733463.94
      },
      {
        "periodo": 202509,
        "valor": 1453242573.48,
        "delta": -108837141.95
      },
      {
        "periodo": 202510,
        "valor": 1495272500.52,
        "delta": 42029927.04
      },
      {
        "periodo": 202511,
        "valor": 1366746742.48,
        "delta": -128525758.04
      },
      {
        "periodo": 202512,
        "valor": 1623110366.28,
        "delta": 256363623.8
      },
      {
        "periodo": 202601,
        "valor": 1771043160.49,
        "delta": 147932794.21
      },
      {
        "periodo": 202602,
        "valor": 1973897251.19,
        "delta": 202854090.7
      },
      {
        "periodo": 202603,
        "valor": 1875076734.8,
        "delta": -98820516.39
      },
      {
        "periodo": 202604,
        "valor": 1714583395.1,
        "delta": -160493339.7
      },
      {
        "periodo": 202605,
        "valor": 1718126914.56,
        "delta": 3543519.46
      },
      {
        "periodo": 202606,
        "valor": 1648581061.49,
        "delta": -69545853.07
      },
      {
        "periodo": 202607,
        "valor": 1818085018.02,
        "delta": 169503956.53
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 9872.0,
        "delta": 9872.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": -9872.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 2053711882.59,
    "valor_anterior": 1723350740.39,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 987234700.21,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1030824148.25,
        "delta": 43589448.04
      },
      {
        "periodo": 202509,
        "valor": 1155258244.65,
        "delta": 124434096.4
      },
      {
        "periodo": 202510,
        "valor": 1241380333.89,
        "delta": 86122089.24
      },
      {
        "periodo": 202511,
        "valor": 1440086259.99,
        "delta": 198705926.1
      },
      {
        "periodo": 202512,
        "valor": 1144779649.81,
        "delta": -295306610.18
      },
      {
        "periodo": 202601,
        "valor": 1606872731.37,
        "delta": 462093081.56
      },
      {
        "periodo": 202602,
        "valor": 1388499963.17,
        "delta": -218372768.2
      },
      {
        "periodo": 202603,
        "valor": 1703754746.88,
        "delta": 315254783.71
      },
      {
        "periodo": 202604,
        "valor": 1740891305.66,
        "delta": 37136558.78
      },
      {
        "periodo": 202605,
        "valor": 1802582465.09,
        "delta": 61691159.43
      },
      {
        "periodo": 202606,
        "valor": 1723350740.39,
        "delta": -79231724.7
      },
      {
        "periodo": 202607,
        "valor": 2053711882.59,
        "delta": 330361142.2
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 722420.79,
    "valor_anterior": 18456113.74,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5423306.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -5423306.19
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 18456113.74,
        "delta": 18456113.74
      },
      {
        "periodo": 202607,
        "valor": 722420.79,
        "delta": -17733692.95
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 792899789.0,
    "valor_anterior": 730496473.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 494375426.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 463314818.0,
        "delta": -31060608.0
      },
      {
        "periodo": 202509,
        "valor": 451663902.0,
        "delta": -11650916.0
      },
      {
        "periodo": 202510,
        "valor": 520818882.0,
        "delta": 69154980.0
      },
      {
        "periodo": 202511,
        "valor": 512823930.0,
        "delta": -7994952.0
      },
      {
        "periodo": 202512,
        "valor": 480416710.0,
        "delta": -32407220.0
      },
      {
        "periodo": 202601,
        "valor": 660824535.0,
        "delta": 180407825.0
      },
      {
        "periodo": 202602,
        "valor": 572243194.0,
        "delta": -88581341.0
      },
      {
        "periodo": 202603,
        "valor": 621325147.0,
        "delta": 49081953.0
      },
      {
        "periodo": 202604,
        "valor": 905095524.0,
        "delta": 283770377.0
      },
      {
        "periodo": 202605,
        "valor": 757047490.0,
        "delta": -148048034.0
      },
      {
        "periodo": 202606,
        "valor": 730496473.0,
        "delta": -26551017.0
      },
      {
        "periodo": 202607,
        "valor": 792899789.0,
        "delta": 62403316.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 19.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10.0,
        "delta": -9.0
      },
      {
        "periodo": 202509,
        "valor": 2682413.0,
        "delta": 2682403.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": -2682413.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 4.0,
        "delta": 4.0
      },
      {
        "periodo": 202601,
        "valor": 7182.0,
        "delta": 7178.0
      },
      {
        "periodo": 202602,
        "valor": 27765005.0,
        "delta": 27757823.0
      },
      {
        "periodo": 202603,
        "valor": 23028.0,
        "delta": -27741977.0
      },
      {
        "periodo": 202604,
        "valor": 11.0,
        "delta": -23017.0
      },
      {
        "periodo": 202605,
        "valor": 13.0,
        "delta": 2.0
      },
      {
        "periodo": 202606,
        "valor": 19.0,
        "delta": 6.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": -19.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 10753305.59,
    "valor_anterior": 17049907.61,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15550975.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11311305.34,
        "delta": -4239669.85
      },
      {
        "periodo": 202509,
        "valor": 10525924.33,
        "delta": -785381.01
      },
      {
        "periodo": 202510,
        "valor": 12217147.72,
        "delta": 1691223.39
      },
      {
        "periodo": 202511,
        "valor": 11869570.09,
        "delta": -347577.63
      },
      {
        "periodo": 202512,
        "valor": 3840097.48,
        "delta": -8029472.61
      },
      {
        "periodo": 202601,
        "valor": 15772925.72,
        "delta": 11932828.24
      },
      {
        "periodo": 202602,
        "valor": 12499620.39,
        "delta": -3273305.33
      },
      {
        "periodo": 202603,
        "valor": 94840450.78,
        "delta": 82340830.39
      },
      {
        "periodo": 202604,
        "valor": 14218262.02,
        "delta": -80622188.76
      },
      {
        "periodo": 202605,
        "valor": 17539208.79,
        "delta": 3320946.77
      },
      {
        "periodo": 202606,
        "valor": 17049907.61,
        "delta": -489301.18
      },
      {
        "periodo": 202607,
        "valor": 10753305.59,
        "delta": -6296602.02
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 33282288.0,
    "valor_anterior": 31019079.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14534507.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15733416.0,
        "delta": 1198909.0
      },
      {
        "periodo": 202509,
        "valor": 17213561.0,
        "delta": 1480145.0
      },
      {
        "periodo": 202510,
        "valor": 18397364.0,
        "delta": 1183803.0
      },
      {
        "periodo": 202511,
        "valor": 21307467.0,
        "delta": 2910103.0
      },
      {
        "periodo": 202512,
        "valor": 22719048.0,
        "delta": 1411581.0
      },
      {
        "periodo": 202601,
        "valor": 27870263.0,
        "delta": 5151215.0
      },
      {
        "periodo": 202602,
        "valor": 25399539.0,
        "delta": -2470724.0
      },
      {
        "periodo": 202603,
        "valor": 32471975.0,
        "delta": 7072436.0
      },
      {
        "periodo": 202604,
        "valor": 32060202.0,
        "delta": -411773.0
      },
      {
        "periodo": 202605,
        "valor": 32691925.0,
        "delta": 631723.0
      },
      {
        "periodo": 202606,
        "valor": 31019079.0,
        "delta": -1672846.0
      },
      {
        "periodo": 202607,
        "valor": 33282288.0,
        "delta": 2263209.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 50957342.0,
    "valor_anterior": 23415529.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 44451485.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 53462216.0,
        "delta": 9010731.0
      },
      {
        "periodo": 202509,
        "valor": 42053085.0,
        "delta": -11409131.0
      },
      {
        "periodo": 202510,
        "valor": 36686395.0,
        "delta": -5366690.0
      },
      {
        "periodo": 202511,
        "valor": 36871592.0,
        "delta": 185197.0
      },
      {
        "periodo": 202512,
        "valor": 35982033.0,
        "delta": -889559.0
      },
      {
        "periodo": 202601,
        "valor": 46003141.0,
        "delta": 10021108.0
      },
      {
        "periodo": 202602,
        "valor": 32442951.0,
        "delta": -13560190.0
      },
      {
        "periodo": 202603,
        "valor": 66184402.0,
        "delta": 33741451.0
      },
      {
        "periodo": 202604,
        "valor": 25132857.0,
        "delta": -41051545.0
      },
      {
        "periodo": 202605,
        "valor": 97980791.0,
        "delta": 72847934.0
      },
      {
        "periodo": 202606,
        "valor": 23415529.0,
        "delta": -74565262.0
      },
      {
        "periodo": 202607,
        "valor": 50957342.0,
        "delta": 27541813.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 34611483.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17491656.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 519835.0,
        "delta": -16971821.0
      },
      {
        "periodo": 202509,
        "valor": 65966.0,
        "delta": -453869.0
      },
      {
        "periodo": 202510,
        "valor": 645921.0,
        "delta": 579955.0
      },
      {
        "periodo": 202511,
        "valor": 150247.0,
        "delta": -495674.0
      },
      {
        "periodo": 202512,
        "valor": 659684.0,
        "delta": 509437.0
      },
      {
        "periodo": 202601,
        "valor": 134563.0,
        "delta": -525121.0
      },
      {
        "periodo": 202602,
        "valor": 146190.0,
        "delta": 11627.0
      },
      {
        "periodo": 202603,
        "valor": 311082.0,
        "delta": 164892.0
      },
      {
        "periodo": 202604,
        "valor": 791790.0,
        "delta": 480708.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": -791790.0
      },
      {
        "periodo": 202606,
        "valor": 34611483.0,
        "delta": 34611483.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": -34611483.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11589387.31,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1125206.56,
        "delta": -10464180.75
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -1125206.56
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 72551.59,
        "delta": 72551.59
      },
      {
        "periodo": 202509,
        "valor": 71632.22,
        "delta": -919.37
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": -71632.22
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 79618.57,
        "delta": 79618.57
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -79618.57
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 8800097.0,
    "valor_anterior": 5489034.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11207139.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7816795.0,
        "delta": -3390344.0
      },
      {
        "periodo": 202509,
        "valor": 7053297.0,
        "delta": -763498.0
      },
      {
        "periodo": 202510,
        "valor": 4240020.0,
        "delta": -2813277.0
      },
      {
        "periodo": 202511,
        "valor": 4398272.0,
        "delta": 158252.0
      },
      {
        "periodo": 202512,
        "valor": 5325147.0,
        "delta": 926875.0
      },
      {
        "periodo": 202601,
        "valor": 6976553.0,
        "delta": 1651406.0
      },
      {
        "periodo": 202602,
        "valor": 4578364.0,
        "delta": -2398189.0
      },
      {
        "periodo": 202603,
        "valor": 4510608.0,
        "delta": -67756.0
      },
      {
        "periodo": 202604,
        "valor": 2891868.0,
        "delta": -1618740.0
      },
      {
        "periodo": 202605,
        "valor": 5592274.0,
        "delta": 2700406.0
      },
      {
        "periodo": 202606,
        "valor": 5489034.0,
        "delta": -103240.0
      },
      {
        "periodo": 202607,
        "valor": 8800097.0,
        "delta": 3311063.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 102093.62,
    "valor_anterior": 21299.16,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3185109.89,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2711810.25,
        "delta": -473299.64
      },
      {
        "periodo": 202509,
        "valor": 2381464.77,
        "delta": -330345.48
      },
      {
        "periodo": 202510,
        "valor": 1226676.25,
        "delta": -1154788.52
      },
      {
        "periodo": 202511,
        "valor": 776079.7,
        "delta": -450596.55
      },
      {
        "periodo": 202512,
        "valor": 622402.92,
        "delta": -153676.78
      },
      {
        "periodo": 202601,
        "valor": 293575.01,
        "delta": -328827.91
      },
      {
        "periodo": 202602,
        "valor": 69643.02,
        "delta": -223931.99
      },
      {
        "periodo": 202603,
        "valor": 101679.46,
        "delta": 32036.44
      },
      {
        "periodo": 202604,
        "valor": 188604.46,
        "delta": 86925.0
      },
      {
        "periodo": 202605,
        "valor": 26918.53,
        "delta": -161685.93
      },
      {
        "periodo": 202606,
        "valor": 21299.16,
        "delta": -5619.37
      },
      {
        "periodo": 202607,
        "valor": 102093.62,
        "delta": 80794.46
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 31454857.06,
    "valor_anterior": 36643749.01,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 39229509.75,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 39149417.33,
        "delta": -80092.42
      },
      {
        "periodo": 202604,
        "valor": 39032169.06,
        "delta": -117248.27
      },
      {
        "periodo": 202605,
        "valor": 34386722.43,
        "delta": -4645446.63
      },
      {
        "periodo": 202606,
        "valor": 36643749.01,
        "delta": 2257026.58
      },
      {
        "periodo": 202607,
        "valor": 31454857.06,
        "delta": -5188891.95
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 20743114.0,
    "valor_anterior": 19369278.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 50325.0,
        "delta": 50325.0
      },
      {
        "periodo": 202509,
        "valor": 1149865.0,
        "delta": 1099540.0
      },
      {
        "periodo": 202510,
        "valor": 1660940.0,
        "delta": 511075.0
      },
      {
        "periodo": 202511,
        "valor": 5672631.0,
        "delta": 4011691.0
      },
      {
        "periodo": 202512,
        "valor": 17054038.0,
        "delta": 11381407.0
      },
      {
        "periodo": 202601,
        "valor": 21182906.0,
        "delta": 4128868.0
      },
      {
        "periodo": 202602,
        "valor": 23570403.0,
        "delta": 2387497.0
      },
      {
        "periodo": 202603,
        "valor": 18763836.0,
        "delta": -4806567.0
      },
      {
        "periodo": 202604,
        "valor": 14416594.0,
        "delta": -4347242.0
      },
      {
        "periodo": 202605,
        "valor": 15122332.0,
        "delta": 705738.0
      },
      {
        "periodo": 202606,
        "valor": 19369278.0,
        "delta": 4246946.0
      },
      {
        "periodo": 202607,
        "valor": 20743114.0,
        "delta": 1373836.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 7145.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 420.0,
        "delta": 420.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": -420.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 7145.0,
        "delta": 7145.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 518371713.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 417389921.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": -417389921.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 518371713.0,
        "delta": 518371713.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": -518371713.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 16464025682.45,
    "valor_anterior": 16006107790.51,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13466443420.08,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13340547399.65,
        "delta": -125896020.43
      },
      {
        "periodo": 202509,
        "valor": 13564650235.1,
        "delta": 224102835.45
      },
      {
        "periodo": 202510,
        "valor": 13882006818.67,
        "delta": 317356583.57
      },
      {
        "periodo": 202511,
        "valor": 14749744205.72,
        "delta": 867737387.05
      },
      {
        "periodo": 202512,
        "valor": 14630183787.64,
        "delta": -119560418.08
      },
      {
        "periodo": 202601,
        "valor": 15427982220.53,
        "delta": 797798432.89
      },
      {
        "periodo": 202602,
        "valor": 15071043005.31,
        "delta": -356939215.22
      },
      {
        "periodo": 202603,
        "valor": 16684916991.35,
        "delta": 1613873986.04
      },
      {
        "periodo": 202604,
        "valor": 15964957423.02,
        "delta": -719959568.33
      },
      {
        "periodo": 202605,
        "valor": 15440788471.46,
        "delta": -524168951.56
      },
      {
        "periodo": 202606,
        "valor": 16006107790.51,
        "delta": 565319319.05
      },
      {
        "periodo": 202607,
        "valor": 16464025682.45,
        "delta": 457917891.94
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 12737697336.0,
    "valor_anterior": 12210683825.94,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11230137065.64,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11185962396.34,
        "delta": -44174669.3
      },
      {
        "periodo": 202509,
        "valor": 11299483773.16,
        "delta": 113521376.82
      },
      {
        "periodo": 202510,
        "valor": 11359917558.09,
        "delta": 60433784.93
      },
      {
        "periodo": 202511,
        "valor": 12169342616.82,
        "delta": 809425058.73
      },
      {
        "periodo": 202512,
        "valor": 12321128308.79,
        "delta": 151785691.97
      },
      {
        "periodo": 202601,
        "valor": 12514072379.0,
        "delta": 192944070.21
      },
      {
        "periodo": 202602,
        "valor": 12321219971.37,
        "delta": -192852407.63
      },
      {
        "periodo": 202603,
        "valor": 13049513005.86,
        "delta": 728293034.49
      },
      {
        "periodo": 202604,
        "valor": 12539617510.59,
        "delta": -509895495.27
      },
      {
        "periodo": 202605,
        "valor": 12069486574.0,
        "delta": -470130936.59
      },
      {
        "periodo": 202606,
        "valor": 12210683825.94,
        "delta": 141197251.94
      },
      {
        "periodo": 202607,
        "valor": 12737697336.0,
        "delta": 527013510.06
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11589387.31,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1125206.56,
        "delta": -10464180.75
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -1125206.56
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 585620005.0,
    "valor_anterior": 532585823.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 486844944.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 422739278.0,
        "delta": -64105666.0
      },
      {
        "periodo": 202509,
        "valor": 428930399.0,
        "delta": 6191121.0
      },
      {
        "periodo": 202510,
        "valor": 529297880.0,
        "delta": 100367481.0
      },
      {
        "periodo": 202511,
        "valor": 402923035.0,
        "delta": -126374845.0
      },
      {
        "periodo": 202512,
        "valor": 455489705.0,
        "delta": 52566670.0
      },
      {
        "periodo": 202601,
        "valor": 368345019.0,
        "delta": -87144686.0
      },
      {
        "periodo": 202602,
        "valor": 508821999.0,
        "delta": 140476980.0
      },
      {
        "periodo": 202603,
        "valor": 546044052.0,
        "delta": 37222053.0
      },
      {
        "periodo": 202604,
        "valor": 536767393.0,
        "delta": -9276659.0
      },
      {
        "periodo": 202605,
        "valor": 509098058.0,
        "delta": -27669335.0
      },
      {
        "periodo": 202606,
        "valor": 532585823.0,
        "delta": 23487765.0
      },
      {
        "periodo": 202607,
        "valor": 585620005.0,
        "delta": 53034182.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 137274006.8,
    "valor_anterior": 104543742.66,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 144417718.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 144903298.32,
        "delta": 485579.67
      },
      {
        "periodo": 202509,
        "valor": 148799120.97,
        "delta": 3895822.65
      },
      {
        "periodo": 202510,
        "valor": 155392089.72,
        "delta": 6592968.75
      },
      {
        "periodo": 202511,
        "valor": 143522505.12,
        "delta": -11869584.6
      },
      {
        "periodo": 202512,
        "valor": 142087345.07,
        "delta": -1435160.05
      },
      {
        "periodo": 202601,
        "valor": 159633629.43,
        "delta": 17546284.36
      },
      {
        "periodo": 202602,
        "valor": 142321657.61,
        "delta": -17311971.82
      },
      {
        "periodo": 202603,
        "valor": 90556668.04,
        "delta": -51764989.57
      },
      {
        "periodo": 202604,
        "valor": 113852923.23,
        "delta": 23296255.19
      },
      {
        "periodo": 202605,
        "valor": 99233712.62,
        "delta": -14619210.61
      },
      {
        "periodo": 202606,
        "valor": 104543742.66,
        "delta": 5310030.04
      },
      {
        "periodo": 202607,
        "valor": 137274006.8,
        "delta": 32730264.14
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 34004708.79,
    "valor_anterior": 49475192.74,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19957813.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15805967.59,
        "delta": -4151845.6
      },
      {
        "periodo": 202509,
        "valor": 17285193.22,
        "delta": 1479225.63
      },
      {
        "periodo": 202510,
        "valor": 18522975.0,
        "delta": 1237781.78
      },
      {
        "periodo": 202511,
        "valor": 21307467.0,
        "delta": 2784492.0
      },
      {
        "periodo": 202512,
        "valor": 22798666.57,
        "delta": 1491199.57
      },
      {
        "periodo": 202601,
        "valor": 27870263.0,
        "delta": 5071596.43
      },
      {
        "periodo": 202602,
        "valor": 25399539.0,
        "delta": -2470724.0
      },
      {
        "periodo": 202603,
        "valor": 32471975.0,
        "delta": 7072436.0
      },
      {
        "periodo": 202604,
        "valor": 32060202.0,
        "delta": -411773.0
      },
      {
        "periodo": 202605,
        "valor": 32691925.0,
        "delta": 631723.0
      },
      {
        "periodo": 202606,
        "valor": 49475192.74,
        "delta": 16783267.74
      },
      {
        "periodo": 202607,
        "valor": 34004708.79,
        "delta": -15470483.95
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100040,
    "label": "Quitas y Castigos Consumo",
    "valor_actual": 2969429625.86,
    "valor_anterior": 3108819206.17,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1573496491.29,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1570011252.84,
        "delta": -3485238.45
      },
      {
        "periodo": 202509,
        "valor": 1670151748.75,
        "delta": 100140495.91
      },
      {
        "periodo": 202510,
        "valor": 1818876315.86,
        "delta": 148724567.11
      },
      {
        "periodo": 202511,
        "valor": 2012648581.78,
        "delta": 193772265.92
      },
      {
        "periodo": 202512,
        "valor": 1688679762.21,
        "delta": -323968819.57
      },
      {
        "periodo": 202601,
        "valor": 2358060930.1,
        "delta": 669381167.89
      },
      {
        "periodo": 202602,
        "valor": 2073279838.33,
        "delta": -284781091.77
      },
      {
        "periodo": 202603,
        "valor": 2966331290.45,
        "delta": 893051452.12
      },
      {
        "periodo": 202604,
        "valor": 2742659394.2,
        "delta": -223671896.25
      },
      {
        "periodo": 202605,
        "valor": 2730278201.84,
        "delta": -12381192.36
      },
      {
        "periodo": 202606,
        "valor": 3108819206.17,
        "delta": 378541004.33
      },
      {
        "periodo": 202607,
        "valor": 2969429625.86,
        "delta": -139389580.31
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 79938965.59,
    "valor_anterior": 59322353.28,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 60752623.73,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 53371388.88,
        "delta": -7381234.85
      },
      {
        "periodo": 202509,
        "valor": 60450616.16,
        "delta": 7079227.28
      },
      {
        "periodo": 202510,
        "valor": 43516150.73,
        "delta": -16934465.43
      },
      {
        "periodo": 202511,
        "valor": 22794678.15,
        "delta": -20721472.58
      },
      {
        "periodo": 202512,
        "valor": 47753276.07,
        "delta": 24958597.92
      },
      {
        "periodo": 202601,
        "valor": 91535245.57,
        "delta": 43781969.5
      },
      {
        "periodo": 202602,
        "valor": 52061870.13,
        "delta": -39473375.44
      },
      {
        "periodo": 202603,
        "valor": 67607544.76,
        "delta": 15545674.63
      },
      {
        "periodo": 202604,
        "valor": 79343148.13,
        "delta": 11735603.37
      },
      {
        "periodo": 202605,
        "valor": 47315242.9,
        "delta": -32027905.23
      },
      {
        "periodo": 202606,
        "valor": 59322353.28,
        "delta": 12007110.38
      },
      {
        "periodo": 202607,
        "valor": 79938965.59,
        "delta": 20616612.31
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 234216487.0,
    "valor_anterior": 396257222.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 162977805.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 81238315.0,
        "delta": -81739490.0
      },
      {
        "periodo": 202509,
        "valor": 402244543.0,
        "delta": 321006228.0
      },
      {
        "periodo": 202510,
        "valor": 286512844.0,
        "delta": -115731699.0
      },
      {
        "periodo": 202511,
        "valor": 102135911.52,
        "delta": -184376932.48
      },
      {
        "periodo": 202512,
        "valor": 420480136.21,
        "delta": 318344224.69
      },
      {
        "periodo": 202601,
        "valor": 49586824.19,
        "delta": -370893312.02
      },
      {
        "periodo": 202602,
        "valor": 209950730.6,
        "delta": 160363906.41
      },
      {
        "periodo": 202603,
        "valor": 438499937.89,
        "delta": 228549207.29
      },
      {
        "periodo": 202604,
        "valor": 239938049.77,
        "delta": -198561888.12
      },
      {
        "periodo": 202605,
        "valor": 67317761.0,
        "delta": -172620288.77
      },
      {
        "periodo": 202606,
        "valor": 396257222.0,
        "delta": 328939461.0
      },
      {
        "periodo": 202607,
        "valor": 234216487.0,
        "delta": -162040735.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 100585557.0,
    "valor_anterior": 83179902.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 122416894.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 193192149.0,
        "delta": 70775255.0
      },
      {
        "periodo": 202509,
        "valor": 144749999.0,
        "delta": -48442150.0
      },
      {
        "periodo": 202510,
        "valor": 217453127.0,
        "delta": 72703128.0
      },
      {
        "periodo": 202511,
        "valor": 1265162525.0,
        "delta": 1047709398.0
      },
      {
        "periodo": 202512,
        "valor": 214143536.0,
        "delta": -1051018989.0
      },
      {
        "periodo": 202601,
        "valor": 69134497.0,
        "delta": -145009039.0
      },
      {
        "periodo": 202602,
        "valor": 82504423.0,
        "delta": 13369926.0
      },
      {
        "periodo": 202603,
        "valor": 72763461.0,
        "delta": -9740962.0
      },
      {
        "periodo": 202604,
        "valor": 74714911.0,
        "delta": 1951450.0
      },
      {
        "periodo": 202605,
        "valor": 81062726.0,
        "delta": 6347815.0
      },
      {
        "periodo": 202606,
        "valor": 83179902.0,
        "delta": 2117176.0
      },
      {
        "periodo": 202607,
        "valor": 100585557.0,
        "delta": 17405655.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 47784288.0,
    "valor_anterior": 52275664.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 52614309.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 60714594.0,
        "delta": 8100285.0
      },
      {
        "periodo": 202509,
        "valor": 76385757.0,
        "delta": 15671163.0
      },
      {
        "periodo": 202510,
        "valor": 50077669.0,
        "delta": -26308088.0
      },
      {
        "periodo": 202511,
        "valor": 47935413.0,
        "delta": -2142256.0
      },
      {
        "periodo": 202512,
        "valor": 41108473.0,
        "delta": -6826940.0
      },
      {
        "periodo": 202601,
        "valor": 45534194.0,
        "delta": 4425721.0
      },
      {
        "periodo": 202602,
        "valor": 104136938.0,
        "delta": 58602744.0
      },
      {
        "periodo": 202603,
        "valor": 74758507.0,
        "delta": -29378431.0
      },
      {
        "periodo": 202604,
        "valor": 44933787.0,
        "delta": -29824720.0
      },
      {
        "periodo": 202605,
        "valor": 39778942.0,
        "delta": -5154845.0
      },
      {
        "periodo": 202606,
        "valor": 52275664.0,
        "delta": 12496722.0
      },
      {
        "periodo": 202607,
        "valor": 47784288.0,
        "delta": -4491376.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 5213418.35,
    "valor_anterior": 6220281.71,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3265879.08,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1499785.23,
        "delta": -1766093.85
      },
      {
        "periodo": 202509,
        "valor": 490399.83,
        "delta": -1009385.4
      },
      {
        "periodo": 202510,
        "valor": 670382.09,
        "delta": 179982.26
      },
      {
        "periodo": 202511,
        "valor": 1974835.09,
        "delta": 1304453.0
      },
      {
        "periodo": 202512,
        "valor": 2209838.22,
        "delta": 235003.13
      },
      {
        "periodo": 202601,
        "valor": 10087016.82,
        "delta": 7877178.6
      },
      {
        "periodo": 202602,
        "valor": 1111083.35,
        "delta": -8975933.47
      },
      {
        "periodo": 202603,
        "valor": 665820.81,
        "delta": -445262.54
      },
      {
        "periodo": 202604,
        "valor": 3164671.98,
        "delta": 2498851.17
      },
      {
        "periodo": 202605,
        "valor": 1902713.46,
        "delta": -1261958.52
      },
      {
        "periodo": 202606,
        "valor": 6220281.71,
        "delta": 4317568.25
      },
      {
        "periodo": 202607,
        "valor": 5213418.35,
        "delta": -1006863.36
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 5120651.0,
    "valor_anterior": 1461.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7941.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1749.0,
        "delta": -6192.0
      },
      {
        "periodo": 202509,
        "valor": 7868.0,
        "delta": 6119.0
      },
      {
        "periodo": 202510,
        "valor": 1810.0,
        "delta": -6058.0
      },
      {
        "periodo": 202511,
        "valor": 3319.0,
        "delta": 1509.0
      },
      {
        "periodo": 202512,
        "valor": 3732.0,
        "delta": 413.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -3732.0
      },
      {
        "periodo": 202602,
        "valor": 66457.0,
        "delta": 66457.0
      },
      {
        "periodo": 202603,
        "valor": 114701.0,
        "delta": 48244.0
      },
      {
        "periodo": 202604,
        "valor": 158122.0,
        "delta": 43421.0
      },
      {
        "periodo": 202605,
        "valor": 23936902.0,
        "delta": 23778780.0
      },
      {
        "periodo": 202606,
        "valor": 1461.0,
        "delta": -23935441.0
      },
      {
        "periodo": 202607,
        "valor": 5120651.0,
        "delta": 5119190.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 37391082.0,
        "delta": 37391082.0
      },
      {
        "periodo": 202509,
        "valor": 11284319.0,
        "delta": -26106763.0
      },
      {
        "periodo": 202510,
        "valor": 5918042.0,
        "delta": -5366277.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": -5918042.0
      },
      {
        "periodo": 202512,
        "valor": 10803258.0,
        "delta": 10803258.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": -10803258.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 4978607.0,
        "delta": 4978607.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": -4978607.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 98793240.0,
    "valor_anterior": 127237183.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 201356425.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 137855406.0,
        "delta": -63501019.0
      },
      {
        "periodo": 202509,
        "valor": 100778302.0,
        "delta": -37077104.0
      },
      {
        "periodo": 202510,
        "valor": 121498639.0,
        "delta": 20720337.0
      },
      {
        "periodo": 202511,
        "valor": 105369846.0,
        "delta": -16128793.0
      },
      {
        "periodo": 202512,
        "valor": 101006576.0,
        "delta": -4363270.0
      },
      {
        "periodo": 202601,
        "valor": 56069674.0,
        "delta": -44936902.0
      },
      {
        "periodo": 202602,
        "valor": 87433212.0,
        "delta": 31363538.0
      },
      {
        "periodo": 202603,
        "valor": 110224133.0,
        "delta": 22790921.0
      },
      {
        "periodo": 202604,
        "valor": 121011369.0,
        "delta": 10787236.0
      },
      {
        "periodo": 202605,
        "valor": 66048553.0,
        "delta": -54962816.0
      },
      {
        "periodo": 202606,
        "valor": 127237183.0,
        "delta": 61188630.0
      },
      {
        "periodo": 202607,
        "valor": 98793240.0,
        "delta": -28443943.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 767061.96,
    "valor_anterior": 77454.13,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1555341.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 926944.77,
        "delta": -628396.95
      },
      {
        "periodo": 202509,
        "valor": 1686091.6,
        "delta": 759146.83
      },
      {
        "periodo": 202510,
        "valor": 5108956.62,
        "delta": 3422865.02
      },
      {
        "periodo": 202511,
        "valor": 1034856.51,
        "delta": -4074100.11
      },
      {
        "periodo": 202512,
        "valor": 2931736.0,
        "delta": 1896879.49
      },
      {
        "periodo": 202601,
        "valor": 25069703.35,
        "delta": 22137967.35
      },
      {
        "periodo": 202602,
        "valor": 2117551.74,
        "delta": -22952151.61
      },
      {
        "periodo": 202603,
        "valor": 980871.52,
        "delta": -1136680.22
      },
      {
        "periodo": 202604,
        "valor": 4548844.22,
        "delta": 3567972.7
      },
      {
        "periodo": 202605,
        "valor": 1456.23,
        "delta": -4547387.99
      },
      {
        "periodo": 202606,
        "valor": 77454.13,
        "delta": 75997.9
      },
      {
        "periodo": 202607,
        "valor": 767061.96,
        "delta": 689607.83
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 87085.0,
    "valor_anterior": 109124.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 63668.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1989.0,
        "delta": -61679.0
      },
      {
        "periodo": 202509,
        "valor": 321867.0,
        "delta": 319878.0
      },
      {
        "periodo": 202510,
        "valor": 17686.0,
        "delta": -304181.0
      },
      {
        "periodo": 202511,
        "valor": 21845.0,
        "delta": 4159.0
      },
      {
        "periodo": 202512,
        "valor": 6635.0,
        "delta": -15210.0
      },
      {
        "periodo": 202601,
        "valor": 8162.0,
        "delta": 1527.0
      },
      {
        "periodo": 202602,
        "valor": 43377.0,
        "delta": 35215.0
      },
      {
        "periodo": 202603,
        "valor": 12814.0,
        "delta": -30563.0
      },
      {
        "periodo": 202604,
        "valor": 9970.0,
        "delta": -2844.0
      },
      {
        "periodo": 202605,
        "valor": 40930.0,
        "delta": 30960.0
      },
      {
        "periodo": 202606,
        "valor": 109124.0,
        "delta": 68194.0
      },
      {
        "periodo": 202607,
        "valor": 87085.0,
        "delta": -22039.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 295503695.41,
    "valor_anterior": 169389301.83,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 182500477.79,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 216990071.55,
        "delta": 34489593.76
      },
      {
        "periodo": 202509,
        "valor": 168662684.63,
        "delta": -48327386.92
      },
      {
        "periodo": 202510,
        "valor": 17995261.74,
        "delta": -150667422.89
      },
      {
        "periodo": 202511,
        "valor": 17334141.91,
        "delta": -661119.83
      },
      {
        "periodo": 202512,
        "valor": 102842781.1,
        "delta": 85508639.19
      },
      {
        "periodo": 202601,
        "valor": 28518728.97,
        "delta": -74324052.13
      },
      {
        "periodo": 202602,
        "valor": 15623658.99,
        "delta": -12895069.98
      },
      {
        "periodo": 202603,
        "valor": 27973624.81,
        "delta": 12349965.82
      },
      {
        "periodo": 202604,
        "valor": 203102032.01,
        "delta": 175128407.2
      },
      {
        "periodo": 202605,
        "valor": 193502710.15,
        "delta": -9599321.86
      },
      {
        "periodo": 202606,
        "valor": 169389301.83,
        "delta": -24113408.32
      },
      {
        "periodo": 202607,
        "valor": 295503695.41,
        "delta": 126114393.58
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 194799.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1318077.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -1318077.0
      },
      {
        "periodo": 202509,
        "valor": 4863.0,
        "delta": 4863.0
      },
      {
        "periodo": 202510,
        "valor": 114032.0,
        "delta": 109169.0
      },
      {
        "periodo": 202511,
        "valor": 329841.0,
        "delta": 215809.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": -329841.0
      },
      {
        "periodo": 202601,
        "valor": 134547.0,
        "delta": 134547.0
      },
      {
        "periodo": 202602,
        "valor": 12066.0,
        "delta": -122481.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": -12066.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 194799.0,
        "delta": 194799.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": -194799.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 4137.16,
    "valor_anterior": 1156.83,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2215.6,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": -2215.6
      },
      {
        "periodo": 202509,
        "valor": 10782.5,
        "delta": 10782.5
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": -10782.5
      },
      {
        "periodo": 202511,
        "valor": 975.02,
        "delta": 975.02
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": -975.02
      },
      {
        "periodo": 202601,
        "valor": 7135.82,
        "delta": 7135.82
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -7135.82
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 9886.66,
        "delta": 9886.66
      },
      {
        "periodo": 202605,
        "valor": 80303.5,
        "delta": 70416.84
      },
      {
        "periodo": 202606,
        "valor": 1156.83,
        "delta": -79146.67
      },
      {
        "periodo": 202607,
        "valor": 4137.16,
        "delta": 2980.33
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 2981830.34,
    "valor_anterior": 2981830.34,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 2981830.34,
        "delta": 2981830.34
      },
      {
        "periodo": 202607,
        "valor": 2981830.34,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 628232.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 628232.0,
        "delta": 628232.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": -628232.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 2738856.18,
    "valor_anterior": 1795769.94,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1840659.37,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1361883.48,
        "delta": -478775.89
      },
      {
        "periodo": 202509,
        "valor": 3257670.31,
        "delta": 1895786.83
      },
      {
        "periodo": 202510,
        "valor": 2994291.77,
        "delta": -263378.54
      },
      {
        "periodo": 202511,
        "valor": 2767897.93,
        "delta": -226393.84
      },
      {
        "periodo": 202512,
        "valor": 2742829.05,
        "delta": -25068.88
      },
      {
        "periodo": 202601,
        "valor": 3774822.77,
        "delta": 1031993.72
      },
      {
        "periodo": 202602,
        "valor": 3605878.71,
        "delta": -168944.06
      },
      {
        "periodo": 202603,
        "valor": 2625199.41,
        "delta": -980679.3
      },
      {
        "periodo": 202604,
        "valor": 3875644.47,
        "delta": 1250445.06
      },
      {
        "periodo": 202605,
        "valor": 2062323.33,
        "delta": -1813321.14
      },
      {
        "periodo": 202606,
        "valor": 1795769.94,
        "delta": -266553.39
      },
      {
        "periodo": 202607,
        "valor": 2738856.18,
        "delta": 943086.24
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 941269.66,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1215960.95,
        "delta": 274691.29
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -1215960.95
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1992760.31,
        "delta": 1992760.31
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": -1992760.31
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 873735272.99,
    "valor_anterior": 899671735.06,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 791613585.95,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 785761318.86,
        "delta": -5852267.09
      },
      {
        "periodo": 202509,
        "valor": 970335763.03,
        "delta": 184574444.17
      },
      {
        "periodo": 202510,
        "valor": 751878891.95,
        "delta": -218456871.08
      },
      {
        "periodo": 202511,
        "valor": 1568858845.44,
        "delta": 816979953.49
      },
      {
        "periodo": 202512,
        "valor": 946032806.65,
        "delta": -622826038.79
      },
      {
        "periodo": 202601,
        "valor": 379460551.49,
        "delta": -566572255.16
      },
      {
        "periodo": 202602,
        "valor": 558667246.52,
        "delta": 179206695.03
      },
      {
        "periodo": 202603,
        "valor": 796226615.2,
        "delta": 237559368.68
      },
      {
        "periodo": 202604,
        "valor": 779789043.24,
        "delta": -16437571.96
      },
      {
        "periodo": 202605,
        "valor": 523050563.57,
        "delta": -256738479.67
      },
      {
        "periodo": 202606,
        "valor": 899671735.06,
        "delta": 376621171.49
      },
      {
        "periodo": 202607,
        "valor": 873735272.99,
        "delta": -25936462.07
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 861942884.0,
    "valor_anterior": 887663087.11,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 782626475.52,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 743363673.43,
        "delta": -39262802.09
      },
      {
        "periodo": 202509,
        "valor": 953279769.79,
        "delta": 209916096.36
      },
      {
        "periodo": 202510,
        "valor": 737055501.47,
        "delta": -216224268.32
      },
      {
        "periodo": 202511,
        "valor": 1560735834.58,
        "delta": 823680333.11
      },
      {
        "periodo": 202512,
        "valor": 927338510.38,
        "delta": -633397324.2
      },
      {
        "periodo": 202601,
        "valor": 340379163.73,
        "delta": -586959346.65
      },
      {
        "periodo": 202602,
        "valor": 551777289.72,
        "delta": 211398125.99
      },
      {
        "periodo": 202603,
        "valor": 791941909.46,
        "delta": 240164619.74
      },
      {
        "periodo": 202604,
        "valor": 763201418.91,
        "delta": -28740490.55
      },
      {
        "periodo": 202605,
        "valor": 518962837.05,
        "delta": -244238581.86
      },
      {
        "periodo": 202606,
        "valor": 887663087.11,
        "delta": 368700250.06
      },
      {
        "periodo": 202607,
        "valor": 861942884.0,
        "delta": -25720203.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 941269.66,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1215960.95,
        "delta": 274691.29
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -1215960.95
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 87085.0,
    "valor_anterior": 109124.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 63668.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1989.0,
        "delta": -61679.0
      },
      {
        "periodo": 202509,
        "valor": 321867.0,
        "delta": 319878.0
      },
      {
        "periodo": 202510,
        "valor": 17686.0,
        "delta": -304181.0
      },
      {
        "periodo": 202511,
        "valor": 21845.0,
        "delta": 4159.0
      },
      {
        "periodo": 202512,
        "valor": 6635.0,
        "delta": -15210.0
      },
      {
        "periodo": 202601,
        "valor": 8162.0,
        "delta": 1527.0
      },
      {
        "periodo": 202602,
        "valor": 43377.0,
        "delta": 35215.0
      },
      {
        "periodo": 202603,
        "valor": 12814.0,
        "delta": -30563.0
      },
      {
        "periodo": 202604,
        "valor": 9970.0,
        "delta": -2844.0
      },
      {
        "periodo": 202605,
        "valor": 40930.0,
        "delta": 30960.0
      },
      {
        "periodo": 202606,
        "valor": 109124.0,
        "delta": 68194.0
      },
      {
        "periodo": 202607,
        "valor": 87085.0,
        "delta": -22039.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 5980480.31,
    "valor_anterior": 7120766.84,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6139297.8,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 39817812.0,
        "delta": 33678514.2
      },
      {
        "periodo": 202509,
        "valor": 13465673.43,
        "delta": -26352138.57
      },
      {
        "periodo": 202510,
        "valor": 11811412.71,
        "delta": -1654260.72
      },
      {
        "periodo": 202511,
        "valor": 3339532.6,
        "delta": -8471880.11
      },
      {
        "periodo": 202512,
        "valor": 15944832.22,
        "delta": 12605299.62
      },
      {
        "periodo": 202601,
        "valor": 35291267.17,
        "delta": 19346434.95
      },
      {
        "periodo": 202602,
        "valor": 3240701.09,
        "delta": -32050566.08
      },
      {
        "periodo": 202603,
        "valor": 1646692.33,
        "delta": -1594008.76
      },
      {
        "periodo": 202604,
        "valor": 12692123.2,
        "delta": 11045430.87
      },
      {
        "periodo": 202605,
        "valor": 1904169.69,
        "delta": -10787953.51
      },
      {
        "periodo": 202606,
        "valor": 7120766.84,
        "delta": 5216597.15
      },
      {
        "periodo": 202607,
        "valor": 5980480.31,
        "delta": -1140286.53
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 2981830.34,
    "valor_anterior": 2981830.34,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1992760.31,
        "delta": 1992760.31
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": -1992760.31
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 2981830.34,
        "delta": 2981830.34
      },
      {
        "periodo": 202607,
        "valor": 2981830.34,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40100041,
    "label": "Quitas y Castigos Vivienda",
    "valor_actual": 2742993.34,
    "valor_anterior": 1796926.77,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1842874.97,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1361883.48,
        "delta": -480991.49
      },
      {
        "periodo": 202509,
        "valor": 3268452.81,
        "delta": 1906569.33
      },
      {
        "periodo": 202510,
        "valor": 2994291.77,
        "delta": -274161.04
      },
      {
        "periodo": 202511,
        "valor": 2768872.95,
        "delta": -225418.82
      },
      {
        "periodo": 202512,
        "valor": 2742829.05,
        "delta": -26043.9
      },
      {
        "periodo": 202601,
        "valor": 3781958.59,
        "delta": 1039129.54
      },
      {
        "periodo": 202602,
        "valor": 3605878.71,
        "delta": -176079.88
      },
      {
        "periodo": 202603,
        "valor": 2625199.41,
        "delta": -980679.3
      },
      {
        "periodo": 202604,
        "valor": 3885531.13,
        "delta": 1260331.72
      },
      {
        "periodo": 202605,
        "valor": 2142626.83,
        "delta": -1742904.3
      },
      {
        "periodo": 202606,
        "valor": 1796926.77,
        "delta": -345700.06
      },
      {
        "periodo": 202607,
        "valor": 2742993.34,
        "delta": 946066.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.8665720000000001,
    "valor_anterior": 1.832241,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.3808,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.3445,
        "delta": -0.0363
      },
      {
        "periodo": 202509,
        "valor": 1.259,
        "delta": -0.0855
      },
      {
        "periodo": 202510,
        "valor": 1.1417,
        "delta": -0.1173
      },
      {
        "periodo": 202511,
        "valor": 1.3762,
        "delta": 0.2345
      },
      {
        "periodo": 202512,
        "valor": 1.4611,
        "delta": 0.0849
      },
      {
        "periodo": 202601,
        "valor": 1.5319,
        "delta": 0.0708
      },
      {
        "periodo": 202602,
        "valor": 1.5885,
        "delta": 0.0567
      },
      {
        "periodo": 202603,
        "valor": 1.8474,
        "delta": 0.2588
      },
      {
        "periodo": 202604,
        "valor": 1.808,
        "delta": -0.0394
      },
      {
        "periodo": 202605,
        "valor": 1.7975,
        "delta": -0.0105
      },
      {
        "periodo": 202606,
        "valor": 1.8322,
        "delta": 0.0348
      },
      {
        "periodo": 202607,
        "valor": 1.8666,
        "delta": 0.0343
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 2.800847,
    "valor_anterior": 2.797278,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.9236,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.9567,
        "delta": 0.0331
      },
      {
        "periodo": 202509,
        "valor": 2.9106,
        "delta": -0.0461
      },
      {
        "periodo": 202510,
        "valor": 2.9461,
        "delta": 0.0355
      },
      {
        "periodo": 202511,
        "valor": 2.9634,
        "delta": 0.0173
      },
      {
        "periodo": 202512,
        "valor": 2.9553,
        "delta": -0.0081
      },
      {
        "periodo": 202601,
        "valor": 2.9413,
        "delta": -0.0141
      },
      {
        "periodo": 202602,
        "valor": 2.8398,
        "delta": -0.1015
      },
      {
        "periodo": 202603,
        "valor": 2.8668,
        "delta": 0.027
      },
      {
        "periodo": 202604,
        "valor": 2.8573,
        "delta": -0.0095
      },
      {
        "periodo": 202605,
        "valor": 2.8122,
        "delta": -0.0451
      },
      {
        "periodo": 202606,
        "valor": 2.7973,
        "delta": -0.0149
      },
      {
        "periodo": 202607,
        "valor": 2.8008,
        "delta": 0.0036
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.673671,
    "valor_anterior": 1.685079,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.5079,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.522,
        "delta": 0.0141
      },
      {
        "periodo": 202509,
        "valor": 1.5143,
        "delta": -0.0076
      },
      {
        "periodo": 202510,
        "valor": 1.5486,
        "delta": 0.0343
      },
      {
        "periodo": 202511,
        "valor": 1.5454,
        "delta": -0.0033
      },
      {
        "periodo": 202512,
        "valor": 1.6073,
        "delta": 0.062
      },
      {
        "periodo": 202601,
        "valor": 1.6336,
        "delta": 0.0263
      },
      {
        "periodo": 202602,
        "valor": 1.6418,
        "delta": 0.0082
      },
      {
        "periodo": 202603,
        "valor": 1.7165,
        "delta": 0.0747
      },
      {
        "periodo": 202604,
        "valor": 1.7427,
        "delta": 0.0262
      },
      {
        "periodo": 202605,
        "valor": 1.6692,
        "delta": -0.0735
      },
      {
        "periodo": 202606,
        "valor": 1.6851,
        "delta": 0.0158
      },
      {
        "periodo": 202607,
        "valor": 1.6737,
        "delta": -0.0114
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 0.702585,
    "valor_anterior": 0.740586,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.7073,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.7411,
        "delta": 0.0338
      },
      {
        "periodo": 202509,
        "valor": 0.7392,
        "delta": -0.0019
      },
      {
        "periodo": 202510,
        "valor": 0.7229,
        "delta": -0.0163
      },
      {
        "periodo": 202511,
        "valor": 0.9041,
        "delta": 0.1812
      },
      {
        "periodo": 202512,
        "valor": 0.8028,
        "delta": -0.1013
      },
      {
        "periodo": 202601,
        "valor": 0.8534,
        "delta": 0.0507
      },
      {
        "periodo": 202602,
        "valor": 0.8617,
        "delta": 0.0083
      },
      {
        "periodo": 202603,
        "valor": 0.9673,
        "delta": 0.1055
      },
      {
        "periodo": 202604,
        "valor": 0.9225,
        "delta": -0.0448
      },
      {
        "periodo": 202605,
        "valor": 0.8731,
        "delta": -0.0494
      },
      {
        "periodo": 202606,
        "valor": 0.7406,
        "delta": -0.1326
      },
      {
        "periodo": 202607,
        "valor": 0.7026,
        "delta": -0.038
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 2.162039,
    "valor_anterior": 2.199424,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.6364,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.6042,
        "delta": -0.0322
      },
      {
        "periodo": 202509,
        "valor": 2.5666,
        "delta": -0.0376
      },
      {
        "periodo": 202510,
        "valor": 2.5331,
        "delta": -0.0335
      },
      {
        "periodo": 202511,
        "valor": 2.4939,
        "delta": -0.0392
      },
      {
        "periodo": 202512,
        "valor": 2.4147,
        "delta": -0.0792
      },
      {
        "periodo": 202601,
        "valor": 2.3774,
        "delta": -0.0374
      },
      {
        "periodo": 202602,
        "valor": 2.3146,
        "delta": -0.0628
      },
      {
        "periodo": 202603,
        "valor": 2.263,
        "delta": -0.0516
      },
      {
        "periodo": 202604,
        "valor": 2.2416,
        "delta": -0.0214
      },
      {
        "periodo": 202605,
        "valor": 2.2069,
        "delta": -0.0347
      },
      {
        "periodo": 202606,
        "valor": 2.1994,
        "delta": -0.0075
      },
      {
        "periodo": 202607,
        "valor": 2.162,
        "delta": -0.0374
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 2.651022,
    "valor_anterior": 2.798154,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.6215,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.5411,
        "delta": -0.0805
      },
      {
        "periodo": 202509,
        "valor": 3.37,
        "delta": -0.1711
      },
      {
        "periodo": 202510,
        "valor": 3.3494,
        "delta": -0.0206
      },
      {
        "periodo": 202511,
        "valor": 3.3135,
        "delta": -0.0359
      },
      {
        "periodo": 202512,
        "valor": 3.2404,
        "delta": -0.0732
      },
      {
        "periodo": 202601,
        "valor": 3.2667,
        "delta": 0.0264
      },
      {
        "periodo": 202602,
        "valor": 3.1713,
        "delta": -0.0954
      },
      {
        "periodo": 202603,
        "valor": 3.1098,
        "delta": -0.0615
      },
      {
        "periodo": 202604,
        "valor": 3.0614,
        "delta": -0.0484
      },
      {
        "periodo": 202605,
        "valor": 2.9258,
        "delta": -0.1355
      },
      {
        "periodo": 202606,
        "valor": 2.7982,
        "delta": -0.1277
      },
      {
        "periodo": 202607,
        "valor": 2.651,
        "delta": -0.1471
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.978431,
    "valor_anterior": 1.9922559999999998,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.1438,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.1328,
        "delta": -0.011
      },
      {
        "periodo": 202509,
        "valor": 2.1301,
        "delta": -0.0028
      },
      {
        "periodo": 202510,
        "valor": 2.1351,
        "delta": 0.0051
      },
      {
        "periodo": 202511,
        "valor": 2.1439,
        "delta": 0.0088
      },
      {
        "periodo": 202512,
        "valor": 2.1061,
        "delta": -0.0378
      },
      {
        "periodo": 202601,
        "valor": 2.1075,
        "delta": 0.0014
      },
      {
        "periodo": 202602,
        "valor": 2.0907,
        "delta": -0.0169
      },
      {
        "periodo": 202603,
        "valor": 2.0706,
        "delta": -0.02
      },
      {
        "periodo": 202604,
        "valor": 2.0434,
        "delta": -0.0272
      },
      {
        "periodo": 202605,
        "valor": 2.0115,
        "delta": -0.032
      },
      {
        "periodo": 202606,
        "valor": 1.9923,
        "delta": -0.0192
      },
      {
        "periodo": 202607,
        "valor": 1.9784,
        "delta": -0.0138
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.368542,
    "valor_anterior": 1.3425,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.1896,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.1708,
        "delta": -0.0188
      },
      {
        "periodo": 202509,
        "valor": 1.1789,
        "delta": 0.0081
      },
      {
        "periodo": 202510,
        "valor": 1.1436,
        "delta": -0.0353
      },
      {
        "periodo": 202511,
        "valor": 1.1201,
        "delta": -0.0236
      },
      {
        "periodo": 202512,
        "valor": 1.148,
        "delta": 0.0279
      },
      {
        "periodo": 202601,
        "valor": 1.1967,
        "delta": 0.0487
      },
      {
        "periodo": 202602,
        "valor": 1.2277,
        "delta": 0.0311
      },
      {
        "periodo": 202603,
        "valor": 1.3678,
        "delta": 0.1401
      },
      {
        "periodo": 202604,
        "valor": 1.3373,
        "delta": -0.0305
      },
      {
        "periodo": 202605,
        "valor": 1.318,
        "delta": -0.0193
      },
      {
        "periodo": 202606,
        "valor": 1.3425,
        "delta": 0.0245
      },
      {
        "periodo": 202607,
        "valor": 1.3685,
        "delta": 0.026
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 2.260537,
    "valor_anterior": 2.259659,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.6225,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.6024,
        "delta": -0.0202
      },
      {
        "periodo": 202509,
        "valor": 2.574,
        "delta": -0.0283
      },
      {
        "periodo": 202510,
        "valor": 2.5685,
        "delta": -0.0056
      },
      {
        "periodo": 202511,
        "valor": 2.5069,
        "delta": -0.0615
      },
      {
        "periodo": 202512,
        "valor": 2.4673,
        "delta": -0.0397
      },
      {
        "periodo": 202601,
        "valor": 2.4212,
        "delta": -0.046
      },
      {
        "periodo": 202602,
        "valor": 2.3846,
        "delta": -0.0366
      },
      {
        "periodo": 202603,
        "valor": 2.3562,
        "delta": -0.0285
      },
      {
        "periodo": 202604,
        "valor": 2.3391,
        "delta": -0.017
      },
      {
        "periodo": 202605,
        "valor": 2.3165,
        "delta": -0.0226
      },
      {
        "periodo": 202606,
        "valor": 2.2597,
        "delta": -0.0568
      },
      {
        "periodo": 202607,
        "valor": 2.2605,
        "delta": 0.0009
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 0.692462,
    "valor_anterior": 0.6728010000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.8946,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.8562,
        "delta": -0.0384
      },
      {
        "periodo": 202509,
        "valor": 0.8929,
        "delta": 0.0368
      },
      {
        "periodo": 202510,
        "valor": 0.8794,
        "delta": -0.0136
      },
      {
        "periodo": 202511,
        "valor": 0.8301,
        "delta": -0.0492
      },
      {
        "periodo": 202512,
        "valor": 0.783,
        "delta": -0.0472
      },
      {
        "periodo": 202601,
        "valor": 0.6841,
        "delta": -0.0989
      },
      {
        "periodo": 202602,
        "valor": 0.647,
        "delta": -0.0371
      },
      {
        "periodo": 202603,
        "valor": 0.6249,
        "delta": -0.0221
      },
      {
        "periodo": 202604,
        "valor": 0.6648,
        "delta": 0.0398
      },
      {
        "periodo": 202605,
        "valor": 0.6592,
        "delta": -0.0056
      },
      {
        "periodo": 202606,
        "valor": 0.6728,
        "delta": 0.0136
      },
      {
        "periodo": 202607,
        "valor": 0.6925,
        "delta": 0.0197
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.9609560000000001,
    "valor_anterior": 1.941598,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.7034,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.7312,
        "delta": 0.0278
      },
      {
        "periodo": 202509,
        "valor": 1.7563,
        "delta": 0.0252
      },
      {
        "periodo": 202510,
        "valor": 1.7412,
        "delta": -0.0151
      },
      {
        "periodo": 202511,
        "valor": 1.7634,
        "delta": 0.0222
      },
      {
        "periodo": 202512,
        "valor": 1.8768,
        "delta": 0.1134
      },
      {
        "periodo": 202601,
        "valor": 1.8711,
        "delta": -0.0056
      },
      {
        "periodo": 202602,
        "valor": 1.876,
        "delta": 0.0049
      },
      {
        "periodo": 202603,
        "valor": 1.8869,
        "delta": 0.0109
      },
      {
        "periodo": 202604,
        "valor": 1.8974,
        "delta": 0.0105
      },
      {
        "periodo": 202605,
        "valor": 1.9079,
        "delta": 0.0105
      },
      {
        "periodo": 202606,
        "valor": 1.9416,
        "delta": 0.0337
      },
      {
        "periodo": 202607,
        "valor": 1.961,
        "delta": 0.0194
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 0.210394,
    "valor_anterior": 0.22017899999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.2466,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.2644,
        "delta": 0.0179
      },
      {
        "periodo": 202509,
        "valor": 0.2789,
        "delta": 0.0145
      },
      {
        "periodo": 202510,
        "valor": 0.2937,
        "delta": 0.0147
      },
      {
        "periodo": 202511,
        "valor": 0.3139,
        "delta": 0.0202
      },
      {
        "periodo": 202512,
        "valor": 0.1658,
        "delta": -0.1481
      },
      {
        "periodo": 202601,
        "valor": 0.1741,
        "delta": 0.0083
      },
      {
        "periodo": 202602,
        "valor": 0.1772,
        "delta": 0.0031
      },
      {
        "periodo": 202603,
        "valor": 0.1916,
        "delta": 0.0145
      },
      {
        "periodo": 202604,
        "valor": 0.2049,
        "delta": 0.0133
      },
      {
        "periodo": 202605,
        "valor": 0.2042,
        "delta": -0.0007
      },
      {
        "periodo": 202606,
        "valor": 0.2202,
        "delta": 0.016
      },
      {
        "periodo": 202607,
        "valor": 0.2104,
        "delta": -0.0098
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 2.5229749999999997,
    "valor_anterior": 2.5344249999999997,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.4774,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.47,
        "delta": -0.0074
      },
      {
        "periodo": 202509,
        "valor": 2.4258,
        "delta": -0.0443
      },
      {
        "periodo": 202510,
        "valor": 2.4258,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 2.4313,
        "delta": 0.0055
      },
      {
        "periodo": 202512,
        "valor": 2.4984,
        "delta": 0.0671
      },
      {
        "periodo": 202601,
        "valor": 2.4886,
        "delta": -0.0098
      },
      {
        "periodo": 202602,
        "valor": 2.4932,
        "delta": 0.0046
      },
      {
        "periodo": 202603,
        "valor": 2.5267,
        "delta": 0.0336
      },
      {
        "periodo": 202604,
        "valor": 2.5467,
        "delta": 0.0199
      },
      {
        "periodo": 202605,
        "valor": 2.528,
        "delta": -0.0187
      },
      {
        "periodo": 202606,
        "valor": 2.5344,
        "delta": 0.0064
      },
      {
        "periodo": 202607,
        "valor": 2.523,
        "delta": -0.0114
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.126696,
    "valor_anterior": 1.069272,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.2437,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.2474,
        "delta": 0.0037
      },
      {
        "periodo": 202509,
        "valor": 1.0581,
        "delta": -0.1893
      },
      {
        "periodo": 202510,
        "valor": 1.2388,
        "delta": 0.1807
      },
      {
        "periodo": 202511,
        "valor": 1.1469,
        "delta": -0.0919
      },
      {
        "periodo": 202512,
        "valor": 1.0305,
        "delta": -0.1164
      },
      {
        "periodo": 202601,
        "valor": 1.1223,
        "delta": 0.0917
      },
      {
        "periodo": 202602,
        "valor": 1.0512,
        "delta": -0.071
      },
      {
        "periodo": 202603,
        "valor": 1.0434,
        "delta": -0.0078
      },
      {
        "periodo": 202604,
        "valor": 1.2056,
        "delta": 0.1622
      },
      {
        "periodo": 202605,
        "valor": 1.1287,
        "delta": -0.0769
      },
      {
        "periodo": 202606,
        "valor": 1.0693,
        "delta": -0.0594
      },
      {
        "periodo": 202607,
        "valor": 1.1267,
        "delta": 0.0574
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.7329219999999999,
    "valor_anterior": 1.806439,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.5992,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.6945,
        "delta": 0.0953
      },
      {
        "periodo": 202509,
        "valor": 2.7159,
        "delta": 0.0214
      },
      {
        "periodo": 202510,
        "valor": 2.7202,
        "delta": 0.0043
      },
      {
        "periodo": 202511,
        "valor": 2.6814,
        "delta": -0.0388
      },
      {
        "periodo": 202512,
        "valor": 2.8212,
        "delta": 0.1399
      },
      {
        "periodo": 202601,
        "valor": 2.6148,
        "delta": -0.2064
      },
      {
        "periodo": 202602,
        "valor": 2.4296,
        "delta": -0.1852
      },
      {
        "periodo": 202603,
        "valor": 2.2336,
        "delta": -0.1959
      },
      {
        "periodo": 202604,
        "valor": 2.208,
        "delta": -0.0256
      },
      {
        "periodo": 202605,
        "valor": 2.0905,
        "delta": -0.1175
      },
      {
        "periodo": 202606,
        "valor": 1.8064,
        "delta": -0.2841
      },
      {
        "periodo": 202607,
        "valor": 1.7329,
        "delta": -0.0735
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.9421689999999998,
    "valor_anterior": 1.937307,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.1094,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.162,
        "delta": 0.0526
      },
      {
        "periodo": 202509,
        "valor": 2.2086,
        "delta": 0.0466
      },
      {
        "periodo": 202510,
        "valor": 2.1802,
        "delta": -0.0284
      },
      {
        "periodo": 202511,
        "valor": 2.1907,
        "delta": 0.0105
      },
      {
        "periodo": 202512,
        "valor": 2.0874,
        "delta": -0.1033
      },
      {
        "periodo": 202601,
        "valor": 1.9805,
        "delta": -0.1069
      },
      {
        "periodo": 202602,
        "valor": 1.9964,
        "delta": 0.0159
      },
      {
        "periodo": 202603,
        "valor": 2.0545,
        "delta": 0.0581
      },
      {
        "periodo": 202604,
        "valor": 2.0197,
        "delta": -0.0349
      },
      {
        "periodo": 202605,
        "valor": 1.9903,
        "delta": -0.0293
      },
      {
        "periodo": 202606,
        "valor": 1.9373,
        "delta": -0.053
      },
      {
        "periodo": 202607,
        "valor": 1.9422,
        "delta": 0.0049
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.266435,
    "valor_anterior": 1.236232,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.2118,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.2026,
        "delta": -0.0092
      },
      {
        "periodo": 202509,
        "valor": 1.1981,
        "delta": -0.0045
      },
      {
        "periodo": 202510,
        "valor": 1.1794,
        "delta": -0.0188
      },
      {
        "periodo": 202511,
        "valor": 1.1773,
        "delta": -0.0021
      },
      {
        "periodo": 202512,
        "valor": 1.2111,
        "delta": 0.0339
      },
      {
        "periodo": 202601,
        "valor": 1.2446,
        "delta": 0.0335
      },
      {
        "periodo": 202602,
        "valor": 1.2723,
        "delta": 0.0277
      },
      {
        "periodo": 202603,
        "valor": 1.1852,
        "delta": -0.0871
      },
      {
        "periodo": 202604,
        "valor": 1.1903,
        "delta": 0.0051
      },
      {
        "periodo": 202605,
        "valor": 1.1867,
        "delta": -0.0036
      },
      {
        "periodo": 202606,
        "valor": 1.2362,
        "delta": 0.0496
      },
      {
        "periodo": 202607,
        "valor": 1.2664,
        "delta": 0.0302
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 0.90104,
    "valor_anterior": 0.9256949999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.5168,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.4668,
        "delta": -0.05
      },
      {
        "periodo": 202509,
        "valor": 1.4005,
        "delta": -0.0664
      },
      {
        "periodo": 202510,
        "valor": 1.3427,
        "delta": -0.0578
      },
      {
        "periodo": 202511,
        "valor": 1.3086,
        "delta": -0.0341
      },
      {
        "periodo": 202512,
        "valor": 1.2283,
        "delta": -0.0802
      },
      {
        "periodo": 202601,
        "valor": 1.1736,
        "delta": -0.0547
      },
      {
        "periodo": 202602,
        "valor": 1.0227,
        "delta": -0.1509
      },
      {
        "periodo": 202603,
        "valor": 1.0078,
        "delta": -0.0149
      },
      {
        "periodo": 202604,
        "valor": 0.9934,
        "delta": -0.0145
      },
      {
        "periodo": 202605,
        "valor": 0.9322,
        "delta": -0.0612
      },
      {
        "periodo": 202606,
        "valor": 0.9257,
        "delta": -0.0065
      },
      {
        "periodo": 202607,
        "valor": 0.901,
        "delta": -0.0247
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.6988960000000002,
    "valor_anterior": 1.770967,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.2665,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.3806,
        "delta": 0.1141
      },
      {
        "periodo": 202509,
        "valor": 1.3967,
        "delta": 0.0161
      },
      {
        "periodo": 202510,
        "valor": 1.4299,
        "delta": 0.0332
      },
      {
        "periodo": 202511,
        "valor": 1.3864,
        "delta": -0.0435
      },
      {
        "periodo": 202512,
        "valor": 1.9478,
        "delta": 0.5614
      },
      {
        "periodo": 202601,
        "valor": 1.8351,
        "delta": -0.1127
      },
      {
        "periodo": 202602,
        "valor": 1.9205,
        "delta": 0.0854
      },
      {
        "periodo": 202603,
        "valor": 1.706,
        "delta": -0.2145
      },
      {
        "periodo": 202604,
        "valor": 1.7359,
        "delta": 0.0299
      },
      {
        "periodo": 202605,
        "valor": 1.8387,
        "delta": 0.1028
      },
      {
        "periodo": 202606,
        "valor": 1.771,
        "delta": -0.0677
      },
      {
        "periodo": 202607,
        "valor": 1.6989,
        "delta": -0.0721
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": -2.515463,
    "valor_anterior": -3.019564,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -4.8496,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -5.313,
        "delta": -0.4635
      },
      {
        "periodo": 202509,
        "valor": -4.9125,
        "delta": 0.4005
      },
      {
        "periodo": 202510,
        "valor": -2.6905,
        "delta": 2.222
      },
      {
        "periodo": 202511,
        "valor": -3.8922,
        "delta": -1.2017
      },
      {
        "periodo": 202512,
        "valor": -6.1292,
        "delta": -2.237
      },
      {
        "periodo": 202601,
        "valor": -5.1085,
        "delta": 1.0207
      },
      {
        "periodo": 202602,
        "valor": -4.4732,
        "delta": 0.6353
      },
      {
        "periodo": 202603,
        "valor": -4.196,
        "delta": 0.2772
      },
      {
        "periodo": 202604,
        "valor": -3.2291,
        "delta": 0.9669
      },
      {
        "periodo": 202605,
        "valor": -3.8011,
        "delta": -0.572
      },
      {
        "periodo": 202606,
        "valor": -3.0196,
        "delta": 0.7816
      },
      {
        "periodo": 202607,
        "valor": -2.5155,
        "delta": 0.5041
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.008672,
    "valor_anterior": 1.193897,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.7764,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.7761,
        "delta": -0.0003
      },
      {
        "periodo": 202509,
        "valor": 1.7599,
        "delta": -0.0162
      },
      {
        "periodo": 202510,
        "valor": 1.8469,
        "delta": 0.087
      },
      {
        "periodo": 202511,
        "valor": 1.8358,
        "delta": -0.0112
      },
      {
        "periodo": 202512,
        "valor": 1.9674,
        "delta": 0.1316
      },
      {
        "periodo": 202601,
        "valor": 1.9557,
        "delta": -0.0117
      },
      {
        "periodo": 202602,
        "valor": 1.9475,
        "delta": -0.0082
      },
      {
        "periodo": 202603,
        "valor": 1.9345,
        "delta": -0.013
      },
      {
        "periodo": 202604,
        "valor": 1.874,
        "delta": -0.0605
      },
      {
        "periodo": 202605,
        "valor": 1.5462,
        "delta": -0.3278
      },
      {
        "periodo": 202606,
        "valor": 1.1939,
        "delta": -0.3523
      },
      {
        "periodo": 202607,
        "valor": 1.0087,
        "delta": -0.1852
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 2.6696370000000003,
    "valor_anterior": 2.590844,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.866,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.1636,
        "delta": 0.2977
      },
      {
        "periodo": 202509,
        "valor": 2.4359,
        "delta": 1.2723
      },
      {
        "periodo": 202510,
        "valor": 2.449,
        "delta": 0.013
      },
      {
        "periodo": 202511,
        "valor": 2.0386,
        "delta": -0.4104
      },
      {
        "periodo": 202512,
        "valor": 2.4417,
        "delta": 0.4031
      },
      {
        "periodo": 202601,
        "valor": 2.5554,
        "delta": 0.1137
      },
      {
        "periodo": 202602,
        "valor": 2.592,
        "delta": 0.0366
      },
      {
        "periodo": 202603,
        "valor": 2.81,
        "delta": 0.218
      },
      {
        "periodo": 202604,
        "valor": 2.7918,
        "delta": -0.0182
      },
      {
        "periodo": 202605,
        "valor": 2.7581,
        "delta": -0.0337
      },
      {
        "periodo": 202606,
        "valor": 2.5908,
        "delta": -0.1672
      },
      {
        "periodo": 202607,
        "valor": 2.6696,
        "delta": 0.0788
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 0.312877,
    "valor_anterior": 0.5016729999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.8088,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.6407,
        "delta": -0.1681
      },
      {
        "periodo": 202509,
        "valor": 0.6283,
        "delta": -0.0124
      },
      {
        "periodo": 202510,
        "valor": 0.6572,
        "delta": 0.0289
      },
      {
        "periodo": 202511,
        "valor": 0.614,
        "delta": -0.0432
      },
      {
        "periodo": 202512,
        "valor": 0.5919,
        "delta": -0.0221
      },
      {
        "periodo": 202601,
        "valor": 0.6497,
        "delta": 0.0577
      },
      {
        "periodo": 202602,
        "valor": 0.6703,
        "delta": 0.0207
      },
      {
        "periodo": 202603,
        "valor": 0.6228,
        "delta": -0.0476
      },
      {
        "periodo": 202604,
        "valor": 0.5137,
        "delta": -0.1091
      },
      {
        "periodo": 202605,
        "valor": 0.555,
        "delta": 0.0413
      },
      {
        "periodo": 202606,
        "valor": 0.5017,
        "delta": -0.0534
      },
      {
        "periodo": 202607,
        "valor": 0.3129,
        "delta": -0.1888
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 8.431991,
    "valor_anterior": 8.475570000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.0757,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.9242,
        "delta": -0.1514
      },
      {
        "periodo": 202509,
        "valor": 8.9259,
        "delta": 0.0017
      },
      {
        "periodo": 202510,
        "valor": 8.8311,
        "delta": -0.0948
      },
      {
        "periodo": 202511,
        "valor": 8.669,
        "delta": -0.1621
      },
      {
        "periodo": 202512,
        "valor": 8.7394,
        "delta": 0.0704
      },
      {
        "periodo": 202601,
        "valor": 8.7798,
        "delta": 0.0404
      },
      {
        "periodo": 202602,
        "valor": 8.6899,
        "delta": -0.0899
      },
      {
        "periodo": 202603,
        "valor": 8.5178,
        "delta": -0.1721
      },
      {
        "periodo": 202604,
        "valor": 8.3008,
        "delta": -0.217
      },
      {
        "periodo": 202605,
        "valor": 8.3215,
        "delta": 0.0208
      },
      {
        "periodo": 202606,
        "valor": 8.4756,
        "delta": 0.154
      },
      {
        "periodo": 202607,
        "valor": 8.432,
        "delta": -0.0436
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 0.97627,
    "valor_anterior": 0.9338219999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.849,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.8166,
        "delta": -0.0323
      },
      {
        "periodo": 202509,
        "valor": 0.8116,
        "delta": -0.005
      },
      {
        "periodo": 202510,
        "valor": 0.8801,
        "delta": 0.0684
      },
      {
        "periodo": 202511,
        "valor": 0.9058,
        "delta": 0.0257
      },
      {
        "periodo": 202512,
        "valor": 0.8772,
        "delta": -0.0286
      },
      {
        "periodo": 202601,
        "valor": 0.866,
        "delta": -0.0112
      },
      {
        "periodo": 202602,
        "valor": 0.8354,
        "delta": -0.0305
      },
      {
        "periodo": 202603,
        "valor": 0.8297,
        "delta": -0.0058
      },
      {
        "periodo": 202604,
        "valor": 0.8461,
        "delta": 0.0165
      },
      {
        "periodo": 202605,
        "valor": 0.87,
        "delta": 0.0238
      },
      {
        "periodo": 202606,
        "valor": 0.9338,
        "delta": 0.0639
      },
      {
        "periodo": 202607,
        "valor": 0.9763,
        "delta": 0.0424
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 0.48068099999999997,
    "valor_anterior": 0.498691,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.991,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.9445,
        "delta": -0.0464
      },
      {
        "periodo": 202509,
        "valor": 0.9456,
        "delta": 0.0011
      },
      {
        "periodo": 202510,
        "valor": 0.929,
        "delta": -0.0167
      },
      {
        "periodo": 202511,
        "valor": 0.8437,
        "delta": -0.0853
      },
      {
        "periodo": 202512,
        "valor": 0.7758,
        "delta": -0.0679
      },
      {
        "periodo": 202601,
        "valor": 0.8462,
        "delta": 0.0704
      },
      {
        "periodo": 202602,
        "valor": 0.6674,
        "delta": -0.1788
      },
      {
        "periodo": 202603,
        "valor": 0.6498,
        "delta": -0.0176
      },
      {
        "periodo": 202604,
        "valor": 0.6232,
        "delta": -0.0266
      },
      {
        "periodo": 202605,
        "valor": 0.7385,
        "delta": 0.1153
      },
      {
        "periodo": 202606,
        "valor": 0.4987,
        "delta": -0.2398
      },
      {
        "periodo": 202607,
        "valor": 0.4807,
        "delta": -0.018
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": -10.25408,
    "valor_anterior": -7.767833,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.9831,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.6413,
        "delta": -0.3418
      },
      {
        "periodo": 202509,
        "valor": 2.3375,
        "delta": -0.3038
      },
      {
        "periodo": 202510,
        "valor": 2.0021,
        "delta": -0.3354
      },
      {
        "periodo": 202511,
        "valor": 1.8591,
        "delta": -0.1431
      },
      {
        "periodo": 202512,
        "valor": 1.0683,
        "delta": -0.7908
      },
      {
        "periodo": 202601,
        "valor": 0.7768,
        "delta": -0.2915
      },
      {
        "periodo": 202602,
        "valor": 0.5055,
        "delta": -0.2713
      },
      {
        "periodo": 202603,
        "valor": -0.1434,
        "delta": -0.6489
      },
      {
        "periodo": 202604,
        "valor": -1.0116,
        "delta": -0.8682
      },
      {
        "periodo": 202605,
        "valor": -2.4532,
        "delta": -1.4416
      },
      {
        "periodo": 202606,
        "valor": -7.7678,
        "delta": -5.3147
      },
      {
        "periodo": 202607,
        "valor": -10.2541,
        "delta": -2.4862
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.2716969999999999,
    "valor_anterior": 1.262443,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.1435,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.9881,
        "delta": -0.1554
      },
      {
        "periodo": 202509,
        "valor": 1.8118,
        "delta": -0.1763
      },
      {
        "periodo": 202510,
        "valor": 1.8581,
        "delta": 0.0463
      },
      {
        "periodo": 202511,
        "valor": 1.8578,
        "delta": -0.0003
      },
      {
        "periodo": 202512,
        "valor": 1.8392,
        "delta": -0.0186
      },
      {
        "periodo": 202601,
        "valor": 1.5754,
        "delta": -0.2638
      },
      {
        "periodo": 202602,
        "valor": 1.5652,
        "delta": -0.0102
      },
      {
        "periodo": 202603,
        "valor": 1.2956,
        "delta": -0.2696
      },
      {
        "periodo": 202604,
        "valor": 1.2613,
        "delta": -0.0343
      },
      {
        "periodo": 202605,
        "valor": 1.1456,
        "delta": -0.1157
      },
      {
        "periodo": 202606,
        "valor": 1.2624,
        "delta": 0.1168
      },
      {
        "periodo": 202607,
        "valor": 1.2717,
        "delta": 0.0093
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": -18.620171,
    "valor_anterior": -19.319104,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -18.7761,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -18.581,
        "delta": 0.1951
      },
      {
        "periodo": 202509,
        "valor": -18.1691,
        "delta": 0.4119
      },
      {
        "periodo": 202510,
        "valor": -18.3629,
        "delta": -0.1938
      },
      {
        "periodo": 202511,
        "valor": -18.7459,
        "delta": -0.383
      },
      {
        "periodo": 202512,
        "valor": -18.9336,
        "delta": -0.1877
      },
      {
        "periodo": 202601,
        "valor": -19.2113,
        "delta": -0.2777
      },
      {
        "periodo": 202602,
        "valor": -19.8859,
        "delta": -0.6747
      },
      {
        "periodo": 202603,
        "valor": -20.0615,
        "delta": -0.1756
      },
      {
        "periodo": 202604,
        "valor": -20.1147,
        "delta": -0.0532
      },
      {
        "periodo": 202605,
        "valor": -19.6634,
        "delta": 0.4513
      },
      {
        "periodo": 202606,
        "valor": -19.3191,
        "delta": 0.3443
      },
      {
        "periodo": 202607,
        "valor": -18.6202,
        "delta": 0.6989
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 0.112056,
    "valor_anterior": 0.112615,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.2431,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.2446,
        "delta": 0.0015
      },
      {
        "periodo": 202509,
        "valor": 0.2596,
        "delta": 0.015
      },
      {
        "periodo": 202510,
        "valor": 0.2556,
        "delta": -0.004
      },
      {
        "periodo": 202511,
        "valor": 0.2104,
        "delta": -0.0452
      },
      {
        "periodo": 202512,
        "valor": 0.1671,
        "delta": -0.0433
      },
      {
        "periodo": 202601,
        "valor": 0.1657,
        "delta": -0.0013
      },
      {
        "periodo": 202602,
        "valor": 0.1253,
        "delta": -0.0405
      },
      {
        "periodo": 202603,
        "valor": 0.1198,
        "delta": -0.0054
      },
      {
        "periodo": 202604,
        "valor": 0.0973,
        "delta": -0.0226
      },
      {
        "periodo": 202605,
        "valor": 0.1049,
        "delta": 0.0076
      },
      {
        "periodo": 202606,
        "valor": 0.1126,
        "delta": 0.0078
      },
      {
        "periodo": 202607,
        "valor": 0.1121,
        "delta": -0.0006
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 3.350441,
    "valor_anterior": 3.5626409999999997,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.577,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.7327,
        "delta": 0.1557
      },
      {
        "periodo": 202509,
        "valor": 2.9432,
        "delta": 0.2105
      },
      {
        "periodo": 202510,
        "valor": 3.0873,
        "delta": 0.1441
      },
      {
        "periodo": 202511,
        "valor": 3.2217,
        "delta": 0.1344
      },
      {
        "periodo": 202512,
        "valor": 3.2074,
        "delta": -0.0143
      },
      {
        "periodo": 202601,
        "valor": 3.325,
        "delta": 0.1176
      },
      {
        "periodo": 202602,
        "valor": 3.4136,
        "delta": 0.0886
      },
      {
        "periodo": 202603,
        "valor": 3.5026,
        "delta": 0.089
      },
      {
        "periodo": 202604,
        "valor": 3.5778,
        "delta": 0.0753
      },
      {
        "periodo": 202605,
        "valor": 3.5777,
        "delta": -0.0002
      },
      {
        "periodo": 202606,
        "valor": 3.5626,
        "delta": -0.015
      },
      {
        "periodo": 202607,
        "valor": 3.3504,
        "delta": -0.2122
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 4.328897,
    "valor_anterior": 4.590642000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5.9361,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6.0615,
        "delta": 0.1254
      },
      {
        "periodo": 202509,
        "valor": 6.2144,
        "delta": 0.1528
      },
      {
        "periodo": 202510,
        "valor": 5.293,
        "delta": -0.9213
      },
      {
        "periodo": 202511,
        "valor": 5.0014,
        "delta": -0.2916
      },
      {
        "periodo": 202512,
        "valor": 5.1091,
        "delta": 0.1077
      },
      {
        "periodo": 202601,
        "valor": 4.8038,
        "delta": -0.3053
      },
      {
        "periodo": 202602,
        "valor": 5.1664,
        "delta": 0.3626
      },
      {
        "periodo": 202603,
        "valor": 5.4265,
        "delta": 0.2601
      },
      {
        "periodo": 202604,
        "valor": 4.6424,
        "delta": -0.7841
      },
      {
        "periodo": 202605,
        "valor": 4.4662,
        "delta": -0.1761
      },
      {
        "periodo": 202606,
        "valor": 4.5906,
        "delta": 0.1244
      },
      {
        "periodo": 202607,
        "valor": 4.3289,
        "delta": -0.2617
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.5087,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -0.1122,
        "delta": -0.621
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 0.959896,
    "valor_anterior": 0.963444,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.3207,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.2794,
        "delta": -0.0413
      },
      {
        "periodo": 202509,
        "valor": 1.212,
        "delta": -0.0674
      },
      {
        "periodo": 202510,
        "valor": 1.17,
        "delta": -0.042
      },
      {
        "periodo": 202511,
        "valor": 1.0627,
        "delta": -0.1073
      },
      {
        "periodo": 202512,
        "valor": 1.1207,
        "delta": 0.058
      },
      {
        "periodo": 202601,
        "valor": 1.0532,
        "delta": -0.0675
      },
      {
        "periodo": 202602,
        "valor": 1.0056,
        "delta": -0.0476
      },
      {
        "periodo": 202603,
        "valor": 0.9662,
        "delta": -0.0394
      },
      {
        "periodo": 202604,
        "valor": 0.9765,
        "delta": 0.0103
      },
      {
        "periodo": 202605,
        "valor": 0.9543,
        "delta": -0.0222
      },
      {
        "periodo": 202606,
        "valor": 0.9634,
        "delta": 0.0091
      },
      {
        "periodo": 202607,
        "valor": 0.9599,
        "delta": -0.0035
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 0.084652,
    "valor_anterior": 0.419141,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.3501,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.5827,
        "delta": 0.2327
      },
      {
        "periodo": 202509,
        "valor": 2.1075,
        "delta": -0.4752
      },
      {
        "periodo": 202510,
        "valor": 1.7654,
        "delta": -0.3421
      },
      {
        "periodo": 202511,
        "valor": 1.1249,
        "delta": -0.6405
      },
      {
        "periodo": 202512,
        "valor": 0.7894,
        "delta": -0.3355
      },
      {
        "periodo": 202601,
        "valor": 1.0636,
        "delta": 0.2743
      },
      {
        "periodo": 202602,
        "valor": 1.1105,
        "delta": 0.0469
      },
      {
        "periodo": 202603,
        "valor": 0.6817,
        "delta": -0.4289
      },
      {
        "periodo": 202604,
        "valor": 0.5318,
        "delta": -0.1499
      },
      {
        "periodo": 202605,
        "valor": 0.0427,
        "delta": -0.4891
      },
      {
        "periodo": 202606,
        "valor": 0.4191,
        "delta": 0.3765
      },
      {
        "periodo": 202607,
        "valor": 0.0847,
        "delta": -0.3345
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": -0.36095900000000003,
    "valor_anterior": -1.24773,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -21.5377,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -19.3907,
        "delta": 2.1469
      },
      {
        "periodo": 202509,
        "valor": -18.021,
        "delta": 1.3697
      },
      {
        "periodo": 202510,
        "valor": -15.6644,
        "delta": 2.3566
      },
      {
        "periodo": 202511,
        "valor": -10.3611,
        "delta": 5.3033
      },
      {
        "periodo": 202512,
        "valor": -7.4803,
        "delta": 2.8807
      },
      {
        "periodo": 202601,
        "valor": -6.3931,
        "delta": 1.0872
      },
      {
        "periodo": 202602,
        "valor": -5.0415,
        "delta": 1.3516
      },
      {
        "periodo": 202603,
        "valor": -3.9147,
        "delta": 1.1268
      },
      {
        "periodo": 202604,
        "valor": -3.5561,
        "delta": 0.3586
      },
      {
        "periodo": 202605,
        "valor": -2.2215,
        "delta": 1.3345
      },
      {
        "periodo": 202606,
        "valor": -1.2477,
        "delta": 0.9738
      },
      {
        "periodo": 202607,
        "valor": -0.361,
        "delta": 0.8868
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": -7.5754269999999995,
    "valor_anterior": -7.273168000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1.8792,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2.8066,
        "delta": -0.9274
      },
      {
        "periodo": 202509,
        "valor": -2.9401,
        "delta": -0.1335
      },
      {
        "periodo": 202510,
        "valor": -3.599,
        "delta": -0.6589
      },
      {
        "periodo": 202511,
        "valor": -4.0854,
        "delta": -0.4864
      },
      {
        "periodo": 202512,
        "valor": -5.5983,
        "delta": -1.5129
      },
      {
        "periodo": 202601,
        "valor": -6.071,
        "delta": -0.4727
      },
      {
        "periodo": 202602,
        "valor": -6.2427,
        "delta": -0.1717
      },
      {
        "periodo": 202603,
        "valor": -6.5793,
        "delta": -0.3365
      },
      {
        "periodo": 202604,
        "valor": -6.7073,
        "delta": -0.128
      },
      {
        "periodo": 202605,
        "valor": -6.8349,
        "delta": -0.1276
      },
      {
        "periodo": 202606,
        "valor": -7.2732,
        "delta": -0.4383
      },
      {
        "periodo": 202607,
        "valor": -7.5754,
        "delta": -0.3023
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 0.777698,
    "valor_anterior": 0.737028,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.154,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.071,
        "delta": -0.083
      },
      {
        "periodo": 202509,
        "valor": 1.0658,
        "delta": -0.0053
      },
      {
        "periodo": 202510,
        "valor": 0.9813,
        "delta": -0.0844
      },
      {
        "periodo": 202511,
        "valor": 0.9283,
        "delta": -0.053
      },
      {
        "periodo": 202512,
        "valor": 0.8807,
        "delta": -0.0476
      },
      {
        "periodo": 202601,
        "valor": 0.9247,
        "delta": 0.044
      },
      {
        "periodo": 202602,
        "valor": 0.884,
        "delta": -0.0406
      },
      {
        "periodo": 202603,
        "valor": 0.8376,
        "delta": -0.0465
      },
      {
        "periodo": 202604,
        "valor": 0.8216,
        "delta": -0.016
      },
      {
        "periodo": 202605,
        "valor": 0.7476,
        "delta": -0.074
      },
      {
        "periodo": 202606,
        "valor": 0.737,
        "delta": -0.0106
      },
      {
        "periodo": 202607,
        "valor": 0.7777,
        "delta": 0.0407
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": -0.8540249999999999,
    "valor_anterior": -1.249278,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -5.0866,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -4.6487,
        "delta": 0.438
      },
      {
        "periodo": 202509,
        "valor": -4.3926,
        "delta": 0.2561
      },
      {
        "periodo": 202510,
        "valor": -4.0427,
        "delta": 0.3499
      },
      {
        "periodo": 202511,
        "valor": -3.9664,
        "delta": 0.0764
      },
      {
        "periodo": 202512,
        "valor": -3.5832,
        "delta": 0.3831
      },
      {
        "periodo": 202601,
        "valor": -3.1244,
        "delta": 0.4588
      },
      {
        "periodo": 202602,
        "valor": -2.6707,
        "delta": 0.4537
      },
      {
        "periodo": 202603,
        "valor": -2.4346,
        "delta": 0.2362
      },
      {
        "periodo": 202604,
        "valor": -2.0301,
        "delta": 0.4045
      },
      {
        "periodo": 202605,
        "valor": -1.6637,
        "delta": 0.3663
      },
      {
        "periodo": 202606,
        "valor": -1.2493,
        "delta": 0.4145
      },
      {
        "periodo": 202607,
        "valor": -0.854,
        "delta": 0.3953
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.8697840000000001,
    "valor_anterior": 1.89902,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.8937,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.9613,
        "delta": 0.0677
      },
      {
        "periodo": 202509,
        "valor": 1.9912,
        "delta": 0.0298
      },
      {
        "periodo": 202510,
        "valor": 2.0965,
        "delta": 0.1053
      },
      {
        "periodo": 202511,
        "valor": 2.0893,
        "delta": -0.0072
      },
      {
        "periodo": 202512,
        "valor": 2.0762,
        "delta": -0.0131
      },
      {
        "periodo": 202601,
        "valor": 2.0484,
        "delta": -0.0278
      },
      {
        "periodo": 202602,
        "valor": 2.0179,
        "delta": -0.0305
      },
      {
        "periodo": 202603,
        "valor": 1.8859,
        "delta": -0.132
      },
      {
        "periodo": 202604,
        "valor": 1.8967,
        "delta": 0.0108
      },
      {
        "periodo": 202605,
        "valor": 1.9238,
        "delta": 0.0271
      },
      {
        "periodo": 202606,
        "valor": 1.899,
        "delta": -0.0248
      },
      {
        "periodo": 202607,
        "valor": 1.8698,
        "delta": -0.0292
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.69602,
    "valor_anterior": 1.6694520000000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.5189,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.5705,
        "delta": 0.0516
      },
      {
        "periodo": 202509,
        "valor": 1.5036,
        "delta": -0.0669
      },
      {
        "periodo": 202510,
        "valor": 1.3739,
        "delta": -0.1297
      },
      {
        "periodo": 202511,
        "valor": 1.4782,
        "delta": 0.1042
      },
      {
        "periodo": 202512,
        "valor": 1.565,
        "delta": 0.0868
      },
      {
        "periodo": 202601,
        "valor": 1.5208,
        "delta": -0.0442
      },
      {
        "periodo": 202602,
        "valor": 1.516,
        "delta": -0.0048
      },
      {
        "periodo": 202603,
        "valor": 1.6257,
        "delta": 0.1097
      },
      {
        "periodo": 202604,
        "valor": 1.5482,
        "delta": -0.0775
      },
      {
        "periodo": 202605,
        "valor": 1.5448,
        "delta": -0.0034
      },
      {
        "periodo": 202606,
        "valor": 1.6695,
        "delta": 0.1246
      },
      {
        "periodo": 202607,
        "valor": 1.696,
        "delta": 0.0266
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.538733,
    "valor_anterior": 1.809504,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.3246,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.2784,
        "delta": -0.0463
      },
      {
        "periodo": 202509,
        "valor": 2.3146,
        "delta": 0.0362
      },
      {
        "periodo": 202510,
        "valor": 2.3223,
        "delta": 0.0077
      },
      {
        "periodo": 202511,
        "valor": 2.2866,
        "delta": -0.0357
      },
      {
        "periodo": 202512,
        "valor": 2.2879,
        "delta": 0.0013
      },
      {
        "periodo": 202601,
        "valor": 2.2744,
        "delta": -0.0134
      },
      {
        "periodo": 202602,
        "valor": 2.3311,
        "delta": 0.0566
      },
      {
        "periodo": 202603,
        "valor": 2.1563,
        "delta": -0.1748
      },
      {
        "periodo": 202604,
        "valor": 1.8282,
        "delta": -0.3281
      },
      {
        "periodo": 202605,
        "valor": 1.9414,
        "delta": 0.1132
      },
      {
        "periodo": 202606,
        "valor": 1.8095,
        "delta": -0.1319
      },
      {
        "periodo": 202607,
        "valor": 1.5387,
        "delta": -0.2708
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 0.915343,
    "valor_anterior": 0.879326,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.8903,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.9107,
        "delta": 0.0204
      },
      {
        "periodo": 202509,
        "valor": 0.9416,
        "delta": 0.0309
      },
      {
        "periodo": 202510,
        "valor": 0.9375,
        "delta": -0.0041
      },
      {
        "periodo": 202511,
        "valor": 0.9166,
        "delta": -0.0209
      },
      {
        "periodo": 202512,
        "valor": 0.917,
        "delta": 0.0004
      },
      {
        "periodo": 202601,
        "valor": 0.904,
        "delta": -0.013
      },
      {
        "periodo": 202602,
        "valor": 0.8764,
        "delta": -0.0276
      },
      {
        "periodo": 202603,
        "valor": 0.8577,
        "delta": -0.0187
      },
      {
        "periodo": 202604,
        "valor": 0.8484,
        "delta": -0.0092
      },
      {
        "periodo": 202605,
        "valor": 0.8543,
        "delta": 0.0058
      },
      {
        "periodo": 202606,
        "valor": 0.8793,
        "delta": 0.0251
      },
      {
        "periodo": 202607,
        "valor": 0.9153,
        "delta": 0.036
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.7631210000000002,
    "valor_anterior": 1.530836,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.7688,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.8179,
        "delta": 0.0491
      },
      {
        "periodo": 202509,
        "valor": 1.7669,
        "delta": -0.0511
      },
      {
        "periodo": 202510,
        "valor": 1.7564,
        "delta": -0.0105
      },
      {
        "periodo": 202511,
        "valor": 1.7531,
        "delta": -0.0032
      },
      {
        "periodo": 202512,
        "valor": 1.6618,
        "delta": -0.0913
      },
      {
        "periodo": 202601,
        "valor": 1.5977,
        "delta": -0.0641
      },
      {
        "periodo": 202602,
        "valor": 1.5822,
        "delta": -0.0155
      },
      {
        "periodo": 202603,
        "valor": 1.6143,
        "delta": 0.0321
      },
      {
        "periodo": 202604,
        "valor": 1.6044,
        "delta": -0.0099
      },
      {
        "periodo": 202605,
        "valor": 1.5941,
        "delta": -0.0103
      },
      {
        "periodo": 202606,
        "valor": 1.5308,
        "delta": -0.0632
      },
      {
        "periodo": 202607,
        "valor": 1.7631,
        "delta": 0.2323
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 2.172755,
    "valor_anterior": 2.2430329999999996,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.769,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.5354,
        "delta": -0.2336
      },
      {
        "periodo": 202509,
        "valor": 3.5517,
        "delta": 0.0164
      },
      {
        "periodo": 202510,
        "valor": 3.4241,
        "delta": -0.1276
      },
      {
        "periodo": 202511,
        "valor": 3.2474,
        "delta": -0.1767
      },
      {
        "periodo": 202512,
        "valor": 3.1436,
        "delta": -0.1038
      },
      {
        "periodo": 202601,
        "valor": 2.8857,
        "delta": -0.2579
      },
      {
        "periodo": 202602,
        "valor": 2.8562,
        "delta": -0.0295
      },
      {
        "periodo": 202603,
        "valor": 2.5188,
        "delta": -0.3374
      },
      {
        "periodo": 202604,
        "valor": 2.4096,
        "delta": -0.1093
      },
      {
        "periodo": 202605,
        "valor": 2.2833,
        "delta": -0.1263
      },
      {
        "periodo": 202606,
        "valor": 2.243,
        "delta": -0.0402
      },
      {
        "periodo": 202607,
        "valor": 2.1728,
        "delta": -0.0703
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.294755,
    "valor_anterior": 1.54083,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.7082,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.9969,
        "delta": 0.2887
      },
      {
        "periodo": 202509,
        "valor": 1.9959,
        "delta": -0.001
      },
      {
        "periodo": 202510,
        "valor": 2.0706,
        "delta": 0.0747
      },
      {
        "periodo": 202511,
        "valor": 2.143,
        "delta": 0.0725
      },
      {
        "periodo": 202512,
        "valor": 2.096,
        "delta": -0.047
      },
      {
        "periodo": 202601,
        "valor": 2.0798,
        "delta": -0.0162
      },
      {
        "periodo": 202602,
        "valor": 1.9466,
        "delta": -0.1332
      },
      {
        "periodo": 202603,
        "valor": 2.0428,
        "delta": 0.0962
      },
      {
        "periodo": 202604,
        "valor": 1.4902,
        "delta": -0.5526
      },
      {
        "periodo": 202605,
        "valor": 1.512,
        "delta": 0.0217
      },
      {
        "periodo": 202606,
        "valor": 1.5408,
        "delta": 0.0289
      },
      {
        "periodo": 202607,
        "valor": 1.2948,
        "delta": -0.2461
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 4.674026,
    "valor_anterior": 4.682407,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5.5993,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5.4365,
        "delta": -0.1627
      },
      {
        "periodo": 202509,
        "valor": 5.3316,
        "delta": -0.1049
      },
      {
        "periodo": 202510,
        "valor": 5.4305,
        "delta": 0.0989
      },
      {
        "periodo": 202511,
        "valor": 5.285,
        "delta": -0.1456
      },
      {
        "periodo": 202512,
        "valor": 5.244,
        "delta": -0.041
      },
      {
        "periodo": 202601,
        "valor": 4.9529,
        "delta": -0.2911
      },
      {
        "periodo": 202602,
        "valor": 4.979,
        "delta": 0.0261
      },
      {
        "periodo": 202603,
        "valor": 4.6983,
        "delta": -0.2807
      },
      {
        "periodo": 202604,
        "valor": 4.6667,
        "delta": -0.0316
      },
      {
        "periodo": 202605,
        "valor": 4.5738,
        "delta": -0.0929
      },
      {
        "periodo": 202606,
        "valor": 4.6824,
        "delta": 0.1086
      },
      {
        "periodo": 202607,
        "valor": 4.674,
        "delta": -0.0084
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 0.731221,
    "valor_anterior": 0.740242,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.8084,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.7634,
        "delta": -0.045
      },
      {
        "periodo": 202509,
        "valor": 0.7604,
        "delta": -0.003
      },
      {
        "periodo": 202510,
        "valor": 0.7591,
        "delta": -0.0013
      },
      {
        "periodo": 202511,
        "valor": 0.7457,
        "delta": -0.0134
      },
      {
        "periodo": 202512,
        "valor": 0.7319,
        "delta": -0.0139
      },
      {
        "periodo": 202601,
        "valor": 0.6297,
        "delta": -0.1021
      },
      {
        "periodo": 202602,
        "valor": 0.6248,
        "delta": -0.0049
      },
      {
        "periodo": 202603,
        "valor": 0.6459,
        "delta": 0.0211
      },
      {
        "periodo": 202604,
        "valor": 0.6449,
        "delta": -0.001
      },
      {
        "periodo": 202605,
        "valor": 0.694,
        "delta": 0.0491
      },
      {
        "periodo": 202606,
        "valor": 0.7402,
        "delta": 0.0462
      },
      {
        "periodo": 202607,
        "valor": 0.7312,
        "delta": -0.009
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.0432379999999999,
    "valor_anterior": 1.271792,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.5031,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.4431,
        "delta": -0.06
      },
      {
        "periodo": 202509,
        "valor": 0.6957,
        "delta": -0.7474
      },
      {
        "periodo": 202510,
        "valor": 0.6051,
        "delta": -0.0906
      },
      {
        "periodo": 202511,
        "valor": 0.669,
        "delta": 0.0639
      },
      {
        "periodo": 202512,
        "valor": 1.377,
        "delta": 0.708
      },
      {
        "periodo": 202601,
        "valor": 1.4556,
        "delta": 0.0786
      },
      {
        "periodo": 202602,
        "valor": 1.4561,
        "delta": 0.0005
      },
      {
        "periodo": 202603,
        "valor": 1.3208,
        "delta": -0.1353
      },
      {
        "periodo": 202604,
        "valor": 1.1315,
        "delta": -0.1893
      },
      {
        "periodo": 202605,
        "valor": 1.262,
        "delta": 0.1305
      },
      {
        "periodo": 202606,
        "valor": 1.2718,
        "delta": 0.0098
      },
      {
        "periodo": 202607,
        "valor": 1.0432,
        "delta": -0.2286
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": -23.942584,
    "valor_anterior": -24.463509,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -30.3463,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -30.1487,
        "delta": 0.1976
      },
      {
        "periodo": 202509,
        "valor": -30.4561,
        "delta": -0.3074
      },
      {
        "periodo": 202510,
        "valor": -29.3124,
        "delta": 1.1437
      },
      {
        "periodo": 202511,
        "valor": -28.1296,
        "delta": 1.1828
      },
      {
        "periodo": 202512,
        "valor": -27.0112,
        "delta": 1.1184
      },
      {
        "periodo": 202601,
        "valor": -26.2432,
        "delta": 0.768
      },
      {
        "periodo": 202602,
        "valor": -25.5504,
        "delta": 0.6928
      },
      {
        "periodo": 202603,
        "valor": -24.7306,
        "delta": 0.8198
      },
      {
        "periodo": 202604,
        "valor": -24.647,
        "delta": 0.0836
      },
      {
        "periodo": 202605,
        "valor": -24.4277,
        "delta": 0.2193
      },
      {
        "periodo": 202606,
        "valor": -24.4635,
        "delta": -0.0358
      },
      {
        "periodo": 202607,
        "valor": -23.9426,
        "delta": 0.5209
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 2.00896,
    "valor_anterior": 2.21109,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 4.0279,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 3.1282,
        "delta": -0.8996
      },
      {
        "periodo": 202603,
        "valor": 2.8313,
        "delta": -0.2969
      },
      {
        "periodo": 202604,
        "valor": 2.1945,
        "delta": -0.6368
      },
      {
        "periodo": 202605,
        "valor": 1.9981,
        "delta": -0.1964
      },
      {
        "periodo": 202606,
        "valor": 2.2111,
        "delta": 0.213
      },
      {
        "periodo": 202607,
        "valor": 2.009,
        "delta": -0.2021
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": -10.558436,
    "valor_anterior": -10.935379000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": -21.5591,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": -16.188,
        "delta": 5.3712
      },
      {
        "periodo": 202512,
        "valor": -14.9259,
        "delta": 1.2621
      },
      {
        "periodo": 202601,
        "valor": -13.9764,
        "delta": 0.9495
      },
      {
        "periodo": 202602,
        "valor": -13.0904,
        "delta": 0.886
      },
      {
        "periodo": 202603,
        "valor": -12.4089,
        "delta": 0.6814
      },
      {
        "periodo": 202604,
        "valor": -11.8348,
        "delta": 0.5741
      },
      {
        "periodo": 202605,
        "valor": -11.4015,
        "delta": 0.4333
      },
      {
        "periodo": 202606,
        "valor": -10.9354,
        "delta": 0.4661
      },
      {
        "periodo": 202607,
        "valor": -10.5584,
        "delta": 0.3769
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.901781,
    "valor_anterior": 1.916944,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.9687,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.9621,
        "delta": -0.0066
      },
      {
        "periodo": 202509,
        "valor": 1.9305,
        "delta": -0.0316
      },
      {
        "periodo": 202510,
        "valor": 1.9325,
        "delta": 0.002
      },
      {
        "periodo": 202511,
        "valor": 1.9529,
        "delta": 0.0204
      },
      {
        "periodo": 202512,
        "valor": 1.9795,
        "delta": 0.0266
      },
      {
        "periodo": 202601,
        "valor": 1.9823,
        "delta": 0.0029
      },
      {
        "periodo": 202602,
        "valor": 1.9626,
        "delta": -0.0197
      },
      {
        "periodo": 202603,
        "valor": 1.9918,
        "delta": 0.0292
      },
      {
        "periodo": 202604,
        "valor": 1.9839,
        "delta": -0.0079
      },
      {
        "periodo": 202605,
        "valor": 1.9425,
        "delta": -0.0414
      },
      {
        "periodo": 202606,
        "valor": 1.9169,
        "delta": -0.0256
      },
      {
        "periodo": 202607,
        "valor": 1.9018,
        "delta": -0.0152
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 2.157511,
    "valor_anterior": 2.1653909999999996,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.128,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.1355,
        "delta": 0.0075
      },
      {
        "periodo": 202509,
        "valor": 2.097,
        "delta": -0.0385
      },
      {
        "periodo": 202510,
        "valor": 2.0991,
        "delta": 0.002
      },
      {
        "periodo": 202511,
        "valor": 2.1438,
        "delta": 0.0448
      },
      {
        "periodo": 202512,
        "valor": 2.1632,
        "delta": 0.0194
      },
      {
        "periodo": 202601,
        "valor": 2.1816,
        "delta": 0.0184
      },
      {
        "periodo": 202602,
        "valor": 2.1573,
        "delta": -0.0244
      },
      {
        "periodo": 202603,
        "valor": 2.229,
        "delta": 0.0717
      },
      {
        "periodo": 202604,
        "valor": 2.2229,
        "delta": -0.0061
      },
      {
        "periodo": 202605,
        "valor": 2.1777,
        "delta": -0.0452
      },
      {
        "periodo": 202606,
        "valor": 2.1654,
        "delta": -0.0123
      },
      {
        "periodo": 202607,
        "valor": 2.1575,
        "delta": -0.0079
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 0.8232200000000001,
    "valor_anterior": 0.785305,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.3011,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.111,
        "delta": -0.1901
      },
      {
        "periodo": 202509,
        "valor": 1.1481,
        "delta": 0.0371
      },
      {
        "periodo": 202510,
        "valor": 1.1073,
        "delta": -0.0409
      },
      {
        "periodo": 202511,
        "valor": 1.0666,
        "delta": -0.0407
      },
      {
        "periodo": 202512,
        "valor": 0.9956,
        "delta": -0.071
      },
      {
        "periodo": 202601,
        "valor": 0.9883,
        "delta": -0.0073
      },
      {
        "periodo": 202602,
        "valor": 0.9989,
        "delta": 0.0106
      },
      {
        "periodo": 202603,
        "valor": 0.916,
        "delta": -0.0829
      },
      {
        "periodo": 202604,
        "valor": 0.9037,
        "delta": -0.0123
      },
      {
        "periodo": 202605,
        "valor": 0.8755,
        "delta": -0.0283
      },
      {
        "periodo": 202606,
        "valor": 0.7853,
        "delta": -0.0901
      },
      {
        "periodo": 202607,
        "valor": 0.8232,
        "delta": 0.0379
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.136355,
    "valor_anterior": 1.171396,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.102,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.1351,
        "delta": 0.0331
      },
      {
        "periodo": 202509,
        "valor": 1.1306,
        "delta": -0.0045
      },
      {
        "periodo": 202510,
        "valor": 1.165,
        "delta": 0.0344
      },
      {
        "periodo": 202511,
        "valor": 1.1422,
        "delta": -0.0228
      },
      {
        "periodo": 202512,
        "valor": 1.2773,
        "delta": 0.1351
      },
      {
        "periodo": 202601,
        "valor": 1.2239,
        "delta": -0.0534
      },
      {
        "periodo": 202602,
        "valor": 1.239,
        "delta": 0.0151
      },
      {
        "periodo": 202603,
        "valor": 1.1659,
        "delta": -0.0731
      },
      {
        "periodo": 202604,
        "valor": 1.1834,
        "delta": 0.0176
      },
      {
        "periodo": 202605,
        "valor": 1.2085,
        "delta": 0.0251
      },
      {
        "periodo": 202606,
        "valor": 1.1714,
        "delta": -0.0371
      },
      {
        "periodo": 202607,
        "valor": 1.1364,
        "delta": -0.035
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.7323330000000001,
    "valor_anterior": 1.739174,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.0375,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.0141,
        "delta": -0.0235
      },
      {
        "periodo": 202509,
        "valor": 1.9908,
        "delta": -0.0233
      },
      {
        "periodo": 202510,
        "valor": 1.981,
        "delta": -0.0098
      },
      {
        "periodo": 202511,
        "valor": 1.9533,
        "delta": -0.0277
      },
      {
        "periodo": 202512,
        "valor": 1.902,
        "delta": -0.0513
      },
      {
        "periodo": 202601,
        "valor": 1.8706,
        "delta": -0.0314
      },
      {
        "periodo": 202602,
        "valor": 1.817,
        "delta": -0.0536
      },
      {
        "periodo": 202603,
        "valor": 1.7855,
        "delta": -0.0315
      },
      {
        "periodo": 202604,
        "valor": 1.7696,
        "delta": -0.0159
      },
      {
        "periodo": 202605,
        "valor": 1.7463,
        "delta": -0.0234
      },
      {
        "periodo": 202606,
        "valor": 1.7392,
        "delta": -0.0071
      },
      {
        "periodo": 202607,
        "valor": 1.7323,
        "delta": -0.0068
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.172039,
    "valor_anterior": 1.160159,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.1049,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.1451,
        "delta": 0.0402
      },
      {
        "periodo": 202509,
        "valor": 1.2258,
        "delta": 0.0808
      },
      {
        "periodo": 202510,
        "valor": 1.2231,
        "delta": -0.0027
      },
      {
        "periodo": 202511,
        "valor": 1.1379,
        "delta": -0.0852
      },
      {
        "periodo": 202512,
        "valor": 1.1713,
        "delta": 0.0334
      },
      {
        "periodo": 202601,
        "valor": 1.2161,
        "delta": 0.0448
      },
      {
        "periodo": 202602,
        "valor": 1.1869,
        "delta": -0.0292
      },
      {
        "periodo": 202603,
        "valor": 1.1719,
        "delta": -0.015
      },
      {
        "periodo": 202604,
        "valor": 1.1509,
        "delta": -0.021
      },
      {
        "periodo": 202605,
        "valor": 1.1694,
        "delta": 0.0185
      },
      {
        "periodo": 202606,
        "valor": 1.1602,
        "delta": -0.0092
      },
      {
        "periodo": 202607,
        "valor": 1.172,
        "delta": 0.0119
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200001,
    "label": "ROA",
    "valor_actual": 1.201401,
    "valor_anterior": 1.37126,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.3223,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.2595,
        "delta": -0.0628
      },
      {
        "periodo": 202509,
        "valor": 2.1996,
        "delta": -0.0599
      },
      {
        "periodo": 202510,
        "valor": 2.2343,
        "delta": 0.0347
      },
      {
        "periodo": 202511,
        "valor": 2.2169,
        "delta": -0.0174
      },
      {
        "periodo": 202512,
        "valor": 2.2792,
        "delta": 0.0623
      },
      {
        "periodo": 202601,
        "valor": 2.192,
        "delta": -0.0872
      },
      {
        "periodo": 202602,
        "valor": 2.1681,
        "delta": -0.0239
      },
      {
        "periodo": 202603,
        "valor": 1.9753,
        "delta": -0.1928
      },
      {
        "periodo": 202604,
        "valor": 1.8639,
        "delta": -0.1113
      },
      {
        "periodo": 202605,
        "valor": 1.6005,
        "delta": -0.2635
      },
      {
        "periodo": 202606,
        "valor": 1.3713,
        "delta": -0.2292
      },
      {
        "periodo": 202607,
        "valor": 1.2014,
        "delta": -0.1699
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 11.483096,
    "valor_anterior": 11.286833,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8.8335,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.5237,
        "delta": -0.3098
      },
      {
        "periodo": 202509,
        "valor": 7.9402,
        "delta": -0.5835
      },
      {
        "periodo": 202510,
        "valor": 7.1678,
        "delta": -0.7724
      },
      {
        "periodo": 202511,
        "valor": 8.5899,
        "delta": 1.4221
      },
      {
        "periodo": 202512,
        "valor": 9.0994,
        "delta": 0.5095
      },
      {
        "periodo": 202601,
        "valor": 9.5226,
        "delta": 0.4232
      },
      {
        "periodo": 202602,
        "valor": 9.8411,
        "delta": 0.3184
      },
      {
        "periodo": 202603,
        "valor": 11.393,
        "delta": 1.552
      },
      {
        "periodo": 202604,
        "valor": 11.1492,
        "delta": -0.2438
      },
      {
        "periodo": 202605,
        "valor": 11.0822,
        "delta": -0.067
      },
      {
        "periodo": 202606,
        "valor": 11.2868,
        "delta": 0.2046
      },
      {
        "periodo": 202607,
        "valor": 11.4831,
        "delta": 0.1963
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 24.104389,
    "valor_anterior": 24.005050999999998,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25.7504,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25.8935,
        "delta": 0.1431
      },
      {
        "periodo": 202509,
        "valor": 25.4363,
        "delta": -0.4573
      },
      {
        "periodo": 202510,
        "valor": 25.5768,
        "delta": 0.1405
      },
      {
        "periodo": 202511,
        "valor": 25.545,
        "delta": -0.0318
      },
      {
        "periodo": 202512,
        "valor": 25.2991,
        "delta": -0.2459
      },
      {
        "periodo": 202601,
        "valor": 25.1024,
        "delta": -0.1967
      },
      {
        "periodo": 202602,
        "valor": 24.2461,
        "delta": -0.8563
      },
      {
        "periodo": 202603,
        "valor": 24.4634,
        "delta": 0.2173
      },
      {
        "periodo": 202604,
        "valor": 24.4068,
        "delta": -0.0567
      },
      {
        "periodo": 202605,
        "valor": 24.1041,
        "delta": -0.3026
      },
      {
        "periodo": 202606,
        "valor": 24.0051,
        "delta": -0.0991
      },
      {
        "periodo": 202607,
        "valor": 24.1044,
        "delta": 0.0993
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 20.707297999999998,
    "valor_anterior": 20.781062,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18.6195,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18.8618,
        "delta": 0.2423
      },
      {
        "periodo": 202509,
        "valor": 18.8839,
        "delta": 0.0221
      },
      {
        "periodo": 202510,
        "valor": 19.4086,
        "delta": 0.5248
      },
      {
        "periodo": 202511,
        "valor": 19.2211,
        "delta": -0.1876
      },
      {
        "periodo": 202512,
        "valor": 19.9535,
        "delta": 0.7324
      },
      {
        "periodo": 202601,
        "valor": 20.2169,
        "delta": 0.2634
      },
      {
        "periodo": 202602,
        "valor": 20.3208,
        "delta": 0.1039
      },
      {
        "periodo": 202603,
        "valor": 21.2654,
        "delta": 0.9446
      },
      {
        "periodo": 202604,
        "valor": 21.4717,
        "delta": 0.2063
      },
      {
        "periodo": 202605,
        "valor": 20.5425,
        "delta": -0.9291
      },
      {
        "periodo": 202606,
        "valor": 20.7811,
        "delta": 0.2385
      },
      {
        "periodo": 202607,
        "valor": 20.7073,
        "delta": -0.0738
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 7.006039,
    "valor_anterior": 7.430739999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7.7701,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.0945,
        "delta": 0.3244
      },
      {
        "periodo": 202509,
        "valor": 8.0429,
        "delta": -0.0517
      },
      {
        "periodo": 202510,
        "valor": 7.8458,
        "delta": -0.1971
      },
      {
        "periodo": 202511,
        "valor": 9.7135,
        "delta": 1.8677
      },
      {
        "periodo": 202512,
        "valor": 8.5307,
        "delta": -1.1828
      },
      {
        "periodo": 202601,
        "valor": 8.9702,
        "delta": 0.4395
      },
      {
        "periodo": 202602,
        "valor": 8.9666,
        "delta": -0.0036
      },
      {
        "periodo": 202603,
        "valor": 9.96,
        "delta": 0.9934
      },
      {
        "periodo": 202604,
        "valor": 9.3859,
        "delta": -0.5741
      },
      {
        "periodo": 202605,
        "valor": 8.8188,
        "delta": -0.5671
      },
      {
        "periodo": 202606,
        "valor": 7.4307,
        "delta": -1.388
      },
      {
        "periodo": 202607,
        "valor": 7.006,
        "delta": -0.4247
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 17.792880999999998,
    "valor_anterior": 18.046568,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21.2814,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21.0458,
        "delta": -0.2356
      },
      {
        "periodo": 202509,
        "valor": 20.7588,
        "delta": -0.287
      },
      {
        "periodo": 202510,
        "valor": 20.4812,
        "delta": -0.2777
      },
      {
        "periodo": 202511,
        "valor": 20.1844,
        "delta": -0.2968
      },
      {
        "periodo": 202512,
        "valor": 19.5897,
        "delta": -0.5946
      },
      {
        "periodo": 202601,
        "valor": 19.2633,
        "delta": -0.3264
      },
      {
        "periodo": 202602,
        "valor": 18.7567,
        "delta": -0.5066
      },
      {
        "periodo": 202603,
        "valor": 18.4002,
        "delta": -0.3565
      },
      {
        "periodo": 202604,
        "valor": 18.2816,
        "delta": -0.1186
      },
      {
        "periodo": 202605,
        "valor": 18.0418,
        "delta": -0.2398
      },
      {
        "periodo": 202606,
        "valor": 18.0466,
        "delta": 0.0047
      },
      {
        "periodo": 202607,
        "valor": 17.7929,
        "delta": -0.2537
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 8.967319,
    "valor_anterior": 9.505044,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.9616,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.6284,
        "delta": -0.3332
      },
      {
        "periodo": 202509,
        "valor": 11.9769,
        "delta": -0.6515
      },
      {
        "periodo": 202510,
        "valor": 11.8421,
        "delta": -0.1349
      },
      {
        "periodo": 202511,
        "valor": 11.6542,
        "delta": -0.1879
      },
      {
        "periodo": 202512,
        "valor": 11.3295,
        "delta": -0.3247
      },
      {
        "periodo": 202601,
        "valor": 11.3656,
        "delta": 0.0361
      },
      {
        "periodo": 202602,
        "valor": 10.9763,
        "delta": -0.3893
      },
      {
        "periodo": 202603,
        "valor": 10.69,
        "delta": -0.2862
      },
      {
        "periodo": 202604,
        "valor": 10.4935,
        "delta": -0.1966
      },
      {
        "periodo": 202605,
        "valor": 9.9829,
        "delta": -0.5106
      },
      {
        "periodo": 202606,
        "valor": 9.505,
        "delta": -0.4778
      },
      {
        "periodo": 202607,
        "valor": 8.9673,
        "delta": -0.5377
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 21.007677,
    "valor_anterior": 21.1896,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 23.0024,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 22.9078,
        "delta": -0.0946
      },
      {
        "periodo": 202509,
        "valor": 22.8498,
        "delta": -0.0581
      },
      {
        "periodo": 202510,
        "valor": 22.8217,
        "delta": -0.0281
      },
      {
        "periodo": 202511,
        "valor": 22.8164,
        "delta": -0.0053
      },
      {
        "periodo": 202512,
        "valor": 22.3442,
        "delta": -0.4722
      },
      {
        "periodo": 202601,
        "valor": 22.4277,
        "delta": 0.0835
      },
      {
        "periodo": 202602,
        "valor": 22.2393,
        "delta": -0.1884
      },
      {
        "periodo": 202603,
        "valor": 22.0554,
        "delta": -0.1839
      },
      {
        "periodo": 202604,
        "valor": 21.7566,
        "delta": -0.2988
      },
      {
        "periodo": 202605,
        "valor": 21.4189,
        "delta": -0.3377
      },
      {
        "periodo": 202606,
        "valor": 21.1896,
        "delta": -0.2293
      },
      {
        "periodo": 202607,
        "valor": 21.0077,
        "delta": -0.1819
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 12.863658000000001,
    "valor_anterior": 12.653785000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11.7523,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.5271,
        "delta": -0.2252
      },
      {
        "periodo": 202509,
        "valor": 11.5527,
        "delta": 0.0257
      },
      {
        "periodo": 202510,
        "valor": 11.198,
        "delta": -0.3548
      },
      {
        "periodo": 202511,
        "valor": 10.9142,
        "delta": -0.2838
      },
      {
        "periodo": 202512,
        "valor": 11.108,
        "delta": 0.1937
      },
      {
        "periodo": 202601,
        "valor": 11.4257,
        "delta": 0.3178
      },
      {
        "periodo": 202602,
        "valor": 11.6777,
        "delta": 0.2519
      },
      {
        "periodo": 202603,
        "valor": 12.9632,
        "delta": 1.2856
      },
      {
        "periodo": 202604,
        "valor": 12.6535,
        "delta": -0.3097
      },
      {
        "periodo": 202605,
        "valor": 12.4635,
        "delta": -0.19
      },
      {
        "periodo": 202606,
        "valor": 12.6538,
        "delta": 0.1903
      },
      {
        "periodo": 202607,
        "valor": 12.8637,
        "delta": 0.2099
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 18.097548999999997,
    "valor_anterior": 18.122499,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21.3434,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21.182,
        "delta": -0.1614
      },
      {
        "periodo": 202509,
        "valor": 20.8979,
        "delta": -0.2841
      },
      {
        "periodo": 202510,
        "valor": 20.7837,
        "delta": -0.1142
      },
      {
        "periodo": 202511,
        "valor": 20.2536,
        "delta": -0.5301
      },
      {
        "periodo": 202512,
        "valor": 19.9199,
        "delta": -0.3337
      },
      {
        "periodo": 202601,
        "valor": 19.5497,
        "delta": -0.3702
      },
      {
        "periodo": 202602,
        "valor": 19.1799,
        "delta": -0.3697
      },
      {
        "periodo": 202603,
        "valor": 18.9858,
        "delta": -0.1941
      },
      {
        "periodo": 202604,
        "valor": 18.8599,
        "delta": -0.1259
      },
      {
        "periodo": 202605,
        "valor": 18.6273,
        "delta": -0.2326
      },
      {
        "periodo": 202606,
        "valor": 18.1225,
        "delta": -0.5048
      },
      {
        "periodo": 202607,
        "valor": 18.0975,
        "delta": -0.025
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 12.676855000000002,
    "valor_anterior": 12.390423,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16.8211,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15.9271,
        "delta": -0.894
      },
      {
        "periodo": 202509,
        "valor": 16.6475,
        "delta": 0.7204
      },
      {
        "periodo": 202510,
        "valor": 16.4373,
        "delta": -0.2102
      },
      {
        "periodo": 202511,
        "valor": 15.5659,
        "delta": -0.8713
      },
      {
        "periodo": 202512,
        "valor": 14.6777,
        "delta": -0.8882
      },
      {
        "periodo": 202601,
        "valor": 12.8166,
        "delta": -1.8611
      },
      {
        "periodo": 202602,
        "valor": 12.1078,
        "delta": -0.7088
      },
      {
        "periodo": 202603,
        "valor": 11.6484,
        "delta": -0.4595
      },
      {
        "periodo": 202604,
        "valor": 12.2731,
        "delta": 0.6247
      },
      {
        "periodo": 202605,
        "valor": 12.1784,
        "delta": -0.0947
      },
      {
        "periodo": 202606,
        "valor": 12.3904,
        "delta": 0.212
      },
      {
        "periodo": 202607,
        "valor": 12.6769,
        "delta": 0.2864
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 15.667479,
    "valor_anterior": 15.913029000000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15.9706,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16.2845,
        "delta": 0.3139
      },
      {
        "periodo": 202509,
        "valor": 16.4496,
        "delta": 0.1651
      },
      {
        "periodo": 202510,
        "valor": 16.1913,
        "delta": -0.2584
      },
      {
        "periodo": 202511,
        "valor": 16.351,
        "delta": 0.1597
      },
      {
        "periodo": 202512,
        "valor": 17.2546,
        "delta": 0.9036
      },
      {
        "periodo": 202601,
        "valor": 16.9908,
        "delta": -0.2638
      },
      {
        "periodo": 202602,
        "valor": 16.768,
        "delta": -0.2229
      },
      {
        "periodo": 202603,
        "valor": 16.5808,
        "delta": -0.1872
      },
      {
        "periodo": 202604,
        "valor": 16.3378,
        "delta": -0.243
      },
      {
        "periodo": 202605,
        "valor": 16.0556,
        "delta": -0.2822
      },
      {
        "periodo": 202606,
        "valor": 15.913,
        "delta": -0.1426
      },
      {
        "periodo": 202607,
        "valor": 15.6675,
        "delta": -0.2456
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 6.838894,
    "valor_anterior": 7.203747000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8.4442,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.0126,
        "delta": 0.5685
      },
      {
        "periodo": 202509,
        "valor": 9.5138,
        "delta": 0.5012
      },
      {
        "periodo": 202510,
        "valor": 10.0653,
        "delta": 0.5515
      },
      {
        "periodo": 202511,
        "valor": 10.7636,
        "delta": 0.6983
      },
      {
        "periodo": 202512,
        "valor": 5.6809,
        "delta": -5.0827
      },
      {
        "periodo": 202601,
        "valor": 5.9721,
        "delta": 0.2912
      },
      {
        "periodo": 202602,
        "valor": 6.0321,
        "delta": 0.06
      },
      {
        "periodo": 202603,
        "valor": 6.4692,
        "delta": 0.4372
      },
      {
        "periodo": 202604,
        "valor": 6.8724,
        "delta": 0.4031
      },
      {
        "periodo": 202605,
        "valor": 6.7601,
        "delta": -0.1122
      },
      {
        "periodo": 202606,
        "valor": 7.2037,
        "delta": 0.4436
      },
      {
        "periodo": 202607,
        "valor": 6.8389,
        "delta": -0.3649
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 30.389322000000003,
    "valor_anterior": 30.239493,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 29.0089,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28.7482,
        "delta": -0.2607
      },
      {
        "periodo": 202509,
        "valor": 28.0959,
        "delta": -0.6523
      },
      {
        "periodo": 202510,
        "valor": 27.8835,
        "delta": -0.2124
      },
      {
        "periodo": 202511,
        "valor": 28.0924,
        "delta": 0.209
      },
      {
        "periodo": 202512,
        "valor": 29.0374,
        "delta": 0.9449
      },
      {
        "periodo": 202601,
        "valor": 29.0296,
        "delta": -0.0078
      },
      {
        "periodo": 202602,
        "valor": 29.204,
        "delta": 0.1744
      },
      {
        "periodo": 202603,
        "valor": 29.7423,
        "delta": 0.5383
      },
      {
        "periodo": 202604,
        "valor": 30.0769,
        "delta": 0.3346
      },
      {
        "periodo": 202605,
        "valor": 29.9966,
        "delta": -0.0804
      },
      {
        "periodo": 202606,
        "valor": 30.2395,
        "delta": 0.2429
      },
      {
        "periodo": 202607,
        "valor": 30.3893,
        "delta": 0.1498
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 7.8690549999999995,
    "valor_anterior": 7.768276,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.6253,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.6336,
        "delta": 0.0083
      },
      {
        "periodo": 202509,
        "valor": 8.1485,
        "delta": -1.4851
      },
      {
        "periodo": 202510,
        "valor": 9.4802,
        "delta": 1.3317
      },
      {
        "periodo": 202511,
        "valor": 8.7172,
        "delta": -0.763
      },
      {
        "periodo": 202512,
        "valor": 7.6599,
        "delta": -1.0573
      },
      {
        "periodo": 202601,
        "valor": 8.1182,
        "delta": 0.4583
      },
      {
        "periodo": 202602,
        "valor": 7.7358,
        "delta": -0.3824
      },
      {
        "periodo": 202603,
        "valor": 7.7429,
        "delta": 0.0071
      },
      {
        "periodo": 202604,
        "valor": 8.7649,
        "delta": 1.0221
      },
      {
        "periodo": 202605,
        "valor": 8.1814,
        "delta": -0.5835
      },
      {
        "periodo": 202606,
        "valor": 7.7683,
        "delta": -0.4132
      },
      {
        "periodo": 202607,
        "valor": 7.8691,
        "delta": 0.1008
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 7.8053479999999995,
    "valor_anterior": 8.108644,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.9768,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.1518,
        "delta": 0.1749
      },
      {
        "periodo": 202509,
        "valor": 13.0895,
        "delta": -0.0623
      },
      {
        "periodo": 202510,
        "valor": 12.9219,
        "delta": -0.1676
      },
      {
        "periodo": 202511,
        "valor": 12.5714,
        "delta": -0.3505
      },
      {
        "periodo": 202512,
        "valor": 12.9881,
        "delta": 0.4168
      },
      {
        "periodo": 202601,
        "valor": 11.823,
        "delta": -1.1651
      },
      {
        "periodo": 202602,
        "valor": 10.9287,
        "delta": -0.8943
      },
      {
        "periodo": 202603,
        "valor": 9.9495,
        "delta": -0.9792
      },
      {
        "periodo": 202604,
        "valor": 9.864,
        "delta": -0.0855
      },
      {
        "periodo": 202605,
        "valor": 9.3336,
        "delta": -0.5304
      },
      {
        "periodo": 202606,
        "valor": 8.1086,
        "delta": -1.225
      },
      {
        "periodo": 202607,
        "valor": 7.8053,
        "delta": -0.3033
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 10.830339,
    "valor_anterior": 11.057082,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.9284,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.505,
        "delta": 0.5766
      },
      {
        "periodo": 202509,
        "valor": 14.0211,
        "delta": 0.5161
      },
      {
        "periodo": 202510,
        "valor": 13.651,
        "delta": -0.3701
      },
      {
        "periodo": 202511,
        "valor": 13.7222,
        "delta": 0.0712
      },
      {
        "periodo": 202512,
        "valor": 12.8198,
        "delta": -0.9024
      },
      {
        "periodo": 202601,
        "valor": 11.9472,
        "delta": -0.8725
      },
      {
        "periodo": 202602,
        "valor": 11.9057,
        "delta": -0.0415
      },
      {
        "periodo": 202603,
        "valor": 12.1733,
        "delta": 0.2675
      },
      {
        "periodo": 202604,
        "valor": 11.8166,
        "delta": -0.3567
      },
      {
        "periodo": 202605,
        "valor": 11.4591,
        "delta": -0.3574
      },
      {
        "periodo": 202606,
        "valor": 11.0571,
        "delta": -0.402
      },
      {
        "periodo": 202607,
        "valor": 10.8303,
        "delta": -0.2267
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 20.755927,
    "valor_anterior": 20.502231000000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 24.944,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24.534,
        "delta": -0.41
      },
      {
        "periodo": 202509,
        "valor": 24.2183,
        "delta": -0.3156
      },
      {
        "periodo": 202510,
        "valor": 23.4138,
        "delta": -0.8045
      },
      {
        "periodo": 202511,
        "valor": 22.8547,
        "delta": -0.5592
      },
      {
        "periodo": 202512,
        "valor": 23.1197,
        "delta": 0.2651
      },
      {
        "periodo": 202601,
        "valor": 23.2153,
        "delta": 0.0955
      },
      {
        "periodo": 202602,
        "valor": 23.2209,
        "delta": 0.0057
      },
      {
        "periodo": 202603,
        "valor": 21.0657,
        "delta": -2.1552
      },
      {
        "periodo": 202604,
        "valor": 20.6441,
        "delta": -0.4216
      },
      {
        "periodo": 202605,
        "valor": 20.0558,
        "delta": -0.5883
      },
      {
        "periodo": 202606,
        "valor": 20.5022,
        "delta": 0.4464
      },
      {
        "periodo": 202607,
        "valor": 20.7559,
        "delta": 0.2537
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 10.543803,
    "valor_anterior": 10.68513,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15.107,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14.6788,
        "delta": -0.4281
      },
      {
        "periodo": 202509,
        "valor": 14.1118,
        "delta": -0.5671
      },
      {
        "periodo": 202510,
        "valor": 13.6381,
        "delta": -0.4736
      },
      {
        "periodo": 202511,
        "valor": 13.3697,
        "delta": -0.2684
      },
      {
        "periodo": 202512,
        "valor": 12.6938,
        "delta": -0.6759
      },
      {
        "periodo": 202601,
        "valor": 12.3432,
        "delta": -0.3506
      },
      {
        "periodo": 202602,
        "valor": 10.996,
        "delta": -1.3472
      },
      {
        "periodo": 202603,
        "valor": 11.0543,
        "delta": 0.0584
      },
      {
        "periodo": 202604,
        "valor": 11.114,
        "delta": 0.0597
      },
      {
        "periodo": 202605,
        "valor": 10.6157,
        "delta": -0.4984
      },
      {
        "periodo": 202606,
        "valor": 10.6851,
        "delta": 0.0695
      },
      {
        "periodo": 202607,
        "valor": 10.5438,
        "delta": -0.1413
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 12.363900999999998,
    "valor_anterior": 12.894816,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10.327,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.1925,
        "delta": 0.8655
      },
      {
        "periodo": 202509,
        "valor": 11.205,
        "delta": 0.0126
      },
      {
        "periodo": 202510,
        "valor": 11.3918,
        "delta": 0.1868
      },
      {
        "periodo": 202511,
        "valor": 10.9896,
        "delta": -0.4023
      },
      {
        "periodo": 202512,
        "valor": 15.0821,
        "delta": 4.0925
      },
      {
        "periodo": 202601,
        "valor": 13.9276,
        "delta": -1.1545
      },
      {
        "periodo": 202602,
        "valor": 14.3349,
        "delta": 0.4073
      },
      {
        "periodo": 202603,
        "valor": 12.6502,
        "delta": -1.6847
      },
      {
        "periodo": 202604,
        "valor": 12.7836,
        "delta": 0.1334
      },
      {
        "periodo": 202605,
        "valor": 13.4736,
        "delta": 0.69
      },
      {
        "periodo": 202606,
        "valor": 12.8948,
        "delta": -0.5788
      },
      {
        "periodo": 202607,
        "valor": 12.3639,
        "delta": -0.5309
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": -2.5899330000000003,
    "valor_anterior": -3.113218,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -5.237,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -5.6906,
        "delta": -0.4536
      },
      {
        "periodo": 202509,
        "valor": -5.2132,
        "delta": 0.4774
      },
      {
        "periodo": 202510,
        "valor": -2.8348,
        "delta": 2.3784
      },
      {
        "periodo": 202511,
        "valor": -4.0732,
        "delta": -1.2384
      },
      {
        "periodo": 202512,
        "valor": -6.3942,
        "delta": -2.321
      },
      {
        "periodo": 202601,
        "valor": -5.3179,
        "delta": 1.0763
      },
      {
        "periodo": 202602,
        "valor": -4.6474,
        "delta": 0.6705
      },
      {
        "periodo": 202603,
        "valor": -4.3486,
        "delta": 0.2988
      },
      {
        "periodo": 202604,
        "valor": -3.3387,
        "delta": 1.0099
      },
      {
        "periodo": 202605,
        "valor": -3.9253,
        "delta": -0.5867
      },
      {
        "periodo": 202606,
        "valor": -3.1132,
        "delta": 0.8121
      },
      {
        "periodo": 202607,
        "valor": -2.5899,
        "delta": 0.5233
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 7.368446,
    "valor_anterior": 8.791815999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14.4562,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14.3813,
        "delta": -0.075
      },
      {
        "periodo": 202509,
        "valor": 14.1097,
        "delta": -0.2716
      },
      {
        "periodo": 202510,
        "valor": 14.6469,
        "delta": 0.5372
      },
      {
        "periodo": 202511,
        "valor": 14.4629,
        "delta": -0.184
      },
      {
        "periodo": 202512,
        "valor": 15.2985,
        "delta": 0.8356
      },
      {
        "periodo": 202601,
        "valor": 15.0949,
        "delta": -0.2036
      },
      {
        "periodo": 202602,
        "valor": 14.8947,
        "delta": -0.2002
      },
      {
        "periodo": 202603,
        "valor": 14.6253,
        "delta": -0.2694
      },
      {
        "periodo": 202604,
        "valor": 14.0405,
        "delta": -0.5848
      },
      {
        "periodo": 202605,
        "valor": 11.4647,
        "delta": -2.5757
      },
      {
        "periodo": 202606,
        "valor": 8.7918,
        "delta": -2.6729
      },
      {
        "periodo": 202607,
        "valor": 7.3684,
        "delta": -1.4234
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 32.718699,
    "valor_anterior": 31.220696999999998,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.1114,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.9432,
        "delta": 3.8318
      },
      {
        "periodo": 202509,
        "valor": 27.9276,
        "delta": 14.9844
      },
      {
        "periodo": 202510,
        "valor": 28.3394,
        "delta": 0.4119
      },
      {
        "periodo": 202511,
        "valor": 23.5646,
        "delta": -4.7748
      },
      {
        "periodo": 202512,
        "valor": 28.9384,
        "delta": 5.3738
      },
      {
        "periodo": 202601,
        "valor": 30.517,
        "delta": 1.5786
      },
      {
        "periodo": 202602,
        "valor": 30.6533,
        "delta": 0.1363
      },
      {
        "periodo": 202603,
        "valor": 33.6647,
        "delta": 3.0114
      },
      {
        "periodo": 202604,
        "valor": 33.0584,
        "delta": -0.6063
      },
      {
        "periodo": 202605,
        "valor": 32.3428,
        "delta": -0.7155
      },
      {
        "periodo": 202606,
        "valor": 31.2207,
        "delta": -1.1221
      },
      {
        "periodo": 202607,
        "valor": 32.7187,
        "delta": 1.498
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 4.691661,
    "valor_anterior": 7.428075000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10.7692,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.8956,
        "delta": -1.8736
      },
      {
        "periodo": 202509,
        "valor": 9.0919,
        "delta": 0.1963
      },
      {
        "periodo": 202510,
        "valor": 9.8123,
        "delta": 0.7204
      },
      {
        "periodo": 202511,
        "valor": 9.2506,
        "delta": -0.5618
      },
      {
        "periodo": 202512,
        "valor": 8.8761,
        "delta": -0.3745
      },
      {
        "periodo": 202601,
        "valor": 9.5779,
        "delta": 0.7018
      },
      {
        "periodo": 202602,
        "valor": 9.9196,
        "delta": 0.3417
      },
      {
        "periodo": 202603,
        "valor": 9.2138,
        "delta": -0.7059
      },
      {
        "periodo": 202604,
        "valor": 7.7229,
        "delta": -1.4909
      },
      {
        "periodo": 202605,
        "valor": 8.3546,
        "delta": 0.6317
      },
      {
        "periodo": 202606,
        "valor": 7.4281,
        "delta": -0.9265
      },
      {
        "periodo": 202607,
        "valor": 4.6917,
        "delta": -2.7364
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 30.714877,
    "valor_anterior": 30.981545,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 33.2282,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 32.618,
        "delta": -0.6102
      },
      {
        "periodo": 202509,
        "valor": 32.5748,
        "delta": -0.0432
      },
      {
        "periodo": 202510,
        "valor": 32.3466,
        "delta": -0.2282
      },
      {
        "periodo": 202511,
        "valor": 31.8211,
        "delta": -0.5255
      },
      {
        "periodo": 202512,
        "valor": 32.1101,
        "delta": 0.289
      },
      {
        "periodo": 202601,
        "valor": 32.2611,
        "delta": 0.151
      },
      {
        "periodo": 202602,
        "valor": 31.9668,
        "delta": -0.2943
      },
      {
        "periodo": 202603,
        "valor": 31.2907,
        "delta": -0.6761
      },
      {
        "periodo": 202604,
        "valor": 30.478,
        "delta": -0.8128
      },
      {
        "periodo": 202605,
        "valor": 30.5155,
        "delta": 0.0376
      },
      {
        "periodo": 202606,
        "valor": 30.9815,
        "delta": 0.466
      },
      {
        "periodo": 202607,
        "valor": 30.7149,
        "delta": -0.2667
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 15.473829,
    "valor_anterior": 14.82925,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.5532,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.2572,
        "delta": -0.296
      },
      {
        "periodo": 202509,
        "valor": 12.3674,
        "delta": 0.1102
      },
      {
        "periodo": 202510,
        "valor": 13.5553,
        "delta": 1.1879
      },
      {
        "periodo": 202511,
        "valor": 14.0282,
        "delta": 0.4729
      },
      {
        "periodo": 202512,
        "valor": 13.7189,
        "delta": -0.3093
      },
      {
        "periodo": 202601,
        "valor": 13.5862,
        "delta": -0.1328
      },
      {
        "periodo": 202602,
        "valor": 13.198,
        "delta": -0.3882
      },
      {
        "periodo": 202603,
        "valor": 13.1941,
        "delta": -0.0038
      },
      {
        "periodo": 202604,
        "valor": 13.4756,
        "delta": 0.2814
      },
      {
        "periodo": 202605,
        "valor": 13.8678,
        "delta": 0.3922
      },
      {
        "periodo": 202606,
        "valor": 14.8293,
        "delta": 0.9615
      },
      {
        "periodo": 202607,
        "valor": 15.4738,
        "delta": 0.6446
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 4.584983,
    "valor_anterior": 4.8217669999999995,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.4363,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.2197,
        "delta": -0.2166
      },
      {
        "periodo": 202509,
        "valor": 9.3637,
        "delta": 0.144
      },
      {
        "periodo": 202510,
        "valor": 9.2308,
        "delta": -0.1329
      },
      {
        "periodo": 202511,
        "valor": 8.4331,
        "delta": -0.7976
      },
      {
        "periodo": 202512,
        "valor": 7.9399,
        "delta": -0.4932
      },
      {
        "periodo": 202601,
        "valor": 8.6471,
        "delta": 0.7072
      },
      {
        "periodo": 202602,
        "valor": 6.7858,
        "delta": -1.8613
      },
      {
        "periodo": 202603,
        "valor": 6.561,
        "delta": -0.2248
      },
      {
        "periodo": 202604,
        "valor": 6.2372,
        "delta": -0.3238
      },
      {
        "periodo": 202605,
        "valor": 7.2509,
        "delta": 1.0138
      },
      {
        "periodo": 202606,
        "valor": 4.8218,
        "delta": -2.4292
      },
      {
        "periodo": 202607,
        "valor": 4.585,
        "delta": -0.2368
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": -19.408468,
    "valor_anterior": -18.529173,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22.3576,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18.4881,
        "delta": -3.8694
      },
      {
        "periodo": 202509,
        "valor": 15.1668,
        "delta": -3.3214
      },
      {
        "periodo": 202510,
        "valor": 12.025,
        "delta": -3.1418
      },
      {
        "periodo": 202511,
        "valor": 10.698,
        "delta": -1.327
      },
      {
        "periodo": 202512,
        "valor": 5.8796,
        "delta": -4.8184
      },
      {
        "periodo": 202601,
        "valor": 4.055,
        "delta": -1.8246
      },
      {
        "periodo": 202602,
        "valor": 2.4814,
        "delta": -1.5736
      },
      {
        "periodo": 202603,
        "valor": -0.6385,
        "delta": -3.1199
      },
      {
        "periodo": 202604,
        "valor": -3.9514,
        "delta": -3.3129
      },
      {
        "periodo": 202605,
        "valor": -7.9179,
        "delta": -3.9665
      },
      {
        "periodo": 202606,
        "valor": -18.5292,
        "delta": -10.6113
      },
      {
        "periodo": 202607,
        "valor": -19.4085,
        "delta": -0.8793
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 9.756333999999999,
    "valor_anterior": 9.715659,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17.5507,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16.1409,
        "delta": -1.4098
      },
      {
        "periodo": 202509,
        "valor": 14.6235,
        "delta": -1.5174
      },
      {
        "periodo": 202510,
        "valor": 14.9066,
        "delta": 0.2831
      },
      {
        "periodo": 202511,
        "valor": 14.8071,
        "delta": -0.0996
      },
      {
        "periodo": 202512,
        "valor": 14.534,
        "delta": -0.273
      },
      {
        "periodo": 202601,
        "valor": 12.3565,
        "delta": -2.1775
      },
      {
        "periodo": 202602,
        "valor": 12.1911,
        "delta": -0.1654
      },
      {
        "periodo": 202603,
        "valor": 10.0668,
        "delta": -2.1243
      },
      {
        "periodo": 202604,
        "valor": 9.7748,
        "delta": -0.292
      },
      {
        "periodo": 202605,
        "valor": 8.8617,
        "delta": -0.9131
      },
      {
        "periodo": 202606,
        "valor": 9.7157,
        "delta": 0.8539
      },
      {
        "periodo": 202607,
        "valor": 9.7563,
        "delta": 0.0407
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": -142.027341,
    "valor_anterior": -147.701108,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -154.2955,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -149.4184,
        "delta": 4.8771
      },
      {
        "periodo": 202509,
        "valor": -142.5601,
        "delta": 6.8583
      },
      {
        "periodo": 202510,
        "valor": -139.8832,
        "delta": 2.6768
      },
      {
        "periodo": 202511,
        "valor": -141.7471,
        "delta": -1.8638
      },
      {
        "periodo": 202512,
        "valor": -142.607,
        "delta": -0.8599
      },
      {
        "periodo": 202601,
        "valor": -144.5314,
        "delta": -1.9244
      },
      {
        "periodo": 202602,
        "valor": -150.0369,
        "delta": -5.5054
      },
      {
        "periodo": 202603,
        "valor": -150.2046,
        "delta": -0.1678
      },
      {
        "periodo": 202604,
        "valor": -151.9115,
        "delta": -1.7069
      },
      {
        "periodo": 202605,
        "valor": -149.6556,
        "delta": 2.2559
      },
      {
        "periodo": 202606,
        "valor": -147.7011,
        "delta": 1.9544
      },
      {
        "periodo": 202607,
        "valor": -142.0273,
        "delta": 5.6738
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 5.9317210000000005,
    "valor_anterior": 5.951128,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.492,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.4571,
        "delta": -0.035
      },
      {
        "periodo": 202509,
        "valor": 13.0559,
        "delta": 0.5988
      },
      {
        "periodo": 202510,
        "valor": 12.8673,
        "delta": -0.1886
      },
      {
        "periodo": 202511,
        "valor": 10.6427,
        "delta": -2.2246
      },
      {
        "periodo": 202512,
        "valor": 8.47,
        "delta": -2.1727
      },
      {
        "periodo": 202601,
        "valor": 8.4473,
        "delta": -0.0227
      },
      {
        "periodo": 202602,
        "valor": 6.4554,
        "delta": -1.9919
      },
      {
        "periodo": 202603,
        "valor": 6.2292,
        "delta": -0.2262
      },
      {
        "periodo": 202604,
        "valor": 5.073,
        "delta": -1.1562
      },
      {
        "periodo": 202605,
        "valor": 5.5102,
        "delta": 0.4372
      },
      {
        "periodo": 202606,
        "valor": 5.9511,
        "delta": 0.441
      },
      {
        "periodo": 202607,
        "valor": 5.9317,
        "delta": -0.0194
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 24.604433,
    "valor_anterior": 26.269279,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18.8178,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 20.0735,
        "delta": 1.2557
      },
      {
        "periodo": 202509,
        "valor": 21.6831,
        "delta": 1.6096
      },
      {
        "periodo": 202510,
        "valor": 22.7894,
        "delta": 1.1063
      },
      {
        "periodo": 202511,
        "valor": 23.738,
        "delta": 0.9486
      },
      {
        "periodo": 202512,
        "valor": 23.5772,
        "delta": -0.1608
      },
      {
        "periodo": 202601,
        "valor": 24.4495,
        "delta": 0.8723
      },
      {
        "periodo": 202602,
        "valor": 25.112,
        "delta": 0.6625
      },
      {
        "periodo": 202603,
        "valor": 25.8246,
        "delta": 0.7126
      },
      {
        "periodo": 202604,
        "valor": 26.5465,
        "delta": 0.7219
      },
      {
        "periodo": 202605,
        "valor": 26.5031,
        "delta": -0.0434
      },
      {
        "periodo": 202606,
        "valor": 26.2693,
        "delta": -0.2338
      },
      {
        "periodo": 202607,
        "valor": 24.6044,
        "delta": -1.6648
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 10.264800000000001,
    "valor_anterior": 10.829865,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.2664,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.7059,
        "delta": 0.4395
      },
      {
        "periodo": 202509,
        "valor": 13.3794,
        "delta": 0.6735
      },
      {
        "periodo": 202510,
        "valor": 11.668,
        "delta": -1.7114
      },
      {
        "periodo": 202511,
        "valor": 11.257,
        "delta": -0.411
      },
      {
        "periodo": 202512,
        "valor": 11.5592,
        "delta": 0.3022
      },
      {
        "periodo": 202601,
        "valor": 10.9206,
        "delta": -0.6385
      },
      {
        "periodo": 202602,
        "valor": 11.8035,
        "delta": 0.8829
      },
      {
        "periodo": 202603,
        "valor": 12.5016,
        "delta": 0.6982
      },
      {
        "periodo": 202604,
        "valor": 10.7937,
        "delta": -1.7079
      },
      {
        "periodo": 202605,
        "valor": 10.4783,
        "delta": -0.3154
      },
      {
        "periodo": 202606,
        "valor": 10.8299,
        "delta": 0.3515
      },
      {
        "periodo": 202607,
        "valor": 10.2648,
        "delta": -0.5651
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.0821,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -2.7878,
        "delta": -15.8699
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 23.314841,
    "valor_anterior": 22.955338,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25.8105,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25.225,
        "delta": -0.5854
      },
      {
        "periodo": 202509,
        "valor": 24.4172,
        "delta": -0.8078
      },
      {
        "periodo": 202510,
        "valor": 24.0126,
        "delta": -0.4046
      },
      {
        "periodo": 202511,
        "valor": 22.0858,
        "delta": -1.9268
      },
      {
        "periodo": 202512,
        "valor": 24.0084,
        "delta": 1.9226
      },
      {
        "periodo": 202601,
        "valor": 23.094,
        "delta": -0.9144
      },
      {
        "periodo": 202602,
        "valor": 22.6108,
        "delta": -0.4832
      },
      {
        "periodo": 202603,
        "valor": 21.9951,
        "delta": -0.6158
      },
      {
        "periodo": 202604,
        "valor": 22.5605,
        "delta": 0.5654
      },
      {
        "periodo": 202605,
        "valor": 22.3861,
        "delta": -0.1744
      },
      {
        "periodo": 202606,
        "valor": 22.9553,
        "delta": 0.5692
      },
      {
        "periodo": 202607,
        "valor": 23.3148,
        "delta": 0.3595
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 0.927991,
    "valor_anterior": 4.490102,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 23.2183,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25.5023,
        "delta": 2.284
      },
      {
        "periodo": 202509,
        "valor": 20.8939,
        "delta": -4.6084
      },
      {
        "periodo": 202510,
        "valor": 17.4847,
        "delta": -3.4093
      },
      {
        "periodo": 202511,
        "valor": 11.1966,
        "delta": -6.2881
      },
      {
        "periodo": 202512,
        "valor": 7.9702,
        "delta": -3.2264
      },
      {
        "periodo": 202601,
        "valor": 10.7181,
        "delta": 2.7478
      },
      {
        "periodo": 202602,
        "valor": 11.2263,
        "delta": 0.5082
      },
      {
        "periodo": 202603,
        "valor": 6.985,
        "delta": -4.2413
      },
      {
        "periodo": 202604,
        "valor": 5.4899,
        "delta": -1.4951
      },
      {
        "periodo": 202605,
        "valor": 0.4491,
        "delta": -5.0408
      },
      {
        "periodo": 202606,
        "valor": 4.4901,
        "delta": 4.041
      },
      {
        "periodo": 202607,
        "valor": 0.928,
        "delta": -3.5621
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": -1.51479,
    "valor_anterior": -4.728944,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -24.7031,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -26.4054,
        "delta": -1.7023
      },
      {
        "periodo": 202509,
        "valor": -26.8939,
        "delta": -0.4885
      },
      {
        "periodo": 202510,
        "valor": -26.6035,
        "delta": 0.2903
      },
      {
        "periodo": 202511,
        "valor": -20.0666,
        "delta": 6.5369
      },
      {
        "periodo": 202512,
        "valor": -16.2148,
        "delta": 3.8518
      },
      {
        "periodo": 202601,
        "valor": -15.6054,
        "delta": 0.6094
      },
      {
        "periodo": 202602,
        "valor": -13.6381,
        "delta": 1.9673
      },
      {
        "periodo": 202603,
        "valor": -11.353,
        "delta": 2.2851
      },
      {
        "periodo": 202604,
        "valor": -10.957,
        "delta": 0.396
      },
      {
        "periodo": 202605,
        "valor": -7.5417,
        "delta": 3.4154
      },
      {
        "periodo": 202606,
        "valor": -4.7289,
        "delta": 2.8127
      },
      {
        "periodo": 202607,
        "valor": -1.5148,
        "delta": 3.2142
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": -12.027807,
    "valor_anterior": -11.384294,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -2.7057,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -4.0534,
        "delta": -1.3476
      },
      {
        "periodo": 202509,
        "valor": -4.2639,
        "delta": -0.2106
      },
      {
        "periodo": 202510,
        "valor": -5.2456,
        "delta": -0.9817
      },
      {
        "periodo": 202511,
        "valor": -5.9912,
        "delta": -0.7456
      },
      {
        "periodo": 202512,
        "valor": -8.2651,
        "delta": -2.2739
      },
      {
        "periodo": 202601,
        "valor": -9.0304,
        "delta": -0.7653
      },
      {
        "periodo": 202602,
        "valor": -9.3589,
        "delta": -0.3285
      },
      {
        "periodo": 202603,
        "valor": -9.9643,
        "delta": -0.6055
      },
      {
        "periodo": 202604,
        "valor": -10.2539,
        "delta": -0.2895
      },
      {
        "periodo": 202605,
        "valor": -10.5661,
        "delta": -0.3123
      },
      {
        "periodo": 202606,
        "valor": -11.3843,
        "delta": -0.8182
      },
      {
        "periodo": 202607,
        "valor": -12.0278,
        "delta": -0.6435
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 6.688026,
    "valor_anterior": 6.337452000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.971,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.2734,
        "delta": -0.6976
      },
      {
        "periodo": 202509,
        "valor": 9.2244,
        "delta": -0.0491
      },
      {
        "periodo": 202510,
        "valor": 8.5005,
        "delta": -0.7239
      },
      {
        "periodo": 202511,
        "valor": 8.0589,
        "delta": -0.4416
      },
      {
        "periodo": 202512,
        "valor": 7.6416,
        "delta": -0.4174
      },
      {
        "periodo": 202601,
        "valor": 8.004,
        "delta": 0.3625
      },
      {
        "periodo": 202602,
        "valor": 7.6174,
        "delta": -0.3866
      },
      {
        "periodo": 202603,
        "valor": 7.2137,
        "delta": -0.4037
      },
      {
        "periodo": 202604,
        "valor": 7.0717,
        "delta": -0.142
      },
      {
        "periodo": 202605,
        "valor": 6.4257,
        "delta": -0.646
      },
      {
        "periodo": 202606,
        "valor": 6.3375,
        "delta": -0.0883
      },
      {
        "periodo": 202607,
        "valor": 6.688,
        "delta": 0.3506
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": -6.082651,
    "valor_anterior": -8.514425000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -22.5292,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -21.6484,
        "delta": 0.8808
      },
      {
        "periodo": 202509,
        "valor": -21.3627,
        "delta": 0.2857
      },
      {
        "periodo": 202510,
        "valor": -20.9392,
        "delta": 0.4235
      },
      {
        "periodo": 202511,
        "valor": -22.1462,
        "delta": -1.2069
      },
      {
        "periodo": 202512,
        "valor": -20.9784,
        "delta": 1.1678
      },
      {
        "periodo": 202601,
        "valor": -18.5676,
        "delta": 2.4107
      },
      {
        "periodo": 202602,
        "valor": -16.3035,
        "delta": 2.2641
      },
      {
        "periodo": 202603,
        "valor": -15.3225,
        "delta": 0.981
      },
      {
        "periodo": 202604,
        "valor": -13.3465,
        "delta": 1.976
      },
      {
        "periodo": 202605,
        "valor": -11.0617,
        "delta": 2.2847
      },
      {
        "periodo": 202606,
        "valor": -8.5144,
        "delta": 2.5473
      },
      {
        "periodo": 202607,
        "valor": -6.0827,
        "delta": 2.4318
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 20.407111,
    "valor_anterior": 20.80689,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20.986,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21.689,
        "delta": 0.703
      },
      {
        "periodo": 202509,
        "valor": 21.9514,
        "delta": 0.2624
      },
      {
        "periodo": 202510,
        "valor": 23.0692,
        "delta": 1.1178
      },
      {
        "periodo": 202511,
        "valor": 23.0122,
        "delta": -0.057
      },
      {
        "periodo": 202512,
        "valor": 22.864,
        "delta": -0.1482
      },
      {
        "periodo": 202601,
        "valor": 22.6239,
        "delta": -0.24
      },
      {
        "periodo": 202602,
        "valor": 22.2794,
        "delta": -0.3445
      },
      {
        "periodo": 202603,
        "valor": 20.8472,
        "delta": -1.4322
      },
      {
        "periodo": 202604,
        "valor": 20.9279,
        "delta": 0.0807
      },
      {
        "periodo": 202605,
        "valor": 21.162,
        "delta": 0.2341
      },
      {
        "periodo": 202606,
        "valor": 20.8069,
        "delta": -0.3551
      },
      {
        "periodo": 202607,
        "valor": 20.4071,
        "delta": -0.3998
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 11.84074,
    "valor_anterior": 11.827061,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.3295,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.7619,
        "delta": 0.4325
      },
      {
        "periodo": 202509,
        "valor": 12.1439,
        "delta": -0.618
      },
      {
        "periodo": 202510,
        "valor": 11.0287,
        "delta": -1.1152
      },
      {
        "periodo": 202511,
        "valor": 11.7888,
        "delta": 0.7601
      },
      {
        "periodo": 202512,
        "valor": 12.2821,
        "delta": 0.4933
      },
      {
        "periodo": 202601,
        "valor": 11.7489,
        "delta": -0.5332
      },
      {
        "periodo": 202602,
        "valor": 11.4752,
        "delta": -0.2738
      },
      {
        "periodo": 202603,
        "valor": 12.0783,
        "delta": 0.6031
      },
      {
        "periodo": 202604,
        "valor": 11.2968,
        "delta": -0.7815
      },
      {
        "periodo": 202605,
        "valor": 11.0895,
        "delta": -0.2074
      },
      {
        "periodo": 202606,
        "valor": 11.8271,
        "delta": 0.7376
      },
      {
        "periodo": 202607,
        "valor": 11.8407,
        "delta": 0.0137
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 13.029027000000001,
    "valor_anterior": 15.29446,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20.6589,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 20.4286,
        "delta": -0.2302
      },
      {
        "periodo": 202509,
        "valor": 20.9383,
        "delta": 0.5096
      },
      {
        "periodo": 202510,
        "valor": 21.1336,
        "delta": 0.1953
      },
      {
        "periodo": 202511,
        "valor": 20.4959,
        "delta": -0.6377
      },
      {
        "periodo": 202512,
        "valor": 19.9656,
        "delta": -0.5303
      },
      {
        "periodo": 202601,
        "valor": 19.5591,
        "delta": -0.4066
      },
      {
        "periodo": 202602,
        "valor": 19.8121,
        "delta": 0.253
      },
      {
        "periodo": 202603,
        "valor": 18.47,
        "delta": -1.3421
      },
      {
        "periodo": 202604,
        "valor": 15.7945,
        "delta": -2.6754
      },
      {
        "periodo": 202605,
        "valor": 16.4497,
        "delta": 0.6551
      },
      {
        "periodo": 202606,
        "valor": 15.2945,
        "delta": -1.1552
      },
      {
        "periodo": 202607,
        "valor": 13.029,
        "delta": -2.2654
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 7.443419,
    "valor_anterior": 7.1613739999999995,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7.4024,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7.5459,
        "delta": 0.1434
      },
      {
        "periodo": 202509,
        "valor": 7.7797,
        "delta": 0.2338
      },
      {
        "periodo": 202510,
        "valor": 7.719,
        "delta": -0.0607
      },
      {
        "periodo": 202511,
        "valor": 7.5113,
        "delta": -0.2077
      },
      {
        "periodo": 202512,
        "valor": 7.5128,
        "delta": 0.0015
      },
      {
        "periodo": 202601,
        "valor": 7.4192,
        "delta": -0.0935
      },
      {
        "periodo": 202602,
        "valor": 7.1949,
        "delta": -0.2243
      },
      {
        "periodo": 202603,
        "valor": 7.0317,
        "delta": -0.1632
      },
      {
        "periodo": 202604,
        "valor": 6.9422,
        "delta": -0.0895
      },
      {
        "periodo": 202605,
        "valor": 6.9718,
        "delta": 0.0295
      },
      {
        "periodo": 202606,
        "valor": 7.1614,
        "delta": 0.1896
      },
      {
        "periodo": 202607,
        "valor": 7.4434,
        "delta": 0.282
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 6.385821,
    "valor_anterior": 5.5633099999999995,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6.1589,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6.4124,
        "delta": 0.2534
      },
      {
        "periodo": 202509,
        "valor": 6.2762,
        "delta": -0.1361
      },
      {
        "periodo": 202510,
        "valor": 6.2929,
        "delta": 0.0166
      },
      {
        "periodo": 202511,
        "valor": 6.3097,
        "delta": 0.0169
      },
      {
        "periodo": 202512,
        "valor": 5.9651,
        "delta": -0.3446
      },
      {
        "periodo": 202601,
        "valor": 5.7886,
        "delta": -0.1766
      },
      {
        "periodo": 202602,
        "valor": 5.7491,
        "delta": -0.0395
      },
      {
        "periodo": 202603,
        "valor": 5.8909,
        "delta": 0.1419
      },
      {
        "periodo": 202604,
        "valor": 5.8403,
        "delta": -0.0506
      },
      {
        "periodo": 202605,
        "valor": 5.7946,
        "delta": -0.0457
      },
      {
        "periodo": 202606,
        "valor": 5.5633,
        "delta": -0.2313
      },
      {
        "periodo": 202607,
        "valor": 6.3858,
        "delta": 0.8225
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 6.5543260000000005,
    "valor_anterior": 6.8600389999999996,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10.3474,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.8352,
        "delta": -0.5122
      },
      {
        "periodo": 202509,
        "valor": 10.0078,
        "delta": 0.1725
      },
      {
        "periodo": 202510,
        "valor": 9.8503,
        "delta": -0.1575
      },
      {
        "periodo": 202511,
        "valor": 9.4585,
        "delta": -0.3918
      },
      {
        "periodo": 202512,
        "valor": 9.1865,
        "delta": -0.272
      },
      {
        "periodo": 202601,
        "valor": 8.4994,
        "delta": -0.6871
      },
      {
        "periodo": 202602,
        "valor": 8.4611,
        "delta": -0.0382
      },
      {
        "periodo": 202603,
        "valor": 7.5614,
        "delta": -0.8997
      },
      {
        "periodo": 202604,
        "valor": 7.3129,
        "delta": -0.2486
      },
      {
        "periodo": 202605,
        "valor": 7.0071,
        "delta": -0.3058
      },
      {
        "periodo": 202606,
        "valor": 6.86,
        "delta": -0.147
      },
      {
        "periodo": 202607,
        "valor": 6.5543,
        "delta": -0.3057
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 4.177749,
    "valor_anterior": 4.98434,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7.8846,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.7412,
        "delta": 0.8567
      },
      {
        "periodo": 202509,
        "valor": 8.2352,
        "delta": -0.506
      },
      {
        "periodo": 202510,
        "valor": 8.2197,
        "delta": -0.0155
      },
      {
        "periodo": 202511,
        "valor": 8.0606,
        "delta": -0.159
      },
      {
        "periodo": 202512,
        "valor": 7.3219,
        "delta": -0.7387
      },
      {
        "periodo": 202601,
        "valor": 7.0961,
        "delta": -0.2258
      },
      {
        "periodo": 202602,
        "valor": 6.4746,
        "delta": -0.6215
      },
      {
        "periodo": 202603,
        "valor": 6.6062,
        "delta": 0.1316
      },
      {
        "periodo": 202604,
        "valor": 4.7596,
        "delta": -1.8466
      },
      {
        "periodo": 202605,
        "valor": 4.871,
        "delta": 0.1115
      },
      {
        "periodo": 202606,
        "valor": 4.9843,
        "delta": 0.1133
      },
      {
        "periodo": 202607,
        "valor": 4.1777,
        "delta": -0.8066
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 11.860037,
    "valor_anterior": 12.090426,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.2362,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.003,
        "delta": -0.2332
      },
      {
        "periodo": 202509,
        "valor": 13.0382,
        "delta": 0.0352
      },
      {
        "periodo": 202510,
        "valor": 12.884,
        "delta": -0.1542
      },
      {
        "periodo": 202511,
        "valor": 12.5365,
        "delta": -0.3475
      },
      {
        "periodo": 202512,
        "valor": 12.3888,
        "delta": -0.1477
      },
      {
        "periodo": 202601,
        "valor": 12.2459,
        "delta": -0.143
      },
      {
        "periodo": 202602,
        "valor": 12.2517,
        "delta": 0.0058
      },
      {
        "periodo": 202603,
        "valor": 12.0897,
        "delta": -0.162
      },
      {
        "periodo": 202604,
        "valor": 12.0237,
        "delta": -0.0661
      },
      {
        "periodo": 202605,
        "valor": 11.9164,
        "delta": -0.1073
      },
      {
        "periodo": 202606,
        "valor": 12.0904,
        "delta": 0.1741
      },
      {
        "periodo": 202607,
        "valor": 11.86,
        "delta": -0.2304
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 2.339473,
    "valor_anterior": 2.369358,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.6714,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.5199,
        "delta": -0.1515
      },
      {
        "periodo": 202509,
        "valor": 2.5058,
        "delta": -0.0141
      },
      {
        "periodo": 202510,
        "valor": 2.4966,
        "delta": -0.0092
      },
      {
        "periodo": 202511,
        "valor": 2.4532,
        "delta": -0.0434
      },
      {
        "periodo": 202512,
        "valor": 2.3941,
        "delta": -0.0591
      },
      {
        "periodo": 202601,
        "valor": 2.0438,
        "delta": -0.3503
      },
      {
        "periodo": 202602,
        "valor": 2.0143,
        "delta": -0.0294
      },
      {
        "periodo": 202603,
        "valor": 2.0782,
        "delta": 0.0638
      },
      {
        "periodo": 202604,
        "valor": 2.0781,
        "delta": -0.0001
      },
      {
        "periodo": 202605,
        "valor": 2.2224,
        "delta": 0.1444
      },
      {
        "periodo": 202606,
        "valor": 2.3694,
        "delta": 0.1469
      },
      {
        "periodo": 202607,
        "valor": 2.3395,
        "delta": -0.0299
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 4.2558869999999995,
    "valor_anterior": 5.225334999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7.2437,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6.854,
        "delta": -0.3896
      },
      {
        "periodo": 202509,
        "valor": 3.2663,
        "delta": -3.5877
      },
      {
        "periodo": 202510,
        "valor": 2.8038,
        "delta": -0.4625
      },
      {
        "periodo": 202511,
        "valor": 2.9643,
        "delta": 0.1605
      },
      {
        "periodo": 202512,
        "valor": 5.9025,
        "delta": 2.9382
      },
      {
        "periodo": 202601,
        "valor": 6.1664,
        "delta": 0.2639
      },
      {
        "periodo": 202602,
        "valor": 6.2061,
        "delta": 0.0397
      },
      {
        "periodo": 202603,
        "valor": 5.6309,
        "delta": -0.5753
      },
      {
        "periodo": 202604,
        "valor": 4.7343,
        "delta": -0.8965
      },
      {
        "periodo": 202605,
        "valor": 5.2439,
        "delta": 0.5096
      },
      {
        "periodo": 202606,
        "valor": 5.2253,
        "delta": -0.0186
      },
      {
        "periodo": 202607,
        "valor": 4.2559,
        "delta": -0.9694
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": -24.890691,
    "valor_anterior": -25.363061999999996,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -32.6087,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -32.2131,
        "delta": 0.3956
      },
      {
        "periodo": 202509,
        "valor": -32.4013,
        "delta": -0.1882
      },
      {
        "periodo": 202510,
        "valor": -31.0708,
        "delta": 1.3305
      },
      {
        "periodo": 202511,
        "valor": -29.6889,
        "delta": 1.382
      },
      {
        "periodo": 202512,
        "valor": -28.3293,
        "delta": 1.3596
      },
      {
        "periodo": 202601,
        "valor": -27.4087,
        "delta": 0.9205
      },
      {
        "periodo": 202602,
        "valor": -26.5861,
        "delta": 0.8226
      },
      {
        "periodo": 202603,
        "valor": -25.6384,
        "delta": 0.9477
      },
      {
        "periodo": 202604,
        "valor": -25.5157,
        "delta": 0.1227
      },
      {
        "periodo": 202605,
        "valor": -25.2984,
        "delta": 0.2174
      },
      {
        "periodo": 202606,
        "valor": -25.3631,
        "delta": -0.0647
      },
      {
        "periodo": 202607,
        "valor": -24.8907,
        "delta": 0.4724
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 9.564849,
    "valor_anterior": 9.33693,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 4.0509,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 5.3938,
        "delta": 1.3429
      },
      {
        "periodo": 202603,
        "valor": 6.8065,
        "delta": 1.4127
      },
      {
        "periodo": 202604,
        "valor": 6.6898,
        "delta": -0.1167
      },
      {
        "periodo": 202605,
        "valor": 7.3014,
        "delta": 0.6116
      },
      {
        "periodo": 202606,
        "valor": 9.3369,
        "delta": 2.0355
      },
      {
        "periodo": 202607,
        "valor": 9.5648,
        "delta": 0.2279
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": -52.363965,
    "valor_anterior": -51.453504,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": -38.7995,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": -33.7852,
        "delta": 5.0142
      },
      {
        "periodo": 202512,
        "valor": -36.1227,
        "delta": -2.3375
      },
      {
        "periodo": 202601,
        "valor": -39.0661,
        "delta": -2.9433
      },
      {
        "periodo": 202602,
        "valor": -41.9711,
        "delta": -2.905
      },
      {
        "periodo": 202603,
        "valor": -44.7995,
        "delta": -2.8284
      },
      {
        "periodo": 202604,
        "valor": -47.5284,
        "delta": -2.729
      },
      {
        "periodo": 202605,
        "valor": -50.456,
        "delta": -2.9275
      },
      {
        "periodo": 202606,
        "valor": -51.4535,
        "delta": -0.9975
      },
      {
        "periodo": 202607,
        "valor": -52.364,
        "delta": -0.9105
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 16.301429,
    "valor_anterior": 16.434801,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17.5116,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17.3901,
        "delta": -0.1215
      },
      {
        "periodo": 202509,
        "valor": 17.0718,
        "delta": -0.3184
      },
      {
        "periodo": 202510,
        "valor": 17.0187,
        "delta": -0.053
      },
      {
        "periodo": 202511,
        "valor": 17.1188,
        "delta": 0.1
      },
      {
        "periodo": 202512,
        "valor": 17.2602,
        "delta": 0.1415
      },
      {
        "periodo": 202601,
        "valor": 17.1929,
        "delta": -0.0674
      },
      {
        "periodo": 202602,
        "valor": 16.9726,
        "delta": -0.2203
      },
      {
        "periodo": 202603,
        "valor": 17.1779,
        "delta": 0.2053
      },
      {
        "periodo": 202604,
        "valor": 17.0602,
        "delta": -0.1177
      },
      {
        "periodo": 202605,
        "valor": 16.6795,
        "delta": -0.3807
      },
      {
        "periodo": 202606,
        "valor": 16.4348,
        "delta": -0.2447
      },
      {
        "periodo": 202607,
        "valor": 16.3014,
        "delta": -0.1334
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 18.30822,
    "valor_anterior": 18.349401,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18.4965,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18.493,
        "delta": -0.0036
      },
      {
        "periodo": 202509,
        "valor": 18.1333,
        "delta": -0.3597
      },
      {
        "periodo": 202510,
        "valor": 18.0971,
        "delta": -0.0362
      },
      {
        "periodo": 202511,
        "valor": 18.4029,
        "delta": 0.3058
      },
      {
        "periodo": 202512,
        "valor": 18.4917,
        "delta": 0.0888
      },
      {
        "periodo": 202601,
        "valor": 18.5734,
        "delta": 0.0817
      },
      {
        "periodo": 202602,
        "valor": 18.3352,
        "delta": -0.2382
      },
      {
        "periodo": 202603,
        "valor": 18.9081,
        "delta": 0.573
      },
      {
        "periodo": 202604,
        "valor": 18.8266,
        "delta": -0.0815
      },
      {
        "periodo": 202605,
        "valor": 18.453,
        "delta": -0.3736
      },
      {
        "periodo": 202606,
        "valor": 18.3494,
        "delta": -0.1036
      },
      {
        "periodo": 202607,
        "valor": 18.3082,
        "delta": -0.0412
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 12.953749,
    "valor_anterior": 12.184469,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22.6127,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18.9594,
        "delta": -3.6534
      },
      {
        "periodo": 202509,
        "valor": 19.3168,
        "delta": 0.3574
      },
      {
        "periodo": 202510,
        "valor": 18.242,
        "delta": -1.0748
      },
      {
        "periodo": 202511,
        "valor": 17.4063,
        "delta": -0.8357
      },
      {
        "periodo": 202512,
        "valor": 16.249,
        "delta": -1.1573
      },
      {
        "periodo": 202601,
        "valor": 16.0007,
        "delta": -0.2483
      },
      {
        "periodo": 202602,
        "valor": 16.029,
        "delta": 0.0283
      },
      {
        "periodo": 202603,
        "valor": 14.5054,
        "delta": -1.5236
      },
      {
        "periodo": 202604,
        "valor": 14.1862,
        "delta": -0.3191
      },
      {
        "periodo": 202605,
        "valor": 13.6002,
        "delta": -0.5861
      },
      {
        "periodo": 202606,
        "valor": 12.1845,
        "delta": -1.4157
      },
      {
        "periodo": 202607,
        "valor": 12.9537,
        "delta": 0.7693
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 10.220137999999999,
    "valor_anterior": 10.625383,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10.9654,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.2241,
        "delta": 0.2586
      },
      {
        "periodo": 202509,
        "valor": 11.1199,
        "delta": -0.1042
      },
      {
        "periodo": 202510,
        "valor": 11.3572,
        "delta": 0.2374
      },
      {
        "periodo": 202511,
        "valor": 11.0421,
        "delta": -0.3152
      },
      {
        "periodo": 202512,
        "valor": 12.1605,
        "delta": 1.1184
      },
      {
        "periodo": 202601,
        "valor": 11.4865,
        "delta": -0.674
      },
      {
        "periodo": 202602,
        "valor": 11.5415,
        "delta": 0.055
      },
      {
        "periodo": 202603,
        "valor": 10.8085,
        "delta": -0.733
      },
      {
        "periodo": 202604,
        "valor": 10.8851,
        "delta": 0.0766
      },
      {
        "periodo": 202605,
        "valor": 11.0415,
        "delta": 0.1564
      },
      {
        "periodo": 202606,
        "valor": 10.6254,
        "delta": -0.4161
      },
      {
        "periodo": 202607,
        "valor": 10.2201,
        "delta": -0.4052
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 16.16797,
    "valor_anterior": 16.202425,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18.4895,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18.3255,
        "delta": -0.164
      },
      {
        "periodo": 202509,
        "valor": 18.1498,
        "delta": -0.1757
      },
      {
        "periodo": 202510,
        "valor": 18.0734,
        "delta": -0.0764
      },
      {
        "periodo": 202511,
        "valor": 17.8302,
        "delta": -0.2432
      },
      {
        "periodo": 202512,
        "valor": 17.413,
        "delta": -0.4172
      },
      {
        "periodo": 202601,
        "valor": 17.172,
        "delta": -0.241
      },
      {
        "periodo": 202602,
        "valor": 16.7232,
        "delta": -0.4487
      },
      {
        "periodo": 202603,
        "valor": 16.5137,
        "delta": -0.2095
      },
      {
        "periodo": 202604,
        "valor": 16.4243,
        "delta": -0.0894
      },
      {
        "periodo": 202605,
        "valor": 16.2435,
        "delta": -0.1807
      },
      {
        "periodo": 202606,
        "valor": 16.2024,
        "delta": -0.0411
      },
      {
        "periodo": 202607,
        "valor": 16.168,
        "delta": -0.0345
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 9.470219,
    "valor_anterior": 9.367694,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8.6722,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.0786,
        "delta": 0.4064
      },
      {
        "periodo": 202509,
        "valor": 9.781,
        "delta": 0.7024
      },
      {
        "periodo": 202510,
        "valor": 9.7956,
        "delta": 0.0146
      },
      {
        "periodo": 202511,
        "valor": 9.1521,
        "delta": -0.6435
      },
      {
        "periodo": 202512,
        "valor": 9.4934,
        "delta": 0.3413
      },
      {
        "periodo": 202601,
        "valor": 9.8711,
        "delta": 0.3778
      },
      {
        "periodo": 202602,
        "valor": 9.6125,
        "delta": -0.2586
      },
      {
        "periodo": 202603,
        "valor": 9.5112,
        "delta": -0.1013
      },
      {
        "periodo": 202604,
        "valor": 9.3231,
        "delta": -0.188
      },
      {
        "periodo": 202605,
        "valor": 9.4293,
        "delta": 0.1062
      },
      {
        "periodo": 202606,
        "valor": 9.3677,
        "delta": -0.0616
      },
      {
        "periodo": 202607,
        "valor": 9.4702,
        "delta": 0.1025
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200002,
    "label": "ROE",
    "valor_actual": 7.386552,
    "valor_anterior": 8.469571,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15.1651,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14.6563,
        "delta": -0.5088
      },
      {
        "periodo": 202509,
        "valor": 14.1587,
        "delta": -0.4976
      },
      {
        "periodo": 202510,
        "valor": 14.2799,
        "delta": 0.1212
      },
      {
        "periodo": 202511,
        "valor": 14.1198,
        "delta": -0.16
      },
      {
        "periodo": 202512,
        "valor": 14.4017,
        "delta": 0.2818
      },
      {
        "periodo": 202601,
        "valor": 13.7864,
        "delta": -0.6153
      },
      {
        "periodo": 202602,
        "valor": 13.6069,
        "delta": -0.1795
      },
      {
        "periodo": 202603,
        "valor": 12.3518,
        "delta": -1.2551
      },
      {
        "periodo": 202604,
        "valor": 11.616,
        "delta": -0.7359
      },
      {
        "periodo": 202605,
        "valor": 9.933,
        "delta": -1.683
      },
      {
        "periodo": 202606,
        "valor": 8.4696,
        "delta": -1.4634
      },
      {
        "periodo": 202607,
        "valor": 7.3866,
        "delta": -1.083
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 36061869476.31,
    "valor_anterior": 36269670149.93,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 41415493963.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 39582624200.45,
        "delta": -1832869762.55
      },
      {
        "periodo": 202509,
        "valor": 37860782530.63,
        "delta": -1721841669.82
      },
      {
        "periodo": 202510,
        "valor": 37060307457.9,
        "delta": -800475072.73
      },
      {
        "periodo": 202511,
        "valor": 35663767847.81,
        "delta": -1396539610.09
      },
      {
        "periodo": 202512,
        "valor": 35844183606.99,
        "delta": 180415759.18
      },
      {
        "periodo": 202601,
        "valor": 36387030371.85,
        "delta": 542846764.86
      },
      {
        "periodo": 202602,
        "valor": 35762990853.54,
        "delta": -624039518.31
      },
      {
        "periodo": 202603,
        "valor": 37950908781.82,
        "delta": 2187917928.28
      },
      {
        "periodo": 202604,
        "valor": 37022250334.34,
        "delta": -928658447.48
      },
      {
        "periodo": 202605,
        "valor": 36665027300.57,
        "delta": -357223033.77
      },
      {
        "periodo": 202606,
        "valor": 36269670149.93,
        "delta": -395357150.64
      },
      {
        "periodo": 202607,
        "valor": 36061869476.31,
        "delta": -207800673.62
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 98985630308.19,
    "valor_anterior": 99850297515.45,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 118826747142.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 116002435710.24,
        "delta": -2824311432.69
      },
      {
        "periodo": 202509,
        "valor": 115451031999.14,
        "delta": -551403711.1
      },
      {
        "periodo": 202510,
        "valor": 113001027322.19,
        "delta": -2450004676.95
      },
      {
        "periodo": 202511,
        "valor": 110534360349.0,
        "delta": -2466666973.19
      },
      {
        "periodo": 202512,
        "valor": 108227707185.92,
        "delta": -2306653163.08
      },
      {
        "periodo": 202601,
        "valor": 106710323246.07,
        "delta": -1517383939.85
      },
      {
        "periodo": 202602,
        "valor": 105206794042.44,
        "delta": -1503529203.63
      },
      {
        "periodo": 202603,
        "valor": 104159116667.35,
        "delta": -1047677375.09
      },
      {
        "periodo": 202604,
        "valor": 102541837360.54,
        "delta": -1617279306.81
      },
      {
        "periodo": 202605,
        "valor": 100815822665.37,
        "delta": -1726014695.17
      },
      {
        "periodo": 202606,
        "valor": 99850297515.45,
        "delta": -965525149.92
      },
      {
        "periodo": 202607,
        "valor": 98985630308.19,
        "delta": -864667207.26
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 92091293624.0,
    "valor_anterior": 92315873938.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 107847708409.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 106196297858.0,
        "delta": -1651410551.0
      },
      {
        "periodo": 202509,
        "valor": 104589191775.0,
        "delta": -1607106083.0
      },
      {
        "periodo": 202510,
        "valor": 103559044794.0,
        "delta": -1030146981.0
      },
      {
        "periodo": 202511,
        "valor": 101568003743.0,
        "delta": -1991041051.0
      },
      {
        "periodo": 202512,
        "valor": 99175200138.0,
        "delta": -2392803605.0
      },
      {
        "periodo": 202601,
        "valor": 97343406880.0,
        "delta": -1831793258.0
      },
      {
        "periodo": 202602,
        "valor": 96281573691.0,
        "delta": -1061833189.0
      },
      {
        "periodo": 202603,
        "valor": 95184646147.0,
        "delta": -1096927544.0
      },
      {
        "periodo": 202604,
        "valor": 94003087591.0,
        "delta": -1181558556.0
      },
      {
        "periodo": 202605,
        "valor": 92816205242.0,
        "delta": -1186882349.0
      },
      {
        "periodo": 202606,
        "valor": 92315873938.0,
        "delta": -500331304.0
      },
      {
        "periodo": 202607,
        "valor": 92091293624.0,
        "delta": -224580314.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 33424165626.5,
    "valor_anterior": 34194128463.5,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 46993880648.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 45997266174.0,
        "delta": -996614474.0
      },
      {
        "periodo": 202509,
        "valor": 45171947247.0,
        "delta": -825318927.0
      },
      {
        "periodo": 202510,
        "valor": 43838729658.0,
        "delta": -1333217589.0
      },
      {
        "periodo": 202511,
        "valor": 42834421718.0,
        "delta": -1004307940.0
      },
      {
        "periodo": 202512,
        "valor": 41675979581.5,
        "delta": -1158442136.5
      },
      {
        "periodo": 202601,
        "valor": 40187836808.5,
        "delta": -1488142773.0
      },
      {
        "periodo": 202602,
        "valor": 38709288080.5,
        "delta": -1478548728.0
      },
      {
        "periodo": 202603,
        "valor": 37472108189.5,
        "delta": -1237179891.0
      },
      {
        "periodo": 202604,
        "valor": 36256881408.61,
        "delta": -1215226780.89
      },
      {
        "periodo": 202605,
        "valor": 35089794684.5,
        "delta": -1167086724.11
      },
      {
        "periodo": 202606,
        "valor": 34194128463.5,
        "delta": -895666221.0
      },
      {
        "periodo": 202607,
        "valor": 33424165626.5,
        "delta": -769962837.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 16350443754.96,
    "valor_anterior": 16434220475.81,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19287398148.48,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19072510978.64,
        "delta": -214887169.84
      },
      {
        "periodo": 202509,
        "valor": 18873147892.13,
        "delta": -199363086.51
      },
      {
        "periodo": 202510,
        "valor": 18587850810.42,
        "delta": -285297081.71
      },
      {
        "periodo": 202511,
        "valor": 18308941383.38,
        "delta": -278909427.04
      },
      {
        "periodo": 202512,
        "valor": 17970495322.05,
        "delta": -338446061.33
      },
      {
        "periodo": 202601,
        "valor": 17589137268.82,
        "delta": -381358053.23
      },
      {
        "periodo": 202602,
        "valor": 17249130942.7,
        "delta": -340006326.12
      },
      {
        "periodo": 202603,
        "valor": 16919324071.76,
        "delta": -329806870.94
      },
      {
        "periodo": 202604,
        "valor": 16714254117.12,
        "delta": -205069954.64
      },
      {
        "periodo": 202605,
        "valor": 16528004459.35,
        "delta": -186249657.77
      },
      {
        "periodo": 202606,
        "valor": 16434220475.81,
        "delta": -93783983.54
      },
      {
        "periodo": 202607,
        "valor": 16350443754.96,
        "delta": -83776720.85
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 54904444601.99999,
    "valor_anterior": 55150250232.00001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 63392175829.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 62554034904.0,
        "delta": -838140925.0
      },
      {
        "periodo": 202509,
        "valor": 61912736389.0,
        "delta": -641298515.0
      },
      {
        "periodo": 202510,
        "valor": 61118043039.0,
        "delta": -794693350.0
      },
      {
        "periodo": 202511,
        "valor": 60146970166.0,
        "delta": -971072873.0
      },
      {
        "periodo": 202512,
        "valor": 59411902945.0,
        "delta": -735067221.0
      },
      {
        "periodo": 202601,
        "valor": 58438563973.0,
        "delta": -973338972.0
      },
      {
        "periodo": 202602,
        "valor": 57652651567.0,
        "delta": -785912406.0
      },
      {
        "periodo": 202603,
        "valor": 57230341999.0,
        "delta": -422309568.0
      },
      {
        "periodo": 202604,
        "valor": 56541870801.0,
        "delta": -688471198.0
      },
      {
        "periodo": 202605,
        "valor": 55607473759.0,
        "delta": -934397042.0
      },
      {
        "periodo": 202606,
        "valor": 55150250232.0,
        "delta": -457223527.0
      },
      {
        "periodo": 202607,
        "valor": 54904444602.0,
        "delta": -245805630.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 10217081376.0,
    "valor_anterior": 10232327969.999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11161442952.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11005705243.0,
        "delta": -155737709.0
      },
      {
        "periodo": 202509,
        "valor": 10880907059.0,
        "delta": -124798184.0
      },
      {
        "periodo": 202510,
        "valor": 10755637284.0,
        "delta": -125269775.0
      },
      {
        "periodo": 202511,
        "valor": 10634053551.0,
        "delta": -121583733.0
      },
      {
        "periodo": 202512,
        "valor": 10520385786.0,
        "delta": -113667765.0
      },
      {
        "periodo": 202601,
        "valor": 10449635717.0,
        "delta": -70750069.0
      },
      {
        "periodo": 202602,
        "valor": 10358019139.0,
        "delta": -91616578.0
      },
      {
        "periodo": 202603,
        "valor": 10299284009.0,
        "delta": -58735130.0
      },
      {
        "periodo": 202604,
        "valor": 10283279676.0,
        "delta": -16004333.0
      },
      {
        "periodo": 202605,
        "valor": 10261422197.0,
        "delta": -21857479.0
      },
      {
        "periodo": 202606,
        "valor": 10232327970.0,
        "delta": -29094227.0
      },
      {
        "periodo": 202607,
        "valor": 10217081376.0,
        "delta": -15246594.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 39051185503.0,
    "valor_anterior": 39481220274.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 50023059856.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 48862670150.0,
        "delta": -1160389706.0
      },
      {
        "periodo": 202509,
        "valor": 47754116367.0,
        "delta": -1108553783.0
      },
      {
        "periodo": 202510,
        "valor": 46642813714.0,
        "delta": -1111302653.0
      },
      {
        "periodo": 202511,
        "valor": 45556495922.0,
        "delta": -1086317792.0
      },
      {
        "periodo": 202512,
        "valor": 44559474327.0,
        "delta": -997021595.0
      },
      {
        "periodo": 202601,
        "valor": 43340615224.0,
        "delta": -1218859103.0
      },
      {
        "periodo": 202602,
        "valor": 42426537980.0,
        "delta": -914077244.0
      },
      {
        "periodo": 202603,
        "valor": 41539173657.0,
        "delta": -887364323.0
      },
      {
        "periodo": 202604,
        "valor": 40704220014.0,
        "delta": -834953643.0
      },
      {
        "periodo": 202605,
        "valor": 40012995933.0,
        "delta": -691224081.0
      },
      {
        "periodo": 202606,
        "valor": 39481220274.0,
        "delta": -531775659.0
      },
      {
        "periodo": 202607,
        "valor": 39051185503.0,
        "delta": -430034771.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 13772272774.98,
    "valor_anterior": 13949684189.99,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16208258109.95,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16078273721.33,
        "delta": -129984388.62
      },
      {
        "periodo": 202509,
        "valor": 15895844723.23,
        "delta": -182428998.1
      },
      {
        "periodo": 202510,
        "valor": 15685824281.73,
        "delta": -210020441.5
      },
      {
        "periodo": 202511,
        "valor": 15469568548.54,
        "delta": -216255733.19
      },
      {
        "periodo": 202512,
        "valor": 15269433720.64,
        "delta": -200134827.9
      },
      {
        "periodo": 202601,
        "valor": 15089765023.64,
        "delta": -179668697.0
      },
      {
        "periodo": 202602,
        "valor": 14887270730.4,
        "delta": -202494293.24
      },
      {
        "periodo": 202603,
        "valor": 14680521506.55,
        "delta": -206749223.85
      },
      {
        "periodo": 202604,
        "valor": 14438065235.5,
        "delta": -242456271.05
      },
      {
        "periodo": 202605,
        "valor": 14191172278.01,
        "delta": -246892957.49
      },
      {
        "periodo": 202606,
        "valor": 13949684189.99,
        "delta": -241488088.02
      },
      {
        "periodo": 202607,
        "valor": 13772272774.98,
        "delta": -177411415.01
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 15647715173.0,
    "valor_anterior": 16198295837.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18110326456.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17550979380.0,
        "delta": -559347076.0
      },
      {
        "periodo": 202509,
        "valor": 17574701174.0,
        "delta": 23721794.0
      },
      {
        "periodo": 202510,
        "valor": 17800636412.0,
        "delta": 225935238.0
      },
      {
        "periodo": 202511,
        "valor": 17973311812.0,
        "delta": 172675400.0
      },
      {
        "periodo": 202512,
        "valor": 17906898997.0,
        "delta": -66412815.0
      },
      {
        "periodo": 202601,
        "valor": 17993349800.0,
        "delta": 86450803.0
      },
      {
        "periodo": 202602,
        "valor": 17440120938.0,
        "delta": -553228862.0
      },
      {
        "periodo": 202603,
        "valor": 17416785003.0,
        "delta": -23335935.0
      },
      {
        "periodo": 202604,
        "valor": 17084898937.0,
        "delta": -331886066.0
      },
      {
        "periodo": 202605,
        "valor": 16581383886.0,
        "delta": -503515051.0
      },
      {
        "periodo": 202606,
        "valor": 16198295837.0,
        "delta": -383088049.0
      },
      {
        "periodo": 202607,
        "valor": 15647715173.0,
        "delta": -550580664.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 3285490748.0,
    "valor_anterior": 3377913802.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4394702649.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4308468865.0,
        "delta": -86233784.0
      },
      {
        "periodo": 202509,
        "valor": 4238306703.0,
        "delta": -70162162.0
      },
      {
        "periodo": 202510,
        "valor": 4145456032.0,
        "delta": -92850671.0
      },
      {
        "periodo": 202511,
        "valor": 4045482965.0,
        "delta": -99973067.0
      },
      {
        "periodo": 202512,
        "valor": 3941697534.0,
        "delta": -103785431.0
      },
      {
        "periodo": 202601,
        "valor": 3836958129.0,
        "delta": -104739405.0
      },
      {
        "periodo": 202602,
        "valor": 3755281805.0,
        "delta": -81676324.0
      },
      {
        "periodo": 202603,
        "valor": 3660826075.0,
        "delta": -94455730.0
      },
      {
        "periodo": 202604,
        "valor": 3570345914.0,
        "delta": -90480161.0
      },
      {
        "periodo": 202605,
        "valor": 3473548281.0,
        "delta": -96797633.0
      },
      {
        "periodo": 202606,
        "valor": 3377913802.0,
        "delta": -95634479.0
      },
      {
        "periodo": 202607,
        "valor": 3285490748.0,
        "delta": -92423054.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 19429715770.0,
    "valor_anterior": 19958087845.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26662226371.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26146781114.0,
        "delta": -515445257.0
      },
      {
        "periodo": 202509,
        "valor": 25616637479.0,
        "delta": -530143635.0
      },
      {
        "periodo": 202510,
        "valor": 24975375269.0,
        "delta": -641262210.0
      },
      {
        "periodo": 202511,
        "valor": 24349552326.0,
        "delta": -625822943.0
      },
      {
        "periodo": 202512,
        "valor": 23718334288.0,
        "delta": -631218038.0
      },
      {
        "periodo": 202601,
        "valor": 23114843544.0,
        "delta": -603490744.0
      },
      {
        "periodo": 202602,
        "valor": 22565550570.0,
        "delta": -549292974.0
      },
      {
        "periodo": 202603,
        "valor": 21894428754.0,
        "delta": -671121816.0
      },
      {
        "periodo": 202604,
        "valor": 21286424600.0,
        "delta": -608004154.0
      },
      {
        "periodo": 202605,
        "valor": 20624018063.0,
        "delta": -662406537.0
      },
      {
        "periodo": 202606,
        "valor": 19958087845.0,
        "delta": -665930218.0
      },
      {
        "periodo": 202607,
        "valor": 19429715770.0,
        "delta": -528372075.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 199200573878.36,
    "valor_anterior": 202281413089.98,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 262496978872.44,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 260689237358.19,
        "delta": -1807741514.25
      },
      {
        "periodo": 202509,
        "valor": 257900912813.28,
        "delta": -2788324544.91
      },
      {
        "periodo": 202510,
        "valor": 253287075378.54,
        "delta": -4613837434.74
      },
      {
        "periodo": 202511,
        "valor": 247191032475.0601,
        "delta": -6096042903.4799
      },
      {
        "periodo": 202512,
        "valor": 240264408480.02,
        "delta": -6926623995.04
      },
      {
        "periodo": 202601,
        "valor": 232641120042.4,
        "delta": -7623288437.62
      },
      {
        "periodo": 202602,
        "valor": 225948115428.17,
        "delta": -6693004614.23
      },
      {
        "periodo": 202603,
        "valor": 218561541163.99,
        "delta": -7386574264.18
      },
      {
        "periodo": 202604,
        "valor": 212033849075.17,
        "delta": -6527692088.82
      },
      {
        "periodo": 202605,
        "valor": 206148543579.66,
        "delta": -5885305495.51
      },
      {
        "periodo": 202606,
        "valor": 202281413089.98,
        "delta": -3867130489.68
      },
      {
        "periodo": 202607,
        "valor": 199200573878.36,
        "delta": -3080839211.62
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 12779837849.999998,
    "valor_anterior": 12861295479.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17791568588.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16982943713.0,
        "delta": -808624875.0
      },
      {
        "periodo": 202509,
        "valor": 16609839327.0,
        "delta": -373104386.0
      },
      {
        "periodo": 202510,
        "valor": 16421884434.0,
        "delta": -187954893.0
      },
      {
        "periodo": 202511,
        "valor": 15709863786.0,
        "delta": -712020648.0
      },
      {
        "periodo": 202512,
        "valor": 15589510079.0,
        "delta": -120353707.0
      },
      {
        "periodo": 202601,
        "valor": 13874134879.0,
        "delta": -1715375200.0
      },
      {
        "periodo": 202602,
        "valor": 14023728296.0,
        "delta": 149593417.0
      },
      {
        "periodo": 202603,
        "valor": 14511225297.0,
        "delta": 487497001.0
      },
      {
        "periodo": 202604,
        "valor": 13579938249.0,
        "delta": -931287048.0
      },
      {
        "periodo": 202605,
        "valor": 13173818782.0,
        "delta": -406119467.0
      },
      {
        "periodo": 202606,
        "valor": 12861295479.0,
        "delta": -312523303.0
      },
      {
        "periodo": 202607,
        "valor": 12779837850.0,
        "delta": -81457629.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 740988430.0,
    "valor_anterior": 732495071.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1048926087.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 997858167.0,
        "delta": -51067920.0
      },
      {
        "periodo": 202509,
        "valor": 957074825.0,
        "delta": -40783342.0
      },
      {
        "periodo": 202510,
        "valor": 924339305.0,
        "delta": -32735520.0
      },
      {
        "periodo": 202511,
        "valor": 885172165.0,
        "delta": -39167140.0
      },
      {
        "periodo": 202512,
        "valor": 844273597.0,
        "delta": -40898568.0
      },
      {
        "periodo": 202601,
        "valor": 801965528.0,
        "delta": -42308069.0
      },
      {
        "periodo": 202602,
        "valor": 775976274.0,
        "delta": -25989254.0
      },
      {
        "periodo": 202603,
        "valor": 749256234.0,
        "delta": -26720040.0
      },
      {
        "periodo": 202604,
        "valor": 734785545.0,
        "delta": -14470689.0
      },
      {
        "periodo": 202605,
        "valor": 730605519.0,
        "delta": -4180026.0
      },
      {
        "periodo": 202606,
        "valor": 732495071.0,
        "delta": 1889552.0
      },
      {
        "periodo": 202607,
        "valor": 740988430.0,
        "delta": 8493359.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 4442061139.0,
    "valor_anterior": 4509825597.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5608699405.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5652599342.0,
        "delta": 43899937.0
      },
      {
        "periodo": 202509,
        "valor": 5661642128.0,
        "delta": 9042786.0
      },
      {
        "periodo": 202510,
        "valor": 5500398611.0,
        "delta": -161243517.0
      },
      {
        "periodo": 202511,
        "valor": 5340610174.0,
        "delta": -159788437.0
      },
      {
        "periodo": 202512,
        "valor": 5026397187.0,
        "delta": -314212987.0
      },
      {
        "periodo": 202601,
        "valor": 4730746578.0,
        "delta": -295650609.0
      },
      {
        "periodo": 202602,
        "valor": 4558757191.0,
        "delta": -171989387.0
      },
      {
        "periodo": 202603,
        "valor": 4460157102.0,
        "delta": -98600089.0
      },
      {
        "periodo": 202604,
        "valor": 4308979459.0,
        "delta": -151177643.0
      },
      {
        "periodo": 202605,
        "valor": 4537891548.0,
        "delta": 228912089.0
      },
      {
        "periodo": 202606,
        "valor": 4509825597.0,
        "delta": -28065951.0
      },
      {
        "periodo": 202607,
        "valor": 4442061139.0,
        "delta": -67764458.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 11567325517.57,
    "valor_anterior": 11826251634.81,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17185496868.08,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16966440522.62,
        "delta": -219056345.46
      },
      {
        "periodo": 202509,
        "valor": 16704856078.99,
        "delta": -261584443.63
      },
      {
        "periodo": 202510,
        "valor": 16369992654.98,
        "delta": -334863424.01
      },
      {
        "periodo": 202511,
        "valor": 15784217398.47,
        "delta": -585775256.51
      },
      {
        "periodo": 202512,
        "valor": 15202872819.39,
        "delta": -581344579.08
      },
      {
        "periodo": 202601,
        "valor": 14678690505.38,
        "delta": -524182314.01
      },
      {
        "periodo": 202602,
        "valor": 14169994186.23,
        "delta": -508696319.15
      },
      {
        "periodo": 202603,
        "valor": 13588921249.99,
        "delta": -581072936.24
      },
      {
        "periodo": 202604,
        "valor": 12974238431.59,
        "delta": -614682818.4
      },
      {
        "periodo": 202605,
        "valor": 12369878980.45,
        "delta": -604359451.14
      },
      {
        "periodo": 202606,
        "valor": 11826251634.81,
        "delta": -543627345.64
      },
      {
        "periodo": 202607,
        "valor": 11567325517.57,
        "delta": -258926117.24
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 7325875539.000001,
    "valor_anterior": 7271206860.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7211381054.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7087705225.0,
        "delta": -123675829.0
      },
      {
        "periodo": 202509,
        "valor": 7021691153.0,
        "delta": -66014072.0
      },
      {
        "periodo": 202510,
        "valor": 6953794837.0,
        "delta": -67896316.0
      },
      {
        "periodo": 202511,
        "valor": 6871118898.0,
        "delta": -82675939.0
      },
      {
        "periodo": 202512,
        "valor": 6795480426.0,
        "delta": -75638472.0
      },
      {
        "periodo": 202601,
        "valor": 6858110426.0,
        "delta": 62630000.0
      },
      {
        "periodo": 202602,
        "valor": 6915025858.0,
        "delta": 56915432.0
      },
      {
        "periodo": 202603,
        "valor": 6984676077.0,
        "delta": 69650219.0
      },
      {
        "periodo": 202604,
        "valor": 7108735877.0,
        "delta": 124059800.0
      },
      {
        "periodo": 202605,
        "valor": 7192677464.0,
        "delta": 83941587.0
      },
      {
        "periodo": 202606,
        "valor": 7271206861.0,
        "delta": 78529397.0
      },
      {
        "periodo": 202607,
        "valor": 7325875539.0,
        "delta": 54668678.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 21301584101.79,
    "valor_anterior": 21588441766.53,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19238117196.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21065388418.35,
        "delta": 1827271221.93
      },
      {
        "periodo": 202509,
        "valor": 23028215637.84,
        "delta": 1962827219.49
      },
      {
        "periodo": 202510,
        "valor": 24152464520.49,
        "delta": 1124248882.65
      },
      {
        "periodo": 202511,
        "valor": 26296858791.5,
        "delta": 2144394271.01
      },
      {
        "periodo": 202512,
        "valor": 26739306002.19,
        "delta": 442447210.69
      },
      {
        "periodo": 202601,
        "valor": 26411455156.78,
        "delta": -327850845.41
      },
      {
        "periodo": 202602,
        "valor": 25981999220.44,
        "delta": -429455936.34
      },
      {
        "periodo": 202603,
        "valor": 25305274497.67,
        "delta": -676724722.77
      },
      {
        "periodo": 202604,
        "valor": 22980840729.54,
        "delta": -2324433768.13
      },
      {
        "periodo": 202605,
        "valor": 22557679136.87,
        "delta": -423161592.67
      },
      {
        "periodo": 202606,
        "valor": 21588441766.53,
        "delta": -969237370.34
      },
      {
        "periodo": 202607,
        "valor": 21301584101.79,
        "delta": -286857664.74
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": -63287.0,
    "valor_anterior": -63287.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6464674.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5518534.0,
        "delta": -946140.0
      },
      {
        "periodo": 202509,
        "valor": 4954940.0,
        "delta": -563594.0
      },
      {
        "periodo": 202510,
        "valor": 1081344.0,
        "delta": -3873596.0
      },
      {
        "periodo": 202511,
        "valor": 282649.0,
        "delta": -798695.0
      },
      {
        "periodo": 202512,
        "valor": 434137.0,
        "delta": 151488.0
      },
      {
        "periodo": 202601,
        "valor": 182332.0,
        "delta": -251805.0
      },
      {
        "periodo": 202602,
        "valor": -63287.0,
        "delta": -245619.0
      },
      {
        "periodo": 202603,
        "valor": -63287.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": -63287.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": -63287.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": -63287.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": -63287.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 11067227593.03,
    "valor_anterior": 11272876291.81,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12855068100.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12679715609.61,
        "delta": -175352491.11
      },
      {
        "periodo": 202509,
        "valor": 12586450092.48,
        "delta": -93265517.13
      },
      {
        "periodo": 202510,
        "valor": 12482749654.86,
        "delta": -103700437.62
      },
      {
        "periodo": 202511,
        "valor": 12235058094.08,
        "delta": -247691560.78
      },
      {
        "periodo": 202512,
        "valor": 12116730242.68,
        "delta": -118327851.4
      },
      {
        "periodo": 202601,
        "valor": 11999566317.2,
        "delta": -117163925.48
      },
      {
        "periodo": 202602,
        "valor": 11876760409.34,
        "delta": -122805907.86
      },
      {
        "periodo": 202603,
        "valor": 11721770208.35,
        "delta": -154990200.99
      },
      {
        "periodo": 202604,
        "valor": 11593575983.06,
        "delta": -128194225.29
      },
      {
        "periodo": 202605,
        "valor": 11437031872.76,
        "delta": -156544110.3
      },
      {
        "periodo": 202606,
        "valor": 11272876291.81,
        "delta": -164155580.95
      },
      {
        "periodo": 202607,
        "valor": 11067227593.03,
        "delta": -205648698.78
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 3250781569.77,
    "valor_anterior": 3006843649.85,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1308661259.83,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1397767125.75,
        "delta": 89105865.92
      },
      {
        "periodo": 202509,
        "valor": 1534847835.16,
        "delta": 137080709.41
      },
      {
        "periodo": 202510,
        "valor": 1706658763.8,
        "delta": 171810928.64
      },
      {
        "periodo": 202511,
        "valor": 1874651382.47,
        "delta": 167992618.67
      },
      {
        "periodo": 202512,
        "valor": 2044109396.0,
        "delta": 169458013.53
      },
      {
        "periodo": 202601,
        "valor": 2246177234.76,
        "delta": 202067838.76
      },
      {
        "periodo": 202602,
        "valor": 2383036141.75,
        "delta": 136858906.99
      },
      {
        "periodo": 202603,
        "valor": 2560998911.36,
        "delta": 177962769.61
      },
      {
        "periodo": 202604,
        "valor": 2727974410.75,
        "delta": 166975499.39
      },
      {
        "periodo": 202605,
        "valor": 2868619536.3,
        "delta": 140645125.55
      },
      {
        "periodo": 202606,
        "valor": 3006843649.85,
        "delta": 138224113.55
      },
      {
        "periodo": 202607,
        "valor": 3250781569.77,
        "delta": 243937919.92
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 4458789124.0,
    "valor_anterior": 4679820572.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4156770331.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4592794754.0,
        "delta": 436024423.0
      },
      {
        "periodo": 202509,
        "valor": 5042092856.0,
        "delta": 449298102.0
      },
      {
        "periodo": 202510,
        "valor": 5424220472.0,
        "delta": 382127616.0
      },
      {
        "periodo": 202511,
        "valor": 5569053139.0,
        "delta": 144832667.0
      },
      {
        "periodo": 202512,
        "valor": 5639990351.0,
        "delta": 70937212.0
      },
      {
        "periodo": 202601,
        "valor": 5646023331.0,
        "delta": 6032980.0
      },
      {
        "periodo": 202602,
        "valor": 5511456255.0,
        "delta": -134567076.0
      },
      {
        "periodo": 202603,
        "valor": 5320445242.0,
        "delta": -191011013.0
      },
      {
        "periodo": 202604,
        "valor": 5181384880.0,
        "delta": -139060362.0
      },
      {
        "periodo": 202605,
        "valor": 4944860105.0,
        "delta": -236524775.0
      },
      {
        "periodo": 202606,
        "valor": 4679820572.0,
        "delta": -265039533.0
      },
      {
        "periodo": 202607,
        "valor": 4458789124.0,
        "delta": -221031448.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 5727385520.0,
    "valor_anterior": 5836062674.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5704413844.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5784534117.0,
        "delta": 80120273.0
      },
      {
        "periodo": 202509,
        "valor": 5868332135.0,
        "delta": 83798018.0
      },
      {
        "periodo": 202510,
        "valor": 5973283571.0,
        "delta": 104951436.0
      },
      {
        "periodo": 202511,
        "valor": 6045655078.0,
        "delta": 72371507.0
      },
      {
        "periodo": 202512,
        "valor": 6067880000.0,
        "delta": 22224922.0
      },
      {
        "periodo": 202601,
        "valor": 6063083664.0,
        "delta": -4796336.0
      },
      {
        "periodo": 202602,
        "valor": 6063895623.0,
        "delta": 811959.0
      },
      {
        "periodo": 202603,
        "valor": 6079097057.0,
        "delta": 15201434.0
      },
      {
        "periodo": 202604,
        "valor": 6026739828.0,
        "delta": -52357229.0
      },
      {
        "periodo": 202605,
        "valor": 5927398585.0,
        "delta": -99341243.0
      },
      {
        "periodo": 202606,
        "valor": 5836062674.0,
        "delta": -91335911.0
      },
      {
        "periodo": 202607,
        "valor": 5727385520.0,
        "delta": -108677154.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 10643804188.0,
    "valor_anterior": 10776096052.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12427797637.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12280674374.0,
        "delta": -147123263.0
      },
      {
        "periodo": 202509,
        "valor": 12177768628.0,
        "delta": -102905746.0
      },
      {
        "periodo": 202510,
        "valor": 12090639541.0,
        "delta": -87129087.0
      },
      {
        "periodo": 202511,
        "valor": 11945999163.0,
        "delta": -144640378.0
      },
      {
        "periodo": 202512,
        "valor": 11792184257.0,
        "delta": -153814906.0
      },
      {
        "periodo": 202601,
        "valor": 11627990950.0,
        "delta": -164193307.0
      },
      {
        "periodo": 202602,
        "valor": 11485824648.0,
        "delta": -142166302.0
      },
      {
        "periodo": 202603,
        "valor": 11327552474.0,
        "delta": -158272174.0
      },
      {
        "periodo": 202604,
        "valor": 11176295504.0,
        "delta": -151256970.0
      },
      {
        "periodo": 202605,
        "valor": 10988234964.0,
        "delta": -188060540.0
      },
      {
        "periodo": 202606,
        "valor": 10776096052.0,
        "delta": -212138912.0
      },
      {
        "periodo": 202607,
        "valor": 10643804188.0,
        "delta": -132291864.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 3851653612.0,
    "valor_anterior": 3928471699.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4853678657.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4777931629.0,
        "delta": -75747028.0
      },
      {
        "periodo": 202509,
        "valor": 4651543850.0,
        "delta": -126387779.0
      },
      {
        "periodo": 202510,
        "valor": 4614658313.0,
        "delta": -36885537.0
      },
      {
        "periodo": 202511,
        "valor": 4525192257.0,
        "delta": -89466056.0
      },
      {
        "periodo": 202512,
        "valor": 4465912461.0,
        "delta": -59279796.0
      },
      {
        "periodo": 202601,
        "valor": 4329006168.0,
        "delta": -136906293.0
      },
      {
        "periodo": 202602,
        "valor": 4288639755.0,
        "delta": -40366413.0
      },
      {
        "periodo": 202603,
        "valor": 4287504079.0,
        "delta": -1135676.0
      },
      {
        "periodo": 202604,
        "valor": 4088738494.0,
        "delta": -198765585.0
      },
      {
        "periodo": 202605,
        "valor": 4002081437.0,
        "delta": -86657057.0
      },
      {
        "periodo": 202606,
        "valor": 3928471699.0,
        "delta": -73609738.0
      },
      {
        "periodo": 202607,
        "valor": 3851653612.0,
        "delta": -76818087.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 131443115.0,
    "valor_anterior": 441925141.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3505766599.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3373099210.0,
        "delta": -132667389.0
      },
      {
        "periodo": 202509,
        "valor": 3061189579.0,
        "delta": -311909631.0
      },
      {
        "periodo": 202510,
        "valor": 2763600551.0,
        "delta": -297589028.0
      },
      {
        "periodo": 202511,
        "valor": 2482865676.0,
        "delta": -280734875.0
      },
      {
        "periodo": 202512,
        "valor": 2171548605.0,
        "delta": -311317071.0
      },
      {
        "periodo": 202601,
        "valor": 1881595512.0,
        "delta": -289953093.0
      },
      {
        "periodo": 202602,
        "valor": 1626084469.0,
        "delta": -255511043.0
      },
      {
        "periodo": 202603,
        "valor": 1342337184.0,
        "delta": -283747285.0
      },
      {
        "periodo": 202604,
        "valor": 1068608655.0,
        "delta": -273728529.0
      },
      {
        "periodo": 202605,
        "valor": 760657643.0,
        "delta": -307951012.0
      },
      {
        "periodo": 202606,
        "valor": 441925141.0,
        "delta": -318732502.0
      },
      {
        "periodo": 202607,
        "valor": 131443115.0,
        "delta": -310482026.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 2612893349.32,
    "valor_anterior": 2607191883.36,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3919467825.47,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3735056007.1,
        "delta": -184411818.37
      },
      {
        "periodo": 202509,
        "valor": 3576923329.6,
        "delta": -158132677.5
      },
      {
        "periodo": 202510,
        "valor": 3407494220.9,
        "delta": -169429108.7
      },
      {
        "periodo": 202511,
        "valor": 3233080406.56,
        "delta": -174413814.34
      },
      {
        "periodo": 202512,
        "valor": 3126680317.57,
        "delta": -106400088.99
      },
      {
        "periodo": 202601,
        "valor": 2970805529.68,
        "delta": -155874787.89
      },
      {
        "periodo": 202602,
        "valor": 2838015896.07,
        "delta": -132789633.61
      },
      {
        "periodo": 202603,
        "valor": 2706644182.59,
        "delta": -131371713.48
      },
      {
        "periodo": 202604,
        "valor": 2672231340.61,
        "delta": -34412841.98
      },
      {
        "periodo": 202605,
        "valor": 2666997873.21,
        "delta": -5233467.4
      },
      {
        "periodo": 202606,
        "valor": 2607191883.36,
        "delta": -59805989.85
      },
      {
        "periodo": 202607,
        "valor": 2612893349.32,
        "delta": 5701465.96
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 581955727.0,
    "valor_anterior": 612421500.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 654795204.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 653257252.0,
        "delta": -1537952.0
      },
      {
        "periodo": 202509,
        "valor": 661307405.0,
        "delta": 8050153.0
      },
      {
        "periodo": 202510,
        "valor": 660377024.0,
        "delta": -930381.0
      },
      {
        "periodo": 202511,
        "valor": 660283722.0,
        "delta": -93302.0
      },
      {
        "periodo": 202512,
        "valor": 657869536.0,
        "delta": -2414186.0
      },
      {
        "periodo": 202601,
        "valor": 656735457.0,
        "delta": -1134079.0
      },
      {
        "periodo": 202602,
        "valor": 662222360.0,
        "delta": 5486903.0
      },
      {
        "periodo": 202603,
        "valor": 665339604.0,
        "delta": 3117244.0
      },
      {
        "periodo": 202604,
        "valor": 653689952.0,
        "delta": -11649652.0
      },
      {
        "periodo": 202605,
        "valor": 638378838.0,
        "delta": -15311114.0
      },
      {
        "periodo": 202606,
        "valor": 612421500.0,
        "delta": -25957338.0
      },
      {
        "periodo": 202607,
        "valor": 581955727.0,
        "delta": -30465773.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 3748926823.0,
    "valor_anterior": 3774498037.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5294873004.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5101225866.0,
        "delta": -193647138.0
      },
      {
        "periodo": 202509,
        "valor": 4922673075.0,
        "delta": -178552791.0
      },
      {
        "periodo": 202510,
        "valor": 4758658361.0,
        "delta": -164014714.0
      },
      {
        "periodo": 202511,
        "valor": 4588702317.0,
        "delta": -169956044.0
      },
      {
        "periodo": 202512,
        "valor": 4425231747.0,
        "delta": -163470570.0
      },
      {
        "periodo": 202601,
        "valor": 4306565111.0,
        "delta": -118666636.0
      },
      {
        "periodo": 202602,
        "valor": 4166821610.0,
        "delta": -139743501.0
      },
      {
        "periodo": 202603,
        "valor": 3991878532.0,
        "delta": -174943078.0
      },
      {
        "periodo": 202604,
        "valor": 3828319524.0,
        "delta": -163559008.0
      },
      {
        "periodo": 202605,
        "valor": 3820987374.0,
        "delta": -7332150.0
      },
      {
        "periodo": 202606,
        "valor": 3774498037.0,
        "delta": -46489337.0
      },
      {
        "periodo": 202607,
        "valor": 3748926823.0,
        "delta": -25571214.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 3197523030.0,
    "valor_anterior": 3222486251.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3348965028.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3352522008.0,
        "delta": 3556980.0
      },
      {
        "periodo": 202509,
        "valor": 3340754594.0,
        "delta": -11767414.0
      },
      {
        "periodo": 202510,
        "valor": 3336811389.0,
        "delta": -3943205.0
      },
      {
        "periodo": 202511,
        "valor": 3325732205.0,
        "delta": -11079184.0
      },
      {
        "periodo": 202512,
        "valor": 3307032945.0,
        "delta": -18699260.0
      },
      {
        "periodo": 202601,
        "valor": 3291240379.0,
        "delta": -15792566.0
      },
      {
        "periodo": 202602,
        "valor": 3338549409.0,
        "delta": 47309030.0
      },
      {
        "periodo": 202603,
        "valor": 3267156492.0,
        "delta": -71392917.0
      },
      {
        "periodo": 202604,
        "valor": 3261259585.0,
        "delta": -5896907.0
      },
      {
        "periodo": 202605,
        "valor": 3235495523.0,
        "delta": -25764062.0
      },
      {
        "periodo": 202606,
        "valor": 3222486251.0,
        "delta": -13009272.0
      },
      {
        "periodo": 202607,
        "valor": 3197523030.0,
        "delta": -24963221.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 618137369.0,
    "valor_anterior": 603783995.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 365705259.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 377268524.0,
        "delta": 11563265.0
      },
      {
        "periodo": 202509,
        "valor": 393412439.0,
        "delta": 16143915.0
      },
      {
        "periodo": 202510,
        "valor": 412922328.0,
        "delta": 19509889.0
      },
      {
        "periodo": 202511,
        "valor": 428457891.0,
        "delta": 15535563.0
      },
      {
        "periodo": 202512,
        "valor": 536468031.0,
        "delta": 108010140.0
      },
      {
        "periodo": 202601,
        "valor": 548279031.0,
        "delta": 11811000.0
      },
      {
        "periodo": 202602,
        "valor": 560641014.0,
        "delta": 12361983.0
      },
      {
        "periodo": 202603,
        "valor": 572688868.0,
        "delta": 12047854.0
      },
      {
        "periodo": 202604,
        "valor": 575303921.0,
        "delta": 2615053.0
      },
      {
        "periodo": 202605,
        "valor": 588987195.0,
        "delta": 13683274.0
      },
      {
        "periodo": 202606,
        "valor": 603783995.0,
        "delta": 14796800.0
      },
      {
        "periodo": 202607,
        "valor": 618137369.0,
        "delta": 14353374.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7539067232.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7469779561.0,
        "delta": -69287671.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 11475376409.999998,
    "valor_anterior": 11348543246.000002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11273486291.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11225232710.0,
        "delta": -48253581.0
      },
      {
        "periodo": 202509,
        "valor": 11250109283.0,
        "delta": 24876573.0
      },
      {
        "periodo": 202510,
        "valor": 11234649622.0,
        "delta": -15459661.0
      },
      {
        "periodo": 202511,
        "valor": 11206697186.0,
        "delta": -27952436.0
      },
      {
        "periodo": 202512,
        "valor": 11261503737.0,
        "delta": 54806551.0
      },
      {
        "periodo": 202601,
        "valor": 11384948425.0,
        "delta": 123444688.0
      },
      {
        "periodo": 202602,
        "valor": 11514866928.0,
        "delta": 129918503.0
      },
      {
        "periodo": 202603,
        "valor": 11488604066.0,
        "delta": -26262862.0
      },
      {
        "periodo": 202604,
        "valor": 11422527277.0,
        "delta": -66076789.0
      },
      {
        "periodo": 202605,
        "valor": 11376666568.0,
        "delta": -45860709.0
      },
      {
        "periodo": 202606,
        "valor": 11348543246.0,
        "delta": -28123322.0
      },
      {
        "periodo": 202607,
        "valor": 11475376410.0,
        "delta": 126833164.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 1226256336.0,
    "valor_anterior": 1199254557.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 932317104.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 956862807.0,
        "delta": 24545703.0
      },
      {
        "periodo": 202509,
        "valor": 977272511.0,
        "delta": 20409704.0
      },
      {
        "periodo": 202510,
        "valor": 996775701.0,
        "delta": 19503190.0
      },
      {
        "periodo": 202511,
        "valor": 1019132070.0,
        "delta": 22356369.0
      },
      {
        "periodo": 202512,
        "valor": 1045802965.0,
        "delta": 26670895.0
      },
      {
        "periodo": 202601,
        "valor": 1070155511.0,
        "delta": 24352546.0
      },
      {
        "periodo": 202602,
        "valor": 1091113225.0,
        "delta": 20957714.0
      },
      {
        "periodo": 202603,
        "valor": 1118804347.0,
        "delta": 27691122.0
      },
      {
        "periodo": 202604,
        "valor": 1148101899.0,
        "delta": 29297552.0
      },
      {
        "periodo": 202605,
        "valor": 1173471989.0,
        "delta": 25370090.0
      },
      {
        "periodo": 202606,
        "valor": 1199254557.0,
        "delta": 25782568.0
      },
      {
        "periodo": 202607,
        "valor": 1226256336.0,
        "delta": 27001779.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 34219888.0,
    "valor_anterior": 33070786.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 24684245.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24993602.0,
        "delta": 309357.0
      },
      {
        "periodo": 202509,
        "valor": 25504953.0,
        "delta": 511351.0
      },
      {
        "periodo": 202510,
        "valor": 26033461.0,
        "delta": 528508.0
      },
      {
        "periodo": 202511,
        "valor": 26671508.0,
        "delta": 638047.0
      },
      {
        "periodo": 202512,
        "valor": 27341796.0,
        "delta": 670288.0
      },
      {
        "periodo": 202601,
        "valor": 28173874.0,
        "delta": 832078.0
      },
      {
        "periodo": 202602,
        "valor": 29005002.0,
        "delta": 831128.0
      },
      {
        "periodo": 202603,
        "valor": 30013947.0,
        "delta": 1008945.0
      },
      {
        "periodo": 202604,
        "valor": 30922405.0,
        "delta": 908458.0
      },
      {
        "periodo": 202605,
        "valor": 31939912.0,
        "delta": 1017507.0
      },
      {
        "periodo": 202606,
        "valor": 33070786.0,
        "delta": 1130874.0
      },
      {
        "periodo": 202607,
        "valor": 34219888.0,
        "delta": 1149102.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 1274650655.97,
    "valor_anterior": 1293185999.19,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1474362668.36,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1467896522.23,
        "delta": -6466146.13
      },
      {
        "periodo": 202509,
        "valor": 1454808022.82,
        "delta": -13088499.41
      },
      {
        "periodo": 202510,
        "valor": 1441721457.28,
        "delta": -13086565.54
      },
      {
        "periodo": 202511,
        "valor": 1428991559.87,
        "delta": -12729897.41
      },
      {
        "periodo": 202512,
        "valor": 1414179838.64,
        "delta": -14811721.23
      },
      {
        "periodo": 202601,
        "valor": 1395986680.06,
        "delta": -18193158.58
      },
      {
        "periodo": 202602,
        "valor": 1376049997.58,
        "delta": -19936682.48
      },
      {
        "periodo": 202603,
        "valor": 1353166489.34,
        "delta": -22883508.24
      },
      {
        "periodo": 202604,
        "valor": 1334907157.59,
        "delta": -18259331.75
      },
      {
        "periodo": 202605,
        "valor": 1313885024.6,
        "delta": -21022132.99
      },
      {
        "periodo": 202606,
        "valor": 1293185999.19,
        "delta": -20699025.41
      },
      {
        "periodo": 202607,
        "valor": 1274650655.97,
        "delta": -18535343.22
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 147140711.0,
    "valor_anterior": 146522693.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 134705309.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 138438916.0,
        "delta": 3733607.0
      },
      {
        "periodo": 202509,
        "valor": 141816055.0,
        "delta": 3377139.0
      },
      {
        "periodo": 202510,
        "valor": 144298477.0,
        "delta": 2482422.0
      },
      {
        "periodo": 202511,
        "valor": 147366587.0,
        "delta": 3068110.0
      },
      {
        "periodo": 202512,
        "valor": 150246361.0,
        "delta": 2879774.0
      },
      {
        "periodo": 202601,
        "valor": 149538406.0,
        "delta": -707955.0
      },
      {
        "periodo": 202602,
        "valor": 146702801.0,
        "delta": -2835605.0
      },
      {
        "periodo": 202603,
        "valor": 145298994.0,
        "delta": -1403807.0
      },
      {
        "periodo": 202604,
        "valor": 146388750.0,
        "delta": 1089756.0
      },
      {
        "periodo": 202605,
        "valor": 146608630.0,
        "delta": 219880.0
      },
      {
        "periodo": 202606,
        "valor": 146522693.0,
        "delta": -85937.0
      },
      {
        "periodo": 202607,
        "valor": 147140711.0,
        "delta": 618018.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 3688199629.93,
    "valor_anterior": 3728490324.08,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4111983126.96,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4078011377.97,
        "delta": -33971748.99
      },
      {
        "periodo": 202509,
        "valor": 4040088671.61,
        "delta": -37922706.36
      },
      {
        "periodo": 202510,
        "valor": 4004732669.98,
        "delta": -35356001.63
      },
      {
        "periodo": 202511,
        "valor": 3961711168.24,
        "delta": -43021501.74
      },
      {
        "periodo": 202512,
        "valor": 3936206919.75,
        "delta": -25504248.49
      },
      {
        "periodo": 202601,
        "valor": 3892492503.93,
        "delta": -43714415.82
      },
      {
        "periodo": 202602,
        "valor": 3852403601.05,
        "delta": -40088902.88
      },
      {
        "periodo": 202603,
        "valor": 3817216523.4,
        "delta": -35187077.65
      },
      {
        "periodo": 202604,
        "valor": 3784640963.33,
        "delta": -32575560.07
      },
      {
        "periodo": 202605,
        "valor": 3759372426.15,
        "delta": -25268537.18
      },
      {
        "periodo": 202606,
        "valor": 3728490324.08,
        "delta": -30882102.07
      },
      {
        "periodo": 202607,
        "valor": 3688199629.93,
        "delta": -40290694.15
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 839548495.04,
    "valor_anterior": 838911010.3,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 754379976.05,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 780494220.83,
        "delta": 26114244.78
      },
      {
        "periodo": 202509,
        "valor": 802113870.6,
        "delta": 21619649.77
      },
      {
        "periodo": 202510,
        "valor": 819104393.11,
        "delta": 16990522.51
      },
      {
        "periodo": 202511,
        "valor": 831512505.69,
        "delta": 12408112.58
      },
      {
        "periodo": 202512,
        "valor": 850475498.46,
        "delta": 18962992.77
      },
      {
        "periodo": 202601,
        "valor": 846226355.92,
        "delta": -4249142.54
      },
      {
        "periodo": 202602,
        "valor": 845491735.18,
        "delta": -734620.74
      },
      {
        "periodo": 202603,
        "valor": 841665686.57,
        "delta": -3826048.61
      },
      {
        "periodo": 202604,
        "valor": 836224293.31,
        "delta": -5441393.26
      },
      {
        "periodo": 202605,
        "valor": 838401672.25,
        "delta": 2177378.94
      },
      {
        "periodo": 202606,
        "valor": 838911010.3,
        "delta": 509338.05
      },
      {
        "periodo": 202607,
        "valor": 839548495.04,
        "delta": 637484.74
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 217397313.0,
    "valor_anterior": 223490031.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 246602239.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 251600698.0,
        "delta": 4998459.0
      },
      {
        "periodo": 202509,
        "valor": 254405713.0,
        "delta": 2805015.0
      },
      {
        "periodo": 202510,
        "valor": 255499454.0,
        "delta": 1093741.0
      },
      {
        "periodo": 202511,
        "valor": 254515380.0,
        "delta": -984074.0
      },
      {
        "periodo": 202512,
        "valor": 249454950.0,
        "delta": -5060430.0
      },
      {
        "periodo": 202601,
        "valor": 245953626.0,
        "delta": -3501324.0
      },
      {
        "periodo": 202602,
        "valor": 242196334.0,
        "delta": -3757292.0
      },
      {
        "periodo": 202603,
        "valor": 242230037.0,
        "delta": 33703.0
      },
      {
        "periodo": 202604,
        "valor": 240569305.0,
        "delta": -1660732.0
      },
      {
        "periodo": 202605,
        "valor": 232820084.0,
        "delta": -7749221.0
      },
      {
        "periodo": 202606,
        "valor": 223490031.0,
        "delta": -9330053.0
      },
      {
        "periodo": 202607,
        "valor": 217397313.0,
        "delta": -6092718.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 8570617768.0,
    "valor_anterior": 8711738035.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9648803449.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9671118199.0,
        "delta": 22314750.0
      },
      {
        "periodo": 202509,
        "valor": 9813184467.0,
        "delta": 142066268.0
      },
      {
        "periodo": 202510,
        "valor": 9746440523.0,
        "delta": -66743944.0
      },
      {
        "periodo": 202511,
        "valor": 9686614044.0,
        "delta": -59826479.0
      },
      {
        "periodo": 202512,
        "valor": 9481001337.0,
        "delta": -205612707.0
      },
      {
        "periodo": 202601,
        "valor": 9356305699.0,
        "delta": -124695638.0
      },
      {
        "periodo": 202602,
        "valor": 9320637178.0,
        "delta": -35668521.0
      },
      {
        "periodo": 202603,
        "valor": 9195716341.0,
        "delta": -124920837.0
      },
      {
        "periodo": 202604,
        "valor": 9008710891.0,
        "delta": -187005450.0
      },
      {
        "periodo": 202605,
        "valor": 8939197870.0,
        "delta": -69513021.0
      },
      {
        "periodo": 202606,
        "valor": 8711738035.0,
        "delta": -227459835.0
      },
      {
        "periodo": 202607,
        "valor": 8570617768.0,
        "delta": -141120267.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 243410040.0,
    "valor_anterior": 241034859.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 238352480.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 243408068.0,
        "delta": 5055588.0
      },
      {
        "periodo": 202509,
        "valor": 242222893.0,
        "delta": -1185175.0
      },
      {
        "periodo": 202510,
        "valor": 242961095.0,
        "delta": 738202.0
      },
      {
        "periodo": 202511,
        "valor": 249207420.0,
        "delta": 6246325.0
      },
      {
        "periodo": 202512,
        "valor": 254464747.0,
        "delta": 5257327.0
      },
      {
        "periodo": 202601,
        "valor": 265391438.0,
        "delta": 10926691.0
      },
      {
        "periodo": 202602,
        "valor": 266894298.0,
        "delta": 1502860.0
      },
      {
        "periodo": 202603,
        "valor": 264379215.0,
        "delta": -2515083.0
      },
      {
        "periodo": 202604,
        "valor": 257496094.0,
        "delta": -6883121.0
      },
      {
        "periodo": 202605,
        "valor": 254701566.0,
        "delta": -2794528.0
      },
      {
        "periodo": 202606,
        "valor": 241034859.0,
        "delta": -13666707.0
      },
      {
        "periodo": 202607,
        "valor": 243410040.0,
        "delta": 2375181.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 505870539.2,
    "valor_anterior": 527634611.32,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 534572035.61,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 546314225.11,
        "delta": 11742189.5
      },
      {
        "periodo": 202509,
        "valor": 559813777.84,
        "delta": 13499552.73
      },
      {
        "periodo": 202510,
        "valor": 563598510.48,
        "delta": 3784732.64
      },
      {
        "periodo": 202511,
        "valor": 564739477.77,
        "delta": 1140967.29
      },
      {
        "periodo": 202512,
        "valor": 557872440.19,
        "delta": -6867037.58
      },
      {
        "periodo": 202601,
        "valor": 549658984.44,
        "delta": -8213455.75
      },
      {
        "periodo": 202602,
        "valor": 546665596.27,
        "delta": -2993388.17
      },
      {
        "periodo": 202603,
        "valor": 552856581.42,
        "delta": 6190985.15
      },
      {
        "periodo": 202604,
        "valor": 545342511.89,
        "delta": -7514069.53
      },
      {
        "periodo": 202605,
        "valor": 538810555.41,
        "delta": -6531956.48
      },
      {
        "periodo": 202606,
        "valor": 527634611.32,
        "delta": -11175944.09
      },
      {
        "periodo": 202607,
        "valor": 505870539.2,
        "delta": -21764072.12
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 191271746.52,
    "valor_anterior": 202958379.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 409825550.79,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 442290595.04,
        "delta": 32465044.25
      },
      {
        "periodo": 202509,
        "valor": 399401096.76,
        "delta": -42889498.28
      },
      {
        "periodo": 202510,
        "valor": 335220101.78,
        "delta": -64180994.98
      },
      {
        "periodo": 202511,
        "valor": 323393341.93,
        "delta": -11826759.85
      },
      {
        "periodo": 202512,
        "valor": 305537837.27,
        "delta": -17855504.66
      },
      {
        "periodo": 202601,
        "valor": 284243706.59,
        "delta": -21294130.68
      },
      {
        "periodo": 202602,
        "valor": 265052946.43,
        "delta": -19190760.16
      },
      {
        "periodo": 202603,
        "valor": 248788807.22,
        "delta": -16264139.21
      },
      {
        "periodo": 202604,
        "valor": 230205697.5,
        "delta": -18583109.72
      },
      {
        "periodo": 202605,
        "valor": 219581155.37,
        "delta": -10624542.13
      },
      {
        "periodo": 202606,
        "valor": 202958379.0,
        "delta": -16622776.37
      },
      {
        "periodo": 202607,
        "valor": 191271746.52,
        "delta": -11686632.48
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 126468053.0,
    "valor_anterior": 127135031.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 150525111.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 149689106.0,
        "delta": -836005.0
      },
      {
        "periodo": 202509,
        "valor": 146333740.0,
        "delta": -3355366.0
      },
      {
        "periodo": 202510,
        "valor": 141663165.0,
        "delta": -4670575.0
      },
      {
        "periodo": 202511,
        "valor": 140872595.0,
        "delta": -790570.0
      },
      {
        "periodo": 202512,
        "valor": 131070444.0,
        "delta": -9802151.0
      },
      {
        "periodo": 202601,
        "valor": 134112480.0,
        "delta": 3042036.0
      },
      {
        "periodo": 202602,
        "valor": 137046105.0,
        "delta": 2933625.0
      },
      {
        "periodo": 202603,
        "valor": 137284753.0,
        "delta": 238648.0
      },
      {
        "periodo": 202604,
        "valor": 135346394.0,
        "delta": -1938359.0
      },
      {
        "periodo": 202605,
        "valor": 130472424.0,
        "delta": -4873970.0
      },
      {
        "periodo": 202606,
        "valor": 127135031.0,
        "delta": -3337393.0
      },
      {
        "periodo": 202607,
        "valor": 126468053.0,
        "delta": -666978.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 167995916.0,
    "valor_anterior": 170032140.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 211429703.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 207631793.0,
        "delta": -3797910.0
      },
      {
        "periodo": 202509,
        "valor": 203442696.0,
        "delta": -4189097.0
      },
      {
        "periodo": 202510,
        "valor": 200235926.0,
        "delta": -3206770.0
      },
      {
        "periodo": 202511,
        "valor": 197001933.0,
        "delta": -3233993.0
      },
      {
        "periodo": 202512,
        "valor": 192029207.0,
        "delta": -4972726.0
      },
      {
        "periodo": 202601,
        "valor": 187016362.0,
        "delta": -5012845.0
      },
      {
        "periodo": 202602,
        "valor": 182371716.0,
        "delta": -4644646.0
      },
      {
        "periodo": 202603,
        "valor": 178831646.0,
        "delta": -3540070.0
      },
      {
        "periodo": 202604,
        "valor": 175232485.0,
        "delta": -3599161.0
      },
      {
        "periodo": 202605,
        "valor": 172365540.0,
        "delta": -2866945.0
      },
      {
        "periodo": 202606,
        "valor": 170032140.0,
        "delta": -2333400.0
      },
      {
        "periodo": 202607,
        "valor": 167995916.0,
        "delta": -2036224.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 443970230.0,
    "valor_anterior": 474132569.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 701823141.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 708996108.0,
        "delta": 7172967.0
      },
      {
        "periodo": 202509,
        "valor": 694506540.0,
        "delta": -14489568.0
      },
      {
        "periodo": 202510,
        "valor": 670215417.0,
        "delta": -24291123.0
      },
      {
        "periodo": 202511,
        "valor": 649944464.0,
        "delta": -20270953.0
      },
      {
        "periodo": 202512,
        "valor": 619166994.0,
        "delta": -30777470.0
      },
      {
        "periodo": 202601,
        "valor": 601202734.0,
        "delta": -17964260.0
      },
      {
        "periodo": 202602,
        "valor": 587121520.0,
        "delta": -14081214.0
      },
      {
        "periodo": 202603,
        "valor": 560258462.0,
        "delta": -26863058.0
      },
      {
        "periodo": 202604,
        "valor": 527782033.0,
        "delta": -32476429.0
      },
      {
        "periodo": 202605,
        "valor": 501563871.0,
        "delta": -26218162.0
      },
      {
        "periodo": 202606,
        "valor": 474132569.0,
        "delta": -27431302.0
      },
      {
        "periodo": 202607,
        "valor": 443970230.0,
        "delta": -30162339.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 755468.91,
    "valor_anterior": 793758.02,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1143937.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1172427.57,
        "delta": 28490.57
      },
      {
        "periodo": 202509,
        "valor": 1179029.3,
        "delta": 6601.73
      },
      {
        "periodo": 202510,
        "valor": 1176007.98,
        "delta": -3021.32
      },
      {
        "periodo": 202511,
        "valor": 1153156.38,
        "delta": -22851.6
      },
      {
        "periodo": 202512,
        "valor": 1111351.1,
        "delta": -41805.28
      },
      {
        "periodo": 202601,
        "valor": 1031179.88,
        "delta": -80171.22
      },
      {
        "periodo": 202602,
        "valor": 952587.03,
        "delta": -78592.85
      },
      {
        "periodo": 202603,
        "valor": 887158.64,
        "delta": -65428.39
      },
      {
        "periodo": 202604,
        "valor": 842388.54,
        "delta": -44770.1
      },
      {
        "periodo": 202605,
        "valor": 801268.94,
        "delta": -41119.6
      },
      {
        "periodo": 202606,
        "valor": 793758.02,
        "delta": -7510.92
      },
      {
        "periodo": 202607,
        "valor": 755468.91,
        "delta": -38289.11
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 497885186.56,
    "valor_anterior": 412553100.24,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 78293159.18,
        "delta": 78293159.18
      },
      {
        "periodo": 202603,
        "valor": 163518848.94,
        "delta": 85225689.76
      },
      {
        "periodo": 202604,
        "valor": 246584011.9,
        "delta": 83065162.96
      },
      {
        "periodo": 202605,
        "valor": 330375004.95,
        "delta": 83790993.05
      },
      {
        "periodo": 202606,
        "valor": 412553100.24,
        "delta": 82178095.29
      },
      {
        "periodo": 202607,
        "valor": 497885186.56,
        "delta": 85332086.32
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 1437356285.0,
    "valor_anterior": 1295564114.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": 291861703.0,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 318800040.0,
        "delta": 26938337.0
      },
      {
        "periodo": 202512,
        "valor": 448668354.0,
        "delta": 129868314.0
      },
      {
        "periodo": 202601,
        "valor": 596443732.0,
        "delta": 147775378.0
      },
      {
        "periodo": 202602,
        "valor": 731989387.0,
        "delta": 135545655.0
      },
      {
        "periodo": 202603,
        "valor": 878588971.0,
        "delta": 146599584.0
      },
      {
        "periodo": 202604,
        "valor": 1014299582.0,
        "delta": 135710611.0
      },
      {
        "periodo": 202605,
        "valor": 1156354450.0,
        "delta": 142054868.0
      },
      {
        "periodo": 202606,
        "valor": 1295564114.0,
        "delta": 139209664.0
      },
      {
        "periodo": 202607,
        "valor": 1437356285.0,
        "delta": 141792171.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 769511462141.97,
    "valor_anterior": 778332276272.1599,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 951812201194.09,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 939430111885.03,
        "delta": -12382089309.0599
      },
      {
        "periodo": 202509,
        "valor": 924886795030.41,
        "delta": -14543316854.62
      },
      {
        "periodo": 202510,
        "valor": 911045219217.4199,
        "delta": -13841575812.9901
      },
      {
        "periodo": 202511,
        "valor": 893923550660.1199,
        "delta": -17121668557.3
      },
      {
        "periodo": 202512,
        "valor": 875969499620.73,
        "delta": -17954051039.3899
      },
      {
        "periodo": 202601,
        "valor": 856312955917.0099,
        "delta": -19656543703.7201
      },
      {
        "periodo": 202602,
        "valor": 839357608166.5099,
        "delta": -16955347750.5
      },
      {
        "periodo": 202603,
        "valor": 826553711216.38,
        "delta": -12803896950.1299
      },
      {
        "periodo": 202604,
        "valor": 806834011721.92,
        "delta": -19719699494.46
      },
      {
        "periodo": 202605,
        "valor": 790751713628.9501,
        "delta": -16082298092.97
      },
      {
        "periodo": 202606,
        "valor": 778332276272.1599,
        "delta": -12419437356.7902
      },
      {
        "periodo": 202607,
        "valor": 769511462141.97,
        "delta": -8820814130.1899
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 553719163018.36,
    "valor_anterior": 559542853662.86,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 690996044720.37,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 679884566354.88,
        "delta": -11111478365.49
      },
      {
        "periodo": 202509,
        "valor": 670640719121.05,
        "delta": -9243847233.83
      },
      {
        "periodo": 202510,
        "valor": 658507041363.63,
        "delta": -12133677757.42
      },
      {
        "periodo": 202511,
        "valor": 643495052220.87,
        "delta": -15011989142.76
      },
      {
        "periodo": 202512,
        "valor": 629158856264.43,
        "delta": -14336195956.4399
      },
      {
        "periodo": 202601,
        "valor": 615048896545.8201,
        "delta": -14109959718.61
      },
      {
        "periodo": 202602,
        "valor": 601987951642.65,
        "delta": -13060944903.17
      },
      {
        "periodo": 202603,
        "valor": 592097836605.66,
        "delta": -9890115036.99
      },
      {
        "periodo": 202604,
        "valor": 579103996584.66,
        "delta": -12993840021.0
      },
      {
        "periodo": 202605,
        "valor": 567155863164.1,
        "delta": -11948133420.5601
      },
      {
        "periodo": 202606,
        "valor": 559542853662.86,
        "delta": -7613009501.24
      },
      {
        "periodo": 202607,
        "valor": 553719163018.36,
        "delta": -5823690644.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 18840418729.57,
    "valor_anterior": 19791679596.809998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 39503816990.08,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 39034552003.62,
        "delta": -469264986.46
      },
      {
        "periodo": 202509,
        "valor": 33159999063.99,
        "delta": -5874552939.63
      },
      {
        "periodo": 202510,
        "valor": 31883423011.98,
        "delta": -1276576052.01
      },
      {
        "periodo": 202511,
        "valor": 30303035275.47,
        "delta": -1580387736.51
      },
      {
        "periodo": 202512,
        "valor": 28635925161.39,
        "delta": -1667110114.08
      },
      {
        "periodo": 202601,
        "valor": 27215517719.38,
        "delta": -1420407442.01
      },
      {
        "periodo": 202602,
        "valor": 25956356510.23,
        "delta": -1259161209.15
      },
      {
        "periodo": 202603,
        "valor": 24423947799.99,
        "delta": -1532408710.24
      },
      {
        "periodo": 202604,
        "valor": 22874583687.59,
        "delta": -1549364112.4
      },
      {
        "periodo": 202605,
        "valor": 21278853970.45,
        "delta": -1595729717.14
      },
      {
        "periodo": 202606,
        "valor": 19791679596.81,
        "delta": -1487174373.64
      },
      {
        "periodo": 202607,
        "valor": 18840418729.57,
        "delta": -951260867.24
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 83119993406.79,
    "valor_anterior": 84903964517.53,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 98770320364.42,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 98954774502.35,
        "delta": 184454137.93
      },
      {
        "periodo": 202509,
        "valor": 100258671721.84,
        "delta": 1303897219.49
      },
      {
        "periodo": 202510,
        "valor": 100770937310.49,
        "delta": 512265588.65
      },
      {
        "periodo": 202511,
        "valor": 101504224218.5,
        "delta": 733286908.01
      },
      {
        "periodo": 202512,
        "valor": 100640613823.19,
        "delta": -863610395.31
      },
      {
        "periodo": 202601,
        "valor": 97614581473.78,
        "delta": -3026032349.41
      },
      {
        "periodo": 202602,
        "valor": 95748514692.44,
        "delta": -1866066781.34
      },
      {
        "periodo": 202603,
        "valor": 94346930589.67,
        "delta": -1401584102.77
      },
      {
        "periodo": 202604,
        "valor": 89648637063.54,
        "delta": -4698293526.13
      },
      {
        "periodo": 202605,
        "valor": 87603217421.87,
        "delta": -2045419641.67
      },
      {
        "periodo": 202606,
        "valor": 84903964517.53,
        "delta": -2699252904.34
      },
      {
        "periodo": 202607,
        "valor": 83119993406.79,
        "delta": -1783971110.74
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 66880095400.94,
    "valor_anterior": 67375273583.8,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 75945081350.43,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 75195987740.97,
        "delta": -749093609.46
      },
      {
        "periodo": 202509,
        "valor": 74662543922.36,
        "delta": -533443818.61
      },
      {
        "periodo": 202510,
        "valor": 73820187277.15,
        "delta": -842356645.21
      },
      {
        "periodo": 202511,
        "valor": 72916295587.92,
        "delta": -903891689.23
      },
      {
        "periodo": 202512,
        "valor": 71828980848.69,
        "delta": -1087314739.23
      },
      {
        "periodo": 202601,
        "valor": 70970945084.46,
        "delta": -858035764.23
      },
      {
        "periodo": 202602,
        "valor": 70215908496.1,
        "delta": -755036588.36
      },
      {
        "periodo": 202603,
        "valor": 69407074479.31,
        "delta": -808834016.79
      },
      {
        "periodo": 202604,
        "valor": 68729341300.62,
        "delta": -677733178.69
      },
      {
        "periodo": 202605,
        "valor": 68100709232.36,
        "delta": -628632068.26
      },
      {
        "periodo": 202606,
        "valor": 67375273583.8,
        "delta": -725435648.56
      },
      {
        "periodo": 202607,
        "valor": 66880095400.94,
        "delta": -495178182.86
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 19471623039.43,
    "valor_anterior": 19497165254.739998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20260367962.6,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 20250374094.93,
        "delta": -9993867.67
      },
      {
        "periodo": 202509,
        "valor": 20161391100.79,
        "delta": -88982994.14
      },
      {
        "periodo": 202510,
        "valor": 20131297918.43,
        "delta": -30093182.36
      },
      {
        "periodo": 202511,
        "valor": 20083181769.97,
        "delta": -48116148.46
      },
      {
        "periodo": 202512,
        "valor": 20065859691.31,
        "delta": -17322078.66
      },
      {
        "periodo": 202601,
        "valor": 19955540562.7,
        "delta": -110319128.61
      },
      {
        "periodo": 202602,
        "valor": 19904122312.26,
        "delta": -51418250.44
      },
      {
        "periodo": 202603,
        "valor": 19937906996.31,
        "delta": 33784684.05
      },
      {
        "periodo": 202604,
        "valor": 19739857927.37,
        "delta": -198049068.94
      },
      {
        "periodo": 202605,
        "valor": 19632646735.08,
        "delta": -107211192.29
      },
      {
        "periodo": 202606,
        "valor": 19497165254.74,
        "delta": -135481480.34
      },
      {
        "periodo": 202607,
        "valor": 19471623039.43,
        "delta": -25542215.31
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200009,
    "label": "Gastos por Intereses (Suma 12m)",
    "valor_actual": 27480168546.88,
    "valor_anterior": 27221339656.42,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26336569806.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26109857188.28,
        "delta": -226712617.91
      },
      {
        "periodo": 202509,
        "valor": 26003470100.38,
        "delta": -106387087.9
      },
      {
        "periodo": 202510,
        "valor": 25932332335.74,
        "delta": -71137764.64
      },
      {
        "periodo": 202511,
        "valor": 25621761587.39,
        "delta": -310570748.35
      },
      {
        "periodo": 202512,
        "valor": 25639263831.72,
        "delta": 17502244.33
      },
      {
        "periodo": 202601,
        "valor": 25507474530.87,
        "delta": -131789300.85
      },
      {
        "periodo": 202602,
        "valor": 25544754512.83,
        "delta": 37279981.96
      },
      {
        "periodo": 202603,
        "valor": 26340014745.44,
        "delta": 795260232.61
      },
      {
        "periodo": 202604,
        "valor": 26737595158.14,
        "delta": 397580412.7
      },
      {
        "periodo": 202605,
        "valor": 26980423105.09,
        "delta": 242827946.95
      },
      {
        "periodo": 202606,
        "valor": 27221339656.42,
        "delta": 240916551.33
      },
      {
        "periodo": 202607,
        "valor": 27480168546.88,
        "delta": 258828890.46
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 21036632693.75,
    "valor_anterior": 20593220952.71,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17035463013.7,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16086147110.38,
        "delta": -949315903.32
      },
      {
        "periodo": 202509,
        "valor": 14640871656.3,
        "delta": -1445275454.08
      },
      {
        "periodo": 202510,
        "valor": 12910777061.02,
        "delta": -1730094595.28
      },
      {
        "periodo": 202511,
        "valor": 15097839060.55,
        "delta": 2187061999.53
      },
      {
        "periodo": 202512,
        "valor": 16095616674.47,
        "delta": 997777613.92
      },
      {
        "periodo": 202601,
        "valor": 16960218262.63,
        "delta": 864601588.16
      },
      {
        "periodo": 202602,
        "valor": 17645749814.64,
        "delta": 685531552.01
      },
      {
        "periodo": 202603,
        "valor": 20563021892.18,
        "delta": 2917272077.54
      },
      {
        "periodo": 202604,
        "valor": 20176678884.97,
        "delta": -386343007.21
      },
      {
        "periodo": 202605,
        "valor": 20136154593.67,
        "delta": -40524291.3
      },
      {
        "periodo": 202606,
        "valor": 20593220952.71,
        "delta": 457066359.04
      },
      {
        "periodo": 202607,
        "valor": 21036632693.75,
        "delta": 443411741.04
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 98735898957.54001,
    "valor_anterior": 97729277809.63,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 96309170474.62,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 97735492991.34,
        "delta": 1426322516.72
      },
      {
        "periodo": 202509,
        "valor": 96839694863.69,
        "delta": -895798127.65
      },
      {
        "periodo": 202510,
        "valor": 98312269159.63,
        "delta": 1472574295.94
      },
      {
        "periodo": 202511,
        "valor": 99083437768.94,
        "delta": 771168609.31
      },
      {
        "periodo": 202512,
        "valor": 98945785354.08,
        "delta": -137652414.86
      },
      {
        "periodo": 202601,
        "valor": 98986654851.1,
        "delta": 40869497.02
      },
      {
        "periodo": 202602,
        "valor": 96324460285.87,
        "delta": -2662194565.23
      },
      {
        "periodo": 202603,
        "valor": 97783378116.51,
        "delta": 1458917830.64
      },
      {
        "periodo": 202604,
        "valor": 98169019884.62,
        "delta": 385641768.11
      },
      {
        "periodo": 202605,
        "valor": 97550077681.78,
        "delta": -618942202.84
      },
      {
        "periodo": 202606,
        "valor": 97729277809.63,
        "delta": 179200127.85
      },
      {
        "periodo": 202607,
        "valor": 98735898957.54,
        "delta": 1006621147.91
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 35162873536.0,
    "valor_anterior": 35106697379.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 29716174892.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 30096820620.0,
        "delta": 380645728.0
      },
      {
        "periodo": 202509,
        "valor": 30113412552.0,
        "delta": 16591932.0
      },
      {
        "periodo": 202510,
        "valor": 30957945975.0,
        "delta": 844533423.0
      },
      {
        "periodo": 202511,
        "valor": 30995144835.0,
        "delta": 37198860.0
      },
      {
        "periodo": 202512,
        "valor": 32328949233.0,
        "delta": 1333804398.0
      },
      {
        "periodo": 202601,
        "valor": 32913471528.0,
        "delta": 584522295.0
      },
      {
        "periodo": 202602,
        "valor": 33235370244.0,
        "delta": 321898716.0
      },
      {
        "periodo": 202603,
        "valor": 34959785277.0,
        "delta": 1724415033.0
      },
      {
        "periodo": 202604,
        "valor": 35704929424.0,
        "delta": 745144147.0
      },
      {
        "periodo": 202605,
        "valor": 34523112637.0,
        "delta": -1181816787.0
      },
      {
        "periodo": 202606,
        "valor": 35106697379.0,
        "delta": 583584742.0
      },
      {
        "periodo": 202607,
        "valor": 35162873536.0,
        "delta": 56176157.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 6157291160.999999,
    "valor_anterior": 6534907278.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6482617613.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6790552304.0,
        "delta": 307934691.0
      },
      {
        "periodo": 202509,
        "valor": 6781850662.0,
        "delta": -8701642.0
      },
      {
        "periodo": 202510,
        "valor": 6651219076.0,
        "delta": -130631586.0
      },
      {
        "periodo": 202511,
        "valor": 8282045913.0,
        "delta": 1630826837.0
      },
      {
        "periodo": 202512,
        "valor": 7311582964.0,
        "delta": -970462949.0
      },
      {
        "periodo": 202601,
        "valor": 7730995829.0,
        "delta": 419412865.0
      },
      {
        "periodo": 202602,
        "valor": 7769446892.0,
        "delta": 38451063.0
      },
      {
        "periodo": 202603,
        "valor": 8677621990.0,
        "delta": 908175098.0
      },
      {
        "periodo": 202604,
        "valor": 8218871924.0,
        "delta": -458750066.0
      },
      {
        "periodo": 202605,
        "valor": 7757830239.0,
        "delta": -461041685.0
      },
      {
        "periodo": 202606,
        "valor": 6534907278.0,
        "delta": -1222922961.0
      },
      {
        "periodo": 202607,
        "valor": 6157291161.0,
        "delta": -377616117.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 8500454661.51,
    "valor_anterior": 8582954825.38,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9556865783.92,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9522600344.22,
        "delta": -34265439.7
      },
      {
        "periodo": 202509,
        "valor": 9462813834.54,
        "delta": -59786509.68
      },
      {
        "periodo": 202510,
        "valor": 9404449349.75,
        "delta": -58364484.79
      },
      {
        "periodo": 202511,
        "valor": 9315916116.94,
        "delta": -88533232.81
      },
      {
        "periodo": 202512,
        "valor": 9079338569.93,
        "delta": -236577547.01
      },
      {
        "periodo": 202601,
        "valor": 8967881885.58,
        "delta": -111456684.35
      },
      {
        "periodo": 202602,
        "valor": 8767910075.29,
        "delta": -199971810.29
      },
      {
        "periodo": 202603,
        "valor": 8629785349.24,
        "delta": -138124726.05
      },
      {
        "periodo": 202604,
        "valor": 8615325167.01,
        "delta": -14460182.23
      },
      {
        "periodo": 202605,
        "valor": 8541127115.35,
        "delta": -74198051.66
      },
      {
        "periodo": 202606,
        "valor": 8582954825.38,
        "delta": 41827710.03
      },
      {
        "periodo": 202607,
        "valor": 8500454661.51,
        "delta": -82500163.87
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 18877698348.000004,
    "valor_anterior": 19871005504.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 24396845150.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24063448333.0,
        "delta": -333396817.0
      },
      {
        "periodo": 202509,
        "valor": 23092888055.0,
        "delta": -970560278.0
      },
      {
        "periodo": 202510,
        "valor": 23086004959.0,
        "delta": -6883096.0
      },
      {
        "periodo": 202511,
        "valor": 22976572657.0,
        "delta": -109432302.0
      },
      {
        "periodo": 202512,
        "valor": 22527724170.0,
        "delta": -448848487.0
      },
      {
        "periodo": 202601,
        "valor": 22800480443.0,
        "delta": 272756273.0
      },
      {
        "periodo": 202602,
        "valor": 22215510864.0,
        "delta": -584969579.0
      },
      {
        "periodo": 202603,
        "valor": 21830921224.0,
        "delta": -384589640.0
      },
      {
        "periodo": 202604,
        "valor": 21608056886.0,
        "delta": -222864338.0
      },
      {
        "periodo": 202605,
        "valor": 20718252785.0,
        "delta": -889804101.0
      },
      {
        "periodo": 202606,
        "valor": 19871005504.0,
        "delta": -847247281.0
      },
      {
        "periodo": 202607,
        "valor": 18877698348.0,
        "delta": -993307156.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 3623887263.0,
    "valor_anterior": 3600716247.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3253235451.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3295662044.0,
        "delta": 42426593.0
      },
      {
        "periodo": 202509,
        "valor": 3343848190.0,
        "delta": 48186146.0
      },
      {
        "periodo": 202510,
        "valor": 3397139297.0,
        "delta": 53291107.0
      },
      {
        "periodo": 202511,
        "valor": 3454941202.0,
        "delta": 57801905.0
      },
      {
        "periodo": 202512,
        "valor": 3440032891.0,
        "delta": -14908311.0
      },
      {
        "periodo": 202601,
        "valor": 3511005547.0,
        "delta": 70972656.0
      },
      {
        "periodo": 202602,
        "valor": 3539567548.0,
        "delta": 28562001.0
      },
      {
        "periodo": 202603,
        "valor": 3569043495.0,
        "delta": 29475947.0
      },
      {
        "periodo": 202604,
        "valor": 3586039688.0,
        "delta": 16996193.0
      },
      {
        "periodo": 202605,
        "valor": 3584880045.0,
        "delta": -1159643.0
      },
      {
        "periodo": 202606,
        "valor": 3600716247.0,
        "delta": 15836202.0
      },
      {
        "periodo": 202607,
        "valor": 3623887263.0,
        "delta": 23171016.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 12322098741.0,
    "valor_anterior": 12040620465.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10549173035.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10409048568.0,
        "delta": -140124467.0
      },
      {
        "periodo": 202509,
        "valor": 10496312940.0,
        "delta": 87264372.0
      },
      {
        "periodo": 202510,
        "valor": 10224215794.0,
        "delta": -272097146.0
      },
      {
        "periodo": 202511,
        "valor": 10015667549.0,
        "delta": -208548245.0
      },
      {
        "periodo": 202512,
        "valor": 10240732574.0,
        "delta": 225065025.0
      },
      {
        "periodo": 202601,
        "valor": 10586777080.0,
        "delta": 346044506.0
      },
      {
        "periodo": 202602,
        "valor": 10878103064.0,
        "delta": 291325984.0
      },
      {
        "periodo": 202603,
        "valor": 12126864942.0,
        "delta": 1248761878.0
      },
      {
        "periodo": 202604,
        "valor": 11886040388.0,
        "delta": -240824554.0
      },
      {
        "periodo": 202605,
        "valor": 11782950565.0,
        "delta": -103089823.0
      },
      {
        "periodo": 202606,
        "valor": 12040620465.0,
        "delta": 257669900.0
      },
      {
        "periodo": 202607,
        "valor": 12322098741.0,
        "delta": 281478276.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 6240664356.55,
    "valor_anterior": 6204208150.43,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6653649513.31,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6667137991.66,
        "delta": 13488478.35
      },
      {
        "periodo": 202509,
        "valor": 6653009525.34,
        "delta": -14128466.32
      },
      {
        "periodo": 202510,
        "valor": 6692571104.93,
        "delta": 39561579.59
      },
      {
        "periodo": 202511,
        "valor": 6592396593.2,
        "delta": -100174511.73
      },
      {
        "periodo": 202512,
        "valor": 6548663045.67,
        "delta": -43733547.53
      },
      {
        "periodo": 202601,
        "valor": 6489820151.65,
        "delta": -58842894.02
      },
      {
        "periodo": 202602,
        "valor": 6421848102.6,
        "delta": -67972049.05
      },
      {
        "periodo": 202603,
        "valor": 6380017283.56,
        "delta": -41830819.04
      },
      {
        "periodo": 202604,
        "valor": 6362114305.62,
        "delta": -17902977.94
      },
      {
        "periodo": 202605,
        "valor": 6330741283.84,
        "delta": -31373021.78
      },
      {
        "periodo": 202606,
        "valor": 6204208150.43,
        "delta": -126533133.41
      },
      {
        "periodo": 202607,
        "valor": 6240664356.55,
        "delta": 36456206.12
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 1438968117.0,
    "valor_anterior": 1391996906.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1685034831.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1614771967.0,
        "delta": -70262864.0
      },
      {
        "periodo": 202509,
        "valor": 1709292107.0,
        "delta": 94520140.0
      },
      {
        "periodo": 202510,
        "valor": 1708893675.0,
        "delta": -398432.0
      },
      {
        "periodo": 202511,
        "valor": 1637452600.0,
        "delta": -71441075.0
      },
      {
        "periodo": 202512,
        "valor": 1560742222.0,
        "delta": -76710378.0
      },
      {
        "periodo": 202601,
        "valor": 1375477105.0,
        "delta": -185265117.0
      },
      {
        "periodo": 202602,
        "valor": 1310703571.0,
        "delta": -64773534.0
      },
      {
        "periodo": 202603,
        "valor": 1271456945.0,
        "delta": -39246626.0
      },
      {
        "periodo": 202604,
        "valor": 1351529158.0,
        "delta": 80072213.0
      },
      {
        "periodo": 202605,
        "valor": 1354446699.0,
        "delta": 2917541.0
      },
      {
        "periodo": 202606,
        "valor": 1391996906.0,
        "delta": 37550207.0
      },
      {
        "periodo": 202607,
        "valor": 1438968117.0,
        "delta": 46971211.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 1331348018.0,
    "valor_anterior": 1335313447.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1154575574.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1193658421.0,
        "delta": 39082847.0
      },
      {
        "periodo": 202509,
        "valor": 1222716320.0,
        "delta": 29057899.0
      },
      {
        "periodo": 202510,
        "valor": 1220288108.0,
        "delta": -2428212.0
      },
      {
        "periodo": 202511,
        "valor": 1249501847.0,
        "delta": 29213739.0
      },
      {
        "periodo": 202512,
        "valor": 1337586078.0,
        "delta": 88084231.0
      },
      {
        "periodo": 202601,
        "valor": 1335232517.0,
        "delta": -2353561.0
      },
      {
        "periodo": 202602,
        "valor": 1335589785.0,
        "delta": 357268.0
      },
      {
        "periodo": 202603,
        "valor": 1338399675.0,
        "delta": 2809890.0
      },
      {
        "periodo": 202604,
        "valor": 1336233105.0,
        "delta": -2166570.0
      },
      {
        "periodo": 202605,
        "valor": 1330184525.0,
        "delta": -6048580.0
      },
      {
        "periodo": 202606,
        "valor": 1335313447.0,
        "delta": 5128922.0
      },
      {
        "periodo": 202607,
        "valor": 1331348018.0,
        "delta": -3965429.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 631926374.0,
    "valor_anterior": 663031240.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 746979928.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 802845914.0,
        "delta": 55865986.0
      },
      {
        "periodo": 202509,
        "valor": 851899699.0,
        "delta": 49053785.0
      },
      {
        "periodo": 202510,
        "valor": 903345230.0,
        "delta": 51445531.0
      },
      {
        "periodo": 202511,
        "valor": 970766111.0,
        "delta": 67420881.0
      },
      {
        "periodo": 202512,
        "valor": 512851066.0,
        "delta": -457915045.0
      },
      {
        "periodo": 202601,
        "valor": 539948819.0,
        "delta": 27097753.0
      },
      {
        "periodo": 202602,
        "valor": 546482213.0,
        "delta": 6533394.0
      },
      {
        "periodo": 202603,
        "valor": 588303024.0,
        "delta": 41820811.0
      },
      {
        "periodo": 202604,
        "valor": 627513006.0,
        "delta": 39209982.0
      },
      {
        "periodo": 202605,
        "valor": 619655215.0,
        "delta": -7857791.0
      },
      {
        "periodo": 202606,
        "valor": 663031240.0,
        "delta": 43376025.0
      },
      {
        "periodo": 202607,
        "valor": 631926374.0,
        "delta": -31104866.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 49050800698.759995,
    "valor_anterior": 48994302782.46,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 46165057860.36,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 46199345691.56,
        "delta": 34287831.2
      },
      {
        "periodo": 202509,
        "valor": 45551233104.33,
        "delta": -648112587.23
      },
      {
        "periodo": 202510,
        "valor": 45664126795.17,
        "delta": 112893690.84
      },
      {
        "periodo": 202511,
        "valor": 45842616898.62,
        "delta": 178490103.45
      },
      {
        "periodo": 202512,
        "valor": 47380078394.57,
        "delta": 1537461495.95
      },
      {
        "periodo": 202601,
        "valor": 47354254030.46,
        "delta": -25824364.11
      },
      {
        "periodo": 202602,
        "valor": 47595187508.4,
        "delta": 240933477.94
      },
      {
        "periodo": 202603,
        "valor": 48380337409.44,
        "delta": 785149901.04
      },
      {
        "periodo": 202604,
        "valor": 48858125439.94,
        "delta": 477788030.5
      },
      {
        "periodo": 202605,
        "valor": 48662056242.83,
        "delta": -196069197.11
      },
      {
        "periodo": 202606,
        "valor": 48994302782.46,
        "delta": 332246539.63
      },
      {
        "periodo": 202607,
        "valor": 49050800698.76,
        "delta": 56497916.3
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 1889844392.0,
    "valor_anterior": 1853591689.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2127416946.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2146728583.0,
        "delta": 19311637.0
      },
      {
        "periodo": 202509,
        "valor": 1828403343.0,
        "delta": -318325240.0
      },
      {
        "periodo": 202510,
        "valor": 2144402166.0,
        "delta": 315998823.0
      },
      {
        "periodo": 202511,
        "valor": 1986371046.0,
        "delta": -158031120.0
      },
      {
        "periodo": 202512,
        "valor": 1756628146.0,
        "delta": -229742900.0
      },
      {
        "periodo": 202601,
        "valor": 1874328481.0,
        "delta": 117700335.0
      },
      {
        "periodo": 202602,
        "valor": 1797502721.0,
        "delta": -76825760.0
      },
      {
        "periodo": 202603,
        "valor": 1810470566.0,
        "delta": 12967845.0
      },
      {
        "periodo": 202604,
        "valor": 2064221225.0,
        "delta": 253750659.0
      },
      {
        "periodo": 202605,
        "valor": 1939767581.0,
        "delta": -124453644.0
      },
      {
        "periodo": 202606,
        "valor": 1853591689.0,
        "delta": -86175892.0
      },
      {
        "periodo": 202607,
        "valor": 1889844392.0,
        "delta": 36252703.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 781420180.0,
    "valor_anterior": 806570407.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1183912301.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1210530949.0,
        "delta": 26618648.0
      },
      {
        "periodo": 202509,
        "valor": 1215454517.0,
        "delta": 4923568.0
      },
      {
        "periodo": 202510,
        "valor": 1210383043.0,
        "delta": -5071474.0
      },
      {
        "periodo": 202511,
        "valor": 1187411614.0,
        "delta": -22971429.0
      },
      {
        "periodo": 202512,
        "valor": 1237393389.0,
        "delta": 49981775.0
      },
      {
        "periodo": 202601,
        "valor": 1135024511.0,
        "delta": -102368878.0
      },
      {
        "periodo": 202602,
        "valor": 1056426927.0,
        "delta": -78597584.0
      },
      {
        "periodo": 202603,
        "valor": 967618551.0,
        "delta": -88808376.0
      },
      {
        "periodo": 202604,
        "valor": 967153550.0,
        "delta": -465001.0
      },
      {
        "periodo": 202605,
        "valor": 922220962.0,
        "delta": -44932588.0
      },
      {
        "periodo": 202606,
        "valor": 806570407.0,
        "delta": -115650555.0
      },
      {
        "periodo": 202607,
        "valor": 781420180.0,
        "delta": -25150227.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 4218378490.0,
    "valor_anterior": 4267827631.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4445040455.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4696143123.0,
        "delta": 251102668.0
      },
      {
        "periodo": 202509,
        "valor": 4933263276.0,
        "delta": 237120153.0
      },
      {
        "periodo": 202510,
        "valor": 4858295416.0,
        "delta": -74967860.0
      },
      {
        "periodo": 202511,
        "valor": 4940125447.0,
        "delta": 81830031.0
      },
      {
        "periodo": 202512,
        "valor": 4665085442.0,
        "delta": -275040005.0
      },
      {
        "periodo": 202601,
        "valor": 4391286078.0,
        "delta": -273799364.0
      },
      {
        "periodo": 202602,
        "valor": 4419883403.0,
        "delta": 28597325.0
      },
      {
        "periodo": 202603,
        "valor": 4565509832.0,
        "delta": 145626429.0
      },
      {
        "periodo": 202604,
        "valor": 4475798453.0,
        "delta": -89711379.0
      },
      {
        "periodo": 202605,
        "valor": 4382259485.0,
        "delta": -93538968.0
      },
      {
        "periodo": 202606,
        "valor": 4267827631.0,
        "delta": -114431854.0
      },
      {
        "periodo": 202607,
        "valor": 4218378490.0,
        "delta": -49449141.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 3678054283.17,
    "valor_anterior": 3602193808.01,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3693249986.96,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3696460580.89,
        "delta": 3210593.93
      },
      {
        "periodo": 202509,
        "valor": 3712699397.62,
        "delta": 16238816.73
      },
      {
        "periodo": 202510,
        "valor": 3649681256.38,
        "delta": -63018141.24
      },
      {
        "periodo": 202511,
        "valor": 3620700353.08,
        "delta": -28980903.3
      },
      {
        "periodo": 202512,
        "valor": 3722995042.91,
        "delta": 102294689.83
      },
      {
        "periodo": 202601,
        "valor": 3800305689.38,
        "delta": 77310646.47
      },
      {
        "periodo": 202602,
        "valor": 3864407030.88,
        "delta": 64101341.5
      },
      {
        "periodo": 202603,
        "valor": 3557648506.22,
        "delta": -306758524.66
      },
      {
        "periodo": 202604,
        "valor": 3533283777.24,
        "delta": -24364728.98
      },
      {
        "periodo": 202605,
        "valor": 3477138206.65,
        "delta": -56145570.59
      },
      {
        "periodo": 202606,
        "valor": 3602193808.01,
        "delta": 125055601.36
      },
      {
        "periodo": 202607,
        "valor": 3678054283.17,
        "delta": 75860475.16
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 1135526502.0,
    "valor_anterior": 1141964567.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1465883678.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1438419381.0,
        "delta": -27464297.0
      },
      {
        "periodo": 202509,
        "valor": 1397435390.0,
        "delta": -40983991.0
      },
      {
        "periodo": 202510,
        "valor": 1362930884.0,
        "delta": -34504506.0
      },
      {
        "periodo": 202511,
        "valor": 1348528014.0,
        "delta": -14402870.0
      },
      {
        "periodo": 202512,
        "valor": 1291216428.0,
        "delta": -57311586.0
      },
      {
        "periodo": 202601,
        "valor": 1266251926.0,
        "delta": -24964502.0
      },
      {
        "periodo": 202602,
        "valor": 1136705939.0,
        "delta": -129545987.0
      },
      {
        "periodo": 202603,
        "valor": 1152350607.0,
        "delta": 15644668.0
      },
      {
        "periodo": 202604,
        "valor": 1168494604.0,
        "delta": 16143997.0
      },
      {
        "periodo": 202605,
        "valor": 1125158140.0,
        "delta": -43336464.0
      },
      {
        "periodo": 202606,
        "valor": 1141964567.0,
        "delta": 16806427.0
      },
      {
        "periodo": 202607,
        "valor": 1135526502.0,
        "delta": -6438065.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 10038865269.449999,
    "valor_anterior": 10362944000.79,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5002130626.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6121860477.53,
        "delta": 1119729850.6
      },
      {
        "periodo": 202509,
        "valor": 6838203378.18,
        "delta": 716342900.65
      },
      {
        "periodo": 202510,
        "valor": 7683024741.86,
        "delta": 844821363.68
      },
      {
        "periodo": 202511,
        "valor": 8120949908.08,
        "delta": 437925166.22
      },
      {
        "periodo": 202512,
        "valor": 11313943634.27,
        "delta": 3192993726.19
      },
      {
        "periodo": 202601,
        "valor": 10589108598.91,
        "delta": -724835035.36
      },
      {
        "periodo": 202602,
        "valor": 11043717740.96,
        "delta": 454609142.05
      },
      {
        "periodo": 202603,
        "valor": 9848143173.48,
        "delta": -1195574567.48
      },
      {
        "periodo": 202604,
        "valor": 10057087632.52,
        "delta": 208944459.04
      },
      {
        "periodo": 202605,
        "valor": 10714277355.77,
        "delta": 657189723.25
      },
      {
        "periodo": 202606,
        "valor": 10362944000.79,
        "delta": -351333354.98
      },
      {
        "periodo": 202607,
        "valor": 10038865269.45,
        "delta": -324078731.34
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": -54420015.0,
    "valor_anterior": -65556532.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -115055199.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -124377668.0,
        "delta": -9322469.0
      },
      {
        "periodo": 202509,
        "valor": -113400773.0,
        "delta": 10976895.0
      },
      {
        "periodo": 202510,
        "valor": -61492907.0,
        "delta": 51907866.0
      },
      {
        "periodo": 202511,
        "valor": -88018533.0,
        "delta": -26525626.0
      },
      {
        "periodo": 202512,
        "valor": -137440252.0,
        "delta": -49421719.0
      },
      {
        "periodo": 202601,
        "valor": -113800426.0,
        "delta": 23639826.0
      },
      {
        "periodo": 202602,
        "valor": -99069031.0,
        "delta": 14731395.0
      },
      {
        "periodo": 202603,
        "valor": -92364091.0,
        "delta": 6704940.0
      },
      {
        "periodo": 202604,
        "valor": -70716747.0,
        "delta": 21647344.0
      },
      {
        "periodo": 202605,
        "valor": -82871837.0,
        "delta": -12155090.0
      },
      {
        "periodo": 202606,
        "valor": -65556532.0,
        "delta": 17315305.0
      },
      {
        "periodo": 202607,
        "valor": -54420015.0,
        "delta": 11136517.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 3569924687.51,
    "valor_anterior": 4240088102.67,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5875648656.17,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5941925787.39,
        "delta": 66277131.22
      },
      {
        "periodo": 202509,
        "valor": 5948700435.82,
        "delta": 6774648.43
      },
      {
        "periodo": 202510,
        "valor": 6303018870.02,
        "delta": 354318434.2
      },
      {
        "periodo": 202511,
        "valor": 6350630139.73,
        "delta": 47611269.71
      },
      {
        "periodo": 202512,
        "valor": 6855098413.95,
        "delta": 504468274.22
      },
      {
        "periodo": 202601,
        "valor": 6870212443.36,
        "delta": 15114029.41
      },
      {
        "periodo": 202602,
        "valor": 6884202956.81,
        "delta": 13990513.45
      },
      {
        "periodo": 202603,
        "valor": 6862621618.2,
        "delta": -21581338.61
      },
      {
        "periodo": 202604,
        "valor": 6667189240.62,
        "delta": -195432377.58
      },
      {
        "periodo": 202605,
        "valor": 5497413997.96,
        "delta": -1169775242.66
      },
      {
        "periodo": 202606,
        "valor": 4240088102.67,
        "delta": -1257325895.29
      },
      {
        "periodo": 202607,
        "valor": 3569924687.51,
        "delta": -670163415.16
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 1673271799.98,
    "valor_anterior": 1482546926.97,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 131504589.63,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 195060666.4,
        "delta": 63556076.77
      },
      {
        "periodo": 202509,
        "valor": 491957436.81,
        "delta": 296896770.41
      },
      {
        "periodo": 202510,
        "valor": 584324849.23,
        "delta": 92367412.42
      },
      {
        "periodo": 202511,
        "valor": 556085492.5,
        "delta": -28239356.73
      },
      {
        "periodo": 202512,
        "valor": 770700005.0,
        "delta": 214614512.5
      },
      {
        "periodo": 202601,
        "valor": 908844900.32,
        "delta": 138144895.32
      },
      {
        "periodo": 202602,
        "valor": 1011868858.37,
        "delta": 103023958.05
      },
      {
        "periodo": 202603,
        "valor": 1229368554.23,
        "delta": 217499695.86
      },
      {
        "periodo": 202604,
        "valor": 1325031193.86,
        "delta": 95662639.63
      },
      {
        "periodo": 202605,
        "valor": 1412452619.49,
        "delta": 87421425.63
      },
      {
        "periodo": 202606,
        "valor": 1482546926.97,
        "delta": 70094307.48
      },
      {
        "periodo": 202607,
        "valor": 1673271799.98,
        "delta": 190724873.01
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 414013672.0,
    "valor_anterior": 658127749.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 981253845.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 803895564.0,
        "delta": -177358281.0
      },
      {
        "periodo": 202509,
        "valor": 814931189.0,
        "delta": 11035625.0
      },
      {
        "periodo": 202510,
        "valor": 872738039.0,
        "delta": 57806850.0
      },
      {
        "periodo": 202511,
        "valor": 823105088.0,
        "delta": -49632951.0
      },
      {
        "periodo": 202512,
        "valor": 789404795.0,
        "delta": -33700293.0
      },
      {
        "periodo": 202601,
        "valor": 851912252.0,
        "delta": 62507457.0
      },
      {
        "periodo": 202602,
        "valor": 882654461.0,
        "delta": 30742209.0
      },
      {
        "periodo": 202603,
        "valor": 819686781.0,
        "delta": -62967680.0
      },
      {
        "periodo": 202604,
        "valor": 686060578.0,
        "delta": -133626203.0
      },
      {
        "periodo": 202605,
        "valor": 741487897.0,
        "delta": 55427319.0
      },
      {
        "periodo": 202606,
        "valor": 658127749.0,
        "delta": -83360148.0
      },
      {
        "periodo": 202607,
        "valor": 414013672.0,
        "delta": -244114077.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 5999478694.0,
    "valor_anterior": 5983873046.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5457878881.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5456746002.0,
        "delta": -1132879.0
      },
      {
        "periodo": 202509,
        "valor": 5548208099.0,
        "delta": 91462097.0
      },
      {
        "periodo": 202510,
        "valor": 5608965852.0,
        "delta": 60757753.0
      },
      {
        "periodo": 202511,
        "valor": 5603510426.0,
        "delta": -5455426.0
      },
      {
        "periodo": 202512,
        "valor": 5738996699.0,
        "delta": 135486273.0
      },
      {
        "periodo": 202601,
        "valor": 5854074548.0,
        "delta": 115077849.0
      },
      {
        "periodo": 202602,
        "valor": 5888887583.0,
        "delta": 34813035.0
      },
      {
        "periodo": 202603,
        "valor": 5849659408.0,
        "delta": -39228175.0
      },
      {
        "periodo": 202604,
        "valor": 5758183970.0,
        "delta": -91475438.0
      },
      {
        "periodo": 202605,
        "valor": 5827588189.0,
        "delta": 69404219.0
      },
      {
        "periodo": 202606,
        "valor": 5983873046.0,
        "delta": 156284857.0
      },
      {
        "periodo": 202607,
        "valor": 5999478694.0,
        "delta": 15605648.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 1727055151.0,
    "valor_anterior": 1632527698.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1210625603.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1194309268.0,
        "delta": -16316335.0
      },
      {
        "periodo": 202509,
        "valor": 1218663187.0,
        "delta": 24353919.0
      },
      {
        "periodo": 202510,
        "valor": 1352143726.0,
        "delta": 133480539.0
      },
      {
        "periodo": 202511,
        "valor": 1417081013.0,
        "delta": 64937287.0
      },
      {
        "periodo": 202512,
        "valor": 1403047730.0,
        "delta": -14033283.0
      },
      {
        "periodo": 202601,
        "valor": 1406552039.0,
        "delta": 3504309.0
      },
      {
        "periodo": 202602,
        "valor": 1382683354.0,
        "delta": -23868685.0
      },
      {
        "periodo": 202603,
        "valor": 1398772430.0,
        "delta": 16089076.0
      },
      {
        "periodo": 202604,
        "valor": 1445980824.0,
        "delta": 47208394.0
      },
      {
        "periodo": 202605,
        "valor": 1506638389.0,
        "delta": 60657565.0
      },
      {
        "periodo": 202606,
        "valor": 1632527698.0,
        "delta": 125889309.0
      },
      {
        "periodo": 202607,
        "valor": 1727055151.0,
        "delta": 94527453.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 324053572.0,
    "valor_anterior": 339730823.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 624523052.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 614278730.0,
        "delta": -10244322.0
      },
      {
        "periodo": 202509,
        "valor": 628269911.0,
        "delta": 13991181.0
      },
      {
        "periodo": 202510,
        "valor": 623736584.0,
        "delta": -4533327.0
      },
      {
        "periodo": 202511,
        "valor": 573444586.0,
        "delta": -50291998.0
      },
      {
        "periodo": 202512,
        "valor": 543331276.0,
        "delta": -30113310.0
      },
      {
        "periodo": 202601,
        "valor": 595846585.0,
        "delta": 52515309.0
      },
      {
        "periodo": 202602,
        "valor": 470151108.0,
        "delta": -125695477.0
      },
      {
        "periodo": 202603,
        "valor": 456434464.0,
        "delta": -13716644.0
      },
      {
        "periodo": 202604,
        "valor": 435750276.0,
        "delta": -20684188.0
      },
      {
        "periodo": 202605,
        "valor": 509253322.0,
        "delta": 73503046.0
      },
      {
        "periodo": 202606,
        "valor": 339730823.0,
        "delta": -169522499.0
      },
      {
        "periodo": 202607,
        "valor": 324053572.0,
        "delta": -15677251.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": -1065564322.0,
    "valor_anterior": -1148190404.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2488777900.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2079862054.0,
        "delta": -408915846.0
      },
      {
        "periodo": 202509,
        "valor": 1706533798.0,
        "delta": -373328256.0
      },
      {
        "periodo": 202510,
        "valor": 1349697067.0,
        "delta": -356836731.0
      },
      {
        "periodo": 202511,
        "valor": 1143513289.0,
        "delta": -206183778.0
      },
      {
        "periodo": 202512,
        "valor": 594422495.0,
        "delta": -549090794.0
      },
      {
        "periodo": 202601,
        "valor": 385778349.0,
        "delta": -208644146.0
      },
      {
        "periodo": 202602,
        "valor": 220934904.0,
        "delta": -164843445.0
      },
      {
        "periodo": 202603,
        "valor": -52809879.0,
        "delta": -273744783.0
      },
      {
        "periodo": 202604,
        "valor": -299262244.0,
        "delta": -246452365.0
      },
      {
        "periodo": 202605,
        "valor": -547123879.0,
        "delta": -247861635.0
      },
      {
        "periodo": 202606,
        "valor": -1148190404.0,
        "delta": -601066525.0
      },
      {
        "periodo": 202607,
        "valor": -1065564322.0,
        "delta": 82626082.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 2287910296.61,
    "valor_anterior": 2266465420.73,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3640739106.97,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3411673322.32,
        "delta": -229065784.65
      },
      {
        "periodo": 202509,
        "valor": 3129395690.96,
        "delta": -282277631.36
      },
      {
        "periodo": 202510,
        "valor": 3238063493.12,
        "delta": 108667802.16
      },
      {
        "periodo": 202511,
        "valor": 3260608823.65,
        "delta": 22545330.53
      },
      {
        "periodo": 202512,
        "valor": 3244898615.54,
        "delta": -15710208.11
      },
      {
        "periodo": 202601,
        "valor": 2792562029.43,
        "delta": -452336586.11
      },
      {
        "periodo": 202602,
        "valor": 2786508282.72,
        "delta": -6053746.71
      },
      {
        "periodo": 202603,
        "valor": 2312351893.2,
        "delta": -474156389.52
      },
      {
        "periodo": 202604,
        "valor": 2257292549.92,
        "delta": -55059343.28
      },
      {
        "periodo": 202605,
        "valor": 2056379098.82,
        "delta": -200913451.1
      },
      {
        "periodo": 202606,
        "valor": 2266465420.73,
        "delta": 210086321.91
      },
      {
        "periodo": 202607,
        "valor": 2287910296.61,
        "delta": 21444875.88
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": -1181069564.0,
    "valor_anterior": -1236764775.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1253575628.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1260884251.0,
        "delta": -7308623.0
      },
      {
        "periodo": 202509,
        "valor": -1242713303.0,
        "delta": 18170948.0
      },
      {
        "periodo": 202510,
        "valor": -1256705919.0,
        "delta": -13992616.0
      },
      {
        "periodo": 202511,
        "valor": -1278350421.0,
        "delta": -21644502.0
      },
      {
        "periodo": 202512,
        "valor": -1276747469.0,
        "delta": 1602952.0
      },
      {
        "periodo": 202601,
        "valor": -1283284361.0,
        "delta": -6536892.0
      },
      {
        "periodo": 202602,
        "valor": -1316567945.0,
        "delta": -33283584.0
      },
      {
        "periodo": 202603,
        "valor": -1317581905.0,
        "delta": -1013960.0
      },
      {
        "periodo": 202604,
        "valor": -1307905228.0,
        "delta": 9676677.0
      },
      {
        "periodo": 202605,
        "valor": -1268491245.0,
        "delta": 39413983.0
      },
      {
        "periodo": 202606,
        "valor": -1236764775.0,
        "delta": 31726470.0
      },
      {
        "periodo": 202607,
        "valor": -1181069564.0,
        "delta": 55695211.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 71992399.0,
    "valor_anterior": 71876034.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 139365146.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 140441672.0,
        "delta": 1076526.0
      },
      {
        "periodo": 202509,
        "valor": 148820745.0,
        "delta": 8379073.0
      },
      {
        "periodo": 202510,
        "valor": 148269705.0,
        "delta": -551040.0
      },
      {
        "periodo": 202511,
        "valor": 123740795.0,
        "delta": -24528910.0
      },
      {
        "periodo": 202512,
        "valor": 99171549.0,
        "delta": -24569246.0
      },
      {
        "periodo": 202601,
        "valor": 99599841.0,
        "delta": 428292.0
      },
      {
        "periodo": 202602,
        "valor": 76520495.0,
        "delta": -23079346.0
      },
      {
        "periodo": 202603,
        "valor": 74218569.0,
        "delta": -2301926.0
      },
      {
        "periodo": 202604,
        "valor": 60694752.0,
        "delta": -13523817.0
      },
      {
        "periodo": 202605,
        "valor": 66224783.0,
        "delta": 5530031.0
      },
      {
        "periodo": 202606,
        "valor": 71876034.0,
        "delta": 5651251.0
      },
      {
        "periodo": 202607,
        "valor": 71992399.0,
        "delta": 116365.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 1382075866.0,
    "valor_anterior": 1445836043.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 826128857.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 896175161.0,
        "delta": 70046304.0
      },
      {
        "periodo": 202509,
        "valor": 986216987.0,
        "delta": 90041826.0
      },
      {
        "periodo": 202510,
        "valor": 1056398762.0,
        "delta": 70181775.0
      },
      {
        "periodo": 202511,
        "valor": 1122856064.0,
        "delta": 66457302.0
      },
      {
        "periodo": 202512,
        "valor": 1137636843.0,
        "delta": 14780779.0
      },
      {
        "periodo": 202601,
        "valor": 1204465547.0,
        "delta": 66828704.0
      },
      {
        "periodo": 202602,
        "valor": 1263802807.0,
        "delta": 59337260.0
      },
      {
        "periodo": 202603,
        "valor": 1328779197.0,
        "delta": 64976390.0
      },
      {
        "periodo": 202604,
        "valor": 1397405788.0,
        "delta": 68626591.0
      },
      {
        "periodo": 202605,
        "valor": 1427181029.0,
        "delta": 29775241.0
      },
      {
        "periodo": 202606,
        "valor": 1445836043.0,
        "delta": 18655014.0
      },
      {
        "periodo": 202607,
        "valor": 1382075866.0,
        "delta": -63760177.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 396345776.0,
    "valor_anterior": 414662858.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 422573136.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 442384713.0,
        "delta": 19811577.0
      },
      {
        "periodo": 202509,
        "valor": 471072394.0,
        "delta": 28687681.0
      },
      {
        "periodo": 202510,
        "valor": 414837509.0,
        "delta": -56234885.0
      },
      {
        "periodo": 202511,
        "valor": 404002209.0,
        "delta": -10835300.0
      },
      {
        "periodo": 202512,
        "valor": 418801091.0,
        "delta": 14798882.0
      },
      {
        "periodo": 202601,
        "valor": 399222778.0,
        "delta": -19578313.0
      },
      {
        "periodo": 202602,
        "valor": 435700409.0,
        "delta": 36477631.0
      },
      {
        "periodo": 202603,
        "valor": 466241791.0,
        "delta": 30541382.0
      },
      {
        "periodo": 202604,
        "valor": 406122960.0,
        "delta": -60118831.0
      },
      {
        "periodo": 202605,
        "valor": 397655289.0,
        "delta": -8467671.0
      },
      {
        "periodo": 202606,
        "valor": 414662858.0,
        "delta": 17007569.0
      },
      {
        "periodo": 202607,
        "valor": 396345776.0,
        "delta": -18317082.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 743305158.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -158119979.0,
        "delta": -901425137.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 1784838917.0,
    "valor_anterior": 1743534097.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1814150378.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1797875870.0,
        "delta": -16274508.0
      },
      {
        "periodo": 202509,
        "valor": 1750952604.0,
        "delta": -46923266.0
      },
      {
        "periodo": 202510,
        "valor": 1732029842.0,
        "delta": -18922762.0
      },
      {
        "periodo": 202511,
        "valor": 1605605049.0,
        "delta": -126424793.0
      },
      {
        "periodo": 202512,
        "valor": 1760513950.0,
        "delta": 154908901.0
      },
      {
        "periodo": 202601,
        "valor": 1706998089.0,
        "delta": -53515861.0
      },
      {
        "periodo": 202602,
        "valor": 1684100337.0,
        "delta": -22897752.0
      },
      {
        "periodo": 202603,
        "valor": 1650114912.0,
        "delta": -33985425.0
      },
      {
        "periodo": 202604,
        "valor": 1696741752.0,
        "delta": 46626840.0
      },
      {
        "periodo": 202605,
        "valor": 1687628587.0,
        "delta": -9113165.0
      },
      {
        "periodo": 202606,
        "valor": 1743534097.0,
        "delta": 55905510.0
      },
      {
        "periodo": 202607,
        "valor": 1784838917.0,
        "delta": 41304820.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 22901517.0,
    "valor_anterior": 108302806.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 382426141.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 437871610.0,
        "delta": 55445469.0
      },
      {
        "periodo": 202509,
        "valor": 372792042.0,
        "delta": -65079568.0
      },
      {
        "periodo": 202510,
        "valor": 323982771.0,
        "delta": -48809271.0
      },
      {
        "periodo": 202511,
        "valor": 214799046.0,
        "delta": -109183725.0
      },
      {
        "periodo": 202512,
        "valor": 159181409.0,
        "delta": -55617637.0
      },
      {
        "periodo": 202601,
        "valor": 221902540.0,
        "delta": 62721131.0
      },
      {
        "periodo": 202602,
        "valor": 241238581.0,
        "delta": 19336041.0
      },
      {
        "periodo": 202603,
        "valor": 155169861.0,
        "delta": -86068720.0
      },
      {
        "periodo": 202604,
        "valor": 125845505.0,
        "delta": -29324356.0
      },
      {
        "periodo": 202605,
        "valor": 10546248.0,
        "delta": -115299257.0
      },
      {
        "periodo": 202606,
        "valor": 108302806.0,
        "delta": 97756558.0
      },
      {
        "periodo": 202607,
        "valor": 22901517.0,
        "delta": -85401289.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": -4679963.0,
    "valor_anterior": -14597330.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -80393477.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -84897260.0,
        "delta": -4503783.0
      },
      {
        "periodo": 202509,
        "valor": -85620411.0,
        "delta": -723151.0
      },
      {
        "periodo": 202510,
        "valor": -83896020.0,
        "delta": 1724391.0
      },
      {
        "periodo": 202511,
        "valor": -63026889.0,
        "delta": 20869131.0
      },
      {
        "periodo": 202512,
        "valor": -50862140.0,
        "delta": 12164749.0
      },
      {
        "periodo": 202601,
        "valor": -48616406.0,
        "delta": 2245734.0
      },
      {
        "periodo": 202602,
        "valor": -42267878.0,
        "delta": 6348528.0
      },
      {
        "periodo": 202603,
        "valor": -35070950.0,
        "delta": 7196928.0
      },
      {
        "periodo": 202604,
        "valor": -33748902.0,
        "delta": 1322048.0
      },
      {
        "periodo": 202605,
        "valor": -23227323.0,
        "delta": 10521579.0
      },
      {
        "periodo": 202606,
        "valor": -14597330.0,
        "delta": 8629993.0
      },
      {
        "periodo": 202607,
        "valor": -4679963.0,
        "delta": 9917367.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": -78521456.0,
    "valor_anterior": -73918352.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -16302686.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -24547222.0,
        "delta": -8244536.0
      },
      {
        "periodo": 202509,
        "valor": -25969840.0,
        "delta": -1422618.0
      },
      {
        "periodo": 202510,
        "valor": -32131978.0,
        "delta": -6162138.0
      },
      {
        "periodo": 202511,
        "valor": -36884099.0,
        "delta": -4752121.0
      },
      {
        "periodo": 202512,
        "valor": -51344964.0,
        "delta": -14460865.0
      },
      {
        "periodo": 202601,
        "valor": -56568032.0,
        "delta": -5223068.0
      },
      {
        "periodo": 202602,
        "valor": -59123138.0,
        "delta": -2555106.0
      },
      {
        "periodo": 202603,
        "valor": -63421203.0,
        "delta": -4298065.0
      },
      {
        "periodo": 202604,
        "valor": -65743975.0,
        "delta": -2322772.0
      },
      {
        "periodo": 202605,
        "valor": -68205601.0,
        "delta": -2461626.0
      },
      {
        "periodo": 202606,
        "valor": -73918352.0,
        "delta": -5712751.0
      },
      {
        "periodo": 202607,
        "valor": -78521456.0,
        "delta": -4603104.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 129875140.76,
    "valor_anterior": 122380051.4,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 179251480.13,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 168012463.55,
        "delta": -11239016.58
      },
      {
        "periodo": 202509,
        "valor": 168421253.42,
        "delta": 408789.87
      },
      {
        "periodo": 202510,
        "valor": 156314779.91,
        "delta": -12106473.51
      },
      {
        "periodo": 202511,
        "valor": 149199168.41,
        "delta": -7115611.5
      },
      {
        "periodo": 202512,
        "valor": 142381469.5,
        "delta": -6817698.91
      },
      {
        "periodo": 202601,
        "valor": 150139359.63,
        "delta": 7757890.13
      },
      {
        "periodo": 202602,
        "valor": 143801848.03,
        "delta": -6337511.6
      },
      {
        "periodo": 202603,
        "valor": 137005846.76,
        "delta": -6796001.27
      },
      {
        "periodo": 202604,
        "valor": 135107409.79,
        "delta": -1898436.97
      },
      {
        "periodo": 202605,
        "valor": 123428197.43,
        "delta": -11679212.36
      },
      {
        "periodo": 202606,
        "valor": 122380051.4,
        "delta": -1048146.03
      },
      {
        "periodo": 202607,
        "valor": 129875140.76,
        "delta": 7495089.36
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": -31166616.0,
    "valor_anterior": -43457561.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -116960468.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -111342015.0,
        "delta": 5618453.0
      },
      {
        "periodo": 202509,
        "valor": -109024019.0,
        "delta": 2317996.0
      },
      {
        "periodo": 202510,
        "valor": -106253946.0,
        "delta": 2770073.0
      },
      {
        "periodo": 202511,
        "valor": -111798248.0,
        "delta": -5544302.0
      },
      {
        "periodo": 202512,
        "valor": -105595336.0,
        "delta": 6202912.0
      },
      {
        "periodo": 202601,
        "valor": -93453760.0,
        "delta": 12141576.0
      },
      {
        "periodo": 202602,
        "valor": -82204822.0,
        "delta": 11248938.0
      },
      {
        "periodo": 202603,
        "valor": -77456755.0,
        "delta": 4748067.0
      },
      {
        "periodo": 202604,
        "valor": -67638684.0,
        "delta": 9818071.0
      },
      {
        "periodo": 202605,
        "valor": -56242005.0,
        "delta": 11396679.0
      },
      {
        "periodo": 202606,
        "valor": -43457561.0,
        "delta": 12784444.0
      },
      {
        "periodo": 202607,
        "valor": -31166616.0,
        "delta": 12290945.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 1105297148.34,
    "valor_anterior": 1108644509.57,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 933211539.89,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 979461347.11,
        "delta": 46249807.22
      },
      {
        "periodo": 202509,
        "valor": 1006982605.66,
        "delta": 27521258.55
      },
      {
        "periodo": 202510,
        "valor": 1076057613.69,
        "delta": 69075008.03
      },
      {
        "periodo": 202511,
        "valor": 1091446977.06,
        "delta": 15389363.37
      },
      {
        "periodo": 202512,
        "valor": 1102563052.26,
        "delta": 11116075.2
      },
      {
        "periodo": 202601,
        "valor": 1109057671.72,
        "delta": 6494619.46
      },
      {
        "periodo": 202602,
        "valor": 1109988454.4,
        "delta": 930782.68
      },
      {
        "periodo": 202603,
        "valor": 1056121286.16,
        "delta": -53867168.24
      },
      {
        "periodo": 202604,
        "valor": 1078146798.57,
        "delta": 22025512.41
      },
      {
        "periodo": 202605,
        "valor": 1108889381.83,
        "delta": 30742583.26
      },
      {
        "periodo": 202606,
        "valor": 1108644509.57,
        "delta": -244872.26
      },
      {
        "periodo": 202607,
        "valor": 1105297148.34,
        "delta": -3347361.23
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 179086474.91,
    "valor_anterior": 174433098.75,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 125354917.4,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 135447999.2,
        "delta": 10093081.8
      },
      {
        "periodo": 202509,
        "valor": 134772920.22,
        "delta": -675078.98
      },
      {
        "periodo": 202510,
        "valor": 127583773.72,
        "delta": -7189146.5
      },
      {
        "periodo": 202511,
        "valor": 142122007.43,
        "delta": 14538233.71
      },
      {
        "periodo": 202512,
        "valor": 153067539.65,
        "delta": 10945532.22
      },
      {
        "periodo": 202601,
        "valor": 150486163.41,
        "delta": -2581376.24
      },
      {
        "periodo": 202602,
        "valor": 151394066.68,
        "delta": 907903.27
      },
      {
        "periodo": 202603,
        "valor": 164166611.19,
        "delta": 12772544.51
      },
      {
        "periodo": 202604,
        "valor": 157971041.4,
        "delta": -6195569.79
      },
      {
        "periodo": 202605,
        "valor": 159439220.29,
        "delta": 1468178.89
      },
      {
        "periodo": 202606,
        "valor": 174433098.75,
        "delta": 14993878.46
      },
      {
        "periodo": 202607,
        "valor": 179086474.91,
        "delta": 4653376.16
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 194900109.0,
    "valor_anterior": 226305473.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 256617442.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 258151231.0,
        "delta": 1533789.0
      },
      {
        "periodo": 202509,
        "valor": 269288276.0,
        "delta": 11137045.0
      },
      {
        "periodo": 202510,
        "valor": 276672729.0,
        "delta": 7384453.0
      },
      {
        "periodo": 202511,
        "valor": 272984388.0,
        "delta": -3688341.0
      },
      {
        "periodo": 202512,
        "valor": 270420138.0,
        "delta": -2564250.0
      },
      {
        "periodo": 202601,
        "valor": 269301751.0,
        "delta": -1118387.0
      },
      {
        "periodo": 202602,
        "valor": 277363212.0,
        "delta": 8061461.0
      },
      {
        "periodo": 202603,
        "valor": 262615032.0,
        "delta": -14748180.0
      },
      {
        "periodo": 202604,
        "valor": 227568248.0,
        "delta": -35046784.0
      },
      {
        "periodo": 202605,
        "valor": 240299174.0,
        "delta": 12730926.0
      },
      {
        "periodo": 202606,
        "valor": 226305473.0,
        "delta": -13993701.0
      },
      {
        "periodo": 202607,
        "valor": 194900109.0,
        "delta": -31405364.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 1359393938.0,
    "valor_anterior": 1299864096.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1255893083.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1288395593.0,
        "delta": 32502510.0
      },
      {
        "periodo": 202509,
        "valor": 1337099247.0,
        "delta": 48703654.0
      },
      {
        "periodo": 202510,
        "valor": 1335330484.0,
        "delta": -1768763.0
      },
      {
        "periodo": 202511,
        "valor": 1307605266.0,
        "delta": -27725218.0
      },
      {
        "periodo": 202512,
        "valor": 1316104168.0,
        "delta": 8498902.0
      },
      {
        "periodo": 202601,
        "valor": 1307774289.0,
        "delta": -8329879.0
      },
      {
        "periodo": 202602,
        "valor": 1275878515.0,
        "delta": -31895774.0
      },
      {
        "periodo": 202603,
        "valor": 1254233586.0,
        "delta": -21644929.0
      },
      {
        "periodo": 202604,
        "valor": 1245453073.0,
        "delta": -8780513.0
      },
      {
        "periodo": 202605,
        "valor": 1258037783.0,
        "delta": 12584710.0
      },
      {
        "periodo": 202606,
        "valor": 1299864096.0,
        "delta": 41826313.0
      },
      {
        "periodo": 202607,
        "valor": 1359393938.0,
        "delta": 59529842.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 125217552.0,
    "valor_anterior": 108502286.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 113673460.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 118985117.0,
        "delta": 5311657.0
      },
      {
        "periodo": 202509,
        "valor": 117069245.0,
        "delta": -1915872.0
      },
      {
        "periodo": 202510,
        "valor": 117996220.0,
        "delta": 926975.0
      },
      {
        "periodo": 202511,
        "valor": 118934150.0,
        "delta": 937930.0
      },
      {
        "periodo": 202512,
        "valor": 112998685.0,
        "delta": -5935465.0
      },
      {
        "periodo": 202601,
        "valor": 110185709.0,
        "delta": -2812976.0
      },
      {
        "periodo": 202602,
        "valor": 109964980.0,
        "delta": -220729.0
      },
      {
        "periodo": 202603,
        "valor": 113231614.0,
        "delta": 3266634.0
      },
      {
        "periodo": 202604,
        "valor": 112807571.0,
        "delta": -424043.0
      },
      {
        "periodo": 202605,
        "valor": 112475830.0,
        "delta": -331741.0
      },
      {
        "periodo": 202606,
        "valor": 108502286.0,
        "delta": -3973544.0
      },
      {
        "periodo": 202607,
        "valor": 125217552.0,
        "delta": 16715266.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 305439911.84,
    "valor_anterior": 318978756.8,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 448974167.99,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 430278157.92,
        "delta": -18696010.07
      },
      {
        "periodo": 202509,
        "valor": 441508825.58,
        "delta": 11230667.66
      },
      {
        "periodo": 202510,
        "valor": 438163029.33,
        "delta": -3345796.25
      },
      {
        "periodo": 202511,
        "valor": 424078743.17,
        "delta": -14084286.16
      },
      {
        "periodo": 202512,
        "valor": 415060312.88,
        "delta": -9018430.29
      },
      {
        "periodo": 202601,
        "valor": 386753827.34,
        "delta": -28306485.54
      },
      {
        "periodo": 202602,
        "valor": 387814370.88,
        "delta": 1060543.54
      },
      {
        "periodo": 202603,
        "valor": 348836278.12,
        "delta": -38978092.76
      },
      {
        "periodo": 202604,
        "valor": 338323504.37,
        "delta": -10512773.75
      },
      {
        "periodo": 202605,
        "valor": 325013456.78,
        "delta": -13310047.59
      },
      {
        "periodo": 202606,
        "valor": 318978756.8,
        "delta": -6034699.98
      },
      {
        "periodo": 202607,
        "valor": 305439911.84,
        "delta": -13538844.96
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 98285526.84,
    "valor_anterior": 116853111.02,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 173560873.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 193830376.26,
        "delta": 20269503.26
      },
      {
        "periodo": 202509,
        "valor": 183871397.95,
        "delta": -9958978.31
      },
      {
        "periodo": 202510,
        "valor": 184790210.72,
        "delta": 918812.77
      },
      {
        "periodo": 202511,
        "valor": 182440396.72,
        "delta": -2349814.0
      },
      {
        "periodo": 202512,
        "valor": 166738624.92,
        "delta": -15701771.8
      },
      {
        "periodo": 202601,
        "valor": 162556740.38,
        "delta": -4181884.54
      },
      {
        "periodo": 202602,
        "valor": 149123740.87,
        "delta": -13432999.51
      },
      {
        "periodo": 202603,
        "valor": 152996341.79,
        "delta": 3872600.92
      },
      {
        "periodo": 202604,
        "valor": 110668803.45,
        "delta": -42327538.34
      },
      {
        "periodo": 202605,
        "valor": 113722272.51,
        "delta": 3053469.06
      },
      {
        "periodo": 202606,
        "valor": 116853111.02,
        "delta": 3130838.51
      },
      {
        "periodo": 202607,
        "valor": 98285526.84,
        "delta": -18567584.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 322570878.0,
    "valor_anterior": 325587973.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 318056021.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 315863980.0,
        "delta": -2192041.0
      },
      {
        "periodo": 202509,
        "valor": 320183021.0,
        "delta": 4319041.0
      },
      {
        "periodo": 202510,
        "valor": 319817906.0,
        "delta": -365115.0
      },
      {
        "periodo": 202511,
        "valor": 314464112.0,
        "delta": -5353794.0
      },
      {
        "periodo": 202512,
        "valor": 313990402.0,
        "delta": -473710.0
      },
      {
        "periodo": 202601,
        "valor": 313556527.0,
        "delta": -433875.0
      },
      {
        "periodo": 202602,
        "valor": 316930633.0,
        "delta": 3374106.0
      },
      {
        "periodo": 202603,
        "valor": 315913362.0,
        "delta": -1017271.0
      },
      {
        "periodo": 202604,
        "valor": 317356427.0,
        "delta": 1443065.0
      },
      {
        "periodo": 202605,
        "valor": 317668243.0,
        "delta": 311816.0
      },
      {
        "periodo": 202606,
        "valor": 325587973.0,
        "delta": 7919730.0
      },
      {
        "periodo": 202607,
        "valor": 322570878.0,
        "delta": -3017095.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 41510309.0,
    "valor_anterior": 41958613.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 46324565.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 43788980.0,
        "delta": -2535585.0
      },
      {
        "periodo": 202509,
        "valor": 43634750.0,
        "delta": -154230.0
      },
      {
        "periodo": 202510,
        "valor": 43564974.0,
        "delta": -69776.0
      },
      {
        "periodo": 202511,
        "valor": 42895206.0,
        "delta": -669768.0
      },
      {
        "periodo": 202512,
        "valor": 41945655.0,
        "delta": -949551.0
      },
      {
        "periodo": 202601,
        "valor": 35869084.0,
        "delta": -6076571.0
      },
      {
        "periodo": 202602,
        "valor": 35412374.0,
        "delta": -456710.0
      },
      {
        "periodo": 202603,
        "valor": 36598001.0,
        "delta": 1185627.0
      },
      {
        "periodo": 202604,
        "valor": 36659775.0,
        "delta": 61774.0
      },
      {
        "periodo": 202605,
        "valor": 39279026.0,
        "delta": 2619251.0
      },
      {
        "periodo": 202606,
        "valor": 41958613.0,
        "delta": 2679587.0
      },
      {
        "periodo": 202607,
        "valor": 41510309.0,
        "delta": -448304.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 240908417.0,
    "valor_anterior": 294911729.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 385714634.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 368059874.0,
        "delta": -17654760.0
      },
      {
        "periodo": 202509,
        "valor": 176261118.0,
        "delta": -191798756.0
      },
      {
        "periodo": 202510,
        "valor": 152173240.0,
        "delta": -24087878.0
      },
      {
        "periodo": 202511,
        "valor": 161709112.0,
        "delta": 9535872.0
      },
      {
        "periodo": 202512,
        "valor": 324158993.0,
        "delta": 162449881.0
      },
      {
        "periodo": 202601,
        "valor": 340802718.0,
        "delta": 16643725.0
      },
      {
        "periodo": 202602,
        "valor": 345006628.0,
        "delta": 4203910.0
      },
      {
        "periodo": 202603,
        "valor": 314308253.0,
        "delta": -30698375.0
      },
      {
        "periodo": 202604,
        "valor": 265155137.0,
        "delta": -49153116.0
      },
      {
        "periodo": 202605,
        "valor": 294868212.0,
        "delta": 29713075.0
      },
      {
        "periodo": 202606,
        "valor": 294911729.0,
        "delta": 43517.0
      },
      {
        "periodo": 202607,
        "valor": 240908417.0,
        "delta": -54003312.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": -749176633.88,
    "valor_anterior": -766456539.44,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": -1071783811.7,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -1057362662.36,
        "delta": 14421149.34
      },
      {
        "periodo": 202509,
        "valor": -1049602205.9,
        "delta": 7760456.46
      },
      {
        "periodo": 202510,
        "valor": -995874877.74,
        "delta": 53727328.16
      },
      {
        "periodo": 202511,
        "valor": -944164704.2,
        "delta": 51710173.54
      },
      {
        "periodo": 202512,
        "valor": -897449998.49,
        "delta": 46714705.71
      },
      {
        "periodo": 202601,
        "valor": -865621507.92,
        "delta": 31828490.57
      },
      {
        "periodo": 202602,
        "valor": -830277622.78,
        "delta": 35343885.14
      },
      {
        "periodo": 202603,
        "valor": -792431170.57,
        "delta": 37846452.21
      },
      {
        "periodo": 202604,
        "valor": -781617345.58,
        "delta": 10813824.99
      },
      {
        "periodo": 202605,
        "valor": -769268071.53,
        "delta": 12349274.05
      },
      {
        "periodo": 202606,
        "valor": -766456539.44,
        "delta": 2811532.09
      },
      {
        "periodo": 202607,
        "valor": -749176633.88,
        "delta": 17279905.56
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 173510857.58,
    "valor_anterior": 165142656.16,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 63362378.81,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 86421907.65,
        "delta": 23059528.84
      },
      {
        "periodo": 202603,
        "valor": 111792683.23,
        "delta": 25370775.58
      },
      {
        "periodo": 202604,
        "valor": 112568802.85,
        "delta": 776119.62
      },
      {
        "periodo": 202605,
        "valor": 125881008.82,
        "delta": 13312205.97
      },
      {
        "periodo": 202606,
        "valor": 165142656.16,
        "delta": 39261647.34
      },
      {
        "periodo": 202607,
        "valor": 173510857.58,
        "delta": 8368201.42
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": -2209346510.0,
    "valor_anterior": -2106751924.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": -1491760335.0,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": -1296702412.0,
        "delta": 195057923.0
      },
      {
        "periodo": 202512,
        "valor": -1401826256.0,
        "delta": -105123844.0
      },
      {
        "periodo": 202601,
        "valor": -1530674729.0,
        "delta": -128848473.0
      },
      {
        "periodo": 202602,
        "valor": -1656559484.0,
        "delta": -125884755.0
      },
      {
        "periodo": 202603,
        "valor": -1773626816.0,
        "delta": -117067332.0
      },
      {
        "periodo": 202604,
        "valor": -1883866592.0,
        "delta": -110239776.0
      },
      {
        "periodo": 202605,
        "valor": -1997892354.0,
        "delta": -114025762.0
      },
      {
        "periodo": 202606,
        "valor": -2106751924.0,
        "delta": -108859570.0
      },
      {
        "periodo": 202607,
        "valor": -2209346510.0,
        "delta": -102594586.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 300752739155.93,
    "valor_anterior": 301651620235.87994,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 296953110410.09,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 297562841545.72,
        "delta": 609731135.63
      },
      {
        "periodo": 202509,
        "valor": 294575719791.31,
        "delta": -2987121754.41
      },
      {
        "periodo": 202510,
        "valor": 296251324483.6,
        "delta": 1675604692.29
      },
      {
        "periodo": 202511,
        "valor": 300359237383.84,
        "delta": 4107912900.2399
      },
      {
        "periodo": 202512,
        "valor": 305009516593.53,
        "delta": 4650279209.6901
      },
      {
        "periodo": 202601,
        "valor": 305956095276.94,
        "delta": 946578683.41
      },
      {
        "periodo": 202602,
        "valor": 304042471756.43,
        "delta": -1913623520.51
      },
      {
        "periodo": 202603,
        "valor": 309607250858.61,
        "delta": 5564779102.18
      },
      {
        "periodo": 202604,
        "valor": 309425946398.9,
        "delta": -181304459.71
      },
      {
        "periodo": 202605,
        "valor": 304450677965.42,
        "delta": -4975268433.48
      },
      {
        "periodo": 202606,
        "valor": 301651620235.8799,
        "delta": -2799057729.54
      },
      {
        "periodo": 202607,
        "valor": 300752739155.93,
        "delta": -898881079.95
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 241343294136.05,
    "valor_anterior": 240870032170.80002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 230654502038.68,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 231380855618.28,
        "delta": 726353579.6
      },
      {
        "periodo": 202509,
        "valor": 227516263833.32,
        "delta": -3864591784.96
      },
      {
        "periodo": 202510,
        "valor": 227806558819.82,
        "delta": 290294986.5
      },
      {
        "periodo": 202511,
        "valor": 232293324682.11,
        "delta": 4486765862.29
      },
      {
        "periodo": 202512,
        "valor": 234830469364.12,
        "delta": 2537144682.01
      },
      {
        "periodo": 202601,
        "valor": 237332852024.19,
        "delta": 2502382660.07
      },
      {
        "periodo": 202602,
        "valor": 235663828672.91,
        "delta": -1669023351.28
      },
      {
        "periodo": 202603,
        "valor": 244321930851.13,
        "delta": 8658102178.22
      },
      {
        "periodo": 202604,
        "valor": 244621722831.53,
        "delta": 299791980.4
      },
      {
        "periodo": 202605,
        "valor": 241130434744.28,
        "delta": -3491288087.25
      },
      {
        "periodo": 202606,
        "valor": 240870032170.8,
        "delta": -260402573.4799
      },
      {
        "periodo": 202607,
        "valor": 241343294136.05,
        "delta": 473261965.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 4054191621.17,
    "valor_anterior": 3935326859.01,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8739483422.96,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7416078525.89,
        "delta": -1323404897.07
      },
      {
        "periodo": 202509,
        "valor": 7529962850.62,
        "delta": 113884324.73
      },
      {
        "periodo": 202510,
        "valor": 7079748543.38,
        "delta": -450214307.24
      },
      {
        "periodo": 202511,
        "valor": 6637955845.08,
        "delta": -441792698.3
      },
      {
        "periodo": 202512,
        "valor": 6077931487.91,
        "delta": -560024357.17
      },
      {
        "periodo": 202601,
        "valor": 5864926629.38,
        "delta": -213004858.53
      },
      {
        "periodo": 202602,
        "valor": 5753179862.88,
        "delta": -111746766.5
      },
      {
        "periodo": 202603,
        "valor": 5087666571.22,
        "delta": -665513291.66
      },
      {
        "periodo": 202604,
        "valor": 4842421395.24,
        "delta": -245245175.98
      },
      {
        "periodo": 202605,
        "valor": 4518441402.65,
        "delta": -323979992.59
      },
      {
        "periodo": 202606,
        "valor": 3935326859.01,
        "delta": -583114543.64
      },
      {
        "periodo": 202607,
        "valor": 4054191621.17,
        "delta": 118864762.16
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 19989788210.45,
    "valor_anterior": 20616311496.79,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16819456057.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18011867175.53,
        "delta": 1192411117.6
      },
      {
        "periodo": 202509,
        "valor": 18637691209.18,
        "delta": 625824033.65
      },
      {
        "periodo": 202510,
        "valor": 19855954234.86,
        "delta": 1218263025.68
      },
      {
        "periodo": 202511,
        "valor": 20115050411.08,
        "delta": 259096176.22
      },
      {
        "periodo": 202512,
        "valor": 22385067246.27,
        "delta": 2270016835.19
      },
      {
        "periodo": 202601,
        "valor": 21348628098.91,
        "delta": -1036439147.36
      },
      {
        "periodo": 202602,
        "valor": 21654491883.96,
        "delta": 305863785.05
      },
      {
        "periodo": 202603,
        "valor": 20448194015.48,
        "delta": -1206297868.48
      },
      {
        "periodo": 202604,
        "valor": 20768104269.52,
        "delta": 319910254.04
      },
      {
        "periodo": 202605,
        "valor": 21246777272.77,
        "delta": 478673003.25
      },
      {
        "periodo": 202606,
        "valor": 20616311496.79,
        "delta": -630465775.98
      },
      {
        "periodo": 202607,
        "valor": 19989788210.45,
        "delta": -626523286.34
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 22586981872.06,
    "valor_anterior": 22462235583.809998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 23396153112.23,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23406524621.88,
        "delta": 10371509.65
      },
      {
        "periodo": 202509,
        "valor": 23412869373.88,
        "delta": 6344752.0
      },
      {
        "periodo": 202510,
        "valor": 23544564845.68,
        "delta": 131695471.8
      },
      {
        "periodo": 202511,
        "valor": 23436468205.14,
        "delta": -108096640.54
      },
      {
        "periodo": 202512,
        "valor": 23078402832.6,
        "delta": -358065372.54
      },
      {
        "periodo": 202601,
        "valor": 22949285838.23,
        "delta": -129116994.37
      },
      {
        "periodo": 202602,
        "valor": 22524593533.89,
        "delta": -424692304.34
      },
      {
        "periodo": 202603,
        "valor": 22384202750.8,
        "delta": -140390783.09
      },
      {
        "periodo": 202604,
        "valor": 22423407661.63,
        "delta": 39204910.83
      },
      {
        "periodo": 202605,
        "valor": 22346582756.19,
        "delta": -76824905.44
      },
      {
        "periodo": 202606,
        "valor": 22462235583.81,
        "delta": 115652827.62
      },
      {
        "periodo": 202607,
        "valor": 22586981872.06,
        "delta": 124746288.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 4318950899.67,
    "valor_anterior": 4203727566.51,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3199461706.04,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3396598833.44,
        "delta": 197137127.4
      },
      {
        "periodo": 202509,
        "valor": 3729547661.64,
        "delta": 332948828.2
      },
      {
        "periodo": 202510,
        "valor": 3810515777.6,
        "delta": 80968115.96
      },
      {
        "periodo": 202511,
        "valor": 3627783339.29,
        "delta": -182732438.31
      },
      {
        "periodo": 202512,
        "valor": 3833631440.21,
        "delta": 205848100.92
      },
      {
        "periodo": 202601,
        "valor": 4059438727.8,
        "delta": 225807287.59
      },
      {
        "periodo": 202602,
        "valor": 4024938612.23,
        "delta": -34500115.57
      },
      {
        "periodo": 202603,
        "valor": 4055904905.25,
        "delta": 30966293.02
      },
      {
        "periodo": 202604,
        "valor": 4044569319.44,
        "delta": -11335585.81
      },
      {
        "periodo": 202605,
        "valor": 4160250023.33,
        "delta": 115680703.89
      },
      {
        "periodo": 202606,
        "valor": 4203727566.51,
        "delta": 43477543.18
      },
      {
        "periodo": 202607,
        "valor": 4318950899.67,
        "delta": 115223333.16
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200015,
    "label": "Resultado Neto (Suma 12m)",
    "valor_actual": 8459532416.53,
    "valor_anterior": 9563986558.96,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14144054072.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13950916770.7,
        "delta": -193137301.55
      },
      {
        "periodo": 202509,
        "valor": 13749384862.67,
        "delta": -201531908.03
      },
      {
        "periodo": 202510,
        "valor": 14153982262.26,
        "delta": 404597399.59
      },
      {
        "periodo": 202511,
        "valor": 14248654901.14,
        "delta": 94672638.88
      },
      {
        "periodo": 202512,
        "valor": 14804014222.42,
        "delta": 555359321.28
      },
      {
        "periodo": 202601,
        "valor": 14400963958.43,
        "delta": -403050263.99
      },
      {
        "periodo": 202602,
        "valor": 14421439190.56,
        "delta": 20475232.13
      },
      {
        "periodo": 202603,
        "valor": 13309351764.73,
        "delta": -1112087425.83
      },
      {
        "periodo": 202604,
        "valor": 12725720921.54,
        "delta": -583630843.19
      },
      {
        "periodo": 202605,
        "valor": 11048191766.2,
        "delta": -1677529155.34
      },
      {
        "periodo": 202606,
        "valor": 9563986558.96,
        "delta": -1484205207.24
      },
      {
        "periodo": 202607,
        "valor": 8459532416.53,
        "delta": -1104454142.43
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 3.180066,
    "valor_anterior": 3.167179,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.8293,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.8063,
        "delta": -0.023
      },
      {
        "periodo": 202509,
        "valor": 2.7993,
        "delta": -0.007
      },
      {
        "periodo": 202510,
        "valor": 2.8679,
        "delta": 0.0686
      },
      {
        "periodo": 202511,
        "valor": 2.8502,
        "delta": -0.0177
      },
      {
        "periodo": 202512,
        "valor": 2.9738,
        "delta": 0.1236
      },
      {
        "periodo": 202601,
        "valor": 3.0507,
        "delta": 0.0769
      },
      {
        "periodo": 202602,
        "valor": 3.1007,
        "delta": 0.05
      },
      {
        "periodo": 202603,
        "valor": 3.0416,
        "delta": -0.0592
      },
      {
        "periodo": 202604,
        "valor": 3.0575,
        "delta": 0.0159
      },
      {
        "periodo": 202605,
        "valor": 3.1434,
        "delta": 0.0859
      },
      {
        "periodo": 202606,
        "valor": 3.1672,
        "delta": 0.0238
      },
      {
        "periodo": 202607,
        "valor": 3.1801,
        "delta": 0.0129
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 1.7008059999999998,
    "valor_anterior": 1.6692909999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.6346,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.6508,
        "delta": 0.0161
      },
      {
        "periodo": 202509,
        "valor": 1.724,
        "delta": 0.0733
      },
      {
        "periodo": 202510,
        "valor": 1.7298,
        "delta": 0.0058
      },
      {
        "periodo": 202511,
        "valor": 1.6955,
        "delta": -0.0344
      },
      {
        "periodo": 202512,
        "valor": 1.6437,
        "delta": -0.0518
      },
      {
        "periodo": 202601,
        "valor": 1.6568,
        "delta": 0.0132
      },
      {
        "periodo": 202602,
        "valor": 1.6095,
        "delta": -0.0473
      },
      {
        "periodo": 202603,
        "valor": 1.5678,
        "delta": -0.0418
      },
      {
        "periodo": 202604,
        "valor": 1.6246,
        "delta": 0.0569
      },
      {
        "periodo": 202605,
        "valor": 1.6777,
        "delta": 0.0531
      },
      {
        "periodo": 202606,
        "valor": 1.6693,
        "delta": -0.0084
      },
      {
        "periodo": 202607,
        "valor": 1.7008,
        "delta": 0.0315
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 2.390807,
    "valor_anterior": 2.371233,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.3224,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.2979,
        "delta": -0.0245
      },
      {
        "periodo": 202509,
        "valor": 2.4065,
        "delta": 0.1085
      },
      {
        "periodo": 202510,
        "valor": 2.3878,
        "delta": -0.0186
      },
      {
        "periodo": 202511,
        "valor": 2.2524,
        "delta": -0.1354
      },
      {
        "periodo": 202512,
        "valor": 2.0616,
        "delta": -0.1909
      },
      {
        "periodo": 202601,
        "valor": 2.0762,
        "delta": 0.0146
      },
      {
        "periodo": 202602,
        "valor": 2.1909,
        "delta": 0.1147
      },
      {
        "periodo": 202603,
        "valor": 2.2145,
        "delta": 0.0236
      },
      {
        "periodo": 202604,
        "valor": 2.2346,
        "delta": 0.0202
      },
      {
        "periodo": 202605,
        "valor": 2.3512,
        "delta": 0.1165
      },
      {
        "periodo": 202606,
        "valor": 2.3712,
        "delta": 0.0201
      },
      {
        "periodo": 202607,
        "valor": 2.3908,
        "delta": 0.0196
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 3.146986,
    "valor_anterior": 3.142217,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.7388,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.9594,
        "delta": 0.2206
      },
      {
        "periodo": 202509,
        "valor": 2.9905,
        "delta": 0.0311
      },
      {
        "periodo": 202510,
        "valor": 2.9909,
        "delta": 0.0005
      },
      {
        "periodo": 202511,
        "valor": 2.9269,
        "delta": -0.064
      },
      {
        "periodo": 202512,
        "valor": 3.0635,
        "delta": 0.1366
      },
      {
        "periodo": 202601,
        "valor": 3.0839,
        "delta": 0.0204
      },
      {
        "periodo": 202602,
        "valor": 3.0769,
        "delta": -0.007
      },
      {
        "periodo": 202603,
        "valor": 3.1634,
        "delta": 0.0864
      },
      {
        "periodo": 202604,
        "valor": 3.0724,
        "delta": -0.091
      },
      {
        "periodo": 202605,
        "valor": 3.0694,
        "delta": -0.003
      },
      {
        "periodo": 202606,
        "valor": 3.1422,
        "delta": 0.0728
      },
      {
        "periodo": 202607,
        "valor": 3.147,
        "delta": 0.0048
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 1.8530890000000002,
    "valor_anterior": 1.811175,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.8704,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.8451,
        "delta": -0.0253
      },
      {
        "periodo": 202509,
        "valor": 1.9736,
        "delta": 0.1285
      },
      {
        "periodo": 202510,
        "valor": 1.9082,
        "delta": -0.0654
      },
      {
        "periodo": 202511,
        "valor": 1.785,
        "delta": -0.1232
      },
      {
        "periodo": 202512,
        "valor": 1.4923,
        "delta": -0.2927
      },
      {
        "periodo": 202601,
        "valor": 1.5027,
        "delta": 0.0103
      },
      {
        "periodo": 202602,
        "valor": 1.5088,
        "delta": 0.0062
      },
      {
        "periodo": 202603,
        "valor": 1.5464,
        "delta": 0.0375
      },
      {
        "periodo": 202604,
        "valor": 1.7555,
        "delta": 0.2091
      },
      {
        "periodo": 202605,
        "valor": 1.7681,
        "delta": 0.0126
      },
      {
        "periodo": 202606,
        "valor": 1.8112,
        "delta": 0.0431
      },
      {
        "periodo": 202607,
        "valor": 1.8531,
        "delta": 0.0419
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 1.984605,
    "valor_anterior": 2.0270360000000003,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.4786,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.5063,
        "delta": 0.0277
      },
      {
        "periodo": 202509,
        "valor": 1.47,
        "delta": -0.0363
      },
      {
        "periodo": 202510,
        "valor": 1.4951,
        "delta": 0.0251
      },
      {
        "periodo": 202511,
        "valor": 1.4681,
        "delta": -0.027
      },
      {
        "periodo": 202512,
        "valor": 1.4416,
        "delta": -0.0265
      },
      {
        "periodo": 202601,
        "valor": 1.3874,
        "delta": -0.0542
      },
      {
        "periodo": 202602,
        "valor": 1.3572,
        "delta": -0.0302
      },
      {
        "periodo": 202603,
        "valor": 1.398,
        "delta": 0.0408
      },
      {
        "periodo": 202604,
        "valor": 1.8761,
        "delta": 0.4781
      },
      {
        "periodo": 202605,
        "valor": 1.9631,
        "delta": 0.087
      },
      {
        "periodo": 202606,
        "valor": 2.027,
        "delta": 0.0639
      },
      {
        "periodo": 202607,
        "valor": 1.9846,
        "delta": -0.0424
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 2.964931,
    "valor_anterior": 2.913355,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.6526,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.8479,
        "delta": 0.1953
      },
      {
        "periodo": 202509,
        "valor": 3.1924,
        "delta": 0.3445
      },
      {
        "periodo": 202510,
        "valor": 3.0925,
        "delta": -0.0999
      },
      {
        "periodo": 202511,
        "valor": 2.9944,
        "delta": -0.0981
      },
      {
        "periodo": 202512,
        "valor": 2.2984,
        "delta": -0.696
      },
      {
        "periodo": 202601,
        "valor": 2.411,
        "delta": 0.1126
      },
      {
        "periodo": 202602,
        "valor": 2.4405,
        "delta": 0.0295
      },
      {
        "periodo": 202603,
        "valor": 2.3965,
        "delta": -0.044
      },
      {
        "periodo": 202604,
        "valor": 2.6778,
        "delta": 0.2812
      },
      {
        "periodo": 202605,
        "valor": 2.9819,
        "delta": 0.3041
      },
      {
        "periodo": 202606,
        "valor": 2.9134,
        "delta": -0.0685
      },
      {
        "periodo": 202607,
        "valor": 2.9649,
        "delta": 0.0516
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 3.9279300000000004,
    "valor_anterior": 3.9718910000000003,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4.0518,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4.0424,
        "delta": -0.0093
      },
      {
        "periodo": 202509,
        "valor": 4.1159,
        "delta": 0.0735
      },
      {
        "periodo": 202510,
        "valor": 4.1275,
        "delta": 0.0116
      },
      {
        "periodo": 202511,
        "valor": 4.1484,
        "delta": 0.0209
      },
      {
        "periodo": 202512,
        "valor": 4.1573,
        "delta": 0.0088
      },
      {
        "periodo": 202601,
        "valor": 4.2017,
        "delta": 0.0444
      },
      {
        "periodo": 202602,
        "valor": 4.175,
        "delta": -0.0267
      },
      {
        "periodo": 202603,
        "valor": 4.0985,
        "delta": -0.0765
      },
      {
        "periodo": 202604,
        "valor": 4.0591,
        "delta": -0.0394
      },
      {
        "periodo": 202605,
        "valor": 4.0427,
        "delta": -0.0164
      },
      {
        "periodo": 202606,
        "valor": 3.9719,
        "delta": -0.0708
      },
      {
        "periodo": 202607,
        "valor": 3.9279,
        "delta": -0.044
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 1.375426,
    "valor_anterior": 1.34021,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.4946,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.5763,
        "delta": 0.0817
      },
      {
        "periodo": 202509,
        "valor": 1.614,
        "delta": 0.0378
      },
      {
        "periodo": 202510,
        "valor": 1.7466,
        "delta": 0.1326
      },
      {
        "periodo": 202511,
        "valor": 1.7739,
        "delta": 0.0273
      },
      {
        "periodo": 202512,
        "valor": 1.267,
        "delta": -0.5068
      },
      {
        "periodo": 202601,
        "valor": 1.1552,
        "delta": -0.1119
      },
      {
        "periodo": 202602,
        "valor": 1.3359,
        "delta": 0.1807
      },
      {
        "periodo": 202603,
        "valor": 1.2803,
        "delta": -0.0556
      },
      {
        "periodo": 202604,
        "valor": 1.3087,
        "delta": 0.0284
      },
      {
        "periodo": 202605,
        "valor": 1.2894,
        "delta": -0.0192
      },
      {
        "periodo": 202606,
        "valor": 1.3402,
        "delta": 0.0508
      },
      {
        "periodo": 202607,
        "valor": 1.3754,
        "delta": 0.0352
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 2.729085,
    "valor_anterior": 2.747496,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.1703,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.3553,
        "delta": 0.185
      },
      {
        "periodo": 202509,
        "valor": 2.2511,
        "delta": -0.1042
      },
      {
        "periodo": 202510,
        "valor": 2.3807,
        "delta": 0.1296
      },
      {
        "periodo": 202511,
        "valor": 2.5169,
        "delta": 0.1363
      },
      {
        "periodo": 202512,
        "valor": 2.649,
        "delta": 0.132
      },
      {
        "periodo": 202601,
        "valor": 3.0715,
        "delta": 0.4225
      },
      {
        "periodo": 202602,
        "valor": 3.1651,
        "delta": 0.0936
      },
      {
        "periodo": 202603,
        "valor": 2.593,
        "delta": -0.572
      },
      {
        "periodo": 202604,
        "valor": 2.64,
        "delta": 0.0469
      },
      {
        "periodo": 202605,
        "valor": 2.6823,
        "delta": 0.0424
      },
      {
        "periodo": 202606,
        "valor": 2.7475,
        "delta": 0.0651
      },
      {
        "periodo": 202607,
        "valor": 2.7291,
        "delta": -0.0184
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 4.90639,
    "valor_anterior": 4.565098,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.6976,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.5418,
        "delta": -0.1557
      },
      {
        "periodo": 202509,
        "valor": 3.6772,
        "delta": 0.1354
      },
      {
        "periodo": 202510,
        "valor": 3.6235,
        "delta": -0.0537
      },
      {
        "periodo": 202511,
        "valor": 3.541,
        "delta": -0.0825
      },
      {
        "periodo": 202512,
        "valor": 3.4805,
        "delta": -0.0605
      },
      {
        "periodo": 202601,
        "valor": 3.7479,
        "delta": 0.2674
      },
      {
        "periodo": 202602,
        "valor": 3.7918,
        "delta": 0.0438
      },
      {
        "periodo": 202603,
        "valor": 4.3109,
        "delta": 0.5192
      },
      {
        "periodo": 202604,
        "valor": 4.5941,
        "delta": 0.2832
      },
      {
        "periodo": 202605,
        "valor": 4.5237,
        "delta": -0.0704
      },
      {
        "periodo": 202606,
        "valor": 4.5651,
        "delta": 0.0414
      },
      {
        "periodo": 202607,
        "valor": 4.9064,
        "delta": 0.3413
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 2.895569,
    "valor_anterior": 2.8840060000000003,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.9544,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.9421,
        "delta": -0.0123
      },
      {
        "periodo": 202509,
        "valor": 3.9086,
        "delta": -0.0335
      },
      {
        "periodo": 202510,
        "valor": 3.906,
        "delta": -0.0026
      },
      {
        "periodo": 202511,
        "valor": 3.897,
        "delta": -0.009
      },
      {
        "periodo": 202512,
        "valor": 2.4421,
        "delta": -1.4548
      },
      {
        "periodo": 202601,
        "valor": 2.4665,
        "delta": 0.0244
      },
      {
        "periodo": 202602,
        "valor": 2.4887,
        "delta": 0.0222
      },
      {
        "periodo": 202603,
        "valor": 2.6001,
        "delta": 0.1113
      },
      {
        "periodo": 202604,
        "valor": 2.6136,
        "delta": 0.0136
      },
      {
        "periodo": 202605,
        "valor": 2.7694,
        "delta": 0.1558
      },
      {
        "periodo": 202606,
        "valor": 2.884,
        "delta": 0.1146
      },
      {
        "periodo": 202607,
        "valor": 2.8956,
        "delta": 0.0116
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 1.509006,
    "valor_anterior": 1.539806,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.1036,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.0782,
        "delta": -0.0254
      },
      {
        "periodo": 202509,
        "valor": 1.3713,
        "delta": 0.2931
      },
      {
        "periodo": 202510,
        "valor": 1.3854,
        "delta": 0.0141
      },
      {
        "periodo": 202511,
        "valor": 1.3973,
        "delta": 0.0119
      },
      {
        "periodo": 202512,
        "valor": 1.4086,
        "delta": 0.0113
      },
      {
        "periodo": 202601,
        "valor": 1.4605,
        "delta": 0.0519
      },
      {
        "periodo": 202602,
        "valor": 1.4706,
        "delta": 0.0101
      },
      {
        "periodo": 202603,
        "valor": 1.4485,
        "delta": -0.0221
      },
      {
        "periodo": 202604,
        "valor": 1.4732,
        "delta": 0.0247
      },
      {
        "periodo": 202605,
        "valor": 1.5228,
        "delta": 0.0496
      },
      {
        "periodo": 202606,
        "valor": 1.5398,
        "delta": 0.017
      },
      {
        "periodo": 202607,
        "valor": 1.509,
        "delta": -0.0308
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 0.9540130000000001,
    "valor_anterior": 0.9335019999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.4839,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.4745,
        "delta": -0.0094
      },
      {
        "periodo": 202509,
        "valor": 1.4694,
        "delta": -0.0051
      },
      {
        "periodo": 202510,
        "valor": 1.2883,
        "delta": -0.1811
      },
      {
        "periodo": 202511,
        "valor": 1.1653,
        "delta": -0.1231
      },
      {
        "periodo": 202512,
        "valor": 0.6704,
        "delta": -0.4948
      },
      {
        "periodo": 202601,
        "valor": 0.6516,
        "delta": -0.0188
      },
      {
        "periodo": 202602,
        "valor": 0.6959,
        "delta": 0.0443
      },
      {
        "periodo": 202603,
        "valor": 0.7079,
        "delta": 0.012
      },
      {
        "periodo": 202604,
        "valor": 0.8635,
        "delta": 0.1556
      },
      {
        "periodo": 202605,
        "valor": 0.929,
        "delta": 0.0655
      },
      {
        "periodo": 202606,
        "valor": 0.9335,
        "delta": 0.0045
      },
      {
        "periodo": 202607,
        "valor": 0.954,
        "delta": 0.0205
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 2.241195,
    "valor_anterior": 2.2201809999999997,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.8738,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.8955,
        "delta": 0.0217
      },
      {
        "periodo": 202509,
        "valor": 2.7593,
        "delta": -0.1362
      },
      {
        "periodo": 202510,
        "valor": 2.6802,
        "delta": -0.0791
      },
      {
        "periodo": 202511,
        "valor": 3.2065,
        "delta": 0.5263
      },
      {
        "periodo": 202512,
        "valor": 3.2867,
        "delta": 0.0802
      },
      {
        "periodo": 202601,
        "valor": 3.3391,
        "delta": 0.0524
      },
      {
        "periodo": 202602,
        "valor": 2.8954,
        "delta": -0.4437
      },
      {
        "periodo": 202603,
        "valor": 3.0155,
        "delta": 0.1201
      },
      {
        "periodo": 202604,
        "valor": 2.921,
        "delta": -0.0945
      },
      {
        "periodo": 202605,
        "valor": 2.84,
        "delta": -0.081
      },
      {
        "periodo": 202606,
        "valor": 2.2202,
        "delta": -0.6199
      },
      {
        "periodo": 202607,
        "valor": 2.2412,
        "delta": 0.021
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 1.476794,
    "valor_anterior": 1.55635,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.3504,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.3908,
        "delta": 0.0405
      },
      {
        "periodo": 202509,
        "valor": 1.4346,
        "delta": 0.0438
      },
      {
        "periodo": 202510,
        "valor": 1.4117,
        "delta": -0.0229
      },
      {
        "periodo": 202511,
        "valor": 1.433,
        "delta": 0.0213
      },
      {
        "periodo": 202512,
        "valor": 1.4358,
        "delta": 0.0029
      },
      {
        "periodo": 202601,
        "valor": 1.448,
        "delta": 0.0121
      },
      {
        "periodo": 202602,
        "valor": 1.5421,
        "delta": 0.0941
      },
      {
        "periodo": 202603,
        "valor": 1.4441,
        "delta": -0.0979
      },
      {
        "periodo": 202604,
        "valor": 1.5527,
        "delta": 0.1086
      },
      {
        "periodo": 202605,
        "valor": 1.5779,
        "delta": 0.0252
      },
      {
        "periodo": 202606,
        "valor": 1.5563,
        "delta": -0.0216
      },
      {
        "periodo": 202607,
        "valor": 1.4768,
        "delta": -0.0796
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 5.582099,
    "valor_anterior": 5.345396,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4.2295,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4.6628,
        "delta": 0.4333
      },
      {
        "periodo": 202509,
        "valor": 4.8728,
        "delta": 0.21
      },
      {
        "periodo": 202510,
        "valor": 5.6155,
        "delta": 0.7427
      },
      {
        "periodo": 202511,
        "valor": 6.12,
        "delta": 0.5045
      },
      {
        "periodo": 202512,
        "valor": 6.3487,
        "delta": 0.2287
      },
      {
        "periodo": 202601,
        "valor": 6.0476,
        "delta": -0.3011
      },
      {
        "periodo": 202602,
        "valor": 5.7813,
        "delta": -0.2663
      },
      {
        "periodo": 202603,
        "valor": 5.7421,
        "delta": -0.0392
      },
      {
        "periodo": 202604,
        "valor": 5.5591,
        "delta": -0.183
      },
      {
        "periodo": 202605,
        "valor": 5.4959,
        "delta": -0.0632
      },
      {
        "periodo": 202606,
        "valor": 5.3454,
        "delta": -0.1505
      },
      {
        "periodo": 202607,
        "valor": 5.5821,
        "delta": 0.2367
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 3.033296,
    "valor_anterior": 2.860478,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.2163,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.7157,
        "delta": -0.5006
      },
      {
        "periodo": 202509,
        "valor": 1.4502,
        "delta": -1.2655
      },
      {
        "periodo": 202510,
        "valor": 1.8355,
        "delta": 0.3853
      },
      {
        "periodo": 202511,
        "valor": 1.9534,
        "delta": 0.1178
      },
      {
        "periodo": 202512,
        "valor": 2.498,
        "delta": 0.5447
      },
      {
        "periodo": 202601,
        "valor": 3.0706,
        "delta": 0.5726
      },
      {
        "periodo": 202602,
        "valor": 2.9481,
        "delta": -0.1226
      },
      {
        "periodo": 202603,
        "valor": 2.8386,
        "delta": -0.1095
      },
      {
        "periodo": 202604,
        "valor": 2.8949,
        "delta": 0.0563
      },
      {
        "periodo": 202605,
        "valor": 3.2361,
        "delta": 0.3412
      },
      {
        "periodo": 202606,
        "valor": 2.8605,
        "delta": -0.3756
      },
      {
        "periodo": 202607,
        "valor": 3.0333,
        "delta": 0.1728
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 4.615982,
    "valor_anterior": 4.594709,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.185,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.2627,
        "delta": 0.0777
      },
      {
        "periodo": 202509,
        "valor": 3.5066,
        "delta": 0.2439
      },
      {
        "periodo": 202510,
        "valor": 3.5958,
        "delta": 0.0892
      },
      {
        "periodo": 202511,
        "valor": 3.6954,
        "delta": 0.0996
      },
      {
        "periodo": 202512,
        "valor": 4.2326,
        "delta": 0.5372
      },
      {
        "periodo": 202601,
        "valor": 4.4703,
        "delta": 0.2377
      },
      {
        "periodo": 202602,
        "valor": 4.8055,
        "delta": 0.3351
      },
      {
        "periodo": 202603,
        "valor": 4.8648,
        "delta": 0.0593
      },
      {
        "periodo": 202604,
        "valor": 4.7263,
        "delta": -0.1385
      },
      {
        "periodo": 202605,
        "valor": 4.8839,
        "delta": 0.1577
      },
      {
        "periodo": 202606,
        "valor": 4.5947,
        "delta": -0.2892
      },
      {
        "periodo": 202607,
        "valor": 4.616,
        "delta": 0.0213
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 2.178674,
    "valor_anterior": 2.214463,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.6201,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.5689,
        "delta": -0.0513
      },
      {
        "periodo": 202509,
        "valor": 2.6904,
        "delta": 0.1215
      },
      {
        "periodo": 202510,
        "valor": 2.6854,
        "delta": -0.005
      },
      {
        "periodo": 202511,
        "valor": 2.5557,
        "delta": -0.1297
      },
      {
        "periodo": 202512,
        "valor": 2.2057,
        "delta": -0.35
      },
      {
        "periodo": 202601,
        "valor": 2.3091,
        "delta": 0.1034
      },
      {
        "periodo": 202602,
        "valor": 1.9377,
        "delta": -0.3715
      },
      {
        "periodo": 202603,
        "valor": 1.8831,
        "delta": -0.0546
      },
      {
        "periodo": 202604,
        "valor": 2.1437,
        "delta": 0.2606
      },
      {
        "periodo": 202605,
        "valor": 2.3729,
        "delta": 0.2292
      },
      {
        "periodo": 202606,
        "valor": 2.2145,
        "delta": -0.1584
      },
      {
        "periodo": 202607,
        "valor": 2.1787,
        "delta": -0.0358
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 1.787727,
    "valor_anterior": 1.780704,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.3319,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.1307,
        "delta": -0.2012
      },
      {
        "periodo": 202509,
        "valor": 2.9741,
        "delta": -0.1566
      },
      {
        "periodo": 202510,
        "valor": 3.0916,
        "delta": 0.1175
      },
      {
        "periodo": 202511,
        "valor": 2.6409,
        "delta": -0.4507
      },
      {
        "periodo": 202512,
        "valor": 2.3415,
        "delta": -0.2994
      },
      {
        "periodo": 202601,
        "valor": 2.3764,
        "delta": 0.0349
      },
      {
        "periodo": 202602,
        "valor": 2.3667,
        "delta": -0.0098
      },
      {
        "periodo": 202603,
        "valor": 2.3428,
        "delta": -0.0239
      },
      {
        "periodo": 202604,
        "valor": 2.3531,
        "delta": 0.0103
      },
      {
        "periodo": 202605,
        "valor": 1.7589,
        "delta": -0.5942
      },
      {
        "periodo": 202606,
        "valor": 1.7807,
        "delta": 0.0218
      },
      {
        "periodo": 202607,
        "valor": 1.7877,
        "delta": 0.007
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 80.861756,
    "valor_anterior": 91.033967,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4.865,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7.0766,
        "delta": 2.2115
      },
      {
        "periodo": 202509,
        "valor": 57.075,
        "delta": 49.9985
      },
      {
        "periodo": 202510,
        "valor": 65.314,
        "delta": 8.239
      },
      {
        "periodo": 202511,
        "valor": 84.7872,
        "delta": 19.4732
      },
      {
        "periodo": 202512,
        "valor": 73.7194,
        "delta": -11.0677
      },
      {
        "periodo": 202601,
        "valor": 75.307,
        "delta": 1.5875
      },
      {
        "periodo": 202602,
        "valor": 70.0802,
        "delta": -5.2268
      },
      {
        "periodo": 202603,
        "valor": 91.3836,
        "delta": 21.3034
      },
      {
        "periodo": 202604,
        "valor": 91.2826,
        "delta": -0.101
      },
      {
        "periodo": 202605,
        "valor": 91.22,
        "delta": -0.0626
      },
      {
        "periodo": 202606,
        "valor": 91.034,
        "delta": -0.1861
      },
      {
        "periodo": 202607,
        "valor": 80.8618,
        "delta": -10.1722
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 6.067717999999999,
    "valor_anterior": 6.206864,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5.8811,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5.4085,
        "delta": -0.4726
      },
      {
        "periodo": 202509,
        "valor": 5.4978,
        "delta": 0.0893
      },
      {
        "periodo": 202510,
        "valor": 4.5012,
        "delta": -0.9966
      },
      {
        "periodo": 202511,
        "valor": 5.0035,
        "delta": 0.5023
      },
      {
        "periodo": 202512,
        "valor": 4.5056,
        "delta": -0.4979
      },
      {
        "periodo": 202601,
        "valor": 6.3291,
        "delta": 1.8235
      },
      {
        "periodo": 202602,
        "valor": 6.4334,
        "delta": 0.1044
      },
      {
        "periodo": 202603,
        "valor": 6.5284,
        "delta": 0.0949
      },
      {
        "periodo": 202604,
        "valor": 6.6988,
        "delta": 0.1704
      },
      {
        "periodo": 202605,
        "valor": 6.8689,
        "delta": 0.1701
      },
      {
        "periodo": 202606,
        "valor": 6.2069,
        "delta": -0.662
      },
      {
        "periodo": 202607,
        "valor": 6.0677,
        "delta": -0.1391
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 11.644229000000001,
    "valor_anterior": 11.18158,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16.6175,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16.5125,
        "delta": -0.105
      },
      {
        "periodo": 202509,
        "valor": 16.2686,
        "delta": -0.2439
      },
      {
        "periodo": 202510,
        "valor": 16.304,
        "delta": 0.0354
      },
      {
        "periodo": 202511,
        "valor": 15.0676,
        "delta": -1.2364
      },
      {
        "periodo": 202512,
        "valor": 15.5126,
        "delta": 0.4451
      },
      {
        "periodo": 202601,
        "valor": 15.1925,
        "delta": -0.3201
      },
      {
        "periodo": 202602,
        "valor": 14.6149,
        "delta": -0.5776
      },
      {
        "periodo": 202603,
        "valor": 12.5908,
        "delta": -2.0241
      },
      {
        "periodo": 202604,
        "valor": 11.6608,
        "delta": -0.9299
      },
      {
        "periodo": 202605,
        "valor": 10.6786,
        "delta": -0.9823
      },
      {
        "periodo": 202606,
        "valor": 11.1816,
        "delta": 0.503
      },
      {
        "periodo": 202607,
        "valor": 11.6442,
        "delta": 0.4626
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 1.609609,
    "valor_anterior": 1.459211,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.6181,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.5104,
        "delta": -0.1076
      },
      {
        "periodo": 202509,
        "valor": 1.4719,
        "delta": -0.0386
      },
      {
        "periodo": 202510,
        "valor": 1.5141,
        "delta": 0.0423
      },
      {
        "periodo": 202511,
        "valor": 1.5622,
        "delta": 0.048
      },
      {
        "periodo": 202512,
        "valor": 1.5836,
        "delta": 0.0214
      },
      {
        "periodo": 202601,
        "valor": 1.5042,
        "delta": -0.0793
      },
      {
        "periodo": 202602,
        "valor": 1.5335,
        "delta": 0.0293
      },
      {
        "periodo": 202603,
        "valor": 1.4034,
        "delta": -0.1301
      },
      {
        "periodo": 202604,
        "valor": 1.4555,
        "delta": 0.0521
      },
      {
        "periodo": 202605,
        "valor": 1.3836,
        "delta": -0.0719
      },
      {
        "periodo": 202606,
        "valor": 1.4592,
        "delta": 0.0756
      },
      {
        "periodo": 202607,
        "valor": 1.6096,
        "delta": 0.1504
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 1.7974219999999999,
    "valor_anterior": 1.6474900000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.0732,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.1171,
        "delta": 0.0439
      },
      {
        "periodo": 202509,
        "valor": 1.1618,
        "delta": 0.0447
      },
      {
        "periodo": 202510,
        "valor": 1.1974,
        "delta": 0.0356
      },
      {
        "periodo": 202511,
        "valor": 1.2557,
        "delta": 0.0583
      },
      {
        "periodo": 202512,
        "valor": 1.2677,
        "delta": 0.012
      },
      {
        "periodo": 202601,
        "valor": 1.2638,
        "delta": -0.0038
      },
      {
        "periodo": 202602,
        "valor": 1.2509,
        "delta": -0.013
      },
      {
        "periodo": 202603,
        "valor": 1.5916,
        "delta": 0.3407
      },
      {
        "periodo": 202604,
        "valor": 1.7131,
        "delta": 0.1215
      },
      {
        "periodo": 202605,
        "valor": 1.8974,
        "delta": 0.1843
      },
      {
        "periodo": 202606,
        "valor": 1.6475,
        "delta": -0.2499
      },
      {
        "periodo": 202607,
        "valor": 1.7974,
        "delta": 0.1499
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.3273,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.107,
        "delta": 4.7797
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 3.444796,
    "valor_anterior": 3.411721,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.1417,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.3503,
        "delta": 0.2086
      },
      {
        "periodo": 202509,
        "valor": 3.2163,
        "delta": -0.134
      },
      {
        "periodo": 202510,
        "valor": 3.3444,
        "delta": 0.1281
      },
      {
        "periodo": 202511,
        "valor": 3.3089,
        "delta": -0.0355
      },
      {
        "periodo": 202512,
        "valor": 3.3865,
        "delta": 0.0776
      },
      {
        "periodo": 202601,
        "valor": 3.356,
        "delta": -0.0305
      },
      {
        "periodo": 202602,
        "valor": 3.3589,
        "delta": 0.0028
      },
      {
        "periodo": 202603,
        "valor": 3.6207,
        "delta": 0.2619
      },
      {
        "periodo": 202604,
        "valor": 2.8657,
        "delta": -0.755
      },
      {
        "periodo": 202605,
        "valor": 3.3957,
        "delta": 0.53
      },
      {
        "periodo": 202606,
        "valor": 3.4117,
        "delta": 0.016
      },
      {
        "periodo": 202607,
        "valor": 3.4448,
        "delta": 0.0331
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 0.6217969999999999,
    "valor_anterior": 0.644687,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.8808,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.8456,
        "delta": -0.0351
      },
      {
        "periodo": 202509,
        "valor": 0.7822,
        "delta": -0.0635
      },
      {
        "periodo": 202510,
        "valor": 0.8531,
        "delta": 0.0709
      },
      {
        "periodo": 202511,
        "valor": 0.8097,
        "delta": -0.0434
      },
      {
        "periodo": 202512,
        "valor": 0.7806,
        "delta": -0.0291
      },
      {
        "periodo": 202601,
        "valor": 0.7372,
        "delta": -0.0434
      },
      {
        "periodo": 202602,
        "valor": 0.7053,
        "delta": -0.0319
      },
      {
        "periodo": 202603,
        "valor": 0.6793,
        "delta": -0.026
      },
      {
        "periodo": 202604,
        "valor": 0.658,
        "delta": -0.0213
      },
      {
        "periodo": 202605,
        "valor": 0.616,
        "delta": -0.042
      },
      {
        "periodo": 202606,
        "valor": 0.6447,
        "delta": 0.0287
      },
      {
        "periodo": 202607,
        "valor": 0.6218,
        "delta": -0.0229
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 13.897234,
    "valor_anterior": 12.895814999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.7036,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.4306,
        "delta": -1.273
      },
      {
        "periodo": 202509,
        "valor": 7.2776,
        "delta": -1.153
      },
      {
        "periodo": 202510,
        "valor": 6.8917,
        "delta": -0.3859
      },
      {
        "periodo": 202511,
        "valor": 7.0957,
        "delta": 0.204
      },
      {
        "periodo": 202512,
        "valor": 7.8579,
        "delta": 0.7622
      },
      {
        "periodo": 202601,
        "valor": 8.3473,
        "delta": 0.4894
      },
      {
        "periodo": 202602,
        "valor": 9.0413,
        "delta": 0.694
      },
      {
        "periodo": 202603,
        "valor": 9.4548,
        "delta": 0.4135
      },
      {
        "periodo": 202604,
        "valor": 10.4336,
        "delta": 0.9788
      },
      {
        "periodo": 202605,
        "valor": 11.9293,
        "delta": 1.4957
      },
      {
        "periodo": 202606,
        "valor": 12.8958,
        "delta": 0.9665
      },
      {
        "periodo": 202607,
        "valor": 13.8972,
        "delta": 1.0014
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 2.439906,
    "valor_anterior": 2.47796,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.8706,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.8254,
        "delta": -0.0452
      },
      {
        "periodo": 202509,
        "valor": 2.7589,
        "delta": -0.0664
      },
      {
        "periodo": 202510,
        "valor": 2.7419,
        "delta": -0.0171
      },
      {
        "periodo": 202511,
        "valor": 2.728,
        "delta": -0.0139
      },
      {
        "periodo": 202512,
        "valor": 2.3815,
        "delta": -0.3465
      },
      {
        "periodo": 202601,
        "valor": 2.3509,
        "delta": -0.0306
      },
      {
        "periodo": 202602,
        "valor": 2.3528,
        "delta": 0.0019
      },
      {
        "periodo": 202603,
        "valor": 2.3211,
        "delta": -0.0317
      },
      {
        "periodo": 202604,
        "valor": 2.4841,
        "delta": 0.163
      },
      {
        "periodo": 202605,
        "valor": 2.444,
        "delta": -0.0401
      },
      {
        "periodo": 202606,
        "valor": 2.478,
        "delta": 0.034
      },
      {
        "periodo": 202607,
        "valor": 2.4399,
        "delta": -0.0381
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 0.25622,
    "valor_anterior": 0.270044,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.1978,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.2073,
        "delta": 0.0095
      },
      {
        "periodo": 202509,
        "valor": 0.2145,
        "delta": 0.0072
      },
      {
        "periodo": 202510,
        "valor": 0.2194,
        "delta": 0.0049
      },
      {
        "periodo": 202511,
        "valor": 0.2229,
        "delta": 0.0036
      },
      {
        "periodo": 202512,
        "valor": 0.2179,
        "delta": -0.005
      },
      {
        "periodo": 202601,
        "valor": 0.2351,
        "delta": 0.0172
      },
      {
        "periodo": 202602,
        "valor": 0.2383,
        "delta": 0.0032
      },
      {
        "periodo": 202603,
        "valor": 0.2363,
        "delta": -0.002
      },
      {
        "periodo": 202604,
        "valor": 0.2383,
        "delta": 0.002
      },
      {
        "periodo": 202605,
        "valor": 0.2525,
        "delta": 0.0142
      },
      {
        "periodo": 202606,
        "valor": 0.27,
        "delta": 0.0175
      },
      {
        "periodo": 202607,
        "valor": 0.2562,
        "delta": -0.0138
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 2.8549,
    "valor_anterior": 2.857815,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.0352,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.1352,
        "delta": 1.1
      },
      {
        "periodo": 202509,
        "valor": 2.1386,
        "delta": 0.0034
      },
      {
        "periodo": 202510,
        "valor": 2.0789,
        "delta": -0.0597
      },
      {
        "periodo": 202511,
        "valor": 1.9756,
        "delta": -0.1032
      },
      {
        "periodo": 202512,
        "valor": 1.9017,
        "delta": -0.0739
      },
      {
        "periodo": 202601,
        "valor": 2.7079,
        "delta": 0.8062
      },
      {
        "periodo": 202602,
        "valor": 2.7036,
        "delta": -0.0043
      },
      {
        "periodo": 202603,
        "valor": 2.6465,
        "delta": -0.0571
      },
      {
        "periodo": 202604,
        "valor": 2.6376,
        "delta": -0.0089
      },
      {
        "periodo": 202605,
        "valor": 2.818,
        "delta": 0.1804
      },
      {
        "periodo": 202606,
        "valor": 2.8578,
        "delta": 0.0398
      },
      {
        "periodo": 202607,
        "valor": 2.8549,
        "delta": -0.0029
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 4.760045,
    "valor_anterior": 4.91779,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5.123,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5.1183,
        "delta": -0.0048
      },
      {
        "periodo": 202509,
        "valor": 5.2333,
        "delta": 0.1151
      },
      {
        "periodo": 202510,
        "valor": 5.2489,
        "delta": 0.0156
      },
      {
        "periodo": 202511,
        "valor": 5.2315,
        "delta": -0.0174
      },
      {
        "periodo": 202512,
        "valor": 5.3947,
        "delta": 0.1632
      },
      {
        "periodo": 202601,
        "valor": 5.8997,
        "delta": 0.505
      },
      {
        "periodo": 202602,
        "valor": 5.5784,
        "delta": -0.3213
      },
      {
        "periodo": 202603,
        "valor": 5.4989,
        "delta": -0.0794
      },
      {
        "periodo": 202604,
        "valor": 5.3977,
        "delta": -0.1012
      },
      {
        "periodo": 202605,
        "valor": 5.3242,
        "delta": -0.0736
      },
      {
        "periodo": 202606,
        "valor": 4.9178,
        "delta": -0.4064
      },
      {
        "periodo": 202607,
        "valor": 4.76,
        "delta": -0.1577
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 4.555698,
    "valor_anterior": 4.499225,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 1.211,
        "delta": 1.211
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -1.211
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 5.2823,
        "delta": 5.2823
      },
      {
        "periodo": 202605,
        "valor": 5.0007,
        "delta": -0.2816
      },
      {
        "periodo": 202606,
        "valor": 4.4992,
        "delta": -0.5015
      },
      {
        "periodo": 202607,
        "valor": 4.5557,
        "delta": 0.0565
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 2.0546100000000003,
    "valor_anterior": 2.096162,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.2519,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.037,
        "delta": -0.2149
      },
      {
        "periodo": 202509,
        "valor": 1.8836,
        "delta": -0.1534
      },
      {
        "periodo": 202510,
        "valor": 1.8076,
        "delta": -0.076
      },
      {
        "periodo": 202511,
        "valor": 1.7934,
        "delta": -0.0142
      },
      {
        "periodo": 202512,
        "valor": 1.7223,
        "delta": -0.0711
      },
      {
        "periodo": 202601,
        "valor": 1.9456,
        "delta": 0.2233
      },
      {
        "periodo": 202602,
        "valor": 1.8916,
        "delta": -0.054
      },
      {
        "periodo": 202603,
        "valor": 1.9692,
        "delta": 0.0776
      },
      {
        "periodo": 202604,
        "valor": 1.9904,
        "delta": 0.0211
      },
      {
        "periodo": 202605,
        "valor": 1.9995,
        "delta": 0.0091
      },
      {
        "periodo": 202606,
        "valor": 2.0962,
        "delta": 0.0967
      },
      {
        "periodo": 202607,
        "valor": 2.0546,
        "delta": -0.0416
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 0.557891,
    "valor_anterior": 1.223125,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.2231,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.2405,
        "delta": 0.0174
      },
      {
        "periodo": 202509,
        "valor": 1.2793,
        "delta": 0.0388
      },
      {
        "periodo": 202510,
        "valor": 1.3617,
        "delta": 0.0824
      },
      {
        "periodo": 202511,
        "valor": 1.3575,
        "delta": -0.0043
      },
      {
        "periodo": 202512,
        "valor": 1.3838,
        "delta": 0.0264
      },
      {
        "periodo": 202601,
        "valor": 1.4453,
        "delta": 0.0615
      },
      {
        "periodo": 202602,
        "valor": 1.4667,
        "delta": 0.0214
      },
      {
        "periodo": 202603,
        "valor": 1.436,
        "delta": -0.0307
      },
      {
        "periodo": 202604,
        "valor": 1.2369,
        "delta": -0.199
      },
      {
        "periodo": 202605,
        "valor": 1.2925,
        "delta": 0.0555
      },
      {
        "periodo": 202606,
        "valor": 1.2231,
        "delta": -0.0693
      },
      {
        "periodo": 202607,
        "valor": 0.5579,
        "delta": -0.6652
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 1.165456,
    "valor_anterior": 1.2419090000000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.3688,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4.2112,
        "delta": 0.8425
      },
      {
        "periodo": 202509,
        "valor": 4.2182,
        "delta": 0.0069
      },
      {
        "periodo": 202510,
        "valor": 2.1024,
        "delta": -2.1158
      },
      {
        "periodo": 202511,
        "valor": 2.1412,
        "delta": 0.0388
      },
      {
        "periodo": 202512,
        "valor": 2.1989,
        "delta": 0.0577
      },
      {
        "periodo": 202601,
        "valor": 2.094,
        "delta": -0.1049
      },
      {
        "periodo": 202602,
        "valor": 1.9152,
        "delta": -0.1787
      },
      {
        "periodo": 202603,
        "valor": 1.5523,
        "delta": -0.363
      },
      {
        "periodo": 202604,
        "valor": 1.4138,
        "delta": -0.1384
      },
      {
        "periodo": 202605,
        "valor": 1.3982,
        "delta": -0.0156
      },
      {
        "periodo": 202606,
        "valor": 1.2419,
        "delta": -0.1563
      },
      {
        "periodo": 202607,
        "valor": 1.1655,
        "delta": -0.0765
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 1.70325,
    "valor_anterior": 1.7014789999999997,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.4856,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.6,
        "delta": 0.1144
      },
      {
        "periodo": 202509,
        "valor": 1.6427,
        "delta": 0.0427
      },
      {
        "periodo": 202510,
        "valor": 1.6317,
        "delta": -0.011
      },
      {
        "periodo": 202511,
        "valor": 1.6015,
        "delta": -0.0303
      },
      {
        "periodo": 202512,
        "valor": 1.6464,
        "delta": 0.0449
      },
      {
        "periodo": 202601,
        "valor": 1.7107,
        "delta": 0.0643
      },
      {
        "periodo": 202602,
        "valor": 1.7432,
        "delta": 0.0325
      },
      {
        "periodo": 202603,
        "valor": 1.704,
        "delta": -0.0392
      },
      {
        "periodo": 202604,
        "valor": 1.7431,
        "delta": 0.0391
      },
      {
        "periodo": 202605,
        "valor": 1.8048,
        "delta": 0.0617
      },
      {
        "periodo": 202606,
        "valor": 1.7015,
        "delta": -0.1033
      },
      {
        "periodo": 202607,
        "valor": 1.7032,
        "delta": 0.0018
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 12.647812,
    "valor_anterior": 18.132376,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 41.1567,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 42.7102,
        "delta": 1.5535
      },
      {
        "periodo": 202509,
        "valor": 37.7336,
        "delta": -4.9766
      },
      {
        "periodo": 202510,
        "valor": 35.421,
        "delta": -2.3126
      },
      {
        "periodo": 202511,
        "valor": 27.9929,
        "delta": -7.4281
      },
      {
        "periodo": 202512,
        "valor": 25.2438,
        "delta": -2.7491
      },
      {
        "periodo": 202601,
        "valor": 21.1656,
        "delta": -4.0782
      },
      {
        "periodo": 202602,
        "valor": 23.4644,
        "delta": 2.2988
      },
      {
        "periodo": 202603,
        "valor": 22.5051,
        "delta": -0.9593
      },
      {
        "periodo": 202604,
        "valor": 18.2537,
        "delta": -4.2515
      },
      {
        "periodo": 202605,
        "valor": 18.5546,
        "delta": 0.3009
      },
      {
        "periodo": 202606,
        "valor": 18.1324,
        "delta": -0.4222
      },
      {
        "periodo": 202607,
        "valor": 12.6478,
        "delta": -5.4846
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 1.79692,
    "valor_anterior": 1.663895,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.6002,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 1.5415,
        "delta": -0.0587
      },
      {
        "periodo": 202604,
        "valor": 1.5618,
        "delta": 0.0203
      },
      {
        "periodo": 202605,
        "valor": 1.7065,
        "delta": 0.1447
      },
      {
        "periodo": 202606,
        "valor": 1.6639,
        "delta": -0.0427
      },
      {
        "periodo": 202607,
        "valor": 1.7969,
        "delta": 0.133
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 11.510054,
    "valor_anterior": 11.469899,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.9095,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.3362,
        "delta": 1.4267
      },
      {
        "periodo": 202509,
        "valor": 4.4823,
        "delta": 2.1461
      },
      {
        "periodo": 202510,
        "valor": 9.773,
        "delta": 5.2907
      },
      {
        "periodo": 202511,
        "valor": 14.5878,
        "delta": 4.8148
      },
      {
        "periodo": 202512,
        "valor": 14.8921,
        "delta": 0.3042
      },
      {
        "periodo": 202601,
        "valor": 14.1012,
        "delta": -0.7909
      },
      {
        "periodo": 202602,
        "valor": 10.7493,
        "delta": -3.3519
      },
      {
        "periodo": 202603,
        "valor": 9.2894,
        "delta": -1.4599
      },
      {
        "periodo": 202604,
        "valor": 10.0989,
        "delta": 0.8095
      },
      {
        "periodo": 202605,
        "valor": 11.2574,
        "delta": 1.1585
      },
      {
        "periodo": 202606,
        "valor": 11.4699,
        "delta": 0.2125
      },
      {
        "periodo": 202607,
        "valor": 11.5101,
        "delta": 0.0402
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 0.212511,
    "valor_anterior": 0.179112,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0161,
        "delta": 0.0161
      },
      {
        "periodo": 202604,
        "valor": 0.0106,
        "delta": -0.0055
      },
      {
        "periodo": 202605,
        "valor": 0.1895,
        "delta": 0.1789
      },
      {
        "periodo": 202606,
        "valor": 0.1791,
        "delta": -0.0104
      },
      {
        "periodo": 202607,
        "valor": 0.2125,
        "delta": 0.0334
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 6.170716,
    "valor_anterior": 5.022928,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 4.741,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 6.0304,
        "delta": 1.2894
      },
      {
        "periodo": 202605,
        "valor": 7.4127,
        "delta": 1.3823
      },
      {
        "periodo": 202606,
        "valor": 5.0229,
        "delta": -2.3898
      },
      {
        "periodo": 202607,
        "valor": 6.1707,
        "delta": 1.1478
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 2.310653,
    "valor_anterior": 2.303614,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.1255,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.1598,
        "delta": 0.0343
      },
      {
        "periodo": 202509,
        "valor": 2.2481,
        "delta": 0.0884
      },
      {
        "periodo": 202510,
        "valor": 2.2651,
        "delta": 0.017
      },
      {
        "periodo": 202511,
        "valor": 2.2509,
        "delta": -0.0142
      },
      {
        "periodo": 202512,
        "valor": 2.1771,
        "delta": -0.0739
      },
      {
        "periodo": 202601,
        "valor": 2.2247,
        "delta": 0.0477
      },
      {
        "periodo": 202602,
        "valor": 2.2215,
        "delta": -0.0032
      },
      {
        "periodo": 202603,
        "valor": 2.2026,
        "delta": -0.0189
      },
      {
        "periodo": 202604,
        "valor": 2.2627,
        "delta": 0.0602
      },
      {
        "periodo": 202605,
        "valor": 2.3194,
        "delta": 0.0566
      },
      {
        "periodo": 202606,
        "valor": 2.3036,
        "delta": -0.0157
      },
      {
        "periodo": 202607,
        "valor": 2.3107,
        "delta": 0.007
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 2.20363,
    "valor_anterior": 2.203172,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.0245,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.0385,
        "delta": 0.014
      },
      {
        "periodo": 202509,
        "valor": 2.1384,
        "delta": 0.0999
      },
      {
        "periodo": 202510,
        "valor": 2.147,
        "delta": 0.0086
      },
      {
        "periodo": 202511,
        "valor": 2.1067,
        "delta": -0.0403
      },
      {
        "periodo": 202512,
        "valor": 2.0784,
        "delta": -0.0283
      },
      {
        "periodo": 202601,
        "valor": 2.1022,
        "delta": 0.0238
      },
      {
        "periodo": 202602,
        "valor": 2.1057,
        "delta": 0.0035
      },
      {
        "periodo": 202603,
        "valor": 2.0838,
        "delta": -0.0219
      },
      {
        "periodo": 202604,
        "valor": 2.1381,
        "delta": 0.0543
      },
      {
        "periodo": 202605,
        "valor": 2.1952,
        "delta": 0.0572
      },
      {
        "periodo": 202606,
        "valor": 2.2032,
        "delta": 0.0079
      },
      {
        "periodo": 202607,
        "valor": 2.2036,
        "delta": 0.0005
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 1.5944289999999999,
    "valor_anterior": 2.034328,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.5878,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.1247,
        "delta": 0.5368
      },
      {
        "periodo": 202509,
        "valor": 3.1932,
        "delta": 0.0686
      },
      {
        "periodo": 202510,
        "valor": 3.2166,
        "delta": 0.0233
      },
      {
        "periodo": 202511,
        "valor": 3.0808,
        "delta": -0.1357
      },
      {
        "periodo": 202512,
        "valor": 1.9124,
        "delta": -1.1685
      },
      {
        "periodo": 202601,
        "valor": 1.865,
        "delta": -0.0474
      },
      {
        "periodo": 202602,
        "valor": 1.8294,
        "delta": -0.0356
      },
      {
        "periodo": 202603,
        "valor": 1.8812,
        "delta": 0.0518
      },
      {
        "periodo": 202604,
        "valor": 1.9064,
        "delta": 0.0252
      },
      {
        "periodo": 202605,
        "valor": 2.0421,
        "delta": 0.1357
      },
      {
        "periodo": 202606,
        "valor": 2.0343,
        "delta": -0.0078
      },
      {
        "periodo": 202607,
        "valor": 1.5944,
        "delta": -0.4399
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 1.621066,
    "valor_anterior": 1.660298,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.6758,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.7173,
        "delta": 0.0416
      },
      {
        "periodo": 202509,
        "valor": 1.7341,
        "delta": 0.0168
      },
      {
        "periodo": 202510,
        "valor": 1.7441,
        "delta": 0.0101
      },
      {
        "periodo": 202511,
        "valor": 1.7847,
        "delta": 0.0405
      },
      {
        "periodo": 202512,
        "valor": 1.5073,
        "delta": -0.2773
      },
      {
        "periodo": 202601,
        "valor": 1.5967,
        "delta": 0.0894
      },
      {
        "periodo": 202602,
        "valor": 1.6442,
        "delta": 0.0475
      },
      {
        "periodo": 202603,
        "valor": 1.52,
        "delta": -0.1243
      },
      {
        "periodo": 202604,
        "valor": 1.5862,
        "delta": 0.0663
      },
      {
        "periodo": 202605,
        "valor": 1.6464,
        "delta": 0.0602
      },
      {
        "periodo": 202606,
        "valor": 1.6603,
        "delta": 0.0139
      },
      {
        "periodo": 202607,
        "valor": 1.6211,
        "delta": -0.0392
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 1.969126,
    "valor_anterior": 1.9496719999999998,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.0701,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.0703,
        "delta": 0.0002
      },
      {
        "periodo": 202509,
        "valor": 2.146,
        "delta": 0.0757
      },
      {
        "periodo": 202510,
        "valor": 2.1287,
        "delta": -0.0173
      },
      {
        "periodo": 202511,
        "valor": 2.1104,
        "delta": -0.0183
      },
      {
        "periodo": 202512,
        "valor": 1.7871,
        "delta": -0.3233
      },
      {
        "periodo": 202601,
        "valor": 1.8217,
        "delta": 0.0346
      },
      {
        "periodo": 202602,
        "valor": 1.7895,
        "delta": -0.0322
      },
      {
        "periodo": 202603,
        "valor": 1.7986,
        "delta": 0.009
      },
      {
        "periodo": 202604,
        "valor": 1.9302,
        "delta": 0.1316
      },
      {
        "periodo": 202605,
        "valor": 1.9876,
        "delta": 0.0574
      },
      {
        "periodo": 202606,
        "valor": 1.9497,
        "delta": -0.038
      },
      {
        "periodo": 202607,
        "valor": 1.9691,
        "delta": 0.0195
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 2.732784,
    "valor_anterior": 2.68575,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.3703,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.5806,
        "delta": 0.2103
      },
      {
        "periodo": 202509,
        "valor": 2.4227,
        "delta": -0.1579
      },
      {
        "periodo": 202510,
        "valor": 2.4379,
        "delta": 0.0152
      },
      {
        "periodo": 202511,
        "valor": 2.3792,
        "delta": -0.0588
      },
      {
        "periodo": 202512,
        "valor": 2.3583,
        "delta": -0.0209
      },
      {
        "periodo": 202601,
        "valor": 2.7227,
        "delta": 0.3644
      },
      {
        "periodo": 202602,
        "valor": 2.6536,
        "delta": -0.0691
      },
      {
        "periodo": 202603,
        "valor": 2.672,
        "delta": 0.0185
      },
      {
        "periodo": 202604,
        "valor": 2.7856,
        "delta": 0.1136
      },
      {
        "periodo": 202605,
        "valor": 2.7616,
        "delta": -0.0241
      },
      {
        "periodo": 202606,
        "valor": 2.6858,
        "delta": -0.0758
      },
      {
        "periodo": 202607,
        "valor": 2.7328,
        "delta": 0.047
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200017,
    "label": "IMOR",
    "valor_actual": 5.077461,
    "valor_anterior": 4.921149,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4.1012,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4.2765,
        "delta": 0.1753
      },
      {
        "periodo": 202509,
        "valor": 4.4385,
        "delta": 0.162
      },
      {
        "periodo": 202510,
        "valor": 4.6503,
        "delta": 0.2117
      },
      {
        "periodo": 202511,
        "valor": 5.0447,
        "delta": 0.3944
      },
      {
        "periodo": 202512,
        "valor": 5.1498,
        "delta": 0.1051
      },
      {
        "periodo": 202601,
        "valor": 5.4038,
        "delta": 0.254
      },
      {
        "periodo": 202602,
        "valor": 5.2352,
        "delta": -0.1685
      },
      {
        "periodo": 202603,
        "valor": 5.2101,
        "delta": -0.0252
      },
      {
        "periodo": 202604,
        "valor": 5.1738,
        "delta": -0.0362
      },
      {
        "periodo": 202605,
        "valor": 5.2601,
        "delta": 0.0863
      },
      {
        "periodo": 202606,
        "valor": 4.9211,
        "delta": -0.339
      },
      {
        "periodo": 202607,
        "valor": 5.0775,
        "delta": 0.1563
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 66.292025,
    "valor_anterior": 66.938577,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 72.5091,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 74.2105,
        "delta": 1.7013
      },
      {
        "periodo": 202509,
        "valor": 71.3469,
        "delta": -2.8636
      },
      {
        "periodo": 202510,
        "valor": 71.8811,
        "delta": 0.5343
      },
      {
        "periodo": 202511,
        "valor": 70.6498,
        "delta": -1.2313
      },
      {
        "periodo": 202512,
        "valor": 67.775,
        "delta": -2.8748
      },
      {
        "periodo": 202601,
        "valor": 67.4582,
        "delta": -0.3168
      },
      {
        "periodo": 202602,
        "valor": 67.7996,
        "delta": 0.3414
      },
      {
        "periodo": 202603,
        "valor": 63.9735,
        "delta": -3.826
      },
      {
        "periodo": 202604,
        "valor": 64.876,
        "delta": 0.9025
      },
      {
        "periodo": 202605,
        "valor": 71.3418,
        "delta": 6.4658
      },
      {
        "periodo": 202606,
        "valor": 66.9386,
        "delta": -4.4032
      },
      {
        "periodo": 202607,
        "valor": 66.292,
        "delta": -0.6466
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 26.08321,
    "valor_anterior": 25.362021000000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28.536,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28.5629,
        "delta": 0.0269
      },
      {
        "periodo": 202509,
        "valor": 28.0249,
        "delta": -0.538
      },
      {
        "periodo": 202510,
        "valor": 24.32,
        "delta": -3.7049
      },
      {
        "periodo": 202511,
        "valor": 23.7609,
        "delta": -0.5591
      },
      {
        "periodo": 202512,
        "valor": 28.017,
        "delta": 4.2561
      },
      {
        "periodo": 202601,
        "valor": 24.0676,
        "delta": -3.9494
      },
      {
        "periodo": 202602,
        "valor": 26.349,
        "delta": 2.2814
      },
      {
        "periodo": 202603,
        "valor": 25.9229,
        "delta": -0.4261
      },
      {
        "periodo": 202604,
        "valor": 27.155,
        "delta": 1.2321
      },
      {
        "periodo": 202605,
        "valor": 25.2344,
        "delta": -1.9206
      },
      {
        "periodo": 202606,
        "valor": 25.362,
        "delta": 0.1276
      },
      {
        "periodo": 202607,
        "valor": 26.0832,
        "delta": 0.7212
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 25.903883,
    "valor_anterior": 27.281367,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 38.4973,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 33.84,
        "delta": -4.6573
      },
      {
        "periodo": 202509,
        "valor": 32.6548,
        "delta": -1.1852
      },
      {
        "periodo": 202510,
        "valor": 26.1691,
        "delta": -6.4857
      },
      {
        "periodo": 202511,
        "valor": 37.8261,
        "delta": 11.6569
      },
      {
        "periodo": 202512,
        "valor": 35.6549,
        "delta": -2.1712
      },
      {
        "periodo": 202601,
        "valor": 29.1214,
        "delta": -6.5335
      },
      {
        "periodo": 202602,
        "valor": 27.5671,
        "delta": -1.5543
      },
      {
        "periodo": 202603,
        "valor": 26.5712,
        "delta": -0.9958
      },
      {
        "periodo": 202604,
        "valor": 25.3804,
        "delta": -1.1908
      },
      {
        "periodo": 202605,
        "valor": 8.4863,
        "delta": -16.8942
      },
      {
        "periodo": 202606,
        "valor": 27.2814,
        "delta": 18.7951
      },
      {
        "periodo": 202607,
        "valor": 25.9039,
        "delta": -1.3775
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 35.152266999999995,
    "valor_anterior": 38.961889,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 36.5622,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 34.1826,
        "delta": -2.3795
      },
      {
        "periodo": 202509,
        "valor": 34.7086,
        "delta": 0.526
      },
      {
        "periodo": 202510,
        "valor": 31.3701,
        "delta": -3.3385
      },
      {
        "periodo": 202511,
        "valor": 44.0736,
        "delta": 12.7034
      },
      {
        "periodo": 202512,
        "valor": 42.699,
        "delta": -1.3745
      },
      {
        "periodo": 202601,
        "valor": 40.0971,
        "delta": -2.6019
      },
      {
        "periodo": 202602,
        "valor": 41.0762,
        "delta": 0.979
      },
      {
        "periodo": 202603,
        "valor": 39.1341,
        "delta": -1.9421
      },
      {
        "periodo": 202604,
        "valor": 38.6995,
        "delta": -0.4346
      },
      {
        "periodo": 202605,
        "valor": 28.526,
        "delta": -10.1735
      },
      {
        "periodo": 202606,
        "valor": 38.9619,
        "delta": 10.4359
      },
      {
        "periodo": 202607,
        "valor": 35.1523,
        "delta": -3.8096
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 31.716825,
    "valor_anterior": 26.657837,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21.6088,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21.4743,
        "delta": -0.1345
      },
      {
        "periodo": 202509,
        "valor": 22.6639,
        "delta": 1.1895
      },
      {
        "periodo": 202510,
        "valor": 22.8155,
        "delta": 0.1516
      },
      {
        "periodo": 202511,
        "valor": 22.4641,
        "delta": -0.3514
      },
      {
        "periodo": 202512,
        "valor": 33.3489,
        "delta": 10.8849
      },
      {
        "periodo": 202601,
        "valor": 30.7403,
        "delta": -2.6087
      },
      {
        "periodo": 202602,
        "valor": 22.6794,
        "delta": -8.0609
      },
      {
        "periodo": 202603,
        "valor": 27.404,
        "delta": 4.7247
      },
      {
        "periodo": 202604,
        "valor": 27.2152,
        "delta": -0.1888
      },
      {
        "periodo": 202605,
        "valor": 24.4974,
        "delta": -2.7179
      },
      {
        "periodo": 202606,
        "valor": 26.6578,
        "delta": 2.1605
      },
      {
        "periodo": 202607,
        "valor": 31.7168,
        "delta": 5.059
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 40.090475,
    "valor_anterior": 37.477225,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 42.5316,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 40.5867,
        "delta": -1.9449
      },
      {
        "periodo": 202509,
        "valor": 39.7694,
        "delta": -0.8173
      },
      {
        "periodo": 202510,
        "valor": 40.7853,
        "delta": 1.0159
      },
      {
        "periodo": 202511,
        "valor": 38.9564,
        "delta": -1.8289
      },
      {
        "periodo": 202512,
        "valor": 43.7232,
        "delta": 4.7668
      },
      {
        "periodo": 202601,
        "valor": 42.8994,
        "delta": -0.8238
      },
      {
        "periodo": 202602,
        "valor": 41.1321,
        "delta": -1.7673
      },
      {
        "periodo": 202603,
        "valor": 39.7811,
        "delta": -1.351
      },
      {
        "periodo": 202604,
        "valor": 37.8409,
        "delta": -1.9402
      },
      {
        "periodo": 202605,
        "valor": 39.8959,
        "delta": 2.055
      },
      {
        "periodo": 202606,
        "valor": 37.4772,
        "delta": -2.4187
      },
      {
        "periodo": 202607,
        "valor": 40.0905,
        "delta": 2.6133
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 46.863705,
    "valor_anterior": 52.05210700000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 57.1301,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 53.9828,
        "delta": -3.1472
      },
      {
        "periodo": 202509,
        "valor": 54.2059,
        "delta": 0.2231
      },
      {
        "periodo": 202510,
        "valor": 52.0862,
        "delta": -2.1197
      },
      {
        "periodo": 202511,
        "valor": 54.6945,
        "delta": 2.6083
      },
      {
        "periodo": 202512,
        "valor": 59.8879,
        "delta": 5.1933
      },
      {
        "periodo": 202601,
        "valor": 59.6519,
        "delta": -0.236
      },
      {
        "periodo": 202602,
        "valor": 55.2694,
        "delta": -4.3825
      },
      {
        "periodo": 202603,
        "valor": 51.316,
        "delta": -3.9534
      },
      {
        "periodo": 202604,
        "valor": 52.6339,
        "delta": 1.3179
      },
      {
        "periodo": 202605,
        "valor": 58.3449,
        "delta": 5.711
      },
      {
        "periodo": 202606,
        "valor": 52.0521,
        "delta": -6.2928
      },
      {
        "periodo": 202607,
        "valor": 46.8637,
        "delta": -5.1884
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 48.612234,
    "valor_anterior": 46.922376,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 47.2549,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 46.9198,
        "delta": -0.3351
      },
      {
        "periodo": 202509,
        "valor": 44.9119,
        "delta": -2.0078
      },
      {
        "periodo": 202510,
        "valor": 47.8743,
        "delta": 2.9624
      },
      {
        "periodo": 202511,
        "valor": 44.4517,
        "delta": -3.4226
      },
      {
        "periodo": 202512,
        "valor": 46.6327,
        "delta": 2.181
      },
      {
        "periodo": 202601,
        "valor": 44.8472,
        "delta": -1.7855
      },
      {
        "periodo": 202602,
        "valor": 47.8238,
        "delta": 2.9766
      },
      {
        "periodo": 202603,
        "valor": 43.3671,
        "delta": -4.4567
      },
      {
        "periodo": 202604,
        "valor": 46.273,
        "delta": 2.9059
      },
      {
        "periodo": 202605,
        "valor": 48.5765,
        "delta": 2.3036
      },
      {
        "periodo": 202606,
        "valor": 46.9224,
        "delta": -1.6542
      },
      {
        "periodo": 202607,
        "valor": 48.6122,
        "delta": 1.6899
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 35.55187,
    "valor_anterior": 39.934177999999996,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40.7303,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 36.3116,
        "delta": -4.4187
      },
      {
        "periodo": 202509,
        "valor": 42.1196,
        "delta": 5.808
      },
      {
        "periodo": 202510,
        "valor": 35.5543,
        "delta": -6.5653
      },
      {
        "periodo": 202511,
        "valor": 38.9746,
        "delta": 3.4204
      },
      {
        "periodo": 202512,
        "valor": 44.383,
        "delta": 5.4084
      },
      {
        "periodo": 202601,
        "valor": 32.7741,
        "delta": -11.6089
      },
      {
        "periodo": 202602,
        "valor": 45.7521,
        "delta": 12.978
      },
      {
        "periodo": 202603,
        "valor": 48.5252,
        "delta": 2.7731
      },
      {
        "periodo": 202604,
        "valor": 37.9409,
        "delta": -10.5843
      },
      {
        "periodo": 202605,
        "valor": 38.2188,
        "delta": 0.2778
      },
      {
        "periodo": 202606,
        "valor": 39.9342,
        "delta": 1.7154
      },
      {
        "periodo": 202607,
        "valor": 35.5519,
        "delta": -4.3823
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 102.09621499999999,
    "valor_anterior": 176.566559,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 285.7475,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 176.6135,
        "delta": -109.134
      },
      {
        "periodo": 202509,
        "valor": 178.3827,
        "delta": 1.7692
      },
      {
        "periodo": 202510,
        "valor": 167.0782,
        "delta": -11.3045
      },
      {
        "periodo": 202511,
        "valor": 163.9479,
        "delta": -3.1303
      },
      {
        "periodo": 202512,
        "valor": 219.2581,
        "delta": 55.3102
      },
      {
        "periodo": 202601,
        "valor": 250.2529,
        "delta": 30.9948
      },
      {
        "periodo": 202602,
        "valor": 260.0319,
        "delta": 9.7789
      },
      {
        "periodo": 202603,
        "valor": 193.4828,
        "delta": -66.5491
      },
      {
        "periodo": 202604,
        "valor": 254.4331,
        "delta": 60.9504
      },
      {
        "periodo": 202605,
        "valor": 87.282,
        "delta": -167.1511
      },
      {
        "periodo": 202606,
        "valor": 176.5666,
        "delta": 89.2845
      },
      {
        "periodo": 202607,
        "valor": 102.0962,
        "delta": -74.4703
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 167.383589,
    "valor_anterior": 174.50661599999998,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 154.5776,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 139.7628,
        "delta": -14.8148
      },
      {
        "periodo": 202509,
        "valor": 153.8513,
        "delta": 14.0885
      },
      {
        "periodo": 202510,
        "valor": 161.9217,
        "delta": 8.0704
      },
      {
        "periodo": 202511,
        "valor": 151.3765,
        "delta": -10.5452
      },
      {
        "periodo": 202512,
        "valor": 175.218,
        "delta": 23.8414
      },
      {
        "periodo": 202601,
        "valor": 168.1193,
        "delta": -7.0986
      },
      {
        "periodo": 202602,
        "valor": 151.2683,
        "delta": -16.851
      },
      {
        "periodo": 202603,
        "valor": 161.08,
        "delta": 9.8117
      },
      {
        "periodo": 202604,
        "valor": 162.9084,
        "delta": 1.8284
      },
      {
        "periodo": 202605,
        "valor": 172.5919,
        "delta": 9.6834
      },
      {
        "periodo": 202606,
        "valor": 174.5066,
        "delta": 1.9147
      },
      {
        "periodo": 202607,
        "valor": 167.3836,
        "delta": -7.123
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 52.982346,
    "valor_anterior": 63.497495,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 50.1869,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 52.2241,
        "delta": 2.0372
      },
      {
        "periodo": 202509,
        "valor": 50.4357,
        "delta": -1.7885
      },
      {
        "periodo": 202510,
        "valor": 56.4653,
        "delta": 6.0297
      },
      {
        "periodo": 202511,
        "valor": 51.4264,
        "delta": -5.0389
      },
      {
        "periodo": 202512,
        "valor": 56.4619,
        "delta": 5.0355
      },
      {
        "periodo": 202601,
        "valor": 61.1471,
        "delta": 4.6853
      },
      {
        "periodo": 202602,
        "valor": 58.9709,
        "delta": -2.1763
      },
      {
        "periodo": 202603,
        "valor": 55.882,
        "delta": -3.0888
      },
      {
        "periodo": 202604,
        "valor": 57.5764,
        "delta": 1.6944
      },
      {
        "periodo": 202605,
        "valor": 53.336,
        "delta": -4.2404
      },
      {
        "periodo": 202606,
        "valor": 63.4975,
        "delta": 10.1615
      },
      {
        "periodo": 202607,
        "valor": 52.9823,
        "delta": -10.5151
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 20.801938,
    "valor_anterior": 21.983025,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 23.8304,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 25.0646,
        "delta": 1.2342
      },
      {
        "periodo": 202509,
        "valor": 24.1466,
        "delta": -0.918
      },
      {
        "periodo": 202510,
        "valor": 25.0475,
        "delta": 0.9009
      },
      {
        "periodo": 202511,
        "valor": 23.4219,
        "delta": -1.6257
      },
      {
        "periodo": 202512,
        "valor": 23.354,
        "delta": -0.0679
      },
      {
        "periodo": 202601,
        "valor": 23.2287,
        "delta": -0.1253
      },
      {
        "periodo": 202602,
        "valor": 26.3424,
        "delta": 3.1138
      },
      {
        "periodo": 202603,
        "valor": 23.8953,
        "delta": -2.4471
      },
      {
        "periodo": 202604,
        "valor": 26.001,
        "delta": 2.1057
      },
      {
        "periodo": 202605,
        "valor": 21.1197,
        "delta": -4.8813
      },
      {
        "periodo": 202606,
        "valor": 21.983,
        "delta": 0.8633
      },
      {
        "periodo": 202607,
        "valor": 20.8019,
        "delta": -1.1811
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 51.792664,
    "valor_anterior": 12.558428999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 124.157,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 70.5259,
        "delta": -53.6311
      },
      {
        "periodo": 202509,
        "valor": 63.5754,
        "delta": -6.9504
      },
      {
        "periodo": 202510,
        "valor": 22.3324,
        "delta": -41.2431
      },
      {
        "periodo": 202511,
        "valor": 100.5914,
        "delta": 78.2591
      },
      {
        "periodo": 202512,
        "valor": 88.3761,
        "delta": -12.2153
      },
      {
        "periodo": 202601,
        "valor": 88.7656,
        "delta": 0.3895
      },
      {
        "periodo": 202602,
        "valor": 60.5614,
        "delta": -28.2043
      },
      {
        "periodo": 202603,
        "valor": 44.1424,
        "delta": -16.419
      },
      {
        "periodo": 202604,
        "valor": 20.8141,
        "delta": -23.3283
      },
      {
        "periodo": 202605,
        "valor": 24.7265,
        "delta": 3.9124
      },
      {
        "periodo": 202606,
        "valor": 12.5584,
        "delta": -12.168
      },
      {
        "periodo": 202607,
        "valor": 51.7927,
        "delta": 39.2342
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 146.584181,
    "valor_anterior": 139.14368,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 132.0862,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 142.252,
        "delta": 10.1657
      },
      {
        "periodo": 202509,
        "valor": 132.4769,
        "delta": -9.7751
      },
      {
        "periodo": 202510,
        "valor": 131.2952,
        "delta": -1.1817
      },
      {
        "periodo": 202511,
        "valor": 136.7643,
        "delta": 5.4692
      },
      {
        "periodo": 202512,
        "valor": 125.0445,
        "delta": -11.7199
      },
      {
        "periodo": 202601,
        "valor": 154.4441,
        "delta": 29.3996
      },
      {
        "periodo": 202602,
        "valor": 129.0569,
        "delta": -25.3872
      },
      {
        "periodo": 202603,
        "valor": 115.8277,
        "delta": -13.2292
      },
      {
        "periodo": 202604,
        "valor": 148.6934,
        "delta": 32.8657
      },
      {
        "periodo": 202605,
        "valor": 144.761,
        "delta": -3.9324
      },
      {
        "periodo": 202606,
        "valor": 139.1437,
        "delta": -5.6173
      },
      {
        "periodo": 202607,
        "valor": 146.5842,
        "delta": 7.4405
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 15.679340999999999,
    "valor_anterior": 56.13550899999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 24.3265,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 30.2329,
        "delta": 5.9064
      },
      {
        "periodo": 202509,
        "valor": 52.9152,
        "delta": 22.6823
      },
      {
        "periodo": 202510,
        "valor": 15.4348,
        "delta": -37.4804
      },
      {
        "periodo": 202511,
        "valor": 37.1349,
        "delta": 21.7001
      },
      {
        "periodo": 202512,
        "valor": 61.2131,
        "delta": 24.0782
      },
      {
        "periodo": 202601,
        "valor": 25.056,
        "delta": -36.1571
      },
      {
        "periodo": 202602,
        "valor": 29.1775,
        "delta": 4.1214
      },
      {
        "periodo": 202603,
        "valor": 61.2179,
        "delta": 32.0404
      },
      {
        "periodo": 202604,
        "valor": 7.4845,
        "delta": -53.7334
      },
      {
        "periodo": 202605,
        "valor": -15.5951,
        "delta": -23.0796
      },
      {
        "periodo": 202606,
        "valor": 56.1355,
        "delta": 71.7306
      },
      {
        "periodo": 202607,
        "valor": 15.6793,
        "delta": -40.4562
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 220.365222,
    "valor_anterior": 189.342254,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 197.2035,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 212.1121,
        "delta": 14.9086
      },
      {
        "periodo": 202509,
        "valor": 171.7405,
        "delta": -40.3716
      },
      {
        "periodo": 202510,
        "valor": 193.066,
        "delta": 21.3255
      },
      {
        "periodo": 202511,
        "valor": 150.4574,
        "delta": -42.6087
      },
      {
        "periodo": 202512,
        "valor": 217.1007,
        "delta": 66.6434
      },
      {
        "periodo": 202601,
        "valor": 173.4912,
        "delta": -43.6095
      },
      {
        "periodo": 202602,
        "valor": 183.0099,
        "delta": 9.5187
      },
      {
        "periodo": 202603,
        "valor": 173.8409,
        "delta": -9.169
      },
      {
        "periodo": 202604,
        "valor": 178.0759,
        "delta": 4.235
      },
      {
        "periodo": 202605,
        "valor": 196.5389,
        "delta": 18.463
      },
      {
        "periodo": 202606,
        "valor": 189.3423,
        "delta": -7.1966
      },
      {
        "periodo": 202607,
        "valor": 220.3652,
        "delta": 31.023
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 28.549750000000003,
    "valor_anterior": 28.290953000000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 29.9163,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26.8001,
        "delta": -3.1162
      },
      {
        "periodo": 202509,
        "valor": 26.935,
        "delta": 0.1349
      },
      {
        "periodo": 202510,
        "valor": 29.7085,
        "delta": 2.7734
      },
      {
        "periodo": 202511,
        "valor": 28.695,
        "delta": -1.0135
      },
      {
        "periodo": 202512,
        "valor": 37.0414,
        "delta": 8.3464
      },
      {
        "periodo": 202601,
        "valor": 27.5448,
        "delta": -9.4965
      },
      {
        "periodo": 202602,
        "valor": 30.2308,
        "delta": 2.686
      },
      {
        "periodo": 202603,
        "valor": 19.8915,
        "delta": -10.3393
      },
      {
        "periodo": 202604,
        "valor": 17.8002,
        "delta": -2.0913
      },
      {
        "periodo": 202605,
        "valor": 32.8191,
        "delta": 15.0189
      },
      {
        "periodo": 202606,
        "valor": 28.291,
        "delta": -4.5282
      },
      {
        "periodo": 202607,
        "valor": 28.5498,
        "delta": 0.2588
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 134.441428,
    "valor_anterior": 111.73692399999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 106.0255,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 104.1688,
        "delta": -1.8567
      },
      {
        "periodo": 202509,
        "valor": 108.4692,
        "delta": 4.3004
      },
      {
        "periodo": 202510,
        "valor": 90.6555,
        "delta": -17.8137
      },
      {
        "periodo": 202511,
        "valor": 108.8481,
        "delta": 18.1925
      },
      {
        "periodo": 202512,
        "valor": 114.392,
        "delta": 5.5439
      },
      {
        "periodo": 202601,
        "valor": 106.9857,
        "delta": -7.4063
      },
      {
        "periodo": 202602,
        "valor": 114.9162,
        "delta": 7.9304
      },
      {
        "periodo": 202603,
        "valor": 102.1881,
        "delta": -12.728
      },
      {
        "periodo": 202604,
        "valor": 100.3922,
        "delta": -1.7959
      },
      {
        "periodo": 202605,
        "valor": 112.1866,
        "delta": 11.7943
      },
      {
        "periodo": 202606,
        "valor": 111.7369,
        "delta": -0.4496
      },
      {
        "periodo": 202607,
        "valor": 134.4414,
        "delta": 22.7045
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 35.257316,
    "valor_anterior": 33.12411,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 30.0583,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 34.9559,
        "delta": 4.8976
      },
      {
        "periodo": 202509,
        "valor": 35.4373,
        "delta": 0.4814
      },
      {
        "periodo": 202510,
        "valor": 35.6198,
        "delta": 0.1825
      },
      {
        "periodo": 202511,
        "valor": 34.972,
        "delta": -0.6478
      },
      {
        "periodo": 202512,
        "valor": 32.5348,
        "delta": -2.4372
      },
      {
        "periodo": 202601,
        "valor": 34.7432,
        "delta": 2.2084
      },
      {
        "periodo": 202602,
        "valor": 32.7996,
        "delta": -1.9436
      },
      {
        "periodo": 202603,
        "valor": 33.8667,
        "delta": 1.0671
      },
      {
        "periodo": 202604,
        "valor": 34.2563,
        "delta": 0.3895
      },
      {
        "periodo": 202605,
        "valor": 34.5793,
        "delta": 0.323
      },
      {
        "periodo": 202606,
        "valor": 33.1241,
        "delta": -1.4552
      },
      {
        "periodo": 202607,
        "valor": 35.2573,
        "delta": 2.1332
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 123.02190200000001,
    "valor_anterior": 157.552804,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 101.3398,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 107.9154,
        "delta": 6.5755
      },
      {
        "periodo": 202509,
        "valor": 92.7592,
        "delta": -15.1561
      },
      {
        "periodo": 202510,
        "valor": 84.2289,
        "delta": -8.5304
      },
      {
        "periodo": 202511,
        "valor": 86.5041,
        "delta": 2.2752
      },
      {
        "periodo": 202512,
        "valor": 97.1965,
        "delta": 10.6924
      },
      {
        "periodo": 202601,
        "valor": 112.1995,
        "delta": 15.003
      },
      {
        "periodo": 202602,
        "valor": 113.7119,
        "delta": 1.5124
      },
      {
        "periodo": 202603,
        "valor": 161.802,
        "delta": 48.0901
      },
      {
        "periodo": 202604,
        "valor": 97.8643,
        "delta": -63.9377
      },
      {
        "periodo": 202605,
        "valor": 103.4135,
        "delta": 5.5492
      },
      {
        "periodo": 202606,
        "valor": 157.5528,
        "delta": 54.1394
      },
      {
        "periodo": 202607,
        "valor": 123.0219,
        "delta": -34.5309
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 922.094834,
    "valor_anterior": -133.297771,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": -1116.6324,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": -263.3482,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": -200.9373,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": -961.3775,
        "delta": -760.4402
      },
      {
        "periodo": 202605,
        "valor": -127.3476,
        "delta": 834.0299
      },
      {
        "periodo": 202606,
        "valor": -133.2978,
        "delta": -5.9502
      },
      {
        "periodo": 202607,
        "valor": 922.0948,
        "delta": 1055.3926
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 124.598236,
    "valor_anterior": 146.807837,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 50.801,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 72.0649,
        "delta": 21.264
      },
      {
        "periodo": 202509,
        "valor": 122.0483,
        "delta": 49.9834
      },
      {
        "periodo": 202510,
        "valor": 200.4623,
        "delta": 78.414
      },
      {
        "periodo": 202511,
        "valor": 138.2178,
        "delta": -62.2445
      },
      {
        "periodo": 202512,
        "valor": 183.9882,
        "delta": 45.7704
      },
      {
        "periodo": 202601,
        "valor": 207.8026,
        "delta": 23.8144
      },
      {
        "periodo": 202602,
        "valor": 193.158,
        "delta": -14.6446
      },
      {
        "periodo": 202603,
        "valor": 167.7635,
        "delta": -25.3945
      },
      {
        "periodo": 202604,
        "valor": 173.8722,
        "delta": 6.1087
      },
      {
        "periodo": 202605,
        "valor": 180.7589,
        "delta": 6.8867
      },
      {
        "periodo": 202606,
        "valor": 146.8078,
        "delta": -33.9511
      },
      {
        "periodo": 202607,
        "valor": 124.5982,
        "delta": -22.2096
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 49.26601,
    "valor_anterior": 49.618084,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 38.599,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 63.3114,
        "delta": 24.7124
      },
      {
        "periodo": 202509,
        "valor": 54.7918,
        "delta": -8.5196
      },
      {
        "periodo": 202510,
        "valor": 59.1044,
        "delta": 4.3126
      },
      {
        "periodo": 202511,
        "valor": 61.5291,
        "delta": 2.4247
      },
      {
        "periodo": 202512,
        "valor": 64.6545,
        "delta": 3.1254
      },
      {
        "periodo": 202601,
        "valor": 58.5872,
        "delta": -6.0673
      },
      {
        "periodo": 202602,
        "valor": 65.6964,
        "delta": 7.1092
      },
      {
        "periodo": 202603,
        "valor": 72.1679,
        "delta": 6.4715
      },
      {
        "periodo": 202604,
        "valor": 65.5123,
        "delta": -6.6556
      },
      {
        "periodo": 202605,
        "valor": 61.3724,
        "delta": -4.1399
      },
      {
        "periodo": 202606,
        "valor": 49.6181,
        "delta": -11.7544
      },
      {
        "periodo": 202607,
        "valor": 49.266,
        "delta": -0.3521
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 152.244633,
    "valor_anterior": 147.389506,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 175.9516,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 148.0296,
        "delta": -27.922
      },
      {
        "periodo": 202509,
        "valor": 140.8676,
        "delta": -7.162
      },
      {
        "periodo": 202510,
        "valor": 146.5761,
        "delta": 5.7085
      },
      {
        "periodo": 202511,
        "valor": 150.4813,
        "delta": 3.9052
      },
      {
        "periodo": 202512,
        "valor": 168.8778,
        "delta": 18.3965
      },
      {
        "periodo": 202601,
        "valor": 117.9379,
        "delta": -50.9399
      },
      {
        "periodo": 202602,
        "valor": 118.7173,
        "delta": 0.7794
      },
      {
        "periodo": 202603,
        "valor": 135.2245,
        "delta": 16.5072
      },
      {
        "periodo": 202604,
        "valor": 142.4298,
        "delta": 7.2053
      },
      {
        "periodo": 202605,
        "valor": 179.1725,
        "delta": 36.7427
      },
      {
        "periodo": 202606,
        "valor": 147.3895,
        "delta": -31.783
      },
      {
        "periodo": 202607,
        "valor": 152.2446,
        "delta": 4.8551
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 86.2994,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 177.2402,
        "delta": 90.9408
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 917712546900.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 55.368689,
    "valor_anterior": 53.928001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 69.4438,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 62.0672,
        "delta": -7.3766
      },
      {
        "periodo": 202509,
        "valor": 59.1019,
        "delta": -2.9653
      },
      {
        "periodo": 202510,
        "valor": 58.1496,
        "delta": -0.9523
      },
      {
        "periodo": 202511,
        "valor": 56.651,
        "delta": -1.4986
      },
      {
        "periodo": 202512,
        "valor": 60.0019,
        "delta": 3.3509
      },
      {
        "periodo": 202601,
        "valor": 54.4538,
        "delta": -5.5481
      },
      {
        "periodo": 202602,
        "valor": 57.2074,
        "delta": 2.7537
      },
      {
        "periodo": 202603,
        "valor": 54.0385,
        "delta": -3.169
      },
      {
        "periodo": 202604,
        "valor": 58.9034,
        "delta": 4.8649
      },
      {
        "periodo": 202605,
        "valor": 55.2219,
        "delta": -3.6815
      },
      {
        "periodo": 202606,
        "valor": 53.928,
        "delta": -1.2939
      },
      {
        "periodo": 202607,
        "valor": 55.3687,
        "delta": 1.4407
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 73.730383,
    "valor_anterior": 75.722696,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 77.9253,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 79.2862,
        "delta": 1.3609
      },
      {
        "periodo": 202509,
        "valor": 76.1713,
        "delta": -3.1148
      },
      {
        "periodo": 202510,
        "valor": 89.4979,
        "delta": 13.3265
      },
      {
        "periodo": 202511,
        "valor": 80.6828,
        "delta": -8.815
      },
      {
        "periodo": 202512,
        "valor": 80.5478,
        "delta": -0.135
      },
      {
        "periodo": 202601,
        "valor": 80.5379,
        "delta": -0.0099
      },
      {
        "periodo": 202602,
        "valor": 91.147,
        "delta": 10.6091
      },
      {
        "periodo": 202603,
        "valor": 79.7862,
        "delta": -11.3608
      },
      {
        "periodo": 202604,
        "valor": 76.2387,
        "delta": -3.5475
      },
      {
        "periodo": 202605,
        "valor": 71.0641,
        "delta": -5.1746
      },
      {
        "periodo": 202606,
        "valor": 75.7227,
        "delta": 4.6586
      },
      {
        "periodo": 202607,
        "valor": 73.7304,
        "delta": -1.9923
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 213.406,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 362.0325,
        "delta": 148.6265
      },
      {
        "periodo": 202509,
        "valor": 499.6541,
        "delta": 137.6216
      },
      {
        "periodo": 202510,
        "valor": 599.5004,
        "delta": 99.8463
      },
      {
        "periodo": 202511,
        "valor": 301.7668,
        "delta": -297.7335
      },
      {
        "periodo": 202512,
        "valor": 420.0207,
        "delta": 118.2539
      },
      {
        "periodo": 202601,
        "valor": 294.239,
        "delta": -125.7817
      },
      {
        "periodo": 202602,
        "valor": 605.0213,
        "delta": 310.7823
      },
      {
        "periodo": 202603,
        "valor": 551.8799,
        "delta": -53.1414
      },
      {
        "periodo": 202604,
        "valor": 521.4055,
        "delta": -30.4744
      },
      {
        "periodo": 202605,
        "valor": 127.7501,
        "delta": -393.6553
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 191.109117,
    "valor_anterior": 455.329828,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 155.4822,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 108.7071,
        "delta": -46.775
      },
      {
        "periodo": 202509,
        "valor": 146.6429,
        "delta": 37.9358
      },
      {
        "periodo": 202510,
        "valor": 194.679,
        "delta": 48.0361
      },
      {
        "periodo": 202511,
        "valor": 132.3818,
        "delta": -62.2972
      },
      {
        "periodo": 202512,
        "valor": 246.3391,
        "delta": 113.9573
      },
      {
        "periodo": 202601,
        "valor": 265.1909,
        "delta": 18.8517
      },
      {
        "periodo": 202602,
        "valor": 364.8312,
        "delta": 99.6404
      },
      {
        "periodo": 202603,
        "valor": 487.5446,
        "delta": 122.7134
      },
      {
        "periodo": 202604,
        "valor": 629.467,
        "delta": 141.9224
      },
      {
        "periodo": 202605,
        "valor": 542.3223,
        "delta": -87.1447
      },
      {
        "periodo": 202606,
        "valor": 455.3298,
        "delta": -86.9925
      },
      {
        "periodo": 202607,
        "valor": 191.1091,
        "delta": -264.2207
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 59.817092,
    "valor_anterior": 70.018834,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 24.624,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18.7242,
        "delta": -5.8998
      },
      {
        "periodo": 202509,
        "valor": 820.3345,
        "delta": 801.6103
      },
      {
        "periodo": 202510,
        "valor": 731.3795,
        "delta": -88.955
      },
      {
        "periodo": 202511,
        "valor": 635.4811,
        "delta": -95.8984
      },
      {
        "periodo": 202512,
        "valor": 66.076,
        "delta": -569.4052
      },
      {
        "periodo": 202601,
        "valor": 19.9996,
        "delta": -46.0763
      },
      {
        "periodo": 202602,
        "valor": 35.1197,
        "delta": 15.1201
      },
      {
        "periodo": 202603,
        "valor": 62.271,
        "delta": 27.1513
      },
      {
        "periodo": 202604,
        "valor": 67.004,
        "delta": 4.7329
      },
      {
        "periodo": 202605,
        "valor": 71.2042,
        "delta": 4.2002
      },
      {
        "periodo": 202606,
        "valor": 70.0188,
        "delta": -1.1853
      },
      {
        "periodo": 202607,
        "valor": 59.8171,
        "delta": -10.2017
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 245.2551,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 92.4715,
        "delta": -152.7836
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 137.798236,
    "valor_anterior": 147.39140799999998,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 156.6421,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 148.4208,
        "delta": -8.2213
      },
      {
        "periodo": 202509,
        "valor": 153.5391,
        "delta": 5.1183
      },
      {
        "periodo": 202510,
        "valor": 158.4575,
        "delta": 4.9184
      },
      {
        "periodo": 202511,
        "valor": 155.8585,
        "delta": -2.5989
      },
      {
        "periodo": 202512,
        "valor": 152.0024,
        "delta": -3.8562
      },
      {
        "periodo": 202601,
        "valor": 145.7083,
        "delta": -6.2941
      },
      {
        "periodo": 202602,
        "valor": 157.9139,
        "delta": 12.2056
      },
      {
        "periodo": 202603,
        "valor": 153.2061,
        "delta": -4.7078
      },
      {
        "periodo": 202604,
        "valor": 144.3267,
        "delta": -8.8793
      },
      {
        "periodo": 202605,
        "valor": 152.1876,
        "delta": 7.8609
      },
      {
        "periodo": 202606,
        "valor": 147.3914,
        "delta": -4.7962
      },
      {
        "periodo": 202607,
        "valor": 137.7982,
        "delta": -9.5932
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 62.385135999999996,
    "valor_anterior": 61.34722299999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 58.3138,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 56.1647,
        "delta": -2.1491
      },
      {
        "periodo": 202509,
        "valor": 58.9613,
        "delta": 2.7966
      },
      {
        "periodo": 202510,
        "valor": 58.6159,
        "delta": -0.3454
      },
      {
        "periodo": 202511,
        "valor": 49.4165,
        "delta": -9.1994
      },
      {
        "periodo": 202512,
        "valor": 73.9059,
        "delta": 24.4894
      },
      {
        "periodo": 202601,
        "valor": 37.4638,
        "delta": -36.442
      },
      {
        "periodo": 202602,
        "valor": 55.214,
        "delta": 17.7501
      },
      {
        "periodo": 202603,
        "valor": 67.8815,
        "delta": 12.6675
      },
      {
        "periodo": 202604,
        "valor": 67.2707,
        "delta": -0.6108
      },
      {
        "periodo": 202605,
        "valor": 63.1191,
        "delta": -4.1516
      },
      {
        "periodo": 202606,
        "valor": 61.3472,
        "delta": -1.7719
      },
      {
        "periodo": 202607,
        "valor": 62.3851,
        "delta": 1.0379
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 180.45653800000002,
    "valor_anterior": 175.804964,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 789.6368,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 121.7448,
        "delta": -667.892
      },
      {
        "periodo": 202509,
        "valor": 141.5706,
        "delta": 19.8259
      },
      {
        "periodo": 202510,
        "valor": 200.3891,
        "delta": 58.8184
      },
      {
        "periodo": 202511,
        "valor": 189.2123,
        "delta": -11.1767
      },
      {
        "periodo": 202512,
        "valor": 904.5032,
        "delta": 715.2909
      },
      {
        "periodo": 202601,
        "valor": 457.0157,
        "delta": -447.4875
      },
      {
        "periodo": 202602,
        "valor": 422.7712,
        "delta": -34.2445
      },
      {
        "periodo": 202603,
        "valor": 1482.3094,
        "delta": 1059.5382
      },
      {
        "periodo": 202604,
        "valor": 2092.2381,
        "delta": 609.9287
      },
      {
        "periodo": 202605,
        "valor": 227.0017,
        "delta": -1865.2364
      },
      {
        "periodo": 202606,
        "valor": 175.805,
        "delta": -51.1967
      },
      {
        "periodo": 202607,
        "valor": 180.4565,
        "delta": 4.6516
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 167.781914,
    "valor_anterior": 288.416419,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 298.6321,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 288.8906,
        "delta": -9.7415
      },
      {
        "periodo": 202509,
        "valor": 316.6714,
        "delta": 27.7807
      },
      {
        "periodo": 202510,
        "valor": 302.7561,
        "delta": -13.9153
      },
      {
        "periodo": 202511,
        "valor": 295.7184,
        "delta": -7.0377
      },
      {
        "periodo": 202512,
        "valor": 336.6794,
        "delta": 40.961
      },
      {
        "periodo": 202601,
        "valor": 311.8002,
        "delta": -24.8792
      },
      {
        "periodo": 202602,
        "valor": 290.6143,
        "delta": -21.1859
      },
      {
        "periodo": 202603,
        "valor": 346.7865,
        "delta": 56.1722
      },
      {
        "periodo": 202604,
        "valor": 279.5712,
        "delta": -67.2153
      },
      {
        "periodo": 202605,
        "valor": 245.5793,
        "delta": -33.9919
      },
      {
        "periodo": 202606,
        "valor": 288.4164,
        "delta": 42.8371
      },
      {
        "periodo": 202607,
        "valor": 167.7819,
        "delta": -120.6345
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 177.5486,
    "valor_anterior": 174.825221,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14.3791,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": -29.522,
        "delta": -43.9011
      },
      {
        "periodo": 202509,
        "valor": 84.155,
        "delta": 113.677
      },
      {
        "periodo": 202510,
        "valor": 59.4752,
        "delta": -24.6798
      },
      {
        "periodo": 202511,
        "valor": 102.3921,
        "delta": 42.9169
      },
      {
        "periodo": 202512,
        "valor": 67.5078,
        "delta": -34.8843
      },
      {
        "periodo": 202601,
        "valor": 113.5018,
        "delta": 45.994
      },
      {
        "periodo": 202602,
        "valor": 108.2516,
        "delta": -5.2502
      },
      {
        "periodo": 202603,
        "valor": 163.4576,
        "delta": 55.206
      },
      {
        "periodo": 202604,
        "valor": 131.0838,
        "delta": -32.3738
      },
      {
        "periodo": 202605,
        "valor": 163.4133,
        "delta": 32.3296
      },
      {
        "periodo": 202606,
        "valor": 174.8252,
        "delta": 11.4119
      },
      {
        "periodo": 202607,
        "valor": 177.5486,
        "delta": 2.7234
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 55.325077,
    "valor_anterior": 48.350403,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 51.1706,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 48.0832,
        "delta": -3.0874
      },
      {
        "periodo": 202509,
        "valor": 47.2289,
        "delta": -0.8543
      },
      {
        "periodo": 202510,
        "valor": 42.2444,
        "delta": -4.9845
      },
      {
        "periodo": 202511,
        "valor": 48.6164,
        "delta": 6.3719
      },
      {
        "periodo": 202512,
        "valor": 60.7099,
        "delta": 12.0936
      },
      {
        "periodo": 202601,
        "valor": 53.4924,
        "delta": -7.2176
      },
      {
        "periodo": 202602,
        "valor": 49.0569,
        "delta": -4.4354
      },
      {
        "periodo": 202603,
        "valor": 53.9864,
        "delta": 4.9295
      },
      {
        "periodo": 202604,
        "valor": 40.66,
        "delta": -13.3264
      },
      {
        "periodo": 202605,
        "valor": 40.0631,
        "delta": -0.5969
      },
      {
        "periodo": 202606,
        "valor": 48.3504,
        "delta": 8.2873
      },
      {
        "periodo": 202607,
        "valor": 55.3251,
        "delta": 6.9747
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 47.709478,
    "valor_anterior": 67.46448699999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27.1516,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23.5728,
        "delta": -3.5788
      },
      {
        "periodo": 202509,
        "valor": 28.2934,
        "delta": 4.7206
      },
      {
        "periodo": 202510,
        "valor": 23.0526,
        "delta": -5.2408
      },
      {
        "periodo": 202511,
        "valor": 26.7757,
        "delta": 3.7232
      },
      {
        "periodo": 202512,
        "valor": 23.9067,
        "delta": -2.8691
      },
      {
        "periodo": 202601,
        "valor": 20.1512,
        "delta": -3.7555
      },
      {
        "periodo": 202602,
        "valor": 22.8957,
        "delta": 2.7445
      },
      {
        "periodo": 202603,
        "valor": 61.1965,
        "delta": 38.3007
      },
      {
        "periodo": 202604,
        "valor": 43.0093,
        "delta": -18.1872
      },
      {
        "periodo": 202605,
        "valor": 55.3494,
        "delta": 12.3401
      },
      {
        "periodo": 202606,
        "valor": 67.4645,
        "delta": 12.1151
      },
      {
        "periodo": 202607,
        "valor": 47.7095,
        "delta": -19.755
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 90.946253,
    "valor_anterior": 84.94886699999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 89.3103,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 88.7455,
        "delta": -0.5648
      },
      {
        "periodo": 202509,
        "valor": 89.6517,
        "delta": 0.9062
      },
      {
        "periodo": 202510,
        "valor": 86.3876,
        "delta": -3.264
      },
      {
        "periodo": 202511,
        "valor": 93.0876,
        "delta": 6.6999
      },
      {
        "periodo": 202512,
        "valor": 78.487,
        "delta": -14.6006
      },
      {
        "periodo": 202601,
        "valor": 90.7702,
        "delta": 12.2833
      },
      {
        "periodo": 202602,
        "valor": 89.5793,
        "delta": -1.1909
      },
      {
        "periodo": 202603,
        "valor": 91.8197,
        "delta": 2.2404
      },
      {
        "periodo": 202604,
        "valor": 90.9052,
        "delta": -0.9145
      },
      {
        "periodo": 202605,
        "valor": 94.7839,
        "delta": 3.8787
      },
      {
        "periodo": 202606,
        "valor": 84.9489,
        "delta": -9.8351
      },
      {
        "periodo": 202607,
        "valor": 90.9463,
        "delta": 5.9974
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 52.314532,
    "valor_anterior": 45.426881,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 67.7681,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 69.201,
        "delta": 1.4329
      },
      {
        "periodo": 202509,
        "valor": 63.4054,
        "delta": -5.7956
      },
      {
        "periodo": 202510,
        "valor": 65.0982,
        "delta": 1.6928
      },
      {
        "periodo": 202511,
        "valor": 60.5777,
        "delta": -4.5205
      },
      {
        "periodo": 202512,
        "valor": 68.3754,
        "delta": 7.7977
      },
      {
        "periodo": 202601,
        "valor": 57.8841,
        "delta": -10.4912
      },
      {
        "periodo": 202602,
        "valor": 60.4685,
        "delta": 2.5844
      },
      {
        "periodo": 202603,
        "valor": 50.8424,
        "delta": -9.6261
      },
      {
        "periodo": 202604,
        "valor": 56.5204,
        "delta": 5.678
      },
      {
        "periodo": 202605,
        "valor": 48.2926,
        "delta": -8.2279
      },
      {
        "periodo": 202606,
        "valor": 45.4269,
        "delta": -2.8657
      },
      {
        "periodo": 202607,
        "valor": 52.3145,
        "delta": 6.8877
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 40.016645000000004,
    "valor_anterior": 41.720417999999995,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16.0967,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18.7921,
        "delta": 2.6954
      },
      {
        "periodo": 202509,
        "valor": 19.1448,
        "delta": 0.3527
      },
      {
        "periodo": 202510,
        "valor": 34.6439,
        "delta": 15.4991
      },
      {
        "periodo": 202511,
        "valor": 30.2564,
        "delta": -4.3875
      },
      {
        "periodo": 202512,
        "valor": 20.1188,
        "delta": -10.1377
      },
      {
        "periodo": 202601,
        "valor": 37.9874,
        "delta": 17.8686
      },
      {
        "periodo": 202602,
        "valor": 35.8789,
        "delta": -2.1085
      },
      {
        "periodo": 202603,
        "valor": 32.0716,
        "delta": -3.8073
      },
      {
        "periodo": 202604,
        "valor": 36.6087,
        "delta": 4.5371
      },
      {
        "periodo": 202605,
        "valor": 34.1883,
        "delta": -2.4204
      },
      {
        "periodo": 202606,
        "valor": 41.7204,
        "delta": 7.5321
      },
      {
        "periodo": 202607,
        "valor": 40.0166,
        "delta": -1.7038
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 100.756123,
    "valor_anterior": 140.22857,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 188.2992,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 204.6757,
        "delta": 16.3765
      },
      {
        "periodo": 202509,
        "valor": 187.4676,
        "delta": -17.2081
      },
      {
        "periodo": 202510,
        "valor": 177.2394,
        "delta": -10.2282
      },
      {
        "periodo": 202511,
        "valor": 208.1278,
        "delta": 30.8884
      },
      {
        "periodo": 202512,
        "valor": 262.0303,
        "delta": 53.9025
      },
      {
        "periodo": 202601,
        "valor": 234.9019,
        "delta": -27.1285
      },
      {
        "periodo": 202602,
        "valor": 237.4421,
        "delta": 2.5402
      },
      {
        "periodo": 202603,
        "valor": 209.402,
        "delta": -28.0401
      },
      {
        "periodo": 202604,
        "valor": 183.8468,
        "delta": -25.5552
      },
      {
        "periodo": 202605,
        "valor": 181.1771,
        "delta": -2.6697
      },
      {
        "periodo": 202606,
        "valor": 140.2286,
        "delta": -40.9486
      },
      {
        "periodo": 202607,
        "valor": 100.7561,
        "delta": -39.4724
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 90.258513,
    "valor_anterior": 98.079282,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 204.7803,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 235.6049,
        "delta": 30.8246
      },
      {
        "periodo": 202509,
        "valor": 173.271,
        "delta": -62.3339
      },
      {
        "periodo": 202510,
        "valor": 164.6788,
        "delta": -8.5922
      },
      {
        "periodo": 202511,
        "valor": 157.6786,
        "delta": -7.0002
      },
      {
        "periodo": 202512,
        "valor": 125.7493,
        "delta": -31.9294
      },
      {
        "periodo": 202601,
        "valor": 123.2044,
        "delta": -2.5448
      },
      {
        "periodo": 202602,
        "valor": 116.8609,
        "delta": -6.3435
      },
      {
        "periodo": 202603,
        "valor": 124.6275,
        "delta": 7.7666
      },
      {
        "periodo": 202604,
        "valor": 107.5233,
        "delta": -17.1042
      },
      {
        "periodo": 202605,
        "valor": 111.0526,
        "delta": 3.5293
      },
      {
        "periodo": 202606,
        "valor": 98.0793,
        "delta": -12.9734
      },
      {
        "periodo": 202607,
        "valor": 90.2585,
        "delta": -7.8208
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 382.413381,
    "valor_anterior": 225.29894499999997,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 178.262,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 194.9675,
        "delta": 16.7055
      },
      {
        "periodo": 202509,
        "valor": 148.7936,
        "delta": -46.1739
      },
      {
        "periodo": 202510,
        "valor": 214.5765,
        "delta": 65.7829
      },
      {
        "periodo": 202511,
        "valor": 172.3844,
        "delta": -42.192
      },
      {
        "periodo": 202512,
        "valor": 349.8236,
        "delta": 177.4391
      },
      {
        "periodo": 202601,
        "valor": 147.9487,
        "delta": -201.8749
      },
      {
        "periodo": 202602,
        "valor": 168.4572,
        "delta": 20.5085
      },
      {
        "periodo": 202603,
        "valor": 90.6314,
        "delta": -77.8259
      },
      {
        "periodo": 202604,
        "valor": 180.3875,
        "delta": 89.7562
      },
      {
        "periodo": 202605,
        "valor": 190.3865,
        "delta": 9.9989
      },
      {
        "periodo": 202606,
        "valor": 225.2989,
        "delta": 34.9125
      },
      {
        "periodo": 202607,
        "valor": 382.4134,
        "delta": 157.1144
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 6.180821,
    "valor_anterior": 5.171996,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.7703,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.2212,
        "delta": -0.5491
      },
      {
        "periodo": 202509,
        "valor": 1.3928,
        "delta": 0.1716
      },
      {
        "periodo": 202510,
        "valor": 1.4294,
        "delta": 0.0366
      },
      {
        "periodo": 202511,
        "valor": 1.2112,
        "delta": -0.2182
      },
      {
        "periodo": 202512,
        "valor": 2.1321,
        "delta": 0.9209
      },
      {
        "periodo": 202601,
        "valor": 1.7501,
        "delta": -0.3819
      },
      {
        "periodo": 202602,
        "valor": 2.4759,
        "delta": 0.7258
      },
      {
        "periodo": 202603,
        "valor": 3.6531,
        "delta": 1.1771
      },
      {
        "periodo": 202604,
        "valor": 5.0555,
        "delta": 1.4024
      },
      {
        "periodo": 202605,
        "valor": 4.8597,
        "delta": -0.1958
      },
      {
        "periodo": 202606,
        "valor": 5.172,
        "delta": 0.3123
      },
      {
        "periodo": 202607,
        "valor": 6.1808,
        "delta": 1.0088
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 5919.131799,
    "valor_anterior": 5707.14673,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3536.4208,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3128.3117,
        "delta": -408.1091
      },
      {
        "periodo": 202509,
        "valor": 3741.6078,
        "delta": 613.2961
      },
      {
        "periodo": 202510,
        "valor": 3804.5335,
        "delta": 62.9256
      },
      {
        "periodo": 202511,
        "valor": 4586.0277,
        "delta": 781.4943
      },
      {
        "periodo": 202512,
        "valor": 4516.6426,
        "delta": -69.3851
      },
      {
        "periodo": 202601,
        "valor": 4871.3063,
        "delta": 354.6637
      },
      {
        "periodo": 202602,
        "valor": 5224.272,
        "delta": 352.9657
      },
      {
        "periodo": 202603,
        "valor": 5414.9244,
        "delta": 190.6524
      },
      {
        "periodo": 202604,
        "valor": 5612.6547,
        "delta": 197.7303
      },
      {
        "periodo": 202605,
        "valor": 5583.47,
        "delta": -29.1848
      },
      {
        "periodo": 202606,
        "valor": 5707.1467,
        "delta": 123.6768
      },
      {
        "periodo": 202607,
        "valor": 5919.1318,
        "delta": 211.9851
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 139.23309,
    "valor_anterior": 147.774548,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6179724.874,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6197420.453,
        "delta": 17695.579
      },
      {
        "periodo": 202509,
        "valor": 6205411.6366,
        "delta": 7991.1836
      },
      {
        "periodo": 202510,
        "valor": 6225099.6674,
        "delta": 19688.0308
      },
      {
        "periodo": 202511,
        "valor": 6244770.9081,
        "delta": 19671.2408
      },
      {
        "periodo": 202512,
        "valor": 6256516.8922,
        "delta": 11745.9841
      },
      {
        "periodo": 202601,
        "valor": 6274378.9717,
        "delta": 17862.0794
      },
      {
        "periodo": 202602,
        "valor": 166.0814,
        "delta": -6274212.8902
      },
      {
        "periodo": 202603,
        "valor": 158.9777,
        "delta": -7.1038
      },
      {
        "periodo": 202604,
        "valor": 154.8961,
        "delta": -4.0816
      },
      {
        "periodo": 202605,
        "valor": 152.4699,
        "delta": -2.4262
      },
      {
        "periodo": 202606,
        "valor": 147.7745,
        "delta": -4.6953
      },
      {
        "periodo": 202607,
        "valor": 139.2331,
        "delta": -8.5415
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 43.960823999999995,
    "valor_anterior": 44.572466999999996,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 115.4829,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 93.1016,
        "delta": -22.3813
      },
      {
        "periodo": 202509,
        "valor": 83.936,
        "delta": -9.1656
      },
      {
        "periodo": 202510,
        "valor": 65.9485,
        "delta": -17.9876
      },
      {
        "periodo": 202511,
        "valor": 54.4773,
        "delta": -11.4712
      },
      {
        "periodo": 202512,
        "valor": 45.4614,
        "delta": -9.0159
      },
      {
        "periodo": 202601,
        "valor": 43.333,
        "delta": -2.1284
      },
      {
        "periodo": 202602,
        "valor": 40.6571,
        "delta": -2.6759
      },
      {
        "periodo": 202603,
        "valor": 45.9899,
        "delta": 5.3328
      },
      {
        "periodo": 202604,
        "valor": 47.1123,
        "delta": 1.1224
      },
      {
        "periodo": 202605,
        "valor": 46.2113,
        "delta": -0.901
      },
      {
        "periodo": 202606,
        "valor": 44.5725,
        "delta": -1.6388
      },
      {
        "periodo": 202607,
        "valor": 43.9608,
        "delta": -0.6116
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 130.80326499999998,
    "valor_anterior": 131.738492,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 26203.2867,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 4097.2833,
        "delta": -22106.0034
      },
      {
        "periodo": 202601,
        "valor": 370.8578,
        "delta": -3726.4256
      },
      {
        "periodo": 202602,
        "valor": 162.705,
        "delta": -208.1528
      },
      {
        "periodo": 202603,
        "valor": 138.1134,
        "delta": -24.5915
      },
      {
        "periodo": 202604,
        "valor": 148.8954,
        "delta": 10.7819
      },
      {
        "periodo": 202605,
        "valor": 139.0831,
        "delta": -9.8123
      },
      {
        "periodo": 202606,
        "valor": 131.7385,
        "delta": -7.3446
      },
      {
        "periodo": 202607,
        "valor": 130.8033,
        "delta": -0.9352
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 122.58901200000001,
    "valor_anterior": 139.307993,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 299.2122,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 187.2768,
        "delta": -111.9354
      },
      {
        "periodo": 202605,
        "valor": 150.3595,
        "delta": -36.9173
      },
      {
        "periodo": 202606,
        "valor": 139.308,
        "delta": -11.0515
      },
      {
        "periodo": 202607,
        "valor": 122.589,
        "delta": -16.719
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 41.195917,
    "valor_anterior": 41.009882,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 44.4793,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 43.8526,
        "delta": -0.6267
      },
      {
        "periodo": 202509,
        "valor": 43.0375,
        "delta": -0.8151
      },
      {
        "periodo": 202510,
        "valor": 40.0728,
        "delta": -2.9647
      },
      {
        "periodo": 202511,
        "valor": 42.9664,
        "delta": 2.8936
      },
      {
        "periodo": 202512,
        "valor": 45.4412,
        "delta": 2.4748
      },
      {
        "periodo": 202601,
        "valor": 41.6047,
        "delta": -3.8365
      },
      {
        "periodo": 202602,
        "valor": 42.6005,
        "delta": 0.9958
      },
      {
        "periodo": 202603,
        "valor": 41.1904,
        "delta": -1.4101
      },
      {
        "periodo": 202604,
        "valor": 40.4588,
        "delta": -0.7316
      },
      {
        "periodo": 202605,
        "valor": 37.741,
        "delta": -2.7179
      },
      {
        "periodo": 202606,
        "valor": 41.0099,
        "delta": 3.2689
      },
      {
        "periodo": 202607,
        "valor": 41.1959,
        "delta": 0.186
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 33.048124,
    "valor_anterior": 33.286521,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 37.5197,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 36.8714,
        "delta": -0.6483
      },
      {
        "periodo": 202509,
        "valor": 35.7954,
        "delta": -1.076
      },
      {
        "periodo": 202510,
        "valor": 33.9625,
        "delta": -1.833
      },
      {
        "periodo": 202511,
        "valor": 35.6464,
        "delta": 1.6839
      },
      {
        "periodo": 202512,
        "valor": 36.6183,
        "delta": 0.9719
      },
      {
        "periodo": 202601,
        "valor": 34.046,
        "delta": -2.5723
      },
      {
        "periodo": 202602,
        "valor": 34.9649,
        "delta": 0.9189
      },
      {
        "periodo": 202603,
        "valor": 33.2156,
        "delta": -1.7493
      },
      {
        "periodo": 202604,
        "valor": 33.9974,
        "delta": 0.7818
      },
      {
        "periodo": 202605,
        "valor": 30.3032,
        "delta": -3.6941
      },
      {
        "periodo": 202606,
        "valor": 33.2865,
        "delta": 2.9833
      },
      {
        "periodo": 202607,
        "valor": 33.0481,
        "delta": -0.2384
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 196.48813,
    "valor_anterior": 180.051016,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 169.4547,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 180.3813,
        "delta": 10.9267
      },
      {
        "periodo": 202509,
        "valor": 180.9366,
        "delta": 0.5553
      },
      {
        "periodo": 202510,
        "valor": 197.1255,
        "delta": 16.1888
      },
      {
        "periodo": 202511,
        "valor": 168.8102,
        "delta": -28.3153
      },
      {
        "periodo": 202512,
        "valor": 209.7615,
        "delta": 40.9513
      },
      {
        "periodo": 202601,
        "valor": 180.3132,
        "delta": -29.4483
      },
      {
        "periodo": 202602,
        "valor": 190.2435,
        "delta": 9.9302
      },
      {
        "periodo": 202603,
        "valor": 171.9268,
        "delta": -18.3167
      },
      {
        "periodo": 202604,
        "valor": 171.5714,
        "delta": -0.3553
      },
      {
        "periodo": 202605,
        "valor": 186.1454,
        "delta": 14.574
      },
      {
        "periodo": 202606,
        "valor": 180.051,
        "delta": -6.0944
      },
      {
        "periodo": 202607,
        "valor": 196.4881,
        "delta": 16.4371
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 94.357558,
    "valor_anterior": 88.30619899999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 94.7641,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 87.2709,
        "delta": -7.4932
      },
      {
        "periodo": 202509,
        "valor": 88.88,
        "delta": 1.609
      },
      {
        "periodo": 202510,
        "valor": 66.1035,
        "delta": -22.7764
      },
      {
        "periodo": 202511,
        "valor": 93.6476,
        "delta": 27.5441
      },
      {
        "periodo": 202512,
        "valor": 100.1166,
        "delta": 6.4689
      },
      {
        "periodo": 202601,
        "valor": 91.2393,
        "delta": -8.8773
      },
      {
        "periodo": 202602,
        "valor": 92.7925,
        "delta": 1.5532
      },
      {
        "periodo": 202603,
        "valor": 86.1632,
        "delta": -6.6293
      },
      {
        "periodo": 202604,
        "valor": 72.6812,
        "delta": -13.482
      },
      {
        "periodo": 202605,
        "valor": 74.6188,
        "delta": 1.9376
      },
      {
        "periodo": 202606,
        "valor": 88.3062,
        "delta": 13.6874
      },
      {
        "periodo": 202607,
        "valor": 94.3576,
        "delta": 6.0514
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 38.42587,
    "valor_anterior": 37.215123,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 36.7365,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 38.7298,
        "delta": 1.9933
      },
      {
        "periodo": 202509,
        "valor": 38.8413,
        "delta": 0.1115
      },
      {
        "periodo": 202510,
        "valor": 38.2822,
        "delta": -0.559
      },
      {
        "periodo": 202511,
        "valor": 38.895,
        "delta": 0.6127
      },
      {
        "periodo": 202512,
        "valor": 46.3773,
        "delta": 7.4823
      },
      {
        "periodo": 202601,
        "valor": 40.184,
        "delta": -6.1934
      },
      {
        "periodo": 202602,
        "valor": 40.6485,
        "delta": 0.4645
      },
      {
        "periodo": 202603,
        "valor": 41.3467,
        "delta": 0.6982
      },
      {
        "periodo": 202604,
        "valor": 38.9155,
        "delta": -2.4313
      },
      {
        "periodo": 202605,
        "valor": 38.7968,
        "delta": -0.1187
      },
      {
        "periodo": 202606,
        "valor": 37.2151,
        "delta": -1.5817
      },
      {
        "periodo": 202607,
        "valor": 38.4259,
        "delta": 1.2107
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 100.83197399999999,
    "valor_anterior": 108.521398,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 107.899,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 103.6919,
        "delta": -4.207
      },
      {
        "periodo": 202509,
        "valor": 101.9512,
        "delta": -1.7408
      },
      {
        "periodo": 202510,
        "valor": 97.0052,
        "delta": -4.946
      },
      {
        "periodo": 202511,
        "valor": 97.9661,
        "delta": 0.961
      },
      {
        "periodo": 202512,
        "valor": 103.7057,
        "delta": 5.7396
      },
      {
        "periodo": 202601,
        "valor": 96.6886,
        "delta": -7.0171
      },
      {
        "periodo": 202602,
        "valor": 94.4178,
        "delta": -2.2708
      },
      {
        "periodo": 202603,
        "valor": 110.35,
        "delta": 15.9322
      },
      {
        "periodo": 202604,
        "valor": 96.2487,
        "delta": -14.1013
      },
      {
        "periodo": 202605,
        "valor": 99.6283,
        "delta": 3.3796
      },
      {
        "periodo": 202606,
        "valor": 108.5214,
        "delta": 8.893
      },
      {
        "periodo": 202607,
        "valor": 100.832,
        "delta": -7.6894
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200032,
    "label": "Liquidez",
    "valor_actual": 49.680144999999996,
    "valor_anterior": 48.856094999999996,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 48.4781,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 48.4525,
        "delta": -0.0256
      },
      {
        "periodo": 202509,
        "valor": 49.3124,
        "delta": 0.8599
      },
      {
        "periodo": 202510,
        "valor": 49.637,
        "delta": 0.3246
      },
      {
        "periodo": 202511,
        "valor": 47.9524,
        "delta": -1.6847
      },
      {
        "periodo": 202512,
        "valor": 48.2708,
        "delta": 0.3184
      },
      {
        "periodo": 202601,
        "valor": 47.565,
        "delta": -0.7057
      },
      {
        "periodo": 202602,
        "valor": 48.1125,
        "delta": 0.5475
      },
      {
        "periodo": 202603,
        "valor": 48.5141,
        "delta": 0.4016
      },
      {
        "periodo": 202604,
        "valor": 51.9903,
        "delta": 3.4762
      },
      {
        "periodo": 202605,
        "valor": 50.3992,
        "delta": -1.5911
      },
      {
        "periodo": 202606,
        "valor": 48.8561,
        "delta": -1.5431
      },
      {
        "periodo": 202607,
        "valor": 49.6801,
        "delta": 0.824
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 7.986003999999999,
    "valor_anterior": 7.9066849999999995,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7.0781,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7.0876,
        "delta": 0.0095
      },
      {
        "periodo": 202509,
        "valor": 7.0878,
        "delta": 0.0002
      },
      {
        "periodo": 202510,
        "valor": 7.1961,
        "delta": 0.1083
      },
      {
        "periodo": 202511,
        "valor": 7.1045,
        "delta": -0.0917
      },
      {
        "periodo": 202512,
        "valor": 7.3754,
        "delta": 0.271
      },
      {
        "periodo": 202601,
        "valor": 7.4769,
        "delta": 0.1015
      },
      {
        "periodo": 202602,
        "valor": 7.5706,
        "delta": 0.0936
      },
      {
        "periodo": 202603,
        "valor": 7.6142,
        "delta": 0.0436
      },
      {
        "periodo": 202604,
        "valor": 7.7154,
        "delta": 0.1013
      },
      {
        "periodo": 202605,
        "valor": 7.8224,
        "delta": 0.107
      },
      {
        "periodo": 202606,
        "valor": 7.9067,
        "delta": 0.0843
      },
      {
        "periodo": 202607,
        "valor": 7.986,
        "delta": 0.0793
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 4.541999,
    "valor_anterior": 4.489172,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4.248,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4.2984,
        "delta": 0.0504
      },
      {
        "periodo": 202509,
        "valor": 4.3956,
        "delta": 0.0972
      },
      {
        "periodo": 202510,
        "valor": 4.4027,
        "delta": 0.0071
      },
      {
        "periodo": 202511,
        "valor": 4.3869,
        "delta": -0.0158
      },
      {
        "periodo": 202512,
        "valor": 4.3854,
        "delta": -0.0016
      },
      {
        "periodo": 202601,
        "valor": 4.4157,
        "delta": 0.0304
      },
      {
        "periodo": 202602,
        "valor": 4.419,
        "delta": 0.0032
      },
      {
        "periodo": 202603,
        "valor": 4.276,
        "delta": -0.143
      },
      {
        "periodo": 202604,
        "valor": 4.4278,
        "delta": 0.1518
      },
      {
        "periodo": 202605,
        "valor": 4.4884,
        "delta": 0.0606
      },
      {
        "periodo": 202606,
        "valor": 4.4892,
        "delta": 0.0008
      },
      {
        "periodo": 202607,
        "valor": 4.542,
        "delta": 0.0528
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 5.248131000000001,
    "valor_anterior": 5.215162,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5.0865,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5.1265,
        "delta": 0.04
      },
      {
        "periodo": 202509,
        "valor": 5.3089,
        "delta": 0.1824
      },
      {
        "periodo": 202510,
        "valor": 5.2417,
        "delta": -0.0672
      },
      {
        "periodo": 202511,
        "valor": 5.1931,
        "delta": -0.0486
      },
      {
        "periodo": 202512,
        "valor": 4.9096,
        "delta": -0.2835
      },
      {
        "periodo": 202601,
        "valor": 4.9359,
        "delta": 0.0263
      },
      {
        "periodo": 202602,
        "valor": 5.0648,
        "delta": 0.1289
      },
      {
        "periodo": 202603,
        "valor": 5.1027,
        "delta": 0.0379
      },
      {
        "periodo": 202604,
        "valor": 5.1206,
        "delta": 0.0179
      },
      {
        "periodo": 202605,
        "valor": 5.2057,
        "delta": 0.0851
      },
      {
        "periodo": 202606,
        "valor": 5.2152,
        "delta": 0.0094
      },
      {
        "periodo": 202607,
        "valor": 5.2481,
        "delta": 0.033
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 6.178836,
    "valor_anterior": 6.186811,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5.5395,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5.7459,
        "delta": 0.2064
      },
      {
        "periodo": 202509,
        "valor": 5.8512,
        "delta": 0.1053
      },
      {
        "periodo": 202510,
        "valor": 5.858,
        "delta": 0.0068
      },
      {
        "periodo": 202511,
        "valor": 5.9139,
        "delta": 0.0559
      },
      {
        "periodo": 202512,
        "valor": 6.0511,
        "delta": 0.1372
      },
      {
        "periodo": 202601,
        "valor": 6.089,
        "delta": 0.038
      },
      {
        "periodo": 202602,
        "valor": 6.1103,
        "delta": 0.0213
      },
      {
        "periodo": 202603,
        "valor": 6.3064,
        "delta": 0.1962
      },
      {
        "periodo": 202604,
        "valor": 6.1548,
        "delta": -0.1517
      },
      {
        "periodo": 202605,
        "valor": 6.0871,
        "delta": -0.0677
      },
      {
        "periodo": 202606,
        "valor": 6.1868,
        "delta": 0.0997
      },
      {
        "periodo": 202607,
        "valor": 6.1788,
        "delta": -0.008
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 2.727102,
    "valor_anterior": 2.675129,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.9021,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.8071,
        "delta": -0.0949
      },
      {
        "periodo": 202509,
        "valor": 2.7893,
        "delta": -0.0178
      },
      {
        "periodo": 202510,
        "valor": 2.7804,
        "delta": -0.009
      },
      {
        "periodo": 202511,
        "valor": 2.7386,
        "delta": -0.0418
      },
      {
        "periodo": 202512,
        "valor": 2.5404,
        "delta": -0.1982
      },
      {
        "periodo": 202601,
        "valor": 2.5606,
        "delta": 0.0202
      },
      {
        "periodo": 202602,
        "valor": 2.5064,
        "delta": -0.0542
      },
      {
        "periodo": 202603,
        "valor": 2.5039,
        "delta": -0.0026
      },
      {
        "periodo": 202604,
        "valor": 2.7451,
        "delta": 0.2412
      },
      {
        "periodo": 202605,
        "valor": 2.7067,
        "delta": -0.0384
      },
      {
        "periodo": 202606,
        "valor": 2.6751,
        "delta": -0.0316
      },
      {
        "periodo": 202607,
        "valor": 2.7271,
        "delta": 0.052
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 3.126454,
    "valor_anterior": 3.1487179999999997,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.6395,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.6714,
        "delta": 0.032
      },
      {
        "periodo": 202509,
        "valor": 2.6601,
        "delta": -0.0113
      },
      {
        "periodo": 202510,
        "valor": 2.7113,
        "delta": 0.0511
      },
      {
        "periodo": 202511,
        "valor": 2.6205,
        "delta": -0.0908
      },
      {
        "periodo": 202512,
        "valor": 2.6326,
        "delta": 0.0121
      },
      {
        "periodo": 202601,
        "valor": 2.6052,
        "delta": -0.0275
      },
      {
        "periodo": 202602,
        "valor": 2.6,
        "delta": -0.0052
      },
      {
        "periodo": 202603,
        "valor": 2.6699,
        "delta": 0.0699
      },
      {
        "periodo": 202604,
        "valor": 3.179,
        "delta": 0.5091
      },
      {
        "periodo": 202605,
        "valor": 3.2787,
        "delta": 0.0997
      },
      {
        "periodo": 202606,
        "valor": 3.1487,
        "delta": -0.13
      },
      {
        "periodo": 202607,
        "valor": 3.1265,
        "delta": -0.0223
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 3.5724859999999996,
    "valor_anterior": 3.510277,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.0738,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.3241,
        "delta": 0.2503
      },
      {
        "periodo": 202509,
        "valor": 3.7213,
        "delta": 0.3972
      },
      {
        "periodo": 202510,
        "valor": 3.6629,
        "delta": -0.0584
      },
      {
        "periodo": 202511,
        "valor": 3.5618,
        "delta": -0.1011
      },
      {
        "periodo": 202512,
        "valor": 3.0672,
        "delta": -0.4945
      },
      {
        "periodo": 202601,
        "valor": 3.1655,
        "delta": 0.0983
      },
      {
        "periodo": 202602,
        "valor": 3.1945,
        "delta": 0.029
      },
      {
        "periodo": 202603,
        "valor": 3.1133,
        "delta": -0.0812
      },
      {
        "periodo": 202604,
        "valor": 3.4037,
        "delta": 0.2904
      },
      {
        "periodo": 202605,
        "valor": 3.639,
        "delta": 0.2353
      },
      {
        "periodo": 202606,
        "valor": 3.5103,
        "delta": -0.1287
      },
      {
        "periodo": 202607,
        "valor": 3.5725,
        "delta": 0.0622
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 4.911172,
    "valor_anterior": 4.974619000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5.2203,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5.236,
        "delta": 0.0156
      },
      {
        "periodo": 202509,
        "valor": 5.3436,
        "delta": 0.1077
      },
      {
        "periodo": 202510,
        "valor": 5.3604,
        "delta": 0.0168
      },
      {
        "periodo": 202511,
        "valor": 5.4071,
        "delta": 0.0467
      },
      {
        "periodo": 202512,
        "valor": 5.3281,
        "delta": -0.079
      },
      {
        "periodo": 202601,
        "valor": 5.1391,
        "delta": -0.1891
      },
      {
        "periodo": 202602,
        "valor": 5.1282,
        "delta": -0.0109
      },
      {
        "periodo": 202603,
        "valor": 5.0644,
        "delta": -0.0638
      },
      {
        "periodo": 202604,
        "valor": 5.0729,
        "delta": 0.0085
      },
      {
        "periodo": 202605,
        "valor": 5.0305,
        "delta": -0.0423
      },
      {
        "periodo": 202606,
        "valor": 4.9746,
        "delta": -0.0559
      },
      {
        "periodo": 202607,
        "valor": 4.9112,
        "delta": -0.0634
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 2.461773,
    "valor_anterior": 2.434885,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.2679,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.3835,
        "delta": 0.1157
      },
      {
        "periodo": 202509,
        "valor": 2.3454,
        "delta": -0.0382
      },
      {
        "periodo": 202510,
        "valor": 2.4969,
        "delta": 0.1516
      },
      {
        "periodo": 202511,
        "valor": 2.5457,
        "delta": 0.0487
      },
      {
        "periodo": 202512,
        "valor": 2.1873,
        "delta": -0.3584
      },
      {
        "periodo": 202601,
        "valor": 2.1197,
        "delta": -0.0676
      },
      {
        "periodo": 202602,
        "valor": 2.554,
        "delta": 0.4344
      },
      {
        "periodo": 202603,
        "valor": 2.4344,
        "delta": -0.1197
      },
      {
        "periodo": 202604,
        "valor": 2.4342,
        "delta": -0.0002
      },
      {
        "periodo": 202605,
        "valor": 2.3927,
        "delta": -0.0415
      },
      {
        "periodo": 202606,
        "valor": 2.4349,
        "delta": 0.0422
      },
      {
        "periodo": 202607,
        "valor": 2.4618,
        "delta": 0.0269
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 9.702081999999999,
    "valor_anterior": 9.670589,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8.0765,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.4953,
        "delta": 0.4188
      },
      {
        "periodo": 202509,
        "valor": 8.5591,
        "delta": 0.0638
      },
      {
        "periodo": 202510,
        "valor": 8.8823,
        "delta": 0.3232
      },
      {
        "periodo": 202511,
        "valor": 8.9769,
        "delta": 0.0946
      },
      {
        "periodo": 202512,
        "valor": 9.3546,
        "delta": 0.3777
      },
      {
        "periodo": 202601,
        "valor": 9.7539,
        "delta": 0.3993
      },
      {
        "periodo": 202602,
        "valor": 10.0177,
        "delta": 0.2639
      },
      {
        "periodo": 202603,
        "valor": 9.4774,
        "delta": -0.5403
      },
      {
        "periodo": 202604,
        "valor": 9.3919,
        "delta": -0.0855
      },
      {
        "periodo": 202605,
        "valor": 9.5049,
        "delta": 0.113
      },
      {
        "periodo": 202606,
        "valor": 9.6706,
        "delta": 0.1657
      },
      {
        "periodo": 202607,
        "valor": 9.7021,
        "delta": 0.0315
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 4.906821,
    "valor_anterior": 4.565535,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.6977,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.542,
        "delta": -0.1557
      },
      {
        "periodo": 202509,
        "valor": 3.6774,
        "delta": 0.1354
      },
      {
        "periodo": 202510,
        "valor": 3.624,
        "delta": -0.0533
      },
      {
        "periodo": 202511,
        "valor": 3.5415,
        "delta": -0.0825
      },
      {
        "periodo": 202512,
        "valor": 3.481,
        "delta": -0.0605
      },
      {
        "periodo": 202601,
        "valor": 3.7485,
        "delta": 0.2674
      },
      {
        "periodo": 202602,
        "valor": 3.7923,
        "delta": 0.0438
      },
      {
        "periodo": 202603,
        "valor": 4.3115,
        "delta": 0.5192
      },
      {
        "periodo": 202604,
        "valor": 4.5946,
        "delta": 0.2832
      },
      {
        "periodo": 202605,
        "valor": 4.5241,
        "delta": -0.0705
      },
      {
        "periodo": 202606,
        "valor": 4.5655,
        "delta": 0.0414
      },
      {
        "periodo": 202607,
        "valor": 4.9068,
        "delta": 0.3413
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 6.362512,
    "valor_anterior": 6.357805,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6.8321,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6.8052,
        "delta": -0.0269
      },
      {
        "periodo": 202509,
        "valor": 6.7623,
        "delta": -0.0429
      },
      {
        "periodo": 202510,
        "valor": 6.8292,
        "delta": 0.0669
      },
      {
        "periodo": 202511,
        "valor": 5.7867,
        "delta": -1.0426
      },
      {
        "periodo": 202512,
        "valor": 5.6792,
        "delta": -0.1075
      },
      {
        "periodo": 202601,
        "valor": 5.6952,
        "delta": 0.016
      },
      {
        "periodo": 202602,
        "valor": 5.7528,
        "delta": 0.0576
      },
      {
        "periodo": 202603,
        "valor": 5.9569,
        "delta": 0.204
      },
      {
        "periodo": 202604,
        "valor": 6.0297,
        "delta": 0.0729
      },
      {
        "periodo": 202605,
        "valor": 6.1767,
        "delta": 0.147
      },
      {
        "periodo": 202606,
        "valor": 6.3578,
        "delta": 0.1811
      },
      {
        "periodo": 202607,
        "valor": 6.3625,
        "delta": 0.0047
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 3.299911,
    "valor_anterior": 3.3303220000000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.8059,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.7984,
        "delta": -0.0074
      },
      {
        "periodo": 202509,
        "valor": 3.0775,
        "delta": 0.2791
      },
      {
        "periodo": 202510,
        "valor": 3.0646,
        "delta": -0.0129
      },
      {
        "periodo": 202511,
        "valor": 3.0273,
        "delta": -0.0374
      },
      {
        "periodo": 202512,
        "valor": 3.0446,
        "delta": 0.0174
      },
      {
        "periodo": 202601,
        "valor": 3.1402,
        "delta": 0.0956
      },
      {
        "periodo": 202602,
        "valor": 3.2006,
        "delta": 0.0603
      },
      {
        "periodo": 202603,
        "valor": 3.1812,
        "delta": -0.0193
      },
      {
        "periodo": 202604,
        "valor": 3.2254,
        "delta": 0.0442
      },
      {
        "periodo": 202605,
        "valor": 3.2866,
        "delta": 0.0611
      },
      {
        "periodo": 202606,
        "valor": 3.3303,
        "delta": 0.0438
      },
      {
        "periodo": 202607,
        "valor": 3.2999,
        "delta": -0.0304
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 1.8655499999999998,
    "valor_anterior": 1.7713079999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.8272,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.5701,
        "delta": -0.2571
      },
      {
        "periodo": 202509,
        "valor": 1.5554,
        "delta": -0.0147
      },
      {
        "periodo": 202510,
        "valor": 1.4986,
        "delta": -0.0568
      },
      {
        "periodo": 202511,
        "valor": 1.5131,
        "delta": 0.0145
      },
      {
        "periodo": 202512,
        "valor": 1.3649,
        "delta": -0.1481
      },
      {
        "periodo": 202601,
        "valor": 1.3569,
        "delta": -0.0081
      },
      {
        "periodo": 202602,
        "valor": 1.4028,
        "delta": 0.0459
      },
      {
        "periodo": 202603,
        "valor": 1.4013,
        "delta": -0.0015
      },
      {
        "periodo": 202604,
        "valor": 1.5585,
        "delta": 0.1572
      },
      {
        "periodo": 202605,
        "valor": 1.6273,
        "delta": 0.0688
      },
      {
        "periodo": 202606,
        "valor": 1.7713,
        "delta": 0.144
      },
      {
        "periodo": 202607,
        "valor": 1.8655,
        "delta": 0.0942
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 2.693144,
    "valor_anterior": 2.641166,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.0634,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.0463,
        "delta": -0.0171
      },
      {
        "periodo": 202509,
        "valor": 2.9281,
        "delta": -0.1182
      },
      {
        "periodo": 202510,
        "valor": 2.8555,
        "delta": -0.0727
      },
      {
        "periodo": 202511,
        "valor": 3.4618,
        "delta": 0.6064
      },
      {
        "periodo": 202512,
        "valor": 3.5304,
        "delta": 0.0685
      },
      {
        "periodo": 202601,
        "valor": 3.5757,
        "delta": 0.0454
      },
      {
        "periodo": 202602,
        "valor": 3.1409,
        "delta": -0.4348
      },
      {
        "periodo": 202603,
        "valor": 3.2566,
        "delta": 0.1157
      },
      {
        "periodo": 202604,
        "valor": 3.3437,
        "delta": 0.087
      },
      {
        "periodo": 202605,
        "valor": 3.2543,
        "delta": -0.0893
      },
      {
        "periodo": 202606,
        "valor": 2.6412,
        "delta": -0.6132
      },
      {
        "periodo": 202607,
        "valor": 2.6931,
        "delta": 0.052
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 1.476794,
    "valor_anterior": 1.55635,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.4899,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.5344,
        "delta": 0.0446
      },
      {
        "periodo": 202509,
        "valor": 1.5826,
        "delta": 0.0482
      },
      {
        "periodo": 202510,
        "valor": 1.5575,
        "delta": -0.0251
      },
      {
        "periodo": 202511,
        "valor": 1.581,
        "delta": 0.0235
      },
      {
        "periodo": 202512,
        "valor": 1.4358,
        "delta": -0.1451
      },
      {
        "periodo": 202601,
        "valor": 1.448,
        "delta": 0.0121
      },
      {
        "periodo": 202602,
        "valor": 1.5421,
        "delta": 0.0941
      },
      {
        "periodo": 202603,
        "valor": 1.4441,
        "delta": -0.0979
      },
      {
        "periodo": 202604,
        "valor": 1.5527,
        "delta": 0.1086
      },
      {
        "periodo": 202605,
        "valor": 1.5779,
        "delta": 0.0252
      },
      {
        "periodo": 202606,
        "valor": 1.5563,
        "delta": -0.0216
      },
      {
        "periodo": 202607,
        "valor": 1.4768,
        "delta": -0.0796
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 13.036797,
    "valor_anterior": 12.443347000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.4942,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.9224,
        "delta": 0.4283
      },
      {
        "periodo": 202509,
        "valor": 10.3238,
        "delta": 0.4013
      },
      {
        "periodo": 202510,
        "valor": 11.0416,
        "delta": 0.7178
      },
      {
        "periodo": 202511,
        "valor": 11.6818,
        "delta": 0.6402
      },
      {
        "periodo": 202512,
        "valor": 12.0133,
        "delta": 0.3315
      },
      {
        "periodo": 202601,
        "valor": 11.8502,
        "delta": -0.1632
      },
      {
        "periodo": 202602,
        "valor": 11.7678,
        "delta": -0.0824
      },
      {
        "periodo": 202603,
        "valor": 12.0503,
        "delta": 0.2825
      },
      {
        "periodo": 202604,
        "valor": 12.1053,
        "delta": 0.055
      },
      {
        "periodo": 202605,
        "valor": 12.3446,
        "delta": 0.2393
      },
      {
        "periodo": 202606,
        "valor": 12.4433,
        "delta": 0.0988
      },
      {
        "periodo": 202607,
        "valor": 13.0368,
        "delta": 0.5934
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 3.450461,
    "valor_anterior": 3.286243,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.5352,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.0177,
        "delta": -0.5175
      },
      {
        "periodo": 202509,
        "valor": 1.5906,
        "delta": -1.4272
      },
      {
        "periodo": 202510,
        "valor": 1.9747,
        "delta": 0.3841
      },
      {
        "periodo": 202511,
        "valor": 2.0833,
        "delta": 0.1086
      },
      {
        "periodo": 202512,
        "valor": 2.5256,
        "delta": 0.4423
      },
      {
        "periodo": 202601,
        "valor": 3.0977,
        "delta": 0.5721
      },
      {
        "periodo": 202602,
        "valor": 2.9745,
        "delta": -0.1232
      },
      {
        "periodo": 202603,
        "valor": 2.8631,
        "delta": -0.1114
      },
      {
        "periodo": 202604,
        "valor": 2.9186,
        "delta": 0.0554
      },
      {
        "periodo": 202605,
        "valor": 3.2544,
        "delta": 0.3358
      },
      {
        "periodo": 202606,
        "valor": 3.2862,
        "delta": 0.0318
      },
      {
        "periodo": 202607,
        "valor": 3.4505,
        "delta": 0.1642
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 14.676542000000001,
    "valor_anterior": 14.411096,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11.4005,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.5805,
        "delta": 0.1799
      },
      {
        "periodo": 202509,
        "valor": 12.1578,
        "delta": 0.5773
      },
      {
        "periodo": 202510,
        "valor": 12.2389,
        "delta": 0.0812
      },
      {
        "periodo": 202511,
        "valor": 12.1495,
        "delta": -0.0894
      },
      {
        "periodo": 202512,
        "valor": 12.7726,
        "delta": 0.6231
      },
      {
        "periodo": 202601,
        "valor": 13.4353,
        "delta": 0.6627
      },
      {
        "periodo": 202602,
        "valor": 13.6723,
        "delta": 0.2369
      },
      {
        "periodo": 202603,
        "valor": 13.6075,
        "delta": -0.0648
      },
      {
        "periodo": 202604,
        "valor": 14.0986,
        "delta": 0.4912
      },
      {
        "periodo": 202605,
        "valor": 14.675,
        "delta": 0.5764
      },
      {
        "periodo": 202606,
        "valor": 14.4111,
        "delta": -0.2639
      },
      {
        "periodo": 202607,
        "valor": 14.6765,
        "delta": 0.2654
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 2.303483,
    "valor_anterior": 2.3457,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.8897,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.8339,
        "delta": -0.0558
      },
      {
        "periodo": 202509,
        "valor": 2.9462,
        "delta": 0.1123
      },
      {
        "periodo": 202510,
        "valor": 3.0535,
        "delta": 0.1073
      },
      {
        "periodo": 202511,
        "valor": 2.7332,
        "delta": -0.3203
      },
      {
        "periodo": 202512,
        "valor": 2.3616,
        "delta": -0.3716
      },
      {
        "periodo": 202601,
        "valor": 2.4706,
        "delta": 0.109
      },
      {
        "periodo": 202602,
        "valor": 2.1089,
        "delta": -0.3617
      },
      {
        "periodo": 202603,
        "valor": 2.0521,
        "delta": -0.0568
      },
      {
        "periodo": 202604,
        "valor": 2.3063,
        "delta": 0.2543
      },
      {
        "periodo": 202605,
        "valor": 2.5282,
        "delta": 0.2219
      },
      {
        "periodo": 202606,
        "valor": 2.3457,
        "delta": -0.1825
      },
      {
        "periodo": 202607,
        "valor": 2.3035,
        "delta": -0.0422
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 1.787727,
    "valor_anterior": 1.780704,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.3319,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.1307,
        "delta": -0.2012
      },
      {
        "periodo": 202509,
        "valor": 2.9741,
        "delta": -0.1566
      },
      {
        "periodo": 202510,
        "valor": 3.0916,
        "delta": 0.1175
      },
      {
        "periodo": 202511,
        "valor": 2.6409,
        "delta": -0.4507
      },
      {
        "periodo": 202512,
        "valor": 2.3415,
        "delta": -0.2994
      },
      {
        "periodo": 202601,
        "valor": 2.3764,
        "delta": 0.0349
      },
      {
        "periodo": 202602,
        "valor": 2.3667,
        "delta": -0.0098
      },
      {
        "periodo": 202603,
        "valor": 2.3428,
        "delta": -0.0239
      },
      {
        "periodo": 202604,
        "valor": 2.3531,
        "delta": 0.0103
      },
      {
        "periodo": 202605,
        "valor": 1.7589,
        "delta": -0.5942
      },
      {
        "periodo": 202606,
        "valor": 1.7807,
        "delta": 0.0218
      },
      {
        "periodo": 202607,
        "valor": 1.7877,
        "delta": 0.007
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 80.861756,
    "valor_anterior": 91.033967,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4.9053,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7.1312,
        "delta": 2.2258
      },
      {
        "periodo": 202509,
        "valor": 57.075,
        "delta": 49.9439
      },
      {
        "periodo": 202510,
        "valor": 65.314,
        "delta": 8.239
      },
      {
        "periodo": 202511,
        "valor": 84.7872,
        "delta": 19.4732
      },
      {
        "periodo": 202512,
        "valor": 73.7194,
        "delta": -11.0677
      },
      {
        "periodo": 202601,
        "valor": 75.307,
        "delta": 1.5875
      },
      {
        "periodo": 202602,
        "valor": 70.0802,
        "delta": -5.2268
      },
      {
        "periodo": 202603,
        "valor": 91.3836,
        "delta": 21.3034
      },
      {
        "periodo": 202604,
        "valor": 91.2826,
        "delta": -0.101
      },
      {
        "periodo": 202605,
        "valor": 91.22,
        "delta": -0.0626
      },
      {
        "periodo": 202606,
        "valor": 91.034,
        "delta": -0.1861
      },
      {
        "periodo": 202607,
        "valor": 80.8618,
        "delta": -10.1722
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 7.133239,
    "valor_anterior": 7.301932,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6.1843,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5.6657,
        "delta": -0.5186
      },
      {
        "periodo": 202509,
        "valor": 5.7544,
        "delta": 0.0887
      },
      {
        "periodo": 202510,
        "valor": 5.5448,
        "delta": -0.2096
      },
      {
        "periodo": 202511,
        "valor": 6.002,
        "delta": 0.4572
      },
      {
        "periodo": 202512,
        "valor": 5.5563,
        "delta": -0.4457
      },
      {
        "periodo": 202601,
        "valor": 7.3588,
        "delta": 1.8024
      },
      {
        "periodo": 202602,
        "valor": 7.4451,
        "delta": 0.0863
      },
      {
        "periodo": 202603,
        "valor": 7.6134,
        "delta": 0.1683
      },
      {
        "periodo": 202604,
        "valor": 7.7975,
        "delta": 0.1841
      },
      {
        "periodo": 202605,
        "valor": 7.9562,
        "delta": 0.1587
      },
      {
        "periodo": 202606,
        "valor": 7.3019,
        "delta": -0.6543
      },
      {
        "periodo": 202607,
        "valor": 7.1332,
        "delta": -0.1687
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 25.026242,
    "valor_anterior": 23.891267,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 31.7028,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 31.2932,
        "delta": -0.4097
      },
      {
        "periodo": 202509,
        "valor": 31.0386,
        "delta": -0.2546
      },
      {
        "periodo": 202510,
        "valor": 30.5733,
        "delta": -0.4653
      },
      {
        "periodo": 202511,
        "valor": 28.7568,
        "delta": -1.8165
      },
      {
        "periodo": 202512,
        "valor": 29.1379,
        "delta": 0.3811
      },
      {
        "periodo": 202601,
        "valor": 29.0065,
        "delta": -0.1314
      },
      {
        "periodo": 202602,
        "valor": 28.0282,
        "delta": -0.9784
      },
      {
        "periodo": 202603,
        "valor": 25.4145,
        "delta": -2.6137
      },
      {
        "periodo": 202604,
        "valor": 24.4546,
        "delta": -0.9599
      },
      {
        "periodo": 202605,
        "valor": 22.8635,
        "delta": -1.5912
      },
      {
        "periodo": 202606,
        "valor": 23.8913,
        "delta": 1.0278
      },
      {
        "periodo": 202607,
        "valor": 25.0262,
        "delta": 1.135
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 3.08445,
    "valor_anterior": 2.937182,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.0616,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.9603,
        "delta": -0.1013
      },
      {
        "periodo": 202509,
        "valor": 2.937,
        "delta": -0.0232
      },
      {
        "periodo": 202510,
        "valor": 2.9418,
        "delta": 0.0048
      },
      {
        "periodo": 202511,
        "valor": 3.0062,
        "delta": 0.0644
      },
      {
        "periodo": 202512,
        "valor": 3.0186,
        "delta": 0.0124
      },
      {
        "periodo": 202601,
        "valor": 2.943,
        "delta": -0.0756
      },
      {
        "periodo": 202602,
        "valor": 3.0054,
        "delta": 0.0623
      },
      {
        "periodo": 202603,
        "valor": 2.8502,
        "delta": -0.1551
      },
      {
        "periodo": 202604,
        "valor": 2.8582,
        "delta": 0.008
      },
      {
        "periodo": 202605,
        "valor": 2.8988,
        "delta": 0.0406
      },
      {
        "periodo": 202606,
        "valor": 2.9372,
        "delta": 0.0383
      },
      {
        "periodo": 202607,
        "valor": 3.0844,
        "delta": 0.1473
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 2.234197,
    "valor_anterior": 2.294204,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.6161,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.6567,
        "delta": 0.0406
      },
      {
        "periodo": 202509,
        "valor": 1.6917,
        "delta": 0.035
      },
      {
        "periodo": 202510,
        "valor": 1.724,
        "delta": 0.0323
      },
      {
        "periodo": 202511,
        "valor": 1.6074,
        "delta": -0.1166
      },
      {
        "periodo": 202512,
        "valor": 1.633,
        "delta": 0.0256
      },
      {
        "periodo": 202601,
        "valor": 1.6177,
        "delta": -0.0153
      },
      {
        "periodo": 202602,
        "valor": 1.5966,
        "delta": -0.0212
      },
      {
        "periodo": 202603,
        "valor": 1.8373,
        "delta": 0.2407
      },
      {
        "periodo": 202604,
        "valor": 1.9619,
        "delta": 0.1246
      },
      {
        "periodo": 202605,
        "valor": 2.1435,
        "delta": 0.1816
      },
      {
        "periodo": 202606,
        "valor": 2.2942,
        "delta": 0.1507
      },
      {
        "periodo": 202607,
        "valor": 2.2342,
        "delta": -0.06
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5.0646,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14.5907,
        "delta": 9.5261
      },
      {
        "periodo": 202509,
        "valor": 100.0,
        "delta": 85.4093
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 3.444796,
    "valor_anterior": 3.411721,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.1417,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.3503,
        "delta": 0.2086
      },
      {
        "periodo": 202509,
        "valor": 3.2163,
        "delta": -0.134
      },
      {
        "periodo": 202510,
        "valor": 3.3444,
        "delta": 0.1281
      },
      {
        "periodo": 202511,
        "valor": 3.3089,
        "delta": -0.0355
      },
      {
        "periodo": 202512,
        "valor": 3.3865,
        "delta": 0.0776
      },
      {
        "periodo": 202601,
        "valor": 3.356,
        "delta": -0.0305
      },
      {
        "periodo": 202602,
        "valor": 3.3589,
        "delta": 0.0028
      },
      {
        "periodo": 202603,
        "valor": 3.6207,
        "delta": 0.2619
      },
      {
        "periodo": 202604,
        "valor": 2.8657,
        "delta": -0.755
      },
      {
        "periodo": 202605,
        "valor": 3.3957,
        "delta": 0.53
      },
      {
        "periodo": 202606,
        "valor": 3.4117,
        "delta": 0.016
      },
      {
        "periodo": 202607,
        "valor": 3.4448,
        "delta": 0.0331
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 0.622836,
    "valor_anterior": 0.6457649999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.8858,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.8511,
        "delta": -0.0347
      },
      {
        "periodo": 202509,
        "valor": 0.7878,
        "delta": -0.0633
      },
      {
        "periodo": 202510,
        "valor": 0.8585,
        "delta": 0.0707
      },
      {
        "periodo": 202511,
        "valor": 0.8114,
        "delta": -0.0471
      },
      {
        "periodo": 202512,
        "valor": 0.7827,
        "delta": -0.0287
      },
      {
        "periodo": 202601,
        "valor": 0.7392,
        "delta": -0.0435
      },
      {
        "periodo": 202602,
        "valor": 0.7065,
        "delta": -0.0326
      },
      {
        "periodo": 202603,
        "valor": 0.6805,
        "delta": -0.026
      },
      {
        "periodo": 202604,
        "valor": 0.6592,
        "delta": -0.0213
      },
      {
        "periodo": 202605,
        "valor": 0.6171,
        "delta": -0.0421
      },
      {
        "periodo": 202606,
        "valor": 0.6458,
        "delta": 0.0287
      },
      {
        "periodo": 202607,
        "valor": 0.6228,
        "delta": -0.0229
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 23.723879,
    "valor_anterior": 22.994546,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 24.7576,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 23.4061,
        "delta": -1.3515
      },
      {
        "periodo": 202509,
        "valor": 21.7898,
        "delta": -1.6162
      },
      {
        "periodo": 202510,
        "valor": 20.8352,
        "delta": -0.9546
      },
      {
        "periodo": 202511,
        "valor": 20.4993,
        "delta": -0.3359
      },
      {
        "periodo": 202512,
        "valor": 20.6123,
        "delta": 0.113
      },
      {
        "periodo": 202601,
        "valor": 21.3831,
        "delta": 0.7708
      },
      {
        "periodo": 202602,
        "valor": 21.9366,
        "delta": 0.5534
      },
      {
        "periodo": 202603,
        "valor": 21.5686,
        "delta": -0.368
      },
      {
        "periodo": 202604,
        "valor": 21.8474,
        "delta": 0.2788
      },
      {
        "periodo": 202605,
        "valor": 22.6522,
        "delta": 0.8048
      },
      {
        "periodo": 202606,
        "valor": 22.9945,
        "delta": 0.3423
      },
      {
        "periodo": 202607,
        "valor": 23.7239,
        "delta": 0.7293
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 2.482322,
    "valor_anterior": 2.6198960000000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.003,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.9597,
        "delta": -0.0433
      },
      {
        "periodo": 202509,
        "valor": 2.8964,
        "delta": -0.0633
      },
      {
        "periodo": 202510,
        "valor": 2.8783,
        "delta": -0.0181
      },
      {
        "periodo": 202511,
        "valor": 2.8797,
        "delta": 0.0014
      },
      {
        "periodo": 202512,
        "valor": 2.5304,
        "delta": -0.3493
      },
      {
        "periodo": 202601,
        "valor": 2.4997,
        "delta": -0.0306
      },
      {
        "periodo": 202602,
        "valor": 2.5014,
        "delta": 0.0017
      },
      {
        "periodo": 202603,
        "valor": 2.4675,
        "delta": -0.0339
      },
      {
        "periodo": 202604,
        "valor": 2.6307,
        "delta": 0.1632
      },
      {
        "periodo": 202605,
        "valor": 2.5883,
        "delta": -0.0424
      },
      {
        "periodo": 202606,
        "valor": 2.6199,
        "delta": 0.0316
      },
      {
        "periodo": 202607,
        "valor": 2.4823,
        "delta": -0.1376
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 0.25622,
    "valor_anterior": 0.270044,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.1978,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.2073,
        "delta": 0.0095
      },
      {
        "periodo": 202509,
        "valor": 0.2145,
        "delta": 0.0072
      },
      {
        "periodo": 202510,
        "valor": 0.2194,
        "delta": 0.0049
      },
      {
        "periodo": 202511,
        "valor": 0.2229,
        "delta": 0.0036
      },
      {
        "periodo": 202512,
        "valor": 0.2179,
        "delta": -0.005
      },
      {
        "periodo": 202601,
        "valor": 0.2351,
        "delta": 0.0172
      },
      {
        "periodo": 202602,
        "valor": 0.2383,
        "delta": 0.0032
      },
      {
        "periodo": 202603,
        "valor": 0.2363,
        "delta": -0.002
      },
      {
        "periodo": 202604,
        "valor": 0.2383,
        "delta": 0.002
      },
      {
        "periodo": 202605,
        "valor": 0.2525,
        "delta": 0.0142
      },
      {
        "periodo": 202606,
        "valor": 0.27,
        "delta": 0.0175
      },
      {
        "periodo": 202607,
        "valor": 0.2562,
        "delta": -0.0138
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 2.8549,
    "valor_anterior": 2.857815,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.0352,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.1352,
        "delta": 1.1
      },
      {
        "periodo": 202509,
        "valor": 2.1386,
        "delta": 0.0034
      },
      {
        "periodo": 202510,
        "valor": 2.0789,
        "delta": -0.0597
      },
      {
        "periodo": 202511,
        "valor": 1.9756,
        "delta": -0.1032
      },
      {
        "periodo": 202512,
        "valor": 1.9017,
        "delta": -0.0739
      },
      {
        "periodo": 202601,
        "valor": 2.7079,
        "delta": 0.8062
      },
      {
        "periodo": 202602,
        "valor": 2.7036,
        "delta": -0.0043
      },
      {
        "periodo": 202603,
        "valor": 2.6465,
        "delta": -0.0571
      },
      {
        "periodo": 202604,
        "valor": 2.6376,
        "delta": -0.0089
      },
      {
        "periodo": 202605,
        "valor": 2.818,
        "delta": 0.1804
      },
      {
        "periodo": 202606,
        "valor": 2.8578,
        "delta": 0.0398
      },
      {
        "periodo": 202607,
        "valor": 2.8549,
        "delta": -0.0029
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 5.319819,
    "valor_anterior": 5.376188,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5.7073,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5.5028,
        "delta": -0.2046
      },
      {
        "periodo": 202509,
        "valor": 5.3408,
        "delta": -0.1619
      },
      {
        "periodo": 202510,
        "valor": 5.3529,
        "delta": 0.0121
      },
      {
        "periodo": 202511,
        "valor": 5.3457,
        "delta": -0.0072
      },
      {
        "periodo": 202512,
        "valor": 5.5103,
        "delta": 0.1646
      },
      {
        "periodo": 202601,
        "valor": 5.9946,
        "delta": 0.4844
      },
      {
        "periodo": 202602,
        "valor": 5.6211,
        "delta": -0.3735
      },
      {
        "periodo": 202603,
        "valor": 5.5551,
        "delta": -0.066
      },
      {
        "periodo": 202604,
        "valor": 5.5263,
        "delta": -0.0289
      },
      {
        "periodo": 202605,
        "valor": 5.4599,
        "delta": -0.0663
      },
      {
        "periodo": 202606,
        "valor": 5.3762,
        "delta": -0.0837
      },
      {
        "periodo": 202607,
        "valor": 5.3198,
        "delta": -0.0564
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 5.039857,
    "valor_anterior": 4.972855,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 1.211,
        "delta": 1.211
      },
      {
        "periodo": 202602,
        "valor": 0.5486,
        "delta": -0.6624
      },
      {
        "periodo": 202603,
        "valor": 0.5728,
        "delta": 0.0242
      },
      {
        "periodo": 202604,
        "valor": 5.8343,
        "delta": 5.2615
      },
      {
        "periodo": 202605,
        "valor": 5.5288,
        "delta": -0.3055
      },
      {
        "periodo": 202606,
        "valor": 4.9729,
        "delta": -0.556
      },
      {
        "periodo": 202607,
        "valor": 5.0399,
        "delta": 0.067
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 2.0546100000000003,
    "valor_anterior": 2.096162,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.2519,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.037,
        "delta": -0.2149
      },
      {
        "periodo": 202509,
        "valor": 1.8836,
        "delta": -0.1534
      },
      {
        "periodo": 202510,
        "valor": 1.8076,
        "delta": -0.076
      },
      {
        "periodo": 202511,
        "valor": 1.7934,
        "delta": -0.0142
      },
      {
        "periodo": 202512,
        "valor": 1.7223,
        "delta": -0.0711
      },
      {
        "periodo": 202601,
        "valor": 1.9456,
        "delta": 0.2233
      },
      {
        "periodo": 202602,
        "valor": 1.8916,
        "delta": -0.054
      },
      {
        "periodo": 202603,
        "valor": 1.9692,
        "delta": 0.0776
      },
      {
        "periodo": 202604,
        "valor": 1.9904,
        "delta": 0.0211
      },
      {
        "periodo": 202605,
        "valor": 1.9995,
        "delta": 0.0091
      },
      {
        "periodo": 202606,
        "valor": 2.0962,
        "delta": 0.0967
      },
      {
        "periodo": 202607,
        "valor": 2.0546,
        "delta": -0.0416
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 0.557891,
    "valor_anterior": 1.223125,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.2231,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.2405,
        "delta": 0.0174
      },
      {
        "periodo": 202509,
        "valor": 1.2793,
        "delta": 0.0388
      },
      {
        "periodo": 202510,
        "valor": 1.3617,
        "delta": 0.0824
      },
      {
        "periodo": 202511,
        "valor": 1.3575,
        "delta": -0.0043
      },
      {
        "periodo": 202512,
        "valor": 1.3838,
        "delta": 0.0264
      },
      {
        "periodo": 202601,
        "valor": 1.4453,
        "delta": 0.0615
      },
      {
        "periodo": 202602,
        "valor": 1.4667,
        "delta": 0.0214
      },
      {
        "periodo": 202603,
        "valor": 1.436,
        "delta": -0.0307
      },
      {
        "periodo": 202604,
        "valor": 1.2369,
        "delta": -0.199
      },
      {
        "periodo": 202605,
        "valor": 1.2925,
        "delta": 0.0555
      },
      {
        "periodo": 202606,
        "valor": 1.2231,
        "delta": -0.0693
      },
      {
        "periodo": 202607,
        "valor": 0.5579,
        "delta": -0.6652
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 2.070394,
    "valor_anterior": 2.204886,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.3688,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4.2112,
        "delta": 0.8425
      },
      {
        "periodo": 202509,
        "valor": 4.2182,
        "delta": 0.0069
      },
      {
        "periodo": 202510,
        "valor": 3.5515,
        "delta": -0.6667
      },
      {
        "periodo": 202511,
        "valor": 3.616,
        "delta": 0.0645
      },
      {
        "periodo": 202512,
        "valor": 3.7119,
        "delta": 0.0959
      },
      {
        "periodo": 202601,
        "valor": 3.5375,
        "delta": -0.1744
      },
      {
        "periodo": 202602,
        "valor": 3.2396,
        "delta": -0.2979
      },
      {
        "periodo": 202603,
        "valor": 2.7492,
        "delta": -0.4904
      },
      {
        "periodo": 202604,
        "valor": 2.5067,
        "delta": -0.2425
      },
      {
        "periodo": 202605,
        "valor": 2.4793,
        "delta": -0.0274
      },
      {
        "periodo": 202606,
        "valor": 2.2049,
        "delta": -0.2744
      },
      {
        "periodo": 202607,
        "valor": 2.0704,
        "delta": -0.1345
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 1.70325,
    "valor_anterior": 1.7014789999999997,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.4856,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.6,
        "delta": 0.1144
      },
      {
        "periodo": 202509,
        "valor": 1.6427,
        "delta": 0.0427
      },
      {
        "periodo": 202510,
        "valor": 1.6317,
        "delta": -0.011
      },
      {
        "periodo": 202511,
        "valor": 1.6015,
        "delta": -0.0303
      },
      {
        "periodo": 202512,
        "valor": 1.6464,
        "delta": 0.0449
      },
      {
        "periodo": 202601,
        "valor": 1.7107,
        "delta": 0.0643
      },
      {
        "periodo": 202602,
        "valor": 1.7432,
        "delta": 0.0325
      },
      {
        "periodo": 202603,
        "valor": 1.704,
        "delta": -0.0392
      },
      {
        "periodo": 202604,
        "valor": 1.7431,
        "delta": 0.0391
      },
      {
        "periodo": 202605,
        "valor": 1.8048,
        "delta": 0.0617
      },
      {
        "periodo": 202606,
        "valor": 1.7015,
        "delta": -0.1033
      },
      {
        "periodo": 202607,
        "valor": 1.7032,
        "delta": 0.0018
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 97.523832,
    "valor_anterior": 96.873539,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 79.2062,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 85.0362,
        "delta": 5.83
      },
      {
        "periodo": 202509,
        "valor": 88.8998,
        "delta": 3.8636
      },
      {
        "periodo": 202510,
        "valor": 91.6994,
        "delta": 2.7996
      },
      {
        "periodo": 202511,
        "valor": 93.1163,
        "delta": 1.4169
      },
      {
        "periodo": 202512,
        "valor": 94.758,
        "delta": 1.6417
      },
      {
        "periodo": 202601,
        "valor": 95.6904,
        "delta": 0.9323
      },
      {
        "periodo": 202602,
        "valor": 96.1672,
        "delta": 0.4768
      },
      {
        "periodo": 202603,
        "valor": 96.5053,
        "delta": 0.3381
      },
      {
        "periodo": 202604,
        "valor": 96.8382,
        "delta": 0.3329
      },
      {
        "periodo": 202605,
        "valor": 96.7965,
        "delta": -0.0417
      },
      {
        "periodo": 202606,
        "valor": 96.8735,
        "delta": 0.0771
      },
      {
        "periodo": 202607,
        "valor": 97.5238,
        "delta": 0.6503
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 3.8563849999999995,
    "valor_anterior": 3.449245,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1.974,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 2.3056,
        "delta": 0.3316
      },
      {
        "periodo": 202604,
        "valor": 2.6977,
        "delta": 0.3922
      },
      {
        "periodo": 202605,
        "valor": 3.1546,
        "delta": 0.4569
      },
      {
        "periodo": 202606,
        "valor": 3.4492,
        "delta": 0.2946
      },
      {
        "periodo": 202607,
        "valor": 3.8564,
        "delta": 0.4071
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 34.751059,
    "valor_anterior": 32.849251,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.9095,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.3633,
        "delta": 1.4538
      },
      {
        "periodo": 202509,
        "valor": 4.9834,
        "delta": 2.6201
      },
      {
        "periodo": 202510,
        "valor": 10.7541,
        "delta": 5.7707
      },
      {
        "periodo": 202511,
        "valor": 16.8685,
        "delta": 6.1143
      },
      {
        "periodo": 202512,
        "valor": 20.9342,
        "delta": 4.0657
      },
      {
        "periodo": 202601,
        "valor": 24.4666,
        "delta": 3.5324
      },
      {
        "periodo": 202602,
        "valor": 25.6249,
        "delta": 1.1583
      },
      {
        "periodo": 202603,
        "valor": 26.4719,
        "delta": 0.847
      },
      {
        "periodo": 202604,
        "valor": 29.012,
        "delta": 2.5402
      },
      {
        "periodo": 202605,
        "valor": 31.3455,
        "delta": 2.3334
      },
      {
        "periodo": 202606,
        "valor": 32.8493,
        "delta": 1.5038
      },
      {
        "periodo": 202607,
        "valor": 34.7511,
        "delta": 1.9018
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 0.21547900000000003,
    "valor_anterior": 0.179342,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0161,
        "delta": 0.0161
      },
      {
        "periodo": 202604,
        "valor": 0.0111,
        "delta": -0.005
      },
      {
        "periodo": 202605,
        "valor": 0.1899,
        "delta": 0.1788
      },
      {
        "periodo": 202606,
        "valor": 0.1793,
        "delta": -0.0105
      },
      {
        "periodo": 202607,
        "valor": 0.2155,
        "delta": 0.0361
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 10.944949,
    "valor_anterior": 10.286349,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 7.6236,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 8.6858,
        "delta": 1.0622
      },
      {
        "periodo": 202605,
        "valor": 9.8548,
        "delta": 1.169
      },
      {
        "periodo": 202606,
        "valor": 10.2863,
        "delta": 0.4315
      },
      {
        "periodo": 202607,
        "valor": 10.9449,
        "delta": 0.6586
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 4.743693,
    "valor_anterior": 4.715378,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4.3274,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4.3873,
        "delta": 0.06
      },
      {
        "periodo": 202509,
        "valor": 4.5027,
        "delta": 0.1154
      },
      {
        "periodo": 202510,
        "valor": 4.5316,
        "delta": 0.0289
      },
      {
        "periodo": 202511,
        "valor": 4.5263,
        "delta": -0.0053
      },
      {
        "periodo": 202512,
        "valor": 4.4789,
        "delta": -0.0475
      },
      {
        "periodo": 202601,
        "valor": 4.5397,
        "delta": 0.0608
      },
      {
        "periodo": 202602,
        "valor": 4.5744,
        "delta": 0.0348
      },
      {
        "periodo": 202603,
        "valor": 4.5479,
        "delta": -0.0265
      },
      {
        "periodo": 202604,
        "valor": 4.6558,
        "delta": 0.1078
      },
      {
        "periodo": 202605,
        "valor": 4.7175,
        "delta": 0.0617
      },
      {
        "periodo": 202606,
        "valor": 4.7154,
        "delta": -0.0021
      },
      {
        "periodo": 202607,
        "valor": 4.7437,
        "delta": 0.0283
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 4.744694,
    "valor_anterior": 4.73279,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4.4064,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4.4475,
        "delta": 0.0411
      },
      {
        "periodo": 202509,
        "valor": 4.5774,
        "delta": 0.1299
      },
      {
        "periodo": 202510,
        "valor": 4.5794,
        "delta": 0.002
      },
      {
        "periodo": 202511,
        "valor": 4.5517,
        "delta": -0.0277
      },
      {
        "periodo": 202512,
        "valor": 4.5348,
        "delta": -0.0169
      },
      {
        "periodo": 202601,
        "valor": 4.5636,
        "delta": 0.0289
      },
      {
        "periodo": 202602,
        "valor": 4.6054,
        "delta": 0.0417
      },
      {
        "periodo": 202603,
        "valor": 4.5717,
        "delta": -0.0336
      },
      {
        "periodo": 202604,
        "valor": 4.6705,
        "delta": 0.0988
      },
      {
        "periodo": 202605,
        "valor": 4.7243,
        "delta": 0.0537
      },
      {
        "periodo": 202606,
        "valor": 4.7328,
        "delta": 0.0085
      },
      {
        "periodo": 202607,
        "valor": 4.7447,
        "delta": 0.0119
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 2.667255,
    "valor_anterior": 3.056789,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.072,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.7811,
        "delta": 0.7091
      },
      {
        "periodo": 202509,
        "valor": 3.9877,
        "delta": 0.2066
      },
      {
        "periodo": 202510,
        "valor": 4.0786,
        "delta": 0.0909
      },
      {
        "periodo": 202511,
        "valor": 4.0121,
        "delta": -0.0664
      },
      {
        "periodo": 202512,
        "valor": 3.0119,
        "delta": -1.0002
      },
      {
        "periodo": 202601,
        "valor": 2.9571,
        "delta": -0.0548
      },
      {
        "periodo": 202602,
        "valor": 2.9031,
        "delta": -0.054
      },
      {
        "periodo": 202603,
        "valor": 2.9237,
        "delta": 0.0206
      },
      {
        "periodo": 202604,
        "valor": 2.9323,
        "delta": 0.0085
      },
      {
        "periodo": 202605,
        "valor": 3.0311,
        "delta": 0.0988
      },
      {
        "periodo": 202606,
        "valor": 3.0568,
        "delta": 0.0257
      },
      {
        "periodo": 202607,
        "valor": 2.6673,
        "delta": -0.3895
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 3.500087,
    "valor_anterior": 3.562589,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.1598,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.2496,
        "delta": 0.0898
      },
      {
        "periodo": 202509,
        "valor": 3.326,
        "delta": 0.0764
      },
      {
        "periodo": 202510,
        "valor": 3.3859,
        "delta": 0.0599
      },
      {
        "periodo": 202511,
        "valor": 3.2468,
        "delta": -0.1391
      },
      {
        "periodo": 202512,
        "valor": 3.21,
        "delta": -0.0368
      },
      {
        "periodo": 202601,
        "valor": 3.3223,
        "delta": 0.1123
      },
      {
        "periodo": 202602,
        "valor": 3.4414,
        "delta": 0.1191
      },
      {
        "periodo": 202603,
        "valor": 3.2867,
        "delta": -0.1547
      },
      {
        "periodo": 202604,
        "valor": 3.413,
        "delta": 0.1263
      },
      {
        "periodo": 202605,
        "valor": 3.5254,
        "delta": 0.1125
      },
      {
        "periodo": 202606,
        "valor": 3.5626,
        "delta": 0.0372
      },
      {
        "periodo": 202607,
        "valor": 3.5001,
        "delta": -0.0625
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 2.618858,
    "valor_anterior": 2.596107,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.6961,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.6841,
        "delta": -0.012
      },
      {
        "periodo": 202509,
        "valor": 2.6948,
        "delta": 0.0107
      },
      {
        "periodo": 202510,
        "valor": 2.7181,
        "delta": 0.0233
      },
      {
        "periodo": 202511,
        "valor": 2.7179,
        "delta": -0.0002
      },
      {
        "periodo": 202512,
        "valor": 2.47,
        "delta": -0.2479
      },
      {
        "periodo": 202601,
        "valor": 2.5176,
        "delta": 0.0476
      },
      {
        "periodo": 202602,
        "valor": 2.5175,
        "delta": -0.0
      },
      {
        "periodo": 202603,
        "valor": 2.4938,
        "delta": -0.0237
      },
      {
        "periodo": 202604,
        "valor": 2.6444,
        "delta": 0.1506
      },
      {
        "periodo": 202605,
        "valor": 2.6709,
        "delta": 0.0265
      },
      {
        "periodo": 202606,
        "valor": 2.5961,
        "delta": -0.0748
      },
      {
        "periodo": 202607,
        "valor": 2.6189,
        "delta": 0.0228
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 2.9964999999999997,
    "valor_anterior": 2.945358,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.5204,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.7246,
        "delta": 0.2042
      },
      {
        "periodo": 202509,
        "valor": 2.5502,
        "delta": -0.1744
      },
      {
        "periodo": 202510,
        "valor": 2.5888,
        "delta": 0.0386
      },
      {
        "periodo": 202511,
        "valor": 2.5341,
        "delta": -0.0547
      },
      {
        "periodo": 202512,
        "valor": 2.5016,
        "delta": -0.0324
      },
      {
        "periodo": 202601,
        "valor": 2.8708,
        "delta": 0.3692
      },
      {
        "periodo": 202602,
        "valor": 2.8171,
        "delta": -0.0537
      },
      {
        "periodo": 202603,
        "valor": 2.8411,
        "delta": 0.024
      },
      {
        "periodo": 202604,
        "valor": 2.9601,
        "delta": 0.119
      },
      {
        "periodo": 202605,
        "valor": 2.9419,
        "delta": -0.0182
      },
      {
        "periodo": 202606,
        "valor": 2.9454,
        "delta": 0.0034
      },
      {
        "periodo": 202607,
        "valor": 2.9965,
        "delta": 0.0511
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200033,
    "label": "IMORA",
    "valor_actual": 10.907134000000001,
    "valor_anterior": 10.56823,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8.5646,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.6586,
        "delta": 0.094
      },
      {
        "periodo": 202509,
        "valor": 8.978,
        "delta": 0.3194
      },
      {
        "periodo": 202510,
        "valor": 9.3417,
        "delta": 0.3637
      },
      {
        "periodo": 202511,
        "valor": 9.7808,
        "delta": 0.4391
      },
      {
        "periodo": 202512,
        "valor": 9.9642,
        "delta": 0.1834
      },
      {
        "periodo": 202601,
        "valor": 10.3249,
        "delta": 0.3607
      },
      {
        "periodo": 202602,
        "valor": 10.1352,
        "delta": -0.1897
      },
      {
        "periodo": 202603,
        "valor": 10.2084,
        "delta": 0.0731
      },
      {
        "periodo": 202604,
        "valor": 10.3647,
        "delta": 0.1563
      },
      {
        "periodo": 202605,
        "valor": 10.6475,
        "delta": 0.2828
      },
      {
        "periodo": 202606,
        "valor": 10.5682,
        "delta": -0.0792
      },
      {
        "periodo": 202607,
        "valor": 10.9071,
        "delta": 0.3389
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 7.998785,
    "valor_anterior": 7.927302,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6.4566,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6.6678,
        "delta": 0.2112
      },
      {
        "periodo": 202509,
        "valor": 6.9047,
        "delta": 0.2369
      },
      {
        "periodo": 202510,
        "valor": 7.1453,
        "delta": 0.2407
      },
      {
        "periodo": 202511,
        "valor": 7.3546,
        "delta": 0.2093
      },
      {
        "periodo": 202512,
        "valor": 7.4498,
        "delta": 0.0952
      },
      {
        "periodo": 202601,
        "valor": 7.4833,
        "delta": 0.0336
      },
      {
        "periodo": 202602,
        "valor": 7.5311,
        "delta": 0.0478
      },
      {
        "periodo": 202603,
        "valor": 7.6724,
        "delta": 0.1413
      },
      {
        "periodo": 202604,
        "valor": 7.7621,
        "delta": 0.0897
      },
      {
        "periodo": 202605,
        "valor": 7.8278,
        "delta": 0.0657
      },
      {
        "periodo": 202606,
        "valor": 7.9273,
        "delta": 0.0995
      },
      {
        "periodo": 202607,
        "valor": 7.9988,
        "delta": 0.0715
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 4.62228,
    "valor_anterior": 4.609804,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4.3309,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4.3418,
        "delta": 0.0109
      },
      {
        "periodo": 202509,
        "valor": 4.3592,
        "delta": 0.0174
      },
      {
        "periodo": 202510,
        "valor": 4.3695,
        "delta": 0.0103
      },
      {
        "periodo": 202511,
        "valor": 4.4195,
        "delta": 0.05
      },
      {
        "periodo": 202512,
        "valor": 4.4873,
        "delta": 0.0678
      },
      {
        "periodo": 202601,
        "valor": 4.5052,
        "delta": 0.0179
      },
      {
        "periodo": 202602,
        "valor": 4.5383,
        "delta": 0.0331
      },
      {
        "periodo": 202603,
        "valor": 4.4845,
        "delta": -0.0538
      },
      {
        "periodo": 202604,
        "valor": 4.5792,
        "delta": 0.0947
      },
      {
        "periodo": 202605,
        "valor": 4.5979,
        "delta": 0.0187
      },
      {
        "periodo": 202606,
        "valor": 4.6098,
        "delta": 0.0119
      },
      {
        "periodo": 202607,
        "valor": 4.6223,
        "delta": 0.0125
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 5.223628000000001,
    "valor_anterior": 5.20867,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5.1323,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5.18,
        "delta": 0.0477
      },
      {
        "periodo": 202509,
        "valor": 5.2146,
        "delta": 0.0345
      },
      {
        "periodo": 202510,
        "valor": 5.2021,
        "delta": -0.0125
      },
      {
        "periodo": 202511,
        "valor": 5.3167,
        "delta": 0.1146
      },
      {
        "periodo": 202512,
        "valor": 5.2841,
        "delta": -0.0326
      },
      {
        "periodo": 202601,
        "valor": 5.2613,
        "delta": -0.0228
      },
      {
        "periodo": 202602,
        "valor": 5.256,
        "delta": -0.0053
      },
      {
        "periodo": 202603,
        "valor": 5.2422,
        "delta": -0.0137
      },
      {
        "periodo": 202604,
        "valor": 5.2272,
        "delta": -0.0151
      },
      {
        "periodo": 202605,
        "valor": 5.2061,
        "delta": -0.0211
      },
      {
        "periodo": 202606,
        "valor": 5.2087,
        "delta": 0.0026
      },
      {
        "periodo": 202607,
        "valor": 5.2236,
        "delta": 0.015
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 5.955149,
    "valor_anterior": 5.925409999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5.1179,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5.1568,
        "delta": 0.039
      },
      {
        "periodo": 202509,
        "valor": 5.2599,
        "delta": 0.1031
      },
      {
        "periodo": 202510,
        "valor": 5.3281,
        "delta": 0.0682
      },
      {
        "periodo": 202511,
        "valor": 5.494,
        "delta": 0.1659
      },
      {
        "periodo": 202512,
        "valor": 5.5507,
        "delta": 0.0566
      },
      {
        "periodo": 202601,
        "valor": 5.6357,
        "delta": 0.0851
      },
      {
        "periodo": 202602,
        "valor": 5.7136,
        "delta": 0.0779
      },
      {
        "periodo": 202603,
        "valor": 5.8162,
        "delta": 0.1026
      },
      {
        "periodo": 202604,
        "valor": 5.8287,
        "delta": 0.0125
      },
      {
        "periodo": 202605,
        "valor": 5.8719,
        "delta": 0.0432
      },
      {
        "periodo": 202606,
        "valor": 5.9254,
        "delta": 0.0535
      },
      {
        "periodo": 202607,
        "valor": 5.9551,
        "delta": 0.0297
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 2.655525,
    "valor_anterior": 2.649906,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.6132,
        "delta": -0.0368
      },
      {
        "periodo": 202509,
        "valor": 2.5064,
        "delta": -0.1068
      },
      {
        "periodo": 202510,
        "valor": 2.596,
        "delta": 0.0896
      },
      {
        "periodo": 202511,
        "valor": 2.7051,
        "delta": 0.1091
      },
      {
        "periodo": 202512,
        "valor": 2.8119,
        "delta": 0.1068
      },
      {
        "periodo": 202601,
        "valor": 2.8116,
        "delta": -0.0003
      },
      {
        "periodo": 202602,
        "valor": 2.7511,
        "delta": -0.0605
      },
      {
        "periodo": 202603,
        "valor": 2.7327,
        "delta": -0.0184
      },
      {
        "periodo": 202604,
        "valor": 2.7662,
        "delta": 0.0335
      },
      {
        "periodo": 202605,
        "valor": 2.7185,
        "delta": -0.0477
      },
      {
        "periodo": 202606,
        "valor": 2.6499,
        "delta": -0.0686
      },
      {
        "periodo": 202607,
        "valor": 2.6555,
        "delta": 0.0056
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 2.7987729999999997,
    "valor_anterior": 2.74668,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.7899,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.7925,
        "delta": 0.0027
      },
      {
        "periodo": 202509,
        "valor": 2.8045,
        "delta": 0.0119
      },
      {
        "periodo": 202510,
        "valor": 2.8219,
        "delta": 0.0174
      },
      {
        "periodo": 202511,
        "valor": 2.748,
        "delta": -0.0738
      },
      {
        "periodo": 202512,
        "valor": 2.7709,
        "delta": 0.0229
      },
      {
        "periodo": 202601,
        "valor": 2.7776,
        "delta": 0.0067
      },
      {
        "periodo": 202602,
        "valor": 2.7794,
        "delta": 0.0017
      },
      {
        "periodo": 202603,
        "valor": 2.7924,
        "delta": 0.0131
      },
      {
        "periodo": 202604,
        "valor": 2.8476,
        "delta": 0.0552
      },
      {
        "periodo": 202605,
        "valor": 2.8994,
        "delta": 0.0518
      },
      {
        "periodo": 202606,
        "valor": 2.7467,
        "delta": -0.1527
      },
      {
        "periodo": 202607,
        "valor": 2.7988,
        "delta": 0.0521
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 3.40156,
    "valor_anterior": 3.371346,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.9399,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.0379,
        "delta": 0.0981
      },
      {
        "periodo": 202509,
        "valor": 3.1504,
        "delta": 0.1125
      },
      {
        "periodo": 202510,
        "valor": 3.2521,
        "delta": 0.1016
      },
      {
        "periodo": 202511,
        "valor": 3.2965,
        "delta": 0.0444
      },
      {
        "periodo": 202512,
        "valor": 3.5379,
        "delta": 0.2414
      },
      {
        "periodo": 202601,
        "valor": 3.5104,
        "delta": -0.0275
      },
      {
        "periodo": 202602,
        "valor": 3.4973,
        "delta": -0.0131
      },
      {
        "periodo": 202603,
        "valor": 3.444,
        "delta": -0.0533
      },
      {
        "periodo": 202604,
        "valor": 3.4477,
        "delta": 0.0037
      },
      {
        "periodo": 202605,
        "valor": 3.4074,
        "delta": -0.0403
      },
      {
        "periodo": 202606,
        "valor": 3.3713,
        "delta": -0.0361
      },
      {
        "periodo": 202607,
        "valor": 3.4016,
        "delta": 0.0302
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 5.091527,
    "valor_anterior": 5.116519,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5.0912,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5.1467,
        "delta": 0.0555
      },
      {
        "periodo": 202509,
        "valor": 5.1961,
        "delta": 0.0494
      },
      {
        "periodo": 202510,
        "valor": 5.2245,
        "delta": 0.0284
      },
      {
        "periodo": 202511,
        "valor": 5.2646,
        "delta": 0.0401
      },
      {
        "periodo": 202512,
        "valor": 5.1917,
        "delta": -0.0729
      },
      {
        "periodo": 202601,
        "valor": 4.9832,
        "delta": -0.2085
      },
      {
        "periodo": 202602,
        "valor": 5.0297,
        "delta": 0.0464
      },
      {
        "periodo": 202603,
        "valor": 5.0692,
        "delta": 0.0395
      },
      {
        "periodo": 202604,
        "valor": 5.1226,
        "delta": 0.0534
      },
      {
        "periodo": 202605,
        "valor": 5.1031,
        "delta": -0.0195
      },
      {
        "periodo": 202606,
        "valor": 5.1165,
        "delta": 0.0134
      },
      {
        "periodo": 202607,
        "valor": 5.0915,
        "delta": -0.025
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 2.5226680000000004,
    "valor_anterior": 2.545294,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.1511,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.211,
        "delta": 0.0599
      },
      {
        "periodo": 202509,
        "valor": 2.1665,
        "delta": -0.0446
      },
      {
        "periodo": 202510,
        "valor": 2.2225,
        "delta": 0.056
      },
      {
        "periodo": 202511,
        "valor": 2.2802,
        "delta": 0.0577
      },
      {
        "periodo": 202512,
        "valor": 2.4324,
        "delta": 0.1522
      },
      {
        "periodo": 202601,
        "valor": 2.4708,
        "delta": 0.0384
      },
      {
        "periodo": 202602,
        "valor": 2.6873,
        "delta": 0.2166
      },
      {
        "periodo": 202603,
        "valor": 2.621,
        "delta": -0.0663
      },
      {
        "periodo": 202604,
        "valor": 2.5972,
        "delta": -0.0238
      },
      {
        "periodo": 202605,
        "valor": 2.5696,
        "delta": -0.0277
      },
      {
        "periodo": 202606,
        "valor": 2.5453,
        "delta": -0.0243
      },
      {
        "periodo": 202607,
        "valor": 2.5227,
        "delta": -0.0226
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 10.201151999999999,
    "valor_anterior": 10.077012999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8.7553,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.9335,
        "delta": 0.1782
      },
      {
        "periodo": 202509,
        "valor": 9.0694,
        "delta": 0.1359
      },
      {
        "periodo": 202510,
        "valor": 9.3204,
        "delta": 0.251
      },
      {
        "periodo": 202511,
        "valor": 9.4243,
        "delta": 0.1039
      },
      {
        "periodo": 202512,
        "valor": 9.5784,
        "delta": 0.1541
      },
      {
        "periodo": 202601,
        "valor": 9.5473,
        "delta": -0.0311
      },
      {
        "periodo": 202602,
        "valor": 9.7377,
        "delta": 0.1904
      },
      {
        "periodo": 202603,
        "valor": 9.8378,
        "delta": 0.1001
      },
      {
        "periodo": 202604,
        "valor": 9.7368,
        "delta": -0.101
      },
      {
        "periodo": 202605,
        "valor": 9.9075,
        "delta": 0.1707
      },
      {
        "periodo": 202606,
        "valor": 10.077,
        "delta": 0.1695
      },
      {
        "periodo": 202607,
        "valor": 10.2012,
        "delta": 0.1241
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 4.010287,
    "valor_anterior": 3.913114,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4.073,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.9727,
        "delta": -0.1002
      },
      {
        "periodo": 202509,
        "valor": 3.9095,
        "delta": -0.0632
      },
      {
        "periodo": 202510,
        "valor": 3.8414,
        "delta": -0.0681
      },
      {
        "periodo": 202511,
        "valor": 3.7735,
        "delta": -0.0679
      },
      {
        "periodo": 202512,
        "valor": 3.7535,
        "delta": -0.02
      },
      {
        "periodo": 202601,
        "valor": 3.7226,
        "delta": -0.0309
      },
      {
        "periodo": 202602,
        "valor": 3.6936,
        "delta": -0.0291
      },
      {
        "periodo": 202603,
        "valor": 3.7081,
        "delta": 0.0145
      },
      {
        "periodo": 202604,
        "valor": 3.7939,
        "delta": 0.0858
      },
      {
        "periodo": 202605,
        "valor": 3.873,
        "delta": 0.0791
      },
      {
        "periodo": 202606,
        "valor": 3.9131,
        "delta": 0.0401
      },
      {
        "periodo": 202607,
        "valor": 4.0103,
        "delta": 0.0972
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 6.454438,
    "valor_anterior": 6.550485999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7.2815,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7.156,
        "delta": -0.1255
      },
      {
        "periodo": 202509,
        "valor": 7.0394,
        "delta": -0.1165
      },
      {
        "periodo": 202510,
        "valor": 6.9746,
        "delta": -0.0649
      },
      {
        "periodo": 202511,
        "valor": 5.8744,
        "delta": -1.1001
      },
      {
        "periodo": 202512,
        "valor": 7.0478,
        "delta": 1.1734
      },
      {
        "periodo": 202601,
        "valor": 6.951,
        "delta": -0.0969
      },
      {
        "periodo": 202602,
        "valor": 6.8706,
        "delta": -0.0803
      },
      {
        "periodo": 202603,
        "valor": 6.7974,
        "delta": -0.0732
      },
      {
        "periodo": 202604,
        "valor": 6.7174,
        "delta": -0.0801
      },
      {
        "periodo": 202605,
        "valor": 6.6255,
        "delta": -0.0919
      },
      {
        "periodo": 202606,
        "valor": 6.5505,
        "delta": -0.075
      },
      {
        "periodo": 202607,
        "valor": 6.4544,
        "delta": -0.096
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 3.291023,
    "valor_anterior": 3.233582,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.6958,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.7283,
        "delta": 0.0325
      },
      {
        "periodo": 202509,
        "valor": 2.7527,
        "delta": 0.0244
      },
      {
        "periodo": 202510,
        "valor": 2.7829,
        "delta": 0.0302
      },
      {
        "periodo": 202511,
        "valor": 2.8042,
        "delta": 0.0213
      },
      {
        "periodo": 202512,
        "valor": 2.8596,
        "delta": 0.0554
      },
      {
        "periodo": 202601,
        "valor": 2.9164,
        "delta": 0.0568
      },
      {
        "periodo": 202602,
        "valor": 2.9903,
        "delta": 0.0739
      },
      {
        "periodo": 202603,
        "valor": 3.0482,
        "delta": 0.0579
      },
      {
        "periodo": 202604,
        "valor": 3.1095,
        "delta": 0.0613
      },
      {
        "periodo": 202605,
        "valor": 3.1698,
        "delta": 0.0603
      },
      {
        "periodo": 202606,
        "valor": 3.2336,
        "delta": 0.0638
      },
      {
        "periodo": 202607,
        "valor": 3.291,
        "delta": 0.0574
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 1.8891580000000001,
    "valor_anterior": 1.882228,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.7917,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.5314,
        "delta": -0.2603
      },
      {
        "periodo": 202509,
        "valor": 1.5228,
        "delta": -0.0086
      },
      {
        "periodo": 202510,
        "valor": 1.6353,
        "delta": 0.1125
      },
      {
        "periodo": 202511,
        "valor": 1.7494,
        "delta": 0.114
      },
      {
        "periodo": 202512,
        "valor": 2.1106,
        "delta": 0.3613
      },
      {
        "periodo": 202601,
        "valor": 2.0389,
        "delta": -0.0717
      },
      {
        "periodo": 202602,
        "valor": 1.9726,
        "delta": -0.0664
      },
      {
        "periodo": 202603,
        "valor": 1.9035,
        "delta": -0.069
      },
      {
        "periodo": 202604,
        "valor": 1.8451,
        "delta": -0.0585
      },
      {
        "periodo": 202605,
        "valor": 1.7946,
        "delta": -0.0505
      },
      {
        "periodo": 202606,
        "valor": 1.8822,
        "delta": 0.0876
      },
      {
        "periodo": 202607,
        "valor": 1.8892,
        "delta": 0.0069
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 3.3236090000000003,
    "valor_anterior": 3.3600619999999997,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.2326,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.1598,
        "delta": -0.0728
      },
      {
        "periodo": 202509,
        "valor": 3.1543,
        "delta": -0.0055
      },
      {
        "periodo": 202510,
        "valor": 3.1257,
        "delta": -0.0286
      },
      {
        "periodo": 202511,
        "valor": 3.2201,
        "delta": 0.0944
      },
      {
        "periodo": 202512,
        "valor": 3.2385,
        "delta": 0.0185
      },
      {
        "periodo": 202601,
        "valor": 3.257,
        "delta": 0.0185
      },
      {
        "periodo": 202602,
        "valor": 3.2591,
        "delta": 0.0021
      },
      {
        "periodo": 202603,
        "valor": 3.2589,
        "delta": -0.0003
      },
      {
        "periodo": 202604,
        "valor": 3.4413,
        "delta": 0.1825
      },
      {
        "periodo": 202605,
        "valor": 3.4211,
        "delta": -0.0202
      },
      {
        "periodo": 202606,
        "valor": 3.3601,
        "delta": -0.0611
      },
      {
        "periodo": 202607,
        "valor": 3.3236,
        "delta": -0.0365
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 1.472775,
    "valor_anterior": 1.461394,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.3932,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.393,
        "delta": -0.0002
      },
      {
        "periodo": 202509,
        "valor": 1.3966,
        "delta": 0.0036
      },
      {
        "periodo": 202510,
        "valor": 1.3978,
        "delta": 0.0012
      },
      {
        "periodo": 202511,
        "valor": 1.4004,
        "delta": 0.0026
      },
      {
        "periodo": 202512,
        "valor": 1.2902,
        "delta": -0.1102
      },
      {
        "periodo": 202601,
        "valor": 1.3109,
        "delta": 0.0208
      },
      {
        "periodo": 202602,
        "valor": 1.3402,
        "delta": 0.0293
      },
      {
        "periodo": 202603,
        "valor": 1.3638,
        "delta": 0.0236
      },
      {
        "periodo": 202604,
        "valor": 1.3947,
        "delta": 0.0309
      },
      {
        "periodo": 202605,
        "valor": 1.4327,
        "delta": 0.038
      },
      {
        "periodo": 202606,
        "valor": 1.4614,
        "delta": 0.0287
      },
      {
        "periodo": 202607,
        "valor": 1.4728,
        "delta": 0.0114
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 13.117064000000001,
    "valor_anterior": 12.629629000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.31,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.4852,
        "delta": 0.1752
      },
      {
        "periodo": 202509,
        "valor": 9.7494,
        "delta": 0.2642
      },
      {
        "periodo": 202510,
        "valor": 9.9751,
        "delta": 0.2257
      },
      {
        "periodo": 202511,
        "valor": 10.3678,
        "delta": 0.3927
      },
      {
        "periodo": 202512,
        "valor": 10.6426,
        "delta": 0.2748
      },
      {
        "periodo": 202601,
        "valor": 10.9906,
        "delta": 0.348
      },
      {
        "periodo": 202602,
        "valor": 11.2728,
        "delta": 0.2822
      },
      {
        "periodo": 202603,
        "valor": 11.5977,
        "delta": 0.3249
      },
      {
        "periodo": 202604,
        "valor": 11.9347,
        "delta": 0.337
      },
      {
        "periodo": 202605,
        "valor": 12.3061,
        "delta": 0.3714
      },
      {
        "periodo": 202606,
        "valor": 12.6296,
        "delta": 0.3235
      },
      {
        "periodo": 202607,
        "valor": 13.1171,
        "delta": 0.4874
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 3.1609909999999997,
    "valor_anterior": 3.184124,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.4843,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.4146,
        "delta": -0.0696
      },
      {
        "periodo": 202509,
        "valor": 3.0101,
        "delta": -0.4045
      },
      {
        "periodo": 202510,
        "valor": 2.7962,
        "delta": -0.2139
      },
      {
        "periodo": 202511,
        "valor": 2.6329,
        "delta": -0.1633
      },
      {
        "periodo": 202512,
        "valor": 2.4327,
        "delta": -0.2002
      },
      {
        "periodo": 202601,
        "valor": 2.509,
        "delta": 0.0763
      },
      {
        "periodo": 202602,
        "valor": 2.5559,
        "delta": 0.0469
      },
      {
        "periodo": 202603,
        "valor": 2.5734,
        "delta": 0.0174
      },
      {
        "periodo": 202604,
        "valor": 2.6023,
        "delta": 0.029
      },
      {
        "periodo": 202605,
        "valor": 2.6654,
        "delta": 0.063
      },
      {
        "periodo": 202606,
        "valor": 3.1841,
        "delta": 0.5188
      },
      {
        "periodo": 202607,
        "valor": 3.161,
        "delta": -0.0231
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 14.716477999999999,
    "valor_anterior": 14.292988000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.71,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.7284,
        "delta": 0.0184
      },
      {
        "periodo": 202509,
        "valor": 12.8526,
        "delta": 0.1242
      },
      {
        "periodo": 202510,
        "valor": 12.9082,
        "delta": 0.0556
      },
      {
        "periodo": 202511,
        "valor": 12.9187,
        "delta": 0.0105
      },
      {
        "periodo": 202512,
        "valor": 12.9484,
        "delta": 0.0297
      },
      {
        "periodo": 202601,
        "valor": 13.034,
        "delta": 0.0856
      },
      {
        "periodo": 202602,
        "valor": 13.1045,
        "delta": 0.0705
      },
      {
        "periodo": 202603,
        "valor": 13.265,
        "delta": 0.1606
      },
      {
        "periodo": 202604,
        "valor": 13.64,
        "delta": 0.375
      },
      {
        "periodo": 202605,
        "valor": 13.9521,
        "delta": 0.3121
      },
      {
        "periodo": 202606,
        "valor": 14.293,
        "delta": 0.3409
      },
      {
        "periodo": 202607,
        "valor": 14.7165,
        "delta": 0.4235
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 2.43886,
    "valor_anterior": 2.482056,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.3228,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.249,
        "delta": -0.0738
      },
      {
        "periodo": 202509,
        "valor": 3.1909,
        "delta": -0.0581
      },
      {
        "periodo": 202510,
        "valor": 3.2525,
        "delta": 0.0615
      },
      {
        "periodo": 202511,
        "valor": 2.9883,
        "delta": -0.2641
      },
      {
        "periodo": 202512,
        "valor": 2.913,
        "delta": -0.0753
      },
      {
        "periodo": 202601,
        "valor": 2.8596,
        "delta": -0.0534
      },
      {
        "periodo": 202602,
        "valor": 2.7786,
        "delta": -0.081
      },
      {
        "periodo": 202603,
        "valor": 2.6811,
        "delta": -0.0976
      },
      {
        "periodo": 202604,
        "valor": 2.6074,
        "delta": -0.0737
      },
      {
        "periodo": 202605,
        "valor": 2.5551,
        "delta": -0.0523
      },
      {
        "periodo": 202606,
        "valor": 2.4821,
        "delta": -0.073
      },
      {
        "periodo": 202607,
        "valor": 2.4389,
        "delta": -0.0432
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 2.4061079999999997,
    "valor_anterior": 2.531217,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.3612,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.3385,
        "delta": -0.0227
      },
      {
        "periodo": 202509,
        "valor": 3.3066,
        "delta": -0.032
      },
      {
        "periodo": 202510,
        "valor": 3.2773,
        "delta": -0.0292
      },
      {
        "periodo": 202511,
        "valor": 3.2096,
        "delta": -0.0678
      },
      {
        "periodo": 202512,
        "valor": 3.1308,
        "delta": -0.0787
      },
      {
        "periodo": 202601,
        "valor": 3.0495,
        "delta": -0.0814
      },
      {
        "periodo": 202602,
        "valor": 3.001,
        "delta": -0.0484
      },
      {
        "periodo": 202603,
        "valor": 2.8822,
        "delta": -0.1188
      },
      {
        "periodo": 202604,
        "valor": 2.799,
        "delta": -0.0832
      },
      {
        "periodo": 202605,
        "valor": 2.6576,
        "delta": -0.1414
      },
      {
        "periodo": 202606,
        "valor": 2.5312,
        "delta": -0.1264
      },
      {
        "periodo": 202607,
        "valor": 2.4061,
        "delta": -0.1251
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 35.992564,
    "valor_anterior": 21.835714,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.6619,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.8801,
        "delta": 0.2182
      },
      {
        "periodo": 202509,
        "valor": 4.2553,
        "delta": 0.3752
      },
      {
        "periodo": 202510,
        "valor": 4.7655,
        "delta": 0.5102
      },
      {
        "periodo": 202511,
        "valor": 5.399,
        "delta": 0.6335
      },
      {
        "periodo": 202512,
        "valor": 5.9835,
        "delta": 0.5844
      },
      {
        "periodo": 202601,
        "valor": 6.7339,
        "delta": 0.7504
      },
      {
        "periodo": 202602,
        "valor": 7.6442,
        "delta": 0.9103
      },
      {
        "periodo": 202603,
        "valor": 8.8865,
        "delta": 1.2423
      },
      {
        "periodo": 202604,
        "valor": 10.7523,
        "delta": 1.8658
      },
      {
        "periodo": 202605,
        "valor": 14.2147,
        "delta": 3.4625
      },
      {
        "periodo": 202606,
        "valor": 21.8357,
        "delta": 7.621
      },
      {
        "periodo": 202607,
        "valor": 35.9926,
        "delta": 14.1569
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 6.984664,
    "valor_anterior": 6.992375000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7.1051,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6.8493,
        "delta": -0.2557
      },
      {
        "periodo": 202509,
        "valor": 6.6041,
        "delta": -0.2453
      },
      {
        "periodo": 202510,
        "valor": 7.1681,
        "delta": 0.564
      },
      {
        "periodo": 202511,
        "valor": 6.9009,
        "delta": -0.2672
      },
      {
        "periodo": 202512,
        "valor": 6.776,
        "delta": -0.1248
      },
      {
        "periodo": 202601,
        "valor": 6.7705,
        "delta": -0.0055
      },
      {
        "periodo": 202602,
        "valor": 6.757,
        "delta": -0.0135
      },
      {
        "periodo": 202603,
        "valor": 6.876,
        "delta": 0.119
      },
      {
        "periodo": 202604,
        "valor": 6.9256,
        "delta": 0.0496
      },
      {
        "periodo": 202605,
        "valor": 6.9743,
        "delta": 0.0488
      },
      {
        "periodo": 202606,
        "valor": 6.9924,
        "delta": 0.018
      },
      {
        "periodo": 202607,
        "valor": 6.9847,
        "delta": -0.0077
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 30.645617,
    "valor_anterior": 31.038012,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 37.9414,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 37.3044,
        "delta": -0.6371
      },
      {
        "periodo": 202509,
        "valor": 36.5898,
        "delta": -0.7146
      },
      {
        "periodo": 202510,
        "valor": 35.7684,
        "delta": -0.8214
      },
      {
        "periodo": 202511,
        "valor": 35.0356,
        "delta": -0.7328
      },
      {
        "periodo": 202512,
        "valor": 34.3502,
        "delta": -0.6854
      },
      {
        "periodo": 202601,
        "valor": 34.0578,
        "delta": -0.2923
      },
      {
        "periodo": 202602,
        "valor": 33.4473,
        "delta": -0.6105
      },
      {
        "periodo": 202603,
        "valor": 32.9379,
        "delta": -0.5094
      },
      {
        "periodo": 202604,
        "valor": 32.3299,
        "delta": -0.608
      },
      {
        "periodo": 202605,
        "valor": 31.5659,
        "delta": -0.764
      },
      {
        "periodo": 202606,
        "valor": 31.038,
        "delta": -0.5279
      },
      {
        "periodo": 202607,
        "valor": 30.6456,
        "delta": -0.3924
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 3.089207,
    "valor_anterior": 3.090197,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.2744,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.2557,
        "delta": -0.0187
      },
      {
        "periodo": 202509,
        "valor": 3.2299,
        "delta": -0.0259
      },
      {
        "periodo": 202510,
        "valor": 3.1631,
        "delta": -0.0668
      },
      {
        "periodo": 202511,
        "valor": 3.1344,
        "delta": -0.0287
      },
      {
        "periodo": 202512,
        "valor": 3.1075,
        "delta": -0.0269
      },
      {
        "periodo": 202601,
        "valor": 3.105,
        "delta": -0.0026
      },
      {
        "periodo": 202602,
        "valor": 3.1234,
        "delta": 0.0185
      },
      {
        "periodo": 202603,
        "valor": 3.0913,
        "delta": -0.0321
      },
      {
        "periodo": 202604,
        "valor": 3.0583,
        "delta": -0.0331
      },
      {
        "periodo": 202605,
        "valor": 3.1284,
        "delta": 0.0701
      },
      {
        "periodo": 202606,
        "valor": 3.0902,
        "delta": -0.0382
      },
      {
        "periodo": 202607,
        "valor": 3.0892,
        "delta": -0.001
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 1.9034840000000002,
    "valor_anterior": 2.064376,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.6885,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.6857,
        "delta": -0.0029
      },
      {
        "periodo": 202509,
        "valor": 1.6757,
        "delta": -0.01
      },
      {
        "periodo": 202510,
        "valor": 1.6701,
        "delta": -0.0055
      },
      {
        "periodo": 202511,
        "valor": 1.5013,
        "delta": -0.1689
      },
      {
        "periodo": 202512,
        "valor": 1.527,
        "delta": 0.0257
      },
      {
        "periodo": 202601,
        "valor": 1.5432,
        "delta": 0.0162
      },
      {
        "periodo": 202602,
        "valor": 1.5542,
        "delta": 0.0111
      },
      {
        "periodo": 202603,
        "valor": 1.497,
        "delta": -0.0572
      },
      {
        "periodo": 202604,
        "valor": 1.5506,
        "delta": 0.0536
      },
      {
        "periodo": 202605,
        "valor": 1.6067,
        "delta": 0.0562
      },
      {
        "periodo": 202606,
        "valor": 2.0644,
        "delta": 0.4576
      },
      {
        "periodo": 202607,
        "valor": 1.9035,
        "delta": -0.1609
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5.1261,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6.7185,
        "delta": 1.5924
      },
      {
        "periodo": 202509,
        "valor": 100.0,
        "delta": 93.2815
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 3.338544,
    "valor_anterior": 3.3127560000000003,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.7504,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.8387,
        "delta": 0.0883
      },
      {
        "periodo": 202509,
        "valor": 2.9005,
        "delta": 0.0617
      },
      {
        "periodo": 202510,
        "valor": 2.9602,
        "delta": 0.0598
      },
      {
        "periodo": 202511,
        "valor": 3.0321,
        "delta": 0.0719
      },
      {
        "periodo": 202512,
        "valor": 3.1038,
        "delta": 0.0717
      },
      {
        "periodo": 202601,
        "valor": 3.142,
        "delta": 0.0382
      },
      {
        "periodo": 202602,
        "valor": 3.1776,
        "delta": 0.0356
      },
      {
        "periodo": 202603,
        "valor": 3.227,
        "delta": 0.0494
      },
      {
        "periodo": 202604,
        "valor": 3.2153,
        "delta": -0.0117
      },
      {
        "periodo": 202605,
        "valor": 3.2655,
        "delta": 0.0503
      },
      {
        "periodo": 202606,
        "valor": 3.3128,
        "delta": 0.0472
      },
      {
        "periodo": 202607,
        "valor": 3.3385,
        "delta": 0.0258
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 0.717118,
    "valor_anterior": 0.737931,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.9802,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.8812,
        "delta": -0.099
      },
      {
        "periodo": 202509,
        "valor": 1.7623,
        "delta": -0.1189
      },
      {
        "periodo": 202510,
        "valor": 1.629,
        "delta": -0.1333
      },
      {
        "periodo": 202511,
        "valor": 1.4808,
        "delta": -0.1482
      },
      {
        "periodo": 202512,
        "valor": 1.3538,
        "delta": -0.127
      },
      {
        "periodo": 202601,
        "valor": 1.2293,
        "delta": -0.1245
      },
      {
        "periodo": 202602,
        "valor": 1.1149,
        "delta": -0.1145
      },
      {
        "periodo": 202603,
        "valor": 1.022,
        "delta": -0.0929
      },
      {
        "periodo": 202604,
        "valor": 0.9289,
        "delta": -0.093
      },
      {
        "periodo": 202605,
        "valor": 0.7608,
        "delta": -0.1681
      },
      {
        "periodo": 202606,
        "valor": 0.7379,
        "delta": -0.0229
      },
      {
        "periodo": 202607,
        "valor": 0.7171,
        "delta": -0.0208
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 20.46163,
    "valor_anterior": 20.708618,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 23.6877,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24.5068,
        "delta": 0.8191
      },
      {
        "periodo": 202509,
        "valor": 25.042,
        "delta": 0.5352
      },
      {
        "periodo": 202510,
        "valor": 24.9885,
        "delta": -0.0535
      },
      {
        "periodo": 202511,
        "valor": 24.7483,
        "delta": -0.2402
      },
      {
        "periodo": 202512,
        "valor": 24.4147,
        "delta": -0.3336
      },
      {
        "periodo": 202601,
        "valor": 24.3336,
        "delta": -0.0811
      },
      {
        "periodo": 202602,
        "valor": 23.7951,
        "delta": -0.5385
      },
      {
        "periodo": 202603,
        "valor": 22.9725,
        "delta": -0.8226
      },
      {
        "periodo": 202604,
        "valor": 21.9838,
        "delta": -0.9887
      },
      {
        "periodo": 202605,
        "valor": 21.2109,
        "delta": -0.7729
      },
      {
        "periodo": 202606,
        "valor": 20.7086,
        "delta": -0.5023
      },
      {
        "periodo": 202607,
        "valor": 20.4616,
        "delta": -0.247
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 2.566158,
    "valor_anterior": 2.705906,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.2396,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.1659,
        "delta": -0.0737
      },
      {
        "periodo": 202509,
        "valor": 3.1042,
        "delta": -0.0616
      },
      {
        "periodo": 202510,
        "valor": 3.0453,
        "delta": -0.0589
      },
      {
        "periodo": 202511,
        "valor": 3.0079,
        "delta": -0.0374
      },
      {
        "periodo": 202512,
        "valor": 2.9572,
        "delta": -0.0507
      },
      {
        "periodo": 202601,
        "valor": 2.9003,
        "delta": -0.0568
      },
      {
        "periodo": 202602,
        "valor": 2.8512,
        "delta": -0.0491
      },
      {
        "periodo": 202603,
        "valor": 2.802,
        "delta": -0.0492
      },
      {
        "periodo": 202604,
        "valor": 2.7736,
        "delta": -0.0285
      },
      {
        "periodo": 202605,
        "valor": 2.7392,
        "delta": -0.0344
      },
      {
        "periodo": 202606,
        "valor": 2.7059,
        "delta": -0.0333
      },
      {
        "periodo": 202607,
        "valor": 2.5662,
        "delta": -0.1397
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 0.232722,
    "valor_anterior": 0.227632,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.2381,
        "delta": -0.0119
      },
      {
        "periodo": 202509,
        "valor": 0.2313,
        "delta": -0.0068
      },
      {
        "periodo": 202510,
        "valor": 0.2263,
        "delta": -0.005
      },
      {
        "periodo": 202511,
        "valor": 0.2217,
        "delta": -0.0045
      },
      {
        "periodo": 202512,
        "valor": 0.2178,
        "delta": -0.0039
      },
      {
        "periodo": 202601,
        "valor": 0.2161,
        "delta": -0.0017
      },
      {
        "periodo": 202602,
        "valor": 0.2158,
        "delta": -0.0003
      },
      {
        "periodo": 202603,
        "valor": 0.2158,
        "delta": -0.0
      },
      {
        "periodo": 202604,
        "valor": 0.2178,
        "delta": 0.0021
      },
      {
        "periodo": 202605,
        "valor": 0.2222,
        "delta": 0.0044
      },
      {
        "periodo": 202606,
        "valor": 0.2276,
        "delta": 0.0054
      },
      {
        "periodo": 202607,
        "valor": 0.2327,
        "delta": 0.0051
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 2.467981,
    "valor_anterior": 2.3230839999999997,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.9621,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.0757,
        "delta": 0.1136
      },
      {
        "periodo": 202509,
        "valor": 1.1831,
        "delta": 0.1074
      },
      {
        "periodo": 202510,
        "valor": 1.2847,
        "delta": 0.1016
      },
      {
        "periodo": 202511,
        "valor": 1.3568,
        "delta": 0.0721
      },
      {
        "periodo": 202512,
        "valor": 1.4428,
        "delta": 0.086
      },
      {
        "periodo": 202601,
        "valor": 1.601,
        "delta": 0.1583
      },
      {
        "periodo": 202602,
        "valor": 1.7539,
        "delta": 0.1528
      },
      {
        "periodo": 202603,
        "valor": 1.8939,
        "delta": 0.14
      },
      {
        "periodo": 202604,
        "valor": 2.0282,
        "delta": 0.1343
      },
      {
        "periodo": 202605,
        "valor": 2.1761,
        "delta": 0.1479
      },
      {
        "periodo": 202606,
        "valor": 2.3231,
        "delta": 0.147
      },
      {
        "periodo": 202607,
        "valor": 2.468,
        "delta": 0.1449
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 5.922112,
    "valor_anterior": 5.84136,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6.1492,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5.7992,
        "delta": -0.35
      },
      {
        "periodo": 202509,
        "valor": 5.4233,
        "delta": -0.3758
      },
      {
        "periodo": 202510,
        "valor": 5.415,
        "delta": -0.0083
      },
      {
        "periodo": 202511,
        "valor": 5.4376,
        "delta": 0.0226
      },
      {
        "periodo": 202512,
        "valor": 5.4259,
        "delta": -0.0117
      },
      {
        "periodo": 202601,
        "valor": 5.4454,
        "delta": 0.0195
      },
      {
        "periodo": 202602,
        "valor": 5.3833,
        "delta": -0.0622
      },
      {
        "periodo": 202603,
        "valor": 5.3969,
        "delta": 0.0136
      },
      {
        "periodo": 202604,
        "valor": 5.4946,
        "delta": 0.0977
      },
      {
        "periodo": 202605,
        "valor": 5.5094,
        "delta": 0.0148
      },
      {
        "periodo": 202606,
        "valor": 5.8414,
        "delta": 0.3319
      },
      {
        "periodo": 202607,
        "valor": 5.9221,
        "delta": 0.0808
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 2.283586,
    "valor_anterior": 1.9029520000000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.1109,
        "delta": 0.1109
      },
      {
        "periodo": 202602,
        "valor": 0.6936,
        "delta": 0.5827
      },
      {
        "periodo": 202603,
        "valor": 0.6895,
        "delta": -0.0042
      },
      {
        "periodo": 202604,
        "valor": 1.1174,
        "delta": 0.4279
      },
      {
        "periodo": 202605,
        "valor": 1.525,
        "delta": 0.4076
      },
      {
        "periodo": 202606,
        "valor": 1.903,
        "delta": 0.378
      },
      {
        "periodo": 202607,
        "valor": 2.2836,
        "delta": 0.3806
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 1.934452,
    "valor_anterior": 1.9488109999999998,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.3512,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.3659,
        "delta": 0.0147
      },
      {
        "periodo": 202509,
        "valor": 2.3394,
        "delta": -0.0265
      },
      {
        "periodo": 202510,
        "valor": 2.3036,
        "delta": -0.0359
      },
      {
        "periodo": 202511,
        "valor": 2.2515,
        "delta": -0.0521
      },
      {
        "periodo": 202512,
        "valor": 2.176,
        "delta": -0.0755
      },
      {
        "periodo": 202601,
        "valor": 2.1284,
        "delta": -0.0476
      },
      {
        "periodo": 202602,
        "valor": 2.0703,
        "delta": -0.0581
      },
      {
        "periodo": 202603,
        "valor": 2.0289,
        "delta": -0.0414
      },
      {
        "periodo": 202604,
        "valor": 1.9917,
        "delta": -0.0373
      },
      {
        "periodo": 202605,
        "valor": 1.9631,
        "delta": -0.0285
      },
      {
        "periodo": 202606,
        "valor": 1.9488,
        "delta": -0.0143
      },
      {
        "periodo": 202607,
        "valor": 1.9345,
        "delta": -0.0144
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 1.270023,
    "valor_anterior": 1.325574,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.4105,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.3796,
        "delta": -0.0308
      },
      {
        "periodo": 202509,
        "valor": 1.3601,
        "delta": -0.0196
      },
      {
        "periodo": 202510,
        "valor": 1.3493,
        "delta": -0.0108
      },
      {
        "periodo": 202511,
        "valor": 1.3462,
        "delta": -0.0031
      },
      {
        "periodo": 202512,
        "valor": 1.3487,
        "delta": 0.0025
      },
      {
        "periodo": 202601,
        "valor": 1.3501,
        "delta": 0.0014
      },
      {
        "periodo": 202602,
        "valor": 1.3527,
        "delta": 0.0026
      },
      {
        "periodo": 202603,
        "valor": 1.3555,
        "delta": 0.0028
      },
      {
        "periodo": 202604,
        "valor": 1.3468,
        "delta": -0.0087
      },
      {
        "periodo": 202605,
        "valor": 1.3413,
        "delta": -0.0055
      },
      {
        "periodo": 202606,
        "valor": 1.3256,
        "delta": -0.0157
      },
      {
        "periodo": 202607,
        "valor": 1.27,
        "delta": -0.0556
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 3.23916,
    "valor_anterior": 3.49641,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.9808,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.9953,
        "delta": 0.0144
      },
      {
        "periodo": 202509,
        "valor": 3.9999,
        "delta": 0.0046
      },
      {
        "periodo": 202510,
        "valor": 4.9328,
        "delta": 0.933
      },
      {
        "periodo": 202511,
        "valor": 4.8003,
        "delta": -0.1326
      },
      {
        "periodo": 202512,
        "valor": 4.6916,
        "delta": -0.1087
      },
      {
        "periodo": 202601,
        "valor": 4.5234,
        "delta": -0.1682
      },
      {
        "periodo": 202602,
        "valor": 4.3477,
        "delta": -0.1757
      },
      {
        "periodo": 202603,
        "valor": 4.1368,
        "delta": -0.211
      },
      {
        "periodo": 202604,
        "valor": 3.9589,
        "delta": -0.1778
      },
      {
        "periodo": 202605,
        "valor": 3.768,
        "delta": -0.1909
      },
      {
        "periodo": 202606,
        "valor": 3.4964,
        "delta": -0.2716
      },
      {
        "periodo": 202607,
        "valor": 3.2392,
        "delta": -0.2572
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 1.684576,
    "valor_anterior": 1.664777,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.4615,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.4625,
        "delta": 0.001
      },
      {
        "periodo": 202509,
        "valor": 1.4647,
        "delta": 0.0023
      },
      {
        "periodo": 202510,
        "valor": 1.4702,
        "delta": 0.0054
      },
      {
        "periodo": 202511,
        "valor": 1.4823,
        "delta": 0.0121
      },
      {
        "periodo": 202512,
        "valor": 1.5081,
        "delta": 0.0258
      },
      {
        "periodo": 202601,
        "valor": 1.537,
        "delta": 0.0289
      },
      {
        "periodo": 202602,
        "valor": 1.5673,
        "delta": 0.0303
      },
      {
        "periodo": 202603,
        "valor": 1.5915,
        "delta": 0.0241
      },
      {
        "periodo": 202604,
        "valor": 1.6173,
        "delta": 0.0258
      },
      {
        "periodo": 202605,
        "valor": 1.6474,
        "delta": 0.0301
      },
      {
        "periodo": 202606,
        "valor": 1.6648,
        "delta": 0.0174
      },
      {
        "periodo": 202607,
        "valor": 1.6846,
        "delta": 0.0198
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 84.17475800000001,
    "valor_anterior": 84.24338300000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 52.4325,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 57.309,
        "delta": 4.8765
      },
      {
        "periodo": 202509,
        "valor": 62.0911,
        "delta": 4.7821
      },
      {
        "periodo": 202510,
        "valor": 65.978,
        "delta": 3.8869
      },
      {
        "periodo": 202511,
        "valor": 69.5602,
        "delta": 3.5822
      },
      {
        "periodo": 202512,
        "valor": 72.3145,
        "delta": 2.7543
      },
      {
        "periodo": 202601,
        "valor": 74.6756,
        "delta": 2.3611
      },
      {
        "periodo": 202602,
        "valor": 76.8719,
        "delta": 2.1963
      },
      {
        "periodo": 202603,
        "valor": 78.9799,
        "delta": 2.108
      },
      {
        "periodo": 202604,
        "valor": 80.9149,
        "delta": 1.935
      },
      {
        "periodo": 202605,
        "valor": 82.5903,
        "delta": 1.6754
      },
      {
        "periodo": 202606,
        "valor": 84.2434,
        "delta": 1.6531
      },
      {
        "periodo": 202607,
        "valor": 84.1748,
        "delta": -0.0686
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 5.798653,
    "valor_anterior": 5.8818269999999995,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 5.9053,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 6.0262,
        "delta": 0.1209
      },
      {
        "periodo": 202604,
        "valor": 6.0102,
        "delta": -0.016
      },
      {
        "periodo": 202605,
        "valor": 5.895,
        "delta": -0.1152
      },
      {
        "periodo": 202606,
        "valor": 5.8818,
        "delta": -0.0132
      },
      {
        "periodo": 202607,
        "valor": 5.7987,
        "delta": -0.0832
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 39.338722999999995,
    "valor_anterior": 37.861548,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 100.0,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": 100.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 7.265,
        "delta": -92.735
      },
      {
        "periodo": 202511,
        "valor": 13.3205,
        "delta": 6.0555
      },
      {
        "periodo": 202512,
        "valor": 22.6495,
        "delta": 9.329
      },
      {
        "periodo": 202601,
        "valor": 29.213,
        "delta": 6.5635
      },
      {
        "periodo": 202602,
        "valor": 33.4916,
        "delta": 4.2786
      },
      {
        "periodo": 202603,
        "valor": 35.1655,
        "delta": 1.6739
      },
      {
        "periodo": 202604,
        "valor": 35.7843,
        "delta": 0.6188
      },
      {
        "periodo": 202605,
        "valor": 36.5658,
        "delta": 0.7815
      },
      {
        "periodo": 202606,
        "valor": 37.8615,
        "delta": 1.2957
      },
      {
        "periodo": 202607,
        "valor": 39.3387,
        "delta": 1.4772
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 100.0,
    "valor_anterior": 100.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 100.0,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": 100.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 100.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 100.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 100.0,
    "valor_anterior": 100.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 100.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 100.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 100.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 100.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 100.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 4.767879,
    "valor_anterior": 4.729906,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4.3094,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4.3399,
        "delta": 0.0305
      },
      {
        "periodo": 202509,
        "valor": 4.3719,
        "delta": 0.0321
      },
      {
        "periodo": 202510,
        "valor": 4.411,
        "delta": 0.0391
      },
      {
        "periodo": 202511,
        "valor": 4.4573,
        "delta": 0.0463
      },
      {
        "periodo": 202512,
        "valor": 4.5133,
        "delta": 0.056
      },
      {
        "periodo": 202601,
        "valor": 4.5301,
        "delta": 0.0167
      },
      {
        "periodo": 202602,
        "valor": 4.5748,
        "delta": 0.0447
      },
      {
        "periodo": 202603,
        "valor": 4.6019,
        "delta": 0.0272
      },
      {
        "periodo": 202604,
        "valor": 4.6627,
        "delta": 0.0608
      },
      {
        "periodo": 202605,
        "valor": 4.6965,
        "delta": 0.0338
      },
      {
        "periodo": 202606,
        "valor": 4.7299,
        "delta": 0.0334
      },
      {
        "periodo": 202607,
        "valor": 4.7679,
        "delta": 0.038
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 4.750387,
    "valor_anterior": 4.723814,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4.3543,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4.3926,
        "delta": 0.0382
      },
      {
        "periodo": 202509,
        "valor": 4.4367,
        "delta": 0.0441
      },
      {
        "periodo": 202510,
        "valor": 4.4667,
        "delta": 0.0301
      },
      {
        "periodo": 202511,
        "valor": 4.527,
        "delta": 0.0603
      },
      {
        "periodo": 202512,
        "valor": 4.563,
        "delta": 0.036
      },
      {
        "periodo": 202601,
        "valor": 4.5685,
        "delta": 0.0055
      },
      {
        "periodo": 202602,
        "valor": 4.6073,
        "delta": 0.0388
      },
      {
        "periodo": 202603,
        "valor": 4.6227,
        "delta": 0.0154
      },
      {
        "periodo": 202604,
        "valor": 4.6804,
        "delta": 0.0577
      },
      {
        "periodo": 202605,
        "valor": 4.7056,
        "delta": 0.0252
      },
      {
        "periodo": 202606,
        "valor": 4.7238,
        "delta": 0.0182
      },
      {
        "periodo": 202607,
        "valor": 4.7504,
        "delta": 0.0266
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 3.34607,
    "valor_anterior": 3.3832359999999997,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.8323,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.9757,
        "delta": 0.1434
      },
      {
        "periodo": 202509,
        "valor": 3.0047,
        "delta": 0.0289
      },
      {
        "periodo": 202510,
        "valor": 3.1184,
        "delta": 0.1137
      },
      {
        "periodo": 202511,
        "valor": 3.2301,
        "delta": 0.1118
      },
      {
        "periodo": 202512,
        "valor": 3.4252,
        "delta": 0.195
      },
      {
        "periodo": 202601,
        "valor": 3.418,
        "delta": -0.0072
      },
      {
        "periodo": 202602,
        "valor": 3.4029,
        "delta": -0.0151
      },
      {
        "periodo": 202603,
        "valor": 3.3824,
        "delta": -0.0204
      },
      {
        "periodo": 202604,
        "valor": 3.3623,
        "delta": -0.0201
      },
      {
        "periodo": 202605,
        "valor": 3.3358,
        "delta": -0.0265
      },
      {
        "periodo": 202606,
        "valor": 3.3832,
        "delta": 0.0474
      },
      {
        "periodo": 202607,
        "valor": 3.3461,
        "delta": -0.0372
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 3.5551079999999997,
    "valor_anterior": 3.5319629999999997,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.4507,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.3783,
        "delta": -0.0723
      },
      {
        "periodo": 202509,
        "valor": 3.3147,
        "delta": -0.0636
      },
      {
        "periodo": 202510,
        "valor": 3.2823,
        "delta": -0.0324
      },
      {
        "periodo": 202511,
        "valor": 3.0388,
        "delta": -0.2435
      },
      {
        "periodo": 202512,
        "valor": 3.2688,
        "delta": 0.23
      },
      {
        "periodo": 202601,
        "valor": 3.2862,
        "delta": 0.0174
      },
      {
        "periodo": 202602,
        "valor": 3.3494,
        "delta": 0.0632
      },
      {
        "periodo": 202603,
        "valor": 3.3925,
        "delta": 0.0431
      },
      {
        "periodo": 202604,
        "valor": 3.4127,
        "delta": 0.0202
      },
      {
        "periodo": 202605,
        "valor": 3.4786,
        "delta": 0.066
      },
      {
        "periodo": 202606,
        "valor": 3.532,
        "delta": 0.0533
      },
      {
        "periodo": 202607,
        "valor": 3.5551,
        "delta": 0.0231
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 2.6421259999999998,
    "valor_anterior": 2.6517720000000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.6331,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.6344,
        "delta": 0.0013
      },
      {
        "periodo": 202509,
        "valor": 2.5896,
        "delta": -0.0448
      },
      {
        "periodo": 202510,
        "valor": 2.6456,
        "delta": 0.056
      },
      {
        "periodo": 202511,
        "valor": 2.6776,
        "delta": 0.032
      },
      {
        "periodo": 202512,
        "valor": 2.7622,
        "delta": 0.0846
      },
      {
        "periodo": 202601,
        "valor": 2.7587,
        "delta": -0.0035
      },
      {
        "periodo": 202602,
        "valor": 2.7725,
        "delta": 0.0138
      },
      {
        "periodo": 202603,
        "valor": 2.7294,
        "delta": -0.0431
      },
      {
        "periodo": 202604,
        "valor": 2.7373,
        "delta": 0.0079
      },
      {
        "periodo": 202605,
        "valor": 2.6993,
        "delta": -0.038
      },
      {
        "periodo": 202606,
        "valor": 2.6518,
        "delta": -0.0476
      },
      {
        "periodo": 202607,
        "valor": 2.6421,
        "delta": -0.0096
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 2.892871,
    "valor_anterior": 2.861686,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.7282,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.7072,
        "delta": -0.0211
      },
      {
        "periodo": 202509,
        "valor": 2.6709,
        "delta": -0.0362
      },
      {
        "periodo": 202510,
        "valor": 2.6696,
        "delta": -0.0014
      },
      {
        "periodo": 202511,
        "valor": 2.6384,
        "delta": -0.0312
      },
      {
        "periodo": 202512,
        "valor": 2.6164,
        "delta": -0.022
      },
      {
        "periodo": 202601,
        "valor": 2.6384,
        "delta": 0.022
      },
      {
        "periodo": 202602,
        "valor": 2.6723,
        "delta": 0.0339
      },
      {
        "periodo": 202603,
        "valor": 2.6873,
        "delta": 0.0151
      },
      {
        "periodo": 202604,
        "valor": 2.7305,
        "delta": 0.0432
      },
      {
        "periodo": 202605,
        "valor": 2.759,
        "delta": 0.0285
      },
      {
        "periodo": 202606,
        "valor": 2.8617,
        "delta": 0.1027
      },
      {
        "periodo": 202607,
        "valor": 2.8929,
        "delta": 0.0312
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200074,
    "label": "TDA",
    "valor_actual": 11.22439,
    "valor_anterior": 10.944084,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8.8774,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.9219,
        "delta": 0.0445
      },
      {
        "periodo": 202509,
        "valor": 9.0323,
        "delta": 0.1104
      },
      {
        "periodo": 202510,
        "valor": 9.2566,
        "delta": 0.2243
      },
      {
        "periodo": 202511,
        "valor": 9.4144,
        "delta": 0.1578
      },
      {
        "periodo": 202512,
        "valor": 9.5402,
        "delta": 0.1258
      },
      {
        "periodo": 202601,
        "valor": 9.742,
        "delta": 0.2018
      },
      {
        "periodo": 202602,
        "valor": 9.895,
        "delta": 0.153
      },
      {
        "periodo": 202603,
        "valor": 10.18,
        "delta": 0.285
      },
      {
        "periodo": 202604,
        "valor": 10.3988,
        "delta": 0.2189
      },
      {
        "periodo": 202605,
        "valor": 10.6346,
        "delta": 0.2357
      },
      {
        "periodo": 202606,
        "valor": 10.9441,
        "delta": 0.3095
      },
      {
        "periodo": 202607,
        "valor": 11.2244,
        "delta": 0.2803
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 170.505967,
    "valor_anterior": 171.475978,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 189.1782,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 190.1422,
        "delta": 0.964
      },
      {
        "periodo": 202509,
        "valor": 190.552,
        "delta": 0.4099
      },
      {
        "periodo": 202510,
        "valor": 188.1136,
        "delta": -2.4384
      },
      {
        "periodo": 202511,
        "valor": 186.3127,
        "delta": -1.8009
      },
      {
        "periodo": 202512,
        "valor": 182.1179,
        "delta": -4.1948
      },
      {
        "periodo": 202601,
        "valor": 177.5389,
        "delta": -4.5791
      },
      {
        "periodo": 202602,
        "valor": 174.0806,
        "delta": -3.4583
      },
      {
        "periodo": 202603,
        "valor": 176.979,
        "delta": 2.8984
      },
      {
        "periodo": 202604,
        "valor": 177.0215,
        "delta": 0.0425
      },
      {
        "periodo": 202605,
        "valor": 173.1676,
        "delta": -3.8538
      },
      {
        "periodo": 202606,
        "valor": 171.476,
        "delta": -1.6917
      },
      {
        "periodo": 202607,
        "valor": 170.506,
        "delta": -0.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 192.275395,
    "valor_anterior": 195.174501,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 189.1028,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 189.9465,
        "delta": 0.8437
      },
      {
        "periodo": 202509,
        "valor": 182.5442,
        "delta": -7.4023
      },
      {
        "periodo": 202510,
        "valor": 183.4333,
        "delta": 0.889
      },
      {
        "periodo": 202511,
        "valor": 183.9265,
        "delta": 0.4932
      },
      {
        "periodo": 202512,
        "valor": 185.7934,
        "delta": 1.867
      },
      {
        "periodo": 202601,
        "valor": 183.8885,
        "delta": -1.905
      },
      {
        "periodo": 202602,
        "valor": 199.6814,
        "delta": 15.7929
      },
      {
        "periodo": 202603,
        "valor": 204.5279,
        "delta": 4.8465
      },
      {
        "periodo": 202604,
        "valor": 196.718,
        "delta": -7.8099
      },
      {
        "periodo": 202605,
        "valor": 192.5508,
        "delta": -4.1672
      },
      {
        "periodo": 202606,
        "valor": 195.1745,
        "delta": 2.6237
      },
      {
        "periodo": 202607,
        "valor": 192.2754,
        "delta": -2.8991
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 137.076058,
    "valor_anterior": 137.780136,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 134.6593,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 135.8751,
        "delta": 1.2158
      },
      {
        "periodo": 202509,
        "valor": 134.0807,
        "delta": -1.7943
      },
      {
        "periodo": 202510,
        "valor": 135.0038,
        "delta": 0.9231
      },
      {
        "periodo": 202511,
        "valor": 141.7572,
        "delta": 6.7534
      },
      {
        "periodo": 202512,
        "valor": 148.1111,
        "delta": 6.3539
      },
      {
        "periodo": 202601,
        "valor": 146.444,
        "delta": -1.6671
      },
      {
        "periodo": 202602,
        "valor": 141.9226,
        "delta": -4.5213
      },
      {
        "periodo": 202603,
        "valor": 142.2239,
        "delta": 0.3013
      },
      {
        "periodo": 202604,
        "valor": 140.2037,
        "delta": -2.0202
      },
      {
        "periodo": 202605,
        "valor": 143.5579,
        "delta": 3.3542
      },
      {
        "periodo": 202606,
        "valor": 137.7801,
        "delta": -5.7778
      },
      {
        "periodo": 202607,
        "valor": 137.0761,
        "delta": -0.7041
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 118.932663,
    "valor_anterior": 117.207502,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 139.9508,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 129.7058,
        "delta": -10.2449
      },
      {
        "periodo": 202509,
        "valor": 129.2347,
        "delta": -0.4712
      },
      {
        "periodo": 202510,
        "valor": 131.0943,
        "delta": 1.8596
      },
      {
        "periodo": 202511,
        "valor": 129.8891,
        "delta": -1.2053
      },
      {
        "periodo": 202512,
        "valor": 124.358,
        "delta": -5.5311
      },
      {
        "periodo": 202601,
        "valor": 121.7905,
        "delta": -2.5675
      },
      {
        "periodo": 202602,
        "valor": 121.4503,
        "delta": -0.3402
      },
      {
        "periodo": 202603,
        "valor": 118.2919,
        "delta": -3.1584
      },
      {
        "periodo": 202604,
        "valor": 119.9097,
        "delta": 1.6178
      },
      {
        "periodo": 202605,
        "valor": 118.3743,
        "delta": -1.5354
      },
      {
        "periodo": 202606,
        "valor": 117.2075,
        "delta": -1.1668
      },
      {
        "periodo": 202607,
        "valor": 118.9327,
        "delta": 1.7252
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 100.035859,
    "valor_anterior": 99.350249,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 121.5759,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 119.96,
        "delta": -1.616
      },
      {
        "periodo": 202509,
        "valor": 115.7463,
        "delta": -4.2137
      },
      {
        "periodo": 202510,
        "valor": 117.4391,
        "delta": 1.6928
      },
      {
        "periodo": 202511,
        "valor": 117.337,
        "delta": -0.1021
      },
      {
        "periodo": 202512,
        "valor": 126.5143,
        "delta": 9.1773
      },
      {
        "periodo": 202601,
        "valor": 126.7006,
        "delta": 0.1863
      },
      {
        "periodo": 202602,
        "valor": 128.866,
        "delta": 2.1654
      },
      {
        "periodo": 202603,
        "valor": 121.7438,
        "delta": -7.1222
      },
      {
        "periodo": 202604,
        "valor": 106.2806,
        "delta": -15.4632
      },
      {
        "periodo": 202605,
        "valor": 104.2046,
        "delta": -2.076
      },
      {
        "periodo": 202606,
        "valor": 99.3502,
        "delta": -4.8544
      },
      {
        "periodo": 202607,
        "valor": 100.0359,
        "delta": 0.6856
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 129.996521,
    "valor_anterior": 123.58972399999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 149.7502,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 149.2014,
        "delta": -0.5489
      },
      {
        "periodo": 202509,
        "valor": 154.1643,
        "delta": 4.9629
      },
      {
        "periodo": 202510,
        "valor": 153.6613,
        "delta": -0.503
      },
      {
        "periodo": 202511,
        "valor": 154.9751,
        "delta": 1.3139
      },
      {
        "periodo": 202512,
        "valor": 156.7026,
        "delta": 1.7274
      },
      {
        "periodo": 202601,
        "valor": 163.1018,
        "delta": 6.3992
      },
      {
        "periodo": 202602,
        "valor": 168.576,
        "delta": 5.4742
      },
      {
        "periodo": 202603,
        "valor": 170.3115,
        "delta": 1.7355
      },
      {
        "periodo": 202604,
        "valor": 132.3681,
        "delta": -37.9434
      },
      {
        "periodo": 202605,
        "valor": 126.0,
        "delta": -6.3681
      },
      {
        "periodo": 202606,
        "valor": 123.5897,
        "delta": -2.4103
      },
      {
        "periodo": 202607,
        "valor": 129.9965,
        "delta": 6.4068
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 73.700482,
    "valor_anterior": 75.132478,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 86.5507,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 79.624,
        "delta": -6.9266
      },
      {
        "periodo": 202509,
        "valor": 71.3132,
        "delta": -8.3109
      },
      {
        "periodo": 202510,
        "valor": 72.3926,
        "delta": 1.0794
      },
      {
        "periodo": 202511,
        "valor": 75.6685,
        "delta": 3.2759
      },
      {
        "periodo": 202512,
        "valor": 85.6807,
        "delta": 10.0122
      },
      {
        "periodo": 202601,
        "valor": 82.831,
        "delta": -2.8496
      },
      {
        "periodo": 202602,
        "valor": 82.8406,
        "delta": 0.0096
      },
      {
        "periodo": 202603,
        "valor": 84.8675,
        "delta": 2.0269
      },
      {
        "periodo": 202604,
        "valor": 79.2894,
        "delta": -5.5781
      },
      {
        "periodo": 202605,
        "valor": 73.0249,
        "delta": -6.2645
      },
      {
        "periodo": 202606,
        "valor": 75.1325,
        "delta": 2.1076
      },
      {
        "periodo": 202607,
        "valor": 73.7005,
        "delta": -1.432
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 72.455027,
    "valor_anterior": 73.456086,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 68.6523,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 69.0249,
        "delta": 0.3726
      },
      {
        "periodo": 202509,
        "valor": 69.4594,
        "delta": 0.4345
      },
      {
        "periodo": 202510,
        "valor": 69.7152,
        "delta": 0.2558
      },
      {
        "periodo": 202511,
        "valor": 70.9058,
        "delta": 1.1906
      },
      {
        "periodo": 202512,
        "valor": 69.4404,
        "delta": -1.4654
      },
      {
        "periodo": 202601,
        "valor": 68.7108,
        "delta": -0.7296
      },
      {
        "periodo": 202602,
        "valor": 69.8942,
        "delta": 1.1834
      },
      {
        "periodo": 202603,
        "valor": 70.1367,
        "delta": 0.2425
      },
      {
        "periodo": 202604,
        "valor": 72.453,
        "delta": 2.3163
      },
      {
        "periodo": 202605,
        "valor": 73.7986,
        "delta": 1.3456
      },
      {
        "periodo": 202606,
        "valor": 73.4561,
        "delta": -0.3426
      },
      {
        "periodo": 202607,
        "valor": 72.455,
        "delta": -1.0011
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 132.781815,
    "valor_anterior": 134.183179,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 143.5183,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 134.4375,
        "delta": -9.0808
      },
      {
        "periodo": 202509,
        "valor": 130.4236,
        "delta": -4.0138
      },
      {
        "periodo": 202510,
        "valor": 123.0719,
        "delta": -7.3517
      },
      {
        "periodo": 202511,
        "valor": 121.8646,
        "delta": -1.2074
      },
      {
        "periodo": 202512,
        "valor": 153.0281,
        "delta": 31.1636
      },
      {
        "periodo": 202601,
        "valor": 164.0392,
        "delta": 11.0111
      },
      {
        "periodo": 202602,
        "valor": 131.2084,
        "delta": -32.8309
      },
      {
        "periodo": 202603,
        "valor": 137.6502,
        "delta": 6.4418
      },
      {
        "periodo": 202604,
        "valor": 133.2298,
        "delta": -4.4204
      },
      {
        "periodo": 202605,
        "valor": 135.4611,
        "delta": 2.2313
      },
      {
        "periodo": 202606,
        "valor": 134.1832,
        "delta": -1.2779
      },
      {
        "periodo": 202607,
        "valor": 132.7818,
        "delta": -1.4014
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 223.35916,
    "valor_anterior": 220.78887200000003,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 257.6151,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 241.8205,
        "delta": -15.7946
      },
      {
        "periodo": 202509,
        "valor": 255.651,
        "delta": 13.8306
      },
      {
        "periodo": 202510,
        "valor": 244.1721,
        "delta": -11.4789
      },
      {
        "periodo": 202511,
        "valor": 239.6714,
        "delta": -4.5007
      },
      {
        "periodo": 202512,
        "valor": 236.6856,
        "delta": -2.9858
      },
      {
        "periodo": 202601,
        "valor": 207.8206,
        "delta": -28.865
      },
      {
        "periodo": 202602,
        "valor": 200.9788,
        "delta": -6.8418
      },
      {
        "periodo": 202603,
        "valor": 231.0899,
        "delta": 30.1112
      },
      {
        "periodo": 202604,
        "valor": 230.5949,
        "delta": -0.495
      },
      {
        "periodo": 202605,
        "valor": 226.8462,
        "delta": -3.7487
      },
      {
        "periodo": 202606,
        "valor": 220.7889,
        "delta": -6.0574
      },
      {
        "periodo": 202607,
        "valor": 223.3592,
        "delta": 2.5703
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 149.882005,
    "valor_anterior": 161.687402,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 166.6847,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 173.2932,
        "delta": 6.6085
      },
      {
        "periodo": 202509,
        "valor": 171.6833,
        "delta": -1.6098
      },
      {
        "periodo": 202510,
        "valor": 176.6027,
        "delta": 4.9193
      },
      {
        "periodo": 202511,
        "valor": 178.3561,
        "delta": 1.7534
      },
      {
        "periodo": 202512,
        "valor": 180.3604,
        "delta": 2.0043
      },
      {
        "periodo": 202601,
        "valor": 173.3348,
        "delta": -7.0256
      },
      {
        "periodo": 202602,
        "valor": 174.5507,
        "delta": 1.216
      },
      {
        "periodo": 202603,
        "valor": 160.9274,
        "delta": -13.6233
      },
      {
        "periodo": 202604,
        "valor": 151.8741,
        "delta": -9.0533
      },
      {
        "periodo": 202605,
        "valor": 156.4649,
        "delta": 4.5908
      },
      {
        "periodo": 202606,
        "valor": 161.6874,
        "delta": 5.2225
      },
      {
        "periodo": 202607,
        "valor": 149.882,
        "delta": -11.8054
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 126.877002,
    "valor_anterior": 120.79882900000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 86.6242,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 84.8827,
        "delta": -1.7415
      },
      {
        "periodo": 202509,
        "valor": 86.241,
        "delta": 1.3583
      },
      {
        "periodo": 202510,
        "valor": 85.0531,
        "delta": -1.1879
      },
      {
        "periodo": 202511,
        "valor": 84.9393,
        "delta": -0.1138
      },
      {
        "periodo": 202512,
        "valor": 130.2127,
        "delta": 45.2734
      },
      {
        "periodo": 202601,
        "valor": 127.3415,
        "delta": -2.8712
      },
      {
        "periodo": 202602,
        "valor": 127.2067,
        "delta": -0.1348
      },
      {
        "periodo": 202603,
        "valor": 125.2451,
        "delta": -1.9616
      },
      {
        "periodo": 202604,
        "valor": 123.6299,
        "delta": -1.6152
      },
      {
        "periodo": 202605,
        "valor": 121.9512,
        "delta": -1.6787
      },
      {
        "periodo": 202606,
        "valor": 120.7988,
        "delta": -1.1524
      },
      {
        "periodo": 202607,
        "valor": 126.877,
        "delta": 6.0782
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 134.715031,
    "valor_anterior": 132.395288,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 152.2945,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 156.928,
        "delta": 4.6335
      },
      {
        "periodo": 202509,
        "valor": 134.9442,
        "delta": -21.9838
      },
      {
        "periodo": 202510,
        "valor": 132.9809,
        "delta": -1.9633
      },
      {
        "periodo": 202511,
        "valor": 131.9629,
        "delta": -1.018
      },
      {
        "periodo": 202512,
        "valor": 133.7966,
        "delta": 1.8337
      },
      {
        "periodo": 202601,
        "valor": 135.2688,
        "delta": 1.4722
      },
      {
        "periodo": 202602,
        "valor": 135.6247,
        "delta": 0.3559
      },
      {
        "periodo": 202603,
        "valor": 139.0525,
        "delta": 3.4278
      },
      {
        "periodo": 202604,
        "valor": 137.367,
        "delta": -1.6855
      },
      {
        "periodo": 202605,
        "valor": 134.5607,
        "delta": -2.8063
      },
      {
        "periodo": 202606,
        "valor": 132.3953,
        "delta": -2.1654
      },
      {
        "periodo": 202607,
        "valor": 134.715,
        "delta": 2.3197
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 139.04554,
    "valor_anterior": 135.869766,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 128.4082,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 128.6824,
        "delta": 0.2742
      },
      {
        "periodo": 202509,
        "valor": 129.9927,
        "delta": 1.3103
      },
      {
        "periodo": 202510,
        "valor": 138.8262,
        "delta": 8.8335
      },
      {
        "periodo": 202511,
        "valor": 146.5426,
        "delta": 7.7165
      },
      {
        "periodo": 202512,
        "valor": 176.0119,
        "delta": 29.4692
      },
      {
        "periodo": 202601,
        "valor": 179.699,
        "delta": 3.6872
      },
      {
        "periodo": 202602,
        "valor": 172.6412,
        "delta": -7.0578
      },
      {
        "periodo": 202603,
        "valor": 170.3291,
        "delta": -2.3121
      },
      {
        "periodo": 202604,
        "valor": 143.0523,
        "delta": -27.2768
      },
      {
        "periodo": 202605,
        "valor": 136.4218,
        "delta": -6.6305
      },
      {
        "periodo": 202606,
        "valor": 135.8698,
        "delta": -0.552
      },
      {
        "periodo": 202607,
        "valor": 139.0455,
        "delta": 3.1758
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 123.053239,
    "valor_anterior": 124.596952,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 107.714,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 111.1577,
        "delta": 3.4436
      },
      {
        "periodo": 202509,
        "valor": 115.2037,
        "delta": 4.046
      },
      {
        "periodo": 202510,
        "valor": 115.9194,
        "delta": 0.7157
      },
      {
        "periodo": 202511,
        "valor": 95.6366,
        "delta": -20.2828
      },
      {
        "periodo": 202512,
        "valor": 91.6544,
        "delta": -3.9822
      },
      {
        "periodo": 202601,
        "valor": 91.2439,
        "delta": -0.4105
      },
      {
        "periodo": 202602,
        "valor": 110.0217,
        "delta": 18.7778
      },
      {
        "periodo": 202603,
        "valor": 102.2644,
        "delta": -7.7573
      },
      {
        "periodo": 202604,
        "valor": 100.4059,
        "delta": -1.8585
      },
      {
        "periodo": 202605,
        "valor": 101.6879,
        "delta": 1.2821
      },
      {
        "periodo": 202606,
        "valor": 124.597,
        "delta": 22.909
      },
      {
        "periodo": 202607,
        "valor": 123.0532,
        "delta": -1.5437
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 163.8095,
    "valor_anterior": 161.70800499999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 189.6772,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 188.5908,
        "delta": -1.0864
      },
      {
        "periodo": 202509,
        "valor": 184.3,
        "delta": -4.2908
      },
      {
        "periodo": 202510,
        "valor": 192.3473,
        "delta": 8.0474
      },
      {
        "periodo": 202511,
        "valor": 190.1947,
        "delta": -2.1526
      },
      {
        "periodo": 202512,
        "valor": 184.5653,
        "delta": -5.6294
      },
      {
        "periodo": 202601,
        "valor": 173.7302,
        "delta": -10.8351
      },
      {
        "periodo": 202602,
        "valor": 174.7506,
        "delta": 1.0204
      },
      {
        "periodo": 202603,
        "valor": 166.2348,
        "delta": -8.5158
      },
      {
        "periodo": 202604,
        "valor": 163.7364,
        "delta": -2.4983
      },
      {
        "periodo": 202605,
        "valor": 161.4396,
        "delta": -2.2968
      },
      {
        "periodo": 202606,
        "valor": 161.708,
        "delta": 0.2684
      },
      {
        "periodo": 202607,
        "valor": 163.8095,
        "delta": 2.1015
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 211.79087,
    "valor_anterior": 220.091183,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 274.0441,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 255.0849,
        "delta": -18.9592
      },
      {
        "periodo": 202509,
        "valor": 254.1132,
        "delta": -0.9718
      },
      {
        "periodo": 202510,
        "valor": 223.0703,
        "delta": -31.0429
      },
      {
        "periodo": 202511,
        "valor": 201.9289,
        "delta": -21.1413
      },
      {
        "periodo": 202512,
        "valor": 195.2842,
        "delta": -6.6448
      },
      {
        "periodo": 202601,
        "valor": 205.7069,
        "delta": 10.4227
      },
      {
        "periodo": 202602,
        "valor": 214.1203,
        "delta": 8.4134
      },
      {
        "periodo": 202603,
        "valor": 208.9793,
        "delta": -5.1411
      },
      {
        "periodo": 202604,
        "valor": 208.9791,
        "delta": -0.0002
      },
      {
        "periodo": 202605,
        "valor": 216.5897,
        "delta": 7.6106
      },
      {
        "periodo": 202606,
        "valor": 220.0912,
        "delta": 3.5015
      },
      {
        "periodo": 202607,
        "valor": 211.7909,
        "delta": -8.3003
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 110.604778,
    "valor_anterior": 111.11922999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 131.8812,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 153.7245,
        "delta": 21.8433
      },
      {
        "periodo": 202509,
        "valor": 178.954,
        "delta": 25.2294
      },
      {
        "periodo": 202510,
        "valor": 147.3779,
        "delta": -31.5761
      },
      {
        "periodo": 202511,
        "valor": 138.2839,
        "delta": -9.094
      },
      {
        "periodo": 202512,
        "valor": 112.6458,
        "delta": -25.6381
      },
      {
        "periodo": 202601,
        "valor": 95.3548,
        "delta": -17.291
      },
      {
        "periodo": 202602,
        "valor": 103.0477,
        "delta": 7.6928
      },
      {
        "periodo": 202603,
        "valor": 107.3281,
        "delta": 4.2804
      },
      {
        "periodo": 202604,
        "valor": 115.6915,
        "delta": 8.3634
      },
      {
        "periodo": 202605,
        "valor": 109.2199,
        "delta": -6.4716
      },
      {
        "periodo": 202606,
        "valor": 111.1192,
        "delta": 1.8993
      },
      {
        "periodo": 202607,
        "valor": 110.6048,
        "delta": -0.5145
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 203.33683800000003,
    "valor_anterior": 203.33126,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 234.4674,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 236.8783,
        "delta": 2.4108
      },
      {
        "periodo": 202509,
        "valor": 236.6115,
        "delta": -0.2667
      },
      {
        "periodo": 202510,
        "valor": 235.2673,
        "delta": -1.3442
      },
      {
        "periodo": 202511,
        "valor": 225.5182,
        "delta": -9.7491
      },
      {
        "periodo": 202512,
        "valor": 209.6472,
        "delta": -15.871
      },
      {
        "periodo": 202601,
        "valor": 205.5646,
        "delta": -4.0826
      },
      {
        "periodo": 202602,
        "valor": 191.8032,
        "delta": -13.7614
      },
      {
        "periodo": 202603,
        "valor": 187.1454,
        "delta": -4.6578
      },
      {
        "periodo": 202604,
        "valor": 198.1426,
        "delta": 10.9972
      },
      {
        "periodo": 202605,
        "valor": 195.572,
        "delta": -2.5706
      },
      {
        "periodo": 202606,
        "valor": 203.3313,
        "delta": 7.7592
      },
      {
        "periodo": 202607,
        "valor": 203.3368,
        "delta": 0.0056
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 114.108468,
    "valor_anterior": 113.34113500000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 112.4191,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 114.3501,
        "delta": 1.931
      },
      {
        "periodo": 202509,
        "valor": 109.9266,
        "delta": -4.4235
      },
      {
        "periodo": 202510,
        "valor": 110.656,
        "delta": 0.7294
      },
      {
        "periodo": 202511,
        "valor": 112.6105,
        "delta": 1.9545
      },
      {
        "periodo": 202512,
        "valor": 118.959,
        "delta": 6.3485
      },
      {
        "periodo": 202601,
        "valor": 116.0506,
        "delta": -2.9084
      },
      {
        "periodo": 202602,
        "valor": 134.7003,
        "delta": 18.6497
      },
      {
        "periodo": 202603,
        "valor": 136.0582,
        "delta": 1.3578
      },
      {
        "periodo": 202604,
        "valor": 124.7989,
        "delta": -11.2592
      },
      {
        "periodo": 202605,
        "valor": 108.633,
        "delta": -16.1659
      },
      {
        "periodo": 202606,
        "valor": 113.3411,
        "delta": 4.7081
      },
      {
        "periodo": 202607,
        "valor": 114.1085,
        "delta": 0.7673
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 143.455728,
    "valor_anterior": 142.499757,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 107.5565,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 111.1205,
        "delta": 3.564
      },
      {
        "periodo": 202509,
        "valor": 113.4637,
        "delta": 2.3432
      },
      {
        "periodo": 202510,
        "valor": 111.293,
        "delta": -2.1707
      },
      {
        "periodo": 202511,
        "valor": 115.494,
        "delta": 4.201
      },
      {
        "periodo": 202512,
        "valor": 130.4664,
        "delta": 14.9723
      },
      {
        "periodo": 202601,
        "valor": 134.5055,
        "delta": 4.0391
      },
      {
        "periodo": 202602,
        "valor": 129.5514,
        "delta": -4.9541
      },
      {
        "periodo": 202603,
        "valor": 130.1269,
        "delta": 0.5755
      },
      {
        "periodo": 202604,
        "valor": 126.4899,
        "delta": -3.637
      },
      {
        "periodo": 202605,
        "valor": 134.7989,
        "delta": 8.309
      },
      {
        "periodo": 202606,
        "valor": 142.4998,
        "delta": 7.7008
      },
      {
        "periodo": 202607,
        "valor": 143.4557,
        "delta": 0.956
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 123.66785600000001,
    "valor_anterior": 109.84910699999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 144.7907,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 143.2332,
        "delta": -1.5575
      },
      {
        "periodo": 202509,
        "valor": 128.6858,
        "delta": -14.5474
      },
      {
        "periodo": 202510,
        "valor": 120.5625,
        "delta": -8.1233
      },
      {
        "periodo": 202511,
        "valor": 117.9423,
        "delta": -2.6201
      },
      {
        "periodo": 202512,
        "valor": 135.6494,
        "delta": 17.7071
      },
      {
        "periodo": 202601,
        "valor": 132.7899,
        "delta": -2.8596
      },
      {
        "periodo": 202602,
        "valor": 142.6937,
        "delta": 9.9038
      },
      {
        "periodo": 202603,
        "valor": 109.4288,
        "delta": -33.2648
      },
      {
        "periodo": 202604,
        "valor": 109.5499,
        "delta": 0.1211
      },
      {
        "periodo": 202605,
        "valor": 109.6251,
        "delta": 0.0752
      },
      {
        "periodo": 202606,
        "valor": 109.8491,
        "delta": 0.224
      },
      {
        "periodo": 202607,
        "valor": 123.6679,
        "delta": 13.8187
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 137.548758,
    "valor_anterior": 136.77618,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 149.5599,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 150.1693,
        "delta": 0.6094
      },
      {
        "periodo": 202509,
        "valor": 150.3434,
        "delta": 0.1741
      },
      {
        "periodo": 202510,
        "valor": 166.5515,
        "delta": 16.2081
      },
      {
        "periodo": 202511,
        "valor": 155.1366,
        "delta": -11.4149
      },
      {
        "periodo": 202512,
        "valor": 167.8292,
        "delta": 12.6926
      },
      {
        "periodo": 202601,
        "valor": 133.2859,
        "delta": -34.5433
      },
      {
        "periodo": 202602,
        "valor": 132.269,
        "delta": -1.0169
      },
      {
        "periodo": 202603,
        "valor": 131.4814,
        "delta": -0.7876
      },
      {
        "periodo": 202604,
        "valor": 133.959,
        "delta": 2.4777
      },
      {
        "periodo": 202605,
        "valor": 129.1691,
        "delta": -4.7899
      },
      {
        "periodo": 202606,
        "valor": 136.7762,
        "delta": 7.607
      },
      {
        "periodo": 202607,
        "valor": 137.5488,
        "delta": 0.7726
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 148.804994,
    "valor_anterior": 146.57226,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 119.8188,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 122.121,
        "delta": 2.3023
      },
      {
        "periodo": 202509,
        "valor": 130.3937,
        "delta": 8.2727
      },
      {
        "periodo": 202510,
        "valor": 131.97,
        "delta": 1.5763
      },
      {
        "periodo": 202511,
        "valor": 137.6129,
        "delta": 5.6428
      },
      {
        "periodo": 202512,
        "valor": 135.4875,
        "delta": -2.1253
      },
      {
        "periodo": 202601,
        "valor": 132.0534,
        "delta": -3.4341
      },
      {
        "periodo": 202602,
        "valor": 135.9463,
        "delta": 3.8928
      },
      {
        "periodo": 202603,
        "valor": 142.5765,
        "delta": 6.6302
      },
      {
        "periodo": 202604,
        "valor": 147.2433,
        "delta": 4.6668
      },
      {
        "periodo": 202605,
        "valor": 146.3888,
        "delta": -0.8544
      },
      {
        "periodo": 202606,
        "valor": 146.5723,
        "delta": 0.1834
      },
      {
        "periodo": 202607,
        "valor": 148.805,
        "delta": 2.2327
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 220.92220600000002,
    "valor_anterior": 231.877087,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 224.0272,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 232.9645,
        "delta": 8.9373
      },
      {
        "periodo": 202509,
        "valor": 237.1531,
        "delta": 4.1886
      },
      {
        "periodo": 202510,
        "valor": 232.2525,
        "delta": -4.9006
      },
      {
        "periodo": 202511,
        "valor": 227.2562,
        "delta": -4.9964
      },
      {
        "periodo": 202512,
        "valor": 224.3042,
        "delta": -2.952
      },
      {
        "periodo": 202601,
        "valor": 233.5838,
        "delta": 9.2796
      },
      {
        "periodo": 202602,
        "valor": 229.5474,
        "delta": -4.0364
      },
      {
        "periodo": 202603,
        "valor": 240.6937,
        "delta": 11.1463
      },
      {
        "periodo": 202604,
        "valor": 236.6024,
        "delta": -4.0913
      },
      {
        "periodo": 202605,
        "valor": 243.2636,
        "delta": 6.6611
      },
      {
        "periodo": 202606,
        "valor": 231.8771,
        "delta": -11.3865
      },
      {
        "periodo": 202607,
        "valor": 220.9222,
        "delta": -10.9549
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 165.812025,
    "valor_anterior": 172.688863,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 210.4993,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 249.9195,
        "delta": 39.4202
      },
      {
        "periodo": 202509,
        "valor": 197.1718,
        "delta": -52.7477
      },
      {
        "periodo": 202510,
        "valor": 202.4425,
        "delta": 5.2707
      },
      {
        "periodo": 202511,
        "valor": 227.822,
        "delta": 25.3795
      },
      {
        "periodo": 202512,
        "valor": 209.0991,
        "delta": -18.723
      },
      {
        "periodo": 202601,
        "valor": 240.8172,
        "delta": 31.7182
      },
      {
        "periodo": 202602,
        "valor": 233.8929,
        "delta": -6.9244
      },
      {
        "periodo": 202603,
        "valor": 181.0526,
        "delta": -52.8403
      },
      {
        "periodo": 202604,
        "valor": 174.6347,
        "delta": -6.4179
      },
      {
        "periodo": 202605,
        "valor": 185.6459,
        "delta": 11.0111
      },
      {
        "periodo": 202606,
        "valor": 172.6889,
        "delta": -12.957
      },
      {
        "periodo": 202607,
        "valor": 165.812,
        "delta": -6.8768
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 102.0289,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 64.7105,
        "delta": -37.3183
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 94.12921899999999,
    "valor_anterior": 94.158911,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 104.1921,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 101.0905,
        "delta": -3.1016
      },
      {
        "periodo": 202509,
        "valor": 103.57,
        "delta": 2.4795
      },
      {
        "periodo": 202510,
        "valor": 103.4723,
        "delta": -0.0976
      },
      {
        "periodo": 202511,
        "valor": 102.6376,
        "delta": -0.8348
      },
      {
        "periodo": 202512,
        "valor": 102.4454,
        "delta": -0.1922
      },
      {
        "periodo": 202601,
        "valor": 101.0059,
        "delta": -1.4395
      },
      {
        "periodo": 202602,
        "valor": 100.956,
        "delta": -0.0499
      },
      {
        "periodo": 202603,
        "valor": 99.7033,
        "delta": -1.2527
      },
      {
        "periodo": 202604,
        "valor": 105.5635,
        "delta": 5.8602
      },
      {
        "periodo": 202605,
        "valor": 94.9501,
        "delta": -10.6134
      },
      {
        "periodo": 202606,
        "valor": 94.1589,
        "delta": -0.7912
      },
      {
        "periodo": 202607,
        "valor": 94.1292,
        "delta": -0.0297
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 239.424658,
    "valor_anterior": 221.96809000000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 209.1237,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 216.9146,
        "delta": 7.791
      },
      {
        "periodo": 202509,
        "valor": 202.2104,
        "delta": -14.7043
      },
      {
        "periodo": 202510,
        "valor": 182.1068,
        "delta": -20.1036
      },
      {
        "periodo": 202511,
        "valor": 193.5182,
        "delta": 11.4114
      },
      {
        "periodo": 202512,
        "valor": 204.606,
        "delta": 11.0878
      },
      {
        "periodo": 202601,
        "valor": 204.1686,
        "delta": -0.4374
      },
      {
        "periodo": 202602,
        "valor": 217.7998,
        "delta": 13.6313
      },
      {
        "periodo": 202603,
        "valor": 228.5227,
        "delta": 10.7229
      },
      {
        "periodo": 202604,
        "valor": 229.5894,
        "delta": 1.0667
      },
      {
        "periodo": 202605,
        "valor": 243.4458,
        "delta": 13.8564
      },
      {
        "periodo": 202606,
        "valor": 221.9681,
        "delta": -21.4777
      },
      {
        "periodo": 202607,
        "valor": 239.4247,
        "delta": 17.4566
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 115.81599700000001,
    "valor_anterior": 120.68682799999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 125.5592,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 135.0563,
        "delta": 9.4971
      },
      {
        "periodo": 202509,
        "valor": 155.7378,
        "delta": 20.6815
      },
      {
        "periodo": 202510,
        "valor": 174.692,
        "delta": 18.9542
      },
      {
        "periodo": 202511,
        "valor": 177.6619,
        "delta": 2.9699
      },
      {
        "periodo": 202512,
        "valor": 152.3245,
        "delta": -25.3374
      },
      {
        "periodo": 202601,
        "valor": 150.042,
        "delta": -2.2825
      },
      {
        "periodo": 202602,
        "valor": 147.2573,
        "delta": -2.7847
      },
      {
        "periodo": 202603,
        "valor": 139.2341,
        "delta": -8.0232
      },
      {
        "periodo": 202604,
        "valor": 137.2538,
        "delta": -1.9804
      },
      {
        "periodo": 202605,
        "valor": 127.0565,
        "delta": -10.1972
      },
      {
        "periodo": 202606,
        "valor": 120.6868,
        "delta": -6.3697
      },
      {
        "periodo": 202607,
        "valor": 115.816,
        "delta": -4.8708
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 66.688029,
    "valor_anterior": 69.827809,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 65.8851,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 64.459,
        "delta": -1.4261
      },
      {
        "periodo": 202509,
        "valor": 64.1077,
        "delta": -0.3513
      },
      {
        "periodo": 202510,
        "valor": 65.7752,
        "delta": 1.6675
      },
      {
        "periodo": 202511,
        "valor": 65.3376,
        "delta": -0.4376
      },
      {
        "periodo": 202512,
        "valor": 67.2198,
        "delta": 1.8823
      },
      {
        "periodo": 202601,
        "valor": 67.8164,
        "delta": 0.5965
      },
      {
        "periodo": 202602,
        "valor": 70.2222,
        "delta": 2.4058
      },
      {
        "periodo": 202603,
        "valor": 70.2415,
        "delta": 0.0193
      },
      {
        "periodo": 202604,
        "valor": 67.4603,
        "delta": -2.7811
      },
      {
        "periodo": 202605,
        "valor": 68.5726,
        "delta": 1.1122
      },
      {
        "periodo": 202606,
        "valor": 69.8278,
        "delta": 1.2552
      },
      {
        "periodo": 202607,
        "valor": 66.688,
        "delta": -3.1398
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 277.121499,
    "valor_anterior": 266.186351,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 388.3568,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 369.2869,
        "delta": -19.07
      },
      {
        "periodo": 202509,
        "valor": 352.5578,
        "delta": -16.729
      },
      {
        "periodo": 202510,
        "valor": 283.5984,
        "delta": -68.9594
      },
      {
        "periodo": 202511,
        "valor": 281.6375,
        "delta": -1.9609
      },
      {
        "periodo": 202512,
        "valor": 282.3048,
        "delta": 0.6673
      },
      {
        "periodo": 202601,
        "valor": 272.6366,
        "delta": -9.6683
      },
      {
        "periodo": 202602,
        "valor": 274.9996,
        "delta": 2.3631
      },
      {
        "periodo": 202603,
        "valor": 275.7507,
        "delta": 0.7511
      },
      {
        "periodo": 202604,
        "valor": 277.0593,
        "delta": 1.3086
      },
      {
        "periodo": 202605,
        "valor": 268.4633,
        "delta": -8.596
      },
      {
        "periodo": 202606,
        "valor": 266.1864,
        "delta": -2.2769
      },
      {
        "periodo": 202607,
        "valor": 277.1215,
        "delta": 10.9351
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 74.184865,
    "valor_anterior": 73.949007,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 149.3579,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 72.3743,
        "delta": -76.9836
      },
      {
        "periodo": 202509,
        "valor": 87.4112,
        "delta": 15.0369
      },
      {
        "periodo": 202510,
        "valor": 84.5262,
        "delta": -2.885
      },
      {
        "periodo": 202511,
        "valor": 87.4876,
        "delta": 2.9614
      },
      {
        "periodo": 202512,
        "valor": 92.0288,
        "delta": 4.5412
      },
      {
        "periodo": 202601,
        "valor": 64.4092,
        "delta": -27.6196
      },
      {
        "periodo": 202602,
        "valor": 64.5717,
        "delta": 0.1625
      },
      {
        "periodo": 202603,
        "valor": 73.9626,
        "delta": 9.3909
      },
      {
        "periodo": 202604,
        "valor": 73.9957,
        "delta": 0.0331
      },
      {
        "periodo": 202605,
        "valor": 68.9048,
        "delta": -5.0909
      },
      {
        "periodo": 202606,
        "valor": 73.949,
        "delta": 5.0442
      },
      {
        "periodo": 202607,
        "valor": 74.1849,
        "delta": 0.2359
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 74.067031,
    "valor_anterior": 75.006582,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 69.2767,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 69.8315,
        "delta": 0.5547
      },
      {
        "periodo": 202509,
        "valor": 70.9082,
        "delta": 1.0767
      },
      {
        "periodo": 202510,
        "valor": 70.9179,
        "delta": 0.0098
      },
      {
        "periodo": 202511,
        "valor": 72.3898,
        "delta": 1.4719
      },
      {
        "periodo": 202512,
        "valor": 72.9119,
        "delta": 0.522
      },
      {
        "periodo": 202601,
        "valor": 67.0255,
        "delta": -5.8863
      },
      {
        "periodo": 202602,
        "valor": 68.496,
        "delta": 1.4705
      },
      {
        "periodo": 202603,
        "valor": 70.088,
        "delta": 1.592
      },
      {
        "periodo": 202604,
        "valor": 71.8145,
        "delta": 1.7265
      },
      {
        "periodo": 202605,
        "valor": 74.0469,
        "delta": 2.2325
      },
      {
        "periodo": 202606,
        "valor": 75.0066,
        "delta": 0.9596
      },
      {
        "periodo": 202607,
        "valor": 74.067,
        "delta": -0.9396
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 77.387714,
    "valor_anterior": 60.517109999999995,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 161.11,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 56.9652,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": 58.0116,
        "delta": 1.0464
      },
      {
        "periodo": 202606,
        "valor": 60.5171,
        "delta": 2.5055
      },
      {
        "periodo": 202607,
        "valor": 77.3877,
        "delta": 16.8706
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 67.548665,
    "valor_anterior": 66.205417,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 66.0529,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 68.9981,
        "delta": 2.9452
      },
      {
        "periodo": 202509,
        "valor": 69.5859,
        "delta": 0.5878
      },
      {
        "periodo": 202510,
        "valor": 71.5118,
        "delta": 1.9259
      },
      {
        "periodo": 202511,
        "valor": 71.3576,
        "delta": -0.1542
      },
      {
        "periodo": 202512,
        "valor": 81.2758,
        "delta": 9.9182
      },
      {
        "periodo": 202601,
        "valor": 70.7112,
        "delta": -10.5646
      },
      {
        "periodo": 202602,
        "valor": 72.26,
        "delta": 1.5488
      },
      {
        "periodo": 202603,
        "valor": 70.2723,
        "delta": -1.9877
      },
      {
        "periodo": 202604,
        "valor": 70.8734,
        "delta": 0.6012
      },
      {
        "periodo": 202605,
        "valor": 70.7429,
        "delta": -0.1306
      },
      {
        "periodo": 202606,
        "valor": 66.2054,
        "delta": -4.5375
      },
      {
        "periodo": 202607,
        "valor": 67.5487,
        "delta": 1.3432
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 105.76303499999999,
    "valor_anterior": 77.261693,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 82.6187,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 74.3435,
        "delta": -8.2752
      },
      {
        "periodo": 202509,
        "valor": 72.7273,
        "delta": -1.6162
      },
      {
        "periodo": 202510,
        "valor": 72.1425,
        "delta": -0.5848
      },
      {
        "periodo": 202511,
        "valor": 72.2185,
        "delta": 0.076
      },
      {
        "periodo": 202512,
        "valor": 71.7369,
        "delta": -0.4815
      },
      {
        "periodo": 202601,
        "valor": 69.2253,
        "delta": -2.5117
      },
      {
        "periodo": 202602,
        "valor": 68.52,
        "delta": -0.7052
      },
      {
        "periodo": 202603,
        "valor": 69.9632,
        "delta": 1.4432
      },
      {
        "periodo": 202604,
        "valor": 73.0358,
        "delta": 3.0726
      },
      {
        "periodo": 202605,
        "valor": 71.2589,
        "delta": -1.7769
      },
      {
        "periodo": 202606,
        "valor": 77.2617,
        "delta": 6.0028
      },
      {
        "periodo": 202607,
        "valor": 105.763,
        "delta": 28.5013
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 144.982968,
    "valor_anterior": 143.461109,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 111.3128,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 109.5885,
        "delta": -1.7243
      },
      {
        "periodo": 202509,
        "valor": 109.8192,
        "delta": 0.2307
      },
      {
        "periodo": 202510,
        "valor": 121.0543,
        "delta": 11.2351
      },
      {
        "periodo": 202511,
        "valor": 124.7079,
        "delta": 3.6536
      },
      {
        "periodo": 202512,
        "valor": 122.7905,
        "delta": -1.9174
      },
      {
        "periodo": 202601,
        "valor": 123.7677,
        "delta": 0.9772
      },
      {
        "periodo": 202602,
        "valor": 125.5752,
        "delta": 1.8075
      },
      {
        "periodo": 202603,
        "valor": 132.9449,
        "delta": 7.3697
      },
      {
        "periodo": 202604,
        "valor": 134.558,
        "delta": 1.6131
      },
      {
        "periodo": 202605,
        "valor": 134.5575,
        "delta": -0.0005
      },
      {
        "periodo": 202606,
        "valor": 143.4611,
        "delta": 8.9036
      },
      {
        "periodo": 202607,
        "valor": 144.983,
        "delta": 1.5219
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 125.106114,
    "valor_anterior": 125.102124,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 128.4538,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 127.477,
        "delta": -0.9767
      },
      {
        "periodo": 202509,
        "valor": 127.1359,
        "delta": -0.3411
      },
      {
        "periodo": 202510,
        "valor": 126.6114,
        "delta": -0.5245
      },
      {
        "periodo": 202511,
        "valor": 131.1755,
        "delta": 4.564
      },
      {
        "periodo": 202512,
        "valor": 130.2908,
        "delta": -0.8847
      },
      {
        "periodo": 202601,
        "valor": 129.6875,
        "delta": -0.6033
      },
      {
        "periodo": 202602,
        "valor": 129.0866,
        "delta": -0.6009
      },
      {
        "periodo": 202603,
        "valor": 130.1187,
        "delta": 1.0321
      },
      {
        "periodo": 202604,
        "valor": 130.3281,
        "delta": 0.2093
      },
      {
        "periodo": 202605,
        "valor": 126.989,
        "delta": -3.3391
      },
      {
        "periodo": 202606,
        "valor": 125.1021,
        "delta": -1.8869
      },
      {
        "periodo": 202607,
        "valor": 125.1061,
        "delta": 0.004
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 119.13843200000001,
    "valor_anterior": 123.01239100000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 98.1087,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 94.3372,
        "delta": -3.7715
      },
      {
        "periodo": 202509,
        "valor": 95.9788,
        "delta": 1.6416
      },
      {
        "periodo": 202510,
        "valor": 96.507,
        "delta": 0.5282
      },
      {
        "periodo": 202511,
        "valor": 110.0308,
        "delta": 13.5238
      },
      {
        "periodo": 202512,
        "valor": 101.9041,
        "delta": -8.1267
      },
      {
        "periodo": 202601,
        "valor": 109.4836,
        "delta": 7.5795
      },
      {
        "periodo": 202602,
        "valor": 110.2793,
        "delta": 0.7957
      },
      {
        "periodo": 202603,
        "valor": 123.72,
        "delta": 13.4406
      },
      {
        "periodo": 202604,
        "valor": 109.754,
        "delta": -13.966
      },
      {
        "periodo": 202605,
        "valor": 113.2262,
        "delta": 3.4722
      },
      {
        "periodo": 202606,
        "valor": 123.0124,
        "delta": 9.7862
      },
      {
        "periodo": 202607,
        "valor": 119.1384,
        "delta": -3.874
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 240.70009899999997,
    "valor_anterior": 257.719845,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 266.1413,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 270.7446,
        "delta": 4.6033
      },
      {
        "periodo": 202604,
        "valor": 281.1722,
        "delta": 10.4276
      },
      {
        "periodo": 202605,
        "valor": 253.9614,
        "delta": -27.2107
      },
      {
        "periodo": 202606,
        "valor": 257.7198,
        "delta": 3.7584
      },
      {
        "periodo": 202607,
        "valor": 240.7001,
        "delta": -17.0197
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 216.043005,
    "valor_anterior": 215.67442400000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2173.6899,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1034.7188,
        "delta": -1138.9712
      },
      {
        "periodo": 202509,
        "valor": 592.7742,
        "delta": -441.9446
      },
      {
        "periodo": 202510,
        "valor": 307.2071,
        "delta": -285.567
      },
      {
        "periodo": 202511,
        "valor": 209.4224,
        "delta": -97.7847
      },
      {
        "periodo": 202512,
        "valor": 194.5343,
        "delta": -14.8882
      },
      {
        "periodo": 202601,
        "valor": 202.2639,
        "delta": 7.7297
      },
      {
        "periodo": 202602,
        "valor": 254.4516,
        "delta": 52.1877
      },
      {
        "periodo": 202603,
        "valor": 257.5091,
        "delta": 3.0575
      },
      {
        "periodo": 202604,
        "valor": 252.5658,
        "delta": -4.9433
      },
      {
        "periodo": 202605,
        "valor": 234.6597,
        "delta": -17.9061
      },
      {
        "periodo": 202606,
        "valor": 215.6744,
        "delta": -18.9853
      },
      {
        "periodo": 202607,
        "valor": 216.043,
        "delta": 0.3686
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 7317.696894,
    "valor_anterior": 8855.597623,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 157250.2224,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 191452.9701,
        "delta": 34202.7477
      },
      {
        "periodo": 202605,
        "valor": 8930.3479,
        "delta": -182522.6222
      },
      {
        "periodo": 202606,
        "valor": 8855.5976,
        "delta": -74.7502
      },
      {
        "periodo": 202607,
        "valor": 7317.6969,
        "delta": -1537.9007
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 269.901578,
    "valor_anterior": 315.752119,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 331.7628,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 277.8964,
        "delta": -53.8664
      },
      {
        "periodo": 202605,
        "valor": 239.3364,
        "delta": -38.5601
      },
      {
        "periodo": 202606,
        "valor": 315.7521,
        "delta": 76.4157
      },
      {
        "periodo": 202607,
        "valor": 269.9016,
        "delta": -45.8505
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 145.306188,
    "valor_anterior": 145.39181000000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 151.2576,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 150.1552,
        "delta": -1.1023
      },
      {
        "periodo": 202509,
        "valor": 147.234,
        "delta": -2.9212
      },
      {
        "periodo": 202510,
        "valor": 146.6776,
        "delta": -0.5564
      },
      {
        "periodo": 202511,
        "valor": 146.0883,
        "delta": -0.5893
      },
      {
        "periodo": 202512,
        "valor": 148.3649,
        "delta": 2.2766
      },
      {
        "periodo": 202601,
        "valor": 146.3057,
        "delta": -2.0592
      },
      {
        "periodo": 202602,
        "valor": 149.2053,
        "delta": 2.8996
      },
      {
        "periodo": 202603,
        "valor": 150.4301,
        "delta": 1.2249
      },
      {
        "periodo": 202604,
        "valor": 146.7776,
        "delta": -3.6525
      },
      {
        "periodo": 202605,
        "valor": 145.3377,
        "delta": -1.4399
      },
      {
        "periodo": 202606,
        "valor": 145.3918,
        "delta": 0.0541
      },
      {
        "periodo": 202607,
        "valor": 145.3062,
        "delta": -0.0856
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 143.163608,
    "valor_anterior": 143.03070200000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 147.0647,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 146.9092,
        "delta": -0.1555
      },
      {
        "periodo": 202509,
        "valor": 142.9128,
        "delta": -3.9964
      },
      {
        "periodo": 202510,
        "valor": 143.1729,
        "delta": 0.2601
      },
      {
        "periodo": 202511,
        "valor": 144.2505,
        "delta": 1.0776
      },
      {
        "periodo": 202512,
        "valor": 144.5065,
        "delta": 0.256
      },
      {
        "periodo": 202601,
        "valor": 143.4863,
        "delta": -1.0202
      },
      {
        "periodo": 202602,
        "valor": 146.6992,
        "delta": 3.2129
      },
      {
        "periodo": 202603,
        "valor": 148.6641,
        "delta": 1.9649
      },
      {
        "periodo": 202604,
        "valor": 145.235,
        "delta": -3.4291
      },
      {
        "periodo": 202605,
        "valor": 144.0091,
        "delta": -1.2259
      },
      {
        "periodo": 202606,
        "valor": 143.0307,
        "delta": -0.9784
      },
      {
        "periodo": 202607,
        "valor": 143.1636,
        "delta": 0.1329
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 121.982341,
    "valor_anterior": 116.082263,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 125.5423,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 116.9841,
        "delta": -8.5582
      },
      {
        "periodo": 202509,
        "valor": 125.2155,
        "delta": 8.2314
      },
      {
        "periodo": 202510,
        "valor": 123.9735,
        "delta": -1.2419
      },
      {
        "periodo": 202511,
        "valor": 124.4558,
        "delta": 0.4823
      },
      {
        "periodo": 202512,
        "valor": 139.7361,
        "delta": 15.2803
      },
      {
        "periodo": 202601,
        "valor": 138.8866,
        "delta": -0.8495
      },
      {
        "periodo": 202602,
        "valor": 141.6938,
        "delta": 2.8073
      },
      {
        "periodo": 202603,
        "valor": 126.4959,
        "delta": -15.1979
      },
      {
        "periodo": 202604,
        "valor": 121.6669,
        "delta": -4.829
      },
      {
        "periodo": 202605,
        "valor": 116.5096,
        "delta": -5.1574
      },
      {
        "periodo": 202606,
        "valor": 116.0823,
        "delta": -0.4273
      },
      {
        "periodo": 202607,
        "valor": 121.9823,
        "delta": 5.9001
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 177.695354,
    "valor_anterior": 174.27325199999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 166.5043,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 163.4555,
        "delta": -3.0488
      },
      {
        "periodo": 202509,
        "valor": 165.5095,
        "delta": 2.054
      },
      {
        "periodo": 202510,
        "valor": 165.9434,
        "delta": 0.4339
      },
      {
        "periodo": 202511,
        "valor": 164.7716,
        "delta": -1.1718
      },
      {
        "periodo": 202512,
        "valor": 193.2292,
        "delta": 28.4576
      },
      {
        "periodo": 202601,
        "valor": 180.4481,
        "delta": -12.7811
      },
      {
        "periodo": 202602,
        "valor": 179.6694,
        "delta": -0.7787
      },
      {
        "periodo": 202603,
        "valor": 181.4935,
        "delta": 1.8241
      },
      {
        "periodo": 202604,
        "valor": 179.4226,
        "delta": -2.0709
      },
      {
        "periodo": 202605,
        "valor": 175.3135,
        "delta": -4.1091
      },
      {
        "periodo": 202606,
        "valor": 174.2733,
        "delta": -1.0403
      },
      {
        "periodo": 202607,
        "valor": 177.6954,
        "delta": 3.4221
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 100.526636,
    "valor_anterior": 100.49470099999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 110.0025,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 108.4615,
        "delta": -1.541
      },
      {
        "periodo": 202509,
        "valor": 105.3174,
        "delta": -3.1441
      },
      {
        "periodo": 202510,
        "valor": 105.3662,
        "delta": 0.0488
      },
      {
        "periodo": 202511,
        "valor": 103.6115,
        "delta": -1.7547
      },
      {
        "periodo": 202512,
        "valor": 113.2059,
        "delta": 9.5945
      },
      {
        "periodo": 202601,
        "valor": 111.2317,
        "delta": -1.9743
      },
      {
        "periodo": 202602,
        "valor": 112.6342,
        "delta": 1.4025
      },
      {
        "periodo": 202603,
        "valor": 110.4329,
        "delta": -2.2013
      },
      {
        "periodo": 202604,
        "valor": 103.2774,
        "delta": -7.1555
      },
      {
        "periodo": 202605,
        "valor": 99.6456,
        "delta": -3.6318
      },
      {
        "periodo": 202606,
        "valor": 100.4947,
        "delta": 0.8491
      },
      {
        "periodo": 202607,
        "valor": 100.5266,
        "delta": 0.0319
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 112.35324600000001,
    "valor_anterior": 112.9003,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 129.8342,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 119.0913,
        "delta": -10.7429
      },
      {
        "periodo": 202509,
        "valor": 124.4012,
        "delta": 5.3099
      },
      {
        "periodo": 202510,
        "valor": 122.4482,
        "delta": -1.9531
      },
      {
        "periodo": 202511,
        "valor": 124.5967,
        "delta": 2.1485
      },
      {
        "periodo": 202512,
        "valor": 126.5137,
        "delta": 1.9169
      },
      {
        "periodo": 202601,
        "valor": 111.0572,
        "delta": -15.4564
      },
      {
        "periodo": 202602,
        "valor": 112.7894,
        "delta": 1.7322
      },
      {
        "periodo": 202603,
        "valor": 115.3971,
        "delta": 2.6077
      },
      {
        "periodo": 202604,
        "valor": 110.7014,
        "delta": -4.6957
      },
      {
        "periodo": 202605,
        "valor": 109.4195,
        "delta": -1.2819
      },
      {
        "periodo": 202606,
        "valor": 112.9003,
        "delta": 3.4808
      },
      {
        "periodo": 202607,
        "valor": 112.3532,
        "delta": -0.5471
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200096,
    "label": "ICOR",
    "valor_actual": 195.706037,
    "valor_anterior": 200.62752700000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 233.0352,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 224.7185,
        "delta": -8.3167
      },
      {
        "periodo": 202509,
        "valor": 224.7743,
        "delta": 0.0559
      },
      {
        "periodo": 202510,
        "valor": 213.4644,
        "delta": -11.31
      },
      {
        "periodo": 202511,
        "valor": 195.8151,
        "delta": -17.6493
      },
      {
        "periodo": 202512,
        "valor": 192.8309,
        "delta": -2.9841
      },
      {
        "periodo": 202601,
        "valor": 188.745,
        "delta": -4.0859
      },
      {
        "periodo": 202602,
        "valor": 191.3533,
        "delta": 2.6083
      },
      {
        "periodo": 202603,
        "valor": 190.9947,
        "delta": -0.3586
      },
      {
        "periodo": 202604,
        "valor": 191.9968,
        "delta": 1.002
      },
      {
        "periodo": 202605,
        "valor": 192.7315,
        "delta": 0.7348
      },
      {
        "periodo": 202606,
        "valor": 200.6275,
        "delta": 7.896
      },
      {
        "periodo": 202607,
        "valor": 195.706,
        "delta": -4.9215
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 5.422202,
    "valor_anterior": 5.430949999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5.3524,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5.3359,
        "delta": -0.0165
      },
      {
        "periodo": 202509,
        "valor": 5.3341,
        "delta": -0.0018
      },
      {
        "periodo": 202510,
        "valor": 5.3949,
        "delta": 0.0608
      },
      {
        "periodo": 202511,
        "valor": 5.3102,
        "delta": -0.0847
      },
      {
        "periodo": 202512,
        "valor": 5.4158,
        "delta": 0.1056
      },
      {
        "periodo": 202601,
        "valor": 5.4162,
        "delta": 0.0004
      },
      {
        "periodo": 202602,
        "valor": 5.3978,
        "delta": -0.0184
      },
      {
        "periodo": 202603,
        "valor": 5.383,
        "delta": -0.0148
      },
      {
        "periodo": 202604,
        "valor": 5.4125,
        "delta": 0.0295
      },
      {
        "periodo": 202605,
        "valor": 5.4433,
        "delta": 0.0308
      },
      {
        "periodo": 202606,
        "valor": 5.4309,
        "delta": -0.0124
      },
      {
        "periodo": 202607,
        "valor": 5.4222,
        "delta": -0.0087
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 3.270232,
    "valor_anterior": 3.258031,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.0912,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.1356,
        "delta": 0.0444
      },
      {
        "periodo": 202509,
        "valor": 3.1471,
        "delta": 0.0115
      },
      {
        "periodo": 202510,
        "valor": 3.1731,
        "delta": 0.026
      },
      {
        "periodo": 202511,
        "valor": 3.1184,
        "delta": -0.0547
      },
      {
        "periodo": 202512,
        "valor": 3.0538,
        "delta": -0.0646
      },
      {
        "periodo": 202601,
        "valor": 3.0467,
        "delta": -0.0071
      },
      {
        "periodo": 202602,
        "valor": 3.2139,
        "delta": 0.1672
      },
      {
        "periodo": 202603,
        "valor": 3.2065,
        "delta": -0.0074
      },
      {
        "periodo": 202604,
        "valor": 3.1959,
        "delta": -0.0106
      },
      {
        "periodo": 202605,
        "valor": 3.2305,
        "delta": 0.0345
      },
      {
        "periodo": 202606,
        "valor": 3.258,
        "delta": 0.0276
      },
      {
        "periodo": 202607,
        "valor": 3.2702,
        "delta": 0.0122
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 3.277224,
    "valor_anterior": 3.2670879999999998,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.1273,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.1223,
        "delta": -0.005
      },
      {
        "periodo": 202509,
        "valor": 3.2266,
        "delta": 0.1043
      },
      {
        "periodo": 202510,
        "valor": 3.2237,
        "delta": -0.0029
      },
      {
        "periodo": 202511,
        "valor": 3.1929,
        "delta": -0.0307
      },
      {
        "periodo": 202512,
        "valor": 3.0534,
        "delta": -0.1396
      },
      {
        "periodo": 202601,
        "valor": 3.0404,
        "delta": -0.013
      },
      {
        "periodo": 202602,
        "valor": 3.1094,
        "delta": 0.0689
      },
      {
        "periodo": 202603,
        "valor": 3.1495,
        "delta": 0.0402
      },
      {
        "periodo": 202604,
        "valor": 3.133,
        "delta": -0.0165
      },
      {
        "periodo": 202605,
        "valor": 3.3753,
        "delta": 0.2422
      },
      {
        "periodo": 202606,
        "valor": 3.2671,
        "delta": -0.1082
      },
      {
        "periodo": 202607,
        "valor": 3.2772,
        "delta": 0.0101
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 3.742794,
    "valor_anterior": 3.6829140000000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.833,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.8386,
        "delta": 0.0056
      },
      {
        "periodo": 202509,
        "valor": 3.8647,
        "delta": 0.0262
      },
      {
        "periodo": 202510,
        "valor": 3.921,
        "delta": 0.0562
      },
      {
        "periodo": 202511,
        "valor": 3.8018,
        "delta": -0.1192
      },
      {
        "periodo": 202512,
        "valor": 3.8097,
        "delta": 0.008
      },
      {
        "periodo": 202601,
        "valor": 3.7559,
        "delta": -0.0538
      },
      {
        "periodo": 202602,
        "valor": 3.7369,
        "delta": -0.019
      },
      {
        "periodo": 202603,
        "valor": 3.742,
        "delta": 0.0051
      },
      {
        "periodo": 202604,
        "valor": 3.6841,
        "delta": -0.0579
      },
      {
        "periodo": 202605,
        "valor": 3.6334,
        "delta": -0.0507
      },
      {
        "periodo": 202606,
        "valor": 3.6829,
        "delta": 0.0495
      },
      {
        "periodo": 202607,
        "valor": 3.7428,
        "delta": 0.0599
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 1.853753,
    "valor_anterior": 1.799407,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.274,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.2134,
        "delta": -0.0606
      },
      {
        "periodo": 202509,
        "valor": 2.2844,
        "delta": 0.071
      },
      {
        "periodo": 202510,
        "valor": 2.241,
        "delta": -0.0434
      },
      {
        "periodo": 202511,
        "valor": 2.0945,
        "delta": -0.1465
      },
      {
        "periodo": 202512,
        "valor": 1.888,
        "delta": -0.2065
      },
      {
        "periodo": 202601,
        "valor": 1.9039,
        "delta": 0.0159
      },
      {
        "periodo": 202602,
        "valor": 1.9444,
        "delta": 0.0405
      },
      {
        "periodo": 202603,
        "valor": 1.8826,
        "delta": -0.0618
      },
      {
        "periodo": 202604,
        "valor": 1.8657,
        "delta": -0.0169
      },
      {
        "periodo": 202605,
        "valor": 1.8424,
        "delta": -0.0233
      },
      {
        "periodo": 202606,
        "valor": 1.7994,
        "delta": -0.043
      },
      {
        "periodo": 202607,
        "valor": 1.8538,
        "delta": 0.0543
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 2.579918,
    "valor_anterior": 2.505208,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.2142,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.2475,
        "delta": 0.0333
      },
      {
        "periodo": 202509,
        "valor": 2.2663,
        "delta": 0.0188
      },
      {
        "periodo": 202510,
        "valor": 2.2975,
        "delta": 0.0312
      },
      {
        "periodo": 202511,
        "valor": 2.2752,
        "delta": -0.0222
      },
      {
        "periodo": 202512,
        "valor": 2.259,
        "delta": -0.0162
      },
      {
        "periodo": 202601,
        "valor": 2.2629,
        "delta": 0.0039
      },
      {
        "periodo": 202602,
        "valor": 2.288,
        "delta": 0.025
      },
      {
        "periodo": 202603,
        "valor": 2.381,
        "delta": 0.093
      },
      {
        "periodo": 202604,
        "valor": 2.4834,
        "delta": 0.1024
      },
      {
        "periodo": 202605,
        "valor": 2.4735,
        "delta": -0.0099
      },
      {
        "periodo": 202606,
        "valor": 2.5052,
        "delta": 0.0317
      },
      {
        "periodo": 202607,
        "valor": 2.5799,
        "delta": 0.0747
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 2.185169,
    "valor_anterior": 2.188876,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.2959,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.2676,
        "delta": -0.0282
      },
      {
        "periodo": 202509,
        "valor": 2.2766,
        "delta": 0.009
      },
      {
        "periodo": 202510,
        "valor": 2.2387,
        "delta": -0.0379
      },
      {
        "periodo": 202511,
        "valor": 2.2658,
        "delta": 0.0271
      },
      {
        "periodo": 202512,
        "valor": 1.9693,
        "delta": -0.2965
      },
      {
        "periodo": 202601,
        "valor": 1.9971,
        "delta": 0.0278
      },
      {
        "periodo": 202602,
        "valor": 2.0218,
        "delta": 0.0247
      },
      {
        "periodo": 202603,
        "valor": 2.0339,
        "delta": 0.0121
      },
      {
        "periodo": 202604,
        "valor": 2.1232,
        "delta": 0.0893
      },
      {
        "periodo": 202605,
        "valor": 2.1775,
        "delta": 0.0543
      },
      {
        "periodo": 202606,
        "valor": 2.1889,
        "delta": 0.0114
      },
      {
        "periodo": 202607,
        "valor": 2.1852,
        "delta": -0.0037
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 2.845983,
    "valor_anterior": 2.917595,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.7816,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.7903,
        "delta": 0.0087
      },
      {
        "periodo": 202509,
        "valor": 2.8589,
        "delta": 0.0686
      },
      {
        "periodo": 202510,
        "valor": 2.8775,
        "delta": 0.0186
      },
      {
        "periodo": 202511,
        "valor": 2.9415,
        "delta": 0.064
      },
      {
        "periodo": 202512,
        "valor": 2.8868,
        "delta": -0.0547
      },
      {
        "periodo": 202601,
        "valor": 2.887,
        "delta": 0.0002
      },
      {
        "periodo": 202602,
        "valor": 2.9181,
        "delta": 0.031
      },
      {
        "periodo": 202603,
        "valor": 2.8745,
        "delta": -0.0435
      },
      {
        "periodo": 202604,
        "valor": 2.9409,
        "delta": 0.0664
      },
      {
        "periodo": 202605,
        "valor": 2.9835,
        "delta": 0.0425
      },
      {
        "periodo": 202606,
        "valor": 2.9176,
        "delta": -0.0659
      },
      {
        "periodo": 202607,
        "valor": 2.846,
        "delta": -0.0716
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 1.826315,
    "valor_anterior": 1.798336,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.145,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.1191,
        "delta": -0.0259
      },
      {
        "periodo": 202509,
        "valor": 2.105,
        "delta": -0.014
      },
      {
        "periodo": 202510,
        "valor": 2.1495,
        "delta": 0.0445
      },
      {
        "periodo": 202511,
        "valor": 2.1617,
        "delta": 0.0122
      },
      {
        "periodo": 202512,
        "valor": 1.9389,
        "delta": -0.2228
      },
      {
        "periodo": 202601,
        "valor": 1.895,
        "delta": -0.044
      },
      {
        "periodo": 202602,
        "valor": 1.7528,
        "delta": -0.1422
      },
      {
        "periodo": 202603,
        "valor": 1.7623,
        "delta": 0.0095
      },
      {
        "periodo": 202604,
        "valor": 1.7435,
        "delta": -0.0188
      },
      {
        "periodo": 202605,
        "valor": 1.7467,
        "delta": 0.0032
      },
      {
        "periodo": 202606,
        "valor": 1.7983,
        "delta": 0.0517
      },
      {
        "periodo": 202607,
        "valor": 1.8263,
        "delta": 0.028
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 6.095661,
    "valor_anterior": 6.0661640000000006,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5.591,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5.6956,
        "delta": 0.1046
      },
      {
        "periodo": 202509,
        "valor": 5.7549,
        "delta": 0.0593
      },
      {
        "periodo": 202510,
        "valor": 5.813,
        "delta": 0.058
      },
      {
        "periodo": 202511,
        "valor": 6.0324,
        "delta": 0.2194
      },
      {
        "periodo": 202512,
        "valor": 6.2697,
        "delta": 0.2373
      },
      {
        "periodo": 202601,
        "valor": 6.3832,
        "delta": 0.1135
      },
      {
        "periodo": 202602,
        "valor": 6.3611,
        "delta": -0.0221
      },
      {
        "periodo": 202603,
        "valor": 5.9922,
        "delta": -0.3689
      },
      {
        "periodo": 202604,
        "valor": 6.0876,
        "delta": 0.0954
      },
      {
        "periodo": 202605,
        "valor": 6.0848,
        "delta": -0.0028
      },
      {
        "periodo": 202606,
        "valor": 6.0662,
        "delta": -0.0186
      },
      {
        "periodo": 202607,
        "valor": 6.0957,
        "delta": 0.0295
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 7.353796,
    "valor_anterior": 7.381188,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6.1633,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6.1378,
        "delta": -0.0255
      },
      {
        "periodo": 202509,
        "valor": 6.3132,
        "delta": 0.1754
      },
      {
        "periodo": 202510,
        "valor": 6.3992,
        "delta": 0.086
      },
      {
        "periodo": 202511,
        "valor": 6.3156,
        "delta": -0.0836
      },
      {
        "periodo": 202512,
        "valor": 6.2775,
        "delta": -0.0381
      },
      {
        "periodo": 202601,
        "valor": 6.4965,
        "delta": 0.219
      },
      {
        "periodo": 202602,
        "valor": 6.6185,
        "delta": 0.122
      },
      {
        "periodo": 202603,
        "valor": 6.9374,
        "delta": 0.3189
      },
      {
        "periodo": 202604,
        "valor": 6.9772,
        "delta": 0.0398
      },
      {
        "periodo": 202605,
        "valor": 7.078,
        "delta": 0.1008
      },
      {
        "periodo": 202606,
        "valor": 7.3812,
        "delta": 0.3032
      },
      {
        "periodo": 202607,
        "valor": 7.3538,
        "delta": -0.0274
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 3.6738109999999997,
    "valor_anterior": 3.483845,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.4254,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.3461,
        "delta": -0.0793
      },
      {
        "periodo": 202509,
        "valor": 3.3708,
        "delta": 0.0247
      },
      {
        "periodo": 202510,
        "valor": 3.3222,
        "delta": -0.0486
      },
      {
        "periodo": 202511,
        "valor": 3.31,
        "delta": -0.0121
      },
      {
        "periodo": 202512,
        "valor": 3.18,
        "delta": -0.1301
      },
      {
        "periodo": 202601,
        "valor": 3.1409,
        "delta": -0.039
      },
      {
        "periodo": 202602,
        "valor": 3.1658,
        "delta": 0.0249
      },
      {
        "periodo": 202603,
        "valor": 3.2565,
        "delta": 0.0906
      },
      {
        "periodo": 202604,
        "valor": 3.2312,
        "delta": -0.0252
      },
      {
        "periodo": 202605,
        "valor": 3.3773,
        "delta": 0.1461
      },
      {
        "periodo": 202606,
        "valor": 3.4838,
        "delta": 0.1065
      },
      {
        "periodo": 202607,
        "valor": 3.6738,
        "delta": 0.19
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 2.032858,
    "valor_anterior": 2.03863,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.6807,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.692,
        "delta": 0.0113
      },
      {
        "periodo": 202509,
        "valor": 1.8505,
        "delta": 0.1585
      },
      {
        "periodo": 202510,
        "valor": 1.8424,
        "delta": -0.0082
      },
      {
        "periodo": 202511,
        "valor": 1.8439,
        "delta": 0.0016
      },
      {
        "periodo": 202512,
        "valor": 1.8847,
        "delta": 0.0408
      },
      {
        "periodo": 202601,
        "valor": 1.9756,
        "delta": 0.0909
      },
      {
        "periodo": 202602,
        "valor": 1.9945,
        "delta": 0.019
      },
      {
        "periodo": 202603,
        "valor": 2.0142,
        "delta": 0.0196
      },
      {
        "periodo": 202604,
        "valor": 2.0236,
        "delta": 0.0095
      },
      {
        "periodo": 202605,
        "valor": 2.0491,
        "delta": 0.0254
      },
      {
        "periodo": 202606,
        "valor": 2.0386,
        "delta": -0.0104
      },
      {
        "periodo": 202607,
        "valor": 2.0329,
        "delta": -0.0058
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 0.76078,
    "valor_anterior": 0.7996420000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.0426,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.9887,
        "delta": -0.0539
      },
      {
        "periodo": 202509,
        "valor": 1.1722,
        "delta": 0.1834
      },
      {
        "periodo": 202510,
        "valor": 1.0392,
        "delta": -0.133
      },
      {
        "periodo": 202511,
        "valor": 0.9851,
        "delta": -0.054
      },
      {
        "periodo": 202512,
        "valor": 0.9868,
        "delta": 0.0017
      },
      {
        "periodo": 202601,
        "valor": 0.9723,
        "delta": -0.0146
      },
      {
        "periodo": 202602,
        "valor": 0.9832,
        "delta": 0.0109
      },
      {
        "periodo": 202603,
        "valor": 0.9195,
        "delta": -0.0637
      },
      {
        "periodo": 202604,
        "valor": 0.8642,
        "delta": -0.0553
      },
      {
        "periodo": 202605,
        "valor": 0.7955,
        "delta": -0.0687
      },
      {
        "periodo": 202606,
        "valor": 0.7996,
        "delta": 0.0042
      },
      {
        "periodo": 202607,
        "valor": 0.7608,
        "delta": -0.0389
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 0.764302,
    "valor_anterior": 0.811228,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.7827,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.7741,
        "delta": -0.0085
      },
      {
        "periodo": 202509,
        "valor": 0.855,
        "delta": 0.0809
      },
      {
        "periodo": 202510,
        "valor": 0.7704,
        "delta": -0.0847
      },
      {
        "periodo": 202511,
        "valor": 0.7634,
        "delta": -0.007
      },
      {
        "periodo": 202512,
        "valor": 0.665,
        "delta": -0.0984
      },
      {
        "periodo": 202601,
        "valor": 0.6921,
        "delta": 0.0271
      },
      {
        "periodo": 202602,
        "valor": 0.8774,
        "delta": 0.1853
      },
      {
        "periodo": 202603,
        "valor": 0.8387,
        "delta": -0.0387
      },
      {
        "periodo": 202604,
        "valor": 0.8013,
        "delta": -0.0374
      },
      {
        "periodo": 202605,
        "valor": 0.5851,
        "delta": -0.2161
      },
      {
        "periodo": 202606,
        "valor": 0.8112,
        "delta": 0.2261
      },
      {
        "periodo": 202607,
        "valor": 0.7643,
        "delta": -0.0469
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 0.72928,
    "valor_anterior": 0.734217,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.6199,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.6421,
        "delta": 0.0221
      },
      {
        "periodo": 202509,
        "valor": 0.6179,
        "delta": -0.0241
      },
      {
        "periodo": 202510,
        "valor": 0.671,
        "delta": 0.0531
      },
      {
        "periodo": 202511,
        "valor": 0.6679,
        "delta": -0.0031
      },
      {
        "periodo": 202512,
        "valor": 0.7852,
        "delta": 0.1173
      },
      {
        "periodo": 202601,
        "valor": 0.7913,
        "delta": 0.006
      },
      {
        "periodo": 202602,
        "valor": 0.7727,
        "delta": -0.0186
      },
      {
        "periodo": 202603,
        "valor": 0.7139,
        "delta": -0.0587
      },
      {
        "periodo": 202604,
        "valor": 0.7085,
        "delta": -0.0054
      },
      {
        "periodo": 202605,
        "valor": 0.7109,
        "delta": 0.0024
      },
      {
        "periodo": 202606,
        "valor": 0.7342,
        "delta": 0.0233
      },
      {
        "periodo": 202607,
        "valor": 0.7293,
        "delta": -0.0049
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 1.326512,
    "valor_anterior": 1.2683470000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.9054,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.8974,
        "delta": -0.008
      },
      {
        "periodo": 202509,
        "valor": 1.9101,
        "delta": 0.0127
      },
      {
        "periodo": 202510,
        "valor": 1.7886,
        "delta": -0.1216
      },
      {
        "periodo": 202511,
        "valor": 1.7076,
        "delta": -0.0809
      },
      {
        "periodo": 202512,
        "valor": 1.1801,
        "delta": -0.5275
      },
      {
        "periodo": 202601,
        "valor": 1.1709,
        "delta": -0.0091
      },
      {
        "periodo": 202602,
        "valor": 1.2014,
        "delta": 0.0305
      },
      {
        "periodo": 202603,
        "valor": 1.2057,
        "delta": 0.0043
      },
      {
        "periodo": 202604,
        "valor": 1.2352,
        "delta": 0.0295
      },
      {
        "periodo": 202605,
        "valor": 1.2673,
        "delta": 0.0321
      },
      {
        "periodo": 202606,
        "valor": 1.2683,
        "delta": 0.001
      },
      {
        "periodo": 202607,
        "valor": 1.3265,
        "delta": 0.0582
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 2.757863,
    "valor_anterior": 2.7662780000000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.0955,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.2186,
        "delta": 0.123
      },
      {
        "periodo": 202509,
        "valor": 3.1788,
        "delta": -0.0398
      },
      {
        "periodo": 202510,
        "valor": 3.1069,
        "delta": -0.0719
      },
      {
        "periodo": 202511,
        "valor": 3.0666,
        "delta": -0.0403
      },
      {
        "periodo": 202512,
        "valor": 3.0124,
        "delta": -0.0542
      },
      {
        "periodo": 202601,
        "valor": 3.0467,
        "delta": 0.0344
      },
      {
        "periodo": 202602,
        "valor": 3.1856,
        "delta": 0.1388
      },
      {
        "periodo": 202603,
        "valor": 3.0838,
        "delta": -0.1018
      },
      {
        "periodo": 202604,
        "valor": 2.9329,
        "delta": -0.1509
      },
      {
        "periodo": 202605,
        "valor": 2.888,
        "delta": -0.0449
      },
      {
        "periodo": 202606,
        "valor": 2.7663,
        "delta": -0.1217
      },
      {
        "periodo": 202607,
        "valor": 2.7579,
        "delta": -0.0084
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 2.419129,
    "valor_anterior": 2.516743,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.5613,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.623,
        "delta": 0.0616
      },
      {
        "periodo": 202509,
        "valor": 2.6439,
        "delta": 0.021
      },
      {
        "periodo": 202510,
        "valor": 2.7154,
        "delta": 0.0715
      },
      {
        "periodo": 202511,
        "valor": 2.7255,
        "delta": 0.0101
      },
      {
        "periodo": 202512,
        "valor": 2.6501,
        "delta": -0.0754
      },
      {
        "periodo": 202601,
        "valor": 2.5156,
        "delta": -0.1345
      },
      {
        "periodo": 202602,
        "valor": 2.6948,
        "delta": 0.1792
      },
      {
        "periodo": 202603,
        "valor": 2.4007,
        "delta": -0.2941
      },
      {
        "periodo": 202604,
        "valor": 2.5423,
        "delta": 0.1417
      },
      {
        "periodo": 202605,
        "valor": 2.5474,
        "delta": 0.0051
      },
      {
        "periodo": 202606,
        "valor": 2.5167,
        "delta": -0.0306
      },
      {
        "periodo": 202607,
        "valor": 2.4191,
        "delta": -0.0976
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 11.822376,
    "valor_anterior": 11.764745,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11.5906,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.894,
        "delta": 0.3034
      },
      {
        "periodo": 202509,
        "valor": 12.3824,
        "delta": 0.4884
      },
      {
        "periodo": 202510,
        "valor": 12.5265,
        "delta": 0.1441
      },
      {
        "periodo": 202511,
        "valor": 12.358,
        "delta": -0.1685
      },
      {
        "periodo": 202512,
        "valor": 12.3981,
        "delta": 0.04
      },
      {
        "periodo": 202601,
        "valor": 12.4404,
        "delta": 0.0423
      },
      {
        "periodo": 202602,
        "valor": 12.379,
        "delta": -0.0614
      },
      {
        "periodo": 202603,
        "valor": 11.9999,
        "delta": -0.3791
      },
      {
        "periodo": 202604,
        "valor": 11.6174,
        "delta": -0.3825
      },
      {
        "periodo": 202605,
        "valor": 11.9036,
        "delta": 0.2862
      },
      {
        "periodo": 202606,
        "valor": 11.7647,
        "delta": -0.1389
      },
      {
        "periodo": 202607,
        "valor": 11.8224,
        "delta": 0.0576
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 3.3549700000000002,
    "valor_anterior": 3.178541,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4.2416,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4.1747,
        "delta": -0.0669
      },
      {
        "periodo": 202509,
        "valor": 2.5952,
        "delta": -1.5795
      },
      {
        "periodo": 202510,
        "valor": 2.7052,
        "delta": 0.11
      },
      {
        "periodo": 202511,
        "valor": 2.7012,
        "delta": -0.004
      },
      {
        "periodo": 202512,
        "valor": 2.8139,
        "delta": 0.1127
      },
      {
        "periodo": 202601,
        "valor": 2.928,
        "delta": 0.1141
      },
      {
        "periodo": 202602,
        "valor": 3.0379,
        "delta": 0.1099
      },
      {
        "periodo": 202603,
        "valor": 3.0466,
        "delta": 0.0087
      },
      {
        "periodo": 202604,
        "valor": 3.3491,
        "delta": 0.3025
      },
      {
        "periodo": 202605,
        "valor": 3.5344,
        "delta": 0.1853
      },
      {
        "periodo": 202606,
        "valor": 3.1785,
        "delta": -0.3559
      },
      {
        "periodo": 202607,
        "valor": 3.355,
        "delta": 0.1764
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 9.385991,
    "valor_anterior": 9.342478999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7.4678,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7.7286,
        "delta": 0.2608
      },
      {
        "periodo": 202509,
        "valor": 8.297,
        "delta": 0.5684
      },
      {
        "periodo": 202510,
        "valor": 8.4597,
        "delta": 0.1627
      },
      {
        "periodo": 202511,
        "valor": 8.3338,
        "delta": -0.1259
      },
      {
        "periodo": 202512,
        "valor": 8.8735,
        "delta": 0.5397
      },
      {
        "periodo": 202601,
        "valor": 9.1895,
        "delta": 0.3159
      },
      {
        "periodo": 202602,
        "valor": 9.2171,
        "delta": 0.0276
      },
      {
        "periodo": 202603,
        "valor": 9.1042,
        "delta": -0.1129
      },
      {
        "periodo": 202604,
        "valor": 9.3647,
        "delta": 0.2605
      },
      {
        "periodo": 202605,
        "valor": 9.5516,
        "delta": 0.1869
      },
      {
        "periodo": 202606,
        "valor": 9.3425,
        "delta": -0.2091
      },
      {
        "periodo": 202607,
        "valor": 9.386,
        "delta": 0.0435
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 2.486052,
    "valor_anterior": 2.509897,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.9455,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.9375,
        "delta": -0.008
      },
      {
        "periodo": 202509,
        "valor": 2.9574,
        "delta": 0.0199
      },
      {
        "periodo": 202510,
        "valor": 2.9715,
        "delta": 0.0141
      },
      {
        "periodo": 202511,
        "valor": 2.878,
        "delta": -0.0936
      },
      {
        "periodo": 202512,
        "valor": 2.6239,
        "delta": -0.2541
      },
      {
        "periodo": 202601,
        "valor": 2.6797,
        "delta": 0.0559
      },
      {
        "periodo": 202602,
        "valor": 2.61,
        "delta": -0.0697
      },
      {
        "periodo": 202603,
        "valor": 2.5621,
        "delta": -0.0479
      },
      {
        "periodo": 202604,
        "valor": 2.6753,
        "delta": 0.1132
      },
      {
        "periodo": 202605,
        "valor": 2.5777,
        "delta": -0.0976
      },
      {
        "periodo": 202606,
        "valor": 2.5099,
        "delta": -0.0678
      },
      {
        "periodo": 202607,
        "valor": 2.4861,
        "delta": -0.0238
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 2.564597,
    "valor_anterior": 2.5375,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.5837,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.4788,
        "delta": -0.1048
      },
      {
        "periodo": 202509,
        "valor": 3.3745,
        "delta": -0.1043
      },
      {
        "periodo": 202510,
        "valor": 3.4407,
        "delta": 0.0662
      },
      {
        "periodo": 202511,
        "valor": 3.0501,
        "delta": -0.3906
      },
      {
        "periodo": 202512,
        "valor": 3.0549,
        "delta": 0.0048
      },
      {
        "periodo": 202601,
        "valor": 3.1964,
        "delta": 0.1416
      },
      {
        "periodo": 202602,
        "valor": 3.0661,
        "delta": -0.1304
      },
      {
        "periodo": 202603,
        "valor": 3.0486,
        "delta": -0.0175
      },
      {
        "periodo": 202604,
        "valor": 2.9765,
        "delta": -0.0721
      },
      {
        "periodo": 202605,
        "valor": 2.371,
        "delta": -0.6055
      },
      {
        "periodo": 202606,
        "valor": 2.5375,
        "delta": 0.1665
      },
      {
        "periodo": 202607,
        "valor": 2.5646,
        "delta": 0.0271
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 100.0,
    "valor_anterior": 100.0,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7.0441,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10.136,
        "delta": 3.0919
      },
      {
        "periodo": 202509,
        "valor": 73.4475,
        "delta": 63.3115
      },
      {
        "periodo": 202510,
        "valor": 78.7442,
        "delta": 5.2967
      },
      {
        "periodo": 202511,
        "valor": 100.0,
        "delta": 21.2558
      },
      {
        "periodo": 202512,
        "valor": 100.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 100.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 100.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 100.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 100.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 100.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 100.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 100.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 8.346070999999998,
    "valor_anterior": 8.489512000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8.7958,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.1219,
        "delta": -0.6739
      },
      {
        "periodo": 202509,
        "valor": 8.2656,
        "delta": 0.1437
      },
      {
        "periodo": 202510,
        "valor": 7.4969,
        "delta": -0.7687
      },
      {
        "periodo": 202511,
        "valor": 7.7623,
        "delta": 0.2654
      },
      {
        "periodo": 202512,
        "valor": 7.5617,
        "delta": -0.2006
      },
      {
        "periodo": 202601,
        "valor": 8.4358,
        "delta": 0.8741
      },
      {
        "periodo": 202602,
        "valor": 8.5095,
        "delta": 0.0737
      },
      {
        "periodo": 202603,
        "valor": 8.5836,
        "delta": 0.0741
      },
      {
        "periodo": 202604,
        "valor": 8.9736,
        "delta": 0.3901
      },
      {
        "periodo": 202605,
        "valor": 8.8725,
        "delta": -0.1012
      },
      {
        "periodo": 202606,
        "valor": 8.4895,
        "delta": -0.383
      },
      {
        "periodo": 202607,
        "valor": 8.3461,
        "delta": -0.1434
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 17.327194000000002,
    "valor_anterior": 16.389095,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19.9109,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 20.1653,
        "delta": 0.2544
      },
      {
        "periodo": 202509,
        "valor": 21.2133,
        "delta": 1.048
      },
      {
        "periodo": 202510,
        "valor": 21.5164,
        "delta": 0.3031
      },
      {
        "periodo": 202511,
        "valor": 20.7349,
        "delta": -0.7815
      },
      {
        "periodo": 202512,
        "valor": 21.0177,
        "delta": 0.2828
      },
      {
        "periodo": 202601,
        "valor": 20.0622,
        "delta": -0.9555
      },
      {
        "periodo": 202602,
        "valor": 19.8684,
        "delta": -0.1938
      },
      {
        "periodo": 202603,
        "valor": 17.9515,
        "delta": -1.9169
      },
      {
        "periodo": 202604,
        "valor": 17.1698,
        "delta": -0.7817
      },
      {
        "periodo": 202605,
        "valor": 15.6322,
        "delta": -1.5376
      },
      {
        "periodo": 202606,
        "valor": 16.3891,
        "delta": 0.7569
      },
      {
        "periodo": 202607,
        "valor": 17.3272,
        "delta": 0.9381
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 0.501065,
    "valor_anterior": 0.5033110000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.4417,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.5662,
        "delta": 0.1245
      },
      {
        "periodo": 202509,
        "valor": 0.5841,
        "delta": 0.0179
      },
      {
        "periodo": 202510,
        "valor": 0.5794,
        "delta": -0.0047
      },
      {
        "periodo": 202511,
        "valor": 0.5565,
        "delta": -0.0229
      },
      {
        "periodo": 202512,
        "valor": 0.5592,
        "delta": 0.0027
      },
      {
        "periodo": 202601,
        "valor": 0.5592,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.5592,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.5527,
        "delta": -0.0065
      },
      {
        "periodo": 202604,
        "valor": 0.5527,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.5128,
        "delta": -0.0399
      },
      {
        "periodo": 202606,
        "valor": 0.5033,
        "delta": -0.0095
      },
      {
        "periodo": 202607,
        "valor": 0.5011,
        "delta": -0.0022
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 3.5559849999999997,
    "valor_anterior": 3.3835749999999996,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.6249,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.5188,
        "delta": -0.1062
      },
      {
        "periodo": 202509,
        "valor": 3.4906,
        "delta": -0.0282
      },
      {
        "periodo": 202510,
        "valor": 3.5166,
        "delta": 0.0261
      },
      {
        "periodo": 202511,
        "valor": 3.5501,
        "delta": 0.0335
      },
      {
        "periodo": 202512,
        "valor": 3.5521,
        "delta": 0.0019
      },
      {
        "periodo": 202601,
        "valor": 3.5137,
        "delta": -0.0384
      },
      {
        "periodo": 202602,
        "valor": 3.5202,
        "delta": 0.0065
      },
      {
        "periodo": 202603,
        "valor": 3.3779,
        "delta": -0.1423
      },
      {
        "periodo": 202604,
        "valor": 3.4438,
        "delta": 0.0659
      },
      {
        "periodo": 202605,
        "valor": 3.3659,
        "delta": -0.078
      },
      {
        "periodo": 202606,
        "valor": 3.3836,
        "delta": 0.0177
      },
      {
        "periodo": 202607,
        "valor": 3.556,
        "delta": 0.1724
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 2.9803409999999997,
    "valor_anterior": 2.845031,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.2591,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.7918,
        "delta": 0.5328
      },
      {
        "periodo": 202509,
        "valor": 2.2907,
        "delta": -0.5011
      },
      {
        "periodo": 202510,
        "valor": 2.424,
        "delta": 0.1333
      },
      {
        "periodo": 202511,
        "valor": 2.8607,
        "delta": 0.4367
      },
      {
        "periodo": 202512,
        "valor": 2.6507,
        "delta": -0.21
      },
      {
        "periodo": 202601,
        "valor": 3.0435,
        "delta": 0.3928
      },
      {
        "periodo": 202602,
        "valor": 2.9257,
        "delta": -0.1178
      },
      {
        "periodo": 202603,
        "valor": 2.8817,
        "delta": -0.044
      },
      {
        "periodo": 202604,
        "valor": 2.9917,
        "delta": 0.11
      },
      {
        "periodo": 202605,
        "valor": 3.5224,
        "delta": 0.5307
      },
      {
        "periodo": 202606,
        "valor": 2.845,
        "delta": -0.6774
      },
      {
        "periodo": 202607,
        "valor": 2.9803,
        "delta": 0.1353
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.3948,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5.2461,
        "delta": 1.8513
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 3.2425589999999995,
    "valor_anterior": 3.21244,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.2734,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.3869,
        "delta": 0.1135
      },
      {
        "periodo": 202509,
        "valor": 3.3311,
        "delta": -0.0557
      },
      {
        "periodo": 202510,
        "valor": 3.4605,
        "delta": 0.1294
      },
      {
        "periodo": 202511,
        "valor": 3.3962,
        "delta": -0.0644
      },
      {
        "periodo": 202512,
        "valor": 3.4693,
        "delta": 0.0731
      },
      {
        "periodo": 202601,
        "valor": 3.3898,
        "delta": -0.0795
      },
      {
        "periodo": 202602,
        "valor": 3.391,
        "delta": 0.0012
      },
      {
        "periodo": 202603,
        "valor": 3.61,
        "delta": 0.219
      },
      {
        "periodo": 202604,
        "valor": 3.0251,
        "delta": -0.5849
      },
      {
        "periodo": 202605,
        "valor": 3.2242,
        "delta": 0.1991
      },
      {
        "periodo": 202606,
        "valor": 3.2124,
        "delta": -0.0118
      },
      {
        "periodo": 202607,
        "valor": 3.2426,
        "delta": 0.0301
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 1.488734,
    "valor_anterior": 1.430999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.8419,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.8343,
        "delta": -0.0075
      },
      {
        "periodo": 202509,
        "valor": 1.5817,
        "delta": -0.2527
      },
      {
        "periodo": 202510,
        "valor": 1.5535,
        "delta": -0.0281
      },
      {
        "periodo": 202511,
        "valor": 1.5669,
        "delta": 0.0133
      },
      {
        "periodo": 202512,
        "valor": 1.5971,
        "delta": 0.0302
      },
      {
        "periodo": 202601,
        "valor": 1.5051,
        "delta": -0.092
      },
      {
        "periodo": 202602,
        "valor": 1.5361,
        "delta": 0.031
      },
      {
        "periodo": 202603,
        "valor": 1.5523,
        "delta": 0.0162
      },
      {
        "periodo": 202604,
        "valor": 1.5107,
        "delta": -0.0416
      },
      {
        "periodo": 202605,
        "valor": 1.4996,
        "delta": -0.0111
      },
      {
        "periodo": 202606,
        "valor": 1.431,
        "delta": -0.0686
      },
      {
        "periodo": 202607,
        "valor": 1.4887,
        "delta": 0.0577
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 16.095219999999998,
    "valor_anterior": 15.563550000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.1838,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.3861,
        "delta": -0.7977
      },
      {
        "periodo": 202509,
        "valor": 11.334,
        "delta": -0.0521
      },
      {
        "periodo": 202510,
        "valor": 12.0392,
        "delta": 0.7053
      },
      {
        "periodo": 202511,
        "valor": 12.6063,
        "delta": 0.567
      },
      {
        "periodo": 202512,
        "valor": 11.9695,
        "delta": -0.6368
      },
      {
        "periodo": 202601,
        "valor": 12.5245,
        "delta": 0.555
      },
      {
        "periodo": 202602,
        "valor": 13.314,
        "delta": 0.7895
      },
      {
        "periodo": 202603,
        "valor": 13.1643,
        "delta": -0.1497
      },
      {
        "periodo": 202604,
        "valor": 14.3205,
        "delta": 1.1562
      },
      {
        "periodo": 202605,
        "valor": 15.1569,
        "delta": 0.8364
      },
      {
        "periodo": 202606,
        "valor": 15.5636,
        "delta": 0.4066
      },
      {
        "periodo": 202607,
        "valor": 16.0952,
        "delta": 0.5317
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 1.6271250000000002,
    "valor_anterior": 1.730305,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.8913,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.8212,
        "delta": -0.0701
      },
      {
        "periodo": 202509,
        "valor": 1.7687,
        "delta": -0.0525
      },
      {
        "periodo": 202510,
        "valor": 1.8035,
        "delta": 0.0348
      },
      {
        "periodo": 202511,
        "valor": 1.7824,
        "delta": -0.0211
      },
      {
        "periodo": 202512,
        "valor": 1.6008,
        "delta": -0.1816
      },
      {
        "periodo": 202601,
        "valor": 1.5943,
        "delta": -0.0065
      },
      {
        "periodo": 202602,
        "valor": 1.6522,
        "delta": 0.0579
      },
      {
        "periodo": 202603,
        "valor": 1.6303,
        "delta": -0.0218
      },
      {
        "periodo": 202604,
        "valor": 1.6758,
        "delta": 0.0454
      },
      {
        "periodo": 202605,
        "valor": 1.6759,
        "delta": 0.0001
      },
      {
        "periodo": 202606,
        "valor": 1.7303,
        "delta": 0.0544
      },
      {
        "periodo": 202607,
        "valor": 1.6271,
        "delta": -0.1032
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 0.7100409999999999,
    "valor_anterior": 0.71882,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.7681,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.7655,
        "delta": -0.0026
      },
      {
        "periodo": 202509,
        "valor": 0.7561,
        "delta": -0.0095
      },
      {
        "periodo": 202510,
        "valor": 0.6221,
        "delta": -0.134
      },
      {
        "periodo": 202511,
        "valor": 0.6279,
        "delta": 0.0057
      },
      {
        "periodo": 202512,
        "valor": 0.6153,
        "delta": -0.0126
      },
      {
        "periodo": 202601,
        "valor": 0.6411,
        "delta": 0.0258
      },
      {
        "periodo": 202602,
        "valor": 0.6554,
        "delta": 0.0143
      },
      {
        "periodo": 202603,
        "valor": 0.6516,
        "delta": -0.0038
      },
      {
        "periodo": 202604,
        "valor": 0.6602,
        "delta": 0.0086
      },
      {
        "periodo": 202605,
        "valor": 0.6779,
        "delta": 0.0177
      },
      {
        "periodo": 202606,
        "valor": 0.7188,
        "delta": 0.041
      },
      {
        "periodo": 202607,
        "valor": 0.71,
        "delta": -0.0088
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 2.117904,
    "valor_anterior": 2.1133260000000003,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.5461,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.5453,
        "delta": -0.0008
      },
      {
        "periodo": 202509,
        "valor": 1.8694,
        "delta": 0.3241
      },
      {
        "periodo": 202510,
        "valor": 1.7572,
        "delta": -0.1122
      },
      {
        "periodo": 202511,
        "valor": 1.7284,
        "delta": -0.0288
      },
      {
        "periodo": 202512,
        "valor": 1.7501,
        "delta": 0.0217
      },
      {
        "periodo": 202601,
        "valor": 1.7441,
        "delta": -0.006
      },
      {
        "periodo": 202602,
        "valor": 1.7458,
        "delta": 0.0016
      },
      {
        "periodo": 202603,
        "valor": 1.9574,
        "delta": 0.2116
      },
      {
        "periodo": 202604,
        "valor": 1.9517,
        "delta": -0.0057
      },
      {
        "periodo": 202605,
        "valor": 1.9418,
        "delta": -0.0099
      },
      {
        "periodo": 202606,
        "valor": 2.1133,
        "delta": 0.1716
      },
      {
        "periodo": 202607,
        "valor": 2.1179,
        "delta": 0.0046
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 3.525624,
    "valor_anterior": 3.688666,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.5491,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.5742,
        "delta": 0.0251
      },
      {
        "periodo": 202509,
        "valor": 3.7109,
        "delta": 0.1367
      },
      {
        "periodo": 202510,
        "valor": 3.7224,
        "delta": 0.0116
      },
      {
        "periodo": 202511,
        "valor": 3.7871,
        "delta": 0.0646
      },
      {
        "periodo": 202512,
        "valor": 3.9334,
        "delta": 0.1463
      },
      {
        "periodo": 202601,
        "valor": 3.9543,
        "delta": 0.0209
      },
      {
        "periodo": 202602,
        "valor": 3.821,
        "delta": -0.1333
      },
      {
        "periodo": 202603,
        "valor": 3.8541,
        "delta": 0.0331
      },
      {
        "periodo": 202604,
        "valor": 3.8763,
        "delta": 0.0222
      },
      {
        "periodo": 202605,
        "valor": 3.9424,
        "delta": 0.066
      },
      {
        "periodo": 202606,
        "valor": 3.6887,
        "delta": -0.2537
      },
      {
        "periodo": 202607,
        "valor": 3.5256,
        "delta": -0.163
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 3.5255509999999997,
    "valor_anterior": 2.722801,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.9622,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.94,
        "delta": -0.0222
      },
      {
        "periodo": 202509,
        "valor": 1.764,
        "delta": -0.176
      },
      {
        "periodo": 202510,
        "valor": 1.6697,
        "delta": -0.0943
      },
      {
        "periodo": 202511,
        "valor": 1.9081,
        "delta": 0.2384
      },
      {
        "periodo": 202512,
        "valor": 1.9556,
        "delta": 0.0476
      },
      {
        "periodo": 202601,
        "valor": 1.951,
        "delta": -0.0046
      },
      {
        "periodo": 202602,
        "valor": 0.7961,
        "delta": -1.1549
      },
      {
        "periodo": 202603,
        "valor": 1.7903,
        "delta": 0.9942
      },
      {
        "periodo": 202604,
        "valor": 3.0091,
        "delta": 1.2188
      },
      {
        "periodo": 202605,
        "valor": 2.901,
        "delta": -0.1081
      },
      {
        "periodo": 202606,
        "valor": 2.7228,
        "delta": -0.1782
      },
      {
        "periodo": 202607,
        "valor": 3.5256,
        "delta": 0.8027
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 1.387862,
    "valor_anterior": 1.387772,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.4875,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1.4055,
        "delta": -0.082
      },
      {
        "periodo": 202509,
        "valor": 1.3107,
        "delta": -0.0948
      },
      {
        "periodo": 202510,
        "valor": 1.2926,
        "delta": -0.0181
      },
      {
        "periodo": 202511,
        "valor": 1.2797,
        "delta": -0.0129
      },
      {
        "periodo": 202512,
        "valor": 1.3998,
        "delta": 0.1201
      },
      {
        "periodo": 202601,
        "valor": 1.3758,
        "delta": -0.024
      },
      {
        "periodo": 202602,
        "valor": 1.3669,
        "delta": -0.0089
      },
      {
        "periodo": 202603,
        "valor": 1.3838,
        "delta": 0.0169
      },
      {
        "periodo": 202604,
        "valor": 1.4107,
        "delta": 0.0268
      },
      {
        "periodo": 202605,
        "valor": 1.4145,
        "delta": 0.0038
      },
      {
        "periodo": 202606,
        "valor": 1.3878,
        "delta": -0.0267
      },
      {
        "periodo": 202607,
        "valor": 1.3879,
        "delta": 0.0001
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 0.590042,
    "valor_anterior": 0.9450069999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.0105,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.9222,
        "delta": -0.0883
      },
      {
        "periodo": 202509,
        "valor": 0.9304,
        "delta": 0.0082
      },
      {
        "periodo": 202510,
        "valor": 0.9824,
        "delta": 0.052
      },
      {
        "periodo": 202511,
        "valor": 0.9803,
        "delta": -0.0021
      },
      {
        "periodo": 202512,
        "valor": 0.9927,
        "delta": 0.0124
      },
      {
        "periodo": 202601,
        "valor": 1.0005,
        "delta": 0.0078
      },
      {
        "periodo": 202602,
        "valor": 1.005,
        "delta": 0.0044
      },
      {
        "periodo": 202603,
        "valor": 1.0046,
        "delta": -0.0003
      },
      {
        "periodo": 202604,
        "valor": 0.9034,
        "delta": -0.1013
      },
      {
        "periodo": 202605,
        "valor": 0.921,
        "delta": 0.0176
      },
      {
        "periodo": 202606,
        "valor": 0.945,
        "delta": 0.024
      },
      {
        "periodo": 202607,
        "valor": 0.59,
        "delta": -0.355
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 0.445129,
    "valor_anterior": 0.43013,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.4659,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.4636,
        "delta": -0.0023
      },
      {
        "periodo": 202509,
        "valor": 0.465,
        "delta": 0.0014
      },
      {
        "periodo": 202510,
        "valor": 0.4738,
        "delta": 0.0088
      },
      {
        "periodo": 202511,
        "valor": 0.426,
        "delta": -0.0478
      },
      {
        "periodo": 202512,
        "valor": 0.4235,
        "delta": -0.0025
      },
      {
        "periodo": 202601,
        "valor": 0.4287,
        "delta": 0.0052
      },
      {
        "periodo": 202602,
        "valor": 0.4186,
        "delta": -0.0102
      },
      {
        "periodo": 202603,
        "valor": 0.4292,
        "delta": 0.0106
      },
      {
        "periodo": 202604,
        "valor": 0.4439,
        "delta": 0.0148
      },
      {
        "periodo": 202605,
        "valor": 0.4409,
        "delta": -0.003
      },
      {
        "periodo": 202606,
        "valor": 0.4301,
        "delta": -0.0108
      },
      {
        "periodo": 202607,
        "valor": 0.4451,
        "delta": 0.015
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 1.689712,
    "valor_anterior": 1.781656,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.7499,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4.615,
        "delta": 0.8652
      },
      {
        "periodo": 202509,
        "valor": 4.6324,
        "delta": 0.0173
      },
      {
        "periodo": 202510,
        "valor": 2.545,
        "delta": -2.0873
      },
      {
        "periodo": 202511,
        "valor": 2.6702,
        "delta": 0.1252
      },
      {
        "periodo": 202512,
        "valor": 2.7,
        "delta": 0.0298
      },
      {
        "periodo": 202601,
        "valor": 2.5917,
        "delta": -0.1083
      },
      {
        "periodo": 202602,
        "valor": 2.4051,
        "delta": -0.1866
      },
      {
        "periodo": 202603,
        "valor": 2.0637,
        "delta": -0.3414
      },
      {
        "periodo": 202604,
        "valor": 1.9024,
        "delta": -0.1612
      },
      {
        "periodo": 202605,
        "valor": 1.8813,
        "delta": -0.0211
      },
      {
        "periodo": 202606,
        "valor": 1.7817,
        "delta": -0.0997
      },
      {
        "periodo": 202607,
        "valor": 1.6897,
        "delta": -0.0919
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 0.8077489999999999,
    "valor_anterior": 0.8487089999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.0596,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.8565,
        "delta": -0.2031
      },
      {
        "periodo": 202509,
        "valor": 0.4603,
        "delta": -0.3962
      },
      {
        "periodo": 202510,
        "valor": 1.2786,
        "delta": 0.8183
      },
      {
        "periodo": 202511,
        "valor": 0.8087,
        "delta": -0.4699
      },
      {
        "periodo": 202512,
        "valor": 0.845,
        "delta": 0.0363
      },
      {
        "periodo": 202601,
        "valor": 0.8552,
        "delta": 0.0102
      },
      {
        "periodo": 202602,
        "valor": 0.8017,
        "delta": -0.0534
      },
      {
        "periodo": 202603,
        "valor": 0.3199,
        "delta": -0.4818
      },
      {
        "periodo": 202604,
        "valor": 0.4809,
        "delta": 0.1609
      },
      {
        "periodo": 202605,
        "valor": 0.8027,
        "delta": 0.3218
      },
      {
        "periodo": 202606,
        "valor": 0.8487,
        "delta": 0.046
      },
      {
        "periodo": 202607,
        "valor": 0.8077,
        "delta": -0.041
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 2.13087,
    "valor_anterior": 2.128586,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1.9083,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.0396,
        "delta": 0.1313
      },
      {
        "periodo": 202509,
        "valor": 2.0885,
        "delta": 0.0489
      },
      {
        "periodo": 202510,
        "valor": 2.0659,
        "delta": -0.0225
      },
      {
        "periodo": 202511,
        "valor": 2.1007,
        "delta": 0.0348
      },
      {
        "periodo": 202512,
        "valor": 2.1451,
        "delta": 0.0444
      },
      {
        "periodo": 202601,
        "valor": 2.2185,
        "delta": 0.0734
      },
      {
        "periodo": 202602,
        "valor": 2.2502,
        "delta": 0.0317
      },
      {
        "periodo": 202603,
        "valor": 2.2172,
        "delta": -0.033
      },
      {
        "periodo": 202604,
        "valor": 2.2717,
        "delta": 0.0545
      },
      {
        "periodo": 202605,
        "valor": 2.2919,
        "delta": 0.0202
      },
      {
        "periodo": 202606,
        "valor": 2.1286,
        "delta": -0.1633
      },
      {
        "periodo": 202607,
        "valor": 2.1309,
        "delta": 0.0023
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 15.068406000000001,
    "valor_anterior": 22.305069,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40.3783,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 40.2916,
        "delta": -0.0867
      },
      {
        "periodo": 202509,
        "valor": 36.2163,
        "delta": -4.0753
      },
      {
        "periodo": 202510,
        "valor": 34.1838,
        "delta": -2.0325
      },
      {
        "periodo": 202511,
        "valor": 30.8008,
        "delta": -3.383
      },
      {
        "periodo": 202512,
        "valor": 25.7245,
        "delta": -5.0763
      },
      {
        "periodo": 202601,
        "valor": 23.1729,
        "delta": -2.5516
      },
      {
        "periodo": 202602,
        "valor": 25.8764,
        "delta": 2.7036
      },
      {
        "periodo": 202603,
        "valor": 27.8434,
        "delta": 1.9669
      },
      {
        "periodo": 202604,
        "valor": 20.0341,
        "delta": -7.8092
      },
      {
        "periodo": 202605,
        "valor": 21.0087,
        "delta": 0.9746
      },
      {
        "periodo": 202606,
        "valor": 22.3051,
        "delta": 1.2964
      },
      {
        "periodo": 202607,
        "valor": 15.0684,
        "delta": -7.2367
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 4.325188,
    "valor_anterior": 4.288189,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 4.2588,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 4.1736,
        "delta": -0.0852
      },
      {
        "periodo": 202604,
        "valor": 4.3914,
        "delta": 0.2178
      },
      {
        "periodo": 202605,
        "valor": 4.334,
        "delta": -0.0575
      },
      {
        "periodo": 202606,
        "valor": 4.2882,
        "delta": -0.0458
      },
      {
        "periodo": 202607,
        "valor": 4.3252,
        "delta": 0.037
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 24.866666000000002,
    "valor_anterior": 24.737639,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19.7695,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 24.1733,
        "delta": 4.4038
      },
      {
        "periodo": 202509,
        "valor": 26.5701,
        "delta": 2.3968
      },
      {
        "periodo": 202510,
        "valor": 30.0234,
        "delta": 3.4533
      },
      {
        "periodo": 202511,
        "valor": 30.5502,
        "delta": 0.5268
      },
      {
        "periodo": 202512,
        "valor": 28.9702,
        "delta": -1.58
      },
      {
        "periodo": 202601,
        "valor": 28.5216,
        "delta": -0.4486
      },
      {
        "periodo": 202602,
        "valor": 27.3518,
        "delta": -1.1698
      },
      {
        "periodo": 202603,
        "valor": 23.921,
        "delta": -3.4308
      },
      {
        "periodo": 202604,
        "valor": 25.5063,
        "delta": 1.5853
      },
      {
        "periodo": 202605,
        "valor": 26.4165,
        "delta": 0.9102
      },
      {
        "periodo": 202606,
        "valor": 24.7376,
        "delta": -1.6789
      },
      {
        "periodo": 202607,
        "valor": 24.8667,
        "delta": 0.129
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 15.550932000000001,
    "valor_anterior": 15.861417,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 156.3139,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 42.6495,
        "delta": -113.6644
      },
      {
        "periodo": 202601,
        "valor": 51.6748,
        "delta": 9.0253
      },
      {
        "periodo": 202602,
        "valor": 40.3834,
        "delta": -11.2913
      },
      {
        "periodo": 202603,
        "valor": 25.2845,
        "delta": -15.0989
      },
      {
        "periodo": 202604,
        "valor": 20.3246,
        "delta": -4.9599
      },
      {
        "periodo": 202605,
        "valor": 16.9272,
        "delta": -3.3974
      },
      {
        "periodo": 202606,
        "valor": 15.8614,
        "delta": -1.0658
      },
      {
        "periodo": 202607,
        "valor": 15.5509,
        "delta": -0.3105
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 16.654859,
    "valor_anterior": 15.860003,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 15.7289,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 16.7583,
        "delta": 1.0294
      },
      {
        "periodo": 202605,
        "valor": 17.7413,
        "delta": 0.983
      },
      {
        "periodo": 202606,
        "valor": 15.86,
        "delta": -1.8813
      },
      {
        "periodo": 202607,
        "valor": 16.6549,
        "delta": 0.7949
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 3.357521,
    "valor_anterior": 3.349266,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.2149,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.243,
        "delta": 0.0281
      },
      {
        "periodo": 202509,
        "valor": 3.31,
        "delta": 0.067
      },
      {
        "periodo": 202510,
        "valor": 3.3224,
        "delta": 0.0124
      },
      {
        "periodo": 202511,
        "valor": 3.2884,
        "delta": -0.034
      },
      {
        "periodo": 202512,
        "valor": 3.23,
        "delta": -0.0584
      },
      {
        "periodo": 202601,
        "valor": 3.2549,
        "delta": 0.0249
      },
      {
        "periodo": 202602,
        "valor": 3.3146,
        "delta": 0.0597
      },
      {
        "periodo": 202603,
        "valor": 3.3133,
        "delta": -0.0013
      },
      {
        "periodo": 202604,
        "valor": 3.3212,
        "delta": 0.0079
      },
      {
        "periodo": 202605,
        "valor": 3.3709,
        "delta": 0.0497
      },
      {
        "periodo": 202606,
        "valor": 3.3493,
        "delta": -0.0216
      },
      {
        "periodo": 202607,
        "valor": 3.3575,
        "delta": 0.0083
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 3.1547970000000003,
    "valor_anterior": 3.1512119999999997,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.9774,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.9948,
        "delta": 0.0174
      },
      {
        "periodo": 202509,
        "valor": 3.0561,
        "delta": 0.0614
      },
      {
        "periodo": 202510,
        "valor": 3.074,
        "delta": 0.0178
      },
      {
        "periodo": 202511,
        "valor": 3.039,
        "delta": -0.035
      },
      {
        "periodo": 202512,
        "valor": 3.0035,
        "delta": -0.0355
      },
      {
        "periodo": 202601,
        "valor": 3.0164,
        "delta": 0.0129
      },
      {
        "periodo": 202602,
        "valor": 3.0891,
        "delta": 0.0727
      },
      {
        "periodo": 202603,
        "valor": 3.0978,
        "delta": 0.0088
      },
      {
        "periodo": 202604,
        "valor": 3.1052,
        "delta": 0.0074
      },
      {
        "periodo": 202605,
        "valor": 3.1613,
        "delta": 0.0561
      },
      {
        "periodo": 202606,
        "valor": 3.1512,
        "delta": -0.0101
      },
      {
        "periodo": 202607,
        "valor": 3.1548,
        "delta": 0.0036
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 1.944922,
    "valor_anterior": 2.361494,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.2488,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.6554,
        "delta": 0.4065
      },
      {
        "periodo": 202509,
        "valor": 3.9984,
        "delta": 0.343
      },
      {
        "periodo": 202510,
        "valor": 3.9877,
        "delta": -0.0107
      },
      {
        "periodo": 202511,
        "valor": 3.8343,
        "delta": -0.1534
      },
      {
        "periodo": 202512,
        "valor": 2.6723,
        "delta": -1.162
      },
      {
        "periodo": 202601,
        "valor": 2.5902,
        "delta": -0.0821
      },
      {
        "periodo": 202602,
        "valor": 2.5922,
        "delta": 0.002
      },
      {
        "periodo": 202603,
        "valor": 2.3797,
        "delta": -0.2125
      },
      {
        "periodo": 202604,
        "valor": 2.3194,
        "delta": -0.0602
      },
      {
        "periodo": 202605,
        "valor": 2.3792,
        "delta": 0.0598
      },
      {
        "periodo": 202606,
        "valor": 2.3615,
        "delta": -0.0177
      },
      {
        "periodo": 202607,
        "valor": 1.9449,
        "delta": -0.4166
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 2.880559,
    "valor_anterior": 2.893455,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.7902,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.8071,
        "delta": 0.0169
      },
      {
        "periodo": 202509,
        "valor": 2.8701,
        "delta": 0.063
      },
      {
        "periodo": 202510,
        "valor": 2.8943,
        "delta": 0.0242
      },
      {
        "periodo": 202511,
        "valor": 2.9406,
        "delta": 0.0463
      },
      {
        "periodo": 202512,
        "valor": 2.9126,
        "delta": -0.028
      },
      {
        "periodo": 202601,
        "valor": 2.8812,
        "delta": -0.0314
      },
      {
        "periodo": 202602,
        "valor": 2.9541,
        "delta": 0.0729
      },
      {
        "periodo": 202603,
        "valor": 2.7586,
        "delta": -0.1955
      },
      {
        "periodo": 202604,
        "valor": 2.8461,
        "delta": 0.0875
      },
      {
        "periodo": 202605,
        "valor": 2.8864,
        "delta": 0.0403
      },
      {
        "periodo": 202606,
        "valor": 2.8935,
        "delta": 0.007
      },
      {
        "periodo": 202607,
        "valor": 2.8806,
        "delta": -0.0129
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 1.9794960000000001,
    "valor_anterior": 1.9593180000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2.2772,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2.2455,
        "delta": -0.0316
      },
      {
        "periodo": 202509,
        "valor": 2.2601,
        "delta": 0.0146
      },
      {
        "periodo": 202510,
        "valor": 2.243,
        "delta": -0.0172
      },
      {
        "periodo": 202511,
        "valor": 2.1866,
        "delta": -0.0563
      },
      {
        "periodo": 202512,
        "valor": 2.0231,
        "delta": -0.1636
      },
      {
        "periodo": 202601,
        "valor": 2.0263,
        "delta": 0.0032
      },
      {
        "periodo": 202602,
        "valor": 2.0156,
        "delta": -0.0107
      },
      {
        "periodo": 202603,
        "valor": 1.9862,
        "delta": -0.0294
      },
      {
        "periodo": 202604,
        "valor": 1.9935,
        "delta": 0.0072
      },
      {
        "periodo": 202605,
        "valor": 1.9806,
        "delta": -0.0129
      },
      {
        "periodo": 202606,
        "valor": 1.9593,
        "delta": -0.0213
      },
      {
        "periodo": 202607,
        "valor": 1.9795,
        "delta": 0.0202
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 3.0703709999999997,
    "valor_anterior": 3.032219,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.0775,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3.0733,
        "delta": -0.0042
      },
      {
        "periodo": 202509,
        "valor": 3.0139,
        "delta": -0.0594
      },
      {
        "periodo": 202510,
        "valor": 2.9852,
        "delta": -0.0286
      },
      {
        "periodo": 202511,
        "valor": 2.9643,
        "delta": -0.0209
      },
      {
        "periodo": 202512,
        "valor": 2.9835,
        "delta": 0.0192
      },
      {
        "periodo": 202601,
        "valor": 3.0237,
        "delta": 0.0402
      },
      {
        "periodo": 202602,
        "valor": 2.9929,
        "delta": -0.0308
      },
      {
        "periodo": 202603,
        "valor": 3.0834,
        "delta": 0.0905
      },
      {
        "periodo": 202604,
        "valor": 3.0837,
        "delta": 0.0003
      },
      {
        "periodo": 202605,
        "valor": 3.0217,
        "delta": -0.062
      },
      {
        "periodo": 202606,
        "valor": 3.0322,
        "delta": 0.0105
      },
      {
        "periodo": 202607,
        "valor": 3.0704,
        "delta": 0.0382
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200118,
    "label": "EPRC / Cartera (Etapa 1 + 2 + 3)",
    "valor_actual": 9.936898,
    "valor_anterior": 9.87318,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.5571,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.61,
        "delta": 0.0529
      },
      {
        "periodo": 202509,
        "valor": 9.9767,
        "delta": 0.3666
      },
      {
        "periodo": 202510,
        "valor": 9.9267,
        "delta": -0.05
      },
      {
        "periodo": 202511,
        "valor": 9.8782,
        "delta": -0.0484
      },
      {
        "periodo": 202512,
        "valor": 9.9304,
        "delta": 0.0522
      },
      {
        "periodo": 202601,
        "valor": 10.1994,
        "delta": 0.269
      },
      {
        "periodo": 202602,
        "valor": 10.0178,
        "delta": -0.1816
      },
      {
        "periodo": 202603,
        "valor": 9.9509,
        "delta": -0.0669
      },
      {
        "periodo": 202604,
        "valor": 9.9336,
        "delta": -0.0173
      },
      {
        "periodo": 202605,
        "valor": 10.1379,
        "delta": 0.2043
      },
      {
        "periodo": 202606,
        "valor": 9.8732,
        "delta": -0.2647
      },
      {
        "periodo": 202607,
        "valor": 9.9369,
        "delta": 0.0637
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 16.242369,
    "valor_anterior": 16.279746,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16.1967,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16.3024,
        "delta": 0.1058
      },
      {
        "periodo": 202509,
        "valor": 16.4309,
        "delta": 0.1285
      },
      {
        "periodo": 202510,
        "valor": 16.5682,
        "delta": 0.1373
      },
      {
        "periodo": 202511,
        "valor": 16.7084,
        "delta": 0.1402
      },
      {
        "periodo": 202512,
        "valor": 16.6061,
        "delta": -0.1024
      },
      {
        "periodo": 202601,
        "valor": 16.521,
        "delta": -0.0851
      },
      {
        "periodo": 202602,
        "valor": 16.4731,
        "delta": -0.0478
      },
      {
        "periodo": 202603,
        "valor": 16.4609,
        "delta": -0.0123
      },
      {
        "periodo": 202604,
        "valor": 16.3953,
        "delta": -0.0656
      },
      {
        "periodo": 202605,
        "valor": 16.3254,
        "delta": -0.0699
      },
      {
        "periodo": 202606,
        "valor": 16.2797,
        "delta": -0.0456
      },
      {
        "periodo": 202607,
        "valor": 16.2424,
        "delta": -0.0374
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 13.143794999999999,
    "valor_anterior": 13.185726,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.8965,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.8197,
        "delta": -0.0768
      },
      {
        "periodo": 202509,
        "valor": 13.7438,
        "delta": -0.0759
      },
      {
        "periodo": 202510,
        "valor": 13.6818,
        "delta": -0.062
      },
      {
        "periodo": 202511,
        "valor": 13.6047,
        "delta": -0.0771
      },
      {
        "periodo": 202512,
        "valor": 13.5268,
        "delta": -0.0779
      },
      {
        "periodo": 202601,
        "valor": 13.47,
        "delta": -0.0568
      },
      {
        "periodo": 202602,
        "valor": 13.4056,
        "delta": -0.0644
      },
      {
        "periodo": 202603,
        "valor": 13.3523,
        "delta": -0.0533
      },
      {
        "periodo": 202604,
        "valor": 13.2996,
        "delta": -0.0526
      },
      {
        "periodo": 202605,
        "valor": 13.2493,
        "delta": -0.0504
      },
      {
        "periodo": 202606,
        "valor": 13.1857,
        "delta": -0.0635
      },
      {
        "periodo": 202607,
        "valor": 13.1438,
        "delta": -0.0419
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 12.860975999999999,
    "valor_anterior": 12.958789000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14.3278,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14.2431,
        "delta": -0.0847
      },
      {
        "periodo": 202509,
        "valor": 14.1119,
        "delta": -0.1312
      },
      {
        "periodo": 202510,
        "valor": 14.0052,
        "delta": -0.1067
      },
      {
        "periodo": 202511,
        "valor": 13.8859,
        "delta": -0.1193
      },
      {
        "periodo": 202512,
        "valor": 13.7073,
        "delta": -0.1786
      },
      {
        "periodo": 202601,
        "valor": 13.549,
        "delta": -0.1582
      },
      {
        "periodo": 202602,
        "valor": 13.4159,
        "delta": -0.1331
      },
      {
        "periodo": 202603,
        "valor": 13.2808,
        "delta": -0.1352
      },
      {
        "periodo": 202604,
        "valor": 13.1747,
        "delta": -0.1061
      },
      {
        "periodo": 202605,
        "valor": 13.069,
        "delta": -0.1057
      },
      {
        "periodo": 202606,
        "valor": 12.9588,
        "delta": -0.1102
      },
      {
        "periodo": 202607,
        "valor": 12.861,
        "delta": -0.0978
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 12.559609,
    "valor_anterior": 12.649648,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.5503,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.4757,
        "delta": -0.0746
      },
      {
        "periodo": 202509,
        "valor": 13.4109,
        "delta": -0.0648
      },
      {
        "periodo": 202510,
        "valor": 13.3329,
        "delta": -0.078
      },
      {
        "periodo": 202511,
        "valor": 13.2603,
        "delta": -0.0726
      },
      {
        "periodo": 202512,
        "valor": 13.1831,
        "delta": -0.0772
      },
      {
        "periodo": 202601,
        "valor": 13.097,
        "delta": -0.0862
      },
      {
        "periodo": 202602,
        "valor": 13.0136,
        "delta": -0.0834
      },
      {
        "periodo": 202603,
        "valor": 12.9402,
        "delta": -0.0734
      },
      {
        "periodo": 202604,
        "valor": 12.8535,
        "delta": -0.0867
      },
      {
        "periodo": 202605,
        "valor": 12.7561,
        "delta": -0.0974
      },
      {
        "periodo": 202606,
        "valor": 12.6496,
        "delta": -0.1064
      },
      {
        "periodo": 202607,
        "valor": 12.5596,
        "delta": -0.09
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 10.503564,
    "valor_anterior": 10.631675,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.58,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.4014,
        "delta": -0.1786
      },
      {
        "periodo": 202509,
        "valor": 12.2278,
        "delta": -0.1736
      },
      {
        "periodo": 202510,
        "valor": 12.0552,
        "delta": -0.1725
      },
      {
        "periodo": 202511,
        "valor": 11.872,
        "delta": -0.1832
      },
      {
        "periodo": 202512,
        "valor": 11.6721,
        "delta": -0.1999
      },
      {
        "periodo": 202601,
        "valor": 11.4767,
        "delta": -0.1954
      },
      {
        "periodo": 202602,
        "valor": 11.2903,
        "delta": -0.1864
      },
      {
        "periodo": 202603,
        "valor": 11.1082,
        "delta": -0.1821
      },
      {
        "periodo": 202604,
        "valor": 10.9441,
        "delta": -0.1642
      },
      {
        "periodo": 202605,
        "valor": 10.7881,
        "delta": -0.156
      },
      {
        "periodo": 202606,
        "valor": 10.6317,
        "delta": -0.1564
      },
      {
        "periodo": 202607,
        "valor": 10.5036,
        "delta": -0.1281
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 10.698702,
    "valor_anterior": 10.810673,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.3206,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.2011,
        "delta": -0.1195
      },
      {
        "periodo": 202509,
        "valor": 12.0832,
        "delta": -0.1179
      },
      {
        "periodo": 202510,
        "valor": 11.9573,
        "delta": -0.1258
      },
      {
        "periodo": 202511,
        "valor": 11.8098,
        "delta": -0.1476
      },
      {
        "periodo": 202512,
        "valor": 11.579,
        "delta": -0.2307
      },
      {
        "periodo": 202601,
        "valor": 11.4263,
        "delta": -0.1527
      },
      {
        "periodo": 202602,
        "valor": 11.2765,
        "delta": -0.1499
      },
      {
        "periodo": 202603,
        "valor": 11.1464,
        "delta": -0.1301
      },
      {
        "periodo": 202604,
        "valor": 11.0454,
        "delta": -0.101
      },
      {
        "periodo": 202605,
        "valor": 10.899,
        "delta": -0.1464
      },
      {
        "periodo": 202606,
        "valor": 10.8107,
        "delta": -0.0883
      },
      {
        "periodo": 202607,
        "valor": 10.6987,
        "delta": -0.112
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 13.647347000000002,
    "valor_anterior": 13.367488,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11.1819,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.0506,
        "delta": -0.1313
      },
      {
        "periodo": 202509,
        "valor": 10.9204,
        "delta": -0.1302
      },
      {
        "periodo": 202510,
        "valor": 11.1607,
        "delta": 0.2403
      },
      {
        "periodo": 202511,
        "valor": 11.4447,
        "delta": 0.2839
      },
      {
        "periodo": 202512,
        "valor": 12.261,
        "delta": 0.8163
      },
      {
        "periodo": 202601,
        "valor": 12.0807,
        "delta": -0.1803
      },
      {
        "periodo": 202602,
        "valor": 12.316,
        "delta": 0.2354
      },
      {
        "periodo": 202603,
        "valor": 12.5976,
        "delta": 0.2815
      },
      {
        "periodo": 202604,
        "valor": 12.8549,
        "delta": 0.2573
      },
      {
        "periodo": 202605,
        "valor": 13.2026,
        "delta": 0.3478
      },
      {
        "periodo": 202606,
        "valor": 13.3675,
        "delta": 0.1649
      },
      {
        "periodo": 202607,
        "valor": 13.6473,
        "delta": 0.2799
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 10.741504,
    "valor_anterior": 10.781289,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11.5181,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.4399,
        "delta": -0.0782
      },
      {
        "periodo": 202509,
        "valor": 11.3761,
        "delta": -0.0638
      },
      {
        "periodo": 202510,
        "valor": 11.2974,
        "delta": -0.0787
      },
      {
        "periodo": 202511,
        "valor": 11.2269,
        "delta": -0.0705
      },
      {
        "periodo": 202512,
        "valor": 11.147,
        "delta": -0.0799
      },
      {
        "periodo": 202601,
        "valor": 11.0905,
        "delta": -0.0564
      },
      {
        "periodo": 202602,
        "valor": 11.0248,
        "delta": -0.0658
      },
      {
        "periodo": 202603,
        "valor": 10.955,
        "delta": -0.0698
      },
      {
        "periodo": 202604,
        "valor": 10.9011,
        "delta": -0.0539
      },
      {
        "periodo": 202605,
        "valor": 10.837,
        "delta": -0.064
      },
      {
        "periodo": 202606,
        "valor": 10.7813,
        "delta": -0.0557
      },
      {
        "periodo": 202607,
        "valor": 10.7415,
        "delta": -0.0398
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 11.226334,
    "valor_anterior": 11.350754,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.0119,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.8816,
        "delta": -0.1303
      },
      {
        "periodo": 202509,
        "valor": 12.7271,
        "delta": -0.1545
      },
      {
        "periodo": 202510,
        "valor": 12.5937,
        "delta": -0.1334
      },
      {
        "periodo": 202511,
        "valor": 12.4528,
        "delta": -0.1409
      },
      {
        "periodo": 202512,
        "valor": 12.2985,
        "delta": -0.1543
      },
      {
        "periodo": 202601,
        "valor": 12.1484,
        "delta": -0.1501
      },
      {
        "periodo": 202602,
        "valor": 11.9781,
        "delta": -0.1703
      },
      {
        "periodo": 202603,
        "valor": 11.821,
        "delta": -0.1571
      },
      {
        "periodo": 202604,
        "valor": 11.6604,
        "delta": -0.1606
      },
      {
        "periodo": 202605,
        "valor": 11.5017,
        "delta": -0.1587
      },
      {
        "periodo": 202606,
        "valor": 11.3508,
        "delta": -0.1509
      },
      {
        "periodo": 202607,
        "valor": 11.2263,
        "delta": -0.1244
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 18.883872,
    "valor_anterior": 18.934479,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19.5952,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19.3984,
        "delta": -0.1967
      },
      {
        "periodo": 202509,
        "valor": 19.3116,
        "delta": -0.0868
      },
      {
        "periodo": 202510,
        "valor": 19.178,
        "delta": -0.1336
      },
      {
        "periodo": 202511,
        "valor": 19.1389,
        "delta": -0.0391
      },
      {
        "periodo": 202512,
        "valor": 19.1349,
        "delta": -0.004
      },
      {
        "periodo": 202601,
        "valor": 19.0338,
        "delta": -0.1011
      },
      {
        "periodo": 202602,
        "valor": 18.9994,
        "delta": -0.0343
      },
      {
        "periodo": 202603,
        "valor": 18.9436,
        "delta": -0.0559
      },
      {
        "periodo": 202604,
        "valor": 18.9343,
        "delta": -0.0093
      },
      {
        "periodo": 202605,
        "valor": 18.9351,
        "delta": 0.0008
      },
      {
        "periodo": 202606,
        "valor": 18.9345,
        "delta": -0.0006
      },
      {
        "periodo": 202607,
        "valor": 18.8839,
        "delta": -0.0506
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 11.400282,
    "valor_anterior": 11.524129,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.566,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.3058,
        "delta": -0.2601
      },
      {
        "periodo": 202509,
        "valor": 13.1537,
        "delta": -0.1522
      },
      {
        "periodo": 202510,
        "valor": 12.9291,
        "delta": -0.2246
      },
      {
        "periodo": 202511,
        "valor": 12.7464,
        "delta": -0.1827
      },
      {
        "periodo": 202512,
        "valor": 12.5723,
        "delta": -0.1741
      },
      {
        "periodo": 202601,
        "valor": 12.2855,
        "delta": -0.2867
      },
      {
        "periodo": 202602,
        "valor": 12.0904,
        "delta": -0.1951
      },
      {
        "periodo": 202603,
        "valor": 11.993,
        "delta": -0.0974
      },
      {
        "periodo": 202604,
        "valor": 11.802,
        "delta": -0.1909
      },
      {
        "periodo": 202605,
        "valor": 11.5994,
        "delta": -0.2026
      },
      {
        "periodo": 202606,
        "valor": 11.5241,
        "delta": -0.0753
      },
      {
        "periodo": 202607,
        "valor": 11.4003,
        "delta": -0.1238
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 14.053664,
    "valor_anterior": 14.095558,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14.8378,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14.7448,
        "delta": -0.093
      },
      {
        "periodo": 202509,
        "valor": 14.6496,
        "delta": -0.0952
      },
      {
        "periodo": 202510,
        "valor": 14.5578,
        "delta": -0.0918
      },
      {
        "periodo": 202511,
        "valor": 14.4765,
        "delta": -0.0813
      },
      {
        "periodo": 202512,
        "valor": 14.4414,
        "delta": -0.0352
      },
      {
        "periodo": 202601,
        "valor": 14.3558,
        "delta": -0.0856
      },
      {
        "periodo": 202602,
        "valor": 14.2803,
        "delta": -0.0755
      },
      {
        "periodo": 202603,
        "valor": 14.2206,
        "delta": -0.0597
      },
      {
        "periodo": 202604,
        "valor": 14.1756,
        "delta": -0.045
      },
      {
        "periodo": 202605,
        "valor": 14.1468,
        "delta": -0.0288
      },
      {
        "periodo": 202606,
        "valor": 14.0956,
        "delta": -0.0512
      },
      {
        "periodo": 202607,
        "valor": 14.0537,
        "delta": -0.0419
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 11.961292,
    "valor_anterior": 12.026159999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.9029,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.8032,
        "delta": -0.0997
      },
      {
        "periodo": 202509,
        "valor": 12.7016,
        "delta": -0.1016
      },
      {
        "periodo": 202510,
        "valor": 12.5956,
        "delta": -0.106
      },
      {
        "periodo": 202511,
        "valor": 12.4962,
        "delta": -0.0994
      },
      {
        "periodo": 202512,
        "valor": 12.3947,
        "delta": -0.1014
      },
      {
        "periodo": 202601,
        "valor": 12.3172,
        "delta": -0.0776
      },
      {
        "periodo": 202602,
        "valor": 12.2569,
        "delta": -0.0603
      },
      {
        "periodo": 202603,
        "valor": 12.1896,
        "delta": -0.0673
      },
      {
        "periodo": 202604,
        "valor": 12.1291,
        "delta": -0.0604
      },
      {
        "periodo": 202605,
        "valor": 12.0799,
        "delta": -0.0493
      },
      {
        "periodo": 202606,
        "valor": 12.0262,
        "delta": -0.0537
      },
      {
        "periodo": 202607,
        "valor": 11.9613,
        "delta": -0.0649
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 7.9288490000000005,
    "valor_anterior": 8.063329,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.3575,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.2665,
        "delta": -0.0911
      },
      {
        "periodo": 202509,
        "valor": 9.1122,
        "delta": -0.1543
      },
      {
        "periodo": 202510,
        "valor": 9.0638,
        "delta": -0.0484
      },
      {
        "periodo": 202511,
        "valor": 8.9549,
        "delta": -0.1089
      },
      {
        "periodo": 202512,
        "valor": 8.8221,
        "delta": -0.1328
      },
      {
        "periodo": 202601,
        "valor": 8.6994,
        "delta": -0.1227
      },
      {
        "periodo": 202602,
        "valor": 8.5573,
        "delta": -0.1421
      },
      {
        "periodo": 202603,
        "valor": 8.424,
        "delta": -0.1332
      },
      {
        "periodo": 202604,
        "valor": 8.3238,
        "delta": -0.1002
      },
      {
        "periodo": 202605,
        "valor": 8.196,
        "delta": -0.1278
      },
      {
        "periodo": 202606,
        "valor": 8.0633,
        "delta": -0.1327
      },
      {
        "periodo": 202607,
        "valor": 7.9288,
        "delta": -0.1345
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 6.305417,
    "valor_anterior": 6.335507,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.0606,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.9724,
        "delta": -0.0882
      },
      {
        "periodo": 202509,
        "valor": 8.8529,
        "delta": -0.1195
      },
      {
        "periodo": 202510,
        "valor": 8.5586,
        "delta": -0.2943
      },
      {
        "periodo": 202511,
        "valor": 8.4,
        "delta": -0.1586
      },
      {
        "periodo": 202512,
        "valor": 8.1086,
        "delta": -0.2914
      },
      {
        "periodo": 202601,
        "valor": 7.826,
        "delta": -0.2826
      },
      {
        "periodo": 202602,
        "valor": 7.5341,
        "delta": -0.2919
      },
      {
        "periodo": 202603,
        "valor": 7.102,
        "delta": -0.432
      },
      {
        "periodo": 202604,
        "valor": 6.8318,
        "delta": -0.2702
      },
      {
        "periodo": 202605,
        "valor": 6.3762,
        "delta": -0.4557
      },
      {
        "periodo": 202606,
        "valor": 6.3355,
        "delta": -0.0407
      },
      {
        "periodo": 202607,
        "valor": 6.3054,
        "delta": -0.0301
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 7.918633,
    "valor_anterior": 8.017487,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8.8583,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.7057,
        "delta": -0.1525
      },
      {
        "periodo": 202509,
        "valor": 8.5513,
        "delta": -0.1544
      },
      {
        "periodo": 202510,
        "valor": 8.4586,
        "delta": -0.0927
      },
      {
        "periodo": 202511,
        "valor": 8.7962,
        "delta": 0.3375
      },
      {
        "periodo": 202512,
        "valor": 8.6972,
        "delta": -0.099
      },
      {
        "periodo": 202601,
        "valor": 8.4927,
        "delta": -0.2045
      },
      {
        "periodo": 202602,
        "valor": 8.408,
        "delta": -0.0846
      },
      {
        "periodo": 202603,
        "valor": 8.3041,
        "delta": -0.1039
      },
      {
        "periodo": 202604,
        "valor": 8.2521,
        "delta": -0.052
      },
      {
        "periodo": 202605,
        "valor": 8.1182,
        "delta": -0.1339
      },
      {
        "periodo": 202606,
        "valor": 8.0175,
        "delta": -0.1008
      },
      {
        "periodo": 202607,
        "valor": 7.9186,
        "delta": -0.0989
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 8.114599,
    "valor_anterior": 8.180152999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.3292,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.2275,
        "delta": -0.1017
      },
      {
        "periodo": 202509,
        "valor": 9.1013,
        "delta": -0.1262
      },
      {
        "periodo": 202510,
        "valor": 9.0028,
        "delta": -0.0985
      },
      {
        "periodo": 202511,
        "valor": 8.9085,
        "delta": -0.0943
      },
      {
        "periodo": 202512,
        "valor": 8.7491,
        "delta": -0.1594
      },
      {
        "periodo": 202601,
        "valor": 8.6417,
        "delta": -0.1074
      },
      {
        "periodo": 202602,
        "valor": 8.5323,
        "delta": -0.1093
      },
      {
        "periodo": 202603,
        "valor": 8.4609,
        "delta": -0.0715
      },
      {
        "periodo": 202604,
        "valor": 8.3616,
        "delta": -0.0992
      },
      {
        "periodo": 202605,
        "valor": 8.2636,
        "delta": -0.098
      },
      {
        "periodo": 202606,
        "valor": 8.1802,
        "delta": -0.0835
      },
      {
        "periodo": 202607,
        "valor": 8.1146,
        "delta": -0.0656
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 10.19901,
    "valor_anterior": 10.321963,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.487,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.2985,
        "delta": -0.1885
      },
      {
        "periodo": 202509,
        "valor": 12.0456,
        "delta": -0.2529
      },
      {
        "periodo": 202510,
        "valor": 11.8353,
        "delta": -0.2103
      },
      {
        "periodo": 202511,
        "valor": 11.6423,
        "delta": -0.193
      },
      {
        "periodo": 202512,
        "valor": 11.4035,
        "delta": -0.2388
      },
      {
        "periodo": 202601,
        "valor": 11.1964,
        "delta": -0.2072
      },
      {
        "periodo": 202602,
        "valor": 10.9988,
        "delta": -0.1976
      },
      {
        "periodo": 202603,
        "valor": 10.806,
        "delta": -0.1928
      },
      {
        "periodo": 202604,
        "valor": 10.6419,
        "delta": -0.1641
      },
      {
        "periodo": 202605,
        "valor": 10.4701,
        "delta": -0.1718
      },
      {
        "periodo": 202606,
        "valor": 10.322,
        "delta": -0.1481
      },
      {
        "periodo": 202607,
        "valor": 10.199,
        "delta": -0.123
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 7.667538,
    "valor_anterior": 7.836329,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8.9862,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.9631,
        "delta": -0.0231
      },
      {
        "periodo": 202509,
        "valor": 8.9014,
        "delta": -0.0617
      },
      {
        "periodo": 202510,
        "valor": 8.8496,
        "delta": -0.0518
      },
      {
        "periodo": 202511,
        "valor": 8.7389,
        "delta": -0.1107
      },
      {
        "periodo": 202512,
        "valor": 8.6818,
        "delta": -0.0571
      },
      {
        "periodo": 202601,
        "valor": 8.5311,
        "delta": -0.1507
      },
      {
        "periodo": 202602,
        "valor": 8.4218,
        "delta": -0.1093
      },
      {
        "periodo": 202603,
        "valor": 8.2486,
        "delta": -0.1732
      },
      {
        "periodo": 202604,
        "valor": 8.1205,
        "delta": -0.128
      },
      {
        "periodo": 202605,
        "valor": 8.0079,
        "delta": -0.1126
      },
      {
        "periodo": 202606,
        "valor": 7.8363,
        "delta": -0.1716
      },
      {
        "periodo": 202607,
        "valor": 7.6675,
        "delta": -0.1688
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 49.932067,
    "valor_anterior": 49.863151,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 50.0175,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 50.1456,
        "delta": 0.1281
      },
      {
        "periodo": 202509,
        "valor": 50.2183,
        "delta": 0.0727
      },
      {
        "periodo": 202510,
        "valor": 50.2727,
        "delta": 0.0544
      },
      {
        "periodo": 202511,
        "valor": 50.4362,
        "delta": 0.1634
      },
      {
        "periodo": 202512,
        "valor": 50.3659,
        "delta": -0.0702
      },
      {
        "periodo": 202601,
        "valor": 50.249,
        "delta": -0.1169
      },
      {
        "periodo": 202602,
        "valor": 50.1535,
        "delta": -0.0955
      },
      {
        "periodo": 202603,
        "valor": 50.1412,
        "delta": -0.0123
      },
      {
        "periodo": 202604,
        "valor": 50.0945,
        "delta": -0.0466
      },
      {
        "periodo": 202605,
        "valor": 49.9386,
        "delta": -0.1559
      },
      {
        "periodo": 202606,
        "valor": 49.8632,
        "delta": -0.0755
      },
      {
        "periodo": 202607,
        "valor": 49.9321,
        "delta": 0.0689
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 12.842107,
    "valor_anterior": 13.004597,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18.0874,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18.3377,
        "delta": 0.2503
      },
      {
        "periodo": 202509,
        "valor": 16.9698,
        "delta": -1.3679
      },
      {
        "periodo": 202510,
        "valor": 16.1645,
        "delta": -0.8053
      },
      {
        "periodo": 202511,
        "valor": 15.3623,
        "delta": -0.8021
      },
      {
        "periodo": 202512,
        "valor": 14.8247,
        "delta": -0.5376
      },
      {
        "periodo": 202601,
        "valor": 14.4336,
        "delta": -0.3911
      },
      {
        "periodo": 202602,
        "valor": 14.0166,
        "delta": -0.417
      },
      {
        "periodo": 202603,
        "valor": 13.7025,
        "delta": -0.3142
      },
      {
        "periodo": 202604,
        "valor": 13.5237,
        "delta": -0.1788
      },
      {
        "periodo": 202605,
        "valor": 13.3397,
        "delta": -0.184
      },
      {
        "periodo": 202606,
        "valor": 13.0046,
        "delta": -0.3351
      },
      {
        "periodo": 202607,
        "valor": 12.8421,
        "delta": -0.1625
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 63.601476,
    "valor_anterior": 63.415752999999995,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 63.9019,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 63.942,
        "delta": 0.0401
      },
      {
        "periodo": 202509,
        "valor": 63.8988,
        "delta": -0.0432
      },
      {
        "periodo": 202510,
        "valor": 63.7206,
        "delta": -0.1782
      },
      {
        "periodo": 202511,
        "valor": 63.6456,
        "delta": -0.075
      },
      {
        "periodo": 202512,
        "valor": 63.7518,
        "delta": 0.1062
      },
      {
        "periodo": 202601,
        "valor": 63.647,
        "delta": -0.1048
      },
      {
        "periodo": 202602,
        "valor": 63.4757,
        "delta": -0.1713
      },
      {
        "periodo": 202603,
        "valor": 63.4654,
        "delta": -0.0103
      },
      {
        "periodo": 202604,
        "valor": 63.5583,
        "delta": 0.0929
      },
      {
        "periodo": 202605,
        "valor": 63.5204,
        "delta": -0.0379
      },
      {
        "periodo": 202606,
        "valor": 63.4158,
        "delta": -0.1046
      },
      {
        "periodo": 202607,
        "valor": 63.6015,
        "delta": 0.1857
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 11.177873,
    "valor_anterior": 11.314614,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.7608,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.5552,
        "delta": -0.2056
      },
      {
        "periodo": 202509,
        "valor": 13.2862,
        "delta": -0.269
      },
      {
        "periodo": 202510,
        "valor": 13.0606,
        "delta": -0.2255
      },
      {
        "periodo": 202511,
        "valor": 12.8573,
        "delta": -0.2033
      },
      {
        "periodo": 202512,
        "valor": 12.5556,
        "delta": -0.3017
      },
      {
        "periodo": 202601,
        "valor": 12.3097,
        "delta": -0.246
      },
      {
        "periodo": 202602,
        "valor": 12.0351,
        "delta": -0.2746
      },
      {
        "periodo": 202603,
        "valor": 11.8906,
        "delta": -0.1444
      },
      {
        "periodo": 202604,
        "valor": 11.6907,
        "delta": -0.1999
      },
      {
        "periodo": 202605,
        "valor": 11.4922,
        "delta": -0.1986
      },
      {
        "periodo": 202606,
        "valor": 11.3146,
        "delta": -0.1776
      },
      {
        "periodo": 202607,
        "valor": 11.1779,
        "delta": -0.1367
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 10.3088,
    "valor_anterior": 10.438144000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.9055,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.6503,
        "delta": -0.2553
      },
      {
        "periodo": 202509,
        "valor": 12.4564,
        "delta": -0.1939
      },
      {
        "periodo": 202510,
        "valor": 12.2795,
        "delta": -0.1769
      },
      {
        "periodo": 202511,
        "valor": 11.9993,
        "delta": -0.2802
      },
      {
        "periodo": 202512,
        "valor": 11.7355,
        "delta": -0.2639
      },
      {
        "periodo": 202601,
        "valor": 11.4716,
        "delta": -0.2639
      },
      {
        "periodo": 202602,
        "valor": 11.2311,
        "delta": -0.2405
      },
      {
        "periodo": 202603,
        "valor": 11.0019,
        "delta": -0.2292
      },
      {
        "periodo": 202604,
        "valor": 10.8185,
        "delta": -0.1835
      },
      {
        "periodo": 202605,
        "valor": 10.6282,
        "delta": -0.1903
      },
      {
        "periodo": 202606,
        "valor": 10.4381,
        "delta": -0.19
      },
      {
        "periodo": 202607,
        "valor": 10.3088,
        "delta": -0.1293
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 18.8029,
    "valor_anterior": 14.945377,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10.2106,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10.2834,
        "delta": 0.0728
      },
      {
        "periodo": 202509,
        "valor": 10.504,
        "delta": 0.2206
      },
      {
        "periodo": 202510,
        "valor": 10.4487,
        "delta": -0.0553
      },
      {
        "periodo": 202511,
        "valor": 10.6318,
        "delta": 0.1831
      },
      {
        "periodo": 202512,
        "valor": 10.6681,
        "delta": 0.0363
      },
      {
        "periodo": 202601,
        "valor": 10.6627,
        "delta": -0.0054
      },
      {
        "periodo": 202602,
        "valor": 10.8403,
        "delta": 0.1776
      },
      {
        "periodo": 202603,
        "valor": 11.2503,
        "delta": 0.4101
      },
      {
        "periodo": 202604,
        "valor": 11.6972,
        "delta": 0.4469
      },
      {
        "periodo": 202605,
        "valor": 12.5492,
        "delta": 0.852
      },
      {
        "periodo": 202606,
        "valor": 14.9454,
        "delta": 2.3962
      },
      {
        "periodo": 202607,
        "valor": 18.8029,
        "delta": 3.8575
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 19.874734999999998,
    "valor_anterior": 19.959919,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22.1968,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21.7089,
        "delta": -0.488
      },
      {
        "periodo": 202509,
        "valor": 21.2703,
        "delta": -0.4385
      },
      {
        "periodo": 202510,
        "valor": 20.9661,
        "delta": -0.3042
      },
      {
        "periodo": 202511,
        "valor": 20.9555,
        "delta": -0.0105
      },
      {
        "periodo": 202512,
        "valor": 20.7191,
        "delta": -0.2364
      },
      {
        "periodo": 202601,
        "valor": 20.5596,
        "delta": -0.1595
      },
      {
        "periodo": 202602,
        "valor": 20.3982,
        "delta": -0.1614
      },
      {
        "periodo": 202603,
        "valor": 20.2534,
        "delta": -0.1448
      },
      {
        "periodo": 202604,
        "valor": 20.1593,
        "delta": -0.0941
      },
      {
        "periodo": 202605,
        "valor": 20.0391,
        "delta": -0.1202
      },
      {
        "periodo": 202606,
        "valor": 19.9599,
        "delta": -0.0792
      },
      {
        "periodo": 202607,
        "valor": 19.8747,
        "delta": -0.0852
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 29.722431,
    "valor_anterior": 29.679899,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27.0639,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 27.3672,
        "delta": 0.3032
      },
      {
        "periodo": 202509,
        "valor": 27.6828,
        "delta": 0.3156
      },
      {
        "periodo": 202510,
        "valor": 28.4281,
        "delta": 0.7453
      },
      {
        "periodo": 202511,
        "valor": 28.8107,
        "delta": 0.3826
      },
      {
        "periodo": 202512,
        "valor": 29.2796,
        "delta": 0.4689
      },
      {
        "periodo": 202601,
        "valor": 29.8436,
        "delta": 0.564
      },
      {
        "periodo": 202602,
        "valor": 29.9892,
        "delta": 0.1456
      },
      {
        "periodo": 202603,
        "valor": 30.1374,
        "delta": 0.1482
      },
      {
        "periodo": 202604,
        "valor": 29.9638,
        "delta": -0.1736
      },
      {
        "periodo": 202605,
        "valor": 29.6532,
        "delta": -0.3106
      },
      {
        "periodo": 202606,
        "valor": 29.6799,
        "delta": 0.0267
      },
      {
        "periodo": 202607,
        "valor": 29.7224,
        "delta": 0.0425
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 10.10022,
    "valor_anterior": 10.256961,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10.2906,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10.1748,
        "delta": -0.1159
      },
      {
        "periodo": 202509,
        "valor": 10.0646,
        "delta": -0.1102
      },
      {
        "periodo": 202510,
        "valor": 9.9421,
        "delta": -0.1225
      },
      {
        "periodo": 202511,
        "valor": 11.5947,
        "delta": 1.6527
      },
      {
        "periodo": 202512,
        "valor": 11.4731,
        "delta": -0.1216
      },
      {
        "periodo": 202601,
        "valor": 11.3433,
        "delta": -0.1298
      },
      {
        "periodo": 202602,
        "valor": 11.2585,
        "delta": -0.0848
      },
      {
        "periodo": 202603,
        "valor": 11.0389,
        "delta": -0.2196
      },
      {
        "periodo": 202604,
        "valor": 10.8424,
        "delta": -0.1965
      },
      {
        "periodo": 202605,
        "valor": 10.4509,
        "delta": -0.3915
      },
      {
        "periodo": 202606,
        "valor": 10.257,
        "delta": -0.1939
      },
      {
        "periodo": 202607,
        "valor": 10.1002,
        "delta": -0.1567
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 28.106198,
    "valor_anterior": 28.123554000000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28.7073,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28.5584,
        "delta": -0.1489
      },
      {
        "periodo": 202509,
        "valor": 28.454,
        "delta": -0.1045
      },
      {
        "periodo": 202510,
        "valor": 28.3741,
        "delta": -0.0798
      },
      {
        "periodo": 202511,
        "valor": 28.3419,
        "delta": -0.0322
      },
      {
        "periodo": 202512,
        "valor": 28.3352,
        "delta": -0.0067
      },
      {
        "periodo": 202601,
        "valor": 28.3005,
        "delta": -0.0347
      },
      {
        "periodo": 202602,
        "valor": 28.2423,
        "delta": -0.0582
      },
      {
        "periodo": 202603,
        "valor": 28.1753,
        "delta": -0.067
      },
      {
        "periodo": 202604,
        "valor": 28.1577,
        "delta": -0.0177
      },
      {
        "periodo": 202605,
        "valor": 28.1429,
        "delta": -0.0148
      },
      {
        "periodo": 202606,
        "valor": 28.1236,
        "delta": -0.0193
      },
      {
        "periodo": 202607,
        "valor": 28.1062,
        "delta": -0.0174
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 14.409058,
    "valor_anterior": 14.470538,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15.6161,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 15.6417,
        "delta": 0.0256
      },
      {
        "periodo": 202509,
        "valor": 15.6785,
        "delta": 0.0367
      },
      {
        "periodo": 202510,
        "valor": 15.6981,
        "delta": 0.0196
      },
      {
        "periodo": 202511,
        "valor": 15.7199,
        "delta": 0.0218
      },
      {
        "periodo": 202512,
        "valor": 14.6855,
        "delta": -1.0344
      },
      {
        "periodo": 202601,
        "valor": 14.6382,
        "delta": -0.0473
      },
      {
        "periodo": 202602,
        "valor": 14.6336,
        "delta": -0.0046
      },
      {
        "periodo": 202603,
        "valor": 14.5799,
        "delta": -0.0537
      },
      {
        "periodo": 202604,
        "valor": 14.5356,
        "delta": -0.0443
      },
      {
        "periodo": 202605,
        "valor": 14.515,
        "delta": -0.0206
      },
      {
        "periodo": 202606,
        "valor": 14.4705,
        "delta": -0.0444
      },
      {
        "periodo": 202607,
        "valor": 14.4091,
        "delta": -0.0615
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.0921,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.044,
        "delta": -0.048
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 9.518395,
    "valor_anterior": 9.64129,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11.5705,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.3606,
        "delta": -0.2099
      },
      {
        "periodo": 202509,
        "valor": 11.1716,
        "delta": -0.189
      },
      {
        "periodo": 202510,
        "valor": 10.9925,
        "delta": -0.1791
      },
      {
        "periodo": 202511,
        "valor": 10.8235,
        "delta": -0.169
      },
      {
        "periodo": 202512,
        "valor": 10.6586,
        "delta": -0.165
      },
      {
        "periodo": 202601,
        "valor": 10.4733,
        "delta": -0.1853
      },
      {
        "periodo": 202602,
        "valor": 10.3203,
        "delta": -0.153
      },
      {
        "periodo": 202603,
        "valor": 10.145,
        "delta": -0.1753
      },
      {
        "periodo": 202604,
        "valor": 9.9686,
        "delta": -0.1764
      },
      {
        "periodo": 202605,
        "valor": 9.8003,
        "delta": -0.1683
      },
      {
        "periodo": 202606,
        "valor": 9.6413,
        "delta": -0.159
      },
      {
        "periodo": 202607,
        "valor": 9.5184,
        "delta": -0.1229
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 14.53769,
    "valor_anterior": 14.693304,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17.5456,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17.3194,
        "delta": -0.2263
      },
      {
        "periodo": 202509,
        "valor": 16.995,
        "delta": -0.3244
      },
      {
        "periodo": 202510,
        "valor": 16.7161,
        "delta": -0.2789
      },
      {
        "periodo": 202511,
        "valor": 16.4202,
        "delta": -0.296
      },
      {
        "periodo": 202512,
        "valor": 16.2139,
        "delta": -0.2062
      },
      {
        "periodo": 202601,
        "valor": 15.9481,
        "delta": -0.2658
      },
      {
        "periodo": 202602,
        "valor": 15.6559,
        "delta": -0.2922
      },
      {
        "periodo": 202603,
        "valor": 15.3961,
        "delta": -0.2598
      },
      {
        "periodo": 202604,
        "valor": 15.1665,
        "delta": -0.2296
      },
      {
        "periodo": 202605,
        "valor": 14.9863,
        "delta": -0.1803
      },
      {
        "periodo": 202606,
        "valor": 14.6933,
        "delta": -0.293
      },
      {
        "periodo": 202607,
        "valor": 14.5377,
        "delta": -0.1556
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 80.078359,
    "valor_anterior": 79.703335,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 78.6667,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 78.6405,
        "delta": -0.0262
      },
      {
        "periodo": 202509,
        "valor": 78.5389,
        "delta": -0.1017
      },
      {
        "periodo": 202510,
        "valor": 78.6596,
        "delta": 0.1208
      },
      {
        "periodo": 202511,
        "valor": 78.7613,
        "delta": 0.1017
      },
      {
        "periodo": 202512,
        "valor": 79.3411,
        "delta": 0.5798
      },
      {
        "periodo": 202601,
        "valor": 79.587,
        "delta": 0.2459
      },
      {
        "periodo": 202602,
        "valor": 79.6116,
        "delta": 0.0245
      },
      {
        "periodo": 202603,
        "valor": 79.4253,
        "delta": -0.1863
      },
      {
        "periodo": 202604,
        "valor": 79.5471,
        "delta": 0.1219
      },
      {
        "periodo": 202605,
        "valor": 79.7403,
        "delta": 0.1931
      },
      {
        "periodo": 202606,
        "valor": 79.7033,
        "delta": -0.0369
      },
      {
        "periodo": 202607,
        "valor": 80.0784,
        "delta": 0.375
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 12.627488000000001,
    "valor_anterior": 12.784211,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15.1757,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14.9291,
        "delta": -0.2465
      },
      {
        "periodo": 202509,
        "valor": 14.7142,
        "delta": -0.2149
      },
      {
        "periodo": 202510,
        "valor": 14.5011,
        "delta": -0.2131
      },
      {
        "periodo": 202511,
        "valor": 14.2622,
        "delta": -0.2389
      },
      {
        "periodo": 202512,
        "valor": 14.0144,
        "delta": -0.2477
      },
      {
        "periodo": 202601,
        "valor": 13.7776,
        "delta": -0.2368
      },
      {
        "periodo": 202602,
        "valor": 13.5686,
        "delta": -0.209
      },
      {
        "periodo": 202603,
        "valor": 13.354,
        "delta": -0.2147
      },
      {
        "periodo": 202604,
        "valor": 13.1603,
        "delta": -0.1937
      },
      {
        "periodo": 202605,
        "valor": 12.952,
        "delta": -0.2083
      },
      {
        "periodo": 202606,
        "valor": 12.7842,
        "delta": -0.1678
      },
      {
        "periodo": 202607,
        "valor": 12.6275,
        "delta": -0.1567
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 11.861392,
    "valor_anterior": 12.052137,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.6588,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.5086,
        "delta": -0.1502
      },
      {
        "periodo": 202509,
        "valor": 13.5893,
        "delta": 0.0807
      },
      {
        "periodo": 202510,
        "valor": 13.4238,
        "delta": -0.1655
      },
      {
        "periodo": 202511,
        "valor": 13.232,
        "delta": -0.1918
      },
      {
        "periodo": 202512,
        "valor": 13.035,
        "delta": -0.197
      },
      {
        "periodo": 202601,
        "valor": 12.8893,
        "delta": -0.1456
      },
      {
        "periodo": 202602,
        "valor": 12.7287,
        "delta": -0.1606
      },
      {
        "periodo": 202603,
        "valor": 12.5516,
        "delta": -0.1771
      },
      {
        "periodo": 202604,
        "valor": 12.4053,
        "delta": -0.1463
      },
      {
        "periodo": 202605,
        "valor": 12.2442,
        "delta": -0.1611
      },
      {
        "periodo": 202606,
        "valor": 12.0521,
        "delta": -0.1921
      },
      {
        "periodo": 202607,
        "valor": 11.8614,
        "delta": -0.1907
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 12.088169,
    "valor_anterior": 12.222906,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14.2566,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14.0886,
        "delta": -0.168
      },
      {
        "periodo": 202509,
        "valor": 13.9022,
        "delta": -0.1865
      },
      {
        "periodo": 202510,
        "valor": 13.6739,
        "delta": -0.2282
      },
      {
        "periodo": 202511,
        "valor": 13.4897,
        "delta": -0.1842
      },
      {
        "periodo": 202512,
        "valor": 13.2986,
        "delta": -0.1911
      },
      {
        "periodo": 202601,
        "valor": 13.1055,
        "delta": -0.1931
      },
      {
        "periodo": 202602,
        "valor": 12.9124,
        "delta": -0.1931
      },
      {
        "periodo": 202603,
        "valor": 12.7398,
        "delta": -0.1726
      },
      {
        "periodo": 202604,
        "valor": 12.5559,
        "delta": -0.1838
      },
      {
        "periodo": 202605,
        "valor": 12.391,
        "delta": -0.165
      },
      {
        "periodo": 202606,
        "valor": 12.2229,
        "delta": -0.1681
      },
      {
        "periodo": 202607,
        "valor": 12.0882,
        "delta": -0.1347
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 16.501847,
    "valor_anterior": 16.689073,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18.936,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18.8177,
        "delta": -0.1183
      },
      {
        "periodo": 202509,
        "valor": 18.6318,
        "delta": -0.1858
      },
      {
        "periodo": 202510,
        "valor": 18.2961,
        "delta": -0.3357
      },
      {
        "periodo": 202511,
        "valor": 18.0919,
        "delta": -0.2042
      },
      {
        "periodo": 202512,
        "valor": 17.8115,
        "delta": -0.2804
      },
      {
        "periodo": 202601,
        "valor": 17.6022,
        "delta": -0.2094
      },
      {
        "periodo": 202602,
        "valor": 17.3019,
        "delta": -0.3003
      },
      {
        "periodo": 202603,
        "valor": 17.143,
        "delta": -0.1589
      },
      {
        "periodo": 202604,
        "valor": 16.9852,
        "delta": -0.1578
      },
      {
        "periodo": 202605,
        "valor": 16.8339,
        "delta": -0.1513
      },
      {
        "periodo": 202606,
        "valor": 16.6891,
        "delta": -0.1448
      },
      {
        "periodo": 202607,
        "valor": 16.5018,
        "delta": -0.1872
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 7.469533,
    "valor_anterior": 7.5251410000000005,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8.4256,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.3642,
        "delta": -0.0614
      },
      {
        "periodo": 202509,
        "valor": 8.3049,
        "delta": -0.0593
      },
      {
        "periodo": 202510,
        "valor": 8.2036,
        "delta": -0.1013
      },
      {
        "periodo": 202511,
        "valor": 8.1471,
        "delta": -0.0565
      },
      {
        "periodo": 202512,
        "valor": 8.0859,
        "delta": -0.0612
      },
      {
        "periodo": 202601,
        "valor": 8.04,
        "delta": -0.0459
      },
      {
        "periodo": 202602,
        "valor": 7.9062,
        "delta": -0.1338
      },
      {
        "periodo": 202603,
        "valor": 7.8634,
        "delta": -0.0428
      },
      {
        "periodo": 202604,
        "valor": 7.781,
        "delta": -0.0824
      },
      {
        "periodo": 202605,
        "valor": 7.6857,
        "delta": -0.0954
      },
      {
        "periodo": 202606,
        "valor": 7.5251,
        "delta": -0.1605
      },
      {
        "periodo": 202607,
        "valor": 7.4695,
        "delta": -0.0556
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 8.401399,
    "valor_anterior": 8.490741,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.8949,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.7482,
        "delta": -0.1466
      },
      {
        "periodo": 202509,
        "valor": 9.5932,
        "delta": -0.1551
      },
      {
        "periodo": 202510,
        "valor": 9.4484,
        "delta": -0.1448
      },
      {
        "periodo": 202511,
        "valor": 9.3112,
        "delta": -0.1372
      },
      {
        "periodo": 202512,
        "valor": 9.1602,
        "delta": -0.1511
      },
      {
        "periodo": 202601,
        "valor": 9.0316,
        "delta": -0.1285
      },
      {
        "periodo": 202602,
        "valor": 8.8944,
        "delta": -0.1373
      },
      {
        "periodo": 202603,
        "valor": 8.8018,
        "delta": -0.0925
      },
      {
        "periodo": 202604,
        "valor": 8.687,
        "delta": -0.1148
      },
      {
        "periodo": 202605,
        "valor": 8.5753,
        "delta": -0.1117
      },
      {
        "periodo": 202606,
        "valor": 8.4907,
        "delta": -0.0845
      },
      {
        "periodo": 202607,
        "valor": 8.4014,
        "delta": -0.0893
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 6.282891,
    "valor_anterior": 6.325603,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7.2055,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7.1313,
        "delta": -0.0742
      },
      {
        "periodo": 202509,
        "valor": 7.0548,
        "delta": -0.0765
      },
      {
        "periodo": 202510,
        "valor": 6.9579,
        "delta": -0.0969
      },
      {
        "periodo": 202511,
        "valor": 6.8789,
        "delta": -0.079
      },
      {
        "periodo": 202512,
        "valor": 6.8067,
        "delta": -0.0722
      },
      {
        "periodo": 202601,
        "valor": 6.7284,
        "delta": -0.0784
      },
      {
        "periodo": 202602,
        "valor": 6.6562,
        "delta": -0.0722
      },
      {
        "periodo": 202603,
        "valor": 6.5892,
        "delta": -0.0669
      },
      {
        "periodo": 202604,
        "valor": 6.4891,
        "delta": -0.1001
      },
      {
        "periodo": 202605,
        "valor": 6.4151,
        "delta": -0.074
      },
      {
        "periodo": 202606,
        "valor": 6.3256,
        "delta": -0.0895
      },
      {
        "periodo": 202607,
        "valor": 6.2829,
        "delta": -0.0427
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 8.353949,
    "valor_anterior": 8.528955,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10.9862,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10.6784,
        "delta": -0.3079
      },
      {
        "periodo": 202509,
        "valor": 10.3869,
        "delta": -0.2914
      },
      {
        "periodo": 202510,
        "valor": 9.8299,
        "delta": -0.5571
      },
      {
        "periodo": 202511,
        "valor": 10.1326,
        "delta": 0.3028
      },
      {
        "periodo": 202512,
        "valor": 10.3926,
        "delta": 0.26
      },
      {
        "periodo": 202601,
        "valor": 10.1702,
        "delta": -0.2224
      },
      {
        "periodo": 202602,
        "valor": 9.9091,
        "delta": -0.261
      },
      {
        "periodo": 202603,
        "valor": 9.6421,
        "delta": -0.267
      },
      {
        "periodo": 202604,
        "valor": 9.1781,
        "delta": -0.4639
      },
      {
        "periodo": 202605,
        "valor": 8.8215,
        "delta": -0.3567
      },
      {
        "periodo": 202606,
        "valor": 8.529,
        "delta": -0.2925
      },
      {
        "periodo": 202607,
        "valor": 8.3539,
        "delta": -0.175
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 7.828229,
    "valor_anterior": 8.04138,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.1189,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.225,
        "delta": 0.106
      },
      {
        "periodo": 202509,
        "valor": 9.2055,
        "delta": -0.0195
      },
      {
        "periodo": 202510,
        "valor": 9.1056,
        "delta": -0.0999
      },
      {
        "periodo": 202511,
        "valor": 9.0585,
        "delta": -0.0472
      },
      {
        "periodo": 202512,
        "valor": 9.0484,
        "delta": -0.01
      },
      {
        "periodo": 202601,
        "valor": 8.8994,
        "delta": -0.1491
      },
      {
        "periodo": 202602,
        "valor": 8.8633,
        "delta": -0.0361
      },
      {
        "periodo": 202603,
        "valor": 8.7364,
        "delta": -0.1269
      },
      {
        "periodo": 202604,
        "valor": 8.4926,
        "delta": -0.2438
      },
      {
        "periodo": 202605,
        "valor": 8.3269,
        "delta": -0.1657
      },
      {
        "periodo": 202606,
        "valor": 8.0414,
        "delta": -0.2855
      },
      {
        "periodo": 202607,
        "valor": 7.8282,
        "delta": -0.2132
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 16.56672,
    "valor_anterior": 14.008129,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19.6831,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17.3129,
        "delta": -2.3702
      },
      {
        "periodo": 202509,
        "valor": 20.974,
        "delta": 3.6611
      },
      {
        "periodo": 202510,
        "valor": 20.106,
        "delta": -0.868
      },
      {
        "periodo": 202511,
        "valor": 18.8412,
        "delta": -1.2649
      },
      {
        "periodo": 202512,
        "valor": 18.5597,
        "delta": -0.2815
      },
      {
        "periodo": 202601,
        "valor": 17.8472,
        "delta": -0.7125
      },
      {
        "periodo": 202602,
        "valor": 18.0818,
        "delta": 0.2346
      },
      {
        "periodo": 202603,
        "valor": 14.1788,
        "delta": -3.903
      },
      {
        "periodo": 202604,
        "valor": 12.2361,
        "delta": -1.9426
      },
      {
        "periodo": 202605,
        "valor": 12.1401,
        "delta": -0.096
      },
      {
        "periodo": 202606,
        "valor": 14.0081,
        "delta": 1.868
      },
      {
        "periodo": 202607,
        "valor": 16.5667,
        "delta": 2.5586
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 5.834308,
    "valor_anterior": 5.877538,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6.5599,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6.4665,
        "delta": -0.0934
      },
      {
        "periodo": 202509,
        "valor": 6.3981,
        "delta": -0.0684
      },
      {
        "periodo": 202510,
        "valor": 6.3512,
        "delta": -0.0469
      },
      {
        "periodo": 202511,
        "valor": 6.2912,
        "delta": -0.06
      },
      {
        "periodo": 202512,
        "valor": 6.2268,
        "delta": -0.0644
      },
      {
        "periodo": 202601,
        "valor": 6.1476,
        "delta": -0.0792
      },
      {
        "periodo": 202602,
        "valor": 6.0887,
        "delta": -0.0589
      },
      {
        "periodo": 202603,
        "valor": 6.0342,
        "delta": -0.0545
      },
      {
        "periodo": 202604,
        "valor": 5.9778,
        "delta": -0.0564
      },
      {
        "periodo": 202605,
        "valor": 5.9141,
        "delta": -0.0637
      },
      {
        "periodo": 202606,
        "valor": 5.8775,
        "delta": -0.0366
      },
      {
        "periodo": 202607,
        "valor": 5.8343,
        "delta": -0.0432
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 35.477801,
    "valor_anterior": 37.420676,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 44.0947,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 44.2407,
        "delta": 0.146
      },
      {
        "periodo": 202509,
        "valor": 43.8701,
        "delta": -0.3706
      },
      {
        "periodo": 202510,
        "valor": 43.2894,
        "delta": -0.5807
      },
      {
        "periodo": 202511,
        "valor": 42.8977,
        "delta": -0.3917
      },
      {
        "periodo": 202512,
        "valor": 42.118,
        "delta": -0.7797
      },
      {
        "periodo": 202601,
        "valor": 41.1045,
        "delta": -1.0135
      },
      {
        "periodo": 202602,
        "valor": 41.7548,
        "delta": 0.6502
      },
      {
        "periodo": 202603,
        "valor": 41.0348,
        "delta": -0.72
      },
      {
        "periodo": 202604,
        "valor": 40.4237,
        "delta": -0.611
      },
      {
        "periodo": 202605,
        "valor": 38.9225,
        "delta": -1.5013
      },
      {
        "periodo": 202606,
        "valor": 37.4207,
        "delta": -1.5018
      },
      {
        "periodo": 202607,
        "valor": 35.4778,
        "delta": -1.9429
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 16.113446,
    "valor_anterior": 16.101044,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 15.3837,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 15.9519,
        "delta": 0.5682
      },
      {
        "periodo": 202604,
        "valor": 16.042,
        "delta": 0.0901
      },
      {
        "periodo": 202605,
        "valor": 16.13,
        "delta": 0.088
      },
      {
        "periodo": 202606,
        "valor": 16.101,
        "delta": -0.0289
      },
      {
        "periodo": 202607,
        "valor": 16.1134,
        "delta": 0.0124
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 25.316113,
    "valor_anterior": 24.255054,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": 16.6472,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 17.2216,
        "delta": 0.5744
      },
      {
        "periodo": 202512,
        "valor": 17.5717,
        "delta": 0.3501
      },
      {
        "periodo": 202601,
        "valor": 18.1083,
        "delta": 0.5366
      },
      {
        "periodo": 202602,
        "valor": 19.2786,
        "delta": 1.1703
      },
      {
        "periodo": 202603,
        "valor": 20.8423,
        "delta": 1.5637
      },
      {
        "periodo": 202604,
        "valor": 22.0158,
        "delta": 1.1734
      },
      {
        "periodo": 202605,
        "valor": 23.2716,
        "delta": 1.2558
      },
      {
        "periodo": 202606,
        "valor": 24.2551,
        "delta": 0.9835
      },
      {
        "periodo": 202607,
        "valor": 25.3161,
        "delta": 1.0611
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 13.800681,
    "valor_anterior": 13.859236999999998,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14.731,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14.6497,
        "delta": -0.0813
      },
      {
        "periodo": 202509,
        "valor": 14.5446,
        "delta": -0.105
      },
      {
        "periodo": 202510,
        "valor": 14.4639,
        "delta": -0.0808
      },
      {
        "periodo": 202511,
        "valor": 14.3864,
        "delta": -0.0775
      },
      {
        "periodo": 202512,
        "valor": 14.2897,
        "delta": -0.0967
      },
      {
        "periodo": 202601,
        "valor": 14.1981,
        "delta": -0.0915
      },
      {
        "periodo": 202602,
        "valor": 14.1191,
        "delta": -0.0791
      },
      {
        "periodo": 202603,
        "valor": 14.0623,
        "delta": -0.0567
      },
      {
        "periodo": 202604,
        "valor": 13.998,
        "delta": -0.0643
      },
      {
        "periodo": 202605,
        "valor": 13.929,
        "delta": -0.069
      },
      {
        "periodo": 202606,
        "valor": 13.8592,
        "delta": -0.0698
      },
      {
        "periodo": 202607,
        "valor": 13.8007,
        "delta": -0.0586
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 12.694124,
    "valor_anterior": 12.756066999999998,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.6199,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.5449,
        "delta": -0.0749
      },
      {
        "periodo": 202509,
        "valor": 13.4667,
        "delta": -0.0782
      },
      {
        "periodo": 202510,
        "valor": 13.3922,
        "delta": -0.0746
      },
      {
        "periodo": 202511,
        "valor": 13.3112,
        "delta": -0.0809
      },
      {
        "periodo": 202512,
        "valor": 13.2018,
        "delta": -0.1094
      },
      {
        "periodo": 202601,
        "valor": 13.1157,
        "delta": -0.0862
      },
      {
        "periodo": 202602,
        "valor": 13.0368,
        "delta": -0.0788
      },
      {
        "periodo": 202603,
        "valor": 12.9648,
        "delta": -0.072
      },
      {
        "periodo": 202604,
        "valor": 12.8969,
        "delta": -0.0679
      },
      {
        "periodo": 202605,
        "valor": 12.8262,
        "delta": -0.0707
      },
      {
        "periodo": 202606,
        "valor": 12.7561,
        "delta": -0.0702
      },
      {
        "periodo": 202607,
        "valor": 12.6941,
        "delta": -0.0619
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 6.792344999999999,
    "valor_anterior": 7.066418,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10.3355,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10.2445,
        "delta": -0.0911
      },
      {
        "periodo": 202509,
        "valor": 8.8582,
        "delta": -1.3863
      },
      {
        "periodo": 202510,
        "valor": 8.6867,
        "delta": -0.1715
      },
      {
        "periodo": 202511,
        "valor": 8.5512,
        "delta": -0.1354
      },
      {
        "periodo": 202512,
        "valor": 8.332,
        "delta": -0.2192
      },
      {
        "periodo": 202601,
        "valor": 8.1162,
        "delta": -0.2159
      },
      {
        "periodo": 202602,
        "valor": 7.9201,
        "delta": -0.1961
      },
      {
        "periodo": 202603,
        "valor": 7.7469,
        "delta": -0.1731
      },
      {
        "periodo": 202604,
        "valor": 7.5271,
        "delta": -0.2198
      },
      {
        "periodo": 202605,
        "valor": 7.2894,
        "delta": -0.2378
      },
      {
        "periodo": 202606,
        "valor": 7.0664,
        "delta": -0.2229
      },
      {
        "periodo": 202607,
        "valor": 6.7923,
        "delta": -0.2741
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 10.603144,
    "valor_anterior": 10.694149999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11.7589,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.5773,
        "delta": -0.1816
      },
      {
        "periodo": 202509,
        "valor": 11.4035,
        "delta": -0.1737
      },
      {
        "periodo": 202510,
        "valor": 11.2464,
        "delta": -0.1572
      },
      {
        "periodo": 202511,
        "valor": 11.1161,
        "delta": -0.1303
      },
      {
        "periodo": 202512,
        "valor": 11.0916,
        "delta": -0.0245
      },
      {
        "periodo": 202601,
        "valor": 10.9933,
        "delta": -0.0983
      },
      {
        "periodo": 202602,
        "valor": 10.9392,
        "delta": -0.0541
      },
      {
        "periodo": 202603,
        "valor": 10.846,
        "delta": -0.0932
      },
      {
        "periodo": 202604,
        "valor": 10.8042,
        "delta": -0.0418
      },
      {
        "periodo": 202605,
        "valor": 10.7656,
        "delta": -0.0386
      },
      {
        "periodo": 202606,
        "valor": 10.6941,
        "delta": -0.0714
      },
      {
        "periodo": 202607,
        "valor": 10.6031,
        "delta": -0.091
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 10.795676,
    "valor_anterior": 10.87317,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.2956,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.1362,
        "delta": -0.1594
      },
      {
        "periodo": 202509,
        "valor": 11.9606,
        "delta": -0.1756
      },
      {
        "periodo": 202510,
        "valor": 11.8377,
        "delta": -0.1229
      },
      {
        "periodo": 202511,
        "valor": 11.7193,
        "delta": -0.1185
      },
      {
        "periodo": 202512,
        "valor": 11.633,
        "delta": -0.0863
      },
      {
        "periodo": 202601,
        "valor": 11.4531,
        "delta": -0.1798
      },
      {
        "periodo": 202602,
        "valor": 11.3121,
        "delta": -0.1411
      },
      {
        "periodo": 202603,
        "valor": 11.2011,
        "delta": -0.1109
      },
      {
        "periodo": 202604,
        "valor": 11.0865,
        "delta": -0.1146
      },
      {
        "periodo": 202605,
        "valor": 10.985,
        "delta": -0.1015
      },
      {
        "periodo": 202606,
        "valor": 10.8732,
        "delta": -0.1118
      },
      {
        "periodo": 202607,
        "valor": 10.7957,
        "delta": -0.0775
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 11.807044999999999,
    "valor_anterior": 11.914627999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.7624,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.6138,
        "delta": -0.1486
      },
      {
        "periodo": 202509,
        "valor": 13.4269,
        "delta": -0.1869
      },
      {
        "periodo": 202510,
        "valor": 13.214,
        "delta": -0.2129
      },
      {
        "periodo": 202511,
        "valor": 13.037,
        "delta": -0.1769
      },
      {
        "periodo": 202512,
        "valor": 12.8812,
        "delta": -0.1558
      },
      {
        "periodo": 202601,
        "valor": 12.6932,
        "delta": -0.188
      },
      {
        "periodo": 202602,
        "valor": 12.5116,
        "delta": -0.1817
      },
      {
        "periodo": 202603,
        "valor": 12.3702,
        "delta": -0.1414
      },
      {
        "periodo": 202604,
        "valor": 12.2179,
        "delta": -0.1523
      },
      {
        "periodo": 202605,
        "valor": 12.0737,
        "delta": -0.1442
      },
      {
        "periodo": 202606,
        "valor": 11.9146,
        "delta": -0.159
      },
      {
        "periodo": 202607,
        "valor": 11.807,
        "delta": -0.1076
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200140,
    "label": "T.I. de Cartera Etapa 1+2",
    "valor_actual": 42.957145000000004,
    "valor_anterior": 43.066359,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 44.5229,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 44.4231,
        "delta": -0.0997
      },
      {
        "periodo": 202509,
        "valor": 44.2813,
        "delta": -0.1418
      },
      {
        "periodo": 202510,
        "valor": 44.1464,
        "delta": -0.1349
      },
      {
        "periodo": 202511,
        "valor": 44.1625,
        "delta": 0.0161
      },
      {
        "periodo": 202512,
        "valor": 44.0119,
        "delta": -0.1506
      },
      {
        "periodo": 202601,
        "valor": 43.8534,
        "delta": -0.1585
      },
      {
        "periodo": 202602,
        "valor": 43.6286,
        "delta": -0.2249
      },
      {
        "periodo": 202603,
        "valor": 43.6754,
        "delta": 0.0468
      },
      {
        "periodo": 202604,
        "valor": 43.507,
        "delta": -0.1684
      },
      {
        "periodo": 202605,
        "valor": 43.2628,
        "delta": -0.2442
      },
      {
        "periodo": 202606,
        "valor": 43.0664,
        "delta": -0.1965
      },
      {
        "periodo": 202607,
        "valor": 42.9571,
        "delta": -0.1092
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 16.409256,
    "valor_anterior": 16.18872,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16.8966,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16.7965,
        "delta": -0.1001
      },
      {
        "periodo": 202509,
        "valor": 16.6397,
        "delta": -0.1568
      },
      {
        "periodo": 202510,
        "valor": 16.8766,
        "delta": 0.2369
      },
      {
        "periodo": 202511,
        "valor": 16.3982,
        "delta": -0.4784
      },
      {
        "periodo": 202512,
        "valor": 16.0252,
        "delta": -0.373
      },
      {
        "periodo": 202601,
        "valor": 16.0374,
        "delta": 0.0122
      },
      {
        "periodo": 202602,
        "valor": 15.5278,
        "delta": -0.5097
      },
      {
        "periodo": 202603,
        "valor": 16.5211,
        "delta": 0.9933
      },
      {
        "periodo": 202604,
        "valor": 16.2209,
        "delta": -0.3002
      },
      {
        "periodo": 202605,
        "valor": 16.2036,
        "delta": -0.0174
      },
      {
        "periodo": 202606,
        "valor": 16.1887,
        "delta": -0.0148
      },
      {
        "periodo": 202607,
        "valor": 16.4093,
        "delta": 0.2205
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 13.12572,
    "valor_anterior": 12.859608,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.7162,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.6198,
        "delta": -0.0965
      },
      {
        "periodo": 202509,
        "valor": 13.313,
        "delta": -0.3068
      },
      {
        "periodo": 202510,
        "valor": 13.7493,
        "delta": 0.4364
      },
      {
        "periodo": 202511,
        "valor": 13.1803,
        "delta": -0.569
      },
      {
        "periodo": 202512,
        "valor": 13.2841,
        "delta": 0.1038
      },
      {
        "periodo": 202601,
        "valor": 13.3271,
        "delta": 0.043
      },
      {
        "periodo": 202602,
        "valor": 12.2889,
        "delta": -1.0382
      },
      {
        "periodo": 202603,
        "valor": 13.4553,
        "delta": 1.1664
      },
      {
        "periodo": 202604,
        "valor": 12.9759,
        "delta": -0.4794
      },
      {
        "periodo": 202605,
        "valor": 13.1639,
        "delta": 0.188
      },
      {
        "periodo": 202606,
        "valor": 12.8596,
        "delta": -0.3042
      },
      {
        "periodo": 202607,
        "valor": 13.1257,
        "delta": 0.2661
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 12.702347999999999,
    "valor_anterior": 12.350796,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.8908,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.7174,
        "delta": -0.1734
      },
      {
        "periodo": 202509,
        "valor": 13.3062,
        "delta": -0.4112
      },
      {
        "periodo": 202510,
        "valor": 13.6035,
        "delta": 0.2973
      },
      {
        "periodo": 202511,
        "valor": 13.0511,
        "delta": -0.5524
      },
      {
        "periodo": 202512,
        "valor": 13.169,
        "delta": 0.1179
      },
      {
        "periodo": 202601,
        "valor": 12.9155,
        "delta": -0.2535
      },
      {
        "periodo": 202602,
        "valor": 11.9496,
        "delta": -0.9659
      },
      {
        "periodo": 202603,
        "valor": 12.6046,
        "delta": 0.655
      },
      {
        "periodo": 202604,
        "valor": 12.723,
        "delta": 0.1183
      },
      {
        "periodo": 202605,
        "valor": 12.7897,
        "delta": 0.0668
      },
      {
        "periodo": 202606,
        "valor": 12.3508,
        "delta": -0.4389
      },
      {
        "periodo": 202607,
        "valor": 12.7023,
        "delta": 0.3516
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 12.212304,
    "valor_anterior": 11.771436,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.2376,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.0969,
        "delta": -0.1406
      },
      {
        "periodo": 202509,
        "valor": 12.8084,
        "delta": -0.2885
      },
      {
        "periodo": 202510,
        "valor": 13.0483,
        "delta": 0.2399
      },
      {
        "periodo": 202511,
        "valor": 12.6226,
        "delta": -0.4257
      },
      {
        "periodo": 202512,
        "valor": 12.7881,
        "delta": 0.1655
      },
      {
        "periodo": 202601,
        "valor": 12.5465,
        "delta": -0.2416
      },
      {
        "periodo": 202602,
        "valor": 11.8149,
        "delta": -0.7316
      },
      {
        "periodo": 202603,
        "valor": 12.5742,
        "delta": 0.7593
      },
      {
        "periodo": 202604,
        "valor": 12.2905,
        "delta": -0.2838
      },
      {
        "periodo": 202605,
        "valor": 12.3655,
        "delta": 0.075
      },
      {
        "periodo": 202606,
        "valor": 11.7714,
        "delta": -0.594
      },
      {
        "periodo": 202607,
        "valor": 12.2123,
        "delta": 0.4409
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 10.118556,
    "valor_anterior": 9.908688,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11.6423,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.4688,
        "delta": -0.1735
      },
      {
        "periodo": 202509,
        "valor": 11.0141,
        "delta": -0.4547
      },
      {
        "periodo": 202510,
        "valor": 11.3073,
        "delta": 0.2932
      },
      {
        "periodo": 202511,
        "valor": 10.724,
        "delta": -0.5833
      },
      {
        "periodo": 202512,
        "valor": 10.9209,
        "delta": 0.1969
      },
      {
        "periodo": 202601,
        "valor": 10.6598,
        "delta": -0.2611
      },
      {
        "periodo": 202602,
        "valor": 9.6018,
        "delta": -1.058
      },
      {
        "periodo": 202603,
        "valor": 10.5756,
        "delta": 0.9738
      },
      {
        "periodo": 202604,
        "valor": 10.1488,
        "delta": -0.4269
      },
      {
        "periodo": 202605,
        "valor": 10.4011,
        "delta": 0.2523
      },
      {
        "periodo": 202606,
        "valor": 9.9087,
        "delta": -0.4924
      },
      {
        "periodo": 202607,
        "valor": 10.1186,
        "delta": 0.2099
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 10.53738,
    "valor_anterior": 10.141284,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11.9253,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.5894,
        "delta": -0.3359
      },
      {
        "periodo": 202509,
        "valor": 11.1909,
        "delta": -0.3984
      },
      {
        "periodo": 202510,
        "valor": 11.6103,
        "delta": 0.4194
      },
      {
        "periodo": 202511,
        "valor": 10.9023,
        "delta": -0.708
      },
      {
        "periodo": 202512,
        "valor": 9.9862,
        "delta": -0.9161
      },
      {
        "periodo": 202601,
        "valor": 10.8254,
        "delta": 0.8392
      },
      {
        "periodo": 202602,
        "valor": 9.6532,
        "delta": -1.1722
      },
      {
        "periodo": 202603,
        "valor": 11.3087,
        "delta": 1.6555
      },
      {
        "periodo": 202604,
        "valor": 10.3577,
        "delta": -0.951
      },
      {
        "periodo": 202605,
        "valor": 10.7272,
        "delta": 0.3694
      },
      {
        "periodo": 202606,
        "valor": 10.1413,
        "delta": -0.5859
      },
      {
        "periodo": 202607,
        "valor": 10.5374,
        "delta": 0.3961
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 14.067336,
    "valor_anterior": 12.83688,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10.5441,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10.3897,
        "delta": -0.1544
      },
      {
        "periodo": 202509,
        "valor": 9.9996,
        "delta": -0.3901
      },
      {
        "periodo": 202510,
        "valor": 14.6845,
        "delta": 4.685
      },
      {
        "periodo": 202511,
        "valor": 14.6147,
        "delta": -0.0698
      },
      {
        "periodo": 202512,
        "valor": 20.6926,
        "delta": 6.0779
      },
      {
        "periodo": 202601,
        "valor": 10.2099,
        "delta": -10.4827
      },
      {
        "periodo": 202602,
        "valor": 13.5712,
        "delta": 3.3613
      },
      {
        "periodo": 202603,
        "valor": 14.5929,
        "delta": 1.0217
      },
      {
        "periodo": 202604,
        "valor": 13.8237,
        "delta": -0.7692
      },
      {
        "periodo": 202605,
        "valor": 14.9113,
        "delta": 1.0876
      },
      {
        "periodo": 202606,
        "valor": 12.8369,
        "delta": -2.0744
      },
      {
        "periodo": 202607,
        "valor": 14.0673,
        "delta": 1.2305
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 10.765632,
    "valor_anterior": 10.456584,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11.2653,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.2425,
        "delta": -0.0228
      },
      {
        "periodo": 202509,
        "valor": 10.8934,
        "delta": -0.3491
      },
      {
        "periodo": 202510,
        "valor": 11.0893,
        "delta": 0.1959
      },
      {
        "periodo": 202511,
        "valor": 10.7126,
        "delta": -0.3767
      },
      {
        "periodo": 202512,
        "valor": 10.9398,
        "delta": 0.2272
      },
      {
        "periodo": 202601,
        "valor": 10.9881,
        "delta": 0.0483
      },
      {
        "periodo": 202602,
        "valor": 9.9665,
        "delta": -1.0216
      },
      {
        "periodo": 202603,
        "valor": 10.806,
        "delta": 0.8395
      },
      {
        "periodo": 202604,
        "valor": 10.5195,
        "delta": -0.2865
      },
      {
        "periodo": 202605,
        "valor": 10.7308,
        "delta": 0.2113
      },
      {
        "periodo": 202606,
        "valor": 10.4566,
        "delta": -0.2742
      },
      {
        "periodo": 202607,
        "valor": 10.7656,
        "delta": 0.309
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 10.855176,
    "valor_anterior": 10.495668,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.3996,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.2413,
        "delta": -0.1584
      },
      {
        "periodo": 202509,
        "valor": 11.7643,
        "delta": -0.477
      },
      {
        "periodo": 202510,
        "valor": 12.0556,
        "delta": 0.2913
      },
      {
        "periodo": 202511,
        "valor": 11.5049,
        "delta": -0.5507
      },
      {
        "periodo": 202512,
        "valor": 11.8097,
        "delta": 0.3049
      },
      {
        "periodo": 202601,
        "valor": 11.5302,
        "delta": -0.2795
      },
      {
        "periodo": 202602,
        "valor": 9.8962,
        "delta": -1.634
      },
      {
        "periodo": 202603,
        "valor": 11.1089,
        "delta": 1.2126
      },
      {
        "periodo": 202604,
        "valor": 10.8166,
        "delta": -0.2922
      },
      {
        "periodo": 202605,
        "valor": 10.9238,
        "delta": 0.1071
      },
      {
        "periodo": 202606,
        "valor": 10.4957,
        "delta": -0.4281
      },
      {
        "periodo": 202607,
        "valor": 10.8552,
        "delta": 0.3595
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 18.767471999999998,
    "valor_anterior": 19.120812,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19.5747,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17.9094,
        "delta": -1.6652
      },
      {
        "periodo": 202509,
        "valor": 19.757,
        "delta": 1.8476
      },
      {
        "periodo": 202510,
        "valor": 19.5329,
        "delta": -0.2241
      },
      {
        "periodo": 202511,
        "valor": 18.8958,
        "delta": -0.6371
      },
      {
        "periodo": 202512,
        "valor": 19.4736,
        "delta": 0.5778
      },
      {
        "periodo": 202601,
        "valor": 18.6522,
        "delta": -0.8214
      },
      {
        "periodo": 202602,
        "valor": 18.9261,
        "delta": 0.2739
      },
      {
        "periodo": 202603,
        "valor": 18.2694,
        "delta": -0.6568
      },
      {
        "periodo": 202604,
        "valor": 20.256,
        "delta": 1.9867
      },
      {
        "periodo": 202605,
        "valor": 18.4823,
        "delta": -1.7737
      },
      {
        "periodo": 202606,
        "valor": 19.1208,
        "delta": 0.6385
      },
      {
        "periodo": 202607,
        "valor": 18.7675,
        "delta": -0.3533
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 10.557108,
    "valor_anterior": 10.907627999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.594,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.883,
        "delta": -0.711
      },
      {
        "periodo": 202509,
        "valor": 12.7182,
        "delta": 0.8351
      },
      {
        "periodo": 202510,
        "valor": 12.0535,
        "delta": -0.6647
      },
      {
        "periodo": 202511,
        "valor": 10.9239,
        "delta": -1.1296
      },
      {
        "periodo": 202512,
        "valor": 12.5311,
        "delta": 1.6072
      },
      {
        "periodo": 202601,
        "valor": 11.1095,
        "delta": -1.4216
      },
      {
        "periodo": 202602,
        "valor": 10.6259,
        "delta": -0.4836
      },
      {
        "periodo": 202603,
        "valor": 11.18,
        "delta": 0.5541
      },
      {
        "periodo": 202604,
        "valor": 10.7586,
        "delta": -0.4214
      },
      {
        "periodo": 202605,
        "valor": 10.9139,
        "delta": 0.1553
      },
      {
        "periodo": 202606,
        "valor": 10.9076,
        "delta": -0.0063
      },
      {
        "periodo": 202607,
        "valor": 10.5571,
        "delta": -0.3505
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 14.095920000000001,
    "valor_anterior": 13.444872,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14.5902,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14.5413,
        "delta": -0.0489
      },
      {
        "periodo": 202509,
        "valor": 14.1264,
        "delta": -0.4149
      },
      {
        "periodo": 202510,
        "valor": 14.4151,
        "delta": 0.2887
      },
      {
        "periodo": 202511,
        "valor": 14.1558,
        "delta": -0.2593
      },
      {
        "periodo": 202512,
        "valor": 14.3239,
        "delta": 0.1681
      },
      {
        "periodo": 202601,
        "valor": 14.228,
        "delta": -0.0959
      },
      {
        "periodo": 202602,
        "valor": 12.937,
        "delta": -1.2909
      },
      {
        "periodo": 202603,
        "valor": 14.2355,
        "delta": 1.2985
      },
      {
        "periodo": 202604,
        "valor": 13.8628,
        "delta": -0.3727
      },
      {
        "periodo": 202605,
        "valor": 14.3479,
        "delta": 0.4851
      },
      {
        "periodo": 202606,
        "valor": 13.4449,
        "delta": -0.9031
      },
      {
        "periodo": 202607,
        "valor": 14.0959,
        "delta": 0.651
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 11.815176,
    "valor_anterior": 11.808708,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.5133,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.4884,
        "delta": -0.0249
      },
      {
        "periodo": 202509,
        "valor": 12.1722,
        "delta": -0.3162
      },
      {
        "periodo": 202510,
        "valor": 12.2462,
        "delta": 0.074
      },
      {
        "periodo": 202511,
        "valor": 11.976,
        "delta": -0.2702
      },
      {
        "periodo": 202512,
        "valor": 12.0115,
        "delta": 0.0355
      },
      {
        "periodo": 202601,
        "valor": 12.0495,
        "delta": 0.0379
      },
      {
        "periodo": 202602,
        "valor": 11.6093,
        "delta": -0.4401
      },
      {
        "periodo": 202603,
        "valor": 12.0322,
        "delta": 0.4229
      },
      {
        "periodo": 202604,
        "valor": 11.8635,
        "delta": -0.1686
      },
      {
        "periodo": 202605,
        "valor": 12.0397,
        "delta": 0.1761
      },
      {
        "periodo": 202606,
        "valor": 11.8087,
        "delta": -0.231
      },
      {
        "periodo": 202607,
        "valor": 11.8152,
        "delta": 0.0065
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 7.406016,
    "valor_anterior": 7.439844,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.1305,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.7244,
        "delta": -0.4061
      },
      {
        "periodo": 202509,
        "valor": 8.4137,
        "delta": -0.3107
      },
      {
        "periodo": 202510,
        "valor": 8.5815,
        "delta": 0.1678
      },
      {
        "periodo": 202511,
        "valor": 8.1285,
        "delta": -0.453
      },
      {
        "periodo": 202512,
        "valor": 8.4357,
        "delta": 0.3072
      },
      {
        "periodo": 202601,
        "valor": 7.8448,
        "delta": -0.5909
      },
      {
        "periodo": 202602,
        "valor": 7.203,
        "delta": -0.6417
      },
      {
        "periodo": 202603,
        "valor": 7.9779,
        "delta": 0.7748
      },
      {
        "periodo": 202604,
        "valor": 7.6654,
        "delta": -0.3125
      },
      {
        "periodo": 202605,
        "valor": 7.772,
        "delta": 0.1066
      },
      {
        "periodo": 202606,
        "valor": 7.4398,
        "delta": -0.3321
      },
      {
        "periodo": 202607,
        "valor": 7.406,
        "delta": -0.0338
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 6.689796,
    "valor_anterior": 6.039996,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6.9832,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6.64,
        "delta": -0.3432
      },
      {
        "periodo": 202509,
        "valor": 6.8877,
        "delta": 0.2477
      },
      {
        "periodo": 202510,
        "valor": 6.4888,
        "delta": -0.399
      },
      {
        "periodo": 202511,
        "valor": 6.3053,
        "delta": -0.1835
      },
      {
        "periodo": 202512,
        "valor": 6.2518,
        "delta": -0.0535
      },
      {
        "periodo": 202601,
        "valor": 6.6956,
        "delta": 0.4438
      },
      {
        "periodo": 202602,
        "valor": 6.1459,
        "delta": -0.5497
      },
      {
        "periodo": 202603,
        "valor": 5.9654,
        "delta": -0.1805
      },
      {
        "periodo": 202604,
        "valor": 5.6386,
        "delta": -0.3268
      },
      {
        "periodo": 202605,
        "valor": 6.4067,
        "delta": 0.7681
      },
      {
        "periodo": 202606,
        "valor": 6.04,
        "delta": -0.3667
      },
      {
        "periodo": 202607,
        "valor": 6.6898,
        "delta": 0.6498
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 7.85946,
    "valor_anterior": 7.5917639999999995,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.1,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.3786,
        "delta": -0.7214
      },
      {
        "periodo": 202509,
        "valor": 7.0732,
        "delta": -1.3054
      },
      {
        "periodo": 202510,
        "valor": 8.4913,
        "delta": 1.4181
      },
      {
        "periodo": 202511,
        "valor": 8.1331,
        "delta": -0.3582
      },
      {
        "periodo": 202512,
        "valor": 8.2858,
        "delta": 0.1527
      },
      {
        "periodo": 202601,
        "valor": 8.045,
        "delta": -0.2408
      },
      {
        "periodo": 202602,
        "valor": 7.2709,
        "delta": -0.7741
      },
      {
        "periodo": 202603,
        "valor": 8.0822,
        "delta": 0.8113
      },
      {
        "periodo": 202604,
        "valor": 7.8285,
        "delta": -0.2537
      },
      {
        "periodo": 202605,
        "valor": 7.9292,
        "delta": 0.1007
      },
      {
        "periodo": 202606,
        "valor": 7.5918,
        "delta": -0.3374
      },
      {
        "periodo": 202607,
        "valor": 7.8595,
        "delta": 0.2677
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 7.823856,
    "valor_anterior": 7.743144,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8.7897,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.8429,
        "delta": 0.0532
      },
      {
        "periodo": 202509,
        "valor": 8.4518,
        "delta": -0.3912
      },
      {
        "periodo": 202510,
        "valor": 8.759,
        "delta": 0.3072
      },
      {
        "periodo": 202511,
        "valor": 8.3847,
        "delta": -0.3742
      },
      {
        "periodo": 202512,
        "valor": 8.1048,
        "delta": -0.2799
      },
      {
        "periodo": 202601,
        "valor": 8.3232,
        "delta": 0.2184
      },
      {
        "periodo": 202602,
        "valor": 7.4542,
        "delta": -0.8691
      },
      {
        "periodo": 202603,
        "valor": 8.4035,
        "delta": 0.9493
      },
      {
        "periodo": 202604,
        "valor": 7.7494,
        "delta": -0.654
      },
      {
        "periodo": 202605,
        "valor": 7.9849,
        "delta": 0.2355
      },
      {
        "periodo": 202606,
        "valor": 7.7431,
        "delta": -0.2418
      },
      {
        "periodo": 202607,
        "valor": 7.8239,
        "delta": 0.0807
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 9.740172,
    "valor_anterior": 9.673344,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11.4742,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.2993,
        "delta": -0.1749
      },
      {
        "periodo": 202509,
        "valor": 10.6643,
        "delta": -0.635
      },
      {
        "periodo": 202510,
        "valor": 10.8983,
        "delta": 0.234
      },
      {
        "periodo": 202511,
        "valor": 10.5455,
        "delta": -0.3528
      },
      {
        "periodo": 202512,
        "valor": 10.5952,
        "delta": 0.0498
      },
      {
        "periodo": 202601,
        "valor": 10.3039,
        "delta": -0.2913
      },
      {
        "periodo": 202602,
        "valor": 9.6366,
        "delta": -0.6673
      },
      {
        "periodo": 202603,
        "valor": 10.2959,
        "delta": 0.6593
      },
      {
        "periodo": 202604,
        "valor": 9.8561,
        "delta": -0.4398
      },
      {
        "periodo": 202605,
        "valor": 9.9597,
        "delta": 0.1036
      },
      {
        "periodo": 202606,
        "valor": 9.6733,
        "delta": -0.2864
      },
      {
        "periodo": 202607,
        "valor": 9.7402,
        "delta": 0.0668
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 7.460364,
    "valor_anterior": 6.788460000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8.7702,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.6186,
        "delta": -0.1515
      },
      {
        "periodo": 202509,
        "valor": 8.1205,
        "delta": -0.4981
      },
      {
        "periodo": 202510,
        "valor": 8.3261,
        "delta": 0.2056
      },
      {
        "periodo": 202511,
        "valor": 7.29,
        "delta": -1.0362
      },
      {
        "periodo": 202512,
        "valor": 8.2008,
        "delta": 0.9109
      },
      {
        "periodo": 202601,
        "valor": 7.7823,
        "delta": -0.4186
      },
      {
        "periodo": 202602,
        "valor": 6.74,
        "delta": -1.0423
      },
      {
        "periodo": 202603,
        "valor": 7.5661,
        "delta": 0.8261
      },
      {
        "periodo": 202604,
        "valor": 7.0803,
        "delta": -0.4858
      },
      {
        "periodo": 202605,
        "valor": 7.4481,
        "delta": 0.3679
      },
      {
        "periodo": 202606,
        "valor": 6.7885,
        "delta": -0.6597
      },
      {
        "periodo": 202607,
        "valor": 7.4604,
        "delta": 0.6719
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 51.190248000000004,
    "valor_anterior": 48.767544,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 51.2033,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 51.5908,
        "delta": 0.3875
      },
      {
        "periodo": 202509,
        "valor": 49.3341,
        "delta": -2.2567
      },
      {
        "periodo": 202510,
        "valor": 50.7501,
        "delta": 1.416
      },
      {
        "periodo": 202511,
        "valor": 50.2803,
        "delta": -0.4698
      },
      {
        "periodo": 202512,
        "valor": 51.0479,
        "delta": 0.7677
      },
      {
        "periodo": 202601,
        "valor": 51.0561,
        "delta": 0.0081
      },
      {
        "periodo": 202602,
        "valor": 45.773,
        "delta": -5.2831
      },
      {
        "periodo": 202603,
        "valor": 50.7573,
        "delta": 4.9843
      },
      {
        "periodo": 202604,
        "valor": 49.2778,
        "delta": -1.4795
      },
      {
        "periodo": 202605,
        "valor": 50.2025,
        "delta": 0.9248
      },
      {
        "periodo": 202606,
        "valor": 48.7675,
        "delta": -1.435
      },
      {
        "periodo": 202607,
        "valor": 51.1902,
        "delta": 2.4227
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 12.358668,
    "valor_anterior": 11.222412,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16.1634,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21.5856,
        "delta": 5.4223
      },
      {
        "periodo": 202509,
        "valor": 17.1009,
        "delta": -4.4847
      },
      {
        "periodo": 202510,
        "valor": 13.2994,
        "delta": -3.8016
      },
      {
        "periodo": 202511,
        "valor": 12.5798,
        "delta": -0.7195
      },
      {
        "periodo": 202512,
        "valor": 12.8119,
        "delta": 0.232
      },
      {
        "periodo": 202601,
        "valor": 13.326,
        "delta": 0.5142
      },
      {
        "periodo": 202602,
        "valor": 12.2614,
        "delta": -1.0647
      },
      {
        "periodo": 202603,
        "valor": 13.3912,
        "delta": 1.1299
      },
      {
        "periodo": 202604,
        "valor": 13.6464,
        "delta": 0.2552
      },
      {
        "periodo": 202605,
        "valor": 12.8559,
        "delta": -0.7905
      },
      {
        "periodo": 202606,
        "valor": 11.2224,
        "delta": -1.6335
      },
      {
        "periodo": 202607,
        "valor": 12.3587,
        "delta": 1.1363
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 65.213184,
    "valor_anterior": 63.43092,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 64.8085,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 65.3849,
        "delta": 0.5764
      },
      {
        "periodo": 202509,
        "valor": 63.2574,
        "delta": -2.1275
      },
      {
        "periodo": 202510,
        "valor": 64.0937,
        "delta": 0.8363
      },
      {
        "periodo": 202511,
        "valor": 62.8072,
        "delta": -1.2865
      },
      {
        "periodo": 202512,
        "valor": 64.5928,
        "delta": 1.7855
      },
      {
        "periodo": 202601,
        "valor": 63.3667,
        "delta": -1.2261
      },
      {
        "periodo": 202602,
        "valor": 60.2085,
        "delta": -3.1581
      },
      {
        "periodo": 202603,
        "valor": 64.5259,
        "delta": 4.3173
      },
      {
        "periodo": 202604,
        "valor": 63.4839,
        "delta": -1.042
      },
      {
        "periodo": 202605,
        "valor": 64.6407,
        "delta": 1.1568
      },
      {
        "periodo": 202606,
        "valor": 63.4309,
        "delta": -1.2098
      },
      {
        "periodo": 202607,
        "valor": 65.2132,
        "delta": 1.7823
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 10.77162,
    "valor_anterior": 10.512576,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.6978,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.4467,
        "delta": -0.2511
      },
      {
        "periodo": 202509,
        "valor": 11.691,
        "delta": -0.7557
      },
      {
        "periodo": 202510,
        "valor": 12.3067,
        "delta": 0.6158
      },
      {
        "periodo": 202511,
        "valor": 11.6991,
        "delta": -0.6077
      },
      {
        "periodo": 202512,
        "valor": 11.5985,
        "delta": -0.1006
      },
      {
        "periodo": 202601,
        "valor": 11.3673,
        "delta": -0.2312
      },
      {
        "periodo": 202602,
        "valor": 10.511,
        "delta": -0.8563
      },
      {
        "periodo": 202603,
        "valor": 11.7437,
        "delta": 1.2327
      },
      {
        "periodo": 202604,
        "valor": 11.2116,
        "delta": -0.5321
      },
      {
        "periodo": 202605,
        "valor": 11.0329,
        "delta": -0.1787
      },
      {
        "periodo": 202606,
        "valor": 10.5126,
        "delta": -0.5203
      },
      {
        "periodo": 202607,
        "valor": 10.7716,
        "delta": 0.259
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 9.908628,
    "valor_anterior": 9.377352,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11.6758,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.4569,
        "delta": -0.2189
      },
      {
        "periodo": 202509,
        "valor": 10.9789,
        "delta": -0.478
      },
      {
        "periodo": 202510,
        "valor": 11.2217,
        "delta": 0.2428
      },
      {
        "periodo": 202511,
        "valor": 10.4938,
        "delta": -0.7279
      },
      {
        "periodo": 202512,
        "valor": 10.7079,
        "delta": 0.2141
      },
      {
        "periodo": 202601,
        "valor": 10.4875,
        "delta": -0.2204
      },
      {
        "periodo": 202602,
        "valor": 9.3957,
        "delta": -1.0918
      },
      {
        "periodo": 202603,
        "valor": 10.223,
        "delta": 0.8273
      },
      {
        "periodo": 202604,
        "valor": 9.8374,
        "delta": -0.3857
      },
      {
        "periodo": 202605,
        "valor": 10.1301,
        "delta": 0.2928
      },
      {
        "periodo": 202606,
        "valor": 9.3774,
        "delta": -0.7528
      },
      {
        "periodo": 202607,
        "valor": 9.9086,
        "delta": 0.5313
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 6.259752000000001,
    "valor_anterior": 7.3790640000000005,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.9081,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10.7865,
        "delta": 0.8784
      },
      {
        "periodo": 202509,
        "valor": 10.2451,
        "delta": -0.5414
      },
      {
        "periodo": 202510,
        "valor": 7.9743,
        "delta": -2.2708
      },
      {
        "periodo": 202511,
        "valor": 83.7666,
        "delta": 75.7923
      },
      {
        "periodo": 202512,
        "valor": 19.8603,
        "delta": -63.9063
      },
      {
        "periodo": 202601,
        "valor": 8.3781,
        "delta": -11.4822
      },
      {
        "periodo": 202602,
        "valor": 15.6983,
        "delta": 7.3203
      },
      {
        "periodo": 202603,
        "valor": 8.1309,
        "delta": -7.5674
      },
      {
        "periodo": 202604,
        "valor": 8.0649,
        "delta": -0.066
      },
      {
        "periodo": 202605,
        "valor": 6.6853,
        "delta": -1.3797
      },
      {
        "periodo": 202606,
        "valor": 7.3791,
        "delta": 0.6938
      },
      {
        "periodo": 202607,
        "valor": 6.2598,
        "delta": -1.1193
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 20.026512,
    "valor_anterior": 19.767444,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20.8662,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 19.7062,
        "delta": -1.1601
      },
      {
        "periodo": 202509,
        "valor": 18.9983,
        "delta": -0.7079
      },
      {
        "periodo": 202510,
        "valor": 20.6054,
        "delta": 1.6071
      },
      {
        "periodo": 202511,
        "valor": 22.0721,
        "delta": 1.4667
      },
      {
        "periodo": 202512,
        "valor": 20.0958,
        "delta": -1.9763
      },
      {
        "periodo": 202601,
        "valor": 19.8785,
        "delta": -0.2173
      },
      {
        "periodo": 202602,
        "valor": 19.474,
        "delta": -0.4045
      },
      {
        "periodo": 202603,
        "valor": 20.3825,
        "delta": 0.9085
      },
      {
        "periodo": 202604,
        "valor": 19.3873,
        "delta": -0.9952
      },
      {
        "periodo": 202605,
        "valor": 20.2216,
        "delta": 0.8343
      },
      {
        "periodo": 202606,
        "valor": 19.7674,
        "delta": -0.4541
      },
      {
        "periodo": 202607,
        "valor": 20.0265,
        "delta": 0.2591
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 29.292432,
    "valor_anterior": 28.720871999999996,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28.7391,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 30.7588,
        "delta": 2.0197
      },
      {
        "periodo": 202509,
        "valor": 30.9447,
        "delta": 0.186
      },
      {
        "periodo": 202510,
        "valor": 33.9995,
        "delta": 3.0548
      },
      {
        "periodo": 202511,
        "valor": 33.0101,
        "delta": -0.9895
      },
      {
        "periodo": 202512,
        "valor": 33.1646,
        "delta": 0.1546
      },
      {
        "periodo": 202601,
        "valor": 34.1403,
        "delta": 0.9757
      },
      {
        "periodo": 202602,
        "valor": 30.8587,
        "delta": -3.2815
      },
      {
        "periodo": 202603,
        "valor": 32.6601,
        "delta": 1.8013
      },
      {
        "periodo": 202604,
        "valor": 28.7426,
        "delta": -3.9174
      },
      {
        "periodo": 202605,
        "valor": 28.6027,
        "delta": -0.14
      },
      {
        "periodo": 202606,
        "valor": 28.7209,
        "delta": 0.1182
      },
      {
        "periodo": 202607,
        "valor": 29.2924,
        "delta": 0.5716
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 8.495352,
    "valor_anterior": 7.883052,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.7952,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.5527,
        "delta": -0.2425
      },
      {
        "periodo": 202509,
        "valor": 9.0919,
        "delta": -0.4608
      },
      {
        "periodo": 202510,
        "valor": 9.1643,
        "delta": 0.0724
      },
      {
        "periodo": 202511,
        "valor": 31.1305,
        "delta": 21.9662
      },
      {
        "periodo": 202512,
        "valor": 8.6184,
        "delta": -22.512
      },
      {
        "periodo": 202601,
        "valor": 8.4285,
        "delta": -0.1899
      },
      {
        "periodo": 202602,
        "valor": 7.5732,
        "delta": -0.8553
      },
      {
        "periodo": 202603,
        "valor": 8.3535,
        "delta": 0.7803
      },
      {
        "periodo": 202604,
        "valor": 7.9201,
        "delta": -0.4334
      },
      {
        "periodo": 202605,
        "valor": 7.349,
        "delta": -0.5711
      },
      {
        "periodo": 202606,
        "valor": 7.8831,
        "delta": 0.5341
      },
      {
        "periodo": 202607,
        "valor": 8.4954,
        "delta": 0.6123
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 28.194804,
    "valor_anterior": 28.039236000000002,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 28.5023,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 28.3603,
        "delta": -0.142
      },
      {
        "periodo": 202509,
        "valor": 28.1918,
        "delta": -0.1685
      },
      {
        "periodo": 202510,
        "valor": 28.4649,
        "delta": 0.2732
      },
      {
        "periodo": 202511,
        "valor": 28.4386,
        "delta": -0.0264
      },
      {
        "periodo": 202512,
        "valor": 28.8549,
        "delta": 0.4163
      },
      {
        "periodo": 202601,
        "valor": 28.8685,
        "delta": 0.0137
      },
      {
        "periodo": 202602,
        "valor": 27.585,
        "delta": -1.2835
      },
      {
        "periodo": 202603,
        "valor": 28.1266,
        "delta": 0.5416
      },
      {
        "periodo": 202604,
        "valor": 28.2583,
        "delta": 0.1317
      },
      {
        "periodo": 202605,
        "valor": 28.1688,
        "delta": -0.0895
      },
      {
        "periodo": 202606,
        "valor": 28.0392,
        "delta": -0.1296
      },
      {
        "periodo": 202607,
        "valor": 28.1948,
        "delta": 0.1556
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 14.957064,
    "valor_anterior": 15.200159999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15.8198,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16.2701,
        "delta": 0.4503
      },
      {
        "periodo": 202509,
        "valor": 16.1873,
        "delta": -0.0828
      },
      {
        "periodo": 202510,
        "valor": 15.8597,
        "delta": -0.3276
      },
      {
        "periodo": 202511,
        "valor": 15.7037,
        "delta": -0.156
      },
      {
        "periodo": 202512,
        "valor": 3.6713,
        "delta": -12.0325
      },
      {
        "periodo": 202601,
        "valor": 15.197,
        "delta": 11.5257
      },
      {
        "periodo": 202602,
        "valor": 15.3794,
        "delta": 0.1824
      },
      {
        "periodo": 202603,
        "valor": 15.1529,
        "delta": -0.2265
      },
      {
        "periodo": 202604,
        "valor": 15.1494,
        "delta": -0.0035
      },
      {
        "periodo": 202605,
        "valor": 15.2914,
        "delta": 0.142
      },
      {
        "periodo": 202606,
        "valor": 15.2002,
        "delta": -0.0912
      },
      {
        "periodo": 202607,
        "valor": 14.9571,
        "delta": -0.2431
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.7958,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7.6266,
        "delta": -5.1692
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 9.138492,
    "valor_anterior": 8.789676,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10.3979,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10.3806,
        "delta": -0.0173
      },
      {
        "periodo": 202509,
        "valor": 9.9798,
        "delta": -0.4008
      },
      {
        "periodo": 202510,
        "valor": 10.181,
        "delta": 0.2013
      },
      {
        "periodo": 202511,
        "valor": 9.6266,
        "delta": -0.5544
      },
      {
        "periodo": 202512,
        "valor": 9.972,
        "delta": 0.3454
      },
      {
        "periodo": 202601,
        "valor": 9.6103,
        "delta": -0.3617
      },
      {
        "periodo": 202602,
        "valor": 8.6374,
        "delta": -0.9729
      },
      {
        "periodo": 202603,
        "valor": 9.6249,
        "delta": 0.9875
      },
      {
        "periodo": 202604,
        "valor": 9.123,
        "delta": -0.5019
      },
      {
        "periodo": 202605,
        "valor": 9.3153,
        "delta": 0.1923
      },
      {
        "periodo": 202606,
        "valor": 8.7897,
        "delta": -0.5256
      },
      {
        "periodo": 202607,
        "valor": 9.1385,
        "delta": 0.3488
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 14.36172,
    "valor_anterior": 13.305527999999999,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16.7815,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16.3668,
        "delta": -0.4148
      },
      {
        "periodo": 202509,
        "valor": 15.1935,
        "delta": -1.1732
      },
      {
        "periodo": 202510,
        "valor": 15.8283,
        "delta": 0.6347
      },
      {
        "periodo": 202511,
        "valor": 15.1995,
        "delta": -0.6288
      },
      {
        "periodo": 202512,
        "valor": 15.6671,
        "delta": 0.4676
      },
      {
        "periodo": 202601,
        "valor": 15.2838,
        "delta": -0.3833
      },
      {
        "periodo": 202602,
        "valor": 13.6681,
        "delta": -1.6157
      },
      {
        "periodo": 202603,
        "valor": 15.184,
        "delta": 1.5158
      },
      {
        "periodo": 202604,
        "valor": 14.7795,
        "delta": -0.4044
      },
      {
        "periodo": 202605,
        "valor": 14.6364,
        "delta": -0.1431
      },
      {
        "periodo": 202606,
        "valor": 13.3055,
        "delta": -1.3309
      },
      {
        "periodo": 202607,
        "valor": 14.3617,
        "delta": 1.0562
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 81.361284,
    "valor_anterior": 78.135216,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 80.1912,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 82.0303,
        "delta": 1.8391
      },
      {
        "periodo": 202509,
        "valor": 80.4144,
        "delta": -1.6159
      },
      {
        "periodo": 202510,
        "valor": 83.2309,
        "delta": 2.8165
      },
      {
        "periodo": 202511,
        "valor": 81.0061,
        "delta": -2.2248
      },
      {
        "periodo": 202512,
        "valor": 83.6952,
        "delta": 2.6891
      },
      {
        "periodo": 202601,
        "valor": 82.4769,
        "delta": -1.2183
      },
      {
        "periodo": 202602,
        "valor": 75.3616,
        "delta": -7.1153
      },
      {
        "periodo": 202603,
        "valor": 79.5788,
        "delta": 4.2172
      },
      {
        "periodo": 202604,
        "valor": 82.3531,
        "delta": 2.7743
      },
      {
        "periodo": 202605,
        "valor": 81.4057,
        "delta": -0.9474
      },
      {
        "periodo": 202606,
        "valor": 78.1352,
        "delta": -3.2705
      },
      {
        "periodo": 202607,
        "valor": 81.3613,
        "delta": 3.2261
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 12.270324,
    "valor_anterior": 12.000024,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14.0456,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.7122,
        "delta": -0.3334
      },
      {
        "periodo": 202509,
        "valor": 13.0376,
        "delta": -0.6746
      },
      {
        "periodo": 202510,
        "valor": 13.527,
        "delta": 0.4894
      },
      {
        "periodo": 202511,
        "valor": 12.8076,
        "delta": -0.7195
      },
      {
        "periodo": 202512,
        "valor": 13.1623,
        "delta": 0.3547
      },
      {
        "periodo": 202601,
        "valor": 12.9323,
        "delta": -0.2299
      },
      {
        "periodo": 202602,
        "valor": 11.5706,
        "delta": -1.3618
      },
      {
        "periodo": 202603,
        "valor": 12.806,
        "delta": 1.2355
      },
      {
        "periodo": 202604,
        "valor": 12.25,
        "delta": -0.556
      },
      {
        "periodo": 202605,
        "valor": 12.4664,
        "delta": 0.2164
      },
      {
        "periodo": 202606,
        "valor": 12.0,
        "delta": -0.4664
      },
      {
        "periodo": 202607,
        "valor": 12.2703,
        "delta": 0.2703
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 11.1018,
    "valor_anterior": 10.802340000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.1325,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12.3588,
        "delta": -0.7737
      },
      {
        "periodo": 202509,
        "valor": 12.9456,
        "delta": 0.5868
      },
      {
        "periodo": 202510,
        "valor": 12.441,
        "delta": -0.5046
      },
      {
        "periodo": 202511,
        "valor": 12.0321,
        "delta": -0.4089
      },
      {
        "periodo": 202512,
        "valor": 12.1544,
        "delta": 0.1223
      },
      {
        "periodo": 202601,
        "valor": 11.6413,
        "delta": -0.5132
      },
      {
        "periodo": 202602,
        "valor": 10.6438,
        "delta": -0.9975
      },
      {
        "periodo": 202603,
        "valor": 11.721,
        "delta": 1.0772
      },
      {
        "periodo": 202604,
        "valor": 11.3502,
        "delta": -0.3708
      },
      {
        "periodo": 202605,
        "valor": 11.0221,
        "delta": -0.3281
      },
      {
        "periodo": 202606,
        "valor": 10.8023,
        "delta": -0.2197
      },
      {
        "periodo": 202607,
        "valor": 11.1018,
        "delta": 0.2995
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 11.6148,
    "valor_anterior": 11.265564,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.3131,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.2755,
        "delta": -0.0376
      },
      {
        "periodo": 202509,
        "valor": 12.5845,
        "delta": -0.691
      },
      {
        "periodo": 202510,
        "valor": 13.2165,
        "delta": 0.632
      },
      {
        "periodo": 202511,
        "valor": 12.5557,
        "delta": -0.6608
      },
      {
        "periodo": 202512,
        "valor": 12.4982,
        "delta": -0.0575
      },
      {
        "periodo": 202601,
        "valor": 12.3217,
        "delta": -0.1765
      },
      {
        "periodo": 202602,
        "valor": 11.1665,
        "delta": -1.1552
      },
      {
        "periodo": 202603,
        "valor": 12.1452,
        "delta": 0.9786
      },
      {
        "periodo": 202604,
        "valor": 11.5738,
        "delta": -0.5713
      },
      {
        "periodo": 202605,
        "valor": 11.897,
        "delta": 0.3232
      },
      {
        "periodo": 202606,
        "valor": 11.2656,
        "delta": -0.6315
      },
      {
        "periodo": 202607,
        "valor": 11.6148,
        "delta": 0.3492
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 16.346928,
    "valor_anterior": 15.550452,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18.5795,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18.3034,
        "delta": -0.2761
      },
      {
        "periodo": 202509,
        "valor": 17.2264,
        "delta": -1.077
      },
      {
        "periodo": 202510,
        "valor": 17.8477,
        "delta": 0.6213
      },
      {
        "periodo": 202511,
        "valor": 16.9585,
        "delta": -0.8892
      },
      {
        "periodo": 202512,
        "valor": 17.2044,
        "delta": 0.2459
      },
      {
        "periodo": 202601,
        "valor": 16.8976,
        "delta": -0.3068
      },
      {
        "periodo": 202602,
        "valor": 15.2751,
        "delta": -1.6226
      },
      {
        "periodo": 202603,
        "valor": 16.8547,
        "delta": 1.5796
      },
      {
        "periodo": 202604,
        "valor": 16.095,
        "delta": -0.7598
      },
      {
        "periodo": 202605,
        "valor": 16.5488,
        "delta": 0.4539
      },
      {
        "periodo": 202606,
        "valor": 15.5505,
        "delta": -0.9984
      },
      {
        "periodo": 202607,
        "valor": 16.3469,
        "delta": 0.7965
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 7.117248,
    "valor_anterior": 6.737940000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8.3961,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8.6749,
        "delta": 0.2788
      },
      {
        "periodo": 202509,
        "valor": 8.1382,
        "delta": -0.5367
      },
      {
        "periodo": 202510,
        "valor": 8.3061,
        "delta": 0.1679
      },
      {
        "periodo": 202511,
        "valor": 7.7601,
        "delta": -0.5459
      },
      {
        "periodo": 202512,
        "valor": 7.4245,
        "delta": -0.3356
      },
      {
        "periodo": 202601,
        "valor": 7.744,
        "delta": 0.3194
      },
      {
        "periodo": 202602,
        "valor": 6.4398,
        "delta": -1.3042
      },
      {
        "periodo": 202603,
        "valor": 7.3768,
        "delta": 0.937
      },
      {
        "periodo": 202604,
        "valor": 7.0796,
        "delta": -0.2972
      },
      {
        "periodo": 202605,
        "valor": 7.3694,
        "delta": 0.2898
      },
      {
        "periodo": 202606,
        "valor": 6.7379,
        "delta": -0.6315
      },
      {
        "periodo": 202607,
        "valor": 7.1172,
        "delta": 0.3793
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 8.176260000000001,
    "valor_anterior": 8.004492,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.3832,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.1744,
        "delta": -0.2088
      },
      {
        "periodo": 202509,
        "valor": 8.7929,
        "delta": -0.3815
      },
      {
        "periodo": 202510,
        "valor": 9.0457,
        "delta": 0.2528
      },
      {
        "periodo": 202511,
        "valor": 8.4947,
        "delta": -0.5511
      },
      {
        "periodo": 202512,
        "valor": 8.6828,
        "delta": 0.1881
      },
      {
        "periodo": 202601,
        "valor": 8.4869,
        "delta": -0.1959
      },
      {
        "periodo": 202602,
        "valor": 7.6461,
        "delta": -0.8408
      },
      {
        "periodo": 202603,
        "valor": 8.5133,
        "delta": 0.8672
      },
      {
        "periodo": 202604,
        "valor": 8.1663,
        "delta": -0.347
      },
      {
        "periodo": 202605,
        "valor": 8.2495,
        "delta": 0.0832
      },
      {
        "periodo": 202606,
        "valor": 8.0045,
        "delta": -0.245
      },
      {
        "periodo": 202607,
        "valor": 8.1763,
        "delta": 0.1718
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 6.2513760000000005,
    "valor_anterior": 5.9707799999999995,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7.1134,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6.8677,
        "delta": -0.2456
      },
      {
        "periodo": 202509,
        "valor": 6.5982,
        "delta": -0.2696
      },
      {
        "periodo": 202510,
        "valor": 6.4981,
        "delta": -0.1001
      },
      {
        "periodo": 202511,
        "valor": 6.3219,
        "delta": -0.1761
      },
      {
        "periodo": 202512,
        "valor": 6.4053,
        "delta": 0.0834
      },
      {
        "periodo": 202601,
        "valor": 6.2817,
        "delta": -0.1236
      },
      {
        "periodo": 202602,
        "valor": 5.5867,
        "delta": -0.695
      },
      {
        "periodo": 202603,
        "valor": 6.2483,
        "delta": 0.6616
      },
      {
        "periodo": 202604,
        "valor": 5.7761,
        "delta": -0.4722
      },
      {
        "periodo": 202605,
        "valor": 6.0865,
        "delta": 0.3104
      },
      {
        "periodo": 202606,
        "valor": 5.9708,
        "delta": -0.1157
      },
      {
        "periodo": 202607,
        "valor": 6.2514,
        "delta": 0.2806
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 7.410156,
    "valor_anterior": 7.180644,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.3202,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.6602,
        "delta": 0.34
      },
      {
        "periodo": 202509,
        "valor": 8.9503,
        "delta": -0.7099
      },
      {
        "periodo": 202510,
        "valor": 9.3593,
        "delta": 0.409
      },
      {
        "periodo": 202511,
        "valor": 11.1523,
        "delta": 1.793
      },
      {
        "periodo": 202512,
        "valor": 8.3922,
        "delta": -2.7601
      },
      {
        "periodo": 202601,
        "valor": 7.9614,
        "delta": -0.4308
      },
      {
        "periodo": 202602,
        "valor": 6.8014,
        "delta": -1.16
      },
      {
        "periodo": 202603,
        "valor": 7.6232,
        "delta": 0.8218
      },
      {
        "periodo": 202604,
        "valor": 9.1257,
        "delta": 1.5024
      },
      {
        "periodo": 202605,
        "valor": 7.6788,
        "delta": -1.4469
      },
      {
        "periodo": 202606,
        "valor": 7.1806,
        "delta": -0.4981
      },
      {
        "periodo": 202607,
        "valor": 7.4102,
        "delta": 0.2295
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 7.403316,
    "valor_anterior": 7.061256,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.2601,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.8638,
        "delta": 0.6037
      },
      {
        "periodo": 202509,
        "valor": 8.5938,
        "delta": -1.2699
      },
      {
        "periodo": 202510,
        "valor": 8.8882,
        "delta": 0.2943
      },
      {
        "periodo": 202511,
        "valor": 8.2971,
        "delta": -0.591
      },
      {
        "periodo": 202512,
        "valor": 8.4541,
        "delta": 0.1569
      },
      {
        "periodo": 202601,
        "valor": 8.0554,
        "delta": -0.3987
      },
      {
        "periodo": 202602,
        "valor": 7.3547,
        "delta": -0.7007
      },
      {
        "periodo": 202603,
        "valor": 7.8225,
        "delta": 0.4678
      },
      {
        "periodo": 202604,
        "valor": 7.2463,
        "delta": -0.5762
      },
      {
        "periodo": 202605,
        "valor": 7.5021,
        "delta": 0.2558
      },
      {
        "periodo": 202606,
        "valor": 7.0613,
        "delta": -0.4409
      },
      {
        "periodo": 202607,
        "valor": 7.4033,
        "delta": 0.3421
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 118.08657600000001,
    "valor_anterior": 51.682368000000004,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3.8147,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.032,
        "delta": 5.2173
      },
      {
        "periodo": 202509,
        "valor": 26.7124,
        "delta": 17.6804
      },
      {
        "periodo": 202510,
        "valor": 25.5937,
        "delta": -1.1187
      },
      {
        "periodo": 202511,
        "valor": 25.2386,
        "delta": -0.3551
      },
      {
        "periodo": 202512,
        "valor": 13.3746,
        "delta": -11.864
      },
      {
        "periodo": 202601,
        "valor": 69.3031,
        "delta": 55.9285
      },
      {
        "periodo": 202602,
        "valor": 98.4612,
        "delta": 29.1582
      },
      {
        "periodo": 202603,
        "valor": 4.6224,
        "delta": -93.8388
      },
      {
        "periodo": 202604,
        "valor": 5.8154,
        "delta": 1.193
      },
      {
        "periodo": 202605,
        "valor": 9.4714,
        "delta": 3.6559
      },
      {
        "periodo": 202606,
        "valor": 51.6824,
        "delta": 42.211
      },
      {
        "periodo": 202607,
        "valor": 118.0866,
        "delta": 66.4042
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 5.70348,
    "valor_anterior": 5.636232,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6.2454,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6.2321,
        "delta": -0.0133
      },
      {
        "periodo": 202509,
        "valor": 6.0637,
        "delta": -0.1684
      },
      {
        "periodo": 202510,
        "valor": 6.3921,
        "delta": 0.3284
      },
      {
        "periodo": 202511,
        "valor": 5.8855,
        "delta": -0.5066
      },
      {
        "periodo": 202512,
        "valor": 5.7637,
        "delta": -0.1218
      },
      {
        "periodo": 202601,
        "valor": 5.6527,
        "delta": -0.111
      },
      {
        "periodo": 202602,
        "valor": 5.1821,
        "delta": -0.4706
      },
      {
        "periodo": 202603,
        "valor": 6.0865,
        "delta": 0.9044
      },
      {
        "periodo": 202604,
        "valor": 5.3261,
        "delta": -0.7605
      },
      {
        "periodo": 202605,
        "valor": 5.687,
        "delta": 0.3609
      },
      {
        "periodo": 202606,
        "valor": 5.6362,
        "delta": -0.0508
      },
      {
        "periodo": 202607,
        "valor": 5.7035,
        "delta": 0.0672
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 24.354048,
    "valor_anterior": 23.284908,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 35.691,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 33.443,
        "delta": -2.2481
      },
      {
        "periodo": 202509,
        "valor": 31.195,
        "delta": -2.248
      },
      {
        "periodo": 202510,
        "valor": 31.1984,
        "delta": 0.0034
      },
      {
        "periodo": 202511,
        "valor": 28.9636,
        "delta": -2.2348
      },
      {
        "periodo": 202512,
        "valor": 27.9925,
        "delta": -0.9711
      },
      {
        "periodo": 202601,
        "valor": 26.8846,
        "delta": -1.1079
      },
      {
        "periodo": 202602,
        "valor": 23.1906,
        "delta": -3.6941
      },
      {
        "periodo": 202603,
        "valor": 24.9286,
        "delta": 1.738
      },
      {
        "periodo": 202604,
        "valor": 23.7713,
        "delta": -1.1573
      },
      {
        "periodo": 202605,
        "valor": 24.3247,
        "delta": 0.5534
      },
      {
        "periodo": 202606,
        "valor": 23.2849,
        "delta": -1.0398
      },
      {
        "periodo": 202607,
        "valor": 24.354,
        "delta": 1.0691
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 16.26774,
    "valor_anterior": 16.071504,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 30.7675,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 16.6851,
        "delta": -14.0824
      },
      {
        "periodo": 202604,
        "valor": 16.281,
        "delta": -0.404
      },
      {
        "periodo": 202605,
        "valor": 16.4591,
        "delta": 0.1781
      },
      {
        "periodo": 202606,
        "valor": 16.0715,
        "delta": -0.3876
      },
      {
        "periodo": 202607,
        "valor": 16.2677,
        "delta": 0.1962
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 30.466968,
    "valor_anterior": 29.480028000000004,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 15.802,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18.8188,
        "delta": 3.0167
      },
      {
        "periodo": 202509,
        "valor": 23.381,
        "delta": 4.5623
      },
      {
        "periodo": 202510,
        "valor": 24.7002,
        "delta": 1.3191
      },
      {
        "periodo": 202511,
        "valor": 20.4963,
        "delta": -4.2039
      },
      {
        "periodo": 202512,
        "valor": 19.7444,
        "delta": -0.7519
      },
      {
        "periodo": 202601,
        "valor": 21.1482,
        "delta": 1.4038
      },
      {
        "periodo": 202602,
        "valor": 26.7198,
        "delta": 5.5716
      },
      {
        "periodo": 202603,
        "valor": 30.8292,
        "delta": 4.1094
      },
      {
        "periodo": 202604,
        "valor": 28.4729,
        "delta": -2.3564
      },
      {
        "periodo": 202605,
        "valor": 30.5438,
        "delta": 2.0709
      },
      {
        "periodo": 202606,
        "valor": 29.48,
        "delta": -1.0637
      },
      {
        "periodo": 202607,
        "valor": 30.467,
        "delta": 0.9869
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 9.7983,
    "valor_anterior": 7.970436,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 2.7912,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 2.1008,
        "delta": -0.6904
      },
      {
        "periodo": 202602,
        "valor": 2.0078,
        "delta": -0.093
      },
      {
        "periodo": 202603,
        "valor": 2.6,
        "delta": 0.5923
      },
      {
        "periodo": 202604,
        "valor": 3.9716,
        "delta": 1.3716
      },
      {
        "periodo": 202605,
        "valor": 5.9997,
        "delta": 2.0281
      },
      {
        "periodo": 202606,
        "valor": 7.9704,
        "delta": 1.9707
      },
      {
        "periodo": 202607,
        "valor": 9.7983,
        "delta": 1.8279
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 42.987936,
    "valor_anterior": 41.792868,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 41.5542,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": 42.7201,
        "delta": 1.1659
      },
      {
        "periodo": 202606,
        "valor": 41.7929,
        "delta": -0.9272
      },
      {
        "periodo": 202607,
        "valor": 42.9879,
        "delta": 1.1951
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 13.766016,
    "valor_anterior": 13.422719999999998,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14.4775,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14.3998,
        "delta": -0.0777
      },
      {
        "periodo": 202509,
        "valor": 13.8175,
        "delta": -0.5823
      },
      {
        "periodo": 202510,
        "valor": 14.396,
        "delta": 0.5785
      },
      {
        "periodo": 202511,
        "valor": 13.9253,
        "delta": -0.4707
      },
      {
        "periodo": 202512,
        "valor": 14.02,
        "delta": 0.0947
      },
      {
        "periodo": 202601,
        "valor": 13.8728,
        "delta": -0.1473
      },
      {
        "periodo": 202602,
        "valor": 12.9411,
        "delta": -0.9317
      },
      {
        "periodo": 202603,
        "valor": 14.1382,
        "delta": 1.1971
      },
      {
        "periodo": 202604,
        "valor": 13.6413,
        "delta": -0.4969
      },
      {
        "periodo": 202605,
        "valor": 13.8256,
        "delta": 0.1843
      },
      {
        "periodo": 202606,
        "valor": 13.4227,
        "delta": -0.4029
      },
      {
        "periodo": 202607,
        "valor": 13.766,
        "delta": 0.3433
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 12.62076,
    "valor_anterior": 12.369900000000001,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13.3812,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.2698,
        "delta": -0.1114
      },
      {
        "periodo": 202509,
        "valor": 12.9511,
        "delta": -0.3187
      },
      {
        "periodo": 202510,
        "valor": 13.2459,
        "delta": 0.2948
      },
      {
        "periodo": 202511,
        "valor": 12.7653,
        "delta": -0.4806
      },
      {
        "periodo": 202512,
        "valor": 12.7576,
        "delta": -0.0077
      },
      {
        "periodo": 202601,
        "valor": 12.7923,
        "delta": 0.0346
      },
      {
        "periodo": 202602,
        "valor": 11.9404,
        "delta": -0.8519
      },
      {
        "periodo": 202603,
        "valor": 12.8522,
        "delta": 0.9119
      },
      {
        "periodo": 202604,
        "valor": 12.5362,
        "delta": -0.316
      },
      {
        "periodo": 202605,
        "valor": 12.6951,
        "delta": 0.1589
      },
      {
        "periodo": 202606,
        "valor": 12.3699,
        "delta": -0.3252
      },
      {
        "periodo": 202607,
        "valor": 12.6208,
        "delta": 0.2509
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 8.01366,
    "valor_anterior": 7.891884,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9.8324,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9.1907,
        "delta": -0.6417
      },
      {
        "periodo": 202509,
        "valor": -11.9311,
        "delta": -21.1218
      },
      {
        "periodo": 202510,
        "valor": 8.9674,
        "delta": 20.8985
      },
      {
        "periodo": 202511,
        "valor": 9.0245,
        "delta": 0.057
      },
      {
        "periodo": 202512,
        "valor": 8.4053,
        "delta": -0.6191
      },
      {
        "periodo": 202601,
        "valor": 8.4964,
        "delta": 0.0911
      },
      {
        "periodo": 202602,
        "valor": 7.6409,
        "delta": -0.8556
      },
      {
        "periodo": 202603,
        "valor": 8.5681,
        "delta": 0.9272
      },
      {
        "periodo": 202604,
        "valor": 7.9353,
        "delta": -0.6327
      },
      {
        "periodo": 202605,
        "valor": 8.1683,
        "delta": 0.233
      },
      {
        "periodo": 202606,
        "valor": 7.8919,
        "delta": -0.2764
      },
      {
        "periodo": 202607,
        "valor": 8.0137,
        "delta": 0.1218
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 10.540175999999999,
    "valor_anterior": 10.200384,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11.283,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10.9509,
        "delta": -0.3321
      },
      {
        "periodo": 202509,
        "valor": 10.8282,
        "delta": -0.1227
      },
      {
        "periodo": 202510,
        "valor": 11.0868,
        "delta": 0.2586
      },
      {
        "periodo": 202511,
        "valor": 10.4427,
        "delta": -0.6441
      },
      {
        "periodo": 202512,
        "valor": 11.026,
        "delta": 0.5833
      },
      {
        "periodo": 202601,
        "valor": 10.6368,
        "delta": -0.3893
      },
      {
        "periodo": 202602,
        "valor": 9.8688,
        "delta": -0.768
      },
      {
        "periodo": 202603,
        "valor": 10.5174,
        "delta": 0.6485
      },
      {
        "periodo": 202604,
        "valor": 10.4809,
        "delta": -0.0365
      },
      {
        "periodo": 202605,
        "valor": 10.6018,
        "delta": 0.1209
      },
      {
        "periodo": 202606,
        "valor": 10.2004,
        "delta": -0.4014
      },
      {
        "periodo": 202607,
        "valor": 10.5402,
        "delta": 0.3398
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 10.517724000000001,
    "valor_anterior": 10.172904,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11.511,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11.3311,
        "delta": -0.1799
      },
      {
        "periodo": 202509,
        "valor": 10.846,
        "delta": -0.4851
      },
      {
        "periodo": 202510,
        "valor": 11.6281,
        "delta": 0.782
      },
      {
        "periodo": 202511,
        "valor": 11.1297,
        "delta": -0.4984
      },
      {
        "periodo": 202512,
        "valor": 11.9565,
        "delta": 0.8268
      },
      {
        "periodo": 202601,
        "valor": 10.5877,
        "delta": -1.3689
      },
      {
        "periodo": 202602,
        "valor": 9.966,
        "delta": -0.6217
      },
      {
        "periodo": 202603,
        "valor": 10.9875,
        "delta": 1.0215
      },
      {
        "periodo": 202604,
        "valor": 10.5484,
        "delta": -0.4391
      },
      {
        "periodo": 202605,
        "valor": 10.7749,
        "delta": 0.2265
      },
      {
        "periodo": 202606,
        "valor": 10.1729,
        "delta": -0.602
      },
      {
        "periodo": 202607,
        "valor": 10.5177,
        "delta": 0.3448
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 11.424660000000001,
    "valor_anterior": 10.952088,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12.9632,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13.0739,
        "delta": 0.1107
      },
      {
        "periodo": 202509,
        "valor": 12.6498,
        "delta": -0.4241
      },
      {
        "periodo": 202510,
        "valor": 12.5947,
        "delta": -0.0551
      },
      {
        "periodo": 202511,
        "valor": 11.9701,
        "delta": -0.6246
      },
      {
        "periodo": 202512,
        "valor": 12.3276,
        "delta": 0.3575
      },
      {
        "periodo": 202601,
        "valor": 12.0419,
        "delta": -0.2857
      },
      {
        "periodo": 202602,
        "valor": 10.9851,
        "delta": -1.0569
      },
      {
        "periodo": 202603,
        "valor": 12.0078,
        "delta": 1.0227
      },
      {
        "periodo": 202604,
        "valor": 11.6424,
        "delta": -0.3653
      },
      {
        "periodo": 202605,
        "valor": 11.6831,
        "delta": 0.0406
      },
      {
        "periodo": 202606,
        "valor": 10.9521,
        "delta": -0.731
      },
      {
        "periodo": 202607,
        "valor": 11.4247,
        "delta": 0.4726
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200162,
    "label": "Tasa Implícita Anualizada de Cartera Etapa 1+2",
    "valor_actual": 43.132416,
    "valor_anterior": 41.618304,
    "tipo": "porcentaje",
    "es_pp": true,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 44.9384,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 44.8733,
        "delta": -0.0652
      },
      {
        "periodo": 202509,
        "valor": 42.8497,
        "delta": -2.0236
      },
      {
        "periodo": 202510,
        "valor": 44.04,
        "delta": 1.1903
      },
      {
        "periodo": 202511,
        "valor": 43.885,
        "delta": -0.1551
      },
      {
        "periodo": 202512,
        "valor": 43.907,
        "delta": 0.022
      },
      {
        "periodo": 202601,
        "valor": 43.8388,
        "delta": -0.0681
      },
      {
        "periodo": 202602,
        "valor": 40.2164,
        "delta": -3.6225
      },
      {
        "periodo": 202603,
        "valor": 46.1135,
        "delta": 5.8971
      },
      {
        "periodo": 202604,
        "valor": 41.9536,
        "delta": -4.1599
      },
      {
        "periodo": 202605,
        "valor": 42.6826,
        "delta": 0.7291
      },
      {
        "periodo": 202606,
        "valor": 41.6183,
        "delta": -1.0643
      },
      {
        "periodo": 202607,
        "valor": 43.1324,
        "delta": 1.5141
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 82500932663.5,
    "valor_anterior": 81955225196.6,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 82853146687.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 81711068608.58,
        "delta": -1142078078.69
      },
      {
        "periodo": 202509,
        "valor": 80742665676.67,
        "delta": -968402931.91
      },
      {
        "periodo": 202510,
        "valor": 79802580168.25,
        "delta": -940085508.42
      },
      {
        "periodo": 202511,
        "valor": 78975763467.71,
        "delta": -826816700.54
      },
      {
        "periodo": 202512,
        "valor": 79260308667.44,
        "delta": 284545199.73
      },
      {
        "periodo": 202601,
        "valor": 79579032200.48,
        "delta": 318723533.04
      },
      {
        "periodo": 202602,
        "valor": 80061190808.53,
        "delta": 482158608.05
      },
      {
        "periodo": 202603,
        "valor": 80715462421.97,
        "delta": 654271613.44
      },
      {
        "periodo": 202604,
        "valor": 81102019946.42,
        "delta": 386557524.45
      },
      {
        "periodo": 202605,
        "valor": 81455444596.51,
        "delta": 353424650.09
      },
      {
        "periodo": 202606,
        "valor": 81955225196.6,
        "delta": 499780600.09
      },
      {
        "periodo": 202607,
        "valor": 82500932663.5,
        "delta": 545707466.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 270778679957.16,
    "valor_anterior": 269733122463.78,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 264786145979.14,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 265146644080.9,
        "delta": 360498101.76
      },
      {
        "periodo": 202509,
        "valor": 265649292635.88,
        "delta": 502648554.98
      },
      {
        "periodo": 202510,
        "valor": 266200507338.4,
        "delta": 551214702.52
      },
      {
        "periodo": 202511,
        "valor": 266130684411.87,
        "delta": -69822926.53
      },
      {
        "periodo": 202512,
        "valor": 266172927172.36,
        "delta": 42242760.49
      },
      {
        "periodo": 202601,
        "valor": 266488283179.51,
        "delta": 315356007.15
      },
      {
        "periodo": 202602,
        "valor": 266621349061.9,
        "delta": 133065882.39
      },
      {
        "periodo": 202603,
        "valor": 267361321295.38,
        "delta": 739972233.4799
      },
      {
        "periodo": 202604,
        "valor": 268125741830.32,
        "delta": 764420534.94
      },
      {
        "periodo": 202605,
        "valor": 268891400297.92,
        "delta": 765658467.6
      },
      {
        "periodo": 202606,
        "valor": 269733122463.78,
        "delta": 841722165.86
      },
      {
        "periodo": 202607,
        "valor": 270778679957.16,
        "delta": 1045557493.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 121345941207.0,
    "valor_anterior": 121602325909.00002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 127765831021.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 127369445856.0,
        "delta": -396385165.0
      },
      {
        "periodo": 202509,
        "valor": 126680180371.0,
        "delta": -689265485.0
      },
      {
        "periodo": 202510,
        "valor": 126015446495.0,
        "delta": -664733876.0
      },
      {
        "periodo": 202511,
        "valor": 125217645874.0,
        "delta": -797800621.0
      },
      {
        "periodo": 202512,
        "valor": 124582888068.0,
        "delta": -634757806.0
      },
      {
        "periodo": 202601,
        "valor": 123941288227.0,
        "delta": -641599841.0
      },
      {
        "periodo": 202602,
        "valor": 123472330611.0,
        "delta": -468957616.0
      },
      {
        "periodo": 202603,
        "valor": 122792013223.0,
        "delta": -680317388.0
      },
      {
        "periodo": 202604,
        "valor": 122424485147.0,
        "delta": -367528076.0
      },
      {
        "periodo": 202605,
        "valor": 121978714395.0,
        "delta": -445770752.0
      },
      {
        "periodo": 202606,
        "valor": 121602325909.0,
        "delta": -376388486.0
      },
      {
        "periodo": 202607,
        "valor": 121345941207.0,
        "delta": -256384702.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 56965183919.0,
    "valor_anterior": 57877837991.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 66835245873.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 66351858053.0,
        "delta": -483387820.0
      },
      {
        "periodo": 202509,
        "valor": 65773195183.0,
        "delta": -578662870.0
      },
      {
        "periodo": 202510,
        "valor": 65142706064.0,
        "delta": -630489119.0
      },
      {
        "periodo": 202511,
        "valor": 64396471345.0,
        "delta": -746234719.0
      },
      {
        "periodo": 202512,
        "valor": 63604532241.0,
        "delta": -791939104.0
      },
      {
        "periodo": 202601,
        "valor": 62735918349.0,
        "delta": -868613892.0
      },
      {
        "periodo": 202602,
        "valor": 61861464227.0,
        "delta": -874454122.0
      },
      {
        "periodo": 202603,
        "valor": 60865084727.0,
        "delta": -996379500.0
      },
      {
        "periodo": 202604,
        "valor": 59856546840.11,
        "delta": -1008537886.89
      },
      {
        "periodo": 202605,
        "valor": 58901313358.0,
        "delta": -955233482.11
      },
      {
        "periodo": 202606,
        "valor": 57877837991.0,
        "delta": -1023475367.0
      },
      {
        "periodo": 202607,
        "valor": 56965183919.0,
        "delta": -912654072.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 28979573120.739998,
    "valor_anterior": 29041274308.79,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 32578348719.01,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 32278463389.09,
        "delta": -299885329.92
      },
      {
        "periodo": 202509,
        "valor": 31950122703.48,
        "delta": -328340685.61
      },
      {
        "periodo": 202510,
        "valor": 31603913052.59,
        "delta": -346209650.89
      },
      {
        "periodo": 202511,
        "valor": 31219141050.19,
        "delta": -384772002.4
      },
      {
        "periodo": 202512,
        "valor": 30810098850.28,
        "delta": -409042199.91
      },
      {
        "periodo": 202601,
        "valor": 30390525920.48,
        "delta": -419572929.8
      },
      {
        "periodo": 202602,
        "valor": 30000999787.14,
        "delta": -389526133.34
      },
      {
        "periodo": 202603,
        "valor": 29684959229.99,
        "delta": -316040557.15
      },
      {
        "periodo": 202604,
        "valor": 29419251074.98,
        "delta": -265708155.01
      },
      {
        "periodo": 202605,
        "valor": 29192809398.56,
        "delta": -226441676.42
      },
      {
        "periodo": 202606,
        "valor": 29041274308.79,
        "delta": -151535089.77
      },
      {
        "periodo": 202607,
        "valor": 28979573120.74,
        "delta": -61701188.05
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 50773084545.0,
    "valor_anterior": 51017049255.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 55354987635.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55040774411.0,
        "delta": -314213224.0
      },
      {
        "periodo": 202509,
        "valor": 54740399186.0,
        "delta": -300375225.0
      },
      {
        "periodo": 202510,
        "valor": 54543841982.0,
        "delta": -196557204.0
      },
      {
        "periodo": 202511,
        "valor": 54186911747.0,
        "delta": -356930235.0
      },
      {
        "periodo": 202512,
        "valor": 53269486935.0,
        "delta": -917424812.0
      },
      {
        "periodo": 202601,
        "valor": 52803702230.0,
        "delta": -465784705.0
      },
      {
        "periodo": 202602,
        "valor": 52327567593.0,
        "delta": -476134637.0
      },
      {
        "periodo": 202603,
        "valor": 51920119401.0,
        "delta": -407448192.0
      },
      {
        "periodo": 202604,
        "valor": 51611379128.0,
        "delta": -308740273.0
      },
      {
        "periodo": 202605,
        "valor": 51138564888.0,
        "delta": -472814240.0
      },
      {
        "periodo": 202606,
        "valor": 51017049255.0,
        "delta": -121515633.0
      },
      {
        "periodo": 202607,
        "valor": 50773084545.0,
        "delta": -243964710.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 12153221313.999998,
    "valor_anterior": 11765062899.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8780679551.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8736817903.0,
        "delta": -43861648.0
      },
      {
        "periodo": 202509,
        "valor": 8682169955.0,
        "delta": -54647948.0
      },
      {
        "periodo": 202510,
        "valor": 8941096363.0,
        "delta": 258926408.0
      },
      {
        "periodo": 202511,
        "valor": 9246359675.0,
        "delta": 305263312.0
      },
      {
        "periodo": 202512,
        "valor": 10015110790.0,
        "delta": 768751115.0
      },
      {
        "periodo": 202601,
        "valor": 9989148918.0,
        "delta": -25961872.0
      },
      {
        "periodo": 202602,
        "valor": 10319427539.0,
        "delta": 330278621.0
      },
      {
        "periodo": 202603,
        "valor": 10695823692.0,
        "delta": 376396153.0
      },
      {
        "periodo": 202604,
        "valor": 11045453692.0,
        "delta": 349630000.0
      },
      {
        "periodo": 202605,
        "valor": 11473524477.0,
        "delta": 428070785.0
      },
      {
        "periodo": 202606,
        "valor": 11765062899.0,
        "delta": 291538422.0
      },
      {
        "periodo": 202607,
        "valor": 12153221314.0,
        "delta": 388158415.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 55208604431.0,
    "valor_anterior": 55236458297.99999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 58055638178.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 57697434492.0,
        "delta": -358203686.0
      },
      {
        "periodo": 202509,
        "valor": 57378720648.0,
        "delta": -318713844.0
      },
      {
        "periodo": 202510,
        "valor": 57033976919.0,
        "delta": -344743729.0
      },
      {
        "periodo": 202511,
        "valor": 56712956084.0,
        "delta": -321020835.0
      },
      {
        "periodo": 202512,
        "valor": 56405558281.0,
        "delta": -307397803.0
      },
      {
        "periodo": 202601,
        "valor": 56146398253.0,
        "delta": -259160028.0
      },
      {
        "periodo": 202602,
        "valor": 55868594314.0,
        "delta": -277803939.0
      },
      {
        "periodo": 202603,
        "valor": 55630657659.0,
        "delta": -237936655.0
      },
      {
        "periodo": 202604,
        "valor": 55504099252.0,
        "delta": -126558407.0
      },
      {
        "periodo": 202605,
        "valor": 55333581309.0,
        "delta": -170517943.0
      },
      {
        "periodo": 202606,
        "valor": 55236458298.0,
        "delta": -97123011.0
      },
      {
        "periodo": 202607,
        "valor": 55208604431.0,
        "delta": -27853867.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 21005325258.27,
    "valor_anterior": 21163312712.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22925577786.08,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 22866991287.37,
        "delta": -58586498.71
      },
      {
        "periodo": 202509,
        "valor": 22761641629.22,
        "delta": -105349658.15
      },
      {
        "periodo": 202510,
        "valor": 22673196568.97,
        "delta": -88445060.25
      },
      {
        "periodo": 202511,
        "valor": 22543758734.12,
        "delta": -129437834.85
      },
      {
        "periodo": 202512,
        "valor": 22403657763.6,
        "delta": -140100970.52
      },
      {
        "periodo": 202601,
        "valor": 22262908550.4,
        "delta": -140749213.2
      },
      {
        "periodo": 202602,
        "valor": 22015974818.45,
        "delta": -246933731.95
      },
      {
        "periodo": 202603,
        "valor": 21783085006.99,
        "delta": -232889811.46
      },
      {
        "periodo": 202604,
        "valor": 21568360981.31,
        "delta": -214724025.68
      },
      {
        "periodo": 202605,
        "valor": 21359731131.61,
        "delta": -208629849.7
      },
      {
        "periodo": 202606,
        "valor": 21163312712.0,
        "delta": -196418419.61
      },
      {
        "periodo": 202607,
        "valor": 21005325258.27,
        "delta": -157987453.73
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 9742086017.0,
    "valor_anterior": 9645188885.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8558218636.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8602040407.0,
        "delta": 43821771.0
      },
      {
        "periodo": 202509,
        "valor": 8692223835.0,
        "delta": 90183428.0
      },
      {
        "periodo": 202510,
        "valor": 8753233362.0,
        "delta": 61009527.0
      },
      {
        "periodo": 202511,
        "valor": 8864610058.0,
        "delta": 111376696.0
      },
      {
        "periodo": 202512,
        "valor": 8987627836.0,
        "delta": 123017778.0
      },
      {
        "periodo": 202601,
        "valor": 9049123867.0,
        "delta": 61496031.0
      },
      {
        "periodo": 202602,
        "valor": 9144461891.0,
        "delta": 95338024.0
      },
      {
        "periodo": 202603,
        "valor": 9250304143.0,
        "delta": 105842252.0
      },
      {
        "periodo": 202604,
        "valor": 9370138081.0,
        "delta": 119833938.0
      },
      {
        "periodo": 202605,
        "valor": 9508673346.0,
        "delta": 138535265.0
      },
      {
        "periodo": 202606,
        "valor": 9645188885.0,
        "delta": 136515539.0
      },
      {
        "periodo": 202607,
        "valor": 9742086017.0,
        "delta": 96897132.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 3188833831.0,
    "valor_anterior": 3244944911.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3300576262.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3326633749.0,
        "delta": 26057487.0
      },
      {
        "periodo": 202509,
        "valor": 3369514733.0,
        "delta": 42880984.0
      },
      {
        "periodo": 202510,
        "valor": 3393843392.0,
        "delta": 24328659.0
      },
      {
        "periodo": 202511,
        "valor": 3426476250.0,
        "delta": 32632858.0
      },
      {
        "periodo": 202512,
        "valor": 3421224958.0,
        "delta": -5251292.0
      },
      {
        "periodo": 202601,
        "valor": 3378906841.0,
        "delta": -42318117.0
      },
      {
        "periodo": 202602,
        "valor": 3359962857.0,
        "delta": -18943984.0
      },
      {
        "periodo": 202603,
        "valor": 3355521401.0,
        "delta": -4441456.0
      },
      {
        "periodo": 202604,
        "valor": 3313134929.0,
        "delta": -42386472.0
      },
      {
        "periodo": 202605,
        "valor": 3265717168.0,
        "delta": -47417761.0
      },
      {
        "periodo": 202606,
        "valor": 3244944911.0,
        "delta": -20772257.0
      },
      {
        "periodo": 202607,
        "valor": 3188833831.0,
        "delta": -56111080.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 9462684721.0,
    "valor_anterior": 9485403147.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9365390853.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9370948829.0,
        "delta": 5557976.0
      },
      {
        "periodo": 202509,
        "valor": 9387364493.0,
        "delta": 16415664.0
      },
      {
        "periodo": 202510,
        "valor": 9401197756.0,
        "delta": 13833263.0
      },
      {
        "periodo": 202511,
        "valor": 9426632836.0,
        "delta": 25435080.0
      },
      {
        "periodo": 202512,
        "valor": 9460204380.0,
        "delta": 33571544.0
      },
      {
        "periodo": 202601,
        "valor": 9467144533.0,
        "delta": 6940153.0
      },
      {
        "periodo": 202602,
        "valor": 9482456692.0,
        "delta": 15312159.0
      },
      {
        "periodo": 202603,
        "valor": 9491813558.0,
        "delta": 9356866.0
      },
      {
        "periodo": 202604,
        "valor": 9503108798.0,
        "delta": 11295240.0
      },
      {
        "periodo": 202605,
        "valor": 9516738277.0,
        "delta": 13629479.0
      },
      {
        "periodo": 202606,
        "valor": 9485403147.0,
        "delta": -31335130.0
      },
      {
        "periodo": 202607,
        "valor": 9462684721.0,
        "delta": -22718426.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 142738043266.63998,
    "valor_anterior": 142444838182.72998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 143784459089.04,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 143512755107.31,
        "delta": -271703981.73
      },
      {
        "periodo": 202509,
        "valor": 143205178629.59,
        "delta": -307576477.72
      },
      {
        "periodo": 202510,
        "valor": 142950594677.61,
        "delta": -254583951.98
      },
      {
        "periodo": 202511,
        "valor": 142811729633.4,
        "delta": -138865044.21
      },
      {
        "periodo": 202512,
        "valor": 142554663205.98,
        "delta": -257066427.42
      },
      {
        "periodo": 202601,
        "valor": 142362444521.26,
        "delta": -192218684.72
      },
      {
        "periodo": 202602,
        "valor": 142187838241.64,
        "delta": -174606279.62
      },
      {
        "periodo": 202603,
        "valor": 142014313753.37,
        "delta": -173524488.27
      },
      {
        "periodo": 202604,
        "valor": 142029514453.63,
        "delta": 15200700.26
      },
      {
        "periodo": 202605,
        "valor": 142206194759.54,
        "delta": 176680305.91
      },
      {
        "periodo": 202606,
        "valor": 142444838182.73,
        "delta": 238643423.19
      },
      {
        "periodo": 202607,
        "valor": 142738043266.64,
        "delta": 293205083.91
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 3519526895.0,
    "valor_anterior": 3546000647.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3473604220.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3506511184.0,
        "delta": 32906964.0
      },
      {
        "periodo": 202509,
        "valor": 3541894194.0,
        "delta": 35383010.0
      },
      {
        "periodo": 202510,
        "valor": 3588384602.0,
        "delta": 46490408.0
      },
      {
        "periodo": 202511,
        "valor": 3609801846.0,
        "delta": 21417244.0
      },
      {
        "periodo": 202512,
        "valor": 3620673493.0,
        "delta": 10871647.0
      },
      {
        "periodo": 202601,
        "valor": 3619714386.0,
        "delta": -959107.0
      },
      {
        "periodo": 202602,
        "valor": 3610526033.0,
        "delta": -9188353.0
      },
      {
        "periodo": 202603,
        "valor": 3604593340.0,
        "delta": -5932693.0
      },
      {
        "periodo": 202604,
        "valor": 3596068663.0,
        "delta": -8524677.0
      },
      {
        "periodo": 202605,
        "valor": 3566177244.0,
        "delta": -29891419.0
      },
      {
        "periodo": 202606,
        "valor": 3546000647.0,
        "delta": -20176597.0
      },
      {
        "periodo": 202607,
        "valor": 3519526895.0,
        "delta": -26473752.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 489725536.0,
    "valor_anterior": 489144924.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1101140963.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1035600647.0,
        "delta": -65540316.0
      },
      {
        "periodo": 202509,
        "valor": 963943134.0,
        "delta": -71657513.0
      },
      {
        "periodo": 202510,
        "valor": 896009631.0,
        "delta": -67933503.0
      },
      {
        "periodo": 202511,
        "valor": 837480889.0,
        "delta": -58528742.0
      },
      {
        "periodo": 202512,
        "valor": 761506146.0,
        "delta": -75974743.0
      },
      {
        "periodo": 202601,
        "valor": 687677625.0,
        "delta": -73828521.0
      },
      {
        "periodo": 202602,
        "valor": 626686732.0,
        "delta": -60990893.0
      },
      {
        "periodo": 202603,
        "valor": 573949595.0,
        "delta": -52737137.0
      },
      {
        "periodo": 202604,
        "valor": 529823500.0,
        "delta": -44126095.0
      },
      {
        "periodo": 202605,
        "valor": 490810757.0,
        "delta": -39012743.0
      },
      {
        "periodo": 202606,
        "valor": 489144924.0,
        "delta": -1665833.0
      },
      {
        "periodo": 202607,
        "valor": 489725536.0,
        "delta": 580612.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 1872202784.0,
    "valor_anterior": 1901549851.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2193195496.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2193626351.0,
        "delta": 430855.0
      },
      {
        "periodo": 202509,
        "valor": 2159006057.0,
        "delta": -34620294.0
      },
      {
        "periodo": 202510,
        "valor": 2135754611.0,
        "delta": -23251446.0
      },
      {
        "periodo": 202511,
        "valor": 2202561428.0,
        "delta": 66806817.0
      },
      {
        "periodo": 202512,
        "valor": 2149635039.0,
        "delta": -52926389.0
      },
      {
        "periodo": 202601,
        "valor": 2090860735.0,
        "delta": -58774304.0
      },
      {
        "periodo": 202602,
        "valor": 2058163410.0,
        "delta": -32697325.0
      },
      {
        "periodo": 202603,
        "valor": 2018084934.0,
        "delta": -40078476.0
      },
      {
        "periodo": 202604,
        "valor": 1974334803.0,
        "delta": -43750131.0
      },
      {
        "periodo": 202605,
        "valor": 1926455339.0,
        "delta": -47879464.0
      },
      {
        "periodo": 202606,
        "valor": 1901549851.0,
        "delta": -24905488.0
      },
      {
        "periodo": 202607,
        "valor": 1872202784.0,
        "delta": -29347067.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 4890268873.93,
    "valor_anterior": 4888013062.3,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4798076624.38,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4821355124.69,
        "delta": 23278500.31
      },
      {
        "periodo": 202509,
        "valor": 4819645009.35,
        "delta": -1710115.34
      },
      {
        "periodo": 202510,
        "valor": 4830327995.25,
        "delta": 10682985.9
      },
      {
        "periodo": 202511,
        "valor": 4832300096.66,
        "delta": 1972101.41
      },
      {
        "periodo": 202512,
        "valor": 4813128677.78,
        "delta": -19171418.88
      },
      {
        "periodo": 202601,
        "valor": 4821246262.36,
        "delta": 8117584.58
      },
      {
        "periodo": 202602,
        "valor": 4822367483.63,
        "delta": 1121221.27
      },
      {
        "periodo": 202603,
        "valor": 4854328728.18,
        "delta": 31961244.55
      },
      {
        "periodo": 202604,
        "valor": 4867609499.73,
        "delta": 13280771.55
      },
      {
        "periodo": 202605,
        "valor": 4882423606.16,
        "delta": 14814106.43
      },
      {
        "periodo": 202606,
        "valor": 4888013062.3,
        "delta": 5589456.14
      },
      {
        "periodo": 202607,
        "valor": 4890268873.93,
        "delta": 2255811.63
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 6571728616.999999,
    "valor_anterior": 6567482520.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7003984493.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6923278422.0,
        "delta": -80706071.0
      },
      {
        "periodo": 202509,
        "valor": 6834849926.0,
        "delta": -88428496.0
      },
      {
        "periodo": 202510,
        "valor": 6772188975.0,
        "delta": -62660951.0
      },
      {
        "periodo": 202511,
        "valor": 6715963135.0,
        "delta": -56225840.0
      },
      {
        "periodo": 202512,
        "valor": 6663421210.0,
        "delta": -52541925.0
      },
      {
        "periodo": 202601,
        "valor": 6622542404.0,
        "delta": -40878806.0
      },
      {
        "periodo": 202602,
        "valor": 6591938062.0,
        "delta": -30604342.0
      },
      {
        "periodo": 202603,
        "valor": 6568970823.0,
        "delta": -22967239.0
      },
      {
        "periodo": 202604,
        "valor": 6561429982.0,
        "delta": -7540841.0
      },
      {
        "periodo": 202605,
        "valor": 6557668246.0,
        "delta": -3761736.0
      },
      {
        "periodo": 202606,
        "valor": 6567482520.0,
        "delta": 9814274.0
      },
      {
        "periodo": 202607,
        "valor": 6571728617.0,
        "delta": 4246097.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 11605120134.609999,
    "valor_anterior": 11955977948.88,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11116293456.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12287090483.75,
        "delta": 1170797027.36
      },
      {
        "periodo": 202509,
        "valor": 13357064980.77,
        "delta": 1069974497.02
      },
      {
        "periodo": 202510,
        "valor": 14445784618.04,
        "delta": 1088719637.27
      },
      {
        "periodo": 202511,
        "valor": 15399244293.34,
        "delta": 953459675.3
      },
      {
        "periodo": 202512,
        "valor": 15045337300.34,
        "delta": -353906993.0
      },
      {
        "periodo": 202601,
        "valor": 14545798003.56,
        "delta": -499539296.78
      },
      {
        "periodo": 202602,
        "valor": 14039535317.49,
        "delta": -506262686.07
      },
      {
        "periodo": 202603,
        "valor": 13507520298.41,
        "delta": -532015019.08
      },
      {
        "periodo": 202604,
        "valor": 12995735017.31,
        "delta": -511785281.1
      },
      {
        "periodo": 202605,
        "valor": 12468134743.91,
        "delta": -527600273.4
      },
      {
        "periodo": 202606,
        "valor": 11955977948.88,
        "delta": -512156795.03
      },
      {
        "periodo": 202607,
        "valor": 11605120134.61,
        "delta": -350857814.27
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 98254922122.20999,
    "valor_anterior": 97868442490.89,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 91488605647.51,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 92494783571.93,
        "delta": 1006177924.42
      },
      {
        "periodo": 202509,
        "valor": 93335407406.12,
        "delta": 840623834.19
      },
      {
        "periodo": 202510,
        "valor": 94078294656.11,
        "delta": 742887249.99
      },
      {
        "periodo": 202511,
        "valor": 94911734046.25,
        "delta": 833439390.14
      },
      {
        "periodo": 202512,
        "valor": 95397324507.7,
        "delta": 485590461.45
      },
      {
        "periodo": 202601,
        "valor": 95915195393.69,
        "delta": 517870885.99
      },
      {
        "periodo": 202602,
        "valor": 96398781063.81,
        "delta": 483585670.12
      },
      {
        "periodo": 202603,
        "valor": 96924721122.81,
        "delta": 525940059.0
      },
      {
        "periodo": 202604,
        "valor": 97338027660.59,
        "delta": 413306537.78
      },
      {
        "periodo": 202605,
        "valor": 97509786713.44,
        "delta": 171759052.85
      },
      {
        "periodo": 202606,
        "valor": 97868442490.89,
        "delta": 358655777.45
      },
      {
        "periodo": 202607,
        "valor": 98254922122.21,
        "delta": 386479631.32
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 3048508373.98,
    "valor_anterior": 2873211705.47,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1216219287.27,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1317832277.53,
        "delta": 101612990.26
      },
      {
        "periodo": 202509,
        "valor": 1463539067.9,
        "delta": 145706790.37
      },
      {
        "periodo": 202510,
        "valor": 1621600247.58,
        "delta": 158061179.68
      },
      {
        "periodo": 202511,
        "valor": 1770734333.5,
        "delta": 149134085.92
      },
      {
        "periodo": 202512,
        "valor": 1918259745.0,
        "delta": 147525411.5
      },
      {
        "periodo": 202601,
        "valor": 2070307317.95,
        "delta": 152047572.95
      },
      {
        "periodo": 202602,
        "valor": 2208707257.43,
        "delta": 138399939.48
      },
      {
        "periodo": 202603,
        "valor": 2369246427.53,
        "delta": 160539170.1
      },
      {
        "periodo": 202604,
        "valor": 2548021034.36,
        "delta": 178774606.83
      },
      {
        "periodo": 202605,
        "valor": 2726091360.2,
        "delta": 178070325.84
      },
      {
        "periodo": 202606,
        "valor": 2873211705.47,
        "delta": 147120345.27
      },
      {
        "periodo": 202607,
        "valor": 3048508373.98,
        "delta": 175296668.51
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 37157367676.0,
    "valor_anterior": 36868564926.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 32172197916.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 32754568315.0,
        "delta": 582370399.0
      },
      {
        "periodo": 202509,
        "valor": 33219016218.0,
        "delta": 464447903.0
      },
      {
        "periodo": 202510,
        "valor": 33734312794.0,
        "delta": 515296576.0
      },
      {
        "periodo": 202511,
        "valor": 34311529341.0,
        "delta": 577216547.0
      },
      {
        "periodo": 202512,
        "valor": 34790697222.0,
        "delta": 479167881.0
      },
      {
        "periodo": 202601,
        "valor": 35163837545.0,
        "delta": 373140323.0
      },
      {
        "periodo": 202602,
        "valor": 35569337350.0,
        "delta": 405499805.0
      },
      {
        "periodo": 202603,
        "valor": 36040695697.0,
        "delta": 471358347.0
      },
      {
        "periodo": 202604,
        "valor": 36351980811.0,
        "delta": 311285114.0
      },
      {
        "periodo": 202605,
        "valor": 36583547924.0,
        "delta": 231567113.0
      },
      {
        "periodo": 202606,
        "valor": 36868564926.0,
        "delta": 285017002.0
      },
      {
        "periodo": 202607,
        "valor": 37157367676.0,
        "delta": 288802750.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 10831638238.000002,
    "valor_anterior": 10627952647.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9616381707.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9599785418.0,
        "delta": -16596289.0
      },
      {
        "periodo": 202509,
        "valor": 9589280432.0,
        "delta": -10504986.0
      },
      {
        "periodo": 202510,
        "valor": 9613748294.0,
        "delta": 24467862.0
      },
      {
        "periodo": 202511,
        "valor": 9693976890.0,
        "delta": 80228596.0
      },
      {
        "periodo": 202512,
        "valor": 9760262606.0,
        "delta": 66285716.0
      },
      {
        "periodo": 202601,
        "valor": 9833885508.0,
        "delta": 73622902.0
      },
      {
        "periodo": 202602,
        "valor": 9931620582.0,
        "delta": 97735074.0
      },
      {
        "periodo": 202603,
        "valor": 10109576674.0,
        "delta": 177956092.0
      },
      {
        "periodo": 202604,
        "valor": 10270418070.0,
        "delta": 160841396.0
      },
      {
        "periodo": 202605,
        "valor": 10440509628.0,
        "delta": 170091558.0
      },
      {
        "periodo": 202606,
        "valor": 10627952647.0,
        "delta": 187443019.0
      },
      {
        "periodo": 202607,
        "valor": 10831638238.0,
        "delta": 203685591.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 3021971228.0,
    "valor_anterior": 3041388667.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3470479049.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3432408468.0,
        "delta": -38070581.0
      },
      {
        "periodo": 202509,
        "valor": 3402994064.0,
        "delta": -29414404.0
      },
      {
        "periodo": 202510,
        "valor": 3371739298.0,
        "delta": -31254766.0
      },
      {
        "periodo": 202511,
        "valor": 3315753702.0,
        "delta": -55985596.0
      },
      {
        "periodo": 202512,
        "valor": 3257721691.0,
        "delta": -58032011.0
      },
      {
        "periodo": 202601,
        "valor": 3201284709.0,
        "delta": -56436982.0
      },
      {
        "periodo": 202602,
        "valor": 3158793300.0,
        "delta": -42491409.0
      },
      {
        "periodo": 202603,
        "valor": 3127018922.0,
        "delta": -31774378.0
      },
      {
        "periodo": 202604,
        "valor": 3101985767.0,
        "delta": -25033155.0
      },
      {
        "periodo": 202605,
        "valor": 3071414994.0,
        "delta": -30570773.0
      },
      {
        "periodo": 202606,
        "valor": 3041388667.0,
        "delta": -30026327.0
      },
      {
        "periodo": 202607,
        "valor": 3021971228.0,
        "delta": -19417439.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 238663939.0,
    "valor_anterior": 414205085.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2306916235.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2259483487.0,
        "delta": -47432748.0
      },
      {
        "periodo": 202509,
        "valor": 2130328572.0,
        "delta": -129154915.0
      },
      {
        "periodo": 202510,
        "valor": 1935673229.0,
        "delta": -194655343.0
      },
      {
        "periodo": 202511,
        "valor": 1769257013.0,
        "delta": -166416216.0
      },
      {
        "periodo": 202512,
        "valor": 1561609021.0,
        "delta": -207647992.0
      },
      {
        "periodo": 202601,
        "valor": 1345128236.0,
        "delta": -216480785.0
      },
      {
        "periodo": 202602,
        "valor": 1151733828.0,
        "delta": -193394408.0
      },
      {
        "periodo": 202603,
        "valor": 978056062.0,
        "delta": -173677766.0
      },
      {
        "periodo": 202604,
        "valor": 798573894.0,
        "delta": -179482168.0
      },
      {
        "periodo": 202605,
        "valor": 603564623.0,
        "delta": -195009271.0
      },
      {
        "periodo": 202606,
        "valor": 414205085.0,
        "delta": -189359538.0
      },
      {
        "periodo": 202607,
        "valor": 238663939.0,
        "delta": -175541146.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 15467502592.78,
    "valor_anterior": 15258468894.689999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13840034328.12,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13850343753.94,
        "delta": 10309425.82
      },
      {
        "periodo": 202509,
        "valor": 13891003754.02,
        "delta": 40660000.08
      },
      {
        "periodo": 202510,
        "valor": 14010879924.78,
        "delta": 119876170.76
      },
      {
        "periodo": 202511,
        "valor": 14284642734.84,
        "delta": 273762810.06
      },
      {
        "periodo": 202512,
        "valor": 14390853869.35,
        "delta": 106211134.51
      },
      {
        "periodo": 202601,
        "valor": 14509303862.09,
        "delta": 118449992.74
      },
      {
        "periodo": 202602,
        "valor": 14637777989.0,
        "delta": 128474126.91
      },
      {
        "periodo": 202603,
        "valor": 14780022076.09,
        "delta": 142244087.09
      },
      {
        "periodo": 202604,
        "valor": 14937696655.38,
        "delta": 157674579.29
      },
      {
        "periodo": 202605,
        "valor": 15084779576.06,
        "delta": 147082920.68
      },
      {
        "periodo": 202606,
        "valor": 15258468894.69,
        "delta": 173689318.63
      },
      {
        "periodo": 202607,
        "valor": 15467502592.78,
        "delta": 209033698.09
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 320497344.0,
    "valor_anterior": 297602825.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 131734114.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 139954136.0,
        "delta": 8220022.0
      },
      {
        "periodo": 202509,
        "valor": 149165890.0,
        "delta": 9211754.0
      },
      {
        "periodo": 202510,
        "valor": 160590927.0,
        "delta": 11425037.0
      },
      {
        "periodo": 202511,
        "valor": 172230037.0,
        "delta": 11639110.0
      },
      {
        "periodo": 202512,
        "valor": 185524977.0,
        "delta": 13294940.0
      },
      {
        "periodo": 202601,
        "valor": 200626146.0,
        "delta": 15101169.0
      },
      {
        "periodo": 202602,
        "valor": 215069337.0,
        "delta": 14443191.0
      },
      {
        "periodo": 202603,
        "valor": 233911139.0,
        "delta": 18841802.0
      },
      {
        "periodo": 202604,
        "valor": 252573798.0,
        "delta": 18662659.0
      },
      {
        "periodo": 202605,
        "valor": 273972986.0,
        "delta": 21399188.0
      },
      {
        "periodo": 202606,
        "valor": 297602825.0,
        "delta": 23629839.0
      },
      {
        "periodo": 202607,
        "valor": 320497344.0,
        "delta": 22894519.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 24804957.0,
    "valor_anterior": 24698127.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 26612271.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 26067015.0,
        "delta": -545256.0
      },
      {
        "periodo": 202509,
        "valor": 25522435.0,
        "delta": -544580.0
      },
      {
        "periodo": 202510,
        "valor": 24932316.0,
        "delta": -590119.0
      },
      {
        "periodo": 202511,
        "valor": 28603822.0,
        "delta": 3671506.0
      },
      {
        "periodo": 202512,
        "valor": 27855386.0,
        "delta": -748436.0
      },
      {
        "periodo": 202601,
        "valor": 27099424.0,
        "delta": -755962.0
      },
      {
        "periodo": 202602,
        "valor": 26469379.0,
        "delta": -630045.0
      },
      {
        "periodo": 202603,
        "valor": 25843373.0,
        "delta": -626006.0
      },
      {
        "periodo": 202604,
        "valor": 25275588.0,
        "delta": -567785.0
      },
      {
        "periodo": 202605,
        "valor": 24751459.0,
        "delta": -524129.0
      },
      {
        "periodo": 202606,
        "valor": 24698127.0,
        "delta": -53332.0
      },
      {
        "periodo": 202607,
        "valor": 24804957.0,
        "delta": 106830.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 9229773725.0,
    "valor_anterior": 9115367262.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7578156631.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7732750818.0,
        "delta": 154594187.0
      },
      {
        "periodo": 202509,
        "valor": 7892424957.0,
        "delta": 159674139.0
      },
      {
        "periodo": 202510,
        "valor": 8051823773.0,
        "delta": 159398816.0
      },
      {
        "periodo": 202511,
        "valor": 8199328380.0,
        "delta": 147504607.0
      },
      {
        "periodo": 202512,
        "valor": 8343692254.0,
        "delta": 144363874.0
      },
      {
        "periodo": 202601,
        "valor": 8489062693.0,
        "delta": 145370439.0
      },
      {
        "periodo": 202602,
        "valor": 8617218435.0,
        "delta": 128155742.0
      },
      {
        "periodo": 202603,
        "valor": 8743420843.0,
        "delta": 126202408.0
      },
      {
        "periodo": 202604,
        "valor": 8880174768.0,
        "delta": 136753925.0
      },
      {
        "periodo": 202605,
        "valor": 8998091320.0,
        "delta": 117916552.0
      },
      {
        "periodo": 202606,
        "valor": 9115367262.0,
        "delta": 117275942.0
      },
      {
        "periodo": 202607,
        "valor": 9229773725.0,
        "delta": 114406463.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 1143315068.0,
    "valor_anterior": 1134180350.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 990279678.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1022573583.0,
        "delta": 32293905.0
      },
      {
        "periodo": 202509,
        "valor": 1055097158.0,
        "delta": 32523575.0
      },
      {
        "periodo": 202510,
        "valor": 1085675597.0,
        "delta": 30578439.0
      },
      {
        "periodo": 202511,
        "valor": 1113964063.0,
        "delta": 28288466.0
      },
      {
        "periodo": 202512,
        "valor": 1058468324.0,
        "delta": -55495739.0
      },
      {
        "periodo": 202601,
        "valor": 1071473546.0,
        "delta": 13005222.0
      },
      {
        "periodo": 202602,
        "valor": 1087368052.0,
        "delta": 15894506.0
      },
      {
        "periodo": 202603,
        "valor": 1099192723.0,
        "delta": 11824671.0
      },
      {
        "periodo": 202604,
        "valor": 1111254513.0,
        "delta": 12061790.0
      },
      {
        "periodo": 202605,
        "valor": 1123998854.0,
        "delta": 12744341.0
      },
      {
        "periodo": 202606,
        "valor": 1134180350.0,
        "delta": 10181496.0
      },
      {
        "periodo": 202607,
        "valor": 1143315068.0,
        "delta": 9134718.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1947711509.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1869391254.0,
        "delta": -78320255.0
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 958855430.0,
    "valor_anterior": 969381737.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1271258281.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1237772538.0,
        "delta": -33485743.0
      },
      {
        "periodo": 202509,
        "valor": 1207540403.0,
        "delta": -30232135.0
      },
      {
        "periodo": 202510,
        "valor": 1175894867.0,
        "delta": -31645536.0
      },
      {
        "periodo": 202511,
        "valor": 1142743827.0,
        "delta": -33151040.0
      },
      {
        "periodo": 202512,
        "valor": 1111904317.0,
        "delta": -30839510.0
      },
      {
        "periodo": 202601,
        "valor": 1080534112.0,
        "delta": -31370205.0
      },
      {
        "periodo": 202602,
        "valor": 1055633610.0,
        "delta": -24900502.0
      },
      {
        "periodo": 202603,
        "valor": 1030685940.0,
        "delta": -24947670.0
      },
      {
        "periodo": 202604,
        "valor": 1006908438.0,
        "delta": -23777502.0
      },
      {
        "periodo": 202605,
        "valor": 986337035.0,
        "delta": -20571403.0
      },
      {
        "periodo": 202606,
        "valor": 969381737.0,
        "delta": -16955298.0
      },
      {
        "periodo": 202607,
        "valor": 958855430.0,
        "delta": -10526307.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 2475164598.0,
    "valor_anterior": 2394031684.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1655825636.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1713825095.0,
        "delta": 57999459.0
      },
      {
        "periodo": 202509,
        "valor": 1767398930.0,
        "delta": 53573835.0
      },
      {
        "periodo": 202510,
        "valor": 1828271982.0,
        "delta": 60873052.0
      },
      {
        "periodo": 202511,
        "valor": 1892227410.0,
        "delta": 63955428.0
      },
      {
        "periodo": 202512,
        "valor": 1961434561.0,
        "delta": 69207151.0
      },
      {
        "periodo": 202601,
        "valor": 2029301641.0,
        "delta": 67867080.0
      },
      {
        "periodo": 202602,
        "valor": 2091020666.0,
        "delta": 61719025.0
      },
      {
        "periodo": 202603,
        "valor": 2160352819.0,
        "delta": 69332153.0
      },
      {
        "periodo": 202604,
        "valor": 2240072829.0,
        "delta": 79720010.0
      },
      {
        "periodo": 202605,
        "valor": 2331420853.0,
        "delta": 91348024.0
      },
      {
        "periodo": 202606,
        "valor": 2394031684.0,
        "delta": 62610831.0
      },
      {
        "periodo": 202607,
        "valor": 2475164598.0,
        "delta": 81132914.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 357978878.0,
    "valor_anterior": 349163865.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 303594240.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 297052091.0,
        "delta": -6542149.0
      },
      {
        "periodo": 202509,
        "valor": 293458141.0,
        "delta": -3593950.0
      },
      {
        "periodo": 202510,
        "valor": 293657552.0,
        "delta": 199411.0
      },
      {
        "periodo": 202511,
        "valor": 296706136.0,
        "delta": 3048584.0
      },
      {
        "periodo": 202512,
        "valor": 302486629.0,
        "delta": 5780493.0
      },
      {
        "periodo": 202601,
        "valor": 308900223.0,
        "delta": 6413594.0
      },
      {
        "periodo": 202602,
        "valor": 314885656.0,
        "delta": 5985433.0
      },
      {
        "periodo": 202603,
        "valor": 321599593.0,
        "delta": 6713937.0
      },
      {
        "periodo": 202604,
        "valor": 330264126.0,
        "delta": 8664533.0
      },
      {
        "periodo": 202605,
        "valor": 339826477.0,
        "delta": 9562351.0
      },
      {
        "periodo": 202606,
        "valor": 349163865.0,
        "delta": 9337388.0
      },
      {
        "periodo": 202607,
        "valor": 357978878.0,
        "delta": 8815013.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 1629823017.43,
    "valor_anterior": 1632219820.88,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1808400690.63,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1796489830.91,
        "delta": -11910859.72
      },
      {
        "periodo": 202509,
        "valor": 1783142551.84,
        "delta": -13347279.07
      },
      {
        "periodo": 202510,
        "valor": 1768388290.8,
        "delta": -14754261.04
      },
      {
        "periodo": 202511,
        "valor": 1748565623.67,
        "delta": -19822667.13
      },
      {
        "periodo": 202512,
        "valor": 1729120613.38,
        "delta": -19445010.29
      },
      {
        "periodo": 202601,
        "valor": 1708379531.87,
        "delta": -20741081.51
      },
      {
        "periodo": 202602,
        "valor": 1689202112.4,
        "delta": -19177419.47
      },
      {
        "periodo": 202603,
        "valor": 1671251607.22,
        "delta": -17950505.18
      },
      {
        "periodo": 202604,
        "valor": 1653578837.66,
        "delta": -17672769.56
      },
      {
        "periodo": 202605,
        "valor": 1638877028.04,
        "delta": -14701809.62
      },
      {
        "periodo": 202606,
        "valor": 1632219820.88,
        "delta": -6657207.16
      },
      {
        "periodo": 202607,
        "valor": 1629823017.43,
        "delta": -2396803.45
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 164989706.0,
    "valor_anterior": 171400232.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 176833915.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 183654640.0,
        "delta": 6820725.0
      },
      {
        "periodo": 202509,
        "valor": 190221177.0,
        "delta": 6566537.0
      },
      {
        "periodo": 202510,
        "valor": 192057151.0,
        "delta": 1835974.0
      },
      {
        "periodo": 202511,
        "valor": 193199897.0,
        "delta": 1142746.0
      },
      {
        "periodo": 202512,
        "valor": 193776602.0,
        "delta": 576705.0
      },
      {
        "periodo": 202601,
        "valor": 193111604.0,
        "delta": -664998.0
      },
      {
        "periodo": 202602,
        "valor": 190995580.0,
        "delta": -2116024.0
      },
      {
        "periodo": 202603,
        "valor": 188355209.0,
        "delta": -2640371.0
      },
      {
        "periodo": 202604,
        "valor": 184397442.0,
        "delta": -3957767.0
      },
      {
        "periodo": 202605,
        "valor": 178384697.0,
        "delta": -6012745.0
      },
      {
        "periodo": 202606,
        "valor": 171400232.0,
        "delta": -6984465.0
      },
      {
        "periodo": 202607,
        "valor": 164989706.0,
        "delta": -6410526.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 5582980692.93,
    "valor_anterior": 5585102592.31,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5567190082.95,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5587180722.82,
        "delta": 19990639.87
      },
      {
        "periodo": 202509,
        "valor": 5598372288.75,
        "delta": 11191565.93
      },
      {
        "periodo": 202510,
        "valor": 5599642044.77,
        "delta": 1269756.02
      },
      {
        "periodo": 202511,
        "valor": 5621715484.84,
        "delta": 22073440.07
      },
      {
        "periodo": 202512,
        "valor": 5621341209.75,
        "delta": -374275.09
      },
      {
        "periodo": 202601,
        "valor": 5613357913.18,
        "delta": -7983296.57
      },
      {
        "periodo": 202602,
        "valor": 5604917950.53,
        "delta": -8439962.65
      },
      {
        "periodo": 202603,
        "valor": 5604080658.84,
        "delta": -837291.69
      },
      {
        "periodo": 202604,
        "valor": 5599023648.29,
        "delta": -5057010.55
      },
      {
        "periodo": 202605,
        "valor": 5598911324.95,
        "delta": -112323.34
      },
      {
        "periodo": 202606,
        "valor": 5585102592.31,
        "delta": -13808732.64
      },
      {
        "periodo": 202607,
        "valor": 5582980692.93,
        "delta": -2121899.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 1308729534.91,
    "valor_anterior": 1291107209.56,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1022716171.98,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1056348834.24,
        "delta": 33632662.26
      },
      {
        "periodo": 202509,
        "valor": 1082923706.48,
        "delta": 26574872.24
      },
      {
        "periodo": 202510,
        "valor": 1103034872.83,
        "delta": 20111166.35
      },
      {
        "periodo": 202511,
        "valor": 1127991001.21,
        "delta": 24956128.38
      },
      {
        "periodo": 202512,
        "valor": 1149907475.89,
        "delta": 21916474.68
      },
      {
        "periodo": 202601,
        "valor": 1174114227.82,
        "delta": 24206751.93
      },
      {
        "periodo": 202602,
        "valor": 1196453465.91,
        "delta": 22339238.09
      },
      {
        "periodo": 202603,
        "valor": 1225455000.92,
        "delta": 29001535.01
      },
      {
        "periodo": 202604,
        "valor": 1249988594.94,
        "delta": 24533594.02
      },
      {
        "periodo": 202605,
        "valor": 1273482749.66,
        "delta": 23494154.72
      },
      {
        "periodo": 202606,
        "valor": 1291107209.56,
        "delta": 17624459.9
      },
      {
        "periodo": 202607,
        "valor": 1308729534.91,
        "delta": 17622325.35
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 390563887.0,
    "valor_anterior": 389540798.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 333956601.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 344145245.0,
        "delta": 10188644.0
      },
      {
        "periodo": 202509,
        "valor": 355352832.0,
        "delta": 11207587.0
      },
      {
        "periodo": 202510,
        "valor": 367633656.0,
        "delta": 12280824.0
      },
      {
        "periodo": 202511,
        "valor": 379580150.0,
        "delta": 11946494.0
      },
      {
        "periodo": 202512,
        "valor": 386294647.0,
        "delta": 6714497.0
      },
      {
        "periodo": 202601,
        "valor": 391717206.0,
        "delta": 5422559.0
      },
      {
        "periodo": 202602,
        "valor": 392278522.0,
        "delta": 561316.0
      },
      {
        "periodo": 202603,
        "valor": 392527079.0,
        "delta": 248557.0
      },
      {
        "periodo": 202604,
        "valor": 389853620.0,
        "delta": -2673459.0
      },
      {
        "periodo": 202605,
        "valor": 389184422.0,
        "delta": -669198.0
      },
      {
        "periodo": 202606,
        "valor": 389540798.0,
        "delta": 356376.0
      },
      {
        "periodo": 202607,
        "valor": 390563887.0,
        "delta": 1023089.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 8860833556.0,
    "valor_anterior": 8874243334.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9294174642.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9190857584.0,
        "delta": -103317058.0
      },
      {
        "periodo": 202509,
        "valor": 9103721686.0,
        "delta": -87135898.0
      },
      {
        "periodo": 202510,
        "valor": 9045123595.0,
        "delta": -58598091.0
      },
      {
        "periodo": 202511,
        "valor": 8975838535.0,
        "delta": -69285060.0
      },
      {
        "periodo": 202512,
        "valor": 8933851908.0,
        "delta": -41986627.0
      },
      {
        "periodo": 202601,
        "valor": 8906058914.0,
        "delta": -27792994.0
      },
      {
        "periodo": 202602,
        "valor": 8889750454.0,
        "delta": -16308460.0
      },
      {
        "periodo": 202603,
        "valor": 8898374262.0,
        "delta": 8623808.0
      },
      {
        "periodo": 202604,
        "valor": 8886755233.0,
        "delta": -11619029.0
      },
      {
        "periodo": 202605,
        "valor": 8868261769.0,
        "delta": -18493464.0
      },
      {
        "periodo": 202606,
        "valor": 8874243334.0,
        "delta": 5981565.0
      },
      {
        "periodo": 202607,
        "valor": 8860833556.0,
        "delta": -13409778.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 250562810.0,
    "valor_anterior": 254399200.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 280448771.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 283855594.0,
        "delta": 3406823.0
      },
      {
        "periodo": 202509,
        "valor": 284905595.0,
        "delta": 1050001.0
      },
      {
        "periodo": 202510,
        "valor": 283263829.0,
        "delta": -1641766.0
      },
      {
        "periodo": 202511,
        "valor": 280696706.0,
        "delta": -2567123.0
      },
      {
        "periodo": 202512,
        "valor": 277239617.0,
        "delta": -3457089.0
      },
      {
        "periodo": 202601,
        "valor": 273752342.0,
        "delta": -3487275.0
      },
      {
        "periodo": 202602,
        "valor": 270291665.0,
        "delta": -3460677.0
      },
      {
        "periodo": 202603,
        "valor": 267022378.0,
        "delta": -3269287.0
      },
      {
        "periodo": 202604,
        "valor": 262054983.0,
        "delta": -4967395.0
      },
      {
        "periodo": 202605,
        "valor": 257539127.0,
        "delta": -4515856.0
      },
      {
        "periodo": 202606,
        "valor": 254399200.0,
        "delta": -3139927.0
      },
      {
        "periodo": 202607,
        "valor": 250562810.0,
        "delta": -3836390.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 429070064.44,
    "valor_anterior": 429875857.98,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 592457729.22,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 587979552.16,
        "delta": -4478177.06
      },
      {
        "periodo": 202509,
        "valor": 583695801.32,
        "delta": -4283750.84
      },
      {
        "periodo": 202510,
        "valor": 579945457.48,
        "delta": -3750343.84
      },
      {
        "periodo": 202511,
        "valor": 592402394.53,
        "delta": 12456937.05
      },
      {
        "periodo": 202512,
        "valor": 577105160.84,
        "delta": -15297233.69
      },
      {
        "periodo": 202601,
        "valor": 532026678.66,
        "delta": -45078482.18
      },
      {
        "periodo": 202602,
        "valor": 491839495.1,
        "delta": -40187183.56
      },
      {
        "periodo": 202603,
        "valor": 451614035.13,
        "delta": -40225459.97
      },
      {
        "periodo": 202604,
        "valor": 438763152.85,
        "delta": -12850882.28
      },
      {
        "periodo": 202605,
        "valor": 432509483.76,
        "delta": -6253669.09
      },
      {
        "periodo": 202606,
        "valor": 429875857.98,
        "delta": -2633625.78
      },
      {
        "periodo": 202607,
        "valor": 429070064.44,
        "delta": -805793.54
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 255527834.65,
    "valor_anterior": 254517505.5,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 357193057.58,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 348117879.12,
        "delta": -9075178.46
      },
      {
        "periodo": 202509,
        "valor": 334337084.51,
        "delta": -13780794.61
      },
      {
        "periodo": 202510,
        "valor": 323926614.9,
        "delta": -10410469.61
      },
      {
        "periodo": 202511,
        "valor": 313835727.51,
        "delta": -10090887.39
      },
      {
        "periodo": 202512,
        "valor": 302702583.13,
        "delta": -11133144.38
      },
      {
        "periodo": 202601,
        "valor": 290602588.92,
        "delta": -12099994.21
      },
      {
        "periodo": 202602,
        "valor": 282281080.43,
        "delta": -8321508.49
      },
      {
        "periodo": 202603,
        "valor": 271993873.85,
        "delta": -10287206.58
      },
      {
        "periodo": 202604,
        "valor": 263108244.3,
        "delta": -8885629.55
      },
      {
        "periodo": 202605,
        "valor": 257567371.9,
        "delta": -5540872.4
      },
      {
        "periodo": 202606,
        "valor": 254517505.5,
        "delta": -3049866.4
      },
      {
        "periodo": 202607,
        "valor": 255527834.65,
        "delta": 1010329.15
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 12970378.0,
    "valor_anterior": 12827159.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13046125.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13459854.0,
        "delta": 413729.0
      },
      {
        "periodo": 202509,
        "valor": 15316275.0,
        "delta": 1856421.0
      },
      {
        "periodo": 202510,
        "valor": 14689820.0,
        "delta": -626455.0
      },
      {
        "periodo": 202511,
        "valor": 15736948.0,
        "delta": 1047128.0
      },
      {
        "periodo": 202512,
        "valor": 15133293.0,
        "delta": -603655.0
      },
      {
        "periodo": 202601,
        "valor": 14461015.0,
        "delta": -672278.0
      },
      {
        "periodo": 202602,
        "valor": 14293367.0,
        "delta": -167648.0
      },
      {
        "periodo": 202603,
        "valor": 12920944.0,
        "delta": -1372423.0
      },
      {
        "periodo": 202604,
        "valor": 13182870.0,
        "delta": 261926.0
      },
      {
        "periodo": 202605,
        "valor": 12875296.0,
        "delta": -307574.0
      },
      {
        "periodo": 202606,
        "valor": 12827159.0,
        "delta": -48137.0
      },
      {
        "periodo": 202607,
        "valor": 12970378.0,
        "delta": 143219.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 200555508.0,
    "valor_anterior": 203959551.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 250935618.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 247898416.0,
        "delta": -3037202.0
      },
      {
        "periodo": 202509,
        "valor": 245631013.0,
        "delta": -2267403.0
      },
      {
        "periodo": 202510,
        "valor": 243651367.0,
        "delta": -1979646.0
      },
      {
        "periodo": 202511,
        "valor": 240031731.0,
        "delta": -3619636.0
      },
      {
        "periodo": 202512,
        "valor": 234187682.0,
        "delta": -5844049.0
      },
      {
        "periodo": 202601,
        "valor": 227479070.0,
        "delta": -6708612.0
      },
      {
        "periodo": 202602,
        "valor": 221568117.0,
        "delta": -5910953.0
      },
      {
        "periodo": 202603,
        "valor": 216970904.0,
        "delta": -4597213.0
      },
      {
        "periodo": 202604,
        "valor": 212241294.0,
        "delta": -4729610.0
      },
      {
        "periodo": 202605,
        "valor": 206803282.0,
        "delta": -5438012.0
      },
      {
        "periodo": 202606,
        "valor": 203959551.0,
        "delta": -2843731.0
      },
      {
        "periodo": 202607,
        "valor": 200555508.0,
        "delta": -3404043.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 629346.43,
    "valor_anterior": 908947.05,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12927488.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11602955.39,
        "delta": -1324533.43
      },
      {
        "periodo": 202509,
        "valor": 10066226.46,
        "delta": -1536728.93
      },
      {
        "periodo": 202510,
        "valor": 8517197.74,
        "delta": -1549028.72
      },
      {
        "periodo": 202511,
        "valor": 7096191.17,
        "delta": -1421006.57
      },
      {
        "periodo": 202512,
        "valor": 5764427.76,
        "delta": -1331763.41
      },
      {
        "periodo": 202601,
        "valor": 4548076.9,
        "delta": -1216350.86
      },
      {
        "periodo": 202602,
        "valor": 3553094.17,
        "delta": -994982.73
      },
      {
        "periodo": 202603,
        "valor": 2591107.35,
        "delta": -961986.82
      },
      {
        "periodo": 202604,
        "valor": 1846711.59,
        "delta": -744395.76
      },
      {
        "periodo": 202605,
        "valor": 1294158.31,
        "delta": -552553.28
      },
      {
        "periodo": 202606,
        "valor": 908947.05,
        "delta": -385211.26
      },
      {
        "periodo": 202607,
        "valor": 629346.43,
        "delta": -279600.62
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 854697399.27,
    "valor_anterior": 707817521.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 131597912.83,
        "delta": 131597912.83
      },
      {
        "periodo": 202603,
        "valor": 275875431.46,
        "delta": 144277518.63
      },
      {
        "periodo": 202604,
        "valor": 418717150.52,
        "delta": 142841719.06
      },
      {
        "periodo": 202605,
        "valor": 564301956.83,
        "delta": 145584806.31
      },
      {
        "periodo": 202606,
        "valor": 707817521.2,
        "delta": 143515564.37
      },
      {
        "periodo": 202607,
        "valor": 854697399.27,
        "delta": 146879878.07
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 76364305.0,
    "valor_anterior": 67951793.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": 13372846.0,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 17647270.0,
        "delta": 4274424.0
      },
      {
        "periodo": 202512,
        "valor": 22177470.0,
        "delta": 4530200.0
      },
      {
        "periodo": 202601,
        "valor": 27268300.0,
        "delta": 5090830.0
      },
      {
        "periodo": 202602,
        "valor": 34021178.0,
        "delta": 6752878.0
      },
      {
        "periodo": 202603,
        "valor": 42492888.0,
        "delta": 8471710.0
      },
      {
        "periodo": 202604,
        "valor": 50675646.0,
        "delta": 8182758.0
      },
      {
        "periodo": 202605,
        "valor": 59424149.0,
        "delta": 8748503.0
      },
      {
        "periodo": 202606,
        "valor": 67951793.0,
        "delta": 8527644.0
      },
      {
        "periodo": 202607,
        "valor": 76364305.0,
        "delta": 8412512.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 1098387833848.04,
    "valor_anterior": 1096332014421.92,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1102359247192.3901,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1102184398271.73,
        "delta": -174848920.6602
      },
      {
        "periodo": 202509,
        "valor": 1100168537161.36,
        "delta": -2015861110.3699
      },
      {
        "periodo": 202510,
        "valor": 1099965573149.0999,
        "delta": -202964012.2603
      },
      {
        "periodo": 202511,
        "valor": 1099333705500.51,
        "delta": -631867648.5898
      },
      {
        "periodo": 202512,
        "valor": 1097518708829.21,
        "delta": -1814996671.3
      },
      {
        "periodo": 202601,
        "valor": 1095419621723.0499,
        "delta": -2099087106.16
      },
      {
        "periodo": 202602,
        "valor": 1094023025976.94,
        "delta": -1396595746.11
      },
      {
        "periodo": 202603,
        "valor": 1094863480581.37,
        "delta": 840454604.4301
      },
      {
        "periodo": 202604,
        "valor": 1095208686489.9,
        "delta": 345205908.53
      },
      {
        "periodo": 202605,
        "valor": 1095267664315.31,
        "delta": 58977825.41
      },
      {
        "periodo": 202606,
        "valor": 1096332014421.92,
        "delta": 1064350106.61
      },
      {
        "periodo": 202607,
        "valor": 1098387833848.04,
        "delta": 2055819426.12
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 780310469989.2999,
    "valor_anterior": 779866857296.1101,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 799435454462.4501,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 796829980608.79,
        "delta": -2605473853.66
      },
      {
        "periodo": 202509,
        "valor": 794169632330.14,
        "delta": -2660348278.65
      },
      {
        "periodo": 202510,
        "valor": 791689653644.26,
        "delta": -2479978685.88
      },
      {
        "periodo": 202511,
        "valor": 788432162562.98,
        "delta": -3257491081.28
      },
      {
        "periodo": 202512,
        "valor": 785850364570.78,
        "delta": -2581797992.2
      },
      {
        "periodo": 202601,
        "valor": 784057066960.25,
        "delta": -1793297610.53
      },
      {
        "periodo": 202602,
        "valor": 782400334857.0701,
        "delta": -1656732103.1799
      },
      {
        "periodo": 202603,
        "valor": 781298972480.7201,
        "delta": -1101362376.35
      },
      {
        "periodo": 202604,
        "valor": 780653786597.48,
        "delta": -645185883.2401
      },
      {
        "periodo": 202605,
        "valor": 779905213603.97,
        "delta": -748572993.51
      },
      {
        "periodo": 202606,
        "valor": 779866857296.1101,
        "delta": -38356307.8599
      },
      {
        "periodo": 202607,
        "valor": 780310469989.2999,
        "delta": 443612693.1898
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 4899969800.93,
    "valor_anterior": 5261718240.3,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 10323962649.38,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 10188002403.69,
        "delta": -135960245.69
      },
      {
        "periodo": 202509,
        "valor": 8618395449.35,
        "delta": -1569606954.34
      },
      {
        "periodo": 202510,
        "valor": 8252542469.25,
        "delta": -365852980.1
      },
      {
        "periodo": 202511,
        "valor": 7903728212.66,
        "delta": -348814256.59
      },
      {
        "periodo": 202512,
        "valor": 7486642015.78,
        "delta": -417086196.88
      },
      {
        "periodo": 202601,
        "valor": 7081017126.36,
        "delta": -405624889.42
      },
      {
        "periodo": 202602,
        "valor": 6702408686.63,
        "delta": -378608439.73
      },
      {
        "periodo": 202603,
        "valor": 6365715775.18,
        "delta": -336692911.45
      },
      {
        "periodo": 202604,
        "valor": 6004733453.73,
        "delta": -360982321.45
      },
      {
        "periodo": 202605,
        "valor": 5632480813.16,
        "delta": -372252640.57
      },
      {
        "periodo": 202606,
        "valor": 5261718240.3,
        "delta": -370762572.86
      },
      {
        "periodo": 202607,
        "valor": 4899969800.93,
        "delta": -361748439.37
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 36729121422.61,
    "valor_anterior": 37060790688.88,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 35847502020.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 37035344770.75,
        "delta": 1187842750.36
      },
      {
        "periodo": 202509,
        "valor": 38142335403.77,
        "delta": 1106990633.02
      },
      {
        "periodo": 202510,
        "valor": 39259986716.04,
        "delta": 1117651312.27
      },
      {
        "periodo": 202511,
        "valor": 40384672120.34,
        "delta": 1124685404.3
      },
      {
        "periodo": 202512,
        "valor": 40067972873.34,
        "delta": -316699247.0
      },
      {
        "periodo": 202601,
        "valor": 39501879588.56,
        "delta": -566093284.78
      },
      {
        "periodo": 202602,
        "valor": 39002592821.49,
        "delta": -499286767.07
      },
      {
        "periodo": 202603,
        "valor": 38485030185.41,
        "delta": -517562636.08
      },
      {
        "periodo": 202604,
        "valor": 38007667320.31,
        "delta": -477362865.1
      },
      {
        "periodo": 202605,
        "valor": 37514616461.91,
        "delta": -493050858.4
      },
      {
        "periodo": 202606,
        "valor": 37060790688.88,
        "delta": -453825773.03
      },
      {
        "periodo": 202607,
        "valor": 36729121422.61,
        "delta": -331669266.27
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 88402320104.01001,
    "valor_anterior": 88039328420.79,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 90199146898.09,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 89596194003.46,
        "delta": -602952894.63
      },
      {
        "periodo": 202509,
        "valor": 88921786331.7,
        "delta": -674407671.76
      },
      {
        "periodo": 202510,
        "valor": 88649266848.56,
        "delta": -272519483.14
      },
      {
        "periodo": 202511,
        "valor": 88395038019.31,
        "delta": -254228829.25
      },
      {
        "periodo": 202512,
        "valor": 88586403127.88,
        "delta": 191365108.57
      },
      {
        "periodo": 202601,
        "valor": 88005070214.88,
        "delta": -581332913.0
      },
      {
        "periodo": 202602,
        "valor": 87749711242.59,
        "delta": -255358972.29
      },
      {
        "periodo": 202603,
        "valor": 87740789687.98,
        "delta": -8921554.61
      },
      {
        "periodo": 202604,
        "valor": 87751669033.29,
        "delta": 10879345.31
      },
      {
        "periodo": 202605,
        "valor": 87892504650.17,
        "delta": 140835616.88
      },
      {
        "periodo": 202606,
        "valor": 88039328420.79,
        "delta": 146823770.62
      },
      {
        "periodo": 202607,
        "valor": 88402320104.01,
        "delta": 362991683.22
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 22267778430.34,
    "valor_anterior": 22063302559.699997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20164966985.63,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 20366324439.78,
        "delta": 201357454.15
      },
      {
        "periodo": 202509,
        "valor": 20611194734.8,
        "delta": 244870295.02
      },
      {
        "periodo": 202510,
        "valor": 20837589130.36,
        "delta": 226394395.56
      },
      {
        "periodo": 202511,
        "valor": 21075440448.26,
        "delta": 237851317.9
      },
      {
        "periodo": 202512,
        "valor": 21215841522.99,
        "delta": 140401074.73
      },
      {
        "periodo": 202601,
        "valor": 21284967817.4,
        "delta": 69126294.41
      },
      {
        "periodo": 202602,
        "valor": 21373381405.8,
        "delta": 88413588.4
      },
      {
        "periodo": 202603,
        "valor": 21535321454.49,
        "delta": 161940048.69
      },
      {
        "periodo": 202604,
        "valor": 21708798174.4,
        "delta": 173476719.91
      },
      {
        "periodo": 202605,
        "valor": 21901876847.51,
        "delta": 193078673.11
      },
      {
        "periodo": 202606,
        "valor": 22063302559.7,
        "delta": 161425712.19
      },
      {
        "periodo": 202607,
        "valor": 22267778430.34,
        "delta": 204475870.64
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200184,
    "label": "Intereses Cartera Etapa 1+2 (Suma 12m)",
    "valor_actual": 165778174100.85,
    "valor_anterior": 164040017216.14,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 146388214176.45,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 148168552045.26,
        "delta": 1780337868.81
      },
      {
        "periodo": 202509,
        "valor": 149705192911.6,
        "delta": 1536640866.34
      },
      {
        "periodo": 202510,
        "valor": 151276534340.63,
        "delta": 1571341429.03
      },
      {
        "periodo": 202511,
        "valor": 153142664136.96,
        "delta": 1866129796.33
      },
      {
        "periodo": 202512,
        "valor": 154311484718.44,
        "delta": 1168820581.48
      },
      {
        "periodo": 202601,
        "valor": 155489620015.6,
        "delta": 1178135297.16
      },
      {
        "periodo": 202602,
        "valor": 156794596963.36,
        "delta": 1304976947.76
      },
      {
        "periodo": 202603,
        "valor": 159437650997.59,
        "delta": 2643054034.23
      },
      {
        "periodo": 202604,
        "valor": 161082031910.69,
        "delta": 1644380913.1
      },
      {
        "periodo": 202605,
        "valor": 162420971938.59,
        "delta": 1338940027.9
      },
      {
        "periodo": 202606,
        "valor": 164040017216.14,
        "delta": 1619045277.55
      },
      {
        "periodo": 202607,
        "valor": 165778174100.85,
        "delta": 1738156884.71
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 28416617664.300003,
    "valor_anterior": 27894181200.67,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 22235997640.37,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 22675163307.29,
        "delta": 439165666.92
      },
      {
        "periodo": 202509,
        "valor": 23236449899.68,
        "delta": 561286592.39
      },
      {
        "periodo": 202510,
        "valor": 23782429444.14,
        "delta": 545979544.46
      },
      {
        "periodo": 202511,
        "valor": 24165445288.74,
        "delta": 383015844.6
      },
      {
        "periodo": 202512,
        "valor": 24785903976.11,
        "delta": 620458687.37
      },
      {
        "periodo": 202601,
        "valor": 25025649357.06,
        "delta": 239745380.95
      },
      {
        "periodo": 202602,
        "valor": 25329434751.23,
        "delta": 303785394.17
      },
      {
        "periodo": 202603,
        "valor": 26190818190.06,
        "delta": 861383438.83
      },
      {
        "periodo": 202604,
        "valor": 26797632141.33,
        "delta": 606813951.27
      },
      {
        "periodo": 202605,
        "valor": 27229015458.18,
        "delta": 431383316.85
      },
      {
        "periodo": 202606,
        "valor": 27894181200.67,
        "delta": 665165742.49
      },
      {
        "periodo": 202607,
        "valor": 28416617664.3,
        "delta": 522436463.63
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 65018790365.490005,
    "valor_anterior": 64399578596.490005,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 54758911571.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55404791109.0,
        "delta": 645879538.0
      },
      {
        "periodo": 202509,
        "valor": 56097544972.0,
        "delta": 692753863.0
      },
      {
        "periodo": 202510,
        "valor": 56575314371.28,
        "delta": 477769399.28
      },
      {
        "periodo": 202511,
        "valor": 57830133775.89,
        "delta": 1254819404.61
      },
      {
        "periodo": 202512,
        "valor": 59585064572.34,
        "delta": 1754930796.45
      },
      {
        "periodo": 202601,
        "valor": 60191540674.42,
        "delta": 606476102.08
      },
      {
        "periodo": 202602,
        "valor": 61231880920.21,
        "delta": 1040340245.79
      },
      {
        "periodo": 202603,
        "valor": 60358071045.79,
        "delta": -873809874.42
      },
      {
        "periodo": 202604,
        "valor": 62859087160.49,
        "delta": 2501016114.7
      },
      {
        "periodo": 202605,
        "valor": 63638733955.49,
        "delta": 779646795.0
      },
      {
        "periodo": 202606,
        "valor": 64399578596.49,
        "delta": 760844641.0
      },
      {
        "periodo": 202607,
        "valor": 65018790365.49,
        "delta": 619211769.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 30099197040.999996,
    "valor_anterior": 29840024162.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27207451525.06,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 27707137433.06,
        "delta": 499685908.0
      },
      {
        "periodo": 202509,
        "valor": 28104657618.06,
        "delta": 397520185.0
      },
      {
        "periodo": 202510,
        "valor": 27947870562.06,
        "delta": -156787056.0
      },
      {
        "periodo": 202511,
        "valor": 29140683573.0,
        "delta": 1192813010.94
      },
      {
        "periodo": 202512,
        "valor": 29244728833.0,
        "delta": 104045260.0
      },
      {
        "periodo": 202601,
        "valor": 29421452389.0,
        "delta": 176723556.0
      },
      {
        "periodo": 202602,
        "valor": 29662468941.0,
        "delta": 241016552.0
      },
      {
        "periodo": 202603,
        "valor": 29748758959.0,
        "delta": 86290018.0
      },
      {
        "periodo": 202604,
        "valor": 29819077155.0,
        "delta": 70318196.0
      },
      {
        "periodo": 202605,
        "valor": 29710185826.0,
        "delta": -108891329.0
      },
      {
        "periodo": 202606,
        "valor": 29840024162.0,
        "delta": 129838336.0
      },
      {
        "periodo": 202607,
        "valor": 30099197041.0,
        "delta": 259172879.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 14426494713.999998,
    "valor_anterior": 14569011737.999998,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14639017365.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14515362423.0,
        "delta": -123654942.0
      },
      {
        "periodo": 202509,
        "valor": 14695896813.0,
        "delta": 180534390.0
      },
      {
        "periodo": 202510,
        "valor": 14714690945.0,
        "delta": 18794132.0
      },
      {
        "periodo": 202511,
        "valor": 15248722020.0,
        "delta": 534031075.0
      },
      {
        "periodo": 202512,
        "valor": 15133700869.0,
        "delta": -115021151.0
      },
      {
        "periodo": 202601,
        "valor": 15153159991.0,
        "delta": 19459122.0
      },
      {
        "periodo": 202602,
        "valor": 15141082948.0,
        "delta": -12077043.0
      },
      {
        "periodo": 202603,
        "valor": 15211273344.0,
        "delta": 70190396.0
      },
      {
        "periodo": 202604,
        "valor": 14844263037.0,
        "delta": -367010307.0
      },
      {
        "periodo": 202605,
        "valor": 14692427757.0,
        "delta": -151835280.0
      },
      {
        "periodo": 202606,
        "valor": 14569011738.0,
        "delta": -123416019.0
      },
      {
        "periodo": 202607,
        "valor": 14426494714.0,
        "delta": -142517024.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 2673869822.6100006,
    "valor_anterior": 2630740916.12,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2805817682.14,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2642548371.0,
        "delta": -163269311.14
      },
      {
        "periodo": 202509,
        "valor": 2250462317.77,
        "delta": -392086053.23
      },
      {
        "periodo": 202510,
        "valor": 2415778574.39,
        "delta": 165316256.62
      },
      {
        "periodo": 202511,
        "valor": 2685510757.76,
        "delta": 269732183.37
      },
      {
        "periodo": 202512,
        "valor": 2992780032.46,
        "delta": 307269274.7
      },
      {
        "periodo": 202601,
        "valor": 3010050643.12,
        "delta": 17270610.66
      },
      {
        "periodo": 202602,
        "valor": 2852433899.06,
        "delta": -157616744.06
      },
      {
        "periodo": 202603,
        "valor": 2813080791.47,
        "delta": -39353107.59
      },
      {
        "periodo": 202604,
        "valor": 2909533649.42,
        "delta": 96452857.95
      },
      {
        "periodo": 202605,
        "valor": 2799008757.87,
        "delta": -110524891.55
      },
      {
        "periodo": 202606,
        "valor": 2630740916.12,
        "delta": -168267841.75
      },
      {
        "periodo": 202607,
        "valor": 2673869822.61,
        "delta": 43128906.49
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 5856441716.999999,
    "valor_anterior": 5772390934.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5507689479.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5585555133.0,
        "delta": 77865654.0
      },
      {
        "periodo": 202509,
        "valor": 5713377152.0,
        "delta": 127822019.0
      },
      {
        "periodo": 202510,
        "valor": 5894824372.0,
        "delta": 181447220.0
      },
      {
        "periodo": 202511,
        "valor": 5631860665.0,
        "delta": -262963707.0
      },
      {
        "periodo": 202512,
        "valor": 5827430232.0,
        "delta": 195569567.0
      },
      {
        "periodo": 202601,
        "valor": 6007351040.0,
        "delta": 179920808.0
      },
      {
        "periodo": 202602,
        "valor": 6184947031.0,
        "delta": 177595991.0
      },
      {
        "periodo": 202603,
        "valor": 6366589506.0,
        "delta": 181642475.0
      },
      {
        "periodo": 202604,
        "valor": 6568958308.0,
        "delta": 202368802.0
      },
      {
        "periodo": 202605,
        "valor": 6732616399.0,
        "delta": 163658091.0
      },
      {
        "periodo": 202606,
        "valor": 5772390934.0,
        "delta": -960225465.0
      },
      {
        "periodo": 202607,
        "valor": 5856441717.0,
        "delta": 84050783.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 607737104.0,
    "valor_anterior": 596758643.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 362105073.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 415999909.0,
        "delta": 53894836.0
      },
      {
        "periodo": 202509,
        "valor": 460998928.0,
        "delta": 44999019.0
      },
      {
        "periodo": 202510,
        "valor": 507083680.0,
        "delta": 46084752.0
      },
      {
        "periodo": 202511,
        "valor": 513077872.0,
        "delta": 5994192.0
      },
      {
        "periodo": 202512,
        "valor": 735478814.0,
        "delta": 222400942.0
      },
      {
        "periodo": 202601,
        "valor": 725115412.0,
        "delta": -10363402.0
      },
      {
        "periodo": 202602,
        "valor": 730974628.0,
        "delta": 5859216.0
      },
      {
        "periodo": 202603,
        "valor": 706839007.0,
        "delta": -24135621.0
      },
      {
        "periodo": 202604,
        "valor": 709047971.0,
        "delta": 2208964.0
      },
      {
        "periodo": 202605,
        "valor": 649826460.0,
        "delta": -59221511.0
      },
      {
        "periodo": 202606,
        "valor": 596758643.0,
        "delta": -53067817.0
      },
      {
        "periodo": 202607,
        "valor": 607737104.0,
        "delta": 10978461.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 5664075055.000001,
    "valor_anterior": 5728651195.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6509815470.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 6702632607.0,
        "delta": 192817137.0
      },
      {
        "periodo": 202509,
        "valor": 6865601773.0,
        "delta": 162969166.0
      },
      {
        "periodo": 202510,
        "valor": 6948771693.0,
        "delta": 83169920.0
      },
      {
        "periodo": 202511,
        "valor": 7108594130.0,
        "delta": 159822437.0
      },
      {
        "periodo": 202512,
        "valor": 6619168747.0,
        "delta": -489425383.0
      },
      {
        "periodo": 202601,
        "valor": 5245625113.0,
        "delta": -1373543634.0
      },
      {
        "periodo": 202602,
        "valor": 5335999164.0,
        "delta": 90374051.0
      },
      {
        "periodo": 202603,
        "valor": 5461562567.0,
        "delta": 125563403.0
      },
      {
        "periodo": 202604,
        "valor": 5739472561.0,
        "delta": 277909994.0
      },
      {
        "periodo": 202605,
        "valor": 5610921300.0,
        "delta": -128551261.0
      },
      {
        "periodo": 202606,
        "valor": 5728651195.0,
        "delta": 117729895.0
      },
      {
        "periodo": 202607,
        "valor": 5664075055.0,
        "delta": -64576140.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 2145270902.42,
    "valor_anterior": 2163208214.79,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1462365631.01,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1542059284.56,
        "delta": 79693653.55
      },
      {
        "periodo": 202509,
        "valor": 1411667228.39,
        "delta": -130392056.17
      },
      {
        "periodo": 202510,
        "valor": 1454179943.92,
        "delta": 42512715.53
      },
      {
        "periodo": 202511,
        "valor": 1498974024.08,
        "delta": 44794080.16
      },
      {
        "periodo": 202512,
        "valor": 1799572239.05,
        "delta": 300598214.97
      },
      {
        "periodo": 202601,
        "valor": 1898379038.33,
        "delta": 98806799.28
      },
      {
        "periodo": 202602,
        "valor": 2322697255.23,
        "delta": 424318216.9
      },
      {
        "periodo": 202603,
        "valor": 2212024509.22,
        "delta": -110672746.01
      },
      {
        "periodo": 202604,
        "valor": 2189498591.43,
        "delta": -22525917.79
      },
      {
        "periodo": 202605,
        "valor": 2176154809.72,
        "delta": -13343781.71
      },
      {
        "periodo": 202606,
        "valor": 2163208214.79,
        "delta": -12946594.93
      },
      {
        "periodo": 202607,
        "valor": 2145270902.42,
        "delta": -17937312.37
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 4454534131.0,
    "valor_anterior": 4344293836.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3173165631.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3310674554.0,
        "delta": 137508923.0
      },
      {
        "periodo": 202509,
        "valor": 3432288637.0,
        "delta": 121614083.0
      },
      {
        "periodo": 202510,
        "valor": 3611119591.0,
        "delta": 178830954.0
      },
      {
        "periodo": 202511,
        "valor": 3712594921.0,
        "delta": 101475330.0
      },
      {
        "periodo": 202512,
        "valor": 3840283144.0,
        "delta": 127688223.0
      },
      {
        "periodo": 202601,
        "valor": 3840283144.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 3972254427.0,
        "delta": 131971283.0
      },
      {
        "periodo": 202603,
        "valor": 4080800270.0,
        "delta": 108545843.0
      },
      {
        "periodo": 202604,
        "valor": 4048586843.0,
        "delta": -32213427.0
      },
      {
        "periodo": 202605,
        "valor": 4194855879.0,
        "delta": 146269036.0
      },
      {
        "periodo": 202606,
        "valor": 4344293836.0,
        "delta": 149437957.0
      },
      {
        "periodo": 202607,
        "valor": 4454534131.0,
        "delta": 110240295.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 125611.0,
    "valor_anterior": 125611.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 37237.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 37237.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 37237.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 162848.0,
        "delta": 125611.0
      },
      {
        "periodo": 202511,
        "valor": 162848.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 162848.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 162848.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 162848.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 162848.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 162848.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 125611.0,
        "delta": -37237.0
      },
      {
        "periodo": 202606,
        "valor": 125611.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 125611.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 2513596808.0,
    "valor_anterior": 2524083227.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2105007702.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2116811169.0,
        "delta": 11803467.0
      },
      {
        "periodo": 202509,
        "valor": 2139246827.0,
        "delta": 22435658.0
      },
      {
        "periodo": 202510,
        "valor": 2198978415.0,
        "delta": 59731588.0
      },
      {
        "periodo": 202511,
        "valor": 1422801519.0,
        "delta": -776176896.0
      },
      {
        "periodo": 202512,
        "valor": 2385348528.0,
        "delta": 962547009.0
      },
      {
        "periodo": 202601,
        "valor": 2405108017.0,
        "delta": 19759489.0
      },
      {
        "periodo": 202602,
        "valor": 2442482437.0,
        "delta": 37374420.0
      },
      {
        "periodo": 202603,
        "valor": 2475500675.0,
        "delta": 33018238.0
      },
      {
        "periodo": 202604,
        "valor": 2505436586.0,
        "delta": 29935911.0
      },
      {
        "periodo": 202605,
        "valor": 2515928635.0,
        "delta": 10492049.0
      },
      {
        "periodo": 202606,
        "valor": 2524083227.0,
        "delta": 8154592.0
      },
      {
        "periodo": 202607,
        "valor": 2513596808.0,
        "delta": -10486419.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 23369126905.250004,
    "valor_anterior": 22870193849.539997,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20123264513.35,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 20505271904.11,
        "delta": 382007390.76
      },
      {
        "periodo": 202509,
        "valor": 20492796139.36,
        "delta": -12475764.75
      },
      {
        "periodo": 202510,
        "valor": 20554755669.68,
        "delta": 61959530.32
      },
      {
        "periodo": 202511,
        "valor": 20496268772.32,
        "delta": -58486897.36
      },
      {
        "periodo": 202512,
        "valor": 20787422113.58,
        "delta": 291153341.26
      },
      {
        "periodo": 202601,
        "valor": 21027266815.56,
        "delta": 239844701.98
      },
      {
        "periodo": 202602,
        "valor": 21450963953.2,
        "delta": 423697137.64
      },
      {
        "periodo": 202603,
        "valor": 21710991298.83,
        "delta": 260027345.63
      },
      {
        "periodo": 202604,
        "valor": 22040184431.39,
        "delta": 329193132.56
      },
      {
        "periodo": 202605,
        "valor": 22366644443.52,
        "delta": 326460012.13
      },
      {
        "periodo": 202606,
        "valor": 22870193849.54,
        "delta": 503549406.02
      },
      {
        "periodo": 202607,
        "valor": 23369126905.25,
        "delta": 498933055.71
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 571876617.76,
    "valor_anterior": 537840216.79,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 194742436.13,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 53613695.8,
        "delta": -141128740.33
      },
      {
        "periodo": 202509,
        "valor": 47695075.03,
        "delta": -5918620.77
      },
      {
        "periodo": 202510,
        "valor": 120104780.8,
        "delta": 72409705.77
      },
      {
        "periodo": 202511,
        "valor": 200487934.82,
        "delta": 80383154.02
      },
      {
        "periodo": 202512,
        "valor": 447329227.36,
        "delta": 246841292.54
      },
      {
        "periodo": 202601,
        "valor": 451807429.94,
        "delta": 4478202.58
      },
      {
        "periodo": 202602,
        "valor": 453807465.6,
        "delta": 2000035.66
      },
      {
        "periodo": 202603,
        "valor": 454551094.74,
        "delta": 743629.14
      },
      {
        "periodo": 202604,
        "valor": 453511816.87,
        "delta": -1039277.87
      },
      {
        "periodo": 202605,
        "valor": 453475185.74,
        "delta": -36631.13
      },
      {
        "periodo": 202606,
        "valor": 537840216.79,
        "delta": 84365031.05
      },
      {
        "periodo": 202607,
        "valor": 571876617.76,
        "delta": 34036400.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 323066779.0,
    "valor_anterior": 306262570.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 117381687.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 93075879.0,
        "delta": -24305808.0
      },
      {
        "periodo": 202509,
        "valor": 107865444.0,
        "delta": 14789565.0
      },
      {
        "periodo": 202510,
        "valor": 112178982.0,
        "delta": 4313538.0
      },
      {
        "periodo": 202511,
        "valor": 166765301.0,
        "delta": 54586319.0
      },
      {
        "periodo": 202512,
        "valor": 166765301.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 163353827.0,
        "delta": -3411474.0
      },
      {
        "periodo": 202602,
        "valor": 172438251.0,
        "delta": 9084424.0
      },
      {
        "periodo": 202603,
        "valor": 172445822.0,
        "delta": 7571.0
      },
      {
        "periodo": 202604,
        "valor": 300030068.0,
        "delta": 127584246.0
      },
      {
        "periodo": 202605,
        "valor": 300030068.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 306262570.0,
        "delta": 6232502.0
      },
      {
        "periodo": 202607,
        "valor": 323066779.0,
        "delta": 16804209.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 237525642.94,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 237525642.94,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 237525642.94,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 237525642.94,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 237525642.94,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.02,
        "delta": -237525642.92
      },
      {
        "periodo": 202601,
        "valor": 0.02,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -0.02
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 18032106849.23,
    "valor_anterior": 16965627745.289999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11696756256.85,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11950047255.56,
        "delta": 253290998.71
      },
      {
        "periodo": 202509,
        "valor": 12399834369.51,
        "delta": 449787113.95
      },
      {
        "periodo": 202510,
        "valor": 12619128222.37,
        "delta": 219293852.86
      },
      {
        "periodo": 202511,
        "valor": 13140798581.84,
        "delta": 521670359.47
      },
      {
        "periodo": 202512,
        "valor": 13422352393.55,
        "delta": 281553811.71
      },
      {
        "periodo": 202601,
        "valor": 13955596689.21,
        "delta": 533244295.66
      },
      {
        "periodo": 202602,
        "valor": 14372023518.9,
        "delta": 416426829.69
      },
      {
        "periodo": 202603,
        "valor": 14938064021.08,
        "delta": 566040502.18
      },
      {
        "periodo": 202604,
        "valor": 15548671346.05,
        "delta": 610607324.97
      },
      {
        "periodo": 202605,
        "valor": 16270224959.38,
        "delta": 721553613.33
      },
      {
        "periodo": 202606,
        "valor": 16965627745.29,
        "delta": 695402785.91
      },
      {
        "periodo": 202607,
        "valor": 18032106849.23,
        "delta": 1066479103.94
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 128963701.28,
    "valor_anterior": 130682756.34,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 31458526.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 31458526.69,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 31458526.69,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 31458526.69,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 31458526.69,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 6712645.93,
        "delta": -24745880.76
      },
      {
        "periodo": 202601,
        "valor": 6712645.93,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 6712645.93,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 6712645.93,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 6712645.93,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 5423306.19,
        "delta": -1289339.74
      },
      {
        "periodo": 202606,
        "valor": 130682756.34,
        "delta": 125259450.15
      },
      {
        "periodo": 202607,
        "valor": 128963701.28,
        "delta": -1719055.06
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 7468970394.0,
    "valor_anterior": 7170446031.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5460100597.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5560634993.0,
        "delta": 100534396.0
      },
      {
        "periodo": 202509,
        "valor": 5722805133.0,
        "delta": 162170140.0
      },
      {
        "periodo": 202510,
        "valor": 5870238002.0,
        "delta": 147432869.0
      },
      {
        "periodo": 202511,
        "valor": 5985262570.0,
        "delta": 115024568.0
      },
      {
        "periodo": 202512,
        "valor": 6058990162.0,
        "delta": 73727592.0
      },
      {
        "periodo": 202601,
        "valor": 6174835013.0,
        "delta": 115844851.0
      },
      {
        "periodo": 202602,
        "valor": 6274367782.0,
        "delta": 99532769.0
      },
      {
        "periodo": 202603,
        "valor": 6424695212.0,
        "delta": 150327430.0
      },
      {
        "periodo": 202604,
        "valor": 6688989930.0,
        "delta": 264294718.0
      },
      {
        "periodo": 202605,
        "valor": 6901041830.0,
        "delta": 212051900.0
      },
      {
        "periodo": 202606,
        "valor": 7170446031.0,
        "delta": 269404201.0
      },
      {
        "periodo": 202607,
        "valor": 7468970394.0,
        "delta": 298524363.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 148612705.0,
    "valor_anterior": 152981111.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 222764013.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 222046294.0,
        "delta": -717719.0
      },
      {
        "periodo": 202509,
        "valor": 228989332.0,
        "delta": 6943038.0
      },
      {
        "periodo": 202510,
        "valor": 326081582.0,
        "delta": 97092250.0
      },
      {
        "periodo": 202511,
        "valor": 161089259.0,
        "delta": -164992323.0
      },
      {
        "periodo": 202512,
        "valor": 160336363.0,
        "delta": -752896.0
      },
      {
        "periodo": 202601,
        "valor": 161932635.0,
        "delta": 1596272.0
      },
      {
        "periodo": 202602,
        "valor": 176613730.0,
        "delta": 14681095.0
      },
      {
        "periodo": 202603,
        "valor": 176188129.0,
        "delta": -425601.0
      },
      {
        "periodo": 202604,
        "valor": 176867635.0,
        "delta": 679506.0
      },
      {
        "periodo": 202605,
        "valor": 175238069.0,
        "delta": -1629566.0
      },
      {
        "periodo": 202606,
        "valor": 152981111.0,
        "delta": -22256958.0
      },
      {
        "periodo": 202607,
        "valor": 148612705.0,
        "delta": -4368406.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8055634.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8055634.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -8055634.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 1005173883.95,
    "valor_anterior": 1009073356.74,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 225712161.58,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 215768427.96,
        "delta": -9943733.62
      },
      {
        "periodo": 202509,
        "valor": 213159755.76,
        "delta": -2608672.2
      },
      {
        "periodo": 202510,
        "valor": 875990334.88,
        "delta": 662830579.12
      },
      {
        "periodo": 202511,
        "valor": 861982566.91,
        "delta": -14007767.97
      },
      {
        "periodo": 202512,
        "valor": 915467043.92,
        "delta": 53484477.01
      },
      {
        "periodo": 202601,
        "valor": 915792279.44,
        "delta": 325235.52
      },
      {
        "periodo": 202602,
        "valor": 913388457.41,
        "delta": -2403822.03
      },
      {
        "periodo": 202603,
        "valor": 993840399.67,
        "delta": 80451942.26
      },
      {
        "periodo": 202604,
        "valor": 997432248.79,
        "delta": 3591849.12
      },
      {
        "periodo": 202605,
        "valor": 998370890.94,
        "delta": 938642.15
      },
      {
        "periodo": 202606,
        "valor": 1009073356.74,
        "delta": 10702465.8
      },
      {
        "periodo": 202607,
        "valor": 1005173883.95,
        "delta": -3899472.79
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 310166127.0,
    "valor_anterior": 291418346.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 166426710.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 173764455.07,
        "delta": 7337744.38
      },
      {
        "periodo": 202509,
        "valor": 181048395.07,
        "delta": 7283940.0
      },
      {
        "periodo": 202510,
        "valor": 184544378.07,
        "delta": 3495983.0
      },
      {
        "periodo": 202511,
        "valor": 191705747.35,
        "delta": 7161369.28
      },
      {
        "periodo": 202512,
        "valor": 198338588.01,
        "delta": 6632840.66
      },
      {
        "periodo": 202601,
        "valor": 211062111.78,
        "delta": 12723523.77
      },
      {
        "periodo": 202602,
        "valor": 220549360.43,
        "delta": 9487248.65
      },
      {
        "periodo": 202603,
        "valor": 237168707.79,
        "delta": 16619347.36
      },
      {
        "periodo": 202604,
        "valor": 254164390.0,
        "delta": 16995682.21
      },
      {
        "periodo": 202605,
        "valor": 272324399.0,
        "delta": 18160009.0
      },
      {
        "periodo": 202606,
        "valor": 291418346.0,
        "delta": 19093947.0
      },
      {
        "periodo": 202607,
        "valor": 310166127.0,
        "delta": 18747781.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 547172334.0,
    "valor_anterior": 540666477.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 457900267.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 470042422.0,
        "delta": 12142155.0
      },
      {
        "periodo": 202509,
        "valor": 479066195.0,
        "delta": 9023773.0
      },
      {
        "periodo": 202510,
        "valor": 473488264.0,
        "delta": -5577931.0
      },
      {
        "periodo": 202511,
        "valor": 474691740.0,
        "delta": 1203476.0
      },
      {
        "periodo": 202512,
        "valor": 475123102.0,
        "delta": 431362.0
      },
      {
        "periodo": 202601,
        "valor": 487211376.0,
        "delta": 12088274.0
      },
      {
        "periodo": 202602,
        "valor": 502483188.0,
        "delta": 15271812.0
      },
      {
        "periodo": 202603,
        "valor": 503006174.0,
        "delta": 522986.0
      },
      {
        "periodo": 202604,
        "valor": 502979719.0,
        "delta": -26455.0
      },
      {
        "periodo": 202605,
        "valor": 540389977.0,
        "delta": 37410258.0
      },
      {
        "periodo": 202606,
        "valor": 540666477.0,
        "delta": 276500.0
      },
      {
        "periodo": 202607,
        "valor": 547172334.0,
        "delta": 6505857.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 38036761.0,
    "valor_anterior": 55528417.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40153572.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 40625426.0,
        "delta": 471854.0
      },
      {
        "periodo": 202509,
        "valor": 40606853.0,
        "delta": -18573.0
      },
      {
        "periodo": 202510,
        "valor": 41250356.0,
        "delta": 643503.0
      },
      {
        "periodo": 202511,
        "valor": 28421888.0,
        "delta": -12828468.0
      },
      {
        "periodo": 202512,
        "valor": 29033472.0,
        "delta": 611584.0
      },
      {
        "periodo": 202601,
        "valor": 28981801.0,
        "delta": -51671.0
      },
      {
        "periodo": 202602,
        "valor": 28925876.0,
        "delta": -55925.0
      },
      {
        "periodo": 202603,
        "valor": 20796755.0,
        "delta": -8129121.0
      },
      {
        "periodo": 202604,
        "valor": 21170827.0,
        "delta": 374072.0
      },
      {
        "periodo": 202605,
        "valor": 21018539.0,
        "delta": -152288.0
      },
      {
        "periodo": 202606,
        "valor": 55528417.0,
        "delta": 34509878.0
      },
      {
        "periodo": 202607,
        "valor": 38036761.0,
        "delta": -17491656.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 306418306.26,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 526900987.94,
        "delta": 220482681.68
      },
      {
        "periodo": 202509,
        "valor": 505056597.56,
        "delta": -21844390.38
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 223802.38,
    "valor_anterior": 223802.38,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 642988.35,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 715539.94,
        "delta": 72551.59
      },
      {
        "periodo": 202509,
        "valor": 787172.16,
        "delta": 71632.22
      },
      {
        "periodo": 202510,
        "valor": 787172.16,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 258754.31,
        "delta": -528417.85
      },
      {
        "periodo": 202512,
        "valor": 338372.88,
        "delta": 79618.57
      },
      {
        "periodo": 202601,
        "valor": 338372.88,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 223802.38,
        "delta": -114570.5
      },
      {
        "periodo": 202603,
        "valor": 223802.38,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 223802.38,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 223802.38,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 223802.38,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 223802.38,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 67672329.0,
    "valor_anterior": 70079371.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 76400558.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 79037929.0,
        "delta": 2637371.0
      },
      {
        "periodo": 202509,
        "valor": 81456851.0,
        "delta": 2418922.0
      },
      {
        "periodo": 202510,
        "valor": 81528098.0,
        "delta": 71247.0
      },
      {
        "periodo": 202511,
        "valor": 81663699.0,
        "delta": 135601.0
      },
      {
        "periodo": 202512,
        "valor": 81342534.0,
        "delta": -321165.0
      },
      {
        "periodo": 202601,
        "valor": 83751926.0,
        "delta": 2409392.0
      },
      {
        "periodo": 202602,
        "valor": 83005422.0,
        "delta": -746504.0
      },
      {
        "periodo": 202603,
        "valor": 80535330.0,
        "delta": -2470092.0
      },
      {
        "periodo": 202604,
        "valor": 76375601.0,
        "delta": -4159729.0
      },
      {
        "periodo": 202605,
        "valor": 72638522.0,
        "delta": -3737079.0
      },
      {
        "periodo": 202606,
        "valor": 70079371.0,
        "delta": -2559151.0
      },
      {
        "periodo": 202607,
        "valor": 67672329.0,
        "delta": -2407042.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 6149623.58,
    "valor_anterior": 20195679.08,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17030318.4,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17412682.41,
        "delta": 382364.01
      },
      {
        "periodo": 202509,
        "valor": 17895623.33,
        "delta": 482940.92
      },
      {
        "periodo": 202510,
        "valor": 17895623.33,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 19888383.64,
        "delta": 1992760.31
      },
      {
        "periodo": 202512,
        "valor": 20197772.66,
        "delta": 309389.02
      },
      {
        "periodo": 202601,
        "valor": 20197772.66,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 20197772.66,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 20197772.66,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 20197772.66,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 20197772.66,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 20195679.08,
        "delta": -2093.58
      },
      {
        "periodo": 202607,
        "valor": 6149623.58,
        "delta": -14046055.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 55696196.76,
    "valor_anterior": 43898558.07,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 43349942.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29413969.09,
        "delta": -13935973.06
      },
      {
        "periodo": 202509,
        "valor": 8429538.85,
        "delta": -20984430.24
      },
      {
        "periodo": 202510,
        "valor": 8531811.59,
        "delta": 102272.74
      },
      {
        "periodo": 202511,
        "valor": 9601691.11,
        "delta": 1069879.52
      },
      {
        "periodo": 202512,
        "valor": 9909709.24,
        "delta": 308018.13
      },
      {
        "periodo": 202601,
        "valor": 8345967.04,
        "delta": -1563742.2
      },
      {
        "periodo": 202602,
        "valor": 3903689.23,
        "delta": -4442277.81
      },
      {
        "periodo": 202603,
        "valor": 5193044.72,
        "delta": 1289355.49
      },
      {
        "periodo": 202604,
        "valor": 11981672.34,
        "delta": 6788627.62
      },
      {
        "periodo": 202605,
        "valor": 13081620.6,
        "delta": 1099948.26
      },
      {
        "periodo": 202606,
        "valor": 43898558.07,
        "delta": 30816937.47
      },
      {
        "periodo": 202607,
        "valor": 55696196.76,
        "delta": 11797638.69
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 29244836.0,
    "valor_anterior": 29244836.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 29244836.0,
        "delta": 29244836.0
      },
      {
        "periodo": 202603,
        "valor": 29244836.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 29244836.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 29244836.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 29244836.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 29244836.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 43074075.35,
    "valor_anterior": 43074075.35,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 43074075.35,
        "delta": 43074075.35
      },
      {
        "periodo": 202511,
        "valor": 43074075.35,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 43074075.35,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 43074075.35,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 43074075.35,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 43074075.35,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 43074075.35,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 43074075.35,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 43074075.35,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 43074075.35,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 8522247.15,
    "valor_anterior": 11605263.42,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25120650.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 27727162.31,
        "delta": 2606511.59
      },
      {
        "periodo": 202509,
        "valor": 30108627.08,
        "delta": 2381464.77
      },
      {
        "periodo": 202510,
        "valor": 30923178.82,
        "delta": 814551.74
      },
      {
        "periodo": 202511,
        "valor": 31135988.61,
        "delta": 212809.79
      },
      {
        "periodo": 202512,
        "valor": 29931933.16,
        "delta": -1204055.45
      },
      {
        "periodo": 202601,
        "valor": 27778628.53,
        "delta": -2153304.63
      },
      {
        "periodo": 202602,
        "valor": 24293493.2,
        "delta": -3485135.33
      },
      {
        "periodo": 202603,
        "valor": 20471704.17,
        "delta": -3821789.03
      },
      {
        "periodo": 202604,
        "valor": 16770531.23,
        "delta": -3701172.94
      },
      {
        "periodo": 202605,
        "valor": 13781467.56,
        "delta": -2989063.67
      },
      {
        "periodo": 202606,
        "valor": 11605263.42,
        "delta": -2176204.14
      },
      {
        "periodo": 202607,
        "valor": 8522247.15,
        "delta": -3083016.27
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 237710914.21,
    "valor_anterior": 202550123.48,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 39774663.92,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 83305739.63,
        "delta": 43531075.71
      },
      {
        "periodo": 202604,
        "valor": 125336774.08,
        "delta": 42031034.45
      },
      {
        "periodo": 202605,
        "valor": 162162433.35,
        "delta": 36825659.27
      },
      {
        "periodo": 202606,
        "valor": 202550123.48,
        "delta": 40387690.13
      },
      {
        "periodo": 202607,
        "valor": 237710914.21,
        "delta": 35160790.73
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 158756262.0,
    "valor_anterior": 138013148.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 50325.0,
        "delta": 50325.0
      },
      {
        "periodo": 202509,
        "valor": 1200190.0,
        "delta": 1149865.0
      },
      {
        "periodo": 202510,
        "valor": 2861130.0,
        "delta": 1660940.0
      },
      {
        "periodo": 202511,
        "valor": 8533761.0,
        "delta": 5672631.0
      },
      {
        "periodo": 202512,
        "valor": 25587799.0,
        "delta": 17054038.0
      },
      {
        "periodo": 202601,
        "valor": 46770705.0,
        "delta": 21182906.0
      },
      {
        "periodo": 202602,
        "valor": 70341108.0,
        "delta": 23570403.0
      },
      {
        "periodo": 202603,
        "valor": 89104944.0,
        "delta": 18763836.0
      },
      {
        "periodo": 202604,
        "valor": 103521538.0,
        "delta": 14416594.0
      },
      {
        "periodo": 202605,
        "valor": 118643870.0,
        "delta": 15122332.0
      },
      {
        "periodo": 202606,
        "valor": 138013148.0,
        "delta": 19369278.0
      },
      {
        "periodo": 202607,
        "valor": 158756262.0,
        "delta": 20743114.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 7565.0,
    "valor_anterior": 420.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 420.0,
        "delta": 420.0
      },
      {
        "periodo": 202605,
        "valor": 420.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 420.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 7565.0,
        "delta": 7145.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 935761634.0,
    "valor_anterior": 935761634.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 417389921.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 417389921.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 417389921.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 935761634.0,
        "delta": 518371713.0
      },
      {
        "periodo": 202607,
        "valor": 935761634.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 215591255693.4,
    "valor_anterior": 212237490138.99002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 180218586788.69,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 182861961688.73,
        "delta": 2643374900.04
      },
      {
        "periodo": 202509,
        "valor": 185236014864.24,
        "delta": 2374053175.51
      },
      {
        "periodo": 202510,
        "valor": 188175452239.56,
        "delta": 2939437375.32
      },
      {
        "periodo": 202511,
        "valor": 191591838209.77,
        "delta": 3416385970.21
      },
      {
        "periodo": 202512,
        "valor": 196225534028.87,
        "delta": 4633695819.1
      },
      {
        "periodo": 202601,
        "valor": 197122246129.02,
        "delta": 896712100.15
      },
      {
        "periodo": 202602,
        "valor": 200463136610.87,
        "delta": 3340890481.85
      },
      {
        "periodo": 202603,
        "valor": 202409322375.21,
        "delta": 1946185764.34
      },
      {
        "periodo": 202604,
        "valor": 207167823345.43,
        "delta": 4758500970.22
      },
      {
        "periodo": 202605,
        "valor": 209458033503.12,
        "delta": 2290210157.69
      },
      {
        "periodo": 202606,
        "valor": 212237490138.99,
        "delta": 2779456635.87
      },
      {
        "periodo": 202607,
        "valor": 215591255693.4,
        "delta": 3353765554.41
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 172850743462.04,
    "valor_anterior": 171074031675.7,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 150982147563.78,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 153095913916.46,
        "delta": 2113766352.68
      },
      {
        "periodo": 202509,
        "valor": 155206324367.1,
        "delta": 2110410450.64
      },
      {
        "periodo": 202510,
        "valor": 156418657057.16,
        "delta": 1212332690.06
      },
      {
        "periodo": 202511,
        "valor": 159621708224.95,
        "delta": 3203051167.79
      },
      {
        "periodo": 202512,
        "valor": 161983419343.03,
        "delta": 2361711118.08
      },
      {
        "periodo": 202601,
        "valor": 162072045380.04,
        "delta": 88626037.01
      },
      {
        "periodo": 202602,
        "valor": 164336777708.64,
        "delta": 2264732328.6
      },
      {
        "periodo": 202603,
        "valor": 165048064910.68,
        "delta": 711287202.04
      },
      {
        "periodo": 202604,
        "valor": 168668674794.21,
        "delta": 3620609883.53
      },
      {
        "periodo": 202605,
        "valor": 169980545139.19,
        "delta": 1311870344.98
      },
      {
        "periodo": 202606,
        "valor": 171074031675.7,
        "delta": 1093486536.51
      },
      {
        "periodo": 202607,
        "valor": 172850743462.04,
        "delta": 1776711786.34
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 800288832.44,
    "valor_anterior": 786914294.23,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 509216376.39,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 588570317.74,
        "delta": 79353941.35
      },
      {
        "periodo": 202509,
        "valor": 552751672.59,
        "delta": -35818645.15
      },
      {
        "periodo": 202510,
        "valor": 612006749.89,
        "delta": 59255077.3
      },
      {
        "periodo": 202511,
        "valor": 663149866.23,
        "delta": 51143116.34
      },
      {
        "periodo": 202512,
        "valor": 844987812.61,
        "delta": 181837946.38
      },
      {
        "periodo": 202601,
        "valor": 835365820.69,
        "delta": -9621991.92
      },
      {
        "periodo": 202602,
        "valor": 823791735.53,
        "delta": -11574085.16
      },
      {
        "periodo": 202603,
        "valor": 811190327.46,
        "delta": -12601408.07
      },
      {
        "periodo": 202604,
        "valor": 795746308.56,
        "delta": -15444018.9
      },
      {
        "periodo": 202605,
        "valor": 767087431.93,
        "delta": -28658876.63
      },
      {
        "periodo": 202606,
        "valor": 786914294.23,
        "delta": 19826862.3
      },
      {
        "periodo": 202607,
        "valor": 800288832.44,
        "delta": 13374538.21
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 6968130939.000001,
    "valor_anterior": 6868377063.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5515698975.94,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5665011365.94,
        "delta": 149312390.0
      },
      {
        "periodo": 202509,
        "valor": 5809061106.94,
        "delta": 144049741.0
      },
      {
        "periodo": 202510,
        "valor": 6047623648.94,
        "delta": 238562542.0
      },
      {
        "periodo": 202511,
        "valor": 5372922082.94,
        "delta": -674701566.0
      },
      {
        "periodo": 202512,
        "valor": 6225631672.02,
        "delta": 852709589.08
      },
      {
        "periodo": 202601,
        "valor": 6245391161.02,
        "delta": 19759489.0
      },
      {
        "periodo": 202602,
        "valor": 6414736864.0,
        "delta": 169345702.98
      },
      {
        "periodo": 202603,
        "valor": 6556300945.0,
        "delta": 141564081.0
      },
      {
        "periodo": 202604,
        "valor": 6554023429.0,
        "delta": -2277516.0
      },
      {
        "periodo": 202605,
        "valor": 6710784514.0,
        "delta": 156761085.0
      },
      {
        "periodo": 202606,
        "valor": 6868377063.0,
        "delta": 157592549.0
      },
      {
        "periodo": 202607,
        "valor": 6968130939.0,
        "delta": 99753876.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 5898557313.030001,
    "valor_anterior": 5849951454.910001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4970434086.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4915729737.56,
        "delta": -54704348.59
      },
      {
        "periodo": 202509,
        "valor": 4459983250.16,
        "delta": -455746487.4
      },
      {
        "periodo": 202510,
        "valor": 4815302762.31,
        "delta": 355319512.15
      },
      {
        "periodo": 202511,
        "valor": 5025417213.84,
        "delta": 210114451.53
      },
      {
        "periodo": 202512,
        "valor": 5854932749.51,
        "delta": 829515535.67
      },
      {
        "periodo": 202601,
        "valor": 5958831555.45,
        "delta": 103898805.94
      },
      {
        "periodo": 202602,
        "valor": 6255157763.29,
        "delta": 296326207.84
      },
      {
        "periodo": 202603,
        "valor": 6080578258.69,
        "delta": -174579504.6
      },
      {
        "periodo": 202604,
        "valor": 6284977914.85,
        "delta": 204399656.16
      },
      {
        "periodo": 202605,
        "valor": 6100258164.59,
        "delta": -184719750.26
      },
      {
        "periodo": 202606,
        "valor": 5849951454.91,
        "delta": -250306709.68
      },
      {
        "periodo": 202607,
        "valor": 5898557313.03,
        "delta": 48605858.12
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 573643973.35,
    "valor_anterior": 558863664.22,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 258945723.28,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 252802410.2,
        "delta": -6143313.08
      },
      {
        "periodo": 202509,
        "valor": 239656493.1,
        "delta": -13145917.1
      },
      {
        "periodo": 202510,
        "valor": 286454435.19,
        "delta": 46797942.09
      },
      {
        "periodo": 202511,
        "valor": 296150026.45,
        "delta": 9695591.26
      },
      {
        "periodo": 202512,
        "valor": 278734012.07,
        "delta": -17416014.38
      },
      {
        "periodo": 202601,
        "valor": 289893793.64,
        "delta": 11159781.57
      },
      {
        "periodo": 202602,
        "valor": 324069029.98,
        "delta": 34175236.34
      },
      {
        "periodo": 202603,
        "valor": 341977732.83,
        "delta": 17908702.85
      },
      {
        "periodo": 202604,
        "valor": 365762042.66,
        "delta": 23784309.83
      },
      {
        "periodo": 202605,
        "valor": 383695423.18,
        "delta": 17933380.52
      },
      {
        "periodo": 202606,
        "valor": 558863664.22,
        "delta": 175168241.04
      },
      {
        "periodo": 202607,
        "valor": 573643973.35,
        "delta": 14780309.13
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200193,
    "label": "Quitas y Castigos Total (Suma 12m)",
    "valor_actual": 28499891173.539997,
    "valor_anterior": 27099351986.93,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17982144063.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18343933940.83,
        "delta": 361789877.68
      },
      {
        "periodo": 202509,
        "valor": 18968237974.35,
        "delta": 624304033.52
      },
      {
        "periodo": 202510,
        "valor": 19995407586.07,
        "delta": 1027169611.72
      },
      {
        "periodo": 202511,
        "valor": 20612490795.36,
        "delta": 617083209.29
      },
      {
        "periodo": 202512,
        "valor": 21037828439.63,
        "delta": 425337644.27
      },
      {
        "periodo": 202601,
        "valor": 21720718418.18,
        "delta": 682889978.55
      },
      {
        "periodo": 202602,
        "valor": 22308603509.43,
        "delta": 587885091.25
      },
      {
        "periodo": 202603,
        "valor": 23571210200.55,
        "delta": 1262606691.12
      },
      {
        "periodo": 202604,
        "valor": 24498638856.15,
        "delta": 927428655.6
      },
      {
        "periodo": 202605,
        "valor": 25515662830.23,
        "delta": 1017023974.08
      },
      {
        "periodo": 202606,
        "valor": 27099351986.93,
        "delta": 1583689156.7
      },
      {
        "periodo": 202607,
        "valor": 28499891173.54,
        "delta": 1400539186.61
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 1028361755.39,
    "valor_anterior": 1041314399.05,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 911619457.65,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 930368299.35,
        "delta": 18748841.7
      },
      {
        "periodo": 202509,
        "valor": 954852705.63,
        "delta": 24484406.28
      },
      {
        "periodo": 202510,
        "valor": 993166438.28,
        "delta": 38313732.65
      },
      {
        "periodo": 202511,
        "valor": 908393426.99,
        "delta": -84773011.29
      },
      {
        "periodo": 202512,
        "valor": 949277853.17,
        "delta": 40884426.18
      },
      {
        "periodo": 202601,
        "valor": 946986272.4,
        "delta": -2291580.77
      },
      {
        "periodo": 202602,
        "valor": 897802248.82,
        "delta": -49184023.58
      },
      {
        "periodo": 202603,
        "valor": 904846426.11,
        "delta": 7044177.29
      },
      {
        "periodo": 202604,
        "valor": 954744783.82,
        "delta": 49898357.71
      },
      {
        "periodo": 202605,
        "valor": 976749674.86,
        "delta": 22004891.04
      },
      {
        "periodo": 202606,
        "valor": 1041314399.05,
        "delta": 64564724.19
      },
      {
        "periodo": 202607,
        "valor": 1028361755.39,
        "delta": -12952643.66
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 5384492779.32,
    "valor_anterior": 5370105952.32,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3575674563.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3691316647.0,
        "delta": 115642084.0
      },
      {
        "periodo": 202509,
        "valor": 3755970573.0,
        "delta": 64653926.0
      },
      {
        "periodo": 202510,
        "valor": 3678089044.28,
        "delta": -77881528.72
      },
      {
        "periodo": 202511,
        "valor": 3670628187.71,
        "delta": -7460856.57
      },
      {
        "periodo": 202512,
        "valor": 4768112576.28,
        "delta": 1097484388.57
      },
      {
        "periodo": 202601,
        "valor": 4761828826.51,
        "delta": -6283749.77
      },
      {
        "periodo": 202602,
        "valor": 5085158729.3,
        "delta": 323329902.79
      },
      {
        "periodo": 202603,
        "valor": 5186868725.85,
        "delta": 101709996.55
      },
      {
        "periodo": 202604,
        "valor": 5172645573.32,
        "delta": -14223152.53
      },
      {
        "periodo": 202605,
        "valor": 5320038090.32,
        "delta": 147392517.0
      },
      {
        "periodo": 202606,
        "valor": 5370105952.32,
        "delta": 50067862.0
      },
      {
        "periodo": 202607,
        "valor": 5384492779.32,
        "delta": 14386827.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 6436277539.000001,
    "valor_anterior": 6269906708.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5286658440.06,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5422336225.06,
        "delta": 135677785.0
      },
      {
        "periodo": 202509,
        "valor": 5484080714.06,
        "delta": 61744489.0
      },
      {
        "periodo": 202510,
        "valor": 5201399999.06,
        "delta": -282680715.0
      },
      {
        "periodo": 202511,
        "valor": 5279382181.0,
        "delta": 77982181.94
      },
      {
        "periodo": 202512,
        "valor": 5408660054.0,
        "delta": 129277873.0
      },
      {
        "periodo": 202601,
        "valor": 5517697735.0,
        "delta": 109037681.0
      },
      {
        "periodo": 202602,
        "valor": 5825618791.0,
        "delta": 307921056.0
      },
      {
        "periodo": 202603,
        "valor": 5952056694.0,
        "delta": 126437903.0
      },
      {
        "periodo": 202604,
        "valor": 6105824896.0,
        "delta": 153768202.0
      },
      {
        "periodo": 202605,
        "valor": 6130776091.0,
        "delta": 24951195.0
      },
      {
        "periodo": 202606,
        "valor": 6269906708.0,
        "delta": 139130617.0
      },
      {
        "periodo": 202607,
        "valor": 6436277539.0,
        "delta": 166370831.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 1472199182.0,
    "valor_anterior": 1477795432.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1636911558.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1574210769.0,
        "delta": -62700789.0
      },
      {
        "periodo": 202509,
        "valor": 1619514048.0,
        "delta": 45303279.0
      },
      {
        "periodo": 202510,
        "valor": 1647705094.0,
        "delta": 28191046.0
      },
      {
        "periodo": 202511,
        "valor": 2015840600.0,
        "delta": 368135506.0
      },
      {
        "periodo": 202512,
        "valor": 1883430944.0,
        "delta": -132409656.0
      },
      {
        "periodo": 202601,
        "valor": 1873870823.0,
        "delta": -9560121.0
      },
      {
        "periodo": 202602,
        "valor": 1874242511.0,
        "delta": 371688.0
      },
      {
        "periodo": 202603,
        "valor": 1890547249.0,
        "delta": 16304738.0
      },
      {
        "periodo": 202604,
        "valor": 1502856551.0,
        "delta": -387690698.0
      },
      {
        "periodo": 202605,
        "valor": 1476223807.0,
        "delta": -26632744.0
      },
      {
        "periodo": 202606,
        "valor": 1477795432.0,
        "delta": 1571625.0
      },
      {
        "periodo": 202607,
        "valor": 1472199182.0,
        "delta": -5596250.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 1788284224.87,
    "valor_anterior": 1756473752.4,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1969968332.44,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1799058400.36,
        "delta": -170909932.08
      },
      {
        "periodo": 202509,
        "valor": 1404127278.79,
        "delta": -394931121.57
      },
      {
        "periodo": 202510,
        "valor": 1561322015.14,
        "delta": 157194736.35
      },
      {
        "periodo": 202511,
        "valor": 1815089267.29,
        "delta": 253767252.15
      },
      {
        "periodo": 202512,
        "valor": 2122357898.32,
        "delta": 307268631.03
      },
      {
        "periodo": 202601,
        "valor": 2127775154.84,
        "delta": 5417256.52
      },
      {
        "periodo": 202602,
        "valor": 1973067817.5,
        "delta": -154707337.34
      },
      {
        "periodo": 202603,
        "valor": 1936313456.39,
        "delta": -36754361.11
      },
      {
        "periodo": 202604,
        "valor": 2027294356.02,
        "delta": 90980899.63
      },
      {
        "periodo": 202605,
        "valor": 1918191893.68,
        "delta": -109102462.34
      },
      {
        "periodo": 202606,
        "valor": 1756473752.4,
        "delta": -161718141.28
      },
      {
        "periodo": 202607,
        "valor": 1788284224.87,
        "delta": 31810472.47
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 349317802.0,
    "valor_anterior": 351725746.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1040542716.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1045310820.0,
        "delta": 4768104.0
      },
      {
        "periodo": 202509,
        "valor": 1061990112.0,
        "delta": 16679292.0
      },
      {
        "periodo": 202510,
        "valor": 1071849161.0,
        "delta": 9859049.0
      },
      {
        "periodo": 202511,
        "valor": 1047232686.0,
        "delta": -24616475.0
      },
      {
        "periodo": 202512,
        "valor": 1059797527.0,
        "delta": 12564841.0
      },
      {
        "periodo": 202601,
        "valor": 1077703546.0,
        "delta": 17906019.0
      },
      {
        "periodo": 202602,
        "valor": 1086003099.0,
        "delta": 8299553.0
      },
      {
        "periodo": 202603,
        "valor": 1102558699.0,
        "delta": 16555600.0
      },
      {
        "periodo": 202604,
        "valor": 1161763143.0,
        "delta": 59204444.0
      },
      {
        "periodo": 202605,
        "valor": 1174347213.0,
        "delta": 12584070.0
      },
      {
        "periodo": 202606,
        "valor": 351725746.0,
        "delta": -822621467.0
      },
      {
        "periodo": 202607,
        "valor": 349317802.0,
        "delta": -2407944.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 465886655.0,
    "valor_anterior": 470184218.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 314737462.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 329906296.0,
        "delta": 15168834.0
      },
      {
        "periodo": 202509,
        "valor": 360880517.0,
        "delta": 30974221.0
      },
      {
        "periodo": 202510,
        "valor": 395644544.0,
        "delta": 34764027.0
      },
      {
        "periodo": 202511,
        "valor": 399860978.0,
        "delta": 4216434.0
      },
      {
        "periodo": 202512,
        "valor": 611090298.0,
        "delta": 211229320.0
      },
      {
        "periodo": 202601,
        "valor": 597637233.0,
        "delta": -13453065.0
      },
      {
        "periodo": 202602,
        "valor": 596819128.0,
        "delta": -818105.0
      },
      {
        "periodo": 202603,
        "valor": 572490013.0,
        "delta": -24329115.0
      },
      {
        "periodo": 202604,
        "valor": 588553575.0,
        "delta": 16063562.0
      },
      {
        "periodo": 202605,
        "valor": 529325582.0,
        "delta": -59227993.0
      },
      {
        "periodo": 202606,
        "valor": 470184218.0,
        "delta": -59141364.0
      },
      {
        "periodo": 202607,
        "valor": 465886655.0,
        "delta": -4297563.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 222605365.0,
    "valor_anterior": 217141959.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2517687047.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2516983499.0,
        "delta": -703548.0
      },
      {
        "periodo": 202509,
        "valor": 2506399555.0,
        "delta": -10583944.0
      },
      {
        "periodo": 202510,
        "valor": 2427408452.0,
        "delta": -78991103.0
      },
      {
        "periodo": 202511,
        "valor": 2535736566.0,
        "delta": 108328114.0
      },
      {
        "periodo": 202512,
        "valor": 1815921280.0,
        "delta": -719815286.0
      },
      {
        "periodo": 202601,
        "valor": 349107867.0,
        "delta": -1466813413.0
      },
      {
        "periodo": 202602,
        "valor": 349222530.0,
        "delta": 114663.0
      },
      {
        "periodo": 202603,
        "valor": 307259787.0,
        "delta": -41962743.0
      },
      {
        "periodo": 202604,
        "valor": 394669996.0,
        "delta": 87410209.0
      },
      {
        "periodo": 202605,
        "valor": 217151159.0,
        "delta": -177518837.0
      },
      {
        "periodo": 202606,
        "valor": 217141959.0,
        "delta": -9200.0
      },
      {
        "periodo": 202607,
        "valor": 222605365.0,
        "delta": 5463406.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 1028472521.79,
    "valor_anterior": 1013830942.8,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 588383572.01,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 659821379.61,
        "delta": 71437807.6
      },
      {
        "periodo": 202509,
        "valor": 620194314.71,
        "delta": -39627064.9
      },
      {
        "periodo": 202510,
        "valor": 627804407.56,
        "delta": 7610092.85
      },
      {
        "periodo": 202511,
        "valor": 649701220.32,
        "delta": 21896812.76
      },
      {
        "periodo": 202512,
        "valor": 1031127907.2,
        "delta": 381426686.88
      },
      {
        "periodo": 202601,
        "valor": 1098854326.96,
        "delta": 67726419.76
      },
      {
        "periodo": 202602,
        "valor": 1073560846.97,
        "delta": -25293479.99
      },
      {
        "periodo": 202603,
        "valor": 974894776.45,
        "delta": -98666070.52
      },
      {
        "periodo": 202604,
        "valor": 964369591.23,
        "delta": -10525185.22
      },
      {
        "periodo": 202605,
        "valor": 992933120.51,
        "delta": 28563529.28
      },
      {
        "periodo": 202606,
        "valor": 1013830942.8,
        "delta": 20897822.29
      },
      {
        "periodo": 202607,
        "valor": 1028472521.79,
        "delta": 14641578.99
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 134777025.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 134777025.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 134777025.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 134777025.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 134777025.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 134777025.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 134777025.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 134777025.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 134777025.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 1140786809.0,
    "valor_anterior": 1139831411.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 798604590.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 837155632.0,
        "delta": 38551042.0
      },
      {
        "periodo": 202509,
        "valor": 838856373.0,
        "delta": 1700741.0
      },
      {
        "periodo": 202510,
        "valor": 861585318.0,
        "delta": 22728945.0
      },
      {
        "periodo": 202511,
        "valor": 118824781.0,
        "delta": -742760537.0
      },
      {
        "periodo": 202512,
        "valor": 1117927633.0,
        "delta": 999102852.0
      },
      {
        "periodo": 202601,
        "valor": 1123838982.0,
        "delta": 5911349.0
      },
      {
        "periodo": 202602,
        "valor": 1127139596.0,
        "delta": 3300614.0
      },
      {
        "periodo": 202603,
        "valor": 1126843323.0,
        "delta": -296273.0
      },
      {
        "periodo": 202604,
        "valor": 1137635620.0,
        "delta": 10792297.0
      },
      {
        "periodo": 202605,
        "valor": 1134078528.0,
        "delta": -3557092.0
      },
      {
        "periodo": 202606,
        "valor": 1139831411.0,
        "delta": 5752883.0
      },
      {
        "periodo": 202607,
        "valor": 1140786809.0,
        "delta": 955398.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 1891842778.31,
    "valor_anterior": 1880651706.7500002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1750068744.46,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1790354405.32,
        "delta": 40285660.86
      },
      {
        "periodo": 202509,
        "valor": 1532750723.53,
        "delta": -257603681.79
      },
      {
        "periodo": 202510,
        "valor": 1556394337.23,
        "delta": 23643613.7
      },
      {
        "periodo": 202511,
        "valor": 1639230340.8,
        "delta": 82836003.57
      },
      {
        "periodo": 202512,
        "valor": 1794197146.14,
        "delta": 154966805.34
      },
      {
        "periodo": 202601,
        "valor": 1793493880.61,
        "delta": -703265.53
      },
      {
        "periodo": 202602,
        "valor": 1698288200.91,
        "delta": -95205679.7
      },
      {
        "periodo": 202603,
        "valor": 1706512043.63,
        "delta": 8223842.72
      },
      {
        "periodo": 202604,
        "valor": 1738050610.23,
        "delta": 31538566.6
      },
      {
        "periodo": 202605,
        "valor": 1767701527.04,
        "delta": 29650916.81
      },
      {
        "periodo": 202606,
        "valor": 1880651706.75,
        "delta": 112950179.71
      },
      {
        "periodo": 202607,
        "valor": 1891842778.31,
        "delta": 11191071.56
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 571876617.76,
    "valor_anterior": 537840216.79,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 189002465.82,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 47873725.49,
        "delta": -141128740.33
      },
      {
        "periodo": 202509,
        "valor": 41957883.95,
        "delta": -5915841.54
      },
      {
        "periodo": 202510,
        "valor": 114839935.62,
        "delta": 72882051.67
      },
      {
        "periodo": 202511,
        "valor": 195728648.39,
        "delta": 80888712.77
      },
      {
        "periodo": 202512,
        "valor": 442605667.84,
        "delta": 246877019.45
      },
      {
        "periodo": 202601,
        "valor": 447156045.62,
        "delta": 4550377.78
      },
      {
        "periodo": 202602,
        "valor": 449313902.71,
        "delta": 2157857.09
      },
      {
        "periodo": 202603,
        "valor": 450142279.64,
        "delta": 828376.93
      },
      {
        "periodo": 202604,
        "valor": 449108416.78,
        "delta": -1033862.86
      },
      {
        "periodo": 202605,
        "valor": 453475185.74,
        "delta": 4366768.96
      },
      {
        "periodo": 202606,
        "valor": 537840216.79,
        "delta": 84365031.05
      },
      {
        "periodo": 202607,
        "valor": 571876617.76,
        "delta": 34036400.97
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 322266759.0,
    "valor_anterior": 304144473.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 116054216.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 91748408.0,
        "delta": -24305808.0
      },
      {
        "periodo": 202509,
        "valor": 106533110.0,
        "delta": 14784702.0
      },
      {
        "periodo": 202510,
        "valor": 110732616.0,
        "delta": 4199506.0
      },
      {
        "periodo": 202511,
        "valor": 164989094.0,
        "delta": 54256478.0
      },
      {
        "periodo": 202512,
        "valor": 164989094.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 161443073.0,
        "delta": -3546021.0
      },
      {
        "periodo": 202602,
        "valor": 170515431.0,
        "delta": 9072358.0
      },
      {
        "periodo": 202603,
        "valor": 170515431.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 298099677.0,
        "delta": 127584246.0
      },
      {
        "periodo": 202605,
        "valor": 298099677.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 304144473.0,
        "delta": 6044796.0
      },
      {
        "periodo": 202607,
        "valor": 322266759.0,
        "delta": 18122286.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 237525642.94,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 237525642.94,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 237525642.94,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 237525642.94,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 237525642.94,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.02,
        "delta": -237525642.92
      },
      {
        "periodo": 202601,
        "valor": 0.02,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -0.02
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 103821506.07,
    "valor_anterior": 103821506.07,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17371863.44,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17371863.44,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 17371863.44,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 17371863.44,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 17371863.44,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": -17371863.44
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 103821506.07,
        "delta": 103821506.07
      },
      {
        "periodo": 202607,
        "valor": 103821506.07,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 117506788.0,
    "valor_anterior": 121875175.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 204092669.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 204092669.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 208380828.0,
        "delta": 4288159.0
      },
      {
        "periodo": 202510,
        "valor": 306450328.0,
        "delta": 98069500.0
      },
      {
        "periodo": 202511,
        "valor": 141458202.0,
        "delta": -164992126.0
      },
      {
        "periodo": 202512,
        "valor": 140705314.0,
        "delta": -752888.0
      },
      {
        "periodo": 202601,
        "valor": 142294419.0,
        "delta": 1589105.0
      },
      {
        "periodo": 202602,
        "valor": 142294419.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 141845800.0,
        "delta": -448619.0
      },
      {
        "periodo": 202604,
        "valor": 142525298.0,
        "delta": 679498.0
      },
      {
        "periodo": 202605,
        "valor": 142525298.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 121875175.0,
        "delta": -20650123.0
      },
      {
        "periodo": 202607,
        "valor": 117506788.0,
        "delta": -4368387.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8055634.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8055634.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": -8055634.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 739133090.74,
    "valor_anterior": 739133090.74,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 667003082.97,
        "delta": 667003082.97
      },
      {
        "periodo": 202511,
        "valor": 667003082.97,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 738705577.34,
        "delta": 71702494.37
      },
      {
        "periodo": 202601,
        "valor": 738929477.25,
        "delta": 223899.91
      },
      {
        "periodo": 202602,
        "valor": 739090137.58,
        "delta": 160660.33
      },
      {
        "periodo": 202603,
        "valor": 739106114.05,
        "delta": 15976.47
      },
      {
        "periodo": 202604,
        "valor": 739133090.74,
        "delta": 26976.69
      },
      {
        "periodo": 202605,
        "valor": 739133090.74,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 739133090.74,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 739133090.74,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2127053.75,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2088635.68,
        "delta": -38418.07
      },
      {
        "periodo": 202509,
        "valor": 2088635.68,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 2088635.68,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 2088635.68,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 2088635.68,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 2088635.68,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": -2088635.68
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 139286068.2,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 156861842.41,
        "delta": 17575774.21
      },
      {
        "periodo": 202509,
        "valor": 153059254.74,
        "delta": -3802587.67
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 4156863.27,
    "valor_anterior": 18202918.77,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17030318.4,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17412682.41,
        "delta": 382364.01
      },
      {
        "periodo": 202509,
        "valor": 17895623.33,
        "delta": 482940.92
      },
      {
        "periodo": 202510,
        "valor": 17895623.33,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 17895623.33,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 18205012.35,
        "delta": 309389.02
      },
      {
        "periodo": 202601,
        "valor": 18205012.35,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 18205012.35,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 18205012.35,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 18205012.35,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 18205012.35,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 18202918.77,
        "delta": -2093.58
      },
      {
        "periodo": 202607,
        "valor": 4156863.27,
        "delta": -14046055.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 55696196.76,
    "valor_anterior": 43898558.07,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 43349942.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 29413969.09,
        "delta": -13935973.06
      },
      {
        "periodo": 202509,
        "valor": 8429538.85,
        "delta": -20984430.24
      },
      {
        "periodo": 202510,
        "valor": 8531811.59,
        "delta": 102272.74
      },
      {
        "periodo": 202511,
        "valor": 9601691.11,
        "delta": 1069879.52
      },
      {
        "periodo": 202512,
        "valor": 9909709.24,
        "delta": 308018.13
      },
      {
        "periodo": 202601,
        "valor": 8345967.04,
        "delta": -1563742.2
      },
      {
        "periodo": 202602,
        "valor": 3903689.23,
        "delta": -4442277.81
      },
      {
        "periodo": 202603,
        "valor": 5193044.72,
        "delta": 1289355.49
      },
      {
        "periodo": 202604,
        "valor": 11981672.34,
        "delta": 6788627.62
      },
      {
        "periodo": 202605,
        "valor": 13081620.6,
        "delta": 1099948.26
      },
      {
        "periodo": 202606,
        "valor": 43898558.07,
        "delta": 30816937.47
      },
      {
        "periodo": 202607,
        "valor": 55696196.76,
        "delta": 11797638.69
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 29244836.0,
    "valor_anterior": 29244836.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 29244836.0,
        "delta": 29244836.0
      },
      {
        "periodo": 202603,
        "valor": 29244836.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 29244836.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 29244836.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 29244836.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 29244836.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 17814489.57,
    "valor_anterior": 14108555.9,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 545154.17,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 4926812.55,
        "delta": 4381658.38
      },
      {
        "periodo": 202604,
        "valor": 7925677.94,
        "delta": 2998865.39
      },
      {
        "periodo": 202605,
        "valor": 10364614.78,
        "delta": 2438936.84
      },
      {
        "periodo": 202606,
        "valor": 14108555.9,
        "delta": 3743941.12
      },
      {
        "periodo": 202607,
        "valor": 17814489.57,
        "delta": 3705933.67
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 23188728924.9,
    "valor_anterior": 22928025357.5,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 21499529381.32,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21544044470.16,
        "delta": 44515088.84
      },
      {
        "periodo": 202509,
        "valor": 21067636320.65,
        "delta": -476408149.51
      },
      {
        "periodo": 202510,
        "valor": 21789803797.36,
        "delta": 722167476.71
      },
      {
        "periodo": 202511,
        "valor": 21813031660.26,
        "delta": 23227862.9
      },
      {
        "periodo": 202512,
        "valor": 24304258476.03,
        "delta": 2491226815.77
      },
      {
        "periodo": 202601,
        "valor": 23010350294.63,
        "delta": -1293908181.4
      },
      {
        "periodo": 202602,
        "valor": 23361637445.53,
        "delta": 351287150.9
      },
      {
        "periodo": 202603,
        "valor": 23440014792.61,
        "delta": 78377347.08
      },
      {
        "periodo": 202604,
        "valor": 23526153217.6,
        "delta": 86138424.99
      },
      {
        "periodo": 202605,
        "valor": 23412961371.06,
        "delta": -113191846.54
      },
      {
        "periodo": 202606,
        "valor": 22928025357.5,
        "delta": -484936013.56
      },
      {
        "periodo": 202607,
        "valor": 23188728924.9,
        "delta": 260703567.4
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 16785097201.02,
    "valor_anterior": 16608641903.12,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16719162526.17,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16970880664.73,
        "delta": 251718138.56
      },
      {
        "periodo": 202509,
        "valor": 16915558431.22,
        "delta": -55322233.51
      },
      {
        "periodo": 202510,
        "valor": 16576012525.85,
        "delta": -339545905.37
      },
      {
        "periodo": 202511,
        "valor": 17096443988.5,
        "delta": 520431462.65
      },
      {
        "periodo": 202512,
        "valor": 17679397380.59,
        "delta": 582953392.09
      },
      {
        "periodo": 202601,
        "valor": 16320688950.52,
        "delta": -1358708430.07
      },
      {
        "periodo": 202602,
        "valor": 16816336110.03,
        "delta": 495647159.51
      },
      {
        "periodo": 202603,
        "valor": 17050649624.59,
        "delta": 234313514.56
      },
      {
        "periodo": 202604,
        "valor": 17030555553.37,
        "delta": -20094071.22
      },
      {
        "periodo": 202605,
        "valor": 17062987562.22,
        "delta": 32432008.85
      },
      {
        "periodo": 202606,
        "valor": 16608641903.12,
        "delta": -454345659.1
      },
      {
        "periodo": 202607,
        "valor": 16785097201.02,
        "delta": 176455297.9
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 590560983.81,
    "valor_anterior": 564634016.63,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 336344168.02,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 212791201.9,
        "delta": -123552966.12
      },
      {
        "periodo": 202509,
        "valor": 195017138.69,
        "delta": -17774063.21
      },
      {
        "periodo": 202510,
        "valor": 265058357.86,
        "delta": 70041219.17
      },
      {
        "periodo": 202511,
        "valor": 340400564.68,
        "delta": 75342206.82
      },
      {
        "periodo": 202512,
        "valor": 532976991.29,
        "delta": 192576426.61
      },
      {
        "periodo": 202601,
        "valor": 535472037.97,
        "delta": 2495046.68
      },
      {
        "periodo": 202602,
        "valor": 536138242.7,
        "delta": 666204.73
      },
      {
        "periodo": 202603,
        "valor": 535009523.51,
        "delta": -1128719.19
      },
      {
        "periodo": 202604,
        "valor": 530629257.61,
        "delta": -4380265.9
      },
      {
        "periodo": 202605,
        "valor": 524790535.18,
        "delta": -5838722.43
      },
      {
        "periodo": 202606,
        "valor": 564634016.63,
        "delta": 39843481.45
      },
      {
        "periodo": 202607,
        "valor": 590560983.81,
        "delta": 25926967.18
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 1140786809.0,
    "valor_anterior": 1139831411.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1170907257.94,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1209458299.94,
        "delta": 38551042.0
      },
      {
        "periodo": 202509,
        "valor": 1211159040.94,
        "delta": 1700741.0
      },
      {
        "periodo": 202510,
        "valor": 1233887985.94,
        "delta": 22728945.0
      },
      {
        "periodo": 202511,
        "valor": 491127448.94,
        "delta": -742760537.0
      },
      {
        "periodo": 202512,
        "valor": 1252704658.02,
        "delta": 761577209.08
      },
      {
        "periodo": 202601,
        "valor": 1258616007.02,
        "delta": 5911349.0
      },
      {
        "periodo": 202602,
        "valor": 1261916621.0,
        "delta": 3300613.98
      },
      {
        "periodo": 202603,
        "valor": 1261620348.0,
        "delta": -296273.0
      },
      {
        "periodo": 202604,
        "valor": 1137635620.0,
        "delta": -123984728.0
      },
      {
        "periodo": 202605,
        "valor": 1134078528.0,
        "delta": -3557092.0
      },
      {
        "periodo": 202606,
        "valor": 1139831411.0,
        "delta": 5752883.0
      },
      {
        "periodo": 202607,
        "valor": 1140786809.0,
        "delta": 955398.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 3722416948.66,
    "valor_anterior": 3666508561.2,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3193236251.45,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3084627152.97,
        "delta": -108609098.48
      },
      {
        "periodo": 202509,
        "valor": 2700116048.5,
        "delta": -384511104.47
      },
      {
        "periodo": 202510,
        "valor": 3001953910.7,
        "delta": 301837862.2
      },
      {
        "periodo": 202511,
        "valor": 3171098761.61,
        "delta": 169144850.91
      },
      {
        "periodo": 202512,
        "valor": 4070270511.52,
        "delta": 899171749.91
      },
      {
        "periodo": 202601,
        "valor": 4128004206.8,
        "delta": 57733695.28
      },
      {
        "periodo": 202602,
        "valor": 3956257642.47,
        "delta": -171746564.33
      },
      {
        "periodo": 202603,
        "valor": 3796059476.84,
        "delta": -160198165.63
      },
      {
        "periodo": 202604,
        "valor": 4020842497.25,
        "delta": 224783020.41
      },
      {
        "periodo": 202605,
        "valor": 3881075571.19,
        "delta": -139766926.06
      },
      {
        "periodo": 202606,
        "valor": 3666508561.2,
        "delta": -214567009.99
      },
      {
        "periodo": 202607,
        "valor": 3722416948.66,
        "delta": 55908387.46
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 192919402.1,
    "valor_anterior": 195167818.91,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 79879177.74,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 66287150.62,
        "delta": -13592027.12
      },
      {
        "periodo": 202509,
        "valor": 45785661.3,
        "delta": -20501489.32
      },
      {
        "periodo": 202510,
        "valor": 45887934.04,
        "delta": 102272.74
      },
      {
        "periodo": 202511,
        "valor": 46957813.56,
        "delta": 1069879.52
      },
      {
        "periodo": 202512,
        "valor": 30203357.27,
        "delta": -16754456.29
      },
      {
        "periodo": 202601,
        "valor": 28639615.07,
        "delta": -1563742.2
      },
      {
        "periodo": 202602,
        "valor": 51353537.58,
        "delta": 22713922.51
      },
      {
        "periodo": 202603,
        "valor": 52642893.07,
        "delta": 1289355.49
      },
      {
        "periodo": 202604,
        "valor": 59431520.69,
        "delta": 6788627.62
      },
      {
        "periodo": 202605,
        "valor": 60531468.95,
        "delta": 1099948.26
      },
      {
        "periodo": 202606,
        "valor": 195167818.91,
        "delta": 134636349.96
      },
      {
        "periodo": 202607,
        "valor": 192919402.1,
        "delta": -2248416.81
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200194,
    "label": "Quitas y Castigos Comercial (Suma 12m)",
    "valor_actual": 756947580.31,
    "valor_anterior": 753241646.64,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 667003082.97,
        "delta": 667003082.97
      },
      {
        "periodo": 202511,
        "valor": 667003082.97,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 738705577.34,
        "delta": 71702494.37
      },
      {
        "periodo": 202601,
        "valor": 738929477.25,
        "delta": 223899.91
      },
      {
        "periodo": 202602,
        "valor": 739635291.75,
        "delta": 705814.5
      },
      {
        "periodo": 202603,
        "valor": 744032926.6,
        "delta": 4397634.85
      },
      {
        "periodo": 202604,
        "valor": 747058768.68,
        "delta": 3025842.08
      },
      {
        "periodo": 202605,
        "valor": 749497705.52,
        "delta": 2438936.84
      },
      {
        "periodo": 202606,
        "valor": 753241646.64,
        "delta": 3743941.12
      },
      {
        "periodo": 202607,
        "valor": 756947580.31,
        "delta": 3705933.67
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 26033366303.13,
    "valor_anterior": 25530543347.3,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19800927288.17,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 20228985686.69,
        "delta": 428058398.52
      },
      {
        "periodo": 202509,
        "valor": 20725439203.65,
        "delta": 496453516.96
      },
      {
        "periodo": 202510,
        "valor": 21245178849.63,
        "delta": 519739645.98
      },
      {
        "periodo": 202511,
        "valor": 21720791769.2,
        "delta": 475612919.57
      },
      {
        "periodo": 202512,
        "valor": 22253271165.75,
        "delta": 532479396.55
      },
      {
        "periodo": 202601,
        "valor": 22695257044.11,
        "delta": 441985878.36
      },
      {
        "periodo": 202602,
        "valor": 23160953412.8,
        "delta": 465696368.69
      },
      {
        "periodo": 202603,
        "valor": 23913798850.72,
        "delta": 752845437.92
      },
      {
        "periodo": 202604,
        "valor": 24566726550.23,
        "delta": 652927699.51
      },
      {
        "periodo": 202605,
        "valor": 24969809260.94,
        "delta": 403082710.71
      },
      {
        "periodo": 202606,
        "valor": 25530543347.3,
        "delta": 560734086.36
      },
      {
        "periodo": 202607,
        "valor": 26033366303.13,
        "delta": 502822955.83
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 56705918823.99,
    "valor_anterior": 56172332563.99,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 49111338242.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 49606846762.0,
        "delta": 495508520.0
      },
      {
        "periodo": 202509,
        "valor": 50110068017.0,
        "delta": 503221255.0
      },
      {
        "periodo": 202510,
        "valor": 50547765509.0,
        "delta": 437697492.0
      },
      {
        "periodo": 202511,
        "valor": 51773224615.66,
        "delta": 1225459106.66
      },
      {
        "periodo": 202512,
        "valor": 52298746095.33,
        "delta": 525521479.67
      },
      {
        "periodo": 202601,
        "valor": 52978281970.99,
        "delta": 679535875.66
      },
      {
        "periodo": 202602,
        "valor": 53633358658.39,
        "delta": 655076687.4
      },
      {
        "periodo": 202603,
        "valor": 52433526114.53,
        "delta": -1199832543.86
      },
      {
        "periodo": 202604,
        "valor": 54875310932.99,
        "delta": 2441784818.46
      },
      {
        "periodo": 202605,
        "valor": 55509123218.99,
        "delta": 633812286.0
      },
      {
        "periodo": 202606,
        "valor": 56172332563.99,
        "delta": 663209345.0
      },
      {
        "periodo": 202607,
        "valor": 56705918823.99,
        "delta": 533586260.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 21064272689.0,
    "valor_anterior": 20949639304.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20363440460.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 20745174338.0,
        "delta": 381733878.0
      },
      {
        "periodo": 202509,
        "valor": 21053812379.0,
        "delta": 308638041.0
      },
      {
        "periodo": 202510,
        "valor": 21102832789.0,
        "delta": 49020410.0
      },
      {
        "periodo": 202511,
        "valor": 21031819296.0,
        "delta": -71013493.0
      },
      {
        "periodo": 202512,
        "valor": 20914931141.0,
        "delta": -116888155.0
      },
      {
        "periodo": 202601,
        "valor": 20996337813.0,
        "delta": 81406672.0
      },
      {
        "periodo": 202602,
        "valor": 21004146950.0,
        "delta": 7809137.0
      },
      {
        "periodo": 202603,
        "valor": 21011650070.0,
        "delta": 7503120.0
      },
      {
        "periodo": 202604,
        "valor": 20987831427.0,
        "delta": -23818643.0
      },
      {
        "periodo": 202605,
        "valor": 20889126961.0,
        "delta": -98704466.0
      },
      {
        "periodo": 202606,
        "valor": 20949639304.0,
        "delta": 60512343.0
      },
      {
        "periodo": 202607,
        "valor": 21064272689.0,
        "delta": 114633385.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 12268871305.999998,
    "valor_anterior": 12400962059.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12362458016.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12302558684.0,
        "delta": -59899332.0
      },
      {
        "periodo": 202509,
        "valor": 12403558746.0,
        "delta": 101000062.0
      },
      {
        "periodo": 202510,
        "valor": 12410185900.0,
        "delta": 6627154.0
      },
      {
        "periodo": 202511,
        "valor": 12576221163.0,
        "delta": 166035263.0
      },
      {
        "periodo": 202512,
        "valor": 12613669917.0,
        "delta": 37448754.0
      },
      {
        "periodo": 202601,
        "valor": 12644896414.0,
        "delta": 31226497.0
      },
      {
        "periodo": 202602,
        "valor": 12596094894.0,
        "delta": -48801520.0
      },
      {
        "periodo": 202603,
        "valor": 12621281010.0,
        "delta": 25186116.0
      },
      {
        "periodo": 202604,
        "valor": 12635851921.0,
        "delta": 14570911.0
      },
      {
        "periodo": 202605,
        "valor": 12519306471.0,
        "delta": -116545450.0
      },
      {
        "periodo": 202606,
        "valor": 12400962059.0,
        "delta": -118344412.0
      },
      {
        "periodo": 202607,
        "valor": 12268871306.0,
        "delta": -132090753.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 850375350.8,
    "valor_anterior": 841004456.05,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 774690285.45,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 790419804.54,
        "delta": 15729519.09
      },
      {
        "periodo": 202509,
        "valor": 797630868.29,
        "delta": 7211063.75
      },
      {
        "periodo": 202510,
        "valor": 813626296.02,
        "delta": 15995427.73
      },
      {
        "periodo": 202511,
        "valor": 830468596.03,
        "delta": 16842300.01
      },
      {
        "periodo": 202512,
        "valor": 836936119.2,
        "delta": 6467523.17
      },
      {
        "periodo": 202601,
        "valor": 841108581.38,
        "delta": 4172462.18
      },
      {
        "periodo": 202602,
        "valor": 840031488.18,
        "delta": -1077093.2
      },
      {
        "periodo": 202603,
        "valor": 838791947.49,
        "delta": -1239540.69
      },
      {
        "periodo": 202604,
        "valor": 846348383.88,
        "delta": 7556436.39
      },
      {
        "periodo": 202605,
        "valor": 846328928.7,
        "delta": -19455.18
      },
      {
        "periodo": 202606,
        "valor": 841004456.05,
        "delta": -5324472.65
      },
      {
        "periodo": 202607,
        "valor": 850375350.8,
        "delta": 9370894.75
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 5477707143.000001,
    "valor_anterior": 5396361126.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4174714101.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4247831135.0,
        "delta": 73117034.0
      },
      {
        "periodo": 202509,
        "valor": 4358965994.0,
        "delta": 111134859.0
      },
      {
        "periodo": 202510,
        "valor": 4530552673.0,
        "delta": 171586679.0
      },
      {
        "periodo": 202511,
        "valor": 4292205754.0,
        "delta": -238346919.0
      },
      {
        "periodo": 202512,
        "valor": 4475221552.0,
        "delta": 183015798.0
      },
      {
        "periodo": 202601,
        "valor": 4637237596.0,
        "delta": 162016044.0
      },
      {
        "periodo": 202602,
        "valor": 4806482702.0,
        "delta": 169245106.0
      },
      {
        "periodo": 202603,
        "valor": 4971458917.0,
        "delta": 164976215.0
      },
      {
        "periodo": 202604,
        "valor": 5114471653.0,
        "delta": 143012736.0
      },
      {
        "periodo": 202605,
        "valor": 5241608772.0,
        "delta": 127137119.0
      },
      {
        "periodo": 202606,
        "valor": 5396361126.0,
        "delta": 154752354.0
      },
      {
        "periodo": 202607,
        "valor": 5477707143.0,
        "delta": 81346017.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 71475141.0,
    "valor_anterior": 56199117.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 44365413.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 45700333.0,
        "delta": 1334920.0
      },
      {
        "periodo": 202509,
        "valor": 48440812.0,
        "delta": 2740479.0
      },
      {
        "periodo": 202510,
        "valor": 53843495.0,
        "delta": 5402683.0
      },
      {
        "periodo": 202511,
        "valor": 55621253.0,
        "delta": 1777758.0
      },
      {
        "periodo": 202512,
        "valor": 58186864.0,
        "delta": 2565611.0
      },
      {
        "periodo": 202601,
        "valor": 61276527.0,
        "delta": 3089663.0
      },
      {
        "periodo": 202602,
        "valor": 67953848.0,
        "delta": 6677321.0
      },
      {
        "periodo": 202603,
        "valor": 68952293.0,
        "delta": 998445.0
      },
      {
        "periodo": 202604,
        "valor": 50119088.0,
        "delta": -18833205.0
      },
      {
        "periodo": 202605,
        "valor": 50125570.0,
        "delta": 6482.0
      },
      {
        "periodo": 202606,
        "valor": 56199117.0,
        "delta": 6073547.0
      },
      {
        "periodo": 202607,
        "valor": 71475141.0,
        "delta": 15276024.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 4208143557.0,
    "valor_anterior": 4175619918.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3245533292.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3340833012.0,
        "delta": 95299720.0
      },
      {
        "periodo": 202509,
        "valor": 3449319411.0,
        "delta": 108486399.0
      },
      {
        "periodo": 202510,
        "valor": 3523111157.0,
        "delta": 73791746.0
      },
      {
        "periodo": 202511,
        "valor": 3518835517.0,
        "delta": -4275640.0
      },
      {
        "periodo": 202512,
        "valor": 3696885828.0,
        "delta": 178050311.0
      },
      {
        "periodo": 202601,
        "valor": 3797376750.0,
        "delta": 100490922.0
      },
      {
        "periodo": 202602,
        "valor": 3871780304.0,
        "delta": 74403554.0
      },
      {
        "periodo": 202603,
        "valor": 3978558675.0,
        "delta": 106778371.0
      },
      {
        "periodo": 202604,
        "valor": 4087539897.0,
        "delta": 108981222.0
      },
      {
        "periodo": 202605,
        "valor": 4123982783.0,
        "delta": 36442886.0
      },
      {
        "periodo": 202606,
        "valor": 4175619918.0,
        "delta": 51637135.0
      },
      {
        "periodo": 202607,
        "valor": 4208143557.0,
        "delta": 32523639.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 629782650.79,
    "valor_anterior": 661573262.39,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 861769895.38,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 869461160.33,
        "delta": 7691264.95
      },
      {
        "periodo": 202509,
        "valor": 777741670.34,
        "delta": -91719489.99
      },
      {
        "periodo": 202510,
        "valor": 813010979.6,
        "delta": 35269309.26
      },
      {
        "periodo": 202511,
        "valor": 834884111.92,
        "delta": 21873132.32
      },
      {
        "periodo": 202512,
        "valor": 751800558.03,
        "delta": -83083553.89
      },
      {
        "periodo": 202601,
        "valor": 757926339.55,
        "delta": 6125781.52
      },
      {
        "periodo": 202602,
        "valor": 765135883.76,
        "delta": 7209544.21
      },
      {
        "periodo": 202603,
        "valor": 753091800.78,
        "delta": -12044082.98
      },
      {
        "periodo": 202604,
        "valor": 736716079.27,
        "delta": -16375721.51
      },
      {
        "periodo": 202605,
        "valor": 694873089.31,
        "delta": -41842989.96
      },
      {
        "periodo": 202606,
        "valor": 661573262.39,
        "delta": -33299826.92
      },
      {
        "periodo": 202607,
        "valor": 629782650.79,
        "delta": -31790611.6
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 4454534131.0,
    "valor_anterior": 4344293836.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3038388606.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3175897529.0,
        "delta": 137508923.0
      },
      {
        "periodo": 202509,
        "valor": 3297511612.0,
        "delta": 121614083.0
      },
      {
        "periodo": 202510,
        "valor": 3476342566.0,
        "delta": 178830954.0
      },
      {
        "periodo": 202511,
        "valor": 3577817896.0,
        "delta": 101475330.0
      },
      {
        "periodo": 202512,
        "valor": 3705506119.0,
        "delta": 127688223.0
      },
      {
        "periodo": 202601,
        "valor": 3705506119.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 3837477402.0,
        "delta": 131971283.0
      },
      {
        "periodo": 202603,
        "valor": 3946023245.0,
        "delta": 108545843.0
      },
      {
        "periodo": 202604,
        "valor": 4048586843.0,
        "delta": 102563598.0
      },
      {
        "periodo": 202605,
        "valor": 4194855879.0,
        "delta": 146269036.0
      },
      {
        "periodo": 202606,
        "valor": 4344293836.0,
        "delta": 149437957.0
      },
      {
        "periodo": 202607,
        "valor": 4454534131.0,
        "delta": 110240295.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 125611.0,
    "valor_anterior": 125611.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 37237.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 37237.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 37237.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 162848.0,
        "delta": 125611.0
      },
      {
        "periodo": 202511,
        "valor": 162848.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 162848.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 162848.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 162848.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 162848.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 162848.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 125611.0,
        "delta": -37237.0
      },
      {
        "periodo": 202606,
        "valor": 125611.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 125611.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 1372128515.0,
    "valor_anterior": 1383593749.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1278796933.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1252073367.0,
        "delta": -26723566.0
      },
      {
        "periodo": 202509,
        "valor": 1272491148.0,
        "delta": 20417781.0
      },
      {
        "periodo": 202510,
        "valor": 1309514103.0,
        "delta": 37022955.0
      },
      {
        "periodo": 202511,
        "valor": 1293881020.0,
        "delta": -15633083.0
      },
      {
        "periodo": 202512,
        "valor": 1266631491.0,
        "delta": -27249529.0
      },
      {
        "periodo": 202601,
        "valor": 1280492348.0,
        "delta": 13860857.0
      },
      {
        "periodo": 202602,
        "valor": 1314533417.0,
        "delta": 34041069.0
      },
      {
        "periodo": 202603,
        "valor": 1347842694.0,
        "delta": 33309277.0
      },
      {
        "periodo": 202604,
        "valor": 1366997040.0,
        "delta": 19154346.0
      },
      {
        "periodo": 202605,
        "valor": 1381285927.0,
        "delta": 14288887.0
      },
      {
        "periodo": 202606,
        "valor": 1383593749.0,
        "delta": 2307822.0
      },
      {
        "periodo": 202607,
        "valor": 1372128515.0,
        "delta": -11465234.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 20019845433.84,
    "valor_anterior": 19645106667.31,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 16233583212.76,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 16535254916.48,
        "delta": 301671703.72
      },
      {
        "periodo": 202509,
        "valor": 16775917480.24,
        "delta": 240662563.76
      },
      {
        "periodo": 202510,
        "valor": 16981660417.95,
        "delta": 205742937.71
      },
      {
        "periodo": 202511,
        "valor": 17023724050.93,
        "delta": 42063632.98
      },
      {
        "periodo": 202512,
        "valor": 17256640292.29,
        "delta": 232916241.36
      },
      {
        "periodo": 202601,
        "valor": 17634626236.09,
        "delta": 377985943.8
      },
      {
        "periodo": 202602,
        "valor": 18275049743.13,
        "delta": 640423507.04
      },
      {
        "periodo": 202603,
        "valor": 18712329979.42,
        "delta": 437280236.29
      },
      {
        "periodo": 202604,
        "valor": 18956762189.57,
        "delta": 244432210.15
      },
      {
        "periodo": 202605,
        "valor": 19267694357.11,
        "delta": 310932167.54
      },
      {
        "periodo": 202606,
        "valor": 19645106667.31,
        "delta": 377412310.2
      },
      {
        "periodo": 202607,
        "valor": 20019845433.84,
        "delta": 374738766.53
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 9872.0,
    "valor_anterior": 9872.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 9872.0,
        "delta": 9872.0
      },
      {
        "periodo": 202604,
        "valor": 9872.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 9872.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 9872.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 9872.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 18031992471.74,
    "valor_anterior": 16965515289.36,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11696645633.22,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11949936631.93,
        "delta": 253290998.71
      },
      {
        "periodo": 202509,
        "valor": 12399719903.18,
        "delta": 449783271.25
      },
      {
        "periodo": 202510,
        "valor": 12619019970.17,
        "delta": 219300066.99
      },
      {
        "periodo": 202511,
        "valor": 13140694457.87,
        "delta": 521674487.7
      },
      {
        "periodo": 202512,
        "valor": 13422266518.72,
        "delta": 281572060.85
      },
      {
        "periodo": 202601,
        "valor": 13955512682.79,
        "delta": 533246164.07
      },
      {
        "periodo": 202602,
        "valor": 14371992960.17,
        "delta": 416480277.38
      },
      {
        "periodo": 202603,
        "valor": 14938033462.35,
        "delta": 566040502.18
      },
      {
        "periodo": 202604,
        "valor": 15548633670.79,
        "delta": 610600208.44
      },
      {
        "periodo": 202605,
        "valor": 16270113660.28,
        "delta": 721479989.49
      },
      {
        "periodo": 202606,
        "valor": 16965515289.36,
        "delta": 695401629.08
      },
      {
        "periodo": 202607,
        "valor": 18031992471.74,
        "delta": 1066477182.38
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 19178534.53,
    "valor_anterior": 23879419.93,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 14086663.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14086663.25,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 14086663.25,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 14086663.25,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 14086663.25,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 6712645.93,
        "delta": -7374017.32
      },
      {
        "periodo": 202601,
        "valor": 6712645.93,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 6712645.93,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 6712645.93,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 6712645.93,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 5423306.19,
        "delta": -1289339.74
      },
      {
        "periodo": 202606,
        "valor": 23879419.93,
        "delta": 18456113.74
      },
      {
        "periodo": 202607,
        "valor": 19178534.53,
        "delta": -4700885.4
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 7468970394.0,
    "valor_anterior": 7170446031.000001,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5460100597.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5560634993.0,
        "delta": 100534396.0
      },
      {
        "periodo": 202509,
        "valor": 5722805133.0,
        "delta": 162170140.0
      },
      {
        "periodo": 202510,
        "valor": 5870238002.0,
        "delta": 147432869.0
      },
      {
        "periodo": 202511,
        "valor": 5985262570.0,
        "delta": 115024568.0
      },
      {
        "periodo": 202512,
        "valor": 6058990162.0,
        "delta": 73727592.0
      },
      {
        "periodo": 202601,
        "valor": 6174835013.0,
        "delta": 115844851.0
      },
      {
        "periodo": 202602,
        "valor": 6274367782.0,
        "delta": 99532769.0
      },
      {
        "periodo": 202603,
        "valor": 6424695212.0,
        "delta": 150327430.0
      },
      {
        "periodo": 202604,
        "valor": 6688989930.0,
        "delta": 264294718.0
      },
      {
        "periodo": 202605,
        "valor": 6901041830.0,
        "delta": 212051900.0
      },
      {
        "periodo": 202606,
        "valor": 7170446031.0,
        "delta": 269404201.0
      },
      {
        "periodo": 202607,
        "valor": 7468970394.0,
        "delta": 298524363.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 30477685.0,
    "valor_anterior": 30477704.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 18175529.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 17457810.0,
        "delta": -717719.0
      },
      {
        "periodo": 202509,
        "valor": 20112689.0,
        "delta": 2654879.0
      },
      {
        "periodo": 202510,
        "valor": 19631254.0,
        "delta": -481435.0
      },
      {
        "periodo": 202511,
        "valor": 19631057.0,
        "delta": -197.0
      },
      {
        "periodo": 202512,
        "valor": 19631049.0,
        "delta": -8.0
      },
      {
        "periodo": 202601,
        "valor": 19638216.0,
        "delta": 7167.0
      },
      {
        "periodo": 202602,
        "valor": 34319311.0,
        "delta": 14681095.0
      },
      {
        "periodo": 202603,
        "valor": 34342329.0,
        "delta": 23018.0
      },
      {
        "periodo": 202604,
        "valor": 34342337.0,
        "delta": 8.0
      },
      {
        "periodo": 202605,
        "valor": 32712771.0,
        "delta": -1629566.0
      },
      {
        "periodo": 202606,
        "valor": 30477704.0,
        "delta": -2235067.0
      },
      {
        "periodo": 202607,
        "valor": 30477685.0,
        "delta": -19.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 232437725.86,
    "valor_anterior": 237235395.46,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 213513267.97,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 203339462.35,
        "delta": -10173805.62
      },
      {
        "periodo": 202509,
        "valor": 198335493.52,
        "delta": -5003968.83
      },
      {
        "periodo": 202510,
        "valor": 191670534.08,
        "delta": -6664959.44
      },
      {
        "periodo": 202511,
        "valor": 175336792.32,
        "delta": -16333741.76
      },
      {
        "periodo": 202512,
        "valor": 154832814.77,
        "delta": -20503977.55
      },
      {
        "periodo": 202601,
        "valor": 152139421.74,
        "delta": -2693393.03
      },
      {
        "periodo": 202602,
        "valor": 147356748.12,
        "delta": -4782673.62
      },
      {
        "periodo": 202603,
        "valor": 226842610.11,
        "delta": 79485861.99
      },
      {
        "periodo": 202604,
        "valor": 227651531.66,
        "delta": 808921.55
      },
      {
        "periodo": 202605,
        "valor": 227460927.16,
        "delta": -190604.5
      },
      {
        "periodo": 202606,
        "valor": 237235395.46,
        "delta": 9774468.3
      },
      {
        "periodo": 202607,
        "valor": 232437725.86,
        "delta": -4797669.6
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 310166127.0,
    "valor_anterior": 291418346.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 164299656.94,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 171675819.39,
        "delta": 7376162.45
      },
      {
        "periodo": 202509,
        "valor": 178959759.39,
        "delta": 7283940.0
      },
      {
        "periodo": 202510,
        "valor": 182455742.39,
        "delta": 3495983.0
      },
      {
        "periodo": 202511,
        "valor": 189617111.67,
        "delta": 7161369.28
      },
      {
        "periodo": 202512,
        "valor": 196249952.33,
        "delta": 6632840.66
      },
      {
        "periodo": 202601,
        "valor": 208973476.1,
        "delta": 12723523.77
      },
      {
        "periodo": 202602,
        "valor": 220549360.43,
        "delta": 11575884.33
      },
      {
        "periodo": 202603,
        "valor": 237168707.79,
        "delta": 16619347.36
      },
      {
        "periodo": 202604,
        "valor": 254164390.0,
        "delta": 16995682.21
      },
      {
        "periodo": 202605,
        "valor": 272324399.0,
        "delta": 18160009.0
      },
      {
        "periodo": 202606,
        "valor": 291418346.0,
        "delta": 19093947.0
      },
      {
        "periodo": 202607,
        "valor": 310166127.0,
        "delta": 18747781.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 547172334.0,
    "valor_anterior": 540666477.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 457900267.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 470042422.0,
        "delta": 12142155.0
      },
      {
        "periodo": 202509,
        "valor": 479066195.0,
        "delta": 9023773.0
      },
      {
        "periodo": 202510,
        "valor": 473488264.0,
        "delta": -5577931.0
      },
      {
        "periodo": 202511,
        "valor": 474691740.0,
        "delta": 1203476.0
      },
      {
        "periodo": 202512,
        "valor": 475123102.0,
        "delta": 431362.0
      },
      {
        "periodo": 202601,
        "valor": 487211376.0,
        "delta": 12088274.0
      },
      {
        "periodo": 202602,
        "valor": 502483188.0,
        "delta": 15271812.0
      },
      {
        "periodo": 202603,
        "valor": 503006174.0,
        "delta": 522986.0
      },
      {
        "periodo": 202604,
        "valor": 502979719.0,
        "delta": -26455.0
      },
      {
        "periodo": 202605,
        "valor": 540389977.0,
        "delta": 37410258.0
      },
      {
        "periodo": 202606,
        "valor": 540666477.0,
        "delta": 276500.0
      },
      {
        "periodo": 202607,
        "valor": 547172334.0,
        "delta": 6505857.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 38036761.0,
    "valor_anterior": 55528417.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 40153572.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 40625426.0,
        "delta": 471854.0
      },
      {
        "periodo": 202509,
        "valor": 40606853.0,
        "delta": -18573.0
      },
      {
        "periodo": 202510,
        "valor": 41250356.0,
        "delta": 643503.0
      },
      {
        "periodo": 202511,
        "valor": 28421888.0,
        "delta": -12828468.0
      },
      {
        "periodo": 202512,
        "valor": 29033472.0,
        "delta": 611584.0
      },
      {
        "periodo": 202601,
        "valor": 28981801.0,
        "delta": -51671.0
      },
      {
        "periodo": 202602,
        "valor": 28925876.0,
        "delta": -55925.0
      },
      {
        "periodo": 202603,
        "valor": 20796755.0,
        "delta": -8129121.0
      },
      {
        "periodo": 202604,
        "valor": 21170827.0,
        "delta": 374072.0
      },
      {
        "periodo": 202605,
        "valor": 21018539.0,
        "delta": -152288.0
      },
      {
        "periodo": 202606,
        "valor": 55528417.0,
        "delta": 34509878.0
      },
      {
        "periodo": 202607,
        "valor": 38036761.0,
        "delta": -17491656.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 151958222.91,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 146725996.9,
        "delta": -5232226.01
      },
      {
        "periodo": 202509,
        "valor": 137266509.87,
        "delta": -9459487.03
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 223802.38,
    "valor_anterior": 223802.38,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 642988.35,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 715539.94,
        "delta": 72551.59
      },
      {
        "periodo": 202509,
        "valor": 787172.16,
        "delta": 71632.22
      },
      {
        "periodo": 202510,
        "valor": 787172.16,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 258754.31,
        "delta": -528417.85
      },
      {
        "periodo": 202512,
        "valor": 338372.88,
        "delta": 79618.57
      },
      {
        "periodo": 202601,
        "valor": 338372.88,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 223802.38,
        "delta": -114570.5
      },
      {
        "periodo": 202603,
        "valor": 223802.38,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 223802.38,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 223802.38,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 223802.38,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 223802.38,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 67672329.0,
    "valor_anterior": 70079371.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 76400558.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 79037929.0,
        "delta": 2637371.0
      },
      {
        "periodo": 202509,
        "valor": 81456851.0,
        "delta": 2418922.0
      },
      {
        "periodo": 202510,
        "valor": 81528098.0,
        "delta": 71247.0
      },
      {
        "periodo": 202511,
        "valor": 81663699.0,
        "delta": 135601.0
      },
      {
        "periodo": 202512,
        "valor": 81342534.0,
        "delta": -321165.0
      },
      {
        "periodo": 202601,
        "valor": 83751926.0,
        "delta": 2409392.0
      },
      {
        "periodo": 202602,
        "valor": 83005422.0,
        "delta": -746504.0
      },
      {
        "periodo": 202603,
        "valor": 80535330.0,
        "delta": -2470092.0
      },
      {
        "periodo": 202604,
        "valor": 76375601.0,
        "delta": -4159729.0
      },
      {
        "periodo": 202605,
        "valor": 72638522.0,
        "delta": -3737079.0
      },
      {
        "periodo": 202606,
        "valor": 70079371.0,
        "delta": -2559151.0
      },
      {
        "periodo": 202607,
        "valor": 67672329.0,
        "delta": -2407042.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 8522247.15,
    "valor_anterior": 11605263.42,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 25120650.72,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 27727162.31,
        "delta": 2606511.59
      },
      {
        "periodo": 202509,
        "valor": 30108627.08,
        "delta": 2381464.77
      },
      {
        "periodo": 202510,
        "valor": 30923178.82,
        "delta": 814551.74
      },
      {
        "periodo": 202511,
        "valor": 31135988.61,
        "delta": 212809.79
      },
      {
        "periodo": 202512,
        "valor": 29931933.16,
        "delta": -1204055.45
      },
      {
        "periodo": 202601,
        "valor": 27778628.53,
        "delta": -2153304.63
      },
      {
        "periodo": 202602,
        "valor": 24293493.2,
        "delta": -3485135.33
      },
      {
        "periodo": 202603,
        "valor": 20471704.17,
        "delta": -3821789.03
      },
      {
        "periodo": 202604,
        "valor": 16770531.23,
        "delta": -3701172.94
      },
      {
        "periodo": 202605,
        "valor": 13781467.56,
        "delta": -2989063.67
      },
      {
        "periodo": 202606,
        "valor": 11605263.42,
        "delta": -2176204.14
      },
      {
        "periodo": 202607,
        "valor": 8522247.15,
        "delta": -3083016.27
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 219896424.64,
    "valor_anterior": 188441567.58,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 39229509.75,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 78378927.08,
        "delta": 39149417.33
      },
      {
        "periodo": 202604,
        "valor": 117411096.14,
        "delta": 39032169.06
      },
      {
        "periodo": 202605,
        "valor": 151797818.57,
        "delta": 34386722.43
      },
      {
        "periodo": 202606,
        "valor": 188441567.58,
        "delta": 36643749.01
      },
      {
        "periodo": 202607,
        "valor": 219896424.64,
        "delta": 31454857.06
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 158756262.0,
    "valor_anterior": 138013148.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 50325.0,
        "delta": 50325.0
      },
      {
        "periodo": 202509,
        "valor": 1200190.0,
        "delta": 1149865.0
      },
      {
        "periodo": 202510,
        "valor": 2861130.0,
        "delta": 1660940.0
      },
      {
        "periodo": 202511,
        "valor": 8533761.0,
        "delta": 5672631.0
      },
      {
        "periodo": 202512,
        "valor": 25587799.0,
        "delta": 17054038.0
      },
      {
        "periodo": 202601,
        "valor": 46770705.0,
        "delta": 21182906.0
      },
      {
        "periodo": 202602,
        "valor": 70341108.0,
        "delta": 23570403.0
      },
      {
        "periodo": 202603,
        "valor": 89104944.0,
        "delta": 18763836.0
      },
      {
        "periodo": 202604,
        "valor": 103521538.0,
        "delta": 14416594.0
      },
      {
        "periodo": 202605,
        "valor": 118643870.0,
        "delta": 15122332.0
      },
      {
        "periodo": 202606,
        "valor": 138013148.0,
        "delta": 19369278.0
      },
      {
        "periodo": 202607,
        "valor": 158756262.0,
        "delta": 20743114.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 7565.0,
    "valor_anterior": 420.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 420.0,
        "delta": 420.0
      },
      {
        "periodo": 202605,
        "valor": 420.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 420.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 7565.0,
        "delta": 7145.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 935761634.0,
    "valor_anterior": 935761634.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 417389921.0,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": 417389921.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 417389921.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 935761634.0,
        "delta": 518371713.0
      },
      {
        "periodo": 202607,
        "valor": 935761634.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 181226954031.40997,
    "valor_anterior": 178229371769.04,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 149609040588.12,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 151823130146.11,
        "delta": 2214089557.99
      },
      {
        "periodo": 202509,
        "valor": 154375446617.97,
        "delta": 2552316471.86
      },
      {
        "periodo": 202510,
        "valor": 156462876700.85,
        "delta": 2087430082.88
      },
      {
        "periodo": 202511,
        "valor": 158782641333.81,
        "delta": 2319764632.96
      },
      {
        "periodo": 202512,
        "valor": 160721832470.81,
        "delta": 1939191137.0
      },
      {
        "periodo": 202601,
        "valor": 163304438301.93,
        "delta": 2582605831.12
      },
      {
        "periodo": 202602,
        "valor": 166046799086.28,
        "delta": 2742360784.35
      },
      {
        "periodo": 202603,
        "valor": 167735688621.16,
        "delta": 1688889534.88
      },
      {
        "periodo": 202604,
        "valor": 172339668682.49,
        "delta": 4603980061.33
      },
      {
        "periodo": 202605,
        "valor": 174765140296.78,
        "delta": 2425471614.29
      },
      {
        "periodo": 202606,
        "valor": 178229371769.04,
        "delta": 3464231472.26
      },
      {
        "periodo": 202607,
        "valor": 181226954031.41,
        "delta": 2997582262.37
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 145778125255.96,
    "valor_anterior": 144270564985.6,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 125291994611.93,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 127007484534.17,
        "delta": 1715489922.24
      },
      {
        "periodo": 202509,
        "valor": 128877081230.89,
        "delta": 1869596696.72
      },
      {
        "periodo": 202510,
        "valor": 130341287295.58,
        "delta": 1464206064.69
      },
      {
        "periodo": 202511,
        "valor": 131936822165.79,
        "delta": 1595534870.21
      },
      {
        "periodo": 202512,
        "valor": 133509365991.37,
        "delta": 1572543825.58
      },
      {
        "periodo": 202601,
        "valor": 135384013824.19,
        "delta": 1874647832.82
      },
      {
        "periodo": 202602,
        "valor": 137347866664.32,
        "delta": 1963852840.13
      },
      {
        "periodo": 202603,
        "valor": 137642603616.67,
        "delta": 294736952.35
      },
      {
        "periodo": 202604,
        "valor": 141224494570.79,
        "delta": 3581890954.12
      },
      {
        "periodo": 202605,
        "valor": 142520651824.04,
        "delta": 1296157253.25
      },
      {
        "periodo": 202606,
        "valor": 144270564985.6,
        "delta": 1749913161.56
      },
      {
        "periodo": 202607,
        "valor": 145778125255.96,
        "delta": 1507560270.36
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 1125206.56,
    "valor_anterior": 12714593.87,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 151958222.91,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 146725996.9,
        "delta": -5232226.01
      },
      {
        "periodo": 202509,
        "valor": 137266509.87,
        "delta": -9459487.03
      },
      {
        "periodo": 202510,
        "valor": 127148752.78,
        "delta": -10117757.09
      },
      {
        "periodo": 202511,
        "valor": 103648960.04,
        "delta": -23499792.74
      },
      {
        "periodo": 202512,
        "valor": 93202124.42,
        "delta": -10446835.62
      },
      {
        "periodo": 202601,
        "valor": 81307449.84,
        "delta": -11894674.58
      },
      {
        "periodo": 202602,
        "valor": 69836328.04,
        "delta": -11471121.8
      },
      {
        "periodo": 202603,
        "valor": 60507779.41,
        "delta": -9328548.63
      },
      {
        "periodo": 202604,
        "valor": 49895996.42,
        "delta": -10611782.99
      },
      {
        "periodo": 202605,
        "valor": 31922364.59,
        "delta": -17973631.83
      },
      {
        "periodo": 202606,
        "valor": 12714593.87,
        "delta": -19207770.72
      },
      {
        "periodo": 202607,
        "valor": 1125206.56,
        "delta": -11589387.31
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 5826662646.0,
    "valor_anterior": 5727887584.999999,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4317185539.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4427970896.0,
        "delta": 110785357.0
      },
      {
        "periodo": 202509,
        "valor": 4570002760.0,
        "delta": 142031864.0
      },
      {
        "periodo": 202510,
        "valor": 4785856669.0,
        "delta": 215853909.0
      },
      {
        "periodo": 202511,
        "valor": 4871698916.0,
        "delta": 85842247.0
      },
      {
        "periodo": 202512,
        "valor": 4972137610.0,
        "delta": 100438694.0
      },
      {
        "periodo": 202601,
        "valor": 4985998467.0,
        "delta": 13860857.0
      },
      {
        "periodo": 202602,
        "valor": 5152010819.0,
        "delta": 166012352.0
      },
      {
        "periodo": 202603,
        "valor": 5293865939.0,
        "delta": 141855120.0
      },
      {
        "periodo": 202604,
        "valor": 5415583883.0,
        "delta": 121717944.0
      },
      {
        "periodo": 202605,
        "valor": 5576141806.0,
        "delta": 160557923.0
      },
      {
        "periodo": 202606,
        "valor": 5727887585.0,
        "delta": 151745779.0
      },
      {
        "periodo": 202607,
        "valor": 5826662646.0,
        "delta": 98775061.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 1582120699.59,
    "valor_anterior": 1589264411.44,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1699001122.83,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1723039107.87,
        "delta": 24037985.04
      },
      {
        "periodo": 202509,
        "valor": 1643926039.63,
        "delta": -79113068.24
      },
      {
        "periodo": 202510,
        "valor": 1700112024.62,
        "delta": 56185984.99
      },
      {
        "periodo": 202511,
        "valor": 1740605017.95,
        "delta": 40492993.33
      },
      {
        "periodo": 202512,
        "valor": 1666554590.23,
        "delta": -74050427.72
      },
      {
        "periodo": 202601,
        "valor": 1679949663.93,
        "delta": 13395073.7
      },
      {
        "periodo": 202602,
        "valor": 1707440530.94,
        "delta": 27490867.01
      },
      {
        "periodo": 202603,
        "valor": 1695188242.27,
        "delta": -12252288.67
      },
      {
        "periodo": 202604,
        "valor": 1667535760.15,
        "delta": -27652482.12
      },
      {
        "periodo": 202605,
        "valor": 1624050231.01,
        "delta": -43485529.14
      },
      {
        "periodo": 202606,
        "valor": 1589264411.44,
        "delta": -34785819.57
      },
      {
        "periodo": 202607,
        "valor": 1582120699.59,
        "delta": -7143711.85
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 329694074.91,
    "valor_anterior": 315647179.31,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 179066545.54,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 186515259.58,
        "delta": 7448714.04
      },
      {
        "periodo": 202509,
        "valor": 193870831.8,
        "delta": 7355572.22
      },
      {
        "periodo": 202510,
        "valor": 197492425.8,
        "delta": 3621594.0
      },
      {
        "periodo": 202511,
        "valor": 204125377.23,
        "delta": 6632951.43
      },
      {
        "periodo": 202512,
        "valor": 203463819.14,
        "delta": -661558.09
      },
      {
        "periodo": 202601,
        "valor": 216187342.91,
        "delta": 12723523.77
      },
      {
        "periodo": 202602,
        "valor": 227648656.74,
        "delta": 11461313.83
      },
      {
        "periodo": 202603,
        "valor": 244268004.1,
        "delta": 16619347.36
      },
      {
        "periodo": 202604,
        "valor": 261263686.31,
        "delta": 16995682.21
      },
      {
        "periodo": 202605,
        "valor": 278097118.57,
        "delta": 16833432.26
      },
      {
        "periodo": 202606,
        "valor": 315647179.31,
        "delta": 37550060.74
      },
      {
        "periodo": 202607,
        "valor": 329694074.91,
        "delta": 14046895.6
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200198,
    "label": "Quitas y Castigos Consumo (Suma 12m)",
    "valor_actual": 27709226148.39,
    "valor_anterior": 26313293013.82,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 17969834545.91,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 18331394351.59,
        "delta": 361559805.68
      },
      {
        "periodo": 202509,
        "valor": 18953299245.78,
        "delta": 621904894.19
      },
      {
        "periodo": 202510,
        "valor": 19310979533.07,
        "delta": 357680287.29
      },
      {
        "periodo": 202511,
        "valor": 19925740896.8,
        "delta": 614761363.73
      },
      {
        "periodo": 202512,
        "valor": 20277108335.65,
        "delta": 351367438.85
      },
      {
        "periodo": 202601,
        "valor": 20956981554.06,
        "delta": 679873218.41
      },
      {
        "periodo": 202602,
        "valor": 21541996087.24,
        "delta": 585014533.18
      },
      {
        "periodo": 202603,
        "valor": 22799255039.71,
        "delta": 1257258952.47
      },
      {
        "periodo": 202604,
        "valor": 23720894785.82,
        "delta": 921639746.11
      },
      {
        "periodo": 202605,
        "valor": 24734276952.57,
        "delta": 1013382166.75
      },
      {
        "periodo": 202606,
        "valor": 26313293013.82,
        "delta": 1579016061.25
      },
      {
        "periodo": 202607,
        "valor": 27709226148.39,
        "delta": 1395933134.57
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 705010480.35,
    "valor_anterior": 685824138.49,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 564392138.06,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 562691590.87,
        "delta": -1700547.19
      },
      {
        "periodo": 202509,
        "valor": 592425787.45,
        "delta": 29734196.58
      },
      {
        "periodo": 202510,
        "valor": 574407707.39,
        "delta": -18018080.06
      },
      {
        "periodo": 202511,
        "valor": 552897435.73,
        "delta": -21510271.66
      },
      {
        "periodo": 202512,
        "valor": 543411851.81,
        "delta": -9485583.92
      },
      {
        "periodo": 202601,
        "valor": 580898123.28,
        "delta": 37486271.47
      },
      {
        "periodo": 202602,
        "valor": 604964036.41,
        "delta": 24065913.13
      },
      {
        "periodo": 202603,
        "valor": 619955165.03,
        "delta": 14991128.62
      },
      {
        "periodo": 202604,
        "valor": 657614040.02,
        "delta": 37658874.99
      },
      {
        "periodo": 202605,
        "valor": 665154697.28,
        "delta": 7540657.26
      },
      {
        "periodo": 202606,
        "valor": 685824138.49,
        "delta": 20669441.21
      },
      {
        "periodo": 202607,
        "valor": 705010480.35,
        "delta": 19186341.86
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 2928378762.18,
    "valor_anterior": 2857140080.18,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2071898766.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2106627700.0,
        "delta": 34728934.0
      },
      {
        "periodo": 202509,
        "valor": 2231506382.0,
        "delta": 124878682.0
      },
      {
        "periodo": 202510,
        "valor": 2349459818.0,
        "delta": 117953436.0
      },
      {
        "periodo": 202511,
        "valor": 2386280972.52,
        "delta": 36821154.52
      },
      {
        "periodo": 202512,
        "valor": 2518205900.73,
        "delta": 131924928.21
      },
      {
        "periodo": 202601,
        "valor": 2451429876.92,
        "delta": -66776023.81
      },
      {
        "periodo": 202602,
        "valor": 2513363532.52,
        "delta": 61933655.6
      },
      {
        "periodo": 202603,
        "valor": 2737676205.41,
        "delta": 224312672.89
      },
      {
        "periodo": 202604,
        "valor": 2811130654.18,
        "delta": 73454448.77
      },
      {
        "periodo": 202605,
        "valor": 2809572646.18,
        "delta": -1558008.0
      },
      {
        "periodo": 202606,
        "valor": 2857140080.18,
        "delta": 47567434.0
      },
      {
        "periodo": 202607,
        "valor": 2928378762.18,
        "delta": 71238682.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 2598646813.0,
    "valor_anterior": 2620478150.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1557352625.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1539626870.0,
        "delta": -17725755.0
      },
      {
        "periodo": 202509,
        "valor": 1566764525.0,
        "delta": 27137655.0
      },
      {
        "periodo": 202510,
        "valor": 1643637774.0,
        "delta": 76873249.0
      },
      {
        "periodo": 202511,
        "valor": 2829482096.0,
        "delta": 1185844322.0
      },
      {
        "periodo": 202512,
        "valor": 2921137638.0,
        "delta": 91655542.0
      },
      {
        "periodo": 202601,
        "valor": 2907416841.0,
        "delta": -13720797.0
      },
      {
        "periodo": 202602,
        "valor": 2832703200.0,
        "delta": -74713641.0
      },
      {
        "periodo": 202603,
        "valor": 2785052195.0,
        "delta": -47651005.0
      },
      {
        "periodo": 202604,
        "valor": 2725420832.0,
        "delta": -59631363.0
      },
      {
        "periodo": 202605,
        "valor": 2690282774.0,
        "delta": -35138058.0
      },
      {
        "periodo": 202606,
        "valor": 2620478150.0,
        "delta": -69804624.0
      },
      {
        "periodo": 202607,
        "valor": 2598646813.0,
        "delta": -21831337.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 685424226.0,
    "valor_anterior": 690254247.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 639647791.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 638592970.0,
        "delta": -1054821.0
      },
      {
        "periodo": 202509,
        "valor": 672824019.0,
        "delta": 34231049.0
      },
      {
        "periodo": 202510,
        "valor": 656799951.0,
        "delta": -16024068.0
      },
      {
        "periodo": 202511,
        "valor": 656660257.0,
        "delta": -139694.0
      },
      {
        "periodo": 202512,
        "valor": 636600008.0,
        "delta": -20060249.0
      },
      {
        "periodo": 202601,
        "valor": 634392754.0,
        "delta": -2207254.0
      },
      {
        "periodo": 202602,
        "valor": 670745543.0,
        "delta": 36352789.0
      },
      {
        "periodo": 202603,
        "valor": 699445085.0,
        "delta": 28699542.0
      },
      {
        "periodo": 202604,
        "valor": 705554565.0,
        "delta": 6109480.0
      },
      {
        "periodo": 202605,
        "valor": 696897479.0,
        "delta": -8657086.0
      },
      {
        "periodo": 202606,
        "valor": 690254247.0,
        "delta": -6643232.0
      },
      {
        "periodo": 202607,
        "valor": 685424226.0,
        "delta": -4830021.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 35210246.94,
    "valor_anterior": 33262707.67,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 61159064.25,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 53070166.1,
        "delta": -8088898.15
      },
      {
        "periodo": 202509,
        "valor": 48704170.69,
        "delta": -4365995.41
      },
      {
        "periodo": 202510,
        "valor": 40830263.23,
        "delta": -7873907.46
      },
      {
        "periodo": 202511,
        "valor": 39952894.44,
        "delta": -877368.79
      },
      {
        "periodo": 202512,
        "valor": 33486014.94,
        "delta": -6466879.5
      },
      {
        "periodo": 202601,
        "valor": 41166906.9,
        "delta": 7680891.96
      },
      {
        "periodo": 202602,
        "valor": 39334593.38,
        "delta": -1832313.52
      },
      {
        "periodo": 202603,
        "valor": 37975387.59,
        "delta": -1359205.79
      },
      {
        "periodo": 202604,
        "valor": 35890909.52,
        "delta": -2084478.07
      },
      {
        "periodo": 202605,
        "valor": 34487935.49,
        "delta": -1402974.03
      },
      {
        "periodo": 202606,
        "valor": 33262707.67,
        "delta": -1225227.82
      },
      {
        "periodo": 202607,
        "valor": 35210246.94,
        "delta": 1947539.27
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 29416772.0,
    "valor_anterior": 24304062.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 292432662.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 292413178.0,
        "delta": -19484.0
      },
      {
        "periodo": 202509,
        "valor": 292421046.0,
        "delta": 7868.0
      },
      {
        "periodo": 202510,
        "valor": 292422538.0,
        "delta": 1492.0
      },
      {
        "periodo": 202511,
        "valor": 292422225.0,
        "delta": -313.0
      },
      {
        "periodo": 202512,
        "valor": 292411153.0,
        "delta": -11072.0
      },
      {
        "periodo": 202601,
        "valor": 292409898.0,
        "delta": -1255.0
      },
      {
        "periodo": 202602,
        "valor": 292461230.0,
        "delta": 51332.0
      },
      {
        "periodo": 202603,
        "valor": 292571890.0,
        "delta": 110660.0
      },
      {
        "periodo": 202604,
        "valor": 292723512.0,
        "delta": 151622.0
      },
      {
        "periodo": 202605,
        "valor": 316660414.0,
        "delta": 23936902.0
      },
      {
        "periodo": 202606,
        "valor": 24304062.0,
        "delta": -292356352.0
      },
      {
        "periodo": 202607,
        "valor": 29416772.0,
        "delta": 5112710.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 70375308.0,
    "valor_anterior": 70375308.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3002198.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 40393280.0,
        "delta": 37391082.0
      },
      {
        "periodo": 202509,
        "valor": 51677599.0,
        "delta": 11284319.0
      },
      {
        "periodo": 202510,
        "valor": 57595641.0,
        "delta": 5918042.0
      },
      {
        "periodo": 202511,
        "valor": 57595641.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 66201652.0,
        "delta": 8606011.0
      },
      {
        "periodo": 202601,
        "valor": 66201652.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 66201652.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 65396701.0,
        "delta": -804951.0
      },
      {
        "periodo": 202604,
        "valor": 70375308.0,
        "delta": 4978607.0
      },
      {
        "periodo": 202605,
        "valor": 70375308.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 70375308.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 70375308.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 1233326133.0,
    "valor_anterior": 1335889318.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 746595131.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 844816096.0,
        "delta": 98220965.0
      },
      {
        "periodo": 202509,
        "valor": 909882807.0,
        "delta": 65066711.0
      },
      {
        "periodo": 202510,
        "valor": 998252084.0,
        "delta": 88369277.0
      },
      {
        "periodo": 202511,
        "valor": 1054022047.0,
        "delta": 55769963.0
      },
      {
        "periodo": 202512,
        "valor": 1106361639.0,
        "delta": 52339592.0
      },
      {
        "periodo": 202601,
        "valor": 1099140496.0,
        "delta": -7221143.0
      },
      {
        "periodo": 202602,
        "valor": 1114996330.0,
        "delta": 15855834.0
      },
      {
        "periodo": 202603,
        "valor": 1175744105.0,
        "delta": 60747775.0
      },
      {
        "periodo": 202604,
        "valor": 1257262668.0,
        "delta": 81518563.0
      },
      {
        "periodo": 202605,
        "valor": 1269787358.0,
        "delta": 12524690.0
      },
      {
        "periodo": 202606,
        "valor": 1335889318.0,
        "delta": 66101960.0
      },
      {
        "periodo": 202607,
        "valor": 1233326133.0,
        "delta": -102563185.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 45251528.65,
    "valor_anterior": 46039808.41,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12212163.62,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12776744.62,
        "delta": 564581.0
      },
      {
        "periodo": 202509,
        "valor": 13731243.34,
        "delta": 954498.72
      },
      {
        "periodo": 202510,
        "valor": 13364556.76,
        "delta": -366686.58
      },
      {
        "periodo": 202511,
        "valor": 14388691.84,
        "delta": 1024135.08
      },
      {
        "periodo": 202512,
        "valor": 16643773.82,
        "delta": 2255081.98
      },
      {
        "periodo": 202601,
        "valor": 41598371.82,
        "delta": 24954598.0
      },
      {
        "periodo": 202602,
        "valor": 42236323.31,
        "delta": 637951.49
      },
      {
        "periodo": 202603,
        "valor": 42273730.8,
        "delta": 37407.49
      },
      {
        "periodo": 202604,
        "valor": 46648719.74,
        "delta": 4374988.94
      },
      {
        "periodo": 202605,
        "valor": 46584398.71,
        "delta": -64321.03
      },
      {
        "periodo": 202606,
        "valor": 46039808.41,
        "delta": -544590.3
      },
      {
        "periodo": 202607,
        "valor": 45251528.65,
        "delta": -788279.76
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 681484.0,
    "valor_anterior": 658067.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27606179.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 27582170.0,
        "delta": -24009.0
      },
      {
        "periodo": 202509,
        "valor": 27899306.0,
        "delta": 317136.0
      },
      {
        "periodo": 202510,
        "valor": 27878994.0,
        "delta": -20312.0
      },
      {
        "periodo": 202511,
        "valor": 10095718.0,
        "delta": -17783276.0
      },
      {
        "periodo": 202512,
        "valor": 789404.0,
        "delta": -9306314.0
      },
      {
        "periodo": 202601,
        "valor": 776687.0,
        "delta": -12717.0
      },
      {
        "periodo": 202602,
        "valor": 809424.0,
        "delta": 32737.0
      },
      {
        "periodo": 202603,
        "valor": 814658.0,
        "delta": 5234.0
      },
      {
        "periodo": 202604,
        "valor": 803926.0,
        "delta": -10732.0
      },
      {
        "periodo": 202605,
        "valor": 564180.0,
        "delta": -239746.0
      },
      {
        "periodo": 202606,
        "valor": 658067.0,
        "delta": 93887.0
      },
      {
        "periodo": 202607,
        "valor": 681484.0,
        "delta": 23417.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 1457438693.1,
    "valor_anterior": 1344435475.48,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2139612556.13,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2179662582.31,
        "delta": 40050026.18
      },
      {
        "periodo": 202509,
        "valor": 2184127935.59,
        "delta": 4465353.28
      },
      {
        "periodo": 202510,
        "valor": 2016700914.5,
        "delta": -167427021.09
      },
      {
        "periodo": 202511,
        "valor": 1833314380.59,
        "delta": -183386533.91
      },
      {
        "periodo": 202512,
        "valor": 1736584675.15,
        "delta": -96729705.44
      },
      {
        "periodo": 202601,
        "valor": 1599146698.86,
        "delta": -137437976.29
      },
      {
        "periodo": 202602,
        "valor": 1477626009.16,
        "delta": -121520689.7
      },
      {
        "periodo": 202603,
        "valor": 1292149275.78,
        "delta": -185476733.38
      },
      {
        "periodo": 202604,
        "valor": 1345371631.59,
        "delta": 53222355.81
      },
      {
        "periodo": 202605,
        "valor": 1331248559.37,
        "delta": -14123072.22
      },
      {
        "periodo": 202606,
        "valor": 1344435475.48,
        "delta": 13186916.11
      },
      {
        "periodo": 202607,
        "valor": 1457438693.1,
        "delta": 113003217.62
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5739970.31,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5739970.31,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 5737191.08,
        "delta": -2779.23
      },
      {
        "periodo": 202510,
        "valor": 5264845.18,
        "delta": -472345.9
      },
      {
        "periodo": 202511,
        "valor": 4759286.43,
        "delta": -505558.75
      },
      {
        "periodo": 202512,
        "valor": 4723559.52,
        "delta": -35726.91
      },
      {
        "periodo": 202601,
        "valor": 4651384.32,
        "delta": -72175.2
      },
      {
        "periodo": 202602,
        "valor": 4493562.89,
        "delta": -157821.43
      },
      {
        "periodo": 202603,
        "valor": 4408815.1,
        "delta": -84747.79
      },
      {
        "periodo": 202604,
        "valor": 4403400.09,
        "delta": -5415.01
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 790148.0,
    "valor_anterior": 2108225.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1327471.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1327471.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 1332334.0,
        "delta": 4863.0
      },
      {
        "periodo": 202510,
        "valor": 1446366.0,
        "delta": 114032.0
      },
      {
        "periodo": 202511,
        "valor": 1776207.0,
        "delta": 329841.0
      },
      {
        "periodo": 202512,
        "valor": 1776207.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 1910754.0,
        "delta": 134547.0
      },
      {
        "periodo": 202602,
        "valor": 1922820.0,
        "delta": 12066.0
      },
      {
        "periodo": 202603,
        "valor": 1920519.0,
        "delta": -2301.0
      },
      {
        "periodo": 202604,
        "valor": 1920519.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1920519.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 2108225.0,
        "delta": 187706.0
      },
      {
        "periodo": 202607,
        "valor": 790148.0,
        "delta": -1318077.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 114377.49,
    "valor_anterior": 112455.93,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 110623.63,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 110623.63,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 114466.33,
        "delta": 3842.7
      },
      {
        "periodo": 202510,
        "valor": 108252.2,
        "delta": -6214.13
      },
      {
        "periodo": 202511,
        "valor": 104123.97,
        "delta": -4128.23
      },
      {
        "periodo": 202512,
        "valor": 85874.83,
        "delta": -18249.14
      },
      {
        "periodo": 202601,
        "valor": 84006.42,
        "delta": -1868.41
      },
      {
        "periodo": 202602,
        "valor": 30558.73,
        "delta": -53447.69
      },
      {
        "periodo": 202603,
        "valor": 30558.73,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 37675.26,
        "delta": 7116.53
      },
      {
        "periodo": 202605,
        "valor": 111299.1,
        "delta": 73623.84
      },
      {
        "periodo": 202606,
        "valor": 112455.93,
        "delta": 1156.83
      },
      {
        "periodo": 202607,
        "valor": 114377.49,
        "delta": 1921.56
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 5963660.68,
    "valor_anterior": 2981830.34,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 2981830.34,
        "delta": 2981830.34
      },
      {
        "periodo": 202607,
        "valor": 5963660.68,
        "delta": 2981830.34
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 628232.0,
    "valor_anterior": 628232.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 495815.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 495815.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 495815.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": -495815.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 628232.0,
        "delta": 628232.0
      },
      {
        "periodo": 202607,
        "valor": 628232.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 33603067.35,
    "valor_anterior": 32704870.54,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12198893.61,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12428965.61,
        "delta": 230072.0
      },
      {
        "periodo": 202509,
        "valor": 14824262.24,
        "delta": 2395296.63
      },
      {
        "periodo": 202510,
        "valor": 17316717.83,
        "delta": 2492455.59
      },
      {
        "periodo": 202511,
        "valor": 19642691.62,
        "delta": 2325973.79
      },
      {
        "periodo": 202512,
        "valor": 21928651.81,
        "delta": 2285960.19
      },
      {
        "periodo": 202601,
        "valor": 24723380.45,
        "delta": 2794728.64
      },
      {
        "periodo": 202602,
        "valor": 26941571.71,
        "delta": 2218191.26
      },
      {
        "periodo": 202603,
        "valor": 27891675.51,
        "delta": 950103.8
      },
      {
        "periodo": 202604,
        "valor": 30647626.39,
        "delta": 2755950.88
      },
      {
        "periodo": 202605,
        "valor": 31776873.04,
        "delta": 1129246.65
      },
      {
        "periodo": 202606,
        "valor": 32704870.54,
        "delta": 927997.5
      },
      {
        "periodo": 202607,
        "valor": 33603067.35,
        "delta": 898196.81
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13969975.15,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14914673.51,
        "delta": 944698.36
      },
      {
        "periodo": 202509,
        "valor": 6411693.83,
        "delta": -8502979.68
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 1992760.31,
    "valor_anterior": 1992760.31,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1992760.31,
        "delta": 1992760.31
      },
      {
        "periodo": 202512,
        "valor": 1992760.31,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 1992760.31,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 1992760.31,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1992760.31,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1992760.31,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1992760.31,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 1992760.31,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 1992760.31,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 9833468654.000002,
    "valor_anterior": 9751346966.96,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8149754022.76,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8333270866.96,
        "delta": 183516844.2
      },
      {
        "periodo": 202509,
        "valor": 8620880583.55,
        "delta": 287609716.59
      },
      {
        "periodo": 202510,
        "valor": 8701742503.04,
        "delta": 80861919.49
      },
      {
        "periodo": 202511,
        "valor": 9761489295.41,
        "delta": 1059746792.37
      },
      {
        "periodo": 202512,
        "valor": 9908199855.18,
        "delta": 146710559.77
      },
      {
        "periodo": 202601,
        "valor": 9753714215.72,
        "delta": -154485639.46
      },
      {
        "periodo": 202602,
        "valor": 9696040068.2,
        "delta": -57674147.52
      },
      {
        "periodo": 202603,
        "valor": 9788518830.58,
        "delta": 92478762.38
      },
      {
        "periodo": 202604,
        "valor": 9990610207.42,
        "delta": 202091376.84
      },
      {
        "periodo": 202605,
        "valor": 9969893163.52,
        "delta": -20717043.9
      },
      {
        "periodo": 202606,
        "valor": 9751346966.96,
        "delta": -218546196.56
      },
      {
        "periodo": 202607,
        "valor": 9833468654.0,
        "delta": 82121687.04
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 9637641879.630001,
    "valor_anterior": 9558325471.150002,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8011931669.19,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8164430987.18,
        "delta": 152499317.99
      },
      {
        "periodo": 202509,
        "valor": 8449952502.04,
        "delta": 285521514.86
      },
      {
        "periodo": 202510,
        "valor": 8531680786.89,
        "delta": 81728284.85
      },
      {
        "periodo": 202511,
        "valor": 9605079413.84,
        "delta": 1073398626.95
      },
      {
        "periodo": 202512,
        "valor": 9754712865.69,
        "delta": 149633451.85
      },
      {
        "periodo": 202601,
        "valor": 9564834688.06,
        "delta": -189878177.63
      },
      {
        "periodo": 202602,
        "valor": 9506859881.09,
        "delta": -57974806.97
      },
      {
        "periodo": 202603,
        "valor": 9602593921.22,
        "delta": 95734040.13
      },
      {
        "periodo": 202604,
        "valor": 9795077902.79,
        "delta": 192483981.57
      },
      {
        "periodo": 202605,
        "valor": 9779603927.83,
        "delta": -15473974.96
      },
      {
        "periodo": 202606,
        "valor": 9558325471.15,
        "delta": -221278456.68
      },
      {
        "periodo": 202607,
        "valor": 9637641879.63,
        "delta": 79316408.48
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 1215960.95,
    "valor_anterior": 2157230.61,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 19709945.46,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 20654643.82,
        "delta": 944698.36
      },
      {
        "periodo": 202509,
        "valor": 12148884.91,
        "delta": -8505758.91
      },
      {
        "periodo": 202510,
        "valor": 11520925.13,
        "delta": -627959.78
      },
      {
        "periodo": 202511,
        "valor": 10861153.39,
        "delta": -659771.74
      },
      {
        "periodo": 202512,
        "valor": 10582650.78,
        "delta": -278502.61
      },
      {
        "periodo": 202601,
        "valor": 10425008.76,
        "delta": -157642.02
      },
      {
        "periodo": 202602,
        "valor": 9710483.67,
        "delta": -714525.09
      },
      {
        "periodo": 202603,
        "valor": 7628918.42,
        "delta": -2081565.25
      },
      {
        "periodo": 202604,
        "valor": 7214860.41,
        "delta": -414058.01
      },
      {
        "periodo": 202605,
        "valor": 2475962.04,
        "delta": -4738898.37
      },
      {
        "periodo": 202606,
        "valor": 2157230.61,
        "delta": -318731.43
      },
      {
        "periodo": 202607,
        "valor": 1215960.95,
        "delta": -941269.66
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 681484.0,
    "valor_anterior": 658067.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 27606179.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 27582170.0,
        "delta": -24009.0
      },
      {
        "periodo": 202509,
        "valor": 27899306.0,
        "delta": 317136.0
      },
      {
        "periodo": 202510,
        "valor": 27878994.0,
        "delta": -20312.0
      },
      {
        "periodo": 202511,
        "valor": 10095718.0,
        "delta": -17783276.0
      },
      {
        "periodo": 202512,
        "valor": 789404.0,
        "delta": -9306314.0
      },
      {
        "periodo": 202601,
        "valor": 776687.0,
        "delta": -12717.0
      },
      {
        "periodo": 202602,
        "valor": 809424.0,
        "delta": 32737.0
      },
      {
        "periodo": 202603,
        "valor": 814658.0,
        "delta": 5234.0
      },
      {
        "periodo": 202604,
        "valor": 803926.0,
        "delta": -10732.0
      },
      {
        "periodo": 202605,
        "valor": 564180.0,
        "delta": -239746.0
      },
      {
        "periodo": 202606,
        "valor": 658067.0,
        "delta": 93887.0
      },
      {
        "periodo": 202607,
        "valor": 681484.0,
        "delta": 23417.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 152255463.59,
    "valor_anterior": 152414281.08,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 78196711.87,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 108063476.72,
        "delta": 29866764.85
      },
      {
        "periodo": 202509,
        "valor": 115941162.03,
        "delta": 7877685.31
      },
      {
        "periodo": 202510,
        "valor": 113236826.99,
        "delta": -2704335.04
      },
      {
        "periodo": 202511,
        "valor": 113713434.28,
        "delta": 476607.29
      },
      {
        "periodo": 202512,
        "valor": 118107647.76,
        "delta": 4394213.48
      },
      {
        "periodo": 202601,
        "valor": 150877684.72,
        "delta": 32770036.96
      },
      {
        "periodo": 202602,
        "valor": 149695388.69,
        "delta": -1182296.03
      },
      {
        "periodo": 202603,
        "valor": 147566338.39,
        "delta": -2129050.3
      },
      {
        "periodo": 202604,
        "valor": 154835456.26,
        "delta": 7269117.87
      },
      {
        "periodo": 202605,
        "valor": 153368161.2,
        "delta": -1467295.06
      },
      {
        "periodo": 202606,
        "valor": 152414281.08,
        "delta": -953880.12
      },
      {
        "periodo": 202607,
        "valor": 152255463.59,
        "delta": -158817.49
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 7956420.99,
    "valor_anterior": 4974590.65,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 1992760.31,
        "delta": 1992760.31
      },
      {
        "periodo": 202512,
        "valor": 1992760.31,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 1992760.31,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 1992760.31,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 1992760.31,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 1992760.31,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 1992760.31,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 4974590.65,
        "delta": 2981830.34
      },
      {
        "periodo": 202607,
        "valor": 7956420.99,
        "delta": 2981830.34
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200209,
    "label": "Quitas y Castigos Vivienda (Suma 12m)",
    "valor_actual": 33717444.84,
    "valor_anterior": 32817326.47,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": true,
    "historico": [
      {
        "periodo": 202507,
        "valor": 12309517.24,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 12539589.24,
        "delta": 230072.0
      },
      {
        "periodo": 202509,
        "valor": 14938728.57,
        "delta": 2399139.33
      },
      {
        "periodo": 202510,
        "valor": 17424970.03,
        "delta": 2486241.46
      },
      {
        "periodo": 202511,
        "valor": 19746815.59,
        "delta": 2321845.56
      },
      {
        "periodo": 202512,
        "valor": 22014526.64,
        "delta": 2267711.05
      },
      {
        "periodo": 202601,
        "valor": 24807386.87,
        "delta": 2792860.23
      },
      {
        "periodo": 202602,
        "valor": 26972130.44,
        "delta": 2164743.57
      },
      {
        "periodo": 202603,
        "valor": 27922234.24,
        "delta": 950103.8
      },
      {
        "periodo": 202604,
        "valor": 30685301.65,
        "delta": 2763067.41
      },
      {
        "periodo": 202605,
        "valor": 31888172.14,
        "delta": 1202870.49
      },
      {
        "periodo": 202606,
        "valor": 32817326.47,
        "delta": 929154.33
      },
      {
        "periodo": 202607,
        "valor": 33717444.84,
        "delta": 900118.37
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": true,
      "tematico_solvencia": false,
      "reservas_calificacion": true
    }
  },
  {
    "nombre_entidad": "40002 Banamex",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 871443359721.3434,
    "valor_anterior": 868315782209.3466,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 943858881508.106,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 915499537108.5092,
        "delta": -28359344399.5968
      },
      {
        "periodo": 202509,
        "valor": 892041427627.9199,
        "delta": -23458109480.5892
      },
      {
        "periodo": 202510,
        "valor": 869304966284.8867,
        "delta": -22736461343.0332
      },
      {
        "periodo": 202511,
        "valor": 842202110243.9141,
        "delta": -27102856040.9727
      },
      {
        "periodo": 202512,
        "valor": 847240738637.785,
        "delta": 5038628393.871
      },
      {
        "periodo": 202601,
        "valor": 852668643025.81,
        "delta": 5427904388.025
      },
      {
        "periodo": 202602,
        "valor": 855403119110.3717,
        "delta": 2734476084.5616
      },
      {
        "periodo": 202603,
        "valor": 857107089727.6425,
        "delta": 1703970617.2708
      },
      {
        "periodo": 202604,
        "valor": 860136304587.305,
        "delta": 3029214859.6626
      },
      {
        "periodo": 202605,
        "valor": 864087948681.8942,
        "delta": 3951644094.5891
      },
      {
        "periodo": 202606,
        "valor": 868315782209.3466,
        "delta": 4227833527.4524
      },
      {
        "periodo": 202607,
        "valor": 871443359721.3434,
        "delta": 3127577511.9968
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40012 BBVA México",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 2738233840775.995,
    "valor_anterior": 2712540262626.5083,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2576804861738.3325,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2584297244096.3594,
        "delta": 7492382358.0269
      },
      {
        "periodo": 202509,
        "valor": 2596507875856.776,
        "delta": 12210631760.4165
      },
      {
        "periodo": 202510,
        "valor": 2601379691797.375,
        "delta": 4871815940.5991
      },
      {
        "periodo": 202511,
        "valor": 2605420526552.759,
        "delta": 4040834755.3838
      },
      {
        "periodo": 202512,
        "valor": 2609066174553.697,
        "delta": 3645648000.938
      },
      {
        "periodo": 202601,
        "valor": 2623559493420.495,
        "delta": 14493318866.7983
      },
      {
        "periodo": 202602,
        "valor": 2645210826829.7183,
        "delta": 21651333409.2231
      },
      {
        "periodo": 202603,
        "valor": 2657820698750.4766,
        "delta": 12609871920.7583
      },
      {
        "periodo": 202604,
        "valor": 2671630640635.345,
        "delta": 13809941884.8687
      },
      {
        "periodo": 202605,
        "valor": 2693550167084.0215,
        "delta": 21919526448.6763
      },
      {
        "periodo": 202606,
        "valor": 2712540262626.5083,
        "delta": 18990095542.4868
      },
      {
        "periodo": 202607,
        "valor": 2738233840775.995,
        "delta": 25693578149.4868
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40014 Santander",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 1549364458081.4998,
    "valor_anterior": 1538632747828.3335,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1480981818628.6667,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1482097332544.4998,
        "delta": 1115513915.833
      },
      {
        "periodo": 202509,
        "valor": 1485726587138.0002,
        "delta": 3629254593.5005
      },
      {
        "periodo": 202510,
        "valor": 1488039948434.5835,
        "delta": 2313361296.5833
      },
      {
        "periodo": 202511,
        "valor": 1485884505185.5833,
        "delta": -2155443249.0002
      },
      {
        "periodo": 202512,
        "valor": 1494921226412.6667,
        "delta": 9036721227.0835
      },
      {
        "periodo": 202601,
        "valor": 1504116008748.4167,
        "delta": 9194782335.75
      },
      {
        "periodo": 202602,
        "valor": 1512402875154.7498,
        "delta": 8286866406.333
      },
      {
        "periodo": 202603,
        "valor": 1519374393851.8333,
        "delta": 6971518697.0835
      },
      {
        "periodo": 202604,
        "valor": 1526693168562.0,
        "delta": 7318774710.1667
      },
      {
        "periodo": 202605,
        "valor": 1533017809827.0835,
        "delta": 6324641265.0835
      },
      {
        "periodo": 202606,
        "valor": 1538632747828.3335,
        "delta": 5614938001.25
      },
      {
        "periodo": 202607,
        "valor": 1549364458081.4998,
        "delta": 10731710253.1663
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40021 HSBC",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 688708939588.4166,
    "valor_anterior": 694996667348.0834,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 723419301667.3334,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 724468094294.5833,
        "delta": 1048792627.2499
      },
      {
        "periodo": 202509,
        "valor": 726047940909.6666,
        "delta": 1579846615.0834
      },
      {
        "periodo": 202510,
        "valor": 727317845349.1667,
        "delta": 1269904439.5001
      },
      {
        "periodo": 202511,
        "valor": 726884761023.6666,
        "delta": -433084325.5001
      },
      {
        "periodo": 202512,
        "valor": 724717878710.1666,
        "delta": -2166882313.5
      },
      {
        "periodo": 202601,
        "valor": 721382923055.5,
        "delta": -3334955654.6666
      },
      {
        "periodo": 202602,
        "valor": 719034629716.8334,
        "delta": -2348293338.6666
      },
      {
        "periodo": 202603,
        "valor": 714453684072.0,
        "delta": -4580945644.8334
      },
      {
        "periodo": 202604,
        "valor": 706688524184.1666,
        "delta": -7765159887.8334
      },
      {
        "periodo": 202605,
        "valor": 700783532358.1667,
        "delta": -5904991825.9999
      },
      {
        "periodo": 202606,
        "valor": 694996667348.0834,
        "delta": -5786865010.0834
      },
      {
        "periodo": 202607,
        "valor": 688708939588.4166,
        "delta": -6287727759.6667
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40030 Banco del Bajío",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 331919769083.4775,
    "valor_anterior": 329376529247.80334,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 305589030364.5817,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 308245899033.1017,
        "delta": 2656868668.52
      },
      {
        "periodo": 202509,
        "valor": 310828034704.3267,
        "delta": 2582135671.225
      },
      {
        "periodo": 202510,
        "valor": 312935861159.285,
        "delta": 2107826454.9583
      },
      {
        "periodo": 202511,
        "valor": 314863150210.7808,
        "delta": 1927289051.4958
      },
      {
        "periodo": 202512,
        "valor": 316885265501.0725,
        "delta": 2022115290.2917
      },
      {
        "periodo": 202601,
        "valor": 317790830759.755,
        "delta": 905565258.6825
      },
      {
        "periodo": 202602,
        "valor": 319101280511.26,
        "delta": 1310449751.505
      },
      {
        "periodo": 202603,
        "valor": 321423479272.5042,
        "delta": 2322198761.2441
      },
      {
        "periodo": 202604,
        "valor": 324144167914.7343,
        "delta": 2720688642.2301
      },
      {
        "periodo": 202605,
        "valor": 326524518226.2758,
        "delta": 2380350311.5416
      },
      {
        "periodo": 202606,
        "valor": 329376529247.8033,
        "delta": 2852011021.5275
      },
      {
        "periodo": 202607,
        "valor": 331919769083.4775,
        "delta": 2543239835.6741
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40036 Inbursa",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 479911984336.1667,
    "valor_anterior": 480207856432.6667,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 467021028137.4166,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 470999157135.75,
        "delta": 3978128998.3334
      },
      {
        "periodo": 202509,
        "valor": 474597197366.1666,
        "delta": 3598040230.4166
      },
      {
        "periodo": 202510,
        "valor": 476784677673.6666,
        "delta": 2187480307.5
      },
      {
        "periodo": 202511,
        "valor": 478936396664.0,
        "delta": 2151718990.3334
      },
      {
        "periodo": 202512,
        "valor": 478935420749.4167,
        "delta": -975914.5833
      },
      {
        "periodo": 202601,
        "valor": 479020512916.2499,
        "delta": 85092166.8333
      },
      {
        "periodo": 202602,
        "valor": 479448595293.5834,
        "delta": 428082377.3334
      },
      {
        "periodo": 202603,
        "valor": 478950921880.5,
        "delta": -497673413.0834
      },
      {
        "periodo": 202604,
        "valor": 479831792770.75,
        "delta": 880870890.25
      },
      {
        "periodo": 202605,
        "valor": 479881086101.75,
        "delta": 49293331.0
      },
      {
        "periodo": 202606,
        "valor": 480207856432.6667,
        "delta": 326770330.9167
      },
      {
        "periodo": 202607,
        "valor": 479911984336.1667,
        "delta": -295872096.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40042 Banca Mifel",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 161883767708.6667,
    "valor_anterior": 159821174711.41666,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 134087452908.0833,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 136591190878.6667,
        "delta": 2503737970.5833
      },
      {
        "periodo": 202509,
        "valor": 138773825364.0,
        "delta": 2182634485.3333
      },
      {
        "periodo": 202510,
        "valor": 140644470803.0,
        "delta": 1870645439.0
      },
      {
        "periodo": 202511,
        "valor": 142368270589.3333,
        "delta": 1723799786.3333
      },
      {
        "periodo": 202512,
        "valor": 144333351103.8333,
        "delta": 1965080514.5
      },
      {
        "periodo": 202601,
        "valor": 147216525361.1667,
        "delta": 2883174257.3333
      },
      {
        "periodo": 202602,
        "valor": 149599226791.9167,
        "delta": 2382701430.75
      },
      {
        "periodo": 202603,
        "valor": 152239024930.1667,
        "delta": 2639798138.25
      },
      {
        "periodo": 202604,
        "valor": 154993534924.5833,
        "delta": 2754509994.4167
      },
      {
        "periodo": 202605,
        "valor": 157550424348.8333,
        "delta": 2556889424.25
      },
      {
        "periodo": 202606,
        "valor": 159821174711.4167,
        "delta": 2270750362.5833
      },
      {
        "periodo": 202607,
        "valor": 161883767708.6667,
        "delta": 2062592997.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40044 Scotiabank",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 734298890984.9166,
    "valor_anterior": 732649862276.9166,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 724476325428.4166,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 727521059519.5,
        "delta": 3044734091.0834
      },
      {
        "periodo": 202509,
        "valor": 728424470612.8334,
        "delta": 903411093.3334
      },
      {
        "periodo": 202510,
        "valor": 728394686079.25,
        "delta": -29784533.5834
      },
      {
        "periodo": 202511,
        "valor": 729726931683.0833,
        "delta": 1332245603.8333
      },
      {
        "periodo": 202512,
        "valor": 730201418912.5834,
        "delta": 474487229.5001
      },
      {
        "periodo": 202601,
        "valor": 730896951679.25,
        "delta": 695532766.6666
      },
      {
        "periodo": 202602,
        "valor": 731672244321.5,
        "delta": 775292642.25
      },
      {
        "periodo": 202603,
        "valor": 731223810457.9167,
        "delta": -448433863.5833
      },
      {
        "periodo": 202604,
        "valor": 732058593197.1667,
        "delta": 834782739.25
      },
      {
        "periodo": 202605,
        "valor": 731233015802.25,
        "delta": -825577394.9167
      },
      {
        "periodo": 202606,
        "valor": 732649862276.9166,
        "delta": 1416846474.6666
      },
      {
        "periodo": 202607,
        "valor": 734298890984.9166,
        "delta": 1649028708.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40058 Banregio",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 230720489401.84586,
    "valor_anterior": 229441091217.74252,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 209706170346.4425,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 212014793475.995,
        "delta": 2308623129.5525
      },
      {
        "periodo": 202509,
        "valor": 214284837447.3,
        "delta": 2270043971.305
      },
      {
        "periodo": 202510,
        "valor": 216250636754.0042,
        "delta": 1965799306.7042
      },
      {
        "periodo": 202511,
        "valor": 218493709149.745,
        "delta": 2243072395.7408
      },
      {
        "periodo": 202512,
        "valor": 220923616555.5283,
        "delta": 2429907405.7833
      },
      {
        "periodo": 202601,
        "valor": 223306344073.2225,
        "delta": 2382727517.6942
      },
      {
        "periodo": 202602,
        "valor": 224883940527.6017,
        "delta": 1577596454.3792
      },
      {
        "periodo": 202603,
        "valor": 226172438908.86,
        "delta": 1288498381.2584
      },
      {
        "periodo": 202604,
        "valor": 227347188158.1192,
        "delta": 1174749249.2592
      },
      {
        "periodo": 202605,
        "valor": 228451113190.0475,
        "delta": 1103925031.9283
      },
      {
        "periodo": 202606,
        "valor": 229441091217.7425,
        "delta": 989978027.695
      },
      {
        "periodo": 202607,
        "valor": 230720489401.8459,
        "delta": 1279398184.1033
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40059 Invex",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 176955957722.5,
    "valor_anterior": 176447829555.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 153791251889.75,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 155820944860.0,
        "delta": 2029692970.25
      },
      {
        "periodo": 202509,
        "valor": 159084849660.8333,
        "delta": 3263904800.8333
      },
      {
        "periodo": 202510,
        "valor": 164274732765.3333,
        "delta": 5189883104.5
      },
      {
        "periodo": 202511,
        "valor": 167566243803.1667,
        "delta": 3291511037.8333
      },
      {
        "periodo": 202512,
        "valor": 169280212477.25,
        "delta": 1713968674.0833
      },
      {
        "periodo": 202601,
        "valor": 171045579719.25,
        "delta": 1765367242.0
      },
      {
        "periodo": 202602,
        "valor": 172587518078.0,
        "delta": 1541938358.75
      },
      {
        "periodo": 202603,
        "valor": 173976382173.3333,
        "delta": 1388864095.3333
      },
      {
        "periodo": 202604,
        "valor": 173442096540.9167,
        "delta": -534285632.4167
      },
      {
        "periodo": 202605,
        "valor": 175052428533.5833,
        "delta": 1610331992.6667
      },
      {
        "periodo": 202606,
        "valor": 176447829555.25,
        "delta": 1395401021.6667
      },
      {
        "periodo": 202607,
        "valor": 176955957722.5,
        "delta": 508128167.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40060 Bansí",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 57313755949.0,
    "valor_anterior": 58316571013.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 58735055395.9167,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 59794520409.3333,
        "delta": 1059465013.4167
      },
      {
        "periodo": 202509,
        "valor": 60312216637.75,
        "delta": 517696228.4167
      },
      {
        "periodo": 202510,
        "valor": 60636968953.3333,
        "delta": 324752315.5833
      },
      {
        "periodo": 202511,
        "valor": 61196880246.3333,
        "delta": 559911293.0
      },
      {
        "periodo": 202512,
        "valor": 61475890338.0,
        "delta": 279010091.6667
      },
      {
        "periodo": 202601,
        "valor": 61440880263.25,
        "delta": -35010074.75
      },
      {
        "periodo": 202602,
        "valor": 61349276881.0833,
        "delta": -91603382.1667
      },
      {
        "periodo": 202603,
        "valor": 60942856403.4167,
        "delta": -406420477.6667
      },
      {
        "periodo": 202604,
        "valor": 60258210868.0833,
        "delta": -684645535.3333
      },
      {
        "periodo": 202605,
        "valor": 59465497144.5,
        "delta": -792713723.5833
      },
      {
        "periodo": 202606,
        "valor": 58316571013.25,
        "delta": -1148926131.25
      },
      {
        "periodo": 202607,
        "valor": 57313755949.0,
        "delta": -1002815064.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40062 Afirme",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 238098900934.41666,
    "valor_anterior": 238238089725.5833,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 247139969382.0833,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 247643397252.25,
        "delta": 503427870.1667
      },
      {
        "periodo": 202509,
        "valor": 249336549697.1667,
        "delta": 1693152444.9167
      },
      {
        "periodo": 202510,
        "valor": 250575363258.3333,
        "delta": 1238813561.1667
      },
      {
        "periodo": 202511,
        "valor": 251178792192.6667,
        "delta": 603428934.3333
      },
      {
        "periodo": 202512,
        "valor": 250684022774.9167,
        "delta": -494769417.75
      },
      {
        "periodo": 202601,
        "valor": 250700515435.1667,
        "delta": 16492660.25
      },
      {
        "periodo": 202602,
        "valor": 248095369408.0,
        "delta": -2605146027.1667
      },
      {
        "periodo": 202603,
        "valor": 245700777400.3333,
        "delta": -2394592007.6667
      },
      {
        "periodo": 202604,
        "valor": 244442224881.5,
        "delta": -1258552518.8333
      },
      {
        "periodo": 202605,
        "valor": 240966123992.5833,
        "delta": -3476100888.9167
      },
      {
        "periodo": 202606,
        "valor": 238238089725.5833,
        "delta": -2728034267.0
      },
      {
        "periodo": 202607,
        "valor": 238098900934.4167,
        "delta": -139188791.1667
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40072 Banorte",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 1650325172517.7275,
    "valor_anterior": 1635654260116.815,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1547699336922.6992,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1554758420379.32,
        "delta": 7059083456.6208
      },
      {
        "periodo": 202509,
        "valor": 1560727278725.2783,
        "delta": 5968858345.9583
      },
      {
        "periodo": 202510,
        "valor": 1568074618734.5593,
        "delta": 7347340009.281
      },
      {
        "periodo": 202511,
        "valor": 1573827718351.305,
        "delta": 5753099616.7456
      },
      {
        "periodo": 202512,
        "valor": 1584244803167.41,
        "delta": 10417084816.105
      },
      {
        "periodo": 202601,
        "valor": 1591527964564.3784,
        "delta": 7283161396.9685
      },
      {
        "periodo": 202602,
        "valor": 1599567682391.434,
        "delta": 8039717827.0557
      },
      {
        "periodo": 202603,
        "valor": 1607271619078.5251,
        "delta": 7703936687.0911
      },
      {
        "periodo": 202604,
        "valor": 1615912396680.2183,
        "delta": 8640777601.6931
      },
      {
        "periodo": 202605,
        "valor": 1625035644037.6475,
        "delta": 9123247357.4292
      },
      {
        "periodo": 202606,
        "valor": 1635654260116.815,
        "delta": 10618616079.1675
      },
      {
        "periodo": 202607,
        "valor": 1650325172517.7275,
        "delta": 14670912400.9126
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40106 Bank of America",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 102184522304.75,
    "valor_anterior": 107525205811.08333,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 105606438511.8333,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 106742563905.4167,
        "delta": 1136125393.5833
      },
      {
        "periodo": 202509,
        "valor": 107730806920.4167,
        "delta": 988243015.0
      },
      {
        "periodo": 202510,
        "valor": 108512659286.1667,
        "delta": 781852365.75
      },
      {
        "periodo": 202511,
        "valor": 109258312195.6667,
        "delta": 745652909.5
      },
      {
        "periodo": 202512,
        "valor": 109410281835.0,
        "delta": 151969639.3333
      },
      {
        "periodo": 202601,
        "valor": 107783340901.9167,
        "delta": -1626940933.0833
      },
      {
        "periodo": 202602,
        "valor": 111472142933.3333,
        "delta": 3688802031.4167
      },
      {
        "periodo": 202603,
        "valor": 112043022178.0833,
        "delta": 570879244.75
      },
      {
        "periodo": 202604,
        "valor": 108956910201.75,
        "delta": -3086111976.3333
      },
      {
        "periodo": 202605,
        "valor": 106574323249.5,
        "delta": -2382586952.25
      },
      {
        "periodo": 202606,
        "valor": 107525205811.0833,
        "delta": 950882561.5833
      },
      {
        "periodo": 202607,
        "valor": 102184522304.75,
        "delta": -5340683506.3333
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40108 MUFG Bank",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 32418076175.333336,
    "valor_anterior": 32275278070.916668,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 32344754696.3333,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 32052234207.3333,
        "delta": -292520489.0
      },
      {
        "periodo": 202509,
        "valor": 32065832689.8333,
        "delta": 13598482.5
      },
      {
        "periodo": 202510,
        "valor": 31962846957.75,
        "delta": -102985732.0833
      },
      {
        "periodo": 202511,
        "valor": 32036685438.8333,
        "delta": 73838481.0833
      },
      {
        "periodo": 202512,
        "valor": 31757160645.3333,
        "delta": -279524793.5
      },
      {
        "periodo": 202601,
        "valor": 31570269224.4167,
        "delta": -186891420.9167
      },
      {
        "periodo": 202602,
        "valor": 31442851985.25,
        "delta": -127417239.1667
      },
      {
        "periodo": 202603,
        "valor": 31458344890.25,
        "delta": 15492905.0
      },
      {
        "periodo": 202604,
        "valor": 31648436521.5,
        "delta": 190091631.25
      },
      {
        "periodo": 202605,
        "valor": 31927573160.25,
        "delta": 279136638.75
      },
      {
        "periodo": 202606,
        "valor": 32275278070.9167,
        "delta": 347704910.6667
      },
      {
        "periodo": 202607,
        "valor": 32418076175.3333,
        "delta": 142798104.4167
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40110 J.P. Morgan",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 120782984670.91667,
    "valor_anterior": 122865598791.75,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 116335952315.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 119190515332.5,
        "delta": 2854563017.0
      },
      {
        "periodo": 202509,
        "valor": 122079683626.0833,
        "delta": 2889168293.5833
      },
      {
        "periodo": 202510,
        "valor": 122101650291.5,
        "delta": 21966665.4166
      },
      {
        "periodo": 202511,
        "valor": 122103939880.4167,
        "delta": 2289588.9167
      },
      {
        "periodo": 202512,
        "valor": 119783115178.25,
        "delta": -2320824702.1667
      },
      {
        "periodo": 202601,
        "valor": 119931623163.25,
        "delta": 148507985.0
      },
      {
        "periodo": 202602,
        "valor": 121371982027.4167,
        "delta": 1440358864.1667
      },
      {
        "periodo": 202603,
        "valor": 123237049598.25,
        "delta": 1865067570.8333
      },
      {
        "periodo": 202604,
        "valor": 123456275827.0833,
        "delta": 219226228.8333
      },
      {
        "periodo": 202605,
        "valor": 122758502833.75,
        "delta": -697772993.3333
      },
      {
        "periodo": 202606,
        "valor": 122865598791.75,
        "delta": 107095958.0
      },
      {
        "periodo": 202607,
        "valor": 120782984670.9167,
        "delta": -2082614120.8333
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40112 Monex",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 203851362976.12164,
    "valor_anterior": 204964701739.07416,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 225768751547.4242,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 227639204020.9984,
        "delta": 1870452473.5742
      },
      {
        "periodo": 202509,
        "valor": 228517293312.6625,
        "delta": 878089291.6641
      },
      {
        "periodo": 202510,
        "valor": 227867795896.8817,
        "delta": -649497415.7808
      },
      {
        "periodo": 202511,
        "valor": 225449424775.5925,
        "delta": -2418371121.2892
      },
      {
        "periodo": 202512,
        "valor": 224897289483.9758,
        "delta": -552135291.6167
      },
      {
        "periodo": 202601,
        "valor": 222179893565.5325,
        "delta": -2717395918.4433
      },
      {
        "periodo": 202602,
        "valor": 219761245738.8475,
        "delta": -2418647826.685
      },
      {
        "periodo": 202603,
        "valor": 215059116726.9858,
        "delta": -4702129011.8617
      },
      {
        "periodo": 202604,
        "valor": 210771253020.5758,
        "delta": -4287863706.41
      },
      {
        "periodo": 202605,
        "valor": 206427062222.4542,
        "delta": -4344190798.1217
      },
      {
        "periodo": 202606,
        "valor": 204964701739.0742,
        "delta": -1462360483.38
      },
      {
        "periodo": 202607,
        "valor": 203851362976.1216,
        "delta": -1113338762.9525
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40113 Ve por Más",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 111194857726.08334,
    "valor_anterior": 108616038650.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 82895039645.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 84230564435.75,
        "delta": 1335524790.75
      },
      {
        "periodo": 202509,
        "valor": 85680830566.4167,
        "delta": 1450266130.6667
      },
      {
        "periodo": 202510,
        "valor": 87264234200.0,
        "delta": 1583403633.5833
      },
      {
        "periodo": 202511,
        "valor": 88936660637.3333,
        "delta": 1672426437.3333
      },
      {
        "periodo": 202512,
        "valor": 90995979929.3333,
        "delta": 2059319292.0
      },
      {
        "periodo": 202601,
        "valor": 93808413388.5833,
        "delta": 2812433459.25
      },
      {
        "periodo": 202602,
        "valor": 97001258477.1667,
        "delta": 3192845088.5833
      },
      {
        "periodo": 202603,
        "valor": 100078662960.0,
        "delta": 3077404482.8333
      },
      {
        "periodo": 202604,
        "valor": 102989360082.9167,
        "delta": 2910697122.9166
      },
      {
        "periodo": 202605,
        "valor": 106085492537.75,
        "delta": 3096132454.8333
      },
      {
        "periodo": 202606,
        "valor": 108616038650.0,
        "delta": 2530546112.25
      },
      {
        "periodo": 202607,
        "valor": 111194857726.0833,
        "delta": 2578819076.0833
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40124 Citi México",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 462773533754.39166,
    "valor_anterior": 458627144870.2292,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 310099102259.3967,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 348622462078.91,
        "delta": 38523359819.5134
      },
      {
        "periodo": 202509,
        "valor": 385300554258.41,
        "delta": 36678092179.4999
      },
      {
        "periodo": 202510,
        "valor": 421484649725.8,
        "delta": 36184095467.3901
      },
      {
        "periodo": 202511,
        "valor": 460684611379.145,
        "delta": 39199961653.345
      },
      {
        "periodo": 202512,
        "valor": 455439297365.2958,
        "delta": -5245314013.8492
      },
      {
        "periodo": 202601,
        "valor": 454097501933.51,
        "delta": -1341795431.7858
      },
      {
        "periodo": 202602,
        "valor": 452634435670.8275,
        "delta": -1463066262.6825
      },
      {
        "periodo": 202603,
        "valor": 454319567412.3458,
        "delta": 1685131741.5183
      },
      {
        "periodo": 202604,
        "valor": 455413748052.2549,
        "delta": 1094180639.9091
      },
      {
        "periodo": 202605,
        "valor": 457156459392.3517,
        "delta": 1742711340.0967
      },
      {
        "periodo": 202606,
        "valor": 458627144870.2292,
        "delta": 1470685477.8775
      },
      {
        "periodo": 202607,
        "valor": 462773533754.3917,
        "delta": 4146388884.1625
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40126 Credit Suisse",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 0.0,
    "valor_anterior": 0.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 0.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202509,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202510,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202511,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202512,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202601,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202602,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202603,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202604,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202605,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202606,
        "valor": 0.0,
        "delta": 0.0
      },
      {
        "periodo": 202607,
        "valor": 0.0,
        "delta": 0.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40127 Banco Azteca",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 285091521089.6017,
    "valor_anterior": 286702320736.1225,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 269679188316.3083,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 272727057590.8542,
        "delta": 3047869274.5458
      },
      {
        "periodo": 202509,
        "valor": 275540198415.4484,
        "delta": 2813140824.5942
      },
      {
        "periodo": 202510,
        "valor": 277887832704.8367,
        "delta": 2347634289.3883
      },
      {
        "periodo": 202511,
        "valor": 281475075139.3,
        "delta": 3587242434.4633
      },
      {
        "periodo": 202512,
        "valor": 283632611743.7025,
        "delta": 2157536604.4025
      },
      {
        "periodo": 202601,
        "valor": 285835914341.565,
        "delta": 2203302597.8625
      },
      {
        "periodo": 202602,
        "valor": 287003074573.9033,
        "delta": 1167160232.3383
      },
      {
        "periodo": 202603,
        "valor": 287571383785.2525,
        "delta": 568309211.3492
      },
      {
        "periodo": 202604,
        "valor": 288020435039.455,
        "delta": 449051254.2025
      },
      {
        "periodo": 202605,
        "valor": 287386518638.1008,
        "delta": -633916401.3541
      },
      {
        "periodo": 202606,
        "valor": 286702320736.1225,
        "delta": -684197901.9783
      },
      {
        "periodo": 202607,
        "valor": 285091521089.6017,
        "delta": -1610799646.5208
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40128 Kapital",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 53302284424.223335,
    "valor_anterior": 48699563874.79749,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13512397971.1508,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14850118161.7867,
        "delta": 1337720190.6358
      },
      {
        "periodo": 202509,
        "valor": 17937398197.5617,
        "delta": 3087280035.775
      },
      {
        "periodo": 202510,
        "valor": 21162729902.6142,
        "delta": 3225331705.0525
      },
      {
        "periodo": 202511,
        "valor": 24107218056.905,
        "delta": 2944488154.2908
      },
      {
        "periodo": 202512,
        "valor": 27776130099.2675,
        "delta": 3668912042.3625
      },
      {
        "periodo": 202601,
        "valor": 31031052581.69,
        "delta": 3254922482.4225
      },
      {
        "periodo": 202602,
        "valor": 33794431312.8883,
        "delta": 2763378731.1983
      },
      {
        "periodo": 202603,
        "valor": 37589832598.8417,
        "delta": 3795401285.9533
      },
      {
        "periodo": 202604,
        "valor": 40558965255.4433,
        "delta": 2969132656.6017
      },
      {
        "periodo": 202605,
        "valor": 43427613700.6658,
        "delta": 2868648445.2225
      },
      {
        "periodo": 202606,
        "valor": 48699563874.7975,
        "delta": 5271950174.1317
      },
      {
        "periodo": 202607,
        "valor": 53302284424.2233,
        "delta": 4602720549.4258
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40129 Barclays",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 43404028729.75,
    "valor_anterior": 43429378325.333336,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 43031375988.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 42787880556.0,
        "delta": -243495432.5
      },
      {
        "periodo": 202509,
        "valor": 42184194707.9167,
        "delta": -603685848.0833
      },
      {
        "periodo": 202510,
        "valor": 41453043248.8333,
        "delta": -731151459.0833
      },
      {
        "periodo": 202511,
        "valor": 41185942203.5,
        "delta": -267101045.3333
      },
      {
        "periodo": 202512,
        "valor": 41728964156.5833,
        "delta": 543021953.0833
      },
      {
        "periodo": 202601,
        "valor": 41847905068.8333,
        "delta": 118940912.25
      },
      {
        "periodo": 202602,
        "valor": 42640171144.3333,
        "delta": 792266075.5
      },
      {
        "periodo": 202603,
        "valor": 42437239006.5,
        "delta": -202932137.8333
      },
      {
        "periodo": 202604,
        "valor": 42942945584.0,
        "delta": 505706577.5
      },
      {
        "periodo": 202605,
        "valor": 43815850714.6667,
        "delta": 872905130.6667
      },
      {
        "periodo": 202606,
        "valor": 43429378325.3333,
        "delta": -386472389.3333
      },
      {
        "periodo": 202607,
        "valor": 43404028729.75,
        "delta": -25349595.5833
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40130 Compartamos",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 44662815192.333336,
    "valor_anterior": 44381331394.166664,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 37752694808.9167,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 38373936155.5833,
        "delta": 621241346.6667
      },
      {
        "periodo": 202509,
        "valor": 39003257608.75,
        "delta": 629321453.1667
      },
      {
        "periodo": 202510,
        "valor": 39972254832.0,
        "delta": 968997223.25
      },
      {
        "periodo": 202511,
        "valor": 40738070682.25,
        "delta": 765815850.25
      },
      {
        "periodo": 202512,
        "valor": 41423947916.3333,
        "delta": 685877234.0833
      },
      {
        "periodo": 202601,
        "valor": 42088483367.4167,
        "delta": 664535451.0833
      },
      {
        "periodo": 202602,
        "valor": 42815697951.25,
        "delta": 727214583.8333
      },
      {
        "periodo": 202603,
        "valor": 43308795345.0,
        "delta": 493097393.75
      },
      {
        "periodo": 202604,
        "valor": 43768964451.0833,
        "delta": 460169106.0833
      },
      {
        "periodo": 202605,
        "valor": 44119757509.6667,
        "delta": 350793058.5833
      },
      {
        "periodo": 202606,
        "valor": 44381331394.1667,
        "delta": 261573884.5
      },
      {
        "periodo": 202607,
        "valor": 44662815192.3333,
        "delta": 281483798.1667
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40132 Multiva",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 161524488335.41666,
    "valor_anterior": 159754178419.8333,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 130866860688.5833,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 134393228148.4167,
        "delta": 3526367459.8333
      },
      {
        "periodo": 202509,
        "valor": 138027084195.0833,
        "delta": 3633856046.6666
      },
      {
        "periodo": 202510,
        "valor": 141290967863.4167,
        "delta": 3263883668.3333
      },
      {
        "periodo": 202511,
        "valor": 143828663963.1667,
        "delta": 2537696099.75
      },
      {
        "periodo": 202512,
        "valor": 146917514719.9167,
        "delta": 3088850756.75
      },
      {
        "periodo": 202601,
        "valor": 149001271464.5,
        "delta": 2083756744.5833
      },
      {
        "periodo": 202602,
        "valor": 151664385753.3333,
        "delta": 2663114288.8333
      },
      {
        "periodo": 202603,
        "valor": 154386090736.0833,
        "delta": 2721704982.75
      },
      {
        "periodo": 202604,
        "valor": 156382313944.1667,
        "delta": 1996223208.0833
      },
      {
        "periodo": 202605,
        "valor": 158427632231.3333,
        "delta": 2045318287.1667
      },
      {
        "periodo": 202606,
        "valor": 159754178419.8333,
        "delta": 1326546188.5
      },
      {
        "periodo": 202607,
        "valor": 161524488335.4167,
        "delta": 1770309915.5833
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40133 Actinver",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 47916889669.58333,
    "valor_anterior": 48148371621.58333,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 42922042265.4167,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 44154896831.0833,
        "delta": 1232854565.6667
      },
      {
        "periodo": 202509,
        "valor": 45374887105.5833,
        "delta": 1219990274.5
      },
      {
        "periodo": 202510,
        "valor": 46003911200.9167,
        "delta": 629024095.3333
      },
      {
        "periodo": 202511,
        "valor": 46743128537.75,
        "delta": 739217336.8333
      },
      {
        "periodo": 202512,
        "valor": 47436411310.0833,
        "delta": 693282772.3333
      },
      {
        "periodo": 202601,
        "valor": 48162721575.0833,
        "delta": 726310265.0
      },
      {
        "periodo": 202602,
        "valor": 48331344476.0833,
        "delta": 168622901.0
      },
      {
        "periodo": 202603,
        "valor": 48676601286.9167,
        "delta": 345256810.8333
      },
      {
        "periodo": 202604,
        "valor": 48501085145.9167,
        "delta": -175516141.0
      },
      {
        "periodo": 202605,
        "valor": 48191537196.6667,
        "delta": -309547949.25
      },
      {
        "periodo": 202606,
        "valor": 48148371621.5833,
        "delta": -43165575.0833
      },
      {
        "periodo": 202607,
        "valor": 47916889669.5833,
        "delta": -231481952.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40136 Intercam Banco",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 1562395606.333333,
    "valor_anterior": 5110565438.583333,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 61660471887.3333,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 57933566200.0,
        "delta": -3726905687.3333
      },
      {
        "periodo": 202509,
        "valor": 52816689754.1667,
        "delta": -5116876445.8333
      },
      {
        "periodo": 202510,
        "valor": 48088078175.25,
        "delta": -4728611578.9167
      },
      {
        "periodo": 202511,
        "valor": 43115794121.6667,
        "delta": -4972284053.5833
      },
      {
        "periodo": 202512,
        "valor": 38063181213.6667,
        "delta": -5052612908.0
      },
      {
        "periodo": 202601,
        "valor": 33060809795.75,
        "delta": -5002371417.9167
      },
      {
        "periodo": 202602,
        "valor": 28044857012.4167,
        "delta": -5015952783.3333
      },
      {
        "periodo": 202603,
        "valor": 22717754874.25,
        "delta": -5327102138.1667
      },
      {
        "periodo": 202604,
        "valor": 16883299703.0833,
        "delta": -5834455171.1667
      },
      {
        "periodo": 202605,
        "valor": 10614827030.4167,
        "delta": -6268472672.6667
      },
      {
        "periodo": 202606,
        "valor": 5110565438.5833,
        "delta": -5504261591.8333
      },
      {
        "periodo": 202607,
        "valor": 1562395606.3333,
        "delta": -3548169832.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40137 Bancoppel",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 148168624914.89084,
    "valor_anterior": 148045345859.53915,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 143512692442.9042,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 144439028736.905,
        "delta": 926336294.0008
      },
      {
        "periodo": 202509,
        "valor": 145148579467.5258,
        "delta": 709550730.6208
      },
      {
        "periodo": 202510,
        "valor": 146172285693.2558,
        "delta": 1023706225.73
      },
      {
        "periodo": 202511,
        "valor": 146734336751.7058,
        "delta": 562051058.45
      },
      {
        "periodo": 202512,
        "valor": 147322227465.9083,
        "delta": 587890714.2025
      },
      {
        "periodo": 202601,
        "valor": 147586626339.4233,
        "delta": 264398873.515
      },
      {
        "periodo": 202602,
        "valor": 147724162400.0016,
        "delta": 137536060.5783
      },
      {
        "periodo": 202603,
        "valor": 148019849729.5367,
        "delta": 295687329.535
      },
      {
        "periodo": 202604,
        "valor": 148309693527.185,
        "delta": 289843797.6483
      },
      {
        "periodo": 202605,
        "valor": 148221722967.1792,
        "delta": -87970560.0058
      },
      {
        "periodo": 202606,
        "valor": 148045345859.5392,
        "delta": -176377107.64
      },
      {
        "periodo": 202607,
        "valor": 148168624914.8908,
        "delta": 123279055.3517
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40138 Ualá",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 5252208143.75,
    "valor_anterior": 5306004817.416667,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 5606077690.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 5683938242.75,
        "delta": 77860552.25
      },
      {
        "periodo": 202509,
        "valor": 5710424905.3333,
        "delta": 26486662.5833
      },
      {
        "periodo": 202510,
        "valor": 5689507099.5833,
        "delta": -20917805.75
      },
      {
        "periodo": 202511,
        "valor": 5659119411.6667,
        "delta": -30387687.9167
      },
      {
        "periodo": 202512,
        "valor": 5600680109.5,
        "delta": -58439302.1667
      },
      {
        "periodo": 202601,
        "valor": 5542967117.0,
        "delta": -57712992.5
      },
      {
        "periodo": 202602,
        "valor": 5489825970.0833,
        "delta": -53141146.9167
      },
      {
        "periodo": 202603,
        "valor": 5433185519.25,
        "delta": -56640450.8333
      },
      {
        "periodo": 202604,
        "valor": 5383046675.9167,
        "delta": -50138843.3333
      },
      {
        "periodo": 202605,
        "valor": 5345571270.25,
        "delta": -37475405.6667
      },
      {
        "periodo": 202606,
        "valor": 5306004817.4167,
        "delta": -39566452.8333
      },
      {
        "periodo": 202607,
        "valor": 5252208143.75,
        "delta": -53796673.6667
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40139 BIAfirme",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 62944237261.58333,
    "valor_anterior": 62527524969.58333,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 55896891320.8333,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 55969982523.1667,
        "delta": 73091202.3333
      },
      {
        "periodo": 202509,
        "valor": 55871955654.9167,
        "delta": -98026868.25
      },
      {
        "periodo": 202510,
        "valor": 56542256510.1667,
        "delta": 670300855.25
      },
      {
        "periodo": 202511,
        "valor": 57343316169.8333,
        "delta": 801059659.6667
      },
      {
        "periodo": 202512,
        "valor": 57916698907.0833,
        "delta": 573382737.25
      },
      {
        "periodo": 202601,
        "valor": 58650973190.5,
        "delta": 734274283.4167
      },
      {
        "periodo": 202602,
        "valor": 59629190836.4167,
        "delta": 978217645.9167
      },
      {
        "periodo": 202603,
        "valor": 60410340272.3333,
        "delta": 781149435.9167
      },
      {
        "periodo": 202604,
        "valor": 60877889568.5,
        "delta": 467549296.1667
      },
      {
        "periodo": 202605,
        "valor": 61630144164.0,
        "delta": 752254595.5
      },
      {
        "periodo": 202606,
        "valor": 62527524969.5833,
        "delta": 897380805.5833
      },
      {
        "periodo": 202607,
        "valor": 62944237261.5833,
        "delta": 416712292.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40140 Consubanco",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 23870283820.916668,
    "valor_anterior": 23685178889.416668,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 20681027454.1667,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 21039819784.0833,
        "delta": 358792329.9167
      },
      {
        "periodo": 202509,
        "valor": 21381409692.4167,
        "delta": 341589908.3333
      },
      {
        "periodo": 202510,
        "valor": 21663041228.4167,
        "delta": 281631536.0
      },
      {
        "periodo": 202511,
        "valor": 21907431917.4167,
        "delta": 244390689.0
      },
      {
        "periodo": 202512,
        "valor": 22126798308.9167,
        "delta": 219366391.5
      },
      {
        "periodo": 202601,
        "valor": 22372234244.75,
        "delta": 245435935.8333
      },
      {
        "periodo": 202602,
        "valor": 22563529576.1667,
        "delta": 191295331.4167
      },
      {
        "periodo": 202603,
        "valor": 22750468240.75,
        "delta": 186938664.5833
      },
      {
        "periodo": 202604,
        "valor": 23128014097.5833,
        "delta": 377545856.8333
      },
      {
        "periodo": 202605,
        "valor": 23526917061.3333,
        "delta": 398902963.75
      },
      {
        "periodo": 202606,
        "valor": 23685178889.4167,
        "delta": 158261828.0833
      },
      {
        "periodo": 202607,
        "valor": 23870283820.9167,
        "delta": 185104931.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40141 Volkswagen Bank",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 4678978913.333333,
    "valor_anterior": 4592545665.583333,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3130852911.75,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3264512306.5,
        "delta": 133659394.75
      },
      {
        "periodo": 202509,
        "valor": 3498645033.0,
        "delta": 234132726.5
      },
      {
        "periodo": 202510,
        "valor": 3708612608.1667,
        "delta": 209967575.1667
      },
      {
        "periodo": 202511,
        "valor": 3902734422.3333,
        "delta": 194121814.1667
      },
      {
        "periodo": 202512,
        "valor": 3983974011.0,
        "delta": 81239588.6667
      },
      {
        "periodo": 202601,
        "valor": 4065345750.0,
        "delta": 81371739.0
      },
      {
        "periodo": 202602,
        "valor": 4151898781.0,
        "delta": 86553031.0
      },
      {
        "periodo": 202603,
        "valor": 4268283072.1667,
        "delta": 116384291.1667
      },
      {
        "periodo": 202604,
        "valor": 4385341944.3333,
        "delta": 117058872.1667
      },
      {
        "periodo": 202605,
        "valor": 4503133780.0,
        "delta": 117791835.6667
      },
      {
        "periodo": 202606,
        "valor": 4592545665.5833,
        "delta": 89411885.5833
      },
      {
        "periodo": 202607,
        "valor": 4678978913.3333,
        "delta": 86433247.75
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40143 CIBanco",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 101048592524.0833,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 98444432738.5,
        "delta": -2604159785.5833
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40145 Banco Base",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 168107457402.66666,
    "valor_anterior": 163338183180.6667,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 120502076847.8333,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 123805731665.5833,
        "delta": 3303654817.75
      },
      {
        "periodo": 202509,
        "valor": 127887947612.3333,
        "delta": 4082215946.75
      },
      {
        "periodo": 202510,
        "valor": 131700156134.9167,
        "delta": 3812208522.5833
      },
      {
        "periodo": 202511,
        "valor": 135229252026.9167,
        "delta": 3529095892.0
      },
      {
        "periodo": 202512,
        "valor": 140311242085.0833,
        "delta": 5081990058.1667
      },
      {
        "periodo": 202601,
        "valor": 145493196506.9167,
        "delta": 5181954421.8333
      },
      {
        "periodo": 202602,
        "valor": 150231773785.3333,
        "delta": 4738577278.4167
      },
      {
        "periodo": 202603,
        "valor": 153773906717.0,
        "delta": 3542132931.6667
      },
      {
        "periodo": 202604,
        "valor": 156676504048.3333,
        "delta": 2902597331.3333
      },
      {
        "periodo": 202605,
        "valor": 159964667124.9167,
        "delta": 3288163076.5833
      },
      {
        "periodo": 202606,
        "valor": 163338183180.6667,
        "delta": 3373516055.75
      },
      {
        "periodo": 202607,
        "valor": 168107457402.6667,
        "delta": 4769274222.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40147 Bankaool",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 23324314270.749996,
    "valor_anterior": 22194572409.91667,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13608103827.3333,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 14161299604.1667,
        "delta": 553195776.8333
      },
      {
        "periodo": 202509,
        "valor": 14774802100.0833,
        "delta": 613502495.9167
      },
      {
        "periodo": 202510,
        "valor": 15315049762.9167,
        "delta": 540247662.8333
      },
      {
        "periodo": 202511,
        "valor": 15940555410.0,
        "delta": 625505647.0833
      },
      {
        "periodo": 202512,
        "valor": 16905455970.3333,
        "delta": 964900560.3333
      },
      {
        "periodo": 202601,
        "valor": 17470339192.8333,
        "delta": 564883222.5
      },
      {
        "periodo": 202602,
        "valor": 18287426420.0833,
        "delta": 817087227.25
      },
      {
        "periodo": 202603,
        "valor": 19246386000.4167,
        "delta": 958959580.3333
      },
      {
        "periodo": 202604,
        "valor": 20129664635.4167,
        "delta": 883278635.0
      },
      {
        "periodo": 202605,
        "valor": 21162343646.0,
        "delta": 1032679010.5833
      },
      {
        "periodo": 202606,
        "valor": 22194572409.9167,
        "delta": 1032228763.9167
      },
      {
        "periodo": 202607,
        "valor": 23324314270.75,
        "delta": 1129741860.8333
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40148 Pagatodo",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 471569537.91666704,
    "valor_anterior": 394505163.41666704,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 29417450.9167,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 96866755.1667,
        "delta": 67449304.25
      },
      {
        "periodo": 202509,
        "valor": 135618854.1667,
        "delta": 38752099.0
      },
      {
        "periodo": 202510,
        "valor": 173486381.0833,
        "delta": 37867526.9167
      },
      {
        "periodo": 202511,
        "valor": 218977927.3333,
        "delta": 45491546.25
      },
      {
        "periodo": 202512,
        "valor": 226217489.5833,
        "delta": 7239562.25
      },
      {
        "periodo": 202601,
        "valor": 245529919.5,
        "delta": 19312429.9167
      },
      {
        "periodo": 202602,
        "valor": 265791005.9167,
        "delta": 20261086.4167
      },
      {
        "periodo": 202603,
        "valor": 269120492.0833,
        "delta": 3329486.1667
      },
      {
        "periodo": 202604,
        "valor": 270683489.3333,
        "delta": 1562997.25
      },
      {
        "periodo": 202605,
        "valor": 317119277.25,
        "delta": 46435787.9167
      },
      {
        "periodo": 202606,
        "valor": 394505163.4167,
        "delta": 77385886.1667
      },
      {
        "periodo": 202607,
        "valor": 471569537.9167,
        "delta": 77064374.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40149 Banfeliz",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 329190967.666667,
    "valor_anterior": 313304804.333333,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 212674007.3333,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 217753752.3333,
        "delta": 5079745.0
      },
      {
        "periodo": 202509,
        "valor": 223419426.9167,
        "delta": 5665674.5833
      },
      {
        "periodo": 202510,
        "valor": 229573125.9167,
        "delta": 6153699.0
      },
      {
        "periodo": 202511,
        "valor": 236004500.25,
        "delta": 6431374.3333
      },
      {
        "periodo": 202512,
        "valor": 244432556.6667,
        "delta": 8428056.4167
      },
      {
        "periodo": 202601,
        "valor": 254245593.5833,
        "delta": 9813036.9167
      },
      {
        "periodo": 202602,
        "valor": 264858479.9167,
        "delta": 10612886.3333
      },
      {
        "periodo": 202603,
        "valor": 275995747.6667,
        "delta": 11137267.75
      },
      {
        "periodo": 202604,
        "valor": 287175425.5833,
        "delta": 11179677.9167
      },
      {
        "periodo": 202605,
        "valor": 299618970.25,
        "delta": 12443544.6667
      },
      {
        "periodo": 202606,
        "valor": 313304804.3333,
        "delta": 13685834.0833
      },
      {
        "periodo": 202607,
        "valor": 329190967.6667,
        "delta": 15886163.3333
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40150 Inmobiliario Mexicano",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 14390524554.6175,
    "valor_anterior": 14310392367.909166,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 13352607293.1583,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 13488701878.4892,
        "delta": 136094585.3308
      },
      {
        "periodo": 202509,
        "valor": 13592567319.4525,
        "delta": 103865440.9633
      },
      {
        "periodo": 202510,
        "valor": 13705569617.3367,
        "delta": 113002297.8842
      },
      {
        "periodo": 202511,
        "valor": 13840432297.2817,
        "delta": 134862679.945
      },
      {
        "periodo": 202512,
        "valor": 13929627156.4033,
        "delta": 89194859.1217
      },
      {
        "periodo": 202601,
        "valor": 13991430066.6683,
        "delta": 61802910.265
      },
      {
        "periodo": 202602,
        "valor": 14014815745.355,
        "delta": 23385678.6867
      },
      {
        "periodo": 202603,
        "valor": 14099547582.4358,
        "delta": 84731837.0808
      },
      {
        "periodo": 202604,
        "valor": 14176436690.09,
        "delta": 76889107.6542
      },
      {
        "periodo": 202605,
        "valor": 14233927887.985,
        "delta": 57491197.895
      },
      {
        "periodo": 202606,
        "valor": 14310392367.9092,
        "delta": 76464479.9242
      },
      {
        "periodo": 202607,
        "valor": 14390524554.6175,
        "delta": 80132186.7083
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40151 Dondé Banco",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 2812606107.333333,
    "valor_anterior": 2649051612.833333,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1501507258.8333,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1579729238.5833,
        "delta": 78221979.75
      },
      {
        "periodo": 202509,
        "valor": 1658672922.0833,
        "delta": 78943683.5
      },
      {
        "periodo": 202510,
        "valor": 1797304458.5,
        "delta": 138631536.4167
      },
      {
        "periodo": 202511,
        "valor": 1976410017.75,
        "delta": 179105559.25
      },
      {
        "periodo": 202512,
        "valor": 2093057050.3333,
        "delta": 116647032.5833
      },
      {
        "periodo": 202601,
        "valor": 2148229182.1667,
        "delta": 55172131.8333
      },
      {
        "periodo": 202602,
        "valor": 2217282713.25,
        "delta": 69053531.0833
      },
      {
        "periodo": 202603,
        "valor": 2328810373.0,
        "delta": 111527659.75
      },
      {
        "periodo": 202604,
        "valor": 2471267826.5,
        "delta": 142457453.5
      },
      {
        "periodo": 202605,
        "valor": 2567001127.9167,
        "delta": 95733301.4167
      },
      {
        "periodo": 202606,
        "valor": 2649051612.8333,
        "delta": 82050484.9167
      },
      {
        "periodo": 202607,
        "valor": 2812606107.3333,
        "delta": 163554494.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40152 Bancrea",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 52938856797.98167,
    "valor_anterior": 52274288944.52334,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 44025477845.5008,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 44677822333.5892,
        "delta": 652344488.0883
      },
      {
        "periodo": 202509,
        "valor": 45258694411.2475,
        "delta": 580872077.6583
      },
      {
        "periodo": 202510,
        "valor": 45925412802.4125,
        "delta": 666718391.165
      },
      {
        "periodo": 202511,
        "valor": 46753206715.6358,
        "delta": 827793913.2233
      },
      {
        "periodo": 202512,
        "valor": 47548717859.095,
        "delta": 795511143.4592
      },
      {
        "periodo": 202601,
        "valor": 48371084087.3692,
        "delta": 822366228.2742
      },
      {
        "periodo": 202602,
        "valor": 49174295947.2317,
        "delta": 803211859.8625
      },
      {
        "periodo": 202603,
        "valor": 50113056999.2625,
        "delta": 938761052.0308
      },
      {
        "periodo": 202604,
        "valor": 50893648065.4442,
        "delta": 780591066.1817
      },
      {
        "periodo": 202605,
        "valor": 51628006560.1792,
        "delta": 734358494.735
      },
      {
        "periodo": 202606,
        "valor": 52274288944.5233,
        "delta": 646282384.3442
      },
      {
        "periodo": 202607,
        "valor": 52938856797.9817,
        "delta": 664567853.4583
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40154 Covalto",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 8618038634.355,
    "valor_anterior": 8563497923.6525,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 6972062922.6183,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7294070800.3867,
        "delta": 322007877.7683
      },
      {
        "periodo": 202509,
        "valor": 7578243940.8475,
        "delta": 284173140.4608
      },
      {
        "periodo": 202510,
        "valor": 7843670998.1533,
        "delta": 265427057.3058
      },
      {
        "periodo": 202511,
        "valor": 8112840132.9458,
        "delta": 269169134.7925
      },
      {
        "periodo": 202512,
        "valor": 8225501309.4725,
        "delta": 112661176.5267
      },
      {
        "periodo": 202601,
        "valor": 8291241973.9983,
        "delta": 65740664.5258
      },
      {
        "periodo": 202602,
        "valor": 8326191339.6075,
        "delta": 34949365.6092
      },
      {
        "periodo": 202603,
        "valor": 8380312106.6617,
        "delta": 54120767.0542
      },
      {
        "periodo": 202604,
        "valor": 8430404030.5258,
        "delta": 50091923.8642
      },
      {
        "periodo": 202605,
        "valor": 8491303922.3708,
        "delta": 60899891.845
      },
      {
        "periodo": 202606,
        "valor": 8563497923.6525,
        "delta": 72194001.2817
      },
      {
        "periodo": 202607,
        "valor": 8618038634.355,
        "delta": 54540710.7025
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40155 ICBC",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 10649429782.25,
    "valor_anterior": 10538454544.083334,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 9399772916.0,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 9666914854.25,
        "delta": 267141938.25
      },
      {
        "periodo": 202509,
        "valor": 9958349615.0,
        "delta": 291434760.75
      },
      {
        "periodo": 202510,
        "valor": 10206605796.4167,
        "delta": 248256181.4167
      },
      {
        "periodo": 202511,
        "valor": 10198709665.6667,
        "delta": -7896130.75
      },
      {
        "periodo": 202512,
        "valor": 10058531999.1667,
        "delta": -140177666.5
      },
      {
        "periodo": 202601,
        "valor": 10047856579.5,
        "delta": -10675419.6667
      },
      {
        "periodo": 202602,
        "valor": 10071446664.6667,
        "delta": 23590085.1667
      },
      {
        "periodo": 202603,
        "valor": 10324757157.4167,
        "delta": 253310492.75
      },
      {
        "periodo": 202604,
        "valor": 10572988876.75,
        "delta": 248231719.3333
      },
      {
        "periodo": 202605,
        "valor": 10470008869.75,
        "delta": -102980007.0
      },
      {
        "periodo": 202606,
        "valor": 10538454544.0833,
        "delta": 68445674.3333
      },
      {
        "periodo": 202607,
        "valor": 10649429782.25,
        "delta": 110975238.1667
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40156 Sabadell",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 129033824904.5,
    "valor_anterior": 128475350827.41666,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 122802243232.5833,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 123103861936.75,
        "delta": 301618704.1667
      },
      {
        "periodo": 202509,
        "valor": 123528457958.5833,
        "delta": 424596021.8333
      },
      {
        "periodo": 202510,
        "valor": 123887144774.5,
        "delta": 358686815.9167
      },
      {
        "periodo": 202511,
        "valor": 124039577565.75,
        "delta": 152432791.25
      },
      {
        "periodo": 202512,
        "valor": 124864732640.0833,
        "delta": 825155074.3333
      },
      {
        "periodo": 202601,
        "valor": 125923722768.3333,
        "delta": 1058990128.25
      },
      {
        "periodo": 202602,
        "valor": 126742649224.75,
        "delta": 818926456.4167
      },
      {
        "periodo": 202603,
        "valor": 127267776965.8333,
        "delta": 525127741.0833
      },
      {
        "periodo": 202604,
        "valor": 127710411726.0,
        "delta": 442634760.1667
      },
      {
        "periodo": 202605,
        "valor": 128088536996.5833,
        "delta": 378125270.5833
      },
      {
        "periodo": 202606,
        "valor": 128475350827.4167,
        "delta": 386813830.8333
      },
      {
        "periodo": 202607,
        "valor": 129033824904.5,
        "delta": 558474077.0833
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40157 Shinhan",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 5019149440.333334,
    "valor_anterior": 5022113154.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 4529910597.8333,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 4638413330.5833,
        "delta": 108502732.75
      },
      {
        "periodo": 202509,
        "valor": 4705103497.5,
        "delta": 66690166.9167
      },
      {
        "periodo": 202510,
        "valor": 4780794358.9167,
        "delta": 75690861.4167
      },
      {
        "periodo": 202511,
        "valor": 4829914414.25,
        "delta": 49120055.3333
      },
      {
        "periodo": 202512,
        "valor": 4829453729.5833,
        "delta": -460684.6667
      },
      {
        "periodo": 202601,
        "valor": 4910748710.8333,
        "delta": 81294981.25
      },
      {
        "periodo": 202602,
        "valor": 4948856590.6667,
        "delta": 38107879.8333
      },
      {
        "periodo": 202603,
        "valor": 4997158068.25,
        "delta": 48301477.5833
      },
      {
        "periodo": 202604,
        "valor": 4993598112.5833,
        "delta": -3559955.6667
      },
      {
        "periodo": 202605,
        "valor": 5002337815.4167,
        "delta": 8739702.8333
      },
      {
        "periodo": 202606,
        "valor": 5022113154.25,
        "delta": 19775338.8333
      },
      {
        "periodo": 202607,
        "valor": 5019149440.3333,
        "delta": -2963713.9167
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40158 Mizuho Bank",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 8956106233.076668,
    "valor_anterior": 9145839095.179167,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7242392054.2342,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7457144245.2217,
        "delta": 214752190.9875
      },
      {
        "periodo": 202509,
        "valor": 7677891087.2892,
        "delta": 220746842.0675
      },
      {
        "periodo": 202510,
        "valor": 8002819763.17,
        "delta": 324928675.8808
      },
      {
        "periodo": 202511,
        "valor": 8188777515.7658,
        "delta": 185957752.5958
      },
      {
        "periodo": 202512,
        "valor": 8281825703.1,
        "delta": 93048187.3342
      },
      {
        "periodo": 202601,
        "valor": 8446842029.1808,
        "delta": 165016326.0808
      },
      {
        "periodo": 202602,
        "valor": 8616150898.3892,
        "delta": 169308869.2083
      },
      {
        "periodo": 202603,
        "valor": 8880329450.2875,
        "delta": 264178551.8983
      },
      {
        "periodo": 202604,
        "valor": 9046824681.575,
        "delta": 166495231.2875
      },
      {
        "periodo": 202605,
        "valor": 9200745514.5933,
        "delta": 153920833.0183
      },
      {
        "periodo": 202606,
        "valor": 9145839095.1792,
        "delta": -54906419.4142
      },
      {
        "periodo": 202607,
        "valor": 8956106233.0767,
        "delta": -189732862.1025
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40159 Bank of China",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 5180868474.131667,
    "valor_anterior": 5181355294.868333,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 7898278052.3008,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 7420715161.4192,
        "delta": -477562890.8817
      },
      {
        "periodo": 202509,
        "valor": 6910991189.8375,
        "delta": -509723971.5817
      },
      {
        "periodo": 202510,
        "valor": 6608351341.0708,
        "delta": -302639848.7667
      },
      {
        "periodo": 202511,
        "valor": 6182626995.6342,
        "delta": -425724345.4367
      },
      {
        "periodo": 202512,
        "valor": 5611822562.5975,
        "delta": -570804433.0367
      },
      {
        "periodo": 202601,
        "valor": 5460281649.2325,
        "delta": -151540913.365
      },
      {
        "periodo": 202602,
        "valor": 5295055537.1067,
        "delta": -165226112.1258
      },
      {
        "periodo": 202603,
        "valor": 5112527022.0358,
        "delta": -182528515.0708
      },
      {
        "periodo": 202604,
        "valor": 5041378937.28,
        "delta": -71148084.7558
      },
      {
        "periodo": 202605,
        "valor": 5128086769.3608,
        "delta": 86707832.0808
      },
      {
        "periodo": 202606,
        "valor": 5181355294.8683,
        "delta": 53268525.5075
      },
      {
        "periodo": 202607,
        "valor": 5180868474.1317,
        "delta": -486820.7367
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40160 Banco S3",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 3080042013.416667,
    "valor_anterior": 3197927181.0,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 2457605521.9167,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 2521071884.6667,
        "delta": 63466362.75
      },
      {
        "periodo": 202509,
        "valor": 2661084960.5,
        "delta": 140013075.8333
      },
      {
        "periodo": 202510,
        "valor": 2495195041.3333,
        "delta": -165889919.1667
      },
      {
        "periodo": 202511,
        "valor": 2499221054.4167,
        "delta": 4026013.0833
      },
      {
        "periodo": 202512,
        "valor": 2447123159.4167,
        "delta": -52097895.0
      },
      {
        "periodo": 202601,
        "valor": 2720472559.25,
        "delta": 273349399.8333
      },
      {
        "periodo": 202602,
        "valor": 2721343866.6667,
        "delta": 871307.4167
      },
      {
        "periodo": 202603,
        "valor": 3042461697.6667,
        "delta": 321117831.0
      },
      {
        "periodo": 202604,
        "valor": 3145676489.3333,
        "delta": 103214791.6667
      },
      {
        "periodo": 202605,
        "valor": 3257888771.25,
        "delta": 112212281.9167
      },
      {
        "periodo": 202606,
        "valor": 3197927181.0,
        "delta": -59961590.25
      },
      {
        "periodo": 202607,
        "valor": 3080042013.4167,
        "delta": -117885167.5833
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40162 KEB Hana México",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 3808340237.083333,
    "valor_anterior": 3814275371.583333,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 3947731916.6667,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 3947541081.0833,
        "delta": -190835.5833
      },
      {
        "periodo": 202509,
        "valor": 3943099028.0,
        "delta": -4442053.0833
      },
      {
        "periodo": 202510,
        "valor": 3940411792.5,
        "delta": -2687235.5
      },
      {
        "periodo": 202511,
        "valor": 3947169835.3333,
        "delta": 6758042.8333
      },
      {
        "periodo": 202512,
        "valor": 3923596314.5,
        "delta": -23573520.8333
      },
      {
        "periodo": 202601,
        "valor": 3881451587.0833,
        "delta": -42144727.4167
      },
      {
        "periodo": 202602,
        "valor": 3847670543.0,
        "delta": -33781044.0833
      },
      {
        "periodo": 202603,
        "valor": 3840331392.5,
        "delta": -7339150.5
      },
      {
        "periodo": 202604,
        "valor": 3847934647.8333,
        "delta": 7603255.3333
      },
      {
        "periodo": 202605,
        "valor": 3813663005.25,
        "delta": -34271642.5833
      },
      {
        "periodo": 202606,
        "valor": 3814275371.5833,
        "delta": 612366.3333
      },
      {
        "periodo": 202607,
        "valor": 3808340237.0833,
        "delta": -5935134.5
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40164 BNP Paribas México",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 8694205843.166668,
    "valor_anterior": 8588059598.916667,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8455756513.5,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8513051465.6667,
        "delta": 57294952.1667
      },
      {
        "periodo": 202509,
        "valor": 8565520052.5833,
        "delta": 52468586.9167
      },
      {
        "periodo": 202510,
        "valor": 8928957457.9167,
        "delta": 363437405.3333
      },
      {
        "periodo": 202511,
        "valor": 8753980083.0833,
        "delta": -174977374.8333
      },
      {
        "periodo": 202512,
        "valor": 8755120839.9167,
        "delta": 1140756.8333
      },
      {
        "periodo": 202601,
        "valor": 9019824579.1667,
        "delta": 264703739.25
      },
      {
        "periodo": 202602,
        "valor": 8831690275.1667,
        "delta": -188134304.0
      },
      {
        "periodo": 202603,
        "valor": 8751179491.4167,
        "delta": -80510783.75
      },
      {
        "periodo": 202604,
        "valor": 8460626104.5833,
        "delta": -290553386.8333
      },
      {
        "periodo": 202605,
        "valor": 8276063477.8333,
        "delta": -184562626.75
      },
      {
        "periodo": 202606,
        "valor": 8588059598.9167,
        "delta": 311996121.0833
      },
      {
        "periodo": 202607,
        "valor": 8694205843.1667,
        "delta": 106146244.25
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40165 Banco Bineo",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 23271136.66,
    "valor_anterior": 24159250.640833,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 35746337.1658,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 35745260.1492,
        "delta": -1077.0167
      },
      {
        "periodo": 202509,
        "valor": 35082369.5617,
        "delta": -662890.5875
      },
      {
        "periodo": 202510,
        "valor": 34648570.405,
        "delta": -433799.1567
      },
      {
        "periodo": 202511,
        "valor": 33682932.0842,
        "delta": -965638.3208
      },
      {
        "periodo": 202512,
        "valor": 32276336.05,
        "delta": -1406596.0342
      },
      {
        "periodo": 202601,
        "valor": 30934734.4383,
        "delta": -1341601.6117
      },
      {
        "periodo": 202602,
        "valor": 29169854.445,
        "delta": -1764879.9933
      },
      {
        "periodo": 202603,
        "valor": 27896908.4967,
        "delta": -1272945.9483
      },
      {
        "periodo": 202604,
        "valor": 26651758.305,
        "delta": -1245150.1917
      },
      {
        "periodo": 202605,
        "valor": 25387088.6125,
        "delta": -1264669.6925
      },
      {
        "periodo": 202606,
        "valor": 24159250.6408,
        "delta": -1227837.9717
      },
      {
        "periodo": 202607,
        "valor": 23271136.66,
        "delta": -888113.9808
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40167 Hey Banco",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 6438455593.3475,
    "valor_anterior": 5377321212.8125,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": 20100.0,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": 1085955501.8658,
        "delta": 1085935401.8658
      },
      {
        "periodo": 202603,
        "valor": 2174431086.9142,
        "delta": 1088475585.0483
      },
      {
        "periodo": 202604,
        "valor": 3250382814.8025,
        "delta": 1075951727.8883
      },
      {
        "periodo": 202605,
        "valor": 4318352139.0875,
        "delta": 1067969324.285
      },
      {
        "periodo": 202606,
        "valor": 5377321212.8125,
        "delta": 1058969073.725
      },
      {
        "periodo": 202607,
        "valor": 6438455593.3475,
        "delta": 1061134380.535
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40169 Openbank",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 16157313399.25,
    "valor_anterior": 14610599724.25,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": 2488055091.3333,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": 3567288501.5833,
        "delta": 1079233410.25
      },
      {
        "periodo": 202512,
        "valor": 4931125998.1667,
        "delta": 1363837496.5833
      },
      {
        "periodo": 202601,
        "valor": 6466501367.1667,
        "delta": 1535375369.0
      },
      {
        "periodo": 202602,
        "valor": 8136407095.4167,
        "delta": 1669905728.25
      },
      {
        "periodo": 202603,
        "valor": 9751338920.0833,
        "delta": 1614931824.6667
      },
      {
        "periodo": 202604,
        "valor": 11363276310.0833,
        "delta": 1611937390.0
      },
      {
        "periodo": 202605,
        "valor": 12985783518.9167,
        "delta": 1622507208.8333
      },
      {
        "periodo": 202606,
        "valor": 14610599724.25,
        "delta": 1624816205.3333
      },
      {
        "periodo": 202607,
        "valor": 16157313399.25,
        "delta": 1546713675.0
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40170 Revolut Bank",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "40171 Banco Plata",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": null,
    "valor_anterior": null,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202509,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202510,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202511,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202512,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202601,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202602,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202603,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202604,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202605,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202606,
        "valor": null,
        "delta": null
      },
      {
        "periodo": 202607,
        "valor": null,
        "delta": null
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "5 Total Banca Múltiple",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 12307965873241.672,
    "valor_anterior": 12246961271798.254,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 11743184592057.824,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 11805911209158.744,
        "delta": 62726617100.9199
      },
      {
        "periodo": 202509,
        "valor": 11872393129405.78,
        "delta": 66481920247.0352
      },
      {
        "periodo": 202510,
        "valor": 11923627973727.297,
        "delta": 51234844321.5176
      },
      {
        "periodo": 202511,
        "valor": 11960825608280.633,
        "delta": 37197634553.3359
      },
      {
        "periodo": 202512,
        "valor": 11995031315163.54,
        "delta": 34205706882.9062
      },
      {
        "periodo": 202601,
        "valor": 12040464935829.672,
        "delta": 45433620666.1328
      },
      {
        "periodo": 202602,
        "valor": 12094023864058.46,
        "delta": 53558928228.7891
      },
      {
        "periodo": 202603,
        "valor": 12131009956185.014,
        "delta": 36986092126.5527
      },
      {
        "periodo": 202604,
        "valor": 12162860925673.13,
        "delta": 31850969488.1172
      },
      {
        "periodo": 202605,
        "valor": 12200355485835.639,
        "delta": 37494560162.5078
      },
      {
        "periodo": 202606,
        "valor": 12246961271798.254,
        "delta": 46605785962.6152
      },
      {
        "periodo": 202607,
        "valor": 12307965873241.672,
        "delta": 61004601443.418
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "59 G-7",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 8712286646006.065,
    "valor_anterior": 8662997438838.671,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 8464261554030.972,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 8459640845078.521,
        "delta": -4620708952.4502
      },
      {
        "periodo": 202509,
        "valor": 8464072778236.642,
        "delta": 4431933158.1201
      },
      {
        "periodo": 202510,
        "valor": 8459296434353.487,
        "delta": -4776343883.1543
      },
      {
        "periodo": 202511,
        "valor": 8442882949704.312,
        "delta": -16413484649.1758
      },
      {
        "periodo": 202512,
        "valor": 8469327661143.726,
        "delta": 26444711439.4141
      },
      {
        "periodo": 202601,
        "valor": 8503172497410.1,
        "delta": 33844836266.374
      },
      {
        "periodo": 202602,
        "valor": 8542739972818.191,
        "delta": 39567475408.0918
      },
      {
        "periodo": 202603,
        "valor": 8566202217818.894,
        "delta": 23462245000.7021
      },
      {
        "periodo": 202604,
        "valor": 8592951420616.952,
        "delta": 26749202798.0586
      },
      {
        "periodo": 202605,
        "valor": 8627589203892.813,
        "delta": 34637783275.8613
      },
      {
        "periodo": 202606,
        "valor": 8662997438838.671,
        "delta": 35408234945.8574
      },
      {
        "periodo": 202607,
        "valor": 8712286646006.065,
        "delta": 49289207167.3945
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "60 Bancos Cambiarios",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 378397177177.62164,
    "valor_anterior": 384640463912.49084,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 508979892806.6742,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 507822934625.0817,
        "delta": -1156958181.5925
      },
      {
        "periodo": 202509,
        "valor": 500325212155.8292,
        "delta": -7497722469.2524
      },
      {
        "periodo": 202510,
        "valor": 489777957343.215,
        "delta": -10547254812.6143
      },
      {
        "periodo": 202511,
        "valor": 476310544897.8425,
        "delta": -13467412445.3725
      },
      {
        "periodo": 202512,
        "valor": 465957694527.3925,
        "delta": -10352850370.45
      },
      {
        "periodo": 202601,
        "valor": 454675219392.2825,
        "delta": -11282475135.11
      },
      {
        "periodo": 202602,
        "valor": 442801991298.0975,
        "delta": -11873228094.185
      },
      {
        "periodo": 202603,
        "valor": 427718004814.3192,
        "delta": -15083986483.7783
      },
      {
        "periodo": 202604,
        "valor": 412847101184.5758,
        "delta": -14870903629.7434
      },
      {
        "periodo": 202605,
        "valor": 396797412200.9542,
        "delta": -16049688983.6216
      },
      {
        "periodo": 202606,
        "valor": 384640463912.4908,
        "delta": -12156948288.4633
      },
      {
        "periodo": 202607,
        "valor": 378397177177.6216,
        "delta": -6243286734.8692
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "61 Inversión y Servicios Financieros",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 1251808058948.1416,
    "valor_anterior": 1254116542063.0625,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 1075188515850.5632,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 1119960970821.0767,
        "delta": 44772454970.5134
      },
      {
        "periodo": 202509,
        "valor": 1165016651082.8267,
        "delta": 45055680261.75
      },
      {
        "periodo": 202510,
        "valor": 1208504840924.2168,
        "delta": 43488189841.3901
      },
      {
        "periodo": 202511,
        "valor": 1252830022328.0615,
        "delta": 44325181403.8447
      },
      {
        "periodo": 202512,
        "valor": 1247428214828.6292,
        "delta": -5401807499.4324
      },
      {
        "periodo": 202601,
        "valor": 1247613535694.76,
        "delta": 185320866.1309
      },
      {
        "periodo": 202602,
        "valor": 1251692487231.3274,
        "delta": 4078951536.5674
      },
      {
        "periodo": 202603,
        "valor": 1255645484612.596,
        "delta": 3952997381.2686
      },
      {
        "periodo": 202604,
        "valor": 1253057513260.7551,
        "delta": -2587971351.8408
      },
      {
        "periodo": 202605,
        "valor": 1251732477567.0183,
        "delta": -1325035693.7368
      },
      {
        "periodo": 202606,
        "valor": 1254116542063.0625,
        "delta": 2384064496.0442
      },
      {
        "periodo": 202607,
        "valor": 1251808058948.1416,
        "delta": -2308483114.9209
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "62 Comercial Mediano",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 1126277197159.99,
    "valor_anterior": 1115484363074.2124,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 985946797185.2742,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 998579537908.6799,
        "delta": 12632740723.4058
      },
      {
        "periodo": 202509,
        "valor": 1011123070235.71,
        "delta": 12543532327.03
      },
      {
        "periodo": 202510,
        "valor": 1022273315554.2058,
        "delta": 11150245318.4958
      },
      {
        "periodo": 202511,
        "valor": 1032530032116.1091,
        "delta": 10256716561.9033
      },
      {
        "periodo": 202512,
        "valor": 1044920460449.7675,
        "delta": 12390428333.6583
      },
      {
        "periodo": 202601,
        "valor": 1057047107815.5608,
        "delta": 12126647365.7933
      },
      {
        "periodo": 202602,
        "valor": 1068992741286.0283,
        "delta": 11945633470.4675
      },
      {
        "periodo": 202603,
        "valor": 1081567473773.4476,
        "delta": 12574732487.4193
      },
      {
        "periodo": 202604,
        "valor": 1093566976750.52,
        "delta": 11999502977.0724
      },
      {
        "periodo": 202605,
        "valor": 1105127717530.8235,
        "delta": 11560740780.3035
      },
      {
        "periodo": 202606,
        "valor": 1115484363074.2124,
        "delta": 10356645543.3889
      },
      {
        "periodo": 202607,
        "valor": 1126277197159.99,
        "delta": 10792834085.7776
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "63 Comercial Pequeño",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 299483372718.4692,
    "valor_anterior": 294164352045.8467,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 233253418007.4633,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 238815826172.7258,
        "delta": 5562408165.2625
      },
      {
        "periodo": 202509,
        "valor": 245393341957.5692,
        "delta": 6577515784.8433
      },
      {
        "periodo": 202510,
        "valor": 251619107847.8409,
        "delta": 6225765890.2717
      },
      {
        "periodo": 202511,
        "valor": 257676989252.9183,
        "delta": 6057881405.0775
      },
      {
        "periodo": 202512,
        "valor": 263696701511.4359,
        "delta": 6019712258.5175
      },
      {
        "periodo": 202601,
        "valor": 269197126595.8892,
        "delta": 5500425084.4533
      },
      {
        "periodo": 202602,
        "valor": 273764071039.495,
        "delta": 4566944443.6058
      },
      {
        "periodo": 202603,
        "valor": 279965691960.6917,
        "delta": 6201620921.1967
      },
      {
        "periodo": 202604,
        "valor": 284305454449.3583,
        "delta": 4339762488.6667
      },
      {
        "periodo": 202605,
        "valor": 288127644430.905,
        "delta": 3822189981.5467
      },
      {
        "periodo": 202606,
        "valor": 294164352045.8467,
        "delta": 6036707614.9417
      },
      {
        "periodo": 202607,
        "valor": 299483372718.4692,
        "delta": 5319020672.6225
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  },
  {
    "nombre_entidad": "64 Créditos a los Hogares",
    "idconcepto": 40200216,
    "label": "Pasivos Financieros (Promedio 12m)",
    "valor_actual": 539713421231.38336,
    "valor_anterior": 535558111863.97003,
    "tipo": "monto",
    "es_pp": false,
    "invert_delta": false,
    "historico": [
      {
        "periodo": 202507,
        "valor": 475554414176.8784,
        "delta": null
      },
      {
        "periodo": 202508,
        "valor": 481091094552.6583,
        "delta": 5536680375.78
      },
      {
        "periodo": 202509,
        "valor": 486462075737.2025,
        "delta": 5370981184.5442
      },
      {
        "periodo": 202510,
        "valor": 492156317704.3309,
        "delta": 5694241967.1284
      },
      {
        "periodo": 202511,
        "valor": 498595069981.3909,
        "delta": 6438752277.06
      },
      {
        "periodo": 202512,
        "valor": 503700582702.5883,
        "delta": 5105512721.1974
      },
      {
        "periodo": 202601,
        "valor": 508759448921.0809,
        "delta": 5058866218.4926
      },
      {
        "periodo": 202602,
        "valor": 514032600385.3208,
        "delta": 5273151464.2399
      },
      {
        "periodo": 202603,
        "valor": 519911083205.0641,
        "delta": 5878482819.7433
      },
      {
        "periodo": 202604,
        "valor": 526132459410.97,
        "delta": 6221376205.9058
      },
      {
        "periodo": 202605,
        "valor": 530981030213.125,
        "delta": 4848570802.155
      },
      {
        "periodo": 202606,
        "valor": 535558111863.97,
        "delta": 4577081650.845
      },
      {
        "periodo": 202607,
        "valor": 539713421231.3834,
        "delta": 4155309367.4133
      }
    ],
    "reportes": {
      "ejecutivo": true,
      "comparativo": true,
      "tematico_riesgo": false,
      "tematico_solvencia": true,
      "reservas_calificacion": false
    }
  }
],
};

// Listas de entidades extraídas automáticamente del pipeline
export const ENTIDADES_BANNER1 = ["40002 Banamex", "40012 BBVA México", "40014 Santander", "40021 HSBC", "40030 Banco del Bajío", "40036 Inbursa", "40042 Banca Mifel", "40044 Scotiabank", "40058 Banregio", "40059 Invex", "40060 Bansí", "40062 Afirme", "40072 Banorte", "40106 Bank of America", "40108 MUFG Bank", "40110 J.P. Morgan", "40112 Monex", "40113 Ve por Más", "40124 Citi México", "40127 Banco Azteca", "40128 Kapital", "40130 Compartamos", "40132 Multiva", "40133 Actinver", "40136 Intercam Banco", "40137 Bancoppel", "40138 Ualá", "40139 BIAfirme", "40140 Consubanco", "40141 Volkswagen Bank", "40143 CIBanco", "40145 Banco Base", "40147 Bankaool", "40149 Banfeliz", "40150 Inmobiliario Mexicano", "40151 Dondé Banco", "40152 Bancrea", "40154 Covalto", "40155 ICBC", "40156 Sabadell", "40157 Shinhan", "40158 Mizuho Bank", "40159 Bank of China", "40160 Banco S3", "40162 KEB Hana México", "40165 Banco Bineo", "40167 Hey Banco", "40169 Openbank", "40170 Revolut Bank", "40171 Banco Plata", "5 Total Banca Múltiple"];

export const ENTIDADES_BANNER2 = ["40002 Banamex", "40012 BBVA México", "40014 Santander", "40021 HSBC", "40030 Banco del Bajío", "40036 Inbursa", "40042 Banca Mifel", "40044 Scotiabank", "40058 Banregio", "40059 Invex", "40060 Bansí", "40062 Afirme", "40072 Banorte", "40106 Bank of America", "40108 MUFG Bank", "40110 J.P. Morgan", "40112 Monex", "40113 Ve por Más", "40124 Citi México", "40126 Credit Suisse", "40127 Banco Azteca", "40128 Kapital", "40129 Barclays", "40130 Compartamos", "40132 Multiva", "40133 Actinver", "40136 Intercam Banco", "40137 Bancoppel", "40138 Ualá", "40139 BIAfirme", "40140 Consubanco", "40141 Volkswagen Bank", "40143 CIBanco", "40145 Banco Base", "40147 Bankaool", "40148 Pagatodo", "40149 Banfeliz", "40150 Inmobiliario Mexicano", "40151 Dondé Banco", "40152 Bancrea", "40154 Covalto", "40155 ICBC", "40156 Sabadell", "40157 Shinhan", "40158 Mizuho Bank", "40159 Bank of China", "40160 Banco S3", "40162 KEB Hana México", "40164 BNP Paribas México", "40165 Banco Bineo", "40167 Hey Banco", "40169 Openbank", "40170 Revolut Bank", "40171 Banco Plata", "5 Total Banca Múltiple", "59 G-7", "60 Bancos Cambiarios", "61 Inversión y Servicios Financieros", "62 Comercial Mediano", "63 Comercial Pequeño", "64 Créditos a los Hogares"];

export const ENTIDADES_BANNER3 = ["40002 Banamex", "40012 BBVA México", "40014 Santander", "40021 HSBC", "40030 Banco del Bajío", "40036 Inbursa", "40042 Banca Mifel", "40044 Scotiabank", "40058 Banregio", "40059 Invex", "40060 Bansí", "40062 Afirme", "40072 Banorte", "40106 Bank of America", "40108 MUFG Bank", "40110 J.P. Morgan", "40112 Monex", "40113 Ve por Más", "40124 Citi México", "40126 Credit Suisse", "40127 Banco Azteca", "40128 Kapital", "40129 Barclays", "40130 Compartamos", "40132 Multiva", "40133 Actinver", "40136 Intercam Banco", "40137 Bancoppel", "40138 Ualá", "40139 BIAfirme", "40140 Consubanco", "40141 Volkswagen Bank", "40143 CIBanco", "40145 Banco Base", "40147 Bankaool", "40148 Pagatodo", "40149 Banfeliz", "40150 Inmobiliario Mexicano", "40151 Dondé Banco", "40152 Bancrea", "40154 Covalto", "40155 ICBC", "40156 Sabadell", "40157 Shinhan", "40158 Mizuho Bank", "40159 Bank of China", "40160 Banco S3", "40162 KEB Hana México", "40164 BNP Paribas México", "40165 Banco Bineo", "40167 Hey Banco", "40169 Openbank", "40170 Revolut Bank", "40171 Banco Plata", "5 Total Banca Múltiple", "59 G-7", "60 Bancos Cambiarios", "61 Inversión y Servicios Financieros", "62 Comercial Mediano", "63 Comercial Pequeño", "64 Créditos a los Hogares"];
